//

//! Variables

let variables = {
  //* index, movie (search bar)
  moviesToShow: 8, // how many movie li elements to show
  maxCharactersPerLine: 40, // characters per line in movie li (for genres and stars)
  maxCharactersPerTitle: 35, // characters per line in movie li (for title)

  //* movie (movies parameters)
  inBetween: ", ", // between stars, genres, writers
}


//! Movies data

let movies = [
{title:'Bullet Train',
titleCZ:'Bullet Train',
year:2022,
runtime:127,
countries:['USA'],
genres:['Action','Comedy','Thriller'],
director:['David Leitch'],
actors:['Brad Pitt','Joey King','Aaron Taylor-Johnson','Brian Tyree Henry','Andrew Koji','Hirojuki Sanada','Michael Shannon','Bad Bunny','Sandra Bullock','Zazie Beetz','Logan Lerman','Masi Oka','Karen Fukuhara','Channing Tatum','Minchi Murakami','Jim Garrity','Emelina Adams','Yoshua Sudarso','Johanna Watts','Tania Verafield','Nancy Daly','Pasha D. Lychnikoff','Michelle Lee','Garland Scott','Jason Matthew Smith','David Leitch','Ryan Reynolds','Ayne','Shoko Rice','Ego Mikitas','Charlotte Xia','Harrison Xu'],
basedOn:['Kótaró Isaka'],
screenplay:['Zak Olkewicz'],
production:['Kelly McCormick','David Leitch','Antoine Fuqua'],
music:['Dominic Lewis'],
camera:['Jonathan Sela'],
cut:['Elísabet Ronaldsdóttir'],
sound:['Frank A. Montaño','Oleg Kulchytskyi','Mark P. Stoeckinger','Jon Taylor'],
scenography:['David Scheunemann','Elizabeth Keenan'],
masks:['Merc Arceneaux','Cindy Welles'],
costumes:['Sarah Evelyn']},
{title:'Oppenheimer',
titleCZ:'Oppenheimer',
year:2023,
runtime:180,
countries:['USA','UK'],
genres:['Drama','History','Biographic'],
director:['Christopher Nolan'],
actors:['Cillian Murphy','Matt Damon','Robert Downey Jr.','Emily Blunt','Florence Pugh','Josh Hartnett','Casey Affleck','Rami Malek','Kenneth Branagh','Tom Conti','Benny Safdie','Jason Clarke','Dylan Arnold',"James D'Arcy",'David Dastmalchian','Dane DeHaan','Alden Ehrenreich','Tony Goldwyn','Jefferson Hall','David Krumholtz','Matthew Modine','Gustaf Skarsgård','Michael Angarano','Jack Quaid','Josh Peck','Olivia Thirlby','Danny Deferrari','Devon Bostick','Alex Wolff','Scott Grimes','Josh Zuckerman','Matthias Schweighöfer','Christopher Denham','David Rysdahl','Guy Burnet','Louise Lombard','Harrison Gilbertson','Emma Dumont','Trond Fausa Aurvåg','Gary Oldman','John Gowans','Macon Blair','Harry Groener','Jack Cutmore-Scott','James Remar','Gregory Jbara','Tim DeKay','James Urbaniak','Máté Haumann','Bryce Johnson','Jeff Hephner','Sadie Stratton','Jacob Taylor','Rory Keane','Petrie Willink'],
basedOn:['Kai Bird','Martin Sherwin'],
screenplay:['Christopher Nolan'],
production:['Charles Roven','Emma Thomas','Christopher Nolan'],
music:['Ludwig Göransson'],
camera:['Hoyte van Hoytema'],
cut:['Jennifer Lame'],
sound:["Kevin O'Connell",'Richard King','Gary Rizzo'],
scenography:['Ruth De Jong','Claire Kaufman','Adam Willis'],
masks:['Andrea Steele','Luisa Abel','Jason Hamer'],
costumes:['Ellen Mirojnick']},
{title:'Batman',
titleCZ:'Batman',
year:1989,
runtime:122,
countries:['USA','UK'],
genres:['Action','Crime','Thriller'],
director:['Tim Burton'],
actors:['Michael Keaton','Jack Nicholson','Kim Basinger','Robert Wuhl','Pat Hingle','Billy Dee Williams','Michael Gough','Jerry Hall','Jack Palance','Tracey Walter','Lee Wallace','Mac McDonald','Philip Tan','Garrick Hagon','Richard Durden','Prince','Leon Herbert','William Hootkins','Lachele Carl','Hugo Blick','Vincent Wong','Wayne Michaels','Terence Plummer','Pat Gorman','Michael Balfour','Christopher Fairbank','David Baxt','Steve Plytas','Denis Lill','Richard Strange','Del Baker','Harold Coyne','Paul Michael','John Sterland','Bruce McGuire','Liza Ross','Jimmy Star','Chris Andrews','Sam Douglas'],
basedOn:['Bob Kane','Bill Finger'],
screenplay:['Sam Hamm','Warren Skaaren'],
production:['Jon Peters','Peter Guber'],
music:['Danny Elfman'],
camera:['Roger Pratt'],
cut:['Ray Lovejoy'],
sound:['Bill Rowe'],
scenography:['Anton Furst','Peter Young'],
masks:['Paul Engelen','Lynda Armstrong','Nick Dudman'],
costumes:['Bob Ringwood']},
{title:'Inception',
titleCZ:'Počátek',
year:2010,
runtime:148,
countries:['USA','UK'],
genres:['Action','Sci-Fi','Thriller','Mystery','Adventure'],
director:['Christopher Nolan'],
actors:['Leonardo DiCaprio','Joseph Gordon-Levitt','Elliot Page','Tom Hardy','Ken Watanabe','Dileep Rao','Cillian Murphy','Tom Berenger','Marion Cotillard','Pete Postlethwaite','Michael Caine','Lukas Haas','Tai-Li Lee','Claire Geare','Taylor Geare','Johnathan Geare','Tohoru Masamune','Júdži Okumoto','Earl Cameron','Ryan Hayward','Talulah Riley','Silvie Laguna','Virgile Bramly','Nicole Pulliam','Peter Basham','Michael Gaston','Michael August','John Ceallach','Adam Cole','Mark Fleischmann','Tim Kelleher','Carl Gilliard','Andrew Pleavin','Miranda Nolan','Russ Fega'],
screenplay:['Christopher Nolan'],
production:['Christopher Nolan','Emma Thomas'],
music:['Hans Zimmer'],
camera:['Wally Pfister'],
cut:['Lee Smith'],
sound:['Richard King','James P. Lay','Lora Hirschberg','Gary Rizzo','Michael Semanick'],
scenography:['Guy Hendrix Dyas','Brad Ricker','Larry Dias','Douglas A. Mowat'],
masks:['Matthew W. Mungle','Estelle Tolstoukine','Luisa Abel'],
costumes:['Jeffrey Kurland']},
{title:'Avatar',
titleCZ:'Avatar',
year:2009,
runtime:166,
countries:['USA','UK'],
genres:['Action','Adventure','Sci-Fi','Fantasy'],
director:['James Cameron'],
actors:['Sam Worthington','Zoe Saldana','Stephen Lang','Michelle Rodriguez','Giovanni Ribisi','Joel David Moore','CCH Pounder','Wes Studi','Laz Alonso','Sigourney Weaver','Dileep Rao','James Pitt','Peter Mensah','Matt Gerald','Scott Lawrence','Kevin Dorman','Anthony Ingruber','Gareth Ruck','Alicia Vela-Bailey','Debra Wilson','Lasco Atkins','Allan Henry','Jessica J. Stowes','Terry Notary','Sean Patrick Murphy','Luke Hawker','Jimmy Star','Rowan Bettjeman','Jon Curry','Kelson Henderson','James Gaylyn','David Sampen'],
screenplay:['James Cameron'],
production:['James Cameron','Jon Landau'],
music:['James Horner'],
camera:['Mauro Fiore'],
cut:['Stephen E. Rivkin','John Refoua','James Cameron'],
sound:['Gwendolyn Yates Whittle','Gary Summers','Andy Nelson','Addison Teague','Christopher Boyes','Tony Johnson'],
scenography:['Rick Carter','Robert Stromberg','Nick Bassett','Andy McLaren','Simon Bright'],
masks:['Mike Smithson','Sarah Rubano','Rick Findlater','Kenny Niederbaumer'],
costumes:['Mayes C. Rubeo','Deborah L. Scott']},
{title:'The Shawshank Redemption',
titleCZ:'Vykoupení z věznice Shawshank',
year:1994,
runtime:142,
countries:['USA'],
genres:['Drama','Crime'],
director:['Frank Darabont'],
actors:['Tim Robbins','Morgan Freeman','Bob Gunton','William Sadler','Clancy Brown','Gil Bellows','Mark Rolston','James Whitmore','Jeffrey DeMunn','Larry Brandenburg','Neil Giuntoli','David Proval','Jude Ciccolella','Paul McCrane','Alfonso Freeman','Ned Bellamy','James Babson','Renee Blaine','Frank Medrano','Don McManus','Brian Libby','Dion Anderson','Joseph Ragno','Sergio Kato','Morgan Lund','Brian Brophy','V.J. Foster','Brian Delate','Bill Bolender','Neil Summers','Dorothy Silver','Ken Magee'],
basedOn:['Stephen King'],
screenplay:['Frank Darabont'],
production:['Niki Marvin'],
music:['Thomas Newman'],
camera:['Roger Deakins'],
cut:['Richard Francis-Bruce'],
scenography:['Terence Marsh'],
masks:['Monty Westmore','Kevin Haney'],
costumes:['Elizabeth McBride']},
{title:'The Matrix',
titleCZ:'Matrix',
year:1999,
runtime:136,
countries:['USA'],
genres:['Action','Sci-Fi'],
director:['Lilly Wachowski','Lana Wachowski'],
actors:['Keanu Reeves','Laurence Fishburne','Carrie-Anne Moss','Hugo Weaving','Gloria Foster','Joe Pantoliano','Belinda McClory','Robert Taylor','Anthony Ray Parker','Ada Nicodemou','Paul Goddard','Julian Arahanga','Marcus Chong','Matt Doran','Marc Aden Gray','Chris Pattinson','Deni Gordon','Bill Young','Nash Edgerton','Jeremy Ball','Rowan Witt'],
screenplay:['Lilly Wachowski','Lana Wachowski'],
production:['Joel Silver'],
music:['Don Davis'],
camera:['Bill Pope'],
cut:['Zach Staenberg'],
sound:['John T. Reitz','Gregg Rudloff','David E. Campbell','David Lee'],
scenography:['Owen Paterson'],
masks:['Bob McCarron','Nikki Gooley','Elka Wardega'],
costumes:['Kym Barrett']},
{title:'Forrest Gump',
titleCZ:'Forrest Gump',
year:1994,
runtime:142,
countries:['USA'],
genres:['Drama','Comedy','Romance'],
director:['Robert Zemeckis'],
actors:['Tom Hanks','Robin Wright','Gary Sinise','Mykelti Williamson','Sally Field','Haley Joel Osment','Peter Dobson','Siobhan Fallon Hogan','Hanna Hall','Brett Rice','Kirk Ward','Kurt Russell','Stephen Bridgewater','Michael Jace','Michael McFall','Joe Alaskey','Sam Anderson','Jacqueline Lovell','Mary Ellen Trainor','Vanessa Roth','Bryan Hanna','Jason McGuire','Gerald Ford','Lyndon B. Johnson','John F. Kennedy','Michael Conner Humphreys','David Brisbin','Zach Hanner','John Lennon','Al Harrington','Robb Skyler','Charles Boswell','Afemo Omilami','Byron Minns','Troy Christian','Geoffrey Blake','Timothy McNeil','Don Fischer','Nora Dunfee','Bill Roberson','Rebecca Williams','Dick Cavett','George Wallace','Daniel C. Striepeke','Marla Sucharetza','Sonny Shroyer','Jim Boeke','Tiffany Salerno','Bob Harks','John Connally','Lazarus Jackson'],
basedOn:['Winston Groom'],
screenplay:['Eric Roth'],
production:['Wendy Finerman','Steve Starkey','Steve Tisch'],
music:['Alan Silvestri'],
camera:['Don Burgess'],
cut:['Arthur Schmidt'],
sound:['Randy Thom','Tom Johnson'],
scenography:['Rick Carter','Nancy Haigh'],
masks:['John Logan','Rick Sharp'],
costumes:['Joanna Johnston']},
{title:'Pulp Fiction',
titleCZ:'Pulp Fiction: Historky z podsvětí',
year:1994,
runtime:154,
countries:['USA'],
genres:['Crime','Drama'],
director:['Quentin Tarantino'],
actors:['John Travolta','Samuel L. Jackson','Uma Thurman','Harvey Keitel','Tim Roth','Amanda Plummer','Maria de Medeiros','Ving Rhames','Eric Stoltz','Rosanna Arquette','Christopher Walken','Bruce Willis','Paul Calderon','Bronagh Gallagher','Peter Greene','Stephen Hibbert','Angela Jones','Phil LaMarr','Robert Ruth','Julia Sweeney','Quentin Tarantino','Frank Whaley','Duane Whitaker','Laura Lovelace','Burr Steers','Michael Gilden','Joseph Pilato','Steve Buscemi','Emil Sitka','Brenda Hillhouse','Chandler Lindauer','Don Blakely','Karen Maruyama','Kathy Griffin','Alexis Arquette','Lawrence Bender','Richard Rossi','Ani Sava'],
screenplay:['Quentin Tarantino','Roger Avary'],
production:['Lawrence Bender'],
camera:['Andrzej Sekula'],
cut:['Sally Menke'],
sound:['Stephen Hunter Flick','Rick Ash','Dean A. Zupancic'],
scenography:['David Wasco','Sandy Reynolds-Wasco'],
masks:['Audrey Futterman-Stern','Wayne Toth'],
costumes:['Betsy Heimann']},
{title:'The Lord of the Rings: The Fellowship of the Ring',
titleCZ:'Pán prstenů: Společenstvo Prstenu',
year:2001,
runtime:172,
countries:['USA','New Zealand'],
genres:['Fantasy','Adventure','Action'],
director:['Peter Jackson'],
actors:['Elijah Wood','Ian McKellen','Viggo Mortensen','Sean Astin','Cate Blanchett','Sean Bean','Liv Tyler','John Rhys-Davies','Billy Boyd','Dominic Monaghan','Orlando Bloom','Christopher Lee','Hugo Weaving','Ian Holm','Noel Appleby','Marton Csokas','Craig Parker','Andy Serkis','Ian Mune','Lawrence Makoare','Harry Sinclair','Elizabeth Moody','Peter Jackson','Bill Johnson','Billy Jackson','Bret McKenzie','Sala Baker','Alan Howard','Shane Rangi','Sabine Crossen','Mark Ferguson','Martyn Sanderson','Jono Manks','Lori Dungey','Sam Kelly','Peter McKenzie','Gino Acevedo','Tim Kano','Thomas Robins','Cameron Rhodes'],
basedOn:['J.R.R. Tolkien'],
screenplay:['Fran Walsh','Philippa Boyens','Peter Jackson'],
production:['Peter Jackson','Fran Walsh','Barrie M. Osborne'],
music:['Howard Shore'],
camera:['Andrew Lesnie'],
cut:['John Gilbert'],
sound:['Mike Hopkins','Ethan Van der Ryn','Michael Semanick','Christopher Boyes'],
scenography:['Grant Major'],
masks:['Vivienne MacGillicuddy',"Peter 'Swords' King",'Davina Lamont','Rick Findlater','Kerryn Flewell-Smith'],
costumes:['Ngila Dickson','Richard Taylor']},
{title:'The Dark Knight',
titleCZ:'Temný rytíř',
year:2008,
runtime:152,
countries:['USA','UK'],
genres:['Action','Drama','Crime','Thriller'],
director:['Christopher Nolan'],
actors:['Christian Bale','Heath Ledger','Aaron Eckhart','Michael Caine','Maggie Gyllenhaal','Gary Oldman','Morgan Freeman','Cillian Murphy','Eric Roberts','Ritchie Coster','Anthony Michael Hall','Michael Jai White','Chin Han','William Fichtner','Keith Szarabajka','Danny Goldring','Beatrice Rosen','Edison Chen','Matthew Leitch','Nestor Carbonell','Nicky Katt','Monique Gabriela Curnen',"Tommy 'Tiny' Lister",'Nathan Gamble','Sarah Jayne Dunn','Matt Rippy','Bronson Webb','Melinda McGraw','Ariyon Bakare','Vincent Riotta','Peter Brooke','Marisol Giraud','Danielle Day','William Smillie','David Dastmalchian','Lisa McAllister','David Ajala','Ramses Jimenez','Andrew Bicknell','Colin McFarlane','Vincenzo Nicoli','Jordon Hodges','Ron Dean','Charles Venn','Richard Dillane','Tommy Campbell','Ryan McGonagle','Joshua Harto','Ronan Summers','Stephen Armourae','Richard Strobel','Chris Wilson','Ian Pirie','Robert Patrick Stern','Keith Kupferer','Essa Zahir','Blayne Bennett','Will Zahrn','Jonathan Ryland','Douglas Bunn','Michael Stoyanov','Brandon Lambdin','Peter DeFaria','Joshua Rollins','Aidan Feore'],
basedOn:['Bob Kane','Bill Finger'],
screenplay:['Jonathan Nolan','Christopher Nolan'],
production:['Christopher Nolan','Charles Roven','Emma Thomas'],
music:['Hans Zimmer','James Newton Howard'],
camera:['Wally Pfister'],
cut:['Lee Smith'],
sound:['Richard King','Lora Hirschberg','Gary Rizzo'],
scenography:['Nathan Crowley'],
masks:['Lisa Jelic','Peter Robb-King','John Caglione','Jr.',"Conor O'Sullivan",'Lillian Sakamaki','Kimberley Spiteri','Linda Rizzuto','Barrie Gower','Deborah K. Dee'],
costumes:['Lindy Hemming']},
{title:'Jurassic Park',
titleCZ:'Jurský park',
year:1993,
runtime:127,
countries:['USA'],
genres:['Adventure','Sci-Fi','Thriller'],
director:['Steven Spielberg'],
actors:['Sam Neill','Laura Dern','Jeff Goldblum','Richard Attenborough','Joseph Mazzello','Ariana Richards','Martin Ferrero','Samuel L. Jackson','BD Wong','Wayne Knight','Miguel Sandoval','Dean Cundey','Brian Smrz','Bob Peck','Richard Kiley','Gerald R. Molen','Brad M. Bucklin','Cameron Thor','Christopher John Fields','Whit Hertford','Michael Lantieri'],
basedOn:['Michael Crichton'],
screenplay:['Michael Crichton','David Koepp'],
production:['Kathleen Kennedy','Gerald R. Molen'],
music:['John Williams'],
camera:['Dean Cundey'],
cut:['Michael Kahn'],
sound:['Richard Hymns','Gary Summers','Gary Rydstrom','Christopher Scarabosio'],
scenography:['Rick Carter','Jackie Carr']},
{title:'The Avengers',
titleCZ:'Avengers',
year:2012,
runtime:143,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Fantasy'],
director:['Joss Whedon'],
actors:['Robert Downey Jr.','Jeremy Renner','Scarlett Johansson','Chris Evans','Samuel L. Jackson','Chris Hemsworth','Mark Ruffalo','Clark Gregg','Lou Ferrigno','Tom Hiddleston','Cobie Smulders','Paul Bettany','Gwyneth Paltrow','Stellan Skarsgård','Jenny Agutter','Enver Gjokaj','Walter Perez','Alexis Denisof','Ashley Johnson','Powers Boothe','Harry Dean Stanton','Stan Lee','Damion Poitier','Arthur Darbinyan','Jerzy Skolimowski','Romy Rosemont','Jillian Morgese','Jamie McShane','Jesse Garcia','Robert Dean','Robert Clohessy','Martin Palmer','Ricardo Andres','Josh Cowdery','Tina Benko','Donald Li','Alicia Sixtos','Layla Cushman','Alex DeCourville','Shane Thompson','William Christopher Stephens','Jimmy Star','Debbie Scaletta','Kelley Robins','Mayank Bhatter','Pat Kiernan','JT Tomangi','Frank Powers'],
basedOn:['Stan Lee','Jack Kirby','Don Heck'],
screenplay:['Joss Whedon'],
production:['Kevin Feige'],
music:['Alan Silvestri'],
camera:['Seamus McGarvey'],
cut:['Lisa Lassek','Jeffrey Ford'],
sound:['Frank Eulner','Lora Hirschberg','Christopher Boyes'],
scenography:['James Chinlund','Victor J. Zolfo'],
masks:['John Blake','Heba Thorisdottir','Kevin Kirkpatrick','Jennifer Bell'],
costumes:['Alexandra Byrne']},
{title:'The Green Mile',
titleCZ:'Zelená míle',
year:1999,
runtime:188,
countries:['USA'],
genres:['Drama','Mystery','Crime'],
director:['Frank Darabont'],
actors:['Tom Hanks','David Morse','Bonnie Hunt','Michael Clarke Duncan','James Cromwell','Michael Jeter','Graham Greene','Doug Hutchison','Sam Rockwell','Barry Pepper','Jeffrey DeMunn','Patricia Clarkson','Harry Dean Stanton','Dabbs Greer','Eve Brent','William Sadler','Rai Tasco','Paula Malcomson','Brian Libby','Brent Briscoe','Bill McKinney','Gary Sinise','Scotty Leavenworth','Rebecca Klingler','Gary Imhoff','Van Epperson','Tommy Barnes','Judy Herrera','Todd Thompson','Fred Astaire','Ginger Rogers'],
basedOn:['Stephen King'],
screenplay:['Frank Darabont'],
production:['Frank Darabont','David Valdes'],
music:['Thomas Newman'],
camera:['David Tattersall'],
cut:['Richard Francis-Bruce'],
sound:['Eric Warren Lindemann','Mark A. Mangini'],
scenography:['Terence Marsh','William Cruse'],
masks:['Lois Burwell','Howard Berger','Greg Nicotero'],
costumes:['Karyn Wagner']},
{title:'Se7en',
titleCZ:'Sedm',
year:1995,
runtime:127,
countries:['USA'],
genres:['Thriller','Crime','Mystery','Psychology','Drama'],
director:['David Fincher'],
actors:['Brad Pitt','Morgan Freeman','Gwyneth Paltrow','Richard Roundtree','R. Lee Ermey','John C. McGinley','Kevin Spacey','Julie Araskog','Mark Boone Junior','John Cassini','Reg E. Cathey','Peter Crombie','Hawthorne James','Michael Massee','Leland Orser','Richard Portnow','Richard Schiff','Andrew Kevin Walker','Daniel Zacapa','Endre Hules','Bob Collins','Dominique Jennings','Allan Kolman','Gene Borkan','Mario Di Donato','Alfonso Freeman','Harrison White','Bob Stephenson','Michael Reid MacKay','Lennie Loftin','Emily Wagner','Jennifer Mueller','Lexie Bigham','Evan Mirand','Paul Eckstein','Harris Savides','Heidi Schanz','Shannon Wilcox','Charles A. Tamburro','Richmond Arquette','Charles S. Dutton','Arthur Max'],
screenplay:['Andrew Kevin Walker'],
production:['Arnold Kopelson','Phyllis Carlyle'],
music:['Howard Shore'],
camera:['Darius Khondji'],
cut:['Richard Francis-Bruce'],
sound:['Ren Klyce'],
scenography:['Arthur Max'],
masks:['Monty Westmore','Jean Ann Black','Rob Bottin'],
costumes:['Michael Kaplan']},
{title:"One Flew over the Cuckoo's Nest",
titleCZ:'Přelet nad kukaččím hnízdem',
year:1975,
runtime:133,
countries:['USA'],
genres:['Drama'],
director:['Miloš Forman'],
actors:['Jack Nicholson','Louise Fletcher','William Redfield','Will Sampson','Brad Dourif','Sydney Lassick','Danny DeVito','Christopher Lloyd','William Duell','Vincent Schiavelli','Michael Berryman','Peter Brocco','Dean R. Brooks','Scatman Crothers','Mwako Cumbuka','Josip Elic','Nathan George','Mel Lambert','Ted Markland','Louisa Moritz','Mimi Sarkisian','Mews Small','Delos V. Smith Jr.','Aurore Clément','Anjelica Huston','Audrey Landers','Tom McCall','Saul Zaentz'],
basedOn:['Ken Kesey'],
screenplay:['Lawrence Hauben','Bo Goldman'],
production:['Saul Zaentz','Michael Douglas'],
music:['Jack Nitzsche'],
camera:['Haskell Wexler'],
cut:['Richard Chew'],
scenography:['Paul Sylbert'],
masks:['Fred B. Phillips'],
costumes:['Aggie Guerard Rodgers']},
{title:"Schindler's List",
titleCZ:'Schindlerův seznam',
year:1993,
runtime:195,
countries:['USA'],
genres:['Drama','History','Biographic'],
director:['Steven Spielberg'],
actors:['Liam Neeson','Ben Kingsley','Ralph Fiennes','Caroline Goodall','Jonathan Sagall','Embeth Davidtz','Małgorzata Gebel','Mark Ivanir','Andrzej Seweryn','Friedrich von Thun','Krzysztof Luft','Harry Nehring','Norbert Weisser','Michael Schneider','Miri Fabian','Anna Mucha','Michael Gordon','Aldona Grochal','Jacek Wójcicki','Beata Paluch','Piotr Polk','Ezra Dagan','Beata Deskur','Rami Heuberger','Leopold Kozłowski','Jerzy Nowak','Adam Siemion','Magdalena Dandourian','Paweł Deląg','Oliwia Dąbrowska','Henryk Bista','Tadeusz Bradecki','Wojciech Klata','Elina Löwensohn','Ewa Kolasińska','Bettina Kupfer','Grzegorz Kwas','Vili Matula','Stanisław Nałęcz-Koczanowicz','Hans-Jörg Assmann','Geno Lechner','August Schmölzer','Ludger Pistor','Beata Rybotycka','Branko Lustig','Artus Maria Matthiessen','Hans-Michael Rehberg','Eugeniusz Priwieziencew','Michael Z. Hoffmann','Erwin Leder','Jochen Nickel','Andrzej Wełmiński','Daniel Del-Ponte','Marian Glinka','Grzegorz Damięcki','Stanisław Brejdygant','Olaf Lubaszenko','Haymon Maria Buttinger','Peter Appiano','Jacek Pulanecki','Tomasz Dedek','Sławomir Holland','Martin Semmelrogge','Tadeusz Huk','Alexander Held','Piotr Cyrwus','Joachim Paul Assböck','Maciej Orłoś','Marek Wrona','Zbigniew Kozłowski','Marcin Grzymowicz','Dieter Witting','Magdalena Komornicka','Agnieszka Krukówna','Anemona Knut','Agnieszka Wagner','Jan Jurewicz','Wiesław Komasa','Maciej Kozłowski','Martin Bergmann','Wilhelm Manske','Peter Flechtner','Etl Szyc','Lucyna Zabawa','Ruth Farhi','Jerzy Sagan','Dariusz Szymaniak','Dirk Bender','Maciej Winkler','Radosław Krzyżowski','Jacek Link-Lenczowski','Hanna Kossowska','Maja Ostaszewska','Sebastian Skalski','Ryszard Radwański','Piotr Kadlcik','Lech Niebielski','Thomas Morris','Sebastian Konrad','Lidia Bank-Wyrobiec'],
basedOn:['Thomas Keneally'],
screenplay:['Steven Zaillian'],
production:['Steven Spielberg','Gerald R. Molen','Branko Lustig'],
music:['John Williams'],
camera:['Janusz Kamiński'],
cut:['Michael Kahn'],
sound:['Ron Judkins','Charles L. Campbell','Louis L. Edemann','Andy Nelson','Steve Pederson','Scott Millan'],
scenography:['Allan Starski','Ewa Braun'],
masks:['Waldemar Pokromski'],
costumes:['Anna Biedrzycka-Sheppard']},
{title:'The Godfather',
titleCZ:'Kmotr',
year:1972,
runtime:175,
countries:['USA'],
genres:['Drama','Crime'],
director:['Francis Ford Coppola'],
actors:['Marlon Brando','Al Pacino','James Caan','Richard S. Castellano','Robert Duvall','Sterling Hayden','John Marley','Richard Conte','Al Lettieri','Diane Keaton','Abe Vigoda','Talia Shire','Gianni Russo','John Cazale','Rudy Bond','Al Martino','Morgana King','Lenny Montana','John Martino','Salvatore Corsitto','Richard Bright','Alex Rocco','Tony Giorgio','Vito Scotti','Victor Rendina','Jeannie Linero','Julie Gregg','Ardell Sheridan','Simonetta Stefanelli','Angelo Infanti','Corrado Gaipa','Franco Citti','Saro Urzì','Carmine Coppola','Roman Coppola','Sofia Coppola','Gray Frederickson','Ron Gilbert','Sonny Grosso','Louis Guss','Randy Jurgensen','Tony King','Tony Lip','Lou Martini Jr.','Raymond Martino','Rick Petrucelli','Tom Rosqui','Frank Sivero','Filomena Spagnuolo','Joe Spinell','Gabriele Torrei','Nick Vallelonga','Conrad Yama','Sal Richards'],
basedOn:['Mario Puzo'],
screenplay:['Mario Puzo','Francis Ford Coppola'],
production:['Albert S. Ruddy'],
music:['Nino Rota'],
camera:['Gordon Willis'],
cut:['William Reynolds','Peter Zinner'],
scenography:['Dean Tavoularis','Philip Smith'],
masks:['Dick Smith','Phil Rhodes'],
costumes:['Anna Hill Johnstone']},
{title:'12 Angry Men',
titleCZ:'Dvanáct rozhněvaných mužů',
year:1957,
runtime:96,
countries:['USA'],
genres:['Drama','Crime'],
director:['Sidney Lumet'],
actors:['Martin Balsam','John Fiedler','Lee J. Cobb','E.G. Marshall','Jack Klugman','Edward Binns','Jack Warden','Henry Fonda','Joseph Sweeney','Ed Begley','Jiří Voskovec','Robert Webber','Rudy Bond','John Savoca','Walter Stocker','Billy Nelson'],
screenplay:['Reginald Rose'],
production:['Henry Fonda','Reginald Rose'],
music:['Kenyon Hopkins'],
camera:['Boris Kaufman'],
cut:['Carl Lerner']},
{title:'The Intouchables',
titleCZ:'Nedotknutelní',
year:2011,
runtime:112,
countries:['France'],
genres:['Comedy','Drama','Biographic'],
director:['Eric Toledano','Olivier Nakache'],
actors:['François Cluzet','Omar Sy','Anne Le Ny','Audrey Fleurot','Joséphine de Meaux','Clotilde Mollet','Alba Gaïa Kraghede Bellugi','Cyril Mendy','Salimata Kamate','Grégoire Oestermann','Dominique Daguier','François Caron','Christian Ameri','Thomas Solivéres','Dorothée Briere','Émilie Caen','Sylvain Lazard','Jean-François Cayrey','François Bureloup','Nicky Marbot','Benjamin Baroche','Antoine Laurent','Caroline Bourg','Marie-Laure Descoureaux','Hedi Bouchenafa','Jérôme Pauwels'],
screenplay:['Eric Toledano','Olivier Nakache'],
production:['Nicolas Duval Adassovsky','Laurent Zeitoun','Yann Zenou'],
music:['Ludovico Einaudi'],
camera:['Mathieu Vadepied'],
cut:['Dorian Rigal-Ansous'],
sound:['Jean-Paul Hurier'],
scenography:['François Emmanuelli'],
masks:['Alice Robert'],
costumes:['Isabelle Pannetier']},
{title:'Cosy Dens',
titleCZ:'Pelíšky',
year:1999,
runtime:116,
countries:['Czechia'],
genres:['Comedy','Drama'],
director:['Jan Hřebejk'],
actors:['Miroslav Donutil','Jiří Kodet','Simona Stašová','Emília Vášáryová','Bolek Polívka','Jaroslav Dušek','Eva Holubová','Stella Zázvorková','Kristýna Badinková Nováková','Michael Beran','Sylvie Koblížková','Marek Morvai-Javorský','Jiří Krejčík','Ondřej Brousek','Boris Hybner','Richard Tesařík','Dagmar Teichmannová','Miroslav Kaman','Hana Marcoňová','Ruslana Miňajlúk','Jana Švamberková','Soňa Nemcová','Matěj Hádek'],
basedOn:['Petr Šabach'],
screenplay:['Petr Jarchovský'],
production:['Pavel Bororvan','Ondřej Trojan'],
music:['Ivan Král','Ivan Hlas'],
camera:['Jan Malíř'],
cut:['Vladimír Barák'],
sound:['Karel Jaroš'],
scenography:['Milan Býček'],
masks:['Hana Šímová'],
costumes:['Katarína Hollá','Marta Ostenová']},
{title:'Terminator 2: Judgment Day',
titleCZ:'Terminátor 2: Den zúčtování',
year:1991,
runtime:137,
countries:['USA','France'],
genres:['Action','Sci-Fi','Thriller'],
director:['James Cameron'],
actors:['Arnold Schwarzenegger','Linda Hamilton','Edward Furlong','Robert Patrick','Michael Edwards','Earl Boen','Joe Morton','S. Epatha Merkerson','Danny Cooksey','Xander Berkeley','Dean Norris','Michael Biehn','Jenette Goldstein','Nikki Cox','Scott Shaw','Mark Christopher Lawrence','DeVaughn Nixon','Leslie Hamilton Gearren','Castulo Guerra','Diane Rodriguez','Jim Palmer','Terrence Evans','Don Lake','Colin Patrick Lynch','Abdul Salaam El Razzac','Pete Schrum','Don Stanton','Dan Stanton','Van Ling','Nancy Fish','Robert Winley','Mike Muscat'],
screenplay:['James Cameron','William Wisher Jr.'],
production:['James Cameron'],
music:['Brad Fiedel'],
camera:['Adam Greenberg'],
cut:['Conrad Buff IV','Dody Dorn','Mark Goldblatt','Richard A. Harris'],
sound:['Gary Summers','Gary Rydstrom','Tom Johnson'],
scenography:['Joseph C. Nemec III','John M. Dwyer'],
masks:['Jeff Dawn','Steve La Porte','Edward French'],
costumes:['Marlene Stewart']},
{title:'The Godfather: Part II',
titleCZ:'Kmotr II',
year:1974,
runtime:202,
countries:['USA'],
genres:['Drama','Crime'],
director:['Francis Ford Coppola'],
actors:['Al Pacino','Robert Duvall','Diane Keaton','Robert De Niro','John Cazale','Talia Shire','Lee Strasberg','Michael V. Gazzo','G. D. Spradlin','Richard Bright','Gastone Moschin','Tom Rosqui','Bruno Kirby','Frank Sivero','Francesca De Sapio','Morgana King','Marianna Hill','Leopoldo Trieste','Dominic Chianese','Troy Donahue','John Aprea','Joe Spinell','Abe Vigoda','Gianni Russo','Maria Carta','Oreste Baldini','Giuseppe Sillato','James Gounaris','Fay Spain','Harry Dean Stanton','James Murdock','Carmine Caridi','Danny Aiello','William Bowers','Carmen Argenziano','Joe Lo Grippo','Kathleen Beller','Peter Donat','Phil Feldman','Roger Corman','Ivonne Coll','Erica Yohn','James Caan','Roman Coppola','Sofia Coppola','Julie Gregg','George Holmes','Buck Houghton','Shep Houghton','Šó Kosugi','Gary Kurtz','Alan Marston','Richard Matheson','John Megna','Joe Pine','Jay Rasumny','Filomena Spagnuolo','Judith Woodbury','Larry Carr'],
basedOn:['Mario Puzo'],
screenplay:['Francis Ford Coppola','Mario Puzo'],
production:['Francis Ford Coppola'],
music:['Nino Rota'],
camera:['Gordon Willis'],
cut:['Peter Zinner','Barry Malkin','Richard Marks'],
sound:['Walter Murch'],
scenography:['Dean Tavoularis','Angelo P. Graham','George R. Nelson'],
masks:['Dick Smith','Naomi Cavin'],
costumes:['Theadora Van Runkle']},
{title:'The Lord of the Rings: The Return of the King',
titleCZ:'Pán prstenů: Návrat krále',
year:2003,
runtime:201,
countries:['USA','New Zealand'],
genres:['Fantasy','Adventure','Action'],
director:['Peter Jackson'],
actors:['Elijah Wood','Billy Boyd','Dominic Monaghan','Sean Astin','Ian McKellen','Viggo Mortensen','Orlando Bloom','Liv Tyler','Christopher Lee','Cate Blanchett','John Rhys-Davies','Bernard Hill','Brad Dourif','Miranda Otto','Marton Csokas','Hugo Weaving','Karl Urban','Sean Bean','David Wenham','John Noble','Noel Appleby','Andy Serkis','Bruce Spence','Peter Jackson','Lawrence Makoare','Billy Jackson','Bret McKenzie','Sala Baker','Joel Tobeck','Alan Howard','Peter Tait','John Bach','Ian Holm','Bruce Hopkins','Pete Smith','Jed Brophy','Bruce Phillips','Shane Rangi','Harry Sinclair','Ali Astin','Ian Hughes','Andrew Lesnie','Richard Taylor','Gino Acevedo','Ross Duncan','Thomas Robins','Michael Semanick','Stephen Ure','Paul Norell'],
basedOn:['J.R.R. Tolkien'],
screenplay:['Fran Walsh','Philippa Boyens','Peter Jackson'],
production:['Peter Jackson','Fran Walsh','Barrie M. Osborne'],
music:['Howard Shore'],
camera:['Andrew Lesnie'],
cut:['Jamie Selkirk'],
sound:['Gary Summers','Mike Hopkins','Ethan Van der Ryn','Michael Semanick','Christopher Boyes','Michael Hedges'],
scenography:['Grant Major','Simon Bright'],
masks:['Vivienne MacGillicuddy','Jeremy Woodhead',"Peter 'Swords' King",'Davina Lamont','Ivana Primorac','Rick Findlater','Tami Lane','Kerryn Flewell-Smith'],
costumes:['Ngila Dickson','Richard Taylor']},
{title:'The Silence of the Lambs',
titleCZ:'Mlčení jehňátek',
year:1991,
runtime:119,
countries:['USA'],
genres:['Thriller','Crime','Horror','Drama'],
director:['Jonathan Demme'],
actors:['Jodie Foster','Anthony Hopkins','Scott Glenn','Ted Levine','Anthony Heald','Brooke Smith','Diane Baker','Kasi Lemmons','Charles Napier','Tracey Walter','Roger Corman','Ron Vawter','Danny Dean Darst','Frankie Faison','Paul Lazar','Dan Butler','Chris Isaak','Lawrence A. Bonney','Don Brockett','Stuart Rudin','Leib Lensky','Gene Borkan','Pat McNamara','Kenneth Utt','Adelle Lutz','Obba Babatundé','Cynthia Ettinger','Brent Hinkley','Andre B. Blake','Daniel von Bargen','Tommy LaFitte','Harry Northup','Robert W. Castle','John Hall','John W. Iwanonkiw','Chris McGinn','Ted Monte','George A. Romero','Mike Schaeffer'],
basedOn:['Thomas Harris'],
screenplay:['Ted Tally'],
production:['Edward Saxon','Kenneth Utt','Ron Bozman'],
music:['Howard Shore'],
camera:['Tak Fujimoto'],
cut:['Craig McKay'],
sound:['Skip Lievsay','Tom Fleischman','Douglas Murray'],
scenography:['Kristi Zea',"Karen O'Hara"],
masks:['Carl Fullerton','Neal Martz'],
costumes:['Colleen Atwood']},
{title:'Once Upon a Time in the West',
titleCZ:'Tenkrát na Západě',
year:1968,
runtime:166,
countries:['Italy','USA'],
genres:['Western','Adventure'],
director:['Sergio Leone'],
actors:['Henry Fonda','Claudia Cardinale','Jason Robards','Charles Bronson','Gabriele Ferzetti','Don Galloway','Paolo Stoppa','Woody Strode','Jack Elam','Keenan Wynn','Frank Wolff','Lionel Stander','Fabio Testi','Al Mulock','Aldo Sambrell','Bruno Corazzari','Aldo Berti','Cris Huerta','Ricardo Palacios','Conrado San Martín','Benito Stefanelli','Luana Strode','Marilù Carteny','Antonio Molino Rojo','Frank Braña','Renato Pinciroli','Lorenzo Robledo','Paolo Figlia','Giovanni Ivan Scratuglia','Saturno Cerra','Spartaco Conversi','Michael Harvey','John Frederick','Robert Hossein','Claudio Mancini','Salvatore Basile','Raffaella Leone','Dino Mele'],
screenplay:['Sergio Leone','Sergio Donati'],
production:['Fulvio Morsella'],
music:['Ennio Morricone'],
camera:['Tonino Delli Colli'],
cut:['Nino Baragli'],
scenography:['Rafael Ferri'],
masks:['Giannetto De Rossi'],
costumes:['Carlo Simi']},
{title:'Gran Torino',
titleCZ:'Gran Torino',
year:2008,
runtime:116,
countries:['USA','Germany'],
genres:['Drama'],
director:['Clint Eastwood'],
actors:['Clint Eastwood','Bee Vang','Ahney Her','Christopher Carley','Brian Haley','Geraldine Hughes','Dreama Walker','Brian Howe','John Carroll Lynch','William Hill','Brooke Chia Thao','Chee Thao','Scott Eastwood','Cory Hardrict','Davis Gloff','Doua Moua'],
screenplay:['Nick Schenk'],
production:['Clint Eastwood','Robert Lorenz','Bill Gerber'],
music:['Kyle Eastwood','Michael Stevens'],
camera:['Tom Stern'],
cut:['Joel Cox','Gary D. Roach'],
sound:['Alan Robert Murray','John T. Reitz','Gregg Rudloff'],
scenography:['James J. Murakami','Gary Fettis'],
masks:['Tania McComas'],
costumes:['Deborah Hopper']},
{title:'The Good, the Bad and the Ugly',
titleCZ:'Hodný, zlý a ošklivý',
year:1966,
runtime:161,
countries:['Italy','USA','Spain','Germany'],
genres:['Western'],
director:['Sergio Leone'],
actors:['Clint Eastwood','Eli Wallach','Lee Van Cleef','Aldo Giuffrè','Luigi Pistilli','Rada Rassimov','Enzo Petito','Claudio Scarchilli','John Bartha','Livio Lorenzon','Antonio Casale','Sandro Scarchilli','Benito Stefanelli','Angelo Novi','Antonio Casas','Aldo Sambrell','Al Mulock','Sergio Mendizábal','Antonio Molino Rojo','Lorenzo Robledo','Mario Brega','Chelo Alonso','Fortunato Arena','Román Ariznavarreta','Silvana Bacci','Frank Braña','Amerigo Castrighella','Saturno Cerra','Tony Di Mitri','Alberigo Donadeo','Attilio Dottesio','Veriano Ginesi','Joyce Gordon','Jesús Guzmán','Víctor Israel','Nazzareno Natale','Ricardo Palacios','Romano Puppo','Antoñito Ruiz','José Terrón','Luis Fernández de Eribe','Gianni Di Segni'],
screenplay:['Agenore Incrocci','Furio Scarpelli','Luciano Vincenzoni','Sergio Leone'],
production:['Alberto Grimaldi'],
music:['Ennio Morricone'],
camera:['Tonino Delli Colli'],
cut:['Nino Baragli','Eugenio Alabiso'],
sound:['Fausto Ancillai'],
scenography:['Carlo Simi'],
costumes:['Carlo Simi']},
{title:'Raiders of the Lost Ark',
titleCZ:'Dobyvatelé ztracené archy',
year:1981,
runtime:115,
countries:['USA'],
genres:['Adventure','Action','Drama','Fantasy'],
director:['Steven Spielberg'],
actors:['Harrison Ford','Karen Allen','John Rhys-Davies','Paul Freeman','Ronald Lacey','Wolf Kahler','Alfred Molina','Denholm Elliott','Anthony Higgins','Frank Marshall','Pat Roach','Terry Leonard','Sergio Mioni','Kiran Shah','George Harris','William Hootkins','Eddie Tagoe','Vic Tablian','Matthew Scurfield','Tutte Lemkow','Don Fellows','Terry Richards','Ishaq Bux','Peter Diamond','John Rees','Anthony Chinn','Michael Sheard','Patrick Durkin','Harry Fielder','Ted Grossman','Dennis Muren'],
screenplay:['Lawrence Kasdan'],
production:['Frank Marshall','George Lucas'],
music:['John Williams'],
camera:['Douglas Slocombe'],
cut:['Michael Kahn','George Lucas'],
sound:['Richard L. Anderson','Steve Maslow'],
scenography:['Norman Reynolds','Michael Ford'],
masks:['Tom Smith','Chris Walas'],
costumes:['Deborah Nadoolman']},
{title:'Rain Man',
titleCZ:'Rain Man',
year:1988,
runtime:133,
countries:['USA'],
genres:['Drama','Road movie'],
director:['Barry Levinson'],
actors:['Dustin Hoffman','Tom Cruise','Valeria Golino','Gerald R. Molen','Jack Murdock','Michael D. Roberts','Ralph Seymour','Lucinda Jenney','Bonnie Hunt','Kim Robillard','Beth Grant','Nick Mazzola','Ray Baker','Jake Hoffman','Royce D. Applegate','June Christopher','Archie Hahn','Ira Miller','Chris Mulkey','Tracy Newman','Julie Payne','Reni Santoni','Bridget Sienna','Jonathan Stark','Lynne Marie Stewart','Arnold F. Turner','Gigi Vorgan','Richard A. Buswell','Barry Levinson','Billie Perkins','Jill Senter','Darryl Wooten'],
screenplay:['Ronald Bass','Barry Morrow'],
production:['Mark Johnson'],
music:['Hans Zimmer'],
camera:['John Seale'],
cut:['Stu Linder'],
sound:['Richard Beggs'],
scenography:['Ida Random'],
masks:['Rick Sharp'],
costumes:['Bernie Pollack']},
{title:'The Magnificent Seven',
titleCZ:'Sedm statečných',
year:1960,
runtime:123,
countries:['USA'],
genres:['Western','Adventure','Action'],
director:['John Sturges'],
actors:['Yul Brynner','Steve McQueen','Horst Buchholz','Charles Bronson','Robert Vaughn','James Coburn','Brad Dexter','Eli Wallach','Jorge Martínez de Hoyos','Vladimir Sokoloff','Rosenda Monteros','Rico Alaniz','Pepe Hern','Natividad Vacío','Danny Bravo','John A. Alonzo','Enrique Lucero','Alex Montoya','Robert J. Wilke','Val Avery','Whit Bissell','Bing Russell','Manuel Alvarado','José Chávez','Roberto Contreras','Jim Davis','Valentin de Vargas','Larry Duran','Victor French','Edwin Max','Joseph Ruskin'],
screenplay:['William Roberts','Walter Bernstein','Walter Newman','Akira Kurosawa','Šinobu Hašimoto','Hideo Oguni'],
production:['John Sturges'],
music:['Elmer Bernstein'],
camera:['Charles Lang'],
cut:['Ferris Webster'],
sound:['Jack Solomon','Rafael Ruiz Esparza'],
scenography:['Edward Fitzgerald','Rafael Suárez'],
masks:['Emile LaVigne','Daniel C. Striepeke'],
costumes:['Bert Henrikson']},
{title:'Indiana Jones and the Last Crusade',
titleCZ:'Indiana Jones a Poslední křížová výprava',
year:1989,
runtime:127,
countries:['USA'],
genres:['Adventure','Action','Drama','Fantasy'],
director:['Steven Spielberg'],
actors:['Harrison Ford','Sean Connery','Denholm Elliott','Alison Doody','John Rhys-Davies','Julian Glover','River Phoenix','Michael Byrne','Kevork Malikyan','Alex Hyde-White','Eugene Lipinski','Ronald Lacey','Suzanne Roquette','Alexei Sayle','Richard Young','Vernon Dobtcheff','Bradley Gregg','Lee Richards','Pat Roach','Isla Blair','Chris Jenkinson','Michael Sheard','Tip Tipping','Frederick Jaeger','Ted Grossman','Stefan Kalipha','Robert Eddison','Julie Eccles'],
screenplay:['Jeffrey Boam'],
production:['Robert Watts'],
music:['John Williams'],
camera:['Douglas Slocombe'],
cut:['Michael Kahn','George Lucas'],
sound:['Richard Hymns','Gary Summers'],
scenography:['Elliot Scott'],
masks:['Peter Robb-King','Nick Dudman'],
costumes:['Anthony Powell','Joanna Johnston']},
{title:'Alien',
titleCZ:'Vetřelec',
year:1979,
runtime:117,
countries:['USA','UK'],
genres:['Horror','Sci-Fi'],
director:['Ridley Scott'],
actors:['Sigourney Weaver','Tom Skerritt','Veronica Cartwright','Harry Dean Stanton','John Hurt','Ian Holm','Yaphet Kotto','Bolaji Badejo','Helen Horton'],
screenplay:["Dan O'Bannon"],
production:['Walter Hill','David Giler','Gordon Carroll'],
music:['Jerry Goldsmith'],
camera:['Derek Vanlint'],
cut:['Terry Rawlings','Peter Weatherley'],
sound:['Bill Rowe'],
scenography:['Michael Seymour','Roger Christian','Leslie Dilley','Ian Whittaker'],
masks:['Pat Hay','Sarah Monzani'],
costumes:['John Mollo']},
{title:'Rush',
titleCZ:'Rivalové',
year:2013,
runtime:123,
countries:['USA','UK','Germany'],
genres:['Drama','Biographic','Sport','Action'],
director:['Ron Howard'],
actors:['Chris Hemsworth','Daniel Brühl','Olivia Wilde','Alexandra Maria Lara','Pierfrancesco Favino','David Calder','Natalie Dormer','Stephen Mangan','Christian McKay','Alistair Petrie','Julian Rhind-Tutt','Colin Stinton','Jamie de Courcey','Patrick Baladi','Vincent Riotta','Martin Savage','Jamie Sives','Tom Wlaschiha','Cristian Solimeno','James Norton','Joséphine de La Baume','Geoffrey Streatfeild','Julien Vialon','Douglas Reith','Brooke Johnston','Hannah Britland','Lisa McAllister','Val Jobara','Folker Banik','Jochen Kolenda','Roger Nevares','Raffaello Degruttola','Christian Feist','Demetri Goritsas','Marcello Walton','Masaši Fudžimoto','Roberto Cavazos','Marco Napoli','Cristian Stelluti','Lee Asquith-Coe','Robert Cambrinus','Niki Lauda','Stuart Mulcaster','Gemita Samarra','Julian Seager','Michael Vardian','Rosalie Wolff','Egija Zviedre','Chris Cowlin','Graham Curry','Tobias James-Samuels','Aisling Knight','Shaun Lucas','James Hunt','Zack Niizato','Vanda Dadras','Filippo Delaunay','Pete Meads','Guy Mayfield','Bob Constanduros','Devora Wilde','Marco Canadea','Philippe Spall','Laura Jean Marsh','Ricardo Freitas','Kai Henschel','Dennis Vehlen','Lucas Antoine Starrets','Eiji Mihara','Xavier Laurent','Erich Redman','Andreas Engelmann','James Michael Rankin'],
screenplay:['Peter Morgan'],
production:['Brian Grazer','Eric Fellner','Brian Oliver','Andrew Eaton','Daniel Hetzer','Ron Howard','Peter Morgan'],
music:['Hans Zimmer'],
camera:['Anthony Dod Mantle'],
cut:['Daniel P. Hanley','Mike Hill'],
sound:['Stefan Korte','Martin Steyer','Markus Stemler'],
scenography:['Mark Digby'],
masks:['Fae Hammond','Kirstin Chalmers','Duncan Jarman','Mark Coulier','Barrie Gower'],
costumes:['Julian Day']},
{title:'Ford v Ferrari',
titleCZ:"Le Mans '66",
year:2019,
runtime:152,
countries:['USA','France'],
genres:['Drama','Biographic','Sport','Action'],
director:['James Mangold'],
actors:['Matt Damon','Christian Bale','Jon Bernthal','Caitríona Balfe','Tracy Letts','Josh Lucas','Noah Jupe','Remo Girone','Ray McKinnon','JJ Feild','Corrado Invernizzi','Joe Williamson','Ian Harding','Christopher Darga','Shawn Law','Adam Mayfield','Sean Carrigan','Giles Matthey','Rudolf Martin','Evan Arnold','Darin Cooper','Wallace Langham','Jonathan LaPaglia','Brad Beyer','Giovanni Cirfiera','Wyatt Nash','Ward Horton','Tanner Foust','Andrew Burlinson','Lou Beatty Jr.','Marc Forget','Arron Shiver','Paul Fox','Zack Zublena','Kirt Kishita','Stefania Spampinato','Mario Di Donato','Jan Munroe','Fatimah Hassan','Mariah Maison','Sergi Cervera','Benjamin Rigby','Dallas Chandler','Marisa Petroro','Brea Bee','Joss Glennie-Smith','Jack McMullen','Bruce M. Stockert','Lachlan Buchanan','Alex Wexo','Drew Rausch','Jenelle McKee'],
screenplay:['Jez Butterworth','John-Henry Butterworth','Jason Keller'],
production:['Peter Chernin','James Mangold','Jenno Topping'],
music:['Marco Beltrami','Buck Sanders'],
camera:['Phedon Papamichael'],
cut:['Michael McCusker','Andrew Buckland'],
sound:['Donald Sylvester','Jay Wilkinson','David Giammarco','Paul Massey'],
scenography:['François Audouy'],
masks:['Lexx Staats',"Yesim 'Shimmy' Osman",'Kenny Niederbaumer','Tyson Fountaine','Ken Diaz','Janice Kavanagh','Doniella Davy','Aubrey Marie','Robert C. Mathews III','Jane Galli','Shaquanta Prescott'],
costumes:['Daniel Orlandi']},
{title:'Die Hard',
titleCZ:'Smrtonosná past',
year:1988,
runtime:131,
countries:['USA'],
genres:['Action','Thriller'],
director:['John McTiernan'],
actors:['Bruce Willis','Bonnie Bedelia','Alan Rickman','Paul Gleason','Reginald VelJohnson','Alexander Godunov','William Atherton','Hart Bochner','James Shigeta','Andreas Wisniewski',"De'voreaux White",'Clarence Gilyard Jr.','Grand L. Bush','Wilhelm von Homburg','Robert Davi','Rick Ducommun','Anthony Peck','Mary Ellen Trainor','Dennis Hayden','Al Leong','Charlie Picerni','Rebecca Broussard','Fred Lerner','Robert Lesser','Tracy Reiner','Selma Archerd','Lorenzo Caccialanza','Kym Malin','Conrad Hurtt','Bill Marcus','Gary Roberts','Bob Harks','David Katz'],
basedOn:['Roderick Thorp'],
screenplay:['Steven E. de Souza','Jeb Stuart'],
production:['Lawrence Gordon','Joel Silver'],
music:['Michael Kamen'],
camera:['Jan de Bont'],
cut:['John F. Link','Frank J. Urioste'],
sound:['Richard Shorr'],
scenography:['Jackson De Govia','Philip Leonard'],
masks:['Wes Dawn','Scott H. Eddo','Jim Kail'],
costumes:['Marilyn Vance']},
{title:'Aliens',
titleCZ:'Vetřelci',
year:1986,
runtime:137,
countries:['USA','UK'],
genres:['Sci-Fi','Thriller','Action','Adventure','Horror'],
director:['James Cameron'],
actors:['Sigourney Weaver','Carrie Henn','Michael Biehn','Paul Reiser','Lance Henriksen','Bill Paxton','William Hope','Jenette Goldstein','Al Matthews','Mark Rolston','Ricco Ross','Colette Hiller','Daniel Kash','Jay Benedict','Holly De Jong','Mac McDonald','Tom Woodruff Jr.','Tip Tipping','Stuart Milligan','Cynthia Dale Scott','Trevor Steedman','Jill Goldston'],
screenplay:['James Cameron'],
production:['Gale Anne Hurd'],
music:['James Horner'],
camera:['Adrian Biddle'],
cut:['Ray Lovejoy'],
sound:['Jeffrey Perkins','Otto Snel'],
scenography:['Peter Lamont','Crispian Sallis'],
masks:['Peter Robb-King','Everett Burrell'],
costumes:['Emma Porteous']},
{title:'The Sting',
titleCZ:'Podraz',
year:1973,
runtime:129,
countries:['USA'],
genres:['Drama','Comedy','Crime'],
director:['George Roy Hill'],
actors:['Paul Newman','Robert Redford','Robert Shaw','Charles Durning','Ray Walston','Eileen Brennan','Harold Gould','John Heffernan','Dana Elcar','Jack Kehoe','Dimitra Arliss','Robert Earl Jones','James Sloyan','Charles Dierkop','Lee Paul','Sally Kirkland','Avon Long','Arch Johnson','Ed Bakey','Brad Sullivan','John Quade','Larry D. Mann','Leonard Barr','Paulene Myers','Joe Tornatore','Jack Collins','Tom Spratley','Ken Sansom',"William 'Billy' Benedict",'Patricia Bratcher','Robert Brubaker','Robert Buckingham','Peter Paul Eastman','Kathleen Freeman','Susan French','Clarke Gordon','Bob Harks','George Holmes','Bruce Kimball','Mike Lally','Alexander Lockwood','Byron Morrow','Edwin Rochelle','Pearl Shear','Arthur Tovey','Guy Way','Sig Frohlich'],
screenplay:['David S. Ward'],
production:['Tony Bill','Michael Phillips','Julia Phillips'],
camera:['Robert Surtees'],
cut:['William Reynolds'],
sound:['Ronald Pierce','Robert R. Bertrand'],
scenography:['Henry Bumstead','James W. Payne'],
masks:['Rick Sharp','Mark Reedall'],
costumes:['Edith Head']},
{title:'Saving Private Ryan',
titleCZ:'Zachraňte vojína Ryana',
year:1998,
runtime:163,
countries:['USA'],
genres:['Drama','War'],
director:['Steven Spielberg'],
actors:['Tom Hanks','Edward Burns','Tom Sizemore','Jeremy Davies','Vin Diesel','Adam Goldberg','Barry Pepper','Giovanni Ribisi','Matt Damon','Dennis Farina','Ted Danson','Harve Presnell','Bryan Cranston','David Wohl','Nathan Fillion','Paul Giamatti','Ryan Hurst','Max Martini','Leland Orser','Dylan Bruno','Dale Dye','Rolf Saxon','Corey Johnson','Andrew Scott','Glenn Wrage','John de Lancie','Martin McDougall','Raffaello Degruttola','John Sharian','Kathleen Byron','Martin Hub','Rob Freeman','Leoš Stránský','Demetri Goritsas','Aiden Condron','Crofton Hardester','Nigel Whitmey','Shane Johnson','Lee Aaron Rosen','Anna Maguire','Amanda Boxer','Laird Macintosh','Paul Hickey','Daniel Cerqueira','John Walters','Harrison Young','Mac Steinmeier','Vincent Walsh','Grahame Wood','Tilo Keiner','Joerg Stadler','Erich Redman'],
screenplay:['Robert Rodat'],
production:['Ian Bryce','Steven Spielberg','Mark Gordon'],
music:['John Williams'],
camera:['Janusz Kamiński'],
cut:['Michael Kahn'],
sound:['Richard Hymns','Gary Summers','Andy Nelson','Gary Rydstrom'],
scenography:['Thomas E. Sanders'],
masks:['Lizzie Yianni Georgiou','Lois Burwell','Sharon Doyle'],
costumes:['Joanna Johnston']},
{title:'Give the Devil His Due',
titleCZ:'S čerty nejsou žerty',
year:1984,
runtime:91,
countries:['Czechoslovakia'],
genres:['Fairytale','Comedy'],
director:['Hynek Bočan'],
actors:['Luděk Munzar','Vladimír Dlouhý','Ondřej Vetchý','Jana Dítětová','Josef Kemr','Viktor Preiss','Jaroslava Kretschmerová','Dana Bartůňková','Monika Stará','Petr Nárožný','Karel Heřmánek','Václav Vydra nejml.','František Vicena','Jan Skopeček','Vladimír Hrubý','Ladislav Gerendáš','Jiří Růžička ml.','Stanislav Hájek','Vladimír Hrabánek','Miloslav Štibich','Vlastimil Přáda','Vladimír Švabík','Vlastimil Bedrna','Petr Růžička','Zdeněk Blažek','Václav Král','Milan Charvát','Stanislav Oubram','Jiří Schmiedt','David Schneider','Václav Upír Krejčí','Jan Šimek','Michal Roneš','Pavel Spálený','Jana Robenková','Miro Grisa','Jan Schmid','Václav Štercl','Naděžda Prchalová-Vicenová','Miloslav Homola','Martin Hron','Roman Holý','Pavel Cajzl','Jan Kreidl','Jiří Pomeje'],
basedOn:['Božena Němcová'],
screenplay:['Jiří Just','Hynek Bočan'],
music:['Jaroslav Uhlíř'],
camera:['Jaromír Šofr'],
cut:['Dalibor Lipský'],
sound:['Karel M. Martínek'],
scenography:['Zbyněk Hloch'],
masks:['Josef Lojík'],
costumes:['Jarmila Konečná','Jiří Bláha','Helena Vondrušková']},
{title:'Léon: The Professional',
titleCZ:'Leon',
year:1994,
runtime:105,
countries:['France'],
genres:['Drama','Crime','Thriller'],
director:['Luc Besson'],
actors:['Jean Reno','Gary Oldman','Natalie Portman','Danny Aiello','Peter Appel','Willi One Blood','Michael Badalucco','Ellen Greene','Elizabeth Regen','Frank Senger','Maïwenn','Jessie Keosian','George Martin','Stuart Rudin','Kent Broadhurst','Geoffrey Bateman','Arsène Jiroyan','Joseph Malerba','Robert LaSardo','Crystal Michelle Blake','Randy Pearlstein','Fred Fischer','Adam Busch','Samy Naceri','Marc Andréoni','Dan Thorens','Don Creech'],
screenplay:['Luc Besson'],
production:['Patrice Ledoux'],
music:['Eric Serra'],
camera:['Thierry Arbogast'],
cut:['Sylvie Landra'],
sound:['Pierre Excoffier'],
scenography:['Dan Weil'],
masks:['Geneviève Peyralade'],
costumes:['Magali Guidasci']},
{title:'Amadeus',
titleCZ:'Amadeus',
year:1984,
runtime:160,
countries:['USA'],
genres:['Drama','Biographic','Music'],
director:['Miloš Forman'],
actors:['F. Murray Abraham','Tom Hulce','Elizabeth Berridge','Roy Dotrice','Simon Callow','Christine Ebersole','Jeffrey Jones','Charles Kay','Kenneth McMillan','Kenny Baker','Martin Cavina','Roderick Cook','Milan Demjanenko','Peter DiGesu','Nicholas Kepros','Philip Lenkowsky','Herman Meckler','Cynthia Nixon','Brian Pettifer','Vincent Schiavelli','Douglas Seale','Cassie Stuart','John Strauss','Rita Zohar','Miro Grisa','Helena Cihelníková','Karel Gult','Zuzana Kadlecová','Eva Šenková','Jaroslav Mikulín','Ladislav Krečmer','Karel Fiala','Jan Blažek','Zdeněk Jelen','Hana Brejchová','Miriam Chytilová','Karel Effa','Radka Fidlerová','René Gabzdyl','Karel Hábl','Aťka Janoušková','Vladimír Krouský','Jiří Krytinář','Jan Kuželka','Jiří Lír','Lenka Loubalová','Jitka Molavcová','Jana Musilová','Pavel Nový','Jan Pohan','Tereza Pokorná-Herzová','Ivan Pokorný','Milan Riehs','Jiří Vančura','Dana Vávrová','Josef Zeman','Zbyněk Bruthans','Zdeněk Mahler','Vladimír Svitáček','Viktor Maurer','Milan Aulický','Milan Karpíšek','Zdeněk Srstka','John Carrafa','Barbara Bryne'],
screenplay:['Peter Shaffer','Peter Shaffer'],
production:['Saul Zaentz'],
music:['Wolfgang Amadeus Mozart','Antonio Salieri'],
camera:['Miroslav Ondříček'],
cut:['Michael Chandler'],
sound:['John Nutt','Mark Berger'],
scenography:['Patrizia von Brandenstein','Karel Černý'],
masks:['František Čížek','Bohumil Sobotka','Dick Smith'],
costumes:['Theodor Pištěk ml.']},
{title:'The Elementary School',
titleCZ:'Obecná škola',
year:1991,
runtime:97,
countries:['Czechoslovakia'],
genres:['Comedy','Drama'],
director:['Jan Svěrák'],
actors:['Jan Tříska','Zdeněk Svěrák','Libuše Šafránková','Rudolf Hrušínský','Irena Pavlásková','Ondřej Vetchý','Daniela Kolářová','Eva Holubová','Rudolf Hrušínský ml.','Iva Škudrnová','Miroslava Škudrnová','Alice Šnirychová','Petr Čepek','Bolek Polívka','Zdeněk Mucha','Oldřich Vlach','Petr Brukner','Karla Chadimová','Bořivoj Penc','Jiří Menzel','Karel Kachyňa','Taťána Puttová','Ladislav Chroust','Miroslava Pleštilová','Václav Chalupa','Viktor Nejedlý ml.','Stanislav Hájek','Olga Vohryzková','Rudolf Hammer','Václav Jakoubek','Radoslav Budáč','Marek Endal','Michal Škrabal','Jaroslav Slánský','Jan Demeter','Filip Lim','Tomáš Krejčík','Jaroslav Kudláček','Jiří Peterka','Michal Lajtkep','Jaroslav Ježek','Jan Kasala','Tomáš Procházka','Marek Pelc','Pavel Kučera','Tomáš Jákl','Martin Pětioký','Ivo Hasalík','Karel Kmoch','Michal Škrabák','Jiří Tala','Jiří Prückner','Petra Bžunková','Hynek Votoček','Zlata Adamovská','Jan Hraběta'],
screenplay:['Zdeněk Svěrák'],
production:['Jaromír Lukáš'],
music:['Jiří F. Svoboda'],
camera:['F. A. Brabec'],
cut:['Alois Fišárek'],
sound:['Jiří Kříž','Jiří Moudrý'],
scenography:['Vladimír Labský','Gabriela Kubenová'],
masks:['František Příhoda','Božena Došlá','Zdena Prchlíková'],
costumes:['Jan Kropáček','Ludmila Ondráčková','Dana Chaloupková']},
{title:'Star Wars: Episode V - The Empire Strikes Back',
titleCZ:'Star Wars: Epizoda V - Impérium vrací úder',
year:1980,
runtime:124,
countries:['USA'],
genres:['Sci-Fi','Adventure','Fantasy','Action'],
director:['Irvin Kershner'],
actors:['Mark Hamill','Harrison Ford','Carrie Fisher','Billy Dee Williams','Anthony Daniels','David Prowse','Peter Mayhew','Frank Oz','Alec Guinness','Jeremy Bulloch','Kenneth Colley','Julian Glover','John Dicks','Treat Williams','James Earl Jones','Ian McDiarmid','Denis Lawson','Martin Dew','John Ratzenberger','Clive Revill','Kenny Baker','Mark Jones','Tom Egeland','John Hollis','Peter MacDonald','Terry Richards','Mike Edmonds','Michael Culver','Milton Johns','Peter Diamond','Peter Roy','Michael Sheard','Bruce Boa','Jason Wingreen','Marjorie Eaton','Shaun Curry','Doug Robinson','Jack Purvis','Arve Juritzen','Mark Capri','Jack McKenzie'],
screenplay:['Leigh Brackett','Lawrence Kasdan'],
production:['Gary Kurtz'],
music:['John Williams'],
camera:['Peter Suschitzky'],
cut:['Paul Hirsch','Marcia Lucas','George Lucas'],
sound:['Gary Summers','Gregg Landaker','Ray Leonard'],
scenography:['Norman Reynolds','Michael Ford'],
masks:['Phil Tippett','Rick Baker'],
costumes:['John Mollo']},
{title:"Journey into the Depth of the Student's Soul",
titleCZ:'Cesta do hlubin študákovy duše',
year:1939,
runtime:88,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Martin Frič'],
actors:['Jindřich Plachta','Jaroslav Marvan','František Vnouček','Miloš Nedbal','Jaroslav Průcha','František Kreuzmann st.','Ludvík Veverka','Vojta Novák','Jarmila Holmová','Karel Veverka','Ferenc Futurista','Ladislav Pešek','R. A. Strejka','Rudolf Hrušínský','František Filipovský','Jana Ebertová','Zbyšek Olšovský','Karel Hošek','Vilém Pruner','Vladimír Salač','Gustav Hilmar','Marie Blažková','Bolek Prchal','Ella Nollová','Zvonimir Rogoz','Blažena Slavíčková','Josef Kemr','Libuše Rogozová','Antonín Jirsa','Stanislav Procházka st.','Bohdan Lachman','Marie Nademlejnská','Karel Roden','Marie Vildová'],
basedOn:['Jaroslav Žák'],
screenplay:['Jan Kaplan','Jaroslav Žák'],
music:['Roman Blahník'],
camera:['Ferdinand Pečenka'],
cut:['Jan Kohout'],
sound:['Stanislav Vondraš'],
scenography:['Karel Petr Adam']},
{title:'L.A. Confidential',
titleCZ:'L. A. - Přísně tajné',
year:1997,
runtime:138,
countries:['USA'],
genres:['Drama','Crime','Mystery','Thriller'],
director:['Curtis Hanson'],
actors:['Kevin Spacey','Russell Crowe','Guy Pearce','James Cromwell','David Strathairn','Kim Basinger','Danny DeVito','Graham Beckel','Simon Baker','Matt McCoy','Jim Metzler','Paul Guilfoyle','Ron Rifkin','Paolo Seganti','Steve Rankin','Symba','Bob Clendenin','Amber Smith','Shane Dixon','Tomas Arana','Michael McCleery','Jack Conley','Michael Chieffo','Jeremiah Birkett','Brenda Bakke','David St. James','Nectar Rose','Thomas Rosales Jr.','Jordan Marder','Brian Lally','Brian Bossetta','Allan Graf','John Mahon','Jack Knight','Rebecca Klingler','Robert Foster','Jeff Austin','Precious Chong','Irene Roseen','Will Zahrn','Steven Lambert','Norman Howell','Salim Grant','Gregory White','Kevin Patrick Kelly','George Yager','Dell Yount','Darrell Sandeen','Lennie Loftin','Sandra Taylor','Jess Thomas','Alice Dinnean','Hennen Chambers','Michael Warwick'],
basedOn:['James Ellroy'],
screenplay:['Brian Helgeland','Curtis Hanson'],
production:['Arnon Milchan','Curtis Hanson','Michael G. Nathanson'],
music:['Jerry Goldsmith'],
camera:['Dante Spinotti'],
cut:['Peter Honess'],
sound:['Andy Nelson','Anna Behlmer'],
scenography:['Jeannine Oppewall','Jay Hart'],
masks:['John M. Elliott','Jr.','Lance Anderson','Scott H. Eddo','Janis Clark','Tommy Cole'],
costumes:['Ruth Myers']},
{title:'Butch Cassidy and the Sundance Kid',
titleCZ:'Butch Cassidy a Sundance Kid',
year:1969,
runtime:110,
countries:['USA'],
genres:['Western','Drama','Crime','Biographic'],
director:['George Roy Hill'],
actors:['Paul Newman','Robert Redford','Katharine Ross','Strother Martin','Henry Jones','Jeff Corey','George Furth','Cloris Leachman','Ted Cassidy','Kenneth Mars','Donnelly Rhodes','Jody Gilbert','Timothy Scott','Don Keefer','Charles Dierkop','Pancho Córdova','Nelson Olmsted','Paul Bryar','Sam Elliott','Eric Sinclair','Larry Barton','Rico Cattani','José Chávez','Percy Helton','Enrique Lucero','Jorge Russek','José Torvay'],
screenplay:['William Goldman'],
production:['John Foreman'],
music:['Burt Bacharach'],
camera:['Conrad L. Hall'],
cut:['John C. Howard','Richard C. Meyer'],
sound:['Bill Edmondson','Don Hall'],
scenography:['Jack Martin Smith','Walter M. Scott','Chester Bayhi'],
masks:['Daniel C. Striepeke'],
costumes:['Edith Head']},
{title:'Back to the Future',
titleCZ:'Návrat do budoucnosti',
year:1985,
runtime:116,
countries:['USA'],
genres:['Adventure','Comedy','Sci-Fi'],
director:['Robert Zemeckis'],
actors:['Michael J. Fox','Christopher Lloyd','Lea Thompson','Crispin Glover','Tom Wilson','Claudia Wells','Marc McClure','Wendie Jo Sperber','George DiCenzo','Frances Lee McCain','James Tolkan','J.J. Cohen','Casey Siemaszko','Billy Zane','Courtney Gains','Robert Krantz','Huey Lewis','Jason Hervey','Lisa Freeman',"George 'Buck' Flower",'Norman Alden','Arthur Tovey','Will Hare','Read Morgan','Ivy Bethune','Maia Brewton','Gary Riley','Deborah Harmon','Elsa Raven','Donald Fullilove','Charles L. Campbell','Hal Gausman','Richard Patrick','John McCook','Jamie Abbott'],
screenplay:['Robert Zemeckis','Bob Gale'],
production:['Neil Canton','Bob Gale'],
music:['Alan Silvestri'],
camera:['Dean Cundey'],
cut:['Arthur Schmidt','Harry Keramidas'],
sound:['Bill Varney','B. Tennyson Sebastian II'],
scenography:['Lawrence G. Paull','Hal Gausman'],
masks:['Ken Chase'],
costumes:['Deborah L. Scott']},
{title:'The Lord of the Rings: The Two Towers',
titleCZ:'Pán prstenů: Dvě věže',
year:2002,
runtime:172,
countries:['USA','New Zealand'],
genres:['Fantasy','Adventure','Action'],
director:['Peter Jackson'],
actors:['Elijah Wood','Ian McKellen','Viggo Mortensen','Sean Astin','Liv Tyler','Billy Boyd','John Rhys-Davies','Dominic Monaghan','Christopher Lee','Miranda Otto','Brad Dourif','Orlando Bloom','Cate Blanchett','Karl Urban','Bernard Hill','David Wenham','Andy Serkis','Craig Parker','Sean Bean','Nathaniel Lees','Robyn Malcolm','Hugo Weaving','Robbie Magasiva','Peter Jackson','John Noble','Billy Jackson','Sala Baker','John Bach','Karlos Drinkwater','Bruce Hopkins','John Leigh','Jed Brophy','Bruce Phillips','Bruce Allpress','Olivia Tennet','Dan Hennah','Barrie M. Osborne','Ben Fransham','Owen Black','Sam Kelly','Alix Bushnell','Samuel E. Shore','Stephen Ure','Paul Norell'],
basedOn:['J.R.R. Tolkien'],
screenplay:['Fran Walsh','Philippa Boyens','Stephen Sinclair','Peter Jackson'],
production:['Peter Jackson','Fran Walsh','Barrie M. Osborne'],
music:['Howard Shore'],
camera:['Andrew Lesnie'],
sound:['Gary Summers','Mike Hopkins','Ethan Van der Ryn','Michael Semanick','Christopher Boyes','Michael Hedges'],
scenography:['Grant Major'],
masks:['Vivienne MacGillicuddy','Jeremy Woodhead',"Peter 'Swords' King",'Davina Lamont','Rick Findlater','Tami Lane','Kerryn Flewell-Smith'],
costumes:['Ngila Dickson','Richard Taylor']},
{title:'City of God',
titleCZ:'Město bohů',
year:2002,
runtime:130,
countries:['Brazil','France'],
genres:['Crime','Drama'],
director:['Fernando Meirelles','Kátia Lund'],
actors:['Alexandre Rodrigues','Leandro Firmino','Matheus Nachtergaele','Phellipe Haagensen','Seu Jorge','Jonathan Haagensen','Douglas Silva','Alice Braga','Gero Camilo','Paulo Lins','Renato de Souza','Jefechander Suplino','Emerson Gomes','Charles Paraventi','Luis Carlos Oliveira','Roberta Rodrigues','Babu Santana','Kiko Marques','Leandro Lima','Tulé Peak'],
basedOn:['Paulo Lins'],
screenplay:['Bráulio Mantovani'],
production:['Mauricio Andrade Ramos','Andrea Barata Ribeiro'],
music:['Antonio Pinto','Ed Côrtes'],
camera:['César Charlone'],
cut:['Daniel Rezende'],
sound:['Martín Hernández','Alessandro Laroca','Alejandro Quevedo'],
scenography:['Tulé Peak'],
costumes:['Inês Salgado','Bia Salgado']},
{title:'A Beautiful Mind',
titleCZ:'Čistá duše',
year:2001,
runtime:135,
countries:['USA'],
genres:['Drama','Biographic'],
director:['Ron Howard'],
actors:['Russell Crowe','Jennifer Connelly','Ed Harris','Christopher Plummer','Paul Bettany','Judd Hirsch','Adam Goldberg','Anthony Rapp','Josh Lucas','Vivien Cardone','Jason Gray-Stanford','Austin Pendleton','Josh Pais','Ron Howard','Alessandro Tanaka','Stelio Savante','Roy Thinnes','Scott Fernstrom','Rance Howard','Reggie Austin','Tanya Clarke','Robert Myers','Michael Fiore','Michael Esper','Michael Abbott Jr.','Bryce Dallas Howard','Betsy Klompus','Seth Gabel','Peter Bonilla'],
basedOn:['Sylvia Nasar'],
screenplay:['Akiva Goldsman'],
production:['Brian Grazer'],
music:['James Horner'],
camera:['Roger Deakins'],
cut:['Daniel P. Hanley','Mike Hill'],
sound:['Joe DeAngelis','Frank A. Montaño','Bob Olari'],
scenography:['Wynn Thomas'],
masks:['Neal Martz','Wesley Wofford','Brian Sipe','Patrick Alemi','Greg Cannom','Christopher Allen Nelson'],
costumes:['Rita Ryack']},
{title:'Gladiator',
titleCZ:'Gladiátor',
year:2000,
runtime:155,
countries:['USA','UK'],
genres:['Action','Adventure','Drama'],
director:['Ridley Scott'],
actors:['Russell Crowe','Joaquin Phoenix','Connie Nielsen','Oliver Reed','Richard Harris','Derek Jacobi','Djimon Hounsou','David Schofield','John Shrapnel','Tomas Arana','Ralf Moeller','Spencer Treat Clark','David Hemmings','Tommy Flanagan','Sven-Ole Thorsen','Omid Djalili','Nicholas McGaughey','Tony Curran','Alun Raglan','David Bailie','Giannina Facio-Scott','Giorgio Cantarini','Allan Corduner','Michael Mellinger','Adam Levy','Gilly Gilchrist','Antone Pagán','Norman Campbell Rees'],
screenplay:['David Franzoni','John Logan','William Nicholson'],
production:['Douglas Wick','Branko Lustig','David Franzoni'],
music:['Hans Zimmer','Lisa Gerrard'],
camera:['John Mathieson'],
cut:['Pietro Scalia'],
sound:['Bob Beemer','Per Hallberg','Scott Millan'],
scenography:['Arthur Max','Crispian Sallis'],
masks:['Paul Engelen','Graham Johnston'],
costumes:['Janty Yates']},
{title:'The Cremator',
titleCZ:'Spalovač mrtvol',
year:1968,
runtime:96,
countries:['Czechoslovakia'],
genres:['Drama','Horror','Thriller','Psychology','Comedy'],
director:['Juraj Herz'],
actors:['Rudolf Hrušínský','Vlasta Chramostová','Jana Stehnová-Čechová','Miloš Vognič','Ilja Prachař','Zora Božinová','Eduard Kohout','Jiří Lír','Dimitrij Rafalský','Jan Vlček','Václav Halama','Jiří Hálek','Václav Kotva','Míla Myslíková','Vladimír Menšík','Jiří Menzel','Václav Štekl','Nataša Gollová','Jindřich Narenta','Helena Anýžová','Jana Šulcová','Jan Řeřicha','Oldřich Vízner','Carmen Mayerová','Libuše Pešková','Růžena Vlčková','Eva Ulincová','Věra Vlčková','Rudolf Iltis','Josef Střecha','František Kubíček','Erich Fichtner','Jiřina Bílá','Jan Kraus','Alfred Růžička','Alena Balejová','Marie Hübschová','Pavla Břínková','Zuzana Rumlová','Olga Bušková','Karel Hovorka st.','Karel Fiala','Miloslav Šindler','Jaroslav Toms','Václav Vodák','František Häusler','Radomír Hubáček','Helena Kotoučová','Jiří Kaftan','Theodor Kunst','František Poláček','Felix Černý','Karel Přinesdomů','Zdeněk Šmidrkal','Marie Rosůlková','Josef Kemr','Jiřina Jandová'],
basedOn:['Ladislav Fuks'],
screenplay:['Ladislav Fuks','Juraj Herz'],
music:['Zdeněk Liška'],
camera:['Stanislav Milota'],
cut:['Jaromír Janáček'],
sound:['František Černý'],
scenography:['Zbyněk Hloch'],
masks:['František Čížek'],
costumes:['Olga Dimitrovová']},
{title:'Dances with Wolves',
titleCZ:'Tanec s vlky',
year:1990,
runtime:181,
countries:['USA','UK'],
genres:['Adventure','Drama','Western'],
director:['Kevin Costner'],
actors:['Kevin Costner','Mary McDonnell','Graham Greene','Rodney A. Grant',"Floyd 'Red Crow' Westerman",'Tantoo Cardinal','Robert Pastorelli','Charles Rocket','Maury Chaykin','Tom Everett','Wes Studi','Jim Wilson','Michael Horton','Michael Spears','Kirk Baltz','Steve Reevis','Tony Pierce','Wayne Grace','Jimmy Herman','Larry Joshua','Donald Hotton','Buffalo Child','Nathan Lee Chasing His Horse'],
basedOn:['Michael Blake'],
screenplay:['Michael Blake'],
production:['Kevin Costner','Jim Wilson'],
music:['John Barry'],
camera:['Dean Semler'],
cut:['Neil Travis','William Hoy','Chip Masamitsu'],
sound:['Jeffrey Perkins'],
scenography:['Jeffrey Beecroft'],
masks:['David Atherton'],
costumes:['Elsa Zamparelli']},
{title:'Spider-Man: Across the Spider-Verse',
titleCZ:'Spider-Man: Napříč paralelními světy',
year:2023,
runtime:140,
countries:['USA'],
genres:['Animation','Action','Adventure','Sci-Fi'],
director:['Joaquim Dos Santos','Kemp Powers','Justin K. Thompson'],
actors:['Shameik Moore','Hailee Steinfeld','Oscar Isaac','Jake Johnson','Brian Tyree Henry','Luna Lauren Velez','Jason Schwartzman','Issa Rae','Rachel Dratch','Shea Whigham','Daniel Kaluuya','Karan Soni','Greta Lee','Mahershala Ali','Amandla Stenberg','Jharrel Jerome','Andy Samberg','Jack Quaid','Jorma Taccone','J.K. Simmons','Donald Glover','Elizabeth Perkins','Kathryn Hahn','Ayo Edebiri','Atsuko Okatsuka','Peter Sohn','Nic Novicki','Taran Killam','Josh Keaton','Sofia Barclay','Danielle Perez','Yuri Lowenthal','Ashley London','Andrew Garfield','Tobey Maguire','Denis Leary','Peggy Lu','Lex Lang','Warren Sroka'],
screenplay:['Phil Lord','Christopher Miller','Dave Callaham'],
production:['Phil Lord','Christopher Miller','Amy Pascal','Avi Arad','Christina Steinberg'],
music:['Daniel Pemberton'],
cut:['Mike Andrews'],
sound:['Alec Rubay','Jessica Schultz','Kip Smedley','Vinii Khullar'],
scenography:['Kevin Aymeric']},
{title:'The Pianist',
titleCZ:'Pianista',
year:2002,
runtime:150,
countries:['France','Poland','Germany','UK','USA'],
genres:['Drama','Biographic','War','Music'],
director:['Roman Polański'],
actors:['Adrien Brody','Emilia Fox','Michał Żebrowski','Ed Stoppard','Maureen Lipman','Frank Finlay','Jessica Kate Meyer','Wanja Mues','Richard Ridings','Anthony Milner','Thomas Lawinky','Joachim Paul Assböck','Daniel Caltagirone','Andrzej Blumenfeld','Zbigniew Zamachowski','Popeck','Zofia Czerwińska','Udo Kroschwald','Uwe Rathsam','Joanna Brodzik','Katarzyna Bargiełowska','Maja Ostaszewska','Cyril Shaps','Wojciech Smolarz','Lech Mackiewicz','Ruth Platt','Frank-Michael Köbe','Torsten Flach','Peter Rappenglück','Ronan Vibert','Andrzej Pieczyński','Katarzyna Figura','Valentine Pelka','Andrew Tiernan','Thomas Kretschmann','Cezary Kosiński','Grzegorz Artman','Adam Bauman','Paweł Burczyk','Zbigniew Dziduch','Marian Dziędziel','Nina Franoszek','Jerzy Góralczyk','John Keogh','Jarosław Kopaczewski','Dmitrij Leščenko','Dorota Liliental','Rafał Mohr','Krzysztof Pieczyński','Morgane Polanski','Norbert Rakowski','Piotr Siejka','Andrzej Szenajch','Tomasz Tyndyk','Andrzej Walden','Zbigniew Waleryś','Maciej Winkler','Tadeusz Wojtych','Andrzej Zieliński','Maurycy Zylber','Ksawery Zylber','Roman Garbowski','Paweł Małaszyński','Axel Prahl','Borys Szyc','Etl Szyc','Małgorzata Trybalska','Jacek Wolszczak','Paweł Zdun'],
basedOn:['Władysław Szpilman'],
screenplay:['Ronald Harwood'],
production:['Roman Polański','Robert Benmussa','Alain Sarde'],
music:['Wojciech Kilar'],
camera:['Paweł Edelman'],
cut:['Hervé de Luze'],
sound:['Jean-Marie Blondel','Gérard Hardy'],
scenography:['Allan Starski','Gabriele Wolff'],
masks:['Waldemar Pokromski','Didier Lavergne'],
costumes:['Anna Biedrzycka-Sheppard']},
{title:'My Sweet Little Village',
titleCZ:'Vesničko má středisková',
year:1985,
runtime:98,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Jiří Menzel'],
actors:['János Bán','Marian Labuda st.','Rudolf Hrušínský','Rudolf Hrušínský ml.','Rudolf Hrušínský nejml.','Petr Čepek','Libuše Šafránková','Jan Hartl','Miloslav Štibich','Oldřich Vlach','Stanislav Aubrecht','Zdeněk Svěrák','Magda Křížková-Šebestová','Július Satinský','Josef Somr','František Vláčil','Milena Dvorská','Milada Ježková','Ladislav Županič','Jitka Asterová','Jiří Lír','Blanka Lormanová','Eugen Jegorov','Jiří Schmitzer','Vlastimila Vlková','Jana Vaňková','Petr Brukner','Míla Myslíková','Jan Hraběta','Jana Kušiaková','Milan Šteindler','Vladimír Hrabánek','Zuzana Burianová','Klára Pollertová-Trojanová','Vida Neuwirthová','Jan Kašpar','Vlasta Jelínková','Dagmar Hajná','Alena Fišerová','Marie Poláková','Libuše Štědrá','Jaroslav Tomsa','Josef Vondráček','Petr Studenovský','Kateřina Nová','Jiří Racek','Miroslav Moravec','Jan Schánilec'],
screenplay:['Zdeněk Svěrák'],
music:['Jiří Šust'],
camera:['Jaromír Šofr'],
cut:['Jiří Brožek'],
sound:['František Černý','Karel Jaroš'],
scenography:['Zbyněk Hloch'],
masks:['Tomáš Kuchta','Šárka Šimůnková','Simona Marešová'],
costumes:['Běla Suchá']},
{title:'The Sixth Sense',
titleCZ:'Šestý smysl',
year:1999,
runtime:107,
countries:['USA'],
genres:['Drama','Thriller','Mystery','Horror'],
director:['M. Night Shyamalan'],
actors:['Bruce Willis','Toni Collette','Haley Joel Osment','Olivia Williams','Donnie Wahlberg','Mischa Barton','Trevor Morgan','KaDee Strickland','M. Night Shyamalan','Angelica Page','Glenn Fitzgerald','Kate Kearney-Patch','Jonathan Nation','Peter Anthony Tambakis','Jeffrey Zubernis','Bruce Norris','Greg Wood','Sarah Ripard','Patrick F. McDade','Firdous Bamji','Alison Robertson','Ellen Sheppard','Bob Bowersox'],
screenplay:['M. Night Shyamalan'],
production:['Frank Marshall','Kathleen Kennedy','Barry Mendel'],
music:['James Newton Howard'],
camera:['Tak Fujimoto'],
cut:['Andrew Mondshein'],
scenography:['Larry Fulton','Douglas A. Mowat'],
masks:['Gerald Quist'],
costumes:['Joanna Johnston']},
{title:'Casino',
titleCZ:'Casino',
year:1995,
runtime:178,
countries:['USA','France'],
genres:['Drama','Crime'],
director:['Martin Scorsese'],
actors:['Robert De Niro','Sharon Stone','Joe Pesci','James Woods','Don Rickles','Alan King','Kevin Pollak','L.Q. Jones','Dick Smothers','Frank Vincent','John Bloom','Pasquale Cajano','Melissa Prophet','Bill Allison','Vinny Vella','Catherine Scorsese','Philip Suriano','Frankie Avalon','Steve Allen','Jayne Meadows','Joseph Rigano','Gene Ruffini','Cathy Scorsese','Paul Herman','Joey DePinto','Dom Angelo','Ali Pirouzkar','Frankie J. Allison','Anthony Russell','Ronald Maccone','Joseph P. Reidy','Joe La Due','Stuart Nisbet','Frank Adonis','Joseph Bono','Craig Vincent','Daniel P. Conte','Jonathan Kraft','Bret McCormick','Clem Caserta','Jed Mills','Brian Le Baron','Richard Riehle','Carl Ciarfalio','Jack Orend','Ffolliott Le Coque','Roy Conrad','Nick Mazzola','Sly Smith','Sam Wilson','Peter Paul Eastman','Alfonso Gomez-Rejon','Steve Schirripa','Jo-Anne Smith-Ojeil','Dick Warlock'],
basedOn:['Nicholas Pileggi'],
screenplay:['Nicholas Pileggi','Martin Scorsese'],
production:['Barbara De Fina'],
camera:['Robert Richardson'],
cut:['Thelma Schoonmaker'],
sound:['Skip Lievsay','Tom Fleischman'],
scenography:['Dante Ferretti'],
masks:['Jo-Anne Smith-Ojeil','Ken Diaz','Howard Berger'],
costumes:['Rita Ryack','John Dunn']},
{title:'Fight Club',
titleCZ:'Klub rváčů',
year:1999,
runtime:139,
countries:['USA','Germany'],
genres:['Drama','Thriller'],
director:['David Fincher'],
actors:['Edward Norton','Brad Pitt','Helena Bonham Carter','Meat Loaf','Jared Leto','Zach Grenier','Holt McCallany','Eion Bailey','Richmond Arquette','David Andrews','Eugenie Bondurant','Christina Cabot','Tim DeZarn','Ezra Buzzington','David Lee Smith','Evan Mirand','Lou Beatty Jr.','Thom Gossom Jr.','Valerie Bickford','Carl Ciarfalio','Stuart Blumberg','Matt Winston','David Jean Thomas','Paul Carafotes','Michael Shamus Wiles','Leonard Termo','Van Quattro','Markus Redmond','Michael Arturo','Matt Cinquanta','Brian Tochi','Charlie Dell','Christopher John Fields','Paul Dillon','Bob Stephenson','Pat McNamara','Peter Iacangelo','George Maguire','Kevin Scott Mack','Greg Bronson','Summer Moore','Mark Fite','Joel Bissonnette','Steve Sobel','Scotch Ellis Loring'],
basedOn:['Chuck Palahniuk'],
screenplay:['Jim Uhls'],
production:['Art Linson','Ceán Chaffin'],
music:['The Dust Brothers'],
camera:['Jeff Cronenweth'],
cut:['James Haygood'],
sound:['Richard Hymns','David Parker','Ren Klyce','Michael Semanick'],
scenography:['Alex McDowell','Jay Hart'],
masks:['Jean Ann Black','Rob Bottin'],
costumes:['Michael Kaplan']},
{title:'Django Unchained',
titleCZ:'Nespoutaný Django',
year:2012,
runtime:165,
countries:['USA'],
genres:['Western','Adventure','Drama'],
director:['Quentin Tarantino'],
actors:['Jamie Foxx','Christoph Waltz','Leonardo DiCaprio','Kerry Washington','Samuel L. Jackson','Walton Goggins','Dennis Christopher','James Remar','David Steen','Dana Gourrier','Nichole Galicia','Laura Cayouette','Ato Essandoh','Sammi Rotibi','Escalante Lundy','Miriam F. Glover','Don Johnson','Franco Nero','James Russo','Tom Wopat','Don Stroud','Russ Tamblyn','Amber Tamblyn','Bruce Dern','M.C. Gainey','Cooper Huckabee','Doc Duhame','Jonah Hill','Lee Horsley','Zoë Bell','Michael Bowen','Robert Carradine','Jake Garber','Ted Neeley','James Parks','Tom Savini','Michael Parks','John Jarratt','Quentin Tarantino','Amari Cheatom','Keith Jefferson','Marcus Henderson','Louise Stratten','Kim Robillard','Shana Stein','Jack Lucarelli','Sharon Pierre-Louis','Christopher Berry','Kim Collins','Dane Rhodes','J.D. Evermore','Rex Linn','Michael Bacall','Ned Bellamy','Danièle Watts','Jon Eyez','Omar J. Dorsey','Evan Parke','Craig Stark','Ritchie Montgomery','Jarrod Bunch','Edrick Browne','Jamal Duff','Todd Allen','Lewis Smith','John McConnell','Marsha Stephanie Blake','Kesha Bullard','Kimberley Drummond','Gary Grubbs','Jacquelyn Twodat Jackson','Kasey James','Elton LeBlanc','Belinda Owino','Samantha Smith','Fatimah Taliah','LaTeace Towns-Cuellar','Mark Ulano','Misty Upham','Glen Warner','Travis Wilkerson','Ryan Happy'],
screenplay:['Quentin Tarantino'],
production:['Stacey Sher','Reginald Hudlin','Pilar Savone'],
camera:['Robert Richardson'],
cut:['Fred Raskin'],
sound:['Wylie Stateman','Mark Ulano','Tony Lamberti','Michael Minkler'],
scenography:['J. Michael Riva','David F. Klassen','Suzan Wexler'],
masks:['Heba Thorisdottir','Camille Friend','Howard Berger','Paul Anthony Morris'],
costumes:['Sharen Davis']},
{title:'American History X',
titleCZ:'Kult hákového kříže',
year:1998,
runtime:119,
countries:['USA'],
genres:['Drama','Crime'],
director:['Tony Kaye'],
actors:['Edward Norton','Edward Furlong',"Beverly D'Angelo",'Jennifer Lien','Ethan Suplee','Fairuza Balk','Avery Brooks','Elliott Gould','Stacy Keach','William Russ','Guy Torry','Joe Cortese','Antonio David Lyons','Keram Malicki-Sánchez','Giuseppe Andrews','Christopher Masterson','Jordan Marder','Paul Le Mat','Allie Moss','Sam Sarpong','Jim Norton','Selwyn Ward','Anne Lambton','Sam Vlahos','Andre McCoy','Alex Sol','Danso Gordon'],
screenplay:['David McKenna'],
production:['John Morrissey'],
music:['Anne Dudley'],
camera:['Tony Kaye'],
cut:['Gerald B. Greenberg','Alan Heim'],
sound:['Frederick Howard','Yuri Reese','Joe Barnett','William Smith'],
scenography:['Jon Gary Steele'],
masks:['Jamie Kelman','Matthew W. Mungle'],
costumes:['Doug Hall']},
{title:'Heat',
titleCZ:'Nelítostný souboj',
year:1995,
runtime:170,
countries:['USA'],
genres:['Action','Drama','Crime','Thriller'],
director:['Michael Mann'],
actors:['Al Pacino','Robert De Niro','Val Kilmer','Tom Sizemore','Diane Venora','Amy Brenneman','Dennis Haysbert','Ashley Judd','Mykelti Williamson','Wes Studi','Ted Levine','William Fichtner','Natalie Portman','Tom Noonan','Kevin Gage','Hank Azaria','Susan Traylor','Kim Staunton','Jon Voight','Danny Trejo','Henry Rollins','Jerry Trimble','Martin Ferrero','Ricky Harris','Tone Loc','Begonya Plaza','Hazelle Goodman','Jeremy Piven','Xander Berkeley','Rick Avery','Max Daniels','Kenny Endoso','Steven Ford','Farrah Forke','Niki Harris','Patricia Healy','Paul Herman','Cindy Katz','Brian Libby','Dan Martin','Terry Miller','Thomas Rosales Jr.','Yvonne Zima','Bud Cort','Iva Franks Singer','Monica Lee Bellais','Darin Mangan','Andre McCoy','Manny Perry','Jimmy Star'],
screenplay:['Michael Mann'],
production:['Michael Mann','Art Linson'],
music:['Elliot Goldenthal'],
camera:['Dante Spinotti'],
cut:['Dov Hoenig','Pasquale Buba','William Goldenberg','Tom Rolf'],
sound:['Per Hallberg','Andy Nelson','Ron Bartlett','Anna Behlmer'],
scenography:['Neil Spisak','Anne H. Ahrens'],
masks:['John Caglione','Jr.','Ken Diaz'],
costumes:['Deborah L. Scott']},
{title:'Shutter Island',
titleCZ:'Prokletý ostrov',
year:2010,
runtime:138,
countries:['USA'],
genres:['Mystery','Thriller','Drama'],
director:['Martin Scorsese'],
actors:['Leonardo DiCaprio','Mark Ruffalo','Ben Kingsley','Max von Sydow','Michelle Williams','Emily Mortimer','Patricia Clarkson','Jackie Earle Haley','Ted Levine','John Carroll Lynch','Elias Koteas','Robin Bartlett','Christopher Denham','Nellie Sciutto','Joseph Sikora','Curtiss Cook','Raymond Anthony Thomas','Joseph McKenna','Ruby Jerins','Tom Kemp','Bates Wilder','Lars Gerhard','Matthew Cowles','Jill Larson','Ziad Akl','Dennis Lynch','John Porell','Drew Beasley','Joseph P. Reidy','Bree Elrod','Thomas B. Duffy','Ken Cheeseman','Steve Witting','Michael E. Chapman','Keith Fluker','Darryl Wooten','Michael Byron','Gary Galone','Gabriel Hansen','Cassity Atkins','Danny Carney','Jeffrey Corazzini','Rob W. Gray','Guy A. Grundy','Cody Harter','Alex Hoffman','Daniel Lowney','Evalena Marie','Dan Marshall','Robert Masiello','Americo Presciutti','Eric Rollins','Skip Shea','Billy Silvia'],
basedOn:['Dennis Lehane'],
screenplay:['Laeta Kalogridis'],
production:['Mike Medavoy','Arnold Messer','Bradley J. Fischer','Martin Scorsese'],
camera:['Robert Richardson'],
cut:['Thelma Schoonmaker'],
sound:['Eugene Gearty','Tom Fleischman','Petur Hliddal'],
scenography:['Dante Ferretti','Francesca Lo Schiavo'],
masks:['Manlio Rocchetti'],
costumes:['Sandy Powell']},
{title:'Braveheart',
titleCZ:'Statečné srdce',
year:1995,
runtime:170,
countries:['USA'],
genres:['Drama','History','War','Biographic'],
director:['Mel Gibson'],
actors:['Mel Gibson','Sophie Marceau','Patrick McGoohan','Catherine McCormack','Angus Macfadyen','Brendan Gleeson',"David O'Hara",'Ian Bannen','James Cosmo','Sean McGinley','Ralph Riach','Brian Cox','Peter Hanly','Barry McGovern','John Kavanagh','Alun Armstrong','Tommy Flanagan','Michael Byrne','Peter Mullan','Gerard McSorley','David Gant','Alex Norton',"Jer O'Lear",'Stephen Billington','Mhairi Calvey','Rupert Vansittart','William Scott-Masson','Jeanne Marine','Mal Whyte','James Robinson','Sean Lawlor','Gerda Stevenson','John Murtagh','Julie Austin','Malcolm Tierney','Bernard Horsfall','Richard Leaf','Dean Lopata','Martin Dunne','Daniel Coll','John Burns','Stephen J. Austin','Joe Savino','Liam Carney','Sandy Nelson','Bill Murdoch','Alan Tall'],
screenplay:['Randall Wallace'],
production:['Mel Gibson','Bruce Davey','Alan Ladd Jr.'],
music:['James Horner'],
camera:['John Toll'],
cut:['Steven Rosenblum'],
sound:['Per Hallberg','Andy Nelson','Anna Behlmer','Scott Millan'],
scenography:['Thomas E. Sanders'],
masks:['Amanda Knight',"Conor O'Sullivan"],
costumes:['Charles Knode']},
{title:'Good Will Hunting',
titleCZ:'Dobrý Will Hunting',
year:1997,
runtime:126,
countries:['USA'],
genres:['Drama','Psychology'],
director:['Gus Van Sant'],
actors:['Robin Williams','Matt Damon','Ben Affleck','Stellan Skarsgård','Minnie Driver','Casey Affleck','Cole Hauser','Alison Folland','Vik Sahay','Scott William Winters','Philip Williams','Kevin Rushton','George Plimpton','Richard Fitzpatrick','David Eisner','James Allodi','Paul Essiembre','Harmony Korine','Dale Resteghini','Jay Yoo','Bruce Hunter'],
screenplay:['Matt Damon','Ben Affleck'],
production:['Lawrence Bender'],
music:['Danny Elfman'],
camera:['Jean-Yves Escoffier'],
cut:['Pietro Scalia'],
sound:['Leslie Shatz','Tom E. Dahl'],
scenography:['Missy Stewart'],
masks:['Leslie Sebert'],
costumes:['Beatrix Aruna Pasztor']},
{title:'Million Dollar Baby',
titleCZ:'Million Dollar Baby',
year:2004,
runtime:133,
countries:['USA'],
genres:['Sport','Drama'],
director:['Clint Eastwood'],
actors:['Clint Eastwood','Hilary Swank','Morgan Freeman','Anthony Mackie','Jay Baruchel','Mike Colter','Lucia Rijker',"Brían F. O'Byrne",'Margo Martindale','Riki Lindhome','Michael Peña','Benito Martinez','Bruce MacVittie','David Powledge',"Joe D'Angerio",'Marcus Chait','Tom McCleister','Erica Grant','Naveen','Morgan Eastwood','Jamison Yang','Dean Familton','Louis Moret','V.J. Foster','Jon D. Schorle II','Marty Sammon','Steven M. Porter','Ray Corona','Ming Lo','Miguel Pérez','Jim Cantafio','Ted Grossman','Ned Eisenberg','Marco Rodríguez','Roy Nugent','Don Familton','Mark Thomason','Brian T. Finney','Spice Williams-Crosby','Kim Strauss','Rob Maron','Kirsten Berman','Susan Krebs','Sunshine Chantal Parkman','Kim Dannenberg','Eddie Bates','Michael Bentt','Jude Ciccolella','Kimberly Estrada','Michael Keyes','Jason Williams'],
basedOn:['F.X. Toole'],
screenplay:['Paul Haggis'],
production:['Clint Eastwood','Albert S. Ruddy','Tom Rosenberg','Paul Haggis'],
music:['Clint Eastwood'],
camera:['Tom Stern'],
cut:['Joel Cox'],
sound:['Alan Robert Murray','Bub Asman','Michael Semanick','Christopher Boyes','Tom Johnson'],
scenography:['Henry Bumstead','Richard B. Goddard'],
masks:['Tania McComas'],
costumes:['Deborah Hopper']},
{title:'Life Is Beautiful',
titleCZ:'Život je krásný',
year:1997,
runtime:116,
countries:['Italy'],
genres:['Comedy','Romance','Drama','War'],
director:['Roberto Benigni'],
actors:['Roberto Benigni','Nicoletta Braschi','Giorgio Cantarini','Giustino Durano','Marisa Paredes','Horst Buchholz','Verena Buratti','Gina Rovere','Andrea Tidona','Omero Antonutti','Richard Sammel','Lidia Alfonsi','Hannes Hellmann','Pietro De Silva','Francesco Guzzo','Giuliana Lojodice','Dirk K. van den Berg','Claudio Alfonsi','Sergio Bini Bustric'],
screenplay:['Roberto Benigni','Vincenzo Cerami'],
production:['Gianluigi Braschi','Elda Ferri'],
music:['Nicola Piovani'],
camera:['Tonino Delli Colli'],
sound:['Tom Fleischman','Alberto Doni','Claudio Chiossi'],
masks:['Martina Cossu']},
{title:'Psycho',
titleCZ:'Psycho',
year:1960,
runtime:109,
countries:['USA'],
genres:['Horror','Mystery','Thriller'],
director:['Alfred Hitchcock'],
actors:['Anthony Perkins','Vera Miles','John Gavin','Janet Leigh','Martin Balsam','John McIntire','Simon Oakland','Frank Albertson','Patricia Hitchcock','Vaughn Taylor','Lurene Tuttle','John Anderson','Mort Mills','Alfred Hitchcock','Jeanette Nolan','Virginia Gregg','Ted Knight','Sam Flint','George Eldredge','Francis De Sales','Hans Moebus','Don Ross','Pat McCaffrie'],
basedOn:['Robert Bloch'],
screenplay:['Joseph Stefano'],
production:['Alfred Hitchcock'],
music:['Bernard Herrmann'],
camera:['John L. Russell'],
cut:['George Tomasini'],
sound:['Waldon O. Watson'],
scenography:['Robert Clatworthy','George Milo'],
masks:['Florence Bush'],
costumes:['Rita Riggs']},
{title:'The Prestige',
titleCZ:'Dokonalý trik',
year:2006,
runtime:130,
countries:['USA','UK'],
genres:['Mystery','Thriller','Drama','Sci-Fi'],
director:['Christopher Nolan'],
actors:['Christian Bale','Hugh Jackman','Michael Caine','Piper Perabo','Rebecca Hall','Scarlett Johansson','David Bowie','Andy Serkis','Daniel Davis','Christopher Neame','Mark Ryan','Roger Rees','Jamie Harris','Ricky Jay','Ezra Buzzington','James Otis','Chris Cleveland','William Morgan Sheppard','Jim Piddock','Ron Perkins','Kevin Will','Edward Hibbert','John B. Crye','Jodi Bianca Wise','Russ Fega','Enn Reitel','Julia Sanford','Chao Li Chi'],
basedOn:['Christopher Priest'],
screenplay:['Jonathan Nolan','Christopher Nolan'],
production:['Aaron Ryder','Christopher Nolan','Emma Thomas'],
music:['David Julyan'],
camera:['Wally Pfister'],
cut:['Lee Smith'],
sound:['Richard King','Gary Rizzo','Lora Hirschberg'],
scenography:['Nathan Crowley','Julie Ochipinti'],
masks:['Peter Robb-King','Kenny Myers','Heba Thorisdottir','Kimberley Spiteri','Ginger Damon'],
costumes:['Joan Bergin','Donna Marcione Pollack']},
{title:'Platoon',
titleCZ:'Četa',
year:1986,
runtime:120,
countries:['UK','USA'],
genres:['Drama','War'],
director:['Oliver Stone'],
actors:['Charlie Sheen','Tom Berenger','Willem Dafoe','Forest Whitaker','Francesco Quinn','John C. McGinley','Richard Edson','Kevin Dillon','Reggie Johnson','Keith David','Johnny Depp','David Neidorf','Mark Moses','Chris Pedersen','Tony Todd','Corkey Ford','Ivan Kane','Paul Sanchez','Corey Glover','Bob Orwig','James Terry McIlvain','Dale Dye','Chris Castillejo','Nick Nicholson','Warren McLean','H. Gordon Boos','Brad Cassini','Eric Hahn','Oliver Stone','Henry Strzalkowski'],
screenplay:['Oliver Stone'],
production:['Arnold Kopelson'],
music:['Georges Delerue'],
camera:['Robert Richardson'],
cut:['Claire Simpson'],
sound:['John Wilkinson'],
scenography:['Bruno Rubeo'],
masks:['Gordon J. Smith']},
{title:'The Twelve Tasks of Asterix',
titleCZ:'12 úkolů pro Asterixe',
year:1976,
runtime:82,
countries:['France'],
genres:['Animation','Adventure','Comedy','Family'],
director:['René Goscinny','Albert Uderzo','Henri Gruel'],
actors:['Roger Carel','Pierre Tornade','Henri Labussière','Henri Poirier','Pierre Tchernia','Henri Virlogeux','Odette Laure','Alice Sapritch','Nicole Vervil','Oliver Postgate','Pascal Mazzotti','Roger Lumont','Bernard Lavalette','Gérard Hernandez','Nicole Jonesco','Jacques Morel','Bill Oddie','Georges Atlas','Gisèle Grimm','Claude Bertrand','Caroline Clerc','Michael Kilgarriff'],
basedOn:['René Goscinny','Albert Uderzo'],
screenplay:['René Goscinny','Albert Uderzo','Pierre Tchernia'],
music:['Gérard Calvi'],
cut:['Isabel García de Herreros']},
{title:'Star Wars: Episode IV - A New Hope',
titleCZ:'Star Wars: Epizoda IV - Nová naděje',
year:1977,
runtime:121,
countries:['USA'],
genres:['Sci-Fi','Adventure','Fantasy','Action'],
director:['George Lucas'],
actors:['Mark Hamill','Harrison Ford','Carrie Fisher','Peter Cushing','Alec Guinness','Anthony Daniels','Peter Mayhew','David Prowse','James Earl Jones','Garrick Hagon','Joe Johnston','Linda Jones','Phil Tippett','Denis Lawson','William Hootkins','Kenny Baker','Shane Rimmer','Phil Brown','Angus MacInnes','Eddie Byrne','Don Henderson','Leslie Schofield','Peter Diamond','George Roubicek','Drewe Henley','Fred Wood','Harry Fielder','Alf Mangan','Jack Klaff','Graham Ashley','Malcolm Tierney','Rick McCallum','Jeremy Sinden','Morgan Upton','Richard LeParmentier','Scott Beach','Tiffany Hillkurtz',"Steve 'Spaz' Williams",'Jack Purvis','Doug Beswick','Tim Condren'],
screenplay:['George Lucas'],
production:['Gary Kurtz'],
music:['John Williams'],
camera:['Gilbert Taylor'],
cut:['Richard Chew','Paul Hirsch','Marcia Lucas','George Lucas'],
sound:['Gary Summers','Michael Minkler','Bob Minkler'],
scenography:['John Barry','Roger Christian'],
masks:['Stuart Freeborn','Rick Baker'],
costumes:['John Mollo']},
{title:'The Shining',
titleCZ:'Osvícení',
year:1980,
runtime:119,
countries:['UK','USA'],
genres:['Horror','Drama','Thriller'],
director:['Stanley Kubrick'],
actors:['Jack Nicholson','Shelley Duvall','Danny Lloyd','Scatman Crothers','Barry Nelson','Philip Stone','Joe Turkel','Anne Jackson','Tony Burton','Lia Beldam','Vivian Kubrick','Billie Gibson','Lisa Burns','Louise Burns','Barry Dennen','David Baxt','Manning Redwood','Bunny Seaman','George Holdcroft','Peter McNamara'],
basedOn:['Stephen King'],
screenplay:['Stanley Kubrick','Diane Johnson'],
production:['Stanley Kubrick'],
music:['Wendy Carlos','Rachel Elkind'],
camera:['John Alcott'],
cut:['Ray Lovejoy'],
sound:['Richard Daniel','Ivan Sharrock'],
scenography:['Roy Walker'],
masks:['Barbara Daly','Tom Smith'],
costumes:['Milena Canonero']},
{title:'Lethal Weapon',
titleCZ:'Smrtonosná zbraň',
year:1987,
runtime:110,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Richard Donner'],
actors:['Mel Gibson','Danny Glover','Gary Busey','Mitchell Ryan','Tom Atkins','Darlene Love','Traci Wolfe','Damon Hines','Ebonie Smith','Jackie Swanson',"Ed O'Ross",'Sven-Ole Thorsen','Mic Rodgers','Joan Severance','Grand L. Bush','Mary Ellen Trainor','Don Gordon','Al Leong','Blackie Dammett','Steve Kahan','Paul Tuerpe','Jack Thibeau','Jimmie F. Skaggs','Selma Archerd','Lenny Juliano','Henry Brown','Jason Ronard','Lycia Naff','Michael Shaner','Conrad Hurtt','Patrick Cameron','Bob Harks'],
screenplay:['Shane Black'],
production:['Richard Donner','Joel Silver'],
music:['Michael Kamen','Eric Clapton'],
camera:['Stephen Goldblatt'],
cut:['Stuart Baird'],
sound:['Alan Robert Murray','Rick Alexander'],
scenography:['J. Michael Riva','Marvin March'],
masks:['Scott H. Eddo'],
costumes:['Mary Malin']},
{title:'Some Like It Hot',
titleCZ:'Někdo to rád horké',
year:1959,
runtime:120,
countries:['USA'],
genres:['Comedy','Crime','Romance','Music'],
director:['Billy Wilder'],
actors:['Marilyn Monroe','Tony Curtis','Jack Lemmon','George Raft',"Pat O'Brien",'Joe E. Brown','Nehemiah Persoff','Joan Shawlee','Billy Gray','George E. Stone','Dave Barry','Mike Mazurki','Harry Wilson','Beverly Wills','Barbara Drew','Edward G. Robinson Jr.','Sam Bagley','Steve Carruthers',"Noble 'Kid' Chissell",'Marian Collier','Paul Cristo','Jimmy Dime','Franklyn Farnum','Duke Fishman','George Ford','Paul Frees','Joe Gray','Stuart Hall','Sam Harris','Shep Houghton','John Indrisano','Tom Kennedy','Carl M. Leviness','King Lockwood','Hank Mann','Tiger Joe Marsh','Jack Mather','Frank McLure','Laurie Mitchell',"William H. O'Brien",'Jack Perry','Danny Richards Jr.','Edwin Rochelle','John Roy','Cosmo Sardo','Scott Seaton','Fred Sherman','Carl Sklover','Bert Stevens','Arthur Tovey','Sid Troy','Ralph Volkie','Tito Vuolo','Sandra Warner','Billy Wayne','Grace Lee Whitney'],
screenplay:['Billy Wilder','I.A.L. Diamond'],
production:['Billy Wilder'],
music:['Adolph Deutsch'],
camera:['Charles Lang'],
cut:['Arthur P. Schmidt'],
sound:['Fred Lau'],
scenography:['Ted Haworth','Edward G. Boyle'],
masks:['Emile LaVigne'],
costumes:['Bert Henrikson']},
{title:'Witchhammer',
titleCZ:'Kladivo na čarodějnice',
year:1969,
runtime:103,
countries:['Czechoslovakia'],
genres:['Drama','History','Horror'],
director:['Otakar Vávra'],
actors:['Elo Romančík','Vladimír Šmeral','Soňa Valentová','Josef Kemr','Lola Skrbková','Jiřina Štěpničková','Marie Nademlejnská','Miriam Kantorková','Lubor Tokoš','Blažena Holišová','Jaroslava Obermaierová','Jiří Holý','Rudolf Krátký','Čestmír Řanda st.','Blanka Waleská','Martin Růžek','Josef Bláha','Eduard Cupák','Ilja Prachař','Gustav Opočenský','Václav Lohniský','Jiří Hurta','Štěpán Zemánek','František Holar','Zdeněk Kryzánek','Miloš Willig','Josef Mixa','Josef Elsner','Karel Bělohradský','Karel Čížek','Zdeněk Dohnal','Eduard Pavlíček','Jan Pohan','Marie Cingrošová','Ladislav Gzela','Miloš Hájek','Zdeněk Hodr','Zbyněk Jirmář','Jiří Lír','Vladimír Navrátil','Jindřiška Gabriela Preissová','Jan Prokeš','Boleslava Svobodová','Vladimír Švabík','Alois Vachek','Martin Kapoun','I. Horká','E. Lázničková','J. Odehnalová','M. Svoboda','J. Umlauf','Zdeněk Derka','Vladimír Šebesta','I. Bobková','J. Janovcová','O. Mazůrek','M. Ždánská','Otakar Rademacher','J. Bartoš','L. Kot','Yvonne Kodoňová','Zuzana Rumlová','L. Divišová','E. Maragnová','S. Procházková','R. Propperová','L. Šindlerová','Gisela Mattishent','Zbyněk Bruthans'],
basedOn:['Václav Kaplický'],
screenplay:['Otakar Vávra','Ester Krumbachová'],
music:['Jiří Srnka'],
camera:['Josef Illík'],
cut:['Antonín Zelenka'],
sound:['František Strangmüller'],
scenography:['Karel Škvor'],
masks:['Jiří Šimon'],
costumes:['Jarmila Konečná']},
{title:'The Hunt',
titleCZ:'Hon',
year:2012,
runtime:115,
countries:['Denmark','Sweden'],
genres:['Drama'],
director:['Thomas Vinterberg'],
actors:['Mads Mikkelsen','Thomas Bo Larsen','Annika Wedderkopp','Lasse Fogelstrøm','Susse Wold','Anne Louise Hassing','Lars Ranthe','Alexandra Rapaport','Sebastian Bull Sarning','Steen Ordell Guldbrandsen','Daniel Engstrup','Troels Thorsen','Søren Rønholt','Hana Shuan','Jytte Kvinesdal','Josefine Gråbøl','Bjarne Henriksen','Nicolai Dahl Hamilton','Øyvind Hagen-Traberg','Allan Wibor Christensen','Rikke Bergmann','Rasmus Lind Rubin','Frank Rubæk','Jakob Højlev Jørgensen','Nina Christrup','Karina Fogh Holmkjær','Thomas Ravn','Martin Boserup','Ole Dupont','Thomas Vinterberg','Katrine Brygmann Salomon'],
screenplay:['Thomas Vinterberg','Tobias Lindholm'],
production:['Sisse Graum Jørgensen','Morten Kaufmann'],
music:['Nikolaj Egelund'],
camera:['Charlotte Bruus Christensen'],
cut:['Anne Østerud','Janus Billeskov Jansen'],
sound:['Kristian Eidnes Andersen','Thomas Jæger'],
scenography:['Torben Stig Nielsen'],
masks:['Bjørg Serup'],
costumes:['Manon Rasmussen']},
{title:'Papillon',
titleCZ:'Motýlek',
year:1973,
runtime:151,
countries:['USA','France'],
genres:['Drama','Crime','Biographic'],
director:['Franklin J. Schaffner'],
actors:['Steve McQueen','Dustin Hoffman','Victor Jory','Don Gordon','Anthony Zerbe','Robert Deman','Woodrow Parfrey','Bill Mumy','George Coulouris','Ratna Assan','William Smithers','Val Avery','Gregory Sierra','Vic Tayback','Mills Watson','Ron Soble','Barbara Morrison','Don Hanmer','E.J. André','Richard Angarola','Jack Denbo','Len Lesser','John Quade','Fred Sadoff','Allen Jaffe','Liam Dunn','Peter Brocco','Richard Farnsworth','Billy M. Greene','Fred Lerner','Dalton Trumbo'],
basedOn:['Henri Charrière'],
screenplay:['Dalton Trumbo','Lorenzo Semple Jr.'],
production:['Robert Dorfmann','Franklin J. Schaffner'],
music:['Jerry Goldsmith'],
camera:['Fred J. Koenekamp'],
cut:['Robert Swink'],
scenography:['Anthony Masters'],
masks:['John Truwe'],
costumes:['Anthony Powell']},
{title:'Roman Holiday',
titleCZ:'Prázdniny v Římě',
year:1953,
runtime:118,
countries:['USA'],
genres:['Comedy','Romance'],
director:['William Wyler'],
actors:['Gregory Peck','Audrey Hepburn','Eddie Albert','Hartley Power','Harcourt Williams','Margaret Rawlings','Tullio Carminati','Paolo Carlini','Claudio Ermelli','Paola Borboni','Alfredo Rizzo','Laura Solari','Gorella Gori','Armando Annuale','Maurizio Arena','Silvio Bagolini','Gildo Bocci','Franco Corsaro','Vittoria Crispo','Piero Pastore','Mimmo Poli','Gianna Segale','Amedeo Trilli','Marco Tulli','Joop van Hulzen','Tania Weber','Giuliano Raffaelli'],
screenplay:['Dalton Trumbo','Ian McLellan Hunter','John Dighton'],
production:['William Wyler'],
music:['Georges Auric'],
camera:['Henri Alekan','Franz Planer'],
cut:['Robert Swink'],
sound:['Joseph de Bretagne'],
scenography:['Hal Pereira','Walter H. Tyler','Luciano Sacripanti'],
masks:['Wally Westmore'],
costumes:['Edith Head']},
{title:'Klaus',
titleCZ:'Klaus',
year:2019,
runtime:96,
countries:['Spain'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Sergio Pablos'],
actors:['Rashida Jones','Joan Cusack','J.K. Simmons','Jason Schwartzman','Mila Brener','Tucker Meek','Pierce Pope','Will Sasso','Norm MacDonald','Teddy Blum','Alyson Reed','Dee Dee Rescher','Helen Slayton-Hughes','Sam McMurray','Brian T. Finney','Cathy Cavadini','Kendall Joy Hall','Hailey Hermida','Lucian Perez','Bill Chott','Sydney Brower','Maximus Riegel','Brad Abrell'],
basedOn:['Sergio Pablos'],
screenplay:['Sergio Pablos','Jim Mahoney','Zach Lewis'],
production:['Gustavo Ferrada','Mercedes Gamero','Mikel Lejarza','Sergio Pablos','Marisa Roman'],
music:['Alfonso González Aguilar'],
scenography:['Marcin Jakubowski']},
{title:'Shrek',
titleCZ:'Shrek',
year:2001,
runtime:90,
countries:['USA'],
genres:['Animation','Adventure','Family','Comedy'],
director:['Vicky Jenson','Andrew Adamson'],
actors:['Mike Myers','Eddie Murphy','Cameron Diaz','John Lithgow','Vincent Cassel','Jim Cummings','Simon J. Smith','Conrad Vernon','Ian Abercrombie','Andrew Adamson','Chris Miller','Kathleen Freeman','Christopher Knights','Cody Cameron','Jean-Paul Vignon','Charles Dennis','Guillaume Aretos','Patrick Pinney','Richard Steven Horvitz','Hope Levy','Bobby Block','Val Bettin'],
basedOn:['William Steig'],
screenplay:['Ted Elliott','Terry Rossio','Joe Stillman','Roger S.H. Schulman'],
production:['Aron Warner','Jeffrey Katzenberg','John H. Williams'],
music:['John Powell','Harry Gregson-Williams'],
cut:['Sim Evan-Jones'],
sound:['Wylie Stateman','Andy Nelson','Anna Behlmer'],
scenography:['Guillaume Aretos','Sean P. Mullen'],
costumes:['Isis Mussenden']},
{title:'Seclusion Near a Forest',
titleCZ:'Pražáci dědy Komárka',
year:1976,
runtime:93,
countries:['Czechoslovakia'],
genres:['Comedy','Family','Drama'],
director:['Jiří Menzel'],
actors:['Josef Kemr','Zdeněk Svěrák','Daniela Kolářová','Marie Hradilková','Martin Hradilek','Jan Tříska','Ladislav Smoljak','Naďa Urbánková','Zdeněk Blažek','Alois Liškutín','František Řehák','Václav Trégl','Vlasta Jelínková','Oldřich Vlach','František Kovářík','Míla Myslíková','Eugen Jegorov','Miloslav Štibich','Petr Brukner','Jaroslav Vozáb','Karel Fiala','Karel Hovorka st.','Rudolf Kalina','Miloš Šustr','Jan Waldmann','Alois Vachek','Karla Chadimová','Vlastimil Brodský','Miloň Čepelka','Jaroslav Weigel'],
screenplay:['Zdeněk Svěrák','Ladislav Smoljak'],
music:['Jiří Šust'],
camera:['Jaromír Šofr'],
cut:['Jiřina Lukešová'],
sound:['Adam Kajzar'],
scenography:['Zbyněk Hloch'],
masks:['Miloslav Jandera'],
costumes:['Zdena Štěpánová']},
{title:'Requiem for a Dream',
titleCZ:'Requiem za sen',
year:2000,
runtime:102,
countries:['USA'],
genres:['Drama'],
director:['Darren Aronofsky'],
actors:['Ellen Burstyn','Jared Leto','Jennifer Connelly','Marlon Wayans','Christopher McDonald','Louise Lasser','Marcia Jean Kurtz','Suzanne Shepherd','Mark Margolis',"Jack O'Connell",'Ajay Naidu','Sean Gullette','Peter Maloney','Denise Dowse','Scott Franklin','James Chinlund','Olga Merediz','Ben Shenkman','Keith David','Dylan Baker','Bill Buell','Jimmie Ray Weeks','Gregg Bello','Henry Stram','Ami Goodheart','Nina Zavarin','Hubert Selby Jr.','Lianna Pai','Darren Aronofsky','Michael Kaycheck'],
basedOn:['Hubert Selby Jr.'],
screenplay:['Hubert Selby Jr.','Darren Aronofsky'],
production:['Eric Watson','Palmer West'],
music:['Clint Mansell'],
camera:['Matthew Libatique'],
cut:['Jay Rabinowitz'],
sound:['Tom Johnson'],
scenography:['James Chinlund'],
masks:['Judy Chin','Vincent J. Guastini'],
costumes:['Laura Jean Shannon']},
{title:'Warrior',
titleCZ:'Warrior',
year:2011,
runtime:140,
countries:['USA'],
genres:['Sport','Drama'],
director:["Gavin O'Connor"],
actors:['Tom Hardy','Joel Edgerton','Nick Nolte','Jennifer Morrison','Noah Emmerich','Kevin Dunn','Denzel Whitaker','Carlos Miranda','Frank Grillo',"Gavin O'Connor",'Jeff Hochendoner','Maximiliano Hernández','Vanessa Martinez','Kurt Angle','Jake McLaughlin','Brenna Roth','Anthony Tambakis','Jason Baker','Bryan Callen','Jace Jeanes','Lloyd Booker','Kevin Christy','Manuel Espinosa','Marquis Wood','Laura Chinn','Fernando Chien','Chad Bruns','Rick Montgomery Jr.'],
screenplay:["Gavin O'Connor",'Anthony Tambakis','Cliff Dorfman'],
production:["Greg O'Connor"],
music:['Mark Isham'],
camera:['Masanobu Takayanagi'],
cut:['Matt Chessé','John Gilroy','Sean Albertson','Aaron Marshall'],
sound:['Gary Summers','Christian P. Minkler'],
scenography:['Dan Leigh','Ron von Blomberg'],
costumes:['Abigail Murray']},
{title:'The Usual Suspects',
titleCZ:'Obvyklí podezřelí',
year:1995,
runtime:106,
countries:['USA','Germany'],
genres:['Drama','Crime','Mystery','Thriller'],
director:['Bryan Singer'],
actors:['Stephen Baldwin','Gabriel Byrne','Benicio Del Toro','Kevin Pollak','Kevin Spacey','Chazz Palminteri','Pete Postlethwaite','Suzy Amis','Giancarlo Esposito','Dan Hedaya','Paul Bartel','Carl Bressler','Phillipe Simon','Jack Shearer','Christine Estabrook','Clark Gregg','Morgan Hunter','Ken Daly','Michelle Clunie','Louis Lombardi','Frank Medrano','Ron Gilbert',"Vito D'Ambrosio",'Gene Lythgow','Castulo Guerra','Bert Williams','Peter Greene','Christopher McQuarrie'],
screenplay:['Christopher McQuarrie'],
production:['Bryan Singer','Michael McDonnell'],
music:['John Ottman'],
camera:['Newton Thomas Sigel'],
cut:['John Ottman'],
sound:['Greg P. Russell','Chuck Michael'],
scenography:['Howard Cummings','Sara Andrews'],
masks:['David P. Barton'],
costumes:['Louise Mingenbach']},
{title:'Goodfellas',
titleCZ:'Mafiáni',
year:1990,
runtime:146,
countries:['USA'],
genres:['Drama','Crime','Biographic'],
director:['Martin Scorsese'],
actors:['Robert De Niro','Ray Liotta','Joe Pesci','Lorraine Bracco','Paul Sorvino','Mike Starr','Frank Vincent','Chuck Low','Catherine Scorsese','Charles Scorsese','Debi Mazar','Christopher Serrone','Elaine Kagan','Beau Starr','Kevin Corrigan','Michael Imperioli','Tony Sirico',"Joe D'Onofrio",'Frank Adonis','Illeana Douglas','Samuel L. Jackson','Edward McDonald','Vincent Pastore','James Quattrochi','Vincent Gallo','Peter Onorati','Tobin Bell','Isiah Whitlock Jr.','Anthony Caso','Nick Vallelonga','Paul Herman','Steve Forleo','Clem Caserta','Melissa Prophet','Johnny Williams','Marianne Leone','Elizabeth Whitcraft','Tony Darrow','Gene Canfield','Joseph Bono','Billy L. Sullivan','Frank Sivero','Gina Mastrogiacomo','Suzanne Shepherd','Frank Pellegrino','Frank Cassini','Frank DiLeo','Margo Winkler','Welker White','Daniel P. Conte','Ronald Maccone','Philip Suriano','Katherine Wallach','Bo Dietl','Stella Keitel','Dominique DeVito','Tony Ellis','Berlinda Tolbert','Michael Citriniti','Lisa Dapolito','Peter Hanlon','Henny Youngman','Angela Pietropinto','Mark Evan Jacobs','Tony Lip','John Di Benedetto','Edward D. Murphy','Nancy Cassaro','Ken Waters','Matthew T. Gitkin','Margaret Smith'],
basedOn:['Nicholas Pileggi'],
screenplay:['Nicholas Pileggi','Martin Scorsese'],
production:['Irwin Winkler'],
camera:['Michael Ballhaus'],
cut:['Thelma Schoonmaker','James Y. Kwei'],
sound:['Tom Fleischman','Skip Lievsay'],
scenography:['Kristi Zea'],
masks:['Carl Fullerton','John Blake'],
costumes:['Richard Bruno']},
{title:'He Stood at the Till',
titleCZ:'U pokladny stál...',
year:1939,
runtime:99,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Karel Lamač'],
actors:['Vlasta Burian','Jaroslav Marvan','Ladislav Hemmer','Adina Mandlová','Marie Blažková','Čeněk Šlégl','Anna Gabrielová','Antonín Streit','Karel Postranecký','Václav Trégl','Emanuel Kovařík','Antonín Soukup','Marta Školudová','Václav Mlčkovský','Václav Menger','Betty Kysilková','František Lašek','Karel Veverka','František Filipovský','Karel Němec','Jaroslav Tryzna','Ferdinand Jarkovský','Marie Ježková','Rudolf Antonín Dvorský','Růžena Kurelová'],
screenplay:['Václav Wasserman','Jiří Verner'],
music:['Josef Dobeš'],
camera:['Jan Stallich'],
cut:['Jan Kohout'],
sound:['Josef Zora']},
{title:'Once Upon a Time in America',
titleCZ:'Tenkrát v Americe',
year:1984,
runtime:229,
countries:['USA','Italy'],
genres:['Crime','Drama','Thriller'],
director:['Sergio Leone'],
actors:['Robert De Niro','James Woods','Elizabeth McGovern','Joe Pesci','Burt Young','Tuesday Weld','Treat Williams','Danny Aiello','Richard Bright','James Hayden','William Forsythe','Darlanne Fluegel','Larry Rapp','Richard Foronjy','Robert Harper','Dutch Miller','Gerard Murphy','James Russo','Scott Schutzman Tiler','Rusty Jacobs','Brian Bloom','Adrian Curran','Jennifer Connelly','Chuck Low','Scott Coffey','Olga Karlatos','Mario Brega','Paul Herman','Clem Caserta','Salvatore Billa','Cliff Cudney','Noah Moazezi','Mike Monetti','Frankie Caserta','Gerritt Debeer','Estelle Harris','Marcia Jean Kurtz','Arnon Milchan','Jerry Strivelli','Baxter Harris','Louise Fletcher','Joey Faye','Zora Ulla Keslerová','Frank Gio','Tandy Cronyn','Amy Ryder','Julie Cohen'],
basedOn:['Ernesto Gastaldi'],
screenplay:['Leonardo Benvenuti','Piero De Bernardi','Enrico Medioli','Franco Arcalli','Franco Ferrini','Sergio Leone'],
production:['Arnon Milchan'],
music:['Ennio Morricone'],
camera:['Tonino Delli Colli'],
cut:['Nino Baragli'],
sound:['Fausto Ancillai'],
scenography:['James T. Singelis','Osvaldo Desideri','Gretchen Rau'],
masks:['Manlio Rocchetti','Gino Zamprioli'],
costumes:['Gabriella Pescucci']},
{title:'Star Wars: Episode III - Revenge of the Sith',
titleCZ:'Star Wars: Epizoda III - Pomsta Sithů',
year:2005,
runtime:140,
countries:['USA'],
genres:['Sci-Fi','Fantasy','Adventure','Action'],
director:['George Lucas'],
actors:['Ewan McGregor','Natalie Portman','Hayden Christensen','Ian McDiarmid','Samuel L. Jackson','Jimmy Smits','Frank Oz','Anthony Daniels','Christopher Lee','Keisha Castle-Hughes',"Jay Laga'aia",'Bruce Spence','Temuera Morrison','Ahmed Best','Joel Edgerton','Claudia Karvan','Rena Owen','Peter Mayhew',"Genevieve O'Reilly",'Matthew Wood','Bai Ling','Caroline de Souza Correa','James Earl Jones','George Lucas','Oliver Ford Davies','Jeremy Bulloch','David Bowers','Wayne Pygram','Goran D. Kleut','Christopher Kirby','Silas Carson','Kenny Baker','Rohan Nichol','Bonnie Piesse','Roger Guyett','David Stiff','Trisha Noble','Masa Yamaguchi','Kee Chan','Aaliyah Williams','David Acord','Rob Coleman','Katie Lucas','John Knoll','Matt Sloan','Jimmy Star'],
screenplay:['George Lucas'],
production:['Rick McCallum'],
music:['John Williams'],
camera:['David Tattersall'],
cut:['Roger Barton','Ben Burtt'],
sound:['Andy Nelson','Christopher Scarabosio'],
scenography:['Gavin Bocquet','Richard Roberts','Phil Harvey'],
masks:['Vivienne MacGillicuddy','Nikki Gooley','Shane Thomas'],
costumes:['Trisha Biggar']},
{title:'The Con',
titleCZ:'Podfuck',
year:1998,
runtime:92,
countries:['USA'],
genres:['Comedy','Crime','Drama','Romance'],
director:['Steven Schachter'],
actors:['William H. Macy','Rebecca De Mornay','Mike Nussbaum','Frances Sternhagen','Don Harvey','Angela Paton','Kathy Lamkin','Robert Prentiss','Cynthia Dorn','Gina Mastrogiacomo','Blue Deckert','Mary B. McCann','Tony Frank','Lee Stringer','Jimmy Ray Pickens','Melanie Haynes'],
screenplay:['Steven Schachter','William H. Macy'],
production:['Bob Roe'],
music:['Peter Manning Robinson'],
camera:['Peter Stein'],
cut:['Cari Coughlin'],
scenography:['Alfred Sole'],
masks:['Desne J. Holland']},
{title:'Journey to the Beginning of Time',
titleCZ:'Cesta do pravěku',
year:1955,
runtime:93,
countries:['Czechoslovakia'],
genres:['Adventure','Fantasy','Family','Sci-Fi'],
director:['Karel Zeman'],
actors:['Vladimír Bejval','Petr Herrmann','Josef Lukáš','Zdeněk Husták','Bedřich Šetena'],
screenplay:['Karel Zeman','J. A. Novotný'],
music:['E. F. Burian'],
camera:['Václav Pazderník','Antonín Horák'],
cut:['Zdeněk Stehlík'],
sound:['František Strangmüller']},
{title:'Bohemian Rhapsody',
titleCZ:'Bohemian Rhapsody',
year:2018,
runtime:134,
countries:['UK','USA'],
genres:['Biographic','Drama','Music'],
director:['Bryan Singer','Dexter Fletcher'],
actors:['Rami Malek','Lucy Boynton','Gwilym Lee','Ben Hardy','Joseph Mazzello','Aidan Gillen','Allen Leech','Tom Hollander','Mike Myers','Aaron McCusker','Meneka Das','Ace Bhatti','Priya Blackburn','Dermot Murphy','Dickie Beau','Tim Plester','Jack Roth','Max Bennett','Neil Fox-Roberts','Kieran Hardcastle','Bruce Mackinnon','Michelle Duncan','Matt Greenwood','Jess Radomska','Philip Andrew','John Ottman','Adam Lambert','Freddie Mercury','Morten Bekkenes','Jason Lines'],
screenplay:['Anthony McCarten'],
production:['Graham King','Jim Beach'],
camera:['Newton Thomas Sigel'],
cut:['John Ottman'],
sound:['Paul Massey','Tim Cavagin','John Warhurst'],
scenography:['Aaron Haye','Anna Lynch-Robinson'],
masks:['Julio Parodi','Mark Coulier','Rebecca Cole','Lucy Sibbick','David Malinowski','Heather Manson'],
costumes:['Julian Day']},
{title:'Coco',
titleCZ:'Coco',
year:2017,
runtime:105,
countries:['USA'],
genres:['Animation','Comedy','Family','Fantasy','Adventure','Music'],
director:['Lee Unkrich','Adrian Molina'],
actors:['Anthony Gonzalez','Gael García Bernal','Benjamin Bratt','Alanna Ubach','Edward James Olmos','Gabriel Iglesias','Jaime Camil','Cheech Marin','Alfonso Arau','Lombardo Boyar','Sofía Espinosa','Renee Victor','Selene Luna','Carla Medina','Blanca Araceli'],
screenplay:['Adrian Molina','Matthew Aldrich'],
production:['Darla K. Anderson'],
music:['Michael Giacchino'],
camera:['Matt Aspbury'],
cut:['Steve Bloom','Lee Unkrich'],
sound:['Michael Semanick','J.R. Grubbs','Christopher Boyes'],
scenography:['Harley Jessup']},
{title:'American Beauty',
titleCZ:'Americká krása',
year:1999,
runtime:122,
countries:['USA'],
genres:['Drama'],
director:['Sam Mendes'],
actors:['Kevin Spacey','Annette Bening','Thora Birch','Wes Bentley','Mena Suvari','Peter Gallagher','Allison Janney','Chris Cooper','Scott Bakula','Sam Robards','Barry Del Sherman','Ara Celi','John Cho','Fort Atkinson','Sue Casey','Kent Faulcon','Brenda Wehle','Alison Faulk','Reshma Gajjar','Chelsea Hertford','Amber Smith','Joel McCrary','Marissa Jaret Winokur','Dennis Anderson','Matthew Kimbrough','Bruce Cohen'],
screenplay:['Alan Ball'],
production:['Dan Jinks','Bruce Cohen'],
music:['Thomas Newman'],
camera:['Conrad L. Hall'],
cut:['Tariq Anwar','Christopher Greenbury'],
sound:['Bob Beemer','Noyan Coşarer','Scott Millan'],
scenography:['Naomi Shohan'],
masks:['Tania McComas','Patricia Dehaney'],
costumes:['Julie Weiss']},
{title:'The Bourne Ultimatum',
titleCZ:'Bourneovo ultimátum',
year:2007,
runtime:115,
countries:['USA','Germany','France','Spain'],
genres:['Action','Thriller'],
director:['Paul Greengrass'],
actors:['Matt Damon','Julia Stiles','David Strathairn','Scott Glenn','Paddy Considine','Édgar Ramírez','Albert Finney','Joan Allen','Tom Gallop','Corey Johnson','Daniel Brühl','Joey Ansah','Colin Stinton','Dan Fredenburgh','Lucy Liemann','Arkie Reece','Mark Bazeley','Scott Adkins','Michael Ahl','Brian Cox','Chris Mansfield','Franka Potente','James Schram','Ben Youcef','Charles Venn','Branko Tomović','Trevor St. John','Jeffrey Lee Gibson','Marina Blake','Chris Wilson','Luis Mottola','Albert Jones','Laurentiu Possa','Michael Wildman'],
basedOn:['Robert Ludlum'],
screenplay:['Tony Gilroy','Scott Z. Burns','George Nolfi'],
production:['Frank Marshall','Patrick Crowley'],
music:['John Powell'],
camera:['Oliver Wood'],
cut:['Christopher Rouse'],
sound:['Per Hallberg','David Parker','Gary Summers','Bob Beemer','Scott Millan'],
scenography:['Peter Wenham','Jason Knox-Johnston','Tina Jones'],
masks:['Monika Münnich','Kay Georgiou','Loulia Sheppard'],
costumes:['Shay Cunliffe']},
{title:'Star Wars: Episode VI - Return of the Jedi',
titleCZ:'Star Wars: Epizoda VI - Návrat Jediho',
year:1983,
runtime:131,
countries:['USA'],
genres:['Sci-Fi','Adventure','Fantasy','Action'],
director:['Richard Marquand'],
actors:['Mark Hamill','Harrison Ford','Carrie Fisher','Billy Dee Williams','Anthony Daniels','Peter Mayhew','Ian McDiarmid','Frank Oz','James Earl Jones','David Prowse','Alec Guinness','Kenneth Colley','Warwick Davis','Richard Marquand','Debbie Lee Carrington','John Altman','Paul Brooke','Tony Cox','Richard Jones','Deep Roy','Luis De Jesus','Felix Silla','Richard Driscoll','Phil Fondacaro','Kiran Shah','Michael Gilden','Denis Lawson','Dermot Crowley','Jeremy Bulloch','Hilton McRae','Kenny Baker','Caroline Blakiston','Sebastian Shaw','Michael Carter','Ernie Fosselius','Robert Watts','Mike Edmonds','Tom Mannion','Claire Davenport','Peter Diamond','Peter Roy','Anthony Lang','Anthony Smee','Daniel Frishman','Kevin Thompson','Peter Allen','Vivienne Chandler','Ronny Cush','Jack Purvis','Monty Jordan','Tim Rose','Adam Bareham','Paul Grant'],
screenplay:['Lawrence Kasdan','George Lucas'],
production:['Howard G. Kazanjian'],
music:['John Williams'],
camera:['Alan Hume','Alec Mills'],
cut:['Marcia Lucas','Sean Barton','Duwayne Dunham','George Lucas'],
sound:['Roger Savage','Randy Thom','Gary Summers'],
scenography:['Norman Reynolds','Harry Lange','Michael Ford'],
masks:['Phil Tippett','Peter Robb-King','Tom Smith','Nick Dudman','Daniel Parker'],
costumes:['Aggie Guerard Rodgers','Nilo Rodis-Jamero']},
{title:'The Terminator',
titleCZ:'Terminátor',
year:1984,
runtime:107,
countries:['USA','UK'],
genres:['Action','Sci-Fi','Thriller'],
director:['James Cameron'],
actors:['Arnold Schwarzenegger','Michael Biehn','Linda Hamilton','Paul Winfield','Lance Henriksen','Rick Rossovich','Earl Boen','Dick Miller','Franco Columbu','Bill Paxton','Marianne Muellerleile','Brian Thompson','Harriet Medin','Brad Rearden','Shawn Schepps','Bess Motta','Philip Gordon','Patrick Pinney','Leslie Morris','Greg Robbins'],
screenplay:['James Cameron','Gale Anne Hurd'],
production:['Gale Anne Hurd'],
music:['Brad Fiedel'],
camera:['Adam Greenberg'],
cut:['Mark Goldblatt'],
masks:['Jeff Dawn'],
costumes:['Hilary Wright']},
{title:'The Fugitive',
titleCZ:'Uprchlík',
year:1993,
runtime:130,
countries:['USA'],
genres:['Action','Thriller','Drama'],
director:['Andrew Davis'],
actors:['Harrison Ford','Tommy Lee Jones','Sela Ward','Julianne Moore','Joe Pantoliano','Andreas Katsulas','Jeroen Krabbé','Daniel Roebuck','L. Scott Caldwell','Tom Wood','David Darlow','Ron Dean','Richard Riehle','Danny Goldring','Nick Searcy','Jane Lynch','Neil Flynn','Kirsten Nelson','Wendy George','David Pasquesi','Mike Bacarella','Kevin Mukherji','Darren W. Conrad','Frank Ray Perilli','Mark D. Espinoza','Nicholas Kusenko','Joseph F. Kosala','Andy Romano','Cheryl Lynn Bruce','Dru Anne Carlson','Kevin Crowley','Gene Barge','Allen Hamilton','John M. Watson Sr.','Eddie Bo Smith Jr.','Pancho Demmings','Johnny Lee Davenport','Don Albert','Dale Hawes','Sal Richards'],
screenplay:['David Twohy','Jeb Stuart'],
production:['Arnold Kopelson'],
music:['James Newton Howard'],
camera:['Michael Chapman'],
cut:['Don Brochu','Dov Hoenig','Richard Nord','David Finfer','Dean Goodhill','Dennis Virkler'],
sound:['Frank A. Montaño'],
scenography:['Dennis Washington'],
masks:['Peter Robb-King','Dominic Mango'],
costumes:['Aggie Guerard Rodgers']},
{title:'Awakenings',
titleCZ:'Čas probuzení',
year:1990,
runtime:121,
countries:['USA'],
genres:['Drama','Biographic'],
director:['Penny Marshall'],
actors:['Robert De Niro','Robin Williams','Julie Kavner','John Heard','Penelope Ann Miller','Alice Drummond','Barton Heyman','George Martin','Anne Meara','Dexter Gordon','Richard Libertini','Mary Alice','Bradley Whitford','Max von Sydow','Harvey Miller','Peter Stormare','Vincent Pastore','Vin Diesel','Ruth Nelson','Judith Malina','Doris McCarthy','Keith Diamond','Charles Keating','James Medina','Steve Vinovich','Mel Gorham','Laura Esterman','Tiger Haynes','Steven Randazzo','John Christopher Jones','Jack Mulcahy'],
basedOn:['Oliver Sacks'],
screenplay:['Steven Zaillian'],
production:['Walter F. Parkes'],
music:['Randy Newman'],
camera:['Miroslav Ondříček'],
cut:['Gerald B. Greenberg','Battle Davis'],
sound:['Gary C. Bourgeois'],
scenography:['Anton Furst','George DeTitta Jr.'],
masks:['Bernadette Mazur'],
costumes:['Cynthia Flynt']},
{title:'The Last Boy Scout',
titleCZ:'Poslední skaut',
year:1991,
runtime:105,
countries:['USA'],
genres:['Action','Crime','Thriller','Comedy'],
director:['Tony Scott'],
actors:['Bruce Willis','Damon Wayans','Chelsea Field','Noble Willingham','Taylor Negron','Danielle Harris','Halle Berry','Bruce McGill','Badja Djola','Kim Coates','Tony Longo','Billy Blanks','Jeff Hochendoner','Morris Chestnut','Denise Ames','Ryan Cutrona','Eddie Griffin','Michael Papajohn','Shane Dixon','Rick Ducommun','Anne Lockhart','Frank Collison','Chelcie Ross','John Cenatiempo','Joe Santos','James Keane','Jack Kehler','Fred Lerner','Sara Suzanne Brown','Gene Borkan','Clarence Felder','Donna W. Scott','Teal Roberts','Dick Butkus','Robert Apisa','Julie K. Smith','Manny Perry','David McMillan'],
screenplay:['Shane Black'],
production:['Joel Silver'],
music:['Michael Kamen'],
camera:['Ward Russell'],
cut:['Stuart Baird','Mark Helfrich','Mark Goldblatt'],
sound:['Rick Alexander','Samuel C. Crutcher'],
scenography:['Brian Morris'],
masks:['Scott H. Eddo'],
costumes:['Marilyn Vance']},
{title:'Cool Hand Luke',
titleCZ:'Frajer Luke',
year:1967,
runtime:126,
countries:['USA'],
genres:['Drama','Crime'],
director:['Stuart Rosenberg'],
actors:['Paul Newman','George Kennedy','J.D. Cannon','Lou Antonio','Robert Drivas','Strother Martin','Jo Van Fleet','Clifton James','Morgan Woodward','Luke Askew','Robert Donner','Dennis Hopper','Wayne Rogers','Harry Dean Stanton','Warren Finnerty','Joe Don Baker','Anthony Zerbe','Donn Pearce','James Gammon','Rance Howard','Ralph Waite','Richard Davalos','Charles Tyner','John McLiam','Marc Cavell','Joy Harmon','Rush Williams','John Pearce','James Jeter','Chuck Hicks'],
basedOn:['Donn Pearce'],
screenplay:['Donn Pearce','Frank Pierson'],
production:['Gordon Carroll'],
music:['Lalo Schifrin'],
camera:['Conrad L. Hall'],
cut:["Sam O'Steen"],
scenography:['Cary Odell','Fred Price'],
masks:['Gordon Bau'],
costumes:['Howard Shoup']},
{title:'Catch Me If You Can',
titleCZ:'Chyť mě, když to dokážeš',
year:2002,
runtime:141,
countries:['USA','Canada'],
genres:['Drama','Crime','Biographic'],
director:['Steven Spielberg'],
actors:['Leonardo DiCaprio','Tom Hanks','Christopher Walken','Martin Sheen','Nathalie Baye','Amy Adams','James Brolin','Brian Howe','Frank John Hughes','Steve Eastin','Chris Ellis','John Finn','Jennifer Garner','Nancy Lenehan','Ellen Pompeo','Elizabeth Banks','Guy Thauvette','Candice Azzara','Matthew Kimbrough','Kaitlin Doubleday','Thomas Kopache','Margaret Travolta','Jimmie F. Skaggs','Alex Hyde-White','Lilyan Chauvin','Robert Ruth','James Morrison','Robert Symonds','Robert Curtis Brown','Kelly Hutchinson','Steve Witting','Wendy Worthington','Brian Goodman','Ray Proscia','Sarah Lancaster','Jill Matson-Sachoff','Mike Baldridge','Ritchie Montgomery','Jim Antonio','Jonathan Brent','Benita Krista Nall','Shane Edelman','Morgan Rusler','Dave Hager','Kyle Davis',"Patrick Thomas O'Brien",'Jaime Ray Newman','Amy Acker','Robert Peters','James DuMont','Sarah Rush','Malachi Throne','Alfred Dennis','Donna Kimball','Jan Munroe','Stephen Dunham','Brandon Keener','Jasmine Jessica Anthony','Jeremy Howard','Jack Knight','Jamie Anderson','Kam Heskin','Gerald R. Molen','Jamie Moss','Jessica Collins','Frank W. Abagnale Jr.','Roger Léger','Jean-François Blanchard','Guy-Daniel Tremblay','Alex Bisping','Patrice Dussault','Ashley Cohen','Kelly Cohen','Steven Meizler','Kitty Carlisle','Nicole Andrews','Honor Blackman','G. Larry Butler','Jillian Clare','Brian Reed Garvin','Jesse Heiman','Beverly Lynne','Summer Moore','Ben Northenor','Alden Olmsted','Tara Rice','Andy Signore','Jimmy Star','Nick Zano','Deborah Kellner','Steve Comisar'],
basedOn:['Frank W. Abagnale Jr.','Stan Redding'],
screenplay:['Jeff Nathanson'],
production:['Steven Spielberg','Walter F. Parkes'],
music:['John Williams'],
camera:['Janusz Kamiński'],
cut:['Michael Kahn'],
sound:['Charles L. Campbell','Ron Judkins','Anna Behlmer','Andy Nelson','John A. Larsen',"T.J. O'Mara",'Kim Maitland'],
scenography:['Jeannine Oppewall','Claudette Didul'],
masks:['Lois Burwell','Ketty Gonzalez','Luisa Abel'],
costumes:['Mary Zophres']},
{title:'Trainspotting',
titleCZ:'Trainspotting',
year:1996,
runtime:90,
countries:['UK'],
genres:['Drama','Crime','Comedy'],
director:['Danny Boyle'],
actors:['Ewan McGregor','Ewen Bremner','Jonny Lee Miller','Kevin McKidd','Robert Carlyle','Kelly Macdonald','Peter Mullan','James Cosmo','Eileen Nicholas','Susan Vidler','Pauline Lynch','Shirley Henderson','Stuart McQuarrie','Irvine Welsh','Keith Allen','Kevin Allen','John Hodge','Andrew Macdonald','Rachael Fleming','Annie Louise Ross','Hugh Ross','Fiona Bell','Billy Riddoch','Kate Donnelly','Finlay Welsh','Vincent Friell'],
basedOn:['Irvine Welsh'],
screenplay:['John Hodge'],
production:['Andrew Macdonald'],
camera:['Brian Tufano'],
cut:['Masahiro Hirakubo'],
sound:['Mark Taylor','Colin Nicolson'],
scenography:['Kave Quinn'],
masks:['Graham Johnston'],
costumes:['Rachael Fleming']},
{title:'Princess Mononoke',
titleCZ:'Princezna Mononoke',
year:1997,
runtime:133,
countries:['Japan'],
genres:['Animation','Adventure','Fantasy'],
director:['Hajao Mijazaki'],
actors:['Júko Tanaka','Jódži Macuda','Kaoru Kobajaši','Tecu Watanabe','Juriko Išida','Masahiko Nišimura','Jošimasa Kondó','Takako Fudži','Hisaja Morišige','Tošio Suzuki','Akihiro Miwa','Sumi Šimamoto','Širó Saitó','Akira Nagoja','Keiko Cukamoto','Kazuja Kobajaši','Šindži Tokumaru','Akio Nakamura','Nobuhisa Okazaki'],
screenplay:['Hajao Mijazaki'],
production:['Tošio Suzuki'],
music:['Džó Hisaiši'],
camera:['Acuši Okui'],
cut:['Takeši Sejama'],
sound:['Dominick Tavella'],
scenography:['Naoja Tanaka','Jódži Takešige']},
{title:'Top Gun: Maverick',
titleCZ:'Top Gun: Maverick',
year:2022,
runtime:131,
countries:['USA'],
genres:['Action','Drama'],
director:['Joseph Kosinski'],
actors:['Tom Cruise','Miles Teller','Jennifer Connelly','Jon Hamm','Val Kilmer','Bashir Salahuddin','Charles Parnell','Glen Powell','Monica Barbaro','Lewis Pullman','Greg Tarzan Davis','Jay Ellis','Jack Schumacher','Danny Ramirez','Manny Jacinto','Kara Wang','Jake Picking','Raymond Lee','Jean Louisa Kelly','Lyliana Wray','Ed Harris','Chelsea Harris','Rachel Winfree','Bob Stephenson','Landon Gordon','James Handy','Brian Ferguson','Chido Nwokocha','Rachael Markarian','Shannon Kane','Andre Franco','Charlotte Xia','Anthony Edwards','Meg Ryan','Kelly McGillis','Peter Mark Kendall','Stephanie Andrea Barron','Sergio Briones','Skylar Witte'],
screenplay:['Ehren Kruger','Eric Warren Singer','Christopher McQuarrie'],
production:['Jerry Bruckheimer','Tom Cruise','David Ellison','Christopher McQuarrie'],
music:['Hans Zimmer','Harold Faltermeyer','Lady Gaga','Lorne Balfe'],
camera:['Claudio Miranda'],
cut:['Eddie Hamilton'],
sound:['Mark Taylor','James Mather','Bjørn Ole Schroeder','Al Nelson','Christopher Boyes','Mark Weingarten','Chris Burdon'],
scenography:['Jeremy Hindle','Jan Pascale'],
masks:['Ken Diaz','Breanne McNally','Martina Kohl','Ozzy Alvarez','Robert C. Mathews III','Claudia Humburg','Desiree Falcon','Steven R. Soussanna'],
costumes:['Marlene Stewart']},
{title:'The Bear',
titleCZ:'Medvěd',
year:1988,
runtime:96,
countries:['France','USA'],
genres:['Adventure','Family','Drama'],
director:['Jean-Jacques Annaud'],
actors:['medvěd Bart','medvěd Youk','Tchéky Karyo','André Lacombe','Jack Wallace'],
screenplay:['Gérard Brach'],
production:['Claude Berri'],
music:['Philippe Sarde'],
camera:['Philippe Rousselot'],
cut:['Noëlle Boisson'],
scenography:['Toni Lüdi'],
costumes:['Corinne Jorry','Françoise Disle']},
{title:'Thirteen Lives',
titleCZ:'Třináct životů',
year:2022,
runtime:149,
countries:['UK'],
genres:['Drama','Adventure'],
director:['Ron Howard'],
actors:['Viggo Mortensen','Colin Farrell','Joel Edgerton','Tom Bateman','Paul Gleeson','Thira Chutikul','Nophand Boonyai','Josh Helman','Zahra Newman','Vithaya Pansringarm','Lewis Fitz-Gerald','Teeradon Supapunpinyo','Sahajak Boonthanakit','Theerapat Sajakul','Luisa Prosser','Pattrakorn Tungsupakul','Sukollawat Kanaros','Achi Jinapanyo','Peter Phan'],
screenplay:['William Nicholson'],
production:['Brian Grazer','Karen Lunder','Gabrielle Tana','P. J. van Sandwijk','Ron Howard'],
music:['Benjamin Wallfisch'],
camera:['Sayombhu Mukdeeprom'],
cut:['James Wilcox'],
sound:['Chris Burdon','Michael Fentum','William Miller','Oliver Tarney','Rachael Tate'],
scenography:['Molly Hughes','Lek Chaiyan Chunsuttiwat'],
masks:['Rick Findlater','Sophie Thorpe'],
costumes:['Tess Schofield']},
{title:'Inglourious Basterds',
titleCZ:'Hanebný pancharti',
year:2009,
runtime:153,
countries:['USA','Germany'],
genres:['Drama','Adventure','War'],
director:['Quentin Tarantino'],
actors:['Brad Pitt','Mélanie Laurent','Christoph Waltz','Eli Roth','Michael Fassbender','Diane Kruger','Daniel Brühl','Til Schweiger','Gedeon Burkhard','Jacky Ido','B. J. Novak','Omar Doom','August Diehl','Denis Ménochet','Sylvester Groth','Martin Wuttke','Mike Myers','Julie Dreyfus','Richard Sammel','Alexander Fehling','Rod Taylor','Sönke Möhring','Samm Levine','Paul Rust','Michael Bacall','Arndt Schwering-Sohnrey','Petra Hartung','Volker Michalowski','Ken Duken','Christian Berkel','Anne-Sophie Franck','Léa Seydoux','Lena Friedrich','Ludger Pistor','Jana Pallaske','Wolfgang Lindner','Michael Kranz','Rainer Bock','André Penvern','Sebastian Hülk','Buddy Joe Hooker','Carlos Fidel','Christian Brückner','Hilmar Eichhorn','Patrick Elias','Eva Löbau','Wilfried Hochholdinger','Bo Svenson','Enzo G. Castellari','Michael August','Noemi Besedes','Alex Boden','Guido Föhrweißer','Jake Garber','Samuel L. Jackson','Harvey Keitel','Andrew Napier','Greg Nicotero','Brendan Potter','Sabrina Rattey','Quentin Tarantino','Vitus Wieser'],
screenplay:['Quentin Tarantino'],
production:['Lawrence Bender'],
camera:['Robert Richardson'],
cut:['Sally Menke'],
sound:['Harry Cohen','Tony Lamberti','Michael Minkler','Wylie Stateman','Mark Ulano'],
scenography:['David Wasco','Sebastian T. Krawinkel','Sandy Reynolds-Wasco'],
masks:['Heba Thorisdottir','Greg Nicotero','Jake Garber'],
costumes:['Anna Biedrzycka-Sheppard']},
{title:'The Butterfly Effect',
titleCZ:'Osudový dotek',
year:2004,
runtime:113,
countries:['USA'],
genres:['Sci-Fi','Mystery','Thriller'],
director:['Jonathan Mackye Gruber','Eric Bress'],
actors:['Ashton Kutcher','Amy Smart','Melora Walters','Eric Stoltz','John Patrick Amedori','Elden Henson','Kevin G. Schmidt','Kevin Durand','William Lee Scott','Ethan Suplee','Logan Lerman','Jesse James','Cameron Bright','Callum Keith Rennie','Sam Easton','Tara Wilson','Magda Apanowicz','Kevan Ohtsji','Camille Sullivan','Kimani Ray Smith','Kendall Cross','Jesse Hutch','John B. Lowe','Meilani Paul','Irina Gorovaia','Paul Lazenby','Lorena Gale','Douglas Arthurs','June B. Wilde','Bill Croft','John Tierney','Grant Thompson'],
screenplay:['Jonathan Mackye Gruber','Eric Bress'],
production:['Chris Bender','A.J. Dix','J.C. Spink'],
music:['Michael Suby'],
camera:['Matthew F. Leonetti'],
cut:['Peter Amundson'],
sound:['Mathew Waters','Derek Marcil','Aaron Levy'],
scenography:['Douglas Higgins','Sam Higgins'],
masks:['Brad Hardin','Patricia Murray','Toby Lindala'],
costumes:['Carla Hetland']},
{title:'The Truman Show',
titleCZ:'Truman Show',
year:1998,
runtime:103,
countries:['USA'],
genres:['Drama','Comedy','Sci-Fi'],
director:['Peter Weir'],
actors:['Jim Carrey','Laura Linney','Ed Harris','Noah Emmerich','Natascha McElhone','Holland Taylor','Peter Krause','Antoni Corone','Paul Giamatti','Harry Shearer','Philip Baker Hall','Brian Delate','Saemi Nakamura','Philip Glass','Marcia DeBonis','O-Lan Jones','Marc Macaulay','Júdži Okumoto','Kevin D. Ross','Susan Angelo','Heidi Schanz','Marco Rubeo','Joel McKinnon Miller','Sergio Kato','Jeanette Miller','Terry Camilleri','Dona Hardy','Judson Vaughn','John Roselius','Una Damon','Joe Minjares','Zoaunne LeRoy','Jake Eberle','Mal Jones','Michael J. McAlister','Blair Slater','Tom Simmons','Jim Towers','Melissa Fitzgerald'],
screenplay:['Andrew Niccol'],
production:['Scott Rudin','Edward S. Feldman','Andrew Niccol','Adam Schroeder'],
music:['Burkhard von Dallwitz','Philip Glass'],
camera:['Peter Biziou'],
cut:['Lee Smith','William M. Anderson'],
sound:['Lee Smith'],
scenography:['Dennis Gassner','Nancy Haigh'],
masks:['Anne Morgan'],
costumes:['Marilyn Matthews']},
{title:'American Gangster',
titleCZ:'Americký gangster',
year:2007,
runtime:157,
countries:['USA','UK'],
genres:['Drama','Crime','Thriller','Biographic'],
director:['Ridley Scott'],
actors:['Denzel Washington','Russell Crowe','Chiwetel Ejiofor','Josh Brolin','Lymari Nadal','Ted Levine','Roger Guenveur Smith','John Hawkes','RZA','Yul Vazquez','Malcolm Goodwin','Ruby Dee','Ruben Santiago-Hudson','Carla Gugino','John Ortiz','Cuba Gooding Jr.','Armand Assante','Joe Morton','Ritchie Coster','Idris Elba','Common','T.I.','Kevin Corrigan','Robert Funaro','Jon Polito','Robert C. Kirk','KaDee Strickland','Jon DeVries','Gavin Grazer','Norman Reedus','Eddie Rouse','Cedric Sanders','Roger Bart','Conor Romero','Daniel Hilt','Ric Young','Chuck Cooper','Chance Kelly','Joey Klein','Al Santos','Fab 5 Freddy','Lloyd Booker','Dj Nino Carta','John Cenatiempo','Ernest Dancy','Gabriel Hansen','Hristo Hristov','Robert Nicotra','Richard Nixon','Nick Poltoranin','Evelyn Vaccaro','Adrain Washington','Clarence Williams III','Frances Mignano','Monique Dupree','Sam Freed',"Tom O'Rourke",'Mark DiConzo','Larry Mitchell','Kevin Geer','Dan Moran','Jermel Howard','Brad Lee Wind','Linda Powell',"Cris D'Annunzio",'Albert Jones','Celestine Rae','Eddie Goines','Artie Pasquale','Saycon Sengbloh','Kathleen Garrett','Atif Lanier','Anthony Hamilton','Jason Furlani','Billy Smith'],
basedOn:['Mark Jacobson'],
screenplay:['Steven Zaillian'],
production:['Brian Grazer','Ridley Scott'],
music:['Marc Streitenfeld'],
camera:['Harris Savides'],
cut:['Pietro Scalia'],
sound:['Bob Beemer','Michael Minkler'],
scenography:['Arthur Max'],
masks:['Carl Fullerton','John Caglione','Jr.','Larry M. Cherry','Bernadette Mazur'],
costumes:['Janty Yates']},
{title:'Lock, Stock and Two Smoking Barrels',
titleCZ:'Sbal prachy a vypadni',
year:1998,
runtime:107,
countries:['UK'],
genres:['Crime','Thriller','Comedy'],
director:['Guy Ritchie'],
actors:['Jason Flemyng','Dexter Fletcher','Nick Moran','Jason Statham','Steven Mackintosh','Nicholas Rowe','Vinnie Jones','Lenny McLean','Peter McNicholl','P. H. Moriarty','Frank Harper','Steve Sweeney','Stephen Marcus','Vas Blackwood','Sting','Rob Brydon','Vera Day','Alan Ford','Danny John-Jules','Tim Maurice-Jones','Victor McGuire','David Reid','Andrew Tiernan','Richard Vanstone','Matthew Vaughn','Olivier Cabassut','Charles Forbes','Jake Abraham','Ronnie Fox'],
screenplay:['Guy Ritchie'],
production:['Matthew Vaughn'],
music:['John Murphy','David A. Hughes'],
camera:['Tim Maurice-Jones'],
cut:['Niven Howie'],
sound:['Simon Hayes','Matthew Collinge'],
scenography:['Iain Andrews','Eve Mavrakis','Jac Hyman'],
costumes:['Stephanie Collie']},
{title:'Scarface',
titleCZ:'Zjizvená tvář',
year:1983,
runtime:170,
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Brian De Palma'],
actors:['Al Pacino','Steven Bauer','Michelle Pfeiffer','Mary Elizabeth Mastrantonio','Robert Loggia','Miriam Colon','F. Murray Abraham','Paul Shenar','Harris Yulin','Ángel Salazar','Arnaldo Santana','Pepe Serna','Michael P. Moran','Al Israel','Dennis Holahan','Mark Margolis','Michael Alldredge','Ted Beniades','Richard Belzer','Paul Espel','John Brandon','Tony Perez','Garnett Smith','Loren Almaguer','Gil Barreto','Heather Benna','Sue Bowser','Tina Leigh Cameron','Victor Campos','Robert Hammer Cannerday','Rene Carrasco','Albert Carrier','John Carter','Richard Caselnova','Gary Carlos Cervantes','Carlos Cestero','Johnny Contardo','Roberto Contreras','Caesar Cordova','Gregory Cruz',"Dante D'Andre",'Richard Delmonte','Wayne Doba','Michel François','Ben Frommer','Edward R. Frommer','John Gamble','Troy Isaacs','Ronald G. Joseph','Mario Machado','Joe Marmo','Ray Martel','John P. McCann','Richard Mendez','Victor Millan','Santos Morales','Mike Moroff','Angela Nisi','Manuel Padilla Jr.','Tony Pann','Ilka Tanya Payán','Barbra Perez','Michael Rougas','Anthony Saenz','Geno Silva','Arnold Tafolla','Charles A. Tamburro','Jim Towers','Robert Vandenberg','Bob Yanez','Angela Aames','Nancy Lee Andrews','Dona Baldwin','Lee Benton','Cynthia Burr','Lana Clarkson','Karen Criswell','Margo Kelly','Ava Lazar','Emilia Crow','Marii Mak','Shelley Taylor Morgan','Catharine Richardson','Pat Simmons','Terri Taylor','Charlie Adiano','Lisa Katz','Jeanette Linne','Margaret Michaels','Rhonda Sandberg','Katt Shea','Marcia Wolf','Linda Gillen','Bart Greene','Bob Harks','Gregg Henry','Kevyn Major Howard','Henry Kingi','Brett Ratner','Marcus Shirock'],
basedOn:['Armitage Trail'],
screenplay:['Oliver Stone','Howard Hawks','Ben Hecht'],
production:['Martin Bregman'],
music:['Giorgio Moroder'],
camera:['John A. Alonzo'],
cut:['Gerald B. Greenberg','David Ray'],
sound:['Edward Beyer','Don Digirolamo'],
scenography:['Edward Richardson','Bruce Weintraub'],
masks:['Stephen Abrums','Janice D. Brandow'],
costumes:['Patricia Norris']},
{title:'Seven Samurai',
titleCZ:'Sedm samurajů',
year:1954,
runtime:160,
countries:['Japan'],
genres:['Action','Drama'],
director:['Akira Kurosawa'],
actors:['Takaši Šimura','Daisuke Kató','Minoru Čiaki','Isao Kimura','Seidži Mijaguči','Toširó Mifune','Kamatari Fudžiwara','Acuši Watanabe','Isao Jamagata','Noriko Sengoku','Tacuja Nakadai','Eidžiró Tóno','Ken Ucui','Bokuzen Hidari','Jošio Inaba','Haruo Suzuki','Jošio Kosugi','Šigeo Kató','Kokuten Kôdô'],
screenplay:['Akira Kurosawa','Šinobu Hašimoto','Hideo Oguni'],
music:['Fumio Hajasaka'],
camera:['Asakazu Nakai'],
cut:['Akira Kurosawa'],
scenography:['Takashi Matsuyama']},
{title:'Black Hawk Down',
titleCZ:'Černý jestřáb sestřelen',
year:2001,
runtime:145,
countries:['USA','UK'],
genres:['Drama','History','War'],
director:['Ridley Scott'],
actors:['Josh Hartnett','Ewan McGregor','Tom Sizemore','Eric Bana','William Fichtner','Ewen Bremner','Sam Shepard','Gabriel Casseus','Kim Coates','Hugh Dancy','Ron Eldard','Ioan Gruffudd','Tom Guiry','Charlie Hofheimer','Danny Hoch','Jason Isaacs','Željko Ivanek','Glenn Morshower','Jeremy Piven','Brendan Sexton III','Johnny Strong','Richard Tyson','Brian Van Holt','Nikolaj Coster-Waldau','Steven Ford','Ian Virgo','Tom Hardy','Gregory Sporleder','Carmine Giovinazzo','Chris Beetem','Matthew Marsden','Orlando Bloom','Enrique Murciano','George Harris','Razaaq Adoti','Treva Etienne','Pavel Vokoun','Ty Burrell','Boyd Kestner','Giannina Facio-Scott','Corey Johnson','Jason Hildebrandt','Tac Fitzgerald','Johann Myers','Norman Campbell Rees'],
basedOn:['Mark Bowden'],
screenplay:['Ken Nolan'],
production:['Ridley Scott','Jerry Bruckheimer'],
music:['Hans Zimmer'],
camera:['Sławomir Idziak'],
cut:['Pietro Scalia'],
sound:['Gary Rizzo','Michael Minkler','Myron Nettinga'],
scenography:['Arthur Max','Elli Griff','Gianni Giovagnoni'],
masks:['Fabrizio Sforza','Ana Bulaić Črček','Michele Vigliotta'],
costumes:['Sammy Sheldon Differ']},
{title:'12 Monkeys',
titleCZ:'12 opic',
year:1995,
runtime:124,
countries:['USA'],
genres:['Mystery','Sci-Fi','Thriller'],
director:['Terry Gilliam'],
actors:['Bruce Willis','Madeleine Stowe','Brad Pitt','Christopher Plummer','Jon Seda','David Morse','Bill Raymond','Frank Gorshin','Chuck Jeffreys','Matt Ross','Christopher Meloni','Stephen Bridgewater','Richard Stanley','LisaGay Hamilton','Joseph McKenna','Frederick Strother','Roger Pratt',"Harry O'Toole",'Annie Golden','Simon Jones','Allelon Ruggiero','Thomas Roy','Bob Adrian','Raymond Mamrak','Irma St. Paule','Charles Techman','Kevin Thigpen'],
screenplay:['David Webb Peoples','Janet Peoples','Chris Marker'],
production:['Mark Egerton','Charles Roven'],
music:['Paul Buckmaster'],
camera:['Roger Pratt'],
cut:['Mick Audsley'],
scenography:['Jeffrey Beecroft','Crispian Sallis'],
costumes:['Julie Weiss']},
{title:'Spirited Away',
titleCZ:'Cesta do fantazie',
year:2001,
runtime:124,
countries:['Japan'],
genres:['Animation','Adventure','Fantasy','Fairytale','Family'],
director:['Hajao Mijazaki'],
actors:['Rumi Hiiragi','Takaši Naitó','Rjúnosuke Kamiki','Bunta Sugawara','Mari Nacuki','Šigejuki Tocugi','Takehiko Ono','Jasuko Sawaguči','Miju Irino','Širó Saitó','Keiko Cukamoto','Koba Hajaši','Yumi Tamai','Kaori Jamagata','Hiromi Takeuči','Minako Masuda','Jóko Óno','Šindži Tokumaru','Majumi Sako','Akio Nakamura','Šigeru Wakita','Makiko Oku','Noriko Kitó'],
screenplay:['Hajao Mijazaki'],
production:['Tošio Suzuki'],
music:['Džó Hisaiši'],
camera:['Acuši Okui'],
cut:['Takeši Sejama'],
scenography:['Jódži Takešige']},
{title:'Green Book',
titleCZ:'Zelená kniha',
year:2018,
runtime:130,
countries:['USA'],
genres:['Drama','Comedy','Road movie','Biographic','Music'],
director:['Peter Farrelly'],
actors:['Viggo Mortensen','Mahershala Ali','Linda Cardellini','Sebastian Maniscalco','Dimiter D. Marinov','Mike Hatton','P.J. Byrne','Joe Cortese','Don Stark','Anthony Mangano','Paul Sloan','Frank Vallelonga','Jenna Laurenzo','Johnny Williams','Randal Gonzalez','Iqbal Theba','Sharon Landry','Nick Vallelonga','Mike Cerrone','Geraldine Singer','Martin Bats Bradford','Ted Huckabee','Gralen Bryant Banks','Sam Malone','David Kallaway','Harrison Stone','Ricky Muse','Tom Virtue','Daniel Greene','Brian Distance','Craig DiFrancia','Jim Klock','Dane Rhodes','Brian Stepanek','Jon Michael Davis','Montrel Miller','Ninja N. Devoe','Brian Hayes Currie','Emily LaGroue','Karn Kalra','Douglas DeLisle','Don DiPetta','Kenneth Israel'],
screenplay:['Nick Vallelonga','Brian Hayes Currie','Peter Farrelly'],
production:['Jim Burke','Charles B. Wessler','Brian Hayes Currie','Peter Farrelly','Nick Vallelonga'],
music:['Kris Bowers'],
camera:['Sean Porter'],
cut:['Patrick J. Don Vito'],
sound:['Andrew DeCristofaro','Mark Paterson','Tony Lamberti'],
scenography:['Tim Galvin'],
masks:['Courtney Lether','Stacey Perry'],
costumes:['Betsy Heimann']},
{title:'Batman Begins',
titleCZ:'Batman začíná',
year:2005,
runtime:140,
countries:['USA','UK'],
genres:['Action','Adventure'],
director:['Christopher Nolan'],
actors:['Christian Bale','Michael Caine','Liam Neeson','Katie Holmes','Gary Oldman','Cillian Murphy','Tom Wilkinson','Rutger Hauer','Ken Watanabe','Mark Boone Junior','Linus Roache','Morgan Freeman','Sara Stewart','Gus Lewis','Christine Adams','Rade Šerbedžija','John Nolan','David Murray','Darragh Kelly','Charles Edwards','Roger Yuan','Jon Foo','Tamer Hassan','Jeremy Theobald','Karen David','Jack Gleeson','Dave Legeno','Richard Brake','Lucy Russell','Terry McMahon','Joey Ansah','David Bedella','Stephen Walters','Vincent Wong','Shane Rimmer','Colin McFarlane','Kwaku Ankomah','Emma Lockhart','Spencer Wilding','Lasco Atkins','T.J. Ramini','Dean Alexandrou','Tom Wu','John Kazek','Jamie Hayden','Nadia Cameron-Blakey','Dominic Burgess','Jo Martin','Risteard Cooper','Omar Mostafa','Alexandra Bastedo','Charlie Kranz','Andrew Pleavin','Mark Rhino Smith','Douglas Bunn','Jimmy Star','Larry Holden','Stuart Ong','Jennifer A. Goodman','Scott Hinds','Tom Nolan','Ronan Leahy'],
basedOn:['Bob Kane','Bill Finger'],
screenplay:['Christopher Nolan','David S. Goyer'],
production:['Charles Roven','Larry Franco','Emma Thomas'],
music:['James Newton Howard','Hans Zimmer'],
camera:['Wally Pfister'],
cut:['Lee Smith'],
sound:['Stefan Henrix','David Evans','Gary Rizzo','Lora Hirschberg'],
scenography:['Paul Kirby','Nathan Crowley','Su Whitaker'],
masks:['Peter Robb-King','Zoe Tahir'],
costumes:['Lindy Hemming']},
{title:'Run, Waiter, Run!',
titleCZ:'Vrchní, prchni!',
year:1980,
runtime:85,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Ladislav Smoljak'],
actors:['Josef Abrhám','Libuše Šafránková','Eliška Balzerová','Zuzana Fišerová-Svátková','Zdeněk Svěrák','Dáda Patrasová','Jiří Kodet','Karel Augusta','Bedřich Prokoš','Jiří Hálek','Milada Ježková','Ilja Racek','Daniela Bakerová','Jaroslava Kretschmerová','Miloslav Štibich','Jana Altmannová','Václav Mareš','Petr Popelka','Jana Březinová','Jan Kašpar','Jan Hraběta','Ivan Pokorný','Jiří Knot','Jiří Lír','Jaroslav Weigel','Pavel Havránek','Hana Čížková','Pavel Vondruška','Miroslav Vladyka','Ivan Wiesner','František Olšovský','Jan Prokeš','Stanislava Bartošová','Ilona Vaňková','Filip Smoljak','Aleš Jánský','Lucie Horová','David Smoljak','Ladislav Smoljak','Josef Koudelka Bergstein','Jaroslav Vozáb','Karel Šíp','Boris Rösner','Jiří Bednář','Helena Dubová','Milan Duchek','Iva Hercíková','Milan Klacek','Milena Koutná','Ludmila Krajíčková','Blažena Kramešová','Jan Kuželka','Jindřich Narenta','Vít Pešina','Zdeněk Skalický','Josef Střecha','Renata Mašková','Zdeněk Zelenka','Ladislav Trojan','Jana Vychodilová','Vlasta Žehrová','Jan Vávra','Gabriela Wilhelmová','Jiří Pokora','Vladimír Hrabánek','Alexej Pyško','Vladimír Žižka','Věra Kočišová','Václav Kotva','Bohumil Fišer','Rudolf Svěcený','Slávka Hamouzová','Václav Eisenhamer','Kateřina Smoljaková','Alžběta Smoljaková','Karel Engel','Martin Velda','Ivo Gübel','Běla Jurdová','Dagmar Smoljaková'],
screenplay:['Zdeněk Svěrák'],
music:['Jaroslav Uhlíř'],
camera:['Ivan Šlapeta'],
cut:['Jiří Brožek'],
sound:['Jiří Pavlík'],
scenography:['Jan Oliva'],
masks:['Vladimír Petřina'],
costumes:['Helena Dubová']},
{title:'Predator',
titleCZ:'Predátor',
year:1987,
runtime:107,
countries:['USA'],
genres:['Action','Sci-Fi','Horror'],
director:['John McTiernan'],
actors:['Arnold Schwarzenegger','Carl Weathers','Elpidia Carrillo','Bill Duke','Jesse Ventura','Sonny Landham','Richard Chaves','R.G. Armstrong','Shane Black','Kevin Peter Hall','Sven-Ole Thorsen','Henry Kingi'],
screenplay:['Jim Thomas','John Thomas'],
production:['John Davis','Lawrence Gordon','Joel Silver'],
music:['Alan Silvestri'],
camera:['Donald McAlpine'],
cut:['John F. Link','Mark Helfrich'],
sound:['Richard L. Anderson'],
scenography:['John Vallone'],
masks:['Jeff Dawn','Scott H. Eddo'],
costumes:['Marilyn Vance']},
{title:'Rocky',
titleCZ:'Rocky',
year:1976,
runtime:115,
countries:['USA'],
genres:['Drama','Sport'],
director:['John G. Avildsen'],
actors:['Sylvester Stallone','Talia Shire','Burt Young','Carl Weathers','Burgess Meredith','Thayer David','Joe Spinell','Jimmy Gambina','Bill Baldwin','Al Silvani','Jodi Letizia','Diana Lewis',"George O'Hanlon",'Stan Shaw','Don Sherman','Pedro Lovell','Tony Burton','Lloyd Kaufman','Frank Stallone','Joe Frazier','Michael Dorn','Arthur Tovey','Frank Pesce','Billy Sands','George Memmoli','Larry Carroll','DeForest Covan','Simmy Bow','Hank Rolike',"Shirley O'Hara",'Jane Marla Robbins','Lou Fillipo','Arnold Johnson','Lavelle Roby','Jack Hollander','Frankie Van'],
screenplay:['Sylvester Stallone'],
production:['Irwin Winkler','Robert Chartoff'],
music:['Bill Conti'],
camera:['James Crabe'],
cut:['Richard Halsey','Scott Conrad'],
sound:['Bud Alper'],
scenography:['William J. Cassidy','Ray Molyneaux'],
masks:['Michael Westmore']},
{title:'Memento',
titleCZ:'Memento',
year:2000,
runtime:113,
countries:['USA'],
genres:['Mystery','Thriller','Psychology'],
director:['Christopher Nolan'],
actors:['Guy Pearce','Carrie-Anne Moss','Joe Pantoliano','Mark Boone Junior','Jorja Fox','Stephen Tobolowsky','Harriet Sansom Harris','Thomas Lennon','Callum Keith Rennie','Marianne Muellerleile','Russ Fega','Larry Holden'],
basedOn:['Jonathan Nolan'],
screenplay:['Christopher Nolan'],
production:['Suzanne Todd','Jennifer Todd'],
music:['David Julyan'],
camera:['Wally Pfister'],
cut:['Dody Dorn'],
sound:['Michael C. Casper'],
scenography:['Patti Podesta','Danielle Berman'],
masks:['Scott H. Eddo'],
costumes:['Cindy Evans']},
{title:'The Lion King',
titleCZ:'Lví král',
year:1994,
runtime:89,
countries:['USA'],
genres:['Animation','Adventure','Drama','Family','Musical'],
director:['Roger Allers','Rob Minkoff'],
actors:['Matthew Broderick','Jeremy Irons','James Earl Jones','Moira Kelly','Nathan Lane','Ernie Sabella','Jonathan Taylor Thomas','Robert Guillaume','Rowan Atkinson','Madge Sinclair','Whoopi Goldberg','Cheech Marin','Jim Cummings','Frank Welker','Phil Proctor','Cathy Cavadini','Patrick Pinney'],
screenplay:['Irene Mecchi','Jonathan Roberts','Linda Woolverton'],
production:['Meinolf Hartung'],
music:['Hans Zimmer','Elton John'],
cut:['Ivan Bilancio'],
sound:['Richard L. Anderson',"Andy D'Addario",'Mark A. Mangini','Lora Hirschberg'],
scenography:['Andy Gaskill']},
{title:'Lethal Weapon 2',
titleCZ:'Smrtonosná zbraň 2',
year:1989,
runtime:107,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Richard Donner'],
actors:['Mel Gibson','Danny Glover','Joe Pesci','Joss Ackland','Patsy Kensit','Darlene Love','Traci Wolfe','Damon Hines','Ebonie Smith',"Derrick O'Connor",'Mark Rolston','Steve Kahan','Nestor Serrano','Grand L. Bush','Sherman Howard','David Marciano','Tommy Hinkley','Dean Norris','Jenette Goldstein','Kenneth Tigar','Jack McGee','Mary Ellen Trainor','J. Mills Goodloe','Paul Tuerpe','Jim Piddock','Marian Collier','Philip Suriano','Pat Skipper','Juney Smith','James Oliver','Conrad Hurtt','Patrick Cameron','Cynthia Burr'],
screenplay:['Jeffrey Boam'],
production:['Richard Donner','Joel Silver'],
music:['Michael Kamen','Eric Clapton','David Sanborn'],
camera:['Stephen Goldblatt'],
cut:['Stuart Baird'],
sound:['Alan Robert Murray','Michael Jiron','Rick Alexander'],
scenography:['J. Michael Riva','Marvin March'],
masks:['Scott H. Eddo']},
{title:'Snow White and the Seven Dwarfs',
titleCZ:'Sněhurka a sedm trpaslíků',
year:1937,
runtime:83,
countries:['USA'],
genres:['Animation','Family','Romance','Musical'],
director:['David Hand'],
actors:['Roy Atwell','Stuart Buchanan','Adriana Caselotti','Pinto Colvig','Billy Gilbert','Otis Harlan','Moroni Olsen','Eddie Collins','Scotty Mattraw','Lucille La Verne','James MacDonald','Marion Darlington'],
basedOn:['Jacob Grimm','Wilhelm Grimm'],
production:['Walt Disney','Hubert Schonger'],
music:['Leigh Harline','Paul J. Smith'],
scenography:['Ken Anderson']},
{title:"The Sorcerer's Apprentice",
titleCZ:'Čarodějův učeň',
year:1977,
runtime:72,
countries:['Czechoslovakia','Germany'],
genres:['Animation','Horror','Fairytale'],
director:['Karel Zeman'],
actors:['Luděk Munzar','Jaroslav Moučka','Christian Brückner','Hans Ernback'],
basedOn:['Otfried Preußler'],
production:['Karel Hutěčka'],
music:['František Belfín'],
camera:['Bohuslav Pikhart','Zdeněk Krupa'],
cut:['Ivan Matouš']},
{title:'The Dark Knight Rises',
titleCZ:'Temný rytíř povstal',
year:2012,
runtime:158,
countries:['USA','UK'],
genres:['Action','Crime','Drama','Thriller'],
director:['Christopher Nolan'],
actors:['Christian Bale','Gary Oldman','Tom Hardy','Joseph Gordon-Levitt','Anne Hathaway','Marion Cotillard','Morgan Freeman','Michael Caine','Matthew Modine','Alon Aboutboul','Ben Mendelsohn','Burn Gorman','Daniel Sunjata','Aidan Gillen','Nestor Carbonell','Brett Cullen','Reggie Lee','Chris Ellis','Juno Temple','Thomas Lennon','Rob Brown','Fredric Lehne','Will Estes','David Dayan Fisher','Brent Briscoe','John Nolan','Robert Wisdom','Ian Bohen','Uri Gavriel','Aramis Knight','Josh Stewart','William Devane','Joey King','Liam Neeson','Cillian Murphy','Tom Conti','Desmond Harrington','Tomas Arana','Jillian Armenante','Aja Evans','Wade Williams','Jake Canuso','Daniel Newman','Warren Brown','Christopher Judge','Jason Yee','Michael Papajohn','David Gyasi','Aaron Eckhart','James Rawlings','Joshua Elijah Reese','John W. Iwanonkiw','Claire Julien','India Wadsworth','Ronnie Gene Blevins','Josh Pence','Edgar Jimz','Thomas Tull','Glen Powell',"Shaun O'Donnell",'Shannon Lanier','Oliver Cotton','Ed Heavey','Mark Falvo','James Harvey Ward','Mitchell Yee','Alex Ziwak','Rey Goyos','John Mancini','Adam Piacente','John Macmillan','Kevin Tanski','Jay Benedict','Gonzalo Menendez','Trevor White','Graham Curry','Joseph Lyle Taylor','Duane Henry','Andrea Vasiliou','Sarah Goldberg','Linus Roache','James Blankenfeld','Peter Holden','Massi Furlan','Patrick Cox','Tyler Dean Flores','Daniel Jordano','Miranda Nolan','Russ Fega','David Monahan','Emily Schooley','Steven Shaffer','Vanessa Alameda','Daina Griffith','Grant Babbitt','London May','Bill Kennedy'],
basedOn:['Bob Kane','Bill Finger'],
screenplay:['Jonathan Nolan','Christopher Nolan'],
production:['Charles Roven','Christopher Nolan','Emma Thomas'],
music:['Hans Zimmer'],
camera:['Wally Pfister'],
cut:['Lee Smith'],
sound:['Richard King','Gary Rizzo','Gregg Landaker'],
scenography:['Nathan Crowley','Kevin Kavanaugh','Toby Britton','Su Whitaker'],
masks:["Conor O'Sullivan",'Patricia Dehaney','Rachel Geary','Luisa Abel'],
costumes:['Lindy Hemming']},
{title:'Home Alone',
titleCZ:'Sám doma',
year:1990,
runtime:103,
countries:['USA'],
genres:['Family','Comedy'],
director:['Chris Columbus'],
actors:['Macaulay Culkin','Joe Pesci','Daniel Stern',"Catherine O'Hara",'John Heard','Roberts Blossom','Angela Goethals','Devin Ratray','Larry Hankin','Kristin Minter','Kieran Culkin','John Candy','Ralph Foody','Michael Guido','Hope Davis','Ken Hudson Campbell','Ray Toler','Luciano Saber','Senta Moses','Bill Erwin','Billie Bird','Marie Verdi','Gerry Bamman','Alan Wilder','Mark Beltzman','James Ryan','Jim Ortlieb','Hillary Wolf','Michael C. Maronna','Terrie Snell','Jedidiah Cohen','Anna Slotky','Diana Rein','Jeffrey Wiseman','Virginia Smith','Matt Doherty','Gerry Becker','D. Danny Warhol','Tracy J. Connor','Sandra Macat','Dale Hawes'],
screenplay:['John Hughes'],
production:['John Hughes'],
music:['John Williams'],
camera:['Julio Macat'],
cut:['Raja Gosnell'],
sound:['Wylie Stateman','Chris Carpenter','Ellis Burman III'],
scenography:['John Muto'],
masks:['Kimberly Phillips','Linda Rizzuto'],
costumes:['Jay Hurley']},
{title:'Hotel Rwanda',
titleCZ:'Hotel Rwanda',
year:2004,
runtime:121,
countries:['UK','USA','Italy','South African republic'],
genres:['Drama','War','Biographic'],
director:['Terry George'],
actors:['Don Cheadle','Sophie Okonedo','Nick Nolte','Hakeem Kae-Kazim','Mothusi Magano','Joaquin Phoenix','Cara Seymour','Jean Reno',"David O'Hara",'Tony Kgoroge','Fana Mokoena','Antonio David Lyons','Desmond Dube','Mosa Kaiser','Mathabo Pieterson','Ofentse Modiselle','Lebo Mashile','Rosie Motene','Ashleigh Tobias'],
screenplay:['Keir Pearson','Terry George'],
production:['A. Kitman Ho'],
music:['Andrea Guerra','Rupert Gregson-Williams'],
camera:['Robert Fraisse'],
cut:['Naomi Geraghty'],
sound:['Doug Cooper','Tom Johnson'],
scenography:['Johnny Breedt','Tony Burrough'],
costumes:['Ruy Filipe']},
{title:'Invention for Destruction',
titleCZ:'Vynález zkázy',
year:1958,
runtime:81,
countries:['Czechoslovakia'],
genres:['Sci-Fi','Adventure','Fantasy'],
director:['Karel Zeman'],
actors:['Lubor Tokoš','Arnošt Navrátil','Miloslav Holub','František Šlégr','Václav Kyzlink','Jana Zatloukalová','Otto Šimánek','František Řehák','Václav Babka','Alena Kreuzmannová','Felix le Breux'],
basedOn:['Jules Verne'],
screenplay:['Karel Zeman','František Hrubín'],
music:['Zdeněk Liška'],
camera:['Jiří Tarantík'],
cut:['Zdeněk Stehlík'],
sound:['František Strangmüller','Hanuš Silvera'],
scenography:['Zdeněk Rozkopal'],
masks:['Oldřich Mach','František Havlíček'],
costumes:['Karel Postřehovský']},
{title:'For a Few Dollars More',
titleCZ:'Pro pár dolarů navíc',
year:1965,
runtime:132,
countries:['Italy','Spain','Germany'],
genres:['Western'],
director:['Sergio Leone'],
actors:['Clint Eastwood','Lee Van Cleef','Gian Maria Volonté','Mario Brega','Luigi Pistilli','Aldo Sambrell','Klaus Kinski','Benito Stefanelli','Luis Rodríguez','Panos Papadopulos','Mara Krupp','Roberto Camardiel','Josef Egger','Tomás Blanco','Lorenzo Robledo','Sergio Mendizábal','Dante Maggio','Diana Rabito','Giovanni Tarallo','Mario Meniconi','Werner Abrolat','Román Ariznavarreta','Frank Braña','José Canalejas','Rosemary Dexter','Fernando Di Leo','Robert Dryden','Joyce Gordon','Jesús Guzmán','Peter Lee Lawrence','Sergio Leone','Rafael López','José Marco','Antonio Molino Rojo','Guillermo Méndez','Nazzareno Natale','Enrique Navarro','Ricardo Palacios','Antoñito Ruiz','Carlo Simi','José Terrón','Kurt Zips'],
screenplay:['Sergio Leone','Luciano Vincenzoni'],
production:['Alberto Grimaldi','Arturo González'],
music:['Ennio Morricone'],
camera:['Massimo Dallamano'],
cut:['Eugenio Alabiso','Giorgio Serrallonga'],
sound:['Oscar De Arcangelis'],
masks:['Juan Farsac']},
{title:'How to Train Your Dragon',
titleCZ:'Jak vycvičit draka',
year:2010,
runtime:94,
countries:['USA'],
genres:['Animation','Adventure','Fantasy','Comedy','Family'],
director:['Chris Sanders','Dean DeBlois'],
actors:['Jay Baruchel','Gerard Butler','Craig Ferguson','America Ferrera','Jonah Hill','Christopher Mintz-Plasse','T.J. Miller','Kristen Wiig','Robin Atkin Downes','Ashley Jensen','David Tennant','Kieron Elliott','Angela Bartys'],
basedOn:['Cressida Cowell'],
screenplay:['William Davies','Dean DeBlois','Chris Sanders'],
production:['Bonnie Arnold'],
music:['John Powell','Jo Blankenburg'],
cut:['Maryann Brandon'],
sound:['Randy Thom','Al Nelson','Gary Rizzo']},
{title:'Edge of Tomorrow',
titleCZ:'Na hraně zítřka',
year:2014,
runtime:108,
countries:['USA','Canada'],
genres:['Sci-Fi','Action','Adventure'],
director:['Doug Liman'],
actors:['Tom Cruise','Emily Blunt','Bill Paxton','Brendan Gleeson','Noah Taylor','Kick Gurry','Dragomir Mrsic','Charlotte Riley','Jonas Armstrong','Franz Drameh','Tony Way','Jeremy Piven','Lara Pulver','Marianne Jean-Baptiste','Lee Asquith-Coe','Madeleine Mantock','Jd Roth-round','Michael Vardian','Jim Sturgeon','Jozef Aoki','Elaine Caulfield','Bentley Kalu','Martin McDougall','Tommy Campbell','François Hollande','Harry Landis','Andrew Neil','Beth Goddard','Masayoshi Haneda','Ronan Summers','Matt Hookings','Pablo Verdejo','Daniel Stisen','Becky Wright','Kyla Frye','Rachel Handshaw','Liquid Thomas','Nick Donald'],
basedOn:['Hiroši Sakurazaka'],
screenplay:['Christopher McQuarrie','Jez Butterworth','John-Henry Butterworth'],
production:['Jeffrey Silver','Erwin Stoff','Gregory Jacobs'],
music:['Christophe Beck','Leo Birenberg'],
camera:['Dion Beebe'],
cut:['James Herbert','Laura Jennings'],
sound:['Dominic Gibbs','Mark Taylor'],
scenography:['Oliver Scholl','Mark Harris','Elli Griff','Gena Vazquez','Jason Knox-Johnston','Stephen Swain'],
masks:['Ailbhe Lemass','Sarah Monzani','Fran Needham','Jessica Brooks','Uxue Laguardia','Zoe Clare Brown'],
costumes:['Kate Hawley']},
{title:'The Game',
titleCZ:'Hra',
year:1997,
runtime:129,
countries:['USA'],
genres:['Drama','Mystery','Thriller'],
director:['David Fincher'],
actors:['Michael Douglas','Sean Penn','Deborah Kara Unger','James Rebhorn','Peter Donat','Carroll Baker','Armin Mueller-Stahl','Anna Katarina','John Aprea','Kimberly Russell','Tommy Flanagan','John Cassini','Harris Savides','Júdži Okumoto','Mark Boone Junior','Jack Kehoe','Linda Manz','Spike Jonze','Michael Massee','J. Anthony Pena','Elise Robins','Caroline Barclay','Trish Summerville','Elizabeth Dennehy','Christopher John Fields','Bob Stephenson','Harrison Young','Gerry Becker','Marc Siegler','George Maguire','Charles Martinet'],
screenplay:['Michael Ferris','John Brancato'],
production:['Steve Golin','Ceán Chaffin'],
music:['Howard Shore'],
camera:['Harris Savides'],
cut:['James Haygood'],
sound:['Richard Hymns','David Parker','Gary Rizzo','Ren Klyce','Michael Semanick'],
scenography:['Jeffrey Beecroft','Jackie Carr'],
costumes:['Michael Kaplan']},
{title:'Full Metal Jacket',
titleCZ:'Full Metal Jacket',
year:1987,
runtime:116,
countries:['UK','USA'],
genres:['Drama','War'],
director:['Stanley Kubrick'],
actors:['Matthew Modine','Adam Baldwin',"Vincent D'Onofrio",'R. Lee Ermey','Dorian Harewood','Arliss Howard','Kevyn Major Howard',"Ed O'Ross",'John Terry','Kieron Jecchinis','Bruce Boa','Kirk Taylor','Jon Stafford','Tim Colceri','Ian Tyler','Gary Landon Mills','Sal Lopez','Papillon Soo','Ngoc Le','Peter Edmund','Tan Hung Francione','Leanne Hong',"Marcus D'Amico",'Costas Dino Chimona','Gil Kopel','Keith Hodiak','Peter Merrill','Herbert Norville','Nguyen Hue Phong','Stanley Kubrick','David Palffy','Vivian Kubrick','Gary Meyer','Steve Hudson','Philip Bailey','Chris Maybach'],
basedOn:['Gustav Hasford'],
screenplay:['Stanley Kubrick','Michael Herr','Gustav Hasford'],
production:['Stanley Kubrick'],
music:['Vivian Kubrick'],
camera:['Douglas Milsome'],
cut:['Martin Hunter'],
scenography:['Anton Furst'],
costumes:['Keith Denny']},
{title:'The Help',
titleCZ:'Černobílý svět',
year:2011,
runtime:140,
countries:['USA','India','United Arab Emirates'],
genres:['Drama'],
director:['Tate Taylor'],
actors:['Emma Stone','Viola Davis','Bryce Dallas Howard','Octavia Spencer','Jessica Chastain',"Ahna O'Reilly",'Allison Janney','Anna Camp','Christopher Lowell','Cicely Tyson','Mike Vogel','Sissy Spacek','Brian Kerwin','Aunjanue Ellis-Taylor','Tarra Riggs','Leslie Jordan','Mary Steenburgen','Ashley Johnson','Nelsan Ellis','David Oyelowo','Dana Ivey','Wes Chatham','Shane McRae','Tiffany Brouwer','Carol Sutton','Ted Welch','LaChanze','Roslyn Ruff'],
basedOn:['Kathryn Stockett'],
screenplay:['Tate Taylor'],
production:['Brunson Green','Michael Barnathan','Chris Columbus'],
music:['Thomas Newman'],
camera:['Stephen Goldblatt'],
cut:['Hughes Winborne'],
sound:['David Giammarco','Scott Millan'],
scenography:['Mark Ricker','Rena DeAngelo'],
masks:['Camille Friend'],
costumes:['Sharen Davis']},
{title:'Kolya',
titleCZ:'Kolja',
year:1996,
runtime:105,
countries:['Czechia','UK','France'],
genres:['Comedy','Drama'],
director:['Jan Svěrák'],
actors:['Zdeněk Svěrák','Andrej Chalimon','Libuše Šafránková','Ondřej Vetchý','Stella Zázvorková','Ladislav Smoljak','Irina Bezrukova','Silvia Šuvadová','Lilian Malkina','Karel Heřmánek','Petra Špalková','Nela Boudová','René Přibil','Miroslav Táborský','Slávka Budínová','Jiří Sovák','Regina Rázlová','Josef Lakatoš','Lubomír Píša','František Xaver Thuri','Netta Deborská','Pavel Taussig','Marek Daniel','Věra Uzelacová','Miriam Chytilová','Otmar Brancuzský','Veronika Freimanová','Magda Křížková-Šebestová','Filip Renč','Pavel Vondruška','Hana Militká','Emma Černá','Eva Klepáčová','Lena Birková','Jan Kašpar','Jana Altmannová','Petr Šplíchal','Nikolaj Hejko','Rafael Kubelík','Luboš Bíža','Pavel Pecháček','Lída Rakušanová'],
screenplay:['Zdeněk Svěrák'],
production:['Jan Svěrák','Eric Abraham'],
music:['Ondřej Soukup'],
camera:['Vladimír Smutný'],
cut:['Alois Fišárek'],
sound:['Zbyněk Mikulík','Pavel Rejholec'],
scenography:['Miloš J. Kohout'],
masks:['František Příhoda'],
costumes:['Katarína Hollá']},
{title:'The Good Soldier Schweik',
titleCZ:'Dobrý voják Švejk',
year:1956,
runtime:105,
countries:['Czechoslovakia'],
genres:['Comedy','War'],
director:['Karel Steklý'],
actors:['Rudolf Hrušínský','Eva Svobodová','Josef Hlinomaz','František Filipovský','Miloš Kopecký','Svatopluk Beneš','Božena Havlíčková','Felix le Breux','Libuše Bokrová','Eman Fiala','Otto Hradecký','Olga Karásková','Bedřich Karen','Josef Kemr','František Kreuzmann st.','Alena Kreuzmannová','Vladimír Leraus','Jiří Lír','Fanda Mrázek','Miloš Nedbal','Stanislav Neumann','Václav Poláček','Vladimír Řepa','Jiřina Steimarová','Světla Svozilová','Josef Šidlichovský','Adolf Šmíd','Václav Trégl','Jaroslav Vojta','Bedřich Vrbský','Bohuš Záhorský','Josef Benátský','Kamil Bešťák','Josef Bláha','František Černý','Arnošt Faltýnek','Oldřich Hoblík','Miroslav Homola','Věra Koktová','Končel','Ladislav Krečmer','František Kubíček','Václav Kyzlink','Otto Lackovič','Stanislav Langer','Vladimír Majer','František Marek','Zdeněk Martínek','Milan Neděla','Miloš Patočka','Jan Petřík','Jaroslav Radimecký','Marcela Sedláčková','Jan Skopeček','Theodor Strejcius','Václav Švec','Míla Vojta','Richard Záhorský','Stella Zázvorková','Žák','Milka Balek-Brodská','Rudolf Deyl ml.','Antonín Jedlička','Jan Maška','Miloslav Homola','Karel Hovorka st.','Oskar Hák','Viktor Očásek','Marie Grossová','Antonín Lebeda','Bohuslav Kupšovský','Marie Nováková','Václav Wasserman','Antonín Soukup','Milan Mach','Milena Asmanová','Václav Vydra ml.','Karel Hlušička','Antonín Žďárský','Zdeněk Erben','Kajetán Maudr','Slávka Rosenbergová'],
basedOn:['Jaroslav Hašek'],
screenplay:['Karel Steklý'],
music:['Jan Seidel'],
camera:['Rudolf Stahl ml.'],
cut:['Miroslav Hájek'],
sound:['Miloslav Hůrka'],
scenography:['Boris Moravec'],
masks:['Karel Marek'],
costumes:['Josef Gabriel']},
{title:'Life of Brian',
titleCZ:'Život Briana',
year:1979,
runtime:94,
countries:['UK'],
genres:['Comedy'],
director:['Terry Jones'],
actors:['Graham Chapman','John Cleese','Terry Gilliam','Eric Idle','Terry Jones','Michael Palin','Terence Bayler','Carol Cleveland','Kenneth Colley','George Harrison','Spike Milligan','Chris Langham','Neil Innes','John Young','Charles Knode','Peter Brett','Gwen Taylor','Charles McKeown','Andrew MacLachlan'],
screenplay:['Graham Chapman','Terry Gilliam','Michael Palin','Terry Jones','John Cleese','Eric Idle'],
production:['John Goldstone'],
music:['Geoffrey Burgon'],
camera:['Peter Biziou'],
scenography:['Roger Christian'],
masks:['Maggie Weston'],
costumes:['Charles Knode','Hazel Pethig']},
{title:'Apocalypse Now',
titleCZ:'Apokalypsa',
year:1979,
runtime:147,
countries:['USA'],
genres:['War','Drama'],
director:['Francis Ford Coppola'],
actors:['Martin Sheen','Marlon Brando','Robert Duvall','Frederic Forrest','Sam Bottoms','Laurence Fishburne','Albert Hall','Harrison Ford','Dennis Hopper','G. D. Spradlin','Scott Glenn','James Keane','Tom Mason','Colleen Camp','Jack Thibeau','Christian Marquand','Aurore Clément','Frank Villard','Roman Coppola','Don Gordon Bell','Francis Ford Coppola','R. Lee Ermey','Jim Gaines','Evan A. Lottman','Nick Nicholson','Charles Robinson','Charlie Sheen','Vittorio Storaro','Henry Strzalkowski','Bill Graham','Damien Leake','Marc Coppola','Kerry Rossall'],
basedOn:['Joseph Conrad'],
screenplay:['John Milius','Francis Ford Coppola'],
production:['Francis Ford Coppola'],
music:['Carmine Coppola','Francis Ford Coppola'],
camera:['Vittorio Storaro'],
cut:['Walter Murch','Gerald B. Greenberg','Lisa Fruchtman'],
sound:['Pete Horner'],
scenography:['Dean Tavoularis','George R. Nelson']},
{title:'The Bridge on the River Kwai',
titleCZ:'Most přes řeku Kwai',
year:1957,
runtime:161,
countries:['UK','USA'],
genres:['Adventure','Drama','War'],
director:['David Lean'],
actors:['William Holden','Alec Guinness','Jack Hawkins','Sessue Hajakawa','James Donald','Geoffrey Horne','André Morell','Percy Herbert','Harold Goodwin','John Boxer','Ann Sears','Peter Williams'],
basedOn:['Pierre Boulle'],
screenplay:['Carl Foreman','Michael Wilson'],
production:['Sam Spiegel'],
music:['Malcolm Arnold'],
camera:['Jack Hildyard'],
cut:['Peter Taylor'],
masks:['Stuart Freeborn']},
{title:'The Elephant Man',
titleCZ:'Sloní muž',
year:1980,
runtime:124,
countries:['USA','UK'],
genres:['Drama','Biographic'],
director:['David Lynch'],
actors:['Anthony Hopkins','John Hurt','Anne Bancroft','John Gielgud','Wendy Hiller','Freddie Jones','Hannah Gordon','Michael Elphick','John Standing','Dexter Fletcher','Lesley Dunlop','Kathleen Byron','Patricia Hodge','Pauline Quirke','Kenny Baker','William Morgan Sheppard','David Ryall','Pat Gorman','Eric Bergren','Christopher De Vore','Phoebe Nicholls','Helen Ryan','Claire Davenport','Hugh Manning','Gerald Case','Patsy Smart','Roy Evans','Fanny Carby','Fred Wood','Harry Fielder','Frederick Trevers','Lesley Scoble','Bernadette Milnes','Ian Selby','George Holdcroft','Michele Amas','Jill Goldston'],
basedOn:['Frederick Treves'],
screenplay:['David Lynch','Christopher De Vore','Eric Bergren'],
production:['Jonathan Sanger'],
music:['John Morris'],
camera:['Freddie Francis'],
cut:['Anne V. Coates'],
scenography:['Stuart Craig'],
masks:['Christopher Tucker','Wally Schneiderman'],
costumes:['Patricia Norris']},
{title:"Carlito's Way",
titleCZ:'Carlitova cesta',
year:1993,
runtime:144,
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Brian De Palma'],
actors:['Al Pacino','Sean Penn','Penelope Ann Miller','John Leguizamo','Ingrid Rogers','Luis Guzmán','James Rebhorn','Joseph Siravo','Viggo Mortensen','Adrian Pasdar','Paul Mazursky','Jon Seda','Rocco Sisto','Brian Tarantina','Jamie Tirelli','Vincent Pastore','Marc Anthony','John Ortiz','John Finn','Rick Aviles','Al Israel','Dan Brennan','Orlando Urdaneta','Chuck Zito','Elliot Santiago','Jorge Porcel','Richard Foronjy','Gene Canfield','Jaime Sánchez','Michael P. Moran','Rene Rivera','Daniel Margotta','Dean Rader-Duval','Bo Dietl','Mel Gorham','Saundra Santiago','Cynthia LaMontagne','Antone Pagán','Ángel Salazar','Nelson Vasquez','Caesar Cordova','John Michael Bolger'],
basedOn:['Edwin Torres'],
screenplay:['David Koepp'],
production:['Martin Bregman'],
music:['Patrick Doyle'],
camera:['Stephen H. Burum'],
cut:['Kristina Boden','Bill Pankow'],
sound:['Lee Dichter','Maurice Schell'],
scenography:['Richard Sylbert'],
costumes:['Aude Bronson-Howard']},
{title:'Finding Nemo',
titleCZ:'Hledá se Nemo',
year:2003,
runtime:100,
countries:['Australia','USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Andrew Stanton','Lee Unkrich'],
actors:['Albert Brooks','Ellen DeGeneres','Alexander Gould','Willem Dafoe','Brad Garrett','Allison Janney','Austin Pendleton','Geoffrey Rush','Andrew Stanton','Elizabeth Perkins','Bob Peterson','Eric Bana','Bruce Spence','Bill Hunter','Erik Per Sullivan','Joe Ranft','Laura Marano','Stephen Root','Barry Humphries','John Ratzenberger','Vicki Lewis'],
screenplay:['Andrew Stanton','Bob Peterson','David Reynolds'],
music:['Thomas Newman'],
camera:['Jericca Cleland','Jeremy Lasky'],
cut:['David Ian Salter'],
sound:['Gary Summers','Gary Rydstrom']},
{title:'Back to the Future Part II',
titleCZ:'Návrat do budoucnosti II',
year:1989,
runtime:108,
countries:['USA'],
genres:['Adventure','Comedy','Sci-Fi','Action'],
director:['Robert Zemeckis'],
actors:['Michael J. Fox','Christopher Lloyd','Lea Thompson','Tom Wilson','Elisabeth Shue','James Tolkan','Jeffrey Weissman','Casey Siemaszko','Billy Zane','J.J. Cohen','Charles Fleischer','Darlene Vogel','Jason Scott Lee','Elijah Wood','Flea','Tracy Dali','Joe Flaherty','Mary Ellen Trainor','Al White','Lisa Freeman',"George 'Buck' Flower",'Ricky Dean Logan','Wesley Mann','Jim Ishida','Donald Fullilove','John Erwin','Neil Ross','Charles Gherardi'],
screenplay:['Bob Gale'],
production:['Neil Canton','Bob Gale'],
music:['Alan Silvestri'],
camera:['Dean Cundey'],
cut:['Arthur Schmidt','Harry Keramidas'],
sound:['Joel Fein','Rick Alexander'],
scenography:['Rick Carter'],
masks:['Ken Chase','Allen Payne'],
costumes:['Joanna Johnston']},
{title:'Prisoners',
titleCZ:'Zmizení',
year:2013,
runtime:153,
countries:['USA'],
genres:['Thriller','Mystery','Crime','Drama','Psychology'],
director:['Denis Villeneuve'],
actors:['Hugh Jackman','Jake Gyllenhaal','Viola Davis','Maria Bello','Terrence Howard','Melissa Leo','Paul Dano','Dylan Minnette','Zoë Soul','Erin Gerasimovich','Kyla-Drew','Wayne Duvall','Len Cariou','David Dastmalchian','Brad James','Anthony Reynolds','Robert C. Treveiler','Sandra Ellis Lafferty','Victoria Staley','Todd Truley','Jeff Pope','Lana Yoo','J. Omar Castro','Jane McNeill','Dennis Christopher','Jason Davis','Katrina Despain','Faith Dillon','Andrew Fincher','Mike Gassaway','Kevin L. Johnson','Tiffany Morgan','Brody Rose','Josh Turner'],
screenplay:['Aaron Guzikowski'],
production:['Broderick Johnson','Andrew A. Kosove','Adam Kolbrenner'],
music:['Jóhann Jóhannsson'],
camera:['Roger Deakins'],
cut:['Joel Cox','Gary D. Roach'],
sound:['Tom Ozanich','Alan Robert Murray','John T. Reitz','Gregg Rudloff'],
scenography:['Patrice Vermette','Frank Galline'],
masks:['Donald Mowat','Taylor Knight'],
costumes:['Renée April']},
{title:'Reservoir Dogs',
titleCZ:'Gauneři',
year:1992,
runtime:99,
countries:['USA'],
genres:['Crime','Thriller'],
director:['Quentin Tarantino'],
actors:['Harvey Keitel','Tim Roth','Michael Madsen','Chris Penn','Steve Buscemi','Lawrence Tierney','Randy Brooks','Kirk Baltz','Edward Bunker','Quentin Tarantino','David Steen','Robert Ruth','Lawrence Bender','Steven Wright','Laurie Lathem','Burr Steers','Craig Hamann'],
screenplay:['Quentin Tarantino'],
production:['Lawrence Bender'],
camera:['Andrzej Sekula'],
cut:['Sally Menke'],
sound:['Stephen Hunter Flick','Ron Bartlett'],
scenography:['David Wasco','Sandy Reynolds-Wasco'],
masks:['Howard Berger'],
costumes:['Betsy Heimann','Mary Claire Hannan']},
{title:'Pink Floyd: The Wall',
titleCZ:'Pink Floyd: The Wall',
year:1982,
runtime:95,
countries:['UK'],
genres:['Drama','Music','Musical','Animation','Fantasy'],
director:['Alan Parker'],
actors:['Bob Geldof','Bob Hoskins','Joanne Whalley','Kevin McKeon','Phil Davis','Roger Waters','Jenny Wright','Alex McAvoy','Nell Campbell','Eddie Tagoe','Vincent Wong','Michael Ensign','Gary Olsen','Malcolm Rogers','Albert Moses','Diana King','Eleanor David','Margery Mason','Brenda Cowling','Christine Hargreaves','Harry Fielder','Peter Jonfield','John Scott Martin','James Laurenson','Ray Mort'],
screenplay:['Roger Waters'],
production:['Alan Marshall'],
music:['Roger Waters'],
camera:['Peter Biziou'],
cut:['Gerry Hambling'],
sound:['Eddy Joseph'],
scenography:['Brian Morris'],
masks:['Paul Engelen','Martin Samuel'],
costumes:['Penny Rose']},
{title:"Singin' in the Rain",
titleCZ:'Zpívání v dešti',
year:1952,
runtime:103,
countries:['USA'],
genres:['Musical','Romance','Comedy'],
director:['Stanley Donen','Gene Kelly'],
actors:['Gene Kelly',"Donald O'Connor",'Debbie Reynolds','Jean Hagen','Cyd Charisse','Douglas Fowley','Millard Mitchell','Rita Moreno','Mae Clarke','Bobby Watson','Lance Fuller','Kathleen Freeman','Elaine Stewart','Dawn Addams','Pat Conway','Robert Fortier','Joi Lansing','William Schallert','Bess Flowers','Mike Lally','Kenner G. Kemp','Forbes Murray',"Harry 'Snub' Pollard",'Robert Williams','Frank Hyers','Harry Tenbrook','Gail Bonney','Chet Brandenburg','Robert Foulk','Brick Sullivan','Joseph Mell','Cosmo Sardo','Phil Schumacher','Paul Maxey','Jack Hendricks','Chalky Williams','Dorothy Patrick','King Donovan','John George','Morgan Jones','Beatrice Gray','Mickey Golden','William F. Leicester','Kay Deslys','Margaret Bert','Jack George','Allen Pinson','Helen Eby-Rock','Julius Tannen','Tommy Farrell','John Dodsworth','Carl Milletaire','Lars Hensen','Leon Lontoc','Richard Emory','Philo McCullough','Lana Turner','George Ford','Timmy Hawkins','Phil Dunham','Bert Davidson','Wilson Wood','Jimmy Bates','Ann McCrea','Diki Lerner','Madge Blake','David Sharpe','Shirley Jean Rickert','Gloria Dea'],
screenplay:['Betty Comden','Adolph Green'],
production:['Arthur Freed'],
music:['Lennie Hayton'],
camera:['Harold Rosson'],
cut:['Adrienne Fazan'],
sound:['Douglas Shearer','Bill Edmondson'],
scenography:['Cedric Gibbons','Edwin B. Willis'],
masks:['John Truwe','William Tuttle','Ben Lane'],
costumes:['Walter Plunkett']},
{title:'The Kid',
titleCZ:'Kid',
year:1921,
runtime:68,
countries:['USA'],
genres:['Comedy','Drama','Family'],
director:['Charlie Chaplin'],
actors:['Charlie Chaplin','Edna Purviance','Jackie Coogan','Henry Bergman','Charles Reisner','Lita Grey','Albert Austin','Esther Ralston','Carl Miller','Beulah Bains','Nellie Bly Baker','Kitty Bradbury','Edgar Sherrod','Edward Biby','Tom Wilson','S.D. Wilcox','Granville Redmond'],
screenplay:['Charlie Chaplin'],
production:['Charlie Chaplin'],
music:['Charlie Chaplin'],
camera:['Roland Totheroh'],
cut:['Charlie Chaplin'],
scenography:['Charles D. Hall']},
{title:'The Departed',
titleCZ:'Skrytá identita',
year:2006,
runtime:151,
countries:['USA','Hong Kong'],
genres:['Drama','Crime','Thriller'],
director:['Martin Scorsese'],
actors:['Leonardo DiCaprio','Matt Damon','Jack Nicholson','Mark Wahlberg','Martin Sheen','Ray Winstone','Vera Farmiga','Anthony Anderson','Alec Baldwin','Kevin Corrigan','James Badge Dale',"David O'Hara",'Mark Rolston','Robert Wahlberg','Kristen Dalton','Thomas B. Duffy','J.C. MacKenzie','Gurdeep Singh','Armen Garo','John Cenatiempo','Larry Mitchell','Tracey Paleo','Dorothy Lyman','Audrie Neenan','Conor Donovan','Amanda Lynch','Sallie Toussaint','Nellie Sciutto','Henry Yuk','Dennis Lynch','Michael Byron','John Rue','Joseph P. Reidy','Brian Haley','Terry Serpico','Jay Giannone','Jill Brown','Johnny Cicco','Chance Kelly','Shay Duffin','John McConnell','Mark Philip Patrick','Francesca Scorsese','Emma Tillinger Koskoff','Craig Castaldo','James P. Anderson','Brendan Burke','Jeffrey Corazzini','Buddy Dolan','Oliver Martin','Adam Masnyk','Robert Myers','Billy Silvia','Joseph Riccobene','Billy Smith'],
screenplay:['William Monahan','Felix Chong','Alan Mak'],
production:['Graham King','Brad Pitt','Gianni Nunnari','Brad Grey'],
music:['Howard Shore'],
camera:['Michael Ballhaus'],
cut:['Thelma Schoonmaker'],
sound:['Tom Fleischman'],
scenography:['Kristi Zea'],
masks:['John Caglione','Jr.','Michael Germain','Donald Mowat','Kay Georgiou','Jerry DeCarlo'],
costumes:['Sandy Powell']},
{title:'The Gentlemen',
titleCZ:'Gentlemani',
year:2019,
runtime:113,
countries:['UK','USA'],
genres:['Action','Comedy','Crime'],
director:['Guy Ritchie'],
actors:['Matthew McConaughey','Charlie Hunnam','Michelle Dockery','Colin Farrell','Henry Golding','Hugh Grant','Jeremy Strong','Eddie Marsan','Lyne Renee','Tom Wu','Jason Wong','Eliot Sumner','John Dagleish','Lily Frazer','Gershwyn Eustache Jnr','Samuel West','Geraldine Somerville','Franz Drameh','James Warren','Sean Sagar','Tom Rhys Harries','Max Bennett','Eugenia Kuzmina','George Asprey','McKell David','Togo Igawa','David Garrick','Andrew Greenough','Brittany Ashworth','Ashley McGuire','Bugzy Malone','Danny Griffin','Jordan Long','Jason Lines','Oleg Hill'],
screenplay:['Guy Ritchie'],
production:['Guy Ritchie','Ivan Atkinson','Bill Block'],
music:['Christopher Benstead'],
camera:['Alan Stewart'],
cut:['James Herbert'],
sound:['Michael Prestwood Smith'],
scenography:['Gemma Jackson'],
masks:['Christine Blundell','Lesa Warrener'],
costumes:['Michael Wilkinson']},
{title:'Dead Poets Society',
titleCZ:'Společnost mrtvých básníků',
year:1989,
runtime:128,
countries:['USA'],
genres:['Drama'],
director:['Peter Weir'],
actors:['Robin Williams','Robert Sean Leonard','Ethan Hawke','Josh Charles','Gale Hansen','Dylan Kussman','Allelon Ruggiero','James Waterston','Norman Lloyd','Kurtwood Smith','George Martin','Kevin Cooney','Melora Walters','John Cunningham','Keith Snyder','Jamie Kennedy','Alexandra Powers','Debra Mooney','Matt Carey','James J. Christy','Welker White','Alan Pottinger','Jeffrey Santoro'],
screenplay:['Tom Schulman'],
production:['Paul Junger Witt','Tony Thomas','Steven Haft'],
music:['Maurice Jarre'],
camera:['John Seale'],
cut:['William M. Anderson'],
sound:['Carlos Delarios'],
scenography:['Wendy Stites'],
masks:['Susan A. Cabral','Dee Manges']},
{title:'Ratatouille',
titleCZ:'Ratatouille',
year:2007,
runtime:111,
countries:['USA'],
genres:['Animation','Comedy','Family','Fantasy'],
director:['Brad Bird','Jan Pinkava'],
actors:['Patton Oswalt','Ian Holm','Lou Romano','Brian Dennehy','Peter Sohn',"Peter O'Toole",'Brad Garrett','Janeane Garofalo','Will Arnett','James Remar','Teddy Newton','Brad Bird','Bradford Lewis','John Ratzenberger','Tony Fucile','Lindsey Collins','Jake Steinfeld'],
screenplay:['Brad Bird'],
production:['Bradford Lewis'],
music:['Michael Giacchino'],
sound:['Randy Thom','Michael Semanick'],
scenography:['Harley Jessup']},
{title:'Clockers',
titleCZ:'Obck se smrtí',
year:1995,
runtime:128,
countries:['USA'],
genres:['Drama','Crime'],
director:['Spike Lee'],
actors:['Harvey Keitel','John Turturro','Delroy Lindo','Mekhi Phifer','Isaiah Washington','Keith David','Peewee Love','Regina Taylor','Thomas Jefferson Byrd','Sticky Fingaz','Fredro Starr','Hassan Johnson','Michael Imperioli','Lisa Arrindell','Paul Calderon','Brendan Kelly','Mike Starr','Spike Lee','Shawn McLean','Arthur J. Nascarella','Harry Lennix','Paul Schulze','Michael Badalucco','David Batiste','Skipp Sudduth','J.C. MacKenzie','Ron Brice','Christopher Wynkoop','Frances Foster','Michael Cullen','Steve White','Lawrence B. Adisa','Rick Aiello','Norman Matlock','Tim Kelleher','Kateřina Peřinová','Maurice Sneed','Michael McGruther'],
basedOn:['Richard Price'],
screenplay:['Richard Price','Spike Lee'],
production:['Jon Kilik','Martin Scorsese','Spike Lee'],
music:['Terence Blanchard'],
camera:['Sayeed Malik Hassan'],
cut:['Sam Pollard'],
sound:['Tom Fleischman','Skip Lievsay','Tod A. Maitland'],
scenography:['Andrew McAlpine'],
masks:['Larry M. Cherry'],
costumes:['Ruth E. Carter']},
{title:"The King's Speech",
titleCZ:'Králova řeč',
year:2010,
runtime:118,
countries:['UK','USA','Australia'],
genres:['Drama','Biographic'],
director:['Tom Hooper'],
actors:['Colin Firth','Helena Bonham Carter','Derek Jacobi','Geoffrey Rush','Richard Dixon','Jennifer Ehle','Ramona Marquez','David Bamber','Michael Gambon','Guy Pearce','Simon Chandler','Claire Bloom','Eve Best','Timothy Spall','Anthony Andrews','Patrick Ryecart','Teresa Gallagher','Adrian Scarborough','Freya Wilson','Tim Downie','Adolf Hitler','Roger Hammond','Jake Hathaway','Andrew Havill','Graham Curry','Mary Robinson','Dominic Applewhite','Robert Portal','Filippo Delaunay'],
screenplay:['David Seidler'],
production:['Gareth Unwin','Iain Canning','Emile Sherman'],
music:['Alexandre Desplat'],
camera:['Danny Cohen'],
cut:['Tariq Anwar'],
sound:['Martin Jensen'],
scenography:['Eve Stewart','Judy Farr'],
masks:['Frances Hannon','Paul Gooch'],
costumes:['Jenny Beavan']},
{title:'The Snowdrop Festival',
titleCZ:'Slavnosti sněženek',
year:1983,
runtime:83,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Jiří Menzel'],
actors:['Rudolf Hrušínský','Jaromír Hanzlík','Josef Somr','Petr Čepek','Miloslav Štibich','Petr Brukner','Rudolf Hrušínský ml.','Eugen Jegorov','Bořík Procházka','Jiří Schmitzer','Marie Spurná','Blažena Holišová','Blanka Lormanová','Jiří Krejčík','František Vláčil','Ferdinand Havlík','Jaroslav Vozáb','Zdeněk Svěrák','František Řehák','Libuše Šafránková','Zdena Hadrbolcová','Zora Jiráková','Johanna Tesařová','Pavel Vondruška','Ladislav Křiváček','Miroslav Kořínek','Jaroslav Klenot','Zdeněk Srstka','Jiří Kasík','Jaroslav Vlk','Bohumil Hrabal','Milada Štýbrová','Jaroslav Tomsa','Josef Abrhám'],
basedOn:['Bohumil Hrabal'],
screenplay:['Bohumil Hrabal','Jiří Menzel'],
music:['Jiří Šust'],
camera:['Jiří Macák'],
cut:['Jiří Brožek'],
sound:['Karel Jaroš'],
scenography:['Zbyněk Hloch'],
masks:['Tomáš Kuchta','Šárka Šimůnková','Pavel Minichbauer'],
costumes:['Běla Suchá','Zuzana Máchová']},
{title:'The Troops of St. Tropez',
titleCZ:'Četník ze Saint Tropez',
year:1964,
runtime:95,
countries:['France','Italy'],
genres:['Comedy','Crime'],
director:['Jean Girault'],
actors:['Louis de Funès','Geneviève Grad','Michel Galabru','Daniel Cauchy','Madeleine Delavaivre','Maria Pacôme','Claude Piéplu','Gabriele Tinti','Michèle Wargnier','Christian Marin','Jean Lefebvre','Jean-Pierre Bertrand','Sylvie Bréal','Martine de Breteuil','Evelyne Céry','Jean Droze','Norma Dugo','Jacques Famery','Patrice Laffont','Guy Grosso','Maurice Jacquin','Claudia Lebail','Michel Modo','Giuseppe Porelli','Nicole Vervil','Franck Vilcour','Fernand Sardou','France Rumilly','Henri Arius','André Badin','Pierre Barouh','Paul Bisciglia','Sacha Briquet','Jean Panisse','Louis Massis'],
screenplay:['Jacques Vilfrid','Jean Girault'],
production:['René Pignières','Gérard Beytout'],
music:['Raymond Lefevre'],
camera:['Marc Fossard'],
cut:['Jean-Michel Gautier','Jean Feyte'],
sound:['Jacques Gallois'],
scenography:['Sydney Bettex'],
masks:['Anatole Paris']},
{title:'Avengers: Infinity War',
titleCZ:'Avengers: Infinity War',
year:2018,
runtime:149,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Anthony Russo','Joe Russo'],
actors:['Robert Downey Jr.','Chris Hemsworth','Mark Ruffalo','Chris Evans','Scarlett Johansson','Don Cheadle','Benedict Cumberbatch','Tom Holland','Chadwick Boseman','Zoe Saldana','Karen Gillan','Tom Hiddleston','Paul Bettany','Elizabeth Olsen','Anthony Mackie','Sebastian Stan','Idris Elba','Danai Gurira','Peter Dinklage','Benedict Wong','Pom Klementieff','Dave Bautista','Vin Diesel','Bradley Cooper','Gwyneth Paltrow','Benicio Del Toro','Josh Brolin','Chris Pratt','Sean Gunn','William Hurt','Letitia Wright','Terry Notary','Tom Vaughan-Lawlor','Carrie Coon','Michael James Shaw','Winston Duke','Florence Kasumba','Kerry Condon','Monique Ganderton','Jacob Batalon','Tiffany Espensen','Isabella Amara','Stephen McFeely','Aaron Lazar','Robert Pralgo','Matthew Zuk','Samuel L. Jackson','Stan Lee','Cobie Smulders','Ross Marquand','Ariana Greenblatt','Harrison Osterfield','Robert Tinsley','Ameenah Kaplan','Marcus Lewis','Ethan Dizon','Marija Juliette Abney','Sergio Briones'],
basedOn:['Stan Lee','Jack Kirby','Don Heck'],
screenplay:['Christopher Markus','Stephen McFeely'],
production:['Kevin Feige'],
music:['Alan Silvestri'],
camera:['Trent Opaloch'],
cut:['Jeffrey Ford','Matthew Schmidt'],
sound:['Juan Peralta','Daniel Laurie','Shannon Mills','Tom Johnson'],
scenography:['Charles Wood','Ray Chan'],
masks:['Benji Dove','Alexei Dmitiew','John Blake','Brian Sipe','Dennis Liddiard','Donald McInnes','Louisa V. Anthony','Vivian Baker','Matteo Silvi','Christopher Allen Nelson'],
costumes:['Judianna Makovsky']},
{title:'K-PAX',
titleCZ:'Svět podle Prota',
year:2001,
runtime:120,
countries:['USA','Germany'],
genres:['Drama','Sci-Fi'],
director:['Iain Softley'],
actors:['Kevin Spacey','Jeff Bridges','Mary McCormack','Alfre Woodard','David Patrick Kelly','Saul Williams','Peter Gerety','Celia Weston','Ajay Naidu','Tracy Vilar','Kimberly Scott','Conchata Ferrell','Vincent Laresca','Brian Howe','Rawle D. Lewis','Julie Sands','Aaron Paul','William Lucking','Kateri Walker','Frank Collison','Mark Christopher Lawrence','Clarke Peters','Norman Alden','Erik LaRay Harvey','Lance E. Nichols','Mary Mara','Peter Maloney','Paul Linke','Olga Merediz','John Toles-Bey','Greg Lewis','Anne Carroll','Clebert Ford','Joe Holt','Scott Lincoln'],
basedOn:['Gene Brewer'],
screenplay:['Charles Leavitt'],
production:['Lawrence Gordon','Robert F. Colesberry','Lloyd Levin'],
music:['Edward Shearmur'],
camera:['John Mathieson'],
cut:['Craig McKay'],
sound:['Frank A. Montaño','Mark Weingarten'],
scenography:['John Beard'],
masks:['Edouard F. Henriques','Martin Samuel','Susan A. Cabral'],
costumes:['Louise Mingenbach']},
{title:'Harry Potter and the Prisoner of Azkaban',
titleCZ:'Harry Potter a vězeň z Azkabanu',
year:2004,
runtime:141,
countries:['UK','USA'],
genres:['Fantasy','Family','Adventure','Mystery'],
director:['Alfonso Cuarón'],
actors:['Daniel Radcliffe','Rupert Grint','Emma Watson','Pam Ferris','Emma Thompson','Tom Felton','Geraldine Somerville','Lenny Henry','Matthew Lewis','James Phelps','Oliver Phelps','Mark Williams','Robbie Coltrane','Julie Walters','David Thewlis','Maggie Smith','Alan Rickman','Gary Oldman','Michael Gambon','Miriam Margolyes','Dawn French','Julie Christie','Timothy Spall','Warwick Davis','Robert Hardy','Richard Griffiths','Fiona Shaw','Harry Melling','Bonnie Wright','Lee Ingleby','Bronson Webb','David Bradley','Adrian Rawlins','Jamie Waylett','Chris Rankin','Devon Murray','Josh Herdman','Alfred Enoch','Jim Tavaré','Genevieve Gaunt','Paul Whitehouse','Jimmy Gardner','Danielle Tabor','Violet Columbus','Kelsey Parker'],
basedOn:['J. K. Rowling'],
screenplay:['Steve Kloves'],
production:['Chris Columbus','David Heyman','Mark Radcliffe'],
music:['John Williams'],
camera:['Michael Seresin'],
cut:['Steven Weisberg'],
sound:['David Evans','Richard Beggs','Michael Prestwood Smith','Michael Semanick'],
scenography:['Stuart Craig','Andrew Ackland-Snow','Stephenie McMillan'],
masks:['Nick Dudman','Amanda Knight','Zoe Tahir'],
costumes:['Jany Temime']},
{title:'Love Actually',
titleCZ:'Láska nebeská',
year:2003,
runtime:135,
countries:['UK','USA','France'],
genres:['Comedy','Drama','Romance'],
director:['Richard Curtis'],
actors:['Bill Nighy','Gregor Fisher','Colin Firth','Sienna Guillory','Liam Neeson','Emma Thompson','Kris Marshall','Heike Makatsch','Martin Freeman','Joanna Page','Chiwetel Ejiofor','Andrew Lincoln','Keira Knightley','Hugh Grant','Nina Sosanya','Frank Moorey','Martine McCutcheon','Laura Linney','Dan Fredenburgh','Julia Davis','Abdul Salis','Edward Hardwicke','Caroline John','Thomas Brodie-Sangster','Alan Rickman','Rodrigo Santoro','Richard Hawley','Gillian Barge','Richard Cotton','Anthony McPartlin','Declan Donnelly','Elisabeth Margoni','Lúcia Moniz','Billy Bob Thornton','Peter Marinker','Meg Wynn Owen','Meredith Ostrom','Michael Fitzgerald','Rowan Atkinson','John Sharian','Glenn Conroy','Ivana Milicevic','January Jones','Elisha Cuthbert','Margery Mason','Joanna Bacon','Bill Moody','Billy Campbell','Adam Godley','Olivia Olson','Arturo Venegas','Claudia Schiffer','Helder Costa','Carla Vasconcelos','Shannon Elizabeth','Denise Richards','Richard Curtis','Rebecca Frayn'],
screenplay:['Richard Curtis'],
production:['Duncan Kenworthy','Tim Bevan','Eric Fellner'],
music:['Craig Armstrong'],
camera:['Michael Coulter'],
cut:['Nick Moore'],
sound:['Glenn Freemantle'],
scenography:['Jim Clay'],
masks:['Nora Robertson','Graham Johnston'],
costumes:['Joanna Johnston']},
{title:'The Rock',
titleCZ:'Skála',
year:1996,
runtime:136,
countries:['USA'],
genres:['Action','Thriller','Adventure'],
director:['Michael Bay'],
actors:['Sean Connery','Nicolas Cage','Ed Harris','John Spencer','David Morse','William Forsythe','Michael Biehn','Vanessa Marcil','John C. McGinley','Gregory Sporleder','Tony Todd','Bokeem Woodbine','Jim Maniaci','Brendan Kelly','Steve Harris','Danny Nucci','Claire Forlani','Todd Louiso','Anthony Clark','Stuart Wilson','Philip Baker Hall','David Marshall Grant','Xander Berkeley','Stanley Anderson','James Caviezel','Tom Towles','John Enos III','Raymond Cruz','Luenell','Buck Kartalian','David Bowe','Marshall R. Teague','Dwight Hicks','Willie Garson','Greg Collins','Matthew James Gulbranson','John Laughlin','Joseph Patrick Kelly','Sam Whipple','Howard Platt','Pat Skipper','Ralph Peduto','Michael Rose',"Raymond O'Connor",'Sean Skelton','Anthony Snow','Jack Yates'],
screenplay:['David Weisberg','Douglas Cook','Mark Rosner'],
production:['Jerry Bruckheimer','Don Simpson','Sean Connery'],
music:['Nick Glennie-Smith','Hans Zimmer','Harry Gregson-Williams'],
camera:['John Schwartzman'],
cut:['Richard Francis-Bruce'],
sound:["Kevin O'Connell",'Christopher Boyes','Greg P. Russell','Keith A. Wester'],
scenography:['Michael White','Rosemary Brandenburg'],
masks:['Peter Robb-King','Tony Gardner','Yolanda Toussieng'],
costumes:['Bobbie Read']},
{title:'The Good Soldier Schweik 2: Beg to Report, Sir',
titleCZ:'Poslušně hlásím',
year:1957,
runtime:91,
countries:['Czechoslovakia'],
genres:['Comedy','War'],
director:['Karel Steklý'],
actors:['Rudolf Hrušínský','Svatopluk Beneš','Miloš Nedbal','Jaroslav Marvan','Fanda Mrázek','Jaroslav Vojta','Alois Dvorský','Jana Kovaříková','František Černý','František Šlégr','Otto Hradecký','František Filipovský','Jarka Pižla','Vladimír Řepa','Arna Pekárková','Miloš Patočka','Vlastimil Brodský','Josef Bartůněk','Václav Trégl','Miloš Nesvadba','Josef Hlinomaz','Milan Neděla','Eman Fiala','Miloslav Homola','Martin Růžek','Ota Sklenčka','Bedřich Vrbský','František Vnouček','Antonín Šůra','Věra Ferbasová','Jiřina Steimarová','Rudolf Princ','Ljuba Hermanová','Jarmila Švabíková','Josef Příhoda','Jan Skopeček','Ladislav Krečmer','Milan Mach','Jindřich Narenta','Zdeněk Kutil','Oldřich Dvorský','František Marek','Stanislav Langer','Zdeněk Martínek','Oskar Hák','Karel Svoboda','Slávka Hamouzová'],
basedOn:['Jaroslav Hašek'],
screenplay:['Karel Steklý'],
music:['Jan Seidel'],
camera:['Jan Roth'],
cut:['Miroslav Hájek'],
sound:['Josef Zora'],
scenography:['Bohumil Pokorný'],
masks:['Karel Marek'],
costumes:['Josef Gabriel']},
{title:'Rear Window',
titleCZ:'Okno do dvora',
year:1954,
runtime:112,
countries:['USA'],
genres:['Mystery','Thriller'],
director:['Alfred Hitchcock'],
actors:['James Stewart','Grace Kelly','Wendell Corey','Thelma Ritter','Raymond Burr','Judith Evelyn','Ross Bagdasarian','Georgine Darcy','Frank Cady','Jesslyn Fax','Rand Harper','Irene Winston','Havis Davenport','Sue Casey','Marla English','Bess Flowers','Fred Graham','Kathryn Grant','Len Hendry','Alfred Hitchcock','Anthony Warde','Gig Young','Dick Simmons','Art Gilmore','Benny Bartlett','Jack Stoney','Eddie Parker','Harry Landers','Nick Borgani','Ralph Smiley','Mike Mahoney'],
basedOn:['Cornell Woolrich'],
screenplay:['John Michael Hayes'],
production:['Alfred Hitchcock'],
music:['Franz Waxman'],
camera:['Robert Burks'],
cut:['George Tomasini'],
sound:['John Cope','Harry Lindgren','Loren L. Ryder'],
scenography:['Hal Pereira','Ray Moyer','Sam Comer'],
masks:['Wally Westmore'],
costumes:['Edith Head']},
{title:'The Dictator',
titleCZ:'Diktátor',
year:2012,
runtime:80,
countries:['USA'],
genres:['Comedy'],
director:['Larry Charles'],
actors:['Sacha Baron Cohen','Aasif Mandvi','Anna Faris','Adeel Akhtar','Horatio Sanz','Ben Kingsley','Megan Fox','B. J. Novak','John C. Reilly','Kevin Corrigan','Jason Mantzoukas','Ajay Naidu','Fred Melamed','Bobby Lee','Olivia Dudley','Marcia DeBonis','Edward Norton','Jessica St. Clair','Kathryn Hahn','Mousa Kraish','Garry Shandling','Ivan Cardona','J.B. Smoove','Olek Krupa','Karl Jacob','Hillary Clinton','Jon Glaser','Rizwan Manji','Elena Goode','Jim Piddock','Glenn Andreiev','Rick Chambers','Alan Cox','Jaiden Kaine','Chris Parnell','Frank Anello','Aja Frary','Ian Roberts','Sondra James','Carmel Amit','Anna Katarina','Seth Morris','Danielle Burgio','Larry Gevirtz','Anthony Mangano','David Fonteno','Adaku Ononogbo','Sean T. Krishnan','Arash Mokhtar','Ross Ryman','Rock Kohli',"Kelsey O'Brien"],
screenplay:['Sacha Baron Cohen','David Mandel','Jeff Schaffer'],
production:['Scott Rudin','Sacha Baron Cohen','Todd Schulman'],
music:['Erran Baron Cohen'],
camera:['Lawrence Sher'],
cut:['Greg Hayden','Eric Kissack'],
sound:['Andrew DeCristofaro','Beau Borders'],
scenography:['Victor Kempster'],
masks:['Naomi Donne','Judy Chin','Michael Marino','Patrick Alemi','Michael Fontaine'],
costumes:['Jeffrey Kurland']},
{title:'The Bourne Identity',
titleCZ:'Agent bez minulosti',
year:2002,
runtime:119,
countries:['USA','Germany','Czechia'],
genres:['Action','Mystery','Thriller'],
director:['Doug Liman'],
actors:['Matt Damon','Franka Potente','Chris Cooper','Clive Owen','Brian Cox','Adewale Akinnuoye-Agbaje','Gabriel Mann','Walton Goggins','Josh Hamilton','Julia Stiles','Orso Maria Guerrini','Tim Dutton','Denis Braccini','Nicky Naudé','Demetri Goritsas','Anthony Green','Hubert Saint-Macary','David Bamber','Vincent Franklin','Paulette Frantz','Roger Frost','Delphine Lanson','Joe Montana','Arnaud Henriet','Danny Erskine','Jimmy Jean-Louis','Eric Moreau','Emanuel Booz','John MacDonald','Gwenaël Clause'],
basedOn:['Robert Ludlum'],
screenplay:['Tony Gilroy','W. Blake Herron'],
production:['Richard N. Gladstein','Patrick Crowley'],
music:['John Powell'],
camera:['Oliver Wood'],
sound:['Bob Beemer','Scott Millan'],
scenography:['Dan Weil'],
masks:['Bohumil Sobotka','Alena Marečková','Tamara Koubová','Kay Georgiou'],
costumes:['Pierre-Yves Gayraud']},
{title:'Toy Story',
titleCZ:'Toy Story: Příběh hraček',
year:1995,
runtime:80,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['John Lasseter'],
actors:['Tom Hanks','Tim Allen','Don Rickles','Jim Varney','Wallace Shawn','Annie Potts','Erik von Detten','Laurie Metcalf','R. Lee Ermey','Penn Jillette','Greg Berg','Bill Farmer','Andrew Stanton','Joe Ranft','John Ratzenberger','Phil Proctor','Cody Dorkin','Debi Derryberry','Patrick Pinney','Jan Rabson','Sarah Rayne','Jack Angel','Gregory Grudt','Scott McAfee'],
screenplay:['Joss Whedon','Andrew Stanton','Joel Cohen','Alec Sokolow'],
production:['Bonnie Arnold','Steve Jobs'],
music:['Randy Newman'],
cut:['Robert Gordon'],
sound:['Tim Holland','Gary Summers','Gary Rydstrom','Timothy J. Garrity']},
{title:'The Bourne Supremacy',
titleCZ:'Bournův mýtus',
year:2004,
runtime:108,
countries:['USA','Germany'],
genres:['Action','Thriller'],
director:['Paul Greengrass'],
actors:['Matt Damon','Franka Potente','Brian Cox','Julia Stiles','Karl Urban','Gabriel Mann','Joan Allen','Marton Csokas','Tom Gallop','John Bedford Lloyd','Ethan Sandler','Michelle Monaghan','Karel Roden','Tomas Arana','Oksana Akiňšina','Jevgenij Sitočin','Tim Griffin','Dominique Chiout','Wanja Mues','Violetta Grafin Tarnowska Bronner','Claudio Maniscalco','Oxana Semjonova','Vitalij Abdulov','Dirk Schoedon','Ivan Shvedoff','Denis Burgazliev','Nick Wilder','Chris Cooper','Patrick Crowley','Alexej Medveděv','Marina Weis','Maxim Kovalevski','Stephan Wolf-Schönburg','Manfred Witt','Sean Smith'],
basedOn:['Robert Ludlum'],
screenplay:['Tony Gilroy'],
production:['Frank Marshall','Henning Molfenter','Patrick Crowley'],
music:['John Powell'],
camera:['Oliver Wood'],
cut:['Richard Pearson','Christopher Rouse'],
sound:['Scott Millan'],
scenography:['Dominic Watkins','Sarah Horton'],
masks:['Kay Georgiou','Valeska Schitthelm'],
costumes:['Dinah Collin']},
{title:'Spider-Man: Into the Spider-Verse',
titleCZ:'Spider-Man: Paralelní světy',
year:2018,
runtime:117,
countries:['USA'],
genres:['Animation','Action','Adventure','Sci-Fi'],
director:['Bob Persichetti','Peter Ramsey','Rodney Rothman'],
actors:['Shameik Moore','Jake Johnson','Hailee Steinfeld','Mahershala Ali','Brian Tyree Henry','Lily Tomlin','Luna Lauren Velez','Zoë Kravitz','John Mulaney','Kimiko Glenn','Nicolas Cage','Kathryn Hahn','Liev Schreiber','Chris Pine','Natalie Morales','Oscar Isaac','Greta Lee','Stan Lee','Jorma Taccone','Joaquín Cosio',"Marvin 'Krondon' Jones III",'Lake Bell','Miguel Jiron','Justin Shenkarow','Post Malone','Michelle Jubilee Gonzalez','Melanie Haynes','Claudia Choi','Mimi Davila','June Christopher','Warren Sroka'],
basedOn:['Stan Lee','Steve Ditko'],
screenplay:['Phil Lord','Rodney Rothman'],
production:['Phil Lord','Christopher Miller','Avi Arad','Amy Pascal','Christina Steinberg'],
music:['Daniel Pemberton'],
cut:['Robert Fisher Jr.'],
sound:['Michael Semanick','Tony Lamberti','Oleg Kulchytskyi'],
scenography:['Justin K. Thompson']},
{title:'The Great Escape',
titleCZ:'Velký útěk',
year:1963,
runtime:165,
countries:['USA'],
genres:['Adventure','Drama','War','History'],
director:['John Sturges'],
actors:['Steve McQueen','James Garner','Richard Attenborough','James Donald','Charles Bronson','Donald Pleasence','James Coburn','Hannes Messemer','David McCallum','Gordon Jackson','John Leyton','Angus Lennie','Nigel Stock','Robert Graf','Jud Taylor','Hans Reiser','Harry Riebauer','William Russell','Robert Freitag','Ulrich Beiger','George Mikell','Lawrence Montaigne','Robert Desmond','Til Kiwe','Heinz Weiss','Tom Adams','Karl-Otto Alberty','Krystyna Szerman'],
basedOn:['Paul Brickhill'],
screenplay:['James Clavell','W.R. Burnett'],
production:['John Sturges'],
music:['Elmer Bernstein'],
camera:['Daniel L. Fapp'],
cut:['Ferris Webster'],
masks:['Emile LaVigne'],
costumes:['Bert Henrikson']},
{title:'Your Name.',
titleCZ:'Kimi no na wa.',
year:2016,
runtime:106,
countries:['Japan'],
genres:['Animation','Fantasy','Romance','Drama'],
director:['Makoto Šinkai'],
actors:['Mone Kamiširaiši','Rjúnosuke Kamiki','Aoi Júki','Ecuko Ičihara','Masami Nagasawa','Rjó Narita','Kanon Tani','Čafúrin','Kaito Išikawa',"Šin'ja Hamazoe",'Kazuhiko Inoue','Kanami Sató','Juka Terasaki','Nobunaga Šimazaki','Mijú Cudži','Júki Šin','Tomohiro Jamaguči','Hiroki Macukawa','Tacuhiro Kikuči','Manami Hanawa','Juki Ominami','Šindžiró Góda','Nodoka Hasegawa','Miho Morisaki','Jasuhiro Kikuči','Baron Jamazaki','Takaši Onozuka','Suguru Inoue','Miho Tabata','Akira Kuwahara','Rjóko Usami','Jóhei Namekawa','Tamari Hinata','Mimi Tamaki'],
screenplay:['Makoto Šinkai'],
production:['Genki Kawamura','Kacuhiro Takei'],
music:['Radwimps'],
cut:['Makoto Šinkai'],
sound:['Haru Jamada'],
scenography:['Takumi Tandži']},
{title:'Taken',
titleCZ:'96 hodin',
year:2008,
runtime:89,
countries:['France','USA','UK'],
genres:['Action','Crime','Thriller','Drama'],
director:['Pierre Morel'],
actors:['Liam Neeson','Maggie Grace','Leland Orser','Jon Gries','David Warshofsky','Holly Valance','Katie Cassidy','Xander Berkeley','Olivier Rabourdin','Gérard Watkins','Famke Janssen','Marc Amyot','Arben Bajraktaraj','Radivoje Bukvič','Mathieu Busson','Nicolas Giraud','Camille Japy','Fani Kolarova','Goran Kostič','Christophe Kourotchkine','Jalil Naciri','Héléna Soubeyrand','Anatole Taubman','George Hertzberg'],
screenplay:['Luc Besson','Robert Mark Kamen'],
production:['Luc Besson'],
music:['Nathaniel Méchaly'],
camera:['Michel Abramowicz'],
cut:['Frédéric Thoraval'],
sound:['Martin Boissau'],
scenography:['Hugues Tissandier'],
costumes:['Corinne Bruand','Olivier Bériot']},
{title:'First Blood',
titleCZ:'Rambo: První krev',
year:1982,
runtime:93,
countries:['USA'],
genres:['Action','Adventure','Drama'],
director:['Ted Kotcheff'],
actors:['Sylvester Stallone','Richard Crenna','Brian Dennehy','Bill McKinney','Jack Starrett','Michael Talbott','Chris Mulkey','John McLiam','Alf Humphreys','David Caruso','David L. Crowley','Don MacKay','Patrick Stack','Stephen E. Miller','Bruce Greenwood','Donald Adams','Gary Hetherington','Alex Kliner','Stephen Chang','Suzee Pai','Stephen Dimopoulos'],
basedOn:['David Morrell'],
screenplay:['Michael Kozoll','William Sackheim','Sylvester Stallone'],
production:['Buzz Feitshans'],
music:['Jerry Goldsmith'],
camera:['Andrew Laszlo'],
cut:['Joan E. Chapman'],
sound:['Gregg Landaker','Robert Nichols II','Rob Young'],
scenography:['Wolf Kroeger'],
masks:['Phyllis Newman','Michael Westmore'],
costumes:['Tom Bronson']},
{title:'The Thing',
titleCZ:'Věc',
year:1982,
runtime:109,
countries:['USA'],
genres:['Sci-Fi','Horror','Thriller','Mystery'],
director:['John Carpenter'],
actors:['Kurt Russell','Wilford Brimley','T.K. Carter','David Clennon','Keith David','Richard Dysart','Charles Hallahan','Peter Maloney','Richard Masur','Thomas G. Waites','Donald Moffat','Joel Polis','John Carpenter','Adrienne Barbeau','pes Jed','William Zeman','Norbert Weisser','Larry Franco'],
basedOn:['John Wood Campbell jr.'],
screenplay:['Bill Lancaster'],
production:['David Foster','Lawrence Turman'],
music:['Ennio Morricone'],
camera:['Dean Cundey'],
cut:['Todd C. Ramsay'],
sound:['Steve Maslow','David Lewis Yewdall'],
scenography:['John J. Lloyd','John M. Dwyer'],
masks:['Phyllis Newman','Ken Chase','Rob Bottin']},
{title:"Hachiko: A Dog's Story",
titleCZ:'Hačikó - příběh psa',
year:2009,
runtime:89,
countries:['USA','UK'],
genres:['Drama','Family'],
director:['Lasse Hallström'],
actors:['Richard Gere','Joan Allen','Cary-Hiroyuki Tagawa','Sarah Roemer','Jason Alexander','Erick Avari','Bates Wilder','Robert Capron','Americo Presciutti','Robbie Sublett','Davenia McFadden','Troy Doherty','Raymond Alongi','Tora Hallström','Rich Skinner'],
screenplay:['Stephen P. Lindsey','Kaneto Šindó'],
production:['Richard Gere'],
music:['Jan A.P. Kaczmarek'],
camera:['Ron Fortunato'],
cut:['Kristina Boden'],
sound:['Robert Fernandez'],
scenography:['Chad Detwiller'],
masks:['Nichole Pleau'],
costumes:['Deborah Newhall']},
{title:'Cinderella Man',
titleCZ:'Těžká váha',
year:2005,
runtime:144,
countries:['USA'],
genres:['Drama','Sport','Biographic','History'],
director:['Ron Howard'],
actors:['Russell Crowe','Renée Zellweger','Paul Giamatti','Craig Bierko','Paddy Considine','Bruce McGill','Rosemarie DeWitt','Chuck Shamata','Ron Canada','Fulvio Cecere','Clint Howard','Gavin Grazer','Boyd Banks','Daniel Kash','Aaron Abrams','Roman Podhora','Krysta Carter','Rance Howard','Sergio Di Zio','Nicholas Campbell','R.D. Reid','Ken James','Gerry Quigley','Connor Price','Rick Cordeiro','Mark Simmons','Ramona Pringle','Philip Craig','Tony Munch','David Huband','Matthew G. Taylor','Timothy Burd','Nick Smyth','Judah Katz','Richard Bachynsky Hoover','Linda Kash','Alicia Johnston','Sharron Matthews','Nola Augustson','Conrad Bergschneider','Paul Ryan','Ariel Waller','Richard Binsley','Wayne Gordon','James Ritz'],
screenplay:['Akiva Goldsman','Cliff Hollingsworth'],
production:['Brian Grazer'],
music:['Thomas Newman'],
camera:['Salvatore Totino'],
cut:['Daniel P. Hanley','Mike Hill'],
sound:['Tom Fleischman','Bob Chefalas'],
scenography:['Wynn Thomas','Gordon Sim'],
masks:['Lance Anderson','David LeRoy Anderson','Ann Brodie','Maribeth Knezev'],
costumes:['Daniel Orlandi']},
{title:'Into the Wild',
titleCZ:'Útěk do divočiny',
year:2007,
runtime:148,
countries:['USA'],
genres:['Adventure','Drama','Biographic'],
director:['Sean Penn'],
actors:['Emile Hirsch','Marcia Gay Harden','William Hurt','Jena Malone','Brian H. Dierker','Catherine Keener','Vince Vaughn','Kristen Stewart','Hal Holbrook','Zach Galifianakis','Haley Ramm','Merritt Wever','medvěd Bart 2','J. Nathan Simmons','Thure Lindhardt','R.D. Call','Signe Egholm Olsen','Leonard Knight','Parris Mosteller','John Jabaley','Cheryl Francis Harrington'],
basedOn:['Jon Krakauer'],
screenplay:['Sean Penn'],
production:['Art Linson','Bill Pohlad','Sean Penn'],
music:['Michael Brook','Eddie Vedder','Kaki King'],
camera:['Eric Gautier'],
cut:['Jay Cassidy'],
sound:['Martín Hernández','Michael Minkler','Lora Hirschberg'],
scenography:['Derek R. Hill','Danielle Berman'],
masks:['Mike Smithson','Sterfon Demings'],
costumes:['Mary Claire Hannan']},
{title:'Treasure of Silver Lake',
titleCZ:'Poklad na Stříbrném jezeře',
year:1962,
runtime:111,
countries:['Germany','Yugoslavia','France'],
genres:['Adventure','Western'],
director:['Harald Reinl'],
actors:['Lex Barker','Pierre Brice','Herbert Lom','Götz George','Karin Dor','Marianne Hoppe','Eddi Arent','Ralf Wolter','Sima Janićijević','Ilija Ivezič','Mirko Boman','Branko Špoljar','Milivoj Stojanović','Slobodan Dimitrijević','Jozo Kovačević','Velimir Chytil','Hans-Walter Clasen','Josef Dahmen','Rudolf Fenner','Uwe Friedrichsen','Benno Gellenbeck','Sime Jagarinac','Erwin Linder','Rolf Mamero','Vladimir Medar','Antun Nalis','Horst Niendorf','Herbert Stass'],
basedOn:['Karl May'],
screenplay:['Harald G. Petersson'],
production:['Horst Wendlandt'],
music:['Martin Böttcher'],
camera:['Ernst W. Kalinke'],
cut:['Hermann Haller'],
sound:['Erik Molnar'],
scenography:['Dušan Jeričević'],
costumes:['Irms Pauli']},
{title:'Whiplash',
titleCZ:'Whiplash',
year:2014,
runtime:107,
countries:['USA'],
genres:['Drama','Music'],
director:['Damien Chazelle'],
actors:['Miles Teller','J.K. Simmons','Paul Reiser','Melissa Benoist','Austin Stowell','Nate Lang','Chris Mulkey','Damon Gupton','Max Kasch','Jayson Blair','April Grace','C.J. Vana','Tarik Lowe','Kofi Siriboe','Henry G. Sanders','Keenan Henson','Marcus Henderson','Herman Johansen','Suanne Spoke','Jocelyn Ayanna','Michael D. Cohen','Calvin C. Winbush'],
screenplay:['Damien Chazelle'],
production:['Jason Blum','Mark David Katchur','Michel Litvak','David Lancaster','Helen Estabrook'],
music:['Justin Hurwitz'],
camera:['Sharone Meir'],
cut:['Tom Cross'],
scenography:['Melanie Jones'],
costumes:['Lisa Norcia']},
{title:'The Graduate',
titleCZ:'Absolvent',
year:1967,
runtime:106,
countries:['USA'],
genres:['Drama','Comedy'],
director:['Mike Nichols'],
actors:['Anne Bancroft','Dustin Hoffman','Katharine Ross','William Daniels','Murray Hamilton','Elizabeth Wilson','Buck Henry','Brian Avery','Walter Brooke','Norman Fell','Alice Ghostley','Eddra Gale','Frank Baker','Richard Dreyfuss','Mike Farrell','Elisabeth Fraser','Donald F. Glut','Harry Holcombe','Jonathan Hole','Elaine May','Eve McVeagh','Ben Murphy',"William H. O'Brien",'Hal Taggart','Kevin Tighe','Arthur Tovey','Robert P. Lieb','George Bruggeman','Noam Pitlik','Lainie Miller'],
basedOn:['Charles Webb'],
screenplay:['Buck Henry','Calder Willingham'],
production:['Lawrence Turman'],
music:['Dave Grusin'],
camera:['Robert Surtees'],
cut:["Sam O'Steen"],
sound:['Jack Solomon'],
scenography:['Richard Sylbert','George R. Nelson'],
costumes:['Patricia Zipprodt']},
{title:'Animal',
titleCZ:'Zvíře',
year:1977,
runtime:96,
countries:['France'],
genres:['Comedy','Action','Romance'],
director:['Claude Zidi'],
actors:['Jean-Paul Belmondo','Raquel Welch','Dany Saval','Jane Birkin','Johnny Hallyday','Charles Gérard','Claude Chabrol','Mario David','Julien Guiomar','Aldo Maccione','Josiane Balasko','Raymond Gerôme','Maurice Bénichou','Richard Bohringer','Didier Flamand','Rita Maiden','Jean-Jacques Moreau','Henri Attal','Henri Génès','Samson Fainsilber','Paul Bisciglia','Jean-Jacques','Georges Riquier','Anne-Marie Coffinet','Xavier Saint-Macary','André Penvern','Fred Personne','Jacques Alric','Jean Cherlian','Agathe Vannier','Patrice Melennec','Maurice Illouz','Marie Pillet','Martine Ferrière','Catherine Meurisse','Eduardo Bergara Leumann','Maurice Auzel'],
screenplay:['Michel Audiard','Claude Zidi','Dominique Fabre'],
production:['Christian Fechner'],
music:['Vladimir Cosma'],
camera:['Claude Renoir'],
cut:['Monique Isnardon','Robert Isnardon'],
sound:['Bernard Aubouy'],
scenography:['Théobald Meurisse']},
{title:"Howl's Moving Castle",
titleCZ:'Zámek v oblacích',
year:2004,
runtime:118,
countries:['Japan'],
genres:['Animation','Adventure','Fantasy','Romance'],
director:['Hajao Mijazaki'],
actors:['Takuja Kimura','Čieko Baišó','Akio Ócuka','Rjúnosuke Kamiki','Jó Óizumi','Šigejuki Tocugi','Akihiro Miwa','Haruko Kató','Makoto Jasumura','Majuno Jasokawa','Seidži Sasaki','Keiko Cukamoto','Manabu Muradži','Jóhei Óbajaši','Hiroši Takahaši','Hiroki Tanaka','Jukiko Mizuoči','Takeši Mijadžima','Teruo Seki','Kódžiró Takahaši','Maki Koizumi','Masako Inui'],
screenplay:['Hajao Mijazaki'],
production:['Tošio Suzuki'],
music:['Džó Hisaiši','Jumi Kimura'],
camera:['Acuši Okui'],
cut:['Takeši Sejama'],
scenography:['Jódži Takešige']},
{title:'A Bronx Tale',
titleCZ:'Příběh z Bronxu',
year:1993,
runtime:122,
countries:['USA'],
genres:['Crime','Drama'],
director:['Robert De Niro'],
actors:['Robert De Niro','Chazz Palminteri','Lillo Brancato','Francis Capra','Taral Hicks','Kathrine Narducci','Joe Pesci',"Joe D'Onofrio",'William DeMeo','David Batiste','Domenick Lombardozzi','Alex Ballar','Fred Fischer','Clem Caserta','Dave Salerno','Ronnie Marmo','Louis Vanaria','Derrick Simmons','Julia Campanelli','Mike Benz','Jody Millard','Nina Peterson','Kresh Novakovic'],
screenplay:['Chazz Palminteri','Chazz Palminteri'],
production:['Jon Kilik','Robert De Niro','Jane Rosenthal'],
music:['Butch Barbella'],
camera:['Reynaldo Villalobos'],
cut:['David Ray','Robert Q. Lovett'],
sound:['Lee Dichter','Tod A. Maitland','Dominick Tavella'],
scenography:['Wynn Thomas'],
costumes:['Rita Ryack']},
{title:'Kramer vs. Kramer',
titleCZ:'Kramerová versus Kramer',
year:1979,
runtime:105,
countries:['USA'],
genres:['Drama'],
director:['Robert Benton'],
actors:['Dustin Hoffman','Meryl Streep','Jane Alexander','Justin Henry','Howard Duff','George Coe','JoBeth Williams','Bill Moor','Jack Ramage','Howland Chamberlain','Ellen Parker','Shelby Brammer','Carol Nadell','Donald Gantry','Judith Calder','Peter Lownds','Kathleen Keller','Ingeborg Sørensen','Iris Albanti','Quentin J. Hruska','Petra King','Melissa Morell','Joe Seneca','Sean Albertson','Jess Osuna','Nicholas Hormann','Marisa Petroro'],
basedOn:['Avery Corman'],
screenplay:['Robert Benton'],
production:['Stanley R. Jaffe'],
camera:['Néstor Almendros'],
cut:['Gerald B. Greenberg'],
sound:['Dick Vorisek','Bob Olari'],
scenography:['Paul Sylbert','Alan Hicks'],
costumes:['Ruth Morley']},
{title:'Sunset Boulevard',
titleCZ:'Sunset Blvd.',
year:1950,
runtime:110,
countries:['USA'],
genres:['Drama','Film-Noir'],
director:['Billy Wilder'],
actors:['William Holden','Gloria Swanson','Erich von Stroheim','Nancy Olson','Fred Clark','Franklyn Farnum','Jack Webb','Lloyd Gough','Cecil B. DeMille','Hedda Hopper','Buster Keaton','Anna Q. Nilsson','H.B. Warner','Yvette Vickers','Creighton Hale','E. Mason Hopper','Henry Wilcoxon','Ruth Clifford','Harold Miller','Archie R. Dalzell','Len Hendry','Danny Borzage','Chuck Hamilton','Larry J. Blake','Eddie Dew','Jack Perrin','Gertrude Messinger',"Frank O'Connor",'Bert Moorhouse','Fred Aldrich','Gertrude Astor','Al Ferguson','Tiny Jones','Edward Biby','Joe Gray',"Robert Emmett O'Connor",'Lee Miller','Howard Negley','Eva Novak','Perc Launders','Rudy Germane','Anne Bauchens','William Meader','Kenneth Gibson','Ralph Montgomery','Ottola Nesmith','Archie Twitchell','Alan Marston','Julia Faye'],
screenplay:['Charles Brackett','Billy Wilder','D.M. Marshman Jr.'],
production:['Charles Brackett'],
music:['Franz Waxman'],
camera:['John F. Seitz'],
cut:['Arthur P. Schmidt'],
sound:['John Cope','Harry Lindgren'],
scenography:['Hans Dreier','John Meehan','Ray Moyer','Sam Comer'],
masks:['Wally Westmore'],
costumes:['Edith Head']},
{title:'Modern Times',
titleCZ:'Moderní doba',
year:1936,
runtime:87,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Charlie Chaplin'],
actors:['Charlie Chaplin','Paulette Goddard','Henry Bergman','Chester Conklin','Lloyd Ingraham','Louis Natheaux','Gloria DeHaven','Richard Alexander','Mira McKinney','Wilfred Lucas','Edward LeSaint','Bobby Barber','Chuck Hamilton','Stanley Blystone','Frank Hagney','Heinie Conklin','Harry Wilson','Russ Powell','Hank Mann','Buddy Messinger','Frank Moran','Jack Low','Murdock MacQuarrie','Sammy Stein','Pat Harmon','Tiny Sandford','J.C. Nugent','Walter James','Fred Malatesta','Al Ernest Garcia'],
screenplay:['Charlie Chaplin'],
production:['Charlie Chaplin'],
music:['Charlie Chaplin'],
camera:['Roland Totheroh','Ira H. Morgan'],
cut:['Charlie Chaplin','Willard Nico'],
scenography:['Charles D. Hall']},
{title:'Paths of Glory',
titleCZ:'Stezky slávy',
year:1957,
runtime:88,
countries:['USA'],
genres:['Drama','War'],
director:['Stanley Kubrick'],
actors:['Kirk Douglas','Ralph Meeker','Adolphe Menjou','George Macready','Wayne Morris','Richard Anderson','Joe Turkel','Timothy Carey','Christiane Kubrick','Jerry Hausner','Peter Capell','Bert Freed','Emile Meyer','Rolf Kralovitz','James B. Harris','Kem Dibbs','Paul Bös','Herbert Ellis'],
basedOn:['Humphrey Cobb'],
screenplay:['Stanley Kubrick','Calder Willingham','Jim Thompson'],
production:['Stanley Kubrick','Kirk Douglas','James B. Harris'],
music:['Gerald Fried'],
camera:['Georg Krause'],
cut:['Eva Kroll'],
sound:['Martin Müller'],
masks:['Arthur Schramm'],
costumes:['Ilse Dubois']},
{title:'The General',
titleCZ:'Frigo na mašině',
year:1926,
runtime:79,
countries:['USA'],
genres:['Comedy','Romance','Adventure','War','Action'],
director:['Buster Keaton','Clyde Bruckman'],
actors:['Buster Keaton','Marion Mack','Glen Cavender','Jim Farley','Frederick Vroom','Joe Keaton','Frank Hagney','Edward Hearn','Eddie Foster','Al St. John','Boris Karloff','Budd Fine'],
screenplay:['Buster Keaton','Clyde Bruckman'],
production:['Buster Keaton','Joseph M. Schenck'],
music:['Džó Hisaiši','Carl Davis','Marcin Pukaluk'],
camera:['Bert Haines','Devereaux Jennings'],
cut:['Sherman Kell','Buster Keaton']},
{title:'The NeverEnding Story',
titleCZ:'Nekonečný příběh',
year:1984,
runtime:94,
countries:['Germany','USA'],
genres:['Fantasy','Adventure','Family','Drama'],
director:['Wolfgang Petersen'],
actors:['Barret Oliver','Noah Hathaway','Gerald McRaney','Drum Garrett','Darryl Cooksey','Thomas Hill','Tilo Prückner','Moses Gunn','Sydney Bromley','Deep Roy','Tami Stronach','Alan Oppenheimer','Patricia Hayes','Silvia Seidel','Heinz Reincke','Limahl','Frank Lenart'],
basedOn:['Michael Ende'],
screenplay:['Wolfgang Petersen','Herman Weigel'],
production:['Bernd Eichinger','Dieter Geissler'],
music:['Klaus Doldinger','Giorgio Moroder'],
camera:['Jost Vacano'],
cut:['Jane Seitz'],
sound:['Milan Bor'],
scenography:['Rolf Zehetbauer'],
masks:['Heiner Niehues','Colin Arthur','Edwin Erfmann'],
costumes:['Diemut Remy']},
{title:'Joker',
titleCZ:'Joker',
year:2019,
runtime:122,
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Todd Phillips'],
actors:['Joaquin Phoenix','Robert De Niro','Zazie Beetz','Frances Conroy','Brett Cullen','Shea Whigham','Bill Camp','Glenn Fleshler','Leigh Gill','Josh Pais','Marc Maron','Sondra James','Murphy Guyer','Douglas Hodge','Dante Pereira-Olson','Sharon Washington','Hannah Gross','Brian Tyree Henry','April Grace','Carl Lundstedt','Michael Benz','Gary Gulman','Chris Redd','Mandela Bellamy','Isabella Ferreira','Alissa Bourne','Tamiz U. Rezvi','Ben Warheit','Matthew Vincini','David Iacono','Jimmy Star','Brendan Patrick Connor','Stephen Stanton','Jeff McCarthy','Brad Abrell'],
screenplay:['Todd Phillips','Scott Silver'],
production:['Todd Phillips','Bradley Cooper','Emma Tillinger Koskoff'],
music:['Hildur Guðnadóttir'],
camera:['Lawrence Sher'],
cut:['Jeff Groth'],
sound:['Alan Robert Murray','Dean A. Zupancic','Tom Ozanich','Tod A. Maitland'],
scenography:['Mark Friedberg'],
masks:['Michael Marino','Nicki Ledermann','Kay Georgiou','Amy Sue Nahhas','Mariko Miyagi','Michael Fontaine'],
costumes:['Mark Bridges']},
{title:'The Untouchables',
titleCZ:'Neúplatní',
year:1987,
runtime:119,
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Brian De Palma'],
actors:['Kevin Costner','Charles Martin Smith','Andy Garcia','Richard Bradford','Jack Kehoe','Robert De Niro','Sean Connery','Brad Sullivan','Billy Drago','Patricia Clarkson','Don Harvey','Robert Swan','Larry Brandenburg','Robert Miranda','Chelcie Ross','Clifton James','Mike Bacarella','Clem Caserta','Del Close',"Vito D'Ambrosio",'Joe Greco','Anthony Mockus Sr.','Will Zahrn','Stephen Burrows','Pat Billingsley','Valentino Cimo','Eddy Donno','Kaitlin Montgomery','Melody Rae'],
basedOn:['Eliot Ness','Oscar Fraley'],
screenplay:['David Mamet'],
production:['Art Linson'],
music:['Ennio Morricone'],
camera:['Stephen H. Burum'],
cut:['Gerald B. Greenberg','Bill Pankow'],
sound:['Dick Vorisek','Bob Olari'],
scenography:['Hal Gausman'],
masks:['Michael Hancock'],
costumes:['Marilyn Vance']},
{title:'The Man from Acapulco',
titleCZ:'Muž z Acapulca',
year:1973,
runtime:90,
countries:['France','Italy'],
genres:['Comedy','Action','Romance'],
director:['Philippe de Broca'],
actors:['Jean-Paul Belmondo','Jacqueline Bisset','Vittorio Caprioli','Hans Meyer','Monique Tarbès','Raymond Gerôme','André Weber','Mario David','Jean Lefebvre','Philippe de Broca','Maurice Auzel','Jean-Pierre Rambal','Robert Berri','Hubert Deschamps','Bernard Musson','Lucienne Legrand','Michel Thomass','Henry Czarniak','Micha Bayard','Max Desrau','Raoul Guylad','Louis Navarre','René Barrera','Gaëtan Noël','Rodrigo Puebla','Jacques Wajsmark','Charly Koubesserian'],
screenplay:['Philippe de Broca','Vittorio Caprioli','Jean-Paul Rappeneau','Francis Veber'],
production:['Georges Dancigers','Alexandre Mnouchkine','Jean-Paul Belmondo'],
music:['Claude Bolling'],
camera:['René Mathelin'],
cut:['Henri Lanoë'],
masks:['Charly Koubesserian']},
{title:"Don't Look Now: We're Being Shot At",
titleCZ:'Velký flám',
year:1966,
runtime:132,
countries:['France','UK'],
genres:['Comedy','War'],
director:['Gérard Oury'],
actors:['Bourvil','Louis de Funès','Claudio Brook','Andréa Parisy','Colette Brosset','Mike Marshall','Mary Marquet','Pierre Bertin','Benno Sterzenbach','Marie Dubois','Terry-Thomas','Sieghardt Rupp','Reinhard Kolldehoff','Helmuth Schneider','Paul Préboist','Hans Meyer','Guy Grosso','Michel Modo','Rudy Lenoir','Noël Darzal','Pierre Roussel','Mag-Avril','Jacques Bodoin','Gabriel Gobin','Paul Mercey','Henri Génès','Anne Berger','Christian Brocard','Jerry Brouer','Jean Droze','Alice Field','Fred Fischer','Rémy Julienne','Jean Minisini','Raymond Pierson','Jean-Pierre Posier','Tony Rödel','Anthony Stuart','Lionel Vitrant','Konrad von Bork'],
screenplay:['Gérard Oury','Danièle Thompson','Marcel Jullian'],
production:['Robert Dorfmann'],
music:['Georges Auric'],
camera:['Claude Renoir'],
cut:['Albert Jurgenson'],
sound:['Antoine Bonfanti','Urbain Loiseau'],
scenography:['Jean André'],
masks:['Pierre Berroyer','Odette Berroyer'],
costumes:['Tanine Autré']},
{title:'My Fair Lady',
titleCZ:'My Fair Lady',
year:1964,
runtime:170,
countries:['USA'],
genres:['Comedy','Drama','Musical','Romance'],
director:['George Cukor'],
actors:['Audrey Hepburn','Rex Harrison','Stanley Holloway','Wilfrid Hyde-White','Gladys Cooper','Jeremy Brett','Theodore Bikel','Bill Shirley','Alan Napier','Monika Henreid','Henry Daniell','John Mitchum','Ben Wright','John McLiam','Barbara Morrison','Sam Harris','Charles Fredericks','Colin Kenny','Arthur Tovey','Oscar Beregi Jr.','Mona Washbourne','Walter Burke','Marjorie Bennett','John Alderson','Michael St. Clair','Barbara Pepper','Harvey B. Dunn','Queenie Leonrad','Isobel Elsom','Jeannie Carson','George Pelling','Pauline Drake','William Beckley','Phyllis Kennedy','Owen McGiveney','Jack Raine','Laurie Main','Orville Sherman','Natalie Core','Betty Blythe','Jerry Rush','Christopher Riordan','Ron Whelan','John Holland',"Patrick O'Moore",'Clyde Howdy','Roy Dean','Grady Sutton','Stuart Hall','Dinah Anne Rogers','Larri Thomas'],
screenplay:['George Bernard Shaw','Alan Jay Lerner','Alan Jay Lerner'],
production:['Jack L. Warner'],
music:['André Previn','Frederick Loewe'],
camera:['Harry Stradling Sr.'],
cut:['William H. Ziegler'],
sound:['Francis J. Scheid'],
scenography:['Cecil Beaton','Gene Allen','Malcolm C. Bert'],
masks:['Robert J. Schiffer','Gordon Bau'],
costumes:['Cecil Beaton']},
{title:'A Moment to Remember',
titleCZ:'Vzpomínky na lásku',
year:2004,
runtime:117,
countries:['South Korea'],
genres:['Drama','Romance'],
director:['Jae-han Lee'],
actors:['Woo-seong Jeong','Ye-jin Son','Jong-hak Baek','Kwang-rok Oh','Joong-ki Kim','Sang-gyoo Park','Hie-ryeong Kim','Ji-hyun Seon','Boo-seon Kim','Min-seong Jeong','Byeong-gil Kwon','Seon-jin Lee','Yong-wook Jin','Yeong Hyeon','Hyeon-tak Sin','David Lee McInnis','Jin-won Seo','Feel Kim'],
screenplay:['Jae-han Lee']},
{title:'In the Name of the Father',
titleCZ:'Ve jménu otce',
year:1993,
runtime:133,
countries:['Ireland','UK','USA'],
genres:['Drama','Biographic','Thriller'],
director:['Jim Sheridan'],
actors:['Daniel Day-Lewis','Pete Postlethwaite','Emma Thompson','Mark Sheppard','John Lynch','Saffron Burrows','Jamie Harris','Corin Redgrave','Gerard McSorley','Phil Davis','Richard Graham','Peter Howitt','Daniel Massey','Bosco Hogan','John Benfield','Dave Duffy','Frank Harper','Paterson Joseph','Peter Sheridan','Tom Wilkinson','Beatie Edney',"Jer O'Lear",'Stuart Wolfenden','Denys Hawthorne','Jürgen Rißmann','Stanley Townsend','Tina Kellegher','Jonathan Ryan','Anthony Brophy','Tony Denham','Rob Spendlove','Mal Whyte','Malcolm Tierney','Sean Lawlor','Martin Dunne','Frankie McCafferty','Marie Jones'],
basedOn:['Gerry Conlon'],
screenplay:['Terry George','Jim Sheridan'],
production:['Jim Sheridan'],
music:['Trevor Jones'],
camera:['Peter Biziou'],
cut:['Gerry Hambling'],
sound:['Andy Nelson','Anna Behlmer'],
costumes:['Joan Bergin']},
{title:'Cinema Paradiso',
titleCZ:'Bio Ráj',
year:1988,
runtime:155,
countries:['Italy','France'],
genres:['Drama','Romance','Comedy'],
director:['Giuseppe Tornatore'],
actors:['Philippe Noiret','Enzo Cannavale','Salvatore Cascio','Leo Gullotta','Isa Danieli','Pupella Maggio','Agnese Nano','Tano Cimarosa','Jacques Perrin','Brigitte Fossey','Marco Leonardi','Nicola Di Pinto','Leopoldo Trieste','Antonella Attili','Nino Terzo','Beatrice Palme','Angelo Tosto','Franco Catalano','Turi Killer','Angela Leontini','Nellina Laganà','Roberta Lena','Turi Giuffrida','Mariella Lo Giudice'],
screenplay:['Giuseppe Tornatore'],
production:['Franco Cristaldi'],
music:['Ennio Morricone','Andrea Morricone'],
camera:['Blasco Giurato'],
sound:['Alberto Doni'],
scenography:['Andrea Crisanti'],
masks:['Maurizio Trani'],
costumes:['Beatrice Bordone']},
{title:'Wolfwalkers',
titleCZ:'Vlkochodci',
year:2020,
runtime:102,
countries:['Ireland','USA'],
genres:['Animation','Adventure','Fantasy','Family'],
director:['Tomm Moore','Ross Stewart'],
actors:['Sean Bean','Honor Kneafsey','Simon McBurney','Maria Doyle Kennedy','Jon Kenny','Nora Twomey','John Morton','Eva Whittaker','Michael McGrath'],
screenplay:['Will Collins'],
production:['Tomm Moore','Nora Twomey','Paul Young','Stéphan Roelants'],
music:['Bruno Coulais'],
scenography:['Ross Stewart']},
{title:'Titanic',
titleCZ:'Titanic',
year:1997,
runtime:194,
countries:['USA'],
genres:['Drama','Romance','History','Catastrophic'],
director:['James Cameron'],
actors:['Leonardo DiCaprio','Kate Winslet','Billy Zane','Kathy Bates','Bill Paxton','Gloria Stuart','Frances Fisher','Bernard Hill','Jonathan Hyde','David Warner','Victor Garber','Danny Nucci','Suzy Amis','Ewan Stewart','Ioan Gruffudd','Richard Graham','Ron Donachie','Bernard Fox','Eric Braeden','James Cameron','Seth Adkins',"Tricia O'Neil",'Anne Fletcher','Jenette Goldstein','Mark Lindsay Chapman','Lewis Abernathy','Simon Crane','Mike Butters','Camilla Overbye Roos','John Walcutt','Charlotte Chatton','Martin Jarvis','Scott Anderson','Jason Barry','Greg Ellis','Rosalind Ayres','Jari Kinnunen','Martin Hub','Michael Ensign','Barry Dennen','Jonny Phillips','Paul Herbert','Nicholas Cascone','Martin Laing','Erik Holland','Sean Lawlor','Scott Hislop','Rebecca Klingler','Rudy Joffroy','Shay Duffin','Paul Brightwell','Lew Palter','Elsa Raven','Rochelle Rose','Van Ling','Brian McDermott','Emmett James','Alexandra Boyd','Nick Meaney','Chris Byrne','Linda Kerns','Oliver Page','Craig Kelly','Mark Capri','Pia Thrasher','Stephen Wolfe Smith','Stephanie Nadolny'],
screenplay:['James Cameron'],
production:['James Cameron','Jon Landau'],
music:['James Horner'],
camera:['Russell Carpenter'],
cut:['Conrad Buff IV','Richard A. Harris','James Cameron'],
sound:['Gary Rydstrom','Lora Hirschberg','Adam Jenkins','Christopher Boyes','Tom Johnson','Mark Ulano'],
scenography:['Martin Laing','Peter Lamont','Michael Ford'],
masks:['Elaine Dill','Kay Georgiou','Greg Cannom','Zoe Tahir','Susan A. Cabral'],
costumes:['Deborah L. Scott']},
{title:'Monsters, Inc.',
titleCZ:'Příšerky s.r.o.',
year:2001,
runtime:90,
countries:['USA'],
genres:['Animation','Family','Comedy','Fantasy'],
director:['Pete Docter','Lee Unkrich','David Silverman'],
actors:['John Goodman','Billy Crystal','Mary Gibbs','Steve Buscemi','James Coburn','Jennifer Tilly','Frank Oz','Bonnie Hunt','Bob Bergen','Rodger Bumpass','Bobby Edner','Ashley Edner','Bill Farmer','Steve Susskind','Laraine Newman','Wallace Shawn','Lee Unkrich','David Silverman','Bob Peterson','Kay Panabaker','Pete Docter','Joe Ranft','Marc John Jefferies','John Ratzenberger','Phil Proctor','Teresa Ganzel','Gino Conforti',"Bret 'Brook' Parker",'Guido Quaroni','Noah Luke','Paul Eiding','Pat Fraley','Jan Rabson','Mona Marshall','Keegan Farrell','Jennifer Darling','Danny Mann','Jack Angel'],
screenplay:['Andrew Stanton','Daniel Gerson','Robert L. Baird'],
production:['Darla K. Anderson'],
music:['Randy Newman'],
cut:['Jim Stewart'],
sound:['Gary Summers','Michael Semanick','Gary Rydstrom'],
scenography:['Harley Jessup']},
{title:'As Good as It Gets',
titleCZ:'Lepší už to nebude',
year:1997,
runtime:139,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['James L. Brooks'],
actors:['Jack Nicholson','Helen Hunt','Greg Kinnear','Cuba Gooding Jr.','Skeet Ulrich','Shirley Knight','Yeardley Smith','Lupe Ontiveros','Bibi Osterwald','Jaffe Cohen','Brian Doyle-Murray','Kristi Zea','Annie Maginnis Tippe','Patricia Childress','Rebekah Johnson','Missi Pyle','Leslie Stefanson','Tara Subkoff','Shane Black','Peter Jacobson','Lisa Edelstein','Randall Batinkoff','Jesse James','Jamie Kennedy','Maya Rudolph',"John F. O'Donohue",'Lawrence Kasdan','Kathryn Morris','Wood Harris','Linda Gehringer','Julie Benz','Harold Ramis','Kaitlin Hopkins','Jimmy Workman','Danielle Spencer','Todd Solondz','Tom McGowan','Danielle Brisebois','Matt Malloy','Paul Greenberg','Roger Ferreira','Alex Ballar','Bronwyn Cornelius','Eddie L. Fauria','Maurice LaMarche','Justin Ward'],
screenplay:['Mark Andrus','James L. Brooks'],
production:['James L. Brooks','Bridget Johnson','Kristi Zea'],
music:['Hans Zimmer'],
camera:['John Bailey'],
cut:['Richard Marks'],
sound:['David Giammarco','Ron Bartlett'],
scenography:['Bill Brzeski'],
masks:['Michèle Burke'],
costumes:['Molly Maginnis']},
{title:'Back to the Future Part III',
titleCZ:'Návrat do budoucnosti III',
year:1990,
runtime:118,
countries:['USA'],
genres:['Adventure','Comedy','Sci-Fi','Western'],
director:['Robert Zemeckis'],
actors:['Michael J. Fox','Christopher Lloyd','Mary Steenburgen','Tom Wilson','Lea Thompson','Elisabeth Shue','James Tolkan','Matt Clark','Harry Carey Jr.','Dub Taylor','Marc McClure','Flea','Donovan Scott','Dean Cundey','Richard Dysart','Marvin J. McIntyre','Bill McKinney','Billy Gibbons','Pat Buttram','Dusty Hill','Ricky Dean Logan','Wendie Jo Sperber','J.J. Cohen','Jeffrey Weissman','Hugh Gillin','Frank Beard','Burton Gilliam','Sean Sullivan','Kenny Myers','Michael Mills'],
screenplay:['Bob Gale'],
production:['Neil Canton','Bob Gale'],
music:['Alan Silvestri'],
camera:['Dean Cundey'],
cut:['Arthur Schmidt','Harry Keramidas'],
sound:['Rick Alexander'],
scenography:['Rick Carter'],
masks:['Sharleen Rassi','Kenny Myers','Michael Mills'],
costumes:['Joanna Johnston']},
{title:'The Godfather: Part III',
titleCZ:'Kmotr III',
year:1990,
runtime:162,
countries:['USA'],
genres:['Drama','Crime'],
director:['Francis Ford Coppola'],
actors:['Al Pacino','Diane Keaton','Talia Shire','Andy Garcia','Eli Wallach','Joe Mantegna','George Hamilton','Bridget Fonda','Sofia Coppola','Raf Vallone',"Franc D'Ambrosio",'Donal Donnelly','Richard Bright','Helmut Berger','Don Novello','John Savage','Franco Citti','Vittorio Duse','Enzo Robutti','Michele Russo','Al Martino','Jeannie Linero','Carmine Caridi','Al Ruscio','Mickey Knox','Rick Aviles','Michael Bowen','Brett Halsey','Gabriele Torrei','Gregory Corso','Marino Masé','Valeria Sabel','Mimmo Cuticchio','Diana Agostini','Catherine Scorsese','Salvatore Billa','Sal Borgese','John Cazale','Anton Coppola','Carmine Coppola','Gia Coppola','Luciano Foti','Ron Jeremy','Joe Drago','Paco Reconti','Remo Remotti','Robert Cicchini','John Abineri','Jessica DiCicco'],
screenplay:['Mario Puzo','Francis Ford Coppola'],
production:['Francis Ford Coppola'],
music:['Carmine Coppola','Nino Rota'],
camera:['Gordon Willis'],
cut:['Walter Murch','Barry Malkin','Lisa Fruchtman'],
sound:['Richard Beggs','Michael Minkler','Gregg Landaker'],
scenography:['Dean Tavoularis'],
masks:['Fabrizio Sforza','Carl Fullerton','Grazia De Rossi'],
costumes:['Milena Canonero']},
{title:'Gentlemen Boys',
titleCZ:'Páni kluci',
year:1975,
runtime:87,
countries:['Czechoslovakia'],
genres:['Adventure','Family','Comedy'],
director:['Věra Plívová-Šimková'],
actors:['Michael Dymek','Petr Voříšek','Petr Starý','Magdalena Reifová','Jitka Chalupníková','David Vlček','Bohumil Luxík','Iva Janžurová','Zdena Hadrbolcová','Josef Somr','Petr Nárožný','Václav Lohniský','Karel Augusta','Jiří Lábus','Karel Dellapina','Lubomír Kostelka','Jan Vostrčil','Karla Chadimová','Vít Olmer','Josef Laufer','Vladimír Ptáček','Viktor Maurer','Petr Skarke','Michal Hofbauer','Daniel Netušil','Antonín Jedlička','Jana Rabová','Martin Růžek','Jiří Wohanka','Mirko Musil','Eva Svobodová'],
basedOn:['Mark Twain'],
screenplay:['Jan Procházka'],
music:['Petr Hapka'],
camera:['Emil Sirotek'],
cut:['Miroslav Hájek'],
sound:['Dobroslav Šrámek'],
scenography:['Boris Moravec'],
masks:['Jaroslav Čermák','Růžena Richterová','František Pilný'],
costumes:['Theodor Pištěk ml.','Aša Teršová','Zdeňka Čochnařová']},
{title:'JFK',
titleCZ:'JFK',
year:1991,
runtime:189,
countries:['USA','France'],
genres:['Drama','History','Thriller'],
director:['Oliver Stone'],
actors:['Kevin Costner','Kevin Bacon','Tommy Lee Jones','Laurie Metcalf','Gary Oldman','John Larroquette','Beata Poźniak Daniels','Michael Rooker','Ron Rifkin','Jay O. Sanders','Sissy Spacek','Richard Rutowski','Wayne Knight',"Vincent D'Onofrio",'Pruitt Taylor Vince','Sally Kirkland','Dale Dye','Edward Asner','Jack Lemmon','Joe Pesci','Walter Matthau','Tony Plana','Tomas Milian','John Candy','Martin Sheen','Sean Stone','Edwin Neal','Lolita Davidovich','Frank Whaley','Donald Sutherland','Bob Gunton','Ron Jackson','Bob Orwig','Gary Grubbs','John S. Davies','George R. Robertson','Chuck Kelley','Jerry Douglas','Jacqueline Kennedy','Leonid Iljič Brežněv','Lyndon B. Johnson','Martin Luther King','Malcolm X','Red Mitchell','Brian Doyle-Murray','Perry R. Russo','J.J. Johnston','Peter Maloney','Gail Cronauer','Jacquelyn Twodat Jackson','Ellen McElduff','John Finnegan','Wayne Tippit','Victor Kempster','Jo Anderson','Baxter Harris','Marco Perella','Darryl Cox','Alex Rodine','Duane Grey','James N. Harrell','Ryan MacDonald','Willem Oltmans','Bill Bolender','Gil Glasgow','Benjamin Dane','Richmond Hoxie','Terence Rosemore','Ludwig Erhard','John Seitz','Marie Del Marco','Lee Harvey Oswald','John Connally','Robert J. Groden'],
screenplay:['Oliver Stone','Zachary Sklar'],
production:['A. Kitman Ho','Oliver Stone'],
music:['John Williams'],
camera:['Robert Richardson'],
cut:['Pietro Scalia','Joe Hutshing'],
sound:['Michael Minkler','Gregg Landaker','Wylie Stateman','Tod A. Maitland'],
scenography:['Victor Kempster','Crispian Sallis'],
masks:['Craig Berkeley'],
costumes:['Marlene Stewart']},
{title:'Ben-Hur',
titleCZ:'Ben Hur',
year:1959,
runtime:212,
countries:['USA'],
genres:['Adventure','Drama','History'],
director:['William Wyler'],
actors:['Charlton Heston','Jack Hawkins','Haya Harareet','Stephen Boyd','Hugh Griffith','Martha Scott',"Cathy O'Donnell",'Sam Jaffe','Finlay Currie','Frank Thring','Terence Longdon','George Relph','André Morell','Ferdy Mayne','Giuliano Gemma','Laurence Payne','Ralph Truman','John Le Mesurier','Lando Buzzanca','José Greci','Marina Berti','Raimondo Van Riel','Pietro Tordi','Enzo Fiermonte','Mino Doro','Aldo Pini','Richard Hale','Nazzareno Zamperla','Tutte Lemkow','Robert Brown','Aldo Silvani','Ady Berber','Edwin Richfield','Richard Coleman','Franco Fantasia','Dervis Ward','Joe Canutt','Liana Del Balzo','John Horsley','Gianni Solaro','Antonio Corevi','Bruno Ariè','Hector Ross','Diego Pozzetto','David Davies','Howard Lang','Gianni Di Segni'],
basedOn:['Lew Wallace'],
screenplay:['Karl Tunberg'],
production:['William Wyler','Sam Zimbalist'],
music:['Miklós Rózsa'],
camera:['Robert Surtees'],
cut:['John D. Dunning','Ralph E. Winters','Margaret Booth'],
sound:['Franklin Milton'],
scenography:['William A. Horning','Vittorio Valentini'],
masks:['John Truwe','Gabriella Borzelli'],
costumes:['Elizabeth Haffenden']},
{title:'Interstellar',
titleCZ:'Interstellar',
year:2014,
runtime:169,
countries:['USA','UK','Canada'],
genres:['Sci-Fi','Adventure','Drama'],
director:['Christopher Nolan'],
actors:['Matthew McConaughey','Anne Hathaway','Jessica Chastain','Matt Damon','Mackenzie Foy','Wes Bentley','David Gyasi','Michael Caine','Casey Affleck','John Lithgow','Ellen Burstyn','Elyes Gabel','Topher Grace','Leah Cairns','David Oyelowo','Bill Irwin','William Devane','Liam Dickinson','Timothée Chalamet','Collette Wolfe','Francis X. McCarthy','Jeff Hephner','Josh Stewart','Russ Fega','Lena Georgas'],
screenplay:['Jonathan Nolan','Christopher Nolan'],
production:['Lynda Obst','Christopher Nolan','Emma Thomas'],
music:['Hans Zimmer'],
camera:['Hoyte van Hoytema'],
cut:['Lee Smith'],
sound:['Richard King','Gary Rizzo','Gregg Landaker','Michael Semanick','Mark Weingarten'],
scenography:['Nathan Crowley','Gary Fettis'],
masks:['Patricia Dehaney','Luisa Abel'],
costumes:['Mary Zophres']},
{title:'WALL-E',
titleCZ:'VALL-I',
year:2008,
runtime:98,
countries:['USA'],
genres:['Animation','Adventure','Family','Sci-Fi'],
director:['Andrew Stanton'],
actors:['Ben Burtt','Elissa Knight','Jeff Garlin','Sigourney Weaver','Fred Willard','Kathy Najimy','MacInTalk','Kim Kopf','Garrett Palmer','Teddy Newton','Jim Ward','Pete Docter','Andrew Stanton','John Ratzenberger','John Cygan','Teresa Ganzel','Donald Fullilove','Lori Alan','Paul Eiding','Jan Rabson','Niki McElroy'],
basedOn:['Andrew Stanton','Pete Docter'],
screenplay:['Andrew Stanton','Jim Reardon'],
music:['Thomas Newman'],
camera:['Jeremy Lasky'],
cut:['Stephen Schaffer'],
sound:['Matthew Wood','Juan Peralta','Michael Semanick','Sean Byrne']},
{title:'Philadelphia',
titleCZ:'Philadelphia',
year:1993,
runtime:125,
countries:['USA'],
genres:['Drama'],
director:['Jonathan Demme'],
actors:['Tom Hanks','Denzel Washington','Roberta Maxwell','Mark Sorensen Jr.','Jeffrey Williamson','Charles Glenn','Anna Deavere Smith','Joanne Woodward','Jason Robards','Chandra Wilson','Antonio Banderas','Paul Lazar','Bradley Whitford','Warren Miller','Tracey Walter','Ann Dowd','John Bedford Lloyd','Adam LeFevre','Daniel von Bargen','Mary Steenburgen','Obba Babatundé','Charles Napier','Roger Corman','Kathryn Witt','Quentin Crisp','Jaime Gomez','Stephanie Roth Haberle','Tak Fujimoto','Harry Northup','Robert Ridgely','Gene Borkan','Gary Goetzman','Ford Wheeler','José Castillo','Roy Blount Jr.','Ron Vawter','Charles Techman','Robert W. Castle','Andre B. Blake','Kenneth Utt','Daniel Chapman','Bob Bowersox'],
screenplay:['Ron Nyswaner'],
production:['Edward Saxon','Jonathan Demme'],
music:['Howard Shore'],
camera:['Tak Fujimoto'],
cut:['Craig McKay'],
sound:['Tom Fleischman','Ron Bochar'],
scenography:['Kristi Zea',"Karen O'Hara"],
masks:['Carl Fullerton'],
costumes:['Colleen Atwood']},
{title:'Two Men in Town',
titleCZ:'Dva muži ve městě',
year:1973,
runtime:90,
countries:['France','Italy'],
genres:['Crime','Drama'],
director:['José Giovanni'],
actors:['Jean Gabin','Alain Delon','Mimsy Farmer','Victor Lanoux','Cécile Vassort','Ilaria Occhini','Guido Alberti','Malka Ribowska','Christine Fabréga','Gérard Depardieu','Robert Castel','Albert Augier','Maurice Barrier','Paul Beauvais','Gabriel Briand','Pierre Collet','Jean-Pierre Honoré','Patrick Lancelot','Raymond Loyer','Jacques Marchand','Armand Mestral','Roland Monod','Dominique Zardi','Jacques Monod','Bernard Giraudeau','Michel Bouquet','Lucie Arnold','Pierre Asso','Jean Degrave','Nicole Desailly','Michel Fortin','Bernard Musson','Jacques Pisias','Jacques Rispal','Jean Rougeul','André Rouyer','Gilbert Servien','Frank Stuart'],
screenplay:['José Giovanni'],
production:['Alain Delon'],
music:['Philippe Sarde'],
camera:['Jean-Jacques Tarbès'],
cut:['Françoise Javet'],
sound:['Jean Rieul'],
scenography:['Jean-Jacques Caziot'],
masks:['Pierre Vadé'],
costumes:['Hélène Nourry']},
{title:'Les Misérables',
titleCZ:'Bídníci',
year:2012,
runtime:157,
countries:['UK','USA'],
genres:['Musical','Drama','Romance','History'],
director:['Tom Hooper'],
actors:['Hugh Jackman','Russell Crowe','Anne Hathaway','Amanda Seyfried','Eddie Redmayne','Helena Bonham Carter','Sacha Baron Cohen','Samantha Barks','Aaron Tveit','Josef Altin','Colm Wilkinson','Isabelle Allen','Edward Lewis French','Lily Laight','Charlotte Hope','Ondra Dorian','Julian Seager','Karol Steele','Andrea Deck','Patrick Godfrey','George Blagden','Kate Fleetwood','Kerry Ingram','Richard Dixon','Ashley Artus','Adrian Scarborough','Daniel Evans','Daniel Huttlestone','Antonia Clarke','Charlotte Spencer','Tony Rohr','Georgie Glen','Bertie Carvel','Lynne Wilmot','Michael Jibson','Kenton Hall','Paul Thornley','Hugh Skinner','Hannah Waddingham','Andy Beckwith','Lottie Steer','Sean Buckley','Philip Philmar','Andrew Havill','Paul Leonard','James Greene','David Cann','Tim Downie','Martyn Mayger','Julian Bleach','James Simmons','Sarah Flind','Richard Cordery','John W. G. Harley','Ben Ryan-Steele','Stephen Bent','Jamie Muscato','Ella Hunt','Frances Ruffelle','Hadley Fraser','Ian Pirie','Helen Cotterill','Heather Chasen','Martin Marquez','Clare Foster','Matt Hookings','Aisling Hughes','Adam Nowell','Josh Wichard','Amy Griffiths','Lorna Brown','Bessie Carter','Dominic Applewhite','Fra Fee','Jaygann Ayeh','Jack Chissick','Nancy Sullivan','Alistair Brammer','Julie Vollono','Ross McCormack'],
basedOn:['Victor Hugo'],
screenplay:['William Nicholson','Alain Boublil','Claude-Michel Schönberg','Herbert Kretzmer'],
production:['Tim Bevan','Eric Fellner','Debra Hayward','Cameron Mackintosh'],
camera:['Danny Cohen'],
cut:['Melanie Ann Oliver','Chris Dickens'],
sound:['Andrew Stirk','John Warhurst','Simon Hayes','Andy Nelson','Mark Paterson'],
scenography:['Eve Stewart','Grant Armstrong','Anna Lynch-Robinson','Su Whitaker'],
masks:['Emma Scott','Jane Walker','Karen Cohen','Rebecca Cole','Paul Gooch','Uxue Laguardia','Lisa Westcott'],
costumes:['Paco Delgado']},
{title:'The Peasants',
titleCZ:'Jagna',
year:2023,
runtime:114,
countries:['Poland','Serbia','Lithuania'],
genres:['Drama','History','Animation'],
director:['DK Welchman','Hugh Welchman'],
actors:['Kamila Urzędowska','Robert Gulaczyk','Mirosław Baka','Sonia Mietielica','Ewa Kasprzyk','Andrzej Konopka','Małgorzata Kożuchowska','Julia Wieniawa-Narkiewicz','Cyprian Grabowski','Mateusz Rusin','Cezary Łukaszewicz','Dorota Stalińska','Helena Korczycka','Andrzej Mastalerz','Sonia Bohosiewicz','Maciej Musiał','Anna Grzeszczak-Hutek','Mateusz Malecki','Lech Dyblik','Klara Bielawka','Piotr Srebrowski','Mariusz Kiljan','Jarosław Gruda','Małgorzata Maślanka','Mariusz Urbaniec','Szymon Kukla','Andrzej Luter','Jadwiga Wianecka','Marek Pyś'],
basedOn:['Władysław Reymont'],
screenplay:['DK Welchman','Hugh Welchman'],
production:['Hugh Welchman','Sean Bobbitt'],
music:['Łukasz Rostkowski'],
camera:['Kamil Polak','Radosław Ładczuk','Szymon Kuriata'],
scenography:['Elwira Pluta'],
masks:['Waldemar Pokromski'],
costumes:['Katarzyna Lewińska']},
{title:'Falling Down',
titleCZ:'Volný pád',
year:1993,
runtime:113,
countries:['USA','France','UK'],
genres:['Drama','Crime','Psychology','Thriller'],
director:['Joel Schumacher'],
actors:['Michael Douglas','Robert Duvall','Barbara Hershey','Rachel Ticotin','Tuesday Weld','Frederic Forrest','Lois Smith','Joey Hope Singer','Ebbe Roe Smith','Michael Paul Chan','Raymond J. Barry','D. W. Moffett','Steve Park','Kimberly Scott','James Keane','Macon McCalman','Richard Montoya','Eddie Frias','Karina Arroyave','Benjamin Mouton','Dean Hallo','James Morrison','John Fleck','Brent Hinkley','Dedee Pfeiffer','Carole Androsky','Vondie Curtis-Hall','Spencer Rochfort','Carole White','John Fink','Jack Kehoe','Jack Betts','Al Mancini','John Diehl','Amy Morton','Susie Singer Carter','Wayne Duvall','Jeffrey Byron','Tobias Jelinek','Deron McBee'],
screenplay:['Ebbe Roe Smith'],
production:['Arnold Kopelson','Herschel Weingrod','Timothy Harris'],
music:['James Newton Howard'],
camera:['Andrzej Bartkowiak'],
cut:['Paul Hirsch'],
sound:['Charles L. Campbell','Louis L. Edemann','Tom E. Dahl'],
scenography:['Barbara Ling'],
masks:['Stephen Abrums'],
costumes:['Marlene Stewart']},
{title:"What's Eating Gilbert Grape",
titleCZ:'Co žere Gilberta Grapea',
year:1993,
runtime:118,
countries:['USA'],
genres:['Drama'],
director:['Lasse Hallström'],
actors:['Johnny Depp','Leonardo DiCaprio','Juliette Lewis','Mary Steenburgen','Darlene Cates','Laura Harrington','Mary Kate Schellhardt','Kevin Tighe','John C. Reilly','Crispin Glover','Joe Stevens','Steve Cook','Cameron Finley','Libby Villari','Mona Lee Fultz','David Stanford'],
basedOn:['Peter Hedges'],
screenplay:['Peter Hedges'],
production:['Bertil Ohlsson','David Matalon'],
music:['Alan Parker','Björn Isfält'],
camera:['Sven Nykvist'],
cut:['Andrew Mondshein'],
sound:['Lee Dichter'],
scenography:['Bernt Amadeus Capra','Gretchen Rau'],
costumes:['Renée Ehrlich Kalfus']},
{title:'Asterix in Britain',
titleCZ:'Asterix v Británii',
year:1986,
runtime:79,
countries:['France'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Pino Van Lamsweerde'],
actors:['Roger Carel','Serge Sauvion','Pierre Tornade','Henri Labussière','Pierre Mondy','Nicolas Silberg','Maurice Risch','Billy Kearns','Alain Doutey','Pierre Mirat','Steve Gadler','Albert Augier','Patrick Floersheim','Gérard Croce','Gordon Heath','Michel Elias'],
basedOn:['René Goscinny','Albert Uderzo'],
music:['Vladimir Cosma'],
cut:['Monique Isnardon','Robert Isnardon']},
{title:'Little Big Man',
titleCZ:'Malý velký muž',
year:1970,
runtime:147,
countries:['USA'],
genres:['Western','Drama','Comedy','Adventure'],
director:['Arthur Penn'],
actors:['Dustin Hoffman','Faye Dunaway','náčelník Dan George','Martin Balsam','Richard Mulligan','Jeff Corey','William Hickey','Aimee Eccles','Kelly Jean Peters','Jesse Vint','Thayer David','Lou Cutell','M. Emmet Walsh','Alan Oppenheimer','Don Brodie','James Anderson','Tracy Hotchner','Jack Bannon','Ruben Moreno','Cal Bellini','Ken Mayer','Jack Mullaney','Carole Androsky','Philip Kenneally','Herbert Nelson','Bud Cokes','Bert Conway'],
basedOn:['Thomas Berger'],
screenplay:['Calder Willingham'],
production:['Stuart Millar'],
music:['John Hammond'],
camera:['Harry Stradling Jr.'],
cut:['Dede Allen'],
sound:['Bud Alper'],
scenography:['Dean Tavoularis','George R. Nelson'],
masks:['Terry Miles','Dick Smith'],
costumes:['Dorothy Jeakins']},
{title:'Happy End',
titleCZ:'Happy end',
year:1967,
runtime:71,
countries:['Czechoslovakia'],
genres:['Comedy','Experimental'],
director:['Oldřich Lipský'],
actors:['Vladimír Menšík','Jaroslava Obermaierová','Josef Abrhám','Bohuš Záhorský','Stella Zázvorková','Jiří Steimar','Martin Růžek','Bedřich Prokoš','Josef Hlinomaz','Jaroslav Štercl','Helena Růžičková','Mirko Musil','Lubomír Bryg','Lena Birková','Alena Bradáčová','Vladimír Čech st.','Valtr Levý','Petr Sedlák','Lubomír Kostelka','Stanislav Litera','Oldřich Lukeš','Miloš Macourek','Oldřich Velen','Viktor Očásek','Jan Maška','Ilona Cicvárková','Milena Jandová','Jiří Kasík','Vojtěch Kheck','Milan Kindl','Josef Krameš','Ivan Kraus','Jan Kraus','Jiří Sýkora','Kateřina Krausová','Helena Rychterová','Otakar Kuttner','Ladislav Gzela','Vlastimila Vlková','Jan Fleischer','Jan Obrda','Jan Odl','Marie Popelková','Otakar Rödr','Karel Mikuláštík','Jan Sieber','Ela Šilarová','Václav Štekl','Jan Teplý st.','Jaroslav Tomsa','Rudolf Veselý','Soňa Zborníková-Stenová','Jiřina Hladíková','Rolf Mey-Dahl'],
screenplay:['Oldřich Lipský','Miloš Macourek'],
music:['Vlastimil Hála'],
camera:['Vladimír Novotný'],
cut:['Miroslav Hájek'],
sound:['Josef Vlček'],
scenography:['Karel Škvor'],
masks:['Otakar Košťál'],
costumes:['Eva Lackingerová']},
{title:'City Lights',
titleCZ:'Světla velkoměsta',
year:1931,
runtime:87,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Charlie Chaplin'],
actors:['Charlie Chaplin','Virginia Cherrill','Harry Myers','Albert Austin','Jean Harlow','Henry Bergman','Robert Parrish','Tiny Ward','Hank Mann','Robert Graves','Leila McIntyre','James Donnelly','Stanhope Wheatcroft','Eddie Baker','Granville Redmond','Al Ernest Garcia'],
screenplay:['Charlie Chaplin','Harry Crocker'],
production:['Charlie Chaplin'],
music:['Alfred Newman','Charlie Chaplin'],
camera:['Roland Totheroh'],
cut:['Charlie Chaplin','Willard Nico']},
{title:'Witness for the Prosecution',
titleCZ:'Svědek obžaloby',
year:1957,
runtime:116,
countries:['USA'],
genres:['Crime','Drama','Mystery','Thriller'],
director:['Billy Wilder'],
actors:['Tyrone Power','Marlene Dietrich','Charles Laughton','Elsa Lanchester','John Williams','Henry Daniell','Ian Wolfe','Torin Thatcher','Norma Varden',"Una O'Connor",'Philip Tonge','Ruta Lee','Patrick Aherne','Eddie Baker','Danny Borzage','George Bruggeman','George Calliga','Steve Carruthers','Marjorie Eaton','Franklyn Farnum','Bess Flowers','Herschel Graham','Stuart Hall','Colin Kenny','Paul Kruger','Wilbur Mack','Thomas Martin','Frank McLure','Ottola Nesmith',"William H. O'Brien","Monty O'Grady","J. Pat O'Malley",'George Pelling','Paul Power','Jack Raine','Leoda Richards','John Roy','Jeffrey Sayre','Norbert Schiller','Scott Seaton','Cap Somers','Bert Stevens','Arthur Tovey','Glen Walters','Ben Wright'],
basedOn:['Agatha Christie'],
screenplay:['Billy Wilder','Harry Kurnitz','Agatha Christie'],
production:['Arthur Hornblow Jr.'],
music:['Matty Malneck'],
camera:['Russell Harlan'],
cut:['Daniel Mandell'],
sound:['Fred Lau'],
scenography:['Alexandre Trauner','Howard Bristol'],
masks:['Ray Sebastian','Harry Ray','Gustaf Norin'],
costumes:['Joe King']},
{title:'X-Men: First Class',
titleCZ:'X-Men: První třída',
year:2011,
runtime:126,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Thriller'],
director:['Matthew Vaughn'],
actors:['James McAvoy','Michael Fassbender','Jennifer Lawrence','Kevin Bacon','January Jones','Nicholas Hoult','Rose Byrne','Lucas Till','Edi Gathegi','Jason Flemyng','Morgan Lily','Zoë Kravitz','Caleb Landry Jones','Oliver Platt','Bill Milner','Laurence Belcher','Matt Craven','Álex González','Hugh Jackman','Rebecca Romijn','Corey Johnson','Glenn Morshower','James Remar','Ludger Pistor','Michael Ironside','Rade Šerbedžija','Ray Wise','Olek Krupa','David Agranov','Annabelle Wallis','Brendan Fehr','Sasha Pieterse','Jason Beghe','Tony Curran','Randall Batinkoff','Carlos Besse Peres','Arthur Darbinyan','David Joseph Martinez','Demetri Goritsas','Neil Fingleton','Gene Farber','Andy Callaghan','Andrei Zayats','Michael Medeiros','Wilfried Hochholdinger','Georg Nikoloff','Éva Magyar','Lasco Atkins','Katrine De Candole','Teresa Mahoney','Peter Stark','Shaun Gerardo','David Crow','Kieran Patrick Campbell','Robert Eames','Charles L. Campbell','Laura Jean Marsh','Dominika Van Santen','Don Creech'],
screenplay:['Ashley Miller','Zack Stentz','Jane Goldman','Matthew Vaughn'],
production:['Simon Kinberg','Lauren Shuler Donner','Gregory Goodman','Bryan Singer'],
music:['Henry Jackman','Jo Blankenburg'],
camera:['John Mathieson'],
cut:['Lee Smith','Eddie Hamilton'],
sound:['Rob Prynne','Ron Bartlett','Doug Hemphill','Simon Hayes','John A. Larsen','Matthew Collinge','Craig Berkey'],
scenography:['Chris Seagers','Steve Cooper','Su Whitaker','Grant Armstrong'],
masks:['Dave Elsey','Steve La Porte','Amber Sibley','Mike Elizalde',"Conor O'Sullivan",'Fran Needham','Nicky Knowles','Mark Coulier','Shauna Giesbrecht','Frances Hannon','Göran Lundström','Jessica Brooks','David Malinowski'],
costumes:['Sammy Sheldon Differ']},
{title:'The Last of the Mohicans',
titleCZ:'Poslední Mohykán',
year:1992,
runtime:107,
countries:['USA'],
genres:['Action','Adventure','Drama','Romance','War'],
director:['Michael Mann'],
actors:['Daniel Day-Lewis','Madeleine Stowe','Jodhi May','Russell Means','Wes Studi','Eric Schweig','Steven Waddington','Maurice Roëves','Patrice Chéreau','Edward Blatchford','Terry Kinney','Pete Postlethwaite','Colm Meaney','Dylan Baker','Scott Means','Jared Harris','Sebastian Roché','David Schofield','Mark Joy','Benton Jennings','Don Tilley','Tom McGowan','Tim Hopper','Dennis Banks','Patrick Fitzgerald','Malcolm Storry','Tracey Ellis','Gregory Zaragoza'],
basedOn:['James Fenimore Cooper'],
screenplay:['Michael Mann','Christopher Crowe','Philip Dunne'],
production:['Michael Mann','Hunt Lowry'],
music:['Trevor Jones','Randy Edelman'],
camera:['Dante Spinotti'],
cut:['Dov Hoenig','Arthur Schmidt'],
sound:['Paul Massey','Doug Hemphill'],
scenography:['Wolf Kroeger','Jim Erickson'],
masks:['Peter Robb-King','Nick Dudman','Jeff Goodwin','Cecilia Verardi','Verne Caruso'],
costumes:['Elsa Zamparelli']},
{title:'Apache Gold',
titleCZ:'Vinnetou',
year:1963,
runtime:97,
countries:['Germany','Yugoslavia','Italy'],
genres:['Western','Adventure'],
director:['Harald Reinl'],
actors:['Lex Barker','Pierre Brice','Mario Adorf','Marie Versini','Walter Barnes','Ralf Wolter','Milivoj Popovič-Mavid','Branko Špoljar','Nikša Stefanini','Dunja Rajter','Chris Howland','Husein Čokić','Demeter Bitenc','Tomislav Erak','Hrvoje Svob','Dusko Dobudj','Vladimir Krstulović','Ilija Ivezič','Tedy Sotosek','Antun Nalis','Ana Kranjcec','Sime Jagarinac','Gojko Mitić','Karl Dall','Peter Ehlebracht','Rainer Brandt','Gerd Duwner','Knut Hartwig','Ursula Heyer','Benno Hoffmann','Gert Günther Hoffmann','Heinz Lausch','Arnold Marquis','Ilse Pagé','Jochen Schröder','Christian Wolff'],
basedOn:['Karl May'],
screenplay:['Harald G. Petersson'],
production:['Horst Wendlandt'],
music:['Martin Böttcher'],
camera:['Ernst W. Kalinke'],
cut:['Hermann Haller'],
sound:['Fedor Jeler','Max Galinsky'],
scenography:['Vladimir Tadej'],
costumes:['Irms Pauli']},
{title:'The Towering Inferno',
titleCZ:'Skleněné peklo',
year:1974,
runtime:165,
countries:['USA'],
genres:['Thriller','Drama','Action','Catastrophic'],
director:['John Guillermin'],
actors:['Steve McQueen','Paul Newman','William Holden','Faye Dunaway','Fred Astaire','Susan Blakely','Richard Chamberlain','Jennifer Jones','O.J. Simpson','Robert Vaughn','Robert Wagner','Susan Flannery','Sheila Allen','Norman Burton','Jack Collins','Don Gordon','Felton Perry','Gregory Sierra','Dabney Coleman','Paul Comi','Jennifer Rhodes','William Bassett','George Wallace','John Crawford','Ross Elliott','Olan Soule','Ernie F. Orsatti','Mike Lookinland','Patrick Culliton','William Traylor','Paul King','Norman Grabowski','David Armstrong','Dale Johnson','Scott Newman','Peter Paul Eastman','Leoda Richards','Robert Hitchcock','Robert Buckingham','Hank Robinson','Maureen McGovern','Larry Carr'],
basedOn:['Richard Martin Stern','Thomas N. Scortia','Frank M. Robinson'],
screenplay:['Stirling Silliphant'],
production:['Irwin Allen'],
music:['John Williams'],
camera:['Fred J. Koenekamp'],
cut:['Harold F. Kress','Carl Kress'],
sound:['Don Hall'],
scenography:['William J. Creber'],
masks:['Monty Westmore','Emile LaVigne','Naomi Cavin'],
costumes:['Paul Zastupnevich']},
{title:'Lady and the Tramp',
titleCZ:'Lady a Tramp',
year:1955,
runtime:75,
countries:['USA'],
genres:['Animation','Family','Romance','Music'],
director:['Hamilton Luske','Wilfred Jackson','Clyde Geronimi'],
actors:['Peggy Lee','Verna Felton','George Givot','Bill Thompson','Dal McKennon','Alan Reed'],
basedOn:['Ward Greene'],
screenplay:['Louis Pollock'],
production:['Walt Disney'],
music:['Oliver Wallace'],
cut:['Donald Halliday']},
{title:'Of Mice and Men',
titleCZ:'O myších a lidech',
year:1992,
runtime:115,
countries:['USA'],
genres:['Drama'],
director:['Gary Sinise'],
actors:['John Malkovich','Gary Sinise','Ray Walston','Casey Siemaszko','Sherilyn Fenn','John Terry','Richard Riehle','Alexis Arquette','Joe Morton','Noble Willingham','Mark Boone Junior','David Steen','Peer Schmidt','Alfred Schieske','Moira Sinise'],
basedOn:['John Steinbeck'],
screenplay:['Horton Foote'],
production:['Russell Smith'],
music:['Mark Isham'],
camera:['Kenneth MacMillan'],
cut:['Robert L. Sinise'],
sound:['Joel Fein','Carlos Delarios'],
scenography:['David Gropman'],
costumes:['Shay Cunliffe']},
{title:'North by Northwest',
titleCZ:'Na sever Severozápadní linkou',
year:1959,
runtime:131,
countries:['USA'],
genres:['Thriller','Mystery','Adventure','Romance'],
director:['Alfred Hitchcock'],
actors:['Cary Grant','Eva Marie Saint','James Mason','Jessie Royce Landis','Leo G. Carroll','Josephine Hutchinson','Philip Ober','Martin Landau','Adam Williams','Les Tremayne','Robert Ellenstein','Lawrence Dobkin','Philip Coolidge','Alfred Hitchcock','Jimmy Cross','Jeremy Slate','Patricia Cutts','Edward Binns','Edward Platt','Bess Flowers','Ned Glass','Ken Lynch','Frank Wilcox','Malcolm Atterbury','Stanley Adams','Robert Shayne','Bert Stevens','Dale Van Sickel','Kenner G. Kemp','Jeffrey Sayre','Robert Williams','Len Hendry','Colin Kenny','Arthur Tovey','John Beradino','Frank Marlowe','Walter Coy','Tom Greenway','Cosmo Sardo','Jesslyn Fax','Harry Strang','Harvey Stephens','Carleton Young','Helen Spring','Olan Soule','Patrick McVey','Adolph Faylauer','Carl M. Leviness','Nora Marlowe','Tol Avery','Scott Seaton','Harry Seymour','Howard Negley','James Mccallion','Alexander Lockwood',"Monty O'Grady",'James Gonzalez','Jack Daly','Ralph Reed','Steve Carruthers','Robert Haines','Paul Genge','Baynes Barron','Tommy Farrell','Bobby Johnson','Carl Milletaire','Eugene Jackson','Murray Pollack','Sally Fraser','John Damler','Hans Moebus','Andy Albin','Sam Bagley','Wilson Wood','Lucille Curtis','Doreen Lang','Thomas Martin','Perk Lazelle','Don Anderson','Stuart Hall','Paula Winslowe','Bill Catching','Anne Anderson','Maudie Prickett'],
screenplay:['Ernest Lehman'],
production:['Alfred Hitchcock'],
music:['Bernard Herrmann'],
camera:['Robert Burks'],
cut:['George Tomasini'],
sound:['Franklin Milton'],
scenography:['Robert F. Boyle','William A. Horning','Henry Grace','Merrill Pye','Frank R. McKelvy'],
masks:['John Truwe','William Tuttle','Peggy Shannon']},
{title:'Castle in the Sky',
titleCZ:'Laputa: Nebeský zámek',
year:1986,
runtime:124,
countries:['Japan'],
genres:['Animation','Action','Adventure','Fantasy'],
director:['Hajao Mijazaki'],
actors:['Keiko Jokozawa','Majumi Tanaka','Ičiró Nagai','Megumi Hajašibara','Tošihiko Seki','Minori Terada','Kotoe Hacui','Tarako','Hóčú Ócuka',"Šin'ja Ótaki",'Jošito Jasuhara','Reiko Suzuki','Tomomiči Nišimura','Takuzó Kamijama','Rjúdži Saikači','Hiroši Ito','Mine Eken','Masaši Sugawara','Sukekijo Kamejama','Takahiro Hirai'],
screenplay:['Hajao Mijazaki'],
production:['Isao Takahata'],
music:['Džó Hisaiši'],
camera:['Eberhard Geick'],
cut:['Jošihiro Kasahara','Takeši Sejama'],
sound:['Lothar Mankewitz']},
{title:'The Hill',
titleCZ:'Pahorek',
year:1965,
runtime:121,
countries:['UK'],
genres:['Drama','War'],
director:['Sidney Lumet'],
actors:['Sean Connery','Harry Andrews','Ian Bannen','Ossie Davis','Ian Hendry','Michael Redgrave','Norman Bird','Howard Goorney','Neil McCarthy','Roy Kinnear','Alfred Lind','Jack Watson','Richard Easton','Alfred Lynch','Tony Caunter'],
screenplay:['Ray Rigby','Ray Rigby'],
production:['Kenneth Hyman'],
camera:['Oswald Morris'],
cut:['Thelma Connell']},
{title:'The Big Country',
titleCZ:'Velká země',
year:1958,
runtime:165,
countries:['USA'],
genres:['Western','Drama','Romance'],
director:['William Wyler'],
actors:['Gregory Peck','Jean Simmons','Carroll Baker','Charlton Heston','Burl Ives','Charles Bickford','Alfonso Bedoya','Chuck Connors','Chuck Hayward','Richard Alexander','Chuck Roberson','Dorothy Adams','Donald Kerr','Ralph Sanford','Buff Brady','Harry Cheshire','John McKee','Rudy Bowman'],
basedOn:['Donald Hamilton'],
screenplay:['James R. Webb','Sy Bartlett','Robert Wilder','Robert Wyler','Jessamyn West'],
production:['William Wyler','Gregory Peck'],
music:['Jerome Moross'],
camera:['Franz Planer'],
cut:['Robert Belcher','John Faure'],
sound:['Roger Heman Sr.'],
scenography:['Frank Hotaling','Edward G. Boyle'],
masks:['Dan Greenway'],
costumes:['Yvonne Wood','Emile Santiago']},
{title:'Dangal',
titleCZ:'Dangal',
year:2016,
runtime:161,
countries:['India'],
genres:['Drama','Biographic','Sport'],
director:['Nitesh Tiwari'],
actors:['Aamir Khan','Sakshi Tanwar','Fatima Sana Shaikh','Sanya Malhotra','Aparshakti Khurana','Zaira Wasim','Girish Kulkarni','Ritvik Sahore','Shishir Sharma','Anurag Arora','Vivan Bhatena','Shivam Sharma','Vaishnavi Kadam'],
screenplay:['Nitesh Tiwari','Piyush Gupta','Shreyas Jain','Nikhil Mehrotra'],
production:['Siddharth Roy Kapur','Aamir Khan','Kiran Rao'],
music:['Pritam Chakraborty'],
camera:['Setu'],
cut:['Ballu Saluja'],
scenography:['Laxmi Keluskar'],
costumes:['Maxima Basu']},
{title:'The Last Samurai',
titleCZ:'Poslední samuraj',
year:2003,
runtime:148,
countries:['USA','New Zealand','Japan'],
genres:['Action','Adventure','Drama'],
director:['Edward Zwick'],
actors:['Ken Watanabe','Tom Cruise','William Atherton','Timothy Spall','Chad Lindberg','Billy Connolly','Tony Goldwyn','Masato Harada','Kojuki Kató','Šun Sugata','Šin Kojamada','Scott Wilson','Šičinosuke Nakamura','Hirojuki Sanada','Togo Igawa','Masaši Odate','Sósuke Ikemacu','John Koyama','Satoši Nikaidó','Seizó Fukumoto','Noriaki Kamata'],
screenplay:['John Logan','Edward Zwick','Marshall Herskovitz'],
production:['Tom Cruise','Edward Zwick','Scott Kroopf','Tom Engelman','Paula Wagner'],
music:['Hans Zimmer'],
camera:['John Toll'],
cut:['Victor Du Bois','Steven Rosenblum'],
sound:['Andy Nelson','Anna Behlmer','Mark P. Stoeckinger'],
scenography:['Jess Gonchor','Lilly Kilvert','Gretchen Rau'],
masks:['Kenny Myers','Daniel Parker','Michael Germain','Greg Nelson','Davina Lamont',"Conor O'Sullivan",'Matthew Smith','Duncan Jarman','Kimberley Spiteri','Colleen LaBaff','Louise Harris','Loulia Sheppard','Lois Burwell'],
costumes:['Ngila Dickson']},
{title:'Crash',
titleCZ:'Crash',
year:2004,
runtime:112,
countries:['USA','Germany'],
genres:['Drama','Crime'],
director:['Paul Haggis'],
actors:['Sandra Bullock','Don Cheadle','Matt Dillon','Jennifer Esposito','William Fichtner','Brendan Fraser','Terrence Howard','Ludacris','Thandiwe Newton','Ryan Phillippe','Larenz Tate','Tony Danza','Keith David','Loretta Devine','Michael Peña','Daniel Dae Kim','Ashlyn Sanchez','Shaun Toub','Nona Gaye','Bahar Soomekh','Alexis Rhee','Jack McGee','Dato Bachtadze','Jayden Lund','Beverly Todd','Ime Etuk','Sina Fredrich','Bruce Kirby','Joe Ordaz','Glenn Taranto','Octavio Gómez Berríos','Eddie J. Fernandez','Taber Cross','Billy Gallo','Karina Arroyave','Howard Fong','Kathleen York','Art Chudabala','Sylva Kelegian','Allan Steele'],
screenplay:['Paul Haggis','Bobby Moresco'],
production:['Bob Yari','Don Cheadle','Cathy Schulman','Mark R. Harris','Bobby Moresco'],
music:['Mark Isham'],
camera:['James M. Muro'],
cut:['Hughes Winborne'],
sound:['Adam Jenkins'],
scenography:['Laurence Bennett','Linda Lee Sutton'],
masks:['Kimberley Spiteri','Michelle Vittone'],
costumes:['Linda M. Bass']},
{title:"The Firemen's Ball",
titleCZ:'Hoří, má panenko',
year:1967,
runtime:71,
countries:['Czechoslovakia','Italy'],
genres:['Comedy'],
director:['Miloš Forman'],
actors:['Jan Vostrčil','Josef Šebánek','Ladislav Adam','Vratislav Čermák','František Debelka','Václav Novotný','František Paska','František Reinstein','Josef Řehořek','Josef Valnoha','J. Řeháček','Josef Kolb','Milada Ježková','František Svět','Jan Stöckl','Antonín Blažejovský','Josef Kutálek','Stanislav Holubec','Alena Květová','Olga Blechová-Matušková','Alena Freiburgová','Marie Slívová','V. Bartošová','V. Janusová','E. Šnajdrová','Hana Kuberová','Miluše Zelená','Jiří Líbal','Anna Liepoldová','Miloslav Balcar','Marie Kovářová','Jarmila Kuchařová','Vlastimila Vlková','Hana Hanusová','Stanislav Dytrich','F. Řehořková','M. Mejsnarová'],
screenplay:['Miloš Forman','Jaroslav Papoušek','Ivan Passer'],
production:['Carlo Ponti'],
music:['Karel Mareš'],
camera:['Miroslav Ondříček'],
cut:['Miroslav Hájek'],
sound:['Adolf Böhm'],
scenography:['Karel Černý'],
masks:['Rudolf Hammer','Marie Machová']},
{title:'Christian',
titleCZ:'Kristián',
year:1939,
runtime:95,
countries:['Czechoslovakia'],
genres:['Comedy','Romance'],
director:['Martin Frič'],
actors:['Oldřich Nový','Adina Mandlová','Nataša Gollová','Raoul Schránil','Bedřich Veverka','Jára Kohout','Anna Steimarová','Jaroslav Marvan','Čeněk Šlégl','Josef Bělský','František Paul','Aša Vašátková','Jarmila Holmová','Jan W. Speerger','Václav Mlčkovský','Miroslava Hromková','Přemysl Pražský','Doďa Pražský','Jaroslav Sadílek','Václav Piskáček','Ada Dohnal','Jiří Schreinzer','Sláva Grossmann','František Filipovský','Alois Dvorský','Antonín Zacpal','František Juhan','Vojta Merten','Jindřich Láznička','R. A. Strejka','Blažena Slavíčková','Jindřich Fiala','Marie Hrdličková','Rudolf Antonín Dvorský','Marie Vildová'],
screenplay:['Josef Gruss','Eduard Šimáček','Martin Frič','Yvan Noé'],
music:['Sláva Eman Nováček'],
camera:['Ferdinand Pečenka'],
cut:['Jan Kohout'],
sound:['Stanislav Vondraš'],
scenography:['Jan Zázvorka']},
{title:'The Professional',
titleCZ:'Profesionál',
year:1981,
runtime:109,
countries:['France'],
genres:['Action','Crime','Drama','Thriller'],
director:['Georges Lautner'],
actors:['Jean-Paul Belmondo','Jean Desailly','Cyrielle Clair','Marie-Christine Descouard','Elisabeth Margoni','Jean-Louis Richard','Michel Beaune','Bernard-Pierre Donnadieu','Pierre Saintons','Gérard Darrieu','Sidiki Bakaba','Baaron','Robert Hossein','Dany Kogan','Marc Lamole','Jacques Canselier','Bernard Marcellin','Jean-Claude Bouillaud','Claude-Bernard Perot','Yves Pignot','Cheik Doukouré',"Pascal N'Zonzi",'Serge Nubret','Guillaume Corea','André Weber','Michel Berreur','Julien Bukowski','Pierre Forget','René Lafleur','Maurice Auzel','Daniel Breton','Bele Mukeba','Samuel Nolison','Beate Kopp','Sidney Kotto','Charly Koubesserian','Pierre Vernier'],
basedOn:['Patrick Alexander'],
screenplay:['Georges Lautner','Jacques Audiard'],
production:['Jean-Paul Belmondo','Alain Belmondo'],
music:['Ennio Morricone'],
camera:['Henri Decaë'],
cut:['Michelle David'],
sound:['Alain Sempé','Maurice Gilbert'],
scenography:['Eric Moulard','Philippe Turlure'],
masks:['Charly Koubesserian'],
costumes:['Paulette Breil']},
{title:'Grave of the Fireflies',
titleCZ:'Hrob světlušek',
year:1988,
runtime:89,
countries:['Japan'],
genres:['Animation','Drama','War'],
director:['Isao Takahata'],
actors:['Cutomu Tacumi','Ajano Širaiši','Acuo Omote','Akemi Jamaguči','Tadaši Nakamura'],
screenplay:['Isao Takahata'],
music:['Mičio Mamija'],
camera:['Nobuo Kojama'],
cut:['Takeši Sejama'],
sound:['Jasuo Urakami'],
scenography:['Nizó Jamamoto']},
{title:'Manon of the Spring',
titleCZ:'Manon od pramene',
year:1986,
runtime:113,
countries:['France','Italy','Switzerland'],
genres:['Drama'],
director:['Claude Berri'],
actors:['Yves Montand','Daniel Auteuil','Emmanuelle Béart','Hippolyte Girardot','Margarita Lozano','Ticky Holgado','Elisabeth Depardieu','Jean Bouchaud','Roger Souza','Chantal Liennel','Armand Meffre','Gabriel Bacquier','Marc Betton','Jean Maurel','Didier Pain','Fransined','Yvonne Gamy','André Dupon','Pierre Nougaro'],
basedOn:['Marcel Pagnol'],
screenplay:['Gérard Brach'],
music:['Jean-Claude Petit'],
camera:['Bruno Nuytten'],
cut:['Hervé de Luze'],
sound:['Pierre Gamet','Dominique Hennequin','Laurent Quaglio'],
scenography:['Bernard Vézat'],
masks:['Michel Deruelle','Pierre Berroyer','Jean-Pierre Eychenne'],
costumes:['Sylvie Gautrelet']},
{title:'Amelie',
titleCZ:'Amélie z Montmartru',
year:2001,
runtime:117,
countries:['France','Germany'],
genres:['Comedy','Drama','Romance'],
director:['Jean-Pierre Jeunet'],
actors:['Audrey Tautou','Mathieu Kassovitz','Rufus','Jamel Debbouze','Clotilde Mollet','Isabelle Nanty','Dominique Pinon','Yolande Moreau','Maurice Bénichou','Claire Maurier','Michel Robin','Claude Perron','Ticky Holgado','André Dussollier','Dominique Bettenfeld','Franck-Olivier Bonnet','Frédéric Mitterrand','Lorella Cravotta','Urbain Cancelier','Armelle','Luc Palun','Thierry Gibault','Serge Merlin','Artus de Penguern','Christiane Bopp','Alain Floret','Jacques Thébault','Frankie Pain','Andrée Damant','François Viaur','Jean Rupert','Patrick Paroux','Valérie Labro','Jonathan Joss','Kevin Fernandes','Jean-Pierre Becker','Marc Amyot','Jean-Pol Brissart','Eugène Berthier','Katherina Mai','Marie-Laure Descoureaux','Dean Baykan','Rudy Galindo'],
screenplay:['Guillaume Laurant','Jean-Pierre Jeunet'],
production:['Claudie Ossard'],
music:['Yann Tiersen'],
camera:['Bruno Delbonnel'],
cut:['Hervé Schneid'],
sound:['Jean Umansky','Gérard Hardy','Vincent Arnardi'],
scenography:['Aline Bonetto','Volker Schäfer'],
masks:['Nathalie Tissier','Vesna Peborde'],
costumes:['Madeline Fontaine']},
{title:'Gone Girl',
titleCZ:'Zmizelá',
year:2014,
runtime:149,
countries:['USA'],
genres:['Mystery','Thriller','Drama','Crime'],
director:['David Fincher'],
actors:['Ben Affleck','Rosamund Pike','Neil Patrick Harris','Tyler Perry','Carrie Coon','Kim Dickens','Patrick Fugit','David Clennon','Lisa Banes','Missi Pyle','Emily Ratajkowski','Casey Wilson','Lola Kirke','Boyd Holbrook','Sela Ward','Lee Norris','Jamie McShane','Leonard Kelly-Young','Kathleen Rose Perkins','Darin Cooper','Casey Ruggieri','Scoot McNairy','Kyle Durant','Davina Joy','Cole Mueller','Lars Slind','Scott Takeda','Taber Cross','Cyd Strittmatter','Justin Nesbitt','Lynn Adrianna','Frederick Keeve','Lauren Glazier','Cooper Thornton','Nicolas Fagerberg','James M. Tweedie','Antonio St. James','Blake Sheldon'],
basedOn:['Gillian Flynn'],
screenplay:['Gillian Flynn'],
production:['Joshua Donen','Arnon Milchan','Ceán Chaffin'],
music:['Trent Reznor','Atticus Ross'],
camera:['Jeff Cronenweth'],
cut:['Kirk Baxter'],
sound:['David Parker','Ren Klyce','Michael Semanick'],
scenography:['Donald Graham Burt','Douglas A. Mowat','Gena Vazquez'],
masks:['Deborah Rutherford','Mark Rappaport','Kate Biscoe','Stacey Morris'],
costumes:['Trish Summerville']},
{title:'Hot Shots! Part Deux',
titleCZ:'Žhavé výstřely 2',
year:1993,
runtime:86,
countries:['USA'],
genres:['Action','Comedy','War'],
director:['Jim Abrahams'],
actors:['Charlie Sheen','Lloyd Bridges','Valeria Golino','Richard Crenna','Brenda Bakke','Miguel Ferrer','Rowan Atkinson','David Wohl','Ryan Stiles','Mitchell Ryan','Tony Edwards','James Lew','Gerald Okamura','Chi Moui Lo','Scott Reeves','Martin Sheen','Andreas Katsulas','Clyde Kusatsu','Shaun Toub','Gregory Sierra','Jerry Haleva','Ben Lemon','Joseph V. Perry','Greg Michaels','Bob Vila','Larry Lindsey','Raye Hollitt','Michael Colyar','Judith Kahan','Loren Janes','Nancy Steen','Stewart Skelton','Mark Steen'],
screenplay:['Jim Abrahams','Pat Proft'],
production:['Bill Badalato'],
music:['Basil Poledouris'],
camera:['John R. Leonetti'],
cut:['Malcolm Campbell'],
sound:['Steve Maslow','Gregg Landaker'],
scenography:['William A. Elliott'],
masks:['David LeRoy Anderson','John Blake'],
costumes:['Mary Malin']},
{title:"Devil's Advocate",
titleCZ:'Ďáblův advokát',
year:1997,
runtime:144,
countries:['USA','Germany'],
genres:['Drama','Mystery','Thriller'],
director:['Taylor Hackford'],
actors:['Keanu Reeves','Al Pacino','Charlize Theron','Jeffrey Jones','Judith Ivey','Connie Nielsen','Craig T. Nelson','Tamara Tunie','Ruben Santiago-Hudson','Debra Monk','Vyto Ruginis','Laura Harrington','Pamela Gray','George Wyner','Chris Bauer','Heather Matarazzo','Murphy Guyer','Leo Burmester','Bill Moor','Neal Jones','Mark Deakins','Rony Clanton','George Gore II','Alan Manson','Kim Chan','Caprice Benedetti','Don King','Susan Kellermann','James Saito','Novella Nelson','Vincent Laresca','Benny Nieves','Gloria Lynne Henry','Monica Keena','William Hill','Juan Carlos Hernández','E. Katherine Kerr','Bo Rucker','Michael Lombard','John Rothman','George Sperdakos','Socorro Santiago','Marcia DeBonis','Tom Riis Farrell','Harold Surratt','Nikita Ager','Paul Benedict','Roy Jones Jr.','Arnold Kopelson','Omar Koury','Frank Licari','Delroy Lindo','Doris McCarthy','Dale Resteghini','Victor Warren'],
screenplay:['Jonathan Lemkin','Tony Gilroy'],
production:['Arnold Kopelson','Arnon Milchan'],
music:['James Newton Howard'],
camera:['Andrzej Bartkowiak'],
cut:['Mark Warner'],
sound:['Per Hallberg','Tod A. Maitland','David E. Campbell','John T. Reitz','Gregg Rudloff'],
scenography:['Bruno Rubeo'],
masks:['Luigi Rocchetti','Manlio Rocchetti','Aldo Signoretti','Angel De Angelis'],
costumes:['Judianna Makovsky']},
{title:'Jaws',
titleCZ:'Čelisti',
year:1975,
runtime:118,
countries:['USA'],
genres:['Thriller','Adventure','Drama'],
director:['Steven Spielberg'],
actors:['Roy Scheider','Robert Shaw','Richard Dreyfuss','Lorraine Gary','Murray Hamilton','Carl Gottlieb','Jeffrey Kramer','Susan Backlinie','Jonathan Filley','Ted Grossman','Chris Rebello','Jay Mello','Lee Fierro','Jeffrey Voorhees','Craig Kingsbury','Peter Benchley','Robert Carroll','Fritzi Jane Courtney','Dorothy Fielding','Beverly Powers','Ayn Ruymen','Steven Spielberg','Alfred Wilde'],
basedOn:['Peter Benchley'],
screenplay:['Peter Benchley','Carl Gottlieb'],
production:['Richard D. Zanuck','David Brown'],
music:['John Williams'],
camera:['Bill Butler'],
cut:['Verna Fields'],
sound:['John R. Carter'],
scenography:['Joe Alves','John M. Dwyer'],
masks:['Jim Gillespie','John Chambers','Verne Caruso']},
{title:'Toy Story 2',
titleCZ:'Toy Story 2: Příběh hraček',
year:1999,
runtime:89,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Ash Brannon','John Lasseter','Lee Unkrich'],
actors:['Tom Hanks','Tim Allen','Joan Cusack','Kelsey Grammer','Don Rickles','Jim Varney','Wallace Shawn','Carly Schroeder','Annie Potts','Wayne Knight','Laurie Metcalf','Jodi Benson','Andrew Stanton','R. Lee Ermey','John Lasseter','Corey Burton','Sheryl Bernstein','Lee Unkrich','Jess Harnell','Rodger Bumpass','Dave Foley','Bill Farmer','Bob Bergen','Joe Ranft','Robert Goulet','John Ratzenberger','Madylin Sweeten','Estelle Harris','Phil Proctor','Mary Kay Bergman','Debi Derryberry','Pat Fraley','Jan Rabson','Andi Peters','Rachel Davey','Jack Angel'],
screenplay:['Andrew Stanton','Rita Hsiao','Doug Chamberlin','Chris Webb'],
music:['Randy Newman'],
cut:['Edie Ichioka','David Ian Salter'],
sound:['Gary Summers','Gary Rydstrom','Shannon Mills','Jeff Hutchins','Eric Freeman','Timothy J. Garrity','Doug Andham']},
{title:'Groundhog Day',
titleCZ:'Na Hromnice o den více',
year:1993,
runtime:101,
countries:['USA'],
genres:['Fantasy','Comedy','Romance'],
director:['Harold Ramis'],
actors:['Bill Murray','Andie MacDowell','Chris Elliott','Stephen Tobolowsky','Brian Doyle-Murray','Marita Geraghty','Rick Ducommun','Rick Overton','Robin Duke','Ken Hudson Campbell','Harold Ramis','Mason Gamble','Michael Shannon','Willie Garson','Angela Paton','David Pasquesi','Tony DeGuide','Les Podewell','Hynden Walch','John M. Watson Sr.','Reni Santoni','Peggy Roeder','Lee R. Sellars'],
screenplay:['Harold Ramis','Danny Rubin'],
production:['Harold Ramis','Trevor Albert'],
music:['George Fenton'],
camera:['John Bailey'],
cut:['Pembroke J. Herring'],
sound:['Sergio Reyes','B. Tennyson Sebastian II'],
scenography:['David Nichols'],
masks:['Dorothy J. Pearl','Deborah K. Dee'],
costumes:['Jennifer Butler']},
{title:'Planet of the Apes',
titleCZ:'Planeta opic',
year:1968,
runtime:112,
countries:['USA'],
genres:['Sci-Fi','Adventure','Drama'],
director:['Franklin J. Schaffner'],
actors:['Charlton Heston','Roddy McDowall','Kim Hunter','Maurice Evans','James Whitmore','Linda Harrison','Robert Gunner','Lou Wagner','Woodrow Parfrey','Jeff Burton','Buck Kartalian','Norman Burton','Felix Silla','James Daly','Wright King','Paul Lambert','Billy Curtis','James Bacon','Lars Hensen','Joe Tornatore','Jerry Maren','Army Archerd'],
basedOn:['Pierre Boulle'],
screenplay:['Rod Serling','Michael Wilson'],
production:['Arthur P. Jacobs'],
music:['Jerry Goldsmith'],
camera:['Leon Shamroy'],
cut:['Hugh S. Fowler'],
scenography:['Jack Martin Smith','Walter M. Scott','Norman Rockett','William J. Creber'],
masks:['Ben Nye','Ken Chase','John Chambers','Sharleen Rassi','Jan Van Uchelen','Howard Smit'],
costumes:['Morton Haack']},
{title:'United 93',
titleCZ:'Let číslo 93',
year:2006,
runtime:111,
countries:['UK','USA','France'],
genres:['History','Drama','Crime','Thriller'],
director:['Paul Greengrass'],
actors:['Cheyenne Jackson','Khalid Abdalla','Lewis Alsamari','Trish Gates','Omar Berdouni','Jamie Harding','Gregg Henry','Ben Sliney','John Rothman','Corey Johnson','Olivia Thirlby','Trieste Kelly Dunn','Kate Jennings Grant','Peter Hermann','Marceline Hugot','Richard Bekins','Christian Clemenson','Michael Bofshever','David Alan Basche','Chip Zien','Patrick St. Esprit','Amanda Boxer',"Tom O'Rourke",'Denny Dillon','Susan Blommaert','Simon Poland','Peter Marinker','Libby Morris Morris','Liza Colón-Zayas','Leigh Zimmerman','Chloe Sirene','Tara Hugo','Opal Alladin','Erich Redman','Alice Dinnean'],
screenplay:['Paul Greengrass'],
production:['Tim Bevan','Eric Fellner','Lloyd Levin','Paul Greengrass'],
music:['John Powell'],
camera:['Barry Ackroyd'],
cut:['Clare Douglas','Christopher Rouse','Richard Pearson'],
sound:['Eddy Joseph','Michael Prestwood Smith','Oliver Tarney','Doug Cooper','Harry Barnes','Chris Munro'],
scenography:['Dominic Watkins','Michael Standish'],
masks:['Kirstin Chalmers','Donald McInnes','Laura Schiavo'],
costumes:['Dinah Collin']},
{title:'The Fabulous Baron Munchausen',
titleCZ:'Baron Prášil',
year:1961,
runtime:83,
countries:['Czechoslovakia'],
genres:['Adventure','Fantasy','Sci-Fi','Animation'],
director:['Karel Zeman'],
actors:['Miloš Kopecký','Jana Brejchová','Rudolf Jelínek','Karel Höger','Eduard Kohout','Jan Werich','Bohuš Záhorský','Rudolf Hrušínský','Miloslav Holub','František Šlégr','Karel Effa','Josef Hlinomaz','Zdeněk Hodr','Richard Záhorský','Otto Šimánek','Miroslav Homola','Václav Trégl','Naděžda Blažíčková','Vítězslav Černý','Jan Libíček','Jarka Pižla'],
basedOn:['Gottfried August Bürger'],
screenplay:['Karel Zeman','Josef Kainar','Jiří Brdečka'],
music:['Zdeněk Liška'],
camera:['Jiří Tarantík'],
cut:['Věra Kutilová'],
sound:['František Strangmüller'],
scenography:['Zdeněk Rozkopal'],
masks:['Gustav Hrdlička','František Havlíček'],
costumes:['Lída Novotná','Miloslava Šmídová']},
{title:'The Lives of Others',
titleCZ:'Životy těch druhých',
year:2006,
runtime:137,
countries:['Germany'],
genres:['Drama','Thriller'],
director:['Florian Henckel von Donnersmarck'],
actors:['Ulrich Mühe','Sebastian Koch','Martina Gedeck','Ulrich Tukur','Thomas Thieme','Charly Hübner','Martin Brambach','Herbert Knaup','Volker Michalowski','Werner Daehn','Hinnerk Schönemann','Gitta Schweighöfer','Ludwig Blochberger','Matthias Brenner','Paul Faßnacht','Hans-Uwe Bauer','Sheri Hagen','Hildegard Schroedter','Kai Ivo Baulitz','Fabian von Klitzing','Volkmar Kleinert','Inga Birkenfeld','Paul Maximilian Schüller','Bastian Trost','Hubertus Hartmann','Hervé Hiolle','Anabelle D. Munro','Klaus Münster','Michael Gerber','Harald Polzin'],
screenplay:['Florian Henckel von Donnersmarck'],
production:['Andreas Schreitmüller','Claudia Gladziejewski','Monika Lobkowicz','Max Wiedemann','Quirin Berg'],
music:['Gabriel Yared','Stéphane Moucha'],
camera:['Hagen Bogdanski'],
cut:['Patricia Rommel'],
sound:['Christoph von Schönburg','Hubertus Rath','Arno Wilms'],
scenography:['Silke Buhr'],
masks:['Sabine Schumann','Annett Schulze'],
costumes:['Gabriele Binder']},
{title:'The Day of the Jackal',
titleCZ:'Den Šakala',
year:1973,
runtime:143,
countries:['UK','France'],
genres:['Thriller','Crime','Drama'],
director:['Fred Zinnemann'],
actors:['Edward Fox','Michel Auclair','Alan Badel','Cyril Cusack','Maurice Denham','Olga Georges-Picot','Jacques François','Derek Jacobi','Michael Lonsdale','Jean Martin','Anton Rodgers','Delphine Seyrig','Jean Sorel','Philippe Léotard','Edward Hardwicke','Andréa Ferréol','Howard Vernon','Féodor Atkine','Maurice Teynac','Donald Sinden','Ronald Pickup','Raymond Gerôme','Eric Porter','Terence Alexander','Vernon Dobtcheff','Robert Le Béal','Bernard Musson','Gilberte Géniat','Adrien Cayla-Legrand','Gérard Buhr','Nicolas Vogel','Robert Favart','Timothy West','Jean Champion','Jacques Alric','David Swift','Max Faulkner','Colette Bergé','Nicole Desailly','Barrie Ingham','Nicholas Young','Bernard Archard','Van Doude','Tony Britton','David Kernan'],
basedOn:['Frederick Forsyth'],
screenplay:['Kenneth Ross'],
production:['John Woolf'],
music:['Georges Delerue'],
camera:['Jean Tournier'],
cut:['Ralph Kemplen'],
masks:['Pierre Berroyer'],
costumes:['Rosine Delamare','Elizabeth Haffenden']},
{title:'Nausicaä of the Valley of the Wind',
titleCZ:'Naušika z Větrného údolí',
year:1984,
runtime:116,
countries:['Japan'],
genres:['Animation','Adventure','Fantasy','Sci-Fi'],
director:['Hajao Mijazaki'],
actors:['Bin Šimada','Ičiró Nagai','Iemasa Kajumi','Miina Tominaga','Robert Clotworthy','Čika Sakamoto','Sumi Šimamoto','Tarako','Jošiko Sakakibara','Hóčú Ócuka','Rihoko Jošida','Akiko Cuboi','Minoru Jada','Džódži Janami','Hisako Kjóda','Masako Sugaja','Tecuo Mizutori','Kóhei Mijauči','Mugihito','Goró Naja','Takako Sasuga','Mahito Cudžimura','Jódži Macuda','Šindži Nomura','Takeki Nakamura'],
screenplay:['Hajao Mijazaki'],
production:['Isao Takahata'],
music:['Džó Hisaiši'],
cut:['Tomoko Kida'],
sound:['Tom E. Dahl'],
scenography:['Micuki Nakamura']},
{title:'Gandhi',
titleCZ:'Gándhí',
year:1982,
runtime:188,
countries:['UK','India'],
genres:['Drama','Biographic'],
director:['Richard Attenborough'],
actors:['Ben Kingsley','Candice Bergen','Edward Fox','John Gielgud','Brian Oulton','Trevor Howard','John Mills','Martin Sheen','Ian Charleson','Athol Fugard','Günther Maria Halmer','Saeed Jaffrey','Geraldine James','Amrish Puri','Roshan Seth','Rohini Hattangadi','Ian Bannen','John Clements','Richard Griffiths','Nigel Hawthorne','Shreeram Lagoo','Om Puri','Marius Weyers','Daniel Day-Lewis','Ray Burdis','Bernard Hill','Nana Palsikar','John Quentin','Pankaj Kapur','David Gant','Mohan Agashe','Supriya Pathak Kapur','John Ratzenberger','Dominic Guard','Michael Hordern','Richard Vernon','Shane Rimmer','Dalip Tahil','Sudhir Dalvi','Alok Nath','Terrence Hardiman','James Cossins','Rupert Frazer','Ken Hutchison','Suhas Palshikar','Amarjeet','John Boxer','Christopher Good','David Sibley','Avis Bunnage','Charu Bala Chokshi','Jon Croft','John Savident','Stanley McGeagh','John Tatum','Ernest Clark','Bernard Hepton','Geoffrey Chater','Harold Coyne','Fred Wood','Gerald Sim','Bernard Horsfall','Richard Leech','Winston Ntshona','Neena Gupta','David Markham','Michael Bryant','Tom Alter','John Vine','Jack McKenzie','Virendra Razdan','Graham Seed'],
screenplay:['John Briley'],
production:['Richard Attenborough'],
music:['George Fenton','Ravi Shankar'],
camera:['Billy Williams','Ronnie Taylor'],
cut:['John Bloom'],
scenography:['Stuart Craig'],
masks:['Tom Smith'],
costumes:['Bhanu Athaiya','John Mollo']},
{title:'Hatred',
titleCZ:'Volyň',
year:2016,
runtime:150,
countries:['Poland'],
genres:['Drama','History','War'],
director:['Wojciech Smarzowski'],
actors:['Michalina Łabacz','Arkadiusz Jakubik','Wasyl Wasylik','Adrian Zaremba','Jacek Braciak','Tomasz Sapryk','Izabela Kuna','Kinga Preis','Jarosław Gruda','Wojciech Zieliński','Lech Dyblik','Gabriela Muskała','Zacharjasz Muszyński','Jerzy Rogalski','Janusz Chabior','Magda Celówna','Ireneusz Czop','Bohdan Graczyk','Anna Grzeszczak-Hutek','Mateusz Janicki','Eryk Lubos','Piotr Nowak','Filip Pławiak','Dariusz Toczek','Grzegorz Wojdon','Ignacy Sut','Oles Fedorčenko','Georgij Povolockij','Monika Roszko','Gera Sandler','Krzysztof Domaszczyński','Grzegorz Domański','Julia Zielińska','Maria Bikont','Ostap Dzjadek','Pavel Kryksunou','Patryk Radziszewski','Jakub Kostrzewa'],
screenplay:['Wojciech Smarzowski'],
production:['Feliks Pastusiak'],
music:['Mikołaj Trzaska'],
camera:['Piotr Sobociński Jr.'],
cut:['Paweł Laskowski'],
sound:['Jacek Hamela','Katarzyna Dzida-Hamela'],
scenography:['Marek Zawierucha','Jacek Gruszecki'],
costumes:['Magdalena Rutkiewicz','Paweł Grabarczyk','Agata Drozdowska','Wanda Kowalska']},
{title:'The Gold Rush',
titleCZ:'Zlaté opojení',
year:1925,
runtime:89,
countries:['USA'],
genres:['Comedy','Adventure'],
director:['Charlie Chaplin'],
actors:['Charlie Chaplin','Mack Swain','Henry Bergman','Georgia Hale','Jack Adams','Albert Austin','Lita Grey','Tom Murray','Mary Williams','Frank Aderias','Leona Aderias','Lillian Adrian','Larry Steers','John Wallace','Heinie Conklin','Jimmy Dime','George Young','Frank Rice','J. C. Fowler','Chris-Pin Martin','Kay Deslys','Tiny Sandford','Bess Wade','George Holt','Sid Grauman','Al Ernest Garcia'],
screenplay:['Charlie Chaplin'],
production:['Charlie Chaplin'],
music:['Charlie Chaplin'],
camera:['Roland Totheroh'],
cut:['Charlie Chaplin'],
scenography:['Charles D. Hall']},
{title:'Harakiri',
titleCZ:'Harakiri',
year:1962,
runtime:133,
countries:['Japan'],
genres:['Action','Drama','History'],
director:['Masaki Kobajaši'],
actors:['Tacuja Nakadai','Rentaró Mikuni','Šima Iwašita','Akira Išihama','Akidži Kobajaši','Kei Sató','Hisaši Igawa','Tecuró Tanba','Joširó Aoki','Jošio Inaba','Nakadžiró Tomita'],
screenplay:['Šinobu Hašimoto'],
music:['Tóru Takemicu'],
camera:['Jošio Mijadžima']},
{title:'Limelight',
titleCZ:'Světla ramp',
year:1952,
runtime:141,
countries:['USA'],
genres:['Drama','Music','Comedy'],
director:['Charlie Chaplin'],
actors:['Charlie Chaplin','Claire Bloom','Nigel Bruce','Buster Keaton','Sydney Chaplin','Norman Lloyd','Edna Purviance',"Harry 'Snub' Pollard",'Geraldine Chaplin','Michael Chaplin','Oona Chaplin','Charles Chaplin Jr.','Josephine Chaplin','Kenner G. Kemp','Sam Harris','Harold Miller','Frank Mills','Colin Kenny','Cyril Delevanti','Frank Hagney','Marjorie Bennett','Eric Wilton','Dorothy Ford','Billy Curtis','Florence Wix','Millicent Patrick','Leonard Mudie','Jack Deery','Paul Ravel','John Barton','Bud Cokes','Perk Lazelle','Tom Ferrandini','Sherry Moreland','Harry Crocker'],
screenplay:['Charlie Chaplin'],
production:['Charlie Chaplin'],
music:['Charlie Chaplin'],
camera:['Karl Struss'],
scenography:['Eugène Lourié']},
{title:'Adventures of Robinson Crusoe, a Sailor from York',
titleCZ:'Dobrodružství Robinsona Crusoe, námořníka z Yorku',
year:1981,
runtime:68,
countries:['Czechoslovakia'],
genres:['Animation','Puppets','Adventure'],
director:['Stanislav Látal'],
actors:['Václav Postránecký','Jiří Bruder','Stanislav Fišer','Dalimil Klapka'],
basedOn:['Daniel Defoe'],
screenplay:['Stanislav Látal','Jiří Kubíček'],
music:['Karel Svoboda'],
camera:['Jiří Šafář'],
cut:['Helena Lebdušková'],
sound:['Ivo Špalj']},
{title:'Safety Last!',
titleCZ:'O patro výš',
year:1923,
runtime:74,
countries:['USA'],
genres:['Comedy','Thriller','Romance'],
director:['Sam Taylor','Fred C. Newmeyer'],
actors:['Harold Lloyd','Mildred Davis','Bill Strother','Noah Young','Fred C. Newmeyer','Mickey Daniels','Marie Mosquini','Gus Leonard','Charles Stevenson','Earl Monah','Sam Lufkin','Helen Gilmore'],
screenplay:['Tim Whelan','Harold Lloyd'],
production:['Hal Roach'],
music:['Carl Davis'],
camera:['Walter Lundin']},
{title:'The Best Years of Our Lives',
titleCZ:'Nejlepší léta našeho života',
year:1946,
runtime:172,
countries:['USA'],
genres:['Drama','Romance','War'],
director:['William Wyler'],
actors:['Myrna Loy','Fredric March','Dana Andrews','Teresa Wright','Virginia Mayo',"Cathy O'Donnell",'Hoagy Carmichael','Gladys George','Harold Russell','Steve Cochran','Roman Bohnen','Ray Collins','Victor Cutler','Minna Gombell','Dorothy Adams','Don Beddoe','Charles Halton','Ray Teal','Erskine Sanford','Leo Penn','Blake Edwards','Joyce Compton',"William H. O'Brien",'Pat Flaherty','Robert Karnes','Earle Hodgins','Kenner G. Kemp','Walter Baldwin','Harold Miller','Donald Kerr','Lester Dorr','Tom Dugan','Edward Earle','Al Bridge','Sidney Clute','William Newell','Howland Chamberlain','Wilbur Mack','James Conaty','Billy Engle','Hal K. Dawson','Heinie Conklin','Ralph Sanford','Clancy Cooper','Harry Cheshire','Suzanne Ridgway','Stuart Holmes','Jack Rice','John Tyrrell','Ray Hyke','Georgie Nokes','Jan Wiley','Ernesto Molinari','Teddy Infuhr','Roy Darmour','Thomas Martin','Bert Conway','Amelita Ward','Michael Hall','Tennessee Ernie Ford','Jackie Jackson','Carol Andrews','Dean White'],
basedOn:['MacKinlay Kantor'],
screenplay:['Robert E. Sherwood'],
production:['Samuel Goldwyn'],
music:['Hugo Friedhofer'],
camera:['Gregg Toland'],
cut:['Daniel Mandell'],
sound:['Richard DeWeese'],
scenography:['Perry Ferguson','George Jenkins','Julia Heron'],
masks:['Robert Stephanoff'],
costumes:['Irene Sharaff']},
{title:'High and Low',
titleCZ:'Nebe a peklo',
year:1963,
runtime:143,
countries:['Japan'],
genres:['Thriller','Crime','Drama','Mystery'],
director:['Akira Kurosawa'],
actors:['Toširó Mifune','Tacuja Nakadai','Kjóko Kagawa','Tacuja Mihaši','Takaši Šimura','Susumu Fudžita','Cutomu Jamazaki','Minoru Čiaki','Kamatari Fudžiwara','Kó Nišimura','Kin Sugai','Eidžiró Tóno','Kódži Micui','Isao Kimura','Jutaka Sada','Kazuo Kitamura','Masao Oda','Džun Hamamura','Kiwami Sazanka','Kazuo Kató','Haruo Suzuki','Akira Nagoja','Kódži Kijomura'],
basedOn:['Evan Hunter'],
screenplay:['Hideo Oguni','Akira Kurosawa','Ryûzô Kikushima'],
production:['Tomojuki Tanaka'],
music:['Masaru Sató'],
camera:['Asakazu Nakai','Takao Saitó']},
{title:'Big Fish',
titleCZ:'Velká ryba',
year:2003,
runtime:125,
countries:['USA'],
genres:['Fantasy','Adventure','Romance','Drama'],
director:['Tim Burton'],
actors:['Ewan McGregor','Albert Finney','Billy Crudup','Jessica Lange','Helena Bonham Carter','Alison Lohman','Marion Cotillard','Matthew McGrory','David Denman','Missi Pyle','Ada Tai','Arlene Tai','Steve Buscemi','Danny DeVito','Deep Roy','Perry Walston','Hailey Anne Nelson','Zac Gardner','Miley Cyrus','Metz Duites','Robert Guillaume','Benjamin Plaut','Billy Redden','Daniel Wallace','Loudon Wainwright III','R. Keith Harris','Trevor Gagnon','Russell Hodgkinson','Zach Hanner','Bevin Kaye','Frank Hoyt Taylor','Bonnie Johnson','Karla Droege','John Lowell','L.C. Holt','Ransom Gates'],
basedOn:['Daniel Wallace'],
screenplay:['John August'],
production:['Richard D. Zanuck','Dan Jinks','Bruce Cohen'],
music:['Danny Elfman'],
camera:['Philippe Rousselot'],
cut:['Chris Lebenzon'],
sound:['Skip Lievsay',"Kevin O'Connell",'Greg P. Russell','Petur Hliddal','Craig Berkey'],
scenography:['Dennis Gassner','Nancy Haigh'],
masks:['Dorothy J. Pearl','Jean Ann Black','Scott Wheeler','Mike Smithson','Arjen Tuiten','Justin Raleigh','Linda De Andrea','Sherri Bramlett'],
costumes:['Colleen Atwood']},
{title:'Apollo 13',
titleCZ:'Apollo 13',
year:1995,
runtime:140,
countries:['USA'],
genres:['Adventure','Drama','History'],
director:['Ron Howard'],
actors:['Tom Hanks','Bill Paxton','Kevin Bacon','Gary Sinise','Ed Harris','Kathleen Quinlan','Miko Hughes','Max Elliott Slade','David Andrews','Chris Ellis','Joe Spano','Xander Berkeley','Clint Howard','Michele Little','Loren Dean','Tom Wood','Googy Gress','Ray McKinnon','Max Grodénchik','Ned Vaughn','Jim Meskimen','Todd Louiso','Walter Cronkite',"Austin O'Brien",'Roger Corman','Bryce Dallas Howard','Mary Kate Schellhardt','Jack Conley','Meadow Williams','Andy Milder','Thom Barry','Brett Cullen','Steve Rankin','Jeffrey Kluger','Jim Lovell','Brian Markinson','Rance Howard','Ben Marley','Endre Hules','Marc McClure','Christian Clemenson','Joseph Culp','Wayne Duvall','Paul Mantee','Chauntal Lewis','John Short','Todd Hallowell','Gabriel Jarret','John Wheeler','Chris Moore','Geoffrey Blake','Mark Wheeler','John Bishop','Christopher John Fields','Lee Anne Matusek','Tracy Reiner','Jean Speegle Howard','Neil Armstrong','Carl Gabriel Yorke','Tory Christopher','Karen Martin','Stephen J. Austin','Frank Cavestani','Greg Bronson','Ben Bode','John Timothy Botka','James Ritz'],
basedOn:['Jim Lovell','Jeffrey Kluger'],
screenplay:['William Broyles Jr.','Al Reinert'],
production:['Brian Grazer'],
music:['James Horner'],
camera:['Dean Cundey'],
cut:['Daniel P. Hanley','Mike Hill'],
sound:['Steve Pederson','Scott Millan','Bob Chefalas','Bob Olari'],
scenography:['Michael Corenblith'],
masks:['Carolyn Elias','Michael Lorenz'],
costumes:['Rita Ryack']},
{title:'21 Grams',
titleCZ:'21 gramů',
year:2003,
runtime:124,
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Alejandro González Iñárritu'],
actors:['Sean Penn','Benicio Del Toro','Danny Huston','Naomi Watts','Carly Nahon','Clea DuVall','Charlotte Gainsbourg','Claire Pakis','Eddie Marsan','John Rubinstein',"Denis O'Hare",'Paul Calderon','Annie Corley','Kevin Chapman','Stephen Bridgewater','Lew Temple','Melissa Leo','Carlo Alban','Catherine Dent','Arron Shiver','Tom Irwin','Michael Finnell','Verda Davenport','John Boyd West','Marc Musso'],
screenplay:['Guillermo Arriaga'],
production:['Ted Hope','Robert Salerno'],
music:['Gustavo Santaolalla'],
camera:['Rodrigo Prieto'],
cut:['Stephen Mirrione'],
sound:['Martín Hernández','Jon Taylor','Brad Sherman'],
scenography:['Brigitte Broch'],
masks:['Gail Rowell-Ryan','Vivian Baker','Luisa Abel'],
costumes:['Marlene Stewart']},
{title:'Zootopia',
titleCZ:'Zootropolis: Město zvířat',
year:2016,
runtime:108,
countries:['USA'],
genres:['Animation','Mystery','Adventure','Crime','Comedy','Family'],
director:['Byron Howard','Rich Moore'],
actors:['Ginnifer Goodwin','Jason Bateman','Idris Elba','Jenny Slate','Nate Torrence','Bonnie Hunt','Don Lake','Tommy Chong','J.K. Simmons','Octavia Spencer','Alan Tudyk','Shakira','Raymond S. Persi','Kristen Bell','Katie Lowes',"Tommy 'Tiny' Lister",'John DiMaggio','Maurice LaMarche','Jeremy Milton','Fabienne Rawley','Jesse Corti','Fuschia!','Mark Rhino Smith','Kath Soucie','Della Saba','Gita Reddy','Brad Simonsen','Josie Trinidad','Madeleine Curry'],
screenplay:['Phil Johnston','Jared Bush'],
production:['Clark Spencer'],
music:['Michael Giacchino'],
cut:['Jeremy Milton','Fabienne Rawley'],
sound:['David E. Fluhr','Addison Teague']},
{title:'The Naked Gun: From the Files of Police Squad!',
titleCZ:'Bláznivá střela',
year:1988,
runtime:82,
countries:['USA'],
genres:['Comedy','Crime','Action'],
director:['David Zucker'],
actors:['Leslie Nielsen','Priscilla Presley','George Kennedy','Ricardo Montalban','O.J. Simpson','Susan Beaubian','Nancy Marchand','Tiny Ron','Joe Grifasi','Lawrence Tierney','John Houseman',"'Weird Al' Yankovic",'Conrad E. Palmisano','Brinke Stevens','Tom Dugan','Mark Holton','Raye Birk','Nicholas Worth','David Gale','Robert K. Weiss','Joyce Brothers','Dick Enberg','Stuart Lancaster','Edwina Moore','Lorali Hart','Steven Swadling','Ronald G. Joseph','Hank Robinson','Don Woodard','David Lloyd Austin','Charles Gherardi','Prince Hughes','David Katz','Robert LuJane','Doris Hess','Jeff Wright'],
screenplay:['Pat Proft','David Zucker','Jim Abrahams','Jerry Zucker'],
production:['Robert K. Weiss'],
music:['Ira Newborn'],
camera:['Robert M. Stevens'],
cut:['Michael Jablow'],
sound:['Steve Maslow','Gregg Landaker'],
scenography:['John J. Lloyd'],
masks:['Cheri Ruff','James R. Scribner','David B. Miller','Gail Rowell-Ryan','Lisa Rocco'],
costumes:['Mary E. Vogt']},
{title:'Changeling',
titleCZ:'Výměna',
year:2008,
runtime:141,
countries:['USA'],
genres:['Drama','History','Crime','Mystery','Thriller','Biographic'],
director:['Clint Eastwood'],
actors:['Angelina Jolie','John Malkovich','Jeffrey Donovan','Michael Kelly','Colm Feore','Jason Butler Harner','Amy Ryan','Geoff Pierson',"Denis O'Hare",'Frank Wood','Peter Gerety','Reed Birney','Gattlin Griffith','Morgan Eastwood','Ric Sarabia','J.P. Bumstead','Debra Christofferson','Pamela Dunlap','Roger Hewlett','Jim Cantafio','Wendy Worthington','Riki Lindhome','Dale Dickey','Eddie Alderson','Michael McCafferty','David Goldman','Joshua Logan Moore','Zach Mills','Colby French','Michael Dempsey','Peter Breitmayer','Phil Van Tee','Lily Knight','Jeffrey Hutchinson','Ryan Cutrona','Mary Stein','Gregg Binkley','Cooper Thornton','E.J. Callahan','Devon Gearhart','Julie Berlin','Pete Brown','Dominick Dunne','Kerry Hennessy','Bruce Holman','Christopher Karl Johnson','Jen Lilley','Darin Mangan','Rob Watt'],
screenplay:['J. Michael Straczynski'],
production:['Clint Eastwood','Brian Grazer','Ron Howard','Robert Lorenz'],
music:['Clint Eastwood'],
camera:['Tom Stern'],
cut:['Joel Cox','Gary D. Roach'],
sound:['Alan Robert Murray','Bub Asman','John T. Reitz','Gregg Rudloff'],
scenography:['James J. Murakami','Gary Fettis'],
masks:['Tania McComas','Zoe Hay','Patricia Dehaney','Janis Clark'],
costumes:['Deborah Hopper']},
{title:'Enemy of the State',
titleCZ:'Nepřítel státu',
year:1998,
runtime:132,
countries:['USA'],
genres:['Drama','Action','Thriller'],
director:['Tony Scott'],
actors:['Will Smith','Gene Hackman','Jon Voight','Lisa Bonet','Regina King','Stuart Wilson','Laura Cayouette','Loren Dean','Barry Pepper','Ian Hart','Jake Busey','Scott Caan','Jason Lee','Gabriel Byrne','James Le Gros','Jack Black','Jamie Kennedy','Bodhi Elfman','Anna Gunn','Jascha Washington','Lillo Brancato','John Capodice','Ivana Milicevic','Arthur J. Nascarella','Grant Heslov','Frank Medrano','Carlos Gómez','Seth Green','Philip Baker Hall','Jason Robards','Tom Sizemore','Jade Wu','Steve Gonzales','Bobby Boriello','Brian Markinson','John Cenatiempo','Paul Herman','Joseph Patrick Kelly','Rebeca Silva','Dan Butler','Pete Sutton','Christopher Lawrence','Donna W. Scott','Greg Collins','Tom Quinn','Michael Chong','Eric Olson','Mark Byrne','Jimmy Star','Carl Mergenthaler'],
screenplay:['David Marconi'],
production:['Jerry Bruckheimer'],
music:['Trevor Rabin','Harry Gregson-Williams'],
camera:['Dan Mindel'],
cut:['Chris Lebenzon'],
sound:["Kevin O'Connell",'Shannon Mills','Christopher Boyes','Greg P. Russell'],
scenography:['Benjamín Fernández'],
masks:['Steve La Porte','John Damiani','Steve La Porte'],
costumes:['Marlene Stewart']},
{title:'The Cider House Rules',
titleCZ:'Pravidla moštárny',
year:1999,
runtime:120,
countries:['USA'],
genres:['Drama','Romance'],
director:['Lasse Hallström'],
actors:['Tobey Maguire','Charlize Theron','Delroy Lindo','Paul Rudd','Michael Caine','Jane Alexander','Kathy Baker','Erykah Badu','Kieran Culkin','Kate Nelligan','Heavy D','K. Todd Freeman','Paz de la Huerta','J.K. Simmons','Evan Parke','Lonnie Farmer','Erik Per Sullivan','Skye McCole Bartusiak','Annie Corley','John Irving','Kevin Chapman','Mary Bogue'],
basedOn:['John Irving'],
screenplay:['John Irving'],
production:['Richard N. Gladstein'],
music:['Rachel Portman'],
camera:['Oliver Stapleton'],
cut:['Lisa Zeno Churgin'],
sound:['Petur Hliddal','Maurice Schell','Steve Pederson','Tom Perry','Bob Chefalas','Bob Olari'],
scenography:['David Gropman','Beth A. Rubino'],
masks:['Ellie Winslow'],
costumes:['Renée Ehrlich Kalfus']},
{title:'Hair',
titleCZ:'Vlasy',
year:1979,
runtime:121,
countries:['USA','Germany'],
genres:['Musical','Comedy','Drama'],
director:['Miloš Forman'],
actors:['John Savage','Treat Williams',"Beverly D'Angelo",'Annie Golden','Dorsey Wright','Don Dacus','Richard Bright','Nicholas Ray','Charlotte Rae','Miles Chapin','Suzanna Love','Michael Jeter','Charlayne Woodard','Laird Stuart','Melba Moore','Grand L. Bush','Adrienne King','Peter Maloney','Fern Tailer','Charles Denny','Herman Meckler','Agness Breen','Ellen Foley','Antonia Rey','Héctor Mercado','Nell Carter','Renn Woods','Chuck Patterson','Megan Murphy','France Mayotte'],
screenplay:['Michael Weller'],
production:['Michael Butler','Lester Persky'],
music:['Galt MacDermot'],
camera:['Miroslav Ondříček','Richard C. Kratina'],
cut:['Alan Heim','Lynzee Klingman'],
sound:['Duncan McEwan','Steve Maslow','Bill Varney','Bob Minkler'],
scenography:['Stuart Wurtzel'],
costumes:['Ann Roth']},
{title:'Billy Elliot',
titleCZ:'Billy Elliot',
year:2000,
runtime:110,
countries:['UK','France'],
genres:['Drama','Comedy','Music'],
director:['Stephen Daldry'],
actors:['Jamie Bell','Julie Walters','Gary Lewis','Jamie Draven','Jean Heywood','Mike Elliot','Nicola Blackwell','Colin Maclachlan','Trevor Fox','Charlie Hardwick','Stephen Mangan','Paul Ridley','Patrick Malahide','Barbara Leigh-Hunt','Imogen Claire','Diana Kent','Neil North','Lee Williams','Merelina Kendall','Zoë Bell','Tracey Wilkinson','Darren Jacobs','Sharon Percy','Luke Fetherston','Fred Astaire'],
screenplay:['Lee Hall'],
production:['Greg Brenman','Jon Finn'],
music:['Stephen Warbeck'],
camera:['Brian Tufano'],
cut:['John Wilson'],
sound:['Mark Holding','Michael Prestwood Smith'],
scenography:['Maria Djurkovic','Tatiana Macdonald'],
masks:['Ivana Primorac'],
costumes:['Stewart Meachem']},
{title:'Raging Bull',
titleCZ:'Zuřící býk',
year:1980,
runtime:129,
countries:['USA'],
genres:['Drama','Sport','Biographic'],
director:['Martin Scorsese'],
actors:['Robert De Niro','Cathy Moriarty','Joe Pesci','Frank Vincent','Nicholas Colasanto','Theresa Saldana','Mario Gallo','Frank Adonis','Joseph Bono','Charles Scorsese','John Turturro','Michael Badalucco','Allen Joseph','Martin Scorsese','Jimmy Williams','Gil Perkins','Kevin Breslin','Peter Savage','Gene LeBell','Lori Anne Flax','Kevin Mahon','Marty Denkin','Vincent Barbi','Geraldine Smith','McKenzie Westmore','Mardik Martin','Harvey Parry','Daniel P. Conte','Shay Duffin','Richard McMurray','Chuck Hicks','Tony Lip','Thomas Murphy','Bob Harks','Michael Charles Hill','Lisa Katz','Mary Albee'],
basedOn:['Jake LaMotta'],
screenplay:['Paul Schrader','Peter Savage','Mardik Martin'],
production:['Irwin Winkler','Robert Chartoff'],
camera:['Michael Chapman'],
cut:['Thelma Schoonmaker'],
scenography:['Frederic C. Weiler','Carl Biddiscombe'],
masks:['Mona Orr','Michael Westmore','Verne Caruso','Allen Payne'],
costumes:['John Boxer','Richard Bruno']},
{title:'The Doors',
titleCZ:'The Doors',
year:1991,
runtime:140,
countries:['USA'],
genres:['Drama','Biographic','Music'],
director:['Oliver Stone'],
actors:['Val Kilmer','Meg Ryan','Kathleen Quinlan','Kyle MacLachlan','Frank Whaley','Kevin Dillon','Michael Wincott','Michael Madsen','Josh Evans','Costas Mandylor','Dennis Burkley','John Capodice','Mark Moses','Will Jordan','Sean Stone','Robert LuPone',"Floyd 'Red Crow' Westerman",'Billy Idol','Claire Stansfield','Wes Studi','Josie Bissett','Debi Mazar','Lisa Edelstein','Mimi Rogers','Jennifer Rubin','Oliver Stone','Crispin Glover','Karina Lombard','David Allen Brooks','Rodney A. Grant','Kelly Hu','Richard Rutowski','Jennifer Tilly','Christina Fulton','Titus Welliver','Gretchen Becker','Jack McGee','Eric Burdon','Andrew Lauer','Erik Dellums','Phil Fondacaro','Rion Hunter','Tay Brooks','Steve Reevis','Charlie Spradling','Christopher Lawford','Annie McEnroe','Adolf Hitler','Martin Luther King','Robert F. Kennedy','Richard Nixon','Robby Krieger','John Densmore','Hawthorne James','Peter Crombie','Sam Whipple','Allan Graf','Frank Military','Alan Manson','Taber Cross','George Wallace','Dean Rader-Duval','Paul Williams','Laura Esterman','Bruce MacVittie','Bill Graham','Bonnie Bramlett','Heidi Schooler','Michael Reardon','Brad Weston','Keith Reddin','Deborah Falconer','Bernard Telsey','Alex Wexo','Dave Knapp','Abby Supple'],
screenplay:['Oliver Stone','Randall Jahnson'],
production:['A. Kitman Ho','Bill Graham'],
camera:['Robert Richardson'],
cut:['David Brenner','Joe Hutshing'],
sound:['Michael Minkler','Gregg Landaker','Wylie Stateman','Tod A. Maitland'],
scenography:['Barbara Ling'],
masks:['John Norin','Ken Diaz','Barbara Lorenz','E. Thomas Case'],
costumes:['Marlene Stewart']},
{title:'Man of the East',
titleCZ:'Podivné dědictví',
year:1972,
runtime:120,
countries:['Italy','France','Yugoslavia'],
genres:['Western','Comedy','Action'],
director:['Enzo Barboni'],
actors:['Terence Hill','Gregory Walcott','Yanti Somer','Dominic Barto','Harry Carey Jr.','Sal Borgese','John Bartha','Salvatore Baccaro','Riccardo Pizzuti','Emilio Messina','Mike Monty','Enzo Fiermonte','Pietro Torrisi','Roberto Messina','Omero Capanna','Claudio Ruffini','Fortunato Arena','Furio Meniconi','Margherita Horowitz','Luciano Bonanni','Luigi Casellato','Giancarlo Bastianoni','Jean Louis','Osiride Pevarello','Franco Ukmar','Paolo Figlia','Rocco Lerro','Luigi Antonio Guerra','Gennarino Pappagalli','Renzo Pevarello','Gaetano Scala','Bruno Ariè','Angelo Boscariol','Spartaco Conversi','Marcello Meconizzi','Sergio Testori','Antonio Monselesan'],
screenplay:['Enzo Barboni'],
production:['Alberto Grimaldi'],
music:['Maurizio De Angelis','Guido De Angelis'],
camera:['Aldo Giordani'],
cut:['Eugenio Alabiso'],
sound:['Pietro Spadoni','Fausto Ancillai'],
masks:['Maurizio Giustini'],
costumes:['Enzo Bulgarelli']},
{title:'My Neighbor Totoro',
titleCZ:'Můj soused Totoro',
year:1988,
runtime:86,
countries:['Japan'],
genres:['Animation','Adventure','Fantasy','Family'],
director:['Hajao Mijazaki'],
actors:['Šigeru Čiba','Ikue Ótani','Tomohiro Nišimura','Tanie Kitabajaši','Čika Sakamoto','Hitoši Takagi','Sumi Šimamoto','Naoki Tacuta','Noriko Hidaka','Čie Kódžiro','Micuko Išida','Peter Renaday'],
screenplay:['Hajao Mijazaki'],
music:['Džó Hisaiši'],
camera:['Hisao Širai'],
cut:['Takeši Sejama'],
sound:['Tom E. Dahl']},
{title:'Persepolis',
titleCZ:'Persepolis',
year:2007,
runtime:96,
countries:['France','USA'],
genres:['Animation','Drama','War','Biographic'],
director:['Vincent Paronnaud','Marjane Satrapi'],
actors:['Chiara Mastroianni','Catherine Deneuve','Danielle Darrieux','Simon Abkarian','Arié Elmaleh','Sean Penn','Iggy Pop','Gena Rowlands','Stéphane Foenkinos','Mathias Mlekuz','François Jerosme','Paul Bandey','Sophie Arthuys','Barbara Scaff','Christine Flowers'],
basedOn:['Marjane Satrapi'],
screenplay:['Vincent Paronnaud'],
production:['Xavier Rigault','Marc-Antoine Robert'],
music:['Olivier Bernet'],
cut:['Stéphane Roche'],
sound:['Sylvie Gourgner','Julie Tribout','Samy Bardet'],
scenography:['Marisa Musy']},
{title:'The Iron Giant',
titleCZ:'Železný obr',
year:1999,
runtime:86,
countries:['USA'],
genres:['Animation','Family','Sci-Fi','Comedy','Adventure','Crime','Action'],
director:['Brad Bird'],
actors:['Jennifer Aniston','Harry Connick','Jr.','Vin Diesel','James Gammon','Cloris Leachman','Christopher McDonald','John Mahoney','Eli Marienthal','M. Emmet Walsh','Oliver M. Johnston Jr.','Rodger Bumpass','Bill Farmer','Brian Tochi','Bob Bergen','Frank Thomas','Zack Eginton','Phil Proctor','Robert Clotworthy','Mary Kay Bergman','Charles Howerton','Patti Tippo','Jan Waldekranz','Paul Eiding','Jennifer Darling','Jack Angel',"Ryan O'Donohue"],
basedOn:['Will Eisner'],
screenplay:['Tim McCanlies'],
production:['Des McAnuff'],
music:['Michael Kamen'],
sound:['Dennis Leonard','Randy Thom','Argiris Kandilis'],
scenography:['Mark Whiting','Alan Bodner']},
{title:'Puss in Boots: The Last Wish',
titleCZ:'Kocour v botách: Poslední přání',
year:2022,
runtime:101,
countries:['USA'],
genres:['Animation','Action','Adventure','Comedy','Family','Fantasy'],
director:['Joel Crawford','Januel Mercado'],
actors:['Antonio Banderas','Salma Hayek','Harvey Guillén','Florence Pugh','Olivia Colman','Ray Winstone','Samson Kayo','John Mulaney','Wagner Moura',"Da'Vine Joy Randolph",'Anthony Mendez','Joel Crawford','Paul Fisher','James Ryan','Conrad Vernon','Januel Mercado'],
screenplay:['Paul Fisher','Tommy Swerdlow'],
production:['Mark Swift'],
music:['Heitor Pereira'],
cut:['James Ryan'],
sound:['Oleg Kulchytskyi','Julian Slater','Greg P. Russell'],
scenography:['Nate Wragg']},
{title:'Song of the Sea',
titleCZ:'Píseň moře',
year:2014,
runtime:94,
countries:['Ireland','Denmark','Belgium','Luxembourg','France'],
genres:['Animation','Family','Fantasy'],
director:['Tomm Moore'],
actors:['Brendan Gleeson','Fionnula Flanagan','Pat Shortt','David Rawle','Jon Kenny','Lisa Hannigan',"Lucy O'Connell",'Paul Young','Grethe Mogensen'],
screenplay:['Will Collins','Tomm Moore'],
production:['Claus Toksvig Kjaer','Tomm Moore','Ross Murray','Frederik Villumsen','Paul Young','Stéphan Roelants'],
music:['Bruno Coulais'],
sound:['Felix Davin','Alexandre Jaclain'],
scenography:['Adrien Merigeau']},
{title:'Cat on a Hot Tin Roof',
titleCZ:'Kočka na rozpálené plechové střeše',
year:1958,
runtime:104,
countries:['USA'],
genres:['Drama'],
director:['Richard Brooks'],
actors:['Elizabeth Taylor','Paul Newman','Burl Ives','Jack Carson','Judith Anderson','Madeleine Sherwood','Larry Gates','Vaughn Taylor','Hugh Corcoran',"Robert 'Rusty' Stevens",'Walter Merrill','Bobby Johnson','Jeane Wood','Patty Ann Gerrity'],
screenplay:['Richard Brooks','Tennessee Williams','James Poe'],
production:['Lawrence Weingarten'],
music:['Charles Wolcott'],
camera:['William H. Daniels'],
cut:['Ferris Webster'],
sound:['Wesley C. Miller'],
scenography:['William A. Horning','Henry Grace'],
masks:['John Truwe','William Tuttle']},
{title:'Mississippi Burning',
titleCZ:'Hořící Mississippi',
year:1988,
runtime:121,
countries:['USA'],
genres:['Drama','History','Crime','Mystery','Thriller'],
director:['Alan Parker'],
actors:['Gene Hackman','Willem Dafoe','Frances McDormand','Brad Dourif','R. Lee Ermey','Gailard Sartain','Stephen Tobolowsky','Michael Rooker','Pruitt Taylor Vince','Badja Djola','Kevin Dunn','Frankie Faison','Stephen Bridgewater','Park Overall','Tobin Bell','Ed Geldart','Darius McCrary','Rick Zieff','Mark Jeffrey Miller','Robert F. Colesberry','Frederick Zollo','Simeon Teague','Ralnardo Davis','Everett Thrall','Dan Desmond','Lou Walker','Geoffrey Nauffts','John P. Fertitta','Robert Glaudini','Tonea Stewart','Mert Hatfield','Daniel Chapman','Paul Henderson','Ken Magee'],
screenplay:['Chris Gerolmo'],
production:['Robert F. Colesberry','Frederick Zollo'],
music:['Trevor Jones'],
camera:['Peter Biziou'],
cut:['Gerry Hambling'],
scenography:['Geoffrey Kirkland','Philip Harrison','Jim Erickson'],
costumes:['Aude Bronson-Howard']},
{title:'The Apartment',
titleCZ:'Byt',
year:1960,
runtime:125,
countries:['USA'],
genres:['Drama','Comedy','Romance'],
director:['Billy Wilder'],
actors:['Jack Lemmon','Shirley MacLaine','Fred MacMurray','Ray Walston','Jack Kruschen','David Lewis','Hope Holiday','Joan Shawlee','Naomi Stevens','Johnny Seven','Joyce Jameson','Willard Waterman','David White','Edie Adams','Bill Baldwin','Fortune Cookie','Paul Picerni','Hal Smith','Franca Marzi','David Macklin',"Monty O'Grady",'Steve Carruthers','Herschel Graham','Lars Hensen','Eugene Jackson','Mason Curry','Lynn Cartwright','Dick Cherney','Norman Stevans','Sid Troy','William Meader','Tony Regan'],
screenplay:['Billy Wilder','I.A.L. Diamond'],
production:['Billy Wilder'],
music:['Adolph Deutsch'],
camera:['Joseph LaShelle'],
cut:['Daniel Mandell'],
sound:['Fred Lau'],
scenography:['Ottavio Scotti','Edward G. Boyle'],
masks:['Harry Ray']},
{title:'The Cabinet of Dr. Caligari',
titleCZ:'Kabinet doktora Caligariho',
year:1920,
runtime:71,
countries:['Germany'],
genres:['Drama','Horror','Fantasy','Mystery'],
director:['Robert Wiene'],
actors:['Werner Krauss','Conrad Veidt','Friedrich Fehér','Lil Dagover','Rudolf Klein-Rogge','Hans Heinrich von Twardowski','Rudolf Lettinger'],
screenplay:['Carl Mayer','Hans Janowitz'],
production:['Erich Pommer'],
music:['Alfredo Antonini'],
camera:['Willy Hameister'],
scenography:['Hermann Warm','Walter Röhrig']},
{title:'Children of Heaven',
titleCZ:'Božské děti',
year:1997,
runtime:89,
countries:['Iran'],
genres:['Comedy','Drama'],
director:['Majid Majidi'],
actors:['Mohammad Amir Naji','Amir Farrokh Hashemian','Bahare Seddiqi','Fereshte Sarabandi','Christopher Maleki','Dariush Mokhtari'],
screenplay:['Majid Majidi'],
music:['Kayvan Jahanshahi'],
camera:['Parviz Malekzaade']},
{title:'Andrei Rublev',
titleCZ:'Andrej Rublev',
year:1966,
runtime:175,
countries:['Russia'],
genres:['Drama','Biographic','History','Psychology'],
director:['Andrej Tarkovskij'],
actors:['Anatolij Solonicyn','Nikolaj Griňko','Bolot Bejšenalijev','Nikolaj Burljajev','Jurij Nikulin','Rolan Bykov','Dmitrij Orlovskij','Michail Kononov','Irina Tarkovskaja','Vladimir Guskov','Vasilij Cygankov','Nikolay Kutuzov','Nikolaj Grabbe','Irina Mirošničenko'],
screenplay:['Andrej Tarkovskij','Andrej Končalovskij'],
music:['Vjačeslav Ovčinnikov'],
camera:['Vadim Jusov'],
cut:['Taťjana Jegoryčeva','Ljudmila Fejginova']},
{title:'Red Beard',
titleCZ:'Rudovous',
year:1965,
runtime:185,
countries:['Japan'],
genres:['Drama'],
director:['Akira Kurosawa'],
actors:['Toširó Mifune','Júzó Kajama','Cutomu Jamazaki','Kjóko Kagawa','Reiko Dan','Mijuki Kuwano','Haruko Sugimura','Kamatari Fudžiwara','Jošitaka Zuši','Kin Sugai','Acuši Watanabe','Čišú Rjú','Takaši Šimura','Kinujo Tanaka','Eidžiró Tóno','Kódži Micui','Akiko Kazami','Jutaka Sada','Šódži Óki','Bokuzen Hidari','Mičiko Araki','Akemi Negiši','Terumi Niki','Šóiči Hirose','Noriko Honma','Joširo Učida'],
screenplay:['Hideo Oguni','Masato Ide','Akira Kurosawa','Ryûzô Kikushima'],
production:['Tomojuki Tanaka'],
music:['Masaru Sató'],
camera:['Asakazu Nakai','Takao Saitó']},
{title:'All Quiet on the Western Front',
titleCZ:'Na západní frontě klid',
year:2022,
runtime:148,
countries:['Germany','USA'],
genres:['War','Action','Drama'],
director:['Edward Berger'],
actors:['Felix Kammerer','Albrecht Schuch','Moritz Klaus','Aaron Hilmer','Adrian Grünewald','Edin Hasanović','Daniel Brühl','Devid Striesow','Sebastian Hülk','Andreas Döhler','Thibault de Montalembert','Luc Feit','Michael Wittenborn','Michael Stange','Sascha Nathan','Tobias Langhoff','Anton von Lucke','Michael Pitthan','Joe Weintraub','Charles Morillon','Gabriel Dufay','Dan Brown','Philipp Schenker','Cyril Dobrý','Sebastian Jacques','Gregory Gudgeon','Cyril Čechák','Jakob Schmidt','Felix von Bredow','Martin Dostál','Marek Simberský','Jakob Diehl','Anthony Paliotti','Radek Brodil','Jonathan Henault','Nico Ehrenteit','Hendrik Heutmann','Daniel Kamen','Tomáš Čapek','Markus Tomczyk','Emil Rothermel','Wolf Danny Homann','Michal Závodský','Nicolas Prokop','Jacob Zacharias Eckstein','Peter Sikorski','Alžběta Malá','Andrea Zatloukalová','Thomas Zielinski','Tomáš Weber','Samuel Neduha','Martin Němec','Tomáš Merkl','André Marcon','Dominikus Weileder','Alexander Schuster','Milan Lorenzo Koritják','Mark Kristián Hochman'],
basedOn:['Erich Maria Remarque'],
screenplay:['Edward Berger','Lesley Paterson','Ian Stokell'],
production:['Malte Grunert','Daniel Marc Dreifuss','Edward Berger'],
music:['Volker Bertelmann'],
camera:['James Friend'],
cut:['Sven Budelmann'],
sound:['Lars Ginzel','Markus Stemler','Frank Kruse','Stefan Korte','Viktor Prášil'],
scenography:['Christian M. Goldbeck','Ernestine Hipper'],
masks:['Heike Merker'],
costumes:['Lisy Christl']},
{title:'M',
titleCZ:'Vrah mezi námi',
year:1931,
runtime:117,
countries:['Germany'],
genres:['Crime','Mystery','Thriller','Drama'],
director:['Fritz Lang'],
actors:['Peter Lorre','Ellen Widmann','Inge Landgut','Otto Wernicke','Theodor Loos','Gustaf Gründgens','Fritz Odemar','Theo Lingen','Georg John','Ernst Stahl-Nachbaur','Gerhard Bienert','Karl Platen','Rosa Valetti','Hertha von Walther','Heinrich Gretler','Lotte Loebinger','Paul Rehkopf','Rolf Wanka','Sigurd Lohde','Paul Kemp','Rudolf Blümner','Josef Dahmen','Karl Elzer','Bruno Ziener','Carl Balhaus','Hadrian Maria Netto','Leonard Steckel','Edgar Pauly','Ilse Fürstenberg','Else Ehser','Paul Mederow','Friedrich Gnaß','Fred Nurney','Neumann-Schüler','Günter Neumann','Albert Hörrmann','Klaus Pohl','Max Sablotzki'],
screenplay:['Thea von Harbou','Fritz Lang'],
production:['Seymour Nebenzal'],
camera:['Fritz Arno Wagner'],
cut:['Paul Falkenberg'],
sound:['Adolf Jansen']},
{title:'A Silent Voice',
titleCZ:'Koe no katači',
year:2016,
runtime:130,
countries:['Japan'],
genres:['Animation','Drama','Psychology','Romance'],
director:['Naoko Jamada'],
actors:['Aoi Júki','Maju Macuoka','Tošijuki Tojonaga','Sacuki Jukino','Miju Irino','Ikuko Tani','Saori Hajami','Akiko Hiramacu','Kenšó Ono','Hana Takeda','Rjó Nišitani','Jui Išikawa','Chris Jai Alex','Sačiko Kodžima','Júki Kaneko','Rjúnosuke Watanuki','Takuja Masumoto','Ajano Hamaguči'],
basedOn:['Jošitoki Óima'],
screenplay:['Reiko Jošida'],
production:['Mikio Uecuki'],
music:['Kensuke Ušio'],
camera:['Kazuya Takao'],
cut:['Kengo Šigemura'],
sound:['Jóta Curuoka'],
scenography:['Mucuo Šinohara']},
{title:'Edward Scissorhands',
titleCZ:'Střihoruký Edward',
year:1990,
runtime:101,
countries:['USA'],
genres:['Drama','Fantasy','Romance'],
director:['Tim Burton'],
actors:['Johnny Depp','Winona Ryder','Dianne Wiest','Anthony Michael Hall','Kathy Baker','Robert Oliveri','Conchata Ferrell','Caroline Aaron','Vincent Price','Alan Arkin','Bryan Larkin','Steven Brill','Brett Rice','Dick Anthony Williams','O-Lan Jones','Nick Carter','Aaron Lustig','Alan Fudge','Marc Macaulay','Susan Blommaert','Stuart Lancaster','Mary Jane Heath','Peter Palmer','Biff Yeager','Donna Pieroni'],
screenplay:['Caroline Thompson'],
production:['Denise Di Novi','Tim Burton'],
music:['Danny Elfman'],
camera:['Stefan Czapsky'],
cut:['Colleen Halsey','Richard Halsey'],
sound:['Richard L. Anderson','Steve Maslow','Petur Hliddal','Stanley Kastner'],
scenography:['Bo Welch'],
masks:['Liz Spang','Ve Neill','Steve La Porte','Yolanda Toussieng','Matthew W. Mungle','Steve La Porte'],
costumes:['Colleen Atwood']},
{title:'Ice Age',
titleCZ:'Doba ledová',
year:2002,
runtime:78,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Carlos Saldanha','Chris Wedge'],
actors:['Ray Romano','John Leguizamo','Denis Leary','Goran Višnjič','Jack Black','Cedric the Entertainer','Diedrich Bader','Alan Tudyk','Jane Krakowski','Josh Hamilton','Chris Wedge','Lorri Bagley','Stephen Root','Rafael Mukajev','Jegor Pazenko','Alexandr Karpilovskij','Vladimir Koševoj','Vladimir Zajcev','Alexandr Semčev','Mitzi McCall','Denny Dillon','Sergej Treběsov','Mona Marshall','Cam Clarke','Jennifer Darling','Danny Mann','Kimberly Brooks'],
screenplay:['Michael Berg','Peter Ackerman'],
production:['Lori Forte'],
music:['David Newman'],
cut:['John Carnochan'],
sound:['Paul Massey','Doug Hemphill','Sean Garnhart'],
scenography:['Brian McEntee']},
{title:'Eternal Sunshine of the Spotless Mind',
titleCZ:'Věčný svit neposkvrněné mysli',
year:2004,
runtime:108,
countries:['USA'],
genres:['Drama','Romance','Sci-Fi'],
director:['Michel Gondry'],
actors:['Jim Carrey','Kate Winslet','Kirsten Dunst','Tom Wilkinson','Mark Ruffalo','Elijah Wood','Ryan Whitney','Debbon Ayer','Thomas Jay Ryan','Jane Adams','Paulie Litt','Josh Flitter','David Cross',"Deirdre O'Connell",'Lola Daehler','Gerry Robert Byrne'],
screenplay:['Charlie Kaufman'],
production:['Steve Golin','Anthony Bregman'],
music:['Jon Brion'],
camera:['Ellen Kuras'],
cut:['Valdís Óskarsdóttir'],
sound:['Eugene Gearty','Bob Olari'],
scenography:['Dan Leigh','Ron von Blomberg'],
costumes:['Melissa Toth']},
{title:'The Mission',
titleCZ:'Mise',
year:1986,
runtime:125,
countries:['UK','France'],
genres:['Drama','Adventure','History'],
director:['Roland Joffé'],
actors:['Robert De Niro','Jeremy Irons','Ray McAnally','Aidan Quinn','Cherie Lunghi','Ronald Pickup','Liam Neeson','Álvaro Guerrero','Chuck Low','Fred Melamed','Sigifredo Ismare','Rolf Gray','Asuncion Ontiveros','Alejandrino Moya','Bercelio Moya'],
screenplay:['Robert Bolt'],
production:['David Puttnam'],
music:['Ennio Morricone'],
camera:['Chris Menges'],
cut:['Jim Clark'],
scenography:['Stuart Craig'],
costumes:['Enrico Sabbatini']},
{title:"The World's Fastest Indian",
titleCZ:'V zajetí rychlosti',
year:2005,
runtime:121,
countries:['New Zealand','USA'],
genres:['Adventure','Drama','Sport','Biographic'],
director:['Roger Donaldson'],
actors:['Anthony Hopkins','Christopher Lawford','Aaron Murphy','Chris Williams','Craig Hall','Bruce Greenwood','Diane Ladd','Gavin Grazer','Walton Goggins','Patrick John Flueger','Paul Rodriguez','Chris Bruno','Campbell Cooley','Jessica Cauffiel','Alison Bruce','Antony Starr','William Lucking','Mark Ruka','Eric Pierpoint','Charles Halford','Michael Mantell','Wesley Dowdel','Saginaw Grant','Carlos Lacámara','Joe Howard','Morgan Lund','Daniel Sing','Latham Gaines','Kristen Marie Jensen','Annie Whittle','Todd Emerson','James Gaylyn','J. Owen Rogers','Dallas Ryan'],
screenplay:['Roger Donaldson'],
production:['Gary Hannam','Roger Donaldson'],
music:['J. Peter Robinson'],
camera:['David Gribble'],
cut:['John Gilbert'],
sound:['Michael Hedges'],
scenography:['Dennis Washington','Robert Gillies','Jennifer Ward'],
costumes:['Jane Holland','Nancy Cavallaro']},
{title:'Spring, Summer, Fall, Winter... and Spring',
titleCZ:'Jaro, léto, podzim, zima... a jaro',
year:2003,
runtime:103,
countries:['South Korea','Germany'],
genres:['Drama','Poetic'],
director:['Ki-duk Kim'],
actors:['Yeong-su Oh','Ki-duk Kim','Yeong-min Kim','Jae-kyeong Seo','Dae-han Ji','Jeong-yeong Kim','Park Ji-a'],
screenplay:['Ki-duk Kim'],
camera:['Dong-hyeon Baek'],
cut:['Ki-duk Kim']},
{title:'Wait Until Dark',
titleCZ:'Čekej do tmy',
year:1967,
runtime:108,
countries:['USA'],
genres:['Horror','Thriller'],
director:['Terence Young'],
actors:['Audrey Hepburn','Alan Arkin','Richard Crenna','Efrem Zimbalist Jr.','Jack Weston','Samantha Jones','Robby Benson','Mel Ferrer','Jean Del Val','Gary Morgan'],
screenplay:['Frederick Knott','Robert Carrington','Jane-Howard Hammerstein'],
production:['Mel Ferrer'],
music:['Henry Mancini'],
camera:['Charles Lang'],
cut:['Gene Milford'],
masks:['Gordon Bau']},
{title:'Barry Lyndon',
titleCZ:'Barry Lyndon',
year:1975,
runtime:184,
countries:['UK'],
genres:['Drama','War','Adventure','History'],
director:['Stanley Kubrick'],
actors:["Ryan O'Neal",'Marisa Berenson','Patrick Magee','Hardy Krüger','Steven Berkoff','Diana Körner','Murray Melvin','André Morell','Philip Stone','Peter Cellier','Ferdy Mayne','Dominic Savage','Anthony Sharp','Vivian Kubrick','Hans Meyer','Michael Hordern','John Bindon','David Bonté Morley','Marie Kean','Pat Roach','Leon Vitali','Leonard Rossiter','Harry Towb','Wolf Kahler','Frank Middlemass','George Sewell','Roger Booth','Barry Jackson','Bernard Hepton','Geoffrey Chater','Godfrey Quigley','Frederick Schiller','Liam Redmond','Gay Hamilton','Jonathan Cecil','Anthony Dawes','Katharina Kubrick','George Holdcroft','John Sharp'],
basedOn:['William Makepeace Thackeray'],
screenplay:['Stanley Kubrick'],
production:['Stanley Kubrick'],
music:['Leonard Rosenman'],
camera:['John Alcott'],
cut:['Tony Lawson'],
scenography:['Ken Adam'],
masks:['Alan Boyle','Barbara Daly','Ann Brodie','Colin Arthur'],
costumes:['Milena Canonero','Ulla-Britt Söderlund']},
{title:'Lawrence of Arabia',
titleCZ:'Lawrence z Arábie',
year:1962,
runtime:216,
countries:['UK'],
genres:['Adventure','War','Drama','Biographic'],
director:['David Lean'],
actors:["Peter O'Toole",'Alec Guinness','Anthony Quinn','Jack Hawkins','Omar Sharif','José Ferrer','Anthony Quayle','Claude Rains','Arthur Kennedy','Donald Wolfit','I.S. Johar','David Lean','Jack Hedley','Ian MacNaughton','Jack Gwillim','Fernando Sancho','Daniel Moynihan','George Plimpton','Howard Marion-Crawford','Rafael Hernández','Harry Fowler','Michel Ray','Robert Bolt','James Hayter','Robert Rietty','Zia Mohyeddin','Gamil Ratib','Basil Dignam','Stuart Saunders','Clive Morton','Ernie Rice','Bruce Beepy','Norman Rossington','Cyril Shaps','Henry Oscar','Bryan Pringle','John Robinson','Noel Howlett','Barry Warren','John Ruddock','Peter Burton','Ugo Pagliai'],
basedOn:['T. E. Lawrence'],
screenplay:['Robert Bolt','Michael Wilson'],
production:['Sam Spiegel','David Lean'],
music:['Maurice Jarre'],
camera:['Freddie Young'],
cut:['Anne V. Coates'],
scenography:['John Box'],
costumes:['Phyllis Dalton']},
{title:'War of the Buttons',
titleCZ:'Knoflíková válka',
year:2011,
runtime:100,
countries:['France'],
genres:['Adventure'],
director:['Christophe Barratier'],
actors:['Laetitia Casta','Guillaume Canet','Jean Texier','Kad Merad','Gérard Jugnot','François Morel','Ilona Bachelier','Marie Bunel','Clément Godefroy','Grégory Gatignol','Thierry Nenez','Eric Naggar','Thierry Liagre','Théophile Baquet','Thomas Langmann','Nathan Parent','Louis Dussol','Thomas Goldberg'],
basedOn:['Louis Pergaud'],
screenplay:['Christophe Barratier'],
production:['Thomas Langmann'],
music:['Philippe Rombi'],
cut:['Anne-Sophie Bion','Yves Deschamps'],
sound:['Edouard Morin','Daniel Sobrino']},
{title:'Dersu Uzala',
titleCZ:'Děrsu Uzala',
year:1975,
runtime:137,
countries:['Russia','Japan'],
genres:['Adventure','Drama','Biographic'],
director:['Akira Kurosawa'],
actors:['Maksim Munzuk','Jurij Solomin','Svetlana Danilčenko','Alexandr Pjatkov','Daniil Nětrebin','Sujmenkul Čokmorov'],
basedOn:['Vladimir Arsenev'],
screenplay:['Akira Kurosawa'],
music:['Isaak Švarc'],
camera:['Asakazu Nakai','Fyodor Dobronravov']},
{title:'Bicycle Thieves',
titleCZ:'Zloději kol',
year:1948,
runtime:93,
countries:['Italy'],
genres:['Drama'],
director:['Vittorio De Sica'],
actors:['Lamberto Maggiorani','Enzo Staiola','Lianella Carell','Gino Saltamerenda','Vittorio Antonucci','Giulio Chiari','Carlo Jachino','Emma Druetti','Nando Bruno','Sergio Leone','Memmo Carotenuto','Giulio Battiferri','Eolo Capritti','Umberto Spadaro','Fausto Guerzoni','Mario Meniconi','Elena Altieri','Peppino Spadaro'],
screenplay:['Cesare Zavattini','Vittorio De Sica','Oreste Biancoli','Adolfo Franci',"Suso Cecchi D'Amico"],
production:['Giuseppe Amato'],
music:['Alessandro Cicognini'],
camera:['Carlo Montuori'],
cut:['Eraldo Da Roma']},
{title:'Double Indemnity',
titleCZ:'Pojistka smrti',
year:1944,
runtime:107,
countries:['USA'],
genres:['Drama','Film-Noir','Crime','Mystery','Thriller'],
director:['Billy Wilder'],
actors:['Fred MacMurray','Barbara Stanwyck','Edward G. Robinson','Porter Hall','Jean Heather','Tom Powers','Richard Gaines','Fortunio Bonanova','John Philliber','Clarence Muse','John Berry','Raymond Chandler','Bess Flowers','George Magrill','Teala Loring','Edmund Cobb','Sam McDaniel','Douglas Spencer','Dick Rush','Kernan Cripps','Eddie Hall','Betty Farrington'],
basedOn:['James M. Cain'],
screenplay:['Billy Wilder','Raymond Chandler'],
production:['Joseph Sistrom'],
music:['Miklós Rózsa'],
camera:['John F. Seitz'],
sound:['Stanley Cooley','Loren L. Ryder','Walter Oberst'],
scenography:['Hal Pereira','Hans Dreier','David S. Hall'],
masks:['Robert Ewing','Wally Westmore','Hollis Barnes'],
costumes:['Edith Head']},
{title:'Paris, Texas',
titleCZ:'Paříž, Texas',
year:1984,
runtime:147,
countries:['UK','France','Germany','USA'],
genres:['Drama','Road movie'],
director:['Wim Wenders'],
actors:['Harry Dean Stanton','Nastassja Kinski','Dean Stockwell','Aurore Clément','Bernhard Wicki','Sam Shepard','John Lurie','Tom F. Farrell','Viva','Hunter Carson'],
screenplay:['Sam Shepard'],
production:['Anatole Dauman','Don Guest'],
music:['Ry Cooder'],
camera:['Robby Müller'],
cut:['Peter Przygodda'],
sound:['Jean-Paul Mugel','Hartmut Eichgrün'],
costumes:['Birgitta Bjerke']},
{title:'Phar Lap',
titleCZ:'Phar Lap: Národní hrdina',
year:1983,
runtime:103,
countries:['Australia'],
genres:['Drama','Family','Sport'],
director:['Simon Wincer'],
actors:['Tom Burlinson','Ron Leibman','Vincent Ball','Gia Carides','Judy Morris','Tommy Woodcock','Richard Terrill','Redmond Phillips','Stuart Finch','Peter Whitford','John Stanton'],
screenplay:['David Williamson'],
music:['Bruce Rowland'],
camera:['Russell Boyd'],
cut:['Tony Paterson']},
{title:'The Sound of Music',
titleCZ:'Za zvuků hudby',
year:1965,
runtime:174,
countries:['USA'],
genres:['Musical','Family','Drama','Biographic'],
director:['Robert Wise'],
actors:['Julie Andrews','Christopher Plummer','Eleanor Parker','Richard Haydn','Peggy Wood','Heather Menzies-Urich','Nicholas Hammond','Angela Cartwright','Kym Karath','Anna Lee','Ben Wright','Bert Stevens','Portia Nelson','Norma Varden','Doris Lloyd','Jeffrey Sayre','Sam Harris','Gertrude Astor','Bernard Sell','Gilchrist Stuart','Norman Stevans','William Meader','Leoda Richards'],
basedOn:['Maria von Trapp'],
screenplay:['Ernest Lehman'],
production:['Richard D. Zanuck','Robert Wise'],
music:['Richard Rodgers','Irwin Kostal'],
camera:['Ted D. McCord'],
cut:['William Reynolds'],
sound:['Fred Hynes','James Corcoran'],
scenography:['Boris Leven','Walter M. Scott'],
masks:['Ben Nye'],
costumes:['Dorothy Jeakins']},
{title:'A Short Film About Love',
titleCZ:'Krátký film o lásce',
year:1988,
runtime:83,
countries:['Poland'],
genres:['Drama','Romance'],
director:['Krzysztof Kieślowski'],
actors:['Grażyna Szapołowska','Olaf Lubaszenko','Stefania Iwińska','Piotr Machalica','Artur Barciś','Jan Piechociński','Hanna Chojnacka','Stanisław Gawlik','Tomasz Gradowski','Rafał Imbro','Krzysztof Koperski','Jarosława Michalewska','Małgorzata Rożniatowska','Emilia Ziółkowska','Anna Lenartowicz'],
screenplay:['Krzysztof Piesiewicz','Krzysztof Kieślowski'],
music:['Zbigniew Preisner'],
camera:['Witold Adamek'],
cut:['Ewa Smal'],
sound:['Nikodem Wołk-Łaniewski'],
scenography:['Halina Dobrowolska','Magdalena Dipont'],
masks:['Dorota Seweryńska'],
costumes:['Małgorzata Obłoza','Hanna Ćwikło']},
{title:'The Agony and the Ecstasy',
titleCZ:'Ve službách papeže',
year:1965,
runtime:138,
countries:['USA','Italy'],
genres:['Drama','History'],
director:['Carol Reed'],
actors:['Charlton Heston','Rex Harrison','Diane Cilento','Harry Andrews','Alberto Lupo','Adolfo Celi','Venantino Venantini','Tomas Milian','Alec McCowen','Fausto Tozzi','Maxine Audley','Furio Meniconi'],
basedOn:['Irving Stone'],
screenplay:['Philip Dunne'],
music:['Alex North','Jerry Goldsmith'],
camera:['Leon Shamroy'],
cut:['Samuel E. Beetley'],
sound:['James Corcoran'],
scenography:['John DeCuir','Jack Martin Smith'],
masks:['Grazia De Rossi'],
costumes:['Vittorio Nino Novarese']},
{title:'Sunrise',
titleCZ:'Východ slunce',
year:1927,
runtime:94,
countries:['USA'],
genres:['Drama','Romance'],
director:['Friedrich Wilhelm Murnau'],
actors:["George O'Brien",'Janet Gaynor','Margaret Livingston','Bodil Rosing','J. Farrell MacDonald','Jane Winton','Arthur Housman','Sally Eilers','Gibson Gowland','Barry Norton','Herman Bing','Gino Corrado','Harry Semels','Sidney Bracey','Clarence Wilson','Eddie Boland','Thomas Jefferson','Bob Kortman','Phillips Smalley'],
basedOn:['Hermann Sudermann'],
screenplay:['Carl Mayer'],
production:['William Fox'],
music:['Willy Schmidt-Gentner','Hugo Riesenfeld'],
camera:['Karl Struss','Charles Rosher'],
cut:['Harold D. Schuster']},
{title:'Fail-Safe',
titleCZ:'Selhání vyloučeno',
year:1964,
runtime:112,
countries:['USA'],
genres:['Drama','Thriller'],
director:['Sidney Lumet'],
actors:["Dan O'Herlihy",'Walter Matthau','Henry Fonda','Larry Hagman','Frank Overton','Edward Binns','William Hansen','Russell Hardie','Russell Collins','Sorrell Booke','Hildy Parks','Dom DeLuise','Dana Elcar','Charles Tyner','Janet Ward','Fritz Weaver'],
basedOn:['Eugene Burdick','Harvey Wheeler'],
screenplay:['Walter Bernstein','Peter George'],
production:['Max E. Youngstein'],
camera:['Gerald Hirschfeld'],
cut:['Ralph Rosenblum'],
scenography:['Albert Brenner'],
costumes:['Anna Hill Johnstone']},
{title:'Woman in the Dunes',
titleCZ:'Písečná žena',
year:1964,
runtime:123,
countries:['Japan'],
genres:['Drama','Thriller','Parable'],
director:['Hiroši Tešigahara'],
actors:['Eidži Okada','Kjóko Kišida','Kódži Micui'],
basedOn:['Kóbó Abe'],
screenplay:['Kóbó Abe'],
music:['Tóru Takemicu']},
{title:'Phone Booth',
titleCZ:'Telefonní budka',
year:2002,
runtime:81,
countries:['USA'],
genres:['Thriller','Mystery','Psychology'],
director:['Joel Schumacher'],
actors:['Colin Farrell','Kiefer Sutherland','Forest Whitaker','Radha Mitchell','Katie Holmes','Paula Jai Parker','Tia Texada','John Enos III','Richard T. Jones','Keith Nobbs','James MacDonald','Josh Pais','Domenick Lombardozzi','Julio Oscar Mechoso','Dean Cochran','Tory Kittles','Ben Foster','Yorgo Constantine','Colin Patrick Lynch','Mia Cottet','Svetlana Jefremova','Jane Bordeaux','Dell Yount','Dean Tarrolly','Arian Ash','Mary Randle','Maile Flanagan'],
screenplay:['Larry Cohen'],
production:['Gil Netter'],
music:['Harry Gregson-Williams'],
camera:['Matthew Libatique'],
cut:['Mark Stevens'],
sound:['Marshall Garlington'],
scenography:['Andrew Laws'],
masks:['Michael Mills','Wendi Lynn Avignone'],
costumes:['Daniel Orlandi']},
{title:'The Nightmare Before Christmas',
titleCZ:'Ukradené Vánoce',
year:1993,
runtime:76,
countries:['USA'],
genres:['Animation','Family','Fantasy','Musical','Puppets'],
director:['Henry Selick'],
actors:['Chris Sarandon',"Catherine O'Hara",'William Hickey','Glenn Shadix','Paul Reubens','Ken Page','Danny Elfman','Sherwood Ball','Edward Ivory','Greg Proops','Billie Hayes'],
basedOn:['Tim Burton'],
screenplay:['Caroline Thompson','Michael McDowell'],
production:['Denise Di Novi','Tim Burton'],
music:['Danny Elfman'],
camera:['Pete Kozachik'],
cut:['Stan Webb'],
sound:['Richard L. Anderson','Greg P. Russell']},
{title:'Sleepers',
titleCZ:'Spáči',
year:1996,
runtime:147,
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Barry Levinson'],
actors:['Kevin Bacon','Robert De Niro','Dustin Hoffman','Bruno Kirby','Jason Patric','Brad Pitt','Brad Renfro','Ron Eldard','Billy Crudup','Vittorio Gassman','Terry Kinney','Frank Medrano','Jonathan Tucker','Geoffrey Wigdor','Joe Perrino','Minnie Driver','Peter Appel','Gerry Becker','William Butler','Eugene Byrd','Pasquale Cajano','Robert W. Castle','John Di Benedetto','Jeffrey Donovan','Ben Hammer','Paul Herman','Lennie Loftin','Chuck Low','Ruth Maleczech','Danny Mastrogiorgio','Mary B. McCann','Pat McNamara','Peter McRobbie','Dash Mihok','Michael P. Moran','Carmine Parisi','James Pickens Jr.','Wendell Pierce','Larry Romano','Tom Signorelli','John Slattery','Henry Stram','Mary Testa','Aida Turturro','Joe Urla','Zachary Ansley','Michael J. Burg','Brian Donahue','Peter Gerety','Justin Halliwell','Billy Malone','George Vincent'],
basedOn:['Lorenzo Carcaterra'],
screenplay:['Barry Levinson'],
production:['Barry Levinson','Steve Golin'],
music:['John Williams'],
camera:['Michael Ballhaus'],
cut:['Stu Linder'],
sound:['Lora Hirschberg','Tim Holland','Tod A. Maitland','Gary Rydstrom'],
scenography:['Kristi Zea'],
masks:['Carl Fullerton'],
costumes:['Gloria Gresham']},
{title:'Payback',
titleCZ:'Odplata',
year:1999,
runtime:100,
countries:['USA'],
genres:['Action','Crime','Thriller','Drama'],
director:['Brian Helgeland'],
actors:['Mel Gibson','Gregg Henry','Maria Bello','David Paymer','Bill Duke','Deborah Kara Unger','John Glover','William Devane','Lucy Liu','Jack Conley','Kris Kristofferson','Freddy Rodríguez','Elizabeth Berridge','James Coburn','Manu Tupou','Robert Kurcz','Trevor St. John','Alex Henteloff','Júiči Hibi','Marc Vann','David Dunard','Alex Skuby','James Deuter','Robert Kim','Doc Duhame','Kwame Amoaku','Jeff Imada','Tedd Taskey'],
basedOn:['Donald E. Westlake'],
screenplay:['Brian Helgeland','Terry Hayes'],
production:['Bruce Davey'],
music:['Chris Boardman'],
camera:['Ericson Core'],
cut:['Kevin Stitt'],
sound:['Chris Carpenter'],
scenography:['Richard Hoover','Sandy Struth'],
masks:['Mindy Hall','Julie Hewett','Matthew W. Mungle','Jennifer Bell'],
costumes:['Ha Nguyen']},
{title:'Casablanca',
titleCZ:'Casablanca',
year:1942,
runtime:102,
countries:['USA'],
genres:['Drama','Romance','War'],
director:['Michael Curtiz'],
actors:['Humphrey Bogart','Ingrid Bergman','Paul Henreid','Claude Rains','Conrad Veidt','Sydney Greenstreet','Peter Lorre','Dooley Wilson','Joy Page','John Qualen','Madeleine Lebeau','Marcel Dalio','Creighton Hale','Dan Seymour','George J. Lewis','Hans Heinrich von Twardowski','Trude Berliner','Leo White','S.Z. Sakall','Paul Porcasi','George Meeker','Norma Varden','Curt Bois','Gino Corrado','Alberto Morin','Barry Norton','Dewey Robinson','Frank Puglia','William Edmunds','Gregory Gaye','Helmut Dantine','Leonid Kinskey','Henry Rowland','Frank Mazzola','Wolfgang Zilzer','Leon Belasco','Ludwig Stössel','Paul Panzer','Olaf Hytten','Ellinor Vanderveer','Oliver Blake','Martin Garralaga','Manuel París','Jacques Lory',"Monty O'Grady",'Sol Murgi',"Adrienne D'Ambricourt",'Herbert Evans','Arthur Stuart Hull','Gerald Oliver Smith','Louis Mercier','Ilka Grüning','Franco Corsaro','Dick Botiller','Michael Mark','Victor Romito','Louis V. Arco','Eugene Borden','Lester Sharpe','Sid Troy','George Sorel','Jacques Vanaire','Georges Renavent','Spencer Chan','George M. Carleton','Enrique Acosta','Melie Chang','Charles La Torre'],
screenplay:['Julius J. Epstein','Philip G. Epstein','Howard Koch','Casey Robinson','Murray Burnett','Joan Alison'],
production:['Hal B. Wallis'],
music:['Max Steiner'],
camera:['Arthur Edeson'],
cut:['Owen Marks'],
sound:['Francis J. Scheid'],
scenography:['Carl Jules Weyl'],
masks:['Perc Westmore'],
costumes:['Orry-Kelly']},
{title:'Beauty and the Beast',
titleCZ:'Kráska a zvíře',
year:2017,
runtime:129,
countries:['USA'],
genres:['Family','Fantasy','Musical','Romance'],
director:['Bill Condon'],
actors:['Emma Watson','Dan Stevens','Luke Evans','Josh Gad','Emma Thompson','Ewan McGregor','Kevin Kline','Gugu Mbatha-Raw','Ian McKellen','Stanley Tucci','Audra McDonald','Nathan Mack','Hattie Morahan','Sonoja Mizuno','Adrian Schiller','Dale Branston','Sophia Brown','Rudi Goodman','Rossana Silva','Lynne Wilmot','Michael Jibson','Harriet Jones','Henry Garrett',"Nicole O'Neill",'Zoe Rainey','Sophie Reid','Clem So','Richard Banks','Alexis Loizon','Lara Decaro','Cassie Clare','Pat Mastroianni','Skye Lucia Degruttola','Lily Frazer','Gerard Horan','Rafaëlle Cohen','Ray Fearon','Alona Leoine','Yuval David'],
screenplay:['Stephen Chbosky','Evan Spiliotopoulos'],
production:['David Hoberman','Todd Lieberman'],
music:['Alan Menken'],
camera:['Tobias A. Schliessler'],
cut:['Virginia Katz'],
sound:['Christian P. Minkler','Michael Minkler','Warren Shaw','Stephen P. Robinson','Sean Garnhart'],
scenography:['Sarah Greenwood','Katie Spencer'],
masks:['Dave Elsey','Göran Lundström','Jenny Shircore','Marc Pilcher'],
costumes:['Jacqueline Durran']},
{title:"Rory O'Shea Was Here",
titleCZ:'Uvnitř tančím',
year:2004,
runtime:104,
countries:['UK','Ireland','France'],
genres:['Drama','Comedy'],
director:["Damien O'Donnell"],
actors:['James McAvoy','Steven Robertson','Romola Garai','Brenda Fricker','Gerard McSorley','Pat Shortt','Stanley Townsend','Tom Hickey','Frank McCusker','Michèle Forbes','Emmet Kirwan','Adam Fergus',"Deirdre O'Kane"],
screenplay:['Jeffrey Caine'],
production:['Eric Fellner','James Flynn'],
music:['David Julyan'],
camera:['Peter Robertson'],
cut:['Frances Parker'],
sound:['Tom Johnson'],
scenography:['Tom Conroy'],
costumes:['Lorna Marie Mugan']},
{title:'Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb',
titleCZ:'Dr. Divnoláska aneb Jak jsem se naučil nedělat si starosti a mít rád bombu',
year:1964,
runtime:95,
countries:['USA','UK'],
genres:['Comedy','War'],
director:['Stanley Kubrick'],
actors:['Peter Sellers','George C. Scott','Sterling Hayden','Keenan Wynn','Slim Pickens','Peter Bull','James Earl Jones','Tracy Reed','Frank Berry','Roy Stephens','Paul Tamarin','Shane Rimmer','Jack Creley','Victor Harrington','Peter Roy','Glenn Beck','Laurence Herder','Hal Galili','Roland Brand','George Holdcroft'],
basedOn:['Peter George'],
screenplay:['Stanley Kubrick','Terry Southern','Peter George'],
production:['Stanley Kubrick'],
music:['Laurie Johnson'],
camera:['Gilbert Taylor'],
cut:['Anthony Harvey'],
scenography:['Ken Adam'],
masks:['Stuart Freeborn']},
{title:'The Trial of the Chicago 7',
titleCZ:'Chicagský tribunál',
year:2020,
runtime:129,
countries:['USA'],
genres:['Drama','History'],
director:['Aaron Sorkin'],
actors:['Eddie Redmayne','Alex Sharp','Sacha Baron Cohen','Jeremy Strong','John Carroll Lynch','Yahya Abdul-Mateen II','Mark Rylance','Joseph Gordon-Levitt','Ben Shenkman','J.C. MacKenzie','Frank Langella','Danny Flaherty','Noah Robbins','John Doman','Michael Keaton','Kelvin Harrison Jr.','Caitlin Fitzgerald','Alice Kremelberg','Juliette Angelo','Brendan Burke','Larry Mitchell',"Kevin O'Donnell",'Wayne Duvall','Damian Young','Michelle Hurst','Max Adler','Shawn Parsons','C.J. Wilson','Marco Lama','Alex Henderson','David Fierro','Lyndon B. Johnson','Martin Luther King','Robert F. Kennedy','Walter Cronkite','Dylan LaRay','Tiffany Denise Hobbs','Sam Nelson Harris','Steve Routman','Michael Oilar','David Bianco'],
screenplay:['Aaron Sorkin'],
production:['Marc Platt','Stuart M. Besser','Matt Jackson','Tyler Thompson'],
music:['Daniel Pemberton'],
camera:['Phedon Papamichael'],
cut:['Alan Baumgarten'],
sound:['Julian Slater'],
scenography:['Shane Valentino','Andrew Baseman','Nick Francone'],
masks:['Stephen Kelley'],
costumes:['Susan Lyall']},
{title:'Cinderella',
titleCZ:'Popelka',
year:2015,
runtime:105,
countries:['USA','UK'],
genres:['Fantasy','Romance','Drama','Family'],
director:['Kenneth Branagh'],
actors:['Lily James','Richard Madden','Cate Blanchett','Helena Bonham Carter','Nonso Anozie','Stellan Skarsgård','Sophie McShera','Holliday Grainger','Derek Jacobi','Ben Chaplin','Hayley Atwell','Rob Brydon','Alex MacQueen','Eloise Webb','Michael Jenn','Andrew Fitch','Edward Lewis French','Jd Roth-round','Julian Seager','Leila Wong','Ella Smith','Tomiwa Edun',"Josh O'Connor",'Francesca Bennett','Barrie Martin','Richard McCabe','Bentley Kalu','Daniel Tuite','Joshua McGuire','Sarah Sharman','Laurie Calvert','Lina Alminas','John W. G. Harley','Mimi Ndiweni','Anjana Vasan','Gerard Horan','Paul Hunter','Jon-Scott Clark','Matthew Steer','Jana Pérez','Sophie-Anna Brough'],
basedOn:['Charles Perrault'],
screenplay:['Chris Weitz'],
production:['Simon Kinberg','David Barron','Allison Shearmur'],
music:['Patrick Doyle'],
camera:['Haris Zambarloukos'],
cut:['Martin Walsh'],
sound:['James Mather','Richard Pryke'],
scenography:['Dante Ferretti','Francesca Lo Schiavo'],
masks:['Naomi Donne','Nora Robertson','Wakana Yoshihara','Kay Georgiou','Morag Ross','Norma Webb','Emma Romans'],
costumes:['Sandy Powell']},
{title:'How to Steal a Million',
titleCZ:'Jak ukrást Venuši',
year:1966,
runtime:123,
countries:['USA'],
genres:['Comedy','Crime','Romance'],
director:['William Wyler'],
actors:['Audrey Hepburn',"Peter O'Toole",'Eli Wallach','Hugh Griffith','Charles Boyer','Fernand Gravey','Marcel Dalio','Jacques Marin','Roger Tréville','Moustache','Jacques Ramade','Olga Valéry','Louise Chevalier','Edward Malin'],
screenplay:['Harry Kurnitz'],
production:['Fred Kohlmar'],
music:['John Williams'],
camera:['Charles Lang'],
cut:['Robert Swink'],
sound:['Joseph de Bretagne'],
scenography:['Alexandre Trauner']},
{title:'Love and Death',
titleCZ:'Láska a smrt',
year:1975,
runtime:85,
countries:['USA'],
genres:['Comedy','War'],
director:['Woody Allen'],
actors:['Woody Allen','Diane Keaton','Féodor Atkine','Yves Barsacq','Yves Brainville','Harold Gould','Jessica Harper','James Tolkan','Howard Vernon','Frank Adu','Olga Georges-Picot','Luce Fabiole','Alfred Lutter III','Georges Adet','Gérard Buhr','Roger Lumont','Henry Czarniak','Jacques Maury','Henri Coutet','Edmond Ardisson','Alan Tilvern','Aubrey Morris','Tony Jay','Anne Lonnberg','Albert Augier','Jack Berard','Rebecca Potok','Lloyd Battista','Andrée Tainsy','Tutte Lemkow','Denise Péron','Brian Coburn','Sandor Elès','Clément Thierry','Leib Lensky','Zvee Scooler','Shimen Ruskin','Despo Diamantidou'],
screenplay:['Woody Allen'],
production:['Charles H. Joffe'],
music:['Sergej Prokofjev'],
camera:['Ghislain Cloquet'],
cut:['Ron Kalish','Ralph Rosenblum','George Hively'],
masks:['Marie-Madeleine Paris'],
costumes:['Gladys de Segonzac']},
{title:"Guess Who's Coming to Dinner",
titleCZ:'Hádej, kdo přijde na večeři',
year:1967,
runtime:108,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Stanley Kramer'],
actors:['Spencer Tracy','Sidney Poitier','Katharine Hepburn','Katharine Houghton','Cecil Kellaway','Beah Richards','Isabel Sanford','Roy Glenn','Virginia Christine','Barbara Randolph','John Hudkins','Alexandra Hay',"D'Urville Martin",'Skip Martin','Tom Heaton','Timothy Scott','Jacqueline Fontaine','Grace Gaynor','Natalie Core'],
screenplay:['William Rose'],
production:['Stanley Kramer'],
music:['Frank De Vol'],
camera:['Sam Leavitt'],
cut:['Robert C. Jones'],
sound:['Charles J. Rice','Clem Portman'],
scenography:['Robert Clatworthy','Frank Tuttle'],
masks:['Joe DiBella','Ben Lane']},
{title:'The Old Gun',
titleCZ:'Stará puška',
year:1975,
runtime:100,
countries:['France','Germany'],
genres:['War','Thriller','Drama'],
director:['Robert Enrico'],
actors:['Philippe Noiret','Romy Schneider','Jean Bouise','Joachim Hansen','Karl Michael Vogler','Madeleine Ozeray','Antoine Saint-John','Marie-Blanche Vergnes','Robert Hoffmann','Daniel Breton','Gérard Dauzat','Catherine Delaporte'],
screenplay:['Robert Enrico','Claude Veillot','Pascal Jardin'],
music:['François de Roubaix'],
camera:['Étienne Becker'],
cut:['Eva Zora'],
sound:['Bernard Aubouy'],
masks:['Didier Lavergne'],
costumes:['Corinne Jorry']},
{title:'Yojimbo',
titleCZ:'Yojimbo',
year:1961,
runtime:110,
countries:['Japan'],
genres:['Drama','Action'],
director:['Akira Kurosawa'],
actors:['Toširó Mifune','Tacuja Nakadai','Jóko Cukasa','Isuzu Jamada','Daisuke Kató','Takaši Šimura','Hiroši Tačikawa','Eidžiró Tóno','Kamatari Fudžiwara','Acuši Watanabe','Susumu Fudžita','Kó Nišimura','Jutaka Sada','Šódži Óki','Kiwami Sazanka','Noriko Honma','Akira Tani'],
screenplay:['Akira Kurosawa','Ryûzô Kikushima'],
production:['Akira Kurosawa'],
music:['Masaru Sató'],
camera:['Kazuo Mijagawa'],
cut:['Akira Kurosawa']},
{title:'Departures',
titleCZ:'Průvodce',
year:2008,
runtime:130,
countries:['Japan'],
genres:['Drama'],
director:['Jódžiró Takita'],
actors:['Masahiro Motoki','Cutomu Jamazaki','Rjóko Hirosue','Kazuko Jošijuki','Kimiko Jo','Takaši Sasano','Tetta Sugimoto','Sanae Mijata','Jóko Imamoto','Tacuhito Okuda','Tacuo Jamada','Tóru Minegiši','Mari Hajašida'],
screenplay:['Kundó Kojama'],
music:['Džó Hisaiši'],
camera:['Takeši Hamada']},
{title:'The Circus',
titleCZ:'Cirkus',
year:1928,
runtime:72,
countries:['USA'],
genres:['Comedy','Family','Drama','Romance'],
director:['Charlie Chaplin'],
actors:['Charlie Chaplin','Merna Kennedy','Henry Bergman','Albert Austin','Stanley Blystone','Heinie Conklin','Hugh Saxon','George Davis','Tiny Sandford','Jack P. Pierce','Al Ernest Garcia','Harry Crocker'],
screenplay:['Charlie Chaplin'],
production:['Charlie Chaplin'],
music:['Charlie Chaplin'],
camera:['Roland Totheroh'],
cut:['Charlie Chaplin'],
scenography:['Charles D. Hall']},
{title:'The Passion of Joan of Arc',
titleCZ:'Utrpení Panny orleánské',
year:1928,
runtime:82,
countries:['France'],
genres:['Drama','Biographic','History'],
director:['Carl Theodor Dreyer'],
actors:['Maria Falconetti','Eugene Silvain','André Berley','Maurice Schutz','Antonin Artaud','Michel Simon',"Jean d'Yd",'Alexandre Mihalesco','Léon Larive','Jean Aymé','Gilbert Dalleu','Paul Jorge','Armand Lurville','Raymond Narlay','Louis Ravet'],
screenplay:['Carl Theodor Dreyer'],
music:['Jesper Kyd','Carlo Crivelli','Ole Schmidt'],
camera:['Rudolph Maté'],
cut:['Marguerite Beaugé','Carl Theodor Dreyer']},
{title:'Samurai Rebellion',
titleCZ:'Vzpoura',
year:1967,
runtime:128,
countries:['Japan'],
genres:['Drama'],
director:['Masaki Kobajaši'],
actors:['Toširó Mifune','Jóko Cukasa','Isao Jamagata','Tacuja Nakadai','Ecuko Ičihara','Tacuo Macumura','Takamaru Sasaki','Joširó Aoki','Džun Hamamura'],
screenplay:['Šinobu Hašimoto'],
production:['Tomojuki Tanaka'],
music:['Tóru Takemicu'],
camera:['Kazuo Yamada']},
{title:'Corpse Bride',
titleCZ:'Mrtvá nevěsta Tima Burtona',
year:2005,
runtime:74,
countries:['UK','USA'],
genres:['Animation','Fantasy','Romance','Musical'],
director:['Tim Burton','Mike Johnson'],
actors:['Johnny Depp','Helena Bonham Carter','Emily Watson','Albert Finney','Richard E. Grant','Christopher Lee','Joanna Lumley','Danny Elfman','Michael Gough','Tracey Ullman','Jane Horrocks','Deep Roy','Paul Whitehouse','Lisa Kay','Stephen Ballantyne','Enn Reitel','Jennifer Darling','Danny Mann'],
screenplay:['John August','Caroline Thompson','Pamela Pettler'],
production:['Tim Burton'],
music:['Danny Elfman'],
camera:['Pete Kozachik'],
cut:['Chris Lebenzon'],
sound:['Eddy Joseph','Michael Prestwood Smith','Steve Boeddeker','Michael Semanick'],
scenography:['Alex McDowell']},
{title:'Tangled',
titleCZ:'Na vlásku',
year:2010,
runtime:100,
countries:['USA'],
genres:['Animation','Comedy','Family','Musical','Romance','Fantasy'],
director:['Byron Howard','Nathan Greno'],
actors:['Mandy Moore','Zachary Levi','Donna Murphy','Ron Perlman','Jeffrey Tambor','Brad Garrett','M.C. Gainey','Paul F. Tompkins','Richard Kiel','Byron Howard','Anne Lockhart','Nicholas Guest','Russell Yuen','Kari Wahlgren','Hynden Walch','Michael Bell','Roy Conli','Paul Pape','Philip Le Maistre','Pat Fraley','Susanne Blakeslee','Mona Marshall','June Christopher','David Cowgill','Chad Einbinder'],
basedOn:['Jacob Grimm','Wilhelm Grimm'],
screenplay:['Dan Fogelman'],
production:['Roy Conli'],
music:['Alan Menken'],
sound:['Dean A. Zupancic','Ai-Ling Lee','David E. Fluhr']},
{title:'Donnie Darko',
titleCZ:'Donnie Darko',
year:2001,
runtime:113,
countries:['USA'],
genres:['Mystery','Drama','Sci-Fi'],
director:['Richard Kelly'],
actors:['Jake Gyllenhaal','Holmes Osborne','Maggie Gyllenhaal','Daveigh Chase','Mary McDonnell','James Duval','Patrick Swayze','David St. James','Seth Rogen','Jena Malone','Noah Wyle','Drew Barrymore','Jolene Purdy','Katharine Ross','Lisa K. Wyatt','Beth Grant','Ashley Tisdale','Jerry Trainor','Fran Kranz','Gary Lundy','Rachel Winfree','Stuart Stone','Lee Weaver','Tiler Peck','Patience Cleveland','Nancy Juvonen','Alex Greenwald','Dee Austin Robertson','Arthur Taxier','Scotty Leavenworth','Marina Malota Darling'],
screenplay:['Richard Kelly'],
production:['Sean McKittrick','Nancy Juvonen','Adam Fields'],
music:['Michael Andrews'],
camera:['Steven Poster'],
cut:['Sam Bauer','Eric Strand'],
sound:['Chris David','Chuck Michael'],
scenography:['Alec Hammond'],
masks:['Lynn Barber'],
costumes:['April Ferry']},
{title:'Monty Python and the Holy Grail',
titleCZ:'Monty Python a Svatý Grál',
year:1975,
runtime:91,
countries:['UK'],
genres:['Comedy','Adventure'],
director:['Terry Gilliam','Terry Jones'],
actors:['Graham Chapman','John Cleese','Eric Idle','Terry Gilliam','Terry Jones','Michael Palin','Carol Cleveland','Julian Doyle','Connie Booth','Neil Innes','Sandy Johnson','Rita Davies','John Young','Bee Duffell','Charles Knode','Roy Forge Smith','Maggie Weston'],
screenplay:['Graham Chapman','Terry Gilliam','Terry Jones','Eric Idle','John Cleese','Michael Palin'],
production:['Michael White','Mark Forstater'],
music:['Neil Innes'],
scenography:['Roy Forge Smith'],
costumes:['Hazel Pethig']},
{title:'Vertigo',
titleCZ:'Vertigo',
year:1958,
runtime:128,
countries:['USA'],
genres:['Mystery','Romance','Thriller'],
director:['Alfred Hitchcock'],
actors:['James Stewart','Kim Novak','Barbara Bel Geddes','Tom Helmore','Henry Jones','Ellen Corby','Konstantin Shayne','Lee Patrick','Alfred Hitchcock','June Jocelyn','Bess Flowers','Raymond Bailey','Paul Bryar','Jeffrey Sayre','Forbes Murray','Danny Borzage','Fred Graham','Steve Conte','Robert Haines','Molly Dodd','Nina Shipman','Sara Taft','Perk Lazelle','Ezelle Poule'],
basedOn:['Pierre Boileau','Thomas Narcejac'],
screenplay:['Alec Coppel','Samuel A. Taylor'],
production:['Alfred Hitchcock'],
music:['Bernard Herrmann'],
camera:['Robert Burks'],
cut:['George Tomasini'],
sound:['Winston H. Leverett','Harold Lewis'],
scenography:['Hal Pereira','Sam Comer','Frank R. McKelvy'],
masks:['Harry Ray','Wally Westmore','Ben Lane'],
costumes:['Edith Head']},
{title:'Mulan',
titleCZ:'Legenda o Mulan',
year:1998,
runtime:88,
countries:['USA'],
genres:['Animation','Family','Adventure','Drama'],
director:['Barry Cook','Tony Bancroft'],
actors:['Ming-Na Wen','BD Wong','Soon-Tek Oh','Eddie Murphy','Harvey Fierstein','Miguel Ferrer','James Hong','Pat Morita','June Foray','Miriam Margolyes','George Takei','Frank Welker','Gedde Watanabe','Cosma Shiva Hagen','Hannes Jaenicke','Horst Buchholz','Conan Lee','Jack Gilpin','John Walcutt','Chris Sanders','James Shigeta','Lea Salonga','Donny Osmond','Dana Lee','Freda Foh Shen','Beth Fowler','Matthew Labyorteaux','Robert Clotworthy','Mary Kay Bergman','Donald Fullilove','Haunani Minn','Patrick Pinney','Claudette Wells','Richard Steven Horvitz','Linda Kerns','David Cowgill','Peter Renaday'],
screenplay:['Rita Hsiao','Chris Sanders','Philip LaZebnik'],
music:['Jerry Goldsmith'],
cut:['Michael Kelly'],
sound:['Dean A. Zupancic','Argiris Kandilis']},
{title:'The Seventh Seal',
titleCZ:'Sedmá pečeť',
year:1957,
runtime:96,
countries:['Sweden'],
genres:['Drama','Fantasy'],
director:['Ingmar Bergman'],
actors:['Gunnar Björnstrand','Bengt Ekerot','Nils Poppe','Max von Sydow','Bibi Andersson','Inga Gill','Maud Hansson','Inga Landgré','Gunnel Lindblom','Bertil Anderberg','Anders Ek','Åke Fridell','Gunnar Olsson','Erik Strandmark','Sten Ardenstam','Harry Asklund','Benkt-Åke Benktsson','Catherine Berg','Tor Borong','Gudrun Brost','Bengt Gillberg','Gunlög Hagberg','Tor Isedal','Ulf Johanson','Uno Larsson','Lennart Lilja','Lars Lind','Monica Lindman','Gordon Löwenadler','Mona Malm','Josef Norman','Gösta Prüzelius','Georg Skarstedt','Marc Smith','Ragnar Sörman','Lennart Tollén','Nils Whiten'],
screenplay:['Ingmar Bergman','Ingmar Bergman'],
production:['Allan Ekelund'],
music:['Erik Nordgren'],
camera:['Gunnar Fischer'],
cut:['Lennart Wallén'],
sound:['Aaby Wedin'],
scenography:['P.A. Lundgren'],
masks:['Nils Nittel']},
{title:'Night on Earth',
titleCZ:'Noc na Zemi',
year:1991,
runtime:129,
countries:['USA','France','UK','Germany','Japan'],
genres:['Comedy','Drama','Tale'],
director:['Jim Jarmusch'],
actors:['Gena Rowlands','Winona Ryder','Armin Mueller-Stahl','Giancarlo Esposito','Rosie Perez','Richard Boes','Isaach De Bankolé','Béatrice Dalle','Stéphane Boucher','Roberto Benigni','Paolo Bonacelli','Matti Pellonpää','Kari Väänänen','Sakari Kuosmanen',"Pascal N'Zonzi","Emile Abossolo M'bo",'Lisanne Falk','Grigorij Melikbekjan','Tomi Salmela','Noël Kaufmann'],
screenplay:['Jim Jarmusch'],
production:['Jim Jarmusch'],
music:['Tom Waits'],
camera:['Frederick Elmes'],
cut:['Jay Rabinowitz'],
sound:['Dominick Tavella'],
scenography:['Johan le Tenoux','Fabrizio De Luca']},
{title:'Harold and Maude',
titleCZ:'Harold a Maude',
year:1971,
runtime:91,
countries:['USA'],
genres:['Comedy','Romance','Drama'],
director:['Hal Ashby'],
actors:['Ruth Gordon','Bud Cort','Vivian Pickles','Cyril Cusack','Charles Tyner','Ellen Geer','Eric Christmas','G. Wood','Tom Skerritt','Hal Ashby','William Lucking','Ray K. Goman','Marjorie Eaton'],
screenplay:['Colin Higgins'],
production:['Colin Higgins','Charles Mulvehill'],
camera:['John A. Alonzo'],
cut:['William A. Sawyer','Edward Warschilka'],
scenography:['Michael D. Haller'],
costumes:['William Ware Theiss']},
{title:'Bloody Sunday',
titleCZ:'Krvavá neděle',
year:2002,
runtime:107,
countries:['UK','Ireland'],
genres:['Drama','War'],
director:['Paul Greengrass'],
actors:['James Nesbitt','Allan Gildea','Gerard Crossan','Tim Pigott-Smith','Nicholas Farrell','Christopher Villiers','Gerard McSorley','Darren Healy','Eva Birthistle','David Clayton Rogers','David Pearse','Mary Moulds','Kathy Kiera Clarke'],
screenplay:['Paul Greengrass'],
production:['Paul Trijbits'],
music:['Dominic Muldowney'],
camera:['Ivan Strasburg'],
cut:['Clare Douglas'],
scenography:['John Paul Kelly'],
masks:['Morna Ferguson'],
costumes:['Dinah Collin']},
{title:'South Park: Imaginationland',
titleCZ:'Městečko South Park: Říše fantazie',
year:2008,
runtime:67,
countries:['USA'],
genres:['Animation','Comedy'],
director:['Trey Parker','Matt Stone'],
actors:['Trey Parker','Matt Stone','Kyle McCulloch','Adrien Beard','April Stewart'],
screenplay:['Trey Parker','Matt Stone'],
production:['Adrien Beard','Vernon Chatman','Erica Rivinoja'],
music:['Scott Nickoley','Jamie Dunlap']},
{title:'The Longest Day',
titleCZ:'Nejdelší den',
year:1962,
runtime:171,
countries:['USA'],
genres:['War','Action','Drama','History'],
director:['Ken Annakin','Andrew Marton','Bernhard Wicki','Gerd Oswald','Darryl F. Zanuck'],
actors:['Eddie Albert','Paul Anka','Arletty','Jean-Louis Barrault','Richard Beymer','Hans Christian Blech','Bourvil','Richard Burton','Wolfgang Büttner','Red Buttons','Pauline Carton','Sean Connery','Ray Danton','Irina Demick','Fabian','Mel Ferrer','Henry Fonda','Steve Forrest','Gert Fröbe','Leo Genn','John Gregson','Paul Hartmann','Peter Helm','Werner Hinz','Donald Houston','Jeffrey Hunter','Karl John','Curd Jürgens','Alexander Knox','Peter Lawford','Fernand Ledoux','Christian Marquand','Dewey Martin','Roddy McDowall','Michael Medwin','Sal Mineo','Robert Mitchum','Kenneth More','Richard Münch',"Edmond O'Brien",'Leslie Phillips','Wolfgang Preiss','Ron Randell','Madeleine Renaud','Georges Rivière','Norman Rossington','Robert Ryan','Tommy Sands','George Segal','Jean Servais','Rod Steiger','Richard Todd','Tom Tryon','Peter van Eyck','Robert Wagner','Richard Wattis','Stuart Whitman','Georges Wilson','John Wayne','Daniel Gélin','Françoise Rosay','Patrick Barr','Yves Barsacq','Geoffrey Bayldon','Michael Beint','Lyndon Brook','Lucien Camiret','Jean Champion','Yvan Chiffre','Bryan Coleman','Gary Collins','John Crawford','Armin Dahlen','Mark Damon','Richard Dawson','Eugene Deckers','Gil Delamare','Michel Duchaussoy','Frank Finlay','Harry Fowler','Bernard Fox','Robert Freitag','Bernard Fresson','Harold Goodwin','Walter Gotell','Clément Harari','Ruth Hausmeister','Jack Hedley','Michael Hinz','Walter Horsbrugh','Patrick Jordan','Til Kiwe','Mickey Knox','Simon Lack','Harry Landis','Rudy Lenoir','Wolfgang Lukschy','Victor Maddern','Howard Marion-Crawford','Neil MacCallum'],
basedOn:['Cornelius Ryan'],
screenplay:['Cornelius Ryan','Romain Gary','James Jones','David Pursall','Jack Seddon'],
production:['Darryl F. Zanuck'],
music:['Maurice Jarre'],
camera:['Jean Bourgoin','Walter Wottitz'],
cut:['Samuel E. Beetley'],
sound:['Jacques Maumont','William Robert Sivel','Joseph de Bretagne']},
{title:'The 400 Blows',
titleCZ:'Nikdo mne nemá rád',
year:1959,
runtime:99,
countries:['France'],
genres:['Crime','Drama'],
director:['François Truffaut'],
actors:['Jean-Pierre Léaud','Claire Maurier','Guy Decomble','Albert Rémy','François Truffaut','Jean-Claude Brialy','Georges Flamant','Jeanne Moreau','Jacques Demy','Jean Douchet','Henri Virlogeux','Jacques Monod','Pierre Repp','Claude Mansard','Christian Brocard','Laure Paillette','Marius Laurey','Louise Chevalier','Luc Andrieux','Yvonne Claudie','Serge Moati','François Nocher','Philippe de Broca'],
screenplay:['François Truffaut','Marcel Moussy'],
production:['François Truffaut'],
music:['Jean Constantin'],
camera:['Henri Decaë'],
cut:['Marie-Josèphe Yoyotte'],
sound:['Jean-Claude Marchetti']},
{title:'The Treasure of the Sierra Madre',
titleCZ:'Poklad na Sierra Madre',
year:1948,
runtime:126,
countries:['USA'],
genres:['Adventure','Drama','Western'],
director:['John Huston'],
actors:['Humphrey Bogart','Walter Huston','Tim Holt','Bruce Bennett','Barton MacLane','Alfonso Bedoya','Arturo Soto Rangel','Manuel Dondé','José Torvay','Margarito Luna','Robert Blake','Guillermo Calles','Roberto Cañedo','Jacqueline Dalya','Ralph Dunn','Pat Flaherty','Martin Garralaga','Jack Holt','John Huston','Julian Rivero','Jay Silverheels','Ildefonso Vega','Ignacio Villalbazo','Clifton Young','Spencer Chan'],
basedOn:['B. Traven'],
screenplay:['John Huston'],
production:['Henry Blanke'],
music:['Max Steiner'],
camera:['Ted D. McCord'],
cut:['Owen Marks'],
sound:['Rafael Ruiz Esparza','Robert B. Lee'],
scenography:['John Hughes'],
masks:['Perc Westmore','Monty Westmore']},
{title:'Fiddler on the Roof',
titleCZ:'Šumař na střeše',
year:1971,
runtime:181,
countries:['USA'],
genres:['Musical','Drama','Family'],
director:['Norman Jewison'],
actors:['Chaim Topol','Norma Crane','Leonard Frey','Molly Picon','Paul Mann','Paul Michael Glaser','Michele Marsh','Neva Small','Ray Lovelock','Aharon Ipalé','Roger Lloyd Pack','Vladimir Medar','Howard Goorney','Rosalind Harris','Vernon Dobtcheff','George Little','Marika Rivera','Barry Dennen','Louis Zorich','Tutte Lemkow','Patience Collier','Arnold Diamond','Carl Jaffe','Brian Coburn','Harry Fielder','Zvee Scooler','Shimen Ruskin','Miki Iveria','Jacob Kalich','Alfie Scopp','Ruth Madoc','Harry Ditson','Danny Mann','Jill Goldston'],
basedOn:['Šolom Alejchem'],
screenplay:['Joseph Stein','Joseph Stein'],
production:['Norman Jewison'],
music:['John Williams','Jerry Bock'],
camera:['Oswald Morris'],
cut:['Antony Gibbs','Robert Lawrence'],
scenography:['Robert F. Boyle'],
masks:['Wally Schneiderman'],
costumes:['Elizabeth Haffenden']},
{title:'The Fifth Element',
titleCZ:'Pátý element',
year:1997,
runtime:126,
countries:['France'],
genres:['Sci-Fi','Action','Comedy','Thriller'],
director:['Luc Besson'],
actors:['Bruce Willis','Gary Oldman','Ian Holm','Milla Jovovich','Chris Tucker','Luke Perry','Brion James','Marie Guillard',"Tommy 'Tiny' Lister",'Lee Evans','Charlie Creed-Miles','Tricky','John Neville','John Bluthal','Mathieu Kassovitz','John Sharian','Maïwenn','Mac McDonald','Martin McDougall','Lenny McLean','Frank Senger','Kim Chan','Michael Culkin','Hon Ping Tang','Kevin Brewerton','Julie T. Wallace','Al Matthews','Mia Frye','Jean-Luc Caron','Christopher Fairbank','Christopher Adamson','Sean Buckley','François Guillaume','Alan Ruscoe','Anthony Chinn','Vincenzo Pellegrino','Tim McMullan','Cecil Cheng','Richard Ashton','Renee Montemayor','Sam Douglas','Stacey McKenzie','Gillian Berrow','Sonita Henry','Indra Ové'],
screenplay:['Luc Besson','Robert Mark Kamen'],
production:['Marc du Pontavice','Patrice Ledoux'],
music:['Eric Serra'],
camera:['Thierry Arbogast'],
cut:['Sylvie Landra'],
sound:['Ron Bartlett'],
scenography:['Dan Weil','Anna Pinnock'],
masks:['Amanda Knight','Michelle Taylor','Sarah Love','Mark Coulier','Lois Burwell'],
costumes:['Jean-Paul Gaultier']},
{title:'Captain Phillips',
titleCZ:'Kapitán Phillips',
year:2013,
runtime:134,
countries:['USA'],
genres:['Biographic','Thriller','Drama'],
director:['Paul Greengrass'],
actors:['Tom Hanks','Catherine Keener','Barkhad Abdi','Barkhad Abdirahman','Faysal Ahmed','Mahat M. Ali','Michael Chernus','David Warshofsky','Corey Johnson','Chris Mulkey','Yul Vazquez','Max Martini','Omar Berdouni','Mohamed Ali','Issak Farah Samatar','San Shella','Terence Anderson','David Webber','Amr El-Bayoumi','Vincenzo Nicoli','Louis Mahoney','Peter Landi','Angus MacInnes','Mark H. Semos','John Patrick Barry','John Magaro','Kevin Resnick','Riann Steele','Thomas Grube'],
basedOn:['Stephan Talty'],
screenplay:['Billy Ray'],
production:['Scott Rudin','Dana Brunetti','Michael De Luca'],
music:['Henry Jackman'],
camera:['Barry Ackroyd'],
cut:['Christopher Rouse'],
sound:['Chris Munro','Oliver Tarney','Michael Prestwood Smith','Chris Burdon','Mark Taylor'],
scenography:['Paul Kirby','Dominic Capon'],
masks:['Frances Hannon'],
costumes:['Mark Bridges']},
{title:'Wind River',
titleCZ:'Wind River',
year:2017,
runtime:111,
countries:['UK','USA','France'],
genres:['Drama','Crime','Mystery','Thriller'],
director:['Taylor Sheridan'],
actors:['Jeremy Renner','Elizabeth Olsen','Graham Greene','Jon Bernthal','Julia Jones','Gil Birmingham','Kelsey Asbille','Apesanahkwat','Martin Sensmeier','Hugh Dillon','Tantoo Cardinal','Eric Lange','Mason D. Davis','Blake Robbins','Matthew Del Negro','Tara Karsian','James Jordan','Devin Hansen','Teo Briones','Austin R. Grant','Althea Sam','Gabe Casdorph'],
screenplay:['Taylor Sheridan'],
production:['Peter Berg','Matthew George','Wayne L. Rogers','Basil Iwanyk','Elizabeth A. Bell'],
music:['Nick Cave','Warren Ellis','Jake Jackson'],
camera:['Ben Richardson'],
cut:['Gary D. Roach'],
sound:['Alan Robert Murray','Dean A. Zupancic','Tom Ozanich'],
scenography:['Neil Spisak'],
masks:['Tim Muir','Megan Danner'],
costumes:['Kari Perkins']},
{title:'Out of Africa',
titleCZ:'Vzpomínky na Afriku',
year:1985,
runtime:161,
countries:['USA'],
genres:['Drama','Romance','Biographic','Adventure'],
director:['Sydney Pollack'],
actors:['Meryl Streep','Robert Redford','Klaus Maria Brandauer','Michael Kitchen','Malick Bowens','Michael Gough','Suzanna Hamilton','Rachel Kempson','Graham Crowden','Leslie Phillips','Shane Rimmer','Donal McCann','Tristam Jelinek','Stephen B. Grimes','Iman',"Maryam d'Abo",'Benny Young'],
basedOn:['Karen Blixen','Judith Thurman','Errol Trzebinski'],
screenplay:['Kurt Luedtke'],
production:['Sydney Pollack'],
music:['John Barry'],
camera:['David Watkin'],
cut:['Fredric Steinkamp','William Steinkamp','Pembroke J. Herring','Sheldon Kahn'],
sound:['Peter Handford','Larry Stensvold','Gary Alexander'],
scenography:['Stephen B. Grimes'],
costumes:['Milena Canonero']},
{title:'3-Iron',
titleCZ:'3-iron',
year:2004,
runtime:88,
countries:['South Korea','Japan'],
genres:['Drama','Crime','Poetic','Romance'],
director:['Ki-duk Kim'],
actors:['Seung-yeon Lee','Hee Jae','Jong-soo Lee','Jin-mo Joo','Park Ji-a'],
screenplay:['Ki-duk Kim']},
{title:'Burnt by the Sun',
titleCZ:'Unaveni sluncem',
year:1994,
runtime:152,
countries:['Russia','France'],
genres:['Drama','History'],
director:['Nikita Michalkov'],
actors:['Oleg Meňšikov','Nikita Michalkov','Ingeborga Dapkunajtě','André Oumansky','Vjačeslav Tichonov','Vladimir Iljin','Jevgenij Mironov','Marat Bašarov','Naděžda Michalkova','Světlana Krjučkova','Georgij Dronov','Alla Kazanskaja','Ljubov Rudněva','Nina Archipova','Vladimir Bělousov','Oleg Feoktistov','Inna Uljanova','Avangard Leonťjev'],
screenplay:['Nikita Michalkov','Rustam Ibragimbekov'],
music:['Eduard Nikolajevič Artěmjev','Dmitrij Atovmjan'],
camera:['Vilen Kaljuta'],
sound:['Vincent Arnardi']},
{title:'Battle Ground 625',
titleCZ:'Welkeom tu Dongmakgol',
year:2005,
runtime:133,
countries:['South Korea'],
genres:['Drama','Comedy','War'],
director:['Kwang-hyeon Park'],
actors:['Ha-kyun Shin','Jae-yeong Jeong','Hye-jeong Kang','Steve Taschler','Ha-ryong Im','Jae-kyeong Seo','Deok-hwan Ryoo','Jae-jin Jeong','Deok-hyeon Jo','Yeong-gi Jeong','Seung-mok Yoo','Hyeon-joong Kang','Mi-nam Jeong','David Anselmo','Leif Gantvoort','Oh-min Kwon','Ran-hee Lee'],
screenplay:['Kwang-hyeon Park','Jin Jang'],
production:['Sang-ho Choi'],
music:['Džó Hisaiši'],
camera:['Sang-ho Choi'],
cut:['Steve M. Choe']},
{title:'To Sir, with Love',
titleCZ:'Panu učiteli s láskou',
year:1967,
runtime:105,
countries:['UK'],
genres:['Drama'],
director:['James Clavell'],
actors:['Sidney Poitier','Faith Brook','Geoffrey Bayldon','Judy Geeson','Ann Bell','Michael Des Barres','Patricia Routledge','Stephen Whittaker','Suzy Kendall','Fred Griffiths','Marianne Stone','Lulu','Adrienne Posta','Chris Chittell','Edward Burnham','Rita Webb','Fiona Duncan','Dervis Ward','Cyril Shaps','Howard Knight','Chitra Neogy','Mona Bruce','Eric Stewart'],
screenplay:['James Clavell'],
production:['James Clavell'],
music:['Ron Grainer'],
camera:['Paul Beeson']},
{title:'Inherit the Wind',
titleCZ:'Kdo seje vítr',
year:1999,
runtime:127,
countries:['USA'],
genres:['Drama'],
director:['Daniel Petrie'],
actors:['Jack Lemmon','George C. Scott','Piper Laurie','Beau Bridges','Tom Everett Scott','Kathryn Morris','Lane Smith','Brad Greenquist','Jim Meskimen','Russ Tamblyn','John Cullum','Doug McGrath','Twyla Banks','David Wells','Peter Mackenzie','Amzie Strickland','Jerry Potter','John DeMita','Dirk Blocker','Royce D. Applegate','Derek McGrath','Ronnie Claire Edwards','Steve Monroe','Matthew Kimbrough','Steve Hofvendahl',"Paul Vincent O'Connor",'Dennis Cockrum'],
screenplay:['Harold Jacob Smith','Nedrick Young'],
music:['Laurence Rosenthal'],
camera:['James Bartle'],
cut:['Paul LaMastra'],
sound:['Keith Rogers',"Terry O'Bright",'Joe Melody'],
scenography:['John DeCuir Jr.'],
masks:['Del Acevedo','Janis Clark'],
costumes:['Shelley Komarov']},
{title:'On Golden Pond',
titleCZ:'Na Zlatém jezeře',
year:1981,
runtime:109,
countries:['USA'],
genres:['Drama','Poetic'],
director:['Mark Rydell'],
actors:['Katharine Hepburn','Henry Fonda','Jane Fonda','Doug McKeon','Dabney Coleman','Troy Garity','Christian Pereira','Christopher Rydell','William Lanteau'],
screenplay:['Ernest Thompson','Ernest Thompson'],
production:['Bruce Gilbert'],
music:['Dave Grusin'],
camera:['Billy Williams'],
cut:['Robert L. Wolfe'],
scenography:['Stephen B. Grimes','Jane Bogart'],
masks:['Thomas Tuttle'],
costumes:['Dorothy Jeakins']},
{title:'Sanjuro',
titleCZ:'Sanjuro',
year:1962,
runtime:96,
countries:['Japan'],
genres:['Action','Adventure','Drama'],
director:['Akira Kurosawa'],
actors:['Toširó Mifune','Tacuja Nakadai','Keidžu Kobajaši','Júzó Kajama','Takaši Šimura','Reiko Dan','Kamatari Fudžiwara','Akira Kubo','Hiroši Tačikawa','Jutaka Sada','Kunie Tanaka','Šóiči Hirose','Takako Irie','Júnosuke Itó'],
screenplay:['Hideo Oguni','Akira Kurosawa','Ryûzô Kikushima'],
production:['Tomojuki Tanaka'],
music:['Masaru Sató'],
camera:['Takao Saitó','Fukuzó Koizumi']},
{title:'Gaslight',
titleCZ:'Plynové lampy',
year:1944,
runtime:114,
countries:['USA'],
genres:['Mystery','Thriller','Film-Noir'],
director:['George Cukor'],
actors:['Charles Boyer','Ingrid Bergman','Joseph Cotten','Dame May Whitty','Angela Lansbury','Emil Rameau','Edmund Breon','Halliwell Hobbes','Tom Stevenson','Alec Craig','Gibson Gowland','Lawrence Grossmith','Terry Moore','Maude Fealy','Jakob Gimpel','Syd Saylor','Jack Kirk','Gary Gray','Al Ferguson','Eric Wilton','Morgan Wallace','Wilson Benge','Arthur Blake','Frank Baker','Lillian Bronson','Milton Rosmer','Barbara Everest','Heather Thatcher','Clive Morgan','Charles McNaughton','Bobbie Hale','Leonard Carey','Georgie Nokes'],
screenplay:['Patrick Hamilton','Walter Reisch','John L. Balderston'],
production:['Arthur Hornblow Jr.'],
music:['Bronislau Kaper'],
camera:['Joseph Ruttenberg'],
cut:['Ralph E. Winters'],
sound:['Douglas Shearer','Joe Edmondson'],
scenography:['Cedric Gibbons','Edwin B. Willis'],
masks:['Jack Dawn','Irma Kusely'],
costumes:['Irene']},
{title:'Somebody Up There Likes Me',
titleCZ:'Někdo tam nahoře mě má rád',
year:1956,
runtime:114,
countries:['USA'],
genres:['Drama','Sport','Biographic'],
director:['Robert Wise'],
actors:['Paul Newman','Pier Angeli','Everett Sloane','Eileen Heckart','Sal Mineo','Harold J. Stone','Joseph Buloff','Sammy White','Robert P. Lieb','Theodore Newton','Robert Loggia','Angela Cartwright','Steve McQueen','Dean Jones','Robert Duvall','Len Lesser','Jinx Falkenburg','John Eldredge','Ray Danton','Ray Walker','William Boyett','Arch Johnson','Stanley Adams','Eddie Ryder','Bert Stevens','Kenner G. Kemp','Frank Mills','Sam Gilman','John Breen','Robin Morse','Robert Easton','Leon Alton','Kit Guard','Russ Conway','Fred Aldrich','Michael Dante','Joe McGuinn','Don Haggerty','Benny Rubin','Jack Perry','George Cisar','Clancy Cooper','Jimmy Dime','Judson Pratt','Ray Stricklyn','Dick Rich','Scott Seaton','Frank McLure','Bart Braverman','Renata Vanni','Russ Clark',"Monty O'Grady",'Sol Murgi','Gene Coogan','Jack Kenney','Jess Kirkpatrick','Willard Sage','James Gonzalez','David Leonard','Jack Shea','Frank Campanella','Ralph Reed','Tom Coleman','Herschel Graham','Richard LaMarr','Tyler McVey','Jack Lomas','Michael Ross','Buster Slaven','Sid Raymond','Jack Orrison','Christopher Riordan','Jimmy Murphy','Bern Hoffman','Byron Kane','Billy Nelson','Don Shelton','James Todd','Margot Gabilondo','Leoda Richards'],
screenplay:['Ernest Lehman'],
production:['Charles Schnee'],
music:['Bronislau Kaper'],
camera:['Joseph Ruttenberg'],
cut:['Albert Akst'],
sound:['Wesley C. Miller'],
scenography:['Cedric Gibbons','Malcolm Brown','Edwin B. Willis','F. Keogh Gleason'],
masks:['John Truwe','William Tuttle']},
{title:'Guilty',
titleCZ:'Présumé coupable',
year:2011,
runtime:97,
countries:['France','Belgium'],
genres:['Drama'],
director:['Vincent Garenq'],
actors:['Philippe Torreton','Wladimir Yordanoff','Noémie Lvovsky','Raphaël Ferret','Michelle Goddet','Farida Ouchani','Sarah Lecarpentier','Christophe Rossignon','Alexandre Carrière','Franck Andrieux','Alain Cerrer','Carine Bouquillon','Tahidir Ouazine','Jean-Pierre Bagot','François Godart','Vincent Nemeth','Juliette Navis','Stéphanie Fatout','Olivier Claverie','Michel Masiero','Jean-Pol Brissart','Christian Van Tomme','Marie-Céline Tuvache','Serge Flamenbaum','Frédéric Trin','Eric Paul','Serpentine Teyssier'],
screenplay:['Vincent Garenq'],
production:['Christophe Rossignon'],
camera:['Renaud Chassaing'],
cut:['Dorian Rigal-Ansous'],
sound:['Philippe Vandendriessche','Pascal Jasmes'],
costumes:['Fanny Drouin']},
{title:'Faust',
titleCZ:'Faust',
year:1994,
runtime:97,
countries:['Czechia','France','UK'],
genres:['Drama','Mystery','Animation'],
director:['Jan Švankmajer'],
actors:['Petr Čepek','Jan Kraus','Vladimír Kudla','Antonín Zacpal','Pavel Marek','Viktorie Knotková','Jaroslava Zelenková','František Polata','Petr Meissel','Josef Fiala','Václav Švankmajer','Jan Peter Heyne','Jiří \'Zip\' Suchý','Lenka Havránková'],
screenplay:['Jan Švankmajer','Johann Wolfgang Goethe','Christopher Marlowe'],
production:['Jaromír Kallista'],
camera:['Svatopluk Malý'],
cut:['Marie Zemanová'],
sound:['Ivo Špalj'],
masks:['Jiřina Bissingerová'],
costumes:['Růžena Bláhová']},
{title:'The Last Laugh',
titleCZ:'Poslední štace',
year:1924,
runtime:77,
countries:['Germany'],
genres:['Drama','Psychology'],
director:['Friedrich Wilhelm Murnau'],
actors:['Emil Jannings','Harald Madsen','Carl Schenstrøm','O.E. Hasse','Hans Unterkircher','Maly Delschaft','Emmy Wyda','Neumann-Schüler'],
screenplay:['Carl Mayer'],
production:['Erich Pommer'],
music:['Werner Schmidt-Boelcke','Karl-Ernst Sasse','Giuseppe Becce'],
camera:['Karl Freund'],
scenography:['Edgar G. Ulmer']},
{title:'War and Peace',
titleCZ:'Vojna a mír',
year:1956,
runtime:205,
countries:['USA','Italy'],
genres:['Drama','Romance','War'],
director:['King Vidor'],
actors:['Audrey Hepburn','Henry Fonda','Mel Ferrer','Vittorio Gassman','Herbert Lom','Anna Maria Ferrero','Oskar Homolka','Anita Ekberg','Tullio Carminati','Barry Jones','Wilfrid Lawson','May Britt','Jeremy Brett','John Mills','Marisa Allasio','Alfredo Rizzo','Giacomo Rossi-Stuart','Clelia Matania','Milly Vitale','Gualtiero Tumiati','Mimmo Palmara','Guido Celano','Mino Doro','Robert Stephens','Charles Fawcett','Helmut Dantine','Robert Rietty','Gilberto Tofano','Vincent Barbi','Piero Palermini','Maria Zanoli','Giuseppe Addobbati','Henri Vidon','John Stacy','Andrea Fantasia','Gertrude Flynn','Joop van Hulzen','Sean Barrett','Enrico Olivieri'],
basedOn:['Lev Nikolajevič Tolstoj'],
screenplay:['King Vidor','Mario Camerini','Ennio De Concini','Ivo Perilli'],
production:['Carlo Ponti','Dino De Laurentiis'],
music:['Nino Rota'],
camera:['Jack Cardiff'],
cut:['Leo Cattozzo'],
sound:['Harold Lewis'],
masks:['Grazia De Rossi'],
costumes:['Maria De Matteis']},
{title:'The Curious Case of Benjamin Button',
titleCZ:'Podivuhodný případ Benjamina Buttona',
year:2008,
runtime:166,
countries:['USA'],
genres:['Drama','Fantasy','Romance'],
director:['David Fincher'],
actors:['Brad Pitt','Cate Blanchett','Taraji P. Henson','Julia Ormond','Jason Flemyng','Mahershala Ali','Jared Harris','Elias Koteas','Phyllis Somerville','Tilda Swinton','Faune Chambers Watkins','Danny Vinson','David Jensen','Johanna Roxanne','Peter Donald Badalamenti II','Lance E. Nichols','Elle Fanning','Ted Manson','Madisen Beaty','Tom Everett','Joshua DesRoches','Richmond Arquette','Josh Stewart','Ilia Volok','Myrton Running Wolf','Stephen Monroe Taylor','Wilbur Fitzgerald','Louis Herthum','Rus Blackwell','Deneen Tyler','Spencer Daniels','Chandler Canterbury','Katherine Crockett','Leslie Augustine','Aliane Baquerot','Eve Brent','Megan Brown','Emma Degerstedt','Walter Delmar','Tiffany Forest','Grant James','Shiloh Jolie-Pitt','Elton LeBlanc','Antonia Putiloff','Simone-Élise Girard','Robert W. Savina','Danny Nelson','Edith Ivey','Robert Towers','Christopher Karl Johnson','Devyn A. Tyler','Autumn Withers','Charles Henry Wyson','Malerie Grady','Sonya Leslie','Marian Filali','David Ross Paterson',"Patrick Thomas O'Brien",'Donna Duplantier','Joel Bissonnette','Don Creech','Harlon Miller','Fiona Hale'],
basedOn:['F. Scott Fitzgerald'],
screenplay:['Eric Roth'],
production:['Frank Marshall','Kathleen Kennedy','Ceán Chaffin'],
music:['Alexandre Desplat'],
camera:['Claudio Miranda'],
cut:['Kirk Baxter','Angus Wall'],
sound:['David Parker','Ren Klyce','Michael Semanick','Mark Weingarten'],
scenography:['Donald Graham Burt','Michele Laliberte','Victor J. Zolfo'],
masks:['Jean Ann Black','Brian Sipe','Kazu Hiro','Greg Cannom','Alexei Dmitiew'],
costumes:['Jacqueline West']},
{title:'Stardust',
titleCZ:'Hvězdný prach',
year:2007,
runtime:128,
countries:['UK','USA','Iceland'],
genres:['Fantasy','Romance','Adventure','Family'],
director:['Matthew Vaughn'],
actors:['Charlie Cox','Claire Danes','Robert De Niro','Michelle Pfeiffer','Ricky Gervais','Kate Magowan','Nathaniel Parker','Sienna Miller','Ben Barnes',"Peter O'Toole",'Ian McKellen','Rupert Everett','Sarah Alexander','Jake Curran','Mark Strong','Jason Flemyng','Henry Cavill','Mark Williams','David Kelly','Carlos Besse Peres','Adam Buxton','Julian Rhind-Tutt','Rab Affleck','Mark Heap','Geoff Bell','Dexter Fletcher','Melanie Hill','Joanna Scanlan','Mark Burns','Struan Rodger','Spencer Wilding','Lasco Atkins','Olivia Grant','George Innes','Adam Fogerty','Eliot Sumner','Grant Burgin','Jordan Long','David Walliams'],
basedOn:['Neil Gaiman'],
screenplay:['Jane Goldman','Matthew Vaughn'],
production:['Lorenzo di Bonaventura','Neil Gaiman','Matthew Vaughn'],
music:['Ilan Eshkeri'],
camera:['Ben Davis'],
cut:['Jon Harris'],
sound:['Sven Taits','Simon Hayes','Mark Paterson','Matthew Collinge'],
scenography:['Gavin Bocquet','Peter Young'],
masks:['Fae Hammond','Duncan Jarman','Barrie Gower'],
costumes:['Sammy Sheldon Differ']},
{title:'The Incredibles',
titleCZ:'Úžasňákovi',
year:2004,
runtime:115,
countries:['USA'],
genres:['Animation','Action','Adventure','Family'],
director:['Brad Bird'],
actors:['Craig T. Nelson','Holly Hunter','Samuel L. Jackson','Jason Lee','Elizabeth Peña','Teddy Newton','Wallace Shawn','Sarah Vowell','Lou Romano','Bud Luckey','Brad Bird','Pete Docter','Bob Peterson','Joe Ranft','Peter Sohn','Andrew Stanton','Frank Thomas','John Ratzenberger','Stephen Schaffer','John Walker','Ted Mathot',"Bret 'Brook' Parker",'Ivica Vidović','Louis Gonzales'],
screenplay:['Brad Bird'],
production:['John Walker'],
music:['Michael Giacchino'],
cut:['Stephen Schaffer'],
sound:['Randy Thom','Gary Rizzo','Christopher Scarabosio'],
scenography:['Lou Romano']},
{title:'Blood Diamond',
titleCZ:'Krvavý diamant',
year:2006,
runtime:143,
countries:['USA','Germany'],
genres:['Adventure','Drama','Thriller'],
director:['Edward Zwick'],
actors:['Leonardo DiCaprio','Djimon Hounsou','Jennifer Connelly','Arnold Vosloo','Basil Wallace','David Harewood','Jimi Mistry','Michael Sheen','Marius Weyers','Stephen Collins','Ntare Guma Mbaho Mwine','Nick Reding',"Adetokumboh M'Cormack",'David S. Lee','Tony Kgoroge','Ato Essandoh','Nigel Harman','Jonathan Pienaar','Akin Omotoso','Tyrone Keogh','Grant Swanby','Vanessa Haywood','Winston Ntshona','Keithian Santos-Sammons'],
screenplay:['Charles Leavitt'],
production:['Graham King','Paula Weinstein','Edward Zwick'],
music:['James Newton Howard'],
camera:['Eduardo Serra'],
cut:['Steven Rosenblum'],
sound:['Andy Nelson','Anna Behlmer','Ivan Sharrock'],
scenography:['Dan Weil','Ray Chan'],
masks:['Judy Chin','Sharon Martin','Anne Morgan','Zoe Tahir'],
costumes:['Ngila Dickson']},
{title:'The Name of the Rose',
titleCZ:'Jméno růže',
year:1986,
runtime:126,
countries:['Italy','France','Germany'],
genres:['Drama','Crime','Mystery','Thriller'],
director:['Jean-Jacques Annaud'],
actors:['Sean Connery','F. Murray Abraham','Elya Baskin','Fjodor Šaljapin ml.','William Hickey','Michael Lonsdale','Ron Perlman','Volker Prechtel','Helmut Qualtinger','Valentina Vargas','Christian Slater','Michael Habeck','Urs Althaus','Leopoldo Trieste','Vernon Dobtcheff',"Donald O'Brien",'Andrew Birkin','Peter Berling','Dwight Weist','Aristide Caporale','Luigi Leoni','Ludger Pistor','Francesco Scali','Francesco Maselli','Kim Rossi Stuart','Franco Diogene','Gianni Rizzo','Pietro Ceccarelli','Franco Marino','Hans Schödel','Giordano Falzoni','Franco Pistoni','Mark Bellinghaus','Peter Clös','Eckehard Koch'],
basedOn:['Umberto Eco'],
screenplay:['Andrew Birkin','Gérard Brach','Howard Franklin','Alain Godard'],
production:['Bernd Eichinger','Thomas Schühly'],
music:['James Horner'],
camera:['Tonino Delli Colli'],
cut:['Jane Seitz'],
sound:['Milan Bor'],
scenography:['Dante Ferretti','Francesca Lo Schiavo'],
masks:['Hasso von Hugo','Hans Jürgen Schmelzle','Gerhard Reitinger','Friederike Mirus'],
costumes:['Gabriella Pescucci']},
{title:'Unforgiven',
titleCZ:'Nesmiřitelní',
year:1992,
runtime:131,
countries:['USA'],
genres:['Western','Drama'],
director:['Clint Eastwood'],
actors:['Clint Eastwood','Gene Hackman','Morgan Freeman','Richard Harris','Jaimz Woolvett','Saul Rubinek','Frances Fisher','Anna Levine','David Mucci','Rob Campbell','Anthony James','Tara Frederick','Beverley Elliott','Liisa Repo-Martell','Shane Meier','Aline Levasseur','Ron White','Mina E. Mina','Jeremy Ratchford','John Pyper-Ferguson','Jefferson Mappin','Frank Charles Turner','Lochlyn Munro','Ben Cardinal','Philip Maurice Hayes','Larry Joshua','Larry Reese'],
screenplay:['David Webb Peoples'],
production:['Clint Eastwood'],
music:['Lennie Niehaus'],
camera:['Jack N. Green'],
cut:['Joel Cox'],
sound:['Alan Robert Murray','Walter Newman','Rob Young','Rick Alexander'],
scenography:['Henry Bumstead'],
masks:['Michael Hancock']},
{title:'The Dinner Game',
titleCZ:'Blbec k večeři',
year:1998,
runtime:80,
countries:['France'],
genres:['Comedy'],
director:['Francis Veber'],
actors:['Thierry Lhermitte','Jacques Villeret','Francis Huster','Daniel Prévost','Alexandra Vandernoot','Catherine Frot','Edgar Givry','Philippe Brigaud','Daniel Russo','Christian Pereira','Jacques Bleu','Daniel Martin','Pierre-Arnaud Juin','Rémy Roubakha','Laurent Gendron','Michel Caccia','Pétronille Moss'],
screenplay:['Francis Veber'],
music:['Vladimir Cosma'],
camera:['Luciano Tovoli'],
cut:['Georges Klotz'],
sound:['Jean Gargonne','Bernard Bats'],
scenography:['Hugues Tissandier'],
costumes:['Jacqueline Bouchard']},
{title:'Serpico',
titleCZ:'Serpico',
year:1973,
runtime:130,
countries:['USA','Italy'],
genres:['Biographic','Crime','Drama'],
director:['Sidney Lumet'],
actors:['Al Pacino','John Randolph','Biff McGuire','Jack Kehoe','Barbara Eda-Young','Cornelia Sharpe','Tony Roberts','John Medici','Allan Rich','Norman Ornellas','Edward Grover','Albert Henderson','James Tolkan','Alan North','M. Emmet Walsh','F. Murray Abraham','Tony Lo Bianco','Judd Hirsch','Kenneth McMillan','John Stewart','Sydney Lassick','Tracey Walter','Nathan George','Mary Louise Weller','Mildred Clinton','Gus Fleming','Richard Foronjy','Lewis J. Stadlen','John McQuade','Ted Beniades','René Enríquez','Jaime Sánchez','Stephen Pearlman','Jay Rasumny','Tim Pelt','Bernard Barrow','Sam Coppola','Hank Garrett','John Lehne','Tom Signorelli','Richard Kuss','Ben Slack','Ed Crowley','John Brandon','Raleigh Bond','Damien Leake','George Loros','Joseph Bova','Sal Carollo','Frank Gio','Don Billett'],
basedOn:['Peter Maas'],
screenplay:['Waldo Salt','Norman Wexler'],
production:['Martin Bregman','Dino De Laurentiis'],
music:['Mikis Theodorakis'],
camera:['Arthur J. Ornitz'],
cut:['Dede Allen','Richard Marks'],
sound:['Dick Vorisek'],
scenography:['Charles Bailey'],
costumes:['Anna Hill Johnstone']},
{title:'Taegukgi: The Brotherhood of War',
titleCZ:'Pouta války',
year:2004,
runtime:140,
countries:['South Korea'],
genres:['Action','Drama','War'],
director:['Je-gyu Kang'],
actors:['Dong-gun Jang','Bin Won','Eun-joo Lee','Hyeong-jin Kong','Min-ho Jang','Jae-hyeong Jeon','Kil-kang Ahn','Yoon-hee Jo','Yoon-min Jeong','Taek-ha Hwang','Dong-bin Park','Tae-won Kwon','Da-yeong Joo','Yeong-ran Lee','Jin Jeong','Soo-ro Kim','Min-sik Choi','Doo-hong Jeong','Ho-bin Jeong','Hae-gon Kim','Jae-gon Son','Gil-soo Park','Ji-hyeok Min','Kil-yong Yang','Woon Jo','Young-jin Jang','Chan-yeong Lee'],
screenplay:['Ji-hoon Han','Sang-don Kim','Je-gyu Kang'],
music:['Dong-joon Lee'],
camera:['Kyeong-pyo Hong'],
sound:['Kim Suk-won']},
{title:'My New Partner',
titleCZ:'Prohnilí',
year:1984,
runtime:107,
countries:['France'],
genres:['Comedy','Crime'],
director:['Claude Zidi'],
actors:['Philippe Noiret','Thierry Lhermitte','Régine','Grace De Capitani','Claude Brosset','Julien Guiomar','Henri Attal','Pierre Baton','Jean-Claude Bouillaud','François Cadet','Jocelyn Canoen','Kamel Cherif','Jean Cherlian','Louise Chevalier','Jacques Ciron','Gérard Couderc','Michel Crémadès','Cheik Doukouré','Michel Duchezeau','Pierre Frag','Jacques Frantz','Olivier Granier','Nicholas Hawtrey','Hélène Hily','Guy Kerner','Jean Lanier','Simon Michaël','René Morard','Pascal Pistacio','Francis Roussef','Jacques Santi','Ticky Holgado','Marius Yelolo','Abbes Zahmani','Albert Simono'],
screenplay:['Claude Zidi'],
production:['Claude Zidi'],
music:['Francis Lai'],
camera:['Jean-Jacques Tarbès'],
cut:['Nicole Saunier'],
sound:['Jean-Louis Ughetto'],
scenography:['Françoise De Leu'],
costumes:['Olga Pelletier']},
{title:"Who's Afraid of Virginia Woolf?",
titleCZ:'Kdo se bojí Virginie Woolfové?',
year:1966,
runtime:134,
countries:['USA'],
genres:['Drama','Psychology'],
director:['Mike Nichols'],
actors:['Elizabeth Taylor','Richard Burton','George Segal','Sandy Dennis'],
screenplay:['Ernest Lehman','Edward Albee'],
production:['Ernest Lehman'],
music:['Alex North'],
camera:['Haskell Wexler'],
cut:["Sam O'Steen"],
sound:['M.A. Merrick'],
scenography:['Richard Sylbert'],
masks:['Gordon Bau'],
costumes:['Irene Sharaff']},
{title:'The Copper Tower',
titleCZ:'Medená veža',
year:1970,
runtime:87,
countries:['Czechoslovakia'],
genres:['Drama'],
director:['Martin Hollý ml.'],
actors:['Emília Vášáryová','Ivan Rajniak','Ivan Mistrík','Štefan Kvietik','Michal Dočolomanský','Vlado Müller','Slávo Drozd','Alena Skokanová','Július Vašek','Viera Strnisková','Martin Hollý ml.','Ernest Kostelník','Jozef Šimonovič st.','Gizela Veclová','Terézia Hurbanová-Kronerová','Viera Radványiová'],
screenplay:['Ivan Bukovčan'],
music:['Zdeněk Liška'],
camera:['Karol Krška'],
cut:['Maximilián Remeň'],
sound:['Ondrej Polomský','Jaroslav Plavec','Milan Strojný'],
scenography:['Juraj Červík'],
costumes:['Otília Hentzová']},
{title:'Corpus Christi',
titleCZ:'Corpus Christi',
year:2019,
runtime:115,
countries:['Poland'],
genres:['Drama'],
director:['Jan Komasa'],
actors:['Bartosz Bielenia','Aleksandra Konieczna','Eliza Rycembel','Tomasz Ziętek','Barbara Jonak','Leszek Lichota','Zdzisław Wardejn','Łukasz Simlat','Anna Biernacik','Lidia Bogaczówna','Malwina Brych','Bogdan Brzyski','Juliusz Chrząstowski','Radosław Ciucias','Mateusz Czwartosz','Lidia Duda','Andrzej Franczyk','Jan Hrynkiewicz','Lubomir Kempka','Krystian Kostow','Józef Kostycz','Alicja Majdosz','Janusz Mazurkiewicz','Bogusław Michałek','Helena Norowicz','Tobiasz Nowakowski','Katarzyna Ostrowska','Grzegorz Palkowski','Piotr Pawlak','Janusz Poborczyk','Jolanta Rychłowska','Jakub Sierenberg','Jarosław Soroko','Dariusz Starczewski','Sebastian Szałaj','Aleksander Talkowski','Marta Waldera','Juliusz Krzysztof Warunek','Leszek Wiśniewski','Tomasz Włosok','Wojciech Ziętek','Konstanty Szemraj'],
screenplay:['Mateusz Pacewicz'],
production:['Leszek Bodzak','Aneta Cebula-Hickinbotham'],
music:['Jevgenij Galperin','Saša Galperin'],
camera:['Piotr Sobociński Jr.'],
cut:['Przemysław Chruścielewski'],
sound:['Tomasz Wieczorek','Kacper Habisiak','Marcin Kasiński'],
scenography:['Marek Zawierucha','Andrzej Górnisiewicz'],
costumes:['Dorota Roqueplo']},
{title:'The Defiant Ones',
titleCZ:'Útěk v řetězech',
year:1958,
runtime:97,
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Stanley Kramer'],
actors:['Tony Curtis','Sidney Poitier','Theodore Bikel','Charles McGraw','Lon Chaney Jr.','King Donovan','Claude Akins','Lawrence Dobkin','Whit Bissell',"Carl 'Alfalfa' Switzer",'Cara Williams','Ned Glass',"Boyd 'Red' Morgan",'Herman Hack','Jimmy Dime','Harold Jacob Smith','Nedrick Young','Kevin Coughlin','Mickey Golden',"Carroll O'Connor",'Clem Fuller'],
screenplay:['Harold Jacob Smith','Nedrick Young'],
production:['Stanley Kramer'],
music:['Ernest Gold'],
camera:['Sam Leavitt'],
cut:['Frederic Knudtson'],
sound:['Jean L. Speak'],
scenography:['Rudolph Sternad'],
masks:['Don L. Cash']},
{title:'The Stoning of Soraya M.',
titleCZ:'The Stoning of Soraya M.',
year:2008,
runtime:114,
countries:['USA'],
genres:['Drama'],
director:['Cyrus Nowrasteh'],
actors:['Shohreh Aghdashloo','Mozhan Marnò','James Caviezel','Navid Negahban','Parviz Sayyad','Prasanna Puwanarajah','Noor Taher','Vachik Mangassarian'],
basedOn:['Freidoune Sahebjam'],
screenplay:['Betsy Giffen Nowrasteh','Cyrus Nowrasteh'],
production:['Stephen McEveety','John Shepherd'],
music:['John Debney'],
camera:['Joel Ransom'],
cut:['Geoffrey Rowland','David Handman'],
sound:['Ethan Beigel'],
scenography:['Judy Rhee'],
masks:['Jason Hamer'],
costumes:['Jane Anderson']},
{title:'Life Feels Good',
titleCZ:'Život je úžasný',
year:2013,
runtime:107,
countries:['Poland'],
genres:['Drama','Biographic'],
director:['Maciej Pieprzyca'],
actors:['Dawid Ogrodnik','Arkadiusz Jakubik','Katarzyna Zawadzka','Anna Karczmarczyk','Gabriela Muskała','Bożena Stryjkówna','Kamil Tkacz','Janusz Chabior','Anna Nehrebecka','Dorota Kolak','Helena Sujecka','Lech Dyblik','Marek Kalita','Witold Wieliński','Klaudia Kąca','Julia Balsewicz','Piotr Trojan','Mikołaj Roznerski','Piotr Żurawski','Małgorzata Moskalewicz','Dariusz Chojnacki','Mirosław Kotowicz','Igor Wilewski-Sobczyk','Tymoteusz Marciniak','Monika Chomicka-Szymaniak'],
screenplay:['Maciej Pieprzyca'],
production:['Wiesław Łysakowski'],
music:['Bartosz Chajdecki'],
camera:['Paweł Dyllus'],
cut:['Krzysztof Szpetmański'],
costumes:['Agata Culak']},
{title:'Man of Marble',
titleCZ:'Člověk z mramoru',
year:1977,
runtime:153,
countries:['Poland'],
genres:['Drama'],
director:['Andrzej Wajda'],
actors:['Jerzy Radziwiłowicz','Krystyna Janda','Tadeusz Łomnicki','Jacek Łomnicki','Michał Tarkowski','Piotr Cieślak','Wiesław Wójcik','Krystyna Zachwatowicz','Magda Teresa Wójcik','Bogusław Sobczuk','Leonard Zajączkowski','Jacek Domański','Zdzisław Kozień','Irena Laskowska','Wiesław Drzewicz','Kazimierz Kaczor','Ewa Ziętek','Elżbieta Borkowska-Szukszta','Andrzej Grąziewicz','Andrzej Seweryn','Krzysztof Kiersznowski','Dorota Stalińska','Zdzisław Szymborski','Stanisław Frąckowiak','Edmund Karwański','Stefania Kornacka','Henryk Łapiński','Jerzy Moniak','Irena Oberska','Zbigniew Płoszaj','Juliusz Roland','Maciej Rayzacher','Grzegorz Skurski','Mariusz Świgoń','Krystyna Wolańska','Andrzej Wykrętowicz','Feliks Falk','Witold Holtz','Jarosław Kopaczewski','Ilona Łepkowska','Stanisław Michalik'],
screenplay:['Aleksander Ścibor-Rylski'],
music:['Andrzej Korzyński'],
camera:['Edward Kłosiński'],
cut:['Halina Prugar-Ketling'],
sound:['Piotr Zawadzki'],
scenography:['Allan Starski','Maria Osiecka-Kuminek'],
masks:['Anna Adamek'],
costumes:['Wiesława Starska','Lidia Rzeszewska']},
{title:'Pirates of the Caribbean: The Curse of the Black Pearl',
titleCZ:'Piráti z Karibiku: Prokletí Černé perly',
year:2003,
runtime:143,
countries:['USA'],
genres:['Adventure','Action','Fantasy','Comedy'],
director:['Gore Verbinski'],
actors:['Johnny Depp','Geoffrey Rush','Orlando Bloom','Keira Knightley','Jack Davenport','Kevin McNally','Zoe Saldana','Jonathan Pryce','Treva Etienne','David Bailie','Lee Arenberg','Mackenzie Crook','Trevor Goddard','Isaac C. Singleton Jr.','Brye Cooper','Vince Lozano','Robbie Gee','Guy Siner','Paul Gagné','Dylan Smith','Martin Klebba','David Schofield','Vanessa Branch','Joe Grisaffi','Lucinda Dryzek','Greg Ellis','Ralph P. Martin','Lauren Maher',"Damian O'Hare",'Christopher S. Capp','Paul Keith','Michael Berry Jr.','Dustin Seavey','Michael Sean Tighe','Maxie Santillan Jr.'],
screenplay:['Ted Elliott','Terry Rossio'],
production:['Jerry Bruckheimer'],
music:['Klaus Badelt'],
camera:['Dariusz Wolski'],
cut:['Arthur Schmidt','Craig Wood','Stephen E. Rivkin'],
sound:['David Parker','David E. Campbell','Christopher Boyes','Dave Whitehead'],
scenography:['Brian Morris','Larry Dias'],
masks:['Deborah Rutherford','Ve Neill','Martin Samuel','Scott Patton','Ken Diaz','Brian Sipe','Marese Langan','Shana Fruman','Zoe Hay','Greg Cannom','Joel Harlow','Christopher Allen Nelson'],
costumes:['Penny Rose']},
{title:'Three Billboards Outside Ebbing, Missouri',
titleCZ:'Tři billboardy kousek za Ebbingem',
year:2017,
runtime:115,
countries:['UK','USA'],
genres:['Drama','Crime'],
director:['Martin McDonagh'],
actors:['Frances McDormand','Caleb Landry Jones','Kerry Condon','Sam Rockwell','Clarke Peters','Darrell Britt-Gibson','Woody Harrelson','Abbie Cornish','Riya May Atwood','Lucas Hedges','Željko Ivanek','Amanda Warren','Malaya Rivera Drew','Sandy Martin','Peter Dinklage','Christopher Berry','Jerry Winsett','Kathryn Newton','John Hawkes','Samara Weaving','William J. Harrison','Brendan Sexton III','Michael Aaron Milligan','Marcus Lyle Brown','Maho Honda','Nick Searcy','Lawrence Turner'],
screenplay:['Martin McDonagh'],
production:['Graham Broadbent','Peter Czernin','Martin McDonagh'],
music:['Carter Burwell'],
camera:['Ben Davis'],
cut:['Jon Gregory'],
sound:['Chris Burdon','Doug Cooper','Joakim Sundström'],
scenography:['Inbal Weinberg','Merissa Lombardo','Jesse Rosenthal'],
costumes:['Melissa Toth']},
{title:'Fargo',
titleCZ:'Fargo',
year:1996,
runtime:98,
countries:['USA','UK'],
genres:['Drama','Crime','Thriller'],
director:['Joel Coen','Ethan Coen'],
actors:['Frances McDormand','William H. Macy','Steve Buscemi','Harve Presnell','Peter Stormare','Kristin Rudrüd','Tony Denman','Gary Houston','Sally Wingert','Melissa Peterman','Steve Reevis','Warren Keith','Sharon Anderson','Larry Brandenburg','James Gaulke','J. Todd Anderson','John Carroll Lynch','Bruce Bohne','Steve Park','Michelle Hutchison','Bix Skahill','Bruce Campbell','José Feliciano'],
screenplay:['Ethan Coen','Joel Coen'],
production:['Ethan Coen','Joel Coen'],
music:['Carter Burwell'],
camera:['Roger Deakins'],
cut:['Joel Coen','Ethan Coen'],
sound:['Skip Lievsay'],
scenography:['Rick Heinrichs'],
masks:['John Blake','Daniel Curet'],
costumes:['Mary Zophres']},
{title:'Ray',
titleCZ:'Ray',
year:2004,
runtime:152,
countries:['USA'],
genres:['Music','Drama','Biographic'],
director:['Taylor Hackford'],
actors:['Jamie Foxx','Kerry Washington','Regina King','Patrick Bauchau','Curtis Armstrong','David Krumholtz','Richard Schiff','Larenz Tate','Clifton Powell','Usher','Aunjanue Ellis-Taylor','Kurt Fuller','Harry Lennix','Bokeem Woodbine','Terrence Howard','Rick Gomez','Warwick Davis','Robert Wisdom','Ray Charles','Gary Grubbs','Wendell Pierce','Alex Van','Tequan Richmond','Tobi Gadison','Larry Gamell Jr.','Don Yesso','Carlos Rivero','Curt Sobel','Carol Sutton','Afemo Omilami','Vernel Bagneris','Mike Pniewski','Rutherford Cravens','Chris Thomas King','Thomas Jefferson Byrd','Sonny Shroyer','Denise Dowse','Elizabeth Omilami','Trae Ireland','Travis Willingham','Justin Groetsch'],
screenplay:['James L. White'],
production:['Taylor Hackford','Howard Baldwin'],
music:['Craig Armstrong'],
camera:['Paweł Edelman'],
cut:['Paul Hirsch'],
sound:['Scott Millan'],
scenography:['Stephen Altman','Maria Nay'],
masks:['Howard Berger','Greg Nicotero','Camille Friend','JoAnn Stafford-Chaney','LaLette Littlejohn','Paul Anthony Morris'],
costumes:['Sharen Davis']},
{title:'Avanti!',
titleCZ:'Nebožtíci přejí lásce',
year:1972,
runtime:140,
countries:['USA','Italy'],
genres:['Comedy','Romance'],
director:['Billy Wilder'],
actors:['Jack Lemmon','Juliet Mills','Clive Revill','Edward Andrews','Pippo Franco','Yanti Somer','Gianfranco Barra','María Rosa Sclauzero','Ty Hardin','Janet Agren','Giacomo Rizzo','Franco Angrisano','Lella Cattaneo','Ettore Geri','Anna Maria Perego','Giuseppe Terranova','Aldo Rendine','Pupita Lea Scuderoni','Nestore Cavaricci','Alba Maiolini','Giuseppe Marrocco','Bruno Alias','Harry Ray','Gianni Di Segni'],
screenplay:['Billy Wilder','I.A.L. Diamond','Samuel A. Taylor'],
production:['Billy Wilder'],
music:['Carlo Rustichelli'],
camera:['Luigi Kuveiller'],
cut:['Ralph E. Winters'],
masks:['Harry Ray']},
{title:'Being There',
titleCZ:'Byl jsem při tom',
year:1979,
runtime:130,
countries:['USA'],
genres:['Drama','Comedy'],
director:['Hal Ashby'],
actors:['Peter Sellers','Shirley MacLaine','Melvyn Douglas','Jack Warden','Richard Dysart','Richard Basehart','David Clennon','Fran Brill','Sam Weisman','Fredric Lehne','Elya Baskin','Hal Ashby','Sandy Ward','Melendy Britt','Basil Hoffman','Richard Venture','Arthur Rosenberg','Jerome Hellman','Maurice Copeland','Hanna Hertelendy','Denise DuBarry','Alice Hirson','James Noble','Than Wyenn','John Harkins','Richard McKenzie','Terrence Currier','Danna Hansen','Paul Marin','Ruth Attaway','Richard Seff','Katherine De Hetre','Ned Wilson','Kenneth Patterson'],
basedOn:['Jerzy Kosiński'],
screenplay:['Jerzy Kosiński','Robert C. Jones'],
production:['Andrew Braunsberg'],
music:['Johnny Mandel'],
camera:['Caleb Deschanel'],
cut:['Don Zimmerman'],
scenography:['Michael D. Haller','Robert R. Benton'],
costumes:['May Routh']},
{title:'Rashomon',
titleCZ:'Rašómon',
year:1950,
runtime:88,
countries:['Japan'],
genres:['Drama','Crime','Mystery'],
director:['Akira Kurosawa'],
actors:['Toširó Mifune','Mačiko Kjó','Takaši Šimura','Masajuki Mori','Minoru Čiaki','Daisuke Kató','Noriko Honma'],
basedOn:['Rjúnosuke Akutagawa'],
screenplay:['Akira Kurosawa','Šinobu Hašimoto'],
music:['Fumio Hajasaka'],
camera:['Kazuo Mijagawa'],
cut:['Akira Kurosawa'],
scenography:['Takashi Matsuyama']},
{title:'Doctor Zhivago',
titleCZ:'Doktor Živago',
year:1965,
runtime:197,
countries:['UK','USA','Italy'],
genres:['Drama','Romance'],
director:['David Lean'],
actors:['Omar Sharif','Julie Christie','Geraldine Chaplin','Rod Steiger','Alec Guinness','Tom Courtenay','Ralph Richardson','Rita Tushingham','Klaus Kinski','Geoffrey Keen','Adrienne Corri','Jack MacGowran','José María Caffarel','Ingrid Pitt','Lili Muráti','Aldo Sambrell','Víctor Israel','Noel Willman','Ricardo Palacios','Pilar Gómez Ferrer','Peter Madden','Bernard Kay','Robert Rietty','Gwen Nelson','Erik Chitty','Luana Alcañiz','Emilio Carrer','María Martín','Roger Maxwell','Mark Eden','Inigo Jackson','María Vico','Wolf Frees','Siobhan McKenna','Gérard Tichy','Virgilio Teixeira','José Nieto'],
basedOn:['Boris Pasternak'],
screenplay:['Robert Bolt'],
production:['Carlo Ponti'],
music:['Maurice Jarre'],
camera:['Freddie Young'],
cut:['Norman Savage'],
sound:['Franklin Milton'],
scenography:['John Box'],
masks:['Mario Van Riel','Julián Ruiz','Grazia De Rossi'],
costumes:['Phyllis Dalton']},
{title:'Wild Strawberries',
titleCZ:'Lesní jahody',
year:1957,
runtime:91,
countries:['Sweden'],
genres:['Drama','Road movie'],
director:['Ingmar Bergman'],
actors:['Victor Sjöström','Bibi Andersson','Ingrid Thulin','Gunnar Björnstrand','Max von Sydow','Per Sjöstrand','Gunnel Lindblom','Maud Hansson','Åke Fridell','Gertrud Fridh','Gio Petré','Naima Wifstrand','Sif Ruud','Gunnel Broström','Gunnar Sjöberg','Ulf Johanson','Gunnar Olsson','Jullan Kindahl','Göran Lundqvist','Yngve Nordwall','Björn Bjelfvenstam','Harry Asklund','Eva Möller'],
screenplay:['Ingmar Bergman'],
production:['Allan Ekelund'],
music:['Erik Nordgren'],
camera:['Gunnar Fischer'],
cut:['Oscar Rosander'],
sound:['Aaby Wedin'],
masks:['Nils Nittel']},
{title:"Laurel and Hardy's Laughing 20's",
titleCZ:'Laurel a Hardy',
year:1965,
runtime:91,
countries:['USA'],
genres:['Comedy','Family'],
director:['Robert Youngson'],
actors:['Jay Jackson','Oliver Hardy','Stan Laurel','Edna Murphy','Charley Chase','James Finlayson','Edgar Kennedy','Dell Henderson','Glenn Tryon',"Spec O'Donnell",'Anders Randolf','Vivien Oakland','Josephine Crowell','Anita Garvin','Tiny Sandford','Dorothy Coburn','Max Davidson']},
{title:'Mr. Smith Goes to Washington',
titleCZ:'Pan Smith přichází',
year:1939,
runtime:129,
countries:['USA'],
genres:['Drama','Comedy'],
director:['Frank Capra'],
actors:['Jean Arthur','James Stewart','Claude Rains','Edward Arnold','Guy Kibbee','Thomas Mitchell','Eugene Pallette','Beulah Bondi','H.B. Warner','Harry Carey','Astrid Allwyn','Ruth Donnelly','Grant Mitchell','William Demarest','Maurice Costello','Dub Taylor','Alec Craig','Jack Carson','Lloyd Ingraham','Russell Simpson','Ann Doran','Dorothy Comingore','Evalyn Knapp','Lorna Gray','Craig Stevens','John Russell','Chester Conklin','Dave Willock','Robert Sterling','Byron Foulger','Porter Hall','Walter Sande','Charles Sullivan','Philo McCullough','Donald Kerr','Lester Dorr','Mary Gordon','George Chandler','Edmund Cobb','Lafe McKee','Henry Roquemore','Pierre Watkin','Harry Tenbrook','Edward Earle','William Worthington','Dick Elliott','Gino Corrado','Al Bridge','Sam Ash','Harry Hayden','James Millican','Stanley Andrews','William Newell','Ferris Taylor','Louis Jean Heydt','Larry Steers','Harry C. Bradley','Harry Strang','Lynton Brent','Wade Boteler','Neal Dodd','Arthur Loft','Robert Middlemass','Frederick Vroom','Milton Kibbee','Emma Tansey','Frank Puglia','Joe Devlin','Charles Lane',"Frank O'Connor",'Brooks Benedict','Bert Moorhouse','Jack Gardner','Frances Gifford','Arthur Thalasso','George McKay','Hank Mann','Allan Cavan','John Dilson','Eddy Chandler','Eddie Kane','Wilson Benge','Olaf Hytten','Florence Wix','Edward Biby','Margaret Mann','Fred Toones','Anne Cornwall','Helen Jerome Eddy','George Cooper','Ralph McCullough','Wyndham Standing','Dickie Jones','Walter Soderling','Frank McLure','Vera Lewis','Maurice Cass','Jack Cooper','John Tyrrell','Jack Richardson'],
screenplay:['Sidney Buchman'],
production:['Frank Capra'],
music:['Dimitri Tiomkin'],
camera:['Joseph Walker'],
cut:['Al Clark','Gene Havlick'],
sound:['John P. Livadary'],
scenography:['Lionel Banks'],
masks:['Fred B. Phillips','Helen Hunt'],
costumes:['Robert Kalloch']},
{title:'Crime and Passion',
titleCZ:'Eso v rukávu',
year:1976,
runtime:92,
countries:['Germany','UK'],
genres:['Comedy','Drama','Thriller'],
director:['Ivan Passer'],
actors:['Omar Sharif','Karen Black','Joseph Bottoms','Bernhard Wicki','Volker Prechtel','Erich Padalewski','Heinz Ehrenfreund'],
basedOn:['James Hadley Chase'],
screenplay:['Ivan Passer','William Richert','Alan Trustman','Jesse Lasky Jr.','Pat Silver'],
music:['Vangelis'],
cut:['John Jympson','Bernard Gribble'],
sound:['Robi Güver','Bill Rowe'],
masks:['Raimund Stangl'],
costumes:['Yvonne Blake']},
{title:'The Search',
titleCZ:'Poznamenaní',
year:1948,
runtime:103,
countries:['USA','Switzerland'],
genres:['Drama','War'],
director:['Fred Zinnemann'],
actors:['Ivan Jandl','Jarmila Novotná','Montgomery Clift','Ewart G. Morrison','Aline MacMahon','Wendell Corey','Fred Zinnemann'],
basedOn:['Betty Smith'],
screenplay:['Richard Schweizer'],
music:['Robert Blum'],
camera:['Emil Berna'],
cut:['Hermann Haller']},
{title:'Shut Up!',
titleCZ:'Drž hubu!',
year:2003,
runtime:85,
countries:['France','Italy'],
genres:['Comedy','Crime'],
director:['Francis Veber'],
actors:['Jean Reno','Gérard Depardieu','Jean-Pierre Malo','Richard Berry','André Dussollier','Leonor Varela','Ticky Holgado','Laurent Gamelon','Aurélien Recoing','Michel Aumont','Edgar Givry','Armelle Deutsch','Johan Libéreau','Philippe Brigaud','Vincent Moscato','Valentin Merlet','Jean-Michel Noirey','Ludovic Berthillot','Thierry Nenez','Antoine Blanquefort','Luq Hamet','Jean Dell','Rebecca Potok','Alain Fourès','Eric Moreau','Dominique Parent','Patrick Médioni','Gilles Conseil','Adrien Saint-Joré','François Gamard','Julien Cafaro','Michel Caccia','Pétronille Moss'],
screenplay:['Francis Veber'],
production:['Saïd Ben Saïd'],
music:['Marco Prince'],
camera:['Luciano Tovoli'],
cut:['Georges Klotz'],
sound:['Jean Gargonne','Bernard Bats'],
scenography:['Dominique André'],
masks:['Turid Follvik'],
costumes:['Jacqueline Bouchard']},
{title:'Star Trek',
titleCZ:'Star Trek',
year:2009,
runtime:127,
countries:['USA','Germany'],
genres:['Sci-Fi','Adventure','Action'],
director:['J.J. Abrams'],
actors:['Chris Pine','Zachary Quinto','Leonard Nimoy','Eric Bana','Bruce Greenwood','Karl Urban','Zoe Saldana','Simon Pegg','John Cho','Anton Yelchin','Ben Cross','Winona Ryder','Chris Hemsworth','Jennifer Morrison','Rachel Nichols','Faran Tahir','Clifton Collins Jr.','Tim Griffin','Freda Foh Shen','Jason Brooks','Kelvin Yu','Marta Martin','Billy Brown','Jimmy Bennett','Greg Grunberg','Spencer Daniels','Jacob Kogan','Cody Klop','Akiva Goldsman','Anna Katarina','Douglas Tait','Jason Matthew Smith','Bob Clendenin','Darlene Tejeiro','Reggie Lee','Jeffrey Byron','Jonathan Dixon','Tyler Perry','Margot Farley','Paul McGillion','Lisa Vidal','Alex Nevil','Sufe Bradshaw','Jeff Chase','Nana Hill','Oz Perkins','Amanda Foreman','Michael Berry Jr.','Lucia Rijker','Pasha D. Lychnikoff','Greg Ellis','Marlene Forte','Leonard O. Turner','Mark Bramhall','Irene Roseen','Scottie Thompson','Deep Roy','Majel Barrett','Sala Baker','Brad William Henke','Elizabeth Ingalls','Daniel D. Lee','Wil Wheaton','T.J. Storm','Damion Poitier','Sarah Klaren','Anne Leighton','Johnny Baca','Katie Soo','Leslie Augustine','Rahvaunia','William Morgan Sheppard','Ravi Valleti','Lorenzo James Henrie','Jolene Kay','Ian Fisher','Rico E. Anderson','Christopher Doohan','Christopher Karl Johnson','Mark Phelan','Massi Furlan','Ken Edling','Matthew McGregor','Gerald W. Abrams','James Cawley','Kimberly Arland','Sonita Henry','Marcus Young','Josh Greene','Max Chernov'],
screenplay:['Alex Kurtzman','Roberto Orci'],
production:['J.J. Abrams','Damon Lindelof'],
music:['Michael Giacchino'],
camera:['Dan Mindel'],
cut:['Maryann Brandon','Mary Jo Markey'],
sound:['David Giammarco','Paul Massey','Andy Nelson','Anna Behlmer','Mark P. Stoeckinger'],
scenography:['Scott Chambliss','Karen Manthey','Gary Kosko','Luke Freeborn'],
masks:['Mindy Hall','Mike Smithson','Jamie Kelman','Kenny Niederbaumer','Brian Sipe','Patricia Dehaney','Colleen LaBaff','Greg Funk','Christopher Allen Nelson','Ketty Gonzalez','Ginger Damon'],
costumes:['Michael Kaplan']},
{title:'Hot Shots!',
titleCZ:'Žhavé výstřely',
year:1991,
runtime:81,
countries:['USA'],
genres:['Action','Comedy','War','Romance'],
director:['Jim Abrahams'],
actors:['Charlie Sheen','Cary Elwes','Valeria Golino','Lloyd Bridges','Kevin Dunn','Jon Cryer','Kristy Swanson','Efrem Zimbalist Jr.','Bill Irwin','Heidi Swedberg','Bruce A. Young','Ryan Stiles','Ryan Cutrona','Pat Proft','Cylk Cozart','Jimmie Ray Weeks','Charles Barkley','Christopher Doyle','Dave Oliver','Marc Shaiman',"William O'Leary",'Sean Kanan','Steven Chester Prince','Jimmy Lennon Jr.','Jerry Haleva','Don Lake',"Annie O'Donnell",'Rino Thunder','Tony Lorea','Judith Kahan','Mark Arnott'],
screenplay:['Pat Proft'],
production:['Bill Badalato'],
music:['Sylvester Levay'],
camera:['Bill Butler'],
cut:['Jane Kurson','Eric A. Sears'],
sound:["Kevin O'Connell"],
scenography:['William A. Elliott','Ken Kaufman'],
masks:['Cindy J. Williams','Allan A. Apone','Dayne Johnson'],
costumes:['Mary Malin']},
{title:'A Clockwork Orange',
titleCZ:'Mechanický pomeranč',
year:1971,
runtime:136,
countries:['UK','USA'],
genres:['Drama','Crime','Sci-Fi'],
director:['Stanley Kubrick'],
actors:['Malcolm McDowell','Patrick Magee','Warren Clarke','Adrienne Corri','Anthony Sharp','Philip Stone','Margaret Tyzack','Steven Berkoff','David Prowse','Gillian Hills','Michael Bates','Carol Drinkwater','George Coulouris','Adolf Hitler','Madge Ryan','Barrie Cookson','Pat Roach','Carl Duering','Aubrey Morris','Alec Wallis','Miriam Karlin','Virginia Wetherell','Clive Francis','Paul Farrell','John Savident','Neil Wilson','Maurice Bush','Godfrey Quigley','Winifred Sabine','Sheila Raynor','Fred Hugh','Harry Hutchinson','Katharina Kubrick','Michael Gover','Lindsay Campbell','John Clive','Vivienne Chandler','Billy Russell','James Marcus','Katya Wyeth','Peter Burton','Jack Arrow','Gaye Brown'],
basedOn:['Anthony Burgess'],
screenplay:['Stanley Kubrick'],
production:['Stanley Kubrick'],
music:['Wendy Carlos','Henry Purcell','Gioachino Rossini','Ludwig van Beethoven'],
camera:['John Alcott'],
cut:['Bill Butler'],
scenography:['John Barry'],
masks:['Barbara Daly'],
costumes:['Milena Canonero']},
{title:'Parasite',
titleCZ:'Parazit',
year:2019,
runtime:132,
countries:['South Korea'],
genres:['Drama','Comedy','Thriller'],
director:['Džun-ho Pong'],
actors:['Kang-ho Song','Seon-gyoon Lee','Yeo-jeong Jo','Hye-jin Jang','Woo-shik Choi','So-dam Park','Seung-min Hyeon','Hyun-jun Jung','Myeong-hoon Park','Keun-rok Park','Seo-joon Park','Jeong-eun Lee','Hye-ri Yoon','Yi-seo Jung','Ji-so Jung','Dong-yong Lee'],
screenplay:['Džun-ho Pong','Jin-won Han'],
production:['Džun-ho Pong','Sin-ae Kwak','Young-Hwan Jang','Yang-kwon Moon'],
music:['Jae-il Jung'],
camera:['Kyeong-pyo Hong'],
cut:['Jinmo Yang'],
sound:['Choi Tae-young'],
scenography:['Ha-jun Lee','Won-woo Cho'],
masks:['Young Kim Seo','Hwang Hyo-kyun','Kwak Tae-yong'],
costumes:['Se-yeon Choi']},
{title:'Chinatown',
titleCZ:'Čínská čtvrť',
year:1974,
runtime:130,
countries:['USA'],
genres:['Mystery','Drama','Thriller','Crime'],
director:['Roman Polański'],
actors:['Jack Nicholson','Faye Dunaway','John Hillerman','John Huston','Perry Lopez','Burt Young','Bruce Glover','Joe Mantell','Roy Jenson','Diane Ladd','Darrell Zwerling','James Hong','Roman Polański','Richard Bakalyan','Noble Willingham','Jesse Vint','Rance Howard','Roy Roberts','Lee de Broux','Belinda Palmer','Paul Jenkins','Beulah Quo','Nandu Hinds','George Justin','Cecil Elliott','Jerry Fujikawa','Fritzi Burr','Bob Golden','John Holland','Joe Pine','Robert Hitchcock','Bob Harks','Alan Marston','Paul Van'],
screenplay:['Robert Towne','Roman Polański'],
production:['Robert Evans'],
music:['Jerry Goldsmith'],
camera:['John A. Alonzo','Stanley Cortez'],
cut:["Sam O'Steen"],
sound:['John Wilkinson'],
scenography:['Richard Sylbert','Ruby R. Levitt'],
masks:['Lee Harman'],
costumes:['Anthea Sylbert']},
{title:'Annie Hall',
titleCZ:'Annie Hallová',
year:1977,
runtime:93,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Woody Allen'],
actors:['Woody Allen','Diane Keaton','Tony Roberts','Carol Kane','Shelley Duvall','Janet Margolin','Colleen Dewhurst','Christopher Walken','John Glover','Jeff Goldblum','William Callaway','Truman Capote','Shelley Hack',"Beverly D'Angelo",'Sigourney Weaver','Tracey Walter','Laurie Bird','Walter Bernstein','Paul Simon','John Dennis Johnston','Rashel Novikoff','Lucy Lee Flippin','Johnny Haymer','Paula Trueman','Mary Boylan','Mark Lenard','Russell Horton','Hy Anzell','Donald Symington','Roger Newman','Humphrey Davis','Gary Allen','Dick Cavett','Rick Petrucelli','Gary Mule Deer'],
screenplay:['Woody Allen','Marshall Brickman'],
production:['Charles H. Joffe','Jack Rollins'],
camera:['Gordon Willis'],
cut:['Wendy Greene Bricmont','Ralph Rosenblum'],
masks:['John Inzerella'],
costumes:['Ruth Morley']},
{title:'Dial M for Murder',
titleCZ:'Vražda na objednávku',
year:1954,
runtime:105,
countries:['USA'],
genres:['Crime','Mystery','Thriller'],
director:['Alfred Hitchcock'],
actors:['Ray Milland','Grace Kelly','Robert Cummings','John Williams','Anthony Dawson','Leo Britt','Patrick Allen','Robin Hughes','Martin Milner','Guy Doleman','Bess Flowers','Forbes Murray','Sam Harris','Harold Miller','Jack Cunningham','Bernard Sell','Herschel Graham',"Monty O'Grady",'Norman Stevans'],
screenplay:['Frederick Knott','Frederick Knott'],
production:['Alfred Hitchcock'],
music:['Dimitri Tiomkin'],
camera:['Robert Burks'],
cut:['Rudi Fehr'],
sound:['Oliver S. Garretson'],
scenography:['Edward Carrere'],
masks:['Gordon Bau','Otis Malcolm']},
{title:'Sorcerer',
titleCZ:'Mzda strachu',
year:1977,
runtime:121,
countries:['USA'],
genres:['Thriller','Drama','Adventure'],
director:['William Friedkin'],
actors:['Roy Scheider','Bruno Cremer','Francisco Rabal','Amidou','Ramon Bieri','Joe Spinell','Jacques François','André Falcon','Jean-Luc Bideau','Anne-Marie Deschodt','Friedrich von Ledebur','Peter Capell','Karl John','Randy Jurgensen','Frank Pesce','Tom Signorelli','Gerard Murphy','Frank Gio','Chico Martínez'],
basedOn:['Georges Arnaud'],
screenplay:['Walon Green'],
production:['William Friedkin'],
music:['Tangerine Dream'],
camera:['Dick Bush','John M. Stephens'],
cut:['Robert K. Lambert','Bud S. Smith'],
sound:['Jean-Louis Ducarme','Aaron Levy','Gary Alexander'],
scenography:['John Box'],
masks:['John Norin','Verne Caruso','Robert Norin'],
costumes:['Anthony Powell']},
{title:'Ninja Scroll',
titleCZ:'Džúbei a umění nindžucu',
year:1993,
runtime:91,
countries:['Japan'],
genres:['Animation','Action','Adventure','Fantasy'],
director:['Jošiaki Kawadžiri'],
actors:['Kóiči Jamadera','Takeši Aono','Norio Wakamoto','Tošihiko Seki','Ičiró Nagai','Júsaku Jara','Daisuke Góri','Osamu Saka','Gara Takašima','Emi Šinohara','Kacudži Mori','Kacumi Suzuki',"Džun'iči Sugawara",'Akimasa Ómori','Masako Kacuki','Rjúzaburó Ótomo','Šúičiró Morijama','Reizó Nomoto'],
production:['Masaki Sawanobori','Masako Fukujo'],
music:['Kaoru Wada'],
camera:['Hitoši Jamaguči'],
cut:['Jukiko Itó','Harutoši Ogata'],
sound:['Jasunori Honda'],
scenography:['Hiromasa Ogura']},
{title:'Wolf Children',
titleCZ:'Vlčí děti',
year:2012,
runtime:117,
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Romance'],
director:['Mamoru Hosoda'],
actors:['Aoi Mijazaki','Haru Kuroki','Jukito Nišii','Bunta Sugawara','Kumiko Asó','Megumi Hajašibara','Micuki Tanimura','Tamio Óki','Šóta Sometani','Amon Kabe','Mone Kamiširaiši','Takuma Hiraoka','Masahiro Usui','Kanau Tanaka','Tomie Kataoka','Kóhei Ikeue','Jóhei Tadano','Eiičiró Tokumoto','Cuda Eizó','Asuka Minamori','Jóko Óno','Tomoko Hiracudži','Ami Nanase','Júi Fudžimaki','Tadaši Nakamura','Takao Išii','Masakazu Itó','Taiči Masu','Teruo Seki'],
screenplay:['Mamoru Hosoda','Satoko Okudera'],
production:['Takuja Itó'],
music:['Masakacu Takagi'],
cut:['Šigeru Nišijama'],
costumes:['Daisuke Iga']},
{title:'Avengers: Endgame',
titleCZ:'Avengers: Endgame',
year:2019,
runtime:182,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Fantasy'],
director:['Anthony Russo','Joe Russo'],
actors:['Robert Downey Jr.','Chris Evans','Mark Ruffalo','Chris Hemsworth','Scarlett Johansson','Jeremy Renner','Don Cheadle','Paul Rudd','Benedict Cumberbatch','Chadwick Boseman','Brie Larson','Tom Holland','Karen Gillan','Zoe Saldana','Evangeline Lilly','Tessa Thompson','Rene Russo','Elizabeth Olsen','Anthony Mackie','Sebastian Stan','Tom Hiddleston','Danai Gurira','Benedict Wong','Pom Klementieff','Dave Bautista','Letitia Wright','John Slattery','Tilda Swinton','Jon Favreau','Hayley Atwell','Natalie Portman','Taika Waititi','Angela Bassett','Marisa Tomei','Michael Douglas','Michelle Pfeiffer','William Hurt','Cobie Smulders','Sean Gunn','Winston Duke','Linda Cardellini','Maximiliano Hernández','Frank Grillo','Hirojuki Sanada','Tom Vaughan-Lawlor',"James D'Arcy",'Jacob Batalon','Vin Diesel','Bradley Cooper','Gwyneth Paltrow','Robert Redford','Josh Brolin','Chris Pratt','Samuel L. Jackson','Lexi Rabe','Ross Marquand','Joe Russo','Emma Fuhrmann','Michael James Shaw','Terry Notary','Kerry Condon','Cade Woodward','Stan Lee','Yvette Nicole Brown','Callan Mulvey','Ken Jeong','Ty Simpkins','Jackson A. Dunn','Jimmy Ray Pickens','Carrie Coon','Faith Logan','Maria Z. Wilson','Joy McAvoy','Sam Hargrave','Robert Tinsley','Kiersten Dolbec','Eric Word','Ava Russo','Roe Dunkley','Ameenah Kaplan','Maurice P. Kerry','Ben Sakamoto','Marie Mouroum'],
basedOn:['Stan Lee','Jack Kirby'],
screenplay:['Christopher Markus','Stephen McFeely'],
production:['Kevin Feige'],
music:['Alan Silvestri'],
camera:['Trent Opaloch'],
cut:['Jeffrey Ford','Matthew Schmidt'],
sound:['Juan Peralta','Daniel Laurie','Shannon Mills','Tom Johnson'],
scenography:['Charles Wood'],
masks:['John Blake',"Valli O'Reilly",'Heba Thorisdottir','Vasilios Tanis','Dennis Liddiard','Donald McInnes','Louisa V. Anthony','Vivian Baker','Katie Ballard','Björn Rehbein','Matteo Silvi','Christopher Allen Nelson','Alexei Dmitiew'],
costumes:['Judianna Makovsky']},
{title:'Goldfinger',
titleCZ:'Goldfinger',
year:1964,
runtime:110,
countries:['UK'],
genres:['Action','Adventure','Thriller'],
director:['Guy Hamilton'],
actors:['Sean Connery','Gert Fröbe','Shirley Eaton','Harold Sakata','Honor Blackman','Tania Mallet','Bernard Lee','Martin Benson','Cec Linder','Austin Willis','Lois Maxwell','Burt Kwouk','Desmond Llewelyn','Les Tremayne','Garry Marshall','Margaret Nolan','Richard Vernon','Michael G. Wilson','Gerry Duggan','Nadja Regin','Bob Simmons','Maggie Wright','Bill Nagy','Raymond Young','Anthony Chinn','Laurence Herder','Michael Mellinger','Lionel Murton','Hal Galili','Carmen Dane','Marian Collins','Bill Brandon','Caron Gardner','Victor Brooks','Peter Brace','George Leech','Terence Brook','Roland Brand','John McLaren','Denis Cowles','John McLaughlin'],
basedOn:['Ian Fleming'],
screenplay:['Richard Maibaum','Paul Dehn','Johanna Harwood'],
production:['Albert R. Broccoli','Harry Saltzman'],
music:['John Barry'],
camera:['Ted Moore'],
cut:['Peter R. Hunt'],
sound:['Otto Snel'],
scenography:['Ken Adam'],
masks:['Basil Newall','Paul Rabiger']},
{title:'The Class',
titleCZ:'Zkažená mládež',
year:2007,
runtime:98,
countries:['Estonsko'],
genres:['Drama'],
director:['Ilmar Raag'],
actors:['Vallo Kirs','Pärt Uusberg','Lauri Pedaja','Paula Solvak','Mikk Mägi','Riina Reis','Joonas Paas','Triin Tenso','Kadi Metsla','Virgo Ernits','Karl Sakrits','Laine Mägi','Kaie Mihkelson','Erik Põllumaa','Margus Prangel','Doris Tislar','Gerda Kordemets','Margus Karu','Saara Kadak','Oya Akar','İmer Özgün','Mirjam Mesak'],
screenplay:['Ilmar Raag'],
production:['Riina Sildos'],
music:['Timo Steiner'],
camera:['Erçin Karabulut'],
cut:['Tambet Tasuja'],
sound:['Horret Kuus']},
{title:'Skeleton on Horseback',
titleCZ:'Bílá nemoc',
year:1937,
runtime:106,
countries:['Czechoslovakia'],
genres:['Drama','Psychology','Parable','Sci-Fi'],
director:['Hugo Haas'],
actors:['Hugo Haas','Zdeněk Štěpánek','Karla Oličová','Bedřich Karen','Václav Vydra st.','Ladislav Boháč','Jaroslav Průcha','Karel Dostal','Rudolf Deyl st.','František Smolík','Helena Friedlová','Eva Svobodová','Vítězslav Boček','Otto Rubík','Vladimír Šmeral','Miroslav Svoboda','Marie Nademlejnská','Karel Jičínský','Eduard Blažek','Vilém Pruner','Frank Rose-Růžička','Vladimír Smíchovský','Karel Jelínek','Vladimír Hlavatý','Jaroslav Vojta','Emil Dlesk','Fráňa Vajner','Marie Holanová','Maria Bibikov','Erna Ženíšková','František Filipovský','Jan Šebor','Julius Baťha','Jaroslav Tryzna','Jiří Schreinzer','Anči Pírková','Jindřich Adolf','Karolína Vávrová','Viktor Dintr','Bohumil Langer','Antonín Šolc','Jiřina Vávrová'],
screenplay:['Hugo Haas','Karel Čapek'],
production:['Hugo Haas'],
music:['Jan Branberger'],
camera:['Otto Heller'],
cut:['Antonín Zelenka'],
sound:['Vilém Taraba'],
scenography:['Štěpán Kopecký']},
{title:'To Kill a Mockingbird',
titleCZ:'Jako zabít ptáčka',
year:1962,
runtime:124,
countries:['USA'],
genres:['Drama'],
director:['Robert Mulligan'],
actors:['Gregory Peck','Mary Badham','Phillip Alford','John Megna','Frank Overton','Rosemary Murphy','Ruth White','Brock Peters','Robert Duvall','Paul Fix','Collin Wilcox Paxton','William Windom','Kim Stanley','Hugh Sanders','Kim Hamilton','Estelle Evans',"William H. O'Brien",'Bobby Barber','Dan White','Alice Ghostley','James Anderson','Crahan Denton','Richard Hale','R.L. Armstrong','Danny Borzage','John Breen','Jess Cavin','Steve Condit','David Crawford','Charles Fredericks','Jamie Forster','Chuck Hamilton','Jester Hairston','Kim Hector','Michael Jeffers','Dick Johnstone','Colin Kenny','Nancy Marshall','Paulene Myers','Gil Perkins','Joe Ploski','Barry Seltzer','Jay Sullivan','Kelly Thordsen','Arthur Tovey','Max Wagner','Bill Walker','Guy Wilkerson','Ethan Laidlaw','Cap Somers','George Sowards','Herman Hack','Chalky Williams','Ray Spiker','Sailor Vincent','Charles Morton',"Noble 'Kid' Chissell",'Charles Perry','Chester Jones','George Tracy','Eddie Baker','John Barton'],
basedOn:['Harper Lee'],
screenplay:['Horton Foote'],
production:['Alan J. Pakula'],
music:['Elmer Bernstein'],
camera:['Russell Harlan'],
cut:['Aaron Stell'],
sound:['Waldon O. Watson','Corson Jowett'],
scenography:['Alexander Golitzen','Oliver Emert'],
masks:['Bud Westmore'],
costumes:['Rosemary Odell']},
{title:'Metro Manila',
titleCZ:'Metro Manila',
year:2013,
runtime:114,
countries:['Filipíny','UK'],
genres:['Drama','Crime','Thriller','Action'],
director:['Sean Ellis'],
actors:['Jake Macapagal','John Arcilla','Althea Vega','Erin Panlilio','Mailes Kanapi','Moises Magisa','Quark Henares'],
screenplay:['Frank E. Flowers','Sean Ellis'],
music:['Robin Foster'],
camera:['Sean Ellis'],
cut:['Richard Mettler']},
{title:'Berserk: Golden Age Arc II - The Battle for Doldrey',
titleCZ:'Berserk: Ógon džidai hen II - Doldrey kórjaku',
year:2012,
runtime:95,
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy'],
director:['Tošijuki Kubooka','Kóiči Hacumi'],
actors:['Aki Tojosaki','Nobujuki Kacube','Júki Kadži','Kazuki Jao','Čafúrin','Takahiro Sakurai','Minako Kotobuki','Kenta Mijake','Hiroaki Iwanaga','Hóčú Ócuka','Takajuki Sugó','Chris Jai Alex','Rikija Kojama','Čieko Mijazaki','Joširó Macumoto','Toa Jukinari','Takahiro Fudžiwara','Marie Ói','Džun Inoue','Rei Sakai','Rjóta Igaraši','Takumi Watanabe','Jasunobu Iwata','Masajuki Tanaka','Rjóko Šimizu','Akijoši Tomita','Keisuke Sogó','Šingo Egami','Maki Mizuma','Maiko Morinaga','Akiko Toda'],
basedOn:['Kentaró Miura'],
screenplay:['Ičiró Ókóči'],
production:['Eiiči Kamagata'],
music:['Širó Sagisu'],
scenography:['Júsuke Takeda','Hideki Nakamura','Marefumi Niibajaši']},
{title:'The Boxer',
titleCZ:'Boxer a smrť',
year:1962,
runtime:102,
countries:['Czechoslovakia'],
genres:['Drama','Sport'],
director:['Peter Solan'],
actors:['Štefan Kvietik','Valentina Thielová','Józef Kondrat','Gerhard Rachold','Manfred Krug','Edwin Marian','Jindřich Narenta','Ján Kováčik','Ľudovít Ozábal','Jan Bobek','Štefan Winkler','Teodor Piovarči','Hana Slivková','Viera Radványiová','Leopold Haverl','Dušan Lenci','Edmund Ogrodziński'],
basedOn:['Józef Hen'],
screenplay:['Tibor Vichta','Józef Hen'],
music:['Wiliam Bukový'],
camera:['Tibor Biath'],
cut:['Bedřich Voděrka'],
scenography:['Anton Krajčovič'],
masks:['Anton Gendiar'],
costumes:['Anna Liďáková']},
{title:'Fury',
titleCZ:'Byl jsem lynčován',
year:1936,
runtime:90,
countries:['USA'],
genres:['Drama','Film-Noir','Crime','Thriller'],
director:['Fritz Lang'],
actors:['Sylvia Sidney','Spencer Tracy','Walter Abel','Bruce Cabot','Edward Ellis','Walter Brennan','Frank Albertson','George Walcott','Arthur Stone','Morgan Wallace','George Chandler','Edwin Maxwell','Howard C. Hickman','Jonathan Hale','Leila Bennett','Esther Dale','Eddie Quillan','Ward Bond','Raymond Hatton',"Dennis O'Keefe",'Bert Roach','Minerva Urecal','Harry Harvey','Charles Sullivan','Frank Mills','Dick Wessel','Gino Corrado','Robert Homans','Harry Hayden','Gwen Lee','William Newell','Sherry Hall','Arthur Hoyt','Oliver Eckhardt','William Tannen','Clarence Kolb','Edgar Edwards','Frank Sully','King Mojave','Fay Helm','Adolph Faylauer','Florence Wix','Nora Cecil','Christian Rub','Ruth Renick','Raymond Brown','Si Jenks','Mira McKinney','Ed Brady','Charles Meakin','Pat McKee','Jack Grey','Guy Usher','Carl Stockdale','Robert Milasch','Murdock MacQuarrie','Bobbie Hale','Will Stanton','Ernie Alexander','Franklin Parker','Harry Bowen','George Offerman Jr.','Paul McAllister','Gertrude Sutton','Erville Alderson','Billy Wayne','Sidney De Gray','Esther Muir','Mary Foy'],
screenplay:['Fritz Lang'],
production:['Joseph L. Mankiewicz'],
music:['Franz Waxman'],
camera:['Joseph Ruttenberg'],
cut:['Frank Sullivan','William LeVanway'],
sound:['Douglas Shearer'],
scenography:['Cedric Gibbons']},
{title:'Logan',
titleCZ:'Logan: Wolverine',
year:2017,
runtime:137,
countries:['USA'],
genres:['Sci-Fi','Action','Thriller','Drama'],
director:['James Mangold'],
actors:['Hugh Jackman','Patrick Stewart','Boyd Holbrook','Dafne Keen','Stephen Merchant','Richard E. Grant','Eriq La Salle','Elise Neal','Elizabeth Rodriguez','Doris Morgado','Reynaldo Gallegos','Dave Davis','Lauren Gros','Mark Ashworth','James Moses Black','Han Soto','David Kallaway','Toby Holguin','Alison Fernandez','Phi Vu','Damon Carney','Jason Genao','Quincy Fouse','Frank Gallegos','Robert Wu','Al Coronel','Bryant Tardy','Lennie Loftin','Daniel Bernhardt','Ted Ferguson'],
basedOn:['Mark Millar'],
screenplay:['Scott Frank','James Mangold','Michael Green'],
production:['Hutch Parker','Lauren Shuler Donner','Simon Kinberg'],
music:['Marco Beltrami'],
camera:['John Mathieson'],
cut:['Michael McCusker','Dirk Westervelt'],
sound:['Donald Sylvester','David Giammarco','Paul Massey','Pedro Sánchez Alonso'],
scenography:['François Audouy','Luke Freeborn'],
masks:['Kenny Niederbaumer','Ozzy Alvarez','Ozzy Alvarez','Remi Savva'],
costumes:['Daniel Orlandi']},
{title:'The Boy in the Striped Pajamas',
titleCZ:'Chlapec v pruhovaném pyžamu',
year:2008,
runtime:94,
countries:['UK','USA'],
genres:['Drama','War'],
director:['Mark Herman'],
actors:['Asa Butterfield','Jack Scanlon','David Thewlis','Vera Farmiga','Rupert Friend','Richard Johnson','Sheila Hancock','Cara Horgan','Amber Beattie','David Hayman','Jim Norton','Béla Fesztbaum','Julia Papp'],
basedOn:['John Boyne'],
screenplay:['Mark Herman'],
production:['Christine Langan','David Heyman'],
music:['James Horner'],
camera:['Benoît Delhomme'],
cut:['Michael Ellis'],
sound:['Mark Paterson'],
scenography:['Martin Childs'],
masks:['Marese Langan'],
costumes:['Natalie Ward']},
{title:'Thelma & Louise',
titleCZ:'Thelma a Louise',
year:1991,
runtime:130,
countries:['USA','UK','France'],
genres:['Crime','Drama','Road movie'],
director:['Ridley Scott'],
actors:['Susan Sarandon','Geena Davis','Harvey Keitel','Michael Madsen','Christopher McDonald','Stephen Tobolowsky','Brad Pitt','Timothy Carhart','Lucinda Jenney','Jason Beghe','Sonny Carl Davis','Ken Swofford','Shelly Desai','Carol Mansell','Stephen Polk','Jack Lindine','Marco St. John','Gregory J. Barnett','Mamie Jean Calvert'],
screenplay:['Callie Khouri'],
production:['Ridley Scott','Mimi Polk Gitlin'],
music:['Hans Zimmer'],
camera:['Adrian Biddle'],
cut:['Thom Noble'],
sound:['Jim Shields'],
scenography:['Norris Spencer','Anne H. Ahrens'],
masks:['Steve La Porte'],
costumes:['Elizabeth McBride','Taneia Lednicky']},
{title:'A Perfect World',
titleCZ:'Dokonalý svět',
year:1993,
runtime:138,
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Clint Eastwood'],
actors:['Kevin Costner','Clint Eastwood','Laura Dern','T.J. Lowther','Keith Szarabajka','Leo Burmester','Paul Hewitt','Bradley Whitford','Ray McKinnon','Jennifer Griffin','Darryl Cox','James Jeter','Ed Geldart','Bruce McGill','Marietta Marich','Rodger Boyce','Lucy Lee Flippin','Elizabeth Ruscio','David Kroll','Gabriel Folse','Gil Glasgow','Dennis Letts','Margaret Bowman','John M. Jackson','Cameron Finley','Marco Perella','Linda Hart','Brandon Smith','Wayne DeHart','Mary Alice','Kevin Jamal Woods','Tony Frank','Woody Watson','Jimmy Ray Pickens','David Stanford','Greg Stechman','Libby Villari'],
screenplay:['John Lee Hancock'],
production:['Mark Johnson','David Valdes','Clint Eastwood'],
music:['Lennie Niehaus'],
camera:['Jack N. Green'],
cut:['Joel Cox','Ron Spang'],
sound:['Alan Robert Murray','Allen L. Stone','Rick Alexander'],
scenography:['Henry Bumstead','Alan Hicks'],
masks:['James Lee McCoy'],
costumes:['Erica Edell Phillips']},
{title:'Scent of a Woman',
titleCZ:'Vůně ženy',
year:1992,
runtime:157,
countries:['USA'],
genres:['Drama'],
director:['Martin Brest'],
actors:['Al Pacino',"Chris O'Donnell",'James Rebhorn','Gabrielle Anwar','Philip Seymour Hoffman','Richard Venture','Bradley Whitford','Rochelle Oliver','Tom Riis Farrell','Nicholas Sadler','Todd Louiso','Matt Smith','Gene Canfield','Frances Conroy','June Squibb','Ron Eldard','Sally Murphy','Michael Santoro','Anh Duong','Leonard Gaines','David Lansbury','Baxter Harris','Francie Swift','William Beckwith','Mansoor Najee-ullah','Peter Carew','Jack Mulcahy'],
basedOn:['Giovanni Arpino'],
screenplay:['Bo Goldman'],
production:['Martin Brest'],
music:['Thomas Newman'],
camera:['Donald E. Thorin'],
cut:['William Steinkamp','Michael Tronick','Harvey Rosenstock'],
sound:['Doug Hemphill'],
scenography:['Angelo P. Graham','George DeTitta Jr.'],
masks:['Bob Laden'],
costumes:['Aude Bronson-Howard']},
{title:'Brubaker',
titleCZ:'Brubaker',
year:1980,
runtime:132,
countries:['USA'],
genres:['Drama'],
director:['Stuart Rosenberg'],
actors:['Robert Redford','Yaphet Kotto','Jane Alexander','Murray Hamilton','David Keith','Morgan Freeman','Matt Clark','Tim McIntire','Richard Ward','M. Emmet Walsh','Linda Haynes','Everett McGill','Albert Salmi','Val Avery','Joe Spinell','Lee Richardson','Harry Groener','Noble Willingham','Wilford Brimley','John McMartin','Nathan George','Brent Jennings','Don Blakely','Jon Van Ness','James Keane','Vic Polizos','Ron Frazier','David Harris','Roy Poole','John Chappell','William Newman','Ebbe Roe Smith',"Jack O'Leary",'Kent Broadhurst','J.C. Quinn','Rob Garrison','Ritch Brinkley','Nick Baldasare','Alex Brown','Monty Jordan'],
screenplay:['W.D. Richter'],
production:['Ron Silverman'],
music:['Lalo Schifrin'],
camera:['Bruno Nuytten'],
cut:['Robert Brown'],
masks:['Gary Liddiard']},
{title:"Kiki's Delivery Service",
titleCZ:'Doručovací služba čarodějky Kiki',
year:1989,
runtime:103,
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy'],
director:['Hajao Mijazaki'],
actors:['Minami Takajama','Akio Ócuka','Kóiči Jamadera','Mika Doi','Keiko Toda','Haruko Kató','Čika Sakamoto','Jošiko Kamei','Kappei Jamaguči','Šinpači Cudži','Rei Sakuma','Juriko Fučizaki','Júko Kobajaši','Takaja Haši','Tomomiči Nišimura','Kikuko Inoue','Mičihiro Ikemizu','Mieko Nobusawa','Takaši Taguči','Júko Cuga','Jošiko Asai','Šó Saitó'],
basedOn:['Eiko Kadono'],
screenplay:['Hajao Mijazaki'],
music:['Džó Hisaiši'],
cut:['Takeši Sejama']},
{title:'Control',
titleCZ:'Control',
year:2007,
runtime:122,
countries:['UK','USA','Australia','Japan','France'],
genres:['Drama','Music','Biographic'],
director:['Anton Corbijn'],
actors:['Sam Riley','Samantha Morton','Alexandra Maria Lara','Joe Anderson','James Anthony Pearson','Harry Treadaway','Craig Parkinson','Toby Kebbell','Matthew McNulty','Tim Plester','Herbert Grönemeyer','Richard Bremmer','George Newton','Eliot Otis Brown Walters','Tanya Myers','Margaret Jackman','Andrew Sheridan','Robert Shelly','Martha Myers Lowe','David Whittington','Mary Jo Randle','Ben Naylor','James Fortune','Angus Addenbrooke','Nicola Harrison','June Alliss','Mark Jardine','Paul Arlington','Joanna Swain','Joseph Marshall','Laura Chambers','Monica Axelsson','Lotti Closs','Eady Williams','Nigel Harris','John Cooper Clarke'],
basedOn:['Deborah Curtis'],
screenplay:['Matt Greenhalgh'],
production:['Orian Williams'],
camera:['Martin Ruhe'],
cut:['Andrew Hulme'],
sound:['Thomas Huhn'],
scenography:['Chris Roope'],
masks:['Jeremy Woodhead'],
costumes:['Julian Day']},
{title:'Loving Vincent',
titleCZ:'S láskou Vincent',
year:2017,
runtime:94,
countries:['UK','Poland','USA'],
genres:['Animation','Biographic','Crime','Drama'],
director:['DK Welchman','Hugh Welchman'],
actors:['Douglas Booth','Holly Earl',"Chris O'Dowd",'John Sessions','Helen McCrory','Eleanor Tomlinson','Aidan Turner','Saoirse Ronan','Jerome Flynn','Cezary Łukaszewicz','Richard Banks','Shaun Newnham'],
screenplay:['DK Welchman','Hugh Welchman'],
production:['Hugh Welchman','Ivan Mactaggart'],
music:['Clint Mansell'],
camera:['Tristan Oliver'],
cut:['DK Welchman','Justyna Wierszyńska'],
scenography:['Matthew Button','Piotr Dominiak']},
{title:'The Road',
titleCZ:'Silnice',
year:1954,
runtime:108,
countries:['Italy'],
genres:['Drama'],
director:['Federico Fellini'],
actors:['Anthony Quinn','Giulietta Masina','Richard Basehart','Marcella Rovere','Livia Venturini','Gustavo Giorgi','Yami Kamadeva','Anna Primula','Nazzareno Zamperla','Goffredo Unger','Aldo Silvani','Mario Passante','Pietro Ceccarelli'],
screenplay:['Federico Fellini','Ennio Flaiano'],
production:['Carlo Ponti','Dino De Laurentiis'],
music:['Nino Rota'],
camera:['Otello Martelli','Carlo Carlini'],
cut:['Leo Cattozzo'],
sound:['Aldo Calpini']},
{title:'Samurai X: Trust and Betrayal',
titleCZ:'Ruróni Kenšin: Meidži kenkaku rómantan - Cuioku hen',
year:1999,
runtime:120,
countries:['Japan'],
genres:['Animation','Drama','History','Romance'],
director:['Kazuhiro Furuhaši'],
actors:['Majo Suzukaze','Hirotaka Suzuoki','Nozomu Sasaki','Šúiči Ikeda','Tomokazu Seki','Wataru Takagi','Rjúsei Nakao','Micuaki Hošino','Tecuja Iwanaga','Satoši Curuoka','Noriko Namiki','Akari Hibino','Džunko Iwao','Rikija Kojama','Makoto Ueki','Azusa Nakao','Hiroši Takahaši','Naoko Seto','Takahiro Hirano','Sačie Marujama','Hiromi Secu','Kaori Juasa'],
basedOn:['Nobuhiro Wacuki'],
screenplay:['Masaši Sogo'],
production:['Kacunori Narumo','Kazunori Noguči'],
music:['Taku Iwasaki'],
camera:['Masahide Okino'],
cut:['Megumi Učida','Takeši Sejama','Keiko Mizuta'],
sound:['Šódži Hata'],
scenography:['Masami Hagiwara']},
{title:'The Shop Around the Corner',
titleCZ:'Obchod za rohem',
year:1940,
runtime:99,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Ernst Lubitsch'],
actors:['James Stewart','Margaret Sullavan','Frank Morgan','Joseph Schildkraut','Sara Haden','Felix Bressart','William Tracy','Inez Courtney','Charles Halton','Sarah Edwards','William Edmunds','Edwin Maxwell','Charles Arnt','Mabel Colcord','Mira McKinney','Sol Murgi','Joan Blair','Mary Carr','Charles Smith'],
basedOn:['Miklós László'],
screenplay:['Samson Raphaelson','Ben Hecht'],
production:['Ernst Lubitsch'],
music:['Werner R. Heymann'],
camera:['William H. Daniels'],
cut:['Gene Ruggiero'],
sound:['Douglas Shearer'],
scenography:['Cedric Gibbons','Edwin B. Willis']},
{title:'Satantango',
titleCZ:'Satanské tango',
year:1994,
runtime:439,
countries:['Hungary','Germany','Switzerland'],
genres:['Drama'],
director:['Béla Tarr'],
actors:['Mihály Víg','János Derzsi','Miklós Székely B.','Erika Bók','Peter Berling','György Barkó','Péter Dobai','Frigyes Hollósi','Zoltán Kamondi','István Juhász'],
basedOn:['László Krasznahorkai'],
screenplay:['László Krasznahorkai','Béla Tarr'],
production:['Ruth Waldburger','György Fehér','Joachim von Vietinghoff'],
music:['Mihály Víg'],
camera:['Gábor Medvigy'],
cut:['Ágnes Hranitzky'],
sound:['György Kovács']},
{title:'Die Hard 2',
titleCZ:'Smrtonosná past 2',
year:1990,
runtime:124,
countries:['USA'],
genres:['Action','Thriller'],
director:['Renny Harlin'],
actors:['Bruce Willis','Bonnie Bedelia','William Atherton','Reginald VelJohnson','Franco Nero','William Sadler','John Amos','Dennis Franz','Art Evans','Fred Dalton Thompson','Tom Bower','Sheila McCarthy','Don Harvey','Robert Patrick','John Leguizamo','Tom Verica','Vondie Curtis-Hall','Mark Boone Junior','Jeanne Bates','Colm Meaney','Paul Abascal','Robert Costanzo','Karla Tamburrelli','Tom Everett','Rande Scott','Peter Nelson','Richard Domeier','Tony Ganios','Felicity Waterman','Dale Jacoby','Robert Sacchi','Robert Lipton','James Wellington','Stephen Gregory Foster','Ben Lemon','Julian Reyes','Sherry Bilsing','Stafford Morgan','Lauren Letherer','John Costelloe','Charles Lanyer','Danial Donai','Jason Ross-Azikiwe','Vance Valencia','Tom Finnegan','Nick Angotti','Bob Braun','David Katz','Jim Hudson'],
basedOn:['Walter Wager'],
screenplay:['Steven E. de Souza','Doug Richardson'],
production:['Lawrence Gordon','Joel Silver','Charles Gordon'],
music:['Michael Kamen'],
camera:['Oliver Wood'],
cut:['Stuart Baird','Robert A. Ferretti'],
sound:['Alan Robert Murray','Sergio Reyes','Michael Jiron','Gary D. Rogers','Tim Cooney'],
scenography:['John Vallone','Robert Gould'],
masks:['Scott H. Eddo','Thomas R. Burman','Jim Kail'],
costumes:['Marilyn Vance']},
{title:'Walk the Line',
titleCZ:'Walk the Line',
year:2005,
runtime:136,
countries:['USA','Germany'],
genres:['Drama','Music','Romance','Biographic'],
director:['James Mangold'],
actors:['Joaquin Phoenix','Reese Witherspoon','Ginnifer Goodwin','Robert Patrick','Dallas Roberts','Dan John Miller','Larry Bagby','Shelby Lynne','Tyler Hilton','Waylon Payne','Shooter Jennings','Ridge Canipe','Hailey Anne Nelson','Kerris Dorsey','Rhoda Griffis','Carly Nahon','Tim Ware','Lucas Till','James Keach','Clare Grant','Danny Vinson','Amy Lavere','Marc Farley','Brit Shaw','Aaron Covington','J.D. Evermore','Ben Taylor','Tracee Mae Miller','Natalie Canerday','Clay Steakley','Sandra Ellis Lafferty','Frank Hoyt Taylor','McGhee Monteith','John Holiday','John Carter Cash','Johnathan Rice'],
basedOn:['Johnny Cash'],
screenplay:['Gill Dennis','James Mangold'],
production:['Cathy Konrad','James Keach'],
music:['T Bone Burnett'],
camera:['Phedon Papamichael'],
cut:['Michael McCusker'],
sound:['Donald Sylvester','Paul Massey','Doug Hemphill'],
scenography:['David J. Bomba','Carla Curry'],
masks:['Anne Morgan','Kathrine Gordon','Michelle Vittone','Jane Galli'],
costumes:['Arianne Phillips']},
{title:'Finding Neverland',
titleCZ:'Hledání Země Nezemě',
year:2004,
runtime:106,
countries:['USA','UK'],
genres:['Drama','Family','Biographic'],
director:['Marc Forster'],
actors:['Johnny Depp','Kate Winslet','Julie Christie','Radha Mitchell','Dustin Hoffman','Freddie Highmore','Joe Prospero','Nick Roud','Ian Hart','Kelly Macdonald','Mackenzie Crook','Eileen Essell','Jimmy Gardner','Oliver Fox','Angus Barnett','Toby Jones','Kate Maberly','Matt Green','Catrin Rhys','Tim Potter','Jane Booker','Paul Whitehouse','Kali Peacock','Nicholas Pritchard','Richard Braine','Tobias Menzies','Tony Way','Murray McArthur','Greg Bennett','Jade Ewen','Marc Forster','William Tomlin'],
screenplay:['David Magee','Allan Knee'],
production:['Richard N. Gladstein','Nellie Bellflower'],
music:['Jan A.P. Kaczmarek'],
camera:['Roberto Schaefer'],
cut:['Matt Chessé'],
sound:['Matthew Collinge','David Crozier','Lora Hirschberg','Brandon Proctor'],
scenography:['Gemma Jackson'],
masks:['Christine Blundell','Lesa Warrener'],
costumes:['Alexandra Byrne']},
{title:'Amores Perros',
titleCZ:'Amores perros - Láska je kurva',
year:2000,
runtime:154,
countries:['Mexico'],
genres:['Thriller','Drama','Crime'],
director:['Alejandro González Iñárritu'],
actors:['Emilio Echevarría','Gael García Bernal','Goya Toledo','Álvaro Guerrero','Vanessa Bauche','Humberto Busto','Rosa María Bianchi','Adriana Barraza','Gustavo Sánchez Parra','Jorge Salinas','Dagoberto Gama','José Sefami','Rodrigo Murray','Patricio Castillo','Dunia Saldívar','Marco Pérez','Quique Mendoza','Ernesto Bog','José Luis Barraza','Carlos Samperio','Gerardo Campbell','Hilda González','Ángeles Marín'],
screenplay:['Guillermo Arriaga'],
production:['Alejandro González Iñárritu'],
music:['Gustavo Santaolalla'],
camera:['Rodrigo Prieto'],
cut:['Alejandro González Iñárritu','Luis Carballar'],
sound:['Martín Hernández','Antonio Diego'],
scenography:['Brigitte Broch'],
masks:['Isabel Amezcua'],
costumes:['Gabriela Diaque']},
{title:'Dead Man',
titleCZ:'Mrtvý muž',
year:1995,
runtime:121,
countries:['USA','Germany','Japan'],
genres:['Western','Drama','Fantasy'],
director:['Jim Jarmusch'],
actors:['Johnny Depp','Gary Farmer','Lance Henriksen','Michael Wincott','Mili Avital','Crispin Glover','Gabriel Byrne','John Hurt','Alfred Molina','Eugene Byrd','Robert Mitchum','Iggy Pop','Michelle Thrush','Jared Harris','Billy Bob Thornton','Jimmie Ray Weeks','Richard Boes','Mark Bringelson','Steve Buscemi','Todd Pfeiffer','Pete Schrum'],
screenplay:['Jim Jarmusch'],
production:['Demetra J. MacBride'],
music:['Neil Young'],
camera:['Robby Müller'],
cut:['Jay Rabinowitz'],
sound:['Dominick Tavella'],
scenography:['Bob Ziembicki'],
masks:['Neal Martz','Christopher Allen Nelson'],
costumes:['Marit Allen']},
{title:'A Fistful of Dollars',
titleCZ:'Pro hrst dolarů',
year:1964,
runtime:99,
countries:['Italy','Spain','Germany'],
genres:['Western','Action','Drama'],
director:['Sergio Leone'],
actors:['Clint Eastwood','Marianne Koch','Gian Maria Volonté','Wolfgang Lukschy','Sieghardt Rupp','Josef Egger','Antonio Prieto','José Calvo','Margarita Lozano','Daniel Martín','Benito Stefanelli','Mario Brega','Bruno Carotenuto','Aldo Sambrell','Raf Baldassarre','Luis Barboo','Frank Braña','José Canalejas','Juan Cortés','Álvaro de Luna','Nino Del Arco','Joyce Gordon','Lee Miller','Antonio Molino Rojo','Antonio Moreno','Nazzareno Natale','José Orjas','Antonio Pica','Nosher Powell','Julio Pérez Tabernero','José Riesgo','Lorenzo Robledo','Umberto Spadaro','Fernando Sánchez Polack','Antonio Vico','Edmondo Tieghi'],
screenplay:['Sergio Leone','Víctor Andrés Catena','Jaime Comas Gil','Ryûzô Kikushima'],
production:['Arrigo Colombo','Giorgio Papi'],
music:['Ennio Morricone'],
camera:['Massimo Dallamano','Federico G. Larraya'],
cut:['Roberto Cinquini','Alfonso Santacana'],
scenography:['Sigfrido Burmann'],
masks:['Dolores Clavel']},
{title:'The Pink Panther Strikes Again',
titleCZ:'Růžový panter znovu zasahuje',
year:1976,
runtime:103,
countries:['UK','USA'],
genres:['Comedy','Crime'],
director:['Blake Edwards'],
actors:['Peter Sellers','Herbert Lom','Lesley-Anne Down','Burt Kwouk','Colin Blakely','Dudley Sutton','Jerry Stovin','Julie Andrews','Omar Sharif','Jackie Cooper','Deep Roy','Geoffrey Bayldon','Chris Langham','Patrick Jordan','Robert Beatty','Richard Vernon','Bob Sherman','Terence Plummer','Leonard Rossiter','Liz Smith','Phil Brown','Dick Crockett','Damaris Hayman','Terry Richards','Marne Maitland','Briony McRoberts','Vanda Godsell','Norman Mitchell','Tony Sympson','André Maranne','Patsy Smart','Harold Berens','Anthony Chinn','Dinny Powell','Michael Robbins','Hal Galili','Harry Fielder','Graham Stark','Peter Brace','George Leech','Fred Haggerty','Howard K. Smith','Byron Kane','Murray Kash','Gordon Rollings','James Warrior','John Clive'],
screenplay:['Blake Edwards','Frank Waldman'],
production:['Blake Edwards'],
music:['Henry Mancini'],
camera:['Harry Waxman'],
cut:['Alan Jones'],
scenography:['Peter Mullins']},
{title:'The Medusa Touch',
titleCZ:'Dotek Medusy',
year:1978,
runtime:105,
countries:['UK','France'],
genres:['Mystery','Thriller','Horror'],
director:['Jack Gold'],
actors:['Richard Burton','Lino Ventura','Lee Remick','Harry Andrews','Alan Badel','Marie-Christine Barrault','Jeremy Brett','Michael Hordern','Gordon Jackson','Michael Byrne','Derek Jacobi','Robert Flemyng','Philip Stone','Gordon Honeycombe','Robert Lang','Mark Jones','Jennifer Jayne','Frances Tomelty','Shaw Taylor','Victor Windig','Avril Elgar','George Innes','Brook Williams','Malcolm Tierney','Colin Rix','Christopher Burgess','Wendy Gifford',"Maurice O'Connell"],
basedOn:['Peter Van Greenaway'],
screenplay:['John Briley'],
production:['Anne V. Coates'],
music:['Michael J. Lewis'],
camera:['Arthur Ibbetson'],
cut:['Ian Crafford'],
sound:['Nicolas Le Messurier','Ivan Sharrock'],
scenography:['Peter Mullins']},
{title:'The Secret World of Arrietty',
titleCZ:'Arrietty ze světa půjčovníčků',
year:2010,
runtime:94,
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy'],
director:['Hiromasa Jonebajaši'],
actors:['Rjúnosuke Kamiki','Mirai Šida','Kirin Kiki','Tacuja Fudžiwara','Šinobu Ótake','Tomokazu Miura','Keiko Takešita',"Šin'iči Hatori"],
basedOn:['Mary Norton'],
screenplay:['Hajao Mijazaki','Keiko Niwa'],
production:['Tošio Suzuki'],
music:['Cécile Corbel'],
cut:['Rie Macubara','Takeši Sejama','Keiko Kadokawa','Hiromi Sasaki'],
sound:['Kódži Kasamacu'],
scenography:['Jódži Takešige']},
{title:'Jeremiah Johnson',
titleCZ:'Jeremiah Johnson',
year:1972,
runtime:108,
countries:['USA'],
genres:['Western','Drama','Adventure'],
director:['Sydney Pollack'],
actors:['Robert Redford','Will Geer','Delle Bolton','Josh Albee','Joaquín Martínez','Matt Clark','Paul Benedict','Charles Tyner','Allyn Ann McLerie','Stefan Gierasch','Richard Angarola','Jack Colvin','Tanya Tucker'],
basedOn:['Vardis Fisher'],
screenplay:['John Milius','Edward Anhalt','David Rayfiel'],
production:['Joe Wizan'],
music:['Tim McIntire','John Rubinstein'],
camera:['Duke Callaghan'],
cut:['Thomas Stanford'],
scenography:['Ray Molyneaux'],
masks:['Ken Chase','Gary Liddiard'],
costumes:['Wesley Jeffries']},
{title:'The Return',
titleCZ:'Návrat',
year:2003,
runtime:110,
countries:['Russia'],
genres:['Drama','Mystery','Thriller'],
director:['Andrej Zvjagincev'],
actors:['Ivan Dobronravov','Vladimir Garin','Konstantin Lavroněnko','Natalija Vdovina','Peter Rappenglück','Juan Palomino','Jelizaveta Alexandrova','Galina Popova','Alfredo Vasco'],
screenplay:['Vladimir Moisejenko','Alexandr Novotockij-Vlasov'],
production:['Dmitrij Lesněvskij'],
music:['Andrej Dergačev'],
camera:['Michail Kričman']},
{title:'Day for Night',
titleCZ:'Americká noc',
year:1973,
runtime:115,
countries:['France','Italy'],
genres:['Drama','Comedy','Romance'],
director:['François Truffaut'],
actors:['Jacqueline Bisset','Valentina Cortese','Alexandra Stewart','Jean-Pierre Aumont','Jean-Pierre Léaud','François Truffaut','Nathalie Baye','Jean-François Stévenin','Georges Delerue','Pierre Zucca','Xavier Saint-Macary','Jean Champion','Bernard Menez','Graham Greene','Maurice Seveno','Ernest Menzer','Dani','Martine Barraqué','Yann Dedet','Marcel Berbert','Walter Bal','Marc Boyle','David Markham','Nike Arrighi'],
screenplay:['François Truffaut','Jean-Louis Richard','Suzanne Schiffman'],
production:['Marcel Berbert'],
music:['Georges Delerue'],
camera:['Pierre-William Glenn'],
cut:['Martine Barraqué','Yann Dedet'],
sound:['René Levert','Harrik Maury'],
masks:['Fernande Hugi'],
costumes:['Monique Dury']},
{title:'Cactus Flower',
titleCZ:'Kaktusový květ',
year:1969,
runtime:103,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Gene Saks'],
actors:['Walter Matthau','Ingrid Bergman','Goldie Hawn','Jack Weston','Rick Lenz','Vito Scotti','Irene Hervey','Tani Guthrie','Eve Bruce','Jean Lanier','Jean-Marie Juan','Christian Bouillette','Lucy Saroyan','Barbara Randolph','Lee Harris','Frédéric Imberty','Robert Buckingham'],
screenplay:['I.A.L. Diamond','Pierre Barillet','Jean-Pierre Grédy','Abe Burrows'],
production:['M.J. Frankovich'],
music:['Quincy Jones'],
camera:['Charles Lang'],
cut:['Maury Winetrobe'],
scenography:['Robert Clatworthy','Edward G. Boyle'],
costumes:['Moss Mabry']},
{title:'Mother and Child',
titleCZ:'Mother and Child',
year:2009,
runtime:125,
countries:['USA','Spain'],
genres:['Drama','Romance'],
director:['Rodrigo García'],
actors:['Samuel L. Jackson','Naomi Watts','Annette Bening','Kerry Washington','S. Epatha Merkerson','David Ramsey','Shareeka Epps','Gloria Garayua','David Morse','LisaGay Hamilton','Amy Brenneman','Carla Gallo','Tatyana Ali','Marc Blucas','Jimmy Smits','Britt Robertson','Cherry Jones','Elpidia Carrillo','LaTanya Richardson Jackson','Ahmed Best','Eileen Ryan','Michael Warren','Susan Bay Nimoy','Frederick Keeve','Karen Graci'],
screenplay:['Rodrigo García'],
production:['Julie Lynn'],
music:['Edward Shearmur'],
camera:['Xavier Grobet'],
cut:['Steven Weisberg'],
sound:['Andy Nelson'],
scenography:['Christopher Tandon'],
masks:['Michael Germain','Gail Rowell-Ryan'],
costumes:['Susie DeSanto']},
{title:'Rififi',
titleCZ:'Rvačka mezi muži',
year:1955,
runtime:120,
countries:['France'],
genres:['Crime','Drama','Thriller'],
director:['Jules Dassin'],
actors:['Jean Servais','Carl Möhner','Robert Manuel','Jules Dassin','Janine Darcey','Pierre Grasset','Robert Hossein','Marcel Lupovici','Dominique Maurin','Magali Noël','Marie Sabouret','Claude Sylvain','Alain Bouvette','André Dalibert','Jacques David','Émile Genevois','Marcelle Hainia','Daniel Mendaille','Lita Recio','Fernand Sardou','Jacques Besnard','Teddy Bilis','René Hell','Maryse Paillet','Marcel Rouzé'],
basedOn:['Auguste Le Breton'],
screenplay:['René Wheeler'],
production:['Henri Bérard','Pierre Cabaud'],
music:['Georges Auric'],
camera:['Philippe Agostini'],
cut:['Roger Dwyre'],
sound:['Jacques Lebreton'],
scenography:['Alexandre Trauner','Auguste Capelier'],
masks:['Anatole Paris'],
costumes:['Rosine Delamare']},
{title:'To Live',
titleCZ:'Huo zhe',
year:1994,
runtime:125,
countries:['China','Hong Kong'],
genres:['Drama','History','War'],
director:['Yimou Zhang'],
actors:['You Ge','Li Gong','Wu Jiang','Dahong Ni','Tao Guo','Yan Su','Cong Xiao','Tianchi Liu','Lifan Dong'],
basedOn:['Hua Yu'],
screenplay:['Hua Yu','Wei Lu'],
music:['Jiping Zhao'],
camera:['Yue Lü'],
sound:['Jing Tao']},
{title:'The Others',
titleCZ:'Ti druzí',
year:2001,
runtime:100,
countries:['Spain','USA','France','Italy'],
genres:['Horror','Mystery','Thriller','Drama'],
director:['Alejandro Amenábar'],
actors:['Nicole Kidman','Fionnula Flanagan','Christopher Eccleston','Alakina Mann','James Bentley','Eric Sykes','Elaine Cassidy','Keith Allen','Renée Asherson','Michelle Fairley','Gordon Reid'],
screenplay:['Alejandro Amenábar'],
production:['Fernando Bovaira'],
music:['Alejandro Amenábar'],
camera:['Javier Aguirresarobe'],
cut:['Nacho Ruiz Capillas'],
sound:['Ricardo Steinberg','Tim Cavagin','Steve Single'],
scenography:['Benjamín Fernández','Elli Griff'],
masks:['Belén López-Puigcerver'],
costumes:['Sonia Grande']},
{title:'Moulin Rouge!',
titleCZ:'Moulin Rouge',
year:2001,
runtime:127,
countries:['Australia','USA'],
genres:['Musical','Romance','Drama'],
director:['Baz Luhrmann'],
actors:['Nicole Kidman','Ewan McGregor','John Leguizamo','Jim Broadbent','Richard Roxburgh','Garry McDonald','Jacek Koman','Matthew Whittet','Kerry Walker',"Caroline O'Connor",'Christine Anu','Natalie Jackson Mendoza','Lara Mulcahy','David Wenham','Kylie Minogue','Plácido Domingo','Tara Morice','Ozzy Osbourne','Nash Edgerton','Kiruna Stamell','Tim Elliott','Deobia Oparei','Arthur Dignam','Peter Collingwood','Linal Haft','Liliya May','Neeraj Singh','Kip Gamblin','Shaun Parker','Peter Whitford'],
screenplay:['Baz Luhrmann','Craig Pearce'],
production:['Baz Luhrmann'],
music:['Craig Armstrong'],
camera:['Donald McAlpine'],
cut:['Jill Bilcock'],
sound:['Roger Savage','Andy Nelson','Anna Behlmer'],
scenography:['Catherine Martin'],
masks:['Lynn Wheeler','Lesley Vanderwalt','Elka Wardega','Wizzy Molineaux','Aldo Signoretti'],
costumes:['Angus Strathie','Catherine Martin']},
{title:'Hacksaw Ridge',
titleCZ:'Hacksaw Ridge: Zrození hrdiny',
year:2016,
runtime:139,
countries:['Australia','USA'],
genres:['Biographic','War','History','Drama'],
director:['Mel Gibson'],
actors:['Andrew Garfield','Vince Vaughn','Sam Worthington','Luke Bracey','Teresa Palmer','Hugo Weaving','Rachel Griffiths','Milo Gibson','Richard Roxburgh','Nathaniel Buzolic','Ryan Corr','Matt Nable','Goran D. Kleut','Firass Dirani','James Mackay','Ori Pfeffer','Nico Cortez','Damien Thomlinson','Bill Young',"Ben O'Toole",'Benedict Hardie','Raphael Dubois','Harry Greenwood','Ben Mingay','James Lugton','Laurence Brewer','Luke Pegler','Jacob Warner'],
screenplay:['Robert Schenkkan','Andrew Knight'],
production:['William D. Johnson','Brian Oliver','Bruce Davey','Terry Benedict','Paul Currie','David Permut','Tyler Thompson','Bill Mechanic'],
music:['Rupert Gregson-Williams'],
camera:['Simon Duggan'],
cut:['John Gilbert'],
sound:['Robert Mackenzie',"Kevin O'Connell"],
scenography:['Barry Robison'],
masks:['Shane Thomas','Bec Taylor'],
costumes:['Lizzy Gardiner']},
{title:'Cold Mountain',
titleCZ:'Návrat do Cold Mountain',
year:2003,
runtime:155,
countries:['USA','UK','Italy','Rumunsko'],
genres:['Drama','War','Romance'],
director:['Anthony Minghella'],
actors:['Jude Law','Nicole Kidman','Renée Zellweger','Eileen Atkins','Brendan Gleeson','Philip Seymour Hoffman','Natalie Portman','Giovanni Ribisi','Donald Sutherland','Ray Winstone','Kathy Baker','James Gammon','Charlie Hunnam','Jack White','Ethan Suplee','Jena Malone','Melora Walters','Lucas Black','Taryn Manning','James Rebhorn','Emily Deschanel','William Boyer','Erik Smith','Cillian Murphy','Richard Brake','Chet Dixon','Jay Tavare','Mark Jeffrey Miller','Hank Stone','Afemo Omilami','Tom Aldredge','Alex Hassell','Dean Whitworth','Sean Gleeson'],
basedOn:['Charles Frazier'],
screenplay:['Anthony Minghella'],
production:['Albert Berger','Ron Yerxa','Sydney Pollack','William Horberg'],
music:['Gabriel Yared'],
camera:['John Seale'],
cut:['Walter Murch'],
sound:['Eddy Joseph','Michael Prestwood Smith','Ivan Sharrock'],
scenography:['Dante Ferretti','Francesca Lo Schiavo'],
masks:['Jeremy Woodhead','Paul Engelen','Ivana Primorac','Matthew Smith'],
costumes:['Ann Roth','Carlo Poggioli']},
{title:'Misery',
titleCZ:'Misery nechce zemřít',
year:1990,
runtime:107,
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Rob Reiner'],
actors:['James Caan','Kathy Bates','Richard Farnsworth','Frances Sternhagen','Lauren Bacall','Graham Jarvis','J. T. Walsh','Rob Reiner','Archie Hahn','Jerry Potter','Julie Payne','June Christopher'],
basedOn:['Stephen King'],
screenplay:['William Goldman'],
production:['Andrew Scheinman','Rob Reiner'],
music:['Marc Shaiman'],
camera:['Barry Sonnenfeld'],
cut:['Robert Leighton'],
sound:['Gregg Landaker',"Kevin O'Connell"],
scenography:['Norman Garwood'],
masks:['John M. Elliott','Jr.','Howard Berger','Greg Nicotero','Robert Kurtzman'],
costumes:['Gloria Gresham']},
{title:'Leaving Las Vegas',
titleCZ:'Leaving Las Vegas',
year:1995,
runtime:111,
countries:['USA','UK','France'],
genres:['Drama','Romance'],
director:['Mike Figgis'],
actors:['Nicolas Cage','Elisabeth Shue','Julian Sands','Steven Weber','Valeria Golino','Graham Beckel','Carey Lowell','Vincent Ward','Lucinda Jenney','French Stewart','Ed Lauter','Mike Figgis','R. Lee Ermey','Mariska Hargitay','Danny Huston','Laurie Metcalf','Paul Quinn','Shawnee Smith','Bob Rafelson','Xander Berkeley','Michael A. Goorjian','Emily Procter','Thomas Kopache','Richard Lewis','Jeremy Jordan','Gordon Michaels','David Brisbin','Davidlee Willson','Albert Henderson','Anne Lange','Susan Barnes','Waldemar Kalinowski','Lou Rawls','Marc Coppola','Julian Lennon'],
basedOn:["John O'Brien"],
screenplay:['Mike Figgis'],
production:['Lila Cazès','Annie Stewart'],
music:['Mike Figgis'],
camera:['Declan Quinn'],
cut:['John Smith'],
sound:['Pawel Wdowczak'],
scenography:['Waldemar Kalinowski'],
masks:['Linda Hardy'],
costumes:['Laura Goldsmith']},
{title:'Stalker',
titleCZ:'Stalker',
year:1979,
runtime:162,
countries:['Russia'],
genres:['Drama','Sci-Fi','Mystery','Poetic'],
director:['Andrej Tarkovskij'],
actors:['Alexandr Kajdanovskij','Anatolij Solonicyn','Nikolaj Griňko','Alisa Frejndlich','Nataša Abramova','Faime Jurno','Je. Kostin','R. Rendi','Sergej Jakovlev','Mary Murray'],
basedOn:['Arkadij Strugackij','Boris Strugackij'],
screenplay:['Andrej Tarkovskij','Arkadij Strugackij','Boris Strugackij'],
music:['Eduard Nikolajevič Artěmjev'],
camera:['Alexandr Kňažinskij','Georgij Rerberg','Leonid Kalashnikov'],
cut:['Ljudmila Fejginova'],
costumes:['Nelli Fomina']},
{title:'Black Peter',
titleCZ:'Černý Petr',
year:1963,
runtime:86,
countries:['Czechoslovakia'],
genres:['Comedy','Drama'],
director:['Miloš Forman'],
actors:['Ladislav Jakim','Pavla Novotná','Jan Vostrčil','Vladimír Pucholt','Pavel Sedláček','Zdeněk Kulhánek','František Kosina','Josef Koza','Božena Matušková','Antonín Pokorný','Jaroslav Kladrubský','Františka Skálová','Jaroslava Rážová','Majka Gillarová','Hannah Kodicek','Jaroslav Bendl','František Pražák','Dana Urbánková','Josef Abrhám'],
screenplay:['Jaroslav Papoušek','Miloš Forman'],
music:['Jiří Šlitr'],
camera:['Jan Němeček'],
cut:['Miroslav Hájek'],
sound:['Adolf Böhm'],
scenography:['Karel Černý']},
{title:'Ghost in the Shell',
titleCZ:'Ghost in the Shell',
year:1995,
runtime:82,
countries:['Japan'],
genres:['Animation','Action','Sci-Fi','Thriller'],
director:['Mamoru Ošii'],
actors:['Akio Ócuka','Acuko Tanaka','Iemasa Kajumi','Kóiči Jamadera','Tamio Óki','Šigeru Čiba','Teššó Genda','Júdži Ueda','Maaja Sakamoto','Hiroši Janaka','Ginzó Macuo','Micuru Mijamoto','Takaši Macujama','Jutaka Nakano','Masato Jamanouči','Kazuhiro Jamadži','Sanrjó Odaka','Masamiči Sató','Acuši Gotó'],
basedOn:['Masamune Širó'],
screenplay:['Kazunori Itó'],
production:['Ken Ijadomi'],
music:['Kendži Kawai'],
camera:['Hisao Širai'],
cut:['Jajoi Ótake','Šúiči Kakesu','Šigejuki Jamamori']},
{title:'Riders of Justice',
titleCZ:'Rytíři spravedlnosti',
year:2020,
runtime:116,
countries:['Denmark'],
genres:['Comedy','Drama','Thriller'],
director:['Anders Thomas Jensen'],
actors:['Mads Mikkelsen','Nikolaj Lie Kaas','Andrea Heick Gadeberg','Lars Brygmann','Nicolas Bro','Gustav Lindh','Roland Møller','Albert Rudbeck Lindhardt','Anne Birgitte Lind','Omar Shargawi','Jacob Lohmann','Henrik Noél Olesen','Gustav Dyekjær Giese','Klaus Hjuler','Peder Holm Johansen','Rikke Louise Andersson','Jesper Ole Feit Andersen','Morten Suurballe','Stine Schrøder Jensen','Jesper Groth','Natalí Vallespir Sand','Rigmor Ranthe','Anders Nyborg','Johanne Dal-Lewkovitch','Kaspar Velberg','Raivo Trass','Kenny Duerlund','Anne Fletting','Jakob Candy Kolborg','Ghita Lehrmann','Alice Bier Zanden','Mikkel Aarestrup','Christina Ibsen','Patrick Kweku Kværnø Quansah','Natasja Crone'],
screenplay:['Anders Thomas Jensen'],
production:['Sisse Graum Jørgensen','Sidsel Hybschmann'],
music:['Jeppe Kaas'],
camera:['Kasper Tuxen'],
cut:['Anders Albjerg Kristiansen','Nicolaj Monberg'],
sound:['Eddie Simonsen','Henric Andersson','Robert Leib'],
scenography:['Nikolaj Danielsen','Søren Jochumsen'],
masks:['Louise Hauberg Lohmann'],
costumes:['Vibe Knoblauch Hededam']},
{title:'Hotel Mumbai',
titleCZ:'Hotel Mumbai',
year:2018,
runtime:125,
countries:['Australia','USA','UK','India','Singapore'],
genres:['Crime','Drama','History','Thriller'],
director:['Anthony Maras'],
actors:['Armie Hammer','Dev Patel','Jason Isaacs','Nazanin Boniadi','Tilda Cobham-Hervey','Anupam Kher','Natasha Liu Bordizzo','Angus McLaren','Vipin Sharma','Carmen Duncan','Rodney Afif','Nagesh Bhonsle','Carmel Johnson','Vitthal Kale','Alex Pinder','Rohan Mirchandaney','Adithi Kalkunte'],
screenplay:['John Collee','Anthony Maras'],
production:['Gary Hamilton'],
music:['Volker Bertelmann'],
camera:['Nick Remy Matthews'],
sound:['Pete Smith'],
scenography:['Steven Jones-Evans','Nicki Gardiner'],
masks:['Jodee Lenaine-Smith']},
{title:'Jesus Christ Superstar',
titleCZ:'Jesus Christ Superstar',
year:1973,
runtime:108,
countries:['USA'],
genres:['Musical'],
director:['Norman Jewison'],
actors:['Ted Neeley','Carl Anderson','Yvonne Elliman','Barry Dennen','Larry Marshall','Josh Mostel','Paul Thomas','Pi Douglass','Robert LuPone','Richard Molinare','Marcia McBroom','Leeyan Granger'],
basedOn:['Tim Rice'],
screenplay:['Melvyn Bragg','Norman Jewison'],
production:['Norman Jewison','Robert Stigwood'],
music:['Andrew Lloyd Webber'],
camera:['Douglas Slocombe'],
cut:['Antony Gibbs'],
scenography:['Richard Macdonald'],
costumes:['Yvonne Blake','Ron Beck']},
{title:'Sling Blade',
titleCZ:'Smrtící bumerang',
year:1996,
runtime:135,
countries:['USA'],
genres:['Drama','Thriller'],
director:['Billy Bob Thornton'],
actors:['Billy Bob Thornton','Dwight Yoakam','J. T. Walsh','John Ritter','Robert Duvall','Lucas Black','Natalie Canerday','James Hampton','Brent Briscoe','Bruce Hampton','Vic Chesnutt','Mickey Jones','Jim Jarmusch','Gary Don Fletcher'],
screenplay:['Billy Bob Thornton'],
production:['David L. Bushell','Brandon Rosser'],
music:['Daniel Lanois'],
camera:['Barry Markowitz'],
cut:['Hughes Winborne'],
sound:['Gary Alexander'],
scenography:['Clark Hunter','Traci Kirshbaum'],
masks:['Kate Biscoe'],
costumes:['Doug Hall']},
{title:'Living',
titleCZ:'Žít',
year:2022,
runtime:102,
countries:['UK'],
genres:['Drama'],
director:['Oliver Hermanus'],
actors:['Bill Nighy','Alex Sharp','Adrian Rawlins','Hubert Burton','Oliver Chris','Michael Cochrane','Anant Varman','Aimee Lou Wood','Tom Burke','Grant Crookes','Richard Cunningham','Daniel Eghan','Zoe Boyle','Lia Williams'],
screenplay:['Kazuo Ishiguro','Akira Kurosawa'],
production:['Elizabeth Karlsen','Stephen Woolley'],
music:['Emilie Levienaise-Farrouch'],
camera:['Jamie Ramsay'],
cut:['Chris Wyatt'],
sound:['Andy Shelley','Stephen Griffiths'],
scenography:['Helen Scott','Sarah Kane'],
costumes:['Sandy Powell']},
{title:'Ghost in the Shell: Stand Alone Complex - Solid State Society',
titleCZ:'Kókaku kidótai: Stand Alone Complex - Solid State Society',
year:2006,
runtime:105,
countries:['Japan'],
genres:['Animation','Action','Sci-Fi'],
director:['Kendži Kamijama','Tošijuki Kóno'],
actors:['Akio Ócuka','Acuko Tanaka','Kóiči Jamadera','Teššó Genda','Tarusuke Šingaki','Masuo Amada','Eidži Sekiguči','Tóru Nara','Osamu Saka','Jošiko Sakakibara','Sakiko Tamagawa','Jutaka Nakano','Tóru Ókawa','Mantaró Iwao','Taimei Suzuki','Makoto Išii','Taró Jamaguči','Masahiro Ogata','Ken Uo','Eidži Marujama','Keisuke Išida','Tomomi Watanabe','Takaši Onozuka','Eri Óno'],
basedOn:['Masamune Širó'],
screenplay:['Šótaró Suga'],
production:['Tomojasu Nišimura','Hisanori Kunisaki'],
music:['Jóko Kanno'],
camera:['Kódži Tanaka'],
sound:['Kazuhiro Wakabajaši'],
scenography:['Júsuke Takeda']},
{title:'White Hell of Pitz Palu',
titleCZ:'Bílé peklo Piz Palü',
year:1929,
runtime:139,
countries:['Germany'],
genres:['Drama','Action','Adventure'],
director:['Arnold Fanck','Georg Wilhelm Pabst'],
actors:['Gustav Diessl','Leni Riefenstahl','Ernst Petersen','Ernst Udet','Mizzi Götzel','Kurt Gerron'],
screenplay:['Laszló Vajda','Arnold Fanck'],
production:['Harry R. Sokal'],
music:['Giuseppe Becce','Ashley Irwin','Willy Schmidt-Gentner'],
camera:['Hans Schneeberger','Richard Angst','Sepp Allgeier'],
cut:['Arnold Fanck','Hermann Haller'],
scenography:['Ernö Metzner']},
{title:'The Wolf of Wall Street',
titleCZ:'Vlk z Wall Street',
year:2013,
runtime:180,
countries:['USA'],
genres:['Biographic','Comedy','Drama','Crime'],
director:['Martin Scorsese'],
actors:['Leonardo DiCaprio','Jonah Hill','Margot Robbie','Matthew McConaughey','Kyle Chandler','Rob Reiner','Jon Bernthal','Jon Favreau','Jean Dujardin','Joanna Lumley','Cristin Milioti','Christine Ebersole','Shea Whigham','Katarina Cas','P.J. Byrne','Kenneth Choi','Brian Sacca','Henry Zebrowski','Ethan Suplee','Barry Rothbart','Jake Hoffman','MacKenzie Meehan','Bo Dietl','Aya Cash','Rizwan Manji','Stephanie Kurtzuba','J.C. MacKenzie','Ashlie Atkinson','Thomas Middleditch','Stephen Kunken','Edward Herrmann','Jordan Belfort','Ted Griffin','Fran Lebowitz','Robert Clohessy','Natasha Newman-Thomas','Sandra Nelson','Johnnie Mae','Welker White','Danny Flaherty','Ashley Blankenship','Madison McKinley','Dierdre Reimold','Aaron Lazar','Steve Routman','Steve Witting','Michael Nathanson','Dan Bittner','John Behlmann','Ward Horton','Bret Shuford','Steven Boyer','Danny A. Abeckaser','Matthew Rauch','Michael Izquierdo','Donnie Keshawarz','Johnathan Tchaikovsky','Sebastian Tillinger','Chris Riggi','José Ramón Rosario','Davram Stiefler','Dan Daily','Ben Van Bergen','Michael Devine','Jason Furlani','Jeremy Bobb','Sharon Jones','Emily Tremaine','Giselle Eisenberg','Ashley Springer','Remy Bennett','Catherine Curtin','Paul Urcioli','Michael Bryan French','Armen Garo','Louis Vanaria','Peter Youngblood Hills','Brendan Griffin','Victor Verhaeghe','Bekah Mulberg','Ari Barkan','Julian Brand','Bryan Burton','Steve Comisar','Natalie Daniels','Kelsey Deanne','Maria Di Angelis','Rosemary Howard','Marisa Hunter','Spike Jonze','Chris Kerson','Shawlini Manjunath-Holbrook','Nyell','Nicole Rutigliano','Sibyl Santiago','Meredith Riley Stewart','Alex Van Zeelandt','Madeleine Wade','David Wenzel','Darren Whitfield'],
basedOn:['Jordan Belfort'],
screenplay:['Terence Winter'],
production:['Martin Scorsese','Leonardo DiCaprio','Joey McFarland','Emma Tillinger Koskoff'],
music:['Theodore Shapiro'],
camera:['Rodrigo Prieto'],
cut:['Thelma Schoonmaker'],
sound:['Eugene Gearty','Tom Fleischman','Dominick Tavella'],
scenography:['Bob Shaw'],
masks:['Brenna McGuire','Mindy Hall','Michael Marino',"Katherine O'Donnell",'Michael Fontaine'],
costumes:['Sandy Powell']},
{title:'The Big Lebowski',
titleCZ:'Big Lebowski',
year:1998,
runtime:117,
countries:['USA','UK'],
genres:['Comedy','Crime'],
director:['Joel Coen','Ethan Coen'],
actors:['Jeff Bridges','John Goodman','Julianne Moore','Steve Buscemi','David Huddleston','Philip Seymour Hoffman','Tara Reid','Mark Pellegrino','Peter Stormare','Flea','John Turturro','David Thewlis','Mike Gomez','Sam Elliott','Leon Russom','Ben Gazzara','Jon Polito','Warren Keith','Asia Carrera','Lu Elrod','Marshall Manesh','Richard Gant','Torsten Voges','Carlos Leon','Christian Clemenson','Jerry Haleva','Jack Kehler','Luis Colina','Kiva Dawson','Dom Irrera','Ajgie Kirkland'],
screenplay:['Ethan Coen','Joel Coen'],
production:['Ethan Coen','Joel Coen'],
music:['Carter Burwell'],
camera:['Roger Deakins'],
cut:['Ethan Coen','Joel Coen','Tricia Cooke'],
sound:['Skip Lievsay'],
scenography:['Rick Heinrichs','John Dexter'],
masks:['Daniel Curet','Edouard F. Henriques','Jean Ann Black'],
costumes:['Mary Zophres']},
{title:'Interstate 60',
titleCZ:'Interstate 60',
year:2002,
runtime:116,
countries:['Canada','USA'],
genres:['Adventure','Comedy','Drama','Road movie'],
director:['Bob Gale'],
actors:['James Marsden','Gary Oldman','Amy Smart','Christopher Lloyd','Amy Jo Johnson','Ann-Margret','Art Evans','Wayne Robson','Rebecca Jenkins','Chris Cooper','Matthew Edison','John Bourgeois','Daniel Kash','Tyler Kyte','Phillip MacKenzie','Kurt Russell','Leah Renee','Deborah Odell','Michael J. Fox','Mark Lutz','Angela Asher','Duane Murray','John Watson','Ken Kramer','Kedar Brown','Jane Moffat','Jonathan Whittaker','Ted Ludzik','James Downing','Billy Otis','Michael Rhoades','Melyssa Ade','Ho Chow','Katherine Trowell','Nigel Hamer'],
screenplay:['Bob Gale'],
production:['Neil Canton','Peter Newman','Bob Gale','Heidi Levitt','Ira Deutchman'],
music:['Christophe Beck'],
camera:['Denis Maloney'],
cut:['Michael Fallavollita'],
sound:['Todd Beckett'],
scenography:['Rocco Matteo'],
costumes:['Anne Dixon']},
{title:'The Omen',
titleCZ:'Přichází Satan!',
year:1976,
runtime:111,
countries:['USA','UK'],
genres:['Horror','Mystery','Thriller'],
director:['Richard Donner'],
actors:['Gregory Peck','Lee Remick','David Warner','Billie Whitelaw','Harvey Stephens','Patrick Troughton','Martin Benson','John Stride','Freda Dowie','Nicholas Campbell','Leo McKern',"Ya'ackov Banai",'Tommy Duggan','Roy Boyd','Robert Rietty','Harvey Bernhard','Don Fellows','Ronald Leigh-Hunt','Victor Harrington','Juba Kennerley','Betty McDowall','Bruce Boa','Guglielmo Spoletini','Sheila Raynor','Miki Iveria','Patrick McAlinney','Anthony Nicholls'],
screenplay:['David Seltzer'],
production:['Harvey Bernhard'],
music:['Jerry Goldsmith'],
camera:['Gilbert Taylor'],
cut:['Stuart Baird']},
{title:'Gone with the Wind',
titleCZ:'Jih proti Severu',
year:1939,
runtime:224,
countries:['USA'],
genres:['Drama','Romance','War'],
director:['Victor Fleming','George Cukor','Sam Wood'],
actors:['Clark Gable','Vivien Leigh','Leslie Howard','Olivia de Havilland','Thomas Mitchell',"Barbara O'Neil",'Evelyn Keyes','Ann Rutherford','George Reeves','Fred Crane','Hattie McDaniel','Oscar Polk','Butterfly McQueen','Victor Jory','Everett Brown','Howard C. Hickman','Alicia Rhett','Rand Brooks','Carroll Nye','Laura Hope Crews',"Eddie 'Rochester' Anderson",'Harry Davenport','Leona Roberts','Jane Darwell','Ona Munson','Paul Hurst','Isabel Jewell','Cammie King Conlon','Eric Linden','J.M. Kerrigan','Ward Bond','Jackie Moran','Cliff Edwards','Yakima Canutt','Louis Jean Heydt','Mickey Kuhn','Olin Howland','Irving Bacon','Robert Elliott','William Bakewell','Mary Anderson','Eric Alden','John Arledge','Roscoe Ates','Trevor Bardette','Ralph Brooks','James Bush','Horace B. Carpenter','Louise Carter','Eddy Chandler','Wallis Clark','Frank Coghlan Jr.','Jim Corey','Gino Corrado','Kernan Cripps','Patrick Curtis','Russell Custer',"Yola d'Avril",'Lester Dorr','Richard Farnsworth','Frank Faylen','Chuck Hamilton','Shep Houghton','Claire James','Si Jenks','Tommy Kelly','Emmett King','Margaret Mann','Caren Marsh','George Meeker','Charles Middleton','Hans Moebus','Alberto Morin','Adrian Morris','David Newell','Lee Phelps','Marjorie Reynolds','Suzanne Ridgway','Scott Seaton','William Stack','William Stelling','Harry Strang','Tom Tyler','Dale Van Sickel','E. Alyn Warren','Blue Washington','Dan White','Ernest Whitman','Guy Wilkerson','John Wray','Dirk Wayne Summers','George Hackathorne'],
basedOn:['Margaret Mitchell'],
screenplay:['Sidney Howard'],
production:['David O. Selznick'],
music:['Max Steiner'],
camera:['Ernest Haller','Lee Garmes'],
cut:['Hal C. Kern'],
sound:['Frank Maher'],
scenography:['William Cameron Menzies','Lyle R. Wheeler','Howard Bristol'],
masks:['Monte Westmore','Paul Stanhope'],
costumes:['Walter Plunkett']},
{title:'Hannah and Her Sisters',
titleCZ:'Hana a její sestry',
year:1986,
runtime:103,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Woody Allen'],
actors:['Barbara Hershey','Carrie Fisher','Michael Caine','Mia Farrow','Dianne Wiest',"Maureen O'Sullivan",'Lloyd Nolan','Max von Sydow','Woody Allen','Lewis Black','Julia Louis-Dreyfus','Julie Kavner','J. T. Walsh','John Turturro','Richard Jenkins','Fred Melamed','Daniel Stern','Paul Bates','Tony Roberts','Sam Waterston','Joanna Gleason','Christian Clemenson','Ira Wheeler','Soon-Yi Previn'],
screenplay:['Woody Allen'],
production:['Robert Greenhut'],
camera:['Carlo Di Palma'],
cut:['Susan E. Morse'],
sound:['Lee Dichter','Tod A. Maitland'],
scenography:['Stuart Wurtzel'],
costumes:['Jeffrey Kurland']},
{title:'Hombre',
titleCZ:'Hombre',
year:1967,
runtime:111,
countries:['USA'],
genres:['Western','Drama'],
director:['Martin Ritt'],
actors:['Paul Newman','Fredric March','Richard Boone','Diane Cilento','Cameron Mitchell','Barbara Rush','Peter Lazer','Margaret Blye','Martin Balsam','Skip Ward','Frank Silvera','David Canary','Val Avery','Larry Ward'],
basedOn:['Elmore Leonard'],
screenplay:['Irving Ravetch','Harriet Frank Jr.'],
production:['Martin Ritt','Irving Ravetch'],
music:['David Rose'],
camera:['James Wong Howe'],
cut:['Frank Bracht'],
sound:['John R. Carter'],
scenography:['Walter M. Scott','Jack Martin Smith'],
masks:['Ben Nye'],
costumes:['Donfeld']},
{title:'The Call of the Wild',
titleCZ:'Volání divočiny',
year:2020,
runtime:100,
countries:['USA'],
genres:['Adventure','Drama','Family'],
director:['Chris Sanders'],
actors:['Harrison Ford','Omar Sy','Dan Stevens','Karen Gillan','Bradley Whitford','Cara Gee','Colin Woodell','Scott MacDonald','Terry Notary','Jean Louisa Kelly','Wes Brown','Preston Bailey','Stephanie Czajkowski','Adam Fergus','Michael Horse','Brad Greenquist','Karl Makinen','Larry Cedar','Anthony Molinari','Micah Fitzgerald','Mac Jarman','Alex Solowitz','Paul Mabon','Christopher Blanchard','Douglas M. Eames','Raven Scott','Britt Bankhead','Greg Tarzan Davis','Shantiel Alexis Vazquez','Ashley Brant','Adam Zastrow'],
basedOn:['Jack London'],
screenplay:['Michael Green'],
production:['Erwin Stoff','James Mangold'],
music:['John Powell'],
camera:['Janusz Kamiński'],
cut:['David Heinz','William Hoy'],
sound:['David Giammarco'],
scenography:['Stefan Dechant','Danielle Berman'],
masks:['Mike Smithson'],
costumes:['Kate Hawley']},
{title:'The Virgin Spring',
titleCZ:'Pramen panny',
year:1960,
runtime:87,
countries:['Sweden'],
genres:['Drama'],
director:['Ingmar Bergman'],
actors:['Max von Sydow','Birgitta Valberg','Gunnel Lindblom','Birgitta Pettersson','Axel Düberg','Tor Isedal','Allan Edwall','Ove Porath','Axel Slangus','Gudrun Brost','Oscar Ljung','Tor Borong'],
screenplay:['Ulla Isaksson'],
production:['Ingmar Bergman','Allan Ekelund'],
music:['Erik Nordgren'],
camera:['Sven Nykvist'],
cut:['Oscar Rosander'],
sound:['Aaby Wedin'],
scenography:['P.A. Lundgren'],
masks:['Börje Lundh'],
costumes:['Marik Vos-Lundh']},
{title:'The Miracle Worker',
titleCZ:'Divotvůrkyně',
year:1962,
runtime:106,
countries:['USA'],
genres:['Drama','Biographic'],
director:['Arthur Penn'],
actors:['Anne Bancroft','Victor Jory','Inga Swenson','Andrew Prine','Kathleen Comegys','Patty Duke','Beah Richards','Jack Hollander','John Bliss'],
basedOn:['Helen Keller'],
screenplay:['William Gibson','William Gibson'],
production:['Fred Coe'],
music:['Laurence Rosenthal'],
camera:['Ernesto Caparrós'],
cut:['Aram Avakian'],
sound:['Dick Vorisek'],
costumes:['Ruth Morley']},
{title:'Basic Instinct',
titleCZ:'Základní instinkt',
year:1992,
runtime:127,
countries:['USA','France'],
genres:['Thriller','Drama','Erotic','Mystery','Crime'],
director:['Paul Verhoeven'],
actors:['Michael Douglas','Sharon Stone','George Dzundza','Jeanne Tripplehorn','Denis Arndt','Leilani Sarelle','Bruce A. Young','Chelcie Ross','Dorothy Malone','Wayne Knight','Daniel von Bargen','Stephen Tobolowsky','Benjamin Mouton','Jack McGee','Stephen Rowe','Mitch Pileggi','Mary Pat Gleason','Freda Foh Shen','James Rebhorn','David Wells','Bradford English','Adilah Barnes','Juanita Jennings','Michael David Lally','Peter Appel','Kayla Blake','Anne Lockhart','Damon Stout'],
screenplay:['Joe Eszterhas'],
production:['Alan Marshall'],
music:['Jerry Goldsmith'],
camera:['Jan de Bont'],
cut:['Frank J. Urioste'],
sound:['Carlos Delarios'],
scenography:['Terence Marsh'],
masks:['Rob Bottin'],
costumes:['Ellen Mirojnick']},
{title:'The War of the Roses',
titleCZ:'Válka Roseových',
year:1989,
runtime:112,
countries:['USA'],
genres:['Comedy','Drama'],
director:['Danny DeVito'],
actors:['Michael Douglas','Kathleen Turner','Danny DeVito','Marianne Sägebrecht','Sean Astin','Heather Fairfield','G. D. Spradlin','Peter Donat','Dan Castellaneta','Gloria Cromwell','Lisa Howard','Peter Hansen','Peter Brocco','Shirley Mitchell','Roy Brocksmith','Robert Harper','David Wohl','Ellen Crawford','Vickilyn Reynolds','Danitra Vance','Mary Fogarty','Susan Isaacs','Tony Crane','Prince Hughes','Rika Hofmann'],
basedOn:['Warren Adler'],
screenplay:['Michael Leeson'],
production:['Arnon Milchan','James L. Brooks'],
music:['David Newman'],
camera:['Stephen H. Burum'],
cut:['Lynzee Klingman'],
scenography:['Ida Random','Anne D. McCulley'],
masks:['John M. Elliott','Jr.','Stephen Abrums'],
costumes:['Gloria Gresham']},
{title:'Cabaret',
titleCZ:'Kabaret',
year:1972,
runtime:124,
countries:['USA'],
genres:['Drama','Musical','Music','Romance'],
director:['Bob Fosse'],
actors:['Liza Minnelli','Michael York','Helmut Griem','Joel Grey','Fritz Wepper','Marisa Berenson','Ralf Wolter','Helen Vita','Ellen Umlauf','Pierre Franckh','Elisabeth Neumann-Viertel','Gerd Vespermann','Gitta Schmidt','Oliver Collignon','Georg Hartmann'],
screenplay:['Jay Presson Allen'],
production:['Cy Feuer'],
music:['John Kander','Ralph Burns'],
camera:['Geoffrey Unsworth'],
cut:['David Bretherton'],
scenography:['Rolf Zehetbauer'],
costumes:['Charlotte Flemming']},
{title:"The Devil's Trap",
titleCZ:'Ďáblova past',
year:1961,
runtime:87,
countries:['Czechoslovakia'],
genres:['Drama'],
director:['František Vláčil'],
actors:['Miroslav Macháček','Vítězslav Vejražka','Čestmír Řanda st.','Karla Chadimová','Vít Olmer','Vlastimil Hašek','Bedřich Karen','František Kovářík','Zdeněk Kutil','Jaroslav Moučka','Ladislav Kazda','Jiří Vršťala','Josef Hlinomaz','Dagmar Kofroňová','Richard Záhorský','Viktor Očásek','Zlatomír Vacek','František Nechyba','Milan Kindl','Jiřina Bílá','Jiří Bělohoubek','Antonín Novotný','Monika Indingerová','Pavla Plášková','V. Bakalářová','Holohlavská','J. Skružný'],
basedOn:['Alfréd Technik'],
screenplay:['František A. Dvořák','Miloš Václav Kratochvíl'],
music:['Zdeněk Liška'],
camera:['Rudolf Milič'],
cut:['Miroslav Hájek'],
sound:['František Fabián','Bohumír Brunclík'],
scenography:['Karel Škvor'],
masks:['Vladimír Černý'],
costumes:['Theodor Pištěk ml.']},
{title:'J.S.A.: Joint Security Area',
titleCZ:'Pohraniční pásmo',
year:2000,
runtime:110,
countries:['South Korea'],
genres:['Drama','Thriller','War'],
director:['Čchan-uk Pak'],
actors:['Byung-hun Lee','Kang-ho Song','Tae-woo Kim','Yeong-ae Lee','Ha-kyun Shin','Joo-bong Ki','Tae-hyeon Jin','Han-wi Lee','Myeong-soo Kim','So-young Ko','Herbert Ulrich','Christoph Hofrichter'],
basedOn:['Sang-yeon Park'],
screenplay:['Hyeon-seok Kim','Moo-yeong Lee','Čchan-uk Pak'],
music:['Jun-seok Bang','Yeong-wook Jo'],
camera:['Sung-bok Kim'],
sound:['Kim Suk-won']},
{title:'Lost in the Suburbs',
titleCZ:'Návrat domů',
year:1948,
runtime:92,
countries:['Czechoslovakia'],
genres:['Drama','War'],
director:['Martin Frič'],
actors:['Karel Höger','Běla Jurdová','Josef Pehr','František Smolík','Terezie Brzková','Zdenka Procházková','Zdeněk Štěpánek','Milada Smolíková','Libuše Zemková','Ladislav Kulhánek','Ella Nollová','Ota Motyčka','Marie Blažková','Alois Dvorský','Miloš Kopecký','Bohuš Hradil','Jaroslav Mareš','Blažena Slavíčková','Vladimír Řepa','Bedřich Bozděch','Jindra Hermanová','Josef Kemr','Michaela Lišková','Hermína Vojtová','Emil Bolek','Zdeněk Řehoř','Milka Balek-Brodská','Marta Májová','Karel Houska','Zdeněk Flendr','Otylie Beníšková','Ervín Zolar','Jan W. Speerger','Ilja Racek','Leo Spáčil','Josef Hořánek','Josef Steigl','Pavla Suchá','Ferdinand Jarkovský','Jindřich Doležal'],
screenplay:['Leopold Lahola','Miloš Řehák','Ludvík Toman'],
music:['František Škvor'],
camera:['Karel Degl'],
cut:['Jan Kohout'],
sound:['Miloslav Hůrka'],
scenography:['Karel Škvor'],
masks:['Ladislav Bacílek'],
costumes:['Marie Jindrová']},
{title:'Mephisto',
titleCZ:'Mefisto',
year:1981,
runtime:154,
countries:['Germany','Hungary','Austria'],
genres:['Drama'],
director:['István Szabó'],
actors:['Klaus Maria Brandauer','Krystyna Janda','Ildikó Bánsági','Rolf Hoppe','György Cserhalmi','Péter Andorai','Karin Boyd','Christine Harbort','Tamás Major','Christian Grashof','Géza Kovács','Judit Hernádi','Martin Hellberg','Teri Tordai','Irén Bordán','János Xantus','Hédi Temessy','Oszkár Gáti','Katalin Sólyom','István Szabó','Vilmos Kun','János Dömölky','György Bánffy','Hans Ulrich Laufer','Mónika Bognár','Ildikó Kishonti','Mária Bisztrai','Sándor Lukács','Ágnes Bánfalvy','Ida Versényi','István Komlós','Zdzisław Mrożewski','Stanislava Strobachová','Károly Ujlaky','Tamás Balikó','Ödön Rubold','István Palotai','Bertalan Papp','Katalin Fráter','Mária Fekete','Tamás Fésűs','Oszkárné Gombik','Magda Kalmár','István Karsai','Bazsa Kiss','Géza Laczkovich','György Lencz','József Lukácsi','Lajos Mezey','Fruzsina Pregitzer','Gizella Ramshorn','András Sebestyén','Mihály Szacsky','Erzsi Sándor','Péter Tihanyi','Tamás Tóth','Katalin Varga','Imre Zvoronics'],
basedOn:['Klaus Mann'],
screenplay:['Péter Dobai','István Szabó'],
production:['Manfred Durniok'],
music:['Zdenkó Tamássy','Karl Millöcker'],
camera:['Lajos Koltai'],
cut:['Zsuzsa Csákány'],
sound:['György Fék'],
scenography:['József Romvári','János P. Nagy'],
masks:['Edit Basilides','Rozália Szegedi'],
costumes:['Ágnes Gyarmathy']},
{title:'Shaun of the Dead',
titleCZ:'Soumrak mrtvých',
year:2004,
runtime:99,
countries:['UK','France','USA'],
genres:['Action','Comedy','Horror'],
director:['Edgar Wright'],
actors:['Simon Pegg','Kate Ashfield','Nick Frost','Lucy Davis','Dylan Moran','Peter Serafinowicz','Bill Nighy','Jessica Hynes','Penelope Wilton','Martin Freeman','Reece Shearsmith','Chris Martin','Jon Buckland','Edgar Wright','Mark Gatiss','Paul Kaye','Tamsin Greig','Rob Brydon','Joe Cornish','David Walliams','Julia Deakin','Patricia Franklin','Rafe Spall','Julia Davis','Michael Smiley','Antonia Campbell-Hughes','Lauren Laverne','Nick Ewans','Lucy Akhurst','Phyllis Mcmahon','Thomas Hodge','Sharon Gavin','Tony Cook','Paul Putner','Finola Geraghty','Steve Emerson','Philippe Spall','Iain Kitching',"Michael O'Mahony"],
screenplay:['Edgar Wright','Simon Pegg'],
production:['Nira Park','Alison Owen','Eric Fellner'],
music:['Dan Mudford','Pete Woodhead'],
camera:['David M. Dunlap'],
cut:['Chris Dickens'],
sound:['Julian Slater','Simon Hayes'],
scenography:['Marcus Rowland'],
masks:['Jane Walker','Barrie Gower'],
costumes:['Annie Hardinge']},
{title:'Hilary and Jackie',
titleCZ:'Hilary a Jackie',
year:1998,
runtime:121,
countries:['UK'],
genres:['Drama','Music','Biographic'],
director:['Anand Tucker'],
actors:['Emily Watson','Rachel Griffiths','James Frain','David Morrissey','Charles Dance','Celia Imrie','Rupert Penry-Jones','Bill Paterson','Nyree Dawn Porter','Vernon Dobtcheff','Jon Rumney','Stella Maris','Robert Rietty','Carla Mendonça','Anthony Smee','Kika Mirylees','Heather Weeks','Oliver Lee'],
screenplay:['Frank Cottrell Boyce'],
production:['Andy Paterson'],
music:['Barrington Pheloung'],
camera:['David Johnson'],
cut:['Martin Walsh'],
sound:['Julian Slater','David Crozier'],
scenography:['Alice Normington'],
masks:['Lois Burwell'],
costumes:['Sandy Powell']},
{title:'The Young and the Damned',
titleCZ:'Zapomenutí',
year:1950,
runtime:80,
countries:['Mexico'],
genres:['Drama','Crime'],
director:['Luis Buñuel'],
actors:['Estela Inda','Miguel Inclán','Alfonso Mejía','Roberto Cobo','Francisco Jambrina','Victorio Blanco','Charles Rooner','Diana Ochoa','José López','Alma Delia Fuentes','Enedina Díaz de León','Lupe Carriles','Salvador Quiroz','Ramón Sánchez','Miguel Funes hijo','José Loza','Ignacio Solorzano','Inés Murillo','Ángel Merino','Antonio Martínez','Héctor López Portillo','Jesús García','Francisco Muller','Antulio Jiménez Pons','Ernesto Alonso'],
screenplay:['Luis Buñuel','Pedro de Urdimalas','Max Aub'],
production:['Sergio Kogan','Óscar Dancigers'],
music:['Rodolfo Halffter'],
camera:['Gabriel Figueroa'],
cut:['Carlos Savage'],
scenography:['Edward Fitzgerald'],
masks:['Armando Meyer']},
{title:'I Want to Eat Your Pancreas',
titleCZ:'Kimi no suizó o tabetai',
year:2018,
runtime:108,
countries:['Japan'],
genres:['Animation','Romance'],
director:["Šin'ičiró Ušidžima"],
actors:['Mahiro Takasugi',"Šin'ičiró Miki",'Acuko Tanaka','Džun Fukušima','Jukijo Fudžii','Emi Wakui','Júma Učida','Lynn','Saja Mikami','Reió Cučida','Nene Hieda','Jurina Amami','Andžu Nitta','Nanami Acugi','Kótaró Išikawa','Momoko Notomi'],
basedOn:['Joru Sumino'],
screenplay:["Šin'ičiró Ušidžima"],
production:['Šin`ičiró Kašiwada'],
music:['Hiroko Sebu'],
camera:['Majuko Koike'],
cut:['Jumi Džingudži'],
sound:['Šódži Hata'],
scenography:['Jukako Ogawa']},
{title:'How to Drown Dr. Mracek, the Lawyer',
titleCZ:'Jak utopit Dr. Mráčka aneb Konec vodníků v Čechách',
year:1974,
runtime:96,
countries:['Czechoslovakia'],
genres:['Comedy','Fantasy'],
director:['Václav Vorlíček'],
actors:['Libuše Šafránková','Jaromír Hanzlík','František Filipovský','Miloš Kopecký','Vladimír Menšík','Zdeněk Řehoř','Stella Zázvorková','Eva Hudečková','Čestmír Řanda st.','Míla Myslíková','Vlastimil Hašek','Jiří Hrzán','Miroslav Masopust','Gabriela Wilhelmová','Milena Steinmasslová','Dáša Neblechová','Lucie Žulová','Jiří Lír','Lubomír Kostelka','Bedřich Prokoš','Oldřich Velen','Karel Hovorka st.','František Miroslav Doubrava','Raoul Schránil','Miloš Vavruška','Ilona Jirotková','Mirko Musil','Karel Augusta','Jan Cmíral st.','Karel Vavřík','Jiřina Bílá','Adolf Filip','Vítězslav Černý','Valerie Čižmárová','Zdeněk Braunschläger','Karel Houska','Petr Hanus','Miloslav Homola','Miroslav Čermák','Stanislav Hájek','Gustav Bubník','Václav Štercl','Jan Kraus','Luďa Marešová','Arnošt Proschek','Zdeněk Skalický','Jiří Vašků','Jan Janků','Rudolf Růžička','Miroslav Svoboda','Jan Krafka','Vladimír Ptáček','Jiří Suchánek','Ludvík Wolf','Antonín Filípek','Pavel Kužela','František Horek','Jaromír Laštovka','Karel Schumpeter','Jaroslav Sus','Karel Engel','Bert Schneider','Eva Hnátková','Jitka Nováková','Max Kulhavý','Zdeněk Straka'],
screenplay:['Miloš Macourek','Petr Markov','Václav Vorlíček'],
music:['Vítězslav Hádl'],
camera:['Vladimír Novotný'],
cut:['Miroslav Hájek'],
sound:['František Fabián'],
scenography:['Oldřich Bosák'],
masks:['Josef Lojík'],
costumes:['Theodor Pištěk ml.','Magdalena Lautnerová']},
{title:'Atonement',
titleCZ:'Pokání',
year:2007,
runtime:123,
countries:['UK','France'],
genres:['Drama','Romance','War','Mystery'],
director:['Joe Wright'],
actors:['James McAvoy','Keira Knightley','Romola Garai','Saoirse Ronan','Vanessa Redgrave','Brenda Blethyn','Juno Temple','Benedict Cumberbatch','Patrick Kennedy','Harriet Walter','Peter Wight','Daniel Mays','Nonso Anozie','Gina McKee','Jérémie Renier','Michelle Duncan','Alfie Allen','Michel Vuillermoz','Lionel Abelanski','Tobias Menzies','Bronson Webb','Jamie Beamish','Johnny Harris','Neil Maskell','Alice Orr-Ewing','Angel Witney','Anthony Minghella','Elliott Francis','Ailidh Mackay','Kelly Scott','Tilly Vosburgh','Georgia Oakley','Ian Bonar','Oliver Gilbert','Wendy Nottingham'],
basedOn:['Ian McEwan'],
screenplay:['Christopher Hampton'],
production:['Tim Bevan','Paul Webster','Eric Fellner'],
music:['Dario Marianelli'],
camera:['Seamus McGarvey'],
cut:['Paul Tothill'],
sound:['Martin Jensen'],
scenography:['Sarah Greenwood','Katie Spencer'],
masks:['Ivana Primorac','Lizzie Yianni Georgiou','Norma Webb'],
costumes:['Jacqueline Durran']},
{title:'Magnolia',
titleCZ:'Magnolia',
year:1999,
runtime:188,
countries:['USA'],
genres:['Drama'],
director:['Paul Thomas Anderson'],
actors:['Julianne Moore','William H. Macy','John C. Reilly','Tom Cruise','Philip Baker Hall','Philip Seymour Hoffman','Jason Robards','Alfred Molina','Melora Walters','Michael Bowen','Ricky Jay','Jeremy Blackman','Melinda Dillon','April Grace','Luis Guzmán','Henry Gibson','Felicity Huffman','Orlando Jones','Michael Murphy','Neil Flynn','Thomas Jane','Veronica Hart','Cleo King','John S. Davies','Neil Pepe','Meagen Fay','Natalie Marston','Clark Gregg','Matt Gerald','Paul F. Tompkins','Mary Lynn Rajskub','Jim Beaver','Ezra Buzzington','Robert Downey Sr.','William Mapother','Scott Alan Smith','Miriam Margolyes','Michael Shamus Wiles','Pat Healy','Patton Oswalt','Don McManus','Patricia Scanlon','Eileen Ryan','Kevin Breznahan','Brad Hunt','Lillian Adams','Art Frankel','Allan Graf','Rod McLachlan','Miguel Pérez','Jim Ortlieb','Patrick Warren','Danny Wells','John Pritchett','Patricia Forte','Jason Andrews','Cory Buck','Emmanuel Johnson','Greg Bronson','James Kiriyama-Lem','Tom Ohmer'],
screenplay:['Paul Thomas Anderson'],
production:['Paul Thomas Anderson','JoAnne Sellar'],
music:['Jon Brion','Aimee Mann'],
camera:['Robert Elswit'],
cut:['Dylan Tichenor'],
sound:['Richard King','Michael Semanick','Steve Pederson'],
scenography:['William Arnold'],
masks:['Joann Kozloff','Christopher Allen Nelson'],
costumes:['Mark Bridges']},
{title:'The Big Blue',
titleCZ:'Magická hlubina',
year:1988,
runtime:132,
countries:['France','USA','Italy'],
genres:['Drama','Romance','Adventure'],
director:['Luc Besson'],
actors:['Rosanna Arquette','Jean-Marc Barr','Jean Reno','Paul Shenar','Sergio Castellitto','Jean Bouise','Griffin Dunne','Valentina Vargas','Eric Do','Luc Besson','Paul Herman','Kimberly Beck','Pierre Semmler','Geoffrey Carey','Marc Duret','Sheila McLaughlin','Claude Robin','Jan Rouiller','Franco Diogene','Andréas Voutsinas','John Erdman','Christian Gazio'],
screenplay:['Luc Besson','Marc Perrier','Robert Garland','Jacques Mayol','Marilyn Goldin'],
production:['Patrice Ledoux'],
music:['Bill Conti','Eric Serra'],
camera:['Carlo Varini'],
cut:['Olivier Mauffroy'],
scenography:['Dan Weil'],
masks:['Geneviève Peyralade'],
costumes:['Magali Guidasci','Martine Rapin','Mimi Lempicka','Blandine Boyer','Malika Khelfa','Brigitte Nierhaus','Patricia Saalburg']},
{title:'Inside the Ku Klux Klan',
titleCZ:'Neobyčejný kluk',
year:2015,
runtime:47,
countries:['UK'],
genres:['Document'],
director:['Daniel Vernon']},
{title:'The Remains of the Day',
titleCZ:'Soumrak dne',
year:1993,
runtime:134,
countries:['USA','UK'],
genres:['Drama','Romance'],
director:['James Ivory'],
actors:['Anthony Hopkins','Emma Thompson','James Fox','Christopher Reeve','Peter Vaughan','Hugh Grant','Michael Lonsdale','Tim Pigott-Smith','Patrick Godfrey','Peter Cellier','Ben Chaplin','Paul Copley','Peter Eyre','Lena Headey','Pip Torrens','Rupert Vansittart','Paula Jacobs','Peter Halliday','Terence Bayler','Jeffry Wickham','John Savident','Tony Aitken','Christopher Brown','Jo Kendall','Frank Shelley','Jestyn Phillips','Wolf Kahler','Miles Richardson'],
basedOn:['Kazuo Ishiguro'],
screenplay:['Ruth Prawer Jhabvala'],
production:['John Calley','Mike Nichols','Ismail Merchant'],
music:['Richard Robbins'],
camera:['Tony Pierce-Roberts'],
cut:['Andrew Marcus'],
scenography:['Luciana Arrighi','Ian Whittaker'],
masks:['Norma Webb'],
costumes:['Jenny Beavan','John Bright']},
{title:'East of Eden',
titleCZ:'Na východ od ráje',
year:1955,
runtime:115,
countries:['USA'],
genres:['Drama'],
director:['Elia Kazan'],
actors:['Julie Harris','James Dean','Raymond Massey','Burl Ives','Richard Davalos','Jo Van Fleet','Albert Dekker','Lois Smith','Harold Gordon','Nick Dennis','Abdullah Abbas','Frank Baker','Barbara Baxley','John Beradino','Joe Brooks','Nora Bush','Timothy Carey','Jack Carr','Wheaton Chambers','Lonny Chapman','Edward Clark','Harry Cording','Lester Dorr','Franklyn Farnum','Al Ferguson','Robert Foulk','Richard Garrick','John George','John Halloran','Sam Harris','Jonathan Haze','Ramsay Hill','Earle Hodgins','Tex Holden','Charles Anthony Hughes','Frank Mazzola','Philo McCullough','Ken Miller','Artie Ortego','Gil Perkins',"William 'Bill' Phillips",'Rose Plumer','Julian Rivero','Henry Rowland','Scott Seaton','Charles Sherlock','Mario Siletti','Hal Taggart','Sid Troy','Sailor Vincent','Max Wagner','Chalky Williams'],
basedOn:['John Steinbeck'],
screenplay:['Paul Osborn'],
production:['Elia Kazan'],
music:['Leonard Rosenman'],
camera:['Ted D. McCord'],
cut:['Owen Marks'],
sound:['Stanley Jones'],
scenography:['James Basevi','Malcolm C. Bert'],
masks:['Gordon Bau','Robert Ewing'],
costumes:['Anna Hill Johnstone']},
{title:'Play It Again, Sam',
titleCZ:'Zahraj to znovu, Same',
year:1972,
runtime:85,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Herbert Ross'],
actors:['Woody Allen','Diane Keaton','Tony Roberts','Jerry Lacy','Susan Anspach','Jennifer Salt','Ted Markland','Mark Goddard','Viva','Frances Tomelty','Michael Greene','Joy Bang','Susanne Zenor'],
screenplay:['Woody Allen','Woody Allen'],
production:['Arthur P. Jacobs'],
music:['Billy Goldenberg'],
camera:['Owen Roizman'],
cut:['Marion Rothman'],
scenography:['Ed Wittstein'],
costumes:['Anna Hill Johnstone']},
{title:'Werckmeister Harmonies',
titleCZ:'Werckmeisterovy harmonie',
year:2000,
runtime:145,
countries:['Hungary','Italy','Germany','France'],
genres:['Mystery','Drama'],
director:['Béla Tarr','Ágnes Hranitzky'],
actors:['Lars Rudolph','Peter Fitz','Hanna Schygulla','János Derzsi','Džoko Rosič','Ferenc Kállai','György Barkó','Attila Kaszás','Péter Dobai','Mátyás Dráfi','Mihály Kormos','Tamás Wichmann','József Szántó'],
basedOn:['László Krasznahorkai'],
screenplay:['László Krasznahorkai','Béla Tarr'],
production:['Joachim von Vietinghoff'],
music:['Mihály Víg'],
camera:['Gábor Medvigy','Rob Tregenza','Erwin Lanzensberger'],
sound:['György Kovács','Ralf Krause']},
{title:'Harry Potter and the Deathly Hallows: Part 2',
titleCZ:'Harry Potter a Relikvie smrti - část 2',
year:2011,
runtime:125,
countries:['UK','USA'],
genres:['Adventure','Drama','Family','Fantasy'],
director:['David Yates'],
actors:['Daniel Radcliffe','Emma Watson','Rupert Grint','Helena Bonham Carter','Bonnie Wright','Maggie Smith','Evanna Lynch','Robbie Coltrane','Alan Rickman','Geraldine Somerville','Natalia Tena','Kelly Macdonald','Tom Felton','Emma Thompson','Ralph Fiennes','Michael Gambon','Gary Oldman','Jason Isaacs','Domhnall Gleeson','John Hurt','Ciarán Hinds','David Thewlis','Clémence Poésy','Helen McCrory','Jim Broadbent','Julie Walters','James Phelps','Matthew Lewis','Oliver Phelps','Jessie Cave','Miriam Margolyes','Mark Williams','Adrian Rawlins','Nick Moran','Sean Biggerstaff','Warwick Davis','Katie Leung','Gemma Jones','Scarlett Hefner','Anna Shaffer','Isabella Laughland','Chris Rankin','Devon Murray','Louis Cordice','Josh Herdman','Ryan Turner','Alfred Enoch','Afshan Azad','Guy Henry','David Bradley','Georgina Leonidas','Freddie Stroma','Robbie Jarvis','Emil Hostina','George Harris','William Melling','Arthur Bowen','Daphne de Beistegui','Helena Barlow','Dave Legeno','Grace Meurisse Francis','Jamie Campbell Bower','Bertie Gilbert','Ralph Ineson','David Heyman','David Barron','Maxwell Laird','Valerie Dane','Jade Gordon','Jon Campling','Graham Duff','Ian Peck','Ninette Finch','Hebe Beardsall',"Sha'ori Morris",'Benn Northover','Jon Key','Joe Kallis','Craig Garner','Ashley McGuire','Marianne Chase','Annabelle Davis'],
basedOn:['J. K. Rowling'],
screenplay:['Steve Kloves'],
production:['J. K. Rowling','David Heyman','David Barron'],
music:['Alexandre Desplat'],
camera:['Eduardo Serra'],
cut:['Mark Day'],
sound:['James Mather','Dominic Gibbs','Michael Fentum'],
scenography:['Stuart Craig','Andrew Ackland-Snow','Stephenie McMillan'],
masks:['Nick Dudman','Amanda Knight','Tamar Aviv','Amy Byrne','Duncan Jarman','Mark Coulier','Pamela Goldammer','Göran Lundström','Barrie Gower'],
costumes:['Jany Temime']},
{title:'Gone Baby Gone',
titleCZ:'Gone, Baby, Gone',
year:2007,
runtime:114,
countries:['USA'],
genres:['Drama','Crime','Mystery'],
director:['Ben Affleck'],
actors:['Casey Affleck','Michelle Monaghan','Ed Harris','John Ashton','Morgan Freeman','Amy Ryan','Amy Madigan','Titus Welliver','Michael Kenneth Williams','Edi Gathegi','Mark Margolis',"Madeline O'Brien",'Slaine','Jay Giannone','Robert Wahlberg','Tom Kemp','Richard Snee','Robert Masiello','Billy Silvia','Michele Proude','Elizabeth Duff','Brian Scannell','Raymond Alongi','Celeste Oliva','Lonnie Farmer','Matthew Maher','Nicholas Purcell','Rena Maliszewski','Lewis D. Wheeler'],
basedOn:['Dennis Lehane'],
screenplay:['Ben Affleck','Aaron Stockard'],
production:['Sean Bailey','Alan Ladd Jr.'],
music:['Harry Gregson-Williams'],
camera:['John Toll'],
cut:['William Goldenberg'],
sound:['Jon Taylor','Christian P. Minkler','Mark P. Stoeckinger'],
scenography:['Chris Cornwell','Sharon Seymour'],
costumes:['Alix Friedberg']},
{title:'The Girl with the Dragon Tattoo',
titleCZ:'Muži, kteří nenávidí ženy',
year:2011,
runtime:158,
countries:['USA','Sweden','UK','Germany'],
genres:['Crime','Drama','Mystery','Thriller'],
director:['David Fincher'],
actors:['Daniel Craig','Rooney Mara','Christopher Plummer','Stellan Skarsgård','Steven Berkoff','Robin Wright','Yorick van Wageningen','Joely Richardson','Geraldine James','Goran Višnjič','Donald Sumpter','Ulf Friberg','Bengt C.W. Carlsson','Tony Way','Per Myrberg','Josefin Asplund','Eva Fritjofson','Moa Garpendal','Maia Hansson Bergqvist','Julian Sands','Anna Björk','Gustaf Hammarsten','Simon Reithner','David Dencik','Marcus Johansson','Mathilda von Essen','Martin Jarvis','Inga Landgré','Anders Berg','Mats Andersson','Anders Jansson','Jürgen Klein','Kalle Josephson','Sandra Andreis','Arly Jover','Tess Panzer','Alastair Duncan','Alan Dale','Julia Rose','Peter Carlberg','Jan Abramson','Lena Strömdahl','Anne-Li Norberg','Marco Albrecht','Anna Carlson','Fredrik Dolk','Christian Heller','Werner Biermeier','Christine Adams','Peter Hottinger','Joyce Giraud','Elodie Yung','Anna Charlotta Gunnarson','Andreas Björklund','Embeth Davidtz','Joel Kinnaman','George Gerdes','Magnus af Sandeberg','Amanda Dyar','Laurence Fuller','Charlotta Lövgren','Christopher Maleki','Mike Zehr'],
basedOn:['Stieg Larsson'],
screenplay:['Steven Zaillian'],
production:['Scott Rudin','Søren Stærmose','Ceán Chaffin','Ole Søndberg'],
music:['Trent Reznor','Atticus Ross'],
camera:['Jeff Cronenweth'],
cut:['Kirk Baxter','Angus Wall'],
sound:['Ren Klyce','David Parker','Michael Semanick','Mark Weingarten'],
scenography:['Donald Graham Burt','Mikael Varhelyi','K.C. Fox'],
masks:['Michael Mills','Eva von Bahr','Love Larson'],
costumes:['Trish Summerville']},
{title:'Gattaca',
titleCZ:'Gattaca',
year:1997,
runtime:106,
countries:['USA'],
genres:['Drama','Sci-Fi','Thriller'],
director:['Andrew Niccol'],
actors:['Ethan Hawke','Uma Thurman','Jude Law','Xander Berkeley','Jayne Brook','Elias Koteas','Blair Underwood','Mason Gamble','William Lee Scott','Ernest Borgnine','Tony Shalhoub','Alan Arkin','Loren Dean','Maya Rudolph','Dean Norris','Ken Marino','Lindsey Ginter','Gore Vidal','Elizabeth Dennehy','Una Damon','Gabrielle Reece','Chad Christ','Cynthia Martells'],
screenplay:['Andrew Niccol'],
production:['Danny DeVito','Michael Shamberg','Stacey Sher'],
music:['Michael Nyman'],
camera:['Sławomir Idziak'],
cut:['Lisa Zeno Churgin'],
sound:['Richard King','Paul Massey','Doug Hemphill','Michael Semanick'],
scenography:['Jan Roelfs','Nancy Nye'],
masks:['Ve Neill'],
costumes:['Colleen Atwood']},
{title:'A Blonde in Love',
titleCZ:'Lásky jedné plavovlásky',
year:1965,
runtime:77,
countries:['Czechoslovakia'],
genres:['Romance','Comedy','Drama'],
director:['Miloš Forman'],
actors:['Hana Brejchová','Vladimír Pucholt','Vladimír Menšík','Ivan Kheil','Jiří Hrubý','Milada Ježková','Josef Šebánek','Josef Kolb','Marie Salačová','Jana Nováková','Jarka Crkalová','Táňa Zelinková','Zdenka Lorencová','Jan Vostrčil','Antonín Blažejovský','Slavoj Banzet','Ota Heinitz','Otto Sattler','Antonín Keyř','Jindřich Heidelberg','Dana Valtová','Arnošt Vrána'],
screenplay:['Jaroslav Papoušek','Miloš Forman','Ivan Passer'],
music:['Evžen Illín'],
camera:['Miroslav Ondříček'],
cut:['Miroslav Hájek'],
sound:['Adolf Böhm'],
scenography:['Karel Černý'],
masks:['Rudolf Hammer'],
costumes:['Zdena Šnajdarová']},
{title:"Boys Don't Cry",
titleCZ:'Kluci nepláčou',
year:1999,
runtime:114,
countries:['USA'],
genres:['Crime','Drama','Romance'],
director:['Kimberly Peirce'],
actors:['Hilary Swank','Chloë Sevigny','Peter Sarsgaard','Brendan Sexton III','Alicia Goranson','Alison Folland','Rob Campbell','Natalie Zea','Caitlin Wehrle','Lou Perryman','Robert Prentiss','Gail Cronauer','Josh Ridgway','Jerry Haynes','Libby Villari','Gabriel Horn','Cheyenne Rushing','Jeannetta Arnette'],
screenplay:['Kimberly Peirce','Andy Bienen'],
production:['Jeffrey Sharp','Christine Vachon','John Hart','Eva Kolodner'],
music:['Nathan Larson'],
camera:['Jim Denault'],
cut:['Lee Percy','Tracy Granger'],
sound:['Robert Fernandez','Sean Garnhart'],
scenography:['Michael Shaw'],
costumes:['Vicki Farrell']},
{title:'Midnight Cowboy',
titleCZ:'Půlnoční kovboj',
year:1969,
runtime:113,
countries:['USA'],
genres:['Drama'],
director:['John Schlesinger'],
actors:['Dustin Hoffman','Jon Voight','Sylvia Miles','John McGiver','Brenda Vaccaro','Barnard Hughes','Ruth White','Jennifer Salt','Bob Balaban','Paul Morrissey','Taylor Mead','Ultra Violet','Philip Bruns','Sandy Duncan','Marlene Clark','Paul Benjamin','Georgann Johnson','International Velvet','Viva','Anthony Holland','Randall Carver','Paul Rossilli','Mary Boylan','Richard Clarke','Joan Murphy','Paul Jabara','Pat Ast'],
screenplay:['Waldo Salt'],
production:['Jerome Hellman'],
music:['John Barry'],
camera:['Adam Holender'],
cut:['Hugh A. Robertson'],
sound:['Dick Vorisek'],
scenography:['John Robert Lloyd','Philip Smith'],
costumes:['Ann Roth']},
{title:'The Last Temptation of Christ',
titleCZ:'Poslední pokušení Krista',
year:1988,
runtime:164,
countries:['USA','Canada'],
genres:['Drama'],
director:['Martin Scorsese'],
actors:['Willem Dafoe','Harvey Keitel','Verna Bloom','Barbara Hershey','Roberts Blossom','Gary Basaraba','Barry Miller','Paul Greco','Irvin Kershner','Victor Argo','John Lurie','Leo Burmester','Tomas Arana','Alan Rosenberg','Nehemiah Persoff','Harry Dean Stanton','Peter Berling','David Bowie','Juliette Caton','Illeana Douglas','Steve Shill','Giovanni Cianfriglia','Peggy Gormley','Andre Gregory','Paul Herman','Michael Been','Ted Rusoff','Leo Damian','Leo Marks','Rod Dana','Penny Brown','Domenico Fiore','Dale Wyatt'],
basedOn:['Nikos Kazantzakis'],
screenplay:['Paul Schrader'],
production:['Barbara De Fina'],
music:['Peter Gabriel'],
camera:['Michael Ballhaus'],
cut:['Thelma Schoonmaker'],
sound:['Tom Fleischman','Skip Lievsay'],
scenography:['John Beard'],
masks:['Luigi Rocchetti','Mario Michisanti','Aldo Signoretti']},
{title:'Vampire Hunter D: Bloodlust',
titleCZ:'Vampire Hunter D',
year:2000,
runtime:102,
countries:['Japan'],
genres:['Animation','Drama','Horror','Sci-Fi'],
director:['Jošiaki Kawadžiri'],
actors:['Hidejuki Tanaka','Ičiró Nagai','Kóiči Jamadera','Megumi Hajašibara','Tošihiko Seki','Takeši Aono','Unšó Išizuka','Keidži Fudžiwara','Akiko Jadžima','Bibari Maeda','Čikao Ócuka','John Hostetter','Matt McKenzie','Júsaku Jara','Emi Šinohara','Hóčú Ócuka','Rintaró Niši','Jóko Sómi','Rjúzaburó Ótomo','Debi Derryberry','Julia Fletcher','Mary Elizabeth McGlynn'],
screenplay:['Brian Irving'],
production:['Takajuki Nagasawa'],
camera:['Hitoši Jamaguči'],
cut:['Satoši Terauči','Kašiko Kimura','Harutoši Ogata'],
sound:['Masafumi Mima']},
{title:'Wings of Desire',
titleCZ:'Nebe nad Berlínem',
year:1987,
runtime:127,
countries:['Germany','France'],
genres:['Fantasy','Drama','Poetic','Romance'],
director:['Wim Wenders'],
actors:['Bruno Ganz','Solveig Dommartin','Otto Sander','Curt Bois','Peter Falk','Hans-Martin Stier','Laurent Petitgand','Paul Busch','Didier Flamand','Jürgen Heinrich','Nick Cave','Blixa Bargeld','Lajos Kovács','Teresa Harder','Sigurd Rachman','Annelinde Gerstl','Thierry Noir','Bernard Eisenschitz','Johanna Penski','Erika Rabau','Chick Ortega','Hans Marquardt','Ulrike Schirm','Mick Harvey','Beatrice Manowski','Patrick Kreuzer','Jerry Barrish','Wolf-Dirk Vogeley'],
screenplay:['Wim Wenders','Peter Handke','Richard Reitinger'],
production:['Anatole Dauman','Wim Wenders'],
music:['Jürgen Knieper'],
camera:['Henri Alekan'],
cut:['Peter Przygodda'],
sound:['Hartmut Eichgrün'],
scenography:['Heidi Lüdi'],
masks:['Victor Leitenbauer','Regina Huyer'],
costumes:['Monika Jacobs']},
{title:'Terms of Endearment',
titleCZ:'Cena za něžnost',
year:1983,
runtime:132,
countries:['USA'],
genres:['Romance','Comedy','Drama'],
director:['James L. Brooks'],
actors:['Shirley MacLaine','Debra Winger','Jack Nicholson','Danny DeVito','Jeff Daniels','John Lithgow','Lisa Hart Carroll','Sharisse Baker-Bernard','Huckleberry Fox','Albert Brooks','Mary Kay Place','F. William Parker','Norman Bennett','David Wohl','Holly Holmberg Brooks'],
basedOn:['Larry McMurtry'],
screenplay:['James L. Brooks'],
production:['James L. Brooks'],
music:['Michael Gore'],
camera:['Andrzej Bartkowiak'],
cut:['Richard Marks'],
sound:["Kevin O'Connell"],
scenography:['Polly Platt','Tom Pedigo'],
masks:['Gerry Leetch'],
costumes:['Kristi Zea']},
{title:'Charade',
titleCZ:'Šaráda',
year:1963,
runtime:113,
countries:['USA'],
genres:['Mystery','Crime','Romance','Comedy','Thriller'],
director:['Stanley Donen'],
actors:['Cary Grant','Audrey Hepburn','Walter Matthau','James Coburn','George Kennedy','Jacques Marin','Ned Glass','Stanley Donen','Raoul Delfosse','Bernard Musson','Peter Stone','Claudine Berg','Michel Thomass','Roger Trapp','Clément Harari','Paul Bonifas','Marcel Bernier','Lucien Desagneaux','Jacques Préboist','Chantal Goya','André Tomasi','Marc Arian','Louis Viret','Anthony Stuart'],
screenplay:['Peter Stone'],
production:['Stanley Donen'],
music:['Henry Mancini'],
camera:['Charles Lang'],
cut:['Jim Clark'],
masks:["John O'Gorman"],
costumes:['Hubert de Givenchy']},
{title:'Time of the Gypsies',
titleCZ:'Dům k pověšení',
year:1988,
runtime:142,
countries:['Yugoslavia','Italy','UK'],
genres:['Drama','Comedy','Crime','Fantasy'],
director:['Emir Kusturica'],
actors:['Davor Dujmovic','Bora Todorovič','Ljubica Adžović','Zabit Memedov',"Predrag 'Pepi' Lakovič"],
screenplay:['Emir Kusturica','Gordan Mihič'],
music:['Goran Bregovič'],
camera:['Vilko Filac'],
cut:['Andrija Zafranovič'],
scenography:['Miljen Kreka Kljakovic'],
costumes:['Mirjana Ostojič']},
{title:'Autumn Sonata',
titleCZ:'Podzimní sonáta',
year:1978,
runtime:99,
countries:['Sweden','Germany','France'],
genres:['Drama','Music'],
director:['Ingmar Bergman'],
actors:['Ingrid Bergman','Liv Ullmann','Lena Nyman','Halvar Björk','Gunnar Björnstrand','Erland Josephson','Georg Løkkeberg','Eva von Hanno','Marianne Aminoff','Mimi Pollak','Arne Bang-Hansen','Linn Ullmann','Knut Wigert'],
screenplay:['Ingmar Bergman'],
camera:['Sven Nykvist'],
cut:['Sylvia Ingemarsdotter'],
sound:['Owe Svensson'],
scenography:['Anna Asp'],
masks:['Cecilia Drott'],
costumes:['Inger Pehrsson','Barbro Sörman']},
{title:'Stalag 17',
titleCZ:'Stalag 17',
year:1953,
runtime:120,
countries:['USA'],
genres:['Drama','Comedy','War'],
director:['Billy Wilder'],
actors:['William Holden','Don Taylor','Otto Preminger','Robert Strauss','Harvey Lembeck','Richard Erdman','Peter Graves','Neville Brand','Sig Ruman','Michael Moore','Peter Baldwin','Ross Bagdasarian','John Mitchum','Tommy Cook','Joe Ploski','Robin Morse','Peter Leeds','Harald Maresch','Max Willenz','Bill McLean','Robert R. Stephenson','A. Gerald Singer','Gil Stratton'],
screenplay:['Billy Wilder'],
production:['Billy Wilder'],
music:['Franz Waxman'],
camera:['Ernest Laszlo'],
cut:['George Tomasini'],
sound:['Harold Lewis','Gene Garvin'],
scenography:['Hal Pereira','Franz Bachelin','Ray Moyer','Sam Comer'],
masks:['Harry Ray','Wally Westmore']},
{title:'Paper Moon',
titleCZ:'Papírový měsíc',
year:1973,
runtime:102,
countries:['USA'],
genres:['Road movie','Drama','Comedy'],
director:['Peter Bogdanovich'],
actors:["Ryan O'Neal","Tatum O'Neal",'Madeline Kahn','John Hillerman','P.J. Johnson','Noble Willingham','Randy Quaid','Art Ellison','Hugh Gillin','Burton Gilliam','James N. Harrell','Jessie Lee Fulton','Desmond Dhooge'],
basedOn:['Joe David Brown'],
screenplay:['Alvin Sargent'],
production:['Peter Bogdanovich'],
camera:['László Kovács'],
cut:['Verna Fields'],
scenography:['Polly Platt'],
costumes:['Polly Platt']},
{title:'A Man Escaped or: The Wind Bloweth Where It Listeth',
titleCZ:'K smrti odsouzený uprchl',
year:1956,
runtime:99,
countries:['France'],
genres:['Drama','Thriller','War'],
director:['Robert Bresson'],
actors:['François Leterrier','Charles Le Clainche','Maurice Beerblock','Roland Monod','Roger Planchon','Jacques Ertaud','Jean Paul Delhumeau','Roger Treherne','Jean Philippe Delamarre','César Gattegno'],
screenplay:['Robert Bresson'],
production:['Alain Poiré'],
camera:['Léonce-Henri Burel'],
cut:['Raymond Lamy'],
sound:['Guy Rophé']},
{title:'The Marathon',
titleCZ:'Maraton',
year:1968,
runtime:100,
countries:['Czechoslovakia'],
genres:['Comedy','Drama','War'],
director:['Ivo Novák'],
actors:['Jaromír Hanzlík','Jana Brejchová','Vladimír Menšík','Karel Höger','Zdeněk Štěpánek','Petr Kostka','Bohuš Záhorský','Ivan Mistrík','Svatopluk Matyáš','Radoslav Brzobohatý','František Peterka','Přemysl Kočí','Josef Langmiler','Josef Větrovec','Jan Cmíral st.','Oldřich Šmalcl','Vít Olmer','Svatopluk Beneš','Štěpán Bulejko','Ivo Niederle','Jaroslav Mareš','Jan Skopeček','Čestmír Řanda st.','Jaroslav Moučka','Lubomír Kostelka','Zdeněk Kryzánek','Miloš Hlavica','Jiří Steimar','Marie Brožová','Rudolf Pellar','Miloš Willig','Gustav Opočenský','Jindřich Narenta','Jiří Pleskot','Taťána Vavřincová','Jorga Kotrbová','Jaroslav Satoranský','Jaroslav Mařan','Lubomír Bryg','Arnošt Faltýnek','Ivo Gübel','Zdeněk Braunschläger','Miroslav Homola','Zdeněk Hodr','Ivan Vyskočil','Karel Hábl','Vilém Besser','Václav Fišer','Jaromír Spal','Josef Kemr','Zdeněk Kutil','Jiří Zahajský','Jiří Krampol','Vladimír Hrabánek','Otto Lackovič','Rudolf Jelínek','Jan Pohan','Jindřich Heidelberg','Petr Svojtka','Aleš Helcelet','Ladislav Trojan','Zdeněk Ornest','Jan Diviš','Jan Faltýnek','Stanislav Zindulka','Václav Sloup','Karel Hlušička','Stanislav Litera','Ladislav Čermák','Karel Hovorka st.','Eduard Dubský','Ladislav Potměšil','Bohumil Koška','Jan Kotva','Zdeněk Najman','František Marek','Eva Jandáčková','Ivona Nováková','Jan Jílek','František Hruška','Miloslav Šindler','Jiří Cimický','Karel Engel','Jiří Kasík','Antonín Kryl','Otakar Rademacher','Jindřich Sejk','Oldřich Semerák','Josef Schneider','Jiří Svárovský','Jan Váňa','Karel Vítek st.','Ludvík Wolf','P. Stejskal','Karel Kryška','Miloslav Novák','Viktor Oktábec','Josef Šulc','Antonín Molčík','Jan Víšek'],
screenplay:['Jan Procházka','Ivo Novák'],
music:['Zdeněk Liška'],
camera:['Václav Hanuš'],
cut:['Jiřina Lukešová'],
sound:['Jaromír Svoboda','František Fabián'],
scenography:['Karel Škvor','Oldřich Okáč'],
masks:['Oldřich Mach']},
{title:'Saw',
titleCZ:'Saw: Hra o přežití',
year:2004,
runtime:99,
countries:['USA'],
genres:['Horror','Mystery','Thriller'],
director:['James Wan'],
actors:['Leigh Whannell','Cary Elwes','Danny Glover','Monica Potter','Ken Leung','Michael Emerson','Tobin Bell','Makenzie Vega','Shawnee Smith','Dina Meyer','Benito Martinez','Mike Butters','Ned Bellamy','Oren Koules','Paul Gutrecht','Alexandra Bokyun Chun'],
screenplay:['Leigh Whannell'],
production:['Mark Burg','Oren Koules','Gregg Hoffman'],
music:['Charlie Clouser'],
camera:['David A. Armstrong'],
cut:['Kevin Greutert'],
scenography:['Julie Berghoff'],
masks:['Scott H. Eddo'],
costumes:['Jennifer L. Soulages']},
{title:'E.T.: The Extra-Terrestrial',
titleCZ:'E.T. - Mimozemšťan',
year:1982,
runtime:115,
countries:['USA'],
genres:['Sci-Fi','Adventure','Drama'],
director:['Steven Spielberg'],
actors:['Henry Thomas','Dee Wallace','Peter Coyote','Robert MacNaughton','Drew Barrymore','C. Thomas Howell','Erika Eleniak','K.C. Martel','Sean Frye',"David M. O'Dell",'Richard Swingler','Frank Toth','Robert Barton','Michael Darrell','David Berkson','David Carlberg','Milt Kogan','Alexander Lampone','Rhoda Makoff','Robert Murphy','Richard Pesavento','Tom Sherry','Susan Cameron','Will Fowler Jr.','Barbara Hartnett','Diane Lampone','Marysia Stein','Mitch Suskin','Anne Lockhart','Debra Winger','Jean-Paul Hellendall','Ted Grossman'],
screenplay:['Melissa Mathison'],
production:['Steven Spielberg','Kathleen Kennedy'],
music:['John Williams'],
camera:['Allen Daviau'],
cut:['Carol Littleton'],
sound:['Don Digirolamo','Robert Glass'],
scenography:['Jim Bissell','Jackie Carr']},
{title:'Knives Out',
titleCZ:'Na nože',
year:2019,
runtime:131,
countries:['USA'],
genres:['Mystery','Crime','Comedy','Thriller','Drama'],
director:['Rian Johnson'],
actors:['Daniel Craig','Ana de Armas','Chris Evans','Jamie Lee Curtis','Michael Shannon','Don Johnson','Toni Collette','Lakeith Stanfield','Christopher Plummer','Katherine Langford','Jaeden Martell','Riki Lindhome','Edi Patterson','Frank Oz','K Callan','Noah Segan','M. Emmet Walsh','Marlene Forte','Raúl Castillo','Shyrley Rodriguez','Joseph Gordon-Levitt','Octavia Chavez-Richmond'],
screenplay:['Rian Johnson'],
production:['Rian Johnson','Ram Bergman'],
music:['Nathan Johnson'],
camera:['Steve Yedlin'],
cut:['Bob Ducsay'],
sound:['David Parker','Al Nelson'],
scenography:['David Crank'],
masks:['Luisa Abel'],
costumes:['Jenny Eagan']},
{title:'The Deer Hunter',
titleCZ:'Lovec jelenů',
year:1978,
runtime:183,
countries:['USA','UK'],
genres:['Drama','War'],
director:['Michael Cimino'],
actors:['Robert De Niro','Christopher Walken','John Savage','Meryl Streep','John Cazale','George Dzundza','Shirley Stoler','Chuck Aspegren','Rutanya Alda','Joe Grifasi',"Paul D'Amato",'Amy Wright','Richard Kuss','Eva León','Blanca Estrada','Carmen de Lirio'],
screenplay:['Deric Washburn'],
production:['Michael Deeley','Barry Spikings','Michael Cimino'],
music:['Stanley Myers'],
camera:['Vilmos Zsigmond'],
cut:['Peter Zinner'],
masks:['Del Acevedo','Dick Smith']},
{title:'Three Days of the Condor',
titleCZ:'Tři dny Kondora',
year:1975,
runtime:117,
countries:['USA'],
genres:['Mystery','Thriller','Crime'],
director:['Sydney Pollack'],
actors:['Robert Redford','Faye Dunaway','Cliff Robertson','Max von Sydow','Addison Powell','John Houseman','Walter McGinn','Tina Chen','Robert Phalen','Russell Johnson','Ernest Harden Jr.','James Keane','Carlin Glynn','Michael Kane','Hank Garrett','Jess Osuna','Michael Miller','Ed Crowley','Arthur French','Patrick Gorman','Helen Stenborg','Michael Prince','David Bowman'],
basedOn:['James Grady'],
screenplay:['Lorenzo Semple Jr.','David Rayfiel'],
production:['Sydney Pollack','Dino De Laurentiis'],
music:['Dave Grusin'],
camera:['Owen Roizman'],
cut:['Don Guidice'],
scenography:['Stephen B. Grimes'],
masks:['Lee Harman','Gary Liddiard'],
costumes:['Joseph G. Aulisi']},
{title:'Star Trek VIII: First Contact',
titleCZ:'Star Trek VIII: První kontakt',
year:1996,
runtime:106,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action','Thriller'],
director:['Jonathan Frakes'],
actors:['Patrick Stewart','Jonathan Frakes','Brent Spiner','LeVar Burton','Michael Dorn','Gates McFadden','Marina Sirtis','Alfre Woodard','James Cromwell','Alice Krige','Michael Horton','Neal McDonough','Robert Picardo','Dwight Schultz','Adam Scott','Majel Barrett','Don Stark','Robert Zachar','Ethan Phillips','Brannon Braga','Ronald D. Moore','Victor Bevine','Eric Steinberg','Michael Braveheart','Patti Yasutake','Jack Shearer','Michael Zaslow','D. Danny Warhol','C.J. Bau','Marnie McPhail','Jon David Casey','Cameron','Don Fischer','David Cowgill','Tamara Krinsky','Wayne King'],
screenplay:['Brannon Braga','Ronald D. Moore'],
production:['Rick Berman'],
music:['Jerry Goldsmith','Joel Goldsmith'],
camera:['Matthew F. Leonetti'],
cut:['John W. Wheeler'],
sound:['Tom Perry','Steve Pederson','Brad Sherman'],
scenography:['Herman F. Zimmerman','John M. Dwyer'],
masks:['Monty Westmore','Michael Westmore','Scott Wheeler','Camille Calvet','Chris McBee','Barbara Ronci','Jane Galli','Mark Bussan'],
costumes:['Deborah Everton']},
{title:"No Man's Land",
titleCZ:'Země nikoho',
year:2001,
runtime:98,
countries:['Bosnia and Herzegovina','France','Slovenia','Italy','UK','Belgium'],
genres:['Drama','Comedy','War'],
director:['Danis Tanović'],
actors:['Branko Djurič','René Bitorajac','Filip Šovagović','Georges Siatidis','Serge-Henri Valcke','Katrin Cartlidge','Bogdan Diklič','Simon Callow','Primoz Petkovsek','Sasa Petrovic','Alain Eloy','Mustafa Nadarevic','Radovan Karadžič','Uroš Fürst','François Mitterrand','Marinko Prga','Tanja Ribič'],
screenplay:['Danis Tanović'],
camera:['Walther Vanden Ende'],
cut:['Francesca Calvelli']},
{title:'Elite Squad: The Enemy Within',
titleCZ:'Elitní jednotka 2: Vnitřní nepřítel',
year:2010,
runtime:116,
countries:['Brazil'],
genres:['Action','Crime','Drama','Thriller'],
director:['José Padilha'],
actors:['Wagner Moura','Irandhir Santos','André Ramiro','Milhem Cortaz','Maria Ribeiro','Seu Jorge','Sandro Rocha','Tainá Müller','Juliana Schalch','Luciano Vidigal','Fabrício Boliveira','Adriano Garib','André Mattos','Luca Bianchi','Emílio Orciollo Netto','Thogun Teixeira','Rodrigo Candelot'],
screenplay:['Bráulio Mantovani'],
music:['Pedro Bromfman'],
camera:['Lula Carvalho'],
cut:['Daniel Rezende'],
sound:['Alessandro Laroca','Armando Torres Jr.'],
scenography:['Odair Zani'],
masks:['Martín Macías Trujillo'],
costumes:['Cláudia Kopke']},
{title:'Come and See',
titleCZ:'Jdi a dívej se',
year:1985,
runtime:142,
countries:['Russia'],
genres:['Drama','War'],
director:['Elem Klimov'],
actors:['Alexej Kravčenko','Olga Mironova','Ljubomiras Laucevičius','Vladas Bagdonas','Jüri Lumiste','Vasilij Domračev','Adolf Hitler','Viktor Lorenc','Svetlana Zelenkovskaja','Anatolij Slivnikov'],
basedOn:['Ales Adamovič'],
screenplay:['Ales Adamovič','Elem Klimov'],
camera:['Alexej Rodionov']},
{title:'Down by Law',
titleCZ:'Mimo zákon',
year:1986,
runtime:107,
countries:['USA','Germany'],
genres:['Comedy','Drama','Crime'],
director:['Jim Jarmusch'],
actors:['Tom Waits','John Lurie','Roberto Benigni','Nicoletta Braschi','Ellen Barkin','Richard Boes','Pruitt Taylor Vince','Joy N. Houck Jr.','Rockets Redglare','Alan Kleinberg','Vernel Bagneris','Billie Neal','Carrie Lindsoe','Eliott Keener'],
screenplay:['Jim Jarmusch'],
production:['Alan Kleinberg'],
music:['John Lurie'],
camera:['Robby Müller'],
cut:['Melody London'],
sound:['Stanley Kastner'],
scenography:['Janet Densmore'],
costumes:['Carol Wood']},
{title:'In the Heat of the Night',
titleCZ:'V žáru noci',
year:1967,
runtime:105,
countries:['USA'],
genres:['Crime','Drama','Mystery','Thriller'],
director:['Norman Jewison'],
actors:['Sidney Poitier','Rod Steiger','Warren Oates','Lee Grant','Larry Gates','James Patterson','William Schallert','Beah Richards','Kermit Murdock','Matt Clark','Larry D. Mann','Scott Wilson','Fred Stewart','Quentin Dean','Peter Masterson','Anthony James','Alan Oppenheimer','Peter Whitney','Arthur Malet','Timothy Scott','Stuart Nisbet','William Watson','Harry Dean Stanton','Eldon Quick','Jester Hairston','Nikita Knatz','Clegg Hoyt'],
basedOn:['John Ball'],
screenplay:['Stirling Silliphant'],
production:['Walter Mirisch'],
music:['Quincy Jones'],
camera:['Haskell Wexler'],
cut:['Hal Ashby'],
sound:['Charles Cooper','Clem Portman'],
scenography:['Paul Groesse'],
costumes:['Alan Levine']},
{title:'Same Time, Next Year',
titleCZ:'Příští rok ve stejnou dobu',
year:1978,
runtime:114,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Robert Mulligan'],
actors:['Ellen Burstyn','Alan Alda','Ivan Bonar','Cosmo Sardo','Bernie Kuby'],
screenplay:['Bernard Slade','Bernard Slade'],
production:['Walter Mirisch'],
music:['Marvin Hamlisch'],
camera:['Robert Surtees'],
cut:['Sheldon Kahn'],
scenography:['Henry Bumstead','Hal Gausman'],
masks:['Terry Miles','William Tuttle','Barbara Ronci'],
costumes:['Theadora Van Runkle']},
{title:'All About Eve',
titleCZ:'Vše o Evě',
year:1950,
runtime:138,
countries:['USA'],
genres:['Drama'],
director:['Joseph L. Mankiewicz'],
actors:['Bette Davis','Anne Baxter','George Sanders','Celeste Holm','Gary Merrill','Hugh Marlowe','Gregory Ratoff','Barbara Bates','Marilyn Monroe','Thelma Ritter','Walter Hampden','Craig Hill','Bess Flowers',"Harry 'Snub' Pollard",'Harold Miller','Steven Geray','Jack Chefe','Ralph Brooks','Franklyn Farnum','Larry Steers','James Conaty','Randy Stuart','Gertrude Astor','Carl M. Leviness','Suzanne Ridgway','Sayre Dearing','Mathew McCue','Eugene Borden','Jack Deery','Ethelreda Leopold','Thomas Martin','Paul Power','Claude Stroud','Helen Mowery'],
screenplay:['Joseph L. Mankiewicz','Erich Kästner'],
production:['Darryl F. Zanuck'],
music:['Alfred Newman'],
camera:['Milton R. Krasner'],
cut:['Barbara McLean'],
sound:['W.D. Flick','Roger Heman Sr.'],
scenography:['George W. Davis','Lyle R. Wheeler','Walter M. Scott'],
masks:['Ben Nye','Gene Roemer']},
{title:'Monsieur Verdoux',
titleCZ:'Pan Verdoux',
year:1947,
runtime:124,
countries:['USA'],
genres:['Comedy','Drama'],
director:['Charlie Chaplin'],
actors:['Charlie Chaplin','Martha Raye','Edna Purviance','Barry Norton','Frank Reicher','William Frawley','Robert Lewis','Arthur Hohl','Fritz Leiber','Vera Marshe','Richard Abbott','Cyril Delevanti','Irving Bacon','Addison Richards','Bert Stevens','Herb Vigran','Joseph Crehan','Jeffrey Sayre','Harold Miller','Adolf Hitler','Benito Mussolini','Pierre Watkin','Charles Wagenheim','Colin Kenny','Lester Matthews','Ralph Brooks','Franklyn Farnum','Wilbur Mack','Virginia Brissac','Almira Sessions','Gertrude Astor','Marjorie Bennett','John Harmon','William Self','Carl M. Leviness','Warren Ashe','Isobel Elsom','Suzanne Ridgway','Paul Newlan','Wheaton Chambers','Herbert Evans','C. Montague Shaw','Elspeth Dudgeon','Bernard Nedell','Ruth Lee','Helene Heigh','Boyd Irwin','Ralph Montgomery','Ella Ethridge','Ber LeBaron'],
screenplay:['Charlie Chaplin'],
production:['Charlie Chaplin'],
music:['Charlie Chaplin'],
camera:['Curt Courant','Roland Totheroh'],
cut:['Willard Nico'],
scenography:['John Beckman'],
masks:['Hedy Mjorud']},
{title:"The Emperor's Nightingale",
titleCZ:'Císařův slavík',
year:1948,
runtime:72,
countries:['Czechoslovakia'],
genres:['Animation','Puppets','Fairytale','Poetic'],
director:['Jiří Trnka','Miloš Makovec'],
actors:['Helena Patočková','Jaromír Sobota'],
basedOn:['Hans Christian Andersen'],
screenplay:['Jiří Trnka','Jiří Brdečka','Vítězslav Nezval'],
music:['Václav Trojan'],
camera:['Ferdinand Pečenka','Emanuel Franek'],
cut:['Helena Lebdušková'],
sound:['Josef Zavadil']},
{title:'Goodbye, Mr. Chips',
titleCZ:'Sbohem, pane profesore!',
year:1969,
runtime:151,
countries:['USA'],
genres:['Drama','Musical','Romance'],
director:['Herbert Ross'],
actors:["Peter O'Toole",'Petula Clark','Michael Redgrave','Siân Phillips','George Baker','Jack May','Jack Hedley','Leo Britt','Elspet Gray','Richard Vernon','Patricia Hayes','Jenny Runacre','Robert Rietty','Jeremy Lloyd','Barbara Couper','Ronnie Stevens','Nicholas Frankau','Alison Leggatt','Elspeth March','Clinton Greyn','Michael Culver','Clive Morton','Sheila Steafel','Royston Tickner','Mario Maranzana','Michael Bryant','Tom Owen','Barbara Knox'],
basedOn:['James Hilton'],
screenplay:['Terence Rattigan'],
production:['Arthur P. Jacobs'],
music:['Leslie Bricusse','John Williams'],
camera:['Oswald Morris'],
cut:['Ralph Kemplen'],
scenography:['Ken Adam'],
masks:['Bill Lodge'],
costumes:['Julie Harris']},
{title:'The Martian',
titleCZ:'Marťan',
year:2015,
runtime:144,
countries:['USA','UK'],
genres:['Sci-Fi','Adventure','Drama'],
director:['Ridley Scott'],
actors:['Matt Damon','Jessica Chastain','Chiwetel Ejiofor','Jeff Daniels','Michael Peña','Kate Mara','Sean Bean','Kristen Wiig','Aksel Hennie','Sebastian Stan','Mackenzie Davis','Donald Glover','Eddy Ko','Jonathan Aris','Brian Caspe','Gruffudd Glyn','Matt Devere','Lili Bordán','Charlie Gardner','Sam Spruell','Benedict Wong','Björn Freiberg','Nick Mohammed',"Mark O'Neal",'Zalán Takács','Shu Chen','Waleska Latorre','Irén Bordán','Nick Wittman'],
basedOn:['Andy Weir'],
screenplay:['Drew Goddard'],
production:['Mark Huffam','Ridley Scott','Aditya Sood','Michael Schaefer','Simon Kinberg'],
music:['Harry Gregson-Williams'],
camera:['Dariusz Wolski'],
cut:['Pietro Scalia'],
sound:['Oliver Tarney','Paul Massey','Michael Fentum','Mac Ruth','Mark Taylor'],
scenography:['Arthur Max','Jason Knox-Johnston','Celia Bobak','Phil Sims'],
masks:['Jana Carboni'],
costumes:['Janty Yates']},
{title:'Indiana Jones and the Temple of Doom',
titleCZ:'Indiana Jones a Chrám zkázy',
year:1984,
runtime:118,
countries:['USA'],
genres:['Adventure','Action','Drama','Fantasy'],
director:['Steven Spielberg'],
actors:['Harrison Ford','Kate Capshaw','Ke Huy Quan','Amrish Puri','Roshan Seth','Philip Stone','Ric Young','Philip Tan','Dan Aykroyd','George Lucas','Frank Marshall','Steven Spielberg','D.R. Nanayakkara','Pat Roach','Roy Chiao','Anthony Powell','David Yip','Michael Yama','Sidney Ganis','Raj Singh','Iranganee Serasinghe','Frank Olegario','Alex Klaus','Ahmed El Shenawi'],
screenplay:['Willard Huyck','Gloria Katz'],
production:['Robert Watts'],
music:['John Williams'],
camera:['Douglas Slocombe'],
cut:['Michael Kahn','George Lucas'],
sound:['Randy Thom','Gary Summers'],
scenography:['Elliot Scott'],
masks:['Peter Robb-King','Tom Smith','Linda DeVetta'],
costumes:['Anthony Powell']},
{title:'Ghostbusters',
titleCZ:'Krotitelé duchů',
year:1984,
runtime:107,
countries:['USA'],
genres:['Sci-Fi','Fantasy','Comedy','Adventure'],
director:['Ivan Reitman'],
actors:['Bill Murray','Dan Aykroyd','Sigourney Weaver','Harold Ramis','Rick Moranis','Annie Potts','William Atherton','Ernie Hudson','Slavitza Jovan','Alice Drummond','Timothy Carhart','John Rothman','Casey Kasem','Reginald VelJohnson','Jordan Charney','Ivan Reitman','Ron Jeremy','Deborah Gibson','Steven Tash','Christopher Wynkoop','Wendy Goldman','Michael Ensign','Jennifer Runyon','David Margulies','Joe Medjuck','Frantz Turner','Paddi Edwards','Eda Reiss Merin','Norman Matlock','Joe Cirillo','Jimmy Star','Eldo Ray Estes',"James 'Hotfeet' Davis",'Paul Van'],
screenplay:['Harold Ramis','Dan Aykroyd','Rick Moranis'],
production:['Ivan Reitman'],
music:['Elmer Bernstein'],
camera:['László Kovács'],
cut:['Sheldon Kahn','David E. Blewitt'],
sound:['Richard Beggs','Rick Alexander','Kim Maitland'],
scenography:['John DeCuir','Marvin March'],
costumes:['Suzy Benzinger','Theoni V. Aldredge']},
{title:'Clash of the Titans',
titleCZ:'Souboj Titánů',
year:2010,
runtime:102,
countries:['UK','USA'],
genres:['Action','Drama','Fantasy','Adventure'],
director:['Louis Leterrier'],
actors:['Sam Worthington','Gemma Arterton','Liam Neeson','Ralph Fiennes','Jason Flemyng','Alexa Davalos','Mads Mikkelsen','Luke Evans','Izabella Miko','Liam Cunningham','Hans Matheson','Ashraf Barhom','Nicholas Hoult','Vincent Regan','Polly Walker','Luke Treadaway','Pete Postlethwaite','Elizabeth McGovern','Rory McCann','Alexander Siddig','Kaya Scodelario','Tamer Hassan','Danny Huston','Jamie Sives','Jane March','Natalija Vodjanova','Charlotte Comer','Martin McCann','William Houston','Agyness Deyn','Ian Whyte','Nina Young','Nathalie Cox','Otto Farrant','Ross Mullan','Paul Warren','Sinead Michael','Stephen Armourae','Geoffrey Beevers','Katrina Vasilieva','Mouloud Achour','Tine Stapelfeldt'],
screenplay:['Travis Beacham','Phil Hay','Matt Manfredi','Beverley Cross'],
production:['Basil Iwanyk','Richard D. Zanuck'],
music:['Ramin Djawadi'],
camera:['Peter Menzies Jr.'],
cut:['David Freeman','Martin Walsh','Vincent Tabaillon'],
sound:['James Mather','Dominic Gibbs','Michael Prestwood Smith','Mark Taylor','Ivan Sharrock','James Glenton'],
scenography:['Martin Laing','Anna Pinnock'],
masks:['Joe Hopker',"Conor O'Sullivan",'Sarah Monzani','Göran Lundström','Jenny Shircore','Zoe Clare Brown'],
costumes:['Lindy Hemming']},
{title:'Maverick',
titleCZ:'Maverick',
year:1994,
runtime:127,
countries:['USA'],
genres:['Western','Comedy','Adventure'],
director:['Richard Donner'],
actors:['Mel Gibson','Jodie Foster','James Garner','Graham Greene','Alfred Molina','James Coburn','Dub Taylor','Geoffrey Lewis','Paul L. Smith','Dan Hedaya','Denver Pyle','John Fogerty','Clint Black','Max Perlich','Corey Feldman','William Smith','Michael Paul Chan','Margot Kidder','Danny Glover','Reba McEntire','Linda Hunt','William Marshall','Charles Dierkop','Vilmos Zsigmond','Doug McClure','Art LaFleur','Robert Fuller','Will Hutchins','James Drury','Bert Remsen','Dennis Fimple','Steve Kahan','Henry Darrow','Leo Gordon','Paul Brinegar','J. Mills Goodloe','Read Morgan','Bill Henderson','Paul Tuerpe','Monica Lee Bellais','Lauren Shuler Donner','Chris M. Allport','John Otrin','Jean De Baer','Jack Garner','Patrick Fullerton','Waylon Jennings','Doc Duhame','Kimberly Cullum'],
screenplay:['William Goldman','Roy Huggins'],
production:['Richard Donner','Bruce Davey'],
music:['Randy Newman'],
camera:['Vilmos Zsigmond'],
cut:['Stuart Baird','Michael Kelly'],
sound:['Allen L. Stone','Rick Alexander'],
scenography:['Thomas E. Sanders'],
masks:['Michael Hancock'],
costumes:['April Ferry']},
{title:'Reign Over Me',
titleCZ:'Volání o pomoc',
year:2007,
runtime:124,
countries:['USA'],
genres:['Drama'],
director:['Mike Binder'],
actors:['Adam Sandler','Don Cheadle','Jada Pinkett Smith','Liv Tyler','Saffron Burrows','Donald Sutherland','Robert Klein','Melinda Dillon','Mike Binder','Jonathan Banks','John de Lancie','B. J. Novak','Ted Raimi','Paula Newsome','M.D. Walton','Lela Loren','Joey King','Arick Salmea','Imani Hakim','Tommy Nohilly','Anthony Chisholm','Rae Allen','Robert Harvey','Denise Dowse','Paul Butler','Nick Taylor','Nick Vlassopoulos'],
screenplay:['Mike Binder'],
production:['Michael Rotenberg','Jack Binder'],
music:['Rolfe Kent'],
camera:['Russ T. Alsobrook'],
cut:['Steve Edwards'],
sound:['Carlos Delarios','Matthieu Tertois'],
scenography:['Christian Wintter'],
costumes:['Deborah L. Scott']},
{title:'The Rainmaker',
titleCZ:'Vyvolávač deště',
year:1997,
runtime:130,
countries:['USA'],
genres:['Drama','Thriller'],
director:['Francis Ford Coppola'],
actors:['Matt Damon','Danny DeVito','Jon Voight','Mickey Rourke','Claire Danes','Danny Glover','Mary Kay Place','Dean Stockwell','Teresa Wright','Virginia Madsen','Andrew Shue','Johnny Whitworth','Roy Scheider','Randy Travis','Michael Keys Hall','Red West','Adrian Roberts','Alan Woolf','Sonny Shroyer','Verda Davenport','Nate Bynum','Trula M. Marcus','Billy Ray Reynolds'],
basedOn:['John Grisham'],
screenplay:['Francis Ford Coppola'],
production:['Michael Douglas','Fred Fuchs','Steven Reuther'],
music:['Elmer Bernstein'],
camera:['John Toll'],
cut:['Melissa Kent','Barry Malkin'],
sound:['Michael Semanick'],
scenography:['Howard Cummings','Barbara Munch'],
masks:['Lois Burwell'],
costumes:['Aggie Guerard Rodgers']},
{title:'Citizen Kane',
titleCZ:'Občan Kane',
year:1941,
runtime:119,
countries:['USA'],
genres:['Drama','Mystery'],
director:['Orson Welles'],
actors:['Orson Welles','Joseph Cotten','Dorothy Comingore','Agnes Moorehead','Ruth Warrick','Ray Collins','Erskine Sanford','Everett Sloane','Paul Stewart','George Coulouris','Louis Natheaux','Alan Ladd',"Arthur O'Connell",'Richard Wilson',"Nat 'King' Cole",'Gregg Toland',"William H. O'Brien",'Walter Sande','Mike Lally','Bert Stevens','Frances E. Neal','Sam Harris','Roland Winters','Danny Borzage','Gino Corrado','Sam Ash','Fortunio Bonanova','George DeNormand','Cyril Ring','Jack Curtis','Eddie Dew','Milton Kibbee',"Frank O'Connor",'Bert Moorhouse','Edith Evanson','Russ Powell','Benny Rubin','Harry Shannon','Jack Raymond','Philip Van Zandt','John Dilson','William Alland','Edmund Cobb','Renee Godfrey','John McCormack','Mickey Martin','Suzanne Ridgway','John Northpole','Frank McLure',"Paddy O'Flynn",'Buddy Messinger','Charles Meakin','Art Dupuis','Jack Gargan','Perc Launders','Larry Wheat','Sally Corner','Bud Geary','Gene Coogan','Herman J. Mankiewicz','Henry Herbert','James T. Mack','Francis Sayles','Jesse Graves','Victor Romito','Tom Coleman','Rudy Germane','Jan Wiley','Tom Steele','Joan Blair','Shimen Ruskin','Walter James','Lew Harvey','Philip Morris','Olin Francis','Irving Mitchell','Glen Turnbull','Louise Currie','Ber LeBaron','Mitchell Ingraham','Arthur Kay'],
screenplay:['Herman J. Mankiewicz','Orson Welles'],
production:['Orson Welles'],
music:['Bernard Herrmann'],
camera:['Gregg Toland'],
cut:['Robert Wise'],
sound:['Clem Portman'],
scenography:['Van Nest Polglase','Darrell Silvera'],
masks:['Maurice Seiderman'],
costumes:['Edward Stevenson']},
{title:'The Straight Story',
titleCZ:'Příběh Alvina Straighta',
year:1999,
runtime:112,
countries:['USA','UK','France'],
genres:['Biographic','Drama','Road movie'],
director:['David Lynch'],
actors:['Richard Farnsworth','Sissy Spacek','Joseph A. Carpenter','Everett McGill','Harry Dean Stanton','Kevin P. Farley','Tracey Maloney','Donald Wiegert','Anastasia Webb','Jim Haun','Cedric Cirotteau','John Farley','Sally Wingert','Jack Walsh','Lana Schwab','Wiley Harker','Barbara Kingsley','James Cada','Dan Flannery','Matt Guidry','John Lordan','Jeremy Kent Jackson'],
screenplay:['Mary Sweeney','John Roach'],
production:['Mary Sweeney','Neal Edelstein'],
music:['Angelo Badalamenti'],
camera:['Freddie Francis'],
cut:['Mary Sweeney'],
scenography:['Jack Fisk','Barbara Haberecht'],
masks:['Deborah K. Dee'],
costumes:['Patricia Norris']},
{title:'A Separation',
titleCZ:'Rozchod Nadera a Simin',
year:2011,
runtime:120,
countries:['Iran','France'],
genres:['Drama'],
director:['Asghar Farhadi'],
actors:['Payman Maadi','Leila Hatami','Sareh Bayat','Shahab Hosseini','Sarina Farhadi',"Merila Zare'i",'Bábak Karímí','Ali-Asghar Shahbazi','Shirin Yazdanbakhsh','Débora Bloch','Ali Nazari'],
screenplay:['Asghar Farhadi'],
music:['Sattar Oraki'],
camera:['Mahmoud Kalari'],
cut:['Hayedeh Safiyari']},
{title:'Living in Oblivion',
titleCZ:'Život v oblouznění',
year:1995,
runtime:90,
countries:['USA'],
genres:['Comedy','Drama'],
director:['Tom DiCillo'],
actors:['Steve Buscemi','Catherine Keener','Dermot Mulroney','James Le Gros','Danielle von Zerneck','Peter Dinklage','Kevin Corrigan','Robert Wightman','Hilary Gilford','Tom Jarmusch','Rica Martens','Lori Tan Chinn','Michael Griffiths'],
screenplay:['Tom DiCillo'],
production:['Marcus Viscidi','Michael Griffiths'],
music:['Jim Farmer'],
camera:['Frank Prinzi'],
cut:['Dana Congdon','Camilla Toniolo'],
sound:['Dominick Tavella','Mathew Price'],
scenography:['Stephanie Carroll','Thérèse DePrez'],
costumes:['Ellen Lutter']},
{title:'Love Exposure',
titleCZ:'Pod vlivem lásky',
year:2008,
runtime:237,
countries:['Japan'],
genres:['Action','Drama','Comedy','Psychology','Romance'],
director:['Šion Sono'],
actors:['Takahiro Nišidžima','Hikari Micušima','Sakura Andó','Makiko Watanabe','Acuró Watabe','Jutaka Šimizu','Hirojuki Onoue','Tasuku Nagaoka','Só Hirosawa','Júko Genkaku','Mami Nakamura','Nanami Hinata','Gó Ajano','Maju Macuoka','Icudži Itao','Motoki Fukami','Micuru Fukikoši','Usamaru Furuja','Keisuke Horibe','Júka Arai','Só Ikeno','Joriko Dóguči','Rjó Iwamacu','Umi Jamano','Rjúta Furuja','Kóiči Košimura','Nobuhiro Nišihara','Arata Jamanaka','Kunihiro Suda'],
screenplay:['Šion Sono'],
production:['Haruo Umekawa'],
music:['Tomohide Harada'],
camera:['Sóhei Tanikawa'],
cut:["Džun'iči Itó"]},
{title:'Nightcrawler',
titleCZ:'Slídil',
year:2014,
runtime:117,
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Dan Gilroy'],
actors:['Jake Gyllenhaal','Rene Russo','Riz Ahmed','Bill Paxton','Kevin Rahm','Michael Hyatt','Ann Cusack','Michael Papajohn','Marco Rodríguez','James Huang','Leah Fredkin','Rick Chambers','Jonny Coyne','Eric Lange','Myra Turley','Jamie McShane','Danny Kaye','Anne McDaniels','Kathleen York','Tyler Cole','Viviana Chavez','Aaron Bledsoe','Emily Dahm','Kevin Dunigan','Dig Wayne','Kiff VandenHeuvel'],
screenplay:['Dan Gilroy'],
production:['Tony Gilroy','Jake Gyllenhaal','Jennifer Fox','Michel Litvak','David Lancaster'],
music:['James Newton Howard'],
camera:['Robert Elswit'],
cut:['John Gilroy'],
scenography:['Kevin Kavanaugh'],
masks:['Donald Mowat'],
costumes:['Amy Westcott']},
{title:'What Ever Happened to Baby Jane?',
titleCZ:'Co se vlastně stalo s Baby Jane?',
year:1962,
runtime:134,
countries:['USA'],
genres:['Drama','Horror','Thriller'],
director:['Robert Aldrich'],
actors:['Bette Davis','Joan Crawford','Victor Buono','Wesley Addy','Julie Allred','Anne Barton','Marjorie Bennett','Robert Cornthwaite','Anna Lee','Maidie Norman','James Seay','Bert Freed','Dave Willock','Steve Condit','Jack Tornek','Russ Conway','Mike Ragan','Jon Shepodd','Maxine Cooper','Murray Alper','Michael Fox','Ralph Volkie','John Shay','Gina Gillespie','Barbara Merrill','William Aldrich','Peter Virgo','Don Ross','Bobs Watson'],
basedOn:['Henry Farrell'],
screenplay:['Lukas Heller'],
production:['Robert Aldrich'],
music:['Frank De Vol'],
camera:['Ernest Haller'],
cut:['Michael Luciano'],
sound:['Jack Solomon'],
scenography:['William Glasgow','George Sawley'],
masks:['Monty Westmore','Robert J. Schiffer','Beau Wilson','Peggy Shannon','Jack Obringer']},
{title:'Anne of the Thousand Days',
titleCZ:'Tisíc dnů s Annou',
year:1969,
runtime:145,
countries:['UK'],
genres:['Drama','History'],
director:['Charles Jarrott'],
actors:['Richard Burton','Geneviève Bujold','Irene Papas','Anthony Quayle','John Colicos','Michael Hordern','Katharine Blake','Peter Jeffrey',"Joseph O'Conor",'William Squire','Valerie Gearon','Vernon Dobtcheff','Gary Bond','Denis Quilley','Esmond Knight','T.P. McKenna','Michael Johnson','Marne Maitland','Nora Swinburne','June Ellis','Cyril Luckham','Brook Williams','Nicola Pagett','Kate Burton','Harry Fielder','Victor Harrington','Aileen Lewis','James Mellor','Terence Mountain','Kynaston Reeves','Charlotte Selwyn','Elizabeth Taylor','Royston Tickner','Anne Tirard','Amanda Walker','Jerold Wells'],
screenplay:['Bridget Boland','John Hale','Maxwell Anderson'],
production:['Hal B. Wallis'],
music:['Georges Delerue'],
camera:['Arthur Ibbetson'],
cut:['Richard Marden'],
scenography:['Maurice Carter'],
masks:['Tom Smith'],
costumes:['Margaret Furse']},
{title:'Go, See, and Become',
titleCZ:'Jdi, žij a někým se staň',
year:2005,
runtime:143,
countries:['France','Belgium','Israel','Italy'],
genres:['Drama'],
director:['Radu Mihăileanu'],
actors:['Yaël Abecassis','Roschdy Zem','Roni Hadar','Shimon Mimran','Pierre-Jean Chérer','Joy Rieger','Hervé Pauchon','Shmil Ben Ari','Patrick Descamps','Shlomo Vishinsky','Moshe Agazai','Lana Ettinger','Avi Hadash','Abraham Celektar'],
screenplay:['Radu Mihăileanu','Alain-Michel Blanc'],
production:['Denis Carot','Marco Chimenz','Giovanni Stabilini','Riccardo Tozzi','Marie Masmonteil','Itai Tamir'],
music:['Armand Amar'],
camera:['Rémy Chevrin'],
cut:['Ludo Troch'],
sound:['Henri Morelle','Eric DeVos'],
scenography:['Eitan Levi'],
masks:['Valérie Tranier'],
costumes:['Rona Doron']},
{title:'Masquerade',
titleCZ:'Králův dvojník',
year:2012,
runtime:131,
countries:['South Korea'],
genres:['History','Drama'],
director:['Chang-min Choo'],
actors:['Byung-hun Lee','Hyo-joo Han','Seung-ryong Ryoo','Joon-hyeok Lee','Eun-kyeong Shim','Myeong-gon Kim','Gwang Jang','Yong-goo Do','El I','Soon-woong Yoo','Jong-goo Kim','Yang-hee Lee','Sung-tae Heo','Gil-dong Kim','Seong-yong Han','Bae-soo Jeon','Seong-chan Son','Eun-soo Kwon','Gook-hyang Jeon','Bong-ryeon Lee','Jin-won Seo','Seung-hun Kim','Hye-hwa Kim','Ran-hee Lee','Woon-Seop Shin'],
screenplay:['Jo-yoon Hwang','Chang-min Choo'],
music:['Mowg','Jun-seong Kim','Joon-Sung Oh'],
camera:['Tae-yoon Lee'],
masks:['Tae-hee Cho'],
costumes:['Yoo-jin Kwon']},
{title:"My Mother's Castle",
titleCZ:'Maminčin zámek',
year:1990,
runtime:98,
countries:['France'],
genres:['Comedy','Drama','Romance','Biographic'],
director:['Yves Robert'],
actors:['Philippe Caubère','Nathalie Roussel','Didier Pain','Thérèse Liotard','Julien Ciamaca','Victorien Delmare','Joris Molinas','Julie Timmerman','Paul Crauchet','Philippe Uchan','Patrick Préjean','Pierre Maguelon','Michel Modo','Jean Carmet','Jean Rochefort','Georges Wilson','Jean-Pierre Darras','André Chaumeau','Raoul Curet','Alain Ganas','Ticky Holgado','Jean-Marie Juan','Louis Lalanne','Elisabeth Macocco','Jean Maurel'],
basedOn:['Marcel Pagnol'],
screenplay:['Jérôme Tonnerre','Yves Robert'],
production:['Alain Poiré'],
music:['Vladimir Cosma'],
camera:['Robert Alazraki'],
cut:['Pierre Gillette'],
sound:['Alain Sempé','Olivier Villette'],
scenography:['Jacques Dugied']},
{title:'The Red Shoes',
titleCZ:'Červené střevíčky',
year:1948,
runtime:133,
countries:['UK'],
genres:['Drama','Romance','Music'],
director:['Michael Powell','Emeric Pressburger'],
actors:['Marius Goring','Moira Shearer','Anton Walbrook','Austin Trevor','Esmond Knight','Irene Browne','Ludmila Tchérina','Albert Bassermann','Hay Petrie','Emeric Pressburger','Jean Hébey','Robert Helpmann','Robert Dorning','Charles Lisner','Bill Shine','George Woodbridge','Eric Berry','Peter Bayliss','Jane Fischer'],
basedOn:['Hans Christian Andersen'],
production:['Michael Powell','Emeric Pressburger'],
music:['Brian Easdale'],
camera:['Jack Cardiff'],
cut:['Reginald Mills'],
scenography:['Hein Heckroth'],
costumes:['Hein Heckroth']},
{title:'The Beautiful Country',
titleCZ:'Země zaslíbená',
year:2004,
runtime:120,
countries:['USA','Norway'],
genres:['Drama','War'],
director:['Hans Petter Moland'],
actors:['Damien Nguyen','Bai Ling','Nick Nolte','Tim Roth','Temuera Morrison','Arthur J. Nascarella','Carl Savering','Thi Kim Xuan Chau','Libby Villari'],
screenplay:['Sabina Murray'],
production:['Terrence Malick','Edward R. Pressman','Petter Borgli'],
music:['Zbigniew Preisner'],
camera:['Stuart Dryburgh'],
sound:['Petter Fladeby','Sturla Einarson'],
scenography:['Karl Júlíusson','William A. Cimino'],
masks:['Eva Rygh'],
costumes:['Anne Pedersen']},
{title:'Pelle the Conqueror',
titleCZ:'Pelle Dobyvatel',
year:1987,
runtime:157,
countries:['Denmark','Sweden'],
genres:['Drama'],
director:['Bille August'],
actors:['Pelle Hvenegaard','Max von Sydow','Erik Paaske','Björn Granath','Kristina Törnqvist','Morten Jørgensen','Axel Strøbye','Astrid Villaume','Lena-Pia Bernhardsson','Buster Larsen','Lars Simonsen','John Wittig','Karen Wegener','Sofie Gråbøl','Nis Bank-Mikkelsen','Troels Munk','Thure Lindhardt','Knut Schultheiß','Maria Grazia Di Meo','Jytte Strandberg','Thomas Bryde Hansen','Jørgen Hansen','Troels Asmussen','Anna Lise Hirsch Bjerrum','Nina Christoffersen','Erik Frisberg'],
basedOn:['Martin Andersen Nexø'],
screenplay:['Per Olov Enquist','Bjarne Reuter','Bille August'],
production:['Per Holst'],
music:['Stefan Nilsson'],
camera:['Jörgen Persson'],
cut:['Janus Billeskov Jansen'],
sound:['Niels Arild','Lars Lund'],
scenography:['Anna Asp'],
masks:['Kaj Grönberg'],
costumes:['Kicki Ilander']},
{title:'Shrek 2',
titleCZ:'Shrek 2',
year:2004,
runtime:93,
countries:['USA'],
genres:['Animation','Adventure','Family','Comedy'],
director:['Conrad Vernon','Andrew Adamson','Kelly Asbury'],
actors:['Mike Myers','Eddie Murphy','Cameron Diaz','Julie Andrews','Antonio Banderas','John Cleese','Rupert Everett','Jennifer Saunders','Kelly Asbury','Conrad Vernon','Chris Miller','Joan Rivers','Andrew Adamson','Christopher Knights','Larry King','Simon Cowell','Cody Cameron','Erika Thomas','Aron Warner','Guillaume Aretos','David P. Smith'],
basedOn:['William Steig'],
screenplay:['Andrew Adamson','Joe Stillman','J. David Stem','David N. Weiss'],
production:['Aron Warner','John H. Williams'],
music:['Harry Gregson-Williams'],
cut:['Sim Evan-Jones','Mike Andrews'],
sound:['Dennis Leonard','Randy Thom','Andy Nelson','Anna Behlmer'],
scenography:['Guillaume Aretos'],
costumes:['Isis Mussenden']},
{title:"Ocean's Eleven",
titleCZ:'Dannyho parťáci',
year:2001,
runtime:116,
countries:['USA'],
genres:['Crime','Comedy','Thriller'],
director:['Steven Soderbergh'],
actors:['George Clooney','Matt Damon','Andy Garcia','Brad Pitt','Julia Roberts','Carl Reiner','Bernie Mac','Elliott Gould','Casey Affleck','Scott Caan','Don Cheadle','Eddie Jemison','Shaobo Qin','Henry Silva','Angie Dickinson','Wayne Newton','Joshua Jackson','Steven Soderbergh','Holly Marie Combs','Barry Watson','Shane West','Topher Grace','Jerry Weintraub','David Jensen','Scott L. Schwartz','Lennox Lewis','Thomas Rosales Jr.','Laurence R. Griffin','Robin Sachs','Vincent M. Ward','Brad Martin','Jeremy Dunn','Charles Halford','Wladimir Klitschko','David Leitch','Jim Lampley','Jeffrey Kurland','Mark Gantt','Christopher Mann','Michael DeLano','Gustavo Perez','Bill Allison','Rusty Meyers','Miguel Pérez','Robert Peters','Jaime Gallagher','J.P. Manoux','Yann Toderi','Joe La Due','Patrick Fullerton','Tim Snay','Joss Gomez','Kerry Rossall','Frankie J. Allison'],
screenplay:['Ted Griffin','Charles Lederer','Harry Brown'],
production:['Jerry Weintraub'],
music:['David Holmes'],
camera:['Steven Soderbergh'],
cut:['Stephen Mirrione'],
scenography:['Philip Messina'],
masks:['Julie Hewett','Kathrine Gordon','Christien Tinsley'],
costumes:['Jeffrey Kurland']},
{title:'Sleepy Hollow',
titleCZ:'Ospalá díra',
year:1999,
runtime:105,
countries:['USA','Germany'],
genres:['Fantasy','Horror','Mystery'],
director:['Tim Burton'],
actors:['Johnny Depp','Christina Ricci','Miranda Richardson','Michael Gambon','Casper Van Dien','Jeffrey Jones','Richard Griffiths','Ian McDiarmid','Michael Gough','Christopher Walken','Marc Pickering','Lisa Marie','Steven Waddington','Claire Skinner','Christopher Lee','Alun Armstrong','Orlando Seale','Gabrielle Lloyd','Jamie Foreman','Layla Alexander','Martin Landau','Ray Park','Kevin Hudson','Sean Cronin','Peter Guinness','Jessica Oyelowo','Michael Feast','Philip Martin Brown','Paul Brightwell','Tony Maudsey'],
screenplay:['Andrew Kevin Walker'],
production:['Scott Rudin','Mark Roybal','Celia D. Costas','Adam Schroeder'],
music:['Danny Elfman'],
camera:['Emmanuel Lubezki'],
cut:['Chris Lebenzon','Joel Negron'],
sound:['Skip Lievsay','Lee Dichter','Frank Morrone','Bob Olari'],
scenography:['Rick Heinrichs','Peter Young','John Dexter'],
masks:['Tamsin Dorling Barbosa','Lizzie Yianni Georgiou','Bernadette Mazur','Paul Gooch'],
costumes:['Colleen Atwood']},
{title:'Blow',
titleCZ:'Kokain',
year:2001,
runtime:124,
countries:['USA'],
genres:['Crime','Drama','Biographic'],
director:['Ted Demme'],
actors:['Johnny Depp','Penélope Cruz','Franka Potente','Rachel Griffiths','Paul Reubens','Jordi Mollà','Cliff Curtis','Miguel Sandoval','Ethan Suplee','Ray Liotta','Kevin Gage','Max Perlich','Jesse James','Tony Amendola','Bobcat Goldthwait','Monet Mazur','Emma Roberts','Jaime King','Kevin Chapman','Ted Demme','Richard LaGravenese','Nick Cassavetes','Lola Glaudini','Elizabeth Rodriguez','Brian Goodman','Michael Tucci','Miguel Ángel Fuentes','Melissa Reneé Martin','Twyla Banks','Mauricio Mendoza','Brad Hunt','Julia Vera','Bobby Reed','Tony Perez','Michael Ralph','Gonzalo Menendez','Crafty St. James','Dan Ferro','Daniel Escobar','Miguel Pérez','Charles Noland','Bert Rosario','Dale Snowberger','Dorothy Lyman','Jorge Jimenez','Piño Moreau','Jodie Mann','Greg Bronson','Al Coronel','Pamela Abdy',"Skip O'Brien",'Raoul N. Rizik','Ajgie Kirkland'],
basedOn:['Bruce Porter'],
screenplay:['David McKenna','Nick Cassavetes'],
production:['Ted Demme','Denis Leary','Joel Stillerman','Tomáš Krejčí'],
music:['Graeme Revell'],
camera:['Ellen Kuras'],
cut:['Kevin Tent'],
sound:['Michael Keller','Mark P. Stoeckinger','Patrick Cyccone Jr.'],
scenography:['Michael Z. Hanan','Douglas A. Mowat'],
masks:['Desne J. Holland','Ve Neill','Martin Samuel','Jamie Kelman','Alfredo Mora','Kevin Yagher','Bonnie Walker'],
costumes:['Mark Bridges']},
{title:'The Notebook',
titleCZ:'Zápisník jedné lásky',
year:2004,
runtime:123,
countries:['USA'],
genres:['Romance','Drama'],
director:['Nick Cassavetes'],
actors:['Rachel McAdams','Ryan Gosling','Gena Rowlands','James Garner','Joan Allen','James Marsden','Kevin Connolly','Sam Shepard','Paul Johansson','Obba Babatundé','Traci Dinwiddie','Nancy De Mayo','Heather Wahlquist','Cullen Moss','Leslea Fisher','David Thornton','Jamie Anne Allman','Robert Fraisse','Matthew Barry','Starletta DuPois','Sandra Elise Williams','Elizabeth Bond','Mark Johnson','Michael D. Fuller','Mark Garner','Rebecca Koon','Ed Grady','Cameron Thrower','Deborah Hobart','Sylvia Jefferies','Meredith Zealy'],
basedOn:['Nicholas Sparks'],
screenplay:['Jeremy Leven'],
production:['Mark Johnson','Lynn Harris'],
music:['Aaron Zigman'],
camera:['Robert Fraisse'],
cut:['Alan Heim'],
sound:['Claude Letessier','Jon Taylor','Kelly Cabral','Brad Sherman'],
scenography:['Sarah Knowles'],
masks:['Cecilia Verardi','Linda Grimes'],
costumes:['Karyn Wagner']},
{title:'Lethal Weapon 3',
titleCZ:'Smrtonosná zbraň 3',
year:1992,
runtime:111,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Richard Donner'],
actors:['Mel Gibson','Danny Glover','Joe Pesci','Rene Russo','Stuart Wilson','Steve Kahan','Darlene Love','Traci Wolfe','Damon Hines','Ebonie Smith','Nick Chinlund','Alan Scarfe','Sven-Ole Thorsen','Miguel A. Núńez Jr.','Paul Hipp','Stephen Kay','Mark Pellegrino','Mic Rodgers','Jan de Bont','Kenneth Tigar','Jack McGee','Mary Ellen Trainor','John Cenatiempo','Scott Bryce','Paul Ganus','J. Mills Goodloe','Paul Tuerpe','Jason Rainwater','Lauren Shuler Donner','Marian Collier','Selma Archerd','James Oliver','Vince Howard','Henry Kingi','Henry Brown','Pete Antico','Veronica Alicino','Delores Hall','Anthony Johnson','Damon Stout','Andrew Hill Newman'],
screenplay:['Jeffrey Boam','Robert Mark Kamen'],
production:['Richard Donner','Joel Silver'],
music:['Michael Kamen','Eric Clapton','David Sanborn'],
camera:['Jan de Bont'],
cut:['Robert Brown','Battle Davis'],
sound:['Franklin Jones Jr.','Tom E. Dahl'],
scenography:['James H. Spencer'],
masks:['Scott H. Eddo'],
costumes:['Teresa Goikoetxea']},
{title:'Sully',
titleCZ:'Sully: Zázrak na řece Hudson',
year:2016,
runtime:96,
countries:['USA'],
genres:['Drama','Biographic'],
director:['Clint Eastwood'],
actors:['Tom Hanks','Aaron Eckhart','Laura Linney',"Mike O'Malley",'Anna Gunn','Jamey Sheridan','Ann Cusack','Molly Hagan','Holt McCallany','Chris Bauer','Patch Darragh','Valerie Mahaffey','Laura Lundy','Gary Weeks','Jeff Kober','Molly Bernard','Purva Bedi','Max Adler','Sam Huntington','Christopher Curry','Ashley Austin Morris','Cooper Thornton','Autumn Reeser','Jeffrey Nordling','Robert C. Treveiler','Pascal Yen-Pfister','Marcia DeBonis','Adam Boyer','Wilbur Fitzgerald','Michael Rapaport','Jeremy Luke','Bernardo Badillo','Jerry Ferrara','Graham Sibley','Wayne Bastrup','Billy Smith','E. Roger Mitchell','Robert Pralgo','Clayton Landey','Tracee Chimo Pallero','Brett Rice','Shane P. Allen','Venus Dana','Lynn Marocola','Doris McCarthy','Chesley Sullenberger'],
basedOn:['Chesley Sullenberger','Jeffrey Zaslow'],
screenplay:['Todd Komarnicki'],
production:['Clint Eastwood','Frank Marshall','Allyn Stewart','Tim Moore'],
music:['Christian Jacob'],
camera:['Tom Stern'],
cut:['Blu Murray'],
sound:['José Antonio García','Alan Robert Murray','Bub Asman','Tom Ozanich','John T. Reitz'],
scenography:['James J. Murakami','Gary Fettis'],
masks:['Patricia Dehaney','Luisa Abel'],
costumes:['Deborah Hopper']},
{title:'Ghost Dog: The Way of the Samurai',
titleCZ:'Ghost Dog - Cesta samuraje',
year:1999,
runtime:116,
countries:['USA','France','Germany','Japan'],
genres:['Action','Drama','Crime','Thriller'],
director:['Jim Jarmusch'],
actors:['Forest Whitaker','John Tormey','Cliff Gorman','Dennis Liu','Richard Portnow','Tricia Vessey','Henry Silva','Frank Adonis','Victor Argo','Gano Grills','Chuck Jeffreys','Isaach De Bankolé','Gary Farmer','Tracy Howe','Harry Shearer','RZA','Sharon Angela','Jamie Hector','Joseph Rigano','Vinny Vella','Scott Bryce','Gene Ruffini','Camille Winbush','Damon Whitaker','Paul Diomede','Clebert Ford'],
screenplay:['Jim Jarmusch'],
production:['Jim Jarmusch','Richard Guay'],
music:['RZA'],
camera:['Robby Müller'],
cut:['Jay Rabinowitz'],
sound:['Dominick Tavella'],
scenography:['Ron von Blomberg'],
masks:['Neal Martz','Judy Chin'],
costumes:['John Dunn']},
{title:'Wallace & Gromit in The Curse of the Were-Rabbit',
titleCZ:'Wallace & Gromit: Prokletí králíkodlaka',
year:2005,
runtime:85,
countries:['UK'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Nick Park','Steve Box'],
actors:['Peter Sallis','Helena Bonham Carter','Ralph Fiennes','John Thomson','Geraldine McEwan','Peter Kay','Christopher Fairbank','Liz Smith','Edward Kelsey','Nicholas Smith','James Mather'],
screenplay:['Nick Park','Steve Box','Mark Burton'],
production:['David Sproxton','Carla Shelley'],
music:['Julian Nott'],
camera:['Dave Alex Riddett','Tristan Oliver'],
cut:['Gregory Perler'],
sound:['James Mather','Sven Taits']},
{title:'Elite Squad',
titleCZ:'Elitní jednotka',
year:2007,
runtime:118,
countries:['Brazil','USA','Argentina'],
genres:['Action','Drama','Crime','Thriller'],
director:['José Padilha'],
actors:['Wagner Moura','André Ramiro','Caio Junqueira','Milhem Cortaz','Fernanda Machado','Maria Ribeiro','Paulo Vilela','Fernanda de Freitas','Fábio Lago','Otto Jr.','Juliano Cazarré','Emerson Gomes','Augusto Madeira','Suzana Pires','Nathalia Dill','Thogun Teixeira','Sandro Rocha','Marcelo Valle','André Di Mauro','Saulo Rodrigues','Allan Guilherme'],
basedOn:['André Batista','Rodrigo Pimentel','Luiz Eduardo Soares'],
screenplay:['Bráulio Mantovani','José Padilha','Rodrigo Pimentel'],
production:['José Padilha','Marcos Prado'],
music:['Pedro Bromfman'],
camera:['Lula Carvalho'],
cut:['Daniel Rezende'],
sound:['Leandro Lima','Alessandro Laroca','Armando Torres Jr.'],
scenography:['Tulé Peak','Odair Zani'],
masks:['Martín Macías Trujillo'],
costumes:['Cláudia Kopke']},
{title:'Asterix and Cleopatra',
titleCZ:'Asterix a Kleopatra',
year:1968,
runtime:72,
countries:['France','Belgium'],
genres:['Animation','Adventure','Comedy','Family'],
director:['René Goscinny','Albert Uderzo'],
actors:['Roger Carel','Pierre Tornade','Henri Labussière','René Goscinny','Jacques Balutin','Micheline Dax','Bernard Lavalette','Serge Sauvion','Pierre Trabaud','Jacques Morel','Rodolphe Marcilly','Hans Hessling','Edgar Ott','Walter Bluhm','Otto Czarski','Martin Hirthe','Claude Dasset'],
basedOn:['René Goscinny','Albert Uderzo'],
screenplay:['Pierre Tchernia','Jos Marissen'],
music:['Gérard Calvi'],
sound:['Jacques Maumont']},
{title:'The Piano',
titleCZ:'Piano',
year:1993,
runtime:121,
countries:['Australia','New Zealand','France'],
genres:['Drama','Romance','Music'],
director:['Jane Campion'],
actors:['Holly Hunter','Harvey Keitel','Sam Neill','Anna Paquin','Kerry Walker','Geneviève Lemon','Ian Mune','Pete Smith','Bruce Allpress','Cliff Curtis','Hori Ahipene','Mika X.','Tamati Rice','Eddie Campbell','Jon Brazier','Stephen Papps','Timothy Raby','Rose McIver','Eru Potaka Dewes'],
screenplay:['Jane Campion'],
production:['Jan Chapman'],
music:['Michael Nyman'],
camera:['Stuart Dryburgh'],
cut:['Veronika Jenet'],
sound:['Lee Smith','Tony Johnson'],
scenography:['Andrew McAlpine'],
masks:['Noriko Watanabe'],
costumes:['Janet Patterson']},
{title:"A Hard Day's Night",
titleCZ:'Perný den',
year:1964,
runtime:87,
countries:['UK'],
genres:['Comedy','Music'],
director:['Richard Lester'],
actors:['John Lennon','Paul McCartney','George Harrison','Ringo Starr','Wilfrid Brambell','John Bluthal','Phil Collins','Victor Spinetti','Margaret Nolan','Rosemarie Frankland','Anna Quayle','David Janson','Richard Vernon','Pattie Boyd','Marianne Stone','Isla Blair','Jeremy Lloyd','Kenneth Haigh','Derek Nimmo','Edward Malin','Edina Ronay','David Langton','Victor Harrington','Hedger Wallace','Andre Charisse','Pauline Chamberlain','Neil Wilson','Roger Avon','Maxwell Craig','Fred Wood','Julian Holloway','Bruce Beepy','Norman Rossington','Noel Trevarthen',"Jim O'Brady",'John Junkin','Gordon Rollings','Mal Evans','Lionel Blair','Deryck Guyler','The Beatles','Ric Hutton','Brian Epstein','Charlie Bird'],
screenplay:['Alun Owen'],
production:['Walter Shenson'],
music:['John Lennon','Paul McCartney'],
camera:['Gilbert Taylor'],
cut:['Bedřich Voděrka','John Jympson'],
sound:['Dominick Tavella'],
masks:["John O'Gorman"],
costumes:['Julie Harris']},
{title:'Land of Mine',
titleCZ:'V písku - Příslib svobody',
year:2015,
runtime:101,
countries:['Denmark','Germany'],
genres:['War','History','Drama'],
director:['Martin Zandvliet'],
actors:['Roland Møller','Louis Hofmann','Joel Basman','Mikkel Boe Følsgaard','Laura Bro','Zoe Zandvliet','Mads Riisom','Oskar Bökelmann','Emil Belton','Oskar Belton','Leon Seidel','Karl Alexander Seidel','Max Beck','August Carter','Tim Bülow','Alexander Rasch','Julius Kochinke','Aaron Koszuta','Levin Henning','Michael Asmussen','Magnus Bruun','Mette Lysdahl','Johnny Melville','Anthony Straeger','Samuel Charle','Martin Roskowetz','Kim Winther'],
screenplay:['Martin Zandvliet'],
production:['Malte Grunert','Mikael Chr. Rieks'],
music:['Sune Martin'],
camera:['Camilla Hjelm Knudsen'],
cut:['Per Sandholt','Molly Malene Stensgaard'],
sound:['Rasmus Winther Jensen','Johannes Elling Dam','Lars Ginzel'],
scenography:['Gitte Malling','Kay Anthony'],
masks:['Barbara Kreuzer','Sonia Salazar Zivoder'],
costumes:['Stefanie Bieker','Claudia Maria Braun']},
{title:'Battleship Potemkin',
titleCZ:'Křižník Potěmkin',
year:1925,
runtime:75,
countries:['Russia'],
genres:['Drama','History','War'],
director:['Sergej M. Ejzenštejn'],
actors:['Alexandr Antonov','Grigorij Alexandrov','Ivan Bobrov','Sergej M. Ejzenštejn','Vladimir Uralskij','Andrej Fajt','Aleksanteri Ahola-Valo','Roman Širman'],
screenplay:['Nina Agadžanova-Šutko','Sergej M. Ejzenštejn'],
music:['Edmund Meisel'],
camera:['Eduard Tisse','Vladimir Popov']},
{title:'Rope',
titleCZ:'Provaz',
year:1948,
runtime:80,
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Alfred Hitchcock'],
actors:['James Stewart','John Dall','Farley Granger','Edith Evanson','Douglas Dick','Joan Chandler','Cedric Hardwicke','Constance Collier','Dick Hogan','Alfred Hitchcock'],
screenplay:['Patrick Hamilton','Ben Hecht','Hume Cronyn'],
production:['Alfred Hitchcock'],
music:['David Buttolph'],
camera:['Joseph A. Valentine','William V. Skall'],
cut:['William H. Ziegler'],
scenography:['Perry Ferguson','Howard Bristol'],
masks:['Perc Westmore']},
{title:"They Shoot Horses, Don't They?",
titleCZ:'Koně se také střílejí',
year:1969,
runtime:120,
countries:['USA'],
genres:['Drama'],
director:['Sydney Pollack'],
actors:['Jane Fonda','Michael Sarrazin','Susannah York','Gig Young','Red Buttons','Bonnie Bedelia','Bruce Dern','Felice Orlandi','Art Metrano','Tim Herbert','Ian Abercrombie','Marilyn Hassett','Severn Darden','Al Lewis','Allyn Ann McLerie','Kenner G. Kemp','Philo McCullough','Cynthia Myers','Paul Mantee','Robert Fields','Jacquelyn Hyde','Bobby Hutcherson','Michael Conrad',"Noble 'Kid' Chissell",'Beverlee McKinsey','Richard LaMarr','Hadley Caliman','Mary Gregory','Tom McFadden','Joe Pine','Robert Buckingham'],
basedOn:['Horace McCoy'],
screenplay:['James Poe','Robert E. Thompson'],
production:['Irwin Winkler','Robert Chartoff'],
music:['Johnny Green'],
camera:['Philip H. Lathrop'],
cut:['Fredric Steinkamp'],
sound:['Tex Rudloff'],
scenography:['Harry Horner','Frank R. McKelvy'],
costumes:['Donfeld']},
{title:'The Count of Monte Cristo',
titleCZ:'Hrabě Monte Christo',
year:2002,
runtime:126,
countries:['UK','USA','Ireland'],
genres:['Adventure','Drama','Romance','Thriller'],
director:['Kevin Reynolds'],
actors:['James Caviezel','Guy Pearce','Richard Harris','James Frain','Dagmara Dominczyk','Michael Wincott','Freddie Jones','Barry Cassin','Luis Guzmán','JB Blanc','Helen McCrory','Henry Cavill','Alex Norton','Patrick Godfrey','Gregor Truter','Albie Woodington','Christopher Adamson','Derek Reid','Zahara Moufid'],
basedOn:['Alexandre Dumas st.'],
screenplay:['Jay Wolpert'],
production:['Roger Birnbaum','Jonathan Glickman'],
music:['Edward Shearmur'],
camera:['Andrew Dunn'],
cut:['Stephen Semel'],
scenography:['Mark Geraghty'],
masks:['Lynda Armstrong','Uxue Laguardia'],
costumes:['Tom Rand']},
{title:'Winter Light',
titleCZ:'Hosté večeře Páně',
year:1963,
runtime:81,
countries:['Sweden'],
genres:['Drama'],
director:['Ingmar Bergman'],
actors:['Gunnar Björnstrand','Ingrid Thulin','Gunnel Lindblom','Max von Sydow','Allan Edwall','Kolbjörn Knudsen','Olof Thunberg','Elsa Ebbesen','Tor Borong','Lars-Owe Carlberg','Bertha Sånnell'],
screenplay:['Ingmar Bergman'],
production:['Allan Ekelund'],
camera:['Sven Nykvist'],
cut:['Ulla Ryghe'],
sound:['Stig Flodin'],
scenography:['P.A. Lundgren'],
masks:['Börje Lundh','Gullan Westfelt'],
costumes:['Mago']},
{title:'In Cold Blood',
titleCZ:'Chladnokrevně',
year:1967,
runtime:134,
countries:['USA'],
genres:['Crime','Drama'],
director:['Richard Brooks'],
actors:['Robert Blake','Scott Wilson','John Forsythe','Paul Stewart',"Gerald S. O'Loughlin",'Jeff Corey','John Gallaudet','James Flavin','Charles McGraw','Will Geer','Rhonda Fultz','Stan Levitt','Raymond Hatton','John McLiam','Vaughn Taylor','Paul Frees','Sheldon Allman','Nick Dimitri','Roosevelt Grier','Paul Carr','Richard Kelton','Bobby Johnson','Al Christy','Ted Eccles','Mary Linda Rapelye','John C. Flinn III','Gerry Okuneff','Brenda Currin'],
basedOn:['Truman Capote'],
screenplay:['Richard Brooks'],
production:['Richard Brooks'],
music:['Quincy Jones'],
camera:['Conrad L. Hall'],
cut:['Peter Zinner'],
scenography:['Robert F. Boyle','Jack H. Ahern']},
{title:'Cars',
titleCZ:'Auta',
year:2006,
runtime:116,
countries:['USA'],
genres:['Animation','Comedy','Family','Sport'],
director:['John Lasseter','Joe Ranft'],
actors:['Owen Wilson','Paul Newman','Bonnie Hunt','Larry the Cable Guy','Cheech Marin','Tony Shalhoub','Jenifer Lewis','Paul Dooley','Teddy Newton','George Carlin','Katherine Helmond','Michael Keaton','Jeremy Piven','Bob Costas','Richard Kind','Andrew Stanton','Michael Schumacher','Jay Leno','Lou Romano','Tom Hanks','Tim Allen','Billy Crystal','John Goodman','Dave Foley','Joe Ranft','Elissa Knight','Jeremy Clarkson','Dan Scanlon','Frank Welker','Sheryl Crow','Jim Ward','John Ratzenberger','Lindsey Collins','Ken Schretzmann','Edie McClurg','Teresa Ganzel','Michael Bell','Mario Andretti','Susan Blu','Stephen Schaffer','Jeroen van Inkel','Guido Quaroni','Zarko Potocnjak','Paul Eiding','Jan Rabson','Jennifer Darling','Danny Mann','Torbin Xan Bullock','Jack Angel','Dale Earnhardt Jr.'],
screenplay:['Dan Fogelman','John Lasseter','Joe Ranft','Robert L. Baird','Phil Lorin','Jorgen Klubien'],
production:['Darla K. Anderson'],
music:['Randy Newman'],
camera:['Jeremy Lasky'],
cut:['Ken Schretzmann'],
sound:['Gary Summers']},
{title:'Rocky IV',
titleCZ:'Rocky IV',
year:1985,
runtime:91,
countries:['USA'],
genres:['Drama','Sport'],
director:['Sylvester Stallone'],
actors:['Sylvester Stallone','Talia Shire','Burt Young','Carl Weathers','Brigitte Nielsen','Tony Burton','Michael Pataki','Dolph Lundgren','Al Bandiero','Dominic Barto','James Brown','Read Morgan','Sylvia Meals','Gabriel Campisi','Marty Denkin','Dan Bradford','Lou Fillipo','Jeff Austin','Gerald Berns','Howard Maurer','Leslie Morris','Ray Glanzmann','David Lloyd Austin','Craig Schaefer'],
screenplay:['Sylvester Stallone'],
production:['Irwin Winkler','Robert Chartoff'],
music:['Vince DiCola'],
camera:['Bill Butler'],
cut:['John W. Wheeler','Don Zimmerman'],
sound:["Ray O'Reilly",'Jay M. Harding'],
scenography:['Bill Kenney'],
masks:['Jayne Dancose','Barbara Lorenz','Stephen Abrums'],
costumes:['Tom Bronson']},
{title:'Closely Watched Trains',
titleCZ:'Ostře sledované vlaky',
year:1966,
runtime:92,
countries:['Czechoslovakia'],
genres:['Comedy','Drama'],
director:['Jiří Menzel'],
actors:['Václav Neckář','Josef Somr','Vlastimil Brodský','Vladimír Valenta','Alois Vachek','Ferdinand Krůta','Jitka Bendová','Jitka Zelenohorská','Naďa Urbánková','Libuše Havelková','Květa Fialová','Pavla Maršálková','Milada Ježková','Zuzana Minichová','Václav Fišer','Miloslav Homola','Karel Hovorka st.','Vladimír Hrabánek','František Husák','Jiří Kodet','Václav Kotva','František Marek','Antonín Pražák','Dagmar Zikánová','Jiří Menzel','Jiří Hálek','Bohumil Koška','Emil Iserle','Ivan Sova','Jana Hana Duffková','Milan Frkal','František Golyšev','Gustav Hrdlička','Mahulena Kulendíková','Pavel Landovský','František Novák','Vratislav Blažek','Zdeňka Tichá','Jaroslav Toms','Nora Tvrzská','Josef Vondráček','Miloň Novotný','Josef Abrhám','Vlasta Kahovcová'],
basedOn:['Bohumil Hrabal'],
screenplay:['Bohumil Hrabal','Jiří Menzel'],
production:['Carlo Ponti'],
music:['Jiří Šust'],
camera:['Jaromír Šofr'],
cut:['Jiřina Lukešová'],
sound:['Jiří Pavlík'],
scenography:['Oldřich Bosák'],
masks:['Miloslav Koubek'],
costumes:['Olga Dimitrovová']},
{title:'The Wing and the Thigh',
titleCZ:'Křidýlko nebo stehýnko',
year:1976,
runtime:104,
countries:['France'],
genres:['Comedy'],
director:['Claude Zidi'],
actors:['Louis de Funès','Coluche','Ann Zacharias','Julien Guiomar','Claude Gensac','Georges Chamarat','Jean Martin','Fernand Guiot','Gérard Boucaron','Antoine Marin','Yves Afonso','Raymond Bussières','Philippe Bouvard','Marcel Dalio','Vittorio Caprioli','Daniel Langlet','Martin Lamotte','Paul Bisciglia','Robert Lombard','Pierre Forget','Aurora Maris','Eduardo Bergara Leumann','Gérard Lorin','Albert Michel','Bob Morel','Max Montavon','Pierre Decazes','Marie-Anne Chazel','Mac Ronay','Dominique Davray','Dyanik Zurakowska','François Viaur','Gérard Victor','François Guillaume','Catherine Meurisse','Gérard Lanvin'],
screenplay:['Claude Zidi'],
production:['Bernard Artigues'],
music:['Vladimir Cosma'],
camera:['Claude Renoir'],
cut:['Monique Isnardon','Robert Isnardon'],
sound:['Jean-Claude Laureux','Claude Villand','Maurice Laumain'],
scenography:['Michel de Broin'],
masks:['Anatole Paris','Marie-Madeleine Paris'],
costumes:['Jacques Fonteray']},
{title:'Aladdin',
titleCZ:'Aladin',
year:2019,
runtime:128,
countries:['USA'],
genres:['Adventure','Family','Fantasy','Musical','Romance'],
director:['Guy Ritchie'],
actors:['Mena Massoud','Will Smith','Naomi Scott','Marwan Kenzari','Navid Negahban','Billy Magnussen','Nasim Pedrad','Numan Acar','Alan Tudyk','Frank Welker','Jordan A. Nash','Jamal Sims','Nina Wadia','Stefan Kalipha','Joey Ansah','Will Blagrove','Kamil Lemieszewski','Amar Chadha-Patel','Nicky Andersen','Maryke Hendrikse','Ocean Navarro','Lucas Antoine Starrets','Alice Dinnean'],
screenplay:['John August','Guy Ritchie'],
production:['Dan Lin','Jonathan Eirich'],
music:['Alan Menken'],
camera:['Alan Stewart'],
cut:['James Herbert'],
sound:['Dominic Gibbs','Michael Prestwood Smith','Mark Taylor','Simon Hayes'],
scenography:['Gemma Jackson','Tina Jones','Steve Summersgill'],
masks:['Susan Cole','Lesa Warrener'],
costumes:['Michael Wilkinson']},
{title:'Delusions of Grandeur',
titleCZ:'Pošetilost mocných',
year:1971,
runtime:103,
countries:['France','Spain','Italy','Germany'],
genres:['Comedy','History'],
director:['Gérard Oury'],
actors:['Louis de Funès','Yves Montand','Alice Sapritch','Karin Schubert','Alberto de Mendoza','Don Jaime de Mora y Aragón','Eduardo Fajardo','Antonio Pica','Joaquín Solís','Venantino Venantini','Gabriele Tinti','Paul Préboist','Sal Borgese','Astrid Frank','Robert Le Béal','Clément Michu','La Polaca','Leopoldo Trieste','Ángel Álvarez','Fernando Bilbao','Xan das Bolas','Frank Braña','Fabián Conde','Fernando Hilbeck','Antonio Iranzo','Ricardo Palacios','Jesús Tordesillas','Roger Carel','Lita Recio','Pierre Tornade'],
screenplay:['Gérard Oury','Danièle Thompson','Marcel Jullian','Victor Hugo','Sandro Continenza'],
production:['Alain Poiré'],
music:['Michel Polnareff'],
camera:['Henri Decaë'],
cut:['Albert Jurgenson'],
sound:['Antoine Bonfanti','Jacques Maumont','André Louis'],
scenography:['Georges Wakhévitch'],
costumes:['Jacques Fonteray']},
{title:"Monty Python's The Meaning of Life",
titleCZ:'Monty Pythonův smysl života',
year:1983,
runtime:107,
countries:['UK'],
genres:['Comedy','Musical'],
director:['Terry Jones','Terry Gilliam'],
actors:['Graham Chapman','John Cleese','Terry Gilliam','Eric Idle','Terry Jones','Michael Palin','Carol Cleveland','Matt Frewer','Jane Leeves','Patricia Quinn','Andrew Bicknell','Simon Jones','Eric Francis','Peter Merrill'],
screenplay:['Terry Jones','Terry Gilliam','Michael Palin','John Cleese','Eric Idle','Graham Chapman'],
production:['John Goldstone'],
music:['John Du Prez'],
camera:['Roger Pratt','Peter Hannan'],
scenography:['Harry Lange'],
masks:['Maggie Weston','Christopher Tucker'],
costumes:['James Acheson']},
{title:'Ip Man 2: Legend of the Grandmaster',
titleCZ:'Ip Man 2',
year:2010,
runtime:108,
countries:['Hong Kong','China'],
genres:['Action','Drama','History','Sport','Biographic'],
director:['Wilson Yip'],
actors:['Donnie Yen','Xiaoming Huang','Sammo Hung','Lynn Hung','Kent Cheng','Darren Shahlavi','Dennis To','Simon Yam','Terry Fan','Meng Lo','Hak-on Fung','Carlson Cheng','Cindy Yuan','Ashton Chen','Stefan Morawietz','Pierre Ngo',"Christian 'Kang' Bachini"],
screenplay:['Edmond Wong','Tai-lee Chan'],
production:['Ann An','Raymond Pak-Ming Wong'],
music:['Kendži Kawai'],
camera:['Hang-Sang Poon','Davy Lin-yau Tsou'],
cut:['Ka-Fai Cheung'],
sound:['Kinson Tsang','Steve Burgess'],
scenography:['Kenneth Mak'],
masks:['Maggie Choy'],
costumes:['Pik-Kwan Lee']},
{title:'A Bridge Too Far',
titleCZ:'Příliš vzdálený most',
year:1977,
runtime:175,
countries:['USA','UK'],
genres:['War','Drama','History'],
director:['Richard Attenborough'],
actors:['Dirk Bogarde','James Caan','Michael Caine','Sean Connery','Edward Fox','Elliott Gould','Gene Hackman','Anthony Hopkins','Hardy Krüger','Laurence Olivier',"Ryan O'Neal",'Robert Redford','Maximilian Schell','Liv Ullmann','Denholm Elliott','Peter Faber','Christopher Good','Frank Grimes','Jeremy Kemp','Wolfgang Preiss','Nicholas Campbell','Paul Copley','Donald Douglas','Keith Drinkel','Colin Farrell','Richard Kane','Walter Kohut','Paul Maxwell','Stephen Moore','Donald Pickering','Gerald Sim','Mary Smithuysen','John Stride',"Erik van 't Wout",'Marlies van Alcmaer','Alun Armstrong','David Auker','Michael Bangerter','Hartmut Becker','Siem Vroom','Hans von Borsody','Michael Byrne','Michael Graham Cox','Hans Croiset','Lex van Delden','Garrick Hagon','Geoffrey Hinsliff','John Judd','Stanley Lebor','Barry McCarthy','Anthony Milner','Anthony Pullen Shaw','John Ratzenberger','John Salthouse','Peter Settelen','Chris Williams','Fred Williams','Simon Chandler','Ben Cross','Sean Mathias','Hilary Minster','Arthur Hill','Patrick Ryecart','Stewart Guidotti','Norman Gregory','Adolf Hitler','Winston Churchill','Franklin D. Roosevelt','Erwin Rommel','Charles de Gaulle','Dwight D. Eisenhower','Alfred Jodl','Brian Gwaspari','Erik Chitty','Jon Croft','Jack Galloway','Brian Hawksley','George Innes','George S. Patton','Johan te Slaa','Georgette Reyevski','Shaun Curry','Ray Jewers','Stephen Churchett','Adriënne Kleiweg','Tim Beekman','Dick Rienstra','Tom van Beek','Henny Alma','Frank Jarvis','Richard Attenborough','Harry Ditson','Jack McKenzie'],
basedOn:['Cornelius Ryan'],
screenplay:['William Goldman'],
production:['Joseph E. Levine'],
music:['John Addison'],
camera:['Geoffrey Unsworth'],
cut:['Antony Gibbs'],
scenography:['Terence Marsh'],
masks:['Tom Smith'],
costumes:['Anthony Mendleson']},
{title:'My Sassy Girl',
titleCZ:'Yeopgijeogin geunyeo',
year:2001,
runtime:124,
countries:['South Korea'],
genres:['Drama','Comedy','Romance'],
director:['Jae-yong Kwak'],
actors:['Ji-hyeon Jeon','Tae-hyeon Cha','In-moon Kim','Jae-yong Kwak','Jin-hee Han','Moo-yeong Lee','Tae-hyeon Jin','Jeong-hak Lee','Ok-sook Song','Soon-cheol Yoo','Ho Im','Min-jae Kim','Geum-seok Yang','Hae-sook Kim','Nozomu Iwao','Kyung-hoon Jo'],
basedOn:['Ho-sik Kim'],
screenplay:['Jae-yong Kwak'],
music:['Hyeong-seok Kim'],
camera:['Sung-bok Kim']},
{title:'The Killing Fields',
titleCZ:'Vražedná pole',
year:1984,
runtime:141,
countries:['UK'],
genres:['Drama','War','History'],
director:['Roland Joffé'],
actors:['Sam Waterston','Haing S. Ngor','John Malkovich','Julian Sands','Craig T. Nelson','Spalding Gray','Bill Paterson','Athol Fugard','Mark Long','Patrick Malahide','Nell Campbell','Joanna Merlin','Ira Wheeler','Jay Barney'],
screenplay:['Bruce Robinson'],
production:['David Puttnam'],
music:['Mike Oldfield'],
camera:['Chris Menges'],
cut:['Jim Clark'],
scenography:['Roy Walker'],
costumes:['Judy Moorcroft']},
{title:'It Happened One Night',
titleCZ:'Stalo se jedné noci',
year:1934,
runtime:105,
countries:['USA'],
genres:['Romance','Comedy','Adventure','Road movie'],
director:['Frank Capra'],
actors:['Clark Gable','Claudette Colbert','Walter Connolly','Roscoe Karns','Jameson Thomas','Alan Hale','Arthur Hoyt','Blanche Friderici','Charles C. Wilson','Ernie Adams','Jessie Arnold','Irving Bacon','Dolores Fuller','William Bailey','Ward Bond','James Burke','Edmund Burns','Harry C. Bradley','Harry Schultz','George P. Breakston','Ken Carson','Charles A. Browne','Joseph Crehan','Claire McDowell','Frank Yaconelli','Sherry Hall','Wallis Clark','Ray Cooke','Ray Creighton','Jack Curtis','Mickey Daniels','Eva Dennison','Neal Dodd','Oliver Eckhardt','Billy Engle','Jack Evans','Bess Flowers','Allen Fox','Joaquin Garay','Carlton Griffin','Kit Guard','Arthur Richard Haysel','Frank Holliday','Harry Holman','Harry Hume','William Irving','Sam Josephson','Milton Kibbee','Mimi Lindell','Marvin Loback','Rose May','William McCall','Kate Morgan',"Patsy O'Byrne",'Earl Pingree','Hal Price','Margaret Reid','Ky Robinson','Blanche Rose','Rita Ross','Matty Roubert','Marvin Schecter','Bert Scott','Harry Semels','S.S. Simon','Linda Lee Solomon','Bert Starkey','Ethel Sykes','Jane Talent','Emma Tansey','Harry Todd','Maidel Turner','William Wagner','John Wallace','Fred Walton','Dave Wengren','Billy West','Eddy Chandler','June Preston'],
basedOn:['Samuel Hopkins Adams'],
screenplay:['Robert Riskin'],
production:['Frank Capra'],
music:['Howard Jackson'],
camera:['Joseph Walker'],
cut:['Gene Havlick'],
scenography:['Stephen Goossón'],
costumes:['Robert Kalloch']},
{title:'Berserk: Golden Age Arc III - Descent',
titleCZ:'Berserk: Ógon džidai hen III - Kórin',
year:2013,
runtime:110,
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy'],
director:['Tošijuki Kubooka','Kóiči Hacumi'],
actors:['Akio Ócuka','Aki Tojosaki','Mijuki Sawaširo','Nobujuki Kacube','Júki Kadži','Ajana Taketacu','Kazuki Jao','Takahiro Sakurai','Minako Kotobuki','Kenta Mijake','Hiroaki Iwanaga','Ajako Takeuči','Rikija Kojama','Joširó Macumoto','Toa Jukinari','Takahiro Fudžiwara','Marie Ói','Tomohiro Sató','Tošifumi Sakai','Šóhei Osada'],
basedOn:['Kentaró Miura'],
screenplay:['Ičiró Ókóči'],
production:['Eiiči Kamagata'],
scenography:['Júsuke Takeda','Hideki Nakamura','Marefumi Niibajaši']},
{title:'Glory',
titleCZ:'Glory',
year:1989,
runtime:122,
countries:['USA'],
genres:['Biographic','War','History','Drama'],
director:['Edward Zwick'],
actors:['Matthew Broderick','Denzel Washington','Cary Elwes','Morgan Freeman','Andre Braugher','Donovan Leitch Jr.','Alan North','Bob Gunton','Cliff De Young','John Finn','RonReaco Lee','Jay O. Sanders','Richard Riehle','Ethan Phillips','Mark Margolis','Bill Nunn','Jane Alexander','Raymond St. Jacques','Benji Wilhoite','Peter Michael Goetz','Bob Minor','JD Cullum','Larry Peterson','Afemo Omilami','Abdul Salaam El Razzac','Jihmi Kennedy','Marc Gowan','Daniel Jenkins','Michael Wayne Thomas','Dan Biggers'],
screenplay:['Kevin Jarre'],
production:['Freddie Fields'],
music:['James Horner'],
camera:['Freddie Francis'],
cut:['Steven Rosenblum'],
sound:['Wylie Stateman','Gregg Rudloff'],
scenography:['Norman Garwood'],
masks:['Carl Fullerton','Kevin Yagher','Vera Yurtchuk'],
costumes:['Francine Jamison-Tanchuck']},
{title:"A Midsummer Night's Dream",
titleCZ:'Sen noci svatojánské',
year:1959,
runtime:76,
countries:['Czechoslovakia'],
genres:['Animation','Puppets','Comedy','Romance'],
director:['Jiří Trnka'],
actors:['Rudolf Pellar','Jack Gwillim','Richard Burton','Joss Ackland','Ann Bell','Jean Desailly','Alec McCowen','Stephen Moore','Georgine Anderson','Donald Eccles','Stephanie Bidmead','Cyril Luckham'],
basedOn:['Josef Kainar'],
screenplay:['Jiří Trnka','Jiří Brdečka','William Shakespeare'],
music:['Václav Trojan'],
camera:['Jiří Vojta'],
sound:['Josef Vlček','Emanuel Formánek','Emil Poledník']},
{title:'A Special Day',
titleCZ:'Zvláštní den',
year:1977,
runtime:105,
countries:['Italy','Canada'],
genres:['Drama'],
director:['Ettore Scola'],
actors:['Sophia Loren','Marcello Mastroianni','John Vernon','Françoise Berd','Alessandra Mussolini','Adolf Hitler','King Victor Emmanuel III','Benito Mussolini'],
screenplay:['Ruggero Maccari','Ettore Scola'],
production:['Carlo Ponti'],
music:['Armando Trovajoli'],
camera:['Pasqualino De Santis'],
cut:['Raimondo Crociani'],
sound:['Carlo Palmieri','Franco Bassi'],
scenography:['Luciano Ricceri'],
costumes:['Enrico Sabbatini']},
{title:'The Roaring Twenties',
titleCZ:'Bouřlivá dvacátá léta',
year:1939,
runtime:106,
countries:['USA'],
genres:['Action','Drama','Film-Noir','Crime','Thriller'],
director:['Raoul Walsh'],
actors:['James Cagney','Priscilla Lane','Humphrey Bogart','Gladys George','Jeffrey Lynn','Frank McHugh','Paul Kelly','Elisabeth Risdon','Edward Keane','Joe Sawyer','Joseph Crehan','George Meeker','John Hamilton','Eddy Chandler','Abner Biberman','Vera Lewis','John Ridgely','Creighton Hale','Maurice Costello','John Harron','Lloyd Ingraham','Eddie Acuff','Bess Flowers','Jack Mower','Emory Parnell','Frank Wilcox','James Flavin','Raymond Bailey','Charles Sullivan','Mike Lally','Paul Bryar','Ben Welden','Jeffrey Sayre','Sam Harris','Donald Kerr','Arthur Loft','Adolf Hitler','Franklin D. Roosevelt','Herbert Hoover','Dick Wessel','Michael Jeffers','Max Wagner','Al Bridge','Fred Graham','Charles C. Wilson','Bill Elliott','Harry C. Bradley','James Conaty','Cyril Ring','Ray Cooke','Wade Boteler','Milton Kibbee','Joe Devlin','Brooks Benedict','Amzie Strickland','King Mojave','Lee Phelps','George Humbert',"Pat O'Malley","Oscar O'Shea",'Paul Phillips','Murray Alper','Eddie Hart','Kernan Cripps','Sayre Dearing','Ann Codee','Charles Marsh','George Lloyd','Nat Carr','Ernie Alexander','Herbert Heywood','Lottie Williams','Al Hill','James Blaine','Elliott Sullivan','Hector V. Sarno','Cliff Saum','Lew Harvey','Philip Morris','Alfred Linder','Billy Wayne','Carl Harbaugh','David Oliver'],
screenplay:['Jerry Wald','Robert Rossen','Richard Macaulay'],
production:['Mark Hellinger'],
music:['Ray Heindorf','Heinz Roemheld'],
camera:['Ernest Haller'],
cut:['Jack Killifer'],
sound:['Everett Alton Brown'],
scenography:['Max Parker'],
masks:['Perc Westmore']},
{title:'Casino Royale',
titleCZ:'Casino Royale',
year:2006,
runtime:144,
countries:['UK','Czechia','USA','Germany','Bahamy'],
genres:['Action','Adventure','Crime','Thriller'],
director:['Martin Campbell'],
actors:['Daniel Craig','Eva Green','Mads Mikkelsen','Judi Dench','Jeffrey Wright','Giancarlo Giannini','Caterina Murino','Simon Abkarian','Isaach De Bankolé','Jesper Christensen','Ivana Milicevic','Tobias Menzies','Claudio Santamaria','Sebastien Foucan','Richard Sammel','Ludger Pistor','Lazar Ristovski','Miroslav Šimůnek','Vladimír Kulhavý','Martin Učík','Urbano Barberini','Jürgen Tarrach','Gunther von Hagens','Vlastina Svátková','Regina Gabajová','Christina Cole',"Ivan G'Vera",'Michaela Ochotská','Carlos Leal','Clemens Schick','Alessandra Ambrosio','Simona Brhlíková','Tara Cardinal','Peter Brooke','Phil Méheux','Tsai Chin','Veruschka von Lehndorff','Darwin Shaw','Leoš Stránský','Crispin Bonham-Carter','Félicité Du Jeu','Tom Chadbon','Martin Campbell','Joseph Millson','Richard Branson','Ade','Michael G. Wilson','Lasco Atkins','Greg Bennett','Tom So','Jan Loukota',"Mark O'Neal",'Valarie Trapp','Filip Bradáč','Robert G. Slade','John Chancer','Rebecca Gethings','Jan Friedman','Emmanuel Avena'],
basedOn:['Ian Fleming'],
screenplay:['Neal Purvis','Robert Wade','Paul Haggis'],
production:['Michael G. Wilson','Barbara Broccoli'],
music:['David Arnold'],
camera:['Phil Méheux'],
cut:['Stuart Baird'],
sound:['Chris Munro','Michal Holubec','Eddy Joseph','Michael Prestwood Smith','Mark Taylor'],
scenography:['Peter Lamont','Lee Sandales'],
masks:['Paul Engelen','Christine Blundell'],
costumes:['Lindy Hemming','Zuzana Brožová','Jiřina Eisenhamerová']},
{title:'Toy Story 3',
titleCZ:'Toy Story 3: Příběh hraček',
year:2010,
runtime:99,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Lee Unkrich'],
actors:['Tom Hanks','Tim Allen','Joan Cusack','Michael Keaton','Ned Beatty','Wallace Shawn','Don Rickles','Whoopi Goldberg','Jeff Garlin','R. Lee Ermey','Laurie Metcalf','Bonnie Hunt','Kristen Schaal','Jodi Benson','Timothy Dalton','Teddy Newton','Erik von Detten','Blake Clark','John Ratzenberger','Richard Kind','Estelle Harris','John Cygan','Teresa Ganzel','Bea Miller','Emily Hahn','Lori Alan','Jan Rabson','Danny Mann','Jack Angel'],
screenplay:['Michael Arndt'],
production:['Darla K. Anderson'],
music:['Randy Newman'],
camera:['Jeremy Lasky'],
cut:['Ken Schretzmann'],
sound:['Michael Semanick']},
{title:'Road to Perdition',
titleCZ:'Road to Perdition',
year:2002,
runtime:117,
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Sam Mendes'],
actors:['Tom Hanks','Tyler Hoechlin','Paul Newman','Jude Law','Daniel Craig','Stanley Tucci','Jennifer Jason Leigh','Liam Aiken','Dylan Baker','Ciarán Hinds','David Darlow','Kevin Chamberlin','Lara Phillips','Harry Groener','Christian Stolte','Kurt Naebig','James Greene','Ian Barford','Doug Spinuzza','Michael Sassone','Keith Kupferer','Maureen Gallagher','Kerry Rossall','Peggy Roeder'],
screenplay:['David Self'],
production:['Richard D. Zanuck','Dean Zanuck'],
music:['Thomas Newman'],
camera:['Conrad L. Hall'],
cut:['Jill Bilcock'],
sound:['Bob Beemer','Scott Millan'],
scenography:['Dennis Gassner','Nancy Haigh'],
masks:['Linda Rizzuto','Suzi Ostos'],
costumes:['Albert Wolsky']},
{title:'The Naked Gun 2 1/2: The Smell of Fear',
titleCZ:'Bláznivá střela 2 a 1/2: Vůně strachu',
year:1991,
runtime:82,
countries:['USA'],
genres:['Comedy','Crime','Action'],
director:['David Zucker'],
actors:['Leslie Nielsen','Priscilla Presley','George Kennedy','O.J. Simpson','Robert Goulet','Richard Griffiths','Jacqueline Brookes','Anthony James','Gail Neely','Zsa Zsa Gabor','John Fleck','David Zucker',"'Weird Al' Yankovic",'Peter Van Norden','Lloyd Bochner','Peter Mark Richman','Mel Tormé','William Woodson','Kelly C. Ryan',"Tim O'Connor",'Lee Terri','Robert K. Weiss','Gina Mastrogiacomo','Al Fann','Robert Weil','Alexander Folk','Don Pugsley','Ken Kerman','Raynor Scheine','Gokul','Cliff Bemis','D.D. Howard','Manny Perry','Robert Buckingham','Wendy Hogan','Jeff Wright'],
screenplay:['Pat Proft','Jerry Zucker','Adam Zucker','Jim Abrahams'],
production:['Robert K. Weiss'],
music:['Ira Newborn'],
camera:['Robert M. Stevens'],
cut:['Christopher Greenbury','James R. Symons'],
sound:['Don Digirolamo','Adam Jenkins','Gary C. Bourgeois'],
scenography:['John J. Lloyd','Mickey S. Michaels'],
masks:['James R. Scribner','Stephen Abrums'],
costumes:['Taryn De Chellis']},
{title:'Sense and Sensibility',
titleCZ:'Rozum a cit',
year:1995,
runtime:131,
countries:['USA','UK'],
genres:['Drama','Comedy','Romance'],
director:['Ang Lee'],
actors:['Emma Thompson','James Fleet','Alan Rickman','Kate Winslet','Hugh Grant','Tom Wilkinson','Gemma Jones','Greg Wise','Harriet Walter','Robert Hardy','Imelda Staunton','Imogen Stubbs','Hugh Laurie','Oliver Ford Davies','Richard Lumsden','Elizabeth Spriggs','Emilie François','Lindsay Doran','Isabelle Amyes','Allan Mitchell'],
basedOn:['Jane Austen'],
screenplay:['Emma Thompson'],
production:['James Schamus','Lindsay Doran'],
music:['Patrick Doyle'],
camera:['Michael Coulter'],
cut:['Tim Squyres'],
scenography:['Luciana Arrighi','Ian Whittaker'],
masks:['Morag Ross'],
costumes:['Jenny Beavan']},
{title:"Rosemary's Baby",
titleCZ:'Rosemary má děťátko',
year:1968,
runtime:136,
countries:['USA'],
genres:['Thriller','Mystery','Drama','Horror'],
director:['Roman Polański'],
actors:['Mia Farrow','John Cassavetes','Ruth Gordon','Sidney Blackmer','Maurice Evans','Ralph Bellamy','Victoria Vetri','Charles Grodin','Tony Curtis','William Castle','Elisha Cook Jr.','Emmaline Henry','Floyd Mutrux','Natalie Masters','Bill Baldwin','George R. Robertson','Jack Ramage','Patsy Kelly','Wende Wagner','Walter Baldwin','Max Wagner','Gail Bonney','Robert Osterloh','Roy Barcroft','George Savalas','Almira Sessions','Hope Summers','Craig Littler','Mona Knox','Fritzi Jane Courtney','Duke Fishman','Hanna Hertelendy','John Halloran','Tom Signorelli','Marianne Gordon','Jack Knight','Phil Leeds',"D'Urville Martin",'Clay Tanner','Ernest Harada','Irene Kelly','Jean Inness','Carol Brewster'],
basedOn:['Ira Levin'],
screenplay:['Roman Polański'],
production:['William Castle'],
music:['Krzysztof Komeda'],
camera:['William A. Fraker'],
cut:["Sam O'Steen",'Bob Wyman'],
sound:['Harold Lewis'],
scenography:['Richard Sylbert','George R. Nelson'],
masks:['Allan Snyder'],
costumes:['Anthea Sylbert']},
{title:'Manhattan',
titleCZ:'Manhattan',
year:1979,
runtime:96,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Woody Allen'],
actors:['Woody Allen','Diane Keaton','Michael Murphy','Mariel Hemingway','Meryl Streep','Tisa Farrow','Gary Weis','Karen Allen','David Rasche','Wallace Shawn','Mark Linn-Baker','Frances Conroy','Raymond Serra','Kenny Vance','Helen Hanft','Michael O’Donoghue'],
screenplay:['Woody Allen','Marshall Brickman'],
production:['Charles H. Joffe','Jack Rollins'],
camera:['Gordon Willis'],
cut:['Susan E. Morse'],
scenography:['Mel Bourne'],
costumes:['Albert Wolsky']},
{title:'Barefoot in the Park',
titleCZ:'Bosé nohy v parku',
year:1967,
runtime:104,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Gene Saks'],
actors:['Robert Redford','Jane Fonda','Charles Boyer','Mildred Natwick','Herb Edelman','Mabel Albertson','Fritz Feld','James Stone','Ted Hartley','Billie Bird','Paul E. Burns','John Indrisano','Doris Roberts','Patsy Kelly'],
screenplay:['Neil Simon','Neil Simon'],
production:['Hal B. Wallis'],
music:['Neal Hefti'],
camera:['Joseph LaShelle'],
cut:['William A. Lyon'],
sound:['Harold Lewis'],
scenography:['Hal Pereira','Walter H. Tyler','Robert R. Benton'],
masks:['Wally Westmore'],
costumes:['Edith Head']},
{title:'The Girl Who Leapt Through Time',
titleCZ:'O dívce, která proskočila časem',
year:2006,
runtime:98,
countries:['Japan'],
genres:['Animation','Drama','Romance','Sci-Fi'],
director:['Mamoru Hosoda'],
actors:['Riisa Naka','Micuki Tanimura','Takuja Išida','Sačie Hara','Jódži Macuda','Acuko Juja','Tadaši Nakamura','Kristie Marsden'],
basedOn:['Jasutaka Cucui'],
camera:['Jošihiro Tomita'],
cut:['Šigeru Nišijama'],
scenography:['Nizó Jamamoto']},
{title:'...And Justice for All',
titleCZ:'...a spravedlnost pro všechny',
year:1979,
runtime:119,
countries:['USA'],
genres:['Drama','Thriller','Crime'],
director:['Norman Jewison'],
actors:['Al Pacino','Jack Warden','John Forsythe','Lee Strasberg','Jeffrey Tambor','Christine Lahti','Sam Levene','Thomas G. Waites','Craig T. Nelson','Dominic Chianese','Victor Arnold','Joe Morton','Alan North','Vincent Beck','J.G. Hertzler','Connie Sawyer','Sidney Clute','Robert Symonds','Darrell Zwerling','Robert Christian','Keith Andes','Larry Bryggman','Baxter Harris','Beverly Sanders','Michael Gorrin','Charles Siebert','Tom Quinn','Johnny Haymer','Terrence Currier','Jack Hollander','Carl Pistilli','Kenneth Patterson'],
screenplay:['Valerie Curtin','Barry Levinson'],
production:['Norman Jewison','Patrick J. Palmer'],
music:['Dave Grusin'],
camera:['Victor J. Kemper'],
cut:['John F. Burnett'],
sound:['Tex Rudloff'],
scenography:['Richard Macdonald','Peter Samish'],
masks:['Frank Westmore'],
costumes:['Ruth Myers']},
{title:'Two Women',
titleCZ:'Horalka',
year:1960,
runtime:100,
countries:['Italy','France'],
genres:['Drama','War'],
director:['Vittorio De Sica'],
actors:['Sophia Loren','Jean-Paul Belmondo','Eleonora Brown','Pupella Maggio','Raf Vallone','Vincenzo Musolino','Renato Salvatori','Carlo Ninchi','Emma Baron','Luciano Pigozzi','Mario Frera','Franco Balducci','Curt Lowens','Antonella Della Porta','Bruna Cealti'],
basedOn:['Alberto Moravia'],
screenplay:['Cesare Zavattini'],
production:['Carlo Ponti'],
music:['Armando Trovajoli'],
camera:['Gábor Pogány'],
cut:['Adriana Novelli'],
scenography:['Gastone Medin'],
costumes:['Elio Costanzi']},
{title:'Crimes and Misdemeanors',
titleCZ:'Zločiny a poklesky',
year:1989,
runtime:107,
countries:['USA'],
genres:['Comedy','Drama'],
director:['Woody Allen'],
actors:['Martin Landau','Woody Allen','Alan Alda','Claire Bloom','Caroline Aaron','Anjelica Huston','Sam Waterston','Mia Farrow','Jerry Orbach','Jerry Zaks','Frances Conroy','Victor Argo','Nora Ephron','Robin Bartlett','Mercedes Ruehl','Daryl Hannah','Myla Pitt','Fred Melamed','Joanna Gleason','Rebecca Schull','Thomas Bolster','Kenny Vance','Hy Anzell','Sylvia Kauders','Anna Berger','Dolores Sutton','Maggie Wagner','Martin Bergmann',"Dylan O'Sullivan Farrow",'Avner Eisenberg','Matthew T. Gitkin','Grace Phillips'],
screenplay:['Woody Allen'],
production:['Robert Greenhut'],
camera:['Sven Nykvist'],
cut:['Susan E. Morse'],
sound:['Lee Dichter'],
scenography:['Santo Loquasto'],
costumes:['Jeffrey Kurland']},
{title:'And Now for Something Completely Different',
titleCZ:'A teď něco úplně jiného',
year:1971,
runtime:85,
countries:['UK'],
genres:['Comedy'],
director:['Ian MacNaughton'],
actors:['Graham Chapman','John Cleese','Eric Idle','Terry Jones','Michael Palin','Terry Gilliam','Carol Cleveland','Connie Booth','Winston Churchill','Lewis Alexander','Fred Wood'],
screenplay:['Graham Chapman','John Cleese','Terry Gilliam','Eric Idle','Terry Jones','Michael Palin'],
music:['Douglas Gamley'],
cut:['Thom Noble']},
{title:'Hamlet',
titleCZ:'Hamlet',
year:1990,
runtime:130,
countries:['UK','USA','France'],
genres:['Drama','Romance'],
director:['Franco Zeffirelli'],
actors:['Mel Gibson','Glenn Close','Alan Bates','Paul Scofield','Ian Holm','Helena Bonham Carter','Stephen Dillane','Nathaniel Parker','Christien Anholt','Pete Postlethwaite','Vernon Dobtcheff','Michael Maloney','Nada Strancar','André Julien','Christopher Fairbank','Gérard Desarthe','Roy Evans','Trevor Peacock','Richard Warwick','Alain Guillo'],
screenplay:['Franco Zeffirelli','Christopher De Vore','William Shakespeare'],
production:['Dyson Lovell'],
music:['Ennio Morricone'],
camera:['David Watkin'],
cut:['Richard Marden'],
scenography:['Dante Ferretti','Francesca Lo Schiavo','Franco Ceraolo'],
masks:['Daniel Parker'],
costumes:['Maurizio Millenotti']},
{title:'The Invisible Man',
titleCZ:'Neviditelný muž',
year:1933,
runtime:71,
countries:['USA'],
genres:['Sci-Fi','Horror','Thriller'],
director:['James Whale'],
actors:['Claude Rains','Gloria Stuart','William Harrigan','Henry Travers',"Una O'Connor",'Forrester Harvey','Holmes Herbert','E.E. Clive','Dudley Digges','Merle Tottenham','Dwight Frye','John Carradine','Walter Brennan','Jameson Thomas','Leo White','Mary Gordon','Emma Tansey','Monte Montague','Bob Reeves','Charles Morton','Tiny Jones','Tom Ricketts','Crauford Kent','Jack Richardson','Bobbie Hale','Paul Kruger','Ted Billings',"D'Arcy Corrigan",'Kathryn Sheldon','Jack Deery','Stuart Hall','John Merivale'],
basedOn:['H.G. Wells'],
screenplay:['R.C. Sherriff','Preston Sturges','Philip Wylie'],
production:['Carl Laemmle Jr.'],
music:['W. Franke Harling','Heinz Roemheld'],
camera:['Arthur Edeson'],
cut:['Ted J. Kent'],
sound:['Gilbert Kurland'],
scenography:['Charles D. Hall'],
masks:['Jack P. Pierce']},
{title:'Capernaum',
titleCZ:'Kafarnaum',
year:2018,
runtime:120,
countries:['Libanon','France','USA'],
genres:['Drama'],
director:['Nadine Labaki'],
actors:['Zain Alrafeea','Yordanos Shifera','Boluwatife Treasure Bankole','Kawthar Al Haddad','Fadi Kamel Youssef','Haita Izam','Alaa Chouchnieh','Nadine Labaki'],
screenplay:['Nadine Labaki','Jihad Hojeily','Michelle Keserwany'],
production:['Michel Merkt','Khaled Mouzanar'],
music:['Khaled Mouzanar'],
camera:['Christopher Aoun'],
cut:['Konstantin Bock','Laure Gardette'],
sound:['Matthieu Tertois'],
scenography:['Hussein Baydoun']},
{title:'Shame',
titleCZ:'Hanba',
year:2011,
runtime:101,
countries:['UK'],
genres:['Drama'],
director:['Steve McQueen'],
actors:['Michael Fassbender','Carey Mulligan','James Badge Dale','Nicole Beharie','Jennifer Butler','Lucy Walters','Elizabeth Masucci','Alex Manette','Hannah Ware','Marta Milans','Amy Hargreaves','Maria Szynkarczuk','Briana Marin','Jake Siciliano','Stanley Mathis','Anna Rose Hopkins'],
screenplay:['Steve McQueen','Abi Morgan'],
production:['Iain Canning','Emile Sherman'],
music:['Harry Escott'],
camera:['Sean Bobbitt'],
cut:['Joe Walker'],
sound:['Glenn Freemantle'],
scenography:['Judy Becker','Heather Loeffler'],
costumes:['David C. Robinson']},
{title:'Slumdog Millionaire',
titleCZ:'Milionář z chatrče',
year:2008,
runtime:115,
countries:['UK','USA','France','Germany','India'],
genres:['Drama','Romance'],
director:['Danny Boyle'],
actors:['Dev Patel','Saurabh Shukla','Freida Pinto','Anil Kapoor','Rajendranath Zutshi','Irrfan Khan','Azharuddin Mohammed Ismail','Ayush Mahesh Khedekar','Mahesh Manjrekar','Rubina Ali','Tanay Chheda','Ashutosh Lobo Gajiwala','Tanvi Ganesh Lonkar','Madhur Mittal','Anand Tiwari','Arfi Lamba','Mamta Sharma','Ankur Tewari','Faezeh Jalali','Anupam Shyam','Imran Hasnee','Sarfaraz Khan','Sharib Hashmi','Kinder Singh','Anjum Sharma','Shruti Seth','David Gilliam'],
basedOn:['Vikas Swarup'],
screenplay:['Simon Beaufoy'],
production:['Christian Colson'],
music:['A.R. Rahman'],
camera:['Anthony Dod Mantle'],
cut:['Chris Dickens'],
sound:['Glenn Freemantle','Richard Pryke','Michael Semanick'],
scenography:['Mark Digby','Swapnali Das'],
costumes:['Suttirat Anne Larlarb']},
{title:'Ed Wood',
titleCZ:'Ed Wood',
year:1994,
runtime:127,
countries:['USA'],
genres:['Drama','Comedy','Biographic'],
director:['Tim Burton'],
actors:['Johnny Depp','Martin Landau','Sarah Jessica Parker','Patricia Arquette','Jeffrey Jones','G. D. Spradlin',"Vincent D'Onofrio",'Bill Murray','Mike Starr','Max Casella','Lisa Marie',"George 'The Animal' Steele",'Juliet Landau','Leonard Termo','Ned Bellamy','Melora Walters','Conrad Brooks','Maurice LaMarche','Vasek Simek','Ray Baker','Mickey Cottrell','Ada Tai','Arlene Tai','Rance Howard','Brent Hinkley','Louis Lombardi','Gregory Walcott','Matthew Barry','Norman Alden','Gretchen Becker','Carmen Filpi','Reid Cruickshanks','Bobby Slayton','Gene LeBell','Charles C. Stevenson Jr.','Tommy Bertelsen','Stanley DeSantis','Ben Ryan Ganger','Don Hood','Anthony Russell','Clive Rosengren','Vinny Argiro','Catherine Butterfield','Joseph R. Gannascoli','Biff Yeager','Mike Breyer','Patti Tippo','Charlie Holliday','Johnny Meyer'],
basedOn:['Rudolph Grey'],
screenplay:['Scott Alexander','Larry Karaszewski'],
production:['Denise Di Novi','Tim Burton'],
music:['Howard Shore'],
camera:['Stefan Czapsky'],
cut:['Chris Lebenzon'],
sound:['David Parker','Michael Semanick'],
scenography:['Tom Duffield'],
masks:['Ve Neill','Yolanda Toussieng','Matt Rose','Rick Baker','Alicia M. Tripi'],
costumes:['Colleen Atwood']},
{title:'Traffic',
titleCZ:'Traffic - Nadvláda gangů',
year:2000,
runtime:147,
countries:['USA','Germany'],
genres:['Crime','Drama','Thriller'],
director:['Steven Soderbergh'],
actors:['Michael Douglas','Don Cheadle','Jacob Vargas','Benicio Del Toro','Dennis Quaid','Tomas Milian','Catherine Zeta-Jones','Emilio Rivera','Erika Christensen','Miguel Ferrer','James Lew','Albert Finney','Ben Scott','Luis Guzmán','James Brolin','Enrique Murciano','Rena Sofer','Topher Grace','Salma Hayek','D. W. Moffett','Stephen Dunham','Margaret Travolta','Steven Bauer','Amy Irving','Clifton Collins Jr.','Viola Davis','James Pickens Jr.','Peter Riegert','Elaine Kagan','John Slattery','Jack Conley','Mary Pat Gleason','Benjamin Bratt','Jsu Garcia','Carlos Gómez','Majandra Delfino','Yul Vazquez',"Michael O'Neill",'Jose Yenque','David Jensen','Russell Solberg','Stacey Travis','Jim Cody Williams','Gary Carlos Cervantes','Thomas Rosales Jr.','Rick Avery','Vincent M. Ward','Eddie Velez','Brian Avery','Carl Ciarfalio','Dave Hager','Vitalij Kravčenko','Brandon Keener','Valerie Lynn Hanna','Barbara Boxer','Michael Showers','Toby Holguin','Cecile Cinco','Tucker Smallwood','Vonte Sweet','Kymberly Newberry','Steven Lambert','Rene Pereyra','William Christopher Stephens','Daniella Kuhn','Michael Saucedo','Russell G. Jones','John Brown','David Bickford','Peter Stader'],
screenplay:['Stephen Gaghan','Simon Moore'],
production:['Edward Zwick'],
music:['Cliff Martinez'],
camera:['Steven Soderbergh'],
cut:['Stephen Mirrione'],
scenography:['Philip Messina'],
masks:['Katherine James','Kathrine Gordon'],
costumes:['Louise Frogley']},
{title:'Mesrine Part 2: Public Enemy #1',
titleCZ:'Veřejný nepřítel č. 1: Epilog',
year:2008,
runtime:133,
countries:['France','Canada'],
genres:['Action','Drama','Crime','Thriller','Biographic'],
director:['Jean-François Richet'],
actors:['Vincent Cassel','Ludivine Sagnier','Gérard Lanvin','Samuel Le Bihan','Olivier Gourmet','Mathieu Amalric','Michel Duchaussoy','Georges Wilson','Anne Consigny','Myriam Boyer','Laure Marsac','Arsène Mosca','Olivier Barthelemy','Elena Anaya','Alain Doutey','Clémence Thioly','Eric Boucher','Joseph Malerba','Françoise Le Plénier','Pascal Elso','Bernard Rosselli','Nicolas Woirion','Héléna Soubeyrand','Luc Thuillier','Pascal Liger','Christophe Vandevelde','Jérôme Boyer','Alain Rimoux','Alain Fromager','Marcel Rouzé','Xavier Letourneur','Rachel Suissa','Vincent Jouan','Isabelle Vitari','Gérard Depardieu','Alexandre Picot','Michaël Vander-Meiren','Yan Brian','Fanny Sidney','Philippe Le Dem','Olivier Pajot','Caroline Mathieu','Serge Biavan'],
screenplay:['Abdel Raouf Dafri','Jean-François Richet'],
production:['André Rouleau','Thomas Langmann','Jean Cottin'],
music:['Marco Beltrami','Marcus Trumpp'],
camera:['Robert Gantz'],
cut:['Hervé Schneid','Bill Pankow'],
masks:['Christophe Giraud'],
costumes:['Virginie Montel']},
{title:'The French Connection',
titleCZ:'Francouzská spojka',
year:1971,
runtime:104,
countries:['USA'],
genres:['Crime','Thriller','Drama','Action'],
director:['William Friedkin'],
actors:['Gene Hackman','Fernando Rey','Roy Scheider','Tony Lo Bianco','Marcel Bozzuffi','Bill Hickman','Frédéric de Pasquale','Harold Gary','Eddie Egan','Benny Marino','William Coke','Irving Abrahams','Doris McCarthy','André Ernotte','Gilda Albertoni','Arlene Farber','Al Fann','Robert Weil','Patrick McDermott','Sonny Grosso','Randy Jurgensen','Alan Weeks','Sarina C. Grant','Charles McGregor','Santos Morales','The Three Degrees'],
basedOn:['Robin Moore'],
screenplay:['Ernest Tidyman'],
production:["Philip D'Antoni"],
music:['Don Ellis'],
camera:['Owen Roizman'],
cut:['Gerald B. Greenberg'],
sound:['Don Hall'],
scenography:['Ben Kasazkow'],
costumes:['Joseph Fretwell III']},
{title:'Chaplin',
titleCZ:'Chaplin',
year:1992,
runtime:143,
countries:['USA','Japan','France','Italy'],
genres:['Drama','Biographic'],
director:['Richard Attenborough'],
actors:['Robert Downey Jr.','Dan Aykroyd','Geraldine Chaplin','Paul Rhys','Anthony Hopkins','John Thaw','Milla Jovovich','Moira Kelly','Kevin Kline','Diane Lane','Penelope Ann Miller','Marisa Tomei','Nancy Travis','James Woods','Kevin Dunn','Deborah Moore','Maria Pitillo','Alan Ford','Howard Lew Lewis','Bradley Pierce','David Duchovny','Michael A. Goorjian','Philip Waley','Mark Long','Andrée Bernard','David Gant','Sacha Bennett','Tim Chaplin','Bill Paterson','John Standing','P. H. Moriarty',"Sean O'Bryan",'Benjamin Whitrow','Michael Villani','Charlie Chaplin','Virginia Cherrill','Jackie Coogan','Paulette Goddard','Adolf Hitler','Malcolm Terris','Robert Stephens','Lance Patrick','Laurel Whitsett','Phil Brown','Norbert Weisser','Renata Scott','Bryan Coleman','Bruce Holman','Mary Healey','Gerald Sim','John Howard Lawson','John Otrin','Raymond Lynch','Karen Salt','Robert Peters','Charles Howerton','Jayson Kane','Michael Miller','Francesca Buller','Julius Schaub','David Mooney','Ralph Votrian','William Dennis Hunt','Vicki Frederick','Donald Elson','Alan Charof','Jacqueline Leonard','Michael Cade','John Lizzi','Dana Craig','Ken Magee','Donnie Kehr'],
basedOn:['Charlie Chaplin'],
screenplay:['Bryan Forbes','William Goldman','William Boyd'],
production:['Richard Attenborough'],
music:['John Barry'],
camera:['Sven Nykvist'],
cut:['Anne V. Coates'],
scenography:['Stuart Craig'],
masks:['Monty Westmore','John Caglione','Jr.','Sarah Love','Wally Schneiderman','Audrey Futterman-Stern'],
costumes:['Ellen Mirojnick','John Mollo']},
{title:'The Chorus',
titleCZ:'Slavíci v kleci',
year:2004,
runtime:98,
countries:['France','Switzerland','Germany'],
genres:['Drama','Music'],
director:['Christophe Barratier'],
actors:['Gérard Jugnot','François Berléand','Jean-Baptiste Maunier','Kad Merad','Marie Bunel','Maxence Perrin','Didier Flamand','Jacques Perrin','Jean-Paul Bonnaire','Thomas Blumenthal','Grégory Gatignol','Monique Ditisheim','Paul Chariéras','Steve Gadler','Philippe du Janerand','Erick Desmarestz','Armen Godel','Simon Fargeot','Cyril Bernicot','Carole Weiss','Michel Caccia','Violette Barratier'],
screenplay:['Christophe Barratier','René Wheeler','Philippe Lopes-Curval','Noël-Noël'],
production:['Jacques Perrin','Nicolas Mauvernay','Arthur Cohn'],
music:['Bruno Coulais'],
camera:['Carlo Varini','Dominique Gentil','Jean-Jacques Bouhon'],
cut:['Yves Deschamps'],
sound:['Vincent Vatoux','Daniel Sobrino'],
scenography:['François Chauvaud'],
masks:['Sylvie Duval','Fabienne Robineau'],
costumes:['Françoise Guégan']},
{title:'Waterloo',
titleCZ:'Waterloo',
year:1970,
runtime:134,
countries:['Italy','Russia','USA'],
genres:['Drama','Action','War','History'],
director:['Sergej Bondarčuk'],
actors:['Rod Steiger','Christopher Plummer','Orson Welles','Jack Hawkins','Virginia McKenna',"Dan O'Herlihy",'Rupert Davies','Philippe Forquet','Gianni Garko','Ivo Garrani','Ian Ogilvy','Michael Wilding','Terence Alexander','Donal Donnelly','Charles Millot','Jevgenij Samojlov','Oleg Vidov','Charles Borromel','Orso Maria Guerrini','Richard Heffer','Orazio Orlando','John Savident','Adrian Brine','Paul Butkevič','Pietro Ceccarelli','Aldo Cecconi','Irina Skobceva','Igor Jasulovič','Vasilij Livanov','Rostislav Jankovskij','Friedrich Schoenfelder','Robert Rietty','Franco Fantasia','Jean Louis','Sergio Testori','Oleg Michajlov','Susan Wood','Alexandr Parchomenko','Andrej Jureněv','Jeffry Wickham','Armando Bottin','Giuliano Raffaelli'],
screenplay:['H.A.L. Craig'],
production:['Dino De Laurentiis'],
music:['Nino Rota'],
camera:['Armando Nannuzzi'],
cut:['Richard C. Meyer'],
sound:['Primiano Muratori','John Dennis'],
scenography:['Mario Garbuglia'],
masks:['Giannetto De Rossi']},
{title:'Song for a Raggy Boy',
titleCZ:'Píseň za chudého chlapce',
year:2003,
runtime:100,
countries:['Ireland','UK','Denmark','Spain'],
genres:['Drama'],
director:['Aisling Walsh'],
actors:['Aidan Quinn','Iain Glen','Marc Warren','Dudley Sutton','Alan Devlin','Stuart Graham','John Travers','Chris Newman','Andrew Simpson','Robert Sheehan','Claus Bue','Danny Sapani','Juan José Ballesta','John McDonnell','John Hand','Simone Bendix'],
screenplay:['Aisling Walsh','Kevin Byron Murphy'],
production:['John McDonnell','Dominic Wright'],
music:['Richard Blackford'],
camera:['Peter Robertson'],
scenography:['John Hand'],
costumes:['Allison Byrne']},
{title:'The Sacrifice',
titleCZ:'Oběť',
year:1986,
runtime:148,
countries:['Sweden','France','UK'],
genres:['Drama'],
director:['Andrej Tarkovskij'],
actors:['Erland Josephson','Susan Fleetwood','Allan Edwall','Guðrún Gísladóttir','Sven Wollter','Valérie Mairesse','Filippa Franzén','Tommy Kjellqvist','Per Källman','Tommy Nordahl','Tintin Anderzon','Birgit Carlstén','Jane Friedmann','Jan-Olof Strandberg','Helena Brodin','Martin Lindström'],
screenplay:['Andrej Tarkovskij'],
production:['Anna-Lena Wibom'],
camera:['Sven Nykvist'],
sound:['Bo Persson','Lasse Ulander','Christin Loman','Wille Peterson-Berger'],
scenography:['Anna Asp'],
masks:['Kjell Gustavsson'],
costumes:['Inger Pehrsson']},
{title:'Cria!',
titleCZ:'Starý dům uprostřed Madridu',
year:1976,
runtime:107,
countries:['Spain'],
genres:['Drama'],
director:['Carlos Saura'],
actors:['Geraldine Chaplin','Ana Torrent','Mónica Randall','Florinda Chico','Conchita Pérez','Mayte Sanchez','Josefina Díaz','Héctor Alterio','Germán Cobos','Mirta Miller'],
screenplay:['Carlos Saura'],
production:['Elías Querejeta'],
music:['Federico Mompou'],
camera:['Teo Escamilla'],
cut:['Pablo G. del Amo'],
sound:['Bernardo Menz'],
scenography:['Rafael Palmero'],
masks:['Romana González'],
costumes:['Maiki Marín']},
{title:'Land',
titleCZ:'Země',
year:2021,
runtime:89,
countries:['USA'],
genres:['Drama'],
director:['Robin Wright'],
actors:['Robin Wright','Demián Bichir','Sarah Dawn Pledge','Warren Christie','Kim Dickens','Brad Leland','Finlay Wojtak-Hissong','Barb Mitchell','Laura Yenga'],
screenplay:['Erin Dignam','Liz Hannah'],
production:['Peter Saraf','Allyn Stewart','Leah Holzer'],
music:['Ben Sollee','Time for Three'],
camera:['Bobby Bukowski'],
cut:['Anne McCabe','Mikkel E.G. Nielsen'],
sound:['Oleg Kulchytskyi'],
scenography:['Trevor Smith','Rob Hepburn','Mark Stope'],
masks:['Jo-Dee Thomson']},
{title:"Daffy Duck's Quackbusters",
titleCZ:'Quackbusters kačera Daffyho',
year:1988,
runtime:72,
countries:['USA'],
genres:['Family','Animation','Comedy'],
director:['Friz Freleng','Chuck Jones','Robert McKimson'],
actors:['Mel Blanc','June Foray','Mel Tormé','Julie Bennett','Mark Kausler','Roy Firestone','B.J. Ward'],
music:['Carl W. Stalling','William Lava']},
{title:'I Am a Fugitive from a Chain Gang',
titleCZ:'Jsem uprchlý galejník',
year:1932,
runtime:92,
countries:['USA'],
genres:['Drama','Film-Noir','Crime'],
director:['Mervyn LeRoy'],
actors:['Paul Muni','Glenda Farrell','Helen Vinson','Noel Francis','Preston Foster','Allen Jenkins','Berton Churchill','Edward Ellis','Hale Hamilton','Sally Blane','Louise Carter','Willard Robertson','Robert Warwick',"Dennis O'Keefe","Douglass Dumbrille",'Edward Arnold','Walter Long','Sheila Terry','Harry Woods','Jack La Rue','Irving Bacon','Charles Sellon','Charles Middleton','Jack Curtis','James Bell','Edward LeSaint','William H. Strauss','Eddy Chandler','Fred Toones','Wallis Clark','George Cooper','Lew Kelly','Charles McAvoy','Everett Brown','John Wray','G. Pat Collins','Erville Alderson','William Le Maire','J. Frank Glendon'],
screenplay:['Sheridan Gibney','Howard J. Green','Brown Holmes'],
music:['Bernhard Kaun'],
camera:['Sol Polito'],
cut:['William Holmes'],
scenography:['Jack Okey'],
costumes:['Orry-Kelly']},
{title:'Guardians of the Galaxy',
titleCZ:'Strážci Galaxie',
year:2014,
runtime:116,
countries:['USA','UK'],
genres:['Action','Adventure','Sci-Fi','Fantasy','Comedy'],
director:['James Gunn'],
actors:['Chris Pratt','Zoe Saldana','Dave Bautista','Vin Diesel','Bradley Cooper','Lee Pace','Michael Rooker','Karen Gillan','Djimon Hounsou','John C. Reilly','Glenn Close','Benicio Del Toro','Laura Haddock','Sean Gunn','Peter Serafinowicz','Christopher Fairbank','Gregg Henry','Tom Proctor','Sharif Atkins','Brendan Fehr','Tomas Arana','Alexis Rodney','Nathan Fillion','Alexis Denisof','Enzo Cilenti','Richard Katz','Ophelia Lovibond','Marama Corlett','Rob Zombie','John Brotherton','James Gunn','Josh Brolin','Lloyd Kaufman','Julian Seager','Stan Lee','Raed Abbas','Nicole Alexandra Shipley','David Yarovesky','Emmett J. Scanlan','Deborah Rosan','Naomi Ryan','Melia Kreiling','Ralph Ineson','Spencer Wilding','Alison Lintott','Paul Warren','Jozef Aoki','Clem So','Wyatt Oleff','Rosie Jones','Tyler Bates','Seth Green','Mikaela Hoover','Enoch Frost','Keeley Forsyth','Laura Ortiz','Marianna Dean','Bruce Mackinnon','Graham Shiels','Matthew David McCarthy','Ronan Summers','Simon Hatt','Gordon Round','Miriam Lucia','Jimmy Star','Frank Gilhooley'],
basedOn:['Dan Abnett','Andy Lanning'],
screenplay:['James Gunn','Nicole Perlman'],
production:['Kevin Feige'],
music:['Tyler Bates','Timothy Williams'],
camera:['Ben Davis'],
cut:['Fred Raskin','Craig Wood','Hughes Winborne'],
sound:['David Acord','Matthew Wood','Simon Hayes','Lora Hirschberg','Christopher Boyes'],
scenography:['Charles Wood','Ray Chan','Richard Roberts','Phil Sims'],
masks:['Pascale Recher','Kevin Haney',"Jane O'Kane",'Karen Cohen','David White','Lizzie Yianni Georgiou','Kenny Niederbaumer','Nicky Knowles','Nora Robertson','Ann Fenton','Siobhan Harper Ryan','Jessica Brooks','Loulia Sheppard'],
costumes:['Alexandra Byrne']},
{title:'Minority Report',
titleCZ:'Minority Report',
year:2002,
runtime:145,
countries:['USA'],
genres:['Sci-Fi','Action','Thriller','Mystery'],
director:['Steven Spielberg'],
actors:['Tom Cruise','Colin Farrell','Samantha Morton','Max von Sydow','Patrick Kilpatrick','Kathryn Morris','Lois Smith','Peter Stormare','Jessica Capshaw','Tim Blake Nelson','Steve Harris','Frank Grillo','Mike Binder','Neal McDonough','Anna Maria Horsford','Arye Gross','Stephen Ramsey','Joel Gretsch','Jessica Harper','Cameron Crowe','Katy Boyer','William Mapother','Meredith Monroe','Scott Frank','Paul Wesley','Caroline Lagerfelt','Ashley Crow','Tyler Patrick Jones','Anne Judson-Yager','Dominic Scott Kay','Daniel London','Michael Ahl','Victor Raider-Wexler','Blake Bashoff','Jason Antoon','Kirk B.R. Woller','Bonnie Morgan','Jim Rash','Rebecca Ritz','Riley Schmidt','Gina Gallego','George Wallace','David Hornsby','Diane Robin','Richard Coca','Karina Logue','Keith Flippen','Eugene Osment','Keith Campbell','Jay Shindell','Ann Ryerson','Andrew Sandler','Jorge-Luis Pallo','Tom Choi','Klea Scott','Christian Taylor','Nina Kaczorowski','Nancy Linehan Charles','Kurt Sinclair','Benita Krista Nall','Sumalee Montano','Daniel Browning Smith','Nicholas Edwin Barb','Greg Bronson','Steven Hack','Elizabeth Anne Smith','Bourke Floyd','Victoria Kelleher','Fiona Hale'],
basedOn:['Philip K. Dick'],
screenplay:['Scott Frank','Jon Cohen'],
production:['Walter F. Parkes','Bonnie Curtis','Gerald R. Molen'],
music:['John Williams'],
camera:['Janusz Kamiński'],
cut:['Michael Kahn'],
sound:['Andy Nelson','Gary Rydstrom'],
scenography:['Alex McDowell','Anne Kuljian'],
masks:['Camille Calvet','Howard Berger','Greg Nicotero','Sherri Bramlett','Barbara Lacy'],
costumes:['Deborah L. Scott']},
{title:'X-Men: Days of Future Past',
titleCZ:'X-Men: Budoucí minulost',
year:2014,
runtime:131,
countries:['USA','UK','Canada'],
genres:['Sci-Fi','Action','Adventure','Thriller'],
director:['Bryan Singer'],
actors:['Hugh Jackman','James McAvoy','Michael Fassbender','Jennifer Lawrence','Nicholas Hoult','Ian McKellen','Patrick Stewart','Elliot Page','Peter Dinklage','Halle Berry','Shawn Ashmore','Lucas Till','Daniel Cudmore','Bingbing Fan','Booboo Stewart','Omar Sy','Evan Peters','Adan Canto','Larry Day','Evan Jonigkeit','Jaa Smith-Johnson','Amelia Giovanni','Gregg Lowe','Josh Helman','Thai-Hoa Le','Jason Deline','Robert Crooks','Anna Paquin','Famke Janssen','James Marsden','Morgan Lily','Susanna Fournier','Karine Vanasse','Stephan Parent','Zabryna Guevara','Mike Dopud','Neil Napier','Kelsey Grammer','Brian Cox','Nathaly Thibault','Kyle Gatehouse','Mark Camacho','Matt Cooke','Andreas Apergis','Alex Ivanovici','Arthur Holden','Harry Standjofski','Tim Post','Lance Kinsey','Miya Shelton-Contreras','Robert Montcalm','Francesco Giannini','Marc Gourdeau','Serge Martineau','Steve Barry','Christian Jadah','Jimmy Star','Freddy Bessa','Pierre Leblanc','Len Wein','Darryl Scheelar','Brent Skagford'],
screenplay:['Simon Kinberg'],
production:['Simon Kinberg','Hutch Parker','Lauren Shuler Donner','Bryan Singer'],
music:['John Ottman'],
camera:['Newton Thomas Sigel'],
cut:['John Ottman'],
sound:['Ron Bartlett','Doug Hemphill','Chuck Michael','John A. Larsen','Craig Berkey'],
scenography:['John Myhre','Eve Boulonne','Gordon Sim','Vincent Gingras-Liberali'],
masks:['Ve Neill','Norma Hill-Patton','Rita Ciccozzi','Brian Sipe','Adrien Morot','Lyne Lapiana'],
costumes:['Louise Mingenbach']},
{title:'Enemy at the Gates',
titleCZ:'Nepřítel před branami',
year:2001,
runtime:126,
countries:['USA','Germany','UK','Ireland','France'],
genres:['Drama','History','War'],
director:['Jean-Jacques Annaud'],
actors:['Jude Law','Joseph Fiennes','Rachel Weisz','Bob Hoskins','Ed Harris','Ron Perlman','Eva Mattes','Gabriel Thomson','Matthias Habich','Ivan Shvedoff','Sophie Rois','Hans-Martin Stier','Clemens Schick','Robert Stadlober','Marc Bischoff','Tom Wlaschiha','Birol Ünel','Michael Schenk','Valentin Platareanu','Werner Daehn','Markus Majowski','Gennadij Věngerov','Anna Böttcher','Gotthard Lange','Holger Handtke','Lenn Kudrjawizki','Hendrik Arnst','André Kaminski','Mark Zak','Axel Neumann','Claudius Freyer','Jürgen G.H. Hoppmann','Dana Cebulla','Mario Bandi','Michail Matvejev','Dmitrij Alexandrov','Piotr Papierz','Maxim Kovalevski','Dietmar Nieder','Thomas Petruo','Arslan Kodirov','Kay Hunsicker','Manfred Witt','Katharina Burowa','Morin Smole','Polina Raykina','Bernd Lambrecht'],
screenplay:['Alain Godard','Jean-Jacques Annaud'],
production:['Jean-Jacques Annaud'],
music:['James Horner'],
camera:['Robert Fraisse'],
cut:['Noëlle Boisson','Humphrey Dixon'],
sound:['Eddy Joseph','Chris Carpenter'],
scenography:['Wolf Kroeger'],
masks:['Hasso von Hugo','Valeska Schitthelm'],
costumes:['Janty Yates']},
{title:'The Imitation Game',
titleCZ:'Kód Enigmy',
year:2014,
runtime:109,
countries:['UK','USA'],
genres:['War','Biographic','Thriller','Drama'],
director:['Morten Tyldum'],
actors:['Benedict Cumberbatch','Keira Knightley','Matthew Goode','Rory Kinnear','Allen Leech','Matthew Beard','Charles Dance','Mark Strong','James Northcote','Tom Goodman-Hill','Steven Waddington','Ilan Goodman','Alex Lawther','Jack Bannon','Tuppence Middleton','James G. Nunn','Charlie Manton','Victoria Wicks','Andrew Havill','Laurence Kennedy','Lee Asquith-Coe','Peter Brown','Grace Calder','Winston Churchill','Chris Cowlin','Adolf Hitler','Adam Nowell','Mark Underwood','Nicola-Jayne Wells','Josh Wichard'],
basedOn:['Andrew Hodges'],
screenplay:['Graham Moore'],
production:['Nora Grossman','Ido Ostrowsky','Teddy Schwarzman'],
music:['Alexandre Desplat'],
camera:['Óscar Faura'],
cut:['William Goldenberg'],
sound:['Andy Kennedy','John Midgley','Martin Jensen'],
scenography:['Maria Djurkovic','Tatiana Macdonald'],
masks:['Ivana Primorac'],
costumes:['Sammy Sheldon Differ']},
{title:'Dead Alive',
titleCZ:'Braindead - Živí mrtví',
year:1992,
runtime:103,
countries:['New Zealand'],
genres:['Comedy','Horror'],
director:['Peter Jackson'],
actors:['Timothy Balme','Diana Peñalver','Elizabeth Moody','Ian Watkin','Stuart Devenie','Brenda Kendall','Jed Brophy','Harry Sinclair','Stephen Papps','Forrest J. Ackerman','Peter Jackson','Fran Walsh','Silvio Famularo','královna Alžběta II.','Jamie Selkirk','Sarah Scott Davis','Angela Robinson Witherspoon','Murray Keane','James Grant'],
screenplay:['Stephen Sinclair','Fran Walsh','Peter Jackson'],
cut:['Jamie Selkirk'],
sound:['Mike Hopkins','Tony Johnson'],
scenography:['Kevin Leonard-Jones'],
masks:['Bob McCarron']},
{title:'The Legend of Bagger Vance',
titleCZ:'Legenda o slavném návratu',
year:2000,
runtime:126,
countries:['USA'],
genres:['Drama','Fantasy','Romance','Sport'],
director:['Robert Redford'],
actors:['Will Smith','Matt Damon','Charlize Theron','Bruce McGill','Joel Gretsch','J. Michael Moncrief','Peter Gerety','Lane Smith',"Michael O'Neill",'Thomas Jay Ryan','Harve Presnell','Carrie Preston','Andrea Powell','Joseph P. Reidy','Todd Soley','Jack Lemmon','Dermot Crowley','E. Roger Mitchell','Wilbur Fitzgerald','Jim Keisler','Danny Nelson','J. Don Ferguson','Jonathan Ignatius Green','Elliott Street','George Green','Leon Lamar'],
basedOn:['Steven Pressfield'],
screenplay:['Jeremy Leven'],
production:['Michael Nozik','Karen Tenkhoff','Robert Redford','Jake Eberts'],
music:['Rachel Portman'],
camera:['Michael Ballhaus'],
cut:['Hank Corwin'],
sound:['Richard Hymns','Gary Summers','Gary Rizzo','Gary Rydstrom'],
scenography:['Stuart Craig','Jim Erickson'],
masks:['Gary Liddiard'],
costumes:['Judianna Makovsky']},
{title:"The Man Who Wasn't There",
titleCZ:'Muž, který nebyl',
year:2001,
runtime:116,
countries:['USA','UK'],
genres:['Drama','Crime'],
director:['Joel Coen','Ethan Coen'],
actors:['Billy Bob Thornton','Frances McDormand','Michael Badalucco','James Gandolfini','Katherine Borowitz','Jon Polito','Scarlett Johansson','Richard Jenkins','Tony Shalhoub','Jack McGee','Lilyan Chauvin','Adam Alexi-Malle','Ted Rooney','Abraham Benrubi','Brooke Smith','Dan Martin','Christopher McDonald','Kenneth Hughes','John Michael Higgins','Jennifer Jason Leigh','Max Thayer','Christopher Kriesa','Don Calfa','Gregg Binkley','Alan Fudge','Don Donati','Booth Colman','E.J. Callahan','Brian Haley','Stanley DeSantis','Rick Scarry','Pete Schrum','George Ives','Robert Loftin','Greg Bronson','Mary Bogue'],
screenplay:['Joel Coen','Ethan Coen'],
production:['Ethan Coen','Joel Coen'],
music:['Carter Burwell'],
camera:['Roger Deakins'],
cut:['Ethan Coen','Joel Coen','Tricia Cooke'],
sound:['Eugene Gearty','Skip Lievsay'],
scenography:['Dennis Gassner'],
masks:['Jean Ann Black','Laverne Caracuzzi','Lynne K. Eagan','Susan Mills'],
costumes:['Mary Zophres']},
{title:'Almost Famous',
titleCZ:'Na pokraji slávy',
year:2000,
runtime:122,
countries:['USA'],
genres:['Music','Drama','Biographic'],
director:['Cameron Crowe'],
actors:['Billy Crudup','Frances McDormand','Kate Hudson','Jason Lee','Patrick Fugit','Zooey Deschanel','Michael Angarano','Anna Paquin','Fairuza Balk','Noah Taylor','John Fedevich','Mark Kozelek','Philip Seymour Hoffman','Liz Stauber','Jimmy Fallon','Bijou Phillips','J.J. Cohen','Gary Kohn','Ray Porter','Mark Pellington','Eion Bailey','Terry Chen','Rainn Wilson','Erin Foley','Jesse Caron','Charles Walker','Jay Baruchel','Pauley Perrette','Peter Frampton','Zack Ward','Mitch Hedberg','Eric Stonestreet','Marc Maron','John Patrick Amedori','Scott N. Stevens','Kevin Sussman','Reathel Bean','Tom Riis Farrell','Holly Maples','Susan Yeagley','Nick Swardson','Greg Bronson','Mark Cirillo','Wayne Doba','Bodhi Elfman','Elizabeth Friedman','Kyle Gass','Jimmy Star'],
screenplay:['Cameron Crowe'],
production:['Cameron Crowe','Ian Bryce'],
music:['Nancy Wilson'],
camera:['John Toll'],
cut:['Joe Hutshing','Saar Klein'],
sound:['Doug Hemphill','Paul Massey'],
scenography:['Clay A. Griffith','Clayton Hartley'],
masks:['Lois Burwell','Michael Germain','Marina Hart','Carolyn Elias'],
costumes:['Betsy Heimann']},
{title:'Legend of the Drunken Master',
titleCZ:'Legenda o opilém Mistrovi',
year:1994,
runtime:97,
countries:['Hong Kong'],
genres:['Action','Comedy'],
director:['Chia-Liang Liu','Jackie Chan'],
actors:['Jackie Chan','Anita Mui','Lung Ti','Felix Wong','Chia-Liang Liu','Bill Tung','Andy Lau','Ken Lo','Kar-Yung Lau','Tai Bo','Hsu Hsia','Mars','Miu Yuen','Alan Kwok-kuen Chan','Siu-ming Lau','Louis Roth','Ho-Sung Pak','Nicky Li','Johnny Wa Cheung','Yee-Sang Hon','Max Alexander','Ram Chiang','Paul Pape','Ka-lok Chin','Suki Kwan','Anthony Carpio','Mark Houghton','Rocky Lai','Ying Cao','Yvonne Yung','Sam Wong','Yan Pak','Kit-Keung Ng','Mark Edward King','Pak-Kwong Ho','Fang Bao','Sun Wong','Fat Wan'],
screenplay:['Edward Tang','Kai-Chi Yuen'],
production:['Eric Tsang'],
music:['William Wai-Lap Wu','Michael Wandmacher'],
camera:['Jingle Ma','Tony Tung-leung Cheung','Yiu-Tsou Cheung','Nico Man-wan Wong'],
cut:['Peter Cheung'],
scenography:['Kim-Sing Ho','Eddie Ma'],
masks:['Lai-Kuen Law','Man-Kuen Chow'],
costumes:['Sukie Yip']},
{title:'Kundun',
titleCZ:'Kundun',
year:1997,
runtime:128,
countries:['USA'],
genres:['Drama','Biographic','History','War'],
director:['Martin Scorsese'],
actors:['Tenzin Thuthob Tsarong','Gyurme Tethong','Tulku Jamyang Kunga Tenzin','Tenzin Yeshi Paichang','Tencho Gyalpo','Tenzin Topjar','Tsewang Migyur Khangsar','Tenzin Lodoe','Geshi Yeshi Gyatso','Losang Gyatso','Sonam Phuntsok','Gyatso Lukhang','Lobsang Samten','Jigme Tsarong','Tenzin Trinley','Namgay Dorjee','Phintso Thonden','Chewang Tsering Ngokhang','Jamyang Tenzin','Tashi Dhondup','Jampa Lungtok','Ken Leung','Kim Chan','Henry Yuk','Salden Kunga'],
screenplay:['Melissa Mathison'],
production:['Barbara De Fina'],
music:['Philip Glass'],
camera:['Roger Deakins'],
cut:['Thelma Schoonmaker'],
sound:['Tom Fleischman'],
scenography:['Dante Ferretti','Francesca Lo Schiavo','Franco Ceraolo'],
masks:['Fabrizio Sforza','Elisabetta De Leonardis'],
costumes:['Dante Ferretti']},
{title:'The Diving Bell and the Butterfly',
titleCZ:'Skafandr a motýl',
year:2007,
runtime:107,
countries:['France','USA'],
genres:['Drama','Biographic'],
director:['Julian Schnabel'],
actors:['Mathieu Amalric','Emmanuelle Seigner','Marie-Josée Croze','Anne Consigny','Patrick Chesnais','Niels Arestrup','Jean-Pierre Cassel','Marina Hands','Max von Sydow','Gérard Watkins','Isaach De Bankolé','Emma de Caunes','Jean-Philippe Écoffey','Zinedine Soualem','Agathe de La Fontaine','Laure de Clermont-Tonnerre','Michael Wincott','Lenny Kravitz','Hiam Abbass','Jean-Baptiste Mondino','Nicolas Le Riche','Françoise Lebrun','François Delaive','Elvis Polanski','Fiorella Campanella','Azzedine Alaïa'],
basedOn:['Jean-Dominique Bauby'],
screenplay:['Ronald Harwood'],
production:['Kathleen Kennedy','Jon Kilik'],
music:['Paul Cantelon'],
camera:['Janusz Kamiński'],
cut:['Juliette Welfling'],
sound:['Damien Lazzerini'],
scenography:['Laurent Ott'],
masks:['Benoît Lestang'],
costumes:['Olivier Bériot']},
{title:'Bambi',
titleCZ:'Bambi',
year:1942,
runtime:70,
countries:['USA'],
genres:['Animation','Family','Drama'],
director:['David Hand'],
actors:['Hardie Albright','Otis Harlan','Sterling Holloway','Will Wright','Ann Gillis','Cammie King Conlon','Sam Edwards','Donnie Dunagan','Marion Darlington'],
basedOn:['Felix Salten'],
production:['Walt Disney'],
cut:['Thomas Scott']},
{title:'Smoke',
titleCZ:'Smoke',
year:1995,
runtime:112,
countries:['Germany','USA','Japan'],
genres:['Drama','Comedy'],
director:['Wayne Wang','Paul Auster'],
actors:['Harvey Keitel','William Hurt','Stockard Channing','Forest Whitaker','Giancarlo Esposito','Harold Perrineau','Jared Harris','Victor Argo','Ashley Judd','Stephen Gevedon','Malik Yoba','John Lurie',"Deirdre O'Connell",'Clarice Taylor','Erica Gimpel','José Zúñiga','Michelle Hurst','Baxter Harris','Mel Gorham','Mary B. Ward'],
screenplay:['Paul Auster'],
production:['Peter Newman'],
music:['Rachel Portman'],
camera:['Adam Holender'],
cut:['Christopher Tellefsen','Maysie Hoy'],
sound:['Drew Kunin'],
scenography:['Kalina Ivanov','Karin Wiesel Holmes'],
costumes:['Claudia Brown','Chuck Keehne']},
{title:'After the Wedding',
titleCZ:'Po svatbě',
year:2006,
runtime:120,
countries:['Denmark','Sweden','Norway','UK'],
genres:['Drama'],
director:['Susanne Bier'],
actors:['Mads Mikkelsen','Rolf Lassgård','Sidse Babett Knudsen','Henrik Larsen','Julie R. Ølgaard','Christian Tafdrup','Neel Rønholt','Stine Fischer Christensen','Ida Dwinger','Jonatan Spang','Rita Angela','Troels Munk','Mona Malm','Claus Flygare','Marie-Louise Coninck','Henning Jensen','Niels Anders Thorn','David Petersen','Erni Arneson','Suhita Thatte','Thomas Voss','Anne Fletting','Samir Di Johansson'],
screenplay:['Anders Thomas Jensen'],
production:['Sisse Graum Jørgensen','Anne Katrine Andersen'],
music:['Johan Söderqvist'],
camera:['Morten Søborg'],
cut:['Pernille Bech Christensen','Morten Højbjerg'],
sound:['Eddie Simonsen','Christian Lund'],
scenography:['Søren Skjær'],
masks:['Lili Malene Rasmussen','Charlotte Laustsen','Bjørg Serup'],
costumes:['Manon Rasmussen']},
{title:'The Cranes Are Flying',
titleCZ:'Jeřábi táhnou',
year:1957,
runtime:97,
countries:['Russia'],
genres:['Drama','Romance','War'],
director:['Michail Kalatozov'],
actors:['Taťjana Samojlova','Alexej Batalov','Vasilij Merkurjev','Alexandr Švorin','Valentina Vladimirova','Valentin Zubkov','Světlana Charitonova','Alevtina Rumjanceva','Jevgenij Stěblov','Nikolaj Smorčkov','Antonina Bogdanova','Daniil Nětrebin','Konstantin Kadočnikov','Galina Stěpanova','Boris Kokovkin','Georgij Kulikov','Valentina Ananina','Olga Dzisko','Anna Zaržitskaja','Valentina Běrezuckaja','Maja Bulgakova','Vasilij Cygankov'],
screenplay:['Viktor Rozov','Viktor Rozov'],
camera:['Sergej Urusevskij']},
{title:'The Battle of Algiers',
titleCZ:'Bitva o Alžír',
year:1966,
runtime:121,
countries:['Italy','Alžírsko'],
genres:['Drama','War'],
director:['Gillo Pontecorvo'],
actors:['Jean Martin','Brahim Hadjadj','Yacef Saadi','Franco Moruzzi','Mohamed Ben Kassen','Fusia El Kader'],
screenplay:['Franco Solinas'],
production:['Yacef Saadi'],
music:['Ennio Morricone','Gillo Pontecorvo'],
camera:['Marcello Gatti'],
cut:['Mario Serandrei','Mario Morra'],
scenography:['Sergio Canevari','Sergio Canevari'],
masks:['Maurizio Giustini']},
{title:'Lone Wolf and Cub: Baby Cart to Hades',
titleCZ:'Vlk samotář a mládě 3: Proti vichru smrti',
year:1972,
runtime:89,
countries:['Japan'],
genres:['Action','Drama'],
director:['Kendži Misumi'],
actors:['Tomisaburó Wakajama','Isao Jamagata','Reiko Kasahara','Júko Hama','Saburó Date','Džun Hamamura','Masaru Šiga']},
{title:'I, Robot',
titleCZ:'Já, robot',
year:2004,
runtime:115,
countries:['USA','Germany'],
genres:['Sci-Fi','Action','Crime','Thriller','Drama','Mystery'],
director:['Alex Proyas'],
actors:['Will Smith','Bridget Moynahan','Bruce Greenwood','James Cromwell','Chi McBride','Shia LaBeouf','Alan Tudyk','Aaron Douglas','Simon Baker','Tiffany Lyndall-Knight','Emily Tennant','Terry Chen','Peter Shinkoda','Sharon Wilkins','Jerry Wasserman','Monique Ganderton','Darren Moore','Angela Moore','Scott Heindl','Victor Formosa','Craig March','Adrian Ricard','Bobby Stewart'],
basedOn:['Isaac Asimov'],
screenplay:['Jeff Vintar','Akiva Goldsman'],
production:['Wyck Godfrey','John Davis','Laurence Mark'],
music:['Marco Beltrami'],
camera:['Simon Duggan'],
cut:['William Hoy','Richard Learoyd','Armen Minasian'],
sound:['Paul Massey','Erik Aadahl','Doug Hemphill','John A. Larsen','Craig Berkey'],
scenography:['Patrick Tatopoulos'],
masks:['Patricia Murray','Vince Yoshida'],
costumes:['Liz Keogh Palmer']},
{title:'Wild Tales',
titleCZ:'Divoké historky',
year:2014,
runtime:122,
countries:['Argentina','Spain'],
genres:['Tale','Comedy','Drama','Thriller'],
director:['Damián Szifron'],
actors:['Darío Grandinetti','María Marull','Mónica Villa','Diego Starosta','Héctor Drachtman','Rita Cortese','Julieta Zylberberg','César Bordón','Leonardo Sbaraglia','Walter Donado','Carlos Moyá','Ricardo Darín','Nancy Dupláa','Luis Mazzeo','Pablo Moseinco','Martín Gervasoni','Federico Liss','Lucrecia Gelardi','Camila Sofía Casas','Fiorella Pedrazzini','Oscar Martínez','María Onetto','Osmar Núñez','Germán de Silva','Diego Velázquez','Alan Daicz','Erica Rivas','Diego Gentile','Margarita Molfino','Marcelo Pozzi','Paula Grinszpan','Miguel Di Lemme','Horacio Nin Uría'],
screenplay:['Damián Szifron'],
production:['Matías Mosteirín','Esther García','Hugo Sigman','Pedro Almodóvar','Agustín Almodóvar'],
music:['Gustavo Santaolalla'],
camera:['Javier Juliá'],
cut:['Damián Szifron','Pablo Barbieri Carrera'],
sound:['José Luis Díaz','Diego Gat'],
scenography:['María Clara Notari'],
masks:['Marisa Amenta'],
costumes:['Ruth Fischerman']},
{title:'The Wave',
titleCZ:'Náš vůdce',
year:2008,
runtime:110,
countries:['Germany'],
genres:['Drama','Thriller'],
director:['Dennis Gansel'],
actors:['Jürgen Vogel','Frederick Lau','Max Riemelt','Jennifer Ulrich','Christiane Paul',"Elyas M'Barek",'Jacob Matschenz','Max Mauff','Cristina do Rego','Ferdinand Schmidt-Modrow','Amelie Kiefer','Odine Johne','Tim Oliver Schultz','Fabian Preger','Maximilian Vollmar','Maren Kroymann','Tino Mewes','Lennard Bertzbach','Alexander Held','Lucas Hardt','Johanna Gastdorf','Dennis Gansel','Liv Lisa Fries','Jaime Ferkic','Teresa Harder','Karoline Teska','Hubert Mulzer','Marco Bretscher-Coschignano','Friederike Wagner',"Joseph M'Barek",'Natascha Paulick','Thommy Schwimmer'],
screenplay:['Johnny Dawkins','Ron Birnbach','Dennis Gansel','Peter Thorwarth'],
production:['Christian Becker','David Groenewold','Martin Moszkowicz'],
music:['Heiko Maile'],
camera:['Torsten Breuer'],
cut:['Ueli Christen'],
sound:['Tschangis Chahrokh','Patrick Veigel','Christian Bischoff','Alexander Saal'],
scenography:['Knut Loewe'],
masks:['Dörte Dobkowitz','Irina Tübbecke'],
costumes:['Ivana Milos']},
{title:'The Abyss',
titleCZ:'Propast',
year:1989,
runtime:139,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Thriller'],
director:['James Cameron'],
actors:['Ed Harris','Mary Elizabeth Mastrantonio','Michael Biehn','Leo Burmester','Todd Graff','John Bedford Lloyd','J.C. Quinn','Kimberly Scott','Jimmie Ray Weeks','Ken Jenkins','Michael Beach','Michael Chapman','Chris Elliott','Dick Warlock','J. Kenneth Campbell','Phillip Darlington','Brad Sullivan','Joseph C. Nemec III','Adam Nelson','Emily Yancy','Tom Isbell','Thomas F. Duffy','Christopher Murphy','Daren Dochterman'],
screenplay:['James Cameron'],
production:['Gale Anne Hurd'],
music:['Alan Silvestri'],
camera:['Mikael Salomon'],
cut:['Conrad Buff IV','Howard E. Smith','Joel Goodman'],
sound:['Sergio Reyes','Michael Minkler'],
scenography:['Leslie Dilley','Anne Kuljian'],
costumes:['Deborah Everton']},
{title:'Donnie Brasco',
titleCZ:'Krycí jméno Donnie Brasco',
year:1997,
runtime:127,
countries:['USA'],
genres:['Drama','Crime','Biographic'],
director:['Mike Newell'],
actors:['Al Pacino','Johnny Depp','Michael Madsen','Bruno Kirby','James Russo','Anne Heche','Željko Ivanek','Robert Miano','Brian Tarantina','Rocco Sisto','Zach Grenier','Gretchen Mol','Tim Blake Nelson','Paul Giamatti','Andrew Parks','Tony Ray Rossi','Elle Alexander','Dan Brennan','Val Avery','Elaine del Valle','Terry Serpico','Madison Arnold','Randy Jurgensen','Frank Pesce','Larry Romano','Sal Jenco','Gerry Becker','Denise Faye','Ronnie Farer','Tony Lip','Katie Sagona','John Di Benedetto','Laura Cahill','Doreen Murphy','James McCauley'],
basedOn:['Joseph D. Pistone','Richard Woodley'],
screenplay:['Paul Attanasio'],
production:['Mark Johnson','Barry Levinson','Gail Mutrux','Louis DiGiaimo'],
music:['Patrick Doyle'],
camera:['Milan Peter Sova'],
cut:['Jon Gregory'],
sound:['Tim Cavagin','Tod A. Maitland'],
scenography:['Donald Graham Burt'],
masks:['John Caglione','Jr.'],
costumes:['Aude Bronson-Howard','David C. Robinson']},
{title:'Blue Velvet',
titleCZ:'Modrý samet',
year:1986,
runtime:120,
countries:['USA'],
genres:['Mystery','Thriller','Drama','Crime'],
director:['David Lynch'],
actors:['Kyle MacLachlan','Dennis Hopper','Laura Dern','Isabella Rossellini','Hope Lange','Dean Stockwell','George Dickerson','Priscilla Pointer','Brad Dourif','Jack Nance','Angelo Badalamenti','Frances Bay','Fred Pickler','J. Michael Hunter'],
screenplay:['David Lynch'],
production:['Dino De Laurentiis','Fred C. Caruso'],
music:['Angelo Badalamenti'],
camera:['Frederick Elmes'],
cut:['Duwayne Dunham'],
sound:['David Parker'],
scenography:['Patricia Norris'],
masks:['Jeff Goodwin']},
{title:'The Animatrix',
titleCZ:'Animatrix',
year:2003,
runtime:101,
countries:['USA'],
genres:['Animation','Sci-Fi','Action','Adventure'],
director:['Andrew R. Jones',"Šin'ičiró Watanabe",'Mahiro Maeda','Kódži Morimoto','Jošiaki Kawadžiri','Peter Chung','Takeši Koike'],
actors:['Akio Ócuka','Dwight Schultz','Carrie-Anne Moss','Keanu Reeves','Rick Gomez','Hedy Burress',"Terrence 'T.C.' Carson",'Tress MacNeille','Tom Kenny',"Olivia d'Abo",'Allison Smith','Melinda Clarke','Phil LaMarr','Pamela Adlon','John DiMaggio','James Arnold Taylor','Alex Fernandez','Jack Fletcher','Bette Ford','Kevin Michael Richardson','John DeMita','Matt McKenzie','Jill Talley','Victor Williams','John Wesley','Eric Aten','Kath Soucie','Rodney Saulsberry','Clayton Watson','Julia Fletcher'],
screenplay:['Lilly Wachowski','Lana Wachowski',"Šin'ičiró Watanabe",'Lilly Wachowski','Lana Wachowski'],
production:['Cameron Stevning'],
music:['Don Davis','Machine Head','Photek'],
cut:['Christopher S. Capp']},
{title:'Now Where Did the Seventh Company Get to?',
titleCZ:'Kam se poděla sedmá rota?',
year:1973,
runtime:90,
countries:['France','Italy'],
genres:['Comedy','War'],
director:['Robert Lamoureux'],
actors:['Jean Lefebvre','Pierre Mondy','Aldo Maccione','Pierre Tornade','Jacques Marin','Paul Bisciglia','Robert Dalban','Alain Doutey','Magali Vendeuil','Marcelle Ranson-Hervé','Erik Colin','Robert Lamoureux','Florence Blot','Konrad von Bork','Michel Duchezeau','Jean-Claude Houdinière','Corinne Lahaye','Rudy Lenoir','Paul Mercey','Pierre Mirat','Raymonde Vattier','Gino Da Ronch'],
screenplay:['Robert Lamoureux'],
production:['Alain Poiré'],
music:['Henri Bourtayre'],
camera:['Marcel Grignon'],
cut:['Gérard Pollicand'],
sound:['Jacques Maumont'],
scenography:['Daniel Guéret']},
{title:'Where Eagles Dare',
titleCZ:'Kam orli nelétají',
year:1968,
runtime:158,
countries:['UK','USA'],
genres:['Action','Adventure','War'],
director:['Brian G. Hutton'],
actors:['Richard Burton','Clint Eastwood','Mary Ure','Michael Hordern','Donald Houston','Anton Diffring','Derren Nesbitt','Vincent Ball','Ferdy Mayne','Ingrid Pitt','Neil McCarthy','Philip Stone','Anton Rodgers','Olga Lowe','Robert Beatty','Max Faulkner','William Squire','Derek Newark','Nigel Lambert','Victor Beaumont','Guy Deghy','Ivor Dean','Peter Roy','Patrick Wymark','Jim Tyson','Brook Williams','Ernst Walder','John G. Heller','Terence Mountain',"Jim O'Brady",'Peter Barkworth','Richard Beale'],
basedOn:['Alistair MacLean'],
screenplay:['Alistair MacLean'],
production:['Elliott Kastner'],
music:['Ron Goodwin'],
camera:['Arthur Ibbetson'],
cut:['John Jympson'],
scenography:['Peter Mullins']},
{title:"All the President's Men",
titleCZ:'Všichni prezidentovi muži',
year:1976,
runtime:132,
countries:['USA'],
genres:['Drama','History','Thriller','Biographic'],
director:['Alan J. Pakula'],
actors:['Dustin Hoffman','Robert Redford','Jack Warden','Martin Balsam','Hal Holbrook','Jason Robards','Jane Alexander','Meredith Baxter','Ned Beatty','Stephen Collins','Penny Fuller','John McMartin','Robert Walden','Frank Wills','F. Murray Abraham','David Arkin','Dominic Chianese','Bryan Clark','Nicolas Coster','Lindsay Crouse','Valerie Curtin','Gene Dynarski','Nate Esformes','Ron Hale','Richard Herd','Polly Holliday','James Karen','Paul Lambert','Frank Latimore','Anthony Mannino','Allyn Ann McLerie','James Murtaugh',"John O'Leary",'Jess Osuna','Neva Patterson','Penny Peyser','Joshua Shelley','George Wyner','Stanley Bennett Clay','John Furlong','Sidney Ganis','Basil Hoffman','Jamie Smith-Jackson','Doug Llewelyn','Jeff MacKay','Christopher Murray','Jess Nadelman','Louis Quinn','Peter Salim','Shawn Shea','Richard Venture','Spiro Agnew','Gerald Ford','Bart Greene','Richard Nixon','John Randolph'],
screenplay:['William Goldman'],
production:['Walter Coblenz'],
music:['David Shire'],
camera:['Gordon Willis'],
cut:['Robert L. Wolfe'],
sound:['Rick Alexander'],
scenography:['George Jenkins','George Gaines'],
masks:['Gary Liddiard'],
costumes:['Bernie Pollack']},
{title:'The Baader Meinhof Complex',
titleCZ:'Baader Meinhof Komplex',
year:2008,
runtime:144,
countries:['Germany','France','Czechia'],
genres:['Action','Drama','Crime','Biographic'],
director:['Uli Edel'],
actors:['Martina Gedeck','Moritz Bleibtreu','Johanna Wokalek','Nadja Uhl','Stipe Erceg','Niels Bruno Schmidt','Vinzenz Kiefer','Simon Licht','Alexandra Maria Lara','Daniel Lommatzsch','Sebastian Blomberg','Heino Ferch','Jan Josef Liefers','Hannah Herzsprung','Tom Schilling','Bruno Ganz','Hans-Werner Meyer','Katharina Wackernagel','Anna Thalbach','Volker Bruch','Jasmin Tabatabai','Thomas Thieme','Susanne Bormann','Michael Gwisdek','Hubert Mulzer','Alexander Held','Bernd Stegemann','Annika Kuhl','Patrick von Blume','Sandra Borgmann','Michael Schenk','Hannes Wegener','Johannes Suhm','Christian Schmidt','Stephan Möller-Titel','Andreas Tobias','Jona Mues','Elisabeth Schwarz','Britta Hammelstein','Christian Blümel','Peter Schneider','Jakob Diehl','Wolfgang Pregler','Leopold Hornung','Christian Näthe','Hassam Ghancy','Martin Glade','Andreas Schröders','Nina Eichinger','Sunnyi Melles','Rainer Reiners','Ralf Tempel','Joachim Paul Assböck','Kirsten Block','Andreas Borcherding','Leonie Brandis','Willy Brandt','Ben Braun','Frank Engster','Samir Fuchs','Aaron Hildebrand','Christian Hoening','Norbert Hülm','Christian Kerepeszki','Ralph Kretschmar','Karl-Heinz Köpcke','Robert Lehmann','Carlo Ljubek','Bettina Lohmeyer','Jim McKay','Smaïl Mekki','Esther Seibt','Muhammad Rezá Pahlaví','Leon Palamarciuc','Sebastian Rüger','Frank-Otto Schenk','Tesie Tellmann','Henrike von Kuick','Martin Walch','Farah Pahlaví','Cyrill Berndt','Andreas Haslinger','Kim Frank','Joachim Schweizer','Adam Jaskolka','Helmut Schmidt','Paul Schlase','Julia Stenke','Stephan Meyer-Kohlhoff','Nicolas Walier','Katja Zinsmeister','Oliver Walser','Dirk Hermann','Hans-Jürgen Brendel','Johanna Bönninghaus','Marco Fischer','Jo Brauner'],
basedOn:['Stefan Aust'],
screenplay:['Bernd Eichinger'],
production:['Bernd Eichinger','Martin Moszkowicz'],
music:['Florian Tessloff','Peter Hinderthür'],
camera:['Rainer Klausmann'],
cut:['Alexander Berner'],
sound:['Roland Winke','Benjamin Rosenkind','Stefan Busch','Nico Krebs','Michael Kranz'],
scenography:['Bernd Lepel','Hucky Hornberger','Paola Riviello'],
masks:['Waldemar Pokromski','Sabine Schumann'],
costumes:['Birgit Missal']},
{title:'Midnight Express',
titleCZ:'Půlnoční expres',
year:1978,
runtime:116,
countries:['UK','USA','Turkey'],
genres:['Crime','Drama','Thriller','Biographic'],
director:['Alan Parker'],
actors:['Brad Davis','Irene Miracle','Bo Hopkins','Paolo Bonacelli','Paul L. Smith','Randy Quaid','Norbert Weisser','John Hurt','Mike Kellin','Franco Diogene','Michael Ensign','Gigi Ballista','Kevork Malikyan','Peter Jeffrey','Joe Zammit Cordina','Yashaw Adem','Raad Rawi','Vic Tablian','Zannino','Mihalis Giannatos','Ahmed El Shenawi'],
basedOn:['Billy Hayes','William Hoffer'],
screenplay:['Oliver Stone'],
production:['Alan Marshall','David Puttnam'],
music:['Giorgio Moroder'],
camera:['Michael Seresin'],
cut:['Gerry Hambling'],
scenography:['Geoffrey Kirkland'],
masks:['Pat Hay','Sarah Monzani'],
costumes:['Milena Canonero']},
{title:"Ronia: The Robber's Daughter",
titleCZ:'Ronja, dcera loupežníka',
year:1984,
runtime:126,
countries:['Sweden','Norway'],
genres:['Adventure','Family','Romance','Fairytale'],
director:['Tage Danielsson'],
actors:['Hanna Zetterberg','Dan Håfström','Börje Ahlstedt','Lena Nyman','Per Oscarsson','Med Reventberg','Allan Edwall','Rune Andersson','Tommy Körberg','Henry Ottenby','Philip Zandén','Björn Isfält','Louise Ræder','Georg Adelly','Lennart Aspegren','Lillemor Ohlson','Claes Janson','Ulf Isenborg','Björn Wallde','Werner Hemmingsen','Arne Liljenberg','Saeed Hooshidar','Anders Albén','Viveka Anderberg','Torkel Henriksson','Lars Peltoniemi','Ingemar Fraim','Linda Krüger','Teddy Scott'],
basedOn:['Astrid Lindgren'],
screenplay:['Astrid Lindgren'],
production:['Anita Tesler'],
music:['Björn Isfält'],
camera:['Rune Ericson','Mischa Gavrjusjov','Per Svensson','Ole Fredrik Haug'],
cut:['Jan Persson'],
sound:['Christer Furubrand','Per Carleson','Wille Peterson-Berger','Berndt Frithiof'],
scenography:['Ulf Axén','Bengt Svedberg','Rolf Persson'],
masks:['Siw Järbyn','Kaj Grönberg','Per Hjorth'],
costumes:['Lenamari Wallström','Per Åhlin','Bente Winther-Larsen']},
{title:'Strangers on a Train',
titleCZ:'Cizinci ve vlaku',
year:1951,
runtime:101,
countries:['USA'],
genres:['Crime','Drama','Thriller','Film-Noir'],
director:['Alfred Hitchcock'],
actors:['Farley Granger','Ruth Roman','Robert Walker','Leo G. Carroll','Patricia Hitchcock','Kasey Rogers','Jonathan Hale','Robert Gist','Howard St. John','Alfred Hitchcock','John Doucette','Mike Lally','Robert Williams','Norma Varden','Dick Wessel','Al Bridge','David McMahon','Charles Sherlock','Ralph Moody','Franklyn Farnum','George Magrill','Barry Norton','John Daheim','Roy Engel','Brooks Benedict','Sam Flint','Edward Hearn','Paul Panzer','Edward Clark','Murray Alper','Suzanne Ridgway','Odette Myrtil','Charles Meredith','Perc Launders','Mary Alan Hokanson','Leonard Carey','Charles Marsh','Herbert Evans','Al Hill','Tommy Farrell','John Butler','Paul McGuire','Joe Brooks','Georges Renavent','Thomas Martin','Tom Ferrandini','Stuart Hall'],
basedOn:['Patricia Highsmith'],
screenplay:['Raymond Chandler','Czenzi Ormonde','Ben Hecht'],
production:['Alfred Hitchcock'],
music:['Dimitri Tiomkin'],
camera:['Robert Burks'],
cut:['William H. Ziegler'],
masks:['Gordon Bau']},
{title:'The African Queen',
titleCZ:'Africká Královna',
year:1951,
runtime:105,
countries:['UK','USA'],
genres:['Adventure','Romance','War'],
director:['John Huston'],
actors:['Humphrey Bogart','Katharine Hepburn','Robert Morley','Peter Bull','Theodore Bikel','Walter Gotell','Richard Marner','Errol John','Peter Swanwick'],
basedOn:['C. S. Forester'],
screenplay:['Peter Viertel','John Collier'],
production:['Sam Spiegel','John Woolf'],
music:['Allan Gray'],
camera:['Jack Cardiff'],
cut:['Ralph Kemplen'],
masks:['George Frost']},
{title:'Lone Wolf and Cub: Baby Cart at the River Styx',
titleCZ:'Vlk samotář a mládě 2: Řeka smrti',
year:1972,
runtime:81,
countries:['Japan'],
genres:['Action','Adventure','Drama'],
director:['Kendži Misumi'],
actors:['Tomisaburó Wakajama','Kajo Macuo','Akidži Kobajaši','Minoru Óki','Ičiró Jamamoto']},
{title:'Violet Perfume: Nobody Hears You',
titleCZ:'Fialkový parfém',
year:2001,
runtime:90,
countries:['Mexico'],
genres:['Drama'],
director:['Marisa Sistach'],
actors:['Ximena Ayala','Nancy Gutiérrez','Arcelia Ramírez','Clarissa Malheiros','Gabino Rodríguez','Luis Fernando Peña','María Rojo','Eligio Meléndez','Rosario Zúñiga','Servando Gajá','Carlos García'],
screenplay:['José Buil'],
production:['José Buil'],
cut:['José Buil'],
sound:['Antonio Diego']},
{title:'The Heart Is a Lonely Hunter',
titleCZ:'Srdce je osamělý lovec',
year:1968,
runtime:123,
countries:['USA'],
genres:['Drama'],
director:['Robert Ellis Miller'],
actors:['Alan Arkin','Chuck McCann','Sondra Locke','Peter Mamakos',"John O'Leary",'Percy Rodrigues','Stacy Keach','Biff McGuire','Cicely Tyson'],
basedOn:['Carson McCullers'],
screenplay:['Thomas C. Ryan'],
production:['Thomas C. Ryan'],
music:['Dave Grusin'],
camera:['James Wong Howe'],
cut:['John F. Burnett'],
sound:['Francis E. Stahl'],
costumes:['Albert Wolsky']},
{title:'Cast Away',
titleCZ:'Trosečník',
year:2000,
runtime:143,
countries:['USA'],
genres:['Adventure','Drama'],
director:['Robert Zemeckis'],
actors:['Tom Hanks','Helen Hunt','David Allen Brooks','Nick Searcy','Nan Martin','Elden Henson','Timothy Stack','Jay Acovone','Chris Noth','Jenifer Lewis','Derick Alexander','Lauren Birkell','Christopher Kriesa','Lari White','Yelena Popovic','Jegor Pazenko','Valerie Wildman','Michael Forest','Viveka Davis','Alyssa Gainer','Paul Sanchez','Vsevolod Boldin','Geoffrey Blake','Wendy Worthington','Tommy Cresswell','Dennis Letts','Anne Bellamy','Steve Monroe','John Duerler','Vince Martin','Skye McKenzie','Joe Conley','Dmitri S. Boudrine','Gregory Pugliese','Wilson the Volleyball','Mark S. Porro'],
screenplay:['William Broyles Jr.'],
production:['Tom Hanks','Robert Zemeckis','Steve Starkey','Jack Rapke'],
music:['Alan Silvestri'],
camera:['Don Burgess'],
cut:['Arthur Schmidt'],
sound:['Dennis Leonard','Randy Thom','Tom Johnson'],
scenography:['Rick Carter','Rosemary Brandenburg',"Karen O'Hara"],
costumes:['Joanna Johnston']},
{title:'X-Men 2',
titleCZ:'X-Men 2',
year:2003,
runtime:128,
countries:['USA','Canada'],
genres:['Action','Adventure','Sci-Fi','Thriller'],
director:['Bryan Singer'],
actors:['Patrick Stewart','Hugh Jackman','Ian McKellen','Halle Berry','Famke Janssen','James Marsden','Rebecca Romijn','Anna Paquin','Alan Cumming','Brian Cox','Bruce Davison','Aaron Stanford','Kelly Hu','Katie Stuart','Chiara Zanni','Brad Loree','Steve Bacic','Aaron Douglas','David Kaye','Newton Thomas Sigel','Shawn Ashmore','Daniel Cudmore','Nolan Gerard Funk','Peter Wingfield','Ty Olsson','Layke Anderson','Roger Cross','James Kirk','Emily Hirst','Valerie Tian','Aaron Pearl','Jade Ramsey','Brian Peck','Colin Lawrence','Cotter Smith','Kendall Cross','Devin Douglas Drewitz','Alf Humphreys','Jill Teed','Nikita Ramsey','Michael Soltis','Dylan Kussman','Blake Mawson','Michasha Armstrong','Michael Reid MacKay','Kurt Max Runte','Michael David Simms','Shauna Kain','Greg Rikaart','Alfonso Quijada','Bryce Hodgson'],
screenplay:['Michael Dougherty','David Hayter','Dan Harris'],
production:['Lauren Shuler Donner','Ralph Winter'],
music:['John Ottman'],
camera:['Newton Thomas Sigel'],
cut:['John Ottman'],
sound:['Doug Hemphill','John A. Larsen','Rob Young','Craig Berkey'],
scenography:['Guy Hendrix Dyas'],
masks:['Jayne Dancose','Gordon J. Smith','Charles Porlier','Norma Hill-Patton','Monica Huppert','Rita Ciccozzi','Leanne Rae Podavin','Bill Terezakis','Toby Lindala'],
costumes:['Louise Mingenbach']},
{title:'You Take the Kids!',
titleCZ:'S tebou mě baví svět',
year:1982,
runtime:82,
countries:['Czechoslovakia'],
genres:['Comedy','Family'],
director:['Marie Poledňáková'],
actors:['Július Satinský','Jana Šulcová','Václav Postránecký','Eliška Balzerová','Pavel Nový','Zdena Studenková','Květa Fialová','Jan Faltýnek','Zuzana Githeisová','Marta Buchtíková','Václav Korda','Cyril Křupala','Lukáš Pelánek','Marek Dvořák','Magda Křížková-Šebestová','Viktor Maurer','Jan Balzer','Zdeněk Skalický','Jaroslav Tomsa','Eduard Pavlíček','Jiří Schmiedt','Marta Pospíchalová','Kateřina Besserová','Jitka Asterová','Marta Richterová','Naďa Konvalinková'],
screenplay:['Marie Poledňáková'],
production:['Jan Balzer'],
music:['Václav Zahradník'],
camera:['Petr Polák'],
cut:['Miroslav Hájek'],
sound:['Pavel Jelínek'],
scenography:['Jiří Matolín'],
masks:['František Čížek'],
costumes:['Libuše Pražáková','Petra Barochová']},
{title:'Rise of the Planet of the Apes',
titleCZ:'Zrození Planety opic',
year:2011,
runtime:105,
countries:['USA'],
genres:['Action','Adventure','Drama','Sci-Fi','Thriller'],
director:['Rupert Wyatt'],
actors:['James Franco','Andy Serkis','Brian Cox','John Lithgow','Freida Pinto','Tom Felton','Tyler Labine','Sonja Bennett','Chelah Horsdal','David Oyelowo','David Hewlett','Timothy Webber','Tracy Spiridakos','Lauren Watson','Jeb Beach','Leah Gibson','Robin Nielsen','Michael Kopsa','Elizabeth Weinstein','Adrian Hough','Evans Johnson','Jesse Reid','Chris Shields','Ki Yurij','Ryan Jefferson Booth','Sean Tyson','James Pizzinato',"Kevin O'Grady",'Richard Ridings','BJ Harrison','Peter Bundic','Linda Watters','Tom Franco','Charles L. Campbell','Ivan Wanis-Ruiz','Devyn Dalton','Jay Caputo','Luc Roderique','Loyd Bateman','Trevor Addie','Ian Gregson','Trevor Carroll','Dean Redman'],
basedOn:['Pierre Boulle'],
screenplay:['Rick Jaffa','Amanda Silver'],
production:['Dylan Clark','Peter Chernin'],
music:['Patrick Doyle'],
camera:['Andrew Lesnie'],
cut:['Conrad Buff IV','Mark Goldblatt'],
sound:['Ron Bartlett','Doug Hemphill','Chuck Michael','John A. Larsen'],
scenography:['Claude Paré'],
masks:['Victoria Down','Emanuela Daus'],
costumes:['Renée April']},
{title:'Spotlight',
titleCZ:'Spotlight',
year:2015,
runtime:129,
countries:['USA'],
genres:['Drama','History','Crime'],
director:['Tom McCarthy'],
actors:['Mark Ruffalo','Michael Keaton','Rachel McAdams','Liev Schreiber','John Slattery',"Brian d'Arcy James",'Stanley Tucci','Doug Murray','Jamey Sheridan','Neal Huff','Billy Crudup','Duane Murray','Paul Guilfoyle','Michael Countryman','Brad Borbridge','Don Allison','Gary Galone','Laurie Heineman','Elena Juatco','Nancy Villone','Siobhan Murphy','Tim Progosh','Michele Proude','Len Cariou','Dennis Lynch','Richard Fitzpatrick','Janet Pinnick','Richard Jenkins','Laurie Murdoch','Chris De Christopher','Cyndy Day','Jami Tennille','Krista Morin','Robert B. Kennedy','Zarrin Darnell-Martin','Stefanie Drummond','David Afflick','Michael Cyril Creighton','Darrin Baker','Lana Antonova','Elena Khan','Robert Clarke','Stew Replogle','Sharon McFarlane','Michael Rezendes','Moira Driscoll',"Mairtin O'Carrigan"],
screenplay:['Josh Singer','Tom McCarthy'],
production:['Blye Pagon Faust','Steve Golin','Michael Sugar','Nicole Rocklin'],
music:['Howard Shore'],
camera:['Masanobu Takayanagi'],
cut:['Tom McArdle'],
sound:['Paul Hsu'],
scenography:['Stephen H. Carter','Michaela Cheyne','Shane Vieau'],
masks:['Jordan Samuel','Nichole Pleau','Mario Cacioppo'],
costumes:['Wendy Chuck']},
{title:'Fearless',
titleCZ:'Obávaný bojovník',
year:2006,
runtime:100,
countries:['Hong Kong','China','USA'],
genres:['Action','Drama','Biographic'],
director:['Ronny Yu'],
actors:['Jet Li','Šidó Nakamura','Betty Sun','Collin Chou','Masato Harada','Nathan Jones','Jon T. Benn','Anthony De Longis','John Paisley','Nina Paw','Samantha Buck','Jacky Heung','Jingjing Ma','Siu-Wah Chan','Sophie Zhang','Yong Dong','Binghua Wei','Bing-Hua Wei'],
screenplay:['Chi-long To'],
music:['Šigeru Umebajaši'],
camera:['Hang-Sang Poon'],
cut:['Virginia Katz','Richard Learoyd'],
sound:['Stephen P. Robinson','Chris David','Marshall Garlington','Richard E. Yawn','Matthew T. Duncan'],
scenography:['Kenneth Mak','Zhanjia Yang'],
masks:['Yun-Ling Man'],
costumes:['Thomas Chong','Emi Wada']},
{title:'Dumbo',
titleCZ:'Dumbo',
year:1941,
runtime:64,
countries:['USA'],
genres:['Animation','Musical','Family'],
director:['Ben Sharpsteen'],
actors:['Edward Brophy','Sterling Holloway','Herman Bing','Verna Felton','James MacDonald'],
production:['Walt Disney'],
music:['Oliver Wallace','Frank Churchill']},
{title:'Yogi Bear',
titleCZ:'Méďa Béďa',
year:2010,
runtime:77,
countries:['USA','New Zealand'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Eric Brevig'],
actors:['Dan Aykroyd','Justin Timberlake','Anna Faris','Tom Cavanagh','T.J. Miller','Nate Corddry','Andy Daly','Josh Robert Thompson','Tim McLachlan','Barry Duffield','Isabella Acres','Will Shadley','Raymond Ochoa','Emily Hahn','Seth Morris','Will Wallace','Shane Baumel','Stephen Stanton','Kirk Baily'],
screenplay:['Joshua Sternin','Jennifer Ventimilia','Brad Copeland'],
production:['Donald De Line','Karen Rosenfelt'],
music:['John Debney'],
camera:['Peter James'],
cut:['Kent Beyda'],
sound:['Ron Bartlett','Doug Hemphill'],
scenography:['Jules Cook','David Sandefur','Ben Milsom'],
masks:['Davina Lamont'],
costumes:['Liz McGregor']},
{title:'Balloon',
titleCZ:'Balón',
year:2018,
runtime:125,
countries:['Germany'],
genres:['Drama','Thriller','History'],
director:['Michael Herbig'],
actors:['Friedrich Mücke','Karoline Schuch','David Kross','Alicia von Rittberg','Thomas Kretschmann','Jonas Holdenrieder','Tilman Döbler','Christian Näthe','Till Patz','Ronald Kukulies','Emily Kusche','Sebastian Hülk','Gernot Kunert','Ulrich Brandhoff','Peter Trabner','Bernd Michael Lade','Kai Ivo Baulitz','Bernd Stegemann','Antje Traue','Elisabeth Wasserscheid','Tilo Keiner','Peter Prager','Nadja Engel','Tom Kreß','Thomas Birnstiel','Cornelius Schwalm','Christian Gaul','Beate Kurecki','Sebastian Schwarz','Timur Bartels','Sandra Lava','Stefan Kaminsky','Thomas Chemnitz','Jonas Laux','Jörn Hentschel','Kaspar Eichel','Daniela Elhagh','Angela Jacobi','Wolfgang Haas','Uwe Kosubek','Matthias Ransberger','Jakub Slodowicz','Helmut Schmidt'],
screenplay:['Kit Hopkins','Michael Herbig'],
production:['Michael Herbig'],
music:['Ralf Wengenmayr','Marvin Miller'],
camera:['Torsten Breuer'],
cut:['Alexander Dittner'],
sound:['Roland Winke','Chris Rebay','Mario Hubert','Christian Bischoff'],
scenography:['Bernd Lepel','Ralf Schreck'],
masks:['Tatjana Krauskopf','Lili Zawierucha'],
costumes:['Lisy Christl']},
{title:'Berserk: Golden Age Arc I - The Egg of the King',
titleCZ:'Berserk: Ógon džidai hen I - Haó no tamago',
year:2012,
runtime:77,
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy'],
director:['Tošijuki Kubooka','Kóiči Hacumi'],
actors:['Aki Tojosaki','Nobujuki Kacube','Kazuki Jao','Takahiro Sakurai','Júiči Nakamura','Minako Kotobuki','Kento Fudžinuma','Kenta Mijake','Hiroaki Iwanaga','Hóčú Ócuka','Hiroši Arikawa','Rikija Kojama','Kendó Kobajaši','Eidži Takeuči','Masaši Nogawa','Joširó Macumoto','Toa Jukinari','Takahiro Fudžiwara','Džun Inoue','Rjóta Igaraši','Takumi Watanabe','Jasunobu Iwata','Masajuki Tanaka','Hisanori Jošida','Šingo Egami','Maki Mizuma'],
basedOn:['Kentaró Miura'],
screenplay:['Ičiró Ókóči'],
production:['Eiiči Kamagata','Eiko Tanaka'],
music:['Susumu Hirasawa'],
scenography:['Júsuke Takeda','Hideki Nakamura','Marefumi Niibajaši']},
{title:'The Classic',
titleCZ:'Keulraesik',
year:2003,
runtime:133,
countries:['South Korea'],
genres:['Romance','Drama'],
director:['Jae-yong Kwak'],
actors:['Ye-jin Son','In-seong Jo','Seung-woo Jo','Ki-woo Lee','Yeong-hee Seo','Byeong-ok Kim','Jeong-tae Kim','Seo Lee','Dong-hyeon Geum','Kwang-in Kim','Seung-chul Lee'],
screenplay:['Jae-yong Kwak'],
music:['Yeong-wook Jo','Seung-hyun Choi'],
sound:['Kim Suk-won']},
{title:'White Heat',
titleCZ:'Bílý žár',
year:1949,
runtime:114,
countries:['USA'],
genres:['Action','Drama','Film-Noir','Crime'],
director:['Raoul Walsh'],
actors:['James Cagney','Virginia Mayo',"Edmond O'Brien",'Margaret Wycherly','Steve Cochran','John Archer','Wally Cassell','Fred Clark','Claudia Barrett','Harry Lauter','Jeffrey Sayre','Sid Melton','Colin Kenny','Milton Parsons','Ray Bennett','Chet Brandenburg','Nolan Leary','John Pickard','Sherry Hall','Robert Foulk','Robert Osterloh','Ray Montgomery','Harry Strang','Ford Rainey','Clarence Hennecke','Grandon Rhodes','Jack Perry','Paul Guilfoyle','Mickey Knox','Eddie Foster','Lee Phelps','Herschel Daugherty','G. Pat Collins','Eddie Phillips','Perry Ivins','Ralph Volkie','Larry McGrath','George Spaulding','Joey Ray','Fred Coby','Buddy Gorman','Tom Coleman','Richard LaMarr','John Rice','John Roy','Marshall Bradford','John Butler','Sid Troy','John McGuire','Charles Ferguson','Jack Henderson','Jim Thorpe','Carl Harbaugh','Ian MacDonald'],
basedOn:['Virginia Kellogg'],
screenplay:['Ivan Goff','Ben Roberts'],
production:['Louis F. Edelman'],
music:['Max Steiner'],
camera:['Sidney Hickox'],
cut:['Owen Marks'],
sound:['Leslie G. Hewitt'],
scenography:['Edward Carrere'],
masks:['Perc Westmore','Edwin Allen']},
{title:'Kes',
titleCZ:'Kes',
year:1969,
runtime:110,
countries:['UK'],
genres:['Drama'],
director:['Ken Loach'],
actors:['David Bradley','Laurence Bould','Agnes Drumgoon','Frank Norton','Martin Harley','Leslie Stringer','Brian Glover','Colin Welland','Lynne Perrie','Freddie Fletcher','Bob Bowes','Bill Dean','Ted Carroll'],
basedOn:['Barry Hines'],
screenplay:['Barry Hines','Ken Loach','Tony Garnett'],
production:['Tony Garnett'],
music:['John Cameron'],
camera:['Chris Menges'],
cut:['Roy Watts']},
{title:'District 9',
titleCZ:'District 9',
year:2009,
runtime:112,
countries:['South African republic','USA','New Zealand','Canada'],
genres:['Action','Sci-Fi','Thriller'],
director:['Neill Blomkamp'],
actors:['Sharlto Copley','Jason Cope','David James','Vanessa Haywood','Mandla Gaduka','Kenneth Nkosi','Eugene Khumbanyiwa','Louis Minnaar','William Allen Young','Robert Hobbs','Jed Brophy','Nathalie Boltt','Mike Huff','Nick Boraine','John Sumner','Brandon Auret','Johnny Selema','John Jacob','Anthony Fridjhon','Bongo Mbutuma','Sylvaine Strike','Nick Blake','Craig Jackson','Daniel Hadebe','David Dukas','Peter Muyzers'],
screenplay:['Neill Blomkamp','Terri Tatchell'],
production:['Peter Jackson','Carolynne Cunningham'],
music:['Clinton Shorter'],
camera:['Trent Opaloch'],
cut:['Julian Clarke'],
sound:['Michael Hedges','Dave Whitehead'],
scenography:['Philip Ivey'],
masks:['Joe Dunckley','Sarah Rubano','Frances Richardson'],
costumes:['Diana Cilliers']},
{title:'No Country for Old Men',
titleCZ:'Tahle země není pro starý',
year:2007,
runtime:122,
countries:['USA'],
genres:['Thriller','Crime','Drama'],
director:['Joel Coen','Ethan Coen'],
actors:['Tommy Lee Jones','Javier Bardem','Josh Brolin','Woody Harrelson','Kelly Macdonald','Garret Dillahunt','Tess Harper','Barry Corbin','Stephen Root','Rodger Boyce','Beth Grant','Ana Reeder','Gene Jones','Myk Watford','Boots Southerland','Kathy Lamkin','Margaret Bowman','Thomas Kopache','Jason Douglas','Doris Hargrave','Rutherford Cravens','Matthew Posey','Mathew Greer','Luce Rains','Chris Warner','Brandon Smith','Roland Uribe','Richard Jackson','Caleb Landry Jones','Angelo Martinez'],
basedOn:['Cormac McCarthy'],
screenplay:['Joel Coen','Ethan Coen'],
production:['Scott Rudin','Ethan Coen','Joel Coen'],
music:['Carter Burwell'],
camera:['Roger Deakins'],
cut:['Ethan Coen','Joel Coen'],
sound:['Skip Lievsay','Greg Orloff','Craig Berkey'],
scenography:['Jess Gonchor','Nancy Haigh'],
masks:['Jean Ann Black','Jason Hamer'],
costumes:['Mary Zophres']},
{title:'The Conjuring',
titleCZ:'V zajetí démonů',
year:2013,
runtime:112,
countries:['USA'],
genres:['Horror','Thriller','Mystery'],
director:['James Wan'],
actors:['Vera Farmiga','Patrick Wilson','Ron Livingston','Lili Taylor','Shanley Caswell','Joey King','Hayley McFarland','Christy Johnson','Mackenzie Foy','John Brotherton','Steve Coulter','Morganna May','Ashley White','Sterling Jerins','Brannigan Carter','Arnell Powell','Shannon Kook','Joe Montanti','Lorraine Warren','Joseph Bishara','Courtney Lakin','Darrell Rackley','Kyla Deaver','Christof Veillon'],
screenplay:['Chad Hayes','Carey W. Hayes'],
production:['Peter Safran','Rob Cowan'],
music:['Joseph Bishara','Mark Isham'],
camera:['John R. Leonetti'],
cut:['Kirk M. Morri'],
sound:['Steve Maslow','Gregg Landaker','Carl Rudisill'],
scenography:['Julie Berghoff','Sophie Neudorfer'],
masks:['Erin Keith','Cecilia Verardi','Justin Raleigh'],
costumes:['Kristin M. Burke']},
{title:'Dallas Buyers Club',
titleCZ:'Klub poslední naděje',
year:2013,
runtime:117,
countries:['USA'],
genres:['Drama','Biographic'],
director:['Jean-Marc Vallée'],
actors:['Matthew McConaughey','Jared Leto','Jennifer Garner','Steve Zahn',"Denis O'Hare",'Griffin Dunne','Kevin Rankin','James DuMont','Philippe Radelet','Juliet Reeves','Dallas Roberts',"Michael O'Neill",'Craig Borten','Deneen Tyler','Robert Segari','Kenneth Kynt Bryan','J.D. Evermore','Bob Walker','Heather Ashley Boyd','Jacquelyn Twodat Jackson','Douglas M. Griffin','Tre Tureaud','Jane McNeill','Ian Casselberry','Sean Boyd','Chris Angerdina','Elton LeBlanc','Scott Takeda','Lawrence Turner','Donna Duplantier'],
screenplay:['Craig Borten','Melisa Wallack'],
production:['Robbie Brenner','Rachel Winter'],
camera:['Yves Bélanger'],
cut:['Martin Pensa','Jean-Marc Vallée'],
scenography:['John Paino'],
masks:['Courtney Lether'],
costumes:['Bart Mueller','Kurt Swanson']},
{title:"My Sister's Keeper",
titleCZ:'Je to i můj život',
year:2009,
runtime:105,
countries:['USA'],
genres:['Drama','Psychology'],
director:['Nick Cassavetes'],
actors:['Abigail Breslin','Sofia Vassilieva','Cameron Diaz','Jason Patric','Evan Ellingson','Alec Baldwin','Heather Wahlquist','Joan Cusack','David Thornton','Thomas Dekker','Elizabeth Daily','Emily Deschanel','Nicole Marie Lenz','Lin Shaye','Mary Jo Deschanel','Matthew Barry','Chris Kinkade','Rico Simonini','Brennan Bailey','Mark Johnson','Paul Butler','Jonah Johnson','Lynn Clayton','Marcos A. Ferraez','Michael Chow','Rob Giles','Roy Allen III','Retson Ross','Frank Peluso','Ellia English','Mimi Fletcher'],
basedOn:['Jodi Picoult'],
screenplay:['Jeremy Leven','Nick Cassavetes'],
production:['Mark Johnson','Chuck Pacheco','Griff Furst'],
music:['Aaron Zigman'],
camera:['Caleb Deschanel'],
cut:['Alan Heim','Jim Flynn'],
sound:['Ron Bartlett','Doug Hemphill','Kelly Cabral'],
scenography:['Jon Hutman','Maggie Martin'],
masks:['Eryn Krueger Mekash','Alicia M. Tripi','Susan Zietlow-Maust'],
costumes:['Shay Cunliffe']},
{title:'Before Sunrise',
titleCZ:'Před úsvitem',
year:1995,
runtime:97,
countries:['USA','Austria','Switzerland'],
genres:['Romance','Drama'],
director:['Richard Linklater'],
actors:['Ethan Hawke','Julie Delpy','Andrea Eckert','Erni Mangold','Hans Weingartner','Peter Ily Huemer','Adam Goldberg','Richard Linklater','Paul Poet','John Sloss','Haymon Maria Buttinger','Hanno Pöschl','Tex Rubinowitz','Christian Ankowitsch','Wolfgang Staribacher','Branko Andric','Otto Reiter','Liese Lyon','Dominik Castell','Karl Bruckschwaiger'],
screenplay:['Richard Linklater','Kim Krizan'],
production:['Anne Walker-McBay'],
music:['Fred Frith'],
camera:['Lee Daniel'],
cut:['Sandra Adair'],
scenography:['Florian Reichmann']},
{title:'My Name is Khan',
titleCZ:'Jmenuji se Khan',
year:2010,
runtime:165,
countries:['India'],
genres:['Drama','Romance','Thriller'],
director:['Karan Johar'],
actors:['Shahrukh Khan','Kajol','Katie A. Keane','Kenton Duty','Jimmy Sheirgill','Tanay Chheda','Parvin Dabas','Beth Bemis','Kathleen M. Darcy','Harmony Blossom','Douglas Tait','Zarina Wahab','Tonya Lee Williams','Mike Howard','Jim Gaines','Anne Marie Scottlin','Vinay Pathak','Navneet Nishan','Arjun Mathur','Pallavi Sharda','Sugandha Garg','Shane Harper','Christopher Damm','Kari Wishingrad','Aubrey K. Miller','Benny Nieves','Jacqueline Buda','Jesse Muick',"A'Ali de Sousa",'Mackenzie Firgens','Arif Zakaria','Greg Collins','Sumeet Raghvan','Mike Stahl','Michele Marsh','Adarsh Gourav','Julie McKinnon','Kavin Dave','Faisal Simon','Mel Fair','Mary Gregory','Peggy Sandow','Retson Ross','Carl Marino','Kerry Leigh Michaels','Will James Johnson','Natasha Marc','Christopher B. Duncan','Jenne Kang','Rod Britt','Adrian Kali Turner','Larry Brown','Kevin Oestenstad','Joseph Zinsman','Mark S. Porro'],
screenplay:['Karan Johar','Shibani Bathija'],
production:['Gauri Khan','Hiroo Johar'],
music:['Shankar Mahadevan','Loy Mendonsa','Ehsaan Noorani'],
camera:['Ravi K. Chandran'],
cut:['Deepa Bhatia'],
sound:['Dileep Subramanian','Anuj Mathur'],
scenography:['Sharmishta Roy','Mansi Dhruv Mehta'],
masks:['Robin Slater'],
costumes:['Shiraz Siddique','Manish Malhotra']},
{title:'The Killer',
titleCZ:'Killer',
year:1989,
runtime:111,
countries:['Hong Kong'],
genres:['Action','Crime','Drama','Thriller'],
director:['John Woo'],
actors:['Yun-fat Chow','Danny Lee','Sally Yeh','Paul Chu','Kenneth Tsang','Fui-on Shing','Tommy Wong','Teddy Yip','Chi-wai Wong','Barry Wong','Parkman Wong','Chung Lam','James Ha','Seung-lam Wan','Candy Hau','Kwok-keung Choi','Wai-cheung Mak','Wai-fai Wong','Paul Lo','Ankle Leung','Bruce Law','Shung-fung Lau','John Chan-sang Cheung','Dion Lam','Marco Lee','Jackson Ng','Derek Kwok','Ricky Wong','Ng Leung','Seng-Kwong Chang','Foo-Wai Lam','Chin-Hung Fan','Danny Ng','Ka-Sang Cheng','Kwok-Kin Ng','Moon-Wa Lam','Chi-Mun Ho','Chi-Hok Wong','Chi-Keung Wong','Sing Yeung','Wing-Cheung Ho','Kim-Man Yeung','Shu-San Mak','Chi-Ming Wong','Paul Wong','Fat Wan'],
screenplay:['John Woo'],
production:['Hark Tsui'],
music:['David Wu','Lowell Lo Koon-Ting'],
camera:['Peter Pau','Horace Wong'],
cut:['Kung-Wing Fan'],
scenography:['Ben Luk'],
masks:['Yu-Lai Cheng','Yun-Ling Man'],
costumes:['Shirley Koo-Fong Chan']},
{title:'The Land Before Time',
titleCZ:'Země dinosaurů',
year:1988,
runtime:70,
countries:['USA','Ireland'],
genres:['Animation','Adventure','Family','Fantasy'],
director:['Don Bluth'],
actors:['Helen Shaver','Pat Hingle','Burke Byrnes','Judith Barsi','Gabriel Damon','Bill Erwin','Candace Hutson','Sven Erik Vikström','Will Ryan'],
screenplay:['Stu Krieger'],
production:['Steven Spielberg'],
music:['James Horner'],
cut:['John K. Carr','Dan Molina'],
sound:['Dan Molina','Michael C. Casper','Bill Rowe']},
{title:'Rosencrantz & Guildenstern Are Dead',
titleCZ:'Rosencrantz a Guildenstern jsou mrtvi',
year:1990,
runtime:117,
countries:['UK','USA'],
genres:['Comedy','Drama'],
director:['Tom Stoppard'],
actors:['Gary Oldman','Tim Roth','Richard Dreyfuss','Joanna Miles','Iain Glen','Donald Sumpter','Ian Richardson','Ljubo Zecevic','Joanna Roth'],
screenplay:['Tom Stoppard','Tom Stoppard','William Shakespeare'],
production:['Michael Brandman'],
music:['Stanley Myers'],
camera:['Peter Biziou'],
cut:['Nicolas Gaster'],
sound:['Otto Snel'],
scenography:['Vaughan Edwards'],
masks:['Ivana Primorac']},
{title:'Miracle on 34th Street',
titleCZ:'Zázrak v New Yorku',
year:1947,
runtime:96,
countries:['USA'],
genres:['Comedy','Drama','Family','Fantasy'],
director:['George Seaton'],
actors:["Maureen O'Hara",'John Payne','Edmund Gwenn','Gene Lockhart','Natalie Wood','Porter Hall','William Frawley','Jerome Cowan','Jack Albertson','Richard Irving','Thelma Ritter','Jeff Corey','Mae Marsh','Robert Gist','Percy Helton','Robert Karnes','Jeffrey Sayre','Dorothy Christy',"Harry 'Snub' Pollard",'Stephen Roberts','Brick Sullivan','Mary Field','William Forrest','Bob Reeves','Ray Spiker','Theresa Harris','Lela Bliss','Harry Antrim','Clark Howat','Herbert Heyes','Jack Gargan','Philip Tonge',"Anne O'Neal",'Alvin Hammer','Dick Cogan','Robert Hyatt','Alvin Greenman'],
screenplay:['George Seaton'],
production:['William Perlberg'],
music:['Cyril J. Mockridge'],
camera:['Charles G. Clarke','Lloyd Ahern Sr.'],
cut:['Robert L. Simpson'],
sound:['Roger Heman Sr.'],
scenography:['Richard Day'],
masks:['Ben Nye'],
costumes:['Kay Nelson']},
{title:'It Happened in Broad Daylight',
titleCZ:'Stalo se za bílého dne',
year:1958,
runtime:100,
countries:['Germany','Switzerland','Spain'],
genres:['Crime','Thriller'],
director:['Ladislao Vajda'],
actors:['Heinz Rühmann','Siegfried Lowitz','Michel Simon','Gert Fröbe','Ewald Balser','Emil Hegetschweiler','Margrit Winter','Max Haufler','Heinrich Gretler','Traute Carlsen','Berta Drews','Holger Schwiers','Sigfrit Steiner','María Rosa Salgado','René Magron'],
basedOn:['Friedrich Dürrenmatt'],
screenplay:['Friedrich Dürrenmatt','Hans Jacoby'],
production:['Artur Brauner'],
music:['Bruno Canfora'],
camera:['Heinrich Gärtner'],
cut:['Hermann Haller','Julio Peña'],
scenography:['Max Röthlisberger']},
{title:"Daffy Duck's Movie: Fantastic Island",
titleCZ:'Kačer Daffy: Fantastický ostrov',
year:1983,
runtime:78,
countries:['USA'],
genres:['Animation','Family','Comedy'],
director:['Friz Freleng','Chuck Jones','Robert McKimson'],
actors:['Mel Blanc','Les Tremayne','June Foray'],
music:['Carl W. Stalling','William Lava','Eugene Poddany','Robert J. Walsh'],
sound:['Franklin Jones Jr.']},
{title:'Our Hospitality',
titleCZ:'Frigo, oběť krevní msty',
year:1923,
runtime:74,
countries:['USA'],
genres:['Comedy','Family'],
director:['Buster Keaton','John G. Blystone'],
actors:['Buster Keaton','Tom London','Joe Keaton','Joe Roberts','Kitty Bradbury','Francis X. Bushman Jr.','Monte Collins','Craig Ward','Natalie Talmadge'],
camera:['Elgin Lessley','Gordon Jennings']},
{title:'Iron Man',
titleCZ:'Iron Man',
year:2008,
runtime:126,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Jon Favreau'],
actors:['Robert Downey Jr.','Terrence Howard','Jeff Bridges','Gwyneth Paltrow','Leslie Bibb','Shaun Toub','Faran Tahir','Clark Gregg','Bill Smitrovich','Paul Bettany','Jon Favreau','Peter Billingsley','Tim Guinee','Will Lyman','Tom Morello','Ahmed Ahmed','Fahim Fazli','Nazanin Boniadi','Stacy Stas Hurst','Sahar Bibiyan','Stan Lee','Tim Griffin','Micah Hauptman','Samuel L. Jackson','America Olivo','Ricki Noel Lander','Halla','Jeannine Kaspar','Kevin Foster','Lana Kinnear','Laura Liguori','Mike Cochrane','Jeffrey Ashkin','Crystal Marie Denha','Garret Noël','Marco Khan','Joshua Harto','Anthony Martins','Russell Richardson','Gerard Sanders','Ido Mor','Jim Cramer','Mark W. Berry',"Patrick O'Connell",'Mellany Gandara'],
basedOn:['Stan Lee','Larry Lieber','Jack Kirby','Don Heck'],
screenplay:['Mark Fergus','Hawk Ostby','Art Marcum','Matt Holloway'],
production:['Kevin Feige','Avi Arad'],
music:['Ramin Djawadi'],
camera:['Matthew Libatique'],
cut:['Dan Lebental'],
sound:['Frank Eulner','Lora Hirschberg','Shannon Mills','Christopher Boyes','Mark Ulano'],
scenography:['J. Michael Riva','Suzan Wexler'],
masks:['Jamie Kelman','Allan A. Apone','Ruth Haney','Kate Biscoe','Ketty Gonzalez','Jennifer Turchi Nigh'],
costumes:['Laura Jean Shannon','Rebecca Gregg']},
{title:'Valkyrie',
titleCZ:'Valkýra',
year:2008,
runtime:121,
countries:['USA','Germany','Italy','Spain','France','Japan','UK'],
genres:['War','History','Thriller','Drama'],
director:['Bryan Singer'],
actors:['Tom Cruise','Kenneth Branagh','Bill Nighy','Tom Wilkinson','Carice van Houten','Thomas Kretschmann','Terence Stamp','Eddie Izzard','Kevin McNally','Christian Berkel','Jamie Parker','David Bamber','Tom Hollander','David Schofield','Kenneth Cranham','Halina Reijn','Werner Daehn','Harvey Friedman','Matthias Schweighöfer','Waldemar Kobus','Florian Panzner','Ian McNeice','Danny Webb','Chris Larkin','Matthew Burton','Philipp von Schulthess','Wotan Wilke Möhring','Christian Oliver','Bernard Hill','Julian Morris','Helmut Stauss','Karl Alexander Seidel','Justus Kammerer','Annika Becker','Marie Becker','Katharine Mehrling','Andy Gätjen','Achim Buch','Anton Algrang','Matthias Freihof','Gerhard Haase-Hindenberg','Matthias Ziesing','Tom Wlaschiha','Carsten Voigt','Anna Holmes','Michael Fritz Schumacher','Niklas Bardeli','Christoph Förster','Max Urlacher','Karsten Antonio Mielke','Wolfram Gumz','Kai Holzapfel','Vincent Kastner','Frank Christian Marx','Travis Andrade','Jason Barry','Joel Bryant','Mike Dunn','Wolfgang Grossmann','Michael Ihnow','Dieter Rupp','Tyrell van Boog','Nicolas Walier'],
screenplay:['Christopher McQuarrie','Nathan Alexander'],
production:['Bryan Singer','Christopher McQuarrie','Gilbert Adler'],
music:['John Ottman'],
camera:['Newton Thomas Sigel'],
cut:['John Ottman'],
sound:['Erik Aadahl','Craig Henighan','Skip Lievsay'],
scenography:['Patrick Lumb','Lilly Kilvert','Ralf Schreck'],
masks:['Ailbhe Lemass','Sarah Monzani','Carmen Botermann','Zoe Clare Brown'],
costumes:['Joanna Johnston']},
{title:'Grease',
titleCZ:'Pomáda',
year:1978,
runtime:106,
countries:['USA'],
genres:['Musical','Romance','Comedy'],
director:['Randal Kleiser'],
actors:['John Travolta','Olivia Newton-John','Stockard Channing','Jeff Conaway','Barry Pearl','Michael Tucci','Kelly Ward','Didi Conn','Jamie Donnelly','Dinah Manoff','Eve Arden','Frankie Avalon','Joan Blondell','Edd Byrnes','Sid Caesar','Alice Ghostley','Dody Goodman','Susan Buckner','Lorenzo Lamas','Fannie Flagg','Eddie Deezen','Darrell Zwerling','Ellen Travolta','Annette Charles','Dennis Stewart','Carol Culver','Antonia Franceschi','Mimi Lieber','Sean Moran','Andy Tennant','Michael Biehn','Greg Bradford','John Michael Graham','Wendie Jo Sperber','Johnny Contardo'],
screenplay:['Bronte Woodard','Jim Jacobs','Warren Casey'],
production:['Robert Stigwood','Allan Carr'],
camera:['Bill Butler'],
cut:['John F. Burnett'],
sound:['Bill Varney'],
scenography:['Philip M. Jefferies'],
masks:['Edwin Allen','Daniel C. Striepeke','Christine George'],
costumes:['Albert Wolsky']},
{title:'Pride & Prejudice',
titleCZ:'Pýcha a předsudek',
year:2005,
runtime:127,
countries:['UK','France'],
genres:['Romance','Drama'],
director:['Joe Wright'],
actors:['Keira Knightley','Rosamund Pike','Matthew Macfadyen','Donald Sutherland','Jena Malone','Brenda Blethyn','Talulah Riley','Judi Dench','Carey Mulligan','Simon Woods','Rupert Friend','Tom Hollander','Kelly Reilly','Sinead Matthews','Penelope Wilton','Peter Wight','Claudie Blakley','Tamzin Merchant','Sylvester Morand','Meg Wynn Owen','Janet Whiteside','Roy Holder'],
basedOn:['Jane Austen'],
screenplay:['Deborah Moggach'],
production:['Tim Bevan','Paul Webster','Eric Fellner'],
music:['Dario Marianelli'],
camera:['Roman Osin','Veli Kuzlu'],
cut:['Paul Tothill'],
scenography:['Sarah Greenwood','Katie Spencer'],
masks:['Fae Hammond','Sharon Martin'],
costumes:['Jacqueline Durran']},
{title:'The Pursuit of Happyness',
titleCZ:'Štěstí na dosah',
year:2006,
runtime:117,
countries:['USA'],
genres:['Drama','Biographic'],
director:['Gabriele Muccino'],
actors:['Will Smith','Jaden Smith','Thandiwe Newton','Kurt Fuller','James Karen','Brian Howe','Dan Castellaneta','David Fine','Mark Christopher Lawrence','Victor Raider-Wexler','George Cheung','Amir Talai','Phil Austin','Molly Celaschi','Phil Talsky','Peaches Hutchinson','Yeena Fisher','Ming Lo','Scott Klace','Esther Scott','Joe Nunez','Darryl Fong','Geoff Callan','Karen Kahn','Peter Fitzsimmons','Kevin West','Maurice Sherbanee','Austin Scott','George Maguire','Stu Klitsner','Ben Fritz'],
screenplay:['Steve Conrad'],
production:['Todd Black','Jason Blumenthal','Steve Tisch','James Lassiter','Will Smith'],
music:['Andrea Guerra'],
camera:['Phedon Papamichael'],
cut:['Hughes Winborne'],
sound:["Kevin O'Connell",'Greg P. Russell'],
scenography:['J. Michael Riva','James Ira Colburn'],
masks:['Camille Friend','JoAnn Stafford-Chaney'],
costumes:['Sharen Davis']},
{title:'Tootsie',
titleCZ:'Tootsie',
year:1982,
runtime:113,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Sydney Pollack'],
actors:['Dustin Hoffman','Jessica Lange','Teri Garr','Dabney Coleman','Charles Durning','Bill Murray','Sydney Pollack','George Gaynes','Geena Davis','Lynne Thigpen','Pamela Lincoln','Estelle Getty','Christine Ebersole','Phillip Borsos','Andy Warhol','Tom Mardirosian','John Kapelos','Debra Mooney','Marjorie Lovett','Ronald L. Schwary','Bernie Pollack','Murray Schisgal','Doris Belack','Ellen Foley','Jim Jansen','Lois De Banzie','Susan Merson','Annie Korzen'],
screenplay:['Larry Gelbart','Murray Schisgal','Robert Garland','Elaine May'],
production:['Sydney Pollack','Ronald L. Schwary','Dick Richards'],
music:['Dave Grusin'],
camera:['Owen Roizman'],
cut:['William Steinkamp','Fredric Steinkamp'],
sound:['Rick Alexander'],
scenography:['Peter S. Larkin'],
masks:['Dorothy J. Pearl'],
costumes:['Ruth Morley']},
{title:'Oldboy',
titleCZ:'Old Boy',
year:2003,
runtime:120,
countries:['South Korea'],
genres:['Drama','Mystery','Thriller'],
director:['Čchan-uk Pak'],
actors:['Min-sik Choi','Ji-tae Yoo','Hye-jeong Kang','Dal-soo Oh','Byeong-ok Kim','Seung-shin Lee','Yeon-seok Yoo','Jin-seo Yoon','Kwang-rok Oh','Su-hyeon Kim','Myeong-shin Park','Dae-yeon Lee','Dae-han Ji','Tae-kyeong Oh','Mi-mi Lee','Lee Seung-jin','Sang-gyeong Jo'],
basedOn:['Nobuaki Minegishi'],
screenplay:['Čchan-uk Pak','Jo-yoon Hwang','Lim Joon-hyung'],
music:['Yeong-wook Jo'],
camera:['Jung-hoon Jung'],
scenography:['Seong-hee Ryoo'],
costumes:['Sang-gyeong Jo']},
{title:'The Life of David Gale',
titleCZ:'Život Davida Galea',
year:2003,
runtime:130,
countries:['USA','Germany','UK'],
genres:['Drama','Crime','Thriller'],
director:['Alan Parker'],
actors:['Kevin Spacey','Kate Winslet','Laura Linney','Gabriel Mann','Rhona Mitra','Leon Rippy','Matt Craven','Jim Beaver','Melissa McCarthy','Julio Cedillo','Alan Parker','Kathy Lamkin','Cleo King','Ken Edwards','Katherine Willis','Keith Poulson','Michael Crabtree','Starla Christian','Matthew Posey','Marco Perella','Kirk Sisco','Robin Simmons','Pilar Ferreiro','Sean Hennigan'],
screenplay:['Charles Randolph'],
production:['Nicolas Cage'],
music:['Alex Parker'],
camera:['Michael Seresin'],
cut:['Gerry Hambling'],
sound:['Eddy Joseph','Andy Nelson','Anna Behlmer'],
scenography:['Geoffrey Kirkland'],
masks:['Martin Samuel','Sarah Monzani','Chelsey Fiske'],
costumes:['Renée Ehrlich Kalfus']},
{title:'An American Crime',
titleCZ:'Americký zločin',
year:2007,
runtime:92,
countries:['USA'],
genres:['Drama','Crime','Biographic'],
director:["Tommy O'Haver"],
actors:['Elliot Page','Catherine Keener','Ari Graynor','Bradley Whitford','Scout Taylor-Compton','Carlie Westerman','Nick Searcy','James Franco','Michael Welch','Brian Geraghty','Jeremy Sumpter','Scott Eastwood','Hayley McFarland','Romy Rosemont','Evan Peters','Hannah Leigh','Kuma','Amy Ferguson','Patricia Place','Michelle Benes','Edward James Gage'],
screenplay:["Tommy O'Haver",'Irene Turner'],
production:['Kevin Turen','Christine Vachon','Katie Roumel','Henry Winterstern'],
music:['Alan Ari Lazar'],
camera:['Byron Shah'],
cut:['Melissa Kent'],
sound:['Marti D. Humphrey'],
scenography:['Nathan Amondson','Lisa Alkofer'],
masks:['Jorjee Douglass'],
costumes:['Alix Hester']},
{title:'Soul',
titleCZ:'Duše',
year:2020,
runtime:107,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family','Fantasy','Music'],
director:['Pete Docter','Kemp Powers'],
actors:['Jamie Foxx','Tina Fey','Graham Norton','Rachel House','Alice Braga','Richard Ayoade','Ahmir-Khalib Thompson','Daveed Diggs','Phylicia Rashad','Angela Bassett','John Ratzenberger','Sam Lavagnino','Aiyanna Miorin','Azriel Dalman','Wes Studi','June Squibb','Sakina Jaffrey','Avery Kidd Waddell','Ronnie Del Carmen'],
screenplay:['Pete Docter','Mike Jones','Kemp Powers'],
production:['Dana Murray'],
music:['Trent Reznor','Atticus Ross','Jonathan Batiste'],
camera:['Matt Aspbury','Ian Megibben'],
cut:['Kevin Nolting'],
sound:['Coya Elliott','David Parker','Ren Klyce'],
scenography:['Paul Abadilla']},
{title:'Spartacus: Behind the Myth',
titleCZ:'Spartakus',
year:2007,
runtime:51,
countries:['UK'],
genres:['Document']},
{title:'The 36th Chamber of Shaolin',
titleCZ:'36 komnat Šaolinu',
year:1978,
runtime:115,
countries:['Hong Kong'],
genres:['Action','History','Adventure','Drama'],
director:['Chia-Liang Liu'],
actors:['Gordon Liu','Norman Chu','John Cheung','Billy Chan','Peter Lung Chan','Ho Hsiao','Yu Wong','Simon Siu-Tin Yuen','Lo Lieh','Sin San','Keung Law','Alan Chui','Austin Wai','Nan Chiang','Kwok-choi Hon','Hoi-sang Lee','Kar-wing Lau','Johnny Wa Cheung','San Tai','Yuet-Sang Chin','Wilson Tong','Li-Jen Hao','Chun Lau','Ming-Wai Chan','Chi-Keung Wong','Ha Huang','Ging-Man Fung','Gwa-Pau Sai','Tung Ting','Fat Wan','Kim-Hung Lai','Siu-Loi Chow','Sek-Aau Cheung'],
camera:['Arthur Wong']},
{title:'DuckTales The Movie - Treasure of the Lost Lamp',
titleCZ:'Kačeří příběhy: Poklad ze ztracené lampy',
year:1990,
runtime:74,
countries:['USA','France'],
genres:['Family','Animation','Adventure','Comedy'],
director:['Paul Brizzi','Gaëtan Brizzi'],
actors:['Alan Young','Russi Taylor','Christopher Lloyd','Rip Taylor','Richard Libertini','June Foray','Terence McGovern','Chuck McCann','Charlie Adler','Frank Welker','Patrick Pinney','Jack Angel'],
screenplay:['Alan Burnett'],
music:['David Newman'],
sound:['Dean A. Zupancic','Nick Alphin']},
{title:'The 3rd Man',
titleCZ:'Třetí muž',
year:1949,
runtime:104,
countries:['UK'],
genres:['Film-Noir','Mystery','Thriller'],
director:['Carol Reed'],
actors:['Joseph Cotten','Alida Valli','Orson Welles','Trevor Howard','Siegfried Breuer','Bernard Lee','Carol Reed','Geoffrey Keen','Karel Štěpánek','Ernst Deutsch','Wilfrid Hyde-White','Annie Rosar','Paul Hörbiger','Paul Birch','Erich Ponto','Robert Brown','Martin Boddey','Eric Pohlmann','Peter Fontaine','Vernon Greeves','Paul Carpenter','Lily Kann','Martin Miller','Moira Redmond','Thomas Gallagher','Alexis Chesnakov','Ernest Sarracino','Michael Godfrey','Harold Ayer','Reed De Rouen','Frederick Schrecker','Ray Browne','Hedwig Bleibtreu','Jack Arrow'],
screenplay:['Graham Greene'],
production:['David O. Selznick'],
music:['Anton Karas'],
camera:['Robert Krasker'],
cut:['Oswald Hafenrichter'],
masks:['George Frost']},
{title:'Fantastic Planet',
titleCZ:'Divoká planeta',
year:1973,
runtime:72,
countries:['France','Czechoslovakia'],
genres:['Animation','Sci-Fi'],
director:['René Laloux'],
actors:['Jean Topart','Hubert de Lapparent','Gérard Hernandez','Miroslav Masopust','Hana Maciuchová','Jorga Kotrbová','Marie Vášová','Věra Kubánková','Václav Voska','Josef Větrovec','Jiří Holý','Bohumil Bezouška','Václav Kaňkovský','Alfred Strejček','Jean Valmont','Eric Baugin','Claude Joseph','William Coryn','Jeanine Forney'],
basedOn:['Stefan Wul'],
screenplay:['Roland Topor'],
production:['Anatole Dauman'],
music:['Alain Goraguer'],
camera:['Lubomír Rejthar','Boris Baromykin'],
cut:['Marta Látalová']},
{title:'Onibaba',
titleCZ:'Onibaba',
year:1964,
runtime:103,
countries:['Japan'],
genres:['Drama','Horror','Psychology'],
director:['Kaneto Šindó'],
actors:['Nobuko Otowa','Džicuko Jošimura','Kei Sató','Taidži Tonojama'],
screenplay:['Kaneto Šindó'],
production:['Hisao Itoya'],
music:['Hikaru Hajaši'],
camera:['Kijomi Kuroda'],
cut:['Toshio Enoki']},
{title:'Days of Wine and Roses',
titleCZ:'Dny vína a růží',
year:1962,
runtime:117,
countries:['USA'],
genres:['Romance','Drama'],
director:['Blake Edwards'],
actors:['Jack Lemmon','Lee Remick','Charles Bickford','Jack Klugman','Alan Hewitt','Jack Albertson','Mel Blanc','Lynn Borden','Charlene Holt','Jack Riley','Ken Lynch','Bert Stevens','Kenner G. Kemp','Harold Miller','Arthur Tovey','Gail Bonney','George DeNormand','Leon Alton','Charles Watts','Russ Bender','Olan Soule','Maxine Stuart','Dick Crockett',"Pat O'Malley",'Tom Rosqui','James Gonzalez','Russell Custer','Mathew McCue','Katherine Squire','Myrna Ross','Tom Palmer','James Lanphier','Don Anderson','John Truax','Ella Ethridge','Chuck Hicks'],
screenplay:['JP Miller'],
production:['Martin Manulis'],
music:['Henry Mancini'],
camera:['Philip H. Lathrop'],
cut:['Patrick McCormack'],
sound:['Jack Solomon'],
masks:['Gordon Bau'],
costumes:['Donfeld']},
{title:'X-Men',
titleCZ:'X-Men',
year:2000,
runtime:104,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Thriller'],
director:['Bryan Singer'],
actors:['Hugh Jackman','Patrick Stewart','Ian McKellen','Famke Janssen','James Marsden','Halle Berry','Anna Paquin','Ray Park','Rebecca Romijn','Bruce Davison','Shawn Roberts','Matt Weinberg','Stan Lee','Gary Goddard','Shawn Ashmore','Tyler Mane','Danny Mags','Jay Yoo','David Hayter','Ryan Fleming','Adam Robitel','Brian Peck','George Buza','Wolfgang Müller','Sumela Kay','Aron Tager','Tom DeSanto','David Lawrence Brown','Kenneth McGregor','Kevin Rushton','Jimmy Star','Donald MacKinnon','Dave Allen Clark','Elias Zarou'],
screenplay:['David Hayter'],
production:['Lauren Shuler Donner','Ralph Winter'],
music:['Michael Kamen'],
camera:['Newton Thomas Sigel'],
cut:['Steven Rosenblum','Kevin Stitt','John Wright'],
sound:['Steve Boeddeker','Andy Nelson','Anna Behlmer','John A. Larsen','Craig Berkey'],
scenography:['John Myhre'],
masks:['Gordon J. Smith','Ann Brodie','Christopher Allen Nelson'],
costumes:['Louise Mingenbach']},
{title:'The Hateful Eight',
titleCZ:'Osm hrozných',
year:2015,
runtime:168,
countries:['USA'],
genres:['Western','Drama','Thriller','Mystery'],
director:['Quentin Tarantino'],
actors:['Samuel L. Jackson','Kurt Russell','Jennifer Jason Leigh','Walton Goggins','Demián Bichir','Tim Roth','Michael Madsen','Bruce Dern','James Parks','Dana Gourrier','Zoë Bell','Lee Horsley','Gene Jones','Channing Tatum','Keith Jefferson','Craig Stark','Belinda Owino','Arnar Valur Halldórsson','Quentin Tarantino'],
screenplay:['Quentin Tarantino'],
production:['Richard N. Gladstein','Shannon McIntosh','Stacey Sher'],
music:['Ennio Morricone'],
camera:['Robert Richardson'],
cut:['Fred Raskin'],
sound:['Christian P. Minkler','Michael Minkler','Wylie Stateman','Mark Ulano'],
scenography:['Jóhei Taneda','Rosemary Brandenburg'],
masks:['Valerie Jackson','Heba Thorisdottir','Howard Berger','Greg Nicotero','Greg Funk','Camille Friend'],
costumes:['Courtney Hoffman']},
{title:'Dune',
titleCZ:'Duna',
year:1984,
runtime:137,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Fantasy'],
director:['David Lynch'],
actors:['Kyle MacLachlan','Francesca Annis','Jürgen Prochnow','Brad Dourif','Sting','José Ferrer','Linda Hunt','Freddie Jones','Richard Jordan','Virginia Madsen','Silvana Mangano','Everett McGill','Kenneth McMillan','Jack Nance','Siân Phillips','Paul L. Smith','Patrick Stewart','Dean Stockwell','Max von Sydow','Alicia Witt','Sean Young','David Lynch','Ernesto Laguardia','Angélica Aragón','Danny Corkill','Ana Ofelia Murguía','Margarita Sanz','Leonardo Cimino','Judd Omen','Julieta Rosen','Jacqueline Voltaire','Humberto Elizondo','Claudia Ramírez','Honorato Magaloni'],
basedOn:['Frank Herbert'],
screenplay:['David Lynch'],
production:['Dino De Laurentiis','Raffaella De Laurentiis'],
music:['TOTO'],
camera:['Freddie Francis'],
cut:['Antony Gibbs'],
sound:['Steve Maslow','Bill Varney',"Kevin O'Connell"],
scenography:['Anthony Masters'],
masks:['Jean Ann Black','Luigi Rocchetti','Giannetto De Rossi','Christopher Tucker','Mario Scutti'],
costumes:['Bob Ringwood']},
{title:'Beverly Hills Cop',
titleCZ:'Policajt v Beverly Hills',
year:1984,
runtime:105,
countries:['USA'],
genres:['Action','Comedy','Crime'],
director:['Martin Brest'],
actors:['Eddie Murphy','Judge Reinhold','John Ashton','Lisa Eilbacher','Ronny Cox','Steven Berkoff','James Russo','Jonathan Banks','Stephen Elliott','Gilbert R. Hill','Art Kimbro','Bronson Pinchot','Paul Reiser','Damon Wayans','Michael Champion','Rick Overton','Martin Brest','William Wallace','Tom Everett','Karen Mayo-Chandler','David Wells','Gene Borkan','Chip Heller','Frank Pesce','Randy Vasquez','Darwyn Carson','Carl Weintraub','Mike Pniewski','Michael Gregory','Jack Heller','Rex Ryon','Gerald Berns','Paul Drake','Nicholas Shields','Israel Juarbe','Chuck Adamson','Douglas Warhit','Donald Chaffin','Farrell Mayer','Robert Hitchcock'],
screenplay:['Daniel Petrie Jr.'],
production:['Jerry Bruckheimer','Don Simpson'],
music:['Harold Faltermeyer'],
camera:['Bruce Surtees'],
cut:['Billy Weber','Arthur Coburn'],
sound:['Gregg Landaker'],
scenography:['Angelo P. Graham','John M. Dwyer'],
masks:['Barbara Lorenz'],
costumes:['Tom Bronson']},
{title:'Mulholland Drive',
titleCZ:'Mulholland Drive',
year:2001,
runtime:147,
countries:['USA','France'],
genres:['Mystery','Thriller','Drama','Romance'],
director:['David Lynch'],
actors:['Naomi Watts','Laura Harring','Ann Miller','Dan Hedaya','Justin Theroux','Brent Briscoe','Robert Forster','Katharine Towne','Lee Grant','Scott Coffey','Billy Ray Cyrus','Chad Everett','James Karen','Lori Heuring','Angelo Badalamenti','Michael Des Barres','Missy Crider','Jeanne Bates','Dan Birnbaum','Michael J. Anderson','Melissa George','Mark Pellegrino','Rena Riffel','Michele Hicks','Tony Longo','Elizabeth Lackey','Richard Green','Desi Singh','Patrick Fischler','William Ostrander','Michael Fairman','Mo Gallini','Wayne Grace','Geno Silva','Rita Taggart','Bonnie Aarons','Phoebe Augustine','Monty Montgomery','Tad Horino','Vincent Castellanos','Blake Lindsley','Marcus Graham','Johanna Stein'],
screenplay:['David Lynch'],
production:['Alain Sarde','Mary Sweeney','Neal Edelstein','Michael Polaire'],
music:['Angelo Badalamenti'],
camera:['Peter Deming'],
cut:['Mary Sweeney'],
scenography:['Jack Fisk','Peter Jamison','Barbara Haberecht'],
masks:['Howard Berger','Greg Nicotero'],
costumes:['Amy Stofsky']},
{title:'Hold-Up',
titleCZ:'Bezva finta',
year:1985,
runtime:114,
countries:['France','Canada'],
genres:['Comedy','Crime'],
director:['Alexandre Arcady'],
actors:['Jean-Paul Belmondo','Kim Cattrall','Guy Marchand','Jean-Pierre Marielle','Jacques Villeret','Jean-Claude de Goros','Tex Konig','Georges Carrère','Yvan Ponton','Guy Provost','Guillaume Lemay-Thivierge','Richard Niquette','Yves Jacques','Karen Racicot','Michel Daigle','Claude Sandoz','Louis-Georges Girard','Charly Koubesserian'],
basedOn:['Jay Cronley'],
screenplay:['Francis Veber','Daniel Saint-Hamont','Alexandre Arcady'],
production:['Alain Belmondo'],
music:['Serge Franklin'],
camera:['Richard Ciupka'],
cut:['Joële van Effenterre','Juliette Welfling'],
sound:['Alain Sempé','Claude Villand','Yvon Benoît'],
scenography:['Jean-Louis Povéda'],
masks:['Charly Koubesserian'],
costumes:['Mic Cheminal','Paulette Breil']},
{title:'Dog Day Afternoon',
titleCZ:'Psí odpoledne',
year:1975,
runtime:125,
countries:['USA'],
genres:['Drama','Crime','Thriller','Biographic'],
director:['Sidney Lumet'],
actors:['Al Pacino','John Cazale','James Broderick','Carol Kane','Charles Durning','Lance Henriksen','Dominic Chianese','Chris Sarandon','Robert Costanzo','Tom Towles','Dick Anthony Williams','Penelope Allen','Judith Malina','Susan Peretz','Ron Gilbert','Marcia Jean Kurtz','William Bogert','Floyd Levine','Sully Boyar','Gary Springer','Estelle Omens','Jay Gerber','Philip Charles Mackenzie','Lionel Pina','Chu Chu Malave','Marcia Haufrecht','Tony Lip','Thomas Murphy'],
basedOn:['Leslie Waller'],
screenplay:['Frank Pierson'],
production:['Martin Bregman','Martin Elfand'],
camera:['Victor J. Kemper'],
cut:['Dede Allen'],
sound:['Dick Vorisek'],
scenography:['Charles Bailey'],
costumes:['Anna Hill Johnstone']},
{title:'The Color Purple',
titleCZ:'Purpurová barva',
year:1985,
runtime:154,
countries:['USA'],
genres:['Drama'],
director:['Steven Spielberg'],
actors:['Whoopi Goldberg','Danny Glover','Margaret Avery','Oprah Winfrey','Willard E. Pugh','Akosua Busia','Adolph Caesar','Rae Dawn Chong','Dana Ivey','Leonard Jackson','Carl Anderson','Susan Beaubian','Laurence Fishburne','Leon Rippy','April Myers','Marcus Covington','Marcus Liles','Juliet Poe','Katie Simon','Maria Howell','Hawthorne James','Jeris Poindexter','Bennet Guillory','Drew Bundini Brown','Arnold F. Turner','Clarence Avant','Gayle King'],
basedOn:['Alice Walker'],
screenplay:['Menno Meyjes'],
production:['Steven Spielberg','Frank Marshall','Kathleen Kennedy','Quincy Jones'],
music:['Quincy Jones'],
camera:['Allen Daviau'],
cut:['Michael Kahn'],
sound:['Richard L. Anderson','Don Digirolamo','Robert Glass'],
scenography:['J. Michael Riva'],
masks:['Ken Chase','Steve La Porte'],
costumes:['Aggie Guerard Rodgers']},
{title:'The Fighting Musketeers',
titleCZ:'Tři mušketýři: Královniny přívěsky',
year:1961,
runtime:100,
countries:['France','Italy'],
genres:['Adventure','Romance','History'],
director:['Bernard Borderie'],
actors:['Gérard Barray','Mylène Demongeot','Georges Descrières','Bernard Woringer','Jacques Toja','Guy Delorme','Daniel Sorano','Jacques Berthier','Jean Carmet','Henri Nassiet','Robert Berri','Léna Skerla','Perrette Pradier','Jacques Seiler','Françoise Christophe','Guy Tréjan','Serge Marquand','Jean Ozenne','Jacques Hilling','Dominique Zardi','Malka Ribowska','Anne Tonietti','Pierre Mirat','Hubert de Lapparent','Philippe March','André Weber','Henri Cogan'],
basedOn:['Alexandre Dumas st.'],
screenplay:['Bernard Borderie'],
production:['Raymond Borderie'],
music:['Paul Misraki'],
camera:['Armand Thirard'],
cut:['Christian Gaudin'],
costumes:['Rosine Delamare']},
{title:'El Dorado',
titleCZ:'El Dorado',
year:1966,
runtime:122,
countries:['USA'],
genres:['Western'],
director:['Howard Hawks'],
actors:['John Wayne','Robert Mitchum','James Caan','Charlene Holt','Paul Fix','Arthur Hunnicutt','Michele Carey','R.G. Armstrong','Edward Asner','Christopher George','Marina Ghane','Robert Donner','Adam Roarke','Jim Davis',"Robert 'Buzz' Henry",'John Mitchum','Chuck Roberson','Danny Borzage','William Henry','Ruben Moreno','Johnny Crawford','John Gabriel','Don Collier','Chuck Courtney','Robert Rothwell','Ralph Volkie','Riley Hill','Lars Hensen','Linda Dangcil','Rosa Turich','Dean Smith'],
basedOn:['Harry Brown'],
screenplay:['Leigh Brackett'],
production:['Howard Hawks'],
music:['Nelson Riddle'],
camera:['Harold Rosson'],
cut:['John Woodcock'],
sound:['Alfonso Pino'],
scenography:['Hal Pereira','Carl Anderson','Ray Moyer','Robert R. Benton'],
masks:['Wally Westmore'],
costumes:['Edith Head']},
{title:'Lovers of the Arctic Circle',
titleCZ:'Milenci ze severního pólu',
year:1998,
runtime:112,
countries:['Spain','France'],
genres:['Drama','Romance','Mystery'],
director:['Julio Medem'],
actors:['Najwa Nimri','Fele Martínez','Nancho Novo','Maru Valdivielso','Ángela Castilla','Pep Munné','Joost Siedhoff','Beate Jensen','Jaroslaw Bielski','María Isasi','Elena Lombao'],
screenplay:['Julio Medem'],
production:['Fernando Bovaira','Enrique López Lavigne'],
music:['Alberto Iglesias'],
camera:['Gonzalo F. Berridi'],
cut:['Iván Aledo'],
scenography:['Satur Idarreta'],
costumes:['Estíbaliz Markiegi']},
{title:'Throne of Blood',
titleCZ:'Krvavý trůn',
year:1957,
runtime:110,
countries:['Japan'],
genres:['Drama'],
director:['Akira Kurosawa'],
actors:['Toširó Mifune','Isuzu Jamada','Takaši Šimura','Akira Kubo','Hiroši Tačikawa','Minoru Čiaki','Takamaru Sasaki','Čieko Naniwa','Seidži Mijaguči','Isao Kimura','Eiko Mijoši','Jošio Inaba','Hitoši Takagi','Asao Koike','Nakadžiró Tomita','Akira Tani','Kokuten Kôdô'],
screenplay:['William Shakespeare','Hideo Oguni','Akira Kurosawa','Šinobu Hašimoto','Ryûzô Kikushima'],
production:['Akira Kurosawa'],
music:['Masaru Sató'],
camera:['Asakazu Nakai']},
{title:'Anatomy of a Fall',
titleCZ:'Anatomie pádu',
year:2023,
runtime:150,
countries:['France'],
genres:['Drama'],
director:['Justine Triet'],
actors:['Sandra Hüller','Swann Arlaud','Milo Machado Graner','Jehnny Beth','Samuel Theis','Saadia Bentaïeb','Antoine Reinartz','Camille Rutherford','Sophie Fillières','Ilies Kadri','Arthur Harari','Pierre-François Garel'],
screenplay:['Arthur Harari','Justine Triet'],
production:['Marie-Ange Luciani','David Thion'],
camera:['Simon Beaufils'],
cut:['Laurent Sénéchal'],
scenography:['Cécile Deleu'],
costumes:['Isabelle Pannetier']},
{title:"Marie's Story",
titleCZ:'Příběh Marie',
year:2014,
runtime:95,
countries:['France'],
genres:['Biographic','Drama'],
director:['Jean-Pierre Améris'],
actors:['Isabelle Carré','Ariana Rivoire','Brigitte Catillon','Noémie Churlet','Gilles Treton','Laure Duthilleul','Martine Gautier','Patricia Legrand','Sonia Laroze','Valérie Leroux','Fany Buy','Noémie Bianco','Eline De Lorenzi','Tiphaine Rabaud Fournier','Sandrine Schwartz','Dimitri Radochevitch','Christophe Tourrette','Stéphane Margot','Isabelle Marchand Munoz','Monique Milliot','Morgane Legrand','Océane Carreau','Ophélie Ezikian','Amélie Guer','Alexandra Guy','Kylona Guyon','Jessy Issartel','Cassandra Lebihan','Oriane Lemaire','Capucine Liatout','Jade Liatout','Juliette Liatout','Manon-Chloé Liatout','Eva Munch','Anaïs Jean','Clarisse Rodrigues da Costa','Alina Terekhova','Vyckie Verraux','Jane Verrechia','Ana Bouveret','Ema Bouveret','Winona Guyon','Claire Potier','Eozenn Weber'],
screenplay:['Jean-Pierre Améris','Philippe Blasband'],
production:['Denis Carot','Sophie Révil'],
music:['Sonia Wieder-Atherton'],
camera:['Virginie Saint-Martin'],
cut:['Anne Souriau'],
scenography:['Franck Schwarz','Pierre-Julien Journet'],
masks:['Emmanuelle Brechet']},
{title:'Suzume',
titleCZ:'Suzume',
year:2022,
runtime:122,
countries:['Japan'],
genres:['Animation','Action','Adventure','Fantasy'],
director:['Makoto Šinkai'],
actors:['Hokuto Macumura','Nanoka Hara','Eri Fukacu','Hakuó Macumoto II','Šóta Sometani','Sairi Itó','Kotone Hanase','Kana Hanazawa','Rjúnosuke Kamiki','Aimi','Takara Hačija','Ann Jamane','Daiči Furusawa','Júsuke Sasaki','Kaito Ogawa','Manacu Hada','Minami Oikawa','Kaó Uesugi','Maki Jamamoto','Takaaki Torašima','Arisa Maesako','Akihiro Tadžima',"Šin'ja Takahaši",'Rjóko Nagata','Seijú Fudžiwara','Jú Ajase','Kó Odadžima','Jódži Ueda','Rjúó Nagaoka','Takahiro Sumi','Tomomiči Nišimura','Kacufumi Jači','Saja Hirose','Juki Sorami','Taiči Takeda','Genta Nakamura','Mijako Kobajaši','Kojomi Asakawa','Čiaki Kido','Šindžiró Góda','Manami Hanawa','Saori Seto','Misano Sakai','Kumiko Nakane','Čiharu Hokaze','Kjó Jaoja','Jošino Aojama','Jasuhiro Kikuči','Šinnosuke Imazu','Keita Azuma','Kaja Ueda','Maó Takemura','Tomomi Tanaka','Šúičiró Umeda','Kósuke Ečigoja','Nanae Sumitomo','Kacunori Okai','Risa Watanabe','Noriaki Kanze','Jumi Fukamizu','Love Morinaga','Sakura Kawaguči','Juri Kimura','Honami Obata','Hiroki Macukawa','Rjósuke Tomita','Majumi Cukišima','Juki Ominami','Ajumi Cudži','Kacumi Fukuhara','Takuja Jokota','Masajuki Fudžibuči','Aina Rutó','Rena Maeda','Maiko Nomura','Tadaaki Doi','Arisa Kinami','Aja Fudžita','Ajasa Itó','Madoka Kido','Sači Jošioka','Tomohiro Jamaguči','Aoto Abe','Erina Koga','Čió Ucumija','Júri Sakamoto'],
screenplay:['Makoto Šinkai'],
production:['Genki Kawamura'],
music:["Kazuma Džinno'uči",'Radwimps'],
camera:['Rjósuke Cuda'],
sound:['Haru Jamada'],
scenography:['Takumi Tandži']},
{title:'The Tree of Wooden Clogs',
titleCZ:'Strom na dřeváky',
year:1978,
runtime:170,
countries:['Italy','France'],
genres:['Drama','History'],
director:['Ermanno Olmi'],
actors:['Luigi Ornaghi','Francesca Moriggi','Omar Brignoli','Antonio Ferrari','Teresa Brescianini','Giuseppe Brignoli','Carlo Rota','Pasqualina Brolis','Massimo Fratus','Francesca Villa','Maria Grazia Caroli','Battista Trevaini','Giuseppina Langalelli','Lorenzo Pedroni','Felice Cervi','Pierangelo Bertoli','Brunella Migliaccio','Giacomo Cavalleri','Lorenza Frigeni','Lucia Pezzoli','Franco Pilenga','Guglielmo Badoni','Laura Lecatelli','Carmelo Silva','Mario Brignoli','Emilio Pedroni','Vittorio Capelli','Francesca Bassurini','Lina Ricci'],
screenplay:['Ermanno Olmi'],
camera:['Ermanno Olmi'],
cut:['Ermanno Olmi'],
scenography:['Enrico Tovaglieri','Franco Gambarana'],
costumes:['Francesca Zucchelli']},
{title:'Kingsman: The Secret Service',
titleCZ:'Kingsman: Tajná služba',
year:2014,
runtime:129,
countries:['UK','USA'],
genres:['Action','Adventure','Comedy','Thriller'],
director:['Matthew Vaughn'],
actors:['Colin Firth','Taron Egerton','Mark Strong','Samuel L. Jackson','Sofia Boutella','Sophie Cookson','Michael Caine','Mark Hamill','Jack Davenport','Edward Holcroft','Geoff Bell','Bjørn Floberg','Hanna Alström','Jack Cutmore-Scott','Corey Johnson','Theo Barklem-Biggs','Richard Brake','Velibor Topic','Lee Nicholas Harris','Ralph Ineson','Morgan Watkins','Tom Bell','Rowan Polonski','Francesca Bennett','Clem So','Jonno Davies','Miroslav Zaruba','Fiona Hampton','Samantha Womack','Tobi Bakare','Lily Travers','Matthew David McCarthy','Graham Curry','David Terry','Tobias James-Samuels','Nicholas Agnew','Matt Hookings','Nicholas Banks','Tom Prior','Anna Krippa','Jordan Long','Ben Dilloway','Paul Kennington','James Michael Rankin'],
basedOn:['Mark Millar','Dave Gibbons'],
screenplay:['Matthew Vaughn','Jane Goldman'],
production:['Matthew Vaughn','Adam Bohling','David Reid'],
music:['Henry Jackman','Matthew Margeson'],
camera:['George Richmond'],
cut:['Jon Harris','Eddie Hamilton'],
sound:['Michael Prestwood Smith','Simon Hayes','Matthew Collinge'],
scenography:['Paul Kirby','Andrew Ackland-Snow'],
masks:['Christine Blundell','Lesa Warrener'],
costumes:['Arianne Phillips']},
{title:'Total Recall',
titleCZ:'Total Recall',
year:1990,
runtime:113,
countries:['USA'],
genres:['Action','Sci-Fi','Thriller'],
director:['Paul Verhoeven'],
actors:['Arnold Schwarzenegger','Rachel Ticotin','Sharon Stone','Ronny Cox','Michael Ironside','Marshall Bell','Mel Johnson Jr.','Ray Baker','Michael Champion','Rosemary Dunsmore','Roy Brocksmith','David Knell','Alexia Robinson','Mark Carlton','Debbie Lee Carrington','Robert Costanzo','Priscilla Allen','Marc Alaimo','Mickey Jones','Robert Picardo','Kamala Lopez','Bob Bergen','Dean Norris','Anne Lockhart','Karlyn Michelson','Peter Kent','Joe Unger','Bob Tzudiker','Allan Graf','Monica Steuer','Michael Gregory','Roger Cudney','Erika Carlsson','Sasha Rionda','Lycia Naff','Ken Strausbaugh','Andy Armstrong','Morgan Lofting'],
basedOn:['Philip K. Dick'],
screenplay:['Ronald Shusett',"Dan O'Bannon",'Gary Goldman'],
production:['Buzz Feitshans','Ronald Shusett'],
music:['Jerry Goldsmith'],
camera:['Jost Vacano'],
cut:['Frank J. Urioste','Carlos Puente'],
sound:['Carlos Delarios'],
scenography:['William Sandell','Robert Gould'],
masks:['Jeff Dawn','Robin Weiss','Craig Berkeley','Rob Bottin','Charles Carter'],
costumes:['Erica Edell Phillips']},
{title:'Headhunters',
titleCZ:'Lovci hlav',
year:2011,
runtime:100,
countries:['Norway','Sweden','Denmark','Germany'],
genres:['Drama','Crime','Thriller'],
director:['Morten Tyldum'],
actors:['Aksel Hennie','Synnøve Macody Lund','Nikolaj Coster-Waldau','Eivind Sander','Julie R. Ølgaard','Kyrre Haugen Sydness','Valentina Alexeeva','Reidar Sørensen','Nils Jørgen Kaalstad','Joachim Rafaelsen','Mats Mogeland','Gunnar Skramstad Johnsen','Lars Skramstad Johnsen','Signe Tynning','Nils Gunnar Lie','Baard Owe','Martin Furulund','Mattis Herman Nyquist','Irina Sokolova','André Santagati','Kyrre Mosleth','Camilla Augusta Hallan','Torgrim Mellum Stene','Morten Hennie','Petter Askø Næss','Daniel Bratterud'],
basedOn:['Jo Nesbø'],
screenplay:['Ulf Ryberg','Lars Gudmestad'],
production:['Paul Røed','Asle Vatn','Hans-Wolfgang Jurgan','Marianne Gray'],
music:['Trond Bjerknæs','Jeppe Kaas'],
camera:['John Andreas Andersen'],
cut:['Vidar Flataukan'],
sound:['Tormod Ringnes','Morten Solum','Kenneth Gustavsen'],
scenography:['Nina Bjerch-Andresen','Hanne Live Andersen'],
masks:['Aina Elisabeth Mork','Tina Helmark','Eros Codinas'],
costumes:['Karen Fabritius Gram']},
{title:'Primal Fear',
titleCZ:'Prvotní strach',
year:1996,
runtime:129,
countries:['USA'],
genres:['Drama','Thriller','Crime'],
director:['Gregory Hoblit'],
actors:['Richard Gere','Laura Linney','John Mahoney','Alfre Woodard','Frances McDormand','Edward Norton',"Terry O'Quinn",'Andre Braugher','Steven Bauer','Joe Spano','Tony Plana','Stanley Anderson','Maura Tierney','Jon Seda','Reg Rogers','Kenneth Tigar','Mike Bacarella','Joseph F. Kosala','Greg Bronson','Kyle Colerider-Krugh'],
basedOn:['William Diehl Jr.'],
screenplay:['Ann Biderman','Steve Shagan'],
production:['Gary Lucchesi'],
music:['James Newton Howard'],
camera:['Michael Chapman'],
cut:['David Rosenbloom'],
scenography:['Jeannine Oppewall'],
masks:['Kathrine Gordon','Sterfon Demings','Jeffrey Sacino'],
costumes:['Betsy Cox']},
{title:'The Last Duel',
titleCZ:'Poslední souboj',
year:2021,
runtime:152,
countries:['USA'],
genres:['Drama','History'],
director:['Ridley Scott'],
actors:['Matt Damon','Adam Driver','Jodie Comer','Ben Affleck','Harriet Walter','Marton Csokas','Željko Ivanek','Alex Lawther','Nathaniel Parker','Sam Hazeldine','Michael McElhatton','Clive Russell',"Caoimhe O'Malley",'Ian Pirie','Zoé Bruneau','Brian F. Mulvey','Simone Collins','Corinne Delacour','William Houston','Julian Firth','Serena Kennedy','Bosco Hogan','Adam Nagaitis','Thomas Silberstein','Lorris Chevalier'],
basedOn:['Eric Jager'],
screenplay:['Nicole Holofcener','Ben Affleck','Matt Damon'],
production:['Ridley Scott','Nicole Holofcener','Kevin J. Walsh','Jennifer Fox'],
music:['Harry Gregson-Williams'],
camera:['Dariusz Wolski'],
cut:['Claire Simpson'],
sound:['Oliver Tarney','William Miller'],
scenography:['Arthur Max','Judy Farr','Riccardo Monti'],
masks:['Matteo Silvi','Daniele Nastasi'],
costumes:['Janty Yates']},
{title:'The Prince of Egypt',
titleCZ:'Princ Egyptský',
year:1998,
runtime:88,
countries:['USA'],
genres:['Animation','Family','Musical','Drama'],
director:['Brenda Chapman','Steve Hickner','Simon Wells'],
actors:['Val Kilmer','Ralph Fiennes','Michelle Pfeiffer','Sandra Bullock','Jeff Goldblum','Danny Glover','Patrick Stewart','Helen Mirren','Steve Martin','Martin Short','Mel Brooks','Eden Riegel','Brian Stokes Mitchell','James Avery','Stephanie Sawyer','Aria Noelle Curzon','Francesca Marie Smith'],
screenplay:['Philip LaZebnik'],
production:['Penney Finkelman Cox'],
music:['Hans Zimmer'],
sound:['Wylie Stateman','Andy Nelson','Anna Behlmer','Michael Keller'],
scenography:['Richie Chavez']},
{title:'Black Book',
titleCZ:'Černá kniha',
year:2006,
runtime:139,
countries:['Nizozemsko','Belgium','Germany','UK'],
genres:['Thriller','War','Drama'],
director:['Paul Verhoeven'],
actors:['Carice van Houten','Sebastian Koch','Thom Hoffman','Halina Reijn','Waldemar Kobus','Derek de Lint','Christian Berkel','Dolf de Vries','Michiel Huisman','Ronald Armbrust','Frank Lammers','Matthias Schoenaerts','Johnny de Mol','Xander Straat','Diana Dobbelman','Garrick Hagon','Theo Maassen','Gijs Naber','Susan Visser','Marcel Musters','Michiel de Jong','Jacqueline Blom','Peter Blok','Bert Luppes','Pieter Tiddens','Tjebbo Gerritsma','Jack Vecht','Maiko Kemper','Rik Sinkeldam','Rian Gerritsen','Janni Goslinga','Dirk Zeelenberg','Jobst Schnibbe','Menno van Beekum','Reinier Bulder','Herman Boerman','Lidewij Mahler','Emile Jansen','Marisa van Eyle','Merel van Houts','Boris Saran','Wimie Wilhelm','Rixt Leddy','Skip Goeree','Hugo Metsers','Patrick Kerkhof','Arno Hazebroek','Nolan Hemmings','Willem de Wolf'],
screenplay:['Gerard Soeteman','Paul Verhoeven'],
production:['San Fu Maltha','Frans van Gestel','Jeroen Beker','Teun Hilte','Jens Meurer'],
music:['Anne Dudley'],
camera:['Karl Walter Lindenlaub'],
cut:['Job ter Burg','James Herbert'],
sound:['Eddy Joseph','James Harrison'],
scenography:['Wilbert van Dorp'],
masks:['Arjen Tuiten'],
costumes:['Yan Tax']},
{title:'Any Given Sunday',
titleCZ:'Vítězové a poražení',
year:1999,
runtime:150,
countries:['USA'],
genres:['Drama','Sport'],
director:['Oliver Stone'],
actors:['Al Pacino','Cameron Diaz','Dennis Quaid','Jaime Bergman','James Woods','Jamie Foxx','LL Cool J','Matthew Modine','Jim Brown','Lawrence Taylor','Bill Bellamy','Andrew Bryniarski','Lela Rochon','Lauren Holly','Ann-Margret','Aaron Eckhart','Elizabeth Berkley','Charlton Heston','John C. McGinley','Gianni Russo','James Karen','Duane Martin','Oliver Stone','Sean Stone','Antoni Corone','Justin D. Hilliard','Delia Sheppard','Margaret Betts','Trish Dempsey','Jose Rosete','Mitch Morris','Gene Gabriel','Mark Robert Ellis','Lanette Fugit','Wilt Chamberlain','Terrell Owens','Rick Johnson','Marty Wright','Allan Graf','Lester Speight','Clifton Davis','Gustavo Perez','Jeremy Denzlinger','Dick Butkus','Greg Orvis','Nikki Novak','Robert Paget','John Daniel','Michelle Bernard','Joanna Theobalds','Patrick H. Fox','Oscar A. Diaz','Eva Tamargo','LynNita Ellis','Nichole Galicia'],
screenplay:['John Logan','Oliver Stone'],
production:['Dan Halsted','Lauren Shuler Donner','Clayton Townsend'],
music:['Richard Horowitz'],
camera:['Salvatore Totino'],
cut:['Stuart Levy','Thomas J. Nordberg'],
sound:['Tom Fleischman','Wylie Stateman','Kelly Cabral','Michael Keller','Brad Sherman','Patrick Cyccone Jr.'],
scenography:['Victor Kempster','Ronald R. Reiss'],
masks:['John Blake','Bernadette Mazur','Anne Morgan'],
costumes:['Mary Zophres']},
{title:'Before Sunset',
titleCZ:'Před soumrakem',
year:2004,
runtime:80,
countries:['USA'],
genres:['Romance','Drama'],
director:['Richard Linklater'],
actors:['Ethan Hawke','Julie Delpy','Vernon Dobtcheff','Albert Delpy','Marie Pillet','Rodolphe Pauly'],
screenplay:['Richard Linklater','Julie Delpy','Ethan Hawke'],
production:['Anne Walker-McBay'],
camera:['Lee Daniel'],
cut:['Sandra Adair'],
costumes:['Thierry Delettre']},
{title:'Marketa Lazarová',
titleCZ:'Marketa Lazarová',
year:1967,
runtime:165,
countries:['Czechoslovakia'],
genres:['Poetic','Drama','History'],
director:['František Vláčil'],
actors:['Magda Vášáryová','Zdeněk Štěpánek','Josef Kemr','František Velecký','Naďa Hejná','Jaroslav Moučka','Ivan Palúch','Vladimír Menšík','Karel Vašíček','Pavel Landovský','Ladislav Považay','Martin Mrázek','Václav Sloup','Pavla Polášková','Alena Pavlíková','Václav Kovařík','Petr Sedlák','Michal Kožuch','Zdeněk Lipovčan','Harry Studt','Vlastimil Harapes','Zdeněk Kutil','František Nechyba','Josef Bradáč','Zdeněk Kryzánek','Zdeněk Řehoř','Jan Pohan','Oto Ševčík','Majka-Čech','František Hlinovský','Jaroslav Mařan','Otto Lackovič','Karla Chadimová','Hana Vítková','Václav Antoš','Karel Meister st.','Marta Záhorová','Alena Bradáčová','Čestmír Čivrný','Antonín Hardt','Luděk Drábek','Jaroslav Klenot','Karel Kryška','Ludvík Wolf','George Pokrovskij','Jan Vítek','Josef Šulc','Zbyšek Šrůta','Josef Šolc','Milan Aulický','Antonie Hegerlíková','Petr Kostka','František Husák','Ladislav Trojan','Karolina Slunéčková','Martin Růžek','Gabriela Vránová','Klaus-Peter Thiele','Gerhard Rachold','Hans Klering','Marie Tomášová','Fritz Diez','Aleš Dospiva','Jiří Bruder'],
basedOn:['Vladislav Vančura'],
screenplay:['František Pavlíček','František Vláčil'],
music:['Zdeněk Liška'],
camera:['Bedřich Baťka'],
cut:['Miroslav Hájek'],
sound:['František Fabián'],
scenography:['Oldřich Okáč'],
masks:['Jiří Hurych','Miloš Bobek'],
costumes:['Theodor Pištěk ml.','Ondrej Brezovský']},
{title:'Morality Above All Else',
titleCZ:'Mravnost nade vše',
year:1937,
runtime:75,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Martin Frič'],
actors:['Hugo Haas','Světla Svozilová','Adina Mandlová','Jiří Hlinomaz','Ladislav Boháč','Saša Rašilov st.','Věra Ferbasová','Mirko Eliáš','Zdeňka Baldová','Marie Ptáková','Marie Pilská','Milada Gampeová','Marie Ježková','Elsa Vetešníková','Marie Marková-Nekolová','Terezie Třebovská','Marie Häusslerová','Miro Bernat','Rudolf Milič','Josef Oliak','F. X. Mlejnek','Marie Oliaková','Jan Černý','Marie Přikrylová'],
screenplay:['Martin Frič','Otakar Vávra','Hugo Haas'],
music:['Rudolf Antonín Dvorský','Roman Blahník'],
camera:['Ferdinand Pečenka'],
cut:['Jan Kohout'],
sound:['Josef Zora'],
scenography:['Štěpán Kopecký']},
{title:'Boy A',
titleCZ:'Ten kluk',
year:2007,
runtime:100,
countries:['UK'],
genres:['Drama'],
director:['John Crowley'],
actors:['Andrew Garfield','Alfie Owen','Peter Mullan','Taylor Doherty','Shaun Evans','Anthony Lewis','Siobhan Finneran','Skye Bennett','Victoria Brazier','Katie Lyons','Jeremy Swift','Helen Wilding','Josef Altin','Tilly Vosburgh','James Young'],
basedOn:['Jonathan Trigell'],
screenplay:["Mark O'Rowe"],
production:['Tally Garner','Nick Marston','Lynn Horsford'],
camera:['Rob Hardy'],
cut:['Lucia Zucchetti'],
sound:['Andrew Stirk'],
scenography:['Jon Henson'],
costumes:['Julian Day']},
{title:'4 Months, 3 Weeks and 2 Days',
titleCZ:'4 měsíce, 3 týdny a 2 dny',
year:2007,
runtime:113,
countries:['Rumunsko'],
genres:['Drama'],
director:['Cristian Mungiu'],
actors:['Anamaria Marinca','Laura Vasiliu','Vlad Ivanov','Alexandru Potocean','Tania Popa','Cerasela Iosifescu','Doru Ana','Eugenia Bosânceanu','Luminița Gheorghiu','Adina Cristescu','Adrian Carauleanu','Geo Dobre','Ion Grosu','Ion Sapdaru','Teodor Corban'],
screenplay:['Cristian Mungiu'],
production:['Cristian Mungiu','Oleg Mutu'],
camera:['Oleg Mutu'],
cut:['Dana Bunescu'],
sound:['Dana Bunescu','Constantin Fleancu'],
masks:['Ioana Angelescu'],
costumes:['Dana Istrate']},
{title:'Hard Boiled',
titleCZ:'Hard Boiled',
year:1992,
runtime:128,
countries:['Hong Kong'],
genres:['Action','Drama','Crime','Thriller'],
director:['John Woo'],
actors:['Yun-fat Chow','Tony Chiu-wai Leung','Anthony Wong','Phillip Kwok','Stephen Tung','John Woo','Pai Wei','Džun Kunimura','Philip Chan','Teresa Mo','Pau-chung Tong','Fat-yuen Lee','Hoi-Shan Kwan','Raymond Tsang','Tai-wo Tang','Kei-hei Leung','Tin-hung Yee','Shui-ting Ng','Seung-lam Wan','Kwok-ping Choi','Kwok-keung Choi','Jameson Wa-Fan Lam','Bruce Law','Ying Lung','Kenny Wong','Marco Lee','Bowie Lam','Derek Kwok','Bobbie Au-Yeung','Gilbert Lam','Kong Lau','Wai-Wo To','Seng-Kwong Chang','Foo-Wai Lam','Chin-Hung Fan','Chin-Bo Sham','Wai-Fong Wong','Kwok-Kin Ng','Chi-Hok Wong','Wai-Man Tam','Chi-Ming Lau','Kai-Wing Lam'],
screenplay:['Barry Wong'],
production:['Terence Chang'],
music:['Michael Gibbs'],
camera:['Horace Wong'],
cut:['David Wu','John Woo','Kit-Wai Hai'],
scenography:['James Leung','Joel Chong'],
costumes:['Bruce Yu']},
{title:'Freaks',
titleCZ:'Zrůdy',
year:1932,
runtime:64,
countries:['USA'],
genres:['Drama','Horror'],
director:['Tod Browning'],
actors:['Wallace Ford','Leila Hyams','Olga Baclanova','Roscoe Ates','Harry Earles','Daisy Earles','Schlitze','Daisy Hilton','Violet Hilton','Josephine Joseph','Johnny Eck','Frances O´Connor','Peter Robinson','Olga Roderick','Koo Koo','Prince Randian','Martha Morris','Elvira Snow','Jenny Lee Snow','Elizabeth Green','Edward Brophy','Tom London','Louise Beavers','John Aasen','Ernie Adams','Rose Dione','Angelo Rossitto','Albert Conti','Henry Victor','Sidney Bracey','Murray Kinnell','Hooper Atchley','Mathilde Comont','Matt McHugh','Michael Visaroff'],
screenplay:['Willis Goldbeck','Charles MacArthur'],
production:['Irving Thalberg','Tod Browning','Harry Rapf'],
camera:['Merritt B. Gerstad'],
cut:['Basil Wrangell'],
sound:['Douglas Shearer'],
scenography:['Cedric Gibbons','Merrill Pye']},
{title:'The Exterminating Angel',
titleCZ:'Anděl zkázy',
year:1962,
runtime:93,
countries:['Mexico'],
genres:['Comedy','Drama','Fantasy','Mystery'],
director:['Luis Buñuel'],
actors:['Silvia Pinal','Jacqueline Andere','Claudio Brook','José Baviera','Rita Macedo','Augusto Benedico','Antonio Bravo','Enrique García Álvarez','Eric del Castillo','Enrique Rambal','Victorio Blanco','Ofelia Montesco','Arturo Cobo','Luis Beristáin','Guillermo Álvarez Bianchi','Chel López','Lucy Gallardo','Jesús Gómez','Pancho Córdova','Daniel Arroyo','Elodia Hernández','Rosa Elena Durgel','Tito Junco','Roberto Meyer','Ángel Di Stefani','César del Campo','Florencio Castelló','Rubén Márquez','Fernando Yapur','Nadia Haro Oliva','David Hayat','Bertha Moss','Ángel Merino','Patricia Morán','Xavier Loyá','Luis Lomelí','Janet Alcoriza','Enrique del Castillo','Patricia de Morelos','Ofelia Guilmáin','Juan Antonio Edwards'],
screenplay:['Luis Buñuel'],
production:['Gustavo Alatriste'],
music:['Raúl Lavista'],
camera:['Gabriel Figueroa'],
cut:['Carlos Savage'],
sound:['José B. Carles','James L. Fields'],
scenography:['Jesús Bracho'],
masks:['Esperanza Gómez','Armando Meyer'],
costumes:['Georgette Somohano']},
{title:'Umberto D.',
titleCZ:'Umberto D.',
year:1952,
runtime:89,
countries:['Italy'],
genres:['Drama'],
director:['Vittorio De Sica'],
actors:['Carlo Battisti','Maria Pia Casilio','Lina Gennari','Ileana Simova','Lamberto Maggiorani','Memmo Carotenuto'],
screenplay:['Cesare Zavattini'],
production:['Angelo Rizzoli','Giuseppe Amato','Vittorio De Sica'],
music:['Alessandro Cicognini'],
camera:['G.R. Aldo'],
cut:['Eraldo Da Roma'],
sound:['Ennio Sensi'],
scenography:['Virgilio Marchi','Ferdinando Ruffo']},
{title:'The Big Bad Fox and Other Tales',
titleCZ:'Velký zlý lišák',
year:2017,
runtime:79,
countries:['France'],
genres:['Animation','Tale','Comedy','Family'],
director:['Patrick Imbert','Benjamin Renner'],
actors:['Magali Rosenzweig','Bernard Larmande','Antoine Schoumsky','Damien Witecka','Guillaume Darnault'],
screenplay:['Benjamin Renner','Jean Regnaud'],
production:['Didier Brunner','Vincent Tavier','Damien Brunner'],
music:['Robert Marcel Lepage'],
cut:['Benjamin Massoubre']},
{title:'Up',
titleCZ:'Vzhůru do oblak',
year:2009,
runtime:93,
countries:['USA'],
genres:['Animation','Adventure','Drama','Comedy','Family'],
director:['Pete Docter','Bob Peterson'],
actors:['Edward Asner','Christopher Plummer','Bob Peterson','Delroy Lindo','David Kaye','Jess Harnell','Josh Cooley','Pete Docter','Brenda Chapman','Teddy Newton','John Ratzenberger','Tony Fucile','John Cygan','Teresa Ganzel','Donald Fullilove','Valerie LaPointe','Paul Eiding','Jan Rabson','Danny Mann'],
screenplay:['Pete Docter','Bob Peterson'],
production:['Jonas Rivera'],
music:['Michael Giacchino'],
camera:['Jean-Claude Kalache'],
cut:['Kevin Nolting'],
sound:['Michael Semanick'],
scenography:['Daniel Lopez Muñoz']},
{title:'Thor: Ragnarok',
titleCZ:'Thor: Ragnarok',
year:2017,
runtime:130,
countries:['USA','Australia'],
genres:['Action','Adventure','Fantasy','Sci-Fi','Comedy'],
director:['Taika Waititi'],
actors:['Chris Hemsworth','Tom Hiddleston','Mark Ruffalo','Cate Blanchett','Tessa Thompson','Idris Elba','Jeff Goldblum','Anthony Hopkins','Karl Urban','Zachary Levi','Ray Stevenson','Benedict Cumberbatch','Tadanobu Asano','Taika Waititi','Clancy Brown','Lou Ferrigno','Stan Lee','Rachel House','Rob Mayes','Sam Neill','Matt Damon','Luke Hemsworth','Charlotte Nicdao','Georgia Blizzard','Scarlett Johansson','Charles Green','Shalom Brune-Franklin','Amali Golden','Sam Hargrave','Jet Tranter','Salvatore Merenda','Hamish Parkinson','Greta Carew-Johns','Jasper Bagg'],
basedOn:['Stan Lee','Larry Lieber','Jack Kirby'],
screenplay:['Eric Pearson','Craig Kyle','Christopher L. Yost'],
production:['Kevin Feige','Brad Winderbaum','Thomas M. Hammel','Stan Lee'],
music:['Mark Mothersbaugh'],
camera:['Javier Aguirresarobe'],
cut:['Zene Baker','Joel Negron'],
sound:['Juan Peralta','Lora Hirschberg','Daniel Laurie','Shannon Mills'],
scenography:['Dan Hennah','Ra Vincent','Beverley Dunn'],
masks:['Jessie Gambardella','Carla Vicenzino','Donald McInnes','Kay Georgiou','Morag Ross','Jason Baird'],
costumes:['Mayes C. Rubeo']},
{title:'The Perks of Being a Wallflower',
titleCZ:'Charlieho malá tajemství',
year:2012,
runtime:103,
countries:['USA'],
genres:['Drama','Romance'],
director:['Stephen Chbosky'],
actors:['Logan Lerman','Emma Watson','Ezra Miller','Mae Whitman','Erin Wilhelmi','Dylan McDermott','Kate Walsh','Nina Dobrev','Paul Rudd','Johnny Simmons','Reece Thompson','Adam Hagenbuch','Nicholas Braun','Melanie Lynskey','Julia Garner','Joan Cusack','Tom Savini','Stacy Chbosky','Dihlon McManne','Landon Pigg','John W. Iwanonkiw','Zane Holtz','Morgan Wolk','Patrick de Ledebur','Brian Balzerini','Tom Kruszewski','Emily Marie Callaway','Chelsea Zhang','Justine Nicole Schaefer','Julie Marie Schaefer','Owen Campbell','Brian Muller','Andre Brassil'],
basedOn:['Stephen Chbosky'],
screenplay:['Stephen Chbosky'],
production:['Lianne Halfon','John Malkovich','Russell Smith'],
music:['Michael Brook'],
camera:['Andrew Dunn'],
cut:['Mary Jo Markey'],
sound:['Joe Barnett','Marshall Garlington'],
scenography:['Inbal Weinberg','Gregory A. Weimerskirch','Merissa Lombardo'],
masks:['Patty Bell'],
costumes:['David C. Robinson']},
{title:'Wreck-It Ralph',
titleCZ:'Raubíř Ralf',
year:2012,
runtime:97,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Rich Moore'],
actors:['John C. Reilly','Sarah Silverman','Jack McBrayer','Jane Lynch','Alan Tudyk','Mindy Kaling',"Ed O'Neill",'Dennis Haysbert','Scott Menville','Jamie Elman','Skylar Astin','Rachael Harris','Phil Johnston','Adam Carolla','Rich Moore','Isabella Acres','Stefanie Scott','Lauren MacMullan','Ava Acres','Roger Craig Smith','Earl Ghaffari','Brandon Scott','Edie McClurg','Raymond S. Persi','April Stewart','Kevin Deters','Paul Pape','Jadon Sand','Mike Carlsen','Emily Hahn','Kath Soucie','Debi Derryberry','David Boat','Reuben Langdon','Mona Marshall','David Cowgill','Josie Trinidad'],
screenplay:['Phil Johnston','Jennifer Lee'],
production:['Clark Spencer'],
music:['Henry Jackman','Skrillex'],
sound:['Frank Eulner','Gary Rizzo','Gary Rydstrom','David E. Fluhr']},
{title:'Taxi Driver',
titleCZ:'Taxikář',
year:1976,
runtime:113,
countries:['USA'],
genres:['Drama','Crime'],
director:['Martin Scorsese'],
actors:['Robert De Niro','Jodie Foster','Albert Brooks','Harvey Keitel','Leonard Harris','Peter Boyle','Cybill Shepherd','Diahnne Abbott','Frank Adu','Victor Argo','Brenda Dickson','Bob Maroff','Norman Matlock','Harry Northup','Gene Palma','Harlan Cary Poe','Steven Prince','Peter Savage','Martin Scorsese','Nicholas Shields','Ralph S. Singleton','Joe Spinell','Debbi Morgan','Antone Pagán'],
screenplay:['Paul Schrader'],
production:['Michael Phillips','Julia Phillips'],
music:['Bernard Herrmann'],
camera:['Michael Chapman'],
cut:['Marcia Lucas','Tom Rolf','Melvin Shapiro'],
sound:['Tex Rudloff','Rick Alexander'],
scenography:['Charles Rosen'],
masks:['Mona Orr','Dick Smith'],
costumes:['Ruth Morley']},
{title:'The Hours',
titleCZ:'Hodiny',
year:2002,
runtime:114,
countries:['USA','UK'],
genres:['Drama'],
director:['Stephen Daldry'],
actors:['Nicole Kidman','Julianne Moore','Meryl Streep','Stephen Dillane','Miranda Richardson','Sophie Wyburd','Lyndsey Marshal','Linda Bassett','Christian Coulson','Michael Culkin','John C. Reilly','Toni Collette','Margo Martindale','Colin Stinton','Ed Harris','Allison Janney','Claire Danes','Jeff Daniels','Eileen Atkins','Michael Cunningham','Carmen De Lavallade','Jack Rovello','Daniel Brocklebank'],
basedOn:['Michael Cunningham'],
screenplay:['David Hare','Michael Cunningham'],
production:['Scott Rudin'],
music:['Philip Glass'],
camera:['Seamus McGarvey'],
cut:['Peter Boyle'],
sound:['Warren Shaw','Lee Dichter','David Crozier'],
scenography:['Maria Djurkovic'],
masks:['Paul Engelen','Ivana Primorac',"Conor O'Sullivan"],
costumes:['Ann Roth']},
{title:'Trading Places',
titleCZ:'Záměna',
year:1983,
runtime:111,
countries:['USA'],
genres:['Comedy'],
director:['John Landis'],
actors:['Dan Aykroyd','Eddie Murphy','Ralph Bellamy','Don Ameche','Denholm Elliott','Jamie Lee Curtis','Paul Gleason','Frank Oz','Jim Belushi','Robert Curtis Brown','Nicholas Guest','John Bedford Lloyd','Giancarlo Esposito','James Eckhouse','Eddie Jones','Bill Cobbs','Philip Bosco','Bryan Clark','Tom Mardirosian','Gary Howard Klar','Walt Gorney','Barry Dennen','Maurice Copeland','George Folsey Jr.','Al Franken','Robert Earl Jones','Afemo Omilami','Ralph Clanton','Clint Smith','Kristin Holby','Ron Taylor','Kelly Curtis','Bo Diddley','Bernie McInerney','Jack Davidson','Arleen Sorkin','Steve Hofvendahl','Avon Long','Stephen Stucker','Benjean','Don McLeod'],
screenplay:['Herschel Weingrod','Timothy Harris'],
production:['Aaron Russo'],
music:['Elmer Bernstein'],
camera:['Robert Paynter'],
cut:['Malcolm Campbell'],
sound:['Don Digirolamo','Robert Glass'],
scenography:['Gene Rudolf','George DeTitta Jr.'],
costumes:['Deborah Nadoolman']},
{title:'Another Round',
titleCZ:'Chlast',
year:2020,
runtime:117,
countries:['Denmark'],
genres:['Drama'],
director:['Thomas Vinterberg'],
actors:['Mads Mikkelsen','Thomas Bo Larsen','Magnus Millang','Lars Ranthe','Maria Bonnevie','Helene Reingaard Neumann','Susse Wold','Silas Cornelius Van','Albert Rudbeck Lindhardt','Martin Greis-Rosenthal','Frederik Winther Rasmussen','Mercedes Claro Schelin','Cassius Aasav Browning','Maria Ovi','Le Münster-Swendsen','Michael Asmussen','Christina Hildebrandt','Thomas Guldberg Madsen','Per Otto Bersang Rasmussen','Dorte Højsted','Morten Jørgensen','Morten Thunbo','Jens Basse Dam','Max Kaysen Høyrup','Ole Dupont','Diêm Camille','Palmi Gudmundsson','Thomas Hou Mandsfeldt','Christiane Gjellerup Koch','Brian Brichs','Clara Phillipson'],
screenplay:['Thomas Vinterberg','Tobias Lindholm'],
production:['Sisse Graum Jørgensen','Kasper Dissing'],
camera:['Sturla Brandth Grøvlen'],
cut:['Anne Østerud','Janus Billeskov Jansen'],
sound:['Jan Schermer','Hans Møller'],
scenography:['Sabine Hviid'],
costumes:['Ellen Lens','Manon Rasmussen']},
{title:'The Fisher King',
titleCZ:'Král rybář',
year:1991,
runtime:137,
countries:['USA'],
genres:['Drama','Comedy','Romance'],
director:['Terry Gilliam'],
actors:['Jeff Bridges','Robin Williams','Mercedes Ruehl','Paul J. Lombardi','David Hyde Pierce','Amanda Plummer','Ted Ross','Kathy Najimy','Harry Shearer','Dan Futterman','William Marshall','Stephen Bridgewater','Michael Jeter','Richard LaGravenese','John de Lancie','Tom Waits','Carlos Carrasco','Lou Hancock','Bradley Gregg','Christian Clemenson','Jayce Bartok','Edgar M. Böhlke','John Heffernan','Diane Robin','Lara Harris','Melinda Culea','Anita Dangler','Mel Bourne','Al Fann','Mark Bringelson','Frazer Smith','William Preston','Pat Fraley','Jack Mulcahy'],
screenplay:['Richard LaGravenese'],
production:['Stacey Sher','Debra Hill','Lynda Obst'],
music:['George Fenton'],
camera:['Roger Pratt'],
cut:['Lesley Walker'],
sound:['Robert Farr'],
scenography:['Mel Bourne'],
costumes:['Beatrix Aruna Pasztor']},
{title:'Straight Outta Compton',
titleCZ:'Straight Outta Compton',
year:2015,
runtime:147,
countries:['USA'],
genres:['Biographic','Music','History','Crime','Drama'],
director:['F. Gary Gray'],
actors:['Jason Mitchell','Corey Hawkins',"O'Shea Jackson Jr.",'Aldis Hodge','Neil Brown Jr.','Lakeith Stanfield','Paul Giamatti','Orlando Brown','Allen Maldonado','Dean Cameron','Demetrius Grosse','Tate Ellington','Alexandra Shipp','Carra Patterson','Elena Goode','Aeriél Miranda','Ina-Alice Kopp','Bryan Casserly','Yatoya Toy','F. Gary Gray','Marcc Rose','Rob Nagle','Simon Rhee','Larry Sullivan','Keith Powers','Karen Ann Cabrera','Eazy-E','Dr. Dre','Ice Cube','MC Ren','DJ Yella','Tupac Shakur','Snoop Dogg','50 Cent','Eminem','Morgan Lester','Jordan Cann','Tonya T. Cannon','Kofi Siriboe','Michael Eauslin','Corey Reynolds','Ashton Sanders','Vince Romo','Deborah Lacey','A. Russell Andrews','Marcus Callender','Alfonso Flores Jr.','Thomas Q. Jones','Matthew Boylan','Travis Nicholson','Josiah Black','Chauntae Pink','Tekin Girgin','Steve Turner','Ciera Foster','Angela Elayne Gibbs',"Cris D'Annunzio",'Jessica Juarez','Ella Rodriguez','Natascha Hopkins','Maria Sten','Sheldon A. Smith','Cassandra Bautista','Benjamin Levy Aguilar','Alexandra Grey','Matt Corboy','Jimmy Star','Caileigh Scott','Brian Gilleece','Lisa Renee Pitts','Lawrence Moran',"Asia'h Epperson",'Christon Blue','Compton Menace','Melissa Bidgoli','Philicia Saunders','Callen David','Alex Wexo',"'Knife' Sotelo",'Arabian Prince','R. Marcus Taylor','Kendrick Lamar','Val Emanuel','Rickey Chaney'],
screenplay:['Jonathan Herman','Andrea Berloff'],
production:['Ice Cube','Dr. Dre','Matt Alvarez','F. Gary Gray','Scott Bernstein'],
music:['Joseph Trapanese'],
camera:['Matthew Libatique'],
cut:['Billy Fox','Michael Tronick'],
sound:['Jon Taylor','Frank A. Montaño','Mark P. Stoeckinger','Greg Hedgepath'],
scenography:['Shane Valentino','Christopher Carlson'],
masks:['Keesha Patterson','Debra Denson','Robert C. Mathews III'],
costumes:['Kelli Jones']},
{title:'Mission: Impossible - Dead Reckoning Part One',
titleCZ:'Mission: Impossible Odplata - První část',
year:2023,
runtime:164,
countries:['USA'],
genres:['Action','Adventure','Thriller'],
director:['Christopher McQuarrie'],
actors:['Tom Cruise','Hayley Atwell','Simon Pegg','Ving Rhames','Rebecca Ferguson','Vanessa Kirby','Esai Morales','Pom Klementieff','Henry Czerny','Shea Whigham','Greg Tarzan Davis','Frederick Schmidt','Mariela Garriga','Cary Elwes','Charles Parnell','Mark Gatiss','Indira Varma','Rob Delaney','Marcello Walton','Marcin Dorociński','Ivan Ivaškin','Zahari Baharov','Adrian Bouchet','Luke J.I. Smith','Nikolaos Brahimllari','Ioachim Ciobanu','Jadran Malkovich','Michail Safronov','Christopher Sciueref','Andrea Scarduzio','Barnaby Kay','Gloria Obianyo','Dana Blacklake','Doroteya Toleva','Yennis Cheung','Faycal Attougui','Gaetano Bruno','Marco Sincini','Evita Ciri','Melissa Anna Bartolini','Marco Lascari','Simon Rizzoni','Nico Toffoli'],
screenplay:['Christopher McQuarrie','Erik Jendresen'],
production:['Tom Cruise','Christopher McQuarrie'],
music:['Lorne Balfe'],
camera:['Fraser Taggart'],
cut:['Eddie Hamilton'],
sound:['James Mather','Glenn Freemantle'],
scenography:['Gary Freeman','Raffaella Giovannetti','Gavin Fitch','Phil Sims'],
masks:['Amy Byrne','Sinead McGowan','Marie Deehan','Teri Trowbridge'],
costumes:['Jill Taylor']},
{title:'The Triplets of Belleville',
titleCZ:'Trio z Belleville',
year:2003,
runtime:80,
countries:['France','Belgium','Canada','UK','Lotyšsko','USA'],
genres:['Animation','Drama','Comedy'],
director:['Sylvain Chomet'],
actors:['Michèle Caucheteux','Michel Robin','Jean-Claude Donda','Monica Viegas','Helga Van Der Heyden','Anneleen Cooreman','Camilia Blereau'],
screenplay:['Sylvain Chomet'],
production:['Viviane Vanfleteren','Didier Brunner'],
music:['Benoît Charest'],
cut:['Dominique Lefever'],
sound:['Henri Morelle','Eric DeVos','Laurent Quaglio','Alek Goosse']},
{title:"The Emperor's New Groove",
titleCZ:'Není král jako král',
year:2000,
runtime:78,
countries:['USA'],
genres:['Animation','Comedy','Adventure','Family'],
director:['Mark Dindal'],
actors:['David Spade','John Goodman','Eartha Kitt','Patrick Warburton','Wendie Malick','Stephen J. Anderson','Bob Bergen','Rodger Bumpass','Tom Jones','John Fiedler','Jess Harnell','Steve Susskind','Miriam Flynn','Robert Clotworthy','Jennifer Darling','Danny Mann'],
screenplay:['David Reynolds'],
music:['John Debney'],
cut:['Tom Finan','Pam Ziegenhagen'],
sound:['Dean A. Zupancic','Argiris Kandilis'],
scenography:['Paul A. Felix']},
{title:'West Side Story',
titleCZ:'West Side Story',
year:2021,
runtime:156,
countries:['USA'],
genres:['Musical','Drama','Romance','Crime'],
director:['Steven Spielberg'],
actors:['Ansel Elgort','Rachel Zegler','David Alvarez','Ariana DeBose','Rita Moreno','Corey Stoll',"Brian d'Arcy James",'Maddie Ziegler','Mike Faist','Ana Isabelle','Jamila Velazquez','Victor Cruz','Kevin Csolak','Victoria Zalipsky','Melania Zalipsky','Ken Holmes','Ryan Woodle','Myles Erlick','Atif Lanier','Annelise Cepero','Paloma Garcia-Lee','Josh Andrés Rivera','Ben Cook','Kyle Allen','Patrick Noonan','Iris Menas','Kylie Victoria Edwards','Yesenia Ayala','Tanairi Sade Vazquez','Kyle Coffman','Arianna Rosario'],
screenplay:['Tony Kushner'],
production:['Steven Spielberg','Kristie Macosko Krieger'],
music:['Leonard Bernstein','David Newman'],
camera:['Janusz Kamiński'],
sound:['Tod A. Maitland','Andy Nelson','Gary Rydstrom','Brian Chumney'],
scenography:['Adam Stockhausen','Rena DeAngelo','Nithya Shrinivasan'],
masks:['Joshua First','Judy Chin','Patrick Alemi','Kay Georgiou','Jerry DeCarlo','Amy Sue Nahhas'],
costumes:['Paul Tazewell']},
{title:'The Sea Inside',
titleCZ:'Hlas moře',
year:2004,
runtime:125,
countries:['Spain','France','Italy'],
genres:['Drama','Biographic'],
director:['Alejandro Amenábar'],
actors:['Javier Bardem','Belén Rueda','Lola Dueñas','Mabel Rivera','Celso Bugallo','Clara Segura','Alberto Jiménez','Tamar Novas','Francesc Garrido','Josep Maria Pou','Alberto Amarilla','Andrea Occhipinti','Nicolás Fernández Luna','Raúl Lavisier','Marta Larralde','Joan Dalmau','Federico Pérez Rey',"Xosé Manuel Olveira 'Pico'",'César Cambeiro','Iolanda Muíños'],
screenplay:['Alejandro Amenábar','Mateo Gil'],
production:['Alejandro Amenábar','Fernando Bovaira'],
music:['Alejandro Amenábar'],
camera:['Javier Aguirresarobe'],
sound:['Ricardo Steinberg'],
scenography:['Benjamín Fernández'],
masks:['Manolo García','David Martí'],
costumes:['Sonia Grande']},
{title:'Infernal Affairs',
titleCZ:'Volavka',
year:2002,
runtime:101,
countries:['Hong Kong'],
genres:['Drama','Crime','Mystery','Thriller'],
director:['Andrew Lau','Alan Mak'],
actors:['Andy Lau','Tony Chiu-wai Leung','Anthony Wong','Eric Tsang','Kelly Wai-lam Chan','Sammi Cheng','Edison Chen','Shawn Yue','Gordon Lam','Chapman To','Berg Ng','Kin-yung Chang','Sai-tang Yu','Yiu-wing Chin','Tony Ho','Terry Lee','Chung-wai Ho','Victy Wong','Kon-chung Tam','Wah-chu Lee','Courtney Wu','Jan-bong Che','Man-kee Yiu','John Hin-wai Au','Chi-wai Lai','Wai-nam So','Chi-Wang Wong','Pok-fu Chow','Simon Yuk-san Cheung','Benjamin Wai-ho Yuen','Jerry Leung','Dion Lam','Eric Li'],
screenplay:['Alan Mak','Felix Chong'],
production:['Andrew Lau'],
music:['Kwong-Wing Chan'],
camera:['Andrew Lau','Yiu-Fai Lai','Christopher Doyle'],
cut:['Danny Pang','Curran Pang'],
sound:['Kinson Tsang'],
scenography:['Sung-Pong Choo'],
masks:['Yu-Lai Cheng'],
costumes:['Pik-Kwan Lee']},
{title:'Cowboy Bebop: The Movie',
titleCZ:'Kovboj Bebop: Lovec odměn',
year:2001,
runtime:116,
countries:['Japan','USA'],
genres:['Animation','Action','Crime','Drama','Thriller','Sci-Fi'],
director:["Šin'ičiró Watanabe",'Jošijuki Takei'],
actors:['Ai Kobajaši','Kóiči Jamadera','Megumi Hajašibara','Aoi Tada','Unšó Išizuka','Hóko Kuwašima','Iššin Čiba','Džúróta Kosugi','Rendži Išibaši','Júdži Ueda','Masuo Amada','Hiroši Naka','Sajaka Óhara','Hidekacu Šibata','Júsaku Jara','Kazuhiko Inoue','Nobuo Tobita','Takaši Nagasako','Kacujuki Koniši','Kazusa Murai','Jósuke Akimoto','Kazuja Ičidžó','Takehiro Kojama','Džin Hirao',"Džun'iči Sugawara",'Miki Nagasawa','Kinrjú Arimoto','Kudžira','Cutomu Isobe','Jutaka Nakano','Rikija Kojama','Tošihiko Nakadžima','Eisuke Joda','Cutomu Tareki'],
production:['Masahiko Minami','Minoru Takanaši','Masao Ueda'],
music:['Jóko Kanno'],
camera:['Jóiči Ógami'],
cut:['Šúiči Kakesu'],
sound:['Kacujoši Kobajaši'],
scenography:['Acuši Morikawa']},
{title:'All That Jazz',
titleCZ:'All That Jazz',
year:1979,
runtime:123,
countries:['USA'],
genres:['Drama','Music','Comedy','Musical'],
director:['Bob Fosse'],
actors:['Roy Scheider','Jessica Lange','Leland Palmer','Ann Reinking','Cliff Gorman','Ben Vereen','Michael Tolan','Max Wright','Irene Kane','Erzsebet Foldi','Keith Gordon','John Lithgow','Sandahl Bergman','CCH Pounder','Wallace Shawn','Leah Ayres','Ben Masters','Joanna Merlin','Anthony Holland','David Margulies','Alan Heim','Terri Treas','Theresa Merritt','Deborah Geffner','Gary Bayer','Tito Goya','Stephen Strimpell','Robert Levine','K.C. Townsend','I.M. Hobson','Sammy Smith','Vicki Frederick','Cathie Shirriff','Tiger Haynes'],
screenplay:['Robert Alan Aurthur','Bob Fosse'],
production:['Robert Alan Aurthur'],
music:['Ralph Burns'],
camera:['Giuseppe Rotunno'],
cut:['Alan Heim'],
sound:['Dick Vorisek','Bob Olari','Maurice Schell'],
scenography:['Philip Rosenberg'],
costumes:['Albert Wolsky']},
{title:'Viridiana',
titleCZ:'Viridiana',
year:1961,
runtime:90,
countries:['Mexico','Spain'],
genres:['Drama'],
director:['Luis Buñuel'],
actors:['Silvia Pinal','Francisco Rabal','Fernando Rey','José Calvo','Margarita Lozano','Victoria Zinny','Claudio Brook','José Manuel Martín','María Isbert','Joaquín Roa','Rosita Yarza','Lola Gaos','José María Lado','Sergio Mendizábal','Narciso Ojeda','Luis Heredia','Teresa Rabal'],
basedOn:['Benito Pérez Galdós'],
screenplay:['Luis Buñuel','Julio Alejandro'],
production:['Gustavo Alatriste'],
camera:['José F. Aguayo'],
cut:['Pedro del Rey'],
scenography:['Francisco Canet']},
{title:'Charlie and the Chocolate Factory',
titleCZ:'Karlík a továrna na čokoládu',
year:2005,
runtime:115,
countries:['USA','UK','Australia'],
genres:['Fantasy','Family','Musical','Adventure','Comedy'],
director:['Tim Burton'],
actors:['Freddie Highmore','Johnny Depp','Helena Bonham Carter','James Fox','David Kelly','Christopher Lee','Deep Roy','Jordan Fry','Phillip Wiegratz','Missi Pyle','Noah Taylor','AnnaSophia Robb','Danny Elfman','Franziska Troegner','Garrick Hagon','Adam Godley','Nitin Ganatra','Eileen Essell','Shelley Conn','Geoffrey Holder','Todd Boyce','Roger Frost','Julia Winter','Annette Badland','Liz Smith','Philip Philmar','Nayef Rashed','Harry Taylor','Debora Weston','Hubertus Geller'],
basedOn:['Roald Dahl'],
screenplay:['John August'],
production:['Richard D. Zanuck'],
music:['Danny Elfman'],
camera:['Philippe Rousselot'],
cut:['Chris Lebenzon'],
sound:['Eddy Joseph','Steve Boeddeker','Michael Semanick','Tom Johnson'],
scenography:['Alex McDowell','Peter Young'],
masks:['Ivana Primorac','Karen Cohen','Neal Scanlan','Michael Krehl'],
costumes:['Gabriella Pescucci']},
{title:'Skyfall',
titleCZ:'Skyfall',
year:2012,
runtime:143,
countries:['UK','USA'],
genres:['Action','Adventure','Thriller'],
director:['Sam Mendes'],
actors:['Daniel Craig','Judi Dench','Ralph Fiennes','Javier Bardem','Naomie Harris','Bérénice Marlohe','Ben Whishaw','Helen McCrory','Albert Finney','Rory Kinnear','Ola Rapace','Tonia Sotiropoulou','Nicholas Woodeson',"Anthony O'Donnell",'Ben Loyd-Holmes','Jens Hultén','Chelsea Li','Darren Lynch','Kurt Egyiawan','Michael G. Wilson','David Norfolk','Greg Bennett','Amber Elizabeth','Peter Basham','Stuart Mulcaster','Jim Conway','Jozef Aoki','Alexandra Doyle','Clem So','Michael Pink','Martyn Mayger','Duncan Casey','Enoch Frost','Chris Cowlin','Richard Banks','Peter Roy','Tom Wu','Claira Watson Parr','Ian Bonar','Graham Curry','Bill Buckhurst','Yennis Cheung','Luke Howard','Shaun Lucas','Jo Cameron Brown','Daniel Adegboyega','Orion Lee','Nicholas Goh','Elize du Toit','Da Qing','Aşkın İbik','Dave Wong','Gregg Wilson','Tom Coulston','Wayne Gordon','Kriss Dillon'],
screenplay:['John Logan','Neal Purvis','Robert Wade'],
production:['Barbara Broccoli','Michael G. Wilson'],
music:['Thomas Newman'],
camera:['Roger Deakins'],
cut:['Stuart Baird'],
sound:['Per Hallberg','Andrii Trifonov','Greg P. Russell','Scott Millan'],
scenography:['Dennis Gassner','Paul Inglis','Mark Harris','Jason Knox-Johnston','Anna Pinnock'],
masks:['Naomi Donne','Donald Mowat','Zoe Tahir'],
costumes:['Jany Temime']},
{title:'In Bruges',
titleCZ:'V Bruggách',
year:2008,
runtime:107,
countries:['UK','USA'],
genres:['Drama','Comedy','Crime','Thriller'],
director:['Martin McDonagh'],
actors:['Colin Farrell','Brendan Gleeson','Ralph Fiennes','Clémence Poésy','Eric Godon','Jérémie Renier','Elizabeth Berrington','Željko Ivanek','Anna Madeley','Jordan Prentice','Thekla Reuten','Ciarán Hinds','Angel Witney','Olivier Bonjour','Theo Stevenson','Carmen Osbahr'],
screenplay:['Martin McDonagh'],
production:['Graham Broadbent','Peter Czernin'],
music:['Carter Burwell'],
camera:['Eigil Bryld'],
cut:['Jon Gregory'],
sound:['Oliver Brierley','Julian Slater'],
scenography:['Michael Carlin','Anna Lynch-Robinson'],
masks:['David White','Sharon Martin'],
costumes:['Jany Temime']},
{title:'Man on the Moon',
titleCZ:'Muž na Měsíci',
year:1999,
runtime:118,
countries:['USA','UK','Germany','Japan'],
genres:['Comedy','Drama','Biographic'],
director:['Miloš Forman'],
actors:['Jim Carrey','Danny DeVito','Courtney Love','Paul Giamatti','Vincent Schiavelli','Leslie Lyles','Peter Bonerz','Eva Jeníčková','Richard Belzer','Michael Kelly','Brent Briscoe','Christopher Lloyd','Jeff Conaway','Judd Hirsch','Carol Kane','Marilu Henner','Norm MacDonald','Mary Lynn Rajskub','Reiko Aylesworth','David Koechner','Angela Jones','Caroline Rhea','Christina Cabot','Edita Brychta','Bobby Boriello','David Letterman','Tracey Walter','Judy Ben-Asher','Sydney Lassick','Mičiko Nišiwaki','Patton Oswalt','Brian Peck','Patricia Scanlon','Chuck Zito','Michael Villani','Conrad Roberts','Mews Small','Stephen Sayadian','Kristin Richardson','Alison Simpson','Christie Pesicka','Scott Baldyga','Lorne Michaels','Greg Travis','Miles Chapin','Marilyn Sokol','Jerry Lawler','Anton Fig','Johnny Legend','Gene LeBell','Catherine Hader','Randall Carver','David Elliott','George Shapiro','Howard West','Max Alexander','Jeanine Jackson','Fredd Wayne','Gerry Becker','Christina Engelhardt','Danielle Burgio','Mark Pinkosh','Charlie Brissette','Karen Martin','Matt Price','Doris Eaton','Roger Ferreira','Howard Kremer','Greg Bronson','Claude Stuart','Dale Hawes','Pamela Abdy','Gerry Robert Byrne','Jani Blom','Budd Friedman','Linda Cevallos','Rob Steiner'],
screenplay:['Scott Alexander','Larry Karaszewski'],
production:['Stacey Sher','Michael Shamberg','Danny DeVito'],
camera:['Anastas N. Michos'],
cut:['Christopher Tellefsen','Lynzee Klingman','Adam Boome'],
sound:['Ron Bochar'],
scenography:['Patrizia von Brandenstein','Maria Nay'],
masks:['Ve Neill','Yolanda Toussieng','Bill Corso','Jori Jenae McGuire','Alicia M. Tripi'],
costumes:['Jeffrey Kurland']},
{title:'Downfall',
titleCZ:'Pád Třetí říše',
year:2004,
runtime:156,
countries:['Germany','Austria','Italy'],
genres:['Drama','History','War','Biographic'],
director:['Oliver Hirschbiegel'],
actors:['Bruno Ganz','Alexandra Maria Lara','Corinna Harfouch','Ulrich Matthes','Juliane Köhler','Heino Ferch','Christian Berkel','Matthias Habich','Thomas Kretschmann','Michael Mendl','André Hennicke','Ulrich Noethen','Birgit Minichmayr','Rolf Kanies','Justus von Dohnányi','Dieter Mann','Christian Redl','Götz Otto','Thomas Limpinsel','Thomas Thieme','Alexander Held','Donevan Gunia','Bettina Redlich','Heinrich Schmieder','Anna Thalbach','Dietrich Hollinderbäumer','Ulrike Krumbiegel','Karl Kranzkowski','Thorsten Krohn','Jürgen Tonkel','Devid Striesow','Fabian Busch','Christian Hoening','Alexandr Slastin','Alina Sokar','Amelie Menges','Charlotte Stoiber','Gregory Borlein','Julia Bauer','Laura Borlein','Andrej Blagoslovenskij','Jelizaveta Bojarskaja','Dirk Borchardt','Michael Brandner','Martin Butzke','Vsevolod Curilo','Mathias Gnädinger','Bohdan Graczyk','Norbert Heckner','Enno Hesse','Julia Jentsch','Michael Kind','Elisabeth von Koch','Tara Marie Linke','Michael Lippold','Stefan Mehren','Ilja Mozgovoj','Silke Nikowski','Katerina Poladjan','Oleg Popov','Silke Popp','Vasilij Reutov','Sergej Rubljov','Tanja Schleiff','Christian Schmidt','August Schmölzer','Jurij Schrader','Marija Semjonova','Igor Sergejev','Valerij Solomachin','Hans H. Steinberg','Klaus-Jürgen Steinmann','Oliver Stritzel','Veit Stübner','Michail Trjasorukov','Klaus B. Wolf','Taťjana Žuravljova','Thomas Franke','Traudl Junge','Henning Peker','Dieter Rupp','Alexandr Sťopin','Helga Filippova','Jelena Saveljeva','Roman Ušakov'],
basedOn:['Joachim Fest','Traudl Junge','Melissa Müller'],
screenplay:['Bernd Eichinger'],
production:['Bernd Eichinger'],
music:['Stephan Zacharias'],
camera:['Rainer Klausmann'],
cut:['Hans Funck'],
sound:['Roland Winke','Stefan Busch','Michael Kranz','Nico Krebs','Abi Schneider'],
scenography:['Bernd Lepel'],
masks:['Waldemar Pokromski','Margrit Neufink'],
costumes:['Claudia Bobsin']},
{title:'Contact',
titleCZ:'Kontakt',
year:1997,
runtime:153,
countries:['USA'],
genres:['Drama','Mystery','Sci-Fi','Thriller'],
director:['Robert Zemeckis'],
actors:['Jodie Foster','Matthew McConaughey','James Woods','John Hurt','Tom Skerritt','William Fichtner','David Morse','Angela Bassett','Geoffrey Blake','Max Martini','Rob Lowe','Jake Busey','Jena Malone','Tucker Smallwood','Timothy McNeil','Henry Strozier','Larry King','Thomas Garner','Dan Gifford','Saemi Nakamura','Geraldo Rivera','Jay Leno','Ann Druyan','Leo Lee','William Jordan','David St. James','Haynes Brooke','Bryant Gumbel','Steven Ford','Philippe Bergeron','Marc Macaulay','Jeffery Thomas Johnson','Júdži Okumoto','Alex Veadov','Alice Kushida','Robin Gammell','Richardson Morse','Delaney Williams','Kristoffer Ryan Winters','Valorie Armstrong','Bill Clinton','Adolf Hitler','Neil Armstrong','Richard Nixon','Martin Luther King','Franklin D. Roosevelt','Cenk Uygur','Ming Lo','Candice T. Cain','Mark Byrne','Carl Gilliard','J.A. Preston','Todd Thompson','Boris Lee Krutonog','Catherine Dao','Walter Winchell','Marisa Petroro','Vance Valencia','Christopher Boyer','Tony Boldi'],
basedOn:['Carl Sagan'],
screenplay:['James V. Hart','Michael Goldenberg'],
production:['Robert Zemeckis','Steve Starkey'],
music:['Alan Silvestri'],
camera:['Don Burgess'],
cut:['Arthur Schmidt'],
sound:['Randy Thom','Gary Rizzo','Tom Johnson'],
scenography:['Ed Verreaux'],
masks:['Carolyn Elias','Barbara Lacy'],
costumes:['Joanna Johnston']},
{title:'The People vs. Larry Flynt',
titleCZ:'Lid versus Larry Flynt',
year:1996,
runtime:129,
countries:['USA'],
genres:['Drama','Biographic'],
director:['Miloš Forman'],
actors:['Woody Harrelson','Courtney Love','Edward Norton','Brett Harrelson','James Cromwell','Crispin Glover','Vincent Schiavelli','Miles Chapin','Richard Paul','Jan Tříska',"D'Army Bailey",'Norm MacDonald','James Carville','Larry Flynt','Scott William Winters','Ryan Post','Jim Palmer','Aurélia Thiérrée','David Kallaway','Mike Pniewski','Tim Parati','Jim Peck','Donna Hanover','Nancy Lea Owen','Jim Grimshaw','Andy Stahl','Nate Bynum','Gerry Robert Byrne','David Dwyer'],
screenplay:['Scott Alexander','Larry Karaszewski'],
production:['Oliver Stone','Michael Hausman'],
music:['Thomas Newman'],
camera:['Philippe Rousselot'],
cut:['Christopher Tellefsen','Les Butler'],
scenography:['Patrizia von Brandenstein','Maria Nay','Amy Wells'],
costumes:['Theodor Pištěk ml.','Arianne Phillips']},
{title:'Master and Commander: The Far Side of the World',
titleCZ:'Master & Commander: Odvrácená strana světa',
year:2003,
runtime:138,
countries:['USA'],
genres:['War','History','Adventure','Action','Drama'],
director:['Peter Weir'],
actors:['Russell Crowe','Paul Bettany','Billy Boyd',"James D'Arcy",'Edward Woodall','Chris Larkin','Max Pirkis','Jack Randall','Max Benitz','Lee Ingleby','David Threlfall','Bryan Dick','Robert Pugh','Joseph Morgan','John DeSantis','Mark Lewis Jones','Patrick Gallagher','Richard McCabe','Ian Mercer','George Innes','William Mannering'],
basedOn:["Patrick O'Brian"],
screenplay:['Peter Weir','John Collee'],
production:['Peter Weir','Samuel Goldwyn Jr.','Duncan Henderson'],
music:['Christopher Gordon','Iva Davies','Richard Tognetti'],
camera:['Russell Boyd'],
cut:['Lee Smith'],
sound:['Richard King','Paul Massey','Doug Hemphill'],
scenography:['William Sandell','Robert Gould'],
masks:['Raúl Sarmiento','Edouard F. Henriques','John M. Elliott','Jr.','Yolanda Toussieng','Matthew W. Mungle','Greg Cannom','Kate Biscoe','Greg Funk','Brian McManus','Keith VanderLaan'],
costumes:['Wendy Stites']},
{title:'Flipped',
titleCZ:'Má mě rád, nemá mě rád',
year:2010,
runtime:90,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Rob Reiner'],
actors:['Madeline Carroll','Callan McAuliffe','Aidan Quinn','Penelope Ann Miller','John Mahoney','Anthony Edwards','Rebecca De Mornay','Morgan Lily','Cody Horn','Aramis Knight','Israel Broussard','Stefanie Scott','Alora Catherine Smith','Kevin Weisman','Shane Harper','Aaron Bledsoe','Kara Pacitto','Katelyn Pacitto','Taylor Groothuis'],
basedOn:['Wendelin Van Draanen'],
screenplay:['Rob Reiner','Andrew Scheinman'],
production:['Rob Reiner','Alan Greisman'],
music:['Marc Shaiman'],
camera:['Thomas Del Ruth'],
cut:['Robert Leighton'],
scenography:['Bill Brzeski','Danielle Berman'],
masks:['Dennis Liddiard'],
costumes:['Durinda Wood']},
{title:'Lords of Dogtown',
titleCZ:'Legendy z Dogtownu',
year:2005,
runtime:107,
countries:['USA','Germany'],
genres:['Drama','Sport','Biographic'],
director:['Catherine Hardwicke'],
actors:['John Robinson','Emile Hirsch','Victor Rasuk','Michael Angarano','Heath Ledger','Rebecca De Mornay','William Mapother','Julio Oscar Mechoso','Nikki Reed','Vincent Laresca','Pablo Schreiber','Elden Henson','Melonie Diaz','Matt Malloy','Kirk Ward','Eddie Cahill','Laura Ramsey','Chelsea Hobbs','Tony Hawk','America Ferrera','Johnny Knoxville','Ned Bellamy','Charles Napier','Stacy Peralta','Bai Ling','Shea Whigham','Alexis Arquette','Jeremy Renner','Eric West','Jeremiah Bitsui','Reef Karim','Allie McCulloch','Sofía Vergara','Joel McHale','Mitch Hedberg','Jay Adams','DeWalt Mix','Tim McIlrath','Rebeca Silva','Rene Rivera','Mark Kubr','Alexander Garcia','Benjamin Anderson','Bridgetta Tomarchio'],
screenplay:['Stacy Peralta'],
production:['John Linson'],
music:['Mark Mothersbaugh'],
camera:['Elliot Davis'],
cut:['Nancy Richardson'],
sound:['Tateum Kohut','Bob Beemer'],
scenography:['Chris Gorak','Gene Serdena'],
masks:['Deborah Rutherford','David LeRoy Anderson'],
costumes:['Cindy Evans']},
{title:'Room',
titleCZ:'Room',
year:2015,
runtime:118,
countries:['Ireland','Canada'],
genres:['Drama'],
director:['Lenny Abrahamson'],
actors:['Brie Larson','Jacob Tremblay','Sean Bridgers','Joan Allen','William H. Macy','Amanda Brugel','Cas Anvar','Jack Fulton','Megan Park','Tom McCamus',"Rory O'Shea",'Kate Drummond','Jee-Yun Lee','Randal Edwards','Rodrigo Fernandez-Stoll','Zarrin Darnell-Martin','Justin Mader','Celeste Bruno'],
basedOn:['Emma Donoghue'],
screenplay:['Emma Donoghue'],
production:['Ed Guiney','David Gross'],
music:['Stephen Rennicks'],
camera:['Danny Cohen'],
cut:['Nathan Nugent'],
sound:['Steve Fanagan'],
scenography:['Ethan Tobman','Mary Kirkland'],
costumes:['Lea Carlson']},
{title:'Disconnect',
titleCZ:'Odpojit',
year:2012,
runtime:116,
countries:['USA'],
genres:['Drama','Thriller'],
director:['Henry Alex Rubin'],
actors:['Frank Grillo','Alexander Skarsgård','Jason Bateman','Paula Patton','Michael Nyqvist','Andrea Riseborough','Hope Davis','Max Thieriot','Colin Ford','Jonah Bobo','John Sharian','Erin Wilhelmi','Kasi Lemmons','Haley Ramm','Alex Manette','Marc Jacobs','Ella Lentini','Norbert Leo Butz','Tessa Albertson','Erin Darke','Hristo Hristov','Hannah Loesch','Cailin Loesch','Kevin Csolak'],
screenplay:['Andrew Stern'],
production:['Mickey Liddell','William Horberg'],
music:['Max Richter'],
camera:['Ken Seng'],
cut:['Kevin Tent','Lee Percy'],
sound:['Paul Hsu'],
scenography:['Dina Goldman'],
masks:['Nicki Ledermann','Mia Neal'],
costumes:['Catherine George']},
{title:'Trinity: Gambling for High Stakes',
titleCZ:'Sudá a lichá',
year:1978,
runtime:109,
countries:['Italy','USA'],
genres:['Comedy','Crime','Action'],
director:['Sergio Corbucci'],
actors:['Terence Hill','Bud Spencer','Sal Borgese','Riccardo Pizzuti','Giovanni Cianfriglia','Luciano Catenacci','Claudio Ruffini','Mimmo Poli','Woody Woodbury','Giancarlo Bastianoni','Sergio Smacchi','Carlo Reali','Giuseppe Pedersoli','Salvatore Basile','Jerry Lester'],
screenplay:['Mario Amendola','Sergio Corbucci'],
music:['Maurizio De Angelis','Guido De Angelis'],
camera:['Luigi Kuveiller'],
cut:['Eugenio Alabiso','Amedeo Salfa'],
scenography:['Marco Dentici'],
costumes:['Franco Carretti']},
{title:'Only the Brave',
titleCZ:'Hrdinové ohně',
year:2017,
runtime:134,
countries:['USA'],
genres:['Drama','Biographic'],
director:['Joseph Kosinski'],
actors:['Josh Brolin','Miles Teller','Jeff Bridges','Jennifer Connelly','James Badge Dale','Taylor Kitsch','Andie MacDowell','Geoff Stults','Alex Russell','Thad Luckinbill','Ben Hardy','Scott Haze','Jake Picking','Dylan Kenin','Sam Quinn','Natalie Hall','Ralph Alderman','Forrest Fyre','Josh Hopkins','Jenny Gabrielle','Barbie Robertson','Pell James','Lauren Myers','Kevin Wiggins','Lora Martinez-Cunningham','Keith Jardine','Matt Nolan','Casey Messer','Sarah Minnich','Lulu Jovovich','J. Nathan Simmons','Michael L. McNulty','Kenneth Miller','Scott Foxx','Raleigh Cain','Brytnee Ratledge','Jermaine Washington','Matthew Van Wettering','John Trejo'],
screenplay:['Ken Nolan','Eric Warren Singer'],
production:['Lorenzo di Bonaventura','Molly Smith','Thad Luckinbill','Trent Luckinbill','Jeremy Steckler','Erik Howsam'],
music:['Joseph Trapanese'],
camera:['Claudio Miranda'],
cut:['Billy Fox'],
sound:['Bjørn Ole Schroeder','David Parker','Al Nelson','Lora Hirschberg'],
scenography:['Kevin Kavanaugh'],
masks:['John Caglione','Jr.'],
costumes:['Louise Mingenbach']},
{title:'The Dirty Dozen',
titleCZ:'Tucet špinavců',
year:1967,
runtime:145,
countries:['UK','USA'],
genres:['Action','War','Drama'],
director:['Robert Aldrich'],
actors:['Lee Marvin','Ernest Borgnine','Charles Bronson','Jim Brown','John Cassavetes','Richard Jaeckel','George Kennedy','Trini López','Ralph Meeker','Robert Ryan','Telly Savalas','Donald Sutherland','Clint Walker','Robert Webber','Tom Busby','Ben Carruthers','Stuart Cooper','Robert Phillips','Al Mancini','George Roubicek','Dora Reisser','Lewis Alexander','Alan Chuntz','Harold Coyne','Gary Files','Hal Galili','Willoughby Gray','Gerard Heinz','John G. Heller','George Hilsdon','John Hollis','Juba Kennerley','Eric Kent','Ann Lancaster','Aileen Lewis','Richard Marner','Dick Miller','Lionel Murton','Mike Reid','Terry Richards','Bunny Seaman','Jack Sharp','Richard Shaw','Warren Stanhope','Elliott Sullivan','John Tatum','Hedger Wallace','Theodore Wilhem','Vicki Woolf'],
basedOn:['E. M. Nathanson'],
screenplay:['Nunnally Johnson','Lukas Heller'],
production:['Kenneth Hyman'],
music:['Frank De Vol'],
camera:['Edward Scaife'],
cut:['Michael Luciano'],
sound:['Franklin Milton'],
masks:['Wally Schneiderman']},
{title:'Detachment',
titleCZ:'Oddělen',
year:2011,
runtime:97,
countries:['USA'],
genres:['Drama','Psychology'],
director:['Tony Kaye'],
actors:['Adrien Brody','Marcia Gay Harden','James Caan','Christina Hendricks','Lucy Liu','Blythe Danner','Tim Blake Nelson','Louis Zorich','William Petersen','Bryan Cranston','Sami Gayle','Betty Kaye','Doug E. Doug','Patricia Rae','John Cenatiempo','Samantha Logan','Ronen Rubinstein','Renée Felice Smith','Isiah Whitlock Jr.','Brennan Brown','Chris Papavasiliou','Celia Au','Mary Joy','Roslyn Ruff','April Maxey','Corwin C. Tuggles','Annabel Barrett','Al Calderon','Aaron Sauter','Alex Boniello'],
screenplay:['Carl Lund'],
production:['Bingo Gubelmann','Benji Kohn','Carl Lund','Chris Papavasiliou','Greg Shapiro','Austin Stark'],
music:['The Newton Brothers'],
camera:['Tony Kaye'],
cut:['Barry Alexander Brown','Geoffrey Richman'],
sound:['Christopher Koch'],
scenography:['Jade Healy']},
{title:'Bitter Moon',
titleCZ:'Hořký měsíc',
year:1992,
runtime:138,
countries:['UK','France'],
genres:['Drama','Romance','Thriller'],
director:['Roman Polański'],
actors:['Hugh Grant','Kristin Scott Thomas','Emmanuelle Seigner','Peter Coyote','Victor Banerjee','Stockard Channing','Patrick Albenque','Geoffrey Carey','Ysé Tran','Jim Adhi Limas','Daniel Dhubert','Olivia Brunaux','Robert Benmussa','Frédérique Lopez'],
basedOn:['Pascal Bruckner'],
screenplay:['Roman Polański','Gérard Brach','John Brownjohn'],
production:['Roman Polański'],
music:['Vangelis'],
camera:['Tonino Delli Colli'],
cut:['Hervé de Luze'],
sound:['Daniel Brisseau','Bill Rowe'],
scenography:['Willy Holt'],
masks:['Didier Lavergne'],
costumes:['Jackie Budin']},
{title:'The Covenant',
titleCZ:'The Covenant',
year:2023,
runtime:123,
countries:['UK','Spain'],
genres:['Action','Drama','Thriller','War'],
director:['Guy Ritchie'],
actors:['Jake Gyllenhaal','Dar Salim','Alexander Ludwig','Emily Beecham','Antony Starr','Bobby Schofield','Jonny Lee Miller','Sean Sagar','Jason Wong','James Nelson-Joyce','Rhys Yates','Christian Ochoa Lavernia','Reza Diako','Hadi Khanjanpour','Gary Anthony Stennette','Mo Ahmadi','Fariba Sheikhan','Altamasch Noor','Marcel Zadé','Swen Temmel','Fahim Fazli','Javier Ramos'],
screenplay:['Guy Ritchie','Ivan Atkinson','Marn Davies'],
production:['Guy Ritchie','Ivan Atkinson','John Friedberg'],
music:['Christopher Benstead'],
camera:['Ed Wild'],
cut:['James Herbert'],
sound:['Adrian Bell','Dominic Gibbs','Mark Taylor'],
scenography:['Martyn John','Florian Müller','David Temprano'],
masks:['Donald Mowat','Rubén Samos'],
costumes:['Loulou Bontemps']},
{title:'The Greatest Game Ever Played',
titleCZ:'Golfový sen',
year:2005,
runtime:120,
countries:['USA'],
genres:['Drama','Sport'],
director:['Bill Paxton'],
actors:['Stephen Dillane','Elias Koteas','Shia LaBeouf','Luke Askew','Luke Kirby','Michael Weaver','Peter Firth','Josh Flitter','Peyton List','Max Kasch','Len Cariou','Michael Sinelnikoff','Nicolas Wright','Matthew Knight','Jonathan Higgins','Jesse Rath','Stephen Marcus','James Paxton','David Rigby','Tom Rack','Arthur Holden','Joe Jackson',"Mike 'Nug' Nahrgang",'George Asprey','J. Thibodeau','Francesco Giannini','Tim Peper','Alexis del Vecchio','Walter Massey','Marnie McPhail','Amanda Tilson'],
basedOn:['Mark Frost'],
screenplay:['Mark Frost'],
production:['Larry Brezner','David Blocker'],
music:['Brian Tyler'],
camera:['Shane Hurlbut'],
cut:['Elliot Graham'],
sound:['Christian P. Minkler','Dean A. Zupancic','David E. Fluhr'],
scenography:['François Séguin'],
costumes:['Renée April']},
{title:'CODA',
titleCZ:'V rytmu srdce',
year:2021,
runtime:111,
countries:['USA'],
genres:['Drama'],
director:['Siân Heder'],
actors:['Emilia Jones','Eugenio Derbez','Troy Kotsur','Ferdia Walsh-Peelo','Daniel Durant','Marlee Matlin','Amy Forsyth','Kevin Chapman','John Fiore','Owen Burke','Erica McDermott','Armen Garo','Rebecca Gibel','Lonnie Farmer','Kayla Caulfield','Rena Maliszewski','Marilyn Busch'],
screenplay:['Siân Heder'],
production:['Philippe Rousselet','Patrick Wachsberger','Fabrice Gianfermi'],
music:['Marius De Vries'],
camera:['Paula Huidobro'],
cut:['Geraud Brisson'],
sound:['Paul Lucien Col','Alexandra Fehrman'],
scenography:['Vanessa Knoll'],
masks:['Michelle Connolly']},
{title:'Incendies',
titleCZ:'Požáry',
year:2010,
runtime:130,
countries:['Canada','France'],
genres:['Drama','Mystery','War'],
director:['Denis Villeneuve'],
actors:['Rémy Girard','Lubna Azabal','Mélissa Désormeaux-Poulin','Maxim Gaudette','Mohamed Majd','Ahmad Massad','Dominique Briand','Frédéric Paquet','Baya Belal','Nadia Essadiqi','Ahmad Srour','Baraka Rahmani'],
screenplay:['Denis Villeneuve','Valérie Beaugrand-Champagne','Wajdi Mouawad'],
production:['Luc Déry'],
music:['Grégoire Hetzel'],
camera:['André Turpin'],
cut:['Monique Dartonne'],
scenography:['André-Line Beauparlant'],
costumes:['Sophie Lefebvre']},
{title:'Take the Money and Run',
titleCZ:'Seber prachy a zmiz',
year:1969,
runtime:85,
countries:['USA'],
genres:['Comedy'],
director:['Woody Allen'],
actors:['Woody Allen','Janet Margolin','Jacquelyn Hyde','Lonny Chapman','Jan Merlin','Howard Storm','Louise Lasser','James Anderson','Mickey Rose','Roy Engel','Dan Frazer','Marcel Hillaire','Thomas Bellin','Mark Gordon','Jackson Beck'],
screenplay:['Woody Allen','Mickey Rose'],
production:['Charles H. Joffe','Jack Rollins'],
music:['Marvin Hamlisch'],
camera:['Fouad Said','Lester Shorr'],
cut:['Paul Jordan','Ron Kalish'],
sound:['Dick Vorisek','Bud Alper'],
scenography:['Marvin March']},
{title:'Fort Apache the Bronx',
titleCZ:'Pevnost Apačů v Bronxu',
year:1981,
runtime:121,
countries:['USA'],
genres:['Crime','Drama','Thriller','Action'],
director:['Daniel Petrie'],
actors:['Paul Newman','Edward Asner','Ken Wahl','Danny Aiello','Rachel Ticotin','Pam Grier','Kathleen Beller','Jamie Tirelli','Paul Gleason','Donald Petrie','Dominic Chianese','Frank Adu','Cleavant Derricks','Michael Higgins','Sully Boyar','Randy Jurgensen','Tony DiBenedetto','Daryl Edwards','Clifford David','Gilbert Lewis','Santos Morales','Tito Goya','Miguel Pinero','Thomas A. Carlin','Rony Clanton','Antone Pagán','Irving Metzman','Norman Matlock','John Pallotta'],
screenplay:['Heywood Gould'],
production:['Martin Richards'],
music:['Jonathan Tunick'],
camera:['John Alcott'],
cut:['Rita Roland'],
scenography:['Ben Edwards','Philip Smith'],
masks:['Monty Westmore'],
costumes:['John Boxer']},
{title:'The Crying Game',
titleCZ:'Hra na pláč',
year:1992,
runtime:112,
countries:['UK','USA','Japan'],
genres:['Crime','Drama','Thriller','Romance'],
director:['Neil Jordan'],
actors:['Stephen Rea','Miranda Richardson','Forest Whitaker','Adrian Dunbar','Jaye Davidson','Andrée Bernard','Jim Broadbent','Ralph Brown','Bryan Coleman','Tony Slattery','Des Lynam','Joe Savino'],
screenplay:['Neil Jordan'],
production:['Stephen Woolley'],
music:['Anne Dudley'],
camera:['Ian Wilson'],
cut:['Kant Pan'],
sound:['Eddy Joseph','Colin Nicolson'],
scenography:['Jim Clay'],
masks:['Daniel Parker','Morag Ross'],
costumes:['Sandy Powell']},
{title:"I'm the Angel of Death: Pusher III",
titleCZ:'Dealer 3',
year:2005,
runtime:90,
countries:['Denmark'],
genres:['Crime','Drama','Thriller'],
director:['Nicolas Winding Refn'],
actors:['Zlatko Burić','Slavko Labovic','Ramadan Huseini','Marinela Dekic','Kurt Nielsen','Levino Jensen','Ilyas Agac','Marek Magierecki'],
screenplay:['Nicolas Winding Refn'],
production:['Henrik Danstrup'],
music:['Peter Peter'],
camera:['Morten Søborg'],
cut:['Anne Østerud','Miriam Nørgaard'],
sound:['Mikkel Groos','Jens Bønding'],
scenography:['Rasmus Thjellesen'],
masks:['Bjørg Serup'],
costumes:['Jane Whittaker']},
{title:'The Front Page',
titleCZ:'Na titulní straně',
year:1974,
runtime:105,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Billy Wilder'],
actors:['Jack Lemmon','Walter Matthau','Susan Sarandon','Vincent Gardenia','David Wayne','Allen Garfield','Austin Pendleton','Charles Durning','Herb Edelman','Martin Gabel','Harold Gould','Cliff Osmond',"Dick O'Neill",'Jon Korkes','Lou Frizzell','Paul Benedict','Doro Merande','Noam Pitlik','Joshua Shelley','Allen Jenkins','John Furlong','Biff Elliot','Leonard Bremen','Carol Burnett','Bob Harks'],
screenplay:['Billy Wilder','I.A.L. Diamond','Ben Hecht','Charles MacArthur'],
production:['Paul Monash'],
camera:['Jordan Cronenweth'],
cut:['Ralph E. Winters'],
scenography:['Henry Bumstead','James W. Payne'],
costumes:['Burton Miller']},
{title:'Children of a Lesser God',
titleCZ:'Bohem zapomenuté děti',
year:1986,
runtime:114,
countries:['USA'],
genres:['Drama','Romance'],
director:['Randa Haines'],
actors:['William Hurt','Marlee Matlin','Piper Laurie','Philip Bosco','Allison Gompf','John F. Cleary','Philip Holmes','Georgia Ann Cline','William D. Byrd','Frank Carter Jr.','John Limnidis','James Carrington','Archie Hahn','Nicholas Guest','Gigi Vorgan','Lynne Marie Stewart','E. Katherine Kerr','Leigh French','Jack Blessing'],
screenplay:['Hesper Anderson','Mark Medoff','Mark Medoff'],
production:['Patrick J. Palmer','Burt Sugarman'],
music:['Michael Convertino'],
camera:['John Seale'],
cut:['Lisa Fruchtman'],
sound:['Steve Maslow'],
scenography:['Gene Callahan','Rose Marie McSherry'],
masks:['Ann Brodie'],
costumes:['Renée April']},
{title:'The Right Stuff',
titleCZ:'Správná posádka',
year:1983,
runtime:193,
countries:['USA'],
genres:['Adventure','Drama'],
director:['Philip Kaufman'],
actors:['Sam Shepard','Scott Glenn','Ed Harris','Dennis Quaid','Fred Ward','Barbara Hershey','Kim Stanley','Veronica Cartwright','Pamela Reed','Scott Paulin','Charles Frank','Lance Henriksen','Donald Moffat','Mary Jo Deschanel','Levon Helm','Scott Wilson','Kathy Baker','Jeff Goldblum','Harry Shearer','David Gulpilil','Mimi Sarkisian','William Russ','Royal Dano','John P. Ryan','Christopher Kriesa','David Clennon','Jurij Alexejevič Gagarin','Lyndon B. Johnson','O-Lan Jones','Jim Haynie','John Dehner','Edward Anhalt','Darryl Henriques','Scott Beach','Mary Apick','Michael Pritchard','Alan Bendich'],
basedOn:['Tom Wolfe'],
screenplay:['Philip Kaufman'],
production:['Irwin Winkler','Robert Chartoff'],
music:['Bill Conti'],
camera:['Caleb Deschanel'],
cut:['Stephen A. Rotter','Douglas Stewart','Tom Rolf','Lisa Fruchtman','Glenn Farr'],
sound:['Randy Thom'],
scenography:['Geoffrey Kirkland','George R. Nelson','Jim Poynter']},
{title:'The Castle of Cagliostro',
titleCZ:'Lupin sansei: Cagliostro no širo',
year:1979,
runtime:102,
countries:['Japan'],
genres:['Animation','Adventure','Comedy'],
director:['Hajao Mijazaki'],
actors:['Jasuo Jamada','Ičiró Nagai','Eiko Masujama','Michael Gregory','Sumi Šimamoto','Kijoši Kobajaši','Makio Inoue','Minoru Midorikawa','Kóhei Mijauči','Goró Naja','Kazuo Tokumicu','Mikio Terašima','Kinpei Azusa','Taró Išida','Jóko Jamaoka','Šózó Hirabajaši'],
basedOn:['Monkey Punch'],
screenplay:['Hajao Mijazaki','Haruja Jamazaki'],
music:['Júdži Óno'],
camera:['Hirokata Takahaši'],
cut:['Masatoši Curubuči'],
scenography:['Šičiró Kobajaši']},
{title:"Where Is the Friend's Home?",
titleCZ:'Kde je dům mého přítele?',
year:1987,
runtime:83,
countries:['Iran'],
genres:['Drama'],
director:['Abbas Kiarostami'],
actors:['Babek Ahmed Poor','Ahmed Ahmed Poor','Kheda Barech Defai','Iran Outari','Ait Ansari','Sadika Taohidi','Biman Mouafi','Ali Djamali','Aziz Babai','Nader Ghoulami','Akbar Mouradi','Teba Slimani','Mohamed Reza Parvaneh'],
screenplay:['Abbas Kiarostami'],
production:['Ali Reza Zarrin'],
music:['Amine Allah Hessine'],
camera:['Farhad Saba'],
cut:['Abbas Kiarostami']},
{title:'Godzilla Minus One',
titleCZ:'Godzilla Minus One',
year:2023,
runtime:125,
countries:['Japan'],
genres:['Action','Adventure','Drama','Horror','Sci-Fi','Catastrophic'],
director:['Takaši Jamazaki'],
actors:['Rjúnosuke Kamiki','Minami Hamabe','Júki Jamada','Munetaka Aoki','Hidetaka Jošioka','Sakura Andó','Kuranosuke Sasaki','Mió Tanaka','Júja Endó','Kisuke Iida','Sae Nagatani','Cubaki Ómura'],
screenplay:['Takaši Jamazaki'],
production:['Minami Ičikawa','Kenji Yamada'],
music:['Naoki Sató'],
camera:['Kózó Šibasaki']},
{title:'Violet Evergarden the Movie',
titleCZ:'Violet Evergarden: film',
year:2020,
runtime:140,
countries:['Japan'],
genres:['Drama','Animation','Romance'],
director:['Taiči Išidate'],
actors:['Jui Išikawa','Daisuke Namikawa','Júki Sanpei','Kóki Učijama','Aja Endó','Takehito Kojasu','Sumire Morohoši','Hidenobu Kiuči','Minori Čihara','Haruka Tomacu','Kaori Mizuhaši','Rina Sató','Kozue Harašima','Aja Saitó'],
basedOn:['Kana Akacuki'],
screenplay:['Reiko Jošida'],
production:['Megumi Suzuki','Šigeru Saitó'],
music:['Evan Call'],
camera:['Kohei Funamoto'],
cut:['Kengo Šigemura'],
sound:['Jóta Curuoka'],
scenography:['Mikiko Watanabe']},
{title:'Long Live Ghosts!',
titleCZ:'Ať žijí duchové!',
year:1977,
runtime:80,
countries:['Czechoslovakia'],
genres:['Family','Comedy','Musical','Fantasy'],
director:['Oldřich Lipský'],
actors:['Dana Vávrová','Jiří Procházka','Jiří Sovák','Vlastimil Brodský','Lubomír Lipský st.','Věra Tichánková','Petr Starý','Igor Nachtigal','David Vlček','Tomáš Holý','Jiří Brož','Jiří Bruder','Adolf Filip','Ladislav Šimek','Pavlína Serbusová','Stanislava Coufalová','Bohumil Luxík','Richard Hes','Josef Bek','Míla Myslíková','Karel Effa','Jana Werichová-Kvapilová','Jiřina Bílá','Lucie Klégrová','Jan Gottlieb','Zdena Kvapilová','Ivana Blanářová','Blažena Slavíčková','Růžena Dvorská','D. Valentová','Lucie Krátká','Renáta Oždianová','Milan Hanák','Robert Kučera','Petr Vacek','Erich Fichtner','Zdeněk Srstka','Bohumil Koška','Lubomír Bryg','Slávka Hamouzová','Vlasta Žehrová','Tereza Brodská','Milada Ježková','Zdeněk Zapletal','Vladimír Bárta','Zdeněk Binko','Arnošt Böhm','Jan Brokl','Miroslav Brokl','Josef Brož','Vladimír Čumpelík','Václav Damašek','Jiří Dolejš','Bedřich Doležal','Petr Drozda','Zlatomil Fabinyi','Jiří Fajt','Jiří Flíček','Jan Geschmay','Josef Hejzlar','Richard Höfer','Václav Horák','Ladislav Hrabě','Josef Hrubý','Miroslav Chochola','František Jákl','Arnošt Janeček','Martin Janský','Zdeněk Jezerský','Miroslav Jíra','Jiří Kasík','Jiří Kelbl','Jaroslav Klenot','Jiří Klenot','Petr Klír','Josef Kočí','Jiří Kosek','Zbyněk Krákora','Antonín Kramerius','Pavel Kudláček','Ladislav Lahoda','Jaromír Lauer','Pavel Matějka','Zdeněk Menger','Jiří Němec','Václav Pešák','Pavel Petřikov','Zdeněk Plavec','Radek Podrabský','Petr Popelák','Miroslav Pospíšil','Vladimír Procházka','Stanislav Sedlařík','Jindřich Sejk','Oldřich Semerák','Jiří Sládek','Karel Slepička','Jaroslav Šanda','Vilém Šefl','Jaroslav Šimonka'],
screenplay:['Zdeněk Svěrák','Jiří Melíšek'],
music:['Jaroslav Uhlíř'],
camera:['Jan Němeček'],
cut:['Miroslav Hájek'],
sound:['Jiří Lenoch'],
scenography:['Vladimír Labský'],
masks:['František Čížek'],
costumes:['Theodor Pištěk ml.']},
{title:'Ready Player One',
titleCZ:'Ready Player One: Hra začíná',
year:2018,
runtime:140,
countries:['USA','India'],
genres:['Action','Sci-Fi','Adventure'],
director:['Steven Spielberg'],
actors:['Tye Sheridan','Olivia Cooke','Ben Mendelsohn','Lena Waithe','Mark Rylance','Simon Pegg','T.J. Miller','Philip Zhao','Win Morisaki','Hannah John-Kamen','Ralph Ineson','Susan Lynch','Clare Higgins','Laurence Spellman','Perdita Weeks','Kit Connor','Ronke Adekoluejo','Sandra Dickinson','Lynne Wilmot','Jayden Fowora-Knight','Elliot Barnes-Worrell','Letitia Wright','Kae Alexander','Turlough Convery','Joe Hurst','Tom Turner','Paul Barnhill','Georgie Farmer','Lulu Wilson','Mckenna Grace','Arianna Jaffier','Armani Jackson','Jacob Bertrand','Daniel Zolghadri','Cara Pifko','Cara Theobold','Blake Ridder','Elisa Perry','Violet McGraw','Kathryn Wilder','Julian Edwards','Britain Dalton','James Dryden','Amanda LaCount','Alicia Shenreice','Antonio Mattera','Annarie Boor','Rona Morison','Jadah Marie','Dallas Dupree Young','Sydney Brower','Michael Wildman','Gloria Garcia','Racheal Ofori','Steven Peace'],
basedOn:['Ernest Cline'],
screenplay:['Zak Penn','Ernest Cline'],
production:['Steven Spielberg','Donald De Line','Dan Farah','Kristie Macosko Krieger'],
music:['Alan Silvestri'],
camera:['Janusz Kamiński'],
cut:['Michael Kahn'],
sound:['Richard Hymns','Andy Nelson','Gary Rydstrom','Pedro Sánchez Alonso'],
scenography:['Adam Stockhausen','Guy Bradley','Gavin Fitch','Anna Pinnock'],
masks:['Kenny Myers','Nora Robertson','Mark Coulier','David Malinowski','Zoe Tahir'],
costumes:['Kasia Walicka-Maimone']},
{title:'Spider-Man: No Way Home',
titleCZ:'Spider-Man: Bez domova',
year:2021,
runtime:148,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Jon Watts'],
actors:['Tom Holland','Zendaya','Benedict Cumberbatch','Jacob Batalon','Jon Favreau','Jamie Foxx','Willem Dafoe','Alfred Molina','Benedict Wong','Tony Revolori','Marisa Tomei','Andrew Garfield','Tobey Maguire','Angourie Rice','Arian Moayed','Paula Newsome','Hannibal Buress','Martin Starr','J.B. Smoove','J.K. Simmons','Rhys Ifans','Charlie Cox','Thomas Haden Church','Ben VanderMey','Gary Weeks','Gregory Konow','Carol Dines','Glenn Keogh','Tom Hardy','Cristo Fernández','Regina Ting Chen','Jwaundace Candece','Jake Gyllenhaal','Jorge Lendeborg Jr.','José Alfredo Fernandez','Paris Benjamin','Marvin E. West','Rudy Eisenzopf'],
basedOn:['Steve Ditko','Stan Lee'],
screenplay:['Chris McKenna','Erik Sommers'],
production:['Kevin Feige','Amy Pascal'],
music:['Michael Giacchino'],
camera:['Mauro Fiore'],
cut:['Leigh Folsom Boyd','Jeffrey Ford'],
sound:["Kevin O'Connell",'Tony Lamberti','Vinii Khullar'],
scenography:['Darren Gilford','Emmanuelle Hoessly','Rosemary Brandenburg'],
masks:['Tim Muir'],
costumes:['Anna Biedrzycka-Sheppard']},
{title:'The Exorcist',
titleCZ:'Vymítač ďábla',
year:1973,
runtime:122,
countries:['USA'],
genres:['Horror'],
director:['William Friedkin'],
actors:['Ellen Burstyn','Linda Blair','Jason Miller','Max von Sydow','Lee J. Cobb','Kitty Winn',"William O'Malley",'Jack MacGowran','Barton Heyman','Peter Masterson','Mercedes McCambridge','Ron Faber','Roy Cooper','William Peter Blatty','Eileen Dietz','Robert Symonds','Donna Mitchell','Mary Boylan','Robert Gerringer','John Mahon','Titos Vandis','Wallace Rooney'],
basedOn:['William Peter Blatty'],
screenplay:['William Peter Blatty'],
production:['William Peter Blatty'],
music:['Jack Nitzsche'],
camera:['Owen Roizman'],
cut:['Evan A. Lottman','Norman Gay'],
sound:['Jean-Louis Ducarme','Richard King'],
scenography:['Bill Malley','Jerry Wunderlich'],
masks:['Dick Smith','Bob Laden'],
costumes:['Joseph Fretwell III']},
{title:"Breakfast at Tiffany's",
titleCZ:'Snídaně u Tiffanyho',
year:1961,
runtime:115,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Blake Edwards'],
actors:['Audrey Hepburn','George Peppard','Patricia Neal','Buddy Ebsen','Martin Balsam','José Luis de Vilallonga','John McGiver','Stanley Adams','Elvia Allman','Alan Reed','Beverly Powers','Claude Stroud','Mickey Rooney','Don Anderson','Henry Beckman','Nicky Blair','Mel Blanc','Sue Casey','Roydon Clark','Marian Collier','Dick Crockett','Tommy Farrell','Joe Gray','Joseph J. Greene','Sam Harris','Hanna Hertelendy','Pete Kellett','Kip King','Gil Lamb','James Lanphier','Mike Mahoney','Frank Marth','Fay McKenzie','William Meader','Joyce Meadows','Harold Miller','Kate Murtagh','Bill Neff','Chuck Niles','Robert Patten','Tony Regan','Charles Sherlock','Helen Spring','Joan Staley','Glen Vernon','Wilson Wood','Richard Wyler','Michael Zaslow','kocour Orangey','Nino Tempo'],
basedOn:['Truman Capote'],
screenplay:['George Axelrod'],
production:['Martin Jurow','Richard Shepherd'],
music:['Henry Mancini'],
camera:['Franz Planer','Philip H. Lathrop'],
cut:['Howard A. Smith'],
sound:['Hugo Grenzbach','John Wilkinson','Richard Gramaglia'],
scenography:['Hal Pereira','Roland Anderson','Sam Comer','Ray Moyer'],
masks:['Wally Westmore'],
costumes:['Edith Head']},
{title:'La Vie En Rose',
titleCZ:'Edith Piaf',
year:2007,
runtime:140,
countries:['France','UK','Czechia'],
genres:['Drama','Biographic','Music'],
director:['Olivier Dahan'],
actors:['Marion Cotillard','Sylvie Testud','Pascal Greggory','Emmanuelle Seigner','Jean-Paul Rouve','Gérard Depardieu','Clotilde Courau','Jean-Pierre Martins','Pavlína Němcová','Marc Barbé','Caroline Sihol','Manon Chevallier','Pauline Burlet','Dominique Bettenfeld','Jan Pavel Filipenský','Diana Stewart','Jaroslav Vízner','Garrick Hagon','Vladimír Javorský','Denis Ménochet','Laurence Gormezano','Robert Nebřenský','Anika Julien','Alban Casterman','Lana Likic','Lucie Březovská','Jan Kuželka','Helena Gabrielová','Christopher Gunning','Catherine Allégret','Zdena Herfortová','Věra Havelková','Martin Sochor','Marek Vašut','Gérard Robert Gratadour','Dominique Paturel','Alain Figlarz','Petr Florián','Laurent Olmedo','André Penvern','Karel Dobrý','Christophe Odent','Marc Chapiteau','Nicholas Pritchard','Valérie Moreau','Olivier Cruveiller','Fedele Papalia','Farida Amrouche','Thierry Gibault','Édith Le Merdy','Jean-Paul Muel','Nathalie Cox','Pierre Derenne','Aubert Fenoy','Jaromír Janeček','Chantal Bronner','Liliane Cebrian','Marie-Armelle Deguy','Harry Hadden-Paton','Élisabeth Commelin','Christophe Kourotchkine','Laura Stainkrycer','Jean-Luc Julien','Cylia Malki','Eric Franquelin','Caroline Raynaud','Ryan McBay','Sylvie Guichenuy','Josette Ménard','Lara Menini','Pascal Mottier','Ashley Wanninger','Pierre Peyrichout'],
screenplay:['Olivier Dahan'],
production:['Alain Goldman'],
camera:['Tecuo Nagata'],
cut:['Richard Marizy'],
sound:['Laurent Zeilig','Marc Doisne'],
scenography:['Beatrice Brentnerová'],
masks:['Didier Lavergne','David White','Matthew Smith','Loulia Sheppard'],
costumes:['Marit Allen']},
{title:'Tarzan',
titleCZ:'Tarzan',
year:2013,
runtime:94,
countries:['Germany'],
genres:['Animation','Family','Adventure'],
director:['Reinhard Klooss'],
actors:['Kellan Lutz','Spencer Locke','Jaime Ray Newman','Robert Capron','Brian Bloom','Mark Deklin','Brian Huskey','Jeff Burrell','Jason Hildebrandt','Christian Serritiello','Craig Garner','Martin Cambeis','Maximilian Allgeier','Rebecca Reaney','Lilly Gropper','Joe Cappelletti'],
basedOn:['Edgar Rice Burroughs'],
screenplay:['Jessica Postigo','Reinhard Klooss'],
production:['Robert Kulzer','Martin Moszkowicz'],
music:['David Newman'],
camera:['Markus Eckert'],
cut:['Alexander Dittner'],
sound:['Stefan Busch','Heiko Müller','Christoph Merkele','Michael Kranz','Chris Rebay','Markus Stemler']},
{title:'Dangerous Liaisons',
titleCZ:'Nebezpečné známosti',
year:1988,
runtime:115,
countries:['USA','UK'],
genres:['Drama','Romance'],
director:['Stephen Frears'],
actors:['Glenn Close','John Malkovich','Michelle Pfeiffer','Swoosie Kurtz','Keanu Reeves','Mildred Natwick','Uma Thurman','Peter Capaldi','Harry Jones','Joe Sheridan','César Lucendo','François Lalande','Laura Benson','Nicholas Hawtrey','François Montagut'],
basedOn:['Choderlos de Laclos'],
screenplay:['Christopher Hampton','Christopher Hampton'],
production:['Norma Heyman','Hank Moonjean'],
music:['George Fenton'],
camera:['Philippe Rousselot'],
cut:['Mick Audsley'],
scenography:['Stuart Craig'],
masks:['Pierre Vadé'],
costumes:['James Acheson']},
{title:'Baron Munchhausen',
titleCZ:'Když Burian prášil',
year:1940,
runtime:93,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Martin Frič'],
actors:['Vlasta Burian','Meda Valentová','Zorka Janů','Anna Steimarová','Oldřich Nový','Jaroslav Marvan','Ella Nollová','Čeněk Šlégl','František Roland','Václav Trégl','Theodor Pištěk','Karel Černý','Karel Postranecký','František Filipovský','Jan W. Speerger','Dalibor Pták','Vladimír Smíchovský','Antonín Mikulič','Josef Sládek'],
screenplay:['Václav Wasserman'],
music:['Julius Kalaš'],
camera:['Václav Hanuš'],
cut:['Jan Kohout'],
sound:['František Šindelář']},
{title:'A Town Called Panic',
titleCZ:'Panika v městečku',
year:2009,
runtime:74,
countries:['Belgium','France','Luxembourg'],
genres:['Animation','Comedy','Adventure','Family'],
director:['Stéphane Aubier','Vincent Patar'],
actors:['Stéphane Aubier','Jeanne Balibar','Bouli Lanners','Vincent Patar','Benoît Poelvoorde','Nicolas Buysse','Alexandre von Sivers','Ben Tesseur','Brian Lykke'],
screenplay:['Stéphane Aubier','Vincent Patar'],
production:['Vincent Tavier','Stéphan Roelants'],
camera:['Jan Vandenbussche'],
cut:['Anne-Laure Guégan'],
sound:['Valène Leroy','Julien Paschal']},
{title:'Sabrina',
titleCZ:'Sabrina',
year:1995,
runtime:122,
countries:['USA','Germany'],
genres:['Comedy','Romance','Drama'],
director:['Sydney Pollack'],
actors:['Harrison Ford','Julia Ormond','Greg Kinnear','Nancy Marchand','John Wood','Richard Crenna','Angie Dickinson','Lauren Holly','Dana Ivey','Miriam Colon','Elizabeth Franz','Fanny Ardant','Valérie Lemercier','Patrick Bruel','Becky Ann Baker','Paul Giamatti','John C. Vennema','Gregory Chase','Margo Martindale','J. Smith-Cameron','Denis Holmes','Ira Wheeler','Ajako Kawahara','Guillaume Gallienne','Inés Sastre','Carmen Chaplin','Patrick Forster-Delmas','Ronald L. Schwary','Phil Nee','Michael Cline'],
screenplay:['Barbara Benedek','David Rayfiel','Billy Wilder','Samuel A. Taylor','Ernest Lehman','Samuel A. Taylor'],
production:['Scott Rudin','Sydney Pollack'],
music:['John Williams'],
camera:['Giuseppe Rotunno'],
cut:['Fredric Steinkamp'],
sound:['Adam Jenkins','Scott Millan'],
scenography:['Brian Morris','George DeTitta Jr.'],
masks:['Bernadette Mazur'],
costumes:['Ann Roth']},
{title:'Kler',
titleCZ:'Klér',
year:2018,
runtime:132,
countries:['Poland'],
genres:['Drama'],
director:['Wojciech Smarzowski'],
actors:['Arkadiusz Jakubik','Robert Więckiewicz','Jacek Braciak','Janusz Gajos','Joanna Kulig','Adrian Zaremba','Ignacy Klim','Michał Gadomski','Katarzyna Chlebny','Iwona Bielska','Bartosz Tryboń','Kamil Panas','Robert Wabich','Sebastian Perdek','Roman Skorovskiy','Izabela Kuna','Mia Goti','Wojciech Urbański','Helena Sujecka','Kuba Dyniewicz','Przemysław Redkowski','Jan Nosal','Anna Szymańczyk','Mateusz Więcławek','Paweł Kumięga','Bartosz Kopeć','Jarosław Gruda','Marta Waldera','Jakub Wróblewski','Magdalena Smalara','Stanisław Brejdygant','Michał Jarmicki','Jacek Beler','Zacharjasz Muszyński','Wojciech Frycz','Marcin Rychcik','Mariusz Zaniewski','Mikołaj Kubacki','Robert Krajewski','Mieczysław Ostroróg','Rafał Mohr','Delfina Wilkońska','Agnieszka Matysiak','Ewa Serwa','Miłosz Kwiecień','Albert Lach','Przemysław Strojkowski','Robert Rogalski','Miroslaw Haniszewski','Bartłomiej Firlet','Bartłomiej Topa','Juliusz Chrząstowski','Bartłomiej Bobrowski','Włodzimierz Matuszak','Piotr Różański','Andrzej Słabiak','Stanisław Szelc','Leszek Zdybał','Joanna Aleksandrowicz','Tomasz Augustynowicz','Olga Bończyk','Marcin Czarnik','Anna Grycewicz','Paweł Kowalczyk','Katarzyna Krzanowska','Piotr Michalski','Sebastian Pawlak','Jagoda Pietruszkówna','Piotr Pilitowski','Adam Serowaniec','Natalia Sikora','Iwona Sitkowska','Rafał Trzaska','Maja Wachowska','Julia Wyszyńska','Karol Piotr Zapała','Katarzyna Herman','Henryk Talar','Wojciech Duryasz','Zbigniew Waleryś','Andrzej Konopka','Michał Sitarski','Grzegorz Mikołajczyk','Bartosz Bielenia','Ryszard Łukowski','Marek Kossakowski','Andrzej Deskur','Elżbieta Jarosik','Mirosław Kropielnicki','Marek Jera','Izabela Kapiasová','Vladimír Javorský','Leonardo Lacaria','Dariusz Toczek','Aleksandra Terpińska','Olaf Marchwicki','Matylda Baczyńska','Antoni Barłowski','Marek Bogucki','Bohdan Graczyk'],
screenplay:['Wojciech Rzehak','Wojciech Smarzowski'],
production:['Jacek Rzehak'],
music:['Mikołaj Trzaska'],
camera:['Tomasz Madejski'],
cut:['Paweł Laskowski'],
sound:['Radosław Ochnio'],
scenography:['Jagna Janicka'],
costumes:['Magdalena Rutkiewicz']},
{title:'On the Waterfront',
titleCZ:'V přístavu',
year:1954,
runtime:108,
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Elia Kazan'],
actors:['Marlon Brando','Karl Malden','Lee J. Cobb','Rod Steiger','Pat Henning','Leif Erickson','John F. Hamilton','Eva Marie Saint','James Westerfield','Tony Galento','Fred Gwynne','Nehemiah Persoff','Martin Balsam','Pat Hingle','Michael V. Gazzo','Don Blackman','Rudy Bond','Johnny Seven','Tiger Joe Marsh','David Saber','Dean Cromer','Barbara Woodell','Katherine MacGregor','Abe Simon','Danni Sue Nolan','Barry Macollum','Nancy Evans'],
screenplay:['Budd Schulberg'],
production:['Sam Spiegel'],
music:['Leonard Bernstein'],
camera:['Boris Kaufman'],
cut:['Gene Milford'],
scenography:['Richard Day']},
{title:'The Keeper',
titleCZ:'Brankář',
year:2018,
runtime:120,
countries:['Germany','UK'],
genres:['Biographic','Drama','Romance','Sport'],
director:['Marcus H. Rosenmüller'],
actors:['David Kross','Freya Mavor','John Henshaw','Harry Melling','Michael Socha','Julian Sands','Dave Johns','Barbara Young','Chloe Harris','Mikey Collins','Gary Lewis','Dervla Kirwan','Angus Barnett','Butz Ulrich Buse','David Schütter','Shenja Lacher','Lukas Turtur','Ian T. Dickinson','Daniel Holzberg','Jesse Inman','Shaun Lawton','Alex Tondowski','Thomas Lettow','Steve Hudson','Maximilian Befort','Florian Kroop','Martin Walch','Ryan Wichert','Pete Riley','Lukas Benjamin Engel','Achim Bogdahn','Stephan Buschmann','Henri A. Tomic'],
screenplay:['Marcus H. Rosenmüller','Nicholas J. Schofield'],
production:['Steve Milne','Robert Marciniak','Chris Curling'],
music:['Gerd Baumann'],
camera:['Daniel Gottschalk'],
cut:['Alexander Berner'],
sound:['Benjamin Rosenkind','Michael Vetter'],
scenography:['Johannes Sternagel','Doerthe Komnick','Michael Binzer'],
masks:['Tatjana Krauskopf','Claudia Stolze','Kurosch-Oliver Akhavan','Sascha Kolmikow'],
costumes:['Anke Winckler']},
{title:'Flood',
titleCZ:'Potopa',
year:2007,
runtime:94,
countries:['UK','Canada','South African republic'],
genres:['Action','Drama'],
director:['Tony Mitchell'],
actors:['Robert Carlyle','Jessalyn Gilsig','Tom Courtenay','David Suchet','Nathalie Boltt','Giorgio Lupano','Joanne Whalley','Tom Hardy','Susan Wooldridge','Gottfried John','Nigel Planer','Jason Cope','Ralph Brown','Jeremy Crutchley','David Hayman','Peter Wight','Andy Callaghan','Cecilia Dazzi','Jaqui Pickering','Moira Lister','Quanita Adams','Forbes KB','Lasco Atkins','Joe Vaz','Bart Fouche','Anthony Oseyemi','Tobias James-Samuels','Chris Wilson','Poppy Miller','Julie Summers','Andre Jacobs','Gary Green'],
basedOn:['Richard Doyle'],
screenplay:['Justin Bodle','Matthew Cope','Nick Morley'],
production:['Genevieve Hofmeyr'],
music:['Debbie Wiseman'],
camera:['Pierre Jodoin'],
cut:['Simon Webb','Annie Ilkow'],
sound:['Steven Gurman','Colin Nicolson'],
scenography:['Jonathan Lee'],
costumes:['Kate Carin']},
{title:'Before the Rain',
titleCZ:'Před deštěm',
year:1994,
runtime:113,
countries:['Macedonia','France','UK'],
genres:['Drama','War'],
director:['Milčo Mančevski'],
actors:['Katrin Cartlidge','Rade Šerbedžija','Grégoire Colin','Labina Mitevska','Phyllida Law','Meto Jovanovski','Daniel Newman','Vladimir Jacev','Josif Josifovski','Boris Delcevski','Dejan Velkov','Kiril Ristoski','Mladen Krstevski','Dzemail Maksut','Mile Jovanovski','Milica Stojanova','Petar Mircevski','Ljupco Bresliski','Igor Madzirov','Kiril Psaltirov','Ilko Stefanovski','Blagoja Spirkovski-Dzumerko','Sando Monev','Suzana Kirandziska','Katherina Kocevska','Vladimir Endrovski','Abdurrahman Shala','Atila Klince','Arben Kastrati','Gabrielle Hamilton','Simeon Moni Damevski','Ljupcho Todorovski','Peter Needham','Melissa Wilkes','Joe Gould','Rod Woodruff','Aleksandar Mikic','Cvetko Mareski','Goran','Silvija Stojanovska','Nino Levi','Lence Delova','Jordan Vitanov','Jay Villiers'],
screenplay:['Milčo Mančevski'],
production:['Judy Counihan','Cédomir Kolar','Sam Taylor','Cat Villiers'],
music:['Dragan Dautovski','Zlatko Origjanski','Zoran Spasovski','Goran Trajkoski'],
camera:['Manuel Teran'],
cut:['Nicolas Gaster'],
scenography:['Sharon Lomofsky','David Munns'],
masks:['Morag Ross'],
costumes:['Caroline Harris']},
{title:'Demon Slayer the Movie: Mugen Train',
titleCZ:'Gekidžóban Kimecu no Jaiba: Mugen Rešša Hen',
year:2020,
runtime:117,
countries:['Japan'],
genres:['Animation','Action','Fantasy','Comedy'],
director:['Haruo Sotozaki'],
actors:['Nacuki Hanae','Akari Kitó','Hiro Šimono','Satoši Hino','Jošicugu Macuoka','Júja Hirose','Daisuke Hirakawa','Akira Išida','Tomokazu Sugita',"Ken'iči Suzumura",'Konomi Kohara','Hóko Kuwašima','Aoi Koga','Kaede Hondo','Jó Taiči',"Šin'ičiró Miki",'Saori Hajami','Megumi Tojoguči',"Džun'ja Enoki",'Tomokazu Seki','Takahiro Sakurai','Rina Sató','Tošijuki Morikawa','Kacujuki Koniši','Hibiku Jamamura','Sajaka Senbongi','Micuki Nakae','Takuja Eguči','Džun Kasama','Šúgo Nakamura',"Šin'ja Takahaši",'Saeko Akiho'],
basedOn:['Kojoharu Gotóge'],
production:['Masanori Mijake'],
music:['Juki Kadžiura','Gó Šiina'],
camera:['Júiči Terao'],
cut:['Manabu Kamino'],
scenography:['Kódži Etó','Juri Kabasawa','Masaru Janaka']},
{title:'Chernobyl',
titleCZ:'Černobyl',
year:2019,
runtime:'5h 11min',
episodeRuntime:'59-65min',
countries:['USA','UK'],
genres:['Drama','History'],
director:['Johan Renck'],
actors:['Jared Harris','Stellan Skarsgård','Emily Watson','Jessie Buckley','Paul Ritter','Adam Nagaitis','Robert Emms','Sam Troughton',"Con O'Neill",'Adrian Rawlins','Alan Williams','David Dencik','Barry Keoghan','Karl Davies','Michael Socha','Ralph Ineson','Mark Lewis Jones','Fares Fares','Michael McElhatton','Alex Ferns','Donald Sumpter','Adam Lundgren','Billy Postlethwaite','Joe Tucker','Philip Barantini','James Cosmo','Gerard Kearns','Lucy Speed','Peter Guinness','Michael Shaeffer','Paulius Markevičius','Sam Strike','Ron Cook','Jamie Sives','Matthew Needham','Laurence Spellman','Victor McGuire','Sakalas Uždavinys','Darius Petkevicius','Lucy Russell','Diarmaid Murtagh','Baltasar Breki Samper','Oscar Dyekjær Giese','Arnas Danusas','James Kermack','June Watson','Josef Altin','Alexej Manvelov','Josef Davies','Ian Pirie','Lukas Malinauskas','Hilton McRae',"Kieran O'Brien",'Laura Elphinstone','Andrew Sheridan','Petras Simonis','Alison Pargeter','Jokubas Gutautas','Douggie McMeekin','Deividas Breive','Caolan Byrne','Caoilfhionn Dunne','Aiste S. Gram','Sammy Hayman'],
screenplay:['Craig Mazin'],
production:['Sanne Wohlenberg'],
music:['Hildur Guðnadóttir'],
camera:['Jakob Ihre'],
cut:['Jinx Godfrey','Simon Smith'],
sound:['Stefan Henrix','Joe Beal'],
scenography:['Claire Levinson-Gendler','Luke Hull','Gavin Fitch','Ainis Jankauskas'],
masks:['Julio Parodi','Daniel Parker','Žaneta Jasiūnienė','Ruta Miglinaite','Lucy Sibbick','Barrie Gower'],
costumes:['Odile Dicks-Mireaux']},
{title:'Band of Brothers',
titleCZ:'Bratrstvo neohrožených',
year:2001,
runtime:'9h 54min',
episodeRuntime:'49-70min',
countries:['UK','USA'],
genres:['War','Drama','History'],
director:['David Frankel','Mikael Salomon','Richard Loncraine','David Leland','Tony To','Phil Alden Robinson','David Nutter','Tom Hanks'],
actors:['Damian Lewis','Scott Grimes','Ron Livingston','Donnie Wahlberg','Shane Taylor','Rick Warden','Michael Cudlitz','Neal McDonough','Frank John Hughes','Richard Speight Jr.','James Madio','Philip Barantini','Peter Youngblood Hills','Matthew Settle','Rick Gomez','Eion Bailey','Kirk Acevedo','Dexter Fletcher','Dale Dye','Robin Laing','Matthew Leitch','David Schwimmer','Marc Warren','Nolan Hemmings','Ross McCall','Nicholas Aaron','Douglas Spain','Colin Hanks','Logan Marshall-Green','Andrew Scott','Tom Hardy','James McAvoy','Stephen Graham','Hugo Metsers','David Andrews','Jordan Frieda','Stephen McCole','Simon Pegg','Jamie Bamber','Jimmy Fallon',"Kieran O'Brien",'Diana Kent','Jack Wouterse','Michael Fassbender','Corey Johnson','Andrew Howard','Andrew Lee Potts','Anatole Taubman','Jamie Harding',"Jason O'Mara",'Dominic Cooper',"Peter O'Meara",'Gertrude Thoma','Isabella Seibert','Suzanne Roquette','Hans-Georg Nenning','Rupert Wickham','Dan van Husen','Matthew Faber','Dirk Galuba','John Light','Luke Roberts','Ian Virgo','Chris Geere','Ben Caplan','Bart Ruspoli','Alexis Conran','Ben Loyd-Holmes','Stephen Walters','Russell Loten','Mark Huberman','James Greene','Kristina Brändén Whitaker',"Jonjo O'Neill",'Joel Beckett','Jason Done','Joseph May','Paul Bentley','Doug Allen','Harry Peacock','Thomas Magnussen','Lucie Jeanne','William Meredith','Iain Robertson','Wolf Kahler','Simon Fenton','Brandon Firla','Mark Wakeling','Goran Kostič','Laird Macintosh','Adam James','Ricky Nixon','Tom Hanks','Ben Hecker','Ezra Godden','John Adams','Freerk Bos','Josefien Hendriks','Wil Röttgen','Dean Mitchell'],
basedOn:['Stephen Ambrose'],
screenplay:['Erik Jendresen','Bruce C. McKenna','Erik Bork','John Orloff','Graham Yost','Tom Hanks','E. Max Frye'],
production:['Erik Bork','Erik Jendresen'],
music:['Michael Kamen'],
camera:['Remi Adefarasin','Joel Ransom'],
cut:['Billy Fox','John Richards','Oral Norrie Ottey','Frances Parker'],
sound:['Mark Taylor','Kevin Patrick Burns','Todd Orr'],
scenography:['Anthony Pratt','Jonathan McKinstry'],
masks:['Daniel Parker','Trefor Proud','Lizzie Yianni Georgiou','Matthew Smith','Duncan Jarman','David Malinowski'],
costumes:['Anna Biedrzycka-Sheppard']},
{title:'Narcos',
titleCZ:'Narcos',
year:2015,
runtime:'25h 49min',
episodeRuntime:'44-61min',
countries:['USA'],
genres:['Biographic','Crime','Drama'],
director:['Andrés Baiz','Josef Kubota Wladyka','Fernando Coimbra','Gerardo Naranjo','Guillermo Navarro','José Padilha','Gabriel Ripstein','Patrick Archibald'],
actors:['Pedro Pascal','Wagner Moura','Boyd Holbrook','Paulina Gaitan','Alberto Ammann','Raúl Méndez','Paulina García','Matias Varela','Diego Cataño','Julian Diaz','Joanna Christie','Damián Alcázar','Maurice Compte','Brett Cullen','Stephanie Sigman','Roberto Urbina','Ana de la Reguera','Juan Pablo Raba','André Mattos','Bruno Bichir','Jorge A. Jimenez','Luis Guzmán','Adria Arjona','Maruia Shelton','Gabriela de la Garza','Juan Riedinger','Richard T. Jones','Adan Canto','Julian Beltran','Salvador del Solar','Dylan Bruno','Manolo Cardona','Orlando Valenzuela','Cristina Umaña','Martina García','Eric Lange','Florencia Lozano','Patrick St. Esprit','Jose Restrepo','Luis Gnecco','Juan Pablo Shuk','Matthew Glave','Patricia Castañeda','Raymond Ablack','Rafael Cebrián','Jon-Michael Ecker','Mauricio Mejía','David Valencia','Andrea Londo','Gabriel Sloyer','Ernesto Alterio','Matt Letscher','Taliana Vargas','Juan Sebastián Calero','Javier Cámara','Kerry Bishé','Edward James Olmos','Shea Whigham','Miguel Ángel Silvestre','Nicholas Gonzalez','Bre Blair','Arturo Castro','Francisco Denis','Pêpê Rapazote','Alejandra Lara','Danielle Kennedy','Carlos Humberto Camacho','Carter Roy','Carlos Clavijo','Michael Stahl-David','Matt Whelan','Gabriel Iglesias','Margarita Rosa de Francisco','Alberto Cardeño','Lisann Valentin','Vicky Hernández',"Lorenzo O'Brien",'José María Yazpik','Glenn Morshower','Wayne Knight','Curtiss Cook','Louis Herthum','Tristán Ulloa','Luis Mesa','Tatu Jokila','Brian Guest','Leynar Gomez','Fiona Horsey','Gabriel Mangones','Federico Rivera','Andres Felipe Torres','Camilo Amores','Juan Camilo Pérez','Alejandra Crispin','Juliette Pardau','Abril Schreiber','Joseph Fussey','David Páez','Jaider Velasco','Ariel Sierra'],
screenplay:['Andrew Black','Clayton Trussell','Dana Ledoux Miller','Dana Calvo','Allison Abner','Nick Schenk','Steve Lightfoot','T.J. Brady','Carlo Bernard','Chris Brancato','Doug Miro','Santa Sierra','Zachary Reiter','Eric Newman','David Matthews','Jason George','Zach Calig','Adam Fierro','Rasheed Newson','Julie Siege','Gideon Yago','Curtis Gwinn','Ashley Lyle','Bart Nickerson'],
production:["Lorenzo O'Brien",'Sidonie Dumas','Paul Eckstein','José Luis Escolar','José Padilha','Christophe Riandee','Allison Abner','Tim King','Rasheed Newson'],
music:['Pedro Bromfman'],
camera:['Adrian Teijido','Lula Carvalho','Carmen Cabana','Luis David Sansans','Juan Carlos Gil','Eduardo Ramirez Gonzalez','Mauricio Vidal'],
cut:['Victor Du Bois','Luis Carballar','Alex Marquez','Nathan Gunn','Leo Trombetta','Trevor Baker','Iain Erskine','Matthew Colonna','Chris McCaleb','Jon Otazua','Ryan Jones'],
sound:['Kevin Roache','Pete Elia','Edmond J. Coblentz Jr.','Pedro Sánchez Alonso','Steve Foster','Scott Shepherd'],
scenography:['Anthony Medina','Diana Trujillo','Salvador Parra','Rafa Mtz Withingham'],
costumes:['Bina Daigeler','María Estela Fernández']},
{title:'Tom and Jerry',
titleCZ:'Tom a Jerry',
year:1940,
runtime:'19h 5min',
episodeRuntime:'6-9min',
countries:['USA'],
genres:['Animation','Comedy','Family'],
director:['Tex Avery','Chuck Jones','Michael Lah','Joseph Barbera','William Hanna','Gene Deitch','Rudolf Ising','Maurice Noble','Abe Levitow','Ben Washam'],
actors:['Mel Blanc','Daws Butler','June Foray','Robert Morley','Harvey Korman','Tex Ritter','William Hanna','Pinto Colvig','Joseph Barbera','Tex Avery','Lillian Randolph','Martha Wentworth','Billy Bletcher','Joseph Forte','Paul Frees','Hans Conried','Shug Fisher','Janet Waldo','Bill Thompson',"George O'Hanlon",'Dal McKennon','Jerry Mann'],
basedOn:['Robert Louis Stevenson'],
screenplay:['William Hanna','Joseph Barbera'],
music:['Štěpán Koníček','Eugene Poddany'],
cut:['Jim Faris']},
{title:'Breaking Bad',
titleCZ:'Perníkový táta',
year:2008,
runtime:'49h 16min',
episodeRuntime:'43-58min',
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Michelle MacLaren','Adam Bernstein','Vince Gilligan','Colin Bucksey','Michael Slovis','Jim McKay','Tricia Brock','Bronwen Hughes','Tim Hunter','Phil Abraham','Bryan Cranston','Peter Gould','George Mastras','Charles Haid','Terry McDonough','John Dahl','Johan Renck','Peter Medak','Félix Enríquez Alcalá','Scott Winant','John Shiban','Rian Johnson','David Slade','Thomas Schnauz','Sam Catlin'],
actors:['Bryan Cranston','Aaron Paul','Anna Gunn','Dean Norris','Betsy Brandt','RJ Mitte','Bob Odenkirk','Jonathan Banks','Giancarlo Esposito','Jesse Plemons','Steven Michael Quezada','Laura Fraser','Charles Baker','Christopher Cousins','Matt Jones','Michael Shamus Wiles','Lavell Crawford','Ray Campbell','Krysten Ritter','Carmen Serano','Emily Rios','Mark Margolis','Jeremiah Bitsui','Raymond Cruz','Max Arciniega','Tess Harper','Jessica Hecht','Danny Trejo','Sam McMurray','Adam Godley','Seri DeYoung','Dale Dickey','Louis Herthum','Loren Haynes','Lora Martinez-Cunningham','Nate Mooney','Caleb Landry Jones','Maurice Compte','Blake Berris','Frederic Doss','Matthew Page','Juliet Lopez','Steven Bauer','Carl Savering','Drew Waters','Kyle Bornheimer','Paul J. Porter','Damon Herriman','Jolene Purdy','Julia Minesci','Keith Jardine','Michael Bofshever','Marius Stan','Jeremy Howard','David Ury','James Martinez','Kevin Wiggins','Eddie J. Fernandez','Geoffrey Rivas','Tom Kiesche','Cesar Garcia','Dennis Keiffer','Myra Turley','Aaron Hill','Franc Ross',"Jacob O'Brien Mulliken",'Judith Rane','Kristen Loree','Edward A. Duran','Mark Vasconcellos','William Sterchi','Michael Bryan French','Richard Barela','Debrianna Mansini','Stoney Westmoreland','David House','Ryan Lee','Nigel Gibbs','Harry Groener','Todd Terry','DJ Qualls','John Koyama','Rodney Rush','Larry Hankin','David Costabile','John de Lancie','Mike Seal','Jere Burns','Luis Moncada','Daniel Moncada','Angelo Martinez','Dean Norris','Tina Parker','Ian Posada','Michael Bowen','Kevin Rankin','Patrick Sane','Bill Burr','Kaija Bales','Tait Fletcher'],
screenplay:['Vince Gilligan','Peter Gould','George Mastras','Sam Catlin','Moira Walley-Beckett','Thomas Schnauz','Gennifer Hutchison','Patty Lin','John Shiban'],
production:['Melissa Bernstein','Stewart A. Lyons','Sam Catlin','Diane Mercer','George Mastras','Patty Lin','Moira Walley-Beckett','Karen Moore','Bryan Cranston','Thomas Schnauz','Peter Gould'],
music:['Dave Porter'],
camera:['Michael Slovis','Reynaldo Villalobos','Arthur Albert','Peter Reniers','Nelson Cragg','Marshall Adams','John Toll'],
cut:['Kelley Dixon','Skip Macdonald','Lynne Willingham','Chris McCaleb','Sharidan Williams-Sotelo'],
sound:['Kurt Nicholas Forshager','Jeffrey Perkins','Eric Justen','Kathryn Madsen','Edmond J. Coblentz Jr.'],
scenography:['Mark S. Freeborn','Robb Wilson King','Brenda Meyers-Ballard','Marcia Calosio','Billy W. Ray','Susan Magestro'],
masks:['Howard Berger','Greg Nicotero','JoAnn Stafford-Chaney'],
costumes:['Kathleen Detoro','Jennifer L. Bryan']},
{title:'The Simpsons',
titleCZ:'Simpsonovi',
year:1989,
runtime:'278h 52min',
episodeRuntime:'20-25min',
countries:['USA'],
genres:['Animation','Comedy'],
director:['Mike B. Anderson','Mark Kirkland','Steven Dean Moore','Bob Anderson','Matthew Nastuk','Jim Reardon','David Silverman','Michael Polcino','Wesley Archer','Nancy Kruse','Lance Kramer','Chris Clements','Chuck Sheetz','Rob Oliver','Rich Moore','Matthew Faughnan','Jeffrey Lynch','Timothy Bailey','Susie Dietter','Pete Michels','Raymond S. Persi','Carlos Baeza','Swinton O. Scott III','Dominic Polcino','Neil Affleck','Michael Marcantel','Lauren MacMullan','Matthew Schofield','Ralph Sosa','Mark Ervin','Jen Kamerman','Milton Gray','Brad Bird','Kent Butterworth','Gregg Vanzo','Alan Smart','David Mirkin','Klay Hall','Shaun Cashman','John Harvatine IV','Jennifer Moeller','Debbie Mahan','Gabriel DeFrancesco'],
actors:['Dan Castellaneta','Julie Kavner','Nancy Cartwright','Yeardley Smith','Harry Shearer','Hank Azaria','Marcia Wallace','Pamela Hayden','Tress MacNeille','Russi Taylor','Phil Hartman','Joe Mantegna','Frank Welker','Kelsey Grammer','Karl Wiedergott','Jon Lovitz','Greg Berg','Albert Brooks','Alex Rocco','Charles Napier','James Earl Jones','George Takei','Pamela Reed','Elizabeth Taylor','Glenn Close','Alec Baldwin','Ron Howard','Eric Idle','Leonard Nimoy','Sam McMurray','Danny DeVito','Adam West','Michael McKean','Sara Gilbert','George Harrison','Michelle Pfeiffer','Patrick Stewart','Paul Winfield','Dave Thomas','Gedde Watanabe','William Daniels','Adam Clayton','Larry Mullen Jr.','Bono','Kim Basinger','The Edge','John Kassir','Edward Asner','Lucy Lawless','Stacy Keach','Justin Timberlake','Joey Fatone','Ricky Gervais','Lee Ranaldo',"'Weird Al' Yankovic",'Kathleen Turner','Kiefer Sutherland','Paul Newman','Michael Jackson','Maurice LaMarche','Burt Ward','Johnny Cash','Mick Jagger','Lenny Kravitz','Keith Richards','Jane Kaczmarek','J. K. Rowling','Natalie Portman','Julia Louis-Dreyfus','Amy Poehler','Tom Savini','Dustin Hoffman','Louis Freese','Stephen King','Steve Buscemi','George Carlin','Sarah Michelle Gellar','Hugh M. Hefner','Jack White','Meg White','Gary Coleman','Harry Morgan','Matt Groening','Fran Drescher','Alan Moore','Dennis Rodman','Mel Gibson','Kirk Hammett','Lars Ulrich','James Hetfield','Larry Hagman','Frances McDormand','Ben Stiller','Reese Witherspoon','Woody Harrelson','Robert Forster','Meg Ryan','Carmen Electra','Tony Hawk','Stan Lee'],
screenplay:['John Swartzwelder','Dan Greaney','David X. Cohen','Richard Appel','Matt Selman','Jennifer Crittenden','Jon Vitti','Bill Canterbury','John Frink','Ian Maxtone-Graham','Tim Long','Al Jean','Don Payne','Joel H. Cohen','Bill Oakley','Josh Weinstein','George Meyer','Mike Scully','Carolyn Omine','Mike Reiss','Jay Kogen','Jeff Martin','Wallace Wolodarsky','Matt Warburton','J. Stewart Burns','Michael Price','Kevin Curran','David M. Stern','Greg Daniels','Daniel Chun','Valentina Garza','Ken Keeler','Ron Hauge','Donick Cary','Larry Doyle','Dan Castellaneta','Deb Lacusta','Marc Wilmore','Bill Odenkirk','Jeff Westbrook','Jonathan Collier','Rob LaZebnik','Dana Gould','Brian Kelley','Billy Kimball','Stephanie Gillis',"Conan O'Brien",'Dan McGrath','Steve Tompkins','Brent Forrester','Frank Mula','Brian Scully','Tom Martin','Julie Thacker-Scully','Allen Glazier','David Isaacs','Ken Levine','Bob Kushell','Joshua Sternin','Jennifer Ventimilia','Rachel Pulido','Reid Harrison','Ned Goldreyer',"Steve O'Donnell",'Bob Bendetson','Andrew Kreisberg','Peter Gaffney','Seth Rogen','Evan Goldberg','Brian K. Roberts','Justin Hurwitz','Robert Cohen','Mimi Pond','Harry Shearer','Nell Scovell','David Mirkin','Josh Lieb','Ricky Gervais','Michael Ferris','David Mandel','Eric Kaplan','Sylvain Chomet','David H. Steinberg','Judd Apatow','Patric M. Verrone','Eric Horsted',"Jane O'Brien",'Dan Vebber','Simon Rich','Bill Freiberger','David Sacks','Matt Marshall','Miranda Thompson','Adam I. Lapidus','Megan Amram','Jane Becker','Nancy Cartwright','Elisabeth Kiernan Averick','Tom Root','Jace Richdale'],
production:['Edward Chiodo','Ron Diamond','Richard Sakai','David Mirkin','Mike Scully','Mike Reiss','Elisabeth Kiernan Averick','J. Michael Mendel','Tom Gammill','David Silverman','Denise Sirkot','Max Pross','Larina Jean Adamson','Bonita Pietila','Colin A.B.V. Lewis','Joseph A. Boucher','Richard Raynis','Al Jean','Jon Vitti','Richard K. Chung','Alexander Duke','Ryan Koh','Cesar Mazariegos','Broti Gupta','Ken Keeler','Ben Houser','Jessica Conrad','Margaret M. Dean','Larry Doyle'],
music:['Arthur B. Rubinstein','Alf Clausen','Danny Elfman','Patrick Williams','Ray Colcord','Richard Gibbs','Matt Groening','Bleeding Fingers Music','Kara Talve'],
cut:['Don Barrozo','Brian K. Roberts','Lee Harting','Michael Bridge','Mark McJimsey','Ric Eisman'],
sound:['Oliver Davis','Eric Friend','Gary Montgomery','Dan Hiland','Bobby Mackston','Robert Nichols II','Bill Thiederman','Jim Fitzpatrick','R. Russell Smith','Nello Torri','William Freesh','Robert Edmondson','Kenneth Kobett','Alan Decker','Tara A. Paul','Mark Linden','Christine Sirois','Tim Lauber','Greg Orloff','Marco Augusto Comba',"Anthony D'Amico",'Brad Sherman','Sean McCormack','Dante Reynolds','Peter Cole','Gary Gegan','Robert Glass']},
{title:'Mr. Bean',
titleCZ:'Mr. Bean',
year:1990,
runtime:'5h 41min',
episodeRuntime:'23-26min',
countries:['UK'],
genres:['Comedy','Family'],
director:['John Birkin','Paul Weiland','John Howard Davies'],
actors:['Rowan Atkinson','Robin Driscoll','Matilda Ziegler','Angus Deayton','Sophie Thompson','Richard Wilson','Phyllis Calvert','Jamie Yeates','Christopher Ryan','Danny La Rue','Howard Goodall','David Schneider','Roger Sloman','Richard Briers','Harriet Eastcott','Stephen Frost','Grant Masters','Rupert Vansittart','Rudolph Walker','Colin Wells','Owen Brenman','Paul Bown','Paul Bown','Suzy Aitchison','David Stoll','Andy Bradford','Robert Austin','Roger Brierley','Roger Lloyd Pack','Steve McNicholas','Suzanne Bertish','John Barrad','Caroline Quentin','Marilyn Finlay','Helen Burns','Tony Haase'],
screenplay:['Rowan Atkinson','Robin Driscoll','Richard Curtis','Paul Weiland','Ben Elton'],
production:['Sue Vertue','John Howard Davies'],
music:['Howard Goodall'],
camera:["Shaun O'Dell"],
sound:['Keith Nixon','Tim Alban'],
scenography:['Gillian Miles'],
masks:['Lesley Faulkner']},
{title:'The Godfather: A Novel for Television',
titleCZ:'Kmotr',
year:1977,
runtime:434,
episodeRuntime:null,
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Francis Ford Coppola'],
actors:['Marlon Brando','Al Pacino','Robert Duvall','James Caan','Richard S. Castellano','Diane Keaton','Robert De Niro','Talia Shire','Sterling Hayden','John Marley','Richard Conte','Lee Strasberg','John Cazale','Morgana King','Tom Rosqui','Al Martino','Julie Gregg','Joe Spinell','Richard Bright','Michael V. Gazzo','Marianna Hill','Troy Donahue','Angelo Infanti','Gastone Moschin','Al Lettieri','G. D. Spradlin','Maria Carta','Rudy Bond','Dominic Chianese','Simonetta Stefanelli','Corrado Gaipa','Franco Citti','Saro Urzì','Sofia Coppola','Bruno Kirby','Roman Coppola','Kathleen Beller','Frank Sivero','John Megna','John Aprea','Francesca De Sapio','Leopoldo Trieste','Oreste Baldini','Giuseppe Sillato','Harry Dean Stanton','Tony Sirico','Abe Vigoda','Vito Scotti','Alex Rocco','Roger Corman','Danny Aiello','Fay Spain','Gianni Russo','Lenny Montana','Carmen Argenziano','Peter Donat','Ivonne Coll','James Murdock','Tony Lip','Carmine Caridi','Richard Matheson','Lou Martini Jr.','Frank Pesce','Tony Giorgio','Steve Peck','Sonny Grosso','Jeannie Linero','Carmine Coppola','John Martino','Louis Guss','Erica Yohn','Randy Jurgensen','Gary Kurtz','Salvatore Corsitto','William Bowers','Gabriele Torrei','Victor Rendina','James Gounaris','Ardell Sheridan','Franco Corsaro','Don Costello','Filomena Spagnuolo','Phil Feldman','Joe Lo Grippo'],
basedOn:['Mario Puzo'],
screenplay:['Francis Ford Coppola'],
production:['Francis Ford Coppola','Albert S. Ruddy'],
music:['Carmine Coppola'],
camera:['Gordon Willis'],
cut:['Barry Malkin']},
{title:'The Offer',
titleCZ:'Nabídka',
year:2022,
runtime:'9h 41min',
episodeRuntime:'51-69min',
countries:['USA'],
genres:['Drama','Biographic'],
director:['Dexter Fletcher','Colin Bucksey','Adam Arkin','Gwyneth Horder-Payton'],
actors:['Miles Teller','Matthew Goode','Juno Temple','Giovanni Ribisi','Dan Fogler','Burn Gorman','Colin Hanks','Josh Zuckerman','Nora Arnezeder','Jake Cannavale','Patrick Gallo','Frank John Hughes','Justin Chambers','Danny Nucci','Lou Ferrigno','James Madio','Paul McCrane','Michael Rispoli','Stephanie Koenig','Anthony Skordi','Anthony Ippolito','Joseph Russo','Meredith Garretson','Lavinia Postolache','Ron Roggé','Ted Monte','Sal Landi','Mimi Gianopulos','Louis Mandylor','Kirk Acevedo','Ross McCall','Michael Landes','Eric Balfour','Michael Gandolfini','Brandon Sklenar','Max Reeves','Jacob Taylor','Aarón Alonso','Danielle Titus','Nick Pupo','Kenny Barr','Ian Michaels','Saint Heart','Nicholas Petroccione','Christopher Wallinger','Victoria Kelleher','Veronica Wylie','Meredith VanCuyk'],
basedOn:['Albert S. Ruddy'],
screenplay:['Michael Tolkin','Nikki Toscano','Kevin J. Hynes','Russell Rothberg','Mona Mira'],
production:['Alex Kerr','Dalia Ibelhauptaitė'],
music:['Isabella Summers'],
camera:['Salvatore Totino','Elie Smolkin'],
cut:['Matt Barber','Tanya M. Swerling','David Trachtenberg'],
sound:['Nick Offord'],
scenography:['Laurence Bennett','Lisa Alkofer','Harry E. Otto','Shannon Walsh'],
masks:['Katy Fray','James Ferry','Ketty Gonzalez'],
costumes:['B.J. Rogers','Michael Kaplan','Amy Stofsky']},
{title:'Sherlock',
titleCZ:'Sherlock',
year:2010,
runtime:'17h 51min',
episodeRuntime:'88-90min',
countries:['UK'],
genres:['Crime','Mystery','Drama'],
director:['Paul McGuigan','Nick Hurran','Euros Lyn','Toby Haynes','Jeremy Lovering','Colm McCarthy','Rachel Talalay','Benjamin Caron'],
actors:['Benedict Cumberbatch','Martin Freeman','Una Stubbs','Louise Brealey','Rupert Graves','Mark Gatiss','Andrew Scott','Amanda Abbington','Jonathan Aris','Vinette Robinson','Lindsay Duncan','Sian Brooke','Tanya Moodie','Timothy Carlton','Wanda Ventham','Yasmine Akram','Lars Mikkelsen','Lara Pulver','Tom Brooke','Phil Davis','John Sessions','Gemma Chan','Daniel Percival','Olivia Poulet','John Lebar','Russell Tovey','Peter Brooke','Katherine Parkinson','Zoe Telford','San Shella','Chipo Chung','Will Sharpe','Peter Pedrero','Danny Webb','Peter Davison','Stephen Wight','Amelia Bullmore','Jeany Spark','David Gant','Todd Boyce','Derren Brown','Lisa McAllister','Clive Mantle','Oona Chaplin','Tony Way','Nicholas Asbury','Victoria Wicks','David Fynn','Rosalind Halstead','Simon Kunz','Lauren Crace','Rick Warden','Daniel van der Molen','Alice Lowe','Malcolm Rennie','Rita Davies','Sharon Rooney','Alfred Enoch','Stefano Braschi','Stanley Townsend','Michael Müller','Bertie Carvel','Kevin Trainor','Honor Kneafsey','Stephanie Hyam','Gordon G. Kennedy','Georgina Rich','Claire Cage','Al Weaver','Sarah Lam','Deborah Moore','Luke Newberry','Trixiebell Harrowell','Rosalind Knight','Lorraine Hilton','Alistair Petrie','Robin Sebastian','George Appleby','Barrie Martin','Siobhan Hewlett','William Scott-Masson','Sean Joseph Young','Ruth Everett','Syrus Lowe','Katy Maw','Ben Rufus Green','Pradeep Jey','Imogen Slaughter','David Nellist','Louise Breckon-Richards','Lasco Atkins','Alison Egan','Paul Chequer','Howard Coggins','Janice Acquah','Jack Bence','John Macmillan','Jacqueline Chan','Gillian Elisa','Stefan Pejic'],
basedOn:['Arthur Conan Doyle'],
screenplay:['Steve Thompson','Mark Gatiss','Steven Moffat'],
production:['Sue Vertue','Susie Liggat','Elaine Cameron'],
music:['David Arnold','Michael Price'],
camera:['Steve Lawes','Fabian Wagner','Matt Gray','Neville Kidd','David Luther','Stuart Biddlecombe'],
cut:['William Oswald','Nick Arthurs','Mali Evans','Charlie Phillips','Tim Porter','Yan Miles'],
sound:['Mark Taylor','Howard Bargroff','Abdelmounaime Ennokra'],
scenography:['Edward Thomas','Arwel Jones','Dafydd Shurmer'],
masks:['Claire Pritchard','Matthew Smith'],
costumes:['Sarah Arthur']},
{title:'Peaky Blinders',
titleCZ:'Peaky Blinders - Gangy z Birminghamu',
year:2013,
runtime:'35h 3min',
episodeRuntime:'55-81min',
countries:['UK'],
genres:['Crime','Drama'],
director:['Otto Bathurst','Tom Harper','Colm McCarthy','Tim Mielants','David Caffrey','Anthony Byrne'],
actors:['Cillian Murphy','Sam Neill','Helen McCrory','Iddo Goldberg','Annabelle Wallis','Andy Nyman','Harry Kirton','Paul Anderson','Joe Cole',"Natasha O'Keeffe","Hugh O'Brien",'Benjamin Zephaniah','Tom Hardy','Tommy Flanagan','Charlotte Riley','Branwell Donaghey','Martin Askew','Lobo Chan','Harrison Vaughan','Henry Garrett','Kunjue Li','David Dawson','Finn Cole',"Josh O'Connor",'Sam Hazeldine','Tony Pitts','Guy Williams','Charlie Anson','Richard McCabe','Ned Dennehy','Charlie Creed-Miles','Simone Kirby','Rory Keenan','Rory Gallagher','Noah Taylor','Jason Redshaw','Patricia Winker','Jassa Ahluwalia','Richard Dillane','Richard Brake','Stephanie Hyam','Alexander Siddig','Gaite Jansen','Ralph Ineson','Paddy Considine','Jan Bijvoet','Kenneth Colley','Dina Korzun','Alex MacQueen','Brid Brennan','Frances Tomelty','Josef Altin','Paul Cawley','Nick Owenford','Sophie Rundle','Brian Woodward','Neil Bell','Dorian Lough','Peter Bankolé','Dustin Demri-Burns','Kate Phillips','Jordan Bolger','Ian Peck','Richard Price','Grant Crookes','Graham Parrington','Nicola-Jayne Wells','Tom Vaughan-Lawlor','Adrien Brody','Aidan Gillen','Joseph Long','Charlie Murphy','Aaron Neil','Rupert Procter','Aimee-Ffion Edwards','Graeme Hawley','Craig Thomas Lambert','Nigel Hastings','Kamil Lemieszewski','Jane Wood','Tom Mothersdale','Tim Delap','Dominic Coleman','Andreas Muñoz','Donald Sumpter','Adam Collins','Jack Rowan','James Boyland','Samuel Edward-Cook','Anya Taylor-Joy','Sam Claflin','Dino Kelly','Kingsley Ben-Adir','Elliot Levey','Peter Campion','Elliot Cowan','Brian Gleeson','Charlene McKenna','Pauline Turner','Emmett J. Scanlan'],
screenplay:['Steven Knight','Toby Finlay'],
production:['Simon Maloney','Steven Knight','Joe Donaldson','Laurie Borg'],
music:['Dickon Hinchliffe','Martin Slattery','Paul Hartnoll','Martin Phipps','Anna Calvi'],
camera:['George Steel','Simon Dennis','Peter Robertson','Laurie Rose','Cathal Watters','Si Bell','Mathieu Plainfossé'],
cut:['Chris Barwell','Mark Eckersley','Matthew Cannings','Dermot Diskin','Dan Roberts','Celia Haining','Paul Knight'],
sound:['Brad Rees','Jim Goddard'],
scenography:['Richard Bullock','Grant Montgomery','Nicole Northridge','Stephen Daly','Jonnie Mead','Julie Ann Horan'],
masks:['Laura Schiavo','Gabrielle Hamilton','Vanessa Summers','Emma Romans'],
costumes:['Stephanie Collie','Alison McCosh','Lorna Marie Mugan','Alexandra Caulfield']},
{title:'Game of Thrones',
titleCZ:'Hra o trůny',
year:2011,
runtime:'67h 52min',
episodeRuntime:'48-82min',
countries:['USA','UK'],
genres:['Fantasy','Action','Adventure','Drama'],
director:['David Nutter','Alan Taylor','Alex Graves','Miguel Sapochnik','Mark Mylod','Jeremy Podeswa','Daniel Minahan','Alik Sakharov','Michelle MacLaren','Brian Kirk','David Benioff','D.B. Weiss','Timothy Van Patten','Neil Marshall','David Petrarca','Michael Slovis','Jack Bender','Daniel Sackheim','Matt Shakman'],
actors:['Peter Dinklage','Lena Headey','Kit Harington','Emilia Clarke','Sophie Turner','Maisie Williams','Iain Glen','Nikolaj Coster-Waldau','John Bradley','Alfie Allen','Conleth Hill','Sean Bean','Michelle Fairley','Mark Addy','Ron Donachie','Rory McCann','Jason Momoa','Richard Madden','Rose Leslie','Natalie Dormer','Jamie Sives','Donald Sumpter','Jack Gleeson','Harry Lloyd','Charles Dance','Roger Allam','Sibel Kekilli','Kate Dickie','James Cosmo','Peter Vaughan','Bronson Webb','Miltos Yerolemou','Owen Teale','Joseph Mawle','Roxanne McKee','Esmé Bianco','Amrita Acharia','Conan Stevens','John Standing','Joe Dempsie','Robert Pugh','Carice van Houten','Liam Cunningham','Stephen Dillane','Emun Elliott','Patrick Malahide','Nonso Anozie','Roy Dotrice','Lucian Msamati','Gethin Anthony','Gwendoline Christie','Oona Chaplin','Mackenzie Crook','Thomas Brodie-Sangster','Kristina Krepela','Aimee Richardson','Antonia Christophers','Laura Pradelska','Elyes Gabel','Ben Crompton','Charlotte Hope','Eros Vlahos','Mia Soteriou','Luke Barnes','Mark Stanley','Callum Wharry','Ed Skrein','Ciaran Bermingham','Daniel Portman','Wilko Johnson','Dar Salim','Iwan Rheon','Ciarán Hinds','Ian McElhinney','Paul Kaye','Richard Dormer','Noah Taylor','Michael McElhatton','Francis Magee','Alexandra Dowling','Elisa Lasowski','Jefferson Hall','Indira Varma','Tara Fitzgerald','Jón Þór Birgisson','Orri Páll Dýrason','Philip McGinley','Clive Mantle','Pedro Pascal','Jonathan Pryce','Michiel Huisman','Tony Way','Struan Rodger','Mark Gatiss','Jurij Kolokolnikov','Burn Gorman','Tim Plester','Kerry Ingram','Hafþór Júlíus Björnsson','Paola Dionisotti'],
basedOn:['George R.R. Martin'],
screenplay:['David Benioff','George R.R. Martin','D.B. Weiss','Vanessa Taylor','Bryan Cogman','Dave Hill','Jane Espenson'],
production:['Frank Doelger','Bernadette Caulfield','Greg Spence','Christopher Newman','Bryan Cogman','Lisa McAtackney','Mark Huffam','Duncan Muggoch'],
music:['Ramin Djawadi'],
camera:['Jonathan Freeman','Sam McCurdy','Kramer Morgenthau','Matthew Jensen','Alik Sakharov','Fabian Wagner','Chris Seager','P.J. Dillon','Anette Haellmigk','Marco Pontecorvo','Martin Kenzie','David Katznelson','Robert McLachlan','David Franco','Gregory Middleton'],
cut:['Martin Nicholson','Frances Parker','Crispin Green','Oral Norrie Ottey','Jesse Parker','Katie Weiland','Tim Porter','Yan Miles'],
sound:['Tim Kimmel','Onnalee Blank','Mathew Waters','Stephen P. Robinson','Mark Taylor','Mark Paterson','Paula Fairfield'],
scenography:['Gemma Jackson','Deborah Riley','Rob Cameron','Tina Jones','Richard Roberts','Nick Wilkinson'],
masks:['Áslaug Dröfn Sigurðardóttir','Nicola Matthews','Paul Engelen','Jane Walker',"Conor O'Sullivan",'Tamar Aviv','Tristan Versluis','Duncan Jarman','Laura Allen','Rob Bottin','Pamela Goldammer','Jessica Brooks','Lucy Sibbick','Barrie Gower','Lara Licari','Debbie Black'],
costumes:['Michele Clapton','April Ferry']},
{title:'Arcane: League of Legends',
titleCZ:'Arcane',
year:2021,
runtime:'12h 47min',
episodeRuntime:'39-44min',
countries:['USA'],
genres:['Animation','Action','Adventure','Drama','Fantasy','Sci-Fi'],
director:['Ash Brannon','Arnaud Delord','Pascal Charrue'],
actors:['Hailee Steinfeld','Kevin Alejandro','Ella Purnell','JB Blanc','Katie Leung','Harry Lloyd','Toks Olagundoye','Jason Spisak','Shohreh Aghdashloo','Miles Brown','Mia Sinclair Jenness','Mara Junot','Josh Keaton','Yuri Lowenthal','Roger Craig Smith','Fred Tatasciore','Brett Tucker','Amirah Vann','Mick Wingert','Erica Lindbeck','Remy Hii','Molly Harris','Faustino Duran','Krizia Bajos','Reed Shannon','Kimberly Brooks','Dave B. Mitchell'],
production:['Chris Neuhahn'],
music:['Alex Seaver','Alexander Temple'],
cut:['Gilad Carmel','Roberto Fernandez','Lawrence Gan','Nazim Meslem'],
sound:['Andrew Garrett Lange','Penny Harold','Odin Benitez'],
scenography:['Kevin Aymeric','Julien Georgel']},
{title:'The Bridge',
titleCZ:'Most',
year:2011,
runtime:'36h 53min',
episodeRuntime:'57-60min',
countries:['Sweden','Denmark','Germany'],
genres:['Crime','Thriller','Mystery'],
director:['Henrik Georgsson','Rumle Hammerich','Charlotte Sieling','Morten Arnfred','Kathrine Windfeld','Lisa Siwe','Tošinori Narita'],
actors:['Sofia Helin','Kim Bodnia','Thure Lindhardt','Rafael Pettersson','Sarah Boberg','Dag Malmberg','Puk Scharbau','Lars Simonsen','Gabriel Flores Jair','Henrik Lundström','Maria Kulle','Julie Carlsen','Emil Birk Hartmann','Anette Lindbäck','William Legue','Kristina Brändén Whitaker','Lotte Munk','Vickie Bak Laursen','Daniel Adolfsson','Elliot Metzdorff','Mikael Birkkjær','Sarah-Sofie Boussnina','Thomas W. Gabrielsson','Sandra Yi Sencindiver','Julia Ragnarsson','Johan Hedenberg','Freja Frost Barlach','Lotte Andersen','Smilla Bak','Holly Lars Bjarke','Anton Frost Barlach','Kristian Lima de Faria','Olaf Johannessen','Christian Hillborg','Magnus Krepper','Rasmus Hammerich','Nicolas Bro','Maria Sundbom Lörelius','Magnus Schmitz','Tova Magnusson','Adam Pålsson','Reuben Sallmander','Louise Peterhoff','Anna Björk','Ellen Hillingsø','Yaba Holst','Sven Ahlström','Ann Petrén','Sonja Richter','Klas Karterud','Dar Salim','Fredrik Hiller','Danica Curcic','Anton Lundqvist','Gunnel Fred','Melinda Kinnaman','Lil Terselius','Simon Åhlander','Ronja Svedmark','Stephanie León','Jakob Oftebro','Claes Bang','Claes Elfsberg','Ida Engvoll','Björn Granath','Catherine Hansson','Fredrik Gunnarsson','Eva Fritjofson','Victor von Schirach','Jörgen Thorsson','Peter Christoffersen','Marall Nasiri','Sofie Stougaard','Tove Wiréen','Fanny Ketter','Carl Martin Norén','Ole Boisen','Henning Valin','Boris Glibusic','Dietrich Hollinderbäumer','Iggy Malmborg','Morten Hauch-Fausbøll','Mia Blihagen','Miodrag Stojanovic','Morten Suurballe','Pia Örjansdotter','Nina Gyllensköld','Rasmus Haxen','Dulfi Al-Jabouri','Sadi Tekelioglu','Hadi Ka-Koush','Maja Herrström','Josefin Iziamo','Tuvalisa Rangström','Milo Randowo','Melvin Krajnc Randowo','Sten Erici','Peter Secher Schmidt','Kim Sønderholm','Sita Verma'],
screenplay:['Camilla Ahlgren','Erik Ahrnbom','Morten Dragsted','Maren Louise Käehne','Måns Mårlind','Hans Rosenfeldt','Nikolaj Scherfig','Björn Stein','Astrid Øye'],
production:['Anders Landström','Gunnar Carlsson','Bo Ehrhardt'],
music:['Johan Söderqvist','Patrik Andrén','Uno Helmersson'],
camera:['Carl Sundberg','Lars Reinholdt','Jørgen Johansson','Olof Johnson','Ari Willey','Morten Søborg'],
cut:['Patrick Austen','Sofia Lindgren','Sebastian Amundsen','Harvey Rosenstock','Margareta Lagerqvist','Emil Stenberg','Thomas Lagerman','Thomas Täng'],
sound:['Carl Edström','Julien Paschal','Mikkel Furbo'],
scenography:['Niels Sejer','Søren Gam','Peter de Neergaard','Rickard Wirén','Olle Remaeus'],
masks:['Tina Helmark','Annika Stödberg','Charlotte Hertz','Lisbeth Rishøj Olsen','Lene Majgaard Arentsen','Metha Engqvist Griffiths','Christina Dahlin','Lotta Sundberg'],
costumes:['Kerstin Halvorsson']},
{title:'The Knick',
titleCZ:'Knick: Doktoři bez hranic',
year:2014,
runtime:'18h 5min',
episodeRuntime:'43-58min',
countries:['USA'],
genres:['Drama','History'],
director:['Steven Soderbergh'],
actors:['Clive Owen','Eve Hewson','André Holland','Eric Johnson','Juliet Rylance','Chris Sullivan','Cara Seymour','Zuzanna Szadkowski','Lucas Papaelias','Suzanne Savoy','Ylfa Edelstein','Danny Hoch','Michael Angarano','Matt Frewer','Tom Lipinski','Melissa Errico','Jennifer Ferrin','Rachel Korine',"Booch O'Connell",'Erin Wilhelmi','Mary Birdsong','Katarína Morháčová','Michael Nathanson','Frank Deal','William Hill','Annie McNamara','Erika Rolfsrud','Grainger Hines','Ben Van Bergen','Marija Skangale','Evie Paller','Maya Kazan','Andy Murray','Glenn Fleshler','Marko Caka','Cris Williams','Emily Kinney','Peter Maloney','Pernell Walker','Jeremy Bobb','David Fierro','Alexandra Roxo','Stephen Tyrone Williams','Teddy Kalin','Charles Aitken','Michael Berresse','Perry Yung','Reg Rogers','Michael Cerveris','Victoria Leigh','Emily Bergl','Jim Norton','Maryann Plunkett','Aly Mang','Geoff Schuppert','Gary Simpson','Thomas Kopache','Brendan Burke','Frank Wood','Alfredo De Quesada','Yury Tsykun','Happy Anderson','Rob Morgan','Frederick Weller','Craig muMs Grant','Brian Tyree Henry','Makenzie Leigh','Kate MacCluggage','David Wilson Barnes','Tom Papa','Kelly Aaron','Cliff Moylan','Annabelle Attanasio','Sawyer Barth','Wally Dunn','Ntare Guma Mbaho Mwine','Jaine Ye','Dominique Fishback','Jessica Keenan Wynn','Anthony Rapp','Annie Young','Karl Bury','Leon Addison Brown','Jarlath Conroy','Helen Coxe','Caroline Clay','Cait Cortelyou','Brian Donahue','Kate Easton','Ashley Bryant','Wade McCollum','David Pittu','Robert Vincent Smith','Ito Aghayere','Johanna Day','Dwayne A. Thomas','Michael Cumpsty','Maria Mercedes Galuppo','Gia Crovatin','Leopold Manswell'],
screenplay:['Jack Amiel','Michael Begler','Steven Katz'],
production:['Michael Polaire'],
music:['Cliff Martinez'],
camera:['Steven Soderbergh'],
cut:['Steven Soderbergh'],
scenography:['Howard Cummings','Regina Graves'],
masks:['Rachel Geary','Nicki Ledermann','Justin Raleigh','Jerry DeCarlo','Kevin Kirkpatrick','Ozzy Alvarez'],
costumes:['Ellen Mirojnick']},
{title:'Fullmetal Alchemist: Brotherhood',
titleCZ:'Fullmetal Alchemist: Bratrství',
year:2009,
runtime:'26h 40min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy'],
director:['Jasuhiro Irie','Kazuhide Tomonaga','Masao Ókubo','Tóru Išida','Takahiro Ikezoe','Kijomicu Sató','Ikuró Sató','Daisuke Cukuši','Kazuo Mijake','Jošifumi Sueda','Keiko Ojamada','Šingo Učida','Šúdži Mijahara','Hisatoši Šimizu','Hiroši Ikehata','Šigeru Ueda','Cutomu Jabuki','Takajuki Tanaka','Masahiro Sonoda','Rokó Ogiwara','Kacumi Terahigaši'],
actors:['Rie Kugimija','Romi Paku','Iemasa Kajumi',"Šin'ičiró Miki",'Unšó Išizuka','Daisuke Namikawa','Fumiko Orikasa','Kazuja Nakai','Kendži Nodžima','Kóiči Jamadera','Mami Kojama','Nana Mizuki','Šózó Iizuka','Sumire Morohoši','Takehito Kojasu','Júdži Ueda','Mamoru Mijano','Keidži Fudžiwara','Jonathan R. Freeman','Chuck Huber','Tecuja Kakihara','Masuo Amada','Kendži Ucumi','Tomoe Hanba','Tadaši Mijazawa','Minami Takajama','Akemi Okamura','Kazuki Jao','Kendži Hamada','Čafúrin','Juri Amano','Acuši Abe','Júiči Nakamura','Šinpači Cudži','Fumihiko Tačiki','Hidekacu Šibata','Anri Kacu','Šóko Cuda','Tóru Nara','Noriko Uemura','Tecu Inada','Kenta Mijake','Hirojuki Jošino','Júko Sanpei','Naomi Šindó','Sacuki Jukino','Kacuhisa Hóki','Jóko Macuoka','Juzuru Fudžimoto','Tomojuki Šimura','Kijotaka Furušima','Risa Hajamizu','Kijojuki Janada','Rokuró Naja','Takako Honda','Seizó Kató','Takaši Óhara','Tomohisa Asó','Džin Horikawa','Kaori Nazuka','Sajuri','Šin Aomori','Seidži Sasaki','Jóko Sómi','Kacunosuke Hori','Kikuko Inoue','Júki Kodaira','Kinrjú Arimoto','Misato Fukuen','Masaki Terasoma','Tecu Širatori','Masatomo Nakazawa','Mai Gotó','Dai Macumoto','Keiiči Nakagawa','Taketora','Jóko Nišino','Jošinori Sonobe','Seiko Ueda','Megumi Takamoto','Kijoši Kacunuma','Masajuki Omoro','Takahiro Mijamoto','Masajuki Šódži','Bon Išihara','Jóhei Nišina','Hisanori Kojacu','Hideki Nakaniši','Džun Konno','Hitoši Janai','Mari Mijamoto','Džunko Kitaniši','Eri Komijama','Júki Hajaši','Sari Kakuta','Juka Nagajoši','Takahide Adači','Tošihiko Ogisawa','Fumihiro Okabajaši','Šinsuke Nagašima'],
basedOn:['Hiromu Arakawa'],
screenplay:['Hiroši Ónogi'],
production:['Nobujuki Kurašige','Noritomo Jonai','Rjo Ójama','Hiró Marujama'],
music:['Akira Sendžu'],
camera:['Majuko Furumoto','Jošijuki Takei'],
cut:['Gó Sadamacu'],
sound:['Masafumi Mima'],
scenography:['Takeši Sató']},
{title:'True Detective',
titleCZ:'Temný případ',
year:2014,
runtime:'32h 5min',
episodeRuntime:'54-86min',
countries:['USA'],
genres:['Crime','Drama','Mystery','Thriller'],
director:['Cary Joji Fukunaga','Justin Lin','Janus Metz','Miguel Sapochnik','Daniel Attias','Jeremy Podeswa','John Crowley','Jeremy Saulnier','Daniel Sackheim','Nic Pizzolatto','Issa López'],
actors:['Matthew McConaughey','Woody Harrelson','Michelle Monaghan','Colin Farrell','Rachel McAdams','Taylor Kitsch','Kelly Reilly','Vince Vaughn','Michael Potts','Tory Kittles','Alexandra Daddario','Kevin Dunn','Shea Whigham','Lili Simmons','Jay O. Sanders','Ann Dowd','Paul Ben-Victor','Clarke Peters','Tess Harper','Elizabeth Reaser','Christopher Berry','Brad Carter','Joe Chrest','Dana Gourrier','Michael Harney','Alyshia Ochse','Dane Rhodes','Wanetah Walmsley','Don Yesso','Glenn Fleshler','Charles Halford','Joseph Sikora','Erin Moriarty','Brighton Sharbino','Ólafur Darri Ólafsson','Johnny McPhail','Louis Herthum','Azure Parsons','Kelsey Scott','Jay Huguley','Michael Hartson','Jim Klock','Jackson Beals','Amy Brassette','Andrea Frankle','Ritchie Montgomery','Bree Williamson','Laura Cayouette','Todd Giebenhain','Jon Eyez','Jaren Mitchell','Shane Jacobsen','Lucky Johnson','Joshua Leonard','Nic Pizzolatto','Tom Proctor','Dave Davis','Terry Moore','Ritchie Coster','Leven Rambin','Abigail Spencer','Lolita Davidovich','James Frain','Riley Smith','Adria Arjona','Michael Hyatt','Christian Campbell','Emily Rios','Ronnie Gene Blevins','Timothy V. Murphy','C.S. Lee','Rick Springfield','Ashley Hinshaw','W. Earl Brown','David Morse','Fred Ward','Yara Martinez','Mariano Mendoza','Miranda Rae Mayo','Agnes Olech','Robert Renderos','Nick Gracer','Gabriel Luna','Madison Wolfe','Will Koberg','Andy Mackenzie','Eddie J. Fernandez','Jeff Doucette','Sam Malone','Jennifer K. Dawson','J.D. Evermore','Charleigh Harmon','Davi Jay','Tony Molina Jr.','Jason Kirkpatrick','Ron Clinton Smith','Charley Vance','Meghan Wolfe','Jon Arthur','Rex Baker'],
screenplay:['Nic Pizzolatto','Scott Lasser','David Milch','Graham Gordy','Issa López'],
production:['Steve Golin','Carol Cuddy','Aida Rodgers','Peter Feldman'],
music:['T Bone Burnett','Keefus Ciancia'],
camera:['Adam Arkapaw','Nigel Bluck','Germain McMicking','Florian Hoffmeister'],
cut:['Affonso Gonçalves','Alex Hall','Chris Figler','Meg Reticker','Byron Smith','Leo Trombetta','Christian Sandino-Taylor'],
sound:['Mariusz Glabinski','Tateum Kohut','Steve Pederson','Greg Orloff','Mandell Winter','Skuli Helgi Sigurgislason'],
scenography:['Alex DiGerlando','Ryan Warren Smith',"Karen O'Hara"],
masks:['Andrea Bowman','Michael Marino','Patricia Dehaney','Anne Morgan','Göran Lundström','Linda Dowds','Stacey K. Black','Michael Fontaine','Darlene Brumfield','Audrey Futterman-Stern'],
costumes:['Alix Friedberg','Jenny Eagan','Emma Potter']},
{title:'Rick and Morty',
titleCZ:'Rick a Morty',
year:2013,
runtime:'28h 57min',
episodeRuntime:'20-23min',
countries:['USA'],
genres:['Animation','Adventure','Comedy','Sci-Fi'],
director:['Dominic Polcino','Stephen Sandoval','Juan Jose Meza-Leon','Justin Roiland','Wesley Archer','Anthony Chun','John Rice','Jeff Myers','Bryan Newton','Pete Michels','Erica Hayes','Jacob Hair','Kyoung Hee Lim','Lucas Gray','Douglas Einar Olsen','Nadine Westerbarkey'],
actors:['Chris Parnell','Sarah Chalke','Jess Harnell','Phil Hendrie','Maurice LaMarche','Echo Kellum','Gary Anthony Williams','Rob Paulsen','David Cross','B. Harrison Smith','John Oliver','Cassie Steele','Dan Harmon','Spencer Grammer','Rob Schrab','Werner Herzog','Chelsea Kane','Aislinn Paul','Kevin Michael Richardson','Kari Wahlgren','Eric Bauza','Alex Hirsch','Nathan Fillion','Tom Kenny','Nolan North','Jill Talley','Justin Roiland','Clancy Brown','Tony Hale','Joel McHale','John DiMaggio','Susan Sarandon','Peter Serafinowicz','Danny Trejo','Gillian Jacobs','Christian Slater','Lance Reddick','Tara Strong','Jeff Bryan Davis','Dana Carvey','Steve Agee','Reagan Gomez-Preston','Claudia Black','Virginia Hey','Pete Michels','Jeff Bergman','Alfred Molina','Rich Fulcher','Tress MacNeille','Chris Romano','Keegan-Michael Key','Jordan Peele','Paul F. Tompkins','Jemaine Clement','Andy Daly','Christina Hendricks','Patton Oswalt','John Kassir','Dawnn Lewis','Keith David','Matt Walsh','Kurtwood Smith','Stephen Colbert','Alan Tudyk','Michael McCafferty','Jim Rash','Gary Cole','James Callis','Tricia Helfer','Nathan Fielder','Matt Besser','Ryan Ridley','Adam Ray','Alex Jayne Go','Sherri Shepherd','Sam Neill','Kathleen Turner','Taika Waititi','Jeffrey Wright','Pamela Adlon','Daniel Bonjour','Dustin Ybarra','Elon Musk','Justin Theroux','Matthew Broderick','Liam Cunningham','Keegan Allen','Phil LaMarr','Thomas Middleditch','Jennifer Hale','Dan Mintz','Paul Giamatti','Christopher Meloni','Vanessa Marshall','Eddie Pepitone','Richard Christy','Jay Johnston','Nick Reczynski','Jim Gaffigan','Jeff Loveness'],
screenplay:['Alex Rubens','Jane Becker','Dan Harmon','Justin Roiland','Ryan Ridley','Mike McMahan','Michael Waldron','Matt Roller','Tom Kauffman','Jessica Gao','Sarah Carbiener','Erica Rosbe','Dan Guterman','David Phillips','Eric Acosta','Wade Randolph','Caitie Delaney','Jeff Loveness','James Siciliano','Albro Lundy IV','Anne Lane','Rob Schrab','Nicholas Rutherford','John Harris','Siobhan Thompson','Scott Marder','Heather Anne Campbell','Cody Ziglar','Alex Song-Xia'],
production:['Dan Harmon','Justin Roiland','Mike McMahan','Sydney Ryan','Tom Kauffman','J. Michael Mendel','Dan Guterman','Ryan Ridley','Lee Harting','Michael Waldron','James Siciliano','Nicholas Rutherford','Albro Lundy IV','Jeff Loveness','Anne Lane','Steven Levy'],
music:['Ryan Elder','Jason Nesmith'],
cut:['Justin Roiland','Lee Harting','Ruthie Aslan','Nick Reczynski','Steve Ingram'],
sound:['Hunter Curra','Joe DeAngelis','Konrad Piñon','Robert Carr','Tony Orozco'],
scenography:['James McDermott','Jeffrey Thompson','Robbie Erwin','Jason Boesch']},
{title:'House of Cards',
titleCZ:'Domek z karet',
year:2013,
runtime:'63h 6min',
episodeRuntime:'42-60min',
countries:['USA'],
genres:['Drama'],
director:['David Fincher','Joel Schumacher','James Foley','Allen Coulter','Charles McDougall','Carl Franklin','Jodie Foster','John David Coles','Robin Wright','Tucker Gates','John Dahl','Agnieszka Holland','Tom Shankland','Alex Graves','Kari Skogland','Jakob Verbruggen','Alik Sakharov','Roxann Dawson','Daniel Minahan','Michael Morris','Ami Canaan Mann','Stacie Passon','Ernest R. Dickerson','Thomas Schlamme','Louise Friedberg'],
actors:['Kevin Spacey','Robin Wright','Michael Kelly','Rachel Brosnahan','Mahershala Ali','Nathan Darrow','Michel Gill','Reg E. Cathey','Sebastian Arcelus','Kate Mara','Corey Stoll','Kate Lyn Sheil','Molly Parker','Jimmi Simpson','Kristen Connolly','Constance Zimmer','Larry Pine','Sandrine Holt','Ben Daniels','Jayne Atkinson','Kim Dickens','Tawny Cypress','Boris McGiver','Daisy Tahan','Kathleen Chalfant','Al Sapienza','Wass Stevens','Curtiss Cook','Gerald McRaney','Reed Birney','Kevin Kilner','Michael Ahl','J.C. MacKenzie','Suzanne Savoy','Karl Kenzler','Francie Swift','Charlie Dreizen','Bill Maher','Mozhan Marnò','David Clennon','John Scurti','Sam Page','Benito Martinez','Jenna Gavigan','Emily Dorsch','Rachel Maddow','Terry Chen','Joanna Going','Gil Birmingham','Malcolm Madera','Malcolm Goodwin','Carme Boixadera','Catalina Parks','Gene Jones','Spencer Garrett','Ben Hyland','Laura Poe','Kara Jackson','Erin Fritch','Angela Christian','Armand Schultz','Gabrielle Senn','Alex Webb','Lyon Beckwith','Monica Sanchez','Olivia Luccardi','Anthony Hackett','Lars Mikkelsen','Naděžda Tolokonnikovová','Pjotr Věrzilov','Marija Aljochina','Elizabeth Marvel','Paul Sparks','Christina Bennett Lind','Kristof Konrad','Christian Camargo','Annie Parisse','John Henry Cox','Rick Zahn','Lance E. Nichols','Armando Gutierrez','Deanna Dunagan','Mark Falvo','Poorna Jagannathan','Jeremy Bobb','Jean Brassard','Andy Clemence','Isabelle McNally','Michael Siberry','Robert Eli','Maryann Plunkett','Geoffrey Cantor','Dominique McElligott','Chance Kelly','Derek Cecil','Murphy Guyer','Alex Russo','Thomas Gobena','Theodore A. Adams III','Monica Lee Bellais'],
basedOn:['Michael Dobbs'],
screenplay:['Kate Barnow','Sam Forman','Rick Cleveland','Keith Huff','Sarah Treem','John Mankiewicz','Frank Pugliese','Laura Eason','Kenneth Lin','Melissa James Gibson','Bill Kennedy','David Manson','Gina Gionfriddo','Beau Willimon','Charlotte Stoudt','Jason Horwitch','Sharon Hoffman','Jerome Hairston'],
production:['Iain Paterson','Boris Malden','Karen Moore','Jerome Hairston'],
music:['Jeff Beal'],
camera:['Eigil Bryld','Igor Martinović','David M. Dunlap','Martin Ahlgren','Paul Elliott','Tim Ives','Peter Konczal','Tim Norman'],
cut:['Kirk Baxter','Cindy Mollo','Michelle Tesoro','Lisa Bromwell','Byron Smith','Josh Beal','Katherine Skjerping','Kyle Traynor','Yuka Shirasuna'],
sound:['David Parker','Ren Klyce','Jeremy Molod','Nathan Nance','Juan Peralta','Michael Semanick','Stephen Urata','Steve Bissinger','Mark Weingarten'],
scenography:['Donald Graham Burt','Julie Walker','Steve Arnold','Douglas A. Mowat','Halina Gebarowicz'],
masks:['Gregory Bazemore','Edward French','Kenny Niederbaumer','Vasilios Tanis','Tifanie White','Michael Ward','Kevin Kirkpatrick','Tania McComas','Sean Flanigan'],
costumes:['Gersha Phillips','Johanna Argan','Tom Broecker','Jessica Wenger']},
{title:'The Wire',
titleCZ:'The Wire - Špína Baltimoru',
year:2002,
runtime:'59h 27min',
episodeRuntime:'55-93min',
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Ernest R. Dickerson','Daniel Attias','Clark Johnson','Brad Anderson','Agnieszka Holland','Jim McKay','Steve Shill','Timothy Van Patten','Seith Mann','Gloria Muzio','David Platt','Anthony Hemingway','Thomas J. Wright','Dominic West','Alex Zakrzewski','Joe Chappelle','Ed Bianchi','Robert F. Colesberry','Leslie Libman','Peter Medak','Clément Virgo','Milčo Mančevski','Elodie Keene','Rob Bailey','Joy Kecken','Scott Kecken','Christine Moore'],
actors:['Dominic West','John Doman','Clarke Peters','Frankie Faison','Deirdre Lovejoy','Wendell Pierce','Lance Reddick','Andre Royo','Sonja Sohn','Seth Gilliam','Aidan Gillen','Robert Wisdom','Domenick Lombardozzi','Michael Kenneth Williams','Corey Parker Robinson','Reg E. Cathey','Idris Elba','Jim True-Frost','Tristan Mack Wilds','Wood Harris','Isiah Whitlock Jr.','Jamie Hector','J.D. Williams','Gbenga Akinnagbe','Delaney Williams','Chad L. Coleman','Chris Bauer','Anwan Glover','Clark Johnson','Tom McCarthy','Michael Kostroff','Gregory L. Williams','Jay Landsman','Tray Chaney','Michael Salconi','Felicia Pearson','Jermaine Crawford','Glynn Turman','Hassan Johnson','Al Brown','Brian Anthony Wilson','Benjamin Busch','Maria Broom','Frederick Strother','Kwame Patterson','Thuliso Dingwall','Richard Burton','Tom Mardirosian','Leo Fitzpatrick','Paul Ben-Victor','Pablo Schreiber','Ryan Sands','Jeff Wincott','Amy Ryan','Merritt Wever','Method Man','Peter Gerety','Ramon Rodriguez','Alexandra Tydings','Bill Raymond','Lawrence Gilliard Jr.','Boris McGiver','Michael Mosley','Cyrus Farmer','David Costabile','Sam Freed','Dionne Audain','Brian Distance','Michael Ahl','Mike D. Anderson','Erik Dellums','Michael Rivera','Keith Johnson','Melanie Nicholls-King','Richard DeAngelis','Cleo Reginald Pizana','Brandy Burre','Maestro Harrell','Julito McCullum','Rick Otto','Michael Willis','Michael B. Jordan','Doug Olear','Megan Anderson','Neal Huff','Dravon James','Shamyl Brown','Callie Thorne','Susan Duvall','David Simon','Dennis Lehane','Ken Arnold','Tracy Teague','Kelley Slagle','James Ransone','Sarah Desage','Dion Graham','Alexander Emmert','Raw Leiba','Mark Joy'],
screenplay:['David Simon','Dennis Lehane','Richard Price','Joy Kecken','Eric Ellis Overmyer','George Pelecanos','Chris Collins','Ed Burns','David Mills','William F. Zorzi'],
production:['Ed Burns'],
camera:['Russell Lee Fine','Uta Briesewitz','Eagle Egilsson','David Insley'],
cut:['Geraldine Peroni','Michael Berenbaum','Alex Hall','Allyson C. Johnson','Kate Sanford','Meg Reticker','Thom Zimny','Deborah Moran'],
sound:['Andy Kris','Frank Morrone','Robert Fernandez','James Peterson'],
scenography:['Vincent Peranio','William A. Cimino','Barbara Haberecht','Halina Gebarowicz'],
masks:['Ardis Cohen'],
costumes:['Francine Jamison-Tanchuck','Alonzo Van Wilson']},
{title:'Stranger Things',
titleCZ:'Stranger Things',
year:2016,
runtime:'36h 1min',
episodeRuntime:'42-150min',
countries:['USA'],
genres:['Drama','Fantasy','Horror','Mystery','Sci-Fi','Thriller'],
director:['Matt Duffer','Ross Duffer','Shawn Levy','Andrew Stanton','Rebecca Thomas','Uta Briesewitz','Nimród Antal'],
actors:['Winona Ryder','David Harbour','Millie Bobby Brown','Finn Wolfhard','Gaten Matarazzo','Caleb McLaughlin','Natalia Dyer','Charlie Heaton','Joe Keery','Noah Schnapp','Sadie Sink','Cara Buono','Rob Morgan','Matthew Modine','Sean Astin','Dacre Montgomery','Joe Chrest','Ross Partridge','Shannon Purser','Chris Sullivan','Chelsea Talmadge','Catherine Curtin','Ron Roggé','Catherine Dyer','Anthony Reynolds','Aimee Mullins','Danny Boushebel','Jon Kohler','Shawn Levy','Andrew Ward','Amy Seimetz','Amy Parrish','Stefanie Butler','Chester Rushing','John Reynolds','Paul Reiser','Alex Van','Tobias Jelinek','Mark Steger','Anniston Price','Tinsley Price','James Donadio','Linnea Berthelsen','Brett Gelman','James Landry Hébert','Joe Davison','Fenton Lawless','Pruitt Taylor Vince','Keith Brooks','Juan Gaspard','Will Chase','Sean Astin','Linnea Berthelsen','Glennellen Anderson','Maya Hawke','Cary Elwes','Jake Busey','Francesca Reale','Anna Jacoby-Heron','Drew Scheid','Abigail Cowen','Kai Greene','Pete Burris','Gilbert Glenn Brown','Nicholas Cirillo','Elle Graham','Priah Ferguson','Charles Green','Andrey Ivchenko','Michael Park','Alec Utgoff','Caroline Arapoglou','Erika Coleman','Dylan Gage','Cara Mantella','Peggy Miley','David Silverman','Kaiser Johnson','Holly Morris','Serge Levin','Arthur Darbinyan','Beth Riesgraf','Dinarte de Freitas','Danny Boyd Jr.','Michael J. Fox','Christopher Lloyd','Claudia Wells','Kyle Dixon','Jevgenij Kartašov','Michael Stein','Roman Varshavsky','Bethany Anne Lind','Matty Cardarople','Jackie Dallas','Jerri Tubbs','Gary Lee Vincent','Leiloni Arrie Pharms','Megan Hayes','Abby Glover','Alicia Shenreice'],
screenplay:['Justin Doble','Paul Dichter','Jessie Nickson-Lopez','Kate Trefry','Matt Duffer','Ross Duffer','Alison Tatlock','William Bridges','Jessica Mecklenburg','Curtis Gwinn','Caitlin Schneiderhan'],
production:['Rand Geiger','Matt Duffer','Ross Duffer','Paul Dichter','Kate Trefry'],
music:['Kyle Dixon','Michael Stein'],
camera:['Tim Ives','Tod Campbell','David Franco','Lachlan Milne','Caleb Heymann','Brett Jutkiewicz'],
cut:['Dean Zimmerman','Kevin D. Ross','Nat Fuller','Katheryn Naranjo'],
sound:['Joe Barnett','Craig Henighan','Mark Paterson','Adam Jenkins','Brad North','Pedro Sánchez Alonso','Will Files'],
scenography:['Chris Trujillo','Jess Royal'],
masks:['Kim Simmons','Nikki Bell','Jessie Gambardella','Erin Keith','Brynn Berg','Siobhan Carmody','Lisa Poe','Kevin Kirkpatrick','Barrie Gower'],
costumes:['Kimberly Adams-Galligan','Kim Wilcox','Amy Parris']},
{title:"The Queen's Gambit",
titleCZ:'Dámský gambit',
year:2020,
runtime:'6h 35min',
episodeRuntime:'46-68min',
countries:['USA'],
genres:['Drama'],
director:['Scott Frank'],
actors:['Anya Taylor-Joy','Marielle Heller','Harry Melling','Bill Camp','Thomas Brodie-Sangster','Moses Ingram','Marcin Dorociński','Isla Johnston','Chloe Pirrie','Matthew Dennis Lewis','Russell Dennis Lewis','Jacob Fortune-Lloyd','Patrick Kennedy','Janina Elkin','Christiane Seidel','John Schwab','Charlotte Lucas','Nicky Goldie','Annabeth Kelly','Rebecca Root','Akemnji Ndifornyen','Simon Jensen','Jenny Galloway','Sophie McShera','Marian Meder','Ben Moor','Sergio Di Zio',"Jonjo O'Neill",'Josepha Walter','Juozas Budraitis','Vlad Chiriac','Peter Gilbert Cotton','Konstantin Frank','Hubertus Grimm','Tiit Lilleorg','Marcus Loges','Juri Padel','Till Trenkel','Evgenij Verenin','Ryan Wichert','Marc Zwinz','Maddie Holliday','Alva Schäfer','Rosalie Craig','Richard Waugh','Eloise Webb','Daniel Holzberg','Johannes Franke','Lucy Ella von Scheele','Daniel Brunet','Raphael Keric','Tim Kalkhof','William von Tagen','Rebecca Dyson-Smith','Nikolai Jegorow','Sam Gilroy','Pablo Scola','Rahul Chakraborty','Paul Walther','Alberto Ruano','Adrian Zwicker','Louis Ashbourne Serkis','Andreas Muñoz','Ivan Gallardo','Dolores Carbonari','Jeremy Mockridge','David Masterson','Murat Dikenci','Max Krause','Millie Brady','Uke Bosse','Frédéric Vonhof','Maximilian Diehle','Colin Stinton','Ricky Watson','Michel Diercks','John Hollingworth','Daniel Montoya','Dora Zygouri','Tim Olcay','Steffen Mennekes','Martin Müller','Samantha Soule','Tatsu Carvalho','Philipp Droste','Jonathan Failla','Kyndra Sanchez','William Horberg','Frederic Stromenger','Zoé Höche','Andruscha Hilscher','Sarah Schubert','Ilja Roßbander','Nahuel Häfliger','Alexander Albrecht','Dmitrij Frid','Frederik Schmid','Frank Streffing','Ben Gageik'],
basedOn:['Walter Tevis'],
screenplay:['Scott Frank'],
production:['Marcus Loges','Mick Aniceto'],
music:['Carlos Rafael Rivera'],
camera:['Steven Meizler'],
cut:['Michelle Tesoro'],
sound:['Wylie Stateman','Gregg Swiatlowski','Eric Hoehn','Roland Winke','Eric Hirsch'],
scenography:['Uli Hanisch','Sabine Schaaf'],
masks:['Daniel Parker','SJ Teasdale'],
costumes:['Gabriele Binder']},
{title:'Fargo',
titleCZ:'Fargo',
year:2014,
runtime:'44h 13min',
episodeRuntime:'39-69min',
countries:['USA'],
genres:['Crime','Drama','Comedy'],
director:['Adam Bernstein','Randall Einhorn','Colin Bucksey','Matt Shakman','Scott Winant','Adam Arkin','Michael Uppendahl','Noah Hawley','Jeffrey Reiner','Keith Gordon','John Cameron','Mike Barker','Dearbhla Walsh','Dana Gonzales','Sylvain White','Donald Murphy'],
actors:['Allison Tolman','Billy Bob Thornton','Martin Freeman','Russell Harvard','Ewan McGregor','Patrick Wilson','Kirsten Dunst','Colin Hanks','Carrie Coon','David Thewlis','Mary Elizabeth Winstead','Jesse Plemons','Ted Danson','Bokeem Woodbine','Jean Smart','Bob Odenkirk','Keith Carradine','Cristin Milioti','Joey King','Zahn McClarnon','Angus Sampson','Michael Stuhlbarg','Andy Yu','Em Haine','Jeffrey Donovan','Olivia Sandoval','Rachel Keller','Graham Verchere','Raven Stewart','Goran Bogdan','Joshua Close','Mark Forward','Gary Valentine','Michael Hogan','Shea Whigham','Adam Goldberg','Glenn Howerton','Brad Garrett','Nick Offerman','Elizabeth Marvel',"Keir O'Donnell",'Tom Musgrave','Barry Flatman','Rachel Blanchard','Susan Park','Oliver Platt','Zina Lee','Allan Dobrescu','Dan Beirne','Kate Walsh','Hamish Linklater','Linda Kash','Mary McDonnell','Julie Ann Emery','Keegan-Michael Key','Peter Breitmayer','Jordan Peele','Gordon S. Miller','Caitlynne Medrek','Spencer Drever','Scott Hylands','Mike Bradecich',"Ryan O'Nan",'Ivan Sherry','Adam Arkin','Atticus Mitchell','Liam Green','Matt Cooke','Eric Keenleyside','Kate Corbett','Scoot McNairy','Ray Wise','Terry Kinney','Shawn Doyle','Stephen Root','Brian Markinson','Helena Mattsson','DJ Qualls','Kelly Holden Bashar','Kieran Culkin','Dan Willmott','Andrew Moxham','Daryl Shuttleworth','Markus Parilo','Dave Trimble','Brian Jensen','Christopher Rosamond','Leah Cairns','Jeff Clarke','Bruce Campbell','Jonas Chernick',"Gregory 'Dominic' Odjig",'Lorne Cardinal','Barkhad Abdirahman','Ann Cusack','Kai Lennox','Greg Bryk','Mackenzie Gray','Sarah Lind','Douglas Chapman'],
screenplay:['Noah Hawley','Matt Wolpert','Ben Nedivi','Robert De Laurentiis','Steve Blackman','Stefani Robinson','Francesca Sloane','Enzo Mileti','Scott Wilson','Monica Beletsky','April Shih','Thomas Bezucha'],
production:['Michael Frislev','Chad Oakes','Kim Todd','Regis Kimble','Craig Yahata','Francesca Sloane','Stefani Robinson','Leslie Cowan','Dana Gonzales','Monica Beletsky'],
music:['Jeff Russo'],
camera:['Matthew J. Lloyd','Dana Gonzales','Craig Wrobleski','Paula Huidobro','Peter Konczal','Bella Gonzales','Gonzalo Amat','Erik Messerschmidt'],
cut:['Skip Macdonald','Bridget Durnford','Regis Kimble','Henk Van Eeghen','Andrew Seklir','Debby Germino','Jordan Goldman','Curtis Thurber','Christopher Nelson'],
sound:['Josh Eckberg','Chris Philp','Jeffrey Perkins','Martin Lee','Kurt Nicholas Forshager','Kathryn Madsen','Mark Server','Kevin W. Buchholz','David Raines','Marco Augusto Comba','Kirk Lynds','Tyler Whitham'],
scenography:['Warren Alan Young','Elisabeth Williams','John Blackie','Paul Healy','Jessie Haddad','Helen Harwell','Bill Ives','Amber Humphries','Trevor Smith','Joel Tobman'],
masks:['Lisa Jelic','Lillian Sakamaki','DeShawn Bowman','Nicole Rogers','Robert White'],
costumes:['Carol Case','J.R. Hawbaker']},
{title:'Generation War',
titleCZ:'Válka generací',
year:2013,
runtime:'4h 30min',
episodeRuntime:'90min',
countries:['Germany'],
genres:['War','History','Drama'],
director:['Philipp Kadelbach'],
actors:['Volker Bruch','Tom Schilling','Miriam Stein','Katharina Schüttler','Ludwig Trepte','Henriette Richter-Röhl','Mark Waschke','Götz Schubert','Christiane Paul','Sylvester Groth','Lucas Gregorowicz','Alina Levshin','Joel Basman','Maxim Mehmet','Bernd Michael Lade','Marek Harloff','Tino Mewes','Samuel Finzi','Johanna Gastdorf','Peter Kremer','Anne Diemer','Michael Ihnow','Ludwig Blochberger','David Zimmerschied','Benjamin Trinks','Martin Hentschel','Antonio Wannek','Trystan Pütter','Jean Denis Römer','Judith Engel','Paul Maaß','Bernhard Conrad','Jan Niklas Berg','Adam Markiewicz','Laurens Walter','Eckehard Hoffmann','Amelie Elisa Klein','André Borning','Valentin Novopolskij','Dorka Gryllus','Thomas Arnold','Hildegard Schroedter','Martin Bruchmann','Lioba Ravén Engel','Janusz Cichocki','Sebastian Urzendowsky','Karina Plachetka','Kai Michael Müller','Franziska Böhm','Inga Jarkova','Merle Dissen','Kristoffer Fuss','Matthias Halbrock','Bruno Montani'],
screenplay:['Stefan Kolditz'],
production:['Benjamin Benedict','Sebastian Werninger','Nico Hofmann','Jürgen Schuster'],
music:['Fabian Römer'],
camera:['David Sláma'],
cut:['Bernd Schlegel'],
sound:['Thomas Neumann','Jörg Krieger','Thorsten Minning','Holger Lehmann'],
scenography:['Thomas Stammer','Frank Herzog'],
masks:['Gerd Zeiss','Georg Korpas'],
costumes:['Wiebke Kratz']},
{title:"Monty Python's Flying Circus",
titleCZ:'Monty Pythonův létající cirkus',
year:1969,
runtime:'23h 2min',
episodeRuntime:'27-57min',
countries:['UK'],
genres:['Comedy'],
director:['Ian MacNaughton','John Howard Davies','Terry Gilliam'],
actors:['Graham Chapman','Eric Idle','Terry Jones','Michael Palin','Terry Gilliam','John Cleese','Carol Cleveland','Connie Booth','Douglas Adams','Neil Innes','Rosalind Bailey','Vincent Wong','Rita Davies','Neville Chamberlain','Julia Breck','Nosher Powell','Caron Gardner','Peter Brett','Ian Davidson','Bob Raymond','Frank Williams','Ringo Starr','Lulu','Katya Wyeth','Tim Condren'],
screenplay:['Graham Chapman','Eric Idle','Terry Jones','Michael Palin','Terry Gilliam','John Cleese','Neil Innes','Douglas Adams'],
production:['Ian MacNaughton','John Howard Davies'],
music:['Neil Innes'],
sound:['Peter Rose'],
scenography:['Kenneth Sharp','Valerie Warrender'],
masks:['Maggie Weston'],
costumes:['Hazel Pethig']},
{title:'The Boys',
titleCZ:'Banda',
year:2019,
runtime:'32h 17min',
episodeRuntime:'54-68min',
countries:['USA'],
genres:['Action','Comedy','Crime','Drama','Sci-Fi'],
director:['Dan Trachtenberg','Jennifer Phang','Philip Sgriccia','Stefan Schwartz','Daniel Attias','Frederick E.O. Toye','Matt Shakman','Eric Kripke','Batan Silva','Steve Boyum','Liz Friedlander','Julian Holmes','Nelson Cragg','Sarah Boyd'],
actors:['Karl Urban','Jennifer Esposito','Jack Quaid','Erin Moriarty','Tomer Capone','Laz Alonso','Jessie T. Usher','Chace Crawford','Dominique McElligott','Karen Fukuhara','Colby Minifie','Elisabeth Shue','Brittany Allen','Brittany Drisdelle','Alanna LeVierge','Nathan Mitchell','Caitlyn Sponheimer','Brendan Beiser','Shaun Benson','Ann Cusack','Mike Donis','Jimmy Fallon','Anton Gillis-Adelman','Alex Hassell','M.E. Lewis','Paulino Nunes','Simon Pegg','Antony Starr','Giancarlo Esposito','David Andrews','Ana Sani','Jordana Lajoie','Jay Yoo','Mishka Thébaud','Bill Turnbull','Malcolm Barrett','Christian Keyes','David Reale','Christian Bako','Biden Hall','Chad Allen','Shantel VanSanten','Wallace Langham','Jordan Andonov','Adam Waxman','Brittany Johnson','Grace Armas','Billy Zane','Brit Morgan','Nicola Correia-Damude','Jim Annan','Nicole Maroon','Haley Joel Osment','Jackie Tohn','Anna Khaja',"Da'Vinchi",'Tara Reid','John Doman','Reid Janisse','Seth Rogen','Alvina August','Laila Robins','Farid Yazdani','Jim Beaver','David Webster','Alex Chung','Shanice Johnson','Hallea Jones','Keller Viaene','Akiel Julien','Momona Tamada','Craig Burnatowski','Aya Cash','Jessica Hecht','Claudia Doumit','Chris Mark','Cameron Crovetti','Adrian Holmes','Keana Lyn Bastidas','Heather Tod Mitchell','David S. Lee','P.J. Byrne','Dan MacKay','Peter Nelson','Vickie Papavs','Shawn Ashmore','Greg Grunberg','Katy Breier','Goran Višnjič','Maria Menounos',"Nancy O'Dell",'Mark Antony Krupa','Lynne Griffin','Lovina Yavari','Anthony Gerbrandt','Andrew Jackson','Jason Gray-Stanford','Christopher Lennertz','Nick Alachiotis','Hubert Boorder'],
basedOn:['Garth Ennis','Darick Robertson'],
screenplay:['Eric Kripke','George Mastras','Craig Rosenberg','Anne Cofell Saunders','Rebecca Sonnenshine','Anslem Richardson','Geoff Aull','Ellie Monahan','David Reed','Logan Ritchey','Jessica Chou'],
production:['Gabriel Garcia','Hartley Gorenstein','Eric Kripke','Karl Urban'],
music:['Christopher Lennertz','Matt Bowen'],
camera:['Jeremy Benning','Dylan Macleod','Jeff Cutter','Evans Brown','Dan Stoloff','Miroslaw Baszak'],
cut:['David Trachtenberg','David Kaldor','Cedric Nairn-Smith','Nona Khodai','William W. Rubenstein','Jonathan Chibnall','Ian Kezsbom'],
sound:['Richard Weingart','Alexandra Fehrman','Wade Barnett'],
scenography:['David Blass','Cheryl Dorsey','Arvinder Greywal','Jeffrey Mossa','David Best'],
masks:['Suzanne Heibati','Paul Jones'],
costumes:['Carrie Grace','Laura Jean Shannon','Rebecca Gregg','Joyce Schure','Michael Ground']},
{title:'The Crown',
titleCZ:'Koruna',
year:2016,
runtime:'55h',
episodeRuntime:'39-72min',
countries:['UK'],
genres:['Drama','History','Biographic'],
director:['Benjamin Caron','Stephen Daldry','Philip Martin','Julian Jarrold','Philippa Lowthorpe','Christian Schwochow','Jessica Hobbs','Samuel Donovan','Paul Whittington','Alex Gabassi','May el-Toukhy','Erik Richter Strand'],
actors:['Claire Foy','Olivia Colman','Imelda Staunton','Matt Smith','Tobias Menzies','Jonathan Pryce','Vanessa Kirby','Helena Bonham Carter','Lesley Manville',"Josh O'Connor",'John Lithgow','Emma Corrin','Elizabeth Debicki','Dominic West','Jared Harris','Alex Jennings','Eileen Atkins','Emerald Fennell','Erin Doherty','Ben Miles','Gillian Anderson','Geraldine Chaplin','Victoria Hamilton','Charles Dance','Matthew Goode','Michael Culkin','Harriet Walter','Nicholas Rowe','Daniel Betts','John Sackville','Lasco Atkins','Todd Boyce','Andrea Deck','Anthony Flanagan','Robert Nairne','Cory Peterson','Greg Wise','Rebecca Benson','Catherine Lamb','Shaun Newnham','Attila G. Kerekes','Jeremy Northam','Simon Chandler','Nigel Cooke','Chris Gordon','Harry Hadden-Paton','Daniel Ings','Will Keen','Rosalind Knight','Jonathan Newth','Ronald Pickup','Patrick Ryecart','Mark Tandy','Pip Torrens','John Woodvine','Paul Leon Bridger','Nick Owenford','Jamie de Courcey','Stephen Dillane','Martyn Mayger','Clive Francis','Lia Williams','Atul Sharma','Philip Philmar','Michael Shelford','Anna Madeley','Nick Hendrix','Ed Stoppard','Paul Thornley','Peter Wight','Nick Davison',"Hugh O'Brien",'Michael Cochrane','Garrick Hagon','Héléna Soubeyrand','Sara Vickers','Grant Gillespie','Caroline Goodall','John Standing','David Yelland','Amelia Bullmore','Kate Phillips','Rita McDonald Damper','Peter Ellis','James Laurenson','Arthur Nightingale','Richard Price','Simon Poland','Tom Fairfoot','Matt Newman','Catherine Bailey','Ed Cooper Clarke','Chloe Pirrie','David Shackleton','Alan Williams','Michael C. Hall','Yolanda Kettle','Anton Lesser','Nicholas Burns','Lucy Russell'],
screenplay:['Peter Morgan','Amy Jenkins','Tom Edge','James Graham'],
production:['Andrew Eaton','Michael Casey','Martin Harrison','Andy Stebbing'],
music:['Rupert Gregson-Williams','Hans Zimmer','Guy Farley','Lorne Balfe','Martin Phipps'],
camera:['Adriano Goldman','Ole Bratt Birkeland','Stuart Howell','Ben Wilson','Rasmus Videbæk','Frank Lamm','Sophia Olsson'],
cut:['Luke Dunkley','Mark Eckersley','Pia Di Ciaula','Kristina Hetherington','Chris Barwell','Alex Mackie','Celia Haining','Ben Lester','Frances Parker','Paulo Pandolpho','Peggy Koretzky','Daniel Greenway','Adam Bosman','Úna Ní Dhonghaíle','Richard Graham','Morten Højbjerg','Tim Porter','Amy Hounsell','Yan Miles','Simon Brasse'],
sound:['Martin Jensen','Andy Kennedy'],
scenography:['Martin Childs','Neesh Ruben','Nuria Muni','Celia Bobak'],
masks:['Laura Schalker','Ivana Primorac','Nora Robertson','Michele Davidson Bell','Cyril Arsac','Doone Forsyth','Agathe Bernardon','Sarah Spears','Lucy Keel'],
costumes:['Michele Clapton','Jane Petrie','Amy Roberts']},
{title:'Mindhunter',
titleCZ:'MINDHUNTER: Lovci myšlenek',
year:2017,
runtime:'17h 1min',
episodeRuntime:'34-74min',
countries:['USA'],
genres:['Thriller','Crime','Drama'],
director:['David Fincher','Carl Franklin','Andrew Douglas','Asif Kapadia','Tobias Lindholm','Andrew Dominik'],
actors:['Jonathan Groff','Holt McCallany','Anna Torv','Stacey Roca','Hannah Gross','Joe Tuttle','Cotter Smith','Albert Jones','Lauren Glazier','Michael Cerveris','June Carryl','Cameron Britton','Sierra McClain','Sonny Valicenti','Zachary Scott Ross','Gareth Williams','Dohn Norwood','Nate Corddry','Siovhan Christensen','Alex Morf','Christopher Livingston','Katherine Banks','Crystal Lee Brown','Regi Davis','Erik Jensen','Happy Anderson','Peter Murnik','Thomas Francis Murphy','Ashley Smith','Jesse C. Boyd','David H. Holmes','Jordan Gelber','Chris James Boylan','Felix Solis','Tommy Nohilly','Judith Delgado','Matt Walton','Tobias Segal','Andrew Sensenig','Sam Strike','Austin Archer','Amelia Campbell','Joseph Cross','Catherine Curtin','Jason Davis','John Walpole','Dashiell Eaves','Lena Olin','Laura Poe','Jordyn DiNatale','Joshua Wills','Grace Rex','Sarah Wilson','Eric William Morris','Daniel James','Christopher Mann','Jack Erdie','Enid Graham','Rich Rule','Rhoda Griffis','Carl Franklin','Ben Cain','Marc Kudisch','Damon Herriman','Michael Park','Drew Seltzer','Andy Umberger','Jeb Kreager','Andrene Ward-Hammond','P.J. Marshall','Don O. Knowlton','Paul Carafotes','Jacob Berger','Christopher Grove','Andrew Yackel','Oliver Cooper','Tammy Felice','Megan McQuillan','David Carranza','Michael Filipowich','Brent Sexton','Mike Ancas','Steven Daniel Brun','Carl Hendrick Louis','Robert Aramayo','David Healy','Emily Bergl','Christopher Backus','Morgan Kelly','Sean Cullen','Scott A. Martin','Marcella Lowery','Anna Magoulas','Deja Dee','Ryan Buggle','Billy Slaughter','Jeff Pope','Michelle Davidson','Allie McCulloch','Circus-Szalewski'],
basedOn:['Mark Olshaker','John Douglas'],
screenplay:['Joe Penhall','Courtenay Miles','Joshua Donen','Liz Hannah','Tobias Lindholm','Erin Levy','Carly Wray','Pamela Cederquist','Shaun Grant','Alex Metcalf','Ruby Rae Spiegel'],
production:['Jim Davidson','Mark Winemaker','Liz Hannah'],
music:['Jason Hill'],
camera:['Erik Messerschmidt','Christopher Probst'],
cut:['Kirk Baxter','Tyler Nelson','Grant Surmi','Byron Smith','Eric Zumbrunnen'],
sound:['Ren Klyce','Jeremy Molod','Nathan Nance','Alessio Masi','Stephen Urata'],
scenography:['Steve Arnold','Gary Kosko','Gregory A. Weimerskirch','Andrew Baseman','Oana Bogdan Miller'],
masks:['Jamie Kelman','Gigi Williams','Rachel Geary','Kazu Hiro','Patty Bell'],
costumes:['Jennifer Starzyk']},
{title:'Yes, Prime Minister',
titleCZ:'Jistě, pane premiére',
year:1986,
runtime:'7h 59min',
episodeRuntime:'29-31min',
countries:['UK'],
genres:['Comedy'],
director:['Peter Whitmore','Sydney Lotterby'],
actors:['Paul Eddington','Nigel Hawthorne','Derek Fowlds','John Nettleton','Peter Cellier','Robert East','Michael Byrne','Richard Vernon','David Glover','Bill Bailey','Christopher Benjamin','Nicholas Courtney','Brian Gwaspari','Ronnie Stevens','Diana Hoddinott','William Fox','Victor Windig','Bill Wallis','David de Keyser','Clive Francis','Miranda Forbes','Denis Lill','Donald Pickering','Frank Middlemass','Jerome Willis','John Barron','Clive Merrison','Barry Stanton','Ronald Hines','Anthony Carrick','Brian Hawksley','Michael Aldridge','Myfanwy Talog','John Barron','Raymond Brody','Louis Mahoney','Jonathan Adams','Geoffrey Beevers','Jeffry Wickham',"Kevin O'Brien"],
screenplay:['Jonathan Lynn','Antony Jay'],
music:['Ronnie Hazlehurst'],
camera:['Chris Seager'],
masks:['Fran Needham']},
{title:'Black Books',
titleCZ:'Black Books',
year:2000,
runtime:'7h 11min',
episodeRuntime:'22-25min',
countries:['UK'],
genres:['Comedy'],
director:['Martin Dennis','Graham Linehan','Nick Wood'],
actors:['Dylan Moran','Bill Bailey','Tamsin Greig','Nick Frost','Simon Pegg','Martin Freeman','Rob Brydon','Selina Giles','Omid Djalili','Jessica Hynes','Mac McDonald','Alice Lowe','Kevin Eldon','Johnny Vegas','Graham Linehan','Lucy Davis','Rhys Thomas','Peter Serafinowicz','David Walliams','Olivia Colman','Patricia Franklin','Miltos Yerolemou','Muriel Pavlow','Julian Rhind-Tutt','Ricky Grover','Craig Parkinson','Sam Kelly','Tony Way','Richard Katz','Annette Crosbie','Keith Allen','Adam Astill','Colin McFarlane','Lonnie James','Stewart Wright','Nina Conti','Ralph Ineson','Vincenzo Nicoli','Dominic Carter','Rupert Vansittart','Tony Bluto','Su Elliot','Howard Coggins','Rosie Day','David Cann','Angela Curran','Ella Kenion','Mark Aiken','Catherine Shepherd','Garry Roost','Judith Jacob','Ben Homewood','Edward Burnham','Michael Parkhouse','John Marquez','Paul Putner','Hugh Parker','Peter Heppelthwaite'],
screenplay:['Dylan Moran','Graham Linehan','Kevin Cecil','Andy Riley','Arthur Mathews'],
production:['Nira Park'],
music:['Jonathan Whitehead'],
camera:['Andy Hollis','John Rosenberg'],
cut:['Paul Machliss'],
scenography:['Simon Rogers','Dennis De Groot'],
masks:['Jane Walker'],
costumes:['Annie Hardinge','Claire Wilson']},
{title:'The Big Bang Theory',
titleCZ:'Teorie velkého třesku',
year:2007,
runtime:'95h 19min',
episodeRuntime:'18-25min',
countries:['USA'],
genres:['Comedy','Romance'],
director:['Mark Cendrowski','James Burrows','Ted Wass','Andrew D. Weyman','Joel Murray','Anthony Rich','Peter Chakos','Howard Murray','Gay Linvill','Nikki Lorre','Kristy Cecil'],
actors:['Johnny Galecki','Jim Parsons','Kaley Cuoco','Simon Helberg','Kunal Nayyar','Melissa Rauch','Mayim Bialik','Kevin Sussman','Carol Ann Susi','John Ross Bowie','Aarti Mann','Sara Gilbert','Wil Wheaton','Kate Micucci','Mark Harelik','Pasha D. Lychnikoff','Laurie Metcalf','Margo Harshman','Brian Patrick Wade','Katie Leclerc','DJ Qualls','James Hong','Kimberly Kevon Williams','Riki Lindhome','Christine Baranski','Charlie Sheen','Summer Glau','Amanda Walsh','Courtney Henggeler',"Jodi Lyn O'Keefe",'Travis Schuldt','Matt Barr','Michael Trucco','Stan Lee','Ally Maki','Katee Sackhoff','Eliza Dushku','George Takei',"Erin Allin O'Reilly",'Steven Yeun','Emma Degerstedt','Sara Rue','Jessica Walter','LeVar Burton','Valerie Azlynn','Lio Tipton','Courtney Ford','Brent Spiner','Yeardley Smith','Stephen Hawking','Steve Paymer','Judy Greer','Marcus Folmar','Danica McKellar','Jen Drohan','Blake Berris','Howie Mandel','Josh Brener','Endre Hules',"Brooke D'Orsay",'Jeff Blum','William Stanford Davis','Buzz Aldrin','Laura Spencer','Ken Lerner','Brian George','Jesse Heiman','Christine Corpuz','James Earl Jones','Carrie Fisher','Bob Newhart','Eric Petersen','Regina King','Troy Winbush','Ira Flatow','Bill Nye','Kimberly Hebert Gregory','Sophie Oda','Brian Thomas Smith','Casey Sander','Barak Hardley','Neil deGrasse Tyson','Eric André','Briana Cuoco','Joshua Malina','Kevin Brief','Brian Posehn','Alex Ball','Octavia Spencer','Andrew W. Walker','Lewis Black','Elizabeth Bogush','Julio Oscar Mechoso','Keith Carradine','Ryan Cartwright','Jennifer Hale','Lance Barber','Rick Fox','Jim Turner','Josh Peck'],
screenplay:['Steven Molaro','David Goetsch','Steve Holland','Maria Ferrari','Eric Kaplan','Jim Reynolds','Robert Cohen','Saladin K. Patterson','Lee Aronsohn','David Litt','Jennifer Glickman','Anthony Del Broccolo','Bill Prady','Chuck Lorre','Jeremy Howe','Tara Hernandez','Tim Doyle','Eddie Gorodetsky','Andrew Gordon','Adam Faberman','Daley Haggar','Richard Rosenstock','Stephen Engel'],
production:['Michael Collier','Steven Molaro','Faye Oshima Belyeu','Steve Holland','Peter Chakos','Kristy Cecil','Anthony Del Broccolo','Robinson Green','Tara Hernandez'],
camera:['Steven V. Silver'],
cut:['Peter Chakos'],
sound:['Charlie McDaniel','Kathy Oldham','Bob La Masney','Ryan Kennedy','Bruce Peters','Ron Arnold'],
scenography:['John Shaffner','Vincent Jefferds','Ann Shea','Francoise Cherry-Cohen'],
masks:['Faye Woods','Matthew W. Mungle','Vikki McCarter','Sylvia Surdu',"Beth O'Rourke"],
costumes:['Mary T. Quigley']},
{title:'Yes, Minister',
titleCZ:'Jistě, pane ministře',
year:1980,
runtime:'11h 20min',
episodeRuntime:'28-61min',
countries:['UK'],
genres:['Comedy'],
director:['Peter Whitmore','Sydney Lotterby','Stuart Allen'],
actors:['Paul Eddington','Nigel Hawthorne','Derek Fowlds','John Nettleton','Philip Stone','Peter Cellier','Robert East','Daniel Moynihan','Richard Vernon','Vic Tablian','Pat Keen','Donald Pelmear','Thomas Baptiste','Robert Goodman','Graeme Garden','Peter Jeffrey','Ivor Roberts','Norman Tipton','Gerry Cowper','Diana Hoddinott','William Fox','Michael Keating','Patricia Shakesby','Norman Mitchell','Milton Johns','Arthur Cox','André Maranne','Frank Middlemass','Nigel Stock','Jerome Willis','Robert Urquhart','Charles McKeown','Norman Bird','Margo Johns','Brenda Blethyn','Judy Parfitt','Eleanor Bron','John Barron','John Savident','Rex Robinson','Moray Watson','Martyn Read','Tenniel Evans','Harry Fielder','Anthony Carrick','Edward Jewesbury','Brian Hawksley','John Barron','Roger Ostime','April Walker','Jay Neill','Jeffrey Segal','Ian Lavender','David Howey','Richard Simpson'],
screenplay:['Jonathan Lynn','Antony Jay'],
production:['Stuart Allen'],
music:['Ronnie Hazlehurst'],
cut:['Chris Wadsworth'],
scenography:['Jim Clay','Tony Burrough','Tim Gleeson','Gary Pritchard','Tom Yardley-Jones']},
{title:'Better Call Saul',
titleCZ:'Volejte Saulovi',
year:2015,
runtime:'52h 16min',
episodeRuntime:'42-69min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Vince Gilligan','Thomas Schnauz','Peter Gould','Michael Morris','Adam Bernstein','Michelle MacLaren','Colin Bucksey','John Shiban','Larysa Kondracki','Terry McDonough','Daniel Sackheim','Minkie Spiro','Jim McKay','Melissa Bernstein','Gordon Smith','Nicole Kassell','Michael Slovis','Scott Winant','Keith Gordon','Deborah Chow','Andrew Stanton','Norberto Barba','Bronwen Hughes','Giancarlo Esposito','Rhea Seehorn'],
actors:['Bob Odenkirk','Jonathan Banks','Patrick Fabian','Michael Mando','Rhea Seehorn','Michael McKean','Miriam Colon','Raymond Cruz','Julie Ann Emery','Jeremy Shamos','Jamie Luner','Cesar Garcia','Grant Barker','Max Arciniega','Amy Davidson','Steven Ogg','Mark Jeffrey Miller','Juan Carlos Cantu','Eddie J. Fernandez','Josh Fadem','Dorian Missick','Vincent Laresca','Mel Rodriguez','Kevin Weisman','Dawnn Lewis','Paul Geoffrey','Clea DuVall','Kerry Condon','Barry Shabaka Henley','Lane Garrison','Dennis Boutsikaris','Jillian Armenante','Sam Quinn','Omid Abtahi','Tomas Sanchez','Ed Begley Jr.','Kyle Bornheimer','Jessie Ennis','Grizelda Quintana','Vincent Fuentes','Liana Mendoza','Kurt Caceres','Suzanne Savoy','Jim Beaver','David Grant Wright','Mark Margolis','Mark Proksch','Luis Moncada','Manuel Uriza','Ann Cusack','James Cady','Robert Clotworthy','Debrianna Mansini','Stoney Westmoreland','Daniel Moncada','Jesus Payan Jr.','Jennifer Hasty','Steve Stafford','T.C. Warner','Sarah Minnich','Andrea Good','Rodger Larance','Michael E. Stogner','Rick Anglada','Jyl Murray','Giancarlo Esposito','Frank Deal','Gabriel Rush','Brandon K. Hampton','Nadine Marissa','Cara Pifko','Rex Linn','Abigail Zoe Lewis','Robert Grossman','Brendan Fehr','Julian Bonfiglio','Tina Parker','Omar Maskati','Joe DeRosa','Luis Bordonada','Carol Herman','JB Blanc','Kimberly Hebert Gregory','Molly Hagan','Jeremiah Bitsui','Ray Campbell','Peter Diseth','Javier Grajeda','Steven Bauer','John Getz','Michael Chieffo','Lavell Crawford','Jalene Mack','Quinn VanAntwerp','Jackamoe Buzzell','Cornell Womack','Anthony Michael Frederick','Laura Fraser','Grant James','Stephen Michael Ayers'],
screenplay:['Peter Gould','Thomas Schnauz','Gennifer Hutchison','Vince Gilligan','Bradley Paul','Gordon Smith','Marion Dayre','Ann Cherkis','Alison Tatlock','Ariel Levine','Jonathan Glatzer'],
production:['Bob Odenkirk','Diane Mercer','Ann Cherkis','Robin Sweet','Gennifer Hutchison','Nina Jack','Jenn Carroll','Jonathan Glatzer','Gordon Smith'],
music:['Dave Porter'],
camera:['Arthur Albert','Marshall Adams','Paul Donachie'],
cut:['Kelley Dixon','Skip Macdonald','Chris McCaleb','Joey Reinisch','Joey Liew'],
sound:['Michael Kalifa','Larry Benjamin','Kurt Nicholas Forshager','Kathryn Madsen','Kevin Valentine'],
scenography:['Tony Fanning','Michael Novotny','Judy Rhee','Mark S. Freeborn','Cindy Coburn','Libbe Green','Billy W. Ray',"Elaine O'Donnell",'Dea Jensen','Denise Pizzini','Ashley Michelle Marsh'],
masks:['Nysh Yellowhorse'],
costumes:['Jennifer L. Bryan']},
{title:'Friends',
titleCZ:'Přátelé',
year:1994,
runtime:'86h 32min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Comedy','Romance'],
director:['Kevin Bright','Gary Halvorson','Michael Lembeck','James Burrows','Gail Mancuso','Peter Bonerz','David Schwimmer','Robby Benson','Terry Hughes','Sheldon Epps','Pamela Fryman','Alan Myerson','Thomas Schlamme','Roger Christiansen','Arlene Sanford','Paul Lazarus','Joe Regalbuto','Ellen Gittelsohn','Mary Kay Place','Steve Zuckerman','Sam Simon','Shelley Jensen','David Steinberg','Dana De Vally Piazza','Andrew Tsao','Todd Holland','Ben Weiss','Stephen Prime'],
actors:['Jennifer Aniston','Courteney Cox','Lisa Kudrow','Matt LeBlanc','Matthew Perry','David Schwimmer','James Michael Tyler','Elliott Gould','Christina Pickles','June Gable','Jane Sibbett','Paul Rudd','Helen Baxendale','Jessica Hecht','Giovanni Ribisi','Tom Selleck','Lauren Tom','Eddie Cahill','Hank Azaria','Mitchell Whitfield','Steven Eckholdt','Paget Brewster','Debra Jo Rupp','Maggie Wheeler','Jon Favreau','Morgan Fairchild','Tate Donovan','Elle Macpherson','Alexandra Holden','Anna Faris','Michael Rapaport','Bonnie Somerville','Dermot Mulroney','Adam Goldberg','Teri Garr','Aisha Tyler','Bruce Willis','Cynthia Mann','Kathleen Turner','Reese Witherspoon','Danny DeVito','Jeff Goldblum','George Clooney','Brooke Shields','Mike Hagerty','Alec Baldwin','JoNell Kennedy','David Arquette','Sherilyn Fenn','Jon Lovitz','Ben Stiller','Jean-Claude Van Damme','Larry Hankin','Noah Wyle','Joel Gretsch','Robin Williams','Billy Crystal','Helen Hunt','Catherine Bell','Christine Taylor','Rebecca Romijn','Hugh Laurie','Jennifer Saunders','Tom Conti','Charlton Heston','Conchata Ferrell','Susan Sarandon','Denise Richards','Gary Oldman','Sean Penn','Brad Pitt','Marla Sokoloff','Freddie Prinze Jr.','Christina Applegate','Vince Vieluf','Mary Pat Gleason','Fisher Stevens','Beth Grant','Robert Costanzo','Emily Procter','Sofia Milos','Evan Handler','Ivana Milicevic','Vincent Ventresca','Steve Zahn','Peter Spears','John Allen Nelson','Rena Sofer','Daryl Sabara','Kristin Davis','Emily Osment','Matt Battaglia','Sean Whalen','Johnny Sneed','Christina Moore','Jason George','Eva Amurri Martino','NiCole Robinson','Laura Cayouette','Maria Pitillo'],
screenplay:['David Crane','Marta Kauffman','Ted Cohen','Scott Silveri','Shana Goldberg-Meehan','Robert Carlock','Vanessa McCarthy','Chris Brown','Dana Klein','Zachary Rosenblatt','Ira Ungerleider','Mark J. Kunerth','Bill Lawrence','Jeff Astrof','Mike Sikowitz','Alexa Junge','Jeff Greenstein','Jeff Strauss','Adam Chase','Doty Abrams','Michael Curtis','Greg Malins','Betsy Borns','Michael Borkow','Sebastian Jones','Brian Buckner','Brown Mandell','Wil Calhoun','Seth Kurland','Andrew Reich','Jill Condon','Amy Toomin','Richard Goodman','Perry M. Rein','Gigi McCreery','Suzie V. Freeman','Alicia Sky Varinaitis','Sherry Bilsing','Ellen Kreamer','Brian Boyle','Patty Lin','R. Lee Fleming Jr.','Steven Rosenhaus','Peter Tibbals','Tracy Reilly'],
production:['Todd Stevens','Betsy Borns','Michael Curtis','Greg Malins','Sebastian Jones','Brian Buckner','Adam Chase','Alexa Junge','Ira Ungerleider','Andrew Reich','Shana Goldberg-Meehan','Scott Silveri','Ted Cohen','Wendy Knoller','Sherry Bilsing','Ellen Kreamer','Dana Klein','Robert Carlock'],
music:['Michael Skloff'],
camera:['Nick McLean','Ken Lamkin','Richard Hissong','Mikel Neiers'],
cut:['Jay Scherberth','Stephen Prime','David Helfand','Andy Zall','Kenny Tintorri'],
sound:['Charlie McDaniel','John Bickelhaupt','Todd Grace','Craig Porter','Kathy Oldham','Fred Tator','Cary Butler','Marc A. Gilmartin','Dana Mark McClure','Walter Baker','William Freesh','Mike Olman','Jim Fitzpatrick','Mike Clark'],
scenography:['John Shaffner','Greg J. Grande'],
masks:['Tony Gardner','Kevin Haney','Kathleen Karridene','Kim Addrisi','Robin Siegel','Bruce Hutchinson','Marilyn Patricia Phillips','DeeDee Altamura','Kim Donohue'],
costumes:['Debra McGuire']},
{title:'Blue Eye Samurai',
titleCZ:'Modrooký samuraj',
year:2023,
runtime:'6h 22min',
episodeRuntime:'35-63min',
countries:['USA'],
genres:['Animation','Action','Adventure','Thriller'],
director:['Jane Wu',"Ryan O'Loughlin",'Earl A. Hibbert','Alan Wan','Michael Green','Alan Taylor','Michael Greenholt'],
actors:['Randall Park','Maya Erskine','George Takei','Alain Uy','Cary-Hiroyuki Tagawa','Brenda Song','Darren Barnet','Christine Ko','Masi Oka','Patrick Gallagher','West Liang','Clyde Kusatsu','Holly Chou','Gedde Watanabe','Matthew Yang King','Eric Bauza','Marcus Choi','Daisuke Suzuki','Keone Young','Orli Mariko Green','Judah Green','Mark Dacascos','Brittany Ishibashi','Joe Cappelletti','Kenneth Branagh','Karen Huie','Lee Shorten','Brian Takahashi','Jane Wu','Yoshi Ando','Junko Goda','James Taku Leung','Yumi Mizui','Ryan Moriarty','Alpha Takahashi','Jenson Cheng','Ann Harada','Amber Noizumi','Harry Shum Jr.','Sherry Cola','Stephanie Hsu','Sophie Kim','Ming-Na Wen','Byron Mann','Charlet Takahashi Chung','Tamlyn Tomita','JB Tadena'],
screenplay:['Amber Noizumi','Michael Green','Yana Bille-Chung'],
production:['Jane Wu','Nick Read','Haven Alexander'],
music:['Amie Doherty'],
cut:['Yuka Shirasuna','Brad Lee Zimmerman'],
sound:['Paul N.J. Ottosson','Myron Nettinga','Paulette Victor-Lifton','Sam Hayward','Jared Dwyer','Andrew Miller'],
scenography:['James Wood Wilson','Emil Mitev','Toby Wilson'],
costumes:['Suttirat Anne Larlarb']},
{title:'Red Dwarf',
titleCZ:'Červený trpaslík',
year:1988,
runtime:'36h 11min',
episodeRuntime:'25-90min',
countries:['UK'],
genres:['Comedy','Adventure','Sci-Fi'],
director:['Rob Grant','Juliet May','Doug Naylor','Andy De Emmony','Ed Bye','Paul Jackson'],
actors:['Chris Barrie','Craig Charles','Danny John-Jules','Norman Lovett','Robert Llewellyn','Robert Bathurst','Mac McDonald','Mark Williams','Clare Grogan','Hattie Hayridge','Chloë Annett','Rob Grant','Craig Ferguson','Brian Cox','John Sharian','Timothy Spall','Jenny Agutter','Ainsley Harriott','Sarah Alexander','Samantha Robson','Graham McTavish','Lenny von Dohlen','Robert Addie','Geraldine McEwan','Ed Bye','Ricky Grover','Howard Goodall','Paul McGuinness','Morwenna Banks','Holly Earl','David Lovgren','Anastasia Hille','David Ross',"Kevin O'Brien",'Lisa Barbuscia','Lucy Briers','Jack Docherty','J. Edgar Hoover','Doug Naylor','Gary Cady','Michael Shannon','Mark Jones','Adolf Hitler','Jeff Walker','Hilary Bevan Jones','Gordon G. Kennedy','Forbes Masson','David Verrey','Cliff Barry','Kenneth Hadley','Simon Paisley Day','Tom Andrews','Robert Nairne','Richard Ridings','Howard Burden','Rebecca Blackstone','Kevin Eldon','Lucie Pohl','Bentley Kalu','Suzanne Bertish','Frances Barber','Lia Williams','Nicholas Ball','Jane Horrocks','Matthew Marsh','Janet Montgomery','Maggie Steed','Hugh Quarshie','Fraser James','Don Henderson','Stephen Marcus','Ruby Wax','Gordon Salkilld','Lee Cornes','Angela Bruce','Anita Dobson','Imogen Bain','Adrienne Posta','Sophie Winkleman','Richard Ng','Jeremy Swift','Michelle Keegan','Sam Creed','Peter Elliott','Mark Dexter',"Richard O'Callaghan",'Isla Ure','Yasmin Bannerman','Noel Coleman','Stephen Critchlow','Denis Lill','Ron Pember','Dinny Powell','Jeremy Peters','Jennifer Calvert','Jack Klaff','Johanna Hargreaves','Tony Slattery','Kika Mirylees','Mark Caven'],
screenplay:['Rob Grant','Doug Naylor','Kim Fuller','Howard Goodall','Robert Llewellyn','James Hendrie','Paul Alexander'],
production:['Ed Bye','Rob Grant','Doug Naylor','Hilary Bevan Jones','Richard Naylor'],
music:['Howard Goodall'],
camera:['Ed Moore','Ian Adrian'],
cut:['Peter Oliver'],
sound:['Keith Nixon'],
scenography:['Paul Montague','Mel Bibby','Michael Ralph','Keith Dunne','Mark Harris','Dominic Roberts'],
masks:['Suzanne Jansen','Lois Burwell','Barrie Gower','Norma Webb'],
costumes:['Howard Burden','Jackie Pinks']},
{title:'DuckTales',
titleCZ:'My z Kačerova',
year:1987,
runtime:'36h 40min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['James T. Walker','Alan Zaslove','David Block','Jamie Mitchell','Richard Trueblood','Vincent Davis','Bob Hathcock','Steve Clark','Mircea Mantta','Jeff Hall','Nobuo Tomizawa','Toshihiko Masuda'],
actors:['Alan Young','Russi Taylor','Chuck McCann','Terence McGovern','Frank Welker','Hal Smith','Hamilton Camp','June Foray','Peter Cullen','Tress MacNeille','Kathleen Freeman','Tony Anselmo','Susan Blu','Miriam Flynn','Jim Cummings','Alan Oppenheimer','William Callaway','Howard Morris','Corey Burton','Clive Revill','Avery Schreiber','Aron Kincaid','Richard Libertini','Mark L. Taylor','Mary Jo Catlett','Steve Susskind','Arte Johnson','Ronnie Schell','Bernie Kopell','Barry Dennen','Roger C. Carmel','Joseph Ruskin','Richard Erdman','Victoria Carroll','Robert Ridgely','Dick Gautier','Gino Conforti','Michael Bell','Keone Young','Jo Anne Worley','Pat McCormick','Larry Moss','Ed Gilbert','Dick Beals','Kenneth Mars','Rob Paulsen','Brock Peters','Johnny Haymer','Phil Hartman','Jerry Dexter','René Auberjonois','Billy Barty','George DiCenzo','Maurice LaMarche','Don Messick','Gregg Berger','Jack DeLeon','Haunani Minn','Pat Musick','Pat Fraley','Linda Gary','Marilyn Lightstone','Will Ryan','Michael Rye','Brian Cummings','Danny Mann','Neil Ross','Allan Melvin','B.J. Ward','Jack Angel','Peter Renaday'],
screenplay:['Alan Burnett','Jeffrey Scott','Earl Kress','Donald F. Glut','Bruce Talkington','Len Uhley','Bruce Reid Schaefer','Ken Koonce','Mark Seidenberg','David Weimers','Jack Enyart','David Schwartz',"Michael O'Mahony",'Richard Merwin','Patsy Cameron','John Semper','Doug Hutchinson','Rich Fogel','Mark Zaslove','Diane Duane','Eleanor Burian-Mohr','Jack Hanrahan','Pamela Hickey','Dennys McCoy','Francis Moss','Evelyn Gabai','Chris Weber','Karen Willson','Sam Locke','Tedd Anasti','Michael Keyes','Gordon Bressack','Randy Lofficier','Samuel Warren Joseph','Frank Ridgeway'],
production:['Fred Wolf','Alan Zaslove'],
music:['Ron Jones'],
sound:['Fred Tator'],
scenography:['Michael Peraza Jr.','Brad Landreth']},
{title:'Shaun the Sheep',
titleCZ:'Ovečka Shaun',
year:2007,
runtime:'19h 41min',
episodeRuntime:'7-14min',
countries:['UK'],
genres:['Animation','Comedy','Family'],
director:['Christopher Sadler','Jean-Philippe Vine','Richard Webber','Richard Starzak','Dave Osmand','Mike Mort','Jay Grace','Seamus Malone','Lee Wilton','Will Becher','Steve Cox','Tom Parkinson'],
actors:['Kate Harbour','Jo Allen','John Sparkes','Justin Fletcher','Richard Webber','Simon Greenall'],
screenplay:['David Fine','James Cary','Glenn Dakin','Ian Carney','Jimmy Hibbert','Dave Ingham','Lee Pressman','Patrick Makin','Robin Crowther-Smith','Richard Beek','Richard Starzak','Rob Dudley','Julie Jones','Sarah Ball','Trevor Ricketts','Charles Hodges','Sara Barbas','Elly Brewer','Lucy Daniel-Raby','John Camm','Andy Williams','Dan Berlinka','Richard Vincent','Christopher Sadler','Keiron Self','Giles New','James Henry','Nick Park','Kay Stonham','Mark Daydy','Giles Pilbrow'],
production:['Julie Lockhart','John Woolley'],
music:['Mark Thomas'],
camera:['Charles Copping'],
cut:['Dan Williamson','Jane Hicks','Andrew Ward'],
sound:['Will Norie'],
scenography:['Michael Salter','Kitty Clay']},
{title:'Dexter',
titleCZ:'Dexter',
year:2006,
runtime:'93h 29min',
episodeRuntime:'44-59min',
countries:['USA'],
genres:['Crime','Drama','Mystery','Thriller'],
director:['John Dahl','Steve Shill','Keith Gordon','Marcos Siega','Adam Davidson','Michael Cuesta','Tony Goldwyn','S.J. Clarkson','Robert Lieberman','Nick Gomez','Colin Hanks','Alik Sakharov','Michael C. Hall','Seith Mann','Romeo Tirone','Jeremy Podeswa','Ernest R. Dickerson','Tim Hunter','Brian Kirk','Milan Cheylov','Stefan Schwartz','Michael Lehmann','Holly Dale','Sanford Bookstaver'],
actors:['Michael C. Hall','Jennifer Carpenter','David Zayas','James Remar','C.S. Lee','Luna Lauren Velez','Desmond Harrington','Julie Benz','Christina Robinson','Geoff Pierson','Preston Bailey','Aimee Garcia','Luke Andrew Kruntchev','Evan George Kruntchev','Erik King','Yvonne Strahovski','David Ramsey','Keith Carradine','Daniel Goldman','John Lithgow','Jaime Murray','Ronny Cox','Julia Stiles','Peter Weller','Ray Stevenson','Christian Camargo','Mark Pellegrino','Brad William Henke','Rudolf Martin','JoBeth Williams','Margo Martindale','Courtney Ford','Denise Crosby','David Batiste','Tony Goldwyn','Mark Matkevich','Debbie Lee Carrington','Sage Kirkpatrick','Carmen Olivares','Glenn Plummer','Bethany Joy Lenz','Kristen Kerr','Albie Selznick','Silas Weir Mitchell','Jonathan Banks','Malcolm-Jamal Warner','Dakin Matthews','David Haley','Martin Papazian','Monique Gabriela Curnen','Valerie Cruz','Amanda Wyss','Liza Lapira','Erin Daniels','Blake Gibbons','Laura Marano','Lynn A. Henderson','Karina Michel','Jimmy Smits','Sam Trammell','Salvator Xuereb','Olivia Burnette','Chris Muto','Nikki Magnusson','Sam Witwer','Vanessa Marano','Marc John Jefferies','Roma Maffia','Symba','Bryce Robinson','Dale Midkiff','April Hernandez Castillo','Tim Maculan','Jonny Lee Miller','Maria Doyle Kennedy','Scott Grimes','Chad Allen','Ann Henson','Devon Graye','Daniel Licht','David Paetkau','Anthony Tyler Quinn','Aramis Knight','Lisa Catara','Matthew Willig','Jesse Borrego','Jeff Chase','Kate Moennig','Angela Alvarado','Mark L. Young','Darcy Fowers','Jayden Lund','Richard Gunn','Brea Grant','Edward James Olmos','Colin Hanks','Yasiin Bey','Frederick Koehler','Jim Hanks','Steven Lee Allen'],
basedOn:['Jeff Lindsay'],
screenplay:['Jeff Lindsay','Tim Schlattmann','Manny Coto','Melissa Rosenberg','Charles H. Eglee','Adam Fierro','Clyde Phillips','Scott Reynolds','Chip Johannessen','Scott Buck','Wendy West','Arika Lisanne Mittman','Lauren Gussis','Karen Campbell','James Manos Jr.','Daniel Cerone','Jace Richdale','Warren Hsu Leonard','Jim Leonard','David McMillan','Tony Saltzman','Veronica West','Scott Reynolds','Kirsa Rein','Drew Z. Greenberg'],
production:['Scott Reynolds','Arika Lisanne Mittman','Lauren Gussis','Drew Z. Greenberg'],
music:['Daniel Licht','Rolfe Kent','Pat Irwin'],
camera:['Terry Stacey','Romeo Tirone','Jeffrey Jur','Alan Caso'],
cut:['Amy E. Duddleston','Padraic McKinley','Elena Maganini','Stewart Schill','Rob Seidenglanz','Keith Henderson','Michael Ruscio','Chris Figler','Louis Cioffi','David Latham','Scott K. Wallace','Matthew Colonna','Katie Ennis','David Leonard'],
sound:['Kevin Roache','Pete Elia','Elmo Ponsdomenech','Joe Earle','Mariusz Glabinski','Michael Colomby','Doug Andham','Fred Judkins','Richard Mercado','Patrick Hanson','Edward L. Moskowitz','Mark Kamps'],
scenography:['Michael Corenblith','Anthony Cowley','Eric Weiler','Jessica Kender','David A. Koneff',"Diane O'Connell",'Jeffrey Kushon','Debra Combs','Bryan Thetford','Christopher Carlson','Adam Rowe','Brandy Alexander'],
masks:['Kenny Niederbaumer'],
costumes:['Jill M. Ohanneson','Marina Draghici','Kathleen Felix-Hager','Abram Waterhouse','Catherine Marie Thomas','James Lapidus']},
{title:"Marvel's The Punisher",
titleCZ:'The Punisher',
year:2017,
runtime:'23h 2min',
episodeRuntime:'47-58min',
countries:['USA'],
genres:['Action','Adventure','Crime','Sci-Fi','Thriller'],
director:['Andy Goddard','Jeremy Webb','Tom Shankland','Kari Skogland','Dearbhla Walsh','Antonio Campos','Marc Jobst',"Jim O'Hanlon",'Kevin Hooks','Stephen Surjik','Salli Richardson-Whitfield','Alex Garcia Lopez','Jet Wilkinson','Iain B. MacDonald','Stacie Passon','Jamie M. Dagg','Michael Offer','Meera Menon','Stephen Kay'],
actors:['Jon Bernthal','Ebon Moss-Bachrach','Ben Barnes','Amber Rose Revah','Jaime Ray Newman','Kelli Barrett','Paul Schulze','Jason R. Moore','Deborah Ann Woll','Michael Nathanson','Shohreh Aghdashloo','C. Thomas Howell','Mary Elizabeth Mastrantonio','Nicolette Pierini','Ripley Sobo','Tony Plana','Delaney Williams','Geoffrey Cantor','Jeb Kreager','Tyler Elliot Burke','Daniel Webber','Clancy Brown','Tim Guinee','Rob Morgan','Owen Burke','Andrew Polk','Ilfenesh Hadera','Rick Holmes','Dov Davidoff','Royce Johnson','René Ifrah','Josh Caras','Adelind Horan','Marlene Ginader','Adrian Alvarado','Floriana Lima','Teri Reeves','Josh Stewart','Giorgia Whigham','Ilia Volok','Jes Davis','Alexa Davalos','Ramon O. Torres','Kobi Frumer','Jimi Stanton','Aidan Pierce Brennan','Lucca De Oliveira','Timothy Stickney','Lenny Thomas','Joe Holt','Brett Diggs','Kyli Zion','Jon David Casey','Michael Pemberton','Alexandr Notkin','Corbin Bernsen',"Annette O'Toole",'Allie McCulloch','Thomas G. Waites','Jordan Dean','Dikran Tulaine','Kara Young','Mike Figueroa','Kevin Chapman','Jordyn DiNatale','E.J. Carroll','Charles Brice','Pat Kiernan','Ambre Anderson','Eboni Booth','Anais Almonte','Jesse Bradley','Rudy Eisenzopf','Shezi Sardar','Greta Quispe','Graham Wolfe'],
basedOn:['Gerry Conway','Ross Andru'],
screenplay:['Ken Kristensen','Steve Lightfoot','Angela LaManna','Dario Scardapane','Christine Boylan','Felicia D. Henderson','Bruce Marshall Romans','Laura Jean Leal'],
production:['Jared Goldman','Bruce Marshall Romans','Megan Thomas Bradner'],
music:['Tyler Bates'],
camera:['Petr Hlinomaz','Francis Spieldenner'],
cut:['William Yeh','Tim Mirkovich','Liza Schroeder','Trevor Penna','Tirsa Hackshaw'],
sound:['Joe DeAngelis','Joe Barnett','Chris Carpenter','Adam Jenkins'],
scenography:['Scott P. Murphy','Lindsay Stephen'],
masks:['Brittany Romney','Elizabeth Piper S.','Joshua Gericke'],
costumes:['Lorraine Calvert']},
{title:'Invincible',
titleCZ:'Neporazitelný',
year:2021,
runtime:'13h 15min',
episodeRuntime:'42-56min',
countries:['USA'],
genres:['Animation','Action','Adventure','Sci-Fi','Thriller'],
director:['Jeff Allen','William Ruzicka','Haylee Herrick','Sol Choi','Tanner Johnson','Dan Duncan','Jason Zurek'],
actors:['Steven Yeun','J.K. Simmons','Sandra Oh','Seth Rogen','Zazie Beetz','Mark Hamill','Walton Goggins','Jason Mantzoukas','Mae Whitman','Max Burkholder','Chris Diamantopoulos','Michael Dorn','Grey Griffin','Gillian Jacobs','Melise','Khary Payton','Zachary Quinto','Andrew Rannells','Kevin Michael Richardson','Mahershala Ali','Nickie Bryar','Lauren Cohan','Chad L. Coleman','Michael Cudlitz','Lennie James','Ross Marquand','Sonequa Martin-Green','Jon Hamm','Fred Tatasciore','Sean Patrick Thomas','Zehra Fazal','Madison Calderon','Taylor Dearden','Phil LaMarr','Tatiana Maslany','Lance Reddick','Stephen Root','Philip Solomon','Jacob Tremblay','Sterling K. Brown','Peter Cullen','Daveed Diggs','Jay Pharoah','Ben Schwartz','Lea Thompson','Paul F. Tompkins','Nyima Funk','Dan Navarro','Cleveland Berto','Cliff Curtis','Scoot McNairy','Reginald VelJohnson','Kari Wahlgren','Gary Anthony Williams','Clancy Brown'],
basedOn:['Robert Kirkman'],
screenplay:['Ryan Ottley','Simon Racioppa','Chris Black','Helen Leigh','Robert Kirkman','Matt Lambert','Adria Lang'],
production:['Maude Lewis','John C. Donkin','Dan Duncan'],
music:['John Paesano'],
cut:['Scott Winlaw','Luke Guidici'],
sound:['Hugh Wielenga','Miguel Nunes','Craig Berkey','Jacob Cook'],
scenography:['Wilson J. Tang']},
{title:'The IT Crowd',
titleCZ:'Ajťáci',
year:2006,
runtime:'9h 29min',
episodeRuntime:'22-26min',
countries:['UK'],
genres:['Comedy'],
director:['Graham Linehan','Richard Boden','Ben Gosling Fuller'],
actors:["Chris O'Dowd",'Richard Ayoade','Katherine Parkinson','Christopher Morris','Matt Berry','Noel Fielding','Dolly Wells','Alice Lowe','Belinda Stewart-Wilson','Peter Serafinowicz','Adam Buxton','Alex MacQueen','Adam Leese','Graham Linehan','Benedict Wong','Laura Pyper','Togo Igawa','Guy Henry','Gemma Chan','Hazel Douglas','Simona Brhlíková','Orlando Seale','Alexandra Weaver','Alexandra Roach','Silas Carson','Amelia Bullmore','Sophie Colquhoun','Sarah Hadland','Ty Glaser','Peter Sullivan','Nicholas Burns','Rachel Riley','David Schaal','Lucy Robinson','Simone McAullay','Oliver Chris','Simon Kunz','Nathalie Cox','Tom Meeten','Adrian Schiller','Marc Small','Ralph Ineson','Ed Weeks','Margaret Cabourn-Smith','Jamie Michie','Danny Wallace','Frances Barber','Nathan Harmer','Wendy Wason','Lucy Liemann','Kevin Cecil','Catherine Shepherd','Hermione Gulliford','Brian Limond','Jon Foster','Cavan Clerkin','Susannah Wise','Stephen Lea Sheppard','Susy Kane','Chris Tarrant','Chris Wilson','Lorna Watson','Claudia Harrison','Ben Moor','Kevin Eldon','Lucy Montgomery','Katie Males','Ash Atalla','Mark Chatterton','Janet Whiteside','Andrew Brooke','Jonathan Ryland','James Tovell','Joanna Bobin','Laura Patch','Chris Hayward','Marcus Garvey','James Bachman'],
screenplay:['Graham Linehan','David Guarascio'],
production:['Derrin Schlesinger'],
camera:['Francis De Groote','Bill Broomfield'],
cut:['Paul Machliss'],
scenography:['Jo Sutherland','Dennis De Groot'],
masks:['Christine Cant','Jane Walker','Lizzie Yianni Georgiou'],
costumes:['Annie Hardinge']},
{title:'Mare of Easttown',
titleCZ:'Mare z Easttownu',
year:2021,
runtime:'6h 53min',
episodeRuntime:'56-66min',
countries:['USA'],
genres:['Drama','Crime','Mystery'],
director:['Craig Zobel'],
actors:['Kate Winslet','Guy Pearce','Julianne Nicholson','Jean Smart','Evan Peters','Patrick Murney','Sosie Bacon','David Denman','Neal Huff','Izzy King','Cameron Mann','James McArdle','Angourie Rice','Cailee Spaeny','Joe Tippett','Patsy Meck','Patrick F. McDade','Gina Jun','Ed Aristone','Stephen C. Bortsalas','Kate Arrington','Enid Graham','Chinasa Ogbuagu','Justin Hurtt-Dunkley','John Douglas Thompson','Setty Brosevelt','Debbie Campbell','Deborah Hedwall','Ned Eisenberg','Jack Mulhern','Robbie Tann','Cody Kostro','Eisa Davis','Gordon Clapp','Christopher Mann','Drew Scheid','Sasha Frolova','Jeb Kreager','Rosa Arredondo','Madeline Weinstein','Brian Anthony Wilson','Phyllis Somerville','Brian Gallagher','Rachel Nielsen','Rob Jankowski','Dominique Johnson','Mackenzie Lansing','Ruby Cruz','Katie Kreisler','Elliot Frances Flynn','Satomi Hofmann','Lee Avant',"Kittson O'Neill",'Kiah McKirnan','Eric T. Miller'],
screenplay:['Brad Ingelsby'],
production:['Karen Wacker'],
music:['Lele Marchitelli'],
camera:['Ben Richardson'],
cut:['Amy E. Duddleston'],
sound:['Joe DeAngelis','Chris Carpenter','Brad North'],
scenography:['Keith P. Cunningham','Michelle C. Harmon'],
masks:['Rachel Geary','Greg Nicotero','Patty Bell'],
costumes:['Meghan Kasperlik']},
{title:'Over the Garden Wall',
titleCZ:'Za zdí zahrady',
year:2014,
runtime:120,
episodeRuntime:'12min',
countries:['USA'],
genres:['Animation','Adventure','Drama'],
director:['Nate Cash','Ken Bruce','Robert Alvarez'],
actors:['Elijah Wood','Collin Dean','Melanie Lynskey','Christopher Lloyd','John Cleese','Shirley Jones','Fred Stoller','Chris Isaak','Tim Curry','Noureen DeWulf','Bebe Neuwirth','Thomas Lennon','Shannyn Sossamon','Audrey Wasilewski','Ashly Burch','Jenna Ortega','Emily Brundige','Mark Bodnar','Cole Sanchez','Sam Marin','Fiona Bishop'],
screenplay:['Steve Wolfhard','Natasha Allegri','Zac Gorman','Patrick McHale','Bert Youn','Aaron Renier','Jim Campbell','Laura Park','Pendleton Ward','Nick Edwards','Tom Herpich','Mark Bodnar','Cole Sanchez','Vi-Dieu Nguyen'],
production:['Pernelle Hayes'],
music:['The Blasting Company'],
sound:['Timothy J. Borquez','Nick Gotten III']},
{title:'Firefly',
titleCZ:'Firefly',
year:2002,
runtime:'10h 51min',
episodeRuntime:'42-86min',
countries:['USA'],
genres:['Sci-Fi','Adventure','Drama'],
director:['James A. Contner','Marita Grabiak','Joss Whedon','Vondie Curtis-Hall','Allan Kroeker','David Solomon','Michael Grossman','Thomas J. Wright','Tim Minear','Vern Gillum'],
actors:['Nathan Fillion','Gina Torres','Alan Tudyk','Morena Baccarin','Adam Baldwin','Jewel Staite','Sean Maher','Summer Glau','Ron Glass','Zac Efron','Mark Sheppard','Michael McMillian','James Kyson','Christina Hendricks','Richard Burgi','Melinda Clarke','Tom Towles','Gregg Henry','Doug Savant','Kevin Gage','Edward Atterton','Larry Drake','Joss Whedon','Andy Umberger','Katherine Kendall','Benito Martinez','Gregory Itzin','Isabella Hofmann','Eric Lange','Fredric Lehne','Dwier Brown','Erica Tazel','Richard Brooks','Valerie Red-Horse','Damion Poitier','Lyle Kanouse','Michael Fairman','Bonnie Bartlett','Jamie McShane','Tom Virtue','Larry Pennell','Andrew Bryniarski','Ilia Volok','Roy Werner','Blake Robbins','Roma Chugani','Michael Bentt','Kimberly McCullough','Tracy Ryan','Jordan Lund','Morgan Rusler','Franc Ross','Colin Patrick Lynch','Kevin Will','Al Pugliese','Carlos Jacott','Craig Vincent','Rolando Molina','Bob McCracken','Lina Patel','David Reynolds','John Eric Bentley','Jeff Ricketts','Jim Lau','William Converse-Roberts','Philip Sternberg','Kelly Wheeler','Laura Niemi','Ron Ostrow','Melody White','Dennis Cockrum','John Jabaley','John Thaddeus','Daniel Bess','Joel Steingold','Erik A. Passoja','Jared Poe','Roderick McCarthy','Michael Keyes'],
screenplay:['Joss Whedon','Tim Minear','Jane Espenson','Ben Edlund','Greg Edmonson','Jose Molina','Brett Matthews','Drew Z. Greenberg'],
production:['Gareth Davies'],
music:['Greg Edmonson'],
camera:['David Boyd'],
cut:['Lisa Lassek','John Peter Bernardo','Sunny Hodge'],
sound:['Cindy Rabideau','Mathew Waters','Joe Barnett','Kurt Kassulke','Tom Perry','Fred Tator','R. Russell Smith','William Freesh','Bill Jackson','Alan Decker','Kerri Wilson','Tony Lamberti','Jim Fitzpatrick','Sherry Klein','Deb Adair','Bobby Mackston','Peggy McAffee'],
scenography:['David A. Koneff','Colin De Rouin'],
masks:['Camille Calvet','Diana Acrey','Ketty Gonzalez'],
costumes:['Jill M. Ohanneson','Shawna Trpcic']},
{title:'Boardwalk Empire',
titleCZ:'Impérium - Mafie v Atlantic City',
year:2010,
runtime:'52h 34min',
episodeRuntime:'47-72min',
countries:['USA'],
genres:['Drama','History','Crime'],
director:['Timothy Van Patten','Allen Coulter','Martin Scorsese','Brad Anderson','Jeremy Podeswa','Brian Kirk','Alan Taylor','Simon Cellan Jones','Alik Sakharov','Susanna White','Ed Bianchi','Kari Skogland','Jake Paltrow','David Petrarca'],
actors:['Steve Buscemi','Dabney Coleman','Paz de la Huerta','Stephen Graham','Kelly Macdonald','Aleksa Palladino','Michael Pitt','Michael Shannon','William Hill','Vincent Piazza','Wrenn Schmidt','Martin Klebba','Shea Whigham','Michael Kenneth Williams','Blaise Corrigan','Michael Stuhlbarg','Anthony Laciura','James Schram','Harry L. Seddon','George Aloi','James P. Anderson','Dan Marshall','Emily Meade','Mark Lotito','Gretchen Mol','David Schallipp','Matthew Schallipp','Paul Sparks','Greg Antonacci','Danny Burstein','Dana Ivey','Joseph Sikora','Molly Parker','Tracy Middendorf','Christopher McDonald','Ben Livingston','Charlie Cox','Jack Huston','William Forsythe','Ted Rooney',"Kevin O'Rourke",'Julianne Nicholson','Mark Povinelli','Heather Chase','Bill Camp','John Cenatiempo','Max Casella','Bobby Cannavale','Billy Magnussen','James Cromwell','Stephen Root','Arron Shiver','Dominic Chianese','Christina Jackson','Peter McRobbie','Terence Winter','Ashlie Atkinson','Emma Kenney','Scott Jaeck','Suzanne Savoy','Francesca Scorsese','Ron Livingston','Jeffrey Wright','Meg Steedle','Randall Newsome','Ned Luke','Amy Warren','Patricia Arquette','Michael Badalucco','Tony Curran','Robert Clohessy','Margot Bingham','Nick Robinson','Josie Gallina','Lucy Gallina','Brian Geraghty','Fredric Lehne','Domenick Lombardozzi','Vincenzo Amato','Anatol Yusef','Louis Gossett Jr.','Jenna Gavigan','Nick Sandow','Emily Dorsch','T.J. Linnard','Malcolm Madera','Lauren A. Kennedy','Stephen Badalamenti','Heather Lind','Kathleen Wilce','Craig DiFrancia','Jonathan Dwyer',"Booch O'Connell",'Carolina Santos Read','Oona Mekas','Jordan Gelber','Gene Jones','Demosthenes Chrysan','Rick Crom','Ed Moran'],
basedOn:['Nelson Johnson'],
screenplay:['Howard Korder','Cristine Chambers','Steve Kornacki','Riccardo DiLoreto','Jennifer Ames','Steve Turner','David Flebotte','Margaret Nagle','David Matthews','Lawrence Konner','Diane Frolov','Andrew Schneider','Terence Winter','Paul Simms','Chris Haddock','Bathsheba Doran','Meg Jackson'],
production:['Joseph E. Iberti','David Coatsworth','Steve Turner','Brad Carpenter','Steve Kornacki'],
camera:['Stuart Dryburgh','Jonathan Freeman','David Franco','Kramer Morgenthau','Eric Moynier'],
cut:['Tim Streeto','Kate Sanford','Perri B. Frank'],
sound:['Ruy García','Bob Chefalas','Jeff Pullman'],
scenography:['Bill Groom','Bob Shaw','Carol Silverman'],
masks:['Michael Marino','Rachel Geary','Eldo Ray Estes','Michele Spooner','Nicki Ledermann','Jerry DeCarlo','Michael Fontaine'],
costumes:['John Dunn','Lisa Padovani']},
{title:'Avatar: The Last Airbender',
titleCZ:'Avatar: Legenda o Aangovi',
year:2005,
runtime:'26h 4min',
episodeRuntime:'23-48min',
countries:['USA'],
genres:['Animation','Adventure','Family','Fantasy','Action','Mystery'],
director:['Giancarlo Volpe','Ethan Spaulding','Lauren MacMullan','Dave Filoni','Joaquim Dos Santos','Michael Dante DiMartino','Anthony Lioi','Bryan Konietzko'],
actors:['Zach Tyler','Mae Whitman','Jack De Sena','Dante Basco','Jessie Flower','Dee Bradley Baker','Mako','Grey Griffin','Mark Hamill','Jim Meskimen','Jason Isaacs','Erik von Detten','Clancy Brown','Jon Polito','Phil LaMarr','René Auberjonois','James Hong','Kristoffer Tabori','Melendy Britt','Serena Williams','Rachel Dratch','Joe Alaskey','Hector Elizondo','Johanna Braddy','Marc Donato','John DiMaggio','Nika Futterman','James Arnold Taylor','Cameron Monaghan','David Jeremiah','Wade Williams','Melinda Clarke','Ross Thomas','Mitch Holleman','Erik Dellums','James Shigeta','Jim Ward','Robin Atkin Downes','Tara Strong','Gary Anthony Sturgis','Salome Jens','George Cheung','Raphael Sbarge','Courtenay Taylor','Andrew Caldwell','Roger Rose','Tsai Chin','Sab Shimono','Will Shadley','Brian George','Julianna Rose','Gabrielle Carteris','Barry Dennen','Nick Jameson','Robert Ito','Clement von Franckenstein','Keone Young','Bruce Locke','William Bassett','Leonard Stone','Daran Norris','Bonnie McNeil','Sean Marquette','Jamie Alcroft','Kevin Michael Richardson','Mick Foley','Karen Maruyama','Malachi Throne','Eric Bauza','Phil Proctor','Michael Yama','Chris Butler','Paul Nakauchi','Jillian Henry','Victor Brandt','Barbara Goodson','Bill Bolender','Jeanne Sakata','George Takei','Tom Kane','Keith Szarabajka','Clyde Kusatsu','Bryan Konietzko','Scott Menville','Robert Pine','Jennifer Hale','Amy Hill','John Kassir','Daniel Dae Kim','Laraine Newman','Fred Tatasciore','Carlos Alazraqui','Mick Foley','Adam Wylie','Walker Edmiston','Brian Tochi','Cameron Bowen','Lauren Tom','Greg Berg','Nicholas Guest'],
screenplay:['Michael Dante DiMartino','Bryan Konietzko','Aaron Ehasz',"John O'Bryan",'Elizabeth Welch Ehasz','Tim Hedrick','Joshua Hamilton','James Eagan','J.J. Abrams','Damon Lindelof','Lauren MacMullan','Pete Goldfinger','Josh Stolberg','Matt Hubbard','Justin Ridge','Giancarlo Volpe','Katie Mattila','Joann Estoesta','May Chan','Andrew Huebner','Scott Sonneborn'],
music:['Jeremy Zuckerman','Benjamin Wynn'],
cut:['Jeffrey Michael Adams'],
sound:['Benjamin Wynn','Jeremy Zuckerman','Tom Maydeck']},
{title:'The Mandalorian',
titleCZ:'Mandalorian',
year:2019,
runtime:'16h 29min',
episodeRuntime:'31-59min',
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Jon Favreau','Dave Filoni','Deborah Chow','Rick Famuyiwa','Bryce Dallas Howard','Taika Waititi','Peyton Reed','Carl Weathers','Robert Rodriguez','Rachel Morrison','Lee Isaac Chung','Peter Ramsey'],
actors:['Pedro Pascal','Gina Carano','Carl Weathers','Werner Herzog','Nick Nolte','Emily Swallow','Omid Abtahi','Taika Waititi','Giancarlo Esposito','John Beasley','Horatio Sanz','Tait Fletcher','Dmitrious Bistrevsky','Brian Posehn','Bernard Bullen','Dominic Pace','Ed Gage','Julia Jones','Eugene Cordero','Sala Baker','Amy Sedaris','Jake Cannavale','Ming-Na Wen','Rio Hackford','Troy Kotsur','Steve Blum','Mark Boone Junior','Bill Burr','Natalia Tena','Clancy Brown','Richard Ayoade','Ismael Cruz Cordova','Matt Lanter','Dave Filoni','Rick Famuyiwa','Deborah Chow','Adam Pally','Drew Hale','Jason Sudeikis','Rosario Dawson','Michael Biehn','Temuera Morrison','Katee Sackhoff','Timothy Olyphant','Mercedes Kaestner-Varnado','Mark Kubr','Misty Rosas','Paul Sun-Hyung Lee','Simon Kassianides','Titus Welliver','John Cameron Mitchell','Norwood Cheek','Alexander Wraith','Philip Alexander','Dee Bradley Baker','Trula M. Marcus','Morgan Benoit',"Katy M. O'Brian",'Diana Lee Inosanto','Gabriel Ebert','Richard Brake','Mark Hamill','Luke Baines','Max Lloyd-Jones','Matthew Wood','John Rosengrant','John Leguizamo','Isaac C. Singleton Jr.','Xavier Jimenez','W. Earl Brown','Dieterich Gray','Eli Jane','Asif Ali','David Choe','Thomas E. Sullivan','Christopher Lloyd','Aydrea Walden','Ahmed Best','Wesley Kimmel','Juan Javier Cardenas','Valarie Pettiford','Veanne Cox','Dylan Firshein','Matthew Bellows','James Chen','Max Fowler','Sunkrish Bala','Danny Jacobs','Logan Leistikow','Tim Meadows','Lateef Crowder','Parvesh Cheena','Nonso Anozie','Mat Fraser','Marti Matulis','Shirley Henderson','Jack Black','Lizzo','Christine Adams','Harry Holland'],
screenplay:['Jon Favreau','Rick Famuyiwa','Dave Filoni','Christopher L. Yost','Noah Kloor'],
production:['John Bartnicki'],
music:['Ludwig Göransson','Joseph Shirley'],
camera:['Greig Fraser','Barry Baz Idoine','Matthew Jensen','David Klein','Paul Hughen'],
cut:['Jeff Seibenick','Andrew S. Eisen','Dana E. Glauberman','Adam Gerstel','Dylan Firshein','Rachel Goodlett Katz'],
sound:['David Acord','Matthew Wood','Stephen Urata','Tony Villaflor'],
scenography:['Andrew L. Jones','Amanda Moss Serino','Doug Chiang','Dustin James Tiberend','Oana Bogdan Miller'],
masks:['Carlton Coleman','Alexei Dmitiew','Kevin Haney','John Blake','Jamie Kelman','Brian Sipe','Christopher Allen Nelson','Ashleigh Childers','Eryn Krueger Mekash','Sallie Ciganovich','Crystal Gomez'],
costumes:['Joseph A. Porro','Shawna Trpcic']},
{title:'Futurama',
titleCZ:'Futurama',
year:1999,
runtime:'59h 40min',
episodeRuntime:'22-30min',
countries:['USA'],
genres:['Animation','Comedy','Sci-Fi'],
director:['Chris Sauve','Gregg Vanzo','Wesley Archer','Rich Moore','Ron Hughart','Peter Avanzino','Bret Haaland','Brian Sheesley','Carlos Baeza','Jeffrey Lynch',"Kevin O'Brien",'Susie Dietter','Mark Ervin','Chris Louden','Dwayne Carey-Hill','Frank Marino','Swinton O. Scott III','Chris Loudon','James Purdum','Patty Shinagawa','Stephen Sandoval','Crystal Chesney','Raymie Muzquiz','Ray Claffey','Edmund Fong','Lance Kramer','Andrew Han'],
actors:['Billy West','Katey Sagal','John DiMaggio','Tress MacNeille','Maurice LaMarche','Lauren Tom','Phil LaMarr','David Herman','Dan Castellaneta','Tom Kenny','Bob Odenkirk','Al Gore','Pamela Anderson','Sigourney Weaver','Leonard Nimoy','Lucy Liu','Stephen Hawking','Nora Dunn','William Shatner','Walter Koenig','George Takei','Nichelle Nichols','Jonathan Frakes','Adam Yauch','Claudia Schiffer','John Goodman','Hank Azaria','Pauly Shore','Byrne Offutt',"Conan O'Brien",'Chris Elliott','Katee Sackhoff','Matt Groening','Bea Arthur','Mark Mothersbaugh','Craig Ferguson','Coolio','Buzz Aldrin','Patton Oswalt','Phil Hendrie','Wanda Sykes','David X. Cohen','Robert Wagner','Patrick Stewart','Dawnn Lewis','Emilia Clarke','Tara Strong','Frank Welker','Seth MacFarlane','Sarah Silverman','Adam West','Burt Ward','Adam Horovitz','Jan Hooks','Mike D','Estelle Harris','Suzie Plakson','Karen Maruyama','Todd Susman','Christopher Tyng','Nancy Cartwright','Dick Clark','Bob Barker','Parker Posey','Roseanne Barr','Dan Vebber','Eric Rogers','Peter Avanzino','Larry Bird','Jill Talley','Danny Jacobs','Kath Soucie','Mark Hamill','Brittany Murphy','David Cross','Bob Uecker','Beck','Bill Nye','Kevin Michael Richardson','Cara Delevingne'],
screenplay:['David X. Cohen','Kristin Gore','Ken Keeler','Bill Odenkirk','Jeff Westbrook','Brian Kelley','Eric Kaplan','Aaron Ehasz','J. Stewart Burns','Lewis Morton','Patric M. Verrone','Eric Horsted','Evan Gore','Heather Lombard','Eric Rogers','Ron Weiner','Dan Vebber','Jason Gorbett','Scott Kirby','Michael Rowe','David A. Goodman','Carolyn Premish','Maiya Williams','Josh Weinstein','Michael Saikin','Neil Mukhopadhyay','Robin Kingsland','Matt Groening','Thomas Hart','Brian Trueman','Cody Ziglar','Ariel Ladensohn'],
production:['J. Stewart Burns','Jason Grode','Claudia Katz','Lewis Morton','Geraldine Symon','Patric M. Verrone','Brian J. Cowan','Eric Horsted',"Jane O'Brien",'Bill Odenkirk','Eric Kaplan','Michael Rowe','Lee Supercinski','Ariel Ladensohn'],
music:['Christopher Tyng'],
camera:['Claudia Katz','Lee Supercinski'],
cut:['Paul D. Calder','Danik Thomas','Chris Vallance'],
sound:['Onnalee Blank','Ed Carr','John Hegedes','Robert Appere','Shaun Cunningham','Peter Cole','Travis Powers']},
{title:'Twin Peaks',
titleCZ:'Městečko Twin Peaks',
year:1990,
runtime:'42h 53min',
episodeRuntime:'46-94min',
countries:['USA'],
genres:['Drama','Mystery'],
director:['David Lynch','Lesli Linka Glatter','Caleb Deschanel','Duwayne Dunham','Tim Hunter','Todd Holland','Tina Rathborne','Graeme Clifford','Stephen Gyllenhaal','Diane Keaton','James Foley','Uli Edel','Jonathan Sanger','Mark Frost'],
actors:['Kyle MacLachlan','Michael Horse','Mädchen Amick','Dana Ashbrook','Richard Beymer','Sherilyn Fenn','Harry Goaz','Michael Ontkean','Lara Flynn Boyle','Warren Frost','Peggy Lipton','James Marshall','Everett McGill','Jack Nance','Kimmy Robertson','Joan Chen','Piper Laurie','Miguel Ferrer','Ray Wise','David Lynch','Wendy Robie','Russ Tamblyn','Eric DaRe','Sheryl Lee','Grace Zabriskie','Don S. Davis','Catherine E. Coulson','Al Strobel','Gary Hershberger','Chris Mulkey','David Patrick Kelly','Ian Buchanan','Chrysta Bell','Mary Jo Deschanel','Robert Forster','Naomi Watts','Kenneth Welsh','Laura Dern','Pierce Gagnon','Charlotte Stewart','John Pirruccello','Don Murray','Victoria Catlin','Brent Briscoe','Heather Graham','Robyn Lively',"Dan O'Herlihy",'Tom Sizemore','Robert Knepper','Jim Belushi','Eamon Farren','Amy Shiels','Michael J. Anderson','Michael Parks','Billy Zane','Frances Bay','Brenda Strong','Matt Battaglia','Lenny von Dohlen','Troy Evans','Frank Silva','Claire Stansfield','Jack McGee','Royal Dano','Van Dyke Parks','Alicia Witt','Kathleen Wilhoite','Ian Abercrombie','Tony Burton','Clarence Williams III','Molly Shannon','David Warner','Ted Raimi','Jane Greer','Austin Jack Lynch','Willie Garson','Don Calfa','Dave Bean','James Craven','Charlie Spradling','Hank Worden','John Apicella','Walter Olkewicz','Tony Jay','Peter Michael Goetz',"Gavan O'Herlihy",'Ritch Brinkley','Eve Brent','Joshua Harris','Robert Bauer','Galyn Görg','Jonny Coyne','Shane Lynch','Brian T. Finney','Scott Coffey','Judith Drake','Trent Reznor','Zoe McLane','Sabrina S. Sutherland','Max Perlich'],
screenplay:['David Lynch','Mark Frost','Harley Peyton','Jerry Stahl','Tricia Brock','Robert Engels'],
production:['Harley Peyton','Gregg Fienberg','David J. Latt'],
music:['Angelo Badalamenti'],
camera:['Frank Byers','Peter Deming','Ronald Víctor García'],
cut:['Mary Sweeney','Duwayne Dunham','Paul Trejo','Jonathan P. Shaw','David Lynch','Toni Morgan'],
sound:['Douglas Murray','David Parker','Jim Fitzpatrick','Adam Jenkins','Matt Sawelson','John A. Larsen','Gary Alexander','Richard Taylor','Walter Hoylman'],
scenography:['Richard Hoover','Ruth De Jong','Patricia Norris','Brian Kasch','Florencia Martin'],
masks:['Jamie Kelman','Allan A. Apone'],
costumes:['Sara Markowitz','Nancy Steiner','Patricia Norris']},
{title:'Gravity Falls',
titleCZ:'Městečko Záhad',
year:2012,
runtime:'15h 18min',
episodeRuntime:'21-29min',
countries:['USA'],
genres:['Animation','Comedy','Family','Horror'],
director:['Stephen Sandoval','Matt Braly','John Aoshima','Joe Pitt','Aaron Springer','Sunil Hall','Rob Renzetti'],
actors:['Jason Ritter','Alex Hirsch','Kristen Schaal','Linda Cardellini','Keith Ferguson','John DiMaggio','Will Forte','Grey Griffin','Tara Strong','Jennifer Coolidge','Dee Bradley Baker','Fred Tatasciore','Horatio Sanz','Greg Ellis','John Oliver','Joshua Rush','Gregg Turkington','Mckenna Grace','Carter Hastings','Kevin Michael Richardson','Kari Wahlgren','John Roberts','Eric Bauza','Justin Roiland','Thurop Van Orman',"John O'Hurley",'Chris Wylde','Chris Parnell','Niki Yang','Patrick McHale','Andrew Pifko','Will Friedle','Conrad Vernon','Coolio','Larry King','James Adomian','Pippa Haywood','Stephen Root','Ken Jenkins','T.J. Miller','Scott Menville','Alfred Molina','Diedrich Bader','Brian Bloom','Daryl Sabara','Corey Burton','Jeff Bennett','Lance Bass','Ken Hudson Campbell','Greg Cipes','Michael Rianda','Nick Offerman','Mark Hamill','Patton Oswalt','Jim Cummings','Nathan Fillion','Jorma Taccone','Jillian Bell','Paul Scheer','Neil deGrasse Tyson','Peter Serafinowicz','Jonathan Banks','J.K. Simmons',"'Weird Al' Yankovic",'Chelsea Peretti','Louis C.K.','Danielle Fishel','Jon Stewart','Kyle MacLachlan','Jennifer Cody','April Winchell','Frank Caliendo','Carl Faruolo','Kurt Braunohler','Facundo Reyes','Kimberly Brooks','Jackie Buscarino','Brad Abrell','Dave Wittenberg'],
screenplay:['Aury Wallington','Alex Hirsch','Nancy Cohen','Shion Takeuchi','Michael Rianda','Jeff Rowe','Josh Weinstein','Timothy McKeon','Mark Rizzo'],
production:['Rob Renzetti'],
music:['Brad Breeck'],
cut:['Kevin Locarro'],
sound:['Michael Beiriger','Ray Leonard','Fil Brown','Melissa Ellis','Heather Olsen'],
scenography:['Phil Rynda']},
{title:'One-Punch Man',
titleCZ:'One Punch Man',
year:2015,
runtime:'9h 36min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Comedy'],
director:['Šingo Nacume','Jóhei Suzuki','Jósuke Hatta',"Šin'ičiró Ušidžima",'Jošiaki Kawadžiri','Rjó Andó','Čikara Sakurai','Nobuhiro Mutó',"Shun'ichi Yoshizawa",'Makoto Sokuza','Hirojuki Okuno','Tomohiro Kamitani'],
actors:['Aoi Júki','Júki Kadži','Kendžiró Cuda','Mamoru Mijano','Masaja Onosaka','Teššó Genda','Daisuke Namikawa','Júdži Ueda',"Ken'iči Ogata",'Mijuki Sawaširo',"Šin'ičiró Miki",'Tomokazu Seki','Unšó Išizuka','Wataru Takagi','Tošijuki Morikawa','Minami Takajama','Kóki Učijama','Makoto Jasumura','Takahiro Sakurai','Satoši Hino','Júiči Nakamura','Kaito Išikawa','Tošiki Masuda','Jošimasa Hosoja','Sóičiró Hoši','Hiroki Jasumoto',"Šin'ja Hamazoe",'Šóta Jamamoto','Jošiaki Hasegawa','Nobuo Tobita','Kacujuki Koniši','Kósuke Toriumi','Rjúsei Nakao','Jukitoši Tokumoto','Kanami Sató','Saori Hajami','Kenta Sasa','Acuši Imaruoka','Makoto Furukawa','Harumi Ueda','Jódži Ueda','Kazuhiro Jamadži','Kimiko Saitó','Hiroki Gotó','Ami Naitó','Rikija Kojama','Masaja Macukaze','Wataru Hatano','Hikaru Midorikawa','Gen Sató','Ai Fairouz','Taiši Murata','Kaede Juasa','Risa Cumugi','Hiromiči Tezuka','Takuma Suzuki','Taró Jamaguči','Kaito Takeda','Sajumi Suzuširo','Šinnosuke Ogami','Reigo Jamaguči','Himari Močida','Rjó Sugisaki','Keisuke Hamaoka','Juka Iwahaši','Hitomi Sasaki','Sóta Arai','Júdžiró Kakuda','Acuši Ono','Júja Murakami','Ajaka Šimizu','Rie Hikisaka','Rena Maeda','Šómaru Zóza','Maju Sagara','Taró Kiuči','Saki Kósaka','Kento Širaiši','Ajumi Mano','Itaru Jamamoto','Naoki Bandó','Nacumi Fudžiwara','Takanori Hošino',"Šin'ja Fukumacu",'Hiroki Maeda','Takehito Kojasu','Jasuaki Takumi','Kendži Nomura','Júičiró Umehara','Tadanori Date','Hazuki Ogino','Juri Kimura','Jurika Aizawa','Džiró Saitó','Kana Motomija','Arisa Sekine','Hajato Fudžii','Sóširó Hori','Rjóta Jano','Ari Ozawa'],
basedOn:['One','Júsuke Murata'],
screenplay:['Tacuró Inamoto','Tomohiro Suzuki'],
music:['Makoto Mijazaki'],
camera:['Akane Fušihara','Jošio Ókóči'],
cut:['Masahiro Gotó'],
sound:['Jošikazu Iwanami','Šódži Hata'],
scenography:['Šigemi Ikeda','Jukiko Marujama']},
{title:'Hunter x Hunter',
titleCZ:'Hunter x Hunter',
year:2011,
runtime:'56h 44min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy','Comedy'],
director:['Hiroši Kódžina','Tomoja Takahaši','Jukijo Teramoto','Satoši Nišimura',"Džun'iči Fudžise",'Čie Jamaširo','Tomoja Tanaka',"Ken'iči Takešita",'Masatoši Hakata'],
actors:['Keidži Fudžiwara','Mijuki Sawaširo','Aja Hirano','Akio Ócuka','Daisuke Namikawa','Ičiró Nagai','Ikue Ótani','Mamiko Noto','Mamoru Mijano','Miina Tominaga','Romi Paku',"Šin'ičiró Miki",'Šúiči Ikeda','Takehito Kojasu','Tošihiko Seki','Činacu Akasaki','Hiroši Ótake','Júdži Ueda','Kotono Micuiši','Kóiči Jamadera','Rie Murakawa','Wataru Takagi','Tomohiro Nišimura','Kendži Ucumi','Issei Futamata','Kóki Učijama','Ajumi Fudžimura','Marina Inoue','Maaja Učida','Mikako Takahaši','Azusa Kataoka','Aja Endó','Rena Maeda','Wataru Hatano','Ičitaró Ai','Fumihiko Tačiki','Hiroši Janaka','Šizuka Okohira','Takaja Kuroda',"Šin'ja Hamazoe",'Tóru Nara','Uki Satake','Bandžó Ginga','Nobuo Tobita','Daiki Nakamura','Hirojuki Jošino','Šindži Kawada','Daisuke Kišio','Marija Ise','Akio Sujama','Makiko Ómoto','Masaki Aizawa','Čó','Noriko Hidaka',"Ken'jú Horiuči",'Takeharu Óniši','Kijojuki Janada','Jukitoši Tokumoto','Hirojuki Jokó','Hiroki Takahaši','Micuaki Hošino','Ikuko Tani','Takahiko Sakaguma','Motoki Takagi','Masaja Macukaze','Rjóta Ósaka','Megumi Macumoto','Hisako Kjóda','Kikuko Inoue','Čisa Jokojama','Miki Nagasawa','Tošiharu Sakurai','Takaši Macujama','Kjósei Cukui','Nobuaki Kanemicu','Mika Kanai','Eidži Hanawa','Tošio Furukawa','Motoko Kumai','Keiko Han',"Džu'iči Kanemaru",'Hidejuki Umezu','Hirofumi Nodžima','Jutaka Nakano','Júja Murakami','KENN','Rjóko Kinomija','Fumi Morisawa','Hidenobu Kiuči','Kimiko Saitó','Čika Anzai','Hiroki Gotó','Džunko Iwao','Masami Kikuči','Mačiko Tojošima','Masahiro Jamanaka','Taiten Kusunoki','Laura Megan Stahl','Rikija Kojama','Takuma Suzuki'],
basedOn:['Jošihiro Togaši'],
screenplay:['Micutaka Hirota','Acuši Maekawa','Fumijo Sakai','Šódži Jonemura','Cutomu Kamiširo','Jasuši Hirano'],
production:['Tecuto Motojasu','Kijóno Hirojuki','Tošio Nakatani','Naoki Iwasa','Acuši Kirimoto','Tomoko Jošino'],
music:['Jošihisa Hirano'],
camera:['Kazuja Arahata','Hiroši Inoue','Hironobu Hatanaka'],
cut:['Naoki Kasai','Satoši Terauči'],
sound:['Čiaki Jamada'],
scenography:['Mio Iššiki']},
{title:'House M.D.',
titleCZ:'Dr. House',
year:2004,
runtime:'129h 31min',
episodeRuntime:'42-90min',
countries:['USA'],
genres:['Drama','Mystery'],
director:['Peter Medak','Bryan Singer','Jace Alexander',"Peter O'Fallon",'Newton Thomas Sigel','Greg Yaitanes','Bryan Spicer','Guy Ferland','Daniel Attias','Nelson McCormick','Keith Gordon','Daniel Sackheim','Tim Hunter','Fred Gerber','Deran Sarafian','Paris Barclay','Frederick King Keller','Félix Enríquez Alcalá','Gloria Muzio','David Semel','James Hayman','John F. Showalter','Martha Mitchell','Laura Innes','David Platt','Tony To','Juan José Campanella','Katie Jacobs','Matt Shakman','Elodie Keene','Paul McCrane','David Straiton','Lesli Linka Glatter','Andrew Bernstein','Hugh Laurie','R. Lee Ermey','Matthew Penn','David Shore','Nick Gomez','Sanford Bookstaver','Tucker Gates','Miguel Sapochnik','S.J. Clarkson','Peter Weller','Bill Johnson','Tim Southam','Colin Bucksey','Julian Higgins','Randy Zisk','Kate Woods','Stefan Schwartz'],
actors:['Hugh Laurie','Omar Epps','Robert Sean Leonard','Jesse Spencer','Lisa Edelstein','Jennifer Morrison','Peter Jacobson','Olivia Wilde','Kal Penn','Odette Annable','Charlyne Yi','Anne Dudek','Jennifer Crystal Foley','Amber Tamblyn','Sela Ward','Michael Weston','Edi Gathegi','Cynthia Ettinger','David Morse','Karolina Wydra','Tracy Vilar','Chi McBride','Zena Grey','Andy Comeau','Currie Graham','Diane Baker','Andre Braugher','Ingrid Sanai Buron','Paula Marshall','Carmen Argenziano','Candice Bergen','Angel Oquendo','Lori Petty','Charles S. Dutton','Leighton Meester','Kimberly Quinn','America Olivo','Stacy Edwards','Brennan Elliott','Chloe Webb','Mike Starr','Brandy Norwood','Leslie Hope','Amanda Seyfried','Scott Foley','Meredith Monroe','Salli Richardson-Whitfield','Nestor Carbonell','Patrick Bauchau','Joe Morton','Kevin Brief','Diane Sellers','Shari Headley','Eddie McClintock','Skye McCole Bartusiak','John Cho','Matt Malloy','Peter Graves','Andrew Keegan','Josh Zuckerman','Brent Briscoe','Andi Eystad','Laura Allen','Keri Lynn Pratt','Lyndsy Fonseca','Frank Whaley','Piper Perabo','Robin Tunney','Andrew Airlie','Scott Mechlowicz','Robin Thomas','Wendy Gazelle','Cress Williams','Wings Hauser','Tom Lenk','Edward Kerr','Jessy Schram','Joel David Moore','Mira Sorvino','Nick Lane','Dakin Matthews','Johnny Sneed','Madison Bauer','Kadeem Hardison','R. Lee Ermey','Brian Klugman','Jayma Mays','Roxanne Hart','Dominic Purcell','Danny Nucci','Carmen Electra','Fred Durst','Elizabeth Mitchell','Clare Kramer','Allison Smith','Michael A. Goorjian','Greg Grunberg','Bryan Singer','Harry Lennix','Sarah Clarke'],
screenplay:['Garrett Lerner','Sara Hess','Seth Hoffman','David Hoselton','Michael R. Perry','John Mankiewicz','Sara B. Cooper','David Foster','Lawrence Kaplow','Sean Whitesell','Thomas L. Moran','Russel Friend','Danny Weiss','Peter Blake','Doris Egan','Kath Lingenfelter','Eli Attie','Matt Witten','David Shore','Joel Anderson Thompson','Liz Friedman','Marqui Jackson','Matthew V. Lewis'],
production:['David Foster','Gerrit van der Meer','Lawrence Kaplow','David Hoselton','Sara Hess'],
music:['Jason Derlatka','Jon Ehrlich','Christopher Hoag'],
camera:['Gale Tattersall','Walt Lloyd','Newton Thomas Sigel','Roy H. Wagner','Cort Fey'],
cut:['Jo Francis','Elliot Graham','Dorian Harris','Tatiana S. Riegel','Kimberly Ray','Bonnie Koehler','Stephen Semel','Bill Johnson','Christopher Nelson','Marta Evry','Chris Brookshire','David Post','Sue Blainey','Scott Boyd',"Arge O'Neal",'Anthony Pinker','Deborah Moran','Amy M. Fleming','Seth Clark','Chad Mochrie'],
sound:['Joe DeAngelis','Gerry Lentz','Richard Weingart','Brad North','Rob Young'],
scenography:['Derek R. Hill','Mark Hutman','Jennifer Herwitt','Danielle Berman','Amber Haley','Adam Rowe','Amy Wells','Robert W. Henderson'],
masks:['Edward French','Robin L. Neal','Kenny Niederbaumer','Rita Ciccozzi','Cynthia Shelley','Vivian Baker','Ozzy Alvarez','Janis Clark','Jori Jenae McGuire','Robert C. Mathews III','Diana Acrey','Toby Lindala','Carol McCoo','Ketty Gonzalez'],
costumes:['Cathy Crandall','Louise Mingenbach']},
{title:'Homeland',
titleCZ:'Ve jménu vlasti',
year:2011,
runtime:'84h 32min',
episodeRuntime:'45-84min',
countries:['USA'],
genres:['Crime','Drama','Mystery','Thriller'],
director:['Lesli Linka Glatter','Michael Cuesta','Daniel Attias','Alex Graves','Keith Gordon','Tucker Gates','Clark Johnson','Seith Mann','Michael Offer','Jeremy Podeswa','Lodge Kerrigan','Charlotte Sieling','Jeffrey Nachmanoff','Brad Turner','Guy Ferland','John David Coles','David Nutter','Carl Franklin','Jeffrey Reiner','Daniel Minahan','David Semel','John Dahl','Michael Klick','Nelson McCormick'],
actors:['Claire Danes','Mandy Patinkin','Rupert Friend','Damian Lewis','Maury Sterling','F. Murray Abraham','Morena Baccarin','Jackson Pace','Morgan Saylor','Elizabeth Marvel','David Harewood','Diego Klattenhoff','Tracy Letts','Linus Roache','David Marciano','Sarita Choudhury','Navid Negahban','Nimrat Kaur','Costa Ronin','Jamey Sheridan','Nazanin Boniadi','Sebastian Koch','Numan Acar','Miranda Otto','Alexander Fehling','Laila Robins','Sarah Sokolovic','Jake Weber','Morgan Spector','Amy Hargreaves','Hrach Titizian','Nina Hoss','Hill Harper','Andrea Deck','Cliff Chamberlain','Shaun Toub','Sam Trammell','Mark Ivanir','Zuleikha Robinson','Atheer Adel','C.J. Wilson','Dylan Baker',"Michael O'Keefe",'Sandrine Holt','James Rebhorn','Timothée Chalamet','Suraj Sharma','Mark Moses','Raza Jaffrey','René Ifrah','Chris Chalk','Allan Corduner','Tim Guinee','Erol Afsin','Taylor Kowalski','Micah Hauptman','Marin Ireland','William Abadie','Valerie Cruz','Marc Menchaca','Sebastian Hülk','Art Malik','Nick Boraine','Talia Balsam','Sam Underwood','Martin Wuttke','Allie McCulloch','Reza Brojerdi','Linda Purl','John Getz','Omid Abtahi','Afton Williamson','Ramsey Faragallah','Mido Hamada','Jason Butler Harner','William Sadler','Mehdi Nebbou','Gary Wilmes','Max Volkert Martens','Matthias Gall','Scott Bryce','Amir Arison','Clara Khoury','Martin Donovan','Emily Donahoe','Charles Borland','Brianna Lynn Brown','Marcia DeBonis','Larry Pine','Reggie Austin','Melissa Benoist','Daniel Newman','Jonah Lotan','Pedro Pascal','Daniella Pineda','Justin Wheelon','Matt Cornwell','Tamara Arias','Dane Northcutt','Loai Nofi'],
screenplay:['Chip Johannessen','Alex Gansa','Patrick Harbinson','Meredith Stiehm','Alexander Cary','Ron Nyswaner','Henry Bromell','Debora Cahn','Barbara Hall','David Fury','Charlotte Stoudt','William Bromell','James Yoshimura','Ted Mann','Evan Wright','Benjamin Cavell','Howard Gordon','Gideon Raff','Liz Flahive','Anya Leta'],
production:['Mandy Patinkin','Michael Klick','Claire Danes','Charlotte Stoudt','Evan Wright','Sunday Stevens'],
music:['Sean Callery'],
camera:['David Klein','Nelson Cragg','Giorgio Scali','Chris Manley','Peter Levy'],
cut:['Harvey Rosenstock','Terry Kelley','Philip Carr Neel','Jordan Goldman','Joe Hobeck','Michael Ruscio','David Latham','Garret Donnelly','Victoria Grimsley','Sarah Zeitlin'],
sound:['Craig A. Dellinger','Patrick Veigel','Nello Torri','Alan Decker'],
scenography:['John D. Kretschmer','Jerry Fleming','Patti Podesta','Ido Dolev','Carlos Osorio','Ricky Eyres','William A. Cimino','Monica Monserrate','Judy Farr','Sabine Schaaf','Donal Woods','Ellen Totleben'],
masks:['Talli Pachter','Rhonda Bareford','Stephanie Barr','Jackie Risotto','Annett Schulze'],
costumes:['Stephen K. Randolph','Marina Draghici','Debra Beebe']},
{title:'BoJack Horseman',
titleCZ:'BoJack Horseman',
year:2014,
runtime:'33h 27min',
episodeRuntime:'25-27min',
countries:['USA'],
genres:['Animation','Comedy','Drama'],
director:['Joel Moser','Amy Winfrey','Tim Rauch','Matt Garofalo','Mollie Helms','Mike Roberts','James Bowman','Anne Walker Farrell','Aaron Long','Adam Parton','Peter Merryman','Mike Hollingsworth'],
actors:['Will Arnett','Alison Brie','Amy Sedaris','Paul F. Tompkins','Aaron Paul','Minae Noji','Aisha Tyler','Olivia Wilde','Patton Oswalt','J.K. Simmons','Kristen Schaal','Margo Martindale','Ken Jeong','Anjelica Huston','Stanley Tucci','Naomi Watts','Wallace Shawn','Kristin Chenoweth','Judy Greer','Stephen Colbert','John Krasinski','Jon Daly','Adam Conover','Maria Bamford','Kevin Bigley','Rachel Bloom','Philip Baker Hall','June Diane Raphael','Greg Kinnear','Ali Wong','Jermaine Fowler','James Adomian','Chris Cox','Larry Clarke','Raphael Bob-Waksberg','Nicholas Gonzalez','Fred Tatasciore','Heléne Yorke','Wendie Malick','Diedrich Bader','Lake Bell','Andre Braugher','David Chase','Kelen Coleman',"Vincent D'Onofrio",'Raúl Esparza','Abbi Jacobson','Phil LaMarr','Matthew Broderick','Colman Domingo','Paul Giamatti','Jane Krakowski','Lin-Manuel Miranda','Gabourey Sidibe','Keith David','Kimiko Glenn','Tim Gunn','Sharon Horgan','Marc Jacobs','Harvey Fierstein','Kathy Najimy','Archie Panjabi','Cedric Yarbrough','Felicity Huffman','Ben Schwartz','Jessica Biel','Zach Braff','Ginger Gonzaga','RuPaul','Hannibal Buress','Jake Johnson','Patti LuPone','Martin Short','Kristen Bell','Sasheer Zamata','Rami Malek','Natalie Morales','Jay Pharoah','Majandra Delfino','David Walton','Rob Morrow','Fred Savage','Nicole Sullivan','Jason Beghe','Kevin Bigley','Brandon T. Jackson','Keegan-Michael Key','John Krasinski','George Takei','Lena Hall','Aja Naomi King','Lisa Kudrow','Joel McHale','Henry Winkler','Paul McCartney','Sheila Vand','Khandi Alexander','Ron Funches','Amy Schumer','Alan Arkin'],
screenplay:['Raphael Bob-Waksberg','Scott Marder','Jordan Young','Elijah Aron','Mehar Sethi','Vera Santamaria','Shauna McGarry','Caroline Williams','Joanna Calo','Joe Lawson','Laura Gutin','Kelly Galuska','Kate Purdy','Nick Adams','Jonny Sun','Alison Tafel'],
production:['Will Arnett','Raphael Bob-Waksberg','Corey Campodonico','Mehar Sethi','Vera Santamaria','Joe Lawson','Laura Gutin','Kelly Galuska','Richard Choi','Mike Hollingsworth','Nick Adams','Shauna McGarry'],
music:['Jesse Novak'],
cut:['Molly Yahr','Jose L. Martinez','Brian Swanson'],
sound:['Hunter Curra','Konrad Piñon']},
{title:'Berserk',
titleCZ:'Kenpú denki Berserk',
year:1997,
runtime:'9h 10min',
episodeRuntime:'22min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy','Horror'],
director:['Naohito Takahaši','Jasuhiro Geši','Jukio Okazaki','Masakazu Amija','Kódži Jošikawa','Kazuja Curumaki','Kazuhisa Óno','Mihiro Jamaguči','Jasuhiro Macumura','Jukina Hiiro'],
actors:['Nobutoši Kanna','Tošijuki Morikawa','Júko Mijamura','Tomohiro Nišimura','Akira Išida','Masuo Amada','Akiko Jadžima','Teššó Genda','Juri Širatori','Tamio Óki','Norio Wakamoto','Masahito Kawanago','Rjúdži Mizuno','Mahito Cudžimura','Tošiko Sawada','Kendži Ucumi','Ikuja Sawaki','Šódži Óki','Tóru Ókawa','Naoki Bandó','Unšó Išizuka','Acuko Tanaka','Ikuo Nišikawa','Takaši Irie','Majumi Asano','Tomoe Hanba','Juki Masuda','Jutaka Aojama','Eidži Sekiguči','Jasujuki Kase','Hirojuki Jokó','Šóto Kašii','Hideto Ebihara','Masajuki Nakata','Hideki Ogihara','Kan Tokumaru','Minami Takajama','Čafúrin','Hiroši Naka','Takuró Kitagawa','Masako Isobe','Acuši Ii','Masaši Sugawara','Eidži Marujama','Noriko Suzuki','Jú Šimaka','Ken Širojama','Hadžime Koseki','Fumio Macuoka','Orine Fukušima','Keisuke Jamašita','Júdži Fudžiširo','Tomoko Miura','Jósuke Naka'],
basedOn:['Kentaró Miura'],
screenplay:['Šódži Jonemura','Šinzó Fudžita','Acuhiro Tomioka','Makoto Itakura','Jukijoši Óhaši'],
production:['Tošio Nakatani'],
music:['Susumu Hirasawa'],
camera:['Micunobu Jošida'],
cut:['Tošio Henmi'],
sound:['Satoši Kató'],
scenography:['Šičiró Kobajaši']},
{title:'1883',
titleCZ:'1883',
year:2021,
runtime:'9h 21min',
episodeRuntime:'44-67min',
countries:['USA'],
genres:['Drama','Western'],
director:['Taylor Sheridan','Christina Alexandra Voros','Ben Richardson'],
actors:['Sam Elliott','Tim McGraw','Isabel May','LaMonica Garrett','Billy Bob Thornton','James Landry Hébert','Faith Hill','Tom Hanks','Stephanie Nur','Dawn Olivieri','Marc Rissmann','Rita Wilson','James Jordan','Amanda Jaros','Noah Le Gros','Martin Sensmeier','David Midthunder','Tokala Clifford','Charles Baker','Taylor Sheridan','Michael Spears','Morgan Lester','Jeremy Gauna','Konstantin Melikhov','Courtney Herbst','Graham Greene','Alex Fine','Emma Malouff','Jordan Walker Ross'],
screenplay:['Taylor Sheridan'],
production:['David Hutkin'],
music:['Brian Tyler','Breton Vivian'],
camera:['Christina Alexandra Voros','Ben Richardson'],
cut:['Chad Galster','Nathan Gunn'],
sound:['Samuel Ejnes','Diego Gat','George Haddad'],
scenography:['Carla Curry','Cary White'],
masks:['Tim Muir'],
costumes:['Janie Bryant']},
{title:'The Sinful People of Prague',
titleCZ:'Hříšní lidé města pražského',
year:1968,
runtime:'10h 25min',
episodeRuntime:'38-54min',
countries:['Czechoslovakia'],
genres:['Crime','Comedy','Drama'],
director:['Jiří Sequens st.'],
actors:['Jaroslav Marvan','Josef Bláha','Josef Vinklář','František Filipovský','Gustav Nezval','Helena Růžičková','Luba Skořepová','Jaroslav Mareš','Jaroslav Raušer','Oldřich Velen','Jiří Smutný','Josef Beyvl','Eduard Dubský','Jan Libíček','Helga Čočková','Zdeněk Dítě','Ladislav Gzela','František Hanus','Vlastimil Hašek','Karel Houska','Václav Kaňkovský','Lubomír Kostelka','Zdeněk Kryzánek','Oldřich Lukeš','Jiří Lír','Rudolf Macharovský','Vladimír Menšík','Míla Myslíková','Jindřich Narenta','Petr Oliva','Karel Pavlík','Jaroslav Satoranský','Blažena Slavíčková','Jiří Sovák','Otto Šimánek','Věra Tichánková','Miloš Vavruška','Josef Větrovec','Miloš Willig','Stella Zázvorková','Svatopluk Beneš','Ladislav Boháč','Zdeněk Braunschläger','Květa Fialová','Hana Kreihanslová','Ladislav Potměšil','Jan Šmíd','Jana Šulcová','Jitka Zelenohorská','Josef Bek','Kamil Blahovec','Zdeněk Blažek','Božena Böhmová','Jiří Bruder','Radoslav Brzobohatý','Jaroslav Cmíral','Bohuslav Čáp','Jana Drbohlavová','Josef Elsner','Stanislav Fišer','Nataša Gollová','Libuše Havelková','Gustav Heverle','Jaroslav Heyduk','Jana Hlaváčová','Jiří Holý','Josef Kemr','Jiří Kodet','Miloš Kopecký','Václav Kotva','Ferdinand Krůta','Otto Lackovič','Pavel Landovský','Václav Lohniský','Růžena Lysenková','Marie Marešová','Pavla Maršálková','Adolf Minský','Jaroslav Moučka','Milan Neděla','Miloš Nesvadba','Stanislav Neumann','Ivo Niederle','Miroslav Nohýnek','Jiří Novotný','Viktor Očásek','Jiří Plachý ml.','Nina Popelíková','Ilja Prachař','Zdeněk Procházka','Ilja Racek','Vladimír Ráž','Martin Růžek','Zdeněk Řehoř','Jan Skopeček','Jiřina Steimarová','Lubomír Lipský st.','Pavel Spálený','František Svačina','Martin Štěpánek'],
basedOn:['Jiří Marek'],
screenplay:['Jiří Sequens st.'],
music:['Zdeněk Liška'],
camera:['Miloslav Harvan'],
cut:['Jan Chaloupek'],
sound:['Adolf Nacházel'],
scenography:['Karel Černý','Přemysl Longa','Vladimír Mácha'],
masks:['František Novotný'],
costumes:['Zdena Kadrnožková','Svatava Sophová','Zdena Mannová','Vlastimil Hasala']},
{title:'Downton Abbey',
titleCZ:'Panství Downton',
year:2010,
runtime:'50h 22min',
episodeRuntime:'47-120min',
countries:['UK'],
genres:['Drama','Romance'],
director:['Brian Percival','Ben Bolt','Brian Kelly','Andy Goddard','Brian Kelly','Ashley Pearce','James Strong','Jeremy Webb','David Evans','Catherine Morshead','Philip John','Edward Hall','Jon East','Minkie Spiro','Michael Engler'],
actors:['Hugh Bonneville','Laura Carmichael','Jim Carter','Brendan Coyle','Maggie Smith','Elizabeth McGovern','Penelope Wilton','Joanne Froggatt','Michelle Dockery','Siobhan Finneran','Dan Stevens','Ian Kelly','Theo James','Robert James-Collier','Jessica Brown Findlay','Rose Leslie','Iain Glen','Maria Doyle Kennedy','Matt Milne','Charlie Cox','Phyllis Logan','Allen Leech','Ed Speleers','Samantha Bond','Kevin McNally','Shirley MacLaine','Michael Culkin','Clare Calbraith','Richard Hawley','Brendan Patricks','Tom Cullen','Lachlan Nieboer','Lily James','Sophie McShera','Lesley Nicol','Zoe Boyle','Thomas Howes','Amy Nuttall','Jonathan Howard','MyAnna Buring','Charles Edwards',"Hugh O'Brien",'Edward Baker-Duly','Terence Harvey','Raquel Cassidy','Jonathan Coy','Cara Theobold','Matt Barber','David Robb','Paul Copley','Poppy Drayton','Simon Lowe','Matthew Goode','Rupert Frazer','Josh Green','Phoebe Nicholls','Martin Walsh','Nicky Henson','Richard Hansell','Brian Kelly','Robert Bathurst','Cal MacAninch','Julian Wadham','Jeremy Swift','Sue Johnston','Antonia Bernath','Harriet Walter','Sebastian Dunn','Rachel Marquez','Ronald Pickup','Nichola Burley','Adrian Lukis','Alun Armstrong','James Faulkner','Penny Downie','Rade Šerbedžija','Jane Lapotaire','Alice Patten','Peter Egan','Catherine Steadman','Julian Ovenden','Matthew Jure','Daisy Lewis','Richard E. Grant','Christopher Rozycki','Scott Plumridge','Anna Chancellor','James Joyce','Paul Giamatti','James Fox','Janet Montgomery','Patrick Kennedy','Richard Dempsey','Joanna David','Kiri Te Kanawa','Alex Carter','Ron Donachie','John Henshaw','Simone Lahbib','Clare Higgins'],
screenplay:['Julian Fellowes','Shelagh Stephenson','Tina Pepler'],
production:['Nigel Marchant','Liz Trubridge','Rupert Ryle-Hodges','Chris Croucher'],
music:['John Lunn'],
camera:['Nigel Willoughby','David Katznelson','David Marsh','Gavin Struthers','Graham Frake','Michael McDonough','David Raedeker','Adam Gillham'],
cut:['Alex Mackie','John Wilson','Steve Singleton','Paul Garrick','Justin Krish','Mike Jones','Al Morrow','Alex Kalmakrian'],
sound:['Mark Holding'],
scenography:['Gina Cromwell','Judy Farr','Donal Woods'],
masks:['Amy Boyd','Julio Parodi','Chris Redman','Nora Robertson','Linzi Bowen','Nadia Stacey','Marc Pilcher','David Malinowski','Doone Forsyth'],
costumes:['Caroline McCall','Anna Robbins','Rosalind Ebbutt']},
{title:'Gomorrah: The Series',
titleCZ:'Gomora',
year:2014,
runtime:'48h 20min',
episodeRuntime:'42-57min',
countries:['Italy','Germany'],
genres:['Crime','Drama','Thriller'],
director:['Stefano Sollima','Claudio Cupellini','Francesca Comencini','Claudio Giovannesi',"Marco D'Amore",'Enrico Rosati','Ciro Visco'],
actors:["Marco D'Amore",'Fortunato Cerlino','Salvatore Esposito','Fabio De Caro','Christian Giroso','Giovanni Buselli','Carmine Monaco','Lino Musella','Marco Palvetti','Maria Pia Calzone','Domenico Balsamo','Emanuele Vicorito','Carmine Battaglia','Alessio Gallo','Gaetano di Vaio','Massimiliano Rossi','Gianluca Di Gennaro','Cristina Donadio','Alfonso Postiglione','Luca Gallone','Antonio Ciccone','Antonio Folletto','Daniele Vicorito','Pina Turco','Riccardo Ciccarelli','Vincenzo Pirozzi','Vittoria Scognamiglio','Liana Balogun','Denise Capezza','Rinat Khismatouline','Matilde Gioli','Antonio Giancarlo Zavatteri','Gino Romano','Antonio Milo','Bianca Nappi','Raffaella Anzalone','Danilo Bonfante','Anna Brancati','Giovanni Auriemma','Simone Borrelli','Riccardo Avitabile','Fabio Bellomunno','Anna Cacace','Alessandro Bressanello','Elena Starace','Alfredo Herrera','Ivana Lotito','Nino Porzio','Gianfranco Gallo','Francesco Meoni','Michelangelo Dalisi',"Rosario D'Angelo",'Nello Mascia',"Cristiana Dell'Anna",'Irene Maiorino','Andrea Di Maria','Carlos Caracciolo','Gaetano Amato','Franco Marino','Mimmo Esposito','Gennaro Canonico','Andrea Renzi','Louise Brealey','Nikola Dodov','Barry Ward','Loris De Luna','Pavel Zelinskiy','Gianni Parisi','Luciano Giugliano','Carlo Caracciolo','Autilia Ranieri','Arturo Muselli','Pierluigi Cuomo','Maria Bakalova','Claudia Tranchese','Tommaso Caporali','Ciro Ruoppo','Andrea Avagliano','Gennaro Iaccarino','Gianni Spezzano','Francesco Alia','Alessandro Coppeto','Dominic Borrelli','Tania Garribba','Antonio Gargiulo','Gennaro Apicella','Gennaro Maresca','Saverio Mattei','Ciro Esposito','Renato De Simone','Cristiano Coppeto','Giuseppe De Vncentis','Giuseppe Di Donna','Francesco Esse','Francesco Fontanella','Andrea Grasso','Sunaj Hasani','Ciro Mazza','Paolo Mendozzi','Lucienne Perreca'],
basedOn:['Roberto Saviano'],
screenplay:['Stefano Bises','Leonardo Fasoli','Roberto Saviano','Ludovica Rampoldi','Maddalena Ravagli','Filippo Gravino','Gianluca Leoncini'],
music:['Mokadelic'],
camera:['Paolo Carnera',"Michele D'Attanasio",'Ivan Casalgrandi','Guido Michelotti'],
cut:['Patrizio Marone'],
sound:['Maricetta Lombardo','Carmine Razzano','Francesco Tumminello','Angelo Bonanni','Alessandro Rolla','Andrea Lancia','Gianluca Costamagna'],
scenography:['Michelle Sotheren','Paki Meduri','Carmine Guarino','Emma Davis','Daniele Frabetti','Simone Taddei','Iole Autero'],
masks:['Rosa Falco','Donatella Borghesi','Giulio Pezza','Peter Nicastro','Aniello Piscopo','Sharim Sabatini','Federico Carretti','Angelo Vannella'],
costumes:['Veronica Fragola','Susanna Mastroianni']},
{title:'Adventure Time',
titleCZ:'Čas na dobrodružství',
year:2010,
runtime:'55h 39min',
episodeRuntime:'11-44min',
countries:['USA'],
genres:['Animation','Adventure','Comedy','Fantasy'],
director:['Bong Hee Han','Larry Leichliter','Elizabeth Ito','Andres Salaff','Adam Muto','Kent Osborne',"David O'Reilly",'Kirsten Lepore','Diana Lafyatis','Cole Sanchez','Lindsey Pollard'],
actors:['Jeremy Shada','John DiMaggio','Tom Kenny','Hynden Walch','Niki Yang','Dee Bradley Baker','Pendleton Ward','Maria Bamford','Steve Little','Olivia Olson','Kent Osborne','Brian Posehn','Tracy Morgan','Mark Hamill','Henry Rollins','Fred Tatasciore','George Takei','Clancy Brown','Isabella Acres','Michael Dorn','Neil Patrick Harris','Kumail Nanjiani','Jonathan Frakes','Brian Doyle-Murray','Matt Jones','Ron Perlman','Kerri Kenney','Ron Lynch','Marc Maron','Johnny Pemberton','Alan Oppenheimer','Max Charles','Dan Mintz','Ashly Burch','Jessica Anne Bogart','Gregg Turkington','Tig Notaro','Lou Ferrigno','Steve Agee','Ava Acres','Bobcat Goldthwait','Kevin Michael Richardson','Mark Proksch','Eric Bauza','Tipper Newton','Brett Gelman','Jonathan Katz','James Adomian','Justin Roiland','Jill Talley','Kyle Kinane','Rae Gray','Cameron Esposito','Paul Williams','Melissa Villaseñor','Andres Salaff','Jack Pendarvis','Steve Wolfhard','Keith Ferguson','John Kassir','Tom Wilson','Erik Estrada','Clancy Brown','Peter Stormare','Jeff Bennett','Tom Herpich','Paul Reubens','Stephen Root','Davey Johnson','Michael J. Anderson','Miguel Ferrer','Andy Samberg','Kate Micucci','Toby Huss','Brian Baumgartner','Grey Griffin','Maurice LaMarche','Madeleine Martin','Rich Fulcher',"'Weird Al' Yankovic",'Keith David','Susie Essman','Donald Faison','Matthew Broderick','Paul F. Tompkins','Ming-Na Wen','Cloris Leachman','James Kyson','M. Emmet Walsh','Jim Cummings','Kristen Schaal','Donald Glover','Shyloh Oostwald','Wallace Shawn','LeVar Burton','Riki Lindhome','Chuck McCann','Aziz Ansari','Isabelle Fuhrman','Paul Scheer'],
screenplay:['Pendleton Ward','Kent Osborne','Adam Muto','Jesse Moynihan','Rebecca Sugar','J.G. Quintel','Andres Salaff','Steve Wolfhard','Niki Yang','Elizabeth Ito','Tom Herpich',"David O'Reilly",'Kirsten Lepore','Patrick McHale','Skyler Page','Luke Pearson','Aleks Sennwald','Peter Browngardt','Bert Youn','Natasha Allegri','Cole Sanchez','Sean Jimenez','Hanna K. Nyström','Laura Knetzger','Luther McLaurin','Somvilay Xayaphone','Graham Falk','Sam Alden','Kris Mukai','Polly Guo','Seo Jung Kim','Ako Castuera'],
production:["David O'Reilly",'Keith Mack','Thurop Van Orman','Kelly Crews','Nick Jennings','Kevin Kolde'],
music:['Rich Vreeland','Pendleton Ward','Timothy Kiefer','Casey James Basichis'],
camera:['Helder Sun'],
cut:['Paul Douglas'],
sound:['Timothy J. Borquez','Thomas Syslo','Pedro Sánchez Alonso','Eric Freeman','Nick Gotten III'],
scenography:["David O'Reilly",'Sandra Lee','Nick Jennings']},
{title:'The Night Of',
titleCZ:'Jedna noc',
year:2016,
runtime:'8h 48min',
episodeRuntime:'57-96min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Steven Zaillian','James Marsh'],
actors:['Riz Ahmed','John Turturro','Bill Camp','Michael Kenneth Williams','Jeannie Berlin','Payman Maadi','Amara Karan','Poorna Jagannathan','Paul Sparks','Afton Williamson','Paulo Costanzo',"Sofia Black-D'Elia",'Glenne Headly','Ben Shenkman','J.D. Williams','Ned Eisenberg','Mohammad Bakri','Chip Zien','Jeff Wincott','Max Casella','Steve Cirbus','Skipp Sudduth','Mike Figueroa','Fisher Stevens','Kevin Dunn','Carlo Alban','Frank Wood','Adam Piacente','Nicholas Turturro','Jonny Coyne','Joseph Latimore','Adam LeFevre','Catherine A. Callahan','Sticky Fingaz','Pernell Walker','Scott Menville','Jeremy Shamos','Michael Rivera','Vincent Laresca','Bobby Di Cicco','Michael Buscemi','Patch Darragh','Chris Bryant','Otoja Abit','Paul Carafotes','Mellini Kantayya','Mustafa Shakir','Aida Turturro','Joe Egender','Yvonne Zima','Glenn Fleshler','Andrew Stewart-Jones','Daniel Gadi','Will Janowitz','Moniere','Don Harvey','Robert C. Kirk','Ashley Thomas','Eddie Cooper','Manny Perez','Esau Pritchett','Michael J. Burg','Cliff Moylan','Marcus Callender','Sean Ringgold','LaChanze','Ray Abruzzo','Roscoe Orman','Chris Perfetti','Aubrey Joseph','Sam Gilroy','Babs Olusanmokun','Victor Verhaeghe','Nicholas J. Coleman','Bryan Burton','Jimmy Palumbo','Reginald L. Barnes','Frank De Julio','Carter Hudson','Albert Jones','Jesús Padilla','Anthony Mangano','Donovan Christie Jr.','Terron Jones','Steven Randazzo','Joshua Bitton','Tijuana Ricks','Garrett Basch','Saycon Sengbloh','Michael Braun','Frank Ridley','Charles Brice','Malachi Weir','James L. Ward','Racquel Palmer','Lennie Loftin','Russell G. Jones','Wallace Smith','Sharrieff Pugh','Aaron Moten'],
screenplay:['Steven Zaillian','Richard Price'],
production:['Scott Ferguson'],
music:['Jeff Russo'],
camera:['Igor Martinović','Frederick Elmes','Robert Elswit'],
cut:['Jay Cassidy','Nick Houy'],
sound:['Nicholas Renbeck','Warren Shaw','Larry Hoff'],
scenography:['Patrizia von Brandenstein','Lester Cohen','Keri Lederman','Melanie J. Baker'],
masks:['Stephen Kelley','Kaela Dobson'],
costumes:['Catherine George','Julie Weiss']},
{title:'Ted Lasso',
titleCZ:'Ted Lasso',
year:2020,
runtime:'23h 20min',
episodeRuntime:'29-69min',
countries:['USA'],
genres:['Comedy','Drama','Sport'],
director:['Tom Marshall','Declan Lowney','Elliot Hegarty','Zach Braff','M.J. Delaney','Ezra Edelman','Erica Dunton','Matt Lipsey','Sam Jones','Destiny Ekaragha'],
actors:['Jason Sudeikis','Brendan Hunt','Stephen Manas','Nick Mohammed','Bronson Webb','Juno Temple','Hannah Waddingham','Jeremy Swift','Teresa Mahoney','James Lance','Phil Dunster','Brett Goldstein','Toheeb Jimoh','Annette Badland','Kola Bokinni','Craig Conway','Shaun Prendergast','Daniel Eghan','Jimmy Akingbola','Anthony Head','Keeley Hazell','Susan Tracy','Anwar Lynch','Andrea Anders','Ellie Taylor',"Kieran O'Brien",'Andrew Bradley','Sarah Niles','Cristo Fernández','Ruth Bradley','Patrick Baladi','David Elsendoorn','Hugh Futcher','Bill Fellows','Raffaello Degruttola','Emilio Doorgasingh','Claire Skinner','Thomas Howes','Harriet Walter','Rich Keeble','Phoebe Walsh','Sidse Babett Knudsen','Sofia Barclay','Nonso Anozie','Thierry Henry','Charlotte Spencer','Jason Hillhouse','Dan Brothers','Alice Nokes','Tom Parry','Bill Paterson','Charlie Rawes','Ninette Finch','Sam Richardson','Kiki May','Elodie Blomfield','Katy Wix','Maximilian Osinski','Ambreen Razia',"Mike O'Gorman",'Precious Mustapha','Tim Bentinck','Stephen Frost','Edyta Budnik','Jodi Balfour','Jadran Malkovich','Peter Landi','Matteo van der Grijn','Carly Wijs','Carolina Dijkhuizen','Mary Roubos','Corey Burton','Mark Kempner','Malcolm Rennie','Ryan Stiles','Colin Mochrie','Andy Umerah','Steve Edge'],
screenplay:['Bill Lawrence','Jason Sudeikis','Joe Kelly','Jane Becker','Brett Goldstein','Bill Wrubel','Brendan Hunt','Leann Bowen','Ashley Nicole Black','Phoebe Walsh','Jamie Lee','Sasha Garron','Chuck Hayward','Keeley Hazell','Dylan Marron'],
production:['Brendan Hunt','Bill Lawrence','Ashley Nicole Black','Leann Bowen','Declan Lowney','Phoebe Walsh','Matt Lipsey','Kip Kroeger'],
music:['Marcus Mumford','Tom Howe'],
camera:['David Rom','John Sorapure','Ryan Kernaghan','Vanessa Whyte'],
cut:['Melissa McCoy','Alex Szabo','A.J. Catoline'],
sound:['Sean Byrne','Kip Smedley','Ryan Kennedy'],
scenography:['Paul Cripps','Bethany Doughty'],
masks:['Nicola Pope'],
costumes:['Jacky Levy']},
{title:'Black Mirror',
titleCZ:'Černé zrcadlo',
year:2011,
runtime:'26h 45min',
episodeRuntime:'41-90min',
countries:['UK'],
genres:['Drama','Comedy','Horror','Sci-Fi','Thriller'],
director:['Otto Bathurst','Euros Lyn','Brian Welsh','Owen Harris','Carl Tibbetts','Bryn Higgins','James Watkins','Joe Wright','Jakob Verbruggen','James Hawes','Dan Trachtenberg','Jodie Foster','Toby Haynes','John Hillcoat','Timothy Van Patten','David Slade','Colm McCarthy','Anne Sewitsky','Ally Pankiw','Sam Miller','John Crowley','Uta Briesewitz'],
actors:['Rory Kinnear','Daniel Kaluuya','Julia Davis','Isabella Laughland','Colin Michael Carmichael','Jessica Brown Findlay','Lindsay Duncan','Rupert Everett','Donald Sumpter','Allen Leech','Jodie Whittaker','Alex MacQueen','Matt Stokoe','Toby Kebbell','Tom Cullen','Patrick Kennedy','Jimi Mistry','Daniel Lapaine','Hayley Atwell','Domhnall Gleeson','Sinead Matthews','Claire Keelan','Jeany Spark','Jason Flemyng','Lenora Crichlow','Michael Smiley','Tuppence Middleton','Tobias Menzies','Christina Chong','Andrew Knott','Lydia Wilson','Sophie Kennedy Clark','Sophie Wu','Alastair Mackenzie','Tom Goodman-Hill','Phoebe Fox','David Fynn','David Ajala','Jonathan Forbes','Amit Shah','Jon Hamm','Chloe Pirrie',"Eugene O'Hare",'Nick Hendrix','Ian Keir Attard','Turlough Convery','Anna Wilson-Jones','McKell David','Amy Beth Hayes','Ian Bonar','Lee Nicholas Harris','Muzz Khan','Michael Shaeffer','Kemal Sylvester','Pip Torrens','Shazad Latif','Karl Collins','Daniel Rigby','Ed Gaughan','Rebekah Staton','Rakie Ayola','Liz May Brice','Ashley Thomas','Phil Hodges','Gugu Mbatha-Raw','Mackenzie Davis','Gavin Stenhouse','Jeff Mash','Jerome Flynn','Alex Lawther','James Norton','Alan Ritchson','Madeline Brewer','Michael Kelly','Malachi Kirby','Sarah Snook','Kelly Macdonald','Faye Marsay','Lasco Atkins','Elizabeth Berrington','Benedict Wong','Natasha Little','Wyatt Russell','Hannah John-Kamen','Wunmi Mosaku','Bryce Dallas Howard','Alice Eve','Demetri Goritsas','Attila G. Kerekes','Zahra Ahmadi','Ken Jamamura','Rafe Spall','Oona Chaplin','Natalia Tena','Janet Montgomery','Rasmus Hardiker','Esther Smith','Samuel Valentine','Matthew Aubrey','Hannah Steele'],
screenplay:['Charlie Brooker','Jesse Armstrong','William Bridges','Rashida Jones','Michael Schur','Konnie Huq','Bisha K. Ali'],
music:['Stephen McKeon','Stuart Earl','Vincent Pope','Alex Heffes','Max Richter','Martin Phipps','Bear McCreary','Clint Mansell','Mark Isham','Daniel Pemberton','Jon Opstad','Cristobal Tapia de Veer','Rival Consoles','Rjúiči Sakamoto','Isobel Waller-Bridge','Atticus Ross','Leopold Ross','Claudia Sarne','Aimee Bessada','Volker Bertelmann','Ariel Marx','Jake Jackson'],
camera:['Jake Polonsky','Damian Bromley','Gustav Danielsson','Zac Nicholson','Tim Maurice-Jones','Seamus McGarvey','Lukas Strebel','George Steel','Ed Wild','Stuart Bentley','Mike Spragg','Lol Crawley','Stephan Pehrsson','Catherine Lutes','David Raedeker','David Luther']},
{title:"Marvel's Daredevil",
titleCZ:'Daredevil',
year:2015,
runtime:'34h 56min',
episodeRuntime:'46-61min',
countries:['USA'],
genres:['Action','Crime','Mystery','Fantasy','Sci-Fi','Thriller'],
director:['Farren Blackburn','Phil Abraham','Adam Kane','Ken Girotti','Guy Ferland','Brad Turner','Stephen Surjik','Nelson McCormick','Nick Gomez','Euros Lyn','Steven S. DeKnight','Marc Jobst','Peter Hoar','Andy Goddard','Michael Uppendahl','Lukas Ettlin','Jennifer Getzinger','Alex Garcia Lopez','Toa Fraser','Alex Zakrzewski','Jennifer Lynch','Sam Miller','Julian Holmes','Jet Wilkinson'],
actors:['Charlie Cox','Deborah Ann Woll','Elden Henson',"Vincent D'Onofrio",'Jon Bernthal','Elodie Yung','Geoffrey Cantor','Toby Leonard Moore','Vondie Curtis-Hall','Bob Gunton','Ayelet Zurer','Peter Shinkoda','Rosario Dawson','Michelle Hurd','Peter McRobbie','Matt Gerald','Scott Glenn','Nikolai Nikolaeff','Adriane Lenox','McCaleb Burnett','David Vadim','Katt Masterson','Alex Webb','D.K. Bowser','Gideon Emery','Peter Gerety','Wendy Moniz','Ben Livingston','Domenick Lombardozzi','Cole Jensen','Phyllis Somerville','Richard Bekins','Clancy Brown','Carrie-Anne Moss','Tony Curran','John Bianco','Andy Murray','Doris McCarthy','Neil Grayston','Joe Forbrich','Michael Pantozzi','Christian Keiber','Brian Distance','William Forsythe','Gilles Marini','Nicholas Tucci','Laurence Mason','Gameela Wright','Josh Philip Weinstein','John Patrick Hayden','Skylar Gaertner','Wai Ching Ho','Rob Morgan','Alex Morf','Amy Rutberg','Chris Tardio','Daryl Edwards','Judith Delgado','Royce Johnson','John Leonard Thompson','Jasson Finney','Jessica Park','Angel Rosa','John Pirkis','Cliff Moylan','Michael Abbott Jr.','Stephen Rider','Vic Noto','James Yaegashi','Tonya Glanz','Keenan Jolliff','Kassia Miller','Jonathan Walker','Danny Johnson','Mike Carlsen','Agneeta Thacker','Allison Winn','Wilson Bethel','Joanne Whalley','Faith Logan','Jay Ali','Stephen Rowe','Fajer Al-Kaisi','Dina Shihabi','Elodie Yung',"Deirdre O'Connell",'Peter Halpin','Antoni Corone','Elisabeth Ness','Max Baker','Meredith Salenger','Andrew Sensenig','David Roberts','Heidi Armbruster','Conor Proft','Gary Hilborn','Kimberli Flores','Lee Tergesen','Anthony Salvador Lewis','Francis Benhamou'],
basedOn:['Stan Lee'],
screenplay:['Drew Goddard','Marco Ramirez','Steven S. DeKnight','Douglas Petrie','Joe Pokaski','Luke Kalteux','Lauren Schmidt','Erik Oleson','Jim Dunn','Dara Resnik Creasey','Sam Ernst','Lewaa Nasserdeen','Tonya Kong','Sneha Koorse','Sonay Hoffman','Tamara Becher','Sarah Streicher','Dylan Gallagher'],
production:['Kati Johnston','Evan Perazzo','Sonay Hoffman'],
music:['John Paesano'],
camera:['Matthew J. Lloyd','Martin Ahlgren','Christopher LaVasseur','Petr Hlinomaz'],
cut:['Jo Francis','Michael N. Knue','Jonathan Chibnall','Monty DeGraff','Damien Smith','Jesse Ellis'],
sound:['Joe Barnett','Adam Jenkins','Scott Millan','Mathew Price'],
scenography:['Scott P. Murphy','Adam Scher','Stephanie Q. Bowen','Loren Weeks','Jan Jericho'],
masks:['Sarah Tollenaar','Robert Lugo','Emma Strachman'],
costumes:['Stephanie Maslansky','Lorraine Calvert','Elisabeth Vastola']},
{title:'Winning Time: The Rise of the Lakers Dynasty',
titleCZ:'Lakers: Vzestup dynastie',
year:2022,
runtime:'16h 8min',
episodeRuntime:'47-69min',
countries:['USA'],
genres:['Comedy','Drama','Sport'],
director:['Adam McKay','Tanya Hamilton','Payman Benz','Jonah Hill','Damian Marcano','Salli Richardson-Whitfield','Trey Edward Shults','Todd Banhazl'],
actors:['John C. Reilly','Quincy Isaiah','Jason Clarke','DeVaughn Nixon','Solomon Hughes','Gaby Hoffmann','Brett Cullen','Adrien Brody','Sally Field','Hadley Robinson','Austin Aaron','Rob Morgan','Jason Segel','Tracy Letts','Stephen Adly Guirgis','Spencer Garrett','Michael Chiklis','Sarah Ramos','Julianne Nicholson','Tamera Tomakili','Nate Richman','Will Fourth','Miles Fowler','Molly Gordon','LisaGay Hamilton','Lola Kirke','Rachel Hilson','Carter Redwood','Lucy Walters','Eddie Pepitone','Earthquake','Donnell Rawlings','Tate Birchmore','Ezra Buzzington','Shaylaren Hilton','Jeff Lewis','Jim Hanna','Albert Malafronte','Kenneth Meseroll','Jayne Entwistle','Earnest Marshall','Mike D','Jimel Atkins','Gillian Jacobs','Rory Cochrane','Danny Burstein','Sheaun McKinney','Rodney Barnes','Kareem Ferguson','Emma Fassler','Cayden K. Williams','Delante Desouza','Sean Patrick Small','Wood Harris','Steve Harris','Orlando Jones','David Bowe','Chris Doubek','Timothy E. Goodwin','Katherine Taylor','Jazlyn Nicolette Sward','Amos Glick','G. Larry Butler','Christopher Gehrman','Roy Abramsohn','Mike Epps','Susan Pourfar','Eric Petersen','Blake Cooper Griffin','Austin Basis','Chet Grissom','David St. James','Scot Zeller','Carey Scott','Steven M. Gagnon','Scott Subiono','Kayla Radomski','Melissa Bickerton','Martin Harris','The D.O.C.','John Deignan','Elsa George','Anna Sundquist','Christopher Wallinger','Azizi Donnelly','Andy Hirsch','Adam Zastrow','Anna Dahl','Tiffany Jeneen','Naomi Walley','Edwin Lee Gibson','Thomas Mann','McCabe Slye','Kate Arrington','Ari Graynor','Britne Oldford','Matthew Barnes','Kyanna Simone','Michael Beasley','Eric Nenninger'],
basedOn:['Jeff Pearlman'],
screenplay:['Max Borenstein','Rodney Barnes','Jim Hecht'],
production:['Hank Corwin','Bruce Dunn'],
music:['Nicholas Britell','Robert Glasper','Jeff Beal'],
camera:['Todd Banhazl','Mihai Malaimare Jr.','Darran Tiernan','Ricardo Diaz','John Matysiak'],
cut:['Hank Corwin','Jeremy Weinstein','Jessica Hernández','Max Koepke','Felicia Mignon Livingston'],
sound:['Nick Offord','Will Digby','Greg Orloff','Mandell Winter'],
scenography:['Richard Toyon','Clayton Hartley','Paul Luther Jackson','Jacqueline Glynn','Adam Alonso','Stephen Dudro','Chris Farmer'],
masks:['Kate Biscoe','Liz Briseno','John Blake','Darlene Brumfield','Ketty Gonzalez'],
costumes:['Susan Matheson','Emma Potter']},
{title:'Fullmetal Alchemist',
titleCZ:'Fullmetal Alchemist',
year:2003,
runtime:'21h 15min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy'],
director:['Seidži Mizušima','Šingo Kaneko','Tomoki Kjóda','Masakazu Hašimoto','Kazuki Kakuta','Tamaki Nakacu','Acuši Ócuki','Džóhei Macuura','Masakazu Amija','Jošito Hata','Džun Fukuda','Kazuki Cunoda','Kendži Jasuda','Masahiro Andó','Šigeru Ueda','Taró Iwasaki','Jošinori Odaka','Kentaró Nakamura'],
actors:['Rie Kugimija','Romi Paku','Hóko Kuwašima',"Džun'iči Suwabe",'Nana Mizuki','Fumiko Orikasa','Hidejuki Tanaka','Kazuko Sugijama','Kotono Micuiši','Takehito Kojasu','Tošihiko Seki','Júdži Ueda','Keidži Fudžiwara','Masane Cukajama','Akiko Jadžima','Tóru Ókawa','Kentaró Itó','Kendži Ucumi','Daisuke Sakaguči','Kazuki Jao','Micuki Saiga','Reiko Kiuči','Kjóko Hikami','Hiroši Naka','Mikako Takahaši','Satomi Kórogi','Džódži Nakata','Džun Fukušima','Miju Macuki','Fumihiko Tačiki','Hidekacu Šibata','Daisuke Góri','Šóko Cuda','Kódži Totani','Šó Hajami','Asami Mukaidono','Jasunori Macumoto','Kacujuki Koniši','Naoki Makišima','Hirojuki Jošino','Megumi Tojoguči','Emi Motoi','Eriko Kawasaki','Takehiro Murozono','Kódži Išii','Masaši Ebara','Tomoko Kawakami','Takaja Haši','Juzuru Fudžimoto','Tomojuki Šimura','Kendži Nomura','Kóiči Sakaguči','Tóko Aojama',"Šin'ja Ótaki",'Jú Mizušima','Takajuki Sugó',"Masa'aki Cukada",'Júko Sató','Júko Kaida','Jumi Kakazu','Tomohisa Asó','Rjókiči Takahaši','Jasuhiro Takato','Džin Horikawa','Reiko Suzuki','Mičiru Jamazaki','Rjúzó Hasuike','Šin Aomori','Nobujuki Furuta','Kei Kurita','Takaši Kondó','Seidži Sasaki','Masakazu Kohara','Rintaró Niši','Aikó Ogata','Cuguo Mogami','Jošihisa Kawahara','Kinrjú Arimoto','Makoto Cumura','Tecu Širatori','Rumi Očiai','Takajuki Fudžimoto','Akimicu Takase','Takuo Kawamura','Miwa Macumoto','Aja Išizu','Jošinori Sonobe','Satoši Katógi','Masao Harada','Kazuo Oka','Majumi Jamaguči','Eidži Marujama','Rjúgo Saitó','Takeši Sasaki','Masumi Kagejama','Takumi Kurebajaši','Jukio Joda','Kóiči Kurijama','Nobuhito Macuki','Majumi Ičikawa'],
basedOn:['Hiromu Arakawa'],
screenplay:['Šó Aikawa','Nacuko Takahaši','Akacuki Jamatoja','Kacuhiko Takajama','Tošiki Inoue','Manabu Išikawa','Aja Jošinaga'],
production:['Rjo Ójama','Hiró Marujama','Masahiko Minami'],
music:['Mičiru Óšima'],
camera:['Susumu Fukuši','Tóru Fukuši'],
cut:['Hiroaki Itabe'],
sound:['Masafumi Mima'],
scenography:['Šindži Aramaki','Kazuyuki Hashimoto','Norifumi Nakamura']},
{title:'The Bureau',
titleCZ:'Le Bureau des Légendes',
year:2015,
runtime:'43h 20min',
episodeRuntime:'52min',
countries:['France'],
genres:['Drama'],
director:['Hélier Cisterne','Mathieu Demy','Laïla Marrakchi','Jean-Marc Moutout','Eric Rochant','Samuel Collardey','Elie Wajeman','Antoine Chevrollier','Pascale Ferran','Jacques Audiard','Mathieu Kassovitz','Thomas Bidegain'],
actors:['Mathieu Kassovitz','Jean-Pierre Darroussin','Sara Giraudeau','Florence Loiret Caille','Gilles Cohen','Alexandre Brasseur','Michaël Abiteboul','Léa Drucker','Emilie Chesnais','Jonathan Zaccaï','Jules Sagot','Dominic Gould','Youssef Hajdi','Patrick Ligardes','Stéphane Debac','Atmen Kelif','Mehdi Nebbou','Élodie Navarre','Husky Kihal','Miglen Mirtchev','Zorah Benali','Andréa Brusque','Slimane Dazi','Grégoire Bonnet','Younes Bouab','Farid Larbi','Djemel Barek','Salomé Stévenin','Paul Minthe','Fabien Baïardi','Alain Buron','Audrey Quoturi','Hyam Zaytoun','Yvonnick Muller','Alika Del Sol','Brad Leland','Jean-Michel Lahmi','Cédric Weber','Mechrafi Akim','Zineb Triki','Mathieu Demy','Roda Fawaz','Adeline Moreau','Pauline Etienne','Alice Belaïdi','Anne-Lise Kedvès','Jana Bittnerová','Amaury de Crayencour','Donia Eden','Grégoire Baujat','Alba Gaïa Kraghede Bellugi','Nathalie Boutefeu','Mathieu Denis','Sarah Kazemy','Samy Seghir','Ginger Romàn','Jean-Michel Fête','Ilse Salas','Laurent Bateau','Laetitia Spigarelli','Farida Rahouadj','Zohra Mouffok','Gabrielle Lazure','Mustapha Abourachid','Hande Kodja','Antoine Michel','Miles Anderson','Ramzi Choukair','Liam Engle','Melisa Sözen','David Saracino','Mohammad Bakri','Driss Ramdi','Werner Daehn','Dimitri Rataud','Alexandre de Seze','Philippe Lelièvre','Arthur Igual','Salim Daw','Marina de Van','Nathan Dellemme','Patrice Quarteron','Brett Gillen','Dany Verissimo-Petit','Bernard Le Coq','David Strajmayster','Stephen Scardicchio','Toufan Manoutcheri','Nadia Benzakour','Mohammed Bouih','Mathieu Amalric','Grégory Fitoussi','Anne Azoulay','Stefan Godin','Franck Monsigny','Alexander Devrient','Lars Doppler','Dinara Drukarova','Laurent Grévill','Alexej Gorbunov'],
screenplay:['Eric Rochant','Emmanuel Bourdieu','Cécile Ducrocq','Antonin Martin-Hilbert','Olivier Dujols','Raphaël Chevènement','Dominique Baumard'],
production:['Eric Rochant'],
music:['Rob'],
camera:['Pierre Novion',"Pierric Gantelmi d'Ille",'Hichame Alaouie','Pierre Aïm','Lubomir Bakchev'],
cut:['Pascale Fenouillet','Thomas Marchand','Olivier Dujols','Eric Rochant'],
sound:['Jean-Luc Audy','Laurent Zeilig','Dimitri Haulet'],
scenography:['Patrick Durand'],
masks:['Frédérique Foglia'],
costumes:['Mimi Lempicka','Nathalie Raoul']},
{title:'Suits',
titleCZ:'Kravaťáci',
year:2011,
runtime:'98h 27min',
episodeRuntime:'41-90min',
countries:['USA'],
genres:['Drama','Comedy'],
director:['Kevin Bray','Terry McDonough','Nicole Kassell','Jennifer Getzinger','Michael Smith','Anton Cropper','Dennie Gordon','Kate Woods','Tim Matheson','Norberto Barba','Félix Enríquez Alcalá','Silver Tree','Christopher Misiano','John Scott','Adam Davidson','David Platt','Roger Kumble','Cherie Nowlan','James Whitmore Jr.','Gabriel Macht','Patrick J. Adams','Kate Dennis','Rob Seidenglanz','Gregor Jordan','Valerie Weiss','Emile B. Levisetti','Maurice Marable','Robert Duncan McNeill','Julian Holmes'],
actors:['Gabriel Macht','Patrick J. Adams','Rick Hoffman','Meghan','vévodkyně ze Sussexu','Sarah Rafferty','Gina Torres','Andrea Parker','David Costabile','Susan Saint James','Vanessa Ray','Alicia Coppola','Nazanin Boniadi','Titus Welliver','Russell Hornsby','Natalie Gal','Vincent Thomas','Julie Ann Emery','John Billingsley','Jeananne Goossen','Hal Ozsan','Jordan Hudyma','Eric Close','Jon Cor','Anthony Starke','Matt Servitto','Abigail Spencer','D.B. Woodside','Chloe Cmarada','Diane Neal','Reiley McClendon','Jon Foster','Michelle Fairley','Jennifer Dale','Jenny Mollen','Max Beesley','Pooch Hall','Elisabeth Hower','Conleth Hill','Adam Godley','José Zúñiga','Damon Gupton','Amanda Schull','Chad Connell','Brendan Hines','Melanie Papalia','Neal McDonough','Neil Brown Jr.','Rachael Crawford','Eric Ladin','Aarti Mann','Pauline Wong','Natalie Krill','Erinn Hayes','Tracie Thoms','Megan Fahlenbock','Christina Chang','Steve Lund','Laine Rettmer','Jacob Blair','Patrick Gallagher','Matt Schichter','Kevin Jubinville','Richard Fitzpatrick','Tom Lipinski','Kevin Hanchard','Paulino Nunes','Billy Miller','Michael Harney','Eric Roberts','Megan Gallagher','Rebecca Schull','John Dossett','Pressly Coker','Chris Payne Gilbert','Patrick Garrow','Sean Bell','Tom Gallop','John Mese','Shawn Campbell','Harvey Atkin','Jason Gosbee','Doug Murray','Danny MacDonald','Jacob Buster','Jim Watson','Maurice Godin','Ben Lewis','Scott Michael Campbell','Lisa Kimberley','Donzaleigh Abernathy','Hamish McEwan','Claire Rankin','Alex Paxton-Beesley','Nadia Dajani','John Finn','James Morrison','Amy Acker','Ian Kahn','Courtney Deelen'],
screenplay:['Erica Lipez','Aaron Korsh','Kyle Long','Nora Zuckerman','Lilla Zuckerman','Chris Downey','Rob LaMorgese','Marshall Knight','Ethan Drogin','Sharyn Rothstein','Garrett Schabb','Kristin Robinson','Sean Jablonski','Daniel Arkin','Jon Cowan','Ian Deitchman','Kristin Rusk Robinson','Justin Peacock','Michael Kramer'],
production:['Steve Wakefield','Gabriel Macht','Patrick J. Adams','Mark Winemaker','Jonathan Hackett'],
music:['Christopher Tyng','Aaron Korsh'],
camera:['Jim Denault','Dan Stoloff','John Aronson','Patrick Cady','Alwyn Kumst','Karl Walter Lindenlaub','William Klayer','Colin Hoult'],
cut:['Danielle Wang','Robert Ivison','David L. Bertman','Angela M. Catanzaro','Christopher Cibelli','Sara Mineo','Brock Hammitt','David Kaldor','Peter Forslund','Janet Ashikaga','Dan Rovetto','Sandra McCallig','Daniel Martens'],
sound:['Robert Carr','Todd Morrissey','Peter Reale','Michael Barosky','Robert Edmondson','Nello Torri','Alan Decker','Stefani Feldman','Brad North','Marco Augusto Comba','Michael LaCroix'],
scenography:['Garreth Stover','Tamara Deverell','Lester Cohen','Sheila Bock','Caroline Gee','Clive Thomasson','Clive Thomasson','Liesl Deslauriers','Lindsey Hermer-Bell'],
masks:['Antoinette Julien','Suzanne Heibati','Mario Cacioppo','Krista Burbidge','Alastair Muir','Leslie Sebert','Stephanie Ingram','Amber Chase','David Waterman'],
costumes:['Christopher Peterson','Margaret Mohr','Michael Harris','Jordanna Fineberg','Jolie Anna Andreatta']},
{title:'Pride and Prejudice',
titleCZ:'Pýcha a předsudek',
year:1995,
runtime:'5h 10min',
episodeRuntime:'49-53min',
countries:['UK'],
genres:['Romance','Drama'],
director:['Simon Langton'],
actors:['Jennifer Ehle','Colin Firth','Susannah Harker','Julia Sawalha','Alison Steadman','Benjamin Whitrow','Crispin Bonham-Carter','Polly Maberly','Lucy Briers','Anna Chancellor','Lucy Robinson','Adrian Lukis','David Bamber','Lucy Scott','Lucy Davis','Emilia Fox','Marlene Sidaway','Barbara Leigh-Hunt','Tim Wylton','Rupert Vansittart','Joanna David','David Bark-Jones','Lynn Farleigh','Christopher Benjamin','Victoria Hamilton','Anthony Calf','Harriet Eastcott','Roy Holder','Neville Phillips','Sam Beazley','Andrew Grainger','Tom Ward','Lee Walters','Bridget Turner','Peter Needham'],
basedOn:['Jane Austen'],
screenplay:['Andrew Davies'],
music:['Carl Davis'],
camera:['John Kenway'],
cut:['Peter Coulson'],
costumes:['Dinah Collin']},
{title:'The Newsroom',
titleCZ:'Newsroom',
year:2012,
runtime:'23h 47min',
episodeRuntime:'47-72min',
countries:['USA'],
genres:['Drama'],
director:['Alan Poul','Greg Mottola','Lesli Linka Glatter','Jeremy Podeswa','Alex Graves','Daniel Minahan','Joshua Marston','Jason Ensler','Julian Farino','Carl Franklin','Anthony Hemingway','Paul Lieberstein'],
actors:['Jeff Daniels','Emily Mortimer','John Gallagher Jr.','Alison Pill','Thomas Sadoski','Dev Patel','Thomas Matthews','Olivia Munn','Sam Waterston','Chris Chalk','Margaret Judson','Adina Porter','Wynn Everett','Chris Messina','David Harbour','Kelen Coleman','Jane Fonda','Chasty Ballesteros','Marcia Gay Harden','Hamish Linklater','Grace Gummer','Hope Davis','Terry Crews','Constance Zimmer','David Krumholtz','Jon Tenney','Stephen McKinley Henderson','Aya Cash','Salli Richardson-Whitfield','Michael Carbonaro','Patrick Fabian','Natalie Morales','Scott Alan Smith','Ned Vaughn','Paul Schneider','Jason Butler Harner','Jesse Eisenberg','Philip Baker Hall','Matt Long','Kathryn Hahn','Adam Arkin','Jake McDorman','Stephen Root','Frank Wood','Lauren Tom','Eve Gordon','Saemi Nakamura','John Walcutt','Maria Dizzia','Melanie Papalia','John DiMaggio','Don McManus','Marshall Bell','Megan Park','Ricky Mabe','Kristin Carey','Phil Austin','Dean Cameron','Briana Venskus','Tristin Mays','Alison Becker','Dio Johnson','Christina Kirk','Damon Gupton','Julia Cho','Briana Cuoco','Merle Dandridge','Brian Huskey','Kenneth Choi','Kat Dennings','Paul Lieberstein','Jimmi Simpson','Mary McCormack','Amy Holland Pennell','Paul Willson','Bruno Amato','Chase Kim','Shelley Robertson','Cherie Jimenez','Elizabeth Marvel','Bryan Casserly','Corey Sorenson','Rene Gube','Dominic Matteucci','Tehmina Sunny','Riley Voelkel','Nick Gehlfuss','Paul Greene','JD Cullum','Chuma Gault','Brian Howe','Jeff Corbett','Saidah Arrika Ekulona','Clea DuVall','Benjamin Koldyke','Kevin Rankin','Jon Bass','Darren Whitfield','Anna Khaja','Frank Cermak Jr.'],
screenplay:['Aaron Sorkin','Paul Redford','Amy Rice','Alena Smith','Gideon Yago'],
production:['Scott Rudin','Leanne Moore','Charlie Goldstein','Jon Lovett'],
music:['Alex Wurman','Johnny Klimek','Thomas Newman','Jeff Beal'],
camera:['Barry Ackroyd','David J. Miller','Todd McMullen'],
cut:['Anne McCabe','Michelle Tesoro','Ron Rosen','Harry Yoon','Howard Leder','Rob Seidenglanz'],
sound:['Dennis Kirk','Todd Orr','Mark Relyea'],
scenography:['Richard Hoover','Jeff Schoen','Sandy Struth','Brian Kasch','Dennis Bradford','Chikako Suzuki'],
masks:['Crystal M. Cook','Kimberley Spiteri','Barbara Lorenz','Jane Galli','Diana Acrey','Sharon Rivera'],
costumes:['Hope Hanafin','Albert Wolsky']},
{title:'Borgen',
titleCZ:'Vláda',
year:2010,
runtime:'36h 28min',
episodeRuntime:'54-59min',
countries:['Denmark'],
genres:['Drama'],
director:['Jesper W. Nielsen','Louise Friedberg','Annette K. Olesen','Mikkel Nørgaard','Søren Kragh-Jacobsen','Rumle Hammerich','Jannik Johansen','Charlotte Sieling','Henrik Ruben Genz','Per Fly','Mogens Hagedorn','Dagur Kári'],
actors:['Sidse Babett Knudsen','Birgitte Hjort Sørensen','Freja Riemann','Emil Poulsen Dam','Søren Malling','Thomas Levin','Pilou Asbæk','Benedikte Hansen','Mikael Birkkjær','Anders Juul','Lisbeth Wulff','Kasper Lange','Lars Knutzon','Søren Spanning','Peter Mygind','Bjarne Henriksen','Morten Kirkskov','Ole Thestrup','Iben Dorner','Petrine Agger','Dar Salim','Jannie Faurschou','Patricia Schumann','Signe Egholm Olsen','Christian Tafdrup','Jens Jacob Tychsen','Jens Albinus','Kristian Halken','Julie Agnete Vang Christensen','Alastair Mackenzie','Ricard Lawrence','Flemming Sørensen','Lars Brygmann','Rikke Lylloff','Mille Dinesen','Marie Askehave','Anne Sofie Espersen','Michelle Bjørn-Andersen','Hanne Hedelund','Lars Mikkelsen','Henrik Birch','Laura Allen Müller','Preben Kristensen','Johannes Lilleøre','Mia Lyhne','Kenneth M. Christensen','Ulf Pilgaard','Sune Kofoed','Anna Elisabeth Goth Engel','Victor Stoltenberg','Lue Dittmann Støvelbæk','Ida Dwinger','Thomas Gaarde','Kaya Brüel','Stine Stengade','Peter Steenberg','Neel Rønholt','Lukas Klærke','Morten Thunbo','Mette Munk Plum','David Bateson','Scott Farrell','Adam Brix','Sebastian Jessen','Niels Weyde','Peter Bankolé','Hans Henrik Clemensen','Waleed Elgadi','Femi Elufowoju Jr.','Abdi Gouhad','Henrik Prip','Stina Ekblad','Stefania Ómarsdóttir','Charlie Top-Nørgaard','Morten Blom Due Hjulmand','Amalie Dollerup','Claus Riis Østergaard','David Leonard','Sam Hoare','Lola Peploe','Natasha Alderslade','Helene Reingaard Neumann','Morten Brovn','Sarah Gottlieb','Anne-Marie Louise Curry','Morten Staugaard','Carl Press','Fadime Turan','Jacob Wagner Guldager','Mette Kolding','Klaus Hjuler','Christina Bech','Astrid Reinhardt','Louise Herbert','Claus Bue','Claes Bang','Jesper Lohmann','Angunnguaq Larsen','Janek Lesniak','Lars Junker Thiesgaard'],
screenplay:['Adam Price','Jeppe Gjervig Gram','Tobias Lindholm','Maja Jul Larsen','Jannik Tai Mosholt','Maren Louise Käehne','Henrik Vincent Thiesen','Emilie Lebech Kaae'],
production:['Camilla Hammerich','Adam Price','Stine Meldgaard Madsen'],
music:['Halfdan E.','August Fenger Janson'],
camera:['Magnus Nordenhof Jønck','Eric Kress','Lars Vestergaard','Jørgen Johansson','Erik Zappon','Lasse Frank','Rasmus Heise','Jan Pallesen','Henrik Kristensen','Karl Oskarsson'],
cut:['Kasper Leick','Per K. Kirkegaard','My Thordal','Martin Schade','Andri Steinn','Janne Bjerg Sørensen','Gerd Tjur','Peter Brandt','Lars Therkelsen','Nicolaj Monberg','Linda Man','Benjamin Binderup'],
sound:['Nino Jacobsen','Michael Dela','Morten Groth Brandt','Andreas Holtti','Lisbet Obel','Morten Holsted','Morten Bak Jensen','Jacques Pedersen','Asser Borgen','Hans Christian Kock','Andreas Kongsgaard','Claus Lynge'],
scenography:['Knirke Madelung','Niels Sejer'],
masks:['Tina Helmark','Jeanet Keil','Charlotte Laustsen','Svend Nielsen','Lisbeth Rishøj Olsen','Lene Majgaard Arentsen','Erik Schiødt','Christina Dahlin','Birgitte Samson','Charlotte Dam','Pernille Rud Hansen','Ulla Glud'],
costumes:['Stine Thaning','Nancy Nickerson','Linda Wallentin','Trine Finnich','Charlotte Moe','Pia Anthony','Tanja Eleonora Spang','Anita Nielsen']},
{title:'Millennium',
titleCZ:'Millennium',
year:1996,
runtime:'66h 27min',
episodeRuntime:'43-60min',
countries:['USA'],
genres:['Crime','Drama','Mystery','Thriller','Horror'],
director:['Thomas J. Wright','Paul Shapiro','Daniel Sackheim','Michael W. Watkins','Ralph Hemecker','Kenneth Fink','Allen Coulter','David Nutter','Peter Markle','Dwight H. Little','Rodman Flender','Jim Charleston','Winrich Kolbe','Perry Lang','Michael Pattinson','Rod Pridy','Arthur W. Forney','Darin Morgan','Cliff Bole','Randy Zisk','John Peter Kousakis'],
actors:['Lance Henriksen','Klea Scott','Megan Gallagher',"Terry O'Quinn",'Brittany Tiplady','Stephen E. Miller','Bill Smitrovich','Kristen Cloke','Peter Outerbridge','Natassia Malthe','Željko Ivanek','Karin Konoval','Michael Hogan','Juliet Landau','Harriet Sansom Harris','Michael Weaver','John Finn','Guy Fauchon','CCH Pounder',"Floyd 'Red Crow' Westerman",'Jeffrey Donovan','Sarah Strange','Dean Norris','Gwynyth Walsh','Andrew Francis','Kate Luyben','A. J. Buckley','Glenn Morshower','Tanja Reichert','Ingrid Kavelaars','Jason Gray-Stanford','Lisa Marie Caruk','Keegan Connor Tracy',"Michael O'Neill",'Patrick Fabian','Kaitlyn Burke','Louis Ferreira','John Hawkes','Chris Ellis','Ryan Robbins','Merrilyn Gann','Missy Crider','Birkett Turton','Eric Mabius','Jeremy Guilbaut','Françoise Yip','Sam Anderson','Jorge Vargas','Roger Cross','Hrothgar Mathews','Hiro Kanagawa','Greg Anderson','James Morrison','Ashlyn Gere','Kimberley Warnat','Shayn Solberg','Donny Lucas','Kevan Ohtsji','Gregory Itzin','Melinda McGraw','Glynn Turman','Jarred Blancard','Kristi Angus','Rachel Victoria','Barbara Bain','John Pyper-Ferguson','Jessica Tuck','James Marsters','Mark Humphrey','Stephen Macht','Tracy Middendorf','Sam Vincent','Jade Malle','Tom Braidwood','Rob Freeman','Barbara Williams','Tom McBeath','Dan Shea','Steve Rankin','Brian Downey','Brian Markinson','Joe Chrest','C. Ernst Harth','Wally Dalton','Paul Simon','April Telek','Kim Hawthorne','Ted Marcoux','Jonathan Silver Scott','Susan Hogan','Sarah-Jane Redmond','Ocean Hellman','Van Quattro','Christian Hoff','Eric Keenleyside','William Lucking','William MacDonald','Benz Antoine','Robert Moloney','Derek Hamilton'],
screenplay:['Chris Carter','Glen Morgan','James Wong','Frank Spotnitz','Bobby Moresco','Michael R. Perry','Marjorie David','Walon Green','Patrick Harbinson','Chip Johannessen','Ted Mann','Ralph Hemecker','Darin Morgan','Richard Whitley','Kay Reindl','Erin Maher','Charles Holland','Michael Duggan','Laurence Andries','Jorge Zamacona'],
production:['Thomas J. Wright','Chip Johannessen','Michael R. Perry'],
music:['Mark Snow'],
camera:['Robert McLachlan','Peter Wunstorf','Barry Donlevy'],
cut:['Chris G. Willingham','James Coblentz','Stephen Mark','Casey O. Rohrs','Peter B. Ellis','Lauren A. Schaffer','George Potter'],
sound:['David John West','Peter Kelsey','Thierry J. Couturier','Kurt Kassulke','Nello Torri','David Rawlinson','Mark R. Crookston','Rob Young'],
scenography:['Mark S. Freeborn','Gary Wissner','Sheila Haley','James Cordeiro','Mark Lane','Dominique Fauquet-Lemaitre'],
masks:['Michael Pachal','Victoria Down','Natalie Cosco','Dianne Pelletier','Leanne Rae Podavin','Tony Wohlgemuth','Toby Lindala','Vince Yoshida']},
{title:'The Kingdom',
titleCZ:'Království',
year:1994,
runtime:'14h 20min',
episodeRuntime:'60-79min',
countries:['Denmark','France','Germany','Sweden'],
genres:['Drama','Horror','Mystery','Comedy'],
director:['Lars von Trier','Morten Arnfred'],
actors:['Ernst-Hugo Järegård','Kirsten Rolffes','Søren Pilmark','Ghita Nørby','Jens Okking','Baard Owe','Peter Mygind','Udo Kier','Holger Perfort','Laura Christensen','Ole Boisen','Lars von Trier','Mette Munk Plum','Birte Tove','Solbjørg Højfeldt','Claus Nissen','Birthe Neumann','Benny Hansen','Lars Lunøe','Dick Kaysø','Thomas Bo Larsen','Ole Dupont','Michael Moritzen','Morten Eisner','Stellan Skarsgård','Kurt Ravn','Anders Hove','Philip Zandén','Jens Jørn Spottag','Torben Zeller','Troels Lyby','Mette Marckmann','Bente Eskesen','Finn Nielsen','Henning Jensen','Tove Maës','Paul Hüttel','Claus Flygare','Michelle Bjørn-Andersen','Jannie Faurschou','Peter Gilsfort','Louise Fribo','Nis Bank-Mikkelsen','Henrik Koefoed','John Hahn-Petersen','Ole Emil Riisager','Julie Wieth','Søren Lenander','Gunnvør Nolsøe','Bjarne G. Nielsen','Steen Svare','Gordon Kennedy','Lars Mikkelsen','Nicolas Bro','Tuva Novotny','Nikolaj Lie Kaas','Mikael Persbrandt','Bodil Jørgensen','Ida Engvoll','Birgitte Raaberg','David Dencik','Danica Curcic','Jens Albinus','Asta Kamma August','Anders Mossling','Cyron Melville','Helle Pilar Larsen','Palmi Gudmundsson','Peter Hartmann','Tomas Stender','Cecilie Brask','Willem Dafoe','Alexander Skarsgård','Jasmine Junker','Victoria Carmen Sonne','Simon Sears','Mads Reuther','Dorte Rømer','Kevin K. Yuven','Marie Reuther','Rebecca Langley Jensen','Michael Asmussen','Imad Abul-Foul','Rasmus Botoft','Katrine Falkenberg','Elias Eliot','Charlotte Sieling','Stig Hoffmeyer','Joakim Höglund','Lene Axelsen','Mikkel Vadsholt','Lado Hadzic','Fredrik Bock','Jesper Sørensen','Henrik Fiig'],
screenplay:['Lars von Trier','Tómas Gislason','Niels Vørsel'],
production:['Bo Lindquist','Louise Vesth'],
music:['Joachim Holbek'],
camera:['Eric Kress','Manuel Alberto Claro'],
cut:['Jacob Thuesen','Molly Malene Stensgaard','Pernille Bech Christensen','Jacob Secher Schulsinger','My Thordal','Olivier Bugge Coutté'],
sound:['Per Streit','Robert Leib'],
scenography:['Jette Lehmann','Cecilia Hellner'],
masks:['Birthe Lyngsøe','Jeanet Keil','Kim Olsson','Love Larson'],
costumes:['Annelise Bailey']},
{title:'Cobra Kai',
titleCZ:'Cobra Kai',
year:2018,
runtime:'34h 9min',
episodeRuntime:'22-49min',
countries:['USA'],
genres:['Action','Comedy','Drama','Family','Sport'],
director:['Jon Hurwitz','Hayden Schlossberg','Jennifer Celotta','Josh Heald','Steve Pink','Michael Grossman','Lin Oeding','Steven K. Tsuchida','Marielle Woods','Joel Novoa','Tawnia McKiernan'],
actors:['Ralph Macchio','William Zabka','Xolo Maridueña','Mary Mouser','Courtney Henggeler','Tanner Buchanan','Peyton List','Vanessa Rubio','Jacob Bertrand','Gianni DeCenzo','Martin Kove','Thomas Ian Griffith','Nichole Brown','Paul Walter Hauser','Owen Morgan','Hannah Kepple','Cameron Markeles','Asher Sheets','Griffin Santopietro','Aldan Karanovich','Aedin Mincks','Khalil Everage','Chris Schmidt Jr.','Dan Ahdoot','Joe Seo','Bo Mitchell','Rose Bianco','Bret Ernst','Annalisa Cochrane','Vas Sanchez','Susan Gallagher','Dawson Towery','Diora Baird','Terayle Hill','Jeff Kaplan','Nathaniel Oh','Kwajalyn Brown','Keith Arthur Bolden','Ashton Leigh','Jessica Roth','Matt Mangum','Jerri Tubbs','Kristin Brock','Kylie Delre','Shawn Weston Thacker','Edward Asner','Martin Kove','Pat Morita','Elisabeth Shue','Linda Boston','David Shatraw','Ken Davitian','Candace Moon','Michael H. Cole','Randee Heller','Hiro Koda','Brandon Gibson','Andrea Andrade','Kim Fields','Ron Thomas','Rob Garrison',"Tony O'Dell",'Scott Hamm','Lara Silva','Kurt Yue','Andrew Roach','Jonathan Mercedes','Reese TinLee','Chris Mason','Erin Bradley Dangar','Cara AnnMarie','Matt Lewis','Casey Hendershot','Gabe Bowles',"K.D. O'Hair",'Elisabeth Shue','Jose Miguel Vasquez','Jesse Kove','Grayson Berry','Emily Marie Palmer','Eric Goins','Tomoko Karina','Randee Heller','Tamlyn Tomita','Júdži Okumoto','Major Dodge','Rome Kanda','Dee Snider','Terry Serpico','Han Soto','James Logan','Cuyle Carvin','David Silverman','Zele Avradopoulos','Deborah May','Najah Bradley','Dennis Friebe','Alan Heckner','Grace Lawell','Sara Torres'],
screenplay:['Jon Hurwitz','Hayden Schlossberg','Josh Heald','Jason Belleville','Joe Piarulli','Luan Thomas','Stacey Harman','Michael Jonathan Smith','Kevin McManus','Matthew McManus','Bob Dearden','Alyssa Forleiter','Mattea Greene','Bill Posley','Ashley Darnall'],
production:['Bob Wilson','Katrin L. Goodson','Cindy Kerber','Joe Piarulli','Luan Thomas','Stacey Harman','Michael Jonathan Smith','Bob Dearden','Josh Heald','Jon Hurwitz','Hayden Schlossberg'],
music:['Leo Birenberg','Zach Robinson'],
camera:['Cameron Duncan','D. Gregor Hagey','Paul Varrieur','Don E. FauntLeRoy'],
cut:['Nicholas Monsour','Jeff Seibenick','Ivan Victor','Zack Arnold','Spencer Houck','Jordan Goldman','Dexter N. Adriano','Bartholomew Burcham'],
sound:['Joe DeAngelis','Patrick Hogan','Albert Romero','Chris Carpenter'],
scenography:['Ryan Berg','Liz Chatov'],
masks:['Jamie Cline','Leay Cangelosi','Tammi Terrell'],
costumes:['Frank Helmer']},
{title:'I, Claudius',
titleCZ:'Já, Claudius',
year:1976,
runtime:'11h 35min',
episodeRuntime:'55-90min',
countries:['UK'],
genres:['Drama','History'],
director:['Herbert Wise'],
actors:['Derek Jacobi','Siân Phillips','Brian Blessed','George Baker','John Hurt','Ian Ogilvy','Patrick Stewart','John Rhys-Davies','Guy Siner','Stuart Wilson','Bernard Hill','Esmond Knight','Jiří Pravda','Peter Bowles','Charles Kay','Patricia Quinn','Simon MacCorkindale','Kevin McNally','Margaret Tyzack','James Faulkner','Jonathan Burn','Stratford Johns','John Castle','George Little','Freda Dowie','Russell Lewis','Carol Gillies','David Robb','Lockwood West','Nicholas Amer','Jennifer Croxton','Katherine Hughes','Pat Gorman','Norman Eshley','Tony Haygarth','Peter Williams','Angela Morant','Christopher Guard','Patsy Byrne','Fiona Walker','Darein Angadi','Aubrey Richards','Sheila White','Frances White','Graham Rowe','John Drake','Carleton Hobbs','Kevin Stoney','John Cater','Bernard Hepton','David Davenport','John Scott Martin','Edward Jewesbury','Katharine Levy','Lyndon Brook','Norman Rossington','Moira Redmond','Isabel Dean','Donald Eccles','George Innes','Linal Haft','Charles Rayford','Robert Morgan','Manning Wilson','John Franklyn Robbins','Sheila Ruskin','Patrick Drury','Norman Shelley','Jo Rowbottom','Bruce Purchase','Anne Dyson','Alan Thompson','Neal Arden','Anni Domingo','Danny Schiller','Graham Seed','Jill Goldston'],
basedOn:['Robert Graves'],
screenplay:['Jack Pulman'],
scenography:['Tim Harvey'],
masks:['Norma Hill-Patton','Christopher Tucker']},
{title:'Cowboy Bebop',
titleCZ:'Kovboj Bebop: Lovec odměn',
year:1998,
runtime:'10h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Adventure','Drama','Comedy','Sci-Fi'],
director:["Šin'ičiró Watanabe",'Ikuró Sató','Hirokazu Jamada','Kunihiro Mori'],
actors:['Kóiči Jamadera','Unšó Išizuka','Megumi Hajašibara','Norio Wakamoto','Akio Ócuka','Acuko Tanaka','Iššin Čiba','Maaja Sakamoto','Mika Doi','Šigeru Čiba',"Šin'ičiró Miki",'Takeši Aono','Tamio Óki','Teššó Genda','Jui Horie','Čikao Ócuka','Wasabi Mizuta','Kappei Jamaguči','Micuki Saiga','Čafúrin','Hiroši Naka','Šinpači Cudži','Sačiko Kodžima','Takeši Watabe','Takaši Taguči','Arisa Ogasawara','Masajuki Omoro','Jošiko Okamoto','Rintaró Niši','Kacumi Čó','Jurika Hino','Takehiro Kojama','Kaoru Morota','Džin Hirao','Tošihiko Nakadžima','Naoki Makišima','Rjúzaburó Ótomo','Juzuru Fudžimoto','Keidži Fudžiwara','Miki Nagasawa','Ako Majama','Takehiro Murozono','Kazuhiro Nakata',"Kijomicu Mizu'uči",'Šindži Ogawa','Jutaka Nakano','Aruno Tahara','Ai Učikawa','Masaki Aizawa','Gara Takašima','Mijuki Ičidžó','Kazuaki Itó','Hidetoši Nakamura','Daisuke Góri','Rjúdži Nakagi','Jumi Tóma','Tomie Kataoka','Kei Hajami','Rjúsei Nakao','Aoi Tada','Asako Dodo','Džódži Nakata','Naoki Tacuta','Hirohiko Kakegawa','Kacuhisa Hóki',"Ken'jú Horiuči",'Hiroši Iwasaki','Hikaru Midorikawa','Jukimasa Kišino','Čiharu Suzuka','Masaši Hirose','Júdži Mikimoto','Kósei Hirota','Bin Sasaki','Motomu Kijokawa','Hóčú Ócuka','Džin Jamanoi','Kozue Jošizumi','Takaši Nagasako','Joku Šioja','Kódži Išii','Bandžó Ginga','Jajoi Kuroda','Masaši Ebara','Takaja Haši',"Džun'iči Sugawara",'Sajaka Óhara','Kendži Ucumi','Ruri Asano','Šigeru Nakahara','Ikuko Tani','Mami Horikoši','Nobujuki Hijama','Jú Šimaka','Fumio Macuoka','Kazumi Okušima','Hiromiči Kogami','Ajumi Kida','Hitoši Ója','Masaru Hačinohe'],
screenplay:["Šin'ičiró Watanabe",'Akihiko Inari','Keiko Nobumoto','Mičiko Jokote','Sadajuki Murai','Rjóta Jamaguči','Dai Saitó'],
production:['Kazuhiko Ikeguchi','Masahiko Minami'],
music:['Jóko Kanno'],
camera:['Jóiči Ógami'],
cut:['Tomoaki Curubuči'],
sound:['Kacujoši Kobajaši'],
scenography:["Džun'iči Higaši"]},
{title:'Vikings',
titleCZ:'Vikingové',
year:2013,
runtime:'66h 51min',
episodeRuntime:'44-51min',
countries:['Ireland','Canada'],
genres:['Action','Drama','History','Adventure'],
director:['Johan Renck','Ciaran Donnelly','Ken Girotti','Jeff Woolnough','Kari Skogland','Helen Shaver','Kelly Makin','Daniel Grou','Sarah Harding','Ben Bolt','David Wellington','Steve Saint Leger','David Frazee','Katheryn Winnick','Paddy Breathnach'],
actors:['Travis Fimmel','Katheryn Winnick','Gustaf Skarsgård','Clive Standen','Alexander Ludwig','Linus Roache','Moe Dunford','Jessalyn Gilsig','Jefferson Hall','Alyssa Sutherland','Maude Hirst','Donal Logue','Thorbjørn Harr','Ivan Kaye','George Blagden',"Nathan O'Toole",'John Kavanagh',"Cathal O'Hallin",'Cormac Melia','Gaia Weiss','Edvin Endre',"Ruby O'Leary",'Gabriel Byrne','Amy Bailey','Elinor Crawley','Vladimír Kulich','Jouko Ahola','David Wilmot','Matt Ryan','Morgan C. Jones','Michelle Beamish','James Flynn','Morten Suurballe','Billy Gibson','Kevin Durand','David Murray','Ben Robson','Amber Jean Rowan','Niamh Algar','David Pearse','Lalor Roddy','Dianne Doan','Deirdre Mullins','Ian Beattie','Brian Fortune','Andy Kellegher','Brian Matthews Murphy','Melissa Maria Carton','Peter Franzén','Jasper Pääkkönen','Duncan Lacroix','David Michael Scott','Chris Gallagher','Rick Burn','Jonathan Ryan','Dez McMahon','Steve Wilson','Tyrone Kearns','Michelle Costello',"Ciaran O'Grady",'Michael Liebmann','Michael Hough','Mark Quigley','Jonathan Gunning','Eddie Elks','Jack Hickey','Tristan McConnell','Christopher Dane','Riku Rokkanen',"Philip O'Sullivan",'Sarah Greene','Jennie Jacques','Aaron Monaghan','Conor Ryan',"Nigel O'Neill",'Jill Harding','Lothaire Bluteau','Owen Roe','Mark Huberman','Karen Hassan','Eddie Drew','Gerard McCarthy','Conor Madden','Donna Dent','Daniel Aherne','Eric Higgins','Robert MacDomhnail','Diarmaid Murtagh','Tadhg Murphy','Craig Whittaker','Paul Kealyn','Carolyn Murray','Will Irvine','Des Braiden','Eddie Jackson','Nathan Gordon','Martin Phillips',"Dean O'Neill",'Aaron Lee Reed','Carrie Crowley'],
screenplay:['Michael Hirst'],
production:['Keith Thompson','Steve Wakefield','Sanne Wohlenberg'],
music:['Trevor Morris'],
camera:['P.J. Dillon','John S. Bartley','Owen McPolin','Suzie Lavelle','Peter Robertson'],
cut:['Christopher Donaldson','Michele Conroy','Aaron Marshall','Tad Seaborn','Don Cassidy','Dan Briceno'],
sound:['Martin Lee','Jane Tattersall','Ian Rankin','David McCallum','Kirk Lynds'],
scenography:['Mark Geraghty','Tom Conroy','Andrew Berry','Jil Turner','Crispian Sallis','David Wilson'],
masks:['Tina Phelan','Belinda Roche','Ciara Scannell'],
costumes:['Joan Bergin',"Susan O'Connor Cave"]},
{title:'Lucky Louie',
titleCZ:'Lucky Louie',
year:2006,
runtime:'5h 25min',
episodeRuntime:'20-31min',
countries:['USA'],
genres:['Comedy'],
director:['Louis C.K.','Andrew D. Weyman','Gary Halvorson'],
actors:['Louis C.K.','Pamela Adlon','Mike Hagerty','Jim Norton','Kim Hawthorne','Kelly Gould','Nick Di Paolo','Emma Stone','Brandon Mychal Smith','Dave Allen','Noah Harpster','Jim Turner','Robert Eaton','Todd Barry','Lou Myers','Wayne Wilderson','Susan Priver','Jerry Minor','Lyne Odums','Kathleen Butler','Laura Kightlinger','Paul Raci','Rick Shapiro','Kurt Doss','Loren Berman','Dig Wayne','Stewart Skelton'],
screenplay:['Dan Mintz','Louis C.K.','Dino Stamatopoulos','Patricia Breen','Aaron Shure','Mike Royce'],
production:['Andrew D. Weyman','Leo Clarke'],
music:['Mark Rivers'],
camera:['Bruce L. Finn'],
cut:['Brian Schnuckel'],
sound:['John W. Cook II'],
scenography:['Naomi Slodki','Julieann Getman'],
masks:['Jody Burton'],
costumes:['Caroline B. Marx']},
{title:'Parks and Recreation',
titleCZ:'Odbor městské zeleně',
year:2009,
runtime:'44h 10min',
episodeRuntime:'21-22min',
countries:['USA'],
genres:['Comedy'],
director:['Seth Gordon','Randall Einhorn','Matt Sohn','Jeffrey Blitz','Alan Yang','Tristram Shapeero','Jay Karas','Rob Schrab','Dean Holland','Millicent Shelton','Jason Woliner','Daniel J. Goor','Michael Schur','Kyle Newacheck','Greg Daniels','Michael McCullers','Beth McCarthy-Miller','Paul Feig','Alex Hardcastle','Charles McDougall','Troy Miller','Ken Kwapis','Michael Trim','Ken Whittingham','Wendey Stanzler','Tucker Gates','Nicole Holofcener','Jorma Taccone','Robert B. Weide','Amy Poehler','Craig Zisk','Nick Offerman','Julie Anne Robinson','Adam Scott','Morgan Sackett','David Rogers','Tom Magill','Norm Hiscock'],
actors:['Amy Poehler','Rashida Jones','Paul Schneider','Aziz Ansari','Jim O’Heir','Aubrey Plaza','Nick Offerman','Frank Medrano','Retta','Lennon Wynn','H. Jon Benjamin','Chris Pratt','Meg Wolf','Kathleen M. Darcy','Gary Weeks','Jeryl Prescott','Adam Scott','Rob Lowe','Jon Glaser','Pamela Reed','Louis C.K.','Natalie Morales','Kirk Fox','Justin Theroux','Sarah Wright','Yvans Jourdain','Patricia Clarkson','Don McManus','Lennon Parham','Jessica St. Clair','Jay Jackson','Billy Eichner','Kathryn Hahn','Jonathan Erickson Eisley','Damion Poitier','Jordi Vilasuso','Marcus Folmar','Lyle Kanouse','Sean Hayes','Jason Mantzoukas','Windell Middlebrooks','Daniel Bridges','Lucy Lawless','Jon Paul Burkhart','Katie Dippold','Carlos Carrasco','Nick Kroll','Izzy Eggerling','Todd Berger','Kevan Peterson','Mara Marini','Annalise Basso','Alison Becker','Ryan Hartwig','Danielle Bisutti','Vanessa Vander Pluym','Alex Calloway','Marc Evan Jackson','Kristen Bell','Adam Harrington','Christopher Frontiero','Annabeth Gish','Gloria Henry','Katie Gill','Jane Morris','Debra Mooney','Josh Pence',"Hugh O'Brien",'Jama Williamson','Heidi Klum','Ben Schwartz','Jenny Slate','Megan Mullally','Peter Serafinowicz','Henry Winkler','Tania Pilar','Greg McKenna','Kay Hanley','Julie Wittner','Brady Smith','Nick Armstrong','Blake Lee','Chelsea Peretti','Jon Daly','Joseph Russo','Alyssa Shafer','Pete Ploszek','Rachael Markarian','Mark Saul','Alan Yang','Jack Carter','Bonnie Bartlett','Michael D. Roberts','Sam Elliott','Keegan-Michael Key','Jeff Tweedy','Bo Burnham','Richard Burch','June Diane Raphael','Brian Huskey'],
screenplay:['Katie Dippold','Nick Offerman','Chelsea Peretti','Alan Yang','Emily Kapnek','Emily Spivey','Daniel J. Goor','Joe Mande','Paul Schneider','Louis C.K.','Mike Scully','Greg Daniels','Michael Schur','Amy Poehler','Donick Cary','Matt Hubbard','Rachna Fruchbom','Megan Amram','Sam Means','Alexandra Rushfield','Tucker Cawley','Matt Murray','Norm Hiscock','Emma Fletcher','Rachel Axler','Jen Statsky','Dave King'],
production:['Emily Spivey','Daniel J. Goor','Amy Poehler','Dean Holland','Alan Yang','David Hyman','Dave King'],
music:['Mark Rivers'],
camera:['John Inwood','Peter Smokler','Michael Trim','Matt Sohn','Tom Magill'],
cut:['Dan Schalk','Jon Corn','Dean Holland','Jeff Seibenick','Shawn Paper','Ivan Victor','Mark Sadlek','Richie Edelson','John M. Valerio'],
sound:['Guillaume Le Bras','Bobby Mackston','Robert Carr','John W. Cook II','William Freesh','Kenneth Kobett','Alex Thompson','Peter Nusbaum'],
scenography:['Dan Bishop','Ian Phillips','Julieann Getman','Julie Bolder','Adam Rowe'],
masks:['Alexei Dmitiew','Robin L. Neal','Michele Tyminski Schoenbach','Patricia Dehaney','Phyllis Williams','Matt Danon'],
costumes:['Kelli Jones','Kirston Leigh Mann']},
{title:'The Take',
titleCZ:'Úlovek',
year:2009,
runtime:180,
episodeRuntime:45,
countries:['UK'],
genres:['Crime','Drama','Thriller'],
director:['David Drury'],
actors:['Shaun Evans','Tom Hardy','Kierston Wareing','Brian Cox','Steve Nicolson','Sara Stewart','Charlotte Riley','Mark Huberman','René Zagger','Gary Murphy','Nicholas Day','Jane Wood','David Schofield','Eamon Geoghegan','Emmet Kirwan'],
screenplay:['Neil Biswas'],
music:['Ruth Barrett','Jake Jackson'],
camera:['Owen McPolin'],
cut:['Chris Ridsdale'],
scenography:['Susie Cullen'],
masks:['Tina Phelan','Morna Ferguson']},
{title:'Demon Slayer',
titleCZ:'Kimecu no jaiba',
year:2019,
runtime:'28h 24min',
episodeRuntime:'24-55min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy'],
director:['Haruo Sotozaki','Júki Itó','Takahiro Miura','Kei Cunemacu','Ken Takahaši','Hideki Hosokawa','Šinsuke Gomi','Takahiro Madžima','Šúdži Mijahara','Jó Miura','Takuja Nonaka','Tošijuki Širai',"Šin'ja Šinomura",'Takaši Suhara','Masaši Takeuči'],
actors:['Akari Kitó','Nacuki Hanae','Hiro Šimono','Jošicugu Macuoka','Ai Kakuma','Aoi Júki','Daisuke Namikawa','Hikaru Midorikawa','Hóčú Ócuka','Júki Kadži','Nobuhiko Okamoto','Šiori Izawa','Takahiro Sakurai','Takehito Kojasu','Takumi Jamazaki','Tošijuki Morikawa','Makoto Kóiči',"Šun'iči Toki",'Kóhei Amasaki','Taito Ban','Riho Sugijama','Micuki Nakae','Hiromiči Tezuka','Miho Okasaki','Hisako Tódžó','Hana Sató','Šinnosuke Ogami','Čado Horii','Saori Hajami','Manaka Iwami','Kóki Mijata','Ajumi Mano','Satoši Hino','Júki Kuwahara','Nanami Jamašita','Reina Ueda','Eidži Takemoto','Ai Kajano','Daisuke Hirakawa','KENN','Tošihiko Seki','Kana Ueda','Taiten Kusunoki','Sóičiró Hoši','Kacujuki Koniši','Konomi Kohara','Hóko Kuwašima','Kaede Hondo','Jó Taiči','Masaki Terasoma',"Šin'ja Takahaši",'Júsuke Tonozaki','Jošiaki Hasegawa','Saeko Akiho','Satoši Curuoka','Džun Fukušima','Aki Tojosaki','Jú Hajaši','Čikahiro Kobajaši','Kódai Sakai','Rjóhei Kimura','Misako Tomioka','Haruka Širaiši','Júko Minaguči','Micuo Iwata','Mikako Komacu','Maaja Sakamoto','Džun Fukujama','Daiki Jamašita','Takara Inoue','Júki Takada',"Džun'iči Suwabe",'Micuhiro Ičiki','Jošihisa Kawahara','Tarusuke Šingaki','Ikuko Tani','Rjóko Širaiši','Tecu Inada','Ami Košimizu','Kóki Učijama','Jumiri Hanamori','Ari Ozawa','Šótaró Morikubo','Jošimasa Hosoja','Šigeru Čiba','Mamiko Noto','Satomi Sató',"Šin'ičiró Miki",'Makoto Furukawa','Kanae Itó','Šinnosuke Tačibana','Nacuko Kuwatani','Ajaka Šimizu','Tomokazu Sugita',"Ken'iči Suzumura",'Kana Hanazawa','Tomokazu Seki','Kengo Kawaniši','Juri Ehara','Akira Išida'],
basedOn:['Kojoharu Gotóge'],
production:['Hikaru Kondó','Masanori Mijake'],
music:['Gó Šiina','Juki Kadžiura'],
camera:['Júiči Terao'],
cut:['Manabu Kamino'],
scenography:['Kódži Etó','Juri Kabasawa','Masaru Janaka']},
{title:'The Legend of Vox Machina',
titleCZ:'Legenda jménem Vox Machina',
year:2022,
runtime:'10h 3min',
episodeRuntime:'24-28min',
countries:['USA'],
genres:['Animation','Action','Adventure','Fantasy','Comedy'],
director:['Sung Jin Ahn','Alicia Chan','Young Heller','Stanley Von Medvey','Chan-Young Park','Sung-jin Suh','Yu-Won Pang'],
actors:['Matthew Mercer','Ashley Johnson','Laura Bailey','Marisha Ray','Travis Willingham',"Liam O'Brien",'Taliesin Jaffe','Grey Griffin','Esme Creed-Miles','Khary Payton','Stephen Root','Gina Torres','Indira Varma','Rory McCann','Stephanie Beatriz','Anjali Bhimani','Dominic Monaghan','Kelly Hu','Eugene Byrd','Tony Hale','Logic','David Tennant','Max Mittelman','Felicia Day','Tracie Thoms','Cree Summer','Mason Alexander Park','Sam Riegel','Maximus Riegel','Sunil Malhotra','Mary Elizabeth McGlynn','Darin De Paul'],
screenplay:['Jennifer Muro','Eugene Son','Brandon Auman','Sam Riegel','Travis Willingham'],
production:['Eugene Son'],
music:['Neal Acree'],
cut:['Todd Raleigh'],
sound:['James Lucero','Konrad Piñon'],
scenography:['Arthur Loftis']},
{title:'A Small Light',
titleCZ:'Světlo naděje',
year:2023,
runtime:'6h 49min',
episodeRuntime:'41-56min',
countries:['USA'],
genres:['Biographic','History','Drama'],
director:['Leslie Hope','Susanna Fogel','Tony Phelan'],
actors:['Bel Powley','Liev Schreiber','Ashley Brooke','Jim High','Billie Boullet','Joe Cole','Liza Sadovy','Andrew Van Wilpe','Victor Dohlsten','Amira Casar','Jenn Kirk','Veronika Bellová','Andy Nyman','Caroline Catz','Ian McElhinney','Nicholas Burns','Sally Messham','Laurie Kynaston','Eleanor Tomlinson','Brian Caspe','Nathan Macchioni','Tom Stourton','Vicki Pepperdine','Sebastian Armesto','Noah Taylor','Gregory Gudgeon','Kryštof Bartoš','Aleš Bílík','Jan Chudý','Daniel Kamen','Arnost Kraus','Jiří Vojta','Alex Figueiredo','Noah Leggott','Cosima Shaw','Hanna van Vliet','Claudia Vašeková','Ben Esler','Rudi Goodman','Sean Hart','Dylan Edwards','Sarah T. Cohen','Lisa Karlström','Abigail Rice','Václav Jiráček','Eliza Roth','Preston Nyman','Michal Roneš','Sebastian Jacques','Michael Pitthan','Gabriela Farr','Sytske van der Ster','Robbert Bleij','Evelyne Tollman','Daniel Donskoy','Robert Dölle','Rosie Fellner','James Beaumont','Daniela Hirsh','Sinead Phelps','George Cobell','Tadeáš Moravec','Thomas Flynn','Judith Georgi','Jan Jakubal','Tadeas Mestdagh','Andrew Mockler','Charleen Elea'],
screenplay:['Ben Esler','Tony Phelan','Joan Rater','William Harper','Alyssa Margarite Jacobson'],
production:['Guy Riedel'],
music:['Ariel Marx'],
camera:['Stuart Howell','Azul Serra'],
cut:['Susan E. Kim','Nicole Artzer','Martin Nicholson','Lynarion Hubbard'],
sound:['Ruth Adelman','Myron Nettinga'],
scenography:['Ines Rose','Marc Homes'],
masks:['Sophia Knight','Pavla Frýdová'],
costumes:['Matthew Simonelli']},
{title:'Rome',
titleCZ:'Řím',
year:2005,
runtime:'19h 45min',
episodeRuntime:'44-65min',
countries:['UK','USA'],
genres:['Drama','History','War','Action'],
director:['Michael Apted','Allen Coulter','Jeremy Podeswa','Mikael Salomon','Alan Taylor','Roger Young','Steve Shill','Timothy Van Patten','Julian Farino','Alan Poul','Alik Sakharov','Adam Davidson','John Maybury','Carl Franklin'],
actors:['Kevin McKidd','Ray Stevenson','Polly Walker','Kerry Condon','James Purefoy','Ian McNeice','Coral Amiga','Lindsay Duncan','Lidia Biondi','Tobias Menzies','Nicholas Woodeson','David Bamber','Chiara Mastalli','Kenneth Cranham','Indira Varma','Alice Henley','Max Pirkis','Esther Hall','Ciarán Hinds','Rick Warden','Zuleikha Robinson','Guy Henry','Lyndsey Marshal','Camilla Rutherford','Allen Leech','Clive Riche','Graham McTavish','Simon Woods','Alex Wyndham','Ronan Vibert','Rafi Gavron','Allan Corduner','Cosimo Fusco','Lee Boardman','Karl Johnson','Tim Barlow','Lydia Leonard','Francesca Fowler','Paolo Paoloni','Vernon Dobtcheff','Edward de Souza','Paul Jesson','Abhin Galeya','Michael Culkin','Paola Lavini','Danny Midwinter','Bart Ruspoli','Nigel Lindsay','Richard Katz','Lorcan Cranitch','Adam Levy','Andrew Greenough','Jonathan Coy','Georgie Glen','Emilio De Marchi','Andy Linden','Roger Hammond','Grant Masters','Giacomo Gonnella','Vincenzo Nicoli','René Zagger','Ted Rusoff','Haydn Gwynne','Andrew Scarborough','Charlie Anson','Matt Patresi','Richard Dillane','Douglas Dean','Rebekah Staton','Niko Nicotera','Lynda Baron','Enoch Frost','Barbara Marten','Michael Nardone','Anne Lambton','Sara Kestelman','David de Keyser','Simon Gregor','Bruce Mackinnon','Linal Haft','Peter Eyre','Suzanne Bertish','Giovanni Calcagno','Manfredi Aliquo','Anna Fausta Primiano','Anna Francolini','Daniel Cerqueira','Alessio Cuna','Frank Baker','Enzo Cilenti','Anthony Souter','Francesca Romana Coluzzi','Simon Callow','Silvio Evangelista','David Kennedy','Dominic Coleman','Michele Melega','Indira Varma','Deborah Moore','Sergio Di Pinto'],
screenplay:['Adrian Hodges','Alexandra Cunningham','David Frankel','Scott Buck','Bruno Heller','Eoghan Mahony','William J. MacDonald','John Milius'],
production:['Todd London'],
music:['Jeff Beal'],
camera:['Jonathan Freeman','Alik Sakharov','Marco Pontecorvo','Martin Kenzie'],
cut:['Rick Shaine','David Siegel','Glenn Farr','Frances Parker','Sidney Wolinsky','Oral Norrie Ottey','Yan Miles'],
sound:['R. Russell Smith','William Freesh','David B. Cohn'],
scenography:['Anthony Pratt','Joseph Bennett','Cristina Onori'],
masks:['Matteo Silvi','Massimo Gattabrusi','Giulio Pezza','Elisabetta De Leonardis','Claudia Bianchi','Alessandro Durante','Aldo Signoretti','Marco Perna','Marta Iacoponi'],
costumes:['April Ferry']},
{title:'Shameless',
titleCZ:'Hříšníci',
year:2011,
runtime:'118h 29min',
episodeRuntime:'43-59min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Mark Mylod','John Wells','John Dahl','Todd Holland','Stephen Hopkins','Mimi Leder','Scott Frank','Anthony Hemingway','Michael Uppendahl','William H. Macy','Emmy Rossum','David Nutter','Adam Bernstein','Sanaa Hamri','Craig Zisk','Daisy von Scherler Mayer','Alex Graves','Steve Shill','Randall Einhorn','Danny Cannon','Peter Segal','James Ponsoldt','Richie Keen','Wendey Stanzler','Iain B. MacDonald','Nisha Ganatra','Jake Schreier','Lynn Shelton','Christopher Chulack','Allison Liddi-Brown','Regina King','Zetna Fuentes','Jeffrey Reiner','Anna Mastro','James M. Muro','Michael Morris','Erin Feeley','Ruben Garcia','Kat Coiro','Silver Tree','Loren Yaconelli','Roberto Sneider','Shari Springer Berman','Robert Pulcini','Jennifer Arnold','Rose Troche','Anthony Hardwick','Kevin Bray','Gary B. Goldman','Jude Weng','Daniella Eisman','Satya Bhabha','Shanola Hampton','John M. Valerio'],
actors:['Emmy Rossum','William H. Macy','Cameron Monaghan','Steve Howey','Justin Chatwin','Michael Patrick McGill','Joan Cusack','Jeremy Allen White','Jane Levy','Jillian Armenante','Steven Lee Allen','Kelly Curran','Bonnie Morgan','Robert Knepper','Amy Smart','Toby Huss','Joel Murray','Dennis Boutsikaris','John Kapelos','Mike Cochrane','Dichen Lachman','Nathan McMullen','Tim Thomerson','Stephanie Fantauzzi','Laura Wiggins','Ethan Cutkosky','Emma Kenney','Emma Greenwell','Shanola Hampton','Noel Fisher','Dove Cameron','Joe Minoso','William Smillie','Frank Pacheco','Jes Macallan','Sarah Stouffer','Valente Rodriguez','Robert Gallo','Angelo Tiffe','Ben Batt','Madison Davenport','Brent Jennings','William Stanford Davis','Tony Revolori','Ed Lauter','Paul James','Christian Clemenson','Bill Brochtrup','Casey Biggs','Zach McGowan','Jonathan Dane','Megan Easton','James Wolk','James Pusztay','Kimberly Hebert Gregory','Katherine Cunningham','Danika Yarosh','Ryan McIntyre','Mike Doyle','Yves Bright','Timothy V. Murphy','Vyto Ruginis','Angela Oh','Exie Booker','Pete Ploszek','Gina Gallego','Noel Arthur','Chris Fogleman','Susan Krebs','Diora Baird','Jack Carter','Michael Mantell','Marguerite Moreau','Eric Edelstein','Elizabeth Bond','Sam Doumit','J. Michael Trautmann','Yrsa Daley-Ward','Jerry Lambert','Bruno Amato','Kevin Mukherji','Michael Hyatt','Alison Haislip','Michael Adam Hamilton','Carol Kiernan','Cherami Leigh','Nichole Sakura','Aubrey K. Miller','Hector Duran','Sunkrish Bala','Rose Abdoo','Niky Wardley','Bridgid Coulter','Yorgo Constantine','Ellen Albertini Dow','Jeffery Self','Corey Sorenson','Zoran Korach','Lucien Laviscount','Austin Abrams'],
screenplay:['Paul Abbott','Emma Frost','John Wells',"Mike O'Malley",'Malcolm Campbell','Daniel Brocklehurst','William H. Macy','Sheila Callaghan','Nancy M. Pimental','Alex Borstein','Steven Schachter','Krista Vernoff','Davey Holmes','Mark Steilen','Molly Smith Metzler','Philip Buiser','Sherman Payne','Joe Lawson','Corina Maritescu'],
production:['Philip Buiser','Molly Smith Metzler','Terri Murphy','John Wells','Michelle Lankwarden','Michael Hissrich'],
music:['Fil Eisler','Jeff Russo','Mark Mothersbaugh','Mike McCready'],
camera:['James M. Muro','Florian Emmerich','Rodney Charters','Jean-Philippe Gossart','Loren Yaconelli','Kevin McKnight','Anthony Hardwick','Philip Buiser','Anthony Vietro'],
cut:['David Moritz','Julie Monroe','Kelley Dixon','Kevin D. Ross','Toby Yates','John Wells','Jeffrey M. Werner','Regis Kimble','Mark Sadlek','Robert Bramwell','Thomas M. Bolger','Russell Denove','Finnian Murray','Michael Stern','Tim Tommasino','Shannon Mitchell','Mark Strand','Nathan Allen','Omar Hassan-Reep','John M. Valerio','Chetin Chabuk','Brent McReynolds'],
sound:['Dan Hiland','Carlos Sanches','Ed Carr','Gerry Lentz','Todd Grace','Gary D. Rogers','Jason Brennan','Tom Marks','Daniel P. Church'],
scenography:['Nina Ruscio','Stephen Altman','Danielle Berman','Tricia Schneider','Jacqueline Glynn','Jami Primmer','K.C. Fox'],
masks:['Crystal M. Cook','Michele Teleis-Fickle','Jori Jenae McGuire','Rochelle Uribe','Alejandra Ford','Lynne K. Eagan','Sharon Rivera','Ginger Damon'],
costumes:['Lyn Paolo','Mandi Line']},
{title:'Fleabag',
titleCZ:'Potvora',
year:2016,
runtime:'5h 6min',
episodeRuntime:'23-28min',
countries:['UK'],
genres:['Comedy','Drama'],
director:['Harry Bradbeer','Tim Kirkby'],
actors:['Phoebe Waller-Bridge','Sian Clifford','Olivia Colman','Hugh Skinner','Bill Paterson','Jenny Rainsford','Brett Gelman','Ben Aldridge','Hugh Dennis','Kevin McNally','Jamie Demetriou','Anthony Welsh','Jenny Galloway','Ben Bailey Smith','Kae Alexander','Andrew Scott','Sophie Karl','Olive Gray','Fiona Shaw','Jo Martin','Amelda Brown','David Hargreaves','Ray Fearon','Angus Imrie','Kristin Scott Thomas','Bob Goody','Rebecca Johnson','Christian Hillborg','Kadiff Kirwan','Jenny Robins','London Hughes','Jordan Long'],
screenplay:['Phoebe Waller-Bridge'],
music:['Isobel Waller-Bridge'],
camera:['Laurie Rose','Tony Miller'],
cut:['Gary Dollner','Paul Machliss'],
scenography:['Julian Nagel','Jonathan Paul Green'],
masks:['Polly Campbell','Marie Deehan'],
costumes:['Ray Holman','Jo Thompson']},
{title:'Dopesick',
titleCZ:'Absťák',
year:2021,
runtime:'8h 20min',
episodeRuntime:'58-67min',
countries:['USA'],
genres:['Drama','Crime'],
director:['Barry Levinson','Michael Cuesta','Patricia Riggen','Danny Strong'],
actors:['Michael Keaton','Michael Stuhlbarg','Peter Sarsgaard','Will Poulter','John Hoogenakker','Kaitlyn Dever','Rosario Dawson','Will Chase','Jake McDorman','Phillipa Soo','Ryan Paynter','Elizabeth Becka','Brendan Patrick Connor','Winsome Brown','Andrea Laing','Andrés Erickson','David Alexander','Alexander Baxter','Ray McKinnon','Cleopatra Coleman','Raúl Esparza','Mare Winningham','Jaime Ray Newman','Andrea Frankle','Linda Powell','Meagen Fay','Rebecca Wisocky','Amy Rutberg','R. Keith Harris','Paden Fallis','Vince Pisani','Deja Dee','Cory Scott Allen','Andrew Polk','Helen Goldsby','Jennifer Haralson','Adam Grupper','Eliana Ghen','Dave Pileggi','Joe Knezevich','Brian Kurlander','Lawrence Arancio','Rachel Walters','Marilyn Busch','Scott Deal','Wyatt Hunt','Arischa Conner'],
basedOn:['Beth Macy'],
screenplay:['Danny Strong'],
production:['Richie Kern'],
music:['Lorne Balfe'],
camera:['Checco Varese'],
cut:['Douglas Crise','Matt Barber','Chi Yoon Chung'],
sound:['Nick Offord','Robert Getty'],
scenography:['Neil Spisak','Chris Cornwell'],
masks:['Ann-Maree Hurley','Shelley Illmensee','Alexis Arenas'],
costumes:['Michele Michel']},
{title:'Initial D: First Stage',
titleCZ:'Initial D',
year:1998,
runtime:'10h 50min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Drama','Comedy','Sport'],
director:['Šin Misawa',"Šin'iči Masaki",'Masami Hata','Hiroši Curuta','Susumu Kudó','Naojuki Kuzuja','Mihiro Jamaguči','Jošitaka Kojama','Jukio Nišimoto','Kazujoši Jokota','Júzó Sató'],
actors:["Šin'ičiró Miki",'Ajako Kawasumi','Micuo Iwata','Takehito Kojasu','Tomokazu Seki','Unšó Išizuka','Wataru Takagi','Kazuhisa Kawahara','Nobujuki Hijama','Akio Sujama','Jumi Kakazu','Kósuke Okano','Tomomiči Nišimura','Kunihiko Jasui','Osamu Hosoi','Tóru Furusawa','Orine Fukušima','Kazuki Jao','Keidži Fudžiwara','Mičiko Neja','Keiiči Cučija','Kate Higgins','Neil Kaplan'],
basedOn:['Šúiči Šigeno'],
screenplay:['Nobuaki Kišima','Hiroši Toda'],
production:['Kajo Fukuda','Hiromiči Mogaki'],
music:['Rjúiči Kacumata'],
camera:['Seiiči Morišita','Kendži Akazawa'],
cut:['Hideaki Murai','Kijotaka Mijake','Tošihiko Kodžima','Jumiko Nakaba','Hadžime Okajasu','Akihiro Kawasaki','Hideto Óta'],
sound:['Masafumi Mima'],
scenography:['Minoru Maeda','Kazuhiro Takahaši']},
{title:'Billions',
titleCZ:'Miliardy',
year:2016,
runtime:'78h 58min',
episodeRuntime:'49-61min',
countries:['USA'],
genres:['Drama'],
director:['Neil Burger','James Foley','Scott Hornbacher','Neil LaBute','Stephen Gyllenhaal','John Dahl','Susanna White','Karyn Kusama','Anna Boden','Ryan Fleck','Michael Cuesta','Reed Morano','Alex Gibney','Noah Emmerich','Steph Green','Adam Arkin','John Singleton','Colin Bucksey','Matt Shakman','Mike Binder','Stacie Passon','Jake Polonsky','Jessica Yu','Michael Morris','Adam Bernstein','Matthew McLoota','Laurie Collyer','Naomi Geraghty','Lee Tamahori','Shaz Bennett','David Costabile','Joshua Marston','Daniel Attias','Chloe Domont','Tara Nicole Weyr','Sylvain White','Darren Grant','Rose Beth Johnson-Brown','Daniel Gray Longino'],
actors:['Paul Giamatti','Damian Lewis','Maggie Siff','Malin Åkerman','Toby Leonard Moore','Liz Celeste','Marko Caka','David Costabile','Jeffrey DeMunn','Terry Kinney','Glenn Fleshler','Stephen Kunken','Aly Mang','Michael Countryman','Nathan Darrow','Ruben Santiago-Hudson','Murphy Guyer','Ilfenesh Hadera','Kelly AuCoin','Zachary Unger','John Carroll Lynch','Anthony Edwards','James Le Gros','Noah Emmerich','Casey Siemaszko',"Jerry O'Connell",'Ben Shenkman','Neal Huff','Stephen Rowe','Arthur J. Nascarella','Deborah Rush','Melissa Errico','Robert LuPone','Jack Gore','Daniel Cosgrove','Angela Oh','Susan Misner','Louis Cancelmi','Dennis Boutsikaris','Jack Gilpin','John Ellison Conlee','Penn Jillette','Catherine A. Callahan','Alex Cranmer','Cadden Jones','Gregg Bello','Doris McCarthy','Scott Cohen','Tamara Tunie','Louisa Krause','Austin Pendleton','Jeremy Bobb','Kate Jennings Grant','John Henry Cox','Susan Kelechi Watson','Richard Toth','Bobby Kruger','Kerry Bishé','James Hetfield','Lars Ulrich','Kirk Hammett','Robert Trujillo','Tom Kemp','Joanne Tucker','Rob Morrow','Jennifer Lafleur','Steven Pasquale','Harry Lennix','Adriane Lenox','Matthew Humphreys','Sal Rendino','Seth Barrish','Ian Blackman','Ezra Knight','Ben Lawson','Katie Maguire','Rich Chew','Victor Slezak','Ivan Martin','Kathryn Erbe','Ashley Blankenship','Glenn Fitzgerald','Edward Baker-Duly','Orlagh Cassidy','Clara Wong','Kate Arrington','Christopher Denham','Frank Harts','Danny Strong','Kevin Breznahan','James Wolk','Brian Distance','Alexandra Wilson','John Pirkis','David Paterson','Matt Servitto','Eric Bogosian','Allan Havey','Quinn Franzen','Ian Kahn'],
screenplay:['Wes Jones','Peter Blake','Andrew Ross Sorkin','David Levien','Wes Taylor','Brian Koppelman','Adam R. Perlman','Randall Green',"Alice O'Neill",'Brian Chamberlayne','Michael Russell Gunn','Lenore Zion','Heidi Schreck','Ben Mezrich','Theo Travers','Eli Attie','Beth Schacter','Emily Hornsby','Amadou Diallo','Lio Sigerson','Mae Smith','Aiyana White'],
music:['Brendan Angelides'],
camera:['Eric Steelberg','Jake Polonsky','Radium Cheung','Alexander Dynan','Giorgio Scali','Joseph E. Gallagher','J.B. Smith']},
{title:'Severance',
titleCZ:'Odloučení',
year:2022,
runtime:'16h 20min',
episodeRuntime:'40-57min',
countries:['USA'],
genres:['Drama','Thriller','Mystery','Sci-Fi'],
director:['Ben Stiller','Aoife McArdle'],
actors:['Adam Scott','Patricia Arquette','Zach Cherry','Dichen Lachman','Britt Lower','Tramell Tillman','Jen Tullock','John Turturro','Christopher Walken','Yul Vazquez','Michael Chernus','Michael Cumpsty','Annie McNamara','Grace Rex','Mark Kenneth Smaltz','Nikki M. James'],
screenplay:['Dan Erickson','Andrew Colville','Anna Ouyang Moench','Kari Drake'],
music:['Theodore Shapiro'],
camera:['Jessica Lee Gagné']},
{title:'Why Women Kill',
titleCZ:'Proč ženy zabíjí',
year:2019,
runtime:'16h 31min',
episodeRuntime:'43-56min',
countries:['USA'],
genres:['Comedy','Crime','Drama'],
director:['David Grossman','Elizabeth Allen Rosenbaum','Marc Webb','Valerie Weiss','Lucy Liu','Dawn Wilkinson','David Warren','Jennifer Getzinger','Eva Longoria','Larry Shaw','Melanie Mayron','Joanna Kerns'],
actors:['Lucy Liu','Ginnifer Goodwin','Kirby Howell-Baptiste','Alicia Coppola','Philip Anthony-Rodriguez','Bobby Nish','David Banks','Alexandra Daddario','Robert Craighead','Jack Davenport','Sam Jaeger','Reid Scott','Leo Howard','Sadie Calvano','Kevin Daniels','Katie Finneran','Adam Ferrara','Michael Dempsey','Spencer Garrett','Josh Clark','Jill Basey','Beau Dremann','Lindsey Kraft','Maria Russell','Saidah Arrika Ekulona','Christine Estabrook','E.J. Callahan','Alex Meneses','Marianne Muellerleile','Kevin McNamara','Rod Keller','Li Jun Li','Lio Tipton','Scott Porter','Scot Zeller','Peter Breitmayer','Karl T. Wright','Kevin Sifuentes','Jack Armstrong','Jason Boegh','Abbie Cobb','Frank Gallegos','T.J. Hoban','Ron Roggé','Clint Carmichael','Christina Anthony','Beverly Rose','Joe Gillette','Annie Korzen','Michelle Bernard','Adam Shapiro','Peta Murgatroyd','Tim Cannon','Jean St. James','Claudia Choi','Dominique Toney','Carrie Schroeder','Allison Tolman','Nick Frost','Lana Parrilla','B.K. Cannon','Jordane Christie','Matthew Daddario','Veronica Falcón','Rachel Bay Jones','Daniel Zacapa','Virginia Williams','Rondi Reed','Jack Davenport',"Kerry O'Malley",'Jonathan Ohye','Jessica Phillips','Rachel Redleaf','Alex Lange','Kayla Carlson','Talita Maia','Warren Kole','Jason Kravits','Brad Greenquist','Debra Christofferson','Nardeep Khurmi','Frederick Keeve','Tyler Clark','Robbie Troy','Dan Sachoff','Amy Chaffee','Mason Wells','Smac','Odelya Halevi','David Perez Babich','Christopher Bencomo','Marcel Nahapetian','Eileen Galindo','Jack Seavor McDonald','Shelli Boone','Victoria Kelleher','Jay Brian Winnick','Connie Jackson','Kendall Denise Clark'],
screenplay:['Marc Cherry','Randi Mayem Singer','Joe Keenan','Alexa Junge','Hannah Schneider','Joshua Michael Stern','Stacey Harman'],
production:['Mark Grossan','Marc Cherry','Stacey Harman','Stephen Bowman','Hannah Schneider'],
music:['Mateo Messina','Steve Jablonsky'],
camera:['Michael A. Price'],
cut:['Michael Berenbaum','Christopher Kroll'],
sound:['Robb Navrides','Brad Zoern','Adam Sawelson','Frank Morrone'],
scenography:['Mark Worthington'],
masks:['Valerie Jackson','Kristina Frisch','Cyndilee Rice','Ayat Malek Kiankhooy','Maurine Burke','Desiree Falcon','Diana Acrey'],
costumes:['Janie Bryant']},
{title:'M*A*S*H',
titleCZ:'M*A*S*H',
year:1972,
runtime:'108h 15min',
episodeRuntime:'25-120min',
countries:['USA'],
genres:['Comedy','Drama','War'],
director:['Michael Switzer','Mel Damski','Gabrielle Beaumont','Jackie Cooper','Stuart Millar','Hy Averback','John Erman','Susan Oliver','E. W. Swackhamer','Lee Philips','Charles S. Dubin','William Wiard','Norman Tokar','Don Weis','Alan Alda','Harry Morgan','Jamie Farr','Mike Farrell','David Ogden Stiers',"Michael O'Herlihy",'Bruce Bilson','Earl Bellamy','Larry Gelbart','William K. Jurgensen','Tony Mordente','Gene Reynolds','Alan Rafkin','George Tyne','Joshua Shelley','Burt Metcalfe','James Sheldon','Nell Cox','Joan Darling'],
actors:['Alan Alda','Wayne Rogers','Mike Farrell','McLean Stevenson','Harry Morgan','Loretta Swit','Larry Linville','David Ogden Stiers','Jamie Farr','William Christopher','G. Wood','Gary Burghoff','Kellye Nakahara','Jeff Maxwell','G. W. Bailey','Allan Arbus','Edward Winter','Robert Alda','Antony Alda','Pat Morita','Marcia Strassman','Sal Viscuso','Patrick Swayze','Leslie Nielsen','Jerry Zaks','Andrew Dice Clay','Soon-Tek Oh','Perry Lang','Michael Mann','Mary Wickes','Ron Howard','John Fujioka','Rosalind Chao','Gwen Verdon','Mako','Odessa Cleveland','Gary Grubbs','John Ritter','Brett Cullen','John Anderson','James Stephens','David Graf','Laurence Fishburne','Joe Pantoliano','George Wendt','Teri Garr','Bruno Kirby','Earl Boen','Stuart Margolin','Craig Wasson','James Karen','Jack Soo','Albert Hall','Larry Wilcox','Edward Herrmann','Mariette Hartley','Art LaFleur','Joan Van Ark','John P. Ryan','Mark Herrier','Susan Saint James','George Cheung','James Sikking','Sorrell Booke','Gail Strickland','Kario Salem','Ed Flanders','Philip Bruns',"Cyril O'Reilly",'William Lucking','Mark L. Taylor','Linda Kelsey','Kieu Chinh','Charles Frank','Denny Miller','Ned Beatty','Calvin Levels','Mary Jo Catlett','Harry S. Truman','Stuart Charno','Douglas MacArthur','Marty Thomas','Louisa Moritz',"Dick O'Neill",'Alex Karras','Jack Riley','Robin Riker','Joseph Maher','Sab Shimono','Barbara Tarbuck','James Gregory','Edward Binns','Václav Kabourek','Cameron Dye','Mills Watson','Charles Aidman','Arlene Golonka','Grant Withers','Richard Herd','Dennis Fimple'],
basedOn:['Richard Hooker'],
screenplay:['David Isaacs','Ken Levine','Richard Hooker','Larry Gelbart','Ring Lardner Jr.','Alan Alda','Robert Klane','Linda Bloodworth-Thomason','Mike Farrell','Mary Kay Place','McLean Stevenson','Mitch Markowitz','Hal Dresner','Allan Katz','Gary David Goldberg','Carl Kleinschmitt','Sheldon Keller','Arthur Julian','Keith Walker','Wayne Rogers','Laurence Marks','Ronny Graham','Don Reo','James Fritzell','Everett Greenbaum','Gene Reynolds','Burt Metcalfe','Rick Mittleman','Elias Davis','David Pollock','Glen Charles','Les Charles','Burt Prelutsky','Larry Balmagia','Simon Muntner','Bill Idelson','Karen Hall','Bruce Shelly','Richard Powell','Dennis Koenig','Bob Colleary','Charlie Hauck','Thad Mumford','Sheldon Bull','Jerry Mayer','Paul Perlove','Burt Styler','Ed Jurist','Tom Reeder','Lee H. Grant','Jim Mulligan','John D. Hess','Sy Rosen','Sid Dorfman'],
production:['Don Reo','Larry Gelbart','Gene Reynolds','Allan Katz','Burt Metcalfe','Dennis Koenig','Thad Mumford','Jim Mulligan'],
music:['Johnny Mandel','Roger Kellaway','Earle Hagen','Pete Rugolo','William K. Jurgensen','John Carl Parker','Duane Tatro','Billy May','Benny Golson'],
camera:['William K. Jurgensen','Vilis Lapenieks','Andrew Jackson','Meredith M. Nicholson','Dominic Palmieri','Joe Jackman','Sherman Kunkel','Richard A. Kelley'],
cut:['Samuel E. Beetley','Fred W. Berger','Howard Kunin','Stanford Tischler','Larry L. Mills'],
scenography:['Stuart A. Reiss','Donald E. Webb','Bert Allen','Norman Rockett','Frank T. Smith','Jerry Wunderlich','Walter McKeegan','James W. Sullivan','Ralph Sylos','Rodger Maus'],
masks:['Terry Miles','Carol Pershing']},
{title:'The Killing',
titleCZ:'Zločin',
year:2011,
runtime:'33h 47min',
episodeRuntime:'43-60min',
countries:['USA'],
genres:['Crime','Drama','Mystery'],
director:['Ed Bianchi','Nicole Kassell','Phil Abraham','Daniel Attias','Keith Gordon','Lodge Kerrigan','Agnieszka Holland','Gwyneth Horder-Payton','Patty Jenkins','Brad Anderson','Gregory Middleton','Jonathan Demme','Jennifer Getzinger','Veena Sud','Kevin Bray','Kari Skogland','Michael Rymer','Tricia Brock','Coky Giedroyc'],
actors:['Mireille Enos','Joel Kinnaman','Billy Campbell','Liam James','Michelle Forbes','Brent Sexton','Kristin Lehman','Eric Ladin','Jamie Anne Allman','Evan Bird','Seth Isaac Johnson','Tom Butler','Annie Corley','Gregg Henry','Brendan Sexton III','Amy Seimetz','Garry Chalk','Katie Findlay','Elias Koteas','Hugh Dillon','Bex Taylor-Klaus','Julia Sarah Stone','Peter Sarsgaard','Aaron Douglas','Brandon Jay McLaren','Colin Lawrence','Jewel Staite','Claudia Ferri','Mark Moses','Brian Markinson','Callum Keith Rennie','Ashley Johnson','Katherine Evans','Ingrid Torrance','Kerry Sandomirsky','Joan Allen','Tyler Ross','Sterling Beaumon','Ben Cotton','Don Thompson','Kacey Rohl','Randal Edwards','Barclay Hope','Richard Harmon','Chad Willett','Little JJ','Alan Dale','Ryan Robbins','Marin Ireland','Tyler Johnston','Lee Garlington','Patrick Gilmore','Sean Owen Roberts','Brendan Fletcher','Allison Hossack',"Q'orianka Kilcher",'Nicholas Lea','Eric Keenleyside','Ted Whittall','Peter Benson','Diana Bang','Michael Kopsa','Matreya Scarrwener','Chelsea Ricketts','Sachin Sahel','Brad Kelly','Jake Croker','Peter Kelamis','Kevin McNulty','Leanne Lapp','Justin Rain','Peter Bryant','Jack Irvine','Grace Zabriskie','Jennifer Spence','Michael Mando','Sofie Gråbøl','Patti Smith','Laine MacNeil','Brendan Penny','Anne Marie DeLuise','Jarod Joseph','Adrian Hough','Camille Sullivan','Madeleine Arthur','Chilton Crane','Peter Graham-Gaudreau','Alex Zahara','Farrah Aviva','Alona Tal','Andrew Moxham','Rob Carpenter','Paul Jarrett','Darren Moore','Jesse Wheeler','Avery Konrad','Eve Harlow','Erica Tremblay','Lindsay Collins','Jillian Fargey'],
screenplay:['Veena Sud','Dan Nowak','Dawn Prestwich','Nicole Yorkin','Soo Hugh','Nic Pizzolatto','Wendy Riss','Brett Conrad','Nathaniel Halpern','Sean Whitesell','Aaron Zelman','Eliza Clark','Nic Sheff','Coleman Herbert','Jeremy Doner','David Wiener'],
music:['Frans Bak'],
camera:['Peter Wunstorf','Gregory Middleton','Brian Johnson']},
{title:'The Sopranos',
titleCZ:'Rodina Sopránů',
year:1999,
runtime:'78h 30min',
episodeRuntime:'43-72min',
countries:['USA'],
genres:['Drama','Crime'],
director:['Andy Wolk','John Patterson','Daniel Attias','Lorraine Senna','Allen Coulter','Alan Taylor','Lee Tamahori','Nick Gomez','Steve Buscemi','Jack Bender','Peter Bogdanovich','Mike Figgis','David Nutter','Steve Shill','Timothy Van Patten','Rodrigo García','James Hayman','David Chase','Matthew Penn','Terence Winter','Phil Abraham','Henry Bronchtein','Danny Leiner'],
actors:['James Gandolfini','Lorraine Bracco','Edie Falco','Michael Imperioli','Dominic Chianese','Steven Van Zandt','Tony Sirico','Robert Iler','Jamie-Lynn Sigler','Drea de Matteo','Steve Schirripa','Vincent Pastore','Frank Vincent','Nancy Marchand','Kathrine Narducci','Jerry Adler','Joseph R. Gannascoli','John Ventimiglia','Chandra Wilson','Paul Schulze','Aida Turturro','Oksana Lada','Al Sapienza','Federico Castelluccio','Sharon Angela','Frank Pando','Max Casella','Michael Rispoli','Anthony DeSando','Annette Bening','David Strathairn','Robert Loggia','Elias Koteas','Vondie Curtis-Hall','Burt Young','Joe Pantoliano','Robert Patrick','Alicia Witt','Dan Grimaldi','Steve Buscemi','Charles S. Dutton','Jon Favreau','Bill Cobbs','Sallie Toussaint','Annabella Sciorra','Edoardo Ballerini','Julianna Margulies','Dick Latessa','Erica Leerhsen','Bokeem Woodbine','Richard Portnow','Neal Jones','Paul Dano','Peter Bogdanovich','John Heard','Will McCormack','John Hensley','Vanessa Ferlito','J.D. Williams','Geoffrey Cantor','Sofia Milos','Aleksa Palladino','Josh Pais','Lola Glaudini','Chris Diamantopoulos','Bryan Greenberg','Ben Kingsley','Lauren Bacall','Wilmer Valderrama','Daniel Baldwin','Ken Leung','Tim Daly','Siân Heder','Michael Gaston','Ari Graynor','Robert LuPone','Oni Faida Lampley','Bruce Altman','Mark Blum','Liza Lapira','Anthony Indelicato','C.S. Lee','Linda Lavin','Mike Epps','Jerry Grayson','Judy Reyes','Yul Vazquez','Larry Sellers','Sarah Shahi','Jason Cerbone','Elizabeth Reaser','Jelena Solověj','Christina Cabot','Amy Redford','Jonathan LaPaglia','Elizabeth Bracco','Heather MacRae','Sarah Thompson','Joe Penny','Arabella Field'],
screenplay:['David Chase','Terence Winter','Michael Caleo','David Flebotte','Nick Santora','Mitchell Burgess','Robin Green','Lawrence Konner','Michael Imperioli','Todd A. Kessler','Matthew Weiner','Toni Kalem','Salvatore Stabile','Diane Frolov','Andrew Schneider','Frank Renzulli','James Manos Jr.','Jason Cahill','Mark Saraceni'],
production:['Diane Frolov'],
camera:['Phil Abraham','Alik Sakharov'],
cut:['Michael Ruscio','William B. Stich','Sidney Wolinsky','Joanna Cappuccilli Lovetti','Tammis Chandler'],
sound:['Kevin Patrick Burns','Todd Orr','Adam Sawelson','Tom Perry','Fred Tator','Peter Nusbaum','Verna Mandel','Jason George','Mathew Price','William H. Angarola','Ron Evans'],
scenography:['Bob Shaw','Edward Pisoni','Dean Taucher','Janet Shaw','Jennifer Greenberg'],
masks:['John Caglione','Jr.','Fabrizio Sforza','Stephen Kelley','Dennis Parker','Patrick Alemi','Jerry DeCarlo','Linda Grimes'],
costumes:['Juliet Polcsa','Ane Crabtree','Kim Marie Druce']},
{title:"'Allo 'Allo!",
titleCZ:'Haló, haló!',
year:1982,
runtime:'43h 14min',
episodeRuntime:'25-50min',
countries:['UK'],
genres:['Comedy','War'],
director:['David Croft','Martin Dennis','Richard Boden','John B. Hobbs','Mike Stephens','Susan Belbin'],
actors:['Gorden Kaye','Carmen Silvera','Vicki Michelle','Richard Marner','Kim Hartman','Guy Siner','Rose Hill','Philip Kendall','Jack Haig','Richard Gibson','Kenneth Connor','Arthur Bostrom','John Louis Mansi','Robert East','Gaby Dellal','Hilary Minster','Kirsten Cooke','Sam Kelly','Tim Barker','Francesca Gonshaw','Sue Hodge','Derek Royle','Gavin Richards','David Janson','Pat Gorman','Roger Hammond','Richard Cottan','Jeremy Lloyd','Harriet Thorpe','Jonnie Hurn','Giles Watlling','Moira Foot','Owen Brenman','Nicholas Frankau','David Griffin','Aimée Delamain','John Rutland','Michael Percival','Michael Sheard','Ian McLaren','David Croft','John Bluthal','Peter Waddington','Peggy Ann Clifford','Joy Allen','Eric Dodson','Jack Hedley','Ann Michelle','Stephen Churchett','Tim Marriott','Bill Malin','Carole Ashby','Chris Andrews','Robin Parkinson','Graham Seed'],
screenplay:['Ian Davidson','Ronald Chesney','Ronald Wolfe'],
production:['David Croft','John B. Hobbs','Mike Stephens'],
music:['David Croft','Roy Moore'],
sound:['Terry Elms'],
scenography:['Gary Williamson','Paul Cross','Garry Freeman'],
masks:['Jane Walker','Suzanne Jansen'],
costumes:['Jill Taylor','Sheena Napier','Carol Lawrence']},
{title:'Hustle',
titleCZ:'Podfukáři',
year:2004,
runtime:'47h 44min',
episodeRuntime:'57-60min',
countries:['UK'],
genres:['Crime','Drama','Mystery'],
director:['Otto Bathurst','James Strong','Colm McCarthy','S.J. Clarkson','Stefan Schwartz','Iain B. MacDonald','Rob Bailey','Minkie Spiro','Roger Goldby','Bharat Nalluri','Alrick Riley',"Sarah O'Gorman",'Luke Watson'],
actors:['Robert Glenister','Robert Vaughn','Adrian Lester','Marc Warren','Jaime Murray','Matt Di Angelo','Kelly Adams','Ashley Walters','Rob Jarvis','Stephen Campbell Moore','Ben Miles','Tamzin Outhwaite','Max Grodénchik','Richard Chamberlain','Emil Marwa','Lee Ingleby','Orla Brady','Katie Walder','Eileen Essell','David Walliams','John Carlisle','Patrick Bergin','Dido Miles','Nikki Magnusson','Steven Robertson','Tim Plester','Robert Pugh','Jake Canuso','Indira Varma','Elizabeth Croft','Mark Bazeley','Kate Fleetwood','Guy Henry','Christine Adams','Shaun Dooley','Paul Nicholls','Vincent Riotta','Steve McTigue','Ronald Pickup','Patricia Hodge','Denis Lawson','Michael Smiley','Craig Parkinson','Tom Goodman-Hill','Mel Smith','Tom Beard','David Haig','Angel Coulby','Clemency Burton-Hill','Danny Webb','Peter Ferdinando','Stuart McQuarrie','John Barrowman','Silas Carson','Abhin Galeya','Peter Polycarpou','Bill Bailey','William Ellis','Eleanor Matsuura','Nicholas Boulton','William Lucking','Joe Armstrong','India Wadsworth','Francis Magee','Julian Firth','Dimitri Leonidas','Brian Pettifer','David Schaal','Ryan Gage','Claire Goose','Marlene Sidaway','Patrick Ryecart','Phil Atkinson','Richard Dixon','Kenneth Gilbert','Nicholas Asbury','Richard Katz','John Harding','Terence Harvey','Amit Shah','Richard Harrington','Phil Cornwell','Kieran Bew','Raquel Cassidy','David Harewood','Andrew Greenough','Velibor Topic','Simon Kassianides','Geno Monteiro','Tony Rohr','Simon Kunz','Jonny Phillips','Alix Wilton Regan','Brett Fancy','Leon Ockenden','Vincent Franklin','Mark Tandy','Zubin Varla','David Spinx','Paul Chahidi'],
screenplay:['Dave Cummings','Steve Coombes','Howard Overman','James Payne','Ryan Craig','Tom Butterworth','Chris Hurford','Mark Chappell','Julie Rutterford','Colin Bytheway','Tony Jordan','Fintan Ryan','Marston Bloom','Matthew Graham','Chris Lang','Ashley Pharoah'],
production:['Simon Crawford Collins','Karen Wilson'],
music:['Magnus Fiennes','Beatguru'],
camera:['Kieran McGuigan','Stephan Pehrsson','Tim Fleming','Fabian Wagner','Jake Polonsky','Checco Varese','Balazs Bolygo','Simon Archer','Nic Morris','Adam Suschitzky','Tim Palmer','Gordon Hickie'],
cut:['Barney Pilling','Victoria Boydell','David Thrasher','Steve Ackroyd','Jeremy Strachan','Dominic Strevens','Mike Jones','Sarah Brewerton','Emma Oxley','Philip Hookway'],
sound:['Michael Fentum','Mark Ettel','Alex Thompson'],
scenography:['Paul Cross','Paul Spriggs','Anthony Ainsworth','Jane Broomfield','Alice Norris'],
masks:['Fran Needham','Katy Fray'],
costumes:['Iain Macaulay','Richard Cooke']},
{title:'Succession',
titleCZ:'Boj o moc',
year:2018,
runtime:'39h 25min',
episodeRuntime:'56-85min',
countries:['USA'],
genres:['Drama'],
director:['Adam McKay','Mark Mylod','Adam Arkin','Andrij Parekh','Miguel Arteta','S.J. Clarkson','Shari Springer Berman','Robert Pulcini','Becky Martin','Cathy Yan','Kevin Bray','Lorene Scafaria'],
actors:['Brian Cox','Jeremy Strong','Matthew Macfadyen','Sarah Snook','Kieran Culkin','Alan Ruck','Nicholas Braun','Hiam Abbass','Natalie Gold','Mary Birdsong','Dagmara Dominczyk','Zack Robidas','Peter Friedman','Parker Sawyers','Edan Alexander','J. Smith-Cameron','Justine Lupe','David Rasche','Judy Reyes','John Rue','Gameela Wright','Arian Moayed','Larry Pine','Ashley Zukerman','Annika Boras','Natasha Romanova','Peggy J. Scott','James Cromwell','Robert Myers','Eric Bogosian','Griffin Dunne','Ryan Begay','Vic Browder','Jason Selvig','Michael Izquierdo','Caitlin Fitzgerald','Jack Gilpin','Kristin Griffith','Richard Huw','Harriet Walter','Anna Wilson-Jones','Helen Coxe','Brock Yurich','Jake Choi','Jacqueline Antaramian','Drew Lewis','Justin Cunningham','Zoë Chao','Mandy Siegfried','Sydney Lemmon','Holly Hunter','Cherry Jones','Annabelle Dexter-Jones','Jeremy Shamos','Mark Linn-Baker','Taylor Ortega','Robert Jack','Jeannie Berlin','Jessica Hecht','Saamer Usmani','Patch Darragh','Zach Cherry','Danny Huston','Fisher Stevens','David K. Conklin','Albert Welling','Sally Murphy','Mark Blum','Victor Slezak','Michael Nathanson','Ekin Koç','Selim Bayraktar','Preston Fritz Smith','Angus Wright','Madeline Grey DeFreece','Tony DeMil','Christopher Convery','Swayam Bhatia','Wayne Pyle','Emily Levine','Jason DeStefano','Ken Holmes','Gina Jun','Bret Lada','Alison Chace','Ron Simons','Juliana Canfield','Michael Braun','Christine Spang','Sanaa Lathan','Linda Emond','Jihae','Dasha Nekrasova','Jordan Lage','Peter Riegert','Hope Davis','Ziwe Fumudoh','Johnny Ferri','Adrien Brody','Megan Byrne'],
screenplay:['Jesse Armstrong','Tony Roche','Jonathan Glatzer','Lucy Prebble','Jon Brown','Georgia Pritchett','Ted Cohen','Will Tracy','Susan Soon He Stanton'],
production:['Ron Bozman','Jonathan Filley','Jesse Armstrong','Will Tracy','Susan Soon He Stanton','Jonathan Glatzer'],
music:['Nicholas Britell'],
camera:['Andrij Parekh','Patrick Capone','Christopher Norr','Katelin Arizmendi'],
cut:['Ken Eluto','Jane Rizzo','Anne McCabe','Mark Yoshikawa','William Henry','Brian A. Kates','Joe Giganti'],
sound:['Nicholas Renbeck','Andy Kris'],
scenography:['Stephen H. Carter','Kevin Thompson','Mark Harris','Marci Mudd','George DeTitta Jr.','Andrew Sloane','Brandi Kalish'],
masks:['Gary Martori','Daniella Duque','Tania Couper','Patrick Alemi','Allison MacPherson','Shelley Illmensee','Daniel Ferretti','Björn Rehbein','Doone Forsyth','Maria Bjørnnes Hermansen','Rick Caroto','Milagros Medina-Cerdeira'],
costumes:['Catherine George','Michelle Matland']},
{title:'Endeavour',
titleCZ:'Endeavour',
year:2012,
runtime:'59h 8min',
episodeRuntime:'88-120min',
countries:['UK'],
genres:['Crime','Drama','Mystery'],
director:['Edward Bazalgette','Colm McCarthy','Tom Vaughan','Craig Viveiros','Lawrence Gough','Kristoffer Nyholm','Jim Loach','Börkur Sigþórsson','Michael Lennox','Ashley Pearce','Giuseppe Capotondi','Andy Wilson','Geoffrey Sax','Sandra Goldbacher','Bryn Higgins','Olly Blackburn','Brady Hood','Gordon Anderson','Robert Quinn','Johnny Kenton','Shaun Evans','Leanne Welham','Jamie Donoughue','Zam Salim','Kate Saxon','Ian Aryeh','Nirpal Bhogal'],
actors:['Shaun Evans','Roger Allam','Anton Lesser','Sean Rigby','Jack Laskey','Simon Kunz','Jonathan Hyde','Nigel Cooke','Chris Larkin','John Light','Rosalind Halstead','Tom McKay',"Genevieve O'Reilly",'Flora Montgomery','Louise Dylan','Jack Roth','Andrew Gower','David Oakes','Bronson Webb','Patrick Malahide','Fiona Ryan','Jessica Ellerby','Oliver Lansley','Lloyd McGuire','Craig Parkinson','Gina Bramhill','Nell Tiger Free','Vincent Riotta','Cécile Paoli','Anya Taylor-Joy','Daisy Head','Luke Allen-Gale','Martin Jarvis','Lex Shrapnel','Maimie McCoy','Beth Goddard','Hilton McRae','Lisa Backwell','Darwin Shaw','Sophie Stuckey','Lucy Boynton','Jonathan Coy','Crystal Leaity',"Hugh O'Brien",'Struan Rodger','Richard Dixon','Celyn Jones','David Westhead','Chris Barnes','Michael Shannon','Pooky Quesnel','Clive Wood','Sonya Cassidy','Adrian Schiller','Amelia Clarkson','Gordon G. Kennedy','Ian Gelder','Lasco Atkins','Lynn Farleigh','Greg Bennett','Alexandra Doyle','Matthew Wilson','James Bradshaw','Guy Williams','Jamie Glover','Edmund Kingsley','Richard Dillane','Martyn Mayger','Rob Callender','Albert Welling','Sara Vickers','Gala Gordon','Daniel Ings',"Caroline O'Neill",'Richard Banks','Jessie Buckley','Olivia Grant','Rita McDonald Damper','Martin Hancock','Sarah Winter','Sheila Hancock','Dakota Blue Richards','Chris Coghill','Grahame Fox','Sam Hoare','Alex Wyndham','Adam Levy','Celine Buckens','Robert Wilfort','Glen Davies','Phoebe Nicholls','David Yelland','Edward MacLiam','John Hopkins','Sion Alun Davies','Paul Bown','Sylvestra Le Touzel','Michael Fox','Jonathan Barnwell','Will Payne'],
screenplay:['Russell Lewis'],
production:['Camille Gatin','Neil Duncan','Tom Mullens'],
music:['Barrington Pheloung','Matthew Slater'],
camera:['Stephan Pehrsson','Gavin Finney','Neus Ollé','Peter Robertson','Gavin Struthers','John Pardue','John Lee','Zac Nicholson','Baz Irvine','Suzie Lavelle','Ed Rutherford','G. Magni Ágústsson','Jake Polonsky','Søren Bay','Adam Etherington','Simon Archer','Ollie Downey','Jamie Cairney','Chas Bain','Phil Wood','James Aspinall','James Moss','Joel Devlin','Tony Miller','Mark Waters','Annemarie Lean-Vercoe','Anna Valdez-Hanks'],
cut:['Masahiro Hirakubo','Stephen Haren','Andrew MacRitchie','Alex Mackie','Guy Bensley','Kate Baird','Daniel Greenway','Ben Drury','Alastair Reid','Mike Phillips','Mark Hermida','Tim Murrell','Miikka Leskinen','Anthony Combes','David Blackmore','Adam Bosman','Mark Thornton','Simon Smith','Sarah Louise Bates','David Webb','Jeremy Strachan','Adam Bokey','Charlie Phillips','Ulrike Münch','Yan Miles','Tom Henson-Webb'],
sound:['Alessio Masi','James Drake','John Downer','James Ridgway','Gareth Bull'],
scenography:['Matt Gant','Anna Pritchard','Pat Campbell','Paul Cripps','Claire Levinson-Gendler','Spencer Robertson','Anna Higginson','Faye Brothers'],
masks:['Niall McCaffrey-Cassidy'],
costumes:['Caroline Harris','Lindsay Pugh','Molly Emma Rowe','Jo Thompson','Eleanor Baker','Charlotte Mitchell','Sarah Ryan']},
{title:'Big Little Lies',
titleCZ:'Sedmilhářky',
year:2017,
runtime:'11h 48min',
episodeRuntime:'44-59min',
countries:['USA'],
genres:['Drama','Crime'],
director:['Jean-Marc Vallée','Andrea Arnold'],
actors:['Reese Witherspoon','Nicole Kidman','Shailene Woodley','Alexander Skarsgård','Laura Dern','Adam Scott','Zoë Kravitz','Parker Croft','James Tupper','Sarah Baker','Sarah Burns','Kathryn Newton','Hong Chau','Kelen Coleman','Jeffrey Nordling','Mark Adair-Rios','P.J. Byrne','Lacy Camp','Gia Carides','Joseph Cross','Carrie Alexander','Merrin Dungey','Virginia Kull','Larry Sullivan','Sarah Sokolovic','Iain Armitage','Ivy George','Santiago Cabrera','Stephen Graybill','Robin Weigert','Anil Kumar','Annie Fitzgerald','Meryl Streep','Darby Camp','Douglas Smith','Kate Rene Gleason','Chloe Coleman','Kimmy Shields','Khalilah Joi','Mo McRae','Chris Aquilino','Katie Featherston','Talia Toms','Cameron Crovetti','Nicholas Crovetti','Nelly Buchet','Martin Donovan','Linda Burzynski','Charles Maceo','Jeryl Prescott','Scott Alan Smith','Leonard Kelly-Young','Anthony Molinari','Crystal Fox','Kerri Kenney','Lauren Lakis','Michael Laskin','Alan Godshaw','Mark Heidelberger','Santiago Cabrera','Jonathan Grebe','Mykal-Michelle Harris','Michelle Lenhardt',"Denis O'Hare",'Christopher Backus','Eve Gordon','John Marshall Jones','Becky Ann Baker','Merrin Dungey','Poorna Jagannathan','Mike Bradecich','Will Hawkes','Bellina Logan','Travis Schuldt','Maverick Thompson','Teddy Blum','Taylor Treadwell','Tim True','Lauren Glazier','Kathreen Khavari','Stacie Greenwell','Bruce Nozick','Elizabeth Liang','Kevyn Bashore','David Monahan','Heather Simpson','Benjamin Valic','Wendy Wang','McKenna Ferry','Sheena Peña','Larry Bates','Richard Israel','Kayvon Esmaili','Paull Walia','Amy Tolsky','Bruce M. Stockert','Grant Davis','Michael Andrew Baker','Keisuke Hoashi','Benjamin Plessala'],
basedOn:['Liane Moriarty'],
screenplay:['David E. Kelley'],
production:['Nicole Kidman','David Auge'],
music:['Sam Williams'],
camera:['Yves Bélanger','Jim Frohna'],
cut:['Mags Arnold','Dino Jonsäter','Jacob Secher Schulsinger','Jean-Marc Vallée','Émile Vallée','Ana García','Katie Weiland','Sam Williams','Tom Randaxhe','Julian Smirke','Justin Lachance','David Berman'],
sound:['Paul Lucien Col','Stephen Griffiths','Éric Ladouceur'],
scenography:['John Paino','Amy Wells'],
masks:['Nickole Jones','Ayat Malek Kiankhooy','Justin Raleigh','Lisa Rocco','Claudia Humburg'],
costumes:['Alix Friedberg']},
{title:'This Is Us',
titleCZ:'Tohle jsme my',
year:2016,
runtime:'76h 21min',
episodeRuntime:'42-50min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Glenn Ficarra','John Requa','Ken Olin','Silas Howard','Sarah Pia Anderson','Uta Briesewitz','Helen Hunt','Timothy Busfield','Wendey Stanzler','John Fortenberry','Regina King','Chris Koch','Joanna Kerns','Rebecca Asher','Catherine Hardwicke','Roxann Dawson','Anne Fletcher','Sarah Boyd','Kevin Hooks','George Tillman Jr.','Milo Ventimiglia','Jessica Yu','Yasu Tanida','Justin Hartley','Kay Oyegun','Kevin Rodney Sullivan','Jon Huertas','Chris Sullivan','Glenn Steelman','Mandy Moore','Zetna Fuentes','James Takata'],
actors:['Milo Ventimiglia','Mandy Moore','Sterling K. Brown','Chrissy Metz','Justin Hartley','Susan Kelechi Watson','Gerald McRaney','Chris Sullivan','Alan Thicke','Caitlin Thompson','Andrew Santino','Jill Johnson','Mario Lopez','Jon Huertas','Katey Sagal','Brad Garrett','Alena Savostikova','Lak Rana','Ron Cephas Jones','Natalia Cigliuti','Wynn Everett','Milana Vayntrub','Hollie Shay','Logan Shroyer','Sam Trammell','Megan West','Janet Montgomery','Ric Sarabia','Julia Cho','Dan Considine','Brittany Ishibashi','Peter Onorati','Nikiva Dionne','Elizabeth Perkins',"Denis O'Hare",'Adam Bartley','Alexandra Breckenridge','Amanda Warren','Harrison White','Ken Lerner','Amanda Leighton','Kym Jackson','Anna Ross','Danielle Pinnock','John Pollono','Sylvester Stallone','Brett Tucker','Ron Howard','Lonnie Chavis','Jason Butler Harner','Abigail Zoe Lewis','Elizabeth Bond','Debra Jo Rupp','Kristin Minter','Betsy Baker','Brandon Ford Green','Brian Grazer','Tom Virtue','Nick Smoke','Adam Johnson','Jeremiah Birkett','Charley Koontz','Sam Anderson','Delroy Lindo','Cinda Adams','Conni Marie Brazelton','John Lee Ames','Jon Paul Burkhart','Stefanie Black','James Read','Matt Riedy','Rebecca Metz','Elise Robertson','Carlos E. Campos','Herbert Russell','Jason Rogel','Craig Stepp','Kate Burton','Tarina Pouncy','Jack McGee','Garrett Morris','Dawnn Lewis','Lena Waithe','Jane Daly','Lidia Porto','Bill Irwin','April Betts','Mark Proksch','Susan Blakely','Mallory Jansen','Jamal Duff','Pam Grier','Reynaldo Gallegos','Kevin Covais','Hari Dhillon','Erik Aude','Niles Fitch','Shaun Duke','Richard Tanner','Phil Abrams'],
screenplay:['K.J. Steinberg','Isaac Aptaker','Elizabeth Berger','Don Roos','Shukree Tilghman','Dan Fogelman','Donald Todd','Aurin Squire','Kay Oyegun','Julia Brownell','Kevin Falls','Laura Kenar','Danielle Bauman','Casey Johnson','David Windsor','Elan Mastai','Tyler Bensinger','Joe Lawson','Vera Herbert','Eboni Freeman','Jonny Gomez','Jon Dorsey','Bekah Brunstetter','Susan Kelechi Watson','Jake Schnesel','Chrissy Metz'],
production:['Shukree Tilghman','Elan Mastai','Kay Oyegun','Nick Pavonetti','Vera Herbert','Isaac Aptaker','Elizabeth Berger'],
music:['Siddhartha Khosla'],
camera:['Brett Pawlak','Yasu Tanida','James Takata'],
cut:['David L. Bertman','Brandi Bradburn','Romina Rey','Howard Leder','Lai-San Ho','Erin Nicole Wyatt','Susan Vaill','Bjørn T. Myrholt','Nicholas Rucka'],
sound:['Joe DeAngelis','Michael Kalifa','Lisle Engle','Sherry Klein','Christian P. Minkler','Brian Harman','Dean Okrand','Adam Sawelson','Randal S. Thomas','Matthew T. Duncan'],
scenography:['Gary Frutkoff','Dan Bishop','Cindy Coburn','Greg Richman'],
masks:['Tifanie White','Michele Tyminski Schoenbach','David Abbott','Zoe Hay','Jennifer Tremont','Tania McComas','Ketty Gonzalez'],
costumes:['Hala Bahmet','Ashley Kemper']},
{title:'The Marvelous Mrs. Maisel',
titleCZ:'Úžasná paní Maiselová',
year:2017,
runtime:'39h 23min',
episodeRuntime:'43-76min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Amy Sherman-Palladino','Daniel Palladino','Scott Ellis','Jamie Babbit','Daniel Attias','Daisy von Scherler Mayer'],
actors:['Rachel Brosnahan','Tony Shalhoub','Michael Zegen','Alex Borstein','Marin Hinkle','Justine Lupe','Eden Malyn','Joey Stromberg','Ned Van Zandt','Barbara Kingsley','Byron Jennings','Jon Wolfe Nelson','Caitlin Mehner','Victor Verhaeghe','Bailey De Young','Luke Kirby','Gilbert Gottfried','Betsy Hogg','Holly Curran','Brian Tarantina','Doris McCarthy','Kevin Pollak','Caroline Aaron','Mary Testa',"Jack O'Connell",'Kiva Dawson','David Paymer','Max Casella','Joe Grifasi','Robert Myers','Steve Rosen','Andrea Boehlke','Wallace Shawn','Erin Darke','Kara Jackson','Peggy J. Scott','Nate Corddry','Will Brill','Connie Ray','David Aaron Baker','Michael Nathanson','Larry Petersen','Zach Appelman','Jane Lynch','Steven Hauck','Wakeema Hollis','Laura Dreyfuss','Colby Minifie','Leslie Ann Phillips','Fred Applegate','Zachary Levi','Rufus Sewell','Blaise Corrigan','John Cariani','Chris Banks','Caitlin McGee','Jimmy Palumbo','Grayson Berry','Jake Silbermann','Chaz Lamar Shepherd','Andrew Gillespie','Ashley Bryant','Lucy DeVito','Michael Devine','Mark C. Fullhardt','Kevin Isola','Jacob Berger','Oona Roche','Stephanie Hsu','Sydney Farley','Sterling K. Brown','Devon Diffenderfer','Lauren Blumenfeld','Meghan Roberts','Gary Littman','Susannah Perkins','Adriana DeMeo','Teddy Coluca','Lydia Jordan','Zoila Garcia','Alexandre Wetter','Jo Ellen Pellman','Anni Krueger','Sophie Zucker','Allen Lewis Rickman','Tommy Beardmore','John Waters','David Bluvband','Patrick H. Fox','Ken Holmes','Lisandro Boccacci','Milo Ventimiglia','Jaz Goodreau','Lissa Carandang-Sweeney','Dee Hoty','Molly Brown','Ryan Woodle','Lilli Stein','Stephen C. Bradbury','Christopher De Stefano'],
screenplay:['Amy Sherman-Palladino','Sheila R. Lawrence','Daniel Palladino','Kate Fodor'],
production:['Sono Patel','Sal Carino','Kate Fodor','Nick Thomason','Daniel Goldfarb','Jen Kirkman','Dipika Guha'],
music:['Leslie Ann Phillips'],
camera:['M. David Mullen','Eric Moynier','Alex Nepomniaschy'],
cut:['Brian A. Kates','Kate Sanford','Tim Streeto','Andrew Mondshein','Anthony Boys'],
sound:['Ron Bochar','Mathew Price'],
scenography:['Bill Groom','Susan Kaufman','Imogen Lee','Jan Jericho','Heather Loeffler','Ines Rose','Katie Citti'],
masks:['Brittany Romney','Joshua First','Danielle Minnella','Elvira Gonzalez','Kimberley Spiteri','Patrick Alemi','Michael Buonincontro','Colleen LaBaff','Jerry DeCarlo','Laura Burns','Daniel Ferretti','Amy Sue Nahhas','Michael Ward','Lena Jemmott','Mariko Miyagi','Jason J Dougherty','Greg Cooper-Spencer','Milagros Medina-Cerdeira'],
costumes:['Donna Zakowska']},
{title:'Blackadder',
titleCZ:'Černá zmije',
year:1983,
runtime:'12h 15min',
episodeRuntime:'30-35min',
countries:['UK'],
genres:['Comedy','History'],
director:['Martin Shardlow','Mandie Fletcher','Richard Boden'],
actors:['Rowan Atkinson','Richard Murdoch','Roger Sloman','John Savident','Brian Blessed','Bill Wallis','Gretchen Franklin','John Hallam','Stephen Gressieux','Angus Deayton','Perry Benson','Philip Kendall','Roy Evans','Elspet Gray','Kathleen St. John','Hugh Laurie','Ron Cook','Stephen Frost','Jim Broadbent','John Barrad','Joolia Cappleman','Forbes Collins','Patrick Allen','Robert East','Miriam Margolyes','John Carlisle','Peter Benson','Alex Norton','Oengus MacNamara','Arthur Hewlett','Peter Cook','Tony Robinson','Tim McInnerny','Patrick Malahide','Paul Brooke','Rik Mayall','Stephen Fry','Willoughby Goddard','Jane Freeman','Tom Baker','Lesley Nicol','Sadie Shimmin','Miranda Richardson','William Hootkins','Simon Jones','Holly De Jong','Chris Barrie','Geoffrey McGivern','Robbie Coltrane','Ben Elton','Kenneth Connor','Nigel Planer','Geoffrey Palmer','Lee Cornes','Gabrielle Glaister','Hugo Blick','Howard Lew Lewis','Frank Finlay','Patsy Byrne','Gabrielle Glaister','John Grillo','Edward Jewesbury','Tony Aitken','Ronald Lacey','Cassie Stuart','Daniel Thorndike','William Russell','Denis Lill','Hugh Paddick','Warren Clarke','Roger Avon','Gertan Klauber','Adrian Edmondson','Philip Pope','Helen Atkinson Wood','Paul Mark Elliott','Sarah Thomas','Linda Polan'],
screenplay:['Richard Curtis','William Shakespeare','Rowan Atkinson','Ben Elton'],
music:['Howard Goodall'],
camera:['Bill Broomfield'],
cut:['Mike Jackson','Chris Wadsworth'],
masks:['Ann Fenton'],
costumes:['Odile Dicks-Mireaux','Annie Hardinge']},
{title:'Luther',
titleCZ:'Luther',
year:2010,
runtime:'19h 40min',
episodeRuntime:'57-62min',
countries:['UK'],
genres:['Crime','Drama','Mystery','Thriller'],
director:['Sam Miller','Jamie Payne','Brian Kirk','Stefan Schwartz','Farren Blackburn'],
actors:['Idris Elba','Dermot Crowley','Warren Brown','Ruth Wilson','Michael Smiley','Paul McGann','Nikki Amuka-Bird','Steven Mackintosh','Saskia Reeves','Indira Varma','Patrick Malahide','Sienna Guillory','Aimee-Ffion Edwards','Wunmi Mosaku',"David O'Hara",'Hermione Norris','Enzo Cilenti','Kierston Wareing','David Dawson','Pam Ferris','Matthew Marsh','Danny Lee Wynter','Louisa Lytton','Ross McCall','Sam Spruell','Nicola Walker','Nigel Cooke','Bryony Afferson','Babou Ceesay','Hamza Jeetooa','Brett Fancy','Laura Haddock','Rose Leslie','Louise Rose','Michael Shaeffer','Lasco Atkins','Sasha Behar','Clem So','Oliver Stark','Jamie Glover','Ania Sowinski','Keeley Forsyth','Ellie Haddington','Chris Cowlin','Atul Sharma','Sean Pertwee','Paul Rhys','Andrew Tiernan','Rob Jarvis','Thomas Lockyer','Alexander Morton','Lee Ingleby','Anna Brewster','Lee Nicholas Harris','Steven Robertson','Lucian Msamati','Laura Pyper','Ned Dennehy','Alexandra Moen','Elliot Cowan','Jason Riddington','Michelle Duncan','Paul Blackwell','Darren Boyd','Michael Obiora','Lorraine Hilton','Mick Slaney','Matthew David McCarthy','Ryan Calais Cameron','Shaun Mason','John Heffernan','Teresa Mahoney','Rupert Procter','Alan Williams','Chris Wilson','Matti Houghton','Luke Westlake','Vincent Vermignon','Andrew Mullan','Katie Brayben','Anthony Howell','Selin Hizli','Mark Rowley','Anton Valensi','Selva Rasalingam','Simon Wilson','Tommy French','Annabel Bates','Roberta Taylor','Luke Ward-Wilkinson','Nicholas Asbury','Johann Myers','Jami Reid-Quarrell','Stephen Boxer','Golda Rosheuvel','Emma Fischer','Okorie Chukwu','Andreea Paduraru'],
screenplay:['Neil Cross'],
production:['Marcus Wilson'],
music:['Paul Englishby'],
camera:['Julian Court','John Conroy','John Pardue','Giulio Biccari','Stephan Pehrsson','Tim Fleming'],
cut:['Katie Weiland','Tania Reddin','Victoria Boydell','Elen Pierce Lewis','Sam Williams','Joel Skinner'],
sound:['Mathew Knights','Jay Price','Steve Single'],
scenography:['Paul Cross','Tom Brown','Nicola De Fresnes','Jason Carlin'],
masks:["Jess O'Shea",'Nora Robertson'],
costumes:['James Keast']},
{title:'The Kominsky Method',
titleCZ:'Kominského metoda',
year:2018,
runtime:'9h 44min',
episodeRuntime:'22-37min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Beth McCarthy-Miller','Chuck Lorre','Donald Petrie','Andy Tennant'],
actors:['Alan Arkin','Sarah Baker','Michael Douglas','Ashleigh LaThrop','Emily Osment','Graham Rogers','Melissa Tang','Nancy Travis','Azie Tesfai','Willam','Jully Lee','Lisa Edelstein','Corbin Bernsen','Nikiva Dionne','Elizabeth Sung','Jocelyn Towne','Danny DeVito','Ann-Margret','Elliott Gould','Jay Leno','Patti LaBelle','Allison Janney','Tommy Walker','Haley Joel Osment','Jenna Lyng Adams','Aaron Schwartz','Jean St. James','Paul Reiser','Bob Odenkirk','Ravi Kapoor','Kevyn Bashore','Brandon Morales',"Becky O'Donohue",'Susan Sullivan','Jason Kravits','George Wyner','Raymond Ma','Harrison White','Rex Linn','Frank Noon','Lauren Weedman','Christian Barillas','Jen Drohan','Jeffrey D. Sams','Lainie Kazan','Julie Wittner','Christopher Kriesa','Nadia Lanfranconi','Jane Seymour','David James Elliott','Rebekah Graf','Kathleen Turner','Julianna Gamiz','Kamilla Alnes','Amber Lynn','Annie Tedesco','Melody Butiu','Alice Tate','Christon Blue','Matt Knudsen','Casey Thomas Brown','Bob Rumnock','Eddie Money','Butch Klein','AnaSofia Bianchi','Natasha Hall','J.D. Walsh','Marianne Muellerleile','Lynn A. Henderson','Morgan Freeman','Barry Levinson','Lourdes Benedicto','Gilbert Gottfried','Christine Ebersole','Jon Cryer','Joseph Will','Maurice Hall','Judith Sheindlin','Jeremy A. Lopez','Adam Zastrow','Anoush NeVart'],
screenplay:['Chuck Lorre','Alan J. Higgins'],
production:['Marlis Pujol','Andy Tennant','Beth McCarthy-Miller'],
music:['Jeff Cardoni'],
camera:['Anette Haellmigk','Jaime Reynoso'],
cut:['Steven Lang','Matthew Barbato','Gina Sansom','Steven Pristin'],
sound:['Yuri Reese','Sean Madsen','William Smith'],
scenography:['Denny Dugally','Kristin Peterson','Kathy Orlando','Denise Hudson'],
masks:['Liz Briseno','Michele Tyminski Schoenbach','Björn Rehbein'],
costumes:['Beth Morgan','Molly Grundman']},
{title:'Spartacus: Gods of the Arena',
titleCZ:'Spartakus: Bohové arény',
year:2011,
runtime:'5h 31min',
episodeRuntime:'51-63min',
countries:['USA'],
genres:['Action','Drama','Adventure','History'],
director:['Rick Jacobson','Michael Hurst','Jesse Warn','Brendan Maher','John Fawcett'],
actors:['John Hannah','Lucy Lawless','Dustin Clare','Nick E. Tarabay','Raicho Vasilev','Lesley-Ann Brandt','Peter Mensah','Manu Bennett','Jaime Murray','Marisa Ramirez','Craig Walsh Wrightson','Temuera Morrison','Jeffrey Thomas','Antonio Te Maioha','Stephen Lovatt','Gareth Williams','Josef Brown','Jessica Grace Smith','Shane Rangi','Jason Hood','Peter Feeney','David Austin','Daniel Feuerriegel','Ande Cunningham','Janine Burchett','Brooke Williams','Lliam Powell','Andy Whitfield','Matthew Saville','Luke Pegler','Andrew Laing','Stephen Ure'],
screenplay:['Steven S. DeKnight','Maurissa Tancharoen','Jed Whedon','Brent Fletcher','Aaron Helbing','Todd Helbing','Misha Green','Seamus Kevin Fahey'],
production:['Rob Tapert'],
music:['Joseph LoDuca'],
camera:['Aaron Morton','John Cavill'],
cut:['Allanah Milne'],
sound:['William Freesh'],
masks:['Sarah Rubano',"Jane O'Kane",'Roger Murray'],
costumes:['Barbara Darragh']},
{title:'Hale and Pace',
titleCZ:'Hale and Pace',
year:1988,
runtime:'33h 30min',
episodeRuntime:'30min',
countries:['UK'],
genres:['Comedy'],
director:['Peter Orton','David G. Hillier','Vic Finch'],
actors:['Gareth Hale','Norman Pace','Vinnie Jones','Ainsley Harriott','J.C. Mac','Geoffrey Greenhill','Lee Richards','Andy Linden','Gary Olsen','Beryl Nesbitt','Melvyn Bragg','David Quilter','Claire King','Melanie Kilburn','Carla Mendonça','Felicity Dean','Tony Mathews','Linda Regan','Georgia Allen','Angus Lennie','Mark Caven','Edward Clayton','Hazel Ellerby','Matilda Thorpe','Helen Atkinson Wood','Jo Kendall','Tony Millan','Annette Badland','Ron Tarr','Gordon G. Kennedy','Patricia Mort','Royce Mills','Rick Wakeman','Doon Mackichan','Caroline Quentin','Walter Sparrow','Freddie Jones','Gian Sammarco','Arthur White','Derren Nesbitt','Anna Nicholas','Vic Reeves','Bob Mortimer','Vas Blackwood','Cleo Rocos','Alec Bregonzi','Angela Curran','Veronica Doran','Peter MacQueen','Zita Sattar','Amanda Holden','Beverley Klein','Sheila Grier'],
screenplay:['Andy Parsons','Chris Lang','Gareth Hale','Norman Pace','Laurie Rowley','Simon Greenall'],
production:['Alan Nixon','David G. Hillier','Mark C. Robson'],
cut:['Chris Welch'],
sound:['Alex Thompson'],
scenography:['Mike Oxley'],
masks:['Christine Cant'],
costumes:['Tudor George','Janet Benge']},
{title:'The Return of Sherlock Holmes',
titleCZ:'Návrat Sherlocka Holmese',
year:1986,
runtime:'9h 22min',
episodeRuntime:'50-52min',
countries:['UK'],
genres:['Crime','Mystery'],
director:['Peter Hammond','Patrick Lau','Brian Mills','John Madden','David Carson','Howard Baker','John Gorrie','John Bruce','Ken Hannam'],
actors:['Jeremy Brett','Edward Hardwicke','Kristoffer Tabori','Kika Markham','Charles Gray','Geoffrey Bayldon','Robert Addie','Alan Howard','Eric Sykes','Vernon Dobtcheff','Jonathan Newth','Freda Dowie','Richard Bebb','Ozzie Yue','Terence Longdon','Jonathan Coy','Vincenzo Nicoli','Christopher Benjamin','Eleanor David','Steve Plytas','Conrad Phillips','William Abney','Clive Francis','Norman Bowler','Denis Lill','Michael Logan','Paul Williamson','Basil Hoskins','Rosalie Williams','Patrick Allen','Colin Jeavons','Anne-Louise Lambert','Oliver Tobias','Michael Culver','Yves Beneyton','Patricia Hodge','Stuart Wilson','Harry Andrews','Albert Moses','Marina Sirtis','Damien Thomas','Sally Faulkner','Freddie Jones','Robert Fyfe','Emil Wolk','Sean Scanlan','Malcolm Storry'],
basedOn:['Arthur Conan Doyle','Arthur Conan Doyle'],
screenplay:['John Hawkesworth'],
music:['Patrick Gowers'],
camera:['Tony Imi','Mike Popley','Ray Goode','Ken Morgan'],
cut:['Oral Norrie Ottey','Edward Mansell'],
scenography:['Michael Grimes','Alan Pickford']},
{title:'Vinland Saga',
titleCZ:'Vinland Saga',
year:2019,
runtime:'19h 40min',
episodeRuntime:'24-29min',
countries:['Japan'],
genres:['Animation','Action','History'],
director:['Šúhei Jabuta','Takaši Andó','Jódži Sató','Acuši Kobajaši','Tomoko Hiramuki','Šigacu Jošikawa','Jasuo Edžima','Šingo Učida','Mičiru Itabisaši','Nobujoši Arai','Tadahito Macubajaši','Šigeru Fukase','Jošiaki Kawadžiri','Keisuke Inoue','Šigejuki Mija','Seimei Kidokoro','Taró Kubo','Aiko Sakuraba'],
actors:['Júto Uemura','Akio Ócuka','Ao Takahaši','Hiroki Gotó','Hiroki Jasumoto','Jódži Ueda','Jošimicu Šimojama',"Ken'ičiró Macuda",'Kenšó Ono','Makoto Furukawa','Micuhiro Ičiki','Naoja Učida','Rjóta Takeuči','Satoši Hino',"Šin'ja Takahaši",'Takajuki Sugó','Šizuka Išigami','Maki Kawase','Taiči Ičikawa','Ikumi Hasegawa','Taito Ban','Riho Sugijama','Saki Mijašita','Júki Sanpei','Kósuke Óniši','Takahiro Sumi','Hana Sató','Takajuki Nakacukasa','Hitomi Nabatame','Jošiaki Hasegawa','Cuguo Mogami','Ajako Takeuči','Rjósuke Takahaši','Kappei Jamaguči','Kendži Nomura','Tadaši Mijazawa','Reina Kondó','Širó Saitó','Čiaki Kobajaši','Jumi Hara','Hiroši Širokuma','Šóko Cuda','Kensuke Sató',"Šin'ja Hamazoe",'Takuja Nakašima','Masato Niwa','Acuši Ono','Džin Urajama','Rjúnosuke Watanuki','Hiroaki Okuda','Džiró Saitó','Kazuhiro Nakaja','Júki Išikari','Kaori Motojama','Manami Hanawa','Juki Ominami','Šinnosuke Musaši','Júko Ueda','Júsuke Óta','Šóko Haraguči',"Ken'ičiró Macuda",'Majumi Sako','Šunsuke Takeuči','Fuminori Komacu','Hideaki Tezuka','Jú Hajaši','Mugihito','Taiten Kusunoki','Emiko Takeuči','Hajato Kimura','Nao Tójama','Tomoko Šiota','Hiroši Janaka','Marie Ói','Mirei Kumagai','Kowaka Wakana','Kósuke Okamoto','Šinpači Cudži','Šómaru Zóza','Daiki Kobajaši','Minami Kurisaka','Sajuri Sadaoka','Činacu Akasaki','Hazuki Ogino','Rie Hikisaka','Takuja Sató','Jasuhiro Mamija','Júki Wakai','Tacumaru Tačibana','Mičitake Kikuči','Sakuma Motoki','Satoru Itó','Šóta Jamamoto','Masafumi Kobatake','Takuja Masumoto','Hiroki Macukawa','Takaaki Torašima','Takajuki Mijamoto','Kódži Takeda','Jóko Fudžita'],
basedOn:['Makoto Jukimura'],
screenplay:['Kenta Ihara','Hiroši Seko'],
production:['Hitoši Macumoto'],
music:['Jutaka Jamada'],
camera:['Júki Kawašita','Hisaši Macumuko'],
cut:['Kašiko Kimura'],
sound:['Šódži Hata'],
scenography:['Júsuke Takeda','Izumi Hirabajaši','Kentaró Ónuki']},
{title:'All Creatures Great and Small',
titleCZ:'Všechny velké a malé bytosti',
year:2020,
runtime:'21h 38min',
episodeRuntime:'45-53min',
countries:['UK'],
genres:['Drama'],
director:['Andy Hay','Metin Hüseyin','Brian Percival','Sasha Ransome','Stewart Svaasand','Jordan Hogg'],
actors:['Anna Madeley','Samuel West','Rachel Shenton','Callum Woodhouse','Nigel Betts','Matthew Lewis','Melanie Kilburn','Diana Rigg','Nigel Havers','Maimie McCoy','Tony Pitts','Naomi Radcliffe','Nicholas Ralph','Charlie May-Clark','Mike Harding','Austin Haynes','Paul Hawkyard','Joseph May','Euan Macnaughton','June Watson','Dorothy Atkinson','Will Thorp','James Fleet','Cleo Sylvestre','Amy Nuttall','Patricia Hodge','Steven Hartley','Frances Tomelty','James Burrows','Samuel Jordan','Michael Maloney','Marc Pickering','Jolyon Coy','Vic Reeves','Adrian Rawlins','Ian Mercer','Tina Louise Owens','Susan Jameson','Jake Hayes','Harriet Slater','Gabriel Quigley','Drew Cain','Paul Hilton','Billy Hickey','Neve McIntosh','James Bolam','Paul Bazely','Cat Simmons','Ryan Hawley','Chloe Harris','Paul Copley','Sam Retford','James Anthony-Rose','Rachel Leskovac'],
basedOn:['James Herriot'],
screenplay:['Ben Vanstone','Lisa Holdsworth','Chloë Mi Lin Ewart','Debbie O’Malley','Karim Khan','Jamie Crichton','Freddy Syborn','James Herriot','Helen Raynor'],
production:['Richard Burrell','Yvonne Francas'],
music:['Alexandra Harwood'],
camera:['Vanessa Whyte','Erik Molberg Hansen','James Swift','Annemarie Lean-Vercoe','Mark Waters','Erik Persson','Sara Deane','Ian Adrian'],
cut:['Adam Trotman','John Wilson','William Oswald','Caroline Bleakley','Pete Drinkwater','David Thrasher'],
scenography:['James Gray','Jacqueline Smith','Steven Grainger','Dominic Smithers'],
masks:['Stephanie Lalley','Jules Greenan'],
costumes:['Ros Little']},
{title:'Narcos: Mexico',
titleCZ:'Narcos: Mexiko',
year:2018,
runtime:'29h 25min',
episodeRuntime:'46-70min',
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Andrés Baiz','Amat Escalante','Alonso Ruizpalacios','Josef Kubota Wladyka','Marcela Said','Wagner Moura','Alejandra Marquez Abella','Luis Ortega'],
actors:['Diego Luna','Scoot McNairy','José María Yazpik','Fermín Martínez','Michael Peña','Alejandro Edda','Alfonso Dosal','Fernanda Urrejola','Alyssa Diaz','Mark Kubr','Jorge A. Jimenez','Ernesto Alterio','Joaquín Cosio','Clark Freeman','Horacio Garcia Rojas','Jackie Earle Haley','Tenoch Huerta','Tessa Ia','Lenny Jacobson','Matt Letscher','Tim Ransom','Teresa Ruiz','Edison Ruíz','Aaron Staton','Gerardo Taracena','Yul Vazquez','Memo Villegas','Ron Melendez','Dettmar Yañez','Ricardo Esquerra','Pedro Joaquín','Edgar Novoa','Tete Espinoza','Gustavo Navarro','Carlos Hernan Romo','Mayra Hermosillo','Omar Ayala','Bobby Soto','Sebastián Buitrón','Daniel Damuzi','Manuel Masalva','Andrés Almeida','Rodrigo Murray','Ari Gallegos','Emilio Guerrero','Luis Roberto Guzmán','Francisco Barreiro','Gorka Lasaosa','Vladimir Cruz','Itza Sodi','Yuriria del Valle','Mike Doyle','Julia Lehman','Tania Arredondo','Jorge Antonio Guerrero','Natasha Esca','Claudio Roca','Eric Lange','Juan Pablo de Santiago','Wagner Moura','Alberto Ammann','Francisco Denis','Pêpê Rapazote','J. Downing','Sabina Gadecki','Baltimore Beltran','Nicolasa Ortíz Monasterio','Pamela Almanza','Scoot McNairy','Miguel Rodarte','Alex Knight','Jesse Garcia','Alberto Zeni','Andres Londono','Juan Sebastián Calero','Viviana Serna','Francisco Calvillo','Flavio Medina','Jesús Ochoa','Sosie Bacon','José Julián','Noé Hernández','Alfonso Borbolla','Marilyn Uribe','Roxana Saucedo','Érick Israel Consuelo','Roberto Cavazos','Fernanda Andrade','Nat Faxon','Christopher Stanley','Molly Hagan','Barry Livingston','Rafael Simón','Matias Varela','Mauricio Isaac','Mariana Treviño','Adolfo Madera','Mike Ostroski','Alejandra Guilmant','Edmundo Vargas'],
basedOn:['Terrence E. Poppa'],
screenplay:['Clayton Trussell','Johnny Newman','Eric Newman','Ashley Lyle','Bart Nickerson','Andrew Black','Jessie Nickson-Lopez','Scott Teems','Alec Ziff','Carlo Bernard','Doug Miro','Eva Aridjis','Maggie Cohn','Isaac Gomez'],
production:["Lorenzo O'Brien",'Clayton Trussell','Ashley Lyle','Bart Nickerson','Nick Laws','Tim King'],
music:['Kevin Kiner','Gustavo Santaolalla'],
camera:['Luis David Sansans','Damian Garcia','Lula Carvalho'],
cut:['Iain Erskine','Joaquin Elizondo','Monty DeGraff','Jon Otazua','Hugo Diaz','Garret Donnelly'],
sound:['Kevin Roache','Joe Barnett','Brad Zoern','Adam Jenkins','Pete Elia'],
scenography:['Salvador Parra','Paola Enríquez','Mariana Fernández Santoyo','Joaquín de la Riva','Julieta Jiménez'],
masks:['Karla Dueñas','Carla Díaz González','Alejandra Velarde'],
costumes:['María Estela Fernández','Malena De la Riva']},
{title:'The Last Kingdom',
titleCZ:'Poslední království',
year:2015,
runtime:'42h 33min',
episodeRuntime:'51-59min',
countries:['UK'],
genres:['Drama','History','Action'],
director:['Peter Hoar','Nick Murphy','Anthony Byrne','Ben Chanan','Jon East','Jamie Donoughue','Richard Senior','Erik Leijonborg',"Sarah O'Gorman",'Andy Hay','Andy De Emmony','Jan Matthys','Edward Bazalgette','David Moore'],
actors:['Alexander Dreymon','David Dawson','Ian Hart','Millie Brady','Eliza Butterworth','Harry McEntire','Mark Rowley','Emily Cox','Arnas Fedaravicius','Adrian Bouchet','Peri Baumeister','Jeppe Beck Laursen','James Northcote','Toby Regbo','Adrian Bower','Ewan Mitchell','Simon Kunz','Tobias Santelmann','Eva Birthistle','Julia Bache-Wiig','Timothy Innes','Cavan Clerkin','Brian Vernel','Thomas W. Gabrielsson','Amy Wren','Rune Temte','Henning Valin','Sean Gilder','Charlie Murphy','Nicholas Rowe','Joseph Millson','Gerard Kearns','Alec Newman','Lorcan Cranitch','Jonas Malmsjö','Matthew Macfadyen','Peter Gantzler','Jason Flemyng','Rutger Hauer','Michael Jibson','Declan Hannigan','Paul Ritter','Grahame Fox','Andrea Vagn Jensen','Craig Whittaker','Kevin Griffiths','Tom Taylor','Madeleine Power','Jocelyn Macnab','Victor McGuire','Björn Bengtsson','Ingar Helge Gimle','Christian Hillborg','Thure Lindhardt','Erik Madsen','Peter McDonald','Marc Rissmann','David Schofield','André Eriksen','Jóhannes Haukur Jóhannesson','Richard Rankin','Magnus Samuelsson','Kenneth M. Christensen','Anthony Cozens','David Gant','Henrik Lundström','Björn Freiberg','Attila G. Kerekes','David Pearse','Oengus MacNamara','Caroline Boulton','Alexandre Willaume','László Mátray','Laura Döbrösi','Simon Krogh Stenspil','Helen Monks','Ole Christoffer Ertvaag','Kata Sarbó','Klári Tolnai','Thea Sofie Loch Næss','Christopher Rygh','Martin Furulund','Ola Rapace','Kevin Eldon','Daniel Tuite','Ed Birch','Ágnes Csikász','Magnus Bruun','Tygo Gernandt','Martin Angerbauer','Julia Brown','Richard Clews','Mark Burns','Mirjam Novak','Bernard Cornwell','Balázs Medveczky','Mike Kelly','Sergej Onopko','Nikolett Barabás','Stefanie Martini'],
basedOn:['Bernard Cornwell'],
screenplay:['Stephen Butchard','Lydia Adetunji','Ben Vanstone','Sophie Petzal','Peter McKenna','Martha Hillier','Charlotte Wolf','Jamie Crichton','Alex Straker'],
production:['Chrissy Skinns','Cait Collins','Liz Trubridge','Vicki Delow','Helen Ostler'],
music:['John Lunn','Eivør Pálsdóttir','Danny Saul'],
camera:['Chas Bain','Tim Palmer','Sergio Delgado','Dale McCready','Richie Donnelly','Ashley Rowe','Mike Spragg'],
cut:['Mike Phillips','Steve Singleton','Tim Murrell','Kim Gaster','Nikki McChristie','Paul Knight','Joris Brouwers','Tom White','Mark Thornton','Sarah Brewerton','Adam Green','Dan Crinnion','David Yardley','William Oswald','Catherine Creed'],
sound:['Jack Gillies'],
scenography:['Martyn John','Ben Smith','Dominic Hyman'],
masks:['Réka Görgényi','Nóra Koltai','Maja Mocsári'],
costumes:['Molly Emma Rowe','Ralph Wheeler-Holes','Nina Ayres','Ros Little','Howard Burden']},
{title:'Burn Notice',
titleCZ:'Agent',
year:2007,
runtime:'78h 49min',
episodeRuntime:'41-66min',
countries:['USA'],
genres:['Crime','Drama','Thriller','Mystery'],
director:['Stephen Surjik','Jeremiah S. Chechik','Dennie Gordon','John T. Kretchmer','Tim Matheson','Matt Nix','Scott Peters','Jonathan Frakes','Jace Alexander','Rod Hardy','Colin Bucksey','David Solomon','Sanford Bookstaver','Paul Holahan','Ken Girotti','Paul Shapiro','Jeffrey Donovan','Renny Harlin','Nick Gomez','Larry Teng','Michael Smith','Tawnia McKiernan','Henry Bronchtein','Marc Roskin','Terry Miller','Bronwen Hughes','Jeff Freilich','Ernest R. Dickerson','Bryan Spicer','Félix Enríquez Alcalá','Michael Zinberg','Kevin Bray','Jeffrey G. Hunt','Peter Markle','Ron Underwood','Bill Eagles','Craig Siebels','Alfredo Barrios Jr.'],
actors:['Jeffrey Donovan','Gabrielle Anwar','Bruce Campbell','Sharon Gless','Coby Bell','Paul Tei','Seth Peterson','Lauren Stamile','Jack Coleman','Marc Macaulay','Tricia Helfer','Jere Burns','Robert Wisdom','Alona Tal','Alex Carter','David Fickas','John C. McGinley','John Pyper-Ferguson','Tim Matheson','Chris Vance','Sonja Sohn','Stephen Martines','Michael Shanks','Otto Sanchez','Audrey Landers','Gary Weeks','Ben Shenkman','Jay Karnes','Richard Kind','Garret Dillahunt','Kristanna Loken','Zabryna Guevara','Jennifer Taylor','Ray Wise','David Zayas','Lucy Lawless','Mark Pellegrino','Kelvin Yu','Antoni Corone','Richard Schiff','Maya Stange','Nicholle Tom','Jeffrey Johnson','Bruce Blauer','Johnny Messner','Laurence Mason','Max Martini','Patrick Fischler','James C. Burns','Erick Avari','Kevin Alejandro','Jacqueline Piñol','Patrick Fabian','Michael Naughton','Assaf Cohen','Cindy Pickett','Stefen Laurantz','David Fine','Andrew Divoff','Emily Baldoni','Larry Miller','Cindy Taylor','Brett Cullen','Oded Fehr','Marshall Manesh','Tim Ware','Chris Ellis','Basil Wallace','Moon Bloodgood','Carlos Bernard','Rodney Rowland','Debi Mazar','Holt McCallany','Katherine LaNasa','Rey Hernandez','Susie Abromeit','Eric Lange','Dina Meyer','Daniel Franzese','Michael B. Jordan','Callie Thorne','Navi Rawat','Lorena Segura York','Brice Beckham','Jeff Chase','Clayne Crawford','Paul Wight','John Ross Bowie','Aviva Baumann','James Ransone','Tina Casciani','Jeff Kober','Dylan Baker','David Dayan Fisher','Bobby Dodge','Marcus Chong','Jay Harrington','Dimitri Diatchenko','Castulo Guerra','Tyne Daly'],
screenplay:['Michael Horowitz','Matt Nix','Ryan Johnson','Peter Lalayanis','Lisa Joy','Nick Thiel','Jason Ning','Ben Watkins','Rashad Raisani','Alfredo Barrios Jr.','Daniel Tuch','Jason Tracey',"Craig S. O'Neill"],
production:['Terry Miller','Craig Siebels',"Craig S. O'Neill"],
music:['John Dickson','Toby Chu'],
camera:['William Wages','Roy H. Wagner','Bart Tau'],
cut:['Zack Arnold','Paul Fontaine','Casey Brown','Doug Hannah','James Kilton','Scott van Beever'],
sound:['Lisle Engle','Mark T. Williams','Sherry Klein','Fred Tator','Albert Ibbotson','Mark Server','David Raines'],
scenography:['J. Mark Harrington','Craig Siebels','Barbara Peterson-Malesci'],
costumes:['Emae Villalobos','Danny Santiago']},
{title:'Suburra: Blood on Rome',
titleCZ:'Suburra: Krvavé předměstí',
year:2017,
runtime:'19h 29min',
episodeRuntime:'40-63min',
countries:['Italy'],
genres:['Action','Crime'],
director:['Giuseppe Capotondi','Andrea Molaioli','Michele Placido','Piero Messina','Arnaldo Catinari'],
actors:['Filippo Nigro','Francesco Acquaroli','Alessandro Borghi','Adamo Dionisi','Giacomo Ferrara','Claudia Gerini','Eduardo Valdarnini','Francesco De Rosa','Lorena Cesarini','Diego Ribon','Gerasimos Skiadaressis','Augusto Zucchi','Rosa Diletta Rossi','Pietro Ragusa','Federica Sabatini','Barbara Chichiarelli','Federico Tocci','Elisabetta De Palo','Carlotta Antonelli','Renato Marchetti','Paola Sotgiu','Stefano Santospago','Lucia Mascino','Emmanuele Aita','Daniele Amendola','Alessandro Bernardini','Maurizio Bianucci','Pietro Biondi','Alessio De Persio','Paolo Gattini','Piero Gimondo','Daniele Locci','Alessandro Rossi','Fiorenza Tessari','Adriano Saleri','Mario Sgueglia',"Marco D'Alberti",'Stefano Fabrizi','Franca Maresa','Maurizio Capocciama','Mirko Faro','Lorenzo Ricci','Valentino Campitelli','Manuel Rulli','Mario Pirrello','Angelo Tanzi','Jacopo Venturiero','Simone Destrero','Marco Felli','Raffaele Gangale','Fabrizio Nardi','Andrea Onori','Raja Sethi','Aleph Viola','Pierluigi Telese','Alberto Cracco','Ivano Calafato','Gianluca Gobbi','Luca Paniconi','Giovanni Federico','Gabriele Rizzoli',"Fabio D'Avino",'Claudio Vanni','Andrea Fuorto','Claudio Del Rosso','Tiziano Ferracci','Gabriele Coppola','Salvatore Ceserani','Gianpiero Pumo','Massimo Zucchegna','Giulio Dicorato'],
basedOn:['Carlo Bonini','Giancarlo De Cataldo'],
screenplay:['Daniele Cesarano','Barbara Petronio','Ezio Abbate','Fabrizio Bettelli','Nicola Guaglianone','Camilla Buizza','Marco Sani'],
production:['Marco Chimenz','Giovanni Stabilini','Riccardo Tozzi','Gina Gardini'],
music:['Scott Morgan'],
camera:['Arnaldo Catinari'],
cut:['Lorenzo Peluso','Patrizio Marone'],
sound:['Carmine Razzano','Francesco Tumminello','Nadia Paone','Piergiuseppe Fancellu'],
scenography:['Paki Meduri','Andrea Castorina','Maurizio Leonardi','Maria Francesca Fogagnolo','Simone Taddei'],
masks:['Sonia Cedrone','Barbara Morosetti','Veronique Iemma','Silvia Massucci'],
costumes:['Veronica Fragola']},
{title:'What We Do in the Shadows',
titleCZ:'Co děláme v temnotách',
year:2019,
runtime:'19h 4min',
episodeRuntime:'20-28min',
countries:['USA'],
genres:['Comedy','Fantasy','Horror'],
director:['Taika Waititi','Jemaine Clement','Jackie van Beek','Jason Woliner','Kyle Newacheck','Liza Johnson','Yana Gorskaya','Tig Fong','D.J. Stipsen'],
actors:['Kayvan Novak','Harvey Guillén','Natasia Demetriou','Matt Berry','Mark Proksch','Alexandra Henrikson','Beanie Feldstein','Doug Jones','Jake McDorman','Chris Perfetti','Hayden Szeto','Gloria Laino','Marceline Hugot','Vanessa Bayer','Anthony Atamanuik','Arj Barker','Nick Kroll','Rob Ramsay','Kate Comer','Siobhan Fallon Hogan','Taika Waititi','Dave Bautista','Tilda Swinton','Evan Rachel Wood','Jemaine Clement','Wesley Snipes','Danny Trejo','Kristen Schaal','Paul Reubens','Jonny Brugh','Julia Vally','Oliver Dennis','Jeremy O. Harris','Haley Joel Osment','Benedict Wong','Sondra James','Marissa Jaret Winokur','Craig Robinson','Chris Sandiford','Abigail Savage','Veronika Slowikowska','Beanie Feldstein','Kevin Whalen','Mark Hamill','Madeleine Martin','Craig Burnatowski','Greta Lee',"Jack O'Connell",'Lilly Bartlam','Tig Fong','Amish Patel','Lucy Punch','Clara Wong','James Frain','Myrna Cabello','Erica Anderson','Jessica B. Hill','Adrian Spencer','Casey Feigh','Paul Jones','Alex Spencer','Bobby Wilson','Justin Linville','Indiana Mehta','Karly Bon','Aida Turturro','Tyler Alvarez','Lauren Collins','Mercedes Morris','Khadijah Roberts-Abdullah','Rakhee Morzaria','Maury Ginsberg','Allie Goodbun','Catherine Cohen','Julie Nolke','Ben Sanders','Hannan Younis','Veronika Slowikowska','Abigail Savage','Craig Robinson','Julie Klausner','Cole Escola','Julius Cho','Jean-Michel Richaud','Scott Bakula','Cree Summer','Tamina Pollack-Paris','Scott Dion Brown','Donal Logue','Khandi Alexander','David Cross','Samantha Helt','Lauren Collins','Cree Summer','Aida Turturro','Jasmine Renée Thomas','Jason Sklar','Randy Sklar','Jesse Camacho','Blessing Adedijo'],
screenplay:['Jemaine Clement','Josh Lieb','Tom Scharpling','Duncan Sarkies','Marika Sawyer','Paul Simms','Jake Bender','Zach Dunn','Sarah Naftalis','Shana Gohd','Stefani Robinson','Sam Johnson','Chris Marcil','William Meny','Aasia LaShay Bullock','Wally Baram','Ayo Edebiri'],
production:['Kyle Newacheck','Derek Rappaport','Joanne Toll','Paul Simms','Hartley Gorenstein','Sarah Naftalis','Ingrid Lageder','Todd Aronauer','Jake Bender','Zach Dunn','Shana Gohd','William Meny'],
music:['Mark Mothersbaugh','John Enroth','Albert Fox'],
camera:['D.J. Stipsen','Christian Sprenger','David A. Makin','Michael Storey','Kim Derko'],
cut:['Yana Gorskaya','Shawn Paper','Varun Viswanath','Tom Eagles','Dane McMaster','Daniel Haworth','Wendy Nomiyama','Liza Cardinale','Thomas Calderon','Antonia de Barros','A.J. Dickerson'],
sound:['Samuel Ejnes','Diego Gat','Penny Harold','Kevin Roache','Trevor Gates','Steffan Falesitch'],
scenography:['Ra Vincent','Kate Bunch','Shayne Fox','Shayne Fox','Andrea Raymond','Kerri Wylie'],
masks:['Connie Agawin','Suzanne Heibati','Paul Jones','Kenny Niederbaumer','Patrick Baxter','Sarah Milk','Jaye Falcioni','Samantha Terry','Steve Newburn'],
costumes:['Rahel Afiley','Amanda Neale','Laura Montgomery']},
{title:'The Innocent',
titleCZ:'Nevina',
year:2021,
runtime:'7h 47min',
episodeRuntime:'50-71min',
countries:['Spain'],
genres:['Drama','Crime','Mystery','Thriller'],
director:['Oriol Paulo'],
actors:['Mario Casas','Aura Garrido','Alexandra Jiménez','José Coronado','Martina Gusmán','Juana Acosta','Susi Sánchez','Gonzalo de Castro','Ana Wagener','Anna Alarcón','Miki Esparbé','Josean Bengoetxea','Santi Pons','Oriol Vila','Mima Riera','Jordi Coll','Frank Feys','Victor Solé','Gary Anthony Stennette','Alejandro Albarracín','Ariadna Cabrol','Mireia Vilapuig','Cocó Salvador','Eudald Font','Pedro Hernández','Arnau Casanovas','Elena Vilaplana','Marc Rodríguez','Zoe Arnao','David Vert','Miquel Sitjar','Marc Barbena','Javier Beltrán','Òscar Intente','Asia Ortega','Isabel Rocatti','Isaac Alcayde','Joan Sureda','Tània Sàrrias','Carlus Fàbrega','Toni Climent','Albert Pérez','Aleida Torrent','Arnau Gol-Karsunke'],
basedOn:['Harlan Coben'],
screenplay:['Oriol Paulo','Jordi Vallejo','Guillem Clua'],
music:['Fernando Velázquez'],
camera:['Bernat Bosch'],
cut:['Guillermo de la Cal'],
sound:['Laura Díez Mora'],
scenography:['Sylvia Steinbrecht','Gina Bernadó Muntané'],
costumes:['Miguel Cervera']},
{title:"It's a Sin",
titleCZ:'Byl by to hřích',
year:2021,
runtime:'3h 53min',
episodeRuntime:'46-48min',
countries:['UK'],
genres:['Comedy','Drama'],
director:['Peter Hoar'],
actors:['Olly Alexander','Lydia West','Nathaniel Curtis','Callum Scott Howells','Omari Douglas','Neil Ashton','Michelle Greenidge','Graham Parrington','Debra Baker','Grant Crookes','Shaun Dooley','Stephen Fry','Neil Patrick Harris','Keeley Hawes','Tina Louise Owens','April Kelley','David Carlyle','Toto Bruin','Tracy-Ann Oberman','Delroy Brown','Dan Linney','Nicholas Blane','Susan Brown','Shaniqua Okwok','Gary Lewis','Olisa Odele','Owen Arwyn','Ashley McGuire','Andria Doherty','Seyan Sarvan','Steve Toussaint','Desmond Barrit','Richard Cant','Ruth Sheen','Tatsu Carvalho','Ken Christiansen','David Gregan-Jones','Jonny Green','Richard Clifford','Jake Neads'],
screenplay:['Russell T. Davies'],
production:['Phil Collinson'],
music:['Murray Gold'],
camera:['David Katznelson'],
cut:['Sarah Brewerton'],
sound:['Jonathan Seale'],
scenography:['Luana Hanson','Gavin Lewis'],
masks:['Alicia Jane Robinson'],
costumes:['Ian Fulcher']},
{title:'Happy Valley',
titleCZ:'Šťastné údolí',
year:2014,
runtime:'17h 52min',
episodeRuntime:'57-60min',
countries:['UK'],
genres:['Crime','Drama'],
director:['Sally Wainwright','Euros Lyn','Tim Fywell','Neasa Hardiman','Patrick Harkins',"Fergus O'Brien"],
actors:['Sarah Lancashire','Siobhan Finneran','Shane Zaza','Charlie Murphy','James Norton','Ishia Bennison','George Costigan','Joe Armstrong','Steve Pemberton','Adam Long','Jill Baker','Amer Nazir','Kelly Harrison','Karl Davies','Alan McKenna','Ramon Tikaram','Luke Williams','Rick Warden','Mina Anwar','Amelia Young','Adam Nagaitis','Sydney Wade','Kevin Doyle','Darren Morfitt','Martin Gledhill','Susan Lynch','Hannah John-Kamen','Margaret Jackman','Sophie Rundle','Steven Hartley',"Caroline O'Neill",'Keeley Forsyth','Robert Emms','Julie Hesmondhalgh','Amelia Bullmore','Vincent Franklin','Katherine Kelly',"Con O'Neill",'Matthew Lewis','Shirley Henderson','Angela Pleasence','Derek Riddell','Julia Ford','Marcus Langford','David Crellin','Paul Brennen','Ian Champion','Craig Thomas Lambert','Olwen May','Amy Garcia','Richard Price','Graham Parrington','Kent Riley','Lena Kaur','Shameem Ahmad','James Burrows','Rhys Connah','Ivana Basic','Hebe Beardsall','Karl Haynes','Karen Bryson','Velton Lishke','Matthew Zajac','Rachel Leskovac','Danny Seward','Steve Edge'],
screenplay:['Sally Wainwright'],
production:['John Battsek','Karen Lewis','Juliet Charlesworth'],
music:['Ben Foster'],
camera:['Ivan Strasburg','Andrew McDonnell'],
cut:['Jamie Pearson','Emma Oxley','Brian Funck','Richard Cox','Joe Carey'],
sound:['Tom Erik Lie'],
scenography:['Susie Cullen','John Collins','Steven Grainger','Lawrence Hearn'],
masks:['Nadia el-Saffar','Lotte Aas'],
costumes:['Ian Holmes']},
{title:'ERASED',
titleCZ:'Boku dake ga inai mači',
year:2016,
runtime:'4h 36min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Drama','Crime','Psychology','Thriller'],
director:['Tomohiko Itó','Tošimasa Išii','Kosaja','Hirotaka Mori',"Šin'ja Watada",'Takahiro Šikama'],
actors:['Šinnosuke Micušima','Minami Takajama','Tao Cučija','Aoi Júki','Akemi Okamura','Činacu Akasaki','Jó Taiči','Takahiro Mizušima','Hideaki Tezuka','Aoi Koga','Jamato Kindžó',"Šin'ja Takahaši",'Micuru Mijamoto','Ajaka Asai','Kanehira Jamamoto','Hina Kino','Ami Naitó','Eidži Takeuči','Acuši Tamaru','Sara Macumoto','Ajaka Nanase','Jukitoši Kikuči',"Šun'iči Maki",'Kumiko Nakane','Asami Jošida','Čie Horikoši','Akari Kitó','Reika Ujama','Sajaka Kaneko','Taisuke Nišimura','Tóru Ókawa','Tasuku Emoto','Kendži Hamada','Fumie Mori','Júsuke Suda','Issei Maeda','Hiroko Takahaši'],
basedOn:['Kei Sambe'],
screenplay:['Taku Kišimoto','Jutaka Jasunaga'],
music:['Juki Kadžiura'],
camera:['Tošiaki Aošima'],
cut:['Šigeru Nišijama'],
sound:['Jošikazu Iwanami'],
scenography:['Masaru Sató']},
{title:'After Life',
titleCZ:'Po životě',
year:2019,
runtime:'8h 31min',
episodeRuntime:'25-36min',
countries:['UK'],
genres:['Comedy','Drama'],
director:['Ricky Gervais'],
actors:['Ricky Gervais','Tom Basden','David Bradley','Roisin Conaty','Kerry Godliman','Ashley Jensen','Paul Kaye','Diane Morgan','Tony Way','Joe Wilkinson','Penelope Wilton','Tim Plester','Mandeep Dhillon','Ninette Finch','Adrian McLoughlin','David Earl','Jo Hartley','Ethan Lawrence','Michelle Greenidge','Nancy Sullivan','Tracy-Ann Oberman','Nicky B','Megan Heffernan','Mark Weinman','Islam Bouakkaz','Dan Li','Annette Crosbie','Seb Cardinal','Peter Egan','Andrew Brooke','Tom Bennett','Holli Dempsey','Steve Speirs','Lucy Speed','Nancy Sullivan','Bill Ward','Laura Patch','Colin Hoult','Ricky Grover','Jo Enright','Ewen MacIntosh','Karen-J Sear','Kenneth Collard','Grace Wood','Nikhil Parmar'],
screenplay:['Ricky Gervais'],
music:['Andy Burrows'],
camera:['Martin Hawkins'],
cut:['Joe Walker','Mark Williams'],
sound:['Alex Thompson'],
scenography:['Jane Dundas','Julie Signy'],
costumes:['Amanda Monk']},
{title:'Crash Landing on You',
titleCZ:'Láska padá z nebe',
year:2019,
runtime:'22h 29min',
episodeRuntime:'70-112min',
countries:['South Korea'],
genres:['Drama','Romance','Comedy'],
director:['Jeong-hyo Lee'],
actors:['Bin Hyun','Ye-jin Son','Ji-hye Seo','Jeong-hyeon Kim','Kyeong-eup Nam','Ji-min Yoon','Hye-jin Jang','Yeong-min Kim','Soo-bin Yoo','Jeong-nan Kim','Sun-young Kim','So-yeon Jang','Myeong-hoon Park','Joon-sang Tang','Man-seok Oh','Ji-woo Choi','Woo-jin Hong','Gook-hwan Jeon','Ae-ri Jeong','Seung-joon Park','Seong-min Lim','Mi-young Shin','Hyung-suk Kang','Choi Dae-hoon','Sin-young Lee','Dong-ho Kwon','Jung-yeol Lee','Kyung-won Yang','Hyoung-soo Park','Chan-woo Park'],
screenplay:['Ji-eun Park'],
music:['Hye-Seung Nam'],
camera:['Sung-yong Park']},
{title:'The Bugs Bunny Show',
titleCZ:'Bugs Bunny a jeho přátelé',
year:1960,
runtime:1300,
episodeRuntime:25,
countries:['USA'],
genres:['Animation','Family','Comedy'],
director:['Robert McKimson','Friz Freleng','Chuck Jones','Maurice Noble','Abe Levitow','Hawley Pratt'],
actors:['Mel Blanc','Daws Butler','June Foray','Jim Backus','Bea Benaderet','Hal Smith'],
music:['Carl W. Stalling']},
{title:'The Bear',
titleCZ:'Medvěd',
year:2022,
runtime:'14h 14min',
episodeRuntime:'20-67min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Christopher Storer','Joanna Calo','Ramy Youssef'],
actors:['Jeremy Allen White','Abby Elliott','Ebon Moss-Bachrach','Ayo Edebiri','Liza Colón-Zayas','Chris Witaske','Corey Hendrix','Richard Esteras','Oliver Platt','Amy Morton','Joel McHale','Sarah Wisterman','Christopher Kahler','Molly Ringwald','Lionel Boyce','Jon Bernthal','Richard Cotovsky',"Gram 'Chino' Otero Livemore",'Brian Boland','Molly Gordon','Robert Townsend','Will Poulter','Alex Moffat','Mitra Jouhari','Jamie Lee Curtis','Gillian Jacobs','John Mulaney','Bob Odenkirk','Sarah Paulson','Maura Kidwell','Sarah Ramos','Adam Shapiro','Olivia Colman','Rene Gube','Andrew Lopez','Matty Matheson','Edwin Lee Gibson','Carmen Christopher','Jack Lancaster'],
screenplay:['Christopher Storer','Sofya Levitsky-Weitz','Karen Joseph Adcock','Rene Gube','Joanna Calo','Stacy Osei-Kuffour','Alex Russell','Kelly Galuska'],
production:['Tyson Bidner','Stacy Osei-Kuffour'],
music:['J.A.Q.'],
camera:['Andrew Wehde','Adam Newport-Berra','Chloe Weaver'],
cut:['Joanna Naugle','Adam Epstein'],
sound:['Geoff Strasser','Jonathan Fuhrer'],
scenography:['Sam Lisenco','Eric Dean','Merje Veski'],
masks:['Heather Napolitano','Rochelle Uribe','Nicole Rogers'],
costumes:['Cristina Spiridakis','Courtney Wheeler']},
{title:'Police Squad!',
titleCZ:'Policejní jednotka v barvách',
year:1982,
runtime:'2h 24min',
episodeRuntime:'24min',
countries:['USA'],
genres:['Comedy','Action','Crime','Mystery'],
director:['Reza Badiyi','Paul Krasny','Georg Stanford Brown','Jerry Zucker','David Zucker','Joe Dante','Jim Abrahams'],
actors:['Leslie Nielsen','Alan North','Rex Hamilton','William Duell','Peter Lupus','William Shatner','Georg Stanford Brown','John Ashton','Robert Costanzo','William Conrad','Dick Miller','Grand L. Bush','Robert Goulet','Rebecca Holden','Lorne Greene','Thomas Rosales Jr.','Barbara Tarbuck','Claudette Nevins','Floyd Levine','Florence Henderson','Michael Frost','Patrick St. Esprit','Al Ruscio','Dick Clark','Joyce Brothers','Tessa Richarde','Kathryn Leigh Scott','David Schwimmer','Tiny Ron','Irwin Keyes','Tony Sirico','Nicolas Coster','K Callan','Marvin Miller','Dick Clark','Peter Elbling','Spencer Milligan','Terrence Beasor','Hank Robinson','Connie Needham'],
screenplay:['Jim Abrahams','David Zucker','Jerry Zucker','Pat Proft','Robert Wuhl','Tino Insana','Nancy Steen','Neil Thompson'],
production:['Robert K. Weiss'],
music:['Ira Newborn'],
camera:['Sherman Kunkel'],
cut:['Malcolm Campbell','Tom Benko'],
scenography:['Bruce A. Gibeson'],
masks:['Ron Walters']},
{title:'From the Earth to the Moon',
titleCZ:'Ze Země na Měsíc',
year:1998,
runtime:'10h 48min',
episodeRuntime:'47-60min',
countries:['USA'],
genres:['Action','Drama','Thriller'],
director:['Jon Turteltaub','Jonathan Mostow','Frank Marshall','Tom Hanks','Gary Fleder','Sally Field','David Carson','David Frankel','Graham Yost','Michael Grossman','Lili Fini Zanuck'],
actors:['Tom Hanks','Rita Wilson','JoBeth Williams','Elizabeth Perkins','Deborah May','Sally Field','Blythe Danner','Lane Smith','Brandon Smith','James Rebhorn','Kevin Pollak','Ethan Phillips','Ted Levine','Tchéky Karyo','Peter Horton','Mark Harmon','Tony Goldwyn','Cary Elwes','Tim Daly','Ronny Cox','Gary Cole','Adam Baldwin','Dan Lauria','Wendy Crewson','Janel Moloney','Max Wright','Diana Scarwid','Steve Zahn','Jay Mohr','David Andrews','Daniel Hugh Kelly','George Newbern','Clint Howard','Tom Amandes','Matt Craven','Robert John Burke','Robert Catrini','Chris Isaak','Dylan Baker','Ann Magnuson','John Carroll Lynch','John Slattery','Brett Rice','Robert Curtis Brown','Debra Jo Rupp','Joshua Malina','Dann Florek','Dave Foley','Tom Verica','Elizabeth Morehead','Holmes Osborne','Harve Presnell','John Rothman','Mark Rolston','Nick Searcy','Cynthia Stevenson','Bryan Cranston','Georges Wilson','Joe Spano','Paul McCrane','Cullen Douglas','Graham Yost','Brittany Snow','Željko Ivanek','Shawn Pyfrom','John E. Moyer','Dakin Matthews','Rhoda Griffis','Alan Ruck','Andy Milder','Stefen Laurantz','Brett Cullen','Betsy Brantley','John Michael Higgins','Chris Ellis','JoAnna Garcia Swisher','Kieran Mulroney','Jack Gilpin','Sam Anderson','Jay Karnes','Peter Scolari','Fredric Lehne','Stephen Root','John M. Jackson','Gareth Williams','Doug McKeon','Ann Cusack','Ric Reitz','R. Keith Harris','Jerry Hardin','Reed Birney','Rus Blackwell','Ben Marley','Tom Nowicki','David Clennon','Ronald Fox','Jurij Alexejevič Gagarin','Lyndon B. Johnson','Martin Luther King',"Deirdre O'Connell"],
basedOn:['Andrew Chaikin'],
screenplay:['Erik Bork','Al Reinert','Graham Yost','Karen Janszen','Paul McCudden','Tom Hanks','Jeffrey Alan Fiskin','Steven Katz','Remi Aubuchon','Andy Wolk','Peter Osterlund'],
production:['Brian Grazer','Ron Howard'],
music:['James Newton Howard','Michael Kamen','Mark Mancina','Mark Isham','Brad Fiedel','Marc Shaiman','Mason Daring','Jeff Beal'],
camera:['Gale Tattersall'],
cut:['Lisa Zeno Churgin','Richard Pearson','Christopher Rouse','Wendy Smith'],
sound:['Jerry Edemann','Adam Sawelson','Kevin Patrick Burns','Brad Sherman','Scott Millan','Todd Orr','Richard Taylor'],
scenography:['Richard Toyon','Michele Poulik'],
masks:['Ve Neill','Greg Cannom'],
costumes:['Chrisi Karvonides-Dushenko']},
{title:'Hilda',
titleCZ:'Hilda',
year:2018,
runtime:'15h 3min',
episodeRuntime:'23-78min',
countries:['UK','Canada','USA'],
genres:['Animation','Adventure','Family','Comedy','Fantasy'],
director:['Andy Coyle'],
actors:['Bella Ramsey','Ameerah Falzon-Ojo','Oliver Nelson','Daisy Haggard','Rasmus Hardiker','Kaisa Hammarlund','David Menkin','Reece Pockney','Claire Skinner','Nina Sosanya','Ólafur Darri Ólafsson','Ilan Galkoff','Rob Rackstraw','Simon Greenall','Ako Mitchell','Nicklas Kingo'],
basedOn:['Luke Pearson'],
screenplay:['Luke Pearson','Stephanie Simpson','Ben Joseph','Timothy McKeon','Gabe Pulliam','Kenny Byerly'],
production:['Adam Idelson'],
music:['Ryan Carlson'],
cut:['John McKinnon']},
{title:'Sex Education',
titleCZ:'Sexuální výchova',
year:2019,
runtime:'29h 20min',
episodeRuntime:'47-85min',
countries:['UK'],
genres:['Comedy','Drama'],
director:['Ben Taylor','Kate Herron','Sophie Goodhart','Alice Seabright','Runyararo Mapfumo','Dominic Leclerc','Alyssa McClelland','Michelle Savill'],
actors:['Asa Butterfield','Emma Mackey','Gillian Anderson','Ncuti Gatwa','Kedar Williams-Stirling','Aimee Lou Wood','Connor Swindells','Patricia Allison','Tanya Reynolds','Mikael Persbrandt','Chaneil Kular','Alistair Petrie','Mimi Keene','Simone Ashley','Jim Howick','Samantha Spiro','Deobia Oparei','Lily Newmark','Alice Hewkin','Daniel Ings','Rakhee Thakrar','Jojo Macari','Max Boast','Dan Mersh','Ronnie Danowska','Bradley Birkholz','Lisa Palfrey','Toby Williams','Jonny Aimes','Olive Gray','James Purefoy','Joe Wilkinson','Freddie Watkins','Lu Corfield','Dominic Applewhite','Anjana Vasan','Lily Frazer','Cerys Watkins','Alexander Westwood','Adam Young','Hannah Waddingham','Edward Bluemel','Femi Elufowoju Jr.','Daniel Adegboyega','Aurora Burghart','Tom Colley','Sharon Duncan-Brewster',"T'Nia Miller",'Ashna Rabheru','Chinenye Ezeudu','Samuel Jordan','Jack Bandeira','Daniel Betts','Sami Outalbali','Conor Clarke-McGrath','Spike Leighton','George Robinson','Anne-Marie Duff','George Georgiou','Armin Karima','Susan Lynch','Neil Maskell','George Somner','Mirren Mack','Chris Jenks','Lino Facioli','David Cann','Jack Helsby','Youssef Kerkour','Stephen Fry','Gbemisola Ikumelo','Leanne Holder','Dee Ahluwalia','Dua Saleh','Jemima Kirke','Jason Isaacs','Lois Chimimba','Rosie Dwyer','Maud Druine','Kieron Moore','Suzanne Bertish','Miles Jupp','Laurent C. Lucas','George Asprey','Jerry Iwu','Rebecca Root','Robert Wilfort','Sinna Mogul','Sophie Thompson','Adam Young','Sindhu Vee','Kieron Moore','Amar Chadha-Patel','India Amarteifio','Tallulah Bond','Indra Ové','Dan Levy','Jodie Turner-Smith','Thaddea Graham','Andi Osho'],
screenplay:['Sophie Goodhart','Laurie Nunn','Freddy Syborn','Laura Neal','Laura Hunter','Mawaan Rizwan','Richard Gadd','Alice Seabright','Selina Lim','Lisa Palfrey','Troy Hunter'],
production:['Jon Jennings','Laurie Nunn'],
music:['Oli Julian'],
camera:['Jamie Cairney','Oli Russell','Andrew McDonnell'],
cut:['Steve Ackroyd','Calum Ross','David Webb Peoples','David Webb','Phil Hignett','Izabella Curry','Dan Gage'],
sound:['Neil Collymore','Bryn Thomas','Dom Corbisiero'],
scenography:['Samantha Harley','Paul Spriggs','Jen Saguaro'],
masks:['Natasha Richards'],
costumes:['Rosa Dias','Daniella Pearman']},
{title:'Six Feet Under',
titleCZ:'Odpočívej v pokoji',
year:2001,
runtime:'62h 25min',
episodeRuntime:'52-63min',
countries:['USA'],
genres:['Drama','Comedy'],
director:['Alan Ball','Daniel Attias','Rodrigo García','Jeremy Podeswa','Kathy Bates','Michael Cuesta','Michael Engler','Alan Poul','Daniel Minahan','Miguel Arteta','Nicole Holofcener','Lisa Cholodenko','Allen Coulter','Jim McBride','John Patterson','Alan Taylor','Rose Troche','Karen Moncrieff','Peter Care','Peter Webber','Adam Davidson','Mary Harron','Joshua Marston','Matt Shakman','Alan Caso'],
actors:['Peter Krause','Michael C. Hall','Frances Conroy','Lauren Ambrose','Freddy Rodríguez','Mathew St. Patrick','Rachel Griffiths','Justina Machado','Jeremy Sisto','James Cromwell','Lili Taylor','Ben Foster','Joanna Cassidy','Richard Jenkins',"Ed O'Ross",'Peter Macdissi','Tim Maculan','Rainn Wilson','Tina Holmes','Sprague Grayden','Eric Balfour','Kathy Bates','Peter Facinelli','Marina Black','Justin Theroux','Ed Begley Jr.','David Norona','Mena Suvari','David Hornsby','Patricia Clarkson','Kellie Waymire','Anne Ramsay','Matt Malloy','Robert Foxworth','Chris Messina','Nicki Micheaux',"Catherine O'Hara",'Michael Weston','Timm Sharp','Michelle Trachtenberg','Beverly Todd','Matt Winston','Christine Tucci','Ricardo Chavira','Abby Brammell','James Black','Kevin Rankin','Julie White','Myndy Crist','Illeana Douglas','Glenn Fitzgerald','Grant Show','Bobby Cannavale','Jennifer Elise Cox','Veronica Cartwright','Wendy Schaal','Lisa Banes','Rosalind Chao','Brooke Smith',"Sean O'Bryan",'Lauren Birkell','J.G. Hertzler','Peter Birkenhead','Arye Gross','Harriet Sansom Harris','Molly Parker','Adam Scott','Alice Krige','Steven Pasquale','Graham Jarvis','Stark Sands','James Pickens Jr.','Jenna Fischer','Lee Garlington','Andrew Prine','Josh Stamberg','Lana Parrilla','Lisa K. Wyatt','Meagen Fay','Manuel Urrego','Pat Healy','Ilia Volok','Vanessa Marano','Robert Baker','Robert Pine','Austin Nichols','Kimberlin Brown','Brian Poth','Nolan North','Larry Sullivan','Mark L. Young','Michail Chmurov','Brian Ames','Caroline Aaron','Jacob Vargas','Shawn Hatosy','Mare Winningham','Lombardo Boyar','Bill Cobbs','Mary Gross'],
screenplay:['Alan Ball','Nancy Oliver','Rick Cleveland','Joey Soloway','Craig Wright','Christian Taylor','Scott Buck','Kate Robin','Christian Williams','Laurence Andries','Bruce Eric Kaplan'],
production:['Lori Jo Nemhauser','Laurence Andries','Bruce Eric Kaplan','Rick Cleveland','Robert Del Valle'],
music:['Richard Marvin','Thomas Newman'],
camera:['Jim Denault','Rob Sweeney','Alan Caso','Bruce Douglas Johnson','Frederick Iannone','Lowell Peterson'],
cut:['Ron Rosen','Michael Ruscio','Christopher Nelson','Tanya M. Swerling','Sue Blainey'],
sound:['Elmo Ponsdomenech','Joe Earle','Peter Reale','Roberta Doheny','Bob Newlan','Bo Harwood','Vince Garcia'],
scenography:['Marcia Hinds','Suzuki Ingerslev','Susan Mina Eschelbach','Rusty Lipscomb'],
masks:['Scott Wheeler','Dan Rebert','Kimberley Spiteri','Matthew W. Mungle','Dennis Parker','Bonnie Walker','Michelle Vittone','Jane Galli','June Bracken','Ketty Gonzalez'],
costumes:['Jill M. Ohanneson','Gail McMullen']},
{title:'Generation Kill',
titleCZ:'Generation Kill',
year:2008,
runtime:'7h 32min',
episodeRuntime:'61-67min',
countries:['USA'],
genres:['War','Drama'],
director:['Simon Cellan Jones','Susanna White'],
actors:['Alexander Skarsgård','Stark Sands','Michael Kelly','Jon Huertas','Neal Jones','Brian Patrick Wade','Lee Tergesen','Kellan Lutz','Paweł Szajda','Mike Figueroa','Owain Yeoman','Langley Kirkwood','Aiden Lithgow','Rudy Reyes','Sean Brosnan','Michael Mosley','Rich McDonald','Rey Valentin','Benjamin Busch','Wilson Bethel','James Ransone','Billy Lush','Jonah Lotan','Marc Menchaca','Mike Piscitelli','Robert John Burke','Eric Nenninger','Josh Barrett','Kevin Otto','Henk Pretorius','Eric Ladin','Antonio David Lyons','Karl Thaning','Raad Rawi','Chance Kelly','Rachid Sabitri','Tamer Burjaq','David Barrera','Craig Hawks','Tyrone Keogh','Badria Timimi','Daniel Janks','Garth Breytenbach','Stefan Otto'],
basedOn:['Evan Wright'],
screenplay:['David Simon','Ed Burns','Evan Wright'],
production:['Andrea Calderwood','Lance Samuels'],
camera:['Ivan Strasburg'],
cut:['Tania Reddin','Oral Norrie Ottey'],
sound:['Stefan Henrix','Martin Jensen','David Evans','Colin Nicolson'],
costumes:['Darion Hing']},
{title:'Peacemaker',
titleCZ:'Peacemaker',
year:2022,
runtime:'11h 44min',
episodeRuntime:'37-47min',
countries:['USA'],
genres:['Action','Comedy','Adventure','Sci-Fi'],
director:['James Gunn','Brad Anderson','Rosemary Rodriguez','Jody Hill'],
actors:['John Cena','Steve Agee','Danielle Brooks','Robert Patrick','Jennifer Holland','Chris Conrad','Chukwudi Iwuji','Christopher Heyerdahl','Lochlyn Munro','Annie Chang','Elizabeth Ludlow','Rizwan Manji','Freddie Stroma','Alison Araya','Stephen Blackehart','Lenny Jacobson','Neil Webb','Paul Lazenby','Zak Santiago',"Kevin O'Grady",'Rochelle Greenwood','Liam Hughes','Dee Bradley Baker','Antonio Cupo','Veena Sood','Lissa Neptuno','Elizabeth McCarthy Meek','Klarc Jerome Wilson','Viola Davis','Mel Tuck','Nhut Le','Ryan Jefferson Booth','Trevor Hinton','Jason Momoa','Ezra Miller','Haig Sutherland','Brad Abramenko','Alexander Brophy','Tinashe Kajese','Alice Comer','Darryl Scheelar'],
screenplay:['James Gunn'],
production:['John Rickard'],
music:['Kevin Kiner','Clint Mansell'],
camera:['Michael Bonvillain','Sam McCurdy','Michael Wale'],
cut:["Greg D'Auria",'Fred Raskin'],
sound:['Joe Barnett','Adam Jenkins'],
scenography:['Lisa Soper'],
masks:['Brooke Sovdi','Cayley Giene','Sandy Lindala','Toby Lindala'],
costumes:['Shay Cunliffe','Karin Nosella']},
{title:'Hatfields & McCoys',
titleCZ:'Hatfieldovi a McCoyovi',
year:2012,
runtime:'4h 48min',
episodeRuntime:'88-102min',
countries:['USA'],
genres:['Western','Drama','Romance','War','History'],
director:['Kevin Reynolds'],
actors:['Kevin Costner','Bill Paxton','Tom Berenger','Mare Winningham','Powers Boothe','Matt Barr','Lindsay Pulsipher','Ronan Vibert','Jena Malone','Andrew Howard','Sarah Parish','Boyd Holbrook','Noel Fisher','Noah Taylor','Nick Dunning','Rob Moran','John Bell','Sam Reid','Max Deacon','Tom McKay','Jack Laskey','Michael Jibson','Tom Bell','Stuart Martin','Katie Griffiths','Jón Ólafsson','Christopher Hatherall',"Damian O'Hare",'Darrell Fetty','Lloyd Hutchinson','Alixandra von Renner','Joe Absolom','David Kennedy','Jilon VanOver','Michael Woods','Robert Cavanah','Mihai Niculescu','Jon Bloch','Ben Cartwright','Rebecca Calder'],
screenplay:['Ronald Parker','Ted Mann'],
production:['Kevin Costner','Darrell Fetty','Vlad Paunescu','Herb Nanas'],
music:['John Debney','Tony Morales'],
camera:['Artur Reinhart'],
cut:['Harry Jierjian','Don Cassidy'],
sound:['Brad Zoern','Christian T. Cooke'],
scenography:['Derek R. Hill'],
masks:['Mario Michisanti','Francesca Tampieri'],
costumes:['Doug Hall']},
{title:'Time',
titleCZ:'Čas',
year:2021,
runtime:'5h 37min',
episodeRuntime:'51-65min',
countries:['UK'],
genres:['Drama','Crime'],
director:['Lewis Arnold','Andrea Harkin'],
actors:['Sean Bean','Stephen Graham','David Calder','Siobhan Finneran','Natalie Gavin','Kevin Harvey','Sue Johnston','Nadine Marshall','James Nelson-Joyce','Tina Louise Owens','Hannah Walters','Philip Barantini','Jonathan Harden','Jack McMullen','Theo Nate','Jodie Whittaker','Bella Ramsey','Tamara Lawrance','James Corrigan','Julie Graham','Faye McKeever','Lisa Millett','Nicholas Nunn','Sophie Willan'],
screenplay:['Jimmy McGovern'],
production:['Simon Maloney','Mark Hedges','Carmel Maloney'],
music:['Sarah Warne'],
camera:['Mark Wolf','Paul Morris'],
cut:['Sacha Szwarc','Alex Mackie'],
scenography:['Anna Higginson'],
costumes:['John Dunn','Jan Simpson']},
{title:'The Alfred Hitchcock Hour',
titleCZ:'Zadáno pro Alfreda Hitchcocka',
year:1962,
runtime:'77h 30min',
episodeRuntime:'50min',
countries:['USA'],
genres:['Crime','Drama','Mystery','Thriller'],
director:['Alf Kjellin','Joseph M. Newman','Bernard Girard','John Brahm','Joseph Pevney','Harvey Hart','Robert Stevens','Robert Douglas','Jack Smight','William Friedkin','David Lowell Rich','Norman Lloyd','László Benedek','Jerry Hopper','Philip Leacock','Leo Penn','Sydney Pollack','Alfred Hitchcock','Paul Henreid','Alex March','Charles F. Haas','David Friedkin','Alan Crosland Jr.','Herschel Daugherty','Herbert Coleman','Arnold Laven','Leonard J. Horn','James Sheldon','William Witney','Harry Morgan','Lewis Teague','James H. Brown'],
actors:['Alfred Hitchcock','Gary Merrill','George Macready','Barry Nelson','Michael Parks','Gena Rowlands','Angie Dickinson','John Cassavetes','Roddy McDowall','Robert Redford','Dabney Coleman','Robert Loggia','Tony Randall','Michael Rennie','John Anderson','Sara Shane','Slim Pickens','Jean Willes','Buck Taylor','Jennifer Gan','Jack Cassidy','Peggy Lipton',"Patrick O'Neal",'James Caan','Gene Barry','Ann Morgan Guilbert','Efrem Zimbalist Jr.','Rolfe Sedan','Natalie Trundy','Frances Reid','George Petrie','Hugh Sanders','Richard Basehart','Jim McMullan','Joyce Van Patten','Bradford Dillman','Julie London','Royal Dano','James Best','James MacArthur','Fess Parker','Michael Pate','Laraine Day','Jane Withers','Louis Hayward','Scott Brady','Hari Rhodes','Jane Wyatt','Joan Hackett','Jessica Walter','Gus Trikonis','Phillip Reed','Diana Dors','Barry Sullivan','Patricia Medina','Jeremy Slate','Gia Scala','Alice Pearce','Robert Strauss','Charles McGraw','Pina Pellicer','Harold J. Stone','Adam Roarke','June Vincent',"Hugh O'Brian",'Jocelyn Lane','John A. Alonzo','Richard Dawson','Howard Duff','Linda Christian','Peter Brown','Albert Salmi','Anna Lee','Will Hutchins','Leif Erickson','John Kerr','Peggy McCay','Edward Mallory','Patricia Barry','Dee Carroll','Russell Thorson','Joanna Moore','Patricia Cutts','Philip Coolidge','Richard Kiley','Lilia Skala','Kathryn Hays','Patricia Collinge','Olive Deering','Sharon Farrell','Dick York','Cathleen Cordell','Tom Drake','Pat Crowley','Charlene Holt','Tisha Sterling','Phyllis Thaxter','Norman Fell','Jeanette Nolan','Collin Wilcox Paxton'],
basedOn:['John Bingham','H.G. Wells','Richard Matheson','Patricia Highsmith','André Maurois','Anthony Gilbert','Cecil Day-Lewis','C.B. Gilford','Paul Winterton','Cornell Woolrich','John Garden','Marie Belloc Lowndes','Celia Fremlin','Edith Pargeter','Amber Dean','John D. MacDonald','Helena J. Nielsen','Margaret Millar','Julian Symons'],
screenplay:['John Wyndham','Ethel Lina White','Alvin Sargent','Lukas Heller','Leigh Brackett','Robert Bloch','Arthur A. Ross','David Friedkin','James Bridges','Richard Deming','Gilbert Ralston','David Goodis','Barré Lyndon','Alfred Hayes','Gabrielle Upton','William Bast','Roland Kibbee','Mann Rubin','Lewis Davidson','Richard Levinson','William Link','Lee Kalcheim','William Jerome Fay','Richard Fielder','Charles Beaumont','Oscar Millard','Harlan Ellison','Henry Slesar','William D. Gordon','Morton S. Fine','Harold Swanton','Joel Murcott','Lou Rambeau','Richard Matheson','Alec Coppel','Ray Bradbury','John Collier','Lee Erwin','Robert Gould','John Resko','Boris Sobelman','Francis Gwaltney','Anthony Terpiloff','Clyde Ware'],
production:['Joan Harrison','Herbert Coleman','Morton S. Fine','Norman Lloyd','David Lowell Rich','Roland Kibbee','Robert Douglas','Leon Benson','Charles Russell','Gordon Hessler','David Friedkin'],
music:['Bernard Herrmann','Lalo Schifrin','Robert Drasnin','Pete Rugolo','Lyn Murray','Richard Shores','Leonard Rosenman','Benny Carter'],
camera:['Stanley Cortez','John L. Russell','Lionel Lindon','Ray Rennahan','Jacques R. Marquette','Benjamin H. Kline','William Margulies','Bud Thackery','John F. Warren','Walter Strenge','Richard L. Rawlings','Robert Tobey'],
cut:['Douglas Stewart','Danford B. Greene','Bud S. Isaacs','Tony Martinelli','John C. Fuller','Howard Terrill','Edward W. Williams','Lee Huntington'],
sound:['David H. Moriarty','Melvin M. Metcalfe Sr.','Frank H. Wilkinson','Stanley Cooley','Earl Crain Sr.','J.S. Westmoreland','Corson Jowett','William H. Lynch','Edwin J. Somers Jr.','Lyle Cain','Earl Crain Jr.','Robert R. Bertrand'],
scenography:['Martin Obzina','George Patrick','John J. Lloyd','Frank Arrigo','Oliver Emert','Alexander A. Mayer','James M. Walters Sr.','John McCarthy Jr.','Julia Heron','Perry Murdock','George Milo','James Redd','Russell Kimball','Mac Mulcahy','Raymond Beal','H. Web Arrowsmith','Robert C. Bradfield'],
masks:['Bud Westmore','Florence Bush','Jack Barron','Larry Germain'],
costumes:['Helen Colvig','Burton Miller']},
{title:'Manhunt',
titleCZ:'Manhunt',
year:2017,
runtime:'13h 18min',
episodeRuntime:'42-51min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Greg Yaitanes','Michael Dinner','Jon Avnet','Janice Cooke','Ali Selim'],
actors:['Gethin Anthony','Arliss Howard','Kelly Jenrette','Cameron Britton','Ness Bautista','Sam Worthington','Paul Bettany','Jeremy Bobb','Desmond Harrington','Jack Huston','Ben Weber','Judith Light','Chris Noth','Lynn Collins','Carla Gugino',"Brían F. O'Byrne",'Keisha Castle-Hughes','Elizabeth Reaser','Mark Duplass','Katja Herbers','Jane Lynch','Jana Allen','Griff Furst','Rebecca Henderson','Doug Kruse','Jon Arthur','Frank Brennan','Mary Rachel Quinn','Wilbur Fitzgerald','Mike Pniewski','Wallace Langham','Rhoda Griffis','Juan Gaspard','Steve Coulter','Johnny Berchtold','Trieste Kelly Dunn','Tom Nowicki','David Jensen','Bonnie Johnson','Quandae Stewart','Cindy Fernandez-Nixon','Michael Nouri',"Brian d'Arcy James",'Christian Camargo','Onye Eme-Akwari','Jay O. Sanders','Jesse C. Boyd','Banks Repeta','Robert Tinsley','Roxanne Hart','Cornelius Smith Jr.','Ricky Wayne','Andrew Sensenig','Jay DeVon Johnson',"Michael O'Keefe",'Malerie Grady','Pete Burris','Justin Swain','Ben Cain','Russell Bradley Fenton','Grayson Berry','Nick Searcy','Alex Webb','Paden Fallis','Tommy LaFitte','Becky Ann Baker','Brad William Henke','Marley Shelton','Anabelle Holloway','Billy Hepfinger','Katie McClellan','Tony DeMil','Mark Jeffrey Miller','Corey Maher','Dihlon McManne','Allie McCulloch','Gena Shaw','Geraldine Singer','Kasey Daley','Deirdre Lovejoy','James Healy Jr.','Scott A. Martin','Dana Cuomo','Mike Stanley','Brendan Byrne','Matthew Ewald','Tonya Bludsworth','Christopher Ryan Lewis','Mark Borkowski','John Archer Lundgren','Skyler Elyse Philpot','Allen Parker','James Michael Smith','Daniel Johnson','Ted Koppel','Lindsay Ayliffe','Elizabeth Becka','Chris Frank','Curtis Wyatt III','David Alexander'],
screenplay:['Andrew Sodroski','Allison Moore','Max Hurwitz','Steven Katz','Nick Schenk','Denise Harkavy'],
production:['David A. Rosemont'],
music:['Harry Gregson-Williams','Gregory Tripi'],
camera:['Zack Galler','John Lindley','Eric Moynier'],
cut:['John Duffy','Iain Erskine','Scott Turner','Donn Aron','Debra Beth Weinfeld','Niven Howie'],
sound:['Nick Offord','Joe DeAngelis','Andrew Spencer Dawson','Kenneth Kobett','Brad North'],
scenography:['Lauren Crasco','Jonathan A. Carlson','P. Erik Carlson','Diane Yates'],
masks:['Jamie Cline','David Atherton','Rachel Geary','Rachel Kick','Patty Bell'],
costumes:['Alonzo Van Wilson','Patia Prouty']},
{title:'Parasyte: The Maxim',
titleCZ:'Kiseidžú: Sei no kakuricu',
year:2014,
runtime:'9h 12min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Drama','Action','Sci-Fi','Horror'],
director:['Keniči Šimizu','Hiromiči Matano','Čie Jamaširo','Juki Inaba'],
actors:['Aja Hirano','Nobunaga Šimazaki','Kana Hanazawa','Acuko Tanaka','Daisuke Namikawa','Mijuki Sawaširo','Rie Murakawa','Akira Išida','Hirojuki Jokó','Issei Futamata','Makoto Jasumura','Rena Maeda',"Šin'ja Hamazoe",'Tóru Nara','Kazuhiko Inoue','Hirojuki Jošino','Makiko Ómoto','Masaki Aizawa','Takeharu Óniši','Jú Mizušima','Takahiko Sakaguma','Ajumu Murase','Hidejuki Umezu','Takaja Aojagi','Júja Murakami','KENN',"Džun'ja Enoki",'Kimiko Saitó','Kikumi Umeda','Rina Kitagawa','Rikija Kojama','Džunta Terašima','Takuma Suzuki','Miho Mijagawa','Čieko Sasai','Kijono Jasuno','Haruka Kudó','Jú Serizawa','Seiko Fudžiki','Džiró Saitó','Daiči Fudžiwara','Eidži Itó','Velo Takeda','Rieko Kamenaka'],
basedOn:['Hitoši Iwaaki'],
screenplay:['Šódži Jonemura','Šinzó Fudžita'],
production:['Hirojuki Inage','Tošio Nakatani','Acuši Kirimoto'],
music:['Ken Arai'],
camera:['Akane Fušihara'],
cut:['Kašiko Kimura'],
sound:['Čiaki Jamada'],
scenography:['Fuminao Akai']},
{title:'How I Met Your Mother',
titleCZ:'Jak jsem poznal vaši matku',
year:2005,
runtime:'76h 7min',
episodeRuntime:'20-22min',
countries:['USA'],
genres:['Comedy','Romance'],
director:['Pamela Fryman','Rob Greenberg','Neil Patrick Harris','Michael J. Shea','Lesley Manning'],
actors:['Josh Radnor','Jason Segel','Neil Patrick Harris','Alyson Hannigan','Cobie Smulders','David Henrie','Lyndsy Fonseca','Alexis Denisof','Jayma Mays','Eva Amurri Martino','Morena Baccarin','Amy Acker','Mandy Moore','Valerie Azlynn','Danica McKellar','Elizabeth Bogush','Preston Bailey','Heidi Klum','Hayes MacArthur','Michael Trucco','Bob Saget','Tom Lenk','David Burtka','James Tupper','Erin Cardillo','Britney Spears','Sarah Chalke','Eric Allan Kramer','Neil Jackson','Nikki Griffin','Sharon Madden','Maggie Wheeler','John Cho','James van der Beek','Enrique Iglesias','Harry Groener','Jane Seymour','Patricia Belcher','Abigail Spencer','Ashley Williams','Lucy Hale','Jessica Barth','America Olivo','Alyssa Shafer','April Bowlby','Anne Dudek','Floyd Van Buskirk','Nate Torrence','Vanessa Evigan','Lindsay Price','Camryn Manheim','Samm Levine','Kathleen Rose Perkins','Caroline Lagerfelt','Jacqueline Piñol','Rachel Specter','Alan Thicke','Deanna Russo','Erinn Bartlett','Busy Philipps','Vanessa Lachey','Katie Walder','Hallie Lambert','Megan Mullally','Kristen Schaal','Kelly Stables','Arielle Vandenberg','Heidi Herschbach','Betsy Rue','Marshall Manesh','Martin Starr','Michele Nordin','Orson Bean','Michelle Noh','Adriana Lima','Laura Prepon','Cedric Yarbrough','Robert Wisdom','Wayne Brady','John Getz','Darcy Rose Byrnes','Eric Braeden','Nicole Taylor','Alexis Krause','Beth Riesgraf','Danneel Ackles','Renée Taylor','Shammy Dee','Courtney Ford','Buck Kartalian','Rachel Bilson','Christine Woods','Scoot McNairy','Jamie-Lynn Sigler','Raquel Alessi','Jae Head','Amanda Peet','Will Forte','Meredith Scott Lynn','Jennifer Lopez'],
screenplay:['Carter Bays','Maria Ferrari','Craig Thomas','Kristin Newman','David Hemingson','Phil Lord','Christopher Miller','Ira Ungerleider','Gloria Calderon Kellett','Greg Malins','Chris Romano','Dan Gregor','Doug Mand','Stephen Lloyd','Craig Gerard','Matthew Zinman','Eric Falconer','Matt Kuhn','Chuck Tatham','Robia Rashid','Tami Sagher','Theresa Mulligan','Barbie Adler','Kourtney Kang','Joe Kelly','Sam Johnson','Chris Marcil','Jamie Rhonheimer','Chris Harris','Tom Ruprecht','Rachel Axler','Brenda Hsueh'],
production:['Rob Greenberg','Theresa Mulligan','Randy Cordray','Kourtney Kang','Stewart Halpern-Fingerhut','Jamie Rhonheimer','Chris Harris','Rachel Axler','Brenda Hsueh','Mia Jupp'],
music:['John Swihart'],
camera:['Steven V. Silver','Chris La Fountaine'],
cut:['Kirk Benson','Sue Federman'],
sound:['Charlie McDaniel','Tamara Johnson','John Bickelhaupt','Kathy Oldham'],
scenography:['Steve Olson','Susan Mina Eschelbach','Richard C. Walker','Michele Poulik'],
masks:['Shellie Biviens','Julie Teel','Renee Caruso-Napolitano','Samantha Wen','Jani Kleinbard','Lona Jeffers','Cheryl Calo','Cindy Costello','Roxanne Baker-Sarver','Bret Mardock','Jennifer Turchi Nigh'],
costumes:['Susanna Puisto','Julie Bennett Block','Reiko Schoenfeld']},
{title:"Chip 'n Dale Rescue Rangers",
titleCZ:'Rychlá rota',
year:1989,
runtime:'23h 50min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['John Kimball','Bob Zamboni','Alan Zaslove','Jamie Mitchell','Tayk Kim','Nobuo Tomizawa','Toshihiko Masuda'],
actors:['Peter Cullen','Corey Burton','Tress MacNeille','Jim Cummings','Deborah Walley','Alan Oppenheimer','Robert Ito','Victoria Carroll','Pat Carroll','Fran Ryan','Frank Buxton','Ruth Buzzi','Kathleen Freeman','Hamilton Camp','Rob Paulsen','Susan Blu','Pete Schrum','Patti Howeth','Michael Merton','Dev Ross','Chuck McCann','Russi Taylor','Howard Morris','Gregg Berger','Bernard Fox','Carol Channing','Sindy McKay','James MacDonald','Noelle North','Brian Cummings','Tim Hoskins','Neil Ross'],
screenplay:['Linda Woolverton','Kevin Hopps','Alan Burnett','David Wise','Eric Lewald','Michael Edens','Mark Edward Edens','Bruce Talkington','Dev Ross','Julia Lewald','Tad Stones','Somtow Papinian Sucharitkul','Bryce Malek','Len Uhley','Dean Stefan','Michael Price Nelson','Burt Brown','Sindy McKay','Larry Swerdlove','Bruce Reid Schaefer','Ken Koonce','David Weimers','Buzz Dixon','Lydia Marano'],
production:['Tad Stones','Alan Zaslove'],
music:['Ron Jones','Glen Daum'],
cut:['Cecil Broughton']},
{title:'The Fall',
titleCZ:'The Fall',
year:2013,
runtime:'17h 27min',
episodeRuntime:'58-90min',
countries:['UK'],
genres:['Drama','Thriller','Psychology'],
director:['Jakob Verbruggen','Allan Cubitt'],
actors:['Gillian Anderson','Laura Donnelly','Jamie Dornan','John Lynch',"Jonjo O'Neill",'Archie Panjabi','Ian McElhinney','Michael McElhatton','Karen Hassan','Simon Delaney','Nick Lee','Gerard Jordan','Sarah Beattie','Niamh McGrady','David Beattie','Bronagh Waugh','Siobhan McSweeney','Aisling Franciosi','Emmett J. Scanlan','Stuart Graham','Séainín Brennan',"Eugene O'Hare",'Colin Morgan','Tobias Winter','B.J. Hogg','Paul Caddell','Sara Dylan',"Patrick O'Kane",'Omar Youssef','Kristy Robinson','Andy Moore','Desmond Edwards','Paul Kennedy','Bobby Marno','Roman Beguns','Simon Millar','Irma Mali','Gerard McCarthy','Marty Maguire','Frank McCusker','Aisling Bea','Brian Milligan','Tara Lee','Tim Loane','Aoibhin Garrihy','Liam McMahon','Sean McGinley','Richard Coyle','Barry Ward','Cathy White','Patrick FitzSymons',"Hugh O'Conor",'Shashi Rami','Lacy Moore','Ruth Bradley','Laura Hughes','Aidan McArdle',"Genevieve O'Reilly",'Denise Gough','Krister Henriksson','Andrea Irvine','Conor MacNeill','Martin McCann','Valene Kane','Sophie Harkness','Judith Roddy',"Tara Lynne O'Neill",'Bronágh Taggart','Kelly Gough','Joanne Crawford','Claire Rafferty','Vanessa Emme','Carolyn Bracken','Roisin Gallagher','Lisa Dwyer Hogg','Paul Kennington','Tara Egan Langley','Ben Peel','Vincent Walsh','Michael Johnston','Kelly Campbell','Enda Oates'],
screenplay:['Allan Cubitt'],
production:['Carol Moorhead','Julian Stevens'],
music:['Keefus Ciancia','David Holmes'],
camera:['David Grennan',"Ruairí O'Brien"],
cut:['Steve Singleton'],
sound:['Derek Hehir'],
scenography:['Tom McCullagh','Gillian Devenney'],
masks:['Sharon Watson'],
costumes:['Eimer Ni Mhaoldomhnaigh','Maggie Donnelly']},
{title:'Andor',
titleCZ:'Andor',
year:2022,
runtime:'20h 42min',
episodeRuntime:'38-57min',
countries:['USA'],
genres:['Sci-Fi','Action','Adventure','Thriller'],
director:['Toby Haynes','Susanna White','Benjamin Caron'],
actors:['Diego Luna',"Genevieve O'Reilly",'Stellan Skarsgård','Kyle Soller','Denise Gough','Adria Arjona','James McArdle','Rupert Vansittart','Joplin Sibtain','Alastair Mackenzie','Forest Whitaker','Fiona Shaw','Alex Ferns','Gary Beadle','Alex Lawther','Ebon Moss-Bachrach','Gershwyn Eustache Jnr','Stanley Townsend','David Hayman','Richard Katz','Faye Marsay','Varada Sethu','Dan Li','Michelle Duncan','Nick Blood','Luke Baker','Chris Ryman','Michael Akinsulire','Jacob James Beswick','Anton Lesser','Michael Jenn','Robert Emms','Lucy Russell','Ben Bailey Smith','Nick Owenford','Kathryn Hunter','Bronte Carmichael','Wilf Scolding','Lee Ross','Jimmy Walker','Antonio Viña','Victor Perez','Ron Cook','Jordan Long','Dave Chapman','Richard Henderson','Fraser Ayres','Abhin Galeya','Zubin Varla','David Cheung',"Kieran O'Brien",'Margaret Clunie','Kiran Shah','Lee Boardman','Stephen Wight','Peter Bankolé','Ian Whyte','Andy Serkis','Josh Herdman','Anton Valensi','Duncan Pow','Christopher Fairbank','Clemens Schick','Tom Reed','Rasaq Kukoyi','Fode Simbo','Ben Miles','Hugh Sachs','Romario Simpson','Jonathan Gunning','Alice Orr-Ewing','Chelsea Edge','Nicholas Moss','Joshua James','Ragevan Vasan','Lucas Bond','Jolyon Coy','Beatie Edney','Neil Bell','Matt Dunkley','Gavin Spokes','Richard Dillane','Rosalind Halstead','Roger Barclay','Harry McEntire','Hebe Beardsall','Adrian Rawlins','Josef Davies','Victor Alli','Katrina Nare','Abraham Popoola','Brandon Bassir'],
screenplay:['Tony Gilroy','Stephen Schiff','Dan Gilroy','Beau Willimon'],
production:['Kate Hazell','David Meanti','Kathleen Kennedy'],
music:['Nicholas Britell'],
camera:['Adriano Goldman','Frank Lamm','Damian Garcia'],
cut:['Frances Parker','John Gilroy','Tim Porter','Dan Roberts','Matthew Cannings','Simon Smith','Yan Miles','Hazel Baillie'],
sound:['David Acord'],
scenography:['Luke Hull','Richard Campling','Andrea Borland','Toby Britton','Will Coubrough','Claire Fleming','Richard Hardy','Max Klaentschi','Darren Tubby','Su Whitaker','Rebecca Alleway','Mark Harris'],
masks:['Holly Caddy','Niall Monteith-Mann','Daniele Nastasi','Julio Parodi'],
costumes:['Michael Wilkinson']},
{title:'The Killing',
titleCZ:'Vražda',
year:2007,
runtime:'38h 5min',
episodeRuntime:'54-58min',
countries:['Denmark','Norway','Sweden','Germany'],
genres:['Crime','Drama','Mystery','Thriller'],
director:['Fabian Wullenweber','Charlotte Sieling','Henrik Ruben Genz','Birger Larsen','Natasha Arthy','Mikkel Serup','Kathrine Windfeld','Morten Arnfred','Morten Køhlert','Kristoffer Nyholm'],
actors:['Sofie Gråbøl','Lars Mikkelsen','Bjarne Henriksen','Ann Eleonora Jørgensen','Marie Askehave','Michael Moritzen','Søren Malling','Nicolaj Kopernikus','Bent Mejding','Laura Drasbæk','Johan Gry','Troels Munk','Ole Boisen','Morten Suurballe','Farshad Kholghi','Eske Forsting Hansen','Julie R. Ølgaard','Louise Herbert','Jesper Lohmann','Laura Christensen','Cyron Melville','Solbjørg Højfeldt','Rasmus Hammerich','Peder Holm Johansen','Tina Gylling Mortensen','Casper Steffensen','Petrine Agger','Helene Egelund','Troels Lyby','Morten Lützhøft','Kim Bodnia','Claus Bue','Vibeke Hastrup','Anders Nyborg','Joy-Maria Frederiksen','Jakob Cedergren','Henrik Prip','Benjamin Boe Rasmussen','Lars Simonsen','Maibritt Saerens','Klaus Tange','Rita Angela','Rasmus Haxen','Anders Hove','John Martinus','Kim Sønderholm','Morten Hauch-Fausbøll','Carl Martin Norén','Charlotte Fich','Mette Munk Plum','Claus Riis Østergaard','Hans Henrik Clemensen','Stine Holm Joensen','Henrik Larsen','Janek Lesniak','Michael Sand','David Dencik','Kim Haugen','Henning Valin','Lisbeth Wulff','Ole Ernst','Jens Jørn Spottag','Klaus Hjuler','Robert Reinhold','Astrid Reinhardt','Ulver Skuli Abildgaard','Mette Kolding','Mette Vibe Utzon','Max Hansen','Søren Stærmose','Nukâka Coster-Waldau','Kjeld Nørgaard','Pilou Asbæk','Janus Nabil Bakrawi','Preben Kristensen','Søren Pilmark','Casper Crump','Hanne Hedelund','Lotte Andersen','Mikael Birkkjær','Lotte Munk','Claus Damgaard','Kurt Ravn','Michelle Bjørn-Andersen','Julie Agnete Vang Christensen','Nicolas Bro','Anne Sofie Espersen','Stine Prætorius','Ida Dwinger','Morten Eisner','Nicolai Dahl Hamilton','Jon Lange','Sarah Gottlieb','Thomas Hwan','Pelle Koppel','Puk Scharbau','Jacob Lohmann','Benedikte Hansen','Carsten Bjørnlund','Kim Kold'],
screenplay:['Søren Sveistrup','Michael W. Horsten','Torleif Hoppe','Per Daumiller'],
production:['Piv Bernth'],
music:['Frans Bak'],
camera:['Magnus Nordenhof Jønck','Eric Kress','Jørgen Johansson','Marcel Zyskind','Rasmus Arrildt','Bo Tengberg','Niels Reedtz Johansen'],
cut:['Søren B. Ebbe','Kasper Leick','Theis Schmidt','Martin Schade','Janne Bjerg Sørensen','Gerd Tjur','Lars Therkelsen','Steen Schapiro','Thomas Krag','Rikke Selin','Bodil Kjærhauge'],
sound:['Nino Jacobsen','Michael Dela','Andreas Holtti','Rune Mygind','Henning Engelbak','Jeppe Jungersen'],
scenography:['Niels Sejer','Jette Lehmann','Trine Padmo','Anja Wessel','Charlotte Garnov','Jacob Wirth Carlsen'],
masks:['Jeanet Keil','Julie Holst','Lene Majgaard Arentsen','Bettina Züberlein Petersen','Christina Dahlin','Kamilla Bjerglind','Áslaug Dröfn Sigurðardóttir','Birgitte Samson'],
costumes:['Nancy Nickerson','Linda Wallentin','Charlotte Moe','Mette Meinicke','Grith Rahbek','Anita Nielsen']},
{title:'Yellowstone',
titleCZ:'Yellowstone',
year:2018,
runtime:'45h 19min',
episodeRuntime:'37-93min',
countries:['USA'],
genres:['Drama','Western'],
director:['Taylor Sheridan','Ed Bianchi','Stephen Kay','John Dahl','Ben Richardson','Guy Ferland','Christina Alexandra Voros'],
actors:['Kevin Costner','Kelly Reilly','Dave Annable','Kelsey Asbille','Wes Bentley','Gil Birmingham','Ian Bohen','Luke Grimes','Cole Hauser','Jill Hennessy','Danny Huston','Lonzo Liggins','Crystle Lightning','Gretchen Mol','Rudy Ramos','Kylie Rogers','Patrick St. Esprit','Buck Taylor','Jeremiah Bitsui','Golden Brooks','J.R. Cacia','Mason D. Davis','Fredric Lehne','Wendy Moniz','Michael Nouri','Geno Segers','Devin Hansen','John Aylward','Timothy Carhart','Austin R. Grant','Josh Lucas','Bill Tangradi','Moses Brings Plenty','Dylan Kenin','Steve Coulter','Heather Hemmens','Taylor Sheridan','Barret Swatek','Ryan Bingham','Michaela Conlin','Katherine Cunningham','Mike Faiola','Brian Unger','Michelle Campbell','Tinsel Korey','Savonna Spracklin','Jim Lau','Travis W Bruyer','Valerie Yu','Jefferson White','DeJean Brown','Sean Dillingham','Ryan Dorsey','Tanaya Beatty','Steven Williams','Althea Sam','Kelly Rohrbach','Rya Kihlstedt','Eddie Spears','Ryan Begay','Martin Sensmeier','Neal McDonough','Terry Serpico','James Jordan','Lane Garrison','Hugh Dillon','Don Harvey','Jae Head','Kari Hawker-Diaz','Wolé Parks','Kyle Red Silverstein','Luce Rains','Domenick Lombardozzi','Allison Dunbar','Chantel Flanders','Dabney Coleman','Christopher May','Josh Holloway','Eden Brolin','Karen Pittman','John Emmet Tracy',"Q'orianka Kilcher",'Adam Johnson','Blythe Howard','Kristen Marie Jensen','Christy Summerhays','Will Patton','Hassie Harrison','Boots Southerland','John Sanderford','Anna Daines','Austin Hébert','Craig Clyde','K.C. Clyde','Kathleen Wilhoite','Scout Smith','Kelsie Elena','Nicole Duke','Tiffany Quilter','David Cleveland Brown'],
screenplay:['Taylor Sheridan','Brett Conrad','Ian McCulloch','Eric Jay Beck','John Coveny'],
production:['Rajeev Malhotra'],
music:['Brian Tyler','Breton Vivian'],
camera:['Ben Richardson','David Johnson','Christina Alexandra Voros','Adam Suschitzky','Jim Denault','William Wages','Dino Parks'],
cut:['Evan Ahlgren','Gary D. Roach','Chad Galster','Chris G. Willingham','Michael N. Knue','John Coniglio'],
sound:['Alan Robert Murray','Yuri Reese','Sean Madsen','Dean A. Zupancic','Samuel Ejnes','Diego Gat','John T. Reitz','David Raines','Andrejs Prokopenko'],
scenography:['Ruth De Jong','Cary White','Carla Curry','Yvonne Boudreaux'],
masks:['Shannon Kelsey Hokama','Molly Moonanne Sanders','Tim Muir','Megan Danner'],
costumes:['Ruth E. Carter','Johnetta Boone','Brit Ellerman']},
{title:'Miranda',
titleCZ:'Miranda',
year:2009,
runtime:'10h 6min',
episodeRuntime:'30-33min',
countries:['UK'],
genres:['Comedy'],
director:['Juliet May','Mandie Fletcher'],
actors:['Miranda Hart','Patricia Hodge','Tom Ellis','Sarah Hadland','Sally Phillips','James Holmes','Naomi Bentley','James Doherty','Adam Rayner','Luke Pasqualino','Patrick Barlow','Peter Davison','Ewen MacIntosh','Terence Maynard','Michael Landes','Belinda Stewart-Wilson','Kerry Godliman','Alex MacQueen','Anna Chancellor','Mark Heap','Tom Conti','Jason Watkins','Tim Pigott-Smith','Gary Barlow','Hilary Gish','Steven Webb','Alice Hart','Graham Bohea','Ben Forster','Adrian Scarborough','Steve Speirs','Steve Oram','Neil Edmond','Tom Meeten','Stefano Braschi','Theo Barklem-Biggs','François Migeat','Margaret Cabourn-Smith','Glen Davies','Katherine Jakeways','Katy Wix','Taj Atwal','Charles Venn','Joe Wilkinson','Rosalie Craig','Ben Bailey Smith','Mel Giedroyc','Angela McHale','Vicki Pepperdine','Emma Kennedy','Stephen Critchlow','Nick Mohammed','Mark Killeen','Adam James','Augustina Amoa','Damson Idris','Liza Tarbuck','Richard Sutton','Philip Brodie','Tim Downie','Alex Hassell','Rufus Wright','Bohdan Poraj','Dominic Coleman','Kate Maravan','Chris Wilson','Stacy Liu','Stacy Liu','Tim Pigott-Smith','Michael Landes','Ashley McGuire','Geraldine McNulty','Jamie Langlands','Dan Tetsell','John Voce','Maggie Service','Michael Wildman','John Finnemore','Laurence Howarth','Dave Lamb','James Bachman','Oriane Messina','Tom Parry'],
screenplay:['Miranda Hart','James Cary','Paul Powell','Dan Gaster','Will Ing'],
camera:['Pete Rowe','Chris Goodger'],
cut:['Gavin Buckley','Jake Bernard'],
scenography:['Harry Banks'],
masks:['Ann Fenton','Siân Miller'],
costumes:['Yves Barre']},
{title:'Godless',
titleCZ:'Godless',
year:2017,
runtime:'7h 36min',
episodeRuntime:'41-80min',
countries:['USA'],
genres:['Western'],
director:['Scott Frank'],
actors:['Michelle Dockery','Jeff Daniels',"Jack O'Connell",'Scoot McNairy','Adam David Thompson','Merritt Wever','Thomas Brodie-Sangster','Rob Morgan','Rio Alexander','Michael E. Stogner','Sam Waterston','Kim Coates','Jeremy Bobb','Whitney Able','Keith Jardine','Phoebe Neidhardt','Christiane Seidel','Randy Oglesby','Justin Welborn','Patrick Carlyle','Travis Hammer','Zack Duhame','J. Nathan Simmons','Delaney Williams','Sarah Minnich','Tabatha Shaun','Trine Christensen','Jessica Sula','Erik LaRay Harvey','Samuel Marty','Christopher Fitzgerald','Tantoo Cardinal','Tess Frazer','Mia Stallard','Nathan Darrow','Marceline Hugot','Kayli Carter','Audrey Moore','Donald Cerrone','Elisa Perry','Russell Dennis Lewis','Marie Wagenman','Shawn-Caulin Young','Matthew Dennis Lewis','Austin Kane','Samantha Soule','André Lamoglia','Sophia Silver','Russell G. Jones'],
screenplay:['Scott Frank'],
production:['Michael J. Malone'],
music:['Carlos Rafael Rivera'],
camera:['Steven Meizler'],
cut:['Michelle Tesoro'],
sound:['Eric Hoehn','Wylie Stateman'],
scenography:['David J. Bomba','Carlos Barbosa','Carla Curry'],
masks:['Bonnie Masoner','Justin Raleigh','Megan Daum','Kevin Kirkpatrick'],
costumes:['Betsy Heimann']},
{title:'Code Geass: Lelouch of the Rebellion',
titleCZ:'Code Geass: Hangjaku no Lelouch',
year:2006,
runtime:1200,
episodeRuntime:24,
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy','Psychology','Sci-Fi'],
director:['Goró Taniguči','Kazuja Murata','Noriaki Akitaja','Rion Kudžó','Kazuo Mijake','Akira Toba','Fumija Hódžó','Kazuo Sakai','Masato Mijoši'],
actors:['Akeno Watanabe','Fumiko Orikasa','Ken Narita','Noriaki Sugijama','Norio Wakamoto','Naoki Bandó','Jasujuki Kase','Kan Tokumaru','Kazunari Tanaka','Issei Futamata','Jukana','Takeši Kusao','Juri Amano','Takahiro Sakurai','Džunko Minagawa','Sajaka Óhara','Ami Košimizu','Džódži Nakata','Nobuo Tobita','Satomi Arai','Kacuhisa Hóki','Kijojuki Janada','Kaori Nazuka','Micuaki Madono','Kikuko Inoue','Tecu Širatori','Masajo Kurata','Mika Kanai','Saeko Čiba','Jošijuki Kóno','Nobuaki Sekine','Takahiro Mizušima','Sóičiró Hoši','Asako Dodo','Júko Gotó','Asami Sanada','Kózó Mito','Takaši Taguči','Acuši Kisaiči','Kazuo Oka','Džun Fukujama','Omi Minami','Šinpači Cudži','Norihiro Inoue','Jú Šimaka','Júdži Takada','Rjúzó Hasuike','Džin Jamanoi','Masako Kacuki','Nobujuki Tanaka','Kazato Tomizawa','Hikaru Midorikawa','Júdži Mikimoto','Masaharu Sató','Sómei Učida','Tamaki Macumoto','Dai Macumoto','Emi Motoi','Džunko Asami'],
screenplay:['Hirojuki Jošino','Ičiró Ókóči','Júiči Nomura'],
production:['Hirofumi Morotomi','Džun Jukawa'],
music:['Hitomi Kuroiši','Kótaró Nakagawa'],
camera:['Sóta Ója'],
cut:['Seidži Morita','Masaki Ucunomija','Juri Tamura','Megumi Nakamura'],
sound:['Motoi Izawa','Jasuo Urakami'],
scenography:['Jošinori Hišinuma']},
{title:'Dekalog',
titleCZ:'Dekalog',
year:1989,
runtime:'9h 20min',
episodeRuntime:'53-58min',
countries:['Poland','Germany'],
genres:['Drama'],
director:['Krzysztof Kieślowski'],
actors:['Henryk Baranowski','Jerzy Stuhr','Daniel Olbrychski','Bogusław Linda','Piotr Rzymyszkiewicz','Olaf Lubaszenko','Wojciech Klata','Władysław Kowalski','Janusz Gajos','Henryk Bista','Zbigniew Zamachowski','Joanna Szczepkowska','Artur Barciś','Krystyna Janda','Grażyna Szapołowska','Krzysztof Globisz','Piotr Machalica','Olgierd Łukaszewicz','Aleksander Bardini','Aleksandra Kisielewska','Aleksandra Majsiuk','Agnieszka Brustman','Mirosław Baka','Adrianna Biedrzyńska','Jan Tesarz','Maja Barełkowska','Katarzyna Piwowarczyk','Anna Polony','Maria Kościałkowska','Teresa Marczewska','Ewa Błaszczyk','Jolanta Piętek-Górecka','Maciej Szary','Barbara Kolodziejska','Maria Gładkowska','Maja Komorowska','Krzysztof Kumor','Piotr Siejka','Jerzy Fedorowicz','Włodzimierz Musiał','Dorota Stalińska','Jerzy Zygmunt Nowak','Maria Pakulnis','Jacek Kałucki','Andrzej Blumenfeld','Igor Śmiałowski','Adam Hanuszkiewicz','Helena Kowalczykowa','Sylwester Maciejewski','Maciej Maciejewski','Aleksander Bednarz','Zbigniew Zapasiewicz','Zdzisław Rychter','Borys Marynowski','Jerzy Zass','Małgorzata Rożniatowska','Jan Piechociński','Dariusz Jabłoński','Bożena Dykiel','Jan Mayzel','Bronisław Pawlik','Jerzy Schejbal','Marek Kępiński','Tadeusz Łomnicki','Ewa Skibińska','Marian Opania','Renata Berger','Jerzy Trela','Jan Jankowski','Grzegorz Warchoł','Cezary Harasimowicz','Anna Gornostaj','Jerzy Turek','Maciej Stuhr','Ewa Kania','Iwona Głębicka','Daniel Kozakiewicz','Marcin Sławiński','Janusz Mond','Halina Drohocka','Włodzimierz Rzeczycki','Hanna Szczerkowska','Maciej Borniński','Janusz Cywiński','Zdzisław Tobiasz','Henryk Majcherek','Stefania Błońska','Maria Krawczyk-Ważyk','Ewa Ekwińska','Sławomir Kwiatkowski','Krzysztof Rojek','Rafał Imbro','Magdalena Mikołajczak'],
screenplay:['Krzysztof Kieślowski','Krzysztof Piesiewicz'],
music:['Zbigniew Preisner'],
camera:['Wiesław Zdort','Edward Kłosiński','Piotr Sobociński','Sławomir Idziak','Andrzej J. Jaroszewicz'],
cut:['Ewa Smal'],
sound:['Nikodem Wołk-Łaniewski'],
scenography:['Halina Dobrowolska']},
{title:'Olive Kitteridge',
titleCZ:'Olive Kitteridgeová',
year:2014,
runtime:240,
episodeRuntime:60,
countries:['USA'],
genres:['Drama'],
director:['Lisa Cholodenko'],
actors:['Frances McDormand','Bill Murray','Richard Jenkins','John Gallagher Jr.','Zoe Kazan','Ken Cheeseman','Rachel Brosnahan','Patrick Carroll','Brady Corbet','Cory Michael Smith','Rosemarie DeWitt','Devin Druid','Theo Stockman','Donna Mitchell','Nada Despotovich','Mike Messier','James McMenamin','Martha Wainwright','Celeste Oliva','Christopher Jon Gombos','Jesse Plemons','Peter Mullan','Ann Dowd','Jeffrey Corazzini','Patricia Kalember','Audrey Marie Anderson','Colbi Gannett','Georgia Lyman','Libby Winters','Frank Ridley','Moira Driscoll'],
basedOn:['Elizabeth Strout'],
screenplay:['Jane Anderson'],
music:['Carter Burwell'],
camera:['Frederick Elmes'],
cut:['Jeffrey M. Werner'],
sound:['Christian P. Minkler','Michael Minkler'],
scenography:['Julie Berghoff','Sophie Neudorfer','Colin De Rouin'],
masks:['Gerald Quist'],
costumes:['Jenny Eagan']},
{title:'The Shield',
titleCZ:'Policejní odznak',
year:2002,
runtime:'87h 14min',
episodeRuntime:'44-72min',
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['D.J. Caruso','Peter Horton','Brad Anderson','Davis Guggenheim','Stephen Gyllenhaal','Guy Ferland',"Terrence O'Hara",'Félix Enríquez Alcalá','Scott Winant','Clark Johnson','Nick Gomez','Gary Fleder','John Badham','David Von Ancken','Phillip G. Atwell','Michael Chiklis','Gwyneth Horder-Payton','Frank Darabont','David Mamet','Billy Gierhart','Kurt Sutter','Dean White','Rohn Schmidt','Paris Barclay','Stephen Kay','Vondie Curtis-Hall','Michael Fields','Craig Brewer','Leslie Libman','Scott Brazil'],
actors:['Michael Chiklis','Walton Goggins','CCH Pounder','Catherine Dent','Jay Karnes','Benito Martinez','Michael Jace','Kenny Johnson','David Rees Snell','Cathy Cahlin Ryan','Michele Hicks','David Marciano','Paula Garcés','Forest Whitaker','John Diehl',"Alex O'Loughlin",'Reed Diamond','Kurt Caceres','Gina Torres','Lela Loren','Chris Williams','Frank Grillo','Michael Peña','Daniel Dae Kim','April Scott','Johnny Whitworth','Lindsay Hollister','Will McCormack','Glen Badyna','David Batiste','Tracie Thoms','Lydia Blanco','Glenn Close','Gareth Williams','Mark Ivanir','Danny Pino','Sung Kang','Pasha D. Lychnikoff','Caroline Macey','Simon Rhee','Jenya Lano','Geoff Meed','Nichole Hiltz','Jay Harrington','April Grace','Aasha Davis','Joseph D. Reitman','Rigo Sanchez','Clark Gregg','Sahar Bibiyan','Steve Cell','Suyun Kim','Jamie Anderson','Elizabeth Rodriguez','Kelvin Yu','Alex Veadov','Damon Standifer','Elijah Kelley','Matthew John Armstrong','Johnny Trí Nguyễn','Joe Chacon','Laurence Mason','Sandra Purpuro','Gloria Garayua','Julanne Chidi Hill','Anthony Anderson','Wayne Dalglish','Noel Gugliemi','Yancey Arias','Stana Katic','Cory Hardrict','Brent Sexton','Michael J. Pagan','Paula Jai Parker','Guy Torry','Franka Potente','Kyle Gallner','Ken Jeong','Frances Fisher','Joseph Julian Soria','Jason Earles','Matt Gerald','Abby Brammell','Kristen Bell','Melanie Lynskey','Katey Sagal','Guillermo Díaz','Jon Huertas','Robert LaSardo','Alex Fernandez','Scoot McNairy','Jimmy Jean-Louis','Brandon Mychal Smith','Judi Beecher','Mageina Tovah','Garrett M. Brown',"Stu 'Large' Riley",'Greg Davis Jr.','Tanee McCall-Short','Eric Lange'],
screenplay:['Scott Rosenbaum','Charles H. Eglee','Adam Fierro','John Hlavin','Gary Lennon','Ted Griffin','Elizabeth Craft','Sarah Fain','Glen Mazzara','Kurt Sutter','Reed Steiner','Evan Bleiweiss','Lisa Randolph','Benjamin Cavell','Jameal Turner','Diego Gutierrez','Kim Clements','Angela Russo-Otstot','Tony Soltis','Elizabeth A. Hansen'],
production:['Glen Mazzara','Dean White','Kevin G. Cremin'],
music:['Matthias Weber'],
camera:['Rohn Schmidt'],
cut:['Lori Jane Coleman','Jim Page','Lee Haxall','Padraic McKinley','Hunter M. Via','Angela M. Catanzaro','Jordan Goldman','Steve Polivka','Jacques Gravett','Jim Gross','Les Butler'],
sound:['Chris Philp','Brian Harman','Eric Justen','Sherry Klein','Fred Tator','R. Russell Smith','William Freesh','Albert Ibbotson','Mike Olman','Kenneth Kobett','Tim Cooney'],
scenography:['James William Newport','Anthony Medina','Dena Allen','Melissa M. Levander','Michele Poulik','Suzette Sheets','Jeannie Gunn'],
masks:['Susan Kelber','Donna J. Anderson','Elisabeth Dietrich','Ketty Gonzalez','Sherilyn Stetz'],
costumes:['Linda M. Bass','Terry Dresbach','Amy Stofsky','Kathryn Morrison']},
{title:'Shogun',
titleCZ:'Shogun',
year:1980,
runtime:'9h 44min',
episodeRuntime:'90-138min',
countries:['USA','Japan'],
genres:['Adventure','Drama','History','War'],
director:['Jerry London'],
actors:['Richard Chamberlain','Toširó Mifune','Jóko Šimada','Furankí Sakai','Alan Badel','Damien Thomas','John Rhys-Davies','Orson Welles','Vladek Sheybal','Hideo Takamacu','Nobuo Kaneko','Hiroši Hasegawa','Tóru Abe','Seidži Mijaguči','Neil McCarthy','Miiko Taka','Michael Hordern','William Morgan Sheppard','Šin Takuma','Eric Richard','George Innes','Júki Meguro','Midori Takei','Hjóe Enoki','Jósuke Nacuki','Takeši Óbajaši','Masaši Ebara','Júko Kada'],
basedOn:['James Clavell'],
screenplay:['Eric Bercovici'],
production:['Eric Bercovici'],
music:['Maurice Jarre'],
camera:['Andrew Laszlo'],
cut:['Donald R. Rode','Benjamin A. Weissman','James T. Heckert','Jerry Young','Bill Luciano'],
sound:['Stanley Paul'],
scenography:['Joseph R. Jennings','Tom Pedigo'],
costumes:['Shin Nishida']},
{title:'Brooklyn Nine-Nine',
titleCZ:'Brooklyn 99',
year:2013,
runtime:'56h 25min',
episodeRuntime:'21-43min',
countries:['USA'],
genres:['Comedy','Crime'],
director:['Dean Holland','Michael McDonald','Craig Zisk','Victor Nelli Jr.','Claire Scanlon','Tristram Shapeero','Eric Appel','Linda Mendoza','Ryan Case','Beth McCarthy-Miller','Julie Anne Robinson','Max Winkler','Fred Goss','Ken Whittingham','Payman Benz','Nisha Ganatra','Rebecca Asher','Jason Ensler','Phil Lord','Christopher Miller','Jake Szymanski','Jay Karas','Troy Miller','Peter Lauer','Jorma Taccone','Julian Farino','Michael Engler','Tucker Gates','Akiva Schaffer','Michael Spiller','Bruce McCulloch','Maggie Carey','Jaffar Mahmood','Daniel J. Goor','Michael Schur','Tim Kirkby','Jamie Babbit','Phil Traill','Michael Blieden',"Trent O'Donnell",'Kat Coiro','Luke Del Tredici','Alex Reid','Giovani Lampassi','Cortney Carrillo','Jennifer Arnold','Phil Augusta Jackson','Stephanie Beatriz','Rebecca Addelman','Joe Lo Truglio','Melissa Fumero','Kim O. Nguyen','Kevin Bray','Daniella Eisman','Gail Mancuso','Thembi Banks','Matthew Nodella'],
actors:['Andy Samberg','Stephanie Beatriz','Terry Crews','Joe Lo Truglio','Melissa Fumero','Andre Braugher','Andrey Ivchenko','Dirk Blocker','Joel McKinnon Miller','Adam Sandler','Kid Cudi','Marilu Henner','Patton Oswalt','Fred Armisen','Dean Winters','Mike Hagerty','Stacy Keach','Craig Robinson','Matt Walsh','Andy Richter','Nate Torrence','John Ross Bowie','Merrin Dungey','Anthony Azizi','Joey Diaz','Kevin Bigley','Amanda Lund','Isabella Day','Chelsea Peretti','Daniel Moncada','Exie Booker','Mary Elizabeth Ellis','Frank Cappello','Houston Rhines','Brian Huskey','Beth Dover','Kyra Sedgwick','Andy Kreiss','Jerry Lambert','Bruno Amato','S.E. Perry','Eva Longoria','Pete Davidson','August Roads','Mariano Mendoza','Nick Gracer','David Grant Wright','Doug Simpson','Jamie Denbo','Ron Gilbert','Heather Olt','Michael James Bell','Harvey J. Alperin','Mo Gaffney','Jerome Ro Brooks',"John O'Leary",'Andrew Patrick Ralston','Catherine Carlen','Jason Mantzoukas','Marcus D. Spencer','James Morrison','Artemis Pebdani','Rolando Boyce','Allan Graf','Ric Sarabia','Rhea Perlman','Maya Rudolph','Jorma Taccone','Ken Marino','Jim O’Heir','Eric Roberts','Zooey Deschanel','Emily Spivey','Rob Kerkovich','Nick Nicotera','Jamal Duff','Allen Evangelista','Matthew Willig','Danny Belrose','Nicole Pulliam','Sean Whalen','Kyle Bornheimer','Richard Burch','Tiffany Martin','Amy Okuda','Niecy Nash','Fred Melamed','Theodore Barnes','Bill Hader','Archie Panjabi','Jon Daly','Mary Lynn Rajskub','James Urbaniak','Gabe Liedman','Nick Cannon','Matt Lasky','Robin Bartlett','Nick Offerman','Tom Proctor','Anders Holm'],
screenplay:['Gabe Liedman','Luke Del Tredici','Daniel J. Goor','Michael Schur','Andy Bobrow','Andrew Guest','Prentice Penny','Phil Augusta Jackson','Matt Murray','Matt Lawton','Carol Kolb','Van Robichaux','Evan Susser','Lang Fisher','Norm Hiscock','Gil Ozeri','David Phillips','Brigitte Liebowitz','Jess Dweck','Kylie Condon','Laura McCreary','Dewayne Perkins','Lamar Woods','Paul Welsh','Nick Perdue','Stephanie Amante-Ritter','Beau Rawlins','Justin Noble','Vanessa Ramos','April Quioh','Brian Reich','Neil Campbell'],
production:['Andy Samberg','Phil Augusta Jackson','Matt Lawton','David Phillips','Sierra Teller Ornelas','Justin Noble','Matthew Nodella','Vanessa Ramos','Brian Reich','Neil Campbell'],
music:['Dan Marocco'],
camera:['Giovani Lampassi','Barry Peterson','Rick Page'],
cut:['Cortney Carrillo','Sandra Montiel','Jeremy Reuben','Jason Gill'],
sound:['John W. Cook II','Andrew Garrett Lange','Robert Carr','Todd Morrissey','Ross Davis','Frank A. Montaño','William Freesh','Larry Mann','Kenneth Kobett','Alan Decker','Penny Harold','Jared Marshack'],
scenography:['Ian Phillips','Sharon Busse','Elizabeth Thinnes','Val Wilt','Walter Eckert','Jill Sprayregen Henkel','Ellen Totleben'],
masks:['Nanette Moore','Rebecca DeHerrera','Dennis Parker','Shana Fruman','Samantha Wen','Annie Maniscalco','David Fields','Anthony Miner'],
costumes:['Kirston Leigh Mann','Alexis Jacks']},
{title:'North & South',
titleCZ:'Láska v bílém pekle',
year:2004,
runtime:240,
episodeRuntime:60,
countries:['UK'],
genres:['Drama','Romance'],
director:['Brian Percival'],
actors:['Daniela Denby-Ashe','Tim Pigott-Smith','Brendan Coyle','Richard Armitage','Lesley Manville','Rupert Evans','Sinéad Cusack','Lucy Brown','Anna Maxwell Martin','John Light','William Houston','Ben Crompton','Pauline Quirke','Jonathan Magnanti','Martin Walsh','Sam Chapman','Jo Joyner','Travis Oliver','David Crellin','Jane Booker','Brian Protheroe','Karl Haynes','Marc Finn','Kay Lyon','Russell Mabey'],
basedOn:['Elizabeth Gaskell'],
music:['Martin Phipps'],
camera:['Peter Greenhalgh'],
cut:['Kristina Hetherington'],
sound:['Ian Morgan'],
scenography:['Simon Elliott'],
costumes:["Mike O'Neill"]},
{title:'Derek',
titleCZ:'Derek',
year:2013,
runtime:'5h 23min',
episodeRuntime:'22-47min',
countries:['UK'],
genres:['Comedy','Drama'],
director:['Ricky Gervais'],
actors:['Ricky Gervais','Kerry Godliman','David Earl','Tim Barlow','Arthur Nightingale','Margaret Towner','Ninette Finch','Barry Martin','Brett Goldstein','Holli Dempsey','Karl Pilkington','Laura June Hudson','Colin Hoult','Tony Rohr','Vicky Hall','Joe Wilkinson','Ben Bailey Smith','Robert Vahey','Susannah Wise','Joan Linder','Tom Basden','Tom Hughes','Sophie Fletcher','Teresa Churcher','Tony Way','Ashley McGuire','Ruth Bratt'],
screenplay:['Ricky Gervais'],
production:['Charlie Hanson'],
music:['Anne Chmelewsky'],
camera:['Martin Hawkins'],
cut:['Valerio Bonelli'],
scenography:['Anna Higginson','Dennis De Groot'],
masks:['Lucy Sibbick'],
costumes:['Amanda Monk']},
{title:'24: Live Another Day',
titleCZ:'24 hodin: Dnes neumírej',
year:2014,
runtime:540,
episodeRuntime:45,
countries:['USA'],
genres:['Action','Crime','Drama','Mystery','Thriller'],
director:['Jon Cassar','Milan Cheylov','Adam Kane','Omar Madha'],
actors:['Kiefer Sutherland','Mary Lynn Rajskub','Kim Raver','William Devane','Giles Matthey','Gbenga Akinnagbe','Benjamin Bratt','Yvonne Strahovski','Tate Donovan','Michelle Fairley','Stephen Fry','Colin Salmon','Miranda Raison','Michael Wincott','Emily Berrington','Sean Knopp','Jd Roth-round','Kevin McNally','David Avery','Ross McCall','Raed Abbas','Julian Kostov','Leila Wong','Joseph Millson','Tzi Ma','Charles Furness','Jennifer Armour','Aaron McCusker','Stanley Townsend','David Bark-Jones','Sacha Dhawan','Tehmina Sunny','Fraser James','Liam Garrigan','Muzz Khan','Lasco Atkins','Adam Prickett','Jozef Aoki','Alexandra Doyle','Christina Chong','Branko Tomović','Martyn Mayger','Nigel Whitmey','John Boyega','Tamer Hassan','Miroslav Zaruba','Corey Johnson','Attila G. Kerekes','Martin McDougall','James Allenby-Kirk','Alex Lanipekun','David Yip','Richard Banks','Denis Lill','Christopher Hatherall','Mick Slaney','Arkie Reece','Rhashan Stone','Mandeep Dhillon','Duncan Pow','Jace Desay','Alec Newman','Aksel Hennie','Adam Sinclair','Shelley Conn','Joel Surnow','Tony Basgallop','Mark Dexter','Philip Winchester','William Ellis','Alexis Rodney','Graham Curry','Ronan Summers','Tobias James-Samuels','Alex Ferns','Nicholas Khan','Kola Krauze','Daniel Hill','Pamela Betsy Cooper','Jon Wennington','Kevin Shen','Dan Li','Abubakar Salim','Ingo Raudkivi','Alison Pargeter','Greg Canestrari','Tom Christian','Matt Rentell','Tim Seyfert'],
screenplay:['Joel Surnow','Manny Coto','Evan Katz','David Fury','Tony Basgallop','Patrick Harbinson','Sang Kyu Kim','Robert Cochran'],
production:['Iain Smith'],
music:['Sean Callery'],
camera:['Jeffrey C. Mygatt'],
cut:['Casey O. Rohrs','Scott Powell','Jordan Goldman','Joe Hobeck'],
sound:['Joe DeAngelis','Todd Morrissey','Mark D. Fleming','William Freesh','Kenneth Kobett'],
scenography:['Jonathan Lee'],
costumes:['Sarah Arthur']},
{title:'Made in Abyss',
titleCZ:'Made in Abyss',
year:2017,
runtime:'10h 48min',
episodeRuntime:'24-48min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy','Psychology'],
director:['Masajuki Kodžima','Šinja Iino','Hitoši Haga','Seung Hui Son','Motoki Nakaniši'],
actors:['Marija Ise','Miju Tomita','Aki Tojosaki','Maaja Sakamoto','Mucumi Tamura','Šiori Izawa','Jóko Sómi','Mijuki Kobori','Taiši Murata','Masaja Fukuniši','Júki Šin','Takajuki Nakacukasa','Manami Numakura','Tecu Inada','Hitomi Nabatame','Hiroki Macukawa','Čafúrin','Eri Kitamura','Sajaka Óhara','Tošijuki Morikawa','Arisa Maesako','Šindži Kawada','Nacuki','Nacuko Hara','Kaori Motojama','Manami Hanawa','Masaaki Ihara','Rina Hidaka','Jošimicu Šimojama','Nodoka Hasegawa','Akinobu Imai','Daiči Nitta','Sena Šódži','Maaja Sakamoto','Micuki Saiga','Misaki Kuno','Rjóta Takeuči','Kana Ičinose','Hiroki Gotó','Kimiko Saitó','Inori Minase','Juka Terasaki','Hiroaki Hirata','Honami Obata','Hikaru Tanaka','Saja Hirose','Hikaru Ikuta','Misano Sakai','Risa Watanabe','Genta Nakamura','Ai Kaneta','Tomohiro Jamaguči','Majumi Cukišima','Šúičiró Umeda','Akihiro Tadžima','Júsuke Sasaki','Jódži Ueda','Akane Misaka','Masato Niwa','Taiči Takeda','Júdži Murai','Takaaki Torašima','Šinnosuke Musaši','Miho Tabata','Kjósuke Nitta','Kaori Išihara','Hana Šimano','Jasuhiro Kikuči',"Šin'ja Takahaši",'Jóhei Namekawa','Tomoja Macubara'],
basedOn:['Akihito Cukuši'],
screenplay:['Hidejuki Kurata','Keigo Kojanagi'],
production:['Noritomo Isogai','Takajuki Takagi'],
music:['Kevin Penkin'],
camera:['Cunetaka Ema'],
cut:['Masayuki Kurosawa'],
sound:['Haru Jamada'],
scenography:['Osamu Masujama','Teru Sekiguči']},
{title:'Yaya and Paya',
titleCZ:'Jája a Pája',
year:1986,
runtime:'4h 5min',
episodeRuntime:'9-10min',
countries:['Czechoslovakia'],
genres:['Animation','Puppets','Comedy','Family'],
director:['Břetislav Pojar','Lubomír Beneš','František Váša'],
actors:['František Filipovský','Petr Haničinec','Václav Postránecký'],
screenplay:['Stanislav Havelka','Petr Chvojka','Lubomír Beneš','Marek Beneš'],
music:['Petr Skoumal'],
camera:['Jan Müller','Ivan Vít'],
cut:['Helena Lebdušková','Jan Sládek','Věra Benešová'],
sound:['Benjamin Astrug','Ivo Špalj']},
{title:'Legend of the Galactic Heroes',
titleCZ:'Ginga eijú densecu',
year:1988,
runtime:'47h 40min',
episodeRuntime:'26min',
countries:['Japan'],
genres:['Animation','Drama','Sci-Fi','War'],
director:['Noboru Išiguro','Masatoši Tahara','Akio Sakai','Keitaró Motonaga','Keniči Maedžima','Tošija Šinohara','Jasunori Urata','Micutaka Nošitani','Tošikacu Tokoro','Kunitoši Okadžima','Jasuo Iwamoto','Kacuhisa Jamada','Hiroši Fukutomi','Kazuo Tomizawa','Fumihiro Ueno','Seidži Okuda','Satoru Namekawa','Hideki Tonokacu','Tecu Kimura','Kazunori Tanahaši','Cuneo Tominaga',"Šin'ičiró Kimura",'Takaši Watanabe','Jasuhiro Macumura','Masato Kitagawa','Kazu Jokota','Mihiro Jamaguči','Jasuhiro Kuroda',"Ken'iči Imaizumi",'Keizó Šimizu','Šigeru Kimija','Kacuma Kanazawa','Tošimasa Suzuki','Akira Mano','Tomomasa Jamazaki','Šigeru Jamazaki','Makoto Nagao','Takaši Asami',"Šin'ja Hanai",'Šigeru Jazaki','Tomokazu Kógo','Tacuja Okamoto'],
actors:['Júsaku Jara','Kaneto Šiozawa','Keiiči Noda','Kotono Micuiši','Norio Wakamoto','Nozomu Sasaki','Šúiči Ikeda','Akio Ócuka','Hidejuki Tanaka','Hirotaka Suzuoki','Ičiró Nagai','Iemasa Kajumi','Džúróta Kosugi',"Ken'iči Ogata",'Kóiči Jamadera','Mami Kojama','Mika Doi','Šigeru Čiba','Šózó Iizuka','Takeši Aono','Tamio Óki','Teššó Genda','Tošihiko Seki','Unšó Išizuka','Kan Tokumaru','Issei Futamata','Čikao Ócuka','Čafúrin','Hiroko Emori','Takeši Kusao','Hidejuki Hori','Taró Arakawa','Hiroši Naka','Šinpači Cudži','Juriko Jamamoto','Miki Narahaši','Džódži Nakata','Nobutoši Kanna','Fumihiko Tačiki','Kósuke Meguro','Kišó Tanijama','Hiroši Janaka','Sóičiró Hoši','Júdži Micuja','Naoki Tacuta','Tošiko Fudžita','Mičie Tomizawa','Kóiči Kitamura','Daisuke Góri','Kódži Totani','Jasunori Masutani','Šó Hajami','Osamu Saka','Kazuhiko Inoue','Masato Hirano','Bandžó Ginga','Jasunori Macumoto','Nobuo Tobita','Kózó Šioja','Takaši Nagasako','Eidži Janagisawa','Šunsuke Šima','Hirohiko Kakegawa','Takumi Jamazaki','Tomohiro Cuboi','Naoki Makišima','Nobujuki Hijama','Ako Majama','Rjó Kamon','Emi Motoi','Masaši Hirose','Júsuke Numata','Jósuke Akimoto','Hideki Ogihara','Masaki Aizawa','Osamu Kobajaši','Kijoši Kobajaši','Hiroja Išimaru','Jošiko Sakakibara','Čó','Noriko Hidaka','Tecuo Sakaguči','Masaši Ebara','Rjóiči Tanaka','Tomoko Kawakami','Takaja Haši',"Mari Joko'o",'Sakiko Tamagawa','Kacuhisa Hóki','Rjúsei Nakao','Šótaró Morikubo','Hóčú Ócuka',"Ken'jú Horiuči",'Seiko Tomoe','Rihoko Jošida','Kósei Tomita','Kazuhiko Kišino','Ginzó Macuo','Kijojuki Janada','Kazuhiro Nakata'],
basedOn:['Jošiki Tanaka'],
screenplay:['Kawanaka Šimao','Šigeru Janagawa','Hiroši Toda','Akinori Endó','Takeši Šudó','Júho Hanazono','Hiroši Konišikawa'],
production:['Masatoši Tahara','Akiko Odawara'],
music:['Šinsuke Kazato'],
camera:["Kin'iči Išikawa",'Hideo Okazaki','Masaaki Fudžita'],
cut:['Harutoši Ogata','Kazuo Inoue','Nobujuki Kunijoši','Osamu Suda','Sačiko Miki','Satoši Terauči','Jukiko Nodžiri','Júko Watase'],
sound:['Susumu Aketagawa'],
scenography:['Hidetoši Kaneko','Hitoši Nagao','Jasujuki Čiba','Takeši Waki','Júdži Ikeda','Júko Tahara','Tadami Šimokawa','Kazuko Kacui','Kazušige Takató','Kikuko Tada','Šigenori Takada','Takeo Jamamoto','Tošikacu Sanuki','Teiiči Akaši']},
{title:'And Then There Were None',
titleCZ:'Až tam nezbyl žádný',
year:2015,
runtime:180,
episodeRuntime:60,
countries:['UK'],
genres:['Mystery','Crime','Drama'],
director:['Craig Viveiros','Basi Akpabio','Rebecca Keane'],
actors:['Douglas Booth','Charles Dance','Maeve Dermody','Burn Gorman','Anna Maxwell Martin','Sam Neill','Miranda Richardson','Toby Stephens','Noah Taylor','Aidan Turner','Harley Gallacher','Paul Chahidi','Charlie Russell','Richard Hansell','Tom Clegg','Rob Heaps','Catherine Bailey','Christopher Hatherall','Miranda Richardson','Daisy Waterstone'],
basedOn:['Agatha Christie'],
screenplay:['Sarah Phelps'],
production:['Abi Bach'],
music:['Stuart Earl'],
camera:['John Pardue'],
cut:['Sam White','Mike Phillips'],
sound:['Blair Jollands','Gareth Bull'],
scenography:['Sophie Becher'],
masks:['Marella Shearer'],
costumes:['Lindsay Pugh']},
{title:'Hellsing',
titleCZ:'Hellsing',
year:2001,
runtime:'5h 25min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Action','Drama','Horror'],
director:['Umanosuke Iida','Jasunori Urata','Kaoru Suzuki','Akihiko Nišijama','Tomio Jamauči',"Šin'ja Hanai",'Rjóki Kamicubo'],
actors:['Džódži Nakata','Fumiko Orikasa','Jošiko Sakakibara','Hidejuki Tanaka','Unšó Išizuka','Akeno Watanabe','Kazuja Nakai','Ken Narita','Mika Doi','Norio Wakamoto','Takehito Kojasu','Wataru Takagi','Čikao Ócuka','Takumi Jamazaki','Nači Nozawa','Kunihiko Jasui','Akiko Hiramacu','Motomu Kijokawa','Kaori Mizuhaši','Takajasu Usui','Jošijuki Kaneko','Macuo Macuo','Otoja Kawano','Masato Funaki','Hisanori Kojacu','Kacuhiro Kitagawa','Minako Ičiki','Takaši Taniguči','Masaru Motegi','Tadasuke Ómizu','Hidetoši Itó','Šizuka Arai','Minako Moto','Aki Daitó','Ajako Kurosaki','Tadaši Wakabajaši'],
basedOn:['Kóta Hirano'],
screenplay:['Čiaki Konaka','Júdži Hosono'],
music:['Jasuši Išii'],
camera:['Acuši Takejama'],
cut:['Kengo Šigemura'],
sound:['Jóta Curuoka'],
scenography:['Šindži Katahira']},
{title:'Warrior',
titleCZ:'Bojovník',
year:2019,
runtime:'27h 20min',
episodeRuntime:'44-65min',
countries:['USA'],
genres:['Action','Drama','History'],
director:['Loni Peristere','Lin Oeding','Assaf Bernstein','David Petrarca','Kevin Tancharoen','Jonathan Tropper','Dustin Nguyen','Omar Madha','Dennie Gordon','Nima Nourizadeh','Dinh Thai','Brett Chan'],
actors:['Jason Tobin','Andrew Koji','Olivia Cheng','Kieran Bew','Dianne Doan','Dean Jagger','Langley Kirkwood','Rich Ting','Kenneth Fok','Dustin Nguyen','Joanna Vanderham','Joe Taslim','Hoon Lee','Tom Weston-Jones','Christian McKay','Robert Hobbs','Perry Yung','Henry Yuk','Graham Hopkins','Warrick Grier','Steve Park','Ron Smerczak','Hon Ping Tang','Benike Palfi','Bianca Amato','C.S. Lee','Patrick Baladi','Steve Wall','Yu Beng Lim','Frank Rautenbach','Russell Yuen','Orion Lee','Rachel Colwell','Damon Berry','Ryan Kruger','Nicole Law','Celine Buckens','Miranda Raison','Maria-Elena Laas','Craig Gardner','Mark Elderkin','Kelsey Egan','Emmanuel Castis','Michael Bisping','María Elisa Camargo','Christos Vasilopoulos','Jason William Day','Brad Kelly','Aubrey Shelton','Pierre Malherbe','David Dukas','Trevor Frost','Esteban Cueto','Deon Lotz','Erica Wessels','Ashley Dowds','Riaz Solker','Ash Lee','Mark Dacascos','Chelsea Muirhead','Adam Rayner','Morne Visser','Matthew Vey','Neels Clasen','Colin Moss','Kevin Otto','Jason Wong','Jason Li','Kieran Tamondong','Paul Chan'],
screenplay:['Evan Endicott','Josh Stoddard','Jonathan Tropper','Adam Targum','Kenneth Lin','Lillian Yu','Glenise Mullins','Brad Kane','Hoon Lee'],
production:['Lori Jo Nemhauser','Jonathan Tropper','Glenise Mullins'],
music:['Reza Safinia','H. Scott Salinas'],
camera:['Ed Wild','Michael Snyman','Giulio Biccari','Trevor Michael Brown'],
cut:['Andy Keir','Thomas J. Nordberg','Anthony Muzzatti','Tessa Verfuss','Aaron Yanes'],
sound:['Robert Fernandez'],
scenography:['Andrew Laws','James Foster'],
masks:['Lian van Wyk','Joeke Bonthuys','Fumana Anelisa'],
costumes:['Diana Cilliers','Moira Anne Meyer']},
{title:'The Office',
titleCZ:'Kancl',
year:2001,
runtime:'7h 24min',
episodeRuntime:'29-52min',
countries:['UK'],
genres:['Comedy','Drama'],
director:['Ricky Gervais','Stephen Merchant'],
actors:['Ricky Gervais','Martin Freeman','Mackenzie Crook','Lucy Davis','Ewen MacIntosh','Ben Bradshaw','Jamie Deeks','Jane Lucas','Emma Manton','Alexander Perkins','Patrick Baladi','Philip Pickard','Julie Fernandez','Rachel Isaac','Howard Saddler','Stephen Merchant','Matthew Holness','Ash Varrez','Olivia Colman','Julia Davis','Paul Sharma','Tom Goodman-Hill','David Schaal','Sandy McDade','Ben Forster','Oliver Chris','Jennifer Hennessy','Alyssa Preston','Vincent Franklin','Joel Beckett','Ralph Ineson','Kellie Shirley','Dan Renton Skinner','Peter Purves','Martha Howe-Douglas','Gareth Tunley','Bruce Mackinnon','Stirling Gallacher','Stacey Roca','Robin Hooper','Angela Clerkin','Patrick Driver','Tony MacMurray','Sally Bretton','Neil Fitzmaurice','Elizabeth Berrington','Ché Walker','Joann Condon','Richard Cotton','Rebecca Charles','Hugh Parker','Mike Jerome Putnam','Peter Heppelthwaite'],
screenplay:['Ricky Gervais','Stephen Merchant'],
camera:['Andy Hollis'],
sound:['Mark Found'],
masks:['Val Akrill']},
{title:'The Wonder Years',
titleCZ:'Báječná léta',
year:1988,
runtime:'42h 10min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Drama','Family','Comedy'],
director:['Greg Beeman','Richard Masur','Michael Dinner','Neal Israel','Tom Moore','Bryan Gordon','Jim McBride','Thomas Schlamme','Matia Karrell','Jeffrey D. Brown','Nick Marck','Andy Tennant','Daniel Stern','Steve Miner','Peter Horton','Dan Lauria','Arlene Sanford','Stephen Cragg','Lyndall Hobbs','Peter Baldwin','Arthur Albert','Bethany Rooney','Peter Werner','David Greenwalt','Ken Topolsky','Nancy Cooperstein','Carol Black','Neal Marlens','Rob Thompson','Art Wolff'],
actors:['Fred Savage','Dan Lauria','Alley Mills','Jason Hervey','Danica McKellar','Josh Saviano',"Olivia d'Abo",'Daniel Stern','Michael Landes','Juliette Lewis','David Schwimmer','Giovanni Ribisi','Robert Picardo','Ben Stein','Wendel Meldrum','Jay Lambert','Arye Gross','Michael Paul Chan','Bentley Mitchum','Scott Menville','Lindsay Sloane','Eric Dane','Tom Wood','Chad Allen','Pat Crawford Brown','Richard Fancy','Paula Marshall','Joshua John Miller','Michael Bacall','Aimee Graham','Willie C. Carpenter','Jonathan Brandis','Michael Manasseri','Jack McGee','Seth Green','Earl Boen','Don Perry','Meredith Scott Lynn','Wendy Cox','Mike Hagerty','Victor Raider-Wexler','Gerry Bednob','A. J. Langer','Douglas Emerson','Lorna Scott','Cristine Rose','Lance Guest','Renée Humphrey','Brice Beckham','Mars Callahan','Salome Jens','Gary Carlos Cervantes','Angela Paton','Katie Wright','Raye Birk','Bobbie Eakes','Ford Austin','Nicolas Read','Denis Arndt','Scott Jaeck','Vanessa Brown','Brandon Crane','Hoke Howell','Charles Tyner','Hunter Bodine','Ryan Francis','Candice Azzara','Kelly Packard','Robin Thicke','Gerrit Graham','Dustin Diamond','David Huddleston','Michael Ensign','Tom McCleister','Marguerite Moreau','Alicia Silverstone','Brad Hunt','Lindsay Price','Alan Fudge','Sean Stanek','Macon McCalman','Dianne Hull','Paul B. Price','Ellen Albertini Dow','Bobby Jacoby','Billie Bird','Kimberley Kates','Loanne Bishop','Jane Dulo','Peter Spellos','Roy Brocksmith','Nancy Fish','Sara Melson','Andy Berman','William Bogert','Deborah Rose','Bette Ford','Arlen Dean Snyder','Chris Demetral','Eric Lloyd'],
screenplay:['Scott Frank','Jane Anderson','Debra Frank','Mark Levin','Jill Gordon','Michael J. Weithorn','David M. Stern','Kerry Ehrin','Ian Gurvitz','Todd W. Langen','David Greenwalt','Eric Gilliland','David Kohan','Frank Renzulli','Bob Brush','Jon Harmon Feldman','Mark B. Perry','Sy Dukane','Winnie Holzman','Bob Stevens','Carol Black','Neal Marlens','Matthew Carlson','Tom Gammill','Max Pross','Tammy Ader','Denise Moss','Craig Hoffman','Sivert Glarum','Robin Riordan','Sy Rosen'],
music:['W.G. Snuffy Walden','J. Peter Robinson','Joel McNeely','Stewart Levin'],
camera:['Newton Thomas Sigel','Russell Carpenter','Walt Lloyd','Tim Suhrstedt','Mac Ahlberg','Sandi Sissel','Rene Ohashi','Arthur Albert','Philip Holahan','James Jansen']},
{title:'Banshee',
titleCZ:'Banshee',
year:2013,
runtime:'32h 32min',
episodeRuntime:'44-60min',
countries:['USA'],
genres:['Crime','Drama','Action'],
director:['Greg Yaitanes','S.J. Clarkson','Miguel Sapochnik','Ole Christian Madsen','Dean White','Babak Najafi','Loni Peristere','Magnus Martens','Everardo Gout','Jonathan Tropper'],
actors:['Antony Starr','Ivana Milicevic','Ulrich Thomsen','Frankie Faison','Hoon Lee','Rus Blackwell','Lili Simmons','Matt Servitto','Trieste Kelly Dunn','Steve Coulter','Demetrius Grosse','Anthony Ruivivar','Claire Bronson','Ben Cross','Jeff Chase','Derek Cecil','Matt Lintz','Alpha Trivette','Odette Annable','Jim McKeny','Marcus Hester','Melissa Ponzio','Moniqua Plante','Željko Ivanek','Julian Sands','Peter Scanavino','Harrison Thomas','Conor Donovan','Amber Midthunder','Gil Birmingham','Geno Segers','Ólafur Darri Ólafsson','Andrew Howard','Griff Furst','Matthew Rauch','Joseph Sikora','Reg E. Cathey','Bryan Friday','Joseph Gatt','Tanya Clarke','Jesica Ahlberg','Tom McCleister','Maya Dunbar','Jerod Meagher','Miles Doleac','Surely Alvelo','Marisela Zumbado','Gabriel Suttle','Clark Sarullo','Langley Kirkwood','Chaske Spencer','Tom Pelphrey',"Denis O'Hare",'Shuler Hensley','Mark Ashworth','Jackson Beals','Afton Williamson','Meaghan Rath','Cherie Jimenez','Sam Medina','Raoul Max Trujillo','Chris Coy','Mauricio Ovalle','Lee Spencer','Eliza Dushku','Kerry Patton','Madeline Taylor','Abby Corrigan','Mark Falvo','Eric Rasmussen','Adam Minarovich','Jen Landon','Jim Keisler','Carlos Guerrero','Jack Erdie','Lyne Renee','Robert John Burke','J.D. Evermore','Michael Hamory','C.J. Perry','Chance Kelly','Owen Harn','Kelley Davis','Deja Dee','Brett Gentile','Peter Luis Zimmerman','Jennifer Griffin','Daniel Ross Owens','Christos Vasilopoulos','Russell Means','Michael Papajohn','John Cenatiempo','Quentin Kerr','Kristopher Kling','Kay Story','Toby Leonard Moore','Leslea Fisher','Wayne Pére','Leo Fitzpatrick','Dennis Keiffer'],
screenplay:['Jonathan Tropper','David Schickler','Adam Targum','Justin Britt-Gibson','Chris Kelley','Jennifer Ames','Steve Turner','John Romano','Doug Jung'],
production:['Stephanie Laing','Chad Feehan','Robert F. Phillips'],
music:['Methodic Doubt'],
camera:['Christopher Faloona'],
cut:['Glenn Garland','Miklos Wright',"Michael O'Halloran",'Donn Aron','Chris A. Peterson','Michael Ruscio','Carol Stutz','Amy M. Fleming','John M. Valerio'],
sound:['Joe DeAngelis','Elmo Ponsdomenech','William Freesh','Kenneth Kobett','Brad North','Nadia Paone'],
scenography:['Jonathan A. Carlson','Hilda Stark','Barbee S. Livingston'],
masks:['Jeff Goodwin','Erin Keith','Crystal M. Cook','Ozzy Alvarez','Patty Bell'],
costumes:['Patia Prouty']},
{title:'Ash vs Evil Dead',
titleCZ:'Ash vs Evil Dead',
year:2015,
runtime:'15h 13min',
episodeRuntime:'27-43min',
countries:['USA'],
genres:['Action','Comedy','Horror'],
director:['Sam Raimi','Rick Jacobson','Michael Hurst','M.J. Bassett','David Frazee','Tony Tilse','Mark Beesley','Daniel Nettheim','Andres Meza-Valdes','Diego Meza-Valdes','Regan Hall'],
actors:['Bruce Campbell','Ray Santiago','Dana DeLorenzo','Jill Marie Jones','Lucy Lawless','Samara Weaving','Hemky Madera','Peter Feeney','Damien Garvey','Indiana Evans','Mimi Rogers','Mark Mitchinson','Milo Cawthorne','David Frazee','Ellen Sandweiss','Lee Majors','Michelle Hurd','Stephen Lovatt','Tony Tilse','Ted Raimi','James Russell','Joel Tobeck','Nicholas Hope','Shareena Clanton','Andrew Grainger','Lindsay Farris','Katrina Hobbs','Ellie Gall','Jeffrey Thomas','Ben Fransham',"Arielle Carver-O'Neill",'Albertine Jonas','Ross Anderson','Samantha Young','Chelsie Preston Crayford','Emilia Burns','Colin Moy','Mikaela Rüegg','Jeff Szusterman','Danielle Cormack','Ido Drent','Pepi Sonuga','Sara West','Jessica Green','Robert Hartley','Jordan Mooney','Shoshana McCallum','Will Wallace','Bronwyn Bradley','Shara Connolly','Mike Edward','Olivia Mahood','Kelson Henderson','James Gaylyn','Paul Harrop','Stephen Ure','Sophia Johnson'],
screenplay:['Craig DiGregorio','James Eagan','Noelle Valdivia','William Bromell','Mark Verheiden','Sam Raimi','Ivan Raimi','Tom Spezialy','Rick Jacobson','Cameron Welsh','Luke Kalteux','Caitlin Meares','Suzanne Keilly','Lindsey Allen','Nicki Paluga','Steve Turner','Hank Chilton','Rob Fresco','Nate Crocker','Rob Wright','Dominic Dierkes','Sean Clements','Aaron Lam','Zoë Green'],
production:['Craig DiGregorio','Rick Jacobson','Sean Clements','Aaron Lam'],
music:['Joseph LoDuca'],
camera:['Dave Garbett','John Cavill','Kevin Riley','Andrew McGeorge'],
cut:['Bob Murawski','Allanah Bazzard','Tom Eagles','Gary Hunt','Jochen FitzHerbert'],
sound:['Marti D. Humphrey','Tony Johnson'],
scenography:['Nick Bassett'],
masks:['Hannah Wilson','Vanessa Hurley',"Jane O'Kane",'Rachel Johanson','Mitzi Doney','Tamara Eyre'],
costumes:['Barbara Darragh']},
{title:'Mad Men',
titleCZ:'Šílenci z Manhattanu',
year:2007,
runtime:'73h 4min',
episodeRuntime:'45-56min',
countries:['USA'],
genres:['Drama'],
director:['Tim Hunter','Andrew Bernstein','Paul Feig','Matthew Weiner','Michael Uppendahl','Phil Abraham','Chris Manley','Alan Taylor','Ed Bianchi','Lesli Linka Glatter','John Slattery','Jon Hamm','Jared Harris','Scott Hornbacher','Jennifer Getzinger','Daisy von Scherler Mayer','Barbet Schroeder','Lynn Shelton','Matt Shakman'],
actors:['Jon Hamm','Elisabeth Moss','Vincent Kartheiser','Christina Hendricks','John Slattery','January Jones','Rosemarie DeWitt','Paul Schulze','Julie McNiven','Kiernan Shipka','Peyton List','Audrey Wasilewski','Patrick Fischler','Andy Umberger','Rebecca Creskoff','Brian Klugman','Darby Stanchfield','Maggie Siff','Katherine Boecher','Kristoffer Polaha','Anne Dudek','Nathan Anderson','Kristen Schaal','Randy Oglesby','Melinda Page Hamilton','Kevin Rahm','Charles Shaughnessy','Brian Krause','Emilio Roso','Seamus Dever','John Walcutt','Jeffrey Nordling','Mark Moses','Amy Landecker','Laura Ramsey','Aloma Wright','Embeth Davidtz','Carla Gallo','Abigail Spencer','Elizabeth Rice','Adam Kaufman','Sam Page','Ryan McPartlin','David Bowe','Blake Bashoff','Sarah Drew','Tess Parker','Melinda McGraw','Jared Harris','Kate Connor','Marshall Allman','Alison Brie','Crista Flanagan','Jamie Elman','Colin Hanks','Robert Morse','Anna Camp','Gareth Williams','Kate Norby','Talia Balsam','Miles Fisher','Amy Sloan','Cameron Goodman','Ryan Cartwright','Jay Paulson','Rich Sommer','Gabriel Mann','Aaron Staton','John Aniston','Denise Crosby','Jud Tylor','Caity Lotz','Nat Faxon','Ian Bohen','Gerald Downey','Jade Ramsey','Joel Murray','Sewell Whitney','Alexis Bledel','Kate McNeil','Amy Motta','Zosia Mamet','John Patrick Jordan','David Warshofsky','James DuMont','Jamie Thomas King','Jared Gilmore','Peter Jason','La Monde Byrd','Nina Rausch','Sadie Alexandru','Nora Zehetner','Megan Duffy','Mark Metcalf','Johanna Roxanne','Randee Heller','Rachel Oliva','Jennifer Siebel Newsom','Chris McGarry','Hrach Titizian'],
screenplay:['Rick Cleveland','Marti Noxon','Jane Anderson','Brett Johnson','Matthew Weiner','Lisa Albert','André Jacquemetton','Maria Jacquemetton','Tom Palmer','Bridget Bedard','Chris Provenzano','Robin Veith','Kater Gordon','Cathryn Humphris','Dahvi Waller','Andrew Colville','Erin Levy','Tracy McMillan','Jonathan Abrahams','Keith Huff','Janet Leahy','Jonathan Igla','Victor Levin','Frank Pierson','Semi Chellas','Tom Smuts','Jason Grote','Carly Wray','Heather Jeng Bladt','David Iserson'],
production:['Scott Hornbacher','Jack Lechner','Todd London','Greg Schultz','Lisa Albert','Blake McCormick','Dahvi Waller','Dwayne L. Shattuck','Erin Levy','Jonathan Abrahams','Jon Hamm','Tom Smuts','Robert Towne'],
music:['David Carbonara','Joaquín Rodrigo'],
camera:['Frank G. DeMarco','Phil Abraham','Jeffrey Jur','Steve Mason','Chris Manley','Bill Roe','Don Devine','M. David Mullen'],
cut:['Tom Wilson','Cindy Mollo','Malcolm Jamieson','David Siegel','Conrad Smart','Chris Figler','Leo Trombetta','Christopher Nelson','Christopher Gay','Pattye Rogers'],
sound:['Lisle Engle','Ken Teaney','Alec St. John','Jim Fitzpatrick','Cormac Funge','Jason George','Brian Miksis','Todd Orr','Peter Bentley'],
scenography:['Dan Bishop','Bob Shaw','Christopher Brown','Rena DeAngelo','Claudette Didul','Amy Wells'],
masks:['David Danon','Valerie Jackson','Kymber Blake','Kenny Niederbaumer','Vasilios Tanis','Tifanie White','Rebecca DeHerrera','Ruth Haney','Loretta Nero','Kathrine Gordon','Maurine Burke','Marilyn Patricia Phillips','Christopher Allen Nelson','Denise Dellavalle','Sean Flanigan','Brigette A. Myre'],
costumes:['John Dunn','Janie Bryant']},
{title:'Samurai Champloo',
titleCZ:'Samurai Champloo',
year:2004,
runtime:'9h 58min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Action','Drama','Comedy'],
director:['Mamoru Hosoda',"Šin'ičiró Watanabe",'Kazuto Nakazawa','Sajo Jamamoto','Kei Cunemacu','Hirotaka Endó','Masato Mijoši','Akira Jošimura','Šintaró Inokawa'],
actors:['Kazuja Nakai','Ajako Kawasumi','Ai Maeda','Akio Ócuka','Hiroši Ótake','Ičiró Nagai','Iššin Čiba','Džúróta Kosugi','Ken Narita','Kóiči Jamadera','Norio Wakamoto','Nozomu Sasaki',"Šin'ičiró Miki",'Šózó Iizuka','Takehito Kojasu','Tošihiko Seki','Unšó Išizuka','Džun Fukujama','Hitomi Nabatame','Tarusuke Šingaki','Nobutoši Kanna','Ikuo Nišikawa','Šóto Kašii','Kazunari Tanaka','Keiiči Nanba','Jošiko Kamei','Reiko Kiuči','Hiroši Naka','Masahito Jabe','Hiro Šimono','Džódži Nakata','Fumihiko Tačiki','Daisuke Góri','Šóko Cuda','Kódži Totani','Šó Hajami','Maria Kawamura','Kacujuki Koniši','Naoki Makišima','Megumi Tojoguči','Kódži Nakata','Noriko Hidaka','Sakiko Tamagawa','Kacuhisa Hóki','Šótaró Morikubo','Hóčú Ócuka','Kijojuki Janada','Takajuki Sugó',"Masa'aki Cukada",'Tomohisa Asó','Makio Inoue','Tomomiči Nišimura','Sajuri','Hiromi Curu','Šin Aomori','Takaši Kondó','Seidži Sasaki','Masakazu Kohara','Rintaró Niši','Masaharu Sató','Tošio Furukawa','Júto Kazama','Rjúzaburó Ótomo','Hisao Egawa','Šigeru Šibuja','Hiroši Širokuma','Takeši Watabe','Ikudži Nose','Takuma Suzuki','Šunsuke Sakuja','Nobuhiko Kazama',"Šin'iči Jamada",'Takuo Kawamura','Masaaki Ókura','Jorie Terauči','Jošinori Sonobe','Satoši Katógi','Masao Harada','Otoja Kawano','Ginpei Sató','Masako Kacuki','Takaja Haši','Takehiro Murozono','Cuguo Mogami','Hidekacu Šibata','Tecu Inada','Rjúzó Hasuike','Tecuo Sakaguči','Kei Kurita','Megumi Macumoto','Juzuru Fudžimoto','Kae Araki','Motomu Kijokawa','Osmau Rjútani','Masato Funaki','Majumi Jamaguči','Sajuri Kubo','Eidži Marujama','Bon Išihara','Rjúgo Saitó'],
screenplay:["Šin'ičiró Watanabe",'Šindži Obara','Dai Saitó','Seiko Takagi','Tóko Mačida','Keiko Nobumoto'],
production:['Takaši Kóčijama','Takatoši Hamano'],
music:['Cutčie','Fat Jon','Force of Nature','Nujabes'],
camera:['Kazuhiro Jamada'],
cut:['Šúiči Kakesu'],
scenography:['Takeši Waki']},
{title:'Mushishi: The Next Chapter',
titleCZ:'Mušiši zoku šó',
year:2014,
runtime:'8h 20min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy','Mystery'],
director:['Hiroši Nagahama','Kóičiró Sótome','Rjó Mijata','Jasuhiro Geši'],
actors:['Mika Doi','Júto Nakano','Ai Kobajaši','Júdži Ueda','Mijuki Sawaširo','Kóki Učijama','Hiroši Naka','Masahito Jabe','Satoši Mikami','Jóko Hikasa','Ami Košimizu','Sumi Šimamoto',"Šin'ja Hamazoe",'Júsaku Jara','Daisuke Kišio','Čó','Rjúsei Nakao','Micuru Mijamoto','Reiko Suzuki','Kjóko Čikiri','Hiroši Šimozaki','Tomomiči Nišimura','Jošiko Iseki','Sajaka Aida','Hisako Kjóda','Maju Iino','Kanehira Jamamoto','Tošio Furukawa','Mičio Hazama','Kokoro Kikuči','Júto Uemura','Jui Išikawa','Hiroši Iwasaki','Daiki Hamano','Haruka Širaiši','Fumiko Orikasa','Megumi Han','Naomi Marujama','Hiromi Konno','Otoja Kawano','Sumi Mutó','Tomisaburó Horikoši','Kódži Očiai','Subaru Tógó','Kazumasa Takemoto','Rjóta Akazawa','Makoto Arikawa','Rina Endó','Iku Minase',"Aju Macu'ura",'Juki Kurimoto','Masumi Taira','Hiroši Takahaši','Hiroši Sumino','Jošimi Komijama','Šino Kakinuma','Taja Fudžimori',"Šin'ičiró Ueda",'Umedži Sasaki','Tacu Kaneko','Kaori Fukumori','Šó Ueno','Naoko Širakami','Mariko Šimura','Majumi Cučija','Sajaka Kobajaši','Kazuja Hasegawa','Acuši Sekiguči','Akiko Muta','Júki Kanno'],
basedOn:['Juki Urušibara'],
screenplay:['Hiroši Nagahama'],
music:['Tošio Masuda'],
camera:['Júta Nakamura'],
cut:['Masahiro Macumura'],
sound:['Kazuja Tanaka'],
scenography:['Takeši Waki']},
{title:'Vicious',
titleCZ:'Jízlivě tvůj',
year:2013,
runtime:'5h 46min',
episodeRuntime:'22-47min',
countries:['UK'],
genres:['Comedy'],
director:['Ed Bye','Ben Kellett'],
actors:['Ian McKellen','Derek Jacobi','Frances de la Tour','Iwan Rheon','Marcia Warren','Philip Voss','Deborah Rosan','Michael Cochrane','Georgina Beedle','James Greene','Sam Swann','Geoffrey McGivern','Joan Linder','Aysha Kala','Jack Ashton','Bohdan Poraj','Alexandra Roach','Georgia King','Christopher Villiers','Hazel Douglas','Samuel Barnett','Celia Imrie','Eileen Atkins','Luke Treadaway','Frances Barber','Philip Anthony','George Layton','Judi Dench','Katrina Durden','Jonathan Readwin','Richard Gadd','Alistair Brammer','Anthony Edridge'],
screenplay:['Gary Janetti'],
cut:['Chris Wadsworth'],
sound:['Stevie Haywood'],
scenography:['Harry Banks'],
masks:['Lucy Sibbick'],
costumes:['June Nevin']},
{title:'Oz',
titleCZ:'Oz',
year:1997,
runtime:'54h 37min',
episodeRuntime:'53-98min',
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Terry Kinney','Bob Balaban','Mary Harron','Adam Bernstein','Kenneth Fink','Alan Taylor','Barbara Kopple','Brian Cox','Roger Rees','Chazz Palminteri','Rob Morrow','Nick Gomez','Uli Edel','Matt Dillon','Jean de Segonzac','Steve Buscemi','Kathy Bates','Keith Samples','David Von Ancken','J. Miller Tobin','Gloria Muzio','Darnell Martin','Goran Gajič','Alex Zakrzewski','John Henry Davis','Marc Klasfeld','Leslie Libman','Daniel Loflin','Ted Bogosian'],
actors:['Ernie Hudson','J.K. Simmons','Lee Tergesen','Adewale Akinnuoye-Agbaje','Harold Perrineau','Terry Kinney','Dean Winters','George Morfogen','Rita Moreno','Eamonn Walker','Robert Clohessy','Kirk Acevedo','Scott William Winters','Luna Lauren Velez','Thomas G. Waites','Tom Mardirosian','Christopher Meloni','Annika Peterson','Željko Ivanek','David Zayas','R.E. Rodgers','BD Wong','Sandra Purpuro','J.D. Williams','Melina Kanakaredes','Mary Alice','Luke Perry','Luis Guzmán','Maury Chaykin','Edie Falco','Joel Grey','Jon Seda','Skipp Sudduth','Mark Margolis',"Milo O'Shea",'Tony Musante','Brian Bloom',"Brían F. O'Byrne",'John Lurie','Tom Atkins','Austin Pendleton','Jamie Tirelli','Leon','Edward Herrmann','Brian Tarantina','Bobby Cannavale','Larry Pine','Reg E. Cathey','Arija Bareikis','Lance Reddick','Rick Fox','Adrienne Shelly','Erik King','Paul Schulze','Michael Gaston','Oni Faida Lampley','Rosalyn Coleman','Katheryn Winnick','Method Man','Judy Reyes','Wood Harris','Elizabeth Rodriguez','Antoni Corone','Kathryn Erbe','Carlo Alban','Betty Buckley','Patrick Breen','Paula Garcés','Elaine Stritch','Robert Iler','Jamie Hector','Katie Finneran','Anne Meara','Kathryn Meisle','Philip Casnoff','Seth Gilliam','Eric Roberts','Frank Senger','Domenick Lombardozzi','Dylan Baker','Matthew Cowles','Raymond Anthony Thomas','Cyrus Farmer','Joyce Van Patten','John Doman','Peter Francis James','David Crane','Clarke Peters','Michael Rivera','Aasif Mandvi','Zakes Mokae','Roy Thinnes','Patti LuPone','Stephen Gevedon','Eartha Kitt','Ben Vereen','Michael Wright','Frederick Koehler','Alexander Emmert','Robert John Burke'],
screenplay:['Tom Fontana','Sean Whitesell','Sean Jablonski','Sunil Nayar'],
production:['Sean Whitesell','Jorge Zamacona'],
camera:['Glenn Kershaw','Jean de Segonzac'],
cut:['Jay Rabinowitz','Cindy Mollo','Ken Eluto','Sue Blainey','Deborah Moran','Vanessa Procopio'],
sound:['Tony Pipitone'],
scenography:['Gary Weist','Janet Shaw'],
masks:['Joe Cuervo'],
costumes:['Tina Nigro','Stephanie Maslansky','Lisa Padovani']},
{title:'Peep Show',
titleCZ:'Peep Show',
year:2003,
runtime:'22h 7min',
episodeRuntime:'23-27min',
countries:['UK'],
genres:['Comedy'],
director:['Becky Martin','Jeremy Wooding','Tristram Shapeero'],
actors:['David Mitchell','Robert Webb','Matt King','Olivia Colman','Paterson Joseph','Rachel Blanchard','Sophie Winkleman','Alex MacQueen','Katy Brand','Kevin Bishop','Cara Horgan','Daisy Haggard','Michele Austin','Stuart McQuarrie','Jack Doolan','Francis Magee','Sarah Hadland','Robert Cambrinus','Ellie Chidzey','Jonathan Aris','Tom Basden','Rosie Cavaliero','James Pusztay','Josef Altin','David Fynn','Tom Chadbon','James Holmes','Leanne Wilson','Stephen Beresford','Ingrid Oliver','Neil Edmond','Niky Wardley','Neil Fitzmaurice','Simon Lowe','Jenny Howe','Morgan Watkins','Mark Kempner','Gareth Tunley','Sarah Niles','Lasco Atkins','Jack Bence','Lynn Farleigh','Paul Warren','Yasmine Akram','Isy Suttie','Robert Harley','Agnieszka Liggett','Dylan Edwards','Liz May Brice','Daniel Ings','Catherine Shepherd','Tim Preece','Trevor Laird','Zac Fox','Huw Higginson','Geoffrey McGivern','Tessa Wyatt','Charlie Covell','Jim Howick','Robert Popper','Cariad Llyod','Michael Dempsey','Harmage Singh Kalirai','Franc Ashman','Susannah Wise','Jamie Deeks','Patrick Driver','Frog Stone','Nigel Boyle','Nadia Cameron-Blakey','Tim Downie','Alan Westaway','Flora Newbigin','Bradley Hall','Chris Wilson','Scarlett Sabet','Dorothy Atkinson','Colin Mace','Camilla Beeput','Rakhee Thakrar','Meredith MacNeill','Bart Edwards','Rufus Jones','Dolly Wells','Jesse Armstrong','Alice Arnold','Peter Capaldi','Mark Wakeling','Cheryl Campbell','Paul Clayton','Margaret Cabourn-Smith','Emily Bruni','Clive Merrison','Mathew Baynton','Patrick Kennedy','Tim Key','Angus Wright','Phil Gilbert','Vera Graziadei','Dan Tetsell'],
screenplay:['Jesse Armstrong','Sam Bain','David Mitchell','Simon Blackwell','Tom Basden','Jon Brown'],
production:['Izzy Mant'],
music:['Daniel Pemberton','Jonathan Whitehead'],
camera:['Jono Smith','Ben Wheeler',"Jim O'Donnell"],
cut:['Jonathan Amos','Paul Machliss','Mark Everson','Stefan Stuckert','Lucien Clayton'],
sound:['Alex Thompson'],
scenography:['Jeff Sherriff','Mo Holden','Jonathan Wingrove','Polly Davenport'],
costumes:['June Nevin']},
{title:'Bosch',
titleCZ:'Bosch',
year:2014,
runtime:'52h 11min',
episodeRuntime:'39-52min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Alex Zakrzewski','Ernest R. Dickerson','Patrick Cady','Aaron Lipstadt','Kevin Dowling','Adam Davidson','Daisy von Scherler Mayer','Jim McKay','Roxann Dawson','Sarah Pia Anderson','Matt Earl Beesley','Thomas Carter','Pieter Jan Brugge','Phil Abraham','Tim Hunter','Christine Moore','Zetna Fuentes','Neema Barnette','Laura Belsey','Michael McDonough','Trey Batchelor','Hagar Ben-Asher','Tara Nicole Weyr','Stephen Gyllenhaal'],
actors:['Titus Welliver','Jamie Hector','Amy Aquino','Lance Reddick','Madison Lintz','Mimi Rogers','Paul Calderon','Sarah Clarke','Troy Evans','Gregory Scott Cummins','DaJuan Johnson','Scott Klace','Linda Park','Jacqueline Obradors','Daya Vaidya','Mark Herrier','Steven Culp','Ingrid Rogers','John Eddins','Yancey Arias','Eric Ladin','Annie Wersching','Winter Ave Zoli','John Marshall Jones','John Getz','David Marciano','Jeri Ryan','Brent Sexton','Erika Alexander','Jason Gedrick','Nick Gomez','Rose Rollins','Scott Wilson','Amy Price-Francis','Valerie Cruz','Alan Rosenberg','Abraham Benrubi','Arlene Santana','Richard Cabral','Iris Almario','Chelsea Rendon','Jamie McShane','Ricardo Chacon','Veronica Cartwright','Dave Florek','Michael Yebba','B.J. Clinkscales','Jaime Ray Newman','Ming Lo','Randy Vasquez','Tamara Braun','Stephanie Escajeda','Peter Macon','Kikey Castillo','Bridger Zadina','Justene Alpert','Stephanie Erb','Spencer Garrett','Chase Kim','Brooke Smith','Paola Turbay','Ana Flavia Gavlak','Bar Paly','Tasia Sherel','Max Arciniega','Christopher Backus','Jeffrey Pierce','Jimmy Bennett','Jacqueline Piñol','Raychel Diane Weiner','David Futernick','Robert Catrini','Gabriela Fresquez','Jonathan Scarfe','Floyd Van Buskirk','Rob Brownstein','Robbie Jones','Mary Page Keller','Christine Avila','Hoon Lee','Shawn Hatosy','Jesse D. Goins','Hemky Madera','Michelle Hurd','Sara Botsford','Cinda Adams','Shannon Lucio','Chasty Ballesteros','Gina Gallego','Max Bird-Ridnell','James Ransone','Leisha Hailey','Myk Watford','Nicholas Gonzalez','Brad Carter','Rick Otto','Emilia Ares','Amir Talai','Matthew Lillard','Barbara Eve Harris'],
basedOn:['Michael Connelly'],
screenplay:['Michael Connelly','Jennifer Ames','Steve Turner','T.L. Lankford','Tom Smuts','Daniel Pyne','Joe Gonzalez','Diane Frolov','Andrew Schneider','William N. Fordes','Tom Bernardo','John Mankiewicz','George Pelecanos','Shaz Bennett','Jeffrey Alan Fiskin','Eric Ellis Overmyer','Elle Johnson','Alex Meenehan','Osokwe Tychicus Vasquez','Katie Pyne'],
music:['Jesse Voccia'],
camera:['Patrick Cady','Michael McDonough','Paul M. Sommers','Joseph E. Gallagher','Eric Alan Edwards','Theo van de Sande']},
{title:'Key and Peele',
titleCZ:'Key and Peele',
year:2012,
runtime:'18h 34min',
episodeRuntime:'21-22min',
countries:['USA'],
genres:['Comedy'],
director:['Peter Atencio','Payman Benz'],
actors:['Keegan-Michael Key','Jordan Peele','Amrapali Ambegaokar','Brenda Song','Jennefer Ludwigsen','Colin Hanks','Matt Jones','Kevin Sorbo','Stevie Nelson','Kerri Kenney','Adrian Gonzalez','Jon Daly','Luis Moncada','Carlson Young','Drew Droege','Carla Gallo','Eric Edelstein','Michaela Watkins','Jerry Lambert','Brendan Hunt','Patrick Carlyle','Chelsea Cook','Tone Bell','Zack Pearlman','Anders Holm','Rob Delaney','Thomas Middleditch','Satya Bhabha','Lauren Lapkus','Natasha Leggero','Stephanie Allynne','Jay Martel','Erin Gibson','Heather Anne Campbell','Milana Vayntrub','Maribeth Monroe','James Pumphrey','Jonathan Davila','Uggie','Jamie Denbo','Josh Fadem','Jeff Sloniker','Alex Fernie','Devon Libran','Errol Sack','Denise Boutte','Lily Holleman','Craig Anton','Omar Nazel','Alex Rubens','Carlease Burke','Madison Mason','Guy Stevenson','Arden Myrin','Cedric Sanders','Andrew Bachelor','Ty Burrell','Malcolm Barrett','Jennifer Wenger','Helena Barrett','Laird Macintosh','Vernee Watson','Yassir Lester','Eric Price','Joe Nunez','Brad Morris','Jean Villepique',"Edward 'Grapevine' Fordham Jr.",'Eugene Cordero','Rebecca Drysdale',"Katie O'Brien",'Victor Samuel Lopez','Marissa Cuevas','Colton Dunn','Bert Belasco','Justin Hires','Jerry Minor','Tayler Buck','Nicole Parker','Reatha Grey','Janet Varney','Melanie Lynskey','Paul Walter Hauser','Esther Povitsky','Marc Evan Jackson','Matt Besser','Georgie Guinane','Keke Palmer','Ptosha Storey','Stig Eldred','Retta','Ian Roberts','Julie Berlin','Scott Rodgers','Louisa Abernathy','Paul Welsh',"Caitlin O'Connor",'Madison Horcher','Connor Del Rio','April Barnett'],
screenplay:['Jay Martel','Alex Rubens','Rebecca Drysdale','Colton Dunn','Phil Augusta Jackson'],
production:['Keith Raskin'],
music:['Joshua Funk','Shawn K. Clement','Aaron Kaplan'],
camera:['Charles Papert'],
cut:['Nicholas Monsour','Adam Lichtenstein','Stephen Waichulis','Richard LaBrie','Christian Hoffman','Maura Corey'],
sound:['Greg Stacy','Fred Howard'],
scenography:['Gary Kordan','Julie Drach'],
masks:['Alexei Dmitiew','Scott Wheeler','Jason Hamer'],
costumes:['Beth Morgan','Melody Koerber']},
{title:'Mayor of Kingstown',
titleCZ:'Starosta Kingstownu',
year:2021,
runtime:'15h 43min',
episodeRuntime:'34-66min',
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Taylor Sheridan','Ben Richardson','Guy Ferland','Clark Johnson','Stephen Kay','Tasha Smith'],
actors:['Jeremy Renner','Taylor Handley','Dianne Wiest','Derek Webster','Michael Reventar','Hugh Dillon','Aidan Gillen','Kyle Chandler','Michael Beach','Necar Zadegan','James Jordan','Andrew Howard','Dorly Jean-Louis','Nishi Munshi','Nichole Galicia','Lombardo Boyar','George Tchortov','Scott Gibson','Zoe Doyle','David McNally','Emma Laird','Billy Lush','Jose Pablo Cantillo','Rob Stewart','Erik Knudsen','Jason Blicker','Elizaveta Neretin','Derek Basco','Mandela Van Peebles','Drew Davis','Jonathan Watton','Tim Post','Tony Nappo','Chris Owens','Jorge Molina','Patrick Stevenson','Roman Pesino','Paul Popowich','Brian Markinson','Natasha Marc','Stacie Greenwell','Joseph Ruud','Joseph Kathrein','Emma Campbell','Alex Jade','Alex House','Tobi Bamtefa','Drew Nelson','Jesse Collin','Dru Viergever','Paulino Nunes','Drew Zeran','Chase Lawless','Krista Morin','Charlie Benger','Ben Sanders','Tony Nash','Marcus Gladney Jr.','Darlene Cooke','Amanda Barker','Monica Knox','Hamish Allan-Headley','Lane Garrison','Latarsha Rose','Michael Gaston','Gena Shaw','Frank Licari','Tommy LaFitte','Brandon Rush','Dylan Kenin','Ash Santos','Brandon Tyler Moore','Sandrine Holt','Juanita Jennings','Charles Baker','Jake Schur','Tony DeMil','Javon Johnson','Bryce Clyde Jenkins','Matt Gerald','Kenny Johnson','Jock McKissic','Katie Carpenter','Michael Godere','Pete Burris','Callie Thorne','Blake Shields','Tina Ivlev','Maia Jae Bastidas','Ryan Allen','Lovensky Jean-Baptiste','James Edward Campbell','Natalie Dale'],
screenplay:['Taylor Sheridan','Hugh Dillon','Dave Erickson','Keli Goff','Evan Ball','Leon Hendrix','Christian Donovan','Regina Corrado','Stephen Kay'],
production:['Alex Jordan','Hartley Gorenstein','Evan Ball'],
music:['Andrew Lockington'],
camera:['Maya Bankovic','Stuart Campbell','Kenji Katori'],
cut:['Chad Galster','Sarah Zeitlin','John Coniglio','Bjørn T. Myrholt','Ishai Setton','Sushila Love','Todd Desrosiers','Ryan Malanaphy'],
sound:['Samuel Ejnes','Diego Gat','Stephen Fitzmaurice','Cary Stacy','David S. Di Pietro'],
scenography:['Mary Kirkland','Bernardo Trujillo','John Willett','Anthony Bruno'],
masks:['Amanda Nestico','Jason Baker','Rachel Geary','Erica Stewart','Patty Bell'],
costumes:['Shelley Mansell','Amy Andrews']},
{title:'Steins;Gate',
titleCZ:'Steins;Gate',
year:2011,
runtime:'9h 36min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Drama','Mystery','Psychology','Sci-Fi','Thriller'],
director:['Takuja Sató','Hiroši Hamasaki','Kandži Wakabajaši','Hisato Šimoda','Hirojuki Cučija','Tomoko Hiramuki','Šigetaka Ikeda'],
actors:['Tomokazu Seki','Asami Imai','Mamoru Mijano','Kana Hanazawa','Júki Ono','Jú Kobajaši','Saori Gotó','Kódži Takeda','Jukari Tamura','Micuaki Hošino','Hiroko Ušida','Masaki Terasoma','Ajano Jamamoto','Haruko Momoi','Manabu Sakamaki','Micuru Ogata',"Šin'ja Fukumacu","Džun'ja Enoki",'Ikumi Hajama','Minoru Širaiši','Hiroši Cučida','Iori Nomizu','Taira Kikumoto','Toa Jukinari','Naoko Sakakibara','Šóhei Jamaguči','Naoki Košida','Masaaki Itatori','Mai Hirano','Jóhei Óbajaši','Takajuki Saitó','Jukiko Mizuno','Kacunori Kobajaši'],
screenplay:['Džukki Hanada','Tošizó Nemoto','Masahiro Jokotani'],
production:['Yoshito Danno','Yoshinao Doi','Kenjirou Gomi','Takayuki Matsunaga','Shinsaku Tanaka'],
music:['Takeši Abo','Džun Murakami'],
camera:['Keisuke Nakamura'],
cut:['Masahiro Gotó'],
sound:['Fusanobu Fudžijama'],
scenography:['Kódži Etó']},
{title:'Twilight Zone',
titleCZ:'The Twilight Zone',
year:1959,
runtime:'74h 32min',
episodeRuntime:'25-52min',
countries:['USA'],
genres:['Mystery','Sci-Fi','Horror','Thriller','Fantasy','Drama'],
director:['John Brahm','Douglas Heyes','Buzz Kulik','Lamont Johnson','Richard L. Bare','James Sheldon','Richard Donner','Don Medford','Montgomery Pittman','Jack Smight','Alvin Ganzer','Ted Post','William F. Claxton','Elliot Silverstein','Abner Biberman','Joseph M. Newman','Alan Crosland Jr.','Robert Florey','Mitchell Leisen','Robert Parrish','Ron Winston','Stuart Rosenberg','David Orrick McDearmon','Justus Addiss','Perry Lafferty','Robert Stevens','John Rich','Anton Leader','Boris Sagal','Christian Nyby','Don Siegel','Robert Butler','Allen Reisner','William Asher','Ralph Nelson','Norman Z. McLeod','David Greene','Robert Ellis Miller','Allen H. Miner','Harold D. Schuster','Paul Stewart','David Butler','Bernard Girard','Robert Gist','Walter Grauman','Roger Kay','David Lowell Rich','Richard C. Sarafian','Ralph Senensky','Don Weis','Robert Enrico','Ida Lupino','Jacques Tourneur'],
actors:['Rod Serling','Robert McCord','Jay Overholts','James Turley','Vaughn Taylor','David Armstrong','Jack Klugman','Burgess Meredith','John Anderson',"Pat O'Malley",'Barney Phillips','George Mitchell','Cyril Delevanti','Jon Lormer','Bill Erwin','Nan Peterson','Lew Brown','S. John Launer','Gladys Cooper','Albert Salmi','James Franciscus','Gary Merrill','Betty Lou Gerson','George Macready','Florence Marly','Barry Nelson','Buddy Ebsen','Elizabeth Montgomery','Dewey Martin','Don Rickles','Lee Marvin','Inger Stevens','Cliff Robertson','Ed Wynn','William Shatner','John Hoyt','Martin Landau','Jack Warden','Martin Balsam','Claude Akins','Frank Overton','Ivan Dixon','Harold Gould','Barbara Nichols','Jean Willes','Estelle Winwood','Orson Bean','John McIntire',"Patrick O'Neal",'Jean Marsh','Charles Bronson','Veronica Cartwright','Vito Scotti','Wilfrid Hyde-White','Natalie Trundy','Luther Adler','George Petrie','Hugh Sanders','Leonard Bremen','Natalie Masters','Richard Basehart','John McGiver','Joyce Van Patten','Donna Douglas','James Best','Steve Cochran','Marsha Hunt','Julie Newmar','Doug McClure','Steve Forrest','Joan Hackett','Andy Devine','Mariette Hartley','Janice Rule','George Grizzard','Dane Clark','Earl Holliman','Alice Pearce','George E. Stone','Penny Singleton','Everett Sloane','Harold J. Stone','John A. Alonzo','Donald Losby','Don Gordon','Howard Duff','Thalmus Rasulala','Alan Sues','Denise Alexander','Patricia Barry','Dee Carroll','Mark Tapscott','Meg Wyllie','Jeanne Cooper','Edgar Buchanan','Jack Ging','Philip Coolidge','Margaret Field','Edy Williams','John Eldredge'],
basedOn:['Lucille Fletcher','Richard Matheson','Henry Slesar','Manly Wade Wellman','John Collier','Henry Kuttner'],
screenplay:['Rod Serling','Charles Beaumont','Richard Matheson','Earl Hamner Jr.','George Clayton Johnson','Montgomery Pittman','Martin Goldsmith','Oceo Ritch','E. Jack Neuman','Robert Presnell Jr.','Bill Idelson','Ray Bradbury','Richard De Roy','John Furia','Reginald Rose','Jerry McNeely','Bernard C. Schoenfeld','Adele T. Strassfield','John Tomerlin','Anthony Wilson','Jerry Sohl'],
production:['Buck Houghton','William Froug','Bert Granet','Herbert Hirschman','Paul de Roubaix','Marcel Ichac'],
music:['Van Cleave','Bernard Herrmann','Fred Steiner','Jerry Goldsmith','René Garriguenc','Tommy Morgan','Jeff Alexander','Lucien Moraweck','Nathan Scott','Leonard Rosenman','Leith Stevens','Franz Waxman','Lyn Murray','Wilbur Hatch','William Lava','Laurindo Almeida','Robert Drasnin','Henri Lanoë','Richard Shores'],
camera:['George T. Clemens','Robert Pittack','Jack Swain','Fred Mandl','Charles F. Wheeler','Joseph LaShelle','Harkness Smith','Harry J. Wild','William V. Skall','Jean Boffety'],
cut:['Bill Mosher','Jason H. Bernie','Richard V. Heermance','Joseph Gluck','Thomas Scott','Leon Barsha','Richard W. Farrell','Edward Curtiss','Eda Warren','Everett Dodd','Fred Maguire','Al Clark','Lyle Boyer','Roland Gross','Denise de Casabianca','Robert Enrico'],
sound:['Franklin Milton','Bill Edmondson','Joe Edmondson','Philip Mitchell','Jean G. Valentino','Charles Scheid','Leslie I. Carey','Vernon W. Kramer','Jean Nény'],
scenography:['George W. Davis','Philip Barber','William Ferrari','Merrill Pye','Walter Holscher','Malcolm Brown','Eddie Imazu','Edward C. Carfagno','Paul Groesse','John J. Thompson','William Craig Smith','Robert Tyler Lee','Robert Clatworthy','Alexander Golitzen','Henry Grace','H. Web Arrowsmith','Robert R. Benton','Rudy Butler','F. Keogh Gleason','Frank R. McKelvy','Don Greenwood Jr.','Edward M. Parker','Jerry Wunderlich','Arthur Jeph Parker','Buck Henshaw','Budd Friend','George R. Nelson','Russell A. Gausman','Ruby R. Levitt'],
masks:['William Tuttle','Bud Westmore','Grant Keate']},
{title:'Misfits',
titleCZ:'Misfits: Zmetci',
year:2009,
runtime:'29h 12min',
episodeRuntime:'43-51min',
countries:['UK'],
genres:['Comedy','Drama','Fantasy','Sci-Fi'],
director:['China Moo-Young','Tom Green','Tom Harper','Wayne Yip','Alex Garcia','Owen Harris','Lewis Arnold','Lawrence Gough','Alex Garcia Lopez','William Sinclair','Jonathan van Tulleken','Nirpal Bhogal','Dušan Lazarević','William McGregor'],
actors:['Iwan Rheon','Joe Gilgun','Nathan Stewart-Jarrett','Antonia Thomas','Lauren Socha','Robert Sheehan','Robert Sheehan','Karla Crome','Nathan McMullen','Matt Stokoe',"Natasha O'Keeffe",'Matthew McNulty','Shaun Dooley','Craig Parkinson','Alex Reid','Ruth Negga','Michael Winder','Michael Obiora','Matt Cross','Ellie Kendrick','Kate Bracken','Dexter Fletcher','Michelle Fairley','Amy Beth Hayes','Zawe Ashton','Jessica Brown Findlay','Jayne Wisener','Stephen Wight','Gillian Saker','Amy Manson','Robert Fyfe','Nathalie Emmanuel','Adrian Rawlins','Danny Sapani','Francis Magee','Jamie Blackley','Edward Hogg','Nicholas Burns','Catrin Stewart','Charlie Murphy','Hannah Britland','Jordan Metcalfe','Riann Steele','Josef Altin','Tom Austen','Sandy McDade','Michael Marcus','Phil Cornwell','Jamie Davis','Jack Donnelly','Rick Warden','Fred Pearson','Lucy Gaskell','Velile Tshabalala','Royce Pierreson','Nick Blood','Michael Müller','Anna Koval','Sam Keeley','Chloe Pirrie','Charlene McKenna','Osy Ikhile','Philip Rosch','Nadine Lewington','Gwyneth Keyworth','Perry Benson','Jack Bence','Oliver Lansley','Eve Ponsonby','Andrew Gower','Richard Riddell','Robert Whitelock','Hannah John-Kamen','Joshua McGuire','Steven Cree','Dylan Edwards','Liz May Brice','Juliet Cowan','Roland MacLeod','Nathan Constance','Susan Wokoma','Charlie Covell','Ade Oyefeso','Harry Hepple','Phil Daniels','Adam Richards','Evelyn Hoskins','Anna Wilson-Jones','Joanna Christie','David Ajala','Mark Heap','Rosie Day','Ruth Sheen','Lydia Wilson','Kenneth Colley','Klariza Clayton','Erin Richards','Kehinde Fadipe','Julia Ford','Nathaniel Martello-White'],
screenplay:['Howard Overman','Jon Brown'],
production:['Kate Crowe','Matt Strevens','Chloe Moss','Nick Pitt'],
music:['Vincent Pope'],
camera:['Christopher Ross','Damian Bromley','Adam Etherington','Tim Sidell','Simon Tindall','Felix Wiedemann','Sam Care','David Raedeker'],
cut:['Jake Roberts','Stephen Haren','Andrew MacRitchie','Richard Graham','Tom Hemmings','Mark Eckersley','Robin Peters','Crispin Green','Celia Haining','Kim Gaster','Matthew Tabern','Christopher Watson'],
scenography:['Tom Bowyer','Debbie Burton','Rebecca Pilkington','Stella Fox'],
masks:['Vickie Lang'],
costumes:['Liza Bracey','Molly Emma Rowe']},
{title:'Battlestar Galactica',
titleCZ:'Battlestar Galactica',
year:2004,
runtime:'61h 28min',
episodeRuntime:'42-103min',
countries:['USA','UK'],
genres:['Sci-Fi','Action','Adventure','Drama'],
director:['Michael Rymer','Sergio Mimica-Gezzan','Jonas Pate','Félix Enríquez Alcalá','Anthony Hemingway','Jeff Woolnough','Gwyneth Horder-Payton','Edward James Olmos','Rod Hardy','Wayne Rose','Ronald D. Moore','Allan Kroeker','Marita Grabiak','Robert M. Young','Brad Turner','Michael Nankin','James Head','Reynaldo Villalobos','Jean de Segonzac','Bill Eagles','Paul A. Edwards','John Dahl'],
actors:['Edward James Olmos','Mary McDonnell','Jamie Bamber','James Callis','Grace Park','Tricia Helfer','Katee Sackhoff','Aaron Douglas','Michael Hogan','Tahmoh Penikett','Kandyse McClure','Nicki Clyne','Leah Cairns','Michael Trucco','Amanda Plummer','Fulvio Cecere','Amber Rothwell','Leela Savasta','Lucy Lawless','Mark Sheppard','James Remar','John Heard','Colm Feore','Bruce Davison','Carl Lumbly','Michelle Forbes','Bill Duke','Dominic Zamprogna','Amy Lalonde','Tammy Hui','Claudette Mink','Colby Johannson','Steve Lawlor','Chelah Horsdal','Samuel Patrick Chu','Emilie Ullerup','Holly Elissa','Keegan Connor Tracy','Heather Doerksen','Charles Singh','Christopher Jacot','Alessandro Juliani','Callum Keith Rennie','Haley Guiel','Ryan Robbins','Dan Payne','Erika-Shaye Gair','Ty Olsson','Jeremy Guilbaut','Dean Stockwell','James Lafazanos','Sam Witwer','Torrance Coombs','Tom Bower','Tiffany Lyndall-Knight','Rick Worthy','John Hodgman','Donnelly Rhodes','Kate Vernon','Paul Campbell','Warren Christie','John Pyper-Ferguson','Lara Gilchrist','Tygh Runyan','David Richmond-Peck','Nana Visitor','Samantha Ferris','Françoise Robertson','Aaron Pearl','Camille Sullivan','Robert Gauvin','Richard Hatch','Colin Lawrence','Roark Critchlow','Kimani Ray Smith','Alain Chanoine','Susan Hogan','Adrian Holmes','Ronald D. Moore','Karen Austin','Mylène Dinh-Robic','Luciana Carro','Ryan McDonell','Erica Carroll','Michael Angeli','Jerry Wasserman','Kevin McNulty','Rebecca Davis','Monique Ganderton','Patrick Gallagher','Jill Teed','Alex Zahara','Don Thompson','Brent Stait','Vincent Gale','Aleks Paunovic','Benjamin Ayres','Georgia Craig','Barry Nerling','Ally Warren'],
screenplay:['Ronald D. Moore','Mark Verheiden','Anne Cofell Saunders','Jane Espenson','Michael Angeli','Bradley Thompson','David Weddle','Jeff Vlaming','Michael Taylor','Michael Rymer','Dawn Prestwich','Nicole Yorkin','Seamus Kevin Fahey','Joel Anderson Thompson','Toni Graphia','David Eick'],
production:['Michael Rymer','Ron French','Harvey Frand'],
music:['Bear McCreary','Richard Gibbs'],
camera:['Joel Ransom','Stephen McNutt'],
cut:['Dany Cooper','Gib Jaffe','Bert Glatstein','Anthony Redman',"Michael O'Halloran",'Andrew Seklir','Stewart Schill','Julius Ramsay','Annette Davey','Jacques Gravett','Michael Stern'],
sound:['Daniel Colman','Peter Reale','Kevin Patrick Burns','Mike Olman','Kenneth Kobett','Todd Orr'],
scenography:['Richard Hudolin','Jonathan Lancaster','Paul Peters'],
masks:['Forest Sala','Patricia Murray'],
costumes:['Deborah Everton','Glenne Campbell']},
{title:'The Young Pope',
titleCZ:'Mladý papež',
year:2016,
runtime:'8h 38min',
episodeRuntime:'50-55min',
countries:['Italy','France','Spain','USA'],
genres:['Drama'],
director:['Paolo Sorrentino'],
actors:['Jude Law','Diane Keaton','Silvio Orlando','Javier Cámara','Scott Shepherd','Cécile de France','Ludivine Sagnier','Toni Bertorelli','James Cromwell','Ignazio Oliva','Marcello Romolo','Stefano Accorsi','Guy Boyd','Andre Gregory','Allison Case','Sebastian Roché','Olivia Macklin','Daniel Vivian','Gianluca Guidi','Jim Adhi Limas','Sara Lazzaro','Maurizio Lombardi','Matteo Lai','Tony Plana','Rayna Tharani','Kevin Jackson','Robert Dawson','Jan Hoag','Delaina Mitchell','Ashley Watkins','Todd Grinnell','Troy Ruptash','Lino Musella','Alex Esola','Madalina Bellariu Ion','Euridice Axen','Camilla Diana','Marcos Franz','Giovanni Agrò','Biagio Forestieri','Francesca Cutolo','Alexia Murray','Mattia Sbragia','Franco Pinelli','Dino Santoro','Massimiliano Gallo','Duccio Camerini','Alessio Praticò','Fabrizio Jovine','Milvia Marigliano','Chris April','Lea Gramsdorff','Jonathan Silvestri','Nicolas Coster','Edwin Apps','Diego Maradona','Carolina Carlsson','Luke Grakal','Nadie Kammallaweera','Davide Cincis','Armando Pizzuti','Lydia Giordano','Gil Perez-Abraham','Dino Conti'],
screenplay:['Paolo Sorrentino','Umberto Contarello','Tony Grisoni','Stefano Rulli'],
production:['Jude Law','Mauro Monachini'],
music:['Lele Marchitelli'],
camera:['Luca Bigazzi'],
cut:['Cristiano Travaglioli'],
sound:['Michele Mazzucco','Paolo Segat','Pedro Sánchez Alonso','Emanuele Cecere'],
scenography:['Ludovica Ferrario','Dennis Washington','Massimo Pauletto','Laura Casalini'],
masks:['Giuliana Lavinia','Marco Perna','Domingo Santoro'],
costumes:['Carlo Poggioli']},
{title:'Genius',
titleCZ:'Génius',
year:2017,
runtime:'31h 23min',
episodeRuntime:'43-75min',
countries:['USA'],
genres:['Biographic','Drama'],
director:['Kenneth Biller','Anthony Hemingway','Kevin Hooks','Minkie Spiro','James Hawes','Laura Belsey','Greg Yaitanes','Mathias Herndl','Neema Barnette','Ron Howard','Bille Woodruff'],
actors:['Antonio Banderas','Cynthia Erivo','Johnny Flynn','Geoffrey Rush','Samantha Colley','Alex Rich','Seth Gabel','Clémence Poésy','T.R. Knight','Michael McElhatton','Courtney B. Vance','Ralph Brown','Shaian Jordan','Aisling Franciosi','Lucy Russell','Richard Topol','Malcolm Barrett','David Cross','Patrice Covington','Rebecca Naomi Jones','Poppy Delevingne','Bruno Paviot','Kimberly Hebert Gregory','Jon Fletcher','Sebastian Roché','Stéphane Caillard','Emily Watson','Sally Dexter','Robert Sheehan','Claire Rushbrook','Adrian Schiller','Catherine McCormack','Alicia von Rittberg','Shannon Tarbet','Alistair Petrie','David Dencik','Ed Stoppard','Nicholas Rowe','Simon Buret','Andrew Buchan','Predrag Bjelac','Kerr Logan','Henry Goodman','George Webster','Athena Strates','Klára Issová','Charity Wakefield','Vincent Kartheiser','Zoe Telford','Simon Kunz','Zita Téby','Tim Dutton','Benjamin Haigh','Eric Colvin','Ivo Novák','Thomas Morris','George Lenz','Karel Heřmánek ml.','Zdeněk Piškula','Nikki Hahn','Claudia Vašeková','Silvina Buchbauer','Corrado Invernizzi','Rod Hallett','Eugene Simon','Radik Golovkov','Ted Otis','Ania Bukstein','Adam Garcia','Mitchell Mullen','Georg Nikoloff','Christian Rubeck','John Sackville','Robert Goodman','David Hunt','Georgij Streljannyj','Timothy Radford','Tom Brittney','Petra Bučková','Jared Doreck','Robert Lindsay','Martin Umbach','Christopher Reinhardt','Ondřej Novák','Pavel Myslík','Norbert Hülm','Kristýna Janáčková','Jana Krausová','Halka Jeřábek Třešňáková','Michael Culkin','Alexander Vlahos','Adrian Lukis','Terrence Hardiman','Alena Štréblová','Patrik Plešinger','Michal Zelenka','Nikola Djuričko','Beáta Kaňoková','Michal Roneš','Ignát Kinol'],
basedOn:['Walter Isaacson'],
screenplay:['Suzan-Lori Parks','Raf Green','Noah Pink','Kenneth Biller','Brian Peterson','Angelina Burnett','Mark Lafferty','Wendy Riss','Matthew Newman','Kelly Souders','Nathan Louis Jackson','Gwendolyn M. Parker','Becky Mode','Francesca Butler','Jeff Stetson','Stephanie K. Smith','Ali Gordon-Goldstein'],
production:['Steven Felder','Kelly A. Manners','Ed Cathell III','Nathan Louis Jackson'],
music:['Lorne Balfe','Terence Blanchard'],
camera:['Mathias Herndl','Kevin McKnight','Ryan Purcell'],
cut:['J. Kathleen Gibson','James Wilcox','Mark Sadlek','Debby Germino','Ryan Denmark','Vanessa Procopio','Agnes Grandits','Ken Eluto','Daniel A. Valverde','James Kilton'],
scenography:['Arvinder Greywal','Tim Galvin','Jonathan Lee'],
masks:['Hana Šurkalová','Davina Lamont','Erin Keith','Louisa V. Anthony','Terje Rødsjø','Göran Lundström','Dee Dee Metzger','Erika García'],
costumes:['Sonu Mishra','Jennifer L. Bryan','Julian Day','Zuzana Brožová']},
{title:'Jane Eyre',
titleCZ:'Osudová láska Jany Eyrové',
year:2006,
runtime:'3h 40min',
episodeRuntime:'50-60min',
countries:['UK'],
genres:['Drama','Romance'],
director:['Susanna White'],
actors:['Ruth Wilson','Toby Stephens','Francesca Annis','Christopher Bowen','Pam Ferris','Tara Fitzgerald','Georgie Henley','Sam Hoare','Christina Cole','Annabel Scholey','Georgia King','Cara Horgan','Elsa Mollien','Charity Wakefield','Maisie Dimbleby','Andrew Buchan','Daniel Pirrie','Emma Lowndes','Richard McCabe','Rebekah Staton','Lorraine Ashbourne','Arthur Cox','Jacqueline Pilton','Letty Butler','Aidan McArdle','Eglantine Rembauville-Nicolle','Sally Sheridan','Anne Reid','Peter Ivatts'],
basedOn:['Charlotte Brontë'],
music:['Rob Lane'],
camera:['Mike Eley'],
sound:['Stephen Griffiths']},
{title:'The Case-Book of Sherlock Holmes',
titleCZ:'Z deníku Sherlocka Holmese',
year:1991,
runtime:'5h 7min',
episodeRuntime:'48-52min',
countries:['UK'],
genres:['Crime','Mystery'],
director:['Tim Sullivan','John Madden','Michael A. Simpson','Patrick Lau','June Howson'],
actors:['Jeremy Brett','Edward Hardwicke','Rosalie Williams','Cheryl Campbell','Julian Curry','Mary Cunningham','Jack Klaff','Michael Jayston','Anthony Benson','Daniel Massey','Catherine Russell','Andrew Wilde','Philip Bretherton','Robin Ellis','Frank Grimes','Denise Black','Michael Bilton','Michael Wynne','Jude Law','Peter Vaughan','Joanna Roth','Leslie Schofield','James Purefoy','Anthony Valentine','David Langton','Abigail Cruttenden','Kim Thomson','Roy Holder','Andy Bradford','Charles Kay','Adrian Lukis','Sarah Woodward','Anna Mazzotti','Peter Guinness','Colin Jeavons','Peter Elliott','Norma West','Nickolas Grace','David Mallinson','Sophie Thompson','Alan Rothwell','Keith Barron','Yolanda Vazquez','Richard Dempsey','Juliet Aubrey','Elizabeth Spriggs','Peter Geddis','Geoffrey Beevers','Anna Calder-Marshall','Mary Ellis','Heather Chasen'],
basedOn:['Arthur Conan Doyle'],
screenplay:['T.R. Bowen','Jeremy Paul','John Hawkesworth','Robin Chapman'],
music:['Patrick Gowers'],
camera:['Ken Morgan','Mike Popley','Doug Hallows'],
cut:['Clive Maltby','Chris Gill'],
scenography:['Paul Rowan','Chris Wilkinson']},
{title:'Gumball',
titleCZ:'Gumballův úžasný svět',
year:2011,
runtime:2880,
episodeRuntime:12,
countries:['UK','Germany','Ireland','USA'],
genres:['Animation','Comedy','Fantasy','Family'],
director:['Mic Graves','Antoine Perez','Rossitza Likomanova'],
actors:['Dan Russell','Teresa Gallagher','Kerry Shale','Kyla Rae Kowalewski','Jacob Hopkins','Terrell Ransom Jr.','Hugo Harold-Harrison','Mic Graves','Sandra Dickinson','Logan Grove','Kwesi Boakye','Jessica McDonald','Nicolas Cantu','Tony Hull','Steve Furst','Adam Long','Alex Jordan','Alix Wilton Regan','Stefan Ashton Frank','Donielle T. Hansley Jr.','Colin McFarlane','David Warner','Gillian Hanna','Ben Bocquelet','Philip Hunt','Christian J. Simon','Peter Browngardt','Fergus Craig','Greg Eagles','Rob Rackstraw','Baker Terry','Chuck Klein','Richard Overall',"James O'Brien"],
screenplay:['Ben Bocquelet','Andrew Brenner','Mic Graves','Andy Wolton','Chris Garbutt','Joe Markham','Joe Parham','Ciaran Murtagh','Andrew Jones','Guillaume Cassuto','Tony Hull','James Hamilton','Jack Bernhardt','Sam Ward','Richard Overall','Mark Evans'],
production:['Joanna Beresford','Sarah Fell'],
music:['Ben Locket'],
cut:['Richard Overall','Tony Hull','Lucy Benson'],
sound:["James O'Brien",'Tony Orozco','Robert Serda','Pedro Sánchez Alonso','Timothy J. Borquez','Mic Graves'],
scenography:['Ben Bocquelet','Antoine Perez','Yann Benedi']},
{title:'Egypt',
titleCZ:'Egypt',
year:2005,
runtime:'5h 45min',
episodeRuntime:'55-60min',
countries:['UK'],
genres:['Drama','History'],
director:['Ferdinand Fairfax'],
actors:['Andrew Sachs','Stuart Graham','Julian Wadham','Caroline Langrishe','Laurence Fox','Elliot Cowan','Joseph Beattie','Richard Dempsey','Nickolas Grace','Patrick Ryecart','William Hope','Jalaal Hartley','Valentine Pelka','David Quilter','Catherine Bailey','Badi Uzzaman','Christopher Good','Joseph Long','Hugh Ross','Gyuri Sarossy','Alexandra Weaver','Hugh Fraser','Olegar Fedoro','Angelo Andreou','Thomas Lockyer','Stuart Bunce','Clive Merrison'],
screenplay:['Tony Mulholland','Ferdinand Fairfax'],
music:['Stanisław Syrewicz'],
camera:['Tim Palmer','Peter Hannan'],
cut:['Les Healey'],
scenography:['Maurice Cain','Dominic Smithers','Hamed Hemdan'],
masks:['Sarah Monzani'],
costumes:['Jane Robinson']},
{title:'Legacy from the Future - Fantastic Adventures of Family Mézga',
titleCZ:'Odkaz budoucnosti aneb Podivuhodná dobrodružství rodiny Smolíkovy',
year:1968,
runtime:'5h 24min',
episodeRuntime:'23-27min',
countries:['Hungary'],
genres:['Animation','Sci-Fi','Family'],
director:['József Nepp'],
actors:['Endre Harkányi','Ilona Győri','Margit Földessy','Attila Némethy','Nándor Tomanek','Rudolf Somogyvári','István Egresi','Miklós Szakáts','Imre Surányi','Alfonzó','Józsa Hacser','Ferenc Deák B.','Pál Horváth','Tamás Fodor','György Szoó','György Bárdy','Antal Farkas','Ottó Szabó','Hédi Váradi','Árpád Gyenge','Judit Tóth','András Kern'],
screenplay:['József Nepp','József Romhányi'],
music:['Tamás Deák'],
camera:['Zoltán Bacsó','Csaba Nagy','Alfréd Klausz'],
sound:['Domonkos Horváth']},
{title:'Naruto: Shippūden',
titleCZ:'Naruto: Šippúden',
year:2007,
runtime:12000,
episodeRuntime:24,
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy'],
director:['Hajato Date',"Ken'iči Nišida",'Masaharu Watanabe','Masahiko Murata','Šindži Sató','Takahiro Ono','Kijomu Fukuda','Masajuki Macumoto','Júsuke Onoda','Osamu Kobajaši','Naoki Horiuči','Jasumi Mikamoto','Maki Odaira','Ogura Širakawa','Sumito Sasaki','Acuši Wakabajaši','Kazuma Sató','Čiaki Kon','Acuši Nigorikawa','Júki Kinošita','Seidži Okuda','Micutaka Nošitani','Tošija Niidome','Hiroši Kimura','Šigeharu Takahaši','Seiki Takuno','Kunitoši Okadžima','Cutomu Murakami','Tošiaki Kanbara','Júičiró Mijake','Šú Watanabe','Jutaka Kagawa','Masahiro Takada','Rion Kudžó','Akitoši Jokojama','Minoru Jamaoka','Daisuke Cukuši','Masato Kitagawa','Fudžiaki Asari','Eiko Niši','Jošihiro Sugai','Tošinori Watanabe','Jasuhiro Minami','Taisuke Mamori'],
actors:['Džunko Takeuči','Noriaki Sugijama','Nana Mizuki','Romi Paku','Akeno Watanabe','Akio Ócuka','Acuko Tanaka','Džúróta Kosugi','Ikue Ótani','Jú Asakawa','Júsuke Kamidži','Kazuja Nakai','Ken Narita','Kendži Jamauči','Kendžiró Cuda',"Ken'iči Suzumura",'Kotono Micuiši','Kózó Dózaka','Maaja Sakamoto','Mamiko Noto','Majumi Asano','Nozomu Sasaki',"Šin'ičiró Miki",'Susumu Čiba','Takako Fudži','Teššó Genda','Tomojuki Dan','Tošihiko Seki','Unšó Išizuka','Wataru Takagi','Mucumi Tamura','Akiko Jadžima','Daisuke Hirakawa','Kentaró Itó','Stephanie Sheh','Nobutoši Kanna','Tošijuki Morikawa','Akira Išida','Masuo Amada','Rjúdži Mizuno','Ikuo Nišikawa','Ikuja Sawaki','Takaši Irie','Juki Masuda','Naoki Bandó','Jutaka Aojama','Jasujuki Kase','Šóto Kašii','Pete Sepenuk','Daisuke Sakaguči','Kazunari Tanaka','Juka Komacu','Hideaki Tezuka','Hiroaki Hirata','Kazuki Jao','Kazue Ikura','Hideo Išikawa','Tomoaki Maeno','Jumiko Kobajaši','Takeši Kusao','Takahiro Sakurai','Satoši Hino','Ajumi Fudžimura','Hiroši Naka','Šinpači Cudži','Naoko Macui','Džódži Nakata','Rjóka Juzuki','Kumiko Higa','Jošimasa Hosoja','Ai Kakuma','Anri Kacu','Hiroši Janaka','Sóičiró Hoši','Takaja Kuroda','Hiroki Jasumoto','Rjóta Takeuči','Tóru Nara','Kazuhiko Inoue','Nobuo Tobita','Takaši Nagasako','Kenta Mijake','Džunko Midori','Daiki Nakamura','Tomohiro Cuboi','Šindži Kawada','Kóki Mijata','Megumi Tojoguči','Haruhi Nanao','Jošimicu Šimojama','Masaki Aizawa','Kósuke Toriumi','Noriko Šitaja','Šizuka Išikawa','Masaši Ebara','Takaja Haši','Emi Šinohara','Kacuhisa Hóki','Šótaró Morikubo','Hóčú Ócuka'],
basedOn:['Masaši Kišimoto'],
screenplay:['Džunki Takegami','Satoru Nišizono','Masanao Akahoši','Osamu Kobajaši','Juka Mijata','Masahiro Hikokubo','Jasujuki Suzuki','Šin Jošida','Daisuke Watanabe','Kacuhiko Čiba'],
production:['Fukaši Azuma','Makoto Hidžikata','Naodži Hónokidani','Makoto Širaiši','Tomoko Gušima'],
music:['Jasuharu Takanaši','Tošio Masuda'],
camera:['Acuho Macumoto','Nobuo Kimura'],
cut:['Seidži Morita','Jukie Oikawa'],
sound:['Jasunori Ebina'],
scenography:['Norihiko Jokomacu','Šigenori Takada']},
{title:'How Not to Live Your Life',
titleCZ:'Jak nežít svůj život',
year:2007,
runtime:'10h 57min',
episodeRuntime:'30-57min',
countries:['UK'],
genres:['Comedy'],
director:['Dan Clark','Martin Dennis','Gary Reich','Sam Leifer'],
actors:['Dan Clark','David Armand','Lloyd Woolf','Laura Haddock','Sinead Moynihan','Rich Fulcher','Finlay Robertson','Jessica Knappett','Silas Carson','Olivia Lee','Julian Barratt','Claire Keelan','Greg McHugh','David Schneider','Sarah Hadland','Fiona Button','Rosalind Halstead','Tom Meeten','Theo Barklem-Biggs','Niky Wardley','Honor Kneafsey','Rupert Vansittart','Robert Yates','Rachel Fielding','James Greene','Susan Calman','David Webber','Fiona Mollison','Simon Weir','Euan Macnaughton','Nick Mohammed','Scarlett Rose Patterson','Bruce Mackinnon','Mark Field','Sally Bretton','Laura Fedorowycz','Daniel Lawrence Taylor','Blayne Bennett','Isabel Fay','Arnab Chanda','Matthew Marsh','Frank Gallagher','Leila Hoffman','Limahl','Sabrina Jàvor',"Grant O'Rourke",'Noel Fielding','Phoebe Waller-Bridge','Julia Davis','Oliver Maltman','James Martin','Sharon MacKenzie','Joy McAvoy','Jenny Ryan','Ben Bradley','Annette Staines','Sheila Latimer','Erin Gavin','Anne Kidd','Callum Cuthbertson','Sheila Donald','Ronni Menzies-Stirling','Sheena Penson'],
screenplay:['Dan Clark'],
camera:['Jono Smith'],
cut:['Paul Machliss'],
scenography:['Iain McDonald','Suzanne Field'],
costumes:['Gillian Horn','Lynn Aitken']},
{title:'Atypical',
titleCZ:'Atypický',
year:2017,
runtime:'19h 51min',
episodeRuntime:'26-39min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Seth Gordon','Michael Patrick Jann','Joe Kessler','Ryan Case','Silver Tree','Geeta Vasant Patel','Wendey Stanzler','Pete Chatmon','Ken Whittingham'],
actors:['Jennifer Jason Leigh','Michael Rapaport','Keir Gilchrist','Jenna Boyd','Brigette Lundy-Paine','Amy Okuda','Raúl Castillo','Megan Easton','Tina Grimm','Donnabella Mortel','Graham Rogers','Ariela Barer','Major Curda','Kue Lawrence','Nik Dodani','Gino Montesinos','Amy Hessler','Gabriela Flores','Dan Ahdoot','Karly Rothenberg','Kevin Daniels','Michelle Farrah Huang','Karl T. Wright','Brittney Bertier','Rachel Redleaf','Nakia Burrise','Michael Rady','Beth Curry','Christopher Gehrman','Dan Levy','Fivel Stewart','Graham Phillips','Casey Wilson','Kimmy Gatewood','Nina Ameri','Elena Campbell-Martinez','Nikki Gutman','Nicole Zyana','Jeremiah Birkett','Mina Badie','West Liang','Daniela Leon','Erica Shaffer','Andrew Secunda','Chiquita Fuller','Megan Suri','Annie Mebane','James S.W. Lee','Andrew Kai','Roni Geva','Kevyn Bashore','Marisa Davila','Micaela Wittman','Marietta Melrose','Cornelius Peter','Peter James Smith','Tess Aubert','Logan Johnson','Amy Tolsky','Michael Franklin','Marcy Goldman','Monnae Michaell','Azur-De','Donna Pieroni','Allie Rae Treharne','Cooper Mothersbaugh','Chris Grace','Chau Long','Kyle Kittredge','Carla Vila','Sheldon White','Lucia Oskerová'],
screenplay:['Annabel Oakes','Robia Rashid','Michael Oppenhuizen','Jen Regan','Theresa Mulligan','Brian Tanen','Annie Mebane','Dennis Saldua'],
production:['Jennifer Jason Leigh','Jill Danton','Joanne Toll'],
music:['Dan Romer'],
camera:['Joe Kessler','Tom Magill'],
cut:['Sandra Montiel','David Codron','Peter B. Ellis','Thomas M. Bolger','Kristin Windell','David Helfand','Sue Federman','Rebekah Fridman',"Brian D'Augustine"],
sound:['Whitney Purple','Peter Nusbaum'],
scenography:['Joseph P. Lucky','Claire Kaufman','Julie Bolder'],
masks:['Heba Thorisdottir','Phyllis Williams','Bryn E. Leetch'],
costumes:['Mojdeh Daftary']},
{title:'Roots',
titleCZ:'Kořeny',
year:1977,
runtime:540,
episodeRuntime:60,
countries:['USA'],
genres:['Drama','History'],
director:['David Greene','Marvin J. Chomsky','John Erman','Gilbert Moses'],
actors:['Olivia Cole','Maya Angelou','LeVar Burton','Ben Vereen','Edward Asner','O.J. Simpson','Louis Gossett Jr.','Vic Morrow','John Amos','Madge Sinclair','Thayer David','Carolyn Jones','Macdonald Carey','Scatman Crothers','George Hamilton','Ian McShane','Richard Roundtree','Lloyd Bridges','Georg Stanford Brown','Brad Davis','Robert Phalen','Brion James','Yaphet Kotto','Richard Farnsworth','Austin Stoker','Burl Ives','Cicely Tyson','Charles Cyphers','Grand L. Bush','Moses Gunn','Yvonne De Carlo','Doug McClure','Hari Rhodes','Chuck Connors','Gary Collins','Lynda Day George','Beverly Todd','Paul Shenar','Ernest Thomas','Lawrence Hilton-Jacobs','Lorne Greene','Todd Bridges','Thalmus Rasulala','Ralph Waite','Tanya Boyd','John Schuck','Sandy Duncan','Pat Corley','Raymond St. Jacques','John Quade','Macon McCalman','John Dennis Johnston','Lillian Randolph','Wally Taylor','Lee de Broux','Joe Dorsey','Lynne Moody','Davis Roberts','Helen Martin','Jonathan Pienaar','Ji-Tu Cumbuka','William Watson','Leslie Uggams','Hank Rolike','Richard McKenzie','Hilly Hicks','Roxie Roker','Tina Andrews','Sally Kemp','Renn Woods','Robert Reed','Stan Haze','Tracey Gold','Wayne Heffley','Ann Weldon','Fred D. Scott','Fred Covington'],
basedOn:['Alex Haley'],
screenplay:['William Blinn','James Lee','Ernest Kinoy'],
production:['Stan Margulies'],
music:['Gerald Fried','Quincy Jones'],
camera:['Joseph M. Wilcots','Stevan Larner'],
cut:['Neil Travis','James T. Heckert'],
sound:['Leonard Peterson'],
scenography:['Jan Scott','Alice Baker'],
masks:['Stan Winston'],
costumes:['Jack Martell']},
{title:"Dirk Gently's Holistic Detective Agency",
titleCZ:"Dirk Gently's Holistic Detective Agency",
year:2016,
runtime:'12h 49min',
episodeRuntime:'41-53min',
countries:['USA','UK'],
genres:['Comedy','Sci-Fi'],
director:['Paco Cabezas','Dean Parisot','Michael Patrick Jann','Douglas Mackinnon','Richard Laxton','Wayne Yip','Alrick Riley'],
actors:['Elijah Wood','Samuel Barnett','Christian Bako','Neil Brown Jr.','Aaron Douglas','Fiona Dourif','Michael Eklund','Mpho Koaho','Hannah Marks','Dustin Milligan','Miguel Sandoval','Richard Schiff','Zak Santiago','Caroline Cave','Paul Lazenby','Aaron Hutchinson','Osric Chau','David Lewis','Aiden Longworth','Viv Leacock','Fiona Vroom','Jade Eshete','Alison Thornton','Jeremy Jones','Mark Acheson','Michael Adamthwaite','Julian McMahon','Anja Savcic','Byron Bertram','Daniel Boileau','John Hannah','Tyler Labine','Lee Majdoub','Christopher Russell','Alan Tudyk','Amanda Walsh','Karin Konoval','Aleks Paunovic','Jared Ager-Foster','Sean Campbell','Kelly-Ruth Mercier','Sean Tyson','Emily Tennant','Reese Alexander','Christian Sloan','Agam Darshi','Tony Amendola','Roger Cross','Grayson Gabriel','Françoise Robertson','William Vaughan','Dylan Schombing','Miranda Edwards','Alexia Fast','Simon Ager','Ajay Friese','Laura Mitchell','Mark Brandon','Bronwen Smith','Justine Warrington','Karyn Mott','Hunter Dillon','Jerome Yoo','Hannah Zirke','Andrea Ware','Tyler Gibson','Izzie Steele','Amitai Marmorstein','Trevor Lerner','Donia Kash','Cassandra Naud','David Allan Pearson','Ian Gregson','Robert Lawrenson'],
basedOn:['Douglas Adams'],
screenplay:['Max Landis','Russel Friend','Matt Goldman','Garrett Lerner','Molly Nussbaum','Sinead Daly'],
music:['Cristobal Tapia de Veer','The Newton Brothers'],
camera:['John Pardue','Samy Inayeh'],
cut:['Jamie Alain','Alison Grace','Justin Li','Kye Meechan','Allan Lee'],
sound:['Bill Sheppard','Dean Giammarco'],
scenography:['Thomas William Hallbauer','Gregory Clarke','Sam Higgins'],
masks:['Connie Agawin','Amy Bell','Darci Jackson','Cara Doell','Naomi Bakstad','Victoria Ferguson'],
costumes:['Antoinette Messam','Julie Carnahan']},
{title:"This Is England '88",
titleCZ:"This Is England '88",
year:2011,
runtime:'2h 27min',
episodeRuntime:'47-51min',
countries:['UK'],
genres:['Drama'],
director:['Shane Meadows'],
actors:['Joe Gilgun','Stephen Graham','Thomas Turgoose','Vicky McClure','Alex MacQueen','Dena Smiles','Emily Aston','Jo Hartley','Michael Socha','Johnny Harris','Danielle Watson','Chanel Cresswell','Kieran Hardcastle','Andrew Shim','Andrew Ellis','Rosamund Hanson','George Newton','Muammar Kaddáfí','Katherine Dow Blyton','Hannah Walters','Guy Williams','George Bush','Muammar Kaddáfí','Saddám Husajn',"Jack O'Connell",'Rebecca Manley','Joanna Swain','Helen Behan'],
screenplay:['Shane Meadows','Jack Thorne'],
production:['Mark Herbert'],
camera:['Danny Cohen'],
cut:['Alastair Reid','Jonathan Stenton'],
scenography:['Jane Levick'],
masks:['Nadia Stacey'],
costumes:['Charlotte Walter']},
{title:'Californication',
titleCZ:'Californication',
year:2007,
runtime:'39h 37min',
episodeRuntime:'26-33min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['David Von Ancken','Adam Bernstein','John Dahl','Bart Freundlich','Michael Lehmann','Stephen Hopkins','Scott Winant','Michael Lembeck','Ken Whittingham','Tucker Gates','Scott Z. Burns','David Duchovny','Jake Kasdan','Helen Hunt','Seith Mann','Michael Weaver','Daniel Ducovny','Beth McCarthy-Miller','Millicent Shelton','Eric Stoltz'],
actors:['David Duchovny','Natascha McElhone','Madeleine Martin','Evan Handler','Pamela Adlon','Madeline Zima','Callum Keith Rennie','Rachel Miner','Carla Gallo','Kathleen Turner','Carla Gugino','Camilla Luddington','Stephen Tobolowsky','Paula Marshall','Embeth Davidtz','Eva Amurri Martino','Diane Farr','Zoë Kravitz','Ellen Woglom','Peter Gallagher','Maggie Grace','Addison Timlin','Angus Macfadyen','Michael Ealy','Chris Williams','Ezra Miller','Mädchen Amick','Amy Price-Francis','Rick Springfield','Luenell','Adam Silver','Rob Lowe','Judy Greer','Camille Langfield','Michelle Lombardo','Jonathan Kasdan','Jason Beghe','Michele Nordin','Josh Gad','Larry Poindexter','Patrick Fischler','Kathy Christopherson','Robert Merrill','Carly Pope','Zita Vass','Michaela Watkins','Mark Margolis','Ed Westwick','Justine Bateman','Alexis Arquette','Brian Posehn','Ann Henson','Lucy Davis','Joaquin Pastor','Lynn A. Henderson','Mary Gross','Henry Rollins','Amy Okuda','Damian Young','Angie Patterson','Kristine Blackport','Meredith Monroe','Paul Rae','Megan Stevenson','Stephen Root','Lindsay Stuart','Sheri Moon Zombie','Kevin Corrigan','Fisher Stevens','Alan Dale','Allison McAtee','RZA','Meagan Good','Scott Michael Foster','Vanessa Angel','Ervin Ross','Natalie Zea','Adam Pally','Ashley Watkins','Drea de Matteo','Hal Ozsan','Jim Tavaré','Kathryn Adams','Christina Ulloa','Dustin Ybarra','Tim Minchin','Fiona Gubelmann','Danielle Souza','Nina Rausch','Marilyn Manson','Meghan Falcone','Alison Becker','Cory Knauf',"Keir O'Donnell",'John Laughlin','Camden Gray','Tara Holt','Brian Thompson','Ronnie Gene Blevins','Paola Turbay'],
screenplay:['Tom Kapinos','Ildy Modrovich','Daisy Gardner','Susan McMartin','Eric Weinberg','Gina Fattore','Jay Dyer','Gabriel Roth','Matt Patterson','Vanessa Reisen'],
production:['Ann Kindberg','Lou Fusaro','John H. Radulovic'],
music:['Tyler Bates','Tree Adams'],
camera:['Andy Graham','Tim Bellen','John H. Radulovic','Michael Weaver'],
cut:['Kevin D. Ross','Michael D. Ornstein','Todd Desrosiers','Shannon Mitchell'],
sound:['Ed Carr','Todd Grace','Nicholas R. Allen','Ryan Davis','Rick Norman','Daniel P. Church','Edward L. Moskowitz','Charles Hamilton'],
scenography:['Michael Wylie','Garreth Stover','Michael Z. Hanan','Eric Weiler','Gabrael Wilson','Ray Yamagata','Megan Malley Cannon','Ron Franco','Timothy Stepeck','Maggie Martin','Debra Combs','Chikako Suzuki'],
masks:['Martin Samuel','Vasilios Tanis','Anthony Miner','Laurel Van Dyke'],
costumes:['Peggy A. Schnitzer']},
{title:'Mr. Robot',
titleCZ:'Mr. Robot',
year:2015,
runtime:'36h 52min',
episodeRuntime:'41-65min',
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Niels Arden Oplev','Sam Esmail','Jim McKay','Nisha Ganatra','Deborah Chow','Christoph Schrewe','Tricia Brock'],
actors:['Rami Malek','Carly Chaikin','Christian Slater','Portia Doubleday','Martin Wallström','Michael Cristofer','Stephanie Corneliussen','Michel Gill','Grace Gummer','Gloria Reuben','BD Wong','Omar Metwally','Bobby Cannavale','Sunita Mani','Joey Bada$$','Bruce Altman','Erik Jensen','Michael Drayer','Ron Cephas Jones','Brian Stokes Mitchell','Michele Hicks','Sakina Jaffrey','Frankie Shaw','Armand Schultz','Samrat Chakrabarti','Rick Gonzalez','Ben Rappaport','Susan Pourfar','Gabriel Hansen','Tom Riis Farrell','Gregory Konow','Aaron Takahashi','Michael Buscemi','Randy Harrison','Aimee Spring Fortier','Justin Morck','David Iserson','Nadia Gan','Mark Lotito','Richard Bekins','David H. Holmes','Jeremy Holm','Sandrine Holt','Sahar Bibiyan','David Chen','Marko Caka','Mihran Slougian','Mark Moses','Tom Degnan','Nicholas Dullea','Adrienne Lovette','Andrew Pang','John Wojda','Steven Hauck','Eve Lindley','Elliot Villar','Chris Conroy','Cadden Jones','Alex Esola','Carolina Ravassa','Craig Robinson','Nancy Grace','Rebecca Klingler','Anthony Laciura','Jordan Gelber','Jeremy Bobb','Josh Mostel','Rizwan Manji','Luce Rains','Ralph Alderman','Wallace Shawn','Chloe Levine','Julian Gavilanes','Doug Trapp','Karl Kenzler','Ben Livingston','Dileep Rao','Richard Masur','Elisha Henig','Barack Obama','Donald Trump','Bobby Cannavale','Martin Wallström','Zachery Byrd','Greg Murphy','Hailie Sahar','Matt Mercurio','Alix Elias','Faith Logan','Christine Toy Johnson','Michael Maize',"Soledad O'Brien",'Ramy Youssef','Bernadette Quigley','Lynn Marocola','Friday Chamberlain','Brian Donahue','Megan Channell','Lorrie Odom','Ashlie Atkinson'],
screenplay:['Sam Esmail','David Iserson','Adam Penny','Adam Penn','Amelia Gray','Robbie Pickering','Kyle Bradstreet','Kate Erickson','Lucy Teitler'],
production:['Steve Golin','Margo Myers','Christian Slater','Rami Malek','Kyle Bradstreet','Gregg Tilson'],
music:['Mac Quayle'],
camera:['Tim Ives','Tod Campbell'],
cut:['Sam Seig','Joe Bini','Franklin Peterson','Justin Krohn','John Petaja','Joel T. Pashby','Melissa Lawson Cheung','Philip Harrison','Rosanne Tan','Sharidan Williams-Sotelo','Chris Guiral'],
sound:['John W. Cook II','Michael Barosky','William Freesh','Albert Romero','Albert Ibbotson','Dan Kremer','Kevin W. Buchholz','Sherry Klein','Brett Hinton','Joe White','Dean Okrand'],
scenography:['Anastasia White','Stephen Beatrice','Matthew Munn','Karin Wiesel Holmes','Jacqueline Jacobson Scarfo','Kara Zeigon','Tora Peterson','Miguel López-Castillo'],
masks:['Danielle Minnella','Madeline McCue','Tricia Heine','Rebecca Hickey'],
costumes:['Mairi Chisholm','Catherine Marie Thomas','Kim Wilcox']},
{title:'Brickleberry',
titleCZ:'Brickleberry',
year:2012,
runtime:'13h 9min',
episodeRuntime:'21-22min',
countries:['USA'],
genres:['Animation','Comedy'],
director:['Zac Moncrief','Susie Dietter','Ira Sherak','Spencer Laudiero','Bert Ring','Ashley J. Long','Matthew Long','Carl Faruolo','Mike Hollingsworth','Seung Woo Cha','Brian LoSchiavo'],
actors:['Daniel Tosh','Kaitlin Olson','David Herman','Tom Kenny','Roger Black',"Waco O'Guin",'Jerry Minor','Tara Strong','Sheetal Sheth','Natasha Leggero','John DiMaggio','Grey Griffin','Toby Huss','Mark Hamill','Carlos Alazraqui','Maurice LaMarche','Tress MacNeille','Josef Powell'],
screenplay:["Waco O'Guin",'Roger Black','Rocky Russo','Jeremy Sosenko','Kevin Jakubowski','Lewis Morton','Eric Rogers','Michael Rowe','Peter Tibbals','Josh Weinstein','Deepak Sethi','Christopher Vane','Greg White','Kyle Stegina','Josh Lehrman','Lisa Parsons','Sivert Glarum','Michael Jamin'],
music:['Nicolas Barry','Rene Garza Aldape','Tomas Jacobi','Alejandro Valencia',"Waco O'Guin"],
cut:['Chris Vallance','Andy Tauke'],
sound:['Hunter Curra','Konrad Piñon','Mike Greenberg']},
{title:'When They See Us',
titleCZ:'Když nás vidí',
year:2019,
runtime:'4h 56min',
episodeRuntime:'64-88min',
countries:['USA'],
genres:['Drama','Crime'],
director:['Ava DuVernay'],
actors:['Jovan Adepo','Kylie Bunbury','Chris Chalk','Omar J. Dorsey','Aunjanue Ellis-Taylor','Vera Farmiga','Caleel Harris','Felicity Huffman','Chris Jackson','Joshua Jackson','Famke Janssen','Jharrel Jerome','John Leguizamo','Niecy Nash','Adepero Oduye','Aurora Perrineau','Storm Reid','Marquis Rodriguez','William Sadler','Andrew Stewart-Jones','Blair Underwood','Michael Kenneth Williams','Suzzanne Douglass','Jayce Bartok','Frank Pando','Joseph Adams','Vincent De Paul','Jaishon Fisher','Jamar Greene','Henry Hunter Hall','Aamira Martinez','Reece Noi','Gary Perez','Derrick Simmons','Wass Stevens','Colin Walker','Ty Jones','Bruce MacVittie','Robbie Tann','Len Cariou','Asante Blackk','Lynn Marocola','Donald Trump','Reginald L. Barnes','Marsha Stephanie Blake','Justin Cunningham','Ethan Herisse','Dascha Polanco','Freddy Miyares','Kate Easton','Berto Colon','Taylor Selé','Robert G. McKay','Michael Devine','Tyler Dean Flores','Maliq Johnson','Ivory Aquino','Bryan Terrell Clark','Michael Andreaus','Mark Borkowski','Logan Crawford','Jake Ryan Lozano','Edward Carnevale','Elijah Richardson','Christine Spang','Isis King','Patrick Gallo','Ariel Shafir','Maxwell Whittington-Cooper','Kevin Richardson'],
screenplay:['Ava DuVernay','Julian Breece','Robin Swicord','Attica Locke','Michael Starrbury'],
music:['Kris Bowers'],
camera:['Bradford Young'],
cut:['Spencer Averick','Terilyn A. Shropshire','Michelle Tesoro'],
sound:['Joe DeAngelis','Suat Onur Ayas','John Benson','Chris Carpenter'],
scenography:['Akin McKenzie','Henry Dunn','Kara Zeigon'],
masks:['Lena Jemmott'],
costumes:['Caroline Duncan']},
{title:'Wentworth Prison',
titleCZ:'Wentworth',
year:2013,
runtime:'79h 18min',
episodeRuntime:'44-60min',
countries:['Australia'],
genres:['Crime','Drama'],
director:['Kevin Carlin','Steve Jodrell','Catherine Millar','Pino Amenta','Dee McLachlan','Adrian Russell Wills','Mat King','Fiona Banks','Roger Hodgman','Sian Davies','Jet Wilkinson','Beck Cole','Corrie Chen'],
actors:['Danielle Cormack','Kate Atkinson','Celia Ireland','Shareena Clanton','Robbie Magasiva','Katrina Milosevic','Jacqueline Brennan','Nicole da Silva','Pamela Rabe','Aaron Jeffery','Catherine McClements','Leeanna Walsman','Richard Sutherland','Ra Chapman','Claudia Greenstone','Georgia Chara','Damon Gameau','Louise Harris','Syd Brisbane','Alex Menglet','Bernard Curry','Melanie Lockman','Nicole Gulasekharam','Socratis Otto','Paul McDermott','Andy McPhee','Frankie Adams','Martin Sacks','Cassandra Magrath','Reef Ireland','John Bach','Annie Jones','Paul Ireland','Lynette Curran','Steve Le Marquand','John Brumpton','Tasia Zalar','Pia Miranda','Tammy MacIntosh','Sarah Howett','Liddy Clark','Sebastian Bertoli','Kate Jenkinson','Martin Sharpe','Tom Budge','Sigrid Thornton','Steve Bastoni','Jeremy Stanford','Hunter Page-Lochard','Shannon Glowacki','Georgia Flood','Gareth Reeves','Damien Richardson','Libby Tanner','Leah Purcell','Ian Bliss','Shane Connor','Susie Porter','Kate Elliott','Marny Kennedy','Debra Lawrance','Virginia Cashmere','Thomas Fisher','Anne Charleston','Kris McQuade','Rarriwuy Hick','David Cormick','Gary Bennett','Lester Ellis Jr.','Anne McCaffery-French','Zahra Newman','Pete McTighe','Tony Briggs','Anthony J. Sharpe','Phoenix Raei','Maria Angelico','Alexandra Schepisi','Georgina Naidu','Kate Box','David de Lautour','Kevin Harrington','Tom Wren','Luke McKenzie','Rachael Maza','Carolyn Bock','Katherine Tonkin','Jada Alberts','Mereoni Vuki','Alexandra Fowler','Lawrence Mooney','Julie Forsyth','Bessie Holland','Maddy Jevic','Stephen Ballantyne','Emily Havea','Huw Higginson','Emma-Louise Wilson','Marta Dusseldorp','Katherine Halliday','Simon Maiden'],
screenplay:['Reg Watson','Lara Radulovich','John Ridley','Andrew Anastasios','Marcia Gardner','Adam Todd','Samantha Winston','Stuart Page','Pete McTighe','Jane Allen','John Ridley','Kim Wilson','Michael Lucas','Giula Sandler','Lally Katz'],
production:['Pino Amenta'],
music:['Richard Pleasance'],
camera:['Craig Barden','Kathy Chambers'],
cut:['Ben Joss','Amelia Ford','Philip Watts','Geoff Hitchins'],
sound:['Paul Pirola','Ralph Ortner','John McKerrow'],
scenography:['Kate Saunders'],
masks:['Dyan Gregoriou'],
costumes:['Cappi Ireland','Michael Davies']},
{title:'Our Boys',
titleCZ:'Naši kluci',
year:2019,
runtime:'9h 41min',
episodeRuntime:'53-61min',
countries:['USA'],
genres:['Drama'],
director:['Joseph Cedar','Tawfik Abu Wael'],
actors:['Michael Aloni','Lior Ashkenazi','Shadi Mar´i','Noa Kooler','Tzahi Grad','Shlomi Elkabetz','Johnny Arbid','Ruba Blal','Moris Cohen','Yoram Toledano','Tom Gal','Liraz Chamami','Slava Bibergal'],
screenplay:['Joseph Cedar','Tawfik Abu Wael','Hagai Levi'],
music:['Yishai Adar'],
camera:['Yaron Scharf'],
sound:['Ami Arad'],
scenography:['Arad Sawat'],
masks:['Ronit Dugo-Arbiv']},
{title:'The Scooby-Doo Show',
titleCZ:'The Scooby-Doo Show',
year:1976,
runtime:'15h 28min',
episodeRuntime:'22-24min',
countries:['USA'],
genres:['Animation','Adventure','Comedy','Mystery','Family'],
director:['Charles A. Nichols','Alex Lovy'],
actors:['Patricia Stevens','Frank Welker','Casey Kasem','Don Messick','Heather North','John Stephenson','Janet Waldo','Daws Butler','Alan Oppenheimer','Shirley Mitchell','Michael Bell','Regis Cordic','Henry Corden','Gary Owens','Ron Feinberg','Virginia Gregg','Vic Perrin','Lennie Weinrib','Micky Dolenz','Bob Holt','Allan Melvin','Hal Smith'],
screenplay:['Michael Maurer','Orville H. Hampton','Lee Orgel','Dick Conway','Haskell Barkin','Donald F. Glut','Norman Maurer','David Ketchum','Duane Poole','Dick Robbins'],
music:['Hoyt Curtin'],
cut:['Chip Yaras'],
scenography:['Bob Singer']},
{title:'Doctor Who',
titleCZ:'Pán času',
year:2005,
runtime:'155h 57min',
episodeRuntime:'42-88min',
countries:['UK'],
genres:['Sci-Fi','Fantasy','Adventure','Drama'],
director:['Graeme Harper','James Strong','James Hawes','Joe Ahearne','Charlie Palmer','Keith Boak','Colin Teague','Dan Zeff','Nick Hurran','Euros Lyn','Adam Smith','Hettie MacDonald','Farren Blackburn','Richard Clark','Andy Goddard','Paul Wilmshurst','Stephen Woolfenden','Peter Hoar','Ben Wheatley','Jeremy Webb','Justin Molotnikov','Alice Troughton','Brian Grant','Douglas Mackinnon',"Daniel O'Hara",'Edward Bazalgette','Daniel Nettheim','Rachel Talalay','Lawrence Gough','Sheree Folkson','Saul Metzstein','Andrew Gunn','Jonny Campbell','Catherine Morshead','Ashley Way','Toby Haynes','Julian Simpson','Colm McCarthy','Jamie Payne','Mat King','Steve Hughes','Bill Anderson','Wayne Yip','Mark Tonderai','Jamie Childs','Sallie Aprahamian','Jennifer Perrott','Paul Murphy','Jamie Magnus Stone','Lee Haven Jones','Nida Manzoor','Emma Sullivan','Azhur Saleem','Annetta Laufer','Haolu Wang','Julie Anne Robinson','Tom Kingsley','Chanya Button'],
actors:['Peter Capaldi','Matt Smith','David Tennant','Jodie Whittaker','Ncuti Gatwa','Christopher Eccleston','Billie Piper','Karen Gillan','Arthur Darvill','Catherine Tate','Freema Agyeman','Alex Kingston','Jenna Coleman','Noel Clarke','John Barrowman','John Simm','Samuel Anderson','Anita Briem','Abdul Salis','Zoë Wanamaker','MyAnna Buring','Tamsin Greig','Thomas Brodie-Sangster','Elize du Toit','Michelle Ryan','Colin Morgan','Andrée Bernard','Ryan Carnes','Lenora Crichlow','Sara Stewart','Christina Cole',"Ardal O'Hanlon",'Gabriel Woolf','Derek Jacobi','Richard Dawkins','Sharon Osbourne','Alexander Armstrong','Lesley Sharp','Eve Myles','Gareth David-Lloyd','Naoko Mori','Talulah Riley','Carey Mulligan','Joe Dempsie','Sarah Smart','Ayesha Dharker','Anthony Head','Adrian Rawlins','Simon Pegg','Anna Maxwell Martin','Sophia Myles','Lee Evans','Steve Pemberton','Mark Gatiss','Harry Lloyd','Adam Garcia','Timothy Dalton','Lindsay Duncan','Sarah Parish','Claire Bloom','Robert Pugh','Andrew Garfield','Dean Lennox Kelly','Tony Curran','Elizabeth Croft','Claire Rushbrook','Richard Wilson','Olivia Colman','Ron Cook','Ian McNeice','Nina Sosanya','Miranda Raison','Murray Gold','David Harewood','Finlay Robertson','Christine Adams','Bill Paterson','Laurence Belcher','Gemma Chan','Elisabeth Sladen','Daniel Kaluuya','Florence Hoath','Tom Goodman-Hill','Jessica Raine','Roy Marsden','Gugu Mbatha-Raw','Michelle Duncan','Amy Beth Hayes','Matt King','Alexandra Moen','Christopher Ryan','Gabriella Wilde','Clive Standen','Sebastian Armesto','Peter Brooke','Claire Skinner',"Peter O'Brien",'Amara Karan','Simon Pearsall','Paul Anderson'],
basedOn:['Charles Dickens'],
screenplay:['Russell T. Davies','Steven Moffat','Mark Gatiss','Steve Thompson','Toby Whithouse','Neil Gaiman','Richard Curtis','Tom MacRae','Neil Cross','Chris Chibnall','James Moran','Peter Harness','Frank Cottrell Boyce','Gareth Roberts','Rona Munro','Mike Bartlett','Jamie Mathieson','Simon Nye','Malcolm Hulke','Helen Raynor','Pete McTighe','Catherine Tregenna','Ed Hime','Malorie Blackman','Joy Wilkinson','Matthew Graham','Sarah Dollard','Phil Ford','Nina Metivier','Charlene James','Stephen Greenhorn'],
production:['Susie Liggat','Nikki Wilson','Tracie Simpson','Marcus Wilson','Sanne Wohlenberg','Peter Bennett','Adam Friedlander','Phil Collinson','Alex Mercer','Chris May','Denise Paul'],
music:['Murray Gold','Segun Akinola','Högni Egilsson','Jake Jackson'],
camera:['Stephan Pehrsson','Simon Dennis','Erik Wilson','Ashley Rowe','Ali Asad','Richard Stoddard','Balazs Bolygo','Mike Southon','Neville Kidd','Owen McPolin','Gavin Struthers','Graham Frake','Mark Garrett','Simon Archer','Dale McCready','Nic Morris','G. Magni Ágústsson','Damian Bromley','Jake Polonsky','Tony Slater Ling','Ernest Vincze','Suzie Lavelle','Stuart Biddlecombe','Tim Palmer','Denis Crossan','Tico Poulakakis','Simon Chapman','Catherine Goldschmidt','Ed Moore','Mark Waters','Robin Whenary','Mike Spragg','Tobias Datum','Miroslaw Baszak','Mika Orasmaa','Nick Dance','Matt Gray'],
cut:['William Oswald','Matthew Newman','Jamie Pearson','Anthony Boys','Philip Kloss','Matthew Cannings','Alan Levy','Nick Arthurs','John Richards','Iain Erskine','Selina Macarthur','Liana Del Giudice','Crispin Green','Graham Walker','Adam Trotman','Jamie McCoan','Tim Hodges','Anthony Combes','Matthew Tabern','David Fisher','Helen Murphy','Úna Ní Dhonghaíle','Mike Jones','Sam Williams','Adam Green','Joel Skinner','Philip Hookway','Edel McDonnell','Tom Chapman','Lucien Clayton','Peter Oliver','Ulrike Münch','Tim Porter','Mark Trend','Becky Trotman'],
sound:['Bryn Thomas','Deian Humphreys','Ray Parker','Julian Howarth','Burak Topalakçı','Dom Corbisiero','Harry Barnes','Alex Thompson'],
scenography:['Michael Pickwoad','Amy Pickwoad','Edward Thomas','Arwel Jones','Vicki Male','Dafydd Shurmer','Lucienne Suren','Phil Sims'],
masks:['Claire Pritchard','Alison Webb','Angharad Walsh','Megan Bowes','David Malinowski','Cailin Nicolson','Moira Thomson','Stevie Smith','Göran Lundström'],
costumes:['Howard Burden','Ray Holman','Edward K. Gibbon','Hayley Nebauer','Charlotte Graf','Louise Page','Lucinda Wright','Pam Downe']},
{title:'Catch-22',
titleCZ:'Hlava 22',
year:2019,
runtime:'4h 24min',
episodeRuntime:'44min',
countries:['USA'],
genres:['War','History','Drama','Crime','Comedy'],
director:['Ellen Kuras','Grant Heslov','George Clooney'],
actors:['Christopher Abbott','Kyle Chandler','Rafi Gavron','Graham Patrick Martin','Lewis Pullman','Austin Stowell','Pico Alexander','Jon Rudnitsky','Gerran Howell','Hugh Laurie','Giancarlo Giannini','George Clooney',"Kevin J. O'Connor",'Tessa Ferrer','Grant Heslov','Jay Paulson','Julie Ann Emery','Valentina Bellè','Joe Massingill','Josh Bolt','Freddie Watkins','Aaron Stielstra','Anthony Skordi','Nicola Goodchild','Jamie Blackley','Jackson Bews','Leonardo Cecchi','Nicholas Moss','Joseph Millson','Peter Guinness','Preston Nyman','Giusi Merli','Valentina Ruggeri','Ian Toner','Harrison Osterfield','Sara Pallini','Daniel David Stewart','Alison Pargeter','Sergio Bini Bustric','Domenico Cuomo','Grazia Leone','Arduino Speranza','Lorenzo Pozzan','Marilena Anniballi'],
basedOn:['Joseph Heller'],
screenplay:['Luke Davies','David Michôd'],
production:['Ellen Kuras'],
music:['Rupert Gregson-Williams','Harry Gregson-Williams'],
camera:['Martin Ruhe'],
cut:['Michael Ruscio','Tanya M. Swerling'],
sound:['Todd Beckett'],
scenography:['David Gropman','Anna Pinnock'],
masks:['Francesca Giorgino','Domingo Santoro'],
costumes:['Jenny Eagan']},
{title:'Carnivàle',
titleCZ:'Carnivale',
year:2003,
runtime:'20h 17min',
episodeRuntime:'44-56min',
countries:['USA'],
genres:['Drama','Thriller','Mystery'],
director:['Rodrigo García','Tim Hunter','Jack Bender','John Patterson','Jeremy Podeswa','Scott Winant','Steve Shill','Tucker Gates','Peter Medak','Alison Maclean','Alan Taylor','Todd Field','Dan Lerner'],
actors:['Michael J. Anderson','Nick Stahl','Adrienne Barbeau','Patrick Bauchau','Debra Christofferson','Tim DeKay','Cynthia Ettinger','John Fleck','Carla Gallo','Toby Huss','Amy Madigan','Diane Salinger','Karyne Steben','John Carroll Lynch','Clea DuVall','Clancy Brown','Scott Fishkind','Robert Knepper','Jenna Boyd','Ralph Waite','Susan Walters','Bill Moseley','Lisa K. Wyatt','Dakin Matthews','Frank Collison','Ted Rooney','Richard Fancy',"Michael O'Neill",'Jimmi Simpson','John Savage','Erin Sanders','Judith Hoag','Don Swayze','Stephen White','Aria Wallace','Joseph Sikora','Lorna Scott','Darin Cooper','Jim Cody Williams','George Cheung','Vlad Kozlov','Michael Robert Brandon','Peter Jason','Lou Glenn','Jon Gries','John Aylward','Spencer Garrett','Ritchie Montgomery','Raymond Ma',"Derrick O'Connor",'William Bassett','Tye Alexander','Amanda Aday','Brett Rickaby','Hawthorne James','Time Winters','Octavio Gómez Berríos','Jeff Doucette','Joe Unger','Tony Perez','E.J. Callahan','Steph DuVall','Billy Beck','Kyle Dietz','Leonard Kelly-Young','Valeria Hernandez','Luis Contreras','Scott MacDonald','Vincent De Paul','Scott Vance','Ron Perkins','Wolf Muser','Joshua Harto','Marco Morales','Christopher Murray','Kim Robillard','Michael Massee','K Callan','Lucinda Jenney','Jack McGee','Matthew McGrory','Jane Adams','Gregory Sporleder','Brent Hinkley','Glenn Shadix','Matt McCoy','Charles Robinson','Gabriel Mann','Jesse Burch','John Hannah','Thomas Kopache','Michael Cavanaugh','John Doe','Linda Hunt','Saemi Nakamura','Kurt Fuller','Mark Boone Junior','Leo Fitzpatrick','Fay Masterson','Ellen Geer'],
screenplay:['Daniel Knauf','Ronald D. Moore','Tracy Tormé','Dawn Prestwich','Nicole Yorkin','Henry Bromell','John J. McLaughlin','Toni Graphia'],
production:['Bernadette Caulfield','Anthony Santa Croce'],
music:['Jeff Beal'],
camera:['Jim Denault','Tami Reiker','Jeffrey Jur','James Glennon'],
cut:['Carole Kravetz Aykanian','David Siegel','Leo Trombetta','Peter B. Ellis','Jacques Gravett','Monty DeGraff'],
sound:['Mace Matiosian',"Andy D'Addario",'Lisle Engle','Yuri Reese','Sherry Klein','William Smith','Aaron Levy','Richard L. Morrison','Alan Decker','Verna Mandel','Matt Sawelson','Chris Haire','David B. Cohn','Peter Bentley','William H. Angarola'],
scenography:['Dan Bishop','Bernt Amadeus Capra','Sara Andrews','Leslie McCarthy-Frankenheimer','Gary Kosko'],
masks:['William Howard','Louisa V. Anthony','Rick Sharp','Carol Pershing'],
costumes:['Ruth Myers','Terry Dresbach','Chrisi Karvonides-Dushenko']},
{title:'I Know This Much Is True',
titleCZ:'Bludné kruhy',
year:2020,
runtime:'5h 58min',
episodeRuntime:'59-60min',
countries:['USA'],
genres:['Drama'],
director:['Derek Cianfrance'],
actors:['Mark Ruffalo','Melissa Leo','John Procaccino','Rob Huebel','Kathryn Hahn',"Rosie O'Donnell",'Michael Greyeyes','Imogen Poots','Juliette Lewis','Archie Panjabi','Philip Ettinger','Donnie Masihi','Rocco Masihi','Gabe Fazio','A.C. Peterson','Guillermo Díaz','Marylouise Burke','Brian Goodman','Laura Silverman','Annie Fitzgerald','Joseph Ragno','Laura Esterman','Christopher J. Hanke','James Quattrochi','Brandon J. Dirden','Katt Masterson','Aisling Franciosi','Bruce Greenwood','Roberta Rigano','Robert Mladinich','MorningStar Angeline','Kate Grimes','Sue Jean Kim','Destry Allyn Spielberg','Matt Helm','Jason Furlani','Rachel B. Joyce','Raymond Neil Hernandez','Irene Muscara'],
basedOn:['Wally Lamb'],
screenplay:['Derek Cianfrance'],
production:['Judith Regan'],
camera:['Jody Lee Lipes'],
cut:['Jim Helton','Malcolm Jamieson','Nico Leunen','Dean Palisch','Ron Patane'],
sound:['Mariusz Glabinski'],
scenography:['Inbal Weinberg','Nicole Montagnino'],
masks:['David Kalahiki','Julie Teel','Michael Marino'],
costumes:['Kasia Walicka-Maimone']},
{title:'My Hero Academia',
titleCZ:'Boku no Hero Academia',
year:2016,
runtime:'59h 21min',
episodeRuntime:'23-24min',
countries:['Japan'],
genres:['Animation','Action','Fantasy'],
director:['Kendži Nagasaki','Masahiro Mukai','Jošifumi Sasahara','Kó Macuo','Šindži Sató','Satoši Nakagawa','Takanori Jano','Ikuró Sató','Daisuke Cukuši','Takudai Kakuči','Hitomi Ezoe','Júsuke Kamata','Naoki Hišikawa','Takaši Kawabata','Geisei Morita','Takahiro Hasui','Motonobu Hori','Mičio Fukuda','Masato Mijoši','Minoru Óhara','Takuró Cukada','Tomohiro Kamitani','Masatojo Takada','Satoši Takafudži','Jóhei Fukui','Hakuju Go','Kacumi Terahigaši'],
actors:['Daiki Jamašita','Nobuhiko Okamoto','Aoi Júki',"Džun'iči Suwabe",'Tasuku Hatanaka','Akeno Watanabe','Kósuke Kuwano','Inuko Inujama','Eri Kitamura','Kóki Učijama','Marina Inoue','Kaito Išikawa','Tošiki Masuda','Jošimasa Hosoja','Tóru Nara','Minoru Inaba','Kenta Mijake','Hirojuki Jošino','Ajane Sakura','Kijotaka Furušima','Jasuhiro Takato','Kaori Nazuka','Cuguo Mogami','Sači Kokurjú','Kei Šindó','Kenta Ókuma','Sajaka Kitahara','Kósuke Mijoši',"Šin'ja Fukumacu",'Júja Murakami','Fukuši Očiai','Jú Šimamura','Nacuki Aikawa','Kazuhiro Fusegawa','Gó Inoue','Misato Fukuen','Júki Kadži','Akio Ócuka','Kóhei Amasaki','Rjóta Iwasaki','Sara Macumoto','Júki Sanpei','Kacunori Okai','Čisa Suganuma','Ajano Šibuja','Takahiro Sumi','Kensuke Óta','Rjó Hirohaši','Noriaki Kanze','Masaja Fukuniši','Júki Šin','Keitaró Tanaka','Kódži Okino','Keiiči Nakagawa','Ecuko Kozakura','Tokujoši Kawašima','Masamiči Kitada','Masakazu Nišida','Šúhei Macuda','Šinnosuke Ogami','Takahiro Fudžiwara','Aja Kawakami',"Ken'iči Ogata",'Wataru Hatano','Tecu Inada','Azu Sakura','Saki Ogasawara','Miho Masaka','Mičiko Neja','Hikaru Midorikawa','KENN','Rjóta Takeuči','Seiró Ogino','Tomokazu Seki','Ami Košimizu','Anri Kacu','Akio Sujama','Jošihito Sasaki','Takuma Nagacuka','Hiro Šimono','Mičiru Jamazaki','Kósuke Takaguči','Meiko Kawasaki','Rjó Iwasaki','Jošicugu Macuoka','Kenta Kamakari','Mie Sonozaki','Masaaki Ihara','Masami Iwasaki','Minori Čihara','Megumi Han','Júta Kasuja','Makoto Furukawa','Jó Kitazawa','Mariko Nagai','Satoru Inoue','Tošicugu Takašina','Daiki Hamano','Reina Ueda',"Ken'ičiró Macuda"],
basedOn:['Kóhei Horikoši'],
screenplay:['Jósuke Kuroda'],
production:['Jošihiro Ójabu','Kódži Nagai'],
music:['Júki Hajaši'],
camera:['Masataka Ikegami','Takaši Sawa'],
cut:['Kumiko Sakamoto'],
sound:['Masafumi Mima'],
scenography:['Šigemi Ikeda','Jukiko Marujama']},
{title:'Call the Midwife',
titleCZ:'Zavolejte porodní sestřičky',
year:2012,
runtime:'105h 39min',
episodeRuntime:'52-90min',
countries:['UK'],
genres:['Drama','History'],
director:['Jamie Payne','Juliet May','Dominic Leclerc','Minkie Spiro','Philippa Lowthorpe','Roger Goldby','James Larkin','Syd Macartney','Claire Winyard','China Moo-Young','Thea Sharrock',"Thaddeus O'Sullivan",'Amy Neil','Sheree Folkson','Rebecca Johnson','Lisa Clarke','Kate Cheeseman','Emma Sullivan','Ann Tricklebank','Kate Saxon','Noreen Kershaw'],
actors:['Vanessa Redgrave','Jenny Agutter','Laura Main','Judy Parfitt','Helen George','Bryony Hannah','Pam Ferris','Ben Caplan','Miranda Hart','Jack Ashton','Jessica Raine','Linda Bassett','Annabelle Apsion','Cheryl Campbell','Simon Sherlock','Gethin Anthony','Aimée Kelly','Ronald Pickup','Monica Dolan','Sharon Small','Jamie Thomas King','Claudie Blakley','Rosalind March','Tom Goodman-Hill','Cara Theobold','Kika Markham','Jennifer Aries','Darwin Shaw','Hayley Squires','Leanne Rowe','Lucy Russell','Lacey Turner','Warren Clarke','Karl Johnson','Lucy Robinson','Matilda Ziegler','Claire-Louise Cordwell','Velile Tshabalala','Jason Watkins','Nell Hudson','Tara Ellis','Robert Putt','Reece Buttery','Anthony Calf','Trevor Martin','Emily Taaffe','Hannah Tointon','Raymond Coulthard','Christopher Dane','Tristan Gemmill','Tommy McDonnell','Stanley Townsend','Louisa Connolly-Burnham','Nicholas Farrell','Zandra Andersson','Louise Dylan','Olivia Llewellyn','David Kennedy','Nancy Carroll','Sandi Toksvig','Michelle Duncan','Ruth Sheen','Maxine Evans','Maria Doyle Kennedy','Rita Davies','Daniel van der Molen','Teresa Churcher','Kate Copeland','Sam Crane','Eileen Davies','David Ryall','Adrian Scarborough','Una Stubbs','Michael Vardian','Lisa Ronaghan','Rachel Marquez','Ella Smith','George Russo','Claudia Jessie','Mia Austen','Sarah Finigan','Nick Hendrix','Killian Scott','Lily-Rose Aslandogdu','Elizabeth Webster','Trixiebell Harrowell','Susan Brown','Reece Pockney','Doron Davidson','Simon Armstrong','Chris Reilly','Jem Wall','Raewyn Lippert','Sheila Reid','Thomasin Rand','Jim Conway','Glen Davies','Sophie Cosson','James Greene','Leo Staar'],
screenplay:['Heidi Thomas','Jack Williams','Harriet Warner','Kelly Jones','Lauren Klee','Andrea Gibb','Esther Wilson','Damian Wayling','Gabbie Asher','Liz Lake','Lisa Holdsworth','Helen Blakeman','Nicola Wilson','Louise Ironside','Amy Roberts','Jess Williams'],
production:['Ann Tricklebank','Hugh Warren'],
music:['Peter Salem','Maurizio Malagnini','Jake Jackson'],
camera:['Chris Seager','Ulf Brantås','Polly Morgan','James Aspinall','Mark Garrett','Simon Archer','Stuart Biddlecombe','Nick Dance','Toby Moore','Mark Waters','John Rhodes','Len Gowing','Henry Pierce','Sean Van Hales'],
cut:['Mary Finlay','Les Healey','Beverley Mills','Vicky Tooms','Daniel Greenway','David Thrasher','Jamie McCoan','Mark Thornton','Rachel Hoult','Al Morrow','Alex Kalmakrian',"St. John O'Rorke",'Charlene Short','Stephen Young','Jan Deas',"David I'Anson",'Fiona Starogardzki','Jake Bernard','Paul Brown','John Dwelly','Hannah Jeal','Simon Brasse'],
sound:['Martin Jensen','Cassandra Rutledge','Diethard Keck','Steve Phillips'],
scenography:['Eve Stewart','Lotty Sanna','Simon Walker','Sarah-Jane Prentice'],
masks:['Amanda Finlay','Siân Miller','Natasha Richards'],
costumes:['Amy Roberts','Nigel Egerton','June Nevin','Claire Lynch']},
{title:'Mushi-Shi',
titleCZ:'Mušiši',
year:2005,
runtime:'10h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Mystery','Psychology','Thriller'],
director:['Hiroši Nagahama','Osamu Jamasaki','Tacujuki Nagai','Kóičiró Sótome','Kazu Jokota','Tošinori Narita','Rjó Mijata','Šinpei Mijašita',"Ken'iči Imaizumi",'Akira Mano','Šintaró Inokawa'],
actors:['Júto Nakano','Ai Kobajaši','Juka Imai','Júdži Ueda','Maaja Sakamoto','Mijuki Sawaširo','Mika Doi','Takeši Aono','Rina Sató','Akemi Okamura','Makoto Jasumura','Eidži Takemoto','Masami Iwasaki','Juri Amano','Masahito Jabe','Ami Košimizu','Rion Kako','Šizuka Okohira','Džunko Midori','Šindži Kawada','Marija Ise','Júko Sanpei','Jošikazu Nagano','Hjósei','Haruhi Nanao','Takeši Maeda','Kódži Išii','Tomoko Kawakami','Hiroko Kasahara','Acuko Bungo','Džun Hazumi','Akira Nakagawa','Susumu Akagi','Kaori Nazuka','Ajaka Saitó','Kjóko Čikiri','Hiroši Šimozaki','Jošiko Iseki','Jošisada Sakaguči','Jošihisa Kawahara','Hisako Kjóda','Takaši Macujama','Kudžira','Kaori Šimizu','Čiemi Čiba','Rjó Naitó','Reiko Jasuhara','Jútaró Hondžó','Keiko Nakamura','Kokoro Kikuči','Kazuhiro Jamadži','Džunko Iwao','Akio Nodžima','Jume Mijamoto','Satomi Hanamura','Hiroši Širokuma','Cujoši Kojama','Miki Ótani','Mičiru Wada','Júna Inamura','Jošiko Takemura','Naoto Adači','Azusa Nakao','Kóiči Nagano','Mika Itó','Wahei Iida','Midori Tamai','Tamio Sobami','Jošihiro Nozoe','Hiroko Igaraši','Fudžita Daisuke','Satomi Akesaka','Júko Šima','Masami Suzuki','Eri Mijadžima','Narumi Hidaka','Júko Mogi','Rjúiči Horibe','Mijú Cuzurahara','Džin Nišimura','Mari Adači','Tomomi Seo','Jukari Kokubun','Suguru Inoue','Kaori Fukumori','Sei Hirajama','Kazuki Macuoka','Šigeru Wakita','Júma Tamura','Čihiro Jarita','Akari Kudó','Šigemi Tanaka','Takuja Tačibana','Majumi Cučija','Kačiko Hino','Akiko Oka','Araši Curutani','Acuši Sekiguči','Kana Honda','Tai Kagejama'],
basedOn:['Juki Urušibara'],
screenplay:['Juka Jamada','Aki Itami','Kinuko Kuwahata'],
production:['Šin Hieda'],
music:['Tošio Masuda'],
camera:['Júki Hama'],
cut:['Masahiro Macumura'],
sound:['Kazuja Tanaka'],
scenography:['Takeši Waki']},
{title:'Regular Show',
titleCZ:'Normálka',
year:2009,
runtime:'47h 48min',
episodeRuntime:'11-23min',
countries:['USA'],
genres:['Animation','Comedy'],
director:['John Davis Infantino','Sean Szeles','J.G. Quintel','Mike Roth','Calvin Wong','Richard Collado','Robert Alvarez','Brian Sheesley','Lindsey Pollard'],
actors:['Mark Hamill','Robin Atkin Downes','David Kaye','Linda Cardellini','Robert Englund','Carl Weathers','Donald Glover','James Hong','Steve Blum','Rich Fulcher','David Ogden Stiers',"Tommy 'Tiny' Lister",'Paul F. Tompkins','Tim Curry','Jennifer Hale','Courtenay Taylor','Roger Rose','Alastair Duncan','Natasha Leggero','Katey Sagal','Steve Agee','Debra Wilson','Bobcat Goldthwait','Kevin Michael Richardson','Mitzi McCall','Roger Craig Smith','Scott MacDonald','Awkwafina','Elizabeth Pan','Edie McClurg','John Cygan','April Stewart','James Adomian','J.G. Quintel','Andres Salaff','MC Lyte','Matthew Yang King',"Liam O'Brien",'Julián Rebolledo','Josh Keaton','Eddie Pepitone','Minty Lewis','Sean Szeles','Matt Price','William Salyers','Sam Marin','Jeff Bennett','Janie Haddad Tompkins','Yuri Lowenthal','Julian Holloway','David Sobolov','Richard McGonagle','James Sie','Emre Çambel','Tyler the Creator','Laura Bailey','Ben Diskin','S. Scott Bullock','Kate Higgins','B.J. Ward','Lex Lang','Andrew Kishino','Toby Jones','Sunil Malhotra','Roger Jackson'],
screenplay:['John Davis Infantino','Kent Osborne','Henry Yu','J.G. Quintel','Andres Salaff','Shion Takeuchi','Owen Dennis','Calvin Wong','Darrick Bachman','Michele Cavin','James Kim','Minty Lewis','Sean Szeles','Ryan Pequin','Madeline Queripel','Matt Price','Mike Roth','Bill Oakley','Jake Armstrong','Kat Morris','Paul Scarlata','Jack C. Thomas','Casey Crowe','Gina Ippolito','Hilary Florido','Hellen Jo','Alex Cline','Sarah Oleksyk','Toby Jones','Nathan Bulmer'],
production:['Sean Szeles','Ryan Slater','Janet Dimon','Mike Roth','Chris Reccardi'],
music:['Mark Mothersbaugh','John Enroth','Albert Fox'],
cut:['Bobby Gibis'],
sound:['Timothy J. Borquez','Tony Orozco','Eric Freeman'],
scenography:['Paula Spence']},
{title:'The Dark Crystal: Age of Resistance',
titleCZ:'Temný krystal: Věk vzdoru',
year:2019,
runtime:'8h 28min',
episodeRuntime:'47-61min',
countries:['USA','UK'],
genres:['Puppets','Adventure','Drama','Family','Fantasy','Sci-Fi'],
director:['Louis Leterrier'],
actors:['Hannah John-Kamen','Caitríona Balfe','Helena Bonham Carter','Dave Chapman','Harris Dickinson','Natalie Dormer','Taron Egerton','Nathalie Emmanuel','Harvey Fierstein','Mark Hamill','Ralph Ineson','Jason Isaacs','Eddie Izzard','Theo James','Toby Jones','Keegan-Michael Key','Shazad Latif','Gugu Mbatha-Raw','Simon Pegg','Andy Samberg','Mark Strong','Anya Taylor-Joy','Alicia Vikander','Ólafur Darri Ólafsson','Beccy Henderson','Victor Yerrid','Donna Kimball','Alice Dinnean'],
screenplay:['Simon Racioppa','Kari Drake'],
music:['Daniel Pemberton','Samuel Sim'],
camera:['Erik Wilson'],
cut:['Kate Baird','Andrew MacRitchie','Jesse Parker'],
scenography:['Gavin Bocquet','Richard Roberts','Phil Harvey'],
masks:['Holly Caddy']},
{title:'The Hollow Crown',
titleCZ:'V kruhu koruny',
year:2012,
runtime:'14h 29min',
episodeRuntime:'112-140min',
countries:['UK'],
genres:['Drama','History','War'],
director:['Rupert Goold','Richard Eyre','Thea Sharrock','Dominic Cooke'],
actors:['James Purefoy','Tom Hughes','Rory Kinnear','David Morrissey','Lucian Msamati','Patrick Stewart','Adrian Schiller','Tom Goodman-Hill','Clémence Poésy','David Suchet','David Bradley','Isabella Laughland','Lindsay Duncan','Peter De Jersey','Samuel Roukin','Ben Whishaw','Stephen McCole','Harry Lloyd','Maxine Peake','David Hayman','Mark Tandy','Simon Russell Beale','Miroslav Zaruba','David Dawson','Alun Armstrong','Alexandra Clatworthy','Jolyon Coy','Julie Walters','Tom Georgeson','Matthew Tennyson','Joe Armstrong','Michelle Dockery','Dominic Rowan','Jeremy Irons','Tom Hiddleston','Douglas Henshall','Reece Shearsmith','Geoffrey Palmer','Niamh Cusack','Iain Glen','Stanley Weber','Paterson Joseph','Richard Griffiths','Edward Akrout','Lambert Wilson','Anton Lesser','Tom Brooke','John Hurt','Nigel Cooke','Geraldine Chaplin','Paul Freeman','Owen Teale','Gwilym Lee','Graham Curry','Jd Roth-round','Mélanie Thierry','Stuart McQuarrie','Ben Miles','Laura Morgan','Max Bennett','Philip Glenister','Sophie Okonedo','Daniel Stisen','Sean Cernow','Lucy Robinson','David Murray','Jason Watkins','Adrian Dunbar','Tom Sturridge','Attila G. Kerekes','Hugh Bonneville','Sally Hawkins','Stanley Townsend','Michael Gambon','Samuel West','Andrew Scott','Angus Imrie','Keeley Hawes','Sam Troughton','Benedict Cumberbatch','Barney Harris','Ben Daniels','Phoebe Fox','James Fleet','Kyle Soller','Judi Dench','James Michael Rankin'],
screenplay:['Rupert Goold','Ben Power','William Shakespeare','Richard Eyre','Thea Sharrock','Christopher Marlowe'],
production:['Rupert Ryle-Hodges'],
music:['Stephen Warbeck','Dan Jones'],
camera:['Zac Nicholson'],
cut:['Lesley Walker','John Wilson'],
sound:['Jamie Roden'],
scenography:['Andrew McAlpine','Judy Farr','Alan MacDonald','John Stevenson','Dominic Roberts','Donal Woods'],
masks:['Jeremy Woodhead','Kirstin Chalmers'],
costumes:['Odile Dicks-Mireaux','Nigel Egerton']},
{title:'This Is Going to Hurt',
titleCZ:'Tohle bude bolet',
year:2022,
runtime:'5h 16min',
episodeRuntime:'44-46min',
countries:['UK'],
genres:['Comedy','Drama'],
director:['Lucy Forbes','Tom Kingsley'],
actors:['Ben Whishaw','Michele Austin','Alex Jennings','Rory Fleck Byrne','Tom Durant Pritchard','Harriet Walter','Ashley McGuire','Kadiff Kirwan','Ambika Mod','Jade Johnson','Al Roberts','Hiftu Quasem','Lucy Russell','Josie Walker','Simon Harrison','Hannah Onslow','Michael Workeye','Andreea Paduraru','Alice Bailey Johnson'],
basedOn:['Adam Kay'],
screenplay:['Adam Kay'],
music:['Jarvis Cocker','Serafina Steer'],
camera:['Benedict Spence','Nick Cooke'],
cut:['Peter Oliver','Selina Macarthur'],
sound:['Steve Browell','Jamie Selway'],
scenography:['Steve Wright'],
masks:['Ian Grummit'],
costumes:['Emma Rees']},
{title:'11.22.63',
titleCZ:'Dallas 63',
year:2016,
runtime:'7h 6min',
episodeRuntime:'42-81min',
countries:['USA'],
genres:['Mystery','Thriller'],
director:['Kevin Macdonald','Frederick E.O. Toye','James Kent','James Strong','James Franco','John David Coles'],
actors:['James Franco','Sarah Gadon','George MacKay','Chris Cooper','Cherry Jones','Daniel Webber',"Kevin J. O'Connor",'Lucy Fry','Nick Searcy','T.R. Knight','Brooklyn Sudano','Josh Duhamel','Joanna Douglas','Shauna Macdonald','Juliette Angelo','Gil Bellows','Braeden Lemasters','Leon Rippy','Jack Fulton','Christian Lloyd','Kristian Bruun','Boyd Banks','Kevin Jubinville',"Annette O'Toole","Michael O'Neill",'Eric Woolfe','Jadon Clews','Cody Gallant','Martha Girvin','Tony Munch','Michael Izquierdo','Jonny Coyne','Wilbur Fitzgerald','Antoni Corone','Percy Hynes White','Pip Dwyer','Kevin Dennis','Michael Rhoades','Greg Fallon','Tonya Pinkins','Stewart Arnott','Bob Stephenson','Allie Gallerani','Ben Beauchemin','Jen Goodhue','Kayleigh Shikanai','Peter J. Calvin','Vitali Makarov','Hannah Levinson','Max Silvestri','Michel Issa Rubio','Colin Doyle','Erica Anderson','Addison McGarry','Jake Michaels','Andres Munar','Kelly McCormack','Grantham Coleman','Savannah Solsbery','Alison Brooks','Lindsay Christopher','Nola Martin','Cody Ray Thompson','Zac Vran','Kent Sheridan','Tanya Karn','Anna Vocino','Deborah Lobban','Abigail Chu'],
basedOn:['Stephen King'],
screenplay:['Quinton Peeples','Brigitte Hales','Bridget Carpenter','Brian Nelson','Joe Henderson'],
production:['James Franco','Joseph Boccia'],
music:['Alex Heffes'],
camera:['David Katznelson','Adam Suschitzky'],
cut:['Plummy Tucker','Dorian Harris','Michael R. Fox','Sue Blainey'],
sound:['Kevin Roache','Pete Elia'],
scenography:['Carol Spier','Peter P. Nicolakakos','Kimberley Zaharko','Elinor Rose Galbraith'],
masks:['Antoinette Julien','Missy Lisenby'],
costumes:['Roland Sanchez']},
{title:'The Act',
titleCZ:'Odhalení',
year:2019,
runtime:'6h 57min',
episodeRuntime:'52-53min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Laure de Clermont-Tonnerre','Steven Piet','Adam Arkin','Christina Choe','Hannah Fidell'],
actors:['Patricia Arquette','Joey King','Chloë Sevigny','AnnaSophia Robb','Calum Worthy','Steve Coulter','Ashley Dulaney','Patricia French','Poorna Jagannathan','Butch Hammett','Nicholas Cirillo','Denitra Isler','Alexandria DeBerry','Mary Hollis Inboden','Jason Alan Smith','Elizabeth Bond','Stephanie Enderby','Ashton Leigh','Dean Norris','Joe Tippett','Joshua Mikel','Melissa Tang','Rhea Seehorn','Margo Martindale','Eva Ariel Binder','John Ales','Juliette Lewis','Lee Spencer','Cliff Chamberlain','Krisha Fairchild','Wilbur Fitzgerald','Chantal Maurice','Charles D. Clark','Stephanie McIntyre','Dawson Shea','José Alfredo Fernandez','Tyler Kay Whitley','Alicia Kelley','Lana Young','Elizabeth Becka','Michael Shenefelt','Roy Williams Jr.','Gwydion Lashlee-Walton','Joe Knezevich','Tywayne Wheatt'],
screenplay:['Nick Antosca','Michelle Dean','Robin Veith','Dan Dietz','Lisa Long'],
production:['Jan Peter Meyboom'],
music:['Jeff Russo'],
camera:['Zack Galler'],
cut:["Greg O'Bryant",'Kate Brokaw','Ken Ramos'],
scenography:['Thomas A. Walsh'],
masks:['Arlene Martin','Melody Wylie','Shaquanta Prescott'],
costumes:['Michele Michel']},
{title:'Ugly Americans',
titleCZ:'Oškliví Američané',
year:2010,
runtime:'11h 22min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Animation','Comedy','Horror'],
director:['Devin Clark','Aaron Augenblick','Lou Solis','Richard Ferguson-Hull'],
actors:['Matt Oberg','Natasha Leggero','Kurt Metzger','Randy Pearlstein','Julie Klausner','Devin Clark','Pete Holmes',"Mike O'Gorman",'Maria Bamford','Kumail Nanjiani','John Mulaney','Kristen Wiig','Bobby Moynihan','Thomas Middleditch','Kevin Shinick','Daniel Powell',"De'Adre Aziza",'Rebekka Johnson','Bill Hader','Fred Armisen','Jack McBrayer','Rob Riggle','Jenny Slate','Abby Elliott','H. Jon Benjamin','Ed Helms','Dan Fogler','Janeane Garofalo','John Gemberling','Michael-Leon Wooley'],
screenplay:['David M. Stern','Craig DiGregorio','Julie Klausner','Daniel Powell','Kevin Shinick','Bill Krebs','Erik Richter','Greg White'],
production:['Aaron Augenblick','Devin Clark','Craig DiGregorio','Colin A.B.V. Lewis','Erik Richter'],
music:['Chris Anderson'],
cut:['Brett Jubinville'],
sound:['Abigail Savage']},
{title:'Black Bird',
titleCZ:'Volavka',
year:2022,
runtime:'5h 47min',
episodeRuntime:'54-60min',
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Michaël R. Roskam','Jim McKay','Joe Chappelle'],
actors:['Taron Egerton','Ray Liotta','Greg Kinnear','Jake McLaughlin','Paul Walter Hauser','Robyn Malcolm','Lawrence Turner','Cecilia Leal','Christopher B. Duncan','Brandon Morales','Sepideh Moafi','James DuMont','Raheem Allen','Cullen Moss','Addison Ross','Michael Tacconi','Lee Tergesen','Michael Aaron Milligan','Logan Macrae','Blue Clarke','Robert Wisdom','Carlo Alban','Christopher Berry','Joe Williamson','Jason Bayle','Brett Gentile','Kwajalyn Brown','Melanie Nicholls-King','Tony Amendola','Peter Jaymes Jr.','Christopher Backus','Charles Green','Braxton Alexander','Joey Bicicchi','Karsen Liotta','Ryan Broussard','Rudy Eisenzopf','Holly Bonney','Jason Edwards','Dominique McClellan','Robert Diago DoQui'],
basedOn:['James Keene','Hillel Levin'],
screenplay:['Dennis Lehane','Riccardo DiLoreto','Sean K. Smith'],
music:['Mogwai'],
camera:['Natalie Kingston'],
cut:['Jonathan Alberts','Rob Bonz'],
scenography:['Charisse Cardenas','Fernando Carrion','Monica Monserrate'],
masks:['Hailey Authement','Kathrine Gordon'],
costumes:['Amy Roth']},
{title:'The Dragon Prince',
titleCZ:'Dračí princ',
year:2018,
runtime:'19h 50min',
episodeRuntime:'24-34min',
countries:['USA'],
genres:['Animation','Fantasy','Family'],
director:['Villads Spangsberg','Giancarlo Volpe'],
actors:['Jack De Sena','Jason Simpson','Jonathan Holmes','Paula Burrows','Sasha Rojen','Racquel Belmonte','Kazumi Evans','Erik Dellums','Adrian Hough','Adrian Petriw','Sam Vincent','Rena Anakwe','Omari Newton','Brenda Crichlow','Vincent Gale','Rhona Rees','Peter Kelamis','Patricia Isaac','Jay Brazeau','Vincent Tong','Ian James Corlett','Nahanni Mitchell','Tyrone Savage','Luc Roderique','Nicole Oliver','Ana Sani','Bill Newton','Mark Hildreth','Dylan Schombing','Ben Cotton','Jennifer Hale','Adam Coleman Howard','Greg Rogers','Deven Mack','Julie Lemieux','Laara Sadiq',"Dave 'Squatch' Ward",'Ian Hanlin'],
screenplay:['Aaron Ehasz','Justin Richmond','Devon Giehl','Iain Hendry','Neil Mukhopadhyay'],
production:['Lauren Topal','Lisa Thibault','Devon Giehl','Iain Hendry'],
music:['Frederik Wiedmann'],
sound:['Adam Rooner','Jeff Davis']},
{title:'Violet Evergarden',
titleCZ:'Violet Evergarden',
year:2018,
runtime:'5h 59min',
episodeRuntime:'25-34min',
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Sci-Fi'],
director:['Taiči Išidate','Haruka Fudžita','Norijuki Kitanohara','Taiči Ogawa','Takuja Jamamura','Šinpei Sawa','Jošidži Kigami','Jasuhiro Takemoto'],
actors:['Jui Išikawa','Aja Endó','Takehito Kojasu','Kóki Učijama','Daisuke Namikawa','Hidenobu Kiuči','Júto Uemura','Haruka Tomacu','Azusa Tadokoro','Jukari Nozawa','Ikudži Nose','Riki Kagami','Šunsuke Sakuja','Kengo Cudží','Džun Mijamoto','Satoši Taki','Kowaka Wakana','Šóko Juzuki','Haruo Jamagiši','Minori Čihara','Rie Hikisaka','Ajaka Saitó','Jurika Aizawa','Naoja Nosaka','Megumi Nakadžima','Kendžiró Cuda','Kósei Hirota','Subaru Kimura','Takajuki Mijamoto','Tošiko Sawada','Sajaka Senbongi','Jasunori Macumoto','Jóko Sómi','Aja Saitó','Mari Doi','Šintaró Asanuma','Takuma Sasaki','Satoši Mikami','Susumu Akagi','Čikahiro Kobajaši','Jumi Sudó','Marika Hajaši','Daisuke Jokota','Takuja Inagaki','Jóko Hikasa','Kjóko Sakai','Jošito Jasuhara','Daisuke Hirakawa','Mami Kojama','Micuaki Hošino','Sumire Morohoši','Ajako Kawasumi','Mami Horikoši','Gara Takašima'],
basedOn:['Kana Akacuki'],
screenplay:['Reiko Jošida','Tacuhiko Urahata','Takaaki Suzuki'],
production:['Šigeru Saitó'],
music:['Evan Call'],
camera:['Kohei Funamoto'],
cut:['Kengo Šigemura'],
sound:['Jóta Curuoka'],
scenography:['Mikiko Watanabe']},
{title:'Dororo',
titleCZ:'Dororo',
year:2019,
runtime:'9h 36min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Drama','History','Horror'],
director:['Kazuhiro Furuhaši','Hiromiči Matano','Daisuke Tokudo','Kana Kawana','Fumihiro Jošimura'],
actors:['Mugihito','Hiroki Suzuki','Rio Suzuki','Mucumi Sasaki','Naoja Učida','Akio Ócuka','Šója Čiba','Secudži Sató','Kóhei Amasaki','Masajuki Akasaka','Rjúiči Kidžima','Čie Nakamura','Ikudži Nose','Masaši Nogawa','Manta Jamamoto','Kósuke Óniši','Takumu Mijazono','Farahnaz Nikray','Masaja Fukuniši','Takahiro Šimada','Šinnosuke Ogami','Džun Mijamoto',"Šun'iči Maki",'Hitomi Sasaki','Kaoru Koga','Takuja Nakašima','Acuši Ono','Júgo Sekiguči','Šómaru Zóza','Jošihito Sasaki','Mizuko Arima','Kanako Sakuragi','Takajuki Sakazume','Džun Inoue','Taró Kiuči','Taisuke Nakano','Šóta Ebina','Kazuhiro Jamadži','Jume Mijamoto','Momoe Kišimoto',"Ken'ičiró Macuda",'Tóru Nara','Júki Tamai','Satoru Murakami','Nana Mizuki','Sacumi Macuda','Kódži Fudžijoši','Takeši Hajakawa','Džunko Takeuči','Takaki Ótomari',"Šin'ja Takahaši",'Kenta Mijake','Ajumi Fudžimura','Kósuke Katajama','Kódži Jusa','Ikue Ótani','Rie Hikisaka','Akira Kuwabara','Júko Kaida','Fuminori Komacu','Kotomi Ócuka',"Šin'ja Fukumacu",'Anri Tačibana','Mami Kojama','Riki Kitazawa','Juka Terasaki','Hiroši Karasuda','Júko Ueda','Hodaka Mieno','Kento Fudžinuma','Wataru Cujuzaki','Nodoka Hasegawa','Eiko Hanawa','Jurina Watanabe','Fumitake Išiguro','Ajano Hamaguči','Akihiro Mine','Harumi Ueda','Masajuki Tanaka','Šúei Ikawa','Čie Arikawa','Tošijuki Hara',"Šin'ja Honda",'Mugihito','Masumi Taira','Hajato Watanabe','Takamaru Seko','Misa Kató','Mariko Munakata','Miki Nacutani','Namiko Morimoto','Mai Jamane','Rin Namino'],
basedOn:['Osamu Tezuka'],
screenplay:['Jasuko Kobajaši','Kijoko Jošimura','Akira Kindaiči','Šigeru Murakoši'],
music:['Jošihiro Ike'],
camera:['Jošihasa Ójama'],
cut:['Mucumi Takemija'],
sound:['Kisuke Koizumi'],
scenography:['Mari Fudžino']},
{title:'The Hour',
titleCZ:'Hodinka',
year:2011,
runtime:'11h 53min',
episodeRuntime:'59-60min',
countries:['UK'],
genres:['Drama'],
director:['Harry Bradbeer','Coky Giedroyc','Jamie Payne','Sandra Goldbacher','Catherine Morshead'],
actors:['Dominic West','Romola Garai','Ben Whishaw','Burn Gorman','Anna Chancellor','Lisa Greenwood','Oona Chaplin','Anton Lesser','John Bowe','Tim Pigott-Smith','Peter Sullivan','Juliet Stevenson','Kelly Adams','Andrew Scott','Jamie Parker','Nicholas Woodeson','Julian Rhind-Tutt','Jason Watkins','Robert Demeger','Joe Cole','Peter Capaldi','Ben Lloyd-Hughes','Vanessa Kirby','Tony Bennett','Roger Ringrose','Jodi Balfour','Tim Bentinck','Lloyd McGuire','Jeff Tweedy','Richard \'Buck 65\' Terfry','Kate Fahy','Sam Palladio','Paul Chahidi','Michael Jenn','Sylvia Tyson','Tomiwa Edun','Morgan Watkins','Peter Silverleaf','Greg Bennett','Ken Bones','Robert Whitelock','Hannah John-Kamen','Jason Cheater','Joshua McGuire','Colin Spaull','Anna Maguire','Nicholas Kristof','Roger May','Teresa Mahoney','Nadim Sawalha','Adam Leese','Jessica Hynes','Karen Meagher','Vincent Riotta','Hannah Tointon','Tom Burke','Lizzie Brocheré','John Hollingworth','Antonia Christophers','Jake Canuso','Steven Elder','Adrian McLoughlin','Kris Saddler','Max Fowler','Remmie Milner','Laurence Kennedy','Filippo Delaunay','Geoffrey Kirkness','Jessie Williams','Cera Rose Pickering','Nick Caldecott'],
screenplay:['Abi Morgan','Nicole Taylor','George Kay'],
production:['Ruth Kenley-Letts'],
music:['Kevin Sargent','Daniel Giorgetti'],
camera:['Chris Seager','David Luther'],
cut:['Paul Machliss','Nick Arthurs','Gareth C. Scales'],
scenography:['Eve Stewart'],
costumes:['Suzanne Cave']},
{title:'GTO: Great teacher Onizuka',
titleCZ:'GTO',
year:1999,
runtime:'18h 18min',
episodeRuntime:'25-48min',
countries:['Japan'],
genres:['Animation','Action','Drama','Comedy'],
director:['Norijuki Abe','Satoši Nakagawa','Tomio Jamauči','Hirojuki Išidó','Šigeki Hatakejama','Hiroto Kató','Naojasu Habu','Hideaki Kuši','Akihiro Enomoto'],
actors:['Wataru Takagi','Fumiko Orikasa','Džunko Noda','Tomokazu Seki','Acuko Tanaka','Ajako Kawasumi','Iššin Čiba',"Džun'iči Suwabe",'Kotono Micuiši','Megu Aširo',"Šin'ičiró Miki",'Teššó Genda','Unšó Išizuka','Akemi Okamura','Hiroaki Hirata','Kazuki Jao','Hideo Išikawa','Kendži Hamada','Micuki Saiga','Čafúrin','Takeši Kusao','Kjóko Hikami','Čó','Kazuhiro Nakata','Acuko Bungo','Takako Honda','Kósuke Okano','Kacumi Suzuki','Megumi Ogata','Tóru Furuja','Kaja Macutani','Tokujoši Kawašima','Jasutaka Júki','Takeši Watabe','Takacugu Awazu','Hikaru Midorikawa','Ikuko Tani','Kóki Mitomo','Kijomi Asai','Macuo Macuo','Sara Nakajama','Jošiko Okamoto','Jošiko Takemura','Hirohiko Kakegawa','Kóiči Kurijama','Hisao Egawa','Kazuhiro Óguro','Kijojuki Janada','Tošihiko Nakadžima','Haruhi Nanao','Júko Mijamura','Naoki Janagi','Tóru Fudžisawa','Kentaró Itó','Cutomu Cudži','Masumi Cuda','Tóru Ókawa','Džun Išimaru','Tomoe Hanba','Sumi Šimamoto','Miki Nagasawa','Daisuke Hirakawa','Jukiko Hattori','Asako Dodo','Daisuke Góri','Emiko Hagiwara','Hiromiči Kogami','Kae Araki','Kósuke Toriumi','Makoto Ataka','Masami Kikuči','Minoru Inaba','Misa Watanabe','Mugihito','Noriaki Sugijama','Rokuró Naja','Tomoko Kawakami','Tošiharu Sakurai','Jasunori Macumoto','Juri Širatori','Jutaka Aojama'],
basedOn:['Tóru Fudžisawa'],
screenplay:['Jošijuki Suga','Satoru Nišizono','Masaši Sogo','Rjóta Jamaguči'],
production:['Ken Hagino','Hideo Kacumata','Jošihiro Suzuki'],
music:['Júsuke Honma'],
camera:['Harutoši Mijagawa'],
cut:["Džun'iči Uemacu",'Haruhiko Kurijagawa'],
scenography:['Júdži Ikeda']},
{title:'Falcon',
titleCZ:'Strážce noci',
year:1981,
runtime:'21h 36min',
episodeRuntime:'54min',
countries:['Japan'],
genres:['Adventure','History'],
director:['Daisuke Jamazaki','Masahiro Takase','Júiči Harada','Kazuo Hase','Takedži Hidaka','Jasutada Nagano','Sahei Aracu','Akira Kobajaši'],
actors:['Akira Kobajaši','Kajo Macuo','Hirojuki Nagato','Kazutaka Kodžó','Isamu Nagato','Jošimi Ašikawa','Kazujo Macui','Čóta Kokontei','Šógo Šimada'],
screenplay:['Kacujuki Nakamura','Hirojasu Jamaura','Masaaki Wakuda','Jú Tagami','Eimei Jamamoto']},
{title:'Spartacus',
titleCZ:'Spartakus',
year:2010,
runtime:null,
episodeRuntime:null,
countries:['USA'],
genres:['Action','Drama','Adventure','History'],
director:['Rick Jacobson','Michael Hurst','Jesse Warn','T.J. Scott','Brendan Maher','Chris Martin-Jones','Mark Beesley','John Fawcett','Grady Hall','Rowan Woods','Glenn Standring'],
actors:['Andy Whitfield','Liam McIntyre','Lucy Lawless','John Hannah','Viva Bianca','Manu Bennett','Craig Parker','Lesley-Ann Brandt','Erin Cummings','Peter Mensah','Jai Courtney','Anna Hutchison','Nick E. Tarabay','Antonio Te Maioha','Dustin Clare','Katrina Law','David Austin','Siaosi Fonua','Stephen Dunlevy','Craig Walsh Wrightson','Eka Darville','Raicho Vasilev','Daniel Feuerriegel','Ande Cunningham','Janine Burchett','Brooke Williams','John Bach','Lliam Powell','Mark Mitchinson','Campbell Cooley','Karlos Drinkwater','Matthew Chamberlain','Tim Foley','Tania Nolan','Mia Pistorius','Brooke Harmon','Matt Gillanders','Jon Brazier','John Way','Tim Cronin','Matthew Saville','Cynthia Addai-Robinson','Reuben de Jong','Kyle Rowling','Marcus Johnson','Dylan Hopkins','Bonnie Sveen','Hanna Mangan Lawrence','Michael Hurst','Ellen Hollman','Alain Chanoine','Simon Merrells','Christian Antidormi','Pana Hema Taylor','Gwendoline Taylor','Jenna Lind','Tom Hobbs','Todd Lasance','Cohen Holloway','Peter McCauley','Jared Turner','Richard Norton','Paul Glover','Luna Rioumina','Conan Stevens','Catherine Boniface','Lauren Shaw','Ditch Davey','Joseph Naufahu','Andrew Stehlin','Mark Ferguson','Aaron Jakubenko','Vince Colosimo','Brett Tucker','Jeffrey Thomas','Peter Feeney','Marisa Ramirez','Jason Hood','Stephen Papps','Barry Duffield','Colin Moy','Anthony Ray Parker','Stephen Lovatt','Joel Tobeck','Andrew Grainger','Greg Ward','Chris Petrovski','Kevin J. Wilson','Levi Holley','Lucy Li','Stephen Butterworth','Luke Pegler','Rowan Bettjeman','Mike Markoff','Heath Jones','Jordan Mooney','Arlo Gibson','Delaney Tabron','Roy Snow','Samuel E. Shore'],
screenplay:['Andrew Chambliss','Steven S. DeKnight','Jed Whedon','Allison Miller','Jeffrey Bell','Brent Fletcher','Aaron Helbing','Todd Helbing','David Kob','Miranda Kwok','Misha Green','Daniel Knauf','Seamus Kevin Fahey','Mark Leitner','Tracy Bellomo'],
production:['Rob Tapert'],
music:['Joseph LoDuca'],
camera:['Aaron Morton','Dave Garbett','John Cavill'],
cut:['Jonathan Woodford-Robinson','Allanah Milne'],
sound:['William Freesh','Gary Gegan'],
scenography:['Megan Vertelle','Ben Milsom'],
masks:['Vanessa Hurley',"Jane O'Kane",'Roger Murray','Tamara Eyre','Susie Glass'],
costumes:['Barbara Darragh','Lesley Burkes-Harding']},
{title:'Orange Is the New Black',
titleCZ:'Orange Is the New Black',
year:2013,
runtime:'90h 44min',
episodeRuntime:'51-93min',
countries:['USA'],
genres:['Drama','Comedy','Crime'],
director:['Michael Trim','Andrew McCarthy','Jodie Foster','Matthew Penn','Phil Abraham','Uta Briesewitz','Jennifer Getzinger','Constantine Makris','Tricia Brock','Allison Anders','Daisy von Scherler Mayer','S.J. Clarkson','Nicole Holofcener','Anthony Hemingway','Julie Anne Robinson','Mark A. Burley','Jesse Peretz','Matthew Weiner','Laura Prepon','Nick Sandow','Wendey Stanzler','Siân Heder','Clark Johnson','Erin Feeley','Ludovic Littee','Natasha Lyonne','Diego Velasco'],
actors:['Taylor Schilling','Laura Prepon','Kate Mulgrew','Uzo Aduba','Danielle Brooks','Natasha Lyonne','Taryn Manning','Nick Sandow','Yael Stone','Vicky Jeudy','Jason Biggs','Jackie Cruz','Lorraine Toussaint','Samira Wiley','Laverne Cox','Alysia Reiner','Pablo Schreiber','Matt McGorry','Annie Golden','Madeline Brewer','Michael Chernus','Deborah Rush','Teena Byrd','Robert Stanton','Rachel Brosnahan','Beth Katehis','Joanna Adler','Beth Dover','Natalie Knepp','Alexander Flores','Madison McKinley','Bill Hoag','Mary Looram','Robert C. Kirk','Stephanie Andujar','Sabrina Carpenter','Joe Caniano','Sebastian La Cause','Olivia Luccardi','Lauren Lapkus','Ruby Rose','Abigail Savage','Michael Harney','Oona Laurence','Conor Romero','Maria Di Angelis','Marko Caka','Mike Malvagno','Tyler Alvarez','Jamie Denbo','Chris Beetem','Erin Davie','Alexander Wraith','Morgan Spector','Portia Reiners','Constance Shulman','Dominic Comperatore','Lin Tucci','Matt Peters','Dascha Polanco','Norm Golden','Roy Jackson','Miguel Izaguirre','Beanie Feldstein','Maria Dizzia','Elizabeth Rodriguez','Lori Petty','Clare Foley','Amelia Fowler','Justin Morck','Patricia Kalember','Michael Rainey Jr.','Tanya Wright','Dionne Audain','Blair Brown','Brad William Henke','Richard Masur','Jolene Purdy','Shannon Esper','John Magaro','Mike Birbiglia','Chris Sarandon','Christopher Clawson','Judith Roberts','Demosthenes Chrysan','Michelle Hurst','Catherine Curtin','Nick Stevenson','Kathryn Kates','Todd Susman','Beth Fowler','Harold Surratt','Christian Keiber','Jessica Pimentel','Arden Myrin','James McDaniel','David Aaron Baker','Michael Nathanson','Emma Myles','Diane Guerrero'],
basedOn:['Piper Kerman'],
screenplay:['Siân Heder','Sara Hess','Nick Jones','Lauren Morelli','Marco Ramirez','Stephen Falk','Jim D. Gray','Gary Lennon','Tara Herrmann','Hartley Voss','Alex Regnery','Jordan Harrison','Carly Mensch','Jenji Kohan','Ludovic Littee','Brian Chamberlayne','Molly Smith Metzler','Liz Friedman','Tami Sagher','Heather Jeng Bladt','Vera Santamaria','Hilary Weisman Graham','Merritt Tierce','Anthony Natoli','Kirsa Rein','Lauren Schuker Blum','Rebecca Angelo'],
production:['Tara Herrmann','Hilary Weisman Graham'],
music:['Scott Doherty','Gwendolyn Sanford','Brandon Jay'],
camera:['Vanja Cernjul','Yaron Orbach','Michael Trim','Manuel Billeter','Ludovic Littee','David M. Dunlap'],
cut:['William Turro','Michael Stern','Shannon Mitchell','Liza Cardinale','Jennifer Hatton','Tim Boettcher','Amy M. Fleming'],
sound:['Brian Armstrong','Joshua Sieh','Chris Philp','John Chamberlin','John Kincade','Christopher Gomez','Joe White'],
scenography:['Michael Shaw','Chryss Hionis','Kara Zeigon','Malchus Janocko','Geoffrey A. Ehrlich','Lisa Scoppa'],
masks:['Danielle Minnella','Elizabeth Piper S.','Eldo Ray Estes','Stephanie Barr','Lena Jemmott'],
costumes:['Jennifer Rogien']},
{title:'Community',
titleCZ:'Zpátky do školy',
year:2009,
runtime:'41h 26min',
episodeRuntime:'22-29min',
countries:['USA'],
genres:['Comedy'],
director:['Joe Russo','Anthony Russo','Adam Davidson','Justin Lin','Seth Gordon','Jay Chandrasekhar','Victor Nelli Jr.','Fred Goss','Jeff Melman','Tristram Shapeero','Rob Schrab','Duke Johnson','Bobcat Goldthwait','Jim Rash','Kyle Newacheck','Ken Whittingham','Gail Mancuso','Anthony Hemingway','Richard Ayoade','Steven K. Tsuchida','Steven Sprung','Dan Eckman','Michael Patrick Jann','Tricia Brock','Beth McCarthy-Miller','Nat Faxon'],
actors:['Joel McHale','Gillian Jacobs','Danny Pudi','Donald Glover','Alison Brie','Yvette Nicole Brown','Chevy Chase','Ken Jeong','Jim Rash','Shelby Rabara','Twink Caplan','Dan Eckman','Sandeep Parikh','Jared Kusnitz','Paget Brewster','Richard Erdman','Blake Clark','Jill Latiano','Jack Black','Eric Christian Olsen','Hilary Duff','Michael Kenneth Williams','Stephen Tobolowsky','Josh Holloway','Amber Lancaster','Betty White','Rob Corddry','Brit Marling','Michael McCafferty','Lauren Stamile','Jillian Rose Reed','Taran Killam','Kirk Fox','John Goodman','Katharine McPhee','Patton Oswalt','Holly Beavon','Michael Ironside','Ryan Lee','Julianna Guill','Holland Roden','Marcus Folmar','opice Crystal','Marcus Choi','Jeff Garlin','Luis Guzmán','Iqbal Theba','Matt Walsh','Nick Kroll','Tony Hale','Jason Rogel','David Born','Alix Elizabeth Gitter','Brad Slaughter','Matt Lucas','Malcolm McDowell','Irene Choi','James Brolin','Mel Rodriguez','Luke Youngblood','Kimberley Datnow','John Oliver','Brie Larson','Matt Jones','Jonathan Banks','Robert Patrick','Josh Diamond','Walton Goggins','Barak Hardley','Jennie Garth','Craig Cackowski','Nathan Fillion','Danielle Kaplowitz','Brooke Lynn Howard','Mitchell Hurwitz','Gloria Sandoval','Katie Leclerc','Dan Harmon','Adam Devine','Randall Park','Larry Cedar','Natalina Maggio','Maite Schwartz','Steven W. Bailey','Brian Huskey','Lee Weaver','Aaron Takahashi','Dan Bakkedahl','Max Charles','Marcy McCusker','Paulie Redding','Bruno Amato','Brendan Hunt','Matt Riedy','Mary McDonald-Lewis','Carol Kiernan','Zack Pearlman','Jennifer Flack','Cyrina Fiallo','Rob Schrab'],
screenplay:['Dan Harmon','Emily Cutler','Karey Dornetto','Gene Hong','Jack Kukoda','Alex Rubens','Jim Rash','Erik Sommers','Neil Goldman','Garrett Donovan','Dean Young','Ben Wexler','Megan Ganz','Andy Bobrow','Tim Hobert','Dino Stamatopoulos','Andrew Guest','Donald Diego','Ryan Ridley','Jon Pollack','Chris McKenna','Matt Warburton','Jordan Blum','Hunter Covington','Hilary Winston','Matt Murray','Maggie Bandur','Adam Countee','Mark Stegemann','Matt Lawton','Carol Kolb','Monica Padrick','Matt Roller','Parker Deay','Tim Saccardo','Alex Cuthbertson','Matt Fusfeld','Alex Cooley','Vera Santamaria','Annie Mebane','Stephen Basilone','Dan Guterman','Chris Kula','Liz Cackowski','Clay Lapari','Lauren Pomerantz'],
production:['Timothy Silver','Patrick Kienlen','Douglas Rowell','Emily Cutler','Matt Murray','Maggie Bandur','Vera Santamaria'],
music:['Ludwig Göransson'],
camera:['James Hawkinson','Michael A. Price','Gary Hatfield','Buzz Feitshans IV','Jon Tucker'],
cut:['Lisa Lassek','Jeff Hall','Jeff Groth','Christian Kinnard','Jeffrey M. Werner','Larry Bock','Joel Goodman','Peter B. Ellis','Garret Elkins','Spencer Houck','Ruthie Aslan','Steven Sprung','Luke Guidici','John Peter Bernardo','William Marrinson','Jim Towne'],
sound:['Petur Hliddal'],
scenography:['Derek R. Hill','Aaron Osborne','Denise Pizzini','Erin Cochran','Dorit Hurst','Jennifer M. Gentile','Ellen King'],
masks:['Gina Ghiglieri','Kristina Frisch','Loretta Nero','Matt Danon'],
costumes:['Karen Patch','Sabrina Rosen','Mary-Kate Killilea']},
{title:'Silicon Valley',
titleCZ:'Silicon Valley',
year:2014,
runtime:'26h 4min',
episodeRuntime:'27-48min',
countries:['USA'],
genres:['Comedy'],
director:['Mike Judge','Charlie McDowell','Eric Appel','Jamie Babbit','Alec Berg','Clay Tarver','Maggie Carey','Tim Roche','Gillian Robespierre','Matt Ross','Liza Johnson','Pete Chatmon'],
actors:['Martin Starr','Amanda Crew','T.J. Miller','Josh Brener','Matt Ross','Zach Woods','Kumail Nanjiani','Angela Trimbur','Christopher Evan Welch','Andy Buckley','Casey Sander','Brent Alan Henry','Bernard White','Tiara Lanai','Chase Kim','Gabriel Tigerman','Karen James','Thomas Middleditch','Jimmy O. Yang','Teddy Lane Jr.','Austin Abrams','Milana Vayntrub','Diallo Riddle','Avi Nash','Mary Holland','Jessica Chaffin','Nate Smith','Jeff Sloniker','Brett Baumayr','Jill E. Alexander','Jack Foley','Charan Prabhakar','Scott Prendergast','Lynn Chen','Andy Daly','AJ Michalka','Alexander Chaplin','Jack Plotnick','David Rees Snell','Mark Bloom','Angela Gulner','Jules Hartley','Suzanne Cryer','Mariano Mendoza','Skyler Seymour','Christina July Kim','Ben Feldman','Matt McCoy','Stephen Tobolowsky',"Anthony 'Citric' Campos",'Henry Phillips','Lynn A. Henderson','Ping Wu','Bridey Elliott','Ken Lerner','Michael McMillian','Bridgett Newton','Harrison Thomas','Alice Wetterlund','Chris Diamantopoulos','Juliocesar Chavez','Lara Everly','Stan Vang','Joe Spellman','Flo Rida','Anna Khaja','Linda Park','Tim Chiou','Irene Choi','Leisha Hailey','Haley Joel Osment','Phoebe Neidhardt','Graham Rogers','Eugene Cordero','Brian Gattas','Anjali Bhimani','Annie Sertich','Santiago Segura','Maverick Thompson','Jonna Walsh','Lindsey Broad','Ursula Burton','Kid Rock','Eme Ikwuakor','Porscha Coleman','Caroline de Souza Correa','Matt Shea','Griffin Gluck','Erika Stillwater','Vincent M. Biscione','Juan Jiménez','Audrey Moore','Patrick Fischler','Charlie Saxton','Julia Cho','Frank Collison','Dustin Milligan','Porter Lynn','Joe Rogan','Matthew Houston'],
screenplay:['Alec Berg',"Dan O'Keefe",'Clay Tarver','Carson Mell','Donick Cary','Carrie Kemper','Ron Weiner','Chris Provenzano','John Altschuler','Mike Judge','Dave Krinsky','Josh Lieb','Megan Amram','John Levenstein','Anthony King','Sung-Jin Lee','Daisy Gardner','Lewis Morton','Amy Aniobi','Adam Countee','Jessica Gao','Rachele Lynn','Rob Turbovsky','Matteo Borghese','Sarah Walker','Graham Wagner'],
production:['Jim Kleverweis','Scott Rudin','Chrisann Verges','Sung-Jin Lee','Adam Countee','Alonzo Nevarez'],
music:['Jeff Cardoni'],
camera:['Jim Denault','Tim Suhrstedt'],
cut:['Paul Zucker','Tim Roche','Brian Merken','Al LeVine','Gina Sansom'],
sound:['Nick Offord','Bobby Mackston','Todd Beckett','Elmo Ponsdomenech',"Terry O'Bright",'Mark Relyea','Jason Gaya'],
scenography:['Richard Toyon','Jennifer Mueller','Brandi Kalish','Andrew Sloane','Oana Bogdan Miller'],
masks:['Matthew Holman','Jody Burton','Denise Dellavalle'],
costumes:['Suzanne McCabe','Daniel Orlandi','Christina Mongini','Ashley Kemper']},
{title:'Wallander',
titleCZ:'Wallander',
year:2008,
runtime:'18h 1min',
episodeRuntime:'88-94min',
countries:['UK','Sweden','USA','Germany'],
genres:['Crime','Thriller','Drama'],
director:['Benjamin Caron','Philip Martin','Niall MacCormick','Hettie MacDonald','Aisling Walsh','Andy Wilson','Esther Campbell','Toby Haynes','Charles Martin'],
actors:['Kenneth Branagh','Richard McCabe','Jeany Spark','Sarah Smart','Sadie Shimmin','Tom Hiddleston','Barnaby Kay','David Warner','Boel Marie Larsson','Jonathan Aris','Orla Brady','Saskia Reeves','Emil Forselius','Nicholas Hoult','Guy Henry','Beatie Edney','Phyllis Logan','Tom Beard','Susannah Fielding','Yohanna Idha','Søren Malling','Rebecca Ferguson','Rupert Graves','Maimie McCoy','Annabel Mullion','Claire Cox','David Mallinson','Arsher Ali','Luke Allen-Gale','Josh Cole','Radosław Kaim','Jill Baker','Jens Hultén','Jacob Ericksson','Artūrs Skrastiņš','Julia Ragnarsson','Sandra Voe','Michael Müller','Willie Andréason','Ole Dupont','Flora Spencer-Longhurst','Dermot Keaney','Joe Claflin','William Scott-Masson','Lynn Farleigh','Glen Davies','Håkan Bengtsson','Karin Bertling','Roland Hedlund','Louis Hilyer','Harry Hadden-Paton','John Lightbody','Thomas Coombes','Rebekah Staton',"Dhaffer L'Abidine",'Annette Ekblom','David Sibley','Angela Thorne','Michael Culver','Jon Laurimore','John Ringham','Malcolm Tierney','Andrew Buckley','Lemogang Tsipa','Vincent Regan','Emma Griffiths Malin','Benedict Taylor','Lindsay Duncan','Daniel Cerqueira','Hugh Mitchell','Rune Bergman','Fredrik Gunnarsson','Barbara Wilshere','Cecilia Hjalmarsson Milldoff','Sandra Redlaff','Angela Terrence','Nimmy March','Katarina Lundgren','Isabell Andén','Bill Moody','Arvydas Dapšys','Ingeborga Dapkunajtě','Patrik Fridh','Siya Mayola','Dearbhla Molloy','Michael Gould','Johan Svensson','Kimmo Rajala','Julian Koberman','Bo von Gegerfelt','Peter Briggs','John-Paul Hurley','Joanna Bacon'],
basedOn:['Henning Mankell'],
screenplay:['Richard Cottan','Simon Donald','James Dormer','Peter Harness','Henning Mankell','Richard McBrien'],
production:['Sanne Wohlenberg','Daniel Gylling'],
music:['Martin Phipps','Natalie Holt','Vincent Pope','Ruth Barrett','Dominic Muldowney'],
camera:['Anthony Dod Mantle','G. Magni Ágústsson','Igor Martinović','Lukas Strebel','Jan Jonaeus'],
cut:['Tony Cranstoun','Alex Mackie','Chris Barwell','Kristina Hetherington','Matthew Tabern','Úna Ní Dhonghaíle',"St. John O'Rorke",'Tim Porter'],
scenography:['Jacqueline Abrahams','Candida Otton','Anne Mette Bo Drivsholm'],
masks:['Love Larson'],
costumes:['Diana Cilliers','Katja Watkins']},
{title:'Kingdom',
titleCZ:'Království zombie',
year:2019,
runtime:'9h 41min',
episodeRuntime:'36-57min',
countries:['South Korea'],
genres:['Action','Thriller','Horror'],
director:['Seong-hoon Kim','In-je Park'],
actors:['Ji-hoon Joo','Seung-ryong Ryoo','Du-na Bae','Sang-ho Kim','Joon-ho Heo','Seok-ho Jeon','Seok-won Jeong','Seon-kyu Jin','Sungkyu Kim','Hye-joon Kim','Byeong-eun Park','Jae-hong Ahn','Ji-hyeon Jeon','Dong-min Oh','Seung-hun Kim','Ye-eun Kim','Eui-tae Yu','Hee-jin Choi','Dan-bi Kim','Young-sub Jung'],
screenplay:['Eun-hee Kim'],
cut:['Chang-joo Kim']},
{title:'Fighting Spirit',
titleCZ:'Hadžime no Ippo: The Fighting',
year:2000,
runtime:'29h 8min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Action','Animation','Drama','Comedy','Sport'],
director:['Satoši Nišimura','Šindži Sató','Jasuhiro Macumura','Jasuo Iwamoto',"Šin'iči Cudži",'Fumie Muroi','Hideo Hajaši','Akira Mano','Nanako Šimazaki','Rokó Ogiwara','Saburó Hašimoto','Tošiharu Sató'],
actors:['Kóhei Kijasu','Tomokazu Seki','Wataru Takagi','Ičiró Nagai','Kazuko Sugijama','Masaja Onosaka','Unšó Išizuka','Masahiro Kobajaši','Daisuke Sakaguči','Juka Komacu','Akemi Okamura','Hiroaki Hirata','Hiroši Naka','Nobutoši Kanna','Fumihiko Tačiki','Hiroši Janaka','Naoki Tacuta','Kóiči Kitamura','Šóko Cuda','Tecu Inada','Takaši Nagasako','Daiki Nakamura','Čigusa Ikeda','Kacujuki Koniši','Hirojuki Jošino','Masako Džó','Sanae Kobajaši','Šindži Kawada','Akio Sujama','Masaši Hirose','Jósuke Akimoto','Hitomi','Masaki Aizawa','Hiromi Hirata','Júko Kobajaši','Naomi Šindó','Čó','Tomoko Kawakami','Takaja Haši',"Mari Joko'o",'Sakiko Tamagawa','Emi Šinohara','Tomojuki Šimura','Kóiči Sakaguči','Takeharu Óniši','Kijojuki Janada',"Šin'ja Ótaki","Miki Mači'i",'Masato Amada','Jukari Tamura','Mizuko Arima','Rjókiči Takahaši','Jasuhiko Tokujama','Džin Horikawa','Taiki Macuno','Jošino Ótori','Megumi Tano','Šihori Niwa','Micuaki Madono','Nobujuki Furuta',"Ken'iči Ono",'Seidži Sasaki','Masahiko Tanaka','Jošihisa Kawahara','Hitoši Horimoto','Ruri Asano','Jukitoši Hori',"Kei'iči Sonobe",'Tošija Ueda','Čie Kódžiro','Juriko Jamaguči','Masumi Asano','Micuru Ogata','Šóko Kikuči',"Šin'ičiró Óta",'Jukimasa Kišino','Tóru Ókawa','Asako Širakura','Motomu Kijokawa','Šúhei Sakaguči','Acuko Mine','Naohiro Jamamoto','Fudžiko Takimoto','Rjúzó Išino','Naomi Wakabajaši','Hisao Egawa','Rikija Kojama','Tošihiko Nakadžima','Kóiči Hasebe','Kendži Ucumi','Keidži Fudžiwara','Kódži Jusa','Jumiko Kobajaši','Issei Futamata','Kódži Cudžitani','Juki Macuoka','Tošijuki Morikawa','Makoto Higo','Masaaki Ókura','Jorie Terauči'],
basedOn:['George Morikawa'],
screenplay:['Kazujuki Fudejasu','Tacuhiko Urahata','Šingó Nišikawa','Rjósuke Nakamura','Kódži Aritomi','Kendži Sugihara','Jasuko Kamo','Fumie Muroi','Daisuke Araniši'],
production:['Masao Marujama','Micuru Óšima','Hiroši Jamašita'],
music:['Cuneo Imahori'],
camera:['Hisao Širai','Takahiro Mijata'],
cut:['Kašiko Kimura','Satoši Terauči','Jukiko Itó','Jurika Cučija'],
sound:['Masafumi Mima'],
scenography:['Hidetoši Kaneko']},
{title:'Bad Exorcist',
titleCZ:'Vymítač Boner',
year:2020,
runtime:'10h 34min',
episodeRuntime:'11-18min',
countries:['Poland'],
genres:['Comedy','Animation'],
director:['Bartosz Walaszek'],
actors:['Bartosz Walaszek','Tom Bromhead'],
screenplay:['Bartosz Walaszek'],
production:['Bartosz Walaszek']},
{title:'Ozark',
titleCZ:'Ozark',
year:2017,
runtime:'44h 30min',
episodeRuntime:'52-80min',
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Jason Bateman','Daniel Sackheim','Andrew Bernstein','Ellen Kuras','Phil Abraham','Alik Sakharov','Amanda Marsalis','Ben Semanoff','Melissa Hickey','Robin Wright','Laura Linney'],
actors:['Jason Bateman','Laura Linney','Julia Garner','Esai Morales','Jason Butler Harner','Clayton Rohner','Sean Freeland','Ralph Alexander','Skylar Gaertner','Josh Randall','Bruce Altman','McKinley Belcher III','Steve Witting',"Brandon O'Dell",'Lyon Beckwith','Jordana Spiro','Harris Yulin','Charlie Tahan','Marc Menchaca','Christopher James Baker','Adam Boyer','Jill Jane Clements','Dave Hager','Michael Mosley','Peter Mullan','Ben Rappaport','Sherry Richards','Trevor Long','Cassady McClincy','Alex ter Avest','Keith Flippen','Joshua Brady','Nancy De Mayo','Ivan Martin','Jim Dougherty','Quinn Cooke','Janet McTeer','Jackson Beals','Ian Gregg','Gunner Willis','Kiley Casciano','Robert C. Treveiler','Nelson Bonilla','Ricky Muse','Mariana Paola Vicente','Spencer Neville','Sofia Hublitz','Lisa Emery','Darren Goldstein','John Bedford Lloyd','Damian Young','Pedro Lopez','Claire Bronson','Erica Page','Samantha Worthen','Victor McCay','Michael Aaron Milligan','Amy Parrish','Brooke Butler','Jim Gleason','Jonathon Pawlowski','Eric Mendenhall','Andrew Masset','Charles Green','Bethany Anne Lind','Asher Miles Fallica','Michael Tourek','Jerri Tubbs','Opal Littleton','Megan Hayes','Abby Glover','Erin Elizabeth Burns','Jay DeVon Johnson','Joseph Sikora','Tom Pelphrey','Erin Ownbey','Robert Tinsley','Felix Solis','Philip Fornah','Renell Gibbs','Malone Thomas','Matt Lewis','Adam Cronan','Melissa Saint-Amand','José Alfredo Fernandez','Dani Deetté','Skyler Elyse Philpot','Tracey Bonner','Alicia Kelley','Gabrielle Byndloss','Lindsay Ayliffe','Madison Thompson','Elizabeth Becka','Gissette Valentin','Bruno Bichir','Jason Davis','Patricia French','Alfonso Herrera','Adam Rothenberg','Rodrigo Rojas'],
screenplay:['Paul Kolsby','Chris Mundy','Bill Dubuque','David Manson','Martin Zimmerman','Alyson Feltes','John Shiban','Miki Johnson','Laura Deeley','Michael M. Chang','Jed Rapp Goldstein','Ning Zhou'],
production:['Patrick Markey','Chris Mundy','Dana Scott','Laura Deeley','Paul Kolsby','Martin Zimmerman','Matthew Spiegel'],
music:['Danny Bensi','Saunder Jurriaans'],
camera:['Pepe Avila del Pino','Ben Kutchins','Armando Salas','Shawn Kim','Attila Szalay','Eric Koretz'],
cut:['Cindy Mollo','Vikash Patel','Elliott Eisman','Heather Goodwin Floyd'],
sound:['Michael Kalifa','Larry Benjamin','Kurt Nicholas Forshager','Kevin Valentine'],
scenography:['Derek R. Hill','David J. Bomba','Elena Albanese','Kim Leoleis','Anthony Stabley','Hugo Santiago'],
masks:['Nikki Bell','Erin Keith','Jessie Gambardella','Dee Dee Metzger'],
costumes:['Stephani Lewis']},
{title:'SAS: Rogue Heroes',
titleCZ:'Pluk mizerů',
year:2022,
runtime:'11h 15min',
episodeRuntime:'55-58min',
countries:['UK'],
genres:['War','Drama','Thriller'],
director:['Tom Shankland'],
actors:['Connor Swindells',"Jack O'Connell",'Sofia Boutella','Alfie Allen','Dominic West','Jacob Ifan','Jacob McCarthy','Theo Barklem-Biggs','Bobby Schofield','Stuart Campbell','Tom Glynn-Carney','Jason Watkins','Adrian Lukis','Amir El-Masry','Dónal Finn','Virgile Bramly','Paul Boche','Moritz Jahn','César Domboy','Tom Hygreck','Anthony Calf','Miles Jupp','James Wilbraham','Michael Shelford','Ramzan Miah','Nisrine Adam','Jo Stone-Fewings','Michael Shaeffer','Nicholas Nunn','Nicholas Burns','Loris Scarpa','Isobel Laidler','Ian Davies','Arthur Orcier'],
basedOn:['Ben Macintyre'],
screenplay:['Steven Knight'],
production:['Stephen Smallwood'],
music:['Ilan Eshkeri'],
camera:['Stephan Pehrsson'],
cut:['Carmela Iandoli','Malcolm Crowe','Vicky Tooms','Helen Chapman'],
sound:['Nigel Squibbs'],
scenography:['Richard Bullock','Alice Norris','Bethany Doughty'],
masks:['Claire Campbell','Sarah Spears'],
costumes:['Rachel Walsh']},
{title:'Mad Jack the Pirate',
titleCZ:'Pirát divoký Jack',
year:1998,
runtime:360,
episodeRuntime:30,
countries:['USA'],
genres:['Animation','Comedy'],
director:['Bill Kopp','Jeff DeGrandis'],
actors:['Jess Harnell','Bill Kopp','Brad Garrett','Jay Robinson','Reinder van der Naalt','April Winchell','Cam Clarke','Steve Ochs'],
screenplay:['Martin Olson','Steve Ochs'],
production:['Jeff DeGrandis'],
music:['Haim Saban'],
sound:['T.A. Moore Jr.','Mark Ettel']},
{title:'Scenes from a Marriage',
titleCZ:'Scény z manželského života',
year:2021,
runtime:'4h 50min',
episodeRuntime:'54-64min',
countries:['USA'],
genres:['Drama'],
director:['Hagai Levi'],
actors:['Oscar Isaac','Jessica Chastain','Sunita Mani','Corey Stoll','Michelle Williams','Nicole Beharie','Tovah Feldshuh','Tre Ryder','Shirley Rumierk','Michael Aloni','Susan Pourfar','Daniella Rabbani','Anna Rust','Hagai Levi','Sophia Kopera','Lily Jane'],
screenplay:['Hagai Levi','Amy Herzog'],
production:['Carver Karaszewski'],
music:['Jevgenij Galperin','Saša Galperin'],
camera:['Andrij Parekh'],
cut:['Yael Hersonski'],
sound:['Niv Adiri'],
scenography:['Kevin Thompson','Stephanie Q. Bowen'],
masks:['Tricia Heine'],
costumes:['Miyako Bellizzi']},
{title:'The Loudest Voice',
titleCZ:'Nejsilnější hlas',
year:2019,
runtime:'5h 51min',
episodeRuntime:'46-54min',
countries:['USA'],
genres:['Drama'],
director:['Kari Skogland','Stephen Frears','Jeremy Podeswa','Scott Z. Burns'],
actors:['Russell Crowe','Naomi Watts','Sienna Miller','Josh Charles','Seth MacFarlane','Annabelle Wallis','Simon McBurney','Aleksa Palladino','Josh Stamberg','Guy Boyd','John Finn','Mackenzie Astin','Patch Darragh','Hayley Griffith','Orlagh Cassidy','Kaye Tuckerman','Matt Crabtree','Rod McLachlan','Susan Pourfar','Peggy Gormley','Meredith Holzman','Catherine Blades','Nicholas J. Coleman','Emory Cohen','Jessica Hecht','Barry Watson','Timothy Busfield','Josh Helman','Catherine Curtin','Richard Topol','Jenna Leigh Green','Natalie Roy','April Rogalski','Jane May Graves','Erin Gerasimovich','Conor Donovan','Erin Darke','Fran Kranz','Joe Cortese','David Whalen','Mark Zeisler','Anthony Caso','Josh McDermitt','Kieran Mulcare','Mark Lotito','Julee Cerda','Kevin Anton','Jamie Jackson','Nicholas Baroudi','Peter Grosz','Lucy Owen','Adam Harper','Gayatri Bahl','Erica Cho','Raymond Neil Hernandez'],
basedOn:['Gabriel Sherman'],
screenplay:['Laura Eason','Tom McCarthy','Gabriel Sherman','Alex Metcalf','Jennifer Stahl'],
production:['Jason Blum','Agatha Warren'],
camera:['Eigil Bryld','William Rexer','Tim Norman'],
cut:['Padraic McKinley',"Greg O'Bryant",'Vanessa Procopio','Matthew Woolley'],
sound:['Andrew Garrett Lange','Dan Cubert'],
masks:['Kenny Myers','Adrien Morot','Laura Burns'],
costumes:['Catherine Riley']},
{title:'Vengeance Unlimited',
titleCZ:'Pomsta - s.r.n.',
year:1998,
runtime:960,
episodeRuntime:60,
countries:['USA'],
genres:['Crime','Drama'],
director:['James Frawley','Lou Antonio','Mel Damski','Bobby Roth','John Patterson','Alan J. Levi','Bill Norton','Perry Lang','Adam Nimoy'],
actors:['Michael Madsen','Kathleen York','Jeffrey Pierce','Gregg Henry','Scott Patterson','Greg Grunberg','Alan Blumenfeld','Tom Wood','Silas Weir Mitchell','Wanda De Jesus','Rick Peters','Dakin Matthews','Jennifer Bransford','Ken Jenkins','Bobby Garabedian','Markus Redmond','Scott Alan Smith','Frankie Thorn','Tom Dugan','Cary-Hiroyuki Tagawa','Kimberly Huie','Twink Caplan','Amanda Pays','Richard Beymer','Tony Denison','Louis Herthum','Clare Carey','Darin Cooper','Al Israel','Jarrad Paul','Dayton Callie','Francesco Quinn','Raphael Sbarge','Cliff Potts','Suzanne Ford','Tim Thomerson','Steven Schub','Travis Fine','Cotter Smith','Lisa Langlois','Jennifer Hetrick','Lindsay Taylor','Ray Laska','Karen Austin','James Avery','Christian Clemenson','Senta Moses','Clint Culp','Gina Gallego','Jerry Mathers','Raymond Ma','John Aprea','David Brisbin','Michael Harney','Markus Flanagan','Mark Kiely','Allen Cutler','Chris Jaymes','Charles C. Stevenson Jr.','Patricia Gaul','Thomas Bellin','Dina Merrill','Lewis Van Bergen','Alexia Robinson','Sandra Ellis Lafferty','Niklaus Lange','Christopher John Fields','Jeff Austin','Mel Jackson','Ryan Bollman','James Coburn','Louisa Abernathy','Michael B. Silver','Richard Jamison','Sage Parker','Tom Billett','Karen Lorre','Richard Gross','Marcy Goldman','Claudette Sutherland','Shawn Huff','Fred Sanders','Richard Gilbert-Hill','Bart McCarthy','Ken Takemoto','Keith Sellon-Wright','Christian Leffler','Frankie J. Allison','Scott Allan Campbell',"Skip O'Brien",'Tom La Grua','Charmaine De Grate','David Bickford'],
screenplay:['John McNamara','Kim Newton','Wendy Battles','Charles Holland','Tom Chehak','David Simkins'],
camera:['Robert Draper','Donald M. Morgan'],
cut:['Michael Kewley','Scott K. Wallace','David Ekstrom'],
sound:['Michael E. Lawshe'],
scenography:['Anthony Cowley','Bryan Thetford'],
masks:['Jill Cady'],
costumes:['Darryl Levine']},
{title:'The Ricky Gervais Show',
titleCZ:'Show Rickyho Gervaise',
year:2010,
runtime:'15h 53min',
episodeRuntime:'21-27min',
countries:['USA'],
genres:['Animation','Comedy'],
director:['Dan Fraga','Craig Kellman'],
actors:['Ricky Gervais','Stephen Merchant','Karl Pilkington'],
production:['Margaret M. Dean'],
music:['Glyn Hughes'],
cut:['Damon P. Yoches','Bruce King']},
{title:'Westworld',
titleCZ:'Westworld',
year:2016,
runtime:'35h 28min',
episodeRuntime:'48-91min',
countries:['USA'],
genres:['Sci-Fi','Thriller','Western','Drama','Mystery'],
director:['Jonathan Nolan','Richard J. Lewis','Neil Marshall','Vincenzo Natali','Jonny Campbell','Frederick E.O. Toye','Stephen Williams','Michelle MacLaren','Lisa Joy','Craig Zobel','Tarik Saleh','Nicole Kassell','Uta Briesewitz','Amanda Marsalis','Paul Cameron','Anna Foerster','Jennifer Getzinger','Helen Shaver','Craig William Macneill','Hanelle M. Culpepper','Meera Menon','Andrew Seklir'],
actors:['Anthony Hopkins','Jeffrey Wright','Sidse Babett Knudsen','Evan Rachel Wood','James Marsden','Thandiwe Newton','Ed Harris','Shannon Woodward','Luke Hemsworth','Angela Sarafyan','Jimmi Simpson','Rodrigo Santoro','Clifton Collins Jr.','Simon Quarterman','Leonardo Nam','Joshua Sawtell','Ingrid Bolsø Berdal','Steven Ogg','Currie Graham','Kyle Bornheimer','Brian Howe','Jackie Moore','Louis Herthum','Demetrius Grosse','Brook Kerr','Eddie Rouse','Jason Konopisos','Molly Schreiber','Vincent M. Biscione','Bridgid Coulter','Sancho Martin','James Landry Hébert','Tessa Thompson','Jeff Daniel Phillips','Mike Bash','Ben Barnes','Talulah Riley','Tait Fletcher','Oliver Bell','Chris Browning','Jonathan Erickson Eisley','Paul Fox','Bruno Gunn','Travis Hammer','Chris Mollica','Bojana Novakovic','Tom Proctor','Ward Roberts','Eddie Shin','Petra Lo','Judson Mills','Lili Bordán','Dylan Kenin','Chris Osborn','Jonny Pasvolsky','Micah Fitzgerald','Robert Allen Mukes','Ane Crabtree','Jessica Clark','Bryan Friday','Donnabella Mortel','Martin Sensmeier','Michael Wincott','Lili Simmons','Kaiwi Lyman','Trevante Rhodes','Folake Olowofoyeku','Kanin Howell','Katja Herbers','Jonathan Tucker','Neil Jackson','Timothy Lee DePriest','Frantz Durand','Tai Bennett','Regi Davis','Josh Clark','Brian Ames','Lane Smith Jr.','Andrew Constantini','Maddison Bullock','Christine Weatherup','Tao Okamoto','Julia Jones','Kiki Sukezane','Zahn McClarnon','Gustaf Skarsgård','Rinko Kikuči','Peter Mullan','Hirojuki Sanada','Betty Gabriel','Fares Fares','René Ashton','Randal Edwards','Adrian Dev','Brett Edwards','Boualem Hassaine','Anouar H. Smaine','Mark Kubr','Giancarlo Esposito','Wiley M. Pickett'],
screenplay:['Jonathan Nolan','Lisa Joy','Daniel T. Thomsen','Ed Brubaker','Carly Wray','Roberto Patino','Halley Wegryn Gross','Dan Dietz','Kath Lingenfelter','Ron Fitzgerald','Jordan Goldberg','Karrie Crouse','Suzanne Wrubel','Denise Thé','Christina Ham','Matt Pitts','Kevin Lau','Will Soodik','Wes Humphrey','Charles Yu'],
music:['Ramin Djawadi'],
camera:['Paul Cameron','Brendan Galvin','Robert McLachlan','Jeffrey Jur','David Franco','Darran Tiernan','John Grillo','M. David Mullen','Zoe White','Matt Flannery','John Conroy','Peter Flinckenberg']},
{title:'Freaks and Geeks',
titleCZ:'Machři a šprti',
year:1999,
runtime:'13h 24min',
episodeRuntime:'43-48min',
countries:['USA'],
genres:['Drama','Comedy'],
director:['Danny Leiner','Bryan Gordon','Paul Feig','Judd Apatow','Jake Kasdan','Lesli Linka Glatter','Miguel Arteta','Ken Olin','Ken Kwapis'],
actors:['Linda Cardellini','John Francis Daley','James Franco','Samm Levine','Matt Czuchry','Martin Starr','Joe Flaherty','Busy Philipps','Samaire Armstrong','Seth Rogen','Sarah Hagan','Lizzy Caplan','Alexander Gould','JoAnna Garcia Swisher','Jack Conley','Alexandra Breckenridge','Jason Segel','Brianna Lynn Brown','Percy Daggs III','Samantha Shelton','Ben Stiller','Chauncey Leopardi','Paul Feig','Kayla Ewell','David Bowe','Jessica Campbell','Kevin Tighe','Lauren Hodges','Omri Katz','Michael Andrews','Kristy Wu','Tom Wilson','Dave Allen','Ben Livingston','Ann Dowd','Becky Ann Baker','Lyle Kanouse','Jonathan Kasdan','Amy Aquino','Ben Ziff','Joanna Canton','Natasha Melnick','Herbert Russell','Jane Morris','Tava Smiley','Susan Krebs','Sam McMurray','John Apicella','Teddy Lane Jr.','Tom Virtue','Andy Mackenzie','Steve Higgins','Judith Drake','Stephanie Erb','Jarrett Lennon','Shane Johnson','Ron Lester','Alison Martin','Bruce Holman','Peggy Miley','Amy Wheaton','Douglas Bennett','Bruce Bohne','Ben Foster','Steve Bannos','Allen Covert','Shaun Weiss','Stephen Lea Sheppard','Rashida Jones','Mike White','Kevin Corrigan','Jason Schwartzman','Trace Beaulieu','Riley Smith','Shia LaBeouf','Leslie Mann','Claudia Christian','Meagen Fay','David Krumholtz','Bianca Kajlich','Doug Spinuzza','Pamela Gordon','Denalda Williams','Kenny Blank','Blake Shields','Steve Nguyen','Joel Hodgson','Jane Bordeaux','Renee Cohen','Jodi Fleisher','Bill Chott','Ron Marasco','Kevin Ruf','Michael C. McCarthy','Charlie Hartsock','Maura Soden','Adam Welsh','Olivia Hack','Scott McAfee','Jerry Messing'],
screenplay:['Judd Apatow','Jonathan Kasdan','Mike White','Patty Lin','Gabe Sachs','Jeff Judah','Paul Feig','J. Elvis Weinstein','Bob Nickman','Rebecca Sinclair','Steve Bannos'],
production:['David Knoller','J. Elvis Weinstein','Victor Hsu'],
music:['Michael Andrews'],
camera:['Bill Pope','Russ T. Alsobrook'],
cut:['Brent White','Tara Timpone','Sean K. Lambert'],
sound:['Mace Matiosian','Joseph D. Citarella','Neil Brody'],
scenography:['Philip Messina','Jefferson Sage'],
masks:['Laverne Caracuzzi'],
costumes:['Debra McGuire']},
{title:'Ray Donovan',
titleCZ:'Ray Donovan',
year:2013,
runtime:'74h 49min',
episodeRuntime:'45-61min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Allen Coulter','Greg Yaitanes','John Dahl','Daniel Attias','Michael Uppendahl','Lesli Linka Glatter','Guy Ferland','Jeremy Podeswa','Tucker Gates','Daniel Minahan','Michael Apted','Phil Abraham','Liev Schreiber','Colin Bucksey','Ed Bianchi','David Hollander','Robert McLachlan','Daisy von Scherler Mayer','Tricia Brock','James Whitmore Jr.','Stephen Williams','Zetna Fuentes','Tarik Saleh','Denise Di Novi','Joshua Marston','Nick Gomez','Dash Mihok','Kyra Sedgwick'],
actors:['Liev Schreiber','Paula Malcomson','Eddie Marsan','Kate Moennig','Kerris Dorsey','Frank Whaley','Jon Voight','Elliott Gould','Ambyr Childers','Devon Bagby','Peter Jacobson','Dash Mihok','Josh Pais','Brooke Smith','Denise Crosby','Max Bird-Ridnell','Johnathon Schaech','James Woods','Drew Powell','Pooch Hall','Lidia Porto','Michael Trotter','David Dastmalchian','Ashley Jackson','Austin Nichols','Kwame Patterson','Octavius J. Johnson','William Stanford Davis','Doug McKeon','Tara Holt','Diego Serrano','Paul Michael Glaser','Sheryl Lee Ralph','Michael McGrady','Rosanna Arquette','Michael Cristofer','Jonathan Kowalsky','Jessica Jean Milligan','Mark Adair-Rios','Exie Booker','Heather Schlitt','Hank Azaria','Ann-Margret','Brent Spiner','Alexandra Shipp','Vinessa Shaw','Wendell Pierce','Presciliana Esparolini','Tori Black','John Ales','Brian Geraghty','Heather McComb','Sherilyn Fenn','Kip Pardue','Andrea Bogart','Omar J. Dorsey','Richard Fancy','Eion Bailey','Jayne Taini','Richard Benjamin','Kandis Fay','Jamie Donnelly','Colby French','Jeryl Prescott',"Casey O'Keefe",'Taji Coleman','Glenn Keogh','Brooke Newton','Connie Sawyer','Jake Elliott','Garrett Boyd','Mariano Mendoza','Tom Virtue','Ian Patrick Williams','Nick Gracer','Katie Holmes','Loanne Bishop','Karen Ann Cabrera','Leland Orser','Mary Mara','Shree Crooks','Leah Bateman','Chase Wilmot','Julia Silverman','Karina Logue','Ian McShane','Andre Brooks','Chris Cordone','Jay R. Ferguson','Elizabeth Greer','Scott Slade','Alyssa Diaz','Stephanie Erb','B.J. Clinkscales','Steph DuVall','Christy Williams','Aaron Staton','Char Sidney','Jason Butler Harner','Fairuza Balk'],
screenplay:['Ron Nyswaner','David Hollander','Michael Tolkin','Brett Johnson','Cheo Hodari Coker','Sean Conway','Chad Feehan','Mike Binder','William Wheeler','Gina Welch','Ann Biderman','Miki Johnson','Joshua Marston','Tanya Barfield','Laura Marks','Rob Fresco','Jim Leonard','Karl Taro Greenfeld','Liev Schreiber'],
music:['Marcelo Zarvos'],
camera:['Matthew Jensen','Robert McLachlan','Loren Yaconelli','Roy H. Wagner','David Franco','Dan Stoloff','Ron Fortunato','Mauricio Rubinstein']},
{title:'Patrick Melrose',
titleCZ:'Patrick Melrose',
year:2018,
runtime:'5h 4min',
episodeRuntime:'59-63min',
countries:['UK'],
genres:['Drama'],
director:['Edward Berger'],
actors:['Benedict Cumberbatch','Allison Williams','Jennifer Jason Leigh','Hugo Weaving','Holliday Grainger','Indira Varma','Jessica Raine','Anna Madeley','Prasanna Puwanarajah','Jennifer Armour','Cory Peterson','Anthony Boyle','James Fleet','Pip Torrens','Margo Stilley','Morfydd Clark','Harriet Walter','Irène Jacob','Gary Beadle','Jamie Bradley','Amanda Root','John Standing','Julian Firth','Richard Dixon','Hippolyte Girardot','Tim McMullan','Simon Weir','Celia Imrie','Blythe Danner','Kevin Layne','Janine Harouni','Gabriel Quigley','Kerry Shale'],
basedOn:['Edward St. Aubyn'],
screenplay:['David Nicholls'],
production:['Stephen Smallwood'],
music:['Volker Bertelmann'],
camera:['James Friend'],
cut:['Luke Dunkley','Dan Roberts','Tim Murrell'],
sound:['Nigel Squibbs'],
scenography:['Tom Burton','Lucienne Suren'],
costumes:['Keith Madden']},
{title:'Navy Street',
titleCZ:'Kingdom',
year:2014,
runtime:'30h 40min',
episodeRuntime:'43-56min',
countries:['USA'],
genres:['Drama'],
director:['Adam Davidson','Gary Fleder','Dennie Gordon','Tim Iacofano','Padraic McKinley','Sidney Sidell','Craig Zisk','John Dahl','Michael Morris'],
actors:['Frank Grillo','Kiele Sanchez','Matt Lauria','Nick Jonas','Joanna Going','Paul Walter Hauser','Jonathan Tucker','Juliette Jackson','Natalie Martinez','Mac Brandt','Gentry White','Bryan Casserly','Evan Arnold','Bryan Callen','Keith Campbell','Coby Ryan McLaughlin','Joe Spellman','Jeff Ross','Anne Johnson','Kirk Acevedo','Lina Esco','Katherine Hughes','Jamie Harris','Mario Perez','Anna Easteden','Kim Robillard','Zuleikha Robinson','Ronnie Gene Blevins','Frederick Koehler','Dina Meyer','Talia Shire','Chris Coy','Jonathan Howard','Patrick St. Esprit','Deborah Meister','Kevin Weisman','Larry Poindexter','Roman Mitichyan','Mark Consuelos','Jessica Szohr','Mark Adair-Rios','M.C. Gainey','Michael Mantell','Suzanne Whang','Michael Graziadei','Vince Duvall','Bruce Davison','Roxy Olin','Andre Royo','Paul Ben-Victor','Billy Lush','Hector Luis Bustamante','Jolene Andersen','Alina Andrei','Kamar de los Reyes','Wendy Moniz','Robert Baker','Corbin Reid','Obba Babatundé','Meaghan Rath','Alicia Witt','Jamie Kennedy','Cynthia Stevenson','Fernanda Andrade','Lane Smith Jr.','Santana Dempsey','Brandon Barash','Matthew Le Nevez','Kevin Makely','Courtney Bandeko','Madeleine Wade','Phil Abrams','Lukas Gage','Chloe Lanier','Joe LoCicero','Alisa Allapach',"James Dav're",'Anita Tucker','M.J. Karmi','Joy Osmanski','Adam Shapiro','Avery Kidd Waddell','Michael Stoyanov','Darrion Scoggins','Ken Waters','Ishmel Sahid','Melody Butiu','Steph Langnas','J.J. Boone','Bruce M. Stockert','Shanti Lowry','Kyle McCaffrey','Callen David','Max Valentine','Karole Foreman','Adam Zastrow','Zach Scheerer','Paul Eliopoulos'],
screenplay:['Fernanda Coppel','Vladimir Cvetko','Jennifer Ames','Bruce Rasmussen','Alex Metcalf','Steve Turner','Patrick Aison','Enzo Mileti','Scott Wilson','Tom Garrigus','Peter Noah'],
production:['Steve Turner','Cleve Landsberg'],
music:['Tyler Bates'],
camera:['Loren Yaconelli','Sidney Sidell'],
cut:['Padraic McKinley','Banner Gwin','Matthew Woolley'],
sound:['Karol Urban','Larry Benjamin',"Andy D'Addario",'Mike Marchain','Keith Rogers','Walter Anderson','Mark Friedgen'],
scenography:['Maria Caso','Linda Louise Sheets'],
masks:['Ken Diaz','Roxxi Dott','Vanessa Price'],
costumes:['Julia Schklair','Nancy Ceo','Agata Maszkiewicz']},
{title:'Fur TV',
titleCZ:'Fur TV',
year:2008,
runtime:'2h 56min',
episodeRuntime:'22min',
countries:['UK'],
genres:['Comedy'],
director:['Chris Waitt','Simon Ellis','Ben Unwin'],
actors:['Simon Greenall','Sophiya Haque','Dominic Burns','Kate Groombridge','Shelley Longworth','Richard Glover'],
production:['Derrin Schlesinger'],
music:['Chris Waitt'],
camera:['Ossie McLean'],
cut:['Adam Windmill','Ben Unwin']},
{title:'Euphoria',
titleCZ:'Euforie',
year:2019,
runtime:'25h 15min',
episodeRuntime:'50-65min',
countries:['USA'],
genres:['Drama'],
director:['Augustine Frizzell','Sam Levinson','Jennifer Morrison','Pippa Bianco'],
actors:['Zendaya','Hunter Schafer','Austin Abrams','Sydney Sweeney','Jacob Elordi','Alexa Demie','Algee Smith','Barbie Ferreira','Lukas Gage','Maude Apatow','Angus Cloud','Nika King','Alanna Ubach','Storm Reid','Eric Dane','Keean Johnson','Olivia Grace Applegate','McKenna Roberts','John Ales','George W. Bush','Britney Spears','Paula Marshall','Colman Domingo','Zak Steiner','Jeremiah Birkett','Tyler Chase','Mercedes Colon','Elsa Marquez','Meeko',"Javon 'Wanna' Walton",'Tyler Timmons','Tristan Timmons','Johanna Colón','Lauren Graham','Scott Patterson','Stephen Moyer','Anna Paquin','Tony Goldwyn','Kerry Washington','Charles Manson','Pell James','Will Peltz','Anthony Ray Parker','Nancy De Mayo','Mike Ostroski','Hannah Nordberg','Elpidia Carrillo','Larry Joe Campbell','Shiloh Fernandez',"Vito D'Ambrosio",'Aliyah Conley','Andy Sandoval','Courtney Taylor Burness','Cranston Johnson','Michael Petrone','Will Peltz','Nat Faxon','Nick Blood','Bobbi Salvör Menuez','Quintessa Swindell','Ryan Gibson','Chris Doubek','Davey Johnson','Elizabeth Greer','An Phan','Allie Marie Evans','Mel Fair','Bruce Wexler','David Meza','Isaac Arellanes','Jennifer Kathreen Larson','Alyson Van','Clark Furlong','Kelvin Harrison Jr.','Jeff Pope','Montanna Gillis','Lauren Weedman','Bree Winslow',"Brock O'Hurn",'Jean Kinsella','Janet Song','Lindsey Sirera','Aileen Burdock','Peyton Clark','Ruben Dario','Michael Franklin','Will Fourth','Martha Kelly','Andy Mackenzie','Richie Merritt','Kathrine Narducci','Chloe Cherry','Cinda Adams','Daeg Faerch','Miguel Garzon Martinez','Aiden Ashley','Minka Kelly','Amanda LaCount','Maynard Bagang','Joanne Baron'],
screenplay:['Sam Levinson','Hunter Schafer'],
production:['Philipp A. Barnett','Harrison Kreiss','Kenneth Yu'],
music:['Labrinth','Gustave Rudman'],
camera:['Marcell Rév','Adam Newport-Berra','Drew Daniels','Rina Yang'],
cut:['Julio Perez IV','Harry Yoon','Laura Zempel','Aaron I. Butler'],
sound:['Wylie Stateman','Brett Hinton'],
scenography:['Michael Grasley','Kay Lee','Chilly Nathan','Jason Baldwin Stewart','Adam Willis','Bryan Langer','Kirby Feagan','Alyssa Hill','Julia Altschul','Rebekah Killam'],
masks:['Daniel Curet','Monique Hyman','Doniella Davy','Mary Czech','Melanie Smith'],
costumes:['Heidi Bivens']},
{title:'Bodyguard',
titleCZ:'Bodyguard',
year:2018,
runtime:'5h 53min',
episodeRuntime:'57-60min',
countries:['UK'],
genres:['Crime','Drama','Thriller'],
director:['Thomas Vincent','John Strickland'],
actors:['Richard Madden','Sophie Rundle','Vincent Franklin','Paul Ready','Nicholas Gleaves','Pippa Haywood','Gina McKee','Stuart Bowman','Ash Tandon','Richard Riddell','Anjli Mohindra','Nina Toussaint-White','Keeley Hawes','Tom Brooke','Claire-Louise Cordwell','Shubham Saraf','Mishal Husain','Matt Stokoe','Stephanie Hyam','David Westhead','Michael Shaeffer','Rosie Jones','Bailey Patrick','Tina Chiang','Julian Firth','Olwen May','Renée Castle','Joanna Burnett','Peter Basham','Andrew Marr',"Hugh O'Brien",'Michael Müller','Miriam Lucia','Russ Bain','Phelim Kelly','Gary Pillai','David Carlyle','Oliver Devoti','Lucas Antoine Starrets','Faraz Ayub','Matthew Stagg'],
screenplay:['Jed Mercurio'],
production:['Eric Coulter'],
music:['Ruth Barrett','Ruskin Williamson'],
camera:['John Lee'],
cut:['Steve Singleton','Andrew McClelland'],
scenography:['Jamie Lapsley','Steve Wright'],
masks:['My Alehammar'],
costumes:['Charlie Knight']},
{title:'The Legend of Korra',
titleCZ:'Legenda Korry',
year:2012,
runtime:'19h 56min',
episodeRuntime:'23min',
countries:['USA'],
genres:['Animation','Action','Adventure','Fantasy'],
director:['Ian Graham','Colin Heck','Joaquim Dos Santos','Ki Hyun Ryu','Melchior Zwyer','Michael Dante DiMartino','Chan-Young Park','Sung-jin Suh','Yu-Won Pang'],
actors:['Janet Varney','Jeff Bennett','Dee Bradley Baker','P.J. Byrne','David Faustino','J.K. Simmons','Seychelle Gabriel','Mindy Sterling','Logan Wells','Kiernan Shipka','John Michael Higgins','Darcy Rose Byrnes','Maria Bamford','Richard Riehle','James Remar','Adrian LaTourelle','Anne Heche','Lisa Edelstein','Henry Rollins','Steve Blum','Aubrey Plaza','Zelda Williams','Stephanie Sheh','Spencer Garrett','Aaron Himelstein','Alyson Stoner','Grey Griffin','Jim Meskimen','Daniel Dae Kim','Lance Henriksen','Dante Basco','Tom Kenny','Stephen Root','Michael Dante DiMartino','George Coe','Fisher Stevens','Joey Richter','Jayne Taini','Max Charles','Amy Gross','Justin Prentice','Serena Williams','Jacob Bertrand','Rick Zieff','Caitlin Carmichael','Ashley Boettcher','Kevin Michael Richardson','Tim Hedrick','Jason Isaacs','April Stewart','Paul Nakauchi','Keone Young','Marcus Toji','Barbara Goodson','Jessie Flower','Carlos Alazraqui','Amy Hill','Alex McKenna','Dave Thomas','Eva Marie Saint','Maurice LaMarche','Clyde Kusatsu','Rami Malek','Joaquim Dos Santos','D.B. Sweeney','Chris Hardwick','Clancy Brown','Bryan Konietzko','Nolan North','Tom Kane','Jim Cummings','Wade Williams','Steven Yeun','Jonathan Adams','Jason Marsden','Jennifer Hale','Hector Elizondo','Jon Heder','Michael Donovan','Bruce Davison','Gary Cole','Greg Cipes','Kristy Wu','Mitchell Whitfield','Matthew Willig','Todd Haberkorn','Robert Morse','Philece Sampler','Nika Futterman','Bailey Gambertoglio','Zach Callison','Pat Fraley','James Sie','David Kaufman','Stephen Stanton','Susan Silo','Andrea Romano','S. Scott Bullock','Michael Yurchak','Kate Higgins'],
screenplay:['Michael Dante DiMartino','Bryan Konietzko','Joshua Hamilton','Tim Hedrick','Katie Mattila'],
production:['Tim Yoon','Karen Malach'],
music:['Jeremy Zuckerman'],
cut:['Christopher Hink'],
sound:['Frank Verderosa'],
scenography:['Christine Bian','William Niu','Frederic Stewart','Angela Sung','Emily Tetri']},
{title:'The Playlist',
titleCZ:'The Playlist',
year:2022,
runtime:300,
episodeRuntime:50,
countries:['Sweden'],
genres:['Drama','Biographic'],
director:['Hallgrim Haug','Per-Olav Sørensen'],
actors:['Christian Hillborg','Gizem Erdogan','Edvin Endre','Joel Lützow','Severija Janušauskajtě','Ulf Stenberg','Ella Rappich','Jonatan Bökman','Erik Norén','Rufus Glaser','Sofia Karemyr','Valter Skarsgård','Fredrik Wagner','Sam Hazeldine','Patrick Baladi','Hanna Ardéhn','Agnes Kittelsen','Malin Barr','John Carew','Félice Jankell','Amy Deasismont','Christel Elsayah'],
basedOn:['Sven Carlsson','Jonas Leijonhufvud'],
screenplay:['Christian Spurrier','Tove Forsman'],
production:['Eiffel Mattsson'],
music:['Kristian Eidnes Andersen'],
camera:['Jonas Alarik','Ulf Brantås'],
cut:['Simen Gengenbach','Håkan Wärn'],
sound:['Vytautas Kizala'],
scenography:['Liv Ask','Lise Hillkirk Olimb','Ieva Rojute','Liberta Misan','Hanna Drugge'],
masks:['Linda Boije af Gennäs','Sandra Mateikaitė','Vilma Garliauskiene'],
costumes:['Mia Ögren']},
{title:'1932',
titleCZ:'1923',
year:2022,
runtime:'15h 47min',
episodeRuntime:'48-70min',
countries:['USA'],
genres:['Drama','Western'],
director:['Ben Richardson','Guy Ferland'],
actors:['Harrison Ford','Helen Mirren','Marley Shelton','Brian Geraghty','James Badge Dale','Timothy Dalton','Robert Patrick','Peter Stormare','Sebastian Roché','Darren Mann','Michelle Randolph','Aminah Nieves','Julia Schlaepfer','Jerome Flynn','Brandon Sklenar','Isabel May','Jennifer Ehle','Bruce Davison',"Kerry O'Malley",'Tim DeKay','Michael Spears','Nick Boraine','Jo Ellen Pellman','Caleb Martin','Mike Peebler','Rafe Soule','Bianca Bosch','Jessalyn Gilsig','Craig Clyde','Tim Mikulecky','Hunter Goligoski','Bradley Fisher','Michael Greyeyes','Joseph Mawle','Tanc Sade','Mark Daneri','Nico Panagiotopoulos','Walker Hare','Jamie McShane','Remy Holt','Colin Moss','Chuck McCollum','Joel Brady','Currie Graham','Cailyn Rice','Craig Jackson','Michael Andrew Baker','Wallace Langham',"Damian O'Hare",'Joy Osmanski','Danny Farber','Tony Nowicki','Andrew Koponen','Maxime Durand','David Chevers','Ryan Happy'],
screenplay:['Taylor Sheridan'],
production:['Rajeev Malhotra'],
music:['Brian Tyler','Breton Vivian'],
camera:['Corrin Hodgson','Ben Richardson','Robert McLachlan'],
cut:['Chad Galster','Byron Smith','Christopher Gay'],
sound:['Samuel Ejnes','Diego Gat','George Haddad'],
scenography:['Carla Curry','Cary White'],
costumes:['Janie Bryant']},
{title:"Kuroko's Basketball",
titleCZ:'Kuroko no basket',
year:2012,
runtime:'31h 15min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Drama','Comedy','Sport'],
director:['Šunsuke Tada','Kanta Kamei','Kazuto Nakazawa','Takajuki Hamana',"Ken'iči Macuzawa",'Naotaka Hajaši','Hazuki Mizumoto','Tošija Niidome','Icuki Imazaki','Šintaró Itoga','Takatoši Suzuki','Šigetaka Ikeda',"Ken'ičiró Komaja",'Jasuhiro Minami'],
actors:['Júki Ono','Kenšó Ono','Jošimasa Hosoja','Čiwa Saitó','Takuja Eguči','Gó Inoue',"Džun'iči Suwabe",'Fumiko Orikasa','Kazuja Nakai',"Ken'iči Suzumura","Šin'ičiró Miki",'Hiro Šimono','Sóičiró Hoši','Hiroki Jasumoto','Subaru Kimura','Kósuke Toriumi','Kijotaka Furušima','Joriko Nagata','Nobunaga Šimazaki','Hirofumi Nodžima','Kensuke Sató','Rjóhei Kimura','Jošihito Sasaki','Júja Murakami','Daisuke Ono','Naoko Sugiura','Nobujuki Hijama','Takanori Hošino','Sajori Išizuka','Kódži Takeda','Wataru Hatano','Jú Šimamura','Kaito Išikawa','Kišó Tanijama','Gó Šinomija','Júsuke Kuwahata','Kazuhiro Fusegawa','Juki Kaida','Jósuke Akimoto','Júma Učida','Rjóta Ósaka','Masakazu Morita','Tasuku Hatanaka','Cuguo Mogami','Hiroši Kamija','Tacuhisa Suzuki','Rjúzó Hasuike','Karin Nanami','Takehito Kojasu','Acuši Imaruoka','Jui Azuma','Kenta Ókuma','Tošiki Masuda','Masaki Terasoma','Šiho Kokido','Noriko Obata','Takahiro Fudžiwara','Meiko Kawasaki','Daiči Endó','Kazunori Nomata','Keisuke Hamaoka','Rjóhei Arai','Daisuke Takahaši','Kendži Hamada','Džun Fukujama','Šúhei Iwase','Hiró Sasaki','Mičiko Kaiden','Naoja Nosaka','Daigo Fudžimaki','Takuja Masumoto','Masajuki Šódži','Tomojuki Higuči','Kijohito Jošikai','Júki Hajaši','Jošimicu Takasugi','Šigejuki Susaki','Fumihiro Okabajaši','Konomi Fudžimura','Rei Šimoda','Biiči Sató','Jasuhiro Jošimoto','Naoki Mizutani','Noa Sakai','Mása Kobajaši','Hiroko Igaraši','Tecuja Kakihara','Nacuki Aikawa','Jurie Kobori','Šóta Čónan','Rjótaró Okiaju','Haruka Itó','Čise Nakamura','Hiroki Macuhisa','Juki Horinaka','Jú Hajaši','Akira Jamamoto'],
basedOn:['Tadatoši Fudžimaki'],
screenplay:['Sawako Hirabajaši','Daiširó Tanimura','Tošizó Nemoto','Noboru Takagi','Šingo Irie'],
production:['Kazuhiro Asou','Fumi Morihiro','Juka Sakurai','Hiró Marujama','Tomojuki Ówada'],
music:['Rjosuke Nakaniši','Jošihiro Ike','R.O.N.'],
camera:['Eidži Arai'],
cut:["Džun'iči Uemacu"],
sound:['Masafumi Mima'],
scenography:["Šin'ja Mita",'Mičie Suzuki']},
{title:'Bad Sisters',
titleCZ:'Zlé sestry',
year:2022,
runtime:'8h 41min',
episodeRuntime:'49-58min',
countries:['USA','Belgium','UK'],
genres:['Comedy','Drama','Thriller'],
director:['Rebecca Gatward','Josephine Bornebusch','Dearbhla Walsh'],
actors:['Anne-Marie Duff','Claes Bang','Eva Birthistle','Sarah Greene','Eve Hewson','Brian Gleeson','Daryl McCormack','Assaad Bouab','Paul Tylak','Sharon Horgan','Amy De Bhrún','Seán Doyle','Seána Kerslake','Lloyd Hutchinson','Peter Coonan',"Jonjo O'Neill",'Barry Ward','Nina Norén','Michael Smiley','Yasmine Akram','Peter Claffey','Jeanne Nicole Ní Áinle','Christie-Leigh Emby','Niall McNamee','Susan Fordham'],
screenplay:['Dave Finkel','Brett Baer','Perrie Balthazar','Paul Howard','Sharon Horgan','Ailbhe Keogan'],
production:['Susan Breen','Paul Slavin'],
music:['Tim Phillips','PJ Harvey'],
camera:['Tim Palmer','Nicole Hirsch Whitaker','David Pimm'],
cut:['Anne Sopel','Fin Oates','Catherine Creed','Derek Holland'],
sound:['Oliver Brierley'],
scenography:['Mark Geraghty','Kay Brown'],
masks:['Jodie Llewellyn','Vanessa Summers'],
costumes:['Camille Benda']},
{title:'Wednesday',
titleCZ:'Wednesday',
year:2022,
runtime:'13h 52min',
episodeRuntime:'46-57min',
countries:['USA'],
genres:['Comedy','Mystery','Horror'],
director:['Tim Burton','Gandja Monteiro','James Marshall'],
actors:['Jenna Ortega','Catherine Zeta-Jones','Luis Guzmán','Isaac Ordonez','Fred Armisen','Gwendoline Christie','Christina Ricci','Tommie Earl Jenkins','William Houston','Riki Lindhome','Jamie McShane','Hunter Doohan','Georgie Farmer','Emma Myers','Percy Hynes White','Michael Okele','Joy Sunday','Islam Bouakkaz','Moosa Mostafa',"Lisa O'Hare",'Sophia Nomvete','Murray McArthur','Gloria Garcia','Nitin Ganatra','Lucius Hoyos','Amanda Drew','Philip Rosch','Lachele Carl','Olimpia Malai','Oliver Watson','Johnna Dias-Watson','Naomi J. Ogawa','Iman Marson','Calum Ross','Luyanda Unati Lewis-Nyawo','George Burcea','Ryan Ellsworth','Gwen Jones','Gracy Goldman','Karina Varadi','Victor Dorobantu'],
screenplay:['Alfred Gough','Miles Millar','Kayla Alpert','April Blair','Matt Lambert'],
production:['Carmen Pepelea'],
music:['Danny Elfman','Chris Bacon'],
camera:['David Lanzenberg','Stephan Pehrsson'],
cut:['Jay Prychidny','Ana Yavari','Paul G. Day'],
sound:['Michael Baskerville','Jamie Sulek'],
scenography:['Mark Scruton','Rob Hepburn','Adrian Curelea','Roxana Alexandru','Serban Porupca','Silvia Nancu','Ghinea Diana'],
masks:['Margo Stefan','Gabriella Havens','Raluca Moldoveanu'],
costumes:['Colleen Atwood']},
{title:'Monster',
titleCZ:'Monstrum',
year:2022,
runtime:'9h 53min',
episodeRuntime:'45-63min',
countries:['USA'],
genres:['Drama','Crime','Biographic'],
director:['Paris Barclay','Carl Franklin','Clément Virgo','Jennifer Lynch','Gregg Araki'],
actors:['Evan Peters','Richard Jenkins','Niecy Nash','Michael Learned','Molly Ringwald','Karen Malina White','Penelope Ann Miller','David Barrera','Shaun Brown','Scott Michael Morgan','Nikea Gamby-Turner','Colin Ford','Jackson Hurst','Josh Braaten','Matthew Alan','Michael Beach','Colby French','Mac Brandt','Rodney Burford','Nigel Gibbs','Dominic Burgess','Grant Harvey','Chris Gann','Rhoyle Ivy King','Brey Chanadet','Ken Clement','Peter Holden','Daniel Curtis Lee','Teshi Thomas','Cameron Cowperthwaite','Michael Andrew Baker','Trilby Glover','Alex Hyde-White','Emma Kennedy','Peter Mackenzie','Vince Hill-Bedford','Blake Cooper Griffin','Fiona Bishop','Isaac Faulkner','John Kellar','Andy Taylor Kim','Dyllón Burnside','Skyler Bible','Ivar Brogger','Ron Bush','Phet Mahathongdy','Ben Scott','Mark Weiler','Karl Makinen','Noel Arthur','Cheryl Francis Harrington','Arthur Richardson','John Shartzer','Michael Anthony Spady','Matt Steele','Brandon Black','Raphael Sbarge','Maurice Demus','Stephanie Erb','Clark Moore','Scott Thomas Reynolds','Frank Scozzari','Michael Adler','Demi Castro','Chase Fein','Vanessa Giordano','Rodney J. Hobbs','Bobbie Lee Jr.','Mercy Malick','Spencer Squire','Khetphet Phagnasay','Ken Lerner','Verton R. Banks','Phil Biedron','J. Paul Boehmer','Adwin Brown','Celestial','Sarah Chang','Bill Chott','Kareem Ferguson','Britt George','Eric Normington','Jonathan Stanley','Jordan Wall','Linda Park','Nicole Lynn Evans','David Kelsey','Matt Kaminsky','Antonio David Lyons','Rachel Winfree','Paul Zies','Anissa Borrego','Christopher Bencomo','Karole Foreman','Kyle Butenhoff','Jonathan Stanley','Christian Weissmann','Crystal Coney','Brayden Maniago','Kieran Tamondong'],
screenplay:['Janet Mock','Ryan Murphy','Ian Brennan','David McMillan','Reilly Smith','Todd Kubrak'],
production:['Mathew Hart','Regis Kimble','David McMillan','Reilly Smith','Todd Nenninger','Lou Eyrich','Todd Kubrak','Richard Jenkins'],
music:['Nick Cave','Warren Ellis'],
camera:['Jason McCormick','John T. Connor'],
cut:['Curtis Thurber','Regis Kimble','Taylor Mason','Stephanie Filo'],
sound:['Gary Megregian'],
scenography:['Matthew Flood Ferguson','Melissa Licht','Adam Karavatakis'],
masks:['Michael Ward','Annie Cardea','Robert C. Mathews III'],
costumes:['Rudy Mance']},
{title:'Final Space',
titleCZ:'Final Space',
year:2018,
runtime:'12h 50min',
episodeRuntime:'21-23min',
countries:['USA'],
genres:['Animation','Sci-Fi'],
director:['Ben Bjelajac','Mike Roberts','Juan Jose Meza-Leon','Anne Walker Farrell','Yoriaki Mochizuki'],
actors:['Olan Rogers','Fred Armisen','Tom Kenny','Tika Sumpter','Steven Yeun','David Tennant','Keith David','John DiMaggio','Caleb McLaughlin',"Conan O'Brien",'Ron Perlman','Shannon Purser','Andy Richter','Gina Torres','Ashly Burch','Jane Lynch','Vanessa Marshall','Ron Funches','Alan Tudyk','Tobias Conan Trost','Claudia Black','Oscar Montoya','Phil LaMarr','Christopher Judge','Krystal Joy Brown','Debra Wilson','Jasmin Savoy Brown'],
screenplay:['Olan Rogers','David Sacks','Jane Becker',"Dan O'Keefe",'Cameron Squires','Ben Bjelajac','Ben Mekler',"Kelly Lynne D'Angelo",'Alyssa Lane','Alex J. Sherman','Adam Stein','Christopher Amick'],
production:['Tobias Conan Trost','Matt Price'],
music:['Shelby Merry','Jake Sidwell','Andrew Goodwin'],
cut:['Matthew Pumphret','Peter Tomaszewicz','Maria Lasalle'],
sound:['Hunter Curra','Konrad Piñon','James Lucero'],
scenography:['Devin Roth']},
{title:'The Adventures of Sherlock Holmes',
titleCZ:'Dobrodružství Sherlocka Holmese',
year:1984,
runtime:'11h 16min',
episodeRuntime:'52min',
countries:['UK'],
genres:['Crime','Mystery','Drama'],
director:['David Carson','Paul Annett','Alan Grint','John Bruce','Ken Grieve'],
actors:['Jeremy Brett','Charles Gray','David Burke','Rosalie Williams','Eugene Lipinski','Ken Campbell','Joss Ackland','Natasha Richardson','Nicholas Clay','Betsy Brantley','Eric Allan','Gayle Hunnicutt','Denys Hawthorne','Charles Cork','Max Faulkner','Shelagh Stephenson','Helen Ryan','David Ross','Paul Chapman','Wolf Kahler','Brian Miller','Michael Carter','Michael Siberry','John Castle','James Wilby','Fiona Shaw','Jeremy Kemp','Rosalind Knight','George Costigan','Rosalie Crutchley','Colin Jeavons','Tim Barlow','Roger Hammond','Tim McInnerny','Richard Wilson','Alison Skilbeck','Ian Bleasdale','Norman Jones','Patience Collier','Eric Kent','Frank Middlemass','Desmond Mcnamara','Amelda Brown','Don Mccorkindale','David Gwillim','David Baukham','John Ringham','Tenniel Evans','Rosalyn Landor','Peter Jonfield','Lisa Daniely','Angela Browne','Patrick Newell','Ted Carroll','Lorraine Peters','John Woodnutt','Jonathan Adams','Gareth Thomas','Barbara Wilshere','Denise Armon','Frank Mills','Matthew Solon','Catherine Rabett','Robert Henderson','Simon Bleakley','Sarah Aitchison','Tim Condren','Colin Campbell'],
basedOn:['Arthur Conan Doyle','Arthur Conan Doyle'],
music:['Patrick Gowers'],
camera:['Mike Popley','Ray Goode','Ken Morgan'],
cut:['Chris Gill','John W. Carr']},
{title:'Studio 60 on the Sunset Strip',
titleCZ:'Studio 60',
year:2006,
runtime:'15h 54min',
episodeRuntime:'37-60min',
countries:['USA'],
genres:['Drama','Comedy'],
director:['Thomas Schlamme','Timothy Busfield','Lesli Linka Glatter','David Semel','David Petrarca','John Fortenberry','Bryan Gordon','Daniel Attias','Laura Innes','Andrew Bernstein','Christopher Misiano','Lawrence Trilling','David Chameides','Bradley Whitford'],
actors:['Matthew Perry','Amanda Peet','Bradley Whitford','Steven Weber','D.L. Hughley','Sarah Paulson','Donna Murphy','Nate Torrence','Merritt Wever','Columbus Short','Mark McKinney','Evan Handler','Lauren Graham','Timothy Busfield','Jayma Mays','Nate Corddry','Martin Sheen','Stephen Tobolowsky','James Lesure','Simon Helberg','Mircea Monroe','Kelvin Yu','Molly Price','Zeberiah Newman','Nancy Lenehan','Rob Nagle','Hallie Lambert','Sarah Christine Smith','Christopher Carley','Randy Oglesby','Lucy Davis','Kari Matchett','Felicity Huffman','Edward Asner','Michael Stuhlbarg','Kimberly Huie','Julia Ling','Michael Kostroff','Christine Adams','Jay Paulson','Ruben Pla','Amir Talai','Vanessa Born','Teddy Sears','Scott Lawrence','William Stanford Davis','Casey Sander','Blake Hood','Todd Stashwick','Hayley Marie Norman','Geno Monteiro','Maxine Bahns','Diana Maria Riva','Raymond Ma','Michael Hyatt','Eddie Hassell','Austin Basis','Alejandro Furth','Tom Virtue','Elizabeth Sung','Fred Stoller','Nick Nordella','Tony Perez','Camille Chen','Leslie Connelly','Rich Hutchman','Scott Klace','Tate Hanyok','Robert Noble','John Ennis','Vernee Watson','Mystro Clark','John Mahon','Alix Angelis','Wendy Phillips','Joseph Lyle Taylor','Jennifer Peo','Ayda Field','Judd Hirsch','Shaun Robinson','Akiva Goldsman','Rob Reiner','Cyia Batten','Christine Lahti','Anne Lockhart','Harry Van Gorkum','Sting','Eli Wallach','John Goodman','Howie Mandel','Josh Stamberg','Kurt Fuller','Christian Camargo','Masi Oka','Natalie Cole','Tamala Jones','Allison Janney','Jenna Fischer','Amy Hill','Matt McCoy'],
screenplay:['Aaron Sorkin','Dana Calvo','Mark McKinney','Mark Goffman','Chad Gomez Creasey','Dara Resnik Creasey','Eli Attie'],
production:['Aaron Sorkin','Thomas Schlamme','Dylan K. Massin','Sarah Caplan','Patrick Ward'],
music:['W.G. Snuffy Walden'],
camera:['Thomas Del Ruth','Dennis Hall'],
cut:['Russell Denove','Rob Seidenglanz','Janet Ashikaga','Matthew Colonna'],
sound:['Dan Hiland','Walter Newman','Ed Carr','Gary D. Rogers','Thomas A. Harris','Patrick Hanson','Chuck Fitzpatrick','Charles Hamilton'],
scenography:['Carlos Barbosa','Kenneth Hardy','Ellen Totleben'],
masks:['Gigi Williams','Sharon Rivera'],
costumes:['Lyn Paolo','Amy Stofsky','Kathryn Morrison']},
{title:'My Brilliant Friend',
titleCZ:'Geniální přítelkyně',
year:2018,
runtime:'30h 46min',
episodeRuntime:'43-74min',
countries:['Italy','USA'],
genres:['Drama'],
director:['Saverio Costanzo','Alice Rohrwacher','Daniele Luchetti'],
actors:['Elisa del Genio','Ludovica Nasti','Luca Gallone','Fabrizia Sacchi','Antonio Milo','Antonio Pennarella','Vittorio Viviani','Gennaro Canonico','Gaia Girace','Margherita Mazzucco','Anna Redi','Alessio Gallo','Valentina Acca','Antonio Buonanno','Clotilde Sabatino','Christian Giroso','Eduardo Scarpetta','Giovanni Buselli','Dora Romano','Valentina Arena','Elvis Esposito','Sarah Falanga','Evelina De Felice','Mario Aterrano','Mattia Bisonni','Elisabetta De Palo','Alba Rohrwacher','Emanuele Valenti','Antonio Maglione','Nunzia Schiano','Tim Daish','Francesco Russo','Mimmo Ruggiero','Carlo Tarmati','Jurij Alexejevič Gagarin','Francesca Bellamoli','Pina Di Gennaro','Anna Rita Vitolo','Giuseppe Brunetti','Francesco Catena','Gennaro De Stefano','Francesca Pezzella','Giovanni Amura','Fabrizio Cottone','Giorgia Gargano','Francesco Serpico','Federica Sollazzo','Dodi Conti','Bruno Orlando','Matteo Cecchi','Gabriele Vacis','Imma Villa','Andrea Avagliano','Iacopo Ricciotti','Eugenio di Fraia','Giulia Mazzarino','Domenico Cuomo','Paolo Serra','Paolo Tarallo','Vincenzo Antonucci','Rosaria Langellotto','Carmen Pommella','Alba Rohrwacher','Irene Maiorino','Fabrizio Gifuni','Gaia Buongiovanni','Riccardo Palmieri','Giuseppe Cortese','Daria Deflorian','Maria Vittoria Dallasta','Eduardo Rejón','Daniele Cacciatore','Davide De Lucia','Giovanni Cannata','Chiara Celotto','Giulia Pica','Claudio Lardo','Mirko Setaro','Vittorio Ciorcalo','Giovanni Toscano','Rebecca Fanucchi','Sofia Luchetti','Salvatore Tortora','Francesca Montuori','Valentina Ceriello','Sophia Protino','Antonella Formisano','Edoardo Sferrella','Ianua Coeli Linhart','Raffaella Antinucci'],
basedOn:['Elena Ferrante'],
screenplay:['Saverio Costanzo','Elena Ferrante','Laura Paolucci','Francesco Piccolo'],
production:['Laura Paolucci','Adrian Politowski','Lorenzo Mieli','Domenico Procacci','Sara Polese'],
music:['Max Richter'],
camera:['Fabio Cianchetti','Hélène Louvart','Ivan Casalgrandi'],
cut:['Francesca Calvelli','Carlotta Cristiani','Stefano Mariotti','Annalisa Forgione'],
sound:['Gaetano Carito','Emanuele Cecere','Francesco Tumminello','Brando Mosca'],
scenography:['Giancarlo Basili','Elio Maiello'],
masks:['Sonia Cedrone','Rosa Falco','Francesca Giorgino','Alessia Iacino','Aniello Piscopo','Leila Benbarka','Domingo Santoro','Virna Vento'],
costumes:['Antonella Cannarozzi','Sonia Travaglia']},
{title:'No Game No Life',
titleCZ:'No Game, No Life',
year:2014,
runtime:'4h 48min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Adventure','Fantasy','Comedy'],
director:['Acuko Išizuka','Mičita Širaiši','Hideki Hosokawa','Sumito Sasaki','Takaši Ikehata','Kotono Watanabe','Čikajo Nakamura','Juki Inaba'],
actors:['Ai Kajano','Jošicugu Macuoka','Jóko Hikasa','Mamiko Noto','Mijuki Sawaširo','Rie Kugimija','Juka Iguči','Džun Fukušima','Satomi Arai','Naomi Šindó','Harumi Sakurai','Risa Taneda','Jukari Tamura','Rjókiči Takahaši','Jasuhiro Mamija','Rei Jamahata','Haruki Išija','Mugihito','Acuši Kósaka','Kengo Kawaniši','Eidži Takeuči','Rjósuke Kanemoto','Čieko Mijazaki','Itaru Jamamoto','Hironori Saitó','Jóhei Azakami','Kóiči Sóma','Taketora','Rjóhei Arai','Šinobu Macumoto','Tošiki Iwasawa','Juka Keičó','Kenta Macumoto','Seidži Kató','Džun Jokojama','Taisuke Nišimura','Rjókan Kojanagi','Jóhei Namekawa'],
basedOn:['Jú Kamija'],
screenplay:['Kento Šimojama','Džukki Hanada','Takaši Aošima','Jú Kamija'],
music:['Šindži Hosoe'],
camera:['Kenji Fujita'],
cut:['Kašiko Kimura'],
sound:['Džin Aketagawa'],
scenography:['Eidži Iwase']},
{title:'Moribito: Guardian of the Spirit',
titleCZ:'Seirei no moribito',
year:2007,
runtime:'10h 50min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy'],
director:['Kendži Kamijama','Kódai Kakimoto','Kóiči Hacumi','Hiroši Jamazaki','Tošijuki Kóno','Tošija Niidome'],
actors:['Mabuki Andó','Majumi Asano','Akihiko Išizumi','Keidži Fudžiwara','Masuo Amada','Juki Masuda','Wasabi Mizuta','Hiroši Naka','Fumihiko Tačiki','Hadžime Iidžima','Šindži Kawada','Ako Majama','Asami Šimoda','Naomi Šindó','Emi Šinohara','Hiroki Tóči','Saburó Kamei','Naomi Kusumi','Širó Saitó','Jóko Asagami','Reiko Suzuki','Sajuri','Masaja Macukaze','Masanori Takeda','Rintaró Niši','Óki Sugijama','Taketoši Kawano','Kacunosuke Hori','Misato Fukuen','Tecu Širatori','Takkó Išimori',"Ken'ičiró Macuda",'Daisuke Macubara','Kacumi Čó','Tomie Kataoka','Kenšó Ono','Kóhei Fukuhara',"Ken'iči Močizuki",'Noboru Jamaguči','Rjúiči Azuma','Rjúzaburó Ótomo','Keikó Sakai','Taiten Kusunoki','Takuma Takewaka','Rjó Hirohaši','Keiiči Nakagawa','Kóiči Makišima','Acuši Ono','Hirofumi Nodžima','Kódži Cudžitani','Júki Masuda','Riiči Nišimoto','Hideki Nakaniši','Takajuki Sasada','Naoto Adači','Tomomi Watanabe','Rjója Kobajaši','Mačiko Kawana','Kappei Jamaguči','Jonehiko Kitagawa','Marika Hajaši','Kacunori Kobajaši',"Ken'iči Morozumi",'Sósuke Komori','Akio Nakamura','Kódžiró Takahaši','Jošinori Mutó'],
basedOn:['Nahoko Uehaši'],
screenplay:['Jošiki Sakurai','Šótaró Suga','Šunpei Okada','Rjó Higaki'],
production:['Hisako Macumoto','Akio Macuda','Šindžiró Jokojama','Tomojasu Nišimura'],
music:['Kendži Kawai'],
camera:['Kódži Tanaka'],
cut:["Džun'iči Uemacu"],
sound:['Kazuhiro Wakabajaši'],
scenography:['Júsuke Takeda']},
{title:'Lost',
titleCZ:'Nezvěstní',
year:2004,
runtime:'88h 30min',
episodeRuntime:'40-105min',
countries:['USA'],
genres:['Adventure','Drama','Fantasy','Mystery','Sci-Fi','Thriller'],
director:['J.J. Abrams','Jack Bender','Stephen Williams','Kevin Hooks','Greg Yaitanes','Marita Grabiak','Bobby Roth','Paul A. Edwards','Frederick E.O. Toye','Tucker Gates','Karen Gaviola','Matt Earl Beesley','Eric Laneuville','Stephen Semel','Daniel Attias','Deran Sarafian','David Grossman','Michael Zinberg','Rod Holcomb','Mario Van Peebles','Alan Taylor','Roxann Dawson','Robert Mandel','Adam Davidson','Paris Barclay','Mark Goldman'],
actors:['Matthew Fox','Evangeline Lilly','Josh Holloway','Jorge Garcia',"Terry O'Quinn",'Naveen Andrews','Yunjin Kim','Daniel Dae Kim','Michael Emerson','Dominic Monaghan','Emilie de Ravin','Henry Ian Cusick','Ian Somerhalder','Maggie Grace','Harold Perrineau','Malcolm David Kelley','Jeff Fahey','Ken Leung','Jeremy Davies','Elizabeth Mitchell','L. Scott Caldwell','Michelle Rodriguez','Adewale Akinnuoye-Agbaje','Sam Anderson','Cynthia Watros','Nestor Carbonell','Tania Raymonde','M.C. Gainey','Michael Bowen','Rebecca Mader','John Terry','William Mapother','Mira Furlan','Alan Dale','François Chau','Rodrigo Santoro','Kiele Sanchez','Zuleikha Robinson','Clancy Brown','Julie Bowen','Kevin Durand','Doug Hutchison','Fionnula Flanagan','Alexandra Krosney','Christian Bowman','Dustin Watchman','Kimberley Joseph','Lance Reddick','Brian Goodman','Bill Duke','Robert Patrick','Saul Rubinek','Daniel Roebuck','Rachel Ticotin','Nathan Fillion','Tamara Taylor','Kim Dickens','Zack Ward','April Grace','Beth Broderick','Željko Ivanek','Greg Grunberg','Cheech Marin','Andrew Divoff','Kevin Dunn','Billy Dee Williams','Andrew Connolly','Marsha Thomason','Sonya Walger','Evan Handler','Billy Mayo','DJ Qualls','Katey Sagal','James Lesure','Bruce Davison','Samantha Mathis',"Adetokumboh M'Cormack",'Thekla Reuten','Shawn Doyle','Graham McTavish','Fisher Stevens','Andrea Roth','Gabrielle Fitzpatrick','Stephen Semel','Zoë Bell','Grant Bowler','Lanny Joon','Simon Rhee','Anson Mount','Bai Ling','Marguerite Moreau','Madeline Carroll','Theo Rossi','Susse Budde','Michelle Forbes','Marlene Forte','Alexis Rhee','Michael Cudlitz','Monica Barladeanu','Shaun Toub'],
screenplay:['J.J. Abrams','Damon Lindelof','Adam Horowitz','Edward Kitsis','Drew Goddard','Paul Zbyszewski','Jeff Pinkner','Craig Wright','Steven Maeda','Carlton Cuse','Brent Fletcher','Monica Owusu-Breen','Alison Schapker','David Fury','Melinda Hsu Taylor','Christina M. Kim','Elizabeth Sarnoff','Jordan Rosenberg','Graham Roland','Paul Dini','Lynne E. Litt','Brian K. Vaughan','Jennifer Johnson','Janet Tamaro'],
production:['Melinda Hsu Taylor','Sarah Caplan','Brian K. Vaughan','Jeph Loeb',"Ra'uf Glasgow",'Adam Horowitz'],
music:['Michael Giacchino'],
camera:['Larry Fong','Michael Bonvillain','John S. Bartley','Edward J. Pei','Stephen St. John','Cort Fey'],
cut:['Henk Van Eeghen','Jo Francis','Mary Jo Markey','Sarah Boyd','Martin Nicholson','Stephen Semel','Christopher Nelson','Robert Florio','Sue Blainey','David Eisenberg'],
sound:['Paula Fairfield','Ed Carr','Scott Weber','Sherry Klein','Robert Appere','Frank Morrone',"Terry O'Bright",'Thomas DeGorter','Sean Rush'],
scenography:['James William Newport','James H. Spencer','Stephen Storer','Jonathan A. Carlson','Mark Worthington','Carlos Barbosa','Carol Bayne Kelley','Julieann Getman','Rick Romer','Luke Freeborn','Scott Meehan'],
masks:['Jeff Dawn','Steve La Porte','Janis Clark'],
costumes:['Billy Ray McKenna','Kathryn Morrison','Roland Sanchez']},
{title:'Willo the Wisp',
titleCZ:'Bludička',
year:1981,
runtime:'2h 10min',
episodeRuntime:'5min',
countries:['UK'],
genres:['Animation','Family'],
director:['Nicholas Spargo'],
actors:['Kenneth Williams'],
screenplay:['Nicholas Spargo'],
music:['Tony Kinsey'],
cut:['Michael Crane'],
scenography:['Nicholas Spargo']},
{title:'Tour of Duty',
titleCZ:'Četa v akci',
year:1987,
runtime:'45h 26min',
episodeRuntime:'47min',
countries:['USA'],
genres:['Drama','War'],
director:['George Kaczender','Bradford May','Edwin Sherin','Helaine Head','Reynaldo Villalobos','James L. Conway','Charles Correll','Paul Lynch','James A. Contner','Tommy Lee Wallace','Robert Iscove','Bill Duke','Bill Norton','Aaron Lipstadt','Stephen L. Posey','Ronald L. Schwary','Randy Roberts','Stephen Caffrey','Steve Dubin'],
actors:['Terence Knox','Stephen Caffrey','Tony Becker','Miguel A. Núńez Jr.','Ramón Franco','Dan Gauthier','Jeff Hochendoner','Carl Weathers','Kim Delaney','Lee Majors','Patrick Kilpatrick','John Dye','Alan Scarfe','Kyle Chandler','Glenn Plummer','L. Scott Caldwell','Lar Park-Lincoln','Leilani Sarelle','Jace Alexander','Kelly Hu','Kristoffer Tabori','Bill Moseley','Keri Johnson','Malcolm-Jamal Warner','Rosalind Chao','Neil Flynn','Alexis Rhee','Penny Johnson Jerald','Melora Hardin','Betsy Brantley','Robert Knepper','Tia Carrere','Michael Madsen','Ted King','Kevin Conroy','Everett McGill','Aki Aleong','Don Keith Opper','Mark Ginther','François Chau','William Russ','Talia Balsam','Kayla Blake','Robert Fuller','Michele Lamar Richards','Randy Brooks','William Sadler','Trevor Goddard','Tim Thomerson','Len Lesser','Richard Allen','Stephen Quadros','Jon Cypher','Jay Arlen Jones','Antoni Stutz','Eddie Velez','Charles Frank','Michael Fairman','Kerry James','Scott Lawrence','Rob Moran','Rob Neukirch','Jon Gries','Bill Brochtrup','Joe Hart','Robert Ito','Ping Wu','Raymond Ma','Tim DeZarn','Sean Stanek','Josef Cannon','John D. LeMay','Les Lannom','Wally Taylor','Greg Travis','Dana Lee','Michael Champion','Rob Garrison','Matt Nolan','Christina Kokubo','James Harper','Jim Piddock',"Arsenio 'Sonny' Trinidad",'Jeff Corbett','Marc Buckland',"George O'Hanlon Jr.",'John DeMita','Sterling Macer Jr.','Peter Murnik','Cynthia Bain','John Toles-Bey','Todd Eric Andrews','Noel De Souza','Darren Foreman','Marilyn Tokuda','Penny Peyser','Bradley Thomas','Jihmi Kennedy','William Allen Young','James Sutorius'],
screenplay:['Rick Husky','Carol Mendelsohn','Bill Norton','James Kearns','Brian Herskowitz','David Wyles','Steve Duncan','L. Travis Clark','Robert Bielak','David Ehrman','Steve Bello','Cynthia Darnell'],
production:['Ronald L. Schwary','James A. Westman'],
music:['Joseph Conlan'],
camera:['Peter Smokler','Alan Caso','Stephen L. Posey'],
cut:['Michael Ripps','John Duffy','Kim Secrist','Robert L. Sinise','Douglas Ibold','Ellen Ring Jacobson','Thomas Petersen','Herbert H. Dow','Stephen Michael'],
sound:['Bud Maffett','Thomas J. Huth','Anthony Constantini','Susan Moore-Chong','Sam Black','Tim Philben'],
scenography:['Mayling Cheng','Rick Caprarelli','Gary Fettis','Robin Peyton'],
masks:['James R. Scribner','Alan Fama']},
{title:'Staged',
titleCZ:'Inscenace',
year:2020,
runtime:'5h 45min',
episodeRuntime:'15-22min',
countries:['UK'],
genres:['Comedy'],
director:['Simon Evans'],
actors:['David Tennant','Michael Sheen','Georgia Tennant','Anna Lundberg','Nina Sosanya','Simon Evans','Phin Glynn','Whoopi Goldberg','Ben Schwartz','Michael Palin','Jim Parsons','Simon Pegg','Samuel L. Jackson','Adrian Lester','Cate Blanchett','Nick Frost','Josh Gad','Romesh Ranganathan','Christoph Waltz','Judi Dench','Ewan McGregor','Phoebe Waller-Bridge','Hugh Bonneville','Ryan Gage','Ken Jeong'],
screenplay:['Simon Evans'],
production:['Phin Glynn','Georgia Tennant'],
music:['Alex Baranowski'],
cut:['Dan Gage']},
{title:'Mr. Sunshine',
titleCZ:'Miseuteo syeonsyain',
year:2018,
runtime:'30h 11min',
episodeRuntime:'68-97min',
countries:['South Korea'],
genres:['History','Romance','Drama','War'],
director:['Eung-bok Lee'],
actors:['Byung-hun Lee','Tae-ri Kim','Yeon-seok Yoo','Min-jeong Kim','Yo-han Byeon','Woo-jin Jo','David Lee McInnis','Moo-seong Choi','Kap-soo Kim','Ee-seong Kim','Jeong-eun Heo','Hye-eun Kim','Seung-joon Lee','Shin-il Kang','Byeong-cheol Kim','Jin-ho Choi','Si-eun Kim','Shi-ah Lee','Seung-hyeon Ji','Jong-won Choi','Goo Jin','Ji-won Kim','Kyeong-ho Yoon','Kwang-je Choi','Jeong-eun Lee','Ah-yeon Oh','Joo-bin Lee','Jung-nam Bae','Ho-jae Lee','Jeong-geun Shin','Hak-joo Lee','In-woo Kim','Sang-hee Lee','Hee-tae Jung','Kang-il Kim','Seon-kyu Jin','Dong-yoon Jang','Hakurjú','Jeong-min Park','Min-jae Kim','Yoo-song Choi','Eung-soo Kim','Se-mi Lim','Woo-rim Ko','Jin-seo Jeon','Kang-hoon Kim','Sun-hwa Kim','Ji-on Yoon','Jung-hyun Lee','Seung-gil Jung','Young-woo Choi','Soon-won Lee','Dong-hyun Kim','Ah-In Park','Jin-woo Song','Joong-hee Kim','Dong-yong Lee','Nam-hee Kim','Minyeong Choi'],
screenplay:['Eun-sook Kim'],
production:['Yun Ha Rim'],
music:['Hye-Seung Nam']},
{title:'The Addams Family',
titleCZ:'Rodina Addamsova',
year:1964,
runtime:'26h 40min',
episodeRuntime:'25min',
countries:['USA'],
genres:['Comedy','Family','Horror'],
director:['Jerry Hopper','Sidney Lanfield','Sidney Salkow','Jean Yarbrough','Arthur Lubin','Arthur Hiller','Sidney Miller','Nat Perrin'],
actors:['Carolyn Jones','John Astin','Jackie Coogan','Ted Cassidy','Marie Blake','Lisa Loring','Ken Weatherwax','Vito Scotti','Don Rickles','Rolfe Sedan','Felix Silla','Anthony Magro','Parley Baer','Natalie Masters','George Petrie','Hugh Sanders','Bob LeMond','Tim Herbert','Roger Arroyo','Robert Nunn','Richard Reeves','George Barrows','Allyn Joslyn','Jimmy Cross','Margaret Hamilton','Leonard Bremen','Bill Baldwin','Loyal T. Lucas','Barry Kelley','Jeff Donnell','Sig Ruman','Meg Wyllie','Ray Walker','Merry Anders','Ben Wright','Richard Deacon','Jesse White','Byron Foulger','Frank Wilcox','James Flavin','Roy Roberts','Hal Baylor','Virginia Gregg','Stanley Adams','Norman Leavitt','Hal Smith','Charles Wagenheim','Roland Winters','Skip Homeier','Gail Bonney','Diane Jergens','Jonathan Hole','Peter Leeds','Cynthia Pepper','Elisabeth Fraser','Nestor Paiva','Marty Ingels','Anthony Caruso','Elvia Allman','Alan Reed','Thomas Browne Henry','George Cisar','Jack Collins','Olan Soule','Milton Frome','Carlos Rivas',"Tom D'Andrea",'Lela Bliss','John Hart','William Keene','Fred Clark','John Lawrence','Pamela McMyler','Irene Tedrow','Nydia Westman','Jan Arvan','Maxine Semon','Carol Byron','Del Moore','Robert Nichols','Ken Mayer','Bob Jellison','Lee Bergere','Tommy Farrell','Lauren Gilbert','John J. Fox','Bella Bruck','Frederic Downs','Tom Lowell','Laurie Mitchell','Dorothy Neumann','Eddie Quillan','Eddie Marr','George N. Neise','Ellen Corby','Pearl Shear','Ceil Cabot','Jack LaLanne','Peggy Mondo','Jill Andre'],
screenplay:['George Haight','Jay Dratler','Elroy Schwartz','Ben Gershman','Leo Rifkin','Gene Thompson','Ed James','Hannibal Coons','Phil Leslie','Seaman Jacobs','Arthur Weingarten'],
production:['Nat Perrin'],
music:['Vic Mizzy'],
camera:['Archie R. Dalzell'],
cut:['Douglas Hines','James Ballas','Joseph Harrison','Gerald Shepard','Jim Faris'],
sound:['Earl E. Spicer'],
scenography:['Edward L. Ilou','Ruby R. Levitt'],
masks:['Norman Pringle','Myrl Stoltz']},
{title:'Taboo',
titleCZ:'Taboo',
year:2017,
runtime:'8h 55min',
episodeRuntime:'55-60min',
countries:['UK'],
genres:['Drama','Thriller','Mystery'],
director:['Anders Engström','Kristoffer Nyholm'],
actors:['Tom Hardy','David Hayman','Jonathan Pryce','Oona Chaplin','Richard Dixon','Leo Bill','Edward Hogg','Ruby-May Martinwood','Jessie Buckley','Stephen Graham','Franka Potente','James Greaves','Michael Kelly','Louis Ashbourne Serkis','Jefferson Hall','Jason Watkins','Tallulah Haddon','Tom Hollander','Nicholas Woodeson','Mark Gatiss','Lucian Msamati','Christopher Fairbank','Marina Hands','Brian Nickels','Daniel Tuite','James Oliver Wheatley','Roger Ashton-Griffiths','Richard Katz','Philip Philmar','Richard Syms','Richard Teverson','Tim Plester','Frederick Schmidt','Ben Moor','Jamie de Courcey','Tom Durant Pritchard','Michael Shaeffer','David Nellist','Nicholas Blane','Albert Welling','Matthew Marsh','Phil Hodges','Martyn Mayger','Gabrielle Downey','Andy Gillies','Fiona Skinner','Robert Morgan','Alex Ferns','Edward Fox','Andrew Greenough','Helen Monks','Clare Foster','Jo Cameron Brown','Sophie Karl','Oliver Powell','Lewin Lloyd','Neil Ashton','Pearl Appleby','Violet Verigo','Jordan Long','Barney White'],
screenplay:['Chips Hardy','Steven Knight','Emily Ballou','Ben Hervey'],
production:['Tim Bricknell'],
music:['Max Richter'],
camera:['Mark Patten'],
cut:['Matt Platts-Mills','Guy Bensley','Katie Weiland'],
scenography:['Sonja Klaus'],
costumes:['Joanna Eatwell']},
{title:'Silo',
titleCZ:'Silo',
year:2023,
runtime:'15h 40min',
episodeRuntime:'43-62min',
countries:['USA'],
genres:['Sci-Fi','Drama'],
director:['David Semel','Morten Tyldum','Bert','Bertie','Adam Bernstein'],
actors:['Rebecca Ferguson','Iain Glen','Ferdinand Kingsley','Tim Robbins','Shane McRae','Rick Gomez','Henry Garrett','Angela Yeoh','Harriet Walter','David Oyelowo','Common','Rashida Jones','Christian Ochoa Lavernia','Will Merrick','Will Patton','Geraldine James','Sophie Thompson','Billy Postlethwaite','Chipo Chung','Remmie Milner','Peter Gadiot','Nick Davison','Avi Nash','Roderick Hill','Andy Linden','Rita McDonald Damper','Amelie Child Villiers','Chinaza Uche','Sonita Henry','Tanya Moodie','Akie Kotabe','Sienna Guillory','Simon Armstrong','Paul Herzberg','Matt Gomez Hidaka','Oscar Coleman','Caitlin Zoz','Claire Perkins'],
basedOn:['Hugh Howey'],
screenplay:['Graham Yost','Cassie Pappas','Ingrid Escajeda','Jessica Blaire','Remi Aubuchon','Aric Avelino','Jeffery Wang','Lekethia Dalcoe','Fred Golan'],
production:['Aric Avelino','Jessica Blaire','Joanna Thapa','Matthew Bird'],
music:['Atli Örvarsson'],
camera:['Mark Patten','David Luther','Laurie Rose'],
cut:['Hazel Baillie','Jean Crupper','Christian Sandino-Taylor'],
sound:['Dustin Harris','Kirk Lynds'],
scenography:['Gavin Bocquet','Olly Williams','Simon Elsley','Daniel Swingler','Phil Harvey','Amanda Bernstein'],
masks:['Marie Deehan'],
costumes:['Charlotte Morris']},
{title:'The Morning Show',
titleCZ:'The Morning Show',
year:2019,
runtime:'27h 40min',
episodeRuntime:'46-66min',
countries:['USA'],
genres:['Drama'],
director:['Mimi Leder','Lynn Shelton','David Frankel','Tucker Gates','Roxann Dawson','Michelle MacLaren','Kevin Bray','Lesli Linka Glatter','Jessica Yu','Rachel Morrison','Victoria Mahoney','Miguel Arteta','Thomas Carter','Stacie Passon','Jennifer Getzinger','Millicent Shelton'],
actors:['Jennifer Aniston','Reese Witherspoon','Steve Carell','Billy Crudup','Nestor Carbonell','Gugu Mbatha-Raw','Mark Duplass','Bel Powley','Karen Pittman','Victoria Tate','Shari Belafonte','Joe Marinelli','Eli Bildner','Hannah Leder','Desean Terry','Jack Davenport','Janina Gavankar','Tom Irwin','Mindy Kaling','Marcia Gay Harden','David Morse','Ian Gomez','Augustus Prew','Kate Vernon','Philip Anthony-Rodriguez','Markus Flanagan','Mark Harelik','Robert Cicchini','Carolyn Zeller','Michelle Kim','Julian Morris','Cory Tucker','Cheyenne Jackson','Brett Butler','Kelly Clarkson','Joe Tippett','Natalia Warner',"Ahna O'Reilly",'Roman Mitichyan','Harley Graham','Kelly Sullivan','Jack Armstrong','Shelley Robertson','John Patrick Jordan','Martin Short','Adina Porter','Fred Melamed','Hannah Marshall','Andrea Bendewald','Elizabeth Greer','Ellen Gerstein','Hank Cheyne','Embeth Davidtz','Andrew Leeds','John Marshall Jones','Allan Graf','Deborah Geffner','Jacqueline Mazarella',"Mike O'Malley",'Alain Uy','Paul Guilfoyle','Richard Whiten','Ethan Cohn','Jeff Pomerantz','Dana Davis','Rachael Markarian','Cassie Dzienny','Romy Rosemont','John Paino','Oona Roche','Maria Šarapovová','Hayes MacArthur','Lisa London','Carole Kravetz Aykanian','Amber Friendly','Katherine Ko','Michelle Meredith','Laura Dickinson','Jordan Seigel','Nanrisa Lee','Kelli Dawn Hancock','Andre Boyer','Ken Holmes','Stefanie Stevens','Holland Taylor','Katie Aselton','Kathy Najimy','James Urbaniak','Tara Karsian','David Bowe','Judy Kain','Jay Jackson','Greta Lee','Hasan Minhaj',"Ruairi O'Connor",'Valeria Golino','Will Arnett','Patrick Fabian','Ali Astin','Erika Ringor'],
screenplay:['Kerry Ehrin','Torrey Speer','Erica Lipez','Kristen Layden','J.C. Lee','Jeff Augustin','Adam Milch','Brian Chamberlayne','Ali Vingiano','Scott Troy','Stacy Osei-Kuffour','Justin Matthews','Charlotte Stoudt','Michelle Denise Jackson','Kimi Lee','Joshua Allen','Zander Lehmann','Micah Schraft','Bill Kennedy','Selina Fillinger','Anya Leta'],
production:['Jamie Vega Wheeler','Cherylanne Martin','Stacy Osei-Kuffour','Kristen Layden','Torrey Speer','Jonathan Talbert','Michelle Denise Jackson','Bill Kennedy','Mallory Schwartz','Ronald Cosmo Vecchiarelli','Anne Berger','John Blair','Emily Ferenbach','Kendall L. Nichols','Brian Stelter'],
music:['Carter Burwell'],
camera:['Michael Grady','David Lanzenberg','John Brawley','Jeffrey Waldron','John Grillo','Tami Reiker'],
cut:['Vikash Patel','Carole Kravetz Aykanian','Ron Rosen','Peter B. Ellis','Elliott Eisman','Sidney Wolinsky','Henk Van Eeghen','Bjørn T. Myrholt','J. Kathleen Gibson','Plummy Tucker','Andrew Gust'],
sound:['Elmo Ponsdomenech','Paul Lucien Col','Mark Relyea','Jason Gaya'],
scenography:['John Paino','Shauna Aronson','Nelson Coates','Wes Hottman','Amy Wells','Oana Bogdan Miller','Clarence Major','Elizabeth Newton','Thomas P. Wilkins','Lauree Martell'],
masks:['Cindy J. Williams','Steven R. Soussanna','Jennifer Petrovich'],
costumes:['Sophie De Rakoff','Clare Hallworth','Nina Hallworth','Elizabeth Lancaster']},
{title:'Batman: The Animated Series',
titleCZ:'Batman',
year:1992,
runtime:'31h 10min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Animation','Action','Adventure','Crime','Drama','Mystery','Thriller','Sci-Fi'],
director:['Boyd Kirkland','Frank Paur','Dick Sebast','Dan Riba','Eric Radomski','Bruce Timm','Kent Butterworth','Kevin Altieri','Toshihiko Masuda'],
actors:['Kevin Conroy','Efrem Zimbalist Jr.','Loren Lester','Robert Costanzo','Mark Hamill','Richard Moll','Lloyd Bochner','John Vernon','Adrienne Barbeau','Brock Peters','Paul Williams','Ingrid Oliu','Aron Kincaid','George Dzundza','Melissa Gilbert','Frank Welker','Jeff Bennett','Edward Asner','David Warner','Diana Muldaur','Marilu Henner','Helen Slater','William Sanderson','Ron Perlman','Roddy McDowall','Roger Rose','Clive Revill','John Glover','Dick Miller','Henry Silva',"'Weird Al' Yankovic",'Brad Garrett','Jason Marsden','Gregg Berger','Elizabeth Montgomery','Megan Mullally','Hector Elizondo','Joe Piscopo','Earl Boen','Robert Picardo','Heather Locklear','Andrea Martin','Peter Scolari','Leslie Easterbrook','Kimmy Robertson','Richard Dysart','Bill McKinney','Scott Valentine','Khrystyne Haje','Nichelle Nichols','Brian Stokes Mitchell','Micky Dolenz','Joseph Campanella','Herb Edelman','Peter Jason','Jay Thomas','Gary Frank','Mark L. Taylor','Tasia Valenza','Julie Brown','Steve Susskind','Robert DoQui','Joseph Maher','Alison La Placa','Brian George','Michael Ansara','Peter Mark Richman','Virginia Capers','Barry Dennen','Alan Oppenheimer','George Murdock','Steve Franken','Robert Ito','Richard Erdman','Victoria Carroll','Carmen Zapata','Mary McDonald-Lewis','Walter Olkewicz','William Bryant','Richard Jeni','Ian Patrick Williams','Jeff Doucette','Manu Tupou','Alan Rachins','Robert Ridgely','Dick Gautier','Marcelo Tubert','Denny Dillon','Robert Clotworthy','Franklin Cover','Grant Shaud','Lynne Marie Stewart','Vernee Watson','Gary Kroeger','Michael Bell','Danny Goldman','Paul Nakauchi','Joey Simmrin','David L. Lander','Whit Hertford'],
basedOn:['Bob Kane','Bill Finger','Jerry Robinson','Robert Kanigher','Len Wein','David Vern Reed','Elliot S. Maggin','Walter Simonson',"Denny O'Neil"],
screenplay:['Garfield Reeves-Stevens','Judith Reeves-Stevens','Alan Burnett','Joe R. Lansdale','Eddie Gorodetsky','David Wise','Marv Wolfman','Henry Gilroy','Chris Hubbell','Martin Pasko','Michael Reaves','Marty Isenberg','Sean Catherine Derek','Len Wein','Steve Hayes','Tom Ruegger','Buzz Dixon','Beth Bornstein','Richard Mueller','Diane Duane','Peter Morwood','Elliot S. Maggin','Gerry Conway','Brynne Stephens',"Denny O'Neil",'Mark Saraceni','Steve Perry','Robert N. Skir','Laren Bright','Samuel Warren Joseph'],
production:['Eric Radomski','Bruce Timm','Alan Burnett','Paul Dini'],
music:['Nerida Tyson-Chew','James Stemple','Harvey Cohen','Carl Johnson','Kristopher Carter','Lolita Ritmanis','Michael McCuistion','Brian Langsbard','Shirley Walker','John Tatgenhorst','Steven Chesne','Lisa Bloom','Jeff Atmajian'],
cut:['Joe Gall','Theresa Gilroy-Nielsen','Al Breitenbach','Kelly Ann Foley'],
sound:['Tom Maydeck','Chris McIntosh']},
{title:'Fate/Zero',
titleCZ:'Fate/Zero',
year:2011,
runtime:'10h 50min',
episodeRuntime:'25-50min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy'],
director:['Ei Aoki','Kei Cunemacu','Tomonori Sudó','Takahiro Miura','Takuja Nonaka','Takaši Suhara'],
actors:['Ajako Kawasumi','Tomokazu Seki','Džódži Nakata','Sajaka Óhara','Rikija Kojama','Akio Ócuka','Daisuke Namikawa','Akeno Watanabe','Činacu Akasaki','Tamio Óki','Masane Cukajama','Hikaru Midorikawa','Asami Seto','Akira Išida','Ikuo Nišikawa','Mai Kadowaki','Kana Ueda','Kódži Takeda','Šó Hajami','Takumi Jamazaki','Megumi Tojoguči','Masaši Hirose','Momoko Óhara','Noriko Šitaja','Juzuru Fudžimoto','Naomi Kusumi','Júsuke Kuwahata','Satoši Curuoka','Nobunaga Šimazaki','Jošihito Sasaki','Šó Okumura','Hiromi Igaraši','Rie Nakagawa','Júja Murakami','Acuko Mine','Ajumi Cunemacu','Manabu Sakamaki','Tomohisa Hašizume',"Šin'ja Fukumacu",'Gó Inoue','Džunko Noda','Kacumi Toriumi','Ajahi Takagaki','Rjó Iwasaki','Miju Irino','Iššin Čiba','Rjúiči Kidžima','Taira Kikumoto','Eimi Okada','Itaru Jamamoto','Seiko Jošida','Kazunori Nomata','Šinobu Macumoto','Takuo Kawamura','Hiró Sasaki','Naoja Nosaka','Rjótaró Okiaju','Tarusuke Šingaki','Hasumi Itó','Hidemicu Šimizu','Saki Hošino','Rei Macuzaki','Jukako Jonejama','Aiko Kusumi','Akina Abe'],
screenplay:['Takumi Mijadžima','Kazuharu Sató','Akira Hijama'],
production:['Yoshinao Doi'],
music:['Juki Kadžiura'],
camera:['Júiči Terao'],
cut:['Manabu Kamino'],
sound:['Jošikazu Iwanami'],
scenography:['Kódži Etó']},
{title:"It's Okay to Not Be Okay",
titleCZ:'Dotkni se mých ran',
year:2020,
runtime:'20h 21min',
episodeRuntime:'70-85min',
countries:['South Korea'],
genres:['Comedy','Drama','Romance'],
director:['Shin-woo Park'],
actors:['Soo-hyeon Kim','Ye-ji Seo','Jeong-se Oh','Gyu-young Park','Joo-hun Kim','Hae-sun Bae','Jae-gwang Jung','Seung-gil Jung','Woo-kyum Kim','Dong-ho Kwon','Gyu-ri Jang'],
screenplay:['Yong Jo'],
music:['Hye-Seung Nam']},
{title:'Rascal Does Not Dream of Bunny Girl Senpai',
titleCZ:'Seišun buta jaró wa Bunny Girl-senpai no jume o minai',
year:2018,
runtime:'5h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Fantasy','Comedy','Romance','Drama'],
director:['Sóiči Masui','Daisuke Cukuši','Kazuja Iwata','Masahiro Šinohara','Kendži Takahaši','Hidetoši Takahaši','Rjúta Ono'],
actors:['Kaito Išikawa','Asami Seto','Jurika Kubo','Acumi Tanezaki','Nao Tójama','Inori Minase','Maaja Učida','Fumiko Učimura','Mei Šibata','Haruka Šimizu','Koko Hajaši','Erisa Kuon','Miho Okasaki','Hisako Tódžó','Takahiro Sumi','Masaaki Mizunaka','Satoši Taki','Kento Širaiši','Himika Akaneja','Júma Učida','Nacuki Aikawa','Jasunao Sakai','Takaaki Učino','Akari Kagejama','Šótaró Uzawa','Kazuja Sadži','Tomojuki Šimura','Mami Kameoka','Aja Endó','Akira Kuwabara','Wakana Maruoka','Airi Ócu','Satomi Sató','Aina Takeda','Fumitake Išiguro','Šiori Macui','Hajato Kašiwazaki','Sajuki Iizaka','Rin Namino'],
basedOn:['Hadžime Kamošida'],
screenplay:['Masahiro Jokotani'],
camera:['Jošihiro Sekija'],
cut:['Akinori Mišima'],
sound:['Jošikazu Iwanami'],
scenography:['Jukihiro Šibutani']},
{title:'Adventures of the Gummi Bears',
titleCZ:'Gumídci',
year:1985,
runtime:'24h 1min',
episodeRuntime:'11-22min',
countries:['USA'],
genres:['Animation','Fantasy','Family'],
director:['David Block','Art Vitello','Alan Zaslove','John Ahern','Bob Zamboni','Robert Alvarez','Toshihiko Masuda','Mitch Rochon'],
actors:['June Foray','Jim Cummings','Walker Edmiston','Corey Burton','Rob Paulsen','Tress MacNeille','David Faustino','Jason Marsden','Chuck McCann','Dana Hill','Barry Dennen','Alan Oppenheimer','Roger C. Carmel','Hal Smith','Gino Conforti','Keone Young','Aeryk Egan','Hamilton Camp','Lorenzo Music','Kath Soucie','Pat Musick','Linda Gary','Christian Jacobs','Katie Leigh','Noelle North','Will Ryan','Lennie Weinrib','Jymn Magon','Howard Morris','Michael Rye','Michael Rye','Frank Welker','Peter Cullen','Brian Cummings','Townsend Coleman','Les Tremayne','Ed Gilbert','Billy Barty','Russi Taylor','Allan Melvin','R.J. Williams'],
screenplay:['Michael Maurer','Kevin Hopps','Alan Burnett','Duane Capizzi','Bruce Talkington','Bryce Malek','Len Uhley','Bruce Reid Schaefer','Diane Dixon','Kayte Kuch','Mark Seidenberg','Sheryl Scarborough','Richard Hoag','Bob Langhans','Michael Lyons','Kimberley Wells','Rose G. Wong','Doug Hutchinson','Steve Hulett','Jymn Magon','Randal Case','Mark Zaslove','James David Pasternak','Richard Mueller','Tad Stones','Terrie Collins','Rich Fogel','Marion Wells'],
production:['David Block','Mark Seidenberg','Art Vitello','Tad Stones','Alan Zaslove','Rich Fogel'],
music:['Thomas Chase','Steve Rucker'],
sound:['Allen L. Stone']},
{title:'Who Is America?',
titleCZ:'Who Is America?',
year:2018,
runtime:'3h 11min',
episodeRuntime:'24-29min',
countries:['USA'],
genres:['Comedy'],
director:['Sacha Baron Cohen','Payman Benz','Daniel Gray Longino','Dan Mazer','Nathan Fielder','Todd Schulman'],
actors:['Sacha Baron Cohen','Donald Trump','John F. Kennedy','Ronald Reagan','Hillary Clinton','Melania Trump','Bernie Sanders','Dick Cheney','Gloria Sandoval','O.J. Simpson','Emanuela Postacchini','Francis Collins','Todd Schulman','Philip Van Cleave','Corinne Olympios','Jason Spencer','Ted Koppel'],
screenplay:['Sacha Baron Cohen','Anthony Hines','Dan Mazer','Eric Notarnicola','Kurt Metzger','Scotty Landes','Dan Swimer','Lee Kern','Aaron Geary','Brian Reich','Jensen Karp'],
production:['Andrew Newman','Daniel Gray Longino','Dan Swimer','Melanie J. Elin'],
music:['Erran Baron Cohen'],
camera:['Luke Geissbühler'],
cut:['Eric Notarnicola','Roger Nygard','Jeremy Cohen','Vera Drew'],
masks:['Alexis Arenas','Tony Gardner']},
{title:'Akame ga Kill!',
titleCZ:'Akame ga kill!',
year:2014,
runtime:'9h 12min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy','Horror','Psychology'],
director:['Tomoki Kobajaši','Masafumi Tamura','Acuši Ikarija','Hirojuki Cučija','Mamiko Sekija','Takahiro Kawakoši','Sumito Sasaki','Tomoko Hiramuki','Jošiko Mikami','Akihisa Šibata','Daisuke Eguči'],
actors:['Sóma Saitó','Sora Amamija','Jú Asakawa','Mamiko Noto','Jošicugu Macuoka','Hitomi Nabatame','Kana Hanazawa','Hozumi Góda','Eidži Takemoto','Masami Iwasaki','Satoši Hino','Džódži Nakata','Ajaka Imamura','Jošimasa Hosoja','Anri Kacu','Satomi Akesaka','Jó Taiči','Kento Fudžinuma',"Šin'ja Hamazoe",'Kacujuki Koniši','Kódži Išii','Kendži Nomura',"Šin'ja Takahaši",'Jukari Tamura','Kaori Nazuka','Risa Mizuno','Rintaró Niši','Šintaró Asanuma','Mikako Komacu','Kanehira Jamamoto','Satoši Curuoka','Džundži Madžima','Rjóhei Kimura','Ajaka Óhaši','Eriko Macui','Jódži Ueda','Acuši Kósaka','Takehiro Hasu','Juri Jamaoka','Aina Suzuki','Daiki Hamano','Noriko Šibasaki','Konomi Tada','Eidži Takeuči','Cujoši Kojama','Masaši Nogawa','Kanami Sató','Ken Narita','Júka Aisaka','Riki Kagami','Takahiro Fudžiwara','Daiči Endó','Čado Horii','Haruo Jamagiši','Jurika Aizawa','Júki Išikari','Kódži Takahaši','Tecuo Gotó','Rjóta Akazawa','Keiiči Kuwabara','Sakiko Kawai','Ajaka Fukujama','Kóhei Sugesawa'],
basedOn:['Tecuja Taširo','Takahiro'],
screenplay:['Tóko Mačida','Makoto Uezu','Kódžiró Nakamura'],
production:['Kazuhiro Asou','Masaki Fudžita','Masanori Mijake'],
music:['Taku Iwasaki'],
camera:['Keisuke Nakamura'],
cut:['Masahiro Gotó'],
sound:['Hozumi Góda'],
scenography:['Jošito Takamine']},
{title:"Tess of the D'Urbervilles",
titleCZ:"Tess z rodu D'Urbervillů",
year:2008,
runtime:null,
episodeRuntime:'4h60min',
countries:['UK'],
genres:['Drama','Romance'],
director:['David Blair'],
actors:['Gemma Arterton','Eddie Redmayne','Ruth Jones','Hans Matheson','Ian Puleston-Davies','Christopher Fairbank','Jo Woodcock','Steven Robertson','Hugh Skinner','Jodie Whittaker','Anna Massey','Donald Sumpter','Kenneth Cranham','Emily Beecham','Christine Bottomley','Jeany Spark','Merelina Kendall','Trevor Cooper','Sally Bankes','Rebekah Staton','Emma Stansfield','Jessica Turner','Laura Elphinstone','Joel Rowbottom'],
basedOn:['Thomas Hardy'],
screenplay:['David Nicholls'],
music:['Rob Lane'],
camera:['Wojciech Szepel'],
cut:['Pia Di Ciaula'],
scenography:['Candida Otton'],
masks:['Vickie Lang'],
costumes:['James Keast']},
{title:'Alchemy of Souls',
titleCZ:'Alchymie duše',
year:2022,
runtime:'37h 5min',
episodeRuntime:'69-86min',
countries:['South Korea'],
genres:['Action','History','Fantasy','Romance'],
director:['Joon-hwa Park'],
actors:['Jae-wook Lee','So-min Jeong','Min-Hyun Hwang','Seung-ho Shin','Joon-sang Yoo','Na-ra Oh','Yoon-Jung Go','Sang-hoon Park','In-soo Yoo','Jae-yoon Jo','Eun-hye Park','Do-kyeong Lee','Ha-yul Lee','Gwang-il Choi','Dong-yong Lee'],
screenplay:['Mi-ran Hong'],
music:['Hye-Seung Nam']},
{title:'Bunny Drop',
titleCZ:'Usagi Drop',
year:2011,
runtime:'4h 13min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Drama','Comedy'],
director:['Kanta Kamei','Susumu Micunaka','Rokó Ogiwara'],
actors:["Aju Macu'ura",'Maaja Sakamoto','Daisuke Hirakawa','Tošiko Sawada','Maaja Učida','Sajaka Óhara','Kana Ueda','Kódži Takeda','Takahiro Mizušima','Šindži Kawada','Tomojuki Šimura','Kóiči Sakaguči','Júko Gibu','Maju Iino','Takkó Išimori','Masaru Ikeda','Akiko Kawase','Sajuri Sadaoka','Jumi Učijama','Bin Sasaki','Tóru Sakurai','Acuko Mine','Hiroši Arikawa','Gó Inoue','Hajato Nakata','Šiori Mikami','Hiroši Cučida','Rio Sasaki','Taiši Murata','Maju Kitaki','Mami Fudžita','Toa Jukinari','Fúka Sudó','Júdžiró Kakuda','Hiró Sasaki','Kajó Nakadžima','Šun Takagi','Mari Hino','Jui Kano','Rjóko Hikida','Nanako Sudó','Mari Hagai','Aki Nakadžima','Hidetoši Akucu','Tomomi Watanabe','Mičie Ikeda','Tomohiro Waki','Riho Fušida','Ken Širojama','Noa Sakai','Jonehiko Kitagawa','Masakazu Itó','Waku Sakaguči','Wataru Sekine','Eiko Kanazawa','Misaki Marujama'],
basedOn:['Jumi Unita'],
screenplay:['Taku Kišimoto'],
production:['Noriko Ozaki','Daisuke Konaka'],
music:['Suguru Matsutani'],
camera:['Kódži Tanaka'],
cut:["Džun'iči Uemacu"],
sound:['Kazuhiro Wakabajaši'],
scenography:['Ičiró Tacuta']},
{title:'Around the World with Willy Fog',
titleCZ:'Willy Fog na cestě kolem světa',
year:1981,
runtime:null,
episodeRuntime:'26x24min',
countries:['Spain','Japan'],
genres:['Animation','Family','Adventure'],
director:['Luis Ballester Bustos','Fumio Kurokawa','Jukio Okazaki'],
actors:['Ičiró Nagai','Šigeru Čiba',"Ken'iči Ogata",'Teššó Genda','Patrick Préjean','Jacques Marin','Luis Marín','Claudio Rodríguez','Masako Nozawa','Juriko Jamamoto','Sumi Šimamoto','Gloria Cámara','Naoki Tacuta','Bandžó Ginga','Kózó Šioja','Miki Takahaši','Félix Acaso','José Moratalla','Rafael de Penagos','Kei Tomijama','Manuel Peiró','Tomomiči Nišimura','Šin Aomori','Masaharu Sató','Alfonso Santigosa'],
basedOn:['Jules Verne'],
production:['Claudio Biern Boyd','José Manuel Iglesias','Takadži Macudo'],
music:['Maurizio De Angelis','Guido De Angelis','Šunsuke Kikuči'],
camera:['Tošiaki Morita']},
{title:'The Expanse',
titleCZ:'Expanze',
year:2015,
runtime:'46h 56min',
episodeRuntime:'40-63min',
countries:['USA'],
genres:['Sci-Fi','Drama','Mystery'],
director:['Breck Eisner','Jeff Woolnough','Terry McDonough','Robert Lieberman','Kenneth Fink','David Grossman','Thor Freudenthal','Bill Johnson','Mikael Salomon','Jennifer Phang','Simon Cellan Jones','David Petrarca','Sarah Harding','Thomas Jane','Nick Gomez','Marisol Adler','Anya Adams'],
actors:['Steven Strait','Dominique Tipper','Wes Chatham','Shohreh Aghdashloo','Cas Anvar','Frankie Adams','Cara Gee','Thomas Jane','Shawn Doyle','Nadine Nicole','Florence Faivre','Keon Alexander','Jasai Chase-Owens','Chad L. Coleman','Paulo Costanzo','Anna Hopkins','Andrew Rotilio','Nick E. Tarabay','David Strathairn','Terry Chen','François Chau','Vanessa Smythe','Elizabeth Mitchell','Lyndie Greenwood','Burn Gorman','José Zúñiga','Rosa Gilmore','Jess Salgueiro','George Tchortov','Jonathan Whittaker','Ted Atherton','Martin Roach','Athena Karkanis','Kristen Hager','Brett Ryan','Rossif Sutherland','Jonathan Banks','Jay Hernandez','Kevin Hanchard','Jane Moffat','Philip Akin','Russell Yuen','Kyle Gatehouse','Elias Toufexis','James Binkley','Sara Mitich','Craig Henry','Jared Harris','Raven Stewart','Hugh Dillon','Kyle Mitchell','Conrad Pla','Lola Glaudini','Brian George','Julian Richings','Christian Bako','Ian Agard','Kenneth Welsh','Greg Bryk','Boyd Banks','Tattiawna Jones','Duane Murray','Daniel Kash','Frances Fisher','Phillip MacKenzie','Elisa Moolecherry','Paul Popowich','Bruno Verdoni','Tommy Chang','Markus Parilo','Anthony Gerbrandt','Billy MacLellan','John MacDonald','Alex Karzis','Jean Yoon','Ted Ludzik','Patrick Stevenson','Peter Spence','Jeff Clarke','Alden Adair','Sarah Allen','Mpho Koaho','Dewshane Williams','Roberto Campanella','Byron Mann','Colin MacPherson','Etan Muskat','Mark Quigley','Peter Williams','Steven Yaffee','Clé Bennett','Sam Huntington','Ted Whittall','Grace Lynn Kung','Peter Outerbridge','Rachael Crawford','Neven Pajkic','Allison Hossack','Milton Barnes','Gage Munroe'],
basedOn:['Daniel Abraham','Ty Franck'],
screenplay:['Dan Nowak','Daniel Abraham','Ty Franck','Naren Shankar','Mark Fergus','Hawk Ostby','Robin Veith','Georgia Lee','Hallie Lambert','Jason Ning','Alan DiFiore','Laura Marks'],
production:['Ben Cook','Lewin Webb','Steven Strait','Lynn Raynor','Daniel Abraham','Ty Franck','Dan Nowak','Robin Veith','Jason Ning','Shohreh Aghdashloo','Wes Chatham','Dominique Tipper'],
music:['Clinton Shorter'],
camera:['Jeremy Benning','Ray Dumas','Michael Galbraith','Kevin Jewison'],
cut:['Stephen Lawrence','Stephen Roque','Roderick Deogrades','D. Gillian Truster','Susan Shipton','Matthew Hannam','Paul G. Day','Harvey Rosenstock','Dev Singh','Michelle Szemberg','Nicholas Wong'],
sound:['Hugo DeLaCerda','Christian T. Cooke','Michael Baskerville','Dustin Harris','Steve Foster','Andrew Tay','Kirk Lynds','Matthew Chan'],
scenography:['Anthony A. Ianni','Seth Reed','Justin Craig','Peter Emmink','Peter P. Nicolakakos','Colin Adams','Jamie Frith','Michele Brady'],
masks:['Suzanne Heibati','Verity Fiction','Patrick Baxter',"Amanda O'Leary",'Maribeth Knezev'],
costumes:['Joanne Hansen']},
{title:'The Good Doctor',
titleCZ:'Dobrý doktor',
year:2017,
runtime:'96h 53min',
episodeRuntime:'41-43min',
countries:['USA'],
genres:['Drama'],
director:['Seth Gordon','John Dahl','Steven DePaul','Larry Teng','Michael Patrick Jann','David Straiton','Nestor Carbonell','Bronwen Hughes','Mike Listo','Cherie Nowlan',"Bill D'Elia",'Steve Robin','Sharat Raju','Tara Nicole Weyr','Marisol Adler','Joanna Kerns','Dawn Wilkinson','Allison Liddi-Brown','Freddie Highmore','Alrick Riley','David Shore','X. Dean Lim','Gary Hawes','Barbara Brown','Lisa Demaine','Sarah Wayne Callies','Vanessa Parise','Rachel Leiterman','Felipe Rodriguez','Rebecca Moline','Tim Southam','Anne Renton','James Genn','Lee Friedlander','Dinh Thai','Mina Shum','Bosede Williams','Cayman Grant','Aaron Rottinghaus','Daniel Dae Kim','Ruben Fleischer','Phillip Rhys Chaudhary'],
actors:['Freddie Highmore','Nicholas Gonzalez','Antonia Thomas','Hill Harper','Chuku Modu','Richard Schiff','Beau Garrett','Tamlyn Tomita','Graham Verchere','Dylan Kingwell','Miranda Edwards','Jasika Nicole','Britt Loder','Eve Gordon','Victoria Bidewell','Jesse Reid','Lucia Walters','Crystal Balint','Niall Matter','Tim Russ','Kirby Morrow','Adam Lolacher','Angela Moore','Teryl Rothery','Brett Rice','Jesse Moss','Samantha Sloyan','Michael Muhney','Norma Maldonado','Gloria Garayua','Ruben Garfias','Kandyse McClure','Kari Coleman','Michael Antonakos','Paul Dooley','Zachary Gordon','Zahf Paroo','Pej Vahdat','Christina Chang','Irene Keng','Orlando Lucas','Matthew Mandzij','Roman Podhora','Sam Vincent','Jesse James','Kacey Rohl','Catherine Lough Haggquist','Elfina Luk','Paige Spara','Erin Matthews','Parveen Dosanjh','Elizabeth Hinkler','Emily Hinkler','Adil Zaidi','Debs Howard','Alvina August','Marsha Thomason','Tegan Moss','Jojo Salkey-Randon','Charlie Latimer','Erika Scigliano','Alex Kliner','Nicholas Carella','Carly Bentall','Kayla Wallace','Eric Winter','Maggie Benedict','Lissa Neptuno','Vaughan Winmill','Coby Bird','Kari Matchett','Luvia Petersen','Devon Sandhu','Demord Dann','Manny Jacinto','Andrew Airlie','Faustino Di Bauda','Chad Matchette','Kylie McKay','Meghan Gardiner','Brendon Zub','Hayley Sales','Necar Zadegan','Kerry Sandomirsky','Robert Moloney','Sunita Prasad','Nelson Wong','Chelah Horsdal',"Chris D'Elia",'Fiona Gubelmann','JoBeth Williams','Michelle Morgan','Keith Allan','Kristin Lehman','Bruce Blain','Majumi Jošida','Michelle Martin','Hannah Pederson','Judith Maxie','Yasmeene Ball'],
screenplay:['Johanna Lee','David Hoselton','Simran Baidwan','Thomas L. Moran','William L. Rotko','David Renaud','Karen Struck','Lloyd Gilyard Jr.','David Shore','Freddie Highmore','Liz Friedman','Sal Calleros','Doris Egan','Brian Shin','Mark Rozeman','Peter Blake','Jessica Grasl','Tracy Taylor','Patricia Carr','Deborah J. Ezer','April Fitzsimmons','Jim Adler','Adam Scott Weissman','Peter Noah','Tristan Thai','Garrett Lerner','Sam Chanse'],
production:['Freddie Highmore','Shawn Williamson','Ron French','Konshik Yu','Min Soo Kee','David Renaud','Rebecca Moline'],
music:['Dan Romer'],
camera:['John S. Bartley','Eric Steelberg','Christopher Faloona','Mark Chow'],
cut:['Aaron Rottinghaus','Paul Fontaine',"Joe D'Augustine",'Sandra Montiel','Farrel Levy','Philip Carr Neel','Michael Hathaway','Jennifer Van Goethem','Craig Bench','Kirstie Mattheis'],
sound:['Nick Offord','Craig A. Dellinger','Robert Edmondson','Tara A. Paul','Mark Linden','Richard E. Yawn'],
scenography:['Charles M. Lagola','John Marcynuk','Tedd Kuchera','Michael Joy','Kate Marshall'],
masks:['Karoline Mlynarczyk','Jim Dreichel','Angela Nair','Mariah Crawley','Nichole Sanduliak','Natalie Cosco','James Dreichel','Tanya Hudson','Karly Paranich'],
costumes:['Kimberly A. Tillman','Jenni Gullett','Lorraine Carson']},
{title:'Extras',
titleCZ:'Komparz',
year:2005,
runtime:'7h 24min',
episodeRuntime:'30-84min',
countries:['UK','USA'],
genres:['Comedy'],
director:['Ricky Gervais','Stephen Merchant'],
actors:['Ricky Gervais','Ashley Jensen','Stephen Merchant','Shaun Williamson','Shaun Pye','Katherine Parkinson','Rob Brydon','Ben Stiller','Ross Kemp','Vinnie Jones','Kate Winslet','Samuel L. Jackson','Patrick Stewart','Orlando Bloom','Sophia Myles','David Bowie','Daniel Radcliffe','Diana Rigg','Warwick Davis','Chris Martin','Ian McKellen','Jonathan Ross','Robert Lindsay','Robert De Niro','Patrick Malahide','Clive Owen','Gareth Hale','Norman Pace','Toby Walton','Thomas Byrne','Karl Pilkington','Naomi Bentley','Kerry Godliman','Guy Henry','Natasha Little','Martin Savage','Stuart McQuarrie','Richard Briers','Ben Willbond','Tony Way','Kevin Moore','George Michael','Russell Loten','Steve Speirs','Raymond Coulthard','Peter Sullivan','Eleanor Matsuura','Nadia Williams','Nick Ball','Joanna Burnett','Paul Albertson','Katherine Jakeways','Jason Barnett','Katy Wix','Pascal Langdale','Lawry Lewin','Alex Dee','Sarah Preston','Gerard Kelly','David Earl','Cathy Murphy','Keith Chegwin','Adam James','Sarah Moyle','Andrew Buckley','Liza Tarbuck','Stephen Swift','Claire Adams','Ronnie Corbett','Patricia Potter','Stephen Fry','Jonathan Cake','Gordon Ramsay','David Tennant','Chico Slimani','Scott Baker','Rufus Wright','Susy Kane','Chris Wilson','Marek Larwood','Mark Kermode','Les Dennis','Rufus Jones','Geraldine Alexander','Jay Villiers','Lolita Chakrabarti',"Barunka O'Shaughnessy",'Rebecca Gethings','Wendy Nottingham','Matt Green','Fergus Craig','Dan Tetsell','Jo Wyatt','Michael Wildman','Susan Scott','Liza Sadovy','Nadia Williams'],
screenplay:['Ricky Gervais','Stephen Merchant'],
production:['Charlie Hanson'],
music:['Glyn Hughes','John Collins'],
camera:['Martin Hawkins'],
scenography:['Anna Higginson'],
costumes:['Annie Hardinge']},
{title:'Neon Genesis Evangelion',
titleCZ:'Šinseiki Evangelion',
year:1995,
runtime:'10h 50min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Action','Drama','Psychology','Sci-Fi'],
director:['Hideaki Anno','Kazuja Curumaki','Tensai Okamura','Keiiči Sugijama','Masajuki','Seidži Mizušima','Šóiči Masuo','Masahiko Ócuka','Minoru Óhara','Ken Andó','Hirojuki Išidó','Naojasu Habu','Akira Takamura'],
actors:['Megumi Hajašibara','Megumi Ogata','Kotono Micuiši','Júko Mijamura','Kóiči Jamadera','Takehito Kojasu','Tomokazu Seki','Akiko Jadžima','Akira Išida','Hiroši Naka','Fumihiko Tačiki','Maria Kawamura','Takaši Nagasako','Hidenari Ugaki','Hóčú Ócuka','Džin Jamanoi','Tecuja Iwanaga','Tomomiči Nišimura','Kacumi Suzuki','Miki Nagasawa','Akiko Hiramacu','Masako Kacuki','Hiro Júki','Juriko Jamaguči','Mugihito','Mijuki Macušita','Motomu Kijokawa','Jutaka Ójama','Fudžiko Takimoto','Džunko Iwao','Rjúzó Išino','Eidži Marujama','Kóiči Nagano'],
screenplay:['Masajuki','Hideaki Anno','Akio Sacukawa','Jódži Enokido','Hiroši Jamaguči','Šindži Higuči'],
production:['Jutaka Sugijama','Noriko Kobajaši'],
music:['Širó Sagisu'],
camera:['Yôichi Kuroda'],
cut:['Sačiko Miki'],
sound:['Hidejuki Tanaka'],
scenography:['Hiroši Kató']},
{title:"It's Always Sunny in Philadelphia",
titleCZ:"It's Always Sunny in Philadelphia",
year:2005,
runtime:'61h 5min',
episodeRuntime:'18-43min',
countries:['USA'],
genres:['Comedy'],
director:['Matt Shakman','Fred Savage','Randall Einhorn','Rob McElhenney','Todd Biermann','Richie Keen','Jerry Levine','John Fortenberry','Daniel Attias','Kat Coiro','Josh Drisko','Maurice Marable','Heath Cullens','Jamie Babbit','LP','Pete Chatmon','Megan Ganz','Glenn Howerton','Tim Roche','Kimberly McCullough'],
actors:['Charlie Day','Rob McElhenney','Danny DeVito','Glenn Howerton','Kaitlin Olson','Jaimie Alexander','Autumn Reeser','Kristoffer Polaha','Ted Rooney','Sabrina Machado','Gregory Scott Cummins','Suzanne Quast','Jimmi Simpson','Jose Yenque','Jackie Tohn','Fran Kranz','Tracey Walter','Geoff Pierson','Travis Schuldt','Michael August','Nora Dunn','Sam Witwer','Nick Wechsler','Kristen De Luca','Damian Young','Tom Bower','Jill Latiano','Marshall Allman','Aja Evans','Nasim Pedrad','Katie Chonacas','Aisha Hinds','Cody Kasch','Cleo King','Lindsey McKeon','Brandon Molale','Brian Unger','Richard Ruccolo','Jennifer Blanc-Biehn','Steven Lee Allen','Don Scribner','Mark Povinelli','Nate Mooney','Kevin Bangos','Robert Blanche','René Auberjonois','Nikki McKenzie','Mike Cochrane','Marcus Choi','Morena Baccarin','Kim Hawthorne','Matt Cedeño','Windell Middlebrooks','Sheldon Candis','Brighid Fleming','Jessie Ward','Retta','Benton Jennings','Robert Adamson','Sianoa Smit-McPhee','Josh Groban','Noah Bean','Michael Trotter','Liana Mendoza','P.J. Byrne','Tania Gunadi','Scott Beehner','Katie Gill','Spencer Daniels','David Huddleston','Alexandra Begg','Kat Purgal','Kerri Kenney','Don Frye','William Morgan Sheppard','Claire Risoli','Ian Reed Kesler','Seann William Scott','Mary Elizabeth Ellis','Jennifer Ann Massey','Julia Cho','Johnny Pemberton','Carla Renata','Pablo Schreiber','Jim O’Heir','April Scott','Lee Weaver','Heather Donahue','Rob Rosell','Mary Lynn Rajskub','Symba','Brian Lally','Amy Holland Pennell','Kyle Davis','Lisa Schwartz','Suzy Nakamura','Geoffrey Owens','Karen James','Lauren Mary Kim','Matt Nicholas'],
screenplay:['Adam Stein','Rob Rosell','Lance Krall','David Hornsby','Dave Chernin','John Chernin','Megan Ganz','Patrick Walsh','Charlie Day','Rob McElhenney','Glenn Howerton','Eric Falconer','Chris Romano','Scott Marder','Jordan Young','Elijah Aron','Sung-Jin Lee','Becky Mann','Audra Sielaff','Luvh Rakhe','Charlie Hornsby','Mehar Sethi','David Benioff','D.B. Weiss','Eric Ledgin','Hunter Covington','Conor Galvin','Jon Silberman','Josh Silberman','Dannah Feinglass','Danielle Schneider','Erin Ryan','Adam Weinstock','Andy Jones','John Harris','Katie McElhenney','Nina Pedrad'],
music:['Cormac Bluestone'],
camera:['Peter Smokler','John Tanzer','Eric Zimmerman']},
{title:'Into the West',
titleCZ:'Na Západ',
year:2005,
runtime:null,
episodeRuntime:'9h90min',
countries:['USA'],
genres:['Western','Adventure','Drama'],
director:['Simon Wincer','Jeremy Podeswa','Michael W. Watkins','Robert Dornhelm','Sergio Mimica-Gezzan','Timothy Van Patten'],
actors:['Matthew Settle','Josh Brolin','Gary Busey','Will Patton','Skeet Ulrich','John Terry','Gordon Tootoosis','Simon Baker','Rachael Leigh Cook','Tyler Christopher','Alan Tudyk','Keri Russell','Nathaniel Arcand','Sean Astin','Irene Bedard','Tom Berenger','Francesco Quinn','Jessica Capshaw','Beau Bridges','Keith Carradine','Balthazar Getty','Joanna Going','Graham Greene','Lance Henriksen','Christopher Heyerdahl','Matthew Modine','David Paymer','Tyler Posey','Kalani Queypo','Judge Reinhold','Clayton Rohner','Jonathan Scarfe','Eric Schweig','Craig Sheffer','Richard Speight Jr.','Wes Studi','Jeremiah Bitsui','Emily Holmes','Derek de Lint','Michael Spears','David Midthunder','Tinsel Korey','Samuel Patrick Chu','Christian Kane','Eddie Spears','Tonantzin Carmelo','Sean Wei Mah','Tokala Clifford','Shaun Johnston','Jesse Moss','Gil Birmingham','Ryan Robbins','Chaske Spencer','James Kirk','Dennis E. Garber','Arron Shiver','Daniel Gillies','Lawrence Santiago','John Pyper-Ferguson','Greyston Holt','Warren Kole','Nakotah LaRance','Mia Stallard','David Richmond-Peck','Myrton Running Wolf','Serge Houde','James Blackburn','Jay Tavare','Aldred Montoya','Anthony Parker','Steve Reevis','John Novak','Tatanka Means','Robert Moloney','Thom Schioler','Sean Blakemore','Zahn McClarnon','Roseanne Supernault','Chris Browning','Glen Powell','Kevin McNulty','George Aguilar','Forrest Fyre','Alexandr Kuzněcov','Alejandro Rae','Teach Grant','Brent Stait','Kevin Wiggins','Duane Howard','José Vargas','Scott Heindl','Kwesi Ameyaw','Sheila Tousey','Joe Peracchio','Greg Lawson','Dave Trimble','Rod Rondeaux','Dave Bald Eagle','Boots Southerland','William Sterchi'],
screenplay:['Cyrus Nowrasteh','Craig Storper','Kirk Ellis','William Mastrosimone'],
production:['Larry Rapaport'],
music:['Geoff Zanelli'],
camera:['Alan Caso','William Wages'],
cut:['Mark Conte','Sabrina Plisco'],
sound:['G. Michael Graham','Rick Alexander'],
scenography:['Marek Dobrowolski','Paul Healy'],
masks:['Matthew W. Mungle','Sharon Toohey'],
costumes:['Michael T. Boyd']},
{title:'Mob Psycho 100',
titleCZ:'Mob Psycho 100',
year:2016,
runtime:'15h 37min',
episodeRuntime:'24-25min',
countries:['Japan'],
genres:['Animation','Action','Fantasy','Comedy'],
director:['Juzuru Tačikawa','Takefumi Anzai','Hiroši Takeuči','Tomoaki Óta','Kacuja Šigehara','Tošijuki Sone','Takaši Kawabata','Takahiro Hasui','Jošitomo Jonetani','Hiroši Kobajaši','Masahiro Mukai','Acuši Takahaši','Šindži Sató','Tomomi Kamija','Jóhei Šindó','Tóko Jatabe','Hakuju Go','Jóko Kanamori','Kacumi Terahigaši'],
actors:['Secuo Itó','Takahiro Sakurai','Akio Ócuka','Miju Irino','Jošicugu Macuoka',"Šin'ičiró Miki",'Tošihiko Seki','Ai Kajano','Akeno Watanabe','Činacu Akasaki','Keidži Fudžiwara','Kotori Koiwai','Kódži Jusa','Kózó Dózaka','Rumi Ókubo','Wataru Takagi','Ajumi Fudžimura','Hijori Nitta','Fumihiko Tačiki','Jošimasa Hosoja','Džuri Kimura','Anri Kacu','Šunsuke Takeuči','Uki Satake','Naoki Makišima','Daisuke Kirii','Rintaró Niši','Sači Kokurjú','Júsuke Kuwahata',"Džun'iči Janagita",'Satoši Curuoka','Acumi Tanezaki',"Šin'ja Fukumacu",'Kenta Sasa','Tóru Sakurai','Seiičiró Jamašita','Jódži Ueda','Hirojuki Kagura','Risae Macuda','Hiroši Iwasaki','Čiaki Omigawa','Júko Hara','Daiki Hamano','Keikó Sakai','Hikaru Akao','Fumiko Učimura','Kóhei Amasaki','Haruka Čisuga','Mariko Higašiuči','Ikudži Nose','Juka Nukui','Nacu Jorita','Jú Hajaši','Kótaró Šinohara','Daisuke Motohaši','Rika Abe','Júna Mimura','Jú Okano','Kóiči Makišima','Taró Kiuči','Hiroki Macukawa','Terujuki Tanzawa','Taiten Kusunoki','Kazuhiko Inoue','Tasuku Hatanaka','Sanae Fuku','Júsuke Kobajaši','Rjóta Iwasaki','Takanori Hošino','Kenta Mijake','Noriaki Sugijama','Šógo Jano','Masafumi Kimura','Nobujuki Kobuši','Júdži Ueda','Fumie Mizusawa','Arisa Sakuraba','Jú Kobajaši','Akira Išida','Micuaki Hošino','M.A.O','Rjósuke Hara','Sacumi Macuda','Rjóta Takeuči',"Ken'ičiró Macuda",'Rjúnosuke Watanuki','Miju Komaki','Riho Kuma','Kajó Nakadžima','Gentoku Kumazawa','Takara Inoue','Tecu Kimišima','Tomomi Watanabe','Takaši Onozuka','Eisuke Asakura','Kandži Obana','Jumika Jano','Nao Oketani','Jú Šimamura','Jošinori Mutó'],
basedOn:['One'],
screenplay:['Hiroši Seko','Juzuru Tačikawa'],
production:['Masahiko Minami','Akio Macuda','Džun Fukuda'],
music:['Kendži Kawai'],
camera:['Majuko Furumoto'],
cut:['Kijoši Hirose'],
sound:['Kazuhiro Wakabajaši'],
scenography:['Rjó Kóno','Šiori Iwahara']},
{title:"The Handmaid's Tale",
titleCZ:'Příběh služebnice',
year:2017,
runtime:'57h 27min',
episodeRuntime:'42-60min',
countries:['USA'],
genres:['Drama','Sci-Fi','Thriller'],
director:['Mike Barker','Kari Skogland','Reed Morano','Kate Dennis','Floria Sigismondi','Jeremy Podeswa','Daina Reid','Amma Asante','Colin Watkinson','Dearbhla Walsh','Deniz Gamze Ergüven','Elisabeth Moss','Christina Choe','Richard Shepard','Liz Garbus','Dana Gonzales','Eva Vives','Natalia Leite','Bradley Whitford'],
actors:['Elisabeth Moss','Alexis Bledel','O.T. Fagbenle','Joseph Fiennes','Max Minghella','Yvonne Strahovski','Samira Wiley','Amanda Brugel','Ever Carradine','Madeline Brewer','Robert Curtis Brown','Kristen Gutoskie','Edie Inksetter','Stephen Kunken','Jim Cummings','Cyndy Day','Ann Dowd','Kim Roberts','Bea Santos','Erin Way','Shane Daly','Kristian Bruun','Nina Kiri','Amish Patel','Tattiawna Jones','Jenessa Grant','Zabryna Guevara','Ben Lewis','Christian Lloyd','Kirsten Johnson','Adrian Griffin','Meghan Allen','Clea DuVall','Jonathan Malen','Marisa Tomei','Tim Ransom','Bahia Watson','Jordana Blake','John Carroll Lynch','Nicky Guadagni','Janet Pinnick','Mark Wiebe','Cherry Jones','Philip Craig','Vas Saranga','Joanna Douglas','Trevor Hayes','Yahya Abdul-Mateen II','Kelly Jenrette','Greg Bryk','Sydney Sweeney','Soo Garay','Paula Boudreau','Margaret Atwood','Elise Bauman','Christopher Thompson','Rebecca Rittenhouse','Krista Morin','Nina Iordanova','James Gilbert','Karen Robinson','Dan Beirne','Christian Barillas','Marvin Kaye','Sam Jaeger','Bradley Whitford','Julie Dretzin','Chris Gillett','David Tompa','Vanessa Matsui','Oprah Winfrey','Lesleh Donaldson','David Kirby','Angela Thompson','Julia Chantrey','Ricky Tollman','Alana Pancyr','Ipsita Paul','Isaiah Rockcliffe','Amy Landecker','Ashleigh LaThrop','Natalie Lisinska','Kathryn Greenwood','Dylan Trowbridge','Jonathan Watton','Laila Robins','Samy Osman','Hélène Robbie','Kirsten Wendlandt','Christopher Meloni','Elizabeth Reaser','Sarah McVie','John Ortiz','Emily Althaus','Stefanie Nakamura','Gil Bellows','Sadie Munroe','Lilly Bartlam','Deidrie Henry','Paniz Zade'],
basedOn:['Margaret Atwood'],
screenplay:['Ilene Chaiken','Leila Gerstein','Eric Tuchman','Bruce Miller','Kira Snyder','Dorothy Fortenberry','Wendy Straker Hauser','Lynn Renee Maxcy','Nina Fiore','Marissa Jo Cerar','Jacey Heldrich','John Herrera','Aly Monroe','Yahlin Chang','J. Holtham','Katherine Collins','Rachel Shukert'],
production:['Joseph Boccia','Dorothy Fortenberry','Elisabeth Moss','Nina Fiore','Kim Todd','Marissa Jo Cerar','John Herrera','Michael Stoyanov','Elisabeth Williams','Nika Castillo'],
music:['Adam Taylor'],
camera:['Colin Watkinson','Zoe White','Stuart Biddlecombe','Bérénice Eveno','Nicola Daley','Stuart Campbell'],
cut:['Christopher Donaldson','Aaron Marshall','Julian Clarke','Wendy Hallam Martin','Ana Yavari'],
sound:['Joe Morrow','Jane Tattersall','Brad Dawe','David McCallum'],
scenography:['Caroline Gee','Sophie Neudorfer','Rob Hepburn','Julie Berghoff','Mark White','Elisabeth Williams','Andrew M. Stearn','Larry Spittle','Tijana Petrovic'],
masks:['Shane Zander','Alastair Muir','Jaime Donnelly','Samantha Terry'],
costumes:['Ane Crabtree','Natalie Bronfman','Leslie Kavanagh']},
{title:'Good Omens',
titleCZ:'Dobrá znamení',
year:2019,
runtime:'10h 30min',
episodeRuntime:'45-60min',
countries:['UK'],
genres:['Comedy','Fantasy'],
director:['Douglas Mackinnon'],
actors:['David Tennant','Michael Sheen','Frances McDormand','Sam Taylor Buck','Daniel Mays','Sian Brooke','Jon Hamm','Jack Whitehall','Michael McKean','Amma Ris','Alfie Taylor','Miranda Richardson','Paul Chahidi','Ilan Galkoff','Ned Dennehy','Doon Mackichan','Simon Merrells','Gloria Obianyo','Ariyon Bakare','Anna Maxwell Martin','Mireille Enos','Brian Cox','Yusuf Gatewood','Bill Paterson','Lourdes Faberes','Georg Nikoloff','Nina Sosanya','Nick Offerman','Laura Evelyn','Benedict Cumberbatch','Bryony Corrigan','Niamh Walsh','Nicola Harrison','Schelaine Bennett','Brice Bexter','Susan Brown','Jim Meskimen','Tim Bentinck','Nicholas Parsons','Adria Arjona','Stewart Scudamore','Philip Wright','Josie Lawrence','Amanda Hadingue','Ben Willbond','Phelim Kelly','Mark Cameron','Marianna Palka','Rowan Polonski','Mark Gatiss','Steve Pemberton','Joe Vaz','Reece Shearsmith','Jackie Clune','Neil Gaiman','Derek Jacobi','Dan Starkey','Kristofer Kamiyasu','Paul Kaye','Jenny Galloway','Johnny Vegas','Jonathan Aris','Elizabeth Berrington','Steve Oram','Mercedes Grower','Rosie Day','Euan Macnaughton','Kevin Millington','Jennifer Armour','Sanjeev Bhaskar','Tim Wallers','Niall Greig Fulton','Michel Diercks','Angela Yeoh','Maggie Service','Adam Bond','Konnie Huq','Andy de la Tour','Jordan Long','Nathan Amzi','Jill Winternitz','Louise Stewart','Liz Carr','Shelley Conn','Tim Downie','Peter Davison','Andi Osho','Sienna Arif Arif Knights','Ty Tennant','Abigail Lawrie','Julie McLellan','Moray Hunter','Sean Biggerstaff','Alex Norton','Douglas Russell','Mark McDonnell','Siân Phillips','Holly Woodhouse','Rich Keeble','Crystal Yu'],
basedOn:['Neil Gaiman','Terry Pratchett'],
screenplay:['Neil Gaiman','John Finnemore','Andy Nyman','Jeremy Dyson'],
production:['Phil Collinson','Tim Bradley','Loucas George','Sarah Kate Fenelon'],
music:['David Arnold'],
camera:['Gavin Finney'],
cut:['William Oswald','Emma Oxley','Steve Singleton','Colin Monie','Nikki McChristie'],
scenography:['Michael Ralph','Bronwyn Franklin','Barry Coetzer'],
costumes:['Claire Anderson','Kate Carin']},
{title:'The Serpent',
titleCZ:'Had',
year:2021,
runtime:'7h 41min',
episodeRuntime:'56-59min',
countries:['UK'],
genres:['Crime','Thriller'],
director:['Hans Herbots','Tom Shankland'],
actors:['Jenna Coleman','Tahar Rahim','Chicha Amatayakul','Ruby Ashbourne Serkis','Ellie Bamber','Sahajak Boonthanakit','Alice Englert','Stuart Bowman','Billy Howle','Darshan Jariwala','Dasha Nekrasova','Fabien Frankel','Tim McInnerny','Adam Rothenberg','Raphael Roger Levy','Mathilde Warnier','Tim McMullan','İlker Kaleli','Alma Jodorowsky','Damon Herriman','Stacy Martin','Nicole Beutler','Johan van Assche','Colin Stinton','Alyy Khan','Gabrielle Lazure','Geoffrey Breton','Saana Koivisto','Thomas Ryckewaert','Nigel Whitmey','Lucy Newman-Williams','Katrina Grey','Alexandra Merle','Apasiri Kulthanan'],
screenplay:['Toby Finlay','Richard Warlow'],
production:['Stephen Smallwood'],
music:['Dominik Scherrer'],
camera:['Seppe Van Grieken','Si Bell','Anton Mertens'],
cut:['Malcolm Crowe','Miikka Leskinen','Danielle Palmer','Helen Chapman'],
scenography:['François-Renaud Labarthe',"Witoon 'Boom' Suanyai"],
masks:['Anne Moralis'],
costumes:['Adam Howe','Rachel Walsh']},
{title:'Maid',
titleCZ:'Služka',
year:2021,
runtime:'9h 5min',
episodeRuntime:'48-60min',
countries:['USA'],
genres:['Drama','Comedy'],
director:['John Wells','Nzingha Stewart','Lila Neugebauer','Helen Shaver','Quyen Tran'],
actors:['Margaret Qualley','Nick Robinson','Rylea Nevaeh Whittet','Anika Noni Rose','Tracy Vilar','Billy Burke','Andie MacDowell','Raymond Ablack','Christie Burke','Mila Jones','Spencer Drever','Toby Levins','Matthew Mandzij','Jessica Matten','Jason Tremblay','Aimee Carrero','BJ Harrison','Alessandro Juliani','Nitin Prasad','Alison Araya','Philip Granger','Jed Rees','Lia Frankland','Erin Karpluk','Théodore Pellerin','Jessie Liang','Jelena Milinkovic','Jill Morrison','Eileen Pedde','Sachin Sahel','Patti Kim','Gloria Garayua','Nels Lennarson','Mozhan Marnò','Nhi Do','Erin Aubrey','Sook Hexamer','Roman Podhora','Chris Shields','Zolan Arneja','Laara Sadiq','Megan Leitch','Scott Bellis','Leo Chiang','Carmela Sison','Requell Jodeah','Madeleine Kelders','Mercedes De La Cruz','Kurt Szarka','Kristina Capati'],
basedOn:['Stephanie Land'],
screenplay:['Molly Smith Metzler','Colin McKenna','Marcus Gardley','Bekah Brunstetter','Michelle Denise Jackson'],
production:['Bonnie Benwick','Colin McKenna'],
music:['Este Haim','Christopher Stracey'],
camera:['Vincent De Paula','Quyen Tran'],
cut:['Annie Eifrig','Annette Davey'],
sound:['Joe DeAngelis','Adam Sawelson','Albert Romero','Chris Carpenter'],
scenography:['Renee Read'],
masks:['Darci Jackson'],
costumes:['Lyn Paolo','Lorraine Carson']},
{title:'Flight of the Conchords',
titleCZ:'Flight of the Conchords',
year:2007,
runtime:'9h 54min',
episodeRuntime:'25-29min',
countries:['USA'],
genres:['Comedy','Music'],
director:['Troy Miller','Taika Waititi','Michel Gondry','James Bobin','Michael Patrick Jann','Paul Simms'],
actors:['Jemaine Clement','Bret McKenzie','Rhys Darby','Kristen Schaal','Arj Barker','Frank Wood','David Costabile','Sutton Foster','Rachel Blanchard','Judah Friedlander','Aziz Ansari','Joan Hess','Sarah Burns','Demetri Martin','Kristen Wiig','June Diane Raphael','Lucy Lawless','Jim Gaffigan','Will Forte','Eliza Coupe','John Hodgman','Taika Waititi','Murray Bartlett','Patton Oswalt','Dena Kaplan','Michael Potts','Emily Swallow','Steve Sirkis','Christina Rose','Todd Barry','Madison McKinley','Dan Bakkedahl','Ramsey Faragallah','José Ramón Rosario','Randy Jones','Wai Ching Ho','Clayton Dean Smith','James Callanan','Sylvia Kauders','Adrian Martinez','Kate Pierson','John Turturro','Greg Proops','Michael Chen','Seymour Cassel','Alan Dale','Adam Garcia','Tiffany Limos','Sarah Wynter','Art Garfunkel','Victor Williams','Mary Lynn Rajskub','Halley Feiffer','Jonno Roberts','Anjali Bhimani','Diana Bologna','Eugene Mirman','Andrew Secunda','Truck Hudson','Heather Lawless','Junes Zahdi','Eddie Pepitone','Daryl Hall','Mary Catherine Garrison','Andrea Rosen','Megan Neuringer'],
screenplay:['James Bobin','Damon Beesley','Iain Morris','Taika Waititi','Eric Kaplan','Duncan Sarkies','Jemaine Clement','Bret McKenzie','Paul Simms'],
production:['Anna Dokoza'],
music:['Jemaine Clement','Bret McKenzie'],
camera:['Patrick Alexander Stewart'],
cut:['James Thomas','Shawn Paper','Steven Rasch','Casey Brown'],
scenography:['Dan Butts','Christine Stocking','Lisa Scoppa'],
masks:['Julie Teel'],
costumes:['Rahel Afiley']},
{title:'Little Dorrit',
titleCZ:'Malá Dorritka',
year:2008,
runtime:null,
episodeRuntime:'8h30-60min',
countries:['UK'],
genres:['Drama','Romance','History'],
director:['Diarmuid Lawrence','Dearbhla Walsh','Adam Smith'],
actors:['Claire Foy','Russell Tovey','Matthew Macfadyen','Tom Courtenay','Alun Armstrong','Judy Parfitt','Eddie Marsan','Emma Pierson','Andy Serkis','Rosie Cavaliero','Alex Wyndham','Amanda Redman','Eve Myles','Maxine Peake','Ruth Jones','Pam Ferris','Vincent Riotta','Annette Crosbie','Robert Hardy','Darren Boyd','Mackenzie Crook','James Fleet','Ron Cook','Zubin Varla','Georgia King','Bill Paterson','Laurence Belcher','Freema Agyeman','Sebastian Armesto','Arthur Darvill','Jason Watkins','Elliott Francis','Anton Lesser','Ian McElhinney','Bel Powley','Mark Kempner','Nicholas Blane','Philip Desmeules','David Verrey','Jonathan Slinger','Stephen Marcus','Imogen Bain','John Alderton','Janine Duvitski','Geoffrey McGivern','Nicholas Jones','Stuart Nurse','Geoffrey Whitehead','Amanda Lawrence','Hollie Burgess','Daniel Rovai','Sue Johnston','Harriet Walter','Jason Thorpe','Kingsley Frances-Gray','Julen De Retuerto','Alan Almond','Antonio Magro','Roy Hudd'],
basedOn:['Charles Dickens'],
screenplay:['Andrew Davies'],
production:['Lisa Osborne'],
music:['John Lunn'],
camera:['Alan Almond','Lukas Strebel','Owen McPolin'],
cut:['Philip Kloss','Nick Arthurs'],
scenography:['James Merifield'],
masks:['Talli Pachter','Jessica Brooks']},
{title:'Dragon Ball Z',
titleCZ:'Dragon Ball Z',
year:1989,
runtime:'116h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Action','Animation','Comedy','Fantasy'],
director:['Daisuke Nišio','Kazuhisa Takenouči','Minoru Okazaki','Šigejasu Jamauči','Hiromiči Matano',"Džun'iči Fudžise",'Acutoši Umezawa'],
actors:['Masako Nozawa','Džódži Janami','Hirotaka Suzuoki','Kóiči Jamadera','Majumi Tanaka','Miki Itó','Naoko Watanabe','Bin Šimada','Ičiró Nagai','Keiko Jokozawa','Mami Kojama','Megumi Hajašibara','Norio Wakamoto','Šigeru Čiba','Šózó Iizuka','Takeši Aono','Hikaru Midorikawa','Kendži Ucumi','Kazunari Tanaka','Keiiči Nanba','Hideo Išikawa','Hiroko Emori','Hidejuki Hori','Júdži Micuja','Majumi Šó','Naoki Tacuta','Daisuke Góri','Kódži Totani','Šó Hajami','Kózó Šioja','Júsuke Numata','Júko Kobajaši','Júko Minaguči','Džunpei Takiguči','Rjúsei Nakao','Ginzó Macuo','Šigeru Nakahara','Akira Kamija','Tomohisa Asó','Kacudži Mori','Kódži Jada','Džódži Janami','Hiromi Curu','Šin Aomori','Jasuo Tanaka','Tóru Furuja','Jukitoši Hori','Masaharu Sató','Tošio Furukawa','Rjó Horikawa','Kóhei Mijauči','Hiro Júki','Mijoko Aoba','Jukimasa Kišino','Isamu Tanonaka','Mariko Mukai','Jošijuki Kóno','Rjúzaburó Ótomo','Hisao Egawa','Kazumi Tanaka','Hiroši Masuoka','Toku Nišio','Kinpei Azusa','Hiromi Nišikawa','Nobuhiko Kazama','Acuši Kisaiči','Masaaki Ókura','Sara Nakajama','Eidži Marujama','Makiko Mizogami','Mičio Nakao','Juka Óno','Hirojuki Sató','Júdži Mači','Tošio Kobajaši','Reizó Nomoto','Naoko Nakamura','Arihiro Masuda','Reiko Jamada','Jóko Kawanami'],
basedOn:['Akira Torijama'],
screenplay:['Aja Macui','Mičiru Šimada','Kacujuki Sumisawa','Takao Kojama','Hiroši Toda','Masaši Kubota'],
production:['Kendži Šimizu','Kódži Kaneda'],
music:['Šunsuke Kikuči'],
cut:["Šin'iči Fukumicu"],
sound:['Nobuhiro Komacu']},
{title:'Yu Yu Hakusho: Ghost Files',
titleCZ:'Jú jú hakušo',
year:1992,
runtime:'44h 48min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Fantasy','Comedy'],
director:['Norijuki Abe','Akijuki Šinbó','Džunja Košiba'],
actors:['Nozomu Sasaki','Šigeru Čiba','Majumi Tanaka','Ikue Ótani','Džúróta Kosugi',"Ken'iči Ogata",'Megumi Hajašibara','Mika Doi','Norio Wakamoto','Rika Macumoto','Šózó Iizuka','Takehito Kojasu','Teššó Genda','Chuck Huber','Minami Takajama','Issei Futamata','Juri Amano','Kjóko Hikami','Taró Arakawa','Jasunori Macumoto','Nobuo Tobita','Minoru Inaba','Daiki Nakamura','Nobujuki Hijama','Jó Inoue','Ako Majama','Rokuró Naja','Šigeru Nakahara','Sanae Mijuki','Tecuo Kanao','Kacumi Suzuki','Šin Aomori','Micuaki Madono','Nobujuki Furuta','Nobuaki Fukuda','Hisako Kjóda','Jóko Sómi','Megumi Ogata','Šigezó Sasaoka','Čisa Jokojama','Hidetoši Nakamura','Rjó Horikawa','Kumiko Takizawa','Micuo Senda','Juri Širatori','Tomomiči Nišimura','Tamie Kubota','Macuo Macuo','Eidži Marujama','Jú Šimaka','Ken Širojama','Eidži Itó','Hadžime Koseki','Takaši Taniguči','Ajumi Kida','Cutomu Takajama','Kacujo Endó'],
basedOn:['Jošihiro Togaši'],
screenplay:['Hiroši Hašimoto','Sukehiro Tomita','Kacujuki Sumisawa'],
production:['Kendži Šimizu','Kódži Kaneda','Ken Hagino','Kjótaró Kimura'],
music:['Júsuke Honma'],
camera:['Tošijuki Fukušima'],
cut:['Haruhiko Kurijagawa',"Džun'iči Uemacu"],
sound:['Kan Mizumoto'],
scenography:['Júdži Ikeda','Šigenori Takada']},
{title:'Rurouni Kenshin: Wandering Samurai',
titleCZ:'Ruróni Kenšin: Meidži kenkaku romantan',
year:1996,
runtime:'37h 36min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','History','Comedy'],
director:['Kazuhiro Furuhaši','Šigeo Kóši','Takaši Kobajaši','Jasuhiro Geši','Hiroši Curuta','Naoki Hišikawa','Džun Fukuda','Makoto Sokuza','Akira Jošimura','Naoto Hašimoto',"Ken'ičiró Watanabe",'Kazuja Mijazaki','Kacumi Terahigaši'],
actors:['Majo Suzukaze','Miina Tominaga','Hirotaka Suzuoki','Mika Doi','Miki Fudžitani','Júdži Ueda','Akio Ócuka','Ikue Ótani',"Ken'iči Ogata",'Kendžiró Cuda','Majumi Tanaka','Nozomu Sasaki','Šózó Iizuka','Šúiči Ikeda','Takehito Kojasu','Unšó Išizuka','Wataru Takagi','Ikuo Nišikawa','Ikuja Sawaki','Takanori Nišikawa','Čieko Honda','Čafúrin','Hozumi Góda','Džunko Takeuči','Eidži Takemoto','Kan Tanaka','Šinpači Cudži','Džódži Nakata','Hiroši Janaka','Masanori Ikeda','Šizuka Okohira','Sumi Šimamoto','Kóiči Kitamura','Jasunori Macumoto','Nobuo Tobita','Minoru Inaba','Jasuo Muramacu','Gara Takašima','Nobujuki Hijama','Juriko Fučizaki','Jošikazu Nagano','Takeši Maeda','Takajuki Kondó','Noriko Hidaka','Júko Mizutani','Džunpei Takiguči','Hóčú Ócuka','Juzuru Fudžimoto','Kazuhiro Nakata','Joku Šioja','Šigeru Ušijama','Hiroko Kasahara','Rjúdži Nakagi','Kaneta Kimocuki','Jošito Jasuhara','Aruno Tahara','Takajuki Nezu','Taiki Macuno','Hiroši Šimozaki','Tomomiči Nišimura','Jasuhiro Mamija','Kumiko Nišihara','Kacuja Šiga','Šó Rjúzandži','Mika Išibaši','Kaneko Holly','Jošisada Sakaguči','Tomo Sakurai','Kazuhiro Óguro','Jasuo Tanaka','Šigezó Sasaoka','Júdži Mikimoto','Čisa Jokojama','Satoši Curuoka','Akiko Hiramacu','Jukinobu Kaneko','Noriko Namiki','Takkó Išimori','Akari Hibino','Hidetoši Nakamura','Masaru Ikeda','Hidejuki Umezu','Hiro Júki','Hiroši Takemura','Mugihito','Taeko Kawata','Rjúdži Saikači','Rjúnosuke Óbajaši','Rjó Naitó','Tacujuki Džinnai','Ricuo Sawa','Tomie Kataoka','Kósei Jagi','Mahito Cudžimura','Hidenobu Kiuči','Kazuhiro Jamadži','Džunko Iwao','Masami Kikuči','Akio Nodžima','Juri Širatori'],
basedOn:['Nobuhiro Wacuki'],
screenplay:['Jošijuki Suga','Nobuaki Kišima','Mičiru Šimada','Masaši Sogo','Mičiko Jokote','Akemi Omode'],
production:['Kódži Kaneda','Akio Wakana'],
music:['Norijuki Asakura'],
camera:['Masahide Okino','Hiroaki Edamicu'],
cut:['Megumi Učida','Takeši Sejama','Keiko Mizuta'],
scenography:['Nobuto Sakamoto','Masami Hagiwara']},
{title:'That Time I Got Reincarnated as a Slime',
titleCZ:'Tensei šitara slime datta ken',
year:2018,
runtime:'28h 23min',
episodeRuntime:'23-24min',
countries:['Japan'],
genres:['Animation','Fantasy','Comedy'],
director:['Jasuhito Kikuči','Acuši Nakajama','Munenori Nawa','Takahiro Tanaka','Takaomi Kanasaki','Šin Tósaka','Jošifumi Sasahara','Šunsuke Išikawa','Daisuke Eguči','Taizó Jošida','Šintaró Inokawa','Kacumi Terahigaši','Jasuhiro Itó'],
actors:['Megumi Tojoguči','Tomoaki Maeno','Makoto Furukawa','Sajaka Senbongi','M.A.O','Takuja Eguči','Hóčú Ócuka',"Džun'iči Janagita",'Kanehira Jamamoto','Haruki Išija','Rie Tanaka','Takuma Terašima','Takaja Haši','Ken Narita','Gen Sató','Čikahiro Kobajaši','Daiči Hajaši','Taiši Murata','Tomo Muranaka','Džun Kasama','Hiromiči Tezuka','Rjúiči Kidžima','Masaši Nogawa','Itaru Jamamoto','Rjóko Maekawa','Juka Nukui','Miho Okasaki','Džun Fukušima','Takahiro Sakurai','Manami Numakura','Čiaki Kobajaši','Hijori Kóno','Ai Kakuma','Satoši Hino','Acumi Tanezaki','Takehito Kojasu','Júja Hirose','Asuna Tomari','Taró Jamaguči','Reigo Jamaguči','Šó Nogami','Rjó Sugisaki',"Šun'iči Maki",'Jó Taiči','Rina Hidaka','Acuši Ono','Naoko Komacu','Kendžiró Cuda','Šóto Kašii','Harumi Sakurai','Misaki Watada','Júja Murakami','Jumiri Hanamori','Madoka Asahina','Kan Tanaka','Hinata Tadokoro','Jošimasa Hosoja','Kendži Hamada','Akane Kumada','Kazumasa Nakamura','Makoto Kaneko','Kazuja Nakai','Nacuki Hanae','Anzu Haruno','Haruka Širaiši','Azusa Tadokoro','Ajaka Asai','Šizuka Išigami','Kengo Takahaši','Tomojuki Šimura','Hisao Egawa','Šindži Kawada','Kóiči Sóma','Džuri Kimura','Šun Horie','Rumi Ókubo','Kaede Hondo','Kana Asumi','Jošihito Sasaki','Jasuhiro Mamija','Gakuto Kadžiwara','Kazumasa Fukagawa','Kengo Kawaniši','Akinori Egoši','Kendži Nomura','Jasuaki Takumi','Seiičiró Jamašita','Hadžime Iidžima','Júko Iida','Mikako Komacu','Jutaka Aojama','Tošiki Iwasawa','Haruka Džinja','Ajako Kawasumi','Daiki Kobajaši','Acuši Imaruoka','Hajato Fudžii','Ken Mizukoši','Hidejuki Umezu','Činacu Akasaki'],
basedOn:['Fuse'],
screenplay:['Kazujuki Fudejasu','Tošizó Nemoto'],
music:['Hitoši Fudžima'],
camera:['Hiroši Sató'],
cut:['Jumi Džingudži'],
sound:['Džin Aketagawa'],
scenography:['Ajumi Sató']},
{title:'We Bare Bears',
titleCZ:'Mezi námi medvědy',
year:2015,
runtime:'25h 40min',
episodeRuntime:'11-22min',
countries:['USA'],
genres:['Animation','Comedy','Family'],
director:['Manny Hernandez','John McIntyre','Kevin Petrilak','Richard Collado','Robert Alvarez','Elizabeth Kwon','Karl Fischer','Eulseong Kim','Duseok Lee','Sherie Pollack','Gi-dong Lee','Seunghyun Seo','Shaun Cashman','Brian Sheesley','Sae Chang Kwak','Nick DeMayo','Sang-Un Jeon','Meehea Kim','Hyungkon Song','Sean Dempsey','Seung Jin Oh','Jungja Kim-Wolf','Kidong Lee','Haesung Park','Sangman Park','Seung Wook Shin'],
actors:['Eric Edelstein','Demetri Martin','Bobby Moynihan','Keith Ferguson','Edi Patterson','Sam Lavagnino','Jason Lee','Kyler Spears','Charlyne Yi','Bert Youn','Cameron Esposito','Duncan Joiner','Stephanie Sheh','Max Mitchell','Patton Oswalt','Grey Griffin','Jinkoo Jeong','Niki Yang','Dexter Hobert','Alison Fernandez','Justin Felbinger','Cate Gragnani','Dee Bradley Baker','Fred Tatasciore','John DiMaggio','Tom Kenny','Ellie Kemper','Ben Diskin','Kyla Rae Kowalewski','Avery Kidd Waddell','Rick Zieff','James Arnold Taylor','Mel Rodriguez','Kahyun Kim','Faruq Tauheed','Cooper Friedman','Ashly Burch','Antonio Raul Corbo','Philece Sampler','Damien C. Haas','David Kaye','Kari Wahlgren','Steve Blum','Sydney Bell','Malcolm McDowell','Yuri Lowenthal','Tom Law','Tim Pocock','Peter Jessop','Jason Mantzoukas','Marcus Toji','Cedric Yarbrough','Erin Fitzgerald','Addie Chandler','Kevin McHale','Myrna Velasco','James Kyson','Maggie Lowe','Dean Cameron','Cynthia Kaye McWilliams','Kristina Pesic','Joel McCrary','Victor Brandt','Kyrie Irving','Kimiko Glenn','Brigitte Kali Canales','Sydney Mikayla','Michael Croner','Samuel Faraci','Christian J. Simon','Fernando Chien','Sullivan Jones','Jolie Hoang-Rappaport','Luke Lowe','ViviAnn Yee','Minty Lewis','Paul Eiding','Paul Rugg','Laura Bailey','Ben Bode','Steve Harwell','Dana Lyn Baron','Donovan Patton','Kody Kavitha','Vivienne Rutherford','Jonathon Buckley','Arnie Pantoja','Rafi Silver','Daphne Thomas','Sean Kenin','Andrew Kishino','Scott Menville','Jim Ward','Daniel Hagen','Lou Ferrigno','Margarita Levijeva','Kevin Michael Richardson','Daniel Chong','Rhys Darby','Jeff Bergman'],
screenplay:['Manny Hernandez','Bert Youn','Abe Audish','Kyler Spears','Danny Ducker','Daniel Chong','Madeline Sharafian','Tom Law','Guillermo Martinez','Adam Campbell','Eric Favela','Lauren Sassen','Julian Narino','Vera Brosgol','Louie Zong','Christina Chang','Sang Yup Lee','Sarah Sobole','Charlie Parisi','Roan Everly','Katie Mitroff','Hannah Cho','Yvonne Hsuan Ho','Quinne Larsen'],
production:['Randy Myers','Carrie Wilksen','Nate Funaro'],
music:['Brad Breeck'],
cut:['Bobby Gibis','Tom Browngardt','Tony Tedford','Peter Tomaszewicz'],
sound:['Timothy J. Borquez','Alex Borquez','Nick Gotten III','Eric Freeman','Patrick Janssen'],
scenography:['Tony Pulham','Sue Mondt']},
{title:'Squid Game',
titleCZ:'Hra na oliheň',
year:2021,
runtime:'13h 26min',
episodeRuntime:'32-63min',
countries:['South Korea'],
genres:['Thriller','Adventure','Action','Mystery','Drama'],
director:['Dong-hyeok Hwang'],
actors:['Jeong-jae Lee','Hje-su Pak','Sung-tae Heo','Ha-joon Wi','Yoo-mi Lee','Yoo Gong','Jung Hoyeon','Anupam Tripathi','Yeong-su Oh','Paul Nakauchi','Byung-hun Lee','Donald Chang','Tom Choi','Ah-in Jo','Joo-ryeong Kim','Mal-geum Kang','Jully Lee','Ji-ha Lee','Yang Mal-bok','Dong-hyun Kim','Gyu-young Park','David Lee','T.O.P','Ji An Won'],
screenplay:['Dong-hyeok Hwang'],
production:['Heung-seok Han'],
music:['Jae-il Jung'],
camera:['Hyeong-deok Lee'],
cut:['Na-young Nam'],
scenography:['Kyoung-sun Chae'],
masks:['Tae-hee Cho'],
costumes:['Sang-gyeong Jo']},
{title:'Samurai Jack',
titleCZ:'Samuraj Jack',
year:2001,
runtime:'23h 28min',
episodeRuntime:'21-24min',
countries:['USA'],
genres:['Animation','Action','Sci-Fi','Adventure'],
director:['Genndy Tartakovsky','Randy Myers','Robert Alvarez','Phil LaMarr','Chris Savino','Rob Renzetti','Jinsung Kim','Dong-Won Jung'],
actors:['Phil LaMarr','Mako','Kevin Michael Richardson','Jeff Bennett','Grey Griffin','Rob Paulsen','Jennifer Hale','Lauren Tom','Joe Alaskey','John DiMaggio','Sab Shimono','Brian George','Larry Cedar','Daran Norris','Bobby Edner','Anndi McAfee','Keone Young','Rachael MacFarlane','Chris Parnell','Tom Kenny','Brock Peters','Clyde Kusatsu','Mark Hamill','Jess Harnell','Maurice LaMarche','Josh Peck','Tim Curry','Dee Bradley Baker','Corey Burton','Clancy Brown','John Kassir','George Takei','Tara Strong','Brian Tochi','Billy West','Rino Romano','David Alan Grier','Kari Wahlgren','Keegan-Michael Key','Ruth Williamson','Kath Soucie','Bob Joles','Mike Bell','Richard McGonagle','Patrick Pinney','Danny Mann','Aaron LaPlante','B.J. Ward','André Sogliuzzo','Jennifer Martin','Peter Renaday','Matt Levin'],
screenplay:['Genndy Tartakovsky','Bryan Andrews','Mark Andrews','Charlie Bean','Brian Larsen','David Krentz','Aaron Springer','Darrick Bachman','Chris Reccardi'],
production:['Genndy Tartakovsky','Eric Gardner','Paul Rudish','Aaron Springer','Kelly Crews','Kevin Kolde'],
music:['James L. Venable','Tyler Bates','Joanne Higginbottom','Randy Myers'],
cut:['Paul Douglas'],
sound:['Eric Freeman','Timothy J. Borquez','Alex Borquez','Joel Valentine'],
scenography:['Scott Wills']},
{title:'Trigun',
titleCZ:'Trigun',
year:1998,
runtime:'10h 50min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Action','Comedy','Western'],
director:['Satoši Nišimura','Hideo Hajaši','Tomio Jamauči','Nanako Šimazaki','Jutaka Sató','Jošihide Kurijama'],
actors:['Šó Hajami','Hiromi Curu','Sacuki Jukino','Masaja Onosaka','Tošihiko Seki','Akio Ócuka','Acuko Tanaka','Hirotaka Suzuoki','Iššin Čiba','Džúróta Kosugi',"Ken'iči Ogata",'Kendži Nodžima','Miki Itó','Norio Wakamoto','Rika Macumoto','Susumu Čiba','Takehito Kojasu','Takeši Aono','Unšó Išizuka','Wataru Takagi','Aja Hisakawa','Hiroši Kamija','Tošijuki Morikawa','Tomohiro Nišimura','Masuo Amada','Šódži Óki','Juki Masuda','Masajuki Nakata','Kazunari Tanaka','Keiiči Nanba','Jošiko Kamei','Issei Futamata','Čafúrin','Juri Amano','Kjóko Hikami','Šinpači Cudži','Rei Sakuma','Mari Mašiba','Miki Narahaši','Fumihiko Tačiki','Hiroši Janaka','Naoki Tacuta','Daisuke Góri','Nobuo Tobita','Takaši Nagasako','Kóki Mijata','Wakana Jamazaki','Emi Motoi','Jukari Honma','Júko Kobajaši','Kódži Išii','Takaja Haši','Hidenari Ugaki','Juzuru Fudžimoto','Kendži Nomura','Kijojuki Janada','Seizó Kató','Jukari Tamura','Šigeru Nakahara','Kaneta Kimocuki','Aruno Tahara','Tomohisa Asó','Maja Okamoto','Tecuja Iwanaga','Hiroaki Išikawa','Reiko Suzuki','Kunihiko Jasui',"Ken'iči Ono",'Nobuaki Fukuda','Masahiko Tanaka','Akiko Takeguči','Jóko Sómi',"Masa'aki Jadžima",'Júdži Mikimoto','Miki Nagasawa','Kinrjú Arimoto','Tošiharu Sakurai','Kjósei Cukui','Mika Kanai','Hidetoši Nakamura',"Džu'iči Kanemaru",'Rjó Horikawa','Hidejuki Umezu','Kijoši Kawakubo','Jukimasa Kišino','Hiroši Ito','Tóru Furusawa','Miho Jamada','Tomoko Išimura','Čie Sató','Rjúzaburó Ótomo','Ai Sató','Hisao Egawa','Takuma Suzuki','Takuró Kitagawa','Kazuo Oka','Masaši Sugawara','Eidži Marujama','Kazujuki Išikawa','Hiroši Naka'],
basedOn:['Jasuhiro Naitó'],
screenplay:['Jósuke Kuroda'],
production:['Šigeru Kitajama'],
music:['Cuneo Imahori'],
camera:['Hisao Širai'],
cut:['Jukiko Itó','Satoši Terauči','Harutoši Ogata'],
sound:['Jasunori Honda'],
scenography:['Hidetoši Kaneko']},
{title:'Delhi Crime',
titleCZ:'Delhi Crime',
year:2019,
runtime:'9h 42min',
episodeRuntime:'36-64min',
countries:['India'],
genres:['Drama','Crime'],
director:['Richie Mehta'],
actors:['Swati Bhatia','Shefali Shetty','Rasika Dugal','Rajesh Tailang','Yashaswini Dayama','Anurag Arora','Jaya Bhattacharya','Adil Hussain','Vinod Sharawat','Denzil Smith','Shobhna Bharadwaj','Sanjay Bishnoi','Avijit Dutt','Dinker Sharma','Jatin Goswami'],
screenplay:['Richie Mehta'],
music:['Andrew Lockington'],
camera:['Johan Heurlin Aidt'],
cut:['Beverley Mills'],
sound:['Martin Lee'],
scenography:['Mandar D. Nagaonkar'],
costumes:['Smriti Chauhan']},
{title:'Puella Magi Madoka Magica',
titleCZ:'Mahó šódžo Madoka Magika',
year:2011,
runtime:'4h 56min',
episodeRuntime:'24-26min',
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Psychology','Thriller'],
director:['Akijuki Šinbó',"Šin'iči Omata",'Fudžiaki Asari','Jukihiro Mijamoto','Masahiro Mukai','Júki Jase','Seimei Kidokoro','Kotono Watanabe','Takahiro Madžima','Takaši Kawabata'],
actors:['Aoi Júki','Emiri Kató','Čiwa Saitó','Ai Nonaka','Rumi Ókubo',"Šin'ičiró Miki",'Jošicugu Macuoka','Eri Kitamura','Júko Gotó','Nobuo Tobita','Ajane Sakura','Tecuja Iwanaga','Hideki Tasaka','Hidejuki Umezu','Seiró Ogino','Kaori Mizuhaši','Džunko Iwao','Dai Macumoto','Tomoko Nakamura','Seiko Jošida','Rjóko Šintani','Rei Macuzaki','Mizuki Nakamura'],
screenplay:['Gen Urobuči'],
production:['Hiró Marujama','Osamu Hosokawa','Yoshinao Doi'],
music:['Juki Kadžiura'],
camera:["Šin'ičiró Etó"],
cut:['Rie Macubara'],
sound:['Jóta Curuoka'],
scenography:['Kunihiko Inaba','Júdži Kaneko']},
{title:'Kanon',
titleCZ:'Kanon',
year:2006,
runtime:null,
episodeRuntime:'10h25min',
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Romance'],
director:['Tacuja Išihara','Jutaka Jamamoto','Noriko Takao','Šinobu Jošioka','Taiči Išidate','Kazuja Sakamoto','Jasuhiro Takemoto','Jošidži Kigami',"Džun'iči Fudžise",'Norijuki Kitanohara'],
actors:['Majumi Iizuka','Jui Horie','Tomokazu Sugita','Jukari Tamura','Akemi Sató','Ajako Kawasumi','Tomokazu Seki','Kei Kobajaši','Kendži Nodžima','Masaja Onosaka','Akiko Jadžima','Sajuri Jahagi','Jóko Honda','Hiroši Janaka','Rjóko Ono','Tecu Inada','Júko Minaguči','Tomoko Kawakami','Eri Nakao','Aimi Ueda','Acuši Imaruoka','Sajaka Kinošita',"Ken'iči Močizuki",'Kentaró Tone','Kengo Kawaniši','Jú Šimamura','Mariko Kóda','Gó Šinomija','Arise Sató','Kaja Mijake','Hisanori Kojacu','Ajano Išikawa','Haruka Kimura','Keisuke Fudžii','Masajasu Nagata','Miwa Jasuda','Maaja Sakamoto','Taku Kimura','Kazuhisa Tanaka','Makiko Mizogami','Kóko Cukimoto','Masaru Uekura','Juka Tanaka','Tomojoši Fukazu'],
screenplay:['Fumihiko Šimo'],
music:['Džun Maeda','Odiakes','Šindži Orito'],
camera:['Rjúta Nakagami'],
cut:['Jukie Oikawa','Masaki Sakamoto'],
sound:['Jóta Curuoka'],
scenography:['Mucuo Šinohara']},
{title:'To Play the King',
titleCZ:'Hrát králem',
year:1993,
runtime:'3h 43min',
episodeRuntime:'54-59min',
countries:['UK'],
genres:['Drama'],
director:['Paul Seed'],
actors:['Ian Richardson','Kitty Aldridge','Diane Fletcher','Rowena King','Nicholas Farrell','Nick Brimble','Bernice Stegers','Susannah Harker','Emma Bunton','Richard Durden','Michael Kitchen','Kenneth Gilbert','Richard Howard','Merelina Kendall','David Ryall','Elizabeth Chambers','Christopher Owen','Colin Jeavons','Paula Tlbrook','Geoffrey McGivern','Don Warrington','Anthony Smee','Barry Linehan','Frederick Trevers','Pip Torrens','Susannah Harker','Jack Fortune','Adam Bareham'],
basedOn:['Michael Dobbs'],
screenplay:['Andrew Davies'],
music:['Jim Parker'],
camera:['Ian Punter'],
scenography:['Ken Ledsham'],
costumes:['Rosalind Ebbutt']},
{title:'Unorthodox',
titleCZ:'Neortodoxní',
year:2020,
runtime:'3h 35min',
episodeRuntime:'53-55min',
countries:['Germany'],
genres:['Drama'],
director:['Maria Schrader'],
actors:['Shira Haas','Amit Rahav','Jeff Wilbusch','Aaron Altaras','Tamar Amit-Joseph','Ronit Asheri','Dina Doron','Aziz Dyab','David Mandelbaum','Delia Mayer','Felix Mayr','Alex Reid','Eli Rosen','Safinaz Sattar','Langston Uibel','Isabel Schosnig',"Yousef 'Joe' Sweid",'Laura Beckner','Harvey Friedman','Melissa Weisz','Lena Kalisch','Alexa Karolinski','Lenn Kudrjawizki','Hildegard Schroedter','Dennenesch Zoudé','Joey Lawrence','Lucie Bates','Christian David','Michel Diercks','Lena Lauzemis','Irina Potapenko','Harald Siebler','Mihaela Sirbu','Gera Sandler'],
basedOn:['Deborah Feldman'],
screenplay:['Deborah Feldman','Daniel Hendler','Alexa Karolinski','Eli Rosen','Anna Winger'],
production:['Alexa Karolinski'],
music:['Antonio Gambale'],
camera:['Wolfgang Thaler'],
cut:['Hansjörg Weißbrich','Gesa Jäger'],
sound:['Daniel Iribarren','Linus Nickl','Adrian Baumeister','Paul Rischer','Florian Holzner'],
scenography:['Silke Fischer'],
masks:['Jens Bartram','Barbara Zschetzsche'],
costumes:['Justine Seymour']},
{title:'Tulsa King',
titleCZ:'Král Tulsy',
year:2022,
runtime:'12h 16min',
episodeRuntime:'36-43min',
countries:['USA'],
genres:['Drama','Crime'],
director:['Ben Semanoff','Allen Coulter','Ben Richardson','Guy Ferland','Lodge Kerrigan'],
actors:['Sylvester Stallone','Andrea Savage','Martin Starr','Jay Will','Max Casella','Domenick Lombardozzi','Vincent Piazza','A.C. Peterson','Garrett Hedlund','Dana Delany','Dashiell Connery','Ritchie Coster','Tatiana Zappardino','Annabella Sciorra','Angel Rosario Jr.','Tyler Elliot Burke','Barry Corbin','Miles Mussenden','Steve Witting','John Cenatiempo','Justin Henry','Cassie Shea Watson','Sabreena Iman','Cheryl Francis Harrington','Carmine Famiglietti','Michael Beach','Nicole Shalhoub','Glen Gould','Tiffany Dawn','Bruce Davis','Scarlet Rose Stallone','Dan Waller','Dani Deetté','Joseph Riccobene','David Maldonado','Jeremy Denzlinger','Marissa Joy Davis','James Healy Jr.','Anthony Patellis','Skip Schwink','Samara Gonzalez','Henry Eckmann','Pierce Eckmann','Gabrielle Reyes'],
screenplay:['Terence Winter','Taylor Sheridan','Regina Corrado','Dave Flebotte','Joseph Riccobene','David Flebotte','Tom Sierchio'],
production:['Braden Aftergood','Cristine Chambers'],
music:['Danny Bensi','Saunder Jurriaans'],
camera:['Cameron Duncan','Jalaludin Trautmann','Glenn Brown'],
cut:['Sidney Wolinsky','Amy Colla','Harvey Rosenstock','Jonny Converse'],
sound:['Andrejs Prokopenko'],
scenography:['Janessa Hitsman','Todd Jeffery','Justyna Kornacka'],
masks:['Roxxi Dott'],
costumes:['Amy Stofsky','Suzanne McCabe']},
{title:'Years and Years',
titleCZ:'Roky a roky',
year:2019,
runtime:'5h 50min',
episodeRuntime:'56-59min',
countries:['UK'],
genres:['Drama'],
director:['Lisa Mulcahy','Simon Cellan Jones'],
actors:['Russell Tovey','Rory Kinnear',"T'Nia Miller",'Ruth Madeley','Anne Reid','Jessica Hynes','Emma Thompson','Lydia West','Jade Alleyne','Maxim Baldry','Sharon Duncan-Brewster','Zita Sattar','Alexander Armstrong','Tamar Baruch',"Kieran O'Brien",'Dino Fetscher','Paul Merton','Tina Louise Owens','Heather Dutton','Roger Ringrose','Ian Hislop','Eamonn Riley','Natasha Jayetileke','David Crellin','Sue Devaney','Andrew Byron',"Dermot O'Leary",'Emma Fielding','Dan Starkey','Ellie Haddington','Rish Shah','Jack Kane','Michael Moreland','Dan McGee','Julie Peasgood','Lee Latchford-Evans','Rachel Logan','Nadia Albina','Gracy Goldman','Adesuwa Oni','Simon Darwen'],
screenplay:['Russell T. Davies'],
music:['Murray Gold'],
camera:['Tony Slater Ling','Stephen Murphy'],
cut:['Billy Sneddon'],
sound:['Howard Bargroff'],
scenography:['Emma Davis','Julie Signy'],
costumes:['Jacky Levy']},
{title:'War and Peace',
titleCZ:'Vojna a mír',
year:2016,
runtime:null,
episodeRuntime:'Televizní verze: 4x90min',
countries:['UK','USA'],
genres:['Drama','History','Romance','War'],
director:['Tom Harper'],
actors:['Paul Dano','James Norton','Lily James','Adrian Edmondson','Aisling Loftus','Greta Scacchi','Jack Lowden','Tuppence Middleton','Aneurin Barnard','Jessie Buckley','Olivia Ross','Tom Burke','Jim Broadbent','Callum Turner','Rebecca Front','Stephen Rea','Kenneth Cranham','Gillian Anderson','Brian Cox','Michael Epp','Chloe Pirrie','Jean-Baptiste Puech','Pip Torrens','Sakalas Uždavinys','David Quilter','Paulius Markevičius','David Sibley','Valerijus Jevsejevas','Ferdinandas Jakšys','Fenella Woolgar','Kate Phillips','Mathieu Kassovitz','Philippe Maymat','Jolyon Coy','Ludger Pistor','Michael Shelford','Emily Taaffe','Ben Lloyd-Hughes','Vincent Brimble','Ken Stott','Tim Bentinck','Rory Keenan','Nicholas McGaughey','Otto Farrant','Kate Fleetwood','Nicolas Carpentier','Nick Brimble','Edward Dogliani','Harry Lister Smith','Andrew Bicknell','Lukas Malinauskas','Terence Beesley','Renan Carteaux','Giedre Giedraityte','Mindaugas Cerniauskas','Adrian Rawlins','Guillaume Delorme','Gary Oliver','Will Attenborough','Thibaut Evrard','Kit Connor','Guillaume Faure','Benjamin Wainwright','Jay Villiers','Petras Kuneika','Manuel Severi','Samuel Brafman-Moutier','Marc Arnaud','Dan Tetsell','Laurent Maurel','Vidmantas Fijalkauskas','Justas Valinskas','Milo Twomey','Benson Wang','Matthew Stagg'],
basedOn:['Lev Nikolajevič Tolstoj'],
screenplay:['Andrew Davies'],
production:['Julia Stannard'],
music:['Martin Phipps'],
camera:['George Steel'],
cut:['Mark Eckersley','Steven Worsley'],
scenography:['Chris Roope'],
masks:['Jurgita Globytė','Giedre Jarockaite'],
costumes:['Edward K. Gibbon']},
{title:'TRON: Uprising',
titleCZ:'Tron: Povstání',
year:2012,
runtime:'6h 58min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Animation','Action','Adventure','Sci-Fi'],
director:['Charlie Bean','Robert Valley'],
actors:['Elijah Wood','Tricia Helfer','Bruce Boxleitner','Paul Reubens','Lance Henriksen','Mandy Moore','Emmanuelle Chriqui','Reginald VelJohnson','Nate Corddry','Charlie Bean','Fred Tatasciore','Kate Mara','Olivia Wilde','Adam Devine','Greg Ellis','Matt Jones','Elizabeth Ho','Parminder Nagra','Keone Young','Paul Scheer','Ron Yuan','John Eric Bentley','Kathryn Hunter','Meeghan Holaway','Kim Talon','Lance Reddick','Ben Schwartz','Donald Faison','Lake Bell','Mark Boone Junior','Chris Klein','David Arquette','Paul Rust','John Glover','Aaron Paul','Jamie Hector','Jack Huston','Marcia Gay Harden','Scott Nimerfro','Kevin Michael Richardson','Sam Riegel','Mark Kondracki'],
screenplay:['Adam Nussdorf','Adam Horowitz','Edward Kitsis','Steven Lisberger','Bonnie MacBird','Scott Nimerfro','Bill Wolkoff','Mark Litton','Kamran Pasha','Akela Cooper','Donna Thorland','André Bormanis'],
music:['Joseph Trapanese'],
cut:['Tony Mizgalski'],
sound:['Keith Rogers','Scott Weber']},
{title:'Yuri!!! on Ice',
titleCZ:'Júri!!! on ICE',
year:2016,
runtime:'4h 36min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Drama','Comedy','Sport'],
director:['Sajo Jamamoto','Kaori Makita','Takaši Kobajaši','Jasuhiro Geši','Júsuke Onoda','Macuo Asami','Hirokazu Jamada','Kunihiro Mori','Kendži Takahaši'],
actors:['Tošijuki Tojonaga',"Džun'iči Suwabe",'Kóki Učijama','Džun Fukujama','Kendži Nodžima','Kenšó Ono','Mamoru Mijano','Juka Komacu','Hideaki Tezuka','Tomoaki Maeno','Satoši Hino','Jošimasa Hosoja','Hiroki Jasumoto','Marija Ise','Kei Hajami','Ajumu Murase','Kudžira','Ai Fukada','Šiho Kokido','Jútaró Hondžó','Mijuki Kobori','Ami Naitó','Eri Inagawa','Acuo Hasegawa',"Šun'iči Toki",'Akiko Jadžima','Jutaka Furukawa','Misono Suzuki','Mijako Čida','Naoki Takimura','Júki Kazu','Tomonori Išihara','Tomisaburó Horikoši','Kódži Očiai','Satoši Nakao','Wataru Hatano','Eri Ózeki','Jukari Watanabe','Sórjú Konno','Seiko Tamura','Šinobu Hozumi','Mari Doi','Kjóko Sakai','Misao Kobajaši','Dženja','Osamu Taira','Isato Jamamura','Eriko Učino','Naoto Cučija','Marika Minase','Kengo Mizoguči','Kendži Jošida','Júko Kawaniši'],
screenplay:['Micuró Kubo','Sajo Jamamoto'],
production:['Tomoharu Macuhisa','Satoši Noguči'],
music:['Taró Umebajaši','Taku Macušiba'],
camera:['Jošihasa Ójama'],
cut:['Tomoki Nagasaka'],
sound:['Jódži Šimizu'],
scenography:['Tošiharu Mizutani']},
{title:'Wu-Tang: An American Saga',
titleCZ:'Wu-Tang: Americká sága',
year:2019,
runtime:'25h 15min',
episodeRuntime:'41-70min',
countries:['USA'],
genres:['Biographic','Drama','Music'],
director:['Craig Zisk','Tara Nicole Weyr','Norberto Barba','Darren Grant','Colin Bucksey','Chris Robinson','Jet Wilkinson','Mario Van Peebles','Matthew Ross','Rachel Raimist','Dinh Thai','Nijla Mumin','Nefertite Nguvu','Janice Cooke','Eif Rivera','RZA'],
actors:['Tamiz U. Rezvi','Caleb Castille','Anthony Chisholm','Dave East','Zolee Griggs','Julian Elijah Martinez','Ashton Sanders','Siddiq Saunderson','Tom Galantich','Shameik Moore','Bokeem Woodbine','Jake Hoffman','Jamie Hector','Erika Alexander','Joey Bada$$','Ebony Obsidian','Vincent Pastore','Marcus Callender','Adam Scarimbolo','Natalie Carter','Chris Jarell','Reginald L. Barnes','Eric Ruffin','Scott Stangland','Jill Flint','Ron Yuan','Alex Kramer','Eric Tabach','Brian Muller','Adriane Lenox','Imani Lewis','Mark Lotito','Tatum Marilyn Hall','Tonya Pinkins','Antoni Corone','Armen Garo','Iba Thiam','Hugues Faustin','Brian Anthony Wilson','Jorge Lendeborg Jr.','Ezra Knight','Dj Nino Carta','Stephen McKinley Henderson','Lucas Papaelias','Jimi Stanton','Dante Hoagland','Tibor Feldman','Sullivan Jones','Paola Lázaro','Kecia Lewis','Silvia Dionicio','Jos Laniado','J. Bernard Calloway','Mandela Van Peebles','Matt Walton','DeShawn White','Andrew D. Manning','Gino Cafarelli','Motell Gyn Foster','Andy Le','Brianna Cohen','JaQwan J. Kelly','Iroko Anyogu','Josiah Gaffney','Marcus Gladney Jr.','Racquel Jean-Louis','Max Woertendyke','Jordan-Amanda Hall','Delissa Reynolds','Bryan Reynoso','Bill Dawes','Deja Blaise','Perry Strong','Racquel Palmer','Serayah','Brenda Currin','Trayce Malachi','Emily Kimball','T.J. Atoms','Jashawn Lee','Brian Rojas','Jasmine Ashanti','David J. Cork','Christen Sharice'],
screenplay:['RZA','Alex Tse',"Ryan O'Nan",'Zak Schwartz','Chelsey Lora','Rodney Barnes','Emily Shesh','Zina Camblin','Earl Davis','Michael C. Martin','Gabe Fonseca'],
production:["Ryan O'Nan",'Earl Davis','Gabe Fonseca','Keira Morrisette','James Seidman'],
music:['RZA'],
camera:['Gavin Kelly','Niels Alpert','David S. Tuttman'],
cut:['Jake Pushinsky','Josh Beal','Jonathan Chibnall','Martin Wilson','Bjørn T. Myrholt','Melissa Gearhart','Adrienne McNally'],
sound:['Richard Weingart','Alexandra Fehrman','Mark Server','Rick Ash','Paul Bercovitch','Thomas DeGorter'],
scenography:['Scott P. Murphy','Jacqueline Jacobson Scarfo','Nicki Ritchie','Lisa Myers','Rocio Gimenez','Ted LeFevre','Nick Francone'],
masks:['Jenn Blum','Kaela Dobson'],
costumes:['Marci Rodgers']},
{title:'Treme',
titleCZ:'Treme',
year:2010,
runtime:'35h 30min',
episodeRuntime:'56-85min',
countries:['USA'],
genres:['Drama','Music'],
director:['Anthony Hemingway','Ernest R. Dickerson','Agnieszka Holland','Jim McKay','Simon Cellan Jones','Brad Anderson','Roxann Dawson','Alex Hall','Tim Robbins','Christine Moore','Daniel Attias','Alex Zakrzewski','Rob Bailey','Adam Davidson'],
actors:['Khandi Alexander','Rob Brown','Kim Dickens','Michiel Huisman','Melissa Leo','Lucia Micarelli','Clarke Peters','Wendell Pierce','Steve Zahn','India Ennenga','David Morse','Jon Seda','Chris Coy','Lance E. Nichols','Ntare Guma Mbaho Mwine','Davi Jay','Edwina Findley','Dan Ziskie','Renwick D. Scott II','Walter Harris','Lloyd Watts','Elizabeth Ashley','John Goodman','Hong Chau','Anwan Glover','Terence Blanchard','Stephanie Honoré','Danai Gurira','Talia Balsam','Tarra Riggs','Marc John Jefferies','Derek Cecil','Marco St. John','Yolonda Ross','LeToya Luckett-Walker','Victor Slezak','Mahershala Ali','Jim True-Frost','Gary Grubbs','Indigo','Elvis Costello','Ned Bellamy','Tim Reid','Louis Herthum','Mattie Liptak','Glen Warner','Candace Weber','Jerry Katz','Tracy Miller','James Ransone','Marc Menchaca','John McConnell','Levy Easterly','Ashton Leigh','Gralen Bryant Banks','Lucky Johnson','James DuMont','Phil Austin','Brittney Alger','David Joseph Martinez','Nick Gomez','Luis Da Silva Jr.','Juliet Reeves','Jaren Mitchell','Christopher Matthew Cook','Dane Rhodes','Han Soto','Tevis R. Marcum','Colin Walker','Jessy Hughes','Dana Gourrier','Matthew Rauch','Jim Klock','Jay Huguley','Nelson George','Isabella Rossellini','Wilson Bethel','Valarie Pettiford','Rob Steinberg','Jon Eyez','Ron Roggé','Leticia Jimenez','Casey McMurray','Vanessa Cloke','Miles Doleac','Christopher Berry','Ritchie Montgomery','Ato Essandoh','Jackson Beals','Sam Medina','Al Roker','Don Yesso','Kelsey Scott','Dean J. West','Darien Sills-Evans','Ladson Deyne','Alynda Lee Segarra','Billy Slaughter','Jonathan Batiste','Kim Ormiston'],
screenplay:['Eric Ellis Overmyer','David Simon','George Pelecanos','James Yoshimura','Chris Offutt','Chris Yakaitis','Mari Kornhauser','David Mills'],
production:['Joe Incaprera','Anthony Hemingway'],
camera:['Ivan Strasburg','Tim Ives','Ireneusz Hartowicz','Lisa Rinzler'],
cut:['Bill Pankow','Naomi Geraghty','Alex Hall','Malcolm Jamieson','Brian A. Kates','Kate Sanford','Matthew Booras'],
sound:['Andy Kris'],
scenography:['Chester Kaczenski'],
masks:['Paul Anthony Morris'],
costumes:['Ann Walters','Alonzo Van Wilson']},
{title:'The Master and Margarita',
titleCZ:'Mistr a Markétka',
year:2005,
runtime:'8h 20min',
episodeRuntime:'50min',
countries:['Russia'],
genres:['Drama','Mystery','Romance','Thriller'],
director:['Vladimir Bortko'],
actors:['Anna Kovalčuk','Alexandr Galibin','Oleg Basilašvili','Vladislav Galkin','Alexandr Adabašjan','Kirill Lavrov','Sergej Bezrukov','Alexandr Abdulov','Valerij Zolotuchin','Vasilij Livanov','Ljubomiras Laucevičius','Ilja Olejnikov','Vladimir Bortko','Dmitrij Nagijev','Valentin Smirnitskij','Alexandr Baširov','Julija Aug','Stanislav Sokolov','Alexandr Filippenko','Alexandr Pankratov-Čjornyj','Valentin Gaft','Natalja Surkova','Jurij Orlov','Andrej Urgant','Georgij Štil','Ivan Krasko','Viktor Smirnov','Vladimir Matvejev','Lev Jelisejev','Jurij Kovaljov','Lidija Dorotěnko','Valerij Grigorev','Semjon Strugačjov','Alexandr Ťutrjumov','Andrej Fedorcov','Olga Kirsanova-Miropolskaja','Galina Bokaševskaja','Anatolij Rudakov','Alexandr Ronis','Andrej Šarkov','Vachtang Beridze','Olga Nikolajeva','Sergej Treběsov','Taťjana Ju','Vano Miraňan','Roman Karcev','Sergej Mučenikov','Pavel Komarov','Jevgenij Merkurjev','Alexandr Šechtěl','Marina Černyšjova','Oleg Sorokin','Alexandr Ťurin','Vladislava Nazarova','Irina Osnovina','Vladimir Marjanov','Vadim Lobanov','Semjon Furman','Gali Abajdulov','Žanna Obuchova','Jurij Ovečkin','Valentin Bukin','Alexandr Volkov','Ljubov Tiščenko','Valerij Krupenikov','Dmitrij Poddubnyj','Sergej Lebeděv','Olga Kalmykova','Jelena Menšikova','Jevgenij Filatov','Anna Bagmet','Marina Jakovleva','Marija Oděgova','Jurij Oskin','Alexandr Slastin','Jekatěrina Novikova','Vladimir Kosmidajlo','Taťjana Tkač','Anatolij Konďubov','Pjotr Koroljov','Nikolaj Jakovlev','Taťjana Zacharova','Natalja Volkova','Galina Močalova','Vadim Smirnov','Natalja Vasiljeva','Alexandr Judin','Alexandr Rjazancev','Alexandr Jesaulov','Vladimir Sapunkov','Dmitrij Konokotov','Anton Zacharov','Vladimir Adžamov','Stanislav Fesjunov','Leonid Maksimov','Alexandr Lobanov'],
basedOn:['Michail Bulgakov'],
screenplay:['Vladimir Bortko'],
production:['Vladimir Bortko'],
music:['Igor Korněljuk'],
camera:['Valerij Mjulgaut'],
cut:['Leda Semyonova'],
sound:['Antonina Balašova'],
scenography:['Marina Nikolaeva'],
costumes:['Naděžda Vasiljeva']},
{title:'Full Metal Panic? Fumoffu',
titleCZ:'Fullmetal Panic? Fumoffu',
year:2003,
runtime:null,
episodeRuntime:'5h25min',
countries:['Japan'],
genres:['Animation','Action','Comedy','Romance'],
director:['Jasuhiro Takemoto','Tacuja Išihara','Norijuki Kitanohara','Jutaka Jamamoto','Jošidži Kigami','Tomihiko Ókubo','Masacugu Arakawa','Sumio Watanabe',"Džun'iči Sakata"],
actors:['Tomokazu Seki','Sacuki Jukino','Akio Ócuka','Mamiko Noto',"Šin'ičiró Miki",'Džunko Noda','Iššin Čiba','Júdži Ueda','Ken Narita','Majumi Asano','Mikuni Šimokawa','Noriaki Sugijama','Takeši Aono','Tošijuki Morikawa','Jukana','Hiroši Naka','Takaja Kuroda','Daisuke Góri','Tecu Inada','Tomoko Kaneda','Takahiro Mizušima','Jasuhiro Fudžiwara','Ken Takeuči','Šindži Kawada','Kazusa Murai','Rie Tanaka','Kóki Harasawa','Takajuki Kondó','Takehiro Murozono','Kacuhisa Hóki','Tomojuki Šimura','Kijotaka Furušima','Rio Nacuki','Takeharu Óniši','Takehiro Kojama','Micuru Mijamoto','Džun Hazumi','Mizuko Arima','Rjókiči Takahaši','Hiromi Konno','Jošino Ótori','Reiko Suzuki','Tomomiči Nišimura','Šiho Kikuči','Sawa Išige','Makoto Naruse','Nacuko Kuwatani','Akiko Hiramacu','Mičihiro Ikemizu','Masumi Asano',"Šin'ičiró Óta",'Jasuhiko Kawazu','Takajuki Okada','Motomu Kijokawa','Ricuo Sawa','Ikue Kimura',"Ken'iči Močizuki",'Daisuke Ono','Hisao Egawa','Tošihiko Nakadžima','Takeši Watabe','Júko Tačibana','Joširó Macumoto','Tamocu Nišiwaki','Tomoko Naka','Wasabi Mizuta','Masato Hidžikata','Macuo Macuo','Tošihide Cušija','Mičihiko Hagi','Mičitoši Seki','Akari Higuči','Tomoja Kawai','Kihačiro Uemura','Masatojo Tecuno','Sajuri Jošida','Mami Hamada','Ikuja Sawaki','Jasujuki Kase','Džunro Marujama','Kazutaka Išii','Džun Fukujama','Takaši Kubota','Mičiko Neja','Šigenori Sója','Mikako Takahaši','Čiaki Takahaši','Asami Imai'],
basedOn:['Šódži Gató','Dódži Šiki'],
screenplay:['Fumihiko Šimo','Šódži Gató','Jasuhiro Takemoto'],
production:['Toshio Hatanaka','Cuneo Takeči','Takatoši Hamano'],
music:['Tošihiko Sahaši'],
camera:['Rjúta Nakagami'],
cut:['Seidži Morita','Jukie Oikawa'],
sound:['Jóta Curuoka'],
scenography:['Džódži Unoguči']},
{title:'Ali G in da USAiii',
titleCZ:'Da Ali G Show',
year:2003,
runtime:null,
episodeRuntime:'12x30min',
countries:['UK','USA'],
genres:['Comedy','Talk-show'],
director:['James Bobin','Dan Mazer'],
actors:['Sacha Baron Cohen','Paris Hilton','Donald Trump','Buzz Aldrin','Janice Dickinson','Tara Reid','Gisele Bündchen','Jennifer Defrancisco','Gore Vidal','Leonard Maltin'],
screenplay:['Sacha Baron Cohen','James Bobin','Craig DiGregorio','Craig Thomas','Evan Goldberg','Seth Rogen','Dan Mazer','Anthony Hines','Jamie Glassman'],
music:['Erran Baron Cohen'],
camera:['Andy Hollis'],
cut:['James Thomas'],
costumes:['Jason Alper']},
{title:'Derry Girls',
titleCZ:'Holky z Derry',
year:2018,
runtime:'7h 58min',
episodeRuntime:'20-49min',
countries:['UK'],
genres:['Comedy'],
director:['Michael Lennox'],
actors:['Saoirse-Monica Jackson','Louisa Harland','Nicola Coughlan',"Jamie-Lee O'Donnell",'Dylan Llewellyn',"Tara Lynne O'Neill",'Siobhan McSweeney','Ian McElhinney','Kathy Kiera Clarke','Tommy Tiernan','David Ireland',"Leah O'Rourke",'Sophie Robertson','Peter Campion','Laurie Kynaston',"Brenock O'Connor",'Phillipa Dunne',"Nigel O'Neill",'Paul Mallon','Jay Duffy','Robbie Williams','Jamie Beamish','Judith Roddy','Eleanor Methven',"Ardal O'Hanlon",'Beccy Henderson','Aoife Hinds','Calam Lynch','Chris Lew Kum Hoi','Bronagh Waugh','Donna Traynor','Chris Robinson','Anthony Boyle','Niall Cusack','Ciaran Flynn','Bronágh Taggart','Amelia Crowley','Diona Doherty','Ryan McParland','Claire Rafferty','Liam Neeson','Desmond Eastwood','Martin Quinn','Vanessa Ifediora','Alex Gaumond'],
screenplay:['Lisa McGee'],
production:['Sam Pinnell'],
camera:['Oli Russell'],
cut:['Mark Williams','Lucien Clayton'],
sound:['Martin Harrison'],
scenography:['Nicola Moroney'],
costumes:['Cathy Prior','Carla Barrow']},
{title:'Baccano!',
titleCZ:'Baccano!',
year:2007,
runtime:'6h 40min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Action','Fantasy','Horror','Comedy'],
director:['Takahiro Ómori','Mamoru Kanbe','Džóhei Macuura','Jutaka Sató','Kijotaka Óhata','Kacumi Terahigaši','Hiroši Hara'],
actors:['Masakazu Morita','Acuši Imaruoka','Hirojuki Jošino','Masaja Onosaka','Daisuke Namikawa','Keidži Fudžiwara','Sajaka Aoki','Kenta Mijake','Ken Narita','Miki Itó','Norio Wakamoto','Susumu Čiba','Takehito Kojasu','Šizuka Itó','Chuck Huber','Ajahi Takagaki','Tomokazu Sugita','Nobutoši Kanna','Daisuke Sakaguči','Kappei Jamaguči','Jú Kobajaši','Marina Inoue','Saori Gotó','Čiwa Saitó','Hiroki Jasumoto','Šó Hajami','Sanae Kobajaši','Jošimicu Šimojama','Kóiči Sakaguči','Kazuhiro Nakata','Takajuki Sugó',"Masa'aki Cukada",'Micuru Mijamoto','Saburó Kamei','Tomohisa Asó','Tomomiči Nišimura','Seidži Sasaki','Tecuharu Óta','Kinrjú Arimoto','Nobuaki Kanemicu','Naomi Nagasawa','Akemi Kanda','Rjúnosuke Óbajaši','Tóru Furusawa','Kacumi Čó','Jukito Sóma','Šintaró Óhata','Cutomu Densaka','Taiten Kusunoki','Hiroši Jazaki','Hiroši Širokuma','Rjó Hirohaši','Tošitaka Hirano','Acuši Ono','Taketora','Nobujuki Kobuši','Jošinori Sonobe','Kunihiro Kawamoto','Riiči Nišimoto','Eri Jasui','Eriko Macušima','Sanri Okada'],
basedOn:['Rjógo Narita'],
music:['Jošimori Makoto'],
camera:['Jošihiro Sekija'],
cut:['Kazuhiko Seki'],
sound:['Jošikazu Iwanami'],
scenography:['Akira Itou']},
{title:'Gintama',
titleCZ:'Gintama',
year:2006,
runtime:'148h 28min',
episodeRuntime:'24-26min',
countries:['Japan'],
genres:['Animation','Action','Adventure','Drama','Fantasy','Comedy','Sci-Fi'],
director:['Šindži Takamacu','Jóiči Fudžita','Hirofumi Ogura','Čizuru Mijawaki','Ai Jošimura','Šinobu Sasaki','Tošija Šinohara','Tomojuki Kawamura','Tacuma Minamikawa','Keidži Kawakubo','Taró Kubo','Macuo Asami','Kazuo Mijake','Satoši Ósedo','Naoki Hišikawa','migmi','Hikaru Jamaguči',"Šin'ja Watada",'Hirokazu Jamada','Nanako Šimazaki','Fumihiro Jošimura','Kei Umabiki','Šúdži Mijahara','Jasuhiro Minami','Eri Osada'],
actors:['Tomokazu Sugita','Daisuke Sakaguči','Rie Kugimija','Kazuja Nakai',"Ken'iči Suzumura",'Susumu Čiba','Akeno Watanabe','Akio Ócuka','Ajako Kawasumi','Bin Šimada','Fumiko Orikasa','Ičiró Nagai','Iššin Čiba',"Džun'iči Suwabe",'Júdži Ueda','Kei Kobajaši','Keidži Fudžiwara','Ken Narita',"Ken'iči Ogata",'Kóiči Jamadera','Mamiko Noto','Masaja Onosaka','Majumi Asano','Miki Itó','Noriaki Sugijama','Norio Wakamoto',"Šin'ičiró Miki",'Takehito Kojasu','Takeši Aono','Teššó Genda','Tošihiko Seki','Unšó Išizuka','Wataru Takagi','Hiroši Kamija','Júki Ono','Madoka Jonezawa','Hikaru Midorikawa','Kódži Jusa','Tošijuki Morikawa','Akira Išida','Tošiko Sawada','Kendži Ucumi','Jutaka Aojama','Šóto Kašii','Tadaši Mijazawa','Kazunari Tanaka','La Salle Išii','Rikako Aikawa','Issei Futamata','Kendži Hamada','Micuki Saiga','Čafúrin','Makoto Jasumura','Jukana','Džunko Takeuči','Takahiro Sakurai','Satoši Hino','Šinpači Cudži','Jú Kobajaši','Kanae Itó','Mikako Takahaši','Júko Gotó','Hiro Šimono','Džódži Nakata','Aja Endó','Kana Ueda','Wataru Hatano','Majuki Makiguči','Fumihiko Tačiki','Kumiko Higa','Čiwa Saitó','Anri Kacu','Hiroši Janaka','Takaja Kuroda','Sumi Šimamoto','Júsaku Jara','Naoki Tacuta','Daisuke Góri','Šóko Cuda','Šó Hajami','Bandžó Ginga','Nobuo Tobita','Kózó Šioja','Takaši Nagasako','Kenta Mijake','Nobuaki Sekine','Takumi Jamazaki','Kacujuki Koniši','Gara Takašima','Hirojuki Jošino','Masako Džó','Rie Kanda','Sanae Kobajaši','Hadžime Iidžima','Čihiro Suzuki','Megumi Tojoguči','Nobujuki Hijama','Júko Sanpei','Masahiro Okazaki','Masaši Hirose'],
basedOn:['Hideaki Sorači'],
screenplay:['Akacuki Jamatoja','Kacujuki Sumisawa','Kento Šimojama','Mičiko Jokote','Deko Akao','Taku Kišimoto','Masaki Tačihara','Šú Macubara'],
production:['Tomojuki Saitó','Fukaši Azuma','Naoki Sasada','Noriko Kobajaši','Susumu Macujama','Šinnosuke Wada'],
music:['Audio Highs'],
camera:['Suguru Oidaira','Júki Teramoto'],
cut:['Rie Macubara','Megumi Učida','Takeši Sejama','Keiko Kadokawa','Hiromi Sasaki'],
sound:['Kacujoši Kobajaši','Šindži Takamacu'],
scenography:['Takajoši Fukušima','Júki Nomura','Nami Maniwa']},
{title:'Spin City',
titleCZ:'Všichni starostovi muži',
year:1996,
runtime:null,
episodeRuntime:'1996-2002',
countries:['USA'],
genres:['Comedy'],
director:['Andy Cadiff','Ted Wass','Lee Shallat Chemel','John Fortenberry','Thomas Schlamme','David S. Rosenthal'],
actors:['Michael J. Fox','Charlie Sheen','Richard Kind','Alan Ruck','Michael Boatman','Barry Bostwick','Connie Britton','Alexander Chaplin','Victoria Dillard','Heather Locklear','Jennifer Esposito','Carla Gugino','Lana Parrilla','Paula Marshall','Denise Richards','Lori Loughlin','Sam Robards','Queen Latifah','Jorge Garcia','Cynthia Watros','Krista Allen','Marlee Matlin','Lisa Ling','Kim Raver','Robert Maschio','Bonita Friedericy','John Scurti','Rena Sofer','Amanda Peet','Judah Friedlander','Sung Kang','Jeffrey Donovan','Michael Gaston','Sean Whalen','Landry Allbright','Mark Valley','C.S. Lee','Amy Poehler','Ken Marino','Kathryn Joosten','Chris Elwood','Sarah Shahi','Kevin Rankin',"Serah D'Laine",'Lorri Bagley','Marla Maples','Deborah Zoe','Ned Romero','Geneva Carr','Samm Levine','John Francis Daley','Noelle Beck','James Carville','Jerry Adler','Mark Nelson','Donald Trump','Raquel Welch','Marceline Hugot','Willie C. Carpenter','Bill Maher','Minae Noji','Shawn Christian','Jack McGee','Andy Daly','David Letterman','Sam Lloyd','Frank Santorelli','Beth Riesgraf','Vanessa Marcil','Carrie Preston','Deirdre Lovejoy','Alice Drummond','Tom McCarthy','Judith Light','Deborah Rush','Raymond Anthony Thomas','Marion McCorry','Mitch Rouse','Nancy Valen','Marin Hinkle','Marcia DeBonis',"Conan O'Brien",'Eric Stonestreet','Marcia Cross','Bree Turner','Peter Hermann','Staci Cross','André Gordon','Amanda Thorp','Mark Linn-Baker','Tracy Pollan','Jason Antoon','Derek Waters','Geoff Stults','Willie Garson','Michelle Phillips','Beth Littleford','Seth Meyers','Geoffrey Wigdor','Kathleen Chalfant'],
screenplay:['Gary David Goldberg','Bill Lawrence','Michelle Nader','David Ronn','Jay Scherick','Chris Henchy','David S. Rosenthal','Bonnie Sikowitz','Hadley Davis','Mark Torgove','Sebastian Jones','Brian Buckner','Stephen Godchaux','Tim Hobert','Jon Pollack','Tom Hertz','Sarah Dunn','Jeff Lowell','Jill Cargerman','Mike Royce','Bill Callahan','Philip Wen','Stacy Traub','Laurie Parres','Paul A. Kaplan','Michael Lisbe','Nate Reger'],
production:['Jeff Lowell','Stephen Godchaux','Michelle Nader','Andy Cadiff','Bill Lawrence','Tom Hertz','Tim Hobert','Jon Pollack','David Ronn','Jay Scherick','Chris Henchy','Mark Torgove','Walter Barnett','Philip Wen','Linda Nieber'],
music:['Danny Pelfrey'],
camera:['Mikel Neiers','Richard Brown','Richard Quinlan','George La Fountaine Sr.'],
cut:['Steven Rasch','Jay Scherberth','John Michel','Noel Rogers','Leo Papin'],
sound:['John W. Cook II','Craig Porter','Fred Tator','Jack Donato','Jesse Peck'],
scenography:['Cabot McMullen','Thomas Azzari','Rusty Lipscomb','Greg J. Grande','Diana White','Diane Yates','Andrew Baseman'],
masks:['Angel De Angelis','Lisa Ashley','Matiki Anoff','Bob Laden'],
costumes:['Molly Maginnis','Patricia Field','Sarah Lemire','Susan Michalek','Thomas Lee Keller','Craig Ames']},
{title:'Unbelievable',
titleCZ:'Neuvěřitelná',
year:2019,
runtime:'6h 29min',
episodeRuntime:'44-59min',
countries:['USA'],
genres:['Drama','Crime'],
director:['Lisa Cholodenko','Susannah Grant','Michael Dinner'],
actors:['Toni Collette','Merritt Wever','Kaitlyn Dever','Vanessa Bell Calloway','Dale Dickey','John Hartmann','Austin Hébert','Liza Lapira','Kai Lennox','Danielle Macdonald','Elizabeth Marvel','Omar Maskati','Scott Lawrence','Bridget Everett','Bill Fagerbakke','Eric Lange','Charlie McDermott','Brent Sexton','Jon Beavers','Shane Paul McGhie','Rif Hutton','Jessica Jones','Tate Ellington','David Futernick','Meghan Lennox','Frank Gerrish','Max Arciniega','Nicole J. Butler','Ashwin Gore','Charles Maceo',"Patricia Fa'asua",'Alyson Reed','Rebecca Field','Andrew Jacobs','Jayne Taini','Elena Campbell-Martinez','Rati Gupta','Annaleigh Ashford','Nick Searcy','Dale Godboldo','Darin Cooper','Aaron Staton','Melissa Jo Bailey','Trevor Lee Georgeson','Tim Martin Gleason','Jeff Marchelletta','Ashton Moio','Veronica St. Clair','Fay Wolf','Brooke Smith','Phil Biedron','Tom Amandes','John Billingsley','Blake Ellis','Jabree Webber','Grace Rowe','Kelly Marcus','Scott Bender','Kya Kruse','Olivia Scott Welch','Allius Barnes',"Tommy O'Brien",'Connor Tillman','Eva Fisher','Tess Aubert','Alison Jaye','Hendrix Yancey','Matisha Baldwin','Victoria Kelleher','Mike McColl'],
screenplay:['Michael Chabon','Susannah Grant','Ayelet Waldman','Jennifer Schuur','Becky Mode'],
production:['Katie DiMento'],
music:['Will Bates'],
camera:['Quyen Tran','Xavier Grobet','John Lindley'],
cut:['Jeffrey M. Werner','Keith Henderson'],
sound:['Tara A. Paul','Mark Linden','Kenn Fuller'],
scenography:['Julie Berghoff','Sophie Neudorfer','Brett McKenzie'],
masks:['Ketty Gonzalez'],
costumes:['Alonzo Van Wilson']},
{title:'The Mighty Boosh',
titleCZ:'Mighty Boosh',
year:2004,
runtime:'9h 27min',
episodeRuntime:'27-29min',
countries:['UK'],
genres:['Comedy','Fantasy','Musical'],
director:['Paul King','Steve Bendelack'],
actors:['Julian Barratt','Noel Fielding','Michael Fielding','Rich Fulcher','Matt Berry','Richard Ayoade','Simon Farnaby','Alice Lowe','Dan Clark','Peter Elliott','John Hopkins','Ramon Tikaram','Nicholas Burns','Victoria Wicks','Roger Daltrey','Steve Oram','Tom Meeten','Margaret John','Diva Zappa','Richard Glover','Jeanne Mockford','Tabitha Denholm','Lucy Montgomery','Peter Kyriacou','Dean Mitchell','Dee Plume','Kirk Gaitskell-Kendrick','Olly Ralfe','Sue Denim',"Barunka O'Shaughnessy",'David Westlake','Dianne Fielding','Dave Brown','Paul James','Gary Numan','Tony Devon','Dolly Wells','Faris Badwan','Martin Trenaman','James Bachman'],
screenplay:['Julian Barratt','Noel Fielding','Richard Ayoade'],
production:['Ted Dowd','Alison MacPhail','Spencer Millman'],
music:['Julian Barratt','Chris Tate'],
camera:['Rob Kitzmann','John Sorapure','John Simmons'],
cut:['Gary Dollner','Mark Everson','Alan Levy','Adam Windmill'],
sound:['Alex Thompson'],
scenography:['James Dillon','Dennis De Groot'],
masks:['Christine Cant'],
costumes:['Annie Hardinge','June Nevin']},
{title:"Garth Marenghi's Darkplace",
titleCZ:'Garth Marenghi: Nemocnice na kraji světa',
year:2004,
runtime:'2h 23min',
episodeRuntime:'23-24min',
countries:['UK'],
genres:['Horror','Comedy'],
director:['Richard Ayoade'],
actors:['Matthew Holness','Richard Ayoade','Matt Berry','Alice Lowe','Graham Linehan','Stephen Merchant','Julian Barratt','Noel Fielding','Paul King','Adrian Sturges','Richard Thomson','Matt Green','Spencer Brown'],
screenplay:['Richard Ayoade','Matthew Holness'],
production:['Charlie Hanson'],
music:['Andrew Hewitt'],
camera:['Martin Hawkins'],
cut:['Adam Windmill'],
sound:['Jamie Roden'],
scenography:['Dennis De Groot'],
costumes:['Leah Archer']},
{title:'Happy!',
titleCZ:'Happy!',
year:2017,
runtime:'12h 33min',
episodeRuntime:'39-48min',
countries:['USA'],
genres:['Drama','Comedy','Crime'],
director:['Brian Taylor','Wayne Yip','David Petrarca','Christopher Meloni','Joseph Kahn','Marianna Palka'],
actors:['Christopher Meloni','Patton Oswalt','Christopher Fitzgerald','Ritchie Coster','Lili Mirojnick','Patrick Fischler','Joseph D. Reitman','Gus Halper','Ashlie Atkinson','Donnetta Lavinia Grays','Antonia Rey','Debi Mazar','Morgan Wolk','Hannah Hodson','Laura Poe','Joe Perrino','Jerry Springer','Jennifer Kim','Anne Troup','Billy West','Gino Cafarelli','Dante Pereira-Olson','Michael Maize','Ruth Righi','Ashley Paige Albert','Paul Wight','Bob Turton','Daniel Sunjata','Jordan Gelber','Wass Stevens','Ann-Margret','Curtis Armstrong','Marylouise Burke',"'Weird Al' Yankovic",'Christopher Carley','Mandela Bellamy','Sebastian Chacon','Jacob Laval','Ben Cole','Stephanie Gibson','Katie Beth Hall','Alison Fraser','Emmy Elliott','Julian Lerner','Benny Elledge','Carly Sullivan','David Abeles','Luke Slattery','Anais Lee','Joe Feldman-Barros','Aubin Bradley','Catherine Ashmore Bradley','Tiffany Denise Hobbs','Lee R. Sellars'],
basedOn:['Grant Morrison','Darick Robertson'],
screenplay:['Grant Morrison','Brian Taylor','Patrick Macmanus','Noelle Valdivia','Peter Macmanus','Ken Kristensen','Matthew White','Evan T. Reilly','Ahmadu Garba','Ashley Michel Hoban'],
music:['Guillaume Roussel','Blair Mowat'],
camera:['Niels Alpert','Andrew Voegeli','Christopher LaVasseur','Todd Antonio Somodevilla'],
cut:['Erica Freed Marker','Ryan Denmark','Perri B. Frank','Alex Minnick'],
sound:['Nicholas Renbeck','Mariusz Glabinski','Greg Sextro'],
scenography:['Matthew Munn','Mylene Santos','James Bednark','Melanie J. Baker'],
masks:['Brenna McGuire','Michael Buonincontro',"Katherine O'Donnell"],
costumes:['Lorraine Calvert']},
{title:'Pistol',
titleCZ:'Pistol',
year:2022,
runtime:'5h 22min',
episodeRuntime:'46-58min',
countries:['USA'],
genres:['Drama','Music','Biographic'],
director:['Danny Boyle'],
actors:['Toby Wallace','Maisie Williams','Louis Partridge','Emma Appleton','Jacob Slater','Fabien Frankel','Anson Boon','Dylan Llewellyn','Thomas Brodie-Sangster','Freddie Wise','Sydney Chandler','Talulah Riley','Rory Alexander','Francesca Mills'],
screenplay:['Craig Pearce','Frank Cottrell Boyce'],
camera:['Anthony Dod Mantle'],
cut:['Jon Harris'],
sound:['Niv Adiri','Glenn Freemantle'],
scenography:['Kave Quinn','Stella Fox'],
masks:['Laura Allen'],
costumes:['Liza Bracey']},
{title:'Hannibal',
titleCZ:'Hannibal',
year:2013,
runtime:'27h 54min',
episodeRuntime:'41-44min',
countries:['USA'],
genres:['Crime','Thriller','Drama','Horror','Mystery'],
director:['Michael Rymer','Guillermo Navarro','Vincenzo Natali','David Slade','Tim Hunter','Peter Medak','John Dahl','James Foley','David Semel','Marc Jobst','Adam Kane','Neil Marshall'],
actors:['Hugh Dancy','Mads Mikkelsen','Caroline Dhavernas','Laurence Fishburne','Scott Thompson','Aaron Abrams','Gillian Anderson','Hettienne Park','Kacey Rohl','Lara Jean Chorostecki','Raúl Esparza','Vladimir Jon Cubrt','Katharine Isabelle','Eddie Izzard','Richard Armitage','Gina Torres','Rutina Wesley','Joe Anderson','Fortunato Cerlino','Cynthia Nixon','Tao Okamoto','Anna Chlumsky','Nina Arianda','Krista Patton','Alana Bridgewater','Michael Pitt','Daniel Kash','Glenn Fleshler','Mark Rendall','Torianna Lee','Dan Fogler','Jeremy Davies','Chris Diamantopoulos','Ellen Muth',"Mark O'Brien",'Jonathan Tucker','Zachary Quinto','Tom Wisdom','Seann Gallagher','John Benjamin Hickey','Molly Shannon','Jeremy Crutchley','Aidan Devine','Lance Henriksen','Cynthia Preston','Martin Donovan','Krista Bridges','Holly Deveaux','Ellen Greene','Maria del Mar','Severn Thompson','Shawn Doyle','Amanda Plummer','Chelan Simmons','Barry Flatman','Max White','Jason Blicker','Scott Anderson','Travis Hedland','Peyton Kennedy','Austin Macdonald','Patrick Garrow','Demore Barnes','Emily Klassen','Rob Norman','Paul Sturino','Julian Richings','Mía Maestro','Giorgio Lupano','Hilary Jardine','Ted Ludzik','Peter Spence','Michael James Regan','Brendee Green','Bernadette Couture','Kevin Whalen','Samuel Faraci','Pierre Simpson','Dwight Ireland','Devan Cohen','Aiden Glenn','Sara Sue Vallee','Graeme Jokic','Nola Martin','Joel Labelle','Craig Thomas','Toni Ellwand'],
screenplay:['Bryan Fuller','Thomas Harris','Steve Lightfoot','Scott Nimerfro','Jeff Vlaming','Chris Brancato','Andrew Black','Nick Antosca','Kai Wu','Jennifer Schuur','Don Mancini','Jesse Alexander','David Fury','Jim D. Gray','Ayanna Floyd','Jason Grote','Angelina Burnett','Tom de Ville','Angela LaManna','Helen Shang'],
production:['Karen Moore','Carol Dunn Trussell','Michael Wray'],
music:['Brian Reitzell'],
camera:['James Hawkinson','Karim Hussain','Michael Marshall'],
cut:['Michael Doherty','Art Jones','Stephen Philipson','Ben Wilkinson'],
sound:['Joe DeAngelis','Andre Perreault','Kenneth Kobett','Michael Colomby','Mike Woroniuk','Paul Shubat','Steve Foster','Scott Shepherd'],
scenography:['Matthew Davies','Patti Podesta','Rory Cheyne','Michele Brady'],
masks:['Verity Fiction','Patrick Baxter'],
costumes:['Christopher Hargadon']},
{title:'Life with Louie',
titleCZ:'Život s Louiem',
year:1995,
runtime:'13h 56min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Animation','Family','Comedy'],
director:['Bert Ring',"Matthew O'Callaghan"],
actors:['Louie Anderson','Edie McClurg','Justin Shenkarow','Miko Hughes','Sid Caesar','Mary Wickes','Gregg Berger','Joe Alaskey','Michael Horse','Jimmy Workman','Richard Libertini','Roger Rose','Norman Fell','Marc Robinson','Chris Young','Brian Doyle-Murray','James Greene','Aaron Michael Metchik','Liz Sheridan','James Murray','Miriam Flynn','Patrick Bristow','Lynne Marie Stewart','Robert Alan Beuth','Hamilton Camp','Jack Blessing',"Terrence 'T.C.' Carson",'Meagen Fay','Glenn Shadix','Tommy Hinkley','Barry Corbin','Troy Evans','Shelley Long','Jim Cummings','Joe Pantoliano','Justin Jon Ross','Xander Berkeley','Erik von Detten','Stuart Pankin','Richard Doyle','Eddie Deezen','Ken Hudson Campbell','Kenneth Mars','Soon-Tek Oh','Jess Harnell','Jim Belushi','Finola Hughes','Jon Polito','Paul McCrane','Edward Asner','Laurie Metcalf','Inga Swenson','Stephen Tobolowsky','Benjamin Kimball Smith','Debi Derryberry','Cleandre Norman','Art Chudabala','Kevin Ruf','Olivia Hack'],
screenplay:['David Silverman','Alex Taub','Robert Rabinowitz','Greg Cope White','Shawn Ryan',"Matthew O'Callaghan",'Matthew Negrete','Rich Halke','Ed Driscoll','Bernie Ancheta'],
production:['Russell P. Marleau'],
music:['John Zuker','Randall Crissman'],
cut:['Ron Fedele'],
sound:['Timothy J. Borquez','Timothy J. Garrity']},
{title:"The Devil's Hour",
titleCZ:'Ďáblova hodina',
year:2022,
runtime:'11h 54min',
episodeRuntime:'57-60min',
countries:['UK'],
genres:['Thriller'],
director:['Johnny Allan','Isabelle Sieb','Shaun James Grant'],
actors:['Jessica Raine','Peter Capaldi','Phil Dunster','Benjamin Chivers','Ramanique Ahluwalia','Meera Syal','Alex Ferns','Nikesh Patel','Kern Falconer'],
screenplay:['Tom Moran'],
production:['Ken Horn'],
music:['The Newton Brothers'],
camera:['Bjørn Ståle Bratberg','Stuart Biddlecombe'],
cut:['Mark Trend'],
sound:['Les Honess'],
scenography:['Tom McCullagh','Neesh Ruben'],
costumes:['Tudor George']},
{title:'The End of the F***ing World',
titleCZ:'The End of the F***ing World',
year:2017,
runtime:'5h 41min',
episodeRuntime:'18-25min',
countries:['UK'],
genres:['Drama','Crime','Thriller','Comedy','Adventure','Romance'],
director:['Jonathan Entwistle','Destiny Ekaragha','Lucy Forbes','Lucy Tcherniak'],
actors:['Jessica Barden','Alex Lawther','Steve Oram','Wunmi Mosaku','Gemma Whelan','Christine Bottomley','Navin Chowdhry','Jonathan Aris','Eileen Davies','Alex Sawyer','Barry Ward','Kierston Wareing','Alex Beckett','Geoff Bell','Kelly Harrison','Matt King','Felicity Montagu','Adam Brown','Juliet Cowan','Teresa Mahoney','Daniel Eghan','Earl Cave','Emma Appleton','Naomi Ackie','Nadine Marshall','Karl Collins','Josh Dylan','Nigel Boyle','Tilly Gaunt','Bronwyn Jones','Robert Whitelock','Tim Key','Paterson Joseph','Aoife Duffin','Divian Ladwa','Naomi Ackie','Jonathan Aris','Dorothy Peters-Lowe','Will Rogers','Jessica Barden','Alex Lawther','Nadine Marshall','Conor Clarke-McGrath','Jack Veal','Susannah Doyle'],
basedOn:['Charles S. Forsman'],
screenplay:['Charlie Covell','Jonathan Entwistle'],
production:['Jenny Frayn'],
music:['Graham Coxon'],
camera:['Justin Brown','Benedict Spence','Ben Fordesman'],
cut:['Celia Haining','Tony Kearns','Anna Dick'],
sound:['Richard Davey'],
masks:['Barrie Gower'],
costumes:['Emma Rees']},
{title:'Big Train',
titleCZ:'Velkovlak',
year:1998,
runtime:null,
episodeRuntime:'6h30min',
countries:['UK'],
genres:['Comedy'],
director:['Graham Linehan','Christopher Morris','Jonathan Gershfield'],
actors:['Kevin Eldon','Mark Heap','Simon Pegg','Phil Cornwell','Julia Davis','Rebecca Front','Nick Frost','Catherine Tate','Graham Linehan','Julia Deakin','Amelia Bullmore','Kevin Hudson','Tracy-Ann Oberman','Rita Davies','Rosie Day','Barbara Keogh','Geoffrey McGivern','Arthur Mathews','Simon Greenall'],
screenplay:['Graham Linehan','Rebecca Front','David Mitchell','Kevin Cecil','James Serafinowicz','Arthur Mathews'],
production:['Philip Clarke'],
music:['Willie Dowling'],
camera:['John Rosenberg'],
sound:['Alex Thompson'],
scenography:['Jo Sutherland','Dennis De Groot'],
costumes:['Lucia Santa Maria']},
{title:'Heartstopper',
titleCZ:'Srdcerváči',
year:2022,
runtime:'12h 40min',
episodeRuntime:'27-41min',
countries:['UK'],
genres:['Drama','Romance'],
director:['Euros Lyn'],
actors:['Joe Locke','Kit Connor','William Gao','Yasmin Finney','Tobie Donovan','Corinna Brown','Kizzy Edgell','Rhea Norwood','Sebastian Croft','Jenny Walser','Bradley Riches','Leila Khan','Olivia Colman','Cormac Hyde-Corrin','Fisayo Akinade','Nima Taleghani','Jack Barton','Momo Yeung','Joseph Balderrama','Chetna Pandya','Alan Turkington','Ashwin Viswanath','Evan Ovenell','Araloyin Oshunremi','Isabel Adomakoh-Young','Stephen Fry','Georgina Rich','Tabitha Byron','Hesper Holden','Jessal Kullar-Bell','Ella Maisy Purvis','Andrew Malik','Leonie Spilsbury','Frewyn Thursfield',"Jack O'Doherty",'Livia Nelson','Ashwin Vishwanath','Alice Oseman','Euros Lyn','Thibault de Montalembert','Rachael Stirling','Ash Self','Bel Priestley'],
basedOn:['Alice Oseman'],
screenplay:['Alice Oseman'],
production:['Zorana Piggott'],
music:['Adiescar Chase'],
camera:['Diana Olifirova','Simona Susnea'],
cut:['Andonis Trattos','Sofie Alonzi'],
sound:['Doug Cooper','Richard Pryke'],
scenography:['Tim Dickel','Maxwell Fine','Carys Beard','Sophie Lockwood'],
masks:['Sorcha Fisher','Dana Clarke'],
costumes:['Adam Dee']},
{title:"The Avengers: Earth's Mightiest Heroes",
titleCZ:'Avengers: Nejmocnější hrdinové světa',
year:2010,
runtime:'19h 15min',
episodeRuntime:'22-23min',
countries:['USA'],
genres:['Animation','Action','Sci-Fi','Fantasy'],
director:['Frank Paur','Boyd Kirkland','Sebastian Montes','Roy Burdine','Ciro Nieli','Vinton Heuck','Steven E. Gordon','Gary Hartle'],
actors:['Eric Loomis','Rick D. Wasserman','Fred Tatasciore','Brian Bloom','Wally Wingert','Phil LaMarr','Chris Cox','Nolan North','Robin Atkin Downes','Jim Ward','Kari Wuhrer','Gabriel Mann','Jonathan Adams','Dawn Olivieri','Graham McTavish','Tom Kane','Jeffrey Combs','Lance Henriksen','Nika Futterman','JB Blanc','Mark Hamill','Clancy Brown','Jennifer Hale','J.K. Simmons','Kevin Grevioux','Brent Spiner','Greg Ellis','Lacey Chabert','Vanessa Marshall','Daran Norris','Kevin Michael Richardson','Kari Wahlgren','Roger Craig Smith','Roger Craig Smith','Loren Lester','Bumper Robinson','Mick Wingert','Bumper Robinson','Alex Désert','Gary Anthony Williams','Christopher B. Duncan','Keith Ferguson','Steve Blum','Scott Menville',"Colleen O'Shaughnessey",'Troy Baker','Hakeem Kae-Kazim','Dee Bradley Baker','Elizabeth Daily','Laurent Vernin','John DiMaggio','Dwight Schultz','Keith Szarabajka','Kirk Thornton','Lance Reddick','Grey Griffin','Drake Bell','David Kaye','Jon Curry','David Kaufman','Cam Clarke','Danny Mann','Neil Ross','Quinton Flynn','Crispin Freeman','Lex Lang','Grant Moninger','Moira Quirk','Mary Elizabeth McGlynn'],
basedOn:['Jack Kirby','Joe Simon'],
screenplay:['Andy Lanning','Dan Abnett','Christopher L. Yost','Benjamin Townsend','Joelle Sellner','Joe Casey','Joe Kelly','Steven T. Seagle','Kevin Burke','Brandon Auman','Paul Giacoppo','Brian Reed','Andrew Robinson','Chris Wyatt','Eugene Son','Caroline Farah','Mark Parsons','James Felder','Danielle Wolff','Michael Ryan'],
production:['Dana C. Booton','Eric S. Rollman','Joshua Fine'],
music:['Guy Michelmore'],
cut:['Steve Ingram','Jonathan Polk','Robert Walz','George Rizkallah'],
sound:['Mike Draghi','Barry Lawson']},
{title:'Louie',
titleCZ:'Rozvedený se závazky',
year:2010,
runtime:'22h 42min',
episodeRuntime:'19-42min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Louis C.K.'],
actors:['Louis C.K.','Amy Landecker','Nick Di Paolo','Danny Burstein','Stephen Root','Hadley Delany','Christine Donlon','Pamela Adlon','Joan Rivers','Jim Norton','Megan Hilty','Ricky Gervais','Matthew Broderick','Ann Dowd','Elisabeth Hower','Dane Cook','Artie Lange','David Lynch','Chris Rock','Robert Kelly','F. Murray Abraham','Steven Wright','Will Brill','Teena Byrd','Adepero Oduye','J.B. Smoove','Ashlie Atkinson','Robin Williams','Kurt Metzger','Heléne Yorke','Godfrey','Stephen Badalamenti','Chelsea Peretti','Todd Barry','Marc Maron','Gene Jones','Demosthenes Chrysan','Miguel Gomez','Rick Crom','Sarah Silverman','Brooke Bloom','Gina Piersanti','Liz Holtan','Larisa Polonsky','Maria Menounos','Maria Thayer','Janie Brookshire','Yvonne Strahovski','Michael Drayer','Devin Druid','Parker Posey','Cary Woodworth','Jeremy Renner','Oona Laurence','Veanne Cox','Cory Nichols','Amir Blumenfeld','Susan Kelechi Watson','Christoph Manuel','Ashley Gerasimovich','Ali Reza','Louis Vanaria','Jim Florentine','Hannibal Buress','Connie Ray','Dan Ziskie','Heidi Armbruster','McKinley Belcher III','Niki Russ Federman','Lulu Wilson','Yul Vazquez','Michael Torpey','Stephen Hill','Yury Tsykun','Laurel Griggs','Clayton Dean Smith','Stivi Paskoski','Clara Wong','Denny Dillon','Susan Blommaert','Clark Middleton','Grant Shaud','Lauren Francesca','Vernon Chatman','Eszter Balint','David Wilson Barnes','Angel Rosa','Joe DeRosa','Allan Havey','Cliff Moylan','Genoveva Rossi','Mary Louise Wilson','Nick Kocher','Donna Hanover','Kaija Matiss','Sylvia Kauders','Ursula Parker','Gideon Adlon','Eunice Anderson','Don Pugsley'],
screenplay:['Louis C.K.','Pamela Adlon'],
production:['Vernon Chatman','Pamela Adlon','Steven Wright','John Skidmore'],
music:['Benjamin Wright','Reggie Watts','Matt Kilmer'],
camera:['Paul Koestner'],
cut:['Susan E. Morse','Louis C.K.','Doug Abel','Gina Sansom'],
scenography:['Amy Beth Silver','Steven Wright','Ted LeFevre'],
costumes:['Amy Andrews','Vicki Farrell','Leslie Schilling','Dana Covarrubias']},
{title:'Chicago Fire',
titleCZ:'Chicago Fire',
year:2012,
runtime:'176h 8min',
episodeRuntime:'40-43min',
countries:['USA'],
genres:['Action','Drama'],
director:['Joe Chappelle','Reza Tabrizi','Sanford Bookstaver','Jeffrey Nachmanoff','Jean de Segonzac','Jann Turner','Tom DiCillo','Steve Shill','Michael Brandt','Alex Chapple','Michael Slovis','Holly Dale','Arthur W. Forney','Dan Lerner','Alik Sakharov','Haze J.F. Bergeron III','Dru Anne Carlson','Gloria Muzio','Karen Gaviola','Darnell Martin','Rod Holcomb','Constantine Makris','David Rodriguez','Karyn Kusama','Daniel Sackheim','Eric Laneuville','John Hyams','Fred Berner','Matt Earl Beesley','Jono Oliver','Stephen Cragg','Bill Johnson','James Hanlon','Leslie Libman','Lin Oeding','Batan Silva','Olivia Newman','Mark Tinker','Paul McCrane','Milena Govich','Carl Seaton','Heather Cappiello','Brenna Malloy'],
actors:['Jesse Spencer','Taylor Kinney','Yuriy Sardarov','Christian Stolte','Eamonn Walker','Monica Raymund','Joe Minoso','Randy Flagler','David Eigenberg','Anne Lockhart','Anthony Ferraris','DuShon Monique Brown','Kara Killmer','Charlie Barnett','Lauren German','William Smillie','Jon Seda','Teri Reeves','Treat Williams','Robyn Coffin','Anita Nicole Brown','Jeff Hephner','Michelle Forbes','Jason Beghe','Sarah Shahi','Kathleen Quinlan','Nicole Forester','Shiri Appleby','Mike Starr','Brooke Nevin','Brittany Curran','Griffin Kane','CJ Adams','Dylan Baker','Sophia Bush','Mena Suvari','Tania Raymonde','Christine Evangelista','Melissa Ponzio','Laroyce Hawkins','Jesse Lee Soffer','Dustin Whitehead','Emily Peterson','David Aron Damane','Daisy Betts','Jake Weary','Marina Squerciati','Kirsten Fitzgerald','Maura Kidwell','Alexandra Metz','Mo Gallini','Amy Newbold','Jeffrey DeMunn','Meghann Fahy','Max Baker','Scott Jaeck','Irma P. Hall','Joanna Adler','Amanda Righetti','Mouzam Makkar','Edwin Hodge','Cody Sullivan','Karen Aldridge','Katherine Cunningham','Matt Trudeau','Joe Farina','Ben Marten','Karin Anglin','Zack Ward','Kelli Barrett','Kurt Naebig','Andy Ahrens','Richard Cabral','Scott Eastwood','Melissa Sagemiller','J.B. Smoove','Christopher Cousins','Nestor Serrano','Domenick Lombardozzi','Rachel Cerda','Larisa Polonsky','Vedette Lim','Elias Koteas','Jeff Lima','Molly Pan','W. Earl Brown','Chris Johnson','Amy Morton','Shane McRae','David Pasquesi','Alex Weisman','Gordon Clapp','Kenny Johnson','Laya DeLeon Hayes','Patrick John Flueger','Rebecca Spence','Serinda Swan','Kelli Giddish','James Russo','Summer Naomi Smart'],
screenplay:['Liz Alper','Ally Seibert','Jill Weinberger',"Michael A. O'Shea",'Andrea Newman','Michael Gilvary','Matt Olmstead','Tiller Russell','Hilly Hicks Jr.','Dick Wolf','Sarah Kucserka','Veronica West','Ryan Harris','Tim Talbott','Ian McCulloch','Marc Dube','Thania St. John','Andi Bushell','Mick Betancourt','Bryan Oh','Gwen Sigan','Roger Grant','Álvaro Rodríguez','Jamila Daniel','Derek Haas','Michael Brandt','Jeff Drayer','Matt Whitney','Ron McCants','Kimberly Ndombe','Elizabeth Sherman','Victor Teran'],
production:['Todd Arnow','Carla Corwin','John L. Roman','Hilly Hicks Jr.','Tim Deluca','Michael Gilvary',"Michael A. O'Shea",'Anastasia Puglisi'],
music:['Atli Örvarsson'],
camera:['Lisa Wiegand','Jayson Crothers','William R. Nielsen Jr.','Marc Ritzema','William Eichler'],
cut:["Megan D'Arco",'Micky Blythe','Oscar Rene Lozoya II','Etienne Des Lauriers','Michael Schweitzer','Adam Stilestein','Billy Fox','John David Buxton','Rick Tuber','Christine Yoon'],
sound:['Karol Urban','Adam Rooner','Todd Morrissey','Peter Reale','Jeffrey Kaplan','Keith Rogers'],
scenography:['Craig Jackson','John D. Kretschmer','Desi Wolff','Karen Frick','Stephanie Gilliam'],
masks:['Rosalind Jones-Crosby','Dominic Mango','Lillian Sakamaki','DeShawn Bowman','Heather Napolitano','David Ian Grant','Jessica Scheithe','Deborah K. Dee'],
costumes:['Susan Kaufmann','Mirela Rupic','Vivian Pavlos']},
{title:'Poldark',
titleCZ:'Poldark',
year:2015,
runtime:'41h 43min',
episodeRuntime:'55-60min',
countries:['UK'],
genres:['Drama','History'],
director:['Edward Bazalgette','Charlie Palmer','William Sinclair','William McGregor','Stephen Woolfenden','Joss Agnew','Brian Kelly','Philip Dudley'],
actors:['Aidan Turner','Eleanor Tomlinson','Ruby Bentall','Jack Farthing','Phil Davis','Crystal Leaity','Tristan Sturrock','Sabrina Bartlett','Beatie Edney','Alexander Arnold','Michael Culkin','Henry Garrett','Gruffudd Glyn','Warren Clarke','Kyle Soller','Will Mattos','Heida Reed','Matthew Rohman','Matthew Wilson','Pip Torrens','Ed Browning',"Gracee O'Brien",'Jason Squibb','Emma Spurgin Hussey','Richard Harrington','Luke Norris','John Hollingworth','Caroline Blakiston','Robin Ellis','Sebastian Armesto','Turlough Convery','Mark Frost','John Nettles','Hugh Skinner','Gabriella Wilde','Richard Dillane','Samuel Valentine','Patrick Ryecart','Richard McCabe','Amelia Clarkson','Julian Seager','Robert Dawson','Stuart Davidson','Sally Dexter','Robert Daws','Stuart McNeil','Harry Richardson','Tom York','John Hopkins','Sean Gilder','Elsa Mollien','James Wilby','Christian Brassington','Richard Hope','Freddie Watkins','Simon Meacock','Steve Walsh','Jake Blight','Rose Reynolds','Ciara Charteris','Alex Bartram','Will Merrick','Rebecca Front','Max Bennett','Ellise Chappell','Josh Whitehouse','Charlie Field','Peter Sullivan','Andrew Gower','Tim Dutton','Anthony Calf','Ben Lambert','Danny Kirrane','Sophie Simnett','Richard Durden','Charlie Field','Max Bennett','William Mannering','Jason Thorpe','Stephen Boxer','Konstanza Firth-Radford','Oscar Novak','Freddie Wise','Lily Dodsworth-Evans','Sofia Oxenham','Louis Davison','Madeleine Knight','Tim Seyfert'],
basedOn:['Winston Graham'],
screenplay:['Debbie Horsfield'],
production:['Eliza Mellor'],
music:['Anne Dudley'],
camera:['Adam Etherington','Cinders Forshaw','Sergio Delgado','Nick Dance','David Rom','James Aspinall','Simon Archer','Mark Waters'],
cut:['Adam Recht','Robin Hill','Jo Smyth','Mike Phillips','Tim Hodges','Anne Sopel','Helen Murphy','Adam Green'],
sound:['Blair Jollands','Glen Marullo','Gareth Bull'],
scenography:['Nandie Narishkin','Jeff Tessler','Ed Turner','Catrin Meredydd','Beckie Harvey','Dominic Roberts'],
masks:['Polly Campbell','Chloe Southall'],
costumes:['Marianne Agertoft','Howard Burden','Ros Little']},
{title:'John Adams',
titleCZ:'John Adams',
year:2008,
runtime:'8h 18min',
episodeRuntime:'62-91min',
countries:['USA'],
genres:['Drama','History','Biographic'],
director:['Tom Hooper'],
actors:['Paul Giamatti','Laura Linney','John Dossett','Stephen Dillane','Sarah Polley','Samuel Barnett','David Morse','Rufus Sewell','Justin Theroux','Tom Wilkinson','Danny Huston','Mamie Gummer','John Bedford Lloyd','Željko Ivanek','Ebon Moss-Bachrach','Jason Butler Harner','Christopher Clawson','Boris McGiver','Neal Huff','Cyril Descours',"Hugh O'Gorman",'Guy Henry','Matthew James Gulbranson','Jeremy Ambler',"Michael Hall D'Addario",'Julian Firth','Pip Carter','Eric Zuckerman','Ritchie Coster','Damien Jouillerot','Christiane Conil','Bertie Carvel','Dara Coleman','Judith Magre','John Keating','Madeline Taylor','Brennan Brown','Andrew Scott','Murray McArthur','Kevin Trainor','Mark Jeffrey Miller','Jean Brassard','Patrice Valota','Michael Countryman','Brett Gentile','Nicolas Vaude','Quentin Kerr','Alan Cox','Alex Draper','Afemo Omilami','Tom Mannion','Tripp Green','Bill Buell','John Curran','Sean Haggerty','Crispin Redman','Del Pentecost','Tim Parati','Jack Gwaltney','Jules Croiset','Sieger Sloot','Austin Zajur','Michael Tourek','Paul Fitzgerald','Jean-Hugues Anglade','Tom Hollander','Aaron Michael Lacey','Zak Orth','Kevyn Settle','Ed Jewett','Dominic Borrelli','Ginew Benton'],
basedOn:['David McCullough'],
screenplay:['Michelle Ashford','Kirk Ellis'],
production:['David Coatsworth'],
music:['Rob Lane','Joseph Vitarelli'],
camera:['Tak Fujimoto','Danny Cohen'],
cut:['Melanie Ann Oliver'],
sound:['Bob Beemer','Michael Minkler','Tony Lamberti'],
scenography:['Gemma Jackson','Kathy Lucas'],
masks:['Trefor Proud','Matthew W. Mungle','Loulia Sheppard'],
costumes:['Donna Zakowska']},
{title:'Dragon Ball',
titleCZ:'Dragon Ball',
year:1986,
runtime:'61h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Fantasy','Comedy'],
director:['Daisuke Nišio','Minoru Okazaki','Kazuhisa Takenouči','Júdži Endó','Jutaka Sató'],
actors:['Masako Nozawa','Džódži Janami','Hirotaka Suzuoki','Mami Kojama','Majumi Tanaka','Naoko Watanabe','Šigeru Čiba','Takeši Aono','Teššó Genda','Hiroši Ótake','Ičiró Nagai','Kaneto Šiozawa','Kazuko Sugijama','Micuko Horie','Šózó Iizuka','Kendži Ucumi','Ikuja Sawaki','Issei Futamata','Čikao Ócuka','Čieko Honda','Eiko Jamada','Tomiko Suzuki','Hiroko Emori','Juriko Jamamoto','Hidekacu Šibata','Sumi Šimamoto','Majumi Šó','Naoki Tacuta','Tošiko Fudžita','Kjóko Tongú','Daisuke Góri','Kódži Totani','Osamu Saka','Masato Hirano','Bandžó Ginga','Noriko Uemura','Kózó Šioja','Jasuo Muramacu','Hirohiko Kakegawa','Rjóiči Tanaka','Džunpei Takiguči','Rjúsei Nakao','Noriko Cukase','Ginzó Macuo','Kacue Miwa','Akiko Cuboi','Jumi Tóma','Kacudži Mori','Reiko Suzuki','Šin Aomori','Keiko Jamamoto','Masaharu Sató','Tošio Furukawa','Seiko Nakano','Masako Kacuki','Kóhei Mijauči','Mičihiro Ikemizu','Rjúdži Saikači','Jukimasa Kišino','Acuko Mine','Mahito Cudžimura','Mariko Mukai','Kazumi Tanaka','Theodore Lehmann','Toku Nišio','Takeši Watabe','Nana Jamaguči','Masaaki Ókura','Mičitaka Kobajaši','Juka Óno','Hirojuki Sató','Takedži Jošihara','Jóko Kawanami','Mariko Takigawa'],
basedOn:['Akira Torijama'],
screenplay:['Jošijuki Suga','Kacujuki Sumisawa','Takao Kojama','Jasuši Hirano','Keidži Terui','Naruhisa Arakawa'],
production:['Kendži Šimizu','Tokizó Cučija'],
music:['Šunsuke Kikuči'],
cut:["Šin'iči Fukumicu"],
sound:['Nobuhiro Komacu']},
{title:'Let Them Eat Cake',
titleCZ:'Ať jedí koláče',
year:1999,
runtime:null,
episodeRuntime:'3h30min',
countries:['UK'],
genres:['Comedy','History'],
director:['Christine Gernon'],
actors:['Dawn French','Jennifer Saunders','Lucy Punch','Alison Steadman','Elizabeth Berrington','Nicholas Rowe','Richard E. Grant','Louisa Lytton','Julian Rhind-Tutt','Crispian Belfrage','Tim Barker','Adrian Scarborough','James Greene','Margaret Whiting','Philip Voss','Adam James','Kathy Burke','Maggie Steed','Thomas Wheatley'],
screenplay:['Peter Learmouth'],
music:['Nick Bicât'],
cut:['Mark Lawrence'],
scenography:['Dennis De Groot'],
masks:['Lynda Armstrong'],
costumes:['Sarah Burns']},
{title:'Death Parade',
titleCZ:'Přehlídka smrti',
year:2015,
runtime:'4h 36min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Drama','Mystery','Psychology'],
director:['Juzuru Tačikawa','Džun Šišido',"Šin'ičiró Ušidžima",'Jósuke Hatta'],
actors:['Tomoaki Maeno','Asami Seto','Rumi Ókubo','Teššó Genda','Ajako Kawasumi','Kazuja Nakai','Keidži Fudžiwara','M.A.O','Mamoru Mijano','Miki Itó','Kóki Učijama','Čafúrin','Takahiro Sakurai','Rjóka Juzuki','Fumihiko Tačiki','Juna Taniguči','Jošimasa Hosoja','Jó Taiči','Hiroki Jasumoto','Šóta Jamamoto','Júko Kobajaši','Ikuko Tani','Činami Hašimoto','Lynn','Megumi Macumoto','Džundži Madžima','Acumi Tanezaki','Juriko Jamaguči','Rjóko Širaiši','Jošihito Sasaki','Hiroki Maeda','Masakazu Morita','Akane Fudžita','Šinnosuke Ogami','Rika Abe','Hironori Kondó','Hirojuki Honda','Čisa Júki','Izumi Čiba','Tošinari Fukamači','Hirómi Tamaru','Masajoši Sugawara','Kacujuki Miura','Marie Hatanaka','Jasujo Tomita','Misa Kató'],
screenplay:['Juzuru Tačikawa'],
production:['Hirojuki Inage','Tošio Nakatani','Šunsuke Nara'],
music:['Júki Hajaši'],
camera:['Júki Kawašita'],
cut:['Satoši Terauči','Naoki Kasai'],
sound:['Satoši Motojama'],
scenography:['Satoru Hirajanagi']},
{title:'The Memoirs of Sherlock Holmes',
titleCZ:'Vzpomínky na Sherlocka Holmese',
year:1994,
runtime:'5h 4min',
episodeRuntime:'50-52min',
countries:['UK'],
genres:['Crime','Drama','Mystery'],
director:['Peter Hammond','Sarah Hellings'],
actors:['Jeremy Brett','Edward Hardwicke','Rosalie Williams','Claudine Auger','Gary Cady','Ben Pullen','Caroline Blakiston','Mary Ellis','Peter Wyngarde','Michael Graham','Steve Toussaint','Barbara Young','John Gill','Jonathan Hyde','Susannah Harker','Hugh Bonneville','Roy Hudd','T.R. Bowen','Caroline John','Rowland Davies','Charles Gray','Nigel Planer','Anna Carteret','Christopher Guard','Kathleen Byron','Roger Ringrose','Kenneth Connor','John Hallam','Tom Chadbon','Joseph Long','Barbara Hicks','Jon Finch','Phyllis Calvert','Denis Lill','James Villiers',"Gavan O'Herlihy",'Helen Ryan','Richard Caldicot','Harry Landis','Michael Wynne','Ciarán Hinds','Joanna David','Deborah Findlay','Richard Dixon','Rachel Smith','Kerry Shale'],
basedOn:['Arthur Conan Doyle'],
screenplay:['Jeremy Paul','T.R. Bowen'],
music:['Patrick Gowers'],
camera:['Doug Hallows']},
{title:'Normal People',
titleCZ:'Normální lidi',
year:2020,
runtime:'5h 45min',
episodeRuntime:'22-34min',
countries:['UK'],
genres:['Drama','Romance'],
director:['Lenny Abrahamson','Hettie MacDonald'],
actors:['Daisy Edgar-Jones','Paul Mescal','Desmond Eastwood','Aislín McGuckin','Sarah Greene','Frank Blake','India Mullen','Eliot Salt','Eanna Hardwicke','Seán Doyle',"Fionn O'Shea",'Niamh Lynch','Meadhbh Maxwell','Leah McNamara','Clinton Liberty','Aoife Hinds','Liz Fitzgibbon','Megan McDonnell','Killian Filan','Kwaku Fortune','Leah Minto','Sebastian De Souza','Killian Coyle',"Laurence O'Fuarain",'Olga Wehrly','Martina Babišová','Slaney Power','Lauryn Canny','Tina Kellegher','Lancelot Ncube','Noma Dumezweni','Michael Power','Carl Austin','Sean Duggan','Eleanor Methven','Eileen Byrne','Bláithín Mac Gabhann','Domhnall Herdman'],
basedOn:['Sally Rooney'],
screenplay:['Alice Birch','Sally Rooney',"Mark O'Rowe"],
production:['Catherine Magee'],
music:['Stephen Rennicks'],
camera:['Suzie Lavelle','Kate McCullough'],
cut:['Nathan Nugent',"Stephen O'Connell"],
sound:['Michelle Cunniffe','Steve Fanagan'],
scenography:['Lucy van Lonkhuyzen'],
masks:['Tina Phelan','Belinda Roche','Sharon Doyle'],
costumes:['Lorna Marie Mugan']},
{title:'Victoria',
titleCZ:'Viktorie',
year:2016,
runtime:'22h 47min',
episodeRuntime:'46-95min',
countries:['UK'],
genres:['Drama','History'],
director:['Olly Blackburn','Tom Vaughan','Sandra Goldbacher','Lisa James Larsson','Geoffrey Sax','Jim Loach',"Daniel O'Hara",'Chloe Thomas','Delyth Thomas'],
actors:['Jenna Coleman','Daniela Holtz','Adrian Schiller','Catherine Flemming','Tommy Knight','Margaret Clunie','Anna Wilson-Jones','Eve Myles','Nell Hudson','Ferdinand Kingsley','Jordan Waller','Tom Hughes','Nigel Lindsay','Rufus Sewell','David Oakes','Peter Bowles','Basil Eidenbenz','Alex Jennings','Peter Firth','Robin Soans','Andrew Bicknell','Paul Rhys','Nichola McAuliffe','Samantha Colley','Robin McCallum','Patricia Winker','Richard Dixon','Tom Price','Simon Paisley Day','Michael Parkhouse','David Bamber','Daniel Donskoy','Alice Orr-Ewing','James Wilby','Terence Beesley','Annabel Mullion','Andrew Scarborough','Scott Arthur','Ryan Pope','Gertrude Thoma','Bruce Mackinnon','Cornell John','Clare Wille','Daisy Goodwin','Richard Price','Grant Crookes','Guy Oliver-Watts','Nicola-Jayne Wells','Leo Suter','Richard Braine','Bebe Cave','Diana Rigg','Craig Thomas Lambert','Emerald Fennell','Nicholas Agnew','Bruno Wolkowitch','Guillaume Rivaud','Martin Compston','Michael Maloney','Dan Fredenburgh','Andrew Havill','Denis Lawson','Andrew Neil','Carolin Stoltz','Hebe Beardsall','Peter Ivatts','Tilly Steele','Murray Fraser','Roger May','Olivia Popica','Catherine Steadman','Ben Lamb','Oliver Walker','Grant Gillespie','Michael Baral','Kate Fleetwood','Kerr Logan','Lily Travers','Vincent Regan','Nicholas Audsley','Laurence Fox','John Sessions','Sabrina Bartlett','Simon Gregor','Sam Swainsbury',"Róisín O'Neill",'Akbar Kurtha','Julian Firth','Clive Hayward','David Schaal','Edwin Thomas','Christopher Dunne','Gary Oliver','Hilton McRae','Andrew Byron','Tina Louise Owens','Ellen Evans','Harry McEntire','Ben Cartwright','Louisa Bay'],
basedOn:['A.N. Wilson'],
screenplay:['Daisy Goodwin','Guy Andrews'],
production:['David Boulter'],
music:['Ruth Barrett','Martin Phipps'],
camera:['John Lee','Rasmus Arrildt','Ed Rutherford','James Friend','Denson Baker','Andrew McDonnell'],
cut:['Jamie Pearson','Adam Recht','Ben Drury','Annie Kocur','Anthony Combes','Josh Cunliffe','Matthew Tabern','Simon Smith'],
sound:['Alessio Masi','Ashoke Ghosh','Gareth Bull'],
scenography:['Michael Howells','Stephen Daly','Tanya Bowd','E.J. Grainger','Julie Ann Horan','Kat Hale','Andrew Holden-Stokes'],
masks:['Amanda Finlay','Vanessa Summers','Emma Romans','Jules Greenan'],
costumes:['Michael Howells','James Keast','Rosalind Ebbutt']},
{title:'Mr. Pickles',
titleCZ:'Pan Nakládačka',
year:2013,
runtime:'5h 52min',
episodeRuntime:'11min',
countries:['USA'],
genres:['Animation','Comedy','Horror'],
director:['Will Carsola'],
actors:['Dave Stewart','Will Carsola','Frank Collison','Brooke Shields','Brett Gelman','John Ennis','Colton Dunn','Candi Milo','Kaitlyn Robrock','Frank Vincent','Christine Lakin','Tracy Morgan','Amy Sedaris','Andy Daly','John Waters','Joey Lauren Adams','Iggy Pop','Dave Foley','Pamela Adlon','Vivica A. Fox','Bob Bergen','Tom Kenny','Elaine Hendrix','Rob Zombie','Steve-O',"'Weird Al' Yankovic",'Andy Richter','Henry Rollins','Stephen Root','Barbara Goodson','Alex Désert','Mike L. Mayfield','Jay Johnston','Julia Prescott','Mark Rivers','Johnny Ryan','Jason Hightower','Carrie Keranen'],
screenplay:['Will Carsola','Dave Stewart','Shawn Simmons','Mike L. Mayfield'],
production:['Eric Binns'],
music:['Will Carsola'],
cut:['Will Carsola']},
{title:'Emma',
titleCZ:'Slečna Emma',
year:2009,
runtime:'3h 52min',
episodeRuntime:'58min',
countries:['UK'],
genres:['Comedy','Drama','Romance'],
director:["Jim O'Hanlon"],
actors:['Romola Garai','Christina Cole','Rupert Evans','Michael Gambon','Robert Bathurst','Tamsin Greig','Jodhi May','Jonny Lee Miller','Blake Ritson','Laura Pyper','Jefferson Hall','Annabel Mullion','Louise Dylan','Dan Fredenburgh',"Eileen O'Higgins",'Poppy Miller','Amy Loughton','Susie Trayling','Liza Sadovy'],
basedOn:['Jane Austen'],
music:['Samuel Sim'],
camera:['Adam Suschitzky'],
cut:['Mark Thornton'],
scenography:['Stevie Herbert'],
masks:['Karen Edwards'],
costumes:['Rosalind Ebbutt']},
{title:'Re:Zero - Starting Life in Another World',
titleCZ:'Re: Zero kara hadžimeru isekai seikacu',
year:2016,
runtime:'21h 15min',
episodeRuntime:'25-50min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy'],
director:['Hidejo Jamamoto','Masaharu Watanabe','Daisuke Takašima','Hirojuki Cučija','Daigo Jamagiši','Masahiro Šinohara','Naoko Takeiči','Kendži Takahaši','Taisuke Mamori'],
actors:['Rie Takahaši','Júsuke Kobajaši','Rie Murakawa','Jumi Učijama','Inori Minase','Činacu Akasaki','Mamiko Noto','Takehito Kojasu','Hideaki Tezuka','Jumiko Kobajaši','Júiči Nakamura','Kaito Išikawa','Jóko Hikasa','Kana Ueda','Šizuka Išigami','Jukijo Fudžii','Genki Muro','Hiroši Janaka','Nobuo Tobita','Tecu Inada','Akiko Kimura','Satomi Arai',"Ken'jú Horiuči",'Kendži Nomura','Jukari Tamura','Kaori Nazuka','Aimi Tanaka','Kanehira Jamamoto',"Džun'iči Janagita",'Haruki Išija','Hidejuki Umezu','Mugihito','Takuja Eguči','Tóru Ókawa','Kenta Sasa','Motomu Kijokawa','Marika Kóno','Daiki Jamašita','Hiroki Šimowada','Tomojuki Marujama','Júki Kuwahara','Hibiku Jamamura','Minami Šinoda','Eri Suzuki','Rjúiči Kidžima','Ikudži Nose','Maki Izawa','Itaru Jamamoto','Asuna Tomari','Takumu Mijazono','Aja Jamane','Kóki Kojasu','Takajuki Išii','Minami Takahaši','Reigo Jamaguči','Rjó Sugisaki','Mai Murakami','Naoko Komacu','Maaja Torigoe','Kenta Mijake','Kóiči Sóma','Keidži Fudžiwara','Juka Iguči','Jui Horie','Jutaka Aojama','Megumi Han','Maaja Sakamoto','Kóhei Amasaki','Nobuhiko Okamoto','Kósuke Toriumi','Takaši Narumi','Takuja Makimura','Juna Jošino','Rjósuke Higa','Džiró Saitó','Tacuhiro Kikuči','Júki Išikari','Júki Arai','Masaši Jamane','Kengo Kawaniši','Jukija Macui','Džun Fukazawa','Akira Kuwabara','Konomi Inagaki','Hodaka Mieno','Kacujuki Miura','Misa Kató','Takumi Motoi','Misaki Watanabe','Takuši Fudžikawa','Cubasa Mijoši','Akane Jabušima','Akira Išida','Čisa Cušima'],
basedOn:['Tappei Nagacuki'],
screenplay:['Masahiro Jokotani','Jošiko Nakamura','Eidži Umehara'],
production:['Jošikazu Benija'],
music:["Ken'ičiró Suehiro"],
camera:['Kentaró Minegiši'],
cut:['Hitomi Sudó'],
sound:['Džin Aketagawa'],
scenography:['Jošito Takamine']},
{title:'Gurren Lagann',
titleCZ:'Tengen toppa Gurren Lagann',
year:2007,
runtime:'10h 48min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Adventure','Sci-Fi','Comedy'],
director:['Hirojuki Imaiši','Masahiko Ócuka','Jasuhiro Geši','Osamu Kobajaši','Seung Hui Son','Hiroaki Tomita','Takajoši Morimija','Hiroši Kurimoto'],
actors:['Kana Asumi','Nobujuki Hijama','Marina Inoue','Šizuka Itó','Tecuja Kakihara','Kacujuki Koniši','Daiki Nakamura','Masaja Onosaka','Micuki Saiga','Rina Sató','Kišó Tanijama','Kana Ueda','Džúróta Kosugi','Kózó Dózaka','Teššó Genda','G.K. Bowes','Naruši Ikeda','Sajuri Jahagi','Džódži Nakata','Kenta Mijake','Masako Džó','Takahiro Mizušima','Kurumi Mamija','Akio Sujama','Haruhi Nanao','Noriko Šitaja','Kana Uetake','Kóiči Sakaguči','Kijojuki Janada','Takajuki Sugó','Hiroki Tóči','Takako Honda','Daisuke Kirii','Takaši Kondó','Tecuharu Óta',"Kei'iči Sonobe",'Kijoši Kawakubo','Čikara Ósaka','Jukito Sóma','Gó Šinomija','Norihisa Mori','Daiki Macubajaši','Takaši Mito','Takafumi Kawakami','Kazuja Kobajaši','Mari Tódó','Daisaku Šinohara'],
screenplay:['Kazuki Nakašima','Šódži Saeki','Masahiko Ócuka'],
production:['Eiiči Kamagata','Norio Jamakawa'],
music:['Taku Iwasaki'],
camera:['Tojonori Jamada'],
cut:["Džun'iči Uemacu",'Gó Sadamacu'],
sound:['Tóru Nakano'],
scenography:['Juka Hirama']},
{title:'Doctor in the House',
titleCZ:'Doktor v domě',
year:1969,
runtime:null,
episodeRuntime:'26x30min',
countries:['UK'],
genres:['Comedy'],
director:['Maurice Murphy'],
actors:['Barry Evans','Robin Nedwell','Geoffrey Davies','Martin Shaw','Jonathan Lynn','Helen Fraser','Patrick Connor','Renee Houston','Chris Gannon','Michael MacKenzie','Angharad Rees','Bernard Bresslaw','Graeme Garden','Ralph Michael','Harold Bennett','Joan Benham','Lucy Griffiths','Michael N. Harbour','Edna Doré','Lynn Dalby','Mike Grady','Patricia Shakesby','Angela Scoular','Alison Leggatt','Norman Mitchell','Eric Kent','Kathleen Heath','Arnold Diamond','Donald Bisset','Stanley McGeagh','Kenneth Thornett','Ernest Clark','Sally Douglas','Kenneth Benda','John Devaut','Arthur English','Neil Wilson','Jeanne Mockford','Totti Truman Taylor','Maurice Bush','Martin Miller','Peter Bathurst','Barry Justice','Yutte Stensgaard','John Barcroft','Graham Ashley','Keith Ashley','Julia Foster','Lionel Wheeler','Terence Woodfield','Winifred Sabine','Noel Hood','James Beck','Fred McNaughton','Petra Davies','Pamela Cundell','Sidney Vivian','George Layton','Nicholas Smith','Kurt Christian','Jonathan Cecil','Barbara Ogilvie','Mona Bruce','Michael Earl','Barrie Gosney','Maureen Pryor','Peter Bayliss','Bert Palmer','Royce Mills','Rosemary McHale','Andrew Jack','Jill Goldston','Anthony Jackson'],
screenplay:['David Sherlock','Bill Oddie']},
{title:'Fate/stay Night: Unlimited Blade Works',
titleCZ:'Fate/stay night: Unlimited Blade Works',
year:2014,
runtime:'11h 39min',
episodeRuntime:'24-51min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy','Thriller'],
director:['Takahiro Miura','Kei Cunemacu','Tacuki Ičinose','Júsuke Marujama','Takuja Nonaka','Tošijuki Širai','Takuró Takahaši','Masaši Takeuči'],
actors:['Ajako Kawasumi',"Džun'iči Suwabe",'Noriaki Sugijama','Acuko Tanaka','Jú Asakawa','Miki Itó',"Šin'ičiró Miki",'Tomokazu Seki','Daisuke Namikawa','Džunko Noda','Šizuka Itó','Nobutoši Kanna','Mai Kadowaki','Sajaka Óhara','Džódži Nakata','Džun Fukušima','Kana Ueda','Noriko Šitaja','Eri Nakao','Micuaki Madono','Masaki Terasoma','Šó Okumura','Fumie Mizusawa','Rie Nakagawa','Sakura Nakamura','Micuhiro Ičiki','Reina Ueda','Júki Takada','Ajumi Cudži','Ringo Aoba','Rikija Kojama','Miho Mijagawa','Minami Takahaši','Džun Hirose','Hiroši Kamija','Mičiru Juimoto','Daigo Fudžimaki','Haruhi Nanao','Rjúiči Kidžima','Teppei Ono','Konami Saitó','Micuki Nakae'],
screenplay:['Kazuharu Sató','Akira Hijama','Tacuki Ičinose'],
production:['Hikaru Kondó'],
music:['Hidejuki Fukasawa'],
camera:['Júiči Terao'],
cut:['Manabu Kamino'],
sound:['Jošikazu Iwanami'],
scenography:['Kódži Etó']},
{title:'Keeping Up Appearances',
titleCZ:'Zachovávat dekorum',
year:1990,
runtime:'21h 54min',
episodeRuntime:'28-58min',
countries:['UK'],
genres:['Comedy'],
director:['Harold Snoad'],
actors:['Patricia Routledge','Judy Cornwell','Geoffrey Hughes','Clive Swift','Josephine Tewson','David Griffin','Helen Dorward','Peter Cellier','Norman Lovett','Anna Bolt','Una Stubbs','Eileen Davies','Shirley Stelfox','David Janson','Marcia Warren','Tony Aitken','Andrew Bicknell','Jennifer Daniel','Jean Harvey','Rita Davies','Jessica James','Jack Smethurst','Preston Lockwood','Terrence Hardiman','Timothy Carlton','Michael Cochrane','Sue Lloyd','Ivor Danvers','Bruce Alexander','Derek Waring','Trevor Bannister','Bruce Montague','Charmian May','Geraldine Newman','Gretchen Franklin','Jean Anderson','Bernard Archard','Bernard Holley','Paul Williamson','Jeanne Mockford','Angus Lennie','Tricia Thorns','Michael Bilton','John Barrad','Helen Christie','Gerald Sim','Frederick Jaeger','Margaret Towner','John Arnatt','Ian Lavender','Richard Ashton','Leo Dolan','James Ottaway','Jonny Lee Miller','Len Lowe','Stuart Sherwin','Dinah Sheridan','Robert McBain','Anthony Dawes','Royce Mills','Barrie Gosney','Liz Daniels','Clovissa Newcombe','Nigel Davenport','Alice Macdonald','Rebecca Root','Anna Dawson','Jon Glover','John Phythian'],
screenplay:['Roy Clarke'],
production:['Harold Snoad'],
scenography:['Tim Gleeson','Steve Wright'],
masks:['Ann Fenton']},
{title:'American Horror Story',
titleCZ:'American Horror Story',
year:2011,
runtime:'100h 59min',
episodeRuntime:'34-74min',
countries:['USA'],
genres:['Drama','Horror','Sci-Fi','Thriller'],
director:['Bradley Buecker','Ryan Murphy','Angela Bassett','Jeremy Podeswa','Michael Rymer','Alfonso Gomez-Rejon','Howard Deutch','Michael Uppendahl','Craig Zisk','Michael Lehmann','David Semel','Michael Goi','Loni Peristere','Anthony Hemingway','Jennifer Lynch','Marita Grabiak','Nelson Cragg','John Scott','Tim Hunter','Miguel Arteta','Elodie Keene','Gwyneth Horder-Payton','Alexis Ostrander','Kevin R. Hershberger','Liza Johnson','Maggie Kiley','Barbara Brown','Sarah Paulson','Sheree Folkson','Rachel Goldberg','Jennifer Arnold','Evan Peters','John J. Gray','Mary Wigmore','Liz Friedlander','Axelle Carolyn','Max Winkler','Tessa Blake','Laura Belsey','Paris Barclay','Our Lady J','Jessica Yu'],
actors:['Sarah Paulson','Evan Peters','Lily Rabe','Jessica Lange',"Denis O'Hare",'Kathy Bates','Angela Bassett','Frances Conroy','Taissa Farmiga','Emma Roberts','Adina Porter','Jamie Brewer','Wes Bentley','Lady Gaga','Cheyenne Jackson','Matt Bomer','Zachary Quinto','Finn Wittrock','Billie Lourd','Gabourey Sidibe','Chloë Sevigny','Dylan McDermott','Connie Britton','Naomi Grossman','James Cromwell','Cuba Gooding Jr.','John Carroll Lynch','Danny Huston','Alexandra Breckenridge','Joseph Fiennes','Alison Pill','Lizzie Brocheré','Billy Eichner','Leslie Grossman','Michael Chiklis','Mare Winningham','Patti LuPone','Grace Gummer','Jenna Dewan','Adam Levine','Kate Mara','Clea DuVall','Neil Patrick Harris','Colton Haynes','Christine Ebersole','Lance Reddick','Ian Anthony Dale','Lara Grice','Sam Malone','Lauren Gros','Danny Cosmo','Kesha Bullard','Sharon Garrison','Ritchie Montgomery','Jennifer Lynn Warren','Kim Collins','Riley Voelkel','Josh Hamilton','James DuMont','Dana Gourrier','Jim Gleason','Sir Maejor','Bob Walker','Charley Vance','Sadarias Harrell','Michael Cristofer','Leslie Jordan','John L. Armijo','P.J. Boudousqué','Matthew James','Robin Bartlett','Alexander Dreymon','Carol Sutton','Molly Conarro','Grey Damon','Lola Phillips','Stevie Nicks','Michelle Page','Ameer Baraka','LaJessie Smith','Dane Rhodes','Lance E. Nichols','Elizabeth Bond','Sal Landi','Nolan Gross','Mark Margolis','Barbara Tarbuck','Matthew John Armstrong','Lara Harris','Tara Holt','Franka Potente',"Erin Allin O'Reilly",'Lily Knight','Jill Marie Jones','Devon Graye','Paul Tei','Marc Aden Gray','John Aylward','Jenny Wade','Jen Drohan'],
basedOn:['Ryan Murphy','Brad Falchuk','Danielle Vega'],
screenplay:['Ryan Murphy','Jennifer Salt','James Wong','Jessica Sharzer','Tim Minear','Douglas Petrie','John J. Gray','Crystal Liu','Ned Martel','Akela Cooper','Todd Kubrak','Brad Falchuk','Adam Penn','Manny Coto','Joshua Green','Asha Michelle Wilson','Jay Beattie','Dan Dworkin','Kristen Reidel','Reilly Smith','Charlie Carver','Our Lady J','Halley Feiffer'],
production:['Chip Vucelich','Alexis Martin Woodall','Patrick McKee','Joe Incaprera','Robert M. Williams Jr.','Ned Martel','Lou Eyrich','Crystal Liu','Eryn Krueger Mekash','Todd Nenninger','Melissa Wylie','Eric Kovtun','Evan Peters','Todd Kubrak','Reilly Smith','Tanase Popa','Sara Stelwagen','Charlie Carver','Karl Frankenfield','Franzis Muller'],
music:['James S. Levine','Mac Quayle'],
camera:['Michael Goi','Nelson Cragg','John Aronson','James Chressanthis','Christopher Baffa','Joaquín Sedillo','Jesse M. Feldman','Tom Houghton','Chris Manley','Gavin Kelly','Andrew Mitchell','Stanley Fernandez Jr.','Andrei Bowden-Schwartz','Tim Norman'],
cut:['Justin Krohn','Joe Leonard','Bradley Buecker','Adam Penn','Stewart Schill','Kaja Fehr','Robert Komatsu','Regis Kimble','Lizzy Calhoun','Micky Blythe','Chris A. Peterson','Adriaan van Zyl','John Petaja','Fabienne Bouville','Shelly Westerman','Peggy Tachdjian','Ken Ramos','Danielle Wang','Sean Aylward','Travis Weaver','Julia Franklin','Thomas Mitchell','Erick Fefferman','Lisa Trulli','Franzis Muller','Paul E. Alderman'],
sound:['Vicki Lemar','Joe Earle','Andrew Spencer Dawson','Christian Buenaventura','R. Russell Smith','William Freesh','Albert Ibbotson','Kenneth Kobett','Alan Decker','Ed Carr','Gary Megregian','Jim Fitzpatrick','Sherry Klein','Marco Augusto Comba','Doug Andham','Sean McCormack','Sean Rush'],
scenography:['Beth A. Rubino','Mark Worthington','Andrew Murdock','Giles Masters','Val Wilt','Chloe Arbiture','Claire Kaufman','Jeffrey Mossa','Kathy Orlando','Brandi Kalish','Jonathan Bell','Matthew Flood Ferguson','Adam Karavatakis','Rich Murray','Jamie Walker McCall','Durell Lefler'],
masks:['Valerie Jackson','Dawn Victoria Dudley','David LeRoy Anderson','Melody White','Eryn Krueger Mekash','Stacy Bisel','Jack Firman','Justin Raleigh','Sarah Tanno','Frederic Aspiras','Stacey K. Black','Amy Wood','Kevin Kirkpatrick','Kevin Kirkpatrick','Debra-Lee Davidson','Christopher Allen Nelson','Robert C. Mathews III','Dnelle Almanza','Taylor Bennett','Roxxi Dott','Milagros Medina-Cerdeira'],
costumes:['Chrisi Karvonides-Dushenko','Lou Eyrich','Mark Zunino','Helen Huang','Sarah Evelyn','Rudy Mance','Paula Bradley','Abby Walton','Jacqueline Demeterio']},
{title:'Sense8',
titleCZ:'Osmý smysl',
year:2015,
runtime:'24h 57min',
episodeRuntime:'46-152min',
countries:['USA'],
genres:['Drama','Mystery','Sci-Fi','Thriller'],
director:['Lilly Wachowski','Lana Wachowski','James McTeigue','Tom Tykwer','Dan Glass'],
actors:['Terrence Mann','Du-na Bae','Jamie Clayton','Tina Desai','Tuppence Middleton','Max Riemelt','Miguel Ángel Silvestre','Brian J. Smith','Aml Ameen','Eréndira Ibarra','Freema Agyeman','Purab Kohli','Anupam Kher','Darshan Jariwala','Ari Brickman','Naveen Andrews','Daryl Hannah','Alfonso Herrera','Christian Oliver','Joe Pantoliano','Andre Bellos','Ron Jeremy','Chiron Elias Krase','Max Mauff','Joseph Mawle','Matt Stokoe','Steven Wiig','Mita Vashisht','Sylvester Groth','Wanja Götz','Rainer Reiners','Frank Dillane','Harvey Friedman','Jorres Risse','Kyle T. Heffner','Mukani Njiru','Raúl Méndez','Chris Theisinger','Bernhard Schütz','Ron Dean','Luis Ignacio Urive Alvirde','Lilja Nótt Þórarinsdóttir','Þorsteinn Bachmann','Georg Ebinal','Sammy Scheuritzel','Rocio Garcia','Arantza Ruiz','Lilja Þórisdóttir','Lucas Jade Zumann','Hannes Óli Ágústsson','Birgitta Sigursteinsdóttir','Tristan Gribbin','Ester Sveinbjarnardóttir','Jesus N. Jimenez','Howie Johnson','Emily Matheny','Toby Onwumere','Danny Goldring','Amy Mußul','Irene Azuela','Kyeong-yeong Lee','Georg Tryphon','Dong-seok Ma','Hannah Leigh','In-pyo Cha','Yeo-jeong Yoon','Lára Jóhanna Jónsdóttir','Mansi Dovhal','Priya Bhatija','Antoine McKay','Stefán Hallur Stefánsson','Joe Toedtling','Kurt Naebig','Lars Eidinger','Clive Wood','Annabelle Dowler','Satya Bhabha','Aidan McArdle','Valeria Bilello','Tony Dalton','Cecilia Suárez','Joseph Wairimu','Max Huang','Kick Gurry','Marco Treviño','Sikander Kher','Martin Wuttke','Elsaphan Njora','Sylvester McCoy','Eduardo Semerjian','Rainer Sellien','Robert Maaser','Vanessa Ross','Rafael Sánchez Navarro','Leticia Huijara','Juan Pablo Castañeda','Noemi Besedes','Dolores Heredia','Joshua Grothe','Vicki Saputo'],
screenplay:['J. Michael Straczynski','Lana Wachowski','Lilly Wachowski','Aleksandar Hemon'],
production:['Alex Boden','Marcus Loges'],
music:['Johnny Klimek','Tom Tykwer','Gabriel Isaac Mounsey'],
camera:['John Toll','Danny Ruhlmann'],
cut:['Joseph Jett Sally','Joe Hobeck','Fiona Colbeck'],
sound:['Eric Warren Lindemann','Tom Ozanich','Tom Marks','Stevie Haywood'],
scenography:['Hugh Bateup','Christopher Marsteller','Lisa Wolff','Claudia Parker','Raffaella Giovannetti','Jessie Haddad','Roberto Caruso','Katharina Birkenfeld','Stephan O. Gessler','Choi Ho Man'],
masks:['Emilia Seifert','Jeremy Woodhead','Marta Roggero','Dominic Mango','Suzi Ostos'],
costumes:['Lindsay Pugh']},
{title:'Escape at Dannemora',
titleCZ:'Útěk z vězení v Dannemoře',
year:2018,
runtime:'7h 6min',
episodeRuntime:'49-96min',
countries:['USA'],
genres:['Drama'],
director:['Ben Stiller'],
actors:['Patricia Arquette','Paul Dano','Benicio Del Toro','Eric Lange','Jeremy Bobb','Dominic Colón','Michael Beasley','Antoni Corone','Michael Imperioli','John W. Iwanonkiw','Daniel James','David Morse','Jim Parrack','Amy Stiller','Joy Sudduth','Harry Sutton Jr.','Guy Boyd','Calvin Dutton','Robert Neary','Bonnie Hunt','Jean Brassard',"Alana O'Brien",'Frank Deal','Skipp Sudduth','Joe Lisi','Nikki M. James','Charlie Hofheimer','Hani Furstenberg','Leo James Davis','Shadow C. LaValley','Micah Stock','Jermaine Wells','Brian Donahue','Sarah Jes Austell','Jerry Wood','Anthony Mangano','Amber Gray','Johanna Day','Libby Winters','Enzo Cellucci',"Harry O'Reilly",'Patrick H. Fox','Ken Holmes','Edward Carnevale','Guerrin Gardner','Daniel Johnson','Anthony Barrile','Thomas Hatz'],
screenplay:['Jerry Stahl','Brett Johnson','Michael Tolkin'],
production:['Adam Brightman'],
music:['Edward Shearmur'],
camera:['Jessica Lee Gagné'],
cut:['Geoffrey Richman','Malcolm Jamieson'],
sound:['Schavaria Reeves','Jacob Ribicoff','Bob Chefalas'],
scenography:['Mark Ricker'],
masks:['Valerie Gladstone-Appel','Bernadette Mazur','Rachel Geary','Alyssa Battersby'],
costumes:['David C. Robinson']},
{title:'Tokyo Vice',
titleCZ:'Tokyo Vice',
year:2022,
runtime:'15h 45min',
episodeRuntime:'54-64min',
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Michael Mann','Destin Daniel Cretton','Josef Kubota Wladyka','HIKARI','Alan Poul'],
actors:['Ansel Elgort','Ken Watanabe','Rachel Keller','Ella Rumpf','Rinko Kikuči','Hideaki Itó','Šó Kasamacu','Tomohisa Jamašita','Šun Sugata','Masato Hagiwara','Ajumi Tanida','Kósuke Tojohara','Noémie Nakai','Takaki Uda','Masayoshi Haneda','Eugene Nomura','Jóhei Macukado','Masana Bokuzó','Ken Jamamura','Ajumi Itó','Hanna Komacu','Fumija Kimura','Danny Burstein','Jessica Hecht'],
basedOn:['Jake Adelstein'],
screenplay:['J.T. Rogers','Jessica Brickman','Adam Stein','Karl Taro Greenfeld','Arthur Phillips','Naomi Iizuka','Brad Kane'],
production:['Alex Boden','Satch Watanabe','Brad Carpenter','Jessica Brickman','Ralph Winter','Arthur Phillips','Todd Brown'],
music:['Danny Bensi','Saunder Jurriaans'],
camera:['Daniel Satinoff','John Grillo','Diego García'],
cut:['Ana García','Aaron Kuhn','Michael Berenbaum','Benjamin Rodriguez Jr.','Tad Dennis','Mako Kamitsuna','David Rosenbloom','John M. Valerio'],
sound:['Ryotaro Harada','Eric Hirsch'],
scenography:['Jeff Mann','Kikuo Ohta','Raymond Talley'],
masks:['Kathrine Gordon'],
costumes:['Kumiko Ogawa']},
{title:'Tom and Jerry Tales',
titleCZ:'Příběhy Toma a Jerryho',
year:2006,
runtime:null,
episodeRuntime:'10h23-25min',
countries:['USA'],
genres:['Animation','Comedy','Family'],
director:['Spike Brandt','Tony Cervone','Tim Maltby','Douglas McCarthy','Neal Sternecky','T.J. House','Frank Molieri'],
actors:['Don Brown','Sam Vincent','Michael Donovan','Ian James Corlett','Janyse Jaud','John Payne','Maryke Hendrikse','Louis Chirillo','Scott McNeil','Ben Diskin','Matt Hill'],
screenplay:['Eric Shaw','Earl Kress','Christopher Keenan','T.J. House','Matt Wayne','Joseph Purdy','Tom Minton'],
production:['Frank Molieri','Jennifer Pelphrey','Tom Minton'],
music:['Gordon Goodwin'],
cut:['Ken Solomon','Rob Desales'],
sound:['John Hegedes','Robert Hargreaves']},
{title:'Maid Sama!',
titleCZ:'Kaičó wa Maid-sama!',
year:2010,
runtime:'10h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Comedy','Romance'],
director:['Hiroaki Sakurai','Daisuke Takašima','Tamaki Nakacu','Takaši Ikehata',"Šin'ja Watada",'Makoto Sokuza','Čikajo Nakamura','Kei Umabiki'],
actors:['Ajumi Fudžimura','Nobuhiko Okamoto','Micuhiro Ičiki','Takuma Terašima','Jošimasa Hosoja','Aki Tojosaki',"Ken'iči Suzumura",'Kendži Nodžima','Ajako Kawasumi','Sumire Morohoši','Júki Ono','Tecuja Kakihara','Tomoaki Maeno','Jú Kobajaši','Kana Ueda','Majuki Makiguči','Sanae Kobajaši','Marija Ise','Kósuke Toriumi','Kazujuki Okicu','Harumi Sakurai','Kana Asumi','Takaši Óhara','Júko Gibu','Manabu Sakamaki','Hiromi Igaraši','Jui Ogura','Hiroki Šimowada','Jukito Sóma','Sajuri Hara','Takuma Suzuki','Ajako Uemura','Ajumi Jonemaru','Sakura Jošioka','Kóiči Bandó','Miki Makiguči','Hideki Nakaniši','Kendži Takahaši','Kazujoši Šiibaši','Takuja Kurijama','Fumihiro Okabajaši'],
screenplay:['Reiko Jošida','Masaharu Amija','Masahiro Jokotani','Mamiko Ikeda'],
production:['Tomohiro Fujita','Akio Macuda'],
music:['Wataru Maeguči'],
camera:['Jutaka Kurosawa'],
cut:['Masahiro Gotó'],
sound:['Satoši Motojama'],
scenography:['Šičiró Kobajaši']},
{title:'Coffee Prince',
titleCZ:'Kávový princ',
year:2007,
runtime:'17h 31min',
episodeRuntime:'58-66min',
countries:['South Korea'],
genres:['Romance','Comedy'],
director:['Yoon-jeong Lee'],
actors:['Eun-hye Yoon','Yoo Gong','Seon-gyoon Lee','Jeong-ahn Chae','Yeong-ok Kim','Chang-wan Kim','Ja-ok Kim','Han-wi Lee','Il-hwa Choi','Eon Lee','Jae-wook Kim','Dong-wook Kim','Ye-in Han','Myeong-ryeol Nam','Hye-ra Bae','Ji-yoo Yoon','Jeong-min Kim','Eung-sil Lee'],
basedOn:['Sun-mi Lee'],
screenplay:['Hyeon-joo Jang','Jung Ah Lee']},
{title:'Harley and the Davidsons',
titleCZ:'Harley a Davidsonovi',
year:2016,
runtime:null,
episodeRuntime:'3x90min',
countries:['USA'],
genres:['Biographic'],
director:['Ciaran Donnelly'],
actors:['Robert Aramayo','Michiel Huisman','Bug Hall','Mitchell Mullen','Gabriel Luna','Alex Shaffer','Mish Boyko','Jessica Camacho','Christopher Dunne','Louisa Harland','Stephen Hogan','Robbie Jarvis','Jeff Mash','Alistair Petrie','Bobby Schofield','Joe McGann','Richard Cordery','Robin McCallum','Philip Brodie','Annie Read','Alex Felton','Stephen Rider','Daniel Coonan','Rufus Wright','Giulia Nahmany','Stewart Alexander','Bryan Jardine','Jim Liu',"Essa O'Shea",'Olivia Nita','Ovidiu Niculescu','Caolan Byrne'],
screenplay:['Evan Wright'],
cut:['Oral Norrie Ottey'],
sound:['Dragos Stanomir','Nigel Squibbs'],
scenography:['Tom Conroy','Gina Calin']},
{title:'Supernatural',
titleCZ:'Lovci duchů',
year:2005,
runtime:'247h 25min',
episodeRuntime:'29-60min',
countries:['USA'],
genres:['Horror','Drama','Mystery','Thriller','Fantasy','Comedy'],
director:['Kim Manners','Robert Singer','David Nutter','J. Miller Tobin','Mike Rohl','Charles Beeson','Guy Norman Bee','Philip Sgriccia','Steve Boyum','Chris Long','Whitney Ransick','Adam Kane','Tim Iacofano','Eric Kripke','James L. Conway','Ben Edlund','Rachel Talalay','Allan Kroeker','John Badham','Cliff Bole','Nina Lopez-Corrado','Thomas J. Wright','John F. Showalter','Eduardo Sánchez','Robert Duncan McNeill','David Jackson','Ken Girotti','Paul Shapiro','Tony Wharmby','Jensen Ackles','Rashaad Ernesto Green','Serge Ladouceur','Bradford May','Richard Speight Jr.','P.J. Pesce','Jeff Woolnough','Rick Bota','Rod Hardy','Jan Eliasberg','David Barrett','Jeannot Szwarc','Tim Andrew','Stefan Pleszczynski','Jerry Wanek','John MacCarthy','Kevin Hooks','Rob Spera','Kevin Parks','Misha Collins','Charles Robert Carner','Paul A. Edwards','Nick Copus','Amyn Kaderali','Amanda Tapping','Peter Ellis','Darren Grant','John Fitzpatrick','Matt Cohen','Catriona McKenzie'],
actors:['Jared Padalecki','Jensen Ackles','Jim Beaver','Jeffrey Dean Morgan','Katie Cassidy','Sterling K. Brown','Misha Collins','Genevieve Padalecki','Chris Gauthier','Neil Grayston','Jodelle Ferland','Nicki Aycox','Haili Page','Michelle Borth','Amy Acker','Jake Abel','Julie Benz','Amber Benson','Mercedes McNab','Ken Kirzinger','Leela Savasta','Matthew Humphreys','Amara Zaragoza','Bridget White','Jared Keeso','Tricia Helfer','Katharine Isabelle','Richard Speight Jr.','Dominic Zamprogna','Rachel Pattee','Alexia Fast','Alden Ehrenreich','Andrew Francis','Blu Mankuma','Alona Tal','Christopher Cousins','Marnette Patterson','Gina Holden','Leah Cairns','Tammy Hui','Brooke Nevin','Daniella Evangelista','Nicholas Elia','A. J. Buckley','Nicole LaPlaca','Sarah Shahi','Anjul Nigam','Julie McNiven','Kathleen Munroe','Cindy Sampson','Margot Berner','Lauren Cohan','Michael Massee','Martin Papazian','Sasha Barrese','Andrew Airlie','Colby Johannson','Ellen Geer','Steve Lawlor','Chelah Horsdal','Ridge Canipe','Colin Ford','Chiara Zanni','G. Michael Gray','Myriam Sirois','Cherilyn Wilson','Lindsay Maxwell','Amber Borycki','Peter Birkenhead','Billy Drago','Erin Cahill','Ona Grauer','Brenda Campbell','Kristin Booth','Lisa Marie Caruk','Keegan Connor Tracy','Christie Laing','Jody Thompson','Megalyn Echikunwoke','Beth Broderick','Carrie Genzel','Jane McGregor','Richard Kahan','Traci Dinwiddie','Dustin Milligan','Dameon Clarke','Mitch Pileggi','Matt Cohen','Amy Gumenick','Conchita Campbell','Nicole Leduc','Ted Raimi','Kate Jennings Grant','Heather Doerksen','Jeannette Sousa','Jonathan Watton','Chad Lindberg','Christine Chatelain','Jaime Ray Newman','Jean-Luc Bilodeau'],
basedOn:['John Shiban'],
screenplay:['Ben Edlund','Jeremy Carver','Eric C. Charmelo','Nicole Snyder','Trey Callaway','Cathryn Humphris','Andrew Dabb','John Shiban','Brett Matthews','Sera Gamble','Robert Singer','Daniel Loflin','Meredith Glynn','Daniel Knauf','Raelle Tucker','Nancy Won','Terri Hughes Burton','Ron Milbauer','Eric Kripke','Davy Perez','Steve Yockey','Brad Buckner','James Krieg','Matt Witten','Eugenie Ross-Leming','Denise Thé','Julie Siege','Richard Hatem','Ben Acker','Ben Blacker','Robert Berens','Jenny Klein','Laurence Andries','John Bring','David Ehrman','Adam Glass','Robbie Thompson'],
production:['Marc David Alpert','Sera Gamble','Cyrus Yavneh','Todd Aronauer','Val Stefoff','Andrew Dabb','Daniel Loflin','Meredith Glynn','Jim Michaels','Steve Yockey','Davy Perez'],
music:['Christopher Lennertz','Jay Gruska','Timothy Andrew Edwards','Tim Wynn','Alexander Bornstein'],
camera:['Aaron Schneider','Serge Ladouceur','Christopher Lennertz','Bradley S. Creasser'],
cut:['John Fitzpatrick','Paul Karasick','James Pickel','Nicole Baer','David Ekstrom','Anthony Pinker','Tom McQuade','Don Koch'],
sound:['Dennis Kirk','Dan Hiland','Josh Eckberg','Otis Van Osten','Bill Jackson','Gary D. Rogers','Michael E. Lawshe','Norval D. Crutcher III','Todd Orr','Marc Meyer','Charles Hamilton'],
scenography:['Jerry Wanek','Michael Novotny','Dan Hermansen','George Neuman','John Marcynuk','Richard Reams'],
masks:['Edward French','Fay von Schroeder','Brittin Ireland','Trisha Porter','Amy Bell','Darci Jackson','Charmaine Clark','Juliana Vit','Suzi Ostos','Don Lynch','Leanne Rae Podavin','Cayley Giene','Darah Wyant','Victoria Ferguson','Céline Godeau','Toby Lindala','Vince Yoshida'],
costumes:['Patricia Hargreaves','Kerry Weinrauch','Bobbie Mannix']},
{title:'Modern Family',
titleCZ:'Taková moderní rodinka',
year:2009,
runtime:'91h 3min',
episodeRuntime:'20-22min',
countries:['USA'],
genres:['Comedy','Romance'],
director:['Michael Spiller','Jason Winer','Gail Mancuso','Beth McCarthy-Miller','Chris Koch','Fred Savage','Scott Ellis','Reginald Hudlin','Randall Einhorn','Bryan Cranston','Jeffrey Walker','Seth Gordon','Kevin Rodney Sullivan','Dean Parisot','Adam Shankman','Lev L. Spiro','Fred Goss','Jeff Melman','James R. Bagdonas','Ryan Case','Steven Levitan','Claire Scanlon','Phil Traill','Ken Whittingham','Michelle MacLaren','John Riggi','James Alan Hensz','Jaffar Mahmood','Eric Dean Seaton','Alisa Statman','Kat Coiro','Elaine Ko','Abraham Higginbotham','Helena Lamb','Julie Bowen','Jason Z. Kemp','Trey Clinesmith'],
actors:["Ed O'Neill",'Sofía Vergara','Julie Bowen','Ty Burrell','Jesse Tyler Ferguson','Eric Stonestreet','Rico Rodriguez','Nolan Gould','Sarah Hyland','Ariel Winter','Aubrey Anderson-Emmons','Jeremy Maguire','Reid Ewing','Adam Devine','Justin Kirk','David Cross','Philip Baker Hall','Chazz Palminteri','Shelley Long','Nathan Lane','Benjamin Bratt','Kevin Hart','Fred Willard','Brandy Ledford','Nolan North','Elizabeth Banks','Edward Norton','Margo Harshman','Eddie Diaz','Marina Valle','Kristen Schaal','Minnie Driver','Blake Gibbons','Judy Greer','Bruce Altman','Jason Antoon','Eric Lange','Tom Wright','Taylor Nichols','Lauren Cohan','James Devoti','Norman Lloyd','Celia Weston','Danny Trejo','Steve Kehela','James Marsden','Jami Gertz','Mary Lynn Rajskub','Rachael Harris','Matt Dillon','Jonathan Banks','Holly Weber','Bob Levitan','Kaitlyn Dever','Greg Kinnear','Mark Povinelli','Carolyn Morse','Nicole Lynn Evans','Phil Hendrie','Tim Blake Nelson','Annie Tedesco','Lusia Strus','Samm Levine','Leslie Mann','Jennifer Tilly','Josh Gad','Micaela Johnson','Ernie Hudson','Will Greenberg','Kali Rocha','John DiMaggio','Ellen Barkin','Bobby Cannavale','Melinda Page Hamilton','Frank Wood','Barry Corbin','Stacey Travis','Matt Prokop','Sarah Baker','Beth Grant','Matt Roth','Rob Huebel','Amir Talai','Matthew Broderick','Stephnie Weir','Andrea Savage','Kevin Daniels','Wendi McLendon-Covey','Michaela Watkins','Matthew Alan','Amy Motta','Rob Kerkovich','Joe Adler','Paul Scheer','Alex Fernandez','Lainie Kazan','Billy Dee Williams','Lyle Kanouse','Jason Mantzoukas','Jamie Anderson'],
screenplay:['Ben Karlin','Vanessa McCarthy','Daisy Gardner','Emily Spivey','Carol Leifer','Ilana Wernick','Cindy Chupack','Megan Ganz','Steven Levitan','Christopher Lloyd','Abraham Higginbotham','Jon Pollack','Danny Zuker','Bill Wrubel','Vali Chandrasekaran','Jessica Poter','Stephen Lloyd','Ryan Walls','Jeffrey Richman','Elaine Ko','Jack Burditt','Rick Wiener','Kenny Schwartz','Chuck Tatham','Becky Mann','Audra Sielaff','Alex Herschlag','Caroline Williams','Christy Stratton','Joe Lawson','Andrew Gordon','Morgan Murphy',"Dan O'Shannon"],
production:['Ryan Walls','Becky Mann','Audra Sielaff','Chris Smirnoff','Chuck Tatham'],
music:['Gabriel Mann','Daniel Licht'],
camera:['David Hennings','James R. Bagdonas','Hugo Cortina','Brandon Mastrippolito'],
cut:['Jonathan Schwartz','Steven Rasch','Ryan Case','Jamie Kennedy','Christian Miglio','Giselle Murillo','Tony Orcena','Shaheed Qaasim'],
sound:['Joel D. Catalan','Tamara Johnson','Michael Kalifa','Larry Benjamin','Brian Harman','Dean Okrand','Penny Harold','Jerry Lafuente','Blake Marymor','Mark Friedgen'],
scenography:['Richard Berg','Claire Bennett','Amber Haley','Tara Stephenson','Brian Kasch','Christopher Carlson'],
masks:['Lois Kawasaki-Harriman','Matthew W. Mungle','Shana Fruman','Stephanie L. Massie','Kelly Kline','Jessica Elbaum','Ketty Gonzalez'],
costumes:['Pamela Withers','Alix Friedberg','Marissa Borsetto']},
{title:'In Treatment',
titleCZ:'V odborné péči',
year:2008,
runtime:'54h 55min',
episodeRuntime:'19-29min',
countries:['USA'],
genres:['Drama','Psychology'],
director:['Paris Barclay','Rodrigo García','Jim McKay','Melanie Mayron','Ryan Fleck','Ali Selim','Christopher Misiano','Courtney Hunt','Terry George','Jean de Segonzac','Norberto Barba','Warren Leight','Joshua Marston','Michael Pressman','Richard Schiff','Alan Taylor','Patricia Rozema','Hagai Levi','Michelle MacLaren','Julian Farino','Uta Briesewitz','Janicza Bravo','Karyn Kusama'],
actors:['Gabriel Byrne','Dianne Wiest','Michelle Forbes','Blair Underwood','Mia Wasikowska','Josh Charles','Embeth Davidtz','Melissa George','Mae Whitman','Glynn Turman','Julia Campbell','Uzo Aduba','Max Burkholder','Amanda Axelrod','Patrick Cavanaugh','Peter Horton','Jake Richardson','David Norona','Drew Matthews','Hope Davis','Mike Doyle','Alison Pill','Aaron Grady Shaw','Sherri Saum','Russell Hornsby','John Mahoney','Laila Robins','Keith Nobbs','Lauren Hodges','Cassandra Palacio','Irrfan Khan','Sonya Walger','Samrat Chakrabarti','Susan Misner','Debra Winger','Dane DeHaan','Amy Ryan','Alex Wolff','Louis Katz','Dendrie Taylor','Rachel Brosnahan','Guy Boyd','Natalie Carter','Joseph Siravo','Shawna Christensen',"Roberto 'Sanz' Sanchez",'Jacquelyn Reingold','Anthony Ramos','Liza Colón-Zayas','John Benjamin Hickey','Quintessa Swindell','Joel Kinnaman','Madeline Zima','Charlayne Woodard'],
screenplay:['Rodrigo García','Nir Bergman','Ori Sivan','Sarah Treem','Warren Leight','Merritt Johnson','Amy Lippman','Bryan Goluboff','Keith Bunin','Dan Futterman','Adam Rapp','Pat Healy','Ari Folman','Eran Kolirin','Davey Holmes','Alison Tatlock','Anya Epstein','Jacquelyn Reingold','Chris Gabo','Zack Whedon','Jackie Sibblies Drury','Joshua Allen','Marsha Norman'],
production:['Sarah Treem'],
music:['Richard Marvin','Marty Beller'],
camera:['Fred Murphy','Xavier Grobet','Derick V. Underschultz','Patrick Cady','Steve Mathis','Mauricio Rubinstein','Steven Fierberg'],
cut:['Amy E. Duddleston','Michelle Tesoro','Joe Hobeck','Michael Ruscio','Lisa Bromwell','J. Kathleen Gibson','Tanya M. Swerling','Beatrice Sisul','Debra Beth Weinfeld','Kristina Hamilton-Grobler'],
sound:['Cary Stacy','Rick Norman','Michael Colomby','Jared Marshack','Joe White','Jeff Pullman','Gary Gegan'],
scenography:['Neil Patel','Suzuki Ingerslev','Carol Bayne Kelley','Karin Wiesel Holmes',"Elaine O'Donnell",'Catherine Smith'],
costumes:['Sarah Beers','Tom Broecker','Maria Tortu','Tiffany Hasbourne']},
{title:'The Class: Life After',
titleCZ:'Třída - Život poté',
year:2010,
runtime:null,
episodeRuntime:'7x56min',
countries:['Estonsko'],
genres:['Drama','Psychology'],
director:['Ilmar Raag','Priit Valkna','Gerda Kordemets'],
actors:['Kadi Metsla','Paula Solvak','Laine Mägi','Vallo Kirs','Pärt Uusberg','Lauri Pedaja','Mikk Mägi','Riina Reis','Joonas Paas','Triin Tenso','Virgo Ernits','Indrek Sammul','Hannes Kaljujärv','Guido Kangur','Carmen Mikiver','Piret Kalda','Tiit Sukk','Laura Peterson','Erik Ruus','Andres Raag','Rita Rätsepp','Kärt Tomingas','Anu Lamp','Üllar Saaremäe','Ingomar Vihmar','Margus Prangel','Doris Tislar','Tanel Saar','Anne Reemann','Armin Pajula','Kristjan Sarv','Timo Steiner','Maria Peterson','Saara Kadak','Roland Laos','Elina Purde','Aarne Mägi','Mirjam Mesak'],
screenplay:['Margit Keerdo-Dawson'],
production:['Gerda Kordemets'],
music:['Timo Steiner'],
masks:['Siiri Lauri']},
{title:'Boss',
titleCZ:'Šéf',
year:2011,
runtime:'16h 55min',
episodeRuntime:'52-59min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Mario Van Peebles','Jim McKay','Gus Van Sant','Phil Abraham','Jean de Segonzac','Lesli Linka Glatter','Nelson McCormick'],
actors:['Kelsey Grammer','Kathleen Robertson','Martin Donovan','Christian Stolte','Bill Stoneking','David Pasquesi','Jonathan Groff','Connie Nielsen','James Vincent Meredith','Troy Garity','Francis Guinan','Hannah Ware','Rich Komenich','Nicole Forester','Anita Nicole Brown','Joe Minoso','William Smillie','Daniel J. Travanti','Amy Morton','Danny Goldring','Sanaa Lathan','T.I.','Jeff Hephner','Craig Lemons','Rotimi','Tyler Ross','Andre Bellos','Maura Kidwell','Amy Newbold','James Pusztay','Karen Aldridge','Usman Ally','Valerie Meachum','Grace McPhillips','Rebecca Spence','Nicole I. Butler','Josh Odor','Guy Van Swearingen','Madrid St. Angelo','Emmanuel Isaac','Ric Morgan','Jeremy Denzlinger','Justin James Farley','Bruce Jarchow','Tim Mason','Russ Panzarella','Tamberla Perry','Howie Johnson','Antoine McKay','Roger Welp','Phillip Edward Van Lear','Richard Bull','Lara Phillips','Brian Boland','Chelcie Ross','Marin Ireland','Kamal Angelo Bolden','Gil Bellows','Jessie Prez','Mia Park','DuShon Monique Brown','José María Mendiola','John Hoogenakker','Mary Hollis Inboden','Jennifer Mudge','Henry Godinez','Coburn Goss','Jeremy Isaiah Earl','Andrew Carter','Alana Arenas','Charin Alvarez','Brian King','Michelle Davidson','Džunpei Hašino','Sasha Gioppo','Tracey Bonner','Loren Lazerine','Jaden Klein','Dan Flannery','Danny McCarthy','Mildred Marie Langford','Vail Romeyn','Madison Dae Clarion','Elizabeth Laidlaw','Janet Ulrich Brooks','Michael Accardo'],
screenplay:['Farhad Safinia','Angelina Burnett','Julie Hébert','Richard Levine','Kevin J. Hynes','Paul Keables','Lynnie Greene','Dee Johnson'],
production:['Peter Giuliano'],
music:['Brian Reitzell'],
camera:['Kasper Tuxen','Richard Rutkowski'],
cut:['Jo Francis','Elliot Graham','Dorian Harris','Stephen Mark','Elba Sanchez-Short','J. Kathleen Gibson','Kevin Casey'],
sound:['Larry Benjamin','Kurt Nicholas Forshager','Ethan Beigel','Frank Morrone'],
scenography:['Daniel B. Clancy','Desi Wolff','Christopher Brown'],
masks:['Lillian Sakamaki','Suzi Ostos'],
costumes:['Juliet Polcsa','Kim Wilcox']},
{title:'The Promised Neverland',
titleCZ:'Jakusoku no Neverland',
year:2019,
runtime:'9h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Mystery'],
director:['Mamoru Kanbe','Tošimasa Išii','Šigeru Fukase','Sumito Sasaki','Takahiro Harada','Hiroki Itai','Jajoi Takano','Jukiko Imai','Kakuši Ifuku','Makoto Kodama'],
actors:['Maaja Učida','Marija Ise','Sumire Morohoši','Júko Kaida','Hijori Kóno','Lynn','Ai Kajano','Ari Ozawa','Jošino Aojama','Šizuka Išigami','Nao Širaki','Šiničiró Kamio','Acumi Tanezaki','Šinei Ueki','Mari Hino','Koko Hajaši','Erisa Kuon','Mami Kojama','Jasujuki Kase','Tošija Ueda','Čika Anzai','Jošiki Nakadžima','Hidenori Takahaši','Jošimasa Hosoja','Šúhei Macuda','Šinnosuke Ogami','Rjó Sugisaki','Jú Okano','Sakuma Motoki','Nao Fudžita','Jú Wakabajaši','Kósuke Okamoto','Džunpei Baba','Takuhiro Eda','Hajato Kimura','Júko Mori','Kódai Sensaki','Kijohiro Jamaguči','Takanori Kino'],
basedOn:['Kaiu Širai'],
screenplay:['Tošija Óno','Seiko Takagi','Čiaki Nagai'],
production:['Masanori Mijake'],
music:['Takahiro Obata'],
camera:['Tomojuki Šiokawa'],
cut:['Rie Macubara'],
sound:['Kacunori Šimizu'],
scenography:['Šigemi Ikeda','Jukiko Marujama']},
{title:"Not the Nine O'Clock News",
titleCZ:'Žádné zprávy v devět',
year:1979,
runtime:'11h 15min',
episodeRuntime:'25min',
countries:['UK'],
genres:['Comedy'],
director:['Geoff Posner','Bob Spiers','Bill Wilson'],
actors:['Rowan Atkinson','Mel Smith','Pamela Stephenson','Griff Rhys Jones','Chris Langham','Mary Tamm','Jim Carter','John Cleese','Billy Connolly','Kenny Everett','Bruce Forsyth','Willoughby Goddard','Hugh Thomas','Claire Davenport','Harry Fielder','Richard Davies','David Rappaport','Philip Pope','Jim Broadbent'],
screenplay:['Douglas Adams','Rowan Atkinson','Richard Curtis','David Renwick','Kim Fuller','Andy Hamilton','Victoria Pile','Colin Bostock-Smith','Terry Kyan','Paul Smith','Laurie Rowley','Richard Sparks','Sean Hardie','Guy Jenkin','Nigel Planer','Guy Meredith','Roger Planer','Ian Hopkins'],
production:['John Lloyd','Sean Hardie'],
music:['Howard Goodall','Philip Pope','Nic Rowley','Chris Judge Smith'],
cut:['Noel Chanan','Hefny Zaky'],
sound:['Terry Elms'],
scenography:['David Hitchcock','Paul Joel'],
masks:['Kezia De Winne'],
costumes:['Dorinda Rea']},
{title:'South Park',
titleCZ:'Městečko South Park',
year:1997,
runtime:'118h 25min',
episodeRuntime:'16-48min',
countries:['USA'],
genres:['Animation','Comedy'],
director:['Trey Parker','Matt Stone','Eric Stough','Adrien Beard','Toni Wurts'],
actors:['Trey Parker','Matt Stone','Isaac Hayes','Isaac Hayes','Jay Leno','Tomorowo Taguči','Jenna Mattison','Elton John','Ozzy Osbourne','George Clooney','Malcolm McDowell','Kyle McCulloch','Jennifer Aniston','Dian Bachar','Peter Serafinowicz','Rick James','Thom Yorke','Courtney Ford',"Reginald 'Fieldy' Arvizu",'Natasha Henstridge','Joe Strummer','DMX','Meat Loaf','John Lydon','Marc Shaiman','Jonny Greenwood',"Ol' Dirty Bastard",'Tim Armstrong','Brandon Hardesty','Bill Hader','Robert Amstler','Jessica Makinson','Brad Paisley','Pam Brady','Jonathan Davis','Frank Welker','Tommy Chong','Cheech Marin','Eric Stough','Myko Olivier','Ilana Cohn','Robert Smith','Giancarlo Ganziano','PewDiePie','Mary Kay Bergman','Henry Winkler','The Crystal Method','Charles Manson','Eliza Schneider','Richard Belzer','Patrick Stewart','Anne Garefino','Kief Davidson','Adrien Beard','Jennifer Howell','Franchesca Clifford','Karri Turner','Jesse Brant Howell','Michelle Jones','Michael Buffer','Toddy Walters','Bruce Howell','Brent Musburger','Nico Agnone','Jonathan Katz','Les Claypool','Nancy Kerrigan','Norman Lear','April Stewart','Stanley G. Sawicki','Michael Ann Young','Usáma bin Ládin','Vernon Chatman','Erica Rivinoja','Tyrone Jenkins','Eric Bauza','Sia','Endre Hules','Elon Musk','Alex Veadov','Martin L. Washington Jr.','Craig LaMarsh','Rowan Smyth',"Brian 'Head' Welch",'Thomas M. Vogt','Kellen Michael','Josh Gad','Eli Bildner','Vlada Verevko','Mason McNulty','Megan Liu','Dakota Sky','Daniel Luján','Ness Bautista','Debi Derryberry','Eli Harris','Calvin C. Winbush','Mayank Bhatter','Roger Goodell','Mona Marshall'],
basedOn:['Charles Dickens'],
screenplay:['Trey Parker','Matt Stone','Michael Anthony Snowden','Dave Polsky','Tim Talbott','Karey Dornetto','Philip Stark','Nancy M. Pimental','Dan Sterling','David R. Goodman','Trisha Nixon','Pam Brady','Kyle McCulloch','Susan Hurwitz Arneson'],
production:['Anne Garefino','Adrien Beard','Frank C. Agnone II','Kyle McCulloch','Vernon Chatman','Erica Rivinoja','Pam Brady','Bruce Howell','Eric Stough','Bill Hader','Josh Gad','Giancarlo Ganziano','David List'],
music:['Adam Berry','Scott Nickoley','Trey Parker','Marc Shaiman','Jamie Dunlap'],
cut:['Giancarlo Ganziano','Thomas M. Vogt','Keef Bartkus','David List','John Laus'],
sound:['Cary Butler'],
scenography:['Jack Shih'],
costumes:['Karen Mann']},
{title:'Scrubs',
titleCZ:'Scrubs: Doktůrci',
year:2001,
runtime:'66h 26min',
episodeRuntime:'20-28min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Bill Lawrence','John Inwood','Matthew Diamond','Elodie Keene','Adam Bernstein','Gail Mancuso','Craig Zisk','Michael Spiller','Will Mackenzie','Chris Koch','Jason Ensler','Peter Lauer','Ken Whittingham','Zach Braff','Joanna Kerns','Lawrence Trilling','Rob Greenberg','Michael McDonald','Jay Alaimo','Paul Quinn','Victor Nelli Jr.','Jeff Melman','Marc Buckland','Randall Keenan Winston','Henry Chan','Matthew Perry','Linda Mendoza','John Putch','Ted Wass','John Michel','Mark Stegemann','Richard W. Davis','Eren Celeboglu'],
actors:['Zach Braff','Sarah Chalke','Donald Faison','Judy Reyes','Ken Jenkins','John C. McGinley','Neil Flynn','Christa Miller','Sam Lloyd','Aloma Wright','Robert Maschio','Masi Oka','Ricky Schroder','Eliza Coupe','Michael Mosley','Travis Schuldt','Kerry Bishé','Nicky Whelan','Nicole Sullivan','Paul Adelstein','Julianna Margulies','Torrey DeVitto','Allison Smith','Amy Smart','Elizabeth Banks','Lindsay Hollister','Mary Kate Schellhardt','Kerris Dorsey','Elizabeth Bogush','Scott Foley','Michael Copon','Tara Reid','Heather Graham','Brendan Fraser','Freddy Rodríguez','Mandy Moore','Michael J. Fox','Colin Farrell','Matthew Perry','Tom Cavanagh','Fred Stoller','Bonita Friedericy','Sarah Lancaster','Heather Locklear','Zach Mills','Lauren Stamile','Meredith Roberts','Mary Mouser','Sean Whalen','Mona Weiss','Eric Laneuville','Kathryn Joosten','Nathan Lee Graham','J.B. Ghuman Jr.','medvěd Bart 2','Mircea Monroe','David Blue','Troy Kotsur','Bellamy Young','Martin Klebba','Michael Weston','Alan Ruck','Gillian Vigman','Angel Oquendo','Carole Goldman','James Michael Tyler','Rebecca Metz','Cheryl Hines','Maria Menounos','Phill Lewis','Sean Hayes','William Brent','Dick Van Dyke','John Ritter','Yara Brighton','Marshall Manesh','Ryan Reynolds','Nestor Carbonell','Jon Polito','Keri Russell','Louie Anderson','David Copperfield','Jay Leno','George Takei','Gary Busey','Courteney Cox','Aziz Ansari','Lynn A. Henderson','Colin Hay','Mindy Sterling','Liliana Mumy','Don Perry','Julian Berlin','Trevor Wright','Kevin Rahm','Matt Bush','Cayden Boyd','Kareem Abdul-Jabbar','Embeth Davidtz','Dave Franco'],
screenplay:['Gabrielle Allan','Bonnie Sikowitz','Eric Weinberg','Hadley Davis','Neil Goldman','Garrett Donovan','Rich Eustis','David Feinberg','Astro','Brian Avenet-Bradley','Ken Whittingham','Lon Zimmet','Justin Spitzer','Tim Hobert','Ryan A. Levin','Matt Tarses','Bill Lawrence','Prentice Penny','Aseem Batra','Leila Strachan','Janae Bakken','Angela Nissel','Dan Rubin','Mark Stegemann','Josh Bycel','Bill Callahan','Alessia Costantini','Will Berson','Kevin Biegel','Eren Celeboglu','Debra Fordham','Andy Schwartz','Dave Tennant'],
production:['Neil Goldman','Garrett Donovan','Gabrielle Allan','Mychelle Deschamps','Randall Keenan Winston','Debra Fordham'],
music:['Michael Spiller','Jan Stevens'],
camera:['John Inwood','Dave Perkal','Andrew Rawson','Richard W. Davis','Richard Quinlan'],
cut:['Jay Scherberth','John Michel','Stuart Bass'],
sound:['Paul Tade','John W. Cook II','Peter Nusbaum','William Freesh','Jim Fitzpatrick','Sherry Klein','Tamara Johnson','Mike Olman','Robert Appere','Ed Carr'],
scenography:['Cabot McMullen','Susan Bolles','Woody Crocker','Donald Krafft','Brian Kasch'],
masks:['Kimberly Carlson',"Valli O'Reilly",'Nikoletta Skarlatos','Janice Kavanagh','Cyndilee Rice','Lisa Ashley','Rebecca DeHerrera','Phyllis Williams','Rachel Dowling','Kenneth Paul Schoenfeld','Bob Jermain','Suzanne Kontonickas','Brad Hardin'],
costumes:['Carey Bennett','Alexandra Dewey']},
{title:'The White Lotus',
titleCZ:'Bílý lotos',
year:2021,
runtime:'13h 31min',
episodeRuntime:'54-63min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Mike White'],
actors:['Murray Bartlett','Connie Britton','Jennifer Coolidge','Alexandra Daddario','Lukas Gage','Jon Gries','Fred Hechinger','Jake Lacy',"Brittany O'Grady",'Jolene Purdy','Natasha Rothwell','Molly Shannon','Sydney Sweeney','Steve Zahn','Christie Volkmer','Alec Merlino','Kekoa Kekumano','F. Murray Abraham','Adam DiMarco','Haley Lu Richardson','Michael Imperioli','Aubrey Plaza','Theo James','Meghann Fahy','Will Sharpe','Sabrina Impacciatore','Eleonora Romandini','Amber Abara','Beatrice Grannò','Simona Tabasco','Federico Scribani','Lorenzo Scalzo','Federico Ferrante','Katia Gargano','Leo Woodall','Tom Hollander','Stefano Gianino','Lucio Patané','Laura Dern','Italo Di Pinto'],
screenplay:['Mike White'],
production:['Heather Persons','John M. Valerio','Todd Brown'],
music:['Cristobal Tapia de Veer','Kim Neundorf'],
camera:['Ben Kutchins','Xavier Grobet'],
cut:['Heather Persons','John M. Valerio'],
sound:['Kathryn Madsen','Angelo Bonanni','Walter Anderson','Vincenzo Urselli','Christian P. Minkler'],
scenography:['Laura Fox','Jennifer Lukehart','Letizia Santucci','Cristina Onori'],
masks:['Rebecca Hickey'],
costumes:['Alex Bovaird']},
{title:'The Sinner',
titleCZ:'Hříšnice',
year:2017,
runtime:'24h 5min',
episodeRuntime:'41-55min',
countries:['USA'],
genres:['Drama','Mystery','Thriller','Crime'],
director:['Antonio Campos','Brad Anderson','Cherien Dabis','Jody Lee Lipes','Tucker Gates','John David Coles','Adam Bernstein','Andrew McCarthy','Colin Bucksey','Radium Cheung','Rachel Goldberg','Derek Simonds','Haifaa Al-Mansour','Batan Silva','Monica Raymund'],
actors:['Jessica Biel','Christopher Abbott','Bill Pullman',"Patti D'Arbanville",'Teri Wyble','Robert Funaro','C.J. Hunt','Jacob Berger','Adrienne Lovette','Abby Miller','Dohn Norwood','Rebecca Wisocky','Nadia Alexander','Mike Holt','Jules Haven','Granit Lahu','Kathryn Erbe','Jacob Pitts','Enid Graham','Orlagh Cassidy','Susan Pourfar','Peggy Gormley','Danielle Burgess','Pamela Gray','C.J. Wilson','Carrie Coon','Elisha Henig','Natalie Paul','Adam David Thompson','Adam LeFevre','Rosemary Howard','Leslie Fray','Joanna Adler','Elaine del Valle','Gary Hilborn','Rodrigo Lopresti','Justin Silver','John Rue','Aamira Martinez','David Call','Jay O. Sanders','Arthur French','Jamie Neumann','Tracy Letts','Victor Williams','Kiran Merchant','Hannah Gross','Allison Case','Melanie Nicholls-King','Marc Menchaca','Samrat Chakrabarti','Richard Bekins','Eva Kaminsky','Antonio Ortiz','Brennan Brown','Martin Shakar','Marceline Hugot','Ellen Adair','Faith Logan','Lisa Emery','Meredith Holzman','Robert G. McKay','Lynn Marocola','Matt Bomer','Jacob Berger','Parisa Fitz-Henley','Jessica Hecht','Ruibo Qian','Mathilde Dehaye','Chris Messina','Brooke Bloom','Luke David Blumm','Walker Hare',"De'Adre Aziza",'Robert Myers','Ella Rae Peck','Jordan Dean','Rileigh McDonald','Robert Cuccioli','Gameela Wright','Garrett Coffey','Alexa Shae Niziak','Kerry McGann','Scott Cohen','Lee Wilkof','Nick Taylor','Amanda Kristin Nichols','Delilah Napier','Mike Figueroa','Erich Schuett','Dani Deetté','Ken Holmes','Spenser Granese','Gina Jun','Logan Crawford','Dee Hoty','Michael Braun','Frances Fisher','Alice Kremelberg','Neal Huff'],
basedOn:['Petra Hammesfahr'],
screenplay:['Petra Hammesfahr','Liz W. Garcia','Derek Simonds','Ellen Fairey','Tom Pabst','Hannah Shakespeare','Jonathan Caren','Julie Siege','Samir Mehta','Nina Braddock','Ahmadu Garba','Piero S. Iberti','Jenny Zhang','Kate Roche','Gerald Cuesta','Mia Chung','Jesse McKeown'],
production:['Randy Sutter','Tom Pabst','Donna E. Bloom','Meredith Mills','Brad Carpenter','Jonathan Caren','Ellen Marie Blum','Aaron Seliquini'],
music:['Ronit Kirchman'],
camera:['Jody Lee Lipes','Radium Cheung','Justin Charles Foster','André Pienaar'],
cut:['Gary Levy','Matthew Hannam','Erica Freed Marker','Aaron Yanes','Daniel A. Valverde','Deborah Moran','Amanda Pollack','Doug Abel'],
sound:['David J. Schwartz'],
scenography:['Scott Kuzio','Matthew Munn','Dina Goldman','Missy Berent Ricker','Karin Wiesel Holmes','Tora Peterson','Phillip Barker','James Bednark'],
masks:['Gary Martori','Jeff Goodwin','Patrick Alemi','Kiara Desjarlais',"Katherine O'Donnell",'Rebecca Hickey'],
costumes:['Hope Hanafin','Jennifer von Mayrhauser','Jeriana San Juan','Lisa R. Frucht','Catherine Crabtree']},
{title:'Masters of Sex',
titleCZ:'Mystérium sexu',
year:2013,
runtime:'43h 54min',
episodeRuntime:'52-60min',
countries:['USA'],
genres:['Drama'],
director:['Michael Apted','Michael Dinner','Adam Davidson','Tim Fywell','Lesli Linka Glatter','John Madden','Lawrence Trilling','Phil Abraham','Chris Manley','Jennifer Getzinger','Jeremy Webb','Michael Engler','Keith Gordon','Adam Arkin','Adam Bernstein','Dean Parisot','Miguel Sapochnik','Michael Weaver','Matt Earl Beesley','Daniel Attias','Susanna White','Colin Bucksey','Karyn Kusama','Julie Anne Robinson','Eric Tignini'],
actors:['Michael Sheen','Lizzy Caplan','Caitlin Fitzgerald','Teddy Sears',"Nicholas D'Agosto",'Heléne Yorke','Beau Bridges','Julianne Nicholson','Rose McIver','Allison Janney','Josh Charles','Ann Dowd','Keke Palmer','Garrett M. Brown','Alan Ruck','James Eckhouse','Rae Foster','Joan Severance','Nicholle Tom','Ellen Wroe','Kandis Fay','Adam Silver','Brian Howe','Michael Cassidy','Margo Martindale','Mae Whitman','Greg Grunberg','Emily Davenport','Bobby Campo','Clark Freeman','Natasha Sims','Clark Moore','Pepper Binkley','Elizabeth Bogush','Shanna Collins','Eileen Grubba','Micah Hauptman','Olivia Alaina May','Doug McKeon','Evie Ryland','Betsy Zajko','Mather Zickel','Molly Hagan','Lauren Weedman','Finn Wittrock','Blake Robbins','Spencer Garrett','Sarah Silverman','Yetide Badaki','Jocko Sims','Karissa Lee Staples','Annaleigh Ashford','Ashley Johnson','Yvans Jourdain','Anne Griffin','Michael Mantell','Cole Sand',"Gabe O'Mara",'Veronica Mannion','Steve Rosen','Nick Smoke','Claire van der Boom','David Ury','Melanie Paxson','Emily Kinney','Evan Arnold','Brit Shaw','Peter Mackenzie',"Kerry O'Malley",'Mike Peebler','Jeff Doucette','Maury Sterling','Linara Washington','Braden Moran','Gil McKinney','Dean Chekvala','Larry Joshua','Maggie Grace','Alexa Alemanni','Scott Michael Campbell','Grant Harvey','Kevin Shinick','Rebecca Staab','Isabelle Fuhrman','Rya Kihlstedt','Danny Huston','Jed Rees','Eric Lange','Jaeden Martell','Alyvia Alyn Lind','Peter Douglas','Hanna Hall','Liesel Kopp','Kayla Madison','Barry Bostwick','Ann Cusack','Caroline Lagerfelt','Mary Passeri','Leah Costello','Rachel Kimsey'],
basedOn:['Thomas Maier'],
screenplay:['Michelle Ashford','Michael Cunningham','Amy Lippman','Richard Levine','Noelle Valdivia','David Flebotte','Esta Spalding','Jonathan Igla','Gina Fattore','Ellen Fairey','Sam Shaw','Lynnie Greene','Tyler Bensinger','Steven Levenson','Bathsheba Doran'],
production:['Esta Spalding','Steven Levenson'],
music:['Michael Penn'],
camera:['Michael Weaver','Chris Manley','Tim Bellen','Ben Davis','Joseph E. Gallagher','John Newby'],
cut:['Robert Frazen','Lauren Connelly','Jordan Goldman','Fabienne Bouville','David Dworetzky'],
sound:['Michael Barosky','R. Russell Smith','Robert Edmondson','Robert Getty','David B. Cohn','Sean Rush'],
scenography:['Michael Wylie','Andrew Jackness','Halina Siwolop'],
masks:['Matthew Holman','Jean Ann Black','Janice Kavanagh','Cyndilee Rice','Donna J. Anderson','Joann Kozloff','Ayat Malek Kiankhooy','Kathrine Gordon','Maurine Burke','John Damiani','Vivian Maxwell','Cynthia Hernandez'],
costumes:['Isis Mussenden','Ane Crabtree','Caroline Duncan','Ashley Kemper']},
{title:'How to Get Away with Murder',
titleCZ:'Vražedná práva',
year:2014,
runtime:'64h 27min',
episodeRuntime:'42-44min',
countries:['USA'],
genres:['Crime','Drama','Mystery'],
director:['Michael Offer','Jennifer Getzinger',"Bill D'Elia",'Laura Innes','Eric Stoltz','Debbie Allen','Stephen Williams','Michael Katleman','Rob Hardy','John Terlesky','Stephen Cragg','Kevin Bray','Zetna Fuentes','Jann Turner','Kevin Rodney Sullivan','Sharat Raju','Michael Smith','Cherie Nowlan','Hanelle M. Culpepper','Randy Zisk','Paris Barclay','Nzingha Stewart','Lexi Alexander','Mike Listo','Jonathan Brown','Marta Cunningham','Valerie Weiss','Nicole Rubio','Eric Laneuville','Alrick Riley','DeMane Davis','Catriona McKenzie','Félix Enríquez Alcalá','Lily Mariye','Sheelin Choksey','Dawn Wilkinson','Janice Cooke','Jet Wilkinson','Scott Printz'],
actors:['Viola Davis','Billy Brown','Jack Falahee','Aja Naomi King','Matt McGorry','Karla Souza','Charlie Weber','Liza Weil','Conrad Ricamora','Alfred Enoch','Tom Verica','Katie Findlay','Michael Gaston','Suzanne Savoy','Andrea Syglowski','Kate Kearney-Patch','Ana Ortiz','Michael Adam Hamilton','David Burke','Marcia Gay Harden','Amy Pietz','Megan West','Tye Alexander','Sara Paxton','Yatoya Toy','Brett Zimmerman','Karen Ann Cabrera','Jeff Doucette','John Posey','Jen Dede','John McKeever','Frank Maharajh','Karina Logue','Tabitha Morella','Anne Betancourt','Lou Richards','Famke Janssen','Elliot Knight','Catherine Carlen','John Getz','Brian Gallagher','Assaf Cohen','Jennifer Butler','Steven Weber','Wes Armstrong','Missy Doty','Jason Gedrick','David Denman','Alysia Reiner','Arjun Gupta','Sage Kirkpatrick','Tim Griffin','Elizabeth Perkins','Karen Malina White','Tracy Vilar','Robin Gammell','David Gautreaux','Jim Turner','Eric Davis','Greg Germann','Tamlyn Tomita','Mark Adair-Rios','Dean Cameron','Bonnie Burroughs','Lynn Whitfield','Stacy Edwards','David Burke','Katie Cleary','Thomas Robinson','Pat Healy','Eddie Driscoll','Faran Tahir','Jackie Geary','José Zúñiga','Brynn Thayer','Innis Casey','Vince Duvall','Delpaneaux Wills','James Logan','Peter Onorati','Michael McGrady','Hector Luis Bustamante','Cicely Tyson','Michelle Hurd','Mark Famiglietti','Mageina Tovah','Tom Everett Scott','Lilli Birdsell','Mari Weiss','Karl T. Wright','Dan Martin','Sarah Burns','Steven Culp','Barbara Eve Harris','Kendrick Sampson','Amy Okuda','Christine Corpuz','Bonita Friedericy','Matt Cohen','Sherri Saum'],
screenplay:['Angela Robinson','Fernanda Coppel','Maya Goldsmith','Tanya Saracho','Peter Nowalk','Sarah L. Thompson','J.C. Lee','Erika Green Swafford','Maisha Closson','Matthew Cruz','Warren Hsu Leonard','Hadi Nicholas Deeb','Michael Foley','Inda Craig-Galván','Erika Harrison','Ricardo Lira','Morenike Balogun','Marcus Dalzine','Rob Fresco','Tess Leibowitz','Laurence Andries','Tracy Bellomo','Doug Stockstill','Abby Ajayi','Brendan Kelly','Sara Rose Feinberg','Joe Fazzio'],
production:['Viola Davis','Sarah L. Thompson','Erika Harrison','Scott Printz','Brendan Kelly','Joe Fazzio'],
music:['Photek'],
camera:['Michael A. Price','Jeffrey Jur','Christian Sebaldt','Spencer Combs','Joe Broderick'],
cut:['Philip Carr Neel','David Greenspan','John Wesley Whitton',"Jill D'Agnenica",'Chris Lorusso','Blake Harjes','Michael Hathaway','Matthew Pevic'],
sound:['Marla McGuire','Stephen Fitzmaurice','David S. Di Pietro','Walter Michael Bost'],
scenography:['Mayling Cheng','Charles M. Lagola','Lori Agostino','Peter Politanoff','Erin Smith','Timothy Stepeck','Colin Kirkpatrick','Ellen King','Claudette Didul'],
masks:['Matthew Holman','Porshawna Mosely','Tifanie White','Jamika Wilson','Leslie Lightfoot','Christopher Allen Nelson','Sherri Bramlett'],
costumes:['Ellen Mirojnick','Linda M. Bass','Lyn Paolo','Ladon Whitmire']},
{title:'Blue Mountain State',
titleCZ:'Borci z Blue Mountain State',
year:2010,
runtime:'14h 29min',
episodeRuntime:'21-29min',
countries:['USA'],
genres:['Comedy','Sport'],
director:['John Fortenberry','Brian Robbins','Fred Savage','Clay Weiner','Jay Chandrasekhar','Jeff Melman','Eric Appel','Rob Schrab','Clark Mathis','Dean Holland','Lev L. Spiro','Ken Whittingham','Alex Winter'],
actors:['Darin Brooks','Alan Ritchson','Chris Romano','Ed Marinaro','Meghan Heffern','Leah Renee','Denise Richards','Tod Fennell','Kelly Kruger','Sinqua Walls','Alex Weiner','Stephen Amell','James A. Woods','Julie-Anne Côté','Neil Napier','Michelle Argyris','Ricky Mabe','Kaitlyn Leeb','Elisabetta Fantone','Cristina Rosato','Amber Goldfarb','Gabrielle Dennis','Alexandra Ordolis','Goûchy Boy','Anastasia Phillips','Sam Jones III','Michael J. Willett','Frankie Shaw','Vanessa Matsui','Lindsay Maxwell','Nastassia Markiewicz','Steve Lund','Sarah Booth','Annie Murphy','Alison Louder','Bill Romanowski','Kevin Hanchard','Alex Cardillo','Danny Blanco Hall','Tristan D. Lalla','Erin Agostino','Shawn Baichoo','Madison McAleer','Andrew Carter','Omari Newton','Page Kennedy','Kevin Coughlin','C. David Johnson','Chantal Quesnelle','Karl Graboshas','Hilary Jardine','Andrew Johnston','Marc-André Poliquin','Jasson Finney','Chester Tam','Shane Daly','Judah Katz','Raphael Grosz-Harvey','Matthew Raudsepp','Michael Rhoades','Kevin Woodhouse','Harry Standjofski','Mike Paterson','Erica Deutschman','Xiao Sun','Kimberly Laferriere','Kristian Hodko','Antoni Porowski','Pauline Egan','Kwasi Songui','Christina Broccolini','Miguel A. Núńez Jr.','Peter Michael Dillon','Guy Sprung','Moshana Halbert','Tom Stevens','James Cade','Lucas Till','Cloris Leachman','Curtis Armstrong','Brittany Drisdelle','Jessica Malka','Artur Gorishti','Brian Bosworth','Ted Atherton','Gary Hudson','Kristina Pesic','Clara Altimas','Karl Dorcin','Stacy Keibler','Rob Ramsay','Michel Perron','Chuck Liddell','Anthony Lemke','Mike Dopud','Claudia Besso','Danny Wells','Tammy Gillis','Alex Bisping','Kristofor Brown'],
screenplay:['Chris Romano','Drew Hancock','Brian Burns','Chester Tam','Eric Falconer','Chip Hall','J.D. Ryznar','Heather Flanders','Kristofor Brown','Ryan Ridley'],
music:['Mark Mothersbaugh','Lewis T. Powell'],
camera:['Mathew Rudenberg','Eric Cayla','Bruce Chun','Robert Mattigetz'],
cut:['Ned Bastille','Steven Rasch','Cortney Carrillo','Pamela March'],
sound:['Joel D. Catalan','Michael Kalifa','Ken Teaney','Dean Okrand','Ethan Beigel'],
scenography:['Vincent Aird'],
masks:['Christophe Giraud'],
costumes:['Mariane Carter','Claire Nadon']},
{title:'Young Royals',
titleCZ:'Mladá modrá krev',
year:2021,
runtime:'8h 58min',
episodeRuntime:'40-50min',
countries:['Sweden'],
genres:['Drama','Romance'],
director:['Rojda Sekersöz'],
actors:['Edvin Ryding','Omar Rudberg','Malte Gårdinger','Nikita Uggla','Frida Argento','Samuel Astor','Mimmi Cyon','Uno Elger','Ingela Olsson','Fabian Penje','Felicia Maxime','Nils Wetterholm','Aminah Al Fakir','Peter Carlberg','Claes Hartelius','Ivar Forsling','Carmen Gloria Pérez','Hannes Alin','Nathalie Varli'],
screenplay:['Lisa Ambjörn','Sofie Forsman'],
production:['Lisa Berggren Eyre','Martin Söder'],
music:['Matti Bye'],
cut:['Sofia Lindgren','Gregers Dohn'],
sound:['Alexander Berggren','Eduardo Rodriguez'],
masks:['Märta Dahlberg']},
{title:'Black Lagoon',
titleCZ:'Black Lagoon',
year:2006,
runtime:'9h 36min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Adventure','Drama'],
director:['Sunao Katabuči','Hiromicu Kanazawa',"Ken'iči Kawamura",'Hisato Šimoda','Jošihisa Macumoto','Fumie Muroi','Takao Abo','Kazuhiro Soeta'],
actors:['Daisuke Namikawa','Cutomu Isobe','Hiroaki Hirata','Megumi Tojoguči','Mami Kojama','Ken Narita','Tecuja Kakihara','Tomokazu Sugita','Tošijuki Morikawa','Ikuja Sawaki','Masajuki Nakata','Kazue Ikura','Júiči Nakamura','Džódži Nakata','Takaja Kuroda','Mičie Tomizawa','Tóru Nara','Bandžó Ginga','Kenta Mijake','Tomoko Kaneda','Jósuke Akimoto','Masaki Aizawa','Asami Jaguči','Takaja Haši',"Masa'aki Cukada",'Šigeru Ušijama','Rjúdži Nakagi','Širó Saitó','Masahiko Tanaka','Akiko Takeguči','Akimasa Ómori','Ken Jamaguči','Júko Sasaki','Sajuri Ikemoto','Taiten Kusunoki','Hisao Egawa','Kijojuki Janada','Hóko Kuwašima','Šinpači Cudži','Masaru Ikeda','Wataru Takagi','Miki Nagasawa','Rino Marimo','Kijonobu Suzuki','Tomomiči Nišimura','Masaki Terasoma','Fumihiko Tačiki','Hitoši Bifu','Jui Kano','Jóiči Nišidžima','Komina Macušita','Rika Morinaga','Fumio Macuoka',"Ken'iči Morozumi",'Džun Karasawa'],
basedOn:['Rei Hiroe'],
screenplay:['Sunao Katabuči'],
music:['Edison'],
camera:['Jukihiro Masumoto'],
cut:['Kašiko Kimura'],
sound:['Jasunori Honda'],
scenography:['Hidetoši Kaneko']},
{title:'Halt and Catch Fire',
titleCZ:'Halt and Catch Fire - PC Rebelové',
year:2014,
runtime:'30h 57min',
episodeRuntime:'42-60min',
countries:['USA'],
genres:['Drama'],
director:['Juan José Campanella','Jon Amiel','Ed Bianchi','Larysa Kondracki','Karyn Kusama','Terry McDonough','Johan Renck','Daisy von Scherler Mayer','Kimberly Peirce','Jeff Freilich','Jake Paltrow','Andrew McCarthy','Reed Morano','Phil Abraham','Craig Zisk','Christopher Cantwell','Meera Menon','Stacie Passon','So-yong Kim','Tricia Brock','Michael Morris'],
actors:['Lee Pace','Scoot McNairy','Mackenzie Davis','Kerry Bishé','Toby Huss','Scott Michael Foster','Aleksa Palladino','Jenna Bryant','D.B. Woodside','James Cromwell','Jason Vail','Stephen Caudill','Jim Gleason','Julie Ivey','Neko Parham','Michael Irby','Amy Parrish','David Silverman','Ted Huckabee','Brody Rose','Brett Gentile','Morgan Hinkleman','Martin Seifert','Keith Flippen','Nick Arapoglou','Jennifer Irwin','James DuMont','John Getz','Bill Stinchcomb','Elliott Grey',"Mark O'Brien",'Niko Nicotera','Annabeth Gish','Manish Dayal','Doug Savant','Wayne Pére','Gary Weeks','Jon Kohler','Moli Hall','Matthew Lillard','Joshua Brady','Joe Dinicol','Joe Massingill','Catherine Dyer','Elizabeth Ludlow','Jay Huguley','Anthony Reynolds','William J. Harrison','Geoff Schuppert','Amy Seimetz','Deja Dee','Graham Beckel','Lisa Sheridan','Maggie Elizabeth Jones','Will Greenberg','Jean Smart',"Annette O'Toole",'Jason Davis','David Sherrill','Chris Mulkey','Han Soto','Sean Bury','Lou Taylor Pucci','Barak Hardley','Griff Furst','Dane Rhodes','R. Keith Harris','Andrea Powell','Kevin Rankin','Michael May','Alexandra Bayless','Erin Cummings','Skylar Astin','Cuyle Carvin','Jose Miguel Vasquez','Lee Spencer','Heather Gilliland','Bianca Malinowski','Lenny Jacobson','Ricky Wayne','Jason Giuliano','August Emerson','Virginia Newcomb','Cooper Andrews','Michael Esper','Greg Sproles','David Wilson Barnes','Mike Pniewski','Scott Takeda','Javier Grajeda','Joshua Hoover','Stephen Michael Ayers','Lou Anne Cooper','Cathryn de Prume','Alano Miller','Kathryn Newton','Chelsea Talmadge','Joshua Sawtell','Blue Man Group','Miles Doleac'],
screenplay:['Zack Whedon','Jamie Pachino','Dahvi Waller','Angelina Burnett','Lisa Albert','Mark Lafferty','Christopher Cantwell','Christopher C. Rogers','Jonathan Lisco','Alison Tatlock','Julia Cho','Jason Cahill'],
production:['Jeff Freilich','Julia Cho'],
music:['Paul Haslinger'],
camera:['Nelson Cragg','Jeffrey Jur','Evans Brown'],
cut:['Victor Du Bois','Kelley Dixon','Kevin D. Ross','Robert Komatsu','Tom Wilson','Rachel Goodlett Katz','Chris McCaleb'],
sound:['Tim Kimmel','Andy King','Onnalee Blank','Mathew Waters','Keith Rogers','Scott Weber','Susan Cahill'],
scenography:['Craig Stearns','Ola Maslik','Lisa Alkofer','Lance Totten','Christopher Brown','Jon Carlos','Jeffrey Scott Taylor'],
masks:['Leay Cangelosi','Nikki Bell','Teresa Foshee'],
costumes:['Kimberly Adams-Galligan','Kathryn Morrison','Jennifer L. Bryan']},
{title:'Inside No. 9',
titleCZ:'V čísle 9',
year:2014,
runtime:'23h 36min',
episodeRuntime:'28-30min',
countries:['UK'],
genres:['Comedy'],
director:['David Kerr','Guillem Morales','Steve Pemberton','Graeme Harper','Dan Zeff','Reece Shearsmith',"Jim O'Hanlon",'Matt Lipsey','Louise Hooper','Al Campbell','Kieron J. Walsh','George Kane'],
actors:['Steve Pemberton','Reece Shearsmith','Gemma Arterton','Anna Chancellor','Adam Deacon','Tamsin Greig','Conleth Hill','Katherine Parkinson','Anne Reid','Sophie Thompson','Marc Wootton','Julian Rhind-Tutt','Luke Pasqualino','Ophelia Lovibond','Timothy West','Ben Willbond','Tim Key','Oona Chaplin','Denis Lawson','Kayvan Novak','Joyce Veheary','Lucy Hutchinson','David Bedella','Rosie Cavaliero','Julia Davis','Lyndsey Marshal','Helen McCrory','Julie Hesmondhalgh','Jessica Ellerby','Sean Buckley','Di Botcher','Trevor Cooper','Vicky Hall','Lorraine Ashbourne','Jim Howick','Cariad Llyod','Jessica Raine','Rula Lenska','Derek Jacobi','Dan Starkey','Aimee-Ffion Edwards','Tony Way','Alice Lowe','Naz Osmanoglu','Philip Glenister','Jason Watkins','Sarah Hadland','Tamzin Outhwaite','Javone Prince','Roger Sloman','Jessica Gunning','Jack Whitehall','Paul Copley','Tom Riley','Sheridan Smith','Paul Kaye','Sinead Matthews','Ruth Sheen','David Warner','Nikki Amuka-Bird','Jane Horrocks','Claire Skinner','Sophie McShera','Alison Steadman','Alexandra Roach','Richard Cordery','Michele Dotrice','Bruce Mackinnon','Mathew Baynton','Keeley Hawes','Cavan Clerkin','Chris Wilson','Kevin Eldon','Tanya Franks','Rory Kinnear','Hattie Morahan','Bill Paterson','Marcia Warren','Sian Gibson','Monica Dolan','Nick Moran','David Calder','Emilia Fox','Nicola Walker','Kenneth Cranham','Noel Clarke','Zoë Wanamaker','Fenella Woolgar','Phoebe Sparrow','Nigel Planer','Weruche Opia','Helen Monks','Mark Benton','Rufus Jones','Caden Ellis Wall','Stacy Liu','Eve Austin','Jenna Coleman','Kadiff Kirwan','Sarah Solemani'],
screenplay:['Steve Pemberton','Reece Shearsmith'],
production:['Adam Tandy','Claire McCarthy','Kim Crowther'],
music:['Christian Henson'],
camera:['Stephan Pehrsson','John Sorapure','Tony Coldwell','James Moss'],
cut:['Alan Levy','Peter Oliver'],
sound:['Keith Nixon','Chris MacLean','Alex Thompson','Bob Newton'],
scenography:['Tom Sayer','Simon Rogers','Amy Maguire','Paul Rowan','Dennis De Groot','Thorin Thompson'],
masks:['Matthew Smith','Helena Jopling','Lisa Cartlidge'],
costumes:['June Nevin','Yves Barre']},
{title:'Unsolved',
titleCZ:'Nevyšetřeno',
year:2018,
runtime:'7h 43min',
episodeRuntime:'44-56min',
countries:['USA'],
genres:['Biographic','Crime'],
director:['Anthony Hemingway','Kate Woods','Ernest R. Dickerson','Darren Grant','Erica Watson'],
actors:['Josh Duhamel','Bokeem Woodbine','Wavyy Jonez','Marcc Rose','Jimmi Simpson','Rhys Coiro','Amirah Vann','Brent Sexton','Jamie McShane','Dominic L. Santana','Laurie Fortier','Michael Harney','Luke James','Scott Michael Campbell','Lahmard J. Tate','Aisha Hinds','Wendell Pierce','Maestro Harrell','Spencer Garrett','Camille Chen','Patrick St. Esprit','Page Kennedy','Aleksa Palladino','Brian Guest','Ford Austin','LeToya Luckett-Walker','P.J. Marshall','Rick Otto','Aaron V. Williamson','Michael Beach','Omar Gooding','Brie Carter','Greg Kading','Pooch Hall','Dorian Missick','Ian Reed Kesler','James Bland','Davetta Sherwood','Donald Faison','Malik Barnhardt','Erin Coker','Antwon Tanner','Jim Titus','V.J. Foster','Christian Isaiah','Eli Bildner','Abraham Clinkscales','Chris Jones','Tommie Earl Jenkins','Danny Vasquez','Michelle Hayden','Jamie Hector','Kevin Phillips','Abby Brammell','Nakia Burrise','James Darnell','David L. King','Celeste Thorson','Sola Bamis','Lobo Sebastian','Brett Edwards','Gabriela Fresquez','Kareem J. Grimes','Jawed El Berni','Dominic Hoffman','Skylan Brooks','Amin Joseph','Yvette Nicole Brown','Bresha Webb','Idara Victor','J. Anthony Pena','Jeff Davis','Chris Bauer','Michael Trotter','Pat Asanti','Avery Kidd Waddell','Kevyn Bashore','Garland Whitt','Granville Ames','Lorin Doctor','Janet Song','Suge Knight','Funkmaster Flex','Elizabeth Ruiz','Ken Weiler','Chris Ufland','Scott Rinker','Colin Powell','Michael Bolwaire','Maurice J. Irvin','Marlon Aquino','Cisco Reyes','Terrence Terrell','Woody McClain','Jerry Ying','Petra Sprecher'],
basedOn:['Greg Kading'],
screenplay:['Kyle Long','Denitria Harris-Lawrence','Jameal Turner','Chris Downey','Natasha Tash Gray','Samir Mehta'],
music:['Joseph Trapanese'],
camera:['Sidney Sidell','Kevin McKnight'],
cut:['Zack Arnold','Melissa Lawson Cheung','Stewart Schill','Karoliina Tuovinen'],
sound:['Frank Morrone'],
scenography:['Maria Caso','Meghan C. Rogers','Claire Kaufman','Brent David Mannon','Oana Bogdan Miller'],
masks:['Shian S. Banks'],
costumes:['Dahlia Foroutan','Rahimah Yoba']},
{title:'Steven Universe',
titleCZ:'Steven Universe',
year:2013,
runtime:'34h 58min',
episodeRuntime:'7-44min',
countries:['USA'],
genres:['Animation','Action','Comedy','Family','Fantasy'],
director:['Alonso Ramirez Ramos','Joseph D. Johnston','Kat Morris','Phil Rynda','Ian Jones-Quartey','Nick DeMayo','Sang-Un Jeon','Sangman Park','Seung Wook Shin','Hee Man Yang','Maureen Mlynarczyk'],
actors:['Matthew Moy','Kate Micucci','Tom Scharpling','Dee Bradley Baker','Atticus Shaffer','Estelle','Kevin Michael Richardson','Godfrey','Eric Bauza','Toks Olagundoye','Eugene Cordero','Olivia Olson','Colton Dunn','Nicki Minaj','Rebecca Sugar','Uzo Aduba','Ian Jones-Quartey','Aparna Nancherla','Nancy Linari','Jinkx Monsoon','Jennifer Paz','Peter Browngardt','Joel Hodgson','Marieve Herington','Zach Callison','Della Saba','Jon Wurster','Shoniqua Shandai','Kimberly Brooks','Michaela Dietz','Deedee Magno','Sinbad','Grace Rolek','Reagan Gomez-Preston','Chris Jai Alex','Aimee Mann','Lamar Abrams','Brian Posehn','Susan Egan','Shelby Rabara','AJ Michalka','Mason Cook','Eric Bell Jr.','Erica Luttrell','Charlyne Yi','Adam Devine','Jackie Buscarino','Kate Flannery','Patti LuPone','Natasha Lyonne','Brian George','Dave Willis','Lisa Hannigan','Cristina Valenzuela','Martha Higareda','Amy Sedaris','Enuka Okuma','Ashly Burch','Joan Jett','Zach Steel','Christine Ebersole','Michelle Maryk','Indya Moore','Johnny Hawkes','Jemaine Clement','Sarah Stiles','Crispin Freeman','Andrew Kishino','Mary Elizabeth McGlynn'],
screenplay:['Rebecca Sugar','Matt Burnett','Ben Levin','Ian Jones-Quartey','Matt Braly','Joseph D. Johnston','Madeline Queripel','Kat Morris','Miki Brewster','Jeff Liu','Raven Molisee','Paul Villeco','Lamar Abrams','Hilary Florido','Katie Mitroff','Hellen Jo','Jesse Zukauskas','Tom Herpich','Adam Muto','Aaron Austin','Amish Kumar','Etienne Guignard','Drew Green','Colin Howard'],
production:['Peter Browngardt','Chuck Austen','Jackie Buscarino','Nate Funaro'],
music:['Aivi Tran','Steven Velema','Jon Baken','Jeff Ball'],
cut:['Paul Douglas'],
sound:['Timothy J. Borquez','Thomas Syslo','Pedro Sánchez Alonso','Tony Orozco','Eric Freeman','Patrick Janssen'],
scenography:['Kevin Dart','Elle Michalka','Jasmin Lai','Ricky Cometa','Liz Artinian','Sue Mondt']},
{title:'Ferry: The Series',
titleCZ:'Ferry: Seriál',
year:2023,
runtime:'6h 6min',
episodeRuntime:'36-52min',
countries:['Belgium','Nizozemsko'],
genres:['Crime','Drama','Thriller'],
director:['Eshref Reybrouck','Joël Vanhoebrouck'],
actors:['Frank Lammers','Moora Vander Veken','Max Croes','Elise Schaap','Yannick van de Velde','Raymond Thiry','Huub Smit','Tim Haars','Poal Cairo','Steef Cuijpers','Koen De Graeve','Alice Reys','Kevin Janssens','Monic Hendrickx','Tygo Gernandt','Dirk Roofthooft'],
screenplay:['Nico Moolenaar']},
{title:'The X-Files',
titleCZ:'Akta X',
year:1993,
runtime:'162h 42min',
episodeRuntime:'42-86min',
countries:['USA','Canada'],
genres:['Drama','Horror','Thriller','Mystery','Sci-Fi','Comedy'],
director:['Kim Manners','Rob Bowman','Chris Carter','David Nutter','R.W. Goodwin','Tony Wharmby','Michael W. Watkins','Daniel Sackheim','Michael Lange','James Wong','Cliff Bole','Jim Charleston','Gillian Anderson','David Duchovny','Frank Spotnitz','John Shiban','Vince Gilligan','Michael Katleman','Jerrold Freedman','Harry Longstreet','William A. Graham','Robert Mandel','Larry Shaw','Fred Gerber','Michelle MacLaren','Ralph Hemecker','Joe Napolitano','Richard Compton','James Whitmore Jr.','Thomas J. Wright','Rod Hardy','Win Phelps','Tucker Gates','Stephen Surjik','Nick Marck','Michael Vejar','James A. Contner','Peter Markle','Allen Coulter','Bryan Spicer','Robert Lieberman','Paul Shapiro','Brett Dowler',"Terrence O'Hara",'Dwight H. Little','Darin Morgan','Glen Morgan','Kevin Hooks','Carol Banker','Holly Dale'],
actors:['Gillian Anderson','David Duchovny','Mitch Pileggi','Robert Patrick','Annabeth Gish','William B. Davis','Tom Braidwood','Bruce Harwood','Dean Haglund','Nicholas Lea','James Pickens Jr.','Sheila Larken','Chris Owens','Steven Williams','Jerry Hardin','Laurie Holden','Rebecca Toolan','Brian Thompson','Arlene Pileggi','Brendan Beiser','John Neville','Cliff De Young','Gabrielle Rose','Doug Hutchison','Donal Logue','Carrie Snodgress','Donald Gibb','Claire Stansfield','Michael MacRae','Andrew Airlie','Barry Primus','Veena Sood','Blu Mankuma','Xander Berkeley','Felicity Huffman','Ken Kirzinger','Ed Lauter','Susanna Thompson','Marshall Bell','Harriet Sansom Harris','Amanda Pays','Mark Sheppard','Keegan MacIntosh','Brad Dourif','Don S. Davis','Robyn Lively',"Floyd 'Red Crow' Westerman",'Alan Dale','Suleka Mathew','Sarah Strange','Octavia Spencer','Leon Russom','Titus Welliver','Aaron Paul','Dean Norris','Zuleikha Robinson','Vincent Schiavelli','Garret Dillahunt','Karin Konoval','Michael Chieffo','Henry Mah','April Grace','Michael Welch','Ken Jenkins','Valarie Pettiford','Kathryn Joosten','Sharon Madden','Heather Charles','Seth Green','Adam Baldwin','Kate Luyben','A. J. Buckley','Glenn Morshower','Anthony Rapp','Christine Willes','Catherine Lough Haggquist','Danielle Savre','Jesse L. Martin','David Faustino','Aaron Poole','Kiara Hunter','Carrie Hamilton','Bellamy Young','Penny Johnson Jerald','Brian Leckner','Paul McGillion','Chris Carter','Roz Witt','Derick Alexander','Maria Luisa Cianni','Michael Berryman','Constance Zimmer','Gary Grubbs','Mimi Rogers','Karl T. Wright','Caroline Lagerfelt',"Michael O'Neill",'Tara Karsian','Ernie Lively','Justine Miceli'],
screenplay:['Chris Carter','Frank Spotnitz','Vince Gilligan','John Shiban','Howard Gordon','Glen Morgan','James Wong','David Amann','Darin Morgan','Alex Gansa','Jeffrey Bell','Steven Maeda','Steve De Jarnatt','William Gibson','David Duchovny','Gillian Anderson','Chris Brancato','Thomas Schnauz','Jessica Scott','Sara B. Cooper','Jeff Vlaming','Kenneth Biller','Tim Minear','R.W. Goodwin','Mike Wollaeger','Stephen King','William B. Davis','Tom Maddox','Kenneth H. Hawryliw','Chip Johannessen','Greg Walker','Charles Grant Craig','David Greenwalt','Kim Newton','Paul Brown','Daniel Arkin','Chris Ruppenthal','Marilyn Osborn','Jim Guttridge','Kristen Cloke','Mat Beck'],
music:['Mark Snow'],
camera:['Bill Roe','John S. Bartley','Joel Ransom','Jon Joffin','Craig Wrobleski','Thomas Del Ruth','Ron Stannett']},
{title:'The Night Manager',
titleCZ:'The Night Manager',
year:2016,
runtime:null,
episodeRuntime:'6h60min',
countries:['UK'],
genres:['Crime','Drama'],
director:['Susanne Bier'],
actors:['Tom Hiddleston','Olivia Colman','Hugh Laurie','Elizabeth Debicki','Tom Hollander','Michael Nardone','Alistair Petrie','David Harewood','Katherine Kelly','Tobias Menzies','Neil Morrissey','Jonathan Aris','Douglas Hodge','David Avery','Aure Atika','Bijan Daneshmand','Antonio de la Torre','Hovik Keuchkerian','Jorge Suquet','Russell Tovey','Adeel Akhtar','Natasha Little','Gertrude Thoma','Nader Boussandel','Sara Stewart','Noah Jupe','Branwell Donaghey','Simona Brown','Andrei Zayats','John le Carré','Hannah Steele','Amir El-Masry','Aymen Hamdouchi','Marta Torné','Fleur Keith','Aziz Dhiouer','Mansour Badri',"Kevin O'Loughlin",'Said Taibi','Alice Bier Zanden','Sam Redford','Salvador Oliva','Bartholomew Cariss','Erich Redman','Gido Schimanski'],
basedOn:['John le Carré'],
screenplay:['David Farr'],
production:['Simon Cornwell'],
music:['Víctor Reyes'],
camera:['Michael Snyman'],
cut:['Ben Lester'],
sound:['Howard Bargroff'],
scenography:['Lucienne Suren'],
costumes:['Signe Sejlund']},
{title:'Archer',
titleCZ:'Archer',
year:2009,
runtime:'53h 53min',
episodeRuntime:'21-65min',
countries:['USA'],
genres:['Animation','Action','Comedy'],
director:['Adam Reed','Bryan Fordney','Mack Williams','Marcus Rosentrater','Megan Johnson','Chad Hurd','Pierre Cerrato','Casey Willis','Matt Thompson','Chi Duong','Justin Wagner','Yusuke Sato','Kim Feigenbaum'],
actors:['H. Jon Benjamin','Judy Greer','Chris Parnell','Aisha Tyler','Jessica Walter','Jeffrey Tambor','George Coe','Maggie Wheeler','Adam Reed','René Auberjonois','Joan Van Ark','David Cross','Bryan Cranston','James Hong','Burt Reynolds','John Paul Tremblay','Ona Grauer','Coby Bell','Brett Butler','Kat Cressida','Ron Perlman','Christian Slater','Kenny Loggins','Kari Wahlgren','Omid Abtahi','CCH Pounder','Lauren Cohan','Carla Jimenez','Vernee Watson','Dave Willis','Wyatt Cenac','Keegan-Michael Key','Wendell Pierce','John Roberts',"John O'Hurley",'Shelly Desai','Eugene Mirman','Armando Valdes-Kennedy','Blake Perlman','Zach Villa','Pierre Cerrato',"D'Arcy Carden",'Neal Holman','Keith Szarabajka','Eric Sims','Enn Reitel','David Boat','Peter Newman','Jon Curry','Cedric Pendleton','Stephen Stanton','Joe Hanna','Michael Gray','Brian T. Delaney','Patrick Piper','Amber Nash','Audrey Wasilewski','Lucky Yates','Thomas Lennon','Robert Ben Garant','Nika Futterman','Clarke Peters','Roy McCrerey','Peter Serafinowicz','Rachael Harris','Heaven MacPherson','Casey Willis','Charles Napier','Darren Criss','Craig Ferguson','Tom Kane','Patrick Warburton','Joaquim de Almeida','Robb Wells','Mike Smith','George Takei','Paula Malcomson','Jack McBrayer','Michael Rooker','Steve Cirbus','Ron Leibman','Timothy Olyphant','Jamie Moss','Anthony Bourdain','Dayton Callie','Nick Searcy','Hoon Lee','Fred Tatasciore','Jon Hamm','Kristen Schaal','Matt Thompson','Fred Armisen','Gary Cole','Clancy Brown','Togo Igawa','Carlos Alazraqui','Rob Huebel','Allison Tolman','Kumail Nanjiani','Keith David'],
screenplay:['Chris Provenzano','Adam Reed','Mehar Sethi','Ben Hoffman','Kelly Galuska','Matt Thompson','Rick Cleveland','Mike Arnold','Casey Willis','Mark Ganek','Shane Kosakowski','Tesha Kondrat','Shana Gohd','Matt Roller','Brittany Miller','Asha Michelle Wilson','Alison Zeidman'],
production:["Chris 'Casper' Kelly",'Neal Holman','Eric Sims','Jeff Fastner','Mollie Brock','Mack Williams','Casey Willis','Bryan Fordney','Chad Hurd','Pierre Cerrato','Marcus Rosentrater','Justin Wagner'],
music:['J.G. Thirlwell','Michael Kohler','J.C. Richardson'],
cut:['Pierre Cerrato','Brad Lee Zimmerman','Christian Danley','Nate Ladd','Andy Sipes','Ted Murphy'],
sound:['Michael Kohler','J.C. Richardson','Frank Verderosa'],
scenography:['Neal Holman','Chad Hurd','Adam Toews','Justin Wagner']},
{title:'Vinyl',
titleCZ:'Vinyl',
year:2016,
runtime:'10h 17min',
episodeRuntime:'52-113min',
countries:['USA'],
genres:['Drama','Music'],
director:['Martin Scorsese','Allen Coulter','Mark Romanek','S.J. Clarkson','Peter Sollett','Nicole Kassell','Jon S. Baird','Carl Franklin'],
actors:['Bobby Cannavale','Olivia Wilde','Ray Romano','Ato Essandoh','Max Casella','P.J. Byrne','J.C. MacKenzie','Birgitte Hjort Sørensen','Juno Temple','Jack Quaid','Paul Ben-Victor','Andrew Dice Clay','Robert Funaro','Joe Caniano','Madison McKinley','Maria Di Angelis','Liz Celeste','Susan Heyward','Richard Short','Mike Steinmetz','Rodrigo Lopresti','Aly Mang','Angelica Boccella','Jill Larson','Griffin Newman','Ephraim Sykes','Nicola Fiore','Kristoffer Cusick','Jay Klaitz','Dustin Ingram','Annie Parisse','Michael Drayer','David Proval','Val Emmich','Allen Coulter','Terence Winter','David Vadim','Ian Hart','Anna Šerbinina','Danny A. Abeckaser','Jeff Biehl','John Cenatiempo','John Rue','Till Schauder','Pernell Walker','James Jagger','John Cameron Mitchell','Emily Tremaine','Carrington Vilmont','Dustin Payseur','Jack Doyle Smith','Lena Olin','Ken Marino','Roberta Wallach','Gregory Bastien','Thomas Gardner','Daniel J. Watts','Scott Stangland','Erin Cressida Wilson','Noah Bean','Douglas Smith','Samantha Buck','Nadia Kay','Kenneth Pattengale','Chris Anderson','Gene Jones','John Ventimiglia','Michael Kostroff','Travis Quentin Young','Tom Sierchio','Clara Wong','Christian Navarro','Nathan James','Michael J. Burg','Kelly Aaron','Brian Shoaf','Stephen DeRosa','Keston John','Kati Rediger','Jennifer Suter','Chris Cardillo','Bo Dietl','Tina Benko','Max Curnin','Connor Hanwick','Armen Garo','Adam Wade McLaughlin','Rony Clanton','Catherine Stephen','Dave Shalansky','Nika Ezell Pappas','Greg Vrotsos','Armando Riesco','Allen McCullough','Alex Van Zeelandt','Giovanni Celentano','James Kautz','Dominique Johnson','Maury Ginsberg','Lawrence Jansen'],
screenplay:['Terence Winter','Mick Jagger','Adam Rapp','Jonathan Tropper','George Mastras','Debora Cahn','Erin Cressida Wilson','Carl Capotorto','David Matthews','Michael Mitnick','Riccardo DiLoreto'],
production:['Jessica Levin','Mari-Jo Winkler','Erin Cressida Wilson','David Matthews','Brad Carpenter'],
camera:['Reed Morano','David Franco','Rodrigo Prieto'],
cut:['Tim Streeto','Kate Sanford','Perri B. Frank','David Tedeschi'],
sound:['Tom Fleischman','Schavaria Reeves'],
scenography:['Bill Groom','Bob Shaw','Regina Graves'],
masks:['Sarah Tollenaar','Shellie Biviens','Kim Simmons','Rachel Geary','Patrick Alemi','Nicki Ledermann','Lena Jemmott','Kevin Kirkpatrick'],
costumes:['Mark Bridges','John Dunn']},
{title:'The Company',
titleCZ:'V síti CIA',
year:2007,
runtime:null,
episodeRuntime:'Alternativní 6x45min',
countries:['USA'],
genres:['History','Thriller','Drama'],
director:['Mikael Salomon'],
actors:["Chris O'Donnell",'Alfred Molina','Michael Keaton','Rory Cochrane','Alessandro Nivola','Tom Hollander','Simon Callow','Péter Fancsikai','Judah Katz','Matt Lindquist','Natascha McElhone','Raoul Bova','Ulrich Thomsen','Alexandra Maria Lara','Ted Atherton','Erika Marozsán','JB Blanc','Kristin Booth','Phillip MacKenzie','Anna Silk','Antony Sher','Mišel Matičević','Rick Roberts','Hristo Mitzkov','Constantine Gregory','Dan Petronijevic','Stephen Bogaert','Cedric Smith','Martin Doyle','Rahnuma Panthaky','Joe Lisi','Leonid Alimov','Catherine McNally','Barry Flatman','Gábor Nagypál','Zoltán Berzsenyi','László Konter','László Keszég','Paul Mota','Ramón Franco','Péter Kertész','Chuck Shamata','Ferenc Elek','Scott Alexander Young'],
basedOn:['Robert Littell'],
screenplay:['Ken Nolan'],
production:['Robert Bernacchi','Andrej Kamorin'],
music:['Jeff Beal'],
camera:['Ben Nott'],
cut:['Robert A. Ferretti','Scott Vickrey'],
sound:['Mac Ruth','Nello Torri','Alan Decker'],
scenography:['Marek Dobrowolski','William A. Cimino','Zoltán Horváth'],
masks:['Trefor Proud','Katalin Jakóts'],
costumes:['Michael T. Boyd']},
{title:'Northern Exposure',
titleCZ:'Zapadákov',
year:1990,
runtime:'82h 30min',
episodeRuntime:'45min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Adam Arkin','Stuart Margolin','Randall Miller','Jack Bender','Dan Lerner','Tom Moore','Steven Robman','Daniel Attias','Lorraine Senna',"Peter O'Fallon",'Scott Paulin',"Bill D'Elia",'Max Tash','Janet Greek','Nick Marck','Dean Parisot','Michael Lange','John David Coles','Jim Charleston','David Carson','Michael Katleman','Michael Fresco','Sandy Smolan','James Hayman','Oz Scott','Joe Napolitano','Stephen Cragg','Joan Tewkesbury','Frank Prinzi','Win Phelps','Victor Lobl','Patrick McKee','Lee Shallat Chemel','Miles Watkins','Joshua Brand','Mark Horowitz','Thomas R. Moore','Matthew Nodella','Rob Thompson','Michael Vittes'],
actors:['Barry Corbin','Janine Turner','John Cullum','Darren E. Burrows','John Corbett','Cynthia Geary','Elaine Miles','Peg Phillips','Rob Morrow','William J. White','Moultrie Patten','Teri Polo','Jillian Armenante','Jerry Adler','Graham Greene','Anthony Edwards','Paul Provenza','David Hemmings','Mark Pellegrino',"Floyd 'Red Crow' Westerman",'Patrick Warburton','Darlene Vogel','Michelle Thrush','Floyd Van Buskirk','Sparkle','Ned Romero','Beth Broderick','Garrett Bennett','Christine Elise','Kimberly Guerrero','John Hawkes','Lindsay Parker','Ashleigh Aston Moore','Charles Braverman','Vito Scotti','Dylan Baker','Wayne Pére','Joyce Van Patten','Tara Subkoff','Edan Gross','Alix Koromzay','Phil Fondacaro','Brandon Douglas','Delia Sheppard','Harriet Medin','John Murray','Stephen Root','John M. Jackson','James Marsters','Art LaFleur','David Spielberg','Diane Delano','Richard Romanus','Gary Taylor','Remy Ryan',"Sean O'Bryan",'Don McManus','Wally Dalton','John Billingsley','Jared Rushton','Valerie Mahaffey','Adam Ant','Margaret Mason','Bill Irwin','Denice Duff','Andreas Wisniewski','Ocean Hellman','Gabriel Judet-Weinshel','Charmaine Craig','Joaquín Martínez','Lisa Darr','Bibi Besch','Felicity Waterman','Jim Haynie','John Aylward','Jessica Lundy','Brian George','Debra Mooney','John McLiam','Ken Schneider','Clement von Franckenstein','Alan Fudge','Allan Miller','Tim Sampson','Jack Kehler','Gérard Ismaël','Krisha Fairchild','Joel Polis','Eloy Casados','Time Winters','Markus Flanagan','Joanna Merlin','Anne De Salvo','John Mese','Ralph P. Martin','Christa Miller','Simon Templeman','David Margulies','Micole Mercurio','Norbert Weisser'],
screenplay:['Diane Frolov','Andrew Schneider','Sam Egan','David Chase','Jerry Stahl','Barbara Hall','Jeff Vlaming','Meredith Stiehm','Mitchell Burgess','Robin Green','Joshua Brand','John Falsey','Patrick Sean Clark','Jeff Melvoin','Robert Rabinowitz','Jed Seidel','Jordan Budde','Mark B. Perry','Ellen Herman','Christian Williams','Steve Wasserman','Jessica Klein','Kate Boutilier','Geoffrey Neigher','Rogers Turrentine','Karen Hall','Dennis Koenig','Sy Rosen','Charles Rosin'],
production:['Cheryl Bloch','Diane Frolov','Robin Green','Jeff Melvoin','Michael Vittes','Rob Thompson','Michael Fresco','Matthew Nodella','Robert T. Skodis','Charles Rosin'],
music:['David Schwartz'],
camera:['Gordon Lonsdale','Frank Prinzi','James Hayman','Scott Williams','James A. Lebovitz'],
cut:['Thomas R. Moore','Adam Wolfe','Briana London','Alec Smight','David Strohmaier','Jonathan Pontell','Sharon Silverman','Robert Boucher','Pam Ziegenhagen','Dana E. Glauberman'],
sound:['Dan Hiland','Jon Taylor','Christian P. Minkler','Dean Okrand','Bill Thiederman','Kevin Patrick Burns','R. Russell Smith','Greg Orloff',"Anthony D'Amico",'Garrie Bolger','William H. Angarola','Peter Cole','Gary Gegan','Richard Taylor','Thomas DeGorter','Mike Getlin','Art Ottinger','Robert Glass','Stanley Kastner'],
scenography:['Woody Crocker','Phil Peters','Kenneth Berg','Lachlin Loud','Woody Crocker','Lori Melendy','Robert Stover','Bart Hilliker','Gene Serdena'],
masks:['Denise Dellavalle','Joni Powell','Rebecca Lynne','Bryn E. Leetch'],
costumes:['Katharine Bentley']},
{title:'Doctor Foster',
titleCZ:'Doktorka Fosterová',
year:2015,
runtime:'9h 47min',
episodeRuntime:'57-60min',
countries:['UK'],
genres:['Drama'],
director:['Tom Vaughan','Bruce Goodison','Jeremy Lovering'],
actors:['Suranne Jones','Bertie Carvel','Jodie Comer','Cian Barry','Sara Stewart','Victoria Hamilton','Neil Stuke','Robert Pugh','Cheryl Campbell','Paul Blackwell','Peter De Jersey','Tom Taylor','Elizabeth Rider','Martha Howe-Douglas','Clare-Hope Ashitey','Adam James','Charlie Cunniffe','Navin Chowdhry','Ricky Nixon','Matthew David McCarthy','Daniel Cerqueira','Sian Brooke','Philip Wright','Varada Sethu','Kezia Burrows','Danny Szam','Prasanna Puwanarajah','Helena Lymbery','Charlotte McKinney','Thusitha Jayasundera','Emily Lloyd-Saini','Nneka Okoye','Sam Redford','Laura Crowhurst','Harriet Kemsley'],
screenplay:['Mike Bartlett'],
production:['Kate Crowther','Grainne Marmion'],
music:['Frans Bak','Stuart Earl'],
camera:['Jean-Philippe Gossart','Ben Wheeler','Joel Devlin'],
cut:['Tom Hemmings'],
scenography:['Simon Rogers'],
costumes:['Alexandra Caulfield','Jo Slater']},
{title:'Aggretsuko',
titleCZ:'Aggressive Retsuko',
year:2018,
runtime:'14h 55min',
episodeRuntime:'15-34min',
countries:['Japan'],
genres:['Animation','Comedy'],
director:['Rareko'],
actors:['Kaolip','Rareko','Šingo Kató','Sóta Arai','Maki Curuta','Komegumi Koiwasaki','Júki Kadži','Rina Inóe','Jóhei Azakami','Juki Takahaši','Čiharu Sasa','Kósuke Mijauči','Sayumi','Arisa','Rima','Akiko Ucumi','Kacuhisa Hóki','Mewhan'],
screenplay:['Rareko'],
music:['Satoši Hóno','Nacumi Tabuči','Hanae Nakamura','Miki Sakurai','Tacuhiko Saiki'],
sound:['Kóhei Čida']},
{title:'Shigurui: Death Frenzy',
titleCZ:'Šigurui',
year:2007,
runtime:'4h 48min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Drama','History'],
director:['Hiroši Hamasaki','Naojasu Habu'],
actors:['Daisuke Namikawa','Nozomu Sasaki','Hóko Kuwašima','Bin Šimada','Micuko Horie','Šózó Iizuka','Tamio Óki','Kjóko Hikami','Kósuke Meguro','Júsaku Jara','Osamu Saka','Minoru Inaba','Jasuhiro Fudžiwara','Asako Dodo','Masaši Hirose','Rino Marimo','Asami Jaguči','Čó','Emi Šinohara','Juzuru Fudžimoto','Kendži Nomura','Jukitoši Tokumoto',"Masa'aki Cukada",'Seizó Kató','Tomohisa Asó','Takaši Kondó','Jošisada Sakaguči','Masaki Terasoma','Júki Macuda','Rjúnosuke Óbajaši','Takajuki Okada','Motomu Kijokawa','Taiten Kusunoki','Kjóko Hamura','Rikija Kojama','Tadahisa Saizen','Hiromu Kondó','Motoi Kojanagi','Haruka Kimura','Kijoko Nagaki','Fumiaki Sakabe','Jošihiro Kanemicu','Jasujoši Hara','Misato Sakamoto'],
basedOn:['Norio Nanjo'],
screenplay:['Seiši Minakami'],
music:['Kiyoshi Yoshida'],
camera:['Jukihiro Masumoto'],
cut:['Satoši Terauči'],
sound:['Jasunori Honda'],
scenography:['Hidetoši Kaneko']},
{title:'My Name Is Earl',
titleCZ:'Jmenuju se Earl',
year:2005,
runtime:'35h 18min',
episodeRuntime:'21-25min',
countries:['USA'],
genres:['Comedy'],
director:['Tamra Davis','Chris Koch','Lev L. Spiro','Ken Whittingham','Michael Fresco','Victor Nelli Jr.','Eyal Gordin','Millicent Shelton','Marc Buckland','Craig Zisk','Gail Mancuso','Jason Ensler','John Putch','Allison Liddi-Brown','Gregory Thomas Garcia','Mike Mariano'],
actors:['Jason Lee','Ethan Suplee','Jaime Pressly','Eddie Steeples','Nadine Velazquez','Dale Dickey','Timothy Stack','Giovanni Ribisi','Beau Bridges','Nancy Lenehan','Gigi Goff','Craig T. Nelson',"Mike O'Malley",'Derek Mears','Malcolm David Kelley','Marlee Matlin','Larry Hankin','Beth Grant','Silas Weir Mitchell','Lindsay Hollister','Leo Fitzpatrick','Lisa K. Wyatt','Kadeem Hardison','Dennis Burkley','Johnny Sneed','Chloë Grace Moretz','Shailene Woodley','Alyssa Milano','Rigo Sanchez','Mona Weiss','Kathryn Joosten','DJ Qualls','Kevin Rankin','Jon Heder','Carel Struycken','Frank Collison','Skyler Gisondo','Angel Oquendo','Samm Levine','Cody Klop','Julanne Chidi Hill','Katy Mixon','Jimmi Simpson','Arjay Smith','Tyler Kain','Mindy Sterling','Tatum McCann','Danny Glover','Johnny Galecki','Joel David Moore','Jon Favreau','Adam Goldberg','Juliette Lewis','Darcy Rose Byrnes','Kara R. Stribling','Don Swayze','Betty White','John DiMaggio','Don Perry','Julian Berlin','Beth Riesgraf','Raymond Cruz','Larry Joe Campbell','Brie Gabrielle','Deborah Ann Woll','Jason Priestley','Chelcie Ross','Mark Christopher Lawrence','Jane Seymour','Ravi Kapoor','Sean Astin','Penny Balfour','Scoot McNairy','Nikki Magnusson','Shelby Rabara','Trish Gates','Michael Bailey Smith','Geoffrey Lewis','Christian Slater','John Leguizamo','John Waters','Roseanne Barr','Burt Reynolds','Charles S. Dutton','Michael Rapaport','Victor Raider-Wexler','Paris Hilton','Michael Peña','Tamala Jones','Emilio Rivera','David Paymer','Seth Green','Ewen Bremner','Christine Taylor','Bob Clendenin','Ben Foster','Erik Estrada','Jack Betts','Jeff Lewis','Jessica Cauffiel'],
screenplay:['Gregory Thomas Garcia','Brad Copeland','Victor Fresco','Timothy Stack','Matthew Thompson','Vali Chandrasekaran','Matt Ward','Ralph Greene','Mike Mariano','Barbie Adler','Alan Kirschenbaum','Hunter Covington','Hilary Winston','Bobby Bowman','Erika Kaestle','Patrick McCarthy','Danielle Sanchez-Witzel','Kat Likkel','Chrissy Pietrosh','Jessica Goldstein','John Hoberg'],
production:['Jason Lee','Mike Mariano','Hilary Winston','Erika Kaestle','Patrick McCarthy','Kat Likkel','Chrissy Pietrosh','Jessica Goldstein'],
music:['Danny Lux','Mark Leggett'],
camera:['Eyal Gordin','Michael Goi','Feliks Parnell','Walt Fraser'],
cut:['Lance Luckey','Dan Riddle','Janet Ashikaga','William Marrinson'],
sound:['Peter Kelsey','David Rawlinson','Richard Mercado'],
scenography:['Randy Ser','Gregory S. Melton','Debra Combs','Julie Kaye Fanton'],
masks:['Kenny Niederbaumer','Audrey Futterman-Stern'],
costumes:['Giovanna Ottobre-Melton','Robin Kennedy']},
{title:'Loki',
titleCZ:'Loki',
year:2021,
runtime:null,
episodeRuntime:'10h42-59min',
countries:['USA'],
genres:['Action','Adventure','Fantasy','Sci-Fi'],
director:['Kate Herron','Justin Benson','Aaron Moorhead','Dan DeLeeuw','Kasra Farahani'],
actors:['Tom Hiddleston','Sophia Di Martino','Richard E. Grant','Gugu Mbatha-Raw','Owen Wilson','Cailey Fleming','Michael Rose','Wunmi Mosaku','Sasha Lane','Eugene Cordero','Tara Strong','Derek Russo','Erika Coleman','Josh Fadem','Philip Fornah','Michelle Rose','Daniel Newman','Ravi Naidu','Josh Brolin','Robert Downey Jr.','Chris Evans','Clark Gregg','Chris Hemsworth','Anthony Hopkins','Scarlett Johansson','Jeremy Renner','Mark Ruffalo','Rene Russo','Tessa Thompson','Aaron Beelner','Susan Gallagher','Alex Van','Ben VanderMey','Jwaundace Candece','Malerie Grady','Chris Hemsworth','Jonathan Majors','Jack Veal','Hannah Aslesen','Alec Zais','Kate Berlant','Ilan Muallem','Jordan Woods-Robinson','Austin Freeman','Ricky Muse','Zele Avradopoulos','Deobia Oparei','Nicholas Anthony Zarrillo','Robert Pralgo','Jaimie Alexander','Neil Ellice','Sarafina King','Anthony Mackie','Chadwick Boseman','Evangeline Lilly','Paul Rudd','Chris Pratt','Michael Douglas','Brie Larson','Bradley Cooper','Taika Waititi','Pom Klementieff','Sebastian Stan','Tom Holland','Benedict Cumberbatch','Paul Bettany','Lou Ferrigno','Michael B. Jordan','Ben Mendelsohn','Elizabeth Olsen','Samuel L. Jackson','Danai Gurira','Letitia Wright','Mads Mikkelsen','Richard E. Grant','Neil Armstrong','Greta Thunberg','Malala Yousafzai','Nelson Mandela','Maya Angelou','Lucius Baston','Raphael Luce','Rafael Casal','Lauren Revard','Ke Huy Quan','Dayna Beilenson','Kate Dickie','Richard Dixon','Liz Carr','Vinii Khullar'],
basedOn:['Stan Lee','Larry Lieber','Jack Kirby'],
screenplay:['Michael Waldron','Tom Kauffman','Bisha K. Ali','Eric Martin','Elissa Karasik','Kasra Farahani',"Jason O'Leary"],
production:['Tom Kauffman','Michael Waldron','Tommy Turtle'],
music:['Natalie Holt','Jake Jackson'],
camera:['Autumn Durald'],
cut:['Calum Ross','Emma McCleave'],
sound:['David Acord','Danielle Dupre','Bjørn Ole Schroeder','Karol Urban','Vinii Khullar'],
scenography:['Kasra Farahani','Claudia Bonfe','Olly Williams','Victoria Allwood'],
masks:['Amy Wood'],
costumes:['Christine Wada']},
{title:'The Lost Room',
titleCZ:'Pokoj č. 10',
year:2006,
runtime:'4h 21min',
episodeRuntime:'87min',
countries:['USA'],
genres:['Sci-Fi','Action','Fantasy','Mystery'],
director:['Craig R. Baxley','Michael W. Watkins'],
actors:['Peter Krause','Kevin Pollak','Julianna Margulies','Ewen Bremner','Peter Jacobson','Roger Bart','Jenny Gabrielle','Chris Bauer','Elle Fanning','Harriet Sansom Harris','April Grace','Margaret Cho','Luce Rains','J. Nathan Simmons','Arron Shiver','Jason Antoon','Dennis Christopher','Ann Cusack','Steve Rankin','Remy Ryan','Rebecca Lowman','Thomas Rosales Jr.','Chris Ashworth','Chris Browning','Elizabeth Chambers','Nicholas Guilak','Edward A. Duran','Debrianna Mansini','Beth Bailey','Benjamin Petry','Gregory Chase','J.D. Garfield','Dave Colon','Billy Lockwood','Tavia Schwartz','Jorge-Luis Pallo','Joshua Bryant','Lorri Oliver','Jason Douglas','Dennis Keiffer','Dylan Kenin','John Beasley','Tim Guinee','Lois Geary','Doris Hargrave','Josh Berry','Eric Martinez','Esodie Geiger'],
screenplay:['Christopher Leone','Michael Foley'],
production:['Paul Kurta'],
music:['Robert J. Kral'],
camera:['David Connell'],
cut:['Sonny Baskin','David Crabtree'],
sound:['Kenneth R. Burton','Andre Perreault','Rick Alexander','Richard Taylor','Todd Murakami','Patrick Giraudi'],
scenography:['Keith Neely'],
costumes:['Daniel J. Lester']},
{title:"John Silver's Return to Treasure Island",
titleCZ:'Silverův návrat na ostrov pokladů',
year:1986,
runtime:'8h 42min',
episodeRuntime:'52-53min',
countries:['UK'],
genres:['Adventure'],
director:['Piers Haggard','Alex Kirby','Alan Clayton'],
actors:['Brian Blessed','Christopher Guard','Kenneth Colley','Reiner Schöne','Artro Morris','José María Caffarel','Nick Brimble','Arthur Bostrom','Graham McTavish','Tony Osoba','Charlotte Mitchell','Aldo Sambrell','Malcolm Terris','William Morgan Sheppard','Geoffrey Greenhill','Robert Putt','Mark Colleano','Forbes Collins','Roy Boyd','Oliver Cotton','John Hallam','Roy Heather','Willoughby Goddard','Bruce Purchase','Phil Rowlands','Richard Beale','Alan Clayton','Peter Copley','John Tordoff','Jean Faulds','Jeanne Watts','John Cater','Donald Pickering','Reggie Carter','Deborah Poplett','Ancile Gloudon'],
screenplay:['John Goldsmith'],
production:['Alan Clayton'],
music:['Tom McGuinness','Terry Oldfield'],
camera:['Tony Impey'],
cut:['John Gilbert'],
scenography:['Doug James','Kate Barnett','Richard Hornsby'],
costumes:['Aideen Morgan']},
{title:'Prison Break',
titleCZ:'Útěk z vězení',
year:2005,
runtime:'63h 43min',
episodeRuntime:'42-55min',
countries:['USA'],
genres:['Thriller','Drama','Action','Crime'],
director:['Bobby Roth','Dwight H. Little','Robert Mandel','Brett Ratner','Brad Turner','Michael W. Watkins','Kevin Hooks','Greg Yaitanes','Sergio Mimica-Gezzan','Jace Alexander','Guy Ferland','Sanford Bookstaver','Milan Cheylov','Karen Gaviola','Nelson McCormick','Matt Earl Beesley','Eric Laneuville',"Peter O'Fallon",'Fred Gerber','Bryan Spicer','Michael Switzer','Mark Helfrich','Jonathan Glassner','Garry A. Brown','Dean White','Jesse Bochco','Vincent Misiano','Craig Ross Jr.','Jesús Salvador Treviño','Kevin Tancharoen','Randy Zisk','Vern Gillum'],
actors:['Dominic Purcell','Wentworth Miller','Robert Knepper','Amaury Nolasco','Sarah Wayne Callies','William Fichtner','Wade Williams','Peter Stormare','Rockmond Dunbar','Robin Tunney','Stacy Keach','Paul Adelstein','Silas Weir Mitchell','Lane Garrison','Muse Watson','Holly Valance','Marshall Allman','Danay Garcia','Kim Coates','Michael Rapaport','Robert Wisdom','John Heard','Michelle Forbes','Camille Guaty','Diana Scarwid','John Billingsley','Phillip Edward Van Lear','Kurt Caceres','Mac Brandt','Leon Russom','Patricia Wettig','Christian Stolte','Robert Pralgo','Matt DeCaro','Frank Grillo','James Zahn','Callie Thorne','Kevin Dunn','Kristin Lehman','Jessalyn Gilsig',"Jodi Lyn O'Keefe",'JB Blanc','Kaley Cuoco','Al Sapienza','Cullen Douglas','Lea Coco','Reynaldo Gallegos','Michael Gaston','Dameon Clarke','Michael Cudlitz','Mark Harelik','Julio Cedillo','Barbara Eve Harris','Adina Porter','Reggie Lee','Chris Vance','Carlo Alban','Laurence Mason','Alexandra Lydon','Shannon Lucio',"Michael O'Neill",'Cress Williams','Reese Madigan','Tara Karsian','Dale Waddington','Heather McComb','Brian Poth','Demi Lovato','Stacy Haiduk','Keith Szarabajka','Mike Gomez','Graham McTavish','Mark Pellegrino','Denise Crosby','Kathleen Quinlan','Titus Welliver','John S. Davies','Channon Roe','Sala Baker','Crystal Allen','John Getz','Scott Alan Smith','Gianni Russo','Ricki Noel Lander','Jude Ciccolella','Ted King','Chelcie Ross','William Mapother','Jon Huertas','Alex Fernandez','Bonnie Burroughs','Lori Petty','Chris Bruno','Danielle Campbell','Joseph Sikora','Rey Hernandez','Ray Austin','Tony Denison','Marco Rodríguez','Aisha Hinds'],
screenplay:['Paul Scheuring','Seth Hoffman','Nicholas Wootton','Michael Pavone','Karyn Usher','Matt Olmstead','Kalinda Vazquez','Nick Santora','Michael Horowitz','Graham Roland','Monica Macer','Zack Estrin','Vaun Wilmott'],
production:['Marty Adelstein','Neal H. Moritz','Nelson McCormick','Paul Scheuring','Garry A. Brown'],
music:['Ramin Djawadi'],
camera:['Dante Spinotti','Robbie Greenberg','Fernando Argüelles','Chris Manley','Jeffrey C. Mygatt','Rick Anderson','Robert LaBonge'],
cut:['James Coblentz','Mark Helfrich','Kaja Fehr','Etienne Des Lauriers','Scott Powell','Warren Bowman','Fred Peterson','Eric Seaburn','Gregory T. Evans','Scott Eilers'],
sound:['Dennis Kirk','Larry Benjamin','Mathew Waters','Joe Barnett','Gregory King','Forest Williams'],
scenography:['Gary Frutkoff','Philip Leonard','Luca Tranchino','Gary Baugh','Lisa Wolff','Jackie Carr','Sam Higgins'],
masks:['Janice Kavanagh','Linda Rizzuto','Suzi Ostos','Bret Mardock','Amanda McGowan','Victoria Ferguson'],
costumes:['Susan Kaufmann','Betsy Heimann','Sonu Mishra','Taneia Lednicky']},
{title:'Little Britain USA',
titleCZ:'Malá Velká Británie v USA',
year:2008,
runtime:'2h 35min',
episodeRuntime:'24-28min',
countries:['UK','USA'],
genres:['Comedy'],
director:['Michael Patrick Jann','David Schwimmer'],
actors:['Matt Lucas','David Walliams','Brett Gentile','Davenia McFadden','Brad Grunberg','Peggy Miley','Harry Lennix','Nancy Lenehan','Geraldine James','Robert Seay',"Rosie O'Donnell",'Vivica A. Fox','Paul Rudd','Sting','Robert Vaughn','David Bowe','Tom Bower','Lorna Scott','Ann Cusack','Toši Toda','Hilarie Burton','Matt Walsh','Melissa Ponzio','Alex Sgambati','Phillip Troy Linger','Tonita Castro','Jenny Gulley',"Marilyn O'Connor",'Joe Montanti','Brian T. Finney','Lara Everly','Patricia Selznick','Carla Jimenez','Dominic L. Santana','Ritchie Greer','Dona Hardy','Jim Lau','Kate Rene Gleason','Tom Baker','Stephanie Laing','Matt Malloy','Kevin Gould','Amelia Jackson-Gray',"Dan O'Connor",'Lisa LoCicero','Earl Schuman','Willie Amakye'],
screenplay:['Matt Lucas','David Walliams'],
production:['Stephanie Laing'],
music:['David Arnold'],
camera:['Joe Kessler'],
cut:['David Codron'],
sound:['Carl Rudisill'],
scenography:['Michael Wylie'],
masks:['Matthew W. Mungle'],
costumes:['Jane Ruhm']},
{title:'Justified',
titleCZ:'Strážce pořádku',
year:2010,
runtime:'60h 12min',
episodeRuntime:'42min',
countries:['USA'],
genres:['Action','Crime','Drama','Thriller','Western'],
director:['Adam Arkin','Jon Avnet','Peter Werner','Michael Dinner','John Dahl','Bill Johnson','Michael W. Watkins','Gwyneth Horder-Payton','Don Kurt','Dean Parisot','Tony Goldwyn','Michael Pressman','Rod Holcomb','Frederick King Keller','Michael Katleman','Peter Weller','John David Coles','Lesli Linka Glatter','Billy Gierhart','Kevin Rodney Sullivan','Sylvain White','Katrelle N. Kindred'],
actors:['Timothy Olyphant','Nick Searcy','Joelle Carter','Jacob Pitts','Erica Tazel','Walton Goggins','Jere Burns','Natalie Zea','David Meunier','Jonathan Kowalsky','William Ragsdale','Neal McDonough','Margo Martindale','Doug E. Doug','David Haley','Byrne Offutt','Katherine LaNasa','Fredric Lehne','Hassan Johnson','Daniel Stewart Sherman','Stephen Root','Jeremy Davies','Marcus Ashley','Raymond J. Barry','James Logan','Michael Shamus Wiles','Kaitlyn Dever','Sarah Jones','Chris Coy','Joe Stevens','Mike Foy','Scott Wilson','Carla Gugino','Chris Ellis',"Ryan O'Nan",'Sarah Baldwin','David Warshofsky','Matt Craven','Pruitt Taylor Vince','Richard Lineback','Ethan Wilde','Savannah McReynolds','Blake Adams','Peter Jason','Demetrius Grosse','Lew Temple','Adam Johnson','Tony Hale','Daniel Buran','Chadwick Boseman','John W. Iwanonkiw','David Hill','Michael Scott Allen','Frank Pacheco','Kevin Daniels','Jes Macallan','Romy Rosemont','Bonnie Root','Damon Herriman','Chris Ashworth','Mark Elias','Alexandra Kyle','Jessica Camacho','Mark Irvingsen','Tara Buck','A. J. Buckley','Robin Riker','Brendan McCarthy','Nathan Sutton','Jim Haynie','Chris Chalk','Mickey Jones','Sam Anderson','Adam Bartley','Ronnie Gene Blevins','Gabrielle Dennis','Christie Lynn Smith','T.J. Linnard','Justin Cuomo','Leslie Stevens','Jim Klock','Casey Sander','Jacob Lofland','Jesse Luken','Daryl Crittenden','Shelley Hennig','Kai Lennox','Ryan McCann','Daniel Moncada','Ian Reed Kesler','Todd Stashwick','Noel Arthur','Kevin McNamara','Don McManus','Carlos Pratts','Darin Heames','Timothy Brennen','Eric Ladin','Maggie Lawson','Robert Baker'],
basedOn:['Elmore Leonard'],
screenplay:['Gary Lennon','Chris Provenzano','Michael Dinner','Dave Andron','Benjamin Cavell','Graham Yost','VJ Boyd','Benjamin Daniel Lobato','Ingrid Escajeda','Fred Golan','Nichelle D. Tramble','Jon Worley','Leonard Chang','Wendy Calhoun','Eisa Davis','Taylor Elmore'],
production:['Chris Provenzano','Steven Heth','Eisa Davis'],
music:['Steve Porcaro','Mark Isham'],
camera:['Francis Kenny','Peter Levy','Andrew Strahorn','Attila Szalay','Edward J. Pei','Richard Crudo','Stefan von Bjorn','John Lindley','David Stockton','Amy Vincent','Jeffrey Greeley'],
cut:['Victor Du Bois','Dorian Harris','Eric L. Beason','Harvey Rosenstock','Keith Henderson','Bill Johnson','Steve Polivka','Steven Nevius','Jean Crupper','Sandra McCallig','Hunter M. Via','Marta Evry'],
sound:['R. Russell Smith','William Freesh','Albert Ibbotson','Robert Edmondson','Bill Jackson','Gary D. Rogers','Brett Grant-Grierson','Adam Jenkins','Joe Kenworthy','Brad North','David Raines','Jim Fitzpatrick','Sherry Klein','Todd Grace','John W. Cook II','Nick Offord','David B. Cohn','Bobby Mackston'],
scenography:['Marek Dobrowolski','Michael Z. Hanan','Jonathan A. Carlson','Charles M. Lagola','David Blass','David A. Koneff','Shauna Aronson','Oana Bogdan Miller'],
masks:['Liz Briseno','Nancy Baca','Ingrid Hartowicz-Fuentes','Michele Tyminski Schoenbach','Laverne Caracuzzi','Debra-Lee Davidson','Jori Jenae McGuire','Rochelle Uribe','Jennifer Donish','Cynthia Hernandez'],
costumes:['Ane Crabtree','Patia Prouty','Dona Adrian Gibson']},
{title:'The Confession',
titleCZ:'Zpověď',
year:2011,
runtime:null,
episodeRuntime:'10x6min',
countries:['USA'],
genres:['Action','Crime','Drama'],
director:['Brad Mirman'],
actors:['Kiefer Sutherland','John Hurt','Daniel London','Max Casella','Greg Ellis','Michael Badalucco'],
production:['Matthew R. Brady','David Chamberlin'],
music:['Sean Callery','Jamie Forsyth'],
camera:['Joe Arcidiacono'],
cut:["Matt O'Connor"],
scenography:['Elizabeth J. Jones','Emmanuelle Hoessly'],
costumes:['Karen Malecki']},
{title:'Jane Eyre',
titleCZ:'Jana Eyreová',
year:1983,
runtime:null,
episodeRuntime:'239min',
countries:['UK'],
genres:['Romance'],
director:['Julian Amyes'],
actors:['Zelah Clarke','Timothy Dalton','Carol Gillies','Jean Harvey','Joolia Cappleman','Damien Thomas','Kate David','Blance Youinou','Sian Pattenden','Judy Cornwell','Robert James','Mary Tamm','Lockwood West','Andrew Bicknell','Merelina Kendall','Keith Marsh','Sally Osborne','Christine Absalom','Avril Clark','Mary Kenton','Elma Soiron','Colette Barker','Carolle Rousseau','Tracey Childs','Emma Jacobs','Moira Downie','Joby Blanshard','Morris Barry','Colin Jeavons','Alan Cox','Elaine Donnelly','Gabrielle Glaister','Roger Walker','Morag Hood','Daphne Anderson','Dorothea Phillips','Graham Weston','Christopher Burgess','David Dodimead','Anne Dyson','James Marcus'],
basedOn:['Charlotte Brontë'],
music:['Paul Reade'],
camera:['John Kenway'],
sound:['Alastair Askham']},
{title:'American Vandal',
titleCZ:'Americký vandal',
year:2017,
runtime:'8h 53min',
episodeRuntime:'27-42min',
countries:['USA'],
genres:['Comedy'],
director:['Tony Yacenda'],
actors:['Tyler Alvarez','Gabriela Fresquez','Griffin Gluck','Camille Hyde','Calum Worthy','Jimmy Tatro','Genevieve Hannelius','Dendrie Taylor','Larry Joe Campbell','Jayne Taini','Bill Kottkamp','Sean Carrigan','Caleb Emery','Eduardo Franco','Aylin Bayaromoglu','Dana Millican','Jalon Howard','Dan Perrault','Saxon Sharbino','Lou Wilson','Jessica Juarez','Camille Ramsey','Andy Sandoval','Molly Jackson','Tanner Kimberly','Karly Rothenberg','Andrew Caldwell','Todd Robert Anderson','Elise Robertson','Tucker Albrizzi',"Ryan O'Flanagan",'Lukas Gage','Cody Wai-Ho Lee','Jacob Houston','Ashlyn Pearce','Daeg Faerch','PJ McCabe','Joe Hardesty','Chris Markle','Aaron Takahashi','Josh Duvendeck','Evan Arnold','Taylor Dearden','Bellina Logan','Susan Ruttan','Jeanine Jackson','Cynthy Wu','Trevor Noah','Ayanna Berkshire','Victor Morris','Matt Bennett','Shannon Dang','Connor Williams','Travis Tope','Melvin Gregg','Jay Lee','Jeremy Culhane','Sarah Burns','DeRon Horton','Elisha Henig','Tierra Valentine','Adam Ray','Miles J. Harvey','Barbara Deering','Phelan Davis','Kiah Butts','Nicole McCullough','Jeff Joseph','Jessica Lynn Skinner','Olivia Norman','Roni Akurati','Haley Talbot','Ted Rooney','Dan Patrick','Kiah Stern','Erica Shaffer','Stephanie Styles','Cayleb Long','Joyce Greenleaf','Tim True','Greg Vrotsos','Isaac Salzman','Hunter Clowdus','Joshua Bitton','Natalie Shershow','Xaria Dotson','Isaac Lamb','Michael Cojocaru','Pat Janowski','Taylor Misiak','Yelena Friedman','Nathaniel J. Potvin','Samuel Su','Roxana Ortega','Aaron Kee','Caitlin Michael Riley','Catherine Davis','Carla Jeffrey','Rachel Pate','Will McLaughlin'],
screenplay:['Tony Yacenda','Dan Perrault','Mike Rosolio','Kevin McManus','Matthew McManus','Amy Pocha','Jaboukie Young-White','Jess Meyer','Dan Lagana','Seth Cohen'],
production:['Kevin McManus','Matthew McManus','Jess Meyer'],
music:['Darien Shulman'],
camera:['Adam Bricker'],
cut:['Jessica Brunetto','Andrew McAllister','Isaac Hagy','Paul Swain'],
sound:['John Chamberlin','Sebastian Sheehan Visconti','Bo Sundberg'],
scenography:['Bianca Ferro','Schuyler Telleen'],
costumes:['Alisha Silverstein']},
{title:'Bosch: Legacy',
titleCZ:'Bosch: Odkaz',
year:2022,
runtime:'15h 5min',
episodeRuntime:'37-54min',
countries:['USA'],
genres:['Drama','Crime'],
director:['Patrick Cady','Sharat Raju','Alex Zakrzewski','Ernest R. Dickerson','Zetna Fuentes','Hagar Ben-Asher','Kate Woods','Adam Davidson','Tawnia McKiernan','Leslie Libman','Haifaa Al-Mansour','Logan Kibens'],
actors:['Titus Welliver','Mimi Rogers','Madison Lintz','Stephen A. Chang','Denise G. Sanchez','David Moses','Scott Klace','Phil Morris','Danielle Larracuente','Max Martini','Guy Wilson','Jolene Kay','Vincent Laresca','Michael Rose','Jessica Camacho','Kate Burton','Mark Rolston','William Devane','Hugo Armstrong','Len Cordova','Marcus Giamatti','Jason Dirden','Tetiana Gaidar','Alan Rosenberg','Aisha Kabia','Olivia Sandoval','Paul Hipp','Mark Adair-Rios','Jeff Corbett','Jim Holmes','Joe Adler','Ethan Corn','Reed Diamond','Lindsay Musil','Zaria','Betsy Baker','Grace Shen','Sam Valentine','Natsuko Ohama','Jessie Prez','Delayne Mitchell','Terri Hoyos','Troy Evans','Gregory Scott Cummins','Sean Riggs','Mike Ostroski','Ernest Waddell','Alexis Rhee','Anthony Fanelli','John Savage','Marie Buck','Matthew Jones','Sal Landi','Jamie Hector','Pasha D. Lychnikoff','Barry Livingston','Jai Rodriguez','Stefan Marks','Travis Johns','Montae Russell','Marabina Jaimes','Alma Martinez','Cynthia Kaye McWilliams','Gabriel Tigerman','Cleveland Berto','Moronai Kanekoa','Zylan Brooks','Jon Curry','Soma Mitra','Roxana Brusso','Keith Jefferson','Will Chase','Stephanie Erb','JR Reed','Gwyn LaRee','Michael Cudlitz','Gilbert Glenn Brown','Greg Fitzpatrick','Kurt Kanazawa','Clint Jordan','Albert Malafronte','Paul Guzman','Konstantin Melikhov','Sonia Iris Lozada','Todd James Jackson','Roman Arabia','Kiff VandenHeuvel','David Denman','Jacqueline Piñol','David Marciano','Janet Song','James Read','Bruce Davison','Anthony Michael Hall','Ricardo Molina','Chet Grissom','Eddie Yu','Ty Trumbo','Terryn Westbrook','Fred Mata'],
basedOn:['Michael Connelly'],
screenplay:['Tom Bernardo','Eric Ellis Overmyer','Michael Connelly','Naomi Iizuka','Barbara Curry','Chris Wu','Osokwe Tychicus Vasquez','Titus Welliver','Chris Downey','Emily Ragsdale'],
production:['Jamie D. Boscardin','Mark Douglas','Naomi Iizuka','Barbara Curry','Trey Batchelor'],
music:['Jeff Russo'],
camera:['Rodney Taylor','Jason Andrew','Todd A. Dos Reis'],
cut:['Steven Cohen','Jennifer Hatton','Rafael Nur','Gerald Valdez'],
sound:['Joe DeAngelis','Albert Romero','Chris Carpenter','Brad North'],
scenography:['Chester Kaczenski','Jason Zev Cohen'],
masks:['Geri B. Oppenheim','Jody Burton'],
costumes:['Jill M. Ohanneson','Melissa Bruning']},
{title:'Daisy Jones & the Six',
titleCZ:'Daisy Jones & the Six',
year:2023,
runtime:'8h 24min',
episodeRuntime:'46-66min',
countries:['USA'],
genres:['Drama','Music'],
director:['James Ponsoldt'],
actors:['Riley Keough','Sebastian Chacon','Sam Claflin','Suki Waterhouse','Josh Whitehouse','Camila Morrone','Melissa Lehman','Tom Wright','Timothy Olyphant','Nick Pupo','Seychelle Gabriel','Jacqueline Obradors','Nicole LaLiberte','Scott Subiono','Jake B. Miller','Jake Etheridge','Lynn Downey','Damon K. Sperber','Nora Kirkpatrick','Sloane Letourneau','Kane Ritchotte','Malcolm McRae','Luis Fernandez-Gil','Nina Franoszek','Lorelei Olivia Mote','Sara Giannelli','Sam Rubinek','Emily Kimball','Ayesha Harris','Alexander Pobutsky','Nick George','Betsy Borrego','Michael Bower','Amanda Fix','Will Harrison','Nabiyah Be'],
basedOn:['Taylor Jenkins Reid'],
screenplay:['Scott Neustadter','Harris Danow','Nora Kirkpatrick','Michael H. Weber','Jenny Klein','Charmaine De Grate','Will Graham'],
production:['Harris Danow','Amanda Kay Price','Judalina Neira','Taylor Jenkins Reid'],
music:['Tom Howe'],
camera:['Checco Varese'],
cut:['Tyler L. Cook','Garret Price','Julie Monroe'],
sound:['Mathew Waters','Mark Relyea'],
scenography:['Jessica Kender','Kirby Feagan','Lisa Clark','Georgia Schwab','Andi Brittan','Rae Deslich'],
masks:['Liz Briseno','Michele Tyminski Schoenbach','Ketty Gonzalez'],
costumes:['Denise Wingate']},
{title:'Dragons: Race to the Edge',
titleCZ:'Jak vycvičit draky: Závod na hřeben',
year:2015,
runtime:'28h 36min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Animation','Adventure','Comedy'],
director:['Jae Hong Kim','Elaine Bogan','Simon Otto','Robert Briggs','T.J. Sullivan','Greg Rankin'],
actors:['Jay Baruchel','America Ferrera','Zack Pearlman','Christopher Mintz-Plasse','T.J. Miller','Andree Vermeulen','Mae Whitman','David Faustino','Nolan North','JB Blanc','Alfred Molina','Hakeem Kae-Kazim','James Arnold Taylor','Alastair Duncan','Alan Shearman','David Tennant','Adelaide Kane','Tom Kenny','Lucas Grabeel','Chris Edgerly','Paul Rugg','Holly Kagis','Peter Lavin','Brook Chalmers','Michael Goldstrom','Warren Sroka'],
screenplay:['F.M. De Marco','Ricky Roxburgh','Jack C. Thomas','Douglas Sloan','John Tellegen','Laura Bowes','Ian Rickett','Art Edler Brown'],
production:['Chad Hammes'],
music:['John Paesano'],
cut:['Jay Fox','Joel Fisher','Jay Fox','John Laus'],
sound:['Carlos Sanches','Otis Van Osten'],
scenography:['Jessica Bulinski']},
{title:'Call My Agent!',
titleCZ:'Chci mluvit se svým agentem!',
year:2015,
runtime:null,
episodeRuntime:'2015-2020',
countries:['France'],
genres:['Comedy'],
director:['Lola Doillon','Cédric Klapisch','Laurent Tirard','Jeanne Herry','Antoine Garceau','Marc Fitoussi'],
actors:['Camille Cottin','Thibault de Montalembert','Liliane Rovère','Stefi Celma','Nicolas Maury','Laure Calamy','François Civil','Ophélia Kolb','Philippine Leroy-Beaulieu','Gabrielle Forest','Isabelle Candelier','Jean-Yves Chatelais','Zinedine Soualem','Nathalie Baye','François Berléand','Cécile de France','Audrey Fleurot','Julie Gayet','Line Renaud','Françoise Fabian','Laura Smet','Joey Starr','Anthony Sonigo','Arben Bajraktaraj','Igor Mendjisky','Robert Plagnol','Caroline Bal','Marie Berto','Lee Delong','Fleur Lise Heuet','Dominique Besnehard','Scali Delpeyrat','Julie Nicolet','Alain Guillot','Lise Lamétrie','Alain Rimoux','Elise Lhomeau','Eric Naggar','Emmanuel Noblet','Simona Maicanescu','Clémence Thioly','Vladimir Perrin','Gilles Lellouche','Delphine Théodore','Kader Boukhanef','Stéphanie Bataille','Amélie Etasse','Mathieu Barbet','Grégory Montel','Assaad Bouab','Samuel Theis','Virginie Efira','Ramzy Bedia','Norman Thavaud','Olivia Côte','Michel Drucker','Agnès Château','Marc Brunet','Sarah-Megan Allouch-Mainier','Fabienne Galula','Fabrice Luchini','Christopher Lambert','Bruno Fleury','Julien Doré','Aymeline Valade','Raphaëline Goupilleau','Denis Mpunga','Alban Casterman','Jean-Marc Roulot','Isabelle Adjani','Aude Léger','Lou Chauvain','Guy Marchand','Jeanne Herry','Hervé Briaux','Danièle Douet','Juliette Binoche','Hélène Alexandridis','Philippe Uchan','Emilie Gavois-Kahn','Laetitia Rosier','Mourad Frarema','Fanny Sidney','Kate Colebrook','Jean Dujardin','Monica Bellucci','Nicolas Bridet','Louise Coldefy','Antoine Gouy','Hervé Lassïnce','Soufiane Guerrab','Gérard Lanvin','Isabelle Huppert','Cédric Kahn','Johanna Nizard','Doug Rand','Gilles Cohen','Béatrice Dalle','Gwendolyn Gourvenec','Anne Loiret'],
screenplay:['Dominique Besnehard','Quoc Dang Tran','Nicolas Mercier','Camille Chamoux','Cécile Ducrocq','Camille Pouzol','Jeanne Herry','Sabrina B. Karine','Marc Fitoussi','Vianney Lebasque','Fanny Herrero','Jérôme Bruno'],
production:['Dominique Besnehard','Michel Feller','Aurélien Larger','Harold Valentin'],
music:['Loïc Dury','Christophe Minck'],
camera:['Yves Cape','Denis Rouden','Antoine Roch','Antoine Monod'],
cut:['Catherine Schwartz'],
sound:['Cyril Moisson','Cyril Holtz','Steven Ghouti','Cédric Lionnet'],
scenography:['Emmanuelle Duplay','Laurent Avoyne'],
costumes:['Anne Schotte']},
{title:'Claymore',
titleCZ:'Claymore',
year:2007,
runtime:'10h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy'],
director:['Kandži Wakabajaši','Hirojuki Tanaka','Sang Yong Eom'],
actors:['Hóko Kuwašima','Nana Mizuki','Romi Paku','Akeno Watanabe','Ajako Kawasumi','Kotono Micuiši','Minori Čihara','Tamio Óki','Tomokazu Seki','Minami Takajama','Hiroaki Hirata','Kendži Hamada','Džunko Takeuči','Júiči Nakamura','Miju Macuki','Aja Endó','Hirojuki Jošino','Jasuhiro Fudžiwara','Megumi Tojoguči','Nobujuki Hijama','Rino Marimo','Asami Jaguči','Čó','Sacuki Jukino','Emi Šinohara','Hóčú Ócuka','Kazuhiro Nakata',"Masa'aki Cukada",'Micuru Mijamoto','Širó Saitó','Nači Nozawa','Kunihiko Jasui','Kacumi Suzuki','Motoki Takagi','Nobuaki Fukuda','Takaši Kondó',"Masa'aki Jadžima",'Kikuko Inoue','Miki Nagasawa','Sači Macumoto','Kazuma Horie',"Kei'iči Sonobe",'Hiro Júki','Júko Sasaki','Micuo Senda','Hana Takeda','Rjúzaburó Ótomo','Kjóko Hamura','Miho Mijagawa','Kazuo Oka','Ginpei Sató','Akira Išida','Tóru Nara','Kunihiro Kawamoto','Jutaka Aojama','Tecuja Kakihara','Aja Hisakawa','Naoki Bandó','Ai Orikasa','Kappei Jamaguči','Kódži Jusa','Jui Kano','Jóiči Nišidžima','Ai Horanai','Jasuši Mijabajaši','Komina Macušita','Kijoko Nagaki','Rika Morinaga','Rie Išizuka','Umedži Sasaki','Misato Sakamoto'],
basedOn:['Norihiro Jagi'],
screenplay:['Kazujuki Fudejasu','Jasuko Kobajaši','Daisuke Nišida'],
production:['Masao Marujama','Tošio Nakatani'],
music:['Masanori Takumi'],
camera:['Seong-Ha Oh','Seok-Beom Lee'],
cut:['Satoši Terauči','Naoki Kasai'],
sound:['Jasunori Honda'],
scenography:['Manabu Ocuzuki']},
{title:"Wolf's Rain",
titleCZ:"Wolf's Rain",
year:2003,
runtime:'9h 58min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy','Sci-Fi'],
director:['Tensai Okamura','Masahiro Andó','Tomoki Kjóda','Jošijuki Takei','Hirojuki Kanbe','Kódži Sawai','Ikuró Sató','Masaki Kitamura','Kunihiro Mori'],
actors:['Mamoru Mijano','Kenta Mijake','Akio Sujama','Hiroki Šimowada','Majumi Asano','Acuko Tanaka','Unšó Išizuka','Akio Ócuka','Maaja Sakamoto','Masaja Onosaka','Mijuki Sawaširo','Norio Wakamoto','Teššó Genda','Kan Tokumaru','Makoto Jasumura','Miju Macuki','Takaja Kuroda','Asami Mukaidono','Jasunori Macumoto','Takaši Nagasako','Minoru Inaba','Tomohiro Cuboi','Kóki Harasawa','Tomojuki Šimura','Júdži Kiši','Micuru Mijamoto','Masato Amada',"Asuka Tani'i",'Rjúdži Nakagi','Naomi Kusumi','Micuaki Hošino','Ikuko Tani','Reiko Suzuki','Minoru Hirano','Eri Sendai','Sawa Išige','Tecu Širatori','Mika Kanai','Hisafumi Oda','Taeko Kawata','Rjúdži Saikači','Jutaka Nakano','Sajuri Sadaoka','Sačiko Miki','Ricuo Sawa','Rjóko Kinomija',"Ken'iči Močizuki",'Daisuke Ono','Ema Kogure','Kaho Kóda','Daisuke Egawa','Bridget Hoffman','Masahiro Ogata','Akimicu Takase','Arisa Ogasawara','Ikkjú Džuku','Acuko Juja','Tošihiro Nakamura','Masao Harada','Hirojuki Curu','Jukiko Tagami','Jošiko Okamoto','Júna Inamura','Šónosuke Horikoši','Eisuke Asakura','Takahiro Jošino','Acuši Gotó','Rjú Itó','Tošiaki Kuwahara','Kódžiró Takahaši','Kóki Akaiši','Masako Inui'],
screenplay:['Tóko Mačida','Mija Asakawa','Dai Saitó','Ičiró Ókóči','Keiko Nobumoto','Tensai Okamura','Aja Jošinaga'],
production:['Masahiko Minami','Takeo Haruna','Minoru Takanaši','Takatoši Hamano'],
music:['Jóko Kanno'],
camera:['Kósuke Arakawa'],
cut:['Hiroaki Itabe'],
sound:['Kazuhiro Wakabajaši'],
scenography:['Acuši Morikawa']},
{title:'The Durrells in Corfu',
titleCZ:'Durrellovi',
year:2016,
runtime:'20h 2min',
episodeRuntime:'46-47min',
countries:['UK'],
genres:['Drama','Biographic'],
director:['Roger Goldby','Steve Barron','Niall MacCormick','Edward Hall'],
actors:['Keeley Hawes',"Josh O'Connor",'Milo Parker','Daisy Waterstone','Callum Woodhouse','Alexis Georgoulis','Giorgos Karamihos','Anna Savva','Ulric von der Esch','Alexis Conran','Ben Hall','Leslie Caron','Daniel Lapaine','Errika Bigiou','Nikos Orestis Chaniotakis','Elli Tringou','Barbara Flynn','Jeremy Swift','James Cosmo','Vernon Dobtcheff','Maximilian Befort','Gerasimos Skiadaressis','Jamie Ward','Miles Jupp','Panos Koronis','Felicity Montagu','Jeff Rawle','Trevor White','Charlotte Atkinson','Luca Calvani','Tanmay Dhanania','Alice Henley','Andrew Bicknell','Eve Pearce','Una Stubbs','Alexandros Logothetis','Henry Lloyd-Hughes','George Kopsidas','Lucy Black','Erifili Kitzoglou','Merch Husey','Noni Ioannidou','Olivia Lebedeva-Alexopoulou','Grace Hogg-Robinson','Goran Navojec','Laura Ferries','Anna-Maria Everett','Alexandra Aidini','Olga Damani','Electra Nikolouzou','Marios Kotetsis','Maddie Holliday','Sophie May Wake','Talitha Stone','Alex MacQueen','Christopher Sciueref','Sarah Crowden','Sebastiano Kiniger','Peter Bankolé','Alexandros Zouridakis','Drosos Skotis','Manolis Emmanouel','Antonia Desplat','Marina Aslanoglou','Graham Seed'],
basedOn:['Gerald Durrell'],
screenplay:['Simon Nye'],
production:['Christopher Hall'],
music:['Ruth Barrett','Jon Wygens'],
camera:['James Aspinall','Sam Renton','Ben Wheeler','Julian Court','Damian Bromley','Ashley Rowe'],
cut:['Mary Finlay','Vicky Tooms','David Thrasher','Nick McPhee','David Yardley'],
sound:['Alessio Masi','Nigel Squibbs'],
scenography:['Stevie Herbert','Julian Fullalove','Laurie Law','Daisy Popham','Gill Farr','Clare Andrade'],
masks:['Angharad Walsh','Emma Romans'],
costumes:['Charlotte Holdich']},
{title:'Mrs. America',
titleCZ:'Mrs. America',
year:2020,
runtime:'7h 38min',
episodeRuntime:'45-55min',
countries:['USA'],
genres:['Drama'],
director:['Anna Boden','Ryan Fleck','Amma Asante','Laure de Clermont-Tonnerre'],
actors:['Cate Blanchett','Uzo Aduba','Elizabeth Banks','Rose Byrne','Kayli Carter','Jay Ellis','Ari Graynor','Melanie Lynskey','James Marsden','Margo Martindale','Niecy Nash','Sarah Paulson','John Slattery','Jeanne Tripplehorn','Tracey Ullman','Beatriz Yuste','Melinda Page Hamilton','Peter MacNeill','Marcia Bennett','Samantha Espie','John Bourgeois','Geordie Johnson','Ben Rosenfield','Julian DeZotti','Laura de Carteret','Liam MacDonald','Teresa Pavlinek','Brandon J. Dirden','Currie Graham','Norm Lewis','Annie Parisse','Addison Holley','Tanisha Thammavongsa','Lizz Alexander','Angela Besharah','Anna Hardwick','Karen P. Brown','Romy Weltman','Madison Walsh','Alan Catlin','John Palladino','Bria Henderson','Alison Brooks','Hannah Galway','Novie Edwards','Khadijah Roberts-Abdullah','Marianna Phung','Eden Broda','Vanessa Smythe','Nola Martin','Marium Carvell','Cody Ray Thompson','Helen King',"Brian O'Neill",'Liyou Abere','Carrie Kim','Connie Manfredi','Tori Barban','Kent Sheridan','Marisa McIntyre','Joey Coleman','Sharon McFarlane','Zenna Davis-Jones','Sylvain Plasse','Adrienne Kress','Margarita Valderrama','Chris Locke','Natalie Dale',"Tom O'Keefe"],
screenplay:['Dahvi Waller','Tanya Barfield','Boo Killebrew','Micah Schraft','April Shih','Sharon Hoffman','Joshua Allen Griffith'],
production:['Tanya Barfield'],
music:['Kris Bowers'],
camera:['Chris Teague','Jessica Lee Gagné'],
cut:['Robert Komatsu','Emily Greene','Todd Downing'],
sound:['Andy King','Christian P. Minkler'],
scenography:['Mara LePere-Schloop','Patricia Larman','Helen Britten'],
masks:['Silvia Platsis','SJ Teasdale','Miki Caporusso','Rick Findlater','Anne Morgan','Morag Ross','Jaime Donnelly','Louise Coulston'],
costumes:['Bina Daigeler']},
{title:'Shroud for a Nightingale',
titleCZ:'Záhady Slavičího domu',
year:1984,
runtime:'4h 10min',
episodeRuntime:'50min',
countries:['UK'],
genres:['Crime'],
director:['John Gorrie'],
actors:['Roy Marsden','John Vine','Joss Ackland','Richard Marner','Graham Faulkner','Nicholas Coppin','Forbes Collins','Liz Fraser','Deborah Findlay','David Swift','Ellen Thomas','Eleanor David','Margaret Whiting','Anthony Carrick','Natalie Ogle','Lennard Pearce','Gabrielle Hamilton','Sarah Thomas','Adam Bareham'],
basedOn:['P. D. James'],
screenplay:['Robin Chapman'],
production:['John Rosenberg'],
music:['Richard Harvey']},
{title:"That '70s Show",
titleCZ:'Zlatá sedmdesátá',
year:1998,
runtime:'73h 20min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Comedy'],
director:['David Trainer','Terry Hughes'],
actors:['Topher Grace','Mila Kunis','Ashton Kutcher','Danny Masterson','Laura Prepon','Wilmer Valderrama','Debra Jo Rupp','Kurtwood Smith','Tanya Roberts','Don Stark','Tommy Chong','Lisa Robin Kelly','Christina Moore','Joseph Gordon-Levitt','Rachel Bilson','Bret Harrison','Keri Lynn Pratt','Lindsay Lohan','Sarah Lancaster','Ashley Peldon','Courtney Peldon','Jamison Jones','Kavan Reece','Matt Battaglia','Erin Cardillo','Eric Allan Kramer','Marnette Patterson','Jamie Anderson','Neil Flynn','Yvette Nicole Brown','Andrea Bendewald','Shonda Farr','Megalyn Echikunwoke','Nancy Lenehan','Samm Levine','Kevin P. Farley','Jennifer Alden','Estella Warren','Ernie Lively','Melissa Joan Hart','Sarah Christine Smith','Joe Flaherty','Dylan Sprouse','Cole Sprouse','Michele Nordin','Jim Holmes','Cazzy Golomb','Liliana Mumy','Jessica Simpson','Betty White','Jim Beaver','Don Perry','Nectar Rose','Ethan Peck','Chris Elliott','Jim Gaffigan','Nicholas Gonzalez','Marion Ross','Colleen Haskell','Eliza Dushku','David Jeremiah','Megan Paul','Alyson Hannigan','Aria Wallace','Bruce Willis','Barry Williams','Pamela Sue Martin','Wayne Pére','Garrett M. Brown','Bob Clendenin','Jeff Lewis','Mitch Pileggi','Chris McKenna','Don Knotts','Leigh-Allyn Baker','Samantha Raddock','Allison Munn','Alicia Ziegler','Scott Holroyd','Brandon Molale','Caitlin Crosby','Thomas Downey','Jud Tylor','Jim Rash','Leslie David Baker','Luke Wilson','John Ratzenberger','Suzanne Ford','Al Leong','Melinda Sward','Dwayne Johnson','Katey Sagal','Matt Cedeño','Shirley Jones','Scott Whyte','Shannon Elizabeth','Eve Plumb','Mac Davis','Jamie Farr','Tim Reid'],
screenplay:['Mark Brazill','Bonnie Turner','Kristin Newman','Joshua Sternin','Jennifer Ventimilia','Philip Stark','Linda Wallem','Mark Hudis','Terry Turner','Eric Gilliland','Dave Schiff','Jeff Filgo','Jackie Filgo','Arthur F. Montmorency','Rob DesHotel','Dean Batali','Chris Peterson','John Schwab','Bryan Moore','Sarah McLaughlin','Alan Dybner','Gregg Mettler','Will Forte','Patrick Kienlen','Jennifer Keene','David Spancer','Ken Blankstein','Steve Joe','Greg Schaffer'],
production:['Franco Bario','Jackie Filgo','Jeff Filgo','Patrick Kienlen','Mark Hudis','Dean Batali','Rob DesHotel','Gregg Mettler','Dave Schiff','Philip Stark','Will Forte','Melanie Patterson','Bryan Moore','Kristin Newman','Chris Peterson'],
music:['Ben Vaughn','Jeff Sudakin'],
camera:['Ronald W. Browne'],
cut:['Tim Ryder','Vince Humphrey','David Helfand','Michael Karlich'],
sound:['Charlie McDaniel','Todd Grace','Craig Porter','Kathy Oldham'],
scenography:['Garvin Eddy','Bill Gregory','Tara Stephenson','Wendy Fine'],
masks:['Desne J. Holland','Cindy Costello','Jeremy Swan','Brad Hardin','Sherilyn Stetz'],
costumes:['Melina Root']},
{title:'The Benny Hill Show',
titleCZ:'Show Bennyho Hilla',
year:1969,
runtime:null,
episodeRuntime:'58x60min',
countries:['UK'],
genres:['Comedy'],
director:['John Robins','Peter Frazer-Jones'],
actors:['Benny Hill','Jane Leeves','Beryl Reid','David Prowse','Gloria Paul','královna Alžběta II.','Andrea Allan','Derek Royle','princ Philip','vévoda z Edinburghu','Patricia Hayes','Liz Fraser','Gwendolyn Watts','Eileen Nicholas','Albert Moses','Diana King','Moira Foot','Zienia Merton','Jan Waters','Dilys Watling','Doris Hare','Penny Irving','Anita Harris','Andree Melly','Bella Emberg','Kathy Staff','Rosemarie Dunham','Bob Todd','Nosher Powell','Tony Sympson','Sally Smith','Jerold Wells','Peter Diamond','Rita Webb','Verne Morgan','Ronnie Brody','George Roderick','Carmen Dane','Ken Parry','Helli Louise','Patrick Newell','Jim Tyson','Bogdan Kominowski','Trisha Noble','Paula Wilcox','Hugh Paddick','Eira Heath','Dan Jackson','Vivienne Martin','Frank Coda','Pamela Cundell','Sidney Vivian','John Quayle','Luis Alberto del Paraná','Helen Horton','Henry McGee','Matt Monro','Johnny Vyvyan','Jeremy Hawk','Arthur Mullard','Nicholas Parsons','Nicole Shelby','Janie Marden','Peter Bayliss','Lionel Blair','Clovissa Newcombe','Felix Bowness','Charles Stapley','Peter Thomas','Tracy Smith','Stella Moray','Steve Ismay','Maureen Flanagan','Dusty Springfield','Ronald Rich'],
production:['Duncan Wood','Peter Frazer-Jones'],
sound:['Julian Ford','Paul Gartrell'],
scenography:['Norman Garwood','David Ferris','David Richens'],
costumes:['Graham Williams']},
{title:'My So-Called Life',
titleCZ:'Tak tohle je můj život',
year:1994,
runtime:'15h 6min',
episodeRuntime:'46-49min',
countries:['USA'],
genres:['Drama'],
director:['Marshall Herskovitz','Todd Holland','Mark Piznarski','Elodie Keene','Ron Lagomarsino','Claudia Weill','Scott Winant','Patrick R. Norris','Michael Engler','Mark Rosner','Victor Du Bois','Ellen S. Pressman','Jeff Perry'],
actors:['Bess Armstrong','Claire Danes','Wilson Cruz','Devon Gummersall','Jared Leto','Devon Odessa','A. J. Langer','Lisa Wilhoit','Malinda Williams','Channon Roe','Robert Gant','Barbara Bain','Tom Irwin','Bianca Lawson','Shane Powers','Shannon Leto',"Patti D'Arbanville",'Shar Jackson','Mara Hobel','Michael Lowry','Jeff Perry','Del Zamora','Jane Morris','Senta Moses','John Prosky','Sam Sarpong','Rebekah Johnson','Margaret Nagle','Lisa Waltz','Stanley DeSantis','Nada Despotovich','Pamela Gordon','Julie Halston','Adam Biesk','Dina Dayrit','Mary Kay Place','Lin Shaye','Paul Dooley','Kaley Cuoco','Bill Damaschke','Roger Rees','Lindsay Sloane','Mercedes McNab','Liza Del Mundo','Ken Sagoes','Karen Malina White','Mary Woronov','Laura Innes','Jack Nance','Winnie Holzman','Bennet Guillory','Cameron Arnett','Carl Gabriel Yorke','Tracy Melchior','Jonathan Emerson','Monika Loeffler','Francesca P. Roberts','Richard Danielson','Terri Hoyos','Danton Stone','Art Chudabala','Venus DeMilo Thomas','Eric Payne','Lois Foraker'],
screenplay:['Jason Katims','Richard Kramer','Jill Gordon','Betsy Thomas','Justin Tanner','Adam Dooley','Elizabeth Gill','Ellen Herman','Liberty Godshall','Winnie Holzman'],
production:['Alan Poul','Barry Jossen'],
music:['W.G. Snuffy Walden'],
camera:['Charlie Lieberman','Ernest Holzman'],
cut:['Robert Frazen','Ron Rosen','Joanna Cappuccilli Lovetti'],
sound:['Robert Nichols II','Sherry Klein','Mike Olman','Bo Harwood'],
scenography:['Thomas A. Walsh','Barbara Cassel','Brandy Alexander','Michael W. Foxworthy']},
{title:'Durarara!!',
titleCZ:'Durarara!!',
year:2010,
runtime:null,
episodeRuntime:'10h25min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy','Thriller'],
director:['Takahiro Ómori','Júki Jase',"Šin'ja Kawacura",'Jui Umemoto','Tecuo Ičimura','Takaši Jamamoto','Masahisa Kojata','Jukihiro Šino','Kacumi Terahigaši'],
actors:['Júki Kadži','Mijuki Sawaširo','Daisuke Ono','Momoko Óhara','Mamoru Mijano','Hiroši Kamija','Tošijuki Tojonaga','Marija Ise','Wataru Takagi','Ajahi Takagaki','Kana Hanazawa','Sanae Kobajaši','Akio Ócuka','Ai Kajano','Júdži Ueda','Kazuja Nakai','Masaja Onosaka','Nobuhiko Okamoto','Nozomi Sasaki','Takuma Terašima','Kari Wahlgren','Aoi Júki','Džun Fukujama','Kentaró Itó','Doug Erholtz','Eri Kitamura','Hisako Kanemoto','Júiči Nakamura','Saki Fudžita','Šóhei Kadžikawa','Takaja Kuroda','Hiroki Jasumoto','Júiči Iguči','Kacujuki Koniši','Daisuke Kišio','Masaši Hirose','Kazujuki Okicu','Šiori Izawa','Mai Nakahara','Hóčú Ócuka','Eidži Mijašita',"Šin'ja Takahaši",'Rokuró Naja','Jasuaki Takumi','Masaja Macukaze','Kanae Oki','Misato Fukuen','Kazuma Horie','Tóru Ókawa','Čihiro Tagaino','Acuši Imaruoka','Sajaka Aoki','Hajato Nakata','Ikumi Hajama','Haruka Tomacu','Rikija Kojama','Masajuki Kató','Nobuja Mine','Daisuke Endó','Naoki Košida','Kanako Sakai','Džun Konno','Ajano Išikawa','Takao Sugijama','Tecuja Motomura','Fumio Macuoka','Eri Mijadžima','Moemi Nakamura'],
basedOn:['Rjógo Narita'],
screenplay:['Ai Óta','Sadajuki Murai','Tošizó Nemoto','Aja Jošinaga','Noboru Takagi'],
production:['Hiró Marujama'],
music:['Jošimori Makoto'],
camera:['Hitoshi Tamura'],
cut:['Kazuhiko Seki'],
sound:['Takahiro Ómori'],
scenography:['Akira Itou']},
{title:'Dogs of Berlin',
titleCZ:'Berlínští psi'},
{title:'Dr. Stone',
titleCZ:'Dr. Stone',
year:2019,
runtime:'27h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Adventure','Sci-Fi'],
director:['Šinja Iino','Šúhei Macušita','Jošinobu Kasai','Šigeki Awai','Tomoči Kosaka','Šinpei Nagai','Micuko Kase','Tomoko Hiramuki','Satoši Šimizu','Harume Kosaka','Júsaku Saotome','Osamu Nabešima','Susumu Nišizawa',"Šin'iči Tókairin",'Kóičiró Kuroda'],
actors:['Júsuke Kobajaši','Gen Sató','Makoto Furukawa','Kana Ičinose','Júiči Nakamura','Ajumu Murase','Kengo Kawaniši','Manami Numakura','Mugihito','Reina Ueda','Tomoaki Maeno','Maju Mineda','Ai Fairouz','Jú Sasahara','Karin Takahaši','Itaru Jamamoto','Kensuke Óta','Juka Nukui','Akira Išida','Aki Tojosaki','Kenšó Ono','Jošiki Nakadžima','Acumi Tanezaki','Tecuo Kanao','Jasuhiro Mamija','Lynn','Júja Hirose','Asuna Tomari','Šóta Jamamoto',"Džun'iči Janagita",'Jóko Hikasa','Šógo Sakata','Juka Terasaki','Manaka Iwami','Šion Wakajama','Sajumi Suzuširo','Reigo Jamaguči','Rjó Sugisaki','Keidži Fudžiwara','Nozomi Nakazato','Kóiči Hasebe','Gakuto Kadžiwara','Aoi Ičikawa','Haruki Išija','Marika Kóno','Džun Inoue','Mikako Komacu','Mucumi Tamura','Júja Murakami','Genki Muro','Hirojuki Kagura','Hiroki Maeda','Hitoši Bifu','Rjóta Takeuči','Jó Taiči','Kjó Jaoja','Šizuka Išigami','Orie Kimoto','Reina Kondó','Kaori Maeda','Anzu Haruno','Hitomi Šogawa','Arisa Sekine','Norijuki Cujuki','Hajato Kimura','Júki Išikari','Šin Macušige','Jasuhiro Kikuči','Júki Onodera','Hadžime Šačó','Kokoa Išii','Tecuei Sumija','Daisuke Nezu','Maaja Sakamoto','Rjóta Suzuki','Kóiči Sóma','Takaaki Učino','Kentaró Kumagai','Naoko Komacu','Jurika Kubo','Masaki Nakaniši','Kento Širaiši','Šóhei Kadžikawa','Tecuró Mijata','Júki Arai','Nacumi Fudžiwara','Taito Ban','Rie Tanaka','Satoši Mikami','Šótaró Morikubo','Kanehira Jamamoto','Hisako Kanemoto','Saori Óniši','Kóhei Amasaki','Júga Sató','Jutaka Aojama','Kaede Hondo','Kazujuki Okicu','Šója Išige','Jukija Macui'],
basedOn:['Riičiró Inagaki'],
screenplay:['Júičiró Kido'],
music:['Juki Kanesaka','Tacuja Kató','Hiroaki Cucumi'],
camera:['Takeshi Katsurayama','Kwang-jun Kim'],
cut:['Kumiko Sakamoto'],
sound:['Džin Aketagawa'],
scenography:["Šun'ičiró Jošihara"]},
{title:'Lucifer',
titleCZ:'Lucifer',
year:2016,
runtime:'72h 44min',
episodeRuntime:'42-66min',
countries:['USA'],
genres:['Fantasy','Mystery','Comedy'],
director:['Len Wiseman','Matt Earl Beesley','David Frazee','Nathan Hope','Eriq La Salle','Tim Matheson','David Paymer','Eagle Egilsson','Mairzee Almas','Greg Beeman','Louis Shaw Milito','Karen Gaviola','Alrick Riley','Ben Hernandez Bray','Brad Tanenbaum','Sherwin Shilati','Mark Tonderai','Tara Nicole Weyr','Eduardo Sánchez','Marisol Adler','Claudia Yarmy','Hanelle M. Culpepper','Lisa Demaine','Kevin Alejandro','Sam Hill','Nguyen Viet','Jessika Borsiczky','Richard Speight Jr.','Bola Ogun','Ildy Modrovich','D.B. Woodside'],
actors:['Tom Ellis','Lauren German','Kevin Alejandro','Scarlett Estevez','D.B. Woodside','Lesley-Ann Brandt','Rachael Harris','Aimee Garcia','Tricia Helfer','Kayla Ewell','AnnaLynne McCord','Lochlyn Munro','Tina Grimm','Evan Arnold','Adam Bartley','Colman Domingo','Teach Grant','Manny Montana','Eddie Shin','Harrison Thomas','Alessandra Torresani','Isiah Whitlock Jr.','Nelson Wong','Aria Ostrander','Paul Lazenby','Bri Neal','T. Michael Morris','Aatash Amir','John Specogna','Bailey Chase','Tomiwa Edun','John Pankow','Isaac Keys','Jeremy Davies',"Robert Ri'chard",'Greg Vaughan',"Jodi Lyn O'Keefe",'Richard T. Jones','Sofia Vassilieva','Dawn Olivieri','Chris Marquette','Kelly Blatz','Jason William Day','Darcey Johnson','Lanny Joon','Alyssa Diaz','Shaun Omaid','Howard Siegel','Tara Summers','Christina Chang','Philip Granger','Michael Welch','Patrick Sparling','Tom Sizemore','Sean Tyson','Danny Dworkis','Grant Harvey','Steven Lee Allen','Kevin Rankin','Heather Tom','Julianne Christie','Lance Broadway','Charles Edward Bae','Jeremiah Birkett','Matty Finochio','Rusty Schwimmer','Michael A. Goorjian','Emily Maddison','Devielle Johnson','Charisma Carpenter','AnnaMaria Demara','Nicole LaPlaca','Ronnie Gene Blevins','Alex Fernandez','Chris Payne Gilbert','Barry Nerling','Vik Sahay','Anne Leighton','Robert Picardo','Donavon Stinson','Shelene Yung','Robin Givens','Matthew MacCaull','Jessica Sula','Ted Cole','Eric Ladin','Colin Egglesfield','Michael Imperioli','Mark Dacascos','Phil LaMarr','Karen Holness','Andrea Bogart','Ryan Alosio','Michelle Arthur','Chelsea Hobbs','Nick Jandl','Veena Sood','Karin Konoval','Elfina Luk','Lindsey Gort'],
screenplay:['Neil Gaiman','Sheri Elwood','Jenn Kao','Ildy Modrovich','Chris Rafferty','Alex Katsnelson','Joe Henderson','Tom Kapinos','Jason Ning','Julia Fontana','Mike Costa','Jeffrey Lieber','Jennifer Graham Imada','Carly Woodworth','Lloyd Gilyard Jr.','Aiyana White','David McMillan'],
production:['Len Wiseman','Nathan Hope','Preston Fischer','Jenn Kao','Hilton Smith','Jonathan C. Brody','Jason Ning','Bonnie Benwick','Mike Azzolino'],
music:['Marco Beltrami','Dennis Smith','Ben Decter','Jeff Russo'],
camera:['Glen Keenan','Tico Poulakakis','Ryan McMaster','Christian Sebaldt','Barry Donlevy','Stefan von Bjorn','Tom Camarda','Ken Glassing','Paul Theriault'],
cut:["Jill D'Agnenica",'Brad Katz','Tim Mirkovich','Matthew Coleshill','Fred Peterson','Liza Schroeder','Marc Pattavina','Hector Carrillo','Lizzy Calhoun','Ray Daniels III',"Brian D'Augustine",'John Reyes-Nguyen'],
sound:['Mace Matiosian','Yuri Reese','Sean Madsen','William Smith'],
scenography:['Scott Chambliss','Chris August','Stephen Geaghan','Alex Hajdu','Timothy Stepeck','Susan Mina Eschelbach','Sophie Neudorfer','Connery Davoodian','Tim Eckel','Julie Bolder','Penny A. Chalmers'],
masks:['Maria A. Garcia','Trefor Proud','Taylor Bennett','Rachel Galey','Martina Kohl','Roxxi Dott','Vanessa Price','Amber Kemper','Victoria Ferguson','Vince Yoshida','Brigette A. Myre'],
costumes:['Julia Schklair','Agata Maszkiewicz']},
{title:'The Affair',
titleCZ:'Aféra',
year:2014,
runtime:'52h 36min',
episodeRuntime:'52-90min',
countries:['USA'],
genres:['Drama','Psychology'],
director:['Mark Mylod','Jeffrey Reiner','Carl Franklin','Ryan Fleck','Anna Boden','John Dahl','Laura Innes','Scott Winant','Michael Slovis','Agnieszka Holland','Rodrigo García','Jessica Yu','Stacie Passon','Colin Bucksey','Michael Engler','Steven Fierberg','Toa Fraser','Eva Vives','Silas Howard','Sarah Treem'],
actors:['Ruth Wilson','Dominic West','Joshua Jackson','Maura Tierney','Leya Catlett','Carolina Ravassa','Julia Goldani Telles','Rebecca Rittenhouse','Stephen Kunken','Geoffrey Owens','Michael Godere','Mare Winningham','Marko Caka','Pressly Coker','Jeffrey DeMunn','Teddy Bergman','Karina Logue',"Deirdre O'Connell",'Kaili Vernoff','Colin Donnell','Mark Margolis','Paulina Singer','John Doman','Kathleen Chalfant','Lynn Cohen','Josh Stamberg','Marin Hinkle','Blair Brown','Robert LuPone','Patrick Devaney','Anna Friedman','Richard Schiff','Jeremy Shamos','Catalina Sandino Moreno','Joanna Gleason','Peter Friedman','Jennifer Esposito','Ron Canada','Nadia Gan','Kimberly Huie','Samantha Sherman','Rich Chew','Omar Metwally','Sebastian Junger','Brooke Lyons','Nat Cassidy','James Naughton','Virginia Kull','Cynthia Nixon','James Lorinz','Guy Burnet','Brendan Fraser','Ed Moran','Tyrone Brown','René Ifrah','Irène Jacob','Sarah Ramos','Alex Ziwak','Jonathan Cake','Patrick Bauchau','Tim Guinee','Hope Olaide Wilson','Donna Mitchell','Michael Pemberton','Christian Navarro','Pierre Aussedat','Marilyne Canto','Emilie Chesnais','Agathe Dronne','Steven Fierberg','Franck Mercadal','Ana Reeder','Neal Huff','Deborah Ayorinde','Natalie Roy','Reagan Grella','Savannah Grella','Clea Lewis','Quinn VanAntwerp','Victor Williams','Dana de Celis','Elliot Villar','Marcus Callender','Hunter Emery','Sean Kleier','Marquis Rodriguez','Cindy Cheung','Dominique Fishback','Kaytlin Borgen','Jake Siciliano','Jadon Sand','Nicolette Robinson','Darren Goldstein','Danny Fischer','Kaija Matiss','Abigail Dylan Harrison','Nadja Settel','Julian Works','A Leslie Kies','Elizabeth Anweis'],
screenplay:['Alena Smith','Abe Sylvia','Sarah Treem','Kate Robin','Melanie Marnich','Anya Epstein','Mike Batistick','Sharr White','Jaquen Castellanos','Dan LeFranc','Kristina Woo'],
production:['Mark Mylod','Mike Batistick','Andrea P. Stilgenbauer','Huey M. Park','Sharr White'],
music:['Marcelo Zarvos'],
camera:['Steven Fierberg','Tod Campbell','Joe Collins','Robert McLachlan','Manuel Billeter'],
cut:['Dana Congdon','Carole Kravetz Aykanian','Pete Beaudreau','Joe Hobeck','Louis Cioffi','Todd Desrosiers','David Bilow','Kindra Marra','Jennifer Barbot','Agnes Grandits','Scott van Beever','Brian Beal'],
sound:['Richard Weingart','Penny Harold','Michael Colomby','Jared Marshack','Schavaria Reeves','Steffan Falesitch'],
scenography:['Kevin Thompson','Kelly McGehee','Ford Wheeler','Michael Novotny','Christelle Maisonneuve','Jessica Petruccelli','Jonathan Arkin'],
masks:['Rachel Galey','Tifanie White','Stephanie Barr','Ayat Malek Kiankhooy',"Katherine O'Donnell",'Claudia Humburg','Milagros Medina-Cerdeira'],
costumes:['Caroline Duncan','Christina Hribar']},
{title:'The Deuce',
titleCZ:'The Deuce: Špína Manhattanu',
year:2017,
runtime:'25h 20min',
episodeRuntime:'58-86min',
countries:['USA'],
genres:['Drama'],
director:['Michelle MacLaren','Ernest R. Dickerson','James Franco','Alex Hall','Uta Briesewitz','Roxann Dawson','Steph Green','Zetna Fuentes','Susanna White','Tricia Brock','Tanya Hamilton','Minkie Spiro'],
actors:['James Franco','Maggie Gyllenhaal','Zoe Kazan','Margarita Levijeva','Lawrence Gilliard Jr.','Don Harvey','Kim Director','Method Man','Michael Lombardi','Kevin Breznahan','Doris McCarthy','Sepideh Moafi','James Waterston','James Saito','Happy Anderson','Daryl Edwards','Van Hansis','Gary Carr','Emily Meade','Ralph Macchio','Olivia Luccardi','Gbenga Akinnagbe','Amber Skye Noyes','Chris Bauer','Chris Coy','Natalie Paul','Michael Rispoli','Anwan Glover','Michael Kostroff','Mustafa Shakir','Will Chase','Pernell Walker','Aaron Dean Eisenberg','Paul Borghese','Danielle Burgess','David Krumholtz','Michael McFadden','Genevieve Hudson-Price','David Aaron Baker','E.J. Carroll','Saul Stein','Liz Stauber','Lou Martini Jr.','Russell Posner','Chloe Levine','Daniel Hilt','James Russo','John Cenatiempo','Alyssa Kempinski','Dominique Fishback','Tom Kemnitz Jr.','Roxanne Day','Diana Bologna','Ted Sutherland','David Johnson','Christopher Botte','Steve Stanulis','Tamzin Brown','Derek Zuzunaga','DeShawn White','Jamie Neumann','Stephen Gevedon','Luke Kirby','Vic Noto','Jim Parrack','Michael Stahl-David','Annabelle Dexter-Jones','Daniel J. Watts','Alysia Reiner','Larisa Polonsky','Dagmara Dominczyk','Jeanette Dilone','Maria Dizzia','Sebastian Arcelus','Ed Moran','Bethany Lauren James','Jason Kravits','Nan Goldin','Adelind Horan','Heidi Armbruster','Armand Assante','Dena Tyler','Brian Muller','Jamar Greene','Chris Banks','Cameron Cowperthwaite','Michael Gandolfini','Roberta Colindrez','Robbie Tann','Malachy Cleary','Jimmy Palumbo','Brian Donahue','Hannah Elless','Joel Marsh Garland','Rayford Sewell','Delphina Belle','Taylor Selé','Henry Ayres-Brown','Mark C. Fullhardt','Antoinette LaVecchia'],
screenplay:['Richard Price','David Simon','George Pelecanos','Chris Yakaitis','Anya Epstein','Carl Capotorto','Iturri Sosa','Megan Abbott','Lisa Lutz'],
production:['Maggie Gyllenhaal','Anya Epstein','Carl Capotorto','Claire Shanley'],
camera:['Pepe Avila del Pino','Vanja Cernjul','Yaron Orbach'],
cut:['Kate Sanford','Alex Hall','Colleen Sharp','Matthew Booras','Shelby Siegel'],
sound:['Adam Rooner','Andy Kris'],
scenography:['Laurence Bennett','Beth Mickle','Scott Dougan','Shannon Finnerty','Mila Khalevich','Miguel López-Castillo','Kristin Gibler','Lisa Scoppa'],
masks:['Charlene Belmond','Brittany Romney','John Caglione','Jr.','Valerie Gladstone-Appel','Jeni Zaharian','Patrick Alemi','Laura Burns','Amy Sue Nahhas','Mariko Miyagi'],
costumes:['Anna Terrazas','Jenny Gering']},
{title:'My Name',
titleCZ:'Modrá až na kost',
year:2021,
runtime:'6h 39min',
episodeRuntime:'45-59min',
countries:['South Korea'],
genres:['Action','Drama','Crime'],
director:['Jin-min Kim'],
actors:['Bo-hyeon Ahn','So-hee Han','Hee-soon Park','Rich Ting','Dong-kyu Han','Suk-Kyu Seo','Sang Min Moon','Gwang-il Choi','Ye-Ji Hong'],
screenplay:['Ba-da Kim'],
music:['Sang-jun Hwang']},
{title:'Roots: The Next Generations',
titleCZ:'Kořeny: Další pokolení',
year:1979,
runtime:'11h 25min',
episodeRuntime:'95-100min',
countries:['USA'],
genres:['Drama','History'],
director:['John Erman','Charles S. Dubin','Georg Stanford Brown'],
actors:['Georg Stanford Brown','Debbi Morgan','Dorian Harewood','Olivia de Havilland','Henry Fonda','Marc Singer','Richard Thomas','Robert Culp','Harry Morgan','Roger E. Mosley','Paul Koslo','Stan Shaw','Irene Cara','Ossie Davis','Ruby Dee','Jiří Voskovec','Pam Grier','John Rubinstein','Dina Merrill','Brock Peters','Beah Richards','Paul Winfield','Gerald McRaney','Ernie Hudson','Charles Robinson','Andy Griffith','Diahann Carroll','John Hancock','Della Reese','Barbara Barrie','Marlon Brando','James Broderick','Michael Constantine','Al Freeman Jr.','James Earl Jones','Jane Rose','Johnny Sekka','Diana Douglas','Albert Hall','Howard E. Rollins Jr.','Zakes Mokae','Bernie Casey','Percy Rodrigues','Brian Stokes Mitchell','J.A. Preston','Debbie Allen','Kieu Chinh','Norman Fell','Maidie Norman','James Daly','Dennis Fimple','Logan Ramsey','Bill Quinn','Claudia McNeil','Charles Lucia','J. Patrick McNamara','Jon Cedar','Frederick Combs','James Keane','William Mims','Abdoulaye NGom','Timothy Scott','Ted Gehring','Les Lannom','Milt Kogan','Bill Henderson','Bruce French','Charles Lampkin','Don Keefer','Albert Popwell','Hal Williams','Lynne Moody','Kene Holiday','Mel Stewart','Roosevelt Grier','Lynn Hamilton',"Gerald S. O'Loughlin",'F. William Parker','Joel Fluellen','Earl Billings','Michael Alldredge','John Carter','Patrick Cronin','Fred Stuthman','Al Fann','Jason Wingreen','Richard Sanders','Fay Hauser','Robert Kya-Hill','E. Lamont Johnson','Damon Evans','Greg Morris','Fran Bennett',"Ja'net DuBois",'Essex Smith','Lee Chamberlin','Royce Wallace','Kathleen Doyle','Theodore Lehmann','Sue Ann Gilfillan'],
basedOn:['Alex Haley'],
screenplay:['John McGreevey','Thad Mumford','Ernest Kinoy'],
production:['Stan Margulies'],
music:['Gerald Fried'],
camera:['Joseph M. Wilcots'],
cut:['Neil Travis','John W. Wheeler','David Saxon','Robbe Roberts'],
scenography:['Bill Webb','Robert MacKichan'],
masks:['Joe DiBella','David Dittmar'],
costumes:['Tom Dawson']},
{title:'Cover Her Face',
titleCZ:'Zahalte jí tvář',
year:1985,
runtime:null,
episodeRuntime:'6x50min',
countries:['UK'],
genres:['Crime','Drama','Mystery'],
director:['John Davies'],
actors:['Roy Marsden','John Vine','Phyllis Calvert','Norman Wooland','Julian Glover','Clare Higgins','Robert Glenister','Richenda Carey','Struan Rodger','Dimitri Andreas','Freda Dowie','John Crocker','Rupert Frazer','Charles Morgan','Ronnie Stevens','Nick Berry','David Brierly','Kim Thomson','Jean Heywood','Barbara Hicks','Alan Chuntz','Elizabeth Benson','Vivienne Burgess','Bill Fraser','Will Leighton'],
basedOn:['P. D. James'],
screenplay:['Robin Chapman'],
production:['John Rosenberg'],
music:['Richard Harvey'],
cut:['Kevin Waters']},
{title:'Single Father',
titleCZ:'Svobodný otec',
year:2010,
runtime:null,
episodeRuntime:'4h60min',
countries:['UK'],
genres:['Comedy','Drama'],
director:['Sam Miller'],
actors:['David Tennant','Suranne Jones','Neve McIntosh','Laura Fraser','Warren Brown','Sophie Kennedy Clark','Rupert Graves','Mark Heap','Isla Blair','Millie Innes','Stuart Sinclair Blyth','Stephen McCole','Paul Chaal','Gregor Gillespie','Carter Ferguson','Elaine M. Ellis','Matthew Zajac','Alan McHugh','John Macauley'],
screenplay:['Mick Ford'],
music:['Murray Gold'],
camera:['Ulf Brantås'],
cut:['Katie Weiland'],
costumes:['Rhona Russell']},
{title:'Berlin Alexanderplatz',
titleCZ:'Berlín, Alexandrovo náměstí',
year:1980,
runtime:'15h 1min',
episodeRuntime:'58-112min',
countries:['Germany','Italy'],
genres:['Drama','Crime'],
director:['Rainer Werner Fassbinder'],
actors:['Günter Lamprecht','Karlheinz Braun','Hanna Schygulla','Claus Holm','Franz Buchrieser','Brigitte Mira','Roger Fritz','Gottfried John','Barbara Sukowa','Günther Kaufmann','Ivan Desny','Volker Spengler','Vitus Zeplichal','Barbara Valentin','Herbert Steinmetz','Lilo Pempeit','Fritz Schediwy','Elisabeth Trissenaar','Marquard Bohm','Hark Bohm','Karl-Heinz von Hassel','Udo Kier','Werner Schroeter','Kurt Weinzierl','Adrian Hoven','Helmut Griem','Margit Carstensen','Irm Hermann','Katrin Schaake','Karin Baal','Raúl Gimenez','Harry Baer','Joachim Kemmer','Dirk Galuba','Peer Raben','Elma Karlowa','Almut Eggert','Hans-Michael Rehberg','Annemarie Düringer','Yaak Karsunke','Jan George','Karl Scheydt','Christiane Maybach','Y Sa Lo','Matthias Fuchs','Sonja Neudorfer','Helen Vita','Rolf Zacher','Mechthild Großmann','Hermann Lause','Traute Hoess','Marie-Luise Marjan','Roland Schäfer','Werner Asam','Herb Andress','Rainer Will','Jan Groth','Juliane Lorenz','Jürgen Draeger','Wolfried Lier','Klaus Höhne','Axel Bauer','Kristine de Loup','Peter Kuiper','Elke Haltaufderheide','Wolfgang Schenck','Hans Zander','Angela Schmid-Burgk','Rainer Werner Fassbinder','Angela Schmid','Engelbert von Nordhausen','Wolfgang Bathke','Georg Lehn','Rainer Werner Fassbinder','Walter Reichelt','Dieter Prochnow','Angela Schmid'],
basedOn:['Alfred Döblin'],
screenplay:['Rainer Werner Fassbinder'],
production:['Günter Rohrbach','Peter Märthesheimer'],
music:['Peer Raben'],
camera:['Xaver Schwarzenberger'],
cut:['Juliane Lorenz'],
sound:['Milan Bor','Hans R. Weiss'],
costumes:['Barbara Baum']},
{title:'The Life of Leonardo Da Vinci',
titleCZ:'Život Leonarda Da Vinci',
year:1971,
runtime:'6h 45min',
episodeRuntime:'81min',
countries:['Italy','Spain'],
genres:['Biographic','History'],
director:['Renato Castellani'],
actors:['Philippe Leroy','Giampiero Albertini','Renato Chiantoni','Ottavia Piccolo','Bruno Boschetti','Renato Cestiè','Donato Castellaneta','Christian de Tillière','Glauco Onorato','Filippo Scelzo','Renato Montalbano','Germano Longo','Nino Dal Fabbro','Alberto Sorrentino','Enrico Osterman','Christopher Hodge','Renato Malavasi','Sara Franchetti','Riad Gholmie','Bruno Cirino','Maria Marchi'],
screenplay:['Renato Castellani','Ivo Perilli'],
music:['Roman Vlad'],
camera:['Antonio Secchi'],
cut:['Otello Colangeli'],
scenography:['Ezio Frigerio'],
costumes:['Ezio Frigerio']},
{title:'Crest of the Stars',
titleCZ:'Hvězdný erb',
year:1999,
runtime:'5h 28min',
episodeRuntime:'24-40min',
countries:['Japan'],
genres:['Animation','Drama','Romance','Sci-Fi'],
director:['Jasučika Nagaoka','Keitaró Motonaga','Tošija Šinohara','Jukio Nišimoto','Mihiro Jamaguči','Susumu Nišizawa','Osamu Nabešima','Jasuhiro Minami'],
actors:['Ajako Kawasumi','Juka Imai','Hidejuki Tanaka','Hirotaka Suzuoki','Ikue Ótani','Iššin Čiba','Džúróta Kosugi','Kaneto Šiozawa','Mika Doi','Susumu Čiba','Takehito Kojasu','Unšó Išizuka','Wataru Takagi','Takako Fudži','Micuki Saiga','Šóko Cuda','Gara Takašima','Akio Sujama','Taiki Macuno','Rika Fukami','Mičihiro Ikemizu','Mugihito','Issei Mijazaki','Masajo Hosono','Masami Tojošima','Maki Tamura','Haruhiko Jó','Kódži Jusa','Mari Tomokawa','Eiičiró Suzuki','Ajako Kurosaki'],
basedOn:['Hirojuki Morioka'],
screenplay:['Aja Jošinaga'],
production:['Acuši Sugita','Masaki Kaifu'],
music:['Kacuhisa Hattori'],
camera:['Hisao Širai'],
cut:['Takeši Sejama'],
sound:['Kacujoši Kobajaši'],
scenography:['Tomoaki Okada']},
{title:'Kitchen Confidential',
titleCZ:'Šéfkuchař nadivoko',
year:2005,
runtime:'4h 46min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Comedy'],
director:['Peter Lauer','Darren Star','Matt Shakman','Fred Savage','Victor Nelli Jr.','Michael Spiller','Henry Chan','Victoria Hochberg','Dennie Gordon','Lev L. Spiro'],
actors:['Bradley Cooper','Nicholas Brendon','John Francis Daley','Jaime King','Bonnie Somerville','Owain Yeoman','Sam Pancake','John Cho','Frank Langella','Tessie Santiago','Erinn Hayes','Ralph P. Martin','Helena Mattsson','Morena Baccarin','Lauren Stamile','Meredith Roberts','Gigi Orsillo','Mei Melançon','Ragan Wallake','Ava Bellamy','Adrienne Janic','Ali Costello','Bitty Schram','Michelle Belegrin','Iqbal Theba','Ashley Palmer','Andrea Martin','Symba','Jordana Spiro','Aja Evans','Tammi Sutton','Arick Salmea','Andrea Parker','Stephen Rannazzisi','Suzanne Ford','Alex Craig Mann','Jennifer Ann Massey','Clement von Franckenstein','Lindsay Price','Mitch Silpa','Rob Boltin','Bashir Salahuddin','Melanie Paxson','Gary Wolf','Robb Skyler','Matt Winston','Karen Maruyama','Arden Myrin','David Aranovich','Carole Gutierrez','Sadie Stratton','Jeanette Miller','Angelica Bridges','Aaron Hendry','Mary Christina Brown','Keith MacKechnie','Robin McDonald','Kristopher Logan','Michael Maize','Jordan Black','Nikki Novak','Marcy Goldman','J. Richey Nash','Philippe Bergeron','Kevin Foster','John Larroquette','Michael Vartan','Allan Wasserman','Samm Levine','Naja Hill','Concetta Tomei','Loren Lazerine','Keith Pillow','Kerry Carney','Susan Slome','Dmitri S. Boudrine','Joey Vieira','Richard Molinare','Toni Sawyer'],
basedOn:['Anthony Bourdain'],
screenplay:['David Hemingson','Joshua Sternin','Jennifer Ventimilia','Dan Sterling','Dean Lopata','Lesley Wake','Richard Appel','Karine Rosenthal','Stacy Traub'],
production:['Lesley Wake'],
music:['Mark Kilian','Daniel Licht'],
camera:['Tim Ives','Joe Pennella','Bruce M. Pasternack'],
cut:['John Axness','Wendy Smith'],
sound:['Brian Harman','Dean Okrand','Mike Brooks'],
scenography:['Stephen Hendrickson','Leslie McCarthy-Frankenheimer'],
masks:['Nancy Baca'],
costumes:['Genevieve Tyrrell','Roberta Keith']},
{title:'The League of Gentlemen',
titleCZ:'Liga gentlemanů',
year:1999,
runtime:'11h 24min',
episodeRuntime:'29-60min',
countries:['UK'],
genres:['Comedy','Horror'],
director:['Steve Bendelack'],
actors:['Mark Gatiss','Steve Pemberton','Reece Shearsmith','Jeremy Dyson','Blake Ritson','David Arnold','John Lebar','Joby Talbot','Sian Gibson','Neil Bell','Johnny Leeze','Brooke Vincent','Coz Greenop','Liza Tarbuck','Colin Parry','Ameet Chana','Bay White','Jon Key','Ade Dimberline','Paul Popplewell','Nicky Goldie','Nicholas Briggs','Scott Langridge','John Draycott','Ted Robbins','Steven Hillman'],
screenplay:['Mark Gatiss','Steve Pemberton'],
music:['Joby Talbot','Jeremy Holland-Smith'],
camera:['Rob Kitzmann'],
cut:['Tony Cranstoun','Andrew Wilks','Adam Windmill','Jennifer Sheridan','Peter Hallworth'],
scenography:['Grenville Horner','Simon Rogers','Sarah Kane'],
masks:['Daniel Phillips','Pippa Hindle'],
costumes:['Yves Barre']},
{title:'Trollhunters',
titleCZ:'Lovci trolů od Guillerma Del Toro',
year:2016,
runtime:'20h 42min',
episodeRuntime:'23-24min',
countries:['USA','Mexico'],
genres:['Animation','Action','Adventure','Comedy','Drama','Family','Fantasy','Sci-Fi'],
director:['Rodrigo Blaas','Guillermo del Toro','Elaine Bogan','Simon Otto','Andrew L. Schmidt','Johane Matte'],
actors:['Kelsey Grammer','Anton Yelchin','Lexi Medrano','Charlie Saxton','Fred Tatasciore','Cole Sand','Ron Perlman','Jonathan Hyde','Tom Hiddleston','Amy Landecker','Laraine Newman','James Purefoy','Yara Shahidi','Tom Wilson','Steven Yeun','Melanie Paxson','Rodrigo Blaas','Victor Raider-Wexler','Lauren Tom','Tom Kenny','Frank Welker','Clancy Brown','Andrea Navedo','Bebe Wood','Anjelica Huston','Matthew Waterson','Grey Griffin','Mark Hamill','Joanna Leeds','Jim Pirri','Alan Shearman','Lena Headey','Ashley Peldon','Kyle T. Heffner','Scott Menville','David Bradley','Wallace Shawn','Tatiana Maslany','Emile Hirsch','Diego Luna',"Bret 'Brook' Parker",'Ike Amadi','Hope Levy','Guillermo del Toro','Rif Hutton','Kelly Stables','Bridget Hoffman',"Colin O'Donoghue",'Edie Mirman','Alastair Duncan','Sherry Hursey','Brook Chalmers','Chad Hammes','Warren Sroka'],
basedOn:['Guillermo del Toro','Daniel Kraus'],
screenplay:['Marc Guggenheim','Dan Hageman','Kevin Hageman','Guillermo del Toro','A.C. Bradley','Chad Quandt','Aaron Waltke','Lila Scott'],
production:['Rodrigo Blaas','Christina Steinberg','Chad Hammes'],
music:['Jeff Danna','Tim Davies','John Fee','The Crystal Method','Alexandre Desplat'],
cut:['Graham Fisher','John Laus'],
sound:['Carlos Sanches','Otis Van Osten','Noyan Coşarer']},
{title:'Fringe',
titleCZ:'Hranice nemožného',
year:2008,
runtime:'74h 31min',
episodeRuntime:'43-81min',
countries:['USA'],
genres:['Mystery','Sci-Fi','Thriller','Horror'],
director:['Joe Chappelle','Brad Anderson','Frederick E.O. Toye','Jeannot Szwarc','Charles Beeson','Dennis Smith','Akiva Goldsman','Jeffrey G. Hunt','David Straiton','Alex Graves','Paul A. Edwards','Christopher Misiano','Bill Eagles','Gwyneth Horder-Payton','Michael Zinberg','John Polson','Bryan Spicer','Jon Cassar','Paul Holahan','Deran Sarafian','Adam Davidson','Seith Mann','Kenneth Fink','Chuck Russell','Miguel Sapochnik','Anthony Hemingway','Thomas Yatsko','David Moxness','Eagle Egilsson','Jeff T. Thomas','Norberto Barba','Bobby Roth','David Solomon','J.H. Wyman','P.J. Pesce','Tommy Gormley'],
actors:['Anna Torv','Joshua Jackson','Lance Reddick','Blair Brown','Jasika Nicole','John Noble','Kirk Acevedo','Seth Gabel','Michael Cerveris','Mark Valley','Leonard Nimoy','Ryan McDonald','Michael Kopsa','Jared Harris','Lily Pilblad','Ari Graynor','Eugene Lipinski','Sebastian Roché','Kevin Corrigan','Georgina Haig','Clark Middleton','Chance Kelly','Michael Gaston','David Call','Peter Hermann','Zak Orth','Nestor Serrano','Michael Kelly','Jason Butler Harner','Max Baker','Derek Cecil','Chris Eigeman','Marjan Neshat','Billy Burke','Kenneth Tigar','William Sadler','Randall Duk Kim','Yul Vazquez','Susan Misner','James Frain','Chris Bauer','Mary Beth Peil','Noah Fleiss','Al Sapienza','Ebon Moss-Bachrach','Daniel London','Spencer List','Jeremy Shamos','Keith Nobbs','Kiersten Warren','Jefferson Mays','Trieste Kelly Dunn','Jennifer Ferrin','Clint Howard','Luke Goss','Simone Kessell','Meghan','vévodkyně ze Sussexu','John Savage','Stephen McHattie','Claudette Mink','Roger Cross','Theresa Russell','Ravi Kapoor','Travis Schuldt','JR Bourne','Cameron Monaghan','Ali Liebert','Jennifer Missoni','Paul Rae','Peter Woodward','Liam James','Laura Mennell',"Michael O'Neill",'David Orth','Michelle Harrison','Gillian Jacobs','Lars Gerhard','Kevan Ohtsji','Mark Elliot Wilson','James Schram','Harry L. Seddon','Deborah Twiss','Diane Kruger','Gbenga Akinnagbe','Charlie Tahan','Neal Huff','David Nykl','Jennifer Butler','Mark Lotito','Ty Jones','Martin Cummins','Sean Rogerson','Jorge Garcia','Greyston Holt','Sam Vincent','Kacey Rohl','Katie Findlay','David Richmond-Peck','Omar Metwally'],
screenplay:['J.H. Wyman','Jeff Pinkner','Akiva Goldsman','Alison Schapker','Josh Singer','David Fury','J.J. Abrams','David H. Goodman','David Wilcox','Matt Pitts','Ashley Miller','Zack Stentz','Zack Whedon','Monica Owusu-Breen','Jeff Vlaming','Alex Kurtzman','Roberto Orci','Andrew Kreisberg','Justin Doble','Nora Zuckerman','Lilla Zuckerman','Graham Roland','Glen Whitman','Julia Cho','Jason Cahill','J.R. Orci','Brad Kane'],
production:['Robert M. Williams Jr.','Tanya M. Swerling','Reid Shane','Josh Singer','Graham Roland','Jeff Vlaming','J.R. Orci'],
music:['Michael Giacchino','Chris Tilton','Chad Seiter'],
camera:['Fred Murphy','Thomas Yatsko','Michael Bonvillain','David Moxness','Gregory Middleton','David Geddes','Michael Slovis','Gordon Verheul','Michael Wale'],
cut:['Jon Dudkowski','Luyen Vu','Timothy A. Good','Scott Vickrey','Tanya M. Swerling','Henk Van Eeghen','Michelle Tesoro','Russell Denove','Joshua Charson','Jennifer Van Goethem','Chad Rubel'],
sound:['Dan Hiland','Walter Newman','Brian Harman','Eric Justen','Mark D. Fleming','Gary D. Rogers','Ryan Davis','Rick Norman','Larry Hoff','Tom E. Dahl','Thomas A. Harris'],
scenography:['Steven J. Jordan','Carol Spier','Ian D. Thomas','Anne Stuhler','Peter P. Nicolakakos','Beth Kushnick','Elinor Rose Galbraith'],
masks:['Gordon J. Smith','Linda Dowds','Mike Fields','Vince Yoshida'],
costumes:['Jenni Gullett','Joanne Hansen','Marie Abma']},
{title:'Reacher',
titleCZ:'Jack Reacher',
year:2022,
runtime:'13h 11min',
episodeRuntime:'42-56min',
countries:['USA'],
genres:['Action','Drama','Crime'],
director:['Lin Oeding','Thomas Vincent','Sam Hill','Stephen Surjik','Christine Moore','Norberto Barba','Omar Madha','M.J. Bassett','Carol Banker','Julian Holmes'],
actors:['Alan Ritchson','Malcolm Goodwin','Willa Fitzgerald','Bruce McGill','Chris Webster','Maria Sten','Harvey Guillén','Hugh Thompson','Willie C. Carpenter','Kristin Kreuk','Currie Graham','Jonathan Koensgen','Martin Roach','Maxwell Jenkins','Gavin White','Leslie Fray','Marc Bendavid','Matthew Marsden','Patrick Garrow','Catherine Fitch','Paul Braunstein','Lara Jean Chorostecki','Peter Skagen','Kelsey Falconer','Jason Cavalier','Bart Badzioch','James Millington','Brendan Beiser','Ava Cheung','Paulino Nunes','Claire Armstrong','Kyle Gatehouse','Jenni Burke','Jennifer Marshall','Ali Johnson','Kelvin Han Yee','Alan Catlin','Philip Williams','Blake Lindsley','Adam Kenneth Wilson','Dylan Trowbridge','Deborah Tennant','Alexandra Castillo','Jorja Cadence','Katherine Trowell','Ivan Wanis-Ruiz','Laurie Murdoch','Christopher Russell','Lee Child','Jackie Richardson','Drew Moss','Ava Louise Murchison','Baeyen Hoffman','Andres Collantes','Hazel Gorin','Ray Galletti','Robert Patrick','Domenick Lombardozzi','Serinda Swan','Shaun Sipos','Ferdinand Kingsley','Joris Jarsky','Edsson Morales','Luke Bilyk','Shannon Kook','Dean McKenzie','Karl Campbell','Colton Royce','Linda Goranson','Pearl Sun','Arlen Aguayo Stewart','Lochlyn Munro','Neven Pajkic','Adrian Griffin','Gavin Fox','Christina Cox','Josh Blacker','Lindsay Owen Pierre','Lorna Wilson','Nicolas Grimes','Al Sapienza','Kyle Mac','Hailey Summer'],
basedOn:['Lee Child'],
screenplay:['Scott Sullivan','Nick Santora','Aadrita Mukerji','Cait Duffy','Penny Cox'],
production:['Aadrita Mukerji','Agatha Warren','Derek Rappaport','Penny Cox'],
music:['Tony Morales'],
camera:['Ronald Plante','Michael McMurray','Bernard Couture'],
cut:['J.J. Geiger','Eric Seaburn','Anthony Miller','Christopher Donaldson','Sang Han'],
sound:['Marshall Garlington'],
scenography:['Patricio M. Farrell','Liesl Deslauriers','Nazgol Goshtasbpour'],
costumes:['Abram Waterhouse']},
{title:'The Heavy Water War',
titleCZ:'Boj o těžkou vodu',
year:2015,
runtime:'4h 27min',
episodeRuntime:'44-45min',
countries:['Norway'],
genres:['Drama','History','War'],
director:['Per-Olav Sørensen'],
actors:['Andreas Döhler','Robert Hunger-Bühler','Marc Ben Puch','Christoph Bach','Peri Baumeister','Espen Reboli Bjerke','Torstein Bjørklund','Endre Ellefsen','Ole Christoffer Ertvaag','Eirik Evjen','Anna Friel','Ragnhild H. Myntevik','Benjamin Helstad','Espen Klouman Høiner','Frank Kjosås','Rolf Kristian Larsen','Mads Sjøgård Pettersen','Søren Pilmark','Christian Rubeck','Maibritt Saerens','Audun Sandem','Tobias Santelmann','Dennis Storhøi','Pip Torrens','Stein Winge','David Zimmerschied','Julia Schacht','Corey Johnson','Uwe Preuss','Zdeněk Pecha','Jim High','Thomas Wehling','Dominique Guillo','Ingeborg Sundrehagen Raustøl','Glenn André Kaada','Clara Lien Sunde','Elg Elgesem','Bjørn Iversen','Bo Alexander Hallan','Damian Odess-Gillett','Philipp Schenker','Øyvind Mørk'],
screenplay:['Petter S. Rosenlund','Øyvind Rune Stålen'],
production:['Kari Moen Kristiansen'],
music:['Kristian Eidnes Andersen'],
camera:['John Christian Rosenlund'],
cut:['Martin Stoltz','Perry Eriksen','Silje Nordseth'],
sound:['Kristoffer Salting','Kristian Eidnes Andersen'],
scenography:['Jindřich Kočí','Karl Júlíusson'],
masks:['Mattias Tobiasson','Hanna Holm','Brita Johansen','Eva von Bahr','Hana Šurkalová'],
costumes:['Karen Fabritius Gram']},
{title:'Ripping Yarns',
titleCZ:'Neskutečné historky',
year:1976,
runtime:'4h 33min',
episodeRuntime:'29-32min',
countries:['UK'],
genres:['Adventure','Comedy'],
director:['Terry Hughes','Alan J.W. Bell'],
actors:['Michael Palin','Terry Jones','Denholm Elliott','Gwen Watford','Ian Ogilvy','John Barrett','Kenneth Colley','Candace Glendenning','John Louis Mansi','Edward Hardwicke','Jack May','David Leland','John Cleese','Roy Kinnear','Maria Aitken','Roger Sloman','Richard Vernon','Allan Cuthbertson','Matthew Scurfield','Hilary Mason','Liz Smith','Timothy Carlton','Don Henderson','Eileen Way','Nicholas Day','Petra Markham','Anita Carey','Roland MacLeod','Judy Loe','David Griffin','Barbara New','Norman Mitchell','Frank Middlemass','Iain Cuthbertson','John Wentworth','Roger Avon','Roger Brierley','Anthony Smee','Tenniel Evans','Ann Way','Anthony Carrick','Anthony Wooddruff','Dickie Arnold','Aubrey Morris','John Le Mesurier','Isabel Dean','Reg Lye','Dorothy Frere','Gerald Sim','Gilly Flower','Joan Sanderson','Charles McKeown','Ken Shorter','Richard Martin','Roald Amundsen','Marta Gillot','Teddy Turner'],
screenplay:['Terry Jones','Michael Palin'],
music:['André Jacquemin','Dave Howman'],
masks:['Jacqui Fitzmaurice'],
costumes:['Barbara Lane']},
{title:'The Ray Bradbury Theater',
titleCZ:'Divadlo Raye Bradburyho',
year:1985,
runtime:'25h 43min',
episodeRuntime:'21-30min',
countries:['Canada','France','UK','USA','New Zealand'],
genres:['Sci-Fi','Fantasy','Drama','Thriller','Tale'],
director:['Allan Eastman','Timothy Bond','Mario Azzopardi','Alan J. Levi','J. Miles Dale','Paul Lynch','T.J. Scott','William Gereghty','Michael Vejar','Paul Shapiro','Randy Bradshaw','Denys Granier-Deferre','Gilles Béhat','Don McBrearty','Ralph L. Thomas','William Fruet','Bruce Pittman','Douglas Jackson','Wayne Tourell','Steve DiMarco','Alain Bonnot','Gilbert M. Shilton','Brad Turner','Sturla Gunnarsson','Alun Bollinger'],
actors:['Ray Bradbury','Kenneth Welsh','Leslie Nielsen','James Coco','Cliff De Young','Jayne Eastwood','William Shatner','Barry Flatman','Nick Mancuso','Cec Linder','John Rubinstein','Ward Kimball','Charles Martin Smith','Drew Barrymore','Alan Scarfe','Ken James','Jeff Goldblum','Ron Lea','Roger E. Mosley','Yvette Nipar','Gwynyth Walsh','Michael A. Miranda','Gregory Scott Cummins','Jeremy Ratchford','Sherry Miller','Donald Burda','Krista Bridges','Lori Hallier','David Orth','Peter McCauley','John Vernon','Kiel Martin','Len Cariou','John Bach','R.H. Thomson',"Peter O'Toole",'Stephen Lovatt','Janice Rule','Stephen Papps','Stuart Devenie','David Telford','William Kircher','Jean Stapleton','Chad Krowchuk','Bruce Allpress','James Kidnie','Wayne Robson','Janet-Laine Green','Richard Kiley','Paul Coeur','Bill Johnson','Leigh Lawson','Roy Kinnear','Gordon Thomson','Linda Kelsey','John Saxon','Keram Malicki-Sánchez','Pat Harrington Jr.','David Taylor','Jennifer Dale','Kate Trotter','Gregory Sierra','Susan Wooldridge','Frank Whitten','Henry Beckman','Hervé Pauchon','Clare Coulter','George Touliatos','Cedric Smith','Ken James','John Sumner','Cris Campion','Kate Lynch','Sheila Moore','Arne MacPherson','Ron White','Monica Parker','Clive Swift','Brian Jensen','Geordie Johnson','Sally Kirkland','François Clavier','Malcolm Stewart','Frank Charles Turner','Robin Soans','George Anton','Josh Saviano','Peter Rowley','Ben Cardinal','Michael Ironside','Eugene Levy','Robert Vaughn','Helen Shaver','Sonja Smits','Saul Rubinek','Féodor Atkine','Micheline Presle','Henri Poirier','Paul Clemens','Damien Atkins'],
basedOn:['Ray Bradbury'],
production:['Seaton McLean','Arvi Liimatainen','Mary Kahn'],
music:['Fred Mollin','Louis Natale','John Massari','Amin Bhatia','Éric Demarsan','Donald Quan','George Blondheim','Drew King','Domenic Troiano'],
camera:['Tobias A. Schliessler','Richard Bluck','Brian R.R. Hebb','André Neau','Jean Charvein','John Spooner','Jim Jeffrey','Thomas Burstyn','Mark Irwin','Gilberto Azevedo','Dean Bennett','Donald Duncan','Alun Bollinger','Matt Bowkett'],
cut:['John Gilbert','Jamie Selkirk','Sophie Cornu','Peter Svab','Geneviève Vaury','Ralph Brunjes','Christopher Tate','George Appleby','Lenka Svab','Roger Mattiussi','Allan Lee','Alberto Yaccelini','Michael Fruet','Owen Ferrier-Kerr'],
sound:['Jack Heeren','Jack Jullian'],
scenography:['Alicia Keywan','Robert Pearson','Étienne Méry','John Blackie','Elinor Rose Galbraith','Jennifer Ward'],
masks:['Sylvia Carissoli','Kathleen Graham'],
costumes:['Ngila Dickson','Wendy Partridge','Eileen Kennedy','Maya Mani','Gina Kiellerman']},
{title:'Nobuta wo Produce',
titleCZ:'Nobuta. O produce',
year:2005,
runtime:null,
episodeRuntime:'9h54min',
countries:['Japan'],
genres:['Comedy','Drama'],
director:['Hitoši Iwamoto'],
actors:['Kazuja Kamenaši','Tomohisa Jamašita','Maki Horikita','Erika Toda','Jošinori Okada','Nacuna','Šunsuke Daitó','Júto Nakadžima','Kacumi Takahaši','Takeši Masu','Ukadži Takaši','Makoto Sakamoto','Rjúja Wakaba','Rumi Hiiragi','Jasuhisa Furuhara','Erika Janagita','Kanako Fukaura','Džuri Ihata','Júiči Kimura','Ei Morisako','Tomoja Išii','Kazuma Jamane','Seiko Takuma','Yukina Takase','Akiko Óki'],
basedOn:['Gen Širaiwa'],
screenplay:['Júsuke Watanabe','Izumi Kizara']},
{title:'Thai Cave Rescue',
titleCZ:'Záchranná mise v thajské jeskyni',
year:2022,
runtime:null,
episodeRuntime:'6h60min',
countries:['Thajsko','USA'],
genres:['Drama','Adventure','Thriller'],
director:['Baz Poonpiriya','Kevin Tancharoen'],
actors:['Thaneth Warakulnukroh','Papangkorn Lerkchaleampote','Pratya Patong','Songpon Kantawong','Chakkapat Srisat','Thanawut Chetuku','Teeraphat Somkaew','Thanaphong Kanthawong','Thanapat Phungpumkaew','Apisit Yukam','Watcharaphol Poungsawan','Rataphumi Nakisatit','Manatsanun Panlertwongsakul','Arisara Wongchalee','Ronnagaoen Sanitprapadsorn','Monthatip Suksopha','Watthanachai Treedecha','Tanapol Chuksrida','Kumron Jivachat','Sunon Wachirawarakarn','Patchamon Park','Pichai Apichai','Potchani Yailaor','Kane Suh','Apisit Sangjan','Christopher Stollery','Stephen Phillips','Jarunun Phantachat','Damon Herriman','Nicholas Bell','Kevin Garner'],
screenplay:['Michael Russell Gunn','Dana Ledoux Miller'],
music:['Susie Benchasil Seiter','Austin Wintory'],
camera:['Glen MacPherson','Adam Suschitzky'],
cut:['Justin Li','James Patrick','Chonlasit Upanigkit'],
sound:['Matthew Chan'],
scenography:['Jonathan McKinstry',"Carolyn 'Cal' Loucks"],
masks:['Thirawit Solas',"Panupak 'Eiang' Duangchareonsri"],
costumes:['Jo Katsaras']},
{title:'The Owl House',
titleCZ:'Soví dům',
year:2020,
runtime:'17h 10min',
episodeRuntime:'22-55min',
countries:['USA'],
genres:['Animation','Fantasy','Adventure','Horror','Comedy'],
director:['Stephen Sandoval','Amelia Lorenz','Bosook Coburn','Stu Livingston','Aminder Dhaliwal'],
actors:['Sarah-Nicole Robles','Wendie Malick','Alex Hirsch','Issac Ryan Brown','Parvesh Cheena','Eden Riegel','Bumper Robinson','Mae Whitman','Tati Gabrielle','Matthew Rhys','Isabella Rossellini','Roger Craig Smith','Keith Ferguson','Grey Griffin','Dana Terrace','Elizabeth Grullon','Zeno Robinson','Steve Blum','Erica Lindbeck','Rachael MacFarlane',"Ryan O'Flanagan",'Jim Pirri','Lily Sanfelippo','Shannon McKain','Kimberly Brooks','Michaela Dietz','Stephen Sandoval','Kari Wahlgren','Fryda Wolff','Noshir Dalal','Eileen Galindo','Jorge Diaz','André Sogliuzzo','Jake Green'],
screenplay:['Dana Terrace','Zach Marcus','Mikki Crisostomo','Molly Ostertag','John Bailey Owen','Charley Feldman','Rachel Vine','Jeff Trammell'],
production:['Stephen Sandoval','Wade Wisinski'],
music:['T.J. Hill','Brad Breeck'],
cut:['Kevin Locarro'],
sound:['Eric Freeman'],
scenography:['Ricky Cometa']},
{title:'The Walking Dead',
titleCZ:'Živí mrtví',
year:2010,
runtime:'134h 18min',
episodeRuntime:'40-67min',
countries:['USA'],
genres:['Horror','Thriller','Drama'],
director:['Frank Darabont','Ernest R. Dickerson','Greg Nicotero','Michelle MacLaren','Johan Renck','Guy Ferland','Lew Temple','David Boyd','Michael Uppendahl','Seith Mann','Phil Abraham','Michael Slovis','Billy Gierhart','Clark Johnson','Daniel Sackheim','Tricia Brock','Jeremy Podeswa','Kari Skogland','Avi Youabian','Jennifer Lynch','Alrick Riley','Darnell Martin','Rosemary Rodriguez','Julius Ramsay','Jeffrey F. January','Gwyneth Horder-Payton','Daniel Attias','Lesli Linka Glatter','Stefan Schwartz','Michael E. Satrazemis','Larysa Kondracki','Stephen Williams','Dan Liu','John Polson','Larry Teng','Daisy von Scherler Mayer','Michael Cudlitz','Meera Menon','Liesl Tommy','Millicent Shelton','Laura Belsey','John Dahl','Bronwen Hughes','Sharat Raju','Kevin Dowling','Frederick E.O. Toye','Jon Amiel','Tawnia McKiernan','Loren Yaconelli','Marcus Stokes','Lily Mariye','Catriona McKenzie','Karen Gaviola','Aisha Tyler','Rose Troche'],
actors:['Andrew Lincoln','Chandler Riggs','Norman Reedus','Melissa McBride','Lauren Cohan','Danai Gurira','Steven Yeun','Alanna Masterson','Sonequa Martin-Green','Josh McDermitt','Christian Serratos','Seth Gilliam','Ross Marquand','Lennie James','Emily Kinney','Michael Cudlitz','Scott Wilson','Austin Amelio','Sarah Wayne Callies','Laurie Holden','Tom Payne','Katelyn Nacon','Jeffrey Dean Morgan','Xander Berkeley','Chad L. Coleman','Austin Nichols','Steven Ogg','Jon Bernthal','David Morrissey','Irone Singleton','Lawrence Gilliard Jr.','Jeffrey DeMunn','Michael Rooker','Emma Bell','Brighton Sharbino','Lew Temple','Madison Lintz','Jose Pablo Cantillo','Dallas Roberts','Noah Emmerich','Michael L. Covington','Pruitt Taylor Vince','Phillip DeVona','Jeremy Ambler','Amanda Dyar','Michael Raymond-James','Jeryl Prescott','Andrew Rothenberg','Juan Gabriel Pareja','Dave R. Watkins','Noah Lomax','Troy Faruk','Jackey Hall','Theodus Crane','Vincent M. Ward','Nick Gomez','Alexa Nikolas','Melissa Ponzio','Kyle Gallner','Vincent Martella','Juliana Harkavy','Audrey Marie Anderson','Kirk Acevedo','Meyrick Murphy','Enver Gjokaj','Danny Vinson','Sunkrish Bala','Kerry Condon','Daniel Thomas May','Travis Love','Lindsay Abernathy','Markice Moore','Michael Zegen','Santiago Cirilo','Jeff Kober','Brina Palencia','Addy Miller','Neil Brown Jr.','Kyla Kenedy','Mike Mayhall','Marcus Hester','Keith Brooks','Keisha Castle-Hughes','Christine Woods','Teri Wyble','Victor McCay','Andrea Moore','Justin Evangelista','E. Roger Mitchell','Adam Minarovich','John Carroll Lynch','Davi Jay','J.D. Evermore','Merritt Wever','Benedict Samuel','Christopher Berry','Vanessa Cloke','Ethan Embry','Lance Tafelski','Labrandon Shead'],
basedOn:['Robert Kirkman','Tony Moore','Charlie Adlard'],
screenplay:['Frank Darabont','Scott M. Gimple','David Leslie Johnson-McGoldrick','Charles H. Eglee','Adam Fierro','Robert Kirkman','Evan T. Reilly','Seth Hoffman','Glen Mazzara','Heather Bellson','Eddie Guzelian','Frank Renzulli','Ryan C. Coleman','Angela Kang','Jim Barnes','Eli Jorne','Matthew Negrete','Sang Kyu Kim','Curtis Gwinn','Jack LoGiudice','Erik Mountain','Nicole Mirante-Matthews','Channing Powell','Geraldine Inoa','Vivian Tse','LaToya Morgan','Kevin Deiboldt','Nichole Beattie','Corey Reed','Julia Ruchman','Magali Lozano'],
production:['Ryan DeGard','Scott M. Gimple','Heather Bellson','Tom Luse','Angela Kang','Matthew Negrete','Denise M. Huth','Channing Powell','Vivian Tse','Kevin Deiboldt','Nichole Beattie','Sang Kyu Kim','Curtis Gwinn','Jolly Dale','Paul Gadd','Corey Reed','Caleb Womble'],
music:['Bear McCreary','Sam Ewing'],
camera:['David Boyd','Stephen Campbell','David Tattersall','Rohn Schmidt','Michael E. Satrazemis','Duane Charles Manwiller','Jalaludin Trautmann','Paul Varrieur','Scott Kevan'],
cut:['Julius Ramsay','Dan Liu','Hunter M. Via','Avi Youabian','Nathan Gunn','Rachel Goodlett Katz','Kelley Dixon','Evan Schrodek','Todd Desrosiers','Robert Bramwell','Alan Cody','Jack Colwell','Orlando Machado Jr.','Geofrey Hildrew','Sidney Wolinsky','Maria Gonzales','Enrique Sanchez','Brian G. Addie','Tiffany Melvin','Shari Mead'],
sound:['Dan Hiland','James Gallivan','Brian Armstrong','Walter Newman','Mike Marchain','Andy King','Gary D. Rogers','Sean Madsen','Jon Mete','David Raines','Kenneth Young'],
scenography:['Gregory S. Melton',"Graham 'Grace' Walker",'Jeff Schoen','Alex Hajdu','Lynne Mitchell','Kristen Donaldson','Gia Grosso','Lisa Alkofer','Marek Dobrowolski','Matthew C. Jacobs','Thomas William Hallbauer'],
masks:['Jennifer Denise Bennett','Scott H. Eddo','Jamie Kelman','Nikki Bell','Teresa Foshee','Taylor Knight','Howard Berger','Greg Nicotero','Christopher Allen Nelson','Amber Michael'],
costumes:['Eulyn Colette Hufkie','Elaine Montalvo','Peggy Stamper','Tere Duncan','Vera Chow']},
{title:'Little Britain',
titleCZ:'Malá Velká Británie',
year:2003,
runtime:'10h 13min',
episodeRuntime:'26-30min',
countries:['UK'],
genres:['Comedy'],
director:['Matt Lipsey','Steve Bendelack','Graham Linehan','Declan Lowney','Matt Lucas','Geoff Posner'],
actors:['Matt Lucas','David Walliams','Paul Putner','Anthony Head','Joann Condon','Ruth Jones','Imelda Staunton','Rob Brydon','Geraldine James','Sally Hawkins','Indira Varma','Alice Lowe','Nigel Havers','Mac McDonald','Christian Coulson','Amanda Root','Peter Serafinowicz','James Corden','Mark Gatiss','Iddo Goldberg','David Arnold','Lorraine Hilton','Julia Davis','Terence Maynard','Morwenna Banks','Ewen MacIntosh','Danny Sapani','Leslie McKeown','Siobhan Hayes','Georgie Glen','Peter Kay','Donald Pelmear','Dean Whatton','Di Botcher','Robert Rietty','Jason Barnett','James Greene','Kobna Holdbrook-Smith','Sally Bankes','Jamie Theakston','Menna Trussler','Pik Sen Lim','Imogen Bain','Derek Martin','Deddie Davies','Mollie Sugden','Barbara Keogh','Charu Bala Chokshi','Harmage Singh Kalirai','Joan Linder','Jeanne Mockford','Geoffrey Whitehead','Janette Legge','Howell Evans','Joseph Long','Mark Stobbart','Stirling Gallacher','Margaret Towner','Gordon Sterne','Sam Beazley','Helen Coker','Habib Nasib Nader','Tom Baker','Gwenllian Davies','David Soul','Philip Jackson','Claudia Harrison','Joanna Scanlan','Kevin Hudson','Cat Deeley','Caroline Quentin','Margaret John','Steve Coogan','Ronnie Corbett','Dawn French','Rolf Saxon','Robert Blythe','Mike Hayward','Madeleine Bowyer','Junix Inocian','Ruth Madoc','Sally Rogers','Vee Vimolmal','Antonia Whillans','Joanna Bacon','Ted Robbins'],
screenplay:['Kevin Cecil','Matt Lucas','David Walliams'],
production:['Myfanwy Moore','Geoff Posner'],
music:['David Arnold'],
camera:['Rob Kitzmann','John Sorapure','Francis De Groote'],
cut:['Mykola Pawluk'],
sound:['Bob Newton','Alex Thompson'],
scenography:['Dennis De Groot'],
masks:['Mark Coulier','Göran Lundström'],
costumes:['Annie Hardinge']},
{title:'The Good Place',
titleCZ:'Dobré místo',
year:2016,
runtime:'19h 46min',
episodeRuntime:'21-54min',
countries:['USA'],
genres:['Comedy','Drama','Fantasy'],
director:['Drew Goddard','Beth McCarthy-Miller','Michael McDonald','Payman Benz','Tucker Gates','Tristram Shapeero','Linda Mendoza','Lynn Shelton','Dean Holland','Michael Schur',"Trent O'Donnell",'Julie Anne Robinson','Alan Yang','Rebecca Asher','Claire Scanlon','Jude Weng','Morgan Sackett','Ken Whittingham','Anya Adams','Steve Day','Kristen Bell'],
actors:['Kristen Bell','Ted Danson','William Jackson Harper',"D'Arcy Carden",'Jameela Jamil','Manny Jacinto','Marc Evan Jackson','Tiya Sircar','Ruman Kazi','Amy Okuda','Emily Arlook','Jackie Tohn','Susan Park','Jorge Diaz','Braxton Beckham','Leslie Grossman','Luke Guldan','A.J. Hudson','Jill Johnson','Deborah Meister','Angela Trimbur','Jamie Denbo','Jama Williamson','George Basil','Mary Holland','Adam Scott','Maribeth Monroe','Ajay Mehta','Anna Khaja','Tom Beyer','John Hartmann','Eugene Cordero','Keston John','Joe Mande','Hayden Szeto','Jess Rowland','Joanna Sotomura','Doc Farrow','Rebecca Hazlewood','Sunita Mani','Jason Mantzoukas','Dax Shepard','Jim Meskimen','Dominic Burgess','Maya Rudolph','Behzad Dabu','Adam Huber','Prudence Vindin','Lynnette Gaza',"Mike O'Malley",'Kirby Howell-Baptiste','Harvey Guillén','Moshe Kasher','Lisandra Tena','Ben Lawson','Adam Groves','Ben Geurens','Paul Tassone','Flula Borg','Andy Daly','Allyn Rachel','Michael McKean','Stephen Merchant','Carol Herman','Sarah Yarkin','Nicole Byer','Paul Scheer','Dana Powell','Brandon Scott Jones','Phil Augusta Jackson','Seth Morris','Tatiana Carr','Denise G. Sanchez','Marques Ray','Peter Katona','Nicolas Cantu','Benjamin Koldyke','Brad Morris','Rachel Winfree','Antoniette Iesue','Patrick Cox','Noel Arthur','Oliver Muirhead','Kate Berlant','Che Tafari','Timothy Olyphant','Robert Paul Taylor','Lisa Kudrow','Gary Richardson','Nick Offerman','Mary Steenburgen','Meryl Hathaway','Nathan Lovejoy','Max Silvestri','Sonya Leslie','Michael Hagiwara','Jayne Entwistle','Whitmer Thomas','Dallas Dupree Young','Keelia Clarkson'],
screenplay:['Michael Schur','Alan Yang','Joe Mande','Tyler Straessle','Kassia Miller','Megan Amram','Matt Murray','Christopher Encell','Jen Statsky','Andrew Law','Cord Jefferson','Dave King','Kate Gersten'],
production:['Joe Mande','Megan Amram','David Hyman'],
music:['David Schwartz'],
camera:['Barry Peterson','David J. Miller'],
cut:['Eric Kissack','Colin Patton','Matthew Freund','Matthew Barbato'],
sound:['Paul Tade','Andy King','Robert Carr','John W. Cook II','William Freesh','Robert Edmondson','Albert Romero'],
scenography:['Dan Bishop','Ian Phillips','David Smith','Adam Rowe'],
masks:['Renee Caruso-Napolitano','Cyndilee Rice','Michele Tyminski Schoenbach','Aubrey Marie'],
costumes:['Kirston Leigh Mann']},
{title:'Randall and Hopkirk (Deceased)',
titleCZ:'Randall a Hopkirk',
year:1969,
runtime:'21h 41min',
episodeRuntime:'50-51min',
countries:['UK'],
genres:['Action','Comedy','Crime','Drama','Fantasy','Mystery'],
director:['Jeremy Summers','Ray Austin','Cyril Frankel','Leslie Norman','Roy Ward Baker','Paul Dickson','Robert Tronson'],
actors:['Mike Pratt','Kenneth Cope','Annette Andre','Carol Cleveland','Peter Cellier','Michael Ripper','Brian Blessed','Walter Sparrow','Olga Lowe','Michael Gothard','Howard Goorney','Veronica Carlson','Peter Jones','Michael Coles','Robin Hawdon','Kieron Moore','Valerie Leon','Jane Merrow','Timothy West','Madge Ryan','Caroline Blakiston','Patrick Jordan','Patrick Connor','Michael Goodliffe','Stanley Meadows','Liz Fraser','Joby Blanshard','Alan Gifford','Felix Aylmer','Terence Plummer','Chris Gannon','Max Faulkner','Bessie Love','Alfred Burke','Patrick Barr','Frank Windsor','Norman Eshley','John Fraser','Ronald Radd','John Hallam','Bernard Kay','James Culliford','Sue Lloyd','Mary Merrall','Danny Green','Nicholas Courtney','John Boxer','Marne Maitland','Patrick Holt','Victor Harrington','John Rae','Noel Davis','Arnold Diamond','Michael Gwynn','Harry Locke','Ronald Lacey','Anthony Sagar','Harold Innocent','Tom Chatto','Harry Fielder','Doris Hare','Norman Bird','Raymond Young','Cyril Renison','Betty Woolfe','Lois Maxwell','Marjorie Rhodes','Freddie Jones','Eric Dodson','George Lee','William Squire','Drewe Henley','Victor Maddern','Anthony Baird','Michael Bird','Billy Cornelius','Garfield Morgan','Jeremy Young','Tony Steedman','David Lodge','Tenniel Evans','Leslie Schofield','Alex Scott','Gary Watson','Freda Jackson','Michael Radford','Meredith Edwards','Graham Armitage','Denise Buckley','Edward Brayshaw','Gwen Nelson','Alexandra Bastedo','Ivor Dean','Charles Lloyd Pack','Richard Caldicot','Arthur Brough','Harold Berens','David Jason','John Cazabon','Robin Askwith'],
screenplay:['Ralph Smart','Ray Austin','Mike Pratt'],
production:['Monty Berman'],
music:['Edwin Astley'],
camera:['Gilbert Taylor','Frank Watts'],
cut:['John Ireland','Tom Simpson','Lee Doig'],
sound:['Bill Rowe']},
{title:'Angels in America',
titleCZ:'Andělé v Americe',
year:2003,
runtime:null,
episodeRuntime:'6h53-73min',
countries:['USA'],
genres:['Drama','Fantasy'],
director:['Mike Nichols'],
actors:['Al Pacino','Meryl Streep','Emma Thompson','Mary-Louise Parker','Jeffrey Wright','Ben Shenkman','Patrick Wilson','James Cromwell','David Zayas','Michael Gambon','Simon Callow','Justin Kirk','Robin Weigert','Brian Markinson','Tony Kushner','Anna Orso','Maurice Sendak','Paul Wilson'],
screenplay:['Tony Kushner','Tony Kushner'],
production:['Celia D. Costas'],
music:['Thomas Newman'],
camera:['Stephen Goldblatt'],
cut:['John Bloom'],
sound:['Lee Dichter','Ron Bochar'],
scenography:['Stuart Wurtzel','George DeTitta Jr.'],
masks:['John Caglione','Jr.','Alessandro Durante'],
costumes:['Ann Roth']},
{title:'Orphan Black',
titleCZ:'Orphan Black',
year:2013,
runtime:'36h 39min',
episodeRuntime:'43-46min',
countries:['Canada'],
genres:['Action','Drama','Sci-Fi'],
director:['John Fawcett','David Frazee','T.J. Scott','Ken Girotti','Brett Sullivan','Helen Shaver','Grant Harvey','Chris Grismer','David Wellington','Aaron Morton','Vincenzo Natali','Peter Stebbings'],
actors:['Tatiana Maslany','Jordan Gavaris','Maria Doyle Kennedy','Kevin Hanchard','Kristian Bruun','Skyler Wexler','Evelyne Brochu','Dylan Bruce','Ari Millen','James Frain','Zoé De Grand Maison','Rosemary Dunsmore','Cynthia Galant','Tom McCamus','Natalie Lisinska','Alex Ozerov','Amanda Brugel','Ksenia Solo','Alison Steadman','Jenessa Grant','Stephen McHattie','Elyse Levesque','Michael Mando','Inga Cadranel','Matt Frewer','Michiel Huisman','Kathryn Alexandre','Danielle Bourgon','Jack Fulton','Andrew Gillies','Reid Janisse','Marty Adams','Raven Dauda','Carlos Diaz','Miranda Edwards','Courtney Deelen','Matthew Bennett','Allen Keng','Sarain Boylan','Dylan Trowbridge','Nora McLellan','Lamont James','Serje Basi','Alex Karzis','Jean Yoon','Kevin Dennis','Glenda Braganza','Illarion Michaels','Ron Lea','Daniel Kash','David Richmond-Peck','Miriam McDonald','Eric Johnson','Kristi Angus','Melanie Nicholls-King','Peter Outerbridge','Kristin Booth','Julian Richings','Zachary Bennett','Roger Cross','Peter Michael Dillon','Patrick J. Adams','Michelle Forbes','Bishop Brigante','Kyra Harper','Earl Pastko','Trenna Keating','Natalie Krill','Carlos Gonzalez-Vio','Nicholas Campbell','Justin Chatwin','David Fox','Sheila McCarthy','Michelle Arvizu','Nigel Bennett','Daniel Fathers','Brittany Drisdelle','Ian Matthews','Allie MacDonald','Gord Rand','Jade Hassouné','Joel Thomas Hynes','Mark Quigley','Siobhan Murphy','Casey Hudecki','Janet Pinnick','Peaches','Brooke Palsson','Scott Wentworth','Noah Dalton Danby','Géza Kovács','Frank Moore','Andrea Runge','Sadie Munroe','Stuart Hughes','Vas Saranga','Jayne Eastwood','Pip Dwyer','Tom Cullen','Deborah Grover'],
screenplay:['John Fawcett','Graeme Manson','Aubrey Nealon','Karen Walton','Tony Elliott','Adam Higgs','Will Pascoe','Sherry White','Kate Melville','Peter Mohan','Jeremy Boxen','Russ Cochrane','Renée St. Cyr','Gregory Nelson','Chris Roberts','Aisha Porter-Christie','Nikolijne Troubetzkoy'],
production:['Claire Welland'],
music:['Trevor Yuile'],
camera:['Aaron Morton','Michael Marshall','David Frazee'],
cut:['Brett Sullivan','D. Gillian Truster','Stephen Lawrence','Stephen Philipson','Reg Harkema','Matthew Anas','Jay Prychidny','Stephen Roque'],
sound:['Stephen Traub','Shaun Gratto'],
scenography:['John Dondertman','Ian Brock','Michaela Cheyne','Elizabeth Calderhead','Andy Loew'],
masks:['Antoinette Julien','Paul Jones','Alexandra Anger'],
costumes:['Laurie Drew','Debra Hanson']},
{title:'Kidding',
titleCZ:'K smíchu',
year:2018,
runtime:'8h 50min',
episodeRuntime:'22-32min',
countries:['USA'],
genres:['Drama','Comedy'],
director:['Michel Gondry','Jake Schreier','Minkie Spiro','Kimberly Peirce','Bert'],
actors:['Jim Carrey','Catherine Keener','Frank Langella','Judy Greer','Justin Kirk','Cole Allen','Juliet Morris','Juliocesar Chavez','Ginger Gonzaga','Kelly Coffield Park','Bernard White','Danny Trejo',"Conan O'Brien",'Jennifer Sun Bell','Riki Lindhome','Orson Chaplin','Omar Maskati','Lacey Hannan','Daniel Moncada','Keith L. Williams','Tara Lipinski','Joel Swetow','Katherine Willis','Tice Proctor','Louis Ozawa','Dorien Davies','Alex Raul Barrios','Zackary Arthur','Jayden Bartels','Karen Malina White','Dan Martin','Grace Su','Evan Alex','Dorian Martin','Austin Zajur','René Mena','Ariana Grande','Taka Arai','Dick Van Dyke','Rich Fulcher','Julitta Scheel','Marcelo Tubert','Myra Turley','Coda Boesel','Michael Yama','Megan Kathleen Duffy','Ryan Wicks','Frank Bond','Christine Papalexis','Annie Korzen','Juliette Jeffers','Ashleigh Morghan','Eric Roberts','Andy Milder','Marie Osmond','Sharon Osbourne','Shahaub Roudbari','Elayn J. Taylor','Reginald C. Hayes','Louis Lombardi','Dave Holstein','Gregory B. Waldis','Stacy Keach','GlennThomas Cruz','Scott Cargle','Sala Baker','Mig Macario',"Annette O'Toole",'Michael Fairman','Cheryl Lynn Bowers','Mariana Paola Vicente','Carl W. Crudup','Rachel Boston','Shane Francis Smith','Joyce Guy',"T'Keyah Crystal Keymáh",'Terrence Beasor','Reyn Doi','Tyler the Creator','Barry Rothbart','Keli Daniels','Greg Ballora','Kristin Charney','Cadence Murray','Christon Blue','Bruce M. Stockert','Carie Kawa','Bunny Gibson','Kiren','Frederick Dawson','Matt Perfetuo','Mike Perfetuo','Karen Bankhead','Reese Gonzales','Jenna Z','Tamika Simpkins','Terrell J. Ramsey','Gregory Sims','Anna Benuzzi','Kelli Kirkland'],
screenplay:['Dave Holstein','Halley Feiffer','Roberto Benabib','Joey Mazzarino','Mike Vukadinovich','Cody Heller','Hilary Weisman Graham'],
production:['Halley Feiffer','Mike Vukadinovich','Joey Mazzarino','Andrea P. Stilgenbauer','Hilary Weisman Graham'],
music:['David Wingo'],
camera:['Shawn Kim','Shasta Spahn'],
cut:['Ivan Victor','Kyle Reiter','Tony Orcena','Tyler L. Cook','Adam Burr','Jennifer Van Goethem','Franky Guttman','Rylan Rafferty'],
sound:['Andy King','Keith Rogers','Susan Cahill'],
scenography:['Maxwell Orgell'],
masks:['Kymber Blake','Tony Gardner','Anne Morgan','Rheanne Garcia'],
costumes:['Rahel Afiley']},
{title:'The Americans',
titleCZ:'Takoví normální Američané',
year:2013,
runtime:'57h 17min',
episodeRuntime:'40-64min',
countries:['USA'],
genres:['Crime','Drama','Mystery','Thriller','Action'],
director:["Gavin O'Connor",'Nicole Kassell','Stefan Schwartz','Bill Johnson','Lodge Kerrigan','Charlotte Sieling','Constantine Makris','Adam Arkin','Thomas Schlamme','Jean de Segonzac','Holly Dale','Daniel Sackheim','Alex Chapple','Jim McKay','John Dahl','Daniel Attias','Kevin Dowling','Alik Sakharov','Gregory Hoblit','Andrew Bernstein','Noah Emmerich','Stephen Williams','Larysa Kondracki','Christopher Misiano','Chris Long','Kari Skogland','Matthew Rhys','Steph Green','Gwyneth Horder-Payton','Roxann Dawson','Kevin Bray','Sylvain White'],
actors:['Keri Russell','Matthew Rhys','Holly Taylor','Keidrich Sellati','Annet Mahendru','Noah Emmerich','Richard Thomas','Susan Misner','Alison Wright','Lev Gorn','Margo Martindale','Danny Flaherty','Michael Aronov','Frank Langella','Maximiliano Hernández','Lee Tergesen','Cotter Smith','John Carroll Lynch','Rahul Khanna','Wrenn Schmidt','Julia Garner','Reg Rogers','Aimee Carrero','Gillian Alexy','Jefferson Mays','Polly Lee','Derek Luke','Katja Herbers','Tonye Patano','Olek Krupa','Betsy Aidem','Paul Fitzgerald','Natalie Gold','Victor Slezak','Erik Jensen','Richard Kline','Cliff Simon','Scott William Winters','Callie Thorne','Frank Deal','Marmee Cosico','David Vadim','Michael Gaston','Audrey Esparza','Michael Countryman','Marina Squerciati','Geoffrey Cantor','Jeremy Davidson','John Dossett','Chris Sullivan','Kathleen Chalfant','Željko Ivanek','Shuler Hensley','John Bedford Lloyd','George Georgiou','Robert Bogue','Paul Jude Letersky','Michael Oberholtzer','Caitlin Norton','Brian J. Carter','Laura Poe','John Rue','Olivia Nikkanen','Mauricio Ovalle','Marko Caka','Doris McCarthy','Tom Riis Farrell','Lois Smith','Mihran Slougian','Neil Sandilands','Peggy J. Scott','David H. Holmes','Mahadeo Shivraj','Kelly AuCoin','Jeremy Holm','Remy Auberjonois','Bill Heck','Ilia Volok','Chase Coleman','Karen Pittman','Skylar Gaertner','Elizabeth Masucci','Mark Doherty','Daniel London','Dana Eskelson','Gary Galone','David Chen','Mark Zeisler','Ronald Reagan','Michael Bakkensen','Laura Heisler','Dylan Baker','Lars Gerhard','David Copperfield','John Cullum','Jason Robards','William Allen Young','Peter Jacobson','Marceline Hugot','Alex Ozerov'],
screenplay:['Melissa James Gibson','Mike Batistick','Angelina Burnett','Stuart Zicherman','Stephen Schiff','Peter Ackerman','Joseph Weisberg','Joshua Brand','Tanya Barfield','Joel Fields','Sneha Koorse','Tracey Scott Wilson','Sarah Nolen'],
production:['Mitch Engel','Kendall McCarthy','David Woods','Tyson Bidner'],
music:['Nathan Barr'],
camera:['Alan Caso','Radium Cheung','Alex Nepomniaschy','Dan Stoloff','Richard Rutkowski','J.B. Smith'],
cut:['Alan Cody','Michael Berenbaum','Katie Ennis','Marnee Meyer','Daniel A. Valverde','Sheri Bylander','Amanda Pollack'],
sound:['Adam Rooner','Lisle Engle','Sherry Klein','Albert Ibbotson','Greg Sextro',"T.J. O'Mara",'Kim Maitland'],
scenography:['Dan Leigh','John Mott','Diane Lederman','Dan Davis','Ron von Blomberg','Mila Khalevich','Christopher Minard','Tim Goodmanson','Andrew Baseman'],
costumes:['Jenny Gering','Abigail Murray','Katie Irish']},
{title:'Cranford',
titleCZ:'Cranford',
year:2007,
runtime:'7h 59min',
episodeRuntime:'60-90min',
countries:['UK'],
genres:['Drama'],
director:['Simon Curtis','Steve Hudson'],
actors:['Judi Dench','Julia McKenzie','Imelda Staunton','Lisa Dillon','Deborah Findlay','Barbara Flynn','Alex Etel','Alex Jennings','Jim Carter','Emma Fielding','Adrian Scarborough','Andrew Buchan','Claudie Blakley','Kimberley Nixon','John Bowe','Philip Glenister','Francesca Annis','Greg Wise','Eileen Atkins','Simon Woods','Michael Gambon','Alistair Petrie','Lesley Manville','Andrew Byrne','Julia Sawalha','Joe McFadden','Martin Shaw','Tom Hiddleston','Matthew Rohman','Peter Brown','Emma Lowndes','Jessie Cave','Finty Williams','Nicholas Le Prevost','Roddy Maude-Roxby','Bessie Carter','Jodie Whittaker','Lesley Sharp','Matthew McNulty','Jonathan Pryce','Michelle Dockery','Rory Kinnear','Celia Imrie','Tim Curry','Dean Lennox Kelly','Selina Griffiths','Nicholas Bishop'],
basedOn:['Elizabeth Gaskell'],
screenplay:['Heidi Thomas'],
music:['Carl Davis'],
camera:['Ben Smithard'],
cut:['Dan Roberts','Frances Parker'],
scenography:['Donal Woods'],
masks:['Talli Pachter','Marc Pilcher','Barrie Gower'],
costumes:['Jenny Beavan']},
{title:'Cracker',
titleCZ:'Bedna',
year:1993,
runtime:'20h 50min',
episodeRuntime:'48-100min',
countries:['UK'],
genres:['Crime','Drama','Mystery'],
director:['Jean Stewart','Richard Standeven','Andy Wilson','Charles McDougall','Michael Winterbottom','Tim Fywell','Simon Cellan Jones','Julian Jarrold','Tucker Gates','Michael Fields','Whitney Ransick','Roy Battersby'],
actors:['Robbie Coltrane','Barbara Flynn','Geraldine Somerville','Lorcan Cranitch','Christopher Eccleston','Kika Markham',"Kieran O'Brien",'Robert Cavanah','Isobel Middleton','Wil Johnson','Barnaby Kay','Samantha Morton','Adewale Akinnuoye-Agbaje','Robert Carlyle','Marianne Jean-Baptiste','Ashley Crow','Al Sapienza','Jillian Armenante','Rene Liu','Kellie Waymire','David Bradley','Beth Goddard','Adrian Dunbar','Dennis Chan','Christopher Fulford',"Aisling O'Sullivan",'Benedict Wong','Nicholas Woodeson','Tim Barlow','Beryl Reid','Steve Rankin','Ricky Tomlinson','Paul Barber','David Haig','Jared Rushton','Amelia Bullmore','Andrew Knott','Jim Carter',"Seamus O'Neill",'Roger Sloman','Kathryn Hunt','Kenneth Gilbert','Alan Partington','Tony Rohr','Katherine Dow Blyton','Paul Copley','Markus Flanagan','Nicholas Blane','Frances Tomelty','Glen Goei','Freda Foh Shen','David Holt','Don Henderson','Pik Sen Lim','Badi Uzzaman','Darren Tighe','Ian Mercer',"Maurren O'Brien",'Owen Brenman','Annette Ekblom','Sandra Gough','Sunetra Sarker','Ellie Haddington','Marian McLoughlin','Fiona Allen','David Calder','Johnny Leeze','Will Knightley','Elizabeth Estensen','Samia Longchambon','Rosemary Martin','Tom Wu','Geoffrey Hutchings','John Grillo','David Crellin','Biddy Hodson','Jeffrey Robert','Jim Whelan','Jeffrey Longmore','Alan Maher','Aeryk Egan','Peter Faulkner','Kathy Jamieson','Susan Lynch','Andrew Tiernan','Susan Vidler','Linda Henry','Trevyn McDowell','Mike Kelly','John Henshaw','James Fleet','Emma Cunniffe','Ian Curtis','Josh Cruze','Peter Clifford','Sharon Percy','John Vine','Kim Vithana','Emily Joyce','Kay Purcell'],
screenplay:['Paul Abbott','Jimmy McGovern'],
production:['Hilary Bevan Jones'],
music:['Rick Wentworth'],
camera:['Ivan Strasburg','Dick Dodd'],
cut:['Tony Cranstoun','Chris Gill','Trevor Waite','Oral Norrie Ottey','Edward Mansell'],
scenography:['Claire Kenny','Nick Wilkinson','Chris Wilkinson'],
costumes:['Janty Yates','Tudor George']},
{title:'Horrible Histories',
titleCZ:'Děsivé dějiny',
year:2001,
runtime:null,
episodeRuntime:'26x29min',
countries:['UK'],
genres:['Animation','Family'],
director:['Andrew Young'],
actors:['Jess Harnell','Billy West','Stephen Rea','Billy Idol','Katy Wix','David Baddiel','Cree Summer'],
basedOn:['Terry Deary'],
screenplay:['Tamar Simon Hoffs','Libby Hinson','Gabriel Lewis','Michael Maler','David Nadelberg','William Forrest Cluverius'],
production:['Martha Atwater'],
music:['Dean Valentine'],
cut:['Michael Bradley'],
scenography:['Polly Aspinall'],
masks:['Siân Miller']},
{title:'Sharp Objects',
titleCZ:'Ostré předměty',
year:2018,
runtime:'7h 51min',
episodeRuntime:'53-62min',
countries:['USA'],
genres:['Drama','Thriller'],
director:['Jean-Marc Vallée'],
actors:['Amy Adams','Eliza Scanlen','Chris Messina','Patricia Clarkson','April Brinson','Violet Brinson','Taylor John Smith','Will Chase','Jackson Hurst','Catherine Carlen','Madison Davenport','Elizabeth Perkins','Jean Villepique','Dylan Schombing','Emily Yancy','Jessica Treska','Matt Craven','Betsy Baker','Rolando Boyce','Henry Czerny','Barbara Eve Harris','Sophia Lillis','Randy Oglesby','Celeste Pechous','Miguel Sandoval','Cody Sullivan','David Sullivan','D.B. Sweeney','Sydney Sweeney','Lulu Wilson','Jennifer Aspen','Reagan Pasternak','Justin Welborn','Guy Boyd','Hilary Ward','Kennedy Tucker','Beth Broderick','Sameerah Luqmaan-Harris','Annie Fitzgerald','Cristine Rose','Ravi Kapoor','Sam Littlefield','Stacie Greenwell','Jennifer Lamar','Iyana Halley','Shane Donovan Lewis','Adam Cronan','Kevyn Bashore','Harvey B. Jackson','Michelle Arthur','Micaela Wittman','Lindsay Ayliffe','Tom Simmons','Cristina Spruell','Michael Andrew Baker','Cole Doman','Aaron Holliday','Jake Holley','Joy Jacobson'],
basedOn:['Gillian Flynn'],
screenplay:['Marti Noxon','Scott Brown','Gillian Flynn','Alex Metcalf','Ariella Blejer','Dawn Kamoche','Vince Calandra'],
production:['Scott Brown','David Auge'],
camera:['Yves Bélanger','Ronald Plante'],
cut:['Jean-Marc Vallée','Émile Vallée','Dominique Champagne','Justin Lachance','David Berman'],
sound:['Paul Lucien Col'],
scenography:['John Paino','Amy Wells'],
masks:['Kimberly Carlson','Dawn Victoria Dudley','Patricia Dehaney','Adrien Morot','Ayat Malek Kiankhooy','Kate Biscoe','Stacey K. Black','Claudia Humburg'],
costumes:['Alix Friedberg']},
{title:'Robin of Sherwood',
titleCZ:'Robin Hood',
year:1984,
runtime:'22h 8min',
episodeRuntime:'50-102min',
countries:['UK'],
genres:['Action','Fantasy','Adventure'],
director:['Robert Young','Alex Kirby','Ian Sharp','James Allen','Dennis Abey','Christopher King','Gerry Mill','Ben Bolt'],
actors:['Michael Praed','Jason Connery','Mark Ryan','Clive Mantle','Robert Addie','Ray Winstone','Philip Jackson',"Richard O'Brien",'Phil Davis','Anthony Steel','Nick Brimble','Marcus Gilbert','Cathryn Harrison','Gaby Dellal','Peter Llewellyn Williams','Judi Trott','Phil Rose','Patricia Hodge','Simon Shepherd','Paul Geoffrey','Hywel Bennett','Nickolas Grace','Graham Chinn','John Harding','John Nettles','Geoffrey Greenhill','Ingrid Hafner','Nicholas Pritchard','Harry Jones','Glen Murphy','Anthony Valentine','Wayne Michaels',"Derrick O'Connor",'Dorothy Tutin','Michael Craig','Max Faulkner','Oliver Cotton','Rula Lenska','Rachel Fielding','Valentine Pelka','Gemma Craven','Angharad Rees','Duncan Preston','Gary Waldhorn','Larry Dann','Victor McGuire','Conrad Phillips','Robert Daws','Bill Wallis','David de Keyser','Norman Bowler','Brian Coburn','Katharine Levy','Pavel Douglas','Colin Rix','John Horsley','Yves Beneyton','John Rhys-Davies','William Russell','Simon Dutton','George Baker','Jeremy Bulloch','Oliver Tobias','Michael Praed','Keith Bartlett','Cyril Cusack','Jeremy Sinden','Lewis Collins','Martin Shaw','Graham Weston','Matt Frewer','Bryan Marshall','Reece Dinsdale','Stephen MacKenna','Ian Ogilvy','Caroline Holdaway','David Rappaport','Brendan Price','Robbie Bulloch','David Bartlett','Maureen Bennett','David Plimmer'],
screenplay:['Anthony Horowitz','Richard Carpenter','Holly Phillips'],
production:['Paul Knight'],
music:['Clannad'],
scenography:['John Biggs','Kate Barnett','Kenneth Sharp'],
costumes:['Lynnette Cummin']},
{title:'Elfen Lied',
titleCZ:'Elfen Lied',
year:2004,
runtime:'5h 25min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Action','Drama','Horror','Psychology','Romance','Sci-Fi'],
director:['Mamoru Kanbe','Akira Iwanaga','Kóbun Šizuno','Keisuke Óniši','Takejuki Sadohara'],
actors:['Mamiko Noto','Juki Macuoka','Lynn Okamoto','Hitomi Nabatame','Hiroaki Hirata','Mikako Takahaši','Júki Tai','Džódži Nakata','Sanae Kobajaši','Hadžime Iidžima','Ken Takeuči','Čihiro Suzuki','Noriko Šitaja','Tomoko Kawakami',"Asuka Tani'i",'Naoki Kinošita','Masakazu Kohara','Osamu Hosoi','Emiko Hagiwara','Kinrjú Arimoto','Reiko Takagi','Maria Jamamoto','Hideo Watanabe','Kazuma Horie','Akemi Kanda','Keidžin Okuda','Daisuke Ono','Fumiko Ósaka','Kimitake Kakegawa','Eriko Išihara'],
basedOn:['Lynn Okamoto'],
screenplay:['Takao Jošioka'],
production:['Osamu Košinaka','Kasuaki Moridžiri'],
music:['Kajo Koniši','Jukio Kondó'],
camera:['Hisao Širai'],
cut:['Takeši Sejama'],
sound:['Kacunori Šimizu'],
scenography:['Akira Itou']},
{title:'Star Wars: Tales of the Jedi',
titleCZ:'Star Wars: Příběhy rytířů Jedi',
year:2022,
runtime:'1h 39min',
episodeRuntime:'13-19min',
countries:['USA'],
genres:['Animation','Adventure','Action','Sci-Fi'],
director:['Nathaniel Villanueva','Saul Ruiz','Charles Murray'],
actors:['Ashley Eckstein','Toks Olagundoye','Janina Gavankar','Corey Burton','Micheál Richardson','Mark Rolston','Josh Keaton','Vanessa Marshall','Brian George',"Terrence 'T.C.' Carson",'Terrell Tilford','Theo Rossi','Ian McDiarmid','Liam Neeson','Bryce Dallas Howard','Matt Lanter','Dee Bradley Baker','James Arnold Taylor','Phil LaMarr','Clancy Brown','David Shaughnessy','Bryton James','Dana Davis','Noshir Dalal','Andrew Kishino','Sunil Malhotra'],
screenplay:['Dave Filoni','Charles Murray','Élan Murray'],
music:['Kevin Kiner']},
{title:'Fairy Tail',
titleCZ:'Fairy Tail',
year:2009,
runtime:'131h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Fantasy','Comedy'],
director:['Šindži Išihira','Hazuki Mizumoto','Akira Kató','Hiroši Tamada','Kazunobu Šimizu','Mamoru Enomoto','Jasuo Iwamoto','Júsuke Onoda','Jošihisa Macumoto','Jasuši Muroja','Daisuke Cukuši','Kazunobu Fuseki','Hitomi Ezoe','Ajaka Cudžihaši','Micuto Jamadži','Hirokazu Jamada','Takahiro Madžima','Šigeru Jamazaki','Noriaki Saitó','Šigetaka Ikeda','Satoši Šimizu','Naoto Hašimoto','Masato Sató','Jošitaka Makino','Jasunaga Cudži','Toshihiko Masuda','Mašu Itó'],
actors:['Tecuja Kakihara','MAKO','Aja Hirano','Daisuke Namikawa','Mamiko Noto','Mijuki Sawaširo','Rie Kugimija','Jui Horie','Ajako Kawasumi',"Džun'iči Suwabe","Ken'iči Suzumura",'Kendžiró Cuda','Norio Wakamoto','Rie Murakawa','Tomokazu Seki','Eidži Sekiguči','Eri Kitamura','Jukana','Júiči Nakamura','Šinpači Cudži','Masahito Jabe','Jú Kobajaši','Saori Gotó','Satomi Sató','Sajaka Óhara','Juka Iguči','Hiro Šimono','Miki Narahaši','Satomi Kórogi','Wataru Hatano','Cubasa Jonaga','Hidekacu Šibata','Megumi Nakadžima','Jukijo Fudžii','Anri Kacu','Takaja Kuroda','Hiroki Jasumoto','Nacue Sasamoto','Rjóko Ono','Šóko Cuda','Šóta Jamamoto','Júiči Iguči','Šó Hajami','Kazuhiko Inoue','Bandžó Ginga','Tecu Inada','Kacujuki Koniši','Daisuke Kišio','Marija Ise','Ako Majama','Masaši Hirose','Jošimicu Šimojama','Fujuka Ono','Satomi Arai','Šiori Izawa','Naomi Šindó','Harumi Sakurai','Mai Nakahara','Eidži Mijašita','Kanami Sató','Kazuja Ičidžó','Hiroki Tóči','Saori Seto','Kazuja Tatekabe','Širó Saitó','Kaori Nazuka','Júja Učida','Saori Hajami','Masaja Macukaze','Takaši Kondó','Jošihisa Kawahara','Kikuko Inoue','Takaši Macujama','Tecu Širatori','Kóiči Tóčika','Džundži Madžima','Kazuma Horie','Masaharu Sató','Seiró Ogino','Acuši Imaruoka','Sajaka Narita','Rjóko Tanaka','Šúhei Sakaguči','Masafumi Kimura','Hiroki Gotó','Ikumi Hajama','Masami Kikuči','Rjúzaburó Ótomo','Ringo Aoba','Rikija Kojama','Kóhei Amasaki','Taiši Murata','Acuši Tamaru','Kaede Juasa','Aiko Ninomija','Júki Sanpei','Eimi Okada','Rjóko Maekawa','Takaaki Torašima','Makoto Tamura'],
basedOn:['Hiro Mašima'],
screenplay:['Šódži Jonemura','Acuhiro Tomioka','Fumihiko Šimo','Masaši Sogo'],
production:['Jošikazu Benija','Tomonori Očikoši','Jósuke Imai','Taihei Jamaniši','Aja Jošino'],
music:['Jasuharu Takanaši'],
camera:['Acuši Iwasaki','Satoru Kuroiwa'],
cut:['Júdži Oka','Tošio Henmi'],
sound:['Šódži Hata'],
scenography:['Masaaki Kawaguchi','Džunko Šimizu','Tomomi Sugimoto','Šigeru Morimoto']},
{title:'The Dropout',
titleCZ:'Kauza Theranos',
year:2022,
runtime:'6h 52min',
episodeRuntime:'46-55min',
countries:['USA'],
genres:['Drama','Biographic'],
director:['Michael Showalter','Francesca Gregorini','Erica Watson'],
actors:['Amanda Seyfried','Naveen Andrews','Utkarsh Ambudkar','Anne Archer','Kate Burton','Stephen Fry','Michel Gill','Michael Ironside','Bill Irwin','William H. Macy','Elizabeth Marvel','Laurie Metcalf','Kurtwood Smith','Sam Waterston','Shaun Brown','Josh Pais','Nicky Endres','Garrett Coffey','Dylan Minnette','Angel Parker','Peter James Smith','Michaela Watkins','LisaGay Hamilton','Sarah Haruko','Ebon Moss-Bachrach','Damon K. Sperber','Sam Straley','Kevin Sussman','Yossie Mulyadi','Jake Satow','James Hiroyuki Liao','Rich Sommer','Andrew Leeds','Alan Ruck','Camryn Mi-young Kim','Paris Peterson','Gabriel Oliva','Katie Page','Meredith VanCuyk','Zhaleh Vossough'],
screenplay:['Elizabeth Meriwether','Matt Lutsky','Liz Hannah','Dan LeFranc','Wei-Ning Yu'],
production:['Amanda Seyfried','Megan Mascena Gaspar'],
music:['Anne Nikitin'],
camera:['Michelle Lawler','Jonathan Furmanski','Blake McClure'],
cut:['David Berman','Susana Benaim'],
sound:['Albert Romero','Pete Elia','Kimberly Ellen Lowe'],
scenography:['Jacqueline Kay','Kimberly Leonard','Catherine Smith'],
masks:['Rheanne Garcia','Vanessa Price'],
costumes:['Claire Parkinson']},
{title:'Lovesick',
titleCZ:'Lovesick',
year:2014,
runtime:'9h 30min',
episodeRuntime:'23-28min',
countries:['UK'],
genres:['Comedy'],
director:['Elliot Hegarty','Aneil Karia','Gordon Anderson'],
actors:['Johnny Flynn','Antonia Thomas','Nikki Amuka-Bird','Riann Steele','Sharon Young','Cara Theobold','Jessica Ellerby','Turlough Convery','Rosalie Craig','Joshua McGuire','Jamie Demetriou','Bruce Mackinnon','Clare Wille','Duncan Pow','Robert Lonsdale','Hannah Britland','Daniel Ings','Tony Gardner','Vicki Pepperdine','Aimee Parkes','Daisy Beaumont','Kim Allan','Scott Gilmour','Dafydd Llyr-Thomas','Richard Thomson','James Martin','Alisa Anderson','Gayle Telfer Stevens','Oliver Coopersmith','Tom Stourton','Natalie Burt','Tom Duncan','Stephen Wight','Isabelle Joss','Mike Wozniak','Grant Thomson','Molly Innes','Neil Thomas','Robyn Milne','Tala Gouveia',"Kevin O'Loughlin",'Kerry Lynn Hamilton','Sharon MacKenzie','Susannah Fielding','Chris Donald','Antonia Clarke','Nomaan Khaan','Katrine De Candole','Laura Aikman','Jordan Coulson','Bekka Bowling','Jade Ogugua','George Docherty','Rob Crouch','Morag Calder','Seylan Baxter','Simon Tait','Paul Chaal','Moon Saker','Finlay McLean','David Westhead','Jenny Bede','Gabby Best','Charlie Leech','Cassie Layton','Sara Vickers','Yasmine Akram','Deborah Findlay','Karl Johnson','Sam Lathem','Klariza Clayton','Buchan Lennon','Sophie Stevens','Sara Clark-Downie','Florence Hall','Ian Kelsey','Oliver Alvin-Wilson','Laura Evelyn','Tom Golding','Pearce Quigley','Jade Ewen','Tom Bell','John Scougall','Paul Longley','Greg Miller Burns','Melanie Hudson','Paul Ritter','Laura Ferries','Tom Cox','Rich Hardesty','Claudia Jessie','Jaz Deol','Solomon Israel','Oliver Powell','Elena Saurel','Ben Bradley','Eleanor Wyld'],
basedOn:['Tom Edge'],
screenplay:['Tom Edge','Andy Baker','Ed Macdonald','Mark Grimmer'],
production:['Charlie Leech','Alex Walsh-Taylor'],
music:['Si Begg'],
camera:['Simon Vickery'],
cut:['Calum Ross','Billy Sneddon','Robin Peters','Christian Sandino-Taylor'],
scenography:['Iain McDonald','Suzanne Field'],
costumes:['Carole Miller','Lesley Abernethy']},
{title:'For You in Full Blossom',
titleCZ:'Hana zakari no kimitači e: Ikemen paradise',
year:2007,
runtime:'10h 48min',
episodeRuntime:'54min',
countries:['Japan'],
genres:['Comedy','Drama'],
director:['Hidetomo Macuda'],
actors:['Maki Horikita','Šun Oguri','Tóma Ikuta','Júsuke Jamamoto','Hiro Mizušima','Majuko Iwasa','Jošinori Okada','Džunpei Mizobata','Jú Širota','Masaki Okada','Rjóhei Suzuki','Mirei Kiritani','Šó Džinnai','Rjó Kimura','Tetta Sugimoto','Airi Taira','Takaja Kamikawa','Nobuo Kjó','Ukadži Takaši','Nacuki Harada','Mariko Cucui','Susumu Kobajaši','Hadžime Jamazaki','Jóko Moriguči','Júma Išigaki','Mahiru Konno','Keisuke Kató','Jasuhisa Furuhara','Enoku Šimegi','Hiromi Sakimoto','Kóhei Takeda','Sonde Kanai'],
screenplay:['Šógo Mutó'],
production:['Hirojuki Gotó'],
music:['Jú Takami','Šin Kóno']},
{title:'The Snow Queen',
titleCZ:'Nunui yeowang',
year:2006,
runtime:'17h 20min',
episodeRuntime:'65min',
countries:['South Korea'],
genres:['Drama','Romance'],
director:['Hyeong-min Lee'],
actors:['Bin Hyun','Yoo-ri Seong','Ju-hwan Lim','Joo-yeon Ko','Ho-jin Cheon','Jae-won Kim','Doo-shim Ko','Eung-soo Kim','In-yeong Yoo','Deok-moon Choi','Cheol-min Lee','Tae-hyeon Jin','Seon-ho Lee','Mi-hee Oh','Bong-kil Yun','Jin-yeong Park'],
screenplay:['Eun-kyeong Yoon']},
{title:'The Pacific',
titleCZ:'The Pacific',
year:2010,
runtime:'8h 32min',
episodeRuntime:'47-59min',
countries:['USA'],
genres:['War','Drama'],
director:['Timothy Van Patten','Jeremy Podeswa','David Nutter','Carl Franklin','Tony To','Graham Yost'],
actors:['James Badge Dale','Joseph Mazzello','Jon Seda','Ashton Holmes','Rami Malek','Josh Helman','Keith Nobbs','Martin McCann','Jacob Pitts','Brendan Fletcher','Tom Budge','William Sadler',"Conor O'Farrell",'Scott Gibson','Henry Nixon','Leon Ford','Gary Sweet','Toby Leonard Moore','Joshua Bitton','Annie Parisse','Ashley Zukerman','Joseph R. Sicari','Betty Buckley','Matt Craven','Nate Corddry','Cariba Heine','Bill Hunter','Joshua Close','Alice Parkinson','Isabel Lucas','Catherine McClements','Matt Young','Anna Torv','Claire van der Boom','Leeanna Walsman','Mathew Waters','Jon Bernthal','Noel Fisher','Adelaide Clemens','Liam McIntyre','Chris Haywood','Les Hill','Sandy Winton','Luke Arnold','Ian Bliss','Mitch Ryan','Andray Johnson','Heather Mitchell','Christopher Stollery','Toby Schmitz','Tim Budas','Socratis Otto','John Harlan Kim','Nikolai Nikolaeff','Eamon Farren','André de Vanny','Kate Bell','Sebastian Bertoli','Marian Frizelle','Ian Meadows','Samuel Johnson','Sam Parsonson','Rohan Nichol','Caroline Dhavernas','Brandon Keener','Maria Volk','Dylan Watson','Pascal Mercay','Karl Cottee','Andrew Lees','Jutaka Izumihara','Bill Young','Ben Esler','Nick Tate','Zoe Carides','Linda Cropper','Simon Bossell','Lelia Goldoni','Tom Hanks','Mark Leonard Winter','Cassandra Magrath','Penny McNamee','Warwick Allsop','Sean Bunch','Eero Ojala','Shingo Usami','Nathin Butler','Richard Healy','Pauline Egan','Simon Mallory','Eva Lazzaro','Akos Armont','Nathan Lovejoy','Natalie Gee','James Gaylyn','Bob Rumnock','Craig Ball','Kate Kendall','John-Paul Pace','Simon McLachlan'],
screenplay:['Bruce C. McKenna','Robert Schenkkan','Michelle Ashford','Graham Yost','George Pelecanos','Laurence Andries'],
production:['Timothy Van Patten','Todd London','Cherylanne Martin'],
music:['Hans Zimmer','Blake Neely','Geoff Zanelli'],
camera:['Remi Adefarasin','Stephen F. Windon'],
cut:['Alan Cody','Edward A. Warschilka','Marta Evry'],
sound:['Michael Minkler'],
scenography:['Anthony Pratt','Lisa Thompson'],
masks:['Howard Berger','Greg Nicotero','Chiara Tripodi','Jason Baird'],
costumes:['Penny Rose']},
{title:'The Ren & Stimpy Show',
titleCZ:'Ren a Stimpy',
year:1991,
runtime:'20h 44min',
episodeRuntime:'21-24min',
countries:['USA','Canada'],
genres:['Animation','Comedy','Adventure'],
director:['John Kricfalusi','Ron Hughart','Howard E. Baker','Peter Avanzino','Steve Loter','John Dilworth','Craig Bartlett','Tom Owens','Bong Hee Han','Mike Kim','Kelly Armstrong','Lynne Naylor','Vincent Waller','Chris Reccardi','Ken Bruce'],
actors:['Billy West','Edan Gross','Michael Pataki','Alan Young','Frank Zappa','Shawn Patterson','Jack Carter','Gary Owens','Charlie Callas','Gregory Abbey','Charlie Brissette','John Kricfalusi','Lynne Naylor','Gail Matthius','Melissa Fahn','Cheryl Chase'],
screenplay:['Ron Hauge','Will McRobb','Mike Kim','John Kricfalusi','Lynne Naylor','Vincent Waller','Vince Calandra','Chris Reccardi'],
production:['John Kricfalusi','Lynne Naylor','Lu Olkowski','Mary Harrington','Libby Simon'],
music:['Shawn Patterson'],
cut:['John A. Bushelman','Timothy J. Borquez','Michael Bradley','Scott Jeffress'],
sound:['Michael Bradley','Timothy J. Garrity','Timothy J. Borquez'],
scenography:['Chris Reccardi']},
{title:'Barakamon',
titleCZ:'Barakamon',
year:2014,
runtime:'4h 24min',
episodeRuntime:'22min',
countries:['Japan'],
genres:['Animation','Comedy'],
director:['Šinja Iino','Masacugu Arakawa','Kazuhisa Óno','Šingo Kaneko',"Šin'ja Kawacura",'Kaori','Masajuki Kodžima','Satomi Nakamura','Taketomo Išikawa','Imamura'],
actors:["Džun'iči Suwabe",'Suzuko Hara','Rumi Ókubo','Kóki Učijama','Ajaka Suwa','Fumihiko Tačiki','Kósuke Meguro','Rjóko Ono','Nozomi Furuki','Micuru Mijamoto','Majuno Jasokawa','Reiko Suzuki','Kei Hajami','Genki Jošimoto','Kudžira','Hiroši Ito','Mucumi Sasaki',"Ken'iči Močizuki",'Daisuke Ono','Kósuke Gotó','Jošino Takamori','Ikumi Nakagami','Rjósuke Kanemoto','Ellen Locy','Jóhei Tadano','Takahiro Fudžiwara','Acuši Ono','Šinobu Macumoto','Rina Endó','Seija Kimura','Hirómi Sugino','Tošihiko Miki','Jasuko Hatori','Jumiko Nakaniši','Kajó Nakadžima','Ena Macuo','Seidži Kató','Megumi Han','Tacuki Išikawa','Koga Satoru','Kóšin Maeda','Acuko Juja','Júki Kadži','Masuo Amada','Šóhei Ogawa','Hironobu Hatakejama','Kóki Ikehata','Kotori Koiwai'],
basedOn:['Sacuki Jošino'],
screenplay:['Pierre Sugiura'],
production:['Tošio Nakatani','Džunnosuke Itó'],
music:['Kendži Kawai'],
camera:['Jú Wakabajaši'],
cut:['Hitomi Sudó','Imamura'],
sound:['Kazuhiro Wakabajaši'],
scenography:['Hiroši Kató','Izumi Hoki']},
{title:'Sons of Anarchy',
titleCZ:'Zákon gangu',
year:2008,
runtime:'79h 33min',
episodeRuntime:'39-81min',
countries:['USA'],
genres:['Drama','Crime'],
director:['Kurt Sutter','Stephen Kay','Gwyneth Horder-Payton','Charles Haid','Allen Coulter','Michael Dinner','Seith Mann','Tim Hunter','Billy Gierhart','Peter Weller','Phil Abraham','Paris Barclay','Guy Ferland','Mario Van Peebles',"Terrence O'Hara",'Paul Maibaum','Adam Arkin','Karen Gaviola','Craig Yahata','Charles Murray'],
actors:['Charlie Hunnam','Katey Sagal','Mark Boone Junior','Ron Perlman','Kim Coates','Tommy Flanagan','Theo Rossi','Maggie Siff','Winter Ave Zoli','Johnny Lewis','Emilio Rivera','Jeff Wincott','Sprague Grayden','Ryan Hurst','William Lucking','McNally Sagal','Drea de Matteo','Ally Walker','Rockmond Dunbar','Adam Arkin','Henry Rollins','Kristen Renton','Nicholas Guest','Jay Karnes','Mitch Pileggi','Tory Kittles','Glenn Plummer','Judith Hoag','Stevie Long','Olivia Burnette',"Keir O'Donnell",'Taryn Manning','Tom Everett Scott','Tom Arnold','Liana Liberato','Kenny Johnson','Michele Boyd','Titus Welliver','Arie Verveen',"Q'orianka Kilcher",'Robin Weigert','Sarah Jones','Holt Boggs','Cameron Goodman','Joseph Runningfox','Danny Trejo','Stephen King','Cleo King','Paula Malcomson','David Labrava','Will Coffey','Sherrie Rose','Michael Shamus Wiles','Fernanda Andrade','Jim Cody Williams','Dayton Callie','Roman Mitichyan','Jeff Kober','Chris Coy','Dominic Keating','Dimitri Diatchenko','Ruben Garfias','Kurt Sutter','Damion Poitier','Noah Watts','Aldo Gonzalez','Mike Cochrane','Douglas Tait','Callard Harris','Lyle Kanouse','Eileen Grubba','Jason Rodriguez','Walton Goggins','Jimmy Smits','Randolph Mantooth','Taylor Sheridan','Thomas Rosales Jr.','Chuck Zito','Mike Pfaff','David Hill','David J. Wright','David Hasselhoff','Michael Fairman','Scott Lawrence','Bruno Gunn','Jose Pablo Cantillo','Jenny Gago','Jon Gries','Bridget Regan','Ronnie Gene Blevins','Derek Ray','Patrick Brennan','Sarah Domin','Kimberly Estrada','Casey Sander','Chris Browning','Rachel Rud','Blake Robbins','Clint Culp','Timothy V. Murphy'],
screenplay:['Roberto Patino','Marco Ramirez','Kurt Sutter','Brett Conrad','Mike Daniels','Dave Erickson','Charles Murray','Misha Green','Kem Nunn','Regina Corrado','Adria Lang','Pat Charles','Chris Collins','Jack LoGiudice','Peter Elkoff','Nichole Beattie','Gladys Rodriguez','Vaun Wilmott'],
production:['Mike Daniels','Kelly A. Manners','Kevin G. Cremin','Jon Paré'],
music:['Bob Thiele Jr.'],
camera:['Jonathan Freeman','David Boyd','Edward J. Pei','John C. Flinn III'],
cut:['Hunter M. Via','Jordan Goldman','Etienne Des Lauriers','Jacques Gravett','Lauren Pendergrass','Paul Fontaine','Tamara Luciano','Doc Crotzer'],
sound:['Michael Kalifa','Brian Harman','Thierry J. Couturier','Sherry Klein','Dean Okrand','Brett Grant-Grierson','Blake Marymor','Mark Friedgen','Tim Cooney'],
scenography:['Anthony Medina','Scott P. Murphy','Charles M. Lagola','Dena Allen','Tim Colohan','Christopher Marsteller','Sandy Struth'],
masks:['Gina Ghiglieri','Carlton Coleman','Tami Lane','Michele Tyminski Schoenbach','David Abbott','Stacey Morris','Arrick Anderson','Joni Powell','Vivian Maxwell','Ketty Gonzalez','Alicia M. Tripi'],
costumes:['Kelli Jones']},
{title:'Fawlty Towers',
titleCZ:'Hotýlek',
year:1975,
runtime:'6h 14min',
episodeRuntime:'29-34min',
countries:['UK'],
genres:['Comedy'],
director:['John Howard Davies','Bob Spiers'],
actors:['John Cleese','Prunella Scales','Andrew Sachs','Connie Booth','Ballard Berkeley','Gilly Flower','Brian Hall','Renee Roberts','Elspet Gray','Johnny Shannon','Una Stubbs','Derek Royle','Bernard Cribbins','Betty Huntley-Wright','Allan Cuthbertson','Pat Keen','Pat Gorman','David Kelly','James Cossins','Michael Cronin','Claire Nielson','Diana King','Basil Henson','Brenda Cowling','Steve Plytas','Conrad Phillips','Yvonne Gilan','Claire Davenport','Luan Peters','Richard Caldicot','Aimée Delamain','Kathleen Heath','Raymond Mason','Lewis Alexander','André Maranne','Michael Gwynn','Terence Coloney','Martin Wyldeck','Robin Ellis','Harry Fielder','Ann Way','Nicky Henson','Dorothy Frere','Bruce Boa','Geoffrey Morris','Michael Halsey','James Appleby','Lionel Wheeler','Trevor Adams','Peter Brett','Willy Bowman','April Walker','John Lawrence','Elizabeth Benson','Jay Neill','Louis Mahoney','Jeffrey Segal','Norman Bird','Geoffrey Palmer','Charles McKeown','Ken Campbell','Joan Sanderson','Robert Lankesheer','Bill Bradley','Mervyn Pascoe','Sabina Franklyn','John Quarmby','Mavis Pugh'],
screenplay:['John Cleese','Connie Booth'],
production:['John Howard Davies','Douglas Argent'],
sound:['John Howell']},
{title:'Wolverine and the X-Men',
titleCZ:'Wolverine a X-meni',
year:2008,
runtime:'9h 58min',
episodeRuntime:'23min',
countries:['USA'],
genres:['Action','Animation','Adventure','Drama','Sci-Fi'],
director:['Nicholas Filippi','Steven E. Gordon','Doug Murphy','Boyd Kirkland'],
actors:['Steve Blum','Jim Ward','Nolan North','Fred Tatasciore','Kari Wahlgren',"Liam O'Brien",'Tom Kane','Gwendoline Yeo','Yuri Lowenthal','Roger Craig Smith','Mark Hildreth','Susan Dalian','Kieren van den Blink','Jennifer Hale','Richard Doyle','Tara Strong','Michael Ironside','Kevin Michael Richardson','Stephen Stanton','Phil LaMarr','A. J. Buckley','James Patrick Stuart','Grey Griffin','Graham McTavish','Liza Del Mundo','Chris Edgerly','Clancy Brown','Crispin Freeman','Charlie Adler','Peter Lurie','Dominic Janes','Corey Burton','April Stewart','Phil Morris','Vanessa Marshall','Gabriel Mann','Alex Désert','Laraine Newman','Keone Young','James Sie','Benjamin Bryan','Kate Higgins','André Sogliuzzo','Crystal Scales'],
screenplay:['Christopher L. Yost','Boyd Kirkland','Paul Giacoppo','Greg Johnson','Joshua Fine','Len Uhley','Bob Forward','Max Botkin','Kevin Hopps','Zoë Green','Chris Hicks','Francis Lombard'],
production:['Craig Kyle','Jason Netter'],
music:['Dean Grinsfelder'],
cut:['Aeolan Kelly','Ralph A. Eusebio','George Rizkallah'],
sound:['Mike Draghi']},
{title:'The Good Fight',
titleCZ:'Dobrý boj',
year:2017,
runtime:'51h 3min',
episodeRuntime:'40-60min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Ron Underwood','Alex Zakrzewski','Marta Cunningham','Allan Arkush','Michael Zinberg','Jim McKay','Brooke Kennedy','So-yong Kim','Robert King','Clark Johnson','Frederick E.O. Toye','Nelson McCormick','Félix Enríquez Alcalá','Kevin Rodney Sullivan','Tess Malone','James Whitmore Jr.','Fred Murphy','Michael Trim','Tyne Rafaeli','Nikki M. James','Carrie Preston','Lily Mariye'],
actors:['Christine Baranski','Justin Bartha','Cush Jumbo','Rose Leslie','Delroy Lindo','Sarah Steele','Erica Tazel','Scott Bryce','James Martinez','Heléne Yorke','Ron Canada','Anna Khaja','Bernadette Peters','Nyambi Nyambi','Michael Boatman','Paul Guilfoyle','Leroy McClain','Matthew Perry','Carrie Preston','Aaron Tveit','John Cameron Mitchell','John Benjamin Hickey','Tom McGowan','David A. Gregory','Gary Cole','Greta Lee','Paulo Costanzo','Sam Seder','Becky Ann Baker','Peter Gerety','Peter Maloney','Paul Anthony Stewart','Zachary Knighton','Stephanie Roth Haberle','Christian Campbell','Jane Alexander','Christine Lahti','Zachary Booth','Dominic Fumusa','John Ellison Conlee','Robert Picardo','Todd Susman',"Denis O'Hare",'Anthony Rapp','Jerry Adler','Sherman Howard','Zach Grenier','Rick Crom','Louis Gossett Jr.','Fisher Stevens','Frankie Faison','Scott Jaeck','Mimi Lieber','Andrea Martin','Dylan Baker','Jane Lynch','Corey Cott','Cece King','Audra McDonald','Brian Stokes Mitchell','Wally Dunn','Doris McCarthy','Robert Myers','Caroline Aaron','Jayne Houdyshell','Sam McMurray','David Call','Isabella Farrell','Cindy Cheung','Quentin Mare','Rob Reiner','Tim Matheson','Mamie Gummer','Ashley Thomas','Richard Masur','Teddy Cañez','Nat Cassidy','Christian Borle','Keesha Sharp','Peter Scolari','Terry Serpico','Adam Ferrara','Murphy Guyer','F. Murray Abraham','Matt Walsh','Evan Handler','Connie Ray','Maurice Jones','Bebe Neuwirth','Kevin McNally','José Ramón Rosario','Michael Ian Black','Gary Milner','Margo Martindale','Grizz Chapman','Pippa Pearthree','Alan Alda','Kurt Fuller','Megan Hilty','Nikki M. James'],
screenplay:['Joey Hartstone','Phil Alden Robinson','Robert King','Tegan Shohet','Michelle King','Aurin Squire','Davita Scarlett','Keith Josef Adkins','Jonathan Tolins','Laura Marks','Jacquelyn Reingold','William M. Finkelstein','Marcus Dalzine','Eric Holmes','Daniel Beaty','Anju Andre-Bergmann'],
production:['Laura Marks','Christine Baranski','Michelle King','Robert King','Davita Scarlett','Tegan Shohet','Aurin Squire'],
music:['David Buckley'],
camera:['Fred Murphy','Tim Guinness','Ronald Víctor García','Petr Hlinomaz','Alec Jarnagin'],
cut:['Christopher S. Capp','Allyson C. Johnson','Erica Freed Marker','Jake Cohen','Dan Erickson','Gary Levy','Richard Lowe','Dave Labich','James W. Harrison III','Deborah Moran','Katherine Skjerping','Amanda Pollack','Matthew Kregor','Elizabeth Merrick','Nathan Floody','Ryan Allen','Warren Bowman'],
sound:['Andy Kris','Stuart Stanley','Adam Rooner','Frank Morrone','Fred Judkins','Sean Garnhart'],
scenography:['Stephen Hendrickson','Hilda Stark','Shannon Finnerty','Beth Kushnick','Alexandra Mazur','Shannon Nallan'],
masks:['Madeliene LeCuyer','Caitlin Boland','Cheria Brown','Robert Lugo','Greg Cooper-Spencer'],
costumes:['Daniel Lawson']},
{title:'The Last of Us',
titleCZ:'The Last of Us',
year:2023,
runtime:'16h 7min',
episodeRuntime:'43-80min',
countries:['USA'],
genres:['Action','Adventure','Drama','Horror','Sci-Fi','Thriller'],
director:['Ali Abbasi','Jeremy Webb','Neil Druckmann','Peter Hoar','Liza Johnson','Craig Mazin','Jasmila Žbanić'],
actors:['Bella Ramsey','Pedro Pascal','Gabriel Luna','Merle Dandridge','Jeffrey Pierce','Nico Parker','Murray Bartlett',"Con O'Neill",'Anna Torv','Troy Baker','Storm Reid','John Hannah','Josh Brener','Christopher Heyerdahl','Brad Leland','Marcia Bennett','Haysam Kadri','Sarah Himadeh','Caitlin Howden','Max Montesi','Gina Phillips','Taylor St. Pierre','Khadijah Roberts-Abdullah','Jason Burkart','Natasha Mumba','Christine Hakim','Yayu A.W. Unru','Sharon Crandall','Nick Offerman','Kevin Sateri','Riley Davis','Lamar Johnson','Melanie Lynskey','John Getz','Graham Greene','Craig Haas','Adam Basil','Rutina Wesley','Elaine Miles','Toby Levins','Nico Parker','Lamar Johnson','Terry Chen','Ian Rozylo','Scott Shepherd','Sonia Maria Chirila','Nelson Leis','Ashley Johnson','Pardeep Singh Sooch','Corina Akeson','Eric Breker','Logan Pierce','Keivonn Woodard'],
screenplay:['Neil Druckmann','Craig Mazin'],
production:["Cecil O'Connor",'Greg Spence'],
music:['Gustavo Santaolalla','David Fleming'],
camera:['Eben Bolter','Nadim Carlsen','Xenija Sereda','Christine A. Maier'],
cut:['Mark Hartzell','Timothy A. Good','Cindy Mollo'],
sound:['Michael J. Benavente','Kevin Roache'],
scenography:['Paul Healy','Bill Ives','John Paino','Andrew Moreau'],
masks:['Barrie Gower','Shelley Kinaschuk Russell'],
costumes:['Cynthia Ann Summers']},
{title:'Outlander',
titleCZ:'Cizinka',
year:2014,
runtime:'92h 10min',
episodeRuntime:'51-90min',
countries:['USA'],
genres:['Drama','Romance','Sci-Fi'],
director:['Richard Clark','Anna Foerster','John Dahl','Brian Kelly','Mike Barker','Metin Hüseyin','Douglas Mackinnon','Philip John','Brendan Maher','Jennifer Getzinger','Norma Bailey','Matthew B. Roberts','Ben Bolt','Denise Di Novi','David Moore','Charlotte Brändström','Mairzee Almas','Stephen Woolfenden','Julian Holmes','Meera Menon','Jamie Payne','Annie Griffin','Kate Cheeseman','Justin Molotnikov','Christiana Ebohon-Green','Lisa Clarke','Jacquie Gould','Tracey Deer','Joss Agnew'],
actors:['Caitríona Balfe','Sam Heughan','Tobias Menzies','Duncan Lacroix','Stephen Walters','Graham McTavish','Bill Paterson','Nell Hudson','Gary Lewis','Lotte Verbeek','Annette Badland','James Fleet','Douglas Henshall','Laura Donnelly','Francis Magee','Tim McInnerny','Jamie Kennedy','John Sessions','Simon Callow','Nicholas Aaron','Diana Gabaldon','Bryan Larkin','Ian Hanmore','David Elliot','Blair Cunningham','Brian McCardie','Nick Gordon','Anna Foerster','Rosie Day','Stanley Weber','Robert Cavanah','Lionel Lingelser','Andrew Gower','Dominique Pinon','Frances de la Tour','Marc Duret','Romann Berrux','Robbie McIntosh','Niall Greig Fulton','Gaia Weiss','Margaux Châtelier','Clive Russell','Oscar Kennedy','Paddy Wallace','Julian Wadham','Robert Curtis','Brendan Patricks','Steven Cree','Jakub Hajner','Richard Rankin','Chris Kyle','Patrick Macnee','Diana Rigg','Prentis Hancock','Valerie Edmond','Frazer Hines','Tom Brittney','Kevin Mains','Andrew Whipp','Simon Meacock','John Heffernan','Kimberley Nixon','Roger Ringrose','Colin Stinton','Sam Hoare','Wil Johnson','Geoffrey McGivern','James Allenby-Kirk','Murray McArthur','Sophie Skelton','Hannah James','Rupert Vansittart','Beth Goddard','Mitchell Mullen','William Meredith','Douglas Reith','Rufus Wright','Emma Campbell-Jones','Nigel Betts','Kola Krauze','Daniel Kerr','Herbert Forthuber','Laurence Dobiesz','Sera-Lys McArthur','Ed Speleers','César Domboy','Lauren Lyle','Tim Downie','John Bell','Leon Herbert','Rainer Sellien','Geoffrey Austin Newland','Maria Doyle Kennedy','Colin McFarlane','James Barriscale','Lee Boardman','Jerome Holder','Ciaron Kelly','Jamie Scott Gordon','Tantoo Cardinal'],
basedOn:['Diana Gabaldon'],
screenplay:['Ronald D. Moore','Richard Kahan','Ira Steven Behr','Shaina Fewell','Matthew B. Roberts','Jennifer Yale','Toni Graphia','Karen Campbell','Joy Blake','Alyson Evans','Steve Kornacki','Barbara Stepansky','Stephanie Shannon','Danielle Berrow','Megan Ferrell Burke','Diana Gabaldon','Anne Kenney','Shannon Goss','Luke Schelhaas','Bronwyn Garrity','Tyler English-Beckwith','Marque Franklin-Williams','Taylor Mallory','Sarah H. Haught','Margot Ye'],
production:['Shaina Fewell','Jennifer Yale','Caitríona Balfe','Sam Heughan','David Brown','Shannon Goss',"Michael O'Halloran",'Bronwyn Garrity','Michael Wilson','Elicia Bessette','Sarah H. Haught'],
music:['Bear McCreary'],
camera:['David Higgs','Denis Crossan','Neville Kidd','Martin Fuhrer','Stephen McNutt','Stijn van der Veken','Alasdair Walker','Michael Swan','Michael Coulter','Nic Lawson'],
cut:['Liza Cardinale','Melissa Lawson Cheung',"Michael O'Halloran",'Miklos Wright','Gena Bleier','Fabienne Bouville','Tammis Chandler','Alanah Jones'],
sound:['Karol Urban','Nello Torri','Alan Decker','Todd Morrissey'],
scenography:['Jon Gary Steele','Stuart Bryce','Gina Cromwell','Joan Sabaté','Mike Gunn','Leslie Ewe','Nicki McCallum','Moley Campbell'],
masks:['Talli Pachter','Suzanne Jansen','Anita Anderson','Julie Dorrat-Keenan','Emma Romans'],
costumes:['Terry Dresbach','Glenne Campbell','Nina Ayres','Trisha Biggar']},
{title:'Two Year’s Vacation',
titleCZ:'2 roky prázdnin',
year:1974,
runtime:null,
episodeRuntime:'Alternativní 6x55min',
countries:['France','Rumunsko','Germany','Switzerland'],
genres:['Adventure'],
director:['Sergiu Nicolaescu','Gilles Grangier'],
actors:['Marc Di Napoli','Werner Pochath','Constantin Baltaretu','Constantin Bărbulescu','Hans Kraus','Horia Pavel','Constantin Diplan','Cristian Sofron','Aurel Giurumia','Wolfgang Lukschy','Rainer Basedow','Christian Brückner','Klaus Sonnenschein','Dagmar Altrichter','Gerd Duwner','Klaus Miedel','Peter Schiff','Torsten Sense','Franz Seidenschwan','Mathias Einert','Eric Vaessen','Knut Reschke','Günther Kieslich','Günther Kieslich','Erich Ebert','Uwe Paulsen','Dieter Steinbrink'],
screenplay:['Walter Ulbrich'],
cut:['Alfred Srp']},
{title:'Black Butler',
titleCZ:'Kurošicudži',
year:2008,
runtime:'23h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Fantasy','Comedy','Mystery'],
director:['Tošija Šinohara','Jasuhiro Geši','Daisuke Cukuši','Tecuo Ičimura','Hirofumi Ogura','Tecuja Endó','Jošihisa Macumoto','Norijuki Abe','Tomokazu Tokoro','Hitomi Ezoe','Takahiro Okao','Minoru Óhara','Tomihiko Ókubo','Ai Jošimura','Tošifumi Takizawa','Naokacu Cuda','Kentaró Suzuki','Hitojuki Macui','Hirojuki Morita','Norihiko Nagahama','Šinobu Sasaki','Harume Kosaka',"Šin'iči Masaki","Šin'iči Omata",'Micutaka Nošitani','Kijoko Sajama','Takahiro Harada','Takajuki Tanaka','Kenjiro Okada'],
actors:['Maaja Sakamoto','Daisuke Ono',"Džun'iči Suwabe",'Romi Paku','Šundži Fudžimura','Ajako Kawasumi','Kendžiró Cuda','Noriaki Sugijama','Šinnosuke Tačibana','Tacuhisa Suzuki','Akiko Jadžima','Džun Fukujama','Júki Kadži','Kódži Jusa','Jutaka Aojama','Emiri Kató','Micuki Saiga','Satoši Hino','Ajumi Fudžimura','Júko Gotó','Sajuri Jahagi','Anri Kacu','Hiroki Jasumoto',"Šin'ja Hamazoe",'Bandžó Ginga','Masahiro Okazaki','Jošimicu Šimojama','Kósuke Toriumi','Hisajoši Suganuma','Kazujuki Okicu','Asami Šimoda','Kana Uetake','Kóiči Sakaguči','Júko Sasamoto','Hiroki Tóči','Jukari Tamura','Binbin Takaoka','Jasuhiro Mamija','Taketoši Kawano','Takaši Hikida','Šúhei Takubo','Seiró Ogino','Jutaka Nakano','Sajuri Sadaoka','Rjú Jamaguči','Cutomu Densaka','Gó Šinomija','Ao Takahaši','Takajuki Masuda','Rjó Sugisaki','Takafumi Kawakami','Hiromu Mijazaki','Kendži Takahaši','Takafumi Jamaguči','Hitoši Janai','Rjúgo Saitó','Tomo Adači','Fumihiro Okabajaši','Jui Icuki','Keiko Taniguči','Tomojuki Higuči','Takahiro Sakurai','Takahiro Šimura','Aja Hirano',"Ken'iči Suzumura",'Micuaki Hošino','Nana Mizuki','Kimijoši Kibe','Džunko Šimeno','Čihiro Tagaino','Hirokazu Miura','Ajano Išikawa','Marina Inoue','Kotomi Ócuka',"Šin'ja Fukumacu",'Kandži Suzumori','Mikoto Sató','Meguru Takahaši','Daisuke Macuo','Sórjú Konno','KENN','Akimicu Takase','Momoko Óhara','Takuma Terašima','Satoši Mikami','Ajahi Takagaki','Čika Makihara','Čafúrin','Juna Taniguči','Mamoru Mijano','Rjóhei Kimura','Masaharu Tahara','Nobuhiko Okamoto','Rjókan Kojanagi','Haruka Jamazaki','Júko Kaida','Tomoaki Maeno','Kendži Hamada','Hiromi Seta','Daiširó Hano'],
basedOn:['Jana Toboso'],
screenplay:['Mari Okada','Hirojuki Jošino','Juka Jamada','Riko Murakami','Tacuto Higuči','Tošizó Nemoto','Masahiro Jokotani','Juka Mijata','Ičiró Ókóči','Jana Toboso'],
production:['Hiró Marujama','Jasutaka Kimura'],
music:['Taku Iwasaki','Jasunori Micuda','Rjó Kawasaki'],
camera:['Hinata Kinošita','Nozomi Šitara','Takajuki Furukawa','Kento Sasaki'],
cut:['Masahiro Gotó'],
sound:['Kacujoši Kobajaši'],
scenography:['Hiromasa Ogura','Manabu Ocuzuki']},
{title:'Grace and Frankie',
titleCZ:'Grace a Frankie',
year:2015,
runtime:'46h 11min',
episodeRuntime:'25-35min',
countries:['USA'],
genres:['Comedy'],
director:['Tim Kirkby','Miguel Arteta','Bryan Gordon','Dennie Gordon','Andrew McCarthy','Dean Parisot','Julie Anne Robinson','Matt Shakman','Tristram Shapeero','Tate Taylor','Betty Thomas','Scott Winant','Rebecca Asher',"Trent O'Donnell",'Arlene Sanford','Andy Ackerman','Jann Turner','Michael Showalter','Melanie Mayron','Jason Ensler','Lee Rose','Alex Hardcastle','Wendey Stanzler','Marta Kauffman','Ken Whittingham','Gail Lerner','Alan Poul','Kyra Sedgwick','Randall Keenan Winston','Silver Tree','David Warren','Marta Cunningham','John Hoffman'],
actors:['Jane Fonda','Lily Tomlin','Sam Waterston','Martin Sheen','Brooklyn Decker','Ethan Embry','June Diane Raphael','Baron Vaughn','Craig T. Nelson','Geoff Stults','Timothy V. Murphy','Tim Bagley','Anna Ross','Michael Gross','Michael Scott Allen','Corbin Bernsen','Barry Bostwick','Creed Bratton','Sam Buchanan','Julia Cho','Leena Huff','Brittany Ishibashi','Christine Lahti','Joe Morton','Mary Kay Place','Jason Ralph','Dale Waddington',"Nicholas D'Agosto",'Peter Mackenzie','Jeff Doucette','Alberto Jorrin','Hank Chen','John Getz','Rita Moreno','Alison Martin','Craig Welzbacher','Todd Grinnell','Warren Berlinger','John Balma','Raegan Revord','David L. King','Chris Aquilino','Brittany Renee Finamore','Jill Basey','Brian Benben','Ernie Hudson','Peter Cambor','Ken Lerner','Nora Dunn','Todd Giebenhain','Conchata Ferrell','Sam Elliott','Robert Baker','Swoosie Kurtz','Marsha Mason','Suzanne Ford','Casey Sander','Briana Venskus','Charlet Takahashi Chung','Sarah Baker','Jay Ellis','Carrie Preston','David Villar','Amy Madigan','Paul Scheer','Estelle Parsons','Herbert Russell','Kaiwi Lyman','Debbie Lee Carrington','Kenny Loggins','Lilah Richcreek','Mark Saul','Rachel Winfree','Matthew Glave','Jack Plotnick','Lee Weaver','Lois Smith','Damon Dayoub','Emily Montague','Wendie Malick','Millicent Martin','Alyson Reed','Megan Ferguson','Peter Gallagher','Roger Bart','Kevin Chamberlin','Joanne Baron','Nathan Blaiwes','Ed Begley Jr.','Natalie Morales','Todd Sherry','Michael Medico','David Agranov','Larry Dorf','Eugene Cordero','Matt Cook','Rae Gray','Fred Mancuso','Lisa Kudrow','Mel Rodriguez'],
screenplay:['Billy Finnegan','Alexa Junge','Wil Calhoun','Marta Kauffman','Howard J. Morris','Nancy Fichman','Jennifer Hoppe','Jacquelyn Reingold','Sara Lohman','Gretchen Enders','Barry Safchik','John Hoffman','Michael Platt','Elena Crevello','Laura Jacqmin','Ben Siskin','Julieanne Smolinski','Julie Durk','David Budin','Alex Levy'],
production:['David Ellison','Jeff Freilich','Billy Finnegan','Nancy Fichman','Jesse Schiller','Marta Kauffman','Howard J. Morris','Joanne Toll','Julieanne Smolinski','Julie Durk','David Budin'],
music:['Michael Skloff','Sam Kaufman-Skloff'],
camera:['Gale Tattersall','Luke Miller'],
cut:['Michael Jablow','Matthew Freund','Lisa Zeno Churgin','Roger Bondelli','Sam Seig','Spencer Houck','Jamie Gross','Sarah Lucky','Nick Olah','Karoliina Tuovinen'],
sound:['Vicki Lemar','Joe Earle','Kurt Kassulke','Adam Sawelson','Walter Michael Bost','Kenneth Kobett','Doug Andham','Tyler Weisenauer'],
scenography:['Devorah Herbert','Amy Lee Wheeler','Beauchamp Fontaine','Christopher Carlson'],
masks:['Ashleigh Childers','Jody Burton','Patricia Dehaney','Robin Siegel','Kelly Kline'],
costumes:['Allyson B. Fanger']},
{title:"This Is England '86",
titleCZ:"This Is England '86",
year:2010,
runtime:'3h 10min',
episodeRuntime:'45-49min',
countries:['UK'],
genres:['Drama'],
director:['Tom Harper','Shane Meadows'],
actors:['Jo Hartley','Katherine Dow Blyton','Vicky McClure','Thomas Turgoose','Joe Gilgun','Stephen Graham','Michael Socha','Johnny Harris','Danielle Watson','Chanel Cresswell','Andrew Shim','Andrew Ellis','Rosamund Hanson','Perry Benson','George Newton',"Seamus O'Neill",'Hannah Walters','Tony Denham','Joe Dempsie','Jack Thorne','William Travis','Rebecca Manley','Jean Fergusson','Georgia May Foote'],
screenplay:['Shane Meadows','Jack Thorne'],
production:['Derrin Schlesinger','Mark Herbert'],
music:['Uwe Fahrenkrog-Petersen','Ludovico Einaudi'],
camera:['Danny Cohen'],
cut:['Mark Eckersley','Chris Wyatt'],
scenography:['Lisa Hall'],
masks:['Nadia Stacey'],
costumes:['Charlotte Walter']},
{title:'Holocaust',
titleCZ:'Holocaust',
year:1978,
runtime:'6h 59min',
episodeRuntime:'89-135min',
countries:['USA'],
genres:['Drama','Romance'],
director:['Marvin J. Chomsky'],
actors:['James Woods','Meryl Streep','Michael Moriarty','Joseph Bottoms','Tovah Feldshuh','Tom Bell','Rosemary Harris','Ian Holm','Sam Wanamaker','David Warner','Charles Korvin','Michael Beck','Jiří Pravda','Edward Hardwicke','Nigel Hawthorne','T.P. McKenna','Vernon Dobtcheff','Jeremy Levy','Hans Meyer','Erwin Steinhauer','Marius Goring','Robert Stephens','Blanche Baker','Isolde Barth','Bob Sherman','Fritz Weaver','Helmut Janatsch','Lee Montague','Tony Haygarth','Stephan Paryla','Peter Capell','Harry Hornisch','Ernst Hausknost','Wolfgang Lesowsky','Rudolf Melichar','Götz von Langheim','Miriam Mahler','Nora Minor','Käte Jaenicke','Nina Sandt','Otto Clemens','Vera Borek','Sean Arnold','George Rose','Jeffrey Zach','Llewellyn Rees','John Rees','David Daker','Irene Prador','Cyril Shaps','John Collin','Peter Vogel','Oscar Quitak','Bruno Thost','John Bailey','Walter Scheuer','Joe Trummer','Karl Hoess','Karl Schulz','Peter Weihs','Bernd Hall','Peter Garell','Peter Neusser','Julius Schaub','Fritz Schilgen','Elvira Neustaedtl','Hubert Berger','Werner Kreindl','Stanley Lebor','Martin Brandt','Adolf Hitler','Edward Winter','Gottfried Blahovsky','Murray Salem'],
screenplay:['Gerald Green'],
production:['Robert Berger'],
music:['Morton Gould'],
camera:['Brian West'],
cut:['Craig McKay','Alan Heim','Stephen A. Rotter','Robert M. Reitano','Brian Smedley-Aston'],
sound:['Dick Vorisek','Jim Willis'],
scenography:['Wilfred Shingleton','Maxi Hareiter'],
masks:['Hasso von Hugo'],
costumes:['Peggy Farrell','Edith Almoslino']},
{title:'Fortysomething',
titleCZ:'Čtyřicítka na krku',
year:2003,
runtime:'4h 54min',
episodeRuntime:'49min',
countries:['UK'],
genres:['Comedy','Drama'],
director:['Hugh Laurie','Nic Phillips'],
actors:['Hugh Laurie','Anna Chancellor','Sheila Hancock','Peter Capaldi','Benedict Cumberbatch','Stephen Fry','Clive Mantle','Ben Willbond','Phillip Manikum','Siobhan Hewlett','Greg Bennett','Trevor Cooper','Pik Sen Lim','Badi Uzzaman','Tom Allen','Charlie Covell','Bob Mason','Roy Evans','Geoffrey Whitehead','Nicholas Le Prevost','Christine Adams','Peter Wight','Angela Curran','Jenny Howe','Malcolm Terris','Julie Dawn Cole','Lolita Chakrabarti','Simon Greenall','Gbolahan Obisesan','Robert Gwilym'],
screenplay:['Nigel Williams'],
music:['Rob Lane'],
camera:['John Kenway'],
cut:['Paul Endacott'],
scenography:['Sarah Greenwood'],
costumes:['Pam Downe']},
{title:'Welcome to the N.H.K.',
titleCZ:'NHK ni jókoso!',
year:2006,
runtime:'9h 36min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Drama','Comedy','Psychology'],
director:['Júdži Kumazawa','Masahiro Sonoda','Júsuke Jamamoto','Akira Kató','Hirojuki Okuno'],
actors:['Daisuke Sakaguči','Jutaka Koizumi','Jui Makino','Hidejuki Tanaka','Mijuki Sawaširo','Nobuhiko Okamoto','Júdži Ueda','Čafúrin','Eidži Takemoto','Majumi Šó','Kózó Šioja','Sanae Kobajaši','Risa Hajamizu','Joku Šioja','Akiko Macuzaki','Džunko Iwao','Ajumi Cudži','Kaoru Katakai','Rjó Sugisaki','Ken Uo','Sačiko Okada','Rjúsaku Čidžiwa','Masato Nišino','Haruka Kimura','Šinsuke Fukui','Hikari Jono','Jasuši Mijabajaši','Rumi Šišido','Kacui Taira',"Ken'iči Mine",'Mari Orito','Asuka Jano','Jumiko Hori','Risa Cubaki','Kazuo Hara','Kanae Abe'],
basedOn:['Tacuhiko Takimoto'],
screenplay:['Satoru Nišizono'],
production:['Hidemasa Arai','Makoto Chiba','Satoši Macui'],
camera:['Naoki Kitamura'],
cut:['Akinori Mišima'],
sound:['Joku Šioja'],
scenography:['Hiroši Igaki']},
{title:'Gungrave',
titleCZ:'Gungrave',
year:2003,
runtime:'10h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Crime','Sci-Fi'],
director:['Tošijuki Curu','Tecuró Araki','Rjó Mijata'],
actors:['Kikuko Inoue','Kumi Sakuma','Takehito Kojasu','Rjúzaburó Ótomo','Tomokazu Seki','Cutomu Isobe','Kendži Hamada','Iemasa Kajumi','Tamio Óki','Čafúrin','Džódži Nakata','Fumihiko Tačiki','Kenta Mijake','Jasuhiro Fudžiwara','Jósuke Akimoto','Rino Marimo','Kacuhisa Hóki','Kazuhiro Nakata','Nobujuki Furuta','Eidži Hanawa','Masako Kacuki','Motomu Kijokawa',"Ken'iči Močizuki",'Šintaró Óhata','Tošihiko Nakadžima','Šigeru Šibuja','Takuma Suzuki','Kazuo Oka','Kazuhisa Tanaka','Jóiči Nišidžima','Komina Macušita','Mariko Takigawa','Takeru Mijašita'],
basedOn:['Jasuhiro Naitó'],
screenplay:['Jósuke Kuroda'],
production:['Šigeru Kitajama','Tóru Kubo','Hideki Gotó'],
music:['Cuneo Imahori'],
camera:['Hisao Širai'],
cut:['Takeši Sejama','Kašiko Kimura'],
sound:['Jasunori Honda'],
scenography:['Ueno Hidejuki','Tomojuki Šimizu']},
{title:'A Taste for Death',
titleCZ:'Pachuť smrti',
year:1988,
runtime:null,
episodeRuntime:'6x50min',
countries:['UK'],
genres:['Crime'],
director:['John Davies'],
actors:['Roy Marsden','Penny Downie','Wendy Hiller','Bosco Hogan','Simon Ward','Kate Buffery','Oliver Ford Davies','Matthew Marsh','Gabrielle Lloyd','Fiona Fullerton','John Bown','Jack Watson','Rob Spendlove','Patsy Byrne','Morag Hood','Avril Elgar','Derek Newark','Kevin Stoney','John Ringham','Constance Chapman','Rebecca Saire','Geoffrey Chater','Carmel Mcsharry','Terence Edmond','Pauline Delaney','Jean Marlow','Martin Friend'],
basedOn:['P. D. James'],
production:['John Rosenberg'],
music:['Richard Harvey'],
cut:['Kevin Waters']},
{title:'Black Sails',
titleCZ:'Pod černou vlajkou',
year:2014,
runtime:'35h 12min',
episodeRuntime:'49-65min',
countries:['USA'],
genres:['Adventure','Drama'],
director:['Sam Miller','T.J. Scott','Neil Marshall','Marc Munden','Clark Johnson','Steve Boyum','Stefan Schwartz','Alik Sakharov','Michael Nankin','Lukas Ettlin','Roel Reiné','Marc Jobst','Uta Briesewitz','Jonathan E. Steinberg'],
actors:['Toby Stephens','Luke Arnold','Clara Paget','Mark Ryan','Hakeem Kae-Kazim','Jessica Parker Kennedy','Patrick Lyster','Langley Kirkwood','Jeremy Crutchley','Tom Hopper','Hannah New','Zach McGowan','Toby Schmitz','Sean Cameron Michael','Louise Barnes','Mark Elderkin','Lise Slabber','Sibongile Mlambo','Nick Boraine','Karl Thaning','Ray Stevenson','Graham Hopkins','Tadhg Murphy','Pierre Malherbe','Chris April','Joe Vaz','Tony Caprari','Martin Le Maitre','Fiona Ramsay','Gregg Viljoen','Andrew Jacobs','Rupert Penry-Jones','Robert Hobbs','Norman Anstey','Danny Keogh','Lars Arentz-Hansen','Luke Roberts','Anna-Louise Plowman','Jason Cope','Isak Férriz','James Gracie','Wayne Harrison','Tshamano Sebe','Bart Fouche','David Wilmot','Chris Larkin','Dale Jackson','Tony Kgoroge','Ilay Kurelovic','Jorge Suquet','Harriet Walter','Ron Smerczak','Lemogang Tsipa','Craig Hawks','Laura Hopper','Jay-Jay Botha','Paul du Toit','Luke Tyler','Tyrone Keogh','Zethu Dlomo','Quentin Krog','Richard Lukunku','Jannes Eiselen','Brandan Sean Murray','Richard Lothian','David Butler','Eddie Baroo','Craig Jackson','Rob Fruithof','Garth Breytenbach','Leon Clingman','Stevel Marc','Siya Mayola','Meganne Young','Brett Williams','Nic Rasenti','David Dukas','Craig Macrae','Trevor Frost','Riaz Solker','Angelique Pretorius'],
screenplay:['Robert Levine','Jonathan E. Steinberg','Michael Angeli','Aaron Helbing','Todd Helbing','Michael S. Chernuchin','Evan Bleiweiss','Heather Bellson','Doris Egan','Peter Ocko','Brad Kane'],
production:['Julie Siege','Erik Henry','Nina Jack','Brad Kane'],
music:['Bear McCreary'],
camera:['Lukas Ettlin',"Jules O'Loughlin",'David Luther','Gavin Struthers','Michael Swan','Simon Dennis'],
cut:['John Coniglio','Stephen Mark','Terry Kelley','Paul Trejo','Joe Hobeck','Tessa Verfuss','Shonnard Hedges','Tamar Feder'],
sound:['Onnalee Blank','Mathew Waters','Benjamin L. Cook','Pedro Sánchez Alonso','Mark Holding'],
scenography:['Wolf Kroeger','Brian Glaser','Fred Du Preez'],
masks:['Lian van Wyk','Kirstin Chalmers'],
costumes:['Marina Draghici','Tim Aslam']},
{title:'The Alienist',
titleCZ:'Psychiatr',
year:2018,
runtime:'14h 28min',
episodeRuntime:'42-56min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Paco Cabezas','James Hawes','Jakob Verbruggen','David Petrarca','Jamie Payne','David Caffrey','Clare Kilner'],
actors:['Daniel Brühl','Luke Evans','Dakota Fanning','David Wilmot','Eugenia Caruso','Ted Levine','Matt Lintz','Douglas Smith','Dan Bradford','Clare Calbraith','Brian Geraghty','Falk Hentschel','Michael Jibson',"Q'orianka Kilcher",'Aurélia Poirier','Philip Rosch','Matthew Shear','Robert Wisdom','Martin McCreadie','Aldo Maland','Morfydd Clark','Michael Ironside','Peter McRobbie','Daisy Bevan','Bálint Adorjáni','Virág Bárány','Richard Bremmer','Dorka Gáspárfalvi','Péter Kertész','Mary Stockley','Klári Tolnai','Grace Zabriskie','Sean Young','Josef Altin','Katie Brayben','Lily-Rose Aslandogdu','Nicolas Bro','Nicholas Asbury','Kristóf Ódor','Zsolt Páll','Kate Phillips','Sara Vickers','Kate Dickie','Béla Gados','Amanda Hadingue','Katherine Kingsley','Roland Miskey','Gábor Urmai','Dávid Miller','Stephen Louis Grush','William Gaminara','Dániel Kanalas','Ania Marson','Sean McGinley','David Warner','Bill Heck','Jackson Gann','Ed Birch','Ian Hughes','George Lenz','Tom Pilath','Vivien Rujder','Levente Törköly','Cassi Thomson','David Meunier','Sean Bridgers','Eric Johnson','Corey Johnson','Nicola Stephenson','Ágnes Bánfalvy','David Langham','Ronan Vibert','Tim Barlow','Ben Lamb','Kata Pálfi','Nino Surguladze','Brittany Marie Batchelder','Emanuela Postacchini',"Marcus D'Amico",'Jefferson White','Anson Boon','Lewis McGowan','Lewin Lloyd','Zeb Moore','Roman Vasiljev','Max Fincham','Emily Barber','Melanie Field','Gavin Drea','Jacob James Beswick','Antonio Magro','Michael McElhatton','Matt Letscher','Alice Krige','Heather Goldenhersh','Bruna Cusí','Diego Martín','Demetri Goritsas','Hebe Beardsall','Maurice Byrne'],
basedOn:['Caleb Carr'],
screenplay:['Hossein Amini','Cary Joji Fukunaga','E. Max Frye','John Sayles','Gina Gionfriddo','Chase Palmer','Stuart Carolan','Alyson Feltes','Tom Smuts','Amy Berg'],
music:['Rupert Gregson-Williams','Bobby Krlic'],
camera:['P.J. Dillon','Gavin Struthers','Chris Seager','Larry Smith','Cathal Watters','Alejandro Martínez'],
cut:['Nick Arthurs','Martin Nicholson','Philip Kloss','Matt Platts-Mills','Tanya M. Swerling','Katie Weiland','Dermot Diskin','Cheryl Potter','Liyana Mansor','Jay Prychidny'],
sound:['Matthew Skelding','Eilam Hoffman','Steve Browell','Adam Rooner','Richard Davey','Alastair Sirkett','Doug Cooper'],
scenography:['Mara LePere-Schloop','Will Hughes-Jones','Ruth Ammon','Zsuzsanna Sipos','Alice Baker','Stephan O. Gessler','Alessandro Troso'],
masks:['Judit Hornyák','Rita Horváth','Gabriella Németh','Federico Carretti'],
costumes:['Michael Kaplan','Rudy Mance']},
{title:'Soul Eater',
titleCZ:'Bohové smrti',
year:2008,
runtime:'20h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy','Comedy'],
director:['Takuja Igaraši','Šingo Kaneko','Tensai Okamura','Šin Macuo','Daisuke Čiba','Sóiči Masui','Mičio Fukuda','Takefumi Anzai','Tošinori Narita','Ikuró Sató','Ken Andó','Makoto Fučigami','Hiroja Saitō','Micuhiro Joneda','Jošijuki Asai','Šindži Išihira','Kunihiko Ikuhara',"Šin'iči Tókairin",'Kacumi Terahigaši'],
actors:['Čiaki Omigawa','Akeno Watanabe','Hóko Kuwašima','Džunko Noda','Maaja Sakamoto','Takehito Kojasu',"Ken'iči Suzumura",'Kendžiró Cuda',"Šin'ičiró Miki",'Šózó Iizuka','Kóki Učijama','Mamoru Mijano','Čieko Honda','Emiri Kató','Jumiko Kobajaši','Jukana','Hiro Šimono','Džódži Nakata','Nobutoši Kanna','Majuki Makiguči','Čiwa Saitó','Jasunori Macumoto','Hirojuki Jošino','Ako Majama','Kacuhisa Hóki','Hóčú Ócuka','Kóiči Sakaguči','Jošinori Fudžita','Šunzó Mijasaka','Takaši Inagaki','Kaori Nazuka','Júja Učida','Ajaka Saitó','Reiko Suzuki','Takahiko Sakaguma','Masanori Takeda','Rintaró Niši','Cuguo Mogami','Óki Sugijama','Kanae Oki','Misato Fukuen','Tošio Furukawa','Motoko Kumai','Hirofumi Nodžima','Hisafumi Oda','Tóru Ókawa',"Ken'ičiró Macuda",'Tomie Kataoka','Masafumi Kimura',"Ken'iči Močizuki",'Rjúiči Azuma','Hiroši Cučida','Ao Takahaši','Rikija Kojama','Takuró Kitagawa','Jóhei Tadano','Satoru Inoue','Acuši Ono','Ken Uo','Acuši Ii','Keidži Himeno','Masao Harada','Tecuo Gotó','Hiromu Mijazaki','Hideki Nakaniši','Kanako Tódžó','Izumi Koike','Kensuke Niši','Eisuke Asakura','Hisajo Močizuki','Rjó Agawa','Júko Kató','Kacunori Kobajaši',"Ken'iči Morozumi",'Čikao Suzumura','Šinsuke Sakuragi','Narumi Takahira','Majumi Asano','Wataru Hatano','Ikuja Sawaki','Mičiko Neja','Júki Tokura','Tomoe Hanba','Jasujuki Kase','Kenta Mijake'],
basedOn:['Acuši Ókubo'],
screenplay:['Akacuki Jamatoja','Megumi Šimizu'],
production:['Jošihiro Ójabu','Taihei Jamaniši','Aja Jošino'],
music:['Taku Iwasaki'],
camera:['Johei Mijahara','Cujoši Kanbajaši'],
cut:['Šigeru Nišijama'],
sound:['Kazuhiro Wakabajaši'],
scenography:['Norifumi Nakamura']},
{title:'The Melancholy of Haruhi Suzumiya',
titleCZ:'Suzumija Haruhi no júucu',
year:2006,
runtime:'5h 22min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Comedy','Psychology','Sci-Fi'],
director:['Tacuja Išihara','Jasuhiro Takemoto','Jutaka Jamamoto','Šinobu Jošioka','Taiči Išidate','Masaharu Watanabe','Tomoe Aratani','Norijuki Kitanohara','Kazuja Sakamoto'],
actors:['Aja Hirano','Minori Čihara','Juki Macuoka','Akio Ócuka',"Ken'iči Ogata",'Takeši Aono','Júki Ono','Tomokazu Sugita','Tošijuki Morikawa','Júko Gotó','Mai Kadowaki','Kazuhiko Inoue','Eidži Janagisawa','Jasuhiro Fudžiwara','Kóki Harasawa','Megumi Macumoto','Nacuko Kuwatani','Rjóko Nagata','Sajaka Aoki',"Ken'iči Močizuki",'Kimiko Saitó','Daisuke Ono','Takamasa Óhaši','Minoru Širaiši','Hidehiko Kaneko','Juri Širatori','Nobujuki Kobuši','Sara Nakajama','Hirokazu Hiramacu','Aiko Hibi','Riiči Nišimoto','Akane Ómae','Júiči Išigami','Micuaki Furuja','Daisuke Išikawa','Mina Hiroe'],
basedOn:['Nagaru Tanigawa'],
screenplay:['Fumihiko Šimo','Acuši Itó','Kacuhiko Muramoto','Jutaka Jamamoto','Tacuja Išihara','Nagaru Tanigawa','Šódži Gató'],
music:['Satoru Kósaki'],
camera:['Jošiko Tanaka'],
cut:['Kengo Šigemura'],
sound:['Jóta Curuoka'],
scenography:['Seiki Tamura']},
{title:'McMafia',
titleCZ:'McMafie',
year:2018,
runtime:'7h 50min',
episodeRuntime:'55-60min',
countries:['UK','USA'],
genres:['Crime','Drama','Thriller'],
director:['James Watkins'],
actors:['James Norton','David Strathairn','Juliet Rylance','Alexej Serebrjakov','Marija Šukšina','David Dencik','Oshri Cohen','Tim Ahern','Andrew Alexander','Maro Drobnic','Amir El-Masry','Sam Hoare','Faye Marsay','Merab Ninidze','Clifford Samuel','Yuval Scharf','Karel Roden','Jelena Ljadova','Irina Kara-Mosko','Caio Blat','Sofja Lebeděva','Kemi-Bo Jacobs','Nawazuddin Siddiqui','Hoji Fortuna','Fernando Cayo','Goran Navojec','Itzik Cohen','Alexandr Ďjačenko','Lidija Fedosejeva-Šukšina','Ohad Knoller','Joshua James','Marek Vašut','David Menkin','Peter Buchta','Tjasa Perko','Vikash Bhai','Danila Kozlovskij','Charlotte Hamblin','Anna Krippa','Františka Brzobohatá','Francisco Labbe'],
basedOn:['Misha Glenny'],
screenplay:['James Watkins','Hossein Amini','Laurence Coriat'],
music:['Tom Hodge','Franz Kirmann'],
camera:['Mark Patten'],
cut:['Jon Harris','Stuart Gazzard'],
sound:['Ben Barker'],
scenography:['Richard Bullock'],
masks:['Matthew Smith','Tina Jesenkovic'],
costumes:['Suzie Harman','Anthony Unwin']},
{title:'The Looney Tunes Show',
titleCZ:'Looney Tunes: Úžasná show',
year:2011,
runtime:'18h 47min',
episodeRuntime:'20-22min',
countries:['USA'],
genres:['Animation','Comedy','Family'],
director:['Matt Danner','Jeff Siergey','Swinton O. Scott III','Spike Brandt','Tony Cervone','Mauricio Pardo','Keith Baxter','Seth Kearsley','Ethan Spaulding','Chris Headrick','Kyungsook Hwang','Joseph Balderas'],
actors:['Jeff Bergman','Bob Bergen','John Kassir','Kristen Wiig','Joe Alaskey','Fred Armisen','Jim Cummings','June Foray','Maurice LaMarche','Billy West','Tara Strong','René Auberjonois','Ben Falcone','Timothy Brennen','Brian Regan','Estelle Harris','Damon Jones','Kevin Michael Richardson','Kevin Shinick','Eric Bauza','Steve Hytner','Hugh Davidson','Larry Dorf','Rachel Ramras',"John O'Hurley",'Candi Milo','Kwesi Boakye','Steve Mallory','Jess Harnell','Rob Paulsen','Grey Griffin','Paul Julian','Jeff Bennett','Cree Summer','Roz Ryan','Carlos Alazraqui','Dee Bradley Baker','Jennifer Esposito','Garry Marshall','Powers Boothe','Tony Cervone','Mindy Sterling','Wendi McLendon-Covey','Annie Mumolo','Jim Rash','Barry Corbin','Dennis Farina','John DiMaggio','Katy Mixon','Chuck Deezy','Sonya Walger','Stephanie Courtney'],
screenplay:['Doug Langdale','Hugh Davidson','Larry Dorf','Rachel Ramras','Jim Cashman','Ben Falcone','Mark Banker','Seth Kearsley','Pat Devine'],
production:['Hugh Davidson','Rachel Ramras','Matt Danner','Spike Brandt','Tony Cervone'],
music:['Jason Brandt','Andy Sturmer','Damon Jones'],
cut:['Craig Paulsen'],
sound:['Carlos Sanches','Josh Eckberg','Otis Van Osten'],
scenography:['Alan Bodner','John Calmette']},
{title:'Shetland',
titleCZ:'Vraždy na Shetlandech',
year:2013,
runtime:'42h 42min',
episodeRuntime:'53-60min',
countries:['UK'],
genres:['Crime','Drama'],
director:['Peter Hoar','John McKay','David Moore','Stewart Svaasand',"Thaddeus O'Sullivan",'Jan Matthys','Lee Haven Jones','Gordon Anderson','Max Myers','Siri Rodnes','Fiona Walton','Andy Newbery','Giulia Gandini'],
actors:['Douglas Henshall','Steven Robertson','Gemma Chan','Alexander Morton','Alison Peebles','Anthony Flanagan','Martin Wenner','Jordan Young','Lewis Howden','Kari Corbett','Sandra Voe','Anthony Howell','Jack Greenlees','Mark Bonnar','Jim Sturgeon','Robert Yates','Forbes Masson','Chris Reilly','Jamie Michie','Struan Rodger',"Colette O'Neil",'James Greene','Rebecca Benson','Sophie Rundle','Steven Cree','Sara Vickers','Michael Nardone','Iain Robertson','Barbara Rafferty','Lorne MacFadyen','Annie Louise Ross','Gerda Stevenson','Leanne Best','Brian Cox','Frances Grey','Julie Graham','Nina Sosanya','David Hayman','Clive Russell','Alex Norton','John Lynch','Bill Paterson','Susan Vidler','Peter Capaldi','Ciarán Hinds','Bryan Larkin','Ralph Riach','Saskia Reeves','Archie Panjabi','John Stahl','James Cosmo','Mark Cox','Anna Chancellor','Ace Bhatti','Claire Dargo','Kevin Mains','Nathan Welsh','Sophie Stone','David Ireland','Carolin Stoltz',"Alison O'Donnell",'Owen Whitelaw','Isabelle Joss','Robin Laing','Catherine Walker','Derek Riddell','Rakie Ayola','Marnie Baxter','Ryan Fletcher','Geraldine Alexander','Julia Brown','Eldar Skar','Lorn Macdonald','Michael Moreland','Julie Hale','Jana Reinermann','Daniel Stisen','Ben Bradley','Claire Rafferty','Neve McIntosh','Kate Bracken','Thoren Ferguson','Lewis Gribben','Alec Newman','Anneika Rose','Lois Chimimba','Stephen McCole','Sophia Carr-Gomm','Erin Armstrong','John-Paul Hurley','Gerard Miller','Jessica Hardwick','Hannah Donaldson','Kate Donnelly','Finlay Welsh','Shonagh Price','Gail Watson','Frank Gilhooley','John Buick','Sandy Welch'],
basedOn:['Ann Cleeves'],
screenplay:['Gaby Chiappe','David Kane','Paul Logue','Robert Murphy','Louise Ironside','Denise Paul','Vivienne Harvey'],
production:['Eric Coulter','Louise Say'],
music:['John Lunn'],
camera:['Jean-Philippe Gossart','Gavin Struthers','Cinders Forshaw','Stijn van der Veken','Ed Moore','Tim Palmer','Bjørn Ståle Bratberg'],
cut:['Vicky Tooms','Joris Brouwers','Colin Monie','Ben Lester','Elen Pierce Lewis','David Fisher','Rob Garwood','Tim Porter','Johannes Bock','Helen Murphy'],
sound:['Richard Davey','Alessio Masi'],
scenography:['Mike Gunn','Rebecca Pilkington','Suzanne Field'],
masks:['Cecilie Aadnevik','Julie Dorrat-Keenan'],
costumes:['Rhona Russell','Louise Allen','Lesley Abernethy']},
{title:'Healer',
titleCZ:'Hojič',
year:2014,
runtime:'20h 39min',
episodeRuntime:'60-64min',
countries:['South Korea'],
genres:['Drama','Mystery','Romance','Comedy'],
director:['Jung-seob Lee','Jin-woo Kim'],
actors:['Chang-wook Ji','Min-yeong Park','Tae-m','Ji-won Do','Sung-bum Jang','Gyoo-soo Jeong','Mi-kyeong Kim','Kwang-rok Oh','Sang-myeon Park','Sang-wook Park','Won-sang Park','Hee-jin Woo','Ji-tae Yoo','Han-cheol Jo','Il-joo Ji','Moon-shik Lee','Yeong-jin Jo','Hye-bin Jeon','Jong-won Choi','Bit-na Wang','Hyeon Woo','Woo-rim Ko','Seung-woo Lee','Ri-na Kim','Kyu-ho Lee','Kyeong-shim Lee','Seung-won Son','Hye-in Jeong','Ji-in Song','Jong-hyuk Oh','Sang-won Park'],
screenplay:['Ji-na Song']},
{title:'Yona of the Dawn',
titleCZ:'Akacuki no Jona',
year:2014,
runtime:'9h 36min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy','Romance'],
director:['Kazuhiro Joneda','Takaši Andó','Ken Andó','Fumija Hódžó','Masato Mijoši','Júsuke Marujama'],
actors:['Tomoaki Maeno','Čiwa Saitó',"Džun'iči Suwabe",'Nobuhiko Okamoto','Ai Kajano','Šigeru Čiba','Ajahi Takagaki','Hidejuki Hori','Takahiro Sakurai','Džunko Minagawa','Hiro Šimono','Hirojuki Jošino','Takahiro Mizušima','Masaki Aizawa','Nozomi Jamamoto','Jošiko Sakakibara','Rikako Jamaguči','Susumu Akagi','Júsuke Kobajaši',"Džun'iči Janagita","Džu'iči Kanemaru",'KENN','Kazutomi Jamamoto','Kokoro Kikuči','Masakazu Morita','Hisao Egawa','Minami Šinoda','Maja Enojoši','Eidži Takeuči','Daiči Hajaši','Haruka Čisuga','Asuna Tomari','Šúsaku Širakawa','Eiičiró Tokumoto','Kacuhiko Sasaki','Anna Mugiho','Kazuhiro Nakaja','Hirojuki Endó','Jóhei Osa','Nobuo Tobita','Šóto Kašii','Tóru Ókawa','Hanako Omine','Haruna Kawai'],
basedOn:['Mizuho Kusanagi'],
screenplay:['Nacuko Takahaši','Šinsuke Óniši',"Šin'iči Inozume",'Seiko Takagi','Tadaši Morišita'],
production:['Yoshito Danno',"Šin'ičiró Kitazawa",'Hadžime Marujama'],
music:['Kunihiko Rjó'],
camera:['Tóru Fukuši'],
cut:['Kumiko Sakamoto'],
sound:['Jukio Nagasaki'],
scenography:['Mičie Watanabe']},
{title:'Koi Kaze',
titleCZ:'Koi kaze',
year:2004,
runtime:'5h 25min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Drama','Psychology','Romance'],
director:['Takahiro Ómori','Macuo Asami','Tomoaki Óta','Takacugu Kobajaši'],
actors:['Šizuka Itó','Akemi Okamura','Miju Macuki','Rjóka Juzuki','Satomi Akesaka','Kenta Mijake','Haruhi Nanao','Rjóiči Tanaka','Rjókiči Takahaši','Kósuke Okano','Risa Šimizu','Kumiko Itó','Takafumi Kawakami','Kunihiro Kawamoto','Jukimasa Obi','Riiči Nišimoto','Kazuja Kobajaši','Júko Kató','Miharu Iidžima'],
basedOn:['Motoi Yoshida'],
screenplay:['Noboru Takagi'],
music:['Jošimori Makoto','Masanori Takumi'],
camera:['Naojuki Óba'],
cut:['Jasuaki Takeuči'],
sound:['Jošikazu Iwanami'],
scenography:['Čikara Nišikura']},
{title:"Agatha Christie's Poirot",
titleCZ:'Hercule Poirot',
year:1989,
runtime:'85h 4min',
episodeRuntime:'47-105min',
countries:['UK'],
genres:['Crime','Drama','Mystery','Thriller'],
director:['Edward Bennett','Renny Rye','Andrew Grieve','Brian Farnham','Richard Spence','Andy Wilson','Ashley Pearce','Ross Devenish','Andrew Piddington','Peter Barber-Fleming','John Bruce','Ken Grieve','Hettie MacDonald','Charlie Palmer','Stephen Whittaker','Tom Clegg','David Moore','Paul Unwin','Simon Langton','Sarah Harding','Maurice Phillips','James Kent','Dan Reed','Philip Martin','Peter Lydon','John Strickland','Tom Vaughan'],
actors:['David Suchet','Hugh Fraser','Philip Jackson','Pauline Moran','David Yelland','Zoë Wanamaker','Richard Bebb','George Little','Phillip Manikum','Jona Jones','Patrick Ryecart','Sean Pertwee','Beatie Edney','Simon Shepherd','Carol MacReady','Danny Webb','Phyllida Law','Frances Barber','Fenella Woolgar','Frances Low','Rachael Stirling','James Fox','Jenny Agutter','Tim Curry','Harriet Walter','Amelia Bullmore','Martin Shaw','Helen Baxendale','Adrian Lukis','Jon Cartwright','Vernon Dobtcheff','Diane Fletcher','Ann Morrish','Oliver Ford Davies','Aidan Gillen','Megan Dodds','Emma Griffiths Malin','Robert Bathurst','Alice Eve','Patrick Baladi','Rupert Evans','Chris Gordon','Annabel Mullion','Niamh Cusack','Polly Walker','Donald Sumpter','Ann Bell','Anna Chancellor','Malcolm Terris','Kelly Reilly','Toby Stephens','JJ Feild','Sarah Miles','Anna Calder-Marshall','Art Malik','Lorna Nickson Brown','Richard Dixon','Brigit Forsyth','Alan Howard','Peter Settelen','John Harding','Kika Markham','Christopher Eccleston','Nathaniel Parker','Kevork Malikyan','Hermione Norris','Sara Stewart','Ben Pullen','Geraldine Somerville','Jamie Bamber','Flora Montgomery','Elspet Gray','Robert Wisdom','Andrée Bernard','David Burke','Hana Bělská','Michael Fassbender','Elliot Cowan','Jonathan Firth','Serena Scott Thomas','Terence Beesley','Daisy Beaumont','Dorian Healy','Tom Wisdom','Sarah Smart','Jonathan R. Scott','Christopher Gunning','Katie Leung','Vincent Riotta','Julian Rhind-Tutt','Claire Skinner','Zoe Telford','Jason Watkins','William Hootkins','Benjamin Whitrow','Phil Daniels','Paul Geoffrey','Jenny Downham','Vanessa Kirby','David Bowles'],
basedOn:['Agatha Christie','Agatha Christie'],
screenplay:['Clive Exton','Anthony Horowitz','David Renwick','Guy Andrews','Michael Baker','Peter Flannery','Mark Gatiss','Stephen Wakelam','Philomena McDonagh','Douglas Watkinson','Kevin Elyot','Nick Dear','Stewart Harcourt','Ian Hallard','David Pirie','Russell Murray','David Reid'],
production:['Brian Eastman','Trevor Hopkins','Karen Thrussell','David Boulter','Margaret Mitchell'],
music:['Christopher Gunning','Christian Henson','Stephen McKeon'],
camera:["Chris O'Dell",'Ivan Strasburg','Norman Langley','Peter Jessop','Peter Bartlett','Alan Almond','Vernon Layton','Martin Fuhrer','Peter Greenhalgh','Jason Lehel','Simon Kossoff','Cinders Forshaw','Kevin Rowley','Fred Tammes','James Aspinall','David Higgs','David Marsh','Sue Gibson','Paul Bond','Gavin Finney','Niels Reedtz Johansen','Ian Moss','Zac Nicholson','Norman G. Langley'],
cut:['Chris Wimble','Kristina Hetherington','Adam Recht','Tania Reddin','Andrew McClelland','Jamie McCoan','Paul Garrick','Matthew Tabern','Michael Harrowes','Richard Elson','David Blackmore','Adam Bosman','Roger Wilson','Melanie Viner-Cuneo','Derek Bain','Jon Costelloe','Paul Hudson','Frank Webb','David Rees','Max Lemon'],
sound:['John Downer','Gareth Bull'],
scenography:['Michael Pickwoad','Paul Spriggs','Rob Harris','Tim Hutchinson','Jeff Tessler','Rob Hinds','Mark Rimmell','Mike Oxley','Desmond Crowe'],
masks:['Karen Cohen','Jane Tyler','Marc Pilcher','Siân Miller','Roseann Samuel'],
costumes:['Barbara Kronig','Sheena Napier','Sue Thomson','Charlotte Holdich','Linda Mattock','Andrea Galer']},
{title:'The Smurfs',
titleCZ:'Šmoulové',
year:1981,
runtime:'90h 10min',
episodeRuntime:'12-23min',
countries:['USA','Belgium'],
genres:['Animation','Family','Fantasy'],
director:['Ray Patterson','Carl Urbano','Don Lusk','Bob Goe','Paul Sommer','Bob Hathcock','John Walker','Robert Alvarez','Tayk Kim','Joan Drake'],
actors:['Don Messick','Danny Goldman','Lucille Bliss','Frank Welker','Michael Bell','June Foray','Hamilton Camp','William Callaway','Alan Oppenheimer','Alan Young','Charlie Adler','Brenda Vaccaro','Les Tremayne','Phil Hartman','Jonathan Winters','Rob Paulsen','Tress MacNeille','Russi Taylor','Walker Edmiston','Keene Curtis','Ed Begley Jr.','William Christopher','Michael Lembeck','Peter Cullen','Lewis Arquette','Henry Gibson','Lennie Weinrib','John Ingle','René Auberjonois','Gregg Berger','Janet Waldo','Richard Dysart','Avery Schreiber','Aron Kincaid','Sorrell Booke','Mary Jo Catlett','William Schallert','Arte Johnson','Ronnie Schell','Marvin Kaplan','Roger C. Carmel','Joseph Ruskin','Richard Erdman','Hal Smith','Kip King','Peggy Webber','Marcelo Tubert','Phil Proctor','Edie McClurg','Lars Junker Thiesgaard','Niels Weyde','Teresa Ganzel','Sidney Miller','Ruth Buzzi','Regis Cordic','Bernard Behrens','Henry Corden','Ernest Harada','Marshall Efron','Susan Blu','Peter Zhelder','Ray Walston','Joseph G. Medalis','Tandy Cronyn','Kath Soucie','Richard McGonagle','Patrick Pinney','Pat Musick','Paul Eiding','Pat Fraley','Kenneth Mars','John Stephenson','Tony Jay','George Takei','Franklyn Seales','Clive Revill','Chuck McCann','Keye Luke','Robbie Lee','Ed Gilbert','Barry Dennen','Jim Cummings','Townsend Coleman','Clare Peck','Linda Gary','Marilyn Lightstone','Mona Marshall','Bever-Leigh Banfield','Diane Pershing','Susan Silo','Katie Leigh','Noelle North','Will Ryan','Michael Rye','Brian Cummings','Leo DeLyon','Jennifer Darling','Danny Mann','Neil Ross','Allan Melvin'],
basedOn:['Peyo'],
screenplay:['Peyo','Burt Wetanson','John Loy','Kevin Hopps','Earl Kress','Alan Burnett','Dean Stefan','Vin Morreale Jr.','Paul Dini','Allan Cole','Glenn Leopold','Frances Novier','John Bonaccorsi','Sean Catherine Derek','Ernie Contreras','Reed Robbins','Chris Otsuki','Gene Ayres','Ken Koonce','Meg McLaughlin','Mark W. Nelson','Craig Miller','Mark Seidenberg','David Weimers','Richard Merwin','Patsy Cameron','Cynthia Friedlob','John Semper','Terrie Collins','Rich Fogel','Evelyn Gabai',"Jeffry O'Hare",'Tedd Anasti','Charles M. Howell IV','Dick Robbins','Kristina Luckey','John Ludin','Gordon Bressack'],
production:['Gerard Baldwin','Bob Hathcock','Paul Sabella','Don Jurwich','Walt Kubiak'],
music:['Hoyt Curtin','Clark Gassman'],
cut:['Gil Iverson'],
sound:['Stan Wetzel']},
{title:'The New Pope',
titleCZ:'Nový papež',
year:2020,
runtime:'8h 17min',
episodeRuntime:'48-61min',
countries:['Italy','France','Spain','USA'],
genres:['Drama'],
director:['Paolo Sorrentino'],
actors:['Jude Law','John Malkovich','Silvio Orlando','Cécile de France','Javier Cámara','Ludivine Sagnier','Maurizio Lombardi','Nora von Waldstätten','Henry Goodman','Mark Ivanir','Massimo Ghini','Antonio Petrocelli','Kiruna Stamell','Kika Georgiou','Massimo Cagnina','Tony Allotta','Nadie Kammallaweera','Tomas Arana','Daria Baykalova','Christian Erickson','Emmanuel Dabone','Luciano Roffi','Osvaldo Alzari','Sergio Forconi','Guido Roncalli','Libero Sansavini','Claudio Bigagli','Ignazio Oliva','Agnieszka Jania','Jessica Piccolo Valerani','Alessandro Riceci','Ulrich Thomsen','Marcello Marziali','Federica Corti','Daniel Vivian','Marcello Romolo','Francesca Cutolo','Janet Henfrey','Tim Barlow','Alex Esola','David Sebasti','J. David Hinze','Julia Snigir','Sinne Mutsaers','Vito Abbonato','Matthew T. Reynolds','Marilyn Manson','Sharon Stone','Mitchell Mullen','Laura Schettino','Husam Chadat','Bruce McGuire','James Cromwell','Diane Keaton','Olivia Macklin','Enea Barozzi','Eco Andriolo','Giulio Della Monica','Gianluigi Calvani','Marina Viro'],
screenplay:['Paolo Sorrentino','Umberto Contarello','Stefano Bises'],
production:['Mauro Monachini'],
music:['Lele Marchitelli'],
camera:['Luca Bigazzi'],
cut:['Cristiano Travaglioli'],
sound:['Michele Mazzucco','Paolo Segat'],
scenography:['Ludovica Ferrario','Tanya Bowd','Eugenia F. Di Napoli','Massimo Pauletto','Anna Sheldrake','Laura Casalini'],
masks:['Duncan Jarman','Maria Sansone','Giuliana Lavinia','Marco Perna','Domingo Santoro'],
costumes:['Carlo Poggioli']},
{title:'The Big C',
titleCZ:'Ve znamení raka',
year:2010,
runtime:'20h 16min',
episodeRuntime:'25-57min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Michael Engler','Craig Zisk','Tricia Brock','Michael Lehmann','Alan Poul','Miguel Arteta','Anna Boden','Ryan Fleck','Bill Condon','Jennifer Getzinger','Richard Heus','Jann Turner','Adam Bernstein'],
actors:['Laura Linney','Oliver Platt','Gabriel Basso','John Benjamin Hickey','Gabourey Sidibe','Phyllis Somerville','Cynthia Nixon','Reid Scott','Hugh Dancy','Susan Sarandon','Boyd Holbrook','Lee Tergesen','Alan Alda','Idris Elba','Parker Posey','Mamie Gummer','Tammy Blanchard','Phill Lewis','Marcia DeBonis','Brittany Underwood','Hamish Linklater','Eric Sheffer Stevens','Michael Chernus','Teena Byrd','Emily Kinney','Luis Da Silva Jr.','David Schallipp','Allison Janney','J. Smith-Cameron','Olivia Oguma',"Booch O'Connell",'Catherine Manett','Annaleigh Ashford','Liz Holtan','Ramsey Faragallah','Finnerty Steeves','James Colby','Samantha Futerman','Michael Ray Escamilla','Jenilyn Rodriguez','Betsy Aidem',"Brian d'Arcy James",'Ben Levin','Tom Morrissey','Lauren Mizenko','Jimmy Navarro','Madison Arnold','Emily Tremaine','Connie Ray','Ned Eisenberg','Peggy J. Scott','Nadia Dajani','Mike Houston','Bill Heck','Tyler Maynard','Lee Aaron Rosen','Deborah Hedwall','Jaiden Kaine','Susan Blommaert','Myra Lucretia Taylor','David Wilson Barnes','Alexandra Socha','Joe Urla','Wally Dunn','Brandyn T. Williams','Brandon J. Dirden','Nathan Eswine','Keala Settle','Kailie Torres','Mary Joy','Preston Sadleir','Angela Lin','Isaac Mizrahi','David Hull','Jonathan Walker','Annie Parisse','Jessica Carlson','Scott Terra','Brian Cox','Liam Neeson','Polly Draper','Kathy Najimy','Heather MacRae','Bianca Amato','Dana Ivey','Darlene Hunt','Brian Dennehy','Marceline Hugot','David Aaron Baker','Rosemary Howard','Laura Jordan','Ben Sinclair','Seana Kofoed','Jason Antoon','Laura Benanti','Val Emmich','Victor Garber','Geoffrey Cantor','Liz Twining','Billy Porter'],
screenplay:['Mark J. Kunerth','Cara DiPaolo','Hilly Hicks Jr.','Jenny Bicks','Darlene Hunt','Toni Kalem','Melanie Marnich','Cusi Cram'],
production:['Lou Fusaro','Cara DiPaolo','Melanie Marnich','Elicia Bessette'],
music:['Marcelo Zarvos','Eric V. Hachikian','Jesse Voccia'],
camera:['Tobias A. Schliessler','John Thomas','Michael Caracciolo'],
cut:['Jonathan Schwartz','Brian A. Kates','Michael D. Ornstein','Carol Stutz','Byron Smith','Annette Davey','Sunny Hodge','David Dworetzky'],
sound:['Nick Offord','Michael J. Benavente','Todd Beckett','Fred Tator','Derek Marcil','Nello Torri','Robert Getty','David B. Cohn','Blake Marymor',"Terry O'Bright",'Joe White',"T.J. O'Mara",'Kim Maitland'],
scenography:['Michael Shaw','Edward Pisoni','Shelley Barclay'],
masks:['Kimberley Spiteri','Rachel Geary'],
costumes:['Christie Wittenborn','Tom Broecker','Jacqueline Demeterio']},
{title:'Criminal: UK',
titleCZ:'Criminal: Velká Británie',
year:2019,
runtime:'5h 14min',
episodeRuntime:'42-48min',
countries:['UK'],
genres:['Drama','Crime'],
director:['Jim Field Smith'],
actors:['David Tennant','Daniel Chamorro','Lee Ingleby','Katherine Kelly','Nicholas Pinnock','Mark Stanley','Hayley Atwell','Clare-Hope Ashitey','Youssef Kerkour','Lolita Chakrabarti','Rochenda Sandall','Kit Harington','Kunal Nayyar','Sharon Horgan','Sophie Okonedo','Aymen Hamdouchi','Rakhee Thakrar','Shubham Saraf','Amanda Drew','Jyuddah Jaymes','Annette Badland','Joakim Skarli'],
screenplay:['George Kay'],
production:['Georgie Fallon'],
music:['Robin Foster'],
camera:['Jamie Cairney'],
cut:['David Webb'],
sound:['Stefano Marchetti'],
scenography:['Alejandro Fernández','Jonathan Paul Green'],
costumes:['Irene Orts']},
{title:'The Life of Verdi',
titleCZ:'Verdi',
year:1982,
runtime:null,
episodeRuntime:'9x90min',
countries:['Italy','France','Germany','UK'],
genres:['Drama','Biographic','Romance','Music'],
director:['Renato Castellani'],
actors:['Ronald Pickup','Carla Fracci','Omero Antonutti','Lino Capolicchio','Daria Nicolodi','Giampiero Albertini','Burt Lancaster','Jan Niklas','Luciano Pavarotti','Maria Callas','William Berger','Renzo Palmer','Leopoldo Trieste','Ugo Bologna','Giorgio Trestini','Adriana Innocenti','Agla Marsili','Paolo Gozlino','Anna Orso','Alfonso Giganti','Enzo Cerusico','Marc Smith','Jackie Basehart','Marne Maitland','Nino Dal Fabbro','Vanni Materassi','Corrado Olmi','Gualtiero Rispoli','Fernando Cerulli','Clara Colosimo','Eva Christian','Leyla Gencer','Giampiero Becherelli','Tito Schipa Jr.','Luciana Palombi','Dario Ghirardi','Lionello Pio Di Savoia','Renato Montanari'],
screenplay:['Leonardo Benvenuti'],
music:['Roman Vlad'],
camera:['Giuseppe Ruzzolini'],
cut:['Otello Colangeli'],
masks:['Mario Scutti','Manlio Rocchetti'],
costumes:['Maria De Matteis']},
{title:'Altered Carbon',
titleCZ:'Půjčovna masa',
year:2018,
runtime:'15h 36min',
episodeRuntime:'43-67min',
countries:['USA'],
genres:['Sci-Fi','Drama'],
director:['Miguel Sapochnik','Nick Hurran','Uta Briesewitz','Alex Graves','Andy Goddard','Peter Hoar','Ciaran Donnelly','M.J. Bassett','Jeremy Webb','Salli Richardson-Whitfield'],
actors:['Martha Higareda','Joel Kinnaman','James Purefoy','Stephanie Cleough','Ato Essandoh','Byron Mann','Andre Tricoteux','Matt Frewer','Renée Elise Goldsberry','Dichen Lachman','Fraser Aitcheson','Alyson Bath','Daniel Bernhardt','Glynis Davies','Olga Fonda','Victor Formosa','Marlene Forte','Teach Grant','Howie Lai','Paul Lazenby','Elfina Luk','Joel Montgrand','Leonardo Nam','Zahf Paroo','Tahmoh Penikett','Christian Sloan','Katie Stuart','Fiona Vroom','Colleen Wheeler','Waleed Zuaiter','Hayley Law','Will Yun Lee','Michelle Lee','Hannah Rose May','Chris McNally','Bruce Blain','Antonio Marziale','Yukari Komatsu','Kristin Lehman','Chris Conner','Richard Ian Cox','Nickolas Baric','Tamara Taylor','Hiro Kanagawa','Sean Amsing','Jillian Fargey','Garfield Wilson','Ken Kramer','Kat Pasion','Nicole Anthony','Anna Van Hooft','Michael Adamthwaite','Nikohl Boosheri','Demord Dann','Michael Eklund','Adam Busch','Jody Racicot','Seth Whittaker','Arnold Pinnock','Ben Wilkinson','Primo Allon','Cliff Chamberlain','Lexi Atkins','Alison Araya','Darren Dolynski','Rob Hayter','Toby Levins','Courtney Richter','Vivian Full','Anthony Mackie','John Emmet Tracy','Mauri Bernstein','Jason McKinnon','Celeste Ziegler','Kareem Malcolm','Torben Liebrecht','Lela Loren','Simone Missick','Oliver Rice','James Saito','Dina Shihabi','Bradley Stryker','Neal McDonough','Kwasi Thomas','Sen Mitsuji','Secudži Sató','Orphée Ladouceur-Nguyen','David Milchard','Damon Lipari','Alexander Lowe','Nalani Wakita','Darien Martin','Nyla Alleyne','Kat Ruston','Chelsea Gill','Heather-Claire Nortey','Craig Haas','Franckie Francois','Francisco Trujillo','Nia Cummins'],
basedOn:['Richard Morgan'],
screenplay:['David H. Goodman','Laeta Kalogridis','Steve Blackman','Brian Nelson','Russel Friend','Garrett Lerner','Alison Schapker','Sang Kyu Kim','Cori Uchida','Casey Fisher'],
production:['Bradley J. Fischer','Johanna Lee','Cori Uchida'],
music:['Jeff Russo','Jordan Gagne'],
camera:['Martin Ahlgren','Neville Kidd','P.J. Dillon','Bernard Couture'],
cut:['Byron Smith','Barry Alexander Brown','Jonathan Chibnall','Julian Clarke','Stephen Philipson','Erin Deck','Geoff Ashenhurst','Amy M. Fleming','Jay Prychidny'],
sound:['Andy King','Keith Rogers','Brett Hinton','Steve Foster','Kirk Lynds'],
scenography:['Carey Meyer','David Clarke','Colin De Rouin','Lisa Pouliot'],
masks:['Kat Kou','Krista Seller','Florencia Cepeda','Darci Jackson','Lil Batista','Mariah Crawley','Rebekah Bak','Leanne Rae Podavin','Chris Bennett','Kelly Grange','Cayley Giene','Vicki Syskakis'],
costumes:['Christine Wada','Ann Foley','Cynthia Ann Summers']},
{title:'Moonlight',
titleCZ:'Za svitu měsíce',
year:2007,
runtime:'11h 32min',
episodeRuntime:'41-45min',
countries:['USA'],
genres:['Fantasy','Horror','Drama'],
director:['Rod Holcomb','Frederick E.O. Toye','Scott Lautanen','Michael Fields','Paul Holahan','Chris Fisher','Dennis Smith','Eric Laneuville','David Barrett','John T. Kretchmer','James Whitmore Jr.'],
actors:["Alex O'Loughlin",'Sophia Myles','Jason Dohring','Brian White','Shannyn Sossamon','Jacob Vargas','Holly Valance','Rudolf Martin','Tami Roman','Jordan Belfi','David Blue','Eric Winter','Sarah Foret','David Haley','Christopher Cousins','Edoardo Ballerini','Victoria Pratt','Robin Thomas','Daniel Goldman','Abigail Spencer','Claudia Black','Kathleen Munroe','Lorena Segura York','Jonathan LaPaglia','Lisa Sheridan','Shoshana Bush','Manuel Urrego','Martin Spanjers','Michelle Lee','Deanna Smith','Paul Rae','Karina Michel','Adele René','Alex Fernandez','Bonnie Burroughs','Ksenia Solo','Peyton List','Nick E. Tarabay','Patrick Fischler','Shelbie Bruce','Jill Latiano','Meredith Monroe','Elizabeth Tulloch','Heather Stephens','Brandon Molale','Alice Greczyn','Tiya Sircar','Nate Mooney','Mike Cochrane','Roy Vongtama','Amy Motta','Vlad Kozlov','Maurice Compte','Christopher Stapleton','Anthony Starke','Casey LaBow','Sean Wing','Bonnie Root','Ryan Caltagirone','Gideon Emery','Navid Negahban','Al Galvez','Haley Pullos','Kevin Weisman','Richard Cox','Luis Moncada','Elizabeth Chambers','Todd Giebenhain','Matt Riedy','Chase Kim','Gigi Rice','Mitch Eakins','Molly Culver','Brian Maillard','Chris Payne Gilbert','Christian Keyes','Lawrence Mandley','Hal Williams','Rachel Kimsey','Brian Oerly','Vincent De Paul','Wes Robinson','Mark D. Espinoza','Robert Noble','Anthony Molinari','Jeremy Denzlinger','Greg Pitts','Josh Clark','Josh Kelly','James C. Victor','Marques Johnson','Bill Parks','Dierdre Holder','Jon Jon Briones','Bryan Rasmussen','Nancy Stelle','Justice Leak','Philip Maurice Hayes','Erika Ringor',"Dean O'Gorman"],
screenplay:['Josh Pate','Ron Koslow','Gabrielle G. Stanton','Chip Johannessen','Kira Snyder','David Greenwalt','Kay Reindl','Erin Maher','Jill E. Blotevogel','Trevor Munson'],
production:['Paul Kurta'],
music:['John Frizzell','Trevor Morris','Matthew Richard Harris'],
camera:['Marvin V. Rush','Thomas Del Ruth'],
cut:['Charles Bornstein','Sean Albertson','Scot J. Kelly','Michael D. Ornstein','Tod Feuerman','George Pilkinton'],
sound:['Rick Norman','Jon Mete'],
scenography:['Alfred Sole','Claire Kaufman','Christopher Marsteller','Tara Stephenson'],
masks:['Daniel Curet','Susan Kelber','Carol Collini'],
costumes:['Salvador Pérez Jr.']},
{title:'The English Game',
titleCZ:'Hra z Anglie',
year:2020,
runtime:'4h 46min',
episodeRuntime:'44-55min',
countries:['UK'],
genres:['Sport','Drama','History'],
director:['Birgitte Stærmose','Tim Fywell'],
actors:['Joncie Elmore','Kerrie Hayes','Tina Louise Owens','Lara Peake','Alec Newman','Richard McCabe','Anthony Andrews','Ben Ashenden','Ben Batt','Kate Dickie','Richard Dixon','Kevin Guthrie','Edward Holcroft','Charlotte Hope','Daniel Ings','Gerard Kearns','Sam Keeley','Sylvestra Le Touzel','Henry Lloyd-Hughes','Craig Parkinson','Kate Phillips','Niamh Walsh','Harry Michell','Mary Higgins','Tim Chipping','Michael Nardone','Natalie Gavin','Sammy Hayman'],
screenplay:['Oliver Cotton','Julian Fellowes','Geoff Bussetil','Sam Hoare','Ben Vanstone','Tony Charles','Gabbie Asher'],
music:['Harry Escott'],
camera:['Tony Miller'],
cut:['David Thrasher','Helen Murphy'],
scenography:['Faye Brothers','Melanie Allen'],
costumes:['Pam Downe']},
{title:'Wolf Hall',
titleCZ:'Wolf Hall',
year:2015,
runtime:'6h 30min',
episodeRuntime:'59-90min',
countries:['UK'],
genres:['Drama','History'],
director:['Peter Kosminsky'],
actors:['Mark Rylance','Damian Lewis','Claire Foy','Jonathan Pryce','Saskia Reeves','Jonathan Aris','David Bradley','Thomas Brodie-Sangster','Enzo Cilenti','Mark Gatiss','Bernard Hill','Emilia Jones','Anton Lesser','Alastair Mackenzie','Tim Plester','Jessica Raine','Luke Roberts','Ed Speleers','Karol Steele','Charity Wakefield','Joanne Whalley','David Robb','Edward Holcroft','Sam Alexander','Paul Ritter','Tom Holland','Mathieu Amalric','Jack Lowden','Natasha Little','Christopher Fairbank','Kerry Ingram','Sean Buckley','Will Keen','Elaine Caulfield','Samuel Bottomley','Lucy Russell','Monica Dolan','James Greene','Gus Barry','Dan Broderick','Richard Dillane','Martyn Mayger','Ian Barritt','Robert Wilfort','Richard Banks','Hannah Steele','Kate Phillips','Aimee-Ffion Edwards','Colin Taylor','Ben Ryan-Steele','James Laurenson','Harry Lloyd','Xavier Laurent','Stuart McNeil','Bryan Dick','Benjamin Whitrow','Miltos Yerolemou','Richard Durden','Janet Henfrey','Robert Rowe','Nigel Cooke','Paul Clayton','James Larkin','Iain Batchelor','Jacob Fortune-Lloyd','Emma Hiddleston','Max Fowler','Mary Jo Randle','Julian Gamm','Philippe Spall','Tom Forbes'],
basedOn:['Hilary Mantel'],
screenplay:['Peter Straughan'],
music:['Debbie Wiseman'],
camera:['Gavin Finney'],
cut:['Josh Cunliffe','David Blackmore'],
scenography:['Pat Campbell','Elaine McLenachan'],
masks:['Roseann Samuel'],
costumes:['Joanna Eatwell']},
{title:"No Man's Land",
titleCZ:'Země nikoho',
year:2020,
runtime:'6h 12min',
episodeRuntime:'42-53min',
countries:['France','USA','UK'],
genres:['Drama','Thriller'],
director:['Oded Ruskin'],
actors:['James Krishna Floyd','Julia Faure','Félix Moati','James Purefoy','Dean Ridge','Mélanie Thierry','Souheila Yacoub','Jo Ben Ayed','Sam Kalidi','Simon Harrison','Roda Canioglu'],
screenplay:['Amit Cohen','Ron Leshem'],
production:['Maria Feldman','Eitan Mansuri','Simon Arnal','Caroline Benjo','Jonathan Doweck'],
music:['Rutger Hoedemaekers'],
camera:['Stéphane Vallée'],
cut:['Boaz Mann','Omri Zalmona'],
scenography:['Pierre Renson'],
costumes:['Catherine Marchand']},
{title:'Last Exile',
titleCZ:'Last Exile',
year:2003,
runtime:'10h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Adventure','Fantasy','Sci-Fi'],
director:['Kóiči Čigira','Ei Aoki','Daisuke Čiba','Hirojuki Cučija','Jošihiko Iwata','Hirojuki Oči','Taiki Nišimura','Makoto Sokuza','Hirotaka Endó','Kandži Wakabajaši','Nobutoši Ogura'],
actors:['Majumi Asano','Čiwa Saitó','Džunko Noda',"Šin'ičiró Miki",'Tomokazu Seki','Unšó Išizuka','Kana Hanazawa','Tošijuki Morikawa','Rjúdži Mizuno','Tomoe Hanba','Eri Kitamura','Kazunori Itó','Hozumi Góda','Hiroši Naka','Kóiči Kitamura','Keiko Aizawa','Kenta Mijake','Naoki Makišima','Wakana Jamazaki','Jósuke Akimoto','Masaki Aizawa','Kódži Išii','Sacuki Jukino','Seiko Tomoe','Kijojuki Janada','Takehiro Kojama','Jasuhiko Tokujama','Hiroaki Išikawa','Nacuko Kuwatani','Kinrjú Arimoto','Ken Jamaguči','Rjóko Nagata','Kazuhiro Jamadži','Šigeru Šibuja','Makoto Higo','Tošihide Cušija','Šigenori Sója','Seika Kumagai','Jošito Išinami','Jasuo Iwata','Jumi Sudó',"Šin'ja Kitade",'Anna Širaki','Kódži Cudžitani','Micuo Iwata','Mičiko Neja','Šigeru Ušijama','Rei Igaraši','Kazuaki Itó','Tecuo Kanao','Jukana'],
screenplay:['Acuhiro Tomioka','Šúiči Kójama','Kóiči Čigira','Takaaki Suzuki','Tomohiro Jamašita'],
production:['Hirojuki Birukawa','Hisaši Imamoto'],
music:['Hitomi Kuroiši'],
camera:['Takaši Horiuči'],
cut:['Kengo Šigemura','Aja Hida'],
sound:['Jóta Curuoka'],
scenography:['Hiromasa Ogura']},
{title:'Death of an Expert Witness',
titleCZ:'Smrt soudního znalce',
year:1983,
runtime:'5h 50min',
episodeRuntime:'50min',
countries:['UK'],
genres:['Crime','Drama','Mystery'],
director:['Herbert Wise'],
actors:['Roy Marsden','Barry Foster','Geoffrey Palmer','Brenda Blethyn','Chloe Franks','John Vine','Cyril Cusack','Joy Allen','Malcolm Terris','Annabelle Lanyon','Ivor Roberts','Fiona Walker','Stacey Tendeter','Noel Johnson','John Cater','Janet Davies','Allan Mitchell','Ray Brooks','John Bryans','Rhoda Lewis','Andrew Ray'],
basedOn:['P. D. James'],
screenplay:['Robin Chapman'],
production:['John Rosenberg'],
music:['Richard Harvey']},
{title:'House of the Dragon',
titleCZ:'Rod Draka',
year:2022,
runtime:'20h 4min',
episodeRuntime:'51-67min',
countries:['USA'],
genres:['Action','Fantasy','Drama','Adventure'],
director:['Miguel Sapochnik','Greg Yaitanes','Clare Kilner','Geeta Vasant Patel','Alan Taylor'],
actors:['Paddy Considine','Olivia Cooke',"Emma D'Arcy",'Matt Smith','Steve Toussaint','Eve Best','Rhys Ifans','Sonoja Mizuno','Fabien Frankel','Milly Alcock','Emily Carey','Ryan Corr','Jefferson Hall','Graham McTavish','Matthew Needham','Bill Paterson','Gavin Spokes','Alexis Raben','Anthony Flanagan','Bijan Daneshmand','Nina Barker-Francis','Haqi Ali','Tom Glynn-Carney','Ewan Mitchell','John Macmillan','Phia Saban','Harry Collett','Bethany Antonia','Wil Johnson','Savannah Steyn','Frankie Wilson','Maddie Evans','Sian Brooke','Michael Carter','Steffan Rhodri','Elliott Tittensor','Julian Lewis Jones','Mikhail Sen','Gary Raymond','Andrew Bicknell','David Cann','David Horovitch','Theo Nate','Daniel Scott-Smith','Solly McLeod','Edward Rowe','Lucy Briers','Joanna David','Alana Ramsey','Clea Martin','Leo Hart','Harvey Sadler','Shani Smethurst','Ben Dilloway','Kurt Egyiawan','Ramzan Miah','Ty Tennant','Leo Ashton','Nanna Blondell','Paul Kennedy','Arty Froushan','Jordon Stevens','Sean Cernow','Rosa Escoda','Paul Hickey','Afolabi Alli','Phil Daniels','Evie Allen','Eva Ossei-Gerning','Luke Tittensor','Simon Chandler','Miriam Lucia','Paul Clayton','Nick Davison','Elliot Grihault','Phoebe Campbell','Owen Oakeshott','Max Wrottesley','Nicholas Jones','Michael Elwyn','Jason Lines','Aron von Andrian'],
basedOn:['George R.R. Martin'],
screenplay:['Ryan J. Condal','Miguel Sapochnik','Sara Hess','Kevin Lau','Ira Parker','Gabe Fonseca','Charmaine De Grate','Eileen Shim'],
production:['Alexis Raben','Karen Wacker','Kevin Lau','Gabe Fonseca'],
music:['Ramin Djawadi'],
camera:['Fabian Wagner','Pepe Avila del Pino','Alejandro Martínez','Catherine Goldschmidt'],
cut:['Tim Porter','Selina Macarthur','Crispin Green','Chris Hunter'],
sound:['Paula Fairfield','Alastair Sirkett','Doug Cooper'],
scenography:['Jim Clay','Claire Nia Richards','Andrew Ackland-Snow','Dan Clay','Fernando Contreras Díaz','Emma Goodwin','Stephen Swain'],
masks:['Ella Burton','Ian Grummit','Heather Manson','Harriet Thompson','Barrie Gower','Erika García'],
costumes:['Jany Temime']},
{title:'Spider-Man',
titleCZ:'Spiderman',
year:1994,
runtime:'22h 41min',
episodeRuntime:'20-21min',
countries:['USA'],
genres:['Action','Family','Animation','Crime','Thriller','Sci-Fi','Adventure','Fantasy','Romance','Drama'],
director:['Bob Richardson','Robert Shellhorn','Kevin Petrilak'],
actors:['Christopher Daniel Barnes','Sara Ballantine','Edward Asner','Roscoe Lee Browne','Jennifer Hale','Hank Azaria','Maxwell Caulfield','Jim Cummings','Gregg Berger','Martin Landau','Mark Hamill','Dorian Harewood','Walker Edmiston','Nichelle Nichols','Beverly Garland','Stephanie Romanov','Townsend Coleman','Paul Winfield','David Warner','John Phillip Law','Brian Keith','Richard Moll','Eddie Albert','Edward Albert','Jeff Corey','Carrie-Anne Moss','Caroline Goodall','Mira Furlan','Majel Barrett','George Takei','Courtney Peldon','Wanda De Jesus','Earl Boen','Efrem Zimbalist Jr.','Alyson Court','John Vernon','Dimitra Arliss','Rue McClanahan','David Hayter','John Beck','Alfonso Ribeiro','Joseph Campanella','Anne-Marie Johnson','Catherine Disher','Matthew McCurley','Robert Axelrod','George Buza','James Avery','Nita Talbot','Peter Mark Richman','Nick Jameson','Joseph Ruskin','Carl Ballantine','Tony Jay','Cedric Smith','Lawrence Mandley','Cain Devore','Susan Beaubian','Phil Proctor','Oliver Muirhead','Matthew Labyorteaux','Mary Kay Bergman','Michael Bell','Adam Hendershott','Nell Carter','Philip Abbott','Rick Dano','Barbara Goodson',"Laurie O'Brien",'Telma Hopkins','John Beard','Anthony Marciona','Cathal J. Dodd','Gary Imhoff','Lenore Zann','Stanley Ralph Ross','Kathy Garver','Rachel Davies','Iona Morris','Patrick Pinney','Rodney Saulsberry','Linda Gary','Gail Matthius','Cam Clarke','Michael Rye','Neil Ross','Patrick Labyorteaux','Edward Mulhare','Dawnn Lewis','Don Stark','Michael Horton','Nicky Blair','Rob Paulsen','Chris Potter','J.D. Hall','Malcolm McDowell','Leigh-Allyn Baker','Ed Gilbert','Scott Cleverdon','Bob Bergen'],
basedOn:['Stan Lee','Steve Ditko'],
screenplay:['James Krieg','Mark Hoffmeier','Tracey Forbes','Marv Wolfman','Ernie Altbacker','Marty Isenberg','Sean Catherine Derek','Michael Edens','Meg McLaughlin','Len Wein','Gordon Kent','John Semper','Larry Brody','Stan Berkowitz','Francis Moss','Elliot S. Maggin','Stephanie Mathison','Douglas Booth','Brooks Wachtel','Gerry Conway','Cynthia Harrison','Brynne Stephens','David Lee Miller','Lydia Marano','Carl Potts','Evelyn Gabai','Sandy Fries','Terence Taylor','Virginia Roth','Robert N. Skir'],
production:['John Semper','Stanley Liu','Bob Richardson'],
music:['Udi Harpaz','Shuki Levy','Haim Saban'],
sound:['Jim Hodson','Melissa Ellis','Bill Koepnick','Deb Adair'],
scenography:['Vladimir Spasojevic']},
{title:'Jack Ryan',
titleCZ:'Jack Ryan',
year:2018,
runtime:'25h 20min',
episodeRuntime:'40-65min',
countries:['USA'],
genres:['Action','Drama','Thriller'],
director:['Jann Turner','Daniel Sackheim','Patricia Riggen','Andrew Bernstein','Lukas Ettlin','Dennie Gordon','Kevin Dowling','Phil Abraham','Morten Tyldum','David Petrarca','Shana Stein','Carlton Cuse'],
actors:['John Krasinski','Wendell Pierce','Michael Kelly','Abbie Cornish','Betty Gabriel','John Hoogenakker','Ali Suliman','Nina Hoss','Dina Shihabi','Jordi Mollà','James Cosmo','Noomi Rapace','Michael Peña','Alexej Manvelov','Peter Guinness','Okieriete Onaodowan','Zuleikha Robinson','Cristina Umaña','Louis Ozawa','Jovan Adepo','Francisco Denis','Adam Bernett','Amir El-Masry','Haaz Sleiman','Michail Safronov','Allan Hawco','Susan Misner','Victor Rasuk','Paula Castaño','Victoria Sanchez','Mena Massoud','David Norona','Goran Kostič','Timothy Hutton','Adam Vacula','Jonathan Bailey','Marie-Josée Croze','Blair Brown','Ron Canada','Nasser Faris','Daniel Kash','Karim Belkhadra','John Magaro','Cynthia Preston','Youssef Kerkour','Emmanuelle Lussier-Martinez','Victor Slezak','Andreas Apergis','Brian Foreman','Leo Staar','Alex Trebek','Lee Tergesen','Hassam Ghancy','Kamel Labroudi','Matt McCoy','Natalie Brown','Al Sapienza','Brittany Drisdelle','Shailene Garnett','Kaan Urgancıoğlu','Numan Acar','Erdal Yildiz','Conrad Coates','Michael Gaston','Christopher Russell','Raven Dauda','Larry Day','Sarah Deakins','Dusan Dukic','Trevor Hayes','Karen LeBlanc','Nicole Leroux','Martin Thibaudeau','Chris Sandiford','Doug MacLeod','Ljubov Aksjonova','Tom Wlaschiha','Jonathan Potts','Ozan Ayhan','Ash Baggott','Kenny Wong','Áine Rose Daly','Miles Yekinni','Diany Samba-Bandza','Lydia Zadel','Nadia Affolter','Christian Paul','Dean Scott Vazquez','Yanis Charifi','Ciro Suarez','Abanoub Andraous','Donald Sage Mackay','Merena Demont','Jessica Abruzzese','Ana Ularu','Marc Menchaca','George Jac',"Michael O'Neill",'Lev Gorn','William Jackson Harper'],
screenplay:['Graham Roland','Carlton Cuse','Aaron Rabin','Amy Berg','Daria Polatin','Vaun Wilmott','Patrick Aison','David Graziano','Annie Jacobsen','Vince Calandra','Dario Scardapane','Nazrin Choudhury','Stephen Kronish','Marc Halsey','Steven Kane','Jada Nation','Robert David Port'],
production:['José Luis Escolar','Nazrin Choudhury','Daria Polatin','Robert F. Phillips','Jill Footlick','Thomas Hayslip','Patrick Aison',"Ra'uf Glasgow",'Kirk A. Moore','Alan B. McElroy','Gavin J. Behrman','Todd Brown','Aaron Lam','John R. Saunders'],
music:['Ramin Djawadi'],
camera:['Richard Rutkowski','Christopher Faloona','Checco Varese','Arnau Valls Colomer','Patrick Murguia','Jeffrey Greeley','Jacques Jouffret','John T. Connor'],
cut:['John M. Valerio','Paul Trejo','Iain Erskine','Sarah Boyd','Vikash Patel','Mark Goldman','Stephen Semel','Tad Dennis','Zachary Dehm','Marc Jozefowicz'],
sound:['Jon Wakeham','Benjamin L. Cook','Michael Barosky','Steve Pederson','Paula Fairfield','Greg P. Russell','Frank Morrone','Mandell Winter'],
scenography:['Derek R. Hill','Ruth Ammon','Mara LePere-Schloop','Keith Dunne','Ute Bergk','Christopher Minard','Livia Borgognoni','Vincent Aird'],
masks:['Charles Carter','Breanne McNally','Christophe Giraud','Adrien Morot','Márta Antal','Alexis Arenas','Khadija Najahi'],
costumes:['Molly Maginnis','Stephanie Maslansky','Michelle Matland','Michael Ground']},
{title:'Day Break',
titleCZ:'Za rozbřesku',
year:2006,
runtime:'9h 45min',
episodeRuntime:'45min',
countries:['USA'],
genres:['Action','Drama','Sci-Fi','Thriller'],
director:['Rob Bowman','Bryan Spicer','David Von Ancken','Frederick King Keller','Dwight H. Little','Andy Wolk','Elodie Keene'],
actors:['Taye Diggs','Moon Bloodgood','Victoria Pratt','Meta Golding','Ramon Rodriguez','Adam Baldwin','Michael McGrady','Joe Nieves','Mitch Pileggi','Ian Anthony Dale','Bahar Soomekh','Clayton Rohner','Nestor Carbonell','Roxanne Hart','Marlene Forte','Rochelle Aytes','Monique Gabriela Curnen','Jeffrey Johnson','Brian Goodman','Don Franklin','Tyrees Allen','Jim Beaver','Raymond Cruz','Peyton List','Fredric Lehne','Dwier Brown','Aramis Knight','Julieta Ortiz','Olivia Leigh','Aldo Gonzalez','Thomas Wilson Brown','Brent Jennings','Jesse Bernstein','Eric Steinberg','Carl Ciarfalio','Ward Horton','Cameron Meyer','Matt Riedy','Dan Warner','Teddy Lane Jr.','Akie Kotabe','Eddie J. Fernandez','Anne Betancourt','Sara Erikson','Brian Oerly','Josh Daugherty','Ben Hernandez Bray','Jeff Yagher','Kris Iyer','Lewis Tan','Julie Claire','Robert Neary','Sonya Eddy','Michael B. Silver','Michael Patrick McGill','John Rubinstein','Jonathan Banks','Clifton Powell','Shane Edelman','John Getz','Jenifer Lewis','Steven Barr','Kwesi Boakye','Joyce Guy',"Jeanette O'Connor",'Jeff Imada','Victor Togunde','Peter Allas','Luis Saguar',"Chane't Johnson",'Van Earl Wright','Cisco Reyes'],
screenplay:['Paul Zbyszewski','Henry Alonso Myers','John Hlavin','Steven Maeda','Jeffrey Bell','Charles Murray','Jenny Lynn','David Graziano','Angela Russo-Otstot'],
production:['Taye Diggs','David Graziano'],
music:['Christophe Beck','Mark Kilian'],
camera:['Bill Roe'],
cut:['Alan Cody','Jeff Freeman','Heather MacDougall','Edward R. Abroms','Tod Feuerman','Marta Evry'],
sound:['Marla McGuire','Pete Elia','Kurt Kassulke','David S. Di Pietro'],
scenography:['Michael Novotny','Okowita','Brenda Meyers-Ballard','Bryan Thetford'],
masks:['Dennis Parker','June Brickman'],
costumes:['Lisa Tomczeszyn','Julia Caston']},
{title:'A Very English Scandal',
titleCZ:'Skandál po anglicku',
year:2018,
runtime:'2h 50min',
episodeRuntime:'56-58min',
countries:['UK'],
genres:['Biographic','Crime','Drama'],
director:['Stephen Frears'],
actors:['Hugh Grant','Ben Whishaw','Daniel Weyman','Fisayo Akinade','David Bamber','Naomi Battrick','Tim Chipping','Michael Culkin','Monica Dolan','Michele Dotrice','Dyfan Dwyfor','Nicola Goodchild','Chris Grahamson','Blake Harrison','Patricia Hodge','Jonathan Hyde','Alex Jennings','Eve Myles',"Anthony O'Donnell",'Steffan Rhodri','Adrian Scarborough','Paul Sloss','Jason Watkins','Morgan Watkins','Susan Wooldridge','Miroslav Zaruba','Richard Price','Chris Ashby','Nicholas Blane','Ben Moor','Alice Orr-Ewing','Flora Montgomery','Paul Hilton','Patrick Barlow','Nigel Hastings','Pablo Raybould','Patrick Marber','Paul Freeman','John Bett','Caleb Roberts','Daryl McCormack','Charlotte Lucas','Jasmyn Banks'],
basedOn:['John Preston'],
screenplay:['Russell T. Davies'],
production:['Dan Winch'],
music:['Murray Gold','Jake Jackson'],
camera:['Danny Cohen'],
cut:['Pia Di Ciaula'],
scenography:['Helen Scott','Beckie Harvey'],
masks:['Daniel Phillips'],
costumes:['Suzanne Cave']},
{title:'When They Cry - Higurashi',
titleCZ:'Higuraši no naku koro ni',
year:2006,
runtime:'20h 50min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Drama','Horror','Mystery'],
director:['Čiaki Kon','Macuo Asami','Jošihisa Macumoto','Daisuke Cukuši','Tomoko Hiramuki','Makoto Sokuza','Isao Takajama','Kacumi Terahigaši'],
actors:['Jukari Tamura','Mika Kanai','Sóičiró Hoši','Mai Nakahara','Sacuki Jukino','Fumiko Orikasa','Miki Itó','Tošihiko Seki','Šinnosuke Tačibana','Šóto Kašii','Čafúrin','Jú Kobajaši','Naoko Macui','Fumihiko Tačiki','Šizuka Okohira','Jasunori Macumoto','Kacuhisa Hóki',"Masa'aki Cukada",'Risa Mizuno','Kikuko Inoue','Satoši Curuoka','Kudžira','Misa Watanabe','Tóru Ókawa','Akane Tomonaga','Fudžiko Takimoto','Daisuke Ono','Jui Horie','Hiroki Jasumoto','Džúróta Kosugi','Kazunari Tanaka','Kana Hanazawa','Nobujuki Kobuši','Takuo Kawamura','Daisuke Kageura','Manabi Mizuno','Hirómi Sugino','Acuši Kakehaši','Riiči Nišimoto','Miki Suga','Gen Nakano','Eriko Macušima','Suzune Okabe','Jukio Joda','Kun Fuzuki','Kacuhiro Óta','Akifumi Endó'],
basedOn:['Ryuukishi07'],
screenplay:['Fumihiko Šimo','Rika Nakase'],
production:['Jasutaka Hjúga','Mika Nomura','Hiroyuki Omori'],
music:['Kendži Kawai'],
camera:['Seiiči Morišita','Masajuki Kawaguči'],
cut:['Masahiro Macumura'],
sound:['Hozumi Góda','Ludovic Virieux'],
scenography:['Čikako Šibata']},
{title:'Honey and Clover',
titleCZ:'Med a čtyřlístek',
year:2005,
runtime:'13h 48min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Drama','Comedy','Romance'],
director:['Tacujuki Nagai','Kazunobu Šimizu','Jošihisa Macumoto','Ken Andó'],
actors:['Haruka Kudó','Keidži Fudžiwara','Tomokazu Sugita','Júdži Ueda','Hiroši Kamija','Mikako Takahaši','Daisuke Namikawa','Kóiči Jamadera','Takeši Aono','Makoto Jasumura','Kan Tanaka','Sajaka Óhara','Wataru Hatano','Hiroki Jasumoto','Rjóko Ono','Kenta Mijake','Masaši Hirose','Emi Šinohara','Takajuki Sugó','Mugihito','Hiroši Cučida','Tokujoši Kawašima','Rie Kugimija','Kendži Nodžima','Hiroši Naka','Takuma Suzuki','Taró Jamaguči','Júiči Nakamura','Jasuko Hatori','Masajo Hosono','Eriko Kigawa','Tomo Šigemacu','Eri Óno','Čie Macuura','Takaši Taniguči'],
basedOn:['Čika Umino'],
screenplay:['Jósuke Kuroda'],
music:['Júzó Hajaši','Suneohair'],
camera:['Jutaka Kurosawa','Jošio Ókóči'],
cut:['Šigeru Nišijama'],
sound:['Džin Aketagawa'],
scenography:['Čikako Šibata']},
{title:'Romance Is a Bonus Book',
titleCZ:'Příští kapitola: Láska',
year:2019,
runtime:'16h 47min',
episodeRuntime:'61-66min',
countries:['South Korea'],
genres:['Romance','Comedy'],
director:['Jeong-hyo Lee'],
actors:['Jong-seok Lee','Na-young Lee','Yoo-jin Jeong','Ha-joon Wi','Han-cheol Jo','Tae-woo Kim','Yoo-mi Kim','Sun-young Kim','Kwan-hoon Lee','Eui-sik Oh','Ho-jae Lee','Seung-tae Park','Soon-bae Cha','Gyu-young Park','Jung Hyun Noh','Ji-ha Lee','Ji-won Lee'],
screenplay:['Hyeon-jeong Jeong','Hyun-jung Jung'],
music:['Hye-Seung Nam']},
{title:'Tomorrow',
titleCZ:'Zítra je taky den',
year:2022,
runtime:'16h 11min',
episodeRuntime:'58-64min',
countries:['South Korea'],
genres:['Drama','Fantasy'],
director:['Tae-yoon Kim'],
actors:['Hae-sook Kim','Hee-seon Kim','Rowoon','Soo-hyeok Lee','Yu-Seon Yun','Sang-hoon Park','Hyuk Kwon','Won-ho Shin'],
music:['Sung Woo Cho','Tai Joon Cho','Min Sup Shin','Ho Kyung Won']},
{title:'Signal',
titleCZ:'Signál',
year:2016,
runtime:'19h 16min',
episodeRuntime:'64-89min',
countries:['South Korea'],
genres:['Crime','Mystery','Thriller'],
director:['Won-seok Kim'],
actors:['Je-hoon Lee','Hye-soo Kim','Jin-woong Cho','Hyeon-seong Jang','Won-hae Kim','Hae-gyoon Jeong','Eun-ah Seo','Jin-seong Ham','Hak-sun Kim','Min-gyoo Kim','Seong Hyeon','Yeon-ah Oh','Jeong-yeong Kim','Shi-eun Park','Han-bi Jung','Shi-ah Lee','Tae-kwang Hwang','Jeong-pal Kim','Dong-ha Lee','Dong-hyeon Geum','Ji-hoon Seo','Chae-kyeong Lee','Hyeon-bin Kim','Eun-yong Yang','Bong-hak Maeng','Na-ra Lee','Yoo-joon Lee','Young-joo Jeong','Yoo-hyun Song','Dae-yoon Kim','Je-woo Jung','Lee Dal'],
screenplay:['Eun-hee Kim'],
music:['Sung Il Park'],
camera:['Sang-mok Choi','Joo-Young Lee'],
cut:['Na-Young Kim']},
{title:"Dexter's Laboratory",
titleCZ:'Dexterova laboratoř',
year:1996,
runtime:'28h 36min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Animation','Family','Sci-Fi','Comedy'],
director:['Genndy Tartakovsky','Robert Alvarez','Rumen Petkov','Craig McCracken','Chris Savino','Don Judge','Paul Rudish','Rob Renzetti','David P. Smith','John McIntyre','Randy Myers','Jaime Diaz','Richard Collado'],
actors:['Christine Cavanaugh','Candi Milo','Kath Soucie','Jeff Bennett','Eddie Deezen','Allison Moore','Frank Welker','Rob Paulsen','Tom Kenny','Maurice LaMarche','Mako','Cecilia Cheung','Faye Wong','Brad Garrett','Earl Boen','Kat Cressida','Jay Huguley','Daran Norris','Robert Ridgely','Kevin Michael Richardson','Randy Savage','Gary Owens','Rachael MacFarlane','Hamilton Camp','Paul Williams','Greg Eagles','Paul Julian','Michael Pataki','Andy Suriano','Melissa Disney','Kimberly Brooks','Agostino Castagnola','Jennifer Martin'],
screenplay:['Genndy Tartakovsky','Seth MacFarlane','Craig McCracken','Charlie Bean','Walt Dohrn','Chris Savino','Gabe Swarr','Aaron Springer','Clay Morrow','Greg Miller','Jason Butler Rote','Michael Ryan',"Mark O'Hare",'Chris Reccardi','Carlos Ramos'],
production:['Chris Savino','Genndy Tartakovsky'],
music:['Thomas Chase','Steve Rucker','Gary Lionelli'],
cut:['Timothy J. Borquez','Paul Douglas'],
sound:['Timothy J. Borquez','Eric Freeman','Bill Koepnick','Jim Hodson','Joel Valentine'],
scenography:['David P. Smith']},
{title:'Dinosaurs',
titleCZ:'Dinosaurové',
year:1991,
runtime:'25h 54min',
episodeRuntime:'22-24min',
countries:['USA'],
genres:['Comedy','Family'],
director:['William Dear','Brian Henson','Bruce Bilson','Jeff McCracken','Tom Trbovich','Reza Badiyi','Patrick Read Johnson','Max Tash'],
actors:['Stuart Pankin','Jessica Walter','Sally Struthers','Sam McMurray','Christopher Meloni','Ken Hudson Campbell','Julia Louis-Dreyfus','Pat Crawford Brown','Joe Flaherty','Robert Picardo','John Vernon','Mimi Kennedy','Michael Dorn','Allan Trautman','Sherman Hemsley','Leif Tilden','Charles Kimbrough','Jessica Lundy','William Schallert','Shaun Baker','Kate McGregor-Stewart','Jeff Chayette','Rick Zieff','James Murray','Kevin Carlson','Suzie Plakson','Wendie Jo Sperber','Jarrett Lennon','Edie McClurg','Paxton Whitehead','Stephen Caffrey','Thom Sharp','Brian Henson','Frank Welker','Richard Portnow','Harold Gould','Peter Bonerz','Jason Alexander','Tony Shalhoub','Buddy Hackett','John Glover','George Gaynes','Tim Curry','Michael Richards','Jason Bernard','Ben Ryan Ganger','Julie Maddalena','Gary Owens','Florence Stanley','Sally Kellerman','Kirk R. Thatcher','Dan Castellaneta','Michael McKean','Jon Polito','Conchata Ferrell','David Warner','Jeffrey Tambor','Glenn Shadix','Edward Asner','David Wohl','Tim Doyle','Richard Simmons','Pons Maar','Julius Carry','Cynthia Mace','Bill Capizzi','Jack Tate','Steven Banks'],
screenplay:['Dave Caplan','Jane Espenson','Rob Ulin','Dava Savel','Bob Young','Rich Tabach','Victor Fresco','Kirk R. Thatcher','Michael Jacobs','Tim Doyle','Mark Drop','Peter Ocko','Lawrence H. Levy'],
production:['Jeff McCracken','Tim Doyle'],
music:['Ray Colcord','Bruce Broughton'],
camera:['Robert E. Collins'],
cut:['Duane Hartzell','Howard Deane','Marco Zappia','Larry L. Mills'],
sound:['Dean Okrand','Bill Thiederman',"Terry O'Bright",'Mike Getlin'],
scenography:['Robin Royce']},
{title:'Bates Motel',
titleCZ:'Batesův motel',
year:2013,
runtime:'36h 1min',
episodeRuntime:'39-47min',
countries:['USA'],
genres:['Drama','Mystery','Horror','Thriller'],
director:['Tucker Gates','Paul A. Edwards','Johan Renck','David Straiton','S.J. Clarkson','Ed Bianchi','Roxann Dawson','Christopher Nelson','John David Coles','Lodge Kerrigan','Phil Abraham','Nestor Carbonell','Tim Southam','T.J. Scott','Sarah Boyd','Olatunde Osunsanmi','Stephen Surjik','Max Thieriot','Freddie Highmore','Steph Green'],
actors:['Freddie Highmore','Vera Farmiga','Max Thieriot','Olivia Cooke','Nestor Carbonell','Nicola Peltz','Mike Vogel','Kenny Johnson','Keegan Connor Tracy','Ian Tracey','Kevin Rahm','Jere Burns','Kathleen Robertson','Conchita Campbell','W. Earl Brown','David Cubitt',"Aliyah O'Brien",'Terry Chen','Ian Hart','Hiro Kanagawa','Diana Bang','Keenan Tracey','Paloma Kwiatkowski','Brittney Wilson',"Michael O'Neill",'Michael Eklund','Rebecca Creskoff','Diana Pavlovská','Richard Harmon','Peter Bryant','Sarah Grey','Chad Rook','Francis X. McCarthy','Michael Vartan','Tracy Spiridakos','Catherine Lough Haggquist','Matthew MacCaull','Vincent Gale','Ryan Hurst','Joshua Leonard','Kim Kondrashoff','Geoff Gustafson','Jenna Romanin','Peter Stebbings','Tomiwa Edun','Emmalyn Estrada','Agam Darshi','Matthew Mandzij','Andrew Howard','Farrah Aviva','Lini Evans','Martin Cummins','Paul Jarrett','Michael Rogers','Anika Noni Rose','Nick Hunnings','Aaron Pearl','Darren Moore','Uma Jama','Madyson Parsons','Christian Bower','Martin Novotny','Dan Zukovic','Travis Breure','Stephen Boersma','Barry Nerling','Don MacKay','Lara Gilchrist','Ben Cotton','Alexander Calvert','Robert Moloney','Brendan Fletcher','Veena Sood','Sunita Prasad','Andrew Airlie','John Cassini','Garfield Wilson','Robert Mann','Tom McBeath','Wilson Bethel','Valerie Tian','Fiona Vroom','Carolyn Adair','Francisco Cano','José Vargas','Scott Patey','Angela Moore','Lindsay Collins','Yoshie Bancroft','Tiffany Sheppard','Matt Ellis','Mercedes de la Zerda','Dustin Schwartz','Jillian Fargey','D. Harlan Cutshall','Gillian Barber','Loretta Walsh','Broadus Mattison','Larry Hoe','Harrison MacDonald'],
screenplay:['Carlton Cuse','Kerry Ehrin','Nikki Toscano','Jeff Wadlow','Liz Tigelaar','Steve Kornacki','Bill Balas','Alexandra Cunningham','Alyson Evans','Erica Lipez','Scott Kosar','Philip Buiser','Torrey Speer','Tom Szentgyörgyi','Freddie Highmore','Anthony Cipriano'],
production:['Justis Greene','Vera Farmiga','Jamie Vega Wheeler','Christopher Nelson','Alyson Evans','Scott Kosar','Pete Whyte','Steve Kornacki','Erica Lipez','Nikki Toscano','Tim Southam'],
music:['Chris Bacon'],
camera:['John S. Bartley','Thomas Yatsko'],
cut:['Sarah Boyd','Edward A. Warschilka','Cecily Rhett','Paul Trejo','Kevin Krasny','Cedric Nairn-Smith','Vikash Patel','David Eisenberg','Christopher Nelson'],
sound:['Brian Armstrong','Alan Decker','Nello Torri','Thomas DeGorter','Craig Stauffer','Mark Noda','Michael Mullane','Simon Bright'],
scenography:['Mark S. Freeborn','Tony Wohlgemuth','Peter Bodnarus','David Hadaway','Margot Ready','James Willcock','Rose Marie McSherry'],
masks:['Donna Bis','L. Taylor Roberts','Tanya Hudson','Naomi Bakstad','Sandy Lindala','Vicki Syskakis','Megan Harkness','Dean Scheck','Patricia Murray','Victoria Ferguson','Emanuela Daus','Céline Godeau','Toby Lindala','Vince Yoshida'],
costumes:['Monique Prudhomme']},
{title:'Basilisk',
titleCZ:'Basilisk: Kóga ninpó čó',
year:2005,
runtime:'19h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy','Romance'],
director:['Fuminori Kizaki','Takashi Okazaki','Džundži Nišimura','Hazuki Mizumoto','Jukio Nišimoto','Ajaka Cudžihaši','Kazuja Fudžiširo'],
actors:['Nana Mizuki','Šó Hajami','Mijuki Sawaširo','Takeši Aono','Norio Wakamoto','Matthew Tompkins','Tomokazu Sugita','Kendži Ucumi','Wataru Hatano','Fumihiko Tačiki','Kósuke Toriumi','Kijoši Kobajaši','Risa Hajamizu','Tóru Óhira','Hisako Kjóda','Mugihito','Misa Watanabe','Acuši Imaruoka','Jódži Ueda','Kimiko Saitó','Čó','Takuja Kirimoto','Hiroši Cučida','Rjú Jamaguči','Micuhiro Ičiki','Fukuši Očiai','Čafúrin','Inori Minase','Tóru Sakurai','Reina Ueda','Tasuku Hatanaka','Šinei Ueki','Momoko Taneiči','Masaja Fukuniši','Kózó Mito','Tadahisa Saizen','Satoši Taki','Rjó Sugisaki','Jú Okano','Júdži Murai','Ken Uo','Larissa Tago Takeda','Satomi Kobaši','Hiroaki Okuda','Hajato Fudžii','Júmi Hirota','Kósuke Katajama','Satoši Mijazaki','Hodaka Mieno','Tomisaburó Horikoši','Kósuke Sakaki','Takahiro Mijake','Júki Hašimoto','Eidži Jošitomi','Rjúsaku Čidžiwa','Kacuhiro Tokuiši','Haruka Kimura','Hikari Jono','Izumi Koike','Goró Sanada','Aja Saitó','Jasuši Mijabajaši',"Šin'ja Honda",'Kacuhiro Kitagawa','Jú Urata','Naoki Janagi','Kacui Taira','Haruhi Nanao','Tomotaka Hačisuka','Umedži Sasaki','Šóhei Tó','Tomomucu Furukawa','Saori Suzumija','Hiroši Kósaka','Tomato Akai','Hiroaki Mikami'],
basedOn:['Fútaró Jamada'],
screenplay:['Jasujuki Mutó','Mari Okada','Takahiko Masuda','Jasunori Jamada','Džundži Nišimura','Šinsuke Óniši'],
music:['Kó Nakagawa','Gó Sakabe'],
camera:['Tadaši Kitaoka','Kenji Fujita'],
cut:['Kazuhiko Seki','Akinori Mišima'],
sound:['Joku Šioja','Čikako Jokota'],
scenography:['Šigemi Ikeda','Tošiko Kaizu']},
{title:'Friday Night Lights',
titleCZ:'Světla páteční noci',
year:2006,
runtime:'55h 10min',
episodeRuntime:'42-62min',
countries:['USA'],
genres:['Drama','Sport'],
director:['Patrick R. Norris','Jeffrey Reiner','Peter Berg','Mark Piznarski','Stephen Kay','Charles Stone III','Allison Liddi-Brown','Jonas Pate','Ami Canaan Mann','Chris Eyre','Amanda Phillips','Jason Katims','Dean White','David Boyd','Seith Mann','Michael Waxman','Josh Pate','Kyle Chandler','Adam Davidson','Todd McMullen','Christopher Misiano','Daniel Attias','Dan Lerner'],
actors:['Kyle Chandler','Connie Britton','Aimee Teegarden','Brad Leland','Taylor Kitsch','Jesse Plemons','Zach Gilford','Blue Deckert','Maggie Wheeler','Aasha Davis','Minka Kelly','Kevin Rankin','Brea Grant','Alexandra Holden','Jana Kramer','Brett Cullen','Nicole Taylor','Kasey Stevens','Adrianne Palicki','Patrick J. Adams','Jae Head','Scott Porter','Benjamin Ciaramello','Ricky Smith','Sam Jaeger','Gaius Charles','Jeremy Sumpter','D. W. Moffett','Kim Dickens','Alicia Witt','Daniella Alonso','Janine Turner','Brooke Langton','Steve Harris','Glenn Morshower','Austin Nichols','Zach Roerig','Michael B. Jordan','Saxon Sharbino','Aldis Hodge','Barry Tubb','Caleb Landry Jones','Sinqua Walls','Tamara Jolaine','Lupe Trejo','Marissa Garrison','RJ Smith-Tillman','Amanda Phillips','GiGi Erneta','Deke Anderson','Gary Teague','Walter Perez','Morgana Shaw','Morgane Slemp','Dora Madison','Denise Williamson','Roger Edwards','Ryan Lee','Grey Damon','Cathy Baron','Joe Grisaffi','Jeremy James Douglas Norton','Kate Melton','Richard Dillard','John McIntosh','Scott Jefferies','Jessica Nicole Webb','Brian Thornton','Everett Sifuentes','Dan Braverman','Carl Savering','Larry Jack Dotson','Drew Waters','Gerardo Davila','Justin Meeks','David Born','Matt Lauria','Kenneth Wayne Bradley','Derek Phillips','Lidia Porto','Brighton Sharbino','Brooke Peoples','Kristin Malko','Nicole Foster Callahan','Adriene Mishler','Alexandra Begg','Liz Gonzalez','Randy Frank','Stephanie Hunt','Katherine Willis','Jessica Roth','Logan Henderson','Kim Smith','Stacey Oristano','Chris Osborn','Sue Rock','Hope Jaymes','Rett Terrell','John Zinman','Stephen Bishop'],
basedOn:['Buzz Bissinger'],
screenplay:['Jason Katims','Liz Heldens','John Zinman','Brent Fletcher','Kerry Ehrin','Aaron Rahsaan Thomas','Patrick Massett','Ron Fitzgerald','Bridget Carpenter','Rolin Jones','David Hudgins','Monica Beletsky','Derek Santos Olson','Etan Frankel','Carter Harris','Andy Milligan','Peter Berg'],
production:['Michael Waxman','Nan Bernstein Freed','Ron Fitzgerald','Bridget Carpenter','David Hudgins'],
music:['W.G. Snuffy Walden','Bennett Salvay'],
camera:['David Boyd','Todd McMullen','Robert Frazen','Jeff Israel','Ian Ellis'],
cut:['Mark Conte','Ron Rosen','Angela M. Catanzaro','Keith Henderson','Louise Innes','Peter B. Ellis','Margaret Guinee','Matthew Colonna','Scott Gamzon','Jim Towne','Stephen Michael','Joshua Butler','Marc Cohen','Conrad M. Gonzalez'],
sound:['Todd Beckett','Nello Torri','Gregory King'],
scenography:['Cary White','Jeff Knipp','Barbara Haberecht','Carla Curry'],
masks:['Kara Sutherlin'],
costumes:['Alix Friedberg','Karyn Wagner','Kathy Kiatta']},
{title:'FlashForward',
titleCZ:'FlashForward - Vzpomínka na budoucnost',
year:2009,
runtime:'15h 46min',
episodeRuntime:'41-44min',
countries:['USA'],
genres:['Drama','Sci-Fi','Mystery','Thriller'],
director:['David S. Goyer','Michael Rymer','Bobby Roth','Nick Gomez','Michael Nankin','John Polson','Constantine Makris','Leslie Libman'],
actors:['Joseph Fiennes','John Cho','Jack Davenport','Sonya Walger','Zachary Knighton','Christine Woods','Peyton List','Courtney B. Vance',"Brían F. O'Byrne",'Dominic Monaghan','Rachel Roberts','Gabrielle Union','Shohreh Aghdashloo','Barry Shabaka Henley','Annabeth Gish','Gina Torres','Lee Thompson Young','Ryan Wynott','Alex Kingston','Genevieve Padalecki','Júko Takeuči','Lennon Wynn','Michael Massee','Callum Keith Rennie','Rodney Rowland','Frank John Hughes',"Michael O'Neill",'Peter Coyote','Julio Oscar Mechoso','Elizabeth Rodriguez','Ricky Jay','Tom Everett','Michele Boyd','Bryce Robinson','Glynn Turman','Navi Rawat','Jessica Tuck','Talia Balsam','Gil Bellows','James Cosmo','James Remar','Owiso Odera','Amy Rosoff','Ravi Kapoor','Michael Ealy','James Callis','Neil Jackson','Lindsay Pulsipher','Barbara Williams','Toši Toda','Anthony Azizi','Jake Johnson','Cynthia Addai-Robinson','Dominic Rains','Marc Menchaca','Blair Redford','Chris Coy','Elise Robertson','Ted Alderman',"Sean O'Bryan",'Gina Hiraizumi','Seth MacFarlane','Will Poston','Mackenzie Foy','Mike Cochrane',"Matt O'Neill",'Stephnie Weir','Lisa Darr','James Frain','Russell Vance Bailey','Daniel Zacapa','Mel Rodriguez','Rafael Petardi','Vinicius Machado','Blake Robbins','Clint Culp','Ashley Jones','Sufe Bradshaw','Laura Marano','Geoffrey Owens','Mark Famiglietti','Chelsea Rendon','Hannah Marks','John Prosky','Milauna Jackson','Adam Tsekhman','Chyna Layne','Elizabeth Sung','Rizwan Manji','Nick Roth','Peggy Stewart','Lawrence Mandley','Kelly Galindo','Micole Mercurio','Robb Skyler','Omid Abtahi','Jerome Ro Brooks','Patti Yasutake','Lynn Whitfield','James Carraway'],
basedOn:['Robert J. Sawyer'],
screenplay:['Brannon Braga','David S. Goyer','Scott M. Gimple','Marc Guggenheim','Seth Hoffman','Ian Goldberg','Timothy J. Lea','Quinton Peeples','Dawn Prestwich','Nicole Yorkin','Robert J. Sawyer','Barbara Nance'],
production:['Samantha Thomas','Mark H. Ovitz','Jonathan Buss'],
music:['Ramin Djawadi','Jo Blankenburg'],
camera:['Kramer Morgenthau','Nelson Cragg','Jeffrey Jur'],
cut:['Jeff Betancourt','Avi Youabian','Gabriel Wrye','Conrad Smart','Julius Ramsay','Nathan Gunn','Etienne Des Lauriers','Brett Jacobsen'],
sound:['Mark D. Fleming','Michael C. Casper','Tom E. Dahl','Thomas A. Harris'],
scenography:['Aaron Osborne','Stephen Storer','Jennifer M. Gentile','Erin Cochran'],
masks:['Kenny Niederbaumer','Dennis Parker'],
costumes:['Mari-An Ceo','Kathleen Detoro']},
{title:'White Collar',
titleCZ:'Ve službách FBI',
year:2009,
runtime:'59h 20min',
episodeRuntime:'40-55min',
countries:['USA'],
genres:['Crime','Comedy'],
director:['Dennie Gordon','Bronwen Hughes','Allan Arkush','Rosemary Rodriguez','Jeff F. King','Russell Lee Fine','Phil Abraham','Vincent Misiano','Paul Holahan','Charlotte Sieling','Michael Smith','Anton Cropper','Sanford Bookstaver','Martha Mitchell','John T. Kretchmer','Timothy Busfield','Kevin Bray','Ken Girotti','Tim Matheson','Tricia Brock','David Straiton','Andrew McCarthy','Tim DeKay','Stefan Schwartz','Robert Duncan McNeill','Arlene Sanford','Renny Harlin','Roger Kumble','Eric Stoltz','Willie Garson','Doug Hannah'],
actors:['Matt Bomer','Tim DeKay','Willie Garson','Tiffani Thiessen','Sharif Atkins','Marsha Thomason','Hilarie Burton','Diahann Carroll','Natalie Morales','James Rebhorn','Gloria Votsis','Alexandra Daddario','Ross McCall','Noah Emmerich','James Schram','Paul Blackthorne','Anna Chlumsky','Andrew McCarthy','Kevin Kilner','Garret Dillahunt','Lanny Flaherty','Mark Elliot Wilson','Michael Gaston','Deborah Twiss','Heidi Kristoffer','Callie Thorne','Mark Sheppard','John Pyper-Ferguson','Joe Morton','Stephen Gevedon','William Henderson White','Hutch Dano','William Sadler','Kyle Secor','Elizabeth Gillies','Vanessa Ray','Lucy Walters','Dylan Baker','Murray Bartlett','Will Chase','Natalie Gal','Debra Monk','Richard Bekins','Lena Headey','Robert John Burke','Joe Manganiello','Hal Ozsan','Moronai Kanekoa','Patch Darragh','Kate Hodge','Nicole Steinwedell','Cotter Smith','Tom Skerritt','Teena Byrd','Hoon Lee','Peter McRobbie','Diane Neal','Eugenia Kuzmina','Michael Boatman','Bruno Irizarry','Justin Morck','Carlos Leon','Kelly McCreary','Geno Segers','Bridget Regan','Jolly Abraham','Jayce Bartok','Stephen Badalamenti','John Palumbo','Michael Crowe','Sherita Rankins','Margaret Anne Florence','Brady Smith','Annet Mahendru','Alysia Reiner','Gary Hilborn','Ed Moran','Mircea Monroe','Mary Ashlyn Moore','Ward Horton','Pablo Schreiber','Sabina Gadecki','John Bianco','Madison McKinley','Moran Atias','Ashley Fox Linton','Eliza Dushku','Sarah Carter','Donnie Keshawarz','Mía Maestro','Noah Unger','Wayne Duvall','Cody Horn','Susan Misner','Perrey Reeves','Kate Jennings Grant','William Abadie','Robert Funaro','Joe Forbrich','Alex Cranmer'],
screenplay:['Jeff F. King','Mark Goffman','Julian Meiojas','Mark Lafferty','Nick Thiel','Jeff Eastin','Joseph C. Muscat','Clifton Campbell','Rashad Raisani','Jim Campolongo','Joe Henderson','Bob DeRosa','Matt Whitney','Matthew Negrete','Tom Garrigus','Jessica Grasl','Eddie Serrano','Channing Powell','Daniel Shattuck'],
production:['Margo Myers','Tim DeKay','Matt Bomer','Matt Whitney','Jessica Grasl'],
music:['Jon Ehrlich'],
camera:['Russell Lee Fine','Joel Ransom','Niels Alpert','Robert Gantz','Jamie Silverstein'],
cut:['Tom Wilson','Justin Krohn','Russell Denove','Michael Schweitzer','Nicholas Erasmus','Kimberly Ray','Jonathan Chibnall','Jordan Goldman','Kevin Krasny','Michael Stern','Joel T. Pashby','Hibah Schweitzer','Doug Hannah','Jon Dudkowski','Tammis Chandler'],
sound:['Sherry Klein','Albert Ibbotson','Mark Server','David Raines','Mathew Price'],
scenography:['Lester Cohen','Stephen Beatrice','Monica Monserrate','Kara Zeigon','Tora Peterson','Sheila Bock'],
masks:['Linda Grimes'],
costumes:['Catherine Marie Thomas','Karen Malecki','Stephanie Maslansky','Rosemary Lepre Forman']},
{title:'The Lincoln Lawyer',
titleCZ:'Advokát',
year:2022,
runtime:'24h 45min',
episodeRuntime:'43-56min',
countries:['USA'],
genres:['Drama','Crime','Mystery','Thriller'],
director:['Liz Friedlander','Erin Feeley',"Bill D'Elia",'David Grossman','Alonso Alvarez','Rob Seidenglanz','Kate Woods','Antonio Negret','Shana Stein','Ted Humphrey','Ben Hernandez Bray'],
actors:['Manuel Garcia-Rulfo','Neve Campbell','Christopher Gorham','Becki Newton','Angus Sampson','Kim Hawthorne','Chris Browning','Reggie Lee','Lamont Thompson','Ntare Guma Mbaho Mwine','Jon Tenney','Anna Khaja','LisaGay Hamilton','Johann Urb','John Cothran Jr.','Meera Rohit Kumbhani','Bernie Kopell','Paul Urcioli','Jordyn Chang','Krista Warner','Michael Graziadei','Shwayze','Julie Ariola','Eugene Kim','Paul Rae','Mageina Tovah','Justene Alpert','Dan Wells','Jamie McShane','Marlene Forte','Christine Horn','Heather Mazur','Megan McNulty','Christopher Amitrano','Anthony A. Kung','Christopher Thornton','Michael Cory Davis','CJ Jones','Gabriel Burrafato','Jonathan Avigdori','Amelia Brantley','Camilla Arfwedson','Katherine von Drachenberg','Ashley Gallegos','Brian Kamei','Noelle Filippone','Tarnue Massaquoi','Elliott Gould','Carlos Bernard','Puja Mohindra','Andrea Savo','Chris Gehrt','Chuck McCollum','Kadeem Hardison','Jeff Francisco','Eddie Diaz','Frantz Durand','Bruce Davison','Emerson Brooks','Fiona Rene','David Clayton Rogers','JJ Snyder','Ramona DuBarry','Rudy Martinez','Jazz Raycole','Blanca Araceli','Saul Huezo','Adan James Carrillo','Roman Arabia','Chau Long','Lana Parrilla','Douglas Bennett','Jake Tapper','Yaya DaCosta','Clint Carmichael','Maya Goodwin','Kurt Kanazawa','Ryan W. Garcia','Joy Regullano','Paul Alayo','Jason Matthew Smith','Shahaub Roudbari','Brian McGovern','Casey Adams','Darien Sills-Evans','Matt Angel','Andrew Hawtrey','Joanne Baron','Patrick Fischler','Ilean Almaguer','Hemky Madera','Miriam Flynn','Ronnie Clark','Juan Monsalvez','Matthew Garbacz','Angélica María','Keong Sim','Elizabeth Anweis','Damián Delgado','Adam Harrington'],
basedOn:['Michael Connelly'],
screenplay:['David E. Kelley','Ted Humphrey','Justin Peacock','Chris Downey','Andi Bushell','Gladys Rodriguez','Zach Calig','Ryan Hoang Williams','Michael Connelly','Dailyn Rodriguez','Matthew J. Lieberman','Lisa Quintela'],
production:['Tom Bernardo','Zach Calig','Justin Peacock','Leanne Moore'],
music:['David Buckley'],
camera:['Darran Tiernan','David J. Miller','Pedro Gómez Millán','Abraham Martinez'],
cut:['Warren Bowman','Amy Colla','Robert Ivison','Rachel Katz-Overstreet','David Grecu'],
sound:['Andrew Garrett Lange','Penny Harold','Christopher Gomez'],
scenography:['Jessica Kender','Scott Enge','Ray Yamagata','Lisa Clark','Andrew Leitch','Shauna Aronson'],
masks:['Samantha Wen'],
costumes:['Lindy McMichael']},
{title:'The Scarlet Pimpernel',
titleCZ:'Červený bedrník',
year:1999,
runtime:null,
episodeRuntime:'6x90min',
countries:['UK'],
genres:['Adventure','Drama'],
director:['Patrick Lau','Graham Theakston','Simon Langton'],
actors:['Richard E. Grant','Elizabeth McGovern','Martin Shaw','Ron Donachie','Emilia Fox','Jamie Bamber','Karel Roden','Pavel Kříž','Julie Cox','James Callis','John McEnery','Stuart Bunce','Jiří Knot','Jim Sturgess','Winter Ave Zoli','Daniel Rous','Ronan Vibert','Alex Norton','Christopher Clarke','Caroline Carver','Petra Špindlerová','Anthony Green','Beth Goddard','Michaela Flenerová','Emily Bruni','Richard Dempsey','Mark Umbers','Danny Webb','Anton Lesser','Matthew Gravelle','Samantha Beckinsale','Frank Rozelaar-Green','Jonathan Coy','Tracey Childs','Simon Kunz','David Birkin','Steve Speirs','Robert Langdon Lloyd','Christopher Fairbank','Pascal Langdale','Denise Black','Milton Johns','Jerome Willis','Suzanne Bertish','Diana Payan','Dominic Mafham','Bill Stewart','Simon Williams','Stephen Churchett','Selina Griffiths','Hugh Dickson','Joanna Roth','Robert Orr','Andy de la Tour'],
screenplay:['Alan Whiting','Richard Carpenter','Emmuska Orczy','Matthew Hall'],
music:['Michal Pavlíček'],
camera:['Peter Greenhalgh','Lukas Strebel','Simon Kossoff','John Hooper'],
cut:['Beverley Mills','Alan Jones','Jeremy Strachan'],
scenography:['Maurice Cain','Tim Hutchinson','Desmond Crowe'],
costumes:['Howard Burden','Jeremy Turner']},
{title:'Fate/stay night',
titleCZ:'Fate/stay night',
year:2006,
runtime:null,
episodeRuntime:'10h25min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy','Thriller'],
director:['Júdži Jamaguči','Jošihiro Takamoto','Rjódži Fudžiwara','Noriaki Akitaja','Šigeru Ueda','Jumi Kamakura','Kunitoši Okadžima','Masami Furukawa','Isao Takajama'],
actors:['Ajako Kawasumi','Noriaki Sugijama','Kana Ueda','Acuko Tanaka',"Džun'iči Suwabe",'Jú Asakawa','Miki Itó',"Šin'ičiró Miki",'Tomokazu Seki','Džunko Noda','Hóko Kuwašima','Mamiko Noto','Hiroši Kamija','Nobutoši Kanna','Mai Kadowaki','Džódži Nakata','Noriko Šitaja','Kazuhiro Nakata','Eri Nakao','Micuaki Madono','Fumie Mizusawa','Rie Nakagawa','Rikija Kojama','Tadahisa Saizen','Mičiru Juimoto','Kódži Cudžitani','Haruhi Nanao','Kajo Sakata','Satomi Jamagata'],
screenplay:['Mari Okada','Fumihiko Šimo','Džukki Hanada','Takuja Sató'],
production:['Takayuki Matsunaga','Tecuo Genšó'],
music:['Kendži Kawai'],
camera:["Šin'jo Kondó"],
cut:['Masahiro Macumura'],
sound:['Kódži Cudžitani'],
scenography:['Tošihasa Kojama']},
{title:'Noir',
titleCZ:'Noir',
year:2001,
runtime:'10h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Drama','Mystery'],
director:['Kóiči Mašimo','Hidejo Jamamoto',"Šin'ja Kawacura",'Masaki Tačibana','Icuró Kawasaki','Šunsuke Tada'],
actors:['Hóko Kuwašima','Kotono Micuiši','Tošihiko Seki','Aja Hisakawa','Hitoši Takagi','Taró Arakawa','Šinpači Cudži','Fumihiko Tačiki','Kumiko Higa','Hiroši Janaka','Bandžó Ginga','Nobuaki Sekine','Masako Džó','Rie Kanda','Urara Takano','Tarako','Jósuke Akimoto','Osamu Kobajaši','Kijoši Kobajaši','Hiroja Išimaru','Emi Šinohara','Hóčú Ócuka','Juzuru Fudžimoto','Kóiči Sakaguči','Kazuhiro Nakata','Rokuró Naja','Šigeru Ušijama','Džun Hazumi','Micuaki Hošino','Jumi Tóma','Reiko Suzuki','Kacunosuke Hori','Masaharu Sató','Takkó Išimori','Hidetoši Nakamura',"Kei'iči Sonobe",'Masaru Ikeda','Masako Kacuki','Hidejuki Umezu','Kijoši Kawakubo','Juriko Jamaguči','Hiroši Ito','Rjúnosuke Óbajaši','Kacumi Čó','Goró Naja','Kósei Jagi','Taimei Suzuki','Ai Sató','Keikó Sakai','Hikaru Mijata','Hisao Egawa','Takeši Watabe','Takuma Suzuki','Masajuki Omoro','Tomojuki Kóno','Fumiko Ósaka','Kóiči Nagano','Mika Itó','Takaši Taniguči','Masaru Motegi','Kaori Cudži','Júdži Fudžiširo','Jošiko Asai','Hisajoši Izaki','Naoko Miura','Minako Moto','Mijako Tao','Masamiči Sató','Naoja Učida','Tamio Óki','Kan Tanaka','Tokujoši Kawašima','Hiroši Kamija','Naocugu Joneda','Eidži Marujama'],
screenplay:['Rjóe Cukimura'],
production:['Šigeru Kitajama'],
music:['Juki Kadžiura'],
camera:['Kendži Takehara','Seiiči Morišita'],
cut:['Seidži Morita','Jukie Oikawa','Čieko Takajama'],
sound:['Kóiči Mašimo'],
scenography:['Tošihasa Kojama']},
{title:'Boys Over Flowers',
titleCZ:'Hana jori dango',
year:2005,
runtime:null,
episodeRuntime:null,
countries:['Japan'],
genres:['Comedy','Romance'],
director:['Jasuharu Išii','Osamu Katajama','Daisuke Jamamuro'],
actors:['Mao Inoue','Džun Macumoto','Nanako Macušima','Šóta Macuda','Šun Oguri','Cujoši Abe','Mariko Kaga','Šúgo Ošinari','Ajano','Aki Nišihara','Susumu Kobajaši','David Itó','Emiko Macuoka','Kazuaki Hankai','Tomoharu Hasegawa','Masei Nakajama','Takajuki Takuma','Megumi Sató','Majumi Sada','Mako Išino','Kazue Itó','Hard Gay'],
basedOn:['Jóko Kamio'],
screenplay:['Juki Fudžimoto','Nacuko Takahaši','Takajuki Takuma'],
music:['Kósuke Jamašita']},
{title:'False Flag',
titleCZ:'Kfulim',
year:2015,
runtime:'19h 30min',
episodeRuntime:'45min',
countries:['Israel'],
genres:['Drama','Thriller'],
director:['Oded Ruskin'],
actors:['Angel Bonanni','Moris Cohen','Miki Leon','Sergey Bukhman','Hanna Azoulay Hasfari','Hani Furstenberg',"Yousef 'Joe' Sweid",'Yoram Toledano','Yiftach Klein','Lihi Kornowski','Moran Rosenblatt','Neta Riskin','Hezi Saddik','Ishai Golan','Magi Azarzar','Ania Bukstein','Orna Salinger','Roy Assaf','Yoav Donat',"Jig'al Na'or",'Avigail Ariely','Yehuda Mor','Shmil Ben Ari','Shmulik Calderon','Dorin Kario','Ori Yaniv','Shalom Shmuelov','Hili Yalon','Ronit Yudkevitz','Romi Aviram','Peter Knoller','Omer Goldman','Einat Saruf','Fares Hananya','Denis Sandler','Daniel Brusovani','Aviva Marks','Lena Fraifeld','Alma Keni','Bar Miniely'],
screenplay:['Leora Kamenetzky','Amit Cohen'],
production:['Liat Benasuly','Maria Feldman'],
music:['Gilad Benamram'],
camera:['Nadav Hekselman','Rotem Yaron'],
cut:['Omri Zalmona','Boaz Mann','Or Ben David','Erez Mizrahi']},
{title:'13 Reasons Why',
titleCZ:'Proč? 13x proto',
year:2017,
runtime:'47h 32min',
episodeRuntime:'49-99min',
countries:['USA'],
genres:['Drama','Mystery'],
director:['Tom McCarthy','Gregg Araki','Helen Shaver','Kyle Patrick Alvarez','Carl Franklin','Jessica Yu','Karen Moncrieff','Eliza Hittman','Michael Morris','Kat Candler','Bronwen Hughes','Kevin Dowling','Aurora Guerrero','John T. Kretchmer','Michael Sucsy','Russell Mulcahy','Brenda Strong','Sunu Gonera','Tommy Lohmann','Brian Yorkey'],
actors:['Dylan Minnette','Katherine Langford','Christian Navarro','Alisha Boe','Brandon Flynn','Justin Prentice','Miles Heizer','Ross Butler','Devin Druid','Amy Hargreaves','Steven Silver','Michele Selene Ang','Kate Walsh',"Brian d'Arcy James",'Derek Luke','Gary Perez','Steven Wiig','Vanessa Ross','Brandon Larracuente','Lisa Anne Morrison','Michael Sadler','Nina Cheek','Marissa Freeman','Jesus N. Jimenez','Megan Stack','Josh Hamilton','Ajiona Alexus','Bryan Box','Shadia Iman','Tommy Dorfman','Bryan Irwin Thompson','Steven Weber','Sosie Bacon','Robert Gant','Giorgia Whigham','Timothy Granaderos','Mark Pellegrino','Mario Perez','Gabrielle Haugh','Cindy Cheung','Karen Kahn','Wilson Cruz','Maria Dizzia','Ben Lawson','Samantha Logan','Allison Miller','Meredith Monroe','Joseph C. Phillips','Tom Everett Scott','Jake Weber','Anne Winters','Phil Austin','Andrea Roth','Sean Blakemore','Jeffrey Vincent Parise','Brenda Strong','Ainsley Bailey','David Kallaway','Matthew Alan','Jackie Geary','Irina Voronina','Emily Peachey','Spence Moore II','Keiko Agena','Makenzie Vega','Jeanette Pavini','Sally Pressman','Allison Miller','Christopher Michael Holley','Parminder Nagra','Anthony Rapp',"Kelli O'Hara",'Alex MacNicoll','Bryce Cass','Nican Robinson','Derek Crowe','Nick Ryan Jurewicz','David Douglas','Grace Saif','Chelsea Alden','RJ Brown','Austin Aaron','Jake Hanson','Alisha Mullally','Zach Tinker','Richard Gross','Brett Baker','Hart Denton','Benito Martinez','Brandon Scott','Tyler Barnhardt','Erik Braa','Mason Guccione','Keon Motakhaveri','Ron Roggé','Bex Taylor-Klaus','Nana Mensah','Brandon Black','Raymond J. Barry','Deaken Bluman'],
basedOn:['Jay Asher'],
screenplay:['Elizabeth Benjamin','Brian Yorkey','Thomas Higgins','Marissa Jo Cerar','Nic Sheff','Nathan Louis Jackson','Kirk A. Moore','Allen MacDonald','Hayley Tyler','Helen Shang','M.K. Malone','Franky Gonzalez','Evangeline Ordaz','Sahar Jahani','Rohit Kumar','Felischa Marye','Mfoniso Udofia','Julia Bicknell'],
production:['Joe Incaprera',"Barbara D'Alessandro",'Kim M. Cybulski'],
music:['Brendan Angelides'],
camera:['Andrij Parekh','Ivan Strasburg','Cameron Duncan','Marshall Adams','Tommy Lohmann','Kevin Thompson'],
cut:['Leo Trombetta','Daniel Gabbe','Matthew Ramsey','Sue Blainey','Rich Fox','Philip Harrison'],
sound:['Nick Offord','Christian P. Minkler','Kelly Cabral'],
scenography:['Diane Lederman','Scott Cobb','Jim Gloster','Jeremy Cassells','Amber Haley'],
masks:['Kimberly Carlson','Stephan Dupuis','Mindy Hall','Carla Farmer','Michael Ward','Camille Friend','Sterfon Demings'],
costumes:['Amanda Friedland','Caroline B. Marx']},
{title:'Afro Samurai',
titleCZ:'Afro Samurai',
year:2007,
runtime:'2h 15min',
episodeRuntime:'27min',
countries:['Japan','USA'],
genres:['Animation','Action','Drama','Fantasy'],
director:['Fuminori Kizaki','Jasuhiro Geši'],
actors:['Samuel L. Jackson','Kelly Hu','Ron Perlman','Jeff Bennett','John DiMaggio','James Arnold Taylor','Tara Strong','Yuri Lowenthal','S. Scott Bullock','Crystal Scales'],
basedOn:['Takashi Okazaki'],
screenplay:['Jasujuki Mutó','Eric Garcia','Leo Chu','Tomohiro Jamašita'],
music:['RZA'],
cut:['Bruce W. Cathcart']},
{title:'Cold Feet',
titleCZ:'Šest v tom',
year:1997,
runtime:'48h 19min',
episodeRuntime:'44-76min',
countries:['UK'],
genres:['Comedy','Drama','Romance'],
director:['Terry McDonough','Tim Whitby','Simon Delaney','Ciaran Donnelly','Tim Sullivan','Pete Travis','Tom Hooper','Mark Mylod','Tom Vaughan','Declan Lowney','Nigel Cole','Jon Jones','Rebecca Gatward','John Hardwick','Louise Hooper','Juliet May','Paul Kousoulides','Jamie Jay Johnson'],
actors:['James Nesbitt','John Thomson','Robert Bathurst','Hermione Norris','Fay Ripley','Helen Baxendale','Jacey Salles','Ceallach Spellman','Daisy Edgar-Jones','Jack Harper','Christopher Hall','Daniel Hall','Jessica Bateson','Benjamin Bateson','Lara Bateson','Madeleine Edmondson','Leanne Best','Sean Pertwee','Richard Armitage',"Daniel O'Brien","Liam O'Brien",'Antony Yorke','Matthew Yorke','Lennie James','Hugh Dancy','Ben Miles','Kimberley Joseph','Rhea Bailey','Nicholas Ball','Malcolm Raeburn','Lucy Robinson','Ella Hunt','Anna Madeley','Jethro Skinner','Denis Lawson','Peter Feeney','Ricky Tomlinson','Anne Openshaw','Alison King','Stephen Moyer','Ian McElhinney','Brittany Tiplady','Francis Magee','Eva Pope',"Seamus O'Neill",'Sam Kelly','Kathryn Hunt','Rosie Cavaliero','Jo-Anne Stockham','Jonathan Slavin','John Lloyd Fillingham','Eamonn Riley','Filip L. Firlej','Vinette Robinson','Rachel Fielding','Ken Bones','Richard Dillane','Lisa Millett','Jimmy Hibbert','Jonathan Slinger','Elizabeth Rider','Kelly Wenham','Yasmin Bannerman','Tim Dantay','Sunetra Sarker','Suzanne Hall','Natalie Roles','Jo-Anne Knowles','Bernard Wrigley','Jacquetta May','Michael Troughton','Zoë Henry','Lauren K. Robek','Helen Grace','Rebecca Toolan','Paul Moniz de Sa','Jacqueline Pilton','Simon Poland','Dominic Coleman','Graham Parrington','Nicola-Jayne Wells','David Harewood','Prasanna Puwanarajah','Callum Woodhouse','Peter Gunn','Badria Timimi','Shameem Ahmad','Tony Gardner','Karl Haynes','Ronke Adekoluejo','Mark Chatterton','Ann Akinjirin','Mike Bullen','Marji Campi','Charlie Watts','Nicholas Sidi','James Noble','Andrew Morrish','Ian Keith','Chris Coghill'],
screenplay:['Mike Bullen','David Nicholls','Matt Greenhalgh','Mark Brotherhood','Ian Kershaw','James Wood','Amy Roberts','Kerry Ehrin'],
production:['Christine Langan','Lis Steele','Jim Poyser','Margaret Conway'],
music:['Mark Russell','Edmund Butt','Hans Engstrom','Stephen Morris','Gillian Gilbert'],
camera:['Larry Smith','James Mather','Tim Palmer','Søren Bay','Niels Reedtz Johansen','Stuart Biddlecombe','David Marsh','Mattias Nyberg','Si Bell','Ben Smithard','Toby Moore','David Rom','Shane Daly','Matt Gray','Tom McDougal','Doug Hallows'],
cut:['Tony Cranstoun','Selina Macarthur','Simon Reglar','Gary Dollner','Mark Henson','Emma Oxley','Frank Webb','David Gamble','Edward Mansell'],
sound:['Oliver Brierley','Alexander Fielding'],
scenography:['Michael Nemirsky','Hayden Matthews','Dave Arrowsmith','Claire Kenny','Ashley Wilkinson'],
masks:['Lynn Wheeler','Lesley Vanderwalt','L. Taylor Roberts'],
costumes:['Darren Finch','Janet Benge','Joey Attawia']},
{title:'Master of None',
titleCZ:'Mistr amatér',
year:2015,
runtime:'13h 25min',
episodeRuntime:'20-58min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['James Ponsoldt','Aziz Ansari','Eric Wareheim','Alan Yang','Melina Matsoukas','Lynn Shelton'],
actors:['Aziz Ansari','Eric Wareheim','Noël Wells','Lena Waithe','H. Jon Benjamin','Kelvin Yu','Alessandra Mastronardi','Shoukath Ansari','Fatima Ansari','Bobby Cannavale','Todd Barry','Riccardo Scamarcio','Danielle Brooks','Ilfenesh Hadera','Claire Danes','Ravi Patel','Brett Azar','Samantha Cope','Lane Kwederis','Susan Blackwell','Mahadeo Shivraj','Ian Kahn','Adrienne Lovette','Charlie Romanelli','John Reynolds','Frank Harts','Grace Rex','Annie Chang','Kelly Aaron','Maria Dizzia','David Krumholtz','Alexia Rasmussen','Clare-Hope Ashitey','Matt Patresi','Paolo Sassanelli','Ciara Renée','Barak Hardley','Lauren A. Miller','Tiya Sircar','Di Quon','Zachary Spicer','John Legend','José Ramón Rosario','Souleymane Sy Savane','Breanne Racano','Andy Samberg','Cedric the Entertainer','Tama Filianga','Bill Nunn','Suraj Partha',"De'Adre Aziza",'Cady Huffman','Nina Arianda','Father John Misty','Busta Rhymes','Stephen Wallem','Noah Emmerich','Colin Salmon','Doug Trapp','Lynn Shelton','Dola Rashad','Lynn Cohen','Doris McCarthy','Joseph Adams','Angela Bassett','Kym Whitley','Beck Bennett','Raven-Symoné','Asia Kate Dillon','Ryan Buggle','Eden Duncan-Smith','Cody Lindquist','Danielle Davenport','Leonard Ouzts','Aparna Nancherla','K.K. Glick','Katlyn Carlson','Jamar Greene','Gerrard Lobo','Michael Tow','Amy Chang','Mirirai Sithole','Mona Sishodia','Benjamin Thys','Tom Galantich','Brittini Schreiber','Shunori Ramanathan','Ito Aghayere','Devale Ellis','Swayam Bhatia','Ann Harada','Catrina Ganey','Brittany Campbell','Lawrence Jansen','Jessica Watson','Erica Mena','Andre Ward','Treshelle Edmond','Nicoló Ambrosio','Joseph Castillo-Midyett'],
screenplay:['Aziz Ansari','Alan Yang','Joe Mande','Sarah Peters','Lena Waithe'],
music:['Didier Leplae','Joe Wong'],
camera:['Mark Schwartzbard'],
cut:['Suzy Elmiger','Jennifer Lilly','Daniel Haworth'],
sound:['Michael Barosky','Denise Yarde'],
scenography:['Amy Williams','Jan Jericho','Ryan Palmer','Jack Berk','Tamara Marini','Beckie Harvey','Luisa Iemma'],
masks:["Katherine O'Donnell",'Raffaella Iorio'],
costumes:['Dana Covarrubias']},
{title:'Quarry',
titleCZ:'Quarry',
year:2016,
runtime:'8h 38min',
episodeRuntime:'60-82min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Greg Yaitanes'],
actors:['Logan Marshall-Green','Peter Mullan','Jamie Hector','Skipp Sudduth','Nikki Amuka-Bird','Edoardo Ballerini','David Born','Kurt Yaeger','Marc Menchaca','Bryan Blasingame','Meghan Wolfe','Juan Gaspard','Jacquelyn Twodat Jackson','Owen Harn','Terry Dale Parks','Jodi Balfour','Damon Herriman','Christopher Heskey','Jim Klock','Matt Nable','Elton LeBlanc','Josh Randall','Mustafa Shakir','James DuMont','Haviland Morris','Ann Dowd','Tom Noonan','Bob Walker','Christopher James Baker','Jeff Caperton','Philippe Radelet','Ólafur Darri Ólafsson','Chris Angerdina','Mike Mayhall','Susan McPhail','Ritchie Montgomery','Happy Anderson','Bill Irwin','Joshua Mikel','Natalie Canerday','Lyle Brocato','Paige Patterson','Chris Thomas King','Hawn Tran','Kyle Clements','Aoibhinn McGinnity','Andrea Thompson','Brittany S. Hall','Jared Bankens','Albert Jones','Joshua J. Williams','David Mattey','Gary Ray Moore','Natasha Marc','Silas Borelly','Lindsay Ayliffe','Kaley Ronayne','Cariella Smith','Robert Diago DoQui'],
basedOn:['Max Allan Collins'],
screenplay:['Michael D. Fuller','Graham Gordy','Jennifer Schuur'],
production:['Steve Golin','Joe Incaprera','Alan C. Blomquist'],
camera:['Javier Aguirresarobe','Pepe Avila del Pino'],
cut:['Donn Aron','Doc Crotzer'],
sound:['Joe DeAngelis','Kenneth Kobett','Brad North'],
scenography:['Tim Grimes','Roshelle Berliner'],
masks:['David Atherton','Michael Tyler'],
costumes:['Margot Wilson','Patia Prouty']},
{title:'Boys Over Flowers',
titleCZ:'Radši kluci než kytky',
year:2009,
runtime:'27h 14min',
episodeRuntime:'63-71min',
countries:['South Korea'],
genres:['Comedy','Drama','Romance'],
director:['Ki-sang Jeon'],
actors:['Hye-seon Koo','Min-ho Lee','Hyun-joong Kim','Beom Kim','So-eun Kim','Ye-jin Lim','Min-jeong Lee','Si-yeong Lee','Seok-hwan Ahn','Chae-yeong Han','Min-ji Kim','Soo-jin Park','Da-reum Nam','Jeong-gil Lee','Eui-chul Jung','Ho-bin Jeong','Hae-woo Lee','Yeong-ok Kim','Ki-bang Kim','Hyeon-joo Kim','Dan-yool Kim','Seung-hyeon Ji','Hye-young Lee','Kyeong-hwan Heo'],
basedOn:['Jóko Kamio'],
screenplay:['Ji-ryeon Yoon'],
production:['Byung Joon Song']},
{title:'Tokyo Revengers',
titleCZ:'Tokyo Revengers',
year:2021,
runtime:null,
episodeRuntime:'20h24min',
countries:['Japan'],
genres:['Animation','Action','Drama'],
director:['Kóiči Hacumi','Saori Tačibana','Rion Kudžó','Kódži Aritomi','Kazuhisa Óno','Jošinobu Kasai','Jošifumi Sueda','Jošitaka Makino','Jukiko Imai','Kendži Setó','Rei Nakahara'],
actors:['Júki Šin','Azumi Waki','Rjóta Ósaka','Tacuhisa Suzuki','Takuma Terašima','Júja Hirose','Šunsuke Takeuči','Šóta Hajama','Satoši Hino','Masaaki Mizunaka','Jú Hajaši','Júki Inoue','Eidži Mijašita','Riho Sugijama','Šótaró Morikubo',"Džun'iči Janagita",'Mana Hirata','Manami Numakura','Gen Sató','Reió Cučida','Jošicugu Macuoka','Subaru Kimura','Jumi Učijama','Masaši Nogawa','Ai Fairouz','Šizuka Išigami','Eidži Takeuči','Šintaró Óhata','Mai Kanazawa','Šúgo Nakamura','Haruki Išija','Hironori Saitó','Tasuku Hatanaka','Kengo Kawaniši','Daisuke Ono','Takuja Eguči','Acuši Ono','Makoto Kaneko',"Šun'iči Toki",'Júiči Hose','Jukihiro Nozujama','Jukina Šutó',"Šin'ja Hamazoe",'Sakura Nakamura','Manaka Iwami','Kjó Jaoja','Takahiro Mizušima','Masaja Macukaze','Šó Karino','Kanna Nakamura','IKKI','Ikudži Nose','Kazuki Mijagi','Kenta Mijake','Kóhei Janagi','Megumi Sano','Misono Suzuki','Norijuki Cujuki','Tošiki Iwasawa','Júki Ótani','Šúhei Iwase','Rjóta Jano','Hiro Šimono','Daiki Abe','Makiko Nabei','Hajato Kaneko','Kósuke Katajama','Daisuke Namikawa','Čado Horii','Kentaró Kumagai','Cujoši Hajakawa','Asuna Tomari','Rjóta Takeuči','Saki Fudžita','Mizuki Kitadžima',"Džun'ja Enoki",'Nacuki Hanae','Masaja Fukuniši','Tomokazu Sugita','Mikako Komacu','Hiroja Egašira','Akari Kitó','Minami Tanaka','Akeno Watanabe','Čikako Sugimura','Naomi Ózora','Saima Nakano','Šó Okumura','Mai Nakahara','Tecu Inada','Nobunaga Šimazaki','Seiičiró Jamašita','Kóki Učijama','Nobuhiko Okamoto','Rina Sató','Hitomi Ueda','Acumi Tanezaki','Risae Macuda','Reina Ueda','Mei Hjakudomi'],
basedOn:['Ken Wakui'],
screenplay:['Jasujuki Mutó','Joriko Tomita','Seiko Takagi'],
production:['Hirofumi Itó'],
music:['Hiroaki Cucumi'],
camera:['Micujoši Jamamoto'],
cut:['Mai Hasegawa'],
sound:['Satoki Iida'],
scenography:['Manabu Ocuzuki','Rumi Macumoto']},
{title:'The Man in the High Castle',
titleCZ:'Muž z Vysokého zámku',
year:2015,
runtime:'36h 6min',
episodeRuntime:'45-70min',
countries:['USA'],
genres:['Drama','Sci-Fi','War'],
director:['David Semel','Daniel Percival','Colin Bucksey','Daniel Sackheim','David Petrarca','John Fawcett','Paul Holahan','Karyn Kusama','Alex Zakrzewski','Chris Long','Ken Olin','Michael Rymer','Bryan Spicer','Nelson McCormick','Brad Anderson','Michael Slovis','Ernest R. Dickerson','Meera Menon','Steph Green','Deborah Chow','Jennifer Getzinger','Rachel Leiterman','Charlotte Brändström','Julie Hébert','Richard Heus','Frederick E.O. Toye'],
actors:['Alexa Davalos','Rupert Evans','Luke Kleintank','DJ Qualls','Rufus Sewell','Michael Rispoli','Carsten Nørgaard','Conor Leslie','Rick Worthy','Hank Harris','Ron Roggé','Cary-Hiroyuki Tagawa','Alex Zahara','Neal Bledsoe','Jack Kehler','Lini Evans','Louis Ozawa','Donna Yamamoto','Callum Seagram Airlie','Tao Okamoto','Jason Asuncion','Burn Gorman','Nickolas Baric','Joel de la Fuente','Brennan Brown','Callum Keith Rennie','Charles Edward Bae','Steve Byers','Jessie Fraser','Bella Heathcote','Chelah Horsdal','Colin Lawrence','Quinn Lord','Sebastian Roché','Jeremy Schuetze','Ali Skovbye','Emily Holmes','Robert Moloney','Michael Gaston','Veronika Hadravá','Ryan Hesp','Paul Lazenby','Rick Cleveland','Eddie Shin','Gabrielle Rose','Wesley Strick','Bernhard Forcher','Daniel Roebuck','Christine Chatelain','Rob LaBelle','Darren Dolynski','J.C. Williams','Martin Novotny','Camille Sullivan','Amy Okuda','Charles Zuckerman','Hiro Kanagawa','Kevin McNulty','Stefanie von Pfetten','Darcy Laurie','Andrew Kavadas','Sean Poague','Luke Roessler','Pippa Mackie','Michael Yama','Wolf Muser','Allan Havey','Keone Young','Tzi Ma','Kaniehtiio Horn','Eric Keenleyside','Nancy Sorel','Gillian Barber','Sarah Hayward','Tate Donovan','Stephen Root','Michael Hogan','Josh Pence','Kenneth Tigar','Fiona Vroom','Valerie Mahaffey','Thure Riefenstein','Gracyn Shinyei','Carter Ryan Evancic','Matt Lindquist','Paul Pape','Clayton James','Majumi Jošida','Yukari Komatsu','Genea Charpentier','Mark Brandon','David Stuart','Ben Leiataua','Anthony Shim','John Emmet Tracy','Arpad Balogh','Ted Cole','William Forsythe','David Furr','Akie Kotabe'],
basedOn:['Philip K. Dick'],
screenplay:['Frank Spotnitz','Walon Green','Emma Frost','Thomas Schnauz','Wesley Strick','Francesca Gardiner','Rick Cleveland','Evan Wright','Eric Ellis Overmyer','Eric Simonson','Elizabeth Benjamin','Erik Oleson','William N. Fordes','Chris Collins','Chris Wu','Jace Richdale','Mark Richard','Julie Hébert','David Scarpa','Jihan Crowther','Rob Williams'],
production:['Marta Evry','Erin Smith'],
music:['Henry Jackman','Dominic Lewis'],
camera:['James Hawkinson','Gonzalo Amat'],
cut:['Julie Monroe','Kathryn Himoff','Angela M. Catanzaro','Mark C. Baldwin','Marta Evry','Michael Kewley','Monty DeGraff','Jason Savage','Jennifer Barbot','Jon Dudkowski','Diva Magpayo'],
sound:['Kevin Roache','Dennis Kirk','Andy King','Pete Elia','Patrick Veigel','Keith Rogers','Michael E. Lawshe','Bill Mellow','Robert Hanchar','Todd Orr','Rob Coxford'],
scenography:['Drew Boughton','Brenda Meyers-Ballard','Lisa Lancaster','Jonathan Lancaster'],
masks:['Brooke Sovdi','Kimberly Carlson','Karly Paranich','Angela Nair','Samantha Burke','Natalie Cosco','Leanne Rae Podavin','Chris Bennett','Vicki Syskakis','Victoria Ferguson'],
costumes:['Audrey Fisher','Catherine Adair','J.R. Hawbaker']},
{title:'Person of Interest',
titleCZ:'Lovci zločinců',
year:2011,
runtime:'75h 1min',
episodeRuntime:'42-45min',
countries:['USA'],
genres:['Action','Crime','Drama','Mystery','Sci-Fi','Thriller'],
director:['Chris Fisher','Richard J. Lewis','Frederick E.O. Toye','Jeffrey G. Hunt','Stephen Surjik','Stephen Williams','Kenneth Fink','Helen Shaver','David Semel','Brad Anderson','Jeff T. Thomas','Colin Bucksey','Larry Teng','Maja Vrvilo','Steven DePaul','Charles Beeson','Dennis Smith','Milan Cheylov','Alex Zakrzewski','David Von Ancken','Stephen Semel','Kevin Bray','Jon Cassar','James Whitmore Jr.','Félix Enríquez Alcalá','Clark Johnson','John Dahl','Jonathan Nolan','Tricia Brock','Omar Madha','Sylvain White','Jeffrey Lee Gibson','Kevin Hooks','Michael Offer','Kate Woods','Alrick Riley','Margot Lulick','Tim Matheson','Greg Plageman'],
actors:['James Caviezel','Michael Emerson','Kevin Chapman','Amy Acker','Sarah Shahi','Taraji P. Henson','John Nolan','Enrico Colantoni','Robert John Burke','Al Sapienza','Boris McGiver','Brett Cullen','Clarke Peters','John Doman','David Valcin','Paige Turco','Jay O. Sanders','Brennan Brown','Camryn Manheim','Cara Buono','Carrie Preston','Leslie Odom Jr.','Annie Parisse','Michael Kelly','Elizabeth Marvel','Winston Duke','Julian Ovenden','Wrenn Schmidt','Susan Misner','Ken Leung','Mark Margolis','John Fiore','Michael Stahl-David','Jonno Roberts','Natalie Zea','James Hanlon','William Sadler','Jermaine Crawford','Gina Hernandez','Molly Price','Randall Newsome','Keith Nobbs','Vincent Laresca','Lili Mirojnick','Charles Borland','Ruben Santiago-Hudson','Linda Cardellini','Adam Rothenberg','Bridget Regan','Elizabeth Masucci','John Cenatiempo','Courtenay Taylor','Kate Hodge','Terence Schappert','Cotter Smith','Brian J. Smith','Karolína Kurková','Matt Servitto','Joshua Elijah Reese','Scott Bryce','Jay Storey','Matt Lauria','Juan Carlos Hernández','Dan Bittner','Robin Lord Taylor','Samira Wiley',"Deirdre O'Connell",'Steven Ogg','Chris Chalk','Aja Naomi King','Matthew Rauch','José Zúñiga','Jonathan Tucker','Dan Amboyer','Megan Byrne','Scott Jaeck','Annika Boras','Jon Michael Hill','Valentina de Angelis','Kelli Barrett','Cosmo Pfeil','Astro','Erich Bergen','Dominic Fumusa','Dillan Arrick','Veronica Cruz','Ed Moran','Meredith Patterson','Jamie Lynn Concepcion','Virginia Kull','John Rue','Ritchie Coster','Gene Farber','Emily Robinson','Taylor Black','Bridget McKevitt','Derek Wilson','Brooke Bloom','Matt McGorry','River Alexander'],
screenplay:['Greg Plageman','Denise Thé','Erik Mountain','Amanda Segel','Jonathan Nolan','Dan Dietz','Sean Hennen','Tony Camerino','Patrick Harbinson','Ray Utarnachitt','Zak Schwartz','Andy Callahan','Josh Brown',"Lucas O'Connor",'Amy Berg','Ashley Gable','Melissa Scrivner-Love','David Slack','Jacey Heldrich','Sabir Pirzada','Hillary Benefiel'],
production:['Denise Thé','Margot Lulick','Stephen Semel','Amanda Segel','Erik Mountain','Zak Schwartz','Melissa Scrivner-Love'],
music:['Ramin Djawadi'],
camera:['David Insley','Teodoro Maniaci','Manuel Billeter','Stephen McNutt','Tom Houghton','Petr Hlinomaz','Richard Rutkowski','Gonzalo Amat'],
cut:['Mark Conte','Ryan Malanaphy','Scott Powell','Dorian Harris','Russell Denove','John Ganem','Farrel Levy','Hibah Schweitzer','Ray Daniels III'],
sound:['Keith Rogers','Noah Timan','Scott Weber','Matt Sawelson','Frank Morrone','Thomas DeGorter'],
scenography:['Rick Butler','Dan Leigh','Ron von Blomberg','Kalina Ivanov','C.J. Simpson'],
masks:['Stephanie Barr'],
costumes:['Gary Jones','Frank L. Fleming','John Glaser','Juliet Polcsa','Ellen Mirojnick']},
{title:'Looking',
titleCZ:'Hledání',
year:2014,
runtime:'8h 28min',
episodeRuntime:'26-33min',
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Andrew Haigh','Ryan Fleck','Joe Swanberg','Jamie Babbit','Craig Johnson'],
actors:['Jonathan Groff','Frankie J. Alvarez','Murray Bartlett','Lauren Weedman','Russell Tovey','Raúl Castillo','Scott Bakula','O.T. Fagbenle','Daniel Franzese','Vanessa Ross','Jason Ralph','Derek Ray','Andrew Keenan-Bolger','T.J. Linnard','Carlos Carrasco','Kimberly Legg','Tanner Cohen','Matthew Risch','Damon K. Sperber','Bashir Salahuddin','Christine Estabrook','Haley Camille','Nkechi','Jesse Garcia','Christina July Kim','Todd Fjelsted','Robert Noble','Bianca Von Krieg','Brian Gattas','Molly Shaiken','Darryl Fong','Scott Evans','Teresa Navarro','Tanya Saracho','Chris Perfetti','Matthew Wilkas','Joe Williamson','Amy York Rubin','Ann Magnuson','John Robinson','Jaden Alexander','Kelli Garner','Julia Duffy','Mary Kay Place','Hayes MacArthur','Charlyne Yi','Gabe Liedman','Wesley Taylor','Sean Maher','Carl Marino','Richard Gross','Anthony Hill','Jennifer Foster','Andrew Koponen','Carol Jefferson','Debra Norton-Miller','Andrew Law','Honey Mahogany','Frank Scozzari','Joel Steingold'],
screenplay:['Michael Lannan','Allan Heinberg','Tanya Saracho','Andrew Haigh','Roberto Aguirre-Sacasa','J.C. Lee','John Hoffman'],
production:['Kathy Landsberg'],
music:['David Stone Hamilton'],
camera:['Reed Morano','Xavier Grobet'],
cut:['Jonathan Alberts','Andrew Dickler','Geraud Brisson','Joel T. Pashby'],
sound:['Mike Marchain','Kevin W. Buchholz'],
scenography:['Todd Fjelsted'],
costumes:['Danny Glicker']},
{title:'Ergo Proxy',
titleCZ:'Ergo Proxy',
year:2006,
runtime:'9h 58min',
episodeRuntime:'26min',
countries:['Japan'],
genres:['Animation','Drama','Sci-Fi','Psychology','Mystery'],
director:['Šuko Murase','Sajo Jamamoto','Kei Cunemacu','Naoki Kusumoto','Akira Toba','Masaki Kitamura','Taiki Nišimura','Akira Jošimura'],
actors:['Rie Saitó','Kódži Jusa','Akiko Jadžima','Jóko Sómi','Ai Kobajaši','Akio Ócuka','Acuko Tanaka','Bin Šimada','Hóko Kuwašima','Hiroši Kamija','Daisuke Hirakawa','Kentaró Itó','Čikao Ócuka','Takeši Kusao','Hidekacu Šibata','Bandžó Ginga','Hirohiko Kakegawa','Sanae Kobajaši','Hóčú Ócuka','Kanako Tateno','Hikaru Hanada','Jasuhiro Takato',"Kijomicu Mizu'uči",'Hiroši Arikawa','Sačiko Kodžima','Tošicugu Takašina','Cuda Eizó','Acuko Juja','Kóhei Macumoto','Kijomi Jazawa','Jú Šimaka','Rjó Agawa','Júko Mogi'],
screenplay:['Júko Kawabe','Dai Saitó','Naruki Nagakawa','Seiko Takagi'],
production:['Takaši Kóčijama','Akio Macuda'],
music:['Jošihiro Ike'],
camera:['Kazuhiro Jamada'],
cut:['Tomoki Nagasaka'],
sound:['Keiiči Momose'],
scenography:['Takaši Aoi']},
{title:'Darker than Black',
titleCZ:'Darker than Black: Kuro no keijakuša',
year:2007,
runtime:null,
episodeRuntime:'15h24-25min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy','Mystery','Psychology','Sci-Fi'],
director:['Tensai Okamura','Šingo Kaneko','Hidejo Jamamoto','Tomoki Kjóda','Daisuke Čiba','Takeši Mori','Takefumi Anzai','Kei Cunemacu','Hideaki Itó','Akira Toba','Keisuke Óniši','Tomoko Hiramuki','Eiiči Kubojama'],
actors:['Misato Fukuen','Ikuja Sawaki','Masaru Ikeda','Hidenobu Kiuči','Nana Mizuki',"Šin'ičiró Miki",'Hidejuki Tanaka','Iemasa Kajumi','Nozomu Sasaki','Čika Sakamoto','Emiri Kató','Micuki Saiga','Takeši Kusao','Naoko Macui','Sajaka Óhara','Wataru Hatano','Kósuke Meguro','Sajori Išizuka','Maria Kawamura','Kazuhiko Inoue','Jasunori Macumoto','Hirojuki Jošino','Kijomi Asai','Sanae Kobajaši','Megumi Tojoguči','Júko Sanpei','Urara Takano','Kósuke Toriumi','Naomi Šindó','Tomoko Kawakami','Kacuhisa Hóki','Tomojuki Šimura','Takeharu Óniši','Takako Honda','Šigeru Nakahara','Kaori Nazuka','Masanori Takeda','Nobuaki Fukuda','Kazuhiro Óguro','Rumiko Ukai','Jošiko Macuo','Mičihiro Ikemizu',"Ken'ičiró Macuda",'Daisuke Macubara','Megumi Nasu','Jútaró Hondžó','Kóhei Fukuhara','Takuja Kirimoto','Jošino Takamori','Ai Sató','Taiten Kusunoki','Akio Nodžima','Satomi Morija','Masaja Macukaze','Hóko Kuwašima','Šiori Mikami','Joriko Nagata','Micuaki Madono','Kozue Jošizumi','Mucumi Sasaki',"Ken'iči Močizuki",'Jui Išikawa','Takahiko Sakaguma','Rjúzaburó Ótomo','Júdži Ueda','Kenta Mijake','Kei Šindó','Osamu Saka','Óki Sugijama','Rjúiči Azuma','Kendži Akabane','Kacunosuke Hori','Sakiko Tamagawa','Džódži Nakata','Čie Nakamura','Mičio Mijašita','Šunsuke Sakuja','Keiiči Nakagawa','Satoru Inoue','Rjósuke Sakamaki','Cujoši Aoki','Norihisa Mori','Hirómi Sugino','Masao Harada','Keiko Watanabe','Masaši Sugawara','Masajuki Omoro','Kazuja Kobajaši','Erino Hazuki','Hideki Nakaniši','Hinako Sasaki','Kandži Suzumori','Júna Inamura','Tomomi Watanabe','Norihiro Inoue','Minako Ičiki','Kacuhito Nomura','Eisuke Joda','Jasuo Iwata','Marika Hajaši'],
screenplay:['Šótaró Suga','Mari Okada','Hirojuki Jošino','Kurasumi Sunajama','Šinsuke Óniši','Júiči Nomura','Tensai Okamura'],
production:['Rjo Ójama','Hiró Marujama','Jošihiro Ójabu','Osamu Hosokawa'],
music:['Jóko Kanno','Jasuši Išii'],
camera:['Jošijuki Takei','Cujoši Kanbajaši'],
cut:['Kjóko Ogino','Masato Jošitake'],
sound:['Kazuhiro Wakabajaši'],
scenography:['Takaši Aoi']},
{title:'Show Me a Hero',
titleCZ:'Najděte mi hrdinu',
year:2015,
runtime:'5h 45min',
episodeRuntime:'53-69min',
countries:['USA'],
genres:['Crime','Drama','History'],
director:['Paul Haggis'],
actors:['Oscar Isaac','Catherine Keener','Jim Belushi','Stephen Gevedon','Hilary Mann','Christian Keiber','John Bianco','Paul Borghese','Craig DiFrancia','J. Mallory McCree','Clarke Peters','Deborah Rennard','LaTanya Richardson Jackson','Jon Bernthal','Alfred Molina','Winona Ryder','Natalie Paul','John Henry Cox','Carla Quevedo','Marko Caka','Doris McCarthy','Dominic Comperatore','Brynn Horrocks','Ilfenesh Hadera','Dan Ziskie','Peggy J. Scott','McKinley Belcher III','Remy Auberjonois','Laura Gómez','Neal Huff','Josh Salatin','Charlie Romanelli','Stephen DeRosa','Roger Wayne','Dominique Fishback','Clayton LeBouef','Peter Riegert','Bob Balaban','Michael Kostroff','Patrick Breen','Luke Kirby','Michael Potts','Michael Stahl-David','Jordan Dean','John Palumbo','Jenna Stern','Liam Mitchell','Bruce Altman','Aly Mang','Paul Haggis','Terry Kinney','Melanie Nicholls-King','Jeff Lima','Julito McCullum','Lou Martini Jr.','Jordan Bridges','Natalie Carter','Jeremy Davidson','Genevieve Hudson-Price','Wanda Nobles Colon','La Toya Jackson','Jacob Berger','Angela Pietropinto','Kathleen Choe','Faith Logan','Miles J. Harvey','Kyanna Simone','Erica Camarano','Marisol Sacramento','Danny Mastrogiorgio','Berto Colon','Ashley Bryant','Lorrie Odom','Maliq Johnson','Ilene Kristen','Jacob Berger',"Daniel O'Shea",'Patricia R. Floyd','Gary Littman','Adriana DeMeo','Jared Kemp','Despina Mirou','Teddy Coluca','David Iacono','Cybil Lake','Katira Maria','Charles Brice','Eboni Booth','Allan Steele','Guyviaud Joseph'],
screenplay:['David Simon','William F. Zorzi'],
production:['Gail Mutrux'],
music:['Nathan Larson'],
camera:['Andrij Parekh'],
cut:['Jo Francis','Kate Sanford'],
scenography:['Laurence Bennett','Monica Monserrate'],
masks:['Charlene Belmond','Michele Spooner'],
costumes:['Abigail Murray']},
{title:'Lonesome Dove',
titleCZ:'Osamělá holubice',
year:1989,
runtime:'6h 12min',
episodeRuntime:'90-94min',
countries:['USA'],
genres:['Drama','Western'],
director:['Simon Wincer'],
actors:['Robert Duvall','Tommy Lee Jones','Danny Glover','Diane Lane','Robert Urich','Frederic Forrest','D.B. Sweeney','Ricky Schroder','Anjelica Huston','Chris Cooper','Glenne Headly','Barry Corbin','William Sanderson','Steve Buscemi','Lanny Flaherty','Nina Siemaszko','Brandon Smith','Margo Martindale','Missy Crider','Rae Dawn Chong','Matthew Cowles','Barry Tubb','Ed Geldart','Bradley Gregg','Adam Faraizl','O-Lan Jones','Timothy Scott',"Gavan O'Herlihy",'Frederick Coffin','Jordan Lund','Boots Southerland','Jorge Martínez de Hoyos','Joel Palmer','Bud Shrake','Wallace Merck','León Singer','Curtis Taylor',"Kenny O'Morrison",'David Carpenter','Julius Tennon','Nada Despotovich','Tony Epper','Matthew Posey','Jimmy Ray Pickens','Lauren Stanley','Michael Tylo','Pierre Epstein','Sonny Carl Davis','Ron Weyand','James Terry McIlvain','Michael Pritchard','Jerry Biggs','David Ode','John Barks','Jack Caffrey','Danny Kamin'],
basedOn:['Larry McMurtry'],
screenplay:['William D. Wittliff'],
production:['Dyson Lovell'],
music:['Basil Poledouris'],
camera:['Douglas Milsome'],
cut:['Corky Ehlers'],
sound:['James L. Aicholtz',"Kevin O'Connell",'Joe Melody'],
scenography:['Cary White'],
masks:['Jean Ann Black'],
costumes:['Van Broughton Ramsey']},
{title:'V',
titleCZ:'V',
year:2009,
runtime:'15h 46min',
episodeRuntime:'40-47min',
countries:['USA'],
genres:['Sci-Fi','Drama','Thriller'],
director:['Yves Simoneau','Jonathan Frakes','Robert Duncan McNeill','Bryan Spicer','Jesse Warn','Dean White','John Behring','Frederick E.O. Toye','David Barrett','Bobby Roth','Steve Shill','Jeff Woolnough','Ralph Hemecker'],
actors:['Elizabeth Mitchell','Morris Chestnut','Joel Gretsch','Logan Huffman','Laura Vandervoort','Morena Baccarin','Scott Wolf','Charles Mesure','Christopher Shyer','Lourdes Benedicto','Alan Tudyk','Scott Hylands','Mark Hildreth','Zak Santiago','Nicholas Lea','Oded Fehr','Michelle Harrison','Barbara Tyson','Hrothgar Mathews','Ryan Kennedy','Jane Badler','Martin Cummins','Lucie Borhyová','Rey Koranteng','Kyle Labine','Kacey Rohl','Britt Irvin','David Richmond-Peck','Samantha Ferris','Françoise Robertson','Terry Chen','Jim Byrnes','Philip Granger','Jessica Parker Kennedy','Tyler Johnston','Roark Critchlow','Ona Grauer','Sarah-Jane Redmond','Michael Trucco','Adrian Holmes','Jesse Hutch','Derek Hamilton','Jodi Balfour','Crystal Balint','Erica Carroll','Douglas Chapman','Rob Carpenter','Charlie Carrick','Peter Bryant','Lexa Doig','Ingrid Kavelaars','Kennedi Clements','Jacob Blair','Alison Araya','Reese Alexander','Jarod Joseph','Chilton Crane','Teach Grant','Dejan Loyola','Jesse Wheeler','Josh Blacker','Carmen Aguirre','Omari Newton','D. Harlan Cutshall','Jackie Blackmore','Beverley Elliott','Tom Pickett','Amos Stern','Lucas Wolf','Ian Butcher','Chris Shields','Victor Formosa','Ki Yurij','Fane Tse','Chad Riley','Paul Lazenby','Ben Wilkinson','Rob Hayter','Kal Weber','Rekha Sharma','Christopher Rosamond','Sean Tyson','Craig March','Stefan Arngrim','Devielle Johnson','Jeremy Jones','Darcy Laurie','Stephen Park','Michael Karl Richards','Brett Le Bourveau','Marci T. House','Bethany Brown','Lesley Ewen','Patrick Keating','Benita Ha','Brandi Alexander','Jenn Griffin','Michael Filipowich','Veena Sood','Brett Dier'],
screenplay:['Scott Rosenbaum','Sam Egan',"Rockne S. O'Bannon",'Cathryn Humphris','Cameron Litvack','Charles Murray','David Rambo','Gregg Hurwitz','Gwendolyn M. Parker','Scott Peters','Hans Tobeason','Natalie Chaidez','Diego Gutierrez','Angela Russo-Otstot','Christine Roum'],
production:['Kathy Gilroy'],
music:['Marco Beltrami','Normand Corbeil'],
camera:['David Franco','Stephen Jackson'],
cut:['Jonathan Chibnall','Scot J. Kelly','Michael D. Ornstein','Geofrey Hildrew','Joshua Charson','Brady Heck'],
sound:['Dan Hiland','Ed Carr','Todd Grace','William Freesh','Gary D. Rogers','Michael C. Casper','Charles Hamilton'],
scenography:['Ian D. Thomas','Stephen Geaghan','Mark Lane'],
masks:['Rita Ciccozzi','Céline Godeau','Toby Lindala'],
costumes:['Trish Keating','Maya Mani']},
{title:'The Twelve Kingdoms',
titleCZ:'Džúni kokuki',
year:2002,
runtime:'18h 45min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy'],
director:['Cuneo Kobajaši','Čiaki Kon',"Džun'iči Watanabe",'Keiiči Sugijama','Acuši Jano','Šindži Sató','Hiroši Jamazaki','Hibari Kurihara','Hirojuki Cučija','Kódži Jošikawa','Nagisa Mijazaki'],
actors:['Aja Hisakawa','Takehito Kojasu','Hóko Kuwašima',"Ken'iči Suzumura",'Rie Kugimija','Júdži Ueda','Hidejuki Tanaka','Džunko Noda','Kazuja Nakai','Kendži Nodžima','Mami Kojama','Mamiko Noto','Tomokazu Sugita','Daisuke Sakaguči','Jukana','Miki Narahaši','Džódži Nakata','Miju Macuki','Fumihiko Tačiki','Hiroši Janaka','Tošiko Fudžita','Šóko Cuda','Asami Mukaidono','Jasunori Macumoto','Tomoko Kaneda','Kacujuki Koniši','Hirojuki Jošino','Megumi Tojoguči','Wakana Jamazaki','Emi Motoi','Eriko Kawasaki','Masaki Aizawa','Juka Inokuči','Takehiro Murozono','Naomi Šindó','Kódži Išii','Tomoko Kawakami','Takaja Haši',"Mari Joko'o",'Sakiko Tamagawa','Kacuhisa Hóki','Kóiči Sakaguči','Kazuhiro Nakata',"Šin'ja Ótaki","Miki Mači'i",'Júko Sató','Júko Kaida','Kazuja Tatekabe','Mami Kingecu','Rjókiči Takahaši','Jumi Tóma','Džin Horikawa','Kósuke Okano','Reiko Suzuki','Tomomiči Nišimura','Keiko Kómjódži','Sajuri','Micuaki Madono','Nobujuki Furuta','Seidži Sasaki','Kazuaki Itó','Masahiko Tanaka','Rintaró Niši','Akiko Takeguči','Jošihisa Kawahara','Hisako Kjóda','Kinrjú Arimoto','Akiko Hiramacu','Ruri Asano',"Kei'iči Sonobe",'Masako Kacuki','Kumiko Takizawa','Micuru Ogata','Júko Sasaki','Tóru Ókawa','Mijuki Macušita','Čiemi Čiba','Júto Kazama','Motomu Kijokawa','Rjúzó Išino','Šintaró Óhata','Ai Sató','Naomi Wakabajaši','Hisao Egawa','Tošihiko Nakadžima','Takeši Watabe','Rumi Očiai','Aja Išizu','Kappei Jamaguči','Tošitaka Šimizu','Džiró Saitó','Seiko Tomoe','Džun Fukušima','Akira Išida','Keidži Fudžiwara','Hirofumi Nodžima','Kan Tokumaru','Minami Takajama','Reiko Kiuči','Kendži Nomura'],
basedOn:['Fujumi Ono'],
screenplay:['Šó Aikawa','Seija Fudžima'],
music:['Kunihiko Rjó'],
camera:['Acuho Macumoto'],
cut:['Seidži Morita','Čieko Takajama'],
sound:['Cutomu Kašiwakura'],
scenography:["Džun'iči Higaši"]},
{title:'Azumanga Daioh',
titleCZ:'Azumanga daió: The Animation',
year:2002,
runtime:'10h 50min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Comedy'],
director:['Hiroši Nišikiori','Kódži Masunari','Secugoró Tobari','Tóru Takahaši','Hirojuki Išidó','Makoto Nagao','Isao Takajama','Kijotaka Óhata','Jajoi Minazuki',"Ken'ičiró Watanabe",'Hideki Tačibana','Džun Fukuda','Džun Takahaši','Jošinobu Jamakawa','Kazuhiro Sasaki','Makoto Beššo','Hiroaki Sakurai','Tacuo Sató'],
actors:['Hóko Kuwašima','Juki Macuoka','Aja Hisakawa','Tomoko Kaneda','Rie Tanaka','Jú Asakawa','Čieko Higuči','Akiko Hiramacu','Norio Wakamoto','Masako Nozawa','Makoto Jasumura','Sajaka Óhara','Naoki Makišima','Hirojuki Jošino','Kódži Išii','Juzuru Fudžimoto','Kijotaka Furušima','Júko Nagašima','Sakura Nogawa','Rjóko Nagata','Juka Kojama','Tadahisa Saizen','Ai Šimizu','Masaki Kawanabe','Takahiro Jošimizu','Mizuki Saitó','Akane Ómae','Júko Šima','Naoki Janagi','Jonehiko Kitagawa','Takeo Irie'],
basedOn:['Kiyohiko Azuma'],
screenplay:['Cujoši Tamai','Ičiró Ókóči','Tomojasu Ókubo','Aja Jošinaga'],
production:["Šin'iči Ikeda",'Nobuhiro Ósawa'],
music:['Masaki Kurihara'],
camera:['Masaru Takase'],
cut:['Šigeru Nišijama'],
sound:['Jóta Curuoka'],
scenography:['Čikako Šibata']},
{title:'Given',
titleCZ:'Given',
year:2019,
runtime:'4h 13min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Music','Romance','Drama'],
director:['Jú Kinome','Hikaru Jamaguči','Hiromiči Matano'],
actors:['Júma Učida','Ajaka Asai','Jú Šimamura','Rjóta Takeuči','Fumija Imai','Šintaró Asanuma','Takuja Eguči','Čiaki Kobajaši','Šógo Jano','Ikumi Hasegawa','Taito Ban','Masatomo Nakazawa','Kaede Juasa','Micuki Nakae','Umeka Šódži','Júki Šin','Emiri Sujama','Hirosato Amano'],
basedOn:['Nacuki Kizu'],
screenplay:['Juniko Ajana'],
music:['Mičiru'],
camera:['Naoki Serizawa'],
cut:['Rie Itó'],
sound:['Hiromi Kikuta'],
scenography:['Kóhei Honda']},
{title:'Star Wars: The Clone Wars',
titleCZ:'Star Wars: Klonové války',
year:2008,
runtime:'48h 58min',
episodeRuntime:'22-23min',
countries:['USA'],
genres:['Animation','Sci-Fi','Action','Adventure'],
director:['Dave Filoni','Dave Bullock','Giancarlo Volpe','Bosco Ng','Justin Ridge','Kyle Dunlevy','Steward Lee',"Brian O'Connell",'Rob Coleman','Acuši Takeuči','Jesse Yeh','Saul Ruiz','Nathaniel Villanueva','Robert Dalva','Duwayne Dunham','Danny Keller','Walter Murch'],
actors:['Anthony Daniels','Tom Kane','Matthew Wood','Ian Abercrombie','Corey Burton','James Arnold Taylor','Ashley Eckstein','Tom Kenny','Ron Perlman',"Olivia d'Abo",'Dee Bradley Baker','Matt Lanter','Gwendoline Yeo',"Terrence 'T.C.' Carson",'Phil LaMarr','Seth Green','Jim Cummings','Jennifer Hale','Jaime King','Alec Medlock','James Marsters','George Takei','Michael York','Catherine Taber','Nika Futterman','Ahmed Best','Liam Neeson','Cara Pifko','Dave Filoni','Simon Pegg','Barbara Goodson','Jon Favreau','Richard Green','George Coe','Greg Ellis','Tasia Valenza','Gideon Emery','David Tennant','Paul Nakauchi','Barry Dennen','Kevin Michael Richardson','Omid Abtahi','India Dupré','Jeff Fischer','Victor Brandt','Whit Hertford','Brian George','Matthew Senreich','Bobby Moynihan','Brigitte Kali Canales','Elizabeth Rodriguez','Katee Sackhoff','Ray Park','Sam Witwer','Tom Root','Kath Soucie','David Acord','Robin Atkin Downes','Chris Edgerly','Stephen Stanton','David Kaufman','Cam Clarke','Ben Diskin','James Mathis III','Meredith Salenger','Greg Proops','Julian Holloway','Daniel Logan','Larry Brandenburg','Nolan North','Bob Bergen','Jason Spisak','Clancy Brown','Adrienne Wilkinson','Pernilla August','Kevin Thoms','Jeff Anderson','Gary Anthony Williams','Fred Tatasciore','Angelique Perrin','Andrew Kishino','Sunil Malhotra','Dave Fennoy','Olivia Hack'],
screenplay:['Andrew Kreisberg','Brent V. Friedman','Craig Titley','Melinda Hsu Taylor','Cameron Litvack','Charles Murray','Steven Long Mitchell','Craig W. Van Sickle','Wendy Mericle','Chris Collins','Daniel Arkin','Paul Dini','Dave Filoni','Julie Siege','Eoghan Mahony','Steven Melching','Tim Burns','George Krstic','Henry Gilroy','Kevin Rubio','Katie Lucas','Bill Canterbury','Jen Klein','Matt Michnovetz','Ben Edlund','Drew Z. Greenberg','Douglas Petrie','Christian Taylor','Bonnie Mark','Jose Molina'],
production:['Catherine Winder','Caroline Kermel','Daisy Fang','Cary Silver'],
music:['Kevin Kiner','Jose Molina','John Williams'],
cut:['Nate Cormier','Jason Tucker','Nicolas Anastassiou','R. Orlando Duenas'],
sound:['David Acord','Matthew Wood','Juan Peralta','Steve Boeddeker','Jeremy Bowker','Christopher Scarabosio','Danielle Dupre']},
{title:'Strike Back',
titleCZ:'Protiúder',
year:2010,
runtime:'57h 25min',
episodeRuntime:'43-48min',
countries:['UK','USA'],
genres:['Action','Drama','Thriller'],
director:['Daniel Percival','M.J. Bassett','Stephen Woolfenden','Bill Eagles','Brendan Maher','Debs Paterson','Edward Hall','Alex Holmes','Paul Wilmshurst','Steve Shill','Mark Everest','Julian Holmes'],
actors:['Philip Winchester','Sullivan Stapleton','Rhona Mitra','Robson Green','Michelle Lukes','Charles Dance','Andrew Lincoln','Shane Taylor','Richard Armitage','Jimi Mistry','Alexandra Moen','Jodhi May','Shelley Conn','Eva Birthistle','Vincent Regan','Natalie Becker','Colin Salmon','Nicola Stephenson','Natalia Avelon','Laura Haddock','Mel Raido','Ewen Bremner','Adewale Akinnuoye-Agbaje','Cal MacAninch','Shaun Parkes','Alexander Siddig','Liam Cunningham','Iain Glen','David Haig','Toby Stephens','David Harewood','Orla Brady','Adrian Rawlins','Tim Pigott-Smith','Saïd Taghmaoui','Alistair Petrie','Annabelle Wallis','Robert Hobbs','Rachel Shelley','Attila Árpa','Abdul Salis','Langley Kirkwood','Omar Berdouni','Danny Webb','Farid Elouardi','Sara Stewart','Ron Smerczak',"Peter O'Meara",'Matthew Leitch','Hakeem Kae-Kazim','Féodor Atkine','Patrick Lyster','Paul Freeman','Terence Maynard','Eamonn Walker','Silas Carson','Iván Kamarás','Tereza Srbová','Liam Garrigan','Matt Devere','Sean Cameron Michael','Tracy Ifeachor',"Orla O'Rourke",'Laura Greenwood','Babou Ceesay','Constantine Gregory','Mark Griffin','Karen David','Andy Lucas','Milauna Jackson','Zubin Varla','Declan Hannigan','Sibongile Mlambo','Nick Boraine','Gen Seto','Michelle Yeoh','Leo Gregory','Dustin Clare','Philip Bretherton','Ndoni Khanyile','Laëtitia Eïdo','Fraser James','Georg Nikoloff','Peter Guinness','Lyne Renee',"Patrick O'Kane",'Sasha Behar','Gontse Ntshegang','Brian Milligan','Anton David Jeftha','Roger Nevares','Branko Tomović','Nigel Whitmey','Boubacar Babiane','Charles Baloyi','David Dennis','Melanie Liburd','Pim Bubear','Kornelia Horvath','Jane May Graves'],
basedOn:['Chris Ryan'],
screenplay:['Frank Spotnitz','Alan Whiting','M.J. Bassett','James Dormer','Tony Saint','Jed Mercurio','Jack Lothian','Ed Whitmore','Steve Bailie','James Payne','Simon Allen','John Simpson','Robert Murphy','Simon Burke','Steven Lally'],
production:['Chris Clough','M.J. Bassett','Michael Casey','Trevor Hopkins','Sharon Hughff','Andy Morgan','Kristian Dench'],
music:['Ilan Eshkeri','Scott Shields','Paul Saunderson'],
camera:['Steve Lawes','Jean-Philippe Gossart','Kieran McGuigan','Shane Daly','Damian Bromley','James Welland','Tim Palmer','Mike Spragg'],
cut:['Andrew MacRitchie','Guy Bensley','Gavin Buckley','Pia Di Ciaula','Nick Arthurs','John Richards','Iain Erskine','Crispin Green','Adam Trotman','Steve Singleton','Tim Murrell','Steven Worsley','Tim Marchant','Jason Savage','Mark Thornton','Adam Green','Yan Miles','Simon Brasse'],
sound:['Derek Mansvelt','Martin Jensen'],
scenography:['Steve Spence','Ricky Eyres','Matt Gant','Tom Burton','Jonathan Lee','Mike Gunn','Robert Foster','Liberta Misan','Domagoj Mamić','Luke Whitelock','Daniel Nussbaumer','Marijo Grepo'],
masks:['Nóra Koltai',"Jess O'Shea",'Tatjana Tomsic','Tatjana Tomsic'],
costumes:['Darion Hing','Andrew Cox','Kate Carin','Louise Allen']},
{title:'Mildred Pierce',
titleCZ:'Mildred Pierceová',
year:2011,
runtime:'5h 40min',
episodeRuntime:'60-80min',
countries:['USA'],
genres:['Drama'],
director:['Todd Haynes'],
actors:['Kate Winslet',"Brían F. O'Byrne",'Melissa Leo','James Le Gros','Mare Winningham','Marin Ireland','Murphy Guyer','Guy Pearce','Evan Rachel Wood','Elvy Yost','Miriam Shor','Halley Feiffer','Hope Davis','Ronald Guttman','Daniel London','Marceline Hugot','Rocco Sisto','Mark Margolis','Orlagh Cassidy','Lena Dunham','Victor Slezak','Morgan Turner','Till Schauder','Peter McRobbie','Tom Lipinski','Tommy Nelson','Nick Westrate','Quinn McColgan','Kaili Vernoff','Remy Auberjonois','Richard Easton','Laura Esterman','Waltrudis Buck','Brenda Wehle','Bridget Burke','Dan Marshall','William Hill','Jefferson Mays','Paul Sparks','James Biberi','Emily Cass McDonnell','Rebecca Street','Laura Rosenthal','Margaret Reed','MacKenzie Meehan','Harvey Waldman'],
basedOn:['James M. Cain'],
screenplay:['Todd Haynes','Jonathan Raymond'],
music:['Carter Burwell'],
camera:['Edward Lachman'],
cut:['Affonso Gonçalves','Camilla Toniolo'],
sound:['Simone Corelli'],
scenography:['Mark Friedberg'],
masks:['Jerry DeCarlo'],
costumes:['Ann Roth']},
{title:'The Rising of the Shield Hero',
titleCZ:'Tate no júša no nariagari',
year:2018,
runtime:'20h 22min',
episodeRuntime:'24-46min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy'],
director:['Hitoši Haga','Naoki Murata','Rjú Nakajama','Seung Hui Son','Masato Džinbó','Masajuki Kodžima','Tomoko Hiramuki','Daigo Jamagiši','Masacugu Arakawa','Šingo Kaneko','Takao Abo','Tomonori Mine','Takuma Suzuki','Hodaka Kuramoto','Ippei Ičii','Marina Maki','Júsuke Kubo'],
actors:['Kaito Išikawa','Asami Seto','Rina Hidaka','Jošicugu Macuoka','Jošitaka Jamaja','Maaja Učida','Sarah Emi Bridcutt','Jutaka Nakano','Hiroki Jasumoto','Jošino Aojama','Jóhei Hamada','Hiromiči Tezuka','Maki Izawa','Miho Okasaki','Takumu Mijazono','Masaja Fukuniši','Tamaki Orie','Šinnosuke Ogami','Meiko Kawasaki','Tošinari Fukamači','Akihiro Tadžima',"Šun'iči Maki",'Júdžiró Kakuda','Kowaka Wakana','Hitoši Bifu','Džun Fukujama','Kana Ičinose','Taiten Kusunoki','Saori Hajami','Megumi Han','Kikuko Inoue','Serika Hiromacu',"Ken'iči Ogata",'Motojuki Kawahara','Jošihito Sasaki','Acujoši Mijazaki','Eriko Macui','Šintaró Tanaka','Šóta Jamamoto','Šó Okumura','Airi Ócu','Eri Nakao','Šóto Kašii','Nozomi Nišida','Makoto Kóiči','Hajato Fudžii','Gakuto Kadžiwara','Rjúzaburó Ótomo','Ken Mizukoši','Nacuko Hara','Nacumi Fudžiwara','Taku Jaširo','Šunpei Fukuma','Tacujuki Kobajaši','Aimi Tanaka','Mika Kanda','Sakura Tange','Masaši Hašimoto','Makoto Takahaši','Takajuki Sugó','Jutaka Aojama','Eri Inagawa','Šunsuke Takeuči','Džuri Nagacuma','Takako Fudži','Tomojuki Marujama','Kósuke Toriumi','Takahiro Hirai','Hiroši Watanabe','Kódži Kawakami','Tomoko Nacukawa','Taisuke Nišimura','Sóiči Abe','Kana Hanazawa','Mari Hino','Rjóhei Kimura','Kósuke Kobajaši','Takeo Ócuka','Ruriko Aoki','Takaki Ótomari','Šunsuke Kanie','Micuki Nakamura','Takahiro Sumi','Taró Kiuči','Šinnosuke Musaši',"Šin'ja Takahaši",'Rjó Sugisaki','Miju Tomita','Šinnosuke Tačibana','Hisako Tódžó',"Ken'iči Mine",'Satoi Šibuja','Juki Hinata','Kengo Kawaniši','Kódži Seki','Rjúnosuke Watanuki','Kacujuki Miura','Anna Jamaki','Rika Kinugawa','Maki Kawase'],
basedOn:['Jusagi Aneko'],
screenplay:['Keigo Kojanagi','Ohine Ezaki','Rjú Nakajama','Takuja Asahina','Akiko Waba','Momoka Tojoda'],
production:['Jun`ičiró Tamura','Kósuke Arai'],
music:['Kevin Penkin'],
camera:['Jukijo Kadžiwara','Cunetaka Ema'],
cut:['Hitomi Sudó'],
sound:['Fumijuki Gó'],
scenography:['Masaru Sató','Sajaka Kašiwamura']},
{title:'Cadfael',
titleCZ:'Případy bratra Cadfaela',
year:1994,
runtime:'16h 15min',
episodeRuntime:'75min',
countries:['UK'],
genres:['Drama','Mystery'],
director:['Graham Theakston','Malcolm Mowbray','Herbert Wise','Ken Grieve','Sebastian Graham Jones'],
actors:['Derek Jacobi','Michael Culver','Julian Firth','Terrence Hardiman','Mark Charnock','Toby Jones','Eoin McCarthy','Sean Pertwee','Ben Pullen','Natascha McElhone','Lee Ingleby','Jonathan Firth','Ronan Vibert','Terence Beesley','Christien Anholt','Roger Ashton-Griffiths','Juliette Caton','Anthony Green','Robin Laing','Natasha Little','Susan Fleetwood','Anna Friel','Chloë Annett','Sean Chapman','Daniel Betts','Christian Burgess','Tom Georgeson','Crispin Bonham-Carter','Marlene Sidaway','Tim Wylton','Gregor Truter','Martyn Whitby','Rupert Holliday-Evans','Richard Lintern','Albie Woodington','Natasha Pyne','Norman Eshley','Peter Guinness','Rosalie Crutchley','John Hallam','Thomas Craig','Patrick Brennan','Raad Rawi','Michael Grandage','Jamie Glover','Matt Patresi','Natalie Jones','Valentine Pelka','Margery Mason','Tom Mannion','Roy Heather','Aubrey Richards',"Maggie O'Neill",'Michael Nightingale','Hilary Sesta','Roger Booth','Peter Copley','Kitty Aldridge','Jack Klaff','Bernard Gallagher','Guy Oliver-Watts','Richard Henders','Nigel Hastings','Roy Barraclough','Phil Rowlands','Mary Miller','William Mannering','Paul Broughton','Davyd Harries','Louisa Milwood-Haigh','Huw Garmon','Adam Bareham','Richard Clifford'],
basedOn:['Edith Pargeter'],
screenplay:['Russell Lewis','Paul Pender','Simon Burke'],
production:['Stephen Smallwood'],
music:['Colin Towns'],
camera:['Nyika Jancsó','Tony Miller','Walter McGill'],
cut:['Alan Jones','Jamie McCoan','Frances Mclean'],
scenography:['Richard Roberts','Andrew Ackland-Snow'],
masks:['Nóra Koltai'],
costumes:['Mária Hruby']},
{title:'Dead Like Me',
titleCZ:'Mrtví jako já',
year:2003,
runtime:'21h 35min',
episodeRuntime:'42-74min',
countries:['USA','Canada'],
genres:['Comedy','Fantasy','Drama'],
director:['Sarah Pia Anderson','Scott Winant','David Grossman','Milan Cheylov','Robert Duncan McNeill','David Straiton','Peter Lauer','Michael Fresco','James Marshall','Jeff Woolnough','James Whitmore Jr.','Kevin Dowling','Tony Westman','Helen Shaver','Steve Beers','Brad Turner'],
actors:['Ellen Muth','Mandy Patinkin','Rebecca Gayheart','Callum Blue','Cynthia Stevenson','Laura Harris','Christine Willes','Britt McKillip','Peter Williams','Jasmine Guy','Chris Gauthier','Neil Grayston','Erica Cerra','Jodelle Ferland','Darrin Klimek','Jewel Staite','Fulvio Cecere','Mädchen Amick','Emily Holmes','Pascale Hutton','Michael Eklund','Keith Dallas','Yeardley Smith','Kevin Durand','Claudette Mink','Katharine Horsman','Sonya Salomaa','Harold Perrineau','Lisa Marie Caruk','Christie Laing','Zak Santiago','Katie Stuart','Dustin Milligan','Michael Des Barres','Conan Graham','Paul Anthony','Robin Mossley','Ryan Robbins','Nicki Clyne','Dan Payne','Tegan Moss','Teryl Rothery','Ty Olsson','Birkett Turton','Susan Sullivan','Ali Liebert','James Kirk','Tiffany Lyndall-Knight','Eddie Mills','Ben Bass','Sarah Lind','Adrian Petriw','Gary Collins','Tygh Runyan','Tom McBeath','Serge Houde','Daniel Boileau','Philip Granger','Aaron Pearl','Robert Gauvin','Richard Lawson','Tom Butler','C. Ernst Harth','Lochlyn Munro','John DeSantis','John Kapelos','April Telek','Colin Lawrence','Kimani Ray Smith','Alain Chanoine','Michael Rogers','Steven Grayhm','Matthew Currie Holmes','Robin Dunne','Peter Kelamis','William MacDonald','Mary Ann Mobley','Claude Duhamel','Anne Marie DeLuise','Wendy Glenn','Layla Alizada','Michael Kopsa','David Lewis','Peter Bryant','Andrew Moxham','Gavin DeGraw','Sean Owen Roberts','Michael Adamthwaite','Paul Jarrett','Tony Massil','Joseph May','Elias Toufexis','Bruce Fontaine','Cameron McDonald','Peter New','Patti Allan','Kwesi Ameyaw','Ingrid Torrance','Ken Kramer','Bill Dow'],
screenplay:['Karl Gajdusek','Stephen Godchaux','Paul Lieberstein','Tom Spezialy','Bryan Fuller','J.J. Philbin','Annie Weisman','Bridget Carpenter','John Masius','Peter Ocko','Mona Mansour'],
production:['Pascal Verschooris'],
music:['Stewart Copeland'],
camera:['Tony Westman','Danny Nowak','Candace Cruikshank'],
cut:['Alison Grace','Mike Banas','Richard Schwadel','Lara Mazur'],
sound:['Bill Mellow','Paul A. Sharpe'],
scenography:['Ian D. Thomas','Richard Hudolin','Wendy Harke','Penny A. Chalmers','Douglasann Menchions'],
masks:['Monica Huppert','Patricia Murray'],
costumes:['Candace Cruikshank','Stephanie Nolin']},
{title:'The Great',
titleCZ:'Veliká',
year:2020,
runtime:'25h 42min',
episodeRuntime:'46-58min',
countries:['UK','Australia'],
genres:['Drama','Comedy','History','Biographic'],
director:['Matt Shakman','Colin Bucksey','Bertie','Ben Chessell','Geeta Vasant Patel','Bert','Zetna Fuentes','Ally Pankiw','Matthew Moore','Sheree Folkson','Jaffar Mahmood'],
actors:['Elle Fanning','Nicholas Hoult','Florence Keith-Roach','Sebastian De Souza','Sacha Dhawan','Phoebe Fox','Bayo Gbadamosi','Adam Godley','Douglas Hodge','Louis Hynes','Gwilym Lee','Charity Wakefield','Teresa Mahoney','Belinda Bromilow','Kemi-Bo Jacobs','Liv Hill','Liam Fleming','Julian Ferro','Grace Chilton','Blake Harrison','Stewart Scudamore','John Sessions','Jamie Demetriou','Miles Jupp','Tristan Beint','Daniel Tuite','Dan Wyllie','Christophe Tek','Lorenzo Vigevano','Geoff Bell','James Smith','Dustin Demri-Burns','Jack Brett Anderson','Waleed Akhtar','Raphael Sowole','Joakim Skarli','Aiyana Goodfellow','Jeska Pike','Kiki May','Kenneth Collard','Niccy Lin','Tallulah Bond','Danusia Samal','Julian Barratt','Eloise Webb','Jordan A. Nash','Claira Watson Parr','Anthony Welsh','Ramon Tikaram','Danielle Galligan','Raphael Acloque','Ninette Finch','Gillian Anderson','Jason Isaacs','Freddie Fox','Grace Molony','Toto Bruin','Max Boast','Billy Postlethwaite','Franck Assi','Abraham Popoola','Stuart Thompson','Alexis Bennett'],
screenplay:['Tony McNamara','Tess Morris','James Wood','Tami Sagher','Gretel Vella','Fiona Seres'],
production:["Dean O'Toole",'Tony McNamara',"Nick O'Hagan"],
music:['Nathan Barr'],
camera:['John Brawley','Anette Haellmigk','Maja Zamojda','Catherine Derry','Jake Polonsky','Caroline Bridges','Sergio Delgado'],
cut:['Anthony Boys','Nicolas Gaster','Billy Sneddon','Edel McDonnell'],
sound:['Joe Fletcher','Jamie Roden','Mathew Knights'],
scenography:['Francesca di Mottola','Kave Quinn','Tanya Bowd','Sandra Phillips','Marcus Wookey','Stella Fox','Monica Alberte','Alessandro Troso'],
masks:["Jess O'Shea",'Erin Ayanian'],
costumes:['Holly Waddington','Emma Fryer','Sharon Long']},
{title:'Another',
titleCZ:'Another',
year:2012,
runtime:null,
episodeRuntime:'5h25min',
countries:['Japan'],
genres:['Animation','Horror','Thriller','Psychology','Crime'],
director:['Cutomu Mizušima','Tošija Šinohara','Takefumi Anzai','Fumie Muroi','Jong Heo','Nobutoši Ogura'],
actors:['Acuši Abe','Nacumi Takamori','Tomoaki Maeno','Ai Nonaka','Madoka Jonezawa','Hiroaki Hirata','Genki Muro','Satomi Akesaka','Jošino Nandžó',"Šin'ja Takahaši",'Mizuko Arima','Kódži Jada','Misato Fukuen','Kósuke Kobajaši','Sajuri Sadaoka','Misuzu Togaši','Micuhiro Ičiki','Rjóta Asari','Kazutomi Jamamoto','Emi Jamamoto','Gó Inoue','Kengo Kawaniši','Keisuke Kómoto','Jú Šimamura','Hitomi Harada','Šizuka Furuja','Iori Nomizu','Eri Góda','Icuki Takizawa','Takuró Kitagawa','Seiko Jošida','Kózó Mito','Naoko Sakakibara','Mana Hirata','Hiró Sasaki','Cugumi Iki','Šó Takano','Tecuja Oka','Šin Ginoza',"Ken'iči Mine"],
basedOn:['Jukito Ajasudži'],
screenplay:['Rjó Higaki'],
production:['Kendži Horikawa','Džun Fukuda','Takeši Jasuda'],
music:['Kó Ótani'],
camera:['Satoši Namiki'],
cut:['Ajumu Takahaši'],
sound:['Jošikazu Iwanami'],
scenography:['Satoru Hirajanagi']},
{title:'The English',
titleCZ:'Angličanka',
year:2022,
runtime:'5h 16min',
episodeRuntime:'47-69min',
countries:['USA','UK'],
genres:['Drama','Western'],
director:['Hugo Blick'],
actors:['Emily Blunt','Chaske Spencer','Ciarán Hinds','Rafe Spall','Toby Jones','Tom Hughes','Stephen Rea','Valerie Pachner','Malcolm Storry','Nicholas Aaron','Nichola McAuliffe','Steve Wall','William Belleau','Matthew Zajac'],
screenplay:['Hugo Blick'],
production:['Colin Wratten'],
music:['Federico Jusid'],
camera:['Arnau Valls Colomer'],
sound:['Glen Marullo'],
scenography:['Chris Roope','Laura Musso'],
masks:['Olga Cruz','Isabel Duque'],
costumes:['Phoebe De Gaye']},
{title:'Looking for Alaska',
titleCZ:'Hledání Aljašky',
year:2019,
runtime:'7h 4min',
episodeRuntime:'48-57min',
countries:['USA'],
genres:['Drama','Romance'],
director:['Sarah Adina Smith','Rachel Lee Goldenberg','Brett Haley','Ami Canaan Mann','Clea DuVall','Megan Griffiths','Rashaad Ernesto Green','Josh Schwartz'],
actors:['Kristine Froseth','Charlie Plummer','Sofia Vassilieva','Uriah Shelton','Landry Bender','Jordan Connor','Abbie Gayle','Ron Cephas Jones','Jay Lee','Timothy Simons','Henrique Zaga','Mason McKey','Denny Love','Roman Armstrong','Justin Carmouche','Trace Masters','Rachel Matthews','Kelly Murtagh','Silas Borelly','Joy Jacobson'],
basedOn:['John Green'],
screenplay:['Josh Schwartz','Warren Hsu Leonard','Stephanie Savage','Ashley Wigfield','Kirk A. Moore','Leila Gerstein','Kendall Rogers','Sarah Polley'],
production:['Kirk A. Moore','Mark Rowen','Samson Mücke'],
music:['Siddhartha Khosla'],
camera:['Ramsey Nickell'],
cut:['Matthew Ramsey','Shoshanah Tanzer','Todd Gerlinger','Hillary Wills'],
sound:['Nello Torri','Alan Decker'],
scenography:['Aaron Osborne','Erin Cochran'],
masks:['Courtney Lether'],
costumes:['Matthew Simonelli']},
{title:'River',
titleCZ:'River',
year:2015,
runtime:null,
episodeRuntime:'6h60min',
countries:['UK'],
genres:['Crime'],
director:['Jessica Hobbs','Tim Fywell','Richard Laxton'],
actors:['Stellan Skarsgård','Nicola Walker','Lesley Manville','Adeel Akhtar','Eddie Marsan','Sorcha Cusack','Steve Nicolson','Owen Teale','Michael Maloney','Jim Loach','Shannon Tarbet','Paul Blackwell','Jim Norton','Turlough Convery','Georgina Rich','Fady Elsayed','Marko Leht','Adjoa Andoh','Peter Bankolé','Cathy Murphy','Pippa Bennett-Warner','Louis Mahoney','Matthew David McCarthy','Peter Landi','Josef Altin','Franz Drameh','Lee Nicholas Harris','Danny Darren','Andrew Byron','Alec Utgoff','Andrei Zayats','Gledis Cinque','Lydia Leonard','Anamaria Marinca','Nicholas Goh','Faith Edwards','Julian Lewis Jones','Jacqueline Boatswain','Nana Agyeman-Bediako'],
screenplay:['Abi Morgan'],
production:['Chris Carey'],
music:['Harry Escott'],
camera:['Hubert Taczanowski'],
cut:['Mary Finlay','Fiona Colbeck','Adam Bosman'],
sound:['Martin Jensen'],
scenography:['Paul Cross','Nicola De Fresnes'],
costumes:['Emma Fryer']},
{title:'Serial Experiments: Lain',
titleCZ:'Serial Experiments: Lain',
year:1998,
runtime:'5h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Mystery','Sci-Fi','Thriller'],
director:['Rjútaró Nakamura','Džóhei Macuura','Akihiko Nišijama'],
actors:['Kaori Šimizu','Ajako Kawasumi','Miki Itó','Šigeru Čiba','Susumu Čiba','Masahito Kawanago','Michael Gregory','Masahito Jabe','Džódži Nakata','Fumihiko Tačiki','Šó Hajami','Kazuhiko Inoue','Takumi Jamazaki','Eriko Kawasaki','Takehiro Murozono','Kendži Nomura','Džin Jamanoi','Džin Horikawa','Sóičiró Tanaka','Hiromi Ócuda','Mikiko Kurihara','Hiroaki Išikawa','Čiharu Tezuka','Rjúnosuke Óbajaši','Rei Igaraši','Sacuki Cuzumi','Mikako Sató','Hikaru Mijata','Šigeru Šibuja','Madoka Akita','Tamocu Nišiwaki','Jó Kitazawa','Macuo Macuo','Manabi Mizuno','Mičiko Neja','Sumi Mutó','Jóko Asada','Kendži Nodžima','Ken Narita','Masaši Sugawara','Akiko','Emi Sagara','Minako Ičiki','Takaši Taniguči','Hidetoši Itó','Masamiči Sató','Masaru Hačinohe','Wasei Čikada','Kuniko Jošioka','Hiroši Kitazawa','Minako Arakawa','Eiičiró Suzuki','Hiroaki Jošida','Ajako Kurosaki','Akari Fudžiwara','Kazunori Sekine','Nacumi Asaoka'],
screenplay:['Čiaki Konaka'],
music:['Reiči Nakaido'],
camera:['Takaši Azuhata'],
cut:['Takeši Sejama'],
sound:['Jóta Curuoka'],
scenography:['Masaru Sató']},
{title:'Belle and Sebastian',
titleCZ:'Bella a Sebastián',
year:1965,
runtime:null,
episodeRuntime:'13x26min',
countries:['France'],
genres:['Adventure'],
director:['Cécile Aubry','Jean Guillaume'],
actors:['Mehdi El Glaoui','Edmond Beauchamp','Paloma Matta','Pierre Massimi','Charles Vanel','Louise Marleau','Claude Giraud','Harry-Max','Cécile Aubry','Maurice Poli','Albert Dagnant','Hélène Dieudonné','René Blancard','Jean-Michel Audin','Dominique Blondeau','Jacqueline Danno','Nane Germon','Henri-Jacques Huet','Jean Combal','Guy Di Rigo','Jean-Pierre Lorrain','Géo Beuf','Paul Barge','Jacques Godin'],
music:['Éric Demarsan','François Rauber','Daniel White'],
camera:['Jacques Ledoux','Henri Raichi'],
scenography:['Raymond Gabutti']},
{title:'Gentleman Jack',
titleCZ:'Gentleman Jack',
year:2019,
runtime:'15h 50min',
episodeRuntime:'56-69min',
countries:['UK'],
genres:['Drama','History','Romance','Biographic'],
director:['Sarah Harding','Jennifer Perrott','Sally Wainwright','Edward Hall',"Fergus O'Brien"],
actors:['Suranne Jones','Gemma Jones','Joe Armstrong','Amelia Bullmore','Rosie Cavaliero','Stephanie Cole','Albane Courtois','Peter Davison','Shaun Dooley','Vincent Franklin','Thomas Howes','Lydia Leonard','Jodhi May','Sophie Rundle','Timothy West','Gemma Whelan','Michael Xavier','Dino Fetscher','Katherine Kelly','Lucy Briers','Daisy Edgar-Jones','Rupert Vansittart','Steve Evets','George Costigan','Bruce Alexander','Sylvia Syms','Brendan Patricks','John Hollingworth','Amy James-Kelly','David Sterne','Derek Riddell','Daniel Betts','Stephanie Hyam','Caspar Phillipson','Polly Maberly','Julie Agnete Vang Christensen','Magnus Bruun','Sofie Gråbøl','Daniel Weyman','Anthony Flanagan','Stephen MacKenna','Christopher Dane','Merete Friis','Daniel Coll','Alexandro Albrechtsen Aguirre','Natalie Gavin','Dorte Rømer','Lars Malmquist','Jessica Baglow','Tom Lewis','Grant Burgin','Jennifer Matter','Austin Haynes','Cameron Ashplant','Poppy Allen-Quarmby','James Quinn'],
screenplay:['Sally Wainwright'],
production:['Phil Collinson','Stella Merz'],
music:['Murray Gold'],
camera:['Matt Gray','Nick Dance','Simon Chapman','Johann Perry','Nicola Daley'],
cut:['Richard Cox','Ulrike Münch'],
scenography:['Anna Pritchard','Kristine Maj de Neergaard'],
masks:['Jules Greenan'],
costumes:['Tom Pye']},
{title:'Strong Girl Bong-soon',
titleCZ:'Himssen yeoja dobongsoon',
year:2017,
runtime:'17h 59min',
episodeRuntime:'65-71min',
countries:['South Korea'],
genres:['Comedy','Romance','Drama','Fantasy'],
director:['Hyeong-min Lee'],
actors:['Bo-yeong Park','Hyung-sik Park','Ji-soo Kim','Seok-ho Jeon','Jae-myeong Yoo','Won-hae Kim','Won-hee Lim','Woo-yeon Ahn','Hye-jin Shim','Seong-beom Kim','Min-gyo Kim','In-ah Seol','Cheol-min Lee','Jiyoung','Sang-hyeon Yoon','Mi-kwan Jang','Hyeok-soo Kwon','Clara Lee','Ji-hyeon Min','Leesang','Ye-hee Yoon','Won-seob Lee','Su-ryeon Baek','Soo-ji Lee','Hyun-mok Kim','Minyeong Choi'],
screenplay:['Mi-kyeong Baek'],
production:['Jin-seok Lee'],
music:['Seong-nam Moon']},
{title:'Santa Clarita Diet',
titleCZ:'Santa Clarita Diet',
year:2017,
runtime:'14h 37min',
episodeRuntime:'26-36min',
countries:['USA'],
genres:['Comedy','Horror'],
director:['Ruben Fleischer','Ken Kwapis','Marc Buckland','Craig Zisk','Lynn Shelton','Steve Pink','Tamra Davis','Dean Parisot','Jaffar Mahmood','Jamie Babbit','Geeta Vasant Patel','Andy Ackerman','Rebecca Asher','Adam Arkin'],
actors:['Drew Barrymore','Timothy Olyphant','Liv Hewson','Skyler Gisondo','Natalie Morales','Kaylee Bryant','Ricardo Chavira','Mary Elizabeth Ellis','Richard T. Jones','Nathan Fillion','Andy Richter','Patton Oswalt',"Matt O'Leary",'Patricia Belcher','Scott Beehner','Thomas Lennon','Grace Zabriskie','Deobia Oparei','Ryan Hansen','Evan Jones','Carla Jimenez','Derek Waters','Ravi Patel','Portia de Rossi','Karl T. Wright','Carole Gutierrez','Ramona Young','Jonathan Slavin','Amy Hill','Adam Rose','Markie Post','Joel McHale','Maggie Lawson','Zachary Knighton','Jee Young Han','Robert Baker','Abbie Cobb','Adam Arkin','Matt Shively','Arden Belle','Paul Ben-Victor','Christopher Thornton','Leo Howard','Brad Raider','Gerald McRaney','Sarah Baker','Steve Harris','Alex Skuby','Billy Malone','Linwood Boomer','Dominic Burgess','Stephen Full','Miraj Grbic','Eric Nenninger','Laura Silverman','Goran Višnjič','Meg DeLacy','Sydney Park','Ethan Suplee','Shalita Grant','Alan Tudyk','Marcus Folmar','Matthew Glave','Linda Lavin','Malcolm Barrett','Lauren Weedman','George Basil','Zack Gold','Kerri Kenney','Artemis Pebdani','Ivy Dubreuil','Grifon Aldren','Michael Patrick McGill','Sachin Bhatt','Shawn-Caulin Young','Joy Osmanski','Roxana Ortega','David Theune','Cara Santana','Bruce M. Stockert','Christina Ferraro','Adam Zastrow','Teo Olivares','Tiffany Yvonne TCox'],
screenplay:['Victor Fresco','Ben Smith','Caitlin Meares','Simon Ganz','Chadd Gindin','Leila Cohan-Miccio','Romi Barta','Sarah Walker'],
production:['Nancy Juvonen','Leila Cohan-Miccio','Lisa Iannone'],
music:['John Debney','Josh Debney','Jeff Russo'],
camera:['Todd McMullen','Paul Maibaum'],
cut:['Shawn Paper','Lawrence A. Maddox','Andrew Doerfer','Steven Sprung'],
sound:['David Rawlinson'],
scenography:['Kitty Doris-Bates','Julie Bolder'],
costumes:['Mona May','Ashley Kemper']},
{title:'The Thin Blue Line',
titleCZ:'Tenká modrá linie',
year:1995,
runtime:'6h 46min',
episodeRuntime:'29min',
countries:['UK'],
genres:['Comedy'],
director:['John Birkin'],
actors:['Rowan Atkinson','Mina Anwar','James Dreyfus','David Haig','Mark Addy','Kevin Allen','Stephen Fry','Ricci Harnett','Walter Sparrow','Ben Elton','Alexander Armstrong','Jonathan Cake','Owen Teale','Robert Demeger','Lucy Robinson','Stephen Moore','Lloyd McGuire','Gabrielle Blunt','Nicola Stapleton','Colin McFarlane','Albie Woodington','Rupert Vansittart','Serena Evans','Ian Barritt','Alan Cox','Stephen Marcus','Sheila Gish','Natalie Walter','Bridget Turner','Amelda Brown','Melvyn Hayes','Geoffrey Chater','Neil Maskell','Ben Crompton','Bernard Gallagher','Rudolph Walker','Archie Panjabi','Bohdan Poraj','Bill Moody','Jake Wood'],
screenplay:['Ben Elton'],
music:['Howard Goodall'],
cut:['Charlie Phillips','Steve Tempia'],
scenography:['James Dillon'],
masks:['Lisa Westcott']},
{title:'Only Murders in the Building',
titleCZ:'Jen vraždy v budově',
year:2021,
runtime:'17h 30min',
episodeRuntime:'28-41min',
countries:['USA'],
genres:['Comedy','Crime','Mystery','Thriller'],
director:['Cherien Dabis','Jamie Babbit','Gillian Robespierre','Don Scardino','John Hoffman','Jude Weng','Chris Teague','Adam Shankman','Chris Koch','Shari Springer Berman'],
actors:['Steve Martin','Martin Short','Selena Gomez','Vanessa Aspillaga','Teddy Coluca','Adam DeCarlo','Quincy Dunn-Baker','Meredith Holzman','Nathan Lane','Aaron Dominguez','Michael Cyril Creighton','Jackie Hoffman','Jayne Houdyshell','Zainab Jah','Amy Ryan','Adriane Lenox','Sting','Anthony Ruiz','Maulik Pancholy','Tina Fey',"Da'Vine Joy Randolph",'Esteban Benito','William Ragsdale','Mandy Gonzalez','Jane Lynch','Cara Delevingne','Ava Eisenson','Michael Rapaport','Christine Ko','Ben Livingston','Shirley MacLaine','Amy Schumer','Zoe Margaret Colletti','Wakeema Hollis','Johnny Hopkins','Matthew Louie','Andrea Martin','Ken Holmes','Ariel Shafir','Ali Stroker','Jaboukie Young-White','Marie-Françoise Theodore','Samuel Farnsworth','Walker Hare','Mark Consuelos','Paul Rudd','Margaret Reed','Russell G. Jones','Jeena Yi','Ryan Broussard','Alysha Deslorieux','Meryl Streep','Ashley Park','Jesse Williams','Noma Dumezweni','Adrian Martinez','Gerrard Lobo','Harry Sutton Jr.','Linda Emond','Lisa Kron','Wesley Taylor','Jeremy Shamos','Caroline Valencia','Matthew Lamb','Matthew Broderick','Sprague Theobald','Mel Brooks','Marylouise Burke',"Ashanti J'Aria"],
screenplay:['Steve Martin','Kristin Newman','Ben Smith','John Hoffman','Kirker Butler','Thembi Banks','Kim Rosenstock','Madeleine George','Stephen Markley','Ben Philippe','Valentina Garza','Joshua Allen Griffith','Rob Turbovsky','Matteo Borghese','Sas Goldberg','J.J. Philbin','Tess Morris','Elaine Ko','Peter Swanson','Siena Streiber','Jake Schnesel'],
production:['Thembi Banks','Jane Raab','Nick Pavonetti','Rob Turbovsky','Matteo Borghese','Madeleine George','Sas Goldberg','Tess Morris'],
music:['Siddhartha Khosla'],
camera:['Chris Teague','Kyle Wullschleger'],
cut:['JoAnne Yarrow','Julie Monroe','Matthew Barbato','David L. Bertman','Shelly Westerman','Peggy Tachdjian'],
sound:['Mathew Waters','Andrew Garrett Lange','Penny Harold','Joe White'],
scenography:['Curt Beech','Rich Murray','Patrick Howe'],
masks:['Jackie Risotto','Jerry DeCarlo','Laura Burns'],
costumes:['Dana Covarrubias']},
{title:'Star Trek: Strange New Worlds',
titleCZ:'Star Trek: Podivné nové světy',
year:2022,
runtime:'28h 4min',
episodeRuntime:'46-63min',
countries:['USA'],
genres:['Action','Adventure','Drama','Sci-Fi'],
director:['Chris Fisher','Dan Liu','Amanda Row','Maja Vrvilo','Akiva Goldsman','Jonathan Frakes','Andi Armaganian','Sydney Freeland','Leslie Hope','Rachel Leiterman','Christopher J. Byrne','Valerie Weiss','Eduardo Sánchez','Jordan Canning','Jeff W. Byrd','Dermott Downs'],
actors:['Anson Mount','Ethan Peck','Christina Chong','Melissa Navia','Rebecca Romijn','Jess Bush','Celia Rose Gooding','Babs Olusanmokun','Bruce Horak','Dan Jeannotte','André Dae Kim','Melanie Scrofano','Carol Kane','Adrian Holmes','Paul Wesley','Gia Sandhu','Alex Kapp','Jennifer Hui','Etan Muskat','Samantha Smith','Angela Besharah','Ava Cheung','Atticus Mitchell','Cameron Roberts','Alden Adair','Ron Kennell','Torri Webster','Jesse James Keitel','Chandra Galasso','Lindy Booth','Ian Ho','Huse Madhavji','Shawn Ahmed','Stephen Sparks','Michael Hough','Roderick McNeil','Myles Dobson','Carlos Albornoz','Mathieu Bourassa','Ali Hassan','Sophia Walker','Bart Badzioch','Phi Huynh','Avaah Blackwell','Megha Sandhu','Brian Quintero','Sage Arrindell','Chris River','Samer Salem','Shannon Widdis','Tawny Newsome','Jack Quaid','Andrew Jackson','Jamillah Ross','Hannah Spear','Alex Spencer','Laura Wilson','Russell Yuen','Yetide Badaki','Graham Parkhurst','Jim Annan','Anna Claire Beitel','Catherine Black','Eugene Clark','Nicky Guadagni','David Benjamin Tomlinson','Kimberly-Ann Truong','Noah Lamanna','Adelaide Kane','Allison Wilson-Forbes','Tiffany Martin','Reed Birney','Simon Northwood','Mia Kirshner','Michael Benyaer','Ellora Patnaik','Michael Reventar','Noël Wells','Eugene Cordero',"Jerry O'Connell",'Greg Bryk','Robert Wisdom','Clint Howard','Ryan Allen','Kyle Gatehouse','Vanessa Smythe','Martin Quinn','Sonequa Martin-Green'],
screenplay:['Henry Alonso Myers','Davy Perez','Bill Wolkoff','Akiva Goldsman','Sarah Tarkoff','Akela Cooper','Beau DeMayo','Robin Wasserman','Dana Horgan','David Reed','Kirsten Beyer','Kathryn Lyn'],
production:['Andrea Raffaghello','Bill Wolkoff','Jason Michael Zimmerman','Paul Gadd','Kathryn Lyn','Beau DeMayo'],
music:['Nami Melumad','Tom Polce','Kay Hanley'],
camera:['Glen Keenan','Magdalena Górka','Benji Bakshi','Ian Anderson'],
cut:['Andrew Coutts','Dana Gasparine','John Wesley Whitton','Preston Rapp'],
sound:['Todd Grace','Ed Carr'],
scenography:['Jonathan Lee','Justin Craig','Tijana Petrovic','Hayley Isaacs'],
masks:['Daniella Pluchino'],
costumes:['Bernadette Croft','Gersha Phillips']},
{title:'Noragami',
titleCZ:'Noragami',
year:2014,
runtime:'10h 25min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Action','Fantasy','Comedy'],
director:['Kótaró Tamura','Masaši Abe','Satoši Nakagawa','Satomi Nakamura','Jošifumi Sueda','Takuró Cukada','Šúdži Mijahara','Kacumi Terahigaši'],
actors:['Hiroši Kamija','Maaja Učida','Júki Kadži','Aki Tojosaki','Mijuki Sawaširo','Rie Kugimija','M.A.O','Miki Itó','Nao Tójama','Misaki Kuno','Džun Fukujama','Júki Ono','Jumiko Kobajaši','Takahiro Sakurai','Himika Akaneja','Ari Ozawa','Tošiki Masuda','Jukijo Fudžii','Hiroši Janaka','Misako Tomioka','Kazuhiko Inoue','Šiori Izawa',"Šin'ja Takahaši",'Kanami Sató','Saori Hajami','Mikako Komacu','Kanae Oki','Kanehira Jamamoto','Ajumu Murase','Nacuki Hanae','Haruki Išija','Acumi Tanezaki','Tóru Ókawa','Nana Hamasaki',"Džun'ja Enoki",'Daisuke Ono','Kengo Kawaniši','Hiroki Gotó','Momo Asakura','Júsuke Kuwahata','Kaito Išikawa','Hibiku Jamamura','Takehiro Hasu','Jošitaka Jamaja','Kijoko Mijazawa','Takanori Hošino',"Šin'ja Hamazoe",'Satomi Akesaka','Kótaró Nišijama','Juiko Tacumi','Hisako Tódžó','Šunsuke Sakuja','Ruriko Aoki','Minami Takahaši','Kaoru Katakai',"Šun'iči Maki",'Kazumasa Nakamura','Juki Takao','Momoe Kišimoto','Šó Karino','Naoto Kobajaši','Čihiro Išiguro','Júko Takajama','Tomoja Kósaka','Fumija Sugiura'],
basedOn:['Adachi Toka'],
screenplay:['Deko Akao','Hiroko Fukuda','Akiko Waba'],
production:['Tomokazu Iizumi'],
music:['Taku Iwasaki','Kajo Koniši','Jukio Kondó'],
camera:['Majuko Furumoto'],
cut:['Kumiko Sakamoto'],
sound:['Satoki Iida','Minoru Jamada'],
scenography:['Kazuo Nagai']},
{title:'Snowfall',
titleCZ:'Sněží!',
year:2017,
runtime:'45h 33min',
episodeRuntime:'38-57min',
countries:['USA'],
genres:['Crime','Drama'],
director:['John Singleton','Adil El Arbi','Bilall Fallah','Daniel Attias','Hiro Murai','Lawrence Trilling','Michael Lehmann','Zetna Fuentes','Solvan Naim','Meera Menon','Sunu Gonera','Alex Graves','Deborah Chow','Clark Johnson','Logan Kibens','Tanya Hamilton','Alonso Alvarez','Erin Feeley','Carl Seaton','Kevin Bray','Karena Evans','Ugla Hauksdóttir','Greg Yaitanes','Ben Younger','Damian Marcano','Kevin Rodney Sullivan','Katrelle N. Kindred','Jade Holmes Christian','Amin Joseph'],
actors:['Damson Idris','Amin Joseph','Emily Rios','Sergio Peris-Mencheta','Michael Hyatt','Tim Matheson','Mark Rolston','Darius McCrary','Andrea Bogart','Brett Rice','Camila Banus','Lucas Di Medio','Taylor Kowalski','Alon Aboutboul','Nic Bishop','Peta Sergeant',"Becky O'Donohue",'Damon Standifer','José Zúñiga','Mark Harelik','Markice Moore','Karen Malina White','Nick Thurston','Zabryna Guevara','Marcel Ruiz','Hansel Ramírez','Kevin Carroll','Bokeem Woodbine','Michael Ray Escamilla','Bernardo Badillo','Johnny Ray Gill','Ervin Ross','Errol Sack','Marcus Henderson','RZA','Justine Lupe','Susane Lee','Cecil Elmore Jr.','Sheaun McKinney','Carlos Linares','Peggy Blow','Clayton Cardenas','Augusto Aguilera','Nathan Davis Jr.','C.S. Lee','Manuel Uriza','Judith Scott','Kaili Thorne','Raymond Forchion','Reign Edwards','Jonathan Tucker','Alanna Ubach','DeRay Davis','Gail Bean','Emma Lahti','Ricardo Adam Zarate','Izzy Diaz','Michael Benyaer','Kirk Baltz','Marco Rodríguez','DomiNque Perry','Caroline Ivari','June Carryl','Matthew Alan','Stephanie Erb','Ashleigh Morghan','Billy Malone','Saundra Santiago','Trinitee','Joy Brunson','Tony Espinosa','Casey Adams','John Lacy','Isaiah John','Gloria Garayua','Cat Ce','Carter Hudson','Melvin Gregg','John Diehl','David Warshofsky','Adriana Barraza','Ian Casselberry','Matthew Bellows','Hector Hugo','Kenneth Choi','Andrea Londo','Michael Gonzales','Verton R. Banks','Bianca Lopez','Jesse Luken',"De'aundre Bonds",'Jon Chaffin','Taylor Mosby','Jerry Kernion','Danielle Moné Truitt','Jonathan Avigdori','Bentley Green','Sonya Leslie','Asjha Cooper','Ellie Patrikios'],
screenplay:['John Singleton','Eric Amadio','Emmy Grinwis','Sal Calleros','Dave Andron','Walter Mosley','Janine Salinas Schoenberg','Tatiana Suarez-Pico','Aziza Barnes','Enzo Mileti','Scott Wilson','Hiram Martinez','Justin Hillian','Jeanine Daniels','Tyger Williams','Ihuoma Ofordire','Leonard Chang','Davia Carter','Jerome Hairston','Natalia Guled'],
production:['Sal Calleros','Jessie Imundi','Julie DeJoie','Tony Mark','Damson Idris','Jerome Hairston','Natalia Guled','Steven Heth','Evan Silverberg','Davia Carter'],
music:['Jeff Russo'],
camera:['Robrecht Heyvaert','Tommy Maddox-Upshaw','Jeffrey Greeley','Eliot Rockett','Christian Tico Herrera','Luis David Sansans'],
cut:['Hunter M. Via','Trevor Baker','Louise Innes','Matthew Colonna','Keith Henderson','Jason Cherella','Vanessa Ruane','Jeffrey A. Stallman','Susana Benaim'],
sound:['Andrew Spencer Dawson','Joe Earle','Pedro Sánchez Alonso','Doug Andham','Diethard Keck'],
scenography:['Tomas Voth','Rebekah Killam','Corinne Delouise'],
masks:['Shian S. Banks','Mike Smithson','Taschi Lynell','Loretta Nero','Debra Denson','Jori Jenae McGuire','Alicia M. Tripi'],
costumes:['Kelli Jones','Alonzo Van Wilson','Mynka Draper']},
{title:'1 Litre of Tears',
titleCZ:'1 litre no namida',
year:2005,
runtime:'9h 54min',
episodeRuntime:'54min',
countries:['Japan'],
genres:['Drama','Romance'],
director:['Masanori Murakami'],
actors:['Erika Sawadžiri','Rjó Nišikido','Naohito Fudžiki','Riko Narumi',"Ken'iči Macujama",'Takanori Džinnai',"Ken'iči Jadžima",'Šigejuki Tocugi','Saori','Juki Umoto','Júki Sató','Tošihide Tonesaku','Hiroko Jakušimaru','Hiroši Kacuno','Júma Sanada','Ai Mijoši','Momosuke Mizutani','Kana Macumoto','Rjó Hašizume','Makoto Kawahara','Júja Endó','Nacuko Hošino','Kazuko Kató','Asae Óniši','Maja Hamaoka'],
basedOn:['Aja Kitó'],
screenplay:['Satomi Óšima','Mičiru Egašira','Rie Jokota']},
{title:'Taken',
titleCZ:'Uneseni',
year:2002,
runtime:null,
episodeRuntime:'14h84min',
countries:['USA'],
genres:['Drama','Sci-Fi'],
director:['Jeremy Kagan','Bryan Spicer','John Fawcett','Breck Eisner','Félix Enríquez Alcalá','Robert Harmon','Tobe Hooper','Sergio Mimica-Gezzan','Michael Katleman','Jeff Woolnough','Thomas J. Wright'],
actors:['Dakota Fanning','Matt Frewer','Emily Bergl','Heather Donahue','Joel Gretsch','Adam Kaufman','John Hawkes','Ryan Hurst','Camille Sullivan','Eric Close','James McDaniel','Andy Powers','Steve Burton','Catherine Dent','Julie Ann Emery','Jason Gray-Stanford','Desmond Harrington','Brian Markinson','Tina Holmes','Roger Cross','Anton Yelchin','Ken Pogue','Michael Moriarty','Justin Chatwin','Ryan Merriman','Ian Tracey','Gabrielle Rose','Julie Benz','Andrew Jackson','Tobias Mehler','Timothy Webber','Jay Brazeau','Elle Fanning','R. Nelson Brown','Fulvio Cecere','Janet Wright','Erin Karpluk','Sam Easton','Emily Holmes','Aaron Douglas','Kevin Durand','Gwynyth Walsh','Antonio Cupo','Max Martini','Jonathon Young','Mark Hildreth','Nolan Gerard Funk','Alessandro Juliani','Ryan Robbins','Ty Olsson','James Kirk','Jeffrey Ballard','Chad Donella','David Paetkau','Willie Garson','Ben Cotton','Britt Irvin','Terry Chen','Kevin G. Schmidt','Serge Houde','Frederick Koehler','Philip Granger','Aaron Pearl','Kimani Ray Smith','Sarah-Jane Redmond','Steven Grayhm','Matthew Currie Holmes','Jesse Hutch','Karen Austin','Devin Douglas Drewitz','Peter Benson','Rob LaBelle','Jerry Wasserman','Peter Bryant','James Hutson','John B. Lowe','Patrick Gallagher','Tom Heaton','Alf Humphreys','Don Thompson','Stephen E. Miller','Dean Wray','Brent Stait','Catherine Barroll','Steve Makaj','Colleen Winton','Rondel Reynoldson','Michael Soltis','Glynis Davies','Paralee Cook','Richard Stroh','Lachlan Murdoch','Malcolm Stewart','Andrew Johnston','Terry David Mulligan','Fred Henderson','Matthew Walker','Laurie Murdoch','Alison Matthews','Ralph Alderman'],
screenplay:['Leslie Bohem'],
production:['Richard Heus'],
music:['Laura Karpman'],
camera:['Jonathan Freeman','Joel Ransom'],
cut:['Eric Goldfarb','Michael D. Ornstein','Toni Morgan','Frederick E.O. Toye','David Abramson'],
sound:['Richard L. Morrison','Chris Haire','David B. Cohn','Richard Taylor'],
scenography:['Chris Gorak','Michael Norman Wong'],
masks:['Charles Porlier','Paul Edwards','Patricia Murray'],
costumes:['Susan De Laval']},
{title:'The Midnight Gospel',
titleCZ:'Půlnoční evangelium',
year:2020,
runtime:'3h 28min',
episodeRuntime:'20-37min',
countries:['USA'],
genres:['Animation','Comedy'],
director:['Pendleton Ward','Mike L. Mayfield'],
actors:['Phil Hendrie','Joey Diaz','Duncan Trussell','Natasha Leggero','David Nichtern','Johnny Pemberton','Drew Pinsky','Pauly Shore','Maria Bamford','Stephen Root','Steve Little','Will Oldham','Dante Pereira-Olson','Ram Dass','Eddie Pepitone','Christina Pazsitzky'],
screenplay:['Mike L. Mayfield'],
music:['Joe Wong'],
cut:['Megan Love'],
sound:['Jeff Halbert']},
{title:'Frasier',
titleCZ:'Frasier',
year:1993,
runtime:'102h 31min',
episodeRuntime:'21-44min',
countries:['USA'],
genres:['Comedy'],
director:['Kelsey Grammer','Pamela Fryman','James Burrows','Sheldon Epps','Scott Ellis','Wil Shriner','Jerry Zaks','Alan Myerson','Ken Levine','Jeff Melman','Dan Butler','Katy Garretson','David Lee','Ken Lamkin','Andy Ackerman','Cynthia J. Popp','Gordon Hunt','Philip Charles Mackenzie','Rick Beren','Kelly Park','Phill Lewis','Joyce Gittlin','Victor Gonzalez'],
actors:['Kelsey Grammer','Jane Leeves','David Hyde Pierce','Peri Gilpin','John Mahoney','Moose','pes Enzo','Edward Hibbert','Saul Rubinek','Marsha Mason','Harriet Sansom Harris','Anthony LaPaglia','Felicity Huffman','Jean Smart','Pauley Perrette','T.R. Knight','Krista Allen','Celia Weston','Patricia Wettig','Rosa Blasi','Jay Leno','Andy Garcia','Freddie Prinze Jr.','Todd Louiso','Željko Ivanek','Jane Kaczmarek','John Finn','Rhea Perlman','Chris Diamantopoulos','Lisa K. Wyatt','Scott Lowell','Mary Elizabeth Mastrantonio','Gabrielle Fitzpatrick','Mark Blum','Brian Klugman','Matt Roth',"Tricia O'Kelley",'Michael Welch','Valarie Pettiford','Kathryn Joosten','Sharon Madden','Cameron Watson','Sarah Shahi','Kelvin Yu','Cyd Charisse','Suzanne Stokes','Kristin Chenoweth','Heather MacRae','Bellamy Young','Kimberly Oja','Michael Weston','Timothy Omundson','Penny Johnson Jerald','Michael Medico','Macaulay Culkin','Lisa Edelstein','Gregg Berger','Jane Adams','Katarina Witt','Karl T. Wright','Caroline Lagerfelt','Timothy Leary','Rachel Dratch','Patrick Breen','Anita Gillette','Ben Stiller','S. Epatha Merkerson','Woody Harrelson','Gary Sinise','Katie Finneran','Megan Mullally','Shannon Tweed','Michael McFall','Gabrielle Miller','Todd Babcock','Michael Des Barres','John Michael Higgins','Anthony Montgomery','Joe Flaherty','Montae Russell','Penny Marshall','Eric Stoltz','Tony Cox','John Glover','Eric Lutes','Carrie Fisher','Gillian Anderson','Claire Stansfield','Philip Casnoff','Fran Kranz','Robert Klein','Paul F. Tompkins','John C. McGinley','Michelle Stafford','Delaina Mitchell','Mark Ryan','Amy Brenneman','Ted King','Rachael Harris','Hilary Duff'],
screenplay:['David Isaacs','Suzanne Martin','Ken Levine','Dan Cohen','Brad Hall','Lloyd Garver','Saladin K. Patterson','David Lee','Bob Daily','Steven Levitan','Christopher Lloyd','Ron Darian','Jeffrey Richman','Jack Burditt','Elias Davis','David Pollock','Joe Keenan','Patricia Breen','Mark Reisman','Sy Dukane','David Angell','Peter Casey','Rob Greenberg','Jay Kogen','Dave Hackel','Eric Zicklin','Sam Johnson','Chris Marcil','Rob Hanning','Denise Moss','Michael B. Kaplan','Lori Kirkland Baker','Charlie Hauck','David Lloyd','Janis Hirsch','Heide Perlman','Leslie Eberhard','Molly Newman','Anne Flett-Giordano','Chuck Ranberg','Tom Reeder','Sy Rosen','Chris Harris','Joe Cristalli','Stephen Lloyd','Lauren Houseman','Farhan Arshad','Don Seigel','Miles Woods',"Dan O'Shannon",'Robb Chavis','Janene Lin'],
production:['Bob Daily','Elias Davis','David Pollock','Rob Greenberg','Eric Zicklin','Maggie Blanc'],
music:['Bruce Miller'],
camera:['Ken Lamkin','Jerry Workman','Gary Baum']},
{title:'The Umbrella Academy',
titleCZ:'Umbrella Academy',
year:2019,
runtime:'30h 11min',
episodeRuntime:'40-60min',
countries:['USA'],
genres:['Action','Adventure','Comedy'],
director:['Peter Hoar','Andrew Bernstein','Ellen Kuras','Stephen Surjik','Jeremy Webb','Sylvain White','Tom Verica','Amanda Marsalis','Cheryl Dunye','Jeff F. King','Kate Woods','Paco Cabezas'],
actors:['Elliot Page','Tom Hopper','David Castañeda Jr.','Emmy Raver-Lampman','Robert Sheehan','Aidan Gallagher','Mary J. Blige','Cameron Britton','Adam Godley','Colm Feore','Sheila McCarthy','Justin H. Min','Jordan Claire Robbins','John Magaro','Cameron Brodeur','Eden Cupid','T.J. McGibbon','Blake Talabis','Dante Albidone','Ethan Hwang','Kate Walsh','Ashley Madekwe','Peter Outerbridge','Sean Sullivan','Paskal Vaklev','Rainbow Sun Francks','Zachary Bennett','Emily Piggford','Stephen R. Hart','Jim Watson','Dan Willmott','Soo Garay','Quancetia Hamilton','Mark Taylor','Thomas Craig','Patrick Stevenson','Jordana Blake','Ashley Madekwe','John F. Kennedy','Josif Vissarionovič Stalin','Adolf Hitler','Birva Pandya','Thomas Mitchell','Patrice Goodman','Laura Cilevitz','Alyssa Gervasi','Liisa Repo-Martell','Ritu Arya','Yusuf Gatewood','Marin Ireland','Kevin Rankin','Kris Holden-Ried','John Kapelos','Stephen Bogaert','Raven Dauda','Dewshane Williams','Tom Sinclair','Patrick Garrow','Christian Lloyd','Steve Coombes','Richard Waugh','Bo Martynowska','Matthew Edison','Sheila McCarthy','Mary J. Blige','Dov Tiefenbach','George Wyner','Mindy Sterling','Jason Blicker','Ken Hall','Cameron Britton','Mouna Traoré','Katherine Trowell','Robert Maillet','Rod Wilson','Morgan Kelly','Jacqueline Kennedy','Eden Cupid','John Magaro','T.J. McGibbon','Lyndon B. Johnson','Philip Craig','Eli Martyr','Kerr Hewitt','Jesse Noah Gruman','Eric Peterson','Marianna Phung','Neil Bennett','Trish Rainone','Dorly Jean-Louis','Marium Carvell','Matt Biedel','Cody Ray Thompson','Melissa Murray-Mutch','Calem MacDonald','William Ng','Massey Ahmar','Jason Bryden','Justin Kelly','Tony Marra'],
basedOn:['Gerard Way','Gabriel Bá'],
screenplay:['Mark Bomback','Rawson Marshall Thurber','Steve Blackman','Jeremy Slater','Ben Nedivi','Matt Wolpert','Lauren Schmidt','Robert De Laurentiis','Mark Goffman','Nikki Schiefelbein','Sneha Koorse','Michelle Lovretta','Robert Askins','Jesse McKeown','Aeryn Michelle Williams','Elizabeth Padden','Lauren Otero','Bronwyn Garrity'],
production:['Mike Richardson','Kevin Lafferty','Sneha Koorse','Everett Burrell','Steve Wakefield','Robert Askins','Jamie Neese'],
music:['Jeff Russo','Perrine Virgile'],
camera:['Neville Kidd','Craig Wrobleski'],
cut:['Timothy A. Good','Amy E. Duddleston','Todd Desrosiers','Wendy Tzeng','Franklin Peterson','Jon Dudkowski','Brian Beal'],
sound:['Joe DeAngelis','Albert Romero','Patrick Hogan','John Benson','Chris Carpenter','Doug Johnston'],
scenography:['Mark Worthington','Mark Steel','Jim Lambie','Carey Meyer'],
masks:['Antoinette Julien','Suzanne Heibati','Jeanette Stawiarski','Robert White','Trason Fernandes','Sarah Craig'],
costumes:['Christopher Hargadon']},
{title:'Big Mouth',
titleCZ:'Big Mouth',
year:2017,
runtime:'32h 56min',
episodeRuntime:'25-46min',
countries:['USA'],
genres:['Animation','Comedy'],
director:['Joel Moser','Bob Suarez','Mike L. Mayfield','Kim Arndt','Andres Salaff','Bryan Francis','Henrique Jardim','Alex Salyer','Chris Ybarra','Bob Bowen','Paul Scarlata','Dave Stone'],
actors:['Fred Armisen','Jessi Klein','Nick Kroll','Jason Mantzoukas','John Mulaney','Jordan Peele','Maya Rudolph','Jenny Slate','Richard Kind','Paula Pell','Andrew Rannells','June Diane Raphael','Jessica Chaffin','Rob Huebel','Kat Dennings','Kristen Bell','Jon Daly','Jess Harnell','Mark Duplass','Nathan Fillion','Chelsea Peretti','Paul Scheer','Carlos Alazraqui','Nasim Pedrad','Kristen Wiig','Alia Shawkat','Rosa Salazar','Mae Whitman','Zach Woods','Jon Hamm','Michaela Watkins','Jack McBrayer','Craig Robinson','Gina Rodriguez','David Thewlis','Andy Daly','Natasha Lyonne','Harvey Fierstein','Jerry Minor','Bobby Cannavale','Jean Smart','Neil Casey','Seth Morris','Zachary Quinto','Emily Altman','Gary Cole','Chris Redd','Martin Short','Julie White','Ali Wong','David Cross','Judd Hirsch','Carol Kane','Julie Klausner','Quinta Brunson','Tawny Newsome','Retta','Wanda Sykes','Jaboukie Young-White','Joel Kim Booster','Rob Riggle','Bobby Berk','Karamo Brown','Tan France','Thandiwe Newton','Antoni Porowski','Jonathan van Ness','Jak Knight','Heather Lawless','Gil Ozeri','Ayo Edebiri','Maria Bamford','Willie Garson','Mitra Jouhari','John Oliver','Seth Rogen','Josie Totah','Somali Rose','Lena Waithe','Paul Giamatti','Sterling K. Brown','Lynn Chen','Max Silvestri','Maya Erskine','Anna Konkle','Brandon Kyle Goodman','Xosha Roquemore','Karan Soni','Zach Galifianakis','Mark Rivers','Philip Quinaz','Fran Gillespie','Chloe Fineman','Brian Tyree Henry','Kristen Schaal','Peter Capaldi','Georgie Kidder',"Chris O'Dowd",'Juliet Mills','Annaleigh Ashford'],
screenplay:['Mark Levin','Victor Quinaz','Duffy Boudreau','Jennifer Flackett','Nick Kroll','Alex Rubens','Jaboukie Young-White','Andrew Goldberg','Emily Altman','Jak Knight','Max Silvestri','Gil Ozeri','Jess Dweck','Mitra Jouhari','Brandon Kyle Goodman','Hayley Adams','Joellen Redlingshafer','Kelly Galuska','Gabe Liedman'],
production:['Emily Altman','Gil Ozeri','Chris Prynoski','Abe Forman-Greenwald','Victor Quinaz','Nate Funaro','Brandon Kyle Goodman','Ben Kalina','Shannon Prynoski'],
music:['Mark Rivers'],
cut:['Felipe Salazar'],
sound:['Hunter Curra','James Lucero','Konrad Piñon']},
{title:'Star vs. The Forces of Evil',
titleCZ:'Star proti silám zla',
year:2015,
runtime:'28h 12min',
episodeRuntime:'20-23min',
countries:['USA'],
genres:['Animation','Comedy','Family'],
director:['David Wasson','Michael Mullen','Brett Varon','Amelia Lorenz','Aaron Hammersley','Dominic Bisignano','Piero Piluso'],
actors:['Eden Sher','Jeff Bennett','Grey Griffin','Fred Tatasciore','Alan Tudyk','Nate Torrence','Nia Vardalos','Corey Burton','Jenny Slate','Rob Paulsen','Nick Swardson','Minae Noji','Maurice LaMarche','Eddie Deezen','Jon Heder','Brian Posehn','Rider Strong','Joshua Rush','Dee Dee Rescher','Kari Wahlgren','Hynden Walch','Eric Bauza','Keone Young','Daron Nefcy','Leigh-Allyn Baker','Zosia Mamet','Nicole Byer','Veronica Dunne','Laura Silverman','Julian Edwards','Natalie Palamides','Dominic Catrambone','Kenny Pittenger','April Winchell','Max Mittelman','Cindy Robinson','Mark Gagliardi','Brian Michael Jones','Dominic Bisignano','Madeleine Curry','Gabriel Oliva','Kate Higgins','Jenna Rosen','Lyons Mathias','Sean Schemmel','John Mathot','Dave Wittenberg'],
screenplay:['Daron Nefcy','Emily Brundige','Ian Wasseluk','Bert Youn','Kyle Neswald','Michael Mullen','Lane Lueras','Casey Crowe','Kenny Pittenger',"Scott O'Brien",'Brett Varon','Nate Cash','Amelia Lorenz','Zach Marcus','Aaron Hammersley','Katie Crown','Madeleine Flores','Annisa Adjani','Zeus Cervas','Dominic Bisignano','Gina Gress','Piero Piluso','Carlos Ramos','John Mathot','Riccardo Durante','Sarah Oleksyk','Dave Stone','Carder Scholin'],
production:['Aaron Hammersley','Dominic Bisignano'],
music:['Brian H. Kim','Ego Plum'],
cut:['Ted Supa','Anthony F. Rocco'],
sound:['Fil Brown','Melissa Ellis','Heather Olsen','Shaun Cunningham','Robert Poole II'],
scenography:['Josh Parpan','Justin Parpan']},
{title:'Philip Marlowe, Private Eye',
titleCZ:'Detektiv Marlowe',
year:1983,
runtime:'9h 9min',
episodeRuntime:'48-53min',
countries:['UK','Canada'],
genres:['Crime','Mystery'],
director:['Peter R. Hunt','Sidney Hayers','Bryan Forbes','David Wickes','Robert Iscove','Allan King','Martin Lavut'],
actors:['Powers Boothe','John Terry','Ian A. Wallace','Linda Griffiths','John Vernon','Paul Hecht','Ken Pogue','R.H. Thomson','Melody Anderson','Mark Humphrey','William Hootkins','Louis Negin','Michele Scarabelli','Billy Kearns','Wayne Robson','Eugene Clark','Wanda Cannon','Jennifer Dale','George Buza','Kate Trotter','Gayle Hunnicutt','Denis Forest','Shane Rimmer','Ed Bishop','Michael Shannon','Kip King','Richard Donat','Frank Moore','Gene Mack','Bill Bailey','John Alderson','Jurij Borienko','Marc Smith','Peter Frye','Lucy Lee Flippin','David Baxt','Barbara Rosenblat','Mike Edmonds','Amanda Boxer','Michael Copeman','Jill Melford','Miquel Brown','Joe Praml','Hal Galili','David Byrd','Christopher Muncke','Chuck Julian','Bruce Boa','Isabelle Mejias','Kate Reid','Allan Royal','Michael Billington','Terence Mountain','Robert Sutton','Richard LeParmentier','Ray Jewers','Sandra Dickinson','Tony Sibbald','Stephen Davies','J. Winston Carroll','Ed McNamara','Ernesto Macias','Ardon Bess','Kathryn Leigh Scott','David Healy','Kristopher Kum','Richard Aylen','Peter Brace','Steve Plytas','Lise Hilboldt','Liza Ross','Paul Maxwell','Garrick Hagon','Peter Dvorsky','August Schellenberg','Helen Shaver','Peter MacNeill','Gary Farmer','Robin Givens','Al Waxman','Anthony Sherwood','Victoria Snow','Roxanne Hart','Cec Linder','John Ireland','Maury Chaykin','Matt Craven','Steve Mirer','Sally Julian','Booth Savage','Michael Melvin','Arabella Weir'],
basedOn:['Raymond Chandler'],
screenplay:['Jesse Lasky Jr.','Jo Eisinger','David Wickes','Jeremy Hole','Pat Silver','Murray Smith'],
production:['David Wickes','Jon Slan'],
music:['John Cameron','Samuel Matlovsky'],
camera:['Michael Reed','Rene Ohashi','Frank Beascoechea'],
cut:['Bill Lenny','Ronald Sanders','David Nicholson','Eric Wrate'],
scenography:['Mary Ann Biddle','Gina Hamilton'],
costumes:['Delphine White','Jane Robinson']},
{title:'Great Performances at the Met',
titleCZ:'Metropolitan Opera: Live in HD',
year:2006,
runtime:null,
episodeRuntime:'190min',
countries:['USA'],
genres:['Music'],
director:['Gary Halvorson','Brian Large','Yimou Zhang','Anthony Minghella','Julie Taymor','Franco Zeffirelli','Richard Eyre'],
actors:['Renée Fleming','Anna Netrebko','Juan Diego Flórez','Plácido Domingo','Frank Langella','Dmitri Hvorostovsky','Ramón Vargas','Philip Willingham','Luc Bondy','Roberto Alagna','Dan Joyce','Hsing-kuo Wu','Marina Poplavskaja','Gaston Rivero','Adrian Noble','Andreas Scholl','Christophe Dumaux','Semjon Byčkov','William Christie','Sarah Connolly','Danielle de Niese','Richard Croft','Piotr Beczala','Ildar Abdrazakov','Michail Petrenko','Oksana Dyka','Anita Račvelišvili','Sergey Semishkur','Štefan Kocán','Vladimír Chmelo','Julie Boulianne','Emily Magee','John Relyea','Jack Wetherall'],
basedOn:['Alexandr Sergejevič Puškin','Alexandre Dumas mladší','Tim Rice'],
screenplay:['Victor Hugo','William Shakespeare','Emanuel Schikaneder'],
sound:['Mark Mandler'],
scenography:['Boris F. Kudlicka','Christian Fenouillat','Paul Brown','Chantal Thomas','Maria Björnson','Es Devlin'],
costumes:['Agostino Cavalca','Paul Brown','Laurent Pelly']},
{title:'The Professionals',
titleCZ:'Profesionálové',
year:1977,
runtime:'47h 30min',
episodeRuntime:'50min',
countries:['UK'],
genres:['Action','Crime','Adventure'],
director:['William Brayne','Martin Campbell','Dennis C. Lewiston','Anthony Simmons','David Wickes','Dennis Abey','Ian Sharp','Douglas Camfield','Ray Austin','Christopher King','Chris Burt','Phil Méheux','Pat Jackson','Tom Clegg','Charles Crichton','Ernest Day','Sidney Hayers','Peter Medak','Francis Megahy','Raymond Menmuir','Pennant Roberts','Benjamin Wickers','Ferdinand Fairfax',"Gerry O'Hara",'James Allen','Roger Tucker','John Crome','Horace Ové'],
actors:['Gordon Jackson','Martin Shaw','Lewis Collins','Ian McDiarmid','Pierce Brosnan','Steve Alder','Jiří Pravda','David Suchet','Peter Cellier','Patrick Malahide','Patricia Quinn','Vicki Michelle','Nick Brimble','David Bradley','James Faulkner','Sarah Douglas','Michael Gothard','Barbara Kellerman','Philip Latham','Michael Kitchen','Clarke Peters','Michael Coles','Johnny Shannon','Neil McCarthy','Tony Osoba','Billy Murray','Nadim Sawalha','George Harris','Patricia Hodge','P. H. Moriarty','Mark Wingett','Dick Sullivan','Michael Elphick','Peter Polycarpou','Sean Chapman','John Castle','Charles Dance','Pamela Stephenson','Tom Georgeson','Nickolas Grace','Patrick Ryecart','Jonathan Newth','Geoffrey Freshwater','Jeremy Bulloch','Tim Meats','Marsha Fitzalan','David Mallinson','William Morgan Sheppard','Frances Low','Jon Cartwright','George Little','Martyn Whitby','Diane Keen','Godfrey James','Lloyd McGuire','Richard Murdoch','Vincent Wong','Richard Albrecht','John Cording','Barrie Cookson','Geoffrey Bateman','Al Matthews','Robert Putt','Charles Pemberton','Edward Judd','Vic Tablian','Jill Baker','Ed Bishop','Alan Tilvern','Mark Colleano','Robert Dorning','Susan Wooldridge','Stanley Meadows','Anthony Morton','Charles Cork','Keith Marsh','Robert James','Forbes Collins','Sylvia Kay','Norman Gregory',"Derrick O'Connor",'Liz Fraser','Kenneth Nelson','Nicholas Amer','Larry Lamb','John H. Francis','Michael Craig','Stephan Chase','Roy Boyd','Emma Relph','David Swift','Stephen Yardley','Jon Rumney','Mario Renzullo','Pat Gorman','Hildegard Neil','Joseph Marcell','Tony Jay','Paul Daneman','Harry Fowler'],
screenplay:['Brian Clemens','Ranald Graham',"Gerry O'Hara",'Anthony Read','Roger Marshall','Christopher Wicking','Edmund Ward','Don Houghton','Dennis Spooner','Stephen Lister','Tony Barwick','Michael Armstrong','Peter Hammond','Michael Feeney Callan','Ted Childs','Robin Estridge','John Goldsmith','Douglas Watkinson','John Kruse','Dave Humphries','Paul Wheeler'],
production:['Raymond Menmuir','Tristan Lynch'],
music:['Laurie Johnson'],
camera:['Dusty Miller','Ernest Steward','Norman Langley','Vernon Layton','Phil Méheux','Frank Watts','Graham Edgar','Michael J. Davis','Barry Noakes','Tony Imi','David Findlay','Norman G. Langley'],
cut:['Alan Killick','Mike Campbell'],
sound:['David Crozier','Chris Munro'],
scenography:['Tony Curtis'],
masks:['Alan Boyle']},
{title:'The Undoing',
titleCZ:'Mělas to vědět',
year:2020,
runtime:'5h 38min',
episodeRuntime:'50-67min',
countries:['USA'],
genres:['Drama','Thriller'],
director:['Susanne Bier'],
actors:['Nicole Kidman','Hugh Grant','Donald Sutherland','Édgar Ramírez','Noah Jupe','Lily Rabe','Matilda De Angelis','Ismael Cruz Cordova','Noma Dumezweni','Sofie Gråbøl','Jeremy Shamos','Edan Alexander','Naledi Murray','Michael Devine','Vedette Lim','Maria Dizzia',"Alana O'Brien",'Victoria Zalipsky','Sophia Zalipsky','Melania Zalipsky','Tarik Davis','Janel Moloney','Tracee Chimo Pallero','Andrew Keenan-Bolger','Doris McCarthy','Annaleigh Ashford','Fala Chen','Lynn Marocola','Kate Greer','Conor William Wright','Jason Furlani','Jason Kravits','Douglas Hodge','Adriane Lenox','Connie Chung','Rosemary Harris','Clint Jung','Jamar Greene','Jeb Kreager','Casey Braxton'],
basedOn:['Jean Hanff Korelitz'],
screenplay:['David E. Kelley'],
production:['Deb Dyer'],
music:['Jevgenij Galperin','Saša Galperin'],
camera:['Anthony Dod Mantle'],
cut:['Ben Lester'],
sound:['Ben Barker','Glenn Freemantle'],
scenography:['Lester Cohen','Keri Lederman'],
masks:['Caitlin Boland','Michael Marino','Kay Georgiou','Robert Lugo'],
costumes:['Signe Sejlund']},
{title:"A Young Doctor's Notebook",
titleCZ:'Zápisky mladého doktora',
year:2012,
runtime:'3h 3min',
episodeRuntime:'21-24min',
countries:['UK'],
genres:['Drama','Comedy','History'],
director:['Alex Hardcastle','Robert McKillop'],
actors:['Jon Hamm','Daniel Radcliffe','Adam Godley','Rosie Cavaliero','Margaret Clunie','Charles Edwards','Cara Horgan','Tim Key','Lee Asquith-Coe','Steve Speirs','Neil Edmond','Karina Fernandez','Shaun Pye','James Grogan','Miles Jupp','Joshua McGuire','Vicki Pepperdine','Janine Duvitski','Geoffrey McGivern','Colin Hoult','Daniel Cerqueira','Susy Kane','Tayler Marshall','Jake Mann','Rebecca Gethings','Wendy Nottingham','Tom Forbes'],
basedOn:['Michail Bulgakov'],
screenplay:['Mark Chappell','Alan Connor','Shaun Pye'],
music:['Stephen Warbeck'],
camera:['Simon Vickery'],
cut:['Mark Henson'],
masks:['Marie Deehan'],
costumes:['Annie Hardinge']},
{title:'The Fosters',
titleCZ:'Fosterovi',
year:2013,
runtime:'73h 40min',
episodeRuntime:'40-44min',
countries:['USA'],
genres:['Drama'],
director:['Joanna Johnson','Peter Paige','Norman Buckley','Elodie Keene','Rob Morrow','Lee Rose','Martha Mitchell','Aprill Winney','Timothy Busfield','Jeff Melman','Zetna Fuentes','Jay Karas','Millicent Shelton','Nzingha Stewart','Danny Nucci','Tate Donovan','Melanie Mayron','Joanna Kerns','Bethany Rooney','David Paymer','James Hayman','Michael Grossman','Ron Lagomarsino','Daisy von Scherler Mayer','Charlie Stratton','Kees Van Oostrum','Jann Turner','Chandra Wilson','Anne Renton','Silas Howard','Kelli Williams','Susan Flannery','Michael Medico','Lily Mariye','Cheryl Dunye','Laura Nisbet-Peters','Rich Newey'],
actors:['Teri Polo','Sherri Saum','David Lambert','Maia Mitchell','Cierra Ramirez','Danny Nucci','Noah Centineo','Alexandra Barreto','Jake T. Austin','Amanda Leighton','Jordan Rodrigues','Tom Williamson','Annika Marks','Alex Saxon','Gavin MacIntosh','Elliot Fletcher','Denyse Tontz','Izabela Vidovic','Meg DeLacy','Brandon Quinn','Kerr Smith','Jay Ali','Louis Hunter','Ashley Argota',"Rosie O'Donnell",'Madisen Beaty','Bianca A. Santos','Caitlin Carver','Christopher Meyer','Michael Traynor','Marla Sokoloff','Annie Potts','Bailee Madison','Jack DePew','Colby French','David Sullivan','Justina Machado','Sam McMurray','Necar Zadegan','Leslie Stevens','Alejandra Pérez','Romy Rosemont','Exie Booker','Sadie Alexandru','Jayne Taini','Hannah Kasulka','Jamie McShane','Garrett Clayton','Mary Mouser','John Lee Ames','Jake Elliott','Caroline Fogarty','Jeffrey Nicholas Brown','Alex Skuby','Mandy June Turpin','Ricardo Chacon','Jonathan Davila','Anna Akana','Paul Schackman','Anne Winters','Octavio Gómez Berríos','Geoffrey Rivas','Preston James Hillier','Ashlee Füss','Alberto De Diego','Myles Grier','Amanda Anka','Stephanie Erb','Suzanne Cryer','Kevin Sizemore','Toks Olagundoye','Patrick Duffy','Barry Livingston','Rolando Boyce','Nikki Hahn','Brandon W. Jones','Keean Johnson','Anzu Lawson','Chad Todhunter','Diahnna Nicole Baxter','Tanner Buchanan','Hilary Ward','Raney Branch','Michael Dempsey','Stacy Hall','Madison Pettis','Anna Khaja','Jason Tobias','David L. King','Norma Maldonado','Mike Ostroski','Tom Beyer','Deborah Lacey','Cornell Womack','Jasmin Savoy Brown','Michael John Long','Scot Zeller','Giselle DaMier','Anjali Bhimani','J.R. Cacia'],
screenplay:['Joanna Johnson','Peter Paige','Anne Meredith','Constance M. Burge','Thomas Higgins','Marissa Jo Cerar','Kelly Fullerton','Bradley Bredeweg','Kris Q. Rehl','Elle Johnson','Michael MacLennan','Paul Sciarrotta','Megan Lynn','David Ehrman','Dan Richter','Cristian Martinez'],
production:['Mark Benton Johnson','David Hartle','Paul Sciarrotta','Megan Lynn','Wade Solomon'],
music:['Alec Puro','Michael Brook'],
camera:['Robert Draper','Checco Varese','Kees Van Oostrum','Lowell Peterson','Rodney Charters'],
cut:['Michael Jablow','Kristin Windell','Meghan Robertson','Adam K. Tiller','Debra Weinstein','Sharon Silverman'],
sound:['Ryan Davis','Rick Norman','Jason Brennan','Jim Fitzpatrick','Sherry Klein','Albert Ibbotson','Mark Weingarten'],
scenography:['Rachel Kamerman','Linda Louise Sheets','David DiGiacomo','Brana Rosenfeld','Paul Roome'],
masks:['Dawn Victoria Dudley','Dnelle Almanza','Ingrid Hartowicz-Fuentes','Stacy Bisel','Bryn E. Leetch'],
costumes:['Deena Appel','Kathryn Langston Orindgreff','Ann Miller']},
{title:'The Returned',
titleCZ:'Znovuzrozeni',
year:2012,
runtime:'14h 26min',
episodeRuntime:'50-60min',
countries:['France'],
genres:['Mystery','Horror','Thriller'],
director:['Fabrice Gobert','Frédéric Mermoud','Frédéric Goupil'],
actors:['Frédéric Pierrot','Samir Guesmi','Guillaume Gouix','Anne Consigny','Clotilde Hesme','Céline Sallette','Pierre Perrier','Ana Girardot','Jérôme Kircher','Pierre Rochefort','Jenna Thiam','Carole Franck','Alain Blazquez','Victor Chambon','Claude Lévèque','Franck Adrien','Yara Pilartz','Melanie Baxter Jones','Bertrand Constant','Jean-Pierre Laurent','Alix Poisson','Lucie Rébéré','Pascal Decolland','Jean-François Sivadier','Swann Nambotin','Grégory Gadebois','Simon Ehrlacher','Constance Dollé','Matila Malliarakis','Vincent Trouilleux','Laurent Vercelletto','Brune Martin','Laetitia de Fombelle','Guillaume Marquet','Monique Roussel','Alice Butaud','Martin De Myttenaere','Laurent Lucas','Michaël Abiteboul','Laurent Capelluto','Armande Boulanger','Ernst Umhauer','Nicolas Wanczycki','Pierre Nisse','Julien Gauthier','Pauline Parigot','Thomas Doret','Aurélien Recoing','Grégoire Monsaingeon','Fabrice Abraham','Isabelle Sadoyan','Jacopo Menicagli','Béatrice de la Boulaye','Mauricette Laurence','Mélodie Richard','Guillaume Toucas','Francine Lorin-Blazquez','Julien Bourdel','Jean-Emmanuel Pagni','Aksel Üstün','Pascal Bianco-Levrin de Bouzid','Maxime Pambet','Linda Massoz','Robin Barde','Hugues Boucher','Simon Jouannot'],
screenplay:['Fabrice Gobert','Emmanuel Carrère','Fabien Adda','Camille Fontaine','Nathalie Saugeon','Coline Abert','Henrik Ibsen'],
production:['Caroline Benjo','Jimmy Desmarais','Barbara Letellier','Carole Scotta','Simon Arnal'],
music:['Mogwai','Jeff Russo'],
camera:['Patrick Blossier'],
cut:['Mike Fromentin','Peggy Koretzky','Laurence Bawedin','Gwen Mallauran','Bertrand Nail'],
scenography:['Fred Lapierre','Frédérique Lapierre','Boris Piot'],
masks:['Olivier Afonso'],
costumes:['Bethsabée Dreyfus']},
{title:"KonoSuba: God's Blessing on This Wonderful World!",
titleCZ:'Bůh žehnej tomuto nádhernému světu',
year:2016,
runtime:'12h 21min',
episodeRuntime:'23-28min',
countries:['Japan'],
genres:['Animation','Adventure','Fantasy','Comedy'],
director:['Takaomi Kanasaki','Jasuo Iwamoto','Takatoši Suzuki','Masato Mijoši','Júdžiró Abe'],
actors:['Sora Amamija','Ai Kajano','Rie Takahaši','Džun Fukušima','Jui Horie','Hitomi Nabatame','Kotono Micuiši','Kózó Dózaka','Ajaka Suwa','Wataru Hatano','Ai Kakuma','Hiroki Jasumoto','Tecu Inada','Tomoko Kaneda','Čó','Džundži Madžima','Takuja Eguči','Nanami Jamašita','Sajuri Hara','Jumeha Kóda','Nobuo Tobita','Júko Kaida','Šóto Kašii','Akeno Watanabe','Cuguo Mogami','Jui Ogura','Kendžiró Cuda','Kaito Išikawa','Takaši Nagasako','Maria Naganawa','Kazuhiko Inoue','Ari Ozawa','Saki Fudžita','Aki Tojosaki','Hidenari Ugaki','Jošiki Nakadžima','Jošino Aojama','Reió Cučida','Micuki Nakae','Masakazu Nišida','Jú Wakabajaši','Haruka Džinja','Jurie Mikami','Micuo Senda','Nacumi Jamada','Sóširó Hori','Omi Minami','Micuhiro Sakamaki','Kacuhiro Tokuiši','Mari Kijohara','Miki Hase','Činacu Akasaki','Sajuri Jahagi','Kanon Takao','Reina Ueda'],
basedOn:['Nacume Akacuki'],
screenplay:['Makoto Uezu','Kódžiró Nakamura','Aoi Akaširo'],
music:['Masato Kóda'],
camera:['Hisaši Jonezawa','Šigemicu Hamao','Naoki Etó'],
cut:['Kašiko Kimura'],
sound:['Jošikazu Iwanami'],
scenography:['Masakazu Mijake','Jukiko Marujama','Eri Jamanaši']},
{title:'The Thick of It',
titleCZ:'Je to soda',
year:2005,
runtime:'10h 44min',
episodeRuntime:'28-59min',
countries:['UK'],
genres:['Comedy'],
director:['Armando Iannucci','Natalie Bailey','Billy Sneddon','Becky Martin','Chris Addison','Tony Roche'],
actors:['Peter Capaldi','Rebecca Front','Chris Addison','Roger Allam','Joanna Scanlan','Alex MacQueen','Olivia Poulet','Zoe Telford','David Haig','Morwenna Banks','Chris Langham','Martin Savage','Mandeep Dhillon','Joe Cole','Paul Higgins','Jessica Henwick','Tim Bentinck','Lucy Briers','Ben Willbond','Struan Rodger','Sara Pascoe','Hamza Jeetooa','Vincent Franklin','Georgie Glen','Michael Maloney','Gareth Tunley','David Dawson','Di Botcher','Greg Bennett','Teresa Churcher','Tom Andrews','Emily Bevan','Miles Jupp','James Smith','Zahra Ahmadi','Manjinder Virk','Graham Curry','Geoffrey Streatfeild','Pearce Quigley','Rufus Wright','Bohdan Poraj','Susy Kane','Tony Gardner','Colin Mace','Matthew Marsh','James Doherty','Rory Kinnear','Peter Sullivan','Melanie Hill','Simon Chandler','Nicholas Sidi','Tom Hollander','Adam Tandy','Sylvestra Le Touzel','Priyanga Burford','Tobias Menzies','Will Smith','Rebecca Gethings','Michael Gould','Robin Weaver','Chetna Pandya','Theo Fraser Steele','Dave Florez'],
screenplay:['Jesse Armstrong','Dan Gaster','Georgia Pritchett','Ian Martin','David Quantick','Armando Iannucci','Simon Blackwell','Tony Roche','Will Smith','Roger Drew','Sean Gray'],
production:['Adam Tandy','Armando Iannucci'],
camera:['Ben Wheeler','Jamie Cairney','Nick Martin'],
cut:['Anthony Boys','Gary Dollner','Billy Sneddon','Robin Hill'],
sound:['Andrew Halley','Bob Newton'],
scenography:['Laura Marsh','Simon Rogers','Thorin Thompson'],
costumes:['Ros Little']},
{title:'Love, Victor',
titleCZ:'Já, Victor',
year:2020,
runtime:'13h 26min',
episodeRuntime:'24-34min',
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Jay Karas','Amy York Rubin','Jason Ensler','Pilar Boehm','Michael Lennox','Anne Fletcher','Anu Valia','Todd Holland','Rebecca Asher','Alex Hardcastle','Natalia Leite'],
actors:['Michael Cimino','Rachel Hilson','Anthony Turpel','Bebe Wood','Mason Gooding','George Sear','Isabella Ferreira','Mateo Fernandez','James Martinez','Ana Ortiz','Nick Robinson','Andy Richter','Natasha Rothwell','Keiynan Lonsdale','Jorge Lendeborg Jr.','Beth Littleford','Kayla DiVenere','Lukas Gage','Leslie Grossman','Wayne Bastrup','Mekhi Phifer','Sophia Bush','Melanie Haynes','Juan Carlos Cantu','Mark Bloom','Ali Wong','Keiynan Lonsdale','Tommy Dorfman','Katya','Nick Robinson','River Gallo','Friday Chamberlain','Anthony Keyvan','Terri Hoyos','Miss Benny','Cornelius Peter','Will Ropp','Kevin Norman','Betsy Brandt','Ava Capri','Sonia Mena','Charlie Hall','Jack Cain','Aaron Guest','Crystal Coney','Josh Duhamel'],
basedOn:['Becky Albertalli'],
screenplay:['Isaac Aptaker','Elizabeth Berger','Jess Pineda','Marcos Luevanos','Brian Tanen','Jen Braeden','Sheila R. Lawrence','David Smithyman','Danny Fernandez','Jeremy Roth','Jillian Moreno','Sarah Labrie','Debby Wolfe'],
production:['Marcos Luevanos','Shawn Wilt','Nick Robinson','David Smithyman','J.C. Lee'],
music:['Siddhartha Khosla','Kotomi'],
camera:['Mark Schwartzbard','J.P. Wakayama'],
cut:['Tuan Quoc Le','Shoshanah Tanzer','Diandra Kendall Luzon','Rebekah Fridman','Jacquelyn Le'],
sound:['Mark Server','Rick Ash',"Terry O'Bright",'Dante Reynolds','Thomas DeGorter'],
scenography:['Cece Destefano','Will Armstrong','Elizabeth Newton','Kelly Berry'],
masks:['Michele Tyminski Schoenbach','Myesha Starks'],
costumes:['Mojdeh Daftary','Molly Grundman']},
{title:'Goliath',
titleCZ:'Goliáš',
year:2016,
runtime:'27h 17min',
episodeRuntime:'38-65min',
countries:['USA'],
genres:['Drama'],
director:['David Semel',"Bill D'Elia",'Alik Sakharov','Lawrence Trilling','Anthony Hemingway','Dennie Gordon'],
actors:['Billy Bob Thornton','Tania Raymonde','William Hurt','Maria Bello','Olivia Thirlby','Sarah Wynter','Ever Carradine','Nina Arianda','Molly Parker','Damon Gupton','Diana Hopper','Shelby Rabara','Kevin Weisman','Julia Cho','Sarah Baker','Kelly Albanese','Michelle Arthur','Elena Nikitina Bick','Mitchell Clark','Tina Grimm','Ivan Kraljevic','Daniel Robbins','Bryan Friday','Juan Gabriel Pareja','Kimberly Daugherty','Alexandra Bokyun Chun','Rigo Sanchez','Angela Sun','Jeff Denton','Harold Perrineau','Dwight Yoakam','Brent Briscoe','Rizwan Manji','Jason Ritter','Jorge-Luis Pallo','Dominic Burgess','Frankie Ingrassia','Ana de la Reguera','Matthew Del Negro','Mark Duplass','Manuel Garcia-Rulfo','Lou Diamond Phillips','Dominic Fumusa','Ray Corasani','Theodore Barnes','Ervin Ross','Raymond Forchion','Laura Silverman','Alexandra Billings','Gloria Laino','Britain Dalton','Brandon Young','Morris Chestnut','James Wolk','John Savage','Steven Bauer','Paul Ben-Victor','Toni Torres','Christopher Michael','A.J. Rivera','Hash Patel','Rodrick Bostick','Gilbert Owuor','Angel Giuffria','Inger Tudor','Jessica Marie Garcia','Jessica Pohly','Graham Greene','Shamier Anderson','Amy Brenneman','Dennis Quaid','Beau Bridges','Griffin Dunne','Lauren Tom','Illeana Douglas','Sherilyn Fenn','Matthew Weiner','Christopher Douglas Reed','Marshall Cook','Peter Holden','Travis Johns','Catt Sadler','Julia Jones','Paul Williams','Chrystee Pharris','David Cross','David Sullivan','Aaron Yoo','Julian Edwards','Angie Patterson','Shelley Robertson','Monica Potter','Finn Roberts','Ralph Michael Brekan','William W. Barbour','Andrew Koponen','Paul Raci','Michole Briana White','Rachel Alana Handler','Adam Chambers'],
screenplay:['David E. Kelley','Ben Myer','Jonathan Shapiro','Noelle Valdivia','Jennifer Ames','Steve Turner','Marisa Wegrzyn','Andrew Matisziw','Tony Saltzman'],
music:['Jason Derlatka','Jon Ehrlich'],
camera:['Edward J. Pei','Curtis Wehr','Jeffrey Greeley'],
cut:['Kristin Windell','John David Buxton',"Arge O'Neal",'Jeffrey D. Brown'],
sound:['David Rawlinson'],
scenography:['Michael Wylie','Eric Weiler','Jessica Kender','David A. Koneff','Ron Franco','Julie Ziah'],
masks:['Stacy Bisel','Maurine Burke','Ketty Gonzalez'],
costumes:['Lindy McMichael']},
{title:'The Crimson Petal and the White',
titleCZ:'Kvítek karmínový a bílý',
year:2011,
runtime:null,
episodeRuntime:'4h60min',
countries:['UK','Canada'],
genres:['Drama','Romance'],
director:['Marc Munden'],
actors:['Romola Garai',"Chris O'Dowd",'Amanda Hale','Shirley Henderson','Katie Lyons','Elizabeth Berrington','Richard E. Grant','Liz White','Blake Ritson','Gillian Anderson','Mark Gatiss','Peter Cellier','Lydia Wilson','Tom Georgeson','Maimie McCoy','Rosie Cavaliero','Branwell Donaghey','Bertie Carvel','Paul Warren','Patrick Brennan','Alan Williams','Camilla Rutherford','Ben Bishop','Alison Pargeter','Wendy Nottingham','James Wilson'],
basedOn:['Michel Faber'],
screenplay:['Lucinda Coxon'],
production:['Steve Lightfoot'],
music:['Cristobal Tapia de Veer'],
camera:['Lol Crawley'],
cut:['Luke Dunkley'],
scenography:['Grant Montgomery'],
costumes:['Annie Symons']},
{title:'Pluto',
titleCZ:'Pluto',
year:2023,
runtime:'8h 15min',
episodeRuntime:'56-71min',
countries:['Japan'],
genres:['Animation','Action','Drama','Mystery','Sci-Fi','Psychology'],
director:['Tošio Kawaguči','Hirojuki Okiura','Hiromiči Matano','Fumihiro Jošimura','Masajuki Kodžima','Nanako Šimazaki','Sang Yong Eom','Masajuki Sakoi','Kó Macuo','Satoši Nišimura','Kónosuke Uda','Hiroši Aojama'],
actors:['Jóko Hikasa','Šinšú Fudži','Minori Suzuki','Hidenobu Kiuči','Mamoru Mijano','Rikija Kojama','Hiroki Jasumoto','Kóiči Jamadera','Tošihiko Seki','Hidejuki Tanaka','Romi Paku','Tošio Furukawa','Cuda Eizó','Kazuhiro Jamadži','Mičio Hazama',"Ken'jú Horiuči",'Juka Terasaki','Šógo Sakata','Akio Ócuka','Hideto Nitta','Hiroši Janaka','Ikkjú Džuku','Džiró Saitó',"Kijomicu Mizu'uči",'Marina Inoue','Masafumi Kimura','Šózó Iizuka','Takaja Haši','Cuguo Mogami','Wataru Takagi','Jasuhiro Mamija','Jutaka Aojama','Kacuhisa Hóki','Rie Takahaši','Saki Endó','Júna Ogata','Ai Kaneta','Arisa Sekine','Čika Fudžimura','Kósuke Takaguči','Miho Morisaki','Miria Takagiši','Čijuki Miura','Akira Kuwabara','Kengo Cudží','Kendži Hamada','Mariko Nagai','Masami Iwasaki','Masamiči Kitada','Kaoru Katakai','Kunpei Sakamoto','Minoru Inaba','Šóko Juzuki','Wakana Minami','Júko Minaguči','Zenki Kitadžima','Júki Hoši','Júko Tačibana','Micuru Ogata',"Ken'ičiró Macuda",'Kósuke Tanabe','Masaki Nakaniši','Júki Sanpei','Tacuki Kóbe','Takumu Mijazono','Šúhei Takubo','Hina Nacume','Fumiko Takekuma',"Šin'ičiró Miki",'Seiró Ogino','Fumitake Išiguro','Eri Kitamura',"Džun'ja Miura",'Tomomi Kawamura','Takeši Hirabajaši','Júri Sakamoto','Júki Onodera','Mičitake Kikuči','Akihiro Tadžima','Ajano Šibuja','Haruka Šamoto','Mijari Nemoto','Jasuhiro Kikuči','Šúhei Macuda','Naomi Marujama','Naoki Tacuta','Sakuma Motoki','Masaaki Ihara','Hironori Kondó','Kanako Takeuči'],
basedOn:['Osamu Tezuka','Naoki Urasawa'],
screenplay:['Tacuró Inamoto','Heisuke Jamašita'],
music:['Júgo Kanno'],
camera:['Micuhiro Sató'],
sound:['Masafumi Mima'],
scenography:['Čikako Šibata']},
{title:'Green Eggs and Ham',
titleCZ:'Zelená vajíčka se šunkou',
year:2019,
runtime:'10h 51min',
episodeRuntime:'25-31min',
countries:['USA'],
genres:['Animation','Adventure','Fantasy','Comedy'],
director:['Cody Cameron','Piero Piluso'],
actors:['Adam Devine','Jillian Bell','Daveed Diggs','Michael Douglas','Ilana Glazer','Eddie Izzard','Diane Keaton','Keegan-Michael Key','Tracy Morgan','John Turturro','Jeffrey Wright','Bob Joles','Stephanie Courtney','Joe Hanna','Brad Abrell'],
basedOn:['Dr. Seuss'],
screenplay:['Vanessa McGee','Mark Rizzo'],
music:['David Newman'],
sound:['Carlos Sanches']},
{title:'Ascendance of a Bookworm',
titleCZ:'Honzuki no gekokudžó: Šišo ni naru tame ni wa šudan o erande iraremasen',
year:2019,
runtime:'14h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Fantasy'],
director:['Micuru Hongo','Takahide Ogata','Jošiki Kawasaki','Čikajo Nakamura'],
actors:['Juka Iguči','Aja Učida','Fumiko Orikasa','Hiroši Naka','Megumi Nakadžima','Mucumi Tamura','Satoši Hino','Šó Hajami','Takehito Kojasu','Tomoaki Maeno','Júko Sanpei','Minori Suzuki','Kijono Jasuno','Tošijuki Morikawa','Júičiró Umehara','Haruki Išija','Cujoši Kojama','Juki Nagano','Júko Tačibana','Mari Hino','Takajuki Nakacukasa','Šó Karino','Hitomi Nabatame','Jukine Jaehata','Rika Kinugawa','Micuaki Hošino','Marina Jamada','Kanako Mijamoto','Kacunori Okai','Jua Nagae','Majumi Jamaguči','Juri Ehara','Takugo Iwakawa','Jumiri Hanamori','Kódži Takahaši','Takuja Kurijama','Só Takeuči','Čijo Tomaru','Jošijuki Itó','Kazuhiko Inoue','Tošicugu Takašina','Acujoši Mijazaki',"Ken'jú Horiuči",'Hirojuki Endó','Eri Akijama','Masahito Kawanago','Arisa Hirose','Čafúrin','Akane Tomonaga','Ajano Šibuja','Tomohito Takacuka','Šó Hajami','Aino Šimada','Nagisa Marujama'],
basedOn:['Mija Kazuki'],
screenplay:['Mariko Kunisawa','Júko Išiama','Micuru Hongo'],
production:['Hirojuki Birukawa','Hiroaki Cunoda','Júki Sató'],
music:['Mičiru'],
camera:['Naoki Kitamura'],
cut:['Tomoki Nagasaka'],
sound:['Džun Watanabe'],
scenography:['Rjóka Kinošita']},
{title:'Blue Lock',
titleCZ:'Blue Lock',
year:2022,
runtime:'9h 36min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Drama','Sport'],
director:['Tecuaki Watanabe','Šunsuke Išikawa','Takaaki Išijama','Akira Toba','Tomohiro Furukawa','Judži Ikuhara','Jú Kó','Norio Kašima','Júsuke Onoda','Jasuši Muroja','Hiroši Kimura','Jošikazu Mijao','Šintaró Inokawa'],
actors:['Tasuku Kaito','Sóma Saitó','Kazuki Ura','Júki Ono',"Džun'iči Suwabe",'Hiroši Kamija','Šúgo Nakamura','Rjúnosuke Watanuki','Aoi Ičikawa','Šója Čiba','Takahiro Sakurai',"Ken'iči Suzumura",'Masatomo Nakazawa','Júma Učida','Nobunaga Šimazaki','Daiši Kadžita','Nacuki Hanae','Jošicugu Macuoka','Eri Jukimura','Kazujuki Okicu','Rjóta Suzuki','Kóki Učijama','Kacujuki Koniši','Šinnosuke Tačibana','Akito Sugibajaši','Ajasa Gotó','Emiri Sujama','Haruna Mikawa','Kóiči Sóma','Mai Nakahara','Rikija Kojama','Šó Fudžisawa','Šúiči Učida','Teppei Ueniši','Bin Šimada','Kódži Seki',"Šin'ja Takahaši",'Sóta Arai','Jošihito Sasaki','Akihiro Šinohara','Júki Ótani','Júki Šin','Nene Hieda','Hiroki Tóči','Mijú Ajase','Saori Hajami',"Kjóhei Zen'jódži",'Misa Išii','Misaki Watada','Sajumi Suzuširo','Serika Hiromacu','Jui Horie','Mari Učijama','Šizuka Išigami','Aoi Inase','Hiromiči Tezuka','Mizuki Wakamori','Júko Kaida','Miho Okasaki','Šiničiró Kamio','Takuja Eguči','Júiči Nakamura','Makoto Furukawa','Kengo Kawaniši','Hiro Šimono'],
basedOn:['Munejuki Kaneširo','Júsuke Nomura'],
screenplay:['Taku Kišimoto'],
production:['Rjója Arisawa'],
music:['Džun Murajama'],
camera:['Jasuhiro Asagi'],
cut:['Mai Hasegawa'],
sound:['Fumijuki Gó'],
scenography:['Sawako Takagi','Tošihiko Kodžima']},
{title:"Garrow's Law",
titleCZ:'Garrowův zákon',
year:2009,
runtime:null,
episodeRuntime:'12x60min',
countries:['UK'],
genres:['Drama'],
director:['Peter Lydon','Bryn Higgins'],
actors:['Andrew Buchan','Lyndsey Marshal','Rupert Graves','Aidan McArdle','Michael Culkin','Alun Armstrong','Steven Waddington','Teresa Churcher','Sean Biggerstaff','Frances Grey','Jeremy Swift','Paul Hilton','Liz White','Finlay Robertson','Clive Russell','Rebecca Palmer','Anton Lesser','Martin Savage','Chris New','Jessica Raine','Danny Sapani','Jonathan Watson','Brian Pettifer','Jordan Young','David Robb','Mark Tandy','Zubin Varla','Andy Linden','Christopher Downie','Joel Gillman','David Verrey','Will Keen','James Bradshaw','Leon Vickers','Sophie Rundle','Nicholas Day','Barbara Rafferty','Sian Brooke','Andrew Scott','Olivia Grant','Derek Riddell','Richard Cordery','Michael Feast','Nyasha Hatendi','Glenna Morrison','Simon Dutton','Tony Maudsey','J. Scott Murray','Hal Fowler','Julie Hale','Hayley Carmichael','Stephen Boxer','Antony Strachan','Rachel Pickup','Elaine M. Ellis','Victoria Balnaves','Billy Mack','Matthew Zajac','Benny Young'],
screenplay:['Kevin Hood','Damian Wayling','Tony Marchant'],
production:['Nick Pitt'],
music:['Charlie Mole','Edmund Butt'],
camera:['Lukas Strebel','Gavin Struthers','Tony Coldwell'],
cut:['Iain Erskine','Steve Singleton'],
sound:['Keith Nixon']},
{title:'Teenage Mutant Ninja Turtles',
titleCZ:'Želvy Ninja',
year:1987,
runtime:'73h 57min',
episodeRuntime:'21-47min',
countries:['USA'],
genres:['Animation','Action','Adventure','Comedy'],
director:['Bill Wolf','Tony Love','Vincent Davis','Bruno-René Huchez','Mike Stuart','Reg Lodge','Tayk Kim'],
actors:['Townsend Coleman','Rob Paulsen','James Avery','Jim Cummings','Tress MacNeille','Dorian Harewood','Elizabeth Daily','Greg Berg','Dana Hill','Tony Jay','Robert Ridgely','Sophie Arthuys','Stefan Godin','Laurence Dourlens','Jean-Paul Coquelin','Hamilton Camp','Bill Martin','Thom Bray','Susan Blu','Robbie Rist','Rémy Kirch','Pat Musick','Pat Fraley','Jan Rabson','Hal Rayle','Cam Clarke','Renae Jacobs','Katie Leigh','Brian Cummings','Jennifer Darling','Kevin Schon','Barry Gordon','Gaille Heideman','Dave Fennoy','Jack Angel','Peter Renaday'],
basedOn:['Kevin Eastman','Peter Laird'],
screenplay:['Steve Roberts','Bob Schooley','Mark McCorkle','Benjamin Townsend',"Dennis O'Flaherty",'J. Larry Carroll','Michael Maurer','Jeffrey Scott','Duane Capizzi','Jack Mendelsohn','David Wise','Patti Howeth','Martin Pasko','Michael Reaves','Christy Marx','Michael Edens','Mark Edward Edens','Cydne Clark','Bob Forward','Bruce Shelly','Reed Shelly','Doug Molitor','Buzz Dixon','Matt Uitz','Richard Merwin','Lee Schneider','Matthew Malach','Dennis Marks','Francis Moss','Douglas Booth','Gary Greenfield','Brynne Stephens','Rowby Goren','Misty Stewart-Taggart','Charles M. Howell IV','Gordon Bressack','Sean Roche','Steve Granat','Antonio Ortiz','Carmela Ortiz'],
production:['Bill Wolf','Kara Vallow'],
music:['Dennis C. Brown','Chuck Lorre'],
cut:['Catherine MacKenzie','Carol Lewis','Peter Grives','Michael Bradley','Craig Paulsen','Doub Pearce','Kerry Dean Williams','Martina Young','Brian Baker','Rick Hinson','Ralph A. Eusebio'],
sound:['James L. Aicholtz','Kevin Patrick Burns','Deb Adair','Patrick Cyccone Jr.','John Boyd'],
scenography:['Gary Selvaggio','Kyle Menke','Ira Turek','Frank Rocco']},
{title:'The Tenth Kingdom',
titleCZ:'Desáté království',
year:2000,
runtime:null,
episodeRuntime:'5x85min',
countries:['UK','Germany','USA'],
genres:['Adventure','Comedy','Family','Fantasy','Mystery','Romance'],
director:['Herbert Wise','David Carson'],
actors:['Kimberly Williams-Paisley','Scott Cohen','John Larroquette','Dianne Wiest','Camryn Manheim','Ann-Margret',"Ed O'Neill",'Rutger Hauer','Daniel Lapaine',"Hugh O'Gorman",'Jeremiah Birkett','Warwick Davis','Jimmy Nail','Tom Chadbon','John Shrapnel','Timothy Bateson','Robert Hardy','James Cosmo','Peter Vaughan','Lucy Punch','Edward Woodall','Poppy Rogers','Eve Pearce','Jeremy Swift','Gabrielle Lloyd','Tim Killick','Dido Miles','Maria Charles','Luke Healy','Richard Syms','Roger Sloman','Jacqueline Tong','Adam Levy','Jeff Nuttall','Charles Cork','Jessica James','Michael Müller','Moira Lister','Jennifer Croxton','Donald Pelmear','Johnny Myers','Sean Cronin','John Hallam','Cliff Barry','Graham Crowden','Nigel Whitmey','Calum MacPherson','Harriet Thorpe','Liz May Brice','Mike Edmonds','Kim Thomson','Arthur Cox','Frank Middlemass','Amelda Brown','Ann Firbank','John Cater','Sheila Steafel','Jeremy Peters','Edward Jewesbury','Adam James','Len Collin','Bob Barrett','Jeffry Wickham','John Vernon','Jon Key','Aden Gillett','Sam Douglas','Dani Harmer','Dave Nichols'],
screenplay:['Simon Moore'],
production:['Brian Eastman'],
music:['Anne Dudley'],
cut:['Chris Wimble'],
scenography:['Rob Hinds','Leigh Walker'],
costumes:['Jill Taylor']},
{title:'Barry',
titleCZ:'Barry',
year:2018,
runtime:'15h 55min',
episodeRuntime:'24-36min',
countries:['USA'],
genres:['Comedy','Crime'],
director:['Bill Hader','Maggie Carey','Alec Berg','Hiro Murai','Minkie Spiro','Liza Johnson'],
actors:['Bill Hader','Stephen Root','Henry Winkler','Anthony Carrigan','Glenn Fleshler','Rightor Doyle','Paula Newsome','John Pirruccello','Alejandro Furth','Sarah Goldberg','Michael Bofshever','Darrell Britt-Gibson',"D'Arcy Carden",'Izzy Diaz','Mark Ivanir','Cameron Britton','Gerald Webb','Tyler Jacob Moore','Dennis Keiffer','Melissa Villaseñor','Robert Curtis Brown','Kat Foster','Larry Hankin','Cyrina Fiallo','Jon Hamm','Chris Marquette','Dale Pavinski','Julia Cho','Jackie Moore','Karen David','Kirby Howell-Baptiste','Ross Philips','Dominic Pace','Nick Gracer','Sarah Burns','Michael Irby','James Hiroyuki Liao','JB Blanc','Andrew Leeds','Jessy Hodges','Chris McGarry','Rodney To','Michael Beach','Elle Evans','Patrick Fabian','Joe Massingill','Alexa Havins','Deepti Gupta','Ray Haratian','Nicholas Walker','Fahim Fazli','Daniel Bernhardt','Ani Sava','Anthony Molinari','Jay Roach','P.J. Marino','Jill Basey',"De' Leon Howard III",'David Douglas',"Patricia Fa'asua",'Lee Coc','Bella Podaras','Jessie Giacomazzi','Felice Heather Monteith','Harvey B. Jackson','Deb Hiett','Andrew Thacher','Madia Hill Scott','Americus Abesamis','Andra Petru','Elsie Fisher','Miguel Sandoval','Kate Mines','Blair Beeken','Michael Andrew Baker','Elizabeth Perkins','Marika Dominczyk','Cullen Douglas','Joanna Sotomura','Chris Aquilino','Michael J. Sielaff','Lisa Dring','Joe Mantegna','Annabeth Gish','Alex MacNicoll','Brooke Baumer','Avital Ash','Laura San Giacomo','Michael Ironside','Krizia Bajos','Melanie Haynes','Robert Wisdom','Fred Melamed','Chris Coppola','Damián Delgado','Grinnell Morris','Vanessa Bayer','Sal Lopez','Bob Turton','Ana Rey'],
screenplay:['Alec Berg','Bill Hader','Sarah Solemani','Elizabeth Sarnoff','Duffy Boudreau','Ben Smith','Taofik Kolade','Emily Heller','Jason Kim','Nicky Hirschhorn','Emma Barrie'],
production:['Emily Heller','Aida Rodgers','Julie Camino','Jason Kim','Duffy Boudreau'],
music:['David Wingo'],
camera:['Brandon Trost','Paula Huidobro','Carl Herse','Darran Tiernan'],
cut:['Jeff Buchanan','Kyle Reiter','Franky Guttman','Ali Greer'],
sound:['Todd Beckett','Elmo Ponsdomenech','Alessio Masi','Jason Gaya'],
scenography:['Richard Toyon','Eric Schoonover','Tyler B. Robinson','Amber Haley','Jennifer Mueller','Andrew Leitch'],
masks:['Kimberley Spiteri','Rheanne Garcia','Ozzy Alvarez','Denise Dellavalle','Ginger Damon'],
costumes:['Audrey Fisher','Chrisi Karvonides-Dushenko','Tiffany White Stanton']},
{title:'The Young Ones',
titleCZ:'Mladí v partě',
year:1982,
runtime:'6h 35min',
episodeRuntime:'30-35min',
countries:['UK'],
genres:['Comedy'],
director:['Geoff Posner','Paul Jackson','Ed Bye'],
actors:['Adrian Edmondson','Rik Mayall','Nigel Planer','Christopher Ryan','Alexei Sayle','Stephen Frost','Robbie Coltrane','Emma Thompson','Stephen Fry','Terry Jones','Gareth Hale','Norman Pace','Tony Robinson','Norman Lovett','Perry Benson','Ben Elton','Roger Ashton-Griffiths','Jennifer Saunders','Dawn French','Anthony Sharp','Julianne White','Mark Ezra','Ron Cook','Stewart Copeland','Nick Dunning','Roger Sloman','John Otway','Lemmy','Paola Dionisotti','Barrie Cookson','Jools Holland','Pat Gorman','Hilary Mason','Gary Beadle','Damaris Hayman','Helen Lederer','Lee Cornes','Brian Croucher','Justine Lord','Rowland Rivron','Gerard Kelly','Carla Mendonça','Tony Sympson','Barry Stanton','Ken Parry','Patrick Newell','Cyril Shaps','Herbert Norville','Maggie Steed','Chris Barrie','Peter Greene','Keith Allen','Nicholas Ball','Hugh Laurie','Griff Rhys Jones','Mel Smith','Paul Merton','Anne-Marie Martin','Brian Oulton','Lenny Henry','Julia Sawalha','Harry Fielder','Simon Brint','David Rappaport','Vikki Chambers','Alan Freeman','Kay Stonham','Helen Atkinson Wood','Robin Parkinson','Andy de la Tour','Neneh Cherry'],
screenplay:['Rik Mayall','Ben Elton','Lise Mayer'],
production:['Paul Jackson'],
sound:['John Gardner'],
scenography:['Chris Seagers','Graeme Story']},
{title:'Wives and Daughters',
titleCZ:'Manželky a dcery',
year:1999,
runtime:'5h 2min',
episodeRuntime:'74-77min',
countries:['UK','USA'],
genres:['Drama'],
director:['Nicholas Renton'],
actors:['Justine Waddell','Bill Paterson','Francesca Annis','Keeley Hawes','Tom Hollander','Michael Gambon','Penelope Wilton','Barbara Flynn','Iain Glen','Ian Carmichael','Rosamund Pike','Fred Pearson','Richard Coyle','Jemima Rooper','Elizabeth Spriggs','Richard Dempsey','Sheridan Smith','Lucy Briers','Barbara Leigh-Hunt','Charles Simon','Georgie Glen','Deborah Findlay','Anthony Howell','Andrew Havill','Tim Wallers','Anna Maguire','Finty Williams','Alan MacNaughtan','Peter Copley','Gordon Gostelow','Jacqueline Pilton','Steven Webb','Roddy Maude-Roxby'],
basedOn:['Elizabeth Gaskell'],
screenplay:['Andrew Davies'],
music:['John E. Keane'],
cut:['Kevin Lester'],
masks:['Lesley Smith','Lisa Westcott','Karen Edwards'],
costumes:['Deirdre Clancy']},
{title:'White House Farm',
titleCZ:'Zločin na statku',
year:2020,
runtime:null,
episodeRuntime:'6h60min',
countries:['UK'],
genres:['Crime'],
director:['Paul Whittington'],
actors:['Scott Reid','Amanda Burton','Maimie McCoy','Jack Shalloo','Oliver Zetterström','Stewart Scudamore','Mark Addy','Alfie Allen','Cressida Bonas','Alexa Davies','Nicholas Farrell','Freddie Fox','Stephen Graham','David Hunt','Mark Stanley','Gemma Whelan','Thomas Coombes','Sean Gilder','Josh Herdman','Andrew Frame','Grace Calder','Richard Goulding','Dorian Lough','Oliver Dimsdale','Millie Brady','Amy McCallum','Amanda Lawrence','David Bark-Jones','Anthony Calf','Richard Lintern','Michael Simkins','Micah Balfour','Christopher Amos','Glyn Pritchard','David Horovitch','Josie Walker','Tom Christian','Jeanette Maskell'],
screenplay:['Kris Mrksa'],
production:['Lee Thomas'],
music:['Niall Byrne'],
camera:['Ben Wheeler'],
cut:['Edel McDonnell'],
sound:['Richard Davey'],
scenography:['Anna Higginson','Faye Brothers'],
masks:['Jill Sweeney'],
costumes:['Tudor George']},
{title:'Vagabond',
titleCZ:'Vagabond',
year:2019,
runtime:'16h 41min',
episodeRuntime:'60-67min',
countries:['South Korea'],
genres:['Thriller','Action','Drama','Romance'],
director:['In-sik Yoo'],
actors:['Seung-gi Lee','Suzy Bae','Seong-rok Shin','Min-jong Kim','Jeong-hee Moon','Yoon-shik Baek','Kyeong-yeong Lee','Seong-geun Moon','Won Ryoo','Bo-ra Hwang','Man-sik Jeong','Gi-yeong Lee','Seung-hwan Shin','Si-yoo Lee','Gyoo-pil Ko','Dae-cheol Choi','Hyeok-jin Jang','Ji-hyeon Jeon','Yoo Teo','Gwang-il Choi','Ah-In Park'],
screenplay:['Kyeong-soon Jeong','Young-cheol Jang'],
music:['Hye-Seung Nam','Jeong-Hoon Jeon'],
camera:['Gil-Bok Lee']},
{title:'Adventure Time: Distant Lands',
titleCZ:'Čas na dobrodružství: Daleké kraje',
year:2020,
runtime:'2h 57min',
episodeRuntime:'43-47min',
countries:['USA'],
genres:['Animation','Adventure','Comedy','Fantasy'],
director:['Pendleton Ward','Miki Brewster','Jeff Liu','Kimson Albert','Eulseong Kim'],
actors:['Jeremy Shada','John DiMaggio','Olivia Olson','Hynden Walch','Niki Yang','Steve Little','Cole Sanchez','Dee Bradley Baker','Ashly Burch','John Hodgman','Tom Kenny','Randall Park','Stephen Root','Pendleton Ward','Maria Bamford','Jeff Bennett','Erica Luttrell','Charlotte Nicdao','Kevin Michael Richardson','Michaela Dietz'],
screenplay:['Jack Pendarvis','Adam Muto','Hanna K. Nyström','Iggy Craig','Laura Knetzger','Anna Syvertsson','Jim Campbell','Haewon Lee'],
production:['Louis J. Cuck'],
music:['Timothy Kiefer','Amanda Delores Patricia Jones'],
sound:['Tony Orozco','Nick Gotten III','Alex Borquez'],
scenography:['Sandra Lee']},
{title:'Gotham',
titleCZ:'Gotham',
year:2014,
runtime:'72h 58min',
episodeRuntime:'42-50min',
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Danny Cannon','T.J. Scott','Eagle Egilsson','Nick Copus','John Behring','Dermott Downs','Oz Scott','John Stephens','Larysa Kondracki','Paul A. Edwards','Jeffrey G. Hunt','Louis Shaw Milito','Tim Hunter','Rob Bailey','Karen Gaviola','Guy Ferland','Wendey Stanzler','Nathan Hope','Bill Eagles','Kenneth Fink','Scott White','Hanelle M. Culpepper','Olatunde Osunsanmi','Ben McKenzie','Maja Vrvilo','Mark Tonderai','Annabelle K. Frost','Erin Richards','Carol Banker'],
actors:['Ben McKenzie','Donal Logue','Jada Pinkett Smith','Camren Bicondova','Robin Lord Taylor','Andrew Stewart-Jones','John Doman','Cory Michael Smith','Sean Pertwee','David Mazouz','Clare Foley','Richard Kind','Victoria Cartagena','Daniel Stewart Sherman','Carol Kane','Grayson McCouch','Drew Powell','Erin Richards','Sara Paxton','Lili Taylor','Frank Whaley','Wayne Duvall','Dan Bakkedahl','David Zayas','Susan Misner','Jon Beavers','Polly Lee','Marija Skangale','Genevieve Hudson-Price','Jared Brito','Makenzie Leigh','James Colby','Zabryna Guevara','Morena Baccarin','Cameron Monaghan','Adrian Martinez','Willa Fitzgerald','Gabriel Rush','Anthony Carrigan','Marko Caka','Doris McCarthy','Peter Maloney','Jeremy Bobb','Michelle Gomez','Daniel Davis','Charlie Tahan','Gabriel Hansen','Alex Ziwak','James Monroe Iglehart','Perry Yung','David Fierro','Gregory Konow','Joseph Latimore','Aly Mang','Lucille Sharp','Natalie Alyn Lind','Michael Goldsmith','James Frain','Will Brill','Dustin Ybarra','Michael Chiklis','Hakeem Kae-Kazim','Daniel London','Dan Hedaya',"Nicholas D'Agosto",'Jessica Lucas','Chris Chalk','BD Wong','Kristen Hager','Danny Hoch','Nathan Darrow','Michael Kostroff','Michael Bowen','Lori Petty','Melinda Clarke','Justin Mark','Paul Reubens','Mark Margolis','Dan Ziskie','Krista Braun','Norm Golden','Brett Azar','Michelle Veintimilla','Larry Petersen','Tama Filianga','Neil Hellegers','Ron Rifkin','Eisa Davis','Brendan Burke','Barbara Rosenblat','Jonny Coyne','Maggie Geha','Paulina Singer','Kyle Massey','Joey Starr','Birkett Turton','Jeremy Davidson','Margaret Colin','Mark Vincent','Christopher James Baker'],
basedOn:['Bob Kane','Bill Finger'],
screenplay:['John Stephens','Robert Hull','Jim Barnes','Rebecca Perry Cutter','Danny Cannon','Tze Chun','Megan Mostyn-Brown','Ben McKenzie','Peter Blake','Bruno Heller','Steven Lilien','Bryan Wynbrandt','Kim Newton','Charlie Huston','Iturri Sosa','Seth Boston','Ken Woodruff','James Patrick Stoteraux','Chad Fiveash','Denise Thé','Rebecca Dameron'],
production:['Scott White','Annabelle K. Frost','Thomas J. Whelan'],
music:['David E. Russo','Graeme Revell'],
camera:['Christopher Norr','David Stockton','Crescenzo G.P. Notarile','Thomas Yatsko','Scott Kevan'],
cut:['Sarah C. Reeves','Daniel Gabbe','John Ganem','Leland Sexton','Barrie Wise','Kevin Ward','David Ekstrom'],
sound:['Samuel Ejnes','Mace Matiosian','Yuri Reese','William Smith','George Haddad'],
scenography:['Doug Kraner','David Dean Ebert','Richard Berg','Daniel Novotny','Regina Graves','C.J. Simpson','Anu Schwartz','Andrew Baseman','Michelle Schluter-Ford'],
masks:['Sarah Tollenaar','Shellie Biviens','Tomy Rivero','Michele Spooner','Amy Sue Nahhas','Lena Jemmott'],
costumes:['Lisa Padovani','John Glaser']},
{title:'Entourage',
titleCZ:'Vincentův svět',
year:2004,
runtime:'41h 40min',
episodeRuntime:'21-36min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Doug Ellin','Larry Charles','David Frankel','Ken Whittingham','Seith Mann','Patty Jenkins','Julian Farino','Mark Mylod','Roger Kumble','Leslie Libman','Daniel Attias','Adam Bernstein','David Nutter','Craig Zisk','Tucker Gates','Adam Davidson','Kevin Connolly'],
actors:['Kevin Connolly','Adrian Grenier','Kevin Dillon','Jerry Ferrara','Jeremy Piven','Debi Mazar','Perrey Reeves','Emmanuelle Chriqui','Sarah Carter','Rhys Coiro','Scott Caan','Samaire Armstrong','Mini Anden','Arielle Kebbel','Jordan Belfi','Dale Dye','Jay Giannone','Seth Green','Jayma Mays','Carla Gugino','Ali Larter','April Scott','Val Kilmer','Matt Dallas','Laz Alonso','Allie McCulloch','Tracy Dali','Rainn Wilson','Colby French','Malcolm McDowell','Stephen Tobolowsky','Leighton Meester','Brianna Lynn Brown','Shanna Moakler','Courtney Peldon','Amanda Righetti','Leslie Bibb','Charlotte Salt','Simon Rhee','Kimberly Evan','Alejandra Gutierrez','Charity Shea','Scarlett Chorvat','A. J. Buckley','Assaf Cohen','Andrea Bendewald','Jonathan Sadowski','Holly Madison','Bridget Marquardt','Kendra Wilkinson','Hugh M. Hefner','Beverly Lynne','Brandon Quinn','Kate Clarke','Ginny Weirick','Cassie Jaye','Constance Zimmer','Sophie Monk','Lisa Rinna','Samm Levine','Denyce Lawton','Sofía Vergara','Tyrone M. Mitchell','Tara Karsian','Rachel Specter','Michelle Lombardo','Christina DeRosa','Ryan Eggold','Smith Cho','Anthony Anderson','Adam Goldberg','Maria Menounos','Nadine Velazquez','Busy Philipps','Peter Dinklage','Martin Landau','Jamie-Lynn Sigler','Gus Van Sant','Mark Wahlberg','Izzy Diaz','Jessica Custodio','Lauren Lake','Lauren Michelle Hill','Heidi Herschbach','Aneliese Roettger','Irina Voronina','Marshall Manesh','Mercedes Ruehl','Penny Marshall','Jim Holmes','Ashley Rickards','Johann Urb','Joey King','Natasha Alam','Stacy Stas Hurst','Scott Alan Smith','Amy Rosoff','Michael Hitchcock','Shad Moss','Bella Thorne'],
screenplay:['Doug Ellin','Cliff Dorfman','Chris Henchy','Matt Wolpert','Ben Nedivi','Stephen Levinson','Dusty Kay','Marc Abrams','Michael Benson'],
music:['Jeff Cardoni','Tim Phillips','Elliott Goldkind'],
camera:['Steven Fierberg','Anghel Decca','Anthony Hardwick','Dave Perkal','Rob Sweeney','Colin Watkinson','Todd A. Dos Reis']},
{title:'GLOW',
titleCZ:'GLOW: Nádherné ženy wrestlingu',
year:2017,
runtime:'17h 7min',
episodeRuntime:'27-46min',
countries:['USA'],
genres:['Comedy','Drama','Sport'],
director:['Kate Dennis','Tristram Shapeero','Wendey Stanzler','Todd Fjelsted','Claire Scanlon','Jesse Peretz','Melanie Mayron','Phil Abraham','Siân Heder','Lynn Shelton','Mark A. Burley','John Cameron Mitchell','Meera Menon','Anya Adams','Alison Brie'],
actors:['Alison Brie','Betty Gilpin','Marc Maron','Sydelle Noel','Britney Young','Britt Baron','Kimmy Gatewood','Rebekka Johnson','Sunita Mani','Kate Nash','Marianna Palka','Gayle Rankin','Kia Stevens','Shakira Barrera','Jackie Tohn','Ellen Wong','Antonio D. Charity','Mike Ostroski','Aurelia Scheppers','Kevin Sateri','Hunter Fischer','Bashir Salahuddin','Rich Sommer','John Hennigan','Krystal Ellsworth','Heather Morris','Marc Evan Jackson','Christopher Lowell','Esther Anderson','Winston James Francis','Carlos Colón Jr.','Ravil Isjanov','Lisa Ann Walter','Allan Havey','Andy Umberger','Brooke Hogan','Elizabeth Perkins','Adam Lazarre-White','Ronald Reagan','Arturo del Puerto','Casey W. Johnson','Alex Rich','Bonnie Hellman','Zabeth Russell',"Peter O'Brien",'Victor Quinaz','Wyatt Nash','Bill Posley','Dan Warner','Jamie Denbo','Daniel Franzese','Eli Goree','Phoebe Strole','Dana Gourrier','John Hartmann','Kelvin Han Yee','Alice Wetterlund','Emily Nelson','Nicole Alyse Nelson','Nick Nervies','Chloe Perrin','Paul Fitzgerald','Steve Trzaska','Christopher Avila','Jessica Gardner','Annabella Sciorra','Patrick Renna','Horatio Sanz','Lisa Long','Jon Paul Burkhart','Jake Fogelnest','Hulk Hogan','Ric Flair','Christopher Rivas','Graham Sibley','Violet Hicks','Kimmy Shields','Juan Alfonso','Jackson A. Dunn','Michael Rose','Christopher Michael','Geena Davis','Joseph Beck','Andrew Friedman','Bob Stephenson','Ray Xifo','Tami Sagher','Peter Kelamis','Colton Tran','Toby Huss','Erik Aude','Breeda Wool','Abigail Klein','Randy Sklar','Jason Sklar','Arye Gross','Murray SawChuck','Lorin McCraley','Beth Curry','Kevin Cahoon'],
screenplay:['Liz Flahive','Nick Jones','Carly Mensch','Sascha Rothchild','Rachel Shukert','Jenji Kohan','Sascha Rotermund','Kim Rosenstock','Victor Quinaz','Marquita Robinson'],
production:['Leanne Moore','Ashley Glazier'],
music:['Craig Wedren'],
camera:['Christian Sprenger','Adrian Peng Correia','Chris Teague'],
cut:['William Turro','Tanya M. Swerling','Annette Davey','Anthony Rosc','Tyler L. Cook'],
sound:['Robb Navrides','Vicki Lemar','Joshua Sieh','Chris Philp','John Chamberlin','John Kincade','Kenneth Kobett'],
scenography:['Todd Fjelsted','Kellie Jo Tinney','Harry E. Otto'],
masks:['Valerie Jackson','Taylor Bennett','Kristina Frisch','Tifanie White','Carri Hamilton','Loretta Nero','Ayat Malek Kiankhooy','Maurine Burke','Roxxi Dott'],
costumes:['Beth Morgan']},
{title:'Trust',
titleCZ:'Trust',
year:2018,
runtime:'9h 24min',
episodeRuntime:'55-64min',
countries:['USA','UK'],
genres:['Crime','Drama'],
director:['Danny Boyle','Dawn Shadforth','Jonathan van Tulleken','Emanuele Crialese','Susanna White'],
actors:['Brendan Fraser','Donald Sutherland','Hilary Swank','Charlotte Riley','Hannah New','Sophie Winkleman','Anna Chancellor','Harris Dickinson','Verónica Echegui','David Bamber','Lynda Boyd','Teresa Mahoney','Jack Laskey','Norbert Leo Butz','Silas Carson','Michael Esper','Laura Bellini','Sarah Bellini','David Agranov','Niccolò Senni','Amanda Drew','John F. Kennedy','Giuseppe Battiston','Luke de Woolfson','Michele Degirolamo','Antonio Giancarlo Zavatteri','Andrew Havill','Luca Marinelli','Francesco Colella','Nicola Rignanese','Donatella Finocchiaro','Bella Dayne','Tim Key','Kierston Wareing','Fabio Traversa','Giulia Gorietti','Nicola Di Pinto',"Cristiana Dell'Anna",'Rob Brydon','Fabrizio Ferracane','Sylvia Panacione','Clive Brunt','Pamela Betsy Cooper','Sara Pallini','John Schwab','Micah Balfour','Lisa Dwan','Cera Rose Pickering','Filippo Cerra','Adriano Falivene','Alessandro Bruni','Iacopo Paradisi','Matt Rawle'],
screenplay:['Simon Beaufoy','Brian Fillis','Harriet Braun','John Jackson','Alice Nutter'],
production:['Tim Bricknell','Lina Wong'],
music:['James Lavelle'],
camera:['Christopher Ross','Monika Lenczewska','Oliver Curtis'],
cut:['Elliot Graham','Mags Arnold','Tom Hemmings','Morten Højbjerg'],
sound:['Glenn Freemantle'],
scenography:['Suttirat Anne Larlarb','Patrick Rolfe','Ludovica Ferrario','Stella Fox'],
masks:['Ivana Primorac','Laura Allen','Francesca Giorgino','Diego Avolio'],
costumes:['Liza Bracey']},
{title:'Bleak House',
titleCZ:'Ponurý dům',
year:2005,
runtime:'7h 54min',
episodeRuntime:'29-55min',
countries:['UK','USA'],
genres:['Drama','History'],
director:['Justin Chadwick','Susanna White'],
actors:['Anna Maxwell Martin','Denis Lawson','Carey Mulligan','Gillian Anderson','Tom Georgeson','Charles Dance','Patrick Kennedy','Burn Gorman','Pauline Collins','Phil Davis','Nathaniel Parker','Alun Armstrong','Anne Reid','Natalie Press','Bryan Dick','John Lynch','Michael Smiley','Richard Griffiths','Johnny Vegas','Joanna David','Robert Pugh','Dermot Crowley','Louise Brealey','Emma Williams','Brian Pettifer','Timothy West','Patrick Monckton','Richard Harrington','Sally Leonard','Andy Linden','Peter Guinness','Tony Haygarth','Howard Coggins','Di Botcher','Anthony Cozens','Tim Dantay','Kelly Hunter','Amelda Brown','Michelle Tate','Mary Sheen','Liza Tarbuck','Dominic Coleman','John McCrea','Ian Richardson','Alistair McGowan','Harry Eden','Sean McGinley','Roberta Taylor','Warren Clarke','Keith Bartlett','Catherine Tate','Hugo Speer','Sheila Hancock','Benedict Martin','Lilo Baur','Alastair Galbraith'],
basedOn:['Charles Dickens'],
screenplay:['Andrew Davies'],
production:['Nigel Stafford-Clark'],
music:['John Lunn'],
camera:['Kieran McGuigan'],
cut:['Paul Knight'],
sound:['Stephen Griffiths'],
scenography:['Simon Elliott'],
masks:['Joe Hopker','Daniel Phillips']},
{title:'Norm',
titleCZ:'The Norm Show',
year:1999,
runtime:'19h 48min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Comedy'],
director:['Pamela Fryman','Andy Cadiff','Gary Halvorson','Ted Wass','Gail Mancuso','Gerry Cohen','Michael Lessac','Richard Correll','Wil Shriner','Bob Saget','Joe Regalbuto','Steve Zuckerman','Sam Simon','Shelley Jensen','John Fuller'],
actors:['Norm MacDonald','Laurie Metcalf','Ian Gomez','Max Wright','Artie Lange','Kate Walsh','Faith Ford','Suzanne Whang','Ezra Buzzington','Ian Buchanan','Terry Kiser','Bob Saget','Nikki Cox','Ryan Stiles','Pat Crawford Brown','Patrick Cranshaw','Neil Flynn','Melanie Chisholm','Richard Fancy','Vanessa Evigan','Dennis Miller','Michael Bacall','Damien Dante Wayans','Jeff Bryan Davis','Drew Carey','Andrea Martin','Ion Overman','Lorna Scott',"Jenny O'Hara",'Arturo Gil','Stephen Root','Art LaFleur','Alex Albrecht','John Cothran Jr.','Lyle Kanouse','Richard Pryor','Richard Libertini','Tichina Arnold','Ashley Cusato','Reiley McClendon','Ray Laska','Rex Smith','Donna Baltron','Alastair Duncan','Michael McShane','Casey Sander','Jay Huguley','Amy Castle','George Murdock','Jim O’Heir','Ping Wu','Bob Einstein','Veanne Cox','Jan Hoag','Rebecca McFarland','Fred Stoller','Kathy Kinney','Peggy Stewart','Kato Kaelin','Lawrence Mandley','Camille Winbush','Justin Ament','E.J. Callahan','Randall Carver','Janet Carroll','Tom Smothers','Bruce Jarchow','Al Ruscio','Ed Gale','Caprice Benedetti','John Balma','Jamielyn Lippman','Mark Beltzman','John Farley','Peggy Miley','Rocky McMurray','Jeanette Miller','Vicki Lewis','Heather Dubrow','Jason Stuart','Frank Novak','Jean Speegle Howard','Harrison Young','Phil McGraw','Larry Udy','Steven M. Porter','Josie DiVincenzo','Cynthia Szigeti','Ralph Peduto','Ernie Hudson Jr.','Terry Rhoads','Margarita Franco','Nicole Bilderback','Roberta Hanlen','Jim Hanna','Suanne Spoke','J.P. Manoux','Skye McKenzie','Nancy Linehan Charles','Marcy Goldman'],
screenplay:['Bruce Helford','Dave Caplan','Rob Ulin','Curtis Chin','Matt Tarses','Sarah McLaughlin','Bruce Rasmussen','Regina Stewart','Norm MacDonald','Frank Sebastiano','Lloyd Garver','Dave Finkel','Brett Baer'],
production:['Norm MacDonald','Al Lowenstein','Frank Sebastiano'],
music:['W.G. Snuffy Walden'],
camera:['Ken Lamkin'],
cut:['Pam Marshall'],
sound:['Todd Grace','John Hart'],
masks:['Pixie Schwartz','Leslie Lightfoot','Wendy Hogan','Bob Jermain'],
costumes:['Julie Rhine']},
{title:'Thank You',
titleCZ:'Komapseumnida',
year:2007,
runtime:'16h 33min',
episodeRuntime:'57-66min',
countries:['South Korea'],
genres:['Drama','Romance'],
director:['Jae-dong Lee'],
actors:['Hyeok Jang','Hyo-jin Gong','Shin-ae Seo','Seong-rok Shin','Seong-eun Kim','Yeon-mi Yoo','Mi-ryeong Jo','Goo Shin','Seung-soo Ryoo','Yong-woo Kil','Kang-hee Choi','Yong Jang','Won-joo Jeon','Ki-bang Kim','Tae-kwang Hwang','Ha-kyoon Kim','Boo-ja Kang','Yeo-jin Hong','Hyun-jung Kim'],
screenplay:['Kyeong-hee Lee'],
production:['Hwa-min Lim']},
{title:'Bleach',
titleCZ:'Bleach',
year:2004,
runtime:'167h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy'],
director:['Norijuki Abe','Akira Iwanaga','Čiaki Kon','Keizó Kusakawa','Rjó Mijata','Minoru Jamaoka','Kódži Aritomi','Kazunobu Šimizu','Kijomu Fukuda','Jasuhiro Macumura','Masaja Sasaki','Jasuo Iwamoto','Tomohisa Taguči','Taidži Kawaniši','Jukio Okazaki','Ogura Širakawa','Macuo Asami','Tomoko Hiramuki','Tecuo Ičimura','Kazuma Sató','Jošifumi Sueda','Džunja Košiba','Šigeki Hatakejama','Geisei Morita','Kazuo Nogami','Hidehito Ueda','Motosuke Takahaši','Akira Šimizu','Micutaka Nošitani','Satoši Nišimura','Masami Šimoda',"Šin'iči Watanabe",'Jošinori Odaka','Tecuja Endó','Šigeru Ueda','Júdži Morijama','Hitojuki Macui','Džun Takada','Jasuhito Nišikata','Masami Annó','Micue Jamazaki','Šigenori Kagejama','Džun Kamija','Harume Kosaka','Šigejuki Mija','Hidejo Jamamoto','Takeši Jamaguči','Hideki Tačibana','Masahiko Komino','Juzuru Tačikawa','Acuši Wakabajaši','Jukihiro Macušita','Tadahito Macubajaši','Jasuhiro Kuroda','Hikaru Murata','Micutoši Sató','Hikaru Jamaguči','Hiroaki Nišimura','Tošijuki Curu',"Šin'ičiró Ueda",'Eiko Niši','Rokó Ogiwara','Jóiči Fudžita','Kazuja Fudžiširo'],
actors:['Fumiko Orikasa','Akio Ócuka','Daisuke Namikawa',"Džun'iči Suwabe",'Hóko Kuwašima','Masaja Onosaka','Noriaki Sugijama','Romi Paku',"Šin'ičiró Miki",'Juki Macuoka','Aja Hisakawa','Činami Nišimura','Džunko Noda','Hidejuki Tanaka','Iššin Čiba','Jú Asakawa','Júdži Ueda','Ken Narita','Kózó Dózaka','Majumi Asano','Mamiko Noto','Nobuhiko Okamoto','Rie Kugimija','Susumu Čiba','Šigeru Čiba','Šózó Iizuka','Takehito Kojasu','Takuma Terašima','Tomokazu Seki','Tošihiko Seki','Wataru Takagi','Džun Fukujama','Tecuja Kakihara','Hitomi Nabatame','Kódži Jusa','Tomokazu Sugita','Kentaró Itó','Tošijuki Morikawa','Tomoe Hanba','Jutaka Aojama','Šóto Kašii','Pete Sepenuk','Daisuke Sakaguči','Kazunari Tanaka','Rina Sató','Hideo Išikawa','Kendži Hamada','Hisako Kanemoto','Micuki Saiga','Čafúrin','Jukana','Eidži Takemoto','Reiko Kiuči','Júiči Nakamura','Takahiro Sakurai','Satoši Hino','Ajumi Fudžimura','Masahito Jabe','Jú Kobajaši','Kaoru Mizuhara','Sajaka Óhara','Nobutoši Kanna','Wataru Hatano','Fumihiko Tačiki','Cubasa Jonaga','Kišó Tanijama','Sajori Išizuka','Takaja Kuroda','Hiroki Jasumoto','Sumi Šimamoto','Daisuke Góri','Šó Hajami','Nobuo Tobita','Tecu Inada','Takaši Nagasako','Kenta Mijake','Tomoko Kaneda','Kacujuki Koniši','Hirojuki Jošino','Kaoru Morota','Kijomi Asai','Hadžime Iidžima','Džin Domon','Kurumi Mamija','Kóki Mijata','Megumi Tojoguči','Daisuke Kišio','Jošikazu Nagano','Masaši Hirose','Hiroši Iida','Masaki Aizawa','Kósuke Toriumi','Hisajoši Suganuma','Noriko Šitaja','Kódži Išii','Čó','Sacuki Jukino','Tomoko Kawakami','Rjúsei Nakao','Šótaró Morikubo'],
basedOn:['Tite Kubo'],
screenplay:['Genki Jošimura','Nacuko Takahaši','Kazujuki Fudejasu','Kento Šimojama','Masaši Sogo','Mičiko Jokote','Masahiro Ókubo','Rika Nakase','Tomohisa Taguči','Mio Imamura','Masaki Hiramacu'],
production:['Noriko Kobajaši','Jutaka Sugijama','Ken Hagino','Šundži Aoki','Makoto Hidžikata'],
music:['Širó Sagisu'],
camera:['Kacufumi Sató','Tošijuki Fukušima','Kazuhiro Jamada'],
cut:['Hidetoši Okuno','Jošinori Murakami',"Džun'iči Uemacu",'Taeko Hamauzu','Akinori Mišima'],
sound:['Jukio Nagasaki'],
scenography:['Sawako Takagi','Jošio Tanioka']},
{title:'Painkiller',
titleCZ:'Zabiják bolesti',
year:2023,
runtime:'4h 49min',
episodeRuntime:'42-60min',
countries:['USA'],
genres:['Drama','Crime'],
director:['Peter Berg'],
actors:['Matthew Broderick','Uzo Aduba','West Duchovny','Dina Shihabi','Taylor Kitsch','Sam Anderson','Carolina Bartczak','Jack Mulhern','John Rothman','John Ales','Matt Baram','Darrin Baker','Noah Harpster','Ana Cruz Kayne','Zenna Davis-Jones','Billy Smith','Clark Gregg','Brian Markinson','Ron Lea','Daniel Kash','Jonathan Higgins','Maria Ricossa','David Tompa','Lara Daans','Wendy Lyon','Cece King','Johnny Sneed','Jamaal Grant','Kyle Gatehouse','Tara Samuel','Stephanie Herrera','Tyler Ritter','Trenna Keating','Yanna McIntosh','Fuad Ahmed','Laura Cilevitz','Carly Street','Julia Lalonde','Megha Sandhu','Allan Dobrescu','Stuart Hughes','Anthony Gerbrandt','Kayleigh Shikanai','Maddy Hillis','David Kohlsmith','Ned Van Zandt','Frank Moore','Al McFoster'],
basedOn:['Barry Meier'],
screenplay:['Micah Fitzerman-Blue','Noah Harpster','Will Hettinger','Boo Killebrew'],
production:['Chris Hatcher','Ariella Blejer','Dawn Kamoche','Tim King','Richard Perello'],
music:['Matt Morton'],
camera:['Brendan Steacy'],
cut:['Geofrey Hildrew','Garret Donnelly'],
sound:['Wylie Stateman'],
scenography:['Melanie Jones','Zak Faust'],
masks:['Trason Fernandes'],
costumes:['Avery Plewes']},
{title:'Once Upon a Time, There Was a King...',
titleCZ:'Byl jednou jeden král...',
year:1954,
runtime:107,
countries:['Czechoslovakia'],
genres:['Fairytale','Comedy'],
director:['Bořivoj Zeman'],
actors:['Jan Werich','Vlasta Burian','Terezie Brzková','Marie Glázrová','Irena Kačírková','Stella Májová','Milena Dvorská','Miroslav Horníček','Lubomír Lipský st.','Miloš Kopecký','Zdeněk Dítě','Josef Pehr','Vladimír Ráž','František Černý','Fanda Mrázek','František Hanus','Gustav Hrdlička','Eman Fiala','Josef Bartůněk','Josef Bělský','Ladislav Gzela','Bohuš Hradil','Vladimír Jedenáctík','Vladimír Klemens','Zdeněk Kříž','Jiří Valenta','Marcela Sedláčková','Karla Svobodová','Slávka Rosenbergová','Eva Klepáčová','Jiří Novotný','Karel Hovorka st.','Irena Bernátová','Jiřina Lukešová'],
basedOn:['Božena Němcová','Pavol Dobšinský'],
screenplay:['Jan Werich','Jiří Brdečka','Bořivoj Zeman'],
music:['Václav Trojan'],
camera:['Jan Roth'],
cut:['Josef Dobřichovský'],
sound:['Milan R. Novotný'],
scenography:['Jan Zázvorka'],
masks:['Gustav Hrdlička'],
costumes:['Bohumil Sochor']},
{title:'25 Years of Innocence',
titleCZ:'25 let neviny',
year:2020,
runtime:112,
countries:['Poland'],
genres:['Drama'],
director:['Jan Holoubek'],
actors:['Piotr Trojan','Agata Kulesza','Dariusz Chojnacki','Jan Frycz','Łukasz Lewandowski','Mikołaj Chroboczek','Andrzej Konopka','Julian Świeżewski','Magdalena Różczka','Adam Nawojczyk','Adam Kupaj','Piotr Szekowski','Artur Steranko','Elżbieta Okupska','Bartosz Bielenia','Ewelina Starejki','Sebastian Stankiewicz','Dariusz Toczek','Stanisław Linowski','Jacek Beler','Małgorzata Rudzka','Sebastian Pawlak','Magdalena Osińska','Nel Kaczmarek','Halina Bartosik','Elżbieta Bienias','Mateusz Bożek','Arkadiusz Brykalski','Szymon Bujak','Wiesław Cichy','Noah Culbreth','Katarzyna Cynke','Michał Czernecki','Mariusz Dzuryk','Amelia Dążałowicz','Marcin Fabisiak','Slawomir Federowicz','Paweł Ferens','Sebastian Figat','Joanna Gonschorek','Krzysztof Grabowski','Adam Hutyra','Piotr Jamróg','Aleksander Janiszewski','Mila Jankowska','Kaja Karpa','Hanna Knyziak','Andrzej Kordos','Ireneusz Kozioł','Małgorzata Kozłowska','Bartłomiej Krat','Mirosław Kropielnicki','Agnieszka Krukówna','Ewa Kurek','Szymon Kuśmider','Anita Lotko','Piotr Łukaszczyk','Piotr Łukawski','Paweł Łęski','Wojciech Machnicki','Konrad Marszałek','Mateusz Malecki','Tomasz Namiotko','Piotr Nowak','Stanisław Osior','Feliks Probola','Agata Pruchniewska','Adam Przybylski','Grzegorz Przybył','Emilia Puczko','Agnieszka Radzikowska','Iwo Rajski','Jacek Reda','Bożena Rudnik','Antoni Sałaj','Jacek Sałaj','Adam Sikora','Zofia Stafiej','Ireneusz Tatko','Tomasz Tarnowski','Kamila Urzędowska','Juliusz Krzysztof Warunek','Mariusz Węgłowski','Nikodem Wodzyński','Natalia Wolska','Tymoteusz Woźniak','Szymon Wróblewski','Daniel Wrzosek','Krzysztof Zarzycki','Małgorzata Zawadzka','Tomasz Komenda','Marek Dyjak','Piotr Więcławski','Dominik Wald'],
screenplay:['Andrzej Gołda'],
production:['Anna Waśniewska-Gill'],
music:['Colin Stetson','Sarah Neufeld'],
camera:['Bartłomiej Kaczmarek'],
cut:['Rafał Listopad'],
sound:['Kacper Habisiak','Marcin Kasiński','Przemysław Kamieński'],
scenography:['Maciej Fajst','Karolina Kosicka'],
masks:['Lilianna Gałązka','Mirela Zawiszewska','Justyna Osińska'],
costumes:['Weronika Orlińska']},
{title:'Men About Town',
titleCZ:'Světáci',
year:1969,
runtime:99,
countries:['Czechoslovakia'],
genres:['Comedy','Music'],
director:['Zdeněk Podskalský st.'],
actors:['Jiří Sovák','Vlastimil Brodský','Jan Libíček','Jiřina Bohdalová','Jiřina Jirásková','Iva Janžurová','Jiřina Šejbalová','Oldřich Nový','Ilja Prachař','Vladimír Menšík','Otto Šimánek','Jaroslav Moučka','Jiří Lír','Viktor Maurer','Darja Hajská','Ladislav Křiváček','Jaroslav Štercl','Karel Bláha','Josef Bek','Rudolf Kalina','Karel Hovorka st.','Karel Hála','Václav Halama','Jana Andresíková','Jiřina Bílá','Josef Borovian','Otto Budín','Zdeněk Dítě','Oldřich Hoblík','Běla Jurdová','Josef Chval','Bohuslav Konvička','Bohuslav Kupšovský','Josef Maršík','Josef Žák','Milan Neděla','Olga Jungová','Jiřina Machalická','Táňa Zavřelová','Karel Pavlík','Ela Šilarová','Marta Richterová','Helena Růžičková','Jana Sedlmajerová','Iva Šašková','Hana Talpová','Dana Balounová','Bohumil Zoula','Boleslava Svobodová','O. Březina'],
screenplay:['Vratislav Blažek'],
music:['Evžen Illín','Vlastimil Hála'],
camera:['František Valert'],
cut:['Zdeněk Stehlík'],
sound:['Josef Vlček'],
scenography:['Boris Moravec'],
masks:['Otakar Košťál','Jiřina Bissingerová','Eva Vyplelová'],
costumes:['Irena Greifová']},
{title:'Jára Cimrman Lying, Sleeping',
titleCZ:'Jára Cimrman ležící, spící',
year:1983,
runtime:81,
countries:['Czechoslovakia'],
genres:['Comedy','Biography'],
director:['Ladislav Smoljak'],
actors:['Zdeněk Svěrák','Valerie Kaplanová','Josef Abrhám','Libuše Šafránková','Marie Drahokoupilová','Vladimír Svitáček','Jaroslav Vozáb','Petr Kostka','Míla Myslíková','Boris Hybner','Jaroslav Weigel','Edita Dindělová','Zdeňka Rosolová','Ladislav Šimek','Ivan Lukeš','Leoš Suchařípa','Pavel Vondruška','Jiří Hálek','Václav Král','Bořík Procházka','Ladislav Frej st.','Jiří Zahajský','Nina Divíšková','Petr Brukner','Jiří Wimmer','Karel Houska','Věra Bublíková','Jan Cmíral st.','Petr Čepek','Milena Dvorská','František Husák','Jiří Kostka','Jan Hraběta','Marian Cingroš','Jan Kašpar','Jan Kehár','Linda Dřevikovská','Radka Dulíková','Bohumil Vávra','Jožka Stoklasa','Jaroslav Tomsa','Jana Viščaková','Lena Birková','Václav Kotva','Josef Kubíček','Vladimír Švabík','Rudolf Hrušínský ml.','Miroslav Vladyka','Vlasta Žehrová','Oldřich Vlach','Jiřina Jirásková','Jaroslava Kretschmerová','Zdeněk Podskalský st.','Jaromír Kučera','Gustav Skála','Vlastimil Zavřel','Eva Trunečková','Gustav Vondráček','Nina Strnadová-Jarková','Josef A. Stehlík','Filip Švarc','Jan Unger','Miloslav Štibich','Jiří Bruder','Ladislav Smoljak','Ivan Šlapeta','Eva Kudláčková','František Kubíček','Milan Klacek','Eliška Sirová','Martin Šotola','Jan Laibl','Ivan Kubíček','Lubomír Krystlík','Olga Michálková','Jiří Schmiedt','Jindřich Sejk','Zdeněk Skalický','Olga Světelská','Martin Mikuláš','Monika Žáková','Kateřina Smoljaková','Alžběta Smoljaková','Richard Honzovič','Stanislav Šimek'],
screenplay:['Ladislav Smoljak','Zdeněk Svěrák'],
music:['Petr Skoumal'],
camera:['Richard Valenta'],
cut:['Jiří Brožek'],
sound:['Pavel Jelínek'],
scenography:['Jiří Matolín'],
masks:['Jiří Šimon','František Čížek'],
costumes:['Irena Greifová']},
{title:'School Is the Foundation of Life',
titleCZ:'Škola základ života',
year:1938,
runtime:91,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Martin Frič'],
actors:['Theodor Pištěk','František Smolík','František Kreuzmann st.','Jaroslav Marvan','Ladislav Boháč','Václav Trégl','Karel Postranecký','Čeněk Šlégl','Marie Burešová','Lola Skrbková','Gustav Hilmar','Jaroslav Průcha','Antonín Novotný','R. A. Strejka','Ladislav Pešek','František Filipovský','Věra Gabrielová','Marta Májová','Milada Smolíková','Zdeňka Baldová','Karel Jičínský','Miloš Šubrt','Zorka Janů','Milivoj Uzelac st.','Antonín Padrlík','Vladimír Cikán','Jarmila Holmová','Ladislav Velíšek','Josef Kemr','Václav Piskáček','Vladimír Salač','Marie Pilská','František Roland','Alois Dvorský','Leopold Horešovský','Dagmar Appelová','Milena Velíšková','Marie Přikrylová','František Šimon','Martin Frič'],
screenplay:['Václav Wasserman','Jaroslav Žák'],
music:['Julius Kalaš'],
camera:['Jan Stallich'],
cut:['Jan Kohout'],
sound:['Vilém Taraba'],
scenography:['Štěpán Kopecký']},
{title:'The Shop on Main Street',
titleCZ:'Obchod na korze',
year:1965,
runtime:128,
countries:['Czechoslovakia'],
genres:['Drama','War'],
director:['Ján Kadár','Elmar Klos'],
actors:['Ida Kamińska','Jozef Kroner','František Zvarík','Hana Slivková','Martin Hollý st.','Elena Zvaríková-Pappová','Martin Gregor','Adam Matejka','Mikuláš Ladižinský','Alojz Kramár','Eugen Senaj','Tibor Vadaš','František Papp','Gita Strížencová-Mišurová','František Bujdák','Andrej Šilan','Anton Baláž','Martin Hajný','Štefan Petrák','Ladislav Farkaš','Elena Šoltésová','Milan Drotár','Jozef Hatok','Oldřich Kratochvíl','Július Piussi','Jozef Stražan','Juraj Herz','Ladislav Fecko','Stanislav Kubiš','Václav Podhorský','Štefan Servátka','Zdeněk Skalický','Jozef Príhoda','Pavol Simko','Ján Mišura','Ján Pelech','Luisa Grossová'],
basedOn:['Ladislav Grosman'],
screenplay:['Ladislav Grosman','Ján Kadár','Elmar Klos'],
music:['Zdeněk Liška'],
camera:['Vladimír Novotný'],
cut:['Jaromír Janáček'],
sound:['Dobroslav Šrámek'],
scenography:['Karel Škvor'],
masks:['Rudolf Hammer'],
costumes:['Marie Rosenfelderová']},
{title:'The Boat',
titleCZ:'Ponorka',
year:1981,
runtime:'Alternativní 200 min',
countries:['Germany'],
genres:['Drama','War'],
director:['Wolfgang Petersen'],
actors:['Jürgen Prochnow','Herbert Grönemeyer','Klaus Wennemann','Hubertus Bengsch','Martin Semmelrogge','Bernd Tauber','Erwin Leder','Martin May','Heinz Hoenig','Uwe Ochsenknecht','Otto Sander','Günter Lamprecht','Sky du Mont','Oliver Stritzel','Rita Cadillac','Jan Fedder','Ralf Richter','Joachim Bernhard','Claude-Oliver Rudolph','Dirk Salomon','Ulrich Günther','Konrad Becker','Edwige Pierre','Lutz Schnell'],
basedOn:['Lothar G. Buchheim'],
screenplay:['Wolfgang Petersen'],
production:['Günter Rohrbach'],
music:['Klaus Doldinger'],
camera:['Jost Vacano'],
cut:['Hannes Nikel'],
sound:['Milan Bor','Werner Böhm','Stanislav Litera','Heinz Schürer','Karsten Ullrich','Michael Keller'],
scenography:['Rolf Zehetbauer'],
masks:['Ago von Sperl','Alfred Rasche','Rüdiger von Sperl'],
costumes:['Monika Bauert']},
{title:'An Uncertain Season',
titleCZ:'Nejistá sezóna',
year:1987,
runtime:88,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Ladislav Smoljak'],
actors:['Zdeněk Svěrák','Ladislav Smoljak','Jaroslav Weigel','Jan Hraběta','Jaroslav Vozáb','Petr Brukner','Miloň Čepelka','Josef Vondráček','Jan Kašpar','Genadij Rumlena','Michal Weigel','Jana Vokrojová','Karel Kachyňa','Zeno Fifka','Drahomíra Fialková','Jiří Šrámek','Jaroslav Konečný','Ludvík Toman','Boca Abrhámová','Martina Bezoušková','Magda Křížková-Šebestová','Miloslav Homola','Jan Jíra','Bořivoj Penc','Václav Kotek','Václav Verner','Filip Smoljak','Jan Svěrák','Vladimír Svitáček','Kateřina Smoljaková','Alžběta Smoljaková','Robert Bárta'],
screenplay:['Zdeněk Svěrák','Ladislav Smoljak'],
music:['Petr Skoumal'],
camera:['Richard Valenta'],
cut:['Jiří Brožek','Petr Sitár'],
sound:['Antonín Kravka'],
scenography:['Jiří Matolín'],
masks:['Jana Dolejší'],
costumes:['Jaroslav Weigel']},
{title:'Three Wishes for Cinderella',
titleCZ:'Tři oříšky pro Popelku',
year:1973,
runtime:75,
countries:['Czechoslovakia','Germany'],
genres:['Fairytale'],
director:['Václav Vorlíček'],
actors:['Libuše Šafránková','Pavel Trávníček','Carola Braunbock','Rolf Hoppe','Karin Lesch','Dana Hlaváčová','Jan Libíček','Vítězslav Jandák','Jaroslav Drbohlav','Vladimír Menšík','Míla Myslíková','Helena Růžičková','Jan Šůs','Miloš Vavruška','Jiří Růžička ml.','Jiří Krytinář','Ilona Jirotková','Ostara Körner','Joachim Pape','Gerd Funk','Karl-Helge Hofstadt','Holger Eckert','Erika Stiska','Jutta Molter','Aurora Pan','Gertrud Adam','Matthias Molter','Ursula Möckel','Vincenc Vávra','Bohumil Koška','Jiří Kodýtek','Vladimír Horáček','Miroslav Krejča','Vladimír Navrátil','Mirka Cingaislová','Danuše Mikulová','Ludvík Wolf','Petr Svojtka','Jaroslava Adamová','Otto Šimánek','Květa Fialová','Mirko Musil'],
basedOn:['Božena Němcová'],
screenplay:['František Pavlíček','Václav Vorlíček'],
music:['Karel Svoboda'],
camera:['Josef Illík'],
cut:['Miroslav Hájek','Barbara Leuschner'],
sound:['František Fabián','Gerhard Ribbeck'],
scenography:['Oldřich Bosák','Alfred Thomalla'],
masks:['Vladimír Petřina','Hannelore Petzold'],
costumes:['Theodor Pištěk ml.','František Zapletal']},
{title:"The Emperor's Baker - The Baker's Emperor",
titleCZ:'Císařův pekař - Pekařův císař',
year:1951,
runtime:'80 + 64 min',
countries:['Czechoslovakia'],
genres:['Comedy','History'],
director:['Martin Frič'],
actors:['Jan Werich','Marie Vášová','Nataša Gollová','Bohuš Záhorský','Jiří Plachý st.','Zdeněk Štěpánek','František Filipovský','František Černý','Václav Trégl','Vladimír Leraus','Miloš Nedbal','Bohuš Hradil','František Holar','Vladimír Řepa','Lubomír Lipský st.','Theodor Pištěk','Bohumil Bezouška','Felix le Breux','Josef Kemr','Fanda Mrázek','Josef Hlinomaz','Ota Motyčka','Miroslav Svoboda','Jan S. Kolár','Miloš Kopecký','Eliška Kuchařová','Alois Dvorský','Jana Werichová-Kvapilová','Eva Jiroušková','Gustav Hrdlička','František Miroslav Doubrava','Marie Nademlejnská','Jaroslav Vlk','Věra Chytilová','Anna Pitašová','Vladimír Svitáček','Ladislav Rychman','Antonín Soukup','Václav Švec','Antonín Jirsa','Martin Raus','Viktor Pejsar','Emanuel Kovařík','Hynek Němec','Magda Kopřivová','Josef Oliak'],
screenplay:['Martin Frič','Jan Werich','Jiří Brdečka','Jiří Brdečka','Jan Werich'],
music:['Julius Kalaš','Zdeněk Petr'],
camera:['Jan Stallich'],
cut:['Jan Kohout'],
sound:['František Černý'],
scenography:['Jan Zázvorka'],
masks:['Gustav Hrdlička'],
costumes:['Vladimír Synek','Bohumil Sochor','Jiří Trnka']},
{title:'Lemonade Joe',
titleCZ:'Limonádový Joe aneb Koňská opera',
year:1964,
runtime:95,
countries:['Czechoslovakia'],
genres:['Comedy','Musical','Western','Adventure'],
director:['Oldřich Lipský'],
actors:['Karel Fiala','Miloš Kopecký','Květa Fialová','Olga Schoberová','Rudolf Deyl ml.','Bohuš Záhorský','Josef Hlinomaz','Karel Effa','Waldemar Matuška','Eman Fiala','Vladimír Menšík','Jiří Lír','Jiří Steimar','Jaroslav Štercl','Oldřich Lukeš','Alois Dvorský','Miloš Nedbal','Jaroslav Mareš','Antonín Šůra','Rudolf Cortés','Viktor Očásek','Stanislav Litera','Rudolf Princ','Václav Štekl','Miloš Vavruška','Břetislav Dolejší','Karel Engel','Vladimír Erlebach','Jiří Hanzl','Václav Havelka','Gustav Jankovský','Jiří Kasík','Jaroslav Klenot','Jiří Lánský','Jaroslav Mařan','Otakar Rademacher','Jindřich Sejk','Zdeněk Srstka','Jaromír Šťastný','Jaroslav Tetiva','Jaroslav Tomsa','Karel Vítek st.','Ludvík Wolf','Lubomír Žáček','Vlastimil Bedrna','Lubomír Bryg','Ladislav Gzela','Juraj Herz','Antonín Jedlička','Jiří Jelínek','Stanislav Navrátil','Jan Pohan','Jiří Schulz','Milena Zahrynowská'],
basedOn:['Jiří Brdečka'],
screenplay:['Oldřich Lipský','Jiří Brdečka','Jiří Brdečka'],
music:['Jan Rychlík','Vlastimil Hála'],
camera:['Vladimír Novotný'],
cut:['Miroslav Hájek','Jitka Šulcová'],
sound:['Josef Vlček'],
scenography:['Karel Škvor'],
masks:['Otakar Košťál'],
costumes:['Jiří Brdečka','Fernand Vácha']},
{title:'All My Compatriots',
titleCZ:'Všichni dobří rodáci',
year:1968,
runtime:115,
countries:['Czechoslovakia'],
genres:['Drama'],
director:['Vojtěch Jasný'],
actors:['Vlastimil Brodský','Radoslav Brzobohatý','Vladimír Menšík','Waldemar Matuška','Drahomíra Hofmanová','Pavel Pavlovský','Václav Babka','Josef Hlinomaz','Karel Augusta','Ilja Prachař','Václav Lohniský','Jiří Tomek','Věra Galatíková','Helena Růžičková','Oldřich Velen','Jaroslava Vysloužilová','Marie Málková','Zdeněk Kutil','Jaroslava Tichá','Oldřich Slavík','Alexandra Korytová','Vladimír Ptáček','Eva Blažková','Svatopluk Skládal','Karel Vochoč','Michaela Černá','Ivana Bílková','Milan Sandhaus','Růžena Merunková','Ludmila Lebedová','Oldřich Vykypěl','Lubomír Kostelka','Jiří Kodet','Jindřich Bonaventura','Bohumil Koška','Otakar Horký','Jan Báča','Anna Navrátilová','František Unčovský','Adolf Peterka','Jiří Němec','Milada Burešová','Jan Mauer','Rudolf Staud','Antonín Divoký','František Dostál','Leopold Fric','Jan Štafa','Jaromír Knittl','Josef Dziedzic','Jaromír Hons','Miroslav Částek','František Kašpar','Jana Marková','Zdeněk Novák','Bohuš Pastorek','Jiří Plachý ml.','Pavel Veselý','Martin Růžek','Dušan Matouš'],
screenplay:['Vojtěch Jasný'],
music:['Svatopluk Havelka'],
camera:['Jaroslav Kučera'],
cut:['Miroslav Hájek'],
sound:['Dobroslav Šrámek'],
scenography:['Karel Lier'],
masks:['Oldřich Mach'],
costumes:['Ester Krumbachová']},
{title:'The Ear',
titleCZ:'Ucho',
year:1970,
runtime:91,
countries:['Czechoslovakia'],
genres:['Drama','Psychology','Thriller'],
director:['Karel Kachyňa'],
actors:['Jiřina Bohdalová','Radoslav Brzobohatý','Gustav Opočenský','Miloslav Holub','Lubor Tokoš','Bořivoj Navrátil','Jiří Císler','Jaroslav Moučka','Karel Vašíček','Ladislav Křiváček','František Němec','Jan Teplý st.','Josef Šulc','Bronislav Poloczek','Alois Mottl','Ladislav Krečmer','Jindřich Narenta','Karel Vlček','Miroslav Nesvadba','Ivan Palúch','Vladimír Zátka','Daniela Bartáková','Alice Auspergerová','Jan Bartoš','Jana Hana Duffková','Milica Kolofíková','Galina Kopaněva','Zdeněk Hradilák','Hynek Kubasta','Senta Vollnerová'],
basedOn:['Jan Procházka'],
screenplay:['Jan Procházka','Karel Kachyňa'],
music:['Svatopluk Havelka'],
camera:['Josef Illík'],
cut:['Miroslav Hájek'],
sound:['Jiří Lenoch'],
scenography:['Oldřich Okáč'],
masks:['Stanislav Petřek']},
{title:'Czech Soda',
titleCZ:'Česká soda',
year:1998,
runtime:91,
countries:['Czechia'],
genres:['Comedy'],
director:['Milan Šteindler','Václav Křístek','Jan Hřebejk','Fero Fenič','Petr Čtvrtníček','Igor Chaun','Ján Sebechlebský'],
actors:['Petr Čtvrtníček','Milan Šteindler','David Vávra','Veronika Žilková','Vlastimil Zavřel','Jaromír Dulava','Pavel Bobek','Karel Dobrý','Jiří Maria Sieber','David Nykl','Bohumil Klepl','Richard Honzovič','Zdeněk Dolejší'],
screenplay:['Petr Čtvrtníček','Milan Šteindler','Václav Křístek','Ján Sebechlebský','Milan Tesař'],
production:['Čestmír Kopecký','Fero Fenič'],
camera:['Jiří Lebeda'],
cut:['Vladimír Barák','Jiří Brožek','Ľuba Ďurkovičová'],
sound:['Daniel Němec','Petr Kabrhel','Lumír Turek']},
{title:'Station Master',
titleCZ:'Přednosta stanice',
year:1941,
runtime:88,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Jan Sviták'],
actors:['Vlasta Burian','Zita Kabátová','Čeněk Šlégl','Antonín Zacpal','Růžena Šlemrová','Jaroslav Marvan','Václav Trégl','Theodor Pištěk','Marie Norrová','Darja Hajská','František Černý','Karel Postranecký','Bohumil Hradčanský','Bolek Prchal','Emanuel Kovařík','Ada Dohnal','Lída Borovcová-Marečková','Zdeněk Martínek ml.','Míla Svoboda','Karel Veverka','Dalibor Pták','Vojta Merten','Alois Dvorský','F. X. Mlejnek','Václav Švec','Marie Hodrová'],
screenplay:['André Mouézy-Éon','Václav Wasserman'],
music:['Jára Beneš'],
camera:['Jaroslav Tuzar'],
cut:['Antonín Zelenka'],
sound:['Antonín Rambousek'],
scenography:['Bohumil Heš']},
{title:'Ducháček Will Fix It',
titleCZ:'Ducháček to zařídí',
year:1938,
runtime:86,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Karel Lamač'],
actors:['Vlasta Burian','Ladislav Hemmer','Milada Gampeová','Karel Máj','Adina Mandlová','Čeněk Šlégl','Jaroslav Marvan','Jiřina Sedláčková','Václav Trégl','Marie Blažková','Theodor Pištěk','Karel Postranecký','Karel Němec','Milka Balek-Brodská','Ferdinand Jarkovský','Václav Menger','Josef Oliak','Vladimír Pospíšil-Born','Alois Dvorský','Elsa Vetešníková','Karel Jičínský','Karel Lamač','Václav Wasserman','Otto Heller','Eman Fiala','Josef Zora','Václav Dražil','Vratislav Innemann','Marie Pilská'],
screenplay:['Václav Wasserman','Rudolf Österreicher','Rudolf Bernauer'],
music:['Eman Fiala'],
camera:['Otto Heller'],
sound:['Josef Zora']},
{title:'Nebe a dudy',
titleCZ:'Nebe a dudy',
year:1941,
runtime:91,
countries:['Czechoslovakia'],
genres:['Comedy','Romance'],
director:['Vladimír Slavínský'],
actors:['Jindřich Plachta','Jana Romanová','Jiří Blahník','Lumír Blahník','Jaroslav Marvan','Raoul Schránil','Antonie Nedošinská','Zdeněk Podlipný','Karel Dostal','František Filipovský','Sláva Grossmann','Antonín Holzinger','Vladimír Pospíšil-Born','Jan Černý','Jiří Vondrovič','Ladislav Herbert Struna','Vladimír Růžička','Václav Švec','Miloš Šubrt','Bolek Prchal','Fanča Inka Lopatová-Horáková','Vladimír Řepa','Robert Vyhlídka','Leopold Horešovský'],
screenplay:['František Vlček st.'],
music:['Josef Dobeš'],
camera:['Ferdinand Pečenka'],
cut:['Jan Kohout'],
sound:['Emil Poledník']},
{title:'The Creation of the World',
titleCZ:'Stvoření světa',
year:1957,
runtime:80,
countries:['France','Czechoslovakia'],
genres:['Animation','Comedy','Family','Music'],
director:['Eduard Hofman'],
actors:['Jan Werich','Antonín Jedlička','Bohuslav Kupšovský','François Périer','Martine Sarcey','Georges Aminel'],
music:['Jan Rychlík','Jean Wiener'],
camera:['Zdenka Hajdová'],
cut:['Zdenka Navrátilová'],
sound:['Josef Vlček']},
{title:'Yip Man',
titleCZ:'Ip Man',
year:2008,
runtime:106,
countries:['Hong Kong','China'],
genres:['Action','Drama','Sport','Biography'],
director:['Wilson Yip'],
actors:['Donnie Yen','Simon Yam','Lynn Hung','Hirojuki Ikeuči','Gordon Lam','Terry Fan','Dennis To','Yanneng Shi','You-Nam Wong','Tony Siu-Hung Leung','Carlson Cheng','Kong Kam','Tenma Shibuya','Zhihui Chen'],
screenplay:['Edmond Wong','Tai-lee Chan'],
production:['Raymond Pak-Ming Wong'],
music:['Kendži Kawai'],
camera:['Sing-Pui O'],
cut:['Ka-Fai Cheung'],
sound:['Kinson Tsang','George Lee'],
scenography:['Kenneth Mak'],
masks:['Maggie Choy'],
costumes:['Pik-Kwan Lee']},
{title:'Riders in the Sky',
titleCZ:'Nebeští jezdci',
year:1968,
runtime:92,
countries:['Czechoslovakia'],
genres:['War','Drama'],
director:['Jindřich Polák'],
actors:['Jiří Bednář','Jiří Hrzán','Svatopluk Matyáš','Elsie Randolph','Joan Seton','Charles Cameron','Jana Nováková','Gunter Schoß','Winston Chrislock','Vojtěch Holý','Josef Váša','Victor Carter','Geoffrey Russell-Jones','Jaroslav Rozsíval','Ivan Krajíček','Karel Hála','Jan Kaplický','Zlata Adamová','Marie Cingrošová','Jana Sedlmajerová','Jarmila Škrabanová','Ivan Foltýn','Jaroslav Toms','Kazimierz Siedlaczek','Milan Morávek','Celestýn Mrázek','Zdeněk Novotný','Bedřich Šetena','Otakar Šindelář','Jaroslav Vlk','Antonín Kubový','Ladislav Bezubka','Karel Kos','Václav Král','Čestmír Preclík','Zdeněk Šedivý','Karel Hruška','Josef Chrastil','Oldřich Unger','Jaroslav Doktor','Michal Dočolomanský'],
screenplay:['Zdeněk Mahler','Jindřich Polák'],
music:['Evžen Illín'],
camera:['Jan Němeček'],
cut:['Josef Dobřichovský'],
sound:['Bedřich Poledník'],
scenography:['Karel Černý'],
masks:['Rudolf Hammer'],
costumes:['Jan Kropáček']},
{title:'Silent Pain',
titleCZ:'Tichá bolest',
year:1990,
runtime:86,
countries:['Czechoslovakia'],
genres:['Drama'],
director:['Martin Hollý ml.'],
actors:['Rudolf Hrušínský','Ivan Jiřík','Vítězslav Jandák','Miroslav Táborský','Jiří Sedláček','Martin Dejdar','Tomáš Juřička','Jiří Pomeje','Dušan Cinkota','Jiří Langmajer','Tomáš Vacek','Daniel Landa','Daniel Větrovský','Marie Durnová','Radan Rusev','Pavel Zedníček','Jan Vlasák','Oldřich Slavík','Stanislav Zindulka','Valentina Thielová','Monika Žáková','Jiří Novotný','Václav Svoboda'],
screenplay:['Jiří Křižan'],
production:['Karel Kochman'],
music:['Svatopluk Havelka'],
camera:['František Uldrich'],
cut:['Ivana Kačírková'],
sound:['Vladimír Skall'],
scenography:['Jiří Hlupý'],
masks:['Eva Vyplelová'],
costumes:['Jan Kropáček','Jana Ledecká']},
{title:'The Assassination',
titleCZ:'Atentát',
year:1964,
runtime:100,
countries:['Czechoslovakia'],
genres:['Drama','War','History','Thriller'],
director:['Jiří Sequens st.'],
actors:['Radoslav Brzobohatý','Rudolf Jelínek','Ladislav Mrkvička','Luděk Munzar','Jiří Kodet','Josef Vinklář','Siegfried Loyda','Harry Studt','Wolf Goette','Gerhard Rachold','Harald Halgardt','Vlastimil Čaněk','Jaroslav Dufek','Václav Kutheil','Pavel Molčík','Jiří Holý','Jaroslav Moučka','Petr Oliva','Jiří Vršťala','Vlasta Matulová','Vladimír Hlavatý','Josef Trousílek','Oldřich Velen','Gustav Heverle','Miloš Vavruška','Eduard Dubský','Alex Jandouš','Oldřich Lukeš','Ivo Foustka','Pavel Robin','Richard Záhorský','Ludmila Dyrová','Věra Kalenská','Milada Lukašovská','Pavel Bártl','Miroslav Barták','Jiří Cimický','Karel Černoch','Jaroslav Ciboch','Arnošt Faltýnek','Oto Ševčík','Jan Neubert','Vladimír Navrátil','Vladimír Machek','Jan Laibl','Jaroslav Krupař','Pavel Kvasnička','Křížek','Jiří Hein','Ladislav Gzela','Jindřich Chmela','Josef Šolc','Stanislav Fišer','Jindřich Narenta'],
screenplay:['Kamil Pixa','Miloslav Fábera','Jiří Sequens st.'],
camera:['Rudolf Milič'],
cut:['Jan Chaloupek'],
sound:['Jiří Kejř'],
scenography:['Karel Lier'],
masks:['Oldřich Mach'],
costumes:['Libuše Hozová','František Sadílek','Marie Broncová']},
{title:'Hope',
titleCZ:'Sowon',
year:2013,
runtime:123,
countries:['South Korea'],
genres:['Drama'],
director:['Joon-ik Lee'],
actors:['Re Lee','Kjong-gu Sol','Ji-won Eom','Mi-ran Ra','Sang-ho Kim','Hae-sook Kim','Jin-seong Yang','Tae-won Kwon','Jin-hyeok Kim','Bok-rae Jo','Sin-cheol Kang','Min-seong Jeong','Se-ha Ahn','Moon-ee Jo','Dae-woong Jang','Hyun-woo Seo','Mi-kyeong Kim','Yeong-gyu Song','Do-yeop Kim'],
basedOn:['Jae-won So'],
screenplay:['Joong-hoon Jo','Ji-hye Kim'],
music:['Jun-seok Bang']},
{title:'Adela Has Not Had Her Supper Yet',
titleCZ:'Adéla ještě nevečeřela',
year:1978,
runtime:105,
countries:['Czechoslovakia'],
genres:['Comedy','Crime','Sci-Fi'],
director:['Oldřich Lipský'],
actors:['Michal Dočolomanský','Rudolf Hrušínský','Miloš Kopecký','Václav Lohniský','Ladislav Pešek','Naďa Konvalinková','Květa Fialová','Martin Růžek','Olga Schoberová','Zdeněk Dítě','Karel Effa','Vladimír Hrubý','Petr Brukner','Vladimír Hrabánek','Milan Mach','Myrtil Frída','Jiří Brdečka','Vítězslav Černý','Milivoj Uzelac st.','Jan Kotva','Ladislav Krečmer','Pavel Kudláček','Vilém Lipský','Václav Cihelka','Leoš Holan','Petr Hornych','Vladimír Navrátil','Zdeněk Růžička','Josef Vašátko','Miloš Vychtil','Vladislav Vychtil','Jiří Vančura','Jiřina Bílá','Lena Birková','Hana Brejchová','Lorna Homoláčová-Vančurová','Běla Jurdová','Jiřina Koucká','Jarmila Orlová','Marie Popelková','Eva Přidalová','Jitka Zelenohorská','Jiří Kosek','Andrea Andreánská','Zdena Heřmanová','Milena Kaplická','Jana Sedlmajerová','Hana Šterclová','Isabella Tylínková','Marcela Vraná','Miroslav Chochola','Jiří Kraus','Antonín Kramerius','Jan Prokeš','Petr Popelák','Helena Růžičková','Miloš Rozhoň','Pavel Robin','Jiří Šašek','Míla Svoboda','Václav Štekl','Zdeněk Srstka','Václav Štercl','Karel Šott ml.','Viktor Rindler','Miloslav Novák','Ivana Beranová','Dana Daňková','Dana Horáková','Elena Lindauerová','Jindřiška Šulcová','Marcela Šulcová','Eva Tichá','Jitka Vašutová','Jiří Bureš','Miloš Kuchyňka','Lubomír Přidal','Miroslav Dvořák','Josef Pechanec','Miroslav Polívka','Vojtěch Přidal','Gaston Šubert','Jaroslav Toms','Gustav Vondráček','Jiří Vyvadil','Miroslav Vydlák','Ivan Vorlíček','Bohumil Koška','Jaroslav Wagner-Klenka','Otakar Žebrák','Emanuel Brejša','Josef Braun','Vlasta Ziegner','Pavel Stránský','Michael Tarant','Miloslava Dlhá','Jaroslav Engelhart','Karel Engel','František Jákl','Stanislav Benda'],
screenplay:['Jiří Brdečka','Oldřich Lipský'],
music:['Luboš Fišer'],
camera:['Jaroslav Kučera'],
cut:['Miroslav Hájek'],
sound:['Jiří Lenoch'],
scenography:['Vladimír Labský','Milan Nejedlý'],
masks:['František Čížek'],
costumes:['Theodor Pištěk ml.']},
{title:'Divided We Fall',
titleCZ:'Musíme si pomáhat',
year:2000,
runtime:120,
countries:['Czechia'],
genres:['Comedy','Drama','War'],
director:['Jan Hřebejk'],
actors:['Bolek Polívka','Csongor Kassai','Jaroslav Dušek','Anna Šišková','Jiří Pecha','Martin Huba','Simona Stašová','Vladimír Marek','Jiří Kodet','Richard Tesařík','Kryštof Hanzlík','Anna Jarchovská','Iveta Dušková','Oto Ševčík','Karel Heřmánek',"Pjér la Šé'z",'Martin Dušek','Robert Štěrba'],
screenplay:['Petr Jarchovský'],
production:['Pavel Borovan','Ondřej Trojan'],
music:['Aleš Březina'],
camera:['Jan Malíř'],
cut:['Vladimír Barák'],
sound:['Karel Jaroš'],
scenography:['Milan Býček'],
masks:['Hana Šímová'],
costumes:['Katarína Hollá']},
{title:'Fimfárum Jana Wericha',
titleCZ:'Fimfárum Jana Wericha',
year:2002,
runtime:100,
countries:['Czechia'],
genres:['Animation','Puppets','Fairytale','Tale','Fantasy'],
director:['Vlasta Pospíšilová','Aurel Klimt'],
actors:['Jan Werich','Ota Jirák'],
basedOn:['Jan Werich'],
screenplay:['Jiří Kubíček','Aurel Klimt'],
production:['Aurel Klimt','Martin Vandas','Magdalena Sedláková','Michal Havlík'],
music:['Petr Hapka','Miroslav Kořínek','Vladimír Merta','Petr Soudek','Miroslav Wanek'],
camera:['Vladimír Malík','Zdeněk Pospíšil'],
cut:['Aurel Klimt','Jiřina Pěčová','Jan Sládek'],
sound:['Pavel Dvořák','Ivo Špalj','Marek Musil','Jan Kacián']},
{title:'Nuremberg',
titleCZ:'Norimberk',
year:2000,
runtime:'89 + 90 min',
countries:['Canada','USA'],
genres:['Drama','History','War'],
director:['Yves Simoneau'],
actors:['Alec Baldwin','Jill Hennessy','Brian Cox','Michael Ironside','Matt Craven','Len Cariou','Herbert Knaup','Charlotte Gainsbourg','Colm Feore','Robert Joy','Max von Sydow','Christopher Plummer','Christopher Shyer','David McIlwraith','Hrothgar Mathews','Christopher Heyerdahl','Larry Day','Alain Goulem','Mark Ryan','David La Haye','Julien Poulin',"Douglas O'Keeffe",'Joris Jarsky','Baldur von Schirach','Adam MacDonald','Paul Hopkins','Roc LaFortune','Joe Cobden','Susan Glover','Shawn Baichoo','Ken Kramer','Raymond Cloutier','Guy Sprung','Tom Rack','Mark Houghton','Gabriel Gascon','Geoffrey Pounsett','Lorne Brass','Frank Moore','Scott Gibson','Len Doncheff','Roger Dunn','Marc Gourdeau'],
basedOn:['Joseph E. Persico'],
screenplay:['David W. Rintels'],
music:['Richard Grégoire'],
camera:['Alain Dostie'],
cut:['Yves Langlois'],
sound:['Michael Prestwood Smith','Ian Rankin'],
scenography:['Guy Lalande','Réal Proulx'],
masks:['Carl Fullerton'],
costumes:['Mario Davignon']},
{title:'Jean od Floretty',
titleCZ:'Jean od Floretty',
year:1986,
runtime:120,
countries:['France','Switzerland','Italy'],
genres:['Drama'],
director:['Claude Berri'],
actors:['Yves Montand','Gérard Depardieu','Daniel Auteuil','Elisabeth Depardieu','Margarita Lozano','Ernestine Mazurowna','Roger Souza','Chantal Liennel','Armand Meffre','Marcel Champel','Marc Betton','Jean Maurel','Didier Pain','Marcel Berbert','Fransined','André Dupon','Pierre Nougaro','Jo Doumerg'],
basedOn:['Marcel Pagnol'],
screenplay:['Gérard Brach','Claude Berri'],
music:['Jean-Claude Petit'],
camera:['Bruno Nuytten'],
cut:['Hervé de Luze','Noëlle Boisson','Sophie Coussein','Arlette Langmann'],
sound:['Pierre Gamet','Dominique Hennequin','Laurent Quaglio'],
scenography:['Bernard Vézat'],
masks:['Pierre Berroyer','Jean-Pierre Eychenne'],
costumes:['Sylvie Gautrelet']},
{title:'Ball Lightning',
titleCZ:'Kulový blesk',
year:1978,
runtime:82,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Ladislav Smoljak','Zdeněk Podskalský st.'],
actors:['Rudolf Hrušínský','Karel Kalaš','Josef Abrhám','Daniela Kolářová','Bedřich Prokoš','Zita Kabátová','Milada Ježková','Ladislav Smoljak','Zdeněk Svěrák','Karolina Slunéčková','Rudolf Vodrážka','Jaroslav Vozáb','Marie Málková','Věra Kalendová','Zora Božinová','Emilie Zíchová','Petr Brukner','Vlasta Žehrová','Rudolf Pechan','Vít Olmer','Pavel Vondruška','Tibor Kiss','Mari Kiss','Karel Bělohradský','David Smoljak','Dana Vávrová','Daniel Beran','Hana Jírková','Alexandra Korytová','Zdena Pavlátová','Z. Petrová','V. Prášilová','Karel Engel','Jan Cmíral st.','Josef Koudelka Bergstein','Erich Fichtner','Josef Střecha','Zdeněk Srstka','Vít Pešina','Jaroslav Weigel','Eliška Moulisová','Petr Drozda','Karel Hovorka ml.','Bohumil Koška','Miloslav Štibich','Václav Kotek','Zdena Lukášová','Václav Syřiště','Ivan Šlapeta','Jiří Flíček','Alice Pinková','Jaroslav Klenot','Oldřich Semerák','Filip Smoljak'],
screenplay:['Ladislav Smoljak','Zdeněk Svěrák'],
music:['Zdeněk Lukáš'],
camera:['Ivan Šlapeta'],
cut:['Jiří Brožek'],
sound:['Jiří Lenoch'],
scenography:['Boris Moravec'],
masks:['Rudolf Buneš'],
costumes:['Jitka Moravcová','Helena Vondrušková']},
{title:'Mach a Šebestová k tabuli!',
titleCZ:'Mach a Šebestová k tabuli!',
year:1985,
runtime:69,
countries:['Czechoslovakia'],
genres:['Animation','Comedy','Family'],
director:['Miloš Macourek','Jaroslav Doubrava','Adolf Born'],
actors:['Petr Nárožný'],
basedOn:['Miloš Macourek'],
screenplay:['Miloš Macourek','Jaroslav Doubrava','Adolf Born'],
music:['Luboš Fišer'],
camera:['Zdenka Hajdová','Eva Kargerová'],
cut:['Marta Látalová'],
sound:['František Černý','Benjamin Astrug']},
{title:'Metropolis',
titleCZ:'Metropolis',
year:1927,
runtime:153,
countries:['Germany'],
genres:['Sci-Fi','Drama'],
director:['Fritz Lang'],
actors:['Alfred Abel','Gustav Fröhlich','Rudolf Klein-Rogge','Fritz Rasp','Theodor Loos','Erwin Biswanger','Brigitte Helm','Fritz Alberti','Grete Berger','Olly Boeheim','Max Dietze','Ellen Frey','Beatrice Garga','Heinrich George','Curt Siodmak','Helene Weigel','Dolly Grey','Anny Hintze','Georg John','Walter Kuehle','Margarete Lanner','Rolf von Goth','Helen von Münchofen'],
basedOn:['Thea von Harbou'],
screenplay:['Thea von Harbou','Fritz Lang'],
production:['Erich Pommer'],
music:['Gottfried Huppertz','Abel Korzeniowski','Giorgio Moroder'],
camera:['Karl Freund'],
scenography:['Erich Kettelhut']},
{title:'Ten den přijde',
titleCZ:'Ten den přijde',
year:2016,
runtime:110,
countries:['Denmark'],
genres:['Drama'],
director:['Jesper W. Nielsen'],
actors:['Lars Mikkelsen','Sofie Gråbøl','Harald Kaiser Hermann','Albert Rudbeck Lindhardt','Laurids Skovgaard Andersen','Lars Ranthe','Søren Sætter-Lassen','David Dencik','Sonja Richter','Solbjørg Højfeldt','Claus Bahnsen','Paw Henriksen','Mogens Holm','Mads Wille','Thomas Guldberg Madsen','Jens Jørn Spottag','Rasmus Lind Rubin','Jakob Bjerregaard Engmann','Morten Hauch-Fausbøll','Benjamin Kitter','Mads Kruse','Ulla Vejby','Simon Papousek'],
screenplay:['Søren Sveistrup'],
production:['Sisse Graum Jørgensen','Peter Aalbæk Jensen'],
music:['Sune Martin'],
camera:['Erik Zappon'],
cut:['Janus Billeskov Jansen','Morten Højbjerg'],
sound:['Eddie Simonsen','Thomas Jæger','Thomas Arent'],
scenography:['Sabine Hviid','Kristina Kovacs'],
masks:['Louise Hauberg Lohmann','Tina Helmark','Katrine Tersgov','Morten Jacobsen'],
costumes:['Stine Thaning','Pia Anthony']},
{title:'Payback: Straight Up',
titleCZ:'Payback: Straight Up',
year:2006,
runtime:90,
countries:['USA'],
genres:['Action','Crime','Drama','Thriller'],
director:['Brian Helgeland'],
actors:['Mel Gibson','Gregg Henry','Maria Bello','Bill Duke','Deborah Kara Unger','John Glover','William Devane','Lucy Liu','David Paymer','Sally Kellerman','James Coburn','Jack Conley','Christian Stolte','Alex Henteloff','Kwame Amoaku','Tedd Taskey'],
basedOn:['Donald E. Westlake'],
screenplay:['Brian Helgeland'],
production:['Bruce Davey'],
camera:['Ericson Core'],
cut:['Kevin Stitt'],
sound:['Derek Marcil','Chris Carpenter','Gary Coppola'],
scenography:['Richard Hoover','Sandy Struth'],
masks:['Matthew W. Mungle'],
costumes:['Ha Nguyen']},
{title:'Fantomas',
titleCZ:'Fantomas',
year:2024,
runtime:'024',
countries:['France'],
genres:['Action','Crime','Horror','Mystery'],
actors:['Guillaume Campanacci'],
basedOn:['Marcel Allain'],
screenplay:['Christophe Gans'],
production:['Thomas Langmann']},
{title:'Behold Homolka',
titleCZ:'Ecce homo Homolka',
year:1969,
runtime:80,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Jaroslav Papoušek'],
actors:['Josef Šebánek','Marie Motlová','František Husák','Helena Růžičková','Petr Forman','Matěj Forman','Yvonne Kodoňová','Miki Jelínek','Jiří Dědík','Růžena Pružinová','Karel Fridrich','Julie Kučerová-Nezavdalová'],
screenplay:['Jaroslav Papoušek'],
music:['Karel Mareš'],
camera:['Jozef Ort-Šnep'],
cut:['Jiřina Lukešová'],
sound:['Adolf Böhm'],
scenography:['Karel Černý'],
masks:['Rudolf Hammer'],
costumes:['Ludmila Kaválková']},
{title:'Shake Hands with the Devil',
titleCZ:'Shake Hands with the Devil',
year:2007,
runtime:112,
countries:['Canada'],
genres:['Drama','History','War'],
director:['Roger Spottiswoode'],
actors:['Roy Dupuis','Deborah Kara Unger','Jean-Hugues Anglade','Tom McCamus','Patrice Faye','Akin Omotoso','John Matshikiza','Philip Akin','Justin Craig','David Calderisi','Daniel Janks','Michel Mongeau','Robert Lalonde','James Gallanders','Owen Sejake'],
music:['David Hirschfelder'],
camera:['Miroslaw Baszak'],
cut:['Michel Arcand'],
scenography:['Lindsey Hermer-Bell'],
costumes:['Joyce Schure']},
{title:'Mary and Max',
titleCZ:'Mary a Max',
year:2009,
runtime:89,
countries:['Australia'],
genres:['Animation','Comedy','Drama'],
director:['Adam Elliot'],
actors:['Toni Collette','Philip Seymour Hoffman','Eric Bana','Barry Humphries','Bethany Whitmore','Christopher Massey','Julie Forsyth','Alf Klimek','Melanie Coombs'],
screenplay:['Adam Elliot'],
production:['Melanie Coombs'],
music:['Dale Cornelius']},
{title:"Watch Out, We're Mad",
titleCZ:'Jestli se rozzlobíme, budeme zlí',
year:1974,
runtime:101,
countries:['Italy','Spain'],
genres:['Comedy','Action'],
director:['Marcello Fondato'],
actors:['Terence Hill','Bud Spencer','Patty Shepard','Donald Pleasence','Giovanni Cianfriglia','Pietro Torrisi','Omero Capanna','Ada Pometti','Manuel de Blas','Deogratias Huerta','Luis Barbero','Giancarlo Bastianoni','Franco Moruzzi','Osiride Pevarello','Rafael Albaicín','Inés Morales','José Luis Lizalde','Franco Ukmar','Rocco Lerro','Emilio Laguna','José Yepes','José Panizo','John Sharp','Rémy Julienne'],
screenplay:['Marcello Fondato','Francesco Scardamaglia','Vicente Coello'],
production:['Mario Cecchi Gori'],
music:['Guido De Angelis','Maurizio De Angelis'],
cut:['Alfonso Santacana','Sergio Montanari'],
sound:["Gianni D'Amico"],
scenography:['Franco Vanorio'],
masks:['Toñy Nieto','Gino Zamprioli'],
costumes:['Luca Sabatelli']},
{title:'The Tale of John and Mary',
titleCZ:'Pohádka o Honzíkovi a Mařence',
year:1980,
runtime:65,
countries:['Czechoslovakia'],
genres:['Animation','Fairytale','Adventure','Fantasy'],
director:['Karel Zeman'],
actors:['Otakar Brousek st.','Jaroslav Moučka','František Filipovský','Naďa Konvalinková','Helena Vondráčková','Zdeněk Vašek','Miloš Vosmanský','Hana Zaoralová','Antonín Procházka','Jana Tomečková','Jiří Juřina','Karel Semerád'],
screenplay:['Karel Zeman'],
music:['Karel Svoboda'],
camera:['Zdeněk Krupa'],
cut:['Ivan Matouš'],
sound:['Radomír Koutek']},
{title:'Today for the Last Time',
titleCZ:'Dnes naposled',
year:1958,
runtime:93,
countries:['Czechoslovakia'],
genres:['Drama','Psychology'],
director:['Martin Frič'],
actors:['Zdeněk Štěpánek','František Smolík','Vladimír Ráž','Jaroslav Mareš','Vladimír Menšík','Jiří Sovák','Antonie Hegerlíková','Irena Kačírková','Běla Jurdová','Eva Očenášová','Václav Tomšovský','Luděk Munzar','Vlastimil Brodský','Václav Lohniský','Jarmil Škrdlant','Karel Peyr','Zbyněk Vostřák','Bedřich Bozděch','Jiřina Bohdalová','Oldřich Dědek','Marta Fričová','František Holar','Roman Holát','Bohuš Hradil','Vladimír Hrubý','Ota Motyčka','Fanda Mrázek','Jindřich Narenta','Zdeněk Řehoř','Ladislav Herbert Struna','Miroslav Svoboda','Stella Zázvorková','Věra Váchová','Karel Hovorka st.','Věra Ferbasová','Marcela Sedláčková'],
screenplay:['Josef Neuberg','František Vlček st.'],
music:['Jiří Srnka'],
camera:['Jaroslav Tuzar'],
cut:['Jan Kohout'],
sound:['Emanuel Formánek'],
scenography:['Bohuslav Kulič'],
masks:['Josef Mann'],
costumes:['Magdaléna Balíková-Dziaková','Věra Hromádková']},
{title:'Here Comes the Mole',
titleCZ:'Krtek',
year:2011,
runtime:74,
countries:['Czechia','Finland'],
genres:['Animation','Adventure'],
director:['Zdeněk Miler'],
screenplay:['Zdeněk Miler'],
production:['Tom Carpelan'],
music:['Wiliam Bukový','Vadim Petrov','Miloš Vacek'],
camera:['Zdenka Hajdová','Ivan Masník','Emil Strakoň'],
cut:['Marta Látalová','Květa Mašková','Marta Stuchlíková']},
{title:'Eva Fools Around',
titleCZ:'Eva tropí hlouposti',
year:1939,
runtime:90,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Martin Frič'],
actors:['Nataša Gollová','Oldřich Nový','Zdeňka Baldová','Gustav Hilmar','Ella Nollová','Marta Májová','Jiřina Sedláčková','Josef Gruss','Raoul Schránil','Bolek Prchal','Milena Velíšková','Ada Dohnal'],
basedOn:['Fan Vavřincová'],
screenplay:['Vladimír Peroutka'],
music:['Jiří Traxler','Kamil Běhounek'],
camera:['Václav Hanuš'],
cut:['Jan Kohout'],
sound:['Josef Zora'],
scenography:['Jan Zázvorka']},
{title:'Asterix vs. Caesar',
titleCZ:'Asterix a překvapení pro Cézara',
year:1985,
runtime:79,
countries:['France'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Paul Brizzi','Gaëtan Brizzi'],
actors:['Roger Carel','Pierre Tornade','Serge Sauvion','Pierre Mondy','Henri Labussière','Yves Barsacq','Henri Poirier','Patrick Préjean','Martin Lamotte','Pierre Tchernia','Nicolas Silberg','Jean-Pierre Darras','Paul Bisciglia','Billy Kearns','Roger Lumont','Alain Doutey','Pierre Mirat','Pierre Semmler','Steve Gadler','José Luccioni','Thierry Ragueneau','Patrick Floersheim','Gérard Croce','Gordon Heath','Mostéfa Stiti','Séverine Morisot','Danielle Licari'],
basedOn:['René Goscinny','Albert Uderzo'],
music:['Vladimir Cosma'],
cut:['Monique Isnardon','Robert Isnardon'],
sound:['Jack Jullian']},
{title:'The Valley of the Bees',
titleCZ:'Údolí včel',
year:1967,
runtime:96,
countries:['Czechoslovakia'],
genres:['Drama','History'],
director:['František Vláčil'],
actors:['Petr Čepek','Jan Kačer','Věra Galatíková','Zdeněk Sedláček','Zdeněk Kryzánek','Jana Hájková','Michal Kožuch','Ladislav Gzela','Petr Štěpánek','Josef Somr','Miloš Willig','Miroslav Macháček','František Husák','Jana Hlaváčková','František Kovářík','Václav Kotva','Josef Kotapiš','Antonín Pražák','Petr Sedlák','Ludvík Wolf','Vladimír Navrátil','Zdeněk Chlum','Jiří Stivín','Vlastimila Vlková','Zdeněk Řehoř','Vlastimil Hašek','Pavel Landovský','Vítězslav Vejražka'],
basedOn:['Vladimír Körner'],
screenplay:['Vladimír Körner','František Vláčil'],
music:['Zdeněk Liška'],
camera:['František Uldrich'],
cut:['Miroslav Hájek'],
sound:['František Fabián'],
scenography:['Jindřich Goetz'],
masks:['František Malec'],
costumes:['Theodor Pištěk ml.','Eva Martincová']},
{title:'Otec',
titleCZ:'Otec',
year:1981,
runtime:85,
countries:['Czechoslovakia'],
genres:['Family','Drama'],
director:['Andrej Lettrich'],
actors:['Ľubomír Paulovič','Petra Černocká','Hana Slivková','František Filipovský','Jiří Krampol','Dušan Tarageľ','Ľudovít Króner','Juraj Predmerský','Ján Mildner','Anton Šulík st.','Judita Ďurdiaková','Ján Kramár','Tomáš Žilinčík','Mária Hojerová','Ivan Laca','Martin Hunčár'],
screenplay:['Peter Kováčik'],
music:['Vítězslav Hádl'],
camera:['Tibor Biath'],
cut:['Eduard Klenovský'],
sound:['Milan Strojný'],
scenography:['Juraj Červík']},
{title:'Once Were Warriors',
titleCZ:'Kdysi byli bojovníky',
year:1994,
runtime:102,
countries:['New Zealand'],
genres:['Drama','Crime'],
director:['Lee Tamahori'],
actors:['Rena Owen','Temuera Morrison','Cliff Curtis','Pete Smith','George Henare','Ian Mune','Julian Arahanga','Mamaengaroa Kerr-Bell','Riwia Brown','Taungaroa Emile','Jim Ngaata'],
screenplay:['Riwia Brown'],
camera:['Stuart Dryburgh'],
sound:['Graham Morris'],
scenography:['Michael Kane','Shayne Radford']},
{title:'Osudy dobrého vojáka Švejka',
titleCZ:'Osudy dobrého vojáka Švejka',
year:1986,
runtime:'9x25 min',
countries:['Czechoslovakia','Germany'],
genres:['Animation','Comedy'],
director:['Stanislav Látal','Josef Henke'],
actors:['Petr Haničinec','Rudolf Hrušínský','Josef Somr','Věra Kubánková','Marek Brodský','Josef Abrhám','Josef Kemr','Petr Nárožný','Václav Postránecký','František Filipovský'],
basedOn:['Jaroslav Hašek'],
screenplay:['Stanislav Látal','Jiří Kubíček','Kamil Pixa'],
music:['Vadim Petrov'],
camera:['Vladimír Malík','Ivan Vít']},
{title:'A Thousand and One Nights',
titleCZ:'Pohádky tisíce a jedné noci',
year:1974,
runtime:90,
countries:['Czechoslovakia'],
genres:['Animation','Fairytale'],
director:['Karel Zeman'],
actors:['Jan Tříska'],
production:['Karel Hutěčka'],
music:['František Belfín'],
camera:['Bohuslav Pikhart'],
cut:['Ivan Matouš'],
sound:['Radomír Koutek']},
{title:'Four Murders Are Enough, Darling',
titleCZ:'„Čtyři vraždy stačí, drahoušku“',
year:1970,
runtime:102,
countries:['Czechoslovakia'],
genres:['Comedy','Crime'],
director:['Oldřich Lipský'],
actors:['Lubomír Lipský st.','Jiřina Bohdalová','Iva Janžurová','Marie Rosůlková','František Filipovský','Jan Libíček','Josef Hlinomaz','Karel Effa','Lubomír Kostelka','Vlastimil Hašek','Stella Zázvorková','Josef Kemr','Jaroslav Moučka','Robert Vrchota','František Peterka','Jan Přeučil','Zdeněk Řehoř','Zdeněk Kryzánek','Lubor Tokoš','Karel Pavlík','Jiří Lír','Otto Lackovič','Viktor Maurer','Ivo Gübel','Martin Štěpánek','Oldřich Musil','Karel Augusta','Zdeněk Blažek','Karel Sekera','Milan Kindl','Zdeněk Srstka','Antonín Jedlička','Antonín Kryl','Kateřina Frýbová','Jiří Klenot','Jiří Plachý','Aladar Petický','Josef Engel','Karel Engel','Karel Vítek st.','Petr Fleischer','Karel Tokar','Ladislav Tokar','Jan Vítek','Otakar Rademacher','Jaroslav Tomsa','Zoltán Tokar','Jiří Koutný','Nora Krčmářová','Ladislav Mrnka','Bedřich Zelenka','Josef Burda','Rudolf Kalina','Johana Saudková','Oldřich Velen'],
basedOn:['Nenad Brixy'],
screenplay:['Miloš Macourek','Oldřich Lipský'],
music:['Vlastimil Hála'],
camera:['Jiří Tarantík'],
cut:['Miroslav Hájek'],
sound:['Josef Vlček'],
scenography:['Jiří Hlupý'],
masks:['František Čížek','Václav Volk','Zdena Prchlíková'],
costumes:['Theodor Pištěk ml.','Emilie Kůtová','Nita Romaničová']},
{title:'Klepání na nebeskou bránu',
titleCZ:'Klepání na nebeskou bránu',
year:1997,
runtime:85,
countries:['Germany','Netherlands','Belgium'],
genres:['Action','Crime','Comedy','Drama'],
director:['Thomas Jahn'],
actors:['Til Schweiger','Jan Josef Liefers','Thierry van Werveke','Moritz Bleibtreu','Huub Stapel','Leonard Lansink','Ralph Herforth','Hark Bohm','Jürgen Becker','Markus Knüfken','Florian Fitz','Tyron Ricketts','Hannes Jaenicke','Christiane Paul','Willi Thomczyk','Corinna Harfouch','Cornelia Froboess','Rutger Hauer','Jenny Elvers-Elbertzhagen','Muriel Baumeister','Thomas Jahn','Tobias Schenke','Bernd Eichinger','Xenia Seeberg','Sönke Wortmann','Clelia Sarto','Janine Kunze','Eva Mannschott','Wolfgang Kaven','Anton Rattinger','Corinna Flock','Ludwig Boettger','Vladimir Weigl','Salvatore Pascale','Bernd Hoffmann','Angelika Howland','Ayhan Vanelli','Ursula Schreiber','Dana Schweiger'],
screenplay:['Thomas Jahn','Til Schweiger'],
production:['Tom Zickler','André Hennicke','Til Schweiger'],
music:['Christian Neander'],
camera:['Gero Steffen'],
cut:['Alexander Berner'],
sound:['Mark Taylor','Stephan Colli'],
scenography:['Monika Bauert'],
costumes:['Heike Weber']},
{title:'The Stolen Airship',
titleCZ:'Ukradená vzducholoď',
year:1966,
runtime:88,
countries:['Czechoslovakia'],
genres:['Family','Adventure','Fantasy','History'],
director:['Karel Zeman'],
actors:['Michal Pospíšil','Hanuš Bor','Jan Čízek','Josef Stráník','Jan Malát','Jitka Zelenohorská','Čestmír Řanda st.','Stanislav Šimek','Josef Větrovec','Jan Teplý st.','Rudolf Deyl ml.','Jana Sedlmajerová','Václav Babka','Věra Macků','Josef Haukvic st.','Marie Brožová','Josef Hlinomaz','Milan Neděla','Miloš Nesvadba','Miloslav Holub','Eva Kubešová','František Filipovský','Václav Švec','Eduard Kohout','Zdeněk Dítě','Ladislav Navrátil','Václav Trégl','Jaroslav Štercl','Karel Effa','Zdeněk Braunschläger','Miroslav Homola','Antonín Soukup','Václav Wasserman','Štěpánka Řeháková','Jan Kraus','Jaroslav Mareš','Táňa Blažejová','Václav Podhorský','Vladimír Linka','Zdeněk Skalický','Willy Kuk-Znamínko','Jiří Kasík','Jaroslav Klenot','Štěpán Novotný','Jiří Svárovský','Karel Vítek st.','Ludvík Wolf','Jan Tříska','Jaroslav Moučka','Zdeněk Štěpánek','František Hanus','Oldřich Musil'],
basedOn:['Jules Verne'],
screenplay:['Karel Zeman'],
music:['Jan Novák'],
camera:['Josef Novotný','Bohuslav Pikhart'],
cut:['Jan Chaloupek'],
sound:['František Strangmüller']},
{title:'The Celebration',
titleCZ:'Rodinná oslava',
year:1998,
runtime:105,
countries:['Denmark','Sweden'],
genres:['Drama','Psychology'],
director:['Thomas Vinterberg'],
actors:['Ulrich Thomsen','Henning Moritzen','Thomas Bo Larsen','Paprika Steen','Birthe Neumann','Trine Dyrholm','Helle Dolleris','Bjarne Henriksen','Gbatokai Dakinah','Lars Brygmann','John Boas','Erna Boas','Thomas Vinterberg','Lasse Lunderskov','Linda Laursen','Klaus Bondam','Therese Glahn','Sigrid Aalbæk Jensen','Lene Laub Oksen','Birgitte Simonsen'],
screenplay:['Thomas Vinterberg','Mogens Rukov'],
music:['Lars Bo Jensen'],
camera:['Anthony Dod Mantle'],
cut:['Valdís Óskarsdóttir']},
{title:'Fanny and Alexander',
titleCZ:'Fanny a Alexandr',
year:1982,
runtime:188,
countries:['Sweden','France','Germany'],
genres:['Drama'],
director:['Ingmar Bergman'],
actors:['Pernilla Allwin','Bertil Guve','Börje Ahlstedt','Harriet Andersson','Mats Bergman','Gunnar Björnstrand','Allan Edwall','Stina Ekblad','Ewa Fröling','Erland Josephson','Jarl Kulle','Käbi Laretei','Mona Malm','Jan Malmsjö','Christina Schollin','Gunn Wållgren','Pernilla Wahlgren','Kristina Adolphson','Lena Olin','Pernilla August','Kerstin Tidelius','Heinz Hopf','Marie-Hélène Breillat','Hans Strååt','Peter Stormare','Axel Düberg','Georg Årlin','Daniel Bell','Per Mattsson','Inga Ålenius','Ernst Günther','Lars-Owe Carlberg',"Henry 'Nypan' Nyberg",'Carl Billquist','Majlis Granlund','Olle Hilding','Gösta Prüzelius','Nils Brandt','Marianne Karlbeck-Strååt','Gus Dahlström','Marianne Aminoff','Siv Ericks','Sune Mangs','Marrit Ohlsson','Eva von Hanno','Mona Andersson','Marianne Nielsen','Hugo Hasslo','Svea Holst','Nils Kyndel','Maud Hyttenberg','Åke Lagergren','Sven-Erik Jacobsson','Sonya Hedenbratt','Gerd Andersson','Emelie Werkö','Kristian Almgren','Linda Krüger','Krister Hell','Anna Bergman'],
screenplay:['Ingmar Bergman'],
production:['Jörn Donner'],
music:['Daniel Bell'],
camera:['Sven Nykvist'],
cut:['Sylvia Ingemarsdotter'],
sound:['Lasse Liljeholm','Bo Persson','Björn Gunnarsson','Owe Svensson'],
scenography:['Anna Asp','Kaj Larsen'],
masks:['Anna-Lena Melin','Barbro Holmbring','Leif Qviström'],
costumes:['Marik Vos-Lundh']},
{title:'Silenced',
titleCZ:'Dogani',
year:2011,
runtime:125,
countries:['South Korea'],
genres:['Drama'],
director:['Dong-hyeok Hwang'],
actors:['Yoo Gong','Yoo-mi Jeong','Gwang Jang','Hyo-seop Eom','Gook-hwan Jeon','Ji-yeong Kim','Hyeon-seong Lim','Myeong-ryeol Nam','So-yeon Jang','Jin-ho Choi','Hyeon-soo Kim','Seung-hwan Baek','Ji-yeong Kim','Ji-seong Eom','Joo-ryeong Kim','Jae-ho Heo','Hyung-suk Jung','Jang-yoo Lee'],
basedOn:['Ji-young Gong'],
screenplay:['Dong-hyeok Hwang'],
music:['Mowg'],
camera:['Ji-yong Kim'],
scenography:['Kyoung-sun Chae']},
{title:'Cutting It Short',
titleCZ:'Postřižiny',
year:1980,
runtime:93,
countries:['Czechoslovakia'],
genres:['Comedy','Poetic'],
director:['Jiří Menzel'],
actors:['Magda Vášáryová','Jiří Schmitzer','Jaromír Hanzlík','Rudolf Hrušínský','Petr Čepek','Oldřich Vlach','František Řehák','Miloslav Štibich','Alois Liškutín','Pavel Vondruška','Rudolf Hrušínský ml.','Oldřich Vízner','Miroslav Donutil','Josef Vondráček','Jaroslav Vozáb','Zdeněk Podskalský st.','Václav Kotva','Zdeněk Kozák st.','Pavel Wuršer','Josef Otoupal','Jan Hraběta','Jaroslava Kretschmerová','Jiří Kodeš','Václav Knop','Alexej Okuněv','Rudolf Stärz','Tomáš Töpfer','Ivan Rajmont','Jaroslav Tomsa','Rudolf Serina','Hana Forejtová','Ladislav Lahoda','Miroslav Lahoda'],
basedOn:['Bohumil Hrabal'],
screenplay:['Bohumil Hrabal','Jiří Menzel'],
music:['Jiří Šust'],
camera:['Jaromír Šofr'],
cut:['Jiří Brožek'],
sound:['Karel Jaroš'],
scenography:['Zbyněk Hloch'],
masks:['Vladimír Petřina'],
costumes:['Theodor Pištěk ml.']},
{title:'Dissolved and Effused',
titleCZ:'Rozpuštěný a vypuštěný',
year:1984,
runtime:80,
countries:['Czechoslovakia'],
genres:['Comedy','Crime'],
director:['Ladislav Smoljak'],
actors:['Jiří Zahajský','Marek Brodský','Rudolf Hrušínský','Blažena Holišová','Josef Abrhám','Veronika Jeníková','Jaroslava Adamová','Vlastimil Brodský','Petr Čepek','Jiří Kodet','Rudolf Hrušínský ml.','Jaroslava Kretschmerová','Zdeněk Srstka','Zdeněk Svěrák','Jaroslav Weigel','Valérie Zawadská','Jan Hraběta','Boris Hybner','Valerie Kaplanová','Alena Karešová','Jan Kašpar','Milan Klacek','Jiří Knot','Pavel Vondruška','Jaroslav Vozáb','Jana Altmannová','Jan Cmíral st.','Radúz Chmelík','Karel Kachyňa','Miloslav Kopečný','Petr Brukner','Milena Glogarová','Václav Kotek','Václav Král','Jaromír Kučera','Jan Kuželka','Miloslava Kykalová-Ebrová','Libuše Matějová','Mirko Musil','Karel Peyr','Genadij Rumlena','Jan Semotán','Zdeněk Skalický','Břetislav Slováček','Ladislav Smoljak','Vítězslav Sutr','Petr Šícha','Jaroslav Večeřa','Kateřina Smoljaková','Alžběta Smoljaková'],
screenplay:['Ladislav Smoljak','Zdeněk Svěrák','Ladislav Smoljak','Zdeněk Svěrák'],
music:['Petr Skoumal'],
camera:['Andrej Barla'],
cut:['Jiří Brožek'],
sound:['Jiří Moudrý','Vladimír Skall'],
scenography:['Zbyněk Hloch'],
masks:['Jana Dolejší'],
costumes:['Šárka Váchová','Eva Studecká']},
{title:'The Blue Star Hotel',
titleCZ:'Hotel Modrá hvězda',
year:1941,
runtime:93,
countries:['Czechia'],
genres:['Comedy'],
director:['Martin Frič'],
actors:['Nataša Gollová','Oldřich Nový','Adina Mandlová','Karel Černý','Theodor Pištěk','Ladislav Pešek','Jan Pivec','Antonín Novotný','Ferenc Futurista','Jára Kohout','Karel Dostal','Čeněk Šlégl','František Filipovský','František Roland','Vojta Novák','Marie Nademlejnská','Gustav Hilmar','Karel Postranecký','Doďa Pražský','Jaroslav Orlický','Miloš Šubrt','Viktor Socha','Vladimír Štros','Josef Bělský','Jan W. Speerger','Josef Dvorský','Olga Augustová','Ada Karlovský','Emanuel Hříbal','Ferdinand Jarkovský','Jiří Vondrovič','Eman Fiala','Jaroslav Malina','Antonín Zacpal','Vladimír Řepa','Ella Nollová','František Paul','Inka Zemánková','Marie Hodrová','František Haller','Ladislav Janeček','Bolek Prchal','František V. Kučera','Nina Strnadová-Jarková','Růžena Kurelová'],
screenplay:['Václav Wasserman','Martin Frič'],
music:['Sláva Eman Nováček'],
camera:['Ferdinand Pečenka'],
cut:['Jan Kohout'],
sound:['František Šindelář'],
scenography:['Alois Mecera']},
{title:'Three Colours: Red',
titleCZ:'Tři barvy: Červená',
year:1994,
runtime:95,
countries:['France','Poland','Switzerland'],
genres:['Drama','Psychology','Mystery','Romance'],
director:['Krzysztof Kieślowski'],
actors:['Irène Jacob','Jean-Louis Trintignant','Jean-Pierre Lorit','Samuel Le Bihan','Juliette Binoche','Julie Delpy','Zbigniew Zamachowski','Teco Celio','Marion Stalens','Nader Farman','Benoît Régent','Roland Carey','Frédérique Feder','Anne Theurillat','Jean Schlegel'],
screenplay:['Krzysztof Kieślowski','Krzysztof Piesiewicz'],
music:['Zbigniew Preisner'],
camera:['Piotr Sobociński'],
cut:['Jacques Witta'],
sound:['Vincent Arnardi','Jean-Claude Laureux'],
masks:['Nathalie Tanner'],
costumes:['Corinne Jorry']},
{title:'My Left Foot',
titleCZ:'Moje levá noha',
year:1989,
runtime:103,
countries:['Ireland','UK'],
genres:['Drama','Biography'],
director:['Jim Sheridan'],
actors:['Daniel Day-Lewis','Brenda Fricker','Kirsten Sheridan','Eanna MacLiam','Cyril Cusack','Ruth McCabe','Fiona Shaw',"Hugh O'Conor",'Adrian Dunbar','Ray McAnally',"Jer O'Leary",'Naomi Sheridan','Julie Hale','Tom Hickey','Conor Lambert'],
screenplay:['Jim Sheridan','Shane Connaughton'],
production:['Noel Pearson'],
music:['Elmer Bernstein'],
camera:['Jack Conroy'],
costumes:['Joan Bergin']},
{title:'Killing',
titleCZ:'Zabíjení',
year:2018,
runtime:80,
countries:['Japan'],
genres:['Action','Drama','History'],
director:["Šin'ja Cukamoto"],
actors:['Sósuke Ikemacu',"Šin'ja Cukamoto",'Jú Aoi','Rjúsei Maeda','Tacuja Nakamura'],
screenplay:["Šin'ja Cukamoto"],
production:["Šin'ja Cukamoto"],
music:['Čú Išikawa'],
camera:["Šin'ja Cukamoto",'Satoši Hajaši'],
cut:["Šin'ja Cukamoto"],
scenography:['Cujoši Endó'],
costumes:['Masae Mijamoto']},
{title:'Quo vadis, Aida?',
titleCZ:'Quo vadis, Aida?',
year:2020,
runtime:101,
countries:['Bosnia and Herzegovina','Austria','Romania','Netherlands','Germany','Poland','France','Norway','Turkey'],
genres:['Drama'],
director:['Jasmila Žbanić'],
actors:['Jasna Đuričić','Izudin Bajrović','Boris Ler','Johan Heldenbergh','Raymond Thiry','Boris Isakovič','Emir Hadžihafizbegovič','Reinout Bussemaker','Teun Luijkx','Juda Goslinga','Alban Ukaj','Ermin Bravo','Edita Malovčić','Micha Hulshof','Joes Brauers','Sol Vinken','Sanne den Hartogh','Irena Melcer','Emina Minka Muftić','Mario Knezović','Luna Mijović','Jovan Živanović','Dražen Pavlović','Niels Gomperts','Dino Bajrović','Jasenko Pasic','Mirsad Elezi','Jelena Kordic Kuret'],
screenplay:['Jasmila Žbanić'],
production:['Damir Ibrahimović','Jasmila Žbanić'],
music:['Antoni Komasa-Łazarkiewicz'],
camera:['Christine A. Maier'],
cut:['Jarosław Kamiński'],
sound:['Igor Čamo','Marius Leftãrache'],
scenography:['Hannes Salat'],
masks:['Michaela Payer'],
costumes:['Małgorzata Karpiuk']},
{title:'Scenes from a Marriage',
titleCZ:'Scény z manželského života',
year:1973,
runtime:169,
countries:['Sweden'],
genres:['Drama','Psychology'],
director:['Ingmar Bergman'],
actors:['Liv Ullmann','Erland Josephson','Bibi Andersson','Jan Malmsjö','Gunnel Lindblom','Barbro Hiort af Ornäs','Anita Wall','Wenche Foss','Bertil Norström','Ingmar Bergman','Rossana Mariano','Lena Bergman'],
screenplay:['Ingmar Bergman'],
production:['Lars-Owe Carlberg','Ingmar Bergman'],
camera:['Sven Nykvist'],
cut:['Siv Lundgren'],
sound:['Owe Svensson'],
scenography:['Björn Thulin'],
masks:['Cecilia Drott'],
costumes:['Inger Pehrsson']},
{title:'Camera Buff',
titleCZ:'Amatér',
year:1979,
runtime:117,
countries:['Poland'],
genres:['Drama'],
director:['Krzysztof Kieślowski'],
actors:['Jerzy Stuhr','Małgorzata Ząbkowska','Ewa Pokas','Stefan Czyżewski','Jerzy Nowak','Tadeusz Bradecki','Marek Litewka','Bogusław Sobczuk','Krzysztof Zanussi','Andrzej Jurga','Aleksandra Kisielewska','Antonina Barczewska','Krzysztof Wierzbicki','Tadeusz Huk','Tadeusz Sobolewski','Roman Stankiewicz','Alicja Bienicewicz','Tadeusz Rzepka','Włodzimierz Maciudziński','Feliks Szajnert','Jolanta Brzezińska','Teresa Szmigielówna','Jacek Turalik','Andrzej Warchal','Danuta Wiercińska','Zofia Framer','Marian Osuch'],
screenplay:['Krzysztof Kieślowski','Jerzy Stuhr'],
music:['Krzysztof Knittel'],
camera:['Jacek Petrycki'],
cut:['Halina Nawrocka'],
sound:['Michał Żarnecki'],
scenography:['Andrzej Rafał Waltenberger','Barbara Kociuba'],
masks:['Zdzisława Namysław'],
costumes:['Gabriela Star-Tyszkiewicz']},
{title:'Miracle in Cell No. 7',
titleCZ:'Dárek do cely č.7',
year:2019,
runtime:132,
countries:['Turkey'],
genres:['Drama'],
director:['Mehmet Ada Öztekin'],
actors:['Aras Bulut Iynemli','Deniz Baysal','Nisa Sofiya Aksongur','Celile Toyon Uysal','Ferit Kaya','Hayal Köseoğlu','Deniz Celiloğlu','Mesut Akusta','Yurdaer Okur','İlker Aksum','Cankat Aydos','Yıldıray Şahinler','Sarp Akkaya','Doğukan Polat','Emre Yetim','Fevzi Can Açıkgöz','Gülçin Kültür Şahin','Serhan Onat','Özgür Avşar','Serdar Akülker','Ertan Dönmez','Zafer Şahin','Kenan Çınar','Esra Gezginci','Kaan Mutlu','İskender Han Kahramanoğlu','Jackdersin Yeter','İlker Çanga','Cemal Günbaş','Aynur Türk'],
screenplay:['Kubilay Tat'],
production:['Sinan Turan','Saner Ayar'],
music:['Hasan Özsüt'],
camera:['Torben Forsberg'],
cut:['Ruşen Dağhan'],
sound:['Serdar Öngören','Onur Yavuz'],
scenography:['Hakan Yarkın'],
masks:['Sedat Karakaş']},
{title:'The Three Veterans',
titleCZ:'Tři veteráni',
year:1983,
runtime:93,
countries:['Czechoslovakia'],
genres:['Fairytale','Comedy','Fantasy','Family'],
director:['Oldřich Lipský'],
actors:['Rudolf Hrušínský','Petr Čepek','Josef Somr','Vida Neuwirthová','Július Satinský','Zdeněk Svěrák','Miloš Kopecký','Lubomír Lipský st.','Jiří Kaftan','Milan Lasica','Jiří Hálek','Vladimír Hrubý','Ladislav Gerendáš','Jaroslav Vozáb','Dana Balounová','Vlasta Jelínková','Tomáš Vacek','Ivan Pokorný','Hasso Steube','Paul Jaster','Wolfgang Emmrich','Jaroslav Páleník','Jiří Knot','Vladimír Hrabánek','Mirko Musil','Miloslav Štibich','René Gabzdyl','Milan Riehs','Lena Birková','František Kubíček','Karel Smrž','Jiří Krytinář','Jan Kehár'],
basedOn:['Jan Werich'],
screenplay:['Zdeněk Svěrák','Oldřich Lipský'],
music:['Jaroslav Uhlíř'],
camera:['Jiří Macák'],
cut:['Dalibor Lipský'],
sound:['Jiří Lenoch'],
scenography:['Milan Nejedlý'],
masks:['Jiří Budín'],
costumes:['Irena Greifová']},
{title:'On the Trail of Blood',
titleCZ:'Po stopách krve',
year:1969,
runtime:96,
countries:['Czechoslovakia'],
genres:['Crime'],
director:['Petr Schulhoff'],
actors:['Rudolf Hrušínský','Hana Brejchová','Vladimír Ptáček','Jana Vaňková','Ilja Prachař','Libuše Holečková','Michal Kožuch','Milada Ježková','Luděk Nešleha','Zdeněk Martínek','Miloš Willig','Vladimír Kudla','Václav Postránecký','Vladimír Huber','Bohumil Koška','Karel Dellapina','Josef Koza','Stanislav Hájek','Jaroslav Radimecký','Vladimír Foukal','Oldřich Velen','Zdeněk Braunschläger','Václav Halama','Vladimír Hrabánek','Jindra Kvardová','Bohuslav Ličman','Pavel Navara','Hynek Němec','Jiřina Bílá','Jana Sedlmajerová','David Schneider','Eva Vlachová','Marie Štrampachová','Vincenc Vávra','Jan Víšek','Jan Vyčítal','Václav Němec','Slávka Hamouzová'],
screenplay:['Petr Schulhoff'],
music:['Pavel Blatný'],
camera:['Emil Sirotek'],
cut:['Jiřina Lukešová'],
sound:['Miloslav Hůrka'],
scenography:['Karel Lier'],
masks:['Karel Marek','Marie Džbánková','František Pilný'],
costumes:['Zdena Kadrnožková','Marie Jindrová','František Kauler']},
{title:'Prolomit vlny',
titleCZ:'Prolomit vlny',
year:1996,
runtime:159,
countries:['Denmark','Sweden','France','Netherlands'],
genres:['Drama','Romance'],
director:['Lars von Trier'],
actors:['Emily Watson','Stellan Skarsgård','Katrin Cartlidge','Jean-Marc Barr','Adrian Rawlins','Udo Kier','Mikkel Gaup','Sandra Voe','Phil McCall','David Bateson','Charles Kearney','Roef Ragas','Gavin Mitchell','Dorte Rømer','Finlay Welsh','David Gallacher','Callum Cuthbertson','Iain Agnew'],
screenplay:['Lars von Trier','Peter Asmussen'],
production:['Vibeke Windeløv'],
camera:['Robby Müller'],
cut:['Anders Refn'],
sound:['Klas Baggström','Per Streit'],
scenography:['Karl Júlíusson'],
masks:['Jennifer Jorfaid','Sanne Gravfort','Anja Dahl','Morten Jacobsen'],
costumes:['Manon Rasmussen']},
{title:'The Invisible Guest',
titleCZ:'Contratiempo',
year:2016,
runtime:106,
countries:['Spain'],
genres:['Mystery','Crime','Thriller','Drama'],
director:['Oriol Paulo'],
actors:['Mario Casas','Ana Wagener','José Coronado','Bárbara Lennie','Francesc Orella','Paco Tous','David Selvas','Manel Dueso','Ahmed Adel','Annick Weerts','Pere Brasó','Laia Alberch','Betsy Túrnez','Bobby Gonzalez','Iñigo Gastesi'],
screenplay:['Oriol Paulo'],
production:['Mercedes Gamero','Eneko Lizarraga','Mikel Lejarza','Adrián Guerra','Núria Valls','Sandra Hermida'],
music:['Fernando Velázquez'],
camera:['Xavi Giménez'],
cut:['Jaume Martí'],
sound:['Marc Orts'],
scenography:['Balter Gallart','Marta Bazaco','Idoia Esteban'],
costumes:['Miguel Cervera']},
{title:'Kimssi pyoryugi',
titleCZ:'Kimssi pyoryugi',
year:2009,
runtime:116,
countries:['South Korea'],
genres:['Drama','Romance'],
director:['Hae-joon Lee'],
actors:['Jae-yeong Jeong','Ryeo-won Jeong','Nam-yeol Jang','Kyeong-jin Min','So-yeon Jang','Sang-hoon Lee','Yeong-seo Park','Gyo-hwan Koo','Mi-kyeong Yang','Kyu-hyung Lee','Hee-chang Kim'],
screenplay:['Hae-joon Lee'],
production:['Moo Ryung Kim'],
music:['Hong-jib Kim'],
camera:['Byeong-seo Kim'],
cut:['Na-young Nam']},
{title:'The Mysterious Castle in the Carpathians',
titleCZ:'Tajemství hradu v Karpatech',
year:1981,
runtime:97,
countries:['Czechoslovakia'],
genres:['Comedy','Sci-Fi'],
director:['Oldřich Lipský'],
actors:['Michal Dočolomanský','Evelyna Steimarová','Vlastimil Brodský','Miloš Kopecký','Rudolf Hrušínský','Augustín Kubán','Jan Hartl','Jaroslava Kretschmerová','Oldřich Velen','Míla Myslíková','Samuel Adamčík','Jan Skopeček','Václav Kotva','Jiří Lír','Helena Růžičková','Bára Štěpánová','Karel Houska','Václav Mareš','Vilém Lipský','Ladislav Županič','Mirko Musil','Otakar Brousek st.','Gabriela Beňačková'],
basedOn:['Jules Verne'],
screenplay:['Jiří Brdečka','Oldřich Lipský'],
music:['Luboš Fišer'],
camera:['Viktor Růžička'],
cut:['Miroslav Hájek'],
sound:['Jiří Lenoch'],
scenography:['Jan Zázvorka'],
masks:['František Čížek'],
costumes:['Irena Greifová']},
{title:'Death Is Called Engelchen',
titleCZ:'Smrt si říká Engelchen',
year:1963,
runtime:129,
countries:['Czechoslovakia'],
genres:['Drama','War'],
director:['Ján Kadár','Elmar Klos'],
actors:['Jan Kačer','Eva Poláková','Martin Růžek','Blažena Holišová','Pavel Bártl','Ezard Haußmann','Otto Lackovič','Vlado Müller','Oľga Adamčíková','Miroslav Macháček','Čestmír Řanda st.','Ota Sklenčka','Wanda Spinka','Oto Ševčík','Michal Kožuch','Antonín Molčík','Valtr Taub','Ervín Zolar','Karel Fořt','Norbert Chotaš','Alex Jandouš','Helena Kotoučová','Emil Rohan','Josef Stehlík','Jaroslav Moučka','Jozef Príhoda','Otto Šimánek','Karel Vavřík','Karel Bezděk','Karel Hovorka st.','Jiří Hurych','Václav Podhorský','Gustav Vondráček','Karla Svobodová','Věra Tichánková'],
basedOn:['Ladislav Mňačko'],
screenplay:['Ján Kadár','Elmar Klos'],
music:['Zdeněk Liška'],
camera:['Rudolf Milič'],
cut:['Jaromír Janáček'],
sound:['František Černý'],
scenography:['Boris Moravec'],
masks:['Ladislav Bacílek','Jiří Hurych'],
costumes:['Nita Romaničová']},
{title:'The Rocket',
titleCZ:'Maurice Richard',
year:2005,
runtime:124,
countries:['Canada'],
genres:['Drama','Sport','Biography'],
director:['Charles Binamé'],
actors:['Roy Dupuis','Julie LeBreton','Rémy Girard','Stephen McHattie','Larry Day','Albert Kwan','Sebastien Roberts','Serge Houde','Paul Doucet','Benoît Girard','John MacLaren','Philip Craig','Tedd Dillon','Diane Lavallée','Patrice Robitaille','Normand Chouinard','Pierre-François Legendre','Tony Calabretta','Luc Proulx','Mario Jean','Michel Barrette','Sean Avery','Howard Rosenstein','Marc Gourdeau','René Gagnon','Tyler Hall','Randy Thomas'],
screenplay:['Ken Scott'],
production:['Daniel Louis'],
music:['Michel Cusson'],
camera:['Pierre Gill'],
cut:['Michel Arcand'],
scenography:['Michel Proulx'],
masks:['Adrien Morot']},
{title:'To Each His Hell',
titleCZ:'Prožít si své peklo',
year:1977,
runtime:105,
countries:['France','Germany'],
genres:['Drama','Mystery'],
director:['André Cayatte'],
actors:['Annie Girardot','Hardy Krüger','Bernard Fresson','Edith Scob','Roger Miremont','Florence Giorgetti','Marthe Villalonga','Fernand Ledoux','François Perrot','Claudine Berg','Marius Laurey','Dominique Briand','Alain Chevallier','Leila Fréchet','Léo Peltier','Stéphane Hillel','Jacques Bouanich','Liza Braconnier','Paul Rieger','Jean-Paul Tribout','Françoise Bonneau','François Timmerman','Astrid Frank'],
screenplay:['André Cayatte'],
production:['Sergio Gobbi'],
music:['Vladimir Cosma'],
camera:['Maurice Fellous','Ennio Guarnieri'],
cut:['Paul Cayatte'],
scenography:['Robert Clavel'],
masks:['Louis Bonnemaison']},
{title:'War and Peace: Part III',
titleCZ:'Vojna a mír III: Rok 1812',
year:1967,
runtime:84,
countries:['Russia'],
genres:['Drama','War'],
director:['Sergej Bondarčuk'],
actors:['Sergej Bondarčuk','Vjačeslav Tichonov','Ljudmila Saveljeva','Viktor Stanicyn','Anatolij Ktorov','Boris Smirnov','Pjotr Savin','Nikolaj Griňko','Sergej Nikoněnko','Irina Gubanova','Vladislav Strželčik','Nikolaj Smorčkov'],
basedOn:['Lev Nikolajevič Tolstoj'],
screenplay:['Sergej Bondarčuk'],
music:['Vjačeslav Ovčinnikov']},
{title:'Old Czech Legends',
titleCZ:'Staré pověsti české',
year:1952,
runtime:91,
countries:['Czechoslovakia'],
genres:['Animation','Puppets','History'],
director:['Jiří Trnka'],
actors:['Růžena Nasková','Zdeněk Štěpánek','Eduard Kohout','Václav Vydra st.','Karel Höger','Otomar Krejča st.'],
basedOn:['Alois Jirásek'],
screenplay:['Jiří Brdečka','Jiří Trnka'],
music:['Václav Trojan'],
camera:['Emanuel Franek','Ludvík Hájek'],
cut:['Helena Lebdušková'],
sound:['Emanuel Formánek','Emil Poledník','Josef Zavadil']},
{title:"Who's Singin' Over There?",
titleCZ:'Kdo to tam zpívá',
year:1980,
runtime:83,
countries:['Yugoslavia'],
genres:['Comedy','Drama','Road movie'],
director:['Slobodan Šijan'],
actors:['Pavle Vujišič','Dragan Nikolič',"Danilo 'Bata' Stojkovič",'Aleksandar Berček','Neda Arnerič','Taško Načič','Slavko Štimac','Bora Todorovič','Slobodan Aligrudič',"Milivoje 'Miča' Tomič",'Petar Lupa','Ljubomir Čipranič'],
screenplay:['Dušan Kovačevič'],
cut:["Ljiljana 'Lana' Vukobratovič"],
scenography:['Veljko Despotovič'],
costumes:['Mira Čohadžič']},
{title:'Christmas in South Park',
titleCZ:'Christmas in South Park',
year:2000,
runtime:100,
countries:['USA'],
genres:['Animation','Comedy','Musical'],
director:['Trey Parker','Matt Stone','Eric Stough'],
actors:['Trey Parker','Matt Stone','Mary Kay Bergman','Dian Bachar','Isaac Hayes','Eric Stough'],
screenplay:['Trey Parker','Matt Stone']},
{title:'The Color of Paradise',
titleCZ:'Barva ráje',
year:1999,
runtime:90,
countries:['Írán'],
genres:['Drama'],
director:['Majid Majidi'],
actors:['Hossein Mahjoub','Mohsen Ramezani','Salime Feizi','Farahnaz Safari','Elham Sharifi'],
screenplay:['Majid Majidi'],
music:['Alireza Kohandairy'],
camera:['Mohammad Davudi']},
{title:'Aurore',
titleCZ:'Aurore',
year:2005,
runtime:115,
countries:['Canada'],
genres:['Drama'],
director:['Luc Dionne'],
actors:['Serge Postigo','Rémy Girard','Catherine Faucher','Marianne Fortier','Sarah-Jeanne Labrosse','Stéphanie Lapointe','Yves Jacques','Luc Senay','Monique Spaziani','Justin Laramée','Michel Forget','Catherine Trudeau','Pierre Collin','Michel Barrette','Albert Millaire','Alice Morel-Michaud','Jean Marchand','Hélène Bourgeois Leclerc','Noémie Yelle','Muriel Dutil','Laurent-Christophe de Ruelle','Johanne Fontaine','Noel Burton','Reynald Bouchard','David Alexandre Després','Guillaume Gauthier','Marie-Ève Beauregard','Veronika Leclerc Strickland'],
production:['Daniel Louis'],
music:['Michel Cusson'],
cut:['Isabelle Dedieu'],
scenography:['Michel Proulx'],
masks:['Adrien Morot']},
{title:'Sitting on a Branch, Enjoying Myself',
titleCZ:'Sedím na konári a je mi dobre',
year:1989,
runtime:110,
countries:['Czechoslovakia','Germany'],
genres:['Drama','Comedy','Poetic'],
director:['Juraj Jakubisko'],
actors:['Ondřej Pavelka','Bolek Polívka','Markéta Hrubešová','Deana Horváthová-Jakubisková','Viliam Polónyi','Miroslav Macháček','Štefan Kvietik','Stanislav Štepka','Zita Furková','Andrej Hryc','Juliana Mrvová','Nora Kuželová','Štefan Mišovic','Hana Militká','Ľudovít Ozábal','Lotár Radványi','Marta Rašlová','Ľudovít Reiter','Michal Monček','Judita Ďurdiaková','Ján Melkovič','Ján Kroner ml.','Adela Gáborová','Jozef Skala','Milada Ondrašíková','Stanislav Hodoš','Vilhelm Perháč','Ivan Drozdy','Ján Mildner','František Desset','Erik Jamrich'],
screenplay:['Juraj Jakubisko','Jozef Paštéka'],
music:['Jiří Bulis'],
camera:['Laco Kraus'],
cut:['Patrik Pašš'],
sound:['Pavol Sásik'],
scenography:['Anton Krajčovič'],
masks:['Anton Gendiar'],
costumes:['Marie Franková']},
{title:'0',
titleCZ:'0',
year:2020,
runtime:3,
countries:['USA'],
genres:['Short','Animation'],
director:['Anna Wang']},
{title:'Kinoautomat: One Man and His House',
titleCZ:'Kinoautomat: Člověk a jeho dům',
year:1967,
runtime:63,
countries:['Czechoslovakia'],
genres:['Comedy','Experimental'],
director:['Radúz Činčera','Ján Roháč','Vladimír Svitáček'],
actors:['Miroslav Horníček','Karla Chadimová','Libuše Švormová','Josef Somr','Miroslav Macháček','Leopolda Dostalová','Jan Libíček','Jan Vostrčil','Věra Tichánková','František Kovářík','Vlasta Jelínková','Václav Lohniský','František Peterka','Štěpánka Řeháková','Jiří Schmitzer','Alena Vránová','Eduard Hrubeš'],
screenplay:['Pavel Juráček'],
music:['Evžen Illín'],
camera:['Jaromír Šofr'],
cut:['Miroslav Hájek'],
sound:['Ivo Špalj'],
scenography:['Boris Moravec']},
{title:'The Platform',
titleCZ:'Díra',
year:2019,
runtime:94,
countries:['Spain'],
genres:['Sci-Fi','Thriller','Horror'],
director:['Galder Gaztelu-Urrutia'],
actors:['Ivan Massagué','Antonia San Juan','Zorion Eguileor','Emilio Buale','Mario Pardo','Algis Arlauskas','Eric Goode','Miriam Martín','Miren Gaztañaga','Alexandra Masangkay','Txubio Fernández de Jáuregui','Chema Trujillo'],
screenplay:['Pedro Rivero','David Desola'],
production:['Ángeles Hernández','Carlos Juárez','David Matamoros'],
music:['Aránzazu Calleja'],
camera:['Jon D. Domínguez'],
cut:['Elena Ruiz','Haritz Zubillaga'],
scenography:['Yon Gijón','Azegiñe Urigoitia'],
masks:['Amaia Zaballa'],
costumes:['Azegiñe Urigoitia']},
{title:'Černá kočka, bílý kocour',
titleCZ:'Černá kočka, bílý kocour',
year:1998,
runtime:123,
countries:['Yugoslavia','France','Germany','Austria','Greece'],
genres:['Comedy','Romance','Music','Crime'],
director:['Emir Kusturica'],
actors:['Bajram Severdžan','Zabit Memedov','Branka Katič','Srdjan Todorovič','Florijan Ajdini','Sabri Sulejmani','Ljubica Adžović','Jašar Destani','Stojan Sotirov',"Predrag 'Miki' Manojlovič","Predrag 'Pepi' Lakovič",'Dejan Sparavalo','Salija Ibraimova'],
screenplay:['Gordan Mihič'],
production:['Karl Baumgartner'],
music:['Dejan Sparavalo','Nele Karajlić','Vojislav Aralica'],
camera:['Thierry Arbogast'],
cut:['Svetolik Zajc'],
scenography:['Milenko Jeremič'],
costumes:['Nebojša Lipanovič']},
{title:'Adelheid',
titleCZ:'Adelheid',
year:1969,
runtime:99,
countries:['Czechoslovakia'],
genres:['Drama','Psychology','War'],
director:['František Vláčil'],
actors:['Petr Čepek','Emma Černá','Jan Vostrčil','Jana Krupičková','Pavel Landovský','Lubomír Tlalka','Miloš Willig','Karel Hábl','Zdeněk Mátl','Alžběta Frejková','Josef Němeček','Karel Bělohradský','Vlasta Petříková','Bohumil Vávra','Josef Somr'],
basedOn:['Vladimír Körner'],
screenplay:['Vladimír Körner','František Vláčil'],
music:['Zdeněk Liška'],
camera:['František Uldrich'],
cut:['Miroslav Hájek'],
sound:['František Fabián'],
scenography:['Jindřich Goetz'],
masks:['Jiřina Pahlerová','Jiří Hurych','Miloš Bobek'],
costumes:['Theodor Pištěk ml.','Eva Martincová']},
{title:'Raise the Red Lantern',
titleCZ:'Zavěste červené lucerny',
year:1991,
runtime:125,
countries:['China','Hong Kong'],
genres:['Drama','History'],
director:['Yimou Zhang'],
actors:['Li Gong','Caifei He','Jingwu Ma','Cuifen Cao','Lin Kong','Baotian Li','Shuyuan Jin'],
basedOn:['Su Tong'],
screenplay:['Ni Zhen'],
music:['Jiping Zhao','Naoki Tačikawa'],
camera:['Fei Zhao','Lun Yang'],
costumes:['Huamiao Tong']},
{title:'War and Peace: Part IV',
titleCZ:'Vojna a mír IV: Pierre Bezuchov',
year:1967,
runtime:96,
countries:['Russia'],
genres:['Drama'],
director:['Sergej Bondarčuk'],
actors:['Sergej Bondarčuk','Vjačeslav Tichonov','Ljudmila Saveljeva','Viktor Stanicyn','Boris Smirnov','Georgij Milljar','Anastasija Vertinskaja','Oleg Tabakov','Irina Gubanova','Vladislav Strželčik','Nikolaj Smorčkov','Jean-Claude Balard','Zoja Rupasova','Daniil Nětrebin','Vladimir Selezňov'],
basedOn:['Lev Nikolajevič Tolstoj'],
screenplay:['Sergej Bondarčuk'],
music:['Vjačeslav Ovčinnikov']},
{title:'The Petroleum Lamps',
titleCZ:'Petrolejové lampy',
year:1971,
runtime:101,
countries:['Czechoslovakia'],
genres:['Drama'],
director:['Juraj Herz'],
actors:['Iva Janžurová','Petr Čepek','Marie Rosůlková','Ota Sklenčka','Vladimír Jedenáctík','Karel Chromík','Jana Plichtová','Evelyna Steimarová','Karel Černoch','Josef Laufer','Stanislav Remunda','Jan Schánilec','Míla Myslíková','Josef Červinka','Karel Augusta','Václav Vondráček','Jana Sedlmajerová','Marie Hübschová','Václav Halama','Petra Kodýmová','Marie Motlová','Václav Štekl','Jan Kotva','Vlastimila Vlková','Marie Černá','Jaroslav Blažek','Miloslav Šindler','Dušan Urgošík','Ilona Jirotková','Marian Cingroš','Zdeněk Grygárek','Milena Kaplická','Josef Burda','Karel Hovorka st.','Miloslav Štibich','Jiřina Jandová','Otto Ohnesorg','Vít Pešina','Olga Przygrodská','Josef Skrčený','Miloslav Novák','Josef Vlček','Jan Vlček','Růžena Vlčková','Václav Vodák','Vladimír Zoubek','Margit Harníčková','J. Havlíková','Gabriela Ryzcová ml.','Ladislav Mrázek','Robert Kühnel','Jaroslav Šmatlák','Jaroslava Bauerová','Jan Herodes','Josef Hrbek','Vincenc Koblitz','Josef Kočí','Ladislav Kouklík','Aleš Plhoň','Gabriela Ryzcová st.','Věra Ševčíková','Magdalena Šmídová','Ladislava Veselá','Miloš Větvička','Františka Zemanová','Josef Somr','Jaroslav Satoranský'],
basedOn:['Jaroslav Havlíček'],
screenplay:['Václav Šašek'],
production:['Karel Kochman'],
music:['Luboš Fišer'],
camera:['Dodo Šimončič'],
cut:['Jaromír Janáček'],
sound:['František Černý'],
scenography:['Zbyněk Hloch'],
masks:['Ladislav Bacílek'],
costumes:['Irena Greifová','Helena Vondrušková']},
{title:'All About My Mother',
titleCZ:'Vše o mé matce',
year:1999,
runtime:101,
countries:['Spain','France'],
genres:['Drama'],
director:['Pedro Almodóvar'],
actors:['Cecilia Roth','Marisa Paredes','Antonia San Juan','Penélope Cruz','Fernando Fernán Gómez','Carmen Balagué','Pedro Almodóvar','Cayetana Guillén Cuervo','Candela Peña','Eloy Azorín','Fernando Guillén','Fito Páez','Carme Fortuny','José Luis Torrijo','Rosa Maria Sardà','Agustín Almodóvar','Esther García','Juan José Otegui','Patxi Freytez','Yael Barnatán','Alexia Pardo','Lluís Pasqual','Dolors Pozzan'],
screenplay:['Pedro Almodóvar'],
music:['Alberto Iglesias'],
camera:['Affonso Beato'],
cut:['José Salcedo'],
sound:['Miguel Rejas','José Antonio Bermúdez','Diego Garrido'],
scenography:['Antxón Gómez','Federico García Cambero'],
masks:['Juan Pedro Hernández','Jorge Hernández Lobo','Jean-Jacques Puchu'],
costumes:['Bina Daigeler','José María de Cossío']},
{title:'Alice',
titleCZ:'Něco z Alenky',
year:1988,
runtime:86,
countries:['Czechoslovakia','Switzerland','UK','Germany'],
genres:['Animation','Fantasy','Puppets'],
director:['Jan Švankmajer'],
actors:['Kristýna Kohoutová'],
basedOn:['Lewis Carroll'],
screenplay:['Jan Švankmajer'],
production:['Peter-Christian Fueter'],
camera:['Svatopluk Malý']},
{title:'Raz, dva, tři',
titleCZ:'Raz, dva, tri',
year:1985,
runtime:76,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Gábor Várkonyi'],
actors:['Milan Lasica','Zdena Studenková','Vladimír Černý','František Dibarbora','Anna Maľová','Ingrid Filanová-Žirková','Judita Ďurdiaková','Eva Pavlíková','Hana Kováčiková','Teodor Piovarči','Marián Gallo','Marián Zednikovič','František Zvarík','Jozef Šimonovič st.','Stanislav Dančiak','Eduard Bindas','Emil Horváth ml.','Štefan Bučko','Marián Labuda st.','Ľubo Roman','Daniel Junas','František Desset'],
screenplay:['Gábor Várkonyi','Ferenc Molnár'],
music:['Ada Rehorová'],
camera:['Marián Minárik'],
cut:['Jozef Juráš'],
sound:['Dušan Hazucha'],
scenography:['László Barta'],
masks:['Juraj Petráň','Mária Chmelová'],
costumes:['Milan Čorba']},
{title:'The Hidden Fortress',
titleCZ:'Tři zločinci ve skryté pevnosti',
year:1958,
runtime:139,
countries:['Japan'],
genres:['Action','Adventure','Comedy'],
director:['Akira Kurosawa'],
actors:['Minoru Čiaki','Kamatari Fudžiwara','Takaši Šimura','Toširó Mifune','Susumu Fudžita','Kódži Micui','Jutaka Sada','Misa Uehara','Eiko Mijoši','Haruo Suzuki','Nakadžiró Tomita','Šóiči Hirose','Jošio Kosugi','Akira Tani','Kokuten Kôdô'],
screenplay:['Hideo Oguni','Akira Kurosawa','Šinobu Hašimoto','Ryûzô Kikushima'],
production:['Akira Kurosawa'],
music:['Masaru Sató'],
cut:['Akira Kurosawa']},
{title:'Granny',
titleCZ:'Babka',
year:2003,
runtime:97,
countries:['Russia','France'],
genres:['Drama'],
director:['Lidija Bobrova'],
actors:['Nina Šubina','Olga Oniščenko','Anna Ovsjannikova','Sergej Anufrijev','Vladimir Kulakov','Pavel Děrevjanko','Jurij Ovsjanko','Galina Bokaševskaja','Sergej Gamov','Vladimir Baranov','Ljudmila Motornaja'],
screenplay:['Lidija Bobrova'],
camera:['Valerij Revič']},
{title:'The Fifth Seal',
titleCZ:'Pátá pečeť',
year:1976,
runtime:111,
countries:['Hungary'],
genres:['Drama','Psychology','War'],
director:['Zoltán Fábri'],
actors:['Lajos Őze','László Márkus','Ferenc Bencze','Sándor Horváth','István Dégi','Zoltán Latinovits','Gábor Nagy','György Bánffy','József Vándor','Noémi Apor','Ildikó Pécsi','Marianna Moór','Rita Békés','György Cserhalmi','Gábor Kiss','Gabriella Kiss'],
basedOn:['Ferenc Sánta'],
screenplay:['Zoltán Fábri'],
music:['György Vukán'],
camera:['György Illés'],
cut:['Ferencné Szécsényi'],
sound:['György Pintér'],
scenography:['Tamás Vayer','Jánosné Németh'],
masks:['Ottilia Pásztory','Jánosné Száki'],
costumes:['Fanny Kemenes']},
{title:'The Phantom Carriage',
titleCZ:'Vozka smrti',
year:1921,
runtime:107,
countries:['Sweden'],
genres:['Drama','Mystery','Fantasy','Horror'],
director:['Victor Sjöström'],
actors:['Victor Sjöström','Hilda Borgström','Tore Svennberg','Astrid Holm','Concordia Selander','Lisa Lundholm','Tor Weijden','Einar Axelsson','Olof Ås','Nils Aréhn','Simon Lindstrand','Nils Elffors','Algot Gunnarsson','Hildur Lithman','John Ekman','Edvin Adolphson','Elof Ahrle','Emmy Albiin','Anna-Lisa Baude','Josua Bengtson','Helga Brofeldt','Julia Cæsar','Mona Geijer-Falkner','Carl-Harald','Arthur Natorp','Fridolf Rhudin','Signe Wirff','Bror Berger','Erik Bergman','Frida Dahlskog','Björn "Nalle" Halldén'],
basedOn:['Selma Lagerlöf'],
screenplay:['Victor Sjöström'],
production:['Charles Magnusson'],
camera:['Julius Jaenzon'],
scenography:['Axel Esbensen','Alexander Bakó']},
{title:'Crossing',
titleCZ:'Keurosing',
year:2008,
runtime:105,
countries:['South Korea','China','Mongolia'],
genres:['Drama'],
director:['Tae-gyoon Kim'],
actors:['Joo-hyeok Kim','In-pyo Cha','In-gi Jeong','Bok-in Yoon','Oh-jin Kwon','Yong-goo Do','Da-yeong Joo','So-yeon Jang','Yong-wook Jin','Young-hwa Seo','Jae-ryong Jo','Bae-soo Jeon','Jeong-pal Kim','Jin-yeong Park','Kyeong-ran Kim','Yong-joon Jo','Jin-won Seo'],
screenplay:['Yoo-jin Lee'],
production:['Ji-yong Hong','Patrick D. Cheh'],
music:['Tae-seong Kim'],
camera:['Han-cheol Jeong']},
{title:'The Incredibly Sad Princess',
titleCZ:'Šíleně smutná princezna',
year:1968,
runtime:89,
countries:['Czechoslovakia'],
genres:['Fairytale','Music','Comedy'],
director:['Bořivoj Zeman'],
actors:['Helena Vondráčková','Václav Neckář','Bohuš Záhorský','Jaroslav Marvan','Josef Kemr','Darek Vostřel','František Dibarbora','Oldřich Dědek','Stella Zázvorková','Branislav Koreň','Ondriš Jariabek','Jozef Kuchár','Karel Effa','Antonín Jedlička','Bohuslav Kupšovský','Jan Pixa st.','Josef Braun','Antonín Klimeš','Vítězslav Černý','Gustav Heverle','Miloš Vavruška','František Fontén','Jindřich Láznička','Vladimír Linka','Karel Pavlík','Viktor Riebauer','Jiří Štancl','Robert Vrchota','Karel Fiala','Jaroslav Kladrubský','Karel Šlajs','Milan Jonáš','Josefa Pechlátová','Oskar Hák','Zdeněk Braunschläger','Mirko Musil','František Šeba','Milan Klásek','Vladimír Navrátil','Viktor Nejedlý ml.','Zdeněk Plaček','Miloslav Šindler','Rudolf Veselý','Jiřina Bílá','Jiřina Hladíková','Milena Kaplická','Luďa Marešová','Marie Popelková','Blažena Slavíčková','Blažena Vernerová','Jan Cmíral st.','Willy Kuk-Znamínko','Beda Lak','Miloslav Novák','Jaroslav Horký','Josef Chval','Josef Borovian','Václav Štádler','František Vlček st.'],
screenplay:['František Vlček st.','Bořivoj Zeman'],
music:['Jan Hammer ml.'],
camera:['František Valert'],
cut:['Josef Dobřichovský'],
sound:['Adolf Nacházel'],
scenography:['Boris Moravec'],
masks:['Otakar Košťál'],
costumes:['Jan Skalický','Jarmila Romanová']},
{title:'Persona',
titleCZ:'Persona',
year:1966,
runtime:85,
countries:['Sweden'],
genres:['Drama','Psychology'],
director:['Ingmar Bergman'],
actors:['Bibi Andersson','Liv Ullmann','Margaretha Krook','Gunnar Björnstrand','Jörgen Lindström'],
screenplay:['Ingmar Bergman'],
production:['Lars-Owe Carlberg'],
music:['Lars Johan Werle'],
camera:['Sven Nykvist'],
cut:['Ulla Ryghe'],
sound:['Per-Olof Pettersson','Lennart Engholm','Olle Jakobsson'],
scenography:['Bibi Lindström'],
masks:['Börje Lundh'],
costumes:['Mago']},
{title:'Europa Europa',
titleCZ:'Evropa, Evropa',
year:1990,
runtime:112,
countries:['Germany','France','Poland'],
genres:['Drama','War','History'],
director:['Agnieszka Holland'],
actors:['Marco Hofschneider','Julie Delpy','René Hofschneider','André Wilms','Andrzej Mastalerz','Hanns Zischler','Norbert Schwarz','Halina Łabonarska','Artur Barciś','Zbigniew Bielski','Bohdan Ejmont','Marcin Latałło','Włodzimierz Press','Anna Seniuk','Włodzimierz Musiał','Ryszard Pietruski','Grzegorz Wons','Cezary Morawski','Aleksander Bednarz','Tadeusz Wojtych','Alfred Freudenheim','Jarosław Gruda','Alexej Maslov','Nicolas Lormeau','Holger Kunkel','Martin Maria Blau','Bogusława Schubert','Erich Schwarz','Marbo Becker','Marek Brand','Dariusz Buchowiecki','Ashley Wanninger','Marcin Bielawski','Klaus Abramowsky','Bernhard Howe','Klaus Kowatsch'],
screenplay:['Paul Hengge'],
production:['Margaret Ménégoz','Artur Brauner'],
music:['Zbigniew Preisner'],
camera:['Jacek Petrycki'],
cut:['Isabelle Lorente','Ewa Smal'],
sound:['Hans-Dieter Schwarz','Elisabeth Mondi'],
scenography:['Allan Starski','Ewa Braun'],
costumes:['Wiesława Starska','Malgorzata Stefaniak']},
{title:'Winnetou: The Last Shot',
titleCZ:'Vinnetou - Poslední výstřel',
year:1965,
runtime:89,
countries:['Germany','Italy','Yugoslavia'],
genres:['Western','Adventure'],
director:['Harald Reinl'],
actors:['Lex Barker','Pierre Brice','Rik Battaglia','Ralf Wolter','Carl Lange','Miha Baloh','Dušan Antonijević','Ilija Ivezič','Slobodan Dimitrijević','Sophie Hardy','Renato Baldini','Miroslav Buhin','Karin Dor','Dragomir Felba','Sime Jagarinac','Gojko Mitić','Dušan Vujisič','Joachim Nottke','Thomas Eckelmann'],
basedOn:['Karl May'],
screenplay:['J. Joachim Bartsch','Harald G. Petersson'],
production:['Horst Wendlandt'],
music:['Martin Böttcher'],
camera:['Ernst W. Kalinke'],
cut:['Jutta Hering'],
scenography:['Vladimir Tadej'],
costumes:['Irms Pauli']},
{title:'The Best Offer',
titleCZ:'Nejvyšší nabídka',
year:2013,
runtime:124,
countries:['Italy'],
genres:['Drama','Romance','Mystery','Crime'],
director:['Giuseppe Tornatore'],
actors:['Geoffrey Rush','Jim Sturgess','Sylvia Hoeks','Donald Sutherland','Philip Jackson','Dermot Crowley','Kiruna Stamell','Liya Kebede','Caterina Capodilista','Gen Seto','Klaus Tauber','Maximilian Dirr','Laurence Belgrave','Sean Buchanan','John Benfield','Miles Richardson','Jim Conway','Brigitte Christensen','Jacqueline Hopkins','Amanda Walker','Rita Davies','Sylvia De Fanti','Anita Eberwein-Newrkla','Ami Veevers Chorlton','Victoria Chapman','Wolfram Kremer','Gerry Shanahan','Katherine Wilson','David Kevin Fells','Jay Natelle','Luke Charles','Alison Adam','Melanie Gerren','Marcus J. Cotterell','Adrian McCourt','Vernon Dobtcheff','Patricia Meglio','Julian Curry','Stefano Scherini','Katie McGovern','Andrew Ross Phillips','Merlin Ramml','Elizabeth Anne Kaye','Gerhard Haller','Jun Ichikawa','Lynn Swanson','Helen Hutchison','Margherita Pettarin','Diana Pegan','Hannah Britland','Shelagh Gallivan','Tara Elise Schlener','Karel Mika','Simone Spinazze','Elizabeth Kalton','Diana Hobel','Rajeev Badhan','Douglas Dean','Erand Hoxha','Franco Moscon'],
screenplay:['Giuseppe Tornatore'],
production:['Isabella Cocuzza','Arturo Paglia'],
music:['Ennio Morricone'],
camera:['Fabio Zamarion'],
cut:['Massimo Quaglia'],
sound:['Gilberto Martinelli','Gianni Pallotto'],
scenography:['Maurizio Sabatini','Maurizio Di Clemente','Raffaella Giovannetti'],
masks:['Luigi Rocchetti','Matteo Silvi'],
costumes:['Maurizio Millenotti']},
{title:'Krakatit',
titleCZ:'Krakatit',
year:1948,
runtime:97,
countries:['Czechoslovakia'],
genres:['Drama','Sci-Fi'],
director:['Otakar Vávra'],
actors:['Karel Höger','Florence Marly','František Smolík','Nataša Tanská','Miroslav Homola','Jaroslav Průcha','Jiří Plachý st.','Eduard Linkers','Bedřich Vrbský','Karel Dostal','Vlasta Fabianová','Bohuš Hradil','František Vnouček','Vítězslav Boček','Jiřina Petrovická','Jaroslav Zrotal','Zvonimir Rogoz','Antonín Jirsa','Magda Kopřivová','Zdeněk Hodr','Ann Sortreed','Margarette Previtali','Stojanka Mustafova','Tsiao Jeh','Margaret Amakof','Čebeh Čančinov','František Marek','Filip Balek-Brodský','Ema Kreutzerová','Ema Hrubá'],
basedOn:['Karel Čapek'],
screenplay:['Otakar Vávra','Jaroslav R. Vávra'],
music:['Jiří Srnka'],
camera:['Václav Hanuš'],
cut:['Antonín Zelenka'],
sound:['Emil Poledník'],
scenography:['Jan Zázvorka'],
masks:['Oldřich Mach']},
{title:'Underground',
titleCZ:'Underground',
year:1995,
runtime:163,
countries:['Yugoslavia','France','Germany','Bulgaria'],
genres:['Drama','Comedy','War'],
director:['Emir Kusturica'],
actors:["Predrag 'Miki' Manojlovič",'Lazar Ristovski','Mirjana Jokovič','Slavko Štimac','Ernst Stötzner','Srdjan Todorovič','Mirjana Karanovič','Milena Pavlovič',"Danilo 'Bata' Stojkovič",'Bora Todorovič','Davor Dujmovic','Branislav Lečič','Dragan Nikolič','Hark Bohm','Emir Kusturica','Albena Stavreva','Josif Tatič','Leonid Iljič Brežněv','princ Philip','vévoda z Edinburghu','Nele Karajlić','Pierre Spengler','Stojan Sotirov','Predrag Milinkovič','Rick Dano','Kurt Waldheim','Nicolae Ceauşescu','Ljiljana Jovanovič','Branko Petkovič','Željko Mitrovič','Erol Kadic','Elizabeta Djorevska','Helmut Schmidt'],
basedOn:['Dušan Kovačevič'],
screenplay:['Emir Kusturica','Dušan Kovačevič'],
music:['Goran Bregovič'],
camera:['Vilko Filac'],
cut:['Branka Čeperac'],
scenography:['Miljen Kreka Kljakovic'],
masks:['Miloslav Jandera'],
costumes:['Nebojša Lipanovič']},
{title:'Forgotten Love',
titleCZ:'Mastičkář',
year:2023,
runtime:140,
countries:['Poland'],
genres:['Drama'],
director:['Michał Gazda'],
actors:['Leszek Lichota','Maria Kowalska','Ignacy Liss','Anna Szymańczyk','Izabela Kuna','Mikołaj Grabowski','Miroslaw Haniszewski','Paweł Tomaszewski','Małgorzata Mikołajczak','Łukasz Szczepanowski','Artur Barciś','Jarosław Gruda','Henryk Niebudek','Adam Nawojczyk','Stanisław Brudny','Robert Gonera','Patryk Szwichtenberg','Sławomir Holland','Krzysztof Dracz','Żaneta Homa','Przemysław Przestrzelski','Weronika Kozakowska','Piotr Rogucki','Ewa Szykulska','Maciej Damięcki','Jacek Grondowy','Karolina Piechota','Edyta Januszewska','Matylda Paszczenko','Ewa Kolasińska','Szymon Kukla','Joachim Lamża','Albert Osik','Jakub Potyrała','Marek Nędza','Dawid Ściupidro','Paweł Janyst','Oskar Grzegorzewski','Julia Adamczyk','Marcin Walkowski','Piotr Kaźmierczak','Alicja Jachiewicz','Waleria Gorobets','Agnieszka Sztuk','Agata Łabno','Maurycy Opaliński','Jakub Lewczuk','Kamil Pardo','Damian Majewski','Mariusz Urbaniec','Antonina Bonecka'],
basedOn:['Tadeusz Dołęga-Mostowicz'],
screenplay:['Marcin Baczyński','Mariusz Kuczewski'],
production:['Magdalena Szwedkowicz'],
music:['Paweł Lucewicz'],
camera:['Tomasz Augustynek'],
cut:['Piotr Kmiecik'],
sound:['Robert Czyżewicz'],
scenography:['Joanna Macha'],
masks:['Ewa Szwed'],
costumes:['Małgorzata Zacharska']},
{title:'Ubožáci',
titleCZ:'Ubožáci',
year:1982,
runtime:'Televizní verze: 4x55 min',
countries:['France'],
genres:['Drama'],
director:['Robert Hossein'],
actors:['Lino Ventura','Jean Carmet','Michel Bouquet','Evelyne Bouix','Roger Hanin','Paul Préboist','Robin Renucci','Louis Seigner','Denis Lavant','Héléna Manson','Paul Pavel','Robert Dalban','Arlette Thomas','Jean-Roger Caussimon','Dominique Davray','Dominique Zardi','Henri Attal','Armand Mestral','Fernand Ledoux','Françoise Seigner','Christophe Odent','Nathalie Nerval','Max Montavon','Yvette Etiévant','Jean-Marie Proslier','André Dumas','Georges Lycan','Sylvain Lévignac','Christiane Jean','Mado Maurin','Franck Cabot-David','Jean-Pierre Bernard','Emmanuel Curtil','Marcel Champel','Denise Bailly','Madeleine Bouchez','Corinne Dacla','Luc Delhumeau','Patrice Melennec','Pierre Negre','Jacques Riberolles','Candice Patou','René Morard','Hervé Furic','Christian Benedetti','Mario Luraschi','Aline Bertrand','Rose Thiéry','Bernard Dumaine','Jean-René Gossart','Jean-Marie Bernicat','Hubert Noël','André Chanal','Denise Chalem','Guy Di Rigo'],
basedOn:['Victor Hugo'],
screenplay:['Alain Decaux','Robert Hossein'],
production:['Sophie von Uslar'],
music:['André Hossein','Michel Magne'],
camera:['Edmond Richard'],
cut:['Martine Barraqué'],
scenography:['François de Lamothe','Jean Mandaroux'],
masks:['Aïda Carange']},
{title:'Adamova jablka',
titleCZ:'Adamova jablka',
year:2005,
runtime:94,
countries:['Denmark','Germany'],
genres:['Comedy','Drama','Mystery'],
director:['Anders Thomas Jensen'],
actors:['Ulrich Thomsen','Mads Mikkelsen','Nicolas Bro','Paprika Steen','Ali Kazim','Ole Thestrup','Nikolaj Lie Kaas','Gyrd Løfquist','Lars Ranthe','Peter Reichhardt','Tomas Villum Jensen','Peter Lambert'],
screenplay:['Anders Thomas Jensen'],
production:['Tivi Magnusson','Mie Andreasen','Sanne Arnt Torp'],
music:['Jeppe Kaas'],
camera:['Sebastian Blenkov'],
cut:['Anders Villadsen'],
sound:['Morten Degnbol'],
scenography:['Mia Stensgaard'],
masks:['Louise Hauberg Lohmann','Thomas Foldberg'],
costumes:['Jane Whittaker']},
{title:'Drunken Master',
titleCZ:'Mistrův syn',
year:1978,
runtime:107,
countries:['Hong Kong'],
genres:['Comedy','Action'],
director:['Woo-ping Yuen'],
actors:['Jackie Chan','Simon Siu-Tin Yuen','Jang-Lee Hwang','Dean Shek','Sin San','Tino Wong Cheung','Kwai Shan','Hsu Hsia','Jing Tang','Brandy Yuen','Keung Law','Linda Lin','Woo-ping Yuen','Max Chiu-Chun Lee','Ha Huang','Ging-Man Fung','Chi-Ming Wong','Tit-Ching Lam'],
screenplay:['Woo-ping Yuen','Lung Siao','See-yuen Ng'],
production:['See-yuen Ng'],
music:['Fu Liang Chou'],
camera:['Hui Chang'],
cut:['Hung Poon'],
scenography:['Jonathan Ting'],
masks:['Siu-Ping Ko'],
costumes:['Shui-Lin Lo']},
{title:'Coach to Vienna',
titleCZ:'Kočár do Vídně',
year:1966,
runtime:85,
countries:['Czechoslovakia'],
genres:['Drama','War','Psychology'],
director:['Karel Kachyňa'],
actors:['Iva Janžurová','Jaromír Hanzlík','Luděk Munzar','Ladislav Jandoš','Zdeněk Jarolímek','Ivo Niederle','Vladimír Ptáček','Jiří Žák','Klaus-Peter Thiele','Ulrich Thein'],
basedOn:['Jan Procházka'],
screenplay:['Jan Procházka','Karel Kachyňa'],
music:['Jan Novák'],
camera:['Josef Illík'],
cut:['Miroslav Hájek'],
sound:['Jiří Lenoch'],
scenography:['Leoš Karen'],
masks:['Rudolf Buneš']},
{title:'Amarcord',
titleCZ:'Amarcord',
year:1973,
runtime:123,
countries:['Italy','France'],
genres:['Drama','Comedy'],
director:['Federico Fellini'],
actors:['Pupella Maggio','Armando Brancia','Magali Noël','Ciccio Ingrassia','Nando Orfei','Maria Antonietta Beluzzi','Nella Gambini','John Karlsen','Ted Rusoff','Paolo Baroni','Francesco Maselli','Lewis E. Ciannelli','Anthony La Penna','Bruno Bertocci','Veriano Ginesi','Carolyn De Fonseca','Alvaro Vitali','Aristide Caporale','Cicely Browne','Bruno Zanin','Lino Patruno','Eros Ramazzotti','Antonio Spaccatini','Rolando De Santis','Gianni Di Segni'],
screenplay:['Federico Fellini','Tonino Guerra'],
production:['Franco Cristaldi'],
music:['Nino Rota'],
camera:['Giuseppe Rotunno'],
cut:['Ruggero Mastroianni'],
sound:['Oscar De Arcangelis'],
scenography:['Danilo Donati'],
costumes:['Danilo Donati']},
{title:'Cyrano z Bergeracu',
titleCZ:'Cyrano z Bergeracu',
year:1986,
runtime:157,
countries:['Czechoslovakia'],
genres:['Drama'],
director:['Jaroslav Dudek'],
actors:['Jaromír Hanzlík','Svatopluk Skopal','Josef Bláha','Ilja Racek','Břetislav Slováček','Vladimír Bičík','Rudolf Jelínek','Zdeněk Řehoř','Milan Klásek','František Hanus','Michal Pešek','Svatopluk Skládal','Jaroslav Satoranský','Hana Maciuchová','Alena Procházková','Cvetana Igova','Sylva Sequensová','Antonie Hegerlíková','Miroslav Babuský','Alexandra Tomanová','Otakar Brousek st.','Jiří Plachý ml.','Ludmila Vostrčilová'],
screenplay:['Edmond Rostand']},
{title:'A Short Film About Killing',
titleCZ:'Krátký film o zabíjení',
year:1987,
runtime:84,
countries:['Poland'],
genres:['Drama','Crime'],
director:['Krzysztof Kieślowski'],
actors:['Mirosław Baka','Krzysztof Globisz','Jan Tesarz','Zbigniew Zapasiewicz','Barbara Dziekan','Aleksander Bednarz','Jerzy Zass','Zdzisław Tobiasz','Artur Barciś','Krystyna Janda','Olgierd Łukaszewicz','Leonard Andrzejewski','Krzysztof Stelmaszyk','Małgorzata Pieczyńska','Zdzisław Rychter','Maciej Szary','Helena Kowalczykowa','Andrzej Gawroński','Maciej Maciejewski','Borys Marynowski','Marzena Manteska','Iwona Głębicka','Zbigniew Plato','Henryk Guzek','Cezary Świtkowski','Lech Pietrasz','Bogusław Hubicki','Wiesław Bednarz','Zbigniew Borek','Władysław Byrdy','Ryszard W. Borsucki','Elżbieta Helman','Krzysztof Luft','Henryk Łapiński','Bogdan Niewinowski','Andrzej Mastalerz','Jolanta Mielech','Marlena Miarczyńska','Karol Stępkowski','Alicja Wolska','Sylwester Maciejewski'],
screenplay:['Krzysztof Piesiewicz','Krzysztof Kieślowski'],
music:['Zbigniew Preisner'],
camera:['Sławomir Idziak'],
cut:['Ewa Smal'],
sound:['Małgorzata Jaworska'],
scenography:['Halina Dobrowolska','Magdalena Dipont'],
masks:['Dorota Seweryńska'],
costumes:['Małgorzata Obłoza','Hanna Ćwikło']},
{title:'Conscience',
titleCZ:'Svědomí',
year:1948,
runtime:101,
countries:['Czechoslovakia'],
genres:['Drama','Psychology'],
director:['Jiří Krejčík'],
actors:['Marie Vášová','Miloš Nedbal','Jan Prokeš','Irena Kačírková','Bohuš Záhorský','Vladimír Hlavatý','Eduard Dubský','František Kovářík','František Šlégr','Oldřich Hoblík','Michaela Lišková','Jindřich Fairaizl','Bohumil Vild','Ivan Jandl','Oldřich Macháček','Zdeněk Kryzánek','Josef Steigl','Jarmila Kurandová','Václav Kyzlink','Gustav Schönbach','Antonín Holzinger'],
basedOn:['Vladimír Valenta'],
screenplay:['Jiří Fried','J. A. Novotný'],
music:['Jiří Šust'],
camera:['Rudolf Stahl ml.'],
cut:['Josef Dobřichovský'],
sound:['Dobroslav Šrámek'],
scenography:['Chrudoš Uher'],
masks:['Otakar Košťál']},
{title:'Fantomas Strikes Back',
titleCZ:'Fantomas se zlobí',
year:1965,
runtime:94,
countries:['France','Italy'],
genres:['Comedy','Adventure','Crime','Fantasy'],
director:['André Hunebelle','Haroun Tazieff'],
actors:['Jean Marais','Louis de Funès','Mylène Demongeot','Jacques Dynam','Robert Dalban','Albert Dagnant','Christian Toma','Michel Duplaix','Olivier de Funès','Florence Blot','Robert Le Béal','Pietro Tordi','Henri Attal','Dominique Zardi','Jacques Marin','Max Montavon','Jean Michaud','Mino Doro','Yvan Chiffre','Eric Vasberg','Antoine Baud','Arturo Dominici','Bob Morel','Antoine Marin','Philippe Castelli','Roger Lumont','Raymond Pellegrin'],
basedOn:['Pierre Souvestre','Marcel Allain'],
screenplay:['Jean Halain','Pierre Foucaud'],
production:['Paul Cadéac','Alain Poiré'],
music:['Michel Magne'],
camera:['Raymond Pierre Lemoigne'],
cut:['Jean Feyte'],
sound:['René-Christian Forget'],
scenography:['Max Douy','Max Douy'],
masks:['René Daudin','Anatole Paris'],
costumes:['Mireille Leydet']},
{title:'Perfect Strangers',
titleCZ:'Naprostí cizinci',
year:2016,
runtime:93,
countries:['Italy'],
genres:['Comedy','Drama'],
director:['Paolo Genovese'],
actors:['Giuseppe Battiston','Anna Foglietta','Marco Giallini','Edoardo Leo','Valerio Mastandrea','Alba Rohrwacher','Kasia Smutniak','Benedetta Porcaroli','Elisabetta De Palo','Tommaso Tatafiore','Noemi Pagotto'],
screenplay:['Paolo Genovese','Paolo Costella','Rolando Ravello','Filippo Bologna','Paola Mammini'],
production:['Marco Belardi'],
music:['Maurizio Filardo'],
camera:['Fabrizio Lucci'],
cut:['Consuelo Catucci'],
sound:['Francesco Tumminello'],
scenography:['Chiara Balducci'],
masks:['Fabrizio Nanni'],
costumes:['Grazia Materia']},
{title:'Brendan and the Secret of Kells',
titleCZ:'Brendan a tajemství Kellsu',
year:2009,
runtime:75,
countries:['Belgium','Ireland','France'],
genres:['Animation','Adventure','Fantasy','Family'],
director:['Tomm Moore','Nora Twomey'],
actors:['Brendan Gleeson','Nora Twomey','Paul Tylak','Paul Young','Fabian Erlinghauser','Michael McGrath'],
screenplay:['Fabrice Ziolkowski'],
production:['Didier Brunner','Paul Young'],
music:['Bruno Coulais'],
scenography:['Ross Stewart']},
{title:'Return to Life',
titleCZ:'Byt či nebýt',
year:2024,
runtime:90,
countries:['Czechia'],
genres:['Documentary'],
director:['Jaroslav Beran'],
screenplay:['Jaroslav Beran'],
production:['František eF. Horvát','Markéta Plšková','Sandra Klimešová'],
camera:['Adam Černich'],
cut:['Daniel Trögler'],
sound:['Tomáš Kocourek']},
{title:'Roztomilý člověk',
titleCZ:'Roztomilý člověk',
year:1941,
runtime:104,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Martin Frič'],
actors:['Oldřich Nový','Ladislav Pešek','Nataša Gollová','Lída Chválová','Theodor Pištěk','Ella Nollová','Raoul Schránil','Jaroslav Marvan','František Filipovský','Antonín Zacpal','Světla Svozilová','Zdeňka Baldová','Blažena Slavíčková','Ferenc Futurista','Marie Blažková','Karel Hašler','Eva Svobodová','Bohuš Záhorský','Jiří Vondrovič','Bedřich Bozděch','Josef Bělský','Ferdinand Jarkovský','Bolek Prchal'],
basedOn:['F. X. Svoboda'],
screenplay:['Karel Steklý'],
music:['Josef Stelibský'],
camera:['Václav Hanuš'],
cut:['Jan Kohout'],
sound:['Antonín Rambousek'],
scenography:['Alois Mecera']},
{title:'On the Comet',
titleCZ:'Na kometě',
year:1970,
runtime:74,
countries:['Czechoslovakia'],
genres:['Adventure','Sci-Fi','Fantasy'],
director:['Karel Zeman'],
actors:['Emil Horváth ml.','Magda Vášáryová','František Filipovský','Josef Větrovec','Čestmír Řanda st.','Vladimír Menšík','Jiřina Jirásková','Karel Effa','Jaroslav Mareš','Steva Maršálek','Josef Hlinomaz','Jaroslav Štercl','Eduard Kohout','Karel Pavlík','Zdena Bronislavská','Zdeněk Braunschläger','Jiří Lír','Pavel Libovický','Jaroslav Klouda','Hanuš Bor','Miloš Nesvadba','Miloslav Holub','Vladimír Hrubý','Antonín Soukup','Jaroslava Vošmiková','Václav Kaňkovský','František Doleček','Zdeněk Formánek','Jiří Paclík','Dmitrij Turčaninov','Ivan Chrz','Bohumil Koška','Pavel Jiras','Teresia Elad','Jean Lifendi','M. L. Lukongo','Stanislav Junek','Michael Kodais','Antoine Massouh','Josef Matar','Mušrik Rahbány','Willy Kuk-Znamínko','Blažena Kramešová','Marta Richterová','Eva Rubínová','Lolka Šoupalová','Taťána Unkurovová','Iva Šašková','Oldřich Velen','Ladislav Gzela','Miloš Vosmanský','B. K. Sarap','Duggirala Visweswaram','Zdeněk Vašek','Karel Engel','Jaroslav Tomsa','Miloslav Šindler','Vladimír Navrátil','Jan Tříska','Jana Drbohlavová'],
basedOn:['Jules Verne'],
screenplay:['Jan Procházka','Karel Zeman'],
music:['Luboš Fišer'],
camera:['Rudolf Stahl ml.','Bohuslav Pikhart'],
cut:['Josef Valušiak'],
sound:['František Strangmüller'],
scenography:['Jiří Hlupý'],
masks:['Vladimír Černý'],
costumes:['Jan Kropáček']},
{title:'Ghost in the Shell 2: Innocence',
titleCZ:'Ghost in the Shell 2: Innocence',
year:2004,
runtime:99,
countries:['Japan'],
genres:['Animation','Thriller','Sci-Fi','Psychology','Action'],
director:['Mamoru Ošii'],
actors:['Akio Ócuka','Acuko Tanaka','Kóiči Jamadera','Tamio Óki','Naoto Takenaka','Hiroaki Hirata','Makoto Jasumura','Fumihiko Tačiki','Jošiko Sakakibara','Juzuru Fudžimoto','Jú Sugimoto','Rjúdži Nakagi','Minoru Hirano','Kacunosuke Hori','Masaki Terasoma','Jutaka Nakano',"Ken'iči Močizuki",'Hirojuki Kinošita','Masao Harada','Eriko Kigawa','Sumi Mutó','Eisuke Asakura','Emiko Fuku','Sukekijo Kamejama','Jasuši Niko'],
basedOn:['Masamune Širó'],
production:['Tošio Suzuki'],
music:['Kendži Kawai'],
sound:['Michael Semanick'],
scenography:['Jóhei Taneda']},
{title:'Red Cliff: Part II',
titleCZ:'Chi bi xia: Jue zhan tian xia',
year:2009,
runtime:136,
countries:['China'],
genres:['History','Action','Adventure','War'],
director:['John Woo'],
actors:['Tony Chiu-wai Leung','Takeši Kaneširo','Chen Chang','Šidó Nakamura','Vicki Zhao','Chiling Lin','Kou Shixun','Yongzhi You','Ning Wang','Chao Guo','Jingjing Ma','Shan Zhang','Fengyi Zhang','Yong Hou','Jinsheng Zang','Gang Xie','Yin He','Xiaoguang Hu'],
production:['John Woo','Terence Chang','Sanping Han'],
music:['Taró Iwaširo'],
camera:['Yue Lü','Li Zhang','Wei Huang'],
cut:['David Wu','Angie On-Yee Lam','Hongyu Yang'],
sound:['Steve Burgess','Roger Savage','Robert Mackenzie'],
scenography:['Timmy Yip','Han Xing'],
costumes:['Timmy Yip']},
{title:'The Bohemian Life',
titleCZ:'Bohémský život',
year:1992,
runtime:100,
countries:['France','Germany','Sweden','Finland'],
genres:['Drama','Comedy'],
director:['Aki Kaurismäki'],
actors:['Matti Pellonpää','Evelyne Didi','André Wilms','Kari Väänänen','Christine Murillo','Jean-Pierre Léaud','Carlos Salgado','Alexis Nitzer','Sylvie Van den Elsen','Gilles Charmant','Laika','Dominique Marcas','Samuel Fuller','Jean-Paul Wenzel','Louis Malle','André Penvern','Maximilien Regiani','Daniel Dublet','Philippe Dormoy','Louis Delamotte','Kenneth Colley','Joëlle Jacquet','Michel Jacquet','Helene Brousse','Antonio Olivares','Sanna Fransman','Jacques Cheuiche','Simon Murray','Monique Goury','Mark Lavis','Irmeli Debarle','Veikko Nieminen','Jacques Leobold','Jean-Bernard Mateu','Jean-Luc Abel','Christian Ehrhart','Jacques Ehrhart','Gilles Sacuto','Konsta Väänänen','Alain Sakhnowsky','Teresa Saraiva','Andrée Saldo','Karine Arsène','Jean-Pierre Abodi','Remi Adam','Lalouani Areski','Francois Aver','Marc Barbé','Francis Boespflug','Lydia Braun','Noël Bureau','Natalia Cheuiche','André Le Coq','Gilbert Delmas','Daniel Dudon','Bernard Dupont','Albert Godard','Sylvia Folcarelly','Didier Heidet','Henri Gondalle','Claude Guillemard','Alain Impellizzieri','Othman Karoui','Jean Koralewski','Georges Lacour','Louis Latarrige','Deddy Lemardeley','Ange Melet','Michel Michelis','Felix Mpudi','Ruger Murer','Paula Oinonen','Mohand Ouatah','Raymond Pichert','Piitu','Claude Pinalie','Louis Pinquier','Isabelle Rivaud','Pietro Romanach','Simone Roy-Daniel','Laurent Thavonekhayl','Anssi Tikanmäki','Jacques Viard','Fabienne Vonier','Wolfgang Kluge','John Ebden','Timo Salminen','Outi Eranti'],
basedOn:['Henri Murger'],
screenplay:['Aki Kaurismäki'],
production:['Aki Kaurismäki','Klaus Heydemann'],
camera:['Timo Salminen'],
cut:['Veikko Aaltonen'],
sound:['Jouko Lumme','Timo Linnasalo'],
scenography:['John Ebden'],
costumes:['Simon Murray']},
{title:'The White Lady',
titleCZ:'Bílá paní',
year:1965,
runtime:91,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Zdeněk Podskalský st.'],
actors:['Vlastimil Brodský','Rudolf Hrušínský','Miloš Kopecký','Irena Kačírková','Jiřina Bohdalová','Josef Bek','Čestmír Řanda st.','Václav Voska','Vlasta Chramostová','Vladimír Hlavatý','Ilja Prachař','Darja Hajská','Václav Trégl','Zdeněk Řehoř','Vladimír Menšík','Josef Vošalík','Jiří Koutný','Alois Dvorský','Emanuel Kovařík','Vladimír Linka','Zdeněk Najman','Helena Růžičková','Ilona Kubásková','Jaroslav Heyduk','Milan Kindl','Vladimír Navrátil','Milan Neděla','Jaroslav Pasterňak','J. Daněk','J. Vystrčil','Helena Dubová','Josef Bulík','Jaroslav Kladrubský','František Suk','Miloslav Šindler','Zdeněk Týle','Jiří Valenta','Robert Krásný','Michal Prokop','Lopatová','Miloš Vavruška','Robert Vrchota','Mojmír Ticháček','J. Pešek','Josef Hlinomaz','Vladimír Cabalka'],
basedOn:['Karel Michal'],
screenplay:['Karel Michal'],
music:['Evžen Illín'],
camera:['František Valert'],
cut:['Zdeněk Stehlík'],
sound:['František Šindelář'],
scenography:['Boris Moravec'],
masks:['František Čížek'],
costumes:['Jarmila Romanová']},
{title:'Porco Rosso',
titleCZ:'Porco Rosso',
year:1992,
runtime:93,
countries:['Japan'],
genres:['Animation','Adventure','History','Comedy'],
director:['Hajao Mijazaki'],
actors:['Šúičiró Morijama','Akemi Okamura','Akio Ócuka','Jú Šimaka','Cunehiko Kamidžó','Akimasa Ómori','Daisuke Inoue','Ginzó Macuo','Mahito Cudžimura','Minoru Jada','Nobuo Tanaka','Osamu Saka','Tacujuki Džinnai','Jóko Sómi','Juzuru Fudžimoto','Ajumi Kida','Masajuki Inagaki','Reizó Nomoto','Kacujo Endó'],
screenplay:['Hajao Mijazaki'],
production:['Tošio Suzuki'],
music:['Džó Hisaiši'],
camera:['Acuši Okui'],
cut:['Takeši Sejama'],
sound:['Tom E. Dahl']},
{title:'Jim Jefferies Alcoholocaust',
titleCZ:'Jim Jefferies Alcoholocaust',
year:2010,
runtime:75,
countries:['UK'],
genres:['Comedy'],
director:['Tim Kirkby'],
actors:['Jim Jefferies'],
screenplay:['Jim Jefferies'],
production:['Colin Dench'],
cut:['Adam Windmill']},
{title:'Král Lear',
titleCZ:'Král Lear',
year:2003,
runtime:161,
countries:['Czechia'],
genres:['Drama'],
director:['Martin Huba','Jan Brichcín'],
actors:['Jan Tříska','Jiří Langmajer','Adrian Jastraban','Jan Kačer','David Prachař','Eva Elsnerová','Jitka Schneiderová','David Suchařípa','Jan Novotný','Klára Oltová','David Švehlík','Petr Bláha Nejedlý','Igor Chmela','Zdeněk Vencl','Richard Trsťan','Rudolf Jelínek','Přemysl Houška','Daniel Bambas','Pavel Batěk','Jaroslav Slánský','Martin Sochor','Lukáš Typlt','Eva Čížkovská'],
screenplay:['William Shakespeare'],
music:['Petr Malásek'],
scenography:['Jozef Ciller'],
costumes:['Milan Čorba']},
{title:'La traviata',
titleCZ:'La traviata',
year:1982,
runtime:109,
countries:['Italy'],
genres:['Music','Drama'],
director:['Franco Zeffirelli'],
actors:['Teresa Stratas','Plácido Domingo','Renato Cestiè','Axelle Gall','Vladimir Vasilev','Pina Cei'],
basedOn:['Alexandre Dumas mladší'],
screenplay:['Franco Zeffirelli','Francesco Maria Piave'],
production:['Tarak Ben Ammar'],
music:['Giuseppe Verdi'],
camera:['Ennio Guarnieri'],
cut:['Peter Taylor'],
masks:['Luigi Rocchetti','Giannetto De Rossi','Grazia De Rossi'],
costumes:['Piero Tosi']},
{title:'The Black Barons',
titleCZ:'Černí baroni',
year:1992,
runtime:99,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Zdenek Sirový'],
actors:['Pavel Landovský','Bronislav Poloczek','Alois Švehlík','Jiří Schmitzer','Miroslav Donutil','Josef Dvořák','Rudolf Hrušínský ml.','Václav Postránecký','Daniel Landa','Ondřej Vetchý','Vladimír Javorský','Milan Šimáček','Boris Rösner','Zdeněk Podhůrský','Michal Dosedla','Jan Kraus','Jaromír Dulava','Václav Vydra nejml.','Milan Gunár','Jiří Fero Burda','Michal Dlouhý','Miroslav Táborský','Milan Sandhaus','Štěpánka Lisá','Hana Čížková','Josef Somr','Jiří Bruder','Jan Vlasák','Ludvík Pozník','Gabriela Wilhelmová','Alice Chrtková','Zuzana Stivínová','Petr Kasnar','Christian Thuri'],
basedOn:['Miloslav Švandrlík'],
screenplay:['Miloslav Švandrlík','Zdenek Sirový'],
production:['Jaroslav Bouček'],
music:['Luboš Fišer'],
camera:['Jiří Macháně'],
cut:['Ivana Kačírková'],
sound:['Vladimír Skall'],
scenography:['Zbyněk Hloch'],
masks:['Bohumil Sobotka'],
costumes:['Inka Braťková','Hana Malátová']},
{title:'Dogville',
titleCZ:'Dogville',
year:2003,
runtime:140,
countries:['Denmark','Sweden','France','Norway','Finland'],
genres:['Drama','Thriller','Mystery','Crime'],
director:['Lars von Trier'],
actors:['Nicole Kidman','Harriet Andersson','Lauren Bacall','Jean-Marc Barr','Paul Bettany','Blair Brown','James Caan','Patricia Clarkson','Jeremy Davies','Ben Gazzara','Philip Baker Hall','Thom Hoffman','Siobhan Fallon Hogan','John Hurt','Željko Ivanek','Udo Kier','Cleo King','Bill Raymond','Chloë Sevigny','Stellan Skarsgård','Jan Coster','Erich Silva','Ingvar Örner','László Hágó','Shauna Shim','Ove Wolf','Sonny Johnson','Hans Karlsson'],
screenplay:['Lars von Trier'],
production:['Bettina Brokemper','Vibeke Windeløv'],
camera:['Anthony Dod Mantle'],
cut:['Molly Malene Stensgaard'],
sound:['Per Streit'],
scenography:['Peter Grant'],
masks:['Mari Vaalasranta','Anja Dahl'],
costumes:['Manon Rasmussen']},
{title:'The Millennial Bee',
titleCZ:'Tisícročná včela',
year:1983,
runtime:163,
countries:['Czechoslovakia','Germany','Austria'],
genres:['Drama','Comedy','History'],
director:['Juraj Jakubisko'],
actors:['Jozef Kroner','Štefan Kvietik','Ivana Valešová','Michal Dočolomanský','Eva Jakoubková','Pavol Mikulík','Jana Březinová','Štefan Šafárik','Bára Štěpánová','Svatopluk Mohapl','Peter Kočiš','Robo Laurinec','Peter Maťo','Natália Hasprová','Václav Baur','Zdeněk Dušek','Štefan Mišovic','Zdeněk Blažek','Milan Kiš','Igor Čilík','Miki Kučera','Jana Janovská','Ján Mildner','Viliam Polónyi','Augustín Kubán','Katarína Synková','Štefan Figura','František Kovár','Marek Motloch','Žaneta Jakubisková','Branislav Uherek','Jiří Císler','Zuzana Bydžovská','Jana Dolanská','Vladimír Kostovič','Samuel Adamčík','Vladimír Černý','Hana Gregorová','Emil Horváth st.','Štefan Kožka','Lotár Radványi','Teodor Piovarči','Radan Rusev','Jozef Mokoš','Jozef Husár','Jana Stehnová-Čechová','Hugo Kaminský','Jaromír Kučera','Arnošt Goldflam','Jiří Klepl','Pavla Severinová','Michal Dlouhý','Ivan Rumanovský','Václav Šimice','Daniel Vychopeň','Hana Lančíková','Béla Várady','Mátyás Dráfi','Vladimír Kittler','Jozef Belan','Edita Gallová','Alexander Bada','Miluše Šplechtová','Anna Javorková','Zlatica Gillová'],
basedOn:['Peter Jaroš'],
screenplay:['Peter Jaroš','Juraj Jakubisko','Jozef Paštéka'],
music:['Petr Hapka'],
camera:['Stanislav Doršic'],
cut:['Judita Fatulová','Patrik Pašš'],
sound:['Pavol Sásik'],
scenography:['Miloš Kalina'],
costumes:['Milan Čorba']},
{title:'Shine',
titleCZ:'Záře',
year:1996,
runtime:105,
countries:['Australia'],
genres:['Drama','Biography','Music'],
director:['Scott Hicks'],
actors:['Geoffrey Rush','Sonia Todd','Armin Mueller-Stahl','Noah Taylor','Googie Withers','John Gielgud','Marc Warren','Lynn Redgrave','Grant Doyle','Sandy Gardiner','Chris Haywood','Ella Scott Lynch','Richard Hansell','Nicholas Bell','David King','Beverley Dunn'],
screenplay:['Jan Sardi'],
production:['Jane Scott'],
music:['David Hirschfelder'],
camera:['Geoffrey Simpson'],
cut:['Pip Karmel'],
sound:['Roger Savage'],
masks:['Lesley Vanderwalt'],
costumes:['Louise Wakefield']},
{title:'Fist of Legend',
titleCZ:'Pěst legendy',
year:1994,
runtime:103,
countries:['Hong Kong'],
genres:['Action','Drama'],
director:['Gordon Chan'],
actors:['Jet Li','Šinobu Nakajama','Siu-hou Chin','Billy Chow','Jasuaki Kurata','Ada Choi','Cheung-Yan Yuen','Gary Wing-Lun Mak','Wah-wo Wong','Bill Man-Biu Lee','Siu-ming Lui','Ernest Mauser','Tai-wo Tang','Tin-hung Yee','Kwok-kit Lam','Wayne Grace','Chi-hung Ling','Kwok-ping Choi','Marco Lo','Yuk-Wah Cheung','Wai-Yin Lam','Kwok-leung Ching','Jackson Lau','Kendži Tanigaki','Siu-Wah Chan','Tat-Chiu Lee','Sam Kai-Sen Huang','Gam-Kong Chow','Foo-Wai Lam','Wah-Kon Lee','Chi-Keung Wong','Chi-Keung Wong','Wing-Cheung Ho','Tony Ling','Sun Wong'],
screenplay:['Kwong-kim Yip','Gordon Chan'],
music:['Joseph Koo','Sherman Chow'],
camera:['Derek Wan'],
cut:['Kei-Hop Chan'],
scenography:['Horace Ma','Tak-Lam Fu','Shandy Lui'],
masks:['Yun-Ling Man'],
costumes:['Shirley Koo-Fong Chan','Hilda Choi']},
{title:'Šťastný Luke - Daisy Town',
titleCZ:'Šťastný Luke - Daisy Town',
year:1971,
runtime:71,
countries:['Belgium','France'],
genres:['Animation','Comedy','Western'],
director:['René Goscinny'],
actors:['Marcel Bozzuffi','Pierre Tornade','Roger Carel','Rosy Varte','André Le Gall','Pierre Trabaud','Jacques Bodoin','Georges Atlas','Nicole Croisille'],
basedOn:['René Goscinny','Morris'],
screenplay:['Pierre Tchernia','Jos Marissen','Morris'],
production:['Leon Zuratas'],
music:['Claude Bolling'],
cut:['Roger Cacheux'],
sound:['Jean Nény']},
{title:'Be with You',
titleCZ:'Ima, ai ni jukimasu',
year:2004,
runtime:119,
countries:['Japan'],
genres:['Fantasy','Romance','Drama'],
director:['Nobuhiro Doi'],
actors:['Júko Takeuči','Šidó Nakamura','Júta Hiraoka','Čihiro Ócuka','You','Suzuki Macuo','Kacuo Nakamura','Jósuke Asari','Fumijo Kohinata','Kazuaki Hankai','Karen Mijama','Akaši Takei','Tokimasa Tanabe','Mikako Ičikawa','Kei Tanaka','Juki Umoto'],
screenplay:['Jošikazu Okada'],
production:['Minami Ičikawa'],
music:['Suguru Matsutani'],
camera:['Takahide Šibanuši'],
scenography:['Jóhei Taneda']},
{title:'Farewell My Concubine',
titleCZ:'Sbohem, má konkubíno',
year:1993,
runtime:171,
countries:['China','Hong Kong'],
genres:['Drama','Romance','Music','War'],
director:['Kaige Chen'],
actors:['Leslie Cheung','Fengyi Zhang','Li Gong','You Ge','Qing Xu','Wenli Jiang','David Wu','Dan Li','Pu Zhou'],
basedOn:['Pik Wah Li'],
screenplay:['Wei Lu','Pik Wah Li','Bik-Wa Lei'],
music:['Jiping Zhao'],
camera:['Changwei Gu'],
sound:['Jing Tao'],
scenography:['Zhanjia Yang']},
{title:"Bill Burr: I'm Sorry You Feel That Way",
titleCZ:"Bill Burr: I'm Sorry You Feel That Way",
year:2014,
runtime:60,
countries:['USA'],
genres:['Comedy'],
director:['Jaime Eliezer Karas'],
actors:['Bill Burr'],
screenplay:['Bill Burr'],
camera:['Brian Burgoyne']},
{title:'Dařbuján a Pandrhola',
titleCZ:'Dařbuján a Pandrhola',
year:1959,
runtime:80,
countries:['Czechoslovakia'],
genres:['Fairytale','Comedy'],
director:['Martin Frič'],
actors:['Jiří Sovák','Rudolf Hrušínský','Václav Lohniský','Běla Jurdová','Vladimír Menšík','Pavla Maršálková','Bohuš Záhorský','Otakar Brousek st.','Stanislav Neumann','Josef Hlinomaz','Ilona Kubásková','Alena Kreuzmannová','Ota Motyčka','Milka Balek-Brodská','Václav Trégl','Růžena Štěpánová','Karel Fiala','Bohumil Švarc st.','Květa Fialová','Oldřich Dědek','Eman Fiala','Bedřich Bozděch','Jaroslav Moučka','Viola Zinková','Irena Juřičková','Marie Kautská','Blažena Slavíčková','Jiřina Bílá','Jarmila Kurandová','Josef Příhoda','Vladimír Hrubý','Věra Ferbasová','Magda Maděrová','Alois Dvorský','Vladimír Klemens','Josef Čermák','Michael Dáňa','Miloš Vavruška','Hana Talpová','Josefa Pechlátová','Vítězslav Černý','Ladislav Gzela','Josef Langmiler','Oleg Reif','František Miroslav Doubrava','Josef Steigl','Jan S. Kolár','Věra Váchová','Václav Švec','Jan Bobek'],
basedOn:['Jan Drda'],
screenplay:['Jan Drda','Martin Frič'],
music:['Jiří Srnka'],
camera:['Jan Novák'],
cut:['Jan Kohout'],
sound:['Emanuel Formánek'],
costumes:['Věra Hromádková','Aša Teršová','Vladimír Synek']},
{title:'Holy Year',
titleCZ:'Svatý rok',
year:1976,
runtime:85,
countries:['France','Italy'],
genres:['Comedy','Crime'],
director:['Jean Girault'],
actors:['Jean Gabin','Jean-Claude Brialy','Nicoletta Machiavelli','Henri Virlogeux','Danielle Darrieux','Paolo Giusti','Jacques Marin','Maurice Teynac','Giampiero Albertini','Philippe Dumat','Ibrahim Seck','Billy Kearns','Philippe Vallauris','Carlo Nell','Philippe Brigaud','Michel Duplaix','Monique Tarbès','Michel Fortin','André Dumas','Chantal Nobel','Umberto Raho','Renato Romano','Marcel Gassouk','Stéphane Bouy','Jean Valmence','Fulbert Janin','Franck Cabot-David','Yvan Tanguy','André Lawrence','Dominique Briand','Roland Malet','Tommy Duggan','Léon Zitrone','Michel Dacquin','Maurice Travail','El Kebir','Jean-Yves Gautier','Jean Cherlian','Lorenzo Piani','Denyse Roland','Nicole Desailly','Ugo Fangareggi','Pauline Larrieu','Jacques Dhéry','Danielle Durou'],
screenplay:['Jacques Vilfrid','Louis-Emile Galey'],
production:['Gérard Beytout'],
music:['Claude Bolling'],
camera:['Guy Suzuki'],
cut:['Marie-Christine Lewin','Michel Lewin'],
sound:['Pietro Spadoni'],
masks:['Jean-Pierre Eychenne'],
costumes:['Dafne Ciarrocchi']},
{title:'The Disappearance of Haruhi Suzumiya',
titleCZ:'Suzumija Haruhi no šóšicu',
year:2010,
runtime:162,
countries:['Japan'],
genres:['Animation','Mystery','Psychology'],
director:['Jasuhiro Takemoto','Tacuja Išihara','Norijuki Kitanohara'],
actors:['Aja Hirano','Minori Čihara','Juki Macuoka','Tomokazu Sugita','Júko Gotó','Eidži Janagisawa','Joriko Nagata','Megumi Macumoto','Maju Iino','Nacuko Kuwatani','Mai Aizawa','Rjóta Asari','Sajaka Aoki','Daisuke Ono','Naoko Sugiura','Minoru Širaiši','Hitomi Harada','Noriko Obata','Takuto Jošinaga','Kendži Takahaši','Hitoši Janai','Tomo Adači','Tomojuki Higuči','Eri Taruta'],
basedOn:['Nagaru Tanigawa'],
screenplay:['Fumihiko Šimo'],
production:['Acuši Itó'],
music:['Satoru Kósaki','Kakeru Ishihama'],
camera:['Rjúta Nakagami'],
cut:['Kengo Šigemura'],
scenography:['Seiki Tamura']},
{title:'The Boys of Paul Street',
titleCZ:'Chlapci z Pavelské ulice',
year:1969,
runtime:120,
countries:['Hungary','USA'],
genres:['Drama','Adventure'],
director:['Zoltán Fábri'],
actors:['Anthony Kemp','Mari Törőcsik','Sándor Pécsi','László Kozák','William Burleigh','John Moulder-Brown','Robert Efford','Mark Colleano',"Gary O'Brien",'Martin Beaumont','Paul Bartleft','Earl Younger','György Vizi','Julien Holdaway','Péter Delmár','Nyika Jancsó','Attila Némethy','Imre Ebergényi','Sándor Kentner','László Paál','Árpád Téry','András Avar','János Pách','István Seri','Orsolya Zeitler'],
basedOn:['Ferenc Molnár'],
screenplay:['Zoltán Fábri','Endre Bohem'],
production:['Endre Bohem'],
music:['Emil Petrovics'],
camera:['György Illés'],
cut:['Ferencné Szécsényi'],
sound:['György Kovács','György Pintér'],
scenography:['József Romvári'],
masks:['Ottilia Pásztory'],
costumes:['Judit Schäffer']},
{title:'You Are a Widow, Sir',
titleCZ:'„Pane, vy jste vdova!“',
year:1970,
runtime:97,
countries:['Czechoslovakia'],
genres:['Comedy','Sci-Fi'],
director:['Václav Vorlíček'],
actors:['Iva Janžurová','Olga Schoberová','Eduard Cupák','Jiří Sovák','František Filipovský','Čestmír Řanda st.','Jan Libíček','Otto Šimánek','Luděk Kopřiva','Vladimír Menšík','Jiří Hrzán','Miloš Kopecký','Lubomír Kostelka','Stella Zázvorková','Stella Májová','Jaroslav Mareš','Vlastimil Hašek','Svatopluk Skládal','Jiří Lír','Karel Effa','Oldřich Celerýn','Oldřich Velen','Karel Peyr','Zdeněk Braunschläger','Richard Záhorský','Josef Kotapiš','Oleg Reif','Václav Štekl','Miloš Willig','Helena Růžičková','František Husák','Milan Jonáš','Viktor Maurer','Zdeněk Svěrák','Ladislav Smoljak','Zdeněk Blažek','Vítězslav Černý','Jaroslav Tomsa','Gabriela Bártlová-Buddeusová','Jiřina Bílá','Josef Burda','Zdena Burdová','Jan Cmíral st.','Vlastimil Čaněk','František Miroslav Doubrava','Jana Hana Duffková','Karel Houska','Václav Fišer','Vladimír Foukal','Karel Hovorka st.','Vladimír Hrubý','Pavel Jiras','Stanislav Juna','Milan Kindl','Petr Kopřiva','Václav Kotva','František Horáček','František Kovář','František Kubíček','Ladislav Mrnka','Michal Dohányos','Milan Muchna','Jana Sedlmajerová','Bohumil Rod','Pavel Zradička','Jiří Horký','Vladimír Linka','Luďa Marešová','Zdeněk Martínek','Pavel Navara','Zdeněk Novotný','Eduard Pavlíček','Věra Petáková','Vladimír Pospíšil','Alena Procházková','Eva Rubínová','Jiří Růžička st.','Zdeněk Srstka','Karel Vítek st.','Eva Trunečková','Vítězslav Vejražka','Vladimír Navrátil','Vlastimila Vlková','Arnošt Böhm','Vladimír Čech st.','Mirko Musil'],
screenplay:['Miloš Macourek','Václav Vorlíček'],
music:['Svatopluk Havelka'],
camera:['Václav Hanuš'],
cut:['Miroslav Hájek'],
sound:['František Fabián'],
scenography:['Oldřich Bosák'],
masks:['Oldřich Mach','Jan Valkoun'],
costumes:['Theodor Pištěk ml.','Ondrej Brezovský']},
{title:'The Karamazov Brothers',
titleCZ:'Karamazovi',
year:2008,
runtime:110,
countries:['Czechia','Poland'],
genres:['Drama'],
director:['Petr Zelenka'],
actors:['Ivan Trojan','Radek Holub','Igor Chmela','Roman Luknár','David Novotný','Martin Myšička','Andrzej Mastalerz','Lenka Krobotová','Pavel Šimčík','Michaela Badinková','Lucie Žáčková','Jan Kolařík','Klára Lidová','Jerzy Rogalski','Semjon Štejnberg','Alexandr Laptij'],
basedOn:['Fjodor Michajlovič Dostojevskij'],
screenplay:['Petr Zelenka','Evald Schorm'],
production:['Čestmír Kopecký'],
music:['Jan A.P. Kaczmarek'],
camera:['Alexander Šurkala'],
cut:['Vladimír Barák'],
sound:['Michal Holubec'],
scenography:['Barbara Ostapowicz']},
{title:'Mňága - Happy End',
titleCZ:'Mňága - Happy End',
year:1996,
runtime:62,
countries:['Czechia'],
genres:['Music','Comedy'],
director:['Petr Zelenka'],
actors:['Petr Fiala','Christopher Clarke','Martin Schulz','Marek Vašut','Marek Brodský','Oldřich Vlach','Roman Skamene','Petr Zelenka','Eva Turnová','Hana Křížková','Boris Hybner','Ivan Král','Zdeněk Troška','Karel Zich','Olga Dabrowská','Richard Toth','Alexej Guha','Michal Malátný','Petr Hradil','Petr Hošek','Jiří Černý','Jan Foll','Mirka Spáčilová'],
screenplay:['Petr Zelenka'],
production:['Čestmír Kopecký'],
camera:['Miro Gábor'],
cut:['David Charap'],
sound:['Michal Janoušek'],
scenography:['Milan Salák'],
costumes:['Andrea Králová','Tereza Slámová']},
{title:'Funeral Ceremonies',
titleCZ:'Smuteční slavnost',
year:1969,
runtime:70,
countries:['Czechoslovakia'],
genres:['Drama','Psychology'],
director:['Zdenek Sirový'],
actors:['Jaroslava Tichá','Ľudovít Króner','Josef Somr','Jana Vychodilová','Lída Roubíková','Jan Kühmund','Gustav Opočenský','Božena Böhmová','Josef Bartůněk','Vladimír Huber','Jaroslav Heyduk','Václav Bouška','František Kubíček','Zdeněk Kryzánek','Marie Motlová','Hynek Němec','Jaroslav Rajzík','Blažena Slavíčková','Jaroslav Vlk','Vlastimila Vlková','Jaroslav Moučka'],
basedOn:['Eva Kantůrková'],
screenplay:['Eva Kantůrková','Zdenek Sirový'],
music:['Jiří Kalach'],
camera:['Jiří Macháně'],
cut:['Jan Chaloupek'],
sound:['Roman Hloch'],
scenography:['Karel Černý'],
masks:['Rudolf Hammer','Marie Machová']},
{title:'Interstella 5555: The 5tory of the 5ecret 5tar 5ystem',
titleCZ:'Interstella 5555: The 5tory of the 5ecret 5tar 5ystem',
year:2003,
runtime:68,
countries:['Japan','France'],
genres:['Animation','Action','Music','Sci-Fi'],
director:['Kazuhisa Takenouči','Hirotoši Rissen'],
actors:['Thomas Bangalter'],
screenplay:['Guy Manuel De Homem-Christo','Thomas Bangalter'],
production:['Thomas Bangalter','Guy Manuel De Homem-Christo','Šindži Šimizu'],
music:['Daft Punk','Thomas Bangalter','Guy Manuel De Homem-Christo'],
cut:['Olivier Gajan','Šigeru Nišijama'],
sound:['Cyril Holtz'],
scenography:['Hiroši Kató']},
{title:'All My Loved Ones',
titleCZ:'Všichni moji blízcí',
year:1999,
runtime:91,
countries:['Czechia','Slovakia','Poland'],
genres:['Drama','History','War'],
director:['Matej Mináč'],
actors:['Josef Abrhám','Libuše Šafránková','Jiří Bartoška','Ondřej Vetchý','Braňo Holiček','Lucia Cúlková','Tereza Brodská','Marián Labuda st.','Krzysztof Kolberger','Agnieszka Wagner','Jiří Lábus','Grażyna Wolszczak','Andrzej Deskur','Ladislav Chudík','Květa Fialová','Bohumil Klepl','Hanna Dunowska','František Němec','Oldřich Navrátil','Michaela Kuklová','Zdeněk Dušek','Jiří Menzel','Rupert Graves','Bořivoj Navrátil','Miloslav Mejzlík','Jaroslava Rytychová','Svatopluk Matyáš','Martin Zbrožek','Rostislav Kuba','Jan Nemejovský','Oldřich Vlach','Milan Riehs','Jiří Pecha','Jan Škvor','David Novotný','Petra Jindrová','Tereza Bebarová','Jarmila Švehlová','Jan Pohan','Ladislav Smoček','Milan Lasica','Nicholas Winton','Branislav Hesko'],
screenplay:['Jiří Hubač'],
production:['Jiří Bartoška','Rudolf Biermann'],
music:['Janusz Stokłosa'],
camera:['Dodo Šimončič'],
cut:['Patrik Pašš','Alena Spustová'],
sound:['Karel Jaroš','Róbert Barčák'],
scenography:['Martin Kurel'],
masks:['Juraj Steiner','Ľudmila Kováčiková','Viera Rajtárová'],
costumes:['Jarmila Konečná','Hana Káclová']},
{title:'Zkrocení zlé ženy',
titleCZ:'Zkrocení zlé ženy',
year:2022,
runtime:112,
countries:['Poland'],
genres:['Comedy','Romance'],
director:['Anna Wieczur-Bluszcz'],
actors:['Magdalena Lamparska','Mikołaj Roznerski','Piotr Cyrwus','Tomasz Sapryk','Dorota Stalińska','Sławomir Zapała','Dorota Landowska','Piotr Polk','Magdalena Schejbal','Mariusz Wach','Elżbieta Trzaskoś','Jan Kardasiński','Adam Małysz','Martin Budny','Henrique Xavie Cossa','Michał Pietrzak','Zuzanna Hoang','Piotr Majerczyk','Piotr Głuchowski','Tadeusz Łomnicki','Jacek Grygorowicz','Jakub Wiszniewski','Wiesław Kupczak','Hanna Turnau','Agnieszka Makowska','Janu da Cruz','Krzysztof Bochenek','Paweł Wieczorkowski','Magdalena Duszak','Natalia Stachyra','Roma Zachemba','Jan Trebunia Tutka','Maria Majerczyk'],
screenplay:['Hanna Węsierska','Wojciech Saramonowicz'],
production:['Piotr Zygo','Jacek Stalewski'],
music:['Ignacy Zalewski'],
camera:['Maciej Majchrzak'],
cut:['Marceli Majer'],
sound:['Tomasz Dukszta','Piotr Lasota'],
scenography:['Joanna Anastazja Wójcik','Joanna Anastazja Wójcik'],
masks:['Katarzyna Twardoch'],
costumes:['Katarzyna Adamczyk']},
{title:'Rocco and His Brothers',
titleCZ:'Rocco a jeho bratři',
year:1960,
runtime:175,
countries:['Italy','France'],
genres:['Drama'],
director:['Luchino Visconti'],
actors:['Alain Delon','Renato Salvatori','Annie Girardot','Katina Paxinou','Alessandra Panaro','Spiros Focás','Max Cartier','Corrado Pani','Claudia Mori','Adriana Asti','Enzo Fiermonte','Nino Castelnuovo','Rosario Borelli','Renato Terra','Roger Hanin','Paolo Stoppa','Suzy Delair','Claudia Cardinale','Biagio Gambini'],
screenplay:["Suso Cecchi D'Amico",'Pasquale Festa Campanile','Massimo Franciosa','Enrico Medioli','Luchino Visconti'],
production:['Goffredo Lombardo'],
music:['Nino Rota'],
camera:['Giuseppe Rotunno'],
cut:['Mario Serandrei'],
sound:['Giovanni Rossi'],
scenography:['Mario Garbuglia'],
costumes:['Piero Tosi']},
{title:'Midnight Mass',
titleCZ:'Polnočná omša',
year:1962,
runtime:88,
countries:['Czechoslovakia'],
genres:['Drama','Psychology','War'],
director:['Jiří Krejčík'],
actors:['Ján Klimo','Hana Meličková','Jozef Kroner','Margit Bara','Hannjo Hasse','Ladislav Chudík','Karol Machata','Emília Vášáryová','Ivan Mistrík','Vladimír Šmeral','Jiří Pleskot','Mária Markovičová','Elo Romančík','Jindřich Narenta','Dezidér Janda','Ľudovít Greššo','Gašpar Arbét ml.','Elena Latečková-Rampáková','Oľga Adamčíková','Eva Mária Chalupová','Karol Jaura','Ján Gubala','Martin Kolesár','Michal Belák','Anton Michalička','Ivan Kauzlarič','Zdeno Flat','Štefan Benek','Ján Kákoni','Magdalena Lokvencová-Husáková','Peter Paška','Ľubomír Dobrovoda','Irma Bárdyová','Eva Kristínová'],
screenplay:['Peter Karvaš','Albert Marenčin','Jiří Krejčík','Peter Karvaš'],
music:['Zdeněk Liška'],
camera:['Rudolf Stahl ml.'],
cut:['Josef Dobřichovský'],
sound:['Jaroslav Plavec'],
scenography:['Karel Škvor'],
masks:['Otakar Košťál','Anton Gendiar'],
costumes:['Erna Veselá','Milena Doskočová']},
{title:'Anton Špelec, ostrostřelec',
titleCZ:'Anton Špelec, ostrostřelec',
year:1932,
runtime:80,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Martin Frič'],
actors:['Vlasta Burian','Růžena Šlemrová','Jaroslav Marvan','Theodor Pištěk','Jindřich Plachta','Jiří Dréman','Ella Nollová','Karel Postranecký','František Kreuzmann st.','Alexander Třebovský','Čeněk Šlégl','Karel Schleichert','Viktor Nejedlý st.','Emanuel Hříbal','Ferdinand Jarkovský','Anči Pírková','Robert Ford','Václav Menger','Jan W. Speerger','Josef Kytka','Antonín Frič','Luigi Hofman','Josef Klapuch','Jindřich Edl','F. X. Mlejnek','Jan Richter','František Říha','Eduard Šlégl','Bohdan Lachman','Josef Sládek','Emil Dlesk','Antonín Volný','Marie Oliaková','Antonín Šolc','Josef Prček'],
screenplay:['Josef Neuberg','Emil Artur Longen'],
music:['Jára Beneš'],
camera:['Otto Heller'],
cut:['Martin Frič'],
sound:['Josef Zora'],
scenography:['Vilém Rittershain'],
costumes:['František Říha']},
{title:'Valentin Dobrotivý',
titleCZ:'Valentin Dobrotivý',
year:1942,
runtime:100,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Martin Frič'],
actors:['Oldřich Nový','Hana Vítová','Milada Gampeová','Ladislav Pešek','Eman Fiala','Jaroslav Marvan','Theodor Pištěk','Zdeňka Baldová','Vojta Novák','Růžena Šlemrová','Lili Hodačová','Jiřina Sedláčková','Jaroslav Průcha','Anna Letenská','Marie Blažková','Bolek Prchal','Karel Černý','Karel Dostal','Miloš Šubrt','Jindřich Láznička','Ota Motyčka','Jan Černý','Meda Valentová','Emanuel Hříbal','Marie Hodrová','Milada Smolíková','Vladimír Řepa','Josef Kemr','Bohuš Záhorský','Blažena Slavíčková','František Paul','Antonín Jirsa','Míla Spazierová-Hezká','Josef Bělský','Vladimír Štros','Jan W. Speerger','Milka Balek-Brodská','Emanuel Kovařík','Josef Hořánek','Karel Roden','Arnošt Mirský','Josef Cikán','Ada Karlovský'],
screenplay:['Karel Steklý','Martin Frič'],
music:['Josef Stelibský'],
camera:['Václav Hanuš'],
cut:['Jan Kohout'],
sound:['Stanislav Vondraš']},
{title:'Three Colors: Blue',
titleCZ:'Tři barvy: Modrá',
year:1993,
runtime:93,
countries:['France','Poland','Switzerland','UK'],
genres:['Drama','Psychology'],
director:['Krzysztof Kieślowski'],
actors:['Juliette Binoche','Benoît Régent','Florence Pernel','Charlotte Véry','Hélène Vincent','Philippe Volter','Claude Duneton','Hugues Quester','Emmanuelle Riva','Florence Vignon','Daniel Martin','Zbigniew Zamachowski','Julie Delpy','Julie Gayet','Yann Trégouët','Pierre Forget','Philippe Morier-Genoud','Arno Chevrier','Idit Cebula','Isabelle Sadoyan','Jacques Disses','Philippe Manesse','Alain Decaux','Jacek Ostaszewski','Stanislas Nordey'],
screenplay:['Krzysztof Kieślowski','Krzysztof Piesiewicz'],
music:['Zbigniew Preisner'],
camera:['Sławomir Idziak'],
cut:['Jacques Witta'],
sound:['Vincent Arnardi','Jean-Claude Laureux'],
masks:['Jean-Pierre Caminade','Valérie Tranier']},
{title:'Shadows of a Hot Summer',
titleCZ:'Stíny horkého léta',
year:1977,
runtime:99,
countries:['Czechoslovakia'],
genres:['Drama','War'],
director:['František Vláčil'],
actors:['Marta Vančurová','Juraj Kukura','Gustáv Valach','Gustav Opočenský','Karel Chromík','Jiří Bartoška','Zdeněk Kutil','Augustín Kubán','Ilja Prachař','Michal Ladižinský','Ľudovít Króner','Jana Hliňáková','Marie Logojdová','Milan Šulc','Steva Maršálek','Václav Kovařík','Robert Lischke','Andrea Kratochvílová','Karel Hovorka st.','Karol Machata','Oldřich Mach','Dagmar Hachová','Jana Postlerová','Peter Kršák','Václav Babka','Marcela Martínková','Eliška Balzerová','Oldřich Velen','Vladimír Jedenáctík'],
screenplay:['Jiří Křižan'],
production:['Jan Balzer'],
music:['Zdeněk Liška'],
camera:['Ivan Šlapeta'],
cut:['Miroslav Hájek'],
sound:['František Fabián'],
scenography:['Oldřich Okáč'],
masks:['František Příhoda'],
costumes:['Theodor Pištěk ml.','Petra Barochová']},
{title:"My Father's Glory",
titleCZ:'Tatínkova sláva',
year:1990,
runtime:105,
countries:['France'],
genres:['Drama','Adventure','Biography'],
director:['Yves Robert'],
actors:['Philippe Caubère','Nathalie Roussel','Didier Pain','Thérèse Liotard','Julien Ciamaca','Victorien Delmare','Joris Molinas','Benoît Martin','Paul Crauchet','Pierre Maguelon','Michel Modo','Jean Rougerie','Jean-Pierre Darras','Victor Garrivier','Raoul Curet','Louis Lalanne','Andrée Damant'],
basedOn:['Marcel Pagnol'],
screenplay:['Jérôme Tonnerre','Yves Robert'],
production:['Alain Poiré'],
music:['Vladimir Cosma'],
camera:['Robert Alazraki','Guillaume Schiffman','Christophe Beaucarne'],
cut:['Pierre Gillette'],
sound:['Alain Sempé','Olivier Villette'],
scenography:['Jacques Dugied']},
{title:'Ballad of Narayama',
titleCZ:'Balada o Narajamě',
year:1983,
runtime:130,
countries:['Japan'],
genres:['Drama'],
director:['Šóhei Imamura'],
actors:['Ken Ogata','Sumiko Sakamoto','Nendži Kobajaši','Norihei Miki','Micuko Baišó','Ben Hiura','Šóiči Ozawa','Nidžiko Kijokawa'],
basedOn:['Shichirô Fukazawa'],
screenplay:['Šóhei Imamura'],
music:["Šin'ičiró Ikebe"],
camera:['Šigeru Komacubara'],
cut:['Tošihiko Kodžima']},
{title:'The Hidden Blade',
titleCZ:'Skryté ostří',
year:2004,
runtime:132,
countries:['Japan'],
genres:['Drama','Romance'],
director:['Jódži Jamada'],
actors:['Masatoši Nagase','Takako Macu','Hidetaka Jošioka','Jukijoši Ozawa','Tomoko Tabata','Čieko Baišó','Ken Ogata','Nendži Kobajaši','Min Tanaka','Reiko Takašima','Tošiki Ajata','Takaši Sasano','Kóen Kondó','Sačiko Micumoto','Kunie Tanaka','Hiroši Kanbe','Masajasu Kitajama','Jódži Macuda','Tokuhisa Jamašita'],
basedOn:['Šúhei Fudžisawa'],
screenplay:['Jódži Jamada','Jošitaka Asama'],
music:['Isao Tomita'],
camera:['Mucuo Naganuma'],
cut:['Iwao Išii'],
costumes:['Kazuko Kurosawa']},
{title:'Uprchlíci',
titleCZ:'Uprchlíci',
year:2016,
runtime:55,
countries:['Czechia'],
genres:['Documentary'],
director:['Tomáš Kratochvíl']},
{title:'The Incredible Shrinking Man',
titleCZ:'Neuvěřitelný zmenšující se muž',
year:1957,
runtime:81,
countries:['USA'],
genres:['Sci-Fi','Thriller','Drama','Horror'],
director:['Jack Arnold'],
actors:['Grant Williams','Randy Stuart','April Kent','Paul Langton','Raymond Bailey','William Schallert','Billy Curtis','Charles Perry','Diana Darrin','Luce Potter','Regis Parton','Perk Lazelle','kocour Orangey','Lock Martin'],
basedOn:['Richard Matheson'],
screenplay:['Richard Matheson','Richard Alan Simmons'],
production:['Albert Zugsmith'],
music:['Hans J. Salter','Herman Stein','Irving Gertz'],
camera:['Ellis W. Carter'],
cut:['Albrecht Joseph'],
sound:['Leslie I. Carey','Robert Pritchard'],
scenography:['Robert Clatworthy','Alexander Golitzen','Russell A. Gausman','Ruby R. Levitt'],
masks:['Bud Westmore'],
costumes:['Jay A. Morley Jr.']},
{title:'Lost Highway',
titleCZ:'Lost Highway',
year:1997,
runtime:135,
countries:['USA','France'],
genres:['Mystery','Thriller','Drama','Crime'],
director:['David Lynch'],
actors:['Bill Pullman','Patricia Arquette','Michael Massee','Robert Blake','Henry Rollins','Mink Stole','Leonard Termo','Balthazar Getty','Guy Siner','Gary Busey','Giovanni Ribisi','Scott Coffey','Natasha Gregson Wagner','Richard Pryor','Robert Loggia','Jack Nance','Lisa Boyle','Leslie Bega','Marilyn Manson','David Lynch','Bill McAdams Jr.','Heather Stephens','Michael Shamus Wiles','Jack Kehler','Greg Travis','Gene Ross','Amanda Anka','F. William Parker','David Byrd','John Solari','John Roselius','Ivory Ocean','Alexander Folk','Lucy Butler','Al Garrett','Jennifer Syme'],
screenplay:['David Lynch','Barry Gifford'],
production:['Mary Sweeney','Tom Sternberg','Deepak Nayar'],
music:['Angelo Badalamenti'],
camera:['Peter Deming'],
cut:['Mary Sweeney'],
sound:['Derek Marcil','Frank Gaeta'],
scenography:['Patricia Norris','Russell J. Smith'],
costumes:['Patricia Norris']},
{title:'The Cuckoo',
titleCZ:'Kukačka',
year:2002,
runtime:99,
countries:['Russia'],
genres:['Drama','War','Comedy'],
director:['Alexandr Rogožkin','Sergej Aljošečkin'],
actors:['Anni-Kristiina Juuso','Ville Haapasalo','Viktor Byčkov','Alexej Kašnikov','Michail Korobočkin','Michail Pšeničnyj','Taťjana Stěblovskaja','Sergej Antonov','Alexandr Mělnikov'],
screenplay:['Alexandr Rogožkin','Nina Vadčenko'],
production:['Sergej Seljanov'],
music:['Dmitrij Pavlov'],
camera:['Andrej Žegalov'],
costumes:['Marina Nikolaeva']},
{title:'Příběh z Tokia',
titleCZ:'Příběh z Tokia',
year:1953,
runtime:136,
countries:['Japan'],
genres:['Drama'],
director:['Jasudžiró Ozu'],
actors:['Čišú Rjú','Čieko Higašijama','Secuko Hara','Haruko Sugimura','Só Jamamura','Kuniko Mijake','Kjóko Kagawa','Tóru Abe','Eidžiró Tóno','Mucuko Sakura','Tojo Takahaši'],
screenplay:['Kógo Noda','Jasudžiró Ozu'],
production:['Takeši Jamamoto'],
music:['Takanobu Saitô'],
camera:['Júharu Acuta']},
{title:'Betrayal and Revenge',
titleCZ:'Zrada a pomsta',
year:1986,
runtime:104,
countries:['China'],
genres:['Action','Drama','History'],
director:['Kangyu Zhou'],
actors:['A-Ping On','Jian Fang','Kang Chin','Hua Yan']},
{title:'Bad Black',
titleCZ:'Bad Black',
year:2016,
runtime:68,
countries:['Uganda'],
genres:['Action'],
director:['Nabwana I.G.G.'],
actors:['Bukenya Charles','Kakule William','Sserunya Ernest','Ssenkugu Swaib','Kavubu Muhammed','Kasumba Isma','Bisaso Dauda'],
screenplay:['Nabwana I.G.G.'],
production:['Nabwana I.G.G.'],
camera:['Nabwana I.G.G.'],
cut:['Nabwana I.G.G.']},
{title:'Talk to Her',
titleCZ:'Mluv s ní',
year:2002,
runtime:112,
countries:['Spain'],
genres:['Drama','Romance','Comedy'],
director:['Pedro Almodóvar'],
actors:['Javier Cámara','Darío Grandinetti','Leonor Watling','Rosario Flores','Geraldine Chaplin','Fele Martínez','Paz Vega','Elena Anaya','Lola Dueñas','Ana Fernández','Chus Lampreave','Loles León','José Sancho','Caetano Veloso','Marisa Paredes','Cecilia Roth','Fernando Guillén Cuervo','Carmen Machi','Regina Advento','Malou Airaudo','Ruth Amarante','Pina Bausch','Rainer Behr','Andrey Berezin','Adolfo Fernández','Javier Conde','Roberto Álvarez','Sonia Grande','Agustín Almodóvar','Esther García','Helio Pedregal','Ismael Martínez','Juan Fernández','Alejandro Tous','Juan Carlos Martínez Antuña','Mariola Fuentes','Jorge Puerta Armenta','Daphnis Kokkinos','Barbara Hampel'],
screenplay:['Pedro Almodóvar'],
music:['Alberto Iglesias'],
camera:['Javier Aguirresarobe'],
cut:['José Salcedo'],
scenography:['Antxón Gómez'],
costumes:['Sonia Grande']},
{title:'The Big Store',
titleCZ:'Velký bazar',
year:1973,
runtime:84,
countries:['France'],
genres:['Comedy'],
director:['Claude Zidi'],
actors:['Gérard Rinaldi','Jean Sarrus','Gérard Filippelli','Jean-Guy Fechner','Michel Galabru','Michel Serrault','Roger Carel','Jacques Seiler','André Badin','Florence Blot','François Cadet','Coluche','Nicole Dubois','Gib Grossac','Pierre Gualdi','Candice Patou','Maurice Travail','Jacques Van Dooren','Claude Boisson','Manu Pluton','Hélène Soubielle'],
screenplay:['Claude Zidi','Georges Beller','Michel Fabre'],
production:['Christian Fechner'],
music:['Les Charlots'],
camera:['Paul Bonis'],
cut:['Monique Isnardon','Robert Isnardon'],
sound:['Alain Lachassagne'],
scenography:['Bernard Evein']},
{title:'Dívka v modrém',
titleCZ:'Dívka v modrém',
year:1939,
runtime:84,
countries:['Czechoslovakia'],
genres:['Comedy','Romance'],
director:['Otakar Vávra'],
actors:['Lída Baarová','Oldřich Nový','Růžena Šlemrová','Sylva Langová','Antonie Nedošinská','Nataša Gollová','Bedřich Veverka','František Paul','František Kreuzmann st.','Jindřich Láznička','Eliška Pleyová','Vladimír Majer','Vladimír Řepa','Josef Bělský','Jiří Vondrovič','Bolek Prchal','Antonín Zacpal','Eman Fiala','Miloš Šubrt','František Hlavatý','Václav Pata','Přemysl Pražský','Jan W. Speerger','Antonín Jirsa','F. X. Mlejnek','Jarmila Holmová','Jindra Hermanová','Alois Dvorský','Václav Mlčkovský','Karel Veverka','Hugo Huška','Jiří Hron','Josef Oliak','Antonín Šolc','Růžena Kurelová','Josef Cikán','Gustav Čech','Jan Černý','František Haller','Bohumil Langer','František Pošta','Věkoslav Satoria','Vladimír Smíchovský','Marie Svobodová','Milena Velíšková','Marie Vildová'],
screenplay:['Otakar Vávra','Oldřich Nový'],
music:['Sláva Eman Nováček'],
camera:['Jan Roth'],
cut:['Antonín Zelenka'],
sound:['František Šindelář'],
scenography:['Jan Zázvorka']},
{title:'The Murderer Hides His Face',
titleCZ:'Vrah skrývá tvář',
year:1966,
runtime:94,
countries:['Czechoslovakia'],
genres:['Crime','Drama'],
director:['Petr Schulhoff'],
actors:['Rudolf Hrušínský','Radoslav Brzobohatý','Jiří Pleskot','Jaroslav Moučka','Zdeněk Kutil','Ferdinand Krůta','Lola Skrbková','Věra Tichánková','František Peterka','Josef Bláha','Lída Roubíková','Jarmila Doležalová','Zuzana Ondrouchová','Jindřich Světnica','Václav Kaňkovský','Miloš Willig','Josef Šebek','Miroslav Plzák','Zdeněk Šňupárek','Helena Růžičková','Jiří Vondrovič','Vincenc Vávra','Vladimír Foukal','Robert Morávek','Jarmila Rašilovová','Oldřich Velen','Karel Pavlík'],
screenplay:['Lubomír Možný','Petr Schulhoff'],
music:['Pavel Blatný'],
camera:['Jiří Vojta'],
cut:['Josef Dobřichovský'],
sound:['Jiří Kejř'],
scenography:['Jan Oliva'],
masks:['Jiří Šimon','František Havlíček'],
costumes:['Marta Bártová']},
{title:'Jánošík I., II.',
titleCZ:'Jánošík I., II.',
year:1963,
runtime:170,
countries:['Czechoslovakia'],
genres:['Adventure','Drama','History'],
director:['Paľo Bielik'],
actors:['František Kuchta','Ctibor Filčík','Dušan Blaškovič','Ondriš Jariabek','Martin Ťapák','Jozef Kroner','Samuel Adamčík','Andrej Bagar','Viliam Záborský','Magdalena Lokvencová-Husáková','František Dibarbora','Eduard Bindas','Karol L. Zachar','Jaroslav Rozsíval','Martin Gregor','Vilma Jamnická','Ján Kramár','Vladimír Černý','Jozef Hanúsek','Elena Latečková-Rampáková','Ján Klimo','Vojtech Brázdovič','Lucia Poppová','Ernest Pauš','Štefan Winkler','Elena Hollá-Holéczyová','Anton Michalička','Milan Jablonský','Juraj Sarvaš'],
screenplay:['Paľo Bielik'],
music:['Tibor Andrašovan'],
camera:['Vladimír Ješina'],
cut:['Maximilián Remeň'],
sound:['Ondrej Polomský'],
scenography:['Ivan Vaníček'],
masks:['Michal Jurkovič','Mária Grandtnerová'],
costumes:['Ľudmila Purkyňová']},
{title:'Krvavé pobřeží',
titleCZ:'Krvavé pobřeží',
year:2009,
runtime:142,
countries:['China'],
genres:['History','Action','Adventure','Drama'],
director:['John Woo'],
actors:['Tony Chiu-wai Leung','Takeši Kaneširo','Fengyi Zhang','Chen Chang','Vicki Zhao','Chiling Lin','Jun Hu','Šidó Nakamura','Jia Song','Kou Shixun','Chun Sun','Ning Wang','Qingxiang Wang','Chao Guo','Yong Hou','Sen Ba'],
screenplay:['Jingzhi Zou','John Woo'],
production:['Terence Chang','John Woo'],
music:['Taró Iwaširo'],
camera:['Yue Lü','Li Zhang'],
cut:['Hongyu Yang'],
sound:['Robert Mackenzie'],
scenography:['Timmy Yip','Eddy Wong'],
costumes:['Timmy Yip']},
{title:'Vidíš měsíc, Danieli',
titleCZ:'Vidíš měsíc, Danieli',
year:2019,
runtime:135,
countries:['Denmark','Norway','Sweden'],
genres:['Drama'],
director:['Niels Arden Oplev','Anders W. Berthelsen'],
actors:['Esben Smed','Toby Kebbell','Anders W. Berthelsen','Sofie Torp','Christiane Gjellerup Koch','Ellaha Lack','Charlie Carrick','Sara Hjort Ditlevsen','Amir El-Masry','Fady Elsayed','Jens Jørn Spottag','Ardalan Esmaili','Rasmus Bjerg','Rafael Pettersson','Thomas Biehl','Elizabeth Moynihan','Ben Roberts','Henrik Birch','Niels Anders Thorn','Susan A. Olsen','Jonas Jörgensen','Mathieu Busson','Lars Lohmann','Margareta Olsson','Peter Sejer Winther','Rodrigo Pozo Vizcarra','Hanna Holmqvist','Thomas Hou Mandsfeldt','Yvonne Andersen','Andrea Heick Gadeberg','Nadeem Srouji','Samuel Brafman-Moutier','Eddie Hallgren','Jimmi Holm Andersen','Mikkel Aarestrup','Arbi Alviati','Rolf Holmgren','Christian Hetland Jepsen'],
basedOn:['Puk Damsgård'],
screenplay:['Anders Thomas Jensen'],
production:['Morten Kaufmann','Signe Leick Jensen'],
music:['Johan Söderqvist'],
camera:['Eric Kress'],
cut:['Lars Therkelsen','Anne Østerud'],
sound:['Bent Holm','Espen Rønning'],
scenography:['Knirke Madelung'],
masks:['Jenny Fred'],
costumes:['Stine Thaning']},
{title:'Grand Prix',
titleCZ:'Grand Prix',
year:2022,
runtime:107,
countries:['Czechia','Slovakia'],
genres:['Comedy','Drama','Road movie'],
director:['Jan Prušinovský'],
actors:['Kryštof Hádek','Robin Ferro','Štěpán Kozub','Anna Kameníková','Miroslav Donutil','Marek Daniel','Tatiana Dyková','Eva Hacurová','Cyril Drozda','Michal Režný','Nikola Janković'],
screenplay:['Jan Prušinovský'],
production:['Jan Prušinovský','Ondřej Zima','Kateřina Ondřejková','Zuzana Mistríková','Ľubica Orechovská'],
music:['Ondřej Sifon Anděra'],
camera:['David Hofmann'],
cut:['Lukáš Opatrný'],
sound:['Matěj Matuška','Michal Čech'],
scenography:['Henrich Boráros'],
masks:['Lukáš Král','Jana Bílková'],
costumes:['Ivan Stekla']},
{title:'Lucky Luke: Ballad of the Daltons',
titleCZ:'Balada o bratrech Daltonových',
year:1978,
runtime:82,
countries:['France'],
genres:['Animation','Comedy','Western'],
director:['René Goscinny','Henri Gruel'],
actors:['Roger Carel','Daniel Ceccaldi','Xavier Depraz','Henri Labussière','Henri Poirier','Pierre Tornade','René Goscinny','Rosy Varte','Henri Virlogeux','Jacques Fabbri','Jacques Legras','Roger Lumont','Gérard Hernandez','Pierre Trabaud','Jean-Marc Thibault','Jacques Morel','Bernard Haller','Georges Atlas','Gisèle Grimm','Éric Kristy','Michel Elias','Jacques Deschamps'],
basedOn:['René Goscinny'],
screenplay:['Pierre Tchernia'],
music:['Claude Bolling'],
sound:['Jean Nény']},
{title:'Brigand Jurko',
titleCZ:'Zbojník Jurko',
year:1976,
runtime:76,
countries:['Czechoslovakia'],
genres:['Animation','Adventure'],
director:['Viktor Kubal'],
actors:['Darina Laščiaková','Ondriš Jariabek'],
music:['Juraj Lexmann'],
sound:['Alexander Pallós']},
{title:'The Proud Princess',
titleCZ:'Pyšná princezna',
year:1952,
runtime:94,
countries:['Czechoslovakia'],
genres:['Fairytale','Comedy','Drama','Family','Romance'],
director:['Bořivoj Zeman'],
actors:['Alena Vránová','Vladimír Ráž','Stanislav Neumann','Mária Sýkorová','Jaroslav Seník','Miloš Kopecký','Oldřich Dědek','Karel Effa','Gustav Heverle','Josef Hlinomaz','Luděk Mandaus','Bohuslav Čáp','Otomar Korbelář','Jarmila Kurandová','Jana Werichová-Kvapilová','Vladimír Bejval','František Hanus','Nita Romaničová','František Kovářík','Terezie Brzková','Branislav Koreň','Miloš Nesvadba','Bohuslav Kupšovský','Rudolf Cortés','Václav Švec','Jaroslav Orlický','Emil Kavan','Josef Hořánek','František Kokejl','Libuše Bokrová','Jiří Zukal','Helena Kotoučová','Zdeněk Mošnička','Miloš Hájek','Josef Oliak'],
basedOn:['Božena Němcová'],
screenplay:['Bořivoj Zeman','Henryk Bloch','Oldřich Kautský'],
music:['Dalibor C. Vačkář'],
camera:['Jan Roth'],
cut:['Josef Dobřichovský'],
sound:['Milan R. Novotný'],
scenography:['Jan Pacák'],
masks:['Ladislav Bacílek'],
costumes:['Jan Kropáček']},
{title:'The Legend of the Pianist on the Ocean',
titleCZ:'Legenda o "1900"',
year:1998,
runtime:120,
countries:['Italy'],
genres:['Drama','Romance','Music'],
director:['Giuseppe Tornatore'],
actors:['Tim Roth','Pruitt Taylor Vince','Mélanie Thierry','Bill Nunn','Peter Vaughan',"Niall O'Brien",'Gabriele Lavia','Alberto Vazquez','Clarence Williams III','Eamon Geoghegan','Nicola Di Pinto','Heathcote Williams','Kevin McNally','Pierluigi Coppola','Femi Elufowoju Jr.','Anita Zagaria','Dmitrij Saranskov','Emanuele Gullotto','Harry Ditson','Cory Buck','John Armstead'],
screenplay:['Giuseppe Tornatore','Alessandro Baricco'],
music:['Ennio Morricone'],
camera:['Lajos Koltai'],
cut:['Massimo Quaglia','Allen Charlton'],
sound:['Tom Johnson'],
scenography:['Francesco Frigeri'],
masks:['Luigi Rocchetti','Giulio Pezza','Alessandro Durante','Aldo Signoretti'],
costumes:['Maurizio Millenotti']},
{title:'Rome, Julie a tmao',
titleCZ:'Romeo, Julie a tma',
year:1997,
runtime:75,
countries:['Czechia'],
genres:['Drama'],
director:['Karel Smyczek'],
actors:['Barbora Seidlová','Tomáš Masopust','Stanislav Zindulka','Oldřich Navrátil','Václav Postránecký','Jiří Strach','Oldřich Vlach','Emma Černá','Otmar Brancuzský','Adam Novák','Zdeněk Pecháček','Jitka Smutná'],
screenplay:['Petr Zikmund'],
music:['Zbyněk Matějů'],
camera:['Vladimír Holomek'],
cut:['Zdenek Patočka']},
{title:'Perfect Blue',
titleCZ:'Perfect Blue',
year:1997,
runtime:81,
countries:['Japan'],
genres:['Animation','Drama','Mystery','Psychology','Thriller'],
director:['Satoši Kon'],
actors:['Rika Macumoto',"Šin'ičiró Miki",'Hidejuki Hori','Šinpači Cudži','Kišó Tanijama','Akio Sujama','Emi Motoi','Jósuke Akimoto','Masaši Ebara','Emi Šinohara','Šiho Niijama','Kijojuki Janada','Joku Šioja','Kaori Minami','Megumi Tano','Osamu Hosoi','Kjósei Cukui','Kóiči Tóčika','Tóru Furusawa','Džunko Iwao','Masaaki Ókura','Aja Hara'],
screenplay:['Sadajuki Murai'],
cut:['Harutoši Ogata'],
sound:['Masafumi Mima'],
scenography:['Nobutaka Ike']},
{title:'The Girl on the Broomstick',
titleCZ:'Dívka na koštěti',
year:1971,
runtime:76,
countries:['Czechoslovakia'],
genres:['Fairytale','Comedy'],
director:['Václav Vorlíček'],
actors:['Petra Černocká','Jan Hrušínský','Jan Kraus','Vlastimil Zavřel','Michal Hejný','Jaromír Spal','Vlastimil Hašek','Vladimír Menšík','František Filipovský','Zdeněk Dítě','Josef Bláha','Jan Libíček','Lubomír Kostelka','Karel Augusta','Karel Houska','Robert Vrchota','Karel Pavlík','Milan Neděla','Jiří Lír','Otto Lackovič','Svatopluk Skládal','Pavel Spálený','František Miroslav Doubrava','Stanislav Litera','Josef Kolb','Meda Valentová','Míla Myslíková','Jana Drbohlavová','Ludmila Píchová','Stella Zázvorková','Běla Jurdová','Miriam Kantorková','Jaroslava Obermaierová','Helena Růžičková','Milan Kindl','Josefa Pechlátová','Roman Skamene','Juraj Štúr','Marie Štrampachová','Jarmila Beránková','Zdena Burdová','Luďa Marešová','Milan Jonáš','Bohumil Koška','Jiří Krytinář','Miloslav Balcar','Jana Boušková','Renée Nachtigallová','Milena Steinmasslová','Marie Bílá','Karel Vítek st.','Vladimír Ptáček','Vítězslav Černý','Stanislav Hájek','Zdeněk Novák','Vít Pešina','Johana Saudková','Ladislav Mrnka','Vladimír Foukal','Jiří Vašků','Miloš Vavruška','Lubor Tokoš','Karel Nikolau','Richard Genzer','Antonín Jedlička','Alena Kreuzmannová','Magdalena Reifová','Dalimil Klapka','Eva Svobodová'],
basedOn:['Hermína Franková'],
screenplay:['Miloš Macourek','Václav Vorlíček'],
music:['Angelo Michajlov'],
camera:['Vladimír Novotný'],
cut:['Miroslav Hájek'],
sound:['Jiří Hora'],
scenography:['Oldřich Bosák'],
masks:['František Malec'],
costumes:['Theodor Pištěk ml.','Marie Knotková']},
{title:'Sledovaní',
titleCZ:'Sledovaní',
year:2022,
runtime:105,
countries:['Sweden'],
genres:['Horror'],
director:['Johannes Persson'],
actors:['Molly Nutley','Joel Lützow','Sofia Kappel','Amanda Lindh','Emelie Rosenstielke','Vincent Grahl','Annica Liljeblad','Mikael Odhag','Emma Suki','Bella Klaus'],
screenplay:['Paolo Vacirca','Henry Stenberg'],
production:['Alexander Eriksson','Joakim Lundell','Paolo Vacirca'],
music:['Oscar Fogelström'],
camera:['Hanna Kriisa'],
cut:['Mattias Håkansson','Johan Serrander'],
masks:['Lina Nyberg'],
costumes:['Sera Cederberg']},
{title:'Signum Laudis',
titleCZ:'Signum laudis',
year:1980,
runtime:85,
countries:['Czechoslovakia'],
genres:['Drama','Psychology','War'],
director:['Martin Hollý ml.'],
actors:['Vlado Müller','Josef Bláha','Ilja Prachař','Radovan Lukavský','Jiří Kodet','Oldřich Velen','Ladislav Frej st.','Pavel Zedníček','Miroslav Zounar','Jan Skopeček','Jiří Zahajský','Vítězslav Jandák','Jan Pohan','Jiří Krampol','Ivan Palúch','Jiří Kodeš','Zdeněk Dušek','Jana Břežková','Rudolf Hrušínský ml.','Jan Kotva','Milan Klacek','Anna Wetlinská','Viktor Maurer','Eva Asterová','Karel Bělohradský','Zdeněk Braunschläger','Jan Cmíral ml.','Miroslav Vladyka','Jan Laibl','Zdeněk Novotný','Ivan Pokorný','Ladislav Dušek','Miloslav Šindler','Milan Tichý-Kohák','Luděk Kopřiva','Jan Kačmáček','Karel Hovorka st.','Pavel Lehotský','Vladimír Navrátil','Vít Pešina','Ludvík Pozník','Rudolf Serina','Arnošt Böhm','Petr Drozda','Karel Engel','Antonín Hausknecht','Josef Hrubý','František Jákl','Vladimír Ježek','Miroslav Jíra','Vladimír Kaisr','Jiří Kalenský','Jaroslav Klenot','Jiří Klenot','Zdeněk Krumpl','Ladislav Lahoda','Pavel Myslík','Otakar Němec','Jindřich Sejk','František Stupka','Jaroslav Šanda','Jaroslav Tomsa','Stanislav Tůma','Jiří Vach','Jaroslav Vlk','Pavel Želízko','Miroslav Nohýnek'],
screenplay:['Vladimír Kalina','Jiří Křižan'],
music:['Zdeněk Liška'],
camera:['František Uldrich'],
cut:['Ivana Kačírková'],
sound:['Alexandr Vrbata'],
scenography:['Jiří Hlupý'],
masks:['Jiří Šimon'],
costumes:['Jan Kropáček']},
{title:'Cesta domů',
titleCZ:'Cesta domů',
year:1978,
runtime:'2x67 min',
countries:['Czechoslovakia'],
genres:['Drama','Psychology'],
director:['Jiří Adamec'],
actors:['Jana Hlaváčová','Vladimír Menšík','Marcel Vašinka','Tomáš Juřička','Petr Haničinec','Ivanka Devátá','Vladislav Beneš','Zuzana Bydžovská','Miroslav Zounar','Milena Dvorská','Vladimír Dlouhý','František Němec','Ladislav Pešek','Jaroslav Moučka','Libuše Havelková','Petr Oliva'],
screenplay:['Otto Zelenka'],
music:['Martin Kratochvíl'],
camera:['Antonín Kovács','Petr Prima'],
cut:['Vítězslav Romanov','Miloslav Liška'],
sound:['Václav Seyček'],
scenography:['František Skřípek'],
masks:['Jitka Pazderová','Vladimír Valter'],
costumes:['Dagmar Březinová']},
{title:'Forbidden Games',
titleCZ:'Zakázané hry',
year:1952,
runtime:86,
countries:['France'],
genres:['Drama','War'],
director:['René Clément'],
actors:['Georges Poujouly','Brigitte Fossey','Amédée','Laurence Badie','Jacques Marin','Madeleine Barbulée','Bernard Musson','Denise Péronne','André Wasley','Suzanne Courtal','Lucien Hubert','Louis Saintève','Marcel Mérovée','Georges Sauval','Janine Zorelli'],
basedOn:['François Boyer'],
screenplay:['René Clément','Jean Aurenche','Pierre Bost','François Boyer'],
production:['Robert Dorfmann'],
music:['Narciso Yepes'],
camera:['Robert Juillard'],
cut:['Roger Dwyre'],
sound:['Jacques Lebreton']},
{title:'Hero',
titleCZ:'Hrdina',
year:2002,
runtime:99,
countries:['China','Hong Kong'],
genres:['Action','Drama','Adventure'],
director:['Yimou Zhang'],
actors:['Jet Li','Tony Chiu-wai Leung','Maggie Cheung','Ziyi Zhang','Daoming Chen','Donnie Yen','Angela Oh','Elizabeth Sung','Tielin Zhang','Xiaoyang Chang','Yan Qin'],
screenplay:['Yimou Zhang','Wang Bin','Feng Li'],
production:['William Kong'],
music:['Tan Dun'],
camera:['Christopher Doyle','Yong Hou'],
cut:['Angie On-Yee Lam','Zhai Ru'],
sound:['Jing Tao','Roger Savage'],
scenography:['Tingxiao Huo','Zhenzhou Yi','Zhong Han'],
masks:['Shudong Yang'],
costumes:['Emi Wada']},
{title:'Akira',
titleCZ:'Akira',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Action','Drama','Mystery','Sci-Fi','Thriller'],
director:['Taika Waititi'],
basedOn:['Kacuhiro Ótomo'],
screenplay:['Taika Waititi','Marco Ramirez'],
production:['Leonardo DiCaprio','Andrew Lazar','Jennifer Davisson'],
scenography:['Ra Vincent']},
{title:"The Poacher's Foster Daughter or Noble Millionaire",
titleCZ:'Pytlákova schovanka aneb Šlechetný milionář',
year:1949,
runtime:117,
countries:['Czechoslovakia'],
genres:['Comedy','Music','Romance'],
director:['Martin Frič'],
actors:['Hana Vítová','Oldřich Nový','Ella Nollová','Otomar Korbelář','Theodor Pištěk','Zdeněk Dítě','Bohumil Machník','Vítězslav Vejražka','Arnold Flögl','František Paul','Marie Blažková','Eman Fiala','Jan W. Speerger','Jarmila Smejkalová','Irena Bernátová','Mirko Erben','Ilona Kubásková','M. Kopalová','Ferdinand Jarkovský','Růžena Lysenková','Felix le Breux','Emanuel Kovařík','Jindřich Doležal','Fanda Mrázek','Jaroslav Mareš','Vladimír Řepa','Mirko Čech','Josef Hořánek','Josef Bělský','Zdeněk Šavrda','Viktor Nejedlý st.','Viktor Očásek','Saša Danešová','Bohuslav Kupšovský','Marie Hodrová','František Voborský','Otto Tutter','Dobroslav Čech','Miroslav Grác','Zdeněk Borovec','Jiřina Bílá','Josef Příhoda','Ota Motyčka','Růžena Jezerská','František Holar','Ludmila Plichtová','Antonín Jirsa','Alena Pospíšilová'],
screenplay:['František Vlček st.'],
music:['Julius Kalaš'],
camera:['Karel Degl'],
cut:['Jan Kohout'],
sound:['Josef Zora'],
scenography:['Karel Škvor'],
masks:['Ladislav Bacílek'],
costumes:['Erna Veselá','Adolf Wenig','Marie Jindrová']},
{title:'Na dno vášně',
titleCZ:'Na dno vášně',
year:1997,
runtime:103,
countries:['Spain','France'],
genres:['Drama','Romance','Thriller'],
director:['Pedro Almodóvar'],
actors:['Javier Bardem','Francesca Neri','Liberto Rabal','Ángela Molina','José Sancho','Penélope Cruz','Pilar Bardem','Álex Angulo','Josep Molins','Mariola Fuentes'],
basedOn:['Ruth Rendell'],
screenplay:['Pedro Almodóvar','Jorge Guerricaechevarría','Ray Loriga'],
music:['Alberto Iglesias'],
camera:['Affonso Beato'],
cut:['José Salcedo'],
sound:['Bernardo Menz','Eduardo Rodriguez'],
scenography:['Antxón Gómez'],
masks:['Juan Pedro Hernández','Fermín Galán'],
costumes:['José María de Cossío']},
{title:'The Hater',
titleCZ:'Místnost sebevrahů. Hater',
year:2020,
runtime:135,
countries:['Poland'],
genres:['Drama','Thriller','Psychology'],
director:['Jan Komasa'],
actors:['Maciej Musiałowski','Vanessa Aleksander','Danuta Stenka','Jacek Koman','Agata Kulesza','Maciej Stuhr','Adam Gradowski','Piotr Biedroń','Jędrzej Wielecki','Jan Hrynkiewicz','Martynika Kośnica','Wiktoria Filus','Iga Krefft','Sebastian Szałaj','Kacper Dykban','Rafał Wasielkiewicz','Piotr Cyrwus','Krystian Redżeb','Rozalia Mierzicka','Katarzyna Strączek','Philippe Chauvin','Gustaw Bafeltowski','Aleksander Dębicz','Jan Napieralski','Krzysztof Nowakowski','Karol Skoczek','Patrycja Wanat','Maria Ruddick','Piotr Sędkowski','Kaja Kozłowska','Iwo Rajski','Matylda Król','Krzysztof Fus','Katarzyna Borowiecka','Tomasz Chrapusta','Mateusz Pacewicz','Julia Wieniawa-Narkiewicz','Katarzyna Bargiełowska','Wiesław Komasa','Rafał Cieluch','Natalia Jesionowska','Ewelina Woźnica','Aleksandra Górska','Łukasz Jakóbiak','Ewa Majcherczyk','Michał Jarmicki','Viet Anh Do'],
screenplay:['Mateusz Pacewicz'],
production:['Jerzy Kapuściński','Wojciech Kabarowski'],
music:['Michał Jacaszek'],
camera:['Radosław Ładczuk'],
cut:['Aleksandra Gowin'],
sound:['Kacper Habisiak','Marcin Kasiński','Jerzy Murawski','Filip Krzemień'],
scenography:['Katarzyna Sobańska','Marcel Sławiński'],
masks:['Aneta Brzozowska'],
costumes:['Małgorzata Zacharska']},
{title:'With Fire and Sword',
titleCZ:'Ohněm a mečem',
year:1999,
runtime:175,
countries:['Poland'],
genres:['Adventure','Drama','War'],
director:['Jerzy Hoffman'],
actors:['Izabella Scorupco','Michał Żebrowski','Alexandr Domogarov','Krzysztof Kowalewski','Bogdan Stupka','Andrzej Seweryn','Zbigniew Zamachowski','Daniel Olbrychski','Wojciech Malajkat','Marek Kondrat','Gustaw Holoubek','Zbigniew Zapasiewicz','Krystyna Feldman','Andrzej Grabowski','Bartosz Obuchowicz','Robert Więckiewicz','Jacek Rozenek','Andrzej Pieczyński','Adam Ferency','Leszek Teleszyński','Ben Talar','Maciej Kozłowski','Joanna Brodzik','Jerzy Bończak','Wiktor Zborowski','Ewa Wiśniewska','Eugeniusz Priwieziencew','Krzysztof Łukaszewicz','Jan Jurewicz','Anna Majcher','Marek Frąckowiak','Rafał Cieszyński','Lech Dyblik','Stefan Szmidt','Jerzy Cnota','Krzysztof Kołbasiuk','Jerzy Karaszkiewicz','Mieczysław Janowski','Andrzej Żółkiewski','Andrzej Grąziewicz','Ryszard Jabłoński','Zdzisław Szymborski','Jerzy Braszka','Czesław Lasota','Tomasz Grochoczyński','Krzysztof Gosztyła','Dariusz Gnatowski','Bernard Ładysz','Andrzej Haliński','Janusz Zerbst','Jerzy Dukay','Andrzej Szczytko','Piotr Komorowski','Michał Konarski','Paweł Kleszcz','Tomasz Konieczny','Dimitrij Mirgorodskij','Ruslana Pysanka','Krystyna Gierłowska','Przemysław Tejkowski','Władysława Gorpienko','Marek Marcinkowski','Adam Warchoł','Anna Teresa Nowak','Aleksander Pociej','Szymon Kobyliński','Włodzimierz Borysiak','Jerzy Kajetan Frykowski','Marek Czyżewski'],
basedOn:['Henryk Sienkiewicz'],
screenplay:['Jerzy Hoffman','Andrzej Krakowski'],
production:['Jerzy R. Michaluk','Jerzy Hoffman'],
music:['Krzesimir Dębski'],
camera:['Grzegorz Kędzierski'],
cut:['Cezary Grzesiuk','Marcin Kot Bastkowski'],
sound:['Piotr Knop','Krzysztof Wodziński'],
scenography:['Andrzej Haliński'],
masks:['Dariusz Krysiak'],
costumes:['Magdalena Tesławska','Paweł Grabarczyk']},
{title:'Kagemuša',
titleCZ:'Kagemuša',
year:1980,
runtime:180,
countries:['Japan'],
genres:['Drama','War'],
director:['Akira Kurosawa'],
actors:['Tacuja Nakadai','Cutomu Jamazaki',"Ken'iči Hagiwara",'Kaori Momoi','Takaši Šimura','Kamatari Fudžiwara','Micuko Baišó','Daisuke Rjú','Hideo Murota','Hidedži Ótaki','Džinpači Nezu','Šú Nakadžima','Kai Ató','Kódži Šimizu','Tošiaki Tanabe'],
screenplay:['Masato Ide','Akira Kurosawa'],
production:['Akira Kurosawa'],
music:["Šin'ičiró Ikebe"],
camera:['Takao Saitó','Šódži Ueda']},
{title:'Once Upon a Time... Life',
titleCZ:'Byl jednou jeden... život',
year:1987,
runtime:'11h 16min',
episodeRuntime:'26min',
countries:['France'],
genres:['Animation','Family'],
director:['Albert Barillé'],
actors:['Roger Carel','Marie-Laure Beneston','Alain Bergé','Gilles Laurent','Henry Djanik','Josef Meinrad','Patrick Préjean','Béatrice Bruno','Thierry Ragueneau','Sady Rebbot','Serge Sauvion','Salah Bensalah','Arnaud Desplechin'],
screenplay:['Albert Barillé'],
music:['Michel Legrand']},
{title:'Caliphate',
titleCZ:'Chalífát',
year:2020,
runtime:'6h 23min',
episodeRuntime:'47-54min',
countries:['Sweden'],
genres:['Thriller'],
director:['Goran Kapetanovic'],
actors:['Gizem Erdogan','Amed Bozan','Aliette Opheim','Nora Rios','Albin Grenholm','Simon Mezher','Lancelot Ncube','Amanda Sohrabi','Said Legue','Yussra El Abdouni','Monica Albornoz','Caisa Ankarsparre','Ali Jalal','Arvin Kananian','Camilla Larsson','Maria Alm Norell','Ala Riani','Shada-Helin Sulhav','Ida Marianne Vassbotn Klasson','Marcus Vögeli','Marga Pettersson','Agnes Fred','Johan Berg','Johan Eriksson','Andreas Gauffin','Alec Fernandez','Isak Isaksson','Marcel Khouri','Robert Luomala','Björn Lönner','Jonatan Qahoush','Nadeem Srouji','Ahmad Srour','Nils Wetterholm','Jana Zeineddine','Ammod Ashkar','Pierre Aussedat','Soheer Bahnam','Nidal Fares','Nicholas Kruger','Shram Rashid','Donatas Šimukauskas','Richard Turpin','Ahmad Al Zoghbi','Dennis Önder','Mohamed El-Treki','Yasmine Seifi','Fikret Çeşmeli','Milan Dragišić','Khalid Geire','Alexander Larsson','Seija Lind','Sara-Maria Lövgren','Saad Abu Nglieh','Hanna Ullerstam','Birthe Wingren','Amer Majed Abdalrazeq','Goran Sako','Mirjam Shokro','Junia Tekie','Alaa Ahmad Al Jabban','Mohammad Hajalouqa','Mohammed Manaseer','Sira Uysal','Ebrahim Yousef','Julia Marko-Nord','Kalled Mustonen','Sara Zommorodi','Sameera Asir','Dennis Azad','Alma Ballot','Habes Hussein','Suzy Jildeh','Nadeem Robert','Ann-Charlotte Franzén','Waleed Jizawi','Louise Ryme','Frida Beckman','Monica Edwardson','Josh Lenn','David Rangborg','Sasan Bagheri','Cankurd Belge','Susan Taslimi'],
screenplay:['Niklas Rockström','Wilhelm Behrman'],
production:['Tomas Michaelsson'],
music:['Sophia Ersson'],
camera:['Jonas Alarik'],
cut:['Malin Lindström','Håkan Wärn'],
sound:['Carl Edström'],
scenography:['Teresa Beale'],
masks:['Jessica Svensson Reijs'],
costumes:['Linn Eklund','Hanadi Khurma']},
{title:'Money Heist (Antena 3 Version)',
titleCZ:'La casa de papel (Antena 3 version)',
year:2017,
runtime:'17h 30min',
episodeRuntime:'70min',
countries:['Spain'],
genres:['Action','Crime','Thriller','Mystery'],
director:['Jesús Colmenar','Alejandro Bazzano','Miguel Ángel Vivas','Alex Rodrigo','Javier Quintas'],
actors:['María Pedraza','Itziar Ituño','Adelfa Calvo','Esther Acebo','Pedro Alonso','Úrsula Corberó','Miguel Herrán','Paco Tous','Enrique Arce','Alejandro Bazzano','Álvaro Morte','Alba Flores','Jaime Lorente','Darko Peric','Juan Fernández','Anna Gras','Mario de la Rosa','Kiti Mánver','Bárbara de Lema','Óscar Zafra','Miquel García Borda','Elisabet Gelabert','Javier Perdiguero','Roberto García Ruiz','Agnès Llobet','Alberto Lobo'],
screenplay:['Álex Pina','Esther Martínez Lobato','Fernando Sancristóval','Javier Gómez Santander','David Barrocal'],
music:['Manel Santisteban','Iván Martínez Lacámara'],
camera:['Migue Amoedo'],
cut:['Verónica Callón','Raquel Marraco','Raúl Mora'],
sound:['José Ignacio Arrufat','Edi Osso-Raimondo'],
scenography:['Fernando González','Abdón Alcañiz'],
costumes:['Rosa Solano']},
{title:'The Road Runner Show',
titleCZ:'The Road Runner Show',
year:1966,
runtime:null,
episodeRuntime:'30min',
countries:['USA'],
genres:['Animation','Family','Comedy'],
director:['Friz Freleng','Rudy Larriva','Robert McKimson','Chuck Jones','Hawley Pratt'],
actors:['Mel Blanc','June Foray','Bea Benaderet','Hal Smith','Paul Julian'],
music:['Carl W. Stalling','William Lava','Walter Greene']},
{title:'Znovu u Spejbla a Hurvínka',
titleCZ:'Znovu u Spejbla a Hurvínka',
year:1974,
runtime:'1h 57min',
episodeRuntime:'9min',
countries:['Czechoslovakia'],
genres:['Puppets','Fairytale','Family','Comedy'],
director:['Libuše Koutná'],
actors:['Miloš Kirschner','Helena Štáchová','Miroslav Černý','Bohuslav Šulc','Miroslav Vomela','Radko Haken','Miroslav Homola','René Hájek'],
screenplay:['Miloš Kirschner','Pavel Grym','Josef Barchánek'],
camera:['Svatopluk Malý']},
{title:'Once Upon a Time... Man',
titleCZ:'Byl jednou jeden... člověk',
year:1978,
runtime:'11h 16min',
episodeRuntime:'26min',
countries:['France'],
genres:['Animation','Family','Adventure'],
director:['Albert Barillé'],
actors:['Albert Barillé','Patrick Préjean','Josef Meinrad','Claude Bertrand','Albert Augier','Jean Roche','Yves Barsacq','Roger Carel','Jean Berger','Annie Balestra','Vincent Ropion','Albert Barillé','William Coryn','Francine Lainé'],
screenplay:['Albert Barillé'],
music:['Michel Legrand']},
{title:'A Town Called Panic',
titleCZ:'Panika v městečku',
year:2002,
runtime:'1h 40min',
episodeRuntime:'5min',
countries:['Belgium'],
genres:['Animation','Comedy'],
director:['Stéphane Aubier','Vincent Patar'],
actors:['Vincent Patar','Benoît Poelvoorde','Stéphane Aubier','John Sparkes','Bouli Lanners','Christian Hecq'],
screenplay:['Stéphane Aubier','Vincent Patar']},
{title:'Wasteland',
titleCZ:'Pustina',
year:2016,
runtime:'7h 32min',
episodeRuntime:'52-60min',
countries:['Czechia'],
genres:['Drama','Mystery'],
director:['Ivan Zachariáš','Alice Nellis'],
actors:['Zuzana Stivínová','Jaroslav Dušek','Eliška Křenková','Leoš Noha','Jan Cina','Štěpán Benoni','Eva Holubová','Oskar Hes','Martin Sitta','Janek Gregor','Petra Špalková','Anita Krausová','Miroslav Vladyka','Ivan Krúpa','Ctirad Götz','Maxmilián Mráz','Oldřich Vlach','Martin Kubačák','Petra Špindlerová','Zdena Hadrbolcová','Jitka Sedláčková','Kateřina Pindejová','Richard Stanke','Tomáš Dastlík','Jan Jankovský','Karel Zima','Petr Vančura','Pavel Šimčík','Roman Skamene','Markéta Krejčová','Petra Navrátilová','Adam Petrlík','Ján Bavala','Mario Pech','Matyáš Svoboda','Štěpán Matejíčka','Dominika Byrtusová','Ivo Bureš','Andrej Polák','Eva Prchalová','Terezie Holá','Adrian Jastraban','Jiří Krejčí','Michaela Doležalová','Kamila Trnková','Jan Komínek','Dušan Čonka','Halina Paseková','Kajetán Písařovic','Karel Davídek','Sebastian Pála','Tomáš Brychta','Magdaléna Gracerová-Chrzová','Kristina Sitková','Lilian Sarah Fischerová','Veronika Malá','Zuzana Čapková','Hana Grančičová','Angelika Morschlová','Martina Černá','Leoš Juráček','Anastasia Chocholatá','Jan Wágner','Petra Ondřejková','Lukáš Typlt','Josef Vokračka','Nikola Orozovič','Štepánka Fingerhutová','Rostislav Novák st.','Miroslav Dvořák','Pavel Rudolf Plasche','Jana Holcová','Daniel Možnar','Hynek Tajovský','Jan Bílek','Bohumír Starý','Petra Johansson','Rudolf Slivka','Viera Pavlíková','Dominik Zakl','David N. Jahn','Jiří Maršál','Martin Uhlíř','Jakub Slach','Marek Dobeš','Milan Aulický','Eliáš Vyskočil','Lenka Rzepková','Maria Pavlovová','Vilma Frantová','Janusz Kaczmarski'],
screenplay:['Štěpán Hulík'],
production:['Tomáš Hrubý','Pavla Janoušková Kubečková','Tereza Polachová','Steve Matthews'],
music:['David Boulter'],
camera:['Štěpán Kučera','Matěj Cibulka'],
cut:['Filip Malásek','Vladimír Barák'],
sound:['Jakub Čech','Pavel Rejholec'],
scenography:['Milan Býček'],
masks:['Milan Vlček','Romana Karlíková','Markéta Pešková'],
costumes:['Simona Rybáková']},
{title:'Fairy-tale at Krkonose Mountains',
titleCZ:'Krkonošské pohádky',
year:1974,
runtime:'3h 20min',
episodeRuntime:'10min',
countries:['Czechoslovakia'],
genres:['Fairytale'],
director:['Věra Jordánová'],
actors:['František Peterka','Ilja Prachař','Zdeněk Řehoř','Hana Maciuchová','Jaroslav Satoranský','Bohuš Záhorský','Martin Růžek'],
basedOn:['Marie Kubátová'],
screenplay:['Božena Šimková'],
music:['Vadim Petrov'],
camera:['František Němec'],
cut:['Jiřina Lukešová'],
sound:['Jiří Hora'],
scenography:['Oldřich Okáč','Vladimír Dvořák'],
masks:['Jiří Šimon','Rudolf Hammer']},
{title:'Major Case Squad',
titleCZ:'Případy 1. oddělení',
year:2014,
runtime:'35h 50min',
episodeRuntime:'53-70min',
countries:['Czechia'],
genres:['Crime'],
director:['Peter Bebjak','Dan Wlodarczyk','Michal Blaško'],
actors:['Ondřej Vetchý','Petr Stach','Filip Blažek','Miroslav Vladyka','Miroslav Hanuš','Bolek Polívka','Ondřej Malý','Sabina Remundová','Petra Hřebíčková','Igor Bareš','Igor Chmela','Juraj Loj','Barbora Bočková','Václav Helšus','Jan Meduna','Lucie Štěpánková','Luboš Veselý','Stanislav Majer','Petr Franěk','Roman Štabrňák','Zuzana Zlatohlávková','Slávek Bílský','Rebeka Lizlerová','Regina Rázlová','Jarmila Vlčková','Radek Holub','Tomáš Kozák','Robert Poláček','Jiří Modranský','Anna Polívková','Jiří Lábus','Josef Mareš','Jiří Král','Stanislav Zindulka','Roman Skamene','Martin Donutil','Jana Šulcová','Martin Sitta','Marek Adamczyk','Adrian Jastraban','Jiří Wohanka','Antonín Hardt','Vladimír Brabec','Jiří Zapletal','Andrej Polák','Josef Kuhn','Renata Podlipská','Braňo Holiček','Jarek Hylebrant','Tomáš Dastlík','Tereza Blažková','Lukáš Melník','Vlasta Peterková','Ladislava Něrgešová','Lukáš Reichl','Gabriela Mikulková','Lenka Zahradnická','Sebastian Jacques','Alena Doláková','Silvester Matula','Jan Plouhar','Gustav Hašek','Jiří Černý','Milan Mikulčík','Šárka Krausová','Radoslav Šopík','Alena Štréblová','Pavla Beretová','Richard Fiala','Lukáš Příkazký','Jana Gýrová','Přemysl Bureš','Predrag Bjelac','Čeněk Koliáš','Kamil Švejda','Jan Novotný','Zdeněk Košata','Jarmil Škvrna','Petr Halberstadt','Libor Kovář','Olga Schmidtová','Petr Lněnička','Aneta Krejčíková','Anna Kameníková','David Máj','Filip Kaňkovský','Michal Gulyáš','Martin Hofmann','Otto Rošetzký','Miroslav Sabadin','Milan Hloušek','Jiří Čapka','Ondřej Lechnýř','Kryštof Nohýnek','Jiří Ployhar ml.','Vojtěch Záveský','Milena Steinmasslová','Radek Kuchař','Radim Jíra','Andrea Daňková'],
screenplay:['Jan Malinda','Josef Mareš'],
production:['Michal Reitler'],
music:['Juraj Dobrakov'],
camera:['Martin Žiaran','Richard Řeřicha','Tomáš Frkal','Martin Rau'],
cut:['Marek Opatrný','Marek Kráľovský','Michal Hýka','Anna Johnson Ryndová'],
sound:['Otto Chlpek','Radim Hladík ml.','Ivo Broum','Robert Slezák','Martin Šulc'],
scenography:['Jan Vlasák','Petr Zeman','Marcel Hána','Petr Synek','Mariana Kuchařová'],
masks:['Kateřina Sittová','Jiří Sadílek','Michaela Kittlerová'],
costumes:['Petra Krčková','Jitka Matiášková','Tatiana Kohoutová','Lucie Šulcová','Helena Tavelová']},
{title:'Bob and Bobby - Top Hat Rabbits',
titleCZ:'Bob a Bobek - králíci z klobouku',
year:1979,
runtime:'4h 33min',
episodeRuntime:'7min',
countries:['Czechoslovakia'],
genres:['Animation','Comedy','Family'],
director:['Václav Bedřich','Miroslav Walter'],
actors:['Josef Dvořák'],
screenplay:['Jiří Šebánek','Vladimír Jiránek','Jaroslav Pacovský'],
music:['Petr Skoumal'],
camera:['Jaroslav Forman','Eva Kargerová','Dana Olejníčková','Zdeněk Kovář'],
cut:['Jiřina Pěčová'],
sound:['Jan Kacián','Benjamin Astrug']},
{title:'The Chosen',
titleCZ:'The Chosen',
year:2017,
runtime:'30h 50min',
episodeRuntime:'20-91min',
countries:['USA'],
genres:['Drama','History'],
director:['Dallas Jenkins','Jacob Schwarz'],
actors:['Jonathan Roumie','Shahar Isaac','Elizabeth Tabish','Paras Patel','Noah James','George H. Xanthis','Nick Shakoour','Lara Silva','Yasmine Al-Bustami','Kirk B.R. Woller','Vanessa Benavente','Erick Avari','Giavani Cairo','Jordan Walker Ross','Joey Vahedi','Yoshi Barrigas','Austin Reed Alleman','Abe Bueno-Jallad','Alaa Safi','Amber Shana Williams','Elijah Alexander','Shayan Sobhian','Luke Dimyan','Aalok Mehta','Nina Leon','Christopher Maleki',"Wasim No'mani",'Lance E. Nichols','Nick Stevenson','Rom Barkhordar','Loren Lester','Jason Liebrecht',"Adetokumboh M'Cormack",'Leticia Magaña','Maz Siam','Stelio Savante','Daniel Ross Owens',"Amato D'Apolito",'Noah Cottrell','Aaron Himelstein','David DeLao','Nyah Marie Johnson','Nene Nwoko','Fabiola Andújar','Sara Anne','Alican Barlas','Jojo Regina','Major Dodge Jr.','Cesar Caolo','Abel Becerra','Madrid St. Angelo','Donato De Luca','Joe DeMonico','Ulysses Montoya','Rett Terrell','Iba Thiam','Alycya Magana','David Amito','Steve Shermett','Oliver Rayon','Kenneisha Thompson','Kelsie Elena','K. Danor Gerald','Brad Schmidt','Amy Bailey','Lee Amir-Cohen','Eric Osmond','Serafin Falcon','Alireza Mirmontazeri','Billy Blair','Gabe Casdorph','Richard Tanner','Sergio Lanza','Marty Lindsey','Matthew Jayson Cwern','Joe Nemmers','Devin Bonnée','Ryan T. Johnson','Marco Khan','Charan Prabhakar','Ric Sarabia','Damon Carney','Michael Steger','Catherine Lidstone','Gys de Villiers','Robb Hudspeth','Niki Spiridakos','Zhaleh Vossough','Andrew James Allen','Sarah J. Bartholomew','Sonya Balmores','Hannah Barefoot','Carson Minniear','Grant Garrison','Maritza Guerrero','Grayson Berry','Frank Licari','Ethan Flower','Moriah','Kedrick Brown'],
screenplay:['Ryan Swanson','Dallas Jenkins','Tyler Thompson'],
production:['Matthew Siemers'],
music:['Matthew S. Nelson','Dan Haseltine','Dallas Jenkins'],
camera:['Akis Konstantakopoulos','Brent Christy','Dallas Jenkins'],
cut:['John Quinn','Adam Lutge'],
sound:['Brad Harper'],
scenography:['James R. Cunningham','Winona Yu','James R. Cunningham'],
masks:['Martina Sykes'],
costumes:['Leila Heise','Pamela Lee Incardona']},
{title:'Death Note - Zápisník smrti',
titleCZ:'Death Note - Zápisník smrti',
year:2006,
runtime:'14h 11min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Drama','Crime','Mystery','Psychology','Thriller'],
director:['Tecuró Araki','Takajuki Hirao','Tomohiko Itó','Rjósuke Nakamura','Micujuki Masuhara','Kei Cunemacu','Hirojuki Cučija','Hideaki Itó','Jukio Okazaki','Tomio Jamauči','Hironori Aojagi','Naojasu Habu','Eiko Niši','Naoto Hašimoto','Šinsaku Sasaki',"Shin'ichi Miyamae"],
actors:['Mamoru Mijano','Aja Hirano','Kazuja Nakai','Šidó Nakamura','Akeno Watanabe','Maaja Sakamoto','Nozomu Sasaki','Hiroši Ótake',"Ken'iči Macujama",'Keidži Fudžiwara','Tomohiro Nišimura','Rjúdži Mizuno','Hirojuki Jokó','Issei Futamata','Kappei Jamaguči','Kazuki Jao','Hideo Išikawa','Čafúrin','Šinpači Cudži','Naoko Macui','Jasunori Masutani','Majuki Makiguči','Rjóko Ono','Naoja Učida','Masaki Aizawa','Tecuo Sakaguči','Kijoši Kobajaši','Kacuhisa Hóki','Ami Košimizu','Jukitoši Tokumoto','Takeši Morija','Kijojuki Janada','Rino Marimo','Noriko Hidaka','Umeka Šódži','Kóta Nemoto','Čieko Sasai','Takafumi Kawakami','Tecuo Gotó','Kazuja Kobajaši','Šigeo Kijama','Hiromu Kondó','Motoi Kojanagi','Kensuke Niši','Šónosuke Horikoši','Aiko Aihaši','Tomoja Kawai','Kazuma Takeo','Fudžita Daisuke','Masaru Suzuki','Rjó Agawa','Tošio Kobajaši','Daisuke Sugaja','Taiči Masu','Takeši Mori','Júdži Kimura','Kanako Kondó','Sadao Nunome','Mimi Tamaki','Kristie Marsden','Sajaka Hata'],
basedOn:['Takeši Obata','Cugumi Óba'],
screenplay:['Tomohiko Itó','Šódži Jonemura','Jasuko Kobajaši','Tošiki Inoue'],
production:['Masao Marujama','Tošio Nakatani'],
music:['Jošihisa Hirano','Hideki Taniuči'],
camera:['Kazuhiro Jamada'],
cut:['Aja Hida'],
sound:['Čiaki Jamada'],
scenography:['Mio Iššiki']},
{title:'Česká soda',
titleCZ:'Česká soda',
year:1993,
runtime:'4h 38min',
episodeRuntime:'10-29min',
countries:['Czechia'],
genres:['Comedy'],
director:['Milan Šteindler','Václav Křístek','Fero Fenič','Jan Hřebejk','Petr Čtvrtníček','Igor Chaun','Ján Sebechlebský','Petr Zelenka','Tereza Kopáčová'],
actors:['Petr Čtvrtníček','Milan Šteindler','David Vávra','Veronika Žilková','Vlastimil Zavřel','Jaromír Dulava','Pavel Bobek','Karel Dobrý','Petr Vacek','Luděk Sobota','Bára Štěpánová','Jitka Sedláčková','Bohumil Klepl','Vlado Štancel','Miroslava Babůrková','Karel Meister ml.','Aleš Najbrt','David Nykl','Sylva Tománková','Jiří Maria Sieber','Miroslav Noga','Štefan Skrúcaný','Zdeněk Srstka','Mirko Musil','Otakar Brousek st.','Michal Pavlata','Petra Špalková','Tomáš Hanák','Dana Hábová','Miroslav Moravec','Jitka Lebišová','Petr Svoboda','Jiří Bábek','Renáta Kubišová','Zdeněk Pecháček','Jan Hřebejk','Viktorie Kafková','Igor Chaun','Richard Honzovič','Jiří Lábus','Vladimír Barák','Milan Uhde','Miroslav Moravec','Leoš Suchařípa','Oldřich Vízner','Robert Záruba','Josef Vinklář','Jaroslav Švagr'],
screenplay:['Dominik Miškovský','Petr Čtvrtníček','Igor Chaun','Vlado Štancel','Robert Geisler','Tomáš Hanák','Milan Šteindler','David Vávra','Ján Sebechlebský','Jan Hřebejk','Tereza Kopáčová','Bohumil Klepl','David Nykl','Petr Zelenka','Jan Drbohlav','David Černý','Vladimír Barák'],
music:['Josef Spal'],
camera:['Antonín Holub','Martin Duba','Miroslav Čvorsjuk','Jan Velický','Dominik Miškovský','Pravoslav Flak','Miro Gábor','Alexander Šurkala','Jan Malíř','Bohumír Bouček','Jiří Krejčík ml.'],
cut:['Věra Flaková','Šárka Němcová','Vladimír Barák'],
sound:['Michal Holubec','Vlastimil Brávek','Jiří Bartoš','Jan Čeněk','Miroslav Šimčík'],
scenography:['Štefan Theisz'],
costumes:['Pavla Tajerová']},
{title:'Zahrada',
titleCZ:'Zahrada',
year:1974,
runtime:'1h 14min',
episodeRuntime:'14-17min',
countries:['Czechoslovakia'],
genres:['Animation','Puppets','Comedy','Family'],
director:['Břetislav Pojar'],
actors:['Bohuš Záhorský','František Filipovský','Pavlína Filipovská','Iva Janžurová','Jiřina Jirásková','Růžena Merunková','Vlastimil Brodský','Lubomír Lipský st.','Zdeněk Řehoř','Stella Zázvorková','Martin Růžek'],
basedOn:['Jiří Trnka'],
music:['Jiří Kolafa'],
camera:['Vladimír Malík'],
cut:['Věra Benešová','Jitka Kavalierová'],
sound:['Benjamin Astrug']},
{title:'Nineties',
titleCZ:'Devadesátky',
year:2022,
runtime:'7h 2min',
episodeRuntime:'64-78min',
countries:['Czechia'],
genres:['Crime'],
director:['Peter Bebjak'],
actors:['Martin Finger','Ondřej Sokol','Kryštof Bartoš','Vasil Fridrich','Robert Mikluš','Patricie Pagáčová','Kateřina Marešová','Jan Kolařík','Igor Orozovič','Matouš Ruml','Viktor Zavadil','Štepánka Fingerhutová','Martin Stránský','Pavel Batěk','Bořek Slezáček','Daniel Margolius','Michal Novotný','David Šír','Jakub Štáfek','Martin Davídek','Albert Čuba','Richard Němec','Tomáš Kobr','Tomáš Turek','Zdeněk Stadtherr','Veronika Petrová','Pavel Konvalina','Andrei Toader','Václav Pavlík','Josef Mareš','Anna Bazgerová','Klára Miklasová','Miroslav Čáslavka','Radek Polák','Daniela Bakerová','Irena Neradová','Tomáš Karab','Hynek Chmelař','Stanislav Lehký','Johana Nováčková','Daniel Rous','Jaroslav Hanzal','Jiří Stracený','Jana Provázková','Karel Jirák','Michael Aleš Bucifal','Luboš Balog','Tomáš Mrvík','Anna Marie Myšičková','Tomáš Sagher','Kateřina Hájková','Jan Jankovský','Taťána Havlová','Martin Hruška','Jan Janča','Ivo Novák','Václav Hoskovec','Milan Enčev','Tomáš Kolomazník','Roman Slovák','Lukáš Franc','Božena Osvaldová','Michaela Matějovská','Marta Falvey Sovová','Radoslav Bejček','Ivan Jonák','Filip Minařík','Aneta Červená','Jaroslav Tomáš','Libor Jeník','Martin Kraus','Ivo Chládek','Štefan Capko','Terezie Vraspírová','Vendula Křížová','Martin Navrátil','Lucie Ingrová','Patrik Plešinger','Jan Vápeník','Vlastimil Fridrich','Petra Kocmanová','Aneta Bačíková','Vladimír Železný','Miloš Zeman','Václav Havel','Jiří Křižan','Michal Stejskal','Matyáš Řezníček','Matej Landl','František Strnad','František Večeřa','Miroslav Navrátil','Stanislav Hyžík','Gabriela Štefanová','Václav Liška','Petra Kosková','René Šmotek','Vojtěch Babišta','Igor Budykin','Sára Milfajtová'],
screenplay:['Josef Mareš','Matěj Podzimek'],
production:['Michal Reitler'],
music:['Juraj Dobrakov'],
camera:['Martin Žiaran'],
cut:['Marek Kráľovský'],
sound:['Ivo Broum'],
scenography:['Henrich Boráros'],
masks:['Martin Větrovec','Dana Kleňhová','Martin Valeš','Jiřina Kozlová'],
costumes:['Jitka Matiášková','Andrea Králová']},
{title:'Fauda',
titleCZ:'Fauda',
year:2015,
runtime:'32h 52min',
episodeRuntime:'32-53min',
countries:['Israel'],
genres:['Action','Drama','Thriller'],
director:['Assaf Bernstein','Rotem Shamir','Omri Givon'],
actors:['Lior Raz','Tsahi Halevi','Samer Bisharat','Neta Garty','Yaara Benben','Doraid Liddawi','Laëtitia Eïdo','Johnny Arbid','Salim Daw','Tomer Capone','Yaakov Zada Daniel','Shani Atias',"Rona-Lee Shim'on",'Hisham Suliman','Shadi Mar´i','Itzik Cohen','Moshe Zonder','Yuval Segal','Hanan Hillo','Boaz Konforty','Doron Ben-David','Rajai Samduca','Mouna Hawa','Khawlah Hag-Debsy','Yarin Bargita','Mel Malka','Ibrahim Saqallah','Meital Berdah','Uri Gavriel','Majd Bitar','Milad Matar','Carlos Gharzuzi','Neta Shermeister','Muhammad Albaz','Rahik Sliman','Nadine Cabub','Adiv Sfadi','Rida Sliman','Mohamed Naama','Jameel Khoury','Qader Harini','Ghassan Ashkar','Dorin Kario','Hilal Kaboub','Yochai Ben Yitzhak','Mussa Zhalka','Mahmoud More','Firas Nassar',"Jig'al Na'or",'Abdallah El Akal','Rotem Keinan','Luna Mansour','Nadav Nir','Henry Andrawes','Amir Khoury','Imad Mari','Idan Amedi','Moran Rosenblatt','Avi Vardi','Muhamed Salama','Meirav Shirom','Raida Adon','Hadas Reinwald','Muatisam Masalha','Jalal Masrwa','Samira Saraya','Jonathan Avigdori','Fares Hananya','Edan Moses','Ala Dakka','Khalifa Natour','Assaf Cohen','Yafit Josephson','George Iskandar','Marina Maximilian Blumin','Nahd Bashir','Anat Hadid','Samar Qupty'],
screenplay:['Assaf Beiser','Michal Aviram','Leora Kamenetzky','Moshe Zonder','Amir Mann','Noah Stollman','Lior Raz','Avi Issacharoff','Yuval Yefet'],
production:['Maria Feldman','Liat Benasuly'],
music:['Gilad Benamram'],
camera:['Nitai Netzer','Moshe Mishali'],
cut:['Danny Rafic','Omri Zalmona','Boaz Mann'],
sound:['Aviv Aldema','Marco Augusto Comba'],
scenography:['Eyal Biterman'],
masks:['Maya Grastal'],
costumes:['Chen Carmi-Blair']},
{title:'Money Heist (Netflix Version)',
titleCZ:'Papírový dům (Netflix verze)',
year:2017,
runtime:'38h 55min',
episodeRuntime:'41-76min',
countries:['Spain'],
genres:['Action','Crime','Thriller','Mystery'],
director:['Jesús Colmenar','Miguel Ángel Vivas','Koldo Serra','Alejandro Bazzano','Alex Rodrigo','Javier Quintas'],
actors:['Álvaro Morte','Úrsula Corberó','Alba Flores','Itziar Ituño','Jaime Lorente','Miguel Herrán','Darko Peric','Paco Tous','Esther Acebo','Pedro Alonso','María Pedraza','Roberto García Ruiz','Enrique Arce','Anna Gras','Barbara Goodson','Hovik Keuchkerian','Rodrigo De la Serna','Najwa Nimri','Fernando Cayo','Mario de la Rosa','Diana Gomez','Chacha Huang','Ana Iglesias','Jesús Lloveras','Luka Peros','Pep Munné','Deborah Guerrero','Joaquín Gómez','Belén Cuesta','Rafael Rojas','Susi Sánchez','Alejandro Bazzano','Enrique Asenjo','Antonio Romero','Neymar da Silva Santos Júnior','Federico Pérez Rey','Irene Molina','Mari Carmen Sánchez','Chema Ruiz','Juan Fernández','Toni Salgado','Clara Alvarado','Miquel García Borda','Javier Perdiguero','Fernando Soto','Adelfa Calvo','Fran Morcillo','Pep Tosar','Bárbara de Lema','Mikel Bustamante','Ramón Agirre','José Manuel Seda','Patrick Criado','Miguel Ángel Silvestre','Roman Rymar','Gonzalo Bouza','Florencia Nocetti','José Manuel Poga','Alberto Amarilla','Maarten Dannenberg','Irene Anula','Alberto Lobo','Oğulcan Güzeller','Ajay Jethi','Olalla Hernández'],
screenplay:['Esther Martínez Lobato','Álex Pina','Luis Moya','Javier Gómez Santander','Emilio Díez','David Barrocal'],
music:['Manel Santisteban','Iván Martínez Lacámara'],
camera:['Migue Amoedo','Sergi Bartrolí','David Azcano'],
cut:['Raúl Mora','Regino Hernández'],
scenography:['Fernando González','Abdón Alcañiz'],
masks:['Saray Rodríguez','Eva Martínez'],
costumes:['Carlos Díez','Rosa Solano']},
{title:'Bluey',
titleCZ:'Blue',
year:2018,
runtime:'18h 40min',
episodeRuntime:'7-28min',
countries:['Australia','UK'],
genres:['Animation','Family'],
director:['Richard Jeffery','Joe Brumm'],
actors:['David McCormack','Melanie Zanetti','Charlotte Nicdao','Bishanyia Vincent','Joe Brumm','Joff Bush','Sam Moor','Dan Brumm','Charlie Aspinwall','Eva Mendes','Jane Hall','Ian McFadyen'],
screenplay:['Joe Brumm'],
production:['Sam Moor'],
music:['Joff Bush','Ack Kinmonth','Luna Pan'],
cut:['Michael Griffin','Josef Switak','Courtney Teixera','David Peterson','Siobhan Finniss','Anthony Pham'],
sound:['Dan Brumm'],
scenography:['Costa Kassab','Trudi Monteath','Rafferty Amor','Catriona Drummond','Faith Chen']},
{title:'Maxipes Fík',
titleCZ:'Maxipes Fík',
year:1976,
runtime:'1h 27min',
episodeRuntime:'6-7min',
countries:['Czechoslovakia'],
genres:['Animation','Comedy','Family'],
director:['Václav Bedřich'],
actors:['Josef Dvořák'],
basedOn:['Rudolf Čechura'],
screenplay:['Rudolf Čechura'],
music:['Petr Skoumal'],
camera:['Jaroslav Forman','Dana Olejníčková'],
cut:['Jiřina Pěčová','Zdenka Navrátilová'],
sound:['Benjamin Astrug']},
{title:'Fairy Tales from Moss and Fern',
titleCZ:'Pohádky z mechu a kapradí',
year:1968,
runtime:'5h 12min',
episodeRuntime:'8min',
countries:['Czechoslovakia'],
genres:['Animation','Fairytale'],
director:['Zdeněk Smetana'],
actors:['Jiřina Bohdalová'],
basedOn:['Václav Čtvrtek'],
screenplay:['Anna Jurásková'],
music:['Jaroslav Celba'],
camera:['Zdenka Hajdová','Jaroslav Forman','Eva Kargerová','Jaroslava Zimová'],
cut:['Zdenka Navrátilová'],
sound:['Benjamin Astrug']},
{title:'Haikyu!!',
titleCZ:'Haikjú!!',
year:2014,
runtime:null,
episodeRuntime:'2014-2020',
countries:['Japan'],
genres:['Animation','Comedy','Sport'],
director:['Susumu Micunaka','Masako Sató','Hiromiči Matano','Takaši Andó','Pyeon-Gang Ho','Hirotaka Mori','Hitomi Ezoe','Tomoko Hiramuki','Šintaró Itoga','Jasuo Edžima','Hirotaka Endó','Takatoši Suzuki','Tecuaki Watanabe','Rokó Ogiwara','Taizó Jošida','Šinsaku Sasaki'],
actors:['Ajumu Murase','Kaito Išikawa','Satoši Hino','Miju Irino','Daisuke Namikawa','Hiroši Kamija','Nobuhiko Okamoto','Júki Kadži',"Šin'ičiró Miki",'Šinnosuke Tačibana','Kazunari Tanaka','Kóki Učijama','Tomoaki Maeno','Hiroši Naka','Júiči Nakamura','Tošiki Masuda','Jošimasa Hosoja','Ai Kakuma','Misako Tomioka','Rjóta Takeuči','Hirojuki Jošino','Ken Takeuči','Sóma Saitó','Kijotaka Furušima','Kanami Sató','Micuaki Hošino','Takaši Óhara','Kaori Nazuka','Nobuaki Fukuda','Rjóta Ósaka','Kanehira Jamamoto','Džundži Madžima','Takanori Hošino','Rjóhei Kimura','Seiró Ogino','Hiromi Igaraši','Nobujori Sagara','Isamu Júsen','Makoto Furukawa','Šúhei Sakaguči',"Džun'ja Enoki",'Tóru Sakurai','Kazutomi Jamamoto','Takuja Sató','Jui Šódži','Kengo Kawaniši','Kótaró Nišijama','Rie Suegara','Šintaró Óhata','Mika Takašita','Misuzu Togaši','Eidži Takemoto','Jukitoši Tokumoto','Šunsuke Takeuči','Kóhei Fukuhara','Haruki Išija','Čihiro Suzuki','Micuru Ogata','Hiroši Cučida','Ajumi Fudžimura','Sumire Morohoši','Hisafumi Oda','Jamato Kindžó','Šótaró Morikubo','Juka Komacu','Hisajoši Suganuma','Eidži Hanawa','Šunzó Mijasaka','Ajako Takeuči','Jó Taiči','Šóta Jamamoto','Takuja Eguči','Šiho Kokido','Jasuaki Takumi','Hisao Egawa','Subaru Kimura','Rjúsei Nakao','Tošijuki Tojonaga','Takuma Terašima','Kendži Fukuda','Terujuki Tanzawa','Akane Fudžita','Šója Čiba','Tomojo Takajanagi','Takamasa Mogi','Jošiki Nakadžima','Eidži Takeuči','Masatomo Nakazawa','Taiši Murata','Acuši Tamaru','Takeo Ócuka','Šimba Cučija','Džunta Terašima','Nacuki Hanae','Šóma Jamamoto','Júto Uemura','Mamoru Mijano','Džun Kasama','Kósuke Toriumi','Nobunaga Šimazaki'],
basedOn:['Haruiči Furudate'],
screenplay:['Tošimicu Takeuči','Taku Kišimoto','Takuja Sató','Susumu Micunaka'],
production:['Fumi Morihiro','Masaja Šinozaki','Jošihiro Furusawa','Masaki Fudžita','Tomojuki Saitó','Hiró Marujama','Tošihiro Maeda'],
music:['Júki Hajaši','Asami Tačibana'],
camera:['Jumiko Nakata'],
cut:["Džun'iči Uemacu"],
sound:['Hiromi Kikuta'],
scenography:['Ičiró Tacuta']},
{title:'Attack on Titan',
titleCZ:'Šingeki no kjodžin',
year:2013,
runtime:'36h 45min',
episodeRuntime:'23-85min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy','Horror'],
director:['Tecuró Araki','Jošijuki Fudžiwara','Šinpei Ezaki','Tacuma Minamikawa','Masaši Koizuka','Júičiró Hajaši','Takaši Andó','Jasuhiro Geši','Hirojuki Tanaka','Daisuke Tokudo','Jasuhiro Akamacu','Kazujoši Katajama','Džun Šišido','Macuo Asami','Jasuši Muroja','Micue Jamazaki','Kazuo Mijake','Hitomi Ezoe','Keisuke Óniši','Ken Andó','Tomoko Hiramuki','Šintaró Itoga','Naoki Macuura','Hirokazu Jamada','Šingo Učida','Kunihiro Mori','Kendži Takahaši','Hidetoši Takahaši','Jóko Kanamori','Aiko Sakuraba'],
actors:['Romi Paku','Akeno Watanabe','Susumu Čiba','Unšó Išizuka','Hiroši Kamija','Júki Kadži','Juiči Karasuma','Tomokazu Sugita','Kódži Jusa','Minami Takajama','Hideaki Tezuka','Jú Kobajaši','Marina Inoue','Saki Fudžita','Kišó Tanijama','Jošimasa Hosoja','Anri Kacu','Megumi Sató','Rjóta Takeuči','Kenta Mijake','Šindži Kawada','Akio Sujama','Asami Šimoda','Tomojuki Šimura','Kóiči Sakaguči','Tomohisa Asó','Jošino Ótori','Masahiko Tanaka','Rintaró Niši','Cuguo Mogami','Rjóta Ósaka','Masaki Terasoma','Kenta Ókuma','Masaharu Sató','Šúhei Takubo','Takanori Hošino','Jošihito Sasaki','Nobujori Sagara','Júja Murakami','Rjóta Asari','Hiroki Maeda','Čika Anzai','Daisuke Ono','Jui Išikawa','Ikumi Hajama','Šiori Mikami','Tomohisa Hašizume','Jú Šimamura','Mijuki Kobori','Nacuki Aikawa','Kazuhiro Fusegawa','Šintaró Óhata','Hiroši Cučida','Jošino Takamori','Gó Šinomija','Nana Hamasaki','Sajaka Senbongi','Acumi Tanezaki','Hiro Šimono','Risa Šimizu','Hiroši Naka','Tecu Inada','Tóru Sakurai','Keidži Fudžiwara','Júki Sanpei','Kacunori Okai','Masaja Macukaze','Júmi Kawašima','Ajumu Murase','Tošiki Masuda','Manami Numakura','Ajane Sakura','Nacuki Hanae','Takehito Kojasu','Marina Inoue','Tóru Nara',"Kijomicu Mizu'uči",'Seiró Ogino','Naomi Kusumi','Jasuhiro Mamija','Kunpei Sakamoto','Kazuhiro Jamadži','Kazuhiko Inoue','Kódži Išii','Mamiko Noto','Takahiro Sumi','Takumu Mijazono','Noriaki Kanze','Masaja Fukuniši','Júki Šin','Kenšó Ono','Micuki Saiga','Eidži Hanawa','Džunko Iwao','Tasuku Hatanaka','Masaaki Ihara','Šógo Sakata','Kendži Hamada','Daiki Jamašita','Tomo Sakurai'],
basedOn:['Hadžime Isajama'],
screenplay:['Jasuko Kobajaši','Noboru Takagi','Hiroši Seko'],
production:['Kacudži Morišita','Tošihiro Maeda','Hitoši Itó','Hitoši Macumoto','Makoto Kimura'],
music:['Hirojuki Sawano','Kóta Jamamoto'],
camera:['Šigeteru Asakawa','Kazuhiro Jamada'],
cut:['Aja Hida','Masato Jošitake'],
sound:['Masafumi Mima'],
scenography:['Kazuo Ogura',"Šun'ičiró Jošihara",'Kuniaki Nemoto']},
{title:'Na návštěvě u Spejbla a Hurvínka',
titleCZ:'Na návštěvě u Spejbla a Hurvínka',
year:1972,
runtime:'1h 44min',
episodeRuntime:'8min',
countries:['Czechoslovakia'],
genres:['Puppets','Fairytale','Family','Comedy'],
director:['Libuše Koutná'],
actors:['Miloš Kirschner','Helena Štáchová'],
screenplay:['Jiří Kubíček']},
{title:'The Bugs Bunny/Road Runner Hour',
titleCZ:'The Bugs Bunny/Road Runner Hour',
year:1968,
runtime:null,
episodeRuntime:'26x50min',
countries:['USA'],
genres:['Animation','Family','Comedy'],
director:['Maurice Noble','Friz Freleng','Rudy Larriva','Robert McKimson','Chuck Jones','Hawley Pratt'],
actors:['Mel Blanc','Daws Butler','June Foray','Jim Backus','Bea Benaderet','Hal Smith'],
production:['William L. Hendricks']},
{title:'A Bit of Fry and Laurie',
titleCZ:'A Bit of Fry and Laurie',
year:1987,
runtime:'13h 5min',
episodeRuntime:'30-35min',
countries:['UK'],
genres:['Comedy'],
director:['Bob Spiers','Peter Orton'],
actors:['Stephen Fry','Hugh Laurie','Kevin McNally','Morwenna Banks','Benjamin Whitrow','Camille Coduri','Rowan Atkinson','Maria Aitken','Clive Mantle','Selina Cadell','Stephen Moore','Dimitri Andreas','Carol MacReady','Andy Linden','Liz Smith','Harriet Thorpe','Ralph Michael','Paul Whitehouse','Rowland Rivron','Robert Daws','Janine Duvitski','Geoffrey McGivern','Aimée Delamain','Daniel Thorndike','Georgia Allen','Rebecca Saire','John Grillo','Jane Booker','Jacqueline Boatswain','Anne Charleston','Nimmy March','Tony Hawks','Philip Pope','Cliff Parisi'],
screenplay:['Stephen Fry','Hugh Laurie'],
production:['Jon Plowman'],
music:['Hugh Laurie'],
scenography:['Paul Munting','Steve Keogh','Stephen Sharratt'],
costumes:['Sarah Burns','Lyn Avery']},
{title:'Taková normální rodinka',
titleCZ:'Taková normální rodinka',
year:1971,
runtime:'6h 17min',
episodeRuntime:'36-55min',
countries:['Czechoslovakia'],
genres:['Comedy','Family'],
director:['Jaroslav Dudek'],
actors:['Marie Rosůlková','Dana Medřická','Zdeněk Řehoř','Jana Štěpánková','Eduard Cupák','Daniela Kolářová','Jaromír Hanzlík','Jiřina Šejbalová','Jiřina Bohdalová','Oldřich Nový','Jaroslav Moučka','Vítězslav Černý','Jiří Hybš','Václav Hybš','Pavel Landovský'],
screenplay:['Fan Vavřincová'],
music:['Luboš Fišer'],
camera:['Jindřich Novotný']},
{title:'Mach and Šebestová',
titleCZ:'Mach a Šebestová',
year:1976,
runtime:'1h 47min',
episodeRuntime:'7-9min',
countries:['Czechoslovakia'],
genres:['Animation','Comedy','Family'],
director:['Adolf Born','Jaroslav Doubrava','Miloš Macourek'],
actors:['Petr Nárožný'],
basedOn:['Miloš Macourek'],
screenplay:['Adolf Born','Jaroslav Doubrava','Miloš Macourek'],
production:['Jiří Šebestík'],
music:['Luboš Fišer'],
camera:['Zdenka Hajdová','Emil Strakoň','Jaroslav Forman','Jaroslava Zimová','Eva Kargerová'],
cut:['Marta Látalová','Gaia Vítková'],
sound:['Pavel Jelínek','František Černý']},
{title:'There Were Five of Us',
titleCZ:'Bylo nás pět',
year:1994,
runtime:'6h 2min',
episodeRuntime:'60-61min',
countries:['Czechia'],
genres:['Comedy'],
director:['Karel Smyczek'],
actors:['Adam Novák','Jaroslav Pauer','Jan Müller','Štěpán Benyovszký','Jan Brynych','Sandra Nováková','Dagmar Havlová','Oldřich Navrátil','Jakub Hladík','Jiří Strach','Barbora Srncová','Gabriela Wilhelmová','Valentina Thielová','Lenka Termerová','Ljuba Krbová','Naďa Konvalinková','Jiřina Jirásková','Jana Kimlová','Marie Durnová','Nela Boudová','Jana Altmannová','Pavel Zedníček','Oldřich Vízner','Bohumil Vávra','Václav Vydra nejml.','Ondřej Vetchý','Michal Suchánek','Karel Smyczek','Josef Šebek','Raoul Schránil','Václav Postránecký','Jiří Pecha','Petr Nárožný','Jiří Datel Novotný','Miroslav Moravec','Jiří Langmajer','Otto Lackovič','Rostislav Kuba','Lubomír Kostelka','Vladimír Javorský','Ladislav Gerendáš','Petr Brukner','Michal Pospíšil','Stanislav Zindulka','Jan Hraběta','Jan Bonaventura','Jiří Kodeš','Jiří Němeček','Josef Žluťák Hrubý','Bořík Procházka','Bořivoj Penc','Josef Kubíček','Otto Rošetzký','Zdeněk Vronský','Antonín Bubeník','Petr Hanus','Roman Hemala','Ludmila Zábršová-Molínová','Peter Kršák','Kateřina Daňková','Alexander Hemala','Jaroslav Satoranský','Lukáš Rumlena','Michal Kozelka','Vojtěch Oulický','Jiří Nový','Pavel Hejný','Karel Čáslavský','Petr Smyczek','Jana Radojčičová','Karolína Sochorová'],
basedOn:['Karel Poláček'],
screenplay:['Ondřej Vogeltanz'],
music:['Petr Hapka'],
camera:['Martin Šec'],
cut:['Zdenek Patočka'],
sound:['Vladimír Skall'],
scenography:['Jiří Hlupý'],
masks:['Jiří Farkaš','Eva Ungrová-Malíková'],
costumes:['Jaroslava Veselá','Jiřina Eisenhamerová','Marta Kaplerová']},
{title:'Byli jednou dva písaři',
titleCZ:'Byli jednou dva písaři',
year:1972,
runtime:'7h 34min',
episodeRuntime:'38-50min',
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Ján Roháč'],
actors:['Otakar Brousek st.','Jiří Sovák','Miroslav Horníček','Jan Libíček','Jaroslav Moučka','Věra Tichánková','Libuše Havelková','Soběslav Sejk','Klára Jerneková','Věra Ferbasová','Josefa Pechlátová','Jiří Patočka','Josef Kemr','Milica Kolofíková','Josef Engel','Eugen Jegorov','Jiří Hrzán','Josef Somr','Miroslav Kalný','Jiří Hálek','Karel Augusta','Jiří Bruder','Zdeněk Hodr','Stanislav Junek','Václav Lohniský','Darja Hajská','Josef A. Stehlík','Miloš Čálek','Vladimír Hlavatý','Eva Svobodová','Věra Uzelacová','Stanislav Juna','Josef Dvořák','Josef Kořán','Vratislav Hlavatý'],
basedOn:['Gustave Flaubert'],
screenplay:['Jaroslav Dietl','Jiří Sovák','Miroslav Horníček'],
music:['Jiří Šust'],
camera:['Jiří Lebeda'],
cut:['Dana Lukešová'],
sound:['Miloslav Hůrka'],
masks:['František Čížek'],
costumes:['Veronika Pulchartová','Ester Krumbachová']},
{title:'Adventure of Criminalistics',
titleCZ:'Dobrodružství kriminalistiky',
year:1989,
runtime:'21h 36min',
episodeRuntime:'49-52min',
countries:['Czechoslovakia','Germany','France'],
genres:['Crime','Drama','Adventure','History'],
director:['Antonín Moskalyk'],
actors:['Boris Rösner','Petr Kostka','Ladislav Mrkvička','Ondřej Havelka','Vlasta Fabianová','Nelly Gaierová','Ladislav Frej st.','Daniela Kolářová','Luděk Munzar','Ivan Trojan','Lubomír Lipský st.','Viktor Preiss','Dušan Blaškovič','Pavel Rímský','Miloš Vávra','Jozef Husár','Martin Růžek','Simona Stašová','Rudolf Hrušínský ml.','Jan Teplý st.','Petr Čtvrtníček','Jaroslav Rava','Valerie Kaplanová','Rudolf Stärz','Václav Knop','Blažena Holišová','Kamil Halbich','Marcela Peňázová','Steva Maršálek','Ivan Řezáč','Jaroslava Tichá','Michal Dlouhý','Josef Vinklář','Jana Gýrová','Horst Frank','Gabriela Wilhelmová','René Přibil','Vendula Křížová','Radoslav Brzobohatý','Miroslav Moravec','Barbora Srncová','Marek Vašut','Ladislav Potměšil','Jaroslava Obermaierová','Miroslav Táborský','Tomáš Töpfer','Jiří Klem','Stanislav Tříska','Jan Bonaventura','Klaus J. Behrendt','Jaroslava Adamová','Pavel Skřípal','Valérie Zawadská','Ladislav Trojan','Jiří Schmitzer','Petr Pelzer','Pavol Mikulík','Zdeněk Řehoř','Josef Langmiler','Viktor Maurer','Tereza Pergnerová','Jan Vágner','Kamil Prachař','Marek Eben','Jiří Wohanka','Jiřina Jelenská','Bronislav Poloczek','Karel Heřmánek','Jiří Holý','Václav Postránecký','Taťjana Medvecká','Bohumil Švarc st.','Otto Lackovič','Dáša Neblechová','Antonín Hardt','Josef Štefl','Pavel Pípal','Marie Marešová','Vítězslav Jirsák','Rudolf Pellar','Jan Novotný','Zdeněk Dolanský','Andrej Hryc','Karel Urbánek','Gustav Opočenský','Petr Oliva','Miloslav Mejzlík','Vladimír Kratina','Vojtěch Ron','Bohumil Vávra','Vladimír Krška','Jan Schmid','Hugo Kaminský','Gaston Šubert','Tomáš Jirman','Karel Bělohradský','Rudolf Jelínek','Adolf Filip','Ladislav Kazda','Emil Konečný'],
screenplay:['Antonín Moskalyk','Jan Šikl','Pavlína Moskalyková'],
music:['Karel Svoboda'],
camera:['Juraj Šajmovič'],
cut:['Ivana Davidová'],
sound:['Jan Kacián','Josef Bartoš'],
scenography:['Milan Starý','Zdeněk Flemming'],
masks:['František Čížek','Stanislav Petřek'],
costumes:['Libuše Pražáková','Pavla Tajerová','Katarína Hollá']},
{title:'Skam',
titleCZ:'Skam',
year:2015,
runtime:'19h 1min',
episodeRuntime:'14-50min',
countries:['Norway'],
genres:['Drama'],
director:['Julie Andem'],
actors:['Josefine Frida Pettersen','Iman Meskini','Lisa Teige','Tarjei Sandvik Moe','Ulrikke Falch','Marlon Valdés Langeland','Ina Svenningdal','Thomas Hayes','Herman Tømmeraas','Henrik Holm','Liv-Anne Trulsrud','Marit Synnøve Berg','Kristina Ødegaard','Cecilie Martinsen','Justina Diekontaite','Johan Ratvik','Laura Maria Therese Aniksdal','Laila Gatonye','Elias Selhi','Gry Antonie Øverby','Fredrik Aure','Joakim Reinskou','Harald Mork Aune','Erik Alexander Malm Lien','Ines Høysæter Asserson','Vilde Lindhjem','Astrid Arefjord','Sebastian Andersen','Celine Nordheim','Jakob Steine','Markus Askevold','Linn Wellerop','Helene Moltzau Søgård','Rumen Rainov Ivelinov','David Stakston','Matias Dahl','Eskil Hisdal','August Damm','Mathias Walmann','Nicolas Africanus Gjefle','Ada Eide','Asgeir Alvestad Skogseth','Alfred Ekker Strande','Shaun A. Nguema','Petter Martinussen','Carl Martin Eggesbø','Rakel Øfsti Nesje','Nadia Hassan','Axel Onshuus','Arne Vangild','Nadim Lahlahi','Baard Røthe','Sondre Opedal','Julian Lara Asperheim','Henriette Espmarker','Selma Ibrahim Karlsen','Marcus Piippo','Arthur Hakalahti','Volkan Doğan','Fredrik Vildgren','Dennis Orlien','Ruben Gran','Astrid S','Marius Borg Høiby','Viktoria Eikeland','Maja Zachariassen Lay','Sacha Kleber Nyiligira','Ruby Dagnall','Theresa Frostad Eggesbø','Mikkel Maanum','Christine Brita Mortvedt Johnsen','Sigyn Åsa Sætereng','Thea Marie Øverkil','Emilie Nikolaysen','Åshild Dybwad','Nora Krog','Tinka Havnen Amundsen','Vilde Marie Eid','Andrea Paulsen Råstad','Thea Christiansen','Helene Marie Alvim','Kristine Vestby Holstad','Mari Straume Ramberg','Jakob Benito','Marius Hofstad','Hanna Alise Møller','Tomas Nilsen','Ragna Nordenborg','Christine Lossius Thorin','Lise Bang Brandtmar','Marianne Furevold-Boland','Nils Bech','Terje Ragnes','Yousef Hjelde el Mofty','Simo Mohamed Elhbabi','Sherin Wahab','Cengiz Al','Adam Ezzari','Mutasim Ahmed','Amalie Blom Aarnes'],
screenplay:['Julie Andem'],
production:['Marianne Furevold-Boland'],
music:['Christian Wibe'],
camera:['Daniel McStay','Ragnar Molstad','Maja Holand'],
cut:['Alec Thom','Renate Henrikhaugen','Ida Vennerød Kolstø','Stian Kjørstad Zethelius'],
sound:['Vidar Kleivane','Aljoša Ertl','Wenche Holmgren Ødegaard','Marcel Janssen','Hilde Heyerdahl','Jens Mathias Falkenberg','Morten Kristoffersen','Viðar Hákon Gíslason','Øystein Eide','Oda Dimmestøl','Betina Nielsen'],
scenography:['Kathrin Bjørnstad'],
masks:['Susanna Alicia Taylor'],
costumes:['Susanna Alicia Taylor']},
{title:'Well, Just You Wait!',
titleCZ:'Jen počkej...!',
year:1969,
runtime:'3h 19min',
episodeRuntime:'9-11min',
countries:['Russia','Russia'],
genres:['Animation','Comedy','Family'],
director:['Vjačeslav Koťonočkin','Vladimir Tarasov','Alexej Koťonočkin'],
actors:['Anatolij Papanov','Klara Rumjanova','Igor Christěnko','Olga Zvereva'],
screenplay:['Alexandr Kurljandskij','Arkadij Chajt','Felix Kamov'],
music:['Vladimir Vysockij','Alexandr Zacepin','Gennadij Gladkov','Viktor Babuškin','Andrej Děržavin'],
camera:['Jelena Petrova','Svetlana Kaščejeva','Nina Klimova','Alexandr Čechovskij'],
scenography:['Darja Brežněva']},
{title:'Sňatky z rozumu',
titleCZ:'Sňatky z rozumu',
year:1968,
runtime:'7h 44min',
episodeRuntime:'89-97min',
countries:['Czechoslovakia'],
genres:['Drama','History'],
director:['František Filip'],
actors:['Jiří Vala','Slávka Budínová','Vladimír Ráž','Gabriela Vránová','Jiřina Jirásková','Iva Janžurová','Miloš Nedbal','Jiřina Šejbalová','Jaroslav Vojta','Nataša Gollová','Jan Skopeček','Světla Svozilová','Blažena Holišová','Václav Voska','Jaroslav Moučka','Radovan Lukavský','Miroslav Doležal','Dana Medřická','Vladimír Menšík','Eduard Cupák','Zdeněk Řehoř','Jiřina Štěpničková','Ladislav Pešek','Daniela Kolářová','Jana Gýrová','Stanislav Remunda','Vladimír Brabec','Rudolf Hrušínský','Ota Sklenčka','Miroslav Macháček','František Husák','Karolina Slunéčková','Vlasta Jelínková','Marie Rosůlková','Petr Kostka','Jiří Sýkora','Eduard Dubský','Jaroslava Adamová','Svatopluk Beneš','Marta Kučírková','Josef Vinklář','Vladimír Krška','Luba Skořepová','Miloš Willig','Jiří Zahajský','Mirko Musil','Jaroslav Raušer','Jaromír Spal','Otomar Krejča ml.','Otto Šimánek','Karel Pavlík','Otto Budín','Bohumil Švarc st.','Josef Patočka','Zdeněk Dítě','Jiří Pleskot','Jaroslav Mareš','Karel Hlušička','Jan Pohan','Oldřich Janovský','Vlastimil Hašek','Libuše Váchalová','Otto Kinský','Karel Hábl','Miloš Rozhoň','Zdeněk Týle','Ladislav Navrátil','Felix Černý','Rudolf Kalina','Naďa Karochová','Olga Světelská','Miloš Vavruška','Karel Hovorka st.','Josef Mráz','Vladimír Bičík','Václav Voska'],
basedOn:['Vladimír Neff'],
screenplay:['Otto Zelenka'],
music:['Karel Sklenička'],
camera:['Vladimír Opletal'],
cut:['Karel Kohout'],
sound:['Miloš Alster'],
scenography:['Karel Lier'],
masks:['Anežka Kunová'],
costumes:['Lída Novotná']},
{title:'Džudžucu kaisen',
titleCZ:'Džudžucu kaisen',
year:2020,
runtime:'23h 36min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Horror'],
director:['Song-hu Park','Rjú Nakajama','Tomomi Kamija','Daisuke Cukuši','Šóta Gošozono','Kakuši Ifuku','Hirojuki Kitakubo','Masato Nakasono','Takahiro Šikama','Kazuto Arai','Takao Abo','Hakuju Go','Eri Osada'],
actors:['Júiči Nakamura',"Džun'ja Enoki",'Júma Učida','Asami Seto',"Džun'iči Suwabe",'Kendžiró Cuda','Kóki Učijama','Mikako Komacu','Tomokazu Seki','Šigeru Čiba','Marija Ise','Jošiki Nakadžima','Kendži Sugimura','Šóhei Kadžikawa','Takahiro Sumi','Takaja Kuroda','Micuo Iwata','Takahiro Sakurai','Aja Endó','Saori Hajami','Acuko Tanaka','Kendži Fukuda','Nobunaga Šimazaki','Daiči Hajaši','Subaru Kimura','Mugihito','Činacu Akasaki','Tomojo Kurosawa','Jošitaka Jamaja','Marina Inoue','Tecuo Kanao','Sacumi Macuda','Hiromiči Tezuka','Takamasa Mogi','Džunko Noda','Ajaka Fukuhara','Hijori Nitta','Jóko Hikasa','Satoši Hino','Rie Kugimija','Jošicugu Macuoka','Kotono Micuiši','Džódži Nakata','Akiha Macui','Momoko Taneiči','Masaja Fukuniši','Jú Hajaši','Šúhei Macuda','Šinnosuke Ogami','Júki Inoue',"Šun'iči Maki",'Kappei Jamaguči','Nobujuki Hijama','Daisuke Namikawa','Júdži Murai','Takuja Nakašima','Masato Niwa','Kozue Saitó','Kowaka Wakana','Naoko Komacu','Genta Nakamura','Ikuto Kanemasa','Džunko Oka','Júgo Sekiguči','Secudži Sató','Aja Nakamura','Juiči Karasuma','Jurianne Eve','Nao Fudžita','Reina Aojama','Arisa Sakuraba','Čihiro Ueda','Džoičiró Jošida','Kósuke Gotó','Juki Ominami','Júki Kazu','Akira Harada','Jú Hatori','Hidetaka Tendžin','Hyang-Lee Kim','Aki Nagao','Akina Abe','Saori Suzumija','Anna Nagase','Takehito Kojasu','Takahiro Jošino','Risa Šimizu','Hiroki Jasumoto','Kazuki Kjan','Jukitoši Tokumoto','Mirei Kumagai','Naoki Bandó','Seijú Fudžiwara','Jae Sakura','Čijuki Miura','Saja Horigome','Seina Kató','Hana Hišikawa','Mijú Ogura','Tomohiro Jamaguči'],
basedOn:['Gege Akutami'],
screenplay:['Hiroši Seko'],
production:['Tošihiro Maeda','Makoto Kimura','Hiroaki Macutani'],
music:['Jošimasa Terui','Arisa Okehazama','Hiroaki Cucumi'],
camera:['Teppei Itó'],
cut:['Keisuke Janagi'],
sound:['Akiko Fudžita','Jasunori Ebina'],
scenography:['Jeong-Ryeon Kim',"Džun'iči Higaši"]},
{title:'Divoké sny Maxipsa Fíka',
titleCZ:'Divoké sny Maxipsa Fíka',
year:1983,
runtime:'1h 47min',
episodeRuntime:'8-9min',
countries:['Czechoslovakia'],
genres:['Animation','Comedy','Family'],
director:['Václav Bedřich'],
actors:['Josef Dvořák'],
basedOn:['Rudolf Čechura'],
screenplay:['Rudolf Čechura','Václav Bedřich'],
music:['Petr Skoumal'],
camera:['Jaroslav Forman'],
cut:['Jiřina Pěčová'],
sound:['Benjamin Astrug']},
{title:'Chainsaw Man',
titleCZ:'Chainsaw Man',
year:2022,
runtime:'4h 49min',
episodeRuntime:'24-25min',
countries:['Japan'],
genres:['Animation','Action','Adventure'],
director:['Rjú Nakajama','Tacuja Jošihara','Tomomi Kamija','Šun Enokido','Šóta Gošozono','Tóko Jatabe','Masato Nakasono','Riki Matsuura'],
actors:['Toja Kikunosuke','Tomori Kusunoki','Šógo Sakata','Ai Fairouz','Šiori Izawa','Marija Ise','Karin Takahaši','Taku Jaširo','Kendžiró Cuda','Maaja Učida','Nacuki Hanae','Júja Učida','Saori Gotó','Jó Taiči','Daiki Hamano','Hinata Tadokoro','Hiroki Macukawa',"Ken'iči Mine",'Kóki Mijata','Kósei Hirota','Marina Inoue','Micutoši Šundó','Takahiro Hirai','Takaši Uezumija','Takuja Nakašima','Júki Sanpei','Haruo Sató','Sakuma Motoki','Takehiro Hasu','Jamato Kindžó','Jošihito Sasaki','Júki Tamai',"Ken'ičiró Macuda",'Kóiči Sóma','Norijuki Cujuki','Saki Kobari','Satoši Jamaguči','Takeši Hirabajaši','Júki Onodera','Džóko Kawagiši','Júko Tačibana','Júko Kaida','Ajumu Murase','Eri Saitó','Hironori Kondó','Mana Nakatomi','Jódži Ueda','Masao Komaja','Kozue Saitó','Jú Sasahara','Čikahiro Kobajaši','Sacuki Kokubu','Tadaši Mutó','Cujoši Kurosawa','Júko Ueda','Hiroko Kiso','Taiki Jamašita','Kengo Kawaniši','Hitomi Ueda','Ajano Hamaguči','Daiki Kadžimoto','Rjúiči Hirose','Šó Okumura','Takajuki Išii','Takumu Mijazono','Júsaku Hijama','Sara Macumoto','Hiroki Aiba','Takaši Macujama','Do Song','Micuki Nakamura','Šitan En','Kósuke Óniši','Hajato Fudžii','Reina Ueda',"Šin'ja Takahaši",'Hiroki'],
basedOn:['Tacuki Fudžimoto'],
screenplay:['Hiroši Seko'],
music:['Kensuke Ušio'],
camera:['Teppei Itó'],
cut:['Masato Jošitake'],
sound:['Kisuke Koizumi'],
scenography:['Júsuke Takeda']},
{title:'American Crime Story',
titleCZ:'American Crime Story',
year:2016,
runtime:'24h 48min',
episodeRuntime:'42-66min',
countries:['USA'],
genres:['Crime','Drama','Biography'],
director:['Ryan Murphy','Anthony Hemingway','John Singleton','Nelson Cragg','Gwyneth Horder-Payton','Daniel Minahan','Matt Bomer','Michael Uppendahl','Laure de Clermont-Tonnerre','Rachel Morrison'],
actors:['Cuba Gooding Jr.','Sarah Paulson','Darren Criss','John Travolta','Courtney B. Vance','Penélope Cruz','Selma Blair','David Schwimmer','Édgar Ramírez','Sterling K. Brown','Ricky Martin','Connie Britton','Jordana Brewster','Kenneth Choi','Angie Patterson','Chris Bauer','Ken Lerner','Joanna Adler','Michael McGrady','Stina Lundberg','Bruce Greenwood','Nathan Lane','Billy Magnussen','Ron Roggé','Keesha Sharp','Ashlee Füss','Billy Dec','Dale Godboldo','Arriane Alexander','Romy Rosemont','Christian Clemenson','Garrett M. Brown','Cheryl Ladd','Steven Pasquale','Leonard Roberts','Malcolm-Jamal Warner','Christiann Castellanos','Ethan Flower','China Jesusita Shavers','Kwame Patterson','Michael Nardelli','Sam Sarpong','Evan Handler','Larry King','Rob Morrow','Nick Baga','Kelly Pendygraft','Joseph Siravo','Susan Beaubian','Patrick Labyorteaux','Bonita Friedericy','Iris Almario','Suzanne Gutierrez','Rick Otto','Dijon Talton','Kevin Scott Allen','Nelson Cragg','Tyler Poelle','Vincent M. Biscione','Megan Kathleen Duffy','Robert Morse','Judith McConnell','Tracy Fraim','Andrew Patrick Ralston','Marguerite Moreau','Daniel Robbins','Ricky Harris','Jessica Blair Herman','Rick Chambers','Rio Hackford','Jessica J. Stowes','Cocoa Brown','Tom Beyer','Roger Rignack','Greg Collins','Rocky McMurray','India Dupré','Laura Vallejo','Amiée Conn','Nikki Howard','Alma Martinez','Tayler Buck','Finn Wittrock','Max Greenfield','Nico Evers-Swindell','Annaleigh Ashford','Paul Hansen Kim','Walter Addison','Angel Parker','Luke Albright','Will Chase','Brett Edwards','Mike Farrell','Jay R. Ferguson','Cody Fern','Christine Horne','Judith Light','Charles Maceo','Cathy Moriarty','Dascha Polanco'],
basedOn:['Jeffrey Toobin'],
screenplay:['Scott Alexander','Larry Karaszewski','D.V. DeVincentis','Maya Forbes','Wallace Wolodarsky','Joe Robert Cole','Tom Rob Smith','Sarah Burgess','Flora Birnbaum','Halley Feiffer','Daniel Pearle','Maggie Cohn'],
production:['Alexis Martin Woodall','Chip Vucelich','John Travolta','Lou Eyrich','Eryn Krueger Mekash','Eric Kovtun','Flora Birnbaum','Halley Feiffer','Beanie Feldstein','Todd Nenninger','Tanase Popa','Louise Shore','Sara Stelwagen','Monica Lewinsky','Maggie Cohn'],
music:['Mac Quayle'],
camera:['Nelson Cragg','Simon Dennis'],
cut:['Adam Penn','Chi Yoon Chung','Emily Greene','Shelly Westerman','Danielle Wang','Shannon Baker Davis','Michael Griffin','Chris A. Peterson','Franzis Muller'],
sound:['Joe Earle','Gary Megregian','Doug Andham','Gabriel J. Serrano'],
scenography:['Richard Sherman','Judy Becker','Jamie Walker McCall','Amber Haley','Jeffrey Mossa','Carol Uraneck','Florencia Martin','Adam Rowe','Robert Gould'],
masks:['Ana Lozano','David LeRoy Anderson','Eryn Krueger Mekash','Zoe Hay','Karen Lynn Accattato','Justin Raleigh','Massimo Gattabrusi','Reilly Bastian','Sterfon Demings','Darlene Brumfield','Chris Clark','Shutchai Tym Buacharern'],
costumes:['Lou Eyrich','Allison Leach','Meredith Markworth-Pollack']},
{title:'Saturnin',
titleCZ:'Saturnin',
year:1994,
runtime:'2h 34min',
episodeRuntime:'37-40min',
countries:['Czechia'],
genres:['Comedy'],
director:['Jiří Věrčák'],
actors:['Ondřej Havelka','Oldřich Vízner','Lucie Zedníčková','Jana Synková','Petr Vacek','Lubomír Lipský st.','Milan Lasica','Dalimil Klapka','Jan Laibl','Jiří Bruder','Blanka Vikusová','Jitka Molavcová','Vítězslav Bouchner','Ladislav Gerendáš','Ota Jirák','Valérie Zawadská','Jaromír Dulava','Miroslav Kořínek','Emil Křížek','Roman Hemala','Josef Šebek','Romana Sittová'],
basedOn:['Zdeněk Jirotka'],
screenplay:['Magdalena Wagnerová','Jiří Věrčák'],
production:['Jan Milič'],
music:['Josef Spitzer'],
camera:['Josef Špelda'],
cut:['Zdenek Patočka'],
sound:['Jan Kacián','Josef Bartoš'],
scenography:['Michael Krška'],
masks:['Jiřina Pahlerová'],
costumes:['Ivana Brádková','Pavla Tajerová']},
{title:"Dr. Horrible's Sing-Along Blog",
titleCZ:"Dr. Horrible's Sing-Along Blog",
year:2008,
runtime:null,
episodeRuntime:'40min',
countries:['USA'],
genres:['Musical','Sci-Fi','Comedy'],
director:['Joss Whedon'],
actors:['Neil Patrick Harris','Nathan Fillion','Simon Helberg','Felicia Day','Drew Goddard','Jed Whedon','Marti Noxon','Steve Berg','David Fury','Douglas Petrie','Richard Partlow','Athena Demos','Rob Reinis'],
screenplay:['Joss Whedon','Jed Whedon','Zack Whedon','Maurissa Tancharoen'],
cut:['Lisa Lassek'],
scenography:['Sandy Struth'],
costumes:['Shawna Trpcic']},
{title:'Mushoku Tensei: Jobless Reincarnation',
titleCZ:'Mušoku tensei: Isekai ittara honki dasu',
year:2021,
runtime:'19h 13min',
episodeRuntime:'23-24min',
countries:['Japan'],
genres:['Animation','Fantasy'],
director:['Manabu Okamoto','Hiroki Hirano','Jošinobu Tokumoto','Tacujuki Nagai','Kacuja Šigehara','Fumiaki Kataoka','Šingo Fudžii','Mičiru Itabisaši','Jošicugu Kimura','Nobujoši Arai','Ajako Kóno','Rjósuke Šibuja','Tomohiko Itó'],
actors:['Jumi Učijama','Ai Kakuma','Ai Kajano','Konomi Kohara','Daisuke Namikawa','Hisako Kanemoto','Tomokazu Sugita','Tošijuki Morikawa','Lynn','Hiroki Maeda','Ajaka Nanase','Júki Takada','Džun Fukušima','Megumi Tojoguči','Daisuke Ono','Šóta Jamamoto','Juka Nukui','Rjóka Juzuki','Binbin Takaoka','Nobuo Tobita','Aoi Ičikawa','Júki Hirose',"Džun'iči Janagita",'Kendžiró Cuda','Rikija Kojama','Kengo Kawaniši','Juka Iguči','Júsuke Kobajaši','Satomi Sató','Kudžira','Ajaka Asai','Jó Taiči','Kaito Takeda','Rie Tanaka','Hóčú Ócuka','Ikudži Nose','Šóta Hajama','Šion Wakajama','Hironori Saitó','Šinnosuke Ogami','Reigo Jamaguči','Rjó Sugisaki','Mai Murakami','Minami Maju','Rie Kawamura','Kazumasa Nakamura','Maaja Torigoe','Makoto Kaneko','Masajuki Kató','Rjúnosuke Watanuki','Saja Aizawa','Hajato Fudžii','Kaori Nakamura','Júki Išikari','Šin Macušige','Eidži Takeuči',"Šun'iči Maki",'Ajaka Šimizu','Šinpači Cudži','Daiki Hamano','Satoši Inomata','Šiori Izawa','Hajato Kimura','Momo Išibaši','Moeka Kišimoto','Masaši Jamane','Kósuke Katajama','Miku Itó','Akira Koga','Kenta Sasa','Makoto Kóiči','Makoto Sahara','Masaaki Mizunaka','Taisuke Nakano','Taketora','Kotomi Aihara','Jódži Ueda','Ken Mizukoši','Rjóko Maekawa','Sajumi Watabe','Sóširó Hori','Jú Wakabajaši','Takuja Kodama','Juna Jošino','Rikuja Jasuda','Jasuhiro Kikuči','Aimi Tanaka','Mari Hino','Misato Macuoka','Jú Sasahara','Fúka Izumi','Keisuke Hamaoka','Tomo Muranaka','Nacumi Hioka','Satoši Curuoka','Šógo Sakata','Reina Ueda','Kóiči Sóma','Kazujuki Okicu','Hana Sató'],
basedOn:['Rifudžin na Magnote'],
screenplay:['Manabu Okamoto','Hiroki Hirano','Acuši Takajama','Muneo Nakamoto','Rifudžin na Magnote','Tošija Óno','Kóhei Urušihara'],
production:['Nobuhiro Ósawa','Takahiro Jamanaka','Tomojuki Ówada'],
music:['Jošiaki Fudžisawa'],
camera:['Šindži Tonšo'],
cut:['Akinori Mišima'],
sound:['Džin Aketagawa'],
scenography:['Masakazu Mijake','Hiroši Góroku']},
{title:"Hey, Mister, let's play",
titleCZ:'Pojďte pane,budeme si hrát',
year:1965,
runtime:'2h 38min',
episodeRuntime:'12-19min',
countries:['Czechoslovakia'],
genres:['Animation','Comedy','Family'],
director:['Břetislav Pojar','Miroslav Štěpánek'],
actors:['Rudolf Deyl ml.','František Filipovský','Naďa Urbánková'],
music:['Wiliam Bukový','Jiří Kolafa'],
camera:['Vladimír Malík'],
cut:['Helena Lebdušková','Jitka Kavalierová'],
sound:['Benjamin Astrug']},
{title:"Genndy Tartakovsky's Primal",
titleCZ:"Genndy Tartakovsky's Primal",
year:2019,
runtime:'7h 9min',
episodeRuntime:'19-22min',
countries:['USA'],
genres:['Animation','Action','Adventure'],
director:['Genndy Tartakovsky'],
actors:['Tom Kenny','Jon Olson','Laëtitia Eïdo','Fred Tatasciore','Noah Kaye Bentley','Imari Williams','Ike Amadi','Aaron LaPlante','Jacob Dudman','Giles Matthey','Jeremy Crutchley','MyAnna Buring','Adam Fergus','Stefan Johnson','Dave Fennoy','Darin De Paul'],
screenplay:['Darrick Bachman','Genndy Tartakovsky','David Krentz','Mark Andrews','Bryan Andrews','Don Shank'],
production:['Shareena Carlson'],
music:['Tyler Bates','Joanne Higginbottom'],
cut:['Paul Douglas'],
sound:['Timothy J. Borquez','Tony Orozco','Nick Gotten III','Alex Borquez','Joel Valentine'],
scenography:['Scott Wills']},
{title:'Trailer Park Boys',
titleCZ:'Trailer Park Boys',
year:2001,
runtime:'43h 32min',
episodeRuntime:'22-32min',
countries:['Canada'],
genres:['Comedy','Crime'],
director:['Mike Clattenburg','John Dunsworth','Ron Murphy','Cory Bowles','Jonathan Torrens','Jay Baruchel','Bruce McCulloch','Bobby Farrelly','Warren P. Sonoda'],
actors:['John Paul Tremblay','Robb Wells','Mike Smith','Elliot Page','Amy Kerr','Sarah Dunsworth','Shauna MacDonald','Shelley Thompson','Jeremy Akerman','Cory Bowles','Richard Donat','Iain Macleod','Andrew Gillies','Angela Vermeir','Len MacKeigan','Tara Doyle','Sebastian Bach','John Dunsworth','Blain Morris',"Mike O'Neill",'P.J. Crosby','Sheena Larkin','Vox Smith','Nikki Timmons','Jacob Rolfe','Tyrone Parsons','Bernard Robichaud','Michael Jackson','Michael Jackson','Lucy Decoutere','Jeanna Harrison','Jonathan Torrens','Patrick Roach','Barrie Dunn','Jeremiah Sparks','George Green','Linda Busby','John Ghiz','Angelique Jensen','Craig Wood','Sam White','Karen LeBlanc','Ardon Bess','Sandi Ross','Kim Dunn','Doug Barron','Sam Tarasco','Brian Austin Green','Garry James','Alex Lifeson','Paul MacLeod','Joseph Rutten','Jon K. Loverin','Stan Carew','Novalea Buchan','Nancy Regan','Richard Collins','Jim Swansburg','Richard Collins','Chase Duffy','Rita MacNeil','Fukuko Saito','Pauline Kaill','Corey Janes','Maury Chaykin','Cory Bowles','Pam Lutz','Nicholas Lachance','George Canyon','David Gunning','Brian Huggins','Jason Daley','Jordan Talbot','Jemar Beals','Laura Kohoot','Marguerite McNeil','Rasheed Montgomery','Leigh MacInnis','Daniel Lillford','Mike Cerrone','Pasha Ebrahimi','Jimmy Kimmel','Tom Arnold','Snoop Dogg','Brian Downey','Shamier Anderson','Michael Volpe','Emmanuel John','Simon Mutabazi','Joshua Schlaganweit','Dax Ravina','Ian Wilson','Matt Tolton','Calem MacDonald','Leanne Melissa Bishop','Jason Shipley','Nicola Lipman','Doug Benson','Bradley Bailey','Glen Michael Grant'],
screenplay:['Jackie Torrens','Iain Macleod','Timm Hannebohm','Jonathan Torrens','Barrie Dunn','Mike Smith','John Paul Tremblay','Robb Wells'],
production:['Barrie Dunn','Mike Smith','John Paul Tremblay','Robb Wells','Karen Wentzell'],
music:['Blain Morris','Michael Jackson'],
camera:['Mike Clattenburg','Adamm Liley'],
cut:['Jeremy Harty','Mike Clattenburg','Caley MacLennan','Sarah Byrne'],
sound:['Brian Power'],
scenography:['Nicole Dooley'],
masks:['Barbi Jollota'],
costumes:['Sarah Dunsworth','Nicole Dooley']},
{title:'Once Upon a Time... The Discoverers',
titleCZ:'Byl jednou jeden... vynálezce',
year:1994,
runtime:'11h 16min',
episodeRuntime:'26min',
countries:['France'],
genres:['Animation','Family','History'],
director:['Albert Barillé'],
actors:['Patrick Préjean','Sady Rebbot','Albert Augier','Olivier Destrez','Marie-Laure Beneston','Gilles Tamiz'],
screenplay:['Albert Barillé'],
music:['Michel Legrand']},
{title:'Skins',
titleCZ:'Skins',
year:2007,
runtime:'51h 18min',
episodeRuntime:'44-60min',
countries:['UK'],
genres:['Drama','Comedy'],
director:['Charles Martin','Harry Enfield','Esther Campbell','Owen Harris','Adam Smith','Philippa Langdale',"Daniel O'Hara",'Benjamin Caron','Tom Marshall','Dominic Leclerc','Minkie Spiro','Paul Gay','Chris Clough','Aysha Rafaele','Simon Massey','Neil Biswas','Amanda Boyle','Jack Clough','Samuel Donovan','Ian Barnes'],
actors:['Kaya Scodelario',"Jack O'Connell",'Hannah Murray','Nicholas Hoult','Joe Dempsie','Mike Bailey','April Pearson','Will Merrick','Freya Mavor','Mitch Hewer','Larissa Wilson','Dev Patel','Luke Pasqualino','Klariza Clayton',"Sofia Black-D'Elia",'Lily Loveless','Kathryn Prescott','Lisa Backwell','Alexander Arnold','Megan Prescott','Ollie Barbieri','Sean Teale','Sam Jackson','Merveille Lukeba','Laya Lewis','Janet Montgomery',"Ardal O'Hanlon",'Hannah Britland','Jessica Sula','Mackenzie Crook','Daniel Kaluuya','Harry Enfield','Simon Day','Josie Lawrence','Olga Fedori','Rich Fulcher','James Buckley','Danny Dyer','Iddo Goldberg','Craig Roberts','Jenny Eclair','Maria Charles','Olivia Colman','Dakota Blue Richards','Aimee-Ffion Edwards','Hugo Speer','Matt King','Steve Toussaint','Matt Kane','Sebastian De Souza','Bill Bailey','Alistair McGowan','Clare Grogan','Chris Addison','Morwenna Banks','Fenella Fielding','Joe Prospero','Britne Oldford','Mariah Gale','Holly Earl','Adelayo Adedayo','Joe Cole','Ben Lloyd-Hughes','Jamie Brittain','Sarah Solemani','Olly Alexander','Liam Boyle','Lara Pulver','Peter Capaldi','Danny Szam','Elisa Lasowski','Perdita Avery','Alastair Mackenzie','Tim Key','Pauline Quirke','Chris Ashby','Sarah Lancashire','Tom Payne','Chas Early','Kevin Hudson','Charlotte Beaumont','Victoria Wicks','Stephen Walters','Jacqueline Tong','Esther Smith','Phil Cornwell','Antonia Clarke','Spencer Jones','Rupert Holliday-Evans','Kelly Brook','Brendan Patricks','Annette Badland','Giles Thomas','Sam Alexander','Amy Wren','Tom Meeten','Pooky Quesnel','Margaret John','Henry Garrett','Lucien Laviscount'],
screenplay:['Bryan Elsley','Jamie Brittain','Ben Schiffer','Jack Thorne',"Daniel O'Hara",'Simon Amstell','Malcolm Campbell','Chris Hill','Daniel Kaluuya','Atiha Sen Gupta','Lucy Kirkwood','Georgia Lester','Ed Hime','Daniel Lovett','Jack Lothian','Jess Brittain','Geoff Bussetil','Laura Hunter','Ben Bond','Andrew Dawson','Steve Dawson','Camilla Blackett','Sally Tatchell'],
production:['Matt Strevens','Chris Clough','Neil Duncan','Toby Welch'],
music:['Matthew Simpson','Lee McCutcheon'],
camera:['Matt Gray','Steve Lawes','Sam Care','Nick Dance','Maja Zamojda','Mark Waters'],
cut:['Richard Graham','Daniel Gethic','Peter Oliver','Simon Brasse','Colin Fair'],
scenography:['Hayden Matthews','Tim Dickel','Paul Cripps','Amelia Shankland','Muirelle Wilson','Ian Wheatley'],
costumes:['Edward K. Gibbon','Harriet Barsby','Katie J. Newham','Pernille Holm']},
{title:'Locked Up (Netflix Version)',
titleCZ:'Vis a vis (Netflix verze)',
year:2015,
runtime:'27h 22min',
episodeRuntime:'42-54min',
countries:['Spain'],
genres:['Drama','Thriller'],
director:['Sandra Gallego','Jesús Colmenar','Jesús Rodrigo','Alex Rodrigo'],
actors:['Alba Flores','María Isabel Díaz Lago','Marta Aledo','Najwa Nimri','Berta Vázquez','Jesús Castejón','Maggie Civantos','Carlos Hipólito','Roberto Enríquez','Cristina Plazas','Inma Cuevas','Ramiro Blas','Alberto Velasco','Daniel Ortiz','Harlys Becerra','Laura Baena','Ana Labordeta','Belén Cuesta','Sonia Almarcha','Reme Gómez','Irene Arcos','Baya Belal','Moussa Echarif','Adryen Mehdi','Olivia Delcán','Mona Martínez','Verónika Moral','Sara Vidorreta','Yiyo Alonso','María Morales','Luis del Valle','Khaled Kouka','Ester Expósito','Elena Seijo','Óscar de la Fuente','Julio Lázaro'],
screenplay:['Iván Escobar','Álex Pina'],
music:['Iván Martínez Lacámara','Manel Santisteban'],
camera:['Migue Amoedo'],
cut:['Manuela Díaz','Leire Alonso'],
sound:['José Ignacio Arrufat','Edi Osso-Raimondo'],
scenography:['Fernando González','Xabier Iriondo'],
costumes:['Cristina Caspueñas']},
{title:'Rychlé šípy',
titleCZ:'Rychlé šípy',
year:1969,
runtime:'3h 44min',
episodeRuntime:'21-30min',
countries:['Czechoslovakia'],
genres:['Adventure','Family'],
director:['Hynek Bočan'],
actors:['Jiří Lukeš','Tomáš Hádl','Martin Kapoun','Roman Skamene','Zdeněk Jánský','Jaromír Hanzlík','Jaroslav Moučka','Václav Sloup','Jan Tříska','Ivan Vyskočil','Radoslav Brzobohatý','Jaroslav Satoranský','Petr Štěpánek','Jan Kraus','Jiří Krampol','Oldřich Vlach','Jiří Zahajský','Zdeněk Srstka','Michal Koblic','Karel Engel','Adolf Minský','Vladimír Hrubý'],
basedOn:['Jaroslav Foglar'],
screenplay:['Hynek Bočan','Václav Šašek'],
music:['Jiří Šust'],
camera:['Jiří Kadaňka'],
cut:['Zdeněk Stehlík'],
sound:['František Černý'],
scenography:['Oldřich Bosák'],
masks:['Jiří Hurych'],
costumes:['Jarmila Romanová','Olga Dimitrovová']},
{title:'Babylon Berlín',
titleCZ:'Babylon Berlín',
year:2017,
runtime:'31h 17min',
episodeRuntime:'42-62min',
countries:['Germany'],
genres:['Crime','Drama','History','War','Thriller'],
director:['Henk Handloegten','Tom Tykwer','Achim von Borries'],
actors:['Volker Bruch','Liv Lisa Fries','Benno Fürmann','Lars Eidinger','Peter Kurth','Mišel Matičević','Leonie Benesch','Ronald Zehrfeld','Karl Markovics','Hannah Herzsprung','Fritzi Haberlandt','Jens Harzer','Ernst Stötzner','Jördis Triebel','Thomas Thieme','Ivo Pietzcker','Irene Böhm','Thorsten Merten','Christian Friedel','Rüdiger Klink','Godehard Giese','Henning Peker','Martin Wuttke','Saskia Rosendahl','Severija Janušauskajtě','Ivan Shvedoff','Matthias Brandt','Anton von Lucke','Denis Burgazliev','Jacob Matschenz','Waléra Kanischtscheff','Dmitri Alexandrov','Hans-Martin Stier','Meret Becker','Sebastian Urzendowsky','Marie Gruber','Mark Ivanir','Holger Handtke','Pit Bukowski','Lilli Fichtner','Laura Kiehne','Werner Lustig','Hildegard Schroedter','Julius Feldmeier','Victor Pape-Thies','Hanns Zischler','Waldemar Kobus','Jeanette Hain','Johann Jürgens','Anton Rattinger','Florian Panzner','Gabriele Völsch','Joachim Paul Assböck','Oleg Tikhomirov','Roland Wolf','Werner Wölbern','Peter Schneider','Marc Hosemann','Tim Fischer','Ulrike Panse','Judith Neumann','Martin Thuernau','Michael Gerber','Daniel Krauss','Rosa Enskat','Alexander Hörbe','Jörg Malchow','Jesse Albert','Thomas Eickhoff','Felix Raffel','Oliver Bröcker','Hendrik Heutmann','Jan Böhme','Peter Trabner','Emil von Schönfels','Robert Viktor Minich','Dieter Rita Scholl','Gloria Endres de Oliveira','Gisa Flake','Paul Matic','Marko Dyrlich','Oskar von Schönfels','Lutz Blochberger','Dietrich Brüggemann','Udo Samel','Marie-Anne Fliegel','Franz Dinda','Vincent Krüger','Luc Feit','Kerstin Thielemann','Bryan Ferry','Marion Kracht','Sophie Charlotte Conrad','Jytte-Merle Böhrnsen','Georg Blumreiter','Alexander Khuon','Christoph Schechinger','Christian Beermann','Justus Carrière','Finn Fiebig'],
basedOn:['Volker Kutscher'],
screenplay:['Tom Tykwer','Henk Handloegten','Achim von Borries'],
production:['Stefan Arndt','Uwe Schott'],
music:['Johnny Klimek','Tom Tykwer'],
camera:['Bernd Fischer','Frank Griebe','Philipp Haberlandt','Christian Almesberger'],
cut:['Claus Wehlisch','Alexander Berner','Antje Zynga'],
sound:['Matthias Lempert','Frank Kruse','Benjamin Krbetschek','Stefan Soltau','Roland Winke','Klaus-Peter Schmitt','Markus Stemler'],
scenography:['Uli Hanisch','Ingeborg Heinemann','Sabine Schaaf','Michael Fechner'],
masks:['Emilia Seifert','Emilia Grund','Juliane Hübner','Anja Rimkus','Valerie Rossacher','Roman Braunhofer','Heiko Schmidt','Aljona Kassner','Kerstin Gaecklein'],
costumes:['Pierre-Yves Gayraud']},
{title:'Broadchurch',
titleCZ:'Broadchurch',
year:2013,
runtime:'19h 20min',
episodeRuntime:'46-53min',
countries:['UK'],
genres:['Drama','Crime','Mystery'],
director:['Euros Lyn','James Strong','Jessica Hobbs','Jonathan Teplitzky','Mike Barker','Paul Andrew Williams','Lewis Arnold','Daniel Nettheim'],
actors:['David Tennant','Olivia Colman','Andrew Buchan','Jonathan Bailey','Carolyn Pickles','Pauline Quirke','Steve Bennett','Jodie Whittaker','Will Mellor','Arthur Darvill','Tanya Franks','Vicky McClure','David Bradley','Tracey Childs','Julian Seager','Adam Wilson','Simone McAullay','Charlotte Beaumont','Matthew Gravelle','Farzana Dua Elahe','Eve Myles','Alfred Enoch','Charlotte Rampling','Nadia Williams','Abigail Hardingham',"James D'Arcy",'Susan Brown','Peter De Jersey','Simon Blood DeVay','Stuart Mulcaster','Nicole Arumugam','Katherine Denkinson','Clem So','Alan Bond','Bill Fellows','Elaine Caulfield','Ajaz Aslam','Stuart Davidson','Adjoa Andoh','David Sibley','Chris Cowlin','Janet Dibley','Phoebe Waller-Bridge','Jacob Anderson','Lee Asquith-Coe','Eliza Bennett','Roger Ringrose','Marianne Jean-Baptiste','Shaun Dooley','Meera Syal','Adam Leese','Lucy Cohu','Tom Rosenthal','Sarah Parish','Lenny Henry','Georgina Campbell','Mark Bazeley','Julie Hesmondhalgh','Charlie Higson','Amanda Drew','Guillaume Rivaud','Richard Hope','David Rowlands','Jack Ashton','Steve Walsh','Jake Blight','Daniel Hill','Hollie Burgess','Joe Sims','Oskar McNamara','Simone Ashley','Hara Yannas','Hannah Rae','Jenny Bede','Sebastian Armesto','Sunetra Sarker','Julie Cox','Chris Mason','Mariah Gale','Charles Babalola','Hannah Millward','Jim Howick','Elen Rhys','Josette Simon','Ellora Torchia','Kelly Gough','Gbemisola Ikumelo','Thusitha Jayasundera','Charlotte Lucas','Simon Ludders','Roy Hudd','Marcus Garvey','Andrea Hall','Moray Hunter','Nadia Williams','Hannah Blamires'],
screenplay:['Chris Chibnall','Louise Fox'],
production:['Richard Stokes','Dan Winch'],
music:['Ólafur Arnalds'],
camera:['Matt Gray','John Conroy','Carlos Catalán'],
cut:['Johnny Rayner','Ben Lester','James Taylor','Tim Marchant','Dominic Strevens','Mike Jones','Tim Porter','Helen Chapman'],
scenography:['Anna Pritchard','Catrin Meredydd','Laura Marsh','Claire Levinson-Gendler','Simon Rogers'],
masks:['Parm Barker','Harriet Thompson','Cat Wild'],
costumes:['Ray Holman']},
{title:'Kód za miliardu dolarů',
titleCZ:'Kód za miliardu dolarů',
year:2021,
runtime:'4h 27min',
episodeRuntime:'59-77min',
countries:['Germany'],
genres:['Drama','Crime','Biography'],
director:['Robert Thalheim'],
actors:['Mark Waschke','Mišel Matičević','Leonard Scheicher','Marius Ahrendt','Lavinia Wilson','Seumas F. Sargent','Bernhard Schütz','Julika Jenkins','Thomas Douglas','Neda Rahmanian','Rauand Taleb','Marcel Heuperman','Michelle Glick','Johanna Polley','Juki Iwamoto','Clayton Nemrow','Harry Szovik','Christoph Tomanek','Lukas Loughran','Dan Cade','Björn Freiberg','Scott Alexander Young','Balázs Veres','Sabrina Amali','Elias Krischke','Steffen C. Jürgens','Aljoscha Stadelmann','Dominique Chiout','Reza Brojerdi','Lenore Thomas Douglas','András Bálint','Alexis Latham','Krisztina Goztola','Laurent Winkler'],
screenplay:['Oliver Ziegenbalg'],
production:['Annie Schilling'],
music:['Uwe Bossenz','Anton Feist'],
camera:['Henner Besuch'],
cut:['Stefan Kobe','Anja Siemens'],
sound:['Szabolcs Stella'],
scenography:['Myrna Drews'],
masks:['Nica Faas'],
costumes:['Ingken Benesch']},
{title:'Courage the Cowardly Dog',
titleCZ:'Courage the Cowardly Dog',
year:1999,
runtime:'19h 48min',
episodeRuntime:'22-23min',
countries:['USA'],
genres:['Animation','Comedy','Family','Sci-Fi'],
director:['John Dilworth'],
actors:['Marty Grabstein','Thea White','Peter Fernandez','Simon Prebble','Paul Schoeffler','Mary Testa','Jim Cummings','Fran Brill','Arnold Stang','Linda Lavin','John Dilworth','Fred Melamed','Jason Antoon','Katie Griffin','Denny Dillon','Susan Kellermann','Snežana Bogdanovič','Ron McLarty','Ashley Paige Albert','Ruth Williamson','Kath Soucie','Judy Kaye','Will Ryan','J.R. Horne','B.J. Ward','André Sogliuzzo','Daniel Oreskes'],
screenplay:['Bill Marsilii','John T. Reynolds','Billy Aronson','David Steven Cohen'],
production:['Winnie Chaffee','Bill Schultz'],
music:['Andy Ezrin','Jody Gray'],
sound:['Michael Geisler','Bob Pomann']},
{title:'Chen qing ling',
titleCZ:'Chen qing ling',
year:2019,
runtime:'36h 54min',
episodeRuntime:'42-47min',
countries:['China'],
genres:['Action','Drama','Adventure','Fantasy','Horror','Mystery'],
director:['Steve Cheng','Ka-lam Chan'],
actors:['Sean Xiao','Yibo Wang','Yingchun Cai','Ziyi Meng','Zikuan Yu','Haikuan Liu','Lulu Xuan','Zhuocheng Wang','Haoxuan Wang','Zanjin Zhu','Bin Yu','Bowen Li','Mingjing Feng','Cheng Guo','Shuhao Yao','Xiaoting Hu','Peng He','Yinjun Liu','Jingtong Zhang','Fanxing Zheng','Junxiang Cao','Peixin Qi','Li Ji','Yuchen Cao','Yizhou Wang','Cong Feng','Cici Liu','James Huang','Xiaohai Shen','Shuyi Jia','Carman Lee','Luying Jin','Xuantong Ye','Rong Wang','Jiyang Song'],
basedOn:['Mo Xiang Tong Xiu'],
production:['Meng Zhang','Zhijie Han','Fang Fang','Juan Wang','Zhonghuai Sun'],
music:['Hai Lin'],
costumes:['Tongxun Chen']},
{title:'Kancelář Blaník',
titleCZ:'Kancelář Blaník',
year:2014,
runtime:'10h 11min',
episodeRuntime:'4-11min',
countries:['Czechia'],
genres:['Comedy'],
director:['Marek Najbrt','Bohdan Sláma','Jaroslav Fuit'],
actors:['Marek Daniel','Halka Jeřábek Třešňáková','Michal Dalecký','Sandra Nováková','Tomáš Matonoha','Ivana Chýlková','Jan Hřebejk','Ladislav Hampl','Vlastimil Třešňák','Iva Kubelková','Zdeněk Suchý','Boris Hybner','Petr Čtvrtníček','Helena Třeštíková','Olga Sommerová','David Černý','Matěj Ruppert','Martin C. Putna','Igor Chaun','Jan Potměšil','David Koller','Marie Ludvíková','Marek Wollner','Pavel Liška','Martin Veselovský','Jiří Macháček','Jaroslav Plesl','Hana Vagnerová','Stanislav Majer','Dagmar Havlová','Arnošt Goldflam','Václav Marhoul','Jitka Schneiderová','Tatiana Dyková','Bolek Polívka','Marek Eben','Leoš Mareš','Jiří Bartoška','Tomáš Jeřábek','Olbram Zoubek','Alena Doláková','Hana Marie Maroušková','Lucie Končoková','Hynek Schneider','Martin Přikryl','Jiří Havelka','Leoš Noha','Tomáš Sedláček','Štěpán Kubišta','Kryštof Mucha','Jan Hrdina','Robert Geisler','Pavel Vácha','Milan Kuchynka','Andrej Babiš','Václav Moravec','Miroslav Kalousek','Miloš Zeman','Roman Vaněk','Karel Kovář','Duy Quang Nguyen','Petr Dvořák','Dano Dangl','Richard Stanke','Iveta Radičová','Petr Fiala','Petr Lintimer'],
screenplay:['Robert Geisler','Benjamin Tuček','Marek Najbrt','Tomáš Hodan','Milan Kuchynka','Marek Daniel','Jan Bartes'],
production:['Lukáš Záhoř','Milan Kuchynka'],
music:['Midi Lidi'],
camera:['Jan Baset Střítežský','Havel Parkán','Nikolas Tušl','Aleš Němec','Pavel Borovička','Václav Fronk','Michal Vojkůvka','Martin Štěpánek'],
cut:['Michal Hýka','Evženie Brabcová','Pavel Hrdlička ml.','Petr Kozák'],
sound:['Jan Štindl']},
{title:'Povídání o pejskovi a kočičce',
titleCZ:'Povídání o pejskovi a kočičce',
year:1950,
runtime:'1h 8min',
episodeRuntime:'8-16min',
countries:['Czechoslovakia'],
genres:['Animation','Family'],
director:['Eduard Hofman'],
actors:['Karel Höger'],
basedOn:['Josef Čapek'],
screenplay:['Eduard Hofman'],
music:['Jan Rychlík'],
camera:['Josef Střecha'],
cut:['Jana Šebestíková']},
{title:'Vymítač',
titleCZ:'Vymítač',
year:2017,
runtime:'6h 47min',
episodeRuntime:'9-13min',
countries:['Poland'],
genres:['Animation','Comedy','Horror'],
director:['Bartosz Walaszek'],
actors:['Bartosz Walaszek'],
screenplay:['Bartosz Walaszek'],
production:['Bartosz Walaszek'],
music:['Bartosz Walaszek']},
{title:'Atlanta',
titleCZ:'Atlanta',
year:2016,
runtime:'20h 31min',
episodeRuntime:'22-39min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Hiro Murai','Donald Glover','Janicza Bravo','Amy Seimetz','Ibra Ake','Angela Barnes Gomes','Adamma Ebo'],
actors:['Donald Glover','Brian Tyree Henry','Lakeith Stanfield','Zazie Beetz',"Harold 'House' Moore",'Cranston Johnson','Emmett Hunter','Rick Holmes','Ashley John','Erskine C. Johnson III','Terri Abney','Jane Adams','Elizabeth Davidovich','Paloma Guzmán','Isiah Whitlock Jr.','Stephen Caudill','Danny Vinson','Jaleel White','Josh Ventura','David Silverman','Danny Chung','Vincent M. Ward','Freddie Kuguru','Cassandra Freeman','Myra Lucretia Taylor','Andrene Ward-Hammond','Aubin Wise','Montrel Miller','Tobias Jelinek','Griffin Freeman','Alano Miller','Migos','Ralph Wilcox','Erin Ownbey','Alkoya Brunson','Antoinette Robertson','Katt Williams','Khris Davis','Jason Burkey','Joshua Brady','Bryce Hitchcock','Donald Paul','Brittany Wilkerson','Dennis L.A. White','Chris Jarell','Gail Bean','Carlos Guerrero','Diane Sellers','Jaishon Fisher','Myles Truitt','Adriyan Rae','Jordane Christie','Danielle Deadwyler','Austin Crute','Caroline Arapoglou','Tequilla Whitfield','Jonathon Pawlowski','Priah Ferguson','Abraham Clinkscales','Brittany Inge','RJ Walker','Avis-Marie Barnes','Jalyn Hall','Renell Gibbs','Clark Harris','Bryan McClure','Marcus Samuel','Moses Jones','Aysia Moorer','Alan Heckner','Melissa Saint-Amand','Jessica A. Caesar','Edwin Walker','Leon Lamar','Dawn Halfkenny','Conphidance','Brianna Butler','Ira Carmichael','Luke Forbes','Jade Fernandez','Lucius Baston','Jamie Neumann','Laura Dreyfuss','Tobias Segal','Jillian Batherson','Princess Elmore','Jenne Kang','Ilana Kohanchi','Sean Hankinson','Arthur Veen','Matteo Simoni','Jonathan Huisman','Ruben van der Meer','Anniek Pheifer','Jon Tarcy','Liam Neeson','Patrick Kennedy','Daniel Fathers',"Darrell D'Silva",'Sheyi Cole'],
screenplay:['Donald Glover','Stephen Glover','Jamal Olori','Stefani Robinson','Taofik Kolade','Ibra Ake','Janine Nabers','Jordan Temple','Francesca Sloane','Karen Joseph Adcock'],
production:['Hiro Murai','Alex Orr','Stefani Robinson','Kathryn Dean','Taofik Kolade','Jamal Olori','Francesca Sloane','Ibra Ake'],
music:['Ludwig Göransson'],
camera:['Christian Sprenger','Stephen Murphy','Gabriel Patay'],
cut:['Isaac Hagy','Kyle Reiter','Ivan Victor','Jen Bryson'],
sound:['Cary Stacy','John Chamberlin','Samuel Ejnes','Diego Gat','Trevor Gates'],
scenography:["Timothy David O'Brien",'Jonathan Paul Green'],
masks:['Libra Cordero','Rosalyn Farrar-Hall'],
costumes:['Kairo Courts','Lorraine Coppin','Tiffany Hasbourne','Celia Yau']},
{title:'Detectorists',
titleCZ:'Detectorists',
year:2014,
runtime:'10h 18min',
episodeRuntime:'27-75min',
countries:['UK'],
genres:['Comedy'],
director:['Mackenzie Crook'],
actors:['Mackenzie Crook','Toby Jones','Rachael Stirling','Gerard Horan','Pearce Quigley','Divian Ladwa','Sophie Thompson','Johnny Flynn','James Weber Brown','Sean Buckley','Alexa Davies','Daniel Eghan','Lucy Bnejamin','Richard Banks','Aimee-Ffion Edwards','Rachel Bell','Daniel Donskoy','Mick Slaney','Tim Key','David Sterne','Brooke Norbury','Pamela Betsy Cooper','Simon Farnaby','Lee Nicholas Harris','Diana Rigg','Tom Meeten','Neil Edmond','Rebecca Callard','Colin Michael Carmichael','Jack Roth','Jaygann Ayeh','Ella Kenion','Claudia Jessie','Kevin Bishop','Kevin Eldon','Lucinda Rhodes Thakrar','Tony Fadil','Dan Tetsell','Laura Checkley','Frankie Wilson','Kenneth Collard','Chris Martin Hill'],
screenplay:['Mackenzie Crook'],
production:['Adam Tandy'],
music:['Johnny Flynn'],
camera:['Jamie Cairney','Mattias Nyberg','John Sorapure'],
cut:['Colin Fair'],
sound:['Chris MacLean','Bob Newton'],
scenography:['Samantha Harley','Jeff Sherriff','Anna Sheldrake','Joe Rappaport'],
masks:['My Alehammar']},
{title:'Initial D: Second Stage',
titleCZ:'Initial D: Second Stage',
year:1999,
runtime:'4h 59min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Action','Drama','Sport'],
director:["Šin'iči Masaki",'Júzó Jamada','Takeši Ušigusa','Jošizó Cuda',"Šin'ja Hanai",'Jukihiro Šino'],
actors:["Šin'ičiró Miki",'Ajako Kawasumi','Micuo Iwata','Takehito Kojasu','Tomokazu Seki','Unšó Išizuka','Wataru Takagi','Keidži Fudžiwara','Kódži Jusa','Kazuhisa Kawahara','Rjóka Juzuki','Jasunori Macumoto','Nobujuki Hijama','Kódži Išii','Hidenari Ugaki','Kósuke Okano','Tomomiči Nišimura','Masahiko Tanaka','Osamu Hosoi','Kazuki Jao'],
basedOn:['Šúiči Šigeno'],
screenplay:['Nobuaki Kišima','Hiroši Toda'],
production:['Kajo Fukuda'],
music:['Rjúiči Kacumata'],
camera:['Sadanori Kaneda'],
cut:['Hideto Óta'],
sound:['Masafumi Mima'],
scenography:['Minoru Maeda']},
{title:'Peťajn',
titleCZ:'Peťajn',
year:2014,
runtime:null,
episodeRuntime:null,
countries:['Czechia'],
genres:['Short','Comedy'],
director:['Petr Esterka'],
actors:['Petr Esterka','Petr Purmenský']},
{title:'The Boondocks',
titleCZ:'The Boondocks',
year:2005,
runtime:'19h 48min',
episodeRuntime:'19-23min',
countries:['USA'],
genres:['Animation','Comedy','Drama'],
director:['Seung Eun Kim','Anthony Bell','Sung-hoon Kim','Kalvin Lee','Lesean Thomas','Dan Fausett','Kwang Il Han','Bob Hathcock','Joe Horne','Sean Song'],
actors:['Regina King','John Witherspoon','Gary Anthony Williams','Cedric Yarbrough','Jim Meskimen','Charlie Murphy','Snoop Dogg','Aaron McGruder','Xzibit','Sam McMurray','Samuel L. Jackson','Daryl Sabara','Mike Epps','Ghostface Killah',"Mo'Nique",'Jake Cherry','John DiMaggio','James Arnold Taylor','Donald Faison','Marion Ross','Katt Williams','Terry Crews',"Lil' Wayne",'André Gordon','Luenell','Tara Strong','Yuri Lowenthal','Louis Lombardi','Affion Crockett','DeRay Davis','Tichina Arnold',"Bobb'e J. Thompson",'Greg Ellis','Sab Shimono','Nick Jameson','Aisha Tyler','CeeLo Green','Tiffany Espensen','Greg Travis','Bebe Drake','Debra Wilson','Charlie Schlatter','Kevin Michael Richardson','Jessika Van','Michael Ralph','Niecy Nash','Vernee Watson','Jill Talley',"Gerald 'Slink' Johnson",'Candi Milo','Rodney Barnes','Kevontay Jackson','Edward Asner','Billy West','Dawnn Lewis','Adam West','Maria Canals-Barrera','Miguel Sandoval','Yasiin Bey','DJ Pooh','Kym Whitley','Quincy Jones','Tom Kenny','Judge Reinhold','Jeff Bennett','John C. McGinley','Corey Burton','Rob Paulsen','Dee Bradley Baker','Jim Cummings','Tress MacNeille','Carl Jones','Pat Musick','Richard McGregor','Misty Lee','Travis Willingham','Peter Oldring','Bill Maher','Alexander Polinsky','Kimberly Brooks','Cristina Pucelli','Melique Berger','Crystal Scales','Chad Einbinder','Michele Morgan','Kittie KaBoom'],
screenplay:['Aaron McGruder','Rodney Barnes','Angela Nissel','Yamara Taylor'],
production:['Brian J. Cowan','Denys Cowan','Carl Jones'],
music:['Flying Lotus'],
cut:['Lee Harting','Anna Granfors','Bruce King','Ralph A. Eusebio','Jhoanne Reyes'],
sound:['Keith Hodne','Fil Brown','Melissa Ellis','Heather Olsen','Ryan Heiferman']},
{title:'Chalupáři',
titleCZ:'Chalupáři',
year:1975,
runtime:'8h 38min',
episodeRuntime:'39-55min',
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['František Filip'],
actors:['Jiří Sovák','Josef Kemr','Jana Hlaváčová','Josef Vinklář','Jiří Schmitzer','Jiřina Bohdalová','Ilja Prachař','Josef Větrovec','Božena Böhmová','Mahulena Bočanová','František Filipovský','Josef Hlinomaz','Nina Popelíková','Hana Maciuchová','Josef Beyvl','Stella Zázvorková','Václav Sloup','Jaroslav Moučka','Věra Tichánková','Vladimír Menšík','Gabriela Vránová','Otto Lackovič','Luba Skořepová','Boleslav Skalski','Růžena Lysenková','Josef Čáp','Pavel Spálený','Blanka Vikusová','Alena Kreuzmannová','Jaroslava Tvrzníková','Alena Vránová','Jiří Adamíra','Jarmila Beránková','Věra Koktová','Čestmír Řanda st.','Josef Bek','Mirko Musil','Vlastimil Hašek','Zdeněk Braunschläger','Jan Pohan','Karel Urbánek','Petr Kostka','Carmen Mayerová','Vítězslav Černý','Robert Vrchota','Jiří Lír','Václav Lohniský','Darja Hajská','Josef Patočka','Jindřich Narenta','Otto Budín','Bohumil Šmída','Blažena Slavíčková','Josefa Pechlátová','Antonín Soukup','Karel Houska','Václav Kotva','Jiřina Bílá','Milica Kolofíková','Štěpán Bulejko','Lída Roubíková','Jan Teplý st.','Ladislav Frej st.','Věra Budilová','Václav Fišer','Vladimír Pospíšil','Ondřej Stýblo','Ivo Niederle','František Srb','Petra Kodýmová','Miriam Chytilová','Hana Malířová','Zdeněk Kutil','Jan Kotva','Zdeňka Černá','Jiří Fejfar','Jaroslava Čadková','Milan Mach','Karel Smrž','Jan Kuželka','Vladimír Fürst'],
screenplay:['Václav Pavel Borovička','František Vlček st.'],
music:['Luboš Fišer'],
camera:['Rudolf Stahl ml.'],
cut:['Karel Kohout'],
sound:['Ladislav Hausdorf'],
scenography:['Jan Zázvorka'],
masks:['Miloslav Jandera'],
costumes:['Jaroslava Veselá','Lída Novotná']},
{title:'Spy x Family',
titleCZ:'Spy x Family',
year:2022,
runtime:'14h 48min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Comedy','Thriller'],
director:['Kazuhiro Furuhaši','Tacujuki Nagai','Tošifumi Akai','Takahiro Harada','Takahiro Miura','Mijuki Kuroki','Jukiko Imai','Kendži Takahaši','Makoto Kodama','Takaši Katagiri','Makoto Fučigami','Kódži Masunari','Júsuke Kubo','Tomoja Kitagawa','Kento Macui','Šinsaku Sasaki'],
actors:['Takuja Eguči','Acumi Tanezaki','Saori Hajami','Hirojuki Jošino','Júko Kaida','Kazuhiro Jamadži','Acuši Ono','Marie Ói','Júdži Murai','Taisuke Nakano','Kazuja Sadži','Icuki Kurita','Hana Sató','Masafumi Kobatake','Hiroki Gotó','Satoru Itó','Akio Ócuka','Kacunori Okai',"Šin'ja Takahaši",'Umeka Šódži','Šóhei Kadžikawa','Manaka Iwami','Mirei Kumagai',"Džun'iči Suwabe",'Šómaru Zóza','Takaaki Torašima','Emiko Takeuči','Kenšó Ono','Sakuma Motoki','Júko Sasaki','Džin Urajama','Hiroši Janaka','Mari Učijama','Miho Hino','Miju Komaki','Emiri Kató','Nacumi Fudžiwara','Jóhei Tadano','Ai Kaneta','Jošicugu Kawašima','Haruka Okamura','Minami Hinata','Serika Hiromacu','Džiró Saitó','Jasujuki Kase','Hiroki Jasumoto','Saima Nakano','Čihiro Ibuki','Sája Anzai','Arisa Kijoto','Momoe Kišimoto','Júko Tačibana','Ruriko Noguči','Hiroki Takahaši',"Ken'ičiró Macuda",'Naomi Sano','Kentaró Takano','Naoki Bandó','Akari Tadano','Takaja Haši','Hinata Sató','Mikoto Nakai','Júiči Nakamura','Šun Horie','Ajane Sakura','Kento Širaiši','Sacumi Macuda','Tadaši Makino','Jódži Ueda','Júki Šin','Šóko Cuda','Aoi Ičikawa','Jóko Fudžita','Daisuke Kišio','Hiroši Širokuma','Kóiči Sóma','Hinata Tadokoro','Hiroši Naka','Kósuke Kobajaši','Kjó Jaoja','Reina Ueda','Satoši Hino',"Ken'jú Horiuči",'Haruka Džinja','Aja Endó','Džunta Terašima','Juki Ominami','Saja Hirose','Kazujuki Okicu','Takajuki Nakacukasa','Kósuke Toriumi','Rie Kawamura','Fuminori Komacu','Seijú Fudžiwara','Masato Niwa',"Ken'ičiró Macuda",'Rie Hikisaka'],
basedOn:['Tacuja Endó'],
screenplay:['Tomomi Kawaguči','Rino Jamazaki','Daiširó Tanimura','Ajumu Hisao','Ičiró Ókóči','Honoka Kató'],
music:['Makoto Mijazaki','Šúhei Mucuki'],
camera:['Akane Fušihara','Júja Sakuma'],
cut:['Akari Saitó'],
sound:['Šódži Hata'],
scenography:['Hisajo Usui','Kazuo Nagai','Tomomi Sugimoto','Minami Usui']},
{title:"Kaguja-sama wa kokurasetai: Tensaitači no ren'ai zunósen",
titleCZ:"Kaguja-sama wa kokurasetai: Tensaitači no ren'ai zunósen - Season 1",
year:2019,
runtime:'4h 48min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Comedy','Romance'],
director:["Šin'iči Omata"],
actors:['Aoi Koga','Makoto Furukawa','Rjóta Suzuki','Konomi Kohara','Tomomi Mineuči','Cuda Eizó','Takaaki Učino','Jumiri Hanamori','Momo Asakura','Sajumi Suzuširo','Taku Jaširo','Ari Ozawa','Mikako Komacu','Haruo Sató','Kana Ičinose','Kóiči Sóma','Itaru Jamamoto','Keita Tada','Teppei Ueniši','Júki Išikari','Kajuki Macumoto','Sally Amaki','Daiki Kobajaši','Takehito Kojasu','Madoka Asahina','Miho Okasaki','Aoi Ičikawa','Ajaka Asai','Hiromiči Tezuka','Satoši Inomata','Sajaka Kaneko',"Rina Hon'izumi",'Eri Jukimura','Tomoko Cuzuki','Hodaka Mieno','Šunja Hiruma','Takeši Marujama','Himari Močida','Kento Širaiši','Hina Kino','Hiroki Maeda','Rjó Sugisaki','Haruno Inoue','Maki Kawase','Haruki Išija','Šinei Ueki','Juka Nukui','Ikudži Nose','Júka Morišima','Hikaru Akao','Jú Sasahara','Hinata Tadokoro','Miju Tomita','Rina Hidaka','Jutaka Aojama'],
basedOn:['Aka Akasaka'],
screenplay:['Jukie Sugawara','Jasuhiro Nakaniši'],
music:['Kei Haneoka'],
camera:['Masaharu Okazaki'],
cut:['Rie Macubara'],
sound:['Džin Aketagawa'],
scenography:['Risa Wakabajaši']},
{title:'The Long Long Holiday',
titleCZ:'Velké prázdniny',
year:2015,
runtime:'4h 20min',
episodeRuntime:'26min',
countries:['France'],
genres:['Animation','Family'],
director:['Paul Leluc'],
actors:['Benjamin Bollen','Clara Quilichini','Julie-Ann Dean','Jean-Pascal Quilichini'],
screenplay:['Guillaume Mautalent','Alain Serluppus'],
production:['Didier Brunner'],
sound:['Pierre Aretino']},
{title:'MOST!',
titleCZ:'MOST!',
year:2019,
runtime:'5h 58min',
episodeRuntime:'37-48min',
countries:['Czechia'],
genres:['Comedy','Drama'],
director:['Jan Prušinovský'],
actors:['Martin Hofmann','Erika Stárková','Filip František Červenka','Michal Isteník','Zdeněk Godla','Cyril Drozda','Vladimír Škultéty','Jitka Čvančarová','Jiří Schmitzer','Taťjana Medvecká','Leoš Noha','Klaudia Dudová','Dominika Býmová','Ester Janečková','Martin Kavan','Ivana Alferiová','Martin Siničák','Kamil Švejda','Zdeněk Bařinka','Karel Beseda','Matúš Bukovčan','Jan Jankovský','Marie Jansová','Sara Venclovská','Jáchym Pittermann','Jaroslav Novák','Miroslav Babuský','Jan Kalina','Nikola Tonková','Magdaléna Kozáková','Fred Müller','David Horváth','Julius Oračko','Denis Žák','Karolína Zachová','Marcel Rošetzký','Vendelín Urban','Adam Ševčík','Bohdan Golovčenko','Josef Godla','Josef Dudi','Peter Bažo','Eva Hrdličková','Jan Řezníček','Dušan Oračko','Eva Hacurová','Barbara Trojanová','Radvana Havelková','Jan Červenka','Petr Koblovský','Jan Cina','Petr Reif','Sasha W. Isar','Tomáš Choura'],
screenplay:['Petr Kolečko','Jan Prušinovský'],
production:['Michal Reitler'],
camera:['Petr Koblovský'],
cut:['Lukáš Opatrný','Michal Böhm'],
sound:['Matěj Matuška','Michal Čech'],
scenography:['Jan Pjena Novotný','Miloš Vávra'],
masks:['Lukáš Král','Martin Větrovec'],
costumes:['Ivan Stekla']},
{title:'The Adventures of Aladár Mézga',
titleCZ:'Podivuhodná dobrodružství Vladimíra Smolíka',
year:1972,
runtime:'5h 18min',
episodeRuntime:'22-26min',
countries:['Hungary'],
genres:['Animation','Sci-Fi','Family'],
director:['József Nepp','József Gémes','Marcell Jankovics','Béla Ternovszky','Jenő Koltai','Miklós Temesi'],
actors:['Attila Némethy','Ottó Szabó','Endre Harkányi','Ilona Győri','Margit Földessy','Rudolf Somogyvári','Nándor Tomanek','Alfonzó','József Képessy','Pál Horváth','László Csurka','Antal Farkas','Klára Kovács','István Egresi','Erzsi Pártos','Péter Geszti','Zsuzsa Pálos','Ferenc Deák B.','Sándor Suka','Attila Tyll','Ilus Vay','Róbert Rátonyi','Árpád Gyenge','László Bánhidi','Balázs Szuhay','János Körmendi','István Pathó','Tamás Fodor','Sándor Kőmíves','Gellért Raksányi','Éva Schubert','László Csákányi'],
screenplay:['József Nepp','József Romhányi'],
music:['Tamás Deák'],
camera:['Zoltán Bacsó','Mária Neményi','Csaba Nagy','Lajos Kiss']},
{title:'The Adventures of the Bee Teddies',
titleCZ:'Příběhy včelích medvídků',
year:1984,
runtime:'2h 59min',
episodeRuntime:'8-10min',
countries:['Czechoslovakia'],
genres:['Animation','Puppets','Family'],
director:['Libuše Koutná','Ivo Houf'],
actors:['Josef Dvořák','Pavel Zedníček','Aťka Janoušková','Jiří Císler','Josef Podsedník','Jaroslav Vidlář','Jaroslav Holeček','Ivan Anthon','Jana Prachařová','Hana Lamková','Vladimír Gut','Karel Hanc','Miloš Zídek','Lenka Krupanská','Dušan Palenčár','Milan Slepička','Filip Homola','Jan Janovic','Jana Ptáčková'],
basedOn:['Eva Košlerová'],
screenplay:['Eva Košlerová','Jaroslav Vidlář','Libuše Koutná','Ivo Houf'],
production:['Jiří Vaněk'],
music:['Petr Skoumal'],
camera:['Svatopluk Malý','Pavel Černý'],
cut:['Ludvík Pavlíček','Hana Sádlová'],
sound:['Jaroslav Děták','Ivo Špalj'],
scenography:['Radek Houf']},
{title:'Dark',
titleCZ:'Dark',
year:2017,
runtime:'24h 23min',
episodeRuntime:'45-73min',
countries:['Germany'],
genres:['Drama','Crime','Sci-Fi','Mystery'],
director:['Baran bo Odar'],
actors:['Louis Hofmann','Oliver Masucci','Jördis Triebel','Karoline Eichhorn','Maja Schöne','Stephan Kampwirth','Daan Lennard Liebrenz','Andreas Pietschmann','Deborah Kaufmann','Tatja Seibt','Lisa Vicari','Hermann Beyer','Moritz Jahn','Walter Kreye','Peter Benedict','Christian Steyer','Leopold Hornung','Ella Lee','Ludger Bökelmann','Christian Pätzold','Anne Ratte-Polle','Nele Trebs','Angela Winkler','Peter Schneider','Mark Waschke','Carlotta von Falkenhayn','Stephanie Amarell','Sebastian Hülk','Julika Jenkins','Arnd Klawitter','Anna König','Sebastian Rudolph','Anatole Taubman','Felix Kramer','Cordelia Wege','Luise Heyer','Mieke Schymura','Lena Dörrie','Florian Panzner','Anton Rubtsov','Lisa Kreuzer','Barbara Philipp','Gwendolyn Göbel','Michael Mendl','Joshio Marlon','Lena Urzendowsky','Nils Brunkhorst','Tom Jahn','Denis Schmidt','Tara Fischer','Harald Effenberg','Cornelia Lippert','Jennipher Antoni','Lea van Acken','Thomas Arnold','Nino Böhlau','Luc Feit','Franz Hartwig','Eva Maria Jost','Henning Peker','Sammy Scheuritzel','Hannes Wegener','Nina Weniger','Roland Wolf','Paul Lux','Gina Stiebitz','Antje Traue','Béla Gabor Lenz','Valentin Oppermann','Leon Lukas Blaschke','Lydia Maria Makrides','Shani Atias','Arne Fiedler','Max Schimmelpfennig','Roman Knižka','Sylvester Groth','Sandra Borgmann','Dietrich Hollinderbäumer','Carina N. Wiese','Andreas Schröders','Christian Kuchenbuch','Frédéric Vonhof','Winfried Glatzeder','Katharina Spiering','Till Patz','Claude Albert Heinrich','Barbara Nüsse','Natascha Paulick','Tom Philipp','Lea Willkowsky','Pablo Striebeck','Lisa-Marie Janke','Anna Schönberg','Vico Mücke','Anne Lebinsky','Axel Werner','Hans Diehl','Jakob Diehl','Maximilian Dirr','Anjorka Strechel'],
screenplay:['Jantje Friese','Martin Behnke','Baran bo Odar','Marc O. Seng','Ronny Schalk'],
production:['Jantje Friese'],
music:['Ben Frost'],
camera:['Nikolaus Summerer'],
cut:['Robert Rzesacz','Denis Bachter','Simon Gstöttmayr','Ann-Carolin Biesenbach','Boris Gromatzki','Anja Siemens','Sven Budelmann'],
sound:['Achim Hofmann','Mathias Maydl','Alexander Würtz','Jürgen Funk','Jörg Elsner','Benjamin Rosenkind','Matthias Richter','Christian Bischoff'],
scenography:['Udo Kramer','Katharina Birkenfeld'],
masks:['Monika Münnich','Wiebke Madloch','Tamar Aviv','Christina Wagner','Andrea Pirchner','Astrid Stebich'],
costumes:['Anette Guther']},
{title:'Once Upon a Time... The Explorers',
titleCZ:'Byl jednou jeden... objevitel',
year:1997,
runtime:'11h 16min',
episodeRuntime:'26min',
countries:['France'],
genres:['Animation','Family','History'],
director:['Albert Barillé'],
actors:['Roger Carel','Daniel Beretta','Olivier Destrez','Marie-Laure Beneston','Patrick Préjean'],
screenplay:['Albert Barillé'],
music:['Michel Legrand']},
{title:'Ghost in the Shell: Stand Alone Complex',
titleCZ:'Kókaku kidótai: Stand Alone Complex',
year:2002,
runtime:'21h 40min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Action','Sci-Fi','Thriller'],
director:['Kendži Kamijama','Hidejo Jamamoto','Tošijuki Kóno','Jasuhiro Geši','Minoru Óhara','Kazunobu Fuseki','Acuši Wakabajaši',"Ken'iči Takešita",'Nobutoši Ogura','Masajuki Jošihara','Rjútaró Nakamura','Masaki Tačibana','Icuró Kawasaki','Džun Macumoto','Masahiro Andó','Džundži Nišimura','Tensai Okamura'],
actors:['Akio Ócuka','Acuko Tanaka','Kóiči Jamadera','Ken Narita',"Šin'ičiró Miki",'Robert Axelrod','Tóru Šinagawa','Daran Norris','Murphy Dunne','Kazuja Ičidžó','Akiko Jadžima','Tarusuke Šingaki','Eidži Sekiguči','Minami Takajama','Hideo Išikawa','Kjóko Hikami','Džódži Nakata','Fumihiko Tačiki','Hiroši Janaka','Kóiči Kitamura','Daisuke Góri','Osamu Saka','Jasunori Macumoto','Minoru Inaba','Kenta Mijake','Naoki Makišima','Gara Takašima','Jasuhiro Fudžiwara','Nobujuki Hijama','Ako Majama','Rjó Kamon','Jósuke Akimoto','Takehiro Murozono','Kódži Išii','Sakiko Tamagawa','Juzuru Fudžimoto','Kijojuki Janada','Júdži Kiši','Takehiro Kojama','Júko Kaida','Jumi Kakazu','Miju Irino',"Asuka Tani'i",'Naomi Kusumi','Micuaki Hošino','Kósei Hirota','Širó Saitó','Tecuja Iwanaga','Šihori Niwa','Micuaki Madono','Eri Sendai','Júdži Mikimoto','Akiko Hiramacu','Kjósei Cukui','Takkó Išimori','Hideo Watanabe','Micuru Ogata','Rjúdži Saikači','Hiroši Ito','Jutaka Nakano','Rjúnosuke Óbajaši','Tóru Ókawa','Sajuri Sadaoka','Makoto Aoki','Keidžin Okuda','Kacumi Čó','Šúhei Sakaguči','Jódži Ueda',"Ken'iči Močizuki",'Taimei Suzuki','Tomoko Išimura','Tošihiko Nakadžima','Wataru Takagi','Júdži Ueda','Jošiko Sakakibara','Tecuo Mizutori','Óki Sugijama','Rikija Kojama','Makoto Jasumura','Jasuo Muramacu','Megumi Hajašibara','Kaho Kóda','Hirojuki Kinošita','Taró Jamaguči','Masajuki Kató','Jošijuki Kaneko','Arisa Ogasawara','Ikkjú Džuku','Tošihiko Miki','Maaja Sakamoto','Tošihiro Nakamura','Masao Harada','Ken Nišida','Masajo Hosono','Jukiko Tagami','Acuši Kakehaši','Daisuke Hirakawa','Masato Funaki','Hikari Jono','Takeši Marujama'],
basedOn:['Masamune Širó'],
screenplay:['Jošiki Sakurai','Šótaró Suga','Dai Saitó','Jutaka Ómacu',"Džun'iči Fudžisaku",'Kendži Kamijama','Júičiró Macuja'],
production:['Acuši Sugita','Júičiró Macuja','Hisanori Kunisaki'],
music:['Jóko Kanno'],
camera:['Kódži Tanaka'],
cut:["Džun'iči Uemacu"],
sound:['Kazuhiro Wakabajaši'],
scenography:['Júsuke Takeda','Kazuki Higašidži']},
{title:'Anne with an E',
titleCZ:'Anne s E na konci',
year:2017,
runtime:'20h 33min',
episodeRuntime:'43-89min',
countries:['Canada'],
genres:['Drama','History'],
director:['Paul Fox','Amanda Tapping','Anne Wheeler','Norma Bailey','Helen Shaver','Niki Caro','David Evans','Sandra Goldbacher','Patricia Rozema','Kim Nguyen'],
actors:['Amybeth McNulty','Geraldine James','R.H. Thomson','Dalila Bela','Lucas Jade Zumann','Corrine Koslo','Helen Johns','Aymeric Jett Montaz','Kyla Matthews','Jonathan Holmes','Dalmar Abuzeid','Miranda McKeon','Jacob Horsley','Glenna Walters','Christian Martyn','Philip Williams','Ryan Kiera Armstrong','Kyle Meagher','Joanna Douglas','Cory Gruter-Andrew','David Ingram','Hélène Robbie','Edie Inksetter','Martha Girvin','Alden Adair','Janet Porter','Adam Crew','Jim Annan','Wayne Best','Deborah Grover','Dan Lett','Moira Walley-Beckett','Kirsten Wendlandt','Jennifer Hardy CK','Greta Onieogou','Rob Ramsay','David Kirby','Nicolette Pearse','Cara Ricketts','Tanya Bevan','Carina Battrick','Brian Frank','Liisa Repo-Martell','Harper Gunn','Karen P. Brown','Kiawentiio','Brandon Oakes','Trenna Keating','Wesley French','Todd Campbell','Dylan Trowbridge','Brian Paul','Dana Jeffrey','Jim Codrington','Catherine Fitch','Jennifer Wigmore','Katherine Sorbey','Ted Atherton','Amos Crawley','Shawn Lawrence','Judy Marshak','Frank Moore','Andrew Gillies','Jacob Ursomarzo','Melanie Nicholls-King','Corinne Conley','Sheila McCarthy','Zoe Hatz','Ella Jonas Farlinger','Catherine McNally','Brenda Bazinet','Allan Michael Brunet','Madi Langdon','Alexandra Chaves','Jane Luk','Deborah Tennant','Callum Shoniker','Robert Clarke','Charlie Benger','Jeremy Crawford','Chandra Galasso','Stephen Tracey','Nathalie Toriel','Ian D. Clark','Theresa Tova','Teagan Sellers','Joey Coleman','Zenna Davis-Jones','Tammy Isbell','Lisa Codrington','Alexandre Crepet','Anna Bartlam','Ines Feghouli','Shannon McDonough'],
basedOn:['Lucy Maud Montgomery'],
screenplay:['Moira Walley-Beckett','Naledi Jackson','Shernold Edwards','Jane Maggs','Amanda Fahey','Tracey Deer','Kathryn Borel'],
production:['Susan Murdoch','John Calvert'],
music:['Ari Posner','Amin Bhatia'],
camera:['Bobby Shore','Catherine Lutes'],
cut:['David Coulson','D. Gillian Truster','Teresa Hannigan','Lisa Grootenboer','Roslyn Kalloo'],
sound:['Scott Shepherd','Alan deGraaf','Zenon Waschuk'],
scenography:['Friday Myers','Jean-François Campeau','Elliott Carew','Michele Brady'],
masks:['Alexandra Anger'],
costumes:['Anne Dixon']},
{title:'Byl jednou jeden dům',
titleCZ:'Byl jednou jeden dům',
year:1974,
runtime:'6h 12min',
episodeRuntime:'64-87min',
countries:['Czechoslovakia'],
genres:['Drama','War'],
director:['František Filip'],
actors:['Josef Somr','Jaroslava Obermaierová','Vladimír Menšík','Jiří Adamíra','Josef Abrhám','Miloš Nedbal','Vladimír Ráž','Alena Vránová','Josef Bláha','Libuše Švormová','Václav Postránecký','Jiří Sovák','Míla Myslíková','Jiří Hrzán','Zuzana Ondrouchová','Jana Hlaváčová','Josef Vinklář','Jaromír Hanzlík','František Kovářík','Karel Höger','Jiří Vala','Josef Větrovec','Dana Medřická','Eva Hudečková','Jan Skopeček','Slávka Budínová','Jan Libíček','Blažena Holišová','František Němec','Jana Šulcová','Marie Rosůlková','Petr Čepek','Svatopluk Beneš','Zdeněk Řehoř','Libuše Havelková','Jaroslav Moučka','Jaroslava Pokorná','Vladimír Šmeral','Otakar Brousek st.','Jan Teplý st.','Robert Vrchota','Vlastimila Vlková','Jaroslav Heyduk','Zdeněk Srstka','Slávka Hamouzová','Karel Smrž'],
screenplay:['Jan Otčenášek','Oldřich Daněk'],
music:['Jan F. Fischer'],
camera:['Rudolf Stahl ml.'],
cut:['Karel Kohout'],
sound:['Dobroslav Šrámek'],
scenography:['Jan Zázvorka'],
masks:['Stanislav Petřek'],
costumes:['Lída Novotná','Aša Teršová']},
{title:'Cyberpunk: Edgerunners',
titleCZ:'Cyberpunk: Edgerunners',
year:2022,
runtime:'4h 5min',
episodeRuntime:'23-27min',
countries:['Japan'],
genres:['Animation','Action','Sci-Fi'],
director:['Hirojuki Imaiši','Akira Amemija','Jošijuki Kaneko','Júiči Šimoidara','Tomojuki Munehiro'],
actors:['KENN','Aoi Júki','Hiroki Tóči','Mičiko Kaiden','Takako Honda','Wataru Takagi','Tomojo Kurosawa','Kazuhiko Inoue','Jurika Hino','Kendžiró Cuda','Akira Koga','Acuši Tamaru','Ajano Hamaguči','Hidenari Ugaki','Hitoši Bifu','Kaito Išikawa','Masaomi Jamahaši','Takanori Hošino','Komura Tecuo','Šunpei Kusano','Acuko Sakuraoka','Akira Kuwabara','Kento Širaiši','Jóhei Macuoka','Júsuke Sasaki','Takeši Hirabajaši','Rjósuke Higa','Rjó Šimokawa','Haruka Džinja','Kotomi Aihara','Emiko Takeuči','Anna Nagase','Marina Mizusaki','Tomomiči Nišimura','Šóto Kašii','Hiroki Macukawa','Jošito Jasuhara','Šigeo Kijama','Hikaru Tanaka','Jasujuki Kase','Megumi Sano','Šómaru Zóza','Seijú Fudžiwara','Kaoru Katakai','Sóma Saitó','Minoru Hirota','Cuguo Mogami','Miho Šinada','Tomoko Šiota','Hiroši Janaka','Tomojuki Šimura','Sajaka Óhara','Takajuki Nakacukasa','Juki Ominami','Júki Arai','Hajato Kimura','Takuja Makimura','Ken Mizukoši','Hiroko Kiso','Jukihiro Misono'],
screenplay:['Masahiko Ócuka','Jošiki Usa'],
music:['Akira Jamaoka'],
camera:['Tecuja Kawada'],
cut:['Masato Jošitake'],
sound:['Hiroki Urakari'],
scenography:['Masanobu Nomura']},
{title:'The Train of Childhood and Expectation',
titleCZ:'Vlak dětství a naděje',
year:1985,
runtime:null,
episodeRuntime:'6h 60min',
countries:['Czechoslovakia'],
genres:['Comedy','Drama','War'],
director:['Karel Kachyňa'],
actors:['Stanislav Zindulka','Helena Růžičková','Žaneta Fuchsová','Tereza Brodská','Gabriela Wilhelmová','Alena Vránová','Eva Svobodová','Blanka Lormanová','Laďka Kozderková','Naďa Konvalinková','Jiřina Jelenská','Jana Hlaváčová','Věra Galatíková','Bohumila Dolejšová','Nina Divíšková','Zuzana Bydžovská','Marie Brožová','Mahulena Bočanová','Jana Andresíková','Bohumil Vávra','Ivan Vyskočil','Václav Vydra nejml.','Pavel Vondruška','Oldřich Vlach','Václav Štekl','Zuzana Talpová','Zdeněk Srstka','Jan Skopeček','Roman Skamene','Otto Šimánek','Milan Riehs','Zdeněk Řehoř','Čestmír Řanda ml.','Jan Přeučil','Bronislav Poloczek','Jiří Pleskot','Michal Pešek','Zdeněk Ornest','Bořivoj Navrátil','Jiří Langmajer','Václav Kotva','Lubomír Kostelka','Vladimír Javorský','Karel Hábl','František Husák','Vladimír Hlavatý','Karel Heřmánek','Vlastimil Hašek','Ladislav Gerendáš','Karel Bělohradský','Karel Augusta','Oto Ševčík','Ivo Niederle','Vlastimil Bedrna','Miloslav Štibich','Jaroslava Pokorná','Jiřina Třebická','Stanislav Tříska','Pavel Pochylý','Miriam Brochová','Zora Jiráková','Svatava Hubeňáková','Eva Řepíková','Eva Trunečková','Jiří Knot','Luďa Marešová','Karel Linc','Igor Latta','Milan Starý','J. Vernarčík','Marian Marko','Viktor Hajný','Lubomír Mindoš','Jana Vychodilová','Jana Marková','Jarmila Švehlová','Lubomír Bryg','Marta Richterová','Zuzana Schmidová','Jiří Chmelař','Antonín Hardt','Dana Balounová','Stanislav Litera','Šárka Štembergová','Josef Kubíček','Zbyšek Olšovský','Karel Chromík','Petr Skarke','Alena Jánská','Alena Sasínová-Polarczyk','Václav Kaňkovský','Daniela Bakerová','František Kreuzmann','Petr Kosek','Jana Hlaváčková','Jana Eichlerová','Jaroslav Vozáb','Věra Nerušilová','Ferdinand Krůta','Otto Budín'],
basedOn:['Věra Sládková'],
screenplay:['Karel Kachyňa','Dušan Hamšík'],
music:['Luboš Fišer'],
camera:['Vladimír Smutný','Jan Čuřík'],
cut:['Jiří Brožek'],
sound:['Pavel Jelínek'],
scenography:['Jiří Matolín'],
masks:['Stanislav Petřek'],
costumes:['Běla Suchá','Eva Martincová']},
{title:'Locked Up (Antena 3 / Fox Version)',
titleCZ:'Vis a vis (Antena 3 / Fox verze)',
year:2015,
runtime:'42h 2min',
episodeRuntime:'43-80min',
countries:['Spain'],
genres:['Drama','Thriller'],
director:['Jesús Colmenar','David Molina Encinas','Sandra Gallego','Jesús Rodrigo','Marc Vigil','Alex Rodrigo','Ramón Salazar','Carles Torrens'],
actors:['Berta Vázquez','Alba Flores','María Isabel Díaz Lago','Marta Aledo','Najwa Nimri','Laura Baena','Jesús Castejón','Inma Cuevas','Maggie Civantos','Ramiro Blas','Roberto Enríquez','Alberto Velasco','Cristina Plazas','Daniel Ortiz','Harlys Becerra','Carlos Hipólito','Luis del Valle','Melina Matthews','Khaled Kouka','Claudia Placer','Yiyo Alonso','Irene Arcos','Itziar Castro','Ruth Díaz','Benjamín Vicuña','Adriana Paz','Ester Expósito','María Morales','Olivia Delcán','Farah Hamed','Raúl Tejón','Moussa Echarif','Adryen Mehdi','Abril Zamora','Ana Labordeta','Belén Cuesta','Sonia Almarcha','Reme Gómez','Mona Martínez','Verónika Moral','Baya Belal','Sara Vidorreta','Hui Chi Chiu','Ana Marzoa','Luís Callejo','Irene Anula','Cristina Marcos','Pedro Rudolphi','Georgina Amorós','Marta Nieto','Édgar Vittorino','Laura Quirós','Elena Seijo','Óscar de la Fuente','Pedro Beitia','Javier Mula','Hicham Malayo','Leticia Torres','Fernando Valdivielso','Julio Lázaro','Dunia Rodríguez','Martin Aslan'],
screenplay:['Marc Cistaré','Lucía Carballal','Iván Escobar','Álex Pina'],
music:['Manel Santisteban','Iván Martínez Lacámara'],
camera:['Sergi Bartrolí','Migue Amoedo','Curro Ferreira','Javier Castrejón'],
cut:['Manuela Díaz','Raúl Mora','Leire Alonso'],
sound:['José Ignacio Arrufat','Edi Osso-Raimondo'],
scenography:['Fernando González','Xabier Iriondo','Naiara Cortés'],
masks:['Sergio López'],
costumes:['Cristina Caspueñas']},
{title:'Pose',
titleCZ:'Pose',
year:2018,
runtime:'24h 50min',
episodeRuntime:'43-79min',
countries:['USA'],
genres:['Drama','Musical'],
director:['Ryan Murphy','Nelson Cragg','Gwyneth Horder-Payton','Silas Howard','Tina Mabry','Janet Mock','Steven Canals','Jennie Livingston'],
actors:['Michaela Jaé Rodriguez','Ryan Jamaal Swain','Indya Moore','Evan Peters','Kate Mara','Dominique Jackson','Billy Porter','Angelica Ross','Angel Bismark Curiel','Dyllón Burnside','Charlayne Woodard','James van der Beek','Jeremy McClain','Hailie Sahar','Kevin Interdonato','Nicholas Tucci','Kathryn Erbe','Christine Ebersole','E.J. Carroll','Christopher Meloni','Sandra Bernhard','Khalid Rivera','Jiggly Caliente','Our Lady J','David Granados','Jason A. Rodriguez','Samantha Grace Blumm','Alexia Garcia','Sol Pendavis','Trace Lysette','Bernadette Quigley','Jimmy Palumbo','Tamara M. Williams','Roslyn Ruff','Brian Donahue','Trudie Styler','Bob Adrian','Alexander DiPersia','Amelia Fowler','Sophie von Haselberg','Patti LuPone','Frank De Julio','Kevin Curtis','Peppermint','Woody Fu','Danny Johnson','Damaris Lewis','Heidi Armbruster','Courtney Sauls','Johnny Sibilly','Leiomy Maldonado','Austin Scott','Ian Whitt','Jamie Choi','Ethan Herschenfeld','Sebastian Chacon','Tibor Feldman','Valeria A. Avina','Zoey Luna','Flor De Liz Perez','Jayden Marine','Ianne Fields Stewart','Ken Holmes','Bret Lada','Amy Morse','Edward Carnevale','Jordan E. Cooper','John Borras','Cassie Beck','Charles Brice','Margaret Reed','Patrice Johnson','Annelise Cepero','Lynn Kim Do','Rhoyle Ivy King','Andre Ward','Jose Maria Aguila','Ledisi','Adam Grupper','Tiffany Denise Hobbs','Jari Jones','Danielle Cooper','Mia Fowler','Jeff Blumenkrantz','Ariel Eliaz','Adeola Role','Clark Carmichael','Gil Perez-Abraham','Patricia Black','Eddie Korbich'],
screenplay:['Brad Falchuk','Ryan Murphy','Janet Mock','Our Lady J','Steven Canals'],
production:['Lou Eyrich','Janet Mock','Our Lady J','Jeff Dickerson','Tanase Popa','Erica Kay'],
music:['Mac Quayle'],
camera:['Nelson Cragg','Simon Dennis','Andrei Bowden-Schwartz'],
cut:['Danielle Wang','Robert C. Wertman','Adriaan van Zyl','Greg Sirota','Shelly Westerman','Franzis Muller','Taylor Mason'],
sound:['Joe Earle','Adam Jenkins','Gary Megregian','Doug Andham','Joe White'],
scenography:['Judy Becker','Jamie Walker McCall','Mila Khalevich','Heather Loeffler','Shannon Nallan','Michael Nallan'],
masks:['Tim Harvey','Eryn Krueger Mekash','Rob Harmon','Michele Spooner','Mariko Miyagi','Rick Caroto','Chris Clark'],
costumes:['Lou Eyrich','Analucia McGorty']},
{title:'Scarlet Heart',
titleCZ:'Dalui yeonin :bobogyungsim ryeo',
year:2016,
runtime:'19h 57min',
episodeRuntime:'59-60min',
countries:['South Korea'],
genres:['Fantasy','History','Romance','Drama'],
director:['Kyoo-tae Kim'],
actors:['Joon-gi Lee','IU','Ha-neul Kang','Jong-hyeon Hong','Joo-hyeok Nam','Ji-soo Kim','Sun-woo Yoon','Han-na Kang','Seong-gyoon Kim','Seohyun','San-ho Kim','Baekhyun','Min-ki Jo','Ji-yeong Park','Kyeong-soon Jeong','Shi-eun Park','Hee-jin Woo','Z.Hera','Dong-il Seong','Byeong-mo Choi','Jeong-hak Park','Ki-joo Jin','Seo-hee Jang','Ga-eun Seo','Chae-mi Lee','Dong-yeong Hong','Kang-il Kim','Byeon Woo-seok'],
basedOn:['Tong Hua'],
screenplay:['Yoon-yeong Jo']},
{title:'Smiling Friends',
titleCZ:'Smiling Friends',
year:2020,
runtime:'1h 29min',
episodeRuntime:'11-12min',
countries:['USA'],
genres:['Animation','Comedy'],
director:['Michael Cusack','Zach Hadel'],
actors:['Michael Cusack','Zach Hadel','Finn Wolfhard','Nick Wolfhard','Mike Stoklasa','David Dore'],
screenplay:['Michael Cusack','Zach Hadel'],
production:['Ollie Green'],
music:['Brendan Caulfield'],
cut:['Tony Christopherson'],
sound:['Devon Bowman'],
scenography:['Zach Hadel']},
{title:'Half in the Bag',
titleCZ:'Half in the Bag',
year:2011,
runtime:null,
episodeRuntime:null,
countries:['USA'],
genres:['Comedy','Talk-show'],
director:['Mike Stoklasa','Jay Bauman'],
actors:['Mike Stoklasa','Jay Bauman','Rich Evans','Jack Packard','Tim Heidecker','Alexandre O. Philippe','Macaulay Culkin','Lora Story','Tim Higgins','Zach McLain','Gillian Bellinger','Hannah Spear'],
production:['Mike Stoklasa','Jay Bauman'],
cut:['Mike Stoklasa','Jay Bauman']},
{title:'Nula nula nula',
titleCZ:'Nula nula nula',
year:2020,
runtime:'7h 20min',
episodeRuntime:'48-67min',
countries:['Italy'],
genres:['Drama','Crime'],
director:['Janus Metz','Pablo Trapero','Stefano Sollima'],
actors:['Andrea Riseborough','Dane DeHaan','Gabriel Byrne','Érick Israel Consuelo','Giuseppe De Domenico','Mauricio Méndez','Harold Torres','Diego Cataño','Claudia Pineda','Nabiha Akkari','Seydina Baldé','Hawn Tran','Wayne Pére','Summer Selby','Julian Sedgwick','Ferruccio Ferrante','Jesús Lozano','Armando Comonfort Santiago','José Salof','Antonino Paone','Terese Aiello','Silvia Carusillo','Noé Hernández','Magnolia Nunez','Lucy Faust','Diana Mercado','Marco Antonio Aguirre','Mark Grosy','Adriano Chiaramida','Francesco Colella','Nika Perrone','Antonio Alveario','Angelo Campolo','Maurizio Cardillo','Walter Cordopatri','Anna Maria De Luca','Paolo Gasparini','Saverio Malara','Víctor Huggo Martin','Flavio Medina','Giovanni Serratore','Pablo Abitia','Dionysio Basco','Christopher Berry','Costantino Comito','Alessandro Lombardo','Marco Silani','Belén López','Pedro Joaquín','Fernando Cuautle','Tchéky Karyo','María del Carmen Félix','Raquel Robles','Dial Thiam','Samuel Vento','Carmelo Giordano','Moussa Sow','Norman Delgadillo','Michael Francis Horn','Ron Flagge','Carlos Moises','Luis Caballero','Martin Rojas','Gerardo Flores','Armando Silva','Elias Gael Cagliani','Sofia Martinez','Salvatore Spirli','Marina Crialesi','Francesco Brighel','Giuseppe Cutrullà','Raúl Galeana','Arturo Nahum','Carlos Balderrama','Victor Ugo Arana','Robert Korecki','José Carlos Rodríguez','Hussam Núñez','Giuseppe Pizzati','Ximena Falcón','Gian Piero Bonomo','Gioacchino La Rosa','Alberto González','Pepe Vasquez Cedeño','Alan Rodriguez','Heleanne Beltrán','Cynthia Agatón','Socorro Gonzalez Alvarez','Diomaye Augustin Ngom','Roger Sallah','Gbatie Hermann Zako','Diankou Sembene','Roch Peton','Lena Gueye','El Hadj Mammadou Sambe','Tchiky Toure','Souleymane Seye Ndiaye','Boubacar Sarr','Mamadou Lamine Ndiaye','Farid Larbi'],
basedOn:['Roberto Saviano'],
screenplay:['Max Hurwitz','Maddalena Ravagli','Leonardo Fasoli','Mauricio Katz','Roberto Saviano','Stefano Sollima','Stefano Bises'],
production:['Rola Bauer','Jonas Bauer'],
music:['Mogwai'],
camera:['Paolo Carnera','Romain Lacourbas'],
cut:['Hervé Schneid','Alejandro Brodersohn'],
sound:['Nadia Paone','Marco Coppolecchia'],
scenography:['Paki Meduri','Valeria Vecellio','Carlos Y. Jacques'],
masks:['Maria Solberg Lepre','Francesca Galafassi'],
costumes:['Veronica Fragola']},
{title:'sKORO NA mizině',
titleCZ:'sKORO NA mizině',
year:2020,
runtime:'3h 36min',
episodeRuntime:'22-35min',
countries:['Czechia'],
genres:['Short','Comedy'],
director:['Vladimír Skórka'],
actors:['Albert Čuba','Štěpán Kozub','Robin Ferro','Vladimír Polák','Jiří Langmajer','Adéla Gondíková','Jana Bernášková','Rudolf Merkner','Přemysl Bureš','Michal Sedláček','Lada Bělašková','Beáta Hrnčiříková','Michal Suchánek','Josef Kaluža','Petr Sedláček','Jaroslav Rusnák','Dimitrij Dostál','Jana Juříčková','Lukáš Oramus','Ondřej Malý','Kristýna Lipinová','Alena Sasínová-Polarczyk','Eva Čubová','Jan Lefner','Petr Kolečko','Marek Vašut','Honza Dědek','Roman Mrázik','Robert Mikluš','Barbora Jánová','Jiří Nekvasil','Milan Cimerák','Vladimír Skórka','Irena Pláteníková','Libor Hanslík','Jan Lyčka','Michal Schmidtmeyer','Kryštof Malec','Martin Benkó','František Perchlík','Dominik Gerža','David Tobi Tobiasz','Ondřej Kutaš','Jakub Šarjak','Michaela Dvořáková','Miroslav Poláček','Jiří Zahuta','Lukáš Niedoba','Tomáš Kuna','Václav Neužil ml.','Petr Rychlý','Robert Rosenberg','Paweł Deląg','Jakub Prachař'],
screenplay:['Martin Šimíček','Vladimír Skórka','Michal Suchánek','Petr Kolečko'],
music:['Viliam Béreš','Roman Holý'],
camera:['Jan Šťastný'],
cut:['Matěj Jankovský'],
sound:['Marek Ronec','Adam Šebesta','Filip Šnajdr'],
scenography:['Pavla Skaláková','Milan Celuch'],
masks:['Aneta Boháčová','Gabriela Kupková','Jitka Stauder','Rachel Stojkovová'],
costumes:['Jitka Stauder','Sylvie Siráňová','Eva Kotková','Sára Králová']},
{title:'Pohádky o mašinkách',
titleCZ:'Pohádky o mašinkách',
year:1985,
runtime:'1h 8min',
episodeRuntime:'6-8min',
countries:['Czechoslovakia'],
genres:['Animation','Fairytale'],
director:['Eduard Hofman'],
actors:['Vladimír Ráž'],
screenplay:['Olga Kafková'],
music:['Miloš Vacek'],
camera:['Jiří Větroň'],
cut:['Marie Zemanová']},
{title:'Father Ted',
titleCZ:'Father Ted',
year:1995,
runtime:'10h 33min',
episodeRuntime:'23-55min',
countries:['UK','Ireland'],
genres:['Comedy'],
director:['Andy De Emmony','Declan Lowney'],
actors:['Dermot Morgan',"Ardal O'Hanlon",'Frank Kelly','Pauline McLynn','Stephen Kennedy','Ben Keaton','Mark Doherty','Stephen Tompkinson','Richard Wilson','Brian Eno','Clare Grogan','Ed Byrne','Vernon Dobtcheff','Dermot Crowley','Pat Shortt','Graham Linehan','Paul Tylak','Charles Simon','Kevin Moore','Ozzie Yue','Denys Hawthorne','Tony Rohr','Jon Kenny','Graham Norton','Tommy Duggan','Lissa Evans','Jim Norton',"Gerry O'Brien",'Pat McGrath','Brendan Burke','Gemma Craven','James Berwick','Vass Anderson','Declan Lowney','Gerard McSorley','Dervla Kirwan','Kevin McKidd','Peadar Lamb','Ian Fitzgibbon','Maria Doyle Kennedy','Mal Whyte','Shay Gorman','Desmond Jordan','Paul Hickey','Neil McCaul','Arthur Mathews',"Rynagh O'Grady",'Paddy Ward','Tom Farrelly','Noelle Brown','Anna Livia Ryan','Nick Wymer','Joan Sheehy',"Mark O'Regan",'Niall Buggy','Rosemary Henderson'],
screenplay:['Graham Linehan','Arthur Mathews'],
camera:["Eugene O'Connor"],
scenography:['Andrew Howe-Davies'],
masks:['Christine Cant','Morna Ferguson'],
costumes:['Caroline Pitcher']},
{title:'Waco',
titleCZ:'Waco',
year:2018,
runtime:'4h 55min',
episodeRuntime:'48-53min',
countries:['USA'],
genres:['Drama','Crime'],
director:['John Erick Dowdle','Dennie Gordon'],
actors:['Taylor Kitsch','Melissa Benoist','Andrea Riseborough','Shea Whigham','Michael Shannon','John Leguizamo','Paul Sparks','Rory Culkin','Julia Garner','Demore Barnes','Camryn Manheim','Sarah Minnich','Steven Culp','Andy Umberger','Eric Lange','Annika Marks','Christopher Stanley','Duncan Joiner','Rich Ting','Jackamoe Buzzell','David Grant Wright','Mike Miller','Barbie Robertson','Glenn Fleshler','Ralph Alderman','Matthew Page','Tait Fletcher','Stephanie Kurtzuba','Kenneth Miller','Vivien Lyra Blair','Jermaine Washington','David Thibodeau','Gary W. Noesner','Vic Browder',"Jack O'Donnell",'Casey Messer','DTeflon','Lora Martinez-Cunningham','Rex Linn','Dan Rather','Cayen Martin','Sarah Murrey','Hans Christopher'],
basedOn:['David Thibodeau','Leon Whiteson','Gary W. Noesner'],
screenplay:['Salvatore Stabile','Drew Dowdle','John Erick Dowdle','Sarah Nicole Jones'],
production:['Kelly A. Manners'],
music:['Jordan Gagne','Jeff Russo'],
camera:['Todd McMullen'],
cut:['Elliot Greenberg','Christopher Nelson'],
sound:['Beau Borders'],
scenography:['Arvinder Greywal','Billy W. Ray',"Elaine O'Donnell",'David Best'],
masks:['John Caglione','Jr.','Emerald Ortega'],
costumes:['Karyn Wagner']},
{title:'The Victim',
titleCZ:'Oběť',
year:2019,
runtime:'3h 48min',
episodeRuntime:'57min',
countries:['UK'],
genres:['Drama','Crime','Mystery'],
director:['Niall MacCormick'],
actors:['Kelly Macdonald','John Hannah','Georgie Glen','Karla Crome','Cal MacAninch','Chloe Pirrie','Jamie Sives','Ramon Tikaram','Seylan Baxter','John Scougall','Isis Hainsworth','James Harkness','Andrew Rothney','Brian Ferguson','Robin Laing','Ben Bradley','David Goodall','Ceit Kearney'],
screenplay:['Rob Williams','Rob Williams'],
production:['Jenny Frayn'],
music:['Samuel Sim'],
camera:['Jan Jonaeus'],
cut:['Paul Knight'],
scenography:['Monica Black','Laura Donnelly'],
masks:['Lee Melrose']},
{title:'Zlá krev',
titleCZ:'Zlá krev',
year:1986,
runtime:'8h 30min',
episodeRuntime:'66-78min',
countries:['Czechoslovakia'],
genres:['Drama','History'],
director:['František Filip'],
actors:['Jiří Vala','Daniela Kolářová','Vladimír Ráž','Jiřina Jirásková','Václav Postránecký','Dagmar Havlová','Taťjana Medvecká','Bronislav Poloczek','Karel Augusta','Stanislav Remunda','Jana Gýrová','Iva Janžurová','Radovan Lukavský','Jaroslav Moučka','Martin Růžek','Luděk Munzar','Martin Růžek','Otomar Krejča ml.','Ilja Racek','Marek Brodský','Libuše Šafránková','Jiří Císler','Čestmír Řanda st.','Josef Abrhám','David Vejražka','Vladimír Dlouhý','Oldřich Vízner','Jaroslav Satoranský','Ilja Prachař','Ota Sklenčka','Jiří Pleskot','Martin Šotola','Vlastimil Drbal','Martin Zounar','Miroslav Zounar','Soběslav Sejk','Boris Rösner','Marcel Vašinka','Bořivoj Navrátil','Hana Brejchová','Milan Stehlík','Pavel Zedníček','Karel Heřmánek','Stanislav Fišer','Svatopluk Skládal','Jiří Holý','Otto Budín','Bedřich Prokoš','Josef Bláha','Lída Roubíková','Rudolf Hrušínský','Antonín Hardt','Miroslav Masopust','František Hanus','Zdeněk Kutil','Oldřich Velen','Ivo Niederle','Karel Koloušek','Milan Mach','Jiří Lír','Jaroslav Mareš','Mirko Musil','Jiří Bruder','Václav Vydra nejml.','Otakar Brousek st.','Jolana Maurerová-Zelinková','Josef Kubíček','Lena Birková','Jindřich Hinke','Petr Skarke','Martin Dejdar','Zdeněk Srstka','Adolf Kohuth','Zdeňka Sajfertová','Zuzana Skalická','Miloš Vavruška','Oldřich Janovský','Jaroslav Pešice','Vladimír Pospíšil','Markéta Valentová','Milan Pěkný','Josef Čáp','Miloslav Homola','Jaroslav Cmíral','Simona Postlerová','Petr Vacek','Svatopluk Skopal','Ladislav Chroust','Rostislav Kuba','Martin Mejzlík'],
basedOn:['Vladimír Neff'],
screenplay:['Otto Zelenka'],
music:['Karel Sklenička'],
camera:['Andrej Barla'],
cut:['Karel Kohout'],
sound:['Roman Hloch'],
scenography:['Karel Lier','Libuše Jahodová'],
masks:['František Havlíček','Libuše Beranová'],
costumes:['Lída Novotná','Jan Kropáček','Jana Ledecká']},
{title:'Life on Mars',
titleCZ:'Life on Mars',
year:2006,
runtime:null,
episodeRuntime:'16h 60min',
countries:['UK'],
genres:['Crime','Drama','Mystery'],
director:['S.J. Clarkson','John McKay','Bharat Nalluri','Andrew Gunn','John Alexander','Richard Clark'],
actors:['John Simm','Philip Glenister','Liz White','Dean Andrews','Joanne Froggatt','Archie Panjabi','Lee Ingleby','Stephanie Jacobsen','William Matheson','Kevin McNally','Ralph Brown','Steve Evets','Jason Watkins','Sam Hazeldine','Marshall Lancaster','Andrew Knott','Eva Pope',"Seamus O'Neill",'Paul Sharma',"John D'Leo",'Rebecca Atkinson','Anthony Flanagan','Noreen Kershaw','Ray Emmet Brown','Meryl Hampton','Matt Cross','Pablo Schreiber','Katherine Kelly','Joe Duttine','Paul Copley','Sean Gilder','John R. Walker','Paul McDonahue','Nicholas Blane','Ian Hanmore','Lee Ross','Matthew Rohman','Ozman Sirgood','Georgia Taylor','Lisa Millett','Ian Barritt','Kelly Wenham','Yasmin Bannerman','Tom Mannion','Lorraine Cheshire','Johnny Leeze','Antonia Rey','Nicholas Palliser','Olwen May','Stephen Bent','Ian Puleston-Davies','Andrew Tiernan','John Henshaw','Marc Warren','Brendan Mackey','Peter Wight','Reece Dinsdale','Alex Reid','Tim Plester','Jodie Hamblet','Jessalyn Wanlim','Chris Wilson','Nicky Bell','Ruth Millar','Georgia May Foote'],
screenplay:['Chris Chibnall','Julie Rutterford','Mark Greig','Matthew Graham','Ashley Pharoah'],
music:['Edmund Butt'],
camera:['Balazs Bolygo','Adam Suschitzky','Tim Palmer'],
cut:['Barney Pilling','Liana Del Giudice','Jeremy Strachan','Sarah Brewerton','Colin Fair','John Gow'],
scenography:['Matt Gant'],
costumes:['Emma Rosenthal']},
{title:'One Piece',
titleCZ:'One Piece',
year:2023,
runtime:'8h 32min',
episodeRuntime:'49-64min',
countries:['USA'],
genres:['Action','Adventure','Fantasy','Comedy','Drama'],
director:['Marc Jobst','Tim Southam','Josef Kubota Wladyka','Emma Sullivan'],
actors:['Makkenjú Arata','Emily Rudd','Iñaki Godoy','Taz Skylar','Jacob Romero','McKinley Belcher III','Vincent Regan','Jeff Ward','Morgan Davies','Peter Gadiot','Ian McShane','Aidan Scott','Michael Dorman','Langley Kirkwood','Ilia Isorelýs Paulino','Colton Osorio','Tamer Burjaq','Sven Ruygrok','Stevel Marc','Nicole Fortuin','Farouk Valley-Omar','Albert Pretorius','Brett Williams','Celeste Loots','Craig Fairbrass','Steven John Ward','Royston Stoffels','Brashaad Mayweather','Graham Hopkins','Christian Convery','Lily Fisher'],
basedOn:['Eiičiró Oda'],
screenplay:['Tom Hyndman','Steven Maeda','Matt Owens','Ian Stokes','Damani Johnson','Tiffany Greshler','Laura Jacqmin','Diego Gutierrez','Allison Weintraub','Lindsay Gelfand'],
production:['Amie Horiuchi','Takuma Naitô'],
music:['Sonya Belousova','Giona Ostinelli'],
camera:['Nicole Hirsch Whitaker','Trevor Michael Brown','Michael Swan','Michael Wood'],
cut:['Tessa Verfuss','Eric Litman','Kevin D. Ross','Tirsa Hackshaw','Marie Lee','Daniel Williams','Tim Kinzy'],
sound:['Mace Matiosian','Matt Vowles','Bryan Bowen'],
scenography:['Richard Bridgland','Ella Rushforth','Tom Hannam'],
masks:['Zayaan Damon'],
costumes:['Diana Cilliers']},
{title:'Shepherds Grazed Sheep',
titleCZ:'Pásli ovce valasi',
year:1973,
runtime:null,
episodeRuntime:'13x7min',
countries:['Czechoslovakia'],
genres:['Animation','Fairytale'],
director:['Ladislav Čapek'],
actors:['Jozef Kroner'],
music:['Jaroslav Celba'],
camera:['Eva Kargerová','Jaroslava Zimová'],
cut:['Zdenka Navrátilová'],
sound:['Benjamin Astrug']},
{title:'Dead Mountain: The Dyatlov Pass Incident',
titleCZ:'Pěreval Ďatlova',
year:2020,
runtime:'6h 38min',
episodeRuntime:'43-57min',
countries:['Russia'],
genres:['Drama','Mystery','Thriller'],
director:['Valerij Fedorovič','Pavel Kostomarov','Jevgenij Nikišov','Stěpan Gordejev'],
actors:['Ivan Mulin','Jegor Berojev','Pjotr Fjodorov','Marija Lugovaja','Alexandr Meťolkin','Maxim Jeměljanov','Maša Macel','Irina Lukina','Jurij Dějněkin','Roman Jevdokimov','Jevgenij Antropov','Andrej Dobrovolskij','Alexej Kirsanov','Oleg Vasilkov','Alexej Bardukov','Maxim Kostromykin','Pavel Vorožcov','Azamat Nigmanov','Andrej Arzjajev','Michail Kremer','Naděžda Markina','Ilja Ščerbinin','Vladimir Simonov','Jevgenij Tkačuk','Polina Černyšova','Arťjom Semakin','Alexej Sergejev','Lena Markova','Sergej Šakurov','Kirill Vasiljev','Alexej Věrtkov','Olga Makejeva','Sergej Rudzevič','Jevgenij Romancov','Jevgenij Sacharov','Sergej Něudačin','Alexej Ševčenkov','Christian Mock','Lena Tronina','Sergej Barovskij','Vladislav Pogiba','Jurij Loparjov','Fjodor Leonov','Sergej Karjakin','Pavel Kostomarov','Dmitrij Gusev','Julia Amme','Alexej Šemes','Ivan Jefremov','Jurij Anpilogov','Alexej Surenskij','Sergej Sťopin','Jevgenij Petrov','Alexandr Mělnikov','Vasilij Šmakov'],
screenplay:['Ilja Kulikov','Vasilij Vnukov'],
production:['Valerij Fedorovič','Jevgenij Nikišov'],
music:['Igor Syčov'],
camera:['Gleb Filatov','Alexej Strelov','David Chajznikov'],
cut:['Stěpan Gordejev'],
sound:['Roman Platonov','Vijay Rathinam'],
masks:['Anastasija Esadze'],
costumes:['Darja Fomina']},
{title:'O zvířátkách pana Krbce',
titleCZ:'O zvířátkách pana Krbce',
year:1977,
runtime:'1h 44min',
episodeRuntime:'8min',
countries:['Czechoslovakia'],
genres:['Animation','Fairytale'],
director:['Václav Bedřich'],
actors:['Josef Abrhám'],
screenplay:['Stanislav Havelka','Petr Chvojka'],
music:['Petr Skoumal'],
camera:['Vladimír Malík'],
cut:['Věra Benešová'],
sound:['Benjamin Astrug']},
{title:'NANA',
titleCZ:'NANA',
year:2006,
runtime:'18h 48min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Drama','Music','Romance'],
director:['Morio Asaka','Kandži Wakabajaši','Tóru Takahaši','Kódžiró Curuoka','Nanako Šimazaki','Masahiko Watanabe','Tomomasa Jamazaki','Šigetaka Ikeda'],
actors:['Romi Paku','Kaori','Anna Cučija','Aja Hirano',"Džun'iči Suwabe",'Tomokazu Seki','Hidejuki Tanaka',"Ken'iči Ogata",'Masaja Onosaka','Norio Wakamoto','Unšó Išizuka','Akira Išida','Tadaši Mijazawa','Akemi Okamura','Hiroki Takahaši','Takako Honda','Jošihisa Kawahara','Mika Kanai','Hidenobu Kiuči','Kózó Mito','Nacuki Mori','Jošinori Sonobe','Acuši Kakehaši','Majumi Jamaguči','Akiko','Keisuke Fudžii','Eriko Hirata','Kana Ómura','Šódži Izumi','Mijoko Šódži','Kazuo Hajaši','Čika Fudžimura','Tomoaki Ikeda','Megumi Kodžima','Sajaka Maeda'],
basedOn:['Ai Jazawa'],
screenplay:['Kazujuki Fudejasu','Tomoko Konparu','Tacuhiko Urahata'],
production:['Masao Marujama','Tošio Nakatani'],
music:['Tomoki Hasegawa'],
camera:['Jukihiro Masumoto'],
cut:['Kašiko Kimura','Jumi Džingudži'],
sound:['Masafumi Mima'],
scenography:['Tomojuki Šimizu']},
{title:'The Cyanide & Happiness Show',
titleCZ:'The Cyanide & Happiness Show',
year:2014,
runtime:'9h 25min',
episodeRuntime:'11-15min',
countries:['USA'],
genres:['Animation','Comedy'],
director:['Rob DenBleyker','Dave McElfatrick','Kris Wilson','Mike Salcedo','Joel Watson'],
actors:['Joel Watson','Dave McElfatrick','Rob DenBleyker','Mike Salcedo','Kris Wilson','Andrew W.K.','Zach Hadel','Mike Parker','Taylor Ransom','Ben Governale','Kelsey Gunn','Michael Rousselet'],
screenplay:['Rob DenBleyker','Dave McElfatrick','Kris Wilson','Mike Salcedo','Matt Melvin','Joel Watson'],
production:['Felipe Gutierrez','Greg Slagel','Laura Dimaio','Helen Lebeau','Sultan Saeed Al Darmaki'],
music:['Steve Lehmann','Ben Governale'],
cut:['Thaddeus Grant Fenton','Taylor Ransom'],
sound:['Ben Governale']},
{title:'Best of the Worst',
titleCZ:'Best of the Worst',
year:2013,
runtime:null,
episodeRuntime:null,
countries:['USA'],
genres:['Comedy','Talk-show'],
director:['Mike Stoklasa','Jay Bauman','Rich Evans','Max Landis'],
actors:['Mike Stoklasa','Jay Bauman','Rich Evans','Tim Higgins','Jack Packard','Gillian Bellinger','Len Kabasinski','Colin Cunningham','Max Landis','Simon Barrett','Macaulay Culkin','Patton Oswalt','Jack Quaid'],
screenplay:['Rich Evans','Mike Stoklasa'],
production:['Rich Evans'],
music:['Rich Evans'],
cut:['Andy Holton','Jay Bauman','Mike Stoklasa'],
scenography:['Rich Evans']},
{title:'Tisícročná včela',
titleCZ:'Tisícročná včela',
year:1983,
runtime:'3h 46min',
episodeRuntime:'55-58min',
countries:['Czechoslovakia','Germany','Austria'],
genres:['Drama','Comedy','History'],
director:['Juraj Jakubisko'],
actors:['Jozef Kroner','Štefan Kvietik','Michal Dočolomanský','Jana Janovská','Eva Jakoubková','Jana Dolanská','Ivana Valešová','Jiří Císler','Martin Peterich','Zdeněk Blažek','Igor Čilík','Milan Kiš','Ivan Drozdy','Zuzana Bydžovská','Štefan Mišovic','Václav Šimice','Katarína Synková','Viliam Polónyi','Bára Štěpánová','Hugo Kaminský','Hana Lančíková','Zdeněk Dušek','Jana Březinová','Pavol Mikulík','Samuel Adamčík','Ján Mildner','Vladimír Kostovič','Pavla Severinová','Béla Várady','Andrej Rudavský','Augustín Kubán','Jiří Klepl','Štefan Šafárik','Peter Kočiš','František Kovár','Vladimír Černý','Hana Gregorová','Emil Horváth st.','Štefan Kožka','Lotár Radványi','Teodor Piovarči','Radan Rusev','Jozef Mokoš','Jozef Husár','Jana Stehnová-Čechová','Jaromír Kučera','Arnošt Goldflam','Natália Hasprová','Jana Oľhová','Peter Maťo','Daniel Vychopeň','Andrej Hryc','Mátyás Dráfi','Ivan Rumanovský','Branislav Uherek','Darina Maťasová','Michal Dlouhý','Jozef Jakubec','Roman Začka','Peter Weisman','Miroslav Maroň','Dušan Šagát','Václav Baur','Miki Kučera','Štefan Figura','Svatopluk Mohapl','Žaneta Jakubisková','Vladimír Kittler','Robo Laurinec','Jozef Belan','Edita Gallová','Miluše Šplechtová','Marek Motloch','Zlatica Gillová','Anna Javorková'],
basedOn:['Peter Jaroš'],
screenplay:['Peter Jaroš','Juraj Jakubisko','Jozef Paštéka'],
music:['Petr Hapka'],
camera:['Stanislav Doršic'],
cut:['Judita Fatulová','Patrik Pašš'],
sound:['Pavol Sásik'],
scenography:['Miloš Kalina'],
masks:['Anita Hroššová'],
costumes:['Milan Čorba']},
{title:'Ponorka',
titleCZ:'Ponorka',
year:1985,
runtime:null,
episodeRuntime:'3x105min',
countries:['Germany'],
genres:['Drama','War'],
director:['Wolfgang Petersen'],
actors:['Jürgen Prochnow','Herbert Grönemeyer','Klaus Wennemann','Hubertus Bengsch','Martin Semmelrogge','Bernd Tauber','Erwin Leder','Martin May','Uwe Ochsenknecht','Heinz Hoenig','Otto Sander','Günter Lamprecht','Sky du Mont','Oliver Stritzel','Rita Cadillac','Jan Fedder','Ralf Richter','Joachim Bernhard','Claude-Oliver Rudolph','Dirk Salomon','Konrad Becker','Lutz Schnell'],
basedOn:['Lothar G. Buchheim'],
screenplay:['Wolfgang Petersen'],
production:['Günter Rohrbach'],
music:['Klaus Doldinger'],
camera:['Jost Vacano','Wolfgang Treu','Peter Maiwald','Leander R. Loosen'],
cut:['Hannes Nikel'],
sound:['Milan Bor','Werner Böhm','Stanislav Litera','Heinz Schürer','Karsten Ullrich'],
scenography:['Rolf Zehetbauer','Götz Weidner','Götz Weidner','Rolf Zehetbauer'],
masks:['Ago von Sperl','Alfred Rasche','Rüdiger von Sperl'],
costumes:['Monika Bauert']},
{title:'Horace and Pete',
titleCZ:'Horace and Pete',
year:2016,
runtime:'7h 17min',
episodeRuntime:'30-67min',
countries:['USA'],
genres:['Comedy','Drama'],
director:['Louis C.K.'],
actors:['Louis C.K.','Steve Buscemi','Edie Falco','Steven Wright','Kurt Metzger','Alan Alda','Jessica Lange','Aidy Bryant','Maria Dizzia','Nina Arianda','Laurie Metcalf','Rebecca Hall','Colin Quinn','Tom Noonan','Reg E. Cathey','Nick Di Paolo','Lucy Taylor','Angus T. Jones','Paul Simon','Karen Pittman','Craig muMs Grant','Deborah Offner','Zach Cherry','Charles Techman','Sofia Hublitz','Julio Torres','Hannah Dunne','Rick Shapiro','Kyle Beltran','Lynne Koplitz','Joanna Bradley'],
screenplay:['Louis C.K.'],
production:['Ryan Cunningham'],
music:['Paul Simon'],
camera:['Paul Koestner'],
cut:['Gina Sansom'],
scenography:['Amy Beth Silver'],
costumes:['Vicki Farrell']},
{title:'Young Justice',
titleCZ:'Young Justice',
year:2010,
runtime:'36h 56min',
episodeRuntime:'22-27min',
countries:['USA'],
genres:['Animation','Action','Adventure'],
director:['Jay Oliva','Melchior Zwyer','Victor Cook','Matt Youngberg','Christopher Berkeley','Vinton Heuck','Christina Sotta','Tim Divar','Sam Liu','Michael Chang','Lauren Montgomery','Doug Murphy','Seung Bong Lim','Yangho Ji'],
actors:['Danica McKellar','Jesse McCartney','Nolan North','René Auberjonois','George Eads','Bruce Greenwood','Phil LaMarr','Jason Spisak','Masasa Moyo','Rob Lowe','Michael Trucco','Marina Sirtis','Danny Trejo','Tara Strong','Yuri Lowenthal','Brent Spiner','Adam Baldwin','Bill Fagerbakke','Peter MacNicol','Stephen Root','Alan Tudyk','Khary Payton','Michael T. Weiss','Kevin Grevioux','Wentworth Miller','Nick Chinlund','William Morgan Sheppard','Lacey Chabert','Nicole Dubuc','Stephanie Lemelin','Vanessa Marshall','Jacqueline Obradors','Júdži Okumoto','Kevin Michael Richardson','Kari Wahlgren','Denise Boutte','Roger Craig Smith','Greg Weisman','Keone Young','Robert Ochoa','Gregg Rainwater','Alyson Stoner','Fred Tatasciore','Mae Whitman','Jason Marsden','Erick Lopez','Bryton James','Kelly Hu','Cameron Bowen','Troy Baker','Steve Blum','Greg Cipes','Grey Griffin','Mark Rolston','Whitney Moore','Josh Keaton','Michael-Leon Wooley','Robbie Daymond','Kath Soucie','Zeno Robinson','David Sobolov','Ben Diskin','Carl Lumbly','Hynden Walch','Dee Bradley Baker','Usman Ally','David Kaye','Deborah Strang','Lauren Tom','D.B. Woodside','David Shaughnessy','Daniela Bobadilla','Cree Summer','Logan Browning','Oded Fehr','Joel Swetow','Gwendoline Yeo','Jeff Bennett','Kelly Stables','Tiya Sircar','James Arnold Taylor','Nika Futterman','Phil Morris','Geoff Pierson','Crispin Freeman','Keith Szarabajka','Miguel Ferrer','John de Lancie','Arnold Vosloo','Edward Asner','Dave Franco','Adrian Pasdar','Sheryl Lee Ralph','James Remar','Sarah Shahi','Corey Burton','Alyssa Milano','Chad Lowe','Ariel Winter','Nolan North'],
basedOn:['Bob Kane','Bill Finger','William Moulton Marston','John Broome','Gil Kane','John Byrne','Robert Kanigher','Martin Pasko','Martin Nodell','Jack Kirby','J.M. DeMatteis','Chuck Dixon','Gary Frank','Kevin VanHook','Cary Bates','Gene Colan','Brandon Vietti','Greg Weisman','John Rogers','Todd McFarlane','Bill Mantlo'],
screenplay:['Nicole Dubuc','Greg Weisman','Kevin Hopps','Brandon Vietti','Mae Catt','Paul Giacoppo','Andrew Robinson','Tom Pugsley','Joshua Hale Fialkov','Peter David','Kevin Grevioux','Brian Hohlfeld','Rich Fogel','Khary Payton','Jonathan Callan','Charlotte Fullerton','Michael Vogel','Jon Weisman','Alan Moore','Francisco Paredes','James Krieg','Andrew Blanchette','Jake Baumgart','Nida Chowdhry','Taneka Stotts','Giancarlo Volpe','Aaron Sparrow','Akira Mark Fujita','Jeremy Adams'],
production:['Greg Weisman','Brandon Vietti','Leanne Moreau'],
music:['Kristopher Carter','Lolita Ritmanis','Michael McCuistion'],
cut:['Bruce King','Cris Mertens','Jhoanne Reyes'],
sound:['Carlos Sanches','Josh Eckberg','Zach Martin'],
scenography:['Phil Bourassa']},
{title:'Mind Your Language',
titleCZ:'Mind Your Language',
year:1977,
runtime:'17h 28min',
episodeRuntime:'24-26min',
countries:['UK'],
genres:['Comedy'],
director:['Stuart Allen'],
actors:['Barry Evans','George Camiller','Jacki Harding','Zara Nutley','Ricardo Montez','Albert Moses','Kevork Malikyan','Jamila Massey','Françoise Pascal','Pik Sen Lim','Zohra Sehgal','Vincent Wong','Robert Dorning','Damaris Hayman','Blake Butler','Lucy Griffiths','Harry Littlewood','Barbara Keogh','Claire Davenport','Noel Coleman','Ray Marioni','Charu Bala Chokshi','Rita Webb','Russell Hunter','Dorothea Phillips','Tommy Godfrey','Joan Heath','Michael Sheard','George Tovey','Ann Way','George A. Cooper','Charles Rayford','John Quayle','Shaun Curry',"Patrick O'Connell",'Michae Stainton','Arthur Mullard','Margaret Courtenay','David King','James Marcus','Anna Bergman','Russell Harty','Gyearbuor Asante','Anthony Jackson'],
screenplay:['Vince Powell'],
production:['Stuart Allen'],
music:['Max Harris'],
scenography:['Colin Monk','Mike Oxley','Jack Robinson'],
masks:['Rosemary Field','Margaret Palphramand'],
costumes:['Graham Williams','Robin Pidcock']},
{title:'The Defender',
titleCZ:'Ochránce',
year:2021,
runtime:'10h 40min',
episodeRuntime:'60-68min',
countries:['Czechia'],
genres:['Crime','Drama'],
director:['Tereza Kopáčová','Tomáš Mašín'],
actors:['Lukáš Vaculík','Iveta Dušková','Jaroslav Plesl','Pavel Řezníček','Agáta Kryštůfková','Barbora Kodetová','Lucie Ducháčková','Petra Hřebíčková','Jakub Ludvík','Lukáš Veselý','Miroslav Vladyka','Jan Vondráček','Jiří Havelka','Pavla Kosíková','Zora Poulová Valchařová','Vanda Hybnerová','Tomáš Mrvík','Martha Issová','Adam Solar','Vladimír Javorský','Jan Čenský','Lucie Juřičková','Jitka Sedláčková','Tony Mašek','Martin Šnajdr','Vendelín Urban','Eva Vrbková','Anita Krausová','Marek Pospíchal','Dušan Sitek','Martin Kubačák','Tereza Těžká','Michaela Jílková','Bohumil Klepetko','Martin Sobotka','Jan Holík','Jaromíra Mílová','Tomáš Karger','Sylvie Tomsová','Václav Svoboda','Matěj Pour','Prokop Zach','Jan Maršál','Filip František Červenka','Adam Kořán','Vasil Fridrich','Karol Csino','Matěj Dadák','Valentýn Pokorný','Jakub Maršál','Robert Nebřenský','Nataša Gáčová','Martin Siničák','Klára Oltová','Julius Oračko','Michal Sedláček','Petra Špindlerová','Daniel Tůma','Matyáš Řezníček','Lenka Andelová','Martin Dusbaba','Jan Šraitr','Lucie Štěpánková','Miloslav König','Ladislav Hampl','Anna Polívková','Lukáš Rous','Natálie Drabiščáková','Martina Eliášová','Marie Štípková','Sophia Šporclová','Jakub Štáfek','Mariana Novotná','Zita Morávková','Jiří Fero Burda','Štěpán Lustyk','Milan Enčev','Renata Visnerová-Prokopová','Sebastian Petrů','Václav Hubka','Tobiáš Haertl','Ivana Uhlířová','Petr Lněnička','Přemysl Bureš','Zuzana Zlatohlávková','Matěj Havelka','Roman Mrázik','Jiří Bábek','Matylda Homolová','Lucie Domesová','Melika Yildiz','Adam Vohánka','Viktor Limr','Michal Marko','Ondřej Běhan','Jakub Rezek','Tomáš Dalecký','Lucie Klímová','Michal Dalecký','Petr Buchta'],
screenplay:['Tomáš Feřtek','Matěj Podzimek'],
production:['Michal Reitler'],
music:['Jiří Hájek'],
camera:['Pavel Berkovič','Dušan Husár','Anna Smoroňová'],
cut:['Michal Hýka'],
sound:['Marek Hart','Tomáš Zůbek'],
scenography:['Mariana Kuchařová'],
masks:['Jiří Sadílek','Michaela Kittlerová','Lenka Dýcková','Tomáš Richter'],
costumes:['Vladimíra Fomínová','Tereza Kopecká']},
{title:'Line of Duty',
titleCZ:'Line of Duty',
year:2012,
runtime:'35h 42min',
episodeRuntime:'56-87min',
countries:['UK'],
genres:['Crime','Drama','Thriller','Mystery'],
director:['David Caffrey','Douglas Mackinnon','Michael Keillor','Daniel Nettheim','John Strickland','Jed Mercurio'],
actors:['Martin Compston','Vicky McClure','Adrian Dunbar','Lennie James','Neil Morrissey','Craig Parkinson','Kate Ashfield','Claire Keelan','Owen Teale','Gina McKee','Paul Higgins','Elisa Lasowski','Charlotte Spencer','Claire-Louise Cordwell','Julia Krynke','Heather Craney','Mark Bonnar','Sacha Dhawan','Mary Moulds','Lucy Cray-Miller','Ian Beattie','Niall Cusack','Laurence Doherty','Richard Buick','Richard Doubleday','Desmond Edwards','Roman Beguns','Simon Millar','Alison Lintott','Tony Pitts','Tomi May','Simon Coury','Christina Chong','Darren Morfitt','Adjoa Andoh','Michael Nardone','Vicky Hall','Brian Miller','Melanie Kilburn','Lisa Palfrey','Richard Huw','Leanne Best','Nigel Boyle','Philip Wright','Royce Pierreson','Elizabeth Hill','Sue Kelly','Nick Owenford','Brian McCardie','Keeley Hawes','Steve Toussaint','Liz White','Jeany Spark','Jessica Raine','Claire Hackett','Andrea Irvine','Shaun Mason','Daniel Mays','Will Mellor','Shaun Parkes','Arsher Ali','Aiysha Hart',"Rebecca O'Mara",'Polly Walker','Jonas Armstrong','George Costigan','Shashi Rami','David Ryan','Paul Kennedy','Lee Ingleby','Gaite Jansen','Claudia Jessie','Rhodri Lewis','Henry Priest Miller','Thandiwe Newton','Mark Stobbart','Jason Watkins','Patrick FitzSymons','Andy Kellegher','Patrick Baladi','Chris Coghill','Mary Healey','Mark Quigley','Chris Wilson','Poppy Miller',"Tara Lynne O'Neill",'Stephen Graham','Amy De Bhrún','Rosa Escoda','Karolina Koziol','Rochenda Sandall','Joanne Crawford','David Maybrick','Brian Ferguson','Sian Reese-Williams','Scott Reid','Laura Elphinstone','Antonio Magro','Natalie Gavin','Harriet Cains'],
screenplay:['Jed Mercurio'],
production:['Cait Collins'],
music:['Carly Paradis'],
camera:["Ruairí O'Brien",'Stephen Murphy','Ray Carlin','Anna Valdez-Hanks'],
cut:['Steve Singleton','David Blackmore','Dominic Strevens'],
sound:['Franklin Jones Jr.','Mathew Knights'],
scenography:['Edward Thomas','Tom Brown','Gillian Devenney','Patrick Creighton','Barbara Ann Carville'],
masks:['Ashley Hill'],
costumes:['Maggie Donnelly']},
{title:'Daria',
titleCZ:'Daria',
year:1997,
runtime:'22h 30min',
episodeRuntime:'20-23min',
countries:['USA','South Korea'],
genres:['Animation','Comedy'],
director:['Karen Disher','Sue Perrotto','Eric Fogel','Chris Prynoski','Aaron Augenblick','Ray Kosarin','Tony Kluck','Guy Moore','Patrick Smith','Joey Ahlbum','Karen Hydendahl','Choon Man Lee','Ken Kimmelman','Paul Sparagano'],
actors:['Tracy Grandstaff','Wendy Hoopes','Julián Rebolledo','John Lynn','Lisa Kathleen Collins','Ashley Paige Albert','Jessica Cydnee Jackson','Alvaro J. Gonzalez','Sarah Drew','Nora Laudani','Steven Huppert','Geoffrey Arend','Russell Hankin','Tim Novikoff','Wass Stevens','Karen Disher','Kevin Daniels','Zeke Farrow','Amy Bennett','Bart Fasbender','Eric Fogel','Ray Kosarin','Liz Maccie','Hardy Rawls','Tony Pipitone','Marc Thompson','Paul Williams'],
screenplay:['Glenn Eichler','Larry Doyle','Peter Gaffney','Neena Beber','Sam Johnson','Dan Vebber','Jill Cargerman','Jacquelyn Reingold','Sam Johnson','Chris Marcil','Laura Kightlinger','Rachel Lipman','Ron Corcillo','Jonathan Greenberg'],
production:['Glenn Eichler','John Andrews'],
cut:['Karen Sztajnberg'],
scenography:['Karen Hydendahl']},
{title:'Gangs of London',
titleCZ:'Gangs of London',
year:2020,
runtime:'24h 31min',
episodeRuntime:'49-87min',
countries:['UK'],
genres:['Drama','Crime'],
director:['Xavier Gens','Gareth Evans','Corin Hardy','Marcela Said','Nima Nourizadeh'],
actors:['Joe Cole','Ṣọpẹ Dìrísù','Michelle Fairley','Colm Meaney','Lucian Msamati','Paapa Essiedu','Brian Vernel','Pippa Bennett-Warner','Mark Lewis Jones','Jing Lusi','Richard Harrington','David Bradley','Adrian Bower','Narges Rashidi','Orli Shuka','David Avery','Mads Koudal','Ray Panthaki','Valene Kane','Emmett J. Scanlan','Darren Evans','Constantine Gregory','Aksel Üstün','Shervin Alenabi','Shaq B. Grant','Serena Kennedy','Gordon Alexander','Lobo Chan','Richard Pepple','Alina Ioana Serban','Laura Bach','Corin Hardy','Arta Dobroshi','Sharon Morgan','Nebli Basani','Owain Gwynn','Ioan Hefin','Pavel Douglas','Ian Beattie','Phillip Ray Tommy','Victoria Broom','Caroline Lee-Johnson','Lili Miller','Olivier Richters','Aled ap Steffan','Adam J. Bernard','Tom Christian','Jude Akuwudike','Salem Kali','Aymen Hamdouchi','Fady Elsayed','Sammy Broly','Waleed Zuaiter','Rom Blanco','Amanda Drew','Jake Curran','Ronan Raftery','Louis Dempsey','Tim Berrington','Cornell John','Colm Meaney','Pete MacHale','Tony Merritt','Eva-Jane Willis','Florist Bajgora','Aiste S. Gram','Elena Valdameri'],
screenplay:['Gareth Evans','Claire Wilson','Carl Joos','Joe Murtagh','Matt Flannery','Peter Berry','Lauren Sequeira','Tom Butterworth','Danusia Samal','Rowan Athale','Steve Searle'],
production:['Hugh Warren','Ed Talfan','Stella Nwimo','Steve Searle'],
music:['Aria Prayogi','Fajar Yuskemal'],
camera:['Martijn van Broekhuizen','Laurent Barès','Matt Flannery','Petrus Sjövik','Björn Charpentier'],
cut:['Sara Jones','Johnny Rayner','Harrison Wall','Julian Rodd','Mark Davis'],
scenography:['Matt Gant','Megan Bosaw'],
costumes:['Jane Spicer','David Wolfe']},
{title:'Pingu',
titleCZ:'Pingu',
year:1990,
runtime:null,
episodeRuntime:'13h 5min',
countries:['Switzerland','UK'],
genres:['Animation','Comedy','Family'],
director:['Liz Whitaker','Otmar Gutmann','Steve Cox','Nick Herbert'],
actors:['Carlo Bonomi','David Sant','Marcello Magni'],
screenplay:['Otmar Gutmann','Steve Cox','Jackie Cockle','Liz Whitaker'],
production:['Bella Reekie'],
music:['Keith Hopwood','Amin Bhatia'],
cut:['Jane Hicks']},
{title:'Suspicion',
titleCZ:'Podezření',
year:2022,
runtime:'3h 28min',
episodeRuntime:'66-73min',
countries:['Czechia','France'],
genres:['Drama','Crime'],
director:['Michal Blaško'],
actors:['Klára Melíšková','Denisa Barešová','Miroslav Hanuš','Ivan Trojan','Johana Matoušková','Milena Steinmasslová','Jan Nedbal','Marek Pospíchal','Elizaveta Maximová','Petr Lněnička','Klára Pollertová-Trojanová','Jiří Štrébl','Zita Morávková','David Máj','Jaroslav Vlach','Petr Jeništa','Jakub Špalek','Jiří Bábek','Eva Novotná','Inna Žulina','Natálie Drabiščáková','Viera Pavlíková','Karin Bílíková Vápeníčková','Miluše Hradská','Bára Fišerová','Tomáš Petřík','Karla Štaubertová','Pavel Batěk','Ladislav Hampl','Antonie Rašilovová','Ema Businská','Antonio Šoposki','Jakub Rezek','Adam Vohánka','Petr Reif','Jan Bidlas','Magdaléna Borová','Nataša Bednářová','Viktor Dvořák','Barbora Bočková','Igor Chmela','Lucie Domesová','Matěj Merunka','Madla Lážnovská','Anna Bazgerová','Jana Jiskrová','Jitka Sedláčková','Malvína Pachlová','Tereza Groszmannová','Jiří Černý','Jan Slovák','Magdaléna Pittnerová','Viktor Zavadil','Ondřej Bauer','Marie Ludvíková','Lenka Breeding','Sára Štěpánová','Jan Šraitr'],
screenplay:['Štěpán Hulík'],
production:['Jakub Viktorín','Tomáš Hrubý','Pavla Janoušková Kubečková'],
music:['Jonatán Pastirčák'],
camera:['Adam Mach'],
cut:['Anna Johnson Ryndová'],
sound:['Jan Šulcek','Jakub Jurásek'],
scenography:['Stella Šonková'],
masks:['Eva Ungrová-Malíková'],
costumes:['Helena Tavelová']},
{title:'My Mad Fat Diary',
titleCZ:'My Mad Fat Diary',
year:2013,
runtime:'12h 34min',
episodeRuntime:'45-48min',
countries:['UK'],
genres:['Comedy','Drama'],
director:['Tim Kirkby','Benjamin Caron','Vanessa Caswill','Anthony Philipson','Luke Snellin','Alex Winckler'],
actors:['Sharon Rooney','Jodie Comer','Ciara Baxendale','Dan Cohen','Ian Hart','Claire Rushbrook','Nico Mirallegro','Jordan Murphy','Darren Evans','Debra Stephenson','Sacha Parkinson','Nick Preston','Eliot Otis Brown Walters','Turlough Convery','Tony Pitts','Tim Berrington','Shazad Latif','Jodie Hamblet','Daniel Fitzsimons','Hazel Ellerby','Chris Wilson','James Burrows','Julien Ball','Mark Oliver Everett','Sophie Stanton','Keith Allen','Karl Davies','Faye Marsay','Lolita Chakrabarti','Nicola Harrison','James Eeles','Terry Haywood','Okorie Chukwu','Soner Metin','Kenneth Collard','Chris Martin Hill','Kirsty Armstrong'],
screenplay:['Laura Neal','George Kay','Tom Bidwell'],
production:['Jules Hussey'],
music:['Daniel Pemberton','Richard Spiller'],
camera:['David Marsh','Giulio Biccari','Suzie Lavelle'],
cut:['Tom Hemmings','Adam Bosman'],
sound:['Blair Jollands','Grant Bridgeman','Mathew Knights'],
scenography:['Tim Dickel'],
masks:['Donald McInnes']},
{title:'PSYCHO-PASS',
titleCZ:'Psycho-Pass',
year:2012,
runtime:'18h 47min',
episodeRuntime:'23-46min',
countries:['Japan'],
genres:['Animation','Action','Crime','Psychology','Sci-Fi','Thriller'],
director:['Kacujuki Motohiro','Sajo Jamamoto','Jukio Nišimoto','Naojoši Šiotani','Kjóhei Išiguro','Kijotaka Suzuki','Rjóta Itó','Tošijuki Kóno','Tomoja Takahaši','Takaši Andó','Jódži Sató','Kaoru Suzuki','Tomoko Hiramuki','Šintaró Itoga','Keisuke Kodžima','Kacuja Šigehara','Jasuo Edžima','Hirotaka Mori','Tomomi Kamija','Tomojuki Kurokawa','Jasuhiro Geši','Kazuja Aiura','Fumiaki Kataoka','Akie Išii','Tošijuki Sone',"Šun'iči Jošizawa",'Kazuo Sakai','Hirotaka Endó','Jutaka Hirata','Satoši Takafudži','Kacumi Terahigaši'],
actors:['Tomokazu Seki','Takahiro Sakurai','Kana Hanazawa','Kendži Nodžima','Mijuki Sawaširo','Ai Kajano','Akeno Watanabe','Kotori Koiwai','Maaja Sakamoto','Takehito Kojasu','Teššó Genda','Šizuka Itó','Akira Išida','Ajumi Fudžimura','Jasunori Masutani','Kenta Mijake','Takahiro Mizušima','Hadžime Iidžima','Kósuke Toriumi','Ajane Sakura','Jošiko Sakakibara','Noriko Hidaka','Šintaró Asanuma',"Džun'iči Janagita",'Satoši Curuoka','Kinrjú Arimoto','Nobunaga Šimazaki','Masumi Asano','Isamu Júsen','Makoto Furukawa','Kacumi Čó','Kazuhiro Jamadži','Takeaki Masujama','Nacumi Takamori','Kendži Kitamura','Ikumi Nakagami','Subaru Kimura','Kanehira Jamamoto','Júja Učida','Kótaró Nišijama','Takehiro Hasu','Mucumi Sasaki','Kengo Kawaniši','Ikuko Tani','Rjóhei Kimura','Daiki Jamašita','Masaši Ebara','Marina Inoue','Takajuki Sugó','Hiroki Tóči','Kazue Komija','Takuja Sató','Keidži Fudžiwara','Jošiki Nakadžima','Sačiko Kodžima','Čie Nakamura','Eri Góda','Masaši Tamaki','Eimi Okada','Júta Odagaki','Itaru Jamamoto','Riki Kagami','Makoto Tamura','Masaja Fukuniši','Mana Hirata','Masamiči Kitada','Šúhei Macuda','Takahiro Fudžiwara','Akihiro Tadžima','Marie Ói','Acuši Ono','Taiči Takeda','Jošijuki Kaneko','Hiroja Egašira','Sainty Nelsen','Hironori Kondó','Šinobu Macumoto','Rjúnosuke Watanuki','Ikkjú Džuku','Naoki Košida','Hajato Fudžii','Kozue Harašima','Hiró Sasaki','Micuhiro Sakamaki','Daigo Fudžimaki','Masako Širakawa','Takahiro Mijake','Hiro Nakadžima','Taisuke Nišimura','Naoki Tamanoi','Júiči Išigami','Hidemicu Šimizu','Aiko Kusumi','Ajaka Šimojamada','Aki Nakadžima','Eriko Emori','Masaharu Tahara','Hyang-Lee Kim','Mari Kijohara','Hirojuki Takanaka'],
screenplay:['Gen Urobuči','Džun Kumagai','Makoto Fukami','Tó Ubukata','Rjó Jošigami','Aja Takaha'],
production:['Fumi Morihiro','Takaši Jošizawa'],
music:['Júgo Kanno'],
camera:['Eidži Arai','Sakiko Murai','Šunsuke Nakamura'],
cut:['Jošinori Murakami'],
sound:['Jošikazu Iwanami'],
scenography:['Kódži Etó','Takahiro Macúra','Šúiči Kusamori']},
{title:'Food Wars! Shokugeki no Soma',
titleCZ:'Šokugeki no Sóma',
year:2015,
runtime:'35h 50min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Comedy','Sport'],
director:['Jošitomo Jonetani','Hikaru Sató','Jošitaka Fudžimoto','Kazuhiro Joneda','Jóhei Suzuki','Naoki Murata','Rjó Andó','Micutoši Sató','Sumito Sasaki','Takeši Nišino','Hirojuki Okuno'],
actors:['Jošicugu Macuoka','Risa Taneda','Ai Kajano','Činacu Akasaki',"Džun'iči Suwabe",'Mamiko Noto','Nobuhiko Okamoto','Takehito Kojasu','Aja Hisakawa','Ajako Kawasumi','Mucumi Tamura','Taku Jaširo','Júki Ono','Hitomi Nabatame','Takuma Nagacuka','Tomokazu Sugita','Asami Seto','Jutaka Aojama','Šóto Kašii','Jumiko Kobajaši','Eidži Takemoto','Kan Tanaka','Takahiro Sakurai','Júiči Nakamura','Saori Gotó','Maaja Učida','Mikako Takahaši','Rina Hidaka','Jóko Hikasa','Ajaka Suwa','Júko Iida','Šizuka Išigami','Džuri Kimura','Saori Óniši','Ai Kakuma','Jukijo Fudžii','Genki Muro','Hiroši Janaka','Bandžó Ginga','Tecu Inada','Šindži Kawada','Takajuki Kondó','Naomi Šindó','Harumi Sakurai',"Mari Joko'o",'Kendži Nomura','Jú Mizušima','Činami Hašimoto','Kijoko Mijazawa','Masaja Macukaze','Júma Učida','Júsuke Kobajaši','Nacuki Hanae',"Džun'iči Janagita",'Juka Terasaki','Haruki Išija','Džundži Madžima','Hidejuki Umezu','Tóru Ókawa','Kenta Sasa','Makoto Furukawa','Marika Kóno','Seiičiró Jamašita','Kengo Kawaniši','Daiki Hamano','Rikija Kojama','Hirojuki Kagura','Akeno Watanabe','Sajaka Senbongi','Micuru Ogata','Mikako Komacu','Hiroki Jasumoto','Daiki Jamašita','Tošiharu Sakurai','Sajaka Óhara','Kentaró Kumagai','Jó Taiči','Hadžime Iidžima','Jasuaki Takumi','Ajumu Murase','Taidži Seki','Šizuka Itó','Rie Kugimija','Akira Išida','Júki Kadži','Airi Ócu','Hisako Kanemoto','Rjóta Suzuki','Ikumi Hajama','Kana Hanazawa','Taiči Ičikawa','Masumi Tazawa','Kóhei Amasaki','Daiči Hajaši','Taito Ban','Taiši Murata','Eri Suzuki','Rjósuke Kanemoto','Jóhei Hamada','Tomo Muranaka'],
basedOn:['Júto Cukuda'],
screenplay:['Šógo Jasukawa',"Šin'iči Inozume",'Šun Kawanabe'],
production:['Hiró Marujama','Džun Fukuda','Kóhei Kawase','Hirokazu Hara'],
music:['Tacuja Kató'],
camera:['Jutaka Kurosawa'],
cut:['Šigeru Nišijama','Júdži Kondó'],
sound:['Džin Aketagawa'],
scenography:['Kóičiró Bizen']},
{title:'That Mitchell and Webb Look',
titleCZ:'That Mitchell and Webb Look',
year:2006,
runtime:null,
episodeRuntime:null,
countries:['UK'],
genres:['Comedy'],
director:['Ben Gosling Fuller','David Kerr'],
actors:['David Mitchell','Robert Webb','Paterson Joseph','Olivia Colman','Togo Igawa','Kiran Shah','Laura Aikman','Daniel Kaluuya','Terence Maynard','Sarah Hadland','David Kerr','Toby Davies','Paul Warren','Edna Doré','Danny McEvoy','Isabella Laughland',"Barunka O'Shaughnessy",'Sally Grace','John Finnemore','James Bachman','Mark Evans'],
screenplay:['Jesse Armstrong','Sam Bain','David Mitchell','Toby Davies','Dan Gaster','Joel Morris','Jason Hazeley','Tim Inman','Andrew Dawson','Steve Dawson','Keiron Self','George Jeffrie','Bert Tyler-Moore','John Finnemore','James Bachman','Chris Reddy','Madeleine Brettingham','Mark Evans'],
music:['Richie Webb','Matt Katz'],
camera:['Rob Kitzmann','John Sorapure'],
cut:['Scott Flyger','Pete Drinkwater'],
scenography:['Dennis De Groot'],
masks:['Siân Miller','Marie Deehan'],
costumes:['Leah Archer','Annie Hardinge']},
{title:'Pohled do zrcadla',
titleCZ:'Pohled do zrcadla',
year:1985,
runtime:null,
episodeRuntime:'4x51min',
countries:['France'],
genres:['Crime'],
director:['Jean Chapot'],
actors:['Bruno Cremer','Michel Bouquet','Jean-Pierre Aumont','Howard Vernon','Aurore Clément','Claude Vernier','Charles Millot','Edward Meeks','Michel Peyrelon','Isabelle Weingarten','Pierre Semmler','Michèle Simonnet','Michel Ruhl','Nelly Kaplan'],
screenplay:['Jean Chapot','Nelly Kaplan'],
camera:['Michel Carré']},
{title:'Arabela',
titleCZ:'Arabela',
year:1980,
runtime:'6h 17min',
episodeRuntime:'29min',
countries:['Czechoslovakia'],
genres:['Fairytale','Comedy','Adventure'],
director:['Václav Vorlíček'],
actors:['Jana Nagyová Pulm','Vladimír Menšík','Stella Zázvorková','Vladimír Dlouhý','Jiří Lábus','Dáda Patrasová','Vlastimil Brodský','Jana Brejchová','Jiří Sovák','Ondřej Kepka','Veronika Týblová','Jiří Hrzán','František Filipovský','Iva Janžurová','Jitka Zelenohorská','Dana Vávrová','Lenka Termerová','Hana Talpová','Simona Stašová','Helena Růžičková','Lída Roubíková','Zdenka Procházková','Alena Procházková','Míla Myslíková','Lenka Kořínková','Věra Kalendová','Jana Drbohlavová','Ivana Andrlová','Jana Andresíková','Vlastimil Zavřel','Oldřich Vízner','Josef Větrovec','Oldřich Velen','Luba Skořepová','Radim Vašinka','Jaroslav Tomsa','Václav Sloup','Svatopluk Skládal','Otto Šimánek','Ladislav Šimek','Josef Šebek','Milan Riehs','Čestmír Řanda st.','Jan Přeučil','Jiří Pleskot','Michal Pešek','Gustav Opočenský','Vít Olmer','Jiří Datel Novotný','Milan Neděla','Václav Mareš','Jiří Lír','Václav Lohniský','Zdeněk Kutil','Jan Kraus','Jiří Krampol','Václav Kotva','Luděk Kopřiva','Jiří Kodet','Antonín Jedlička','Vítězslav Jandák','Vladimír Hrabánek','Zdeněk Hodr','Stanislav Hájek','Josef Dvořák','Jaroslav Drbohlav','Jan Cmíral st.','Petr Brukner','Karel Augusta','Augustín Kubán','Karel Bělohradský','Svatopluk Beneš','Ladislav Županič','František Peterka','Ivo Niederle','Jaroslav Mareš','Vladimír Krška','Eugen Jegorov','Vlastimil Bedrna','Jiří Bruder','Jan Kuželka','Mirko Musil','Petr Svojtka','Miloslav Homola','Jiří Krytinář','Luděk Nešleha','František Hanus','Karel Koloušek','Jiří Bednář','Milada Ježková','Jiří Růžička ml.','Stanislav Litera','Jan Vokurka','Běla Jurdová','Jiřina Steimarová','Petr Jákl st.','Rudolf Vodrážka','Bohuslav Ličman','Petr Skarke','Pavel Spálený'],
screenplay:['Miloš Macourek','Václav Vorlíček'],
music:['Luboš Fišer'],
camera:['Emil Sirotek'],
cut:['Miroslav Hájek'],
sound:['František Fabián'],
scenography:['Milan Nejedlý'],
masks:['Jiří Hurych','Ivana Frýdová Bisingrová'],
costumes:['Theodor Pištěk ml.','Ludmila Ondráčková']},
{title:'Prisoners of War',
titleCZ:'Hatufim',
year:2010,
runtime:'19h 52min',
episodeRuntime:'41-61min',
countries:['Israel'],
genres:['Drama','Mystery','Thriller'],
director:['Gideon Raff'],
actors:['Ishai Golan','Yoram Toledano','Yaël Abecassis','Mili Avital','Assi Cohen','Adi Ezroni','Yael Eitan','Gal Zaid','Jonathan Uziel','Sendi Bar','Salim Daw','Hadar Ratzon Rotem','Guy Selnik','Nevo Kimchi','Makram Khoury','Said Dasuki','Roni Vidman','Miki Leon','Adam Kenneth','Boaz Konforty','Shimon Mimran','Dalik Wollinitz','Jameel Khoury','Aki Avni',"Yousef 'Joe' Sweid",'Shiri Golan','Shmuel Shiloh','Edna Blilious','Yaara Pelzig','Hagar Ben-Asher','Abdallah El Akal','Doron Amit','Efrat Ben-Yaakov','Neta Haber','Salwa Nakkara','Nova Doval'],
screenplay:['Gideon Raff'],
production:['Liat Benasuly'],
music:['Amit Poznansky'],
camera:["Itai Ne'eman"],
cut:['Simon Herman'],
masks:['Nili Levy']},
{title:'Oši no ko',
titleCZ:'Oši no ko',
year:2023,
runtime:'10h 20min',
episodeRuntime:'24-82min',
countries:['Japan'],
genres:['Animation','Drama','Music'],
director:['Daisuke Hiramaki','Rjóta Itó','Kódži Masunari','Takudai Kakuči','Kenta Oniši','Jasuhiro Irie','Asami Nakatani','Sumie Noro'],
actors:['Rie Takahaši','Takeo Ócuka','Tomojo Takajanagi','Jumi Učijama','Kento Itó','Jurie Igoma','Megumi Han','Manaka Iwami','Rumi Ókubo','Lynn','Acuši Tamaru','Hisao Egawa','Jasujuki Kase','Haruka Šamoto','Hazuki Ogino','Hikaru Iida','Kóiči Sóma','Kó Bonkobara','Kóhei Fukuhara','Masaja Fukuniši','Misa Kató','Mijuri Šimabukuro','Rjósuke Higa','Rjúó Nagaoka','Šiho Hisadžima','Tasuku Kida','Jú Kawada','Júga Sató','Jukiko Motojoši','Ajano Šibuja','Kimiko Saitó','Masahide Jamaguči','Nacu Jorita','Daiči Hajaši','Genta Nakamura','Kódži Okino','Masaki Terasoma','Seidži Maeda','Jui Hašimoto','Asami Seto','Hina Nacume','Hina Jómija','Kóhei Janagi','Konomi Inagaki','Majuko Kazama','Šizuka Itó','Jú Okano','Jú Wakabajaši','Tomohiro Óno','Taito Ban','Taiši Murata','Saori Óniši','Júki Sanpei',"Džun'iči Janagita",'Kanna Nakamura',"Ken'ičiró Macuda",'Kósuke Tanabe','Marie Ói','Reo Osanai','Tomomi Tanaka','Jasuhiro Kikuči','Jurina Amami','Akihiro Mine','Erina Koga','Rjóko Maekawa','Nacuki Miwa','Hana Sató','Naoja Mijase','Minami Kurisaka','Seina Kató','Seijú Fudžiwara','Asaki Juikawa','Hina Kojanagi','Hijori Nitta',"Ken'iči Suzumura",'Kóseki Kogure','Sóhei Horikane','Tomohito Takacuka','Saki Takahaši'],
basedOn:['Aka Akasaka','Mengo Jokojari'],
screenplay:['Džin Tanaka'],
music:['Takuró Iga'],
camera:['Takafumi Kuwano'],
cut:['Kentaró Cubone'],
sound:['Takeši Takadera'],
scenography:['Tetsuya Usami']},
{title:'Love, Death & Robots',
titleCZ:'Love, Death & Robots',
year:2019,
runtime:'7h 45min',
episodeRuntime:'6-21min',
countries:['USA'],
genres:['Animation','Comedy','Fantasy','Horror','Sci-Fi'],
director:['Tim Miller','Víctor Maldonado','Owen Sullivan','Alfredo Torres','Dominique Boidin','Léon Bérelle','Rémi Kozyra','Maxime Luère','Oliver Thomas','Gabriele Pennacchioli','Jon Yeo','Damian Nenow','Jerome Chen','Robert Valley','Dave Wilson','Jennifer Yuh','Alberto Mielgo','Simon Otto','Meat Dept','Patrick Osborne','David Fincher','Emily Dean','Roberto Bisi','Andy Lyon','Carlos Stevens','Elliot Dear','Benjy Brooke'],
actors:['Stefan Kapičič','Elaine Tan','Time Winters','Omid Abtahi','Christine Adams','Hakeem Kae-Kazim','Josh Brener','Gary Anthony Williams','Chris Parnell',"Emily O'Brien",'Nolan North','Alexia Dox','G.K. Bowes','Scott Whyte','Courtenay Taylor','Michael Benyaer','Fred Tatasciore','Laura Waddell','Maurice LaMarche','Delroy Brown','Grahame Fox','Gwendoline Yeo','JB Blanc','Gary Cole','Adam Bartley','Jim Pirri','James Horan','Yuri Lowenthal','Samira Wiley','Nestor Serrano','Jeffrey Pierce','Kevin Michael Richardson','Aaron Himelstein','Carlos Alazraqui','Jill Talley','Brian Bloom','Chris Cox','Mary Elizabeth Winstead','Topher Grace','John DiMaggio','Roger Craig Smith','Dieter Jansen','Bruce Thomas','Jeff Berg','Victor Brandt','Sumalee Montano','Miguel Amorim','Michael B. Jordan','Mike Bodie','Maria Teresa Creasey','Tudi Roche','Christopher Lee Parson','Nancy Linari','Ben Giroux','Archie Madekwe','Sebastian Croft','Elodie Yung','Michelle C. Bonilla','Dendrie Taylor','Ike Amadi','Jennifer Hale','Ayana Haviv','Piotr Michael','Peter Franzén','Zita Hanrot','Jonnie Hurn','Joe Dempsie','Nick Boraine','Kayli Tran','Troy Baker','Chantelle Barry','Parry Shen','Katie Lowes','Kevin Jackson','James Preston Rogers','Jason Flemyng','Max Fowler','Mackenzie Davis','David Shatraw','Joel McHale','Seth Green','Gabriel Luna','Steve Blum','Rosario Dawson','Jason George','Craig Ferguson','Dan Stevens','Joe Manganiello','Christian Serratos','Jai Courtney','Debra Wilson','Sara Silkin','Alina Smolyar','Andrew Hawkes','Brian T. Delaney','Helen Sadler','Beatriz Godinho','Noshir Dalal','Madeleine Knight','Neil Kaplan'],
screenplay:['Tim Miller','Philip Gelatt','Alberto Mielgo','Meat Dept','Andrew Kevin Walker','Andy Lyon','Joe Abercrombie'],
production:['Victoria L. Howard','Cara Speller'],
music:['Rob Cairns','Ben Locket','Junkie XL','Dan Levy','Maxime Herve'],
camera:['Ken Seng'],
cut:['Kevin Van Der Meiren','Julian Clarke','Tyler Nelson','Kirk Baxter','Romain Fuzeau'],
sound:['Joe DeAngelis','Craig Henighan','Albert Romero','Chris Carpenter','Brad North','Chuck Michael'],
scenography:['Robert Valley','Alberto Mielgo']},
{title:'Masha and the Bear',
titleCZ:'Máša a medvěd',
year:2009,
runtime:'14h 39min',
episodeRuntime:'7-9min',
countries:['Russia'],
genres:['Animation','Comedy','Action'],
director:['Oleg Užinov','Denis Chervyatsov','Oleg Kuzovkov','Marina Nefedova','Olga Baulina','Vlad Bayramgulov','Georgiy Orlov','Ilja Trusov','Roly Gutiérrez'],
actors:['Alina Kukuškina','Boris Kutnevich'],
screenplay:['Oleg Kuzovkov','Greg Nix'],
production:['Andrej Dobrunov','Dmitriy Loveyko','Oleg Kuzovkov'],
music:['Vasiliy Bogatyrev'],
cut:['Vlad Bayramgulov','Georgiy Orlov'],
sound:['Boris Kutnevich'],
scenography:['Ilja Trusov']},
{title:'Queer as Folk',
titleCZ:'Queer as Folk',
year:2000,
runtime:'65h 52min',
episodeRuntime:'44-87min',
countries:['USA','Canada'],
genres:['Drama'],
director:['David Wellington','Alex Chapple','Jeremy Podeswa','John Fawcett','Ron Oliver','John Greyson','Kari Skogland','Russell Mulcahy',"John L'Ecuyer",'Chris Grismer','Steve DiMarco','Michael DeCarlo','Bruce McDonald','Thom Best','Laurie Lynd','Kelly Makin','Kevin Inch'],
actors:['Gale Harold','Thea Gill','Hal Sparks','Chris Potter','Peter Paige','Sharon Gless','Sherry Miller','John Furey','Robert Gant','Lawrence Dane','Victoria Snow','Michael Boisvert','Jordan Barker','Jason Matheson','Jefferson Brown','Noah Dalton Danby','Scott Lowell','Matt Battaglia','Christopher Cordell','Amy Lalonde','Carlo Rota','Todd Hofley','Rebekah Boisvert','Jason Gray-Stanford','Jonathan Keltz','Randy Harrison','Dave Lantaigne','Chris Violette','Trish Adams','James Thomas','Nancy Anne Sakovich',"Rosie O'Donnell",'Tate Taylor','Sean Baek','David Berni','Ryan Taylor','Paul Hecht','Julie Khaner','Laura de Carteret','Arlene Duncan','David Reale','Sean Orr','Paul Essiembre','Ben Bass','Keir Gilchrist','Lucas Bryant','Brett Heard','Martha Ferguson','Stephen Amell','Matthew Knight','Meredith Henderson','Harris Allan','Michelle Clunie','Aidan Devine','Tom McCamus','Mark Lutz','David Ingram',"Rory O'Shea",'Louis Negin','John Kapelos','Noam Jenkins','Julie Stewart','Ennis Esmer','Rosemary Dunsmore','Matthew Currie Holmes','John Ralston','Barbara Gordon','Ryan Scott Greene','Jodie Dowdall','Salvatore Antonio','Angela Asher','Dan Lett','Adam Harrington','Mitch Morris','Jason Deline','Goûchy Boy','Peter Keleghan','Ian Matthews','Kathryn Zenna','Rebecca Northan','Grant Nickalls','Vanessa Aspillaga','Damon Runyan','Billie Mintz','Tim Doiron','Paulino Nunes','Steve Belford','Sonia Laplante','Jason Jones','Vincent Gale','Sandy Jobin-Bevans','Kegan Hoover','Logan Hoover','Dean Armstrong','Brad Borbridge','Haylee Wanstall','Fab Filippo','Don Allison','George King','Ryan Jefferson Booth'],
screenplay:['Ron Cowen','Daniel Lipman','Karen Walton','Richard Kramer','Del Shores','Brad Fraser','Jonathan Tolins','Michael MacLennan','Matt Pyken','Michael Berns','Drew Z. Greenberg'],
production:['Sheila Hockin','Brad Fraser','Kevin Inch'],
music:['Tom Third'],
camera:['Gavin Smith','Thom Best'],
cut:['Mike Lee','Bill Goddard'],
sound:['Eric Apps','Jack Heeren','Bill McMillan'],
scenography:['Ingrid Jurek','Paul Gilpin'],
masks:['Clara Dinunzio',"James O'Reilly"],
costumes:['Patrick Antosh','Julie Whitfield']},
{title:'Against the Wind',
titleCZ:'Proti větru',
year:1978,
runtime:'10h 50min',
episodeRuntime:'50min',
countries:['Australia'],
genres:['Drama'],
director:['Simon Wincer','George Miller'],
actors:['Mary Larkin','Bryan Brown','Jon English','Vincent Ball','Rod Mullinar','Julia Blake','Anne-Louise Lambert','Chris Haywood','Tim Elliott','Frank Thring','Jim Norton','Jane Clifton','John Ley','Adrian Wright','Wallas Eaton','Patrick Edgeworth','Tommy Dysart','Vincent Gil','Don Barker','Howard Eynon','Sarah Lambert','John Stanton'],
screenplay:['Ian Jones','Cliff Green','Bronwyn Binns','Tony Morphett','Peter A. Kinloch','Tom Hegarty'],
music:['Jon English','Mario Millo'],
camera:['Dan Burstall'],
scenography:['Tracy Watt']},
{title:'Hikaru no Go',
titleCZ:'Hikaru no go',
year:2001,
runtime:'28h 45min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Fantasy','Sport'],
director:['Susumu Nišizawa','Tecuja Endó','Džun Kamija','Tošinori Narita','Kunitoši Okadžima','Júičiró Mijake','Secuo Takase','Tošija Niidome','Saeko Aoki','Takuja Nonaka','Mašu Itó'],
actors:['Tomoko Kawakami','Susumu Čiba','Sanae Kobajaši','Jumi Kakazu',"Ken'iči Suzumura",'Jú Asakawa','Akeno Watanabe','Akihiko Išizumi','Činami Nišimura','Majumi Asano','Micuo Iwata','Keidži Fudžiwara','Kódži Jusa','Kentaró Itó','Čafúrin','Takahiro Sakurai','Hiroši Naka','Rei Sakuma','Takaši Nagasako','Kacujuki Koniši','Daisuke Kišio','Mami Horikoši','Eriko Kawasaki','Sacuki Jukino','Akiko Suzuki','Jóko Macuoka','Rokuró Naja','Takako Honda','Aruno Tahara','Jurika Hino','Acuko Enomoto','Micuaki Hošino',"Ken'iči Ono",'Kazuaki Itó','Čiaki Takahaši','Makoto Cumura','Takajuki Jamaguči','Reiko Takagi',"Džu'iči Kanemaru",'Takajasu Usui','Jošijuki Kaneko','Akimicu Takase','Cuda Eizó','Takuo Kawamura','Tošitaka Šimizu','Acuši Ii','Mizuki Saitó','Tomo Šigemacu','Tomoja Kawai','Jošito Išinami','Hirofumi Tanaka','Kacuhiro Kitagawa','Rie Išizuka','Takao Išii','Tošiaki Kuwahara','Jajoi Nakazawa'],
basedOn:['Takeši Obata'],
screenplay:['Jukijoši Óhaši','Acuhiro Tomioka','Mičiko Jokote'],
production:['Taihei Jamaniši'],
music:['Kei Wakakusa'],
camera:['Masahide Okino'],
cut:['Masahiro Macumura'],
sound:['Hideo Takahaši'],
scenography:['Sawako Takagi']},
{title:'The Haunting',
titleCZ:'The Haunting',
year:2018,
runtime:'17h 55min',
episodeRuntime:'43-71min',
countries:['USA'],
genres:['Horror','Drama'],
director:['Mike Flanagan','Ciarán Foy','Liam Gavin','Ben Howling','Yolanda Ramke','E. L. Katz'],
actors:['Carla Gugino','Michiel Huisman','Elizabeth Reaser','Henry Thomas','Paxton Singleton','Victoria Pedretti','Mckenna Grace','Oliver Jackson-Cohen','Kate Siegel','Lulu Wilson','Julian Hilliard','Timothy Hutton','Violet McGraw','Samantha Sloyan','May Badr','Katie Parker','Jordane Christie','Logan Medina','Anthony Ruivivar','Olive Elise Abercrombie','Katie Carpenter','Anna Enger Ritch','Arianne Martin','Jeremy Ambler','Christine Horn','Craig Welzbacher','Keith Arthur Bolden','Juan Gaspard','Annabeth Gish','Robert Longstreet','David Shae','Benjamin Weaver','Tommy Campbell','Saidah Arrika Ekulona','Nelson Bonilla','Levy Tran','James Lafferty','Brittany Godfrey','Russ Tamblyn','Elan Gale','Jonathan Kleitman','Carrie Walrond Hood',"T'Nia Miller",'Rahul Kohli','Amelia Eve','Fedor Steer','Trace Masters','Kurt Yue','Martin McCreadie','Tahirah Sharif','Benjamin Evan Ainsworth','Jim Piddock','Amelie Bea Smith','Calix Fraser','Rhys Slack','Atlee Smallman','Carla Gugino','Kamal Khan','Greg Sestero','Christie Burke','Duncan Fraser','Stefania Indelicato','Jill Morrison','John Prowse','Roby Attal','Ken Kramer','Pasha Ebrahimi','Jamie Flanagan','Lynda Boyd','Teryl Rothery','Susan Saint James','Carolyn Adair','Alex Essoe','Matthew Holness','Natasha Quirke','Lizzy McInnerny','Zoë Noelle Baker','Dakota Guppy','Carla Gugino','Oliver Jackson-Cohen','Benjamin Evan Ainsworth','Tahirah Sharif',"T'Nia Miller",'Victoria Pedretti','Amelie Bea Smith','Selena Anduze','Elizabeth Becka','Darrell Duane','Alisha-Marie Ahamed','Marc Anthony Williams','Tiffany Denise Hobbs','Alice Comer','Tim Beckmann'],
basedOn:['Shirley Jackson','Henry James'],
screenplay:['Meredith Averill','Mike Flanagan','Liz Phang','Scott Kosar','Jeff Howard','Diane Ademu-John','Leah Fong','Jamie Flanagan','Angela LaManna','Charise Castro Smith','Michael Clarkson','Paul Clarkson','Julia Bicknell'],
production:['Dan Kaplow','Kathy Gilroy','Leah Fong','Charise Castro Smith','Scott Kosar'],
music:['The Newton Brothers'],
camera:['Michael Fimognari','Maxime Alexandre','James Kniest'],
cut:['Jim Flynn','Brian Jeremiah Smith','Mike Flanagan','Ravi Subramanian'],
sound:['Craig Stauffer','Oleg Kulchytskyi','Trevor Gates','Jonathan Wales'],
scenography:['Patricio M. Farrell','John France','Hugo Santiago'],
masks:['Robert Kurtzman','Debra Wiebe'],
costumes:['Lynn Falconer']},
{title:'Rákosníček a hvězdy',
titleCZ:'Rákosníček a hvězdy',
year:1975,
runtime:'1h 44min',
episodeRuntime:'8min',
countries:['Czechoslovakia'],
genres:['Animation','Fairytale'],
director:['Zdeněk Smetana'],
actors:['Jiřina Bohdalová'],
screenplay:['Zdeněk Smetana','Vladimír Branislav'],
music:['Václav Zahradník'],
camera:['Eva Kargerová','Jaroslava Zimová'],
cut:['Zdenka Navrátilová'],
sound:['Benjamin Astrug']},
{title:'Top Boy',
titleCZ:'Top Boy',
year:2011,
runtime:'28h 9min',
episodeRuntime:'42-66min',
countries:['UK'],
genres:['Drama','Crime','Thriller'],
director:['Yann Demange','Jonathan van Tulleken','Reinaldo Marcus Green','Brady Hood','Myriam Raja'],
actors:['Ashley Walters','Kano','Shone Romulus','Nicholas Pinnock','Benedict Wong','Kierston Wareing','Geoff Bell','David Hayman','Elarica Johnson','Juliet Oldfield','Anthony Welsh','Arnold Oceng','Richard Lintern','Letitia Wright','Pooky Quesnel','Sophia Brown','Andy Beckwith','Jamie Michie','Michaela Coel','Darren Morfitt','Sharon Duncan-Brewster','Ashley Thomas','Chris Cowlin','Sonila Vjeshta','Sarah Flind','Rachel Warren','Yolanda Vazquez','Cornell John','Mick Slaney','John W. G. Harley','Semina Lewis','Sean Sagar','Daniel Cerqueira','Teresa Mahoney','Davood Ghadami','Weruche Opia',"Darrell D'Silva",'Ginny Dee','Todd Von Joel','Jo Martin','Camilla Beeput','Lucy Russell','Micheal Ward','Vihaan Patel','Malcolm Kamulete','Giacomo Mancini','George Wood','Richie Campbell','Clare-Hope Ashitey','Lee Nicholas Harris','Paul Anderson','Lorraine Burroughs','Anton Valensi','Ozzy Chetin','Elizabeth Tan','Kasey McKellar','Lisa Dwan','Araloyin Oshunremi','Hope Ikpoku Jnr','Adwoa Aboah','Sandra James-Young','Alessandro Babalola','Jarreau Benjamin','Seraphina Beh','Kasey Iliana Sfetsios','Brian Gleeson','Barry Keoghan','Joshua Collins','Jasmine Jobson','Hannah Blamires','Finn Bennett'],
screenplay:['Ronan Bennett','Daniel West'],
production:['Charles Steel','Ronan Bennett','Laura Hastings-Smith','Yvonne Isimeme Ibazebo'],
music:['Brian Eno','Andrew Meecham'],
camera:['Tat Radcliffe','Christopher Ross','Joe Anderson','Chloë Thomson','Rina Yang','Adam Scarth'],
cut:['Chris Wyatt','Morten Højbjerg','Matthew Tabern','Nicolas Chaudeurge','John Dwelly'],
sound:['Richard Davey','Steve Single','Jack Gillies'],
scenography:['Carly Reddin','Jacqueline Abrahams','Anna Pritchard','Claire Levinson-Gendler','Ruby Mathers','Sophie Lockwood','Alexandra Toomey'],
masks:['Jemma Carballo','Sharon Martin','Marella Shearer','Satinder Chumber'],
costumes:['Jane Petrie','Liza Bracey','Lauren Miller']},
{title:'Muž v pozadí',
titleCZ:'Muž v pozadí',
year:1995,
runtime:'5h 4min',
episodeRuntime:'70-79min',
countries:['Czechia'],
genres:['Drama','Biography','History'],
director:['Pavel Háša'],
actors:['František Němec','Václav Postránecký','Jan Hartl','Kamil Halbich','Jiří Čapka','Radovan Lukavský','Taťjana Medvecká','Ladislav Frej st.','Petr Kostka','Josef Vinklář','Lenka Skopalová','Vladimír Javorský','Jan Novotný','Barbora Eichlerová','Mahulena Bočanová','Miloš Hlavica','Boris Rösner','Mário Kubec','Miroslava Pleštilová','Jiří Štěpnička','Milena Steinmasslová','Oldřich Vlach','Ivan Vyskočil','Stanislav Lehký','Petr Pelzer','Milan Riehs','Jan Šťastný','Jan Teplý st.','Otakar Brousek st.','Jiří Ptáčník','Filip Sychra','Miluše Šplechtová','Luděk Nešleha','Marcela Nohýnková','Karel Polišenský','Petr Meissel','Vítězslav Jirsák','Ivan Řezáč','Karel Hovorka ml.','Pavel Rímský','Slávka Hozová','Steva Maršálek','Břetislav Slováček','Vladimír Ráž','Bořivoj Navrátil','Martin Zahálka','Vladimír Brabec','Jiří Klem','Marek Ronec','Milan Miroslav Livora','Bohumil Vávra','Nela Boudová','Jan Přeučil','Miroslav Nohýnek','Marek Škobis','Barbara Lukešová'],
screenplay:['František Pavlíček'],
music:['Petr Mandel'],
camera:['Petr Polák'],
cut:['Marie Pačajová','Marie Maršálková'],
sound:['Zdeněk Stropek'],
masks:['Josef Borovička','Martin Větrovec'],
costumes:['Božena Měchurová','Simona Ledererová']},
{title:'James Acaster: Repertoire',
titleCZ:'James Acaster: Repertoire',
year:2018,
runtime:null,
episodeRuntime:'4x60min',
countries:['UK'],
genres:['Comedy'],
director:['Daniel Lucchesi'],
actors:['James Acaster','Joe Parham'],
screenplay:['James Acaster']},
{title:'The Count of Monte Cristo',
titleCZ:'Hrabě Monte Cristo',
year:1998,
runtime:null,
episodeRuntime:'6h 90min',
countries:['France','Germany','Italy'],
genres:['Adventure','Romance','Drama','History'],
director:['Josée Dayan'],
actors:['Gérard Depardieu','Ornella Muti','Jean Rochefort','Pierre Arditi','Stanislas Merhar','Julie Depardieu','Florence Darel','Michel Aumont','Hélène Vincent','Constanze Engelbrecht','Jean-Claude Brialy','Inés Sastre','Sergio Rubini','Patrick Bouchitey','Stéphan Guérin-Tillié','Guillaume Depardieu','Julien Rochefort','Naike Rivelli','Stéphane Boucher','Micheline Presle','Roger Dumas','Mattia Sbragia','David Saracino','Christiane Rorato','Albert Delpy','Jean-Christophe Bouvet','Renato Scarpa','Serge Marquand','Annick Alane','Philippe Clay','Frédéric Gorny','Jean-Marc Thibault','Thierry de Peretti','Michel Bompoil','Jacques Boudet','Sergio Fiorentini','Dominique Besnehard','Alain Ganas','Patrick Bordier','Gilles Treton','Pierre Forest','Georges Moustaki','Serge Merlin','Maria Pia Calzone','Jacques Disses','Alain Stern','Luc Delhumeau','Daniel Martin','Roland Blanche','Max Vialle','Marie-Françoise Audollent','Alain Moussay','Bernard Garnier','Fabienne Mai','Alain Frérot','Philippe Lehembre','Dimitri Rataud','Jean-Michel Lahmi','Rodolphe Pauly','Michèle Bardollet','Christian Ameri','Laurent Arnal','Emanuel Booz','Roland Munter','Eric Averlant','Hichem Rostom','Candice Hugo','Gerhard Acktun','Christophe Le Masne','Mariolina De Fano','Roberto Corcione','Ciro Capano','Marco Stefanelli','Franco Silvestri','André Raffard','Franck Tordjman'],
basedOn:['Alexandre Dumas st.'],
screenplay:['Didier Decoin'],
production:['Jean-Pierre Guérin'],
music:['Bruno Coulais'],
camera:['Willy Stassen'],
cut:['Marie-Josèphe Yoyotte'],
scenography:['Richard Cunin'],
costumes:['Jean-Philippe Abril']},
{title:'V pasti',
titleCZ:'V pasti',
year:2016,
runtime:'23h 27min',
episodeRuntime:'49-54min',
countries:['Iceland','Germany'],
genres:['Crime','Drama','Thriller'],
director:['Óskar Thór Axelsson','Baldvin Zophoníasson','Baltasar Kormákur','Börkur Sigþórsson','Ugla Hauksdóttir'],
actors:['Ólafur Darri Ólafsson','Ilmur Kristjánsdóttir','Ingvar Sigurðsson','Nína Dögg Filippusdóttir','Baltasar Breki Samper','Bjarne Henriksen','Þorsteinn Bachmann','Pálmi Gestsson','Þorsteinn Gunnarsson','Hanna María Karlsdóttir','Steinunn Ólína Þorsteinsdóttir','Sigrún Edda Björnsdóttir','Jóhann Sigurðarson','Magnús Ragnarsson','Kristján Franklin Magnúss','Björn Hlynur Haraldsson','Lilja Nótt Þórarinsdóttir','Rúnar Freyr Gíslason','Katla Margrét Þorgeirsdóttir','Sigurður Karlsson','Arnar Jónsson','Jóel Sæmundsson','Ólafía Hrönn Jónsdóttir','Guðrún Gísladóttir','Sigurður Skúlason','Stefán Jónsson','Halldóra Geirharðsdóttir','Ingrid Jónsdóttir','Bjarki Þór Jónsson','Vytautas Narbutas','Jón Pétursson','Elva María Birgisdóttir','Júlía Guðrún Lovisa Henje','Guðjón Pedersen','Eysteinn Sigurðarson','Gunnar Viðar Valdimarsson','Marta Quental','Grace Achieng','Georg Leite de Oliveira Santos','Steve Lorenz','Salka Sól Eyfeld','Jasmín Dúfa Pitt','Hans Tórgarð','Monika Orlowska','Rán Ísold Eysteinsdóttir','Helga Rós V. Hannam','Sólveig Arnarsdóttir','Valdimar Örn Flygenring','Guðjón Davíð Karlsson','Steinn Ármann Magnússon','Kingsford Siayor','Unnur Ösp Stefánsdóttir','Dar Salim','Þorsteinn Gunnar Bjarnason','Lára Jóhanna Jónsdóttir','Hinrik Ólafsson','Gunnar Bersi Björnsson','Anna Claessen','Björn Ingi Hilmarsson','Ragnar Jónsson','Jóhanna Vigdís Arnardóttir','Elva Ósk Ólafsdóttir','Edda Björg Eyjólfsdóttir','Vignir Rafn Valþórsson','Pétur Óskar Sigurðsson','Arnmundur Ernst Backman','Jóna Guðrún Jónsdóttir','Stormur Jón Kormákur Baltasarsson','Valur Freyr Einarsson','Kristín Lea Sigríðardóttir','Guðlaug Bjarnadóttir','Bogi Ágústsson','Aron Már Ólafsson','Jónmundur Grétarsson','David Lenneman','Hafsteinn Gunnar Hafsteinsson','Haraldur Stefansson','Ylfa Marín Haraldsdóttir','Sigurbjartur Atlason','Baldur T. Hreinsson','Arnfinnur Daníelsson','Helga Kristín Helgadóttir','Hildigunnur Þráinsdóttir','David Katrinarson','Vivian Ólafsdóttir','Páll Sigþór Pálsson','Jógvan Hansen','Heiddis Chadwick Hlynsdottir','Einar Gunn','Sólveig Guðmundsdóttir','Erling Jóhannesson','Guðlaug María Bjarnadóttir','Arnar Dan Kristjánsson','Guðmundur Ingi Þorvaldsson'],
screenplay:['Sigurjón Kjartansson','Jóhann Ævar Grímsson','Margrét Örnólfsdóttir','Holly Phillips','Clive Bradley','Baltasar Kormákur','Davíð Már Stefánsson'],
production:['Sigurjón Kjartansson','Baltasar Kormákur','Magnús Viðar Sigurðsson','Amy Shatsky-Gambrill'],
music:['Jóhann Jóhannsson','Hildur Guðnadóttir','Rutger Hoedemaekers'],
camera:['Bergsteinn Björgúlfsson','Árni Filippusson'],
cut:['Elísabet Ronaldsdóttir','Sigvaldi J. Kárason','Ingibjörg Ásmundsdóttir','Janus Bragi Jakobsson'],
sound:['Huldar Freyr Arnarson'],
scenography:['Atli Geir Grétarsson'],
masks:['Áslaug Dröfn Sigurðardóttir','Harpa Haraldsdóttir','Sigurbjörg Halldórsdóttir','Tinna Ingimarsdóttir'],
costumes:['Helga Rós V. Hannam']},
{title:'Čtvrtníček, Šteindler a Vávra',
titleCZ:'Čtvrtníček, Šteindler a Vávra',
year:1998,
runtime:'3h 6min',
episodeRuntime:'18-32min',
countries:['Czechia'],
genres:['Comedy'],
director:['Petr Čtvrtníček','Milan Šteindler'],
actors:['Petr Čtvrtníček','Milan Šteindler','David Vávra','Karel Dobrý','Richard Honzovič','Roman Holý','Mikuláš Lubomírský','Jaroslav Šmíd','Ladislav Klepal','Bohumil Klepl','Andrei Toader','Barbara Lukešová','Michal Pavlata','Luděk Sobota','Sandra Nováková','Dana Hábová','Petra Špalková','Miroslav Táborský','Robert Nebřenský','Daniel Netušil','Zdeněk Srstka','Tomáš Hanák','Luboš Pecháček','Bára Dlouhá','Kamil Emanuel Gott','Eva Režnarová','Taťána Míková'],
screenplay:['Petr Čtvrtníček','Milan Šteindler'],
music:['Josef Spal'],
camera:['Dominik Miškovský','Martin Douba'],
cut:['Vladimír Barák','Filip Malásek','Kateřina Jurná','Barbora Listíková','Jan Zuska'],
sound:['Juraj Žák'],
masks:['Vlasta Ulbertová','Tomáš Richter','Květa Holasová','Helena Petřinová','Hana Šímová'],
costumes:['Jitka Matiášková']},
{title:'Jeeves and Wooster',
titleCZ:'Jeeves and Wooster',
year:1990,
runtime:null,
episodeRuntime:'23x55min',
countries:['UK'],
genres:['Comedy'],
director:['Ferdinand Fairfax','Simon Langton','Robert Young'],
actors:['Stephen Fry','Hugh Laurie','Peter Benson','Michael Ripper','Mac McDonald','Ronan Vibert','Elizabeth Spriggs','Rosalind Knight','Richard Brake','Anastasia Hille','Julian Firth','Tim Barker','Richenda Carey','Marlene Sidaway','Selina Cadell','Roger Frost','Liz Kettle','Richard Dixon','Hugo Blick','Richard Bebb','Amanda Elwes','Norman Lumsden','Merelina Kendall','Sylvia Kay','Colin McFarlane','Kim Huffman','Preston Lockwood','Jack Watling','Vivian Pickles','Mary Wimbush','Jennifer Gibson','Michael Siberry','Bill Bailey','Paula Jacobs','Nigel Whitmey','Ricco Ross','Brenda Bruce','Don Fellows','Ralph Michael','Gordon Salkilld','Owen Brenman','Patricia Lawrence','Deddie Davies','Richard Braine','Robert Daws','Jean Heywood','Jane Downs','Rosemary Martin','Harry Landis','Peter Diamond','Llewellyn Rees','John Turner','Jon Croft','John Savident','Raymond Young','Heather Canning','John Rutland','Hilary Sesta','Matt Zimmerman','John Cater','Roger Brierley','Georgia Allen','Rebecca Saire','Steph Bramwell','Phillip Reader','Christopher Whittingham','Dave Atkins','Brian Haines','Nicholas Palliser','Ann Queensberry','John Woodnutt','Justine Francesca Glenton','John Pirkis','Frederick Trevers','David Blake Kelly','Neil Hallett','Gordon Sterne','Jack Johnson','David Peart','Tessa Churchard','Manning Redwood','Matthew Solon','Joanna Riding','Norman Rodway',"Marcus D'Amico",'Sonia Graham','Peter Howell','Geoffrey Toone','David Healy','Bunny Seaman','Thomasine Heiner','Peter Hughes','Lou Hirsch','Hubert Rees','James Ottaway','John Alexander','Sam Douglas','Harry Ditson','Joan White','Graham Seed'],
basedOn:['P. G. Wodehouse'],
screenplay:['Clive Exton'],
production:['Brian Eastman'],
music:['Anne Dudley'],
camera:['Peter Jessop','Ernest Vincze'],
cut:['Chris Wimble','Derek Bain'],
sound:['David Crozier'],
scenography:['Chris Townsend','Eileen Diss'],
masks:['Christine Cant'],
costumes:['Dany Everett']},
{title:"Chappelle's Show",
titleCZ:"Chappelle's Show",
year:2003,
runtime:null,
episodeRuntime:'33x22min',
countries:['USA'],
genres:['Comedy'],
director:['Rusty Cundieff','Peter Lauer','Neal Brennan','Bobcat Goldthwait','Bill Berner'],
actors:['Dave Chappelle','Donnell Rawlings','Michael Rapaport','Common','Charlie Murphy','RZA','The GZA','Isiah Whitlock Jr.','Chris LaPanta','Wanda Sykes','Michael Carbonaro','Athena Karkanis','Phyllis Somerville','Geneva Carr','Dee Snider','Fay Wolf','Anthony Anderson','Charles Barkley','Yasiin Bey','Erykah Badu','Snoop Dogg','Ice-T','Wayne Brady','John Legend','Neal Brennan','Rick James','Guillermo Díaz','Tim Kang','Julia Pace Mitchell','Vida Guerra','Rob Riggle','Jesse Borrego','Elon Gold','Jessi Klein','Sophina Brown','Bill Burr','Craig DiFrancia','Jama Williamson','Gene Jones','Rick Crom','Catherine A. Callahan','Mark Indelicato','Ato Essandoh','Mike D','Christian Finnegan','Maurice Jamal','Liz Beckham','William Bogert','La La Anthony','Michael Cullen','Mark Charran','B.J. Clinkscales','Ahmir-Khalib Thompson','Jim Breuer','Dan Ziskie','Randy Pearlstein','Russell Simmons','Ross Bickell','Michael D. Fuller','Jonathan Corbett','Henry Yuk','Craig muMs Grant','Patrick Collins','Paul Mooney','Tina Benko','Jonathan Walker','Nicolle Rochelle','Big Boi','Bunny Levine','John C. Vennema','Irma St. Paule','Matt Oberg','Prudence Wright Holmes','Jennifer Mudge','Daniel Stephen','Doug Hurley','Bob Wiltfong','Eddie Pepitone',"Lynese 'Babs' Wiley",'Funkmaster Flex','Cindy Katz','Sleepy Brown','Brendan Patrick Connor','Talib Kweli','Killer Mike','Quincy Tyler Bernstine','Orfeh','Lee R. Sellars','Freeway','Crazy Legs'],
screenplay:['Kurt Metzger','Paul Mooney','Donnell Rawlings'],
music:['Ahmir-Khalib Thompson'],
camera:['Daniel Shulman','Leland Krane'],
cut:['Joe Klotz','Edward Chin'],
sound:['Paul Furedi'],
scenography:['Norval Johnson'],
costumes:['Danielle Hollowell']},
{title:"This Is England '90",
titleCZ:"This Is England '90",
year:2015,
runtime:'3h 45min',
episodeRuntime:'45-76min',
countries:['UK'],
genres:['Drama'],
director:['Shane Meadows'],
actors:['Chanel Cresswell','Katherine Dow Blyton','Andrew Ellis','Joe Gilgun','Jo Hartley','Vicky McClure','Andrew Shim','Michael Socha','Thomas Turgoose','Danielle Watson','Joe Dempsie','Stephen Graham','Shaun Dooley','Emma Fielding','Rosamund Hanson','George Newton','Stuart Wolfenden','Kieran Hardcastle','Jermaine Liburd','Poppy Corby-Tuech','Sherrie Johnson','Hannah Walters','Karl Collins','Michael Nardone','Neil Bell','Angela Lonsdale','Paul Capatal','Jonny Owen','William Travis','Johnny Harris','Perry Benson','Sophie Ellerby','Ciaran Griffiths','Nick Preston','Jack Thorne','Rebecca Manley','Helen Behan'],
screenplay:['Shane Meadows','Jack Thorne'],
production:['Mark Herbert'],
music:['Toydrum'],
camera:['Stuart Bentley'],
cut:['Matthew Gray'],
scenography:['Jane Levick'],
costumes:['Charlotte Walter']},
{title:'The Visitors',
titleCZ:'Návštěvníci',
year:1983,
runtime:'7h 17min',
episodeRuntime:'29-30min',
countries:['Czechoslovakia','Germany'],
genres:['Sci-Fi','Family','Comedy'],
director:['Jindřich Polák'],
actors:['Josef Bláha','Josef Dvořák','Dáda Patrasová','Jiří Datel Novotný','Vlastimil Brodský','Viktor Král','Vladimír Menšík','Dagmar Havlová','Eugen Jegorov','Dana Bartůňková','Klára Pollertová-Trojanová','Jiří Lábus','Jitka Molavcová','Jaroslav Rozsíval','Jan Hartl','Jiří Císler','Jiří Kodet','Laďka Kozderková','Lukáš Bech','Jiří Krampol','Helena Růžičková','Ondřej Vetchý','Karel Koloušek','Bořivoj Navrátil','Otto Šimánek','Jan Čenský','Miroslav Moravec','Jana Švandová','Jiří Havel','Jana Břežková','Zdeněk Martínek','Vladimír Brabec','Jaromír Kučera','Josef Střecha','Jan Kuželka','Jitka Zelenohorská','Ludmila Zábršová-Molínová','Věra Kalendová','Otakar Brousek st.','Zdenka Procházková','Marie Málková','Mahulena Bočanová','Jan Přeučil','Jaroslav Tomsa','Václav Vydra nejml.','Milan Klásek','Alena Procházková','Martin Stropnický','Josef Šebek','Karel Hovorka st.','Vladimír Pospíšil','Vladimír Hrabánek','Zuzana Burianová','Jaroslav Mareš','Lída Plachá','Vladimír Kratina','Petr Svárovský','Zora Jandová','Jan Kehár','Marta Pospíchalová','Jan Skopeček','Ilona Svobodová','Václav Štekl','Mnislav Hofmann','Lubomír Kostelka','Oldřich Velen','Miloslav Kročil','Taťána Čechovská','Božena Fixová','Zdeněk Hodr','Daniel Dítě','Stanislava Bartošová','Roman Hájek','Ludmila Slancová','Jitka Nováková','Elena Strupková','Zdeněk Srstka','Anna Wetlinská','Jana Viščaková','Luďa Marešová','Jan Kaněra','Milan Svoboda','Vladimír Brabec','Karel Hábl','Ilja Kreslík','Jiří Žák','Monika Hladová','Jaroslav Rava','Jiřina Steimarová','Petr Drozda'],
screenplay:['Ota Hofman','Jindřich Polák'],
music:['Karel Svoboda'],
camera:['Jiří Macháně'],
cut:['Zdeněk Stehlík'],
sound:['Miloslav Hůrka'],
scenography:['Zbyněk Hloch'],
masks:['Tomáš Kuchta','Jiří Hurych'],
costumes:['Theodor Pištěk ml.']},
{title:'Defending Jacob',
titleCZ:'Defending Jacob',
year:2020,
runtime:'6h 42min',
episodeRuntime:'45-65min',
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Morten Tyldum'],
actors:['Chris Evans','Michelle Dockery','Jaeden Martell','Cherry Jones','Pablo Schreiber','Betty Gabriel','Sakina Jaffrey','Daniel Henshall','J.K. Simmons','Ben Taylor','Jordan Alexa Davis','Megan Byrne','Patrick Fischler','Poorna Jagannathan','Myra Lucretia Taylor','Ian Lyons','Michele Proude','Raymond Alongi','Morgan Taylor Campbell','Audrey Wasilewski','Devon Diep','Rebecca Gibel','Kristina Byerley','Aaron Andrade','Daniel Washington','Therese Plaehn','Daryl Edwards','Ken Cheeseman','Michael Tow','Jessi Case','Rena Maliszewski','Marilyn Busch','Austin J. Ryan'],
basedOn:['William Landay'],
screenplay:['Mark Bomback'],
production:['Lisa C. Satriano'],
music:['Atli Örvarsson'],
camera:['Jonathan Freeman'],
cut:['Tanya M. Swerling','Tom Wilson'],
sound:['Steve Pederson','Mandell Winter'],
scenography:['Patti Podesta','Bryan Felty'],
masks:['Michelle Connolly'],
costumes:['Johanna Argan']},
{title:'Extreme Dinosaurs',
titleCZ:'Extreme Dinosaurs',
year:1997,
runtime:'19h 4min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Animation','Action','Crime','Sci-Fi'],
director:['Richard Trueblood'],
actors:['Scott McNeil','Cusse Mankuma','Garry Chalk','Terry Klassen','Lee Tockar','Sam Vincent','Jason Gray-Stanford','Blu Mankuma','Andrew Francis','Andrew Kavadas','Sean Amsing','Philip Maurice Hayes','William Samples','David Sobolov',"Ewan 'Sudsy' Clark",'Art Irizawa','Stevie Vallance','Christopher Gray'],
screenplay:['Douglas Booth','Michael Maurer','Ken Pontac','David Bleiman Ichioka','Jules Dennis','Gildart Jackson','Temple Mathews',"Dennis O'Flaherty",'Eleanor Burian-Mohr','Eric Luke','Greg Johnson','Reed Shelly','Doug Molitor','Matt Uitz','David Henry Schneider','Jeff Kwitny'],
production:['Kurt Weldon'],
music:['Matt McGuire'],
sound:['Mark Lanza','Stephen P. Robinson'],
scenography:['Scott Heming']},
{title:'Okresní přebor',
titleCZ:'Okresní přebor',
year:2010,
runtime:'7h 22min',
episodeRuntime:'25-30min',
countries:['Czechia'],
genres:['Comedy','Sport'],
director:['Jan Prušinovský','Jakub Kohák'],
actors:['Ondřej Vetchý','David Novotný','Luděk Sobota','Pavel Kikinčuk','Leoš Noha','Pavel Nečas','Jaroslava Pokorná','Ladislav Hampl','Jakub Kohák','Petr Růžička','Lukáš Langmajer','Jiří Petříš','Petr Franěk','Miloslav Štrobl','Tatiana Dyková','Marika Procházková','Alena Mihulová','Ivan Trojan','Jan Václavík','Petra Hobzová','Lukáš Příkazký','Jana Pidrmanová','Ladislav Županič','Václav Kopta','Karel Wiencek','Jarmil Škvrna','Hynek Čermák','Ludmila Kartousková','Stanislav Štícha','Jaroslav Šimek','Heda Pacnerová','Luboš Vrňata','Martin Pechlát','Michal Pavlata','Marek Taclík','Jolana Běhounková','Petr Nárožný','Doan Gia Bao','Pavel Šimčík','Barbora Poláková','Pavla Beretová','Mikuláš Křen','Oldřich Limport','Jan Prušinovský','Slávek Horák','Lukáš Novotný'],
screenplay:['Jan Prušinovský','Petr Kolečko'],
production:['Jan Maxa'],
music:['Vratislav Kydlíček'],
camera:['Petr Bednář','Aleš Hart','Darko Štulič','Jan Šťastný','David Šachl','Jan Filip'],
cut:['Lukáš Opatrný','Otakar Šenovský'],
sound:['Matěj Matuška','Michal Čech'],
scenography:['Jan Vlček'],
masks:['Jana Bílková'],
costumes:['Ivan Stekla']},
{title:'Pohádky ovčí babičky',
titleCZ:'Pohádky ovčí babičky',
year:1966,
runtime:'1h 49min',
episodeRuntime:'7-10min',
countries:['Czechoslovakia'],
genres:['Animation','Fairytale'],
director:['Václav Bedřich'],
actors:['Jiřina Bohdalová'],
screenplay:['Dagmar Spanlangová'],
camera:['Zdenka Hajdová']},
{title:'The Beauty Inside',
titleCZ:'The Beauty Inside',
year:2012,
runtime:null,
episodeRuntime:'6x5min',
countries:['USA'],
genres:['Romance','Drama'],
director:['Drake Doremus'],
actors:['Topher Grace','Mary Elizabeth Winstead','Caitríona Balfe','Matthew Gray Gubler','Ben York Jones','Keeley Hazell','Elaine Kagan','Marshall Manesh','Heather Hahn','Eric Edelstein','Jeff Ward','Steve Zissis','Anna Akana','David Hoflin','Jordan Masterson','Oliver Muirhead','Jack Axelrod','Darrell Lake','Melvin Gregg','Bambadjan Bamba','Luis Fernandez-Gil','Sheila Carrasco','Paget Kagy'],
screenplay:['Richard Greenberg'],
music:["Dustin O'Halloran"],
camera:['Sean Stiegemeier'],
cut:['Annette Davey'],
scenography:['Katie Byron'],
masks:['Marianna Elias']},
{title:'You Who Came from the Stars',
titleCZ:'Milenec z vesmíru',
year:2013,
runtime:'20h 35min',
episodeRuntime:'57-60min',
countries:['South Korea'],
genres:['Drama','Romance','Comedy','Sci-Fi'],
director:['Tae-yoo Jang','Choong-hwan Oh'],
actors:['Ji-hyeon Jeon','Soo-hyeon Kim','In-na Yoo','Hae-jin Park','Chang-wan Kim','Seong-rok Shin','Joon-sang Yoo','Eun-seo Sohn','Soo-ro Kim','Hyo-seop Eom','Jae-hyeon Ahn','Jeong-gil Lee','Il-hwa Lee','Seung-ryong Ryoo','Woo-jin Yeon','Eun-pyo Jeong','Hee-bong Jo','In-yeong Yoo','Bo-mi Kim','Yeong-gyoo Park','Suzy Bae','Hee-won Kim','Sandara Park','In-woo Jo','Yoon-tae Kim','Hyeon-soo Kim','Hang-joon Jang','Yi-kyeong Lee','Yeong-hee Nah','Jeong-ah Park','Min Choi','Kang-hyeon Kim','Hyo-eun Choi','Byeong-sook Seong','Jin-seo Jeon','Sang-jin Oh','Dae-seong Choi','Sung-bum Jang','Woong Choi','Hyun-kwang Jin','Woo-hee Bae','Jin-kyung Hong'],
screenplay:['Ji-eun Park'],
camera:['Gil-Bok Lee']},
{title:'Candy Candy',
titleCZ:'Candy Candy',
year:1976,
runtime:'47h 55min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Family','Drama','Romance'],
director:['Hiroši Šidara','Tecuo Imazawa','Júdži Endó'],
actors:['Minori Macušima','Kazuhiko Inoue','Makio Inoue','Mami Kojama','Júdži Micuja','Sačiko Čidžimacu','Kaneta Kimocuki','Kei Tomijama','Keiko Jamamoto','Keaton Jamada','Osamu Kató','Kóko Kagawa','Seiko Nakano','Kijoši Komijama','Mijoko Asó','Haruko Kitahama','Nana Jamaguči','Jonehiko Kitagawa','Jumi Nakatani','Taeko Nakaniši','Taeko Nakaniši'],
basedOn:['Kjóko Mizuki','Jumiko Igaraši'],
screenplay:['Noboru Širojama',"Šun'iči Jukimuro"],
production:['Jújake Usui'],
music:['Takeo Watanabe'],
cut:['Osamu Tanaka','Šigeru Nišijama','Fumio Soda']},
{title:'Grimm Masterpiece Theater',
titleCZ:'Pohádky bratří Grimmů',
year:1987,
runtime:'18h 48min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Drama','Fairytale','Romance','Fantasy'],
director:['Hiroši Saitó','Takajoši Suzuki',"Šin'ja Hanai",'Kazujoši Jokota','Fumio Kurokawa','Kózó Kusuba'],
actors:['Kajoko Fudžii','Micuko Horie','Keisuke Jamašita','Masaja Taki','Čika Sakamoto','Ičiró Nagai','Mijoko Asó','Haru Endó','Minoru Inaba','Ricuo Sawa','Rjúsei Nakao','Takeo Ono','Šunsuke Šima','Jú Šimaka','Sandži Hase','Jošino Ótori','Džódži Janami','Mičitaka Kobajaši','Čie Kitagawa','Šigeru Čiba','Kimie Hantani','Osamu Kató','Terue Nunami','Šó Saitó','Joku Šioja','Juriko Jamamoto','Čikao Ócuka','Bin Šimada','Tošiko Fudžita','Hóčú Ócuka','Bandžó Ginga','Jumiko Šibata','Hidejuki Hori','Reiko Jamada',"Ken'iči Ogata",'Mami Kojama','Čieko Honda','Jošino Takamori','Daisuke Góri','Takuzó Kamijama','Nana Jamaguči','Kózó Šioja','Šinobu Adači','Tomoko Maruo','Teššó Genda','Čijoko Kawašima','Reiko Suzuki','Rjúdži Saikači','Kjóko Tongú','Hiroko Emori','Kazumi Tanaka','Ikuja Sawaki','Masaharu Sató','Ken Jamaguči','Masaru Ikeda','Kaneto Šiozawa','Nobuo Tobita','Keiko Hanagata','Sakiko Tamagawa','Nozomu Sasaki','Kazue Komija','Gara Takašima','Kóhei Mijauči','Tošija Ueda','Šindži Ogawa','Čihoko Šigeta',"Džun'iči Sugawara",'Jósuke Akimoto','Kacunosuke Hori','Keiko Han','Micuaki Hošino','Hiromi Curu','Masami Kikuči','Akiko Cuboi','Tomie Kataoka','Keaton Jamada','Noriko Uemura','Kódži Totani','Kazujo Aoki','Acuko Mine','Sumi Šimamoto','Akio Nodžima','Osamu Saka','Šózó Iizuka','Naoki Tacuta','Jukimasa Kišino','Mičie Tomizawa','Kazuhiko Inoue','Masaši Ebara','Kimie Nakadžima','Mačiko Wašio',"Ken'iči Ono",'Kumiko Takizawa','Kóiči Jamadera','Masako Kacuki','Miho Jošida','Daiki Nakamura','Kacudži Mori','Megumi Hajašibara','Tošio Furukawa'],
basedOn:['Wilhelm Grimm','Jacob Grimm'],
screenplay:['Nobujuki Fudžimoto','Jú Jamamoto','Akira Mijazaki','Hiroši Saitó'],
production:['Šindži Nabešima','Takadži Macudo'],
music:['Hideo Šimazu','Kóiči Morita'],
camera:['Tošiaki Morita'],
cut:['Hidetoši Kadóno','Šigeto Nakamura','Šin`iči Natori','Jošihiro Kasahara'],
sound:['Sadajoši Fudžino'],
scenography:['Makoto Sató','Masazumi Macumija','Midori Čiba','Taisaburó Abe','Cutomu Fudžita','Kazuja Fukuda','Micuki Nakamura','Kazuko Kacui','Teiiči Akaši']},
{title:'Castlevania',
titleCZ:'Castlevania',
year:2017,
runtime:'14h',
episodeRuntime:'22-31min',
countries:['USA'],
genres:['Animation','Action','Adventure'],
director:['Sam Deats','Adam Deats','Spencer Wan'],
actors:['Richard Armitage','James Callis','Alejandra Reynoso','Theo James',"Adetokumboh M'Cormack",'Jaime Murray','Graham McTavish','Matt Frewer','Emily Swallow','Matt Lowe','Jessica Brown Findlay','Lila Fukušima','Jason Isaacs','Yasmine Al Massri','Tony Amendola','Timothy Omundson','Fred Tatasciore','Ivana Milicevic','Navid Negahban','Bill Nighy','Toru Uchikado','Gildart Jackson','Lance Reddick','Barbara Steele','Emma Catherine Rigby','JB Blanc','Peter Stormare','Adam Croasdell','Imari Williams','André Sogliuzzo','Dave B. Mitchell','Moira Quirk','JP Karliak'],
screenplay:['Warren Ellis'],
production:['Jason Williams','Maki Terašima-Furuta'],
music:['Trevor Morris'],
cut:['Adam Deats','Keith Wahrer','David Howe'],
sound:['Gary Falcone','Tom Maydeck'],
scenography:['Sam Deats']},
{title:'Tančírna na hlavní třídě ’56',
titleCZ:'Tančírna na hlavní třídě ’56',
year:2016,
runtime:'4h 41min',
episodeRuntime:'90-98min',
countries:['Germany'],
genres:['Drama'],
director:['Sven Bohse'],
actors:['Sonja Gerhardt','Claudia Michelsen','Maria Ehrich','Emilia Schüle','Heino Ferch','Uwe Ochsenknecht','Sabin Tambrea','Trystan Pütter','August Wittgenstein','Katharina Schüttler','Robert Schupp','Anne Werner','Markus Boysen','Paula Kober','Martina Schöne-Radunski','Ferdinand Dörfler','Steve Windolf','Emanuela von Frankenberg','Steffen C. Jürgens','Hansi Jochmann','Anna König','Carsten Hayes','Felix Maximilian','Charles Lemming','Dieter Rupp','Alexander Cudreasov','David Brückner','Silvina Buchbauer','Michael Ihnow','Thomas Gerber','Timo Hack','Alexander Merk'],
screenplay:['Annette Hess'],
production:['Benjamin Benedict','Nico Hofmann','Marc Lepetit'],
music:['Maurus Ronner'],
camera:['Michael Schreitel'],
cut:['Peter Kirschbaum','Ronny Mattas'],
sound:['Tobias Peper','Stefano Di Fiore','Ralf Herrmann'],
scenography:['Lars Lange','Sabin Enste','Tina Mursall'],
masks:['Gregor Eckstein','Elke Lebender','Jeanette-Nicole Latzelsberger'],
costumes:['Maria Schicker']},
{title:'Never Wipe Tears Without Gloves',
titleCZ:'Nikdy neotírej slzy bez rukavic',
year:2012,
runtime:'2h 54min',
episodeRuntime:'58min',
countries:['Sweden'],
genres:['Drama'],
director:['Simon Kaijser'],
actors:['Adam Lundgren','Adam Pålsson','Björn Kjellman','Björn Kjellman','Simon J. Berger','Emil Almén','Christoffer Svensson','Kristoffer Berglund','Annika Olsson','Stefan Sauk','Marie Richardson','Gerhard Hoberstorfer','Ulf Friberg','Jonathan Eriksson','Claes Hartelius','Belle Weiths','Gorm Rembe Nylander','Lisa Linnertorp','Ia Langhammer','Sanna Sundqvist','Jennie Silfverhjelm','Julia Sporre','Lena B. Eriksson','Shebly Niavarani','David Mjönes','Björn Wahlberg','Christian Arnold','Anton Eriksson','Andreas Samuelson','Andreas Carlsson','Alexi Carpentieri','Emilie Fahlstedt Lindquist','Michael Petersson','Magnus G. Bergström','Iman Mirbioki','Carl Lindquist','Lars Fransson','Michael Jonsson'],
screenplay:['Jonas Gardell'],
production:['Maria Nordenberg'],
music:['Andreas Mattsson'],
camera:['Stefan Kullänger'],
cut:['Agneta Scherman','Simon Kaijser'],
sound:['Anders Larsson','Ulf Janzon'],
scenography:['Jan Olof Ågren'],
masks:['Susanne Unnerstad'],
costumes:['Ewa Mark']},
{title:'Scavengers Reign',
titleCZ:'Scavengers Reign',
year:2023,
runtime:'4h 55min',
episodeRuntime:'23-27min',
countries:['USA'],
genres:['Animation','Adventure','Drama'],
director:['Joe Bennett','Charles Huettner','Benjy Brooke','Jonathan Djob Nkondo','Vincent Tsui','Rachel Reid','Christine Jie-Eun Shin','Diego Porral'],
actors:['Alia Shawkat','Wunmi Mosaku','Sunita Mani','Bob Stephenson','Ted Travelstead','Pollyanna McIntosh','Dash Williams','Freddy Rodríguez','Chris Diamantopoulos','Okieriete Onaodowan','Skyler Gisondo','Sepideh Moafi'],
screenplay:['Charles Huettner','Joe Bennett','Sean Buckelew','James Merrill','Jenny Deiker Restivo','Jillian Goldfluss'],
music:['Nicolas Snyder'],
cut:['Jason Klein'],
sound:['Konrad Piñon','Axel Steichen','Felix Davin','Gaspard Caupeil','Mike Jansson'],
scenography:['Charles Huettner']},
{title:'Romanzo Criminale',
titleCZ:'Romanzo criminale - La serie',
year:2008,
runtime:'19h 51min',
episodeRuntime:'47-61min',
countries:['Italy'],
genres:['Crime','Drama','Thriller'],
director:['Stefano Sollima'],
actors:['Riccardo De Filippis','Vinicio Marchioni','Alessandro Roja','Marco Bocci','Daniela Virgilio','Andrea Sartoretti','Giorgio Caputo','Mauro Meconi','Edoardo Pesce',"Dario D'Ambrosi",'Roberto Infascelli','Alessandra Mastronardi','Ivano De Matteo','Marco Giallini','Chiara Francini','Edoardo Leo','Massimo De Francovich','Antonio Gerardi','Claudio Spadaro','Carolina Felline','Fausto Paravidino','Linda Chang','Alessandro Marverti','Greta Scarano','Adriano Chiaramida','Maurizio Lombardi','Anna Bellato','Lorenzo Gioielli','Josafat Vagni','Alessandro Borghi','Christian Vit','Marco Conidi','Jacopo Troiani','Kai Portman','Tommaso Sacco','Romano Ghini','Bruno Buzzi','Lorenzo Renzi','Francesco Montanari','Fabio Camilli','Orlando Cinque','Fausto Maria Sciarappa','Danilo Nigrelli','Simone Mori','Emiliano Coltorti','Alberto Gasbarri','Alessandro Prete','Antonella Attili','Vincenzo Tanassi','Giovanna Di Rauso','Bruno Pavoncello','Fulvio Pepe','Max Malatesta','Federico Torre','Italo Amerighi','Beatriz Luz Lattanzi','Massimiliano Franciosa','Mauro Cremonini','Emanuele Bosi','Roberto Latini','Adriano Saleri','Paolo Buglioni','Tiziana Buldini','Valentina Calandriello','Flavio Domenici','Duccio Camerini','Francesco Sciacca','Aldo Abbate','Gianpiero Alicchio','Rocco Barbaro','Alessandro Bardani','Enrico Bellisari','Franco Bottone','Ninetto Davoli','Umberto De Luca','Marco Di Folco','Germana Di Giannicola','Angelica Di Majo','Fiorello','Maurizio Ghedin','Gaetano Giordano','Francesco Gisotti','Giovanni la Gorga','Alfonso Liguori','Andrea Lolli','Tony Malco','Fabio Mancini','Alessio Manuali','Paolo Mellucci','Umberto Morelli','Valerio Morigi','Antonio Nobili','Luca Paniconi','Romolo Passini','Alberto Patelli','Orlando Ragusa','Monica Rametta','Francesco Marino','Alessandra Roca','Saverio Mattei'],
screenplay:['Daniele Cesarano','Leonardo Valenti','Barbara Petronio','Giancarlo De Cataldo','Paolo Marchesini'],
production:['Marco Chimenz','Giovanni Stabilini','Riccardo Tozzi'],
music:['Pasquale Catalano'],
camera:['Ivan Casalgrandi','Paolo Carnera','Nicoletta Taranta'],
cut:['Patrizio Marone'],
sound:['Maricetta Lombardo','Francesco Tumminello'],
scenography:['Paola Comencini','Maurizio Leonardi','Alberto Duelli'],
masks:['Maria Federico','Alberto Blasi','Diego Avolio'],
costumes:['Nicoletta Taranta']},
{title:'Ripper Street',
titleCZ:'Ripper Street',
year:2012,
runtime:'39h 30min',
episodeRuntime:'58-130min',
countries:['UK'],
genres:['Crime','Drama','Mystery'],
director:['Andy Wilson','Tom Shankland','Colm McCarthy','Kieron Hawkes','Christopher Menaul','Anthony Byrne','Saul Metzstein','Nick Rowland','Ashley Way','Luke Watson'],
actors:['Matthew Macfadyen','Jerome Flynn','Adam Rothenberg','MyAnna Buring','David Wilmot','Charlene McKenna','David Dawson','Clive Russell','Amanda Hale','Gillian Saker','Peter Ferdinando','Anton Lesser','Steven Robertson','Mark Dexter','Geoff Bell','Joe Gilgun',"Hugh O'Conor",'Michael Smiley','Paul McGann','Ian McElhinney','Emma Catherine Rigby','Jamie Sives','Michael McElhatton','Iain Glen','Julian Firth','Damien Molony','Charlie Murphy','Morgan C. Jones','Paul Kaye','Gina Bellman','Ferdinand Kingsley','Paul Ready','Michael Marcus','Luke Allen-Gale','Joseph Mawle','Lucy Cohu','Callum Turner','Scott Handy','Alfie Stewart','Branislav Martinák','Rod Hallett','Amber Jean Rowan','Peter Sullivan','Stanley Townsend','Emily Taaffe','Emma Griffiths Malin','Laura Haddock','Lalor Roddy','Dermot Magennis','Oliver Cotton','Kunjue Li','Georgina Rich','Joel Gillman','Anthony Morris',"Josh O'Connor",'Andy Kellegher','Melissa Maria Carton','Peter Robbie','Matthew Lewis','David Threlfall','Killian Scott','Izzy Meikle-Small','Anna Koval','Jonas Armstrong','Kristian Nairn','Patrick Baladi','Penny Downie','Stuart Bunce','Dave Legeno','Sam Hazeldine','Edoardo Ballerini','Shauna Macdonald','David Oakes','Ruta Gedmintas','Frank Harper','Nicholas Woodeson','Tom Brooke','Neve McIntosh','David Murray','James Wilby','Martin McCann','Belinda Stewart-Wilson','Andrew Tiernan','David Costabile','Keith Skinner','Lydia Wilson','Louise Brealey','Francis Magee','Charlie Creed-Miles','Jason Manford','Philip Arditti','Dean-Charles Chapman','Charles Edwards','Martin Compston','Peter McDonald','Elliot Levey','Robert Render','Ian Gelder','Mark Coney','Derek Reid'],
screenplay:['Richard Warlow','Toby Finlay','Rob Green','Rachel Bennette','Declan Croghan','Julie Rutterford','Justin Young','Jamie Crichton','Thomas Martin','Marnie Dickens'],
production:['Stephen Smallwood','Joe Donaldson'],
music:['Dominik Scherrer'],
camera:['Julian Court','P.J. Dillon','Peter Robertson','Balazs Bolygo','Simon Dennis','Owen McPolin','Si Bell','John Lee','Suzie Lavelle'],
cut:['Iain Erskine','Paul Knight','Matthew Tabern','Adam Bosman','Úna Ní Dhonghaíle','Sam Williams','Helen Chapman','Simon Brasse'],
sound:['Mathew Knights'],
scenography:['Mark Geraghty','Stephen Daly','David Wilson','Kevin Downey','Jenny Oman'],
masks:['Tina Phelan','Belinda Roche','Sharon Doyle'],
costumes:['Leonie Prendergast','Lorna Marie Mugan']},
{title:'Tenacious D',
titleCZ:'Tenacious D',
year:1999,
runtime:null,
episodeRuntime:'30min',
countries:['USA'],
genres:['Comedy','Music'],
director:['Troy Miller'],
actors:['Jack Black','Kyle Gass','Scott Adsit','Paul F. Tompkins','David Cross','JR Reed','Moon Unit Zappa','Laura Kightlinger','Jay Johnston','Kate Mulligan','Ken Daly','Mark Fite'],
screenplay:['Bill Odenkirk']},
{title:'Helluva Boss',
titleCZ:'Helluva Boss',
year:2019,
runtime:null,
episodeRuntime:'12min',
countries:['USA'],
genres:['Short','Animation','Comedy'],
director:['Vivienne Medrano'],
actors:['Brandon Rogers','Brock Baker','Erica Lindbeck','Richard Steven Horvitz','Cristina Valenzuela','Remy Edgerly'],
screenplay:['Vivienne Medrano','Brandon Rogers'],
music:['Cooper Smith Goodwin'],
sound:['George Peters','Robert Hargreaves','Shaun Cunningham'],
scenography:['Sam Miller']},
{title:'Rákosníček a jeho rybník',
titleCZ:'Rákosníček a jeho rybník',
year:1983,
runtime:'1h 44min',
episodeRuntime:'8min',
countries:['Czechoslovakia'],
genres:['Animation','Fairytale'],
director:['Zdeněk Smetana'],
actors:['Jiřina Bohdalová'],
screenplay:['Zdeněk Smetana','Vladimír Branislav'],
music:['Václav Zahradník'],
camera:['Dana Olejníčková','Jaroslava Zimová'],
cut:['Zdenka Navrátilová'],
sound:['Benjamin Astrug']},
{title:'Fly Tales',
titleCZ:'Moucha',
year:1999,
runtime:'5h 25min',
episodeRuntime:'5min',
countries:['France','Canada','Germany'],
genres:['Animation'],
director:['Charlie Sansonetti'],
actors:['Brigitte Lecordier','Marc Saez'],
screenplay:['Samuel Kaminka','Isabelle de Catalogne','Laurent Turner','Alexandre Reverend','Lewis Trondheim'],
production:['Philippe Delarue'],
music:['Daniel Scott']},
{title:'Danger 5',
titleCZ:'Danger 5',
year:2011,
runtime:null,
episodeRuntime:'14x24min',
countries:['Australia'],
genres:['Adventure','Comedy','Sci-Fi'],
director:['Dario Russo'],
actors:['Susanna Dekker','Natasa Ristic','David Ashby','Aldo Mignone','Sean James Murphy','Amanda Simons','Dario Russo','Brendan Cain','Tiffany Lyndall-Knight','Sarah Jeavons','Andreas Sobik','Andrew Cropley','Pacharo Mzembe','Peta Shannon','Craig Behenna','Grant Page','Stephen Tongun','Diego Boy','Matt Crook','Maddy Jevic','Vince Poletto','Miles Rowland','Louisa Mignone','Brendan Rock'],
production:['Kate Croser'],
sound:['Duncan Campbell','Pete Smith']},
{title:'Alexandr Dumas starší',
titleCZ:'Alexandr Dumas starší',
year:1970,
runtime:'3h 47min',
episodeRuntime:'65-90min',
countries:['Czechoslovakia'],
genres:['Drama','History','Biography'],
director:['Jaroslav Dudek'],
actors:['Vladimír Menšík','Jan Kačer','Jana Hlaváčová','Jana Štěpánková','Josef Langmiler','Dana Medřická','Gustav Nezval','Antonie Hegerlíková','Marie Drahokoupilová','Jana Šulcová','Blanka Waleská','Jiří Hrzán','František Filipovský','Petr Haničinec','Miloš Nesvadba','Josef Patočka','Jaroslava Adamová','Milena Dvorská','Ilja Prachař','Josef Somr','Jaroslav Kepka','Zdeněk Řehoř','Jaroslav Moučka','Otakar Brousek st.','Ladislav Křiváček','František Němec','Jaroslava Pokorná','Jaroslav Cmíral','Alena Procházková','Viktor Očásek','Josef Gruss','Michaela Lohniská','Ladislav Navrátil','Vladimír Stach','Oldřich Musil','Blažena Holišová','Regina Rázlová','Marie Brožová','Ludmila Píchová','Mirko Musil','Jan Přeučil','Vladimír Bičík','Svatopluk Skládal','František Hanus','Ladislav Potměšil','Felix le Breux','Zdeněk Hodr','Vlastimil Fišar','František Holar','Josef Bláha'],
basedOn:['André Maurois'],
screenplay:['Jaroslav Dietl'],
camera:['Adolf Navara'],
cut:['Jiří Šebelka','Miloslav Liška'],
sound:['Svatava Hrubcová'],
scenography:['Miroslav Pelc'],
costumes:['Stela Drozdová']},
{title:'Blackpool',
titleCZ:'Blackpool',
year:2004,
runtime:'5h 53min',
episodeRuntime:'58-60min',
countries:['UK'],
genres:['Musical','Crime','Drama'],
director:['Coky Giedroyc','Julie Anne Robinson'],
actors:['David Morrissey','Sarah Parish','David Tennant','Georgia Taylor','Steve Pemberton','David Bradley','Bryan Dick','Kevin Doyle','Jacqueline Pilton','Lisa Millett','John Thomson','Joe Armstrong','Paul Ready','Josef Altin','Paul Chahidi','Lasco Atkins','Jim Whelan','James Cartwright','Emily Aston'],
screenplay:['Peter Bowker'],
music:['Rob Lane'],
camera:['Lukas Strebel'],
cut:['Anthony Combes']},
{title:'Secret Garden',
titleCZ:'Tajemná zahrada',
year:2010,
runtime:'20h 34min',
episodeRuntime:'55-68min',
countries:['South Korea'],
genres:['Romance','Comedy','Fantasy','Drama'],
director:['Hyeok-chan Kwon','Woo-cheol Shin'],
actors:['Ji-won Ha','Bin Hyun','Sang-hyeon Yoon','Sa-rang Kim','Philip Lee','In-na Yoo','Seong-oh Kim','Ye-jin Son','Jong-seok Lee','Byeong-joon Lee','In-gi Jeong','Yoon-ah Song','Sa-hee Kim','Seo-won Jang','Joon-hyeok Lee','Seong-yong Han','Eun-mi Lee','Yoon-so Choi','Gi-won Yoon','Joon-geum Park','Byeong-sook Seong','Seung-hee Baek','Tae-woo Lee','Dae-seong Choi','Heon-tae Jeon','So-mi Baek','Hong-cheol Noh','Ga-hyun Jang','Mo Jin'],
screenplay:['Eun-sook Kim']},
{title:'Underbelly',
titleCZ:'Ostré jako břitva',
year:2008,
runtime:'55h 56min',
episodeRuntime:'39-74min',
countries:['Australia'],
genres:['Drama','Crime','Mystery'],
director:['Tony Tilse','Shawn Seet','David Caesar','Peter Andrikidis','Mat King','Geoff Bennett','Grant Brown','Ken Cameron','Cherie Nowlan','Ian Watson','Andrew Prowse','Karl Zwicky'],
actors:['Caroline Craig','Rodger Corser',"Peter O'Brien",'Ian Bliss','Callan Mulvey','Alex Dimitriades','Kestie Morassi','Vince Colosimo','Emma Moore','Simon Lyndon','Jessica De Gouw','Ryan Johnson','Charlotte Gregg','Emma Booth','Firass Dirani','Steve Bastoni','Kevin Harrington',"David O'Donnell",'Brooke Callaghan','Anthony Simcoe','Simone Kessell','Toby Leonard Moore','Dustin Clare','Natalie Bassingthwaighte','Gareth Reeves','Wayne Pygram','Matt Passmore','John Brumpton','Martin Sacks','Les Hill','Gyton Grantley','Matthew Newton','Robert Mammone','Paul Tassone','Saskia Burmeister','Peter Phelps','Anna Hutchison','Myles Pollard','Lincoln Lewis','Damian Walshe-Howling','Anna McGahan','Ian Roberts','Jessica Mauboy','T.J. Power','Georgina Haig','Jenna Lind','Newt Wallen','Sullivan Stapleton','Danielle Cormack','Chelsie Preston Crayford','Matt Nable','Jonny Pasvolsky','Hugo Johnstone-Burt','Andrew Hazzard','Roy Billing','Dan Wyllie','Richard Brancatisano','Ashley Zukerman','John Batchelor','John Derum','Tim Phillipps','Ryan Corr','Catherine Farrah','Jodi Gordon','Andy McPhee','Megan Drury','Jessica Tovey','Radek Jonak','Fletcher Humphrys','Ella Scott Lynch','Anna Lawrence','Ed Oxenbould','Sophie Katinis','Jonathan Patrick Moore','Jane Harber','Samuel Johnson','Damon Gameau','Brendan Clearkin','Sam Anderson','Nathan Page','John Waters','Ashleigh Cummings','Rohan Nichol','Andrew Ryan','Damien Garvey','Silas James','George Koutros','Abby Earl','Tom Milton','Wayne Tunks','Matt Butcher','Maria Volk','Wil Traval','Leonine Smith','Adam Zwar','Laura Gordon','Peter Hardy','Jane Allsop','Don Hany','Jane Wormald'],
basedOn:['Andrew Rule'],
screenplay:["Michaeley O'Brien",'Adam Todd','Felicity Packard','Greg Haddrick','Peter Gawler','Kris Mrksa','Jeff Truman','Matt Ford','Niki Aken','Michael Miller'],
production:['Peter Gawler','Brenda Pam','Greg Haddrick','Matt Ford','Kerrie Mainwaring'],
music:['Burkhard von Dallwitz','Amanda Brown'],
camera:['John Brawley','Marc Spicer','Joseph Pickering','Mark Wareham'],
cut:['Peter Carrodus','Stephen Evans','Deborah Peart','Nicholas Holmes','Mark Perry'],
sound:['Joel McLean','Dino Giacomin','Stephen R. Smith'],
scenography:['Paddy Reardon','Ben Morieson','Michael Price','Sam Asher'],
masks:['Jodee Lenaine-Smith','Liz Harper'],
costumes:['Louise Wakefield','Jenny Miles']},
{title:'Horký vítr',
titleCZ:'Horký vítr',
year:1980,
runtime:null,
episodeRuntime:'10x55min',
countries:['Yugoslavia'],
genres:['Comedy'],
director:['Aleksandar Djordjevič'],
actors:['Ljubiša Samardžič','Bora Todorovič','Vesna Čipčič','Branko Cvejič','Tatjana Beljakova','Ranko Gučevac',"Dragomir 'Gidra' Bojanič",'Nikola Simič','Dara Čalenič','Dušan Janićijević','Ratko Miletič','Janez Vrhovec','Mira Banjac','Milutin Butkovič','Slavko Simič','Ljuba Tadič','Milivoj Popovič-Mavid','Danica Ristovski','Melita Bihali','Miodrag Andrič','Predrag Milinkovič',"Mihajlo 'Bata' Paskaljevič","Živojin 'Žika' Milenkovič",'Nikola Milič','Jelica Sretenovič','Ružica Sokič','Ljubica Kovič',"Milivoje 'Miča' Tomič",'Vojislav Brajovič','Petar Lupa','Ljubomir Čipranič','Vladan Živkovič','Dušan Tadič','Mirjana Nikolić'],
screenplay:['Siniša Pavič'],
costumes:['Gordana Andjelkovič']},
{title:'The Vicar of Dibley',
titleCZ:'The Vicar of Dibley',
year:1994,
runtime:'9h 38min',
episodeRuntime:'29-60min',
countries:['UK'],
genres:['Comedy'],
director:['John Howard Davies','Dewi Humphreys','Ed Bye','Martin Dennis','Gareth Carrivick'],
actors:['Dawn French','Emma Chambers','James Fleet','Roger Lloyd Pack','John Bluthal','Richard Armitage','Johnny Depp','Stephen Tompkinson','Orla Brady','Cristian Solimeno','Miranda Hart','Simon McBurney','Jeremy Paxman','Roger Sloman','Clive Mantle','Marlene Sidaway','Carol MacReady','Charles Pemberton','Darcey Bussell','Damian Lewis','Nathalie Cox','Stewart Wright','Preston Lockwood','Emma Watson','Jennifer Saunders','Maureen Lipman','Ruth Jones','Annette Crosbie','Richard Ayoade','Selina Cadell','Kylie Minogue','Sean Bean','Hugh Bonneville','Trudie Styler','Jane Galloway','Charlie Watts','Rachel Hunter','Sting','Richard Griffiths','Liz Smith','Nicholas Blane','Fiona Bruce','Peter Capaldi','Jon Plowman','Mel Giedroyc','Guillaume Tobo','Gary Waldhorn','Nina Wadia','Moray Watson','Edward Kelsey','Nicholas Le Prevost','Trevor Peacock','David Sterne','Jacqueline Crockett','Alistair McGowan','papež Jan Pavel II.','Cliff Richard','Sarah Ferguson','Geraldine McNulty','Philip Whitchurch','Mike Yarwood'],
screenplay:['Richard Curtis','Paul Mayhew-Archer'],
production:['Sue Vertue','Jon Plowman','Margot Gavan Duffy'],
music:['Howard Goodall'],
camera:['John Sorapure'],
cut:['Mykola Pawluk','Chris Wadsworth','Mark Lawrence','Steve Tempia'],
scenography:['Andrew Howe-Davies','Peter Findley'],
masks:['Norma Hill-Patton','Marella Shearer'],
costumes:['Rebecca Hale','Annie Hardinge','Sarah Burns']},
{title:'Carův kurýr',
titleCZ:'Carův kurýr',
year:1998,
runtime:'11h 16min',
episodeRuntime:'26min',
countries:['France'],
genres:['Animation','Adventure'],
director:['Bruno-René Huchez'],
actors:['Guillaume Orsat','Joël Zaffarano','Françoise Blanchard','Hervé Caradec','Olivier Hémon','Patrice Baudrier','Julie Turin','Michel Castelain','Emmanuel Fouquet','Cyrille Artaux','Marc Bretonnière','Pascale Jacquemont'],
basedOn:['Jules Verne'],
production:['Bruno-René Huchez'],
music:['Jean-Michel Bernard']},
{title:'O človíčkovi',
titleCZ:'O človíčkovi',
year:1985,
runtime:'1h 55min',
episodeRuntime:'8-10min',
countries:['Czechoslovakia'],
genres:['Animation','Family'],
director:['Josef Lamka'],
actors:['Jiří Wimmer'],
screenplay:['Josef Lamka'],
music:['Petr Skoumal'],
camera:['Jiří Větroň','Miloslav Žbánek'],
cut:['Marie Zemanová'],
sound:['Ivo Špalj']},
{title:'O chytré kmotře lišce',
titleCZ:'O chytré kmotře lišce',
year:1983,
runtime:'1h 40min',
episodeRuntime:'7-8min',
countries:['Czechoslovakia'],
genres:['Animation','Family'],
director:['Eduard Hofman'],
actors:['Jiřina Bohdalová'],
basedOn:['Josef Lada'],
screenplay:['Jindřich Vodička'],
music:['Miloš Vacek'],
camera:['Emil Strakoň'],
cut:['Marta Látalová']},
{title:'Hell on Wheels',
titleCZ:'Hell on Wheels',
year:2011,
runtime:'41h 29min',
episodeRuntime:'42-87min',
countries:['Canada','UK'],
genres:['Western'],
director:['David Von Ancken','Joe Gayton','John Shiban','Catherine Hardwicke','Alex Zakrzewski','Michael Slovis','Sergio Mimica-Gezzan','Michael Nankin','Rod Lurie','Adam Davidson','Dennie Gordon','Neil LaBute','Deran Sarafian','David Straiton','Rosemary Rodriguez','Billy Gierhart','Terry McDonough','Phil Abraham','Seith Mann','Michelle MacLaren','Marvin V. Rush','Jeremy Webb','Roxann Dawson','Clark Johnson','Karen Gaviola','Tim Southam'],
actors:['Anson Mount','Colm Meaney','Dominique McElligott','Common','Robin McLeavy','Kasha Kropinski','Eddie Spears','Christopher Heyerdahl','Tom Noonan','Barb Mitchell','April Telek','Wes Studi','Jake Weber','Dru Mouser','Ian Tracey','Ty Olsson','Ted Levine','Bruce Ramsay','Virginia Madsen','Byron Mann','Robert Moloney','Dustin MacDougall','Timothy V. Murphy','Wayne Duvall','Grainger Hines','Jennifer Ferrin','Sean Owen Roberts','Phil Burke','Alejandro Rae','Alex Zahara','Aleks Paunovic',"Gregory 'Dominic' Odjig",'Ryan Robbins','Fiona Vroom','Haysam Kadri','Jason Cermak','Duncan Ollerenshaw','Sharon Taylor','Kal Weber','Caitlynne Medrek','Christian Sloan','Siobhan Williams','Greg Lawson','David LeReaney','Christopher Rosamond','Robert Weiss','Scott Michael Campbell','Dave Trimble','Andrew Polk','Douglas Nyback','Jeff Fahey','Brian Jensen','Tim Guinee','Serge Houde','MacKenzie Porter','Victor Slezak','Chelah Horsdal','Peter Benson','John DeSantis','Brendan Fletcher','Reg Rogers','Tzi Ma','Michael Patric','Diego Diablo Del Mar','Taylor St. Pierre','Randy Birch','Brent Briscoe','Adam Beach','Colby French','Christopher Backus','Gregg Henry','Julia Maxwell','Conrad Pla','Zak Santiago','Michael Horse','Sara Canning','Michelle Thrush','Rod Lurie','Jonathan Scarfe','Andrew Howard','Julian Richings','Adrian Petriw','Kaj-Erik Eriksen','Toby Hemingway','Noah Dalton Danby','Barry Flatman','Mpho Koaho','Jason Schombing','Tseng Chang','David Ferry','Ben Sullivan','Michael Tiernan','Lauren K. Robek','Ben Esler','Angela Zhou','Josh Caras','Gerald Auger','Dohn Norwood','James D. Hopkin','James Dugan'],
screenplay:['Joe Gayton','Max Hurwitz','John Romano','Tony Gayton','Tom Brady','John Shiban','Reed Steiner','Chris Mundy','Jennifer Cecil','Miki Johnson',"Jami O'Brien",'Mark Richard','Bruce Marshall Romans'],
production:['Peter Chomsky'],
music:['Kevin Kiner'],
camera:['Elliot Davis','Thomas Burstyn','Marvin V. Rush'],
cut:['Stephen Mark','Skip Macdonald','Bridget Durnford','Todd Desrosiers','Kevin Krasny','Casey Brown','Scott van Beever'],
sound:['John Kincade','Mark Server','Kevin W. Buchholz','David Raines','Rick Ash','John Peccatiello'],
scenography:['John Blackie','Bill Ives'],
masks:['Sharon Toohey'],
costumes:['Wendy Partridge','Carol Case']},
{title:'Ouran High School Host Club',
titleCZ:'Klub společníků óranské střední',
year:2006,
runtime:'9h 58min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Drama','Comedy','Romance'],
director:['Takuja Igaraši','Šingo Kaneko','Tomoki Kjóda','Takefumi Anzai','Kazuki Kakuta','Tamaki Nakacu','Satomi Nakamura','Ikuró Sató','Masajuki Iimura','Kazuki Cunoda','Inuo Inukawa'],
actors:['Maaja Sakamoto','Mamoru Mijano','Masaja Macukaze',"Ken'iči Suzumura",'Jošinori Fudžita','Ajaka Saitó','Daisuke Kirii','Daisuke Namikawa','Mika Doi','Takehito Kojasu','Júdži Ueda','Šigenori Jamazaki','Júki Kadži','Ikuja Sawaki','Micuki Saiga','Džunko Takeuči','Mai Kadowaki','Fumihiko Tačiki','Kósuke Meguro','Sajori Išizuka','Rjóko Ono','Daisuke Góri','Kazuhiko Inoue','Takaši Nagasako','Kijomi Asai','Kurumi Mamija','Júko Sanpei','Kósuke Toriumi','Čó','Tomoko Kawakami','Júko Sasamoto','Jukari Tamura','Micuaki Hošino','Takaši Kondó','Óki Sugijama','Šintaró Asanuma','Hisako Kjóda','Hideki Tasaka','Kikuko Inoue','Tecuharu Óta','Nacuko Kuwatani',"Šin'ja Fukumacu",'Jutaka Nakano','Miho Jamada','Acuši Imaruoka','Kei Watanabe','Sajaka Narita','Masataka Sawada','Mantaró Iwao','Kozue Jošizumi','Ai Sató','Hiroši Širokuma','Acuši Ono','Ken Uo','Jasuko Hatori','Masao Harada','Kazuja Kobajaši','Takajuki Sasada','Tomomi Watanabe','Kajo Sakata','Risa Cubaki','Jutaka Ozawa'],
basedOn:['Bisuko Hatori'],
screenplay:['Jódži Enokido'],
production:['Masahiko Minami','Tošio Nakatani'],
music:['Jošihisa Hirano'],
camera:['Šúiči Heiši'],
cut:['Šigeru Nišijama'],
sound:['Kazuhiro Wakabajaši'],
scenography:['Norifumi Nakamura']},
{title:'Bangkok Hilton',
titleCZ:'Bangkok Hilton',
year:1989,
runtime:240,
episodeRuntime:null,
countries:['Australia'],
genres:['Drama'],
director:['Ken Cameron'],
actors:['Nicole Kidman','Denholm Elliott','Hugo Weaving','Jerome Ehlers','Noah Taylor','Pauline Chan','Lewis Fiander','Vincent Ball','Deborah Kara Unger','Monroe Reimers','Colin Borgonon','Clarissa Kaye-Mason','Bogdan Koca','Wallas Eaton','Gandhi MacIntyre','Richard Moss'],
screenplay:['Terry Hayes','Tony Morphett'],
production:['George Miller','Doug Mitchell'],
music:['Graeme Revell'],
camera:['Geoff Burton'],
cut:["Marcus D'Arcy",'Louise Innes'],
sound:['Lee Smith'],
scenography:['Owen Williams'],
masks:['Lesley Vanderwalt']},
{title:'The Bugs Bunny/Looney Tunes Comedy Hour',
titleCZ:'Bugs Bunny/Looney Tunes Comedy Hour,The',
year:1985,
runtime:null,
episodeRuntime:'13x45min',
countries:['USA'],
genres:['Animation','Family','Comedy'],
director:['Robert McKimson','Rudy Larriva','Chuck Jones','Friz Freleng'],
actors:['Mel Blanc','June Foray'],
music:['Carl W. Stalling','William Lava']},
{title:'Bannertail: The Story of Gray Squirrel',
titleCZ:'Seton dóbucuki: Risu no Banner',
year:1979,
runtime:'9h 58min',
episodeRuntime:'23min',
countries:['Japan','Germany'],
genres:['Animation','Fairytale'],
director:['Jošio Kuroda'],
actors:['Noriko Cukase','Ičiró Nagai','Keiko Jokozawa','Šigeru Čiba','Hiroko Marujama','Kaneta Kimocuki','Ikuko Tani','Hisako Kjóda','Mičiko Hirai','Masako Sugaja','Kazuomi Ikeda','Mijoko Asó','Gudrun Genest','Franz-Otto Krüger','Edith Hancke','Horst Gentzen','Wilfried Herbst'],
basedOn:['Ernest Thompson Seton'],
screenplay:['Tošijuki Kašikura'],
production:['Akira Negoro'],
music:['Akihiro Komori'],
camera:['Keišiči Kuroki'],
cut:['Masuo Warita'],
scenography:['Kazue Itó']},
{title:'Mononoke',
titleCZ:'Mononoke',
year:2007,
runtime:'4h 24min',
episodeRuntime:'22min',
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Mystery'],
director:['Kendži Nakamura','Hiroši Jamazaki','Mana Učijama','Kóhei Hatano','Sumio Watanabe','Hidehito Ueda','Jošihisa Macumoto','Jukihiko Nakao','Kódži Jamazaki','Masatoši Čioka'],
actors:['Daisuke Namikawa','Fumiko Orikasa','Hóko Kuwašima','Takeši Aono','Tomokazu Seki','Norio Wakamoto','Daisuke Sakaguči','Jukana','Eidži Takemoto','Takahiro Sakurai','Haruna Ikezawa','Tošiko Fudžita','Kózó Šioja','Minoru Inaba','Rie Tanaka','Ako Majama','Wakana Jamazaki','Masaši Hirose','Júsuke Numata','Rjúsei Nakao','Kódži Haramaki','Jasuhiro Takato','Seidži Sasaki','Jóko Sómi','Kóhei Fukuhara','Hiroši Iwasaki','Umeka Šódži','Kóta Nemoto','Keidži Hirai','Rjóhei Nakao','Aiko Hibi','Šúma Hiki','Takahiro Fudžimoto','Masaru Suzuki','Hikaru Midorikawa','Noriko Uemura','Hiroši Okamoto','Naoja Učida','Hidehiko Kaneko','Tomohisa Asó','Júta Kasuja','Šunzó Mijasaka','Daisuke Macubara','Rika Komacu','Jošihiro Kanemicu','Saki Jasuda','Miku Jošikawa','Hidemi Anzai','Kozue Kamada','Jumi Sudó','Tomoka Endó','Keiičiró Jamamoto','Isao Teramoto','Aki Sasaki','Asaka Ueoka'],
screenplay:['Mičiko Jokote','Manabu Išikawa','Ikuko Takahaši','Čiaki Konaka'],
production:['Acutoši Umezawa','Acuja Takase'],
music:['Jasuharu Takanaši'],
cut:['Kenta Katase'],
sound:['Jukio Nagasaki']},
{title:'The Founder of Diabolism',
titleCZ:'Mo dao zu shi',
year:2018,
runtime:'14h 15min',
episodeRuntime:'24-25min',
countries:['China'],
genres:['Animation','Action','Comedy'],
director:['Ke Xiong'],
actors:['Jiang Bian','Ketsu','Tong Shao','Shimeng Li','Tianxiang Yang','Shangqing Su','Sanmu Liu','Jin Xian','Chenzhang Taikang','Chenguang Wang','Shiyu Qiao'],
basedOn:['Mo Xiang Tong Xiu']},
{title:'Actor',
titleCZ:'Herec',
year:2020,
runtime:'3h 55min',
episodeRuntime:'76-83min',
countries:['Czechia'],
genres:['Drama'],
director:['Peter Bebjak'],
actors:['Jan Cina','Jenovéfa Boková','Martin Finger','Jan Nedbal','Adrian Jastraban','Alexander Bárta','Judit Pecháček','Elizaveta Maximová','Julius Oračko','Dana Černá','Vasil Fridrich','Lukáš Latinák','Jevgenij Libezňuk','Emília Vášáryová','Luboš Veselý','Jiří Štrébl','Zdeněk Pecha','Filip Kaňkovský','Ctirad Götz','Janusz Hummel','Patrik Plešinger','Aleš Kaizner','Pavel Batěk','Jiří Vyorálek','Hana Vagnerová','Ivan Lupták','Jiří Černý','Vojtěch Fülep','Milan Němec','Vojtěch Babišta','Petr Panzenberger','Jiří Šimek','Daniel Mavrov','Petr Franěk','Nikola Orozovič','David Želina','Rostislav Trtík','Róbert Nižník','Petr Stehlík','Radim Juhász','Ondřej Švec'],
screenplay:['Petr Bok','Pavel Gotthard'],
production:['Rasťo Šesták','Peter Bebjak'],
music:['Juraj Dobrakov'],
camera:['Martin Žiaran'],
cut:['Marek Kráľovský'],
sound:['Klára Javoříková'],
scenography:['Juraj Kuchárek'],
masks:['Michaela Kicková'],
costumes:['Ján Kocman']},
{title:'Robot Chicken',
titleCZ:'Robot Chicken',
year:2005,
runtime:'41h 43min',
episodeRuntime:'10-12min',
countries:['USA'],
genres:['Animation','Comedy'],
director:['Seth Green','Chris McKay','Zeb Wells','Kevin Shinick','Alex Kamer','Matthew Senreich','Tom Sheppard','Tom Root','Douglas Goldstein'],
actors:['Seth Green','Breckin Meyer','Abraham Benrubi','Sarah Michelle Gellar','Mila Kunis','Alex Borstein','Macaulay Culkin','Scarlett Johansson','Mark Hamill','Emma Caulfield Ford','Rachael Leigh Cook','Jordan Ladd','Christian Slater','Ashton Kutcher','Amy Smart','Hulk Hogan','Stuart Townsend','William Mapother','Erika Christensen','Phil LaMarr','Matthew Lillard','Dax Shepard','Kurtwood Smith','Bill Farmer','Peter Gallagher','Sarah Silverman','Michelle Trachtenberg','Ginnifer Goodwin','Kristin Chenoweth','Kelly Hu','Alfonso Freeman',"'Weird Al' Yankovic",'Corey Feldman','Donald Faison','Danny Masterson','Patrick Warburton','Nathan Fillion','James van der Beek','Holly Madison','Bridget Marquardt','Kendra Wilkinson','Hugh M. Hefner','Seth MacFarlane','Scott Adsit','Dave Coulier','Stan Lee','Michael Chiklis','Mindy Sterling','Jimmy Kimmel','Wayne Brady','Jessica Landon','Matthew Wood','Adrianne Palicki','Mario Lopez','Hayden Panettiere','Clare Grant','James Marsden','Scott Porter','Robin Bain','David Hasselhoff','Zachary Gordon','Gregory Itzin','Adam Reed',"Conan O'Brien",'Don Knotts','Joel McHale','Alfonso Ribeiro','Joss Whedon','Diablo Cody','Diora Baird','Josh Cooke','Josh Groban','Clark Duke','Simon Pegg','Freddie Prinze Jr.','Jon Hamm','Jena Malone','Emmanuelle Chriqui','J.K. Simmons','Affion Crockett','Shawn Patterson','Phyllis Diller','J.B. Smoove','Sarah Chalke','Rhea Perlman','Ronald D. Moore','Melanie Griffith','Herbert Russell','Dustin Diamond','Jennifer Field','Nev Schulman','Randall Park','Robert Kirkman','Michael Benyaer','Lauren Ambrose','Shane McRae','Max Charles','Vicki Davis','Spencer Grammer','Dennis Haskins'],
screenplay:['Seth Green','Rachel Bloom','Zeb Wells','Hugh Sterbakov','Hugh Davidson','Matthew Senreich','Breckin Meyer','Daniel Libman','Kevin Shinick','Ben Schwartz','Geoff Johns','Dan Milano','Harland Williams','Tom Sheppard','Mikey Day','Robert Kirkman','Mehar Sethi','Erik Weiner','Jessica Gao','David Phillips','Tom Root','Matthew Ireland Beans','Douglas Goldstein','Jared Gruszecki','Mike Fasolo','J.T. Krul','Eric Schaar','Nick Cron-DeVico','Kyle Stegina','Josh Lehrman','Jordan Allen-Dutton','Matthew Libman','Andrew Ti','Michael Poisson','Tesha Kondrat','Cody Ziglar','Brendan Hay','Jason Reich'],
production:['Alexander Bulkley','Corey Campodonico','Janet Dimon','Margaret M. Dean','Ollie Green'],
music:['Michael Suby','Shawn Patterson','Kevin Manthei','Adam Sanborne','Les Claypool','Randall Crissman','John Zuker'],
camera:['Eric Adkins','Helder Sun','Aaron Wise'],
cut:['Garret Elkins','Chris McKay'],
sound:['Hunter Curra','Timothy J. Borquez','Konrad Piñon','Tony Orozco','Eric Freeman'],
scenography:['Ross Shuman','Huy Vu'],
costumes:['Becky Van Cleve']},
{title:'Spaced',
titleCZ:'Spaced',
year:1999,
runtime:'5h 45min',
episodeRuntime:'24-26min',
countries:['UK'],
genres:['Comedy'],
director:['Edgar Wright'],
actors:['Jessica Hynes','Simon Pegg','Julia Deakin','Mark Heap','Nick Frost','Ricky Gervais','Lee Ingleby','Kevin Eldon','Peter Serafinowicz','David Walliams','Bill Bailey','Reece Shearsmith','Mark Gatiss','Claire Rushbrook','Michael Smiley','Alfie Allen','Clive Russell','Richenda Carey','Tony Way','Simon Kunz','Andy Lucas','Katy Carmichael','Tim Sampson','Andy Hollis','Charles Dale','Kevin Cecil','Lucy Akhurst','Robert Popper','Jeremy Peters','James Lance','Anna Wilson-Jones','Edgar Wright','Paul Kaye','John Simm','Rowena Cooper','Joanna Scanlan','Olivia Williams','Jason Attar','Paul Putner','Derren Litten','Jonathan Ryland','Martin Trenaman','Paul Mark Elliott','Sally Grace'],
screenplay:['Jessica Hynes','Simon Pegg'],
production:['Nira Park'],
music:['Guy Pratt'],
camera:['Martin Hawkins','Andy Hollis'],
cut:['Chris Dickens','Paul Machliss','Edgar Wright'],
sound:['Mark Found'],
scenography:['Marcus Rowland','Jo Sutherland'],
masks:['Christine Cant','Jane Walker'],
costumes:['Annie Hardinge']},
{title:'The Onion News Network',
titleCZ:'The Onion News Network',
year:2011,
runtime:null,
episodeRuntime:'29x22min',
countries:['USA'],
genres:['Comedy'],
director:['Jon Watts','Will Graham','J.J. Adler'],
actors:['Geneva Carr','Rutanya Alda','Damon Lindelof','Ben Livingston','Matthew Faber','Max Antisell','Matt Servitto','Jackie Moore','Ben Stiller','Rachel Maddow','Victoria Guthrie','Mike Doyle','Doug Trapp','Brian Huskey','Jessica Rothe','Anthony Del Negro','Rosie Moss','Jean Brassard','Susan Blackwell','Mike Houston','Gameela Wright','Moujan Zolfaghari','Aaron Lazar','Edmund Lyndeck','Wally Dunn','Patrick Murney','Ivan Martin','Danielle McKee','Leslie Hendrix','Bob Celli','Vincent Rodriguez III','Eva Kaminsky','Sebastian Hedges Thomas','Alberto Vazquez','Arthur French','Matt Oberg','Dena Tyler','John Cariani','Malachy Cleary',"Mike O'Gorman",'Veronika Dash',"Daniel O'Shea",'Tibor Feldman','Jos Laniado','Matt Davis','Jaida-Iman Benjamin','Logan Crawford','Michele Ammon','Mike Huckabee','Andre Ward','David W. Thompson','Tod Engle','Oberon K.A. Adjepong','David Lavine','Therese Plaehn','Dave T. Koenig','Jack Mulcahy','Morgan Evans','Guy Lockard'],
screenplay:['Jack Kukoda','Chris Kelly','Lang Fisher','Jeff Loveness','Dan Mirk','John Harris'],
music:['Chris Maxwell','Phil Hernandez','Elegant Too'],
cut:['Jamie Gross','Jesse Gordon','Laura Weinberg','Sascha Stanton Craven','Matt Davis','Jon Higgins'],
sound:['Lewis Goldstein'],
scenography:['Jessica Petruccelli','Angelique Clark'],
costumes:['Dana Covarrubias']},
{title:'Goblin',
titleCZ:'Sseulsseulhago charanhasindoggaebi',
year:2016,
runtime:'20h 11min',
episodeRuntime:'62-88min',
countries:['South Korea'],
genres:['Romance','Drama','Fantasy','Comedy'],
director:['Eung-bok Lee','Hyeok-chan Kwon'],
actors:['Yoo Gong','Go-eun Kim','Dong-wook Lee','In-na Yoo','Seong-jae Yook','El I','In-woo Jo','Seok-jeong Hwang','Jin-woo Park','Chang-hwan Kim','Moon-soo Lee','Byeong-cheol Kim','Yeong-gi Jeong','Woo-jin Jo','Won Ga','Ri Choi','Hye-ran Yeom','Se-wan Park','Kyu-hyung Lee','Han-seo Lee','Chae-kyeong Lee','Ji-hyeon Ahn','Hae-in Jeong','Hee-bon Park','Da-reum Nam','Joey Albright','Min-jae Kim','Seo-jin Han','So-hyeon Kim','Hyeon-bin Kim','Ji-hoon Jeong','Kyeong-ho Yoon','Soo-hyeon Song','Kyeong-hye Park','Ki-doo Kim','Woong Choi','Min Kang','Young Ki Jung','Hyun-mok Kim'],
screenplay:['Eun-sook Kim'],
production:['Yun Ha Rim'],
music:['Hye-Seung Nam']},
{title:'Epic Rap Battles of History',
titleCZ:'Epic Rap Battles of History',
year:2010,
runtime:null,
episodeRuntime:null,
countries:['USA'],
genres:['Music','Comedy'],
director:['Ryan Moulton'],
actors:['Snoop Dogg',"'Weird Al' Yankovic",'Rhett McLaughlin','Link Neal','Iman Crosson','Hannah Hart','Jin Au-Yeung','PewDiePie','Lauren Francesca','Ryan Moulton','Kimmy Gatewood','Verona Blue','Elena Diaz','Forrest Whaley','Sam Macaroni',"Michael O'Hearn",'Lauren Flans','Brittany White'],
screenplay:['Iman Crosson','Jin Au-Yeung','Kimmy Gatewood','Juliet Seniff','Lauren Flans'],
cut:['Ryan Moulton'],
masks:['Corinne Foster','Ruth Haney','Michelle Connolly','Brittany White']},
{title:'Home for Christmas',
titleCZ:'Vánoce u našich',
year:2019,
runtime:'5h 54min',
episodeRuntime:'25-35min',
countries:['Norway'],
genres:['Comedy','Drama','Romance'],
director:['Anna Gutto','Per-Olav Sørensen'],
actors:['Ida Elise Broch','Gabrielle Leithaug','Dennis Storhøi','Hege Schøyen','Felix Sandman','Sajid Malik Hussain','Oddgeir Thune','Kingsford Siayor','Arthur Hakalahti','Cathrine Haave','Irasj Asanti','Thomas Cassidy','Mads Sjøgård Pettersen','Ole Christoffer Ertvaag','Samantha Gurah','Helga Guren','Ragnhild H. Myntevik','Hkeem','Anette Hoff','Henrik Horge','Nader Khademi','Herbert Nordrum','Rebekka Nystabakk','Ghita Nørby','Audun Sandem','Jakob Schøyen Andersen','Bjørn Skagestad','Iselin Shumba Skjævesland','Line Verndal','Stian Blipp','Christian Ruud Kallum','Loekke Calle','Håvard Bakke','Maria Grazia Di Meo','Dagny Norvoll Sandvik','Edward Schultheiss','Assad Siddique','Dagfinn Tuttunen','Marit Andreassen','Sacha Slengesol Balgobin','Hermann Sabado','Monica Dybwad','Ulrikke Hansen Døvigen','Veslemøy Mørkrid','Kohinoor Nordberg','Marianne Stormoen','Sonja Wanda','Kjersti Elvik','Anette Amelia Larsen','Solveig Aksnes','Camilla Augusta Hallan','Henrik Fladseth','Ingrid Jørgensen','Vår Sørensen Grønlie','Terje Sporsem','Erik Solbakken','Ronny Johansen','Simen Dahl'],
screenplay:['Mattis Herman Nyquist','Julie Skaufel','Per-Olav Sørensen','Fredrik Høyer','Miriam Larsen'],
production:['Anders Tangen','Kaia Foss'],
music:['Gaute Tønder','Backflip Lydkollektiv'],
camera:['Hallgrim Haug','Håvar Karlsen'],
cut:['Rodrigo Stoicheff','Thomas Grotmol','Veslemøy Blokhus Langvik','Silje Nordseth','Elise Solberg','Martin Stoltz'],
scenography:['Kristine Wilhelmsen'],
costumes:['Nadja Halvari','Oddfrid Ropstad']},
{title:'The Inbetweeners',
titleCZ:'The Inbetweeners',
year:2008,
runtime:'7h 7min',
episodeRuntime:'21-26min',
countries:['UK'],
genres:['Comedy'],
director:['Ben Palmer','Gordon Anderson','Damon Beesley','Iain Morris'],
actors:['Simon Bird','James Buckley','Blake Harrison','Joe Thomas','Greg Davies','Emily Head','Belinda Stewart-Wilson','Alex MacQueen','Hannah Tointon','Kacey Clarke','Jayne Wisener','Emily Atack','Janine Wood','Vivi Pineda','Mark L. Young','Chris Jackson','Steven Webb','David Schaal','Nicholas Asbury','David Fynn','Rita Davies','Jonny Sweet','Kali Peacock','Jody Halse','Ben Bailey Smith','Anjli Mohindra',"Caroline O'Neill",'Colin Spaull','Charlie Covell','Ben Homewood','Victoria Willing','Cavan Clerkin','Isabella Laughland','Nigel Boyle','Tom Shaw','Daniel Lawrence Taylor','Andrew Brooke','Dominic Applewhite','Robin Weaver','John Seaward','Martin Trenaman','Waen Shepherd','Charlie Wernham','Oriane Messina','Vladimir Consigny','Suzi Battersby'],
screenplay:['Damon Beesley','Iain Morris','Brett Konner'],
music:['Dido'],
camera:['Ben Wheeler','Jamie Cairney','Rob Kitzmann'],
cut:['Billy Sneddon','Richard Candib','Charlie Fawcett'],
sound:['Bob Newton'],
scenography:['Lucienne Suren'],
costumes:['Caroline Pitcher']},
{title:'Miś Uszatek',
titleCZ:'Miś Uszatek',
year:1975,
runtime:null,
episodeRuntime:'104x7min',
countries:['Poland'],
genres:['Animation','Family'],
director:['Lucjan Dembinski'],
actors:['Mieczyslaw Czechowicz'],
screenplay:['Lucjan Dembinski']},
{title:'Kesslers Knigge',
titleCZ:'Kesslers Knigge',
year:2009,
runtime:'5h',
episodeRuntime:'30min',
countries:['Germany'],
genres:['Comedy'],
director:['Joseph Orr','Jan Markus Linhof'],
actors:['Michael Kessler','Christine Sommer','Rosalie Wolff','Oliver Unkel','Regine Schroeder'],
screenplay:['Morten Kühne','Stefan Stuckmann'],
production:['Christoph Stähler'],
camera:['Günter Handwerker','Eddie Schneidermeier'],
sound:['Georg Schildhauer','Ralf Hamann'],
scenography:['Silvia Masur','Ellen Latz'],
masks:['Marcus Michael'],
costumes:['Nora Sayuri Nüssner']},
{title:'The Corner',
titleCZ:'The Corner',
year:2000,
runtime:null,
episodeRuntime:'376min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Charles S. Dutton'],
actors:['T.K. Carter','Khandi Alexander','Sean Nelson','Antonio D. Charity','Tyra Ferrell','Clarke Peters','Glenn Plummer','Reg E. Cathey','Tasha Smith','Toy Connor','Lance Reddick','Delaney Williams','Cyrus Farmer','Michael Ahl','Corey Parker Robinson','Brian Anthony Wilson','Jay Landsman','Maria Broom','Frederick Strother','Cleo Reginald Pizana','Susan Duvall','David Simon','Ron Brice','James J. Christy','Vivian Bang','Neko Parham','Jerome Ro Brooks','Robert F. Colesberry','Robert Harley','Larry Derr','Matthew Boylan','Regi Davis','Clayton LeBouef','Robert F. Chew','Cloie Wyatt Taylor','Pete Burris','Karl Otter','Donnell Rawlings','Avery Kidd Waddell',"Brian O'Neill",'Yuval David','Don Wallace'],
basedOn:['David Simon','Ed Burns'],
screenplay:['David Simon','David Mills'],
camera:['Ivan Strasburg'],
cut:['Suzanne Pillsbury'],
sound:['Bruce Litecky'],
scenography:['Vincent Peranio','Susan Kessel'],
masks:['Jeannee Josefczyk'],
costumes:['Dana Campbell']},
{title:'Zbojník Jurošík',
titleCZ:'Zbojník Jurošík',
year:1991,
runtime:null,
episodeRuntime:'50x9min',
countries:['Czechoslovakia'],
genres:['Animation','Fairytale'],
director:['Jaroslav Baran'],
actors:['Stanislav Dančiak'],
music:['Vladimír Godár'],
camera:['Otto Geyer'],
sound:['Juraj Solan']},
{title:"Hell's Paradise",
titleCZ:'Džigokuraku',
year:2023,
runtime:null,
episodeRuntime:'10h24min',
countries:['Japan'],
genres:['Animation','Action','Adventure','History'],
director:['Kaori Makita','Jasuhiro Geši','Šigejuki Mija','Šú Watanabe','Taró Kubo','Džun Šišido','Júki Nišihata'],
actors:['Čiaki Kobajaši','Jumiri Hanamori','Rjóhei Kimura','Makoto Kóiči','Tecu Inada','Aoi Ičikawa','Daiki Jamašita','Čikahiro Kobajaši','Júsuke Kobajaši','Kenšó Ono','Rie Takahaši','Makoto Furukawa',"Šun'iči Toki",'Kensuke Óta','Mamiko Noto','Čafúrin','Mugihito',"Šun'iči Maki",'Takahiro Sumi','Jú Okano','Jú Wakabajaši','Takaaki Torašima','Júiči Mizuguči','Takajuki Nakacukasa','Hinata Tadokoro','Kazuja Sadži','Rjúnosuke Watanuki','Ricu Takahaši','Satoru Itó','Hidenari Ugaki','Masafumi Kimura','Kjóko Čikiri','Ai Kaneta','Čó','Júko Kaida',"Džun'iči Suwabe",'Konomi Kohara','Hajato Fudžii','Taiki Jamašita','Kendži Nomura','Minami Hinata','Mijú Ogura','Rjóta Suzuki'],
basedOn:['Júdži Kaku'],
screenplay:['Akira Kindaiči'],
music:['Jošiaki Dewa'],
camera:['Hyo-Gyu Park'],
cut:['Mucumi Takemija'],
sound:['Jasunori Ebina'],
scenography:['E. Caesar']},
{title:'The Mézga Family on Holiday',
titleCZ:'Podivuhodné prázdniny rodiny Smolíkovy',
year:1978,
runtime:'5h 26min',
episodeRuntime:'24-26min',
countries:['Hungary'],
genres:['Animation','Comedy','Family','Adventure'],
director:['József Nepp','Béla Ternovszky','Katalin Bánki','Magda Vásárhelyi','András Szemenyei','Edit Baksa','Sarolta Tóth','János Uzsák','Mária Zsilli','József Haui','László Újváry','Sándor Békési'],
actors:['Endre Harkányi','Ilona Győri','Margit Földessy','Péter Geszti','György Bárdy','János Gálvölgyi','Alfonzó','István Bujtor','Imre Surányi','Attila Tyll','Ferenc Deák B.','Gábor Maros','Kornél Gelley','Péter Szokol','Antal Farkas','Dorottya Géczy','Ági Kökényessy','József Képessy','László Inke','György Miklósy','Árpád Gyenge','Antal Konrád','Pál Horváth','Sándor Suka','Tamás Fodor','András Márton','István Szatmári','György Szoó','Balázs Szuhay','Iván Verebély','István Velenczey','János Körmendi','Zoltán Benkóczy','Károly Mécs','István Avar','Gyula Benkő','László Tahi Tóth','János Horkai','Ottó Szabó','Zoltán Dobránszky','Sándor Makay','György Bálint','Ádám Rajhona'],
screenplay:['József Romhányi'],
music:['Tamás Deák'],
camera:['Csaba Nagy','Mária Neményi','György Varga','Irén Henrik','Árpád Lossonczy','László Cselle','Zsolt Pethes','Sándor Polyák']},
{title:'Marco Polo',
titleCZ:'Marco Polo',
year:1982,
runtime:'9h 12min',
episodeRuntime:'59-78min',
countries:['Italy','USA','Japan','China'],
genres:['Adventure','Drama','Biography','History'],
director:['Giuliano Montaldo'],
actors:['Ken Marshall','Denholm Elliott','Anne Bancroft','John Gielgud','John Houseman','Burt Lancaster','Tony Lo Bianco','David Warner','Tad Horino','Ian McShane','Leonard Nimoy','Mario Adorf','Patrick Mower','F. Murray Abraham','John Dicks','James Hong','Soon-Tek Oh','Andrew Keir','Paul Müller','Gordon Mitchell','Renato Scarpa','Marilù Tolo','Sada Thompson','Riccardo Cucciolla','Rossella Como','Enzo Robutti','Vernon Dobtcheff','Corrado Gaipa','Henry O','Bruno Corazzari','Tecuró Tanba','Ruocheng Ying','Gino Santercole','Georgia Slowe','John Karlsen','Antonella Murgia','Jack Watson','Beulah Quo','Franco Fantasia','Angelo Pellegrino','Terry Raven','Renhua Na','Salvatore Puntillo','Bruno Zanin','Jim Lau','Rate Furlan','Jack Ong','Maria Pia Colonnello','Donato Castellaneta','William Squire','Jesse Dizon','Hesen En',"Džun'iči Išida",'Vladek Sheybal',"Renato D'Amore"],
screenplay:['Giuliano Montaldo','Vincenzo Labella'],
production:['Franco Cristaldi','Giovanni Bertolucci','John A. Martinelli','Vincenzo Labella'],
music:['Ennio Morricone'],
camera:['Pasqualino De Santis'],
cut:['Nino Baragli','John A. Martinelli'],
scenography:['Luciano Ricceri','Franco Velchi'],
masks:['Mario Michisanti'],
costumes:['Enrico Sabbatini']},
{title:'Píseň pro Rudolfa III.',
titleCZ:'Píseň pro Rudolfa III.',
year:1967,
runtime:null,
episodeRuntime:'1967-1969',
countries:['Czechoslovakia'],
genres:['Musical','Comedy'],
director:['Jaromír Vašta'],
actors:['Darek Vostřel','Ludmila Vostrčilová','Iva Janžurová','Jiří Hrzán','Vítězslav Černý','Marta Kubišová','Dáša Neblechová','Helena Blehárová','Karel Černoch','Václav Neckář','Helena Vondráčková','Waldemar Matuška','Stella Zázvorková','Zdeněk Najman','Karel Krautgartner','Karel Gott','Miroslav Homola','Eva Pilarová','Karel Štědrý','Marta Kučírková','Laďka Kozderková','Růžena Lysenková','Pavlína Filipovská','Dalimil Klapka','Karel Hála','Yvonne Přenosilová','Ivo Niederle','Josef Laufer','Naďa Urbánková','Jiří Štědroň','Pavel Sedláček','Jiří Šašek','Milan Drobný','Milan Chladil','Pavel Novák','Yvetta Simonová','Hugues Aufray','Lída Roubíková','Jaromír Mayer','Vlasta Bláhová','Udo Jürgens','Dušan Grúň','Pavel Ruta','Vladimír Huber','Jiří Popper','Eva Martinová','Judita Čeřovská','Jitka Zelenková'],
basedOn:['Ray Bradbury'],
screenplay:['Jaroslav Dietl'],
music:['Karel Krautgartner','Jindřich Brabec','Zdeněk Marat','Václav Hybš','Angelo Michajlov'],
camera:['Jiří Lebeda','Jan Eisner','Josef Motejl'],
scenography:['Miroslav Pelc']},
{title:'Jonathan Strange & Mr. Norrell',
titleCZ:'Jonathan Strange & Mr. Norrell',
year:2015,
runtime:null,
episodeRuntime:'7h60min',
countries:['USA'],
genres:['Fantasy','History'],
director:['Toby Haynes'],
actors:['Eddie Marsan','Bertie Carvel','Marc Warren','Charlotte Riley','Ariyon Bakare','Alice Englert','Peter Bowles','Enzo Cilenti','Jason Deline','Richard Durden','Paul Kaye','Samuel West',"Hugh O'Brien",'Vincent Franklin','Edward Hogg','Brian Pettifer','Ronan Vibert','Jamie Parker','Lucinda Dryzek','Clive Mantle','John Sessions','Neil Edmond','Vernon Dobtcheff','Julian Firth','Timothy Watson','Edward Petherbridge','Claudia Jessie','Phoebe Nicholls','Bobby Asghar','Katy Maw','Patricia Winker','Mark Hindman Smith','Dorian Lough','Rebecca Saire','Sarah Winter','Raphael Grosz-Harvey','Niall Greig Fulton','Grant Crookes','John Heffernan','Arthur Holden','John Dagleish','Tom Lawrence',"Ayana O'Shun","Robbie O'Neill",'Alan Bentley','Steven Peace','John Phythian'],
basedOn:['Susanna Clarke'],
screenplay:['Peter Harness'],
music:['Benoît Charest'],
camera:['Stephan Pehrsson','Lukas Strebel'],
cut:['Peter Christelis','Philip Kloss']},
{title:'Čmuchalové',
titleCZ:'Čmuchalové',
year:2023,
runtime:'8h 9min',
episodeRuntime:'55-74min',
countries:['South Korea'],
genres:['Action','Crime','Drama','Thriller','Sport'],
director:['Joo-hwan Kim'],
actors:['Do-hwan Woo','Sang-yi Lee','Sae-ron Kim','Seong-woong Park','Joon-ho Heo'],
screenplay:['Joo-hwan Kim']},
{title:"Ku'damm 59",
titleCZ:"Tančírna na hlavní třídě '59",
year:2018,
runtime:'4h 30min',
episodeRuntime:'90min',
countries:['Germany'],
genres:['Drama'],
director:['Sven Bohse'],
actors:['Claudia Michelsen','Sonja Gerhardt','Maria Ehrich','Emilia Schüle','Trystan Pütter','Sabin Tambrea','August Wittgenstein','Laura de Boer','Andreas Pietschmann','Markus Boysen','Ulrich Noethen','Heino Ferch','Max Hopp','Uwe Preuss','Bärbel Schwarz','Jörg Bundschuh','Andreas Schröders','Gode Benedix','Rudolf Krause','Lutz Lansemann','Yann Grouhel','Martin Winkelmann','Roman Schomburg','Alma Löhr','Smilla Löhr','Peter Weiss','Julius Robin Weigel','Claudia Lietz','Ricardo Beck'],
screenplay:['Annette Hess'],
production:['Benjamin Benedict','Nico Hofmann'],
music:['Christian Biegai','Maurus Ronner','Joo Fürst','Anna Kühlein'],
camera:['Michael Schreitel'],
cut:['Ronny Mattas'],
sound:['Stefano Di Fiore','Ralf Herrmann','Silvia Dilchert'],
scenography:['Axel Nocker','Nancy Vogel'],
masks:['Gregor Eckstein','Jeanette-Nicole Latzelsberger'],
costumes:['Maria Schicker']},
{title:'Gogs',
titleCZ:'Gogs',
year:1993,
runtime:'1h 5min',
episodeRuntime:'5min',
countries:['UK'],
genres:['Animation','Comedy'],
director:['Deiniol Morris'],
actors:['Gillian Elisa','Rob Rackstraw'],
music:['Arwyn Davies']},
{title:'Please Like Me',
titleCZ:'Please Like Me',
year:2013,
runtime:'13h 35min',
episodeRuntime:'25-28min',
countries:['Australia'],
genres:['Comedy','Drama'],
director:['Matthew Saville','Josh Thomas'],
actors:['Josh Thomas','Thomas Ward','Caitlin Stasey','David Roberts','Charlotte Nicdao','Wade Briggs','Charles Cottier','Ben Anderson','Hannah Gadsby','Tony Nikolakopoulos','Debra Lawrance','Luke McGregor','Geoff Morrell','Emily Barclay','Mark Coles Smith','Deborah Mailman','Joe Klocek','Brenda Palmer','Jenny Zhou','Denise Scott','Roz Hammond','Bob Franklin','Clarke Richards','Liz Doran','Tamiah Bantum','Judi Farr','Lynne Murphy'],
screenplay:['Josh Thomas','Hannah Gadsby','Thomas Ward','Liz Doran'],
music:['Bryony Marks'],
camera:['Katie Milwright','Matthew Temple'],
cut:['Julie-Anne De Ruvo','Chris Branagan','Geoff Hitchins'],
scenography:['Jo Briscoe','Penny Southgate'],
costumes:['Edie Kurzer','Michael Davies','Shauna Lovisetto']},
{title:'Ashes to Ashes',
titleCZ:'Ashes to Ashes',
year:2008,
runtime:'23h 36min',
episodeRuntime:'59min',
countries:['UK'],
genres:['Crime','Drama','Fantasy','Thriller'],
director:['Catherine Morshead','Jonny Campbell','David Drury','Bille Eltringham','Ben Bolt','Philip John','Jamie Payne','Alrick Riley'],
actors:['Philip Glenister','Keeley Hawes','Dean Andrews','Marshall Lancaster','Montserrat Lombard','Joseph Long','Geff Francis','Grace Vance','Amelia Bullmore','Daniel Mays','Adrian Dunbar','Stephen Campbell Moore','Andrew Clover','Sean Harris','David Bradley','Jeremy Clyde','Mathew Baynton','Claire Rushbrook','Lydia Leonard','Paul Anderson','Zoe Telford','Sam Spruell','Lucian Msamati','Camille Coduri','Daisy Haggard','Stephen Wight','Dragan Mićanović','Simon Merrells','Asa Butterfield','Russell Tovey','Perdita Avery','Tom Georgeson','Joseph Millson','John R. Walker','Stanley Townsend','Matthew Macfadyen','Adrian Schiller','Henry Garrett','Gwilym Lee','Forbes KB','Lee Ross','Syrus Lowe','Ryan Pope','Luke Neal','Tanya Franks','Nik Howden','David Schaal','Adam James','Rupert Graves','Christopher Fairbank','Amelda Brown','Leo Bill','Paul Thornley','Lucy Briers','Chris Mansfield','Dan Fredenburgh','Phil Davis','Anna Wilson-Jones','Troy Glasgow','Shaw Taylor','Geoffrey Palmer','Roger Allam','Shaun Evans','Pooky Quesnel','Diane Langton','Deirdre Mullins','Gwyneth Powell','Paola Dionisotti','Rory Kinnear','John Bowe','Sara Stewart','Rita Davies','Ben Bishop','Dorian Lough','Peter Cadwell','Eva Birthistle','David Kennedy','Simon Sherlock','Beth Goddard','Joe Absolom','Katie Lyons','Peter Guinness','Bryan Dick','Nicholas Gleaves','Robert Wilfort','Steven Robertson','Simon Kunz','Thomas Lockyer','Sophie Duval','Aidan Kelly','Geoffrey Streatfeild','Chris Wilson','Estella Daniels','Gerard Monaco','Janet Whiteside','Bill Moody','Michael Gould','Charlie Wernham','Greg Donaldson','Ellie Paskell'],
screenplay:['Julie Rutterford','James Payne','Jack Lothian','Tom Butterworth','Chris Hurford','Nicole Taylor','Mick Ford','Mark Greig','Matthew Graham','Ashley Pharoah'],
production:['Howard Burch'],
music:['Edmund Butt'],
camera:['Simon Archer','Julian Court','Nic Lawson','Fabian Wagner','Balazs Bolygo','Adam Suschitzky','Tim Palmer'],
cut:['Jonathan Amos','Jamie Pearson','Barney Pilling','Guy Bensley','Sam Williams'],
scenography:['Matt Gant','Stevie Herbert','Donald J. Remacle'],
masks:['Siân Miller'],
costumes:['Rosie Hackett','Nat Turner']},
{title:'Jonathan Creek',
titleCZ:'Jonathan Creek',
year:1997,
runtime:'34h 50min',
episodeRuntime:'49-120min',
countries:['UK'],
genres:['Drama','Crime','Mystery'],
director:['Christine Gernon','David Renwick','Sandy Johnson','David Sant','Marcus Mortimer','Keith Washington'],
actors:['Alan Davies','Caroline Quentin','Steven Berkoff','Anthony Head','Adrian Edmondson','Tamsin Greig','Kate Isitt','Gina Bellman','Maxine Peake','Nigel Planer','Elliot Cowan','Lee Ingleby','Matt Rippy','Heather-Jay Jones','Marcus Gilbert','Sanjeev Bhaskar','Michael Sarne','Simon Day','Ralph Brown','Sophie Thompson','Alistair Petrie','Caroline Carver','Suzanna Hamilton','Toby Walton','Saskia Mulder','Murray Melvin','Louise Barrett','Katherine Parkinson','Julia Sawalha','Clarke Peters','Naomi Bentley','Hattie Hayridge','Lorraine Hilton','Ian McNeice','Tom Goodman-Hill','Nina Sosanya','Charlotte Comer','Sheridan Smith','Dermot Crowley','Benjamin Whitrow','Amanda Hadingue','Peter Davison','Florence Hall','Nicholas Boulton','Mary Tamm','Nicola Walker','Stephen Billington','Alice Patten','Pippa Haywood','Annabel Mullion','Jack Dee','Selina Cadell','Rebecca Front','Rebecca Johnson','Frances Low','Lloyd McGuire','Mem Ferda','James Saxon','Vincent Wong','Bill Bailey','Raquel Cassidy','Jill Baker','Gary Cady','Colin McFarlane','Brett Fancy','Steve Speirs','Sandy Johnson','Rachel Power','Nicholas Amer','Georgie Glen','Doreen Mantle','Simon Roberts','Stanley Townsend','Marc Small','Terrence Hardiman','Sean Cronin',"Gavan O'Herlihy",'Del Henney','Christopher Adamson','Marianne Borgo','Cliff Barry','Sean Buckley','Raymond Griffiths','Bernard Kay','Lasco Atkins','Andrew Havill','Sasha Behar','Tim Chipping','Michael Cochrane','Hasina Haque','Angela Curran','Ron Berglas','Harry Peacock','Calum MacPherson','Jon Campling','Jay Benedict','Francis Matthews','Nick Nevern','Mark Aiken','Hannah Gordon'],
screenplay:['David Renwick'],
production:['Verity Lambert','Rosemary McGowan','Susan Belbin'],
music:['Rick Wentworth','Julian Stewart Lindsay','Theo Vidgen'],
camera:['Toby Moore','Simon Maggs','Geoff Harrison'],
cut:['Joe Walker','Paul Garrick','Mark Lawrence','Jake Bernard'],
sound:['Phil Croal','Terry Elms','Steve Phillips'],
scenography:['John Asbridge','Brian Sykes','Steve Wright','Paul Munting'],
masks:['Joe Hopker','Ashley Johnson','Fran Needham'],
costumes:['Rhona Russell','Annie Hardinge','Eleanor Baker','Lucia Santa Maria']},
{title:'O loupežníku Rumcajsovi',
titleCZ:'O loupežníku Rumcajsovi',
year:1967,
runtime:'4h 33min',
episodeRuntime:'7min',
countries:['Czechoslovakia'],
genres:['Animation','Fairytale'],
director:['Ladislav Čapek'],
actors:['Karel Höger','Eduard Cupák'],
basedOn:['Václav Čtvrtek'],
screenplay:['Václav Čtvrtek','Anna Jurásková','Milan Nápravník','Irena Povejšilová'],
music:['Václav Lídl'],
camera:['Zdenka Hajdová','Eva Kargerová'],
cut:['Zdenka Navrátilová'],
sound:['Benjamin Astrug'],
scenography:['Radek Pilař']},
{title:"Frankenstein's Aunt",
titleCZ:'Teta',
year:1987,
runtime:'6h 2min',
episodeRuntime:'51-52min',
countries:['Austria','Germany','France','Czechoslovakia','Spain','Italy'],
genres:['Family','Comedy','Fantasy'],
director:['Juraj Jakubisko'],
actors:['Marie Drahokoupilová','Roman Skamene','Bolek Polívka','Milan Lasica','Andrej Hryc','Martin Hrebeň','Flavio Bucci','Sancho Gracia','Barbara De Rossi','Viveca Lindfors','Ferdy Mayne','Jacques Herlin','František Dibarbora','Gerhard Karzel','Mercedes Sampietro','Eddie Constantine','Tilo Prückner','Gail Gatterburg','Miloslav Holub','Július Satinský','Oľga Šalagová','Karol Machata','Milan Neděla','Valerie Kaplanová','Ľudovít Reiter','Jana Březinová','Ján Melkovič','Elena Petrovická','Karol Machata'],
basedOn:['Alan Rune Pettersson'],
screenplay:['Jaroslav Dietl','Joachim Hammann','Juraj Jakubisko'],
production:['Kurt J. Mrkwicka'],
music:['Maurizio De Angelis','Guido De Angelis'],
camera:['Ján Ďuriš'],
cut:['Patrik Pašš'],
sound:['Pavol Sásik'],
scenography:['Peter Manhardt','Miloš Kalina'],
masks:['Günter Kulier','Ingrid Skorpik'],
costumes:['Claudia Stich']},
{title:'The Guild',
titleCZ:'The Guild',
year:2007,
runtime:'8h 9min',
episodeRuntime:'3-12min',
countries:['USA'],
genres:['Comedy'],
director:['Sean Becker','Christopher Preksta'],
actors:['Felicia Day','Sandeep Parikh','Jeff Lewis','Robin Thorsen','Amy Okuda','Vincent Caso','Michele Boyd','Wil Wheaton','Carly Jones','Simon Helberg','Nathan Fillion','Jillian Armenante','Lamorne Morris','Kevin Sorbo','Brent Spiner','Richard Hatch','Maurissa Tancharoen','Milynn Sarley','Holly Conrad','Julie Wittner','Sean Becker','Tom Lenk',"Brooke 'Dodger' Leigh Lawson",'Brea Grant','Tymberlee Hill','Shanrah Wakefield','Justine Ezarik','Meredith Adelaide','Mark Gantt','Leah Mann','M. Elizabeth Hughes','Rod Keller','Hayley Holmes','Greg Collins','Sujata Day','Jimmy Wong','J. Teddy Garces','Luci Romberg','Corey Craig','Diane Baldwin','Fernando Chien','Aaron Jackson','Derek Basco','Andrew Law','Tara Whitaker','J.P. Pierce','Frank Ashmore'],
screenplay:['Felicia Day','Jeff Lewis'],
production:['Jeff Wald','Felicia Day'],
camera:['John Schmidt','Jared Hoy'],
cut:['Scott Turner','Matthew Philip Smith','Nick Towle'],
scenography:['Tyler B. Robinson','Leah Mann','Greg Aronowitz'],
masks:['Kimberly Graczyk'],
costumes:['Sarah Trost']},
{title:"The Bugs n' Daffy Show",
titleCZ:"Bugs n' Daffy Show,The",
year:1996,
runtime:null,
episodeRuntime:'130x28min',
countries:['USA'],
genres:['Animation','Family','Comedy'],
director:['Chuck Jones','Abe Levitow','Maurice Noble','Frank Tashlin','Friz Freleng','David Detiege','Robert Clampett','Robert McKimson','Hawley Pratt','Tex Avery'],
actors:['Mel Blanc','June Foray','Joe Alaskey','GeGe Pearson'],
cut:['Rick Gehr']},
{title:'The Get Down',
titleCZ:'The Get Down',
year:2016,
runtime:'11h 13min',
episodeRuntime:'50-93min',
countries:['USA'],
genres:['Music','Drama'],
director:['Baz Luhrmann','Ed Bianchi','Andrew Bernstein','Michael Dinner','Lawrence Trilling','Clark Johnson','Mack Williams'],
actors:['Yahya Abdul-Mateen II','Mamoudou Athie','Giancarlo Esposito','Tremaine Brown Jr.','Herizen F. Guardiola','Justice Smith','Jimmy Smits','Yolonda Ross','Alexis Krause','Jaden Smith','Shameik Moore','Aly Mang','Sparrowhawk','Eric Bogosian','Daveed Diggs','Karen Aldridge','Kevin Corrigan','Michel Gill','Zabryna Guevara','Judy Marte','Evan Parke','Sal Rendino','Frank Wood','Justin Clarke','Jaden Michael','Conrad Roberts','Lee Tergesen','Jay Klaitz','Annika Boras','Julia Garner','Ron Cephas Jones','Spencer Daniels','Xiren Wang','Renée Elise Goldsberry','Brandon J. Dirden','Jason Genao','Keenan Jolliff','Okieriete Onaodowan','Imani Lewis','Shyrley Rodriguez','Billy Porter','Skylan Brooks','Dalon J. Holland','Rony Clanton','Bryce Pinkham','Jimmy Palumbo','Frank De Julio','Noah Le Gros','Stefanée Martin','Donovan Christie Jr.','Sebastian Chacon','Julia Morrison','Gerald Jones III','Roe Hartrampf','Yasha Jackson','Noah Catala','Allesondra Helwig','Elizabeth Stanley','Emilio Delgado','JaQwan J. Kelly','Katrina Lenk','Zuri Reed','Nikolaj Cankov','Naomi Walley'],
screenplay:['Aaron Rahsaan Thomas','Nelson George','Baz Luhrmann','Jacqui Rivera','Sinead Daly','Allison Glock-Cooper','Sam Bromell','Stephen Adly Guirgis'],
production:['Katrin L. Goodson','Aaron Seliquini','Elicia Bessette'],
music:['Elliott Wheeler'],
camera:['William Rexer'],
cut:['Allyson C. Johnson','Deborah Moran','Vanessa Procopio','Jonathan Redmond'],
sound:['Sean Garnhart','Eric Hirsch','Dane Lonsdale'],
scenography:['Karen Murphy','Alexandra Schaller','Christina Tonkin Noble','Patrick Howe','Susan Ogu'],
masks:['Stephanie Barr','Jerry DeCarlo','Lena Jemmott','Pat Moore-Theis','Tomasina Smith'],
costumes:['Catherine Martin','Jeriana San Juan']},
{title:'Ranma ½',
titleCZ:'Ranma 1/2',
year:1989,
runtime:'64h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Adventure','Comedy','Fantasy'],
director:['Džundži Nišimura','Cutomu Šibajama','Kódži Sawai','Tomomi Močizuki','Takeši Mori','Šigejasu Jamauči','Kazuhiro Furuhaši'],
actors:['Rjúnosuke Óbajaši','Kikuko Inoue','Kóiči Jamadera','Takeši Aono','Rei Sakuma','Ičiró Nagai','Tacujuki Džinnai','Kappei Jamaguči','Macuo Macuo','Noriko Hidaka','Júdži Micuja','Bin Šimada',"Ken'iči Ogata",'Jošiko Óta','Saeko Šimazu','Kazue Ikura','Takehito Kojasu','Šigeru Čiba','Rika Macumoto','Hirotaka Suzuoki','Minami Takajama','Megumi Hajašibara','Fumihiko Tačiki','Akemi Okamura','Naoko Macui','Eiko Jamada','Tošihiko Seki','Jumi Takada','Isamu Tanonaka','Masako Kacuki','Džun Hazumi','Kinto Tamura','Mijoko Asó','Kacudži Mori','Kazuko Sugijama','Minori Macušima','Júko Kobajaši','Šigeru Šibuja','Rokuró Naja',"Mari Joko'o",'Hiromi Curu','Hóčú Ócuka','Hidejuki Tanaka','Masami Kikuči','Jó Jošimura','Júko Mita','Masako Ikeda','Hiroši Masuoka','Masako Sugaja','Kóiči Kitamura','Mako Hjódó','Rjúdži Saikači','Issei Futamata','Šó Hajami','Jošiko Kamei','Kazuhiko Inoue','Tošihiko Nakadžima','Rjúzó Išino','Midori Nakazawa','Kódži Cudžitani','Sukekijo Kamejama','Ajumi Kida','Terue Nunami','Nadajuki Kašima','Akira Negiši','Hisajoši Izaki','Nacumi Sakuma','Satoko Jasunaga','Zenčú Micui','Kačiko Hino','Haru Endó','Šinnosuke Furumoto','Micuki Jajoi','Tadaši Nakamura','Arihiro Hase','Kacujo Imahaši','Brad Swaile'],
basedOn:['Rumiko Takahaši'],
screenplay:['Hiroši Hašimoto','Jošijuki Suga','Jošio Urasawa','Tošiki Inoue','Hirojuki Kawasaki','Kacujuki Sumisawa','Hideo Takajašiki','Aja Macui','Taku Nomoto','Hiroši Toda','Šigeru Janagawa','Hiroko Naka'],
production:['Jošinobu Nakao','Jóko Macušita'],
music:['Kendži Kawai','Hideharu Mori','Akihisa Macuura'],
camera:['Micunobu Jošida'],
cut:['Masaki Sakamoto','Seidži Morita','Rie Katajama'],
sound:['Šigeharu Šiba'],
scenography:['Satoši Miura']},
{title:'Weak Hero',
titleCZ:'Yakhanyeongung',
year:2022,
runtime:'5h 23min',
episodeRuntime:'37-44min',
countries:['South Korea'],
genres:['Action','Drama'],
director:['Su-min You'],
actors:['Ji-Hoon Park','Hyun-wook Choi','Kyung Hong','Su Gyeom Kim','Seung-ho Shin','Han-cheol Jo'],
screenplay:['Su-min You']},
{title:'Bez vědomí',
titleCZ:'Bez vědomí',
year:2019,
runtime:'6h 5min',
episodeRuntime:'56-66min',
countries:['Czechia'],
genres:['Drama','Thriller'],
director:['Ivan Zachariáš'],
actors:['Táňa Pauhofová','Martin Myšička','Jan Vlasák','Martin Hofmann','Lenka Vlasáková','Petr Lněnička','Hattie Morahan','David Nykl','Kristýna Ryška','Attila Mokos','Martin Huba',"Ivan G'Vera",'Tomáš Jeřábek','Lucie Juřičková','Jiří Štrébl','Brigita Cmuntová','Petr Vízdal','Martin Kubačák','Jim High','Ľubomír Paulovič','Leoš Noha','Jiří Šimek','Aňa Geislerová','Daniela Hirsh','Michal Isteník','Kristina Sitková','Zuzana Stivínová','Jan Novotný','Petra Špindlerová','Johana Racková','Luděk Staněk','Terezie Vraspírová','Jevgenij Libezňuk','Anita Krausová','Zdeněk Černín','Jakub Žáček','Jakub Slach','David Punčochář','Václav Kopta','Leoš Juráček','Eva Prchalová','Anton Tataru','Martin Sitta','Oleg Sokolov','James Beaumont','Štěpán Benoni','Filip Menzel','Dan Dittrich','Robert Russell','Luboš Veselý','Martin Pechlát','Barbora Milotová','David Depta','Marek Dobeš','Karolína Pösinger'],
screenplay:['Ondřej Gabriel'],
production:['Tereza Polachová','Steve Matthews','Jan Bílek'],
music:['Petr Malásek'],
camera:['Jan Velický'],
cut:['Filip Malásek'],
sound:['Jakub Čech','Pavel Rejholec','Kath Pollard'],
scenography:['Jan Vlasák'],
masks:['Milan Vlček'],
costumes:['Simona Rybáková']},
{title:'Lekár umierajúceho času',
titleCZ:'Lekár umierajúceho času',
year:1983,
runtime:'6h 9min',
episodeRuntime:'68-80min',
countries:['Czechoslovakia'],
genres:['Drama','Biography','History'],
director:['Miloslav Luther'],
actors:['Petr Čepek','Milan Kňažko','Emma Černá','Miloš Nedbal','Rudolf Hrušínský','Martin Huba','Josef Karlík','Ladislav Mrkvička','Ilja Racek','Raoul Schránil','Jan Přeučil','Lubomír Kostelka','Jan Kanyza','Ondřej Havelka','Zdeněk Srstka','Miriam Kantorková','Naďa Hejná','Peter Bzdúch','Alfréd Swan','Gustáv Herényi','Bronislav Poloczek','Jiří Wohanka','Dana Hlaváčová','Jan Kotva','Ota Sklenčka','František Řehák','Miloš Pietor','Leoš Suchařípa','Mikuláš Huba','Vladimír Černý','Jan Kačer','Karel Augusta','Bohuslav Čáp','František Husák','Václav Vydra nejml.','Václav Knop','Jiří Bartoška','Ladislav Křiváček','Stanislava Bartošová','Yvetta Kornová','Boris Rösner','Jan Kraus','Jiří Kostka','Vladimír Hrubý','Václav Kotva','Jan Teplý st.','Rostislav Kuba','Jan Kuželka','Stanislav Hájek','Jiří Krytinář','Rudolf Hrušínský ml.','Alena Karešová','Vlastimil Venclík','Miloš Vavruška','Elo Romančík','Jozef Kroner','Vít Olmer','Bohuslav Ličman','Milan Riehs','Peter Debnár','Anna Javorková','Milan Lasica','Stanislav Dančiak','Ivan Rajniak','Rudolf Kraus','Teodor Piovarči','Eva Matejková','Viliam Polónyi','Leopold Haverl','Dušan Tarageľ','Ivan Krivosudský','Slávo Záhradník','Ján Mistrík','Milan Kiš','Július Vašek','Kamila Magálová','Jana Nagyová Pulm','Dušan Kaprálik','Andrej Hryc','Peter Rúfus','Marián Zednikovič','Táňa Fischerová','Marta Richterová','Rudolfína Schránilová','Anna Maľová','Pavol Mikulík','Karel Brožek','Milan Klacek','Václav Kaňkovský','Rudolf Pellar','Zita Furková','František Kovár','Věra Tichánková','Zuzana Kronerová','Bára Štěpánová','Jožka Stoklasa','Jiří Bednář','Jiří Prýmek','Karel Fořt','Viktor Blaho'],
basedOn:['Vladimír Körner'],
screenplay:['Vladimír Körner'],
music:['Svetozár Štúr'],
camera:['Ivan Šlapeta'],
cut:['Jiří Brožek'],
sound:['Jiří Kříž'],
scenography:['Jiří Hlupý'],
masks:['Jiří Šimon'],
costumes:['Jan Kropáček']},
{title:'Angel Beats!',
titleCZ:'Angel Beats!',
year:2010,
runtime:'5h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy','Comedy','Romance'],
director:['Seidži Kiši','Kódai Kakimoto','Hirojuki Hašimoto','Takefumi Anzai','Jong Heo','Masanori Takahaši','Nobutoši Ogura'],
actors:['Hiroši Kamija','Harumi Sakurai','Kana Hanazawa','Rjóhei Kimura','Mijuki Sawaširo','Tomokazu Seki','Hikaru Midorikawa','Akira Išida','Eri Kitamura','Emiri Kató','Jumiko Kobajaši','Masahito Jabe','Saki Fudžita','Džódži Nakata','Hidekacu Šibata','Takahiro Mizušima','Mai Nakahara','Kana Asumi','Jošinori Fudžita','Hiroki Tóči','Jui Makino','Kendži Akabane','Megumi Ogata','Satoši Curuoka','Ajano Jamamoto','Nobunaga Šimazaki','Acuši Imaruoka',"Ken'ičiró Macuda",'Micuhiro Ičiki','Tošija Čiba','Ajumi Cunemacu','Kóta Óšita','Daiči Endó','Eiičiró Tokumoto','Acuši Ono','Júki Masuda','Šun Takagi','Tošihiro Nakamura','Fúko Saitó','Daisuke Macuo','Naohiro Ogura','Čie Macuura','Michael Rivas'],
screenplay:['Džun Maeda'],
production:['Hiró Marujama','Kendži Horikawa','Jósuke Toba'],
music:['Ai Kamači','Džun Maeda'],
camera:['Kacufumi Sató'],
cut:['Ajumu Takahaši'],
sound:['Satoki Iida'],
scenography:['Kazuki Higašidži']},
{title:'Příběhy cvrčka a štěňátka',
titleCZ:'Příběhy cvrčka a štěňátka',
year:1978,
runtime:null,
episodeRuntime:'978',
countries:['Czechoslovakia'],
genres:['Animation','Family'],
director:['Zdeněk Miler'],
actors:['Jiří Prager','Jiřina Šejbalová','Antonín Jedlička','Viola Zinková','Josef Kemr','Alena Kreuzmannová'],
screenplay:['Zdeněk Miler','Jiří Stránský','Iva Hercíková','J. A. Novotný'],
music:['Vadim Petrov','Wiliam Bukový']},
{title:'Night and the Doctor',
titleCZ:'Night and the Doctor',
year:2011,
runtime:null,
episodeRuntime:null,
countries:['UK'],
genres:['Short','Sci-Fi'],
director:['Richard Senior'],
actors:['Matt Smith','Karen Gillan','Alex Kingston','James Corden','Arthur Darvill','Daisy Haggard'],
screenplay:['Steven Moffat']},
{title:'Only Fools and Horses....',
titleCZ:'Only Fools and Horses....',
year:1981,
runtime:null,
episodeRuntime:'47h30-88min',
countries:['UK'],
genres:['Comedy'],
director:['Tony Dow','Martin Shardlow','Mandie Fletcher','Susan Belbin','Bernard Thompson','Ray Butt'],
actors:['David Jason','Nicholas Lyndhurst','Jim Broadbent','Roger Lloyd Pack','Jamie Smith','Sue Holderness','Douglas Hodge','Wanda Ventham','Carol Cleveland','Gina Bellman','Andrée Bernard','Robert Glenister','Antoni Corone','Walter Sparrow','Robin Driscoll','Dan Clark','Howard Goorney','Gail Harrison','Steve Alder','Rosalind Knight','Christopher Ryan','Paul Barber','Richenda Carey','Lee Richards','Treva Etienne','Phil Cornwell','Jill Baker','Mark Colleano','Anthony Morton','Richard Branson','Takashi Kawahara','Colin Jeavons','Peter Blythe','Nayef Rashed','Eva Mottley','Ian Barritt','Nicholas Courtney','Michael Jayston','Angus Mackay','Angela Morant','Gordon Salkilld','Michael Attwell','Nick Stringer','Patrick Murray','Angela Bruce','Beryl Cooke','Tessa Peake-Jones','Robert Vahey','Roy Heather','John Challis','Gerry Cowper','Rosalind Lloyd','Ann Lynn','Derek Martin','Gwyneth Strong','Sheree Murphy','Richard Braine','Diane Langton','Graham Cole','Derek Newark','Denis Lill','Desmond Mcnamara','Garard Green','Donald Bisset','Rex Robinson','Rachel Bell','Roy Evans','David Daker','Seymour Matthews','Del Baker','Constance Chapman','Roger Brierley','Nora Connolly','Jeanne Mockford','Jim McManus','James Ellis','William Thomas','Johnny Allan','John Bardon','Lennard Pearce','Lennard Pearce','Peter Tuddenham','Gilly Flower','Elizabeth Benson','Renee Roberts','Annie Leake','Toni Palmer','Derek Benfield','Philip Bond','John Bryans','Frank Coda','Katharine Page','John Pierce Jones','Daniel Hill','Mike Kemp','Peter Woodthorpe','Peter Woodthorpe','Ray Mort','Jackie Davis','Jean Challis'],
screenplay:['John Sullivan'],
production:['Bernard Thompson','Ray Butt'],
music:['Robert Hartshorne','Graham Jarvis','Ronnie Hazlehurst'],
camera:['John Rhodes'],
cut:['Chris Wadsworth','John Wilkinson'],
scenography:['Bernard Lloyd-Jones','David Hitchcock','Tony Snoaden','Donal Woods','Antony Thorpe'],
costumes:['Dinah Collin','Anushia Nieradzik','Linda Haysman','Jacky Levy']},
{title:'Doraleous and Associates',
titleCZ:'Doraleous and Associates',
year:2012,
runtime:null,
episodeRuntime:null,
countries:['USA'],
genres:['Animation'],
director:['Brent Triplett'],
actors:['Brent Triplett'],
screenplay:['Brent Triplett'],
music:['Alex Beard']},
{title:'Kukačky',
titleCZ:'Kukačky',
year:2021,
runtime:'22h 47min',
episodeRuntime:'52-59min',
countries:['Czechia'],
genres:['Drama','Comedy'],
director:['Biser A. Arichtev'],
actors:['Marta Dancingerová','Marek Adamczyk','Viktor Sekanina','Sabina Remundová','David Novotný','Theo Schaefer','Petr Kostka','Libuše Švormová','Luboš Veselý','Jiří Štrébl','Jan Dolanský','Veronika Freimanová','Jitka Čvančarová','Michal Isteník','Denisa Barešová','Darija Pavlovičová','Štěpán Benoni','Vanesa Vítková','Filip Čapka','Adam Ernest','Klára Cibulková','Adéla Petřeková','Ondřej Kraus','Vilém Udatný','Andrea Daňková','Annette Nesvadbová','Natálie Řehořová','David Máj','Lenka Vahalová','Barbora Bartošová','Helena Dvořáková','Antonio Šoposki','Nataša Bednářová','Zdeněk Julina','Petra Nakládalová','Akram Staněk','Daniel Svoboda','Tony Mašek','Richard Novák','Adam Slavík','Marek Frňka','Diana Dulínková','Eva Hacurová','Lucie Žáčková','Petr Štěpán','Aleš Balda','Jana Kolesárová','Jan Šraitr','Petr Lněnička','Jakub Švec','Pavel Myslík','Lubor Novotný','Šárka Krausová','Kateřina Marie Fialová','Radim Madeja','Daniela Choděrová'],
screenplay:['Jan Coufal'],
production:['Filip Bobiňski','Petr Šizling','Jan Lekeš'],
music:['David Solař'],
camera:['Marek Janda','Jan Hubač'],
cut:['H.M.C.','Martin Šašek'],
sound:['Petr Provazník','Daniel Němec'],
scenography:['Adam Pitra','Jana Nosková'],
masks:['Eva Ungrová-Malíková'],
costumes:['Vladimíra Fomínová','Stanislava Šlosserová']},
{title:'The Teach',
titleCZ:'Učitel',
year:2016,
runtime:'22h 27min',
episodeRuntime:'43-55min',
countries:['Poland'],
genres:['Crime'],
director:['Łukasz Palkowski','Krzysztof Łukaszewicz','Maciej Bochniak','Łukasz Grzegorzek'],
actors:['Maciej Stuhr','Magdalena Cielecka','Grzegorz Damięcki','Paweł Królikowski','Józef Pawłowski','Sebastian Fabijański','Aleksandra Grabowska','Piotr Głowacki','Mateusz Więcławek','Paulina Szostak','Krzysztof Pieczyński','Łukasz Simlat','Katarzyna Dąbrowska','Michalina Łabacz','Szymon Piotr Warszawski','Eliza Rycembel','Dariusz Starczewski','Zofia Wichłacz','Damian Kret','Aleksandra Konieczna','Miroslaw Haniszewski','Stanisław Linowski','Bartosz Sak','Joanna Niemirska','Jakub Gąsowski','Cezary Łukaszewicz','Malwina Buss','Joachim Lamża','Przemysław Bluszcz','Robert Gonera','Katarzyna Kwiatkowska','Aleksandra Popławska','Magdalena Czerwińska','Beata Kawka','Ewa Kolasińska','Andrzej Konopka','Maria Maj','Helena Sujecka','Dariusz Toczek','Tomasz Dedek','Andrzej Deskur','Magdalena Pociecha','Rune Temte','Olga Kalicka','Kamila Kamińska','Piotr Miazga','Aleksander Mikołajczak','Joanna Orleańska','Delfina Wilkońska','Grażyna Zielińska','Bartosz Wesołowski','Tomasz Oświeciński','Zuzanna Bernat','Agnieszka Wosińska','Paulina Walendziak','Anna Smołowik','Magdalena Smalara','Dorota Landowska','Radosław Krzyżowski','Zina Kerste','Weronika Asińska','Adrian Zaremba','Maja Szopa','Patryk Pniewski','Jakub Serwaczak','Robert Czebotar','Jakub Zając','Katarzyna Sawczuk','Kamil Mróz','Wojciech Czerwiński','Jan Aleksandrowicz-Krasko','Jan Hrynkiewicz','Krystian Pesta','Maciej Tomaszewski','Milena Staszuk','Monika Roszko','Filip Warot','Stefan Pawłowski','Filip Tłokiński','Dariusz Biskupski','Aleksandra Domańska','Maciej Charyton','Sandra Drzymalska','Mateusz Malecki','Michalina Rodak','Piotr Kruszewski','Michał Hytroś','Tomasz Jóźwik','Zbigniew Konopka','Łukasz Lewandowski','Krzysztof Łojan','Adam Nawojczyk','Tomasz Piotrowski','Jacek Reda','Zbigniew Stolarek','Rafał Szałajko','Robert Wabich','Jacek Sałaj','Rafał Romaniuk','Artur Łukaszewski'],
screenplay:['Jakub Żulczyk','Monika Powalisz','Bartłomiej Ignaciuk','Przemysław Nowakowski'],
production:['Wojciech Bockenheim','Piotr Dzięcioł','Mariusz Włodarski','Beata Ryczkowska','Agnieszka Nejman'],
music:['Atanas Valkov','Piotr Waglewski'],
camera:['Marian Prokop','Michał Sobociński','Weronika Bilska'],
cut:['Jarosław Barzan','Agata Cierniak','Anna Garncarczyk'],
sound:['Przemysław Kamieński','Mateusz Adamczyk','Sebastian Witkowski'],
scenography:['Maciej Fajst','Karolina Kosicka','Jagna Janicka'],
masks:['Iwona Kajszczak','Mirosława Wojtczak','Tomasz Sielecki'],
costumes:['Agnieszka Werner','Małgorzata Fudala']},
{title:'Spaceship Sagittarius',
titleCZ:'Dobrodruzi z vesmíru',
year:1986,
runtime:'30h 48min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Sci-Fi','Adventure','Comedy'],
director:['Kazujoši Jokota','Takajoši Suzuki'],
actors:['Bin Šimada',"Ken'iči Ogata",'Joku Šioja','Micuko Horie','Maja Okamoto','Eriko Hara','Šózó Iizuka','Ičiró Nagai','Kaneto Šiozawa','Mika Doi','Miki Itó','Naoko Watanabe','Šinobu Adači','Tamio Óki','Teššó Genda','Hiroko Marujama','Čika Sakamoto','Hidejuki Hori','Naoko Macui','Juriko Jamamoto','Miki Narahaši','Majumi Šó','Daisuke Góri','Kódži Totani','Bandžó Ginga','Nobuo Tobita','Kózó Šioja','Minoru Inaba','Jasuo Muramacu','Gara Takašima','Miki Takahaši','Jošiko Sakakibara','Rjóiči Tanaka','Rjúsei Nakao','Saeko Šimazu','Minoru Jada','Nobuo Tanaka','Tomomiči Nišimura','Kumiko Nišihara','Kumiko Watanabe','Keaton Jamada','Kumiko Takizawa','Kóiči Čiba','Ricuo Sawa','Acuko Mine','Mahito Cudžimura','Jošino Takamori','Akio Nodžima','Takuró Kitagawa','Kazuo Oka','Jú Šimaka','Hironori Mijata','Kazuo Hajaši','Kajoko Fudžii','Šingo Hiromori','Jošikazu Hirano','Rjúiči Horibe','Reiko Jamada','Saeri Jokota','Maki Jaosaka','Keiiči Zenzai'],
basedOn:['Andrea Romoli'],
screenplay:['Nobujuki Fudžimoto'],
production:['Takadži Macudo'],
camera:['Tošiaki Morita'],
cut:['Takeši Sejama','Jošihiro Kasahara'],
scenography:['Masahiro Sató','Masazumi Macumija','Makoto Sató','Taisaburó Abe','Cutomu Fudžita','Midori Čiba']},
{title:'Emil i Lönneberga',
titleCZ:'Emil i Lönneberga',
year:1974,
runtime:null,
episodeRuntime:'974',
countries:['Sweden','Germany'],
genres:['Family'],
director:['Olle Hellbom'],
actors:['Astrid Lindgren','Jan Ohlsson','Lena Wisborg','Allan Edwall','Emy Storm','Björn Gustafson','Maud Hansson','Carsta Löck','Bertil Norström','Jan Nygren','Georg Årlin','Göthe Grefbo','Wilhelm Clason','Hans-Eric Stenborg','Paul Esser','Hannelore Schroth','Rudolf Schündler','Ellen Widmann','Mimi Pollak','Pierre Lindstedt','Gisela Hahn','Gus Dahlström','Curt Masreliez','Sven Holmberg','Stefan Grybe','Hildur Lindberg'],
basedOn:['Astrid Lindgren'],
screenplay:['Astrid Lindgren','Olle Hellbom'],
music:['Georg Riedel'],
camera:['Kalle Bergholm'],
masks:['Inger Forsberg'],
costumes:['Ingrid Dalunde','Inger Pehrsson','Helena Sporrek']},
{title:'Overlord',
titleCZ:'Overlord',
year:2015,
runtime:'20h 48min',
episodeRuntime:'23-25min',
countries:['Japan'],
genres:['Animation','Action','Fantasy','Sci-Fi'],
director:['Naojuki Itó','Tacuja Širaiši','Hideki Hosokawa','Tóru Takahaši','Akiko Nakano','Jasumi Mikamoto','Hideki Tonokacu','Norikazu Išigooka','Kazuaki Terasawa','Kazuhiro Soeta',"Shin'ichi Miyamae"],
actors:['Satoši Hino','Akeno Watanabe','Aoi Júki','Jumi Hara','Šigeru Čiba','Kódži Jusa','M.A.O','Mamoru Mijano','Mucumi Tamura','Šinnosuke Tačibana','Takehito Kojasu','Emiri Kató','Júko Gotó','Rjóta Takeuči',"Šin'ja Hamazoe",'Minoru Inaba','Kenta Mijake','Ajane Sakura','Kazujuki Okicu','Sacuki Jukino','Ikuko Tani','Kijoko Mijazawa','Mikako Komacu','Kei Šindó','Kanehira Jamamoto','Ajumu Murase','Nacuki Hanae','Džundži Madžima','Nobuaki Kanemicu','Jošihito Sasaki','Hiromi Igaraši','Jumi Učijama','Marika Kóno','Tóru Sakurai','Kentaró Tone','Kótaró Nišijama','Sumire Uesaka','Masaaki Ihara','Takuja Kirimoto','Eriko Macui','Manami Numakura','Acuši Imaruoka','Jú Šimamura','Masaaki Jano','Sora Amamija','Kacumi Čó','Takuja Sató','Kimiko Saitó','Džunpei Asašina','Takaja Haši','Kódži Išii','Rjóta Ósaka','Nao Tójama','Takahiro Sakurai','Miju Tomita','Hiroki Tóči','Ami Košimizu','Naomi Kusumi','Akane Fudžita','Hiroši Širokuma','Džun Kasama','Hiromiči Tezuka','Masaši Nogawa','Rjótaró Okiaju','Satomi Arai','Nobujuki Hijama','Masako Nozawa','Maki Izawa','Jumiri Hanamori','Šizuka Išigami','Rintaró Niši','Jošimicu Šimojama','Kijono Jasuno','Jutaka Aojama','Asami Seto','Sajaka Senbongi','Takaši Macujama','Tadaši Mijazawa','Saori Óniši','Taiten Kusunoki','Jošikazu Nagano','Hiroši Kamija','Teššó Genda','Kaito Išikawa','Ajahi Takagaki','Daisuke Hirakawa','Hina Kino','Ai Kakuma',"Šin'ja Takahaši",'Haruki Išija','Takuró Nakakuni','Masaki Terasoma','Miho Okasaki','Toa Jukinari','Hironori Saitó','Akihiro Tadžima',"Šun'iči Maki",'Kowaka Wakana','Hitoši Bifu','Taró Kiuči'],
basedOn:['Kugane Marujama'],
screenplay:['Jukie Sugawara','Fúta Takei','Icuki Jokojama','Satoko Sekine'],
production:['Júki Jošida'],
music:['Šúdži Katajama'],
camera:['Júki Kawašita','Micuki Cugioka','Jošio Watanabe'],
cut:['Kašiko Kimura','Mariko Cukacune'],
sound:['Fumijuki Gó'],
scenography:['Šigemi Ikeda','Jukiko Marujama']},
{title:'Pantheon',
titleCZ:'Pantheon',
year:2022,
runtime:'11h 5min',
episodeRuntime:'40-45min',
countries:['USA'],
genres:['Animation','Drama','Sci-Fi'],
director:['Ed Tadem','Melchior Zwyer','Micah Gunnell','David Dwooman Woo','Mari Yang','Juno John Lee','Sang Yeop Kim','Yeongil Park','Sihu Park','Yohan Hahn','Selil Oh','Jinyeol Park','Seungkyung Lee','Jae Woo Kim','Jonghyeon Lee','Min Seon Kim','Tae Sik Kang','Sang Yong Eom','Seung Bong Lim','Gyeong Pyo Hong','Gayeong Myoung','Yangho Ji','Jeonghui Yang','Joung Gil Lee','Seung-Hoon Yoo','Chan-Young Park','Sung-jin Suh','Young Hyun Kim','Yee Young Lee','Yu-Won Pang','Jae Hong Kim'],
actors:['Maude Apatow','Katie Chang','Paul Dano','Rosemarie DeWitt','Chris Diamantopoulos','Aaron Eckhart','William Hurt','Raza Jaffrey','Daniel Dae Kim','Ron Livingston','Scoot McNairy','Lara Pulver','Taylor Schilling','Corey Stoll','Samuel Roukin','Kevin Durand','Grey Griffin','Anika Noni Rose','Tunde Adebimpe','Kevin Dunn','Clyde Kusatsu','Heather Lind','Rosa Salazar','Michael Kelly','Paul F. Tompkins','Tisha Campbell-Martin','Julian Lerner','Thomasin McKenzie','Navid Negahban','Alon Aboutboul','Mark Ivanir','Arthel Neville','Ben Schnetzer','Neil deGrasse Tyson','C.S. Lee','Ken Leung','Toks Olagundoye','Ed Oxenbould','Kari Wahlgren'],
screenplay:['Craig Silverstein','Michael Taylor','Julia Cooperman','Andy Parker','Albert Kim','Taii K. Austin','Yasemin Yılmaz','Scott Gunnison Miller'],
production:['Yasemin Yılmaz'],
music:['Marco Beltrami','Brandon Roberts','Buck Sanders'],
cut:['Jocelyn Barkenhagen','Megan Love','Marco Vera'],
sound:['George Haddad','Gerardo Gonzalez','Josh Eckberg','Carlos Sanches','Dan Hiland','Todd Beckett','Yuri Reese','Paul Menichini'],
scenography:['Crystal Yoori Son','Jake Wyatt']},
{title:'Cops and Robbers',
titleCZ:'Četnické humoresky',
year:2001,
runtime:'53h 46min',
episodeRuntime:'57-105min',
countries:['Czechia'],
genres:['Comedy','Crime'],
director:['Antonín Moskalyk','Pavlína Moskalyková'],
actors:['Tomáš Töpfer','Petr Kostka','Ivan Trojan','Zdeněk Junák','Stanislav Zindulka','František Švihlík','Erik Pardus','Jan Apolenář','Alena Antalová','Libuše Šafránková','Andrea Elsnerová','Vlasta Peterková','Zdena Herfortová','Jiřina Jelenská','Tatiana Dyková','Marek Vašut','Marián Labuda st.','Jiří Krampol','Jan Hartl','Ilja Racek','Miroslav Táborský','Jiřina Bohdalová','Tereza Kostková','Jaroslav Satoranský','Jan Hrušínský','Luděk Munzar','Václav Postránecký','Radovan Lukavský','Pavel Zedníček','Jiří Schmitzer','Václav Vydra nejml.','David Matásek','Bořivoj Navrátil','Jiří Pecha','Michal Dočolomanský','Jiří Langmajer','Pavel Rímský','Jitka Čvančarová','Václav Knop','Tomáš Valík','Petr Štěpán','Ladislav Kolář','Viktor Skála','Martin Havelka','Kamil Halbich','Otmar Brancuzský','Rostislav Čtvrtlík','Jiří Tomek','Vladimír T. Gottwald','František Bohdal','Martin Preiss','Marko Igonda','Jaroslav Plesl','Věra Galatíková','Ludmila Forétková','Uršula Kluková','Anna Bazgerová','Otto Lackovič','Boris Rösner','Viktor Preiss','František Kreuzmann','Miroslav Donutil','Lubomír Kostelka','Zdeněk Srstka','Lenka Skopalová','Carmen Mayerová','Marie Pavlíková','Miroslav Rataj','Květa Fialová','Oldřich Vízner','Jan Budař','Jiří Pištěk','Milena Steinmasslová','Veronika Freimanová','Petr Rychlý','Hynek Pech','Simona Stašová','Svatopluk Skopal','Jitka Smutná','Taťjana Medvecká','Gabriela Štefanová','Jaroslav Rava','Leopold Haverl','Jan Fišar','Ivana Valešová','Jaroslava Obermaierová','Dana Syslová','Vilma Cibulková','Jana Hlaváčová','Ivan Gübel','Zuzana Fišárková','Marcel Vašinka','Josef Karlík','Igor Bareš','Miroslav Vladyka','Blažena Holišová','Jiří Štěpnička','Zdeněk Černín','Hana Maciuchová','Ladislav Lakomý'],
screenplay:['Antonín Moskalyk','Pavlína Moskalyková','Petr Zikmund','Drahoslav Makovička','Miloš Fedaš','Hana Slavíková','Josef Souchop'],
production:['Hana Vrbová','Darina Levová','Robert Fuksa'],
music:['Ivan Kurz'],
camera:['Jakub Nosek','Josef Víšek','Radomír Řezáč'],
cut:['Jaroslav Rásocha','Jindřich Juna','Irena Olivová','Stanislava Novotná'],
sound:['Lubor Hochmann'],
scenography:['Zdeněk Flemming','Vlastimil Maláč','Iva Farkačová','Barbora Erniholdová','Milan Oliva'],
masks:['Irena Olivová','Stanislava Novotná','Květa Zavřelová'],
costumes:['Jana Přichystalová','Michaela Ježová','Ludmila Kubíčková','Alena Burianová','Sylva Zimula Hanáková','Petra Puldová','Blanka Tesařová','Ivana Šťastná','Jana Horáková','Mirka Jandová-Masařová','Dana Józová','Iveta Pátíková','Libuše Pražáková']},
{title:'Rákosníček a povětří',
titleCZ:'Rákosníček a povětří',
year:1983,
runtime:'1h 44min',
episodeRuntime:'8min',
countries:['Czechoslovakia'],
genres:['Animation','Fairytale'],
director:['Zdeněk Smetana'],
actors:['Jiřina Bohdalová'],
screenplay:['Zdeněk Smetana','Vladimír Branislav'],
music:['Václav Zahradník'],
camera:['Dana Olejníčková','Jaroslava Zimová'],
cut:['Jiřina Pěčová'],
sound:['Benjamin Astrug']},
{title:'#martyisdead',
titleCZ:'#martyisdead',
year:2019,
runtime:'1h 42min',
episodeRuntime:'9-17min',
countries:['Czechia'],
genres:['Crime','Thriller','Short'],
director:['Pavel Soukup'],
actors:['Jakub Nemčok','Petra Bučková','Jan Grundman','Sára Korbelová','Matěj Havelka','Jan Zadražil','Nataša Gáčová','Tomáš Bambušek','Andrej Polák','Jan Španbauer','Michal Sušina','Pavel Betka','Jan Knespl','Martin Winter','Edita Blesková','Jakub Kalián','Klára Miklasová','Leoš Juráček','Janusz Hummel','Jitka Doležalová','Pavel Reh','Angelica Wudy','Štepán Dostal'],
screenplay:['Jaroslav T. Miška','Jan Stehlík'],
production:['Milan Kuchynka','Vratislav Šlajer','Jakub Košťál','Lukáš Záhoř'],
music:['Jindřich Kravařík'],
camera:['Miloslav Holman'],
cut:['Tomáš Holocsy'],
sound:['Jakub Šimandl'],
scenography:['Martin Rálek'],
masks:['Tereza Hušková'],
costumes:['Aneta Grňáková']},
{title:'Elite',
titleCZ:'Elita',
year:2018,
runtime:'46h 34min',
episodeRuntime:'40-61min',
countries:['Spain'],
genres:['Crime','Drama','Thriller'],
director:['Ramón Salazar','Dani de la Orden','Jorge Torregrossa','Sílvia Quer','Eduardo Chapero-Jackson','Ginesta Guindal','Lino Escalera','Kike Maíllo','Elena Trapé'],
actors:['Miguel Bernardeau','Miguel Herrán','Danna Paola','María Pedraza','Itzan Escamilla','Mina El Hammani','Shani Atias','Irene Arcos','Ester Expósito','Ainhoa Santamaría','Arón Piper','Álvaro Rico','Omar Ayuso','Jorge López','Georgina Amorós','Claudia Salas','Jaime Lorente','Manu Ríos','Martina Cariddi','Carla Díaz','Pol Granch','Diego Martín','Andrés Velencoso','Farah Hamed','Leïti Sène','Lola Marceli','Yaiza Guimaré','Elisabet Gelabert','Ramón Esquinas','Rocío Muñoz-Cobo','Carlos Olalla','Bruno Lastra','Ken Appledorn','Eva Llorach','Jorge Clemente','Abdelatif Hwidar','Eric Masip','Rafael Sandoval','Kevin McHale','Sergio Momo','Iñaki Juaristi','Fernando Moraleda','Julio Perillán','Joan Manuel Gurillo','Saturnino García','Marta Aledo','Francisco Ramos','Daniel Mantero','Cristina Medina','Diego Betancor','Liz Lobato','Gary Anthony Stennette','Coke Rodriguez','Alfredo Villa','Véronica Polo','Kike Guaza','Jorge Suquet','Julian Ortega','Josete Rivas','Javier Mula','Dori Martin','Emilio Pereda','Julia Rodríguez','Rut Santamaría','Rubén Martínez','Alex de Nova','Hicham Malayo','Félix Herzog','Víctor Castilla','Sonia Oblinski','Paula Fernández Mata','Valentina Zenere','Adam Nourou','André Lamoglia','Carloto Cotta','Boré Buika','Louvia Bachelier','Pablo Rodríguez','Alejandro Ruiz','Angel Bogórquez','Tony Kruuser','Iria del Río','Isabel Garrido','Victoria Abril','Loles León','Àlex Monner','Andrés Velencoso','Rachel Lascar','Carmen Méndez','Guillermo Campra','Núria Prims','Carmen Arrufat','Álvaro de Juana','Alireza Ahmand','Maribel Verdú','Nerea García','Marc Bonnin','Godeliv Van den Brandt','Luz Cipriota','Nadia Al Saidi'],
screenplay:['Darío Madrona','Jaime Vaca','Almudena Ocaña','Abril Zamora','Breixo Corral','Carlos Montero','David Lorenzo','Jessica Pires','Lluís Mosquera','Alberto Manzano'],
production:['Francisco Ramos','Antonio Asensio','Paloma Molina'],
music:['Lucas Vidal','Matthew Jordan Leeds','Ricardo Curto','Lucio Godoy'],
camera:['Ricardo de Gracia','Daniel Sosa Segura','Alfonso Postigo','Juana Jiménez','Miquel Prohens','Carlos Garcés','Sergi Bartrolí','Teo Delgado'],
cut:['Irene Blecua','Ascen Marchena','Javier Martín Penagos','Alicia González Sahagún'],
sound:['Amín Alí Gago','Nicolas de Poulpiquet','Álvaro López-Arregui'],
scenography:['Antón Laguna','Federico García Cambero','Imanol Echeverría','Serafín González'],
masks:['Patricia López','Raúl Gallego'],
costumes:['Cristina Rodríguez']},
{title:'Whitechapel',
titleCZ:'Whitechapel',
year:2009,
runtime:'13h 37min',
episodeRuntime:'44-48min',
countries:['UK'],
genres:['Thriller','Crime','Mystery'],
director:['Jon East','S.J. Clarkson','David Evans','Richard Clark','John Strickland','Daniel Nettheim'],
actors:['Rupert Penry-Jones','Phil Davis','Steve Pemberton','Sam Stockman','Claire Rushbrook','Ben Bishop','Hannah Walters','Angela Pleasence','Alex Jennings','Christopher Fulford','Johnny Harris','Craig Parkinson','Peter Serafinowicz','Steve Nicolson','Tom Beard','Daniel Percival','Christina Chong','Ben Caplan','David Schneider','Jonathan Aris','Ben Loyd-Holmes','Sam Reid','Daisy Beaumont','Dimitri Andreas','Nicholas McGaughey','Joan Blackham','Robert Putt','Kieran Bew','Andy Callaghan','Bryony Afferson','Stephanie Leonidas','Constantine Gregory','Louise Dylan','Sally Leonard','Sadie Shimmin','Nate Fallows','Charlotte Hope','Muna Otaru','Deirdre Mullins','Nicholas Blane','Andy Beckwith','Paul Chequer','Janice Acquah','Munir Khairdin','Paul Warren','Joey Batey','Ed Cooper Clarke','Pip Torrens','Branko Tomović','Mo Zinal','Mona Hammond','Hannah John-Kamen','Victoria Alcock','Jason Maza','Martin Turner','Barbara Marten',"Caroline O'Neill",'Vicky Hall','Chris Cowlin','Deddie Davies','Charlie Covell','Georgine Anderson','George Rossi','Damian Dudkiewicz','Paul Hickey','Trevor Martin','Andrew Tiernan','Shaun Evans','James Dreyfus','Richard Graham','Camilla Power','Lydia Leonard','Alistair Petrie','Holli Dempsey','Tom Fisher','Chris Ryman','Paul Blackwell','David Gant','Jake Curran','William Beck','Brian Protheroe','Janine Wood','Mandeep Dhillon','Hugh Mitchell','Geoff Bell','Diana Kent','Mark Rice-Oxley','Richard Cordery','Matthew David McCarthy','Andrew Buckley','Michael Fitzgerald','Sheena Bhattessa','Nick Fletcher','Kate Maravan','Chris Wilson','Badria Timimi','Simon Manyonda','Tahirah Sharif','Remmie Milner','Kiell Smith-Bynoe'],
screenplay:['Ben Court','Caroline Ip','Steve Pemberton'],
production:['Marcus Wilson','David Boulter','Grainne Marmion'],
music:['Ruth Barrett','Martin Phipps','Malcolm Lindsay','Jake Jackson'],
camera:['Kieran McGuigan','Ulf Brantås','Balazs Bolygo','Owen McPolin'],
cut:['Liana Del Giudice','Anthony Combes','Mark Davis'],
sound:['Ben Baird'],
scenography:['Tom Brown','Martyn John','Anthony Ainsworth','Jane Broomfield','Steve Wright','Melanie Allen'],
masks:['Marella Shearer'],
costumes:['Howard Burden']},
{title:'Dorohedoro',
titleCZ:'Dorohedoro',
year:2020,
runtime:'9h 48min',
episodeRuntime:'24-25min',
countries:['Japan'],
genres:['Animation','Adventure','Fantasy'],
director:['Júičiró Hajaši','Daisuke Tokudo','Kendži Takahaši','Parako Šinohara'],
actors:['Wataru Takagi','Reina Kondó',"Ken'jú Horiuči",'Jošimasa Hosoja','Jú Kobajaši','Kengo Takahaši','Miju Tomita','Anri Kacu','Hisao Egawa','Hozumi Góda','Micuhiro Ičiki',"Šin'ičiró Miki",'Tecu Inada','Hiro Šimono','Takehito Kojasu','Takuma Terašima','Tóru Nara','Minoru Inaba','Šúja Nišidži','Rjóhei Kimura','Júki Kadži','Šigeru Čiba','Rena Maeda','Mijuri Šimabukuro','Júta Odagaki','Masaja Fukuniši','Kazumasa Nakamura','Jú Mijazaki','Hiroki Macukawa','Maju Udono','Kósuke Okamoto','Norijuki Cujuki','Keita Tada','Hajato Kimura','Sóširó Hori','Hodaka Mieno','Kunihiro Kawamoto','Do Song','Rjósuke Morita','Daiširó Hano','Hidetaka Tendžin','Satoru Itó'],
basedOn:['Kjú Hajašida'],
screenplay:['Hiroši Seko'],
music:['Kishi Tomohiro','R.O.N.'],
camera:['Hyo-Gyu Park'],
cut:['Masato Jošitake'],
sound:['Akiko Fudžita'],
scenography:['Šindži Kimura']},
{title:'Vader: A Star Wars Theory Fan Series',
titleCZ:'Vader: A Star Wars Theory Fan Series',
year:2018,
runtime:null,
episodeRuntime:'13min',
countries:['USA'],
genres:['Sci-Fi'],
director:['Danny Ramirez'],
actors:['Olivia Blue'],
screenplay:['Nikolaj Wejp-Olsen','Danny Ramirez'],
cut:['Danny Ramirez']},
{title:'From the New World',
titleCZ:'Šinsekai jori',
year:2012,
runtime:'9h 35min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Mystery'],
director:['Masaši Išihama','Šigejasu Jamauči','Kenjiro Okada','Džun Macumoto','Tomoja Takahaši',"Džun'iči Fudžise",'Kóta Okuno','Júta Takamura','Kazujoši Jaginuma','Acuši Nakajama','Jošihiro Mori','Makoto Fučigami','Hideki Hirošima','Hiroaki Tomita','Nobutoši Ogura','Naomiči Jamato'],
actors:['Risa Taneda','Daisuke Namikawa','Miki Itó','Tamio Óki','Jui Horie','Juri Amano','Aja Endó','Kišó Tanijama','Nao Tamura',"Šin'ja Hamazoe",'Sanae Kobajaši','Rjó Kamon','Kósuke Toriumi','Jošiko Sakakibara','Sakiko Tamagawa',"Šin'ja Takahaši",'Hiroki Tóči','Rikako Jamaguči','Motoki Takagi','Jošihisa Kawahara','Jóko Sómi','Kanehira Jamamoto','Ajumu Murase','Akiko Hiramacu','Saori Hajaši','Takanori Hošino','Kenta Sasa','Júsuke Širai','Hiroši Iwasaki','Mai Tódó','Gó Šinomija','Haruka Kudó','Rjóta Iwasaki','Tomo Muranaka','Toa Jukinari','Jóhei Tadano','Eiičiró Tokumoto','Júki Kadži','Masajuki Kató','Iššin Čiba','Akiko Jadžima','Kaori Jamagata','Hiroaki Hirata','Hirojuki Honda','Kósuke Okamoto','Kana Hanazawa','Hirojuki Endó','Júsuke Kiši','Čisa Júki','Makoto Takahaši','Mucumi Tamura','Asuka Minamori','Kazutaka Išii','Kanako Tódžó','Tomokazu Sugita','Kajoko Fudžii','Kana Sagami','Kazua Akieda','Aja Endó','Kacufumi Jači','Ajano Saitó'],
basedOn:['Júsuke Kiši'],
screenplay:['Masaši Sogo','Jošiko Nakamura','Rika Nakase','Kóhei Urasawa'],
production:['Tomonori Očikoši','Acuši Kadži','Osamu Hosokawa'],
music:['Šigeo Komori'],
camera:['Haruhi Gotó'],
cut:['Kentaró Cubone'],
sound:['Satoši Motojama'],
scenography:['Saho Jamane']},
{title:'State of Play',
titleCZ:'State of Play',
year:2003,
runtime:'5h 42min',
episodeRuntime:'57min',
countries:['UK'],
genres:['Drama','Crime'],
director:['David Yates'],
actors:['John Simm','Kelly Macdonald','Bill Nighy','Philip Glenister','David Morrissey','James McAvoy','Benedict Wong','Marc Warren','Polly Walker','Tom Burke','Christopher Simpson','Shauna Macdonald','Rebecca Ryan','Natasha Wightman','Geraldine James','Elizabeth Elvin','Rory McCann','Nick Brimble','Susie Porter','Peter Sullivan','Amelia Bullmore','Anthony Flanagan','Fred Pearson','David Ryall','Sean Gilder','Deborah Findlay','Andy Linden','Hilary Bevan Jones','Greg Bennett','Patrick Brennan','Chris Obi','Rebekah Staton','Neil Bell','James Laurenson','Michael Feast','Aaron Neil','Finn Atkins','Madeleine Potter','Johann Myers','Michael Gould','Ian Hughes','Keith Bisset'],
screenplay:['Paul Abbott'],
music:['Nicholas Hooper'],
camera:['Chris Seager'],
cut:['Mark Day'],
scenography:['Donal Woods'],
masks:['Karen Edwards'],
costumes:['Claire Anderson']},
{title:'Bravest Warriors',
titleCZ:'Bravest Warriors',
year:2012,
runtime:'14h 1min',
episodeRuntime:'7-11min',
countries:['USA'],
genres:['Comedy','Sci-Fi','Adventure','Action'],
director:['Breehn Burns','Adrian Thatcher','Ki-hoo Hwang'],
actors:['Liliana Mumy','John Omohundro','Ian Jones-Quartey','Graeme Jokic','Breehn Burns','Thomas Middleditch','Eric Bauza','Dana Snyder','Michael-Leon Wooley','Sam Lavagnino','Jessica DiCicco','André Sogliuzzo'],
screenplay:['Breehn Burns','Will McRobb','Chris Viscardi','Steve Wolfhard','Niki Yang','Kevin Burke','Jhonen Vasquez','John Omohundro','Chris Wyatt','Derek Iversen','James Hamilton','Jack Bernhardt','Amalia Levari','Tobi Wilson'],
production:['Jane Crawford','Helen Lebeau','Kevin Kolde'],
music:['Neil Parfitt','Drew Neumann','Timothy Kiefer','Jon Baken'],
cut:['Andy Tauke'],
sound:['Gary Falcone','Tom Maydeck','Marc Schmidt'],
scenography:['Davian Bobrowska']},
{title:'SKAM France',
titleCZ:'SKAM France',
year:2018,
runtime:null,
episodeRuntime:'2018-2022',
countries:['France','Belgium'],
genres:['Drama'],
director:['Shirley Monsarrat','David Hourrègue'],
actors:['Jade Pedri','Lucie Fagedet','Zoé Garcia','Khalil Ben Gharbia','Charlie Loiselier','Olivia Côte','Alain Bouzigues','Régis Romele','Rachid Yous','Axel Auriant','Lula Cotton-Frapier','Maxence Danet-Fauvel','Léo Daudin','Philippine Stindel','Assa Sylla','Robin Migné','Coline Preher','Paul Scarfoglio','Marilyn Lima','Zoé Marchal','Michel Biel','Théo Christine','Caroline Tillette','Victor Le Blond','Mickaël Lumière','Ayumi Roux','Maël Cordier','Flavie Delangle','Louise Malek','Abdallah Charki'],
screenplay:['Clarisse Potoky','Louise Groult','Charlie Loiselier','Marie Lelong','Cyril Tysz','Clémence Lebatteux','Delphine Agut','Frédéric Garcia'],
music:['Christian Wibe'],
camera:['Xavier Dolléans'],
scenography:['Edwige Le Carquet'],
masks:['Shirley Drai','Hue Lan Van Duc']},
{title:'Criminal: Germany',
titleCZ:'Criminal: Německo',
year:2019,
runtime:'2h 13min',
episodeRuntime:'41-46min',
countries:['Germany'],
genres:['Drama','Crime'],
director:['Jim Field Smith','Oliver Hirschbiegel'],
actors:['Jonathan Berlin','Christian Kuchenbuch','Sebastian Koch','Nina Hoss','Alejandro Hernández','Bernd Lange','Antonin Martin-Hilbert','Manuel Martín Cuenca','Mathieu Missoffe','Sylvester Groth','Florence Kasumba','Peter Kurth','Eva Meckbach','Deniz Arora','Christian Berkel'],
screenplay:['Alejandro Hernández','Bernd Lange','Antonin Martin-Hilbert','Manuel Martín Cuenca','Mathieu Missoffe','Sebastian Heeg'],
music:['Robin Foster'],
sound:['Gabriel Gutiérrez'],
scenography:['Alejandro Fernández'],
costumes:['Irene Orts']},
{title:'Neoui moksoriga deulleo',
titleCZ:'Neoui moksoriga deulleo',
year:2013,
runtime:'18h 59min',
episodeRuntime:'62-64min',
countries:['South Korea'],
genres:['Romance','Fantasy','Comedy','Mystery','Thriller'],
director:['Soo-won Jo'],
actors:['Bo-yeong Lee','Jong-seok Lee','Sang-hyeon Yoon','Da-hee Lee','Woong-in Jeong','Dong-hwan Jung','Byeong-ok Kim','Ga-eun Kim','Man-sik Jeong','Seong-gyoon Kim','Hee-woong Jang','Byeong-joon Lee','Deok-hyeon Jo','Hae-sook Kim','Moon-sook Ahn','Mi-kyeong Kim','Joo-sang Yoon','Kwang-gyoo Kim','So-hyeon Kim','Min-jong Kim','Doo-shik Park','Soo-kyeong Jeon','Ki-cheon Kim','Seung-hyeon Goo','Gi-woong Han','Gi-won Han','Jung-hyuk Lee','Hee-soo Jang','Young-mi Ahn','Dae-seong Choi','Kangnam','Sol-gu Lee','Kyung-jin Kim','Won-seok Go'],
screenplay:['Hye-ryeon Park'],
production:['Sung Hoon Lee'],
music:['Seong-nam Moon']},
{title:'Bakuman.',
titleCZ:'Bakuman.',
year:2010,
runtime:null,
episodeRuntime:'30h24min',
countries:['Japan'],
genres:['Animation','Drama','Comedy','Romance'],
director:['Hikaru Sató','Noriaki Akitaja','Keniči Kasai','Seimei Kidokoro','Hirojuki Hašimoto','Jošinobu Tokumoto','Masato Džinbó','Tošinori Fukušima','Micutoši Sató','Masakazu Amija','Makoto Sokuza','Júta Marujama','Fumihiro Jošimura'],
actors:['Ajako Kawasumi',"Džun'iči Suwabe",'Nobuhiko Okamoto','Aja Suzaki','Takehito Kojasu','Kendži Hamada','Emiri Kató','Acuši Abe','Satoši Hino','Ajumi Fudžimura','Saori Gotó','Rina Hidaka','Sajuri Jahagi','Azusa Kataoka','Majuki Makiguči','Kumiko Higa','Šizuka Išigami','Júsaku Jara','Šindži Kawada','Kóki Mijata','Takajuki Kondó','Kazujuki Okicu','Harumi Sakurai','Čó','Hidenari Ugaki','Šótaró Morikubo',"Ken'jú Horiuči",'Tomojuki Šimura','Daisuke Kirii','Maju Harumija','Saori Hajami','Jasuaki Takumi','Jošihisa Kawahara','Kikuko Inoue','Manabu Sakamaki','Masako Kacuki','Hirofumi Nodžima','Júto Kazama','Kentaró Tone','Masakazu Morita','Hiroši Cučida','Ajumi Cunemacu','Jóko Honda','Hidetoši Nakamura','Kenta Mijake','Kan Tanaka','Júiči Iguči','Jošimicu Šimojama','Hiroki Šimowada','Lynn','Jumi Učijama','Sajuri Hara','Takajuki Jamaguči','Kudžira','Masaši Ebara','Fumi Hirano','Júko Kobajaši','Nobuaki Kanemicu','Júko Gibu','Ajane Sakura','Reina Ueda','Kana Asumi','Jošiki Nakadžima','Júta Odagaki','Čina Kitahara','Noriko Obata','Asami Jano','Juka Saitó','Ajako Uemura','Júki Kadži','Kozue Harašima','Micuhiro Sakamaki','Asuka Ógame','Rie Jamaguči','Sakura Jošioka','Šinnosuke Tačibana','Hiro Nakadžima','Kóiči Bandó','Činacu Akasaki','Miki Makiguči','Mucumi Tamura','Tokujoši Kawašima','Kendži Nodžima','Rjótaró Okiaju','Hirojuki Nakano','Šóto Kašii','Tošitaka Hirano','Jošicugu Macuoka','Takuma Suzuki','Afumi Haši','Hinako Sasaki','Takuja Kurijama','Juka Takakura','Cubasa Takanohaši','Júko Mizobe','Narumi Sató','Marie Mizuno','Kentaró Jamazaki','Nozomi Kodžó','Asuka Horiguči'],
basedOn:['Takeši Obata','Cugumi Óba'],
screenplay:['Reiko Jošida','Cutomu Kamiširo','Seiši Minakami','Keiičiró Óči','Mičihiro Cučija','Juniko Ajana'],
music:['Audio Highs'],
camera:['Kazuja Iwai','Daisuke Horino'],
cut:['Masahiro Gotó'],
sound:['Džun Watanabe'],
scenography:['Čikako Šibata']},
{title:'The Fourth Star',
titleCZ:'Čtvrtá hvězda',
year:2014,
runtime:'5h 37min',
episodeRuntime:'27-30min',
countries:['Czechia'],
genres:['Comedy'],
director:['Jan Prušinovský','Miroslav Krobot'],
actors:['Václav Neužil ml.','Ivan Trojan','Martha Issová','David Novotný','Jaroslav Plesl','Simona Babčáková','Lenka Krobotová','Jana Holcová','Miroslav Krobot','Martin Myšička','Marek Taclík','Pavel Šimčík','Pavlína Štorková','Klára Melíšková','Lukáš Příkazký','Radek Holub','Hynek Čermák','Taťjana Medvecká','Petr Kolečko','Leoš Noha','Roman Bednář','Jan Prušinovský','Jiří Zeman','Lukáš Vincour','Mark Grein','Jin Wenjun','Jan Kašpar','Petr Vančura','Filip Kaňkovský','Anton Čamaj','Veronika Řeháková','Vladimír Marek','Ludmila Engelová','Jana Burkiewiczová','Jakub Sedláček','Marián Miezga','Evženie Pfeifferová','John Comer','Pavel Čapek','Jaromír Bosák','Jaroslav Vlach','Soňa Beaumont','Simona Vavrušová'],
screenplay:['Petr Kolečko','Jan Prušinovský','Miroslav Krobot'],
production:['Ondřej Zima','Jan Prušinovský','Jan Štern'],
music:['Adam Svatoš'],
camera:['Petr Bednář'],
cut:['Otakar Šenovský','Lukáš Opatrný'],
sound:['Matěj Matuška','Michal Čech'],
scenography:['Jan Vlček'],
masks:['Lukáš Král'],
costumes:['Ivan Stekla']},
{title:'Kaštánek',
titleCZ:'Kaštánek',
year:2021,
runtime:'5h 31min',
episodeRuntime:'52-59min',
countries:['Denmark'],
genres:['Drama','Crime','Mystery','Thriller'],
director:['Kasper Barfoed','Mikkel Serup'],
actors:['Esben Dalgaard','Danica Curcic','David Dencik','Iben Dorner','Mikkel Boe Følsgaard','Ali Kazim','Louis Næss-Schmidt','Lars Ranthe','Anders Hove','Arian Kashef','Kristine Lauritzen','Thomas L. Corneliussen','Samy Andersen','Morten Brovn','Marie-Lydie Melono Nokouda','Jesper Tønnes','Claudio Morales','Elisabeth von Rosen','Vilje Gabrielle Katring-Rasmussen','Thea Glindorf'],
basedOn:['Søren Sveistrup'],
screenplay:['Dorte Warnøe Høgh','David Sandreuter'],
production:['Morten Kjems Hytten Juhl'],
music:['Kristian Eidnes Andersen'],
camera:['Sine Vadstrup Brooker','Louise McLaughlin'],
cut:['Cathrine Ambus','Martin Schade'],
sound:['Jonas Langkilde','Mick Raaschou','Morten Groth Brandt'],
scenography:['Thomas Greve','Mathias Hassing'],
costumes:['Rikke Simonsen']},
{title:'Gagman',
titleCZ:'Gagman',
year:1987,
runtime:null,
episodeRuntime:'6 x 28min',
countries:['Czechoslovakia','Germany'],
genres:['Comedy','Musical'],
director:['Juraj Herz'],
actors:['Boris Hybner','Jan Kanyza','Tereza Pokorná-Herzová','Juraj Herz','Vlastimil Bedrna','Zdeněk Dítě','Helena Růžičková','Jiří Lír','Jaroslav Heyduk','Jan Přeučil','Gabriela Wilhelmová','Zdeněk Srstka','Josef Platz','Jaroslav Čejka','Jaroslava Kretschmerová','Jiří Růžička ml.','Radan Rusev','Zdeňka Sajfertová','Richard Rýda','Milan Charvát','Vítězslav Bouchner','Vladimír Tausinger'],
screenplay:['Juraj Herz'],
production:['Karel Dirka'],
music:['Petr Hapka'],
camera:['Viktor Růžička'],
sound:['Pavel Jelínek']},
{title:'Tabula Rasa',
titleCZ:'Tabula rasa',
year:2017,
runtime:'7h 30min',
episodeRuntime:'50min',
countries:['Belgium'],
genres:['Psychology','Thriller'],
director:['Kaat Beels','Jonas Govaerts'],
actors:['Veerle Baetens','Gene Bervoets','Hilde Van Mieghem','Natali Broods','Jeroen Perceval','Peter Van den Begin','François Beukelaers','Tom Audenaert','Bilall Fallah','Jan Debski','Michael Pas','Ruth Becquart','Viviane de Muynck','Koen De Sutter','Marc Didden','Valentijn Dhaenens','Vic De Wachter','Annemie Gils','Bob Snijers','Marc Peeters','Kevin Bellemans','Raouf Hadj Mohamed','Victor Zaidi','Peter De Graef','Isabelle van Hecke','Cécile Enthoven','Soufiane Chilah'],
screenplay:['Veerle Baetens','Christophe Dirickx','Malin-Sarah Gozin'],
production:['Frank Van Passel'],
music:['Lachlan Anderson'],
camera:['Brecht Goyvaerts','Dries Delputte'],
scenography:['Bart Van Loo']},
{title:'Metalocalypse',
titleCZ:'Metalocalypse',
year:2006,
runtime:'13h 22min',
episodeRuntime:'11-23min',
countries:['USA'],
genres:['Animation','Comedy','Music'],
director:['Mark Brooks','Jon Schnepp','Brendon Small','Chris Prynoski','Tommy Blacha','Mike Roush','Felipe Salazar','Christine Kolosov'],
actors:['Mark Hamill','Kirk Hammett','James Hetfield','Brian Posehn','Andy Richter','Steve Vai','Mike Patton','Gene Hoglan','Mark Brooks','Werner Herzog','Angela Gossow','Brendon Small','Marc Maron','Billy Gibbons','James Urbaniak','Byron Minns','Victor Brandt','Frankie Ingrassia','Christopher McCulloch','Gary Holt','Drew Pinsky','Tommy Blacha','Laraine Newman','Jon Schnepp','George Fisher','Laura Silverman','Mike Keneally','Malcolm McDowell','Silenoz','Kim B. Petersen','Devin Townsend','Keith Fay','Shannon Prynoski','ICS Vortex','Richard Christy','Joe Satriani','Slash','Brann Dailor','Brent Hinds','Dave Grohl','Amber Tamblyn','Samantha Eggar','Pat Healy','Janeane Garofalo','Jon Hamm','Patton Oswalt','Chris Elliott','Dweezil Zappa','Ace Frehley'],
screenplay:['Brendon Small','Bill Braudis','Janine Ditullio','Kristofor Brown','Daniel Libman','Tommy Blacha','Danielle Vetere','Brian Posehn','Mark Brooks','Mark Rivers','Matthew Libman','Jason Butler Rote','Kevin Kaliher','John Cawley'],
production:['Keith Fay','Shannon Prynoski','Chris Prynoski','Ollie Green'],
music:['Brendon Small','Dethklok'],
cut:['Damon P. Yoches','Chris Prynoski','Jeffrey Perlmutter','Jon Schnepp','Hans Fjellestad','Mark Brooks','Felipe Salazar','Bruce King'],
sound:['Konrad Piñon','George Soto','George Thompson'],
scenography:['Antonio Canobbio']},
{title:"Life's Too Short",
titleCZ:"Life's Too Short",
year:2011,
runtime:'4h 17min',
episodeRuntime:'27-60min',
countries:['UK'],
genres:['Comedy'],
director:['Ricky Gervais','Stephen Merchant'],
actors:['Warwick Davis','Ricky Gervais','Stephen Merchant','Liam Neeson','Johnny Depp','Helena Bonham Carter','Steve Carell','Cat Deeley','Sting','Sophie Ellis-Bextor','Ewen MacIntosh','Ramin Karimloo','Rosamund Hanson','Kiruna Stamell','Tim Key','Tony Way','Matthew Holness','David Fynn','Anthony Welsh','Rupert Holliday-Evans','Shaun Williamson','Steve Oram','Raymond Griffiths','Dean Whatton','George Appleby','Lasco Atkins','Javone Prince','Chris Cowlin','Dustin Demri-Burns','Nick Mohammed','Keith Chegwin','Kerry Godliman','Lee Nicholas Harris','Mark Roper','Val Kilmer','Rob Jarvis','Colin Hoult','Scarlett Sabet','Davood Ghadami','Jo Enright','Les Dennis','Kerry Shale','Hannah Blamires'],
screenplay:['Ricky Gervais','Stephen Merchant','Warwick Davis'],
production:['Charlie Hanson'],
camera:['Martin Hawkins'],
cut:['Richard Halladey'],
scenography:['Anna Higginson','Mel Thompson'],
masks:['Ann Fenton'],
costumes:['Amanda Monk']},
{title:"JoJo's Bizarre Adventure",
titleCZ:'JoJova prazvláštní dobrodružství',
year:2012,
runtime:'79h 10min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy'],
director:["Ken'iči Suzuki",'Naokacu Cuda','Masaši Abe','Tošijuki Kató','Jukio Nišimoto','Džiró Fudžimoto','Hirofumi Ogura','Jasuhiro Kimura','Hideja Takahaši','Naomi Nakajama','Daisuke Čiba','Kacuiči Nakajama','Tacuma Minamikawa','Hikaru Murata','Kóta Okuno','Masaja Sasaki','Šunsuke Mačitani','Júta Takamura','Hitomi Ezoe','Satoši Ósedo','Eiiči Kubojama','Šigacu Jošikawa','Jasuo Edžima','Hirokazu Jamada','Takahiro Madžima','Šingo Učida','Kazuo Nogami','Šigeki Awai','Tomohiro Furukawa','Takahiro Kamei','Kentaró Fudžita','Naoko Takeiči','Fumihiro Ueno','Kunihiro Mori','Jošihiro Mijadžima','Tóru Hasutani','Šingo Tanabe','Jošiko Mikami','Kendži Takahaši','Tóru Hamasaki','Daiši Kató','Tošihiko Masuda','Jasuhiro Minami','Keisuke Nišidžima','Eri Osada','Taizó Jošida','Kacumi Terahigaši','Júsuke Kubo','Taisuke Mamori','Rei Nakahara','Sóiči Šimada'],
actors:['Takehito Kojasu','Kazujuki Okicu','Tomokazu Sugita','Akio Ócuka','Acuko Tanaka','Ajako Kawasumi','Kendžiró Cuda','Tamio Óki','Jošicugu Macuoka','Tošijuki Morikawa','Šóto Kašii','Tadaši Mijazawa','Jumiko Kobajaši','Takahiro Sakurai','Hiroši Naka','Rei Sakuma','Aja Endó','Ai Kakuma','Kódži Takeda','Júiči Iguči','Kazuhiko Inoue','Nobuo Tobita','Tecu Inada','Kendži Nomura','Džin Jamanoi','Joku Šioja','Naomi Kusumi','Júsuke Kuwahata','Satoši Curuoka','Hidetoši Nakamura','Jutaka Nakano','Tóru Ókawa','Acuši Imaruoka',"Ken'ičiró Macuda",'Rjóta Asari','Takuja Sató','Jódži Ueda','Aja Hisakawa','Teššó Genda','Takuja Kirimoto','Kinrjú Arimoto','Hidenobu Kiuči','Reiko Takagi','Ajumi Fudžimura','Sacuki Jukino','Motomu Kijokawa','Rie Kugimija','Šindži Kawada','Kenta Mijake','Anri Kacu','Daisuke Ono','Reiko Suzuki','Ajumi Cunemacu','Ikumi Nakagami','Ajaka Suwa','Kacumi Čó','Jó Taiči','Daisuke Hirakawa','Daisuke Kišio','Unšó Išizuka','Čó','Júma Učida','Šizuka Išigami','Júko Kaida','Saori Óniši','Šó Hajami','Šunsuke Takeuči','Júki Kuwahara','Masaja Onosaka','Motoko Kumai','Jasunori Macumoto','Kengo Kawaniši','Nacumi Takamori',"Džun'iči Janagita",'Bandžó Ginga','Džuri Kimura','Misato Fukuen','Gó Šinomija',"Džun'iči Suwabe",'Tóru Sakurai','Reina Ueda','Hibiku Jamamura','Hidenari Ugaki','Tóru Nara','Tomojuki Šimura','Megumi Tojoguči','Hana Takeda','Makoto Išii','Rina Sató','Tokujoši Kawašima','Šótaró Morikubo','Jú Šimamura','Taeko Kawata','Kacuhisa Hóki','Hiroki Šimowada',"Džun'ja Enoki",'Daiki Jamašita','Kenšó Ono','Júiči Nakamura','Kósuke Toriumi'],
basedOn:['Hirohiko Araki'],
screenplay:['Kazujuki Fudejasu','Jasuko Kobajaši',"Ken'iči Suzuki",'Šógo Jasukawa',"Šin'iči Inozume",'Naokacu Cuda','Akira Horiuči'],
production:['Hiroyuki Omori','Džun Fukuda'],
music:['Júgo Kanno','Taku Iwasaki','Hajato Macuo'],
camera:['Kazuhiro Jamada','Naoki Jorozu'],
cut:['Kijoši Hirose'],
sound:['Jošikazu Iwanami'],
scenography:["Šun'ičiró Jošihara",'Keito Watanabe','Jumiko Kirimoto']},
{title:'Pod horou',
titleCZ:'Pod horou',
year:1982,
runtime:'3h 13min',
episodeRuntime:'24-25min',
countries:['New Zealand'],
genres:['Family','Thriller','Sci-Fi'],
director:['Chris Bailey'],
actors:['Kirsty Wilkinson','Lance Warren','Roy Leywood','William Ewens','Glynis McNicoll','Noel Trevarthen','Roy Billing','Bill Johnson','Annie Whittle'],
basedOn:['Maurice Gee'],
screenplay:['Ken Catran'],
production:['Tom Finlayson'],
music:['Bernie Allen'],
cut:['Harley Oliver'],
sound:['Neil Newcombe'],
scenography:['Robert Gillies'],
masks:['Bernie McKay','Jill Mills'],
costumes:['Barbara Darragh']},
{title:'My Girlfriend Is a Nine-Tailed Fox',
titleCZ:'Nae yeojachinguneun gumiho',
year:2010,
runtime:'17h 10min',
episodeRuntime:'62-67min',
countries:['South Korea'],
genres:['Comedy','Fantasy','Romance'],
director:['Seong-cheol Boo'],
actors:['Min-ah Shin','Seung-gi Lee','Min-woo No','Soo-jin Park','Dong-il Seong','Hee-bong Byeon','Yoo-seon Yoon','Hyomin','Hong-gi Lee','Yu-jin Kim','Hyeon-shik Lim','Ji-yeong Kim','Ho-chang Kim','Soo-geun Lee','Tae-woo Lee','Yu-Seon Yun'],
screenplay:['Mi-ran Hong','Jeong-eun Hong']},
{title:'Muži na křídlech',
titleCZ:'Muži na křídlech',
year:1978,
runtime:null,
episodeRuntime:'6x55min',
countries:['France','Germany','Switzerland','Belgium'],
genres:['Adventure'],
director:['Claude Boissol'],
actors:['Gernot Endemann','Friedrich von Thun','Bernard-Pierre Donnadieu','Michael Hinz','François Leccia','Philippe Brigaud','Gérard Hernandez','Pierre Doris','Félix Marten','Christine Laurent','Fred Personne','Jean-Claude Dauphin','Max Amyl','Jean-Marc Thérin','Vincent Grass','Alain Floret','Jacques Disses','Alexander Radszun','Philippe Jourde','Guy Dhers','Nicole Desailly','Georges Lucas','Erick Desmarestz','Georges Caudron','Jean-Claude Lecas','Bruno Pradal','Max Mégy','Georges Beauvilliers','Franz Rudnick','Bernard Tiphaine','Gérard Couderc','Marie-Claude Rauzier','Ulli Philipp','Suzanne Gabriello','Ekkehardt Belle','Philippe Chauveau'],
screenplay:['Jean-Louis Lignerat','Pierre Pelegri'],
music:['Jack Arel'],
camera:['Guy Suzuki'],
scenography:['Jean Mandaroux']},
{title:'Video Game High School',
titleCZ:'Video Game High School',
year:2012,
runtime:null,
episodeRuntime:'9x11-22min',
countries:['USA'],
genres:['Action','Romance','Sci-Fi'],
director:['Freddie Wong','Brandon Laatsch','Matthew Arnold'],
actors:['Johanna Braddy','Ellary Porterfield','Arden Cho','Jimmy Wong','Brian Firenzi','Rocky Collins','Anna Ross','Debby Gerber','Shira Lazar','Joanna Sotomura','Allison Mattox','Cynthia Watros','Anastasia Roark','Dartanian Sloan','Nathan Kress','Michael Rousselet','Jon Salmon','Burnie Burns','Elizabeth Greer','Justine Ezarik','Brandon Laatsch','John Ennis','Tara Macken','Maria Del Carmen','Josh Duvendeck','Ashton Moio','Wesley Chan','Tristan Bailey','Kara Petersen','Anthony Alabi','Aaron Braxton','Jon Karmen','Sherilyn Henderson','Riley Rose Critchlow','Ethan Newberry','Brennan Murray','Matthew Arnold'],
screenplay:['Brian Firenzi','Sarah Tarkoff','Matthew Arnold'],
music:['Igor Nemirovsky'],
camera:['Jon Salmon'],
scenography:['Rachel Myers','Ryan Martin','Kaitlynn Wood'],
masks:['Henry Sanchez'],
costumes:['Layne McGovern']},
{title:'The Ellen Show',
titleCZ:'The Ellen Show',
year:2001,
runtime:null,
episodeRuntime:'18x30min',
countries:['USA'],
genres:['Comedy'],
director:['Andrew D. Weyman','Andy Ackerman'],
actors:['Ellen DeGeneres','Cloris Leachman','Martin Mull','Emily Rutherfurd','Diane Delano','Susan Walters','Reggie Lee','John Francis Daley','John Ritter','Helen Mirren','Josh Zuckerman','Betty White','Larry Joe Campbell','Jim Gaffigan','Maureen McCormick','Tom Poston','Kerri Kenney','Todd Giebenhain','James Patrick Stuart','Jan Hoag','Meryl Streep','Julia Roberts','Anna Kendrick','Vanessa Hudgens','Johnny Depp','Gwyneth Paltrow','Diane Keaton','Ashton Kutcher','Seán Cullen','Stephanie Erb','Jennifer Irwin','Patience Cleveland','Wayne Wilderson','Michael Blieden','Jennie Pegouskie','John Farley','Jill Talley','Christopher Darga','Susan Yeagley','Herb Ritts','Regan Burns','Bonnie Hellman','Adore Delano','Marissa Jaret Winokur','Carson Daly','Rhyon Nicole Brown','Susan Diol','Fred Sanders','Peter M. Gurski','Vance DeGeneres','Judy Nazemetz','Suzanne Kent','Ashley Gardner','Lauri Johnson'],
screenplay:['Rob LaZebnik','Mitchell Hurwitz','Ric Swartzlander','Jim Gerkin'],
production:['Andy Ackerman','Suzy Mamann-Greenberg'],
music:['David Schwartz','Alvaro Morello'],
camera:['Wayne Kennan','Chuy Elizondo','George La Fountaine Sr.'],
cut:['Peter D. Beyt','Pam Marshall','Skip Collector'],
sound:['Charlie McDaniel','John Bickelhaupt','Craig Porter','Kathy Oldham','Michael T. Gannon'],
scenography:['Michael Hynes','Glenda Rovello','Melinda Ritz'],
masks:['David Cox','Michele Teleis-Fickle','Bruce Grayson','Elizabeth Cooper Smokler','Eileen C. Bugnitz'],
costumes:['Lori Eskowitz-Carter','Judith Brewer Curtis']},
{title:'Bezvadná dvojka',
titleCZ:'Bezvadná dvojka',
year:2007,
runtime:null,
episodeRuntime:'10h25min',
countries:['Japan'],
genres:['Animation','Comedy','Romance'],
director:['Hiroši Fukutomi','Kónosuke Uda','Jasuo Iwamoto','Fukasawa Tošinori'],
actors:['Akemi Okamura',"Džun'iči Suwabe",'Kendžiró Cuda','Masaja Onosaka','Juki Macuoka','Aki Tojosaki','Kazunari Tanaka','Kjóko Hikami','Majumi Šó','Kae Araki','Jošikazu Nagano','Masaši Hirose','Sacuki Jukino','Kazuja Ičidžó','Jasuhiko Tokujama','Daisuke Kirii','Eri Nakao','Mičijo Janagisawa',"Kijomicu Mizu'uči",'Rie Nakagawa','Hiroki Šimowada','Fudžiko Takimoto','Kokoro Kikuči','Marie Mijake','Joširó Macumoto','Satoši Taki','Jóko Nišino','Madoka Jonezawa','Kumiko Itó','Eri Jasui','Šintaró Nakano','Kóiči Nagano','Saori Higaši','Kazuko Kodžima','Mari Adači','Kazunari Kodžima','Nobuhisa Okazaki'],
basedOn:['Aja Nakahara'],
screenplay:['Takaši Jamada','Jóiči Takahaši','Isao Murajama','Mio Inoue','Jumi Kagejama'],
production:['Hiromi Seki'],
music:['Hironosuke Sato'],
cut:['Masahiro Gotó'],
scenography:['Eiko Sawada','Jukiko Iidžima']},
{title:'ReBoot',
titleCZ:'Reboot',
year:1994,
runtime:'18h 48min',
episodeRuntime:'24min',
countries:['Canada'],
genres:['Action','Adventure','Animation','Comedy'],
director:['Owen Hurley','Nicholas Kendall','Michael Robison','Dick Zondag','Ezekiel Norton','Ian Pearson','Steve Ball','Stephen Cooper'],
actors:['Michael Donovan','Kathleen Barr','Garry Chalk','Michael Benyaer','Paul Dobson','Jesse Moss','Tony Jay','Giacomo Baessato','Andrew Kavadas','Cathy Weseluck','Judith Maxie','Philip Maurice Hayes','Ian James Corlett','Janyse Jaud','Sharon Alexander','Gavin Blair','Long John Baldry','Scott McNeil','Stevie Vallance','Danny McKinnon','Christopher Gray'],
screenplay:['Raul Inglis','Brendan McCarthy','D.C. Fontana','Marv Wolfman','Christy Marx','Ian Pearson','Mark Edward Edens','Len Wein','Steve Ball','Dan DiDio','Katherine Lawrence','Jono Howard'],
production:['Ian Pearson'],
music:['Robert Buckley'],
cut:['Sylvain Blais','Patrick Carroll'],
sound:['Marcel Duperreault','Greg Stewart'],
scenography:['Chris Bartleman']},
{title:'Gallipoli',
titleCZ:'Gallipoli',
year:2015,
runtime:'6h 2min',
episodeRuntime:'46-81min',
countries:['Australia'],
genres:['Drama','War'],
director:['Glendyn Ivin'],
actors:['Kodi Smit-McPhee','Tom Budge','James Callis','John Bach','Nicholas Hope','Matt Nable','Leon Ford','Lincoln Lewis','John Lloyd Fillingham','Nicholas Hammond','Lachy Hulme','Justine Clarke','Andy McPhee','Shane Briant','Grant Bowler','Dan Wyllie','Damon Gameau','Gracie Gilbert','Ian Bliss','Sapidah Kian','Sam Parsonson','Tristan Barr','Ashleigh Cummings','Micheal Doonan','Anthony Hayes','Jacob Collins-Levy','John Brumpton','Jeremy Lindsay Taylor','Dion Williams','David Cormick','Coşkun Erdem','Harry Greenwood','Sotiris Tzevelekos','Hugh Parker','Stephen Ballantyne','James Stewart','Tuğrul Dilhan Arslan','Anthony Phelan','Colin Moody','Jim Daly'],
basedOn:['Les Carlyon'],
screenplay:['Christopher Lee'],
production:['Imogen Banks','John Edwards'],
music:['Stephen Rae'],
camera:['Germain McMicking'],
cut:['Deborah Peart'],
sound:['Roger Van Wensveen'],
scenography:['Josephine Ford'],
masks:['Chiara Tripodi'],
costumes:['Cappi Ireland']},
{title:'The Line',
titleCZ:'Lajna',
year:2017,
runtime:'9h 32min',
episodeRuntime:'21-26min',
countries:['Czechia'],
genres:['Comedy'],
director:['Vladimír Skórka'],
actors:['Jiří Langmajer','Zdeněk Piškula','Norbert Lichý','Hana Vagnerová','Petra Špindlerová','Pavla Dostálová','Josef Kaluža','Marek Taclík','Václav Neužil ml.','Kateřina Janečková','Jaromír Jágr','Štěpán Kozub','Barbora Kocmánková','Daniel Seman','Michal Škoda','Jiří Sedláček','Julie Štandera','Daniel Strejc','Vladimír Skórka','Petr Bednář','Michaela Kotková','Albert Čuba','Jiří Konečný','Dominik Hašek','David Viktora','Martin Papesch Huleja','Patrik Děrgel','Tomáš Dastlík','Daniel Mavrov','Petr Kubala','Andrea Daňková','Igor Bareš','Michal Suchánek','Stanislav Šárský','Tereza Vilišová','Lukáš Adam','Milan Cimerák','Leo Gudas','Matěj Hasil','Maxim Havrda','Věra Hlaváčková','Ondřej Holý','Damián Hradil','Martin Hucl','Ezy Hýbl','Jakub Janča','Radim Jíra','David Joska','Jiří Kohout','Tomáš Kořének','Dáša Kouřilová','Lukáš Křenek','Jan Klíma','Julie Langmajerová','Ondřej Malina','Patrik Martinec','Květa Mazurová','Petr Melovič','Alan Novotný','Josef Němeček','Alan Ryšavý','Natálie Řehořová','Jiří Schott','Jiří Smeykal','Martin Šimíček','Luděk Šnajdar','Milan Tomeš','Jaroslav Šutara','Roman Blumaier','Tomáš Turek','Peter Kočiš','Michal Isteník','Maroš Kramár','Sára Rychlíková','Hana Gregorová','Matúš Beniak','Andrej Polák','Roman Mrázik','Peter Brajerčík','Ľuboš Kostelný','Martin Veliký','Tomáš Dianiška','Ľubomír Paulovič','Petr Vydra','Peter Martinček','Radka Pavlovčinová','Nikola Ďuricová','Zuzana Stavná','Jaromír Bosák','Petr Franěk','David Mašek','Jan Janča','Štefan Martinovič','Jan Řezníček','Jiří Panzner','Ondřej Hampl','Terezie Vraspírová','Marek Holý','Branislav Deák','Tomáš Měcháček'],
screenplay:['Petr Kolečko'],
production:['Kamil Ouška','Daniel Strejc','Rudolf Merkner','Martin Tošenovský','Ivan Mikula','Zuzana Konrádová'],
music:['Jiří Burian'],
camera:['Jan Šťastný'],
cut:['Matěj Jankovský','Daniel Trögler','Šimon Hájek'],
sound:['Filip Šnajdr','Petr Janoš','Nikola Barabášová'],
scenography:['Ondřej Turoň','Helena Jiskrová','Petr Kundrát'],
masks:['Petronela Bátorová','Linda Dihn Hai Trieu','Jana Hamová','Michaela Kotková','Petra Trejbalová','Aneta Boháčová','Kamila Jarišová'],
costumes:['Natálie Bernard','Jitka Stauder','Jarmila Dunděrová','Veronika Moudrá','Iva Rašková']},
{title:'Jack Holborn',
titleCZ:'Jack Holborn',
year:1981,
runtime:'4h 59min',
episodeRuntime:'46-52min',
countries:['New Zealand','Germany'],
genres:['Adventure'],
director:['Sigi Rothemund'],
actors:['Patrick Bach','Matthias Habich','Andreas Mannkopff','Monte Markham','Terence Cooper','Frano Lasic','Ljiljana Krstič','Miodrag Krstovič','Stevo Petrovic','Heinz Wanitschek','Franz Blauensteiner','Jovan Janićijević Burduš','Jeremy Stephens','David Weatherley','Brian Flegg','Dušan Janićijević','Zoran Pokupec','Patrick Smyth'],
basedOn:['Leon Garfield'],
screenplay:['Justus Pfaue','Sigi Rothemund'],
production:['Bernd Burgemeister','Dieter Graber','Joachim G. Staab','Jack George'],
music:['Christian Bruhn'],
camera:['Rolf Liccini'],
cut:['Heidrun Berktold','Michael Johns'],
sound:['Heinz Dittlein'],
scenography:['Wolf Witzemann'],
masks:['Hasso von Hugo','Karin Bauer-Hurst'],
costumes:['Nikola Hoeltz']},
{title:'The Same Sky',
titleCZ:'Pod jedním nebem',
year:2017,
runtime:'4h 30min',
episodeRuntime:'90min',
countries:['Germany'],
genres:['Drama'],
director:['Oliver Hirschbiegel'],
actors:['Sofia Helin','Tom Schilling','Friederike Becht','Ben Becker','Hannes Wegener','Patricie Soukupová','Jascha Rust','Claudia Vašeková','Stephanie Amarell','Godehard Giese','Anja Kling','Claudia Michelsen','Daniel Zillmann','Steven Brand','Max Hopp','Daniel Krejčík','Christian Kuchenbuch','Steffi Kühnert','Torsten Michaelis','Uwe Preuss','Udo Schenk','Muriel Wimmer','Jörg Schüttauf','Christian Näthe','Markéta Stehlíková','Jay DeYonker','Robert Polo','Joe Weintraub','Richard Pepper','Sára Korbelová'],
screenplay:['Paula Milne'],
production:['Benjamin Benedict','Ferdinand Dohna','Michal Pokorny','Friedemann Goez'],
music:['Walter Mair'],
camera:['Judith Kaufmann'],
cut:['Alexander Dittner'],
sound:['Thomas Neumann','Gregor Bonse'],
masks:['Tatjana Krauskopf','Isabelle Neu']},
{title:'Šigacu wa kimi no uso',
titleCZ:'Šigacu wa kimi no uso',
year:2014,
runtime:'9h 10min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Drama','Music','Comedy','Psychology','Romance'],
director:['Kjóhei Išiguro','Tošimasa Išii','Kosaja','Ajako Kóno','Takahiro Kawakoši','Kazuja Iwata','Takahiro Madžima','Takahiro Harada','Hidetoši Takahaši'],
actors:['Nacuki Hanae','Risa Taneda','Ai Kajano','Mamiko Noto','Acuko Tanaka','Stephanie Sheh','Minako Kotobuki','Jukiko Morišita','Ari Ozawa','Inori Minase','Júko Iida','Šizuka Išigami','Genki Muro','Nobuo Tobita','Fujuka Óura','Sóma Saitó','Ajane Sakura','Kazujuki Okicu','Naomi Šindó','Harumi Sakurai','Jumi Kakazu','Šunzó Mijasaka','Činami Hašimoto','Saori Hajami','Rie Takahaši','Ajaka Asai','Mika Kanda','Júma Učida','Rjóta Ósaka','Kanehira Jamamoto','Júsuke Kobajaši',"Džun'iči Janagita",'Juka Terasaki','Haruki Išija','Tóru Ókawa','Makoto Furukawa','Marika Kóno','Nana Hamasaki',"Džun'ja Enoki",'Acuši Kósaka','Kana Júki','Hirojuki Kagura','Kótaró Nišijama','Airi Ócu','Maria Naganawa','Daiki Hamano','Mie Sonozaki','Masumi Tazawa','Kóhei Amasaki','Šína Nacukawa','Eidži Takeuči','Daiči Hajaši','Taiši Murata','Eri Suzuki','Tomo Muranaka','Hiromiči Tezuka','Rjúiči Kidžima','Mariko Higašiuči','Ikudži Nose','Masaši Nogawa','Haruka Jamazaki','Jukitoši Kikuči','Rjóko Maekawa','Marie Mijake','Mari Hino','Ruriko Aoki','Minami Takahaši','Hitomi Ówada','Manami Tanaka','Naoko Komacu','Takacugu Awazu','Čitose Morinaga','Kanako Sakuragi','Júki Kadži','Ben Hiura','Džun Inoue','Micutoši Šundó','Kjó Jaoja','Kazumasa Nakamura','Miho Wataja','Ajaka Suwa','Akinori Egoši','Nao Fudžita','Šinobu Macumoto','Juna Jošino','Fumija Kosugi','Júki Išikari','Acuko Juja','Megumi Okada','Rie Murakawa','Takuma Nagacuka','Riiko Tazawa','Tomoko Cuzuki','Daisuke Nagumo','Ai Kakuma','Kenta Sasa','Takumi Watanabe','Jó Taiči','Júki Jonai','Takanori Ójama'],
basedOn:['Naoši Arakawa'],
screenplay:['Takao Jošioka'],
production:['Makoto Kimura'],
music:['Masaru Jokojama'],
camera:['Keisuke Nozawa','Jošihiro Sekija'],
cut:['Akinori Mišima'],
sound:['Džin Aketagawa'],
scenography:['Hisajo Usui']},
{title:'The Bonfire of Destiny',
titleCZ:'Osudná jiskra',
year:2019,
runtime:'6h 45min',
episodeRuntime:'48-56min',
countries:['France','Belgium'],
genres:['Drama','History'],
director:['Alexandre Laurent'],
actors:['Audrey Fleurot','Julie De Bona','Camille Lou','Gilbert Melki','Josiane Balasko','Florence Pernel','Théo Fernandez','Victor Meutelet','François-David Cardonnel','Stéphane Guillon','Aurélien Wiik','Gilles Cohen','Sacha Pinault','Sylvain Dieuaide','Nicky Marbot','Julien Drion','Eric Pucheu','Laurent Claret','Guillaume Briat','José Fumanal','Mathieu Lourdel','Antoine Duléry','Cali DiCapo','Lucien Dodge','Ellen Dubin','Todd Haberkorn','Tammy Klein','Mike Quirk','Philece Sampler','Stephanie Sheh','John Short','Frank Todaro','Caroline Tillette','Roxane Arnal','Ivan Heidsieck','Lisa Livane','Swan Demarsan','Adèle Galloy','Christine Paolini','Lilas-Rose Gilberti-Poisot','Satya Dusaugey','Philippe Spiteri','Julien Sarazin','Armand Eloi','Patrice Tepasso','Rose de Kervenoaël'],
screenplay:['Catherine Ramberg','Karin Spreuzkouski'],
production:['Iris Bucher'],
music:['François Liétout'],
camera:['Jean-Philippe Gosselin'],
cut:['Jean de Garrigues','Emmanuel Douce'],
sound:['Mark Ettel'],
scenography:['Hervé Gallet'],
masks:['Yumiko Oka'],
costumes:['Valérie Adda']},
{title:'Parlement',
titleCZ:'Parlament',
year:2020,
runtime:'12h 24min',
episodeRuntime:'20-29min',
countries:['Belgium','France','Germany'],
genres:['Comedy'],
director:['Noé Debré','Amélie Bonnin','Jérémie Sein','Émilie Noblet'],
actors:['Xavier Lacaille','Liz Kingsman','Philippe Duquesne','William Nadylam','Georgia Scalliet','Johann von Bülow','Lucas Englander','Elina Löwensohn','Niccolò Senni','Anaïs Parello','Christiane Paul','Carole Weyers','Bruno Georis','Aurora Marion','Nagisa Morimoto','Georges Siatidis','Elvira Tröger','Jean-Benoît Ugeux','Koen Van Impe','Jonathon Sawdon','Jane Turner','Renaud Rutten','Martina Eitner-Acheampong','Gustaf Hammarsten','Luis Rego','Stefan Roschy','Ulrich Brandhoff','Paul Delbreil','Ana Rodriguez'],
screenplay:['Noé Debré','Mareike Engelhardt','Andrew Bampfield','Daran Johnson'],
production:['Fabienne Servan-Schreiber','Dagmar Rosenbauer','Jan Diepers','Thomas Saignes'],
music:['François Clos','Julie Roué'],
camera:['Brice Pancot'],
cut:['Mathieu Toulemonde','Baptiste Ribrault'],
costumes:['Charlotte Lebourgeois']},
{title:'Initial D Fifth Stage',
titleCZ:'Initial D Fifth Stage',
year:2012,
runtime:'6h 18min',
episodeRuntime:'27min',
countries:['Japan'],
genres:['Animation','Romance','Sport'],
director:['Micuo Hašimoto','Masajuki Macumoto','Taidži Kawaniši','Šú Watanabe','Osamu Sekita','Kacujuki Kodera','Taiki Nišimura'],
actors:["Šin'ičiró Miki",'Takehito Kojasu','Tomokazu Seki','Kazuja Nakai','Micuo Iwata','Unšó Išizuka','Wataru Takagi','Júiči Nakamura','Nobutoši Kanna','Aja Endó','Anri Kacu','Jasunori Macumoto','Kacujuki Koniši','Nobujuki Hijama','Jumi Kakazu','Hiroki Tóči','Rjókiči Takahaši','Saori Hajami','Kósuke Okano','Rintaró Niši','Osamu Hosoi','Kinrjú Arimoto','Júja Murakami','Šúhei Sakaguči','Rjóta Asari','Hiroki Maeda','Hidenobu Kiuči','Naoko Sugiura','Masajuki Omoro','Hirokazu Miura','Júka Hirose','Kazuki Jao','Jasujuki Kase','Megumi Sató','Kendži Hamada','Acuši Abe','Mičiko Neja'],
basedOn:['Šúiči Šigeno'],
screenplay:['Nobuaki Kišima'],
production:['Kajo Fukuda'],
music:['Acuši Umebori'],
camera:['Šindži Ikegami'],
cut:['Šindži Kofukada'],
sound:['Masafumi Mima'],
scenography:['Nobuto Sakamoto']},
{title:'The Pillars of the Earth',
titleCZ:'Pilíře Země',
year:2010,
runtime:'7h 9min',
episodeRuntime:'48-57min',
countries:['Canada','Germany','UK'],
genres:['Drama','History','Romance','Thriller'],
director:['Sergio Mimica-Gezzan'],
actors:['Ian McShane','Matthew Macfadyen','Eddie Redmayne','Hayley Atwell','Sarah Parish','Natalia Wörner','Anatole Taubman','John Pielmeier','Robert Bathurst','Clive Wood','Sam Claflin','Liam Garrigan','Skye Lourie','David Oakes','Götz Otto','Alison Pill','Skye Bennett','Kate Dickie','Rufus Sewell','Donald Sutherland','István Szori','Ken Follett','Gordon Pinsent','Tony Curran','Douglas Booth','Féodor Atkine','Freddie Boath','Matt Devere','Piroska Molnár','Tatiana Szalay','Jonathan Coy','David Haderer','Virág Bárány','Péter Horkay','David Bark-Jones','Romana Carén','Jody Halse','Lisa Millett','Zsófi Trecskó','László Áron','Ottilia Borbáth','Antal Czapkó','Kevin Griffiths','Máté Haumann','Ákos Horváth','Barna Illyés','Csaba Jakab','Mike Kelly','Péter Kertész','Bernadett Kis','László Konter','Alexis Latham','Antal Leisen','Péter Linka','Pál Makrai','George Mendel','Tibor Pintér','Margaréta Szabó','Sándor Téri','Tamás Varga','András Várkonyi','Mark C. Phelan','Zsolt Zágoni','Marcel Závodi','Miklós Pável'],
basedOn:['Ken Follett'],
screenplay:['John Pielmeier'],
production:['John Ryan'],
music:['Trevor Morris'],
camera:['Attila Szalay'],
cut:['Richard Comeau','Sylvain Lebel'],
scenography:['Miljen Kreka Kljakovic'],
masks:['Loulia Sheppard','Kathy Kelso'],
costumes:['Mario Davignon']},
{title:'Utopia',
titleCZ:'Utopia',
year:2013,
runtime:'10h 21min',
episodeRuntime:'48-62min',
countries:['UK'],
genres:['Drama','Mystery','Thriller','Sci-Fi'],
director:['Marc Munden','Alex Garcia Lopez','Wayne Yip','Samuel Donovan'],
actors:["Fiona O'Shaughnessy",'Alexandra Roach','Nathan Stewart-Jarrett','Adeel Akhtar','Paul Higgins','Oliver Woollford','Neil Maskell','James Fox','Geraldine James','Stephen Rea','Emilia Jones','Anna Madeley','Alistair Petrie','Simon McBurney','Michael Smiley','Rose Leslie','Paul Ready','Anca-Ioana Androne','Trystan Gravelle','Eleanor Matsuura','Jennifer Hennessy','Velile Tshabalala','Pixie Davies','Clive Wood','Michael Yare','Michael Maloney','Kevin Trainor','Sacha Dhawan','Ian McDiarmid','Ed Birch','Oliver Dimsdale','Ruth Gemmell','Mitchell Mullen','Paul Bergquist','Patricia Winker','Diane Morgan','David Quilter','Gregory Caine','Paapa Essiedu','Martin McDougall','Juliet Cowan','Sarah Churm','David Calder','David Sibley','Hermione Gulliford','Ben Bishop','Bruce Mackinnon','Mark Stobbart','Peter Rowley','Will Attenborough','Emma-Louise Wilson','Alan Williams','Joshua James','Lloyd Hutchinson','Ṣọpẹ Dìrísù','Steve Mouzakis','Gerard Monaco','James Boyland','Simon Farnaby','Danny Kirrane','Diana Hardcastle','Tom Burke','Tim McInnerny','Kevin Eldon','Sylvestra Le Touzel','Allan Corduner','Corey Johnson','Emil Hostina','Steven Robertson','Matthew Steer','Dan Tetsell','Micah Balfour','John Voce','Gavin Spokes','Alan Bentley'],
screenplay:['John Donnelly','Dennis Kelly'],
music:['Cristobal Tapia de Veer'],
camera:['Ole Bratt Birkeland','Lol Crawley'],
cut:['Luke Dunkley','Ben Lester','David Charap'],
sound:['Richard Davey','Alessio Masi'],
scenography:['Kristian Milsted','Simon Rogers','Bronwyn Franklin','Elaine McLenachan'],
masks:['Emma Scott','Holly Bliss','Vickie Lang','Dan Martin'],
costumes:['Marianne Agertoft']},
{title:'The Twelve',
titleCZ:'Dvanáct',
year:2019,
runtime:'8h 2min',
episodeRuntime:'46-55min',
countries:['Belgium'],
genres:['Drama','Thriller'],
director:['Wouter Bouvijn'],
actors:['Luc De Ruelle','Maaike Neuville','Tom Vermeir','Peter Gorissen','Zouzou Ben Chikha','Piet De Praitere','Maaike Cafmeyer','Josse De Pauw','Mieke De Groote','Isabelle van Hecke','Souad Boukhatem','Aimé Claeys','Bart Claeys','Lore Dejonckheere','Werner Gielis','Veerle Malschaert','Emin Mektepli','Anne-Mieke Ruyten','Estelle Sys','Marijke Van Der Kelen','Koen Van der Sande','Lino van Reeth','Lynn Van Royen','Bram Verrecas','Charlotte De Bruyne','Johan Heldenbergh','Koen De Sutter','Sophie Decleir','Filip Hellemans','Anne Van Hoorick','Greet Verstraete','Nils De Caster','Sara Vertongen','Bart Slegers','Dominique Van Malder','Titus De Voogdt','Sofia Ferri','Nele Bauwens','Spencer Bogaert','Frank Vercruyssen','Sachli Gholamalizad','Gilles De Schryver','Mungu Cornelis','Ann Bellemans','Jean Caufrier','Celest Henri Cornelis','Louise De Bisscop','Cécile Enthoven','Roman Olaf Enthoven','Myrthe Van Der Mark','Jolente De Keersmaeker','Filip Jordens','Gert Van Boxel','Amara Reta','Marie Bertrands','William Boeva','Aminata Demba','Wim Willaert','Gilles Coulier','Servet Duran','Dries Delputte','Christel Domen','Lucas Tavernier','Janne Desmet'],
screenplay:['Sanne Nuyens','Bert Van Dael'],
production:['Peter Bouckaert'],
music:['David Martijn','Jeroen Swinnen'],
camera:['Dries Delputte'],
cut:['Bert Jacobs','Pieter Smet'],
sound:['Matthias Hillegeer'],
scenography:['Philippe Bertin'],
masks:['Charlotte Blommaert'],
costumes:['Isabel Van Renterghem']},
{title:'Julie and the Phantoms',
titleCZ:'Julie and the Phantoms',
year:2020,
runtime:'5h 9min',
episodeRuntime:'24-60min',
countries:['USA'],
genres:['Comedy','Family','Musical'],
director:['Kabir Akhtar','Paul Becker','Kristin Hanggi'],
actors:['Charlie Gillespie','Jadah Marie','Savannah Lee May','Marci T. House','Madison Reyes','Taylor Kare','Sonny Bustamante','Victoria Caro','Kyra Leroux','Sacha Carlson','Sofia Khachi','Owen Joyner','Booboo Stewart','Steve Bacic','Alison Araya','Cheyenne Jackson','Carlos Ponce','Jeremy Shada','Michael P. Northey','Vicky Lambert','Halle Gall'],
basedOn:['Elise Primavera'],
screenplay:['Tiffany Paulsen','Sean William Cunningham','Marc Dworkin'],
production:['Jameson Parker'],
music:['David Lawrence'],
camera:['Jon Joffin'],
cut:['Don Brochu'],
sound:['David E. Fluhr','Sandra Portman','Gabriel J. Serrano'],
scenography:['Mark Hofeling','Lisa Lancaster','Michael Norman Wong','Jonathan Lancaster'],
costumes:['Soyon An']},
{title:'Deurim hai',
titleCZ:'Deurim hai',
year:2011,
runtime:'35h 15min',
episodeRuntime:'62-70min',
countries:['South Korea'],
genres:['Comedy','Romance','Drama'],
director:['Eung-bok Lee','Seong-yoon Kim','Wan-il Mo'],
actors:['Soo-hyeon Kim','Suzy Bae','Taecyeon','Eun-jeong Ham','Wooyoung','IU','Hyun-joong Kim','Il-hwa Choi','Ki-joon Um','Yong-joon Bae','Yoon-ji Lee','Hyeok-kwon Park','Chansung','Byeong-joon Lee','Eun-bin Park','Won-kil Baek','Kil-kang Ahn','Seon-young Ahn','Seo-hyeon Ahn','Seulong','Jutaka Kobajaši','Bo-reum Han','Yeong Ah','Noo-ri Bae','Hee-soo Jang','Jinwoon','Changmin','Leeteuk','J. Y. Park','Eunhyuk','Fei','Ji-yoo Yoon','Kyeong-lim Park','Hye-sook Lee','Jin-young Park','Hyolyn','Yeon-joo Jeong','Hae-hyo Kwon','So-hye Kim','Jeong-tae Kim','Seo-joon Park','So-young Yoo','Jung-eui Noh','So-ra Kang','Kahi','Ji-yeon Park','Yeo-jin Choi','Ye-eun Park','Jinyoung','PSY','Hee-seok Yoon'],
screenplay:['Hye-ryeon Park','Seung-hye Heo']},
{title:'The Black Donnellys',
titleCZ:'The Black Donnellys',
year:2007,
runtime:'9h 9min',
episodeRuntime:'38-44min',
countries:['USA'],
genres:['Crime','Drama'],
director:['Paul Haggis','Deran Sarafian','Gloria Muzio','Edwin Sherin','Anthony Hemingway','Jeff F. King','T.J. Scott','Dan Lerner','David Straiton','Kevin Bray','Daniel Minahan','Bobby Moresco'],
actors:['Jonathan Tucker','Tom Guiry','Olivia Wilde','Billy Lush','Michael Stahl-David','Kirk Acevedo','Keith Nobbs','Peter Greene','Brian Tarantina','Patrick Brennan','Betsy Beutler','Nick Damici','Robert Clohessy','Bill Sorice','Richard Topol','Kevin Corrigan','Kevin Conway','Michael Rispoli','Lauren Bittner','Wass Stevens','Bridget Regan','Christopher Shand','Elizabeth Regen','Peter Gerety','James Badge Dale','Zach Shaffer','Salvatore Inzerillo',"Joe D'Onofrio",'Geoffrey Wigdor','William Sadler','Elizabeth Gillies','John Cenatiempo','Sonny Marinelli','Patrick Holder','André Holland','Kimberly Hebert Gregory','Pablo Schreiber','Seamus Davey-Fitzpatrick','Darien Sills-Evans','Glenn Taranto','Scott Sowers','Olja Hrustic','Tom Riis Farrell','Rodrigo Lopresti','Chance Kelly','Tom Mason','Ned Eisenberg','Audrie Neenan','Che Landon','Kate Nowlin','Ray Wiederhold','Myra Lucretia Taylor','Sebastian Sozzi','Cornell Womack','Harris Doran','Brendan Bradley','Lenny Venito',"Jack O'Connell",'P.J. Sosko','Bruce MacVittie','Kathleen Doyle','Joe Flood','Bradley White','Rony Clanton','Chris Bauer','Mark Margolis','Paul Calderon','Bonnie Discepolo','Brian Donahue','Kate Mulgrew','Dick Latessa','Mason Pettit','Lou Martini Jr.','Dan Lauria','Ilene Kristen','Catia Ojeda','David Pittu','John Bolger','Kenny Marino',"Harry O'Reilly",'Khan Baykal',"Brendan O'Gorman",'Jeremy Beiler','Don Sparks',"Greg D'Agostino",'Marisa Ryan','Allan Steele','Jason Furlani','Lee R. Sellars','Patrick Noonan','Anthony Robert Grasso'],
screenplay:['Paul Haggis','Gary Lennon','Bobby Moresco','Jeff F. King','Mick Betancourt','Sean Whitesell','Kim Clements','Allan Steele'],
production:['Jim Chory','Kim Clements','James Bigwood'],
music:['Mark Isham'],
camera:['Russell Lee Fine','J. Michael Muro'],
cut:['Jo Francis','David B. Thompson','Kate Sanford'],
sound:["Andy D'Addario",'Mathew Waters','Kevin Patrick Burns','Verna Mandel','Tony Lamberti','Jon Mete','Brian Miksis','Todd Orr'],
scenography:['Rick Butler','Mila Khalevich','Jonathan Arkin'],
costumes:['Abigail Murray','Wallace G. Lane Jr.']},
{title:'Indiánske rozprávky',
titleCZ:'Indiánske rozprávky',
year:1982,
runtime:null,
episodeRuntime:'21x8min',
countries:['Czechoslovakia'],
genres:['Animation','Family'],
director:['Ludmila Zemanová','Eugen Spálený','Ladislav Vlk'],
actors:['Michal Dočolomanský'],
camera:['Zdeněk Krupa']},
{title:'The Lost Flowers of Alice Hart',
titleCZ:'Ztracené květiny Alice Hartové',
year:2023,
runtime:'6h 52min',
episodeRuntime:'51-62min',
countries:['Australia'],
genres:['Drama'],
director:['Glendyn Ivin'],
actors:['Sigourney Weaver','Alycia Debnam-Carey','Frankie Adams','Leah Purcell','Tilda Cobham-Hervey','Asher Keddie','Alexander England','Sebastián Zurita','Shareena Clanton','Alyla Browne','Charlie Vickers','Emma Lung','Andrew McFarlane','Jeremy Lindsay Taylor','Amy Kersey','Helana Sawires','Victoria Haralabidou','David Franklin','Jude Hyland','Rose Riley','Xavier Samuel','Jeremy Blewitt','Maggie Dence'],
basedOn:['Holly Ringland'],
screenplay:['Kirsty Fisher','Kim Wilson','Sarah Lambert'],
production:['Barbara Gibbs'],
music:['Hania Rani'],
camera:['Sam Chiplin'],
cut:['Dany Cooper','Deborah Peart'],
scenography:['Melinda Doring','Anthea Hodge'],
costumes:['Joanna Mae Park']},
{title:'Mamon',
titleCZ:'Mamon',
year:2015,
runtime:'5h 25min',
episodeRuntime:'50-58min',
countries:['Czechia'],
genres:['Crime','Thriller'],
director:['Vladimír Michálek'],
actors:['Matěj Hádek','Eva Leimbergerová','Gabriela Míčová','Michal Dlouhý','Tereza Hofová','Daniel Tůma','Igor Bareš','Ondřej Malý','Dušan Sitek','Pavlína Štorková','Pavel Gajdoš','Jan Novotný','Vladimír Krátký','Kateřina Burianová','Petra Jungmanová','Igor Ondříček','Martin Sitta','Petr Motloch','Jiří Vyorálek','Petr Halberstadt','Ondřej Kraus','Přemysl Bureš','Lukáš Melník','Jakub Korber','Stanislav Gerstner','Diana Toniková','Jonáš Zbořil','Tomáš Kyselka','Tereza Vilišová','Vendula Hlásková','Justin Svoboda','Monika A. Fingerová','Jitka Sluková','Jiří Beremov','Markéta Hurychová','Diana Tomanová','Arnošt Hanf','Rudolf Mareš','Marek Balho','Barbora Bobková','František Kovár','Ivan Kalina','Tereza Lášková','Viktor Muselík','Tereza Gübelová','Nela Štefanová','Marek Dobeš','Matěj Jehlík','Josef Jehlík','Veronika Lapková','Daniel Červ','Lucie Domesová','Martin Janouš','Romana Navarová','Tomáš Hurda','Jiří Mareš','Martina Pavelková','Miloš Vorel','Michal Plecitý','Radek Kašpar','Klára Coufalová','Pavel Oškrkaný','Ondřej Biravský','Michal Lurie','Jiří Šimek','Jakub Koudela','Jiří Oberfalzer','Jakub Hajner','Martin Bačkovský','Amáta Skalová','Michal Zimula','Lukáš Typlt','Hana Malaníková','Michal Čeliš','James Tratas'],
screenplay:['Štefan Titka','Iva Klestilová','Ondřej Provazník','Hynek Trojánek'],
production:['Vratislav Šlajer','Šárka Oujezdská'],
music:['Karel Havlíček'],
camera:['Martin Štrba'],
cut:['Olina Kaufmanová'],
sound:['Marek Hart','Viktor Prášil'],
scenography:['Jan Vlasák'],
masks:['Tereza Prachařová','Jan Anderle'],
costumes:['Josef Čechota']},
{title:'For All Mankind',
titleCZ:'For All Mankind',
year:2019,
runtime:'40h 5min',
episodeRuntime:'42-82min',
countries:['USA'],
genres:['Drama','Sci-Fi'],
director:['Sergio Mimica-Gezzan','Meera Menon','Andrew Stanton','Dan Liu','Seth Gordon','Allen Coulter','John Dahl','Michael Morris','Dennie Gordon','Sarah Boyd','Wendey Stanzler','Craig Zisk','Lukas Ettlin','Sylvain White','Maja Vrvilo'],
actors:['Joel Kinnaman','Wrenn Schmidt','Krys Marshall','Jodi Balfour','Shantel VanSanten','Cynthy Wu','Coral Peña','Michael Dorman','Sarah Jones','Edi Gathegi','Casey W. Johnson','Sonya Walger','Toby Kebbell','Chris Bauer','Tyner Rushing','Svetlana Jefremova','Daniel Stern','Noah Harpster','Nate Corddry','Meghan Leathers','Piotr Adamczyk','Robert Bailey Jr.','Dan Donohue','Jessica Tuck','Teya Patt','John Marshall Jones','David Chandler','Lev Gorn','Nick Toren','C.S. Lee','Arturo del Puerto','Jorge Diaz','Vera Cherny','Salvador Chacón','Lenny Jacobson','Spencer Garrett','Daniel David Stewart','Myk Watford','Moses Jones','Olivia Trujillo','Michaela Conlin','Eric Ladin','Michael Benz','Megan Dodds','Charlie Schlatter','Wallace Langham','Michael Harney','Leonora Pitts','Scott Michael Campbell','Dan Warner','Teddy Blum','Jason David','Andre Boyer','Linda Park','Rebecca Wisocky','Ellen Wroe','Daniel Robbins','Colm Feore','Cass Buggé','Jeff Branson','Brian Stepanek','Deniz Akdeniz','Ryan Kennedy','Ben Begley','Jessica Amlee','David Andrews','Jeffrey Muller','Steven Pritchard','Darin Cooper','Matt Battaglia','Edwin Hodge','Nick Wechsler','Mel Fair','Michael James Bell','James Urbaniak','Benton Jennings','John Rubinstein','David Gautreaux','Scott Alan Smith','Jeff Denton','Jan Munroe','Laura Patalano','Frank Gallegos','Margarita Reyes','Tim Jo','Nikola Djuričko','Mark Ivanir','Stephen Jared','Saul Rubinek','Laura Long','Charlie Hofheimer','Clint Culp','Ben Solenberger','Timothy Ware-Hill','Brad Beyer','Justice Leak','Kayla Blake','Alexander Neher','Irina Maleeva','Yaani King Mondschein'],
screenplay:['David Weddle','Bradley Thompson','Ben Nedivi','Matt Wolpert','Nichole Beattie','Ronald D. Moore','Stephanie Shannon','Naren Shankar','Joe Menosky','Sabrina Almeida','Andrew Black','Jovan Robinson','Kate Burns'],
production:['Huey M. Park'],
music:['Jeff Russo','Paul Doucette'],
camera:['Ross Berryman','Stephen McNutt','Karl Walter Lindenlaub'],
cut:["Michael O'Halloran",'Hibah Schweitzer','David Bilow','Miklos Wright','Justin Bourret','Nathan Gunn','Jonathan Chibnall','David Greenspan','Scott Gamzon','Dana Gasparine','Bryan Bailey'],
sound:['Adam Sawelson','Nello Torri','Karol Urban','Alan Decker','Deb Adair'],
scenography:['Dan Bishop','Seth Reed','Harry E. Otto','Mark Zuelzke'],
masks:['Taylor Bennett','Rachel Busby','Jean Webber','Karen Iverson','Erin Koplow'],
costumes:['Jill M. Ohanneson','Alonzo Van Wilson']},
{title:'Blood+',
titleCZ:'Blood+',
year:2005,
runtime:null,
episodeRuntime:'20h24min',
countries:['Japan'],
genres:['Animation','Action','Drama','Horror'],
director:["Džun'iči Fudžisaku",'Kazuto Nakazawa','Susumu Kudó','Ei Aoki','Džun Macumoto','Man Kawasaki','Daisuke Takašima','Rjó Mijata','Tomoaki Óta','Ken Andó','Šintaró Itoga','Tecuja Kobajaši','Masahiro Okamura','Nanako Šimazaki','Hirotoši Rissen','Naojasu Habu','Naomiči Jamato',"Shin'ichi Miyamae"],
actors:['Eri Kitamura','Kacujuki Koniši','Hirojuki Jošino','Akiko Jadžima','Hóčú Ócuka','Keidži Fudžiwara','Akira Išida','Kentaró Itó','Júko Kaida','Ami Košimizu','Džúróta Kosugi','Takaši Nagasako','Džódži Nakata','Tóru Ókawa',"Džun'iči Suwabe",'Megumi Tojoguči','Kódži Cudžitani',"Ken'iči Ogata",'Kendži Nodžima','Majumi Asano','Nozomu Sasaki','Romi Paku','Wataru Takagi','Džun Fukujama','Kódži Jusa','Ikuja Sawaki','Mai Kadowaki','Čiwa Saitó','Takaja Kuroda','Tecu Inada','Hadžime Iidžima','Tóko Aojama','Takajuki Sugó','Kaori Nazuka','Rika Fukami','Mijuki Ičidžó','Hidejuki Umezu','Takuja Kirimoto','Hidehiko Kaneko','Hiroši Širokuma','Tomoko Nakamura','Miho Mijagawa','Tadahisa Saizen','Jó Kitazawa','Rjó Sugisaki','Džin Urajama','Kazuhiro Nakaja','Tošihiro Nakamura','Akari Higuči','Šiho Hisadžima','Šózó Sasaki','Šigeo Kijama','Kijomi Jazawa','Jóhei Óbajaši','Eri Komijama','Masajasu Nagata','Ió Macukubo','Rika Morinaga','Wahei Iida','Juki Kjói','Fumio Macuoka','Tomoko Hajaši','Hirotake Nagata','Hideaki Nonaka','Minako Ičiki','Tamio Sobami','Micuru Fudžiwara','Naoki Janagi','Cutomu Cudži','Saori Kató','Izumi Sató','Kaori Hajaši','Kazusa Amagai','Naoko Širakami','Jošiko Hisajuki','Akiko Kacuta','Azuma Sakamoto','Júko Kinošita'],
screenplay:['Reiko Jošida','Mičiko Jokote','Šótaró Suga','Kurasumi Sunajama','Šigeru Morita','Midori Gótó',"Džun'iči Fudžisaku",'Jošiki Sakurai','Jutaka Ómacu'],
production:['Hiró Marujama','Tomonori Očikoši','Kacudži Morišita','Hirofumi Morotomi'],
music:['Mark Mancina'],
camera:['Kódži Tanaka'],
cut:['Taeko Hamauzu'],
sound:['Jošikazu Iwanami'],
scenography:["Džun'iči Higaši"]},
{title:'Harley Quinn',
titleCZ:'Harley Quinn',
year:2019,
runtime:'18h 5min',
episodeRuntime:'21-45min',
countries:['USA'],
genres:['Animation','Adventure','Crime'],
director:['Juan Jose Meza-Leon','Matt Garofalo','Vinton Heuck','Cecilia Aranovich','Colin Heck','Tom Derosier','Christina Sotta','Brandon McKinney','Mike Milo','Joonki Park','Jennifer Coyle','Michael Moloney','Chad Hurd','Yoriaki Mochizuki'],
actors:['Kaley Cuoco','Alan Tudyk','James Wolk','Diedrich Bader','Lake Bell','Rahul Kohli','Jason Alexander','Wanda Sykes','J.B. Smoove','Ron Funches','Tony Hale','Christopher Meloni','Natalie Morales','Jim Rash','Sanaa Lathan','Vanessa Marshall','James Adomian','Andy Daly','Wayne Knight','Alfred Molina','Jacob Tremblay','Matt Oberg','Rachel Dratch','Briana Cuoco','Mark Whitten','George Lopez','Brad Morris','Michael Ironside','Jessica Walter','Giancarlo Esposito','Mary Holland','Jameela Jamil','Phil LaMarr','Will Sasso','Tom Hollander','Rory Scovel','Justina Machado','Scott Porter','Tisha Campbell-Martin','Susie Essman','Sean Giambrone','Chris Diamantopoulos','Tom Kenny','Frankie Muniz','Suzy Nakamura','Rhea Perlman','Meryl Hathaway','Howie Mandel','Nicole Sullivan','Talia Tabin','Jonah Platt','Harvey Guillén','Krizia Bajos','Sammi Corona-Lampa','Amy Sedaris','Larry Owens','Sam Richardson','Matt Ryan','James Gunn','Cathy Ang','Billy Bob Thornton','Keith Ferguson','Kari Wahlgren','Jack Stanton','Griffin Newman','Gary Anthony Williams','Casey Wilson','Tyler James Williams','Leila Birch','Quinta Brunson','Brett Goldstein','Josh Helman','John Stamos','Janet Varney','Aline Elasmar','Kerry Knuppe','Edi Patterson','Ben Levin','Zeno Robinson','Eric Bauza','Lacey Chabert','Paul W. Downs','Rain Valdez','Janeane Garofalo','Zosia Mamet','Kimberly Brooks','Amari McCoy','Gregg Turkington'],
screenplay:['Tom Hyndman','Sabrina Jalees','Justin Halpern','Patrick Schumacker','Adam Stein','Jamiesen Borak','Sarah Peters','Jane Becker','Laura Moran','Jordan Weiss','Jess Dweck','Rachel Pegram','Sarah Nevada Smith','Dean Lorey','Ava Tramer','Jen Chuck','Jimmy Mosqueda','Alexis Quasarano','Connie Shin'],
production:['Jennifer Coyle','Cecilia Aranovich','Lisa Hallbauer'],
music:['Jefferson Friedman'],
cut:['Charles Breiner','Annie De Brock','Craig Paulsen','Dave Courter','James Atkinson'],
sound:['George Peters','Robert Hargreaves','Shaun Cunningham','Marc Schmidt'],
scenography:['John Calmette','Matthew Girardi']},
{title:'Haibane Renmei',
titleCZ:'Haibane renmei',
year:2002,
runtime:'4h 59min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Mystery','Psychology'],
director:['Tomokazu Tokoro','Takahiro Ómori','Icuki Imazaki','Wataru Sakaibaši','Džun Takada','Kódži Jošikawa',"Ken'ičiró Watanabe",'Chûichi Iguchi','Masaki Kudô'],
actors:['Džunko Noda','Fumiko Orikasa','Tamio Óki','Aja Hisakawa','Akiko Jadžima','Tomoe Hanba','Miju Macuki','Kumiko Higa','Jasuhiro Fudžiwara','Hadžime Iidžima','Ken Takeuči','Kazusa Murai','Čihiro Suzuki','Akiko Takeguči','Masumi Asano','Ai Tokunaga','Hiroši Jazaki','Rjó Hirohaši','Miwa Macumoto','Manabi Mizuno','Satoši Katógi','Jukimasa Obi','Jutaka Aojama','Kazuja Kobajaši','Kóiči Kurijama','Eri Mijadžima','Cugumi Higasajama'],
basedOn:['Jošitoši Abe'],
screenplay:['Jošitoši Abe'],
production:['Takeo Haruna'],
music:['Kó Ótani'],
camera:['Jutaka Nagauši'],
cut:['Masahiro Gotó'],
sound:['Satoši Motojama'],
scenography:['Šindži Katahira']},
{title:'Seventeen Moments of Spring',
titleCZ:'Sedmnáct zastavení jara',
year:1973,
runtime:null,
episodeRuntime:'12x70min',
countries:['Russia'],
genres:['Adventure','War'],
director:['Taťjana Lioznova'],
actors:['Vjačeslav Tichonov','Oleg Tabakov','Leonid Kuravljov','Lev Durov','Valentin Gaft','Nikolaj Prokopovič','Nikolaj Gricenko','Oleg Fjodorov','Otto Mellies','Fritz Diez','Alexandr Jakovlev','Paul Butkevič','Jevgenij Jevstignějev','Leonid Broněvoj','Vasilij Lanovoj','Nikolaj Volkov','Valentin Golubenko','Vjačeslav Šalevič','Rostislav Pljatt','Konstantin Želdin','Vladimir Ščeglov','Lavrentij Masocha','Jevgenij Lazarev','Igor Gusev','Inna Uljanova','Eleonora Šaškova','Alexej Ejboženko','Vladimir Smirnov','Wilfried Weschke','Wilhelm Burmeier','Světlana Světličnaja','Vladimir Kenigson','Jurij Katin-Jarcev'],
screenplay:['Julian Semjonov'],
music:['Mikael Tariverdijev']},
{title:'The Oblongs...',
titleCZ:'Obloukovi',
year:2001,
runtime:'4h 39min',
episodeRuntime:'21-22min',
countries:['Canada','USA'],
genres:['Animation','Comedy'],
director:['Mike Kim','Gary McCarver','Kelly Armstrong','Bob Jaques','Vincent Waller','Skip Jones','Joe Horne','Linda Miller'],
actors:['Pamela Adlon','Will Ferrell','Jean Smart','Randy Sklar','Jeannie Elias','Billy West','Jim Ward','Susan Krebs','Debra Wilson','Lea DeLaria','Jason Sklar','Becky Thyre','Carrie Aizley','Laraine Newman','Mark Hamill','Maurice LaMarche','Phil LaMarr','Jim Cummings'],
screenplay:['Scott Buck','Jace Richdale','Ben Kull','Eric Friedman'],
production:['J. Michael Mendel','Karen K. Miller','Richard Quan'],
music:['David Michael Frank','David Schwartz'],
cut:['Leo Papin'],
sound:['Michael Gollom','Joseph D. Citarella','Neil Brody']},
{title:'City Hunter',
titleCZ:'Siti hyunteo',
year:2011,
runtime:'21h 25min',
episodeRuntime:'63-67min',
countries:['South Korea'],
genres:['Crime','Romance'],
director:['Hyeok Jin'],
actors:['Min-ho Lee','Min-yeong Park','Sang-joong Kim','Ho-jin Cheon','Sang-ho Kim','Mi-sook Kim','Il-hwa Choi','Kwang-soo Lee','Joon-hyeok Lee','Hara','Jeong-woo Choi','Sun-hee Hwang','Jin-seong Yang','Joon-won Jeong','Byeong-choon Kim','Sung-il Park','Hyo-jeong Lee','Heon-tae Jeon','Seung-hyeon Baek','Bong-hak Maeng','Ye-hee Yoon'],
basedOn:['Cukasa Hódžó'],
screenplay:['Soo-jin Choi','Eun-kyeong Hwang'],
production:['Sebastian Lee']},
{title:'Malviviendo',
titleCZ:'Malviviendo',
year:2008,
runtime:null,
episodeRuntime:null,
countries:['Spain'],
genres:['Comedy'],
director:['David Sáinz'],
actors:['David Sáinz','David Valderrama','Tomás Moreno','Carlos Medrano','Paco Jaen','Álvaro Pérez','Carlos Bernardino','Ken Appledorn','Josema Pichardo','Manuel Noguera','Daniel Mantero','Javi Lería','Adrián Pino','Tomás Moreno'],
camera:['Tomás Moreno'],
cut:['Javi Lería']},
{title:'Board James',
titleCZ:'Board James',
year:2009,
runtime:null,
episodeRuntime:null,
countries:['USA'],
genres:['Comedy'],
director:['James Rolfe'],
actors:['James Rolfe','Mike Matei','Joe Vargas']},
{title:'Initial D Fourth Stage',
titleCZ:'Initial D Fourth Stage',
year:2004,
runtime:'10h 48min',
episodeRuntime:'27min',
countries:['Japan'],
genres:['Animation','Drama','Sport','Action'],
director:['Cuneo Tominaga','Susumu Kudó','Satoši Nakagawa','Júičiró Mijake','Hiroši Kimura','Akira Šimizu','Jasuo Edžima'],
actors:["Šin'ičiró Miki",'Tomokazu Seki','Takehito Kojasu','Makoto Jasumura','Rjóka Juzuki','Jasunori Macumoto','Daiki Nakamura','Hirojuki Jošino','Megumi Tojoguči','Nobujuki Hijama','Kódži Išii','Masaši Ebara','Takaja Haši','Tomojuki Šimura','Eidži Mijašita','Kazuhiro Nakata','Rjókiči Takahaši','Džin Horikawa','Kósuke Okano','Tomomiči Nišimura','Micuaki Madono','Seidži Sasaki','Masahiko Tanaka','Rintaró Niši','Osamu Hosoi','Miki Nagasawa','Hiro Júki','Júto Kazama','Rjúzaburó Ótomo','Naomi Wakabajaši','Šigeru Šibuja','Jošinori Sonobe','Eriko Kigawa','Acuši Kakehaši','Eisuke Asakura','Kazuki Jao','Micuo Iwata','Unšó Išizuka','Ajako Kawasumi','Tošijuki Morikawa','Wataru Takagi','Akimicu Takase','Kazuhisa Kawahara','Makoto Higo','Tacuhisa Suzuki','Masuo Amada','Kenta Mijake'],
basedOn:['Šúiči Šigeno'],
screenplay:['Nobuaki Kišima'],
production:['Kajo Fukuda'],
music:['Martin Dennis','Acuši Umebori'],
camera:['Masaki Nakamura'],
cut:['Cujoši Imai'],
sound:['Masafumi Mima'],
scenography:['Masajoši Banno']},
{title:'Critical Role',
titleCZ:'Critical Role',
year:2015,
runtime:null,
episodeRuntime:null,
countries:['USA'],
genres:['Adventure','Fantasy'],
director:['Matthew Mercer'],
actors:["Liam O'Brien",'Matthew Mercer','Taliesin Jaffe','Marisha Ray','Ashley Johnson','Will Friedle','Ashly Burch','Noelle Stevenson','Wil Wheaton','Felicia Day','Jon Heder','Joe Manganiello','Khary Payton','Chris Hardwick','Phil LaMarr','Eric Bauza','Michael Croner','Jennifer Hale','Yuri Lowenthal','T.J. Storm','Deborah Ann Woll','Roger Craig Smith','Sumalee Montano','Molly Ostertag','Laura Bailey','Mica Burton','Sam Riegel','Travis Willingham','Mary Elizabeth McGlynn','Darin De Paul',"Danny O'Dwyer"],
scenography:['Ryan Brett Puckett']},
{title:'World under Head',
titleCZ:'Svět pod hlavou',
year:2017,
runtime:'9h 38min',
episodeRuntime:'54-60min',
countries:['Czechia'],
genres:['Drama','Mystery','Psychology','Crime'],
director:['Marek Najbrt','Radim Špaček'],
actors:['Václav Neužil ml.','Ivan Trojan','Judit Pecháček','Jan Budař','Václav Kopta','Tomáš Jeřábek','Michal Dalecký','Marie Doležalová','David Máj','Jan Plouhar','Miroslav Hanuš','Kryštof Hádek','Jan Cina','Marek Daniel','Marek Adamczyk','Igor Chmela','Betka Stanková','Ljuba Krbová','Jiří Šimek','Marek Pospíchal','Richard Němec','Tomáš Bambušek','Jitka Schneiderová','Jan Španbauer','Roman Zach','Roman Mrázik','Jana Plodková','Ladislav Hampl','Jiří Černý','Ondřej Malý','Robert Mikluš','Daniel Tůma','Pavel Gajdoš','Tobiáš Rímský','Joshua Adam Kostel','Jiří Maryško','Pavel Lagner','Anita Krausová','Vasil Fridrich','Prokop Zach','Magdalena Zimová','Václav Helšus','Miloslav Maršálek','Vladislav Georgiev','Tomáš Milostný','Václav Marhold','Jana Altmannová','Jakub Koudela','Ondřej Nosálek','Jiří Král','Robert Soukup','Sára Märcová','Jakub Gottwald','Ján Sedal','Tomáš Kořének','Anna Fišerová','Daniel Svoboda','Pavel Šimčík','Dušan Sitek','Marek Taclík','Tomáš Měcháček','Marek Brodský','Jakub Wehrenberg','Zuzana Stavná','Joe Weintraub','Veronika Lapková','Tomáš Dianiška','Eduard Jenický','Jaroslav Pížl','Dana Marková','Dan Dittrich','Tereza Švejdová','Zuzana Stivínová','Roman Skamene','Rostislav Novák ml.','Kamil Švejda','Vladimír Škultéty','Eduard Endt','Martin E. Kyšperský','Ivan Shvedoff','Tereza Hofová','Jana Podlipná','Jan Jankovský','František Staněk','Martin Papesch Huleja','Petr Vršek','René Šmotek','Štěpánka Ludvíková','Zdeněk Dušek','Josef Kadeřábek','Halka Jeřábek Třešňáková','Jiří Štrébl','Jaroslava Pokorná','Lukáš Jůza','Kryštof Rímský','Radim Novák','Jiří Rendl','Marie Ludvíková','David Punčochář','Berenika Kohoutová'],
screenplay:['Ondřej Štindl','Robert Geisler','Benjamin Tuček'],
production:['Michal Reitler','Vratislav Šlajer'],
music:['Hynek Schneider'],
camera:['Martin Štěpánek'],
cut:['Michal Hýka','Petr Mrkous','Anna Johnson Ryndová'],
sound:['Jiří Melcher','Tomáš Zůbek','Lukáš Moudrý'],
scenography:['Jan Vlasák'],
masks:['Eva Ungrová-Malíková'],
costumes:['Andrea Králová']},
{title:'Occupied',
titleCZ:'Okupace',
year:2015,
runtime:null,
episodeRuntime:'18h45min',
countries:['Norway','France','Sweden'],
genres:['Drama','Thriller'],
director:['Erik Skjoldbjærg','Camilla Strøm Henriksen','Gunnar Vikene','Jens Lien','John Andreas Andersen','Erik Richter Strand','Pål Sletaune','Eva Sørhaug','Charlotte Brändström'],
actors:['Henrik Mestad','Eldar Skar','Ingeborga Dapkunajtě','Ane Dahl Torp','Selome Emnetu','Janne Heltberg','Ragnhild Gudbrandsen','Vegar Hoel','Kristin Braut-Solheim','Ella Malia Prince','Alexej Manvelov','Veslemøy Mørkrid','Stig Ryste Amdam','Ulrik Skage','Oddgeir Thune','Hippolyte Girardot','Sondre Larsen','Daniel Rusten Larsen','Kristin Skogheim','Hans Olav Brenner','Lisa Loven Kongsli','Sergej Merkusjev','Morten Svartveit','Thea Green Lundberg','Britt Langlie','Morten Traavik','Lydia Indjova','Elishan Naurbiev','Marianne Mørk Larsen','Øystein Røger','Filip Peeters','Mads Sjøgård Pettersen','Darja Ekamasova','Madalena Helly-Hansen','Lenn Kudrjawizki','Krzysztof Pieczyński','Johannes Gjessing','Per Gørvell','Harald Rosenstrøm','Nigel Whitmey','Erik Aleksander Schjerven','Annika Hallin','Emil Johnsen','Sara Khorami','Aslak Eriksrud','Halvor Tangen Schultz','Sverre Anker Ousdal','Vera Rudi','Ivan Mathias Petersson','Vytautas Kaniušonis','Torbjørn Davidsen','Kate Pendry','Lisa Cooper','Rubert Moses','Sajid Malik Hussain','Torgeir Reiten','Pia Borgli','Hanne Gjerstad Henrichsen','Jonas Bergland','Yama Wolasmal','Anne Grosvold','Irina Kara-Mosko','Naeem Azam','Tom Audenaert','Timur Magomedgadzhiev','Mehdi Nebbou','Nathalie Roussel','Fredrik Steen','Ville Virtanen','Irina Eidsvold Tøien','Thomas Chr. Hansen','Ragnhild Gudbrandsen','Vegar Hoel','André Sørum','Kenan Ibrahimefendic','Bram De Maere','Kjærsti Odden Skjeldal','Roar Kjølv Jenssen','Morten Pedersen','Sacha Slengesol Balgobin','Nasrin Khusrawi','Magnus Aasheim','Ramunas Cicenas','Sergej Vasilkov','Kathrine Thorborg Johansen','Sjur Vatne Brean','Gabija Jaraminaite','Audun Karl Hanssen','Kyrre Haugen Sydness','Valeriu Andriuta','Valentina Alexeeva','Kai Kennet Hanson','Aldona Vilutytė','Rimante Valiukaite','Torstein Bjørklund','Lars Arentz-Hansen','Severina Spakovska','Oscar Ducasse','Arvydas Dapšys','Paulius Markevičius'],
screenplay:['Erik Skjoldbjærg','Karianne Lund','Ina Bruhn','Björn Paqualin','Ståle Stein Berg','Erik Richter Strand','Tomas Solli','Hilde Susan Jægtnes','Camilla Strøm Henriksen'],
production:['Marianne Gray','Gudny Hummelvoll'],
music:['Nicholas Sillitoe'],
camera:['John-Erling H. Fredriksen','Feliksas Abrukauskas','Øystein Mamen','Philip Øgaard','John Andreas Andersen','Johan-Fredrik Bødtker','Kjell Vassdal','Harald Gunnar Paalgard','Geir Hartly Andreassen','Pascal Gennesseaux'],
cut:['Sverrir Kristjánsson','Veslemøy Blokhus Langvik','Simen Gengenbach','Toril Strøm','Christopher Gibb','Stian Kjørstad Zethelius'],
sound:['Hugo Ekornes','Fredric Vogel','Daniel Lindvik','Bent Holm','Espen Rønning','Erik S. Watland','Kenneth Gustavsen'],
scenography:['Nina Bjerch-Andresen','Kathrine Solhoff'],
masks:['Janne Røhmen','Louise Kjær','Vidar Svendsen','Trine Morland','Brita Johansen','Dimitra Drakopoulou','Dorte Pedersen','Maria Bjørnnes Hermansen','Ruta Miglinaite','Sandra Mateikaitė','Linda Røhmen'],
costumes:['Anne Pedersen','Sofie Rage Larsen']},
{title:'Tři tygři',
titleCZ:'Tři tygři',
year:2019,
runtime:null,
episodeRuntime:null,
countries:['Czechia'],
genres:['Comedy'],
director:['Albert Čuba'],
actors:['Štěpán Kozub','Albert Čuba','Beáta Hrnčiříková','Martina Hekerová','Robin Ferro','Vladimír Polák','Jakub Vašek','Milan Baroš','Lada Bělašková','Kristýna Lipinová','Lucie Okonová','Ondřej Malý','Michal Sedláček','Martin Pančocha','Kateřina Elizabeth McIntosh','Marie Anna Kupcová','Yvona Stolařová','Maxmilián Čuba','Lukáš Oramus','Michaela Rykrová','Jan Peršín','Jan Lipovský','Jana Juříčková','Lukáš Káňa','Kryštof Malec','Bořivoj Čermák','Kristýna Leichtová','Iva Janžurová','Jiří Sedláček','Josef Kaluža','Petr Panzenberger','Táňa Bystroňová','Zuzana Truplová','Jiří Krhut','Lucie Rybnikářová','Barbara Kanyzová','Jitka Zelenková','Hana Fialová'],
camera:['Maxmilián Čuba'],
cut:['Maxmilián Čuba']},
{title:'Smiley',
titleCZ:'Smiley',
year:2022,
runtime:'4h 51min',
episodeRuntime:'34-38min',
countries:['Spain'],
genres:['Comedy','Romance'],
director:['David Martín Porras','Marta Pahissa'],
actors:['Carlos Cuevas','Eduardo Lloveras','Miki Esparbé','Ruth Llopis','Pepón Nieto','Ramon Pujol','Meritxell Calvo','Giannina Fruttero','Cedrick Mughisha'],
screenplay:['Guillem Clua','Guillem Clua'],
music:['Arnau Bataller'],
camera:['Pol Orpinell'],
cut:['Frank Gutiérrez'],
sound:['Martí Albert','Miquel Àngel Riaza','Pau Tolosa'],
masks:['Laura Bruy'],
costumes:['Irantzu Campos','Olga Rodal']},
{title:'Heavenly Delusion',
titleCZ:'Tengoku-Daimakyo',
year:2023,
runtime:'5h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Adventure','Mystery','Sci-Fi','Action'],
director:['Hirotaka Mori','Kazuja Nomura','Takaši Ócuka','Jódžiró Arai','Haruka Fudžita','Tošimasa Išii','Tomohiko Itó','Rjó Nakano','Šóta Hamada'],
actors:['Sajaka Senbongi','Gen Sató','Misato Macuoka','Acumi Tanezaki','Masako Isobe','Kazuja Nakai','Tošijuki Tojonaga','Tomojo Kurosawa','Misato Fukuen','Tadaši Mutó','Šunsuke Takeuči','Júki Šin','Hibiku Jamamura','Kei Šindó','Kazuja Sadži','Keisuke Misaizu','Takahiro Šimada','Masao Komaja','Micuaki Kanuka','Satomi Kobaši','Mai Nišikawa','Ajano Šibuja','Aja Hisakawa','Jošiko Hisajuki','Wataru Cujuzaki','Riho Sugijama','Mijuki Sahaku','Šunpei Kusano','Takuja Makimura','Masaaki Ihara','Reimi','Marija Ise','Manta Jamamoto','Anri Tačibana','Kóhei Amasaki','Kósuke Ečigoja','Šinei Ueki','Izó Oikawa','Kanon Amane','Takeru Jagi','Daiči Fudžiwara','Kazumasa Nakamura','Júki Urušijama','Kódži Očiai','Jukari Watanabe','Naoki Tamanoi','Hideki Tanaka','Masaomi Jamahaši','Júko Ueda','Rjó Sugisaki','Kósuke Kobajaši','Júsuke Sasaki',"Šin'ja Takahaši",'Kendži Jošida','Kensuke Óta','Saori Terai','Tomojuki Šimura','Mamiko Noto','Itaru Jamamoto','Fumitake Išiguro','Jutaka Aojama','Kóiči Sóma','Mičitake Kikuči','Kazuki Kjan','Kacuja Jošida','Seiko Tamura','Acuši Gotó','Micuho Kanbe','Takajuki Mijamoto','Jú Hatori','Júiči Macuda','Mičiru Sató','Kentaró Takano','Šóko Juzuki','Šunsuke Sakuja','Takeši Hirabajaši','Hirohito Jamada','Nozomi Mikadžiri','Jasuhiro Mamija','Hikaru Jošihara','Jú Mijazaki','Issei Furuta','Madoka Šiga',"Aju Macu'ura",'Sakura Kawaguči','Kokoa Išii','Minami Iinuma','Rie Hikisaka','Rina Kitagawa','Mari Doi','Hina Kino','Haruna Mikawa','Kozue Saitó','Moe Edamoto','Šóhei Kadžikawa','Jóhei Tadano',"Šun'iči Maki",'Čiharu Sawaširo',"Kijomicu Mizu'uči"],
basedOn:['Masakazu Išiguro'],
screenplay:['Makoto Fukami','Asako Kubojama','Ikumi Nomura','Hirotaka Mori'],
production:['Kazuto Macumura'],
music:['Kensuke Ušio'],
camera:['Kentaró Waki'],
cut:['Kumiko Sakamoto'],
sound:['Eriko Kimura'],
scenography:['Júdži Kaneko']},
{title:'Shtisel',
titleCZ:'Shtisel',
year:2013,
runtime:'27h 6min',
episodeRuntime:'41-58min',
countries:['Israel'],
genres:['Drama'],
director:['Alon Zingman'],
actors:["Doval'e Glickman",'Michael Aloni','Neta Riskin','Shira Haas','Sarel Piterman','Zohar Strauss','Orly Silbersatz','Ayelet Zurer','Moon Shavit','Hanna Rieber','Razia Israeli','Yoav Sadian','Hava Levi Rozelsky','Moshe Folkenflick','Leah Koenig','Ruti Bornstein','Jonni Zicoltz','Yoav Rotman','Irit Alter','Holger Irmisch','Miki Kam'],
screenplay:['Ori Elon','Yehonatan Indursky'],
production:['Jonathan Aroch','Dikla Barkai'],
camera:['Roey Roth'],
cut:['Dikla Barkai'],
masks:['Hila Mins'],
costumes:['Hava Levi Rozelsky','Uzi Amrani','Keren Eyal Melamed']},
{title:'Panoptikum Města pražského',
titleCZ:'Panoptikum Města pražského',
year:1987,
runtime:'10h 13min',
episodeRuntime:'52-68min',
countries:['Czechoslovakia'],
genres:['Crime','Comedy'],
director:['Antonín Moskalyk'],
actors:['Jiří Adamíra','Josef Vinklář','Josef Bláha','Ondřej Havelka','Karel Koloušek','Bedřich Prokoš','Dalimil Klapka','František Filipovský','Karel Augusta','Naďa Konvalinková','Ladislav Mrkvička','Ilja Racek','Ota Sklenčka','Jiří Krampol','Václav Vydra nejml.','Jarmila Švehlová','Zdeněk Martínek','Lubomír Kostelka','Ladislav Kazda','Zdeněk Ornest','Martin Růžek','Jiří Bartoška','Simona Stašová','Jiří Klem','Jiří Holý','Pavel Trávníček','Rudolf Hrušínský','Věra Vlčková','Jiří Vala','Blažena Holišová','Vladimír Huber','Zuzana Skalická','Eduard Cupák','Veronika Jeníková','Miroslav Vladyka','Libuše Havelková','Alois Švehlík','Svatopluk Beneš','Věra Kubánková','Karel Chromík','Zdeněk Buchvaldek','Regina Rázlová','Bronislav Poloczek','Soběslav Sejk','Lubor Tokoš','Míla Myslíková','Miroslav Moravec','Jan Přeučil','Michal Kocourek','Hana Maciuchová','Karel Heřmánek','Petr Kostka','Michal Pešek','Robert Vrchota','Josef Větrovec','Karel Houska','Pavel Zedníček','Jaroslava Obermaierová','Jaroslav Moučka','Oldřich Vlach','Marek Vašut','Marcel Vašinka','Otakar Brousek ml.','Igor Smržík','Viktor Preiss','Jiří Bruder','Valentina Thielová','Daniel Netušil','Zdeněk Srstka','Luděk Kopřiva','Helena Růžičková','Stanislav Junek','Vladimír Krška','Josef Kubíček','Zdeněk Dítě','Hugo Kaminský','Jaroslav Cmíral','Václav Mareš','Alena Konopíková','Eugen Jegorov','Antonín Navrátil','Josef Velda','Oldřich Velen','Antonín Brtoun','Jaroslav Mareš','Karel Bělohradský','Vladimír Bičík','Lena Birková','Božena Böhmová','Bohuslav Čáp','Josef Dvořák','Jan Faltýnek','Adolf Filip','Michaela Gebertová','Jana Hlaváčová','Zbyněk Honzík','Svatava Hubeňáková','Rudolf Jelínek','Milan Klásek','Bohumil Koška'],
basedOn:['Jiří Marek'],
screenplay:['Jiří Marek'],
music:['Ivan Kurz'],
camera:['Jiří Šámal'],
cut:['Josef Valušiak'],
sound:['Jiří Hora'],
scenography:['Jaroslav Krška','Bohumil Pokorný'],
masks:['František Havlíček','Libuše Beranová'],
costumes:['Jaroslava Veselá','Libuše Pražáková']},
{title:'Velmi uvěřitelné příběhy',
titleCZ:'Velmi uvěřitelné příběhy',
year:1991,
runtime:'1h 46min',
episodeRuntime:'12-26min',
countries:['Czechoslovakia'],
genres:['Drama','Horror','Tale'],
director:['Igor Chaun'],
actors:['Jan Hřebejk','Miroslava Součková','Miloš Vávra','Vítězslav Jandák','Jiří Fero Burda','Pavel Nový','Josef Abrhám','Jiří Hálek','Helena Lehká-Rejšková','Jiří Štrébl','Simona Vrbická','Vratislav Kadlec','Václav Knop','Miroslav Chorvát','Rafael Pražák','Martin Stránský','Robert Jašków','Josef Čepelka','Jakub Marek','Jáchym Valášek','Jorga Kotrbová','Barbora Eichlerová','Zoja Oubramová-Pistoriusová','Lena Birková','Eliška Kuchařová','Jiří Schmitzer','Jan Teplý st.','Otakar Brousek st.','Petr Kment','Květoslav Štora','Vít Pešina','Václav Burkert','Martin Hub','Pavel Bezděk','Karel Hovorka ml.','Karel Schoř','Rudolf Kalina','Miloš Frýba','Elena Galanová','Dagmar Dvořáčková','Rudolf Krouza','Marie Krouzová','Anna Kreuzmannová'],
screenplay:['Igor Chaun','Petr Jarchovský','Petr Vachler'],
music:['Jiří Chlumecký'],
camera:['Jan Velický'],
cut:['Zdenek Patočka'],
sound:['Hugo Markes'],
scenography:['Luděk Souček'],
masks:['Josef Borovička','Zdena Báťková'],
costumes:['Dagmar Březinová']},
{title:'Kamisama Kiss',
titleCZ:'Kami-sama hadžimemašita',
year:2012,
runtime:'9h 48min',
episodeRuntime:'23-24min',
countries:['Japan'],
genres:['Animation','Fantasy','Comedy','Romance'],
director:['Akitaró Daiči','Júsuke Onoda','Jasuičiró Jamamoto','Kijoko Sajama','Akira Nišimori','Jošitaka Kojama','Jošitomo Jonetani','Tošiaki Kanbara','Harume Kosaka','Masahiro Mukai','Júta Murano','Hiroaki Akagi','Masaja Fudžimori','Tomoko Iwasaki','Kazuhiro Sasaki','Hadžime Kamegaki','Šúhei Macušita','Naoki Hišikawa','Jasujuki Honda','Kaoru Jabana','Čika Nagaoka','Mašu Itó'],
actors:['Naoko Sugiura','Megumi Nasu','Suzuko Mimori','Jui Horie','Masako Kacuki','Akira Išida','Šúta Morišima',"Džun'iči Suwabe",'Júdži Ueda','Šinnosuke Tačibana','Daisuke Kišio','Kaori Sadohara','Rjóhei Kimura','Nacumi Takamori','Naoja Wakasono',"Šin'ja Takahaši",'Jú Kobajaši','Nobuhiko Okamoto','Eri Góda','Hidekazu Ičinose','Hiroki Takahaši','Kaori Šimizu','Takeši Maeda','Mamiko Noto','Satomi Sató','Masahito Jabe','Daisuke Namikawa','Aimi','Čiaki Šimogama','Akemi Okamura','Nobujuki Hijama','Naoko Macui','Kokoro Kikuči','Hjósei','Ajaka Saitó','Šótaró Morikubo','Juri Amano','Wataru Hatano','Daiki Jamašita','Júko Sanpei','Sajako Tódžó','Hiro Šimono','Akira Kamija','Kotono Micuiši','Nacujo Ataraši','Čika Ókubo','Jošijuki Jamaguči','Kacuja','Júto Nakano','Narumi Sató',"Šin'ja Hamazoe",'Fumika Čiba','Vanilla Jamazaki','Subaru Tógó','Rie Kugimija','Hanae','Jukine Jaehata','Hinata Kusunoki','Akinori Egoši','Kenta Macumoto','Kjóko Hikami','Makoto Šimada','Hirojuki Endó','Só Takeuči','Hiromi Haruki','Haruhi Nanao','Megumi Iwasaki','Kendžiró Cuda','Júko Kawaniši','Miharu Maehara'],
basedOn:['Julietta Suzuki'],
screenplay:['Akitaró Daiči','Mičiko Jokote'],
production:['Hidejuki Nanba','Shinsaku Hatta','Masakacu Ómuro','Ikumi Hajaši'],
music:['Tošio Masuda'],
camera:['Akemi Sasaki'],
cut:['Ikujo Fudžita'],
sound:['Kazuja Tanaka'],
scenography:['Takaši Aoi']},
{title:'Unforgotten',
titleCZ:'Unforgotten',
year:2015,
runtime:'22h 30min',
episodeRuntime:'45min',
countries:['UK'],
genres:['Crime','Drama'],
director:['Andy Wilson'],
actors:['Nicola Walker','Sanjeev Bhaskar','Jordan Long','Lewis Reeves','Peter Egan','Tom Austen','Trevor Eve','Ruth Sheen','Tom Courtenay','Gemma Jones','Bernard Hill','Cherie Lunghi','Zoe Telford','Claire Goose','Silas Carson','Adam Astill','Tamzin Malleson','Struan Rodger','Benedict Taylor','Alan Ford','Dominic Power','Frances Tomelty','Paul Cawley','Emilio Doorgasingh','Pippa Nixon','Lasco Atkins','Yasmine Akram','David Troughton','Jassa Ahluwalia','Sharon Duncan-Brewster','Akin Gazi','Hannah Gordon',"Caroline O'Neill",'Tessa Peake-Jones','Ade Oyefeso','John Salthouse','Sheila Steafel','Linal Haft','Duncan Pow','Matthew David McCarthy','David Terry','Rita Davies','Cliff Barry','Chris Cowlin','Lorraine Ashbourne','Rosie Cavaliero','Bryony Hannah','Douglas Hodge','Mark Bonnar','Emma Cunniffe','Josef Altin','Adeel Akhtar','Nigel Lindsay','Holly Aird','Bobby Lockwood','Wendy Craig','Katherine Jakeways','Munir Khairdin','Teresa Churcher','Shaheen Khan','Alastair Kirton',"Maggie O'Neill",'Mairead McKinley','James Greene','Raad Rawi','Susannah Todd','Bill Paterson','Tom Mannion','Richard Hope','Sharon D. Clarke','Aaron Phagura','Badria Timimi','Tony Gardner','Alex Jennings','Georgia Mackenzie','James Fleet','Neil Morrissey','Kevin McNally','Emma Fielding','Amanda Root','Peter Polycarpou','Finlay Robertson','Sara Stewart','Sasha Behar','Lucinda Dryzek','Gabrielle Glaister','Seeta Indrani','Bronagh Waugh','Tom Rhys Harries','Benjamin Wainwright','Mark Fleischmann','Alan Asaad','Ann Akinjirin','Tori Allen-Martin','Jimmy Forsén','Sara Powell','John Scougall','Vihaan Patel','Sharon Dyall','Jodie Tyack'],
screenplay:['Chris Lang'],
production:['Tim Bradley','Guy de Glanville'],
music:['Michael Price'],
camera:['Gavin Finney','Søren Bay','James Aspinall'],
cut:['Adam Trotman','Tom Henson-Webb','Mark Davis'],
sound:['Erik Guldager','Mathew Knights'],
scenography:['Tom Bowyer','Ashleigh Jeffers','Steve Wright','Andrew Piotrowski','Jan Walker','Mark Tanner'],
masks:['Georgina Coupland','Marella Shearer'],
costumes:['Matthew Price','Eleanor Baker']},
{title:"You Know What's Bullshit",
titleCZ:"You Know What's Bullshit",
year:2007,
runtime:null,
episodeRuntime:'15x5min',
countries:['USA'],
genres:['Comedy'],
director:['James Rolfe'],
actors:['James Rolfe','Mike Matei']},
{title:'Silk',
titleCZ:'Silk',
year:2011,
runtime:null,
episodeRuntime:'18h60min',
countries:['UK'],
genres:['Drama'],
director:['Catherine Morshead','Michael Offer','Marc Jobst','Peter Hoar','Jeremy Webb','Alice Troughton','Michael Keillor'],
actors:['Maxine Peake','Rupert Penry-Jones','Alex Jennings','Amy Wren','Frances Barber','Tom Hughes','Natalie Dormer','Paul Hilton','Nina Sosanya','Ariyon Bakare','Owen Teale','John Light','Ryan Hayward','Sam Creed','Phil Davis','Simon Merrells','Indira Varma','Fenella Woolgar','Jessica Henwick','Ray Fearon','Jonathan Aris','Adrian Lukis','Paul Ready','Mark Lewis Jones','Miranda Raison','Laura Greenwood','Elliott Jordan','Emma Fielding','Shannon Tarbet','Alexander Arnold','David Rintoul','Alan McKenna','Calum Callaghan','Ace Bhatti','Lauren Crace','Sadie Shimmin','Mark Tandy','Theo Barklem-Biggs','Eleanor Matsuura','Michael Müller','Neil Stuke','Stewart Lockwood','Otto Farrant','David Bark-Jones','Adrian Schiller','Philip Bretherton','Paul Thornley','Morgan Watkins','Nick Hendrix','Claire Porter','Reece Noi','Finbar Lynch','Peter De Jersey','John Macmillan','Kemal Sylvester','Munir Khairdin','Greg Bennett','Ed Birch','Tim Chipping','Will Keen','Alan Bond','Andrew Scarborough','Georgina Beedle','Harry Hadden-Paton','Pip Torrens','Kobna Holdbrook-Smith','Shazad Latif','Jacqueline King','Jack Farthing','Jason Maza','Kaye Wragg','Dorian Lough','Brian Capron','Ade Oyefeso','Nicholas Jones','John Salthouse','Sian Brooke','Robin Soans','Nathaniel Martello-White','Mark Penfold','Rhashan Stone','Ian Mann','Tim McMullan','Jane Lucas','Peter Vaughan','Kerry Godliman','Aden Gillett','Rupert Wickham','Peter Wight','Adrian Dunbar','Penny Downie','Diana Quick','Simon Meacock','Prasanna Puwanarajah','Nick Fletcher','Lloyd Hutchinson','Elaine Claxton','Gerard Monaco','Jimmy Akingbola','Ryan Winsley'],
screenplay:['Peter Moffat','Steve Thompson','Colin Teevan','Christian Spurrier'],
production:['Matt Strevens','Richard Stokes'],
music:['Dru Masters','Jake Jackson'],
camera:['John Conroy','Florian Hoffmeister','Dale McCready','Suzie Lavelle','Damian Bromley'],
cut:['Iain Erskine','Simon Reglar','Paul Knight','Dominic Strevens','Ian Farr','Mark Davis'],
sound:['Martin Jensen','Howard Bargroff'],
scenography:['Ed Turner','Melanie Allen'],
masks:['Jemma Carballo','Marella Shearer'],
costumes:['Ray Holman']},
{title:'Z hříček o královnách',
titleCZ:'Z hříček o královnách',
year:1994,
runtime:'6h 8min',
episodeRuntime:'47-64min',
countries:['Czechia'],
genres:['Drama','History'],
director:['Oldřich Daněk'],
actors:['Jana Štěpánková','Ondřej Vetchý','Petr Kostka','František Němec','Jiřina Jirásková','Jana Brejchová','Luděk Munzar','Miriam Chytilová','Lenka Horáková','Tereza Brodská','Marek Ronec','Zuzana Bydžovská','Vladimír Brabec','Bořivoj Navrátil','Jiří Štěpnička','Petr Štěpánek','Eva Spoustová','Jaromír Hanzlík','Ladislav Trojan','Václav Postránecký','Libuše Švormová','Ivana Chýlková','Alena Vránová','Bronislav Poloczek','Hana Igonda Ševčíková','Jiří Bartoška','Lukáš Hlavica','Jiří Hálek','Petr Haničinec','Dalimil Klapka','Jiřina Bohdalová','Petr Pelzer','Jiří Sovák','Jana Hlaváčová','Hana Maciuchová','Svatopluk Skopal','Jiří Klem','Viktor Preiss','Kateřina Brožová','Josef Vinklář'],
screenplay:['Oldřich Daněk'],
music:['Jan F. Fischer'],
camera:['Alois Nožička'],
cut:['Marie Pačajová','Eva Šťáhlavská','Jiří Šebelka','Allan Lazarov','Jiří Friedrich','Jozef Cuker','Eva Honzíková'],
sound:['Jiří Zelenka','Zdeněk Stropek'],
scenography:['Miloš Ditrich'],
masks:['Martin Valeš','Jiřina Kozlová','Josef Borovička'],
costumes:['Miroslava Pletichová','Jan Hever','Jarmila Konečná','Božena Měchurová','Hana Káclová']},
{title:'You Are Beautiful',
titleCZ:'Minami shineyo',
year:2009,
runtime:'17h 32min',
episodeRuntime:'61-68min',
countries:['South Korea'],
genres:['Romance','Comedy'],
director:['Seong-chang Hong'],
actors:['Geun-seok Jang','Shin-hye Park','Yong-hwa Jeong','Hong-gi Lee','Yu-jin Kim','Ran Choi','Chan Jeong','Soo-han Kang','Seong-ryeong Kim','Min-yeong Kim','Yeong-hoon Kim','Ho-chang Kim','Seung-ho Yoo','Gi-won Yoon','Kahi','Dae-seong Choi','Geu-rin Bae','Joo-yeon Lee','So-young Yoo','Hee-joon Oh','Won-young Jang','Heon-tae Jeon','Young-yong Kim'],
screenplay:['Mi-ran Hong','Jeong-eun Hong']},
{title:'Cow and Chicken',
titleCZ:'Cow and Chicken',
year:1997,
runtime:'19h 56min',
episodeRuntime:'23min',
countries:['USA'],
genres:['Animation','Comedy','Family','Fantasy'],
director:['Robert Alvarez','Deane Taylor','David Feiss','Bill Reed','Deane Taylor','John McIntyre','Joey Banaszkiewicz','Dave Brain','Ron Myrick','Rumen Petkov','Bob Jaques'],
actors:['Charlie Adler','Candi Milo','Dee Bradley Baker','Michael Dorn','Howard Morris','Dan Castellaneta','Tom Kenny','Mark Hamill','Gregg Berger','Judith Light','Larry Cedar','Dee Dee Rescher','Fred Stoller','Kevin Michael Richardson','Bibi Osterwald','Dick Gautier','Mitzi McCall','Edie McClurg','Nick Tate','Teresa Ganzel','Jill Talley','Kathleen Freeman','Judy Tenuta','Marabina Jaimes','Lori Alan','Debi Derryberry','April Winchell','Patrick Pinney','Pat Musick','Pat Fraley','Greg Eagles','Steve Marmel','Susanne Blakeslee','S. Marc Jordan','Richard Steven Horvitz','Kevin McDonald','Kerrigan Mahan','Gail Matthius','Jerry Sroka','Cam Clarke','Loretta Swit','Quinton Flynn','Kevin Schon','Mark Klastorin','B.J. Ward','Susan Tolsky','Lauri Johnson','Heidi Shannon','Dionne Quan','Scott Weil','Lauri Fraser','Glenn Shadix','Jess Harnell','Michael Gough','Tom Kane','Nora Dunn','Bronson Pinchot','Dom DeLuise','Jim Belushi','William Sanderson','Laraine Newman','Stuart Pankin','Carlos Alazraqui','Ed McMahon','Will Ferrell','Craig Shoemaker','Marianne Muellerleile','Conchata Ferrell','Kenneth Mars','Jennifer Hale','Paul Eiding','Richard Moll','Philip Maurice Hayes','Diane Delano','Roger Rose','Sally Struthers','Chick Vennera','Paul Lukather','Clancy Brown','Tara Strong','Eddie Deezen','Jeff Bennett','Townsend Coleman','Pamela Adlon','Jeff Doucette','Peter Lurie','Mary Kay Bergman','Nick Jameson','Rob Paulsen','Marcia Wallace','Scott Menville','Maurice LaMarche','Robert Picardo','Earl Boen','Frank Welker','Phyllis Diller','Vanessa Marshall','David Feiss','B.B. King','Harry Hutchinson'],
screenplay:['Seth MacFarlane','David Feiss','Steve Marmel','Michael Ryan','Richard Pursel','Bill Burnett','Maxwell Atoms'],
production:['Louis J. Cuck','Vincent Davis','Davis Doi'],
music:['Guy Moon','Bill Fulton'],
cut:['Pat Foley'],
sound:['Timothy J. Borquez','Timothy J. Garrity','Roy Braverman'],
scenography:['Scott Morse','Deane Taylor']},
{title:'All the Rivers Run',
titleCZ:'Co přináší řeka',
year:1983,
runtime:null,
episodeRuntime:'4x100min',
countries:['Australia'],
genres:['Drama','Romance'],
director:['Pino Amenta','George Miller'],
actors:['Sigrid Thornton','John Waters','Kirk Alexander','Betty Lucas','Don Bridges','Darius Perkins','Adrian Wright','Vivean Gray','Michele Fawdon','Diane Craig','Chantal Contouri','Don Barker','Margo McLennan','Gus Mercurio','Nicholas Brown','Harold Baigent','Steven Tandy','Alan Hardy'],
screenplay:['Peter Yeldham','Colin Free'],
production:['Alan Hardy'],
music:['Bruce Rowland'],
camera:['David Connell'],
scenography:['Otello Stolfo'],
costumes:['Marion Boyce','Clare Griffin']},
{title:'Toradora!',
titleCZ:'Toradora!',
year:2008,
runtime:null,
episodeRuntime:'10h24min',
countries:['Japan'],
genres:['Animation','Drama','Comedy','Romance'],
director:['Tacujuki Nagai','Jóhei Suzuki','Daisuke Takašima','Tóru Išida','Kacuja Asano','Masahito Otani','Eiiči Kubojama','Sajo Aoi','Tošikazu Hašimoto','Noriaki Saitó'],
actors:['Rie Kugimija','Eri Kitamura','Hirofumi Nodžima','Džundži Madžima','Jui Horie','Ai Nonaka','Nobuhiko Okamoto','Šinnosuke Tačibana','Saori Gotó','Jóko Hikasa','Sajaka Óhara','Hirojuki Jošino','Rie Tanaka','Fujuka Óura','Kazujuki Okicu','Kana Asumi','Júko Kaida','Takaši Óhara','Akiko Tanaka','Nobunaga Šimazaki','Nobuaki Kanemicu','Tóru Furusawa','Daisuke Macubara','Džun Miruno','Takuja Sató','Čikara Ósaka','Minami Cuda','Ao Takahaši','Mami Fudžita','Tomoko Nakamura','Cujoši Aoki','Hideki Nakaniši','Mina Kobajaši','Momoko Išikawa','Aiko Kumamoto'],
basedOn:['Jujuko Takemija'],
screenplay:['Mari Okada','Tacuto Higuči','Masahiro Jokotani','Džunko Okazaki'],
production:["Šin'iči Ikeda",'Takahiro Jamanaka','Munejuki Kanbe'],
music:['Jukari Hašimoto'],
camera:['Jutaka Kurosawa'],
cut:['Šigeru Nišijama'],
sound:['Džin Aketagawa'],
scenography:['Čikako Šibata']},
{title:'Jekyll',
titleCZ:'Jekyll',
year:2007,
runtime:'5h 35min',
episodeRuntime:'52-59min',
countries:['UK'],
genres:['Thriller'],
director:['Douglas Mackinnon','Matt Lipsey'],
actors:['James Nesbitt','Gina Bellman','Michelle Ryan','Fenella Woolgar','Matt King','Paterson Joseph','Graham McTavish','Andrew Byrne','Belinda Stewart-Wilson','Mark Gatiss','Amanda Hale','Denis Lawson','Leo Bill','Deborah Cornelius','Cliff Barry','Simon Thorp','Sam Swainsbury','Linda Marlowe','Bruce Mackinnon','Meera Syal','Joanna Scanlan','Fiz Marcus','Tony Gardner','Malcolm Storry','Julian Lewis Jones','Benedict Martin'],
screenplay:['Steven Moffat'],
production:['Elaine Cameron'],
music:['Debbie Wiseman'],
camera:['Peter Greenhalgh','Adam Suschitzky'],
cut:['Fiona Colbeck'],
costumes:['Rhona Russell']},
{title:'Untamed',
titleCZ:'Vítejte na konci světa',
year:2021,
runtime:'6h 1min',
episodeRuntime:'45-46min',
countries:['Norway'],
genres:['Comedy','Drama'],
director:['Dagur Kári'],
actors:['Tobias Santelmann','Stig Henrik Hoff','Marie Blokhus','Niklas Gundersen','Alma Günther','Eero Milonoff','Pelle Heikkilä','Marius Lien','Gard B. Eidsvold','Nils Johnson','Ingvild Holthe Bygdnes','Kamilla Grønli Hartvig','Ingunn Beate Øyen','Ingar Helge Gimle','Ole Bjørgan Schilling','Benoni Brox Krane','Frank Kjosås','Nader Khademi','Terje Ranes','Rozafa Celaj','May-Linda Kosumovic','Henriette Steenstrup','Marit Andreassen','Anne Marie Ottersen','Ingrid Vollan','Nils Rune Utsi','Celina Osnes','Mary Sarre','Marit Østbye','Maria Bock','Arnhild Litleré','Jonas Strand Gravli','Håkon T. Nielsen','Sven Henriksen','Henrik Horge'],
production:['Finn Gjerdrum','Stein B. Kvae'],
camera:['Andreas Johannessen'],
cut:['Vidar Flataukan','Andri Steinn','Sverrir Kristjánsson'],
sound:['Karoline Fjugstad Wendelborg'],
scenography:['Thomas Øyjordsbakken','Ida Bjerch-Andresen'],
costumes:['Margrét Einarsdóttir']},
{title:'Junjou Romantica: Pure Romance',
titleCZ:'Džundžó Romantica',
year:2008,
runtime:'14h 24min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Drama','Comedy','Romance'],
director:['Kunitoši Okadžima','Čiaki Kon','Akira Kató','Takaši Andó','Bob Širahata','Keidži Kawakubo','Kendži Setó','Masaki Watanabe','Šundži Jošida','Rjódži Fudžiwara','Masato Džinbó','Takuja Sató','Acuši Nakajama','Kósuke Kobajaši','Jukio Nišimoto','Mičio Fukuda','Jošihiro Takamoto','Čikajo Nakamura','Masahiro Ise'],
actors:['Hikaru Hanada','Majumi Asano','Eidži Takemoto','Daisuke Kageura','Tošijuki Morikawa','Daisuke Kišio','Nobutoši Kanna','Noriko Namiki','Kišó Tanijama','Asuka Minamori','Iššin Čiba','Kazuhiko Inoue','Kenta Mijake','Hozumi Góda','Susumu Čiba','Džúróta Kosugi','Nana Mizuki','Kósuke Toriumi','Himika Akaneja','Kazuhiro Fusegawa','Wataru Hatano','Júsuke Handa','Šóta Čónan','Acuši Kósaka','Kentaró Itó','Tóru Furuja','Tošijuki Tojonaga','Kentaró Tone','Šunsuke Sakai','Nacuki Aikawa','Takehiro Urao','Kana Marucuka','Hiro Šimono','Rikako Jamaguči','Aoi Inase','Takahiro Sakurai','Rina Sató','Eri Kitamura','Kumiko Hašimoto','Mami Šitara','Sora Kuwakado','Miki Suga','Daisuke Macuoka',"Šin'ja Fukumacu",'Gen Nakano','Hiroka Nišizawa','Šintaró Nakano','Júko Nišihara','Rjótaró Okiaju','Ai Hajasaka','Kei Šindó','Juki Masuda','Eriko Macušima','Hirómi Sugino','Tamako Nohama','Hitomi Harada','Saori Seto','Aiko Aihaši','Hiroši Jamamoto','Kazutaka Išii','Hacumi Takada','Nami Mizuno','Asumi Kodama','Tecuja Kakihara','Jukito Sóma','Júko Jamazaki','Suzune Okabe','Džunna Amako','Ami Košimizu','Jurika Hajama','Marika Motojoši'],
basedOn:['Šungiku Nakamura'],
screenplay:['Jošiko Nakamura','Mičiko Jokote','Rika Nakase','Čiaki Kon'],
production:['Michiko Suzuki','Džunka Kobajaši','Cuneo Takeči','Tomoko Suzuki'],
music:['Jukio Kondó','Kajo Koniši'],
camera:['Akira Šimozaki','Džunko Sakai'],
cut:['Masahiro Macumura'],
sound:['Hozumi Góda'],
scenography:["Džun'iči Higaši",'Džunko Šimizu','Hiroši Itó','Juki Umino']},
{title:'Weird Lawyer, Woo Young-woo',
titleCZ:'Výjimečná právnička U Jong-u',
year:2022,
runtime:'36h 9min',
episodeRuntime:'64-83min',
countries:['South Korea'],
genres:['Drama'],
director:['In-sik Yoo'],
actors:['Eun-bin Park','Tae-oh Kang','Jong-hyuk Joo','Ki-yeong Kang','Bae-soo Jeon','Yoon-kyeong Ha','Kjong Džin','Ji-won Baek','Hyun-young Joo'],
screenplay:['Ji Won Moon'],
music:['Young-shim No']},
{title:'Battlefield Friends',
titleCZ:'Battlefield Friends',
year:2012,
runtime:null,
episodeRuntime:null,
countries:['USA'],
genres:['Comedy'],
director:['Brent Triplett'],
actors:['Brent Triplett','Matthew Warzel'],
screenplay:['Brent Triplett'],
music:['Alex Beard']},
{title:"Don't Hug Me I'm Scared",
titleCZ:'Don’t Hug Me I’m Scared',
year:2022,
runtime:'2h 22min',
episodeRuntime:'23-24min',
countries:['UK'],
genres:['Animation','Puppets','Horror','Comedy'],
director:['Becky Sloan','Joseph Pelling','Baker Terry'],
actors:['Becky Sloan','Baker Terry','Joseph Pelling','Leila Navabi'],
screenplay:['Becky Sloan','Joseph Pelling','Baker Terry'],
production:['Hugo Donkin'],
music:['Baker Terry','Joseph Pelling'],
camera:['Edward Tucker'],
cut:['Nick Armstrong'],
scenography:['Joseph Pelling','Becky Sloan'],
masks:['Suzi Battersby']},
{title:'Láska a anarchie',
titleCZ:'Láska a anarchie',
year:2020,
runtime:'8h 25min',
episodeRuntime:'26-36min',
countries:['Sweden'],
genres:['Comedy','Drama','Romance'],
director:['Lisa Langseth','Emma Bucht'],
actors:['Ida Engvoll','Björn Mosten','Carla Sehn','Reine Brynolfsson','Gizem Erdogan','Björn Kjellman','Ruben Lopez','Johannes Bah Kuhnke','Elsa Agemalm Reiland','Disa Östrand','Ejke Blomberg','Lars Väringer','Yasmine Garbi','Lisette Pagler','Benjamin Shaps','Bengt C.W. Carlsson','Nova Waldfogel','Mira Eklund','Ludde Hagberg','Akar Karami','Malin Levanon','Karin Bertling','Pontus Djanaieff','Lena Endre','Suzanne Ernrup','Eva Gedin','Jessika Gedin','Cyril Hellman','Jacob Hirdwall','Johan Jonason','Olle Knape','Oskar Knape','David Lagercrantz','Stig Larsson','Stefan Lindberg','Camilla Läckberg','Karolina Ramqvist','Ala Riani','Fredrik Silbersky','Joel Valois','Lisa Langseth','Nathalie Söderqvist','Luzia Catomeris Medina','Polly Stjärne','Sinead Daly','Angela Kovács','Fredrik Hammar','Andreas Wijk','Erik Dahlin','Sebastian Morad Adegren','Scharliina Eräpuro','Marina Bouras','David Dencik','Stina Schedin','Carl Johan Merner','Rojan Telo','Roshi Hoss','Beata Cavallin','Pia Oscarsson','David Lenneman','Jane Magnusson','Helmon Solomon','Marga Pettersson','Katta Pålsson','Ulrika Malmgren','Ilkka Villi','Jens Lapidus','Elina du Rietz','Stephen Rappaport','David Book','Lena Nylén','Ulf Eklund','Matilda Källström','Göran Thorell','Yohanna Idha','Penny Smitt','Tobias Carlsson'],
screenplay:['Alex Haridi','Amanda Högberg','Antonia Pyk','Lisa Langseth','Maria Nygren','Josefin Johansson'],
production:['Frida Asp','Fatima Varhos'],
music:['Kristian Selin Lidnes Andersen','Adam Nordén'],
camera:['Ulf Brantås','Victor Davidson'],
cut:['Elin Pröjts','Henrik Källberg','Christoffer Holmberg','Christina Eriksson','Britta Norell'],
sound:['Nicklas Lindh','Tom van Heesch','Per Sundström','Thomas Huhn'],
scenography:['Karin Myrenberg Faber','Charlotte Alfredson'],
masks:['Daniela Mengarelli','Ida Eriksson'],
costumes:['Denise Östholm','Johanna Holmgren','Johanna Borggren']},
{title:'Superjail!',
titleCZ:'Superjail!',
year:2007,
runtime:null,
episodeRuntime:'21x11min',
countries:['USA'],
genres:['Animation','Comedy','Crime'],
director:['Christy Karacas'],
actors:['David Wain','Jon Glaser','Reggie Watts','Eric Bauza','Aaron Augenblick','Christopher McCulloch','Dana Snyder','Stephen Warbrick','Christy Karacas'],
screenplay:['Janine Ditullio','Aaron Augenblick','Ben Gruber','Stephen Warbrick','Christy Karacas'],
music:['Didier Leplae','Joe Wong'],
cut:['Felipe Salazar','Stephen Warbrick']},
{title:'Horimija',
titleCZ:'Horimija',
year:2021,
runtime:'4h 59min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Comedy','Romance'],
director:['Masaši Išihama','Jasuo Edžima','Fumiaki Kataoka','Jošiko Okuda','Jukiko Imai','Makoto Kodama','Akihisa Šibata'],
actors:['Haruka Tomacu','Kóki Učijama','Daiki Jamašita','Džun Fukujama','Jurie Kozakai','M.A.O','Nobuhiko Okamoto','Reina Kondó','Seiičiró Jamašita','Ai Kajano','Daisuke Ono','Hisako Kanemoto','Juka Terasaki','Momo Asakura','Taku Jaširo','Kendžiró Cuda','Šinei Ueki','Manaka Iwami','Hiroki Maeda','Júki Takada','Makoto Kóiči','Tomojo Takajanagi','Saki Mijašita','Sajumi Watabe','Juka Nukui','Ajaka Šimizu','Gen Sató','Minami Tanaka','Júja Murakami','Šója Čiba','Nacumi Fudžiwara','Fumijoši Šioja','Sajaka Óhara','Rikuja Jasuda','Taito Ban','Genki Muro','Nacumi Kawaida','Ajaka Nanase','Šógo Sakata','Acuši Tamaru','Haruki Išija',"Džun'iči Janagita",'Sajaka Kaneko','Masaaki Mizunaka','Kaito Takeda','Acumi Tanezaki','Maju Mineda','Nacumi Hioka','Sajaka Senbongi','Rjóka Juzuki','Aoi Koga','Júja Hirose','Hana Sató','Eri Jukimura','Masamu Ono','Emiri Sujama','Reigo Jamaguči','Šó Nogami','Himari Močida','Jurina Amami','Hitomi Sasaki','Jú Okano','Minami Maju','Rie Kawamura','Kento Širaiši','Anzu Haruno','Jú Mijazaki','Makoto Sahara','Akinori Egoši','Saki Kobari','Momo Išibaši','Hazuki Ogino','Arisa Sakuraba','Anna Jamaki','Saja Aizawa','Júki Išikari','Misa Išii','Kotomi Aihara','Hajato Komija'],
basedOn:['Hero','Daisuke Hagiwara'],
screenplay:['Takao Jošioka','Čiaki Nagai','Sawako Hirabajaši'],
production:['Eidži Maesaka','Tošihiro Maeda'],
music:['Masaru Jokojama'],
camera:['Júja Sakuma'],
cut:['Jošiaki Kimura'],
sound:['Džin Aketagawa'],
scenography:['Morijasu Jasuhira','Hisajo Usui']},
{title:'The Best of Youth',
titleCZ:'La meglio gioventù',
year:2003,
runtime:358,
episodeRuntime:null,
countries:['Italy'],
genres:['Drama','Romance'],
director:['Marco Tullio Giordana'],
actors:['Luigi Lo Cascio','Alessio Boni','Adriana Asti','Sonia Bergamasco','Fabrizio Gifuni','Maya Sansa','Jasmine Trinca','Andrea Tidona','Claudio Gioè','Riccardo Scamarcio','Fabio Camilli','Camilla Filippi','Valentina Carnelutti','Giovanni Scifoni','Stefano Abbati','Domenico Centamore','Lidia Vitale','Paolo De Vita','Danilo Maria Valli','Marcello Prayer','Manuela Massarenti','Pippo Montalbano','Paolo Bonanni','Nicola Vigilante','Angelo Costabile','Walter da Pozzo','Fabio Roscillo','Emilia Marra','Sjur Midttun'],
screenplay:['Sandro Petraglia','Stefano Rulli'],
production:['Donatella Botti'],
camera:['Roberto Forza'],
sound:['Fulgenzio Ceccon','Paolo Segat'],
scenography:['Paola Riviello','Paola Riviello','Franco Ceraolo','Jörg Baumgarten'],
masks:['Maria Gerolama Sale','Enrico Iacoponi'],
costumes:['Elisabetta Montaldo']},
{title:'The Seven Deadly Sins',
titleCZ:'Sedm smrtelných hříchů',
year:2014,
runtime:'39h 12min',
episodeRuntime:'24-25min',
countries:['Japan'],
genres:['Animation','Action','Adventure','Drama','Fantasy','Comedy'],
director:['Tensai Okamura','Takeši Furuta','Tomokazu Tokoro','Susumu Nišizawa','Hiroki Hirano','Hye-Jin Seo','Micutoši Sató','Hideaki Itó','Seung Hui Son','Jošito Hata','Fumio Maezono','Masahiro Šinohara','Masajuki Iimura','Tomoja Tanaka','Kazuja Fudžiširo','Júsuke Marujama','Kendži Takahaši','Čika Nagaoka','Kazuja Monma'],
actors:['Tacuhisa Suzuki','Aoi Júki','Sora Amamija','Misaki Kuno','Džun Fukujama','Júki Kadži','Kotori Koiwai','Maaja Sakamoto','Mamoru Mijano',"Šin'ičiró Miki",'Nana Mizuki','Hiroši Kamija','Erica Lindbeck','Juiči Karasuma','Takuma Nagacuka','Jurie Kobori','Emiri Kató','Hisako Kanemoto','Jumiko Kobajaši','Takahiro Sakurai','Marina Inoue','Minako Kotobuki','Kacujuki Koniši','Nobujuki Hijama','Marija Ise','Nozomi Furuki','Čó','Tomojuki Šimura','Minoru Jada','Takaši Inagaki','Júja Učida','Hiroki Jamada','Rintaró Niši','Genki Jošimoto','Sači Kokurjú','Hirofumi Nodžima','Rjóko Širaiši','Rjóhei Kimura',"Ken'ičiró Macuda",'Makoto Furukawa','Tóru Sakurai','Kazutomi Jamamoto','Keisuke Kómoto','Júhei Takagi','Daiki Hamano','Júko Hara','Júsuke Kobajaši','Hiroši Iwasaki','M.A.O','Kódži Jusa','Rina Sató','Kendžiró Cuda','Tomokazu Sugita','Hiroši Jazaki','Daisuke Ono','Ajahi Takagaki','Hiroki Tóči','Rikija Kojama','Rjóta Suzuki','Kaho Kóda','Šógo Jano','Taiši Murata','Šinšú Fudži','Rjósuke Kanemoto','Itaru Jamamoto','Džódži Nakata','Akira Išida','Šun Horie','Satoši Curuoka','Rjó Hirohaši','Masaja Fukuniši','Júko Kaida','Teššó Genda','Šinei Ueki','Sumire Morohoši','Tošihiko Seki','Jóhei Tadano','Jóhei Azakami','Kazuhiko Inoue','Sara Macumoto','Šinnosuke Ogami','Himika Akaneja','Haruka Čisuga','Jošihito Sasaki','Acuši Ono','Taró Kiuči','Serika Hiromacu','Šinobu Macumoto','Tošiki Iwasawa','Šintaró Tanaka','Satomi Kobaši','Rjúnosuke Watanuki','Hiroaki Okuda','Miju Komaki','Sóširó Hori','Džoičiró Jošida','Kajó Nakadžima','Takuja Masumoto','Makoto Takahaši','Jasujuki Sano'],
basedOn:['Nakaba Suzuki'],
screenplay:['Džukki Hanada','Šótaró Suga','Juniko Ajana','Rie Uehara','Jutaka Jasunaga','Júičiró Kido','Čiaki Nagai','Rintaró Ikeda','Jošiki Ókusa','Jurika Mijao','Takao Jošioka','Masanao Akahoši'],
production:['Jósuke Takabajaši'],
music:['Hirojuki Sawano','Takafumi Wada','Kóta Jamamoto'],
camera:['Tošija Kimura','Takaši Aoki'],
cut:['Megumi Učida','Masahiro Gotó'],
sound:['Kazuhiro Wakabajaši','Čikako Jokota','Marco Augusto Comba'],
scenography:['Jasutoši Kawai','Hiromiči Itó']},
{title:'The Bugs Bunny and Tweety Show',
titleCZ:'The Bugs Bunny and Tweety Show',
year:1986,
runtime:null,
episodeRuntime:'986',
countries:['USA'],
genres:['Animation','Family','Comedy'],
director:['Abe Levitow','Friz Freleng','Rudy Larriva','Robert McKimson','Chuck Jones','Maurice Noble'],
actors:['Mel Blanc','Daws Butler','June Foray','Jim Backus','Ben Frommer'],
screenplay:['Tony Benedict','Warren Foster'],
music:['Carl W. Stalling','William Lava','Eugene Poddany','Shorty Rogers','Dean Elliott'],
cut:['Rick Gehr']},
{title:'The Escape Artist',
titleCZ:'The Escape Artist',
year:2013,
runtime:null,
episodeRuntime:'180min',
countries:['UK'],
genres:['Drama','Thriller'],
director:['Brian Welsh'],
actors:['David Tennant','Toby Kebbell','Roxanne Gregory','Jeany Spark','Ashley Jensen','Sophie Okonedo','Patrick Ryecart','Hilary Bevan Jones','Jessica Ransom','Forbes KB','Lasco Atkins','Michael Cochrane','Gabrielle Jourdan','Gus Barry','Chris Cowlin','Matthew David McCarthy','Nigel Betts','Tony Gardner','Canan Avsar','Ben Bradley','Aaron Niles','Victoria Carling'],
screenplay:['David Wolstencroft'],
camera:['David Higgs'],
cut:['Jamie Pearson'],
costumes:['Jacky Levy']},
{title:'Forever',
titleCZ:'Forever',
year:2014,
runtime:'15h 45min',
episodeRuntime:'42-44min',
countries:['USA'],
genres:['Drama','Crime','Fantasy','Mystery','Sci-Fi'],
director:['Brad Anderson','Sam Hill','Jace Alexander','John T. Kretchmer','Steve Shill','Zetna Fuentes','Matt Barber','Peter Lauer','Steve Boyum','Antonio Negret','John F. Showalter','Michael Fields','David Warren'],
actors:['Ioan Gruffudd','Judd Hirsch','Alana De La Garza','Lorraine Toussaint','Joel David Moore','Donnie Keshawarz','Barbara Eve Harris','MacKenzie Mauzy','Janice Picconi','Lee Tergesen','James McCaffrey','Angela Christian','Dave Quay','Mather Zickel','Christina Bennett Lind','Jordan Dean','Eric William Morris','Michael Oberholtzer','Timothy Britten Parker','Erika Rolfsrud','Janie Brookshire','Cornelius Smith Jr.','Jane Seymour','Marija Skangale','James Colby','Andy Murray','Rosalind Chao','Burn Gorman','Marko Caka','Doris McCarthy','Jeff Biehl','Marlon Perrier','John Solo','Tarik Lowe','James Russell','Robbie Sublett','Kelly AuCoin','Julian Gamble','Doug Kruse','Zachary Unger','Michelle Hurst','Cuba Gooding Jr.','Mike Houston','Megan Ketch','Harris Yulin','Neal Huff','Happy Anderson','Eddie Cooper','Justin Swain','Royce Johnson','Andhy Méndez','Lou Ferguson','DonnaMarie Recco','Steve Cirbus','Christian Scheider','Kathleen Chalfant','Jack Gilpin','Janelle Velasquez','Nicola Fiore','Paul Fitzgerald','Angela Pierce','Robert Gomes','Dina Cataldi','Birkett Turton','Alexandra Neil','Hilarie Burton','Marmee Cosico','James McDaniel','Frankie Faison','Ty Jones','Laura Fraser','Gary Basaraba','Blair Brown','Edoardo Ballerini','Geoffrey Cantor','John Palumbo','Clarke Peters','Sepideh Moafi','William Baldwin','Michael Godere','Steven Kaplan','Shane McRae','Roger Rees','Michael Aronov','Olek Krupa','Cotter Smith','Emily Kinney','Erin Darke','Jane Alexander','Don McManus','Kate Rogal','Souleymane Sy Savane','Frederick Weller','Jordan Gelber','David Krumholtz','Lilla Crawford','Michel Gill','Aaron Dean Eisenberg','Tim Guinee','Boris McGiver'],
screenplay:['Chris Fedak','Phil Klemmer','Sarah Nicole Jones','Ildy Modrovich','Zev Borow','John Enbom','Cameron Litvack','Matthew Miller','Allen MacDonald','Matt Kester','Janet Lin'],
production:['Ray Quinlan'],
music:['John Debney','Josh Kramon'],
camera:['Thomas Yatsko','David Moxness','Joe Collins','Jack Donnelly'],
cut:['Chris Peppe','Matt Barber','Jon Dudkowski','Jeffrey Asher'],
sound:['Ed Carr','Todd Grace','Ryan Davis','Rick Norman','Tom Marks','Peter Austin'],
scenography:['Stuart Wurtzel','Anne Stuhler','Alexandra Mazur','C.J. Simpson','Victoria Ruskin'],
masks:['Sarah Tollenaar','Gary Martori','Lena Jemmott'],
costumes:['Susan Lyall','Lorraine Calvert']},
{title:'Hnízdo',
titleCZ:'Hnízdo',
year:2020,
runtime:'11h 10min',
episodeRuntime:'55-60min',
countries:['Slovakia'],
genres:['Drama'],
director:['Braňo Mišík'],
actors:['Soňa Norisová','Alexander Bárta','Marián Mitaš','Andrea Karnasová','Marek Geišberg','Katarína Šafaříková','Pavol Višňovský','Zuzana Frenglová','Anna Javorková','Zuzana Kubovčíková-Šebová','Dano Heriban','Milo Kráľ','Nataša Grambličková','Andy Kummer','Ján Jackuliak','Nikita Czeri','Heňa Kecerová','Martin Mňahončák','Alex Koníček','Roman Luknár','Juraj Hrčka','Tomáš Vravník','Juraj Predmerský','Tibor Vokoun','Barbora Andrešičová','Dušan Hraňo','Anna Čonková','Pavol Topoľský','Lukáš Dóza','Matúš Gáll','Slavomír Blažek','Petra Dubayová','Milena Minichová','Ľuboš Radošovský','Filip Koiš','Jakub Miščik'],
screenplay:['Alena Bodingerová','Naďa Jurkemik','Peter Nagy'],
production:['Zuzana Balkóová'],
camera:['Laco Janošťák','Mário Ondriš'],
cut:['Zuzana Cseplő','Michal Drobný'],
sound:['Peter Monček','Marián Gregorovič','Peter Mazáček','Ján Ravasz'],
scenography:['Braňo Mihálik'],
masks:['Zuzana Wittgruberová','Katarína Pokorná','Mária Smatanová'],
costumes:['Lucia Šedivá']},
{title:'Chobits',
titleCZ:'Chobits',
year:2002,
runtime:'10h 50min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Comedy','Romance','Sci-Fi'],
director:['Morio Asaka','Tomoki Kobajaši','Rjó Mijata','Hirojuki Tanaka','Nanako Šimazaki'],
actors:['Rie Tanaka','Tomokazu Sugita','Fumiko Orikasa','Hóko Kuwašima','Iššin Čiba',"Džun'iči Suwabe",'Tomokazu Seki','Júdži Ueda','Jukana','Rjóka Juzuki','Megumi Tojoguči','Kikuko Inoue','Rjó Hirohaši','Jošinori Sonobe','Nacuki Jošihara','Júgo Takahaši','Kandži Suzumori','Takeši Sasaki','Masumi Kagejama','Masaja Óšima','Rika Wakusawa','Jumiko Daikoku','Džun Šikano','Hiroko Ónaka','Kumiko Izumi','Juka Tokumicu','Motoko Kumai','Kóiči Sakaguči','Kóiči Tóčika','Naomi Šindó','Šó Wada','Kaori Takeda'],
basedOn:['Clamp'],
screenplay:['Džiro Kaneko'],
production:['Tatsuya Ono','Tecuo Genšó','Júiči Sekido'],
music:['Keitarô Takanami'],
camera:['Kacujoši Kiši','Tsuyoshi Kuzumoto'],
cut:['Satoši Terauči'],
sound:['Masafumi Mima'],
scenography:['Čikako Šibata']},
{title:'Personal Taste',
titleCZ:'Gaeineui chwihyang',
year:2010,
runtime:'17h 4min',
episodeRuntime:'60-67min',
countries:['South Korea'],
genres:['Romance','Comedy'],
director:['Hyeong-seok Son','Jong-chan No'],
actors:['Ye-jin Son','Min-ho Lee','Ji-seok Kim','Ji-hye Wang','Chan Jeong','Eun-ji Jo','Tae-gyu Bong','Eun-hye Yoon','Seok-hwan Ahn','Joon Seong','Nam-gil Kim','Seung-ryong Ryoo','Seulong','Hae-mi Park','Seon-mi Song','Seong-hwa Jeong','Won-young Jang','Bong-hak Maeng','Julien Kang','Kyung-hoon Jo'],
basedOn:['Se-in Lee']},
{title:'Spice and Wolf',
titleCZ:'Ókami to kóšinrjó',
year:2008,
runtime:'9h 36min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Romance'],
director:['Džun Šišido','Takeo Takahaši','Keidži Kawakubo','Ikuo Jamakado','Šunsuke Mačitani','Šinsuke Terasawa','Hidžiri Sanpei','Jó Miura','Masahisa Kojata'],
actors:['Hozumi Góda',"Džun'ja Miura",'Džun Fukujama','Kaori Nazuka','Jasuhiro Fudžiwara','Jukihiro Misono','Jasuhiro Mamija','Micuo Senda','Dai Macumoto','Šinpači Cudži','Hóčú Ócuka','Jutaka Nakano',"Ken'jú Horiuči",'Chuck Huber','Tecuharu Óta','Rjúdži Mizuno','Tokujoši Kawašima','Daisuke Namikawa','Kazuaki Itó','Eidži Hanawa','Susumu Akagi','Nobujuki Furuta','Júki Masuda','Mai Nakahara','Akimicu Takase','Ami Košimizu','Júta Nakano','Tomohisa Asó','Júja Učida','Čikara Ósaka','Rikija Kojama','Romi Paku','Akeno Watanabe','Majumi Janagisawa','Kósei Hirota','Aki Tojosaki','Hidenori Takahaši','Šigeru Ušijama','Jonathan R. Freeman','Kaoru Sasadžima','Saeko Čiba','Sara Nakajama','Júja Tadžima','Masajuki Omoro','Jukitaró Namura','Šónosuke Horikoši','Júko Mizobe','Kazujoši Hajaši','Takao Išii','Micuteru Nagato'],
basedOn:['Isuna Hasekura'],
screenplay:['Naruhisa Arakawa'],
production:['Tomohiro Fujita','Tacuja Išiguro','Tomoko Suzuki'],
music:['Júdži Jošino'],
camera:['Šinja Macui',"Šin'ičiró Tate"],
cut:['Megumi Učida','Naoki Watanabe'],
sound:['Hadžime Takakuwa'],
scenography:['Tošihiro Kohama']},
{title:'Spawn',
titleCZ:'Spawn',
year:1997,
runtime:'8h 9min',
episodeRuntime:'26-29min',
countries:['USA'],
genres:['Animation','Action','Crime','Drama','Horror','Thriller','Fantasy'],
director:['Eric Radomski','Jennifer Yuh','Mike Vosburg','John Hays','Thomas A. Nelson','Chuck Patton','Brad Rader','Todd McFarlane','Frank Paur','Yoshio Chatani','Jošiaki Kawadžiri'],
actors:['Keith David','Richard Dysart','Dominique Jennings','Todd McFarlane','James Keane','Michael McShane','John Rafter Lee','Victor Love','Michael Nicolosi','Kath Soucie','Denise Poirier','Ruben Santiago-Hudson','Ming-Na Wen','Charlie Adler','John Hostetter','Ronny Cox','Alex Fernandez','John DeMita',"Brendan O'Brien",'Tony Amendola','Matthew Flint','Victor Brandt','Paul Raci','Steve Franken','Kevin Michael Richardson','Brenda Vaccaro','Brion James','Jim Lau','Lewis Arquette','Ricky Dean Logan','James Hong','Matt McKenzie','Michael Yama','Jack Fletcher','Julia Fletcher','Michael Scott Ryan','Mark Klastorin','Jamie Hanes','Debbi Morgan','Matt K. Miller','Robert Forster','Michael Beach','Pamela Adlon','Jennifer Jason Leigh','Carlos Ferro','Dwight Schultz','Greg Eagles','Kate McFarlane','Eric Roberts','Kurtwood Smith','Khandi Alexander','Robert Costanzo','John DiMaggio','Max Perlich','Xander Berkeley','Channon Roe'],
basedOn:['Todd McFarlane'],
screenplay:['John Leekley','Alan B. McElroy','Rebekah Bradford Leekley','Larry Brody','Gerard Brown','John Shirley','Gary Hardwick','Victor Bumbalo'],
production:['Catherine Winder','John Kafka','Maryann T. McClure','Randall White'],
music:['Shirley Walker','J. Peter Robinson'],
cut:['Paul D. Calder','Lynn Hobson','Scott Jeffress','Kathie Burr'],
sound:['Craig Berkey','Deb Adair','Paca Thomas','Sean Garnhart','Mike Draghi','Melissa Ellis','Jim Hodson','Ray Leonard']},
{title:'My Dress-Up Darling',
titleCZ:'Sono Bisque Doll wa koi o suru',
year:2022,
runtime:'4h 48min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Comedy','Romance'],
director:['Keisuke Šinohara','Takaši Sakuma',"Šin'ičiró Ušidžima",'Júta Jamazaki','Kento Nagakome'],
actors:['Šója Išige','Hina Suguta','Acuši Ono','Acumi Tanezaki','Hina Jómija','Mai Kanno','Júka Amemija','Tomojo Takajanagi','Akira Sekine','Larissa Tago Takeda','Hiroši Watanabe','Taito Ban','Haruki Išija','Júki Inoue','Saho Širasu','Gó Imakiire','Ajuru Óhaši','Džuri Nagacuma','Šúiči Učida','Tasuku Kida','Kanako Janagihara','Akari Tadano','Ajaka Šimizu','Misako Tomioka','Šó Okumura','Marie Mijake',"Šin'ja Takahaši",'Jukina Šutó','Natsuko Abe','Tomomi Tanaka','Hóko Kuwašima','Rumi Šišido','Kokoro Kikuči','Kóki Mijata','Sakura Tange','Misako Tomioka','Tošinari Fukamači','Júsuke Širai','Misaki Kuno','Tomoe Tamijasu','Júja Murakami','Nanako Mori','Takako Tanaka','Arisa Nakata','Daiki Kurokawa','Rjósuke Šukutani'],
basedOn:["Šin'iči Fukuda"],
screenplay:['Joriko Tomita'],
production:['Širjú Kitazawa','Tomojuki Ówada'],
music:['Takeši Nakacuka'],
camera:['Cubasa Kanamori'],
cut:['Daisuke Hiraki'],
sound:['Akiko Fudžita'],
scenography:['Hirojuki Nemoto','Ajumi Kodžima']},
{title:'Annie and Joe',
titleCZ:'Anča a Pepík',
year:2017,
runtime:'2h 53min',
episodeRuntime:'13-14min',
countries:['Czechia'],
genres:['Animation','Adventure','Short'],
director:['Michal Žabka'],
actors:['Jan Maxián','Ivana Korolová','Jan Vondráček','Jiří Lábus','Vladimír Brabec','Jaroslava Obermaierová','Jaroslava Kretschmerová','Tereza Bebarová','Petr Rychlý','Miroslav Táborský','Martin Sobotka','Jan Přeučil','Jakub Hejdánek','Lucie Bílá'],
basedOn:['Lucie Lomová'],
screenplay:['Lucie Lomová'],
music:['Ondřej Soukup'],
cut:['Lucie Haladová'],
sound:['Jan Čeněk']},
{title:'Ekaterina',
titleCZ:'Jekatěrina',
year:2014,
runtime:null,
episodeRuntime:'24x37-62min',
countries:['Russia'],
genres:['Drama','History'],
director:['Alexandr Baranov','Ramil Sabitov'],
actors:['Marina Alexandrova','Julija Aug','Alexandr Jacenko','Alexandr Balujev','Rinal Muchamětov','Vladimir Meňšov','Konstantin Lavroněnko','Sergej Strelnikov','Nikolaj Kozak','Anna Banščikova','Oleg Flejer','Anna Nosatova','Pjotr Žuravljov','Alexandr Lazarev ml.','Anna Skidanova','Vitalij Kravčenko','Kirill Rubcov','Isabel Schosnig','Nikolaj Gorobec','Igor Larin','Ivan Věrchovych','Petr Mareček','Jevgenij Dančevskij','Jevgenij Volockij','Anastasija Korolkova','Michail Gavrilov','Anastasija Jevgrafova','Leonid Timcunik','Konstantin Topolaga','Sergej Kagakov','Alexandr Věremjuk','Alexej Moisejev','Maxim Kerin','Xenija Razina','Marija Mina','Pavel Vorožcov','Pjotr Něstěrov','Sergej Borisov','Sergej Sotnikov','Andrej Zanoga','Alexej Vorobjov','Anna Rycareva','Ivan Dobronravov','Světlana Korčagina','Alexandr Vysokovskij','Jelena Šamova','Oleg Knyš','Georges Devdariani','Pavel Gajdučenko','Vasilij Belokopytov','Sergej Volkov','Dmitrij Savkin','Kirill Krošman-Klimov','Michail Konovalov','Zdeněk Sedláček'],
screenplay:['Arif Alijev'],
production:['Jekatěrina Jefanova','Taťjana Beličenko'],
music:['Nikolaj Rostov'],
camera:['Maxim Šinkorenko']},
{title:'Bočči the Rock!',
titleCZ:'Bočči the Rock!',
year:2022,
runtime:'4h 48min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Music','Comedy'],
director:['Keiičiró Saitó','Jošijuki Fudžiwara','Júsuke Jamamoto','Keisuke Šinohara','Nobuhide Karija'],
actors:['Jošino Aojama','Sajumi Suzuširo','Ikumi Hasegawa','Saku Mizuno','Anna Nagase','Emiko Takeuči','Hajato Komija','Hinaki Jano','Džundži Madžima','Kotori Koiwai','Kóseki Kogure','Kjó Jaoja','Maaja Učida','Megumi Jamaguči','Misaki Watada','Nacumi Kawaida','Noriaki Kanze','Rie Suegara','Takako Tanaka','Takeo Ócuka','Jasunori Masutani','Jóhei Azakami','Jú Wakabajaši','Jume Mijamoto','Sajaka Senbongi','Kana Ičinose','Mijuri Šimabukuro','Koko Hajaši','Micuhiro Sakamaki','Rina Endó','Sóširó Hori','Erisa Kuon','Hiroki Gotó','Kentaró Tone','Saeko Akiho','Saho Širasu','Šóto Kašii','Jódži Ueda','Juiko Tacumi','Tacumaru Tačibana','Acuši Kósaka','Šiničiró Kamio','Kacujuki Miura','Maki Kawase','Sally Amaki','Šúičiró Umeda','Taiči Ičikawa','Rikuja Jasuda','Konomi Kohara','Hina Jómija','Seena Hošiki','Šigeru Čiba','Reo Osanai'],
basedOn:['Aki Hamadži'],
screenplay:['Erika Jošida'],
music:['Tomoki Kikuja'],
camera:['Cubasa Kanamori'],
cut:['Daisuke Hiraki'],
sound:['Akiko Fudžita'],
scenography:['Morijasu Jasuhira']},
{title:'Teherán',
titleCZ:'Teherán',
year:2020,
runtime:'11h 56min',
episodeRuntime:'37-51min',
countries:['Israel'],
genres:['Drama','Thriller'],
director:['Daniel Syrkin'],
actors:['Niv Sultan','Shaun Toub','Menashe Noy','Shervin Alenabi','Navid Negahban','Liraz Charhi','Reza Diako','Dan Mor','Arash Marandi','Shila Ommi','Danny Sher','Moe Bar-El','Esti Yerushalmi','Vassilis Koukalani','Glenn Close','Darius Homayoun','Bahador Foladi','Hadi Khanjanpour','Elnaaz Norouzi','Tamir Ginsburg','Bijan Daneshmand','Behi Djanati Atai','Elshan Amaan','Lefteris Tsatsis','Sia Alipour','Hugh Laurie'],
screenplay:['Moshe Zonder'],
production:['Fenia Cossovitsa','Tal Leviathan'],
music:['Mark Eliyahu'],
camera:['Giora Bejach'],
cut:['Roni Klimowski','Dana Yardeni Lichter','Amir Winkler'],
sound:['Ami Arad'],
scenography:['Yoel Herzberg','Salim Shehade','Christine Vlachos'],
masks:['Ronit Dugo-Arbiv','Maya Grastal'],
costumes:["Deborah O'Hana"]},
{title:'Log Horizon',
titleCZ:'Log Horizon',
year:2013,
runtime:'25h 13min',
episodeRuntime:'24-25min',
countries:['Japan'],
genres:['Animation','Adventure','Fantasy','Comedy','Sci-Fi'],
director:['Šindži Išihira','Keniči Maedžima','Osamu Jamasaki','Mičio Fukuda','Naoki Murata','Goró Kudži','Takaši Andó','Keidži Kawakubo','Takanori Jano','Kazunobu Fuseki','Jošito Hata','Noriaki Saitó'],
actors:['Takuma Terašima','Jumi Hara','Nobuhiko Okamoto','Misaki Kuno','Ajahi Takagaki','Tecuja Kakihara','Emiri Kató','Hisako Kanemoto','Tomoaki Maeno','Júiči Nakamura','Takahiro Sakurai','Satoši Hino','Ajumi Fudžimura','Šinpači Cudži','Marina Inoue','Hiro Šimono','Džódži Nakata','Šóhei Kadžikawa','Čiwa Saitó','Nao Tamura','Genki Muro','Nacue Sasamoto','Šóta Jamamoto','Júiči Iguči','Marija Ise','Šiori Izawa','Čó','Eidži Mijašita','Kanami Sató','Kaori Nazuka','Rjóta Ósaka','Masaki Terasoma','Kenta Sasa','Sora Amamija','Acuši Imaruoka','Eriko Macui','Makoto Furukawa','Daiki Jamašita','Hiroki Gotó','Ikumi Hajama','Širó Saitó','Cubasa Jonaga','Júja Učida','Hiromi Igaraši','Hóčú Ócuka','Hiroši Cučida','Marika Kóno','Micuhiro Ičiki','Šúhei Sakaguči','Džundži Madžima','Risa Taneda','Anri Kacu','Ai Kakuma','Sajaka Óhara','Jošimicu Šimojama','Rjó Horikawa','Hiroši Janaka','Rie Murakawa','Ajaka Suwa','Jukijo Fudžii','Keidži Fudžiwara',"Šin'ičiró Miki",'Saki Fudžita','Mamiko Noto','Džunpei Asašina','Tomosa Murata','Hiroši Širokuma','Taiši Murata','Kengo Kawaniši','Júko Kaida','Jóko Sómi','Manaka Iwami','Nanami Jamašita','Toa Jukinari','Júki Šin','Aiko Ninomija','Megumi Sató','Jurie Kozakai','Jóhei Tadano','Hironori Saitó','Minami Takahaši','Masakazu Nišida','Šinnosuke Ogami','Jó Kitazawa','Arisa Kijoto','Takuja Nakašima','Masajuki Kató','Daisuke Hirakawa','Haruo Jamagiši','Juka Keičó','Nacuki','Jú Kitada','Asuka Ógame','Jutaka Aojama','Mičiko Kaiden','Širó Gó'],
basedOn:['Mamare Tóno'],
screenplay:['Tošizó Nemoto','Mičiko Itó','Šinsuke Óniši','Šingo Irie'],
music:['Jasuharu Takanaši'],
camera:['Júdžiró Jamane',"Šin'jo Kondó",'Tomohiro Kokacu'],
cut:['Rie Macubara','Gó Sadamacu'],
sound:['Šódži Hata'],
scenography:['Masakazu Mijake','Júki Nomura']},
{title:'Bakemonogatari',
titleCZ:'Bakemonogatari',
year:2009,
runtime:'6h 15min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Comedy','Mystery','Psychology','Romance'],
director:['Tacuja Oiši','Akijuki Šinbó','Šin Itagaki','Jukihiro Mijamoto','Tošimasa Suzuki','Džun Fukuda','Nobujuki Takeuči','Tomojuki Itamura','Jošinobu Tokumoto','Mičio Fukuda','Šin Ónuma','Ei Aoki'],
actors:['Hiroši Kamija','Čiwa Saitó','Jui Horie','Mijuki Sawaširo','Kana Hanazawa','Eri Kitamura','Emiri Kató','Takahiro Sakurai','Juka Iguči','Fumihiko Tačiki'],
basedOn:['Nišio Išin'],
screenplay:['Jukito Kizawa','Muneo Nakamoto'],
music:['Satoru Kósaki'],
camera:['Takajuki Aizu'],
cut:['Rie Macubara','Keiko Kadokawa','Hiromi Sasaki'],
sound:['Jóta Curuoka'],
scenography:['Tošiharu Iidžima']},
{title:'Charlotte',
titleCZ:'Charlotte',
year:2015,
runtime:'5h 12min',
episodeRuntime:'24min',
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Comedy'],
director:['Jošijuki Asai','Micutaka Nošitani',"Ken'iči Imaizumi",'Tošija Šinohara','Tomoaki Óta'],
actors:['Hikaru Midorikawa','Kotori Koiwai','Miki Itó','Mijuki Sawaširo','Tomokazu Sugita','Asami Seto','Kóki Učijama','Eidži Takemoto','Maaja Učida','Ajaka Suwa','Jošimasa Hosoja','Šizuka Išigami','Genki Muro','Takahiro Mizušima','Asako Dodo','Júsei Oda','Ajane Sakura','Kazujuki Okicu','Mai Nakahara','Tomomiči Nišimura','Jasuaki Takumi','Rjóta Ósaka','Kanehira Jamamoto','Sarah Emi Bridcutt','Júsuke Kobajaši','Tomoe Tamijasu','Nacuki Hanae',"Džun'iči Janagita",'Nacuko Kuwatani','Haruki Išija','Džundži Madžima','Rjóhei Kimura','Juiko Tacumi',"Ken'ičiró Macuda",'Makoto Furukawa','Jošitaka Jamaja','Daiki Jamašita','Kenšó Ono','Daisuke Ono','Kengo Kawaniši','Kentaró Kumagai','Daiki Hamano','Ajumi Cunemacu','Momo Asakura','Kóhei Amasaki','Ikudži Nose','Dai Macumoto','Itaru Jamamoto','Asami Takano','Hitomi Ówada','Eiičiró Tokumoto','Rjó Sugisaki','Jóhei Azakami','Acuši Ono','Kóiči Sóma','Kaori Nakamura','Nail Minai','Macuo Macuo','Dženja','Michael Rivas'],
screenplay:['Džun Maeda'],
production:['Hiró Marujama','Kendži Horikawa','Jósuke Toba'],
music:['Džun Maeda','Ai Kamači','Šújó Hikari'],
camera:['Kacufumi Sató'],
cut:['Ajumu Takahaši'],
sound:['Satoki Iida'],
scenography:['Kazuki Higašidži']},
{title:'The 7 Lives of Lea',
titleCZ:'Lea má 7 životů',
year:2022,
runtime:'5h 14min',
episodeRuntime:'41-52min',
countries:['France'],
genres:['Drama','Crime','Fantasy','Mystery','Thriller'],
director:['Julien Despaux','Émilie Noblet'],
actors:['Raïka Hazanavicius','Khalil Ben Gharbia','Théo Fernandez','Anne Azoulay','Mélanie Doutey','Samuel Benchetrit','Anouar H. Smaine','Maïra Schmitt','Kelly Bellacci'],
basedOn:['Nataël Trapp'],
screenplay:['Charlotte Sanson'],
production:['Raphaël Rocher'],
music:['Jean-Benoît Dunckel'],
camera:['Brecht Goyvaerts'],
sound:['Frédéric de Ravignan']},
{title:'Trying',
titleCZ:'Trying',
year:2020,
runtime:'15h 19min',
episodeRuntime:'26-33min',
countries:['UK'],
genres:['Comedy'],
director:["Jim O'Hanlon",'Elliot Hegarty'],
actors:['Esther Smith','Rafe Spall','Imelda Staunton','Sarah Niles','Robyn Cara','Simon Bubb','Ophelia Lovibond','Oliver Chris','Phil Davis','Paula Wilcox','Peter Bramhill','Sian Brooke','Darren Boyd','Diana Požarskaja','Cush Jumbo','Colin Hoult','Susannah Wise','Bruce Mackinnon','Dominic Rowan','Amber Aga','Karina Fernandez','Tomiwa Edun','Sagar Arya','Marian McLoughlin','Alison Lintott','Ian Barritt','Trystan Gravelle','Edward Bluemel','Colin Mace','Lorna Brown','Rick Bacon','James Millard','Fola Evans-Akingbola','Robert Goodman','Ambika Mod','Karl Collins','James Doherty','Eden Togwell','Mickey McAnulty','Joe Wilkinson','Rebekah Murrell','Tommy French','Alex Skarbek','Aurélie Meriel','Mark Kempner','Navin Chowdhry','Fiona Button','Fern Deacon','Olwen May','Ciara Baxendale','Philippa Carson','Brigid Zengeni','Mercedes Grower','Ben Starr','Tom Stourton','Muzz Khan','Sarah Sharman','Joyce Veheary','George Georgiou','Ossian Perret','Tom Bennett','Marcus Garvey','Rich Keeble','Nneka Okoye','Iain Stirling',"Denis O'Hare",'Taj Atwal','Harvey Sadler','Andrea Hall','Elodie Blomfield','Ntiarna Xavier Knight','Phoenix Laroche','Billie Gadsdon','Kaylen Luke'],
screenplay:['Andy Wolton'],
production:['Emma Lawson','Sam Pinnell'],
music:['Paul Saunderson'],
camera:['Arthur Mulhern','Jonas Mortensen','Greg Duffield'],
cut:['Mark Hermida','Mark Thornton','Peter Oliver','Mark Henson','Andy Kinnear'],
sound:['Caroline Singh','Jamie Selway'],
scenography:['John Stevenson','Sarah-Jane Prentice','Jonnie Mead','Emma Davis'],
masks:['Pamela Ip','Kate Medland'],
costumes:['Ros Little','Jessie Fell','Elizabeth Healy']},
{title:'In Living Color',
titleCZ:'In Living Color',
year:1990,
runtime:null,
episodeRuntime:'147x30min',
countries:['USA'],
genres:['Comedy'],
director:['Paul Miller','Keenen Ivory Wayans','Fax Bahr','Adam Small','Matt Wickline'],
actors:['Keenen Ivory Wayans','Jim Carrey','Tommy Davidson','David Alan Grier','Kelly Coffield Park','Kim Wayans','Chris Rock','Shawn Wayans','Anne-Marie Johnson','Chris Carrara','Jennifer Lopez','Jamie Foxx','Marlon Wayans','Carrie Ann Inaba','Damon Wayans','Damien Dante Wayans','Eazy-E','Big Daddy Kane','Alexandra Wentworth','Symba','Loren Avedon','Denise Richards','Steve Oedekerk','Phil Beauman','Sean Moran','Alex Datcher','Carlos Mencia','Endre Hules','John Bradley','Del Zamora','Zahn McClarnon','Brian George','Nick Bakay','Chris Browning','George Skaff','Jay Leggett',"Ed O'Neill",'Danielle Harris','Larry Wilmore','Kellita Smith','Brian Donovan','Kari Coleman','David Jean Thomas','Riley Weston','Ann Yen',"Marilyn O'Connor",'Kim Coles','Nancy Giles','LaWanda Page','Madison Mason','Bob Cooper','Eric Mansker','Donna Spangler','Gina Ravera','Alfredo Septién','Rosie Perez','Robert Bauer','Eric Freeman','Jean-Paul Vignon','Joe George','Mitchell Laurance','Ellen Cleghorne','Phyllis Applegate','DeJuan Guy','Brad Grunberg','Dwayne Alexandre','Rocky Giordani','Steve Park','Lloyd Kino','Ahmad Stoner','Yvette Wilson','Chris Spencer','Jossie Thacker','MC Lyte','Dwayne Wayans','Jonathan Chapin','Alex Ardenti','Thomas F. Duffy','Jeris Poindexter','Alex Brown','Michael Krawic','Renee Tenison','Wonderful Smith','Rick Goldman','Allan Murray','Lori Fetrick','Ángel Salazar','Jennifer Joyce','J. Marvin Campbell','Troy Thirdgill','Chris Fiore','Kipp Shiotani','Dean Hill','Thomas Hobson','Alex Thomas','Michael Gier','Mitch Watson','Jeanne Basone',"T'Keyah Crystal Keymáh",'Bill Feeney'],
screenplay:['Keenen Ivory Wayans','Phil Beauman','Mark Brazill','Ron Hauge','Marlon Wayans','Steve Tompkins','Shawn Wayans','Tim Kelleher','Nick Bakay','Larry Wilmore','Colin Quinn','Pam Veasey','Todd R. Jones','Earl Richey Jones','Fax Bahr','Franklyn Ajaye','Paul Mooney','Damon Wayans','Rick Najera','Steve Oedekerk','Greg Fields','Bill Martin','Mike Schiff','Adam Small',"T'Keyah Crystal Keymáh",'Nancy Neufeld Callaway','John Bowman','Matt Wickline','Barry Douglas','Michelle Jones','Becky Hartman Edwards','Wayne Kline','Al Sonja L. Rice','Jeanette Collins','Joe Toplyn','Spencer Green'],
production:['Kevin Berg','Kevin Bright'],
music:['Tom Rizzo'],
cut:['Darryl Bates','Kris Trexler','Jerry Davis','Ken Denisoff'],
sound:['Bruce Peters'],
scenography:['John Sabato','Lissa Kapstrom'],
masks:['Greg Nelson','Gail Rowell-Ryan','Christy Ann Newquist','Ann Wadlington','Pinky Cunningham'],
costumes:['Michelle Cole']},
{title:'Time Between Dog and Wolf',
titleCZ:'Gaewa neukdaeeui sigan',
year:2007,
runtime:'18h 40min',
episodeRuntime:'70min',
countries:['South Korea'],
genres:['Drama','Romance','Action'],
director:['Jin-min Kim'],
actors:['Joon-gi Lee','Kyeong-ho Jeong','Sang-mi Nam','Jae-seong Choi','Kyeong-soon Jeong','Ji-ho Choi','Hyo-joon Park','Tae-seong Lee','Hyeok-kwon Park','Soo-yeon Cha','Geon-tae Park','Seong-mo Jeong','Jin-ho Choi','Jeong-nan Kim','Gi-yeong Lee','Ye-seul Park','Mi-young Lee','Seon-woo Park','Jeong-rim Goo','Natallia Bulynia'],
screenplay:['Soo-il Jeon','Ji-hoon Han','Yong-jae Ryoo'],
production:['Shin-Ae Yoon']},
{title:'Přítelkyně z domu smutku',
titleCZ:'Přítelkyně z domu smutku',
year:1992,
runtime:'4h 33min',
episodeRuntime:'66-70min',
countries:['Czechoslovakia'],
genres:['Drama'],
director:['Hynek Bočan'],
actors:['Ivana Chýlková','Aňa Geislerová','Jiřina Bohdalová','Jana Boušková','Helena Růžičková','Zdena Hadrbolcová','Vilma Cibulková','Ljuba Krbová','Simona Stašová','Michaela Kuklová','Michal Dlouhý','Pavel Nový','Oldřich Navrátil','František Řehák','Veronika Žilková','Emma Černá','Jaroslava Obermaierová','Ilona Svobodová','Marek Vašut','Yvetta Blanarovičová','Pavlína Mourková','Klára Jirsáková','Hana Brejchová','Jaroslav Šmíd','Bohuslav Čáp','Blažena Holišová','Václav Vydra nejml.','Otakar Brousek ml.','Bronislav Kotiš','Luděk Nešleha','Karel Bělohradský','David Suchařípa','Mirko Musil','Miroslav Saic','Jiří Havel','Petr Pelzer','Martina Menšíková','Pavel Trávníček','Vladimír Kratina','Ernesto Čekan','Ladislav Goral','Miroslav Nohýnek','Veronika Jeníková','Alena Kreuzmannová','Oldřich Vlach','Jindřich Hinke','Vladimír Drha','Jan Hartl','Margita Reiznerová'],
basedOn:['Eva Kantůrková'],
screenplay:['Eva Kantůrková','Václav Šašek'],
music:['Jiří Svoboda'],
camera:['Jiří Šámal'],
cut:['Miloslav Liška'],
sound:['Pavel Dvořák'],
scenography:['Václav Hlávka'],
masks:['Eva Šidlíková','Jiří Sadílek'],
costumes:['Svatava Sophová','Zdena Kočová','Michaela Prokešová']},
{title:'Wayne',
titleCZ:'Wayne',
year:2019,
runtime:'5h 36min',
episodeRuntime:'31-35min',
countries:['USA'],
genres:['Action','Comedy'],
director:['Steve Pink','Tessa Hoffe','Michael Patrick Jann','Iain B. MacDonald','Stephanie Laing'],
actors:['Ciara Bravo','Mark McKenna','Jamie Champagne','Jon Champagne','James Earl','Francesco Antonio','Dean Winters',"Mike O'Malley",'Patrick Gallagher','Maxwell McCabe-Lokos','Lisa Berry','Juno Rinaldi','Ernie Grunwald','Keara Graves','Donald MacLean Jr.','Thomas Mitchell Barnet','Joshua J. Williams','Ray McKinnon','Kirk Ward','Kaniehtiio Horn','Janet Porter','Josh Cruddas','Torri Webster','Arden Alfonso','Donald Burda','Zoe Doyle','Alexander Nunez','Juan Carlos Velis','Daniel Jun','Abigail Spencer','August Winter','Odessa A’zion','Zoé De Grand Maison','Geoff Scovell','Peyton Meyer','Michaela Watkins','Derek Theler','Akiel Julien','Keana Lyn Bastidas','Sima Fisher','Nadine Bhabha','Edsson Morales','Dan Abramovici','Nadine Roden','Sean Patrick Dolan','Diya Kittur','JaNae Armogan','Marium Carvell','Rachel Manson'],
screenplay:['Shawn Simmons','Rhett Reese','Paul Wernick','Greg Coolidge','Kirk Ward','Sarah Jane Cunningham','Lauren Houseman','Paul Jaffe'],
production:['John Ryan'],
music:['Steven Argila'],
camera:['D. Gregor Hagey'],
cut:['Les Butler','Michael Stern','Tom Lewis','Omar Hassan-Reep'],
sound:['Andrew Spencer Dawson'],
scenography:['Aidan Leroux'],
masks:['Patrice Boudreau','Samantha Terry'],
costumes:['Julia Patkos','Megan Oppenheimer']},
{title:'Hadžime no Ippo: The Fighting - New Challenger',
titleCZ:'Hadžime no Ippo: The Fighting - New Challenger',
year:2009,
runtime:null,
episodeRuntime:'26x25min',
countries:['Japan'],
genres:['Animation','Drama','Comedy','Sport'],
director:['Džun Šišido','Hisato Šimoda','Jošifumi Sueda','Fumie Muroi'],
actors:['Tomokazu Seki','Wataru Takagi','Akio Ócuka','Daisuke Namikawa','Šózó Iizuka','Unšó Išizuka','Keidži Fudžiwara','Kóhei Kijasu','Kendži Ucumi','Daisuke Sakaguči','Júiči Nakamura','Jú Kobajaši','Ajaka Šimizu','Takaja Kuroda','Šóko Cuda','Minoru Inaba','Masaki Aizawa',"Mari Joko'o",'Sakiko Tamagawa','Emi Šinohara',"Ken'jú Horiuči",'Tomojuki Šimura','Kendži Nomura','Takaši Óhara','Joriko Nagata','Džin Horikawa','Micuaki Madono','Nobujuki Furuta',"Ken'iči Ono",'Nobuaki Fukuda','Seidži Sasaki','Masahiko Tanaka','Megumi Macumoto','Kikuko Inoue',"Kei'iči Sonobe",'Kensuke Sató','Micuru Ogata','Tóru Ókawa','Jutaka Kóno','Takuja Sató','Čikara Ósaka','Kunpei Sakamoto','Naoko Sugiura','Noriko Fudžimoto','Cutomu Densaka','Naomi Wakabajaši','Rikija Kojama','Tošihiko Nakadžima','Ikumi Nakagami','Mie Sonozaki','Mičio Mijašita','Takuma Suzuki','Noriko Obata','Tomoko Nakamura','Satoru Inoue','Masajuki Kató','Seiko Ueda','Kijoši Kacunuma','Júsuke Kabuta','Masaši Sugawara','Masajuki Omoro','Misaki Sekijama','Kendži Takahaši','Keigo Manaka','Rjúta Morikawa','Kazutoši Hatano','Aki Nakadžima','Kazumi Makabe','Júka Nakacukasa','Kensuke Niši','Kunio Ida','Biiči Sató','Šódži Izumi','Juka Hirata','Jú Amano','Kacunori Kobajaši','Mari Kanó','Jasutaka Sonoda','Genta Fukuda'],
basedOn:['George Morikawa'],
screenplay:['Fúta Takei'],
production:['Tošio Nakatani'],
music:['Jošihisa Hirano'],
camera:['Júja Kumazawa'],
sound:['Masafumi Mima','Tošihiko Nakadžima'],
scenography:['Hidetoši Kaneko']},
{title:'The Girls at the Back',
titleCZ:'Holky ze zadních lavic',
year:2022,
runtime:'4h 20min',
episodeRuntime:'39-45min',
countries:['Spain'],
genres:['Comedy','Drama'],
director:['Daniel Sánchez Arévalo'],
actors:['Maria Rodríguez Soto','Javier Rey','Itsaso Arana','Godeliv Van den Brandt','Mariona Terés','Monica Miranda','Macarena García','Melina Matthews'],
screenplay:['Daniel Sánchez Arévalo'],
sound:['Jaime Barros','Miriam Lisón'],
scenography:['Curru Garabal'],
costumes:['Nazareth Colomina']},
{title:'Dear Child',
titleCZ:'Milé dítě',
year:2023,
runtime:'4h 50min',
episodeRuntime:'46-51min',
countries:['Germany'],
genres:['Crime','Drama','Thriller','Mystery'],
director:['Isabel Kleefeld','Julian Pörksen'],
actors:['Kim Riedle','Naila Schuberth','Sammy Schrein','Hans Löw','Justus von Dohnányi','Julika Jenkins','Haley Louise Jones','Nagmeh Alaei','Christian Skibinski','Eskindir Tesfay','Christian Beermann','Seraphina Schweiger','Özgür Karadeniz','Birge Schade','Jeanne Goursaud','Antje Mairich','Juri Senft','Samy Challah','Zeljka Preksavec','Katharina Hackhausen','Asmae Gassa','Sotiria Loucopoulos','Max Woelky','Alexander Koll','Florian Steffens','Jing Xiang','Denis Schmidt','Birte Schrein','Makke Schneider','Christian Kerepeszki','Jele Brückner','Kenan Dogus Özmen','Michael Che Koch','Kaspar Schellingerhout','Ina Höffgen','Paul Dächert','Barbara Schmidt','Rainer Sellien','Günfer Cölgecen','Joris Gratwohl','Andreas Grothgar','Oliver Hermsen'],
basedOn:['Romy Hausmann'],
screenplay:['Isabel Kleefeld','Julian Pörksen'],
production:['Friederich Oetker','Tom Spieß'],
music:['Juan Luqui','Gustavo Santaolalla'],
camera:['Martin Langer','Alexander Fischerkoesen'],
cut:['Christoph Cepok','Renata Salazar Ivancan'],
scenography:['Cordula Jedamski'],
masks:['Mirjam Himmelsberger'],
costumes:['Genoveva Kylburg']},
{title:'JourneyQuest',
titleCZ:'JourneyQuest',
year:2010,
runtime:null,
episodeRuntime:null,
countries:['USA'],
genres:['Action','Adventure','Comedy','Fantasy'],
director:['Matt Vancil','Ben Dobyns'],
actors:['Cornelia Moore','Alyssa Kay','Emilie Rommel Shimkus','Samara Lerman','Mason Lahd Wilkerson'],
cut:['Ben Dobyns']},
{title:'Gu Family Book',
titleCZ:'Gugaui seo',
year:2013,
runtime:'25h 7min',
episodeRuntime:'62-63min',
countries:['South Korea'],
genres:['History','Fantasy','Drama','Romance'],
director:['Jeong-hyeon Kim','Woo-cheol Shin','Jung-Hyun Kim'],
actors:['Seong-ha Jo','Hye-yeong Jeong','Hee-won Kim','Seong-jae Lee','Seung-gi Lee','Suzy Bae','Joon Seong','Yeon-hee Lee','Jin-hyeok Choi','Kjong Džin','Yeon-seok Yoo','Rjóhei Ótani','Hyo-seop Eom','Yoo-bi Lee','Dong-geun Yoo','Bo-mi Kim','Jae-yoon Jo','Joon-won Jeong','Do-kyeong Lee','David Lee','Hee-jeong Kim','Sung-tae Heo','Se-ah Yoon','Ki-bang Kim','David Lee McInnis','Seong-hyeon Ryoo','Min-ah Jo','Ga-young Son','Dae-seong Choi','Yeong-gyu Song'],
screenplay:['Eun-kyeong Kang']},
{title:'Flowers',
titleCZ:'Flowers',
year:2016,
runtime:'4h 59min',
episodeRuntime:'23-28min',
countries:['UK'],
genres:['Comedy','Drama'],
director:['Will Sharpe'],
actors:['Sophia Di Martino','Olivia Colman','Julian Barratt','Daniel Rigby','Will Sharpe','Leila Hoffman','Georgina Campbell','Desiree Akhavan','Adeel Akhtar','Anna Chancellor','Alastair Roberts','Zita Sattar','Christopher Colquhoun','Sharon Young','Hammed Animashaun','Kathryn Hunter','Angus Wright','Emily Lloyd-Saini','Al Roberts'],
screenplay:['Will Sharpe'],
production:['Sam Pinnell','Emma Kingsman-Lloyd'],
music:['Arthur Sharpe'],
camera:['Jamie Cairney'],
cut:['Selina Macarthur'],
sound:['Gareth Bull','Richard Straker','James Ridgway'],
scenography:['Luana Hanson','Beckie Harvey'],
masks:['Sjaan Gillings','May Liddell-Grainger','Michele Davidson Bell'],
costumes:['Sam Perry']},
{title:'Les Misérables',
titleCZ:'Bídníci',
year:2018,
runtime:null,
episodeRuntime:'6h60min',
countries:['UK','USA'],
genres:['Drama','History','Romance'],
director:['Tom Shankland'],
actors:['Dominic West','David Oyelowo','Olivia Colman','Adeel Akhtar','Lily Collins','Ellie Bamber','Turlough Convery','Kathryn Hunter','Donald Sumpter','David Bradley','Emma Fielding','Henry Lloyd-Hughes','Jean-Louis Sbille','Ann Firbank','Johnny Flynn','Derek Jacobi','Reece Ritchie','Lily Newmark','Ron Cook','Patricia Allison','Erin Kellyman','Archie Madekwe','Isis Hainsworth','Erin Doherty',"Josh O'Connor",'Mailow Defoy','Ayoola Smart','Darren Kent','Ashley Artus','Andrew Paul','Hayley Carmichael','André Pasquasy','Alan David','Woody Norman','Lorcan Cranitch','Sean Cernow','Matthew Steer','Liz Carr','Henry Lawfull','Natalie Simpson','Abraham Popoola'],
basedOn:['Victor Hugo'],
screenplay:['Andrew Davies'],
production:['Chris Carey'],
music:['John Murphy'],
camera:['Stephan Pehrsson'],
cut:['Úna Ní Dhonghaíle','Danielle Palmer','Paulo Pandolpho'],
scenography:['Richard Bullock','Ilse Willocx'],
masks:['Anne Moralis','Marie Messien'],
costumes:['Marianne Agertoft']},
{title:'The Borgias',
titleCZ:'Borgiové',
year:2011,
runtime:'24h 42min',
episodeRuntime:'46-58min',
countries:['Canada','Ireland','Hungary'],
genres:['Drama','History','Crime'],
director:['Neil Jordan','Kari Skogland','John Maybury','Jon Amiel','David Leland','Jeremy Podeswa','Simon Cellan Jones'],
actors:['Jeremy Irons','François Arnaud','Holliday Grainger','Peter Sullivan','Sean Harris','Joanne Whalley','Lotte Verbeek','Colm Feore','David Oakes','Gina McKee','Julian Bleach','Vernon Dobtcheff','Bosco Hogan','Thure Lindhardt','Sebastian De Souza','Steven Berkoff','Ruta Gedmintas','Ronan Vibert','Michel Muller','Luke Pasqualino','Prometheus Aleifer','Pilou Asbæk','Abraham Belaga','Simon McBurney','Roger Lloyd Pack','Noah Silver','László Konter','Augustus Prew','Cyron Melville','Edward de Souza','Björn Hlynur Haraldsson','Brendan Cowell','David Alpay','Charlie Carrick','Peter Stebbings','Tom Austen','Mickey Sumner','Jemima West','Ivan Kaye','Melia Kreiling','Emmanuelle Chriqui','Derek Jacobi','Attila Árpa','David Dencik','Edward Hogg','Noah Taylor','Robert Cavanah','Serge Hazanavicius','Richard Durden','David Bamber','Nicholas Rowe','Russ Bain','Matt Stokoe','Robert Demeger','Richard Bremmer','Elyes Gabel','Sarah Solemani','Ondra Dorian','Danny Midwinter','Jamie Blackley','Darwin Shaw','Matt Devere','Matias Varela','Leo Bill','Ferenc Hujber','Luke Allen-Gale','Callum Turner','Jamie Beamish','Caitlin Joseph',"Nathan O'Toole",'Péter Horkay','Declan Hannigan','Emily Taaffe','Mackenzie Munro','Sam Keeley','Edward Petherbridge','Csaba Vékes','Sarah Finigan','Giacomo Gonnella','David Dawson','Zoltán Schmied','Dermot Keaney','Donal Gallery',"Patrick O'Kane",'Helen Bradbury','Andrew Gower','Gabriela Dorantová','Charlie Anson','Edmund Kingsley','Steven Hartley','Alex Lanipekun','Linda Marlowe','Montserrat Lombard','Anne Lambton','Simon Gregor','Arkie Reece','Lucy Drive','Jalaal Hartley','Máté Haumann','Richard Rifkind'],
screenplay:['Neil Jordan','Guy Burt','David Leland'],
production:['Bill Goddard'],
music:['Trevor Morris'],
camera:['Paul Sarossy','Pierre Gill','David Johnson'],
cut:['Tony Lawson','Wendy Hallam Martin'],
sound:['Martin Lee','Kirk Lynds'],
scenography:['François Séguin','Judit Varga','Jonathan McKinstry'],
costumes:['Gabriella Pescucci']},
{title:'Catastrophe',
titleCZ:'Catastrophe',
year:2015,
runtime:'9h 52min',
episodeRuntime:'23-28min',
countries:['UK'],
genres:['Comedy'],
director:['Ben Taylor',"Jim O'Hanlon"],
actors:['Sharon Horgan','Rob Delaney','Carrie Fisher','Ashley Jensen','Jonathan Forbes','Tobias Menzies','Daniel Lapaine','Sam Spruell','Deborah Rosan','Mark Bonnar','Phil Nichols','Eileen Walsh','John Hopkins','Susannah Fielding','Grant Gillespie','Andrew Byron','Amanda Hale','Lauren Socha','Elena Saurel','Sophie Fletcher',"Ki' Juan Whitton",'Samantha Ledda','Reece Pockney','Sarah Niles','Marta Barrio','Kate Kennedy','Robin Sebastian','Clarence Smith','Frances Tomelty','Janey Lawson','Gary Lilburn','Shola Adewusi','Claire Dargo','Terri-Ann Brumby','Suzette Llewellyn','Margaret Cabourn-Smith','Emmanuelle Bouaziz','Kirsten Hazel Smith','Caroline Lena Olsson','Forbes Masson','Nicole Gibson','Doron Davidson','Peter De Jersey','Paul Cawley','Serena Evans','Rebecca Herod','Taniel Yusef','Phil Dunster','Muzz Khan','Seeta Indrani','Monica Dolan','Celyn Jones','Oliver Ford Davies','Domhnall Gleeson','Douglas Hodge','Lloyd Hutchinson','Ruth McCabe','Jordan Stephens','Julie Hesmondhalgh','Leila Hoffman','Michaela Watkins','Catherine Skinner','Woody Norman','Nick Davison','William Gaminara','Brian Gleeson','Chris Noth','Nat Faxon','David Alan Grier','Mitchell Mullen','Dominic Rowan','Hainsley Lloyd Bennett','Jenny Bede','Ken Nwosu','Emily Lloyd-Saini','Kai Alexander','Sandra Dumaresq','Mathieu Dufresne','Yemisi Oyinloye','Dan Durda','Tonya Cornelisse'],
screenplay:['Sharon Horgan','Rob Delaney'],
production:['Adam Tandy','Jack Bayles','Toby Welch'],
music:['Oli Julian'],
camera:['Adam Etherington','Richard Mott','Oli Russell','Daniel Stafford-Clark','Mattias Nyberg'],
cut:['Steve Ackroyd','Christopher Watson'],
scenography:['Monica Black','Samantha Harley','Chris Richmond','Miranda Jones','Dominic Smithers'],
masks:['Jacquetta Levon'],
costumes:['Matthew Price','Elizabeth Healy','Amanda Monk','Rebecca Duncan','Rosa Dias']},
{title:'Undone',
titleCZ:'Undone',
year:2019,
runtime:'7h 11min',
episodeRuntime:'22-30min',
countries:['USA'],
genres:['Animation','Drama','Fantasy'],
director:['Hisko Hulsing'],
actors:['Bob Odenkirk','Rosa Salazar','Kevin Bigley','Angelique Cabral','Siddharth Dhananjay','Natasha Ofili','Lotus Blossom','Blue Chapman','Joel Steingold','Constance Marie','Alma Martinez','Santiago Cabrera','Ana Ortiz','Sheila Vand','Renee Victor','Fernanda Romero','Holley Fain','Ryan Lopez','Allan McLeod','Brian Gattas','Zabeth Russell','Yael Grobglas','Anthony Nikolchev','Luzer Twersky','Daveed Diggs','John Corbett','Nicholas Gonzalez','Tyler Posey','Jeanne Tripplehorn','Vico Escorcia','Raphael Bob-Waksberg','Percy Daggs III','Tara Karsian','Christine Avila','Brad Hall','Gaby Moreno','Keiko Agena','Edy Ganem','James Mathis III','Laura Patalano','Tonantzin Carmelo','Jorge Diaz','Veda Cienfuegos','Romi Dias'],
screenplay:['Raphael Bob-Waksberg','Joanna Calo','Kate Purdy','Patrick Metcalf','Elijah Aron','Gonzalo Cordova','April Shih','Carmiel Banasky','Mehar Sethi','Lauren Otero'],
production:['Richard Choi','Bob Odenkirk','Rosa Salazar','Patrick Metcalf','Bruno Felix','Femke Wolting'],
music:['Amie Doherty'],
camera:['Nick Ferreiro'],
cut:['Brian Swanson'],
sound:['Hunter Curra','Jeff Halbert','Konrad Piñon'],
scenography:['Hisko Hulsing'],
costumes:['Atara Glazer']},
{title:'Roboti aniya',
titleCZ:'Roboti aniya',
year:2017,
runtime:'16h 28min',
episodeRuntime:'26-37min',
countries:['South Korea'],
genres:['Romance','Sci-Fi','Drama'],
director:['Dae-yoon Jeong'],
actors:['Seung-ho Yoo','Soo-bin Chae','Seung-eon Hwang','Se-wan Park','Ki-yeong Kang','Byeong-joon Lee','Ki-joon Um','Min-ji Lee','Byeong-ho Son','Hyo-seop Eom','Ha-kyoon Kim','Si-eon Lee','Kyeong-ho Yoon','Ki-doo Kim','Gun-han Ko','Jae-ryong Song','Dong-yong Lee'],
screenplay:['Seon-mi Kim','Suk-joon Lee']},
{title:'Love 101',
titleCZ:'Love 101',
year:2020,
runtime:'12h 12min',
episodeRuntime:'34-53min',
countries:['Turkey'],
genres:['Drama','Romance'],
director:['Ahmet Katiksiz','Deniz Yorulmazer','Gönenç Uyanık','Umut Aral'],
actors:['Mert Yazıcıoğlu','Alina Boz','Kubilay Aka','Selahattin Paşalı','Ece Yüksel','İpek Filiz Yazıcı','Müfit Kayacan','Fatih Al','Pınar Deniz','Kaan Urgancıoğlu','Bade İşçil','Uğur Arda Başkan','Samet Kaan Kuyucu','Ramiz Mullamusa','Merve Akkaya','İdil Arkut Malhan','Sekvan Serinkaya','Gümeç Alpay Aslan','Selen Domaç','Fahri Öztezcan','Nil Günal','Cengiz Tangör','Ebru Soyuerdem','Aybanu Aykut','Kenan Demirok','Ozan Bingöl','Hüseyin Şirin','Erdem Duran','Zeynep Melis Girşen','Özgür Daniel Foster','Tayfun Gölbaşı','Cihat Akaydın','Murat Topçınar','Yağmur Pekel','Yahya Çelebi','Eyüp Fariz Dal','Fehmi Tuğcu','Melih Köklü','Tuba Ünsal','Meltem Pamirtan','Firat Bozan','Hacer Togay','İhsan Örs','Gizem Erdem','Onur Ayçelik','Hakan Onat','Fırat Gürsoy','Melis Minkari','Özgür Sürek','Ferhat Ayvaz','Ümit Kaplan','Hayrullah Tarhan Karagöz','Metin Dağıtır','Ogeday Girişken','Caner Nalbantoğlu','Batu Kalabalık','Esra Önen','Seda Kement','Yavuz Aksoy','Ayferi Ertek','Oben Onur','Alin İrem Demir','Lal Ensari','Rıdvan Aslan','Canan Ayşima Veli','Levent Aras','Nazan Beydili','Mert Fırat','Ali İl','Cüneyt Yalaz','Aslı Şahin','Bilgesu Kural','İrem Akgündüz','Seda Bozkurt','Muharrem Sedat Develik','Fatih Artman','Murat Yılancı','Neslihan Uludağ','Onur Cavit İdin','Uraz Kaygılaroğlu','Enginay Gültekin','Kaan Koçak','İzel Demirhan','Eren Dinç','İlker Kepezkaya','Kastriot Hetemi','Ali Eren Bulut','Selin Persentili Aral','Olivier Paris'],
screenplay:['Meriç Acemi'],
production:['Kerem Çatay'],
music:['Marios Takoushis'],
camera:['Vedat Özdemir'],
cut:['Ahmet Can Çakırca','Korhan Koryürek','Murat Başören','Adil Yanık','Aziz İmamoğlu'],
sound:['Serkan Köseoğlu'],
scenography:['Deniz Göktürk','Barış Yıkılmaz','Aslı Dadak','Zeynep Koloğlu','Erim Gayretli','Sedef Ramazanoğulları','Yunus Harani','Görkem Canbolat'],
masks:['Salih Ümit Meral']},
{title:'The Fury',
titleCZ:'Rapl',
year:2016,
runtime:'26h 4min',
episodeRuntime:'58-70min',
countries:['Czechia'],
genres:['Crime','Drama','Thriller','Action'],
director:['Jan Pachl'],
actors:['Hynek Čermák','Lukáš Příkazký','Alexej Pyško','Lucie Žáčková','Tomáš Jeřábek','Jan Dolanský','Dana Černá','Jiří Vyorálek','Aneta Krejčíková','Stanislav Majer','Jitka Ježková','Igor Bareš','Přemysl Bureš','Jan Kačer','Igor Orozovič','Klára Cibulková','Sara Sandeva','Kristýna Frejová','Radek Bruna','Pavel Tesař','Tomáš Racek','David Punčochář','Hana Igonda Ševčíková','Martin Matejka','Petr Kučera','Zdeněk Pecháček','Anna Klausnerová','Oldřich Vlach','Miroslav Etzler','Cyril Drozda','Filip Menzel','Tomáš Dianiška','Hana Kusnjerová','Miroslav Hruška','Marie Durnová','Jan Jankovský','Veronika Lapková','Lukáš Vaculík','David Stecher','Jan Přibyl','Karel Beseda','Martin Kraus','Marie Jansová','Jan Novotný','Tomáš Pavelka','Aleš Putík','Zdeněk Dolanský','Vítězslav Bouchner','Jan Vápeník','Pavel Bezděk','Vjačeslav Pleškov','Halina Richtrová','Martin Písařík','Jakub Kropáček','Viktorie Čermáková','Lilian Sarah Fischerová','Vladimír Marek','René Přibil','Vasil Fridrich','Roman Hájek','Richard Samko','Veronika Maxová','Miroslav Lhotka','David Šamko','Marek Jano','Richard Karol','Tomáš Turek','Marta Dřímal Ondráčková','Miroslav Babuský','Ivana Wojtylová','Hana Seidlová','Chi Chi Tornado','Barbora Vágnerová','Simona Postlerová','Jan Slovák','Roman Vojtek','Filip Bařina','Ondřej Hyneš','Pavel Nečas','David Lištván','Nguyen Guang Huy','Jiří Kraus','Martin Finger','Magdalena Sidonová','Tereza Nekudová','Dušan Sitek','Otmar Brancuzský','Roman Štabrňák','Peter Hosking','Libor Hruška','Philipp Schenker','Václav Vašák','Jiří Maryško','Richard Němec','Martin Zahálka','Lam Le Ngoc','Lada Jelínková','Michal Zelenka','Jiří Zeman','Petr Drozda'],
screenplay:['Jan Pachl'],
production:['Josef Viewegh'],
music:['Tadeáš Věrčák'],
camera:['Marek Janda','Pavel Berkovič','Václav Tlapák'],
cut:['Petr Pauer'],
sound:['Petr Čechák','Lukáš Martina','David Matušek','Lukáš Moudrý'],
scenography:['Pavel Ramplé'],
masks:['Dana Kleňhová','Hana Šímová','Kateřina Přeučilová','Tereza Malá','Jana Bílková','Ivo Strangmüller'],
costumes:['Vladimíra Fomínová']},
{title:'Hurvínek vzduchoplavcem',
titleCZ:'Hurvínek vzduchoplavcem',
year:1997,
runtime:null,
episodeRuntime:'42min6min',
countries:['Czechia'],
genres:['Puppets','Family'],
director:['Libuše Koutná'],
actors:['Miloš Kirschner','Helena Štáchová'],
screenplay:['Miloš Kirschner','Vladimír Straka'],
music:['Petr Skoumal'],
camera:['Svatopluk Malý','Věra Štinglová'],
cut:['Jan Horný'],
sound:['Jan Štorek']},
{title:'Inu Yasha',
titleCZ:'Inujaša',
year:2000,
runtime:'77h 38min',
episodeRuntime:'24-25min',
countries:['Japan'],
genres:['Animation','Adventure','Drama','Fantasy','Comedy','Romance'],
director:['Tošija Šinohara','Micuko Kase','Kaoru Suzuki','Kazuhisa Takenouči','Cukasa Sunaga','Akira Nišimori','Tomoe Aratani','Hirofumi Ogura','Tacuja Išihara','Masajuki Mijadži','Megumi Jamamoto','Kijoši Fukumoto','Jasunao Aoki','Jukio Nišimoto','Jasuhiro Takemoto','Tošifumi Kawase','Masaši Ikeda','Susumu Nišizawa','Teruo Sató','Masakazu Hišida','Masami Hata','Hitojuki Macui','Masaši Abe','Noriaki Akitaja','Takahiko Kjógoku','Takeši Furuta','Acuši Jano','Kendži Kodama','Jasuo Iwamoto','Masakazu Amija','Akira Toba','Takaši Ikehata','Naoki Hišikawa','Kunihiro Mori'],
actors:['Jošinori Sonobe','Tomohisa Asó','Hikaru Hanada','Kazuja Nakai','Rjúgo Saitó','Hidenari Ugaki','Seidži Sasaki','Takeši Aono','Rie Iwacubo','Ricuko Šimamune','Jó Kitazawa','Maju Šibata','Tojoko Nagaki','Masatojo Tecuno','Akira Kasahara','Minako Ičiki','Jumi Kakazu','Kaori Mizuhaši','Miho Jamada','Akiko Suzuki','Kazunari Tanaka','Kódži Watanabe','Júdži Ueda','Jasunari Tadžima',"Šin'iči Namiki",'Rieko Takahaši','Tošihiko Nakadžima','Dai Macumoto','Nacuko Fudži','Nami Okamoto','Jú Kobajaši','Kóki Harasawa','Šinpači Cudži','Hikari Tačibana','Jošiko Mori','Džódži Janami','Takajuki Fudžimoto','Kamioka Šizukeko','Masahiko Tanaka','Júko Mizutani','Jasuhiko Tokujama','Jošino Ótori','Hiroja Išimaru','Jóhei Óbajaši','Jumi Kuroda','Kaori Šimizu','Motoko Kumai','Taró Jamaguči','Wakana Jamazaki','Takehito Kojasu','Haruko Kitahama','Jú Urata','Hiroaki Hirata','Kazuaki Itó','Šinobu Sató','Kumiko Watanabe','Tarako','Acuši Godai','Sacuki Jukino','Haruka Šimazaki','Šigenori Sója','Širó Saitó','Hidejuki Hori','Masaja Takacuka','Asami Sanada','Noriko Jošitake','Hitomi Nabatame','Jukana','Tomojuki Šimura','Takajasu Usui','Sači Macumoto','Rjúzaburó Ótomo','Kumiko Higa','Hisao Egawa','Júko Minaguči','Kacuhiro Kitagawa','Kódži Cudžitani','Hiroko Taguči','Megumi Nasu','Sajaka Aida','Masako Kacuki','Tecu Inada','Miki Cučija','Akira Išida','Naoki Tacuta','Nozomu Sasaki','Šizumi Niki','Takahiro Imamura','Čafúrin','Daiki Nakamura','Jukie Maeda','Juri Amano','Mizuko Arima','Akiko Jadžima','Asako Širakura','Ricuo Sawa','Macuo Macuo','Mugihito','Daisuke Kišio','Jukitoši Hori'],
basedOn:['Rumiko Takahaši'],
screenplay:['Kacuhiko Čiba','Džunki Takegami','Tecuko Takahaši','Akacuki Jamatoja','Ai Óta','Kacujuki Sumisawa','Takaši Jamada','Masaši Ikeda','Akinori Endó'],
production:['Tomojuki Saitó','Hidejuki Tomioka','Naohiro Ogata'],
music:['Kaoru Wada'],
camera:['Kumiko Itó','Jóiči Ógami','Šigemi Ogawa'],
cut:['Tomoaki Curubuči'],
sound:['Jóta Curuoka'],
scenography:['Šigemi Ikeda']},
{title:'Psychoville',
titleCZ:'Psychoville',
year:2009,
runtime:'7h 18min',
episodeRuntime:'30-48min',
countries:['UK'],
genres:['Comedy','Horror','Mystery'],
director:['Matt Lipsey'],
actors:['Reece Shearsmith','Steve Pemberton','Daisy Haggard','Dawn French','Daniel Kaluuya','Elizabeth Berrington','David Bamber','Janet McTeer','Alex Kelly','Mark Gatiss','Imelda Staunton','Hazel Douglas','Jason Watkins','Lucy Hutchinson','Elyes Gabel','Sarah Solemani','Amanda Abbington','Nicholas Burns','James Holmes','Adrian Scarborough','Jennifer Hennessy','Andy Lucas','Jenny Howe','Mark Bonnar','Malcolm Rogers','Ian Gelder','Margaret Cabourn-Smith','Maxwell Laird','Sheila Reid','Alison Lintott','Greg Bennett','Debbie Chazen','Will Ashcroft','David Cann','Tom Andrews','Alex Waldmann','Daniel Ings','Julian Bleach','Kulvinder Ghir','Pik Sen Lim','Joan Linder','Daphne Cheung','Dominic Coleman','Nicholas Le Prevost','Hugh Ross','Stacy Liu','George Asprey','Dan Tetsell','Marcus Garvey','Robert Portal','Christopher Biggins','Eileen Atkins','Nicholas Sidi','Katherine Parkinson','Adam Bond','Josie Walker'],
screenplay:['Steve Pemberton','Reece Shearsmith'],
production:['Justin Davies'],
music:['Joby Talbot','Jeremy Holland-Smith'],
camera:['Francis De Groote'],
cut:['Charlie Phillips'],
sound:['Alex Thompson'],
scenography:['Brian Sykes','Nicola Baker'],
masks:['Laura Schalker','Moira Thomson'],
costumes:['Yves Barre']},
{title:'Red Band Society',
titleCZ:'Red Band Society',
year:2014,
runtime:'9h 24min',
episodeRuntime:'42-45min',
countries:['USA'],
genres:['Drama','Comedy'],
director:['Alfonso Gomez-Rejon','Jason Ensler','Tricia Brock','Elizabeth Allen Rosenbaum','Dan Lerner','Griffin Dunne','Mark Piznarski','Robert Duncan McNeill','Todd Holland'],
actors:['Octavia Spencer','Dave Annable','Astro','Zoe Levin','Rebecca Rittenhouse','Griffin Dunne','Ciara Bravo','Thomas Ian Nicholas','Nolan Sotillo','Charlie Rowe','Griffin Gluck','Wilson Cruz','Andrea Powell','Dana Gourrier','Daren Kagasoff','Mandy Moore','Robert Pralgo',"Tricia O'Kelley",'Susan Park','Jes Macallan','Belita Moreno','Meagan Tandy','Rebecca McFarland','Jessie Ennis','Rachel Varela','Jordan Woods-Robinson','Escalante Lundy','Bertila Damas','Ray Stoney','William Haze','Michael Bryan French','Mike Pniewski','Catalina Sandino Moreno','Andrea Parker','Alex Sgambati','Jay Huguley','Allie Grant','Daniel Pettrow','Adrian Lester','Bella Thorne','John Allen Nelson','Brian Ames','Donny Boaz','Marin Hinkle','Lacy Camp','Carol Anne Watts','William Ragsdale','Jessica Lu','Louis Hunter','Reece Ennis','Tye White','Christian James','Robert C. Treveiler','Jennifer Jalene','Abigail Cowen','Nicolas Bechtel','Samantha Kacho','Bruno Mello','Atkins Estimond','Kennedy Brice','Summer Cain','Phil Armijo','Victor Love','Henry Bazemore Jr.','Jaylen Moore','Tom Ohmer','Joe Knezevich','Malachi Malik','Lisa Canning','Andrew Benator'],
screenplay:['Albert Espinosa','Margaret Nagle','Gina Fattore','Anna Fricke','Alison McDonald','Jeannine Renshaw','Rachel Shukert','Rina Mimoun','Natalie Krinsky','Bill Krebs','Robert Sudduth'],
production:['Jim Kleverweis','Natalie Krinsky','John B. Moranville','Bill Krebs'],
music:['Ludwig Göransson','John Swihart'],
camera:['Joe Pennella','Vanja Cernjul'],
cut:['David Moritz','Mark Manos','Steven Lang','Howard Leder','Jonathan Pledger'],
sound:['Robb Navrides','Kurt Kassulke','Adam Sawelson','Rick Norman','Aron Siegel'],
scenography:['Mark Hutman','Dena Allen','Linda Lee Sutton','Maria Nay','Sandy Getzler'],
masks:['Patricia Messina'],
costumes:['Jennifer Eve','Nicole Schott']},
{title:'Wacky Races',
titleCZ:'Wacky Races',
year:1968,
runtime:'5h 40min',
episodeRuntime:'20min',
countries:['USA'],
genres:['Animation','Family','Sport'],
director:['Joseph Barbera','William Hanna','Charles Nichols'],
actors:['Daws Butler','Don Messick','John Stephenson','Janet Waldo','Dave Willock','Paul Winchell'],
screenplay:['Matt Wayne'],
production:['Joseph Barbera','William Hanna'],
music:['Hoyt Curtin'],
cut:['Richard C. Allen','Milton Krear'],
scenography:['Iwao Takamoto']},
{title:'Vzdálené vrcholky hor',
titleCZ:'Vzdálené vrcholky hor',
year:1984,
runtime:null,
episodeRuntime:'3x105min',
countries:['Italy','UK','USA','Germany'],
genres:['Drama','History','Romance'],
director:['Peter Duffell'],
actors:['Ben Cross','Amy Irving','Christopher Lee','Benedict Taylor','Rossano Brazzi','Saeed Jaffrey','Robert Hardy','Omar Sharif','John Gielgud','Rupert Everett','Art Malik','Anthony Sharp','Caterina Boratto','Constantine Gregory','Parikshat Sahni','Rama Vij','Jennifer Kendal','Sudhir','Rupert Frazer','Mary Peach','Peter Arne','Michael Cochrane','William Gaunt','Mangal','Felicity Dean','David de Keyser','Clive Francis','John Forbes-Robertson','Jeremy Sinden','Goga Kapoor','Adam Bareham'],
screenplay:['Julian Bond'],
music:['Carl Davis'],
camera:['Jack Cardiff'],
cut:['John Jympson','Peter Boita'],
scenography:['Robert W. Laing'],
costumes:['Raymond Hughes']},
{title:'Taotao',
titleCZ:'Tao Tao',
year:1983,
runtime:null,
episodeRuntime:'52x25min',
countries:['China','Japan','Germany'],
genres:['Family','Adventure','Animation'],
director:['Tacuo Šimamura','Jukio Suzuki','Osamu Inoue','Taku Sugijama','Norio Jazawa','Eisuke Kondó','Nobuo Ónuki','Takamicu Jukawa','Masajuki Óseki'],
actors:['Manou Lubowski','Doris Jensen','Čisato Nakadžima','Taeko Nakaniši'],
screenplay:['Keidži Kubota','Hiroši Ócuka'],
music:['Karel Svoboda','Jasunori Cučida'],
sound:['Susumu Aketagawa']},
{title:'Dark Oracle',
titleCZ:'Dark Oracle',
year:2004,
runtime:'9h 58min',
episodeRuntime:'23min',
countries:['Canada'],
genres:['Sci-Fi','Animation'],
director:['Paul Fox','Craig Pryce','Ron Murphy','Philip Earnshaw'],
actors:['Paula Brancati','Alex House','Jonathan Malen','Nathan Stephenson','Megan Park','Kristopher Turner','Sarah Gadon','Philip Riccio','Steven Yaffee','Amber Marshall','Joan Henry','Stacey Farber','Tim Post','Mark Ellis'],
screenplay:['Jana Sinyor','Tony Elliott','Heather Conkie'],
production:['Jana Sinyor'],
music:['Gary Koftinoff'],
camera:['Luc Montpellier','Kim Derko'],
cut:['Stephen Withrow'],
sound:['John Dykstra','Alan deGraaf','John Gare'],
costumes:['Victoria Dobson','Jenifur Jarvis']},
{title:'The Octopus',
titleCZ:'Chobotnice',
year:1984,
runtime:'68h 23min',
episodeRuntime:'52-114min',
countries:['Italy','France','Austria','Spain'],
genres:['Crime','Drama'],
director:['Luigi Perelli','Damiano Damiani','Florestano Vancini'],
actors:['Michele Placido','François Périer','Paul Guers','Remo Girone','Patricia Millardet','Nicole Jamet','Florinda Bolkan','Jacques Dacqmine','Cariddi McKinnon Nardulli','Barbara De Rossi','Angelo Infanti','Vittorio Mezzogiorno','Martin Balsam','Mario Adorf','Raoul Bova','Flavio Bucci','Ennio Fantastichini','Giuliana de Sio','Sergio Fantoni','Claude Rich','Gedeon Burkhard','Bruno Cremer','Stefan Danailov','Rolf Hoppe','Francisco Rabal','Luigi Diberti','Alain Cuny','Marie Laforêt','Marcello Venditti','Renato Mori','Alfonso Giganti','Vittorio Duse','Luigi De Filippo','Domenico Gennaro','Daniel Ceccaldi','Tony Sperandeo','Andrea Aureli','Dagmar Lassander','Renato Montalbano','Carlo Reali','Lara Wendel','Rocco Lerro','Bruno Di Luia','Sergio Graziani','Luciano De Ambrosis','Fabiola Toledo','Luigi Uzzo','Victor Cavallo','Riccardo Parisio Perrotti','Sergio Rossi','Nicola Di Pinto','Adalberto Maria Merli','Giampiero Albertini','Salvatore Billa','Cyrus Elias','Franco Trevisi','Guido Cerniglia','Pierre Vaneck','Eolo Capritti','Cyrus Elias','Lino Capolicchio','Marcello Tusco','Vittorio De Bisogno','Nello Pazzafini','Luigi Mezzanotte','Simona Cavallari','Marino Masé','Gianpaolo Saccarola','Elio Zamuto','Massimo Mirani','Vanessa Gravina','Jean-Luc Bideau','François Marthouret','Adriano Pappalardo','Fabio Galli','Claudio Spadaro','Stefano Dionisi','Delia Boccardo','Gianni Musy','Vanni Corbellini','Orazio Orlando','Ana Torrent','Ray Lovelock','Luigi Pistilli','Gottfried John','Cosimo Fusco','Marco Di Stefano','Claudine Auger','Lorenzo Gioielli','Agnese Nano','Orso Maria Guerrini','Riccardo Cucciolla','Domenico Fortunato','Helena Růžičková','Franco Graziosi','Glauco Onorato','Pierre Mondy','Orsetta De Rossi','Graziella Comana','Corinne Dacla'],
screenplay:['Ennio De Concini','Sandro Petraglia','Stefano Rulli','Nicola Badalucco','Lucio Battistrada','Massimo De Rita','Andrea Porporati','Umberto Contarello','Alessandro Sermoneta','Pier Giuseppe Murgia','Domenico Rafele','Piero Bodrato','Sergio Silva','Luigi Perelli'],
production:['Bruno Turchetto','Matteo Levi','Claudia Aloisi'],
music:['Ennio Morricone','Riz Ortolani','Paolo Buonvino'],
camera:['Sebastiano Celeste','Marcello Gatti','Roberto Forza','Carlo Tafani'],
cut:['Franco Fraticelli','Enzo Meniconi','Gino Bartolini','Pierluigi Leonardi','Mauro Bonanni'],
sound:['Gaetano Carito','Claudio Chiossi',"Gianni D'Amico"],
scenography:['Luciano Ricceri','Umberto Turco',"Lorenzo D'Ambrosio",'Pierfranco Luscrì'],
masks:['Raul Ranieri','Giulio Pezza','Maurizio Nardi'],
costumes:['Gianna Gissi','Andretta Ferrero','Marisa Crimi','Paola Bonucci','Liliana Sotira']},
{title:'SAO',
titleCZ:'Sword Art Online',
year:2012,
runtime:'37h 59min',
episodeRuntime:'23-48min',
countries:['Japan'],
genres:['Animation','Action','Drama','Fantasy','Romance'],
director:['Jošijuki Fudžiwara','Tomohiko Itó','Manabu Ono','Takaši Sakuma','Naomi Nakajama','Šunsuke Nakašige','Júki Itó','Jasujuki Fuse','Juzuru Tačikawa','Makoto Hošino','Tensai Okamura','Hideja Takahaši','Masaši Macumoto','Kótaró Tamura','Tacujuki Nagai','Tecuró Araki','Satoši Mori','Kazuja Sakamoto','Masajuki Mijadži','Tecuo Hirakawa','Šú Watanabe','Acuši Takahaši','Hiroši Kimura','Satoši Nišimura','Kosaja',"Ken'iči Imaizumi",'Masajuki Kodžima','Jasuhito Nišikata','Šunsuke Išikawa','Susumu Nišizawa','Risako Jošida','Hiroki Hirano','Masakazu Ohara','Hirotaka Tokuda','Ken Takahaši','Tošimasa Išii',"Ken'iči Kawamura",'Takeši Furuta','Daisuke Takašima','Tamaki Nakacu','Šunsuke Mačitani','Satoši Saga','Pyeon-Gang Ho','Jošihiko Iwata','Kazuma Sató','Tomoja Tanaka','Šigeki Kawai',"Šin'ja Watada",'Hirokazu Jamada','Hironori Aojagi','Takuma Suzuki','Takajoši Morimija','Júja Horiuči','Mičiru Itabisaši','Saori Den','Šigetaka Ikeda','Júsuke Marujama','Tóru Hamasaki','Hidetoši Takahaši','Takahiro Šikama'],
actors:['Kóiči Jamadera','Takehito Kojasu','Ken Narita','Tomokazu Seki','Jošicugu Macuoka','Natalie Hoover','Cherami Leigh','Ajahi Takagaki','Tóru Ókawa','Terujuki Tanzawa','Kódži Jusa','Tošijuki Morikawa','Kazunari Tanaka','Ajana Taketacu','Haruka Tomacu','Tošijuki Tojonaga','Hiroaki Hirata','Aoi Júki','Hiroši Kamija','Mijuki Sawaširo','Rina Hidaka','Ai Kajano','Hiroki Jasumoto','Akira Išida','Nobunaga Šimazaki','Kaori Išihara','Kaori Maeda',"Džun'iči Suwabe",'Hitomi Nabatame','Hikaru Hanada','Takeaki Masujama','Haruki Išija','Kanehira Jamamoto','Kenta Sasa','Kendži Nodžima',"Šin'ja Takahaši",'Sanae Kobajaši','Iššin Čiba','Cuguo Mogami','Maja Enojoši','Acuši Tamaru','Rjóta Iwasaki','Tomo Muranaka','Jú Sasahara','Rjúiči Kidžima','Cujoši Kojama','Jukitoši Kikuči','Júka Amemija','Miho Okasaki','Kósuke Óniši','Šunsuke Sakuja','Micuaki Kanuka','Takahiro Sumi','Takumu Mijazono','Sajaka Kanda','Ruriko Aoki','Takahiro Šimada','Daisuke Motohaši','Aja Kawakami','Daiči Endó','Arisa Kijoto','Skyler Davenport','Eiičiró Tokumoto','Rjó Sugisaki',"Šun'iči Maki",'Kendži Roa','Sóta Arai','Naoko Komacu','Ikuto Kanemasa','Šiori Izawa','Megumi Tojoguči','Hiroki Gotó','Takacugu Awazu','Kóta Óšita','Micutoši Šundó','Kanae Itó','Čiwa Saitó','Aja Endó','Ajumu Murase','Sajuri Jahagi','Masaja Takacuka',"Džun'ja Enoki",'Šóko Juzuki','Júko Kaida','Konomi Kohara','Hina Kino','Mucumi Tamura','Takanori Hošino','Hitomi Ueda','Genki Jošimoto','Kanako Sakuragi','Megumi Hajašibara','Daiki Hamano','Džun Inoue','Eidži Takeuči','Misato Murai','Kóiči Sóma','Takehiro Hasu','Risae Macuda','Sóičiró Hoši'],
basedOn:['Reki Kawahara'],
screenplay:['Muneo Nakamoto','Jukie Sugawara','Jukito Kizawa','Šúdži Irijama','Naoki Šódži','Jošikazu Mukai','Tomohiko Itó','Rjósuke Suzuki','Acuši Takajama','Kó Nekota','Kóhei Urušihara'],
production:['Kazuma Miki','Šin`ičiró Kašiwada','Jósuke Futami','Nobuhiro Ósawa','Nobuhiro Nakajama'],
music:['Juki Kadžiura'],
camera:['Gaku Hiróka','Mucumi Usuda','Kenta Hajaši','Kentaró Waki','Šóta Kodera'],
cut:['Šigeru Nišijama','Júdži Kondó'],
sound:['Jošikazu Iwanami'],
scenography:['Júsuke Takeda','Takajuki Nagashima','Jukako Ogawa','Keito Watanabe']},
{title:"Workin' Moms",
titleCZ:'Zpátky do práce',
year:2017,
runtime:'30h 26min',
episodeRuntime:'22min',
countries:['Canada'],
genres:['Comedy','Drama'],
director:['Catherine Reitman','Philip Sternberg','Aleysa Young','Paul Fox','Molly McGlynn','Renuka Jeyapalan','Joyce Wong','Mars Horodyski','Yael Staav','Peter Huang'],
actors:['Catherine Reitman','Dani Kind','Juno Rinaldi','Katherine Barrell','Philip Sternberg','Sarah McVie','Jessalyn Wanlim','Dennis Andres','Ryan Belleville','Peter Keleghan','Sadie Munroe','Oluniké Adeliyi','Jennifer Pudavick','Alden Adair','Varun Saranga','Robert B. Kennedy','Raven Cinello','Tabitha Tao','Sarah Murphy-Dyson','Greta Onieogou','Zach Smadu','Zarrin Darnell-Martin','Zoe Doyle','Brock Morgan','Stephanie Belding','Evan Marsh','Doug MacLeod','Jonathan Potts','Allegra Fulton','Carolyne Maraghi','Aviva Mongillo','Ian Lake','Yasmijn Nicolle','Darrin Baker','Donald MacLean Jr.','Hallea Jones','Laura Cilevitz','Shaun Shetty','Nikki Duval','Jayne Eastwood','Jane McLean','Michael Rinaldi','Zachary Bennett','Edie Inksetter','Mimi Kuzyk','Paul Amos','Jess Salgueiro','Dan Beirne','Paulino Nunes','Dan Aykroyd','Mary Ashton','Elana Dunkelman','Wendy Crewson','Rebecca Kohler','Elisa Moolecherry','Christopher Redman','Yani Gellman','Parveen Kaur','Amanda Brugel','Caroline Palmer','Trenna Keating','Angela Asher','Natalie Krill','Tom Lenk','Andrew Hinkson','Pat Mills','John Ralston','Seán Cullen','Paula Boudreau','Paula Brancati','Richard Waugh','Vanessa Matsui','Sean Cullen','Megan Hutchings','Ayisha Issa','Sammi Barber','Victor Webster','Emma Hunter','Carlos Gonzalez-Vio','Christian Martyn','Humberly González','Nicki Whitely','Jonas Chernick','Ann Pirvu','Rodrigo Fernandez-Stoll','Lisa Berry','Dayo Ade','Perrie Voss','Cherisse Woonsam','Tennille Read','Sima Fisher','Kelsey Falconer','Matthew Finlan','Pardeep Bassi','Jeanie Calleja','Steve Byers','Colin Mochrie','Alex Mallari Jr.','Vanessa Burns','Daniel Gold'],
screenplay:['Catherine Reitman','Karen Kicak','Rebecca Kohler','Ingrid Haas','Jillian Locke','Daniel Gold','Jessie Gabe','Linsey Stewart',"Aidan O'Loughlin",'Sasha Leigh Henry','Masooma Hussain','Enuka Okuma','Kathleen Phillips'],
production:['Karen Kicak','Lisa Benedetto','Daniel Gold'],
music:['Peter Chapman','Maylee Todd'],
camera:['Maya Bankovic','Kristin Fieldhouse','Ben Lichty'],
cut:['Jonathan Eagan','David B. Guthrie','Angela Jekums','Christopher Minns','Marianna Khoury','Matt Lyon','Michael Pierro'],
sound:['Eric Apps','Jason Perreira','Peter Clements'],
scenography:['Elisa Sauve','Danielle Sahota','Andy Loew','Ciara Vernon','Marilyn Kiewiet','Jef Silver'],
masks:['Julia Carter'],
costumes:['Sheila Fitzpatrick']},
{title:'Clerks',
titleCZ:'Clerks',
year:2000,
runtime:'2h 12min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Animation','Comedy'],
director:['Steve Loter','Chris Bailey','Nicholas Filippi'],
actors:["Brian O'Halloran",'Jeff Anderson','Jason Mewes','Kevin Smith','Alec Baldwin','Charles Barkley','Brian Posehn','Jim Wise','Bryan Cranston','Judge Reinhold','Matt Damon','Michael McKean','Kerri Kenney','Jeff Bennett','Gwyneth Paltrow','Scott Mosier','Michele Maika','Lisa Spoonauer','Elon Gold','Mark McKinney','Michael McShane','Dan Patrick','Kevin Michael Richardson','Al Franken','Walter Flanagan','Steve Hytner','Michael Buffer','Dan Etheridge','Lorin Dreyfuss','Paul Dini','Kath Soucie','April Winchell','Kevin McDonald','Matthew Maher','Sam Gifaldi','Bryan Johnson','Lauren Tom','Gilbert Gottfried','Tara Strong','Dana Gould','James Woods','Mario Joyner','Reggie Miller','Phil LaMarr','Julia Sweeney','Frank Welker'],
screenplay:['David Mandel','Scott Mosier','Kevin Smith','Brian Kelley','David Kendall','Paul Dini'],
production:['Chris Bailey','Brian Kelley'],
music:['James L. Venable'],
cut:['John Royer'],
sound:['Fil Brown','Melissa Ellis','Paca Thomas'],
scenography:['Alan Bodner']},
{title:'Na útěku',
titleCZ:'Na útěku',
year:2023,
runtime:'16h 41min',
episodeRuntime:'39-60min',
countries:['South Korea'],
genres:['Action','Adventure','Fantasy','Sci-Fi','Thriller'],
director:['In-je Park'],
actors:['Seung-ryong Ryoo','Hyo-joo Han','In-seong Jo','Tae-hyeon Cha','Seung-beom Ryoo','Seong-gyoon Kim','Hee-won Kim','Seong-geun Moon','Jeong-Ha Lee','Yoon-Jung Go','Do-hoon Kim','Sun-Young Kwak','Hee-soon Park'],
basedOn:['Pool Kang'],
screenplay:['Pool Kang'],
music:['Ki-yeong Kang'],
camera:['Hyeong-deok Lee'],
scenography:['Kyoung-sun Chae']},
{title:'The Moaning of Life',
titleCZ:'The Moaning of Life',
year:2013,
runtime:null,
episodeRuntime:'44min',
countries:['UK'],
genres:['Adventure','Comedy'],
director:['Benjamin Green','Richard Yee','Simon Smith'],
actors:['Karl Pilkington','Richard Yee'],
music:['Vik Sharma'],
camera:['Will Churchill','Michael Timney'],
cut:['Mark Williams'],
sound:['Freddie Claire']},
{title:"I'm Alan Partridge",
titleCZ:"I'm Alan Partridge",
year:1997,
runtime:'5h 47min',
episodeRuntime:'28-29min',
countries:['UK'],
genres:['Comedy'],
director:['Dominic Brigstocke','Armando Iannucci','Tristram Shapeero'],
actors:['Steve Coogan','Sally Phillips','Barbara Durkin','Peter Baynham','Simon Pegg','Chris Ryman','Julia Deakin','Christopher Morris','Graham Linehan','Kevin Eldon','Amelia Bullmore','Doon Mackichan','David Schneider','Rebecca Front','Nigel Lindsay','Phil Cornwell','Constantine Gregory','Andrew Burt','Felicity Montagu','Ian Puleston-Davies','James Lance','Daniel Cerqueira','Phoebe Nicholls','Peter Serafinowicz','Stephen Mangan','Jo Enright','Jane Robbins','Tim Dantay','Vicki Pepperdine','Julia Davis','Rob Brydon','Jacquetta May','Arthur Mathews','Hugh Parker','Simon Ludders','Simon Greenall'],
screenplay:['Peter Baynham'],
music:['Jonathan Whitehead'],
camera:['John Rosenberg'],
cut:['Nick Arthurs','Billy Sneddon','Gary Dollner'],
sound:['Russell Edwards'],
scenography:['Simon Rogers','Jo Sutherland','Dennis De Groot'],
masks:['Christine Cant']},
{title:'The Investigation',
titleCZ:'Případ: Ponorka',
year:2020,
runtime:'4h 23min',
episodeRuntime:'41-45min',
countries:['Denmark','Sweden'],
genres:['Crime','Drama','Mystery'],
director:['Tobias Lindholm'],
actors:['Søren Malling','Pilou Asbæk','Pernilla August','Rolf Lassgård','Laura Christensen','Dulfi Al-Jabouri','Hans Henrik Clemensen','Charlotte Munck','Henrik Birch','Anders Juul','Josephine Park','Frank Thiel','Patricia Schumann','Nicklas Søderberg Lundstrøm','Jens Andersen','Robert Karl Bernhard','Johan Esbjörnsson','Dya Josefine Hauch','Brian Hjulmann','Andreas Holm-Hansen','Kristian Høgh Jeppesen','Karen Litthauer','Jacob Regel Møller','Dan Boie Kratfeldt','Inge Lise Goltermann','Palmi Gudmundsson','Gaspard Nicolas Perrier','Brian Conradsen','Sebastian Bull Sarning','Karla Løkke','Marianne Levy','Mette Munk Plum','Lucas Alexander','Jakob Højlev Jørgensen','Christiane Gjellerup Koch','Henning Valin','Hans Norberg','Gerda Lie Kaas','Evamaria Björk'],
screenplay:['Tobias Lindholm'],
production:['Jonas Allen','Caroline Blanco','Peter Bose','René Ezra'],
music:['Rune Tonsgaard Sørensen'],
camera:['Magnus Nordenhof Jønck'],
cut:['Adam Nielsen','Peter Brandt'],
sound:['Morten Green','Kjetil Mørk','Jonas Langkilde'],
scenography:['Roger Rosenberg','Mathias Hassing'],
masks:['Bjørg Serup'],
costumes:['Stine Thaning']},
{title:'The Brown Family',
titleCZ:'Hnědá rodina',
year:2016,
runtime:null,
episodeRuntime:'41min4-7min',
countries:['Germany'],
genres:['Comedy','Drama'],
director:['Maurice Hübner'],
actors:['Edin Hasanović','Vincent Krüger','Nomie Laine Tucker','Stephan Grossmann','Karmela Shako','Marios Gavrilis','Sina Tkotsch','Jonathan Gyles','Erkan Acar','Leopold Ferdinand Schill','Zhong To'],
screenplay:['Manuel Meimberg'],
production:['Beatrice Kramm','Christoph Bicker','Frank Huwe','Uwe Urbas'],
music:['Marti Fischer'],
camera:['Julia Hönemann'],
sound:['Paul Wilke','Andreas Kluge'],
scenography:['Philipp Eggert'],
masks:['Jessica Haupt'],
costumes:['Angelika Huhn']},
{title:'The Comey Rule',
titleCZ:'The Comey Rule',
year:2020,
runtime:'3h 30min',
episodeRuntime:'95-115min',
countries:['USA'],
genres:['Drama'],
director:['Billy Ray'],
actors:['Jeff Daniels','Holly Hunter','Michael Kelly','Jennifer Ehle','Scoot McNairy','Brendan Gleeson','Oona Chaplin','Amy Seimetz','Steven Pasquale','Steve Zissis','Shawn Doyle',"Brian d'Arcy James",'Kingsley Ben-Adir','Dalmar Abuzeid','William Sadler','Richard Thomas','T.R. Knight','Joe Lo Truglio','Spencer Garrett','Michael Hyatt','Peter Coyote','Damon Gupton','Dayo Ade','Violet Brinson','Gene Farber','David Ingram','Jonathan Potts','Jonathan Banks','Andrew Airlie','Isabella Pisacane','John Bourgeois','Dan Lett','George Tchortov','James Gilbert','Philip Riccio','Delphine Roussel','Seann Gallagher','Shauna MacDonald','Chris Owens','Darrin Baker','Clinton Lee Pontes','Christina Notto','Masa Lizdek','Brigitte Robinson','Jason Weinberg','Gina Jun','Paul Bates','Jhene Erwin','Novie Edwards','Vanessa Trenton','Tracey Beltrano','Nate Boyer','Andrew Di Rosa','Claire Cavalheiro','Richard Binsley','Sylvain Plasse','Harmon Walsh','Daniel Falk'],
basedOn:['James Comey'],
screenplay:['Billy Ray'],
production:['Cari-Esta Albert','Terry Gould'],
music:['Henry Jackman'],
camera:['Elliot Davis'],
cut:['Jeffrey Ford'],
sound:['Andrew DeCristofaro','Mark Paterson','Will Files','Jason Gaya','Michael LaCroix'],
scenography:['Christopher Brown'],
masks:['Alexis Arenas','Alastair Muir'],
costumes:['Anne Dixon']},
{title:'Martin Mystère',
titleCZ:'Martin Mystère',
year:2003,
runtime:'24h 12min',
episodeRuntime:'22min',
countries:['France','Canada'],
genres:['Animation','Mystery','Comedy'],
director:['Stéphane Berry','Gregory Panaccione','Jae Woong Kim'],
actors:['Alexis Tomassian','Sam Vincent','Dorothée Pousséo','Kelly Sheridan','Dale Wilson','Laurence Dourlens','Teryl Rothery'],
screenplay:['Jeff Biederman','Michelle Lamoreaux','Robert Lamoreaux','Ben Joseph','Jeff Schechter','David Michel','Richard Clark','Scott Kraft','Rob Hoegee','Simon Racioppa','Franklin Young'],
production:['David Michel','Vincent Chalvon-Demersay','Sylvain Viau'],
music:['Fabrice Aboulker'],
cut:['Martin Tremblay'],
scenography:['Stéphane Berry']},
{title:'K jezeru',
titleCZ:'K jezeru',
year:2019,
runtime:null,
episodeRuntime:'Alternativní 48x8min',
countries:['Russia'],
genres:['Drama','Thriller','Sci-Fi'],
director:['Pavel Kostomarov','Dmitrij Ťjurin'],
actors:['Viktorija Isakova','Kirill Käro','Marjana Spivak','Jurij Kuzněcov','Alexandr Robak','Natalja Zemcova','Eldar Kalimulin','Viktorija Agalakova','Alexandr Jacenko','Anna Michalkova','Savelij Kudrjašov','Alja Nikulina','Jevgenij Sytyj','Igor Savočkin','Pavel Vorožcov','Artěm Sučkov','Jurij Skuljabin','Olga Chochlova','Dmitrij Savjaněnko','Jekatěrina Vasiljeva','Albina Tichanova','Valentin Samochin','Alexej Dmitrijev','Marina Zasuchina','Jevgenija Čirkova','Alexej Ušakov','Vasilisa Němcova','Marija Buknis','Konstantin Balakirev','Nikita Jeleněv','Viktorija Klinkova','Askar Iljasov','Darja Ekamasova','Sergej Šnyrjov','Alexandr Jacko','Ivan Bosiljčič','Erik Abramovič','Naděžda Igošina','Sergej Gorobčenko','Roman Majakin','Vjačeslav Ščenin','Irina Lukina','Beso Gatajev','Dmitrij Gudočkin','Valerij Skorokosov','Sergej Kolbincev','Vadim Gusev','Nikita Abdulov'],
basedOn:['Jana Vagner'],
screenplay:['Roman Kantor','Alexej Karaulov'],
production:['Valerij Fedorovič','Jevgenij Nikišov','Alexandr Bondarev','Rafael Minasbekjan','Džanik Fajzijev'],
music:['Alexandr Sokolov'],
camera:['David Chajznikov','Robert Saruchaňan'],
cut:['Stěpan Gordejev'],
sound:['Roman Platonov']},
{title:'Arrested Development',
titleCZ:'Arrested Development',
year:2003,
runtime:'33h 40min',
episodeRuntime:'22-37min',
countries:['USA'],
genres:['Comedy'],
director:['Mitchell Hurwitz','Joe Russo','Anthony Russo','Greg Mottola','Peter Lauer','Arlene Sanford','Patty Jenkins','Robert Berlinger','Paul Feig','Jason Bateman','Jeff Melman','Rebecca Asher','Lee Shallat Chemel','Troy Miller','Jay Chandrasekhar','John Fortenberry','Andrew Fleming','Danny Leiner','Lev L. Spiro'],
actors:['Jason Bateman','Portia de Rossi','Will Arnett','Michael Cera','Alia Shawkat','David Cross','Jeffrey Tambor','Jessica Walter','Armie Hammer','Ron Howard','Judy Greer','Charlize Theron','Sarah Scott','Bob Odenkirk','Andy Samberg','Patricia Velasquez','Simon Helberg','Rob Corddry','Bradley Stryker','Julia Louis-Dreyfus','Pat Crawford Brown','Amy Poehler','Ed Helms','Kate Luyben','Pej Vahdat','Jack McBrayer','Mae Whitman','Henry Winkler','Michael Naughton','Dale Waddington','Andy Richter','Christine Taylor','Leonor Varela','Ben Stiller','Zach Braff','Liza Minnelli','Craig Robinson','Justine Bateman','John Michael Higgins','Christopher T. Wood','Cedric Yarbrough','Michael Hitchcock','Don Perry','James Lipton','Carrie Preston','Paul Feig','Heather Graham','Jeff Garlin','Alan Tudyk','Tracy Howe','Ione Skye','Alessandra Torresani','Kevin Heffernan','J.K. Simmons','Shane Ryan','Rob Riggle','Nathalia Ramos','Jordan-Claire Green','Eduardo Palomo','Jesse Heiman','Phyllis Smith','Arick Salmea','John Ross Bowie','Toši Toda','Jonathan Penner','Bashar Rahal','Dave Attell','George Cheung','Brian Baumgartner','Rob Huebel','Mousa Kraish','Meghan Stansfield','Iqbal Theba','Jennifer Gonzalez','Matt Walsh','Peter Jason','Tony Hale','Kristen Wiig','Olivia Dudley','John Slattery','Joe Russo','Lauren Bowles','Andy Buckley','Falk Hentschel','Mather Zickel','Larry Thomas','Terry Crews','Isla Fisher','Seth Rogen','Antonio Jaramillo','Baron Vaughn','Nancy Criss','Lauren Weedman','Debra Mooney','Adam Devine','Jake Hoffman','Andrew Santino','Bernie Kopell','Eric Zuckerman','Nelson Franklin'],
screenplay:['Mitchell Hurwitz','Brad Copeland','Karey Dornetto','Dean Lorey','Abraham Higginbotham','Chuck Tatham','John Levenstein','Barbie Adler','Ron Weiner','James Vallely','Caroline Williams','Jim Brandon','Brian C. Singleton','Evan Mann','Gareth Reynolds','Caroline Williams','Sam Laybourne','Jake Farrow','Lisa Parsons','Hallie Cantor','Richard Rosenstock','Tom Saunders'],
production:['Victor Hsu','Brad Copeland','Barbie Adler','Brian Grazer','John Foy','Michael Cera','Chris Smirnoff'],
music:['David Schwartz'],
camera:['Peter Lyons Collister','Patrick Alexander Stewart','James Hawkinson','Chuck Ozeas'],
cut:['Lee Haxall','Mark Scheib','Robert Bramwell','Kabir Akhtar','Richard Candib','Frank McGrath','Todd Zelin','Ruthie Aslan','Steven Sprung','A.J. Dickerson','Lane Farnham','Seth Clark','Stuart Bass'],
sound:['Frederick Howard','Alexey Mohr','Peter Kelsey','Chris Philp','Lisle Engle','Robert Nichols II','Michael Perricone','Sherry Klein','Nello Torri','Alan Decker','Peter Nusbaum','Kerri Wilson','Kevin W. Buchholz','Penny Harold','Lorenzo Dal Ri','Jamie Santos','Christopher Gomez','Gary Alexander','Susan Cahill','Tim Philben','Christopher T. Silverman','Tim Hays','Tom Stasinis'],
scenography:['Dan Butts','Dawn Snyder','Nanci Roberts','Denny Dugally','Jennifer Lukehart'],
masks:['Shana Fruman','Lisa Rocco','Ginger Damon','Jennifer Turchi Nigh','Vito Trotta','Gary J. Perticone'],
costumes:['Katie Sparks','Molly Grundman']},
{title:'Bite Me',
titleCZ:'Bite Me',
year:2010,
runtime:'2h 51min',
episodeRuntime:'7-15min',
countries:['USA'],
genres:['Comedy','Horror'],
director:['Jarrett Lee Conaway'],
actors:['Yousef Abu-Taleb','Ryan Patrick Welsh','Justin Giddings','Risdon Roberts','Dani Lennon','Morgan Benoit','Ricco Ross','Phil LaMarr','Amy Okuda','Del Zamora','Mark Irvingsen','Robert Axelrod','Amy Wolpa','Robin Lynch','Steve Sirkis','Maria Musebrink','Karan Soni','Corri English','Andy Mackenzie','Sancho Martin','Iman Crosson',"Dean O'Neill",'Jonathan M. Dillon','Robert Romanus','Laura Ortiz','Teresa Ganzel','Sam Puefua','Anna Neubauer','Phil Kruse','Brett Jacobsen','Tony Snegoff','Jacquie Walters','Napoleon Tavale','Erin Fitzgerald','John Frank Rosenblum','Jarrett Lee Conaway'],
screenplay:['Bob Quinn','Andy Shapiro'],
production:['Cindi Rice','John Frank Rosenblum'],
music:['Fall On Your Sword','Mark Mallman'],
camera:['Bruce Francis Cole','Jay Visit'],
cut:['Jonathan M. Dillon',"Danny O'Malley"],
sound:['Nick Gotten III'],
scenography:['Robert Hummel','Nathan Morse','Carol Hummel'],
masks:['Marilin Martin-Medina'],
costumes:['Lucas Culshaw']},
{title:'Now and Then, Here and There',
titleCZ:'Ima, soko ni iru boku',
year:1999,
runtime:'5h 25min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Action','Sci-Fi','War'],
director:['Akitaró Daiči','Masahiko Ócuka','Kunitoši Okadžima','Tadaši Hiramacu','Hiroši Nagahama','Jošimicu Óhaši','Kijoko Sajama','Kijotaka Isako','Kendži Jasuda','Iku Suzuki','Hiroki Hajaši','Nagisa Mijazaki'],
actors:['Kaori Nazuka','Akemi Okamura','Juka Imai','Rika Macumoto','Čafúrin','Hiroko Koniši','Akio Sujama','Kódži Išii','Reiko Jasuhara','Tošihide Cušija','Jošiko Okamoto','Ajaka Saitó','Kendži Nomura','Masuo Amada','Majumi Asano','Takako Honda','Takaši Macujama','Takuma Takewaka','Tomo Saeki','Tomoko Išimura','Čó','Azusa Nakao','Ken Širojama','Kazumi Okušima','Hisanori Nemoto','Fumihiko Cuburaja','Maki Mizuma','Masaja Hašimoto'],
screenplay:['Hidejuki Kurata'],
music:['Taku Iwasaki'],
camera:['Akio Saitó'],
cut:['Masahiro Macumura','Miwako Šibaseki'],
sound:['Kazuja Tanaka'],
scenography:['Masanobu Nomura','Hiroši Kató']},
{title:'4 bloky',
titleCZ:'4 bloky',
year:2017,
runtime:'15h 47min',
episodeRuntime:'44-59min',
countries:['Germany'],
genres:['Drama','Crime'],
director:['Marvin Kren','Özgür Yildirim','Oliver Hirschbiegel'],
actors:['Kida Khodr Ramadan','Frederick Lau','Maryam Zaree','Oliver Masucci','Ludwig Trepte','Almila Bağrıaçık','Ronald Zehrfeld','Gerdy Zint','Karolina Lodyga','Rauand Taleb','Emilio Sakraya','Veysel Diker','Tijan Marei','Nik Xhelilaj','Marc Hosemann','Maximilian Jaenisch','Jan Georg Schütte','Ercan Durmaz','David Bredin','Tilo Nest','Andreas Schröders','Dirk Nocker','Gisa Flake','Ulas Kilic','Sami Nasser','Merlin Leonhardt','Jaela Probst','Erkan Sulcani','Laura Cuenca Serrano','Sami Alkomi','Dunja Ramadan','Abusupyan Magomedov','David A. Hamade','Puja Bahrami','David Schütter','Samir Fuchs','Blerim Destani','Amira Ghazalla','Veysel Gelin','Jan Henrik Stahlberg','Laura Louisa Garde','Marwan Moussa','Jekaterina Medvedeva','Michael Keseroglu','Hans-Heinrich Hardt','Duniya Ramadan','Moussa Sullaiman','Tamay Yildirim','Maureen Havlena','Inaam Wali-Al Battat','Fjodor Olev','Niclas Rohrwacher','Lorin Aras','Isaiah Corr','Raad Amawi','Markus Hammer','Mohamed Benali','Georges Khoukaz','Mina Mansour','Daniel Wagner','Hassan Akkouch','Sabrina Amali','Brian Flaccus','Albrecht Ganskopf','Sam Kalidi','Meryem Moutaoukkil','Neil Malik Abdullah','Ahmed Hafiane','Eunique Cudjo Berkeley','Uwe Preuss','Jörn Knebel','Zainab Alsawah','Martin Baden','Cem Ali Gültekin','Leon Ullrich','Carmina Garay','Wasiem Taha','Kailas Mahadevan','Amer El-Erwadi'],
screenplay:['Marvin Kren','Richard Kropf','Benjamin Hessler','Eckehard Weis','Hanno Hackfort','Bob Konrad','Felix Charin','Niko Schulz-Dornburg'],
production:['Max Wiedemann','Quirin Berg'],
music:['Stefan Will','Peter Hinderthür','Marco Dreckkötter'],
camera:['Moritz Schultheiß','Timon Schäppi'],
cut:['Jan Hille','Sebastian Thümler'],
sound:['Wustmann Lukas','Martin Grube','Markus Glunz'],
scenography:['Claus Rudolf Amler'],
masks:['Dörte Dobkowitz','Irina Tübbecke','Sylvia Grave'],
costumes:['Silke Faber']},
{title:'HitRECord on TV',
titleCZ:'HitRECord on TV',
year:2014,
runtime:null,
episodeRuntime:'16x22min',
countries:['USA'],
genres:['Reality-TV'],
director:['Joseph Gordon-Levitt'],
actors:['Joseph Gordon-Levitt','Elle Fanning','Tony Danza','Carla Gugino','John Waters','Scarlett Johansson','Lynn Collins','Bryce Dallas Howard','Brandon Ludwig','James Patrick Stuart','Anne Hathaway','Ludvig Gür','John Orr','Jade Elysan','Chester Lockhart','Janice Sonia Lee'],
screenplay:['Joseph Gordon-Levitt','Sarah Daly'],
music:['Brian Langsbard','John Orr'],
camera:['Jaron Presant','Tarin Anderson'],
cut:['Seagan Ngai']},
{title:'Mr Inbetween',
titleCZ:'Mr Inbetween',
year:2018,
runtime:'10h 18min',
episodeRuntime:'22-26min',
countries:['Australia'],
genres:['Crime','Drama'],
director:['Nash Edgerton'],
actors:['Scott Ryan','Chika Yasumura','Justin Rosniak','Damon Herriman','Brooke Satchwell','Nicholas Cassim','Natalie Tran','Matt Nable','Jeremy Sims','Kenny Graham','Firass Dirani','Benedict Hardie','Aaron Glenane','Kriv Stenders','David Michôd','Felix Jozeps','Josh McConville','Eddie Baroo','Abe Forsythe','Kieran Darcy-Smith','Shaun Martindale','Daniel Amalm','Fayssal Bazzi','Hugo Johnstone-Burt','Sam Delich','Rose Riley','Ben Oxenbould','Nash Edgerton','Julia Billington','Mirrah Foulkes','Henry Nixon','Brendan Donoghue','Karina Banno','Candice Storey','Haiha Le','Alyla Browne','Ian Roberts','Sam Cotton','Rahel Romahn','Julia Savage','Kipan Rothbury','Paul Caesar','Amy Kersey','William Zappa','Bryn Chapman Parish','Ben Hunter'],
screenplay:['Scott Ryan'],
production:['Michele Bennett'],
music:['Michael Yezerski'],
camera:['Aaron McLisky','Christopher Miles'],
cut:['Peter Sciberras','Simon Price','David Whittaker','Drew Thompson','Dan Lee','Graeme Pereira'],
sound:['Paul Pirola','Robert Mackenzie','David Lee','Nathaniel Watkins'],
scenography:['Alice Lanagan','Claire Granville','Ruby Mathers','Daniel Willis'],
masks:['Vardit Lahav'],
costumes:['Sophie Fletcher']},
{title:'Stargate: Atlantis',
titleCZ:'Hvězdná brána: Atlantida',
year:2004,
runtime:'71h 12min',
episodeRuntime:'41-44min',
countries:['Canada','USA'],
genres:['Action','Adventure','Drama','Sci-Fi'],
director:['Martin Wood','William Waring','Andy Mikita','Brenton Spencer','Robert C. Cooper','Peter DeLuise','Mario Azzopardi','Holly Dale','Ken Girotti','Neill Fearnley','Peter F. Woeste','David Warry-Smith','David Winning','Brad Turner','James Head','Paul Ziller','Joe Flanigan','Martin Gero'],
actors:['Joe Flanigan','David Hewlett','Rachel Luttrell','Jason Momoa','Torri Higginson','Paul McGillion','David Nykl','Robert Picardo','Rainbow Sun Francks','Mitch Pileggi','Chuck Campbell','Jewel Staite','Kavan Smith','Amanda Tapping','Christopher Heyerdahl','James Lafazanos','Connor Trinneer','Blake Stadel','Richard Dean Anderson','Sam Charles','Dean Marshall','Chris Gauthier','Michael Boisvert','Reece Thompson','Pascale Hutton','Beau Bridges','Robert Davi','Richard Kind','Leonor Varela','Erin Chambers','David Ogden Stiers','Don S. Davis','Robert Patrick','Michael Shanks','Danny Trejo','Christopher Judge','Leela Savasta','Jodelle Ferland','Michael Beach','Dominic Zamprogna','Michelle Morgan','Tammy Hui','Aaron Abrams','Colm Meaney','Colby Johannson','Chiara Zanni','Ona Grauer','Frank Collison','Brandy Ledford','Alan Ruck','Kyla Wise','Holly Elissa','Lisa Marie Caruk','Alexis Kellum-Creer','Matthew Harrison','Niall Matter','Jonathon Young','Richard Kahan','Christina Cox','Heather Doerksen','Jaime Ray Newman','Conan Graham','Paul Anthony','Jill Wagner','Panou','Jessica Amlee','Ryan Robbins','Dan Payne','Cory Monteith','Caroline Cave','Kari Wuhrer','Kate Hewlett','Kaaren de Zilva','Lauro Chartrand','David Orth','Kimberley Warnat','Gildart Jackson','Janina Gavankar','Meredith McGeachie','Julia Benson','Daniella Alonso','Ross Hull','Dawn Olivieri','Joel Goldsmith','Chelan Simmons','Sean Rogerson','Ari Cohen','Nicole Muñoz','Lara Gilchrist','Ben Cotton','David Richmond-Peck','Agam Darshi','Dan Shea','Daniel Boileau','Martin Jarvis','Mark Dacascos','David Quinlan','David Dayan Fisher','Anne Openshaw','Frank Vincent'],
basedOn:['Brad Wright'],
screenplay:['Carl Binder','Scott Nimerfro','Joseph Mallozzi','Paul Mullie','Martin Gero','Brad Wright','Damian Kindler','Melissa R. Byer','Treena Hancock','Alan Brennert','Ken Cuperus'],
production:['Andy Mikita','Martin Gero'],
music:['Joel Goldsmith'],
camera:['James Alfred Menard','Michael C. Blundell','Brenton Spencer'],
cut:['Stein Myhrstad','Alison Grace','Mike Banas','Ron Yoshida','Rick Martin','Brad Rines','Jeremy Presner','Judith Burke'],
sound:['Bill Mellow','Kevin Sands','William Skinner'],
scenography:['James Robbins','Bridget McGuire','Robert Davidson','Mark Davidson','Peter Bodnarus','Thom Wells','Melanie Cassidy'],
masks:['Lisa Leonard','Mike Fields','Marisa Cappellaro','Tanya Hudson','Céline Godeau','Jan Newman','Richard Kohlen','Rachel Griffin','Leah Ehman'],
costumes:['Valerie Halverson','Christina McQuarrie']},
{title:'Cosmic',
titleCZ:'Kosmo',
year:2016,
runtime:'3h 4min',
episodeRuntime:'33-40min',
countries:['Czechia'],
genres:['Comedy','Drama','Sci-Fi'],
director:['Jan Bártek'],
actors:['Martin Myšička','David Novotný','Jiří Hána','Jakub Žáček','Jana Plodková','Petr Vančura','Eva Podzimková','Václav Kopta','Martin Dejdar','Lenka Krobotová','Tomáš Baldýnský','Marie Ludvíková','Jana Sováková','Mojmír Maděrič','Jan Leflík','Vendelín Lévai','Šárka Kubíková','Pavel Nečas','Radovan Král','Zdeněk Trčálek','Vladimír Císař','Marek Dobeš','Klára Sochorová','Michal Gulyáš','Guo Zhen Liang','Dušan Urban','Jakub Machala','Roman Rosenkranz','Jan Sedláček','Roman Pomajbo','Marián Labuda ml.','David Vaculík','Kateřina Dušková-Vaníčková','Jiří Klem','Tatiana Dyková','Norbert Lichý','Jiří Hájek'],
screenplay:['Tomáš Baldýnský'],
production:['Tomáš Baldýnský'],
music:['Tomáš Háček'],
camera:['Petr Bednář','Darko Štulič'],
cut:['Ondřej Šošolík'],
sound:['Petr Kapeller'],
scenography:['Petr Zeman'],
masks:['Vladimíra Kačírková'],
costumes:['Kateřina Hájková']},
{title:'Slovácko sa nesúdí',
titleCZ:'Slovácko sa nesúdí',
year:1975,
runtime:'7h 9min',
episodeRuntime:'31-43min',
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Petr Tuček'],
actors:['Jozef Kroner','Oldřich Velen','Stanislav Hájek','Ilja Prachař','Oldřich Vykypěl','Jiří Lábus','Vlasta Peterková','Pavla Severinová','Josef Somr','Zdeněk Kryzánek','Jiří Tomek','Stanislav Tříska','Václav Kyzlink','Slávka Budínová','Karel Augusta','Svatopluk Skopal','Oldřich Navrátil','Vladimír Švabík','Vlastimil Brodský','Terézia Hurbanová-Kronerová','Arna Mohelská','Jaroslav Dufek','Miriam Vránová','Nataša Baženová','Alois Liškutín','Stanislav Zindulka','Rudolf Šimara','Jaroslav Tuček','Zdeněk Ševčík','Hana Zaoralová','Michaela Čuperová','Michal Dočolomanský','Jana Švandová','Miroslav Středa','Adam Matejka','Zdeněk Maryška','Josef Karlík','Jiří Přichystal','Karel Hlušička','Bronislav Poloczek','Milena Steinmasslová','Soňa Valentová','Ladislav Mareček','Karel Kabíček','Ladislav Šamlot','Jana Hliňáková','Miroslav Mikulička','Karel Polášek','Michal Nevěčný','Milan Holubář','Eva Matalová','Helena Kružíková','Jaromír Roštínský','Světla Amortová','Zora Jandová','Jan Skopeček','Svatopluk Matyáš','Jan Kuželka','Daniel Dítě','Natalie Švabíková','Marie Beránková','Jana Gazdíková','Jindřich Světnica','Jan Pohan','Helena Trýbová','Vítězslav Jandák','Jiří Kodet','Aleš Jarý','Jaroslav Sypal','Jaroslav Kyncl','Luboš Vraspír','Antonín Kala','Jan Vlasák','Jaroslav Kaňkovský','Karel Adam','Radek Balaš','Ota Filip','Josef Pospíšek','Eva Josefová','Jiří Binder','Michal Tomek','Kateřina Kolínová','Renata Javoříková','Milivoj Voltner','Magda Skopečková','Olga Rastická','Ladislav Svoboda','Zdeněk Blažek'],
basedOn:['Zdeněk Galuška'],
screenplay:['Zdeněk Galuška','Petr Tuček'],
camera:['Jiří Kolín','Vlastimil Kosík'],
cut:['Dana Lukešová','Ivan Matouš'],
sound:['Radomír Koutek','Vladimír Brostík'],
scenography:['Luděk Škuta'],
masks:['Dušan Brodanský','Miloslav Faderhons'],
costumes:['Jaroslava Procházková']},
{title:'Gen V',
titleCZ:'Gen V',
year:2023,
runtime:'14h 7min',
episodeRuntime:'39-59min',
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Drama','Comedy'],
director:['Nelson Cragg','Philip Sgriccia','Steve Boyum','Clare Kilner','Rachel Goldberg','Shana Stein','Sanaa Hamri'],
actors:['Jaz Sinclair','Chance Perdomo','Patrick Schwarzenegger','Sean Patrick Thomas','Shelley Conn','Alexander Calvert','Maddie Phillips','Lizze Broadway','Alexandra Castillo','Marco Pigossi','Elana Dunkelman','Chace Crawford','Jackie Tohn','Laura Kai Chen','Maia Jae Bastidas','Dan Beirne','Jessica Clement','Rayisa Kondracki','Louise Kerr','Sharon McFarlane','Moses Nyarko','Colby Minifie','P.J. Byrne','Robert Bazzocchi','Matthew Edison','Madison Graves','Madeleine Claude','Celestine Caravaggio','Samy Osman','Elisabeth Shue','Jessie T. Usher','Clancy Brown','Nicholas Hamilton','Maria Nash','Greg Zajac','London Thor','Cameron Nicoll','Derek Luh','Asa Germann','Colin Penman'],
basedOn:['Garth Ennis','Darick Robertson'],
screenplay:['Craig Rosenberg','Tara Butters','Michele Fazekas','Evan Goldberg','Eric Kripke','Zak Schwartz','Brant Englestein','Erica Rosbe','Jessica Chou','Lex Edness','Lauren Greer','Chelsea Grate'],
production:['Lex Edness','Jessica Chou'],
music:['Matt Bowen','Christopher Lennertz'],
camera:['Michael Marshall','Marc Laliberté'],
cut:['David Kaldor','Jeffrey Glaser','Danielle Wang','Maura Corey'],
sound:['Alexandra Fehrman','Mark Relyea','Richard Weingart','Bill McMillan','Daisuke Sawa'],
scenography:['Matthew Davies','Michaela Cheyne'],
masks:['Charleen Shillingford'],
costumes:['Laura Montgomery']},
{title:'Mr. Mercedes',
titleCZ:'Mr. Mercedes',
year:2017,
runtime:'29h 12min',
episodeRuntime:'50-60min',
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Jack Bender','John David Coles','Laura Innes','Kevin Hooks','Peter Weller','Michael J. Leone'],
actors:['Harry Treadaway','Brendan Gleeson','Jharrel Jerome','Isaiah Stratton','Ann Cusack','Jimmy Gonzales','Scott Lawrence','Kelly Lynch','Arian Moayed','Mary-Louise Parker','Tim Sitarz','Robert Stanton','Holland Taylor','Breeda Wool','Neko Parham','Katharine Houghton','Keith Flippen','Preston James Hillier','Emma Rayne Lyle','Laila Robins','Nancy Travis','Maddie Hasson','David Furr','Terry Serpico','Tom Nowicki','Danny Vinson','Yohance Myles','Stephen King','Victor McCay','Estes Tarver','Debra Monk','James Martin Kelly','Irene Ziegler','Justine Lupe','Drew Matthews','Jules Haven','Ricky Russert','Nicole Barré','Yossie Mulyadi','Logan Donovan','Jack Huston','Tessa Ferrer','Maximiliano Hernández','Virginia Kull','Mike Starr','Faith Dillon','Todd Terry','Courtney Dietz','Kate Burton','Rich Williams','Nicholas J. Coleman','Gilbert Glenn Brown','Cory Scott Allen','Cynthia Evans','Cecilia Leal','Kendrick Cross','Joe Chrest','Gregory Alan Williams','Fredric Lehne','Rusty Schwimmer','Christina Bach','Denise Dowse','Scott Takeda','Dave Hager','Jana Allen','Bruce Dern','Brett Gelman','Natalie Paul','Glynn Turman','Meg Steedle','Gabriel Ebert','Rarmian Newton','Josh Daugherty','Claire Bronson','Kate Mulgrew','Patch Darragh','Jason Davis','Julie Ivey','Kelly Collins Lintz','Jay DeVon Johnson','Charles D. Clark','Drez Ryan','Ammie Masterson','Madison Bailey','Kurt Yue','Valerie Sue Love','Adam Donshik','Adam Vernier','Selena Anduze','Tracey Bonner','Nathaniel Ashton','Deena Wade','Henry Bazemore Jr.','Lindsay Ayliffe','Braxton Alexander','Makayla Lysiak','Miles Mussenden','William Atticus Parker','Laura Dooling','Hannah Pniewski'],
basedOn:['Stephen King'],
screenplay:['Dennis Lehane','Bryan Goluboff','David E. Kelley','A.M. Homes','Mike Batistick','Samantha Stratton','Jonathan Shapiro'],
production:['Katharine Werner','Danielle Weinstock','Kate Regan'],
music:['Phil Mossman','Anthony Roman'],
camera:['Armando Salas','Yaron Levy','Ross Berryman','Eliot Rockett',"Itai Ne'eman"],
cut:['Michael R. Fox','Edward A. Warschilka','Debra Beth Weinfeld','Eric A. Sears','Cedric Nairn-Smith','Troy Takaki','Katheryn Rupert','Matthew Philip Smith','Anthony McAfee','David Eisenberg'],
sound:['Robb Navrides','Andy King','Brian Armstrong','Adam Sawelson','Keith Rogers','Matthew T. Duncan'],
scenography:['Marek Dobrowolski','Matthew Sullivan'],
masks:['Michaela Farrell','Jeff Goodwin'],
costumes:['Hannah Owens-Bender']},
{title:'Monogatari Series Second Season',
titleCZ:'Monogatari Series: Second Season',
year:2013,
runtime:'10h 50min',
episodeRuntime:'25min',
countries:['Japan'],
genres:['Animation','Drama','Fantasy','Comedy','Psychology','Romance'],
director:['Akijuki Šinbó','Tomojuki Itamura','Jukihiro Mijamoto','Tošimasa Suzuki','Hirojuki Cučija','Sumito Sasaki','Jošitaka Nagaoka','Eiiči Kubojama','Naojuki Tacuwa','Džun Fukuda','Takaši Kawabata','Takatoši Suzuki','Júki Jase','Kenjiro Okada','Hiroko Kazui','Nobujuki Takeuči','Ei Aoki','Šin Ónuma','Tacuja Oiši','Jošinobu Tokumoto','Fumie Muroi','Jošiharu Ašino','Jošihiro Mori','Šunsuke Išikawa','Hiroši Aojama','Ogura Širakawa','Tomoja Takahaši','Šúdži Mijahara','Čika Nagaoka','Šinsaku Sasaki'],
actors:['Jui Horie','Maaja Sakamoto','Mijuki Sawaširo',"Šin'ičiró Miki",'Ken Narita','Eri Kitamura','Emiri Kató','Micuki Saiga','Takahiro Sakurai','Juka Iguči','Fumihiko Tačiki','Ari Ozawa','Čiwa Saitó','Jukijo Fudžii','Jasunori Macumoto','Kaoru Morota','Júko Sanpei','Sacuki Jukino','Saori Hajami','Rjóko Širaiši','Jódži Ueda','Kaori Mizuhaši','Hiroaki Tadžiri','Ai Orikasa','Miju Irino','Hiroši Kamija','Haruka Terui','Akari Harašima','Kana Hanazawa','Eidži Takeuči','Miho Mijagawa'],
basedOn:['Nišio Išin'],
screenplay:['Muneo Nakamoto','Jukito Kizawa'],
music:['Satoru Kósaki'],
camera:['Takajuki Aizu'],
cut:['Rie Macubara'],
sound:['Jóta Curuoka'],
scenography:['Tošiharu Iidžima']},
{title:'F. L. Věk',
titleCZ:'F. L. Věk',
year:1970,
runtime:'11h 35min',
episodeRuntime:'43-63min',
countries:['Czechoslovakia'],
genres:['Drama','History'],
director:['František Filip'],
actors:['Radoslav Brzobohatý','Jan Pivec','Antonie Hegerlíková','Jaroslav Marvan','Václav Voska','Eva Vosková','Jiřina Štěpničková','Dana Medřická','Jana Brejchová','Gabriela Vránová','Jiřina Bohdalová','Martin Růžek','Karel Höger','Zdeněk Řehoř','Eduard Cupák','Josef Kemr','Květa Fialová','Jiří Sovák','Vlastimil Brodský','Pavel Landovský','Jiří Adamíra','Vladimír Menšík','Ota Sklenčka','Bedřich Prokoš','Josef Hlinomaz','Roman Skamene','Soběslav Sejk','Josef Beyvl','Petr Haničinec','Stella Zázvorková','Vladimír Krška','Bohuš Záhorský','Ilja Prachař','Vítězslav Vejražka','Vladimír Hlavatý','Josef Somr','Otakar Brousek st.','Miloš Nedbal','Nina Popelíková','Vladimír Ráž','Jaroslav Moučka','Jan Skopeček','Jiří Vala','Jaroslava Pokorná','Jaroslav Satoranský','František Kovářík','Štěpán Bulejko','Jiří Zahajský','František Hanus','Pavla Maršálková','Alena Kreuzmannová','Jan Libíček','Mirko Musil','Gustav Nezval','Antonín Sedlák','Jindřich Hrdý','Otto Zelenka','Zdeněk Hodr','František Holar','Lída Roubíková','Josef Haukvic st.','Václav Švec','Jiří Valenta','Karel Netolický','Pavel Kolínský','Jiří Pleskot','Jaroslav Maršálek','Josef Burda','Jan Bajer','Otto Šimánek','Karel Hábl','Viktor Preiss','Jaroslav Cmíral','Ladislav Trojan','Karel Vavřík','Magda Maděrová','Jiří Kodet','Aleš Morávek','Karel Meister ml.','Otto Kinský','Hana Houbová','Jarmila Beránková','Vít Pešina','Ilona Jirotková','Otto Lackovič','Hynek Němec','Karel Pavlík','Ferdinand Krůta','Josef Koza','Pavel Spálený','Jiřina Bílá','Lena Birková','František Vicena','Bohuslav Kupšovský','Jaroslav Raušer','Jindřich Narenta','Jaroslav Čejka','Miloslav Šindler','Eduard Haken','Karel Berman'],
basedOn:['Alois Jirásek'],
screenplay:['Otto Zelenka'],
music:['Jiří Srnka'],
camera:['Rudolf Stahl ml.'],
cut:['Karel Kohout'],
sound:['Ladislav Hausdorf'],
scenography:['Jan Zázvorka'],
masks:['Miloslav Jandera'],
costumes:['Lída Novotná']},
{title:'Galavant',
titleCZ:'Galavant',
year:2015,
runtime:'6h 26min',
episodeRuntime:'21-22min',
countries:['USA'],
genres:['Comedy','Musical'],
director:['John Fortenberry','Chris Koch','Declan Lowney','Paul Murphy','James Griffiths'],
actors:['Joshua Sasse','Timothy Omundson','Vinnie Jones','Karen David','Luke Youngblood','Mallory Jansen','Julian Seager','Sophie McShera','Hugh Bonneville','John Stamos','Anthony Head','Rutger Hauer','Stanley Townsend','Michael Jibson','Faith Prince','Leon Lopez','Ricky Gervais','Muzz Khan','Matthew Rohman','David Newman','Elaine Caulfield','Mark Sheals','Kylie Minogue','Michael Brandon','Tim Plester',"'Weird Al' Yankovic",'Simon Callow','Matt Lucas','Robert Lindsay','Chris Bearne','Sarah Hadland','Sally Phillips','Nick Frost','Sheridan Smith','Greg Wise','Reece Shearsmith','Eddie Marsan','Stuart Davidson','Samuel Rush','Andrew Buckley','Andy Gillies','Richard Price','Simon Meacock','John Walters','Genevieve Allenbury','Ben Presley','Darren Evans','Clare Foster','Alfie Simmons','Oliver Coopersmith','Rob Crouch','Oliver Powell','Tommie Earl Jenkins','Harry Collett','Kenneth Collard','Adam Loxley'],
screenplay:['Dan Kopelman','Rick Wiener','Kenny Schwartz','Maggie Bandur','Kat Likkel','Jeremy Hall','Kirker Butler','John Hoberg','Robin Shorr'],
production:['Scott Weinger','Helen Flint','Bari Halle'],
music:['Christopher Lennertz','Alan Menken'],
camera:['Ashley Rowe','Chris Seager','John Pardue'],
cut:['David L. Bertman','Lance Luckey'],
sound:['Brian Harman','Randal S. Thomas','Michael Kalifa','Tim Fraser','Dean Okrand','Glen Marullo','Penny Harold'],
scenography:['Jeff Tessler','Said El Kounti','Andrew Lavin','Paul Gilpin'],
costumes:['Sheena Napier','Susannah Buxton','Charlotte Mitchell']},
{title:'Transparent',
titleCZ:'Transparent',
year:2014,
runtime:'19h 58min',
episodeRuntime:'22-102min',
countries:['USA'],
genres:['Drama','Comedy'],
director:['Joey Soloway','Nisha Ganatra','Silas Howard','Stacie Passon','Shira Piven','Andrea Arnold','So-yong Kim','Marta Cunningham','Marielle Heller','Jim Frohna','Allison Liddi-Brown','Sarah Gavron','Gaby Hoffmann','Rhys Ernst'],
actors:['Jeffrey Tambor','Jay Duplass','Gaby Hoffmann','Judith Light','Amy Landecker','Melora Hardin','Kathryn Hahn','Rob Huebel','Gillian Vigman','Henry Simmons','Alison Sudol','Lawrence Pressman','Emily Robinson','Michaela Watkins','Carrie Brownstein','Bradley Whitford','Noah Harpster','Caroline Aaron','Amin Joseph','Alyvia Alyn Lind','Abby Ryder Fortson','Kiersey Clemons','Ethan Sandler','Tig Notaro','Zackary Arthur','Devendra Banhart','Hank Chen','Jessie Kahnweiler','Rich Hutchman','Holly Woodlawn','Elaine Hendrix','John Kapelos','Rhys Ernst','Joey Soloway','Marquel Skinner','Jason Mantzoukas','James Frecheville','David Futernick','Anjelica Huston','Ron Funches','J.B. Smoove','Sasheer Zamata','Harmony Santana','Cherry Jones',"Jenny O'Hara",'Richard Masur','Aaron Lustig','Courtney Hope','Caitlyn Jenner','Paula Newsome','Matt McCoy','Drew Droege','Keith Levy','Vi Flaten','Danny Jacobs','Bridget Bedard','Brett Rice','Meagen Fay','Michael Stuhlbarg','Anna Belknap','Jon Sklaroff','Andy Umberger','Kayla Madison','John Getz','Tom Lenk','Erinn Hayes','Luzer Twersky','Tim Bagley','Ayana Haviv','Jim Abele','Lyman Ward','Wade Williams','Gregg Binkley','Colby French','Annie Mumolo','Sonya Walger','Angelique Cabral','Bobbi Salvör Menuez','Mousa Kraish','Didi Conn','Adam Silver','Mitch Rouse','Peaches','Deborah S. Craig','Rebecca Kessler','Moshe Kasher','Jennifer Hasty',"John O'Brien",'Cleo Anthony','Emma Howard','Rebecca Drysdale','James Babson','Michelle Gardner','Tate Hanyok','Tim Acres','Becky Thyre','Ray Abruzzo','Bryna Weiss','Alia Shawkat','Molly Bernard'],
screenplay:['Joey Soloway','Bridget Bedard','Noah Harpster','Micah Fitzerman-Blue','Jessi Klein','Gabe Liedman','Arabella Anderson','Our Lady J','Eleanor Jean','Ali Liebegott','Ethan Kuperberg'],
production:['Andrea Sperling','Victor Hsu','Our Lady J','Shakina Nayfack','Jennifer Corey'],
music:["Dustin O'Halloran",'Bryan Senti','Vincent Jones'],
camera:['Jim Frohna','John Guleserian','Keith Dunkerley'],
cut:['David L. Bertman','Catherine Haight','Annette Davey','Hilda Rasula','Sunny Hodge','Amber Bansak','Julia Franklin'],
sound:["Andy D'Addario",'Alexandra Fehrman','Wade Barnett','Gary Gegan','Chris M. Jacobson'],
scenography:['Sandy Struth','Susan Mina Eschelbach','Catherine Smith','Dea Jensen'],
masks:['Taylor Bennett','Dionne Smith','Bryn E. Leetch','Vito Trotta','Gary J. Perticone'],
costumes:['Marie Schley']},
{title:'Assassination Classroom',
titleCZ:'Ansacu kjóšicu',
year:2015,
runtime:'18h 1min',
episodeRuntime:'23min',
countries:['Japan'],
genres:['Animation','Action','Drama','Comedy','Sci-Fi'],
director:['Seidži Kiši','Takaši Kobajaši','Júsuke Kamata','Daiki Fukuoka'],
actors:['Džun Fukujama','Mai Fučigami','Aja Suzaki','Nobuhiko Okamoto','Ajako Kawasumi','Kotono Micuiši','Mamoru Mijano','Šizuka Itó','Takehito Kojasu','Tomokazu Sugita','Hisako Kanemoto','Masahito Jabe','Kaito Išikawa','Satomi Sató','Saki Fudžita','Sajuri Jahagi','Ajaka Suwa','Kana Ueda','Anri Kacu','Rjóta Takeuči','Šóta Jamamoto','Šó Hajami','Kenta Mijake','Naoki Makišima','Takahiro Mizušima','Kurumi Mamija','Subaru Kimura','Rino Marimo','Kóki Harasawa','Eidži Mijašita',"Šin'ja Takahaši",'Šó Kawaguči','Šintaró Asanuma','Rjóta Ósaka','Megumi Ogata','Kanehira Jamamoto','Ajumu Murase','Takaši Macujama','Džundži Madžima','Acuši Imaruoka','Rjó Naitó',"Ken'ičiró Macuda",'Jošitaka Jamaja','Takuja Sató','Hiroki Gotó','Seria Fukagawa','Minami Tanaka','Taiten Kusunoki','Micuaki Madono','Daiki Jamašita',"Džun'iči Janagita",'Nobunaga Šimazaki','Terujuki Tanzawa','Hiromiči Tezuka','Ajaka Nanase','Ikudži Nose','Jošijuki Šimozuma','Daisuke Motohaši','Eiičiró Tokumoto',"Šun'iči Maki",'Tomohiro Jamaguči','Mari Misaki','Šunsuke Kawabe','Takuja Masumoto','Manami Numakura','Tacujuki Kobajaši','Naoto Kobajaši','Gaku Kudó','Tomojuki Higuči','Miho Hino','Fúko Saitó','Kazumasa Kacura','Kacuki Murase','Čie Macuura','Šun Takagi','Teppei Akahira','Hibiku Jamamura','Kósei Hirota','Michael Rivas'],
basedOn:['Júsei Macui'],
screenplay:['Makoto Uezu'],
production:['Noriko Ozaki'],
music:['Naoki Sató'],
camera:['Júsuke Mišina'],
cut:['Masaki Sakamoto'],
sound:['Satoki Iida'],
scenography:['Kazuto Šimojama','Ajumi Mijakoši']},
{title:'Godfather of Harlem',
titleCZ:'Godfather of Harlem',
year:2019,
runtime:'36h 21min',
episodeRuntime:'46-60min',
countries:['USA'],
genres:['Crime','Drama'],
director:['John Ridley','Joe Chappelle','Guillermo Navarro','Tanya Hamilton','Ernest R. Dickerson','Marisol Adler','Carl Seaton','Lily Mariye','Jack Donnelly','Rob Greenlea'],
actors:['Forest Whitaker','Lucy Fry','Nigél Thatch','Ilfenesh Hadera','Kelvin Harrison Jr.','Antoinette Crowe-Legacy','Giancarlo Esposito',"Vincent D'Onofrio",'Erik LaRay Harvey','Rafi Gavron','Paul Sorvino','Elvis Nolasco','Demi Singleton','Markuann Smith','Chazz Palminteri','Kevin Corrigan','Korey Jackson','Tramell Tillman','Roslyn Ruff','Afi Bijou','Luis Guzmán','Dominic Fumusa','Patricia R. Floyd','Rony Clanton','Clifton Davis','Joanne Kelly','Tara Anika Nicolas','Geoffrey Blake','Nikkole Salter','Patrick Murney','Louis Cancelmi','Mark C. Fullhardt','Nneoma Nkuku','Deric Augustine','Nick Chinlund','Taylor Selé','Johnny Hopkins','Billy Wirth','Aloe Blacc','Ken Barnett','Kathrine Narducci','Steve Vinovich','Corey Knight','Peter Francis James','Sonja Sohn','Alex Corrado','Ivo Nandi',"Romina D'Ugo",'Bo Dietl','Leopold Manswell','Jared Kemp','Kevin Dunigan','Method Man','Ronald Guttman','Isaach De Bankolé','Gino Cafarelli','Annabella Sciorra','Justin Bartha','James Madio','Gregory Konow','Nick Ronan','Michael Rispoli','Ralph Brown','Prema Cruz','Richard Topol','Whoopi Goldberg','A$AP Ferg','Louis Vanaria','Nzingha Ashford','Maxwell Whittington-Cooper','Jason Alan Carvell','Yul Vazquez','Michael Raymond-James','Maurice Jones','Eric Berryman','Katya Martin','Edward Carnevale','Arturo del Puerto','Arthur J. Nascarella','Frank Wood','Al Vicente','Craig DiFrancia','Brett Diggs','Samantha Rivers Cole','Evander Duck Jr.','Grace Porter','Lorenzo Pozzan','T.J. Atoms',"Gabriel 'G-Rod' Rodriguez",'Francesca Shipsey','Francois Battiste','Amanda Nicholas','Joel Marsh Garland','Grace Julianna','Ken Holmes','Mu-Shaka Benson','Reggie Alvin Green'],
screenplay:['Chris Brancato','Paul Eckstein','Zach Calig','Resheida Brady','Moses Verneau','Laurence Andries','Matthew Newman','Dean Imperial','Angelica Chéri','Michael Panes'],
production:['Ray Quinlan','Resheida Brady','Zach Calig','Michael Maccarone','Michael Panes'],
music:['Mark Isham'],
camera:['Jack Donnelly','Jay Feather','Sean Donnelly'],
cut:['Andrew Mondshein','Christopher Rand','Susan E. Morse','Daniel A. Valverde','Christopher Nelson','Michael Stern','Chetin Chabuk','Will Blank'],
sound:['Jacob Ribicoff','Bob Chefalas','Julian Townsend'],
scenography:['Dan Leigh','Chryss Hionis','Miguel López-Castillo','Patrick Howe','Melanie J. Baker','Casey Smith'],
masks:['Angela Marinis','Milagros Medina-Cerdeira','Arielle Toelke'],
costumes:['Joshua Marsh','Sarah Laux']},
{title:'Easy Living',
titleCZ:'Sladký život',
year:2015,
runtime:'22h 15min',
episodeRuntime:'48-60min',
countries:['Hungary'],
genres:['Drama','Thriller'],
director:['Zsombor Dyga','Áron Mátyássy'],
actors:['Szabolcs Thuróczy','Eszter Ónodi','Renátó Olasz','Laura Döbrösi','Zsolt Anger','Tamás Lengyel','Franciska Farkas','Tibor Gáspár','Ildikó Tornyi','Zoltán Schmied','Barbara Balogh','Szabolcs Bede Fazekas','Béla Ficzere','Björn Freiberg','Zsolt Kovács','József Kádas','Ádám Lábodi','Sándor Terhes','Richárd Balogh','Claudia Benkő','Beáta Berki','Ralph Berkin','Csaba Debreczeny','Evelin Dobos','Mária Erdélyi','Balázs Fellegi','Béla Gados','György Gyurina','György Gődény','János Horváth','István Hunyadkürthy','Mónika János','Zoltán Karácsonyi','Attila Király','Lehel Kovács','Sándor Lukács','Attila Lőte','Erik Major','Áron Molnár','Réka Nagy','Sára Németh','Ágnes Németh','Iván Oroszi','Adrian Owaimer','Tamás Szabó Sipos','Zsuzsa Száger','Artur Szőcs','Éva Vándor','Zoltán Vígh','Brigitta Csepregi','László Cserjési','László Csíkos','Gábor Csőre','Anna Viktória Dömötör','Judit Harsányi','Attila Kasvinszki','Béla Mészáros','János Papp','Krisztofer Pászik','Tamás Péch','Márkó Rubóczki','Adrián Szász','Levente Tóth','Georgina Varga','György Vass','Vince Zrínyi Gál','Wayne Brett','Iván Dengyel','Kata Domján','Cecília Fekete','Andrea Fullajtár','Adel Lengyel','Dóra Létay','Csilla Radnay','Zoltán Seress','József Tóth','Denis Sweeney','Alex Zelenyánszki','Zsolt Adamecz','András Berzsenyi','Patrícia Chonjo','Katalin Egyed','Viola Lotti Gombó','Ferenc Halász','Gábor Hermann','Luca Barbara Hullám','Éva Igó','Miklós Kapácsy','Károly Kozma','László Kóder','Claudia Magdaléna Molnár','Arpád Zsolt Mészáros','Fanny Müller','Júlia Nyakó','Tamás Takács','József Varga','Bálint Váradi','Zsolt Zsebe','Endre Újhelyi','Attila Borg'],
screenplay:['Virág Zomborácz','István Tasnádi','Márton Bárány','Balázs Lengyel','Balázs Lovas','Péter Vancsik','Oliver Vanice','Gábor Krigler'],
production:['Gábor Krigler','Judit Stalter','Anna Závorszky','Judit Fodor'],
music:['Krisztián Pádár','Levente Szabó','Gábor Katona'],
camera:['Gábor Marosi'],
cut:['Wanda Kiss','Judit Czakó','Béla Barsi','Márton Gothár','Áron Mezei','Júlia Hack','Zoltán Kovács'],
sound:['Gábor Balázs','Tamás Székely','Tamás Zányi','Máté Péterffy'],
scenography:['Balázs Hujber','Judit Varga','Fanni Matyák','Tamás Tamási','Hedvig Kiraly','Juci Szurdi','Zsuzsanna Svertecki'],
masks:['Szandra Gerő','Gabriella Vincze'],
costumes:['János Breckl']},
{title:'Ellen',
titleCZ:'Ellen',
year:1994,
runtime:'40h 33min',
episodeRuntime:'21-46min',
countries:['USA'],
genres:['Comedy','Romance'],
director:['Gil Junger','Alan Myerson','Michael Lembeck','Gail Mancuso','Rob Schiller','Robby Benson','Andrew D. Weyman','Andy Ackerman','John Tracy','John Bowab','Neal Marlens','Tom Cherones'],
actors:['Ellen DeGeneres','Holly Fulger','David Anthony Higgins','Joely Fisher','Clea Lewis','Jeremy Piven','Arye Gross','Alice Hirson','Steven Gilborn','Bruce Campbell','Maggie Wheeler','Julianna Margulies','Harriet Sansom Harris','Jorja Fox','Shawn Pyfrom','Rena Sofer','Ashley Peldon','Patrick Warburton','Jeff Dunham','Marianne Muellerleile','Dennis Burkley','Michael Chieffo','Pat Crawford Brown','Patrick Cranshaw','Eric Allan Kramer','Deanne Bray','Neil Flynn','Ann Talman','Anthony Natale','Andrea Bendewald','Brian Leckner','Shaun Toub','Constance Zimmer','Nancy Lenehan','Christine Taylor','Christine Elise','Louis Gossett Jr.','Woody Harrelson','Marceline Hugot','Willie C. Carpenter','Ty Burrell','Joe Flaherty','Gregory McKinney','Eric Lutes','Orson Bean','Carrie Fisher','Shawn Christian','Mindy Sterling','Bruce Thomas','Earl Boen','Leslie Jordan','David DeLuise','Paul Feig','William Ragsdale','Kathy Griffin','Giovanni Ribisi','Elaine Hendrix','Bodhi Elfman','k.d. lang','Elinor Donahue','David Sederholm','Elizabeth Keener','Phil Leeds','Kimmy Robertson','Bea Arthur','Tim Conway','Robert Gant',"Chris D'Arienzo",'Cristine Rose','Mark Mothersbaugh','Lane Davies','Ken Olandt','Brett Butler','Maurice Gibb','Connie Stevens','Joan Jett','Michael Shamus Wiles','Jim Cody Williams','Dayton Callie','Anne Rice','Jenny Shimizu','Crystal Carson','Jack Plotnick','Priscilla Taylor','Kate Hodge','Iqbal Theba','Marie-Alise Recasner','Jennifer Grant','Dan Gauthier','Mark L. Taylor','Romy Rosemont','Diahann Carroll','Bill Calvert','Tricia Leigh Fisher','Kimberly Russell','Norman Fell','Lisa Darr','Paul Crowder','Felicity Waterman','Jim Haynie'],
screenplay:['Suzanne Martin','Jane Espenson','Peter Tolan','Dan Cohen','Jan Nash','David S. Rosenthal','David Flebotte','Dava Savel','Matt Goldman','Matt Berry','Jonathan Stark','Eileen Heisler','DeAnn Heline','Holly Hester','Rob Lotterstein','Tracy Newman','Tim Doyle','Kit Pongetti','Ric Swartzlander','Maxine Lapiduss','Maria Semple','Alex Herschlag','Carol Black','Neal Marlens','Lisa K. Nelson','Warren Bell','Vance DeGeneres','Sally Lapiduss','Tod Himmel','Iris Dugow','Mike Larsen','Tom Leopold','Mark Driscoll','David Walpert','Ellen Idelson'],
production:['Jonathan Stark','Mark Grossan','Ric Swartzlander','David S. Rosenthal','Jan Nash'],
music:['W.G. Snuffy Walden','Bill Elliott'],
camera:['Gregg Heschong','Richard Brown','Thomas Marshall'],
cut:['Michael L. Sale','Kris Trexler','Dennis C. Vejar','Andy Zall','Iris Dugow','Tony Hayman'],
sound:['Marti D. Humphrey','Mike Olman','Kenneth Kobett','Jim Fitzpatrick','Sherry Klein','Charles Bruce','Larry Tozzi','Michael Ballin'],
scenography:['Bill Brzeski','Joe Aubel',"Archie D'Amico",'Martin Price','Jay Pelissier'],
masks:['Sandra Rubin-Munk','Robin LaVigne'],
costumes:['Bambi Breakstone']},
{title:'The Brittas Empire',
titleCZ:'The Brittas Empire',
year:1991,
runtime:null,
episodeRuntime:'26h30min',
countries:['UK'],
genres:['Comedy'],
director:['Mike Stephens','Christine Gernon'],
actors:['Chris Barrie','Harriet Thorpe','Michael Burns','Tim Marriott','Russell Porter','Pippa Haywood','Jill Greenacre','Judy Flynn','Julia St. John','Guy Siner','Kim Hartman','Andrée Bernard','Richard Lumsden','William Boyer','Ross McCall','Matthew Morgan','Maureen Morris','Henry Cole','Roger Sloman','Mark Gillis','Lucy Briers','Kevin Hudson','Frances Low','Jon Cartwright','Patrick Monckton','Frank Rozelaar-Green','Ray Burnside','Sheila Keith','Jeffery Dench','Terrence Hardiman','Sebastian Coe','David Webber','Adjoa Andoh','Brian Gwaspari','Colin Spaull','Gordon Salkilld','Leslie Schofield','Bruce Alexander','George Sweeney','Richard Braine','Ian Bleasdale','Alexandra Gilbreath','Veronica Doran','Tony Steedman','Miranda Forbes','Donald Pickering','Louis Haslar','Hugh Walters','John Pirkis','Harold Innocent','Lawrence Elman','Sarah Moyle','Derek Benfield','Gary Whitaker','Stephen Churchett','Jo Martin','Beth Buchanan','Rory Murray','Jo Kendall','Ruth Silvestre','Andrew Bradley','Phoebe Gilpin','John Baker','Damien Thomas','Michael Fleming','Perry Fenwick','Tony Alleff','Peter Cockett','Hugh Dickson','Pip Torrens','Donald Morley','Anouschka Menzies','Tony Millan','Rowena Cooper','Jake Abraham','Luisa Bradshaw-White','Ian Lindsay','Robin Parkinson','Anne Hornby'],
screenplay:['Ian Davidson','Richard Fegen','Andrew Norriss','Peter Vincent','Tony Millan','Terry Kyan','Paul Smith','Mike Walling'],
production:['Mike Stephens'],
music:['Frank Renton'],
cut:['Chris Wadsworth'],
scenography:['John Bristow'],
masks:['Lisa Westcott'],
costumes:['Annie Hardinge','Carol Lawrence','Irene Whilton']},
{title:'The Prisoner',
titleCZ:'The Prisoner',
year:1967,
runtime:'14h 10min',
episodeRuntime:'50min',
countries:['UK'],
genres:['Drama','Mystery','Sci-Fi'],
director:['Robert Asher','Patrick McGoohan','Don Chaffey','Pat Jackson','Peter Graham Scott','David Tomblin'],
actors:['Patrick McGoohan','Fenella Fielding','Leo McKern','Paul Eddington','Jiří Pravda','Nadia Gray','Finlay Currie','Donald Sinden','George Coulouris','Guy Doleman','Mark Burns','Fabia Drake','John Castle','Jane Merrow','Valerie French','Norma West','Patrick Jordan','Colin Gordon','Earl Cameron','Pat Keen','Richard Wattis','Max Faulkner','Pat Gorman','Michael Balfour','Rosalie Crutchley','Virginia Maskell','Ronald Radd','Duncan Macrae','Hilary Heath','Robert Rietty','Christopher Benjamin','Kenneth Griffith','Barlett Mullins','Grace Arnold','Joe Gladwin','Lucy Griffiths','Andre Van Gyseghem','Gertan Klauber','Justine Lord','Zena Walker','Conrad Phillips','Charles Lloyd Pack','Basil Dignam','Norman Mitchell','Richard Caldicot','Ray Marioni','Lewis Alexander','Victor Platt','Thomas Heathcote','Bee Duffell','Nigel Stock','Derek Aylward','Michael Nightingale','Hilda Barry','Denis Shaw','Jon Laurimore','John Wentworth','John Drake','Jack Allen','Oliver Macgreevy','Patsy Smart','Peter Swanwick','Kevin Stoney','Pauline Chamberlain','Rachel Herbert','Harold Berens','John Cazabon','Kenneth Benda','William Lyon Brown','John Rees','Patrick Cargill','Dinny Powell','Keith Pyott','Fredric Abbott','Denise Buckley','Brian Worth','Michael Brennan','Lloyd Lamble','Angela Browne','Martin Miller','Henry B. Longhurst','Michael Bilton','Betty McDowall','Dennis Chinnery','Norman Scace','Annette Carell','Mark Eden','Al Mancini','Peter Brace','Michael Billington','George Leech','Fred Haggerty','Gordon Sterne','George Benson','Basil Hoskins','Patricia Jessel',"Jim O'Brady",'Michael Chow','George Baker','Frederick Piper'],
screenplay:['David Tomblin','Patrick McGoohan'],
production:['David Tomblin'],
music:['Wilfred Josephs'],
camera:['Brendan J. Stafford'],
cut:['Eric Boyd-Perkins','Geoffrey Foot','Spencer Reeve','Lee Doig']},
{title:'Invader ZIM',
titleCZ:'Invader ZIM',
year:2001,
runtime:null,
episodeRuntime:'28x30min',
countries:['USA','Filipíny'],
genres:['Family','Animation','Comedy','Sci-Fi'],
director:['Steve Ressel'],
actors:['Andy Berman','Billy West','Rodger Bumpass','Ted Raimi','Michael McDonald','Danny Cooksey','Phil LaMarr','Mindy Sterling','R. Lee Ermey','David Herman','Wally Wingert','Philece Sampler','Jim Wise','Greg Ellis','Brian George','Kerri Kenney','Mary Scheer','Mo Collins','Kevin Michael Richardson','Adam Paul','Eliza Schneider','Paul Greenberg','Candi Milo','Jhonen Vasquez','Philip Tanzini','Lucille Bliss','Bill Chott','Gary Falcone','Richard Steven Horvitz','Hope Levy','S. Scott Bullock','S. Scott Bullock','André Sogliuzzo','Eric Trueheart','Brad Abrell','Lauri Fraser','John Garry'],
screenplay:['Roman Dirge','Jhonen Vasquez','Eric Trueheart','Rob Hummel'],
production:['Steve Ressel'],
music:['Michael Tavera','Kevin Manthei','Jhonen Vasquez'],
cut:['Christopher Hink'],
sound:['Paul Menichini']},
{title:'Love Between Fairy and Devil',
titleCZ:'Love Between Fairy and Devil',
year:2022,
runtime:'26h 19min',
episodeRuntime:'37-50min',
countries:['China'],
genres:['Fantasy','Drama'],
director:['Zheng Yi','Jingwu Qian'],
actors:['Esther Yu','Dylan Wang','Linghe Zhang','Haiqiao Xu','Cristy Guo','Charles Lin','Yueyi Wang','Bo Peng','Yu Wei','Yi Yang','Hua Liu','Jiawei Li','Zining Cheng','Keanu Chi','Sarah Huang','Yutong Pu','Bin Zhao','Bozhi Zhang','Xizi Li','Yitong Li','Boxiao Liu','Renhe Liu','Bin Zhao','Simei Zhao','Zi Cheng','Xiao Hong'],
basedOn:['Feixiang Jiu Liu'],
screenplay:['Jinjin Bai'],
production:['Yu Gong','Bei Yang'],
music:['Ikuro Fudžiwara'],
costumes:['Xiaoya Yi']},
{title:'Midnight Sun',
titleCZ:'Půlnoční slunce',
year:2016,
runtime:'6h 56min',
episodeRuntime:'52min',
countries:['Sweden','France'],
genres:['Drama','Thriller'],
director:['Måns Mårlind','Björn Stein'],
actors:['Leïla Bekhti','Gustaf Hammarsten','Albin Grenholm','Jakob Hultcrantz Hansson','Jessica Grabowsky','Richard Ulfsäter','Oscar Skagerberg','Jeremy Corallo','Göran Forsmark','Sofia Jannok','Olivier Gourmet','Pavva Pittja','Maxida Märak','Malin Persson','Iggy Malmborg','Anna Azcárate','Martin Sundbom','Pär Andersson','Rolf Degerlund','Pelle Heikkilä','Peter Stormare','Denis Lavant','Omid Khansari','Ingemar Raukola','Lisa Henni','Anton Raukola','Anna Björk','Gustav Ekman Mellbin','Franck Neckebrock','Anitta Suikkari','Philippe du Janerand','Henrik Gustafsson','Sofia Ledarp','Clara Kallenius','Pasi Haapala','Charlotte Lindmark','Seydina Baldé','Hugo Emretsson','Jean-Louis Bonnet','Sabina Räw Frank','Karolina Furberg','Editha Domingo','Peter Mörlin','Helena Lindegren','Fredric Thurfjell','Jalila Tlemsi','Amanda Jansson','Maurits Elvingsson','Pontus Wikström','Aslat Mahtte Gaup','Edvin Bredefeldt','Jesper Sjölander'],
screenplay:['Måns Mårlind','Björn Stein'],
production:['Jan Marnell'],
music:['Nathaniel Méchaly'],
camera:['Erik Sohlström'],
cut:['Håkan Karlsson'],
scenography:['Niels Sejer'],
masks:['Erica Spetzig','Tove Jansson'],
costumes:['Ulrika Sjölin']},
{title:'The Pet Girl of Sakurasou',
titleCZ:'Sakurasó no pet na kanodžo',
year:2012,
runtime:null,
episodeRuntime:'10h25min',
countries:['Japan'],
genres:['Animation','Drama','Comedy','Romance'],
director:['Acuko Išizuka','Daisuke Takašima','Kaoru Suzuki','Tomojuki Kurokawa','Hideki Hosokawa','Takaši Ikehata','Šigetaka Ikeda','Masato Sató','Akihisa Šibata','Mamoru Kanbe','Kacuši Sakurabi','Šigehito Takajanagi','Kijoko Sajama','Masato Tamagawa'],
actors:['Jošicugu Macuoka','Ai Kajano','Mariko Nakacu','Nacumi Takamori','Takahiro Sakurai','Jui Horie','Ajako Kawasumi','Nao Tójama','Mucumi Tamura','Júki Ono','Satoši Hino','Ajumi Fudžimura','Kaito Išikawa','Mikako Takahaši','Saori Óniši','Jukijo Fudžii','Misako Tomioka','Kenta Mijake','Megumi Tojoguči','Satomi Arai','Ajane Sakura','Jurika Kubo','Harumi Sakurai','Saori Hajami','Kotomi Jamakawa','Lynn','Šintaró Asanuma','Rjóta Ósaka','Júsuke Kuwahata','Nacuki Hanae',"Džun'iči Janagita",'Nobunaga Šimazaki','Masumi Asano','Tóru Ókawa','Jui Ogura','Jumi Učijama','Motomu Kijokawa','Daiki Jamašita','Juka Ócubo','Ikumi Hajama','Eidži Takeuči','Sačiko Kodžima','Taiši Murata','Rjósuke Kanemoto','Tomo Muranaka','Masaši Nogawa','Haruka Jamazaki','Itaru Jamamoto','Riki Kagami','Minami Takahaši','Asuka Niši','Rjó Sugisaki','Acuši Ono','Taketora','Juna Jošino','Momoe Kišimoto','Megumi Okada','Kazujoši Šiibaši','Mana Šimizu','Madoka Šiga','Una Nagisa'],
basedOn:['Hadžime Kamošida'],
screenplay:['Mari Okada','Fumihiko Šimo','Džukki Hanada','Mičiko Itó','Keigo Kojanagi','Hadžime Kamošida'],
production:['Nobuhiro Ósawa','Masatoši Išizuka','Tošihiro Maeda','Acuši Iwasaki'],
music:['Júzó Hajaši'],
camera:['Júki Kawašita'],
cut:['Šigeru Nišijama'],
sound:['Džin Aketagawa'],
scenography:['Kóičiró Bizen']},
{title:'Sleepers',
titleCZ:'Spjaščije',
year:2017,
runtime:'10h 20min',
episodeRuntime:'49-53min',
countries:['Russia'],
genres:['Thriller','Crime'],
director:['Jurij Bykov','Sergej Arlanov'],
actors:['Igor Petrenko','Natalja Rogožkina','Dmitrij Uljanov','Fjodor Bondarčuk','Jurij Beljajev','Paulina Andrejeva','Alexandr Rapoport','Oleg Morozov','Karina Razumovskaja','Jurij Bykov','Semjon Škalikov','Nikita Pavlenko','Konstantin Strelnikov','Jelena Podkaminskaja','Vjačeslav Čepurčenko','Arťjom Semakin','Irina Lukovskaja','Gleb Podgorodinskij','Igor Klimov','Michail Vodzumi','Andrej Frolov','Anatolij Dzivajev','Erik Jaralov','Sergej Rubljov','Julija Tělpuchova','Sergej Cholmogorov','Jevgenij Bakalov','Sergej Kalašnikov','Alexandr Taraňžin','Jurij Sazonov','Sergej Nasibov','Albert Chasijev','Andrej Moskvičjov','Julija Čebakova','Grant Kagramaňan','Andrej Mežulis','Nikolaj Kozak','Svjatoslav Nastaševskyj','Aristarch Veněs','Darja Pogodina','Natalja Žernakova','Kamal Ballan','Igor Ugolnikov','Sergej Tišin','Anna Zajceva','Daša Jurčenko','Severija Janušauskajtě','Tim Sell','Faridunšo Rachmatullojev','Alexej Longin','Sergej Ugrjumov','Jurij Lachin','Nikolaj Lunin','Igor Mirkurbanov','Alexej Ovsjannikov','Julija Abramova','Sergej Klimov','Maxim Al-Names','Irina Jakovleva','Sergej Gurjev','Michail Konovalov','Lilija Dmitrik'],
screenplay:['Sergej Minajev'],
production:['Fjodor Bondarčuk','Vjačeslav Murugov','Andrej Kretov','Anastasija Kavunovskaja','Konstantin Ernst'],
music:['Jefim Fajfman','Dmitrij Tolstov','Leonid Leněr'],
camera:['Jurij Korobejnikov']},
{title:'De Dag',
titleCZ:'De Dag',
year:2018,
runtime:'9h 17min',
episodeRuntime:'39-58min',
countries:['Belgium'],
genres:['Drama','Action','Crime','Thriller'],
director:['Gilles Coulier','Dries Vos'],
actors:['Jeroen Perceval','Liesa Van der Aa','Titus De Voogdt','Maaike Neuville','Ruth Becquart','Serge-Henri Valcke','Marijke Pinoy','Sebastien Dewaele','Barbara Sarafian','Bert Haelvoet','Geert Van Rampelberg','Dominique Van Malder','Katelijne Verbeke','Nabil Mallat','Circé Lethem','Hans Van Cauwenberghe','Bart Hollanders','Hilde Uitterlinden','Mark Verstraete','Lynn Van Royen','Julie Mahieu','Sophie Decleir','Dolores Bouckaert','Lukas De Wolf','Johan van Assche','Willy Thomas','Michel Bauwens','Zouzou Ben Chikha','Wine Dierickx','Jelle De Beule','Lino van Reeth','Pieter Genard','Per Janssens','Bob Snijers','Olivier De Smet','Imani De Caestecker','Joris Brys','Eric Van Der Sypt','Rikkert van Dijck','Abbas Shirafkan','Griet De Backer','Joris Hessels','Tom Vermeir','Sirin Zahed','Ilse de Vis','François Beukelaers','Marc Didden','Bien de Moor','Andrew Vandaele','Ingrid De Vos','Cedric Tylleman','Piet De Praitere','Koen De Poorter'],
screenplay:['Jonas Geirnaert','Julie Mahieu'],
production:['Michiel Devlieger','Hilde De Laere'],
music:['David Martijn'],
camera:['David Williamson','Brecht Goyvaerts'],
cut:['Yoohan Leyssens','Bert Jacobs'],
sound:['Geert Vlegels','Matthias Hillegeer'],
scenography:['Philippe Bertin'],
masks:['Liesbet Fijalka','Dorien Van Poucke'],
costumes:['Catherine Marchand']},
{title:'Link Click',
titleCZ:'Shiguang Dailiren',
year:2021,
runtime:'9h 12min',
episodeRuntime:'23min',
countries:['China'],
genres:['Animation','Drama','Mystery','Thriller'],
director:['Haoling Li'],
actors:['Shangqing Su','Tianxiang Yang','Shimeng Li','Fuzheng Zhang','Sheng Feng','Chen Qian','Zhao Shuang']},
{title:'Hazbin Hotel',
titleCZ:'Hotel Hazbin',
year:2019,
runtime:'3h 51min',
episodeRuntime:'24-32min',
countries:['USA'],
genres:['Animation','Comedy','Drama','Fantasy','Crime','Horror'],
director:['Vivienne Medrano'],
actors:['Erika Henningsen','Stephanie Beatriz','Jeremy Jordan','Christian Borle','Amir Talai','Keith David','James Monroe Iglehart','Michael Kovach','Maxwell Atoms','Kimiko Glenn','Daphne Rubin-Vega','Brandon Rogers'],
screenplay:['Vivienne Medrano','Ariel Ladensohn'],
production:['Vivienne Medrano','Jes Anderson','Samantha Daley','Paula Haifley','Laura Dimaio'],
music:['Evan Alderete','Cooper Smith Goodwin'],
cut:['Scott Henry'],
scenography:['Sam Miller']},
{title:'She-Hulk: Attorney at Law',
titleCZ:'She-Hulk: Neuvěřitelná právnička',
year:2022,
runtime:'5h 9min',
episodeRuntime:'31-38min',
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Comedy','Drama'],
director:['Kat Coiro','Anu Valia'],
actors:['Tatiana Maslany','Mark Ruffalo','Tim Roth','Jameela Jamil','Josh Segarra','Ginger Gonzaga','Renée Elise Goldsberry','Benedict Wong','Charlie Cox','Megan Thee Stallion','Steve Coulter','Drew Matthews','Arrianna Marie','Mark Linn-Baker','Candice Rose','Michael H. Cole','Nicholas Cirillo','Keith Flippen','Elizabeth Becka','Vas Sanchez','Ronny Chieng','Robert Tinsley','Nick Gomez','Justin Eaton','Caleb Thomas','Karla Martínez',"Peg O'Keef",'Tess Malis Kincaid','Jon Bass','Rhys Coiro','Patty Guggenheim','Britt George','Leon Lamar','Mike Benitez','David Otunga','Brandon Stanley','Griffin Matthews','Darin Toonder','Michel Curiel','Mahdi Cocci','Thao Thanh Nguyen','David Pasquesi','Patti Harrison','Abigail Esmena','Daniel Annone','Trevor Salter','McKenzie Kurtz','Terrence Clowe','John Pirruccello','Ryan Monolopolus','Malia Arrayah','Mitch Miller','Justin Miles','Paul Rudd','Josh Brolin','Benedict Cumberbatch','Terry Notary','Justin Eaton','Joseph Castillo-Midyett','Tiffany Denise Hobbs','Paul Ryden','Vincent van Hinte','Si Chen','George Bryant','Jason Turner','Quincy Giles','Monica Garcia Bradley'],
basedOn:['Stan Lee'],
screenplay:['Jessica Gao','Melissa Hunter','Dana Schwartz','Kara Brown','Cody Ziglar','Zeb Wells','Francesca Gailes','Jacqueline Gailes'],
production:['Melissa Hunter'],
music:['Amie Doherty'],
camera:['Doug Chamberlain','Florian Ballhaus'],
cut:['Zene Baker','Jamie Gross','Stacey Schroeder'],
sound:['Pete Horner','Karol Urban','Steve Bissinger','Mac Smith'],
scenography:['Claudia Bonfe','Elena Albanese'],
masks:['Amy Wood'],
costumes:['Ann Foley']},
{title:'Diabolical',
titleCZ:'Banda: Ďábelské historky',
year:2022,
runtime:'1h 52min',
episodeRuntime:'13-15min',
countries:['USA'],
genres:['Animation','Action','Adventure','Sci-Fi','Comedy'],
director:['Crystal Chesney','Derek Lee Thompson','Parker Simmons','Giancarlo Volpe','Naz Ghodrati-Azadi','Madeleine Flores','Matthew Bordenave','Steve Ahn'],
actors:['Ben Schwartz','Fred Tatasciore','Jenny Yokobori','Frances Conroy','Asjha Cooper','Grey Griffin','Xolo Maridueña','Caleb McLaughlin','Eugene Mirman','Retta','Justin Roiland','Parker Simmons','Christian Slater','Kevin Smith','Kenan Thompson','Gary Anthony Williams','Michael Cera','Kieran Culkin','Jason Isaacs','Dominique McElligott','Simon Pegg','Kevin Michael Richardson','Antony Starr','Chris Diamantopoulos','Emily V. Gordon','Colby Minifie','Kumail Nanjiani','Nasim Pedrad','Eliot Glazer','Awkwafina','Nicole Byer','Chace Crawford','Seth Rogen','Don Cheadle','John DiMaggio','Aisha Tyler','Randall Duk Kim','Khary Payton','Andy Samberg','Yeo-jeong Yoon','Giancarlo Esposito','Jermaine Fowler','David Marciano','Elisabeth Shue','Ursula Taherian','Sean Patrick Thomas','Kimberly Brooks'],
basedOn:['Garth Ennis','Darick Robertson'],
screenplay:['Awkwafina','Garth Ennis','Seth Rogen','Justin Roiland','Andy Samberg','Evan Goldberg','Ben Bayouth','Eliot Glazer','Aisha Tyler','Simon Racioppa'],
music:['Julie Bernstein','Steven Bernstein','Ryan Elder','Christopher Lennertz','Matt Bowen','Sherri Chung','Leo Birenberg','Zach Robinson','Dara Taylor','Hyesu Wiedmann'],
cut:['Zack Alves','Charlene Ramos'],
sound:['James Lucero','Konrad Piñon','James Singleton']},
{title:"Marvel's The Defenders",
titleCZ:'The Defenders',
year:2017,
runtime:'6h 42min',
episodeRuntime:'45-57min',
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['S.J. Clarkson','Peter Hoar','Uta Briesewitz','Stephen Surjik','Farren Blackburn','Félix Enríquez Alcalá','Phil Abraham'],
actors:['Finn Jones','Charlie Cox','Mike Colter','Krysten Ritter','Rosario Dawson','Jessica Henwick','Elodie Yung','Sigourney Weaver','Simone Missick','Scott Glenn','Wai Ching Ho','Ramon Rodriguez','Deborah Ann Woll','Elden Henson','Rachael Taylor','Eka Darville','Carrie-Anne Moss','Peter McRobbie','Marko Zaror','Phil Nee','Amy Rutberg','Chloe Levine','Debbi Morgan','Deborah Twiss','J. Mallory McCree','John Solo','Rob Morgan','Emily Dorsch','Otoja Abit','Zack Robidas','Babs Olusanmokun','Chantal Maurice','Yutaka Takeuchi','Ron Simons','Michelle Federer','Zenzi Williams','Monica Wyche'],
screenplay:['Marco Ramirez','Lauren Schmidt','Douglas Petrie'],
production:['Evan Perazzo'],
music:['John Paesano'],
camera:['Manuel Billeter','Matthew J. Lloyd','James McMillan'],
cut:['Miklos Wright'],
sound:['Joe Barnett','Adam Jenkins','Julian Townsend'],
scenography:['Stephanie Q. Bowen','Loren Weeks','Malchus Janocko'],
masks:['Emma Strachman','Kaela Dobson','Annie Martin'],
costumes:['Stephanie Maslansky']},
{title:'Jessica Jones',
titleCZ:'Jessica Jones',
year:2015,
runtime:'33h 35min',
episodeRuntime:'44-56min',
countries:['USA'],
genres:['Action','Crime','Drama','Sci-Fi','Thriller'],
director:['S.J. Clarkson','David Petrarca','Stephen Surjik','Billy Gierhart','Rosemary Rodriguez','Uta Briesewitz','Simon Cellan Jones','John Dahl','Michael Rymer','Anna Foerster','Minkie Spiro','Mairzee Almas','Deborah Chow','Millicent Shelton','Jennifer Getzinger','Zetna Fuentes','Neasa Hardiman','Jennifer Lynch','Liz Friedlander','Michael Lehmann','Krysten Ritter','Anton Cropper','Liesl Tommy','Tim Iacofano','Larry Teng','Sanford Bookstaver','Sarah Boyd','Jet Wilkinson'],
actors:['Krysten Ritter','Rachael Taylor','Eka Darville','David Tennant','Carrie-Anne Moss','Mike Colter','Wil Traval','Erin Moriarty','Michael Siberry','Rosario Dawson','Marko Caka','Susie Abromeit','Brian J. Carter','Mauricio Ovalle','Brett Azar','Monte Bezell','Justin Clarke','James Colby','Craig DiFrancia','Thomas Kopache','Mark Lotito','Leslie Lyles','Amanda Warren','Aaron Costa Ganis','Ricky Paull Goldin','Angel Pai','Mike Houston','Joseph Ragno','Robin Weigert','Clarke Peters','Jan Kutrzeba','Birkett Turton','Jessica Hecht','Mary Looram','Catherine Blades','Deborah Hedwall','Ian Blackman','Kieran Mulcare','Colby Minifie','Elliot Santiago','Rebecca De Mornay','Patrick Richwood','James Freedson-Jackson','Miriam Shor','Michelle Hurd','Lia Yang','Vanessa Vander Pluym','Royce Johnson','Sonnie Brown','Elizabeth Cappuccino','Stan Lee','Owen Asztalos','Gabriel Sloyer','Cece King','Janet McTeer','Terry Chen','J.R. Ramirez','Ashlie Atkinson','James McCaffrey','Kevin Chacon',"Da'Vinchi",'Parisa Fitz-Henley','Hal Ozsan','Angel Desai','Jay Klaitz','John Ventimiglia','Christina Wright','Chris McGinn','Elden Henson','Ben Van Bergen','Leah Gibson','Victoria Cartagena','Victor Pagan','Callum Keith Rennie','Mel Johnson Jr.','Mat Vairo','Renata Hinrichs','Justin Sintic','Emmy Harrington','Rob Morgan','Lane Napper','Jon Norman Schneider','Barbara Kingsley','Kathleen Doyle','Kobi Libii','DeShawn White','Mandela Bellamy','Evan Hall','Jeté Laurence','Dante Pereira-Olson','Frank Licari','Jacqueline Antaramian','Lisa Emery','Zak Steiner','Haley Murphy','Rachel McKeon','Thaddeus Daniels','Grayson Berry','Ruibo Qian','Lynn Marocola'],
screenplay:['Dana Baratta','Hilly Hicks Jr.','Micah Schraft','Edward Ricourt','Jenna Reback','Scott Reynolds','Jamie King','Melissa Rosenberg','Liz Friedman','Lisa Randolph','Nancy Won','Jane Espenson','Jenny Klein','J. Holtham','Jack Kenny','Gabe Fonseca'],
music:['Sean Callery','Jamie Forsyth'],
camera:['Manuel Billeter','Petr Hlinomaz'],
cut:['Michael N. Knue','Jonathan Chibnall','Shoshanah Tanzer','Jennifer Barbot'],
sound:['Vicki Lemar','Christian P. Minkler','Joe Earle','Kenneth Kobett','Jim Fitzpatrick','Sherry Klein','Doug Andham','Bob Newlan','Julian Townsend','Michael Ferdie','Jared Orlando'],
scenography:['Toni Barton','Loren Weeks','Halina Gebarowicz','David Schlesinger'],
masks:['Caitlin Boland','Robert Lugo','Emma Strachman','Annie Martin','Alexandra Urvois'],
costumes:['Stephanie Maslansky','Elisabeth Vastola','Jennifer Rogien']},
{title:"Marvel's Iron Fist",
titleCZ:'Iron Fist',
year:2017,
runtime:'20h 52min',
episodeRuntime:'49-62min',
countries:['USA'],
genres:['Action','Sci-Fi'],
director:['Miguel Sapochnik','Uta Briesewitz','John Dahl','Tom Shankland','RZA','Farren Blackburn','Kevin Tancharoen','Peter Hoar','Deborah Chow','Andy Goddard','Stephen Surjik','David Dobkin','Rachel Talalay','Toa Fraser','M.J. Bassett','Mairzee Almas','Philip John','Sanford Bookstaver','Jonas Pate','Julian Holmes','Jet Wilkinson'],
actors:['Finn Jones','Jessica Henwick','Jessica Stroup','Tom Pelphrey','David Wenham','Rosario Dawson','Wai Ching Ho','Ramon Rodriguez','Sacha Dhawan','Barrett Doss','Clifton Davis','Carrie-Anne Moss','Ramon Fernandez','Olek Krupa','Toby Nichols','Ludovic Coutaud','David Furr','Victoria Haynes','Esau Pritchett','Craig Walker','Alex Wyse','Murray Bartlett','Sala Baker','Lisa Masters','Hoon Lee','David Sakurai','Henry Yuk','Alessia Sushko','Marquis Rodriguez','Samantha Herrera','Jonathan Lee','Lewis Tan','Alice Eve','James Hiroyuki Liao','Natalie Smith','James Saito','James Chen','Andrew Pang','Simone Missick','Rob Morgan','Rosa Arredondo','Christine Toy Johnson','Michael Maize','Michael Tow','Taylor Treadwell','Alejandra Rivera Flaviá','Fernando Chien','Julee Cerda','Tijuana Ricks','Giullian Yao Gioiello','Jean Tree','Taylor A. Purdee','Lauren LaVera','Victor Sho','Sydney Mae Diaz','Alok Tewari','Christina Nieves','MaameYaa Boafo','Gita Reddy','Jeanna de Waal','Shiv Pai','John Sanders','Brandon Alan Smith','Sol Landerman','Zakiya Young','Patrick Walker','Doua Moua','Frank Modica','Elise Santora','Jeff Kim','Jon Kit Lee'],
basedOn:['Gil Kane'],
screenplay:['Scott Buck','Matthew White','Melissa Glenn','Pat Charles','Jenny Lynn','Tatiana Suarez-Pico','Rebecca Dameron','Declan De Barra','Tamara Becher','Jon Worley','Daniel Shattuck','Ian Stokes'],
production:['Evan Perazzo','Declan De Barra','Tamara Becher'],
music:['Trevor Morris','Robert Lydecker'],
camera:['Manuel Billeter','Christopher LaVasseur','Niels Alpert'],
cut:['Michael N. Knue','Jonathan Chibnall','Miklos Wright','Andrew Coutts','Tim Brinker'],
sound:['Joe Barnett','Adam Jenkins','Bob Newlan'],
scenography:['Stephanie Q. Bowen','Loren Weeks','Patrick Howe','Michael Nallan'],
masks:['Caitlin Boland','Kaela Dobson','Annie Martin'],
costumes:['Stephanie Maslansky']},
{title:'Luke Cage',
titleCZ:"Marvel's Luke Cage",
year:2016,
runtime:'24h 27min',
episodeRuntime:'46-69min',
countries:['USA'],
genres:['Action','Sci-Fi'],
director:['Paul McGuigan','Lucy Liu','Andy Goddard','Clark Johnson','Marc Jobst','George Tillman Jr.','Vincenzo Natali','Guillermo Navarro','Phil Abraham','Steph Green','Salli Richardson-Whitfield','Kasi Lemmons','Millicent Shelton','Rashaad Ernesto Green','Neema Barnette','Stephen Surjik','Everardo Gout','Alex Garcia Lopez'],
actors:['Mike Colter','Simone Missick','Theo Rossi','Alfre Woodard','Rosario Dawson','Mahershala Ali','Mustafa Shakir','Ron Cephas Jones','Frank Whaley','Rob Morgan','Gabrielle Dennis','Reg E. Cathey','Sean Ringgold','Parisa Fitz-Henley','Frankie Faison','Peter Jay Fernandez','Thomas Q. Jones','Elden Henson','Finn Jones','Jessica Henwick','John Scurti','Erik LaRay Harvey','Karen Pittman','Jaiden Kaine','Jacob Vargas','Michael Kostroff','Method Man','Corri English','Chance Kelly','Sônia Braga','David Chen','Jade Wu','Khalil Maasi','Marko Caka','P.J. Marshall','Sonja Sohn','Stephen Hill','Justin Swain','Deborah Ayorinde','Craig muMs Grant','Dawn-Lyen Gardner','Cassandra Freeman','Hugues Faustin','Brian Marc','Andrew Pang','Manny Perez','Stan Lee','Raphael Saadiq','Marquis Rodriguez','Stephen Rider','Roger Wayne','Ninja N. Devoe','Justin Clarke','Danny Johnson','Andy Schneeflock','Daniel Keith','Jermel Howard','Michaela Jaé Rodriguez','Ian Lyons','Robert Neary','Annabella Sciorra','Dorian Missick','Otto Sanchez','Sahr Ngaujah','Carolyn Michelle Smith','Hakim Callender','Stefan Holdbrook','Harold Surratt','Derrick Simmons','Alyma Dorsey','Erika Rolfsrud','Antonique Smith','Freddie Kuguru','Ghostface Killah','Faith Evans','Jadakiss','LaTanya Richardson Jackson','Curtiss Cook','Henry Yuk','Krista Donargo','Marcus Choi','Parisa Fitz-Henley','Reg E. Cathey',"Peyton 'Alex' Smith",'Jamar Greene','Jeff Auer','Aseem Tiwari','John Clarence Stewart','Lynn Marocola','Reginald L. Barnes','Chaz Lamar Shepherd','Truck Hudson','Camrus Johnson','Taylor Selé','Tim Moriarty','Helmar Augustus Cooper','Ignacyo Matynia','Jason Abrams','Tijuana Ricks','J. Alphonse Nicholson'],
screenplay:['Akela Cooper','Charles Murray','Cheo Hodari Coker','Matt Owens','Jason Horwitch','Nathan Louis Jackson','Nicole Mirante-Matthews','Ian Stokes'],
production:['Akela Cooper'],
camera:['Manuel Billeter','Petr Hlinomaz'],
cut:['Miklos Wright','Jonathan Chibnall','Tim Mirkovich','Tirsa Hackshaw','Marie Lee','Jon Otazua'],
sound:['Joe Barnett','Adam Jenkins','Jonathan Golodner','Julian Townsend'],
scenography:['Scott P. Murphy','Toni Barton','Loren Weeks','Malchus Janocko'],
masks:['Kaela Dobson'],
costumes:['Stephanie Maslansky','Sharon Globerson']},
{title:'Yellowjackets',
titleCZ:'Yellowjackets',
year:2021,
runtime:'18h 32min',
episodeRuntime:'57-60min',
countries:['USA'],
genres:['Drama','Horror','Mystery','Thriller'],
director:['Karyn Kusama','Jamie Travis','Eva Sørhaug','Deepa Mehta','Bille Woodruff','Ariel Kleiman','Daisy von Scherler Mayer','Eduardo Sánchez','Ben Semanoff','Jeff W. Byrd','Scott Winant','Liz Garbus','Anya Adams'],
actors:['Melanie Lynskey','Juliette Lewis','Christina Ricci','Tawny Cypress','Jasmin Savoy Brown','Pearl Amanda Dickson','Courtney Eaton','Samantha Hanratty','Jacob Houston','Steven Krueger','Sophie Nélisse','Ella Purnell','Bess Rous','Sophie Thatcher','Jane Widdop','Aiden Stoxx','Winson Won','Eric Pollins','Jeff Holman','Princess Davis','Andres Soto','Liv Hewson','Kevin Alves','Alexa Barajas','Jack DePew','Carlos Sanz','Rekha Sharma','Sarah Desjardins','Rukiya Bernard','Mya Lowe','Charlie Wright','Jill Basey','Van Epperson','Adil Zaidi','Warren Kole','Peter Gadiot','Alex Wyndham','Laara Sadiq','BJ Harrison','Kallie Hu','Lauren K. Robek','Derek Hamilton','Balinder Johal','Ben Wilkinson','Paul Moniz de Sa','Nikolai Witschl','Amber Taylor','Gabrielle Rose','Kevin McNulty','Tanya Jade','Leah Hennessey','Colleen Wheeler','Gig Morton','Michelle Choi-Lee','Beverley Breuer','Meghan K. Lees','Patrick Roccas','William Vaughan','Harv Sihra','Keeya King','Michael Meneer','Tonya Cornelisse','Eve Sigall','Elijah Wood','Rohain Arora','Madonna Gonzalez','Simone Kessell','Nicole Maines','Nia Sondaya','Caitlynne Medrek','Andy Thompson','Maggie Ma','Caroline Shaw','John Reynolds','Kelsey Lopes','François Arnaud','Lauren Ambrose','Julio Rod Marín','Khobe Clarke','Shawna Clarke','Luciano Leroux','Michelle Creber','Jenna Burgess','Oscar Chark','Michael Crouse','Jennifer Lines','Owen Gates','Riley Baron','Jocelyn Kim','Shishy Gebru','Aqqalu Meekis','Erik Gow','Alexandra Voicu','Derek Kwan','JP Padda','Alex Pychtin','John Cameron Mitchell','Nuha Jes Izman'],
screenplay:['Ashley Lyle','Bart Nickerson','Jonathan Lisco','Chantelle Wells','Sarah L. Thompson','Liz Phang','Ameni Rozsa','Katherine Kearns','Cameron Brent Johnson','Julia Bicknell','Karen Joseph Adcock'],
production:['Brad Van Arragon','Ani Arutyunyan','Chantelle Wells','Kathy Gilroy','Tayah Geist'],
music:['Anna Waronker','Craig Wedren','Theodore Shapiro'],
camera:['Julie Kirkwood','C. Kim Miles','Trevor Forrest','Shasta Spahn','François Dagenais','Corey Robson'],
cut:['Plummy Tucker','Kevin D. Ross','Jeff Israel','Kindra Marra','Damien Smith','Daniel Williams'],
sound:['Adam Sawelson','Vicki Lemar','Robb Navrides','Kenneth Kobett','Brett Hinton','Matthew T. Duncan','Michael T. Williamson'],
scenography:['Brian Kane','Catherine Smith','Jennifer Lukehart','Margot Ready'],
masks:['Kimberly Carlson','Ellen Vieira','Beverly Hoy','Teia Dumaresq','Amy Bell','Katelyn Abbott','James Dreichel','Brooke Fenton','Kelly Grange','Patricia Murray','Jeannie Chow'],
costumes:['Marie Schley','Caroline B. Marx','Amy Parris']},
{title:'Obi-Wan Kenobi',
titleCZ:'Obi-Wan Kenobi',
year:2022,
runtime:'4h 23min',
episodeRuntime:'36-52min',
countries:['USA'],
genres:['Sci-Fi','Action','Adventure'],
director:['Deborah Chow'],
actors:['Ewan McGregor','Vivien Lyra Blair','Joel Edgerton','Moses Ingram','Grant Feely','Jimmy Smits','Simone Kessell','Rupert Friend','Sung Kang','Bonnie Piesse','Hayden Christensen','Kumail Nanjiani','Indira Varma','Benny Safdie','Flea','Derek Basco','Anthony Daniels','Temuera Morrison','Jecobi Swain','Marisé Alvarez','Hayden Christensen','James Earl Jones','Shane Hartline','Will Westwater','Rya Kihlstedt','Zach Braff',"O'Shea Jackson Jr.",'Maya Erskine','Ian McDiarmid','Crispian Belfrage','Ryder McLaughlin','Joss Glennie-Smith','Liam Neeson','Ardeshir Radpour','Zack Palmisano','Helen Day','Ian Inigo','Dustin Ceithamer','Esther McGregor'],
screenplay:['Hossein Amini','Joby Harold','Hannah Friedman','Stuart Beattie','Andrew Stanton'],
production:['Katterli Frauenfelder','Thomas Hayslip'],
music:['Natalie Holt','William Ross','John Williams'],
camera:['Jung-hoon Jung'],
cut:['Nicolas De Toth','Kelley Dixon'],
sound:['Julian Howarth','Scott R. Lewis','Danielle Dupre'],
scenography:['Todd Cherniawsky','Doug Chiang','Jan Pascale','Rebekah Killam'],
masks:['Rheanne Garcia','Greg Funk','Desiree Falcon','Luisa Abel'],
costumes:['Suttirat Anne Larlarb']},
{title:'The Summer I Turned Pretty',
titleCZ:'Léto, kdy jsem zkrásněla',
year:2022,
runtime:'12h 16min',
episodeRuntime:'39-59min',
countries:['USA'],
genres:['Drama','Romance'],
director:['Jesse Peretz','Jeff Chan','Erica Dunton','Zoe R. Cassavetes','Isabel Sandoval','Sophia Takal','Megan Griffiths'],
actors:['Lola Tung','Gavin Casalegno','Jackie Chung','Christopher Briney','Al Vicente','Rain Spencer','Alfredo Narciso','J.R. Rodriguez','Minnie Mills','Sean Kaufmann','David Iacono','Colin Ferguson','Rachel Blanchard','Summer Madison','Major Dodge Jr.','Jocelyn Shelfo','Bryan McClure','Nicole Marie Johnson','Rae DeRosa','Cara Mantella','Elsie Fisher','Kyra Sedgwick','Tom Everett Scott','Zach Hanner','Becca Breitfeller'],
basedOn:['Jenny Han'],
screenplay:['Deborah Swisher','Jenny Han','Marty Scott','Becca Gleason','Jenny Zhang','Speed Weed','Bayan Wolcott','Gabrielle G. Stanton','Krystle Drew','Scarlett Curtis','Sabrina Sherif','Vanessa Rojas','Sarah Kucserka'],
production:['Deborah Swisher','Marty Scott','Nicole Colombie','Jenny Zhang'],
music:['Zachary Dawes'],
camera:['J.B. Smith','Sandra Valde-Hansen'],
cut:['Jamie Kennedy','Lindsay Armstrong','Lauren A. Schaffer','Alisa Lepselter','Martin Wilson','Kate Hickey','Sean Fawcett'],
sound:['Joe Morrow','Stacy Coutts'],
scenography:['Teresa Mastropierro','Beth Robinson','Hilda Stark'],
masks:['Christina Maher Holland','Jessica Lou Allen'],
costumes:['Jessica Flaherty']},
{title:'Wayward Pines',
titleCZ:'Městečko Pines',
year:2015,
runtime:'14h 31min',
episodeRuntime:'42-44min',
countries:['USA'],
genres:['Drama','Mystery','Sci-Fi','Thriller'],
director:['M. Night Shyamalan','Steve Shill','Nimród Antal','James Foley','Charlotte Sieling','Jeff T. Thomas','David Petrarca','Zal Batmanglij','Tim Hunter','Brad Turner','John Krokidas','Ti West','Alrick Riley','Vincenzo Natali','Jennifer Lynch','Mathias Herndl'],
actors:['Siobhan Fallon Hogan','Matt Dillon','Carla Gugino','Toby Jones','Shannyn Sossamon','Melissa Leo','Hope Davis','Reed Diamond','Terrence Howard','Tim Griffin','Charlie Tahan','Juliette Lewis','Lisa MacFadden','Barclay Hope','Kennedi Clements','Alison Araya','Sarah Desjardins','Jarod Joseph','Justin Kirk','Jared Ager-Foster','Sarah Jeffery','Greta Lee','Allyson Grant','Primo Allon','Manny Jacinto','Chris Shields','Gerardo Barcala','Anthony Welch','Toby Levins','Andrew Jenkins','Giacomo Baessato','Chad Krowchuk','Samuel Patrick Chu','Michael McShane','Jane Craven','Craig March','Scott Michael Campbell','Jason Patric','Nimrat Kaur','Josh Helman','Kacey Rohl','Djimon Hounsou','Naika Toussaint','Malcolm Goodwin','Nickolas Baric','Katie Hayashida','Simone Missick','Jessica Harmon','Lusia Strus','Lindsay Hollister','Teryl Rothery','Ian Tracey','Nicholas Carella','Robin Nielsen','Jeffrey Ballard','Emma Tremblay','Dean Petriw','Kate Bateman','Jennifer-Juniper Angeli','Christian Michael Cooper','Dakota Daulby','Françoise Yip','Sarah Grey','Paul Lazenby','Dakota Guppy','Lisa Bunting','Danny Mac','Tom Stevens','Devin Hansen','Grayson Gabriel','Elizabeth Bowen','Bruce Blain','Iain Belcher','Lindsey Kraft','BJ Harrison','Liam Hughes',"Tyronne L'Hirondelle",'Ricky He','Jason McKinnon','Jaime M. Callica','Latonya Williams','Sarah Corrigan','Jeanie Cloutier','Michael Garza','Nathan Witte','RJ Fetherstonhaugh','Hunter Dillon','Glen Gordon','Cody Davis','Blair Penner','Amitai Marmorstein','David Raynolds','Sinead Hogan','Sydney Bell','Darryl Scheelar','Corina Akeson','Tina Georgieva'],
screenplay:['Blake Crouch','Matt Duffer','Ross Duffer','Chad Hodge','Brett Conrad','Mark Friedman','Michael R. Perry','Edward Ricourt','Tyler Hisel','Anna Fricke','Seamus Kevin Fahey','Nazrin Choudhury','Patrick Aison','Rob Fresco'],
production:['Donald De Line','Shawn Williamson','Ron French','Patrick Aison'],
music:['Charlie Clouser'],
camera:['Gregory Middleton','Jim Denault','Amy Vincent','Mathias Herndl','Mark Chow'],
cut:['Elizabeth Kling','Tim Mirkovich','Steven Cohen','Michael Ruscio','Glenn Farr','Leo Trombetta','John Axness','Doc Crotzer','Jennifer Van Goethem'],
sound:['Samuel Ejnes','Bob Beemer','Ross Davis','Zach Martin','Gary Gegan','Jack Levy'],
scenography:['Ross Dempster','Curt Beech','Tedd Kuchera','Michael Norman Wong','Janessa Hitsman','David Clarke'],
masks:['Brittin Ireland','Cayley Giene','Darah Wyant','Vicki Syskakis'],
costumes:['Mary E. Vogt','Tish Monaghan']},
{title:'I Am Groot',
titleCZ:'Já jsem Groot',
year:2022,
runtime:null,
episodeRuntime:'49min4-6min',
countries:['USA'],
genres:['Action','Adventure','Comedy'],
director:['Kirsten Lepore'],
actors:['Vin Diesel','Bradley Cooper','Fred Tatasciore','Bob Bergen','Scott Menville','Kaitlyn Robrock','Kari Wahlgren','Matthew Wood','James Gunn','Trevor Devall','Jeffrey Wright','Dee Bradley Baker'],
screenplay:['Kirsten Lepore'],
production:['Dana Vasquez-Eberhardt'],
music:['Daniele Luppi'],
cut:['Dan Urrutia'],
sound:['Coya Elliott','Tony Villaflor'],
scenography:['Loic Zimmermann']},
{title:'The Mentalist',
titleCZ:'Mentalista',
year:2008,
runtime:'106h 57min',
episodeRuntime:'39-45min',
countries:['USA'],
genres:['Drama','Crime','Mystery','Thriller'],
director:['David Nutter','Chris Long','Rod Hardy','Kevin Dowling','Bruno Heller','Dean White','John Behring','Simon Baker','Roxann Dawson','Tawnia McKiernan','Anton Cropper','Edward Ornelas','Nina Lopez-Corrado','Geary McLeod','Randy Zisk','Charles Beeson','Eric Laneuville','John F. Showalter','John Polson','Bobby Roth','David Barrett','Martha Mitchell','Matt Earl Beesley','Paris Barclay','Lesli Linka Glatter','Paul Holahan','Norberto Barba','Adam Kane','Bill Eagles','Michael Nankin','Rod Holcomb','W. Thomas Snyder','Paul A. Kaufman','Dan Lerner',"Bill D'Elia",'Stephen Gyllenhaal'],
actors:['Simon Baker','Amanda Righetti','Robin Tunney','Steven Culp','Tim Kang','Tim Guinee','Owain Yeoman',"Gail O'Grady",'Shaun Toub','Tara Karsian','Morena Baccarin','Brett Cullen','Željko Ivanek','Brando Eaton','Elisabeth Röhm','Mark Weiler','Owen Beckman','Judith Hoag','Deborah Ann Woll','Charles Shaughnessy','Elpidia Carrillo','Josh Stewart','Bodhi Elfman','Geoff Pierson','Cameron Monaghan','Fredric Lehne','Jeffrey Nordling','Bryce Johnson','Paul Michael Glaser','Jake Busey','Gregory Itzin','Joe Adler','Michael Mosley','Mark Pellegrino','Azura Skye','Jack Betts','Torin Sixx','Nancy Stafford','Eric Stonestreet','Rick Worthy','Tony Curran','William Russ','Dina Meyer','Olivia Hardt','Michelle Page','Meredith Monroe','Kristine Blackport','Jeff Witzke','Virginia Williams','Lori Lively','Noel Fisher','Cristine Rose','Dot-Marie Jones','Rebecca Rigg','Michael Trevino','Robin Weigert','Mark Engelhardt','Reynaldo Rosales','Marco Rodríguez','Samaire Armstrong','Dylan Bruno','Stephen Spinella','Will Rothhaar','Anthony Tyler Quinn','Marguerite MacIntyre','Alejandro Chabán','Bradley Whitford','Tracy Middendorf','M.C. Gainey','Art LaFleur','Louis Herthum','Derek Webster','Cheyenne Jackson','Meg Wolf','Richard Gunn','Lilli Birdsell','Scott L. Schwartz','Anthony Azizi','Isabella Acres','Michelle Clunie','Andrea Parker','Elon Gold','Steve Rankin','Jake McLaughlin','Frederick Koehler','Mekia Cox',"Becky O'Donohue",'Adrienne Rusk','Fernanda Andrade','Rebecca Wisocky','Kaitlyn Dever','Alexander Emmert','Chris Coy','Skyler Stone','Jonathan Chase','Paul Ganus','Ted Alderman','Ian Bohen','Adrian Gonzalez','Helena Mattsson'],
screenplay:['Bruno Heller','Andi Bushell','Mike Weiss','John Mankiewicz','Tom Szentgyörgyi','Tom Donaghy','Gary Glasberg','Ken Woodruff','Erika Green Swafford','Daniel Cerone','Marisa Wegrzyn','Alex Berger','Ashley Gable','Eoghan Mahony','Erin Donovan','David Appelbaum','Carolyn Ingber'],
production:['Erika Green Swafford','Alex Berger','Matthew Carlisle','Charlie Goldstein','Eoghan Mahony','Simon Baker'],
music:['Blake Neely'],
camera:['Jeffrey Jur','Michael Goi','Bill Roe','Christopher Faloona','Geary McLeod','Tom Camarda','Frank Perl','Alex Nepomniaschy'],
cut:['Christopher Cibelli','Glenn Farr','Paul Karasick','David Ekstrom','James Gadd'],
sound:['Ed Carr','Thierry J. Couturier','Todd Grace','Tilo Alpermann','Michael E. Lawshe','Daniel P. Church','Charles Hamilton','Mack Melson'],
scenography:['Julie Walker','Michael Novotny','Bryan Thetford','Cherie Day Ledwith','Jason Zev Cohen'],
masks:['Kymber Blake','Susan Kelber','Ingrid Hartowicz-Fuentes','Matthew W. Mungle','Dennis Parker','David Fields','Ketty Gonzalez','Alicia M. Tripi','Amy McHale','Marianna Elias'],
costumes:['Amanda Friedland','Julia Schklair']},
{title:'Moon Knight',
titleCZ:'Moon Knight',
year:2022,
runtime:'4h 45min',
episodeRuntime:'42-51min',
countries:['USA'],
genres:['Action','Adventure','Drama'],
director:['Mohamed Diab','Justin Benson','Aaron Moorhead'],
actors:['Oscar Isaac','Ethan Hawke','May Calamawy','Gaspard Ulliel','F. Murray Abraham','Ann Akinjirin','Fernanda Andrade','Lucy Thackeray','Ahmad Dash','Díana Bermudez','Hayley Konadu','Khalid Abdalla','Saba Mubarak','Declan Hannigan','Nagisa Morimoto','Karim El Hakim','Michael Benjamin Hernandez','Mohamed Diab','Joseph Millson','Barbara Rosenblat','Alexander Cobb','Darwin Shaw','Terique Jarrett','Fiz Marcus','András Korcsmáros','Gabriella Csizmadia','Peyvand Sadeghian','Eric Colvin','Grant Curtis','Miriam Nyarko'],
basedOn:['Jack Kirby','Stan Lee'],
screenplay:['Jeremy Slater','Don Perlin','Beau DeMayo','Michael Kastelein','Peter Cameron','Sabir Pirzada','Rebecca Kirsch','Matthew Orton','Alex Meenehan'],
production:['Sabir Pirzada','Peter Cameron'],
music:['Hesham Nazih'],
camera:['Gregory Middleton','Andrew Droz Palermo'],
cut:['Cedric Nairn-Smith','Joan Sobel','Ahmed Hafez'],
sound:['Scott R. Lewis','Mac Smith'],
scenography:['Stefania Cella','Domenico Sica','Véronique Melery','Peter Findley'],
masks:['Farah Jadaane'],
costumes:['Meghan Kasperlik']},
{title:'Castle Rock',
titleCZ:'Castle Rock',
year:2018,
runtime:'16h 36min',
episodeRuntime:'43-60min',
countries:['USA'],
genres:['Fantasy','Horror','Mystery','Thriller','Drama'],
director:['Michael Uppendahl','Daniel Attias','Andrew Bernstein','Kevin Hooks','Greg Yaitanes','Ana Lily Amirpour','Nicole Kassell','Phil Abraham','Anne Sewitsky','Mark Tonderai','Loni Peristere','Craig William Macneill'],
actors:['Melanie Lynskey','Scott Glenn','André Holland','Jane Levy',"Terry O'Quinn",'Bill Skarsgård','Sissy Spacek','Alex Ziwak','Phyllis Somerville','Ryan Eatherton','Noel Fisher','Frances Conroy','Ann Cusack','Chris Coy','Josh Cooke','Caleel Harris','Schuyler Fisk','Charlie Tahan','Kevin Dennis','John W. Iwanonkiw','Allison Tolman','Adam Rothenberg','Aaron Staton','Brionne Davis','Cassady McClincy','Audrey Moore','Russell Posner','Mark Zeisler','Mark Harelik','Lauren Bowles','David Selby','Noel Fisher','Richard Schiff','Zabryna Guevara','James Le Gros','Jeffrey Pierce','Peta Sergeant','Amanda Brooks','Rory Culkin','Chosen Jacobs','CJ Jones','Richard Chandler','Rodrigo Lopresti','Jayne Atkinson','Anna Rizzo','Mamie Gummer','Brett Rickaby','Nada Despotovich','Bates Wilder','Celeste Oliva','Tim Robbins','Lizzy Caplan','Elsie Fisher','Yusra Warsama','Barkhad Abdi','Matthew Alan','Paul Sparks','John Hoogenakker','Owen Burke','Abby Corrigan','James Wilcox','Tenea Intriago','Isayas Theodros','Colbi Gannett','Chad Knorr','Erica McDermott','Charlie Tacker','Christine Mascott','James Harvey Ward','Alison Wright','Sarah Gadon','Jennifer Lafleur','Robin Weigert','Greg Grunberg','Rhys Olivia Cote','Jimi Stanton','Ethan Herschenfeld','Johnny Lee Davenport','Madison Johnson','Mathilde Dehaye','Georgia Lyman','Joseph Bonamico','Rebecca Gibel','Kristina Byerley','Debbie Campbell','Lonnie Farmer','Frank Ridley','Ruby Cruz','Michael Malvesti','Michael Rodrick','Kris Sidberry','Alexandre Bagot','Reese Grande','Kate Avallone','Chris Richards','Colton Osorio','Forest Quaglia'],
screenplay:['Gina Welch','Sam Shaw','Dustin Thomason','Scott Brown','Vinnie Wilhelm','Marc Bernardin','Mark Lafferty',"K'Naan",'Daria Polatin','Guy Busick','Vince Calandra'],
production:['Scott Brown','Robin Sweet'],
music:['Thomas Newman','Chris Westlake'],
camera:['Richard Rutkowski','Jeffrey Greeley'],
cut:['Trevor Baker','Matthew Colonna','Nathan Easterling','Eleanor Infante','Hugo Diaz','Tammis Chandler','Ryan Jones','David Berman'],
sound:['Samuel Ejnes','Tim Kimmel','Andrew Garrett Lange','James Curwood','Jared Marshack','Gabriel J. Serrano'],
scenography:['Steve Arnold','Tony Fanning','Alex Cameron','Oana Bogdan Miller'],
masks:['Rachel Geary','Angela Marinis','Michelle Connolly'],
costumes:['John Dunn','Kathleen Detoro']},
{title:'The Falcon and the Winter Soldier',
titleCZ:'Falcon a Winter Soldier',
year:2021,
runtime:'5h 4min',
episodeRuntime:'47-57min',
countries:['USA'],
genres:['Action','Drama','Adventure','Sci-Fi'],
director:['Kari Skogland'],
actors:['Anthony Mackie','Sebastian Stan','Wyatt Russell','Erin Kellyman','Daniel Brühl','Desmond Chiam','Miki Ishikawa','Emily VanCamp','Adepero Oduye','Carl Lumbly','Marc Hockl','Georges St-Pierre','Noah Mills','Danny Ramirez','Don Cheadle','Amy Aquino','Ian Gregg','Vince Pisani','Jon Briddell','Akie Kotabe','Dani Deetté','Clé Bennett','Tyler Dean Flores','Ness Bautista','Florence Kasumba','Veronica Falcón','David Bowles','Nicholas Pryor','Giovanni Rodriguez','Antonie Formanová','Julia Louis-Dreyfus','Janeshia Adams-Ginyard','Antonio D. Charity','Demi Castro','Adam Vacula','Gabrielle Byndloss','Chase River McGhee','Aaron Haynes','Elijah Richardson','Ken Takemoto','Brad Brinkley','Jecobi Swain','Tyler Merritt','Jennifer Christa Palmer','Sinead Phelps','Malachi Malik'],
screenplay:['Malcolm Spellman','Derek Kolstad','Michael Kastelein','Dalan Musson','Josef Sawyer'],
production:['Malcolm Spellman','Ariella Blejer','Dawn Kamoche'],
music:['Henry Jackman'],
camera:['P.J. Dillon'],
cut:['Kelley Dixon','Jeffrey Ford','Todd Desrosiers','Rosanne Tan'],
sound:['Matthew Wood'],
scenography:['Ray Chan','Anne Kuljian','Jordan Crockett'],
masks:['Jessie Gambardella','Katie Ballard','Jack Lazzaro'],
costumes:['Eric Daman','Michael Crow']},
{title:'Ms. Marvel',
titleCZ:'Ms. Marvel',
year:2022,
runtime:'4h 44min',
episodeRuntime:'41-52min',
countries:['USA'],
genres:['Action','Adventure','Comedy'],
director:['Adil El Arbi','Bilall Fallah','Meera Menon','Sharmeen Obaid-Chinoy'],
actors:['Iman Vellani','Aramis Knight','Matt Lintz','Laurel Marsden','Rish Shah','Zenobia Shroff','Mohan Kapur','Alysia Reiner','Yasmeen Fletcher','Anjali Bhimani','Farhan Akhtar','Adaku Ononogbo','Azhar Usman','Arian Moayed','Jordan Firstman','Randy Havens','Saagar Shaikh','Mehwish Hayat','Travina Springer','Sophia Mahmud','Jordan Preston Carter','Nimra Bucha','Samina Ahmed','Ali Alsaleh','Vardah Aziz','Asfandyar Khan','Anjan Ghosal','Brie Larson','Laith Nakli','Lex Lauletta','Jessejames Locorriere','Alireza Ahmand','Michelle Pokopac','Nick DeKay','Ethan McDowell'],
screenplay:['Bisha K. Ali','Kate Gritmon','Freddy Syborn','A.C. Bradley','Matthew Chauncey','Fatimah Asghar','Willie Dunn'],
music:['Laura Karpman'],
camera:['Carmen Cabana','Robrecht Heyvaert',"Jules O'Loughlin"],
cut:['Nona Khodai'],
sound:['Steve Bissinger'],
scenography:['Jessie Haddad','Kathy Orlando','Christopher Glass'],
masks:['Katie Ballard','Priya Maharaj'],
costumes:['Arjun Bhasin']},
{title:'Agents of S.H.I.E.L.D.',
titleCZ:'Agenti S.H.I.E.L.D.',
year:2013,
runtime:'97h 8min',
episodeRuntime:'41-45min',
countries:['USA'],
genres:['Action','Drama','Sci-Fi'],
director:['Joss Whedon','David Straiton','Milan Cheylov','Roxann Dawson','Jonathan Frakes','Jesse Bochco','Vincent Misiano','Bobby Roth','Billy Gierhart','Holly Dale','Kevin Hooks','Kenneth Fink','Paul A. Edwards','John Terlesky','Kevin Tancharoen','Ron Underwood','Michael Zinberg','David Solomon','Garry A. Brown','Karen Gaviola','Dwight H. Little','Kate Woods','Wendey Stanzler','Elodie Keene','Brad Turner','Magnus Martens','Nina Lopez-Corrado','Jed Whedon','Oz Scott','Eric Laneuville','Clark Gregg','Stanley M. Brooks','Salli Richardson-Whitfield','Jennifer Lynch','Cherie Gierhart','Lou Diamond Phillips','Kristin Windell','Sarah Boyd','Jennifer Phang','Eli Gonda'],
actors:['Clark Gregg','Ming-Na Wen','Chloe Bennet','Elizabeth Henstridge','Iain De Caestecker','Brett Dalton','Nick Blood','Henry Simmons','Adrianne Palicki','Luke Mitchell','Constance Zimmer','Ruth Negga','J. August Richards','B.J. Britt','Blair Underwood','Kyle MacLachlan','Bill Paxton','Edward James Olmos','Dichen Lachman','Dillon Casey','Simon Kassianides','Jamie Harris','Reed Diamond','Maya Stojan','David Conrad','Titus Welliver','Saffron Burrows','Patton Oswalt','Elena Satine','Cobie Smulders','Samuel L. Jackson','Jaimie Alexander','Hayley Atwell','Lucy Lawless','Dylan Minnette','Juan Pablo Raba','Shannon Lucio','Adrian Pasdar','Christine Adams','Maximiliano Hernández','Neal McDonough','Cullen Douglas','Henry Goodman','Leonor Varela','Ian Hart','Drea de Matteo','Stan Lee','William Sadler','Ron Glass','Matthew Willig','Maiara Walsh','Anthony Dilio','Alicia Lagano','Dylan Bruno','Arlene Santana','Troy Glass','Brandon Molale','Emily Baldoni','Carlo Rota','Daniel Zovatto','Boyd Kestner','Rob Huebel','Molly McCook','Beth Kennedy','Michael Graziadei','Peter MacNicol','Ilia Volok','Charles Halford','Vincent Laresca','Austin Nichols','Louis Ozawa','Assaf Cohen','Carlos Leal','James MacDonald','Matt Mullins','Amy Acker','Brad Dourif','Brannon Bates','Patrick Brennan','Tsai Chin','Bayardo De Murguia','Raquel Gardner','Robert Baker','Joel Gretsch','Brian Van Holt','Kenneth Choi','Bruno Amato','Chase Kim','Trevor Larcom','Brian Tee','Jimmy O. Yang','Kris Lemche','Winter Ave Zoli','Derek Phillips','Mackenzie Astin','Kirk Acevedo','Tzi Ma','Max Daniels','Alvin Ing','Nick Gracer'],
basedOn:['Stan Lee','Jack Kirby'],
screenplay:['Jeffrey Bell','Brent Fletcher','Paul Zbyszewski','Rafe Judkins','Lauren LeFranc','Monica Owusu-Breen','Shalisha Francis','Ron Underwood','Craig Titley','Chris Dingess','Joss Whedon','Maurissa Tancharoen','Jed Whedon','Nora Zuckerman','Lilla Zuckerman','Daniel J. Doyle','Matt Owens','James C. Oliver','Sharla Oliver','George Kitson','Iden Baghdadchi','Mark Leitner','Drew Z. Greenberg'],
production:['Samantha Thomas','Chris Cheramie'],
music:['Bear McCreary','Jason Akers'],
camera:['David Boyd','Jeffrey C. Mygatt','Feliks Parnell','Allan Westbrook','Kyle Jewell'],
cut:['Debby Germino','Paul Trejo','Eric Litman','David Crabtree','Kelly Stuyvesant','Dexter N. Adriano','Joshua Charson'],
sound:['Daniel Colman','Gerry Lentz','Richard Weingart','Robert Carr','Mike Marchain','Jamey Scott','Mark D. Fleming','Robert Edmondson','Kenneth Kobett','Myron Nettinga','Kenn Fuller','Jack Levy','Tom Stasinis','Tucker Bodine'],
scenography:['Gregory S. Melton','Melissa M. Levander','Karin L. McGaughey'],
masks:['Megg Massey','Kenny Niederbaumer','Wendi Lynn Avignone','David Abbott','Jackie Dobbie','Ozzy Alvarez','Jori Jenae McGuire','Cynthia Hernandez','Robert Maverick','R.J. McCasland','Steven R. Soussanna','Shay Sanford-Fong'],
costumes:['Betsy Heimann','Amanda Riley','Ann Foley','Whitney Galitz','Jessica Torok']},
{title:"Marvel's Agent Carter",
titleCZ:'Agent Carter',
year:2015,
runtime:'12h 35min',
episodeRuntime:'41-43min',
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:["Louis D'Esposito",'Scott Winant','Vincent Misiano','Jennifer Getzinger','Peter Leto','Joe Russo','Stephen Cragg','Stephen Williams','Christopher Misiano','Lawrence Trilling','David Platt','Craig Zisk','Metin Hüseyin'],
actors:['Hayley Atwell','Chad Michael Murray','Enver Gjokaj','Dominic Cooper',"James D'Arcy",'Lyndsy Fonseca','Shea Whigham','Kyle Bornheimer','Meagen Fay','Bridget Regan','Stan Lee','James Frain','Neal McDonough','Leonard Roberts','Ray Wise','Toby Jones','Devin Ratray','Ashley Hinshaw','Jim Palmer','Yasmine Aker','James Urbaniak','Glenn Taranto','Caitlin Carmichael','Krista Marie Yu','Richard Short','James Landry Hébert','Gregory Sporleder','Webb Hayes','Myles Grier','Ralph Brown','Andre Royo','Wynn Everett','Reggie Austin','Currie Graham','Lotte Verbeek','Sarah Bolger',"Sean O'Bryan",'Kurtwood Smith','Chris Browning','Casey Sander','Rey Valentin','Max Brown','Samaire Armstrong','Chris Mulkey','Christopher Grove','Andrew Carter','Catriona Toop','Ken Marino','Max Daniels','Chris Coppola','Tim Soergel','John Balma',"Damian O'Hare",'Ivy George','Randy Sklar','Chiara Aurelia','John Bishop','Carl W. Crudup','Hope Lauren','Tom Choi','Lincoln Melcher','John Gilbert','Costa Ronin','Christie Herring','Billy Malone','Kellen Michael','Khalilah Joi','Andrew Carter','Joyce Greenleaf','Tim True','James Austin Kerr','John Kerry','Matt Braunger','Gabriella Graves','Dennis Fitzgerald',"Tina D'Marco",'Olivia Scott Welch','Paul Roache','Joseph Wilson','Kevin Changaris','Lesley Boone','Alex Alcheh','Claude Stuart','Clayton Norcross','Steven Hack','Bruce M. Stockert','DaJuan Johnson','Bruce Katzman','Alexandra Vino','Patrick Robert Smith'],
screenplay:['Eric Pearson','Jose Molina','Michele Fazekas','Tara Butters','Chris Dingess','Lindsey Allen','Brant Englestein','Christopher Markus','Stephen McFeely','Brandon Easton'],
production:['Brant Englestein'],
music:['Christopher Lennertz'],
camera:['Edward J. Pei'],
cut:['Troy Takaki','Chris Peppe','David Siegel','Mark Hartzell','Andrew Doerfer','Christopher Cooke'],
sound:['Daniel Colman','Robert Carr','Mark D. Fleming','Mark Ulano','Jack Levy'],
scenography:['Michael Wylie','Kenneth Hardy','Halina Siwolop','Ellen Totleben'],
masks:['Jamie Kelman'],
costumes:['Giovanna Ottobre-Melton']},
{title:"Marvel's Inhumans",
titleCZ:'Inhumans',
year:2017,
runtime:'5h 44min',
episodeRuntime:'43min',
countries:['USA'],
genres:['Action','Sci-Fi'],
director:['Roel Reiné','Chris Fisher','David Straiton','Kevin Tancharoen','Neasa Hardiman'],
actors:['Anson Mount','Serinda Swan','Iwan Rheon','Eme Ikwuakor','Ken Leung','Sonya Balmores','Ellen Woglom','Tanya Clarke','Isabelle Cornish','Mike Moh','Henry Ian Cusick','Michael Buie','Andra Nechita','Garret Sato','Sumire','Ty Quiamboa','Albert Ueligitone','Allan Cole','Deborah Glazier','Kekoa Kekumano','Chad James Buchanan','Aidan Fiske','Faleolo Alailima','Krista Alvarez','Jason Quinn','Matt Perfetuo'],
screenplay:['Scott Buck'],
production:['Kevin Feige'],
music:['Sean Callery'],
camera:['Jeffrey Jur'],
cut:['Radu Ion','Kristina Hamilton-Grobler','Tim Mirkovich','Jesse Ellis'],
sound:['Joe DeAngelis','Kenneth Kobett'],
scenography:['Carlos Barbosa','Bob Kensinger','Adam Davis','Tim Beach'],
masks:['Mike Smithson','Ralph Malani','Laverne Caracuzzi','Ozzy Alvarez'],
costumes:['Roland Sanchez']},
{title:'Runayways',
titleCZ:'Runaways',
year:2017,
runtime:'29h 9min',
episodeRuntime:'42-60min',
countries:['USA'],
genres:['Action','Drama','Sci-Fi'],
director:['Brett Morgen','Nina Lopez-Corrado','Ramsey Nickell','Peter Hoar','Millicent Shelton','Jeremy Webb','Allison Liddi-Brown','Chris Fisher','Larry Teng','Katie Eastridge','Philip John','Rob Hardy','Vanessa Parise','Jeff Woolnough','Geeta Vasant Patel'],
actors:['Virginia Gardner','Lyrica Okano','Ariela Barer','Gregg Sulkin','Kevin Weisman','Brittany Ishibashi','Rhenzy Feliz','Allegra Acosta','Ryan Sands','Annie Wersching','Kip Pardue','Ever Carradine','James Marsters','Brigid Brannagh','Zayne Emory','Cesar Garcia','Heather Olt','Ric Sarabia','Danielle Campbell','Ryan Doom','Timothy Granaderos','Alex Fernandez','Devan Chandler Long','Cody Kennedy','Carmen Serano','DeVaughn Nixon','Angel Parker','James Yaegashi','Julian McMahon','Stan Lee','Jorge Diaz','Tim Pocock','Roy Vongtama','Marlene Forte','Jeff Witzke','Nathan Davis Jr.','Charlie Charbonneau',"Cris D'Annunzio",'Ajiona Alexus','Rose Portillo','Julian Edwards','Kimmy Shields','Ryan Dorsey','A.J. Rivera','Elayn J. Taylor','Erica Lynne Arden','Mia Topalian','Akaash Yadav','Martin Martinez','Clarissa Thibeaux','Elizabeth Hurley','Jeremiah Birkett','Susan Papa','Kathleen Quinlan','Michelle N. Carter','Minae Noji','John Ales','Ashley Wigfield','Tom Proctor','Elliot Fletcher','Scarlett Hefner','Olivia Holt','Aubrey Joseph','Ever Carradine','James Yaegashi','Elizabeth Hurley','Anjelika Washington','Jan Luis Castellanos','Rachel Gage','Peggy Lu','Paul Lacovara','Soraya Kelley','Granville Ames','Efrain Figueroa','Devin Kawaoka','Tyler Lofton','Josh Pafchek','Emily Alabi','Lauri Hendler','Alexa Marie Anderson','Josh Plasse','Ozioma Akagha','Keisuke Hoashi','Robert Okumu','Diane Mizota','Diana Tanaka','Damien Diaz','Myles Bullock','Cooper Mothersbaugh','Christian Torres Villalobos','Derek Luh','Milan Carter'],
basedOn:['Brian K. Vaughan'],
screenplay:['Drew Pearce','Kalinda Vazquez','Quinton Peeples','Josh Schwartz','Stephanie Savage','Rodney Barnes','Jake Fogelnest','Ashley Wigfield','Kirk A. Moore','Kendall Rogers','Warren Hsu Leonard','Mike Vukadinovich','Tracy McMillan','Russ Cochrane','Tamara Becher','Jiehae Park'],
production:['Kelly Van Horn','Tamara Becher','Emma Fleischer'],
music:['Siddhartha Khosla'],
camera:['Ramsey Nickell','David Stockton','Dave Perkal','John Newby'],
cut:['Jeff Granzow','Lois Blumenthal','Jesse Ellis','Joe Mitacek','Karen Castañeda','Adrienne McNally'],
sound:['Robert Carr','Mark D. Fleming','Nello Torri','Alan Decker'],
scenography:['Warren Alan Young','Jennifer Mueller','Erin Cochran','Colin De Rouin','Kellie Jo Tinney','Chikako Suzuki'],
masks:['Tayari Edwards','Laverne Caracuzzi','Lisa Rocco','Joni Powell','Ahou Mofid','Kerry Mendenhall','Marianna Elias','Solina Tabrizi'],
costumes:['Meredith Markworth-Pollack','Samantha Rattner','Leoisick Castro']},
{title:'Helstrom',
titleCZ:'Helstrom',
year:2020,
runtime:'8h 22min',
episodeRuntime:'45-56min',
countries:['USA'],
genres:['Action','Adventure','Drama'],
director:['Anders Engström','Daina Reid','Michael Offer','Amanda Row','Jovanka Vuckovic','Sanford Bookstaver','Bill Roe','Cherie Nowlan','Kevin Tancharoen',"Jim O'Hanlon"],
actors:['Fiona Dourif','Tom Austen','June Carryl','Ariana Guerra','Eric Gustafsson','Elizabeth Marvel','Alain Uy','Robert Wisdom','Sydney Lemmon','Daniel Cudmore','Erica Tremblay','Todd Thomson','Jessie Fraser','Mig Macario','Kat Pasion','Nicole Anthony','Deborah Van Valkenburgh','Hiro Kanagawa','David Quinlan','Camille Sullivan','Jordan Burtchett','David Meunier','Hamza Fouad','Shauna Hansen','Joe Buffalo','Veenu Sandhu','Samantha Sloyan','Andrew Wheeler','Emma Oliver','Tom Everett','Eugene Lipinski','Christine Horn','Jesse Filkow','Mitch Pileggi','Grace Sunar','Jean Paul Najm','Franckie Francois','Leah Hennessey','Leo Chiang','Kaiel Barreiro','Jen Landon','Sean Kuling','Marcel Zadé','Andres Collantes','Kyle Warren'],
screenplay:['Paul Zbyszewski','Blair Butler','Marcus Dalzine','Sheila Wilson','Ian Sobel','Amanda Segel','Mark Leitner','Maggie Bandur','Matt Morgan'],
production:['Blair Butler','Matt McInnis','Vail Romeyn'],
music:['Danny Bensi','Saunder Jurriaans'],
camera:['Bernard Couture','Christopher Charles Kempinski'],
cut:['Hunter M. Via','Brian G. Addie'],
sound:['Mark D. Fleming'],
scenography:['Todd Fjelsted','Tania Rahimikhoshavaz'],
masks:['Nikita Pennock','Chris Bennett'],
costumes:['Farnaz Khaki-Sadigh','Aieisha Li','Natalie Simon']},
{title:'WandaVision',
titleCZ:'WandaVision',
year:2021,
runtime:'5h 30min',
episodeRuntime:'27-47min',
countries:['USA'],
genres:['Action','Comedy','Romance','Sci-Fi'],
director:['Matt Shakman'],
actors:['Elizabeth Olsen','Paul Bettany','Kat Dennings','Teyonah Parris','Randall Park','Kathryn Hahn','Fred Melamed','Debra Jo Rupp','Jolene Purdy','David Lengel','Ithamar Enriquez','Victoria Blade','Amos Glick','Emma Caulfield Ford','Randy Oglesby','Rose Bianco','David Payton','Josh Stamberg','Viviana Chavez','Vince Canlas','Emma Caulfield Ford','Evan Peters','Julian Hilliard','Jett Klyne','Jenna Kanell','Baylen D. Bielitz','Gavin Borders','Asif Ali','Kathryn Hahn','Alan Heckner','Selena Anduze','Adam Michael Gold','Anthony Molinari','Jackson Robert Scott','Brie Larson','Lashana Lynch','Akira Akbar','Samuel L. Jackson','Daniyar','Michaela Russell','Gabriel Gurevich','Hans Obma','David Anthony Higgins','Chase Yi','Janet Song','Lana Young','Ilana Kohanchi','Sydney Thomas','Neraida Bega','Wesley Kimmel','Shaun MacLean'],
screenplay:['Jac Schaeffer','Megan McDonnell','Gretchen Enders','Bobak Esfarjani','Peter Cameron','Mackenzie Dohr','Chuck Hayward','Cameron Squires','Laura Donney'],
production:['Mary Livanos','Chuck Hayward','Gretchen Enders','Jac Schaeffer'],
music:['Christophe Beck'],
camera:['Jess Hall'],
cut:['Tim Roche','Nona Khodai','Zene Baker','Michael A. Webber'],
sound:['Steve Orlando','Matthew Wood','Gwendolyn Yates Whittle','Danielle Dupre'],
scenography:['Mark Worthington','Kathy Orlando','Chikako Suzuki','Rachel Robb Kondrath'],
masks:['Tyson Fountaine','Kristina Frisch','Rachel Galey','Karen Bartek'],
costumes:['Mayes C. Rubeo']},
{title:'Anchor Point',
titleCZ:'Hawkeye',
year:2021,
runtime:'4h 42min',
episodeRuntime:'39-61min',
countries:['USA'],
genres:['Action','Adventure','Drama','Sci-Fi'],
director:['Rhys Thomas','Bertie','Bert'],
actors:['Jeremy Renner','Hailee Steinfeld','Florence Pugh','Vera Farmiga','Zahn McClarnon',"Brian d'Arcy James",'Tony Dalton','Alaqua Cox','Fra Fee','Cade Woodward','Ava Russo','Ben Sakamoto','Clayton English','Simon Callow','Aleks Paunovic','Piotr Adamczyk','Linda Cardellini','Avery Gillham','Harris Turner','Jason Scott McDonald','Nico DeJesus','Meghan Manning','Tom Feeney','Aaron Nedrick','Scarlett Johansson','Hirojuki Sanada','Carlos Navarro','Ivan Mbakop','Tom Hiddleston','Aaron Taylor-Johnson','Jolt','Pat Kiernan','Clara Stack',"Vincent D'Onofrio",'Carlos Navarro','Annie Hamilton','Marc Shaiman','Adam Pascal','Yssa Mei Panganiban','Adelle Drahos','Adetinpo Thomas','Tinashe Kajese','Jonathan Bergman','Franco Castan','John Crow'],
basedOn:['Don Heck','Stan Lee'],
screenplay:['Jonathan Igla','Tanner Bean','Katrina Mathewson','Heather Quinn'],
music:['Christophe Beck'],
camera:['Eric Steelberg','James Whitaker'],
sound:['Brian Chumney','Danielle Dupre'],
scenography:['Maya Shimoguchi','Summer Gaal'],
masks:['Charmaine Balcerzak','Miki Caporusso','Dennis Liddiard'],
costumes:['Michael Crow']},
{title:'Secret Invasion',
titleCZ:'Tajná invaze',
year:2023,
runtime:'4h 32min',
episodeRuntime:'38-58min',
countries:['USA'],
genres:['Action','Sci-Fi','Adventure','Drama','Mystery','Thriller'],
director:['Thomas Bezucha','Ali Selim'],
actors:['Samuel L. Jackson','Ben Mendelsohn','Emilia Clarke','Cobie Smulders','Olivia Colman','Christopher McDonald','Kingsley Ben-Adir','Killian Scott','Don Cheadle','Martin Freeman','Dermot Mulroney'],
screenplay:['Kyle Bradstreet'],
production:['Jonathan Schwartz'],
music:['Kris Bowers'],
camera:['Remi Adefarasin'],
cut:['Pete Beaudreau'],
scenography:['Adrian Anscombe','Frank Walsh','Su Whitaker'],
masks:['Cyril Arsac','Sarah Spears','Satinder Chumber'],
costumes:['Claire Anderson']},
{title:'Echo',
titleCZ:'Echo',
year:2024,
runtime:'3h 34min',
episodeRuntime:'37-51min',
countries:['USA'],
genres:['Action','Adventure','Crime','Drama'],
director:['Sydney Freeland','Catriona McKenzie'],
actors:['Alaqua Cox','Devery Jacobs','Zahn McClarnon','Graham Greene','Tantoo Cardinal','Chaske Spencer','Cody Lightning','Charlie Cox',"Vincent D'Onofrio",'Andrew Howard','Thomas E. Sullivan','MorningStar Angeline','Dakota Ray Hebert','Elizabeth Frances','David Midthunder','Edith Snow','Omid Zader','Vanessa Vander Pluym','Julia Jones','Tatanka Means','Jana Schmieding','Leander Suleiman','William Belleau','Tim Neff','Erin Ownbey'],
screenplay:['Marion Dayre','Steven Judd','Ken Kristensen','Josh Feldman','Ellen Morton','Chantelle Wells','Amy Rardin'],
production:['Christina D. King','Ken Kristensen','Eleena Khamedoost'],
music:['Mato Standing Soldier','Dave Porter'],
camera:['Kira Kelly','Magdalena Górka'],
cut:['Amelia Allwarden','Shelby Hall','Joel T. Pashby','Chris McCaleb'],
sound:['Karol Urban'],
scenography:['Chris Trujillo','Chris Yoo','Melisa Jusufi'],
masks:['Ellen Arden','Arlene Martin','Amber Michael','Adam Walls'],
costumes:['Stephanie Maslansky','Stacy Caballero','Ambre Wrigley']},
{title:'What if',
titleCZ:'What If',
year:2022,
runtime:null,
episodeRuntime:null,
countries:['Thajsko'],
genres:['Romance'],
director:['Karnpicha Sinlertpattana']},
{title:'Legion',
titleCZ:'Legion',
year:2017,
runtime:'24h 19min',
episodeRuntime:'41-68min',
countries:['USA'],
genres:['Action','Drama','Sci-Fi'],
director:['Noah Hawley','Michael Uppendahl','Larysa Kondracki','Tim Mielants','Hiro Murai','Dennie Gordon','Ana Lily Amirpour','Sarah Adina Smith','Ellen Kuras','John Cameron','Jeremy Webb','Dana Gonzales','Charlie McDowell','Keith Gordon','Carlos López Estrada','Daniel Kwan','Arkasha Stevenson','Andrew Stanton'],
actors:['Dan Stevens','Katie Aselton','Rachel Keller','Amber Midthunder','Aubrey Plaza','Jean Smart','Hamish Linklater','Mackenzie Gray','Bill Irwin','Scott Lawrence','Jeremie Harris','David Selby','Eddie Jemison','Kirby Morrow','Jemaine Clement','David Ferry','Quinton Boisclair','Luke Roessler','Paul Belsito','Sharlene Royer',"Keir O'Donnell",'Camille Mitchell','Christine Horne','Caitlin Leahy','Rachael Markarian','Navid Negahban','Jelly Howie','Christine Horn','Jon Hamm','Jasmine Jessica Anthony','Reatha Grey','Emily Ozrey','Lily Rabe','Dave Baez','Emily Hoffman','Ryan Caldwell','Lavelle Roby','Molly Hagan','Seamus Dever','Alexander Leeb','Hank Chen','Valentina Izumi','Jaclyn Hales','Alex Knight','June B. Wilde','Matt Hamilton','Tisha French','Annie Gonzalez','Karibel Rodriguez','Nathan Hurd','Violet Hicks','Christian Convery','Maddie Phillips','Rachele Schank','Megan Hensley','Lauren Shaw','Lauren Tsai','Harry Lloyd','Stephanie Corneliussen','Time Winters','Stefanie Estes','Jason Mantzoukas','Biff Yeager','Stefanée Martin','Marikah Cunningham','Gabriel Jacob-Cross','Vanessa Dubasso','Lily Keene','Nicholas Tuttle','Yukina Takase','Ryan Novak','Kent Faulcon','Bill Chott','Sebastian Billingsley-Rodriguez','Devyn Dalton','Tiffany Feese','Robert Arce','Holly Traister','Curtis Webster','Margaux Brooke','Tzef Montana','Faye Jackson','Charlie Farrell','Annaka Fourneret','Eve Sigall','Chandler Young','Aaron Guest','Jillian Dion','Jo Farkas','West Mulholland','Leah Mei Gold','Albert Nicholas','Dutch Johnson','Ellie Araiza','Matt Fowler'],
screenplay:['Noah Hawley','Peter Calloway','Nathaniel Halpern','Jennifer Yale','Olivia Dufault','Kate Thulin','Ben H. Winters','Charles Yu'],
production:['Brian Leslie Parker','Regis Kimble','Karim Zreik','Craig Yahata','Ben H. Winters'],
music:['Jeff Russo'],
camera:['Dana Gonzales','Craig Wrobleski','Polly Morgan','Alex Disenhof','Erik Messerschmidt'],
cut:['Regis Kimble','Chris A. Peterson','Todd Desrosiers','Erick Fefferman','Brian Beal'],
sound:['Larry Benjamin','Kurt Nicholas Forshager','Kevin Valentine','Cormac Funge','Tim Boggs','Chris Powell'],
scenography:['Michael Wylie','Marco Niro','Halina Siwolop','Michael Corrado'],
masks:['Marva Stokes','Gerald Quist','Tami Lane','Howard Berger','Charmaine Clark','Christopher Allen Nelson','Robert C. Mathews III','Amanda Mofield','Jason Orion','Patricia Messina'],
costumes:['Carol Case','Robert Blackman']},
{title:'The Witcher',
titleCZ:'Zaklínač',
year:2019,
runtime:'30h 55min',
episodeRuntime:'47-67min',
countries:['USA','Poland'],
genres:['Action','Adventure','Drama','Fantasy'],
director:['Alik Sakharov','Alex Garcia Lopez','Charlotte Brändström','Marc Jobst',"Sarah O'Gorman",'Stephen Surjik','Edward Bazalgette','Louise Hooper','Loni Peristere','Gandja Monteiro','Bola Ogun'],
actors:['Henry Cavill','Freya Allan','Joey Batey','MyAnna Buring','Anya Chalotra','Eamon Farren','Adam Levy','Jodhi May','Lars Mikkelsen','Mimi Ndiweni','Wilson Mbomio','Therica Wilson-Read','Emma Appleton','Alexandra Szűcs','Howard Chadwick','Isobel Laidler','Veronika Varga','Maciej Musiał','Amit Shah','Royce Pierreson','Anna Shaffer','Björn Hlynur Haraldsson','Tom Canton','Jason Thorpe','Julian Rhind-Tutt','Packy Lee','Jordan Renzo','Ossian Perret','Natasha Culzac','Adjoa Andoh','Graham McTavish','Simon Callow','Chris Fulton','Cassie Clare','Kevin Doyle','Philippe Spall','Imogen Daines','Atanáz Babinchak','Liz Carr','Kristofer Hivju','Kim Bodnia','Basil Eidenbenz','Yasen Atour','Mia McKenna-Bruce','Sonny Ashbourne Serkis','Matt Devere','Kata Pető','Martin Berencsy','Kristóf Widder','Tomasz Krzemieniecki','Roderick Hill','Krisztián Csákvári','Sándor Köleséri','Szofi Berki','Balázs Szitás','Péter Fancsikai','Shaun Dooley','Terence Maynard','Ben Lambert','Guðmundur Ingi Þorvaldsson','Sam Marks','Andrej Kurganov','Jade Croot','Bogdan Iancu','Leigh Gill','Tamás Olt','Scott Alexander Young','Gianni Calchetti','Josette Simon','Declan Hannigan','Bart Edwards','Nóra Trokán','Marcin Czarnik','Máté Haumann','Balázs Veres','Lucas Englander','Ben Wiggins','Roger Ringrose','Richard van Weyden','Anita Olatunji','Joachim Paul Assböck','Martin Angerbauer','Kevin Howarth','Steve Wall','Ron Cook','Wayne Brett','Michael Power','Ella-Rae Smith','Anna-Louise Plowman','Viola Prettejohn','Krisztián Koller','Kembe Sorel','Francis Magee','Frida Gustavsson','Lu Corfield','Jack Bandeira','Roland Tzafetás','Theo James','Katia Bokor','Ferenc Iván Szabó'],
basedOn:['Andrzej Sapkowski'],
screenplay:['Lauren Schmidt','Beau DeMayo','Declan De Barra','Haily Hall','Jenny Klein','Sneha Koorse','Mike Ostrowski','Tania Lotia','Clare Higgins','Rae Benjamin',"Matthew D'Ambrosio",'Javier Grillo-Marxuach'],
production:['Sean Daniel','Philip Waley','Mike Ostrowski','Declan De Barra','Sneha Koorse','Sasha Harris','Tania Lotia'],
music:['Sonya Belousova','Giona Ostinelli','Joseph Trapanese'],
camera:['Gavin Struthers','Jean-Philippe Gossart','Romain Lacourbas','Scott Winig','Dale McCready','Mike Spragg'],
cut:['Nick Arthurs','Liana Del Giudice','Jean-Daniel Fernandez-Qundez','Mike Phillips','Mags Arnold','Adam Green'],
sound:['Rob Prynne','Robert Farr','Matthew Collinge','Eric Munch'],
scenography:['Andrew Laws','Naomi Moore','Rob Cameron','Chloe Kletsa'],
masks:['Maja Mocsári','Ildikó Molnár','Anna Tesner','Luca Major','Brigitta Mogony','Gerd Zeiss','Heather Manson','Barrie Gower','Krystal Buckley','Josh Weston'],
costumes:['Tim Aslam','Lucinda Wright']},
{title:'Star Trek',
titleCZ:'Star Trek',
year:1966,
runtime:'65h 51min',
episodeRuntime:'50-51min',
countries:['USA'],
genres:['Sci-Fi','Adventure'],
director:['Marc Daniels','Joseph Pevney','Vincent McEveety','Ralph Senensky','Jud Taylor','Herb Wallerstein','Marvin J. Chomsky','John Meredyth Lucas','Gerd Oswald','James Goldstone','Herschel Daugherty','David Alexander','Robert Butler','Lawrence Dobkin','Harvey Hart','Leo Penn','Joseph Sargent','Robert Sparr','Robert Gist','Don McDougall','John Newland',"Michael O'Herlihy",'John Erman','James Komack','Anton Leader','Gene Nelson','Herbert Kenwith','Murray Golden'],
actors:['William Shatner','Leonard Nimoy','DeForest Kelley','Nichelle Nichols','James Doohan','George Takei','Walter Koenig','Majel Barrett','Grace Lee Whitney','John Winston','David L. Ross','Sean Kenney','Michael Barrier','Jeffrey Hunter','Susan Oliver','Malachi Throne','Peter Duryea','John Hoyt','Adam Roarke','Roger C. Carmel','William Campbell','John Harmon','Morgan Woodward','Morgan Farley','Abraham Sofaer','Richard Compton','Diana Muldaur','Jon Lormer','Barbara Babcock','Booker Bradshaw','Gene Dynarski','Richard Derr','Skip Homeier','Ian Wolfe','Gary Lockwood','Sally Kellerman','Lloyd Haynes','Andrea Dromm','Paul Fix','Anthony D. Call','Clint Howard','Karen Steele','Susan Denberg','Seamon Glass','Alfred Ryder','Robert Walker Jr.','Paul Comi','Garry Walberg','Michael Strong','Sherry Jackson','Ted Cassidy','James Gregory','Marianna Hill','Kim Darby','Michael J. Pollard','John Megna','John Crawford','Elisha Cook Jr.','Richard Webb','Percy Rodrigues','Laurel Goodwin','Meg Wyllie','Perry Lopez','Emily Banks','Roger Perry','Ed Peck','Harry Townes','Torin Thatcher','Sid Haig','David Opatoshu','Robert Sampson','Ricardo Montalban','Madlyn Rhue','Jill Ireland','Frank Overton','Ken Lynch','Biff Elliot','John Abbott','John Colicos','Peter Brocco','Victor Lundin','Joan Collins','Hal Baylor','Antoinette Bower','Gail Bonney','Glenn Corbett','Elinor Donahue','Julie Newmar','Michael Dante','Bob Bralver','Michael Forest','Leslie Parrish','Celia Lovsky','William Windom','John Fiedler','Charles Dierkop','Judith McConnell','Keith Andes','Celeste Yarnall','David Soul'],
screenplay:['Gene L. Coon','Gene Roddenberry','D.C. Fontana','Jerome Bixby','John Meredyth Lucas','Jerry Sohl','Robert Bloch','Richard Matheson','George Clayton Johnson','Stanley Adams','Gilbert Ralston','George F. Slavin','John D.F. Black','Stephen Kandel','Adrian Spies','Robert Sabaroff','John T. Dugan','Don Ingalls','Max Ehrlich','Harlan Ellison','Meyer Dolinsky','David P. Harmon','Robert Hamner','Theodore Sturgeon','David Gerrold','Margaret Armen','Barry Trivers','Judy Burns','Lee Erwin','Boris Sobelman','Edward J. Lakso','Steven W. Carabatsos','Arthur Heinemann'],
production:['Gene L. Coon','John Meredyth Lucas','Gene Roddenberry','Fred Freiberger'],
music:['George Duning','Gerald Fried','Alexander Courage','Sol Kaplan','Fred Steiner','Joseph Mullendore','Samuel Matlovsky','Jerry Fielding'],
camera:['Ernest Haller','Gerald Perry Finnerman','William E. Snyder','Al Francis'],
cut:['Fabien D. Tordjmann','Donald R. Rode','Robert L. Swanson','Frank P. Keller','Leo H. Shreve','John M. Foley','James Ballas'],
sound:['Stanford Houghton','Gordon L. Day','Cam McCulloch'],
scenography:['Pato Guzman','John M. Dwyer','Franz Bachelin','Joseph J. Stone','Rolland M. Brooks','Edward M. Parker','Carl Biddiscombe','Marvin March','Walter M. Jefferies'],
masks:['Fred B. Phillips','Jean Austin','John Chambers'],
costumes:['William Ware Theiss']},
{title:'Star Trek: Enterprise',
titleCZ:'Star Trek: Enterprise',
year:2001,
runtime:'68h 44min',
episodeRuntime:'42-92min',
countries:['USA'],
genres:['Sci-Fi','Action','Adventure'],
director:['Winrich Kolbe','Les Landau','James L. Conway','James A. Contner','Michael Vejar','Robert Duncan McNeill','Rob Hedden','Michael Dorn','Roxann Dawson','Jim Charleston','LeVar Burton','Allan Kroeker','David Straiton','Patrick R. Norris','Michael Grossman','David Barrett','James Whitmore Jr.','Marvin V. Rush','David Livingston','Terry Windell'],
actors:['Scott Bakula','John Billingsley','Jolene Blalock','Dominic Keating','Anthony Montgomery','Linda Park','Connor Trinneer','Vaughn Armstrong','Gary Graham','Randy Oglesby','Jeffrey Combs','Rick Worthy','Matt Winston','John Fleck','Steven Culp','Eric Pierpoint','James Horan','Sean McGowan','Jim Fitzpatrick','Derek Magyar','Kellie Waymire','Daniel Dae Kim','Bruce Thomas','Mary Mara','Brent Spiner','Alec Newman','Abby Brammell','Robert Foxworth','John Rubinstein','Michael Reilly Burke','Brian Thompson','Danny Goldring','Nathan Anderson','Thomas Kopache','Golden Brooks','Christopher Neame','Steve Schirripa','J.G. Hertzler','Richard Riehle','Mark Rolston','Joanna Cassidy','Lee Arenberg','Kevin Brief','Brad Greenquist','Seth MacFarlane','James Avery','John Schuck','Gregory Itzin','Tom Bergeron','Harry Groener','Peter Weller','Peter Mensah','Johanna Watts','Majel Barrett','Melinda Clarke',"Tommy 'Tiny' Lister",'Jim Beaver','Mark Moses','Joseph Ruskin','Diane Klimaszewski','Reynaldo Gallegos','Erick Avari','Mary Carver','Bruce French','Jamie McShane','William Utay','Diane DiLascio','Wade Williams','Lawrence Monoson','Kieran Mulroney','Charles Lucia',"Michael O'Hagan",'Lamont Thompson','Guy Siner','Paula Malcomson','Barbara Tarbuck','Jeff Kober','Enrique Murciano','Robert Pine','Stephanie Niznik','Keith Szarabajka','Clint Howard','Matt Malloy','Ethan Phillips','Annie Wersching','René Auberjonois','Dennis Christopher','David Kagen','Dean Stockwell','Renée Elise Goldsberry','Fionnula Flanagan','Clancy Brown','Dey Young','Rudolf Martin','DonnaMarie Recco','Geoff Meed','Keith Allan','Ann Cusack','Hank Harris','Larry Cedar'],
screenplay:['Rick Berman','Brannon Braga','Manny Coto','David Wilcox','Jonathan Fernandez','Garfield Reeves-Stevens','Judith Reeves-Stevens','Fred Dekker','André Jacquemetton','Maria Jacquemetton','Brent V. Friedman','David A. Goodman','James Duff','John Shiban','Michael Sussman','Hans Tobeason','Alan Brennert','André Bormanis','Alan Cross','Stephen Beck','Ken LaZebnik','Chris Black','Antoinette Stella','Phyllis Strong'],
production:['Peter Lauritson','John Farrell','Michael Sussman','Merri D. Howard','Ken LaZebnik','Chris Black','Antoinette Stella'],
music:['Dennis McCarthy','Jay Chattaway','Paul Baillargeon','Velton Ray Bunch','David Bell','Kevin Kiner','Brian Tyler','Mark McKenzie','John Frizzell'],
camera:['Marvin V. Rush','Douglas Knapp'],
cut:['Robert Lederman','John Farrell','Daryl Baskin'],
sound:['Bill Wistrom','R. Russell Smith','William Freesh','John Asman','Albert Ibbotson','Bill Jackson','Richard L. Morrison','Kerri Wilson','Chris Haire','Jim Fitzpatrick','Sherry Klein','Doug Davey','Robert Nichols II','Chris Elam'],
scenography:['Herman F. Zimmerman','Jim Mees'],
masks:['Cheri Ruff','Michael Westmore','Allan A. Apone','Ruth Haney','Ketty Gonzalez','Robert Maverick','Veronica Lorenz','Ani Plotkin-Maloney'],
costumes:['Robert Blackman']},
{title:'Exorcist',
titleCZ:'Vymítač',
year:2017,
runtime:'6h 47min',
episodeRuntime:'9-13min',
countries:['Poland'],
genres:['Animation','Comedy','Horror'],
director:['Bartosz Walaszek'],
actors:['Bartosz Walaszek'],
screenplay:['Bartosz Walaszek'],
production:['Bartosz Walaszek'],
music:['Bartosz Walaszek']},
{title:'Expats',
titleCZ:'Expatrianti',
year:2024,
runtime:'5h 46min',
episodeRuntime:'53-61min',
countries:['USA'],
genres:['Drama'],
director:['Lulu Wang'],
actors:['Sarayu Blue','Nicole Kidman','Jack Huston','Brian Tee','Ji-young Yoo','Kavi Raz','Valerie Yu','Steven Chan','Brylee Hsu','Kate Sullivan','Yuyu Kitamura','Michael Chan','Chuti Tiu','Jodi Bianca Wise','Jackie Dallas','Darren Dupree Washington','Adrian Dev','Ruby Ruiz','Alan Chang','Gabrielle Chan'],
basedOn:['Janice Y.K. Lee'],
screenplay:['Alice Bell','Melanie Marnich','Vera Miao','Lulu Wang'],
production:['Vera Miao','Gursimran Sandhu'],
music:['Alex Weston'],
camera:['Anna Franquesa Solano'],
cut:['Matt Friedman',"Alex O'Flinn"],
sound:['Matt Vowles'],
scenography:['Yong Ok Lee','Ian Bailie','Kevin Constant','Lauren Richards'],
masks:['Chrissy Zemura'],
costumes:['Malgosia Turzanska']},
{title:'The Vampire Diaries',
titleCZ:'Upíří deníky',
year:2009,
runtime:'120h 1min',
episodeRuntime:'40-43min',
countries:['USA'],
genres:['Drama','Horror','Romance','Fantasy','Mystery','Thriller'],
director:['Marcos Siega','John Dahl','Guy Ferland','Kevin Bray','Ernest R. Dickerson','John Behring','Julie Plec','Darren Genet','Michael A. Allowitz','Lance Anderson','Paul M. Sommers','Garreth Stover','Chris Grismer','Rick Bota','J. Miller Tobin','David Barrett','Liz Friedlander','Joshua Butler','Dennis Smith','David Von Ancken','Patrick R. Norris','Rob Hardy','Jeff Woolnough','Charles Beeson','Ralph Hemecker','Elizabeth Allen Rosenbaum','Michael Katleman','Wendey Stanzler','David Jackson','Jeffrey G. Hunt','Pascal Verschooris','Jesse Warn','Brad Turner','Kellie Cyrus','Darnell Martin','Leslie Libman','Paul Wesley','Ian Somerhalder','Geoffrey Wing Shotz','Tony Solomons','Deborah Chow','Michael Karasick','Rashaad Ernesto Green','James L. Thompson III','Tanya Hamilton','Carol Banker'],
actors:['Nina Dobrev','Ian Somerhalder','Paul Wesley','Steven R. McQueen','Kat Graham','Candice King','Zach Roerig','Michael Trevino','Matthew Davis','Sara Canning','Marguerite MacIntyre','Kayla Ewell','Taylor Kinney','Cindy Busby','Susan Walters','Melise','David Anders','Mia Kirshner','David Gallagher','Shaun Sipos','B.J. Britt','Daniel Gillies','Kelly Hu','Lauren Cohan','Jasmine Guy','Chris Johnson','Chris William Martin','Melinda Clarke','Michaela McManus','Bianca Lawson','Gabrielle Douglas','Sterling Sulieman','Bryton James','Dawn Olivieri','Robert Pralgo','Joseph Morgan','Trent Ford','Trevor Peterson','Arielle Kebbel','Courtney Ford','Randy J. Goodwin','Claire Holt','Sebastian Roché','Tiya Sircar','Colin Ferguson','Torrey DeVitto','Anna Enger Ritch','Alice Evans','Phillip DeVona','Brad James','Cassidy Freeman','Casper Zafer','Ric Reitz','Kimberley Drummond','April Billingsley','Hannah Fierman',"Ahna O'Reilly",'Curtis Lum','Gracie Gillam','Sean Faris','Persia White','Danielle Campbell','Dillon Casey','Todd Williams','David Alpay','Nathaniel Buzolic','Phoebe Tonkin','Alex Livinalli','Marcus Hester','Melissa Ponzio','Charles Michael Davis','Daniella Pineda','Paul Telfer','Olga Fonda','Maiara Walsh','Autumn Dial','Rick Cosnett','Carissa Capobianco','Stephen Amell','Rick Worthy','Blake Hood','Madeline Zima','Charlie Bewley','Shane Callahan','Elizabeth Ludlow','John Gabriel Rodriquez','Michael Malarkey','Hans Obma','Kendrick Sampson','Nicci Faires','Alyssa Diaz','Emily Morris','Amanda Detmer',"Jodi Lyn O'Keefe",'Beth Keener','Chris Osborn','Stephen Martines','Spencer Locke','Holly Lynch','Hunter Deno'],
basedOn:['Lisa Jane Smith'],
screenplay:['Kevin Williamson','Michael Narducci','Andrew Chambliss','Andrew Kreisberg','Elizabeth Craft','Sarah Fain','Holly Brix','Gabrielle G. Stanton','Rebecca Sonnenshine','Turi Meyer','Alfredo Septién','Barbie Kligman','Bryan M. Holdman','Brian Young','Sean Reycraft','Brett Conrad','Bryan Oh','Caroline Dries','Mike Daniels','Evan Bleiweiss','Elisabeth Finch','Jose Molina','Brett Matthews','Charlie Charbonneau','Michael J. Cinquemani','Neil Reynolds','Melinda Hsu Taylor','Sonny Postiglione',"Matthew D'Ambrosio",'Chad Fiveash','James Patrick Stoteraux','Nina Fiore','John Herrera','Celine Geiger','Alan B. McElroy','Shukree Tilghman','Penny Cox','Julie Plec'],
production:['Andrew Kreisberg','Rebecca Sonnenshine','Pascal Verschooris','Sean Reycraft','Caroline Dries','J. Miller Tobin','Michael Narducci','Brian Young','Chris Grismer','Brett Matthews','James L. Thompson III','Michael A. Allowitz','Trish Stanard','Kevin Williamson','Ian Somerhalder','Paul Wesley','Brian Young'],
music:['Michael Suby'],
camera:['John Peters','Michael Karasick','Ramsey Nickell','Darren Genet','Paul M. Sommers','Michael Negrin','Dave Perkal','Star Barry'],
cut:['Nathan Easterling','Glenn Garland','Lance Anderson','Sean Albertson','Nicholas Erasmus','Shawn Paper','Joshua Butler','Michael Ruscio','Jacques Gravett','Nancy Forner','Erik Presant','Joel T. Pashby','Evan J. Warner','Marc Pollon','Tyler L. Cook','Sunny Hodge','Brian Wessel','Peter Basinski'],
sound:['Patrick Hogan','Vicki Lemar','Christian P. Minkler','Andrew Spencer Dawson','Kenneth R. Burton','Kurt Kassulke','Adam Sawelson','William Freesh','Mike Olman','Andre Perreault','John Benson','Kenneth Kobett','Alan Decker','Rick Norman','Jim Fitzpatrick','Todd Grace','Ed Carr','Sean McCormack','Richard E. Yawn','Patrick Hanson','Takako Ishikawa'],
scenography:['Garreth Stover','Jill Scott','Karen Bruck','Carol Bayne Kelley','Tim Beach'],
masks:['Colleen LaBaff','Laverne Caracuzzi','Randa Squillacote','Ellen Arden','Kevin J Edwards','Beverly Jo Pryor'],
costumes:['Leigh Leverett','Jennifer L. Bryan','Susan De Laval']},
{title:'amazing digital circus',
titleCZ:'The Amazing Digital Circus',
year:2023,
runtime:null,
episodeRuntime:null,
countries:['Australia'],
genres:['Animation','Comedy','Horror'],
director:['Cooper Smith Goodwin'],
actors:['Michael Kovach'],
screenplay:['Cooper Smith Goodwin'],
music:['Evan Alderete','Cooper Smith Goodwin']},
{title:'Murder Drones',
titleCZ:'Murder Drones',
year:2021,
runtime:null,
episodeRuntime:null,
countries:['Australia'],
genres:['Animation','Action','Comedy'],
actors:['Michael Kovach']},
{title:'Ice Age: Scrat Tales',
titleCZ:'Doba ledová: Scratovy příhody',
year:2022,
runtime:20,
episodeRuntime:4,
countries:['USA'],
genres:['Animation','Comedy','Family'],
director:['Donnie Long'],
actors:['Chris Wedge','Kari Wahlgren'],
music:['Batu Sener']},
{title:'Sunny',
titleCZ:'Slunečná',
year:2020,
runtime:'166h 49min',
episodeRuntime:60,
countries:['Czechia'],
genres:['Comedy','Romance','Family'],
director:['Libor Kodad','Jaromír Polišenský','Marek Tomažič','Lukáš Buchar','Vojtěch Moravec'],
actors:['Eva Salvatore Burešová','Marek Lambora','Lukáš Langmajer','Barbora Jánová','Filip Tomsa','Eva Holubová','Iva Hüttnerová','Jan Šťastný','Filip Blažek','Lucie Benešová','Dana Batulková','Ondřej Pavelka','Roman Tomeš','Pavla Tomicová','Tereza Brodská','David Prachař','Maroš Kramár','Veronika Arichteva','Martina Preissová','Norbert Lichý','Karel Zima','Jana Stryková','Eva Decastelo','Leoš Noha','Josef Polášek','Regina Řandová','Ota Jirák','Lucie Polišenská','Richard Tesařík','Martin Sitta','Václav Helšus','Václav Knop','Michal Kern','Zdeněk Pohlreich','Jan Plouhar','Adéla Dobešová','Michael Vykus','Adam Vacula','Jan Antonín Duchoslav','Zdeněk Vencl','Radim Novák','Ivo Theimer','Josef Hervert','Martin Ešpandr','Anna Beránková','Kristina Pavelková','Bořek Joura','Ivo Novák','Radovan Klučka','Jindřich Kriegel','Gustav Bubník','Ivan Herma','Tomáš Pospíšil','František Mitáš','Kateřina Klausová','Jana Durčáková','Andrea Daňková','Zdena Herfortová','Tereza Vodochodská','Jarmila Vychodilová','Aleš Balda','Vojtěch Efler','Jakub Gottwald','Martin Zahálka','Nataša Gáčová','Michal Hložánek','Lukáš Adam','Tomáš Tintěra','Zdeněk Velen','Pavel Hermanovský','Zdeněk Žák','Milan Slepička','Martina Hekerová','Karolína Hrůzová - Hlaváčková','Jaromír Polišenský','Ondřej Mataj','Petr Kučera','Jan Pavel Filipenský','Jaroslav Vlach','Jana Hermachová','Michal Žižka','Tereza Klementová','Marie Rezlerová','Klára Kadlecová','Miroslav Večerka','Petr Šplíchal','Jiří Knot','Natálie Grossová','Jan Bláha','Jiří Král','Jan Vlas','Milan Enčev','Tomáš Karger','Radek Valenta','Jiří Šafránek','Jiří Vobecký','Filip Sychra','Andrej Danko','Miroslav Dvořák','Tomáš Kořének'],
screenplay:['René Decastelo','Jaroslav Sauer','David Holý','Jan Drbohlav','Iva Klestilová'],
production:['René Decastelo','Simona Brdičková','Jana Skořepová','Lenka Hornová','Lucia Kršáková'],
music:['Tadeáš Věrčák','Olga Trojková','Michal Hrůza'],
camera:['Jakub Ševčík','Filip Sanders','Martin Schinabek','Jan Matiášek'],
cut:['Vasilis Skalenakis','Filip Issa','Dominik Krutský'],
sound:['Pavel Bělohlávek','Martin Šulc','Jakub Zbíral','Ludvík Bohadlo','Barbora Hovorková','Filip Slavík','Vojtěch Ptáček','Robert Slezák','Lukáš Ujčík','Jan Paul','Stanislav Kejval','David Matušek'],
scenography:['Hynek Dřízhal'],
masks:['Pavel Bauer','Karolína Táborská'],
costumes:['Zuzana Straková']},
{title:"Grey's Anatomy",
titleCZ:'Chirurgové',
year:2005,
runtime:'306h 53min',
episodeRuntime:'40-86min',
countries:['USA'],
genres:['Drama','Romance'],
director:['John David Coles','Adam Davidson','Sarah Pia Anderson','Tony Goldwyn','Peter Horton','Jessica Yu','Mark Tinker','Julie Anne Robinson','Michael Grossman','Tricia Brock','Seith Mann','Wendey Stanzler','Christopher Misiano','Darnell Martin','Eric Stoltz','Chandra Wilson','Kevin McKidd','Debbie Allen','David Greenspan','Jeff Melman','Jesse Bochco','Denzel Washington','Edward Ornelas','Geary McLeod','Steve Robin','Louis Venosta','Randy Zisk','Rob Corn','Cecilie A. Mosli','Rob Greenlea',"Bill D'Elia",'Kevin Rodney Sullivan','Jeannot Szwarc','Nzingha Stewart','Ellen Pompeo','Lesli Linka Glatter','Michael Dinner','David Paymer','Daniel Minahan','Tony Phelan','Adam Arkin','Dan Lerner','Michael W. Watkins','Nicole Rubio','Greg Yaitanes','James Frawley','Tamra Davis','Tom Verica','Bethany Rooney','John Terlesky','Michael Pressman','Joanna Kerns','Arlene Sanford','Allison Liddi-Brown','Daniel Attias','Robert Berlinger','Donna Deitch','Stephen Cragg','Rob Bailey','Ron Underwood','Krista Vernoff','Jann Turner','Daniel Willis','Laura Innes','Cherie Nowlan','Pete Chatmon','Rob Hardy','Bobby Roth','Eric Laneuville','Thomas J. Wright','Zetna Fuentes','Paul McCrane','Jesse Williams','Sydney Freeland','Charlotte Brändström','Victoria Mahoney','Oliver Bokelberg','Scott Brazil','Michael Medico','Deborah Pratt','Linda Klein','Gregory T. Evans','Susan Vaill','Giacomo Gianniotti','Lisa Leone','Michael Watkins','Amyn Kaderali','Kim Raver','Morenike Joela Evans'],
actors:['Ellen Pompeo','Chandra Wilson','James Pickens Jr.','Kevin McKidd','Caterina Scorsone','Patrick Dempsey','Camilla Luddington','Kelly McCreary','Kim Raver','Kate Walsh','Sandra Oh','Justin Chambers','T.R. Knight','Katherine Heigl','Sara Ramirez','Eric Dane','Chyler Leigh','Jessica Capshaw','Jesse Williams','Sarah Drew','Isaiah Washington','Mark Saul','Brooke Smith','Scott Foley','Elizabeth Reaser','Jeffrey Dean Morgan','Mitch Pileggi','Loretta Devine',"Chris O'Donnell",'Giacomo Gianniotti','Martin Henderson','Molly Kidder','Christina Ricci','Peter MacNicol','Melissa George','Kyle Chandler','Nora Zehetner','Haley Ramm','Kali Rocha','Tim Griffin','Noah Gray-Cabey','Rachael Taylor','Roxanne Hart','Alan Blumenfeld','Sendhil Ramamurthy','Jack Conley','Keith David','Valerie Cruz','Curtis Armstrong','Billy Mayo','Pat Healy','Justina Machado','Arlene Santana','Cress Williams','Lauren Stamile','Rockmond Dunbar','Dean Norris','Edward Herrmann','George Dzundza','Anna Maria Horsford','Paul Adelstein','Monica Keena','Taye Diggs','A. Russell Andrews','Seth Green','Shohreh Aghdashloo','David Haley','Liza Lapira','Matt Roth','Tessa Thompson','Mark Harelik','Aasha Davis','Rigo Sanchez','Ken Marino','Kathryn Joosten',"Jason O'Mara",'Brooke Nevin','Teddy Dunn','Cameron Watson','Anjul Nigam','Theo Rossi','Mare Winningham','Peter Paige','Kevin Rankin','Braeden Lemasters','Peter Birkenhead','Maggie Siff','Damon Standifer','Jason London','Bellamy Young','Merrin Dungey','James Immekus','Jurnee Smollett','Dee Wallace','Leisha Hailey','Meg Cionni','Derick Alexander','Omar Metwally','Becca Gardner','Clea DuVall'],
screenplay:['Marti Noxon','Gabrielle G. Stanton','Debora Cahn','Krista Vernoff','Elisabeth Finch','Allan Heinberg','James D. Parriott','Eric Buchman','Jenna Bans','Jeannine Renshaw','Stacy McKee','Gabriel Llanas','Shonda Rhimes','Kip Koenig','Tony Phelan','Joan Rater','Ann Lewis Hamilton','Peter Nowalk','Markus Wildinger','William Jackson Harper','Dan Bucatinsky','Karin Gist','Alex Manugian','Chris Van Dusen','Lauren Barnett','Tia Napolitano','Natalie Krinsky','Lynne E. Litt','Mimi Schmir','Kiley Donovan','Jalysa Conway','Elizabeth Klaviter','William Harper','Jen Klein','Marlana Hope','Sonay Hoffman','Jason Ganzel','Felicia Pride','Adrian Wenner','Meg Marinis','Jase Miles-Perez','Denise Hahn','Matt Byrne','Zoanne Clack','Tameson Duffy','Beto Skubs','Julie Wong','Jamie Denbo','Jess Righthand','Emily Culver','Zakiyyah Alexander','Mark Driscoll','Michelle Lirtzman','Blythe Robe','Alyssa Margarite Jacobson','Briana Belser','Bronwyn Garrity'],
production:['Mark Gordon','Elisabeth Finch','Gabrielle G. Stanton','Tony Phelan','Joan Rater','Ellen Pompeo','Tia Napolitano','Elizabeth Klaviter','William Harper','Krista Vernoff','Felicia Pride','Meg Marinis','Linda Klein','Lisa Taylor','Zoanne Clack','Vanessa Delgado','Tameson Duffy','Michael Metzner','James E. Williams','Julie Wong','Debora Cahn','Tammy Ann Casper','Jeff Rafner'],
music:['Danny Lux'],
camera:['Tim Suhrstedt','Jeffrey Jur','Adam Kane','Robert LaBonge','Ross Riege','Herbert Davis','Carlos González','Mimi Melgaard','Walt Fraser','Christian Sebaldt','Alicia Robbins','Steven G. Fracol','Byron Shah','Jeanne Tyson','John Simmons','James E. Williams'],
cut:['Victor Du Bois','Edward Ornelas','Sarah Boyd','Matthew Ramsey','Briana London','Roger Nygard','Brandi Bradburn','Philip Fowler','David Greenspan','Heidi Scharfe','Justin Chinn','Joe Mitacek','Kyle Bond','Meghan Robertson','Chad Mochrie','Susan Vaill','Katherine Skjerping','Karoliina Tuovinen','Vanessa Delgado','Jason Joseph','Kathleen Latlip','Dan Rovetto','Bjørn T. Myrholt','Gregory Cusumano','Aimee Jennings'],
sound:['Karol Urban','Marla McGuire','Pete Elia','Ken Teaney','Michael Phillips Keeley','Don Digirolamo','Todd Langner','Ross Davis','Kurt Kassulke','T.W. Davis','Kenneth Kobett','Alan Decker','David Raines','Stephen Fitzmaurice','Doug Andham','David S. Di Pietro',"Terry O'Bright"],
scenography:['Laurence Bennett','Donald Lee Harris','Amy B. Ancona','Mimi Melgaard','Corey Kaplan','Linda Lee Sutton','Barbara Cassel','Karen Bruck','Nicole Cramer','Brian Harms','Colin Kirkpatrick','Arlan Jay Vetter','Curtis Moore','John Zachary','Michael Budge'],
masks:["Yesim 'Shimmy' Osman",'Jody Burton','David Abbott','Michele Teleis-Fickle','Erin Ayanian','Thomas R. Burman','Thomas R. Burman','Carla Farmer','Norman T. Leavitt','Danielle Dixon','Denise Hooper','Debra-Lee Davidson','Melanie Smith','Dori Ann Anderson','Ketty Gonzalez','Sean Flanigan','Audrey Futterman-Stern','Julie M. Woods','Jean Webber','Vito Trotta','Thomas Floutz','Brigitte Bugayong','Jason Orion','Patricia Messina','Mary Ann Valdes','Ani Plotkin-Maloney'],
costumes:['Mimi Melgaard','Linda M. Bass','Cynthia Bergstrom','Roemehl Hawkins']},
{title:'Fast & Furious: Spy Racers',
titleCZ:'Rychle a zběsile: Závodníci v utajení',
year:2019,
runtime:'20h 48min',
episodeRuntime:'24min',
countries:['USA'],
genres:['Animation','Action','Crime'],
director:['Leo Riley','Bret Haaland','Micah Gunnell','James Yang'],
actors:['Tyler Posey','Charlet Takahashi Chung','Jorge Diaz','Luke Youngblood','Renée Elise Goldsberry','Tru Valentino','Camille Ramsey','Manish Dayal','Olivia Olson','Jimmy Tatro','Bayardo De Murguia','Fred Tatasciore','Avery Kidd Waddell','Rogelio T. Ramos','Peter Oldring','Kimberly Brooks','Jason Hightower','Sean Kenin','Secunda Wood'],
screenplay:['Tim Hedrick','Joshua Hamilton','Mitch Iverson','May Chan','Mellori Velasquez','Joanna Lewis','Kristine Songco','Emma Dudley','Lauren Otero'],
music:['Jay Vincent','Ryan Lofty'],
sound:['Rob McIntyre','Lawrence Reyes'],
scenography:['Christine Bian']},
{title:'Lethal Weapon',
titleCZ:'Smrtonosná zbraň',
year:2016,
runtime:'39h 50min',
episodeRuntime:'42-46min',
countries:['USA'],
genres:['Action','Crime','Drama','Thriller'],
director:['McG','Steve Boyum','Rob Seidenglanz','Sylvain White','Jason Ensler','Michael Fields','Uta Briesewitz','Matt Barber','Bethany Rooney','Nick Copus','Omar Madha','Eric Laneuville','Salli Richardson-Whitfield','Nathan Hope','Maja Vrvilo','John Behring','Larry Teng','Silver Tree','Rob Bailey','Clayne Crawford','Claudia Yarmy','Keesha Sharp','April Mullen','Jay Chandrasekhar'],
actors:['Damon Wayans','Clayne Crawford','Seann William Scott','Jordana Brewster','Charles Baker','Kevin Rahm','Chandler Kinney','Rudolf Martin','Keesha Sharp','Toni Trucks','Sprague Grayden','Johnathan Fernandez','Anne McDaniels','Tony Plana','Gino Anthony Pesi','Exie Booker','Silvia Busuioc','Jason Derulo','Kwame Patterson','Kristoffer Polaha','Rick Ravanello','Richard Cabral','Ellen Hollman','Ted Levine','Derek Mio','Luis Moncada','Alex Weed','Christopher T. Wood','Teodora Cristea','Tina Grimm','Tanc Sade','Amanda Westlake','Shashawnee Hall','Jeannine Kaspar','Daniel Moncada','Michelle Mitchenor','Hilarie Burton','Megan Stevenson','Floriana Lima','Colin Patrick Lynch','Jeff Davis','Scott William Winters','Dante Brown','Kurt Yaeger','Jack Kehler','Greg Serano','Lyndon Smith','Chin Han','Jessica Parker Kennedy','Jocelin Donahue','Malcolm-Jamal Warner','Brett Rice','Sola Bamis','Clint Jung','Lily Berlina','Rob Evors','Christopher Neiman','Matthew Alan','Johnny Sneed','Adam Kaufman','Thomas Lennon','Daniella Alonso','Matt Passmore','Andrew Patrick Ralston','Carlo Rota','Ned Vaughn','Robert Curtis Brown','Michael Harney','Joyful Drake','James Black','Myles Grier','Marco Morales','Anthony Martins','Alejandro Edda','Raul Casso','Brice Williams','Abbie Gayle','Eric Ladin','Beth Littleford','Manuel Uriza','Katie Walder','Teo Briones',"Joanna 'JoJo' Levesque",'Ntare Guma Mbaho Mwine','Adrian Pasdar','Michelle Hurd','Monica Barbaro','Rex Linn','Travis Hammer','Jeremy Luke','Kristen Gutoskie','Linds Edwards','Spencer Garrett','Duncan Joiner','Pooja Batra','Christopher Kriesa','Andy Buckley','Zach McGowan','Kristanna Loken','Todd Grinnell'],
screenplay:['Amanda Green','Laura Putney','Elizabeth Beall','Michael C. Martin','Zev Borow','Alex Taub','Matthew Miller','Carlos Jacott','David Fury','Seamus Kevin Fahey','Joe Smith','Erik Mountain','Andy Callahan','Norman Morrill','Ariana Jackson','Bill Callahan','Rob Wright','Katie Varney','Felicia Hilario','Eileen Jones','Terence Paul Winter','Margaret Easley','Kyle Warren','Stacy A. Littlejohn'],
music:['Ben Decter','Tree Adams','Robert Lydecker','Josh Kramon'],
camera:['Ramsey Nickell','Andrew Strahorn','David Moxness','William Wages','Joe Broderick']},
{title:'Men in Black: The Series',
titleCZ:'Muži v černém',
year:1997,
runtime:'18h 33min',
episodeRuntime:'21min',
countries:['USA'],
genres:['Animation','Comedy','Sci-Fi'],
director:['Christopher Berkeley','Michael Goguen','Frank Paur','Darwyn Cooke','Bryan Andrews','Dennis Woodyard','Jane Wu','Nathan Chew','Chris Dozois','Chuck Drost'],
actors:['Keith Diamond','Charles Napier','Patrick Pinney','Pat Fraley','Gregg Berger','Jennifer Lien','David Warner','Billy West',"Ed O'Ross",'Beth Broderick','Daniel Davis','Kat Cressida','Charles Rocket','Nick Jameson','Cynthia Songé','Suzie Plakson','Kevin Michael Richardson','Charles Fleischer','Pete Sepenuk','Jesse Corti','Mary Kay Bergman','Eddie Barth','Loren Lester','Michael Reisz','William Dennis Hunt','Peggy Jo Jacobs','Kath Soucie','Debi Derryberry','Dan Gilvezan','April Winchell','Clancy Brown','Thomas Dekker','Sherman Howard','Tony Shalhoub','Cree Summer','Monica Allison','Edward Asner','Ronny Cox','Rino Romano','Kurtwood Smith',"Vincent D'Onofrio",'Pam Dawber','Robert Knepper','Mark Rolston','Roger Rose','Miguel Ferrer','Jess Harnell','Mark Hamill','Brion James','Carlos Alazraqui','Jim Ward','Jennifer Hale','Dee Bradley Baker','Gabrielle Carteris','Peter Jason','Bob Glouberman','Cam Clarke','Danny Mann','Maile Flanagan','Brad Abrell','Jennifer Martin'],
basedOn:['Lowell Cunningham'],
screenplay:['Steve Roberts','Mark Amato','Robin Bernheim','Duane Capizzi','Dean Stefan','Steven Melching','Greg Weisman','Michael Edens','Julia Lewald','Greg Klein','Tom Pugsley','Alexx Van Dyne','Nick DuBois','Jon Weisman'],
production:['Duane Capizzi','Dean Stefan','Frank Paur','Rafael Rosado','Jane Wu'],
music:['Jim Latham'],
cut:['Adam Weiss','Mark Scheib','C.K. Horness','Kyle Solorio','Bruce W. Cathcart','Allan Gelbart'],
sound:['Melissa Ellis','Fil Brown','Michael Beiriger','Ray Leonard','Bobby Mackston','Kenneth Kobett','Kerri Wilson','Sherry Klein'],
scenography:['Alex Stevens']},
{title:'Survivor',
titleCZ:'Kdo přežije',
year:2000,
runtime:null,
episodeRuntime:null,
countries:['USA'],
genres:['Adventure','Reality-TV','Competition'],
director:['Don Roy King'],
production:['Joe Lia','Janice Engel','Jordan Ferrer','Adam Briles','James Bruce','Kyra Thompson','Cathrine Irgens Nilsen','Roger Scott'],
music:['Russ Landau','David Vanacore'],
camera:['Victor Fable','Scott Duncan'],
cut:['Geoffrey Rowland','Jonathon Braun','Lane Baker','David Handman','Mitchell Danton','Barry L. Gold','Grady Cooper','Craig Eustis','Jason Schmidt','Tony Mizgalski','Tom Costantino'],
sound:['Max Holland','Sebastian Dunn'],
scenography:['Wendell Johnson','Jordan Ferrer'],
masks:['Bruce Grayson','Danielle Dixon','Kim Urgel','Jody Lawrence','Justin Jackson','Angie Wells']},
{title:'LEGO NEXO Knights',
titleCZ:'Nexo Knights',
year:2015,
runtime:null,
episodeRuntime:'42x22min',
countries:['USA','Denmark'],
genres:['Animation','Action','Adventure'],
director:['Stu Gamble','Dave Osborne'],
actors:['Alessandro Juliani','Nicole Oliver','Kathleen Barr','Alan Marriott','Garry Chalk','Noel Johansen','Ian Hanlin','Caitlyn Bairstow','Erin Mathews','Vincent Tong','Giles Panton','Maryke Hendrikse'],
screenplay:['Mark Hoffmeier','Ernie Altbacker','F.M. De Marco','Jack C. Thomas','Andrew Robinson','David McDermott'],
production:['Peter Griffiths'],
cut:['Beverly Maguire','Adam Dymond']},
{title:'8 Days',
titleCZ:'Osm dní',
year:2019,
runtime:null,
episodeRuntime:'6h45min',
countries:['Germany'],
genres:['Drama'],
director:['Michael Krummenacher','Stefan Ruzowitzky'],
actors:['Christiane Paul','Mark Waschke','Lena Klenke','Fabian Hinrichs','Nora von Waldstätten','Devid Striesow','Sebastian Achilles','Filip Januchowski','Judith Neumann','Claude Albert Heinrich','Murathan Muslu','Henry Hübchen','David Schütter','David Bredin','Luc Feit','Thomas Prenn','Matthias Lier','Alice Dwyer','Jörn Hentschel','Antonia Holfelder','Thomas Lawinky','Wolfgang Michael','Veit Stübner','Anne Alexander Sieder','Katja Wagner','Ben Hartmann','Luisa-Céline Gaffron','Olek Witt','Vincenz Wagner','Rebecca Dyson-Smith','David Brückner','Nicolais Borger','Meriam Abbas','Oskar Bökelmann','Maximilian Pekrul','Frederik Schmid','Ralf Tempel','Peer Martiny','Urs Jucker','Igor Tjumenzev','Gosia Konieczna','Christofer von Beau','Robert Porter Templeton','Nina Weisz'],
screenplay:['Peter Kocyla','Rafael Parente','Benjamin Seiler'],
production:['Korbinian Dufter','Rafael Parente','Florian Kamhuber'],
music:['David Reichelt'],
camera:['Benedict Neuenfels','Jakob Wiessner'],
cut:['Britta Nahler','Stine Sonne Munch'],
sound:['Christoph Merkele','Bertin Molz'],
scenography:['Christian M. Goldbeck'],
masks:['Tamar Aviv'],
costumes:['Max Wohlkönig']},
{title:'LEGO Ninjago: Masters of Spinjitzu',
titleCZ:'Ninjago',
year:2011,
runtime:'57h 26min',
episodeRuntime:'11-23min',
countries:['Denmark','Singapore','Canada','USA'],
genres:['Animation','Action','Adventure'],
director:['Peter Hausner','Michael Hegner','Justin Joseph Murphy','Michael Helmuth Hansen','Thomas Østergaard Poulsen','Jens Møller','Trylle Vilstrup','Per Risager','Frederik Budolph-Larsen'],
actors:['Vincent Tong','Michael Adamthwaite','Kelly Metzger','Kirby Morrow','Brent Miller','Michael Kopsa','Alan Marriott','Cathy Weseluck','Ian Hanlin','Rhona Rees','Doron Bell','Paul Dobson','John Novak','Jillian Michaels','Klaus-Dieter Klebsch','Ian James Corlett','Sharon Alexander','Maryke Hendrikse','Deven Mack','Garry Chalk','Heather Doerksen','Andrew Francis','Britt McKillip','Sam Vincent','Michael Donovan','Tabitha St. Germain','Kelly Sheridan','Daniel Doheny','Brian Dobson','Andrew McNee','Scott McNeil','David Raynolds','Bill Newton','Wanja Gerick','Gavin Langelo','Dean Redman','Dominic Good'],
screenplay:['Dan Hageman','Kevin Hageman','Ryan A. Levin','Joey Clift','Kevin Burke','Chris Wyatt','David Shayne','Tommy Andreasen','Bragi F. Schut','John Behnke'],
production:['Louise Barkholt','Tommy Andreasen','Nelson LaMonica','Simon Lucas','Cerim Manovi'],
music:['Michael Kramer','Jay Vincent'],
cut:['Rikke Malene Nielsen','Kristian Håskjold','Sirid Garff Vejrum','Nanna Maria Ingemann'],
sound:['Reda el-Kheloufi','Rune Bjerre Sand','Stefan Leissner'],
scenography:['Bjarne Hansen','Geoffrey Hancock','Anne Hofmann','Thomas Østergaard Poulsen']},
{title:'Maria Theresa',
titleCZ:'Marie Terezie',
year:2017,
runtime:'8h 35min',
episodeRuntime:'94-114min',
countries:['Czechia','Austria','Hungary','Slovakia'],
genres:['Drama','History','Biographic'],
director:['Robert Dornhelm'],
actors:['Táňa Pauhofová','Kateřina Coufalová','Aaron Friesz','Ursula Strauss','Martin Pechlát','Adam Vojtek','Rosaria Viola Mlčková','Kateřina Winterová','David Švehlík','Michaela Rajdlíková','Marika Mlčková','Petr Franěk','Magdaléna Malinová','Jitka Asterová','Miroslav Hruška','Mária Mokrášová','Jana Kvantiková','Maroš Kramár','Peter Kočiš','Tereza Marečková','Stanislav Majer','Lukáš Melník','Jiří Severa','Michal Miki Grepl','Sabina Rojková','Alžběta Malá','Jindřich Žampa','Františka Ondříčková','Hanuš Bor','Michael Weinberger','Lucie Šteflová','Jan Maxa','Vojtěch Kotek','Stella Ginger Janáčková','Igor Bareš','Zuzana Mauréry','Denisa Nesvačilová','Oldřich Bělka','Stano Král','Petr Čampa','Eliška Cupová','Zuzana Stivínová','Kryštof Hádek','Berenika Kohoutová','Stefanie Reinsperger','Václav Baur','Bálint Adorjáni','Dominik Warta','Přemysl Boublík','Jenovéfa Boková','Slávek Bílský','Cornelius Obonya','Karel Polišenský','Alexander Bárta','Otmar Brancuzský','Daniel Rous','Johannes Krisch','Roman Luknár','Milan Ondrík','Martin Myšička','Petr Jeništa','Lucie Ducháčková','Rebeka Poláková','Roman Poláčik','Jiří Vyorálek','Mirka Louthanová','Philipp Hochmair','Anna Posch','Lenka Vlasáková','Ondrej Kovaľ','Ondřej Kokorský','Vica Kerekes','Karel Dobrý','Peter Oszlík','Bořek Joura','Jiří Dvořák','Ervin Nagy','Jaromír Janeček','Pavel Želízko','Marie-Luise Stockinger','Julia Stemberger','Marian Roden','Jaromír Nosek','Rozálie Krycnerová','Tomáš Pavelka','Luděk Tvrdý','Petra Polnišová','Alois Švehlík','Ady Hajdu','Jan Jakub Ryba','Miriam Merklová','Václav Chalupa','Slavomír Blažek','Karl Markovics','Antonín Hardt','Zoltán Rátóti','Josefína Krycnerová','Nathalie Köbli','Ivan Vojtek','Milan Řehák'],
screenplay:['Mirka Zlatníková','Radek Bajgar'],
production:['Marcela Mojtová','Jan Maxa','Vladimír Burianek','Ferdinand Dohna','Klaus Lintschinger','Andreas Kamm','Oliver Auspitz','Dániel Papp','Tibor Búza'],
music:['Roman Kariolou'],
camera:['Tomáš Juríček'],
cut:['Klaus Hundsbichler','Michal Lánský'],
sound:['Michal Deliopulos'],
scenography:['Ondřej Lipenský','Martin Kurel','Martin Martinec'],
masks:['Ivo Strangmüller','Lenka Nosková','Barbara Kichi','Jana Malkovská','Jiřina Pahlerová'],
costumes:['Ján Kocman','Patricie Palmer']},
{title:'Siren',
titleCZ:'Siréna',
year:2018,
runtime:'25h 1min',
episodeRuntime:'40-45min',
countries:['USA'],
genres:['Drama','Fantasy'],
director:['Scott Charles Stewart','John Badham','Martha Coolidge','Jay Karas','Steven A. Adelson','Nick Copus','Amanda Tapping','Joe Menendez','Amanda Row','Ellen S. Pressman','David Grossman','David Solomon','Ben Hernandez Bray','Barbara Brown','Rachel Leiterman','Aprill Winney'],
actors:['Eline Powell','Ron Yuan','Curtis Lum','Chad Rook','Anthony Harrison','Rena Owen','Tammy Gillis','Andrew Jenkins','Brian Anthony Wilson','Jennifer Koenig','Jason Asuncion','Kira Clavell','David Cubitt','Fola Evans-Akingbola','Patrick Gallagher','Toby Levins','Ntare Guma Mbaho Mwine','Alex Roe','Gigi Saul Guerrero','Sarah-Jane Redmond','Gil Birmingham','Gerardo Barcala','Sibongile Mlambo','Veronika Hadravá','Sarah Hayward','Jill Teed','Brad Kelly','Angela Moore','Cameron McDonald','Heather Feeney','Ellen Ewusie','Aundrea Smith','Hannah Levien','David Kaye','Alvina August','Garcelle Beauvais','Broadus Mattison','Brendan Fletcher','Marilyn Norry','Marc-Anthony Massiah','Bronwen Smith','Latonya Williams','Graeme Duffy','Stew McLean','Doralynn Mui','Georgia Bradner','Christopher Rosamond','Shaun Omaid','Caroline Cave','Daniel Cudmore','Kaaren de Zilva','Todd Thomson','Hugo Ateo','Khaira Ledeyo','Victor Dolhai','Sedale Threatt Jr.','Adam Pateman','Deniz Akdeniz','Kareem Malcolm','Nitin Prasad','Maria Volk','Megan Danso','Michel Issa Rubio','Tiffany Lonsdale','Clare Filipow','Donny Lucas','Atlee Smallman','Georgia Waters','Alix West Lefler','Jayce Barreiro','Nisreen Slim','Melanie Rose Wilson','Naomi Tan','Morgana Wyllie','Ronald Patrick Thompson','Byron Coll','Jaren Moore','Nia Cummins','Jamall Johnson','Luc Roderique','Elizaveta Neretin','Shawn Ahmed','Stephen Adekolu','Carmela Sison','Dion Riley','Jaycie Dotin','Millan Tesfazgi','Natalee Linez','Madeleine Kelders','Paul Almeida','Maria Meadows','Aylya Marzolf','Joe Costa','Emma Barratt','Kay Shioma Metchie','Chris Carson','Claire Corlett','Ian Verdun','Amy Goodmurphy'],
screenplay:['Eric Wald','Liz Maccie','Emily Whitesell','Heather Thomason','Elias Benavidez','Michael Gans','Richard Register','Ian Sobel','Matt Morgan','Elle Triedman','Zoë Green'],
production:['Peter Lhotka','Ian Sobel','Matt Morgan'],
music:['Michael A. Levine','Anton Sanko'],
camera:['Brian Pearson','Stephen Jackson','Lindsay George','Mark Chow'],
cut:['Peter Gvozdas','Mitchell Danton','Scot J. Kelly','David Beatty','Joe Talbot Hall',"Geoffrey O'Brien",'Jered Zalman','David Abramson'],
sound:['Michael Perricone','Greg Stewart'],
scenography:['Brian Kane','James Hazell'],
masks:['Kat Kou','Brooke Sovdi','Demiko Majik DeCosta','Lisa Love','Miranda Upton','Kiara Desjarlais','Teia Dumaresq','Carmelle Da Roza','Vicki Syskakis','Lyne Denomme'],
costumes:['Lorraine Carson','Maria Livingstone']},
{title:'Head over Heels',
titleCZ:'Až po uši',
year:2014,
runtime:'13h 21min',
episodeRuntime:'33-36min',
countries:['Czechia'],
genres:['Comedy','Romance'],
director:['Jan Hřebejk'],
actors:['Aňa Geislerová','Jiří Havelka','Hynek Čermák','Jitka Čvančarová','Anna Polívková','Radek Holub','Jana Kolesárová','Lenka Krobotová','Stanislav Majer','Zuzana Šulajová','Jana Švandová','Taťjana Medvecká','František Němec','Jaromír Hanzlík','Sebastian Jacques','Nela Bušková','Kajetán Písařovic','Tereza Osláčová','Zdeněk Mucha','Ivan Vojnár','Jana Gýrová','Jordan Haj','Martin Sitta','Matěj Ruppert','Jiří Štědroň','Petr Čadek','Jan Neckář','Jiří Menzel','Naďa Urbánková','Karel Smyczek','Emma Smetana','Jindřich Šmejkal','Alžběta Jungrová','Daniel Junas','Táňa Hlostová','Adéla Stodolová','Karolína Koblenová','Karel Řezníček','Jaroslav Pížl','Karel Lampa','Lenka Franková','Bohumír Starý','Tereza Hálová','Simona Vavrušová','Aleš Dušek','Vladivojna La Chia','Roman Pihík','Karolína Gulyášová','Marta Dancingerová','Anton Čamaj','Jan Bejšovec','Petra Pelechová','Ondřej Polák','Jana Laichterová','Antonín Kratochvíl','Prokop Laichter','Helena Poláková','Lukáš Houdek','Věra Lasovská','Klára Hanušová','Linda Bartošová','Petr Vobecký','Mark Grein','Lars Haken Sjostrand','Ignát Kinol','Vlasta Čtvrtníčková','Alice Kovaczová','Mark von Tiefenbach','Zdeněk Košata','Michaela Vítková','Jan Šibík','Petr Meliš','Anna Vodrážková','Karel Fink','Andrei Toader','Filip Menzel','Vilma Frantová','Dana Klášterecká-Hradiláková','Václav Neckář','Kristýna Boková','Lukáš Melník','Richard Tesařík','Václav Kopta','Roman Vaněk','Zdeněk Podhůrský','Karel Freund','Markéta Krejčová','Kateřina Peřinová','Michal Zimula'],
screenplay:['Tereza Dusová','Iva Klestilová'],
production:['Tereza Polachová'],
music:['Vladivojna La Chia'],
camera:['Asen Šopov'],
cut:['Vladimír Barák'],
sound:['Jiří Klenka','Jiří Melichar','Tomáš Zůbek','Pavel Rejholec'],
scenography:['Milan Býček'],
masks:['Zdeněk Klika','Andrea McDonald'],
costumes:['Katarína Štrbová Bieliková']},
{title:'A Discovery of Witches',
titleCZ:'Čas čarodějnic',
year:2018,
runtime:'18h 1min',
episodeRuntime:'41-47min',
countries:['UK'],
genres:['Drama','Fantasy','Romance'],
director:['Alice Troughton','Sarah Walker','Juan Carlos Medina','Farren Blackburn','Jonathan Teplitzky','Philippa Langdale','Jamie Donoughue'],
actors:['Matthew Goode','Teresa Palmer','Owen Teale','Malin Buska','Julian Kostov','Alex Kingston','Valarie Pettiford','Sorcha Cusack','Lindsay Duncan','Edward Bluemel','Louise Brealey','Gregg Chillin','Michael Culkin','Dustin Demri-Burns','Daniel Eghan','Trevor Eve','Joe Grossi','Aiysha Hart','Elarica Johnson','Aisling Loftus','Greg McHugh','Tanya Moodie','Sophia Myles','David Newman','Sadie Shimmin','Tomiwa Edun','Freddie Thorp','Leo Ashizawa','Richard Katz','Trystan Gravelle','Ken Bones','Daniel Ezra','Ellie Shenker','Tom Hughes','Simon Meacock','Sheila Hancock','Lois Chimimba','Victoria Yeates','Holly Aird','Adrian Rawlins','Laurence Spellman','James Purefoy','Steven Cree','Elaine Cassidy','Paul Brennen','Rebecca Lacey','Paul Rhys','Amanda Hale','Karin Bertling','Struan Rodger','James Allenby-Kirk','Barbara Marten','Anton Lesser','Savannah Steyn','Joshua Blue Pickering','Amy McAllister','Tom Lewis','Adelle Leonce','Adam Sklar','Michael Lindall','Milo Twomey','Olivier Huband','Dominic Borrelli','Meghna Lall','Gamba Cole','Francesca Henry'],
basedOn:['Deborah Harkness'],
screenplay:['Kate Brooke','Sarah Dollard','Pete McTighe','Susie Conklin','Polly Buckle','Lisa Holdsworth','Joseph Wilde','Tom Farrelly','Michelle Gayle','Charlene James'],
production:['Edoardo Ferretti'],
music:['Rob Lane'],
camera:['Petra Korner','Christophe Nuyens','Suzie Lavelle','Adam Etherington','Rasmus Arrildt','Catherine Goldschmidt','Chas Bain'],
cut:['Philip Kloss','Nick Arthurs','Nikki McChristie','Sam Williams','Philip Hookway'],
sound:['Bryn Thomas','Alex Thompson','Andy Kennedy','Stevie Haywood'],
scenography:['James North','Harry Trow','Livia Borgognoni'],
masks:['Harriet Thompson','Roseann Samuel','Chloe Southall'],
costumes:['Nigel Egerton','Sarah Arthur','Molly Emma Rowe']},
{title:'Dallas',
titleCZ:'Dallas',
year:1978,
runtime:'286h 25min',
episodeRuntime:'34-95min',
countries:['USA'],
genres:['Drama','Romance'],
director:['Michael Preece','Larry Hagman','Patrick Duffy','Linda Gray','Robert Day','Dennis Donnelly','Russ Mayberry','Vincent McEveety','Jerry Jameson','Paul Stanley','Lawrence Dobkin','Leslie H. Martinson','Steve Kanaly','Bruce Bilson','Ernest Pintoff','Alex March','Don McDougall','Gwen Arner','Victor French','Ray Danton','Joseph Manduke','David Paulsen','Alexander Singer','Robert C. Thompson','Robert Becker','Gunnar Hellström','Linda Day','Cliff Fenneman','Nicholas Sgarro','Corey Allen','Roy Campanella II','Leonard Katzman','Barry Crane','Irving J. Moore','Harry Harris','Michael A. Hoey','Nick Havinga'],
actors:['Larry Hagman','Barbara Bel Geddes','Lesley-Anne Down','Patrick Duffy','Linda Gray','Ken Kercheval','Steve Kanaly','Howard Keel','George Kennedy','Jenilee Harrison','John Beck','Morgan Brittany','Audrey Landers','William Smithers','Cathy Podewell','Sasha Mitchell','Jim Davis','Priscilla Presley','Victoria Principal','Fredric Lehne','Donna Reed','Charlene Tilton','Sheree J. Wilson','Deborah Shelton','George Petrie','Joseph Campanella','Morgan Fairchild','Jack Scalia','Marc Singer','Brenda Strong','Ken Foree','Mark Lindsay Chapman','Dakin Matthews','Shari Shattuck','Sharon Madden','Glenn Morshower','Barry Nelson','Marla Maples','Christine Taylor','Jeanna Michaels','Kim Johnston Ulrich','Michael Dudikoff','Brad Pitt','Amy Yasbeck','John Anderson','Steve Forrest','Troy Evans','BarBara Luna','Kenneth Tigar','Tyrees Allen','Barbara Eden','Jared Martin','Buck Taylor','Wendy Fulton','Michelle Johnson','Jim Beaver','Barbara Carrera','John McIntire','Edward Winter','Chelcie Ross','Rosanne Katon','Sam Anderson','James Whitmore Jr.','Catherine Dent','Parley Baer','Diana Douglas','Gregory Itzin','Ian McShane','Brad Harris','James Karen','Jim McMullan','Dimitra Arliss','Tom Bower','Melody Anderson','Richard Beymer','Anthony Peck','Jack Ramage','Omri Katz','Alexis Smith','Dale Robertson','Lance Guest','Lane Davies','Talia Balsam','Joan Van Ark','Diane McBain','Chazz Palminteri','Tina Louise','Clifton James','Jean Claudio','Max Thayer','Christopher Kriesa','Deborah Tranelli','Susan Howard','Gary Carlos Cervantes','Joan Staley','Marcus Chong','Howard Duff','Cliff Potts','Crystal Carson','Rance Howard'],
screenplay:['Jonathan Hales','David Paulsen','D.C. Fontana','Bryce Zabel','Jackie Zabel','Darlene Craviotto','Simon Masters','David Jacobs','Calvin Clements Jr.','Virginia Aldridge','Leonard Katzman','Mitchell Wayne Katzman','Stephanie Garman','Hollace White','Bruce Shelly','Joel J. Feigenbaum','Arthur Bernard Lewis','Howard Lakin','Linda Elstad','Lisa Seidman','Peter Dunne','Jim Inman','Worley Thorne','Rena Down','Richard Fontana','Camille Marchetta'],
production:['Calvin Clements Jr.','Leonard Katzman','Arthur Bernard Lewis','James H. Brown','Howard Lakin','Peter Dunne'],
music:['Lance Rubin','Jerrold Immel','Angela Morley','Ken Harrison','John Carl Parker','Richard Lewis Warren','Bruce Broughton'],
camera:['Robert Jessup','Robert Caramico','Bradford May','William Mendenhall','Edward R. Plante','Rick F. Gunter','Jack Swain','Allen M. Davey'],
cut:['Fred W. Berger','Edward A. Biery','Lloyd L. Richardson','Michael McCroskey','Irving Rosenblum','John Arthur Davies'],
sound:['Duncan McEwan','Marty Church','Alfred T. Ferrante','Doug Grindstaff','Robert Davenport'],
scenography:['Ina Peichl','Robin Royce','Bryan Thetford','Chuck Rutherford','Philip Leonard','James Hassinger','Travis Nixon','Robert Gould','Carl Braunger','Les Gobruegge','Walter M. Jefferies','David Marshall','Jack Marty','Charles Zacha Jr.'],
masks:['Cheri Minns','Alan Fama','William Lyon MacKenzie','Lee Crawford','Norman T. Leavitt','Joe Hailey','Jim Kail','Jeffrey Hamilton','Bob Jermain','Jerry Gugliemotto','Susan A. Cabral','Georgina Williams',"Lola 'Skip' McNalley","Jerry O'Dell",'Carolyn Ferguson'],
costumes:['Travilla']},
{title:'Jett',
titleCZ:'Jett',
year:2019,
runtime:'7h 57min',
episodeRuntime:'45-64min',
countries:['USA'],
genres:['Drama','Crime','Thriller'],
director:['Sebastian Gutierrez'],
actors:['Carla Gugino','Giancarlo Esposito','Michael Aronov','Gus Halper','Lucy Walters','Greg Bryk','David Aron Damane','Jesse Aaron Dwyre','Elena Anaya','Gaite Jansen','Gil Bellows','Christopher Backus','Gentry White','Jodie Turner-Smith','Violet McGraw','Mustafa Shakir','Shiloh Fernandez','Rainbow Sun Francks','Stuart Hughes','Alex Mallari Jr.','Dwain Murphy','Gregg Lowe','Tony Nappo','Doug Murray','James Cade','Genevieve Kang','Matt Purdy','Dempsey Bryk','Chivonne Michelle','Bruce Greenwood','Lesleh Donaldson','Corrin Evans','Josh Pence','Rya Kihlstedt','Andreas Apergis','Natalie Hall','Zach Smadu','Conrad Coates','Adam Langton','Hamza Haq','Craig Burnatowski','Sean Rey','Travis Nelson','Alan Catlin','Jonathan Koensgen','Stephanie Anne Mills','Jhene Erwin','Alice Tate','Val Ovtcharov','Billy Bryk','Brenna Stewart','Drew Moss','Elias Edraki','Moni Ogunsuyi'],
screenplay:['Sebastian Gutierrez'],
production:['Kathy Landsberg'],
music:['Johnny Klimek'],
camera:['Cale Finot'],
cut:['Matt Mayer'],
sound:['Henry Embry'],
scenography:['Rocco Matteo','Friday Myers','Michele Brady'],
masks:['Julie Hewett'],
costumes:['Nancy Gould']},
{title:'The Outer Limits',
titleCZ:'Krajní meze',
year:1995,
runtime:'114h 32min',
episodeRuntime:'43-93min',
countries:['Canada','USA'],
genres:['Mystery','Horror','Sci-Fi','Fantasy','Drama','Thriller'],
director:['Ken Girotti','Jonathan Glassner','Mark Sobel','Michael Keusch','Jeff Woolnough','James Head','Adam Nimoy','Allan Eastman','Timothy Bond','Scott Peters','Mario Azzopardi','George Bloomfield','Charles Winkler','Tibor Takács','Michael Robison','David Warry-Smith','Graeme Campbell','Mike Rohl','Peter DeLuise','Helen Shaver','Stuart Gillard','Brad Turner','Rebecca De Mornay','Jorge Montesi','Jim Kaufman',"Catherine O'Hara",'Matthew Hastings','Lou Diamond Phillips','Dan Ireland','Melvin Van Peebles','Jason Priestley','Paul Lynch','Joseph L. Scanlan','Steven Weber','Brenton Spencer','William Fruet','Neill Fearnley','Joe Nimziki','René Bonnière','Steve Anker','Martin Cummins','Robert Habros'],
actors:['Kevin Conway','Beau Bridges','Helen Shaver','Frank Whaley','Rebecca De Mornay','Beau Starr','John Savage','John Heard','Blu Mankuma',"Annette O'Toole",'Timothy Busfield','Len Cariou','Chris Sarandon','Don S. Davis','David Warner','Thora Birch','Rachel Victoria','Kevin Tighe','Dale Midkiff','Joanna Gleason','Marcia Cross','Jeffrey Ballard','Phillip MacKenzie','Rod Wilson','Tiffany Lyndall-Knight','Maurice Dean Wint','Brent David Fraser','Ryan Taylor','Andrea Martin','Rae Dawn Chong','Nora Dunn','James Marsden','Michelle Harrison','Donny Lucas','Kevan Ohtsji','Pat Morita','Greg Anderson','Teryl Rothery','Heather Graham','Adam Hann-Byrd','Jeremy Guilbaut','Roger Cross','Callum Keith Rennie','Gary Hetherington','Adrian Pasdar','Debrah Farentino','Colin Ferguson','John Spencer','David Cubitt','William Sadler','Leslie Hope','Bill Cobbs','Peter Williams','Richard Thomas','Shawn Ashmore','Lela Rochon','Marlee Matlin','Judd Nelson','Roman Podhora','Kristin Lehman','Zack Ward','Haili Page','Robert Picardo','Robert Foxworth','Robert Guillaume','Grace Park','Michael Hogan','Aaron Douglas','Derek de Lint','Ken Kirzinger','Michael Sarrazin','Chris William Martin','Andrea Roth','Sarah Strange','Colin Mochrie','Kevin Durand','Karin Konoval','Anthony De Longis','Nathan Fillion','Gregory Smith','Daniella Evangelista','Claudette Mink','Christine Willes','Catherine Lough Haggquist','Simone Bailly','Barbara Eve Harris','Wallace Langham','Brenda Campbell','Ingrid Kavelaars','Jason Gray-Stanford','Brandy Ledford','Alan Ruck','Holly Elissa','Maria Luisa Cianni','Michelle Beaudoin','Matthew Harrison','Carrie Genzel','Max Martini','Jasmine Guy','Lynda Boyd'],
basedOn:['Brad Wright','Richard Barton Lewis','George R.R. Martin','Harlan Ellison','Jonathan Walker','Stephen King','Naren Shankar','Jonathan Glassner','A.E. van Vogt'],
screenplay:['Sam Egan','Scott Nimerfro','Paul Mones','Melissa Rosenberg','David J. Schow','Tom J. Astle','Jeff F. King','David Shore','Joseph Stefano','Danny McBride','Duncan Kennedy','Manny Coto','Jon Cooksey','John Whelpley','Leslie Stevens','Chris Brancato','Brad Wright','Naren Shankar','Tracy Tormé','Melinda M. Snodgrass','Tom Szollosi','David Kemper','Michael Sloan','James Crocker','Alison Lea Bingeman','Shawn Thompson','Jonathan Glassner','A L Katz','Lawrence Meyers','Ann Lewis Hamilton','Jonathan Walker','Hart Hanson','Jeffrey Hirschfield','Bill Froehlich','Will Dixon','Scott Peters','David Braff','Steven Barnes','Grant Rosenberg','Pen Densham','Matthew Hastings','Alan Brennert','Eric Morris','Seeleg Lester','Eric Estrin','Michael Berlin','Chris Ruppenthal','John Schulian','Naomi Janzen','Brad Markowitz','Robert Forsyth','Ali Marie Matheson','Carleton Eastlake'],
production:['Justis Greene','Chris Ruppenthal'],
music:['Mark Mancina','Joel Goldsmith','Claude Foisy','John Van Tongeren','Patric Caird','Randy Miller','J. Peter Robinson','Stephen Graziano','Graeme Coleman','Edgar Rothermich','Steven M. Stern','Fred Mollin','Daryl Bennett','Mark Leggett','Velton Ray Bunch','Christophe Beck','David Bergeaud','Joel Goldberg'],
camera:['Attila Szalay','Peter F. Woeste','Richard Wincenty','Danny Nowak','Philip Linzey','Rick Maguire','Andreas Poulsson'],
cut:['Alison Grace','Ron Yoshida','Lisa Binkley','Rick Martin','Richard Benwick','Brad Rines','Robb Watson','Eric Hill'],
sound:['Bill Mellow','Dean Giammarco','Miguel Nunes','Paul A. Sharpe'],
scenography:['Brent Thomas','Phil Schmidt','Stephen Geaghan','Sheila Haley','Andrea French'],
masks:['Charles Porlier','Fay von Schroeder','Monica Huppert','Christopher Allen Nelson','Leanne Rae Podavin','Céline Godeau','Jan Newman'],
costumes:['Stephanie Nolin']},
{title:'Lilo & Stitch: The Series',
titleCZ:'Lilo a Stitch',
year:2003,
runtime:'23h 50min',
episodeRuntime:'22min',
countries:['USA'],
genres:['Animation','Family','Sci-Fi','Comedy'],
director:['Rob LaDuca','Chris Sanders','Victor Cook','Tony Craig','Jolan Calibuso','Mike Girard','Archer Lai','Joe Chen','Kirk Lin'],
actors:['Daveigh Chase','Chris Sanders','David Ogden Stiers','Jillian Henry','Rob Paulsen','Kevin Michael Richardson','Frank Welker','Tia Carrere','Dee Bradley Baker','Miranda Cosgrove','Will Sasso','Nicole Sullivan','Katharina Thalbach',"'Weird Al' Yankovic",'Maggie Wheeler','Alyson Stoner','Paula Jai Parker','Liliana Mumy','Andrew Lawrence','John DiMaggio','Tahj Mowry','Tara Strong','Zoe Caldwell','Mark McKinney','Scott Thompson','Ashley Johnson','Shaun Fleming','Charlie Finn','Bobcat Goldthwait',"Rickey D'Shon Collins",'Keone Young','Rocky McMurray','Jo Marie Payton','Robbie Rist','Haunani Minn','Kath Soucie','Matt Corboy','April Winchell','Gigi Bermingham','Matt Hill','Danny Mann','Kittie KaBoom'],
screenplay:['Madellaine Paxson','Brandon Sawyer','Bob Schooley','Mark McCorkle','Evan Gore','Heather Lombard','Mark Drop','Jan Strnad','Ken Koonce','Brian Swenlin','Laura McCreary','Thomas Hart','John Behnke','Jim Peronto','Rob Humphrey','Catherine Lieuwen'],
production:['Victor Cook','Wade Wisinski','Mike Girard'],
music:['Michael Tavera','John Van Tongeren'],
cut:['Joseph Molinari','Gayle M. Grech','Tony Mizgalski'],
sound:['Paul McGrath','Mike Draghi','Otis Van Osten','Mark Ettel','Tom Maydeck','Allen L. Stone','Jason Brennan','Joseph D. Citarella','Larry Stensvold','Stephen Fitzmaurice','Gary Alexander','Frank Verderosa','Dan Cubert','Gary Maiman','John Boyd']},
{title:'Lhostejní',
titleCZ:'Lhostejní',
year:1988,
runtime:null,
episodeRuntime:'988',
countries:['Italy','UK'],
genres:['Drama'],
director:['Mauro Bolognini'],
actors:['Peter Fonda','Liv Ullmann','Sophie Ward','Laura Antonelli','Annie Belle','Stefano Davanzati','Riccardo Salvino','Luigi Giuliani','Luciano Marin','Robert Sampson','Cris Campion','Giovanni Di Benedetto','Teresa Razzauti'],
basedOn:['Alberto Moravia'],
screenplay:['Lucia Drudi Demby'],
production:['Ciro Ippolito'],
music:['Ennio Morricone'],
camera:['Ennio Guarnieri'],
sound:['Alberto Doni'],
scenography:['Pierfranco Luscrì'],
masks:['Gino Zamprioli','Mauro Meniconi'],
costumes:['Aldo Buti']},
{title:'Blindspot',
titleCZ:'Mrtvý bod',
year:2015,
runtime:null,
episodeRuntime:'71h41-43min',
countries:['USA'],
genres:['Drama','Mystery','Thriller'],
director:['David McWhirter','Rob Seidenglanz','David S. Tuttman','Martin Gero','Jeff F. King','Martha Mitchell','Mark Pellington','Marcos Siega','Dermott Downs','Jeff T. Thomas','Steve Shill','Karen Gaviola','Rob Hardy','Kenneth Fink','Tricia Brock','Romeo Tirone','Tawnia McKiernan','Adam Salky','Kate Woods','Glen Winter','Laura Belsey','Darnell Martin','Ernest R. Dickerson','Olatunde Osunsanmi','Solvan Naim','Lin Oeding','Kristin Windell','Marisol Adler','Jean de Segonzac','Neema Barnette','Maja Vrvilo','Marcus Stokes','Andy Mikita','Andi Armaganian','Christopher Place','Aric Avelino','Joy Lane','Mark Tonderai','R.T. Thorne','Ramaa Mosley','Sudz Sutherland','Amanda Tapping','David Johnson','America Young','Pamela Romanowsky','Rich Newey'],
actors:['Sullivan Stapleton','Jaimie Alexander','Audrey Esparza','Ashley Johnson','Rob Brown','Luke Mitchell','Ennis Esmer','Ukweli Roach','Michelle Hurd','Marianne Jean-Baptiste','Archie Panjabi','Aaron Abrams','Mary Elizabeth Mastrantonio','Chad Donella','Trieste Kelly Dunn','François Arnaud','Josh Dean','Tori Anderson','Ami Sheth','Mary Stuart Masterson','Jordana Spiro','Jay O. Sanders','Kristina Reyes','Joe Dinicol','Jefferson White','Julee Cerda','Chaske Spencer','Michael Gaston','Jonathan Patrick Moore','David Morse','Johnny Whitworth','Gloria Reuben','Li Jun Li','Dylan Baker',"Lachlan O'Day",'Logan Smith','Lou Diamond Phillips','Michael Godere','Amy Hargreaves','Dan Butler','Sarita Choudhury','Afton Williamson','James Colby','Robert Eli','Paul Fitzgerald','Dave Quay','Ayman Samman','Aimee Carrero','Mike Doyle','Judy Marte','Laith Nakli','Michael Rogers','Cotter Smith','Jason Kravits','Debra Monk','Trevor Long','Frank Pando','Stephanie Andujar','Ohene Cornelius','Rodrigo Lopresti','Suzanne Lenz','Michael James Levy','Natalya Rudakova','Brian Distance','Usman Ally','Marko Caka','Sakina Jaffrey','Victor Slezak','Bree Williamson','Justin Clarke','Blaise Corrigan','Roy Jackson','Christos Vasilopoulos','Eisa Davis','Remy Auberjonois','Shawn Parsons','Robert C. Kirk','Chris Beetem','Maria Rivera','Adam David Thompson','Ed Moran','Daniel J. Watts','David Chen','Mark Doherty','John Hodgman','Gaius Charles','Paul Calderon','Michelle Ongkingco','Wilson Jermaine Heredia','Lars Gerhard','Tom Lipinski','Sandrine Holt','Stephanie Roth Haberle','David Aaron Baker','David Alan Basche','Ajay Naidu','Neil Jackson','K. Todd Freeman','Chukwudi Iwuji','Oona Laurence'],
screenplay:['Chris Pozzebon','Christina M. Kim','Rachel Caris Love','Ryan Johnson','Peter Lalayanis','Martin Gero','Eric Buchman','Brendan Gall','Kristen Layden','Alex Berger','Matt Young','Hadi Nicholas Deeb','Kate Sargeant','Deanna Shumaker','Anne Hecker','Eoghan Mahony','Tracy A. Whitaker','Katherine Collins','Chelsey Lora','Sabrina Deana-Roga'],
production:['Ryan Johnson','Peter Lalayanis','Kelly Van Horn','Jennifer Lence','Carl Ogawa','Rachel Caris Love','Kate Sargeant','Alex Berger','Brendan Gall','Howard Griffith','Chris Pozzebon','Ryan Lindenberg','Sarah Rath','Harvey Waldman'],
music:['Blake Neely','Sherri Chung'],
camera:['Andrew Priestley','David Johnson','Jon Delgado','David S. Tuttman','Martin Ahlgren'],
cut:['Mike Banas','Finnian Murray','Ian Mayberry','Hilary Bolger','Kristin Windell','Joel T. Pashby','Daniel Raj Koobir','Harry Jierjian'],
sound:['Dennis Kirk','Alexandra Fehrman','Aaron Levy','Ethan Beigel','Brad Sherman','Todd Orr','Mark Relyea','Griffin Richardson','Julian Townsend'],
scenography:['Andrew Jackness','Rebecca Meis DeMarco','Samuel Froeschle','Georges N. Krivobok','Wing Lee','Sarah Maine','Melissa Shakun','Said El Kounti','David Schlesinger'],
masks:['Jenn Blum','Shellie Biviens','Charlene Belmond','Jackie Risotto','Amy Sue Nahhas','Francesca Tampieri','Alexandra Urvois','Joseph Farulla'],
costumes:['Sarah Beers','Marie Abma','Jared B. Leese','Keia Bounds','Wallace G. Lane Jr.']},
{title:'Molo',
titleCZ:'Molo',
year:2019,
runtime:'12h 32min',
episodeRuntime:'42-53min',
countries:['Spain'],
genres:['Drama'],
director:['Jorge Dorado','Jesús Colmenar','Alex Rodrigo','Eduardo Chapero-Jackson'],
actors:['Álvaro Morte','Verónica Sánchez','Irene Arcos','Roberto Enríquez','Marta Milans','Judit Ampudia','Paco Manzanedo','Cecilia Roth','Antonio Garrido','Eva Martín','Miquel Fernández','Luna Fulgencio','Miriam Correa','Ignacio Ysasi','Antonio Dechent','Paqui Horcajo','Pep Ricart','Elisabet Gelabert','Ramón Esquinas','Paula López-Bravo','Sergio Caballero','Arlette Torres','Francisco Campos Barba','Kuni Tomita'],
screenplay:['Esther Martínez Lobato','Álex Pina','Javier Gómez Santander','Emilio Díez','David Barrocal'],
music:['Iván Martínez Lacámara','Manel Santisteban'],
camera:['Álvaro Gutiérrez','Migue Amoedo'],
cut:['Domi Parra','Raquel Marraco','Regino Hernández'],
sound:['José Ignacio Arrufat','Nacho Arenas'],
scenography:['Abdón Alcañiz','Cecilia Minaya'],
masks:['Eva Martínez'],
costumes:['Elena Lahera']},
{title:'Killing Eve',
titleCZ:'Na mušce',
year:2018,
runtime:'22h 24min',
episodeRuntime:'41-43min',
countries:['USA'],
genres:['Drama','Thriller'],
director:['Harry Bradbeer','Jon East','Damon Thomas','Lisa Brühlmann','Francesca Gregorini','Terry McDonough','Miranda Bowen','Shannon Murphy','Stella Corradi','Anu Menon','Emily Atef'],
actors:['Sandra Oh','Jodie Comer','Fiona Shaw','Kim Bodnia','Owen McDonnell','Olivia Ross','Darren Boyd','Aurélie Meriel','Anatole Taubman','Rinat Khismatouline','Susan Lynch','Andrew Byron','Lina Alminas','Andrei Zayats','David Agranov','Kirby Howell-Baptiste','Edyta Budnik','Elena Saurel','Barbara Flynn','Luke de Woolfson','Julian Barratt','Nina Sosanya','Edward Bluemel','Diana Payan','Henry Lloyd-Hughes','Shannon Tarbet','Adrian Scarborough','Simon Thorp','Nickolas Grace','Emma Pierson','Coline Atterbury','Andrea Tivadar','Laurentiu Possa','Ken Nwosu','Remo Girone','David Haig','Ania Marson','Paolo D Bovani','Sean Delaney','Charlie Hamblett','Barbara Sotelsek','Lobo Chan','Susie Trayling','Haruka Kuroda','Edward Akrout','Zhenya Leverett','Irina Kara','Gin Mar','Emily McIllwraith','Yuli Lagodinsky','Irina Lytiak','Sonia Elliman','Pierre Atri','André Refig','Zoë Wanamaker','Zoë Pastelle Holthuizen','Roeland Fernhout','Annelies Appelhof','David Cann','Mike Reus','Thomas Kuratli','Jung Sun den Hollander','Michael Akinsulire','Chelsea Mather','Aidan Kelly','Adeel Akhtar','Geff Francis','Nigel Betts','Cat Simmons','Marko Leht','Tomi May','Jonathan Huisman','Steve Pemberton','Harriet Walter','Lina Garvardt','Raj Bajaj','Turlough Convery','Danny Sapani','Tiffany Ceri','Gianni Calchetti','Gemma Whelan','Elisabeth Bonjour','Dominic Mafham','Don Gallagher','Esther Hall','Anita Poddębniak','Ion Grosu','Rebecca Saire','Camille Cottin','Ayoola Smart','Dimitrij Schaad','Predrag Bjelac','Robert Feldman','Žeňa Dodina','Cristina Casian','Rada Ixari','Kim Bodnia','Harriet Walter','Lia Sinchevici','Temirlan Blaev'],
basedOn:['Luke Jennings'],
screenplay:['Phoebe Waller-Bridge','Emerald Fennell','Jessica Ashworth','George Kay','D.C. Moore','Freddy Syborn','Jeremy Dyson','Vicky Jones','Anna Jordan','Laura Neal','Krissie Ducker','Suzanne Heathcote','Henrietta Ashworth','Rob Williams','Kayleigh Llewellyn','Georgia Lester','Sarah Simmonds'],
production:['Morenike Williams','Andrew Noble','Nige Watson','Colin Wratten','Suzanne Heathcote'],
music:['David Holmes','Keefus Ciancia'],
camera:['Julian Court','Tim Palmer','Damian Bromley','Carlos Catalán','Álvaro Gutiérrez'],
cut:['Gary Dollner','Crispin Green','Jason Savage','Stephen Evans','Al Morrow','Dan Crinnion','Adam Moss','Helen Chapman','Colin Fair'],
sound:['Brad Rees'],
scenography:['Kristian Milsted','Laurence Dorman','Vraciu Eduard Daniel','Tamara Marini','Lucienne Suren','Beckie Harvey','Alexandra Toomey','Peter Findley'],
masks:['Danielle Hawkes','Amy Boyd','Matthew Smith','Georgina Coupland','Jenna Smith','Lucy Keel','Raluca Moldoveanu'],
costumes:['Sam Perry','Charlotte Mitchell']},
{title:'Find Me in Paris',
titleCZ:'Najdi si mě v Paříži',
year:2018,
runtime:'32h 30min',
episodeRuntime:'25min',
countries:['France','Germany'],
genres:['Comedy','Drama','Family','Fantasy','Music'],
director:['Matt Bloom','Rob Burke','Ronan Burke','R.T. Thorne'],
actors:['Jessica Lord','Rik Young','Caitlin-Rose Lacey','Eubha Akilade','Castle Rock',"Christy O'Donnell",'Rory J. Saper','Hannah Dodd','Hiran Abeysekera','Seán Óg Cairns','Lawrence Walker','Luca Varsalona','Katherine Erhardy','Chloe Fox','Ingo Brosch','Rameet Rauli','Javone Prince','Chris Baltus','Elisa Doughty','Sophie Airdien','Manuel Pacific','Lori Mather-Welch','David Michel','Jelle Florizoone','Dominic Gould','Zoe Carrera','Dianne Weller','Katie Louise Hillyer','Terique Jarrett','Edward Kagutuzi','Audrey Hall','Patricia Thibault','Jean-Guillaume Bart','Matt Bloom','Louis Davison'],
screenplay:['Spencer Levine','Mike Kiss','Amy Benham','Hannah Cheesman','Pavan Moondi','Jill Girling','Lori Mather-Welch'],
production:['Zoe Carrera','Mike Kiss','Cécile Lauritano','David Michel'],
music:['Norbert Gilbert'],
camera:['Philippe de Vaucelles','Jean-Philippe Gosselin'],
cut:['Arthur Uberti','Lucas Mitschi','Soline Guyonneau','Sandrine Deegen'],
scenography:['Laurent Avoyne','Jan Petitjean'],
masks:['Marie Messien'],
costumes:['Chouchane Tcherpachian','Gaëtane Paulus']},
{title:'Survivor',
titleCZ:'Robinsonův ostrov',
year:2017,
runtime:null,
episodeRuntime:'45min',
countries:['Czechia'],
genres:['Reality-TV','Competition','Adventure'],
director:['Jiří Volek','Lucie Matějíčka Sehnalová'],
production:['Gabriela Duchoňová','Pavel Čechák'],
camera:['Lukáš Gargulák'],
cut:['Karel Coma']},
{title:'Rain Dogs',
titleCZ:'Pod psa',
year:2023,
runtime:'3h 37min',
episodeRuntime:'24-28min',
countries:['UK'],
genres:['Drama','Comedy'],
director:['Richard Laxton','Jennifer Perrott'],
actors:['Daisy May Cooper','Jack Farthing','Ronke Adekoluejo','Fleur Tashjiian','Emily Fairn','Reid Anderson','Nick Blood','Adrian Edmondson','Alison Lintott','Stephen Wight','Steve Toussaint','Sam Hazeldine','Tom Durant Pritchard','Anna Chancellor','Kate Fleetwood','Camille Coduri','Thomas Coombes','Julian Firth','Tanya Moodie','Phoebe Thomas','Trevor Fox','Jason Harvey','Jay Oliver Yip'],
screenplay:['Cash Carraway'],
production:['Ciara McIlvenny'],
music:['Alex Baranowski'],
camera:['Carlos Catalán','Wojciech Szepel'],
sound:['Nigel Squibbs'],
scenography:['Amelia Shankland','Muirelle Wilson','Harry Trow'],
masks:['Sharmilla Vythelingum','Bethan Adams Stringer'],
costumes:['Nigel Egerton']},
{title:'The Thaw',
titleCZ:'Obleva',
year:2022,
runtime:'4h 54min',
episodeRuntime:'46-55min',
countries:['Poland'],
genres:['Crime','Drama'],
director:['Xawery Żuławski'],
actors:['Katarzyna Wajda','Bartłomiej Kotschedoff','Cezary Łukaszewicz','Juliusz Chrząstowski','Sebastian Fabijański','Andrzej Grabowski','Bogusław Linda','Małgorzata Gorol','Agnieszka Pilaszewska','Monika Krzywkowska','Piotr Żurawski','Ewa Skibińska','Konrad Beta','Arkadiusz Buszko','Marcin Kłosiński','Adam Kuzycz-Berezowski','Joanna Matuszak','Ernest Nita','Konrad Pawicki','Julia Rosnowska','Wojciech Sandach','Marcelina Stępkowska','Agnieszka Suchora','Marcin Zarzeczny','Wojciech Zieliński','Artur Ziółkowski','Dominik Bąk','Sebastian Łach','Maciej Miszczak','Marta Ojrzyńska','Jaśmina Polak','Aleksander Stasiewicz','Paweł Adamski','Adam Dzieciniak','Paweł Niczewski','Krzysztof Sztabiński','Joanna Gonschorek','Piotr Bumaj','Marek Kocot','Mirosław Kropielnicki','Anna Krotoska','Monika Kwiatkowska','Piotr Łaznowski','Krzysztof Pyziak','Krzysztof Zarzecki','Beata Bandurska','Eryk Lubos','Natalia Sikora','Małgorzata Szczerbowska','Tadeusz Woszczyński','Małgorzata Szeptycka'],
screenplay:['Marta Szymanek','Piotr Szymanek'],
production:['Bogumił Lipski'],
music:['Łukasz Targosz'],
camera:['Tomasz Naumiuk'],
cut:['Piotr Kmiecik','Wojciech Mrówczyński'],
sound:['Tomasz Bargieł','Monika Krzanowska','Robert Docew'],
scenography:['Łukasz Trzciński','Hanna Wójcikowska-Szymczak'],
masks:['Karolina Kordas'],
costumes:['Agata Culak']},
{title:'Sex and the City',
titleCZ:'Sex ve městě',
year:1998,
runtime:'43h 2min',
episodeRuntime:'21-43min',
countries:['USA'],
genres:['Comedy','Romance'],
director:['Susan Seidelman','Alison Maclean','Allison Anders','David Frankel','Allen Coulter','Charles McDougall','Alan Taylor','Michael Spiller','Michael Patrick King','Nicole Holofcener','Victoria Hochberg','John David Coles','Daniel Algrant','Timothy Van Patten','Michael Fields','Darren Star','Wendey Stanzler','Michael Engler','Julian Farino','Matthew Harrison','Martha Coolidge'],
actors:['Sarah Jessica Parker','Kim Cattrall','Kristin Davis','Cynthia Nixon','Chris Noth','John Corbett','Willie Garson','Kyle MacLachlan','Michail Baryšnikov','Frances Sternhagen','James Remar','Ron Livingston','Chandra Wilson','Bridget Moynahan','Craig Chester','Sarah Wynter','Sarah Clarke','Victor Webster','Blythe Auffarth','Leslie Lyles','Bradley Cooper','Elizabeth Banks','Meredith Ostrom','J.D. Williams','Evan Handler','Rosemarie DeWitt','Rachel Nichols','Susan Misner','John Scurti','Josh Pais','Edward Kerr','Jack Hartnett','Russ Russo','Daniel Travis','Brad Beyer','Kat Dennings','Robert LuPone','Kimberly Evan','Liza Lapira','Anson Mount','Fred Dalton Thompson','Clark Gregg','Margaret Cho','Seth Gabel','Yul Vazquez','Heidi Klum','Molly Price','Tonye Patano','Maggie Kiley','Timothy Olyphant','Amy Redford','Mark Feuerstein','Caitlin Clarke','Rochelle Aytes','Wallace Langham','Geri Horner','Heather MacRae','Jason Lewis','Jodi Long','Michael Medico','Claudia Besso','Christopher Sieber','Debbon Ayer','Hugh M. Hefner','Deborah Zoe','Phyllis Somerville','Geneva Carr','Will Arnett','Crystal Allen','Patrick Breen','Noelle Beck','Nick Gregory','Anita Gillette','Phil Coccioletti','Anthony DeSando','John Enos III','Donald Trump','Tony Ray Rossi','Ronald Guttman','David Eigenberg','Jen Strickland','Robert Gomes','Alanis Morissette','Blair Underwood','Justin Theroux','Katie Finneran','Marceline Hugot','Kate Jennings Grant','Ali Costello','Lauren Lake','Anne Meara','Daniel Sunjata','Matthew McConaughey','Vince Vaughn','Carrie Fisher','Elizabeth Regen','Eddie Cahill','Blanchard Ryan','Charles Parnell','LisaGay Hamilton'],
basedOn:['Candace Bushnell'],
screenplay:['Michael Patrick King','Julie Rottenberg','Elisa Zuritsky','Amy Harris','Michael Green','Jenji Kohan','Alexa Junge','Jessica Bendinger','Aury Wallington','Allan Heinberg','Jenny Bicks','Cindy Chupack','Darren Star','Liz Tuccillo','Judy Toll','Nicole Avril','Terri Minsky','Becky Hartman Edwards'],
production:['Jane Raab'],
music:['Kenneth Burgomaster','Daniele Luppi','Didier Rachou','Douglas J. Cuomo','Bob Christianson'],
camera:['Stuart Dryburgh','Florian Ballhaus','Terry Stacey','Maryse Alberti','John Thomas','Alik Sakharov','Michael Spiller','Michael F. Barrow'],
cut:['Michael Berenbaum','Kate Sanford','Wendey Stanzler'],
sound:['Tod A. Maitland','Frank Morrone','Bob Chefalas','Louis Bertini',"T.J. O'Mara",'Aiden Ramos'],
scenography:['Jeremy Conway','Mark Friedberg','Bruce Alan Miller','Christina Tonkin Noble','Karin Wiesel Holmes','Susie Goulder','Douglas A. Mowat','Stephanie Carroll','Charles E. McCarry'],
masks:['Nicki Ledermann','Angel De Angelis','Judy Chin','Sasha Cummins'],
costumes:['Ellen Lutter','Patricia Field','Molly Rogers']},
{title:'Top of the Lake',
titleCZ:'Na jezeře',
year:2013,
runtime:'11h 6min',
episodeRuntime:'45-60min',
countries:['Australia','UK','New Zealand','USA'],
genres:['Thriller','Mystery','Crime','Drama'],
director:['Jane Campion','Garth Davis','Ariel Kleiman'],
actors:['Elisabeth Moss','Thomas M. Wright','Holly Hunter','Peter Mullan','Michelle Ang','Jacek Koman','David Wenham','Jay Ryan','Cohen Holloway','Lucy Lawless','Ben Barrington','Mirrah Foulkes','Tammy Davis','Darren Gilshenan','Robyn Nevin','Edwin Wright','Geneviève Lemon','Oscar Redding','Andrew Grainger','Robyn Malcolm','Alison Bruce','Stephen Lovatt','Chris Haywood','Ewen Leslie','Matt Whelan','Gwendoline Christie','David Dencik','Linda Ngo','Alice Englert','Nicole Kidman','Clayton Jacobson','Yianni Warnock','Lawrence Leung','Michelle Ny','Elaine Crombie','Fayssal Bazzi','Mark Leonard Winter','Marny Kennedy','Adam Zwar','Geoff Morrell','Michelle Lim Davidson','Jenny Wu','Damon Herriman','Christopher Stollery','Liv Hewson','Robert Sharpe','Zoe Carides','Susan Prior','Charlotte Nicdao','Jacqueline Joe','Luke Buchanan','Felix Jozeps','Hoa Xuande','Madeleine Sami','Jason Perini','Deborah Jones','Andrew Beattie','Christiaan Van Vuuren','Eddie Campbell','Byron Coll','Helen Thomson','Victoria Abbott','Anthony Phelan','Marg Downey','Gavin Rutherford'],
screenplay:['Jane Campion','Gerard Lee'],
production:['Jane Campion','Iain Canning','Emile Sherman'],
music:['Mark Bradshaw'],
camera:['Adam Arkapaw','Germain McMicking'],
cut:['Alexandre de Franceschi','Scott Gray'],
sound:['Richard Flynn','Robert Mackenzie','David Lee'],
scenography:['Fiona Crombie','Annie Beauchamp','Mandi Bialek-Wester'],
masks:['Davina Lamont','Louise Harris','Noriko Watanabe'],
costumes:['Emily Seresin']},
{title:"Harry Potter and the Sorcerer's Stone",
titleCZ:'Harry Potter a Kámen mudrců',
year:2001,
runtime:152,
countries:['UK','USA'],
genres:['Fantasy','Family','Adventure','Mystery'],
director:['Chris Columbus'],
actors:['Daniel Radcliffe','Rupert Grint','Emma Watson','Robbie Coltrane','Tom Felton','Richard Harris','Fiona Shaw','Ian Hart','John Hurt','Richard Griffiths','Alan Rickman','Zoë Wanamaker','Maggie Smith','John Cleese','Geraldine Somerville','Warwick Davis','Julie Walters','Matthew Lewis','Terence Bayler','Sean Biggerstaff','Adrian Rawlins','Verne Troyer','Bonnie Wright','Oliver Phelps','James Phelps','David Bradley','Harry Melling','Elizabeth Spriggs','Leslie Phillips','Jamie Waylett','Chris Rankin','Devon Murray','Josh Herdman','Alfred Enoch','Julianne Hough','Scot Fearn','Richard Bremmer','Derek Hough','Richard Alan Reid','Ray Fearon','Luke Youngblood','Bianca Sowerby','Nina Young','Eleanor Columbus','Jimmy Vee','Stefan Pejic','Thando Walbaum','Chris Overton','Derek Deadman','Leilah Sutherland','Harry Taylor','Leila Hoffman','Oliver Lavery-Farag','Mark Ballas','Danielle Tabor','Will Theakston','Dani Harmer','Paul Grant','David Holmes'],
basedOn:['J. K. Rowling'],
screenplay:['Steve Kloves'],
production:['David Heyman'],
music:['John Williams'],
camera:['John Seale'],
cut:['Richard Francis-Bruce'],
sound:['Eddy Joseph','Rohan Taylor'],
scenography:['Stuart Craig','Andrew Ackland-Snow','Stephenie McMillan'],
masks:['Nick Dudman','Amanda Knight','Mark Coulier','Zoe Tahir'],
costumes:['Judianna Makovsky']},
{title:'Harry Potter and the Chamber of Secrets',
titleCZ:'Harry Potter a Tajemná komnata',
year:2002,
runtime:161,
countries:['UK','USA','Germany'],
genres:['Fantasy','Family','Adventure','Mystery'],
director:['Chris Columbus'],
actors:['Daniel Radcliffe','Rupert Grint','Emma Watson','Maggie Smith','Kenneth Branagh','Richard Griffiths','Alan Rickman','Richard Harris','Fiona Shaw','Robbie Coltrane','Tom Felton','Matthew Lewis','Mark Williams','John Cleese','James Phelps','Oliver Phelps','Jason Isaacs','Julie Walters','Miriam Margolyes','Christian Coulson','Sean Biggerstaff','Warwick Davis','David Bradley','Adrian Rawlins','Gemma Jones','Shirley Henderson','Robert Hardy','Julian Glover',"Peter O'Farrell",'Toby Jones','Geraldine Somerville','Harry Melling','Bonnie Wright','Louis Doyle','Leslie Phillips','Jamie Waylett','Chris Rankin','Devon Murray','Josh Herdman','Alfred Enoch','Hugh Mitchell','Jamie Yeates','Scot Fearn','Luke Youngblood','Eleanor Columbus','Alfred Burke','Sean Cronin','Jim Norton','Edward Felix Pole Tudor','Harry Taylor','Oliver Lavery-Farag','Danielle Tabor','Violet Columbus',"Chris O'Shea",'David Holmes','Sally Mortemore'],
basedOn:['J. K. Rowling'],
screenplay:['Steve Kloves'],
production:['David Heyman'],
music:['John Williams','William Ross'],
camera:['Roger Pratt'],
cut:['Peter Honess'],
sound:['Dennis Leonard','Randy Thom'],
scenography:['Stuart Craig','Andrew Ackland-Snow','Stephenie McMillan'],
masks:['Nick Dudman','Amanda Knight','Loulia Sheppard','Zoe Tahir'],
costumes:['Lindy Hemming']},
{title:'Harry Potter and the Goblet of Fire',
titleCZ:'Harry Potter a Ohnivý pohár',
year:2005,
runtime:157,
countries:['UK','USA'],
genres:['Fantasy','Family','Adventure','Drama'],
director:['Mike Newell'],
actors:['Daniel Radcliffe','Emma Watson','Rupert Grint','Robbie Coltrane','Tom Felton','Michael Gambon','Brendan Gleeson','Jason Isaacs','Alan Rickman','Maggie Smith','Stanislav Ianevski','Predrag Bjelac','Robert Pattinson','Katie Leung','Matthew Lewis','David Tennant','Mark Williams','Timothy Spall','Robert Hardy','Shirley Henderson','Gary Oldman','Clémence Poésy','Oliver Phelps','James Phelps','Bonnie Wright','Jeff Rawle','Ralph Fiennes','Miranda Richardson','Warwick Davis','Tom Goodman-Hill','Frances de la Tour','Geraldine Somerville','Louis Doyle','David Bradley','Roger Lloyd Pack','Adrian Rawlins','Eric Sykes','Alex Palmer','Jamie Waylett','Devon Murray','Josh Herdman','Alfred Enoch','Jonny Greenwood','Afshan Azad','Shefali Chowdhury','William Melling','Jarvis Cocker','Ian Whyte','Ashley Artus','Lasco Atkins','Charlotte Ritchie','Margery Mason','Robert Wilfort','Christopher Whittingham','Tolga Safer','David Sterne','Montana Manning','Greta Bellamacina','Aaron Heffernan','Jesy Nelson','Carly Houston','Tiana Benjamin','Shona Kay','Cheri Darbon'],
basedOn:['J. K. Rowling'],
screenplay:['Steve Kloves'],
production:['David Heyman'],
music:['Patrick Doyle'],
camera:['Roger Pratt'],
cut:['Mick Audsley'],
sound:['Randy Thom','Dennis Leonard','David Crozier','Tom Johnson','Michael Prestwood Smith'],
scenography:['Stuart Craig','Neil Lamont','Andrew Ackland-Snow','Stephenie McMillan'],
masks:['Amanda Knight','Nick Dudman','Mark Coulier'],
costumes:['Jany Temime']},
{title:'Harry Potter and the Order of the Phoenix',
titleCZ:'Harry Potter a Fénixův řád',
year:2007,
runtime:138,
countries:['UK','USA'],
genres:['Fantasy','Family','Adventure','Drama'],
director:['David Yates'],
actors:['Daniel Radcliffe','Rupert Grint','Emma Watson','Jason Isaacs','Tom Felton','Maggie Smith','Helena Bonham Carter','Robbie Coltrane','Ralph Fiennes','Michael Gambon','Brendan Gleeson','Richard Griffiths','Gary Oldman','Alan Rickman','Fiona Shaw','Imelda Staunton','David Thewlis','Emma Thompson','Julie Walters','Warwick Davis','Evanna Lynch','Katie Leung','Robbie Jarvis','Natalia Tena','Matthew Lewis','Geraldine Somerville','Bonnie Wright','James Phelps','Oliver Phelps','David Bradley','Mark Williams','Adrian Rawlins','Christopher Rithin','Jessica Hynes','Timothy Bateson','Robert Hardy','Simon McBurney','Timothy Spall','Jamie Waylett','Harry Melling','Chris Rankin','Arben Bajraktaraj','Devon Murray','Josh Herdman','Alfred Enoch','Afshan Azad','Shefali Chowdhury','George Harris','William Melling','Daisy Haggard','Robert Pattinson','Nicholas Blane','Lauren Shotton','Miles Jupp','Sian Thomas','Peter Roy','Jim McManus','Sam Beazley','Jason Boyd','Richard Leaf','Elliot James Langridge','Kathryn Hunter','Tony Maudsey','Michael Wildman','Grace Mandeville'],
basedOn:['J. K. Rowling'],
screenplay:['Michael Goldenberg'],
production:['David Heyman','David Barron'],
music:['Nicholas Hooper'],
camera:['Sławomir Idziak'],
cut:['Mark Day'],
sound:['James Mather','Michael Prestwood Smith','Mark Taylor','Doug Cooper','Andy Kennedy'],
scenography:['Stuart Craig','Andrew Ackland-Snow','Stephenie McMillan'],
masks:['Lynda Armstrong','Nick Dudman','Amanda Knight','Amy Byrne','Duncan Jarman','Mark Coulier','David Malinowski'],
costumes:['Jany Temime']},
{title:'Harry Potter and the Half-Blood Prince',
titleCZ:'Harry Potter a Princ dvojí krve',
year:2009,
runtime:147,
countries:['UK','USA'],
genres:['Adventure','Fantasy','Mystery','Family'],
director:['David Yates'],
actors:['Daniel Radcliffe','Rupert Grint','Emma Watson','Alan Rickman','Tom Felton','Jim Broadbent','Helena Bonham Carter','Michael Gambon','Warwick Davis','Maggie Smith','David Thewlis','Helen McCrory','Mark Williams','Robbie Coltrane','Natalia Tena','Evanna Lynch','Julie Walters','Matthew Lewis','Bonnie Wright','Geraldine Somerville','Robert Knox','Anna Shaffer','Georgina Leonidas','Isabella Laughland','Louis Cordice','Jessie Cave','Scarlett Hefner','Freddie Stroma','Hero Fiennes Tiffin','James Phelps','Oliver Phelps','David Bradley','Frank Dillane','Timothy Spall','Gemma Jones','Jamie Waylett','Devon Murray','Josh Herdman','Alfred Enoch','Afshan Azad','Shefali Chowdhury','William Melling','Dave Legeno','Elliott Francis','Elarica Johnson','Katie Leung','Paul Ritter','Ralph Ineson','Amelda Brown','Michael Thomson','Teresa Mahoney','Olivia Jewson','Sarah Alexandra Marks','Joerg Stadler'],
basedOn:['J. K. Rowling'],
screenplay:['Steve Kloves'],
production:['David Heyman','David Barron'],
music:['Nicholas Hooper'],
camera:['Bruno Delbonnel'],
cut:['Mark Day'],
sound:['James Mather'],
scenography:['Stuart Craig','Andrew Ackland-Snow','Stephenie McMillan','Rosie Goodwin'],
masks:['Nick Dudman','Amanda Knight','Amy Byrne','Mark Coulier'],
costumes:['Jany Temime']},
{title:'Harry Potter and the Deathly Hallows: Part 1',
titleCZ:'Harry Potter a Relikvie smrti - část 1',
year:2010,
runtime:140,
countries:['UK','USA'],
genres:['Adventure','Drama','Family','Fantasy'],
director:['David Yates'],
actors:['Daniel Radcliffe','Emma Watson','Rupert Grint','Ralph Fiennes','Helena Bonham Carter','Alan Rickman','Carolyn Pickles','Jason Isaacs','Bill Nighy','Bonnie Wright','Tom Felton','Clémence Poésy','Michael Gambon','John Hurt','Miranda Richardson','Rhys Ifans','Jamie Campbell Bower','Brendan Gleeson','David Thewlis','Robbie Coltrane','Domhnall Gleeson','Helen McCrory','Evanna Lynch','Warwick Davis','Timothy Spall','Julie Walters',"David O'Hara",'Rade Šerbedžija','Imelda Staunton','Toby Regbo','Nick Moran','Peter Mullan','Richard Griffiths','James Phelps','Natalia Tena','Fiona Shaw','Oliver Phelps','Toby Jones','Frances de la Tour','Geraldine Somerville','Sophie Thompson','Matthew Lewis','Mark Williams','Matyelok Gibbs','Katie Leung','Harry Melling','Freddie Stroma','Adrian Rawlins','Michael Byrne','Arben Bajraktaraj','Devon Murray','Hazel Douglas','Steffan Rhodri','Kate Fleetwood','Ian Kelly','Guy Henry','Simon McBurney','Samuel Roukin','Emil Hostina','George Harris','Michelle Fairley','William Melling','Dave Legeno','David Ryall','Sam Creed','Elliott Francis','Daisy Haggard','Ned Dennehy','Scarlett Hefner','Ralph Ineson','Andy Linden','Anthony John Crocker','Greg Bennett','Paul Warren','Daniel Tuite','Jon Campling','Adrian Annis','Graham Duff','Richard Strange','Augustina Amoa','Jessie Cave','Isabella Laughland','Stanislav Ianevski','Daniel Hill','Charlotte Atkinson','Afshan Azad','Ashley McGuire','Georgina Leonidas','Matthew Steer','Simon Britton'],
basedOn:['J. K. Rowling'],
screenplay:['Steve Kloves'],
production:['J. K. Rowling','David Heyman','David Barron'],
music:['Alexandre Desplat'],
camera:['Eduardo Serra'],
cut:['Mark Day'],
sound:['James Mather','Dominic Gibbs','Michael Fentum'],
scenography:['Stuart Craig','Andrew Ackland-Snow','Stephenie McMillan'],
masks:['Nick Dudman','Amanda Knight','Amy Byrne','Tristan Versluis','Duncan Jarman','Mark Coulier','Pamela Goldammer','Barrie Gower'],
costumes:['Jany Temime']},
{title:'Twilight',
titleCZ:'Stmívání',
year:2008,
runtime:117,
countries:['USA'],
genres:['Adventure','Drama','Fantasy','Romance'],
director:['Catherine Hardwicke'],
actors:['Kristen Stewart','Robert Pattinson','Billy Burke','Peter Facinelli','Elizabeth Reaser','Cam Gigandet','Ashley Greene','Christian Serratos','Anna Kendrick','Nikki Reed','Taylor Lautner','Kellan Lutz','Jackson Rathbone','Michael Welch','Gil Birmingham','Justin Chon','Rachelle Lefevre','Edi Gathegi','Sarah Clarke','Ned Bellamy','Stephenie Meyer','Trish Egan','José Zúñiga','Tanaya Beatty','Sean McGrath','Ayanna Berkshire','Hunter Jackson','Matt Bushell','Steve Ellery','Gregory Tyree Boyce','Jimmy Star'],
basedOn:['Stephenie Meyer'],
screenplay:['Melissa Rosenberg'],
production:['Wyck Godfrey','Greg Mooradian','Mark Morgan'],
music:['Carter Burwell'],
camera:['Elliot Davis'],
cut:['Nancy Richardson'],
sound:['Frank Gaeta','Marshall Garlington','Gabriel J. Serrano'],
scenography:['Gene Serdena'],
masks:['Mary Ann Valdes'],
costumes:['Wendy Chuck']},
{title:'The Twilight Saga: Eclipse',
titleCZ:'Twilight sága: Zatmění',
year:2010,
runtime:119,
countries:['USA'],
genres:['Adventure','Drama','Fantasy','Romance'],
director:['David Slade'],
actors:['Kristen Stewart','Robert Pattinson','Taylor Lautner','Ashley Greene','Peter Facinelli','Jackson Rathbone','Kellan Lutz','Nikki Reed','Bryce Dallas Howard','Sarah Clarke','Dakota Fanning','Elizabeth Reaser','Jack Huston','Billy Burke','Jodelle Ferland','Gil Birmingham','Catalina Sandino Moreno','Booboo Stewart','Christian Serratos','Charlie Bewley','Xavier Samuel','Chaske Spencer','Alex Meraz','Kiowa Gordon','Bronson Pelletier','Anna Kendrick','Julia Jones','Cameron Bright','Tinsel Korey','Daniel Cudmore','Alex Rice','Tyson Houseman','Michael Welch','Justin Chon','Leah Gibson','Justin Rain','Monique Ganderton','Mariel Belanger','Paul Jarrett','Cainan Wiebe','Jimmy Star','Iris Quinn','Dawn Chubai','William Belleau'],
basedOn:['Stephenie Meyer'],
screenplay:['Melissa Rosenberg'],
production:['Wyck Godfrey','Karen Rosenfelt'],
music:['Howard Shore'],
camera:['Javier Aguirresarobe'],
cut:['Nancy Richardson','Art Jones'],
sound:['Marshall Garlington'],
scenography:['Paul D. Austerberry','Rose Marie McSherry'],
masks:['Charles Porlier','Céline Godeau'],
costumes:['Tish Monaghan']},
{title:'The Twilight Saga: New Moon',
titleCZ:'Twilight sága: Nový měsíc',
year:2009,
runtime:125,
countries:['USA'],
genres:['Adventure','Drama','Fantasy','Romance'],
director:['Chris Weitz'],
actors:['Robert Pattinson','Kristen Stewart','Taylor Lautner','Jackson Rathbone','Nikki Reed','Kellan Lutz','Ashley Greene','Peter Facinelli','Billy Burke','Jamie Campbell Bower','Edi Gathegi','Elizabeth Reaser','Michael Sheen','Christopher Heyerdahl','Charlie Bewley','Graham Greene','Anna Kendrick','Michael Welch','Tinsel Korey','Gil Birmingham','Cameron Bright','Justin Chon','Noot Seear','Christian Serratos','Dakota Fanning','Kiowa Gordon','Chaske Spencer','Alex Meraz','Bronson Pelletier','Justine Wachsberger','Rachelle Lefevre','Daniel Cudmore','Tyson Houseman','Michael Adamthwaite','Sean McGrath','Russell Roberts','Hunter Jackson','Christina Jastrzembska','Curtis Caravaggio','Justin Shenkarow','Adrien Dorval','Jimmy Star'],
basedOn:['Stephenie Meyer'],
screenplay:['Melissa Rosenberg'],
production:['Wyck Godfrey','Kerry Kohansky-Roberts','Karen Rosenfelt'],
music:['Alexandre Desplat'],
camera:['Javier Aguirresarobe'],
cut:['Peter Lambert'],
sound:['Chris Carpenter','Andy Koyama'],
scenography:['David Brisbin','Lesley Beale','Susanna Codognato'],
masks:['Norma Hill-Patton','Tanya Hudson'],
costumes:['Tish Monaghan']},
{title:'The Twilight Saga: Breaking Dawn - Part 2',
titleCZ:'Twilight sága: Rozbřesk - 2. část',
year:2012,
runtime:115,
countries:['USA'],
genres:['Adventure','Drama','Fantasy','Romance'],
director:['Bill Condon'],
actors:['Kristen Stewart','Robert Pattinson','Maggie Grace','Taylor Lautner','Dakota Fanning','Ashley Greene','Jackson Rathbone','Kellan Lutz','Nikki Reed','Peter Facinelli','Elizabeth Reaser','Billy Burke','Booboo Stewart','Michael Sheen','Jamie Campbell Bower','Christopher Heyerdahl','Cameron Bright','Chaske Spencer','Julia Jones','Daniel Cudmore','Charlie Bewley','Tinsel Korey','Christian Camargo','Rami Malek','MyAnna Buring','Bronson Pelletier','Mía Maestro','Andrea Gabriel','Noel Fisher','Lateef Crowder','JD Pardo','Amanda Dyar','Joe Anderson','Mackenzie Foy','Kiowa Gordon','Lee Pace','Valorie Curry','Casey LaBow','Tracey Heggins','Judith Shekoni','Bill Tangradi','Jodelle Ferland','Tyler Forrest','Guri Weinberg','Omar Metwally','Patrick Brennan','Christie Burke','Christian Serratos','Angela Sarafyan','Toni Trucks','Sonnie Trotter','Paul Becker','John Edward Lee','Travis Hedges Williams','Milli Wilkinson','Marisa Quintanilla','Taylor Dianne Robinson','Angelo Renai'],
basedOn:['Stephenie Meyer'],
screenplay:['Melissa Rosenberg'],
production:['Wyck Godfrey','Karen Rosenfelt'],
music:['Carter Burwell','Jo Blankenburg'],
camera:['Guillermo Navarro'],
cut:['Virginia Katz','Ian Slater'],
sound:['Michael Minkler','Tony Lamberti'],
scenography:['Richard Sherman','David Schlesinger'],
masks:['Andrea Bowman','Jean Ann Black','Remi Savva','Stacey Herbert','Jack Lazzaro'],
costumes:['Michael Wilkinson']},
{title:'The Twilight Saga: Breaking Dawn - Part 1',
titleCZ:'Twilight sága: Rozbřesk - 1. část',
year:2011,
runtime:112,
countries:['USA'],
genres:['Adventure','Drama','Fantasy','Romance'],
director:['Bill Condon'],
actors:['Kristen Stewart','Robert Pattinson','Peter Facinelli','Kellan Lutz','Ashley Greene','Jackson Rathbone','Nikki Reed','Taylor Lautner','Elizabeth Reaser','Maggie Grace','Anna Kendrick','MyAnna Buring','Booboo Stewart','Michael Welch','Rami Malek','Christian Camargo','Mía Maestro','Christian Serratos','Billy Burke','Sarah Clarke','Julia Jones','Alex Meraz','Gil Birmingham','Kiowa Gordon','Justin Chon','Chaske Spencer','Bronson Pelletier','Tinsel Korey','Andrea Gabriel','Noel Fisher','Alex Rice','Stephenie Meyer','Tyson Houseman','Mackenzie Foy','Kimani Ray Smith','Jamie Campbell Bower','Michael Sheen','Casey LaBow','Ali Faulkner','Stephanie Moseley','Christie Burke','Paul Becker','Ian Harmon','Christian Sloan','Gabriel Carter','James Pizzinato','Angelo Renai'],
basedOn:['Stephenie Meyer'],
screenplay:['Melissa Rosenberg'],
production:['Wyck Godfrey','Karen Rosenfelt'],
music:['Carter Burwell','Jo Blankenburg'],
camera:['Guillermo Navarro'],
cut:['Virginia Katz'],
sound:['Michael Minkler','Tony Lamberti'],
scenography:['Richard Sherman','David Schlesinger'],
masks:['Sara Michael','Jean Ann Black','Fay von Schroeder','Brian Sipe','Arjen Tuiten','Remi Savva','Stacey Herbert','Krystal Kershaw','Jack Lazzaro'],
costumes:['Michael Wilkinson']},
{title:'Twilight',
titleCZ:'Zajatci mlhy',
year:2005,
runtime:100,
countries:['Russia','Germany'],
genres:['Drama','War'],
director:['Arťom Antonov'],
actors:['Jurij Tarasov','Anastasija Ševeljova','Lidija Bajraševskaja','Kolja Spiridonov','Martin Jackowski','Dmitrij Averin','Vitalij Kovalenko','Michail Solovjov','Natalja Burmistrova','Sergej Losev','Alexandr Ronis','Alexandr Balsanov','Jevgenij Merkurjev','Alexandr Martynov','Axel Schrick','Oleg Kulikovič','Grigorij Danciger','Alexandr Sťopin','Margarita Ivanova','Christian Sengewald','Kira Krejlis-Petrova','Pjotr Koroljov','Anatolij Gorin','Vladimir Kolesnikov','Arsenij Vorobjov','Johannes Rapp','Ljubov Povolockaja'],
screenplay:['Viktor Smirnov'],
production:['Alexandr Rodňanskij'],
camera:['Andrej Vorobjov']},
{title:'Nobody',
titleCZ:'Nikdo',
year:2021,
runtime:92,
countries:['USA','Japan'],
genres:['Action','Crime','Thriller','Drama'],
director:['Ilja Najšuller'],
actors:['Bob Odenkirk','Alexej Serebrjakov','Connie Nielsen','Christopher Lloyd','Michael Ironside','Colin Salmon','RZA','Billy MacLellan','Araya Mengesha','Gage Munroe','Paisley Cadorath','Alexandr Pal','Humberly González','Edsson Morales','J.P. Manoux','Ilja Najšuller','Sergej Šnurov','Stephanie Sy','Dan Skene','BJ Verot','Margaryta Soldatova','Darja Čaruša','Paul Essiembre','Adam Hurtig','Gabriel Daniels','Kristen Harris','Erik Athavale','Neven Pajkic','Rick Dobran','Sharon Bajer','Daniel Bernhardt','Alain Moussi','Tyrell Witherspoon','Meghan Gardiner','Megan Best','Yulia Guzhva','Eugene Baffoe'],
screenplay:['Derek Kolstad'],
production:['David Leitch','Braden Aftergood','Bob Odenkirk','Kelly McCormick','Marc Provissiero'],
music:['David Buckley'],
camera:['Pawel Pogorzelski'],
cut:['William Yeh','Evan Schiff'],
sound:['Frank A. Montaño','Oleg Kulchytskyi','Mark P. Stoeckinger','Jon Taylor'],
scenography:['Roger Fires','Sara McCudden'],
costumes:['Patricia J. Henderson']},
{title:'Terminator 3: Rise of the Machines',
titleCZ:'Terminátor 3: Vzpoura strojů',
year:2003,
runtime:109,
countries:['USA','Germany','UK'],
genres:['Sci-Fi','Action','Thriller'],
director:['Jonathan Mostow'],
actors:['Arnold Schwarzenegger','Nick Stahl','Claire Danes','Kristanna Loken','David Andrews','Mark Famiglietti','Earl Boen','Mark Hicks','Carolyn Hennesy','Jay Acovone','M.C. Gainey','Elizabeth Morehead','Jon Foster','Michael Papajohn','Timothy Dowling','Poppi Monroe','Matt Gerald','Chris Hardwick',"William O'Leary",'Christopher Lawford','Rick Zieff','Kim Robillard','Moira Sinise','Susan Merson','Rebecca Tilney','Helen Eigenberg','Alana Curry','Walter von Huene'],
screenplay:['Michael Ferris','John Brancato'],
production:['Joel B. Michaels','Hal Lieberman','Colin Wilson','Andrew G. Vajna'],
music:['Marco Beltrami'],
camera:['Don Burgess'],
cut:['Neil Travis','Nicolas De Toth'],
sound:["Kevin O'Connell",'Greg P. Russell'],
scenography:['Jeff Mann','Jay Hart'],
masks:['Jeff Dawn','Steve La Porte','Arjen Tuiten','Mark Landon'],
costumes:['April Ferry','Donna Marcione Pollack']},
{title:'Terminator Salvation',
titleCZ:'Terminator Salvation',
year:2009,
runtime:110,
countries:['USA','Germany','UK','Italy'],
genres:['Sci-Fi','Action','Thriller'],
director:['McG'],
actors:['Christian Bale','Anton Yelchin','Moon Bloodgood','Sam Worthington','Common','Bryce Dallas Howard','Helena Bonham Carter','Roland Kickinger','Jane Alexander','Michael Ironside','Terry Crews','Jadagrace',"Ivan G'Vera",'Emerson Brooks','Brian Steele','Michael Papajohn','Greg Serano','Paul J. Porter','Diego Joaquin Lopez','Chris Ashworth','Dylan Kenin','Zach McGowan','Chris Browning','Treva Etienne','Greg Plitt','Kevin Wiggins','Boots Southerland','Beth Bailey','Isaac Kappy','Rafael Herrera','Maria Bethke','Omar Paz Trujillo','David Douglas','Esodie Geiger','Joe Basile','Babak Tafti','Frank Powers'],
screenplay:['Michael Ferris','John Brancato'],
production:['Moritz Borman','Jeffrey Silver'],
music:['Danny Elfman'],
camera:['Shane Hurlbut'],
cut:['Conrad Buff IV'],
sound:['Ai-Ling Lee','Ron Bartlett','Doug Hemphill','Paul N.J. Ottosson','Mark Ulano'],
scenography:['Martin Laing','Victor J. Zolfo'],
masks:['Edward French','Mike Smithson','Brian Sipe','Arjen Tuiten'],
costumes:['Michael Wilkinson']},
{title:'Zombieland',
titleCZ:'Zombieland',
year:2009,
runtime:88,
countries:['USA'],
genres:['Comedy','Horror','Sci-Fi','Adventure'],
director:['Ruben Fleischer'],
actors:['Jesse Eisenberg','Woody Harrelson','Emma Stone','Abigail Breslin','Amber Heard','Bill Murray','Derek Graf','Jacob G. Akins','Hunter Aldridge','Elle Alexander','Michael August','Melanie Booth','Daniel Burnley','Chris Burns','Dalton Cole','Blaise Corrigan','Ernest Dancy','Anthony J. Davis','Travis Grant','Robert Hatch','John C. Reilly','Barry Hopkins','Steve Warren','Victory Van Tuyl','Jannette Sepwa'],
screenplay:['Rhett Reese','Paul Wernick'],
production:['Gavin Polone'],
music:['David Sardy'],
camera:['Michael Bonvillain'],
cut:['Alan Baumgarten'],
sound:['Tateum Kohut','Greg Orloff','Sean McCormack','Mary H. Ellis'],
scenography:['Maher Ahmad','Gene Serdena'],
masks:['Tony Gardner','Jamie Kelman','Rachel Kick'],
costumes:['Magali Guidasci']},
{title:'Zombieland: Double Tap',
titleCZ:'Zombieland: Rána jistoty',
year:2019,
runtime:99,
countries:['USA'],
genres:['Action','Comedy','Horror'],
director:['Ruben Fleischer'],
actors:['Jesse Eisenberg','Woody Harrelson','Emma Stone','Abigail Breslin','Zoey Deutch','Rosario Dawson','Avan Jogia','Luke Wilson','Thomas Middleditch','Bill Murray','Dan Aykroyd','Ian Gregg','Rachel Luttrell','Julia Vasi','Al Roker','Jessica Medina','Victor Rivera','Sergio Briones'],
screenplay:['Rhett Reese','Paul Wernick','Dave Callaham'],
production:['Gavin Polone'],
music:['David Sardy'],
camera:['Jung-hoon Jung'],
cut:['Dirk Westervelt','Chris Patterson'],
sound:["Kevin O'Connell",'Will Files'],
scenography:['Martin Whist','Claudia Bonfe'],
masks:['Tony Gardner','Bill Corso','Mary Flaa','Missy Lisenby','Thomas Floutz'],
costumes:['Christine Wada']},
{title:'I Am Legend',
titleCZ:'Já, legenda',
year:2007,
runtime:101,
countries:['USA'],
genres:['Drama','Sci-Fi','Thriller','Horror'],
director:['Francis Lawrence'],
actors:['Will Smith','Alice Braga','Charlie Tahan','Salli Richardson-Whitfield','Willow Smith','Darrell Foster','April Grace','Dash Mihok','Steve Cirbus','Emma Thompson','Mike Patton','Marin Ireland','Troy Faruk','Caitlin McHugh','Alexander DiPersia','Don Money','Mark Steger','Drew Leary','Jack Caruso','Kimberly Shannon Murphy','James McCauley','Okwui Okpokwasili'],
basedOn:['Richard Matheson'],
screenplay:['Mark Protosevich','Akiva Goldsman','Joyce Hooper Corrington','John William Corrington'],
production:['Neal H. Moritz','David Heyman','James Lassiter'],
music:['James Newton Howard'],
camera:['Andrew Lesnie'],
cut:['Wayne Wahrman'],
sound:['Skip Lievsay','Tod A. Maitland'],
scenography:['Naomi Shohan','David Lazan','George DeTitta Jr.'],
masks:['Mark Rappaport','Michael Marino','Patrick Baxter','Tomasina Smith','Lufeng Qu'],
costumes:['Michael Kaplan']},
{title:'Strays',
titleCZ:'Vocasy na tripu',
year:2023,
runtime:93,
countries:['USA'],
genres:['Comedy'],
director:['Josh Greenbaum'],
actors:['Will Ferrell','Jamie Foxx','Isla Fisher','Randall Park','Will Forte','Brett Gelman','Rob Riggle','Josh Gad','Sofía Vergara','Jamie Demetriou','Greta Lee','Jimmy Tatro','Harvey Guillén','Phil Morris','David Herman','Charity Cervantes','Jade Fernandez','Mike Dolphy','Aven Lotz','Hannah Alline','Garrett Hines','Dan Perrault','Dennis Quaid','Keith Brooks','Hedy Nasser','Gabriella Garcia','Andrea Laing','Alexandra Ficken','Ryan Dinning','Tinashe Kajese'],
screenplay:['Dan Perrault'],
production:['Erik Feig','Josh Greenbaum','Louis Leterrier','Phil Lord','Christopher Miller','Dan Perrault','Aditya Sood'],
music:['Dara Taylor'],
camera:['Tim Orr'],
cut:['Greg Hayden'],
sound:['Beau Borders'],
scenography:['Aaron Osborne'],
masks:['Katie Ballard'],
costumes:['Romy Itzigsohn']},
{title:'Red Notice',
titleCZ:'Red Notice',
year:2021,
runtime:117,
countries:['USA'],
genres:['Action','Comedy','Crime','Thriller'],
director:['Rawson Marshall Thurber'],
actors:['Dwayne Johnson','Ryan Reynolds','Gal Gadot','Ritu Arya','Chris Diamantopoulos','Vincenzo Amato','Alexander Perkins','Daniel Bernhardt','Ethan Herschenfeld','Ed Sheeran','Ivan Mbakop','Seth Michaels','Guy Nardulli','Rawson Marshall Thurber','Tom Choi','Nick Arapoglou','Robert Tinsley','Robert Clotworthy','Brenna Marie Narayan','Martin Harris','Rafael Petardi','George Tsai'],
screenplay:['Rawson Marshall Thurber'],
production:['Hiram Garcia','Dany Garcia','Rawson Marshall Thurber','Beau Flynn','Dwayne Johnson'],
music:['Steve Jablonsky'],
camera:['Markus Förderer'],
cut:['Michael L. Sale','Julian Clarke'],
sound:["Kevin O'Connell",'Tony Lamberti','Sean McCormack','David Werntz','Mary H. Ellis'],
scenography:['Andy Nicholson','Larry Dias'],
masks:['Vivian Baker','Björn Rehbein','Luisa Abel','Adruitha Lee'],
costumes:['Mary E. Vogt']},
{title:'No Hard Feelings',
titleCZ:'Nic ve zlým',
year:2023,
runtime:104,
countries:['USA'],
genres:['Comedy'],
director:['Gene Stupnitsky'],
actors:['Jennifer Lawrence','Andrew Barth Feldman','Danielia Maximillian','Ebon Moss-Bachrach','Natalie Morales','Matthew Broderick','Hasan Minhaj','Laura Benanti','Scott MacArthur','Kyle Mooney','Quincy Dunn-Baker','Victor Verhaeghe','Amalia Yoo','Matt Walton','Ari Frenkel','Jordan Mendoza','Christina Catechis','Zahn McClarnon'],
screenplay:['John Phillips','Gene Stupnitsky'],
production:['Jennifer Lawrence','Alex Saks','Naomi Odenkirk','Marc Provissiero'],
music:['Mychael Danna','Jessica Weiss'],
camera:['Eigil Bryld'],
cut:['Brent White'],
sound:['Josh Berger','Dane Lonsdale'],
scenography:['Russell Barnes'],
masks:['Sarah Graalman','Robert Lugo','Andrea Miller'],
costumes:['Kirston Leigh Mann']},
{title:'Bodies Bodies Bodies',
titleCZ:'Hádej, kdo je vrah',
year:2022,
runtime:95,
countries:['USA'],
genres:['Horror','Comedy'],
director:['Halina Reijn'],
actors:['Amandla Stenberg','Maria Bakalova','Lee Pace','Pete Davidson','Rachel Sennott',"Myha'la",'Chase Sui Wonders'],
screenplay:['Sarah DeLappe','Kristen Roupenian','Chloe Okuno'],
production:['David Hinojosa'],
camera:['Jasper Wolf'],
cut:['Taylor Levy','Julia Bloch'],
sound:['Dimitri Kouri'],
scenography:['April Lasky','Elise H. Clark-Johnson'],
masks:['Sarah Graalman'],
costumes:['Katina Danabassis']},
{title:'Midsommar',
titleCZ:'Slunovrat',
year:2019,
runtime:'Alternativní 142 min',
countries:['USA','Sweden'],
genres:['Drama','Horror','Mystery'],
director:['Ari Aster'],
actors:['Florence Pugh','Jack Reynor','Will Poulter','William Jackson Harper','Vilhelm Blomgren','Julia Ragnarsson','Björn Andrésen','Archie Madekwe','Anna Åström','Henrik Norlén','Liv Mjönes','Louise Peterhoff','Ellora Torchia','Gunnel Fred','Isabelle Grill','Anki Larsson','Lars Väringer','Mats Blomgren','Tove Skeidsvoll','Anders Beckman','Rebecka Johnston','Hampus Hallberg','Anders Back','Katarina Weidhagen','Anna Berentz','Agnes Rase'],
screenplay:['Ari Aster'],
production:['Patrik Andersson','Lars Knudsen'],
music:['Bobby Krlic'],
camera:['Pawel Pogorzelski'],
cut:['Lucian Johnston'],
sound:['Ric Schnupp','Zsolt Magyar'],
scenography:['Henrik Svensson'],
masks:['Brigitta Mogony'],
costumes:['Andrea Flesch']},
{title:'Sisu',
titleCZ:'Sisu',
year:2022,
runtime:91,
countries:['Sweden','UK'],
genres:['Action','War'],
director:['Jalmari Helander'],
actors:['Jorma Tommila','Aksel Hennie','Jack Doolan','Mimosa Willamo','Onni Tommila','Arttu Kapulainen','Tatu Sinisalo','Vincent Willestrand','Wilhelm Enckell','Elina Saarela','Ilkka Koivula','Max Ovaska','Joel Hirvonen','Pekka Huotari','Severi Saarinen','Aamu Milonoff','Jukka Virtanen','Joonas Brilli','Nicholas Francett','Kevin Francett','Eemeli Franssi','Jussi Kaila','Jarkko Klemetti','Henri Koljonen','Pekka Laakso','Martti Näätä Leinonen','Joosua Oja','Pietari Paappanen','Oskari Skyttä','Tomi Lampinen','Mila Leppälä','Jasmi Mäenpää','Nora Nevia','Jenna Tyni','Anssi-Pekka Fredriksson','Jarmo Hietamäki','Veli-Matti Mikkonen','Akseli Hakovirta','Juho-Lauri Hakovirta','Iisko Hirvasvuopio','Sakari Maliniemi','Jukka Vuorela','Ari Joki','Nikita Makkojev','Jasmin Valjas','Linnea Vilppunen','Hannu Anttila','Mario Esposito','Tarmo Hassinen','Miia Heikkinen','Kimmo Henriksson','Arto Kairajärvi','Risto Korhonen','Mirva Korvala','Steven Madlin','Annika Moisio','Tommi Pelkonen','Arto Peltomäki','Leena Sormunen','Pekka Virkkunen','Julia Malmsten'],
screenplay:['Jalmari Helander'],
production:['Petri Jokiranta'],
music:['Juri Seppä','Tuomas Wäinölä'],
camera:['Kjell Lagerroos'],
cut:['Juho Virolainen'],
sound:['Panu Riikonen'],
scenography:['Otso Linnalaakso'],
masks:['Salla Yli-Luopa','Clara Bourgeot'],
costumes:['Anna Vilppunen']},
{title:'1917',
titleCZ:'1917',
year:2019,
runtime:119,
countries:['USA','UK'],
genres:['Drama','War'],
director:['Sam Mendes'],
actors:['George MacKay','Dean-Charles Chapman','Colin Firth','Benedict Cumberbatch','Mark Strong','Andrew Scott','Richard Madden','Adrian Scarborough','Anson Boon','Tommy French','Nabhaan Rizwan','Daniel Mays','Pip Carter','Gerran Howell','John Hollingworth','Billy Postlethwaite','Josef Davies','Spike Leighton','Jamie Parker','Robert Maaser','Jack Shalloo','Elliot Edusah','Chris Walley','Michael Jibson','Richard McCabe','Richard Dempsey','Phil Cheadle','Merlin Leonhardt','Bogdan Kumšackij','Josh Turner','Jacob James Beswick','Michael Rouse','Claire Duburcq','Adam Hugill','Taddeo Kufus','Bradley Riches'],
screenplay:['Sam Mendes','Krysty Wilson-Cairns'],
production:['Sam Mendes','Brian Oliver','Callum McDougall','Jayne-Ann Tenggren','Pippa Harris'],
music:['Thomas Newman'],
camera:['Roger Deakins'],
cut:['Lee Smith'],
sound:['Oliver Tarney','Michael Fentum','Mark Taylor','James Harrison','Scott Millan'],
scenography:['Dennis Gassner','Lee Sandales','Stephen Swain','Simon Elsley'],
masks:['Naomi Donne','Tristan Versluis','Rebecca Cole','Heather Manson','Norma Webb','Doone Forsyth'],
costumes:['Jacqueline Durran']},
{title:'Ant-Man and the Wasp: Quantumania',
titleCZ:'Ant-Man a Wasp: Quantumania',
year:2023,
runtime:125,
countries:['USA'],
genres:['Action','Adventure','Comedy'],
director:['Peyton Reed'],
actors:['Paul Rudd','Evangeline Lilly','Michael Douglas','Michelle Pfeiffer','Jonathan Majors','Kathryn Newton','Corey Stoll','Bill Murray',"Katy M. O'Brian",'William Jackson Harper','Jamie Andrew Cutler','David Dastmalchian','Randall Park','Ross Mullan','Ruben Rabasa','Tom Hiddleston','Owen Wilson','Gregg Turkington','Mark Weinman','Milton Lopes','Jake Millgard'],
basedOn:['Jack Kirby'],
screenplay:['Jeff Loveness'],
production:['Kevin Feige','Stephen Broussard'],
music:['Christophe Beck'],
camera:['Bill Pope'],
cut:['Adam Gerstel','Laura Jennings'],
scenography:['Will Htay','Richard Roberts'],
masks:['Tonee Roberio'],
costumes:['Sammy Sheldon Differ']},
{title:'Ant-Man and the Wasp',
titleCZ:'Ant-Man a Wasp',
year:2018,
runtime:118,
countries:['USA'],
genres:['Action','Sci-Fi','Adventure','Comedy'],
director:['Peyton Reed'],
actors:['Paul Rudd','Evangeline Lilly','Michael Douglas','Michelle Pfeiffer','Michael Peña','Walton Goggins','Hannah John-Kamen','Laurence Fishburne','Bobby Cannavale','Judy Greer','David Dastmalchian','T.I.','Randall Park','Abby Ryder Fortson','Goran Kostič','Sean Kleier','Michael Cerveris','Riann Steele','Hayley Lovitt','Madeleine McGraw','Tim Heidecker','Stan Lee','Henry Kingi','Derek Crowe','Divian Ladwa','Rob Archer','Virginia Hamilton','Jake Hanson','Mika Kubo','Robert Tinsley','Langston Fishburne','Chris Gann','William W. Barbour','Debra Norton-Miller','Linda Joy Henry','Jon Wurster','Marcella Bragio','Darcy Shean','Sergio Briones'],
basedOn:['Stan Lee','Jack Kirby','Larry Lieber'],
screenplay:['Erik Sommers','Paul Rudd','Andrew Barrer','Gabriel Ferrari','Chris McKenna'],
production:['Kevin Feige','Stephen Broussard'],
music:['Christophe Beck'],
camera:['Dante Spinotti'],
cut:['Dan Lebental','Craig Wood'],
sound:['Gary Summers','Juan Peralta','Addison Teague','Katy Wood','Tom Johnson'],
scenography:['Shepherd Frankel','Clint Wallace','Calla Klessig','Gene Serdena'],
masks:['Stephan Dupuis',"Valli O'Reilly",'Heba Thorisdottir','Seidah Nichols','Björn Rehbein','Darlene Brumfield'],
costumes:['Louise Frogley']},
{title:'Ant-Man',
titleCZ:'Ant-Man',
year:2015,
runtime:117,
countries:['USA'],
genres:['Action','Sci-Fi','Adventure','Comedy'],
director:['Peyton Reed'],
actors:['Paul Rudd','Michael Douglas','Evangeline Lilly','Corey Stoll','Michael Peña','Bobby Cannavale','Judy Greer','John Slattery','Joe Chrest','Wood Harris','T.I.','David Dastmalchian','Martin Donovan','Hayley Atwell','Kourtney Shales','Zack Duhame','Jordi Mollà','Rod Hallett','Marie Joelyn','Vanessa Ross','Shaker Sangam','Abby Ryder Fortson','Stan Lee','Gregg Turkington','Anthony Mackie','Sebastian Stan','Chris Evans','Anna Akana','Neko Parham','Rus Blackwell','Brian Danker','Carlos Aviles','Christina July Kim','Ed Moy','Jeremy Ray Taylor','Jessejames Locorriere','Kylen Davis','Hayley Lovitt','Zamani Wilder','Danny Vasquez','Lyndsi LaRose','Erik Betts','Andrew Koponen','Debra Norton-Miller','Walter Hendrix III','Erick Wofford','Kevin Lacz','Mike Benitez','Raul Colon','Bradley Bowen','Reuben Langdon',"Alphonso A'Qen-Aten Jackson",'Jason Shwartz','Leilani Amour Arenzana'],
basedOn:['Stan Lee','Jack Kirby','Larry Lieber'],
screenplay:['Joe Cornish','Edgar Wright','Adam McKay','Paul Rudd'],
production:['Kevin Feige','Brad Winderbaum'],
music:['Christophe Beck'],
camera:['Russell Carpenter'],
cut:['Dan Lebental','Colby Parker Jr.'],
sound:['Juan Peralta','Daniel Laurie','Shannon Mills','Tom Johnson'],
scenography:['Shepherd Frankel','Marcus Rowland'],
masks:['Stephan Dupuis','Heba Thorisdottir','Greg Funk'],
costumes:['Sammy Sheldon Differ']},
{title:'The Lego Movie',
titleCZ:'LEGO® příběh',
year:2014,
runtime:100,
countries:['USA','Denmark','Australia'],
genres:['Animation','Action','Adventure','Comedy','Family','Fantasy'],
director:['Phil Lord','Christopher Miller'],
actors:['Chris Pratt','Elizabeth Banks','Channing Tatum','Morgan Freeman','Liam Neeson','Will Ferrell','Alison Brie','Charlie Day','Will Arnett','Nick Offerman','Jonah Hill','Keegan-Michael Key','Cobie Smulders','Billy Dee Williams','Jorma Taccone',"Shaquille O'Neal",'Will Forte','Dave Franco','Keith Ferguson','Anthony Daniels','Jake Johnson','Christopher Miller','David Burrows','Chris McKay','Jadon Sand'],
screenplay:['Phil Lord','Christopher Miller'],
production:['Roy Lee','Dan Lin'],
music:['Mark Mothersbaugh'],
camera:['Barry Peterson','Pablo Plaisted'],
cut:['David Burrows'],
sound:['Gregg Rudloff'],
scenography:['Grant Freckelton']},
{title:'The Lego Movie 2: The Second Part',
titleCZ:'LEGO® příběh 2',
year:2019,
runtime:107,
countries:['USA','Denmark','Australia'],
genres:['Animation','Action','Adventure','Comedy','Family','Fantasy','Musical'],
director:['Mike Mitchell'],
actors:['Chris Pratt','Elizabeth Banks','Will Arnett','Tiffany Haddish','Stephanie Beatriz','Alison Brie','Nick Offerman','Charlie Day','Maya Rudolph','Will Ferrell','Jadon Sand','Brooklynn Prince','Channing Tatum','Jonah Hill','Richard Ayoade','Ben Schwartz','Noel Fielding','Jason Momoa','Cobie Smulders','Ike Barinholtz','Ralph Fiennes','Will Forte','Jimmy O. Yang','Jorma Taccone','Bruce Willis','Mike Mitchell','Christopher Miller','Chris McKay','Trisha Gum','Margot Rubin'],
screenplay:['Phil Lord','Christopher Miller'],
production:['Phil Lord','Christopher Miller','Dan Lin','Roy Lee','Jinko Gotoh'],
music:['Mark Mothersbaugh'],
cut:['Clare Knight'],
sound:['Gary Summers','Nathan Nance','Ethan Van der Ryn','Michael Semanick'],
scenography:['Patrick Marc Hanenberger'],
masks:['Naomi Bakstad','Megan Harkness'],
costumes:['Caroline Cranstoun']},
{title:'Borat: Cultural Learnings of America for Make Benefit Glorious Nation of Kazakhstan',
titleCZ:'Borat: Nakoukání do amerycké kultůry na obědnávku slavnoj kazašskoj národu',
year:2006,
runtime:84,
countries:['USA'],
genres:['Comedy'],
director:['Larry Charles'],
actors:['Sacha Baron Cohen','Ken Davitian','Luenell','Pamela Anderson'],
screenplay:['Sacha Baron Cohen','Anthony Hines','Peter Baynham','Dan Mazer'],
production:['Sacha Baron Cohen','Jay Roach'],
music:['Erran Baron Cohen'],
camera:['Anthony Hardwick','Luke Geissbühler'],
cut:['Peter Teschner','James Thomas','Craig Alpert'],
sound:['Andrew DeCristofaro','Lora Hirschberg','Brandon Proctor'],
costumes:['Jason Alper']},
{title:'Borat Subsequent Moviefilm: Delivery of Prodigious Bribe to American Regime for Make Benefit Once Glorious Nation of Kazakhstan',
titleCZ:'Boratův navázaný telefilm',
year:2020,
runtime:96,
countries:['USA'],
genres:['Comedy'],
director:['Jason Woliner'],
actors:['Sacha Baron Cohen','Maria Bakalova','Rudy Giuliani','Tom Hanks','Jason Woliner','Rita Wilson','Mike Pence','Stephen Stanton','Anis Doroftei'],
screenplay:['Sacha Baron Cohen','Anthony Hines','Nina Pedrad','Dan Swimer','Erica Rivinoja','Jena Friedman','Peter Baynham','Lee Kern'],
production:['Sacha Baron Cohen','Anthony Hines','Monica Levinson'],
music:['Erran Baron Cohen'],
camera:['Luke Geissbühler'],
cut:['Craig Alpert','James Thomas','Michael Giambra'],
sound:['Alessio Masi','Lora Hirschberg'],
scenography:['David Saenz de Maturana','Vraciu Eduard Daniel','Bryan Walior','Silvia Nancu'],
masks:["Peter 'Swords' King",'Mark Coulier','Anne Morgan','Katy Fray'],
costumes:['Erinn Knight']},
{title:'Guardians of the Galaxy Vol. 2',
titleCZ:'Strážci Galaxie Vol. 2',
year:2017,
runtime:136,
countries:['USA','New Zealand','Canada'],
genres:['Action','Adventure','Sci-Fi','Fantasy','Comedy'],
director:['James Gunn'],
actors:['Chris Pratt','Zoe Saldana','Dave Bautista','Bradley Cooper','Vin Diesel','Michael Rooker','Karen Gillan','Pom Klementieff','Kurt Russell','Elizabeth Debicki','Chris Sullivan','Sean Gunn','Sylvester Stallone','Evan Jones','Stephen Blackehart','Steve Agee','Tommy Flanagan','Rhoda Griffis','Hilty Bowen','Aramis Knight','Elizabeth Ludlow','Gregg Henry','Stan Lee','Ving Rhames','Michael Rosenbaum','Michelle Yeoh','David Hasselhoff','Seth Green','Miley Cyrus','Rob Zombie','Ben Browder','Sierra Love','Jeff Goldblum','Laura Haddock','Luke Cook','Jimmy Urine','Kendra Carelli','Bo Yokely','Terence Rosemore','Richard Christy','Aaron Schwartz','Sebastian Siegel',"Alphonso A'Qen-Aten Jackson"],
basedOn:['Dan Abnett','Andy Lanning'],
screenplay:['James Gunn'],
production:['Kevin Feige'],
music:['Tyler Bates'],
camera:['Henry Braham'],
cut:['Fred Raskin','Craig Wood'],
sound:['David Acord','Addison Teague','Lora Hirschberg','Christopher Boyes'],
scenography:['Scott Chambliss','Elena Albanese','Jay Hart','Harry E. Otto'],
masks:['Deborah Rutherford','Benji Dove','John Blake','Leay Cangelosi','Brian Sipe','Nikki Bell','Jessie Gambardella','Louisa V. Anthony','Vivian Baker','Kevin Kirkpatrick','Christopher Allen Nelson','Camille Friend','Alexei Dmitiew','James MacKinnon'],
costumes:['Judianna Makovsky']},
{title:'Guardians of the Galaxy Vol. 3',
titleCZ:'Strážci Galaxie: Volume 3',
year:2023,
runtime:150,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['James Gunn'],
actors:['Chris Pratt','Dave Bautista','Pom Klementieff','Karen Gillan','Bradley Cooper','Vin Diesel','Zoe Saldana','Chukwudi Iwuji','Sean Gunn','Maria Bakalova','Elizabeth Debicki','Will Poulter','Sylvester Stallone','Nathan Fillion','Daniela Melchior','Nico Santos','Miriam Shor','Linda Cardellini','Judy Greer','Tara Strong','Michael Rosenbaum','Sarah Alami','Stephen Blackehart','Giovannie Cruz','Dane DiLiegro','Mikaela Hoover','John William Wright','Michael Rooker','Jennifer Holland','Seth Green','Asim Chaudhry','Andrew Bachelor','Gregg Henry','Lloyd Kaufman'],
basedOn:['Dan Abnett','Andy Lanning'],
screenplay:['James Gunn'],
production:['Kevin Feige'],
music:['John Murphy'],
camera:['Henry Braham'],
cut:["Greg D'Auria",'Fred Raskin'],
sound:['David Acord'],
scenography:['Beth Mickle','Rosemary Brandenburg'],
masks:['Crystal Gomez','Alexei Dmitiew','Lindsay MacGowan'],
costumes:['Judianna Makovsky']},
{title:'The Guardians of the Galaxy: Holiday Special',
titleCZ:'Strážci Galaxie: Sváteční speciál',
year:2022,
runtime:42,
countries:['USA'],
genres:['Action','Adventure','Comedy','Sci-Fi'],
director:['James Gunn'],
actors:['Chris Pratt','Vin Diesel','Bradley Cooper','Pom Klementieff','Dave Bautista','Karen Gillan','Sean Gunn','Kevin Bacon','Maria Bakalova','Michael Rooker','Stephen Blackehart','Daniel Bernhardt','Kyra Sedgwick','Rusty Schwimmer','Flula Borg','Rachel Luttrell','Tinashe Kajese','Don McLeod','Si Chen'],
screenplay:['James Gunn'],
music:['John Murphy'],
camera:['Henry Braham'],
cut:["Greg D'Auria"],
scenography:['Beth Mickle'],
masks:['Alexei Dmitiew'],
costumes:['Judianna Makovsky']},
{title:'The Punisher',
titleCZ:'Kat',
year:2004,
runtime:116,
countries:['USA','Germany'],
genres:['Action','Crime','Drama','Thriller'],
director:['Jonathan Hensleigh'],
actors:['Thomas Jane','John Travolta','Ben Foster','Marco St. John','Kevin Nash','Will Patton','Samantha Mathis','Rebecca Romijn','Laura Harring','Roy Scheider','A. Russell Andrews','Antoni Corone','Omar Avila','Darla Delgado','Eddie Jemison','Mark Collie','Eduardo Yáñez','Charleene Closshey','Jeff Chase','Sonny Surowiec','Tom Nowicki','Jillian Kinsman','James Carpinello','Marc Macaulay','Hank Stone','William Haze','Gustavo Perez','Bonnie Johnson','Marcus Johns','Terry Loughlin','Yamil Piedra','Michael Reardon','John Pinette','Jimmy Star','Michael A. Quill'],
basedOn:['Gerry Conway','Ross Andru'],
screenplay:['Jonathan Hensleigh','Michael France'],
production:['Gale Anne Hurd','Avi Arad'],
music:['Carlo Siliotto'],
camera:['Conrad W. Hall'],
cut:['Steven Kemper','Jeff Gullo'],
sound:['Jon Taylor','Kelly Cabral','Brad Sherman','Tim Cooney'],
scenography:['Michael Z. Hanan'],
masks:['Yolanda Toussieng','Matthew W. Mungle','Ozzy Alvarez'],
costumes:['Lisa Tomczeszyn']},
{title:'Punisher: War Zone',
titleCZ:'Kat: Válečná zóna',
year:2008,
runtime:98,
countries:['USA','Canada','Germany'],
genres:['Action','Drama','Crime','Thriller'],
director:['Lexi Alexander'],
actors:['Ray Stevenson','Dominic West','Julie Benz','Colin Salmon','Doug Hutchison','Dash Mihok','Wayne Knight','Larry Day','Romano Orzari','Keram Malicki-Sánchez','Ron Lea','T.J. Storm','Bjanka Murgel','Cas Anvar','Aubert Pallascio','David Vadim','Mark Camacho','Tony Calabretta','Stephanie Janusauskas','Carlos Gonzalez-Vio','Edward Yankie','Mike Paterson','Matt Holland','Brent Skagford'],
basedOn:['Gerry Conway','Ross Andru'],
screenplay:['Nick Santora','Art Marcum','Matt Holloway'],
production:['Gale Anne Hurd'],
music:['Michael Wandmacher'],
camera:['Steve Gainer'],
cut:['William Yeh'],
sound:['Tom Ozanich','Greg Hedgepath'],
scenography:['Andrew Neskoromny'],
masks:['Adrien Morot','Christophe Giraud'],
costumes:['Odette Gadoury']},
{title:'Violent Night',
titleCZ:'Šílená noc',
year:2022,
runtime:111,
countries:['USA'],
genres:['Action','Thriller','Crime','Comedy','Horror'],
director:['Tommy Wirkola'],
actors:['David Harbour','John Leguizamo','Alex Hassell','Alexis Louder','Cam Gigandet','Edi Patterson',"Beverly D'Angelo",'Leah Brady','Alexander Elliot','Brendan Fletcher','André Eriksen','Mike Dopud','Sean Skene','Stephanie Sy','Erik Athavale','John B. Lowe'],
screenplay:['Pat Casey','Josh Miller'],
production:['David Leitch','Kelly McCormick','Guy Danella'],
music:['Dominic Lewis'],
camera:['Matthew Weston'],
cut:['Jim Page'],
sound:['Bill Sheppard'],
scenography:['Roger Fires'],
costumes:['Laura Anania']},
{title:'Moonfall',
titleCZ:'Moonfall',
year:2022,
runtime:131,
countries:['USA','Canada','China'],
genres:['Action','Sci-Fi','Adventure','Catastrophic'],
director:['Roland Emmerich'],
actors:['Halle Berry','Patrick Wilson','John Bradley','Charlie Plummer','Kelly Yu','Michael Peña','Donald Sutherland','Eme Ikwuakor','Carolina Bartczak','Maxim Roy','Stephen Bogaert','Ava Weiss','Azriel Dalman','Kathleen Fee','Chris Sandiford','Frank Schorpion','Sebastian Pigott','Jaa Smith-Johnson','Katy Breier','Josh Cruddas','Kyle Gatehouse','Tyrone Benskin','Tyler Elliot Burke','Andreas Apergis','Jake Lewis','Krista Marchand','Sébastien Cimpaye','Delia Lisette Chambers','Harry Standjofski','Randy Thomas','Jane Gilchrist','Karl Walcott','Kwasi Songui','Nicole Leroux','Christian Jadah','Martin Doepner','André Lacoste','Nathaly Thibault','Francesco Giannini'],
screenplay:['Roland Emmerich','Harald Kloser','Spenser Cohen'],
production:['Harald Kloser','Roland Emmerich'],
music:['Thomas Wanker','Harald Kloser'],
camera:['Robby Baumgartner'],
cut:['Adam Wolfe','Ryan Stevens Harris'],
sound:['Greg P. Russell','Tom Marks','Sean McCormack'],
scenography:['Kirk M. Petruccelli','Vincent Aird'],
masks:['Pamela Goldammer','Kathy Kelso'],
costumes:['Mario Davignon']},
{title:'Censor',
titleCZ:'Cenzorka',
year:2021,
runtime:84,
countries:['UK'],
genres:['Horror','Mystery'],
director:['Prano Bailey-Bond'],
actors:['Niamh Algar','Clare Holman','Michael Smiley','Sophia La Porta','Max Bennett','Adrian Schiller','Vincent Franklin','Beau Gadsdon','Andrew Havill','Nicholas Burns','Nikki Marshall','Tina Louise Owens','Sean Buchanan','Danny Lee Wynter','Joanne Gale','Clare Perkins','Amelie Child Villiers'],
screenplay:['Prano Bailey-Bond','Anthony Fletcher'],
production:['Helen Jones'],
music:['Emilie Levienaise-Farrouch'],
camera:['Annika Summerson'],
cut:['Mark Towns'],
sound:['Jamie Roden','Tim Harrison'],
scenography:['Paulina Rzeszowska','Rachel Amanda Jones'],
masks:['Ruth Pease'],
costumes:['Saffron Cullane']},
{title:'X',
titleCZ:'X',
year:2022,
runtime:105,
countries:['USA'],
genres:['Horror','Thriller'],
director:['Ti West'],
actors:['Mia Goth','Jenna Ortega','Brittany Snow','Kid Cudi','Martin Henderson','Owen Campbell','Geoff Dolan','James Gaylyn','Stephen Ure','Bryony Skillington'],
screenplay:['Ti West'],
production:['Jacob Jaffke','Harrison Kreiss','Kevin Turen','Ti West'],
music:['Tyler Bates','Chelsea Wolfe'],
camera:['Eliot Rockett'],
cut:['Ti West','David Kashevaroff'],
scenography:['Thomas S. Hammock'],
masks:['Katie Fox-Heywood'],
costumes:['Malgosia Turzanska']},
{title:'The Happening',
titleCZ:'Stalo se',
year:2008,
runtime:87,
countries:['USA','Indie','France'],
genres:['Drama','Sci-Fi','Thriller','Mystery'],
director:['M. Night Shyamalan'],
actors:['Mark Wahlberg','Zooey Deschanel','John Leguizamo','Ashlyn Sanchez','Betty Buckley','Spencer Breslin','Frank Collison','Jeremy Strong','Alan Ruck','M. Night Shyamalan','Alison Folland','Kristen Connolly',"Brian O'Halloran",'Mara Hobel','Brian Anthony Wilson','Jennifer Butler','Alexander Emmert','Stéphane Debac','Rick Foster','Charlie Saxton','Armand Schultz','Rich Chew','Robert Bailey Jr.','Mauricio Ovalle','Cyrille Thouvenin',"Kerry O'Malley",'Roberto Lombardi','Greg Wood','Peter Appel','Cornell Womack','Adam Danoff','Victoria Clark','Keith Bullard','Edward James Hyland','Julia Yorks','Alex Harz'],
screenplay:['M. Night Shyamalan'],
production:['Barry Mendel','Sam Mercer'],
music:['James Newton Howard'],
camera:['Tak Fujimoto'],
cut:['Conrad Buff IV'],
sound:['Paul Urmson','Lee Dichter','Tod A. Maitland','Robert Fernandez'],
scenography:['Jeannine Oppewall','Jay Hart'],
masks:['Mike Elizalde','Donald Mowat','Bernadette Mazur','Justin Raleigh','Ozzy Alvarez'],
costumes:['Betsy Heimann']},
{title:'Daredevil',
titleCZ:'Daredevil',
year:2003,
runtime:103,
countries:['USA'],
genres:['Action','Adventure','Thriller','Drama'],
director:['Mark Steven Johnson'],
actors:['Ben Affleck','Jennifer Garner','Michael Clarke Duncan','Colin Farrell','Joe Pantoliano','Jon Favreau','David Keith','Erick Avari','Paul Ben-Victor',"Derrick O'Connor",'Leland Orser','Scott Terra','Ellen Pompeo','Kevin Smith','John Rothman','Jude Ciccolella','Stan Lee','Coolio','Mark Margolis','Frank Miller','Pat Crawford Brown','Robert Iler','Kevin Spirtas','André Gordon','Christian Boeving','Bernard Williams','Greg Collins','Tanoai Reed','Michael Duisenberg','Sandra Teles','Josie DiVincenzo','Stefanos Miltsakakis','Kevin Porter',"Greg 'Christopher' Smith",'Dina Rosenmeier','Jimmy Star','Frankie J. Allison','Carlo Corazon','Roy Lee Jones','Lennie Loftin'],
screenplay:['Mark Steven Johnson'],
production:['Arnon Milchan','Gary Foster','Avi Arad'],
music:['Graeme Revell'],
camera:['Ericson Core'],
cut:['Dennis Virkler','Armen Minasian'],
sound:['Paul Massey','Steve Boeddeker','Doug Hemphill','John A. Larsen'],
scenography:['Barry Chusid','Victor J. Zolfo'],
masks:['Matthew W. Mungle','Kerry Mendenhall'],
costumes:['James Acheson']},
{title:'Star Wars: Episode I - The Phantom Menace',
titleCZ:'Star Wars: Epizoda I - Skrytá hrozba',
year:1999,
runtime:136,
countries:['USA'],
genres:['Sci-Fi','Fantasy','Adventure','Action'],
director:['George Lucas'],
actors:['Liam Neeson','Ewan McGregor','Natalie Portman','Jake Lloyd','Pernilla August','Ian McDiarmid','Oliver Ford Davies','Hugh Quarshie','Anthony Daniels','Ahmed Best','Frank Oz','Terence Stamp','Brian Blessed','Ray Park','Celia Imrie','Samuel L. Jackson','Dominic West','Sofia Coppola','Keira Knightley','Bronagh Gallagher','Roman Coppola','Warwick Davis','Ben Burtt','Lindsay Duncan','Greg Proops','Benedict Freitag','Peter Serafinowicz','Ralph Brown','David Bowers','Silas Carson','Kenny Baker','Paul Martin Smith','Richard Armitage','Steve Speirs','Alexi Kaye Campbell','Sean Cronin','Clarence Smith','Raymond Griffiths','Alan Ruscoe','Hassani Shapi','Doug Chiang','Trisha Biggar','Margaret Towner','Sally Hawkins','Rick McCallum','Ned Gorman','Rob Coleman','Katie Lucas','Scott Squires','John Knoll','Mark Coulier','Michelle Taylor','Douglas Bunn','Andrew Elias','Christopher Scarabosio','Andrew Gersh'],
screenplay:['George Lucas'],
production:['Rick McCallum'],
music:['John Williams'],
camera:['David Tattersall'],
cut:['Paul Martin Smith','Ben Burtt'],
sound:['Matthew Wood','Gary Rydstrom','Christopher Scarabosio','Tom Johnson'],
scenography:['Gavin Bocquet','Phil Harvey'],
masks:['Paul Engelen','Sarah Love','Morag Ross'],
costumes:['Trisha Biggar']},
{title:'Star Wars: Episode II - Attack of the Clones',
titleCZ:'Star Wars: Epizoda II - Klony útočí',
year:2002,
runtime:142,
countries:['USA'],
genres:['Sci-Fi','Fantasy','Adventure','Action'],
director:['George Lucas'],
actors:['Ewan McGregor','Natalie Portman','Hayden Christensen','Christopher Lee','Samuel L. Jackson','Frank Oz','Ian McDiarmid','Pernilla August','Temuera Morrison','Jimmy Smits','Jack Thompson','Leeanna Walsman','Rose Byrne','Oliver Ford Davies','Ahmed Best',"Jay Laga'aia",'Anthony Daniels','Ayesha Dharker','Joel Edgerton','Rena Owen','Susie Porter','Steve John Shepherd','Ian Watkin','Marton Csokas','David Bowers','Kyle Rowling','Justin Dix','Matt Doran','Silas Carson','Alfonso Sánchez','Kenny Baker','Daniel Logan','Bonnie Piesse','Alan Ruscoe','Hassani Shapi','Joseph Jett Sally','Veronica Segura','Liam Neeson','Katie Lucas','R. Christopher White','Douglas Bunn','Matt Sloan','Jimmy Star','Nicolas Anastassiou','Anthony Phelan','Jason Baird'],
screenplay:['George Lucas','Jonathan Hales'],
production:['Rick McCallum'],
music:['John Williams'],
camera:['David Tattersall'],
cut:['Ben Burtt','George Lucas'],
sound:['Gary Rizzo','Matthew Wood','Michael Semanick','Gary Rydstrom','Christopher Scarabosio'],
scenography:['Gavin Bocquet','Phil Harvey'],
masks:['Lynn Wheeler','Lesley Vanderwalt','Mark Coulier','Sarah Love','Wizzy Molineaux'],
costumes:['Trisha Biggar']},
{title:'Star Wars: The Last Jedi',
titleCZ:'Star Wars: Poslední z Jediů',
year:2017,
runtime:152,
countries:['USA'],
genres:['Action','Adventure','Fantasy','Sci-Fi'],
director:['Rian Johnson'],
actors:['Daisy Ridley','Adam Driver','Mark Hamill','Carrie Fisher','Oscar Isaac','John Boyega','Kelly Marie Tran','Domhnall Gleeson','Benicio Del Toro','Andy Serkis','Laura Dern','Billie Lourd','Gwendoline Christie',"Lupita Nyong'o",'Anthony Daniels','Shauna Macdonald','Frank Oz','Jimmy Vee','Peter Mayhew','Warwick Davis','Veronica Ngo','Crystal Clarke','Tom Kane','Akshay Kumar','Andy Nyman','Mark Lewis Jones','Togo Igawa','Joseph Gordon-Levitt','Gareth Edwards','Joonas Suotamo','Ralph Ineson','Justin Theroux','Amanda Lawrence','Hermione Corfield','Michaela Coel','Gerard Monaco','Lily Cole','Kevin Layne','Orion Lee','Aki Omoshaybi','Dave Chapman','David M. Santana','Temirlan Blaev','Ben Morris','Andrew Jack','Tim Rose','Princ Henry z Walesu','princ William','Jonathan Harden','Ramesh Lard','Nick Donald'],
screenplay:['Rian Johnson'],
production:['Kathleen Kennedy','Ram Bergman'],
music:['John Williams'],
camera:['Steve Yedlin'],
cut:['Bob Ducsay'],
sound:['David Parker','Ren Klyce','Matthew Wood','Michael Semanick'],
scenography:['Rick Heinrichs','Kevin Jenkins','Mark Harris','Richard Roberts','Jason Knox-Johnston'],
masks:["Peter 'Swords' King",'Heather Manson'],
costumes:['Michael Kaplan']},
{title:'Star Wars: The Rise of Skywalker',
titleCZ:'Star Wars: Vzestup Skywalkera',
year:2019,
runtime:142,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action','Fantasy'],
director:['J.J. Abrams'],
actors:['Daisy Ridley','Adam Driver','Oscar Isaac','John Boyega','Naomi Ackie','Carrie Fisher',"Lupita Nyong'o",'Domhnall Gleeson','Richard E. Grant','Mark Hamill','Anthony Daniels','Keri Russell','Joonas Suotamo','Kelly Marie Tran','Ian McDiarmid','Billy Dee Williams','Greg Grunberg','Shirley Henderson','Billie Lourd','Dominic Monaghan','Harrison Ford','Brian Herring','Dave Chapman','J.J. Abrams','Mandeep Dhillon','Amanda Lawrence','Tanya Moodie','Simon Paisley Day','Geff Francis','Amanda Hale','Amir El-Masry','Cyril Nri','Richard Bremmer','Richard Durden','Andrew Havill','Nasser Memarzia','Patrick Kennedy','Aaron Neil','Joe Hewetson','Mimi Ndiweni','Chris Terrio','Kiran Shah','Debra Wilson','Josef Altin','Vinette Robinson','Ann Firbank','Warwick Davis','John Williams','Nigel Godrich','Dhani Harrison','J.D. Dillard','Dave Hearn','Rochenda Sandall','Jacob Fortune-Lloyd','Denis Lawson','Carolyn Hennesy','Paul Kasey','Matthew Wood','James Earl Jones','Andy Serkis','Cailey Fleming','Jodie Comer','Billy Howle','Hayden Christensen',"Olivia d'Abo",'Ashley Eckstein','Jennifer Hale','Samuel L. Jackson','Ewan McGregor','Alec Guinness','Frank Oz','Freddie Prinze Jr.','Liam Neeson','Lin-Manuel Miranda','Gerald W. Abrams','Jimmy Star','Ed Sheeran','Logic','Philicia Saunders','Indra Ové','Angelique Perrin'],
screenplay:['Chris Terrio','J.J. Abrams'],
production:['Kathleen Kennedy','J.J. Abrams','Michelle Rejwan'],
music:['John Williams'],
camera:['Dan Mindel'],
cut:['Maryann Brandon','Stefan Grube'],
sound:['David Acord','Matthew Wood','Andy Nelson','Christopher Scarabosio'],
scenography:['Rick Carter','Kevin Jenkins','Rosemary Brandenburg','Claire Fleming','Phil Sims'],
masks:['Bill Corso','Amanda Knight','Amy Byrne'],
costumes:['Michael Kaplan']},
{title:'Mission: Impossible',
titleCZ:'Mission: Impossible',
year:1996,
runtime:110,
countries:['USA'],
genres:['Action','Adventure','Thriller'],
director:['Brian De Palma'],
actors:['Tom Cruise','Jon Voight','Emmanuelle Béart','Henry Czerny','Jean Reno','Ving Rhames','Kristin Scott Thomas','Vanessa Redgrave','Ingeborga Dapkunajtě','Emilio Estevez','Valentina Jakunina','Marek Vašut','Nathan Osgood','John McLaughlin','Rolf Saxon','Karel Dobrý','Andreas Wisniewski','Rudolf Pechan','Gaston Šubert','Ricco Ross','Mark Houghton','Annabel Mullion','Garrick Hagon','Jiřina Třebická','Andrzej Borkowski','Sam Douglas','Olegar Fedoro','Carmela Marner','David Schneider','Helen Lindsay','Randall Paul','Graydon Gould','Ion Caramitru','Dale Dye','Marcel Iureș','Keith Campbell','Harry Fielder','John Knoll'],
screenplay:['David Koepp','Robert Towne'],
production:['Tom Cruise','Paula Wagner'],
music:['Danny Elfman'],
camera:['Stephen H. Burum'],
cut:['Paul Hirsch'],
sound:['David Crozier','Christopher Boyes','Gary Summers','Gary Rydstrom'],
scenography:['Norman Reynolds'],
masks:['Lois Burwell','Amanda Knight','Rob Bottin','Dave Elsey','Thomas Floutz'],
costumes:['Penny Rose']},
{title:'Mission: Impossible II',
titleCZ:'Mission: Impossible II',
year:2000,
runtime:123,
countries:['USA','Germany'],
genres:['Action','Adventure','Thriller'],
director:['John Woo'],
actors:['Tom Cruise','Dougray Scott','Thandiwe Newton','Ving Rhames','Richard Roxburgh','John Polson','Brendan Gleeson','Rade Šerbedžija','William Mapother','Dominic Purcell','Tory Mussett','Anthony Hopkins','Darren Dupree Washington','Alison Araya','Nicholas Bell','Daniel Roberts','Patrick Marber','Kee Chan','Adriana Rodríguez','Brett Partridge','Douglas Bunn','Christian Manon','Alan Lovell'],
screenplay:['Robert Towne'],
production:['Tom Cruise','Paula Wagner'],
music:['Hans Zimmer'],
camera:['Jeffrey L. Kimball'],
cut:['Steven Kemper','Christian Wagner'],
sound:['Al Nelson','Andy Nelson','Anna Behlmer','Mark P. Stoeckinger'],
scenography:['Thomas E. Sanders'],
masks:['Dave Elsey','Mitchell J. Coughlin','Kevin Yagher'],
costumes:['Lizzy Gardiner']},
{title:'Mission: Impossible III',
titleCZ:'Mission: Impossible III',
year:2006,
runtime:126,
countries:['USA','Germany','China'],
genres:['Action','Adventure','Thriller'],
director:['J.J. Abrams'],
actors:['Tom Cruise','Philip Seymour Hoffman','Ving Rhames','Billy Crudup','Michelle Monaghan','Jonathan Rhys Meyers','Keri Russell','Maggie Q','Simon Pegg','Eddie Marsan','Laurence Fishburne','Bahar Soomekh','Jeff Chase','Bellamy Young','Greg Grunberg','Sasha Alexander','Rose Rollins','Jaymes Butler','Paolo Bonacelli','Aaron Paul','Timothy Omundson','Barney Cheng','Tracy Middendorf','Brandon Molale','George Cheung',"Sean O'Bryan",'Jonathan Dixon','Niccolò Senni','José Zúñiga','Carla Gallo','Andrea Sartoretti','Michelle Arthur','Bruce French','Antonio Del Prete','Anne Betancourt','Ellen Bry','James Shanklin','Jane Daly','Diane Marshall-Green','Charles Rahi Chun','Brandon P Bell','Giorgio Marchesi','Michael Berry Jr.','Lucille Soong','Ben Solenberger','Colleen Crozier','Jimmy Star','William Francis McGuire'],
screenplay:['Roberto Orci','Alex Kurtzman','J.J. Abrams'],
production:['Tom Cruise','Paula Wagner'],
music:['Michael Giacchino'],
camera:['Dan Mindel'],
cut:['Maryann Brandon','Mary Jo Markey'],
sound:['Andy Nelson','Anna Behlmer','Mark P. Stoeckinger'],
scenography:['Scott Chambliss','Karen Manthey','Gary Kosko'],
masks:['Deborah Rutherford'],
costumes:['Colleen Atwood']},
{title:'Mission: Impossible - Fallout',
titleCZ:'Mission: Impossible - Fallout',
year:2018,
runtime:147,
countries:['USA','UK','France','Norsko','China'],
genres:['Action','Adventure','Thriller'],
director:['Christopher McQuarrie'],
actors:['Tom Cruise','Henry Cavill','Rebecca Ferguson','Simon Pegg','Ving Rhames','Vanessa Kirby','Alec Baldwin','Sean Harris','Angela Bassett','Michelle Monaghan','Wes Bentley','Frederick Schmidt','Kristoffer Joner','Joey Ansah','Caspar Phillipson','Velibor Topic','Gordon Alexander','Alix Bénézech','Russ Bain','Grahame Fox','Lolly Adefope','Raphael Acloque','David Mumeni','Olivier Huband','Charlie Esquér','Alexandre Poole'],
screenplay:['Christopher McQuarrie'],
production:['J.J. Abrams','Tom Cruise','Christopher McQuarrie','Jake Myers'],
music:['Lorne Balfe'],
camera:['Rob Hardy'],
cut:['Eddie Hamilton'],
sound:['James Mather','Michael Prestwood Smith'],
scenography:['Peter Wenham','Phil Sims'],
masks:['Ailbhe Lemass','Sarah Monzani','Heather Manson','Satinder Chumber'],
costumes:['Jeffrey Kurland']},
{title:'Mission: Impossible - Rogue Nation',
titleCZ:'Mission: Impossible - Národ grázlů',
year:2015,
runtime:132,
countries:['USA','Hong Kong','China'],
genres:['Action','Adventure','Thriller'],
director:['Christopher McQuarrie'],
actors:['Tom Cruise','Simon Pegg','Rebecca Ferguson','Jeremy Renner','Ving Rhames','Alec Baldwin','Sean Harris','America Olivo','Simon McBurney','Ťing-čchu Čang','Tom Hollander','Jens Hultén','Alec Utgoff','Hermione Corfield','Nigel Barber','Osy Ikhile','Jermaine Liburd','Sean Cronin','Thomas Anton','Patrik Plenk','Francesca Bennett','James Weber Brown','Lasco Atkins','Tim Breyvogel','Stella Stocker','Martin Bermoser','James Grogan','Martyn Mayger','Miroslav Zaruba','Shaun Newnham','Attila G. Kerekes','Kornelia Horvath','Robert Maaser','Pete Sepenuk','Daniel Eghan','Richard Banks','Atul Sharma','Yasen Atour','Sascha Merényi','Anthony Milton','David Terry','Wolfgang Cerny','Tobias James-Samuels','David Peart','Deniz Cooper','Will Austin','Hadrian Howard','Peter Stark','Marlon Boess','Martin Müller','Benjamin Plautz','Oliver Leitsberger','Pamela Betsy Cooper','Katrina Vasilieva','Daniela Nitsch','Eva-Marie Becker','Jessica Allain','Pete Meads','Sagar Radia','Jimmy Star','Colin Goodwin','Julian Moore-Cook','Barnabás Réti','Tom Coulston','Rachel Handshaw','Nick Donald'],
screenplay:['Christopher McQuarrie'],
production:['J.J. Abrams','Tom Cruise','Bryan Burk','David Ellison','Don Granger','Dana Goldberg'],
music:['Joe Kraemer'],
camera:['Robert Elswit'],
cut:['Eddie Hamilton'],
sound:['James Mather','Michael Prestwood Smith','Chris Munro'],
scenography:['Jim Bissell','Gena Vazquez'],
masks:['Ailbhe Lemass','Sarah Monzani','Julia Vernon','Daniela Skala','Zoe Clare Brown','Satinder Chumber'],
costumes:['Joanna Johnston']},
{title:'Mission: Impossible - Ghost Protocol',
titleCZ:'Mission: Impossible - Ghost Protocol',
year:2011,
runtime:127,
countries:['USA','United Arab Emirates','Czechia'],
genres:['Action','Adventure','Thriller'],
director:['Brad Bird'],
actors:['Tom Cruise','Paula Patton','Simon Pegg','Jeremy Renner','Michael Nyqvist','Vladimir Maškov','Samuli Edelmann','Ivan Shvedoff','Anil Kapoor','Léa Seydoux','Josh Holloway','Pavel Kříž','Miraj Grbic','Ilia Volok','Tom Wilkinson','Goran Navojec','Pavel Bezděk','Ladislav Beran','Jan Pavel Filipenský','Jiří Kraus','Tomáš Valík','Pavel Cajzl','Andrej Bestčastnyj','Mike Dopud','Martin Hub','Ivo Novák','Claudia Vašeková','Brian Caspe','Petra Lustigová','Gina Hirsch','Ving Rhames','Andreas Wisniewski','Michelle Monaghan','Paul Lazenby','April Stewart','Marek Dobeš','David Stuart','Jessica Belkin','Dawn Chubai','Dmytro Čepoveckyj'],
screenplay:['Josh Appelbaum','André Nemec'],
production:['Bryan Burk','Tom Cruise','J.J. Abrams','David Ellison'],
music:['Michael Giacchino'],
camera:['Robert Elswit'],
cut:['Paul Hirsch'],
sound:['Richard Hymns','Andy Nelson','Gary Rydstrom','Christopher Scarabosio'],
scenography:['Jim Bissell','Rosemary Brandenburg','Andrew Del Rosario'],
masks:['David LeRoy Anderson','Monica Huppert','Mike Fields'],
costumes:['Jiřina Eisenhamerová','Dagmar Pomajbiková','Michael Kaplan']},
{title:'Black Panther',
titleCZ:'Black Panther',
year:2018,
runtime:134,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Ryan Coogler'],
actors:['Chadwick Boseman','Michael B. Jordan',"Lupita Nyong'o",'Danai Gurira','Martin Freeman','Daniel Kaluuya','Letitia Wright','Winston Duke','Sterling K. Brown','Angela Bassett','Forest Whitaker','Andy Serkis','Florence Kasumba','John Kani','David S. Lee','Rodney Luis Aquino','Sydelle Noel','Stan Lee','Isaach De Bankolé','Danny Sapani','Janeshia Adams-Ginyard','Denzel Whitaker','Sope Aluko','Mark Ashworth','Alexis Rhee','Sebastian Stan','Mohamed Hakeemshady','Francesca Faridany','Lidya Jewett','Seth Carr','Shaunette Renée Wilson','Ofu Obekpa',"De'Jon Watts",'Abraham Clinkscales','Tristan Timmons','Rose Bianco','Connie Chiume','Bambadjan Bamba','Alex R. Hibbert','Alexis Louder','Joseph Akharoh Jr.','Tunde Laleye','Alona Leoine','Raven Wynn','Zenzi Williams','Marie Mouroum','Marija Juliette Abney','Michael Christopher Rodney','Nabiyah Be'],
basedOn:['Stan Lee','Jack Kirby'],
screenplay:['Ryan Coogler','Joe Robert Cole'],
production:['Kevin Feige','David J. Grant'],
music:['Ludwig Göransson'],
camera:['Rachel Morrison'],
cut:['Debbie Berman','Michael P. Shawver'],
sound:['Steve Boeddeker','Brandon Proctor','Benjamin A. Burtt'],
scenography:['Hannah Beachler','Jay Pelissier','Jay Hart','Jesse Rosenthal'],
masks:['Gigi Collins','Para Malden','Leay Cangelosi','Nikki Bell','Addison Foreman','Natalie Johnson','Louisa V. Anthony','Joel Harlow','Sandye Kaye','Camille Friend','Dee Dee Metzger','Ellen Arden','Jaime Leigh McIntosh','Sarah Graham','Shutchai Tym Buacharern'],
costumes:['Ruth E. Carter']},
{title:'Black Panther: Wakanda Forever',
titleCZ:'Black Panther: Wakanda nechť žije',
year:2022,
runtime:161,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Ryan Coogler'],
actors:['Letitia Wright',"Lupita Nyong'o",'Winston Duke','Angela Bassett','Danai Gurira','Martin Freeman','Tenoch Huerta','Lake Bell','Michaela Coel','Florence Kasumba','Dominique Thorne','Curtis Bannister','Isaach De Bankolé','Mabel Cadena','Gigi Bermingham','Grace Junot','Kamaru Usman','Richard Schiff','Janeshia Adams-Ginyard','Julia Louis-Dreyfus','Michael B. Jordan','Chadwick Boseman','Bill Barrett','Marija Juliette Abney','Travis Love','Anderson Cooper','Jordan Walker Ross'],
screenplay:['Ryan Coogler','Joe Robert Cole'],
production:['Kevin Feige','Nate Moore'],
music:['Ludwig Göransson'],
camera:['Autumn Durald'],
cut:['Kelley Dixon','Jennifer Lame','Michael P. Shawver'],
sound:['Peter J. Devlin'],
scenography:['Hannah Beachler','Lisa K. Sessions','Jesse Rosenthal'],
masks:['Joel Harlow','Camille Friend','Naveesa Nixon'],
costumes:['Ruth E. Carter']},
{title:'Waterworld',
titleCZ:'Vodní svět',
year:1995,
runtime:135,
countries:['USA'],
genres:['Sci-Fi','Adventure','Drama','Thriller'],
director:['Kevin Reynolds'],
actors:['Kevin Costner','Jeanne Tripplehorn','Lanny Flaherty','Tina Majorino','Michael Jeter','Dennis Hopper','Neil Giuntoli','Robert Joy','John Fleck','R.D. Call','Jack Black','Kim Coates','Sean Whalen','Robert LaSardo','Zakes Mokae','Rick Aviles','Anne Gaybis','Sab Shimono','Jack Kehler','Robert A. Silverman','Leonardo Cimino','John Toles-Bey','Chris Moore','Zitto Kazann','John Otrin','William Preston','Doug Spinuzza','Rita Zohar'],
screenplay:['David Twohy','Peter Rader'],
production:['John Davis','Lawrence Gordon','Kevin Costner','Charles Gordon'],
music:['James Newton Howard'],
camera:['Dean Semler'],
cut:['Peter Boyle'],
sound:['Steve Maslow','Gregg Landaker','Keith A. Wester'],
scenography:['Dennis Gassner','Nancy Haigh'],
masks:['James Lee McCoy','David LeRoy Anderson','Janis Clark'],
costumes:['John Bloomfield']},
{title:'AVP: Alien vs. Predator',
titleCZ:'Vetřelec vs. Predátor',
year:2004,
runtime:87,
countries:['USA','Germany','Czechia','UK','Canada'],
genres:['Action','Sci-Fi','Thriller','Adventure'],
director:['Paul W.S. Anderson'],
actors:['Lance Henriksen','Sanaa Lathan','Raoul Bova','Tommy Flanagan','Ewen Bremner','Colin Salmon','Pavel Bezděk','Petr Jákl','Eoin McCarthy','Jan Pavel Filipenský','Glenn Conroy','Sam Troughton','Carsten Nørgaard','Agathe de La Boulaye','Ian Whyte','Alec Gillis','Kieran Bew','Andy Lucas','Tom Woodruff Jr.','Liz May Brice','Karima McAdams','Carsten Voigt','Joseph Balderrama'],
screenplay:['Paul W.S. Anderson'],
production:['John Davis','Walter Hill','David Giler','Gordon Carroll','Henning Molfenter'],
music:['Harald Kloser'],
camera:['David Johnson'],
cut:['Alexander Berner'],
sound:['Michal Holubec','Mark Taylor','Andrew Stirk','Howard Bargroff'],
scenography:['Richard Bridgland','Ray Chan'],
masks:['Lucie Kuprová','Mark Coulier','Barrie Gower'],
costumes:['Magali Guidasci']},
{title:'Justice League',
titleCZ:'Liga spravedlnosti',
year:2017,
runtime:120,
countries:['USA'],
genres:['Action','Adventure','Fantasy','Sci-Fi'],
director:['Zack Snyder'],
actors:['Ben Affleck','Gal Gadot','Henry Cavill','Ezra Miller','Jason Momoa','Ray Fisher','Amy Adams','Jeremy Irons','J.K. Simmons','Diane Lane','Connie Nielsen','Ciarán Hinds','Amber Heard','Joe Morton','Lisa Loven Kongsli','Ingvar Sigurðsson','Billy Crudup','David Thewlis','Ágústa Eva Erlendsdóttir','Michael McElhatton','John Dagleish','Lara Decaro','Will Austin','Holt McCallany','Kobna Holdbrook-Smith','Robin Wright','Francis Magee','Charlotte Comer','Doutzen Kroes','Ann Ogbomo','Samantha Win','Eleanor Matsuura','Marc McClure','Martin Troakes','Gianpiero Cognoli','Jérôme Pradon','Lynne Anne Rodgers','Vaughn Johseph','Bruce Lester-Johnson','Tomi May','Kasha Bajor','Peter Brooke','Jesse Eisenberg','Joe Manganiello','Stewart Alexander','Craig Thomas Lambert','Anthony Milton','Taylor James','Adam Collins','Jim Sturgeon','Clem So','Rosa Escoda','Oliver Powell','Samantha Schnitzler','Orion Lee','Karen Bryson','Jolie Lennon','Omri Rose','Daniel Stisen','Jimmy Star','Anthony Wise','Aurore Lauzeral','Sergi Constance','Julian Lewis Jones','Gary Reimer','Salóme Gunnarsdóttir','Richard Clifford'],
basedOn:['Gardner Fox'],
screenplay:['Chris Terrio','Joss Whedon'],
production:['Jon Berg','Geoff Johns','Charles Roven','Deborah Snyder'],
music:['Danny Elfman'],
camera:['Fabian Wagner'],
cut:['David Brenner','Richard Pearson','Martin Walsh'],
sound:['Michael Keller','Chuck Michael'],
scenography:['Patrick Tatopoulos','Dominic Capon'],
masks:['Victoria Down','Graham Johnston','Heather Manson'],
costumes:['Michael Wilkinson']},
{title:"Zack Snyder's Justice League",
titleCZ:'Liga spravedlnosti Zacka Snydera',
year:2021,
runtime:242,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['Zack Snyder'],
actors:['Ben Affleck','Henry Cavill','Amy Adams','Gal Gadot','Ray Fisher','Jason Momoa','Ezra Miller','Willem Dafoe','Jesse Eisenberg','Jeremy Irons','Diane Lane','Connie Nielsen','J.K. Simmons','Ciarán Hinds','Ryan Zheng','Amber Heard','Joe Morton','Lisa Loven Kongsli','David Thewlis','Ray Porter','Kiersey Clemons','Robin Wright','Joe Manganiello','Peter Guinness','Jared Leto','Harry Lennix','Samantha Win','Billy Crudup','Kevin Costner','Russell Crowe','Ann Ogbomo','Marc McClure','Eleanor Matsuura','Francis Magee','Karen Bryson','Carla Gugino','Anthony Wise','Aurore Lauzeral','Sergi Constance','Julian Lewis Jones','Sam Benjamin','Gary Reimer','Salóme Gunnarsdóttir','Victor Gardener','Nick McKinless','Richard Clifford'],
screenplay:['Chris Terrio'],
production:['Deborah Snyder','Charles Roven'],
music:['Junkie XL'],
camera:['Fabian Wagner'],
cut:['David Brenner','Dody Dorn','Carlos M. Castillón'],
sound:['Michael Keller','Chuck Michael','Andy Koyama'],
scenography:['Patrick Tatopoulos','Dominic Capon'],
costumes:['Michael Wilkinson']},
{title:'Thor',
titleCZ:'Thor',
year:2011,
runtime:110,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['Kenneth Branagh'],
actors:['Chris Hemsworth','Tom Hiddleston','Anthony Hopkins','Natalie Portman','Colm Feore','Jaimie Alexander','Stellan Skarsgård','Adriana Barraza','Stan Lee','Ray Stevenson','Tadanobu Asano','Dakota Goyo','Idris Elba','Kat Dennings','Rene Russo','Clark Gregg','Cassity Atkins','Samuel L. Jackson','Jeremy Renner','J. Michael Straczynski','Maximiliano Hernández','Josh Dallas','Luke Massy','Darren Kendrick','Douglas Tait','Juliet Lopez','Josh Coxx','Joseph Gatt','Jamie McShane','Jim Palmer','Joel McCrary','Dale Godboldo','Ted Allpress','Terry Dale Parks','Isaac Kappy','Martin Palmer','Michael E. Stogner','Carrie Lazar','Harley Graham','Shawn-Caulin Young','Jimmy Star','Travis Willingham','Vanessa Bednar','Walter Simonson','Courtney Jones','Seth Coltan','Jasyn Jefferies'],
basedOn:['Stan Lee','Larry Lieber','Jack Kirby'],
screenplay:['Ashley Miller','Zack Stentz','Don Payne'],
production:['Kevin Feige'],
music:['Patrick Doyle'],
camera:['Haris Zambarloukos'],
cut:['Paul Rubell'],
sound:['Richard King','Andy Nelson','Anna Behlmer'],
scenography:['Bo Welch','Luke Freeborn'],
masks:['Mike Smithson','Nikoletta Skarlatos','Arjen Tuiten','Luisa Abel','Carol Pershing','Robert Maverick','James MacKinnon'],
costumes:['Alexandra Byrne']},
{title:'Thor: The Dark World',
titleCZ:'Thor: Temný svět',
year:2013,
runtime:112,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['Alan Taylor'],
actors:['Chris Hemsworth','Natalie Portman','Tom Hiddleston','Kat Dennings','Stellan Skarsgård','Idris Elba','Anthony Hopkins','Ray Stevenson','Jaimie Alexander','Tadanobu Asano','Zachary Levi','Christopher Eccleston','Rene Russo','Jonathan Howard','Adewale Akinnuoye-Agbaje',"Chris O'Dowd",'Benicio Del Toro','Stan Lee','Julian Seager','Chris Evans','Brett R. Miller','Ophelia Lovibond','Jd Roth-round','Talulah Riley','Tony Curran','Freddie-Joe Twine','Royce Pierreson','Gruffudd Glyn','Chloe Farnworth','Paul Warren','Richard Whiten','Sophie Cosson','Sam Swainsbury','Jason Beeston','Conor Boru','Graham Shiels','Alice Krige','Roshawn Franklin','Steven Hack','Richard Wharton','James Michael Rankin'],
basedOn:['Stan Lee','Larry Lieber','Jack Kirby'],
screenplay:['Don Payne','Robert Rodat','Christopher L. Yost'],
production:['Kevin Feige'],
music:['Brian Tyler'],
camera:['Kramer Morgenthau'],
cut:['Dan Lebental','Wyatt Smith'],
sound:['Gary Rizzo','Juan Peralta','Lora Hirschberg','Shannon Mills','Will Files','Christopher Scarabosio'],
scenography:['Charles Wood','Ray Chan','Jordan Crockett'],
masks:['Kimberly Carlson','Mike Smithson','Karen Cohen','David White','Lizzie Yianni Georgiou','Allan A. Apone','Giuliano Mariano','Christopher Allen Nelson','Margaret Prentice','James MacKinnon'],
costumes:['Wendy Partridge']},
{title:'Thor: Love and Thunder',
titleCZ:'Thor: Láska jako hrom',
year:2022,
runtime:118,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['Taika Waititi'],
actors:['Chris Hemsworth','Natalie Portman','Christian Bale','Tessa Thompson','Taika Waititi','Russell Crowe','Jaimie Alexander','Chris Pratt','Dave Bautista','Karen Gillan','Pom Klementieff','Sean Gunn','Vin Diesel','Bradley Cooper','Carly Rees','Ben Falcone','Stephen Curry','Bobby Holland Hanton','Daley Pearson','Kieron L. Dyer','Simon Russell Beale','Jonny Brugh','Brooke Satchwell','Elsa Pataky','Kaan Guldur','Alan Dukes','Nico Cortez','Priscilla Doueihy','Stephen Hunter','Indiana Evans','Josh Heuston','Ben Sinclair','Matt Damon','Luke Hemsworth','Melissa McCarthy','Sam Neill','Idris Elba','Brett Goldstein','Kat Dennings','Stellan Skarsgård','Rene Russo','Anthony Hopkins','Tom Hiddleston','Ray Stevenson','Zachary Levi','Tadanobu Asano','Tristan Hemsworth','Jane Kim','Victoria Ferrara','Chris Stanley'],
basedOn:['Stan Lee'],
screenplay:['Taika Waititi','Jennifer Kaytin Robinson'],
production:['Kevin Feige','Brad Winderbaum'],
music:['Michael Giacchino','Nami Melumad'],
camera:['Barry Baz Idoine'],
cut:['Peter S. Elliot','Tim Roche','Matthew Schmidt','Jennifer Vecchiarello'],
sound:['Daniel Laurie','Onnalee Blank','Brandon Proctor','Nick Emond','David C. Hughes','Samson Neslund','Steve Orlando','Qianbaihui Yang','Vinii Khullar'],
scenography:['Robert Webb','Nigel Phelps'],
masks:['Matteo Silvi','Adam Johansen','Adam Johansen','Christopher Allen Nelson'],
costumes:['Cynthia Bergstrom','Mayes C. Rubeo']},
{title:'Morbius',
titleCZ:'Morbius',
year:2022,
runtime:105,
countries:['USA'],
genres:['Action','Horror','Sci-Fi','Thriller'],
director:['Daniel Espinosa'],
actors:['Jared Leto','Adria Arjona','Matt Smith','Jared Harris','Al Madrigal','Tyrese Gibson','Michael Keaton','Charlie Shotwell','Corey Johnson','Archie Renaux','Tina Louise Owens','Kalle Hennie','Chris Ryman','Barry Aird','Jimmy Star','Tom Forbes','Clara Rosager','Bentley Kalu','Gloria Garcia','Abraham Popoola'],
basedOn:['Gil Kane'],
screenplay:['Matt Sazama','Burk Sharpless'],
production:['Avi Arad','Lucas Foster','Matthew Tolmach'],
music:['Jon Ekstrand'],
camera:['Oliver Wood'],
sound:['Paul Massey','Beau Borders','Colin Nicolson','Oleg Kulchytskyi'],
scenography:['Stefania Cella'],
masks:['Jeremy Woodhead',"Conor O'Sullivan",'Lucy Sibbick'],
costumes:['Cindy Evans']},
{title:'The Matrix Resurrections',
titleCZ:'Matrix Resurrections',
year:2021,
runtime:148,
countries:['USA'],
genres:['Action','Sci-Fi'],
director:['Lana Wachowski'],
actors:['Keanu Reeves','Carrie-Anne Moss','Yahya Abdul-Mateen II','Jonathan Groff','Jessica Henwick','Neil Patrick Harris','Jada Pinkett Smith','Priyanka Chopra Jonas','Christina Ricci','Lambert Wilson','Andrew Caldwell','Toby Onwumere','Max Riemelt','Joshua Grothe','Brian J. Smith','Eréndira Ibarra','Mumbi Maina','Max Mauff','Purab Kohli','Freema Agyeman','Sabrina Strehl','Andrew Rothney','Leo Sheng','Telma Hopkins','John Gaeta','Kim Libreri','Chad Stahelski','Tiger Chen Hu','Stephen Dunlevy','Ellen Hollman','Ian Pirie','Nicolas de Pruyssenaere','Felix Quinton','Steven Roy','Mercy Malick','James McTeigue','Andrew Koponen','Daniel Bernhardt','Clayton Watson','Etienne Vick','Gaige Chaturantabut','Laurence Fishburne','Hugo Weaving','Gloria Foster','Daniel Söhner'],
screenplay:['Lana Wachowski','David Mitchell','Aleksandar Hemon'],
production:['James McTeigue','Lana Wachowski','Grant Hill'],
music:['Johnny Klimek','Tom Tykwer'],
camera:['Daniele Massaccesi','John Toll'],
cut:['Joseph Jett Sally'],
sound:['Lars Ginzel'],
scenography:['Hugh Bateup','Barbara Munch','Stephan O. Gessler','Richard Bloom'],
masks:['Stephan Dupuis','Daniel Parker','Heike Merker','Julia Böhm'],
costumes:['Lindsay Pugh']},
{title:'The Matrix Revolutions',
titleCZ:'Matrix Revolutions',
year:2003,
runtime:129,
countries:['USA','Australia'],
genres:['Action','Sci-Fi'],
director:['Lilly Wachowski','Lana Wachowski'],
actors:['Keanu Reeves','Laurence Fishburne','Carrie-Anne Moss','Hugo Weaving','Ian Bliss','Collin Chou','Lachy Hulme','Nathaniel Lees','Harry Lennix','Robyn Nevin','David Roberts','Lambert Wilson','Bruce Spence','Jada Pinkett Smith','Monica Bellucci','Anthony Brandon Wong','Nona Gaye','Anthony Zerbe','Harold Perrineau','Kate Beahan','Gina Torres','Helmut Bakaitis','David Bowers',"Genevieve O'Reilly",'Robert Mammone','Christopher Kirby','Rupert Reid','Mary Alice','Bernard White','Joe Manning','Kevin Michael Richardson','Clayton Watson','Rene Naufahu','Essie Davis','Richard Sydenham'],
screenplay:['Lilly Wachowski','Lana Wachowski'],
production:['Joel Silver'],
music:['Don Davis'],
camera:['Bill Pope'],
cut:['Zach Staenberg'],
sound:['John T. Reitz','Gregg Rudloff','David E. Campbell','David Lee'],
scenography:['Jules Cook','Owen Paterson'],
masks:['Peter Robb-King'],
costumes:['Kym Barrett']},
{title:'The Matrix Reloaded',
titleCZ:'Matrix Reloaded',
year:2003,
runtime:138,
countries:['USA','Australia'],
genres:['Action','Sci-Fi'],
director:['Lilly Wachowski','Lana Wachowski'],
actors:['Keanu Reeves','Laurence Fishburne','Carrie-Anne Moss','Hugo Weaving','Steve Bastoni','Jada Pinkett Smith','Monica Bellucci','Daniel Bernhardt','Ian Bliss','Collin Chou','Randall Duk Kim','Essie Davis','Nona Gaye','Nathaniel Lees','Harry Lennix','Matt McColm','Tory Mussett','Robyn Nevin','Gloria Foster','David Roberts','Leigh Whannell','Lambert Wilson','Anthony Brandon Wong','Anthony Zerbe','Harold Perrineau','Gina Torres','Nash Edgerton','Roy Jones Jr.','Helmut Bakaitis','Stoney Burke','David Franklin',"Genevieve O'Reilly",'Robert Mammone','Michael Budd','Christopher Kirby','Don Battée','Josephine Byrnes','Rupert Reid','Socratis Otto','Bernard White','Bill Pope','Malcolm Kennard','Clayton Watson','Neil Rayment','Adrian Rayment','Rene Naufahu'],
screenplay:['Lilly Wachowski','Lana Wachowski'],
production:['Joel Silver'],
music:['Don Davis'],
camera:['Bill Pope'],
cut:['Zach Staenberg'],
sound:['Eric Warren Lindemann','John T. Reitz','Gregg Rudloff','David E. Campbell','David Lee'],
scenography:['Owen Paterson'],
masks:['Peter Robb-King','Jason Baird'],
costumes:['Kym Barrett']},
{title:'World War Z',
titleCZ:'Světová válka Z',
year:2013,
runtime:116,
countries:['USA','Malta'],
genres:['Horror','Action','Sci-Fi','Thriller','Adventure'],
director:['Marc Forster'],
actors:['Brad Pitt','Mireille Enos','David Morse','Daniella Kertesz','James Badge Dale','David Andrews','Ludi Boeken','Matthew Fox','Moritz Bleibtreu','John Gordon Sinclair','Fana Mokoena','Eric West','Lee Asquith-Coe','Féodor Atkine','Faruk Pruti','Tim Ahern','Lucy Russell','Elyes Gabel','Christian Contreras','Julian Seager','Pierfrancesco Favino','Abigail Hargrove','Sterling Jerins','Fabrizio Guido','Iván Kamarás','Grégory Fitoussi','Peter Capaldi','Basher Savage','Ryan Hartwig','Jonathan Howard','Ruth Negga','Nikola Djuričko','Michiel Huisman','Ruari Cannon','Maddox Jolie-Pitt','Ori Pfeffer','Yaniv Rokah','Michael Jenn','Hattie Gotobed','Doron Davidson','John Macmillan','Peter Basham','Paul Warren','Tim Berrington','Khalid Laith','Sarah Sharman','Troy Glasgow','Trevor White','Mike Noble','Joseph Andrew Mclean','Graham Curry','Okezie Morro','Ann Ogbomo','Katrina Vasilieva','Richard Thomson','Assaf Ben-Shimon','Eunice Olumide','Jane Perry','Josh Wingate','Lucy Aharish','Katalin Dombi','Sharon Sheehan','Katia Bokor','Michael Anthony Brown','Audrey Marie Bartolo','Aggy K. Adams','Kiera Morgan','Colin Matthews','Oleg Hill'],
basedOn:['Max Brooks'],
screenplay:['Matthew Michael Carnahan','Drew Goddard','Damon Lindelof'],
production:['Ian Bryce','Jeremy Kleiner','Brad Pitt','David Ellison','Dede Gardner'],
music:['Marco Beltrami'],
camera:['Ben Seresin','Robert Richardson'],
cut:['Matt Chessé','Roger Barton'],
sound:['Erik Aadahl','Ethan Van der Ryn','Mac Ruth','Anna Behlmer','Lora Hirschberg','Andrii Trifonov'],
scenography:['Nigel Phelps'],
masks:['Jean Ann Black','Luigi Rocchetti','Tamar Aviv','Karen Cohen','Matthew Smith','Arjen Tuiten','Tristan Versluis','Duncan Jarman','Nora Robertson','Mark Coulier','Ann Fenton','Michele Davidson Bell','Frances Hannon','Jessica Brooks','David Malinowski','Siân Miller','Christopher Allen Nelson','Lara Licari','Josh Weston'],
costumes:['Mayes C. Rubeo']},
{title:'Eternals',
titleCZ:'Eternals',
year:2021,
runtime:156,
countries:['USA'],
genres:['Fantasy','Sci-Fi','Action','Adventure'],
director:['Chloé Zhao'],
actors:['Gemma Chan','Richard Madden','Angelina Jolie','Salma Hayek','Kumail Nanjiani','Lia McHugh','Brian Tyree Henry','Lauren Ridloff','Barry Keoghan','Dong-seok Ma','Kit Harington','Harish Patel','Harry Styles','Haaz Sleiman','Patton Oswalt','Mahershala Ali','David Kaye','Bill Skarsgård','Esai Daniel Cross','Alan Scott','Hannah Dodd'],
basedOn:['Jack Kirby'],
screenplay:['Chloé Zhao','Patrick Burleigh','Ryan Firpo','Kaz Firpo'],
production:['Kevin Feige','Nate Moore'],
music:['Ramin Djawadi'],
camera:['Ben Davis'],
cut:['Dylan Tichenor','Craig Wood'],
sound:['Juan Peralta','Addison Teague','Lora Hirschberg','Keith Kohn','Daniel Laurie'],
scenography:['Eve Stewart','Clint Wallace','Michael Standish'],
masks:['Julio Parodi','Karen Cohen','Laura Allen','Frances Hannon','Louisa V. Anthony','Loulia Sheppard','Siân Miller','Remi Savva','Mazena Puksto','Stacey Herbert'],
costumes:['Sammy Sheldon Differ']},
{title:'Prey',
titleCZ:'Predátor: Kořist',
year:2022,
runtime:99,
countries:['USA'],
genres:['Action','Horror','Sci-Fi','Thriller'],
director:['Dan Trachtenberg'],
actors:['Amber Midthunder','Dakota Beavers','Dane DiLiegro','Stormee Kipp','Michelle Thrush','Julian Black Antelope','Stefany Mathias','Mike Paterson','Nelson Leis','Troy Mundle'],
screenplay:['Patrick Aison'],
production:['John Davis','John Fox'],
music:['Sarah Schachner'],
camera:['Jeff Cutter'],
cut:['Claudia Castello','Angela M. Catanzaro'],
sound:['Craig Henighan','Will Files'],
scenography:['Kara Lindstrom'],
masks:['Jo-Dee Thomson']},
{title:'Ready or Not',
titleCZ:'Krvavá nevěsta',
year:2019,
runtime:96,
countries:['USA'],
genres:['Horror','Thriller','Comedy'],
director:['Matt Bettinelli-Olpin','Tyler Gillett'],
actors:['Samara Weaving','Adam Brody',"Mark O'Brien",'Henry Czerny','Andie MacDowell','Melanie Scrofano','Kristian Bruun','Nicky Guadagni','Elyse Levesque','John Ralston','Hanneke Talbot','Daniela Barbosa','Liam MacDonald','Celine Tsai','Etienne Kellici'],
screenplay:['Guy Busick','Ryan Murphy'],
production:['Bradley J. Fischer','William Sherak','James Vanderbilt','Tripp Vinson'],
music:['Brian Tyler'],
camera:['Brett Jutkiewicz'],
cut:['Terel Gibson'],
sound:['Christian T. Cooke'],
scenography:['Andrew M. Stearn'],
costumes:['Avery Plewes']},
{title:'American Psycho',
titleCZ:'Americké psycho',
year:2000,
runtime:101,
countries:['USA','Canada'],
genres:['Crime','Comedy','Drama'],
director:['Mary Harron'],
actors:['Christian Bale','Jared Leto','Reese Witherspoon','Chloë Sevigny','Willem Dafoe','Justin Theroux','Josh Lucas','Bill Sage','Samantha Mathis','Matt Ross','Cara Seymour','Guinevere Turner','Reg E. Cathey','Patricia Gage','Anthony Lemke','Landy Cannon','Catherine Black','Park Bench','Stephen Bogaert','Ross Gibby','Leanne Poirier Greenfield','Blair Williams'],
basedOn:['Bret Easton Ellis'],
screenplay:['Mary Harron','Guinevere Turner'],
production:['Gretchen McGowan','Chris Hanley','Edward R. Pressman'],
music:['John Cale'],
camera:['Andrzej Sekula'],
cut:['Andrew Marcus'],
sound:['Paul Urmson','Henry Embry'],
scenography:['Gideon Ponte'],
costumes:['Isis Mussenden']},
{title:'The Theory of Everything',
titleCZ:'Teorie všeho',
year:2014,
runtime:123,
countries:['UK'],
genres:['Biographic','Romance','Drama'],
director:['James Marsh'],
actors:['Eddie Redmayne','Felicity Jones','Emily Watson','Harry Lloyd','David Thewlis','Charlie Cox','Charlotte Hope','Adam Godley','Lesley Manville','Maxine Peake',"Hugh O'Brien",'Karol Steele','Scott Plumridge','Simon McBurney','Christian McKay','Gruffudd Glyn','Kenton Hall','Georg Nikoloff','Richard Cunningham','Victoria Emslie','Martyn Mayger','Traci McWain','Miroslav Zaruba','Shaun Newnham','Brian Woodward','Abigail Cruttenden','Raffiella Chapman','Chris Cowlin','Richard Banks','Michael Marcus','John W. G. Harley','Colin Taylor','Frank Leboeuf','Guy Oliver-Watts','Tobias James-Samuels','Lucy Chappell','Pamela Betsy Cooper','Shaun Lucas','Jon Wennington','Sophie Karl','Helen Kingston','Paul Longley','Tom Prior'],
basedOn:['Jane Hawking'],
screenplay:['Anthony McCarten'],
production:['Tim Bevan','Eric Fellner','Lisa Bruce'],
music:['Jóhann Jóhannsson'],
camera:['Benoît Delhomme'],
cut:['Jinx Godfrey'],
sound:['Glenn Freemantle','Colin Nicolson','Oleg Kulchytskyi'],
scenography:['John Paul Kelly','Claire Nia Richards'],
masks:['Laura Schalker','Jill Sweeney','Nora Robertson','Lesley Smith'],
costumes:['Steven Noble']},
{title:'Dawn of the Dead',
titleCZ:'Úsvit mrtvých',
year:2004,
runtime:'Alternativní 96 min',
countries:['USA','Canada','Japan','France'],
genres:['Horror','Thriller','Action'],
director:['Zack Snyder'],
actors:['Sarah Polley','Ving Rhames','Jake Weber','Mekhi Phifer','Ty Burrell','Michael Kelly','Kevin Zegers','Michael Barry','Lindy Booth','Jayne Eastwood','Boyd Banks','Inna Korobkina','Kim Poirier','Matt Frewer','Louis Ferreira','Hannah Lochner','Kim Roberts','Mike Realba','Laura de Carteret','Natalie Brown','Tom Savini','Ken Foree','Zack Snyder','Scott H. Reiniger','R.D. Reid','Sandy Jobin-Bevans','Georgia Craig','Tim Post','Bruce Bohne','Chris Gillett'],
screenplay:['James Gunn','George A. Romero'],
production:['Marc Abraham','Eric Newman','Richard P. Rubinstein'],
music:['Tyler Bates'],
camera:['Matthew F. Leonetti'],
cut:['Niven Howie'],
sound:['Frank A. Montaño'],
scenography:['Andrew Neskoromny'],
masks:['Lance Anderson','David LeRoy Anderson','Mario Cacioppo','Jo-Ann MacNeil','Sean Sansom','Diana Ladyshewsky','Carol Hartwick','Sean Sansom','Sarah Craig'],
costumes:['Denise Cronenberg']},
{title:'The Amazing Spider-Man 2',
titleCZ:'Amazing Spider-Man 2',
year:2014,
runtime:142,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['Marc Webb'],
actors:['Andrew Garfield','Emma Stone','Jamie Foxx','Dane DeHaan','Colm Feore','Felicity Jones','Paul Giamatti','Sally Field','Marton Csokas','Louis Cancelmi','Max Charles','Sarah Gadon','Martin Sheen','Chris Zylka','Denis Leary','Chris Cooper','B. J. Novak','Stan Lee','Lucas Till','Aidy Bryant','Jamie Lynn Concepcion','Evie Paller','James Colby','Dario Barosso','Kari Coleman','Doris McCarthy','Cris Williams','Charlie DePew','Bill Heck','Darren Whitfield','Steven Hauck','Kirrilee Berger','J.D. Walsh','Raymond Mamrak','Brian McElhaney','Daniel Gerroll','Sean Buttimer','Elwaldo Baptiste','Jorge Vega','Tanner Flood','Lynn Marocola','Reginald L. Barnes','Tug Coker','Drew Moore','Rikki-lee Millbank','Paul Urcioli','Anslem Richardson','Teddy Coluca','Jonathan Braylock','Paula Rossman','Robert Newman','Mark Doherty','Jamie Greco','Pat Kiernan','Atif Lanier','James McCauley'],
basedOn:['Stan Lee','Steve Ditko'],
screenplay:['Alex Kurtzman','Roberto Orci','Jeff Pinkner'],
production:['Avi Arad','Matthew Tolmach'],
music:['Hans Zimmer','Pharrell Williams','Johnny Marr','Steve Mazzaro','Junkie XL'],
camera:['Dan Mindel'],
cut:['Pietro Scalia'],
sound:['David Giammarco','Paul Massey','Addison Teague'],
scenography:['Mark Friedberg'],
masks:['Ve Neill','John Caglione','Jr.','Sarah Rubano','Peter Montagna','Tami Lane','Howard Berger','LaLette Littlejohn','Ketty Gonzalez'],
costumes:['Deborah L. Scott']},
{title:'Spider-Man 3',
titleCZ:'Spider-Man 3',
year:2007,
runtime:139,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['Sam Raimi'],
actors:['Tobey Maguire','Kirsten Dunst','Thomas Haden Church','James Franco','Dylan Baker','Elizabeth Banks','Topher Grace','Bryce Dallas Howard','Theresa Russell','Bill Nunn','James Cromwell','J.K. Simmons','Cliff Robertson','Ted Raimi','Perla Haney-Jardine','Rosemary Harris','Willem Dafoe','Joe Manganiello','Tim Maculan','Bruce Campbell','Elya Baskin','Mageina Tovah','Stan Lee','Michael Papajohn','Reynaldo Gallegos','Lucy Gordon','Nick Poltoranin','Halla','Arick Salmea','Ksen Shims','Brenna Roth','Natalie McNeil','Becky Ann Baker','Natalie Jones','Evelyn Vaccaro','Tony Besson','Carolyn Neff','Irina Costa','Crystal Marie Denha','Gregg Daniel','Toni Wynne','Robert Myers','Jen Oda','Dan Callahan','Timothy Patrick Quill','Mark Kubr','Marc Vann','Frank Anello','Claudia Katz Minnick','April Parker-Jones','Edward Padilla','John Paxton','Pierangeli Llinas','Andre B. Blake','Brittany Krall','Nick Vlassopoulos','Emily Eckes','Jimmy Star','Rogelio T. Ramos','Martha Millan','Grant Curtis','Emma Raimi'],
basedOn:['Stan Lee','Steve Ditko'],
screenplay:['Sam Raimi','Ivan Raimi','Alvin Sargent'],
production:['Avi Arad','Laura Ziskin','Grant Curtis'],
music:['Christopher Young'],
camera:['Bill Pope'],
cut:['Bob Murawski'],
sound:["Kevin O'Connell",'Greg P. Russell','Paul N.J. Ottosson'],
scenography:['Neil Spisak','J. Michael Riva','Suzan Wexler'],
masks:['Matthew W. Mungle','Patrick Alemi','Vivian Baker','Luisa Abel'],
costumes:['James Acheson']},
{title:'The Amazing Spider-Man',
titleCZ:'Amazing Spider-Man',
year:2012,
runtime:131,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['Marc Webb'],
actors:['Andrew Garfield','Emma Stone','Rhys Ifans','Sally Field','Martin Sheen','Denis Leary','C. Thomas Howell','Chris Zylka','Stan Lee','Irrfan Khan','Kelsey Asbille','Michael Massee','Michael Papajohn','Skyler Gisondo','Embeth Davidtz','Campbell Scott','Barbara Eve Harris','Teena Byrd','Amber Stevens West','James Chen','Jennifer Lyons','Max Charles','Kari Coleman','Kevin McCorkle','Charlie DePew','Keith Campbell','Leif Gantvoort','Ethan Cohn','Matt Martin','Andrea Sixtos','Alexander Bedria','Danielle Burgio','Ken Edling','Zoey Deutch','Adam Masnyk','Ty Upshaw','Miles Elliot','Jay Caputo','Stephen Stanton','Amanda MacDonald','Matthew Berke','Andy Pessoa'],
basedOn:['Stan Lee','Steve Ditko'],
screenplay:['Steve Kloves','James Vanderbilt','Alvin Sargent'],
production:['Avi Arad','Laura Ziskin','Matthew Tolmach'],
music:['James Horner'],
camera:['John Schwartzman'],
cut:['Pietro Scalia','Alan Edward Bell','Michael McCusker'],
sound:['David Giammarco','Paul Massey','Addison Teague','Shannon Mills','Deb Adair'],
scenography:['J. Michael Riva','Suzan Wexler'],
masks:['Ve Neill','Nikoletta Skarlatos','Kathrine Gordon','Christopher Allen Nelson','Lindsay MacGowan','Shane Mahan'],
costumes:['Kym Barrett']},
{title:'Shrek the Third',
titleCZ:'Shrek Třetí',
year:2007,
runtime:93,
countries:['USA'],
genres:['Animation','Adventure','Family','Comedy'],
director:['Chris Miller','Raman Hui'],
actors:['Mike Myers','Eddie Murphy','Cameron Diaz','Antonio Banderas','Julie Andrews','John Cleese','Rupert Everett','Eric Idle','Justin Timberlake','Larry King','Christopher Knights','John Krasinski','Ian McShane','Cheri Oteri','Amy Poehler','Seth Rogen','Maya Rudolph','Conrad Vernon','Kelly Asbury','Tom Kane','Tom McGrath','Chris Miller','Mark Valley','Amy Sedaris','Regis Philbin','Cody Cameron','Kari Wahlgren','Walt Dohrn','Aron Warner','Guillaume Aretos','Sean Bishop','Susanne Blakeslee','David P. Smith'],
basedOn:['William Steig'],
screenplay:['Jeffrey Price','Peter S. Seaman','Chris Miller','Aron Warner'],
production:['Andrew Adamson','John H. Williams','Aron Warner'],
music:['Harry Gregson-Williams'],
cut:['Joyce Arrastia','Mike Andrews'],
sound:['Richard L. Anderson','Andy Nelson','Anna Behlmer'],
scenography:['Guillaume Aretos'],
costumes:['Israel Segal']},
{title:'Shrek Forever After',
titleCZ:'Shrek: Zvonec a konec',
year:2010,
runtime:89,
countries:['USA'],
genres:['Animation','Adventure','Family','Comedy'],
director:['Mike Mitchell'],
actors:['Mike Myers','Eddie Murphy','Cameron Diaz','Antonio Banderas','Julie Andrews','Jon Hamm','John Cleese','Craig Robinson','Jane Lynch','Lake Bell','Kathy Griffin','Mary Kay Place','Kristen Schaal','Larry King','Christopher Knights','Conrad Vernon','Christopher Miller','Mike Mitchell','Regis Philbin','Cody Cameron','Ryan Seacrest','Ashley Boettcher','James Ryan','Walt Dohrn','Aron Warner','Billie Hayes'],
basedOn:['William Steig'],
screenplay:['Josh Klausner','Darren Lemke'],
production:['Gina Shay'],
music:['Harry Gregson-Williams'],
camera:['Yong Duk Jhun'],
cut:['Nick Fletcher'],
sound:['Ethan Van der Ryn','Andy Nelson','Anna Behlmer']},
{title:'Scouts Guide to the Zombie Apocalypse',
titleCZ:'Skautův průvodce zombie apokalypsou',
year:2015,
runtime:93,
countries:['USA'],
genres:['Horror','Action','Comedy'],
director:['Christopher Landon'],
actors:['Tye Sheridan','Logan Miller','Joey Morgan','Sarah Dumont','Halston Sage','Patrick Schwarzenegger','David Koechner','Cloris Leachman','Corsica Wilson','Elle Evans','Julie Paige','Niki Koss','Blake Anderson','Drew Droege','Laurel Harris','Sara Malakul Lane','Tom Gelo','Lukas Gage','Matty Cardarople','Nicole Fancher','Tony Gardner','Rebecca Rowley','Hiram A. Murray','Becktoria','Ardeshir Radpour','Arielle Raycene','Kelsey Delemar'],
screenplay:['Christopher Landon','Carrie Lee Wilson','Emi Močizuki'],
production:['Todd Garner','Andy Fickman'],
music:['Matthew Margeson'],
camera:['Brandon Trost'],
cut:['Jim Page'],
sound:['Adam Jenkins'],
scenography:['Nathan Amondson','Beauchamp Fontaine'],
masks:['Tony Gardner','Alexei Dmitiew','Vito Trotta','Thomas Floutz'],
costumes:['Marylou Lim']},
{title:'Free Guy',
titleCZ:'Free Guy: Hra na hrdinu',
year:2021,
runtime:115,
countries:['USA'],
genres:['Action','Adventure','Comedy','Sci-Fi'],
director:['Shawn Levy'],
actors:['Ryan Reynolds','Jodie Comer','Joe Keery','Lil Rel Howery','Taika Waititi','Utkarsh Ambudkar','Channing Tatum','Britne Oldford','Camille Kostek','Mark Lainer','Michael Tow','Aaron W. Reed','Hugh Jackman','Dwayne Johnson','Tina Fey','John Krasinski','Alex Trebek','Lara Spencer','Matty Cardarople','Eugene Nomura','Owen Burke','Chris Evans','Tait Fletcher','Octavia Chavez-Richmond','Michael Malvesti','Kenneth Israel','Naheem Garcia','Levon Panek'],
screenplay:['Matt Lieberman','Zak Penn'],
production:['Ryan Reynolds','Shawn Levy','Sarah Schechter','Greg Berlanti','Adam Kolbrenner'],
music:['Christophe Beck'],
camera:['George Richmond'],
cut:['Dean Zimmerman'],
sound:['Paul Massey','Craig Henighan','Ai-Ling Lee','Jack Whittaker'],
scenography:['Ethan Tobman','Steve Cooper'],
masks:['Angela Marinis','Kristen Barry','Lori McCoy-Bell'],
costumes:['Marlene Stewart']},
{title:'Shazam!',
titleCZ:'Shazam!',
year:2019,
runtime:132,
countries:['USA'],
genres:['Action','Adventure','Comedy','Fantasy'],
director:['David F. Sandberg'],
actors:['Zachary Levi','Mark Strong','Asher Angel','Jack Dylan Grazer','Adam Brody','Djimon Hounsou','Faithe Herman','Meagan Good','Grace Caroline Currey','Michelle Borth','Ian Chen','Ross Butler','Jovan Armand','D.J. Cotrona','Marta Milans','Cooper Andrews','John Glover','Andi Osho','Lotta Losten','Ava Preston','Carson MacCormac','Evan Marsh','Paul Braunstein','Caroline Palmer','Michael Xavier','Shayna Ryan','Ryan Handley','Shawn Stewart','Lisa Truong','Ethan Pugiotto','Craig Henry','Harper Gunn','Rachel Boyd','Seth Green','Simon Northwood','Nadine Roden','David Kohlsmith','Deborah Tennant','Stephannie Hawkins','Jhaleil Swaby','Hazel Gorin','Pearl Sun','Lisa Codrington','Jackson Reid','Darin De Paul','Jillian Rees-Brown'],
screenplay:['Henry Gayden'],
production:['Peter Safran'],
music:['Benjamin Wallfisch'],
camera:['Maxime Alexandre'],
cut:['Michel Aller'],
sound:["Kevin O'Connell",'Michael Keller'],
scenography:['Jennifer Spence','Shane Vieau'],
masks:['Mindy Hall','Jo-Ann MacNeil','Amber Chase','Samantha Terry'],
costumes:['Leah Butler']},
{title:'Shazam! Fury of the Gods',
titleCZ:'Shazam! Hněv bohů',
year:2023,
runtime:131,
countries:['USA'],
genres:['Action','Adventure','Comedy','Fantasy'],
director:['David F. Sandberg'],
actors:['Zachary Levi','Asher Angel','Jack Dylan Grazer','Adam Brody','Rachel Zegler','Lucy Liu','Djimon Hounsou','Helen Mirren','Ross Butler','Ian Chen','Meagan Good','Faithe Herman','Grace Caroline Currey','D.J. Cotrona','Jovan Armand','Marta Milans','Cooper Andrews','P.J. Byrne','Diedrich Bader','José Mora Ramos','Rizwan Manji','Derek Russo','David Lengel','Abby Glover','Bonnie Discepolo','Gal Gadot','Rick Andosca','Hillary Harley','Milli M.'],
screenplay:['Henry Gayden','Chris Morgan'],
production:['Peter Safran'],
music:['Christophe Beck'],
camera:['Gyula Pados'],
cut:['Michel Aller'],
scenography:['Paul Kirby','Danielle Berman'],
costumes:['Louise Mingenbach']},
{title:'Pirates of the Caribbean: On Stranger Tides',
titleCZ:'Piráti z Karibiku: Na vlnách podivna',
year:2011,
runtime:131,
countries:['USA'],
genres:['Adventure','Action','Fantasy','Comedy'],
director:['Rob Marshall'],
actors:['Johnny Depp','Penélope Cruz','Ian McShane','Geoffrey Rush','Kevin McNally','Sam Claflin','Àstrid Bergès-Frisbey','Stephen Graham','Richard Griffiths','Greg Ellis','Óscar Jaenada','Gemma Ward','Judi Dench','Robbie Kay','Bronson Webb','Steve Evets','Keith Richards','Sebastian Armesto','Luke Roberts','Anton Lesser','Roger Allam','Emilia Jones','Antoinette Kalaj','Chuck Williams','Deobia Oparei','Christopher Fairbank','Jody Halse','Katherine Denkinson','Hannah Walters','Daniel Ings','Ian Mercer',"Damian O'Hare",'Claira Watson Parr','Teresa Mahoney','Kristen StephensonPino','Gerard Monaco','Júki Macuzaki','Paul Bazely','Brea Berrett','Richard Thomson','Paul Hunter','Juan Carlos Vellido','Norberto Morán','Daphne Joy'],
basedOn:['Tim Powers'],
screenplay:['Ted Elliott','Terry Rossio'],
production:['Jerry Bruckheimer'],
music:['Hans Zimmer'],
camera:['Dariusz Wolski'],
cut:['David Brenner','Wyatt Smith'],
sound:['Paul Massey','Shannon Mills','Ivan Sharrock','Christopher Boyes'],
scenography:['John Myhre','Gordon Sim'],
masks:['Deborah Rutherford','Kimberly Carlson','Steve La Porte','Kenny Myers',"Peter 'Swords' King",'Mike Smithson','Nikoletta Skarlatos','Kenny Niederbaumer','Amy Byrne','Duncan Jarman','Sharon Martin','Kimberley Spiteri','Vivian Baker','Paul Gooch','Siân Miller','Joel Harlow','Kevin Kirkpatrick','Stephanie A. Fowler','Josh Weston'],
costumes:['Penny Rose']},
{title:"Pirates of the Caribbean: Dead Man's Chest",
titleCZ:'Piráti z Karibiku: Truhla mrtvého muže',
year:2006,
runtime:145,
countries:['USA'],
genres:['Adventure','Action','Fantasy','Comedy'],
director:['Gore Verbinski'],
actors:['Johnny Depp','Orlando Bloom','Keira Knightley','Stellan Skarsgård','Bill Nighy','Jack Davenport','Kevin McNally','Jonathan Pryce','Lee Arenberg','Mackenzie Crook','Tom Hollander','Naomie Harris','Alex Norton','David Bailie','Martin Klebba','Max Baker','Robbie Gee','Barry McEvoy','Geoffrey Rush','Reggie Lee','San Shella','Samantha Hanratty','David Schofield','Vanessa Branch','Luke de Woolfson','James S. Levine','Jonathan Kite','Jim Cody Williams','Ron Bottitta','Patrick Hume','Nicolas Read','Peter Donald Badalamenti II','Steve Speirs',"Derrick O'Connor",'Marco Khan',"Gerry O'Brien",'Christopher Adamson','Michael A. Levine','Dermot Keaney','Andy Beckwith','Lauren Maher','Faouzi Brahimi','Christopher S. Capp','David Sterne','Karly Rothenberg','Alexander Hall','Rohan Mehra','Natsuko Ohama','David Hadinger','Fred Maske','Travis Grenke'],
screenplay:['Ted Elliott','Terry Rossio'],
production:['Jerry Bruckheimer'],
music:['Hans Zimmer'],
camera:['Dariusz Wolski'],
cut:['Craig Wood','Stephen E. Rivkin'],
sound:['Christopher Boyes'],
scenography:['Rick Heinrichs','John Dexter'],
masks:['Deborah Rutherford','Ve Neill','John Blake','Martin Samuel','Nikoletta Skarlatos','Ken Diaz','Michele Tyminski Schoenbach','Colleen LaBaff','Joel Harlow','Maria Valdivia','Michelle Vittone-McNeil','Camille Friend',"Patrina O'Connor",'Ketty Gonzalez','Lucia Mace'],
costumes:['Penny Rose']},
{title:"Pirates of the Caribbean: At World's End",
titleCZ:'Piráti z Karibiku: Na konci světa',
year:2007,
runtime:161,
countries:['USA'],
genres:['Adventure','Action','Fantasy','Comedy'],
director:['Gore Verbinski'],
actors:['Johnny Depp','Orlando Bloom','Keira Knightley','Stellan Skarsgård','Bill Nighy','Yun-fat Chow','Geoffrey Rush','Jack Davenport','Kevin McNally','Naomie Harris','Tom Hollander','Jonathan Pryce','Lee Arenberg','Mackenzie Crook','David Bailie','Martin Klebba','Keith Richards','JB Blanc','Ghassan Massoud','Reggie Lee','Mark Hildreth','Dominic Scott Kay','Marshall Manesh','David Schofield','Art Hsu','Vanessa Branch','Hakeem Kae-Kazim','Omid Djalili','Stany Coppet','Patrick Hume','Greg Ellis','Peter Donald Badalamenti II','Sergio Calderón',"Barnett O'Hara",'Christopher Adamson','Dermot Keaney','Andy Beckwith','David Meunier','Marcel Iureș','Chris M. Allport','Lauren Maher','Ned Wertimer','Natalie Victoria','Christopher S. Capp','Michelle Lee','Alexandr Bargman','David Prak','Giles New','Angus Barnett','Takayo Fischer','Rick Mali','Rohan Mehra','Thomas Isao Morinaka','Max Valentine','Hans Hernke'],
screenplay:['Ted Elliott','Terry Rossio'],
production:['Jerry Bruckheimer'],
music:['Hans Zimmer'],
camera:['Dariusz Wolski'],
cut:['Craig Wood','Stephen E. Rivkin'],
sound:['Christopher Boyes','Christopher Scarabosio'],
scenography:['Rick Heinrichs','John Dexter'],
masks:['Ve Neill','Martin Samuel','Nikoletta Skarlatos','Ken Diaz','Joel Harlow','Ketty Gonzalez','Lucia Mace'],
costumes:['Penny Rose']},
{title:'Pirates of the Caribbean: Dead Men Tell No Tales',
titleCZ:'Piráti z Karibiku: Salazarova pomsta',
year:2017,
runtime:129,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['Joachim Rønning','Espen Sandberg'],
actors:['Johnny Depp','Javier Bardem','Brenton Thwaites','Kaya Scodelario','Kevin McNally','Golshifteh Farahani','David Wenham','Stephen Graham','Geoffrey Rush','Angus Barnett','Martin Klebba','Adam Brown','Giles New','Orlando Bloom','Keira Knightley','Paul McCartney','Danny Kirrane','Rodney Afif','Nico Cortez','Bruce Spence','Brooke Chamberlain','Piper Nairn','James Mackay','Bryan Probets','Alexander Scheer','Michael Dorman','Rohan Nichol','Andreas Sobik','Goran D. Kleut','Zoe Ventoura','James Fraser','Hannah Walters','Jonathan Elsom','K. Todd Freeman','Darcy Laurie','Jacob Elordi',"Ben O'Toole",'Anthony De La Torre','Joe Klocek','Lewis McGowan','Akos Armont','Jessica Green','Jamie Carter','Juan Carlos Vellido','Madison Haley','Alexandra MacDonald','Korey Williams','Salvatore Merenda','Daniel Millar','Mahesh Jadu','Damian Hussey','Mivon Prince-Leyva'],
screenplay:['Jeff Nathanson'],
production:['Jerry Bruckheimer'],
music:['Geoff Zanelli'],
camera:['Paul Cameron'],
cut:['Roger Barton','Leigh Folsom Boyd'],
sound:['Paul Massey','Jack Whittaker','Christopher Boyes','Pedro Sánchez Alonso','Scott Millan'],
scenography:['Nigel Phelps','John Dexter','Beverley Dunn'],
masks:["Peter 'Swords' King",'Rick Findlater','Kenny Niederbaumer','Damian Martin','Cora Montalban','Ozzy Alvarez','Adam Johansen','Jason Baird','Louise Coulston','Karen Kelly','Jaime Leigh McIntosh'],
costumes:['Penny Rose']},
{title:'Captain America: The First Avenger',
titleCZ:'Captain America: První Avenger',
year:2011,
runtime:119,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Joe Johnston'],
actors:['Chris Evans','Hugo Weaving','Tommy Lee Jones','Hayley Atwell','Stanley Tucci','Sebastian Stan','Dominic Cooper','Neal McDonough','Toby Jones','Anatole Taubman','Richard Armitage','Natalie Dormer','Sam Hoare','Derek Luke','JJ Feild','Amanda Righetti','Samuel L. Jackson','Stan Lee','Laura Haddock','Lex Shrapnel','Kevin Millington','Jenna Coleman','Sophie Colquhoun','Ben Batt','Bruno Ricci','Jack Gordon','William Hope','Spencer Garrett','Luke Allen-Gale','Raed Abbas','Kenneth Choi','Simon Kunz','Nick Hendrix','Jan Pohl','Marek Oravec','Sy Turner','Michael Swan','Rosanna Hoult','Paul Bergquist','Katherine Press','Michael Brandon','Anthony Milton','Graham Curry','Tobias James-Samuels','Peter Stark','Marcello Walton','Amanda Walker','Todd Von Joel','Ronan Raftery','David Bradley','Nicole Evans','David McKail','Nathan Nolan','Erich Redman'],
basedOn:['Joe Simon','Jack Kirby'],
screenplay:['Christopher Markus','Stephen McFeely'],
production:['Kevin Feige'],
music:['Alan Silvestri'],
camera:['Shelly Johnson'],
cut:['Robert Dalva','Jeffrey Ford'],
sound:['David Parker','Shannon Mills','Scott Millan','Christopher T. Silverman'],
scenography:['Rick Heinrichs','Jason Knox-Johnston','John Dexter','Phil Harvey','Phil Sims'],
masks:['David White','Ann Fenton','Rebecca Cole','Lisa Westcott','Josh Weston'],
costumes:['Anna Biedrzycka-Sheppard']},
{title:'Captain America: The Winter Soldier',
titleCZ:'Captain America: Návrat prvního Avengera',
year:2014,
runtime:136,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Anthony Russo','Joe Russo'],
actors:['Chris Evans','Scarlett Johansson','Samuel L. Jackson','Dominic Cooper','Sebastian Stan','Anthony Mackie','Cobie Smulders','Emily VanCamp','Robert Redford','Hayley Atwell','Toby Jones','Frank Grillo','Maximiliano Hernández','Callan Mulvey','Brett R. Miller','Georges St-Pierre','Stan Lee','Danny Pudi','Branka Katič','Aaron Taylor-Johnson','Elizabeth Olsen','Thomas Kretschmann','Jenny Agutter','Bernard White','Charlene May','Pat Healy','Ed Brubaker','Evan Parke','Adrian Denzel','Zack Duhame','Gary Sinise','Ricardo Chacon','Johanna McGinley','Nestor Serrano','Aaron Himelstein','Mitchell Yee','Eddie J. Fernandez','Les Mahoney','Ann Russo','Garry Shandling','Robert Clotworthy','Chad Todhunter','Alan Dale','Andrew Constantini','Justin Lally','Derek Talib','Drew Breeden','Layla Cushman','Jason L. Wang','Vimalraj Jayaseelan','Angela Russo-Otstot','Roshawn Franklin','Debbie Scaletta','Michael Eric','June Christopher','Xavier Wolf','Derek Hughes','Bill Kennedy'],
basedOn:['Joe Simon','Jack Kirby','Ed Brubaker','Don Heck'],
screenplay:['Christopher Markus','Stephen McFeely'],
production:['Kevin Feige'],
music:['Henry Jackman','Matthew Margeson'],
camera:['Trent Opaloch'],
cut:['Jeffrey Ford','Matthew Schmidt'],
sound:['Al Nelson','Juan Peralta','Daniel Laurie','Shannon Mills','Christopher Scarabosio','Petur Hliddal','Tom Johnson'],
scenography:['Peter Wenham'],
masks:['Heba Thorisdottir','Allan A. Apone','Lisa Rocco','Camille Friend','Sherri Bramlett'],
costumes:['Judianna Makovsky']},
{title:'Captain America',
titleCZ:'Captain America',
year:1990,
runtime:97,
countries:['USA','Jugoslávie'],
genres:['Action','Adventure','Sci-Fi'],
director:['Albert Pyun'],
actors:['Matt Salinger','Ronny Cox','Ned Beatty','Darren McGavin','Michael Nouri','Melinda Dillon','Bill Mumy','Francesca Neri','Robert Egon','Relja Bašić','Scott Paulin','Jason Brooks','Ann Bell','Kim Gillingham','Thomas Beatty','Wayde Preston','Mustafa Nadarevic','Antun Nalis','Velimir Chytil','Garette Ratliff Henson','Norbert Weisser','Demeter Bitenc','Zoran Pokupec','Carla Cassola','Galiano Pahor'],
screenplay:['Stephen Tolkin'],
production:['Menahem Golan'],
music:['Barry Goldberg'],
camera:['Philip Alan Waters'],
cut:['Jon Poll'],
sound:['Richard King','Frank A. Montaño','Patrick Cyccone Jr.'],
scenography:['Douglas H. Leonard','Marc Dabe'],
masks:['John Logan','Greg Cannom'],
costumes:['Heidi Kaczenski']},
{title:'A Quiet Place',
titleCZ:'Tiché místo',
year:2018,
runtime:90,
countries:['USA'],
genres:['Horror','Thriller','Sci-Fi','Drama'],
director:['John Krasinski'],
actors:['Emily Blunt','John Krasinski','Noah Jupe','Millicent Simmonds','Cade Woodward','Leon Russom','Doris McCarthy'],
screenplay:['John Krasinski','Scott Beck','Bryan Woods'],
production:['Michael Bay','Andrew Form','Brad Fuller'],
music:['Marco Beltrami'],
camera:['Charlotte Bruus Christensen'],
cut:['Christopher Tellefsen'],
sound:['Erik Aadahl','Brandon Proctor','Ethan Van der Ryn','Michael Barosky'],
scenography:['Jeffrey Beecroft','Heather Loeffler']},
{title:'Batman v Superman: Dawn of Justice',
titleCZ:'Batman v Superman: Úsvit spravedlnosti',
year:2016,
runtime:151,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action'],
director:['Zack Snyder'],
actors:['Ben Affleck','Henry Cavill','Amy Adams','Jesse Eisenberg','Diane Lane','Laurence Fishburne','Jeremy Irons','Holly Hunter','Gal Gadot','Kevin Costner','Scoot McNairy','Callan Mulvey','Tao Okamoto','Ray Fisher','Jason Momoa','Jena Malone','Ezra Miller','Bailey Chase','Michael Cassidy','Christina Wren','Harry Lennix','Dan Amboyer','Nicole Forester','Sammi Rotibi','Ele Bardha','Brian Boland','Rebecca Buller','Patrick Wilson','Gordon Michaels','Jalene Mack','Jay Adams','Joe Cipriano','Marko Caka','Sal Lopez','Michael Shannon','Will Blagrove','Abigail Kuklis','Walbert Beltran','Harley Wallen','Jeffrey Dean Morgan','Anderson Cooper','Brandon Spink','Robin Atkin Downes','Joe Morton','Carla Gugino','Lauren Cohan','Nate Hammer','Russ Panzarella','Sebastian Sozzi','Charlie Rose','Alma Martinez','Jon Stewart','Julius Tennon','Tiffany L. Addison','Mike Dargatis','Jade Chynoweth','Calhoun Koenig','Greg Violand','Coburn Goss',"Soledad O'Brien",'Monib Abhat','Issac Ryan Brown','Stephanie Koenig','Esodie Geiger','Lulu Dahl','Michael James Alexander','Nene Nwoko','Wunmi Mosaku','Jimmy Star','Barton Bund','Owais Ahmed','Debbie Scaletta','Christopher De Stefano','Shannon Garnett','Ardeshir Radpour','Taras Los','Tiffany Bedwell','Jonathan Stanley','Satori Shakoor','Kiff VandenHeuvel','Caleb Silvers','Brooke Baldwin'],
basedOn:['Jerry Siegel','Joe Shuster','Bob Kane','Bill Finger'],
screenplay:['Chris Terrio','David S. Goyer'],
production:['Charles Roven','Deborah Snyder'],
music:['Hans Zimmer','Junkie XL'],
camera:['Larry Fong'],
cut:['David Brenner'],
sound:['Michael Keller','Chuck Michael'],
scenography:['Patrick Tatopoulos',"Carolyn 'Cal' Loucks"],
masks:['Lillian Sakamaki','Kate Biscoe','Victoria Down','Thomas Floutz'],
costumes:['Michael Wilkinson']},
{title:'Spider-Man: Homecoming',
titleCZ:'Spider-Man: Homecoming',
year:2017,
runtime:133,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Jon Watts'],
actors:['Tom Holland','Michael Keaton','Robert Downey Jr.','Marisa Tomei','Jon Favreau','Gwyneth Paltrow','Zendaya','Donald Glover','Jacob Batalon','Laura Harrier','Tony Revolori','Bokeem Woodbine','Tyne Daly','Abraham Attah','Hannibal Buress','Kenneth Choi','Selenis Leyva','Angourie Rice','Martin Starr','Garcelle Beauvais','Michael Chernus','Michael Mando','Logan Marshall-Green','Jennifer Connelly','Gary Weeks','Christopher Berry','Tunde Adebimpe','Tiffany Espensen','Michael Barbieri','Josie Totah','Hemky Madera','Bob Adrian','Stan Lee','Wayne Pére','Chris Evans','Kerry Condon','Amy Hill','Martha Kelly','Jennifer Kim','Andy Powers','Jorge Lendeborg Jr.','Liza Fagin','Isabella Amara','Salena Qureshi','Sondra James','Zach Cherry','Faith Logan','Scarlett Johansson','Don Cheadle','Chadwick Boseman','Paul Rudd','Gary Richardson','Friday Chamberlain','Chuck Chapman','Kirk R. Thatcher','Madison Hine','Chris Silcox','Faith Monique','Lenny Lenox','Nickolas Wolf','Miles Mussenden','Ethan Dizon','Hunter Romanillos','Darshan Patel'],
basedOn:['Stan Lee','Steve Ditko'],
screenplay:['John Francis Daley','Jonathan Goldstein','Erik Sommers','Jon Watts','Christopher Ford','Chris McKenna'],
production:['Kevin Feige','Amy Pascal'],
music:['Michael Giacchino'],
camera:['Salvatore Totino'],
cut:['Debbie Berman','Dan Lebental'],
sound:["Kevin O'Connell",'Tony Lamberti'],
scenography:['Oliver Scholl','Gene Serdena'],
masks:['John Blake','Heba Thorisdottir','Björn Rehbein','Greg Funk','Jack Lazzaro'],
costumes:['Louise Frogley']},
{title:'Spider-Man: Far from Home',
titleCZ:'Spider-Man: Daleko od domova',
year:2019,
runtime:130,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Jon Watts'],
actors:['Tom Holland','Samuel L. Jackson','Jake Gyllenhaal','Marisa Tomei','Jon Favreau','Zendaya','Jacob Batalon','Tony Revolori','Angourie Rice','Remy Hii','Martin Starr','J.B. Smoove','Jorge Lendeborg Jr.','Cobie Smulders','Numan Acar','Zach Barack','Toni Garrn','Peter Billingsley','Nicholas Gleaves','Claire Rushbrook','J.K. Simmons','Jeroen van Koningsbrugge','Michael de Roos','Sergio Pierattini','Anjana Vasan','Giada Benedetti','Lukáš Bech','Alessandro Giuggioli','Michal Kubal','Darren Lee Campbell','Tony Mašek','Meagan Holder','Anthony Molinari','Massi Furlan','Gianni Calchetti','Jake Hanson','Martin Čermák','Amanda Musso','Clare Dunne','Ilya Tank Shilov','Jan-Paul Buijs','Faith Tarby','Rocco Wu','Kat Leroy','Yasmin Mwanza','Tony Mardon','Evelyn Mok','Pat Kiernan','Joshua Sinclair-Evans','Lucas Antoine Starrets','Karen-J Sear','Charlie Esquér','Zoha Rahman','Daniel Olson'],
basedOn:['Stan Lee','Steve Ditko'],
screenplay:['Erik Sommers','Chris McKenna'],
production:['Kevin Feige','Amy Pascal'],
music:['Michael Giacchino'],
camera:['Matthew J. Lloyd'],
cut:['Leigh Folsom Boyd','Dan Lebental'],
sound:["Kevin O'Connell",'Tony Lamberti'],
scenography:['Claude Paré','Grant Armstrong','Tina Jones','Livia Borgognoni','Harry E. Otto','Delia Piccirilli'],
masks:["Peter 'Swords' King",'Donald Mowat','Heba Thorisdottir','Vasilios Tanis','Matiki Anoff','Nicola Pope'],
costumes:['Anna Biedrzycka-Sheppard']},
{title:'Captain Marvel',
titleCZ:'Captain Marvel',
year:2019,
runtime:124,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Anna Boden','Ryan Fleck'],
actors:['Brie Larson','Samuel L. Jackson','Jude Law','Ben Mendelsohn','Annette Bening','Lashana Lynch','Djimon Hounsou','Gemma Chan','Clark Gregg','Lee Pace','Akira Akbar','Rune Temte','Algenis Perez Soto','Mckenna Grace','Chuku Modu','Vik Sahay','Colin Ford','Kenneth Mitchell','Pete Ploszek','Emily Ozrey','Stan Lee','Robert Kazinsky','Nelson Franklin','Patrick Brennan','Patrick Gallagher','Ana Ayora','Matthew Bellows','Duane Henry','Scarlett Johansson','Chris Evans','Mark Ruffalo','Don Cheadle','James Morrison','Anthony Molinari','Andre Franco','Gaige Chaturantabut','Matthew Maher','Stephen A. Chang','Reggie','Diana Toshiko',"Vinny O'Brien",'Marilyn Brett'],
screenplay:['Anna Boden','Ryan Fleck','Geneva Robertson-Dworet'],
production:['Kevin Feige'],
music:['Pinar Toprak'],
camera:['Ben Davis'],
cut:['Debbie Berman','Elliot Graham'],
sound:['Gwendolyn Yates Whittle','Lora Hirschberg','Christopher Boyes'],
scenography:['Andy Nicholson','Elena Albanese'],
masks:['Alexei Dmitiew','Heba Thorisdottir','Brian Sipe','Louisa V. Anthony','Christopher Allen Nelson','Lisa Rocco','Camille Friend','Ahou Mofid','Jaime Leigh McIntosh'],
costumes:['Sanja Milkovic Hays']},
{title:'Iron Man 2',
titleCZ:'Iron Man 2',
year:2010,
runtime:119,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Jon Favreau'],
actors:['Robert Downey Jr.','Mickey Rourke','Samuel L. Jackson','Scarlett Johansson','Gwyneth Paltrow','Don Cheadle','Sam Rockwell','Jon Favreau','Kate Mara','Olivia Munn','Stan Lee','Tim Guinee','Paul Bettany','Clark Gregg','Helena Mattsson','Philippe Bergeron','John Slattery','Garry Shandling','Katie Cleary','Leslie Bibb','Cassity Atkins','Torin Sixx','Tony Nevada','Ted Alderman','John Ceallach','Anya Monzikova','Ayelet Ben-Shahar','Krystal Ellsworth','Rachele Brooke Smith','Karim Saleh','Elon Musk',"Bill O'Reilly",'Jee-Yun Lee','Larry Ellison','Ed Moy','Mark Kubr','Rosa Costanza','Tanoai Reed','Jevgenij Lazarev','Nadine Ellis','Christopher Maleki','Alejandro Patiño','Jenny Robinson','Max Favreau','Davin Ransom','Phillipe Simon'],
basedOn:['Stan Lee','Jack Kirby','Larry Lieber','Don Heck'],
screenplay:['Justin Theroux'],
production:['Kevin Feige'],
music:['John Debney'],
camera:['Matthew Libatique'],
cut:['Dan Lebental','Richard Pearson'],
sound:['Frank Eulner','Gary Summers','Lora Hirschberg','Christopher Boyes','Mark Ulano','Christopher T. Silverman'],
scenography:['J. Michael Riva','Suzan Wexler'],
masks:['John Blake','Allan A. Apone','Arjen Tuiten','David Abbott','Kay Georgiou','Kate Biscoe','Lori McCoy-Bell','Steven R. Soussanna'],
costumes:['Mary Zophres']},
{title:'Iron Man Three',
titleCZ:'Iron Man 3',
year:2013,
runtime:130,
countries:['USA','China'],
genres:['Sci-Fi','Fantasy','Action','Adventure'],
director:['Shane Black'],
actors:['Robert Downey Jr.','Gwyneth Paltrow','Don Cheadle','Ben Kingsley','Paul Bettany','Rebecca Hall','Guy Pearce','James Badge Dale','Jon Favreau','Stan Lee','Stephanie Szostak','Yvonne Zima','Justin Wheelon','Bridger Zadina','Bingbing Fan','Ty Simpkins','Mark Ruffalo','William Sadler','Miguel Ferrer','Adam Pally','Rebecca Mader','Shaun Toub','Jan Broberg','Bill Maher','Joan Rivers','Linden Ashby','Dale Dickey','Corey Hawkins','Lorynn York','Monique Ganderton','Noah Visconti','Rustam Branaman','Megan Henderson','Anthony Reynolds','Tom Virtue','Mitchell Yee','Jenna Ortega','Justin Kucsulain','Cody Lowe','Martin Škrtel','John Eddins','Joshua Harto','Mark Kubr','Tara Macken','Jerry Winsett','Luciana Faulhaber','Aja Frary','Ashley Hamilton','Steve Wilder','Kary Musa','Toochukwu T.C. Anyachonkeya','Kendrick Cross','Irene Santiago','Nate Bynum','Fernando Chien','Drew Day','Samuel Le','Stephen L. Cohen','Jeffrey Hersh','Eric Perez','David W. LeBlanc','Joseph Velez','Lorraine Caporaso','Mike Guzman','Roy McCrerey','Jimmy Star','Indra Patel','Patrick H. Fox','Pete Williams','Serdar Kalsin','Elizabeth Becka','Christopher De Stefano','Christina Rodriguez','Keri Maletto','Joseph Akharoh Jr.','Mariam Devash','Jonathan G Rivera','Katja Rauhe','Raul Colon','Dave Jia','Michael Mariano','Frank Scozzari','Pat Kiernan','Josh Elliott','Wesley Thompson','J. Mardrice Henderson','Angela Davis','Brycen Counts'],
basedOn:['Stan Lee','Jack Kirby','Larry Lieber','Don Heck'],
screenplay:['Shane Black','Drew Pearce'],
production:['Kevin Feige'],
music:['Brian Tyler'],
camera:['John Toll'],
cut:['Peter S. Elliot','Jeffrey Ford'],
sound:['Michael Prestwood Smith','Michael Keller','Mark P. Stoeckinger'],
scenography:['Bill Brzeski','Danielle Berman','Jay Pelissier'],
masks:['Kevin Haney','John Blake','Heba Thorisdottir','Allan A. Apone','Kimberley Spiteri','Kay Georgiou','Kate Biscoe','Cecilia Verardi'],
costumes:['Louise Frogley','Trysha Bakker']},
{title:'The Incredible Hulk',
titleCZ:'Neuvěřitelný Hulk',
year:2008,
runtime:112,
countries:['USA'],
genres:['Action','Thriller','Sci-Fi'],
director:['Louis Leterrier'],
actors:['Edward Norton','Liv Tyler','Tim Roth','William Hurt','Tim Blake Nelson','Ty Burrell','Christina Cabot','Peter Mensah','Lou Ferrigno','Greg Bryk','Martin Starr','Chris Ratz','Genelle Williams','Lenka Matuska','Kristina Pesic','Robert Downey Jr.','Stan Lee','Michael Kenneth Williams','Tamsen McDonough','Wayne Robson','Joris Jarsky','Chris Owens','Grant Nickalls','Dylan Taylor','Maxwell McCabe-Lokos','Jim Annan','Arnold Pinnock','Russell Yuen','Aaron Berg','David Meunier','Rick Cordeiro','David Collins','Tony Nappo','Jee-Yun Lee','Stephen Broussard','John MacDonald','James Downing','Matt Purdy','Débora Nascimento','Max Topplin','Moses Nyarko','Desmond Campbell','Tre Smith','Paul Soles','Wes Berger','Jay Hunter'],
screenplay:['Zak Penn'],
production:['Gale Anne Hurd','Kevin Feige','Avi Arad'],
music:['Craig Armstrong'],
camera:['Peter Menzies Jr.'],
cut:['John Wright','Rick Shaine','Vincent Tabaillon'],
sound:['Eric Warren Lindemann','Chris Carpenter','Greg Hedgepath','Andy Koyama'],
scenography:['Kirk M. Petruccelli',"Carolyn 'Cal' Loucks"],
masks:['Jordan Samuel'],
costumes:['Denise Cronenberg','Renee Fontana']},
{title:'Avengers: Age of Ultron',
titleCZ:'Avengers: Age of Ultron',
year:2015,
runtime:141,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Fantasy'],
director:['Joss Whedon'],
actors:['Chris Evans','Robert Downey Jr.','Chris Hemsworth','Mark Ruffalo','Scarlett Johansson','Jeremy Renner','Samuel L. Jackson','Cobie Smulders','James Spader','Aaron Taylor-Johnson','Elizabeth Olsen','Thomas Kretschmann','Don Cheadle','Paul Bettany','Stellan Skarsgård','Linda Cardellini','Hayley Atwell','Andy Serkis','Idris Elba','Anthony Mackie','Lou Ferrigno','Chelsea Li','Julia Krynke','Claudia Kim','Julie Delpy','Stan Lee','Henry Goodman','Aaron Himelstein','Josh Brolin','Francesca Bennett','Alexandra Doyle','Dominique Provost-Chalkley','Mark Haldor','Bentley Kalu','Attila G. Kerekes','Kornelia Horvath','Julian Bleach','Marianna Dean','Tim Powell','Nondumiso Tembe','Vuyo Dabula','Mandla Gaduka','Aurora Fearnley','Barry Aird','Michael Chapman','Ingvild Deila','Ben Sakamoto','Lex Lang'],
basedOn:['Stan Lee','Jack Kirby','Don Heck'],
screenplay:['Joss Whedon'],
production:['Kevin Feige'],
music:['Brian Tyler','Danny Elfman'],
camera:['Ben Davis'],
cut:['Lisa Lassek','Jeffrey Ford'],
sound:['Frank Eulner','Gary Summers','David Acord','Lora Hirschberg','Christopher Boyes'],
scenography:['Charles Wood','Ray Chan','Jordan Crockett','Richard Roberts','Domenico Sica','Phil Sims'],
masks:['Joceline Andrews','Jeremy Woodhead','John Blake','Allan A. Apone','Nora Robertson','Jessica Brooks','Loulia Sheppard','Moira Thomson','Matteo Silvi','Zoe Tahir'],
costumes:['Alexandra Byrne']},
{title:'Doctor Strange',
titleCZ:'Doktor Strange',
year:2016,
runtime:115,
countries:['USA'],
genres:['Action','Adventure','Fantasy','Sci-Fi'],
director:['Scott Derrickson'],
actors:['Benedict Cumberbatch','Chiwetel Ejiofor','Rachel McAdams','Benedict Wong','Mads Mikkelsen','Tilda Swinton','Michael Stuhlbarg','Benjamin Bratt','Scott Adkins','Zara Phythian','Meera Syal','Amy Landecker','Kei Miura','Daniel Eghan','Chris Hemsworth','Stan Lee','Guillaume Faure','Faith Logan','Shilpa Maskey','Rock Ryan','Katrina Durden','Annarie Boor','Alaa Safi','Pat Kiernan','Topo Wresniwiro','Mark Anthony Brighton'],
basedOn:['Steve Ditko'],
screenplay:['Jon Spaihts','Scott Derrickson','C. Robert Cargill'],
production:['Kevin Feige'],
music:['Michael Giacchino'],
camera:['Ben Davis'],
cut:['Wyatt Smith','Sabrina Plisco'],
sound:['Juan Peralta','Daniel Laurie','Shannon Mills','Tom Johnson'],
scenography:['Charles Wood','Ray Chan','Jordan Crockett'],
masks:['Sharon Martin','Nora Robertson','Donald McInnes','Jessica Brooks','Björn Rehbein'],
costumes:['Alexandra Byrne']},
{title:'Doctor Strange in the Multiverse of Madness',
titleCZ:'Doctor Strange v mnohovesmíru šílenství',
year:2022,
runtime:127,
countries:['USA'],
genres:['Action','Fantasy','Horror'],
director:['Sam Raimi'],
actors:['Benedict Cumberbatch','Elizabeth Olsen','Benedict Wong','Xochitl Gomez','Chiwetel Ejiofor','Rachel McAdams','Julian Hilliard','Jett Klyne','Sheila Atim','Adam Hugill','Ako Mitchell','Michael Stuhlbarg','Patrick Stewart','Lashana Lynch','Hayley Atwell','John Krasinski','Anson Mount','Bruce Campbell','Topo Wresniwiro','Momo Yeung','David K.S. Tse','Nuakai Aru','Joshua Peace','Victoria Sterling','Michael Waldron','Charlize Theron','Jordan Alexandra','Cecilia Appiah'],
basedOn:['Stan Lee','Steve Ditko'],
screenplay:['Michael Waldron'],
production:['Kevin Feige'],
music:['Danny Elfman'],
camera:['John Mathieson'],
cut:['Bob Murawski','Tia Nolan'],
sound:['Juan Peralta','Jussi Tegelman','Addison Teague','Lora Hirschberg','Katy Wood'],
scenography:['Charles Wood','Julia Dehoff'],
masks:['Lizzie Yianni Georgiou','Donald McInnes','Barrie Gower'],
costumes:['Graham Churchyard']},
{title:'Black Widow',
titleCZ:'Black Widow',
year:2021,
runtime:134,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Cate Shortland'],
actors:['Scarlett Johansson','Florence Pugh','David Harbour','Rachel Weisz','Ray Winstone','Ever Anderson','Violet McGraw','O.T. Fagbenle','William Hurt','Olga Kurylenko','Julia Louis-Dreyfus','Ryan Kiera Armstrong','Liani Samuel','Michelle Lee','C.C. Smiff','Nanna Blondell','Yolanda Lynes','Jade Ma','Jade Xu','Enikő Fülöp','Georgia Curtis','Ione Butler','Kurt Yue','Marcel Dorian','Olivier Richters','Andrew Byron','Robert Pralgo','Jose Miguel Vasquez','Aria Brooks','Valentina Herrera','Aubrey Cleland','Jordyn Curet','John Wolfe','Joakim Skarli','Andrew Tull','Danielle Jalade','Lauren Okadigbo','Shaina West','Rhonda Johnson Dents'],
basedOn:['Stan Lee','Don Heck','Don Rico'],
screenplay:['Eric Pearson'],
production:['Kevin Feige'],
music:['Lorne Balfe'],
camera:['Gabriel Beristain'],
cut:['Leigh Folsom Boyd','Matthew Schmidt'],
sound:['Juan Peralta','Lora Hirschberg','Keith Kohn','Daniel Laurie','Shannon Mills','Chris Munro'],
scenography:['Charles Wood','Clint Wallace','Connery Davoodian'],
masks:['Luca Major','Brigitta Mogony','Paul Gooch','Bonnie Walker','Tammi Terrell','Daniele Nastasi','Jessica Lou Allen'],
costumes:['Jany Temime']},
{title:'Shang-Chi and the Legend of the Ten Rings',
titleCZ:'Shang-Chi a legenda o deseti prstenech',
year:2021,
runtime:133,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['Destin Daniel Cretton'],
actors:['Simu Liu','Tony Chiu-wai Leung','Awkwafina',"Meng'er Zhang",'Fala Chen','Michelle Yeoh','Wah Yuen','Florian Munteanu','Ben Kingsley','Jayden Zhang','Stephanie Hsu','Kunal Dudheker','Tsai Chin','Jodi Long','Ronny Chieng','Fernando Chien','Michael-Anthony Taylor','Zach Cherry','Raymond Ma','Lynette Curran','Benedict Wong','Jade Xu','Dee Bradley Baker','Tim Roth','Brie Larson','Mark Ruffalo','Hannah Kim','Andy Le','Dallas Liu'],
screenplay:['Dave Callaham','Destin Daniel Cretton','Andrew Lanham'],
production:['Kevin Feige','Jonathan Schwartz'],
music:['Joel P. West'],
camera:['Bill Pope'],
cut:['Elísabet Ronaldsdóttir','Nat Sanders','Harry Yoon'],
sound:['Lora Hirschberg','Katy Wood','Qianbaihui Yang','Sona Balam','Onnalee Blank','Jeremy Bowker','Peter J. Devlin','J.R. Grubbs','Jack Whittaker'],
scenography:['Sue Chan','David A. Cook','Mark Dawson','Rachel Robb Kondrath'],
masks:['Rick Findlater','Vardit Lahav'],
costumes:['Kym Barrett']},
{title:'The Marvels',
titleCZ:'Marvels',
year:2023,
runtime:105,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Nia DaCosta'],
actors:['Brie Larson','Iman Vellani','Teyonah Parris','Samuel L. Jackson','Zawe Ashton','Lashana Lynch','Mohan Kapur','Zenobia Shroff','Seo-joon Park','Reggie','Saagar Shaikh','Gary Lewis','Leila Farzad','Tessa Thompson','Hailee Steinfeld','Kelsey Grammer','Abraham Popoola'],
screenplay:['Megan McDonnell'],
production:['Kevin Feige'],
music:['Laura Karpman'],
camera:['Sean Bobbitt'],
cut:['Catrin Hedström','Evan Schiff'],
sound:['Christopher Boyes'],
scenography:['Cara Brower'],
costumes:['Lindsay Pugh']},
{title:'Werewolf by Night',
titleCZ:'Vlkodlak: Noční lovec',
year:2022,
runtime:54,
countries:['USA'],
genres:['Action','Adventure','Fantasy','Horror'],
director:['Michael Giacchino'],
actors:['Gael García Bernal','Laura Donnelly','Harriet Sansom Harris','Eugenie Bondurant','Kirk R. Thatcher','Leonardo Nam','Al Hamacher'],
screenplay:['Heather Quinn'],
production:['Jaycob Maya'],
music:['Michael Giacchino'],
camera:['Zoe White'],
cut:['Jaycob Maya'],
scenography:['Maya Shimoguchi'],
masks:['Ellen Arden'],
costumes:['Mayes C. Rubeo']},
{title:'Blade',
titleCZ:'Blade',
year:1998,
runtime:115,
countries:['USA'],
genres:['Action','Fantasy','Horror'],
director:['Stephen Norrington'],
actors:['Wesley Snipes','Stephen Dorff','Kris Kristofferson',"N'Bushe Wright",'Donal Logue','Udo Kier','Traci Lords','Arly Jover','Kevin Patrick Walls','Tim Guinee','Sanaa Lathan','Eric Edwards','Shannon Lee','Matt Schulze','Jenya Lano','Stephen Norrington','Gerald Okamura','John Enos III','D.V. DeVincentis','Ted King','Kenny Johnson','Andray Johnson','Marcus Aurelius','Al Goto','Judson Scott','Frankie Ray','Henry Kingi','Lyle Conway','Jeff Imada'],
basedOn:['Marv Wolfman'],
screenplay:['David S. Goyer'],
production:['Robert Engelman','Wesley Snipes','Peter Frankfurt'],
music:['Mark Isham'],
camera:['Theo van de Sande'],
cut:['Paul Rubell'],
sound:['Ken Teaney','Marshall Garlington'],
scenography:['Kirk M. Petruccelli','Greg J. Grande'],
masks:['Michael Germain','Paul Jones','Greg Cannom','Stephen Abrums','Stephen Norrington'],
costumes:['Sanja Milkovic Hays']},
{title:'Blade II',
titleCZ:'Blade 2',
year:2002,
runtime:112,
countries:['USA','Germany'],
genres:['Action','Fantasy','Horror','Thriller'],
director:['Guillermo del Toro'],
actors:['Wesley Snipes','Kris Kristofferson','Ron Perlman','Leonor Varela','Norman Reedus','Thomas Kretschmann','Luke Goss','Matt Schulze','Danny John-Jules','Donnie Yen','Karel Roden','Marit Velle Kile','Tony Curran','Daz Crawford','Santiago Segura','Marek Vašut','Jiří Maria Sieber','Jan Révai','Ladislav Beran','Jamie Wilson','Karel Vávrovec','Paul Kasey','Jan Loukota','Samuel Le','John Salvitti','Marian Malovanik','Andrea Miltner','Pete Lee-Wilson','Jan Bursa'],
basedOn:['Marv Wolfman'],
screenplay:['David S. Goyer'],
production:['Wesley Snipes','Patrick J. Palmer','Peter Frankfurt','Tomáš Krejčí'],
music:['Marco Beltrami'],
camera:['Gabriel Beristain'],
cut:['Peter Amundson'],
sound:['Mathew Waters','Michael Keller','Mark Holding'],
scenography:['Carol Spier','Peter P. Nicolakakos','Jeffrey Kushon'],
masks:['Amber Sibley','Michelle Taylor','David White','Marese Langan','Greg Funk','Barrie Gower','Thomas Floutz'],
costumes:['Wendy Partridge']},
{title:'Blade: Trinity',
titleCZ:'Blade: Trinity',
year:2004,
runtime:109,
countries:['USA'],
genres:['Action','Adventure','Fantasy','Thriller'],
director:['David S. Goyer'],
actors:['Wesley Snipes','Kris Kristofferson','Jessica Biel','Ryan Reynolds','Parker Posey','Dominic Purcell','John Michael Higgins','James Remar','Eric Bogosian','Patton Oswalt','Callum Keith Rennie','Natasha Lyonne','Paul Levesque','Haili Page','Erica Cerra','Françoise Yip','Paul Anthony','Birkett Turton','Brian Steele','Gabriel Beristain','Kimani Ray Smith','Alejandro Rae','Scott Heindl','Kwesi Ameyaw','Ron Selmour','Mark Berry','Michael Anthony Rawlins','Christopher Heyerdahl','Simon Pidgeon','Darryl Scheelar'],
basedOn:['Marv Wolfman'],
screenplay:['David S. Goyer'],
production:['Wesley Snipes','Lynn Harris','Peter Frankfurt'],
music:['Ramin Djawadi','RZA'],
camera:['Gabriel Beristain'],
cut:['Howard E. Smith','Conrad Smart'],
sound:['Skip Lievsay'],
scenography:['Lucrezia Casta','Chris Gorak','Tedd Kuchera'],
masks:['Mike Elizalde','Lisa Love','Bill Terezakis','Patricia Murray'],
costumes:['Laura Jean Shannon']},
{title:'Elektra',
titleCZ:'Elektra',
year:2005,
runtime:95,
countries:['USA'],
genres:['Action','Adventure','Fantasy','Crime'],
director:['Rob Bowman'],
actors:['Jennifer Garner','Goran Višnjič','Kirsten Zien','Will Yun Lee','Cary-Hiroyuki Tagawa','Terence Stamp','Natassia Malthe','Bob Sapp','Jason Isaacs','Nathaniel Arcand','Colin Cunningham','Ty Olsson','Kevan Ohtsji','Kendall Cross','Tom Woodruff Jr.','Jana Mitsoula','Mark Houghton','Kurt Max Runte','Aaron Au'],
screenplay:['Zak Penn','Stuart Zicherman','Raven Metzner'],
production:['Arnon Milchan','Gary Foster','Avi Arad'],
music:['Christophe Beck'],
camera:['Bill Roe'],
cut:['Kevin Stitt'],
sound:['Erik Aadahl','Andy Nelson','Anna Behlmer','John A. Larsen','Craig Berkey','Michael T. Williamson'],
scenography:['Graeme Murray'],
masks:['Fay von Schroeder'],
costumes:['Lisa Tomczeszyn']},
{title:'Hulk',
titleCZ:'Hulk',
year:2003,
runtime:138,
countries:['USA'],
genres:['Action','Sci-Fi'],
director:['Ang Lee'],
actors:['Eric Bana','Jennifer Connelly','Sam Elliott','Josh Lucas','Nick Nolte','Cara Buono','Celia Weston','Lou Ferrigno','Stan Lee','Daniel Dae Kim','Michael Papajohn','Rhiannon Leigh Wryn','Kevin Rankin','Kirk B.R. Woller','John Littlefield','Victor Rivers','John Prosky','Lou Richards','Jenn Gotzon','Sean Mahon','Jesse Corti','Mike Erwin','Geoffrey Scott','Paul Hansen Kim','Regi Davis','Daniella Kuhn'],
basedOn:['Jack Kirby'],
screenplay:['John Turman','Michael France','James Schamus'],
production:['James Schamus','Gale Anne Hurd','Avi Arad','Larry Franco'],
music:['Danny Elfman'],
camera:['Frederick Elmes'],
cut:['Tim Squyres'],
sound:['Richard Hymns','Eugene Gearty','Michael Semanick','Gary Rydstrom'],
scenography:['Rick Heinrichs','John Dexter'],
masks:['Dennis Liddiard','Carolyn Elias','Christopher Allen Nelson'],
costumes:['Marit Allen']},
{title:'The New Mutants',
titleCZ:'Noví mutanti',
year:2020,
runtime:95,
countries:['USA'],
genres:['Horror','Sci-Fi','Action'],
director:['Josh Boone'],
actors:['Maisie Williams','Anya Taylor-Joy','Charlie Heaton','Blu Hunt','Alice Braga','Henrique Zaga','Adam Beach','Colbi Gannett','Happy Anderson','Marilyn Manson','Dustin Ceithamer'],
screenplay:['Josh Boone','Knate Lee'],
production:['Simon Kinberg','Karen Rosenfelt','Lauren Shuler Donner'],
music:['Mark Snow'],
camera:['Peter Deming'],
cut:['Andrew Buckland','Matthew Rundell','Robb Sullivan'],
sound:['David Giammarco'],
scenography:['Molly Hughes','Merissa Lombardo'],
masks:['Nichole Pleau','Camille Friend','JoJo Myers Proud'],
costumes:['Leesa Evans','Virginia Johnson']},
{title:'X-Men: Apocalypse',
titleCZ:'X-Men: Apokalypsa',
year:2016,
runtime:144,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action'],
director:['Bryan Singer'],
actors:['James McAvoy','Michael Fassbender','Jennifer Lawrence','Nicholas Hoult','Oscar Isaac','Rose Byrne','Evan Peters','Josh Helman','Sophie Turner','Tye Sheridan','Lucas Till','Kodi Smit-McPhee','Ben Hardy','Alexandra Shipp','Lana Condor','Olivia Munn','Monique Ganderton','Fraser Aitcheson','Ally Sheedy','Anthony Konechny','Lukas Penar','Joanne Boland','Manuel Tadros','T.J. McGibbon','Tómas Lemarquis','Stan Lee','Stephen Bogaert','John Bourgeois','Dan Lett','Shawn Campbell','Joe Cobden','John Ottman','Željko Ivanek','Hugh Jackman','Jason Deline','Conrad Coates','Manuel Sinor','Raphaël Dury','Karl Walcott','Serge Martineau','Desmond Campbell','Christopher B. MacCabe','Jimmy Star','Ryan Hollyman','Alexander Chehrazi','Emma Elle Paterson','Abanoub Andraous','Joseph Bellerose'],
screenplay:['Simon Kinberg'],
production:['Simon Kinberg','Hutch Parker','Bryan Singer','Lauren Shuler Donner'],
music:['John Ottman'],
camera:['Newton Thomas Sigel'],
cut:['Michael Louis Hill','John Ottman'],
sound:['Paul Massey','Ron Bartlett','Chuck Michael','John A. Larsen','Craig Berkey'],
scenography:['Grant Major','Anne Kuljian','Eve Boulonne','Charlotte Rouleau'],
masks:['Patrick Baxter','Charles Carter','Rita Ciccozzi','Rosalina Da Silva','Brian Sipe','Krista Seller','Adrien Morot','Alexei Dmitiew'],
costumes:['Louise Mingenbach','Paula Truman']},
{title:'Dark Phoenix',
titleCZ:'X-Men: Dark Phoenix',
year:2019,
runtime:114,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Simon Kinberg'],
actors:['Sophie Turner','James McAvoy','Jennifer Lawrence','Michael Fassbender','Jessica Chastain','Nicholas Hoult','Evan Peters','Tye Sheridan','Alexandra Shipp','Kodi Smit-McPhee','Andrew Stehlin','Ato Essandoh','Scott Shepherd','Summer Fontana','Kota Eberhardt','Lamar Johnson','Julian Bailey','Donny Falsetti','Halston Sage','Robert Montcalm','Orphée Ladouceur-Nguyen','Michael Lipka','Serge Martineau','Christopher B. MacCabe','Amir Sám Nakhjavani','Gryffin Hanvelt','Christopher Hayes','Vanessa Jackson','Joey Coleman'],
screenplay:['Simon Kinberg'],
production:['Simon Kinberg','Hutch Parker','Lauren Shuler Donner','Bryan Singer'],
music:['Hans Zimmer'],
camera:['Mauro Fiore'],
cut:['Lee Smith'],
sound:['Richard King','Paul Massey','Beau Borders','John A. Larsen'],
scenography:['Claude Paré','Kimberley Zaharko','Eve Boulonne','Vincent Gingras-Liberali'],
masks:['Annick Chartier','Brian Sipe','Adrien Morot','Pamela Goldammer','Linda Dowds','Stephanie Ingram','Alexei Dmitiew'],
costumes:['Daniel Orlandi']},
{title:'X-Men: The Last Stand',
titleCZ:'X-Men: Poslední vzdor',
year:2006,
runtime:100,
countries:['USA','UK','Canada'],
genres:['Action','Adventure','Sci-Fi','Thriller'],
director:['Brett Ratner'],
actors:['Hugh Jackman','Halle Berry','Ian McKellen','Patrick Stewart','Famke Janssen','Anna Paquin','Kelsey Grammer','James Marsden','Rebecca Romijn','Shawn Ashmore','Aaron Stanford','Vinnie Jones','Elliot Page','Daniel Cudmore','Ben Foster','Michael Murphy','Dania Ramirez','Shohreh Aghdashloo','Josef Sommer','Bill Duke','Eric Dane','Haley Ramm','Stan Lee','Cayden Boyd','Anthony Heald','Cameron Bright','Julian Richings','Mei Melançon','Ken Leung','Makenzie Vega','R. Lee Ermey','Chelah Horsdal','Olivia Williams','Mark Helfrich','John Pyper-Ferguson','Aaron Pearl','Alex Ferris','Omahyra','Tanya Newbould',"Brenna O'Brien",'Brad Kelly','Monique Ganderton','Adrian Hough','Peter Kawasaki','Julian Christopher','Richard Yee','Benita Ha','Desiree Zurowski','Shauna Kain','Jimmy Star','Bryce Hodgson','Emy Aneke'],
screenplay:['Simon Kinberg','Zak Penn'],
production:['Lauren Shuler Donner','Avi Arad','Ralph Winter'],
music:['John Powell'],
camera:['Dante Spinotti'],
cut:['Peggy Eghbalian','Mark Helfrich','Julia Wong','Mark Goldblatt'],
sound:['Craig Henighan','John A. Larsen','Yann Delpuech'],
scenography:['Ed Verreaux'],
masks:['Kenny Myers','Mike Elizalde','Fay von Schroeder','Lisa Love','Norma Hill-Patton','Rosalina Da Silva','Matthew W. Mungle','Mike Fields','Tanya Hudson','Emanuela Daus','Vince Yoshida','Kris Evans','Sarah Graham'],
costumes:['Judianna Makovsky']},
{title:'Man-Thing',
titleCZ:'Man Thing',
year:2005,
runtime:97,
countries:['USA','Australia'],
genres:['Action','Horror','Sci-Fi'],
director:['Brett Leonard'],
actors:['Rachael Taylor','Jack Thompson',"Alex O'Loughlin",'Patrick Thompson','Steve Bastoni','Rawiri Paratene','Robert Mammone','Conan Stevens','Ian Bliss','Andrea Leon','John Batchelor','James Coyne','Gary Waddell','Matthew Le Nevez','Imogen Bailey','William Zappa'],
screenplay:['Hans Rodionoff'],
production:['Avi Arad','Scott Karol'],
music:['Roger Mason'],
camera:['Steve Arnold'],
cut:['Martin Connor'],
scenography:['Tim Ferrier'],
costumes:['Cappi Ireland']},
{title:'Fantastic Four',
titleCZ:'Fantastická čtyřka',
year:2015,
runtime:100,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action'],
director:['Josh Trank'],
actors:['Miles Teller','Kate Mara','Michael B. Jordan','Jamie Bell','Toby Kebbell','Reg E. Cathey','Tim Blake Nelson','Mary Rachel Quinn','Han Soto','Marco St. John','Don Yesso','Anthony Reynolds','Dan Castellaneta','Tim Heidecker','Wayne Pére','Lance E. Nichols','Christopher Heskey','Deneen Tyler','Jim Gleason','Kesha Bullard','Jon Arthur','John L. Armijo','Hunter Burke','Fernando Rivera','Melissa McCurley','Kylen Davis','Adam Fristoe','Ben VanderMey','Stephen Wise','Evan Hannemann','Michael D. Anglin','Benjamin Papac','Brittney Alger','Chet Hanks','Mary-Pat Green','David Cleveland Brown','Ravi Naidu','Jaylen Moore','Steven Hack','Rhonda Johnson Dents','Shauna Rappold','Joshua Montes'],
screenplay:['Simon Kinberg','Jeremy Slater','Josh Trank'],
production:['Simon Kinberg','Matthew Vaughn','Hutch Parker','Robert Kulzer','Gregory Goodman'],
music:['Marco Beltrami','Philip Glass'],
camera:['Matthew Jensen'],
cut:['Elliot Greenberg','Stephen E. Rivkin'],
sound:['Paul Massey','Craig Henighan','Will Files'],
scenography:['Chris Seagers','Molly Hughes','Clint Wallace','Miguel López-Castillo','Steve Cooper','Victor J. Zolfo'],
masks:['Kimberley Spiteri','Dennis Liddiard','Laurel Van Dyke','Jack Lazzaro','Steven R. Soussanna'],
costumes:['George L. Little']},
{title:'Fantastic Four: Rise of the Silver Surfer',
titleCZ:'Fantastická čtyřka: Silver Surfer',
year:2007,
runtime:88,
countries:['USA','Germany','UK'],
genres:['Action','Sci-Fi','Thriller','Fantasy'],
director:['Tim Story'],
actors:['Jessica Alba','Ioan Gruffudd','Chris Evans','Andre Braugher','Julian McMahon','Kerry Washington','Doug Jones','Laurence Fishburne','Michael Chiklis','Stan Lee','Beau Garrett','Moneca Delain','Brian Posehn','Vanessa Lachey','Valerie Tian','Kevin McNulty','Monique Ganderton','Benjamin Ayres','Peter Kawasaki','Gonzalo Menendez','Michasha Armstrong','Kenneth Welsh','Graeme Duffy','Nimet Kanji','Patricia Harras','Dawn Chubai'],
screenplay:['Don Payne','Mark Frost'],
production:['Avi Arad','Bernd Eichinger','Ralph Winter'],
music:['John Ottman'],
camera:['Larry Blanford'],
cut:['Peter S. Elliot','William Hoy'],
sound:['Craig Henighan','Gary C. Bourgeois','Greg Orloff','John A. Larsen'],
scenography:['Kirk M. Petruccelli'],
masks:['Mike Elizalde','Rosalina Da Silva','Tanya Hudson','Thomas Floutz','Sarah Graham'],
costumes:['Mary E. Vogt']},
{title:'Ghost Rider',
titleCZ:'Ghost Rider',
year:2007,
runtime:105,
countries:['USA','Australia'],
genres:['Action','Thriller','Horror','Fantasy'],
director:['Mark Steven Johnson'],
actors:['Nicolas Cage','Eva Mendes','Wes Bentley','Peter Fonda','Sam Elliott','Raquel Alessi','Donal Logue','Brett Cullen','Matt Long','Jessica Napier','Ryan Johnson','Sally Anne Arnott','Braydn Michael','Joel Tobeck','Charlie Garber','Rebel Wilson','Jason Raftopoulos','Arthur Angel','Rita Kalnejais','Peter Callan'],
screenplay:['Mark Steven Johnson'],
production:['Michael De Luca','Gary Foster','Avi Arad','Steven Paul'],
music:['Christopher Young'],
camera:['Russell Boyd'],
cut:['Richard Francis-Bruce'],
sound:['Gary C. Bourgeois','Greg Orloff','Deb Adair'],
scenography:['Kirk M. Petruccelli'],
masks:['Dave Elsey','Lesley Vanderwalt'],
costumes:['Lizzy Gardiner']},
{title:'Ghost Rider: Spirit of Vengeance',
titleCZ:'Ghost Rider 2',
year:2011,
runtime:95,
countries:['USA','United Arab Emirates'],
genres:['Action','Thriller','Fantasy'],
director:['Mark Neveldine','Brian Taylor'],
actors:['Nicolas Cage','Violante Placido','Ciarán Hinds','Idris Elba','Johnny Whitworth','Christopher Lambert','Anthony Head','Fergus Riordan','Spencer Wilding','Will Ashcroft','Adina Galupa','Sorin Tofan'],
screenplay:['Scott M. Gimple','Seth Hoffman','David S. Goyer'],
production:['Ashok Amritraj','Michael De Luca','Avi Arad','Steven Paul'],
music:['David Sardy'],
camera:['Brandon Trost'],
cut:['Brian Berdan'],
sound:['Roland Winke','Julien Paschal','Deb Adair'],
scenography:['Kevin Phipps','Dominic Capon'],
masks:['Jason Hamer'],
costumes:['Bojana Nikitovič']},
{title:'Venom',
titleCZ:'Venom',
year:2018,
runtime:112,
countries:['USA'],
genres:['Action','Sci-Fi','Thriller'],
director:['Ruben Fleischer'],
actors:['Tom Hardy','Michelle Williams','Riz Ahmed','Jenny Slate','Woody Harrelson','Michelle Lee','Sope Aluko','Reid Scott','Scott Haze','Mac Brandt','Jane McNeill','Wayne Pére','Sam Medina','Martin Bats Bradford','D. James Jones','Ellen Gerstein','Ed Moy','James J. Fuertes','Stan Lee','Christian Convery','Melora Walters','Wade Williams','Jared Bankens','Jake Hanson','M. Shawn Cunningham','Peggy Lu','William W. Barbour','Kurt Yue','Vickie Eng','Selena Anduze','Brandon Morales','Elizabeth Becka','Sailor Larocque','Lauren Richards','Scott Deckert','Diesel Madkins','Jock McKissic','Marcella Bragio','Angela Davis'],
screenplay:['Jeff Pinkner','Scott Rosenberg','Kelly Marcel'],
production:['Avi Arad','Amy Pascal','Matthew Tolmach'],
music:['Ludwig Göransson'],
camera:['Matthew Libatique'],
cut:['Alan Baumgarten','Maryann Brandon'],
sound:["Kevin O'Connell",'Will Files'],
scenography:['Oliver Scholl','Larry Dias'],
masks:['Stephan Dupuis','Leay Cangelosi','Adruitha Lee'],
costumes:['Kelli Jones']},
{title:'Venom: Let There Be Carnage',
titleCZ:'Venom 2: Carnage přichází',
year:2021,
runtime:97,
countries:['USA'],
genres:['Action','Sci-Fi','Thriller'],
director:['Andy Serkis'],
actors:['Tom Hardy','Michelle Williams','Woody Harrelson','Naomie Harris','Stephen Graham','Reid Scott','Sean Delaney','Laurence Spellman','Etienne Vick','Amber Sienna','Peggy Lu','William W. Barbour','Andrew Koponen','Frank Scozzari','Rachel Handshaw','Olumide Olorunfemi','Simon Connolly'],
screenplay:['Kelly Marcel'],
production:['Avi Arad','Amy Pascal','Matthew Tolmach','Kelly Marcel'],
music:['Marco Beltrami'],
camera:['Robert Richardson'],
cut:['Maryann Brandon'],
sound:["Kevin O'Connell",'Will Files'],
scenography:['Oliver Scholl','Dominic Capon'],
masks:['Karleigh Williams'],
costumes:['Joanna Eatwell']},
{title:'Deadpool',
titleCZ:'Deadpool',
year:2016,
runtime:108,
countries:['USA'],
genres:['Action','Comedy','Adventure','Sci-Fi','Romance'],
director:['Tim Miller'],
actors:['Ryan Reynolds','Morena Baccarin','Ed Skrein','T.J. Miller','Karan Soni','Michael Benyaer','Stefan Kapičič','Brianna Hildebrand','Style Dayne','Kyle Cassie','Taylor Hickson','Ayzee','Naika Toussaint','Randal Reeder','Isaac C. Singleton Jr.','Justyn Shippelt','Donna Yamamoto','Jed Rees','Hugh Scott','Gina Carano','Cindy Piper','Em Haine','Aatash Amir','Chad Riley','Paul Belsito','Darcey Johnson','Leslie Uggams','Kyle Rideout','Jason William Day','Stan Lee','Ben Wilkinson','Rachel Shaw','Paul Lazenby','Rob Hayter','Greg LaSalle','Kayla Adams','Heather Ashley Chase'],
basedOn:['Fabian Nicieza','Rob Liefeld'],
screenplay:['Rhett Reese','Paul Wernick'],
production:['Simon Kinberg','Lauren Shuler Donner'],
music:['Junkie XL'],
camera:['Ken Seng'],
cut:['Julian Clarke'],
sound:['Paul Massey','Craig Henighan','Ai-Ling Lee','Will Files'],
scenography:['Sean Haworth'],
masks:['Bill Corso','Monica Huppert','Céline Godeau'],
costumes:['Angus Strathie']},
{title:'Deadpool 2',
titleCZ:'Deadpool 2',
year:2018,
runtime:119,
countries:['USA'],
genres:['Action','Comedy','Adventure','Sci-Fi'],
director:['David Leitch'],
actors:['Ryan Reynolds','Josh Brolin','Morena Baccarin','Julian Dennison','Zazie Beetz','T.J. Miller','Leslie Uggams','Karan Soni','Brianna Hildebrand','Jack Kesy','Eddie Marsan','Šiori Kucuna','Stefan Kapičič','Randal Reeder','Rob Delaney','Lewis Tan','Bill Skarsgård','Terry Crews','Brad Pitt','Robert Maillet','Alan Tudyk','Matt Damon','Michasha Armstrong','Hayley Sales','Luke Roessler','David Leitch','Alicia Morton','Nicholas Hoult','James McAvoy','Evan Peters','Tye Sheridan','Alexandra Shipp','Kodi Smit-McPhee','Scott Vickaryous','Hugh Jackman','Fred Savage','Islie Hirvonen','Nikolai Witschl','Hunter Dillon','Sam Hargrave'],
basedOn:['Fabian Nicieza','Rob Liefeld'],
screenplay:['Rhett Reese','Paul Wernick','Ryan Reynolds'],
production:['Simon Kinberg','Ryan Reynolds','Lauren Shuler Donner'],
music:['Tyler Bates'],
camera:['Jonathan Sela'],
cut:['Craig Alpert','Elísabet Ronaldsdóttir','Dirk Westervelt'],
sound:['Paul Massey','Chuck Michael','Mark P. Stoeckinger','Mark Noda'],
scenography:['David Scheunemann','Roger Fires'],
masks:['Bill Corso','Mike Smithson','Monica Huppert','Mike Fields','Leanne Rae Podavin','Cayley Giene'],
costumes:['Kurt Swanson','Bart Mueller']},
{title:'The Wolverine',
titleCZ:'Wolverine',
year:2013,
runtime:126,
countries:['USA','Australia'],
genres:['Sci-Fi','Action','Adventure','Fantasy'],
director:['James Mangold'],
actors:['Hugh Jackman','Tao Okamoto','Lila Fukušima','Hirojuki Sanada','Světlana Chodčenkova','Brian Tee','Will Yun Lee','Famke Janssen','James Fraser','Ian McKellen','Patrick Stewart','Luke Webb','Monique Ganderton','Hal Yamanouchi','Lewis Fitz-Gerald','Ken Jamamura','Masa Yamaguchi','Garret Sato','Shingo Usami','Tess Haubrich','Jeremy Marinas','Conrad Coleby','Eric Laciste','Keitoku Itó','Nobuaki Kakuda','Kódži Nakamura','Ola Endress','Lex Lang'],
screenplay:['Mark Bomback','Scott Frank'],
production:['Hugh Jackman','Hutch Parker','Lauren Shuler Donner'],
music:['Marco Beltrami'],
camera:['Ross Emery'],
cut:['Michael McCusker'],
sound:['Donald Sylvester','Ron Bartlett','Chuck Michael','John A. Larsen'],
scenography:['François Audouy'],
masks:['Mariel McClorey','Nick Nicolaou','Anna Gray'],
costumes:['Isis Mussenden']},
{title:'X-Men Origins: Wolverine',
titleCZ:'X-Men Origins: Wolverine',
year:2009,
runtime:103,
countries:['USA','UK'],
genres:['Action','Adventure','Sci-Fi','Thriller'],
director:['Gavin Hood'],
actors:['Hugh Jackman','Liev Schreiber','Danny Huston','Lynn Collins','Daniel Henney','Ryan Reynolds','Taylor Kitsch','Will. I. Am','Dominic Monaghan','Kevin Durand','Tahyna MacManus','Scott Adkins','Alice Parkinson','Adelaide Clemens','Panou','Patrick Stewart','Tim Pocock','Troye Sivan','Hakeem Kae-Kazim',"Peter O'Brien",'Myles Pollard','Don Battée','Johnson Phan','Aaron Jeffery','Alexandra Davies','Elizabeth Thai','Socratis Otto','Alison Araya','Dave Florek','Warwick Young','Daniel Negreanu','Nathin Butler','Asher Keddie','Max Cullen','Eileen Bui','Beatrice King','Katherine Taylor',"Tom O'Sullivan",'Eric Breker'],
screenplay:['David Benioff','Skip Woods'],
production:['Peter MacDonald','Hugh Jackman','Lauren Shuler Donner','Bryan Singer','Ralph Winter','John Palermo'],
music:['Harry Gregson-Williams'],
camera:['Donald McAlpine'],
cut:['Nicolas De Toth','Megan Gill'],
sound:['David Giammarco','Paul Massey','John A. Larsen'],
scenography:['Barry Robison'],
masks:['Anita Morgan','Nikki Gooley','Jamie Kelman','Norma Hill-Patton','Adam Johansen','Mike Fields'],
costumes:['Louise Mingenbach']},
{title:'Black Adam',
titleCZ:'Black Adam',
year:2022,
runtime:125,
countries:['USA'],
genres:['Action','Sci-Fi'],
director:['Jaume Collet-Serra'],
actors:['Dwayne Johnson','Sarah Shahi','Viola Davis','Pierce Brosnan','Noah Centineo','Aldis Hodge','Quintessa Swindell','Odelya Halevi','Joseph Gatt','Marwan Kenzari','Mohammed Amer','Bodhi Sabongui','James Cusati-Moyer','Angel Rosario Jr.','Natalie Burn','Uli Latukefu','Derek Russo','Patrick Sabongui','Christopher Matthew Cook','Jalon Christian','Henry Cavill','Jennifer Holland','Alex Parkinson'],
basedOn:['Charles Clarence Beck','Otto Binder'],
screenplay:['Adam Sztykiel','Rory Haines','Sohrab Noshirvani'],
production:['Beau Flynn','Hiram Garcia','Dany Garcia'],
music:['Lorne Balfe'],
camera:['Lawrence Sher'],
cut:['Michael L. Sale','John Lee'],
sound:['Michael Keller','Richard King','David Werntz'],
scenography:['Tom Meyer','Larry Dias'],
masks:['Björn Rehbein','Mazena Puksto','Adruitha Lee'],
costumes:['Kurt Swanson','Bart Mueller']},
{title:'Aquaman',
titleCZ:'Aquaman',
year:2018,
runtime:143,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['James Wan'],
actors:['Jason Momoa','Amber Heard','Patrick Wilson','Nicole Kidman','Willem Dafoe','Dolph Lundgren','Yahya Abdul-Mateen II','Temuera Morrison','Ludi Lin','Michael Beach','Randall Park','Graham McTavish','Leigh Whannell','Tainui Kirkwood','Tamor Kirkwood','Kaan Guldur','Otis Dhanji','Julie Andrews','John Rhys-Davies','Djimon Hounsou','Sophia Forrest','Robert Longstreet','Patrick Cox','Brendan Byrne','Salvatore Merenda','Jimmy Star','Kekoa Kekumano'],
basedOn:['Mort Weisinger','Paul Norris'],
screenplay:['David Leslie Johnson-McGoldrick','Will Beall'],
production:['Peter Safran','Rob Cowan'],
music:['Rupert Gregson-Williams'],
camera:['Don Burgess'],
cut:['Kirk M. Morri'],
sound:['Stephen P. Robinson'],
scenography:['Bill Brzeski','Danielle Berman','Beverley Dunn'],
masks:['Lesley Vanderwalt','Elka Wardega','Justin Raleigh','Ozzy Alvarez','Jason Baird','Karen Kelly'],
costumes:['Kym Barrett']},
{title:'Aquaman and the Lost Kingdom',
titleCZ:'Aquaman a ztracené království',
year:2023,
runtime:124,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['James Wan'],
actors:['Jason Momoa','Patrick Wilson','Yahya Abdul-Mateen II','Dolph Lundgren','Nicole Kidman','Temuera Morrison','Ben Affleck','Amber Heard','Pilou Asbæk','Randall Park','Indya Moore','Vincent Regan','Jani Zhao','Ricardo Molina'],
basedOn:['Mort Weisinger','Paul Norris'],
screenplay:['David Leslie Johnson-McGoldrick'],
production:['Peter Safran','James Wan','Rob Cowan'],
music:['Rupert Gregson-Williams'],
camera:['Don Burgess'],
cut:['Kirk M. Morri'],
sound:['Harry Cohen'],
scenography:['Bill Brzeski'],
masks:['Justin Raleigh','Satinder Chumber'],
costumes:['Richard Sale']},
{title:'Green Lantern',
titleCZ:'Green Lantern',
year:2011,
runtime:109,
countries:['USA'],
genres:['Sci-Fi','Action','Adventure','Thriller'],
director:['Martin Campbell'],
actors:['Ryan Reynolds','Blake Lively','Peter Sarsgaard','Mark Strong','Temuera Morrison','Jon Tenney','Tim Robbins','Angela Bassett','Jay O. Sanders','Taika Waititi','Gattlin Griffith','Salome Jens','Laura Cayouette','Griff Furst','Geoffrey Rush','Michael Clarke Duncan','Clancy Brown','Garrett Hines','Deke Anderson','Nick Jandl','Dane Rhodes','Ashley Reed','Mike Doyle','Teri Wyble','Ritchie Montgomery','Lance E. Nichols','Douglas M. Griffin','Silas Cooper','Laura Flannery','Jenna Craig','Jillian Batherson','Chris Marroy','Tiffany Morgan','Dorian Kingi'],
basedOn:['John Broome','Gil Kane'],
screenplay:['Greg Berlanti','Michael Green','Marc Guggenheim','Michael Goldenberg'],
production:['Greg Berlanti','Donald De Line'],
music:['James Newton Howard'],
camera:['Dion Beebe'],
cut:['Stuart Baird'],
sound:['John T. Reitz','Gregg Rudloff','Shannon Mills'],
scenography:['Grant Major','Anne Kuljian'],
masks:['Andrea Bowman','Amy Wood','Cathrine A. Marcotte','Remi Savva','Krystal Kershaw','Jack Lazzaro'],
costumes:['Ngila Dickson']},
{title:'Man of Steel',
titleCZ:'Muž z oceli',
year:2013,
runtime:143,
countries:['USA','Canada','UK'],
genres:['Action','Adventure','Fantasy','Sci-Fi'],
director:['Zack Snyder'],
actors:['Henry Cavill','Amy Adams','Russell Crowe','Diane Lane','Kevin Costner','Michael Shannon','Dylan Sprayberry','Antje Traue','Harry Lennix','Christopher Meloni','Laurence Fishburne','Ayelet Zurer','Michael Cerveris','Rebecca Buller','Michael Kelly','Richard Schiff','Tahmoh Penikett','Joe Minoso','Mackenzie Gray','Christina Wren','Robert Moloney','Ian Tracey','Mike Dopud','Carla Gugino','Alessandro Juliani','Elizabeth Thai','Lesley Bevan','Ina Lereine','Brad Kelly','Jadin Gould','David Lewis','Rebecca Spence','Samantha Win','Bridgett Newton','Julian Richings','Jack Foley','Mark Gibbon','Howard Siegel','Kwesi Ameyaw','Victor Formosa','Rondel Reynoldson','Sean Campbell','Peter J. Chevalier','Mary Black','Bruce Bohne','Coburn Goss','Cooper Timberline','George Canyon','Carmen Lavigne','Jacqueline Scislowski','Rowen Kahn','Brian King','Apollonia Vanova','Trevor Lerner','Stuart Ambrose','Ian Rozylo','Nicholas W. von Zill'],
basedOn:['Jerry Siegel','Joe Shuster'],
screenplay:['David S. Goyer'],
production:['Charles Roven','Deborah Snyder','Christopher Nolan','Emma Thomas'],
music:['Hans Zimmer'],
camera:['Amir Mokri'],
cut:['David Brenner'],
sound:['Jay Wilkinson','Frank A. Montaño'],
scenography:['Alex McDowell','Anne Kuljian'],
masks:['Rosalind Jones-Crosby','Dominic Mango','Victoria Down','Céline Godeau','Pamela Milone-McLaughlin'],
costumes:['Michael Wilkinson','James Acheson']},
{title:'Wonder Woman',
titleCZ:'Wonder Woman',
year:2017,
runtime:141,
countries:['USA','Hong Kong','China'],
genres:['Action','Adventure','Fantasy','Sci-Fi','War'],
director:['Patty Jenkins'],
actors:['Gal Gadot','Chris Pine','Connie Nielsen','Robin Wright','David Thewlis','Danny Huston','Elena Anaya','Lucy Davis','Ewen Bremner','Lilly Aspell','Saïd Taghmaoui','Lisa Loven Kongsli','Mayling Ng','Miroslav Zaruba','Mick Slaney','Doutzen Kroes','Eleanor Matsuura','Samantha Win','Florence Kasumba','Zack Snyder','Eugene Brave Rock','Richard Price','Tobias James-Samuels','Josette Simon','Peter Stark','Ann Ogbomo','Andrea Vasiliou','Tori Letzler','Gordon Coe','Freddy Carter','Emily Carey','Annarie Boor','Zac Whitehead','Jemma Moore','Jolie Lennon','Gana Bayarsaikhan','Philippe Spall','Morten Bekkenes','Caroline Winberg','Jack Jagodka','Madeleine Vall','Rachel Pickup','Tim Pritchett','Monica Lovari','Ray Whelan','Elena Valdameri','Nick Donald','Sammy Hayman'],
basedOn:['William Moulton Marston'],
screenplay:['Allan Heinberg'],
production:['Richard Suckle','Zack Snyder','Charles Roven','Deborah Snyder','Tommy Gormley'],
music:['Rupert Gregson-Williams'],
camera:['Matthew Jensen'],
cut:['Martin Walsh'],
sound:['James Mather'],
scenography:['Aline Bonetto','Domenico Sica','Anna Lynch-Robinson','Phil Harvey'],
masks:['Lesa Warrener'],
costumes:['Lindy Hemming']},
{title:'Wonder Woman 1984',
titleCZ:'Wonder Woman 1984',
year:2020,
runtime:151,
countries:['USA'],
genres:['Action','Adventure','Fantasy','Sci-Fi'],
director:['Patty Jenkins'],
actors:['Gal Gadot','Chris Pine','Kristen Wiig','Pedro Pascal','Robin Wright','Connie Nielsen','Lilly Aspell','Amr Waked','Kristoffer Polaha','Natasha Rothwell','Ravi Patel','Oliver Cotton','Lucian Perez','Gabriella Wilde','Kelvin Yu','Stuart Milligan','Ed Birch','Lynda Carter','Doutzen Kroes','Jessie Graff','Lyon Beckwith','Brandon Thane Wilson','Oakley Bull','Mike D. Anderson','Susan Smythe','Mitch Holson','Spencer Trinwith','Caroline Coleman','Asim Chaudhry','Danny Morgan','Philip Philmar','Peter Brooke','Jonathan Ajayi','Avi Rothman','Belinda Mayne','Bruce Mackinnon','Patrick Lyster','Vincent Jerome','Akie Kotabe','Gabriel Constantin','Mish Boyko','Constantine Gregory','Mike Sengelow','Sarah Barlondo','Tony Zarouel','Jaron Varsano','Victoria Broom','Colin Stinton','Chris Silcox','Gina Jun','Becki Hayes','David Al-Fahmi','Matt Costello','Mensah Bediako'],
basedOn:['William Moulton Marston'],
screenplay:['Patty Jenkins','Geoff Johns','Dave Callaham'],
production:['Charles Roven','Deborah Snyder','Zack Snyder','Patty Jenkins','Gal Gadot'],
music:['Hans Zimmer'],
camera:['Matthew Jensen'],
cut:['Richard Pearson'],
sound:['Richard King'],
scenography:['Aline Bonetto','Anna Lynch-Robinson','Darren Tubby','Gavin Fitch','Simon Elsley'],
masks:['Julio Parodi','Yurena Cazorla','Mindy Hall','Karen Cohen','Vasilios Tanis','Mark Coulier','Maria Falcon','David Malinowski','Barbara Lacy'],
costumes:['Lindy Hemming']},
{title:'Superman and the Mole Men',
titleCZ:'Superman and the Mole Men',
year:1951,
runtime:67,
countries:['USA'],
genres:['Action','Sci-Fi','Drama','Family'],
director:['Lee Sholem'],
actors:['George Reeves','Phyllis Coates','Jeff Corey','Walter Reed','J. Farrell MacDonald','Ray Walker','Frank Reicher','Byron Foulger','Harry Harvey','Stanley Andrews','Hal K. Dawson','Margia Dean','Billy Curtis','Beverly Washburn','Phil Warren','Frank McLure','Russell Custer','John Baer','Jack Lomas','Adrienne Marden','John Phillips','Jerry Maren'],
basedOn:['Jerry Siegel','Joe Shuster'],
screenplay:['Robert Maxwell'],
production:['Barney A. Sarecky'],
music:['Darrell Calker'],
camera:['Clark Ramsey'],
cut:['Albrecht Joseph'],
scenography:['Ernst Fegté'],
masks:['Harry Thomas']},
{title:'Batman: The Movie',
titleCZ:'Batman',
year:1966,
runtime:105,
countries:['USA'],
genres:['Comedy','Sci-Fi','Crime','Action','Adventure'],
director:['Leslie H. Martinson'],
actors:['Adam West','Burt Ward','Lee Meriwether','Cesar Romero','Burgess Meredith','Frank Gorshin','Alan Napier','Neil Hamilton','Reginald Denny','George J. Lewis','Teru Šimada','Harry Lauter','Robert Adler','Charlie Picerni','Stafford Repp','Gil Perkins','Arthur Tovey','Ivan Triesault','Tommy Noonan','Clark Ross','George DeNormand','Leon Alton','Cap Somers','Sol Gorss','William Tannen','Steve Allen','Gregory Gaye','George Cisar','Dick Crockett','Milton Frome','Van Williams','Julie Gregg','Vincent Barbi','Albert Carrier','Elizabeth Harrower',"Monty O'Grady",'Wally Rose','Bernard Sell','Carl Sklover','Wolfe Barzell','William Dozier','Arlene Charles','Murray Pollack','Peter Forster','George Sawaya','Ed McCready','George Holmes','Madge Blake','Jack LaLanne','John Yates','Alan Marston','Jock Gaynor'],
basedOn:['Bob Kane','Bill Finger'],
screenplay:['Lorenzo Semple Jr.','William Dozier'],
production:['William Dozier'],
music:['Nelson Riddle'],
camera:['Ralph Woolsey','Howard Schwartz'],
cut:['Harry Gerstad'],
sound:['Harry M. Leonard'],
scenography:['Jack Martin Smith','Walter M. Scott','Chester Bayhi','Serge Krizman'],
masks:['Ben Nye'],
costumes:['Pat Barto']},
{title:'Superman',
titleCZ:'Superman',
year:1978,
runtime:143,
countries:['UK','USA'],
genres:['Action','Adventure','Sci-Fi','Drama'],
director:['Richard Donner'],
actors:['Christopher Reeve','Marlon Brando','Gene Hackman','Ned Beatty','Jackie Cooper','Glenn Ford','Trevor Howard','Margot Kidder',"Jack O'Halloran",'Valerie Perrine','Maria Schell','Terence Stamp','Phyllis Thaxter','Susannah York','Marc McClure','Jeff East','Sarah Douglas','Harry Andrews','John Stuart','Lise Hilboldt','Richard Donner','Brian Protheroe','Larry Hagman','Rex Everhart','Noel Neill','John Ratzenberger','Lee Quigley','John Cording','Steve Kahan','Michael Ensign','Shane Rimmer','Alan Tilvern','Larry Lamb','John Hollis','Keith Alexander','Paul Tuerpe','Phil Brown','Bill Bailey','Benjamin Feitelson','Randy Jurgensen','David Baxt','Tony Selby','David Calder','Vass Anderson','Miquel Brown','Harry Fielder','Chuck Julian','Bruce Boa','William Russell','Alan Cullen','Robert Henderson','Weston Gavin','Rex Reed','Michael Gover','Penelope Lee','David Neal','Bo Rucker','Lawrence Trimble','Sue Shifrin'],
basedOn:['Jerry Siegel','Joe Shuster'],
screenplay:['Mario Puzo','David Newman','Robert Benton','Tom Mankiewicz'],
production:['Pierre Spengler'],
music:['John Williams'],
camera:['Geoffrey Unsworth'],
cut:['Stuart Baird','Michael Ellis'],
scenography:['John Barry'],
masks:['Basil Newall','Phil Rhodes'],
costumes:['Yvonne Blake']},
{title:'Superman II',
titleCZ:'Superman 2',
year:1980,
runtime:127,
countries:['UK','USA'],
genres:['Action','Adventure','Sci-Fi','Drama'],
director:['Richard Lester','Richard Donner'],
actors:['Christopher Reeve','Margot Kidder','Gene Hackman','Terence Stamp','Ned Beatty','Jackie Cooper','Sarah Douglas',"Jack O'Halloran",'Valerie Perrine','Susannah York','Clifton James','E.G. Marshall','Marc McClure','Richard Griffiths','Antony Sher','Eugene Lipinski','Richard Donner','John Ratzenberger','Shane Rimmer','Michael Shannon','Tommy Duggan','John Hollis','Angus MacInnes','Bill Bailey','Don Fellows','Miquel Brown','Dinny Powell','Joe Praml','Roger Brierley','Hal Galili','Fred Wood','Harry Fielder','Pepper Martin','Richard LeParmentier','Richard LeParmentier','Tony Sibbald',"Marcus D'Amico",'Marc Boyle','Gordon Rollings','Elva Mai Hoover','Terry Walsh'],
basedOn:['Jerry Siegel','Joe Shuster'],
screenplay:['Mario Puzo','David Newman','Tom Mankiewicz'],
production:['Pierre Spengler'],
music:['Ken Thorne'],
camera:['Robert Paynter','Geoffrey Unsworth'],
cut:['John Victor-Smith'],
scenography:['Peter Murton','John Barry','Peter Young'],
masks:['Stuart Freeborn','Basil Newall'],
costumes:['Yvonne Blake']},
{title:'Swamp Thing',
titleCZ:'Msta přichází z močálu',
year:1982,
runtime:91,
countries:['USA'],
genres:['Horror','Sci-Fi'],
director:['Wes Craven'],
actors:['Louis Jourdan','Adrienne Barbeau','Ray Wise','David Hess','Nicholas Worth','Don Knight','Al Ruban','Dick Durock','Nannette Brown','Reggie Batts','Mimi Craven','Tommy Madden'],
basedOn:['Len Wein'],
screenplay:['Wes Craven'],
production:['Benjamin Melniker','Michael Uslan'],
music:['Harry Manfredini'],
camera:['Robbie Greenberg'],
cut:['Richard Bracken'],
scenography:['David Nichols','Robb Wilson King'],
masks:['William Munns','Steve La Porte','David B. Miller','Steve La Porte'],
costumes:['Patricia Bolomet','Bennett Choate']},
{title:'Superman III',
titleCZ:'Superman 3',
year:1983,
runtime:125,
countries:['UK','USA'],
genres:['Action','Adventure','Sci-Fi','Comedy'],
director:['Richard Lester'],
actors:['Christopher Reeve','Richard Pryor','Margot Kidder','Jackie Cooper','Marc McClure',"Annette O'Toole",'Annie Ross','Pamela Stephenson','Robert Vaughn','John Bluthal','David Winning','Al Matthews','Robert Beatty','Barry Dennen','Shane Rimmer','Larry Lamb',"Gavan O'Herlihy",'Bob Todd','Ronnie Brody','Mildred Shay','Maxwell Craig','Fred Wood','Graham Stark','Terry Camilleri','Sandra Dickinson','Stefan Kalipha','Robert Henderson','Helen Horton','Gordon Rollings','George Chisholm','Philip Gilbert','Gordon Signer','Lou Hirsch','Henry Woolf','Jill Goldston','David Fielder'],
basedOn:['Jerry Siegel','Joe Shuster'],
screenplay:['David Newman'],
production:['Pierre Spengler'],
music:['Ken Thorne'],
camera:['Robert Paynter'],
cut:['John Victor-Smith'],
scenography:['Peter Murton','Peter Young'],
masks:['Stuart Freeborn','Paul Engelen'],
costumes:['Evangeline Harrison']},
{title:'Supergirl',
titleCZ:'Superdívka',
year:1984,
runtime:114,
countries:['UK'],
genres:['Adventure','Fantasy','Action','Sci-Fi'],
director:['Jeannot Szwarc'],
actors:['Helen Slater','Faye Dunaway','Peter Cook','Hart Bochner',"Peter O'Toole",'Mia Farrow','Brenda Vaccaro','Simon Ward','Marc McClure','Maureen Teefy','Matt Frewer','Glory Annen','Elaine Ives-Cameron','G.B. Zoot Money','Kelly Hunter','David Graham','Sandra Dickinson','Lynsey Beauchamp','Saskia van Basten-Batenburg','April Olrich','David Healy','Jill Goldston'],
screenplay:['David Odell'],
production:['Timothy Burrill'],
music:['Jerry Goldsmith'],
camera:['Alan Hume'],
cut:['Malcolm Cooke'],
scenography:['Richard Macdonald','Peter Young'],
masks:['Lee Harman','Basil Newall','Nick Dudman','Ann Brodie'],
costumes:['Emma Porteous']},
{title:'The Return of Swamp Thing',
titleCZ:'Návrat muže z bažin',
year:1989,
runtime:88,
countries:['USA'],
genres:['Sci-Fi','Horror','Comedy','Action','Adventure'],
director:['Jim Wynorski'],
actors:['Louis Jourdan','Heather Locklear','Sarah Douglas','Monique Gabrielle','RonReaco Lee','Ace Mask','Daniel Emery Taylor','Christopher Doyle','Alex Van','Joey Sagal','Dick Durock','J. Don Ferguson','Jim Grimshaw'],
basedOn:['Len Wein'],
screenplay:['Neil Cuthbert'],
production:['Benjamin Melniker','Michael Uslan'],
music:['Chuck Cirino'],
camera:['Zoran Hochstätter'],
cut:['Leslie Rosenthal'],
sound:['John Wilkinson','Blake Wilcox'],
scenography:['Robb Wilson King','Frank Galline'],
masks:['Carl Fullerton','Neal Martz'],
costumes:['Vicki Graef']},
{title:'Batman Returns',
titleCZ:'Batman se vrací',
year:1992,
runtime:122,
countries:['USA','UK'],
genres:['Action','Crime','Fantasy','Thriller'],
director:['Tim Burton'],
actors:['Michael Keaton','Danny DeVito','Michelle Pfeiffer','Christopher Walken','Michael Gough','Rick Zumwalt','Michael Murphy','Andrew Bryniarski','Pat Hingle','Vincent Schiavelli','Jan Hooks','Doug Jones','Branscombe Richmond','Paul Reubens','Diane Salinger','Steven Brill','Debbie Lee Carrington','Rena Riffel','Sean Whalen','Anthony De Longis','Gregory Scott Cummins','Felix Silla','Steve Witting','Robert Gossett','Niki Botelho','Mindi Miller','Stuart Lancaster','Anna Katarina','Henry Kingi','Biff Yeager','Joey DePinto','Kristine Rose','Richard Lawrence','Travis McKenna','Joan Giammarco','Cristi Conaway','Neal Lerner'],
basedOn:['Bob Kane','Bill Finger'],
screenplay:['Daniel Waters'],
production:['Denise Di Novi','Tim Burton'],
music:['Danny Elfman'],
camera:['Stefan Czapsky'],
cut:['Chris Lebenzon'],
sound:['Richard L. Anderson','Steve Maslow','Petur Hliddal','David E. Stone'],
scenography:['Bo Welch'],
masks:['Ve Neill','Everett Burrell','Yolanda Toussieng','Greg Nelson','John Logan','Greg Cannom','Barbara Lorenz','Christopher Allen Nelson','Shane Mahan'],
costumes:['Mary E. Vogt','Bob Ringwood']},
{title:'Batman Forever',
titleCZ:'Batman navždy',
year:1995,
runtime:121,
countries:['USA'],
genres:['Action','Fantasy','Crime','Family'],
director:['Joel Schumacher'],
actors:['Val Kilmer','Tommy Lee Jones','Jim Carrey','Nicole Kidman',"Chris O'Donnell",'Michael Gough','Pat Hingle','Drew Barrymore','Debi Mazar','René Auberjonois','Jessica Tuck','Joe Grifasi','Kimberly Scott','Michael Paul Chan','Jon Favreau','George Wallace',"Don 'The Dragon' Wilson",'John Fink','Ed Begley Jr.','Mark Hicks','Kevin Grevioux','Jack Betts','Joe Sabatino','Deron McBee','Oscar Dillon','Brad Martin','Rebecca Budig','Jim Palmer','Jed Curtis','Velvet Rhodes','Eileen Seeley','Dennis Paladino','Cindy Herron','Bob Kane','Marga Gómez'],
basedOn:['Bob Kane','Bill Finger'],
screenplay:['Akiva Goldsman','Janet Scott Batchler','Lee Batchler'],
production:['Tim Burton','Peter Macgregor-Scott'],
music:['Elliot Goldenthal'],
camera:['Stephen Goldblatt'],
cut:['Dennis Virkler','Mark Stevens'],
sound:['Frank A. Montaño','Petur Hliddal'],
scenography:['Barbara Ling'],
masks:['Edouard F. Henriques','Ve Neill','Janna Phillips','David LeRoy Anderson','Yolanda Toussieng','Julie Hewett','Barbara Lorenz','Rick Baker'],
costumes:['Bob Ringwood','Ingrid Ferrin']},
{title:'The New Adventures of Batman and Robin-The Boy Wonder',
titleCZ:'Batman and Robin',
year:1949,
runtime:263,
countries:['USA'],
genres:['Action','Adventure','Crime','Drama'],
director:['Spencer Gordon Bennet'],
actors:['Robert Lowery','Lyle Talbot','Ralph Graves','Rick Vallin','Michael Whalen','John Doucette','Jack Chefe','Don C. Harvey','William Fawcett','Emmett Vogan','Phil Arnold','House Peters Jr.','Frank Hagney',"Frank O'Connor",'George Cisar','Eric Wilton','Richard Cramer','John Hart','Myron Healey','Rusty Wescoatt','Leonard Penn','Eddie Parker','George Robotham','Marshall Bradford','Allan Ray','Greg McClure','George Offerman Jr.','Lee Roberts','Jane Adams'],
basedOn:['Bob Kane','Bill Finger','Jerry Robinson'],
production:['Sam Katzman'],
camera:['Ira H. Morgan'],
cut:['Dwight Caldwell','Earl Turner'],
scenography:['Sidney Clifford'],
masks:['Ray Sebastian']},
{title:'Catwoman',
titleCZ:'Catwoman',
year:2004,
runtime:100,
countries:['USA','Australia'],
genres:['Action','Fantasy'],
director:['Pitof'],
actors:['Halle Berry','Benjamin Bratt','Sharon Stone','Lambert Wilson','Frances Conroy','Alex Borstein','Kim Smith','Michael Massee','Byron Mann','Anne Fletcher','Peter Williams','Peter Wingfield','Ona Grauer','Aaron Douglas','Missy Peregrym','Holly Eglington','Ryan Robbins','John Cassini','Landy Cannon','Kimani Ray Smith','Larry Sullivan','Michael P. Northey','Aaron Miko','Diego Diablo Del Mar','Michasha Armstrong','Janet Varney','Brooke Theiss','Benita Ha','Ecstasia Sanders','Herbert Duncanson'],
basedOn:['Bob Kane','Bill Finger'],
screenplay:['Michael Ferris','John Brancato','John Rogers'],
production:['Denise Di Novi'],
music:['Klaus Badelt'],
camera:['Thierry Arbogast'],
cut:['Sylvie Landra'],
sound:['Richard Hymns','John T. Reitz','Gregg Rudloff','David E. Campbell','Christopher Boyes','Rob Young'],
scenography:['Bill Brzeski','Lisa K. Sessions'],
masks:['Jayne Dancose','Norma Hill-Patton','Jason Hamer'],
costumes:['Angus Strathie']},
{title:'Constantine',
titleCZ:'Constantine',
year:2005,
runtime:115,
countries:['USA','Germany'],
genres:['Fantasy','Mystery','Thriller','Horror'],
director:['Francis Lawrence'],
actors:['Keanu Reeves','Rachel Weisz','Shia LaBeouf','Tilda Swinton','Pruitt Taylor Vince','Djimon Hounsou','Gavin Rossdale','Peter Stormare','Max Baker','Francis Guinan','José Zúñiga','Michelle Monaghan','Suzanne Whang','Laz Alonso','Valerie Azlynn','April Grace','Kevin Alejandro','Nicholas Downs','Eileen Dietz','Billy Million','Jesse Ramirez','Larry Cedar','Chad Stahelski','Victor Boneva','Barbara Pilavin','Jhoanna Trias','Andres Londono','Ann Ryerson','Tanoai Reed','Sharon Omi','Jeremy Ray Valdez','Michael Keyes','Quinn Buniel','Wesley John'],
basedOn:['Jamie Delano','Garth Ennis'],
screenplay:['Kevin Brodbin','Frank A. Cappello'],
production:['Lorenzo di Bonaventura','Lauren Shuler Donner','Erwin Stoff','Benjamin Melniker','Michael Uslan'],
music:['Brian Tyler','Klaus Badelt'],
camera:['Philippe Rousselot'],
cut:['Wayne Wahrman'],
sound:['Skip Lievsay','John T. Reitz','Gregg Rudloff','David E. Campbell'],
scenography:['Naomi Shohan','Douglas A. Mowat'],
masks:['Ve Neill','Jamie Kelman','Janice Kavanagh','Robin Slater','Joel Harlow','Christopher Allen Nelson','Ginger Damon','Shane Mahan'],
costumes:['Louise Frogley']},
{title:'Steel',
titleCZ:'Supertajná zbraň',
year:1997,
runtime:97,
countries:['USA'],
genres:['Action','Crime','Sci-Fi'],
director:['Kenneth Johnson'],
actors:["Shaquille O'Neal",'Annabeth Gish','Judd Nelson','Richard Roundtree','Irma P. Hall','Ray J','Harvey Silver','Claire Stansfield','Charles Napier','Kerrie Keane','Gary Graham','Eric Pierpoint','Thom Barry','Hill Harper','John Hawkes','Corey Burton','Kevin Grevioux','Rick Worthy','Rutanya Alda','Michael Shamus Wiles',"John F. O'Donohue",'Tim DeZarn','Tembi Locke','Ben Maccabee','Cyd Strittmatter','Kevin Sifuentes','Steven Mattila','Michael Preston','Josh Cruze','Marabina Jaimes','Jacquelyn Houston','Joe Wandell','Scotch Ellis Loring'],
screenplay:['Kenneth Johnson'],
production:['Joel Simon'],
music:['Mervyn Warren'],
camera:['Mark Irwin'],
cut:['John F. Link'],
sound:['David John West','Frank A. Montaño','David Rawlinson'],
scenography:['Gary Wissner','Donald Krafft'],
masks:['Brigette A. Myre'],
costumes:['Catherine Adair']},
{title:'Superman IV: The Quest for Peace',
titleCZ:'Superman 4',
year:1987,
runtime:90,
countries:['UK','USA'],
genres:['Action','Adventure','Sci-Fi','Family'],
director:['Sidney J. Furie'],
actors:['Christopher Reeve','Gene Hackman','Margot Kidder','Mariel Hemingway','Jackie Cooper','Jon Cryer','Marc McClure','Sam Wanamaker','Mark Pillow','Jim Broadbent','Mac McDonald','Jiří Stanislav','Jayne Brook','Esmond Knight','Eugene Lipinski','Susannah York','William Hootkins','Clive Mantle','Robert Beatty','Bob Sherman','John Hollis','Jurij Borienko','Don Fellows','Steve Plytas','Peter Diamond','Peter Roy','Rex Robinson','Mark Caven','David Garth','Samantha Weysom','Jill Goldston','Kerry Shale'],
basedOn:['Jerry Siegel','Joe Shuster'],
screenplay:['Rick Rosenthal','Lawrence Konner'],
production:['Yoram Globus','Menahem Golan'],
music:['Alexander Courage'],
camera:['Ernest Day'],
cut:['John Shirley'],
sound:['Bill Rowe'],
scenography:['John Graysmark','Peter Young'],
masks:['Basil Newall'],
costumes:['John Bloomfield']},
{title:'Superman Returns',
titleCZ:'Superman se vrací',
year:2006,
runtime:154,
countries:['USA','Australia'],
genres:['Adventure','Sci-Fi','Fantasy','Action'],
director:['Bryan Singer'],
actors:['Brandon Routh','Kate Bosworth','Kevin Spacey','James Marsden','Parker Posey','Frank Langella','Sam Huntington','Eva Marie Saint','Marlon Brando','Kal Penn','James Karen','Stephan Bender','Peta Wilson','Raelee Hill','Noel Neill','Jordana Beatty','Michael Dougherty','Dan Harris','Ian Roberts','Todd Williams','Richard Branson','Bobby Roe','Alison Araya','Jack Larson','Warwick Young','Barry Quin','Jutaka Izumihara','Bill Young','Brendan Byrne','Tristan Lake Leabu','Dan Ewing','Jimmy Star','Julian Pulvermacher','Steve Ostrow','David Webb','Rohan Michael'],
basedOn:['Jerry Siegel','Joe Shuster'],
screenplay:['Michael Dougherty','Dan Harris'],
production:['Jon Peters','Gilbert Adler','Bryan Singer'],
music:['John Ottman'],
camera:['Newton Thomas Sigel'],
cut:['Elliot Graham','John Ottman'],
sound:['Erik Aadahl','John T. Reitz','Gregg Rudloff','David E. Campbell','Craig Berkey'],
scenography:['Guy Hendrix Dyas'],
masks:['Nikki Gooley','Tami Lane','Shane Thomas','Adam Johansen','Greg Funk'],
costumes:['Louise Mingenbach']},
{title:'Watchmen',
titleCZ:'Strážci - Watchmen',
year:2009,
runtime:"Director's Cut: 186 min",
countries:['USA'],
genres:['Action','Mystery','Sci-Fi'],
director:['Zack Snyder'],
actors:['Billy Crudup','Malin Åkerman','Carla Gugino','Patrick Wilson','Jeffrey Dean Morgan','Jackie Earle Haley','Matthew Goode','Matt Frewer','Stephen McHattie','Niall Matter','Sonya Salomaa','Matthew Harrison','Carrie Genzel','Jay Brazeau','Isabelle Champeau','Laura Mennell','Robert Wisden','Alessandro Juliani','Haley Guiel','Dan Payne','Fulvio Cecere','Chris Gauthier','Zack Snyder','Darren Shahlavi','Michael Eklund','Tom McBeath','Agam Darshi','Colin Lawrence','Leah Gibson','Douglas Chapman','Michael Kopsa','Rob LaBelle','Jerry Wasserman','Kevin McNulty','Monique Ganderton','Alison Araya','Patrick Sabongui','John Tench','Michael Adamthwaite','Don Thompson','Greg Travis','Ted Cole','Jesse Reid','Mark Gash','L. Harvey Gold','Terence Kelly','Jason Schombing','Daryl Shuttleworth','Manoj Sood','Danny Wattley','Mark Acheson','Frank Cassini','Brett Stimely','Tara Frederick','James M. Connor','Gary Houston','Carly Bentall','Walter Addison','Frank Novak','Sayla de Goede','Stephanie Belding','Danny Woodburn','John Destry','Heidi Iro','Carmen Lavigne','Kurt Evans','Eli Snyder','Apollonia Vanova','Marsha Regis','Tony Ali','Nhi Do','Marshall Virtue','Louis Chirillo','Deborah Finkel','John Shaw','Dawn Chubai','Darryl Scheelar','Lynn Colliar','Ron Chartier'],
basedOn:['Alan Moore'],
screenplay:['David Hayter','Alex Tse','Dave Gibbons'],
production:['Lawrence Gordon','Deborah Snyder','Lloyd Levin'],
music:['Tyler Bates'],
camera:['Larry Fong'],
cut:['William Hoy'],
sound:['Frank A. Montaño','Ai-Ling Lee','David Werntz'],
scenography:['Alex McDowell','Jim Erickson'],
masks:['Rita Ciccozzi','Rosalina Da Silva','Greg Cannom','Emanuela Daus','Debra Wiebe','Zabrina Matiru'],
costumes:['Michael Wilkinson']},
{title:'Jonah Hex',
titleCZ:'Jonah Hex',
year:2010,
runtime:81,
countries:['USA'],
genres:['Action','Thriller','Western','Fantasy'],
director:['Jimmy Hayward'],
actors:['Josh Brolin','John Malkovich','Megan Fox','Michael Fassbender','Will Arnett','Tom Wopat','John Gallagher Jr.','Michael Shannon','Wes Bentley','Julia Jones','David Jensen','Jimmy Hayward','Seth Gabel','Aidan Quinn','Michael Papajohn','Lance Reddick','Jeffrey Dean Morgan','Lisa Rotondi','Matthew C. Temple','Victoria Gabrielle Platt','Eric Scott Woods','John McConnell','Rance Howard','Mitchell Amundsen','Darin Heames','Clint James','Billy Blair','Tait Fletcher','Will Koberg','J.D. Evermore','Charlie Glackin','Sean Boyd','Elton LeBlanc','Rio Hackford','Rod Keller','Jen Mears','Bill Martin Williams','Brian Elerding','Paul Zies'],
screenplay:['Mark Neveldine','Brian Taylor'],
production:['Andrew Lazar'],
music:['Marco Beltrami','Mastodon'],
camera:['Mitchell Amundsen'],
cut:['Daniel P. Hanley','Tom Lewis','Kent Beyda','Fernando Villena'],
sound:['Craig Henighan','Sean Byrne','Tim Hays'],
scenography:['Tom Meyer'],
masks:['Deborah Rutherford','Gerald Quist','Eryn Krueger Mekash','Remi Savva','Jason Hamer','Stacey Herbert','Krystal Kershaw','Jack Lazzaro','Kerry Mendenhall'],
costumes:['Michael Wilkinson']},
{title:'Suicide Squad',
titleCZ:'Sebevražedný oddíl',
year:2016,
runtime:'Alternativní 111 min',
countries:['USA'],
genres:['Fantasy','Sci-Fi','Adventure','Action'],
director:['David Ayer'],
actors:['Will Smith','Jared Leto','Margot Robbie','Joel Kinnaman','Viola Davis','Jai Courtney','Jay Hernandez','Adewale Akinnuoye-Agbaje','Karen Fukuhara','Cara Delevingne','Adam Beach','Ben Affleck','Jim Parrack','Common','Alex Meraz','David Harbour','Corina Calderon','Ike Barinholtz','Scott Eastwood','Mark Quigley','Amos Stern','Brianna Goldie','Justin Moses','Brendan Egan','Ezra Miller','Sergio Kato','Billy Otis','David Ayer','Robert B. Kennedy','Tyler Grey','Jeff Ellenberger','Matt Baram','Alain Chanoine','Tatyana Figueiredo','Ho Chow','Fatimah Hassan','Dwight Ireland','Briana Andrade-Gomes','Bambadjan Bamba','Jimmy Star','Shawn J. Hamilton','Jasmine Renée Thomas','Michael Prather','Kent Sheridan','Drew Moss','Shailyn Pierre-Dixon'],
basedOn:['John Ostrander','Ross Andru','Robert Kanigher'],
screenplay:['David Ayer'],
production:['Richard Suckle','Charles Roven'],
music:['Steven Price','Henryk Mikolaj Górecki'],
camera:['Roman Vasjanov'],
cut:['John Gilroy'],
sound:['Richard King','Gary Rizzo','Michael Keller','Lori Dovi'],
scenography:['Oliver Scholl','Clint Wallace','Shane Vieau'],
masks:['Antoinette Julien','Verity Fiction','Jo-Ann MacNeil','Marta Roggero','Sean Sansom','Shane Zander','Greg Nicotero','Leslie Sebert','Kate Biscoe','Christopher Allen Nelson','Lisa Rocco','Allan Cooke'],
costumes:['Kate Hawley']},
{title:'Birds of Prey (And the Fantabulous Emancipation of One Harley Quinn)',
titleCZ:'Birds of Prey (Podivuhodná proměna Harley Quinn)',
year:2020,
runtime:109,
countries:['USA'],
genres:['Action','Adventure','Crime','Comedy'],
director:['Cathy Yan'],
actors:['Margot Robbie','Rosie Perez','Mary Elizabeth Winstead','Jurnee Smollett','Ewan McGregor','Ella Jay Basco','Chris Messina','Daniel Bernhardt','Charlene Amoia','Derek Wilson','Steven Williams','Ali Wong','Matthew Willig','François Chau','Michael Masini','Jeremy Denzlinger','Bojana Novakovic','Dana Lee','Ella Mika','Eddie Alfano','Greice Santo','Judy Kain','Sam Hargrave','Nico Greetham','Karen Teliha','Zack Whyel','Ego Mikitas','Charles Carpenter'],
screenplay:['Christina Hodson'],
production:['Margot Robbie','Bryan Unkeless','Sue Kroll'],
music:['Daniel Pemberton'],
camera:['Matthew Libatique'],
cut:['Jay Cassidy','Evan Schiff'],
sound:['Onnalee Blank','Brandon Proctor','Katy Wood','Paula Fairfield'],
scenography:['K.K. Barrett','Florencia Martin'],
masks:['Miho Suzuki','Cassie Russek','Stacy Bisel','Adruitha Lee','Ahou Mofid','Jessica Lou Allen'],
costumes:['Erin Benach']},
{title:'The Suicide Squad',
titleCZ:'Sebevražedný oddíl',
year:2021,
runtime:132,
countries:['USA'],
genres:['Action','Adventure','Fantasy'],
director:['James Gunn'],
actors:['Margot Robbie','Idris Elba','John Cena','Joel Kinnaman','David Dastmalchian','Daniela Melchior','Viola Davis','Peter Capaldi','Jai Courtney','Michael Rooker','Pete Davidson','Nathan Fillion','Sean Gunn','Flula Borg','Mayling Ng','Mikaela Hoover','Storm Reid','Taika Waititi','Alice Braga','Joaquín Cosio','Juan Diego Botto','Steve Agee','Jennifer Holland','Sylvester Stallone','Dee Bradley Baker','Pom Klementieff','Lloyd Kaufman','Diany Rodriguez','Giovannie Cruz','Tinashe Kajese',"Gabriel 'G-Rod' Rodriguez",'Maya Le Clark'],
basedOn:['John Ostrander'],
screenplay:['James Gunn'],
production:['Charles Roven','Peter Safran'],
music:['John Murphy'],
camera:['Henry Braham'],
cut:['Fred Raskin'],
sound:['David Acord','Christopher Boyes'],
scenography:['Beth Mickle','Brittany Hites'],
masks:['Heba Thorisdottir','Brian Sipe','Greg Funk','Dee Dee Metzger','Ellen Arden']},
{title:'Blue Beetle',
titleCZ:'Blue Beetle',
year:2023,
runtime:127,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Angel Manuel Soto'],
actors:['Xolo Maridueña','Adriana Barraza','Damián Alcázar','Raoul Max Trujillo','Susan Sarandon','George Lopez','Elpidia Carrillo','Belissa Escobedo','Bruna Marquezine','Harvey Guillén','Becky G','Jorge Jimenez','Yuli Zorrilla','Gabriella Ortiz','Modesto Lacen'],
screenplay:['Gareth Dunnet-Alcocer'],
production:['John Rickard','Zev Foreman'],
music:['Bobby Krlic'],
camera:['Pawel Pogorzelski'],
cut:['Craig Alpert'],
sound:['Andrew DeCristofaro'],
scenography:['Jon Billington','Jennifer M. Gentile'],
masks:['Jacqueline D. Bell'],
costumes:['Mayes C. Rubeo']},
{title:'The Flash',
titleCZ:'Flash',
year:2023,
runtime:144,
countries:['USA'],
genres:['Action','Adventure','Fantasy','Sci-Fi'],
director:['Andy Muschietti'],
actors:['Ezra Miller','Michael Keaton','Sasha Calle','Ben Affleck','Michael Shannon','Kiersey Clemons','Maribel Verdú','Ron Livingston','Jeremy Irons','Rudy Mancuso','Temuera Morrison','Richie Lawrie','Ian Loh','Nina Barker-Francis','Antje Traue','Saoirse-Monica Jackson','Eric Tiede','Luke Brandon Field','Isabelle Bernardo','Andy Muschietti','Gal Gadot','Jason Momoa','George Clooney','Nicolas Cage'],
basedOn:['Gardner Fox','Harry Lampert'],
screenplay:['Christina Hodson'],
production:['Barbara Muschietti','Michael Disco'],
music:['Benjamin Wallfisch'],
camera:['Henry Braham'],
cut:['Jason Ballantine','Paul Machliss'],
sound:['Colin Nicolson','Michael Keller'],
scenography:['Paul D. Austerberry','Dominic Capon','Julia Dehoff'],
masks:['Victoria Down','Zoe Tahir'],
costumes:['Alexandra Byrne']},
{title:'The Lego Batman Movie',
titleCZ:'LEGO® Batman film',
year:2017,
runtime:104,
countries:['USA','Denmark'],
genres:['Animation','Action','Adventure','Comedy','Family','Fantasy'],
director:['Chris McKay'],
actors:['Will Arnett','Jenny Slate','Ralph Fiennes','Rosario Dawson','Zach Galifianakis','Michael Cera','Billy Dee Williams','Jonah Hill','Channing Tatum','Jason Mantzoukas',"Conan O'Brien",'Zoë Kravitz','Kate Micucci','Mariah Carey','Riki Lindhome','Eddie Izzard','Seth Green','Jemaine Clement','Ellie Kemper','Adam Devine','Hector Elizondo','David Burrows','Ralph Garman','Chris Hardwick','Chris McKay','John Venzon','Brent Musburger','Garret Elkins','Vanara Taing','Laura Kightlinger','Mark Jonathan Davis','Doug Benson'],
basedOn:['Bob Kane','Bill Finger'],
screenplay:['Seth Grahame-Smith','Erik Sommers','John Whittington','Chris McKenna','Jared Stern'],
production:['Roy Lee','Dan Lin','Phil Lord','Christopher Miller'],
music:['Lorne Balfe'],
cut:['Matt Villa','David Burrows','John Venzon'],
sound:['Gregg Landaker','Michael Semanick'],
scenography:['Grant Freckelton']},
{title:'DC League of Super-Pets',
titleCZ:'DC Liga supermazlíčků',
year:2022,
runtime:106,
countries:['USA'],
genres:['Animation','Action','Adventure','Comedy','Family'],
director:['Jared Stern','Sam Levine'],
actors:['Dwayne Johnson','John Krasinski','Keanu Reeves','Kate McKinnon','Kevin Hart','Natasha Lyonne','Diego Luna','Vanessa Bayer','Marc Maron','Dascha Polanco','Ben Schwartz','Jemaine Clement','Daveed Diggs','John Early','Jameela Jamil','Olivia Wilde','David Pressman'],
screenplay:['Jared Stern','John Whittington'],
production:['Dany Garcia','Hiram Garcia','Dwayne Johnson','Jared Stern'],
music:['Steve Jablonsky'],
cut:['David Egan','Jhoanne Reyes'],
scenography:['Kim Taylor']},
{title:'Teen Titans Go! To the Movies',
titleCZ:'Mladí Titáni do toho!: Ve filmu',
year:2018,
runtime:84,
countries:['USA'],
genres:['Animation','Musical','Fantasy','Sci-Fi','Adventure','Action','Comedy','Family'],
director:['Peter Rida Michail','Aaron Horvath','Edwin Poon','Eric Pringle','Benjy Brooke'],
actors:['Will Arnett','Kristen Bell','Greg Cipes','Nicolas Cage','Scott Menville','Khary Payton','Tara Strong','Hynden Walch','Stan Lee','Alexander Polinsky','Dave Stone'],
basedOn:['Bob Haney','Bruno Premiani'],
screenplay:['Aaron Horvath','Michael Jelenic'],
production:['Peter Rida Michail','Aaron Horvath','Michael Jelenic','Peggy Regan'],
music:['Jared Faber'],
sound:['Gregg Rudloff','David E. Fluhr','Rob McIntyre'],
scenography:['Dan Hipp']},
{title:'TRON: Legacy',
titleCZ:'TRON: Legacy 3D',
year:2010,
runtime:125,
countries:['USA'],
genres:['Sci-Fi','Action','Thriller','Adventure'],
director:['Joseph Kosinski'],
actors:['Jeff Bridges','Garrett Hedlund','Olivia Wilde','Bruce Boxleitner','James Frain','Beau Garrett','Michael Sheen','Serinda Swan','Yaya DaCosta','Elizabeth Mathis','Thomas Bangalter','Guy Manuel De Homem-Christo','Jeffrey Nordling','Christine Adams','Cillian Murphy','Daft Punk','Steven Lisberger','John Reardon','Donnelly Rhodes','Belinda Montgomery','Monique Ganderton','Matt Ward','Patrick Sabongui','Brent Stait','Darren Dolynski','Ki Yurij','Michael Teigen','Ron Selmour','Conrad Coates','Joanne Wilson','Dean Redman'],
screenplay:['Edward Kitsis','Adam Horowitz'],
production:['Jeffrey Silver','Sean Bailey'],
music:['Daft Punk','Thomas Bangalter','Guy Manuel De Homem-Christo'],
camera:['Claudio Miranda'],
cut:['James Haygood'],
sound:['Gwendolyn Yates Whittle','Gary Rizzo','Julian Howarth','Steve Boeddeker','Addison Teague','Christopher Boyes'],
scenography:['Darren Gilford','Gena Vazquez','Ben Procter'],
masks:['Rosalina Da Silva','Kazu Hiro','Rick Baker','Thomas Nellen'],
costumes:['Michael Wilkinson','Christine Bieselin Clark']},
{title:'In Time',
titleCZ:'Vyměřený čas',
year:2011,
runtime:105,
countries:['USA'],
genres:['Sci-Fi','Thriller','Action','Crime'],
director:['Andrew Niccol'],
actors:['Justin Timberlake','Amanda Seyfried','Cillian Murphy','Alex Pettyfer','Olivia Wilde','Johnny Galecki','Vincent Kartheiser','Aaron Perilo','Nick Lashaway','Matt Bomer','Yaya DaCosta','Toby Hemingway','Melissa Ordway','Ethan Peck','Adam Jamal Craig','Bella Heathcote','Kris Lemche','Sterling Sulieman','Rachel Roberts','Jessica Parker Kennedy',"Matt O'Leary",'Collins Pennie','Cathy Baron','Zuleyka Silver','Emma Fitzpatrick','La Monde Byrd','Sloane Avery','Jesse Lee Soffer','Will Peltz','Kristopher Higgins','Laura Ashley Samuels','Christian Madsen','Monique Ganderton','Korrina Rico','Christiann Castellanos','Will Harris','Abhi Sinha','Ray Santiago','Shyloh Oostwald','Luis Chávez','Alexander Alexandrov','Faye Kingslee','August Emerson','Marcos Mateo Ochoa','Michael William Freeman','Jason Weary','Alyssa de Boisblanc','Swen Temmel','Justin Galindo','Sam Meader','Brendan Miller','Sarah May Sommers','Blake Sheldon','Maximilian Osinski'],
screenplay:['Andrew Niccol'],
production:['Marc Abraham','Eric Newman','Andrew Niccol'],
music:['Craig Armstrong'],
camera:['Roger Deakins'],
cut:['Zach Staenberg'],
sound:['Richard King','David Giammarco','Paul Massey'],
scenography:['Alex McDowell',"Karen O'Hara"],
masks:['Stacey K. Black','Michelle Vittone-McNeil'],
costumes:['Colleen Atwood']},
{title:'Avatar: The Way of Water',
titleCZ:'Avatar: The Way of Water',
year:2022,
runtime:192,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Fantasy'],
director:['James Cameron'],
actors:['Sam Worthington','Zoe Saldana','Sigourney Weaver','Stephen Lang','Kate Winslet','Cliff Curtis','Joel David Moore','CCH Pounder','Edie Falco','Brendan Cowell','Jemaine Clement','Jamie Flatters','Britain Dalton','Trinity Bliss','Jack Champion','Bailey Bass','Filip Geljo','Duane Evans Jr.','Giovanni Ribisi','Dileep Rao','Matt Gerald','Robert Okumu','Keston John','Kevin Dorman','Alicia Vela-Bailey','Maria Walker','Joel Tobeck','Benjamin Hoetjes','Shane Rangi','Scarlett Fernandez','Chloe Coleman','Jake McLean'],
screenplay:['James Cameron','Rick Jaffa','Amanda Silver'],
production:['James Cameron','Jon Landau'],
music:['Simon Franglen'],
camera:['Russell Carpenter'],
cut:['David Brenner','James Cameron','John Refoua','Stephen E. Rivkin'],
sound:['Christopher Boyes','Gary Summers','Gwendolyn Yates Whittle','Michael Hedges','Tony Johnson','Dick Bernstein','Julian Howarth','Mark Weingarten','Dave Whitehead'],
scenography:['Dylan Cole','Ben Procter','Ben Milsom','Andy McLaren','Vanessa Cole','Simon Bright'],
masks:['Sarah Rubano','Katie Fox-Heywood','Thomas Nellen'],
costumes:['Bob Buck','Deborah L. Scott']},
{title:'Napoleon',
titleCZ:'Napoleon',
year:2023,
runtime:158,
countries:['USA','UK'],
genres:['History','War','Biographic','Drama','Action'],
director:['Ridley Scott'],
actors:['Joaquin Phoenix','Vanessa Kirby','Tahar Rahim','Rupert Everett','Mark Bonnar','Paul Rhys','Ben Miles','Ludivine Sagnier','Edouard Philipponnat','Miles Jupp','Scott Handy','Youssef Kerkour','John Hollingworth','Abubakar Salim','Jannis Niewöhner','Julian Rhind-Tutt','Benjamin Chivers','Sinéad Cusack','Matthew Needham','Sam Crane','Sam Troughton','Julian Wadham','Catherine Walker','Honor Kneafsey','Phil Cornwell','Harry Taurasi','Edward Mercieca','Andy Burse','Dominic Coleman','Ian McNeice','Richard McCabe','Gavin Spokes','David Verrey','Benedict Martin','Jonathan Barnwell','Robin Soans','Anna Mawn','Imogen Slaughter','Kevin Eldon','Tim Delap','Cormac Hyde-Corrin','Michael Nardone','Robert Goodman','Morgan Watkins','Maxime Durand'],
screenplay:['David Scarpa'],
production:['Kevin J. Walsh','Mark Huffam','Joaquin Phoenix','Ridley Scott'],
music:['Martin Phipps'],
camera:['Dariusz Wolski'],
cut:['Claire Simpson','Sam Restivo'],
sound:['Michael Fentum','James Harrison','Paul Massey','William Miller'],
scenography:['Arthur Max','Elli Griff'],
masks:['Jana Carboni','Francesco Pegoretti','Julia Vernon'],
costumes:['Janty Yates','David Crossman']},
{title:'Frozen',
titleCZ:'Ledové království',
year:2013,
runtime:109,
countries:['USA'],
genres:['Animation','Musical','Fantasy','Adventure','Comedy','Family'],
director:['Chris Buck','Jennifer Lee'],
actors:['Kristen Bell','Idina Menzel','Josh Gad','Jonathan Groff','Alan Tudyk','Ciarán Hinds','Santino Fontana','Jennifer Lee','Stephen J. Anderson','Robert Pine','Maurice LaMarche','Livvy Stubenrauch','Eva Bella','Jack Whitehall','Tyree Brown','Annaleigh Ashford','Nick Jameson','Ava Acres','Jeffrey Marcus','Edie McClurg','Jesse Corti','Raymond S. Persi','Paul Pape','Jadon Sand','Carter Sand','Paul Briggs','Kevin Duda','David Boat','Mona Marshall','Kirk Baily','June Christopher','Margaux Susi'],
basedOn:['Hans Christian Andersen'],
screenplay:['Jennifer Lee','Shane Morris'],
production:['Peter Del Vecho'],
music:['Christophe Beck','Robert Lopez','Kristen Anderson-Lopez'],
cut:['Jeff Draheim'],
sound:['David E. Fluhr','Odin Benitez']},
{title:'Frozen II',
titleCZ:'Ledové království II',
year:2019,
runtime:103,
countries:['USA'],
genres:['Animation','Musical','Fantasy','Adventure','Comedy','Family'],
director:['Chris Buck','Jennifer Lee'],
actors:['Idina Menzel','Kristen Bell','Jonathan Groff','Josh Gad','Sterling K. Brown','Evan Rachel Wood','Alfred Molina','Santino Fontana','Martha Plimpton','Jason Ritter','Jeremy Sisto','Ciarán Hinds','Rachel Matthews','Alan Tudyk','Mattea Conforti','Antonio Raul Corbo','Aurora Aksnes','Arnaud Léonard','Max Mittelman','David Boat','Jessica DiCicco','June Christopher','David Cowgill','Capri Oliver'],
screenplay:['Jennifer Lee'],
production:['Peter Del Vecho'],
music:['Christophe Beck'],
cut:['Jeff Draheim'],
sound:['Stephen P. Robinson','David E. Fluhr','Odin Benitez']},
{title:'Inside Out',
titleCZ:'V hlavě',
year:2015,
runtime:95,
countries:['USA'],
genres:['Animation','Fantasy','Adventure','Comedy','Drama','Family'],
director:['Pete Docter','Ronnie Del Carmen'],
actors:['Diane Lane','Amy Poehler','Mindy Kaling','Bill Hader','Kyle MacLachlan','Phyllis Smith','Lewis Black','Richard Kind','Jess Harnell','Carlos Alazraqui','Frank Oz','Paula Poundstone','Bobby Moynihan','Josh Cooley','Flea','John Ratzenberger','Rashida Jones','Molly Jackson','Phil Proctor','John Cygan','Teresa Ganzel','Jacob Hopkins',"Bret 'Brook' Parker",'Lori Alan','Jan Rabson','Mona Marshall','Danny Mann','Ronnie Del Carmen'],
screenplay:['Pete Docter','Ronnie Del Carmen','Meg LeFauve','Josh Cooley'],
production:['Jonas Rivera'],
music:['Michael Giacchino'],
cut:['Kevin Nolting'],
sound:['Michael Semanick','Shannon Mills','Tom Johnson']},
{title:'Ralph Breaks the Internet',
titleCZ:'Raubíř Ralf a internet',
year:2018,
runtime:113,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Phil Johnston','Rich Moore'],
actors:['John C. Reilly','Sarah Silverman','Gal Gadot','Taraji P. Henson','Jack McBrayer','Jane Lynch','Alan Tudyk','Alfred Molina',"Ed O'Neill",'Sean Giambrone','Flula Borg','Timothy Simons','Ali Wong','Kristen Bell','Mandy Moore','Kelly Macdonald','Idina Menzel',"Auli'i Cravalho",'Anthony Daniels','Ming-Na Wen','Anika Noni Rose','Irene Bedard','Rebecca Wisocky',"Paige O'Hara",'Jodi Benson','Ana Ortiz','Tim Allen','Vin Diesel','Daniel Platzman','Dan Reynolds','Jenica Bergere','Alex Moffat','Melissa Villaseñor','Jaboukie Young-White','Ben McKee','Wayne Sermon','Olivier Bénard','Della Saba','Brad Simonsen','Josie Trinidad','Jason Hightower','Kate Higgins','Michaela Zee','Linda Larkin'],
screenplay:['Phil Johnston','Pamela Ribon'],
production:['Clark Spencer'],
music:['Henry Jackman'],
cut:['Jeremy Milton','Fabienne Rawley'],
sound:['Gary Rydstrom','David E. Fluhr','Addison Teague','Jeremy Bowker'],
scenography:['Cory Loftis']},
{title:'The Revenant',
titleCZ:'Revenant zmrtvýchvstání',
year:2015,
runtime:156,
countries:['USA','Hong Kong','Taiwan'],
genres:['Adventure','Drama','Thriller','Western'],
director:['Alejandro González Iñárritu'],
actors:['Leonardo DiCaprio','Tom Hardy','Domhnall Gleeson','Will Poulter','Forrest Goodluck','Duane Howard','Arthur Redcloud',"Melaw Nakehk'o",'Grace Dove','Lukas Haas','Paul Anderson','Kristoffer Joner','Joshua Burge','Robert Moloney','Brendan Fletcher','Tyson Wood','McCaleb Burnett','Vincent Leclerc','Javier Botet','Brad Carter','Haysam Kadri','T. Michael Morris','Christopher Rosamond','Adrian McMorran','Alex Bisping','Mark Krysko','Michael Villar','Isaiah Tootoosis'],
basedOn:['Michael Punke'],
screenplay:['Mark L. Smith','Alejandro González Iñárritu'],
production:['Arnon Milchan','Steve Golin','Alejandro González Iñárritu','Mary Parent','Keith Redmon','James W. Skotchdopole'],
music:['Rjúiči Sakamoto','Carsten Nicolai'],
camera:['Emmanuel Lubezki'],
cut:['Stephen Mirrione'],
sound:['Martín Hernández','Randy Thom','Jon Taylor','Frank A. Montaño'],
scenography:['Jack Fisk','Hamish Purdy'],
masks:['Graham Johnston','Sharon Toohey','Vicki Syskakis','Jo-Dee Thomson','Adrien Morot','Vince Yoshida','Toby Lindala'],
costumes:['Jacqueline West']},
{title:'Wonka',
titleCZ:'Wonka',
year:2023,
runtime:116,
countries:['USA'],
genres:['Adventure','Comedy','Family','Fantasy','Musical'],
director:['Paul King'],
actors:['Timothée Chalamet','Calah Lane','Olivia Colman','Hugh Grant','Keegan-Michael Key','Paterson Joseph','Rowan Atkinson','Matt Lucas','Mathew Baynton','Sally Hawkins','Rakhee Thakrar','Jim Carter','Natasha Rothwell','Tom Davis','Rich Fulcher','Simon Farnaby','Kobna Holdbrook-Smith','Ellie White',"Colin O'Brien",'Tracy Ifeachor','Justin Edwards','Freya Parker','Murray McArthur','Rufus Jones','Isy Suttie'],
screenplay:['Simon Farnaby','Paul King'],
production:['David Heyman','Alexandra Derbyshire','Luke Kelly'],
music:['Joby Talbot','Neil Hannon'],
camera:['Jung-hoon Jung'],
cut:['Mark Everson'],
sound:['Niv Adiri','John Casali','Glenn Freemantle','Paul Massey'],
scenography:['Nathan Crowley','Tom Brown','Andrea Borland','Toby Britton','Gavin Fitch','Roxana Alexandru'],
masks:['Heather Manson','Natasha Richards'],
costumes:['Lindy Hemming']},
{title:'Just Mercy',
titleCZ:'Obhájce nevinných',
year:2019,
runtime:136,
countries:['USA'],
genres:['Drama','Crime','Biographic'],
director:['Destin Daniel Cretton'],
actors:['Michael B. Jordan','Jamie Foxx','Rob Morgan','Tim Blake Nelson','Rafe Spall',"O'Shea Jackson Jr.",'Karan Kendrick','Brie Larson','J. Alphonse Nicholson','Darrell Britt-Gibson','Michael Harding','Adam Boyer','Charmin Lee','John Lacy','Dominic Bogart','Hayes Mercure','Denitra Isler','Terence Rosemore','Pete Burris','Ron Clinton Smith','Andrene Ward-Hammond','Alex Van','Lindsay Ayliffe','Ted Huckabee','Tim Ware','Norm Lewis','Claire Bronson','Drew Starkey','Rhoda Griffis','Elizabeth Becka','Steve Coulter','Harvey B. Jackson','Jay DeVon Johnson','Drew Scheid','Tonea Stewart','Robert Tinsley','Al Mitchell','Ryan Dinning'],
screenplay:['Destin Daniel Cretton','Andrew Lanham'],
production:['Gil Netter','Michael B. Jordan'],
music:['Joel P. West'],
camera:['Brett Pawlak'],
cut:['Nat Sanders'],
sound:['Onnalee Blank','Mathew Waters','Katy Wood'],
scenography:['Sharon Seymour','Maggie Martin'],
masks:['Natalie Johnson','Andrea Bowman','David Atherton'],
costumes:['Francine Jamison-Tanchuck']},
{title:'Rogue One: A Star Wars Story',
titleCZ:'Rogue One: Star Wars Story',
year:2016,
runtime:133,
countries:['USA'],
genres:['Action','Adventure','Fantasy','Sci-Fi'],
director:['Gareth Edwards'],
actors:['Felicity Jones','Mads Mikkelsen','Alan Tudyk','Ben Mendelsohn','Diego Luna','Forest Whitaker','Riz Ahmed','James Earl Jones','Jimmy Smits','Warwick Davis','Donnie Yen','Wen Jiang','Jonathan Aris',"Genevieve O'Reilly",'Arthur L. Bernstein','Attila G. Kerekes','Ned Dennehy','Alistair Petrie','Daniel Eghan','Paul Kasey','Michael Smiley','Drewe Henley','Anthony Daniels','Fares Fares','Ian McElhinney','Duncan Pow','Valene Kane','Verona Blue','Kamil Lemieszewski','Weston Gavin','Angus Wright','Sezer Ünver','Axel Nu','Beau Gadsdon','David M. Santana','Ivy Wong','Sharon Duncan-Brewster','Daniel Mays','Robert Benedetti-Hall','Pablo Verdejo','Carrie Fisher','Peter Cushing','Benjamin Hartley','Michael Gould','Gabby Wong','Ingvild Deila','Stephen Stanton','Andy de la Tour','Tim Beckmann','Nick Donald'],
screenplay:['Tony Gilroy','Chris Weitz'],
production:['Kathleen Kennedy','Allison Shearmur','Simon Emanuel'],
music:['Michael Giacchino'],
camera:['Greig Fraser'],
cut:['Jabez Olssen','John Gilroy','Colin Goudie'],
sound:['David Parker','David Acord','Matthew Wood','Christopher Scarabosio'],
scenography:['Doug Chiang','Neil Lamont','Lee Sandales','Stephen Swain'],
masks:['Amanda Knight','Amy Byrne','Siân Miller','Giuliano Mariano'],
costumes:['David Crossman','Glyn Dillon']},
{title:'Jackass: The Movie',
titleCZ:'Jackass: Film',
year:2002,
runtime:85,
countries:['USA'],
genres:['Comedy'],
director:['Jeff Tremaine'],
actors:['Johnny Knoxville','Bam Margera','Chris Pontius','Steve-O','Ryan Dunn','Jason Acuña','Preston Lacy','Dave England','Ehren McGhehey','Brandon Dicamillo','Henry Rollins','Tony Hawk','Spike Jonze','Jason Fijal','Rip Taylor','Jeff Tremaine','Mat Hoffman','Rakeyohn','Chris Raab','Phil Margera','April Margera','Gene LeBell','Greg Iguchi'],
production:['Spike Jonze'],
sound:['Mathew Waters','Joe Barnett','Aaron Levy'],
masks:['Tony Gardner','Rob Burman','Bill Corso','Scott Wheeler','Michael Marino'],
costumes:['Melissa Lacombe']},
{title:'Jackass 4',
titleCZ:'Jackass Forever',
year:2022,
runtime:96,
countries:['USA'],
genres:['Comedy'],
director:['Jeff Tremaine'],
actors:['Johnny Knoxville','Steve-O','Chris Pontius','Jason Acuña','Preston Lacy','Spike Jonze','Eric André','Dave England','Ehren McGhehey','Machine Gun Kelly','Jeff Tremaine','Tony Hawk','Tory Belleci','Bam Margera','P.K. Subban','Davon Wilson','Sean McInerney','Zach Holmes','Rachel Wolfson','Eric Manaka','Compston Wilson','Ryan Dunn','Lionel Boyce','Greg Iguchi','Travis Bennett'],
production:['Spike Jonze','Jeff Tremaine','Johnny Knoxville','Steve-O'],
music:['Joseph Shirley'],
camera:['Lance Bangs'],
cut:['Sascha Stanton Craven','Matthew Kosinski'],
scenography:['Donna Stack Cliver'],
masks:['Julie Hassett','Thomas Floutz']},
{title:'A Breed Apart',
titleCZ:'Nebezpečné tajemství',
year:1984,
runtime:95,
countries:['USA'],
genres:['Drama','Action'],
director:['Philippe Mora'],
actors:['Rutger Hauer','Powers Boothe','Kathleen Turner','Donald Pleasence','Brion James','John Dennis Johnston','Andy Fenwick','Jayne Bentzen','C.K. Bibby','Laurens Moore','Mert Hatfield'],
screenplay:['Paul Wheeler'],
production:['Derek Gibson','John Daly'],
music:['Maurice Gibb'],
camera:['Geoffrey Stephenson'],
cut:['Chris Lebenzon'],
sound:['Allen L. Stone','Carey Lindley'],
scenography:['William Barclay'],
costumes:['John Boxer']},
{title:'Fantastic Beasts and Where to Find Them',
titleCZ:'Fantastická zvířata a kde je najít',
year:2016,
runtime:133,
countries:['UK','USA'],
genres:['Adventure','Family','Fantasy'],
director:['David Yates'],
actors:['Eddie Redmayne','Dan Fogler','Colin Farrell','Katherine Waterston','Alison Sudol','Ezra Miller','Samantha Morton','Jenn Murray','Jon Voight','Gemma Chan','Carmen Ejogo','Ron Perlman','Christine Marzano','Faith Wood-Blagrove','Lasco Atkins','Paul Bergquist','Jason Redshaw','Mitchell Thornton','Peter Breitmayer','Miroslav Zaruba','Akin Gazi','Attila G. Kerekes','Kornelia Horvath','Lobna Futers','Johnny Depp','Miquel Brown','Zoë Kravitz','Elizabeth Moynihan','Richard Price','Josh Cowdery','Richard Clothier','Reid Anderson','Silvia Crastan','Ronan Raftery','Greg Brummel','Bart Edwards','Arinzé Kene','Rich Hardesty','Leigh Gill','Bryn Jones','Jane Perry','Tom Clarke Hill','Pete Meads','Annarie Boor','Brian F. Mulvey','Wunmi Mosaku','Rudi Dharmalingam','Reece Putinas','Sam Redford','Paul Low-Hang','Andreea Paduraru','Nick Donald'],
basedOn:['J. K. Rowling'],
screenplay:['J. K. Rowling'],
production:['J. K. Rowling','David Heyman','Steve Kloves','Lionel Wigram'],
music:['James Newton Howard'],
camera:['Philippe Rousselot'],
cut:['Mark Day'],
sound:['Niv Adiri','Ben Barker','Eilam Hoffman','Glenn Freemantle','Simon Hayes','Andy Nelson'],
scenography:['Stuart Craig','James Hambidge','Toby Britton','Guy Bradley','Gavin Fitch','Anna Pinnock'],
masks:['Fae Hammond','Nicky Knowles','Mark Coulier','Tania Couper','Donald McInnes','Loulia Sheppard','David Malinowski','Jules Greenan','Josh Weston'],
costumes:['Colleen Atwood']},
{title:'Fantastic Beasts: The Crimes of Grindelwald',
titleCZ:'Fantastická zvířata: Grindelwaldovy zločiny',
year:2018,
runtime:134,
countries:['UK','USA'],
genres:['Adventure','Family','Fantasy'],
director:['David Yates'],
actors:['Eddie Redmayne','Katherine Waterston','Dan Fogler','Johnny Depp','Jude Law','Alison Sudol','Ezra Miller','Zoë Kravitz','Claudia Kim','Carmen Ejogo','Jessica Williams','Ólafur Darri Ólafsson','Callum Turner','Victoria Yeates','Poppy Corby-Tuech','Brontis Jodorowsky','William Nadylam','Fiona Glascott','Derek Riddell','Kevin Guthrie','David Sakurai','Ingvar Sigurðsson','Kamil Lemieszewski','Reid Anderson','Jamie Campbell Bower','Toby Regbo','Silvia Crastan','Wolf Roth','Cornell John','Simon Meacock','David Wilmot','Ed Gaughan','Olwen Fouéré','Hugh Quarshie','Sabine Crossen','Maja Bloom','Bart Soroczynski','Olivia Popica','Danielle Hugues','Alfie Simmons','Jemima Woolnough','Hollie Burgess','Thea Lamb','Joshua Shea','Alfrun Rose','Isaura Barbé-Brown','Keith Chanter','Maddie Evans','Annarie Boor','Linda Santiago','Daisy Stone','Jan Freygang','Nick Donald'],
basedOn:['J. K. Rowling'],
screenplay:['J. K. Rowling'],
production:['J. K. Rowling','David Heyman','Steve Kloves','Lionel Wigram'],
music:['James Newton Howard'],
camera:['Philippe Rousselot'],
cut:['Mark Day'],
sound:['Niv Adiri','Ben Barker','Glenn Freemantle','Andy Nelson','Mitch Low'],
scenography:['Stuart Craig','Anna Pinnock'],
masks:['Fae Hammond','Kenny Niederbaumer','Nicky Knowles','Jessica Brooks','Loulia Sheppard','Josh Weston'],
costumes:['Colleen Atwood']},
{title:'Fantastic Beasts: The Secrets of Dumbledore',
titleCZ:'Fantastická zvířata: Brumbálova tajemství',
year:2022,
runtime:143,
countries:['USA'],
genres:['Adventure','Family','Fantasy'],
director:['David Yates'],
actors:['Eddie Redmayne','Jude Law','Ezra Miller','Alison Sudol','Mads Mikkelsen','Dan Fogler','Jessica Williams','Katherine Waterston','Callum Turner','Fiona Glascott','William Nadylam','Kevin Guthrie','Victoria Yeates','Richard Coyle','Oliver Masucci','Ingvar Sigurðsson','Poppy Corby-Tuech','Maria Fernanda Cândido','Maja Bloom','Simon Meacock','Bart Soroczynski','Wilf Scolding','Manuel Klein','Alexandr Kuzněcov','Valerie Pachner','Ramona Kunze-Libnow','Lucas Englander','Jan Pohl','Matthias Brenner','Peter Simonischek','Jacqueline Boatswain','David Bertrand','Jeremy Azis','Hebe Beardsall','Nick Davison','Paul Low-Hang','Dave Wong','Dónal Finn'],
basedOn:['J. K. Rowling'],
screenplay:['Steve Kloves','J. K. Rowling'],
production:['David Heyman','J. K. Rowling'],
music:['James Newton Howard'],
camera:['George Richmond'],
cut:['Mark Day'],
sound:['Niv Adiri','Mitch Low','Andy Nelson'],
scenography:['Stuart Craig','Neil Lamont','Anna Pinnock'],
costumes:['Colleen Atwood']},
{title:'Contagion',
titleCZ:'Nákaza',
year:2011,
runtime:106,
countries:['USA','United Arab Emirates'],
genres:['Drama','Thriller'],
director:['Steven Soderbergh'],
actors:['Marion Cotillard','Matt Damon','Laurence Fishburne','Jude Law','Kate Winslet','Elliott Gould','Bryan Cranston','Gwyneth Paltrow','Tien-you Chui','Josie Ho','Monique Gabriela Curnen','John Hawkes','Armin Rohde','Jennifer Ehle','Demetri Martin','Enrico Colantoni','Chin Han','Sanaa Lathan','Sanjay Gupta','Steven Soderbergh','Amanda Dyar','Griffin Kane','Ina Lereine','Sue Redman','Rebecca Spence','Alexander Kanellakos','E. Roger Mitchell','Jonathan Davila','Raymond Tsang','Jesse Muick','Scott Stangland','Mike Alfieri','Russ Panzarella','Grace Rex','Howie Johnson','Larry Clarke','Jim Ortlieb','Kara Zediker','John Hoogenakker','Anna Jacoby-Heron','Annabel Armour','Peggy Sandow','Liz Clare','Walt Sloan','Carl Marino','Ahmed Boulane','Ryan Ebert','Jeff Stenzel','Bambadjan Bamba','Andrew Dasz','Ylian Alfaro Snyder','Dan Flannery','Joshua Rollins','Helen Sadler','Teri McEvoy','Larry Nazimek','Tara Mallen'],
screenplay:['Scott Z. Burns'],
production:['Stacey Sher','Michael Shamberg','Gregory Jacobs'],
music:['Cliff Martinez'],
camera:['Steven Soderbergh'],
cut:['Stephen Mirrione'],
scenography:['Howard Cummings'],
masks:['Lisa Jelic','Stephan Dupuis','Kay Georgiou','Kate Biscoe','Jennifer Tremont','Alma Izquierdo'],
costumes:['Louise Frogley']},
{title:'Maleficent',
titleCZ:'Zloba - Královna černé magie',
year:2014,
runtime:97,
countries:['USA','UK'],
genres:['Fantasy','Adventure','Action','Romance','Family'],
director:['Robert Stromberg'],
actors:['Angelina Jolie','Sharlto Copley','Elle Fanning','Sam Riley','Imelda Staunton','Juno Temple','Lesley Manville','Brenton Thwaites','Kenneth Cranham','Ella Purnell','Julian Seager','Marama Corlett','Leo Suter','Hannah New','Jd Roth-round','Vivienne Jolie-Pitt','Stephan Chase','Lasco Atkins','John Macmillan','Steven Cree','Sarah Flind','Mark Caven','Jackson Bews','Matt Hookings','Angus Wright','Tim Treloar','Craig Garner','Bruno Mello','Richard Summers-Calvert','Anthony May','Daniel Stisen','Isobelle Molloy','David Boat','Adam Bond','Sophie-Anna Brough','Chris Leaney','Scott Bradley','Nick Donald'],
basedOn:['Jacob Grimm','Wilhelm Grimm','Charles Perrault'],
screenplay:['Linda Woolverton'],
production:['Joe Roth'],
music:['James Newton Howard'],
camera:['Dean Semler'],
cut:['Chris Lebenzon','Richard Pearson'],
sound:['Frank Eulner','David Parker','Gary Rizzo','Steve Boeddeker','Chris Munro'],
scenography:['Dylan Cole','Gary Freeman','Lee Sandales','Phil Sims'],
masks:['Joceline Andrews','Tamsin Dorling Barbosa','David White','Arjen Tuiten','Rebecca Cole','Paul Gooch','Rick Baker','Roz Abery'],
costumes:['Anna Biedrzycka-Sheppard']},
{title:'Maleficent: Mistress of Evil',
titleCZ:'Zloba: Královna všeho zlého',
year:2019,
runtime:118,
countries:['USA','UK'],
genres:['Fantasy','Adventure','Action','Romance','Family'],
director:['Joachim Rønning'],
actors:['Angelina Jolie','Elle Fanning','Michelle Pfeiffer','Harris Dickinson','Sam Riley','Ed Skrein','Chiwetel Ejiofor','Robert Lindsay','Jenn Murray','Imelda Staunton','Juno Temple','Lesley Manville','Alex Martin','Axel Nu','David Gyasi','Warwick Davis','Michael Akinsulire','Charles Berthoud','Ivy Wong','Judith Shekoni','Barry Aird','Arjen Tuiten','Tom Bonington','Tina Gray','Topo Wresniwiro','Freddie Wise','Rebecca Kunikowski'],
screenplay:['Linda Woolverton','Micah Fitzerman-Blue','Noah Harpster','Rebekah F. Smith'],
production:['Angelina Jolie','Joe Roth','Duncan Henderson'],
music:['Geoff Zanelli'],
camera:['Henry Braham'],
cut:['Laura Jennings','Craig Wood'],
sound:['James Mather','Niv Adiri','Paul Massey','Baard H. Ingebretsen'],
scenography:['Patrick Tatopoulos','Dominic Capon','Luke Whitelock','Toby Britton','Will Coubrough','Guy Bradley','Daniel Nussbaumer'],
masks:["Valli O'Reilly",'David White','Arjen Tuiten','Ann Fenton','Erin Ayanian','Paul Gooch','Jessica Brooks','Uxue Laguardia','Daniele Nastasi'],
costumes:['Ellen Mirojnick']},
{title:"You Don't Mess with the Zohan",
titleCZ:'Zohan: Krycí jméno Kadeřník',
year:2008,
runtime:113,
countries:['USA'],
genres:['Comedy','Action','Drama'],
director:['Dennis Dugan'],
actors:['Adam Sandler','John Turturro','Emmanuelle Chriqui','Nick Swardson','Lainie Kazan','Ido Mosseri','Rob Schneider','Dave Matthews','Charlotte Rae','Kevin Nealon','Robert Smigel','Chris Rock','Mariah Carey','John McEnroe','George Takei','Ahmed Ahmed','Dennis Dugan','Henry Winkler','Saye Yabandeh','Kevin James','Dom DeLuise','Eloise DeJoria','Dana Goodman','Moran Atias','Barbara Jean Barrielle','Riley Thomas Stewart','Holly Weber','Mousa Kraish','Lily Javaherpour','Guri Weinberg','Julia Lea Wolov','Ori Pfeffer','Tyler Spindel','Todd Holland','Danny A. Abeckaser','Julius Zagon','Marco Khan','Anne Marie Howard','Helen Siff','Yossi Marshek','Penelope Windust','Kevin Grady','Barry Livingston','Mikael Sharafyan','Edmund Lyndeck','Michael Buffer','John Farley','Mike Batayeh','Anthony Martins','Mark Kubr','Donielle Artese','Sidney Ganis','Donna Feldman','Shelley Berman','Ian Fisher','Terrie Snell','Bunny Levine','John Duerler','Shulie Cowen','Sarah Stringer','Anna Berger','Herzl Tobey','Ido Mor','Rick Gifford','Dina Doron','Betty Murphy','Alec Mapa','Daniel Browning Smith','Roni Meron','Sam Kalidi','Sepideh Haftgoli','Phoebe Dorin','Rock Kohli','Alex Luria'],
screenplay:['Adam Sandler','Robert Smigel','Judd Apatow'],
production:['Jack Giarraputo','Adam Sandler'],
music:['Rupert Gregson-Williams'],
camera:['Michael Barrett'],
cut:['Tom Costain'],
sound:['Gary C. Bourgeois','Greg Orloff'],
scenography:['Perry Andelin Blake','Ronald R. Reiss'],
masks:['Jamie Kelman','Kazu Hiro'],
costumes:['Ellen Lutter']},
{title:'Predator 2',
titleCZ:'Predátor 2',
year:1990,
runtime:108,
countries:['USA'],
genres:['Action','Sci-Fi','Thriller','Horror'],
director:['Stephen Hopkins'],
actors:['Danny Glover','Kevin Peter Hall','Gary Busey','Rubén Blades','Maria Conchita Alonso','Bill Paxton','Robert Davi','Adam Baldwin','Calvin Lockhart','Elpidia Carrillo','Lilyan Chauvin','Michael Papajohn','Abraham Alvarez','Jsu Garcia','Paul Abascal','Kent McCord','Paulo Tocha','Thomas Rosales Jr.','Casey Sander','Steve Kahan',"Billy 'Sly' Williams",'Michael Wiseman','Julian Reyes','Morton Downey Jr.','Sylvia Kauders','Henry Kingi','Pat Skipper','Lucinda Weist','Vonte Sweet','Jim Ishida','Carl Pistilli','Richard Anthony Crenna','Teri Weigel','Manny Perry','Hal Rayle'],
screenplay:['Jim Thomas','John Thomas'],
production:['John Davis','Lawrence Gordon','Joel Silver'],
music:['Alan Silvestri'],
camera:['Peter Levy'],
cut:['Bert Lovitt','Mark Goldblatt'],
sound:['Sergio Reyes','Chris David'],
scenography:['Lawrence G. Paull'],
masks:['Scott H. Eddo','Michael Mills','Kevin Westmore'],
costumes:['Marilyn Vance']},
{title:'Predators',
titleCZ:'Predátoři',
year:2010,
runtime:107,
countries:['USA'],
genres:['Action','Adventure','Thriller','Sci-Fi'],
director:['Nimród Antal'],
actors:['Adrien Brody','Topher Grace','Alice Braga','Walton Goggins','Oleg Taktarov','Laurence Fishburne','Danny Trejo','Louis Ozawa','Mahershala Ali','Carey Jones','Brian Steele','Derek Mears'],
screenplay:['Alex Litvak','Michael Finch'],
production:['Robert Rodriguez','John Davis','Elizabeth Avellan'],
music:['John Debney'],
camera:['Gyula Pados'],
cut:['Dan Zimmerman'],
sound:['Sergio Reyes','Paula Fairfield'],
scenography:['Caylah Eddleblute','Steve Joyner'],
masks:['Howard Berger','Greg Nicotero','Greg Funk'],
costumes:['Nina Proctor']},
{title:'Alien³',
titleCZ:'Vetřelec ³',
year:1992,
runtime:114,
countries:['USA'],
genres:['Sci-Fi','Action','Horror'],
director:['David Fincher'],
actors:['Sigourney Weaver','Charles S. Dutton','Charles Dance','Paul McGann','Brian Glover','Ralph Brown','Danny Webb','Holt McCallany','Lance Henriksen','Christopher Fairbank','Leon Herbert','Vincenzo Nicoli','Pete Postlethwaite','Clive Mantle','Peter Guinness','Deobia Oparei','Phil Davis','Hi Ching','Tom Woodruff Jr.','Paul Brennen','Christopher John Fields'],
screenplay:['David Giler','Walter Hill','Larry Ferguson'],
production:['Walter Hill','David Giler','Gordon Carroll'],
music:['Elliot Goldenthal'],
camera:['Alex Thomson'],
cut:['Terry Rawlings'],
sound:['Chris David'],
scenography:['Norman Reynolds','Michael White'],
masks:['Nick Dudman','Scott Oshita','Greg Cannom'],
costumes:['Bob Ringwood','David Perry']},
{title:'Alien: Covenant',
titleCZ:'Vetřelec: Covenant',
year:2017,
runtime:122,
countries:['USA','UK'],
genres:['Sci-Fi','Thriller','Horror'],
director:['Ridley Scott'],
actors:['Michael Fassbender','Katherine Waterston','Billy Crudup','Danny McBride','Demián Bichir','Carmen Ejogo','Jussie Smollett','Callie Hernandez','Amy Seimetz','Alexander England','Goran D. Kleut','James Franco','Guy Pearce','Noomi Rapace','Javier Botet','Tess Haubrich','Nathaniel Dean','Uli Latukefu','Benjamin Rigby'],
screenplay:['John Logan','Dante Harper'],
production:['Ridley Scott','David Giler','Walter Hill','Mark Huffam','Michael Schaefer'],
music:['Jed Kurzel'],
camera:['Dariusz Wolski'],
cut:['Pietro Scalia'],
sound:['Oliver Tarney','Paul Massey','Michael Fentum','Mark Taylor','Pedro Sánchez Alonso'],
scenography:['Chris Seagers','Victor J. Zolfo'],
masks:['Lesley Vanderwalt','Giuliano Mariano'],
costumes:['Janty Yates']},
{title:'Alien: Resurrection',
titleCZ:'Vetřelec: Vzkříšení',
year:1997,
runtime:109,
countries:['USA'],
genres:['Action','Horror','Sci-Fi'],
director:['Jean-Pierre Jeunet'],
actors:['Sigourney Weaver','Winona Ryder','Dominique Pinon','Ron Perlman','Gary Dourdan','Michael Wincott','Kim Flowers','Dan Hedaya','J.E. Freeman','Brad Dourif','Raymond Cruz','Leland Orser','David St. James','Daniel Raymont','Tom Woodruff Jr.','Archie Hahn','Brad Martin','David Prior','Steven Gilborn',"Cris D'Annunzio"],
screenplay:['Joss Whedon'],
production:['Bill Badalato','Walter Hill','David Giler','Gordon Carroll'],
music:['John Frizzell'],
camera:['Darius Khondji'],
cut:['Hervé Schneid'],
sound:['Paul Urmson','John A. Larsen'],
scenography:['Nigel Phelps','John M. Dwyer'],
masks:['Mike Smithson','Naomi Donne','Jane Galli','Paul Anthony Morris'],
costumes:['Bob Ringwood']},
{title:'Glass Onion: A Knives Out Mystery',
titleCZ:'Na nože: Glass Onion',
year:2022,
runtime:139,
countries:['USA'],
genres:['Mystery','Crime','Comedy','Thriller','Drama'],
director:['Rian Johnson'],
actors:['Daniel Craig','Edward Norton','Janelle Monáe','Kathryn Hahn','Leslie Odom Jr.','Kate Hudson','Dave Bautista','Jessica Henwick','Madelyn Cline','Noah Segan','Jackie Hoffman','Dallas Roberts','Ethan Hawke','Hugh Grant','Yo-Yo Ma','Eddie Gorodetsky','Dan Chariton','Adam Davenport','Serena Williams','Natasha Lyonne','Kareem Abdul-Jabbar','Stephen Sondheim','Angela Lansbury','Joseph Gordon-Levitt','Momo Pićurić'],
screenplay:['Rian Johnson'],
production:['Ram Bergman','Rian Johnson'],
music:['Nathan Johnson'],
camera:['Steve Yedlin'],
cut:['Bob Ducsay'],
sound:['Matthew Wood','Juan Peralta'],
scenography:['Rick Heinrichs','Elli Griff','Dragan Kaplarevic'],
masks:['Jeremy Woodhead'],
costumes:['Jenny Eagan']},
{title:'The Mask',
titleCZ:'Maska',
year:1994,
runtime:101,
countries:['USA'],
genres:['Fantasy','Action','Comedy','Crime'],
director:['Chuck Russell'],
actors:['Jim Carrey','Peter Riegert','Peter Greene','Amy Yasbeck','Tim Bagley','Nancy Fish','Reg E. Cathey','Cameron Diaz','Joely Fisher','Ben Stein','Meadow Williams','Kevin Grevioux','Blake Clark','Max','Denis Forest','Johnny Williams','Orestes Matacena','Richard Jeni','Nils Allen Stewart',"Robert O'Reilly",'Monica Lee Bellais','Jeremy Roberts','Richard Raynesford','Christopher Darga','Garret Sato','Ivory Ocean','Joseph Alfieri','Robert Keith','Jim Doughan'],
screenplay:['Mike Werb'],
production:['Robert Engelman'],
music:['Randy Edelman'],
camera:['John R. Leonetti'],
cut:['Arthur Coburn'],
sound:['Ken Teaney','William Freesh'],
scenography:['Craig Stearns','Ellen Totleben'],
masks:['Greg Cannom'],
costumes:['Ha Nguyen']},
{title:'Star Trek Beyond',
titleCZ:'Star Trek: Do neznáma',
year:2016,
runtime:122,
countries:['USA','Hong Kong','China'],
genres:['Sci-Fi','Adventure','Action','Thriller'],
director:['Justin Lin'],
actors:['Chris Pine','Zachary Quinto','Karl Urban','Zoe Saldana','Simon Pegg','John Cho','Anton Yelchin','Idris Elba','Sofia Boutella','Joe Taslim','Lydia Wilson','Deep Roy','Joseph Gatt','Fiona Vroom','Natalie Moon','Christian Sloan','Shohreh Aghdashloo','Greg Grunberg','Sara Maria Forsberg','Jason Matthew Smith','Roxanne Fernandes','Shea Whigham','Nicole Anthony','Priya Rajaratnam','Anthony Shim','Alika Autran','Thomas Cadrot','Jake Foy','Jeff Bezos','Emy Aneke','Alex Rose'],
screenplay:['Simon Pegg','Doug Jung','Roberto Orci','Patrick McKay','John D. Payne'],
production:['J.J. Abrams','Roberto Orci','Lindsey Weber','Justin Lin'],
music:['Michael Giacchino'],
camera:['Stephen F. Windon'],
cut:['Kelly Matsumoto','Dylan Highsmith',"Greg D'Auria",'Steven Sprung'],
sound:['Jon Taylor','Stephen P. Robinson','Frank A. Montaño'],
scenography:['Thomas E. Sanders','Harry E. Otto'],
masks:['Charles Porlier','Matt Rose','Monica Huppert','Lil Batista','Mike Fields','Megan Harkness','Patricia Murray','Toby Lindala','Sarah Graham'],
costumes:['Sanja Milkovic Hays']},
{title:'Star Trek: The Motion Picture',
titleCZ:'Star Trek: Film',
year:1979,
runtime:132,
countries:['USA'],
genres:['Sci-Fi','Adventure'],
director:['Robert Wise'],
actors:['William Shatner','Leonard Nimoy','DeForest Kelley','James Doohan','George Takei','Walter Koenig','Nichelle Nichols','Majel Barrett','Persis Khambatta','Stephen Collins','Grace Lee Whitney','Roger Aaron Brown','David Gautreaux','Franklyn Seales','Fred Bronson','Susan Sackett','Billy Van Zandt','Marcy Lafferty','Frank Salsedo','Mark Lenard','Norman Stuart','Christopher Doohan','Jimmie Booth','David Gerrold','Ve Neill',"Susan O'Sullivan",'John Gowans','Jon Rashad Kamal','Ralph Byers','Tom Morga','Paula Crist',"Terrence O'Connor"],
screenplay:['Harold Livingston'],
production:['Gene Roddenberry'],
music:['Jerry Goldsmith'],
camera:['Richard H. Kline'],
cut:['Todd C. Ramsay'],
sound:['Richard L. Anderson','Steve Maslow','Bill Varney','Gregg Landaker'],
scenography:['Harold Michelson'],
masks:['Fred B. Phillips','Ve Neill','Janna Phillips','Susan A. Cabral'],
costumes:['Robert Fletcher']},
{title:'Star Trek: The Cage',
titleCZ:'Star Trek: Klec',
year:1965,
runtime:64,
countries:['USA'],
genres:['Sci-Fi','Adventure'],
director:['Robert Butler'],
actors:['Jeffrey Hunter','Susan Oliver','Leonard Nimoy','Majel Barrett','John Hoyt','Peter Duryea','Laurel Goodwin','Meg Wyllie','Adam Roarke','Jon Lormer','Felix Silla','Joseph Mell','Robert Phillips','Anthony Jochim','Malachi Throne','Serena Sande','Bob Johnson'],
screenplay:['Gene Roddenberry'],
production:['Gene Roddenberry'],
music:['Alexander Courage'],
camera:['William E. Snyder'],
cut:['Leo H. Shreve'],
scenography:['Pato Guzman'],
masks:['John Chambers'],
costumes:['William Ware Theiss']},
{title:'star trek: renegades',
titleCZ:'Star Trek: Renegades',
year:2015,
runtime:88,
countries:['USA'],
genres:['Sci-Fi','Action','Adventure'],
director:['Tim Russ'],
actors:['Corin Nemec','Robert Picardo','Walter Koenig','Tim Russ','Courtney Peldon','Edward Furlong','Adrienne Wilkinson','Gary Graham','Grant Imahara','Bruce A. Young','Richard Herd','Vic Mignogna','Jim Roof','Manu Intiraymi','Jason Matthew Smith','Jessica Uberuaga','Rico E. Anderson','Clint Carmichael','Chasty Ballesteros','Madison Russ'],
screenplay:['Ethan H. Calk','Jack Treviño'],
production:['Frank Zanca'],
music:['Justin R. Durban'],
cut:['Marc Linn'],
costumes:['Deborah Hartwell']},
{title:'Star Trek II: The Wrath of Khan',
titleCZ:'Star Trek II: Khanův hněv',
year:1982,
runtime:108,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action','Thriller'],
director:['Nicholas Meyer'],
actors:['William Shatner','Leonard Nimoy','DeForest Kelley','James Doohan','Walter Koenig','George Takei','Nichelle Nichols','Ricardo Montalban','Bibi Besch','Paul Winfield','Kirstie Alley','John Winston','Ike Eisenmann','Nicholas Guest','Kevin Rodney Sullivan','Laura Banks','James Horner','Brett Baxter Clark','Judson Scott','Paul Kent','Joel Marston','Merritt Butrick','John Vargas','David Ruprecht','Cristian Letelier','Eddy Donno','Tom Morga'],
screenplay:['Jack B. Sowards','Nicholas Meyer'],
production:['Robert Sallin'],
music:['James Horner'],
camera:['Gayne Rescher'],
cut:['William Paul Dornisch'],
scenography:['Joseph R. Jennings','Charles Graffeo'],
masks:['James Lee McCoy','Werner Keppler'],
costumes:['Robert Fletcher']},
{title:'Star Trek III: The Search for Spock',
titleCZ:'Star Trek III: Pátrání po Spockovi',
year:1984,
runtime:105,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action'],
director:['Leonard Nimoy'],
actors:['William Shatner','Leonard Nimoy','DeForest Kelley','James Doohan','George Takei','Walter Koenig','Nichelle Nichols','Judith Anderson','Christopher Lloyd','Robert Hooks','Phil Morris','Scott McGinnis','Paul Sorensen','Branscombe Richmond','John Larroquette','Allan Miller','James Sikking','Miguel Ferrer','Grace Lee Whitney','Frank Welker','Charles Correll','Robin Curtis','Stephen Manley','Eric Mansker','Mark Lenard','Carl Steven','Merritt Butrick','Harve Bennett','Phillip R. Allen','Conroy Gedeon','Jeanne Mori','Cathie Shirriff','Tom Morga'],
screenplay:['Harve Bennett'],
production:['Harve Bennett'],
music:['James Horner'],
camera:['Charles Correll'],
cut:['Robert F. Shugrue'],
scenography:['Tom Pedigo','John E. Chilberg II'],
masks:['James Lee McCoy','Wes Dawn','Steve La Porte','Jim Kail','Steve La Porte'],
costumes:['Robert Fletcher']},
{title:'Star Trek IV: The Voyage Home',
titleCZ:'Star Trek IV: Cesta domů',
year:1986,
runtime:119,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action'],
director:['Leonard Nimoy'],
actors:['William Shatner','Leonard Nimoy','DeForest Kelley','James Doohan','George Takei','Walter Koenig','Nichelle Nichols','Jane Wyatt','Catherine Hicks','Robert Ellenstein','John Schuck','Brock Peters','Michael Berryman','Grace Lee Whitney','Madge Sinclair','Vijay Amritraj','Majel Barrett','Tony Edwards','Kirk R. Thatcher','Joe Lando','Robin Curtis','Jane Wiedlin','Alex Henteloff','Melanie Shatner','Mark Lenard','Phil Rubenstein','Eve Smith','Jeff Lester','Nick Ramus','John Miranda'],
screenplay:['Nicholas Meyer','Steve Meerson','Peter Krikes','Harve Bennett'],
production:['Harve Bennett'],
music:['Leonard Rosenman'],
camera:['Donald Peterman'],
cut:['Peter E. Berger'],
scenography:['Jack T. Collis','John M. Dwyer'],
masks:['James Lee McCoy','Wes Dawn','Jeff Dawn'],
costumes:['Robert Fletcher']},
{title:'Star Trek V: The Final Frontier',
titleCZ:'Star Trek V: Nejzazší hranice',
year:1989,
runtime:107,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action'],
director:['William Shatner'],
actors:['William Shatner','Leonard Nimoy','DeForest Kelley','James Doohan','Walter Koenig','Nichelle Nichols','George Takei','David Warner','Laurence Luckinbill','Charles Cooper','Steve Susskind','George Murdock','Bill Quinn','Rex Holman','Melanie Shatner','Harve Bennett','Carey Scott','Mike Smithson','Conrad Hurtt'],
screenplay:['David Loughery'],
production:['Harve Bennett'],
music:['Jerry Goldsmith'],
camera:['Andrew Laszlo'],
cut:['Peter E. Berger'],
sound:['Doug Hemphill','Gary Alexander'],
scenography:['Herman F. Zimmerman','John M. Dwyer'],
masks:['Edouard F. Henriques','Wes Dawn','Jeff Dawn','Kenny Myers','Michael Mills','Allan A. Apone','Erin Koplow','Tina Hoffman'],
costumes:['Nilo Rodis-Jamero']},
{title:'Star Trek VI: The Undiscovered Country',
titleCZ:'Star Trek VI: Neobjevená země',
year:1991,
runtime:105,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action','Mystery'],
director:['Nicholas Meyer'],
actors:['William Shatner','Leonard Nimoy','DeForest Kelley','James Doohan','Walter Koenig','Nichelle Nichols','George Takei','Kim Cattrall','Christopher Plummer','Rosanna DeSoto','Brock Peters','Kurtwood Smith','David Warner','Iman','Michael Dorn','Grace Lee Whitney','Christian Slater','Matthias Hues','René Auberjonois','Leon Russom','John Schuck','Angelo Tiffe','Michael Bofshever','William Morgan Sheppard','John Beck','Edward Clements','Robert Easton','John Bloom','Robert Cohen','BJ Davis','Darryl Henriques','Paul Rossilli','Jeremy Roberts','Mark Lenard','Barron Christian','Jim Boeke','Boris Lee Krutonog','Clifford Shegog','Brett Porter','Tom Morga'],
screenplay:['Nicholas Meyer','Denny Martin Flinn'],
production:['Steven-Charles Jaffe','Ralph Winter'],
music:['Cliff Eidelman'],
camera:['Hiro Narita'],
cut:['William Hoy','Ronald Roose'],
sound:['Greg P. Russell'],
scenography:['Herman F. Zimmerman','Mickey S. Michaels'],
masks:['Kenny Myers','Michael Mills','Edward French','Gerald Quist','Ron Walters','Greg Cannom','Art Harding','Tina Hoffman','R. Christopher Biggs'],
costumes:['Dodie Shepard']},
{title:'Star Trek VII: Generations',
titleCZ:'Star Trek VII: Generace',
year:1994,
runtime:113,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action'],
director:['David Carson'],
actors:['Patrick Stewart','Jonathan Frakes','Brent Spiner','LeVar Burton','Michael Dorn','Gates McFadden','Marina Sirtis','Malcolm McDowell','James Doohan','Walter Koenig','William Shatner','Alan Ruck','Jacqueline Kim','Jenette Goldstein','Thomas Kopache','Glenn Morshower','Tim Russ','Tommy Hinkley','John Putch','Majel Barrett','Gwynyth Walsh','Rif Hutton','Brian Thompson','Christopher James Miller','Thomas Dekker','Whoopi Goldberg','Dendrie Taylor','Patti Yasutake','Barbara March','Kim Braden','Kristopher Logan','Gwen Van Dam','Marcy Goldman','Henry Marshall','Granville Ames','D. Danny Warhol','Cameron','Olivia Hack','Lorine Mendell'],
screenplay:['Ronald D. Moore','Brannon Braga'],
production:['Rick Berman'],
music:['Dennis McCarthy'],
camera:['John A. Alonzo'],
cut:['Peter E. Berger'],
sound:['Adam Jenkins'],
scenography:['Herman F. Zimmerman','John M. Dwyer'],
masks:['Michael Westmore','Carolyn Elias','Tina Hoffman'],
costumes:['Robert Blackman']},
{title:'Star Trek IX: Insurrection',
titleCZ:'Star Trek IX: Vzpoura',
year:1998,
runtime:103,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action','Thriller'],
director:['Jonathan Frakes'],
actors:['Patrick Stewart','Jonathan Frakes','Brent Spiner','LeVar Burton','Michael Dorn','Gates McFadden','Marina Sirtis','F. Murray Abraham','Donna Murphy','Anthony Zerbe','Gregg Henry','Daniel Hugh Kelly','Michael Welch','Mark Deakins','Stephanie Niznik','Michael Horton','Rick Worthy','Jennifer Tung','Raye Birk','Max Grodénchik','Tom Morello','Armin Shimerman','Joseph Ruskin','Claudette Nevins','Bruce French','Lorella Cuccarini','Michael Braveheart','Phillip Glasser','Michael McAdam','McKenzie Westmore','Peggy Miley','John Hostetter','Marti Matulis','Larry Anderson','D. Elliot Woods'],
screenplay:['Michael Piller'],
production:['Rick Berman'],
music:['Jerry Goldsmith'],
camera:['Matthew F. Leonetti'],
cut:['Peter E. Berger'],
scenography:['Herman F. Zimmerman','John M. Dwyer'],
masks:['Monty Westmore','Yolanda Toussieng','Michael Westmore','Scott Wheeler','Alicia M. Tripi','Mark Bussan','Tina Hoffman','Ani Plotkin-Maloney','Geneva Nash Morgan'],
costumes:['Sanja Milkovic Hays']},
{title:'Star Trek X: Nemesis',
titleCZ:'Star Trek X: Nemesis',
year:2002,
runtime:112,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action','Thriller'],
director:['Stuart Baird'],
actors:['Patrick Stewart','Jonathan Frakes','Brent Spiner','LeVar Burton','Michael Dorn','Gates McFadden','Marina Sirtis','Ron Perlman','Tom Hardy','Dina Meyer','Jude Ciccolella','Kate Mulgrew','Shannon Cochran','Alan Dale','Wil Wheaton','Majel Barrett','Bryan Singer','Stuart Baird','Whoopi Goldberg','Marti Matulis','Greg Bronson','Tom Morga'],
screenplay:['John Logan'],
production:['Rick Berman'],
music:['Jerry Goldsmith'],
camera:['Jeffrey L. Kimball'],
cut:['Dallas Puett'],
sound:['Alan Robert Murray','Frank A. Montaño'],
scenography:['Herman F. Zimmerman','John M. Dwyer','Ronald R. Reiss'],
masks:['Judy Crown','Michael Mills','Michael Westmore','Allan A. Apone','Chris McBee','Linda Trainoff','Robert Maverick','Tina Hoffman'],
costumes:['Bob Ringwood']},
{title:'Star trek: prelude to axanar',
titleCZ:'Star Trek: Prelude to Axanar',
year:2014,
runtime:21,
countries:['USA'],
genres:['Short','Sci-Fi'],
director:['Christian Gossett'],
actors:['Tony Todd','Kate Vernon','Richard Hatch','Gary Graham','J.G. Hertzler','Alec Peters'],
screenplay:['Christian Gossett','Alec Peters'],
masks:['Kevin Haney','Allan A. Apone'],
costumes:['William Ware Theiss']},
{title:'Madame Web',
titleCZ:'Madam Web',
year:2024,
runtime:116,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['S.J. Clarkson'],
actors:['Dakota Johnson','Sydney Sweeney',"Celeste O'Connor",'Isabela Merced','Tahar Rahim','Emma Roberts','Mike Epps','Adam Scott','Kerry Bishé','Zosia Mamet','José María Yazpik','Kathy-Ann Hart','Josh Drennen','Naheem Garcia','Jill Hennessy','Michael Malvesti','Rena Maliszewski','Mike Bash'],
screenplay:['Matt Sazama','Burk Sharpless','Claire Parker','S.J. Clarkson'],
production:['Lorenzo di Bonaventura'],
music:['Johan Söderqvist'],
camera:['Mauro Fiore'],
cut:['Leigh Folsom Boyd'],
sound:["Kevin O'Connell",'Paul N.J. Ottosson'],
scenography:['Ethan Tobman','Mila Khalevich'],
costumes:['Ngila Dickson']},
{title:'Deadpool & Wolverine',
titleCZ:'Deadpool & Wolverine',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Action','Comedy','Sci-Fi'],
director:['Shawn Levy'],
actors:['Ryan Reynolds','Hugh Jackman','Leslie Uggams','Morena Baccarin','Matthew Macfadyen','Brianna Hildebrand','Karan Soni','Emma Corrin','Šiori Kucuna','Rob Delaney','Stefan Kapičič'],
basedOn:['Rob Liefeld','Fabian Nicieza'],
screenplay:['Wendy Molyneux','Lizzie Molyneux-Logelin','Rhett Reese','Paul Wernick'],
production:['Simon Kinberg'],
sound:['Mark P. Stoeckinger']},
{title:'Ghostbusters',
titleCZ:'Krotitelé duchů',
year:2016,
runtime:'Televizní verze: 110 min',
countries:['USA','Australia'],
genres:['Fantasy','Sci-Fi','Action','Comedy'],
director:['Paul Feig'],
actors:['Melissa McCarthy','Kristen Wiig','Kate McKinnon','Leslie Jones','Chris Hemsworth','Cecily Strong','Andy Garcia','Michael Kenneth Williams','Charles Dance','Ed Begley Jr.','Matt Walsh','Annie Potts','Elizabeth Perkins','Toby Huss','Nate Corddry','Karan Soni','Mark Falvo','Sparrowhawk','Nick Norrman','Brian Baumgartner','Susan Park','Eugene Cordero','Bill Murray','Dan Aykroyd','Ernie Hudson','Sigourney Weaver','Jaime Pacheco','Lexie Roth','Christopher Michael Cagle','Adam Ray','Kevin J. James','Dan Teicher','Sigrid Lium','Tom Yi','Pat Kiernan','Chaunty Spillane','Stew Replogle','Matteo Borghese','Daniel Washington','Larry Eudene'],
screenplay:['Paul Feig','Katie Dippold'],
production:['Amy Pascal','Ivan Reitman'],
music:['Theodore Shapiro'],
camera:['Robert D. Yeoman'],
cut:['Brent White','Melissa Bretherton'],
sound:['Andrew DeCristofaro','Beau Borders','Mark Paterson'],
scenography:['Jefferson Sage'],
masks:['Nichole Pleau','Heba Thorisdottir','Mia Neal','Angela Marinis'],
costumes:['Jeffrey Kurland']},
{title:'Ghostbusters II',
titleCZ:'Krotitelé duchů II',
year:1989,
runtime:104,
countries:['USA'],
genres:['Sci-Fi','Fantasy','Comedy','Adventure'],
director:['Ivan Reitman'],
actors:['Bill Murray','Dan Aykroyd','Sigourney Weaver','Harold Ramis','Rick Moranis','Ernie Hudson','Annie Potts','Peter MacNicol','Harris Yulin','Kurt Fuller','Janet Margolin','Wilhelm von Homburg','Christopher Neame','Cheech Marin','Ben Stein','Kevin Dunn','Chloe Webb','Philip Baker Hall','Jason Reitman','Catherine Reitman','Tom Dugan','Mary Ellen Trainor','Aaron Lustig','Brian Doyle-Murray','Dave Florek','Richard Foronjy','David Margulies','Erik Holland','Michael P. Moran','Henry J. Deutschendorf II','Robert Alan Beuth','Douglas Seale','Louise Troy','George P. Wilbur','Mark Schneider','Page Leong','Ray Glanzmann','Bobby Brown'],
screenplay:['Harold Ramis','Dan Aykroyd'],
production:['Ivan Reitman'],
music:['Randy Edelman'],
camera:['Michael Chapman'],
cut:['Donn Cambern','Sheldon Kahn'],
sound:['Jim Fitzpatrick','Chris Carpenter','Gary C. Bourgeois','Fred Judkins'],
scenography:['Bo Welch'],
masks:['Gandhi Bob Arrollo','John M. Elliott','Jr.','Stephen Abrums'],
costumes:['Gloria Gresham']},
{title:'Ghostbusters: Afterlife',
titleCZ:'Krotitelé duchů: Odkaz',
year:2021,
runtime:124,
countries:['USA'],
genres:['Adventure','Sci-Fi','Fantasy','Comedy','Drama'],
director:['Jason Reitman'],
actors:['Mckenna Grace','Finn Wolfhard','Logan Kim',"Celeste O'Connor",'Carrie Coon','Paul Rudd','Bokeem Woodbine','Marlon Kazadi','Sydney Mae Diaz','Paulina Alexis','Hannah Duke','Danielle Kennedy','Shohreh Aghdashloo','Josh Gad','Bob Gunton','Oliver Cooper','Tracy Letts','Shelby Young','Annie Potts','Dan Aykroyd','Bill Murray','Ernie Hudson','Sigourney Weaver','Olivia Wilde','J.K. Simmons','Billy Bryk'],
screenplay:['Jason Reitman','Gil Kenan'],
production:['Ivan Reitman'],
music:['Rob Simonsen'],
camera:['Eric Steelberg'],
cut:['Dana E. Glauberman','Nathan Orloff'],
sound:['Mark Paterson','Will Files'],
scenography:['François Audouy','Connery Davoodian','Scott Meehan','Bill Ives','Anthony D. Parrillo'],
masks:['Patrick Baxter','Arjen Tuiten','Pamela Goldammer'],
costumes:['Danny Glicker']},
{title:'The Equalizer',
titleCZ:'Equalizer',
year:2014,
runtime:132,
countries:['USA'],
genres:['Thriller','Action','Crime'],
director:['Antoine Fuqua'],
actors:['Denzel Washington','Marton Csokas','Chloë Grace Moretz','David Harbour','Haley Bennett','Bill Pullman','Melissa Leo','David Meunier','Alex Veadov','Vladimír Kulich','E. Roger Mitchell','Johnny Messner','Robert Wahlberg','Allen Maldonado','Owen Burke','Dan Bilzerian','Tait Fletcher','Alex Ziwak','Che Landon','Chanty Sok','Matt Leonard','Nash Edgerton','Ryan Eatherton','James Wilcox',"Billy 'V' Vigeant",'Austin J. Ryan'],
screenplay:['Richard Wenk'],
production:['Todd Black','Jason Blumenthal','Denzel Washington','Alex Siskin','Steve Tisch','Mace Neufeld','Tony Eldridge','Michael Sloan'],
music:['Harry Gregson-Williams'],
camera:['Mauro Fiore'],
cut:['John Refoua'],
sound:['Steve Pederson','Oleg Kulchytskyi','Mandell Winter','Daniel J. Leahy'],
scenography:['Naomi Shohan'],
masks:['Carl Fullerton','Larry M. Cherry','Howard Berger','Greg Funk'],
costumes:['David C. Robinson']},
{title:'The Equalizer 2',
titleCZ:'Equalizer 2',
year:2018,
runtime:121,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Antoine Fuqua'],
actors:['Denzel Washington','Pedro Pascal','Ashton Sanders','Orson Bean','Bill Pullman','Melissa Leo','Jonathan Scarfe','Sakina Jaffrey','Lexie Roth','Andrei Arlovski',"Patty O'Neil",'Dj Nino Carta','Manny Famolare','Rhys Olivia Cote','Donald Cerrone','Alican Barlas','Caroline Day','Antoine de Lartigue','Tim Misuradze','Naheem Garcia'],
screenplay:['Richard Wenk'],
production:['Todd Black','Jason Blumenthal','Denzel Washington','Antoine Fuqua','Alex Siskin','Steve Tisch','Mace Neufeld','Tony Eldridge','Michael Sloan'],
music:['Harry Gregson-Williams'],
camera:['Oliver Wood'],
cut:['Conrad Buff IV'],
sound:['Steve Pederson','Mandell Winter','Daniel J. Leahy'],
scenography:['Naomi Shohan','David Schlesinger'],
masks:['Carl Fullerton','Larry M. Cherry'],
costumes:['Jenny Gering']},
{title:'The Equalizer 3',
titleCZ:'Equalizer 3: Poslední kapitola',
year:2023,
runtime:110,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Antoine Fuqua'],
actors:['Denzel Washington','Dakota Fanning','Gaia Scodellaro','Bruno Bilotta','David Denman','Eugenio Mastrandrea','Melissa Leo','Sonia Ammar','Remo Girone','Andrea Scarduzio','Daniele Perrone','Andrea Dodero','Zakaria Hamza','Niccolò Senni','Alessandro Pess','Adolfo Margiotta','Valerio Da Silva','Giampiero Rotoli','Isabella Delle Monache','Salvatore Ruocco','Giovanni Trombetta','Massi Furlan','Giuseppe Russo','Giovanni Scotti','Marta Zoffoli','Marco Giuliani','Simona Distefano','Mauro Cremonini','Arcangelo Iannace','Beatrice Aiello','Mariarosaria Mingione','Diego Riace','Lucia Zotti'],
screenplay:['Richard Wenk'],
production:['Todd Black','Jason Blumenthal','Tony Eldridge','Antoine Fuqua','Alex Siskin','Michael Sloan','Steve Tisch','Clayton Townsend','Denzel Washington'],
music:['Marcelo Zarvos'],
camera:['Robert Richardson'],
cut:['Conrad Buff IV'],
scenography:['Naomi Shohan'],
masks:['Maurizio Nardi','Domingo Santoro','Federico Meniconi'],
costumes:['Giovanni Casalnuovo']},
{title:'The Hobbit: An Unexpected Journey',
titleCZ:'Hobit: Neočekávaná cesta',
year:2012,
runtime:169,
countries:['USA','New Zealand'],
genres:['Adventure','Fantasy'],
director:['Peter Jackson'],
actors:['Martin Freeman','Ian McKellen','Richard Armitage','Ken Stott','Graham McTavish','William Kircher','James Nesbitt','Stephen Hunter',"Dean O'Gorman",'Aidan Turner','John Callen','Peter Hambleton','Jed Brophy','Mark Hadlow','Adam Brown','Ian Holm','Elijah Wood','Hugo Weaving','Cate Blanchett','Christopher Lee','Andy Serkis','Sylvester McCoy','Jeffrey Thomas','Lee Pace','Conan Stevens','Manu Bennett','Benedict Cumberbatch','Renee Cataldo','Tim McLachlan','Dan Hennah','Terry Notary','Peter Jackson','Ruby Ashbourne Serkis','Bret McKenzie','Simon Vincent','Mary Nesbitt','Peggy Nesbitt','Jono Kenyon','Thomas Robins','Jarred Blakiston','John Rawls','Stephen Ure'],
basedOn:['J.R.R. Tolkien'],
screenplay:['Fran Walsh','Philippa Boyens','Peter Jackson','Guillermo del Toro'],
production:['Peter Jackson','Fran Walsh','Carolynne Cunningham','Zane Weiner'],
music:['Howard Shore'],
camera:['Andrew Lesnie'],
cut:['Jabez Olssen'],
sound:['Gary Summers','Michael Semanick','Christopher Boyes','Michael Hedges','Tony Johnson','Dave Whitehead'],
scenography:['Dan Hennah','Ben Milsom','Andy McLaren','Simon Bright','Simon Bright'],
masks:["Peter 'Swords' King",'Sarah Rubano','Rick Findlater','Tami Lane','Paul Katte'],
costumes:['Bob Buck','Ann Maskrey','Richard Taylor']},
{title:'The Hobbit: The Battle of the Five Armies',
titleCZ:'Hobit: Bitva pěti armád',
year:2014,
runtime:144,
countries:['USA','New Zealand'],
genres:['Adventure','Fantasy'],
director:['Peter Jackson'],
actors:['Martin Freeman','Ian McKellen','Richard Armitage','Luke Evans','Evangeline Lilly','Orlando Bloom','Hugo Weaving','Cate Blanchett','Christopher Lee','Benedict Cumberbatch','Lee Pace','Manu Bennett','Billy Connolly','Aidan Turner','Ian Holm','Mikael Persbrandt','James Nesbitt','Bret McKenzie','Graham McTavish','Stephen Fry','Sylvester McCoy',"Dean O'Gorman",'Ken Stott','William Kircher','Jed Brophy','Mark Hadlow','Adam Brown','John Callen','Peter Hambleton','Stephen Hunter','John Bell','Ryan Gage','Lawrence Makoare','Debra Wilson','Chris Reilly','Thomasin McKenzie','Miranda Harcourt','Conan Stevens','Peter Jackson','Billy Boyd','Dominic Monaghan','Ruby Ashbourne Serkis','Mary Nesbitt','Peggy Nesbitt','Eric Saindon','Jon Olson','John Tui'],
basedOn:['J.R.R. Tolkien'],
screenplay:['Fran Walsh','Philippa Boyens','Peter Jackson','Guillermo del Toro'],
production:['Peter Jackson','Fran Walsh','Carolynne Cunningham','Zane Weiner'],
music:['Howard Shore'],
camera:['Andrew Lesnie'],
cut:['Jabez Olssen'],
sound:['Gary Summers','Michael Semanick','Christopher Boyes','Michael Hedges','Tony Johnson','Dave Whitehead'],
scenography:['Dan Hennah','Ben Milsom','Andy McLaren','Simon Bright','Simon Bright'],
masks:["Peter 'Swords' King",'Rick Findlater','Tami Lane','Barbara Broucke','Jaime Leigh McIntosh'],
costumes:['Bob Buck','Ann Maskrey','Richard Taylor']},
{title:'The Hobbit: The Desolation of Smaug',
titleCZ:'Hobit: Šmakova dračí poušť',
year:2013,
runtime:161,
countries:['USA','New Zealand'],
genres:['Adventure','Fantasy'],
director:['Peter Jackson'],
actors:['Martin Freeman','Ian McKellen','Benedict Cumberbatch','Luke Evans','Orlando Bloom','Evangeline Lilly','Richard Armitage','Graham McTavish','James Nesbitt','Ken Stott','John Callen','Cate Blanchett','Manu Bennett','Lee Pace','Aidan Turner','Stephen Fry','William Kircher',"Dean O'Gorman",'Mark Hadlow','Jeffrey Thomas','Stephen Hunter','Peter Hambleton','Kiran Shah','Adam Brown','Jed Brophy','Sylvester McCoy','Peter Jackson','John Bell','Ryan Gage','Mikael Persbrandt','Lawrence Makoare','Stephen Colbert','Jabez Olssen','Eli Kent','Terry Notary','Zane Weiner','Peter Colbert','Mary Nesbitt','Peggy Nesbitt','Stephen Ure'],
basedOn:['J.R.R. Tolkien'],
screenplay:['Fran Walsh','Philippa Boyens','Peter Jackson','Guillermo del Toro'],
production:['Peter Jackson','Fran Walsh','Carolynne Cunningham','Zane Weiner'],
music:['Howard Shore'],
camera:['Andrew Lesnie'],
cut:['Jabez Olssen'],
sound:['Gary Summers','Michael Semanick','Christopher Boyes','Michael Hedges','Tony Johnson','Dave Whitehead'],
scenography:['Dan Hennah','Ben Milsom','Andy McLaren','Simon Bright','Simon Bright'],
masks:["Peter 'Swords' King",'Rick Findlater','Tami Lane','Jaime Leigh McIntosh'],
costumes:['Bob Buck','Ann Maskrey','Richard Taylor']},
{title:'Exorcist: The Beginning',
titleCZ:'Vymítač ďábla: Zrození',
year:2004,
runtime:114,
countries:['USA'],
genres:['Drama','Thriller','Horror','Mystery'],
director:['Renny Harlin'],
actors:['Stellan Skarsgård','Izabella Scorupco',"James D'Arcy",'Julian Wadham','Antonie Kamerling','David Bradley','Alan Ford','Ben Cross','Ralph Brown','Michel Leroy',"Patrick O'Kane",'Roberto Davide'],
screenplay:['Alexi Hawley'],
production:['James G. Robinson'],
music:['Trevor Rabin'],
camera:['Vittorio Storaro'],
cut:['Todd E. Miller','Mark Goldblatt'],
sound:['Wylie Stateman','Frank A. Montaño','Tim Webb'],
masks:['Fabrizio Sforza','Christopher Allen Nelson','Maria Federico','Raffaella Iorio'],
costumes:['Luke Reichle']},
{title:'Exorcist II: The Heretic',
titleCZ:'Vymítač ďábla 2: Kacíř',
year:1977,
runtime:118,
countries:['USA'],
genres:['Horror','Sci-Fi'],
director:['John Boorman'],
actors:['Linda Blair','Richard Burton','Louise Fletcher','Max von Sydow','Paul Henreid','James Earl Jones','Ned Beatty','Joey Lauren Adams','Kitty Winn','Richard Paul','Dana Plato','George Skaff','Belinda Beatty','Peter MacDonald','Hank Garrett','Ken Renard','Robert Lussier','Barbara Cason','Rose Portillo','Joey Green','Tiffany Kinney','Lorry Goldman','Shane Butterworth'],
screenplay:['John Boorman','William Goodhart'],
production:['John Boorman'],
music:['Ennio Morricone'],
camera:['William A. Fraker'],
cut:['Tom Priestley'],
sound:['Michael Minkler'],
scenography:['Richard Macdonald'],
masks:['Gary Liddiard','Dick Smith'],
costumes:['Robert De Mora']},
{title:'The Exorcist: Believer',
titleCZ:'Vymítač ďábla: Znamení víry',
year:2023,
runtime:111,
countries:['USA'],
genres:['Horror'],
director:['David Gordon Green'],
actors:['Leslie Odom Jr.','Ann Dowd','Jennifer Nettles','Lidya Jewett','Olivia Marcum','Ellen Burstyn','Raphael Sbarge','Linda Boston','E.J. Bonilla','Antoni Corone','Danny McCarthy','Norah Murphy','Okwui Okpokwasili','Linda Blair','Norbert Leo Butz'],
screenplay:['Peter Sattler','David Gordon Green'],
production:['Jason Blum','James G. Robinson','David Robinson'],
music:['Amman Abbasi','David Wingo'],
camera:['Michael Simmonds'],
cut:['Timothy Alverson'],
sound:['Ted Teske','Chris Chae'],
scenography:['Brandon Tonner-Connolly','Jess Royal'],
masks:['Christopher Allen Nelson','Kenny Niederbaumer'],
costumes:['Lizz Wolf']},
{title:"The Pope's Exorcist",
titleCZ:'Papežův vymítač',
year:2023,
runtime:104,
countries:['USA'],
genres:['Horror','Thriller'],
director:['Julius Avery'],
actors:['Russell Crowe','Daniel Zovatto','Franco Nero','Alex Essoe','Peter DeSouza-Feighoney','Laurel Marsden','Paloma Bloyd','Cornell John','Tom Bonington','Alessandro Gruttadauria','Ralph Ineson','Pablo Raybould','Bianca Bardoe'],
screenplay:['Evan Spiliotopoulos','Chester Hastings','R. Dean McCreary'],
production:['Doug Belgrad','Michael Patrick Kaczmarek','Jeff Katz'],
music:['Jed Kurzel'],
camera:['Khalid Mohtaseb'],
cut:['Matt Evans'],
sound:['Beau Borders'],
scenography:['Alan Gilmore','Til Frohlich'],
masks:['Matthew Smith','Rubén Serra','Juan Olmo'],
costumes:['Lorna Marie Mugan']},
{title:'The Exorcist III',
titleCZ:'Vymítač ďábla III',
year:1990,
runtime:105,
countries:['USA'],
genres:['Horror','Drama','Thriller'],
director:['William Peter Blatty'],
actors:['George C. Scott','Ed Flanders','Brad Dourif','Jason Miller','Nicol Williamson','Scott Wilson','George DiCenzo','Don Gordon','Nancy Fish','Lee Richardson','Grand L. Bush','Viveca Lindfors','Ken Lerner','Zohra Lampert','Tyra Ferrell','Kevin Corrigan','Samuel L. Jackson','Colleen Dewhurst','Fabio','Jodi Long','Larry King','Danny Epper','Harry Carey Jr.','Mary Jackson','Barbara Baxley','Clifford David','Amelia Campbell','William Preston','Alex Zuckerman','Nina Hansen','Sherrie Wills','John Coe','David Dwyer','Patrick Ewing','Lois Foraker'],
basedOn:['William Peter Blatty'],
screenplay:['William Peter Blatty'],
production:['Carter DeHaven'],
music:['Barry De Vorzon'],
camera:['Gerry Fisher'],
cut:['Thom Noble','Peter Lee-Thompson','Todd C. Ramsay'],
sound:['Richard L. Anderson','Rick Alexander'],
scenography:['Leslie Dilley'],
masks:['Del Acevedo','Greg Cannom','Erin Koplow'],
costumes:['Dana Lyman']},
{title:'The Evil Dead',
titleCZ:'Lesní duch',
year:1981,
runtime:85,
countries:['USA'],
genres:['Horror','Thriller'],
director:['Sam Raimi'],
actors:['Bruce Campbell','Ellen Sandweiss','Richard DeManincor','Betsy Baker','Theresa Tilly','Ted Raimi','Scott Spiegel','Sam Raimi','Ivan Raimi','John Cameron','Cheryl Guttridge','Rob Tapert','Kurt Rauf','Bill Vincent','Tom Sullivan'],
screenplay:['Sam Raimi'],
production:['Rob Tapert'],
music:['Joseph LoDuca'],
camera:['Tim Philo'],
cut:['Edna Ruth Paul'],
sound:['Joe Masefield'],
scenography:['Tom Sullivan'],
masks:['Tom Sullivan']},
{title:'Mortal Engines',
titleCZ:'Smrtelné stroje',
year:2018,
runtime:128,
countries:['New Zealand','USA'],
genres:['Action','Adventure','Fantasy','Sci-Fi','Thriller'],
director:['Christian Rivers'],
actors:['Hera Hilmar','Hugo Weaving','Jihae','Robert Sheehan','Stephen Lang','Leila George','Frankie Adams','Caren Pistorius','Andrew Lees','Colin Salmon','Ronan Raftery','Joel Tobeck','Patrick Malahide','Nathaniel Lees','Yoson An','Regé-Jean Page','Mark Mitchinson','Mark Hadlow','Leifur Sigurdarson','Kahn West','Kee Chan','Madeleine Adams','Stephen Ure','Menik Gooneratne'],
basedOn:['Philip Reeve'],
screenplay:['Fran Walsh','Philippa Boyens','Peter Jackson'],
production:['Peter Jackson','Fran Walsh','Zane Weiner','Deborah Forte','Amanda Walker'],
music:['Junkie XL'],
camera:['Simon Raby'],
cut:['Jonathan Woodford-Robinson'],
sound:['Christopher Boyes','Michael Hedges','Dave Whitehead'],
scenography:['Dan Hennah','Shane Vieau','Helen Strevens','Simon Bright'],
masks:['Gino Acevedo','Sarah Rubano','Rick Findlater'],
costumes:['Bob Buck','Kate Hawley']},
{title:'Evil Dead II',
titleCZ:'Smrtelné zlo 2',
year:1987,
runtime:85,
countries:['USA'],
genres:['Horror','Comedy'],
director:['Sam Raimi'],
actors:['Bruce Campbell','Sarah Berry','Dan Hicks','Kassie Wesley DePaiva','Richard Domeier','Denise Bixler','Ted Raimi','Lou Hancock','John Peakes','Josh Becker','Scott Spiegel','Sam Raimi','John W. Walter','Rob Tapert','Tony Elwood','Tom Sullivan','Randy Brenner'],
screenplay:['Sam Raimi','Scott Spiegel'],
production:['Rob Tapert'],
music:['Joseph LoDuca'],
camera:['Peter Deming'],
cut:['Kaye Davis'],
sound:['David John West'],
masks:['Tom Sullivan']},
{title:'Evil Dead Rise',
titleCZ:'Smrtelné zlo: Probuzení',
year:2023,
runtime:97,
countries:['USA','Ireland','New Zealand'],
genres:['Horror','Thriller'],
director:['Lee Cronin'],
actors:['Alyssa Sutherland','Lily Sullivan','Morgan Davies','Gabrielle Echols','Nell Fisher','Billy Reynolds-McCarthy','Tai Wano','Mirabai Pease','Jayden Daniels','Richard Crouchley','Anna-Maree Thomas','Mark Mitchinson'],
screenplay:['Lee Cronin'],
production:['Rob Tapert'],
music:['Stephen McKeon'],
camera:['Dave Garbett'],
cut:['Bryan Shaw'],
scenography:['Gareth Edwards','Nick Bassett'],
masks:['Vanessa Hurley','Hannah Wilson','Mitzi Doney','Adam Johansen','Luke Polti'],
costumes:['Sarah Voon']},
{title:'Zlo mezi námi',
titleCZ:'Zlo mezi námi',
year:2003,
runtime:113,
countries:['Sweden'],
genres:['Drama'],
director:['Mikael Håfström'],
actors:['Andreas Wilson','Henrik Lundström','Gustaf Skarsgård','Linda Zilliacus','Jesper Salén','Filip Berg','Fredrik af Trampe','Richard Danielsson','Martin Svane','Rustan Blomqvist','Per Westergren','Henrik Linnros','Johan Rabaeus','Marie Richardson','Magnus Roosmann','Ulf Friberg','Mats Bergman','Kjell Bergqvist','Björn Granath','Christian Rinmad','Adam Pålsson','Peter Eggers','Sannamari Patjas','Lennart Hjulström','Nicklas Bengtsson','Victor Hallgren','Christina Rothlin Löfqvist','Jan Håfström','Joa Helgesson'],
basedOn:['Jan Guillou'],
screenplay:['Hans Gunnarsson','Mikael Håfström','Klas Östergren'],
production:['Ingemar Leijonborg','Hans Lönnerheden'],
music:['Francis Shaw'],
camera:['Peter Mokrosinski'],
cut:['Darek Hodor'],
sound:['Dan Widegren','Carl Aage Hansen'],
scenography:['Anna Asp'],
masks:['Karin Fahlén','Göran Lundström'],
costumes:['Kersti Vitali Rudolfsson']},
{title:'Resident Evil',
titleCZ:'Resident Evil',
year:2002,
runtime:100,
countries:['UK','Germany','France','USA'],
genres:['Action','Thriller','Horror','Sci-Fi'],
director:['Paul W.S. Anderson'],
actors:['Milla Jovovich','Michelle Rodriguez','Eric Mabius','James Purefoy','Martin Crewes','Colin Salmon','Anna Bolt','Heike Makatsch','Jaymes Butler','Jason Isaacs','Jamie Harding','Stephen Billington','Fiona Glascott','Joseph May','Liz May Brice','Jeremy Bolt','Torsten Jerabek','Indra Ové'],
screenplay:['Paul W.S. Anderson'],
production:['Paul W.S. Anderson','Bernd Eichinger','Jeremy Bolt','Samuel Hadida'],
music:['Marco Beltrami','Marilyn Manson'],
camera:['David Johnson'],
cut:['Alexander Berner'],
sound:['Roland Winke','Stefan Busch','Nico Krebs','Martin Steyer','Michael Kranz'],
scenography:['Richard Bridgland','Jörg Baumgarten'],
masks:['Hasso von Hugo','Duncan Jarman','Valeska Schitthelm','Friederike Rössler','Björn Rehbein','Barrie Gower','Tanja Drewitz'],
costumes:['Richard Bridgland']},
{title:'Resident Evil: The Final Chapter',
titleCZ:'Resident Evil: Poslední kapitola',
year:2016,
runtime:107,
countries:['Germany','Australia','Canada','France','UK','USA','South Africa','Japan'],
genres:['Action','Horror','Sci-Fi','Thriller'],
director:['Paul W.S. Anderson'],
actors:['Milla Jovovich','Iain Glen','Ali Larter','Shawn Roberts','Eoin Macken','Fraser James','Ruby Rose','William Levy','Rola','Joon-gi Lee','Ever Anderson','Aubrey Shelton','Kevin Otto','Lee Raviv','Colin Salmon','Martin Crewes','James Purefoy','Eric Mabius','Pasquale Aleardi','Stephen Billington','Anna Bolt','Joseph May','Heike Makatsch','Jaymes Butler','Liz May Brice','Oded Fehr','Jared Harris','Matthew G. Taylor','Tig Fong','Ashanti','Brian Steele','Linden Ashby','Carsten Nørgaard','Mika Nakašima','Boris Kodjoe','Johann Urb','Kevin Durand','Aryana Engineer','Bingbing Li','Alain Chanoine','Douglas Chapman','James Mark','Indra Ové'],
screenplay:['Paul W.S. Anderson'],
production:['Paul W.S. Anderson','Jeremy Bolt','Samuel Hadida','Robert Kulzer'],
music:['Paul Haslinger'],
camera:['Glen MacPherson'],
cut:['Doobie White'],
sound:['Andrew Stirk','Oleg Kulchytskyi','Andrew Tay'],
scenography:['Edward Thomas','Anneke Botha'],
masks:['Matthew W. Mungle'],
costumes:['Reza Levy']},
{title:'Resident Evil: Apocalypse',
titleCZ:'Resident Evil: Apokalypsa',
year:2004,
runtime:94,
countries:['UK','Germany','France','Canada','USA'],
genres:['Action','Thriller','Horror','Sci-Fi'],
director:['Alexander Witt'],
actors:['Milla Jovovich','Sienna Guillory','Oded Fehr','Thomas Kretschmann','Sophie Vavasseur','Razaaq Adoti','Jared Harris','Mike Epps','Sandrine Holt','Zack Ward','Iain Glen','Ricardo Betancourt','Aaron Abrams','Frank Chiesurin','Jim Codrington','Tom Gerhardt','Roman Podhora','Eric Mabius','Alexander Witt','Stephen R. Hart','Dean Copkov','Amber Marshall','Monique Ganderton','Brad Borbridge','Robert Hall','Natalie Charles','Matthew G. Taylor','Timothy Burd','Jeff White','Ted Ludzik','Michelle Latimer','Yaron Betan','Geoffrey Pounsett','John Migliore','Shaun Austin-Olsen','Richard Harte','Melanie Tonello','Dave Nichols'],
screenplay:['Paul W.S. Anderson'],
production:['Paul W.S. Anderson','Jeremy Bolt','Martin Moszkowicz','Don Carmody'],
music:['Jeff Danna'],
camera:['Christian Sebaldt','Derek Rogers'],
cut:['Eddie Hamilton'],
sound:['Todd Beckett','Craig Henighan'],
scenography:['Paul D. Austerberry','Steven Essam'],
masks:['Paul Jones','Sean Sansom','Vicki Syskakis'],
costumes:['Mary E. McLeod']},
{title:'Resident Evil: Welcome to Raccoon City',
titleCZ:'Resident Evil: Raccoon City',
year:2021,
runtime:107,
countries:['USA','Germany'],
genres:['Action','Horror','Sci-Fi'],
director:['Johannes Roberts'],
actors:['Kaya Scodelario','Hannah John-Kamen','Robbie Amell','Tom Hopper','Avan Jogia','Donal Logue','Neal McDonough','Lily Gao','Nathan Dales','Chad Rook','Marina Mazepa','Josh Cruddas','Janet Porter','Dylan Taylor','Avaah Blackwell','Holly de Barros','Stephannie Hawkins','Sammy Azero'],
screenplay:['Johannes Roberts'],
production:['Martin Moszkowicz','James Harris','Robert Kulzer','Hartley Gorenstein'],
music:['Mark Korven'],
camera:['Maxime Alexandre'],
cut:['Dev Singh'],
sound:['Bret Killoran','Andrew Tay'],
scenography:['Jennifer Spence'],
masks:['Paul Jones','Allan Cooke'],
costumes:['Jennifer Lantz']},
{title:'Resident Evil: Damnation',
titleCZ:'Resident Evil: Zatracení',
year:2012,
runtime:100,
countries:['Japan'],
genres:['Animation','Action','Horror','Sci-Fi'],
director:['Makoto Kamija'],
actors:['Jú Kobajaši','Džunko Minagawa','Nobujuki Hijama','Eriko Kawasaki','Šintaró Óhata','Kozue Harašima','Micuhiro Sakamaki','Hiro Nakadžima','Rjósuke Morita','Kóiči Sakaguči','Masakazu Kohara','Šózó Iizuka','Jú Sugimoto','Nobuaki Kanemicu','Júta Odagaki','Patrick Seitz','Dave Wittenberg'],
screenplay:['Šótaró Suga'],
music:['Rei Kondó'],
sound:['Takeši Takadera'],
scenography:['Acuši Doi']},
{title:'Resident Evil: Degeneration',
titleCZ:'Resident Evil: Rozklad',
year:2008,
runtime:96,
countries:['Japan'],
genres:['Animation','Action','Horror','Sci-Fi'],
director:['Makoto Kamija'],
actors:['Masaši Hirose','Masaši Ebara','Džin Jamanoi','Júko Kaida','Masanori Takeda','Rikija Kojama','Akiko Jadžima','Mabuki Andó','Džunko Midori','Daisuke Kirii','Hadžime Iidžima','Hiroši Širokuma','Kanako Tódžó','Kendži Nomura','Kensuke Sató','Masafumi Kimura','Mie Sonozaki','Rio Nacuki','Sajaka Kinošita','Takehiro Murozono','Taketora','Kandži Suzumori','Takeši Sasaki','Masajasu Nagata','Skip Stellrecht','Jukiko Mizuoči','Mary Elizabeth McGlynn','Dave Wittenberg'],
screenplay:['Šótaró Suga'],
music:['Tecuja Takahaši'],
sound:['Jóta Curuoka'],
scenography:['Acuši Doi']},
{title:'Resident Evil: Retribution',
titleCZ:'Resident Evil: Odveta',
year:2012,
runtime:92,
countries:['Germany','Canada','USA','France'],
genres:['Action','Thriller','Horror','Sci-Fi'],
director:['Paul W.S. Anderson'],
actors:['Milla Jovovich','Sienna Guillory','Michelle Rodriguez','Aryana Engineer','Bingbing Li','Boris Kodjoe','Johann Urb','Kevin Durand','Oded Fehr','Colin Salmon','Shawn Roberts','Mika Nakašima','Amanda Dyar','Megan Charpentier','Razaaq Adoti','Kim Coates','Martin Crewes','Iain Glen','Sandrine Holt','Thomas Kretschmann','Ali Larter','Spencer Locke','Eric Mabius','Wentworth Miller','James Purefoy','Norman Yeung','Anna Bolt','Heike Makatsch','Joseph May','Liz May Brice','Pasquale Aleardi','Robin Kasyanov','Indra Ové'],
screenplay:['Paul W.S. Anderson'],
production:['Paul W.S. Anderson','Jeremy Bolt','Samuel Hadida','Don Carmody','Robert Kulzer'],
music:['tomandandy'],
camera:['Glen MacPherson'],
cut:['Niven Howie'],
sound:['Andrew Stirk','Andrew Tay'],
scenography:['Kevin Phipps'],
masks:['Paul Jones','Jo-Ann MacNeil','Shane Zander','Trason Fernandes','Brian Hui','Vivian Orgill'],
costumes:['Wendy Partridge']},
{title:'Resident Evil: Vendetta',
titleCZ:'Resident Evil: Vendeta',
year:2017,
runtime:97,
countries:['Japan'],
genres:['Animation','Action','Horror'],
director:['Takanori Cudžimoto'],
actors:['Hiroki Tóči','Masaki Aizawa','Takuja Kirimoto','Haruka Tomacu','Rjúzaburó Ótomo','Hajato Fudžii','Tošijuki Morikawa','Sajaka Óhara','Ami Košimizu','Čikahiro Kobajaši','Meiko Kawasaki','Tecu Širatori','Ajaka Nanase','Ikudži Nose','Kósuke Gotó','Mariko Higašiuči','Motojuki Kawahara','Satoši Curuoka','Arnie Pantoja','Lex Lang','Mary Elizabeth McGlynn','Darin De Paul'],
screenplay:['Makoto Fukami'],
music:['Kendži Kawai']},
{title:'Resident Evil: Extinction',
titleCZ:'Resident Evil: Zánik',
year:2007,
runtime:95,
countries:['UK','France','Australia','Germany','USA'],
genres:['Action','Thriller','Horror','Sci-Fi'],
director:['Russell Mulcahy'],
actors:['Milla Jovovich','Oded Fehr','Ali Larter','Iain Glen','Ashanti','Christopher Egan','Spencer Locke','Matthew Marsden','Linden Ashby',"Jason O'Mara",'Mike Epps','Rick Cramer','Madeline Carroll',"Peter O'Meara",'Valorie Hubbard','Geoff Meed','Gary Hudson','Brian Steele','Kirk B.R. Woller','Joe Hursley','Ramón Franco','William Abadie','Shane Woodson','Rusty Joiner','James Tumminia','John Eric Bentley','César Ámigo Aguilar','Carsten Nørgaard'],
screenplay:['Paul W.S. Anderson'],
production:['Robert Kulzer','Paul W.S. Anderson','Bernd Eichinger','Jeremy Bolt','Samuel Hadida','Martin Moszkowicz'],
music:['Charlie Clouser'],
camera:['David Johnson'],
cut:['Niven Howie'],
sound:['Frank A. Montaño'],
scenography:['Eugenio Caballero','Barbara Enriquez'],
costumes:['Joseph A. Porro']},
{title:'Resident Evil: Afterlife',
titleCZ:'Resident Evil: Afterlife',
year:2010,
runtime:93,
countries:['Germany','France','USA','Canada'],
genres:['Action','Thriller','Horror','Sci-Fi'],
director:['Paul W.S. Anderson'],
actors:['Milla Jovovich','Boris Kodjoe','Ali Larter','Wentworth Miller','Sienna Guillory','Spencer Locke','Shawn Roberts','Kacey Clarke','Norman Yeung','Kim Coates','Sergio Peris-Mencheta','Mika Nakašima','Hiromi Okuyama'],
screenplay:['Paul W.S. Anderson'],
production:['Robert Kulzer','Paul W.S. Anderson','Bernd Eichinger','Jeremy Bolt','Samuel Hadida','Martin Moszkowicz','Don Carmody'],
music:['tomandandy'],
camera:['Glen MacPherson'],
cut:['Niven Howie'],
sound:['Andrew Stirk','Andrew Tay'],
scenography:['Arvinder Greywal',"Carolyn 'Cal' Loucks"],
masks:['Paul Jones','Jo-Ann MacNeil','Sean Sansom','Shane Zander','Patrick Baxter','Leslie Sebert','Carol Hartwick','Allan Cooke'],
costumes:['Denise Cronenberg','Azalia Snail']},
{title:'Spectre',
titleCZ:'Spectre',
year:2015,
runtime:148,
countries:['UK','USA'],
genres:['Action','Adventure','Crime','Thriller'],
director:['Sam Mendes'],
actors:['Daniel Craig','Christoph Waltz','Léa Seydoux','Ralph Fiennes','Monica Bellucci','Ben Whishaw','Naomie Harris','Dave Bautista','Andrew Scott','Rory Kinnear','Jesper Christensen','Stephanie Sigman','Tenoch Huerta','Adriana Paz','Domenico Fortunato','Ian Bonar','Pip Carter','Marc Zinga','Adel Bencherif','Peppe Lanzetta','Francesco Arca','Nigel Barber','Victor Schefé','Harald Windisch','Detlef Bothe','Wilhelm Iben','Francis Attakpah','Michael Glantschnig','Derek Horsham','Lasco Atkins','Judi Dench','Martyn Mayger','Clem So','Karol Steele','Miroslav Zaruba','Attila G. Kerekes','Michael Nicolae','Alessandro Bressanello','Noah Saavedra','Daniel Eghan','Marianna Dean','Alan Del Castillo','Chris Wilson','Junichi Kajioka','Lili Epply','Marlon Boess','Marie Fee Wohlmuth','Shaun Lucas','Alex Martin','Konstantin Gerlach','Gerardo Bosco','Marco Zingaro','Noemi Krausz','Oliver Cantú Lozano','Alessandro Cremona','Joseph Balderrama','Pete Meads','Daniel Stisen','Sargon Yelda','Fabio Colonna','Matteo Taranto','Gloria Garcia','Eiji Mihara','Gregg Wilson','George Lasha','Gido Schimanski'],
screenplay:['John Logan','Neal Purvis','Robert Wade','Jez Butterworth'],
production:['Barbara Broccoli','Michael G. Wilson'],
music:['Thomas Newman'],
camera:['Hoyte van Hoytema'],
cut:['Lee Smith'],
sound:['Gregg Rudloff','Oleg Kulchytskyi','Scott Millan'],
scenography:['Dennis Gassner','Mark Harris','Anna Pinnock'],
masks:['Naomi Donne','Donald Mowat','Mark Coulier','Leigh Cranston','Araceli Rios','Matteo Silvi','Zoe Tahir','Norma Webb','Doone Forsyth','Josh Weston'],
costumes:['Jany Temime']},
{title:'Quantum of Solace',
titleCZ:'Quantum of Solace',
year:2008,
runtime:106,
countries:['UK','USA'],
genres:['Action','Adventure','Crime','Thriller'],
director:['Marc Forster'],
actors:['Daniel Craig','Olga Kurylenko','Mathieu Amalric','Judi Dench','Giancarlo Giannini','Gemma Arterton','Jeffrey Wright','David Harbour','Jesper Christensen','Anatole Taubman','Rory Kinnear','Tim Pigott-Smith','Joaquín Cosio','Fernando Guillén Cuervo','Jesús Ochoa','Simon Kassianides','Stana Katic','Neil Jackson','Oona Chaplin','Rachel McDowall','Mark Wakeling','Guillermo del Toro','Alfonso Cuarón','Lucrezia Lante della Rovere','Sarah Hadland','Luis Antonio Gotti','Carl von Malaisé','Antonio Gil','Paul Ritter','Michael G. Wilson','Klemens Niklaus Trenkle','Uygar Tamer','Kamil Krejčí','Karin Lanz','Alexandra Prusa','Paul Simonon','Rufus Wright','Herbert Forthuber','Laila Alina Reischer','Elizabeth Arciniega','Jake Seal','Dale Albright','Sebastien Soules','Norman Campbell Rees'],
screenplay:['Neal Purvis','Robert Wade','Paul Haggis'],
production:['Barbara Broccoli','Michael G. Wilson'],
music:['David Arnold'],
camera:['Roberto Schaefer'],
cut:['Matt Chessé','Richard Pearson'],
sound:['Eddy Joseph','Michael Prestwood Smith','Mark Taylor'],
scenography:['Dennis Gassner','Paul Inglis','Mark Harris','Anna Pinnock'],
masks:['Naomi Donne','David White','Zoe Tahir','Linda DeVetta'],
costumes:['Louise Frogley']},
{title:'No Time to Die',
titleCZ:'Není čas zemřít',
year:2021,
runtime:163,
countries:['UK','USA'],
genres:['Action','Adventure','Crime','Thriller'],
director:['Cary Joji Fukunaga'],
actors:['Daniel Craig','Léa Seydoux','Rami Malek','Lashana Lynch','Ralph Fiennes','Ben Whishaw','Ana de Armas','Naomie Harris','David Dencik','Rory Kinnear','Jeffrey Wright','Billy Magnussen','Christoph Waltz','Dali Benssalah','Lisa-Dorah Sonnet','Coline Defaud','Hugh Dennis','Priyanga Burford','Joe Grossi','Pio Amato','Javone Prince','Amy Morgan','Lourdes Faberes','Philip Philmar','Eliot Sumner','Douglas Bunn','Gordon Alexander','Clem So'],
screenplay:['Neal Purvis','Robert Wade','Cary Joji Fukunaga','Phoebe Waller-Bridge'],
production:['Michael G. Wilson','Barbara Broccoli'],
music:['Hans Zimmer'],
camera:['Linus Sandgren'],
cut:['Tom Cross','Elliot Graham'],
sound:['Paul Massey','Oliver Tarney','Mark Taylor','Simon Hayes','James Harrison','Bryan Bowen'],
scenography:['Mark Tildesley','Mark Harris','Véronique Melery','Sandra Phillips'],
masks:['Daniel Phillips','Duncan Jarman','Zoe Tahir','Barrie Gower'],
costumes:['Suttirat Anne Larlarb']},
{title:'GoldenEye',
titleCZ:'Zlaté oko',
year:1995,
runtime:130,
countries:['UK','USA'],
genres:['Action','Adventure','Crime','Thriller'],
director:['Martin Campbell'],
actors:['Pierce Brosnan','Sean Bean','Izabella Scorupco','Famke Janssen','Joe Don Baker','Judi Dench','Robbie Coltrane','Tchéky Karyo','Gottfried John','Alan Cumming','Desmond Llewelyn','Samantha Bond','Michael Kitchen','Serena Gordon','Simon Kunz','Pavel Douglas','Constantine Gregory','Minnie Driver','Michelle Arthur','Ravil Isjanov','Martin Campbell','Simon Crane','Max Faulkner','Wayne Michaels','Michael G. Wilson'],
screenplay:['Jeffrey Caine','Bruce Feirstein'],
production:['Michael G. Wilson','Barbara Broccoli'],
music:['Eric Serra'],
camera:['Phil Méheux'],
cut:['Terry Rawlings'],
sound:['David John','Jim Shields'],
scenography:['Peter Lamont','Neil Lamont','Michael Ford'],
masks:['Trefor Proud','Norma Webb','Linda DeVetta'],
costumes:['Lindy Hemming']},
{title:"On Her Majesty's Secret Service",
titleCZ:'Ve službách Jejího Veličenstva',
year:1969,
runtime:142,
countries:['UK'],
genres:['Action','Adventure','Thriller'],
director:['Peter R. Hunt'],
actors:['George Lazenby','Diana Rigg','Telly Savalas','Gabriele Ferzetti','Ilse Steppat','Lois Maxwell','George Baker','Bernard Lee','Desmond Llewelyn','Jurij Borienko','Virginia North','Sally Sheridan','Joanna Lumley','Jenny Hanley','Bessie Love','Peter R. Hunt','Anouska Hempel','Robert Rietty','Brian Grellis','Steve Plytas','Angela Scoular','Brian Worth','Julie Ege','Mona Chong','George Leech','Bernard Horsfall','Terence Mountain','Elliott Sullivan','Catherine Schell','Ingrid Back','James Bree','Takis Emmanuel','Zaheera','Helena Ronee','Sylvana Henriques','Irvin Allen','Geoffrey Cheshire'],
basedOn:['Ian Fleming'],
screenplay:['Richard Maibaum'],
production:['Albert R. Broccoli','Harry Saltzman'],
music:['John Barry'],
camera:['Michael Reed'],
cut:['John Glen'],
sound:['Otto Snel'],
scenography:['Syd Cain'],
masks:['Basil Newall','Paul Rabiger'],
costumes:['Marjory Cornelius']},
{title:'Dr. No',
titleCZ:'Dr. No',
year:1962,
runtime:110,
countries:['UK'],
genres:['Action','Adventure','Thriller'],
director:['Terence Young'],
actors:['Sean Connery','Ursula Andress','Joseph Wiseman','Jack Lord','Bernard Lee','Anthony Dawson','John Kitzmiller','Zena Marshall','Eunice Gayson','Lois Maxwell','Martine Beswick','Robert Rietty','Bob Simmons','Victor Harrington','Anthony Chinn','George Hilsdon','Milton Reid','Frank Singuineau','Bunny Seaman','Malou Pantera','Yvonne Shima','Michel Mok','Marguerite LeWars','Reggie Carter','Peter Burton','Jack Arrow','Nigel Bernard','Chris Blackwell','Diana Coupland','Eric Coverley','Reggie de Beer','Alicia Deane','Joe Enrikie','Charles Gilliard','John Hatton'],
basedOn:['Ian Fleming'],
screenplay:['Richard Maibaum','Johanna Harwood','Berkely Mather','Terence Young'],
production:['Albert R. Broccoli','Harry Saltzman'],
music:['Monty Norman'],
camera:['Ted Moore'],
cut:['Peter R. Hunt'],
sound:['John Dennis','Wally Milner'],
scenography:['Ken Adam','Syd Cain'],
masks:["John O'Gorman",'Eileen Warwick']},
{title:'Thunderball',
titleCZ:'Thunderball',
year:1965,
runtime:130,
countries:['UK','USA'],
genres:['Action','Adventure','Thriller'],
director:['Terence Young'],
actors:['Sean Connery','Claudine Auger','Adolfo Celi','Luciana Paluzzi','Rik Van Nutter','Guy Doleman','Martine Beswick','Molly Peters','Desmond Llewelyn','Lois Maxwell','Roland Culver','Kevin McClory','Bernard Lee','Anthony Dawson','Jiří Pravda','Suzy Kendall','Philip Stone','Albert Michel','Jack Gwillim','Reginald Beckwith','Earl Cameron','Edward Underdown','Robert Rietty','Mitsouko','Paul Stassino','Bob Simmons','Lloyd Reckord','Patrick Holt','Amelia Bayntun','Michael Culver','Eric Pohlmann','André Maranne','Leonard Sachs','Peter Roy','Pauline Chamberlain','Rose Alba','George Hilsdon','Harold Coyne','Michael Brennan','Gábor Baraker','Neil Hallett','George Leech','Philo Hauser','Murray Kash','Sheree Winton','Cecil Cheng','Neville Becker','Peter Burton'],
screenplay:['Jack Whittingham','Richard Maibaum','John Hopkins'],
production:['Albert R. Broccoli','Harry Saltzman'],
music:['John Barry'],
camera:['Ted Moore'],
cut:['Ernest Hosler'],
scenography:['Ken Adam'],
masks:['Basil Newall','Paul Rabiger']},
{title:'Octopussy',
titleCZ:'Chobotnička',
year:1983,
runtime:131,
countries:['UK','USA'],
genres:['Action','Adventure','Thriller'],
director:['John Glen'],
actors:['Roger Moore','Maud Adams','Louis Jourdan','Kristina Wayborn','Kabir Bedi','Steven Berkoff','David Meyer','Tony Meyer','Desmond Llewelyn','Robert Brown','Lois Maxwell','Walter Gotell','Vijay Amritraj','Albert Moses','Geoffrey Keen','Douglas Wilmer','Andy Bradford','Philip Voss','Bruce Boa','Richard LeParmentier','Paul Hardwick','Dermot Crowley','Jeremy Bulloch','Stuart Saunders','Patrick Barr','Gertan Klauber','Brenda Cowling','David Grahame','Brian Coburn','Mary Stavin','Eugene Lipinski','Nicola Stapleton','Michael G. Wilson','Julie Martin','Ishaq Bux','Fred Haggerty','William Derrick','Tina Hudson','Peter Edmund','Bunny Seaman','Peter Porteous','Carole Ashby'],
basedOn:['Ian Fleming'],
screenplay:['George MacDonald Fraser','Richard Maibaum','Michael G. Wilson'],
production:['Albert R. Broccoli'],
music:['John Barry'],
camera:['Alan Hume'],
cut:['Henry Richardson','Peter Davies'],
scenography:['Peter Lamont'],
masks:['Peter Robb-King','George Frost','Chris Taylor'],
costumes:['Emma Porteous']},
{title:'Diamonds Are Forever',
titleCZ:'Diamanty jsou věčné',
year:1971,
runtime:120,
countries:['UK'],
genres:['Action','Adventure','Thriller'],
director:['Guy Hamilton'],
actors:['Sean Connery','Jill St. John','Charles Gray','Lana Wood','Bruce Cabot','Jimmy Dean','Lois Maxwell','Norman Burton','Bruce Glover','Bernard Lee','Putter Smith','Desmond Llewelyn','Laurence Naismith','David Bauer','Joe Robinson','Ray Baker','Valerie Perrine','Sammy Davis Jr.','Sid Haig','Trina Parks','Marc Lawrence','Constantine Gregory','Shane Rimmer','Ed Bishop','Larry J. Blake','Ed Call','Henry Rowland','Dick Crockett','Reginald Tsiboe','Gary Dubin','David de Keyser','Karl Held','Joseph Fürst','Terence Mountain','Tom Steele','Burt Metcalfe','Clifford Earl','Owen Song','Brinsley Forde','David Healy','Frank Olegario','Leonard Barr','John Abineri','Bob Harks','Lola Larson','Jack Arrow','Sig Frohlich'],
basedOn:['Ian Fleming'],
screenplay:['Richard Maibaum','Tom Mankiewicz'],
production:['Albert R. Broccoli','Harry Saltzman'],
music:['John Barry'],
camera:['Ted Moore'],
cut:['Bert Bates','John W. Holmes'],
scenography:['Ken Adam'],
masks:['Allan Snyder','Basil Newall','Eileen Warwick']},
{title:'A View to a Kill',
titleCZ:'Vyhlídka na vraždu',
year:1985,
runtime:126,
countries:['UK','USA'],
genres:['Action','Adventure','Crime','Thriller'],
director:['John Glen'],
actors:['Roger Moore','Christopher Walken','Tanya Roberts','Grace Jones','Patrick Macnee','Patrick Bauchau','Desmond Llewelyn','Lois Maxwell','Walter Gotell','Geoffrey Keen','Daniel Benzali','Dolph Lundgren','Maud Adams','Alison Doody','Fiona Fullerton','Gérard Buhr','Jean Rougerie','Roland Malet','Michael G. Wilson','Bill Ackridge','Tobias Nath','Robert Brown','Mary Stavin','Deland Nuse','Manning Redwood','Bogdan Kominowski','Tony Sibbald','Joe Flood','Papillon Soo','Frank Jakeman','Carole Ashby','Tim Condren'],
basedOn:['Ian Fleming'],
screenplay:['Richard Maibaum','Michael G. Wilson'],
production:['Michael G. Wilson','Albert R. Broccoli'],
music:['John Barry'],
camera:['Alan Hume'],
cut:['Peter Davies'],
sound:['Nicolas Le Messurier'],
scenography:['Peter Lamont','Crispian Sallis'],
masks:['George Frost'],
costumes:['Emma Porteous']},
{title:'Moonraker',
titleCZ:'Moonraker',
year:1979,
runtime:126,
countries:['UK','France'],
genres:['Action','Adventure','Thriller','Sci-Fi'],
director:['Lewis Gilbert'],
actors:['Roger Moore','Lois Chiles','Michael Lonsdale','Richard Kiel','Corinne Cléry','Bernard Lee','Geoffrey Keen','Desmond Llewelyn','Lois Maxwell','Mike Marshall','Jean-Pierre Castaldi','Walter Gotell','Alfie Bass','Claude Carliez','Lewis Gilbert','Catherine Serre','Daniel Breton','Marc Mazza','Arthur Howard','Ken Adam','Anne Lonnberg','Jean Rupert','Georges Beller','Leila Shenna','Michael G. Wilson','Michel Berreur','Patrick Floersheim','David Gabison','Jacques Pisias','Benoît Ferreux','Guy Di Rigo','Dominique Hulin','Jean Tournier','Marc Smith','Albert R. Broccoli','Daniel Perche','Kim Fortune','Toshirô Suga','Chichinou Kaeppler','Béatrice Libert','Emily Bolton','Blanche Ravalec','Douglas Lambert','Jean-Louis Airola','Nicaise Jean-Louis','Rika Hofmann'],
basedOn:['Ian Fleming'],
screenplay:['Christopher Wood','Gerry Anderson'],
production:['Albert R. Broccoli','Gerry Anderson'],
music:['John Barry'],
camera:['Jean Tournier'],
cut:['John Glen'],
sound:['Nicolas Le Messurier'],
scenography:['Ken Adam'],
masks:['Paul Engelen','Pierre Vadé'],
costumes:['Jacques Fonteray']},
{title:'For Your Eyes Only',
titleCZ:'Jen pro tvé oči',
year:1981,
runtime:127,
countries:['UK'],
genres:['Action','Adventure','Thriller'],
director:['John Glen'],
actors:['Roger Moore','Carole Bouquet','Chaim Topol','Julian Glover','Lynn-Holly Johnson','Cassandra Harris','Jill Bennett','Michael Gothard','Jack Hedley','Lois Maxwell','Desmond Llewelyn','Geoffrey Keen','Walter Gotell','Charles Dance','Paul Brooke','Jeremy Bulloch','Greg Powell','John Hollis','James Villiers','Michael G. Wilson','Graham Crowden','Robert Rietty','Bob Simmons','George Sweeney','Peter Fontaine','Andy Bradford','John Wyman','Janet Brown','Jack Klaff','George Leech','Fred Haggerty','Toby Robins','Paul Angelis','Stefan Kalipha','Sheena Easton','John Moreno','Tony Alleff','Maureen Bennett','Tim Condren'],
basedOn:['Ian Fleming'],
screenplay:['Richard Maibaum','Michael G. Wilson'],
production:['Albert R. Broccoli'],
music:['Bill Conti'],
camera:['Alan Hume'],
cut:['John Grover'],
sound:['Nicolas Le Messurier'],
scenography:['Peter Lamont'],
masks:['George Frost']},
{title:'Die Another Day',
titleCZ:'Dnes neumírej',
year:2002,
runtime:132,
countries:['UK','USA'],
genres:['Action','Adventure','Crime','Thriller'],
director:['Lee Tamahori'],
actors:['Pierce Brosnan','Halle Berry','Toby Stephens','Rosamund Pike','Rick Yune','John Cleese','Judi Dench','Michael Madsen','Will Yun Lee','Kenneth Tsang','Emilio Echevarría','Lawrence Makoare','Colin Salmon','Samantha Bond','Rachel Grant','Simón Andreu','Deborah Moore','Madonna','Joaquín Martínez','Vincent Wong','Daryl Kwan','Michael G. Wilson','Alan Bond','Trevor White','Ian Pirie','Paul Darrow','Douglas Bunn','Mark Dymond','Stuart Ong'],
screenplay:['Neal Purvis','Robert Wade'],
production:['Barbara Broccoli','Michael G. Wilson'],
music:['David Arnold','Jake Jackson'],
camera:['David Tattersall'],
cut:['Christian Wagner','Andrew MacRitchie'],
sound:['Richard Pryke','Nicolas Le Messurier','Chris Munro'],
scenography:['Peter Lamont','Mark Harris'],
masks:['Paul Engelen','Lynda Armstrong'],
costumes:['Lindy Hemming']},
{title:'The Living Daylights',
titleCZ:'Dech života',
year:1987,
runtime:130,
countries:['UK','USA'],
genres:['Action','Adventure','Crime','Thriller','Romance'],
director:['John Glen'],
actors:['Timothy Dalton',"Maryam d'Abo",'Jeroen Krabbé','Joe Don Baker','John Rhys-Davies','Art Malik','Andreas Wisniewski','Desmond Llewelyn','Geoffrey Keen','Walter Gotell','Caroline Bliss','John Terry','Virginia Hey','John Bowe','Robert Miranda','Simon Crane','Nadim Sawalha','Julie T. Wallace','Hanno Pöschl','Barbara Broccoli','Michael G. Wilson','Mayte Sanchez','Robert Brown','Gertan Klauber','Graham Cole','Michael Percival','Carl Rigg','Del Baker','Anthony Carrick','Scott Hoxby','Heinz Winter','Belle Avery','Catherine Rabett','Marc Boyle','Leslie French','Waris Dirie','Peter Porteous','Thomas Wheatley','Kerry Shale'],
basedOn:['Ian Fleming'],
screenplay:['Richard Maibaum','Michael G. Wilson'],
production:['Michael G. Wilson','Albert R. Broccoli'],
music:['John Barry'],
camera:['Alec Mills'],
cut:['Peter Davies','John Grover'],
sound:['Nicolas Le Messurier'],
scenography:['Peter Lamont','Michael Ford'],
masks:['Naomi Donne','Edwin Erfmann','George Frost'],
costumes:['Emma Porteous']},
{title:'From Russia with Love',
titleCZ:'Srdečné pozdravy z Ruska',
year:1963,
runtime:115,
countries:['UK'],
genres:['Action','Adventure','Thriller'],
director:['Terence Young'],
actors:['Sean Connery','Daniela Bianchi','Pedro Armendáriz','Lotte Lenya','Robert Shaw','Bernard Lee','Eunice Gayson','Walter Gotell','Francis De Wolff','Lois Maxwell','Aliza Gur','Martine Beswick','Vladek Sheybal','Desmond Llewelyn','Barbara Jefford','Anthony Dawson','Terence Young','Peter Madden','Nadja Regin','Bob Simmons','Michael Culver','Victor Harrington','Eric Pohlmann','Aileen Lewis','Andre Charisse','Fred Wood','Ernie Rice','Alf Mangan','Dido Plumb','Bill Brandon','Hugo De Vernier','Fred Haggerty','George Pastell','Gordon Sterne',"Jim O'Brady",'Altan Günbay','Hasan Ceylan','Peter Bayliss','Nusret Ataer','Geraldine Moffat','Tex Fuller','Jan Williams','Peter Brayham'],
basedOn:['Ian Fleming'],
screenplay:['Richard Maibaum','Johanna Harwood','Berkely Mather'],
production:['Albert R. Broccoli','Harry Saltzman'],
music:['John Barry'],
camera:['Ted Moore'],
cut:['Peter R. Hunt'],
masks:['Basil Newall','Paul Rabiger'],
costumes:['Jocelyn Rickards']},
{title:'Never Say Never',
titleCZ:'Nikdy neříkej nikdy',
year:2023,
runtime:104,
countries:['Slovakia','Czechia'],
genres:['Comedy','Romance','Drama'],
director:['Braňo Mišík'],
actors:['Tereza Kostková','Tomáš Maštalír','Lenka Krobotová','Marek Majeský','Hana Holišová','Ondřej Sokol','Petr Vondráček','Pavla Tomicová','Jana Kovalčiková','Štefan Martinovič','Erika Stárková','Lucia Siposová','Zuzana Kanócz','Juraj Šoko Tabaček','Branislav Bystriansky','Juraj Hrčka','Daniel Fischer','Matej Landl','Marek Geišberg','Dominika Mirgová'],
screenplay:['Braňo Mišík'],
production:['Oľga Núñezová','Peter Núñez','Marianna Heinz'],
music:['Matúš Široký'],
camera:['Juraj Chlpík'],
cut:['Michal Kondrla'],
sound:['Alexander Bori','Ján Krnáč'],
scenography:['Juraj Kuchárek'],
masks:['Soňa Kubeníková'],
costumes:['Danica Raytchev']},
{title:'The James Bond Story',
titleCZ:'Příběh Jamese Bonda',
year:1999,
runtime:52,
countries:['USA'],
genres:['Documentary'],
director:['Chris Hunt'],
actors:['Sean Connery','Roger Moore','George Lazenby','Tom Mankiewicz','Pierce Brosnan','Terence Young','John Glen','Desmond Llewelyn','Jane Seymour','Maud Adams','Lewis Gilbert','Michael Apted','Timothy Dalton','Miranda Richardson','Famke Janssen','Telly Savalas','Robert Davi','Robert Carlyle','Diana Rigg','Michael Lonsdale','Claudine Auger','Barbara Bach','Lois Chiles','Gert Fröbe','Samantha Bond',"Maryam d'Abo",'Jill St. John','Honor Blackman','Michael G. Wilson','Milton Reid','Mariella Frostrup','Michael Collins']},
{title:'Tomorrow Never Dies',
titleCZ:'Zítřek nikdy neumírá',
year:1997,
runtime:119,
countries:['UK','USA'],
genres:['Action','Adventure','Crime','Thriller'],
director:['Roger Spottiswoode'],
actors:['Pierce Brosnan','Jonathan Pryce','Michelle Yeoh','Teri Hatcher','Ricky Jay','Götz Otto','Joe Don Baker','Vincent Schiavelli','Judi Dench','Desmond Llewelyn','Samantha Bond','Colin Salmon','Geoffrey Palmer','Julian Fellowes','Colin Stinton','Phillip Kwok','Christopher Bowen','Gerard Butler','Michael Byrne','Hugh Bonneville','Brendan Coyle','Rolf Saxon','Anthony Green','Eoin McCarthy','Julian Rhind-Tutt','Jason Watkins','Antje Schmidt','Ian Boo Khoo','Al Matthews','Nina Young','Kacee DeMasi','Terence Plummer','Michael G. Wilson','William Scott-Masson','Cho-kuen Chu','Terence Rigby','Terry Richards','Nichola McAuliffe','Bruce Alexander','Dinny Powell','Nadia Cameron-Blakey','Daphne Deckers','David Ashton'],
basedOn:['Ian Fleming'],
screenplay:['Bruce Feirstein'],
production:['Barbara Broccoli','Michael G. Wilson'],
music:['David Arnold'],
camera:['Robert Elswit'],
cut:['Michel Arcand','Dominique Fortin'],
sound:['Richard Pryke','Chris Munro'],
scenography:['Allan Cameron','Peter Young'],
masks:['Amanda Knight','Lizzie Yianni Georgiou','Norma Webb'],
costumes:['Lindy Hemming']},
{title:'The World Is Not Enough',
titleCZ:'Jeden svět nestačí',
year:1999,
runtime:128,
countries:['UK','USA'],
genres:['Action','Adventure','Crime','Thriller'],
director:['Michael Apted'],
actors:['Pierce Brosnan','Sophie Marceau','Robert Carlyle','Denise Richards','Robbie Coltrane','Judi Dench','Desmond Llewelyn','John Cleese','Maria Grazia Cucinotta','Samantha Bond','Michael Kitchen','Colin Salmon','Serena Scott Thomas','Ulrich Thomsen','Patrick Malahide','Omid Djalili','Justus von Dohnányi','Daisy Beaumont','Daz Crawford','Goldie','Judith Shekoni','Jeff Nuttall','Greg Powell','Sean Cronin','Michael G. Wilson','Claude-Oliver Rudolph','Andrew Burt','Hassani Shapi','David Calder'],
basedOn:['Ian Fleming'],
screenplay:['Neal Purvis','Robert Wade','Bruce Feirstein'],
production:['Barbara Broccoli','Michael G. Wilson'],
music:['David Arnold'],
camera:['Adrian Biddle'],
cut:['Jim Clark'],
sound:['Richard Pryke','Chris Munro'],
scenography:['Peter Lamont','Mark Harris','Andrew Ackland-Snow'],
masks:['Linda DeVetta'],
costumes:['Lindy Hemming']},
{title:'You Only Live Twice',
titleCZ:'Žiješ jenom dvakrát',
year:1967,
runtime:117,
countries:['UK','USA'],
genres:['Action','Adventure','Thriller'],
director:['Lewis Gilbert'],
actors:['Sean Connery','Akiko Wakabajaši','Mie Hama','Teru Šimada','Karin Dor','Donald Pleasence','Bernard Lee','Lois Maxwell','Desmond Llewelyn','Burt Kwouk','Edward Mulhare','Alexander Knox','David Bauer','Vic Armstrong','William Sylvester','Robert Hutton','Charles Gray','Richard Marner','Tsai Chin','Tecuró Tanba','Patrick Jordan','Shane Rimmer','Ed Bishop','Francesca Tu','Robert Rietty','Norman Jones','John Stone','George Roubicek','Bill Nagy','Basil Moss','Anthony Chinn','Andy Ho','Laurence Herder','Robin Bailey','George Murcell','Frazer Hines','Kikko Macuoka','Michael Chow','Jeffry Wickham','Mehmet Ali Akpınar','Cecil Cheng','David Healy','Ekrem Bora','Kristopher Kum','Anthony Ainley','Sylvana Henriques','Brian Wilde','Ronald Rich'],
basedOn:['Ian Fleming'],
screenplay:['Roald Dahl'],
production:['Albert R. Broccoli','Harry Saltzman'],
music:['John Barry'],
camera:['Freddie Young'],
cut:['Thelma Connell'],
sound:['Otto Snel'],
scenography:['Ken Adam','David Ffolkes'],
masks:['Basil Newall','Paul Rabiger']},
{title:'Licence to Kill',
titleCZ:'Povolení zabíjet',
year:1989,
runtime:133,
countries:['UK','USA'],
genres:['Action','Adventure','Crime','Thriller'],
director:['John Glen'],
actors:['Timothy Dalton','Carey Lowell','Robert Davi','Talisa Soto','Frank McRae','David Hedison','Everett McGill','Wayne Newton','Benicio Del Toro','Anthony Starke','Desmond Llewelyn','Pedro Armendáriz Jr.','Priscilla Barnes','Don Stroud','Grand L. Bush','Caroline Bliss','Cary-Hiroyuki Tagawa','Christopher Neame','Claudio Brook','Branscombe Richmond','Anthony Zerbe','Carl Ciarfalio','Jeff Moldovan','Michael G. Wilson','Robert Brown','Jorge Russek','Enrique Novi','Sergio Corona','Stuart Quan','Juan Peláez','Roger Cudney','Humberto Elizondo','Fidel Garriga','Rafer Johnson','Gerardo Albarrán','Edna Bolkan','Honorato Magaloni','Diane Hsu','George Belanger','Jorge Valdés García','Christopher De Stefano'],
screenplay:['Richard Maibaum','Michael G. Wilson'],
production:['Michael G. Wilson','Albert R. Broccoli'],
music:['Michael Kamen'],
camera:['Alec Mills'],
cut:['John Grover'],
sound:['Nicolas Le Messurier'],
scenography:['Peter Lamont','Michael Ford'],
masks:['Naomi Donne','Norma Webb','George Frost'],
costumes:['Jodie Lynn Tillen']},
{title:'The Man with the Golden Gun',
titleCZ:'Muž se zlatou zbraní',
year:1974,
runtime:125,
countries:['UK'],
genres:['Action','Adventure','Thriller'],
director:['Guy Hamilton'],
actors:['Roger Moore','Christopher Lee','Britt Ekland','Maud Adams','Hervé Villechaize','Clifton James','Richard Loo','Soon-Tek Oh','Marc Lawrence','Bernard Lee','Lois Maxwell','Marne Maitland','Desmond Llewelyn','James Cossins','Carmen Du Sautoy','Michael Goodliffe','Terence Plummer','Qiu Yuen','Francoise Therry','Sonny Caldinez','Ngai-Tik Man'],
basedOn:['Ian Fleming'],
screenplay:['Richard Maibaum','Tom Mankiewicz'],
production:['Albert R. Broccoli','Harry Saltzman'],
music:['John Barry'],
camera:['Ted Moore','Oswald Morris'],
cut:['John Shirley','Raymond Poulton'],
scenography:['Peter Murton'],
masks:['Paul Engelen']},
{title:'Live and Let Die',
titleCZ:'Žít a nechat zemřít',
year:1973,
runtime:121,
countries:['UK','USA'],
genres:['Action','Adventure','Thriller'],
director:['Guy Hamilton'],
actors:['Roger Moore','Yaphet Kotto','Jane Seymour','Clifton James','Julius Harris','Geoffrey Holder','David Hedison','Gloria Hendry','Bernard Lee','Lois Maxwell','Madeline Smith','Robert Dix','Lance Gordon','Shane Rimmer','Marc Smith','Lewis Alexander','Aileen Lewis','Stephen Hendrickson','Dan Jackson','Lon Satton','Tommy Lane','Stocker Fontelieu','Arnold Williams','Dennis Edwards','Irvin Allen'],
basedOn:['Ian Fleming'],
screenplay:['Tom Mankiewicz'],
production:['Albert R. Broccoli','Harry Saltzman'],
music:['George Martin','Paul McCartney'],
camera:['Ted Moore'],
cut:['Bert Bates','John Shirley','Raymond Poulton'],
scenography:['Syd Cain','Frederic C. Weiler'],
masks:['Paul Rabiger'],
costumes:['Julie Harris']},
{title:'The Spy Who Loved Me',
titleCZ:'Špion, který mě miloval',
year:1977,
runtime:120,
countries:['UK'],
genres:['Action','Adventure','Thriller'],
director:['Lewis Gilbert'],
actors:['Roger Moore','Barbara Bach','Curd Jürgens','Richard Kiel','Caroline Munro','Walter Gotell','Geoffrey Keen','Bernard Lee','George Baker','Michael Billington','Olga Bisera','Desmond Llewelyn','Edward de Souza','Vernon Dobtcheff','Valerie Leon','Lois Maxwell','Sydney Tafler','Nadim Sawalha','Robert Brown','Milton Reid','Cyril Shaps','Milo Sperber','Albert Moses','Rafiq Anwar','Shane Rimmer','Bob Sherman','Nicholas Campbell','Garrick Hagon','Ray Jewers','Christopher Muncke','Anthony Pullen Shaw','Bryan Marshall','Kim Fortune','Barry Andrews','Kevin McNally','Jeremy Bulloch','Sean Bury','David Auker','John Salthouse','George Roubicek','Yashaw Adem','Harry Fielder','Robert Goodman','Brian Gwaspari','George Leech','Bob Simmons','Jeremy Wilkin','Michael G. Wilson','Vincent Wong','Sue Vanner','Dawn Rodrigues','Keith Buckley','Irvin Allen','Tim Condren','Murray Salem'],
basedOn:['Ian Fleming'],
screenplay:['Christopher Wood','Richard Maibaum'],
production:['Albert R. Broccoli'],
music:['Marvin Hamlisch'],
camera:['Claude Renoir'],
cut:['John Glen'],
sound:['Nicolas Le Messurier'],
scenography:['Ken Adam'],
masks:['Paul Engelen']},
{title:'Being James Bond: The Daniel Craig Story',
titleCZ:'Být Jamesem Bondem',
year:2021,
runtime:46,
countries:['UK','USA'],
genres:['Documentary'],
director:['Baillie Walsh'],
actors:['Daniel Craig','Michael G. Wilson','Barbara Broccoli','Mathieu Amalric','Gemma Arterton','Javier Bardem','Dave Bautista','Monica Bellucci','Martin Campbell','Jesper Christensen','Ana de Armas','Judi Dench','Ralph Fiennes','Gregg Wilson']},
{title:'Taylor Swift: The Eras Tour',
titleCZ:'Taylor Swift: The Eras Tour',
year:2023,
runtime:160,
countries:['USA'],
genres:['Music','Documentary'],
director:['Sam Wrench'],
actors:['Taylor Swift']},
{title:'Killers of the Flower Moon',
titleCZ:'Zabijáci rozkvetlého měsíce',
year:2023,
runtime:206,
countries:['USA'],
genres:['Drama','Crime','History','Thriller','Western'],
director:['Martin Scorsese'],
actors:['Leonardo DiCaprio','Robert De Niro','Lily Gladstone','Jesse Plemons','Tantoo Cardinal','John Lithgow','Brendan Fraser','Louis Cancelmi','Tatanka Means','Scott Shepherd','Gene Jones','Pat Healy','Michael Abbott Jr.','Gary Basaraba','Martin Scorsese','Jason Isbell','Sturgill Simpson','Barry Corbin','Joshua Close','Katherine Willis','Steve Witting','Steve Eastin','Cara Jade Myers','Janae Collins','Jillian Dion','William Belleau','Nathaniel Arcand','Charlie Musselwhite','Jay Paulson','Samuel French','Eric Parkinson','Gabe Casdorph','Joey Oglesby','David Born','Brian Shoop','Steve Routman','J.C. MacKenzie','Jack White','Larry Sellers','Wally Welch','Pete Yorn','James Healy Jr.','Moe Headrick','Jennifer Rader','Ben Hall','Victor McCay','Justin France','Lee Eddy','Kristin Keith','Shonagh Smith','Brett Bower','Mary Buss','Ted Welch','Vinny Raniolo','Skip Schwink','Elden Henson','Scott George','Joe Chrest'],
basedOn:['David Grann'],
screenplay:['Eric Roth','Martin Scorsese'],
production:['Dan Friedkin','Daniel Lupi','Martin Scorsese','Bradley Thomas'],
music:['Robbie Robertson'],
camera:['Rodrigo Prieto'],
cut:['Thelma Schoonmaker'],
sound:['Tom Fleischman','Mark Ulano'],
scenography:['Jack Fisk','Spencer Davison','Jordan Crockett','Adam Willis'],
masks:['Kay Georgiou','Thomas Nellen','Siân Grigg','Jason Hamer'],
costumes:['Jacqueline West']},
{title:'Pain Hustlers',
titleCZ:'Obchodníci s bolestí',
year:2023,
runtime:122,
countries:['USA'],
genres:['Crime','Drama'],
director:['David Yates'],
actors:['Emily Blunt','Chris Evans',"Catherine O'Hara",'Andy Garcia','Chloe Coleman',"Brian d'Arcy James",'Jay Duplass','Amit Shah','Valerie LeBlanc','Aubrey Dollar','Britt Rentschler','Michael Kosta','Chapel Oaks','Selena Anduze','Josh Ventura','Avis-Marie Barnes','Lydia Castro','Mandi Christine Kerr','Samantha Kacho','Chris Marks','Becca Breitfeller','Andrea Laing','Adrian Eppley','Greyson Chadwick','Hillary Harley','Pat Dortch','Cara Mantella','Alex Van','Quinn Bozza','Donna Duplantier','Michael Lowry','Jackie Goldston','Alex Mitchell','Brandon Stanley','Hannah Pniewski','Erin Ownbey','Kaysi J. Bradley','Sharon Conley','Nick Arapoglou'],
screenplay:['Wells Tower'],
production:['Lawrence Grey','David Yates'],
music:['James Newton Howard','Michael Dean Parsons'],
camera:['George Richmond'],
cut:['Mark Day'],
sound:['Glenn Freemantle','Ben Barker','Niv Adiri'],
scenography:['Molly Hughes','Jesse Rosenthal','Hugo Santiago','Chris Yoo'],
costumes:['Colleen Atwood']},
{title:'The Killer',
titleCZ:'Zabiják',
year:2023,
runtime:118,
countries:['USA'],
genres:['Action','Adventure','Crime','Thriller','Drama'],
director:['David Fincher'],
actors:['Michael Fassbender','Tilda Swinton','Charles Parnell','Arliss Howard',"Kerry O'Malley",'Sala Baker','Sophie Charlotte','Endre Hules','Monique Ganderton','Daran Norris','Nikki Dixon','Arturo Duvergé','Kellan Rhude','Brandon Morales','Jack Kesy','Jérôme Keen','Stéphane Vasseur','François Patissier','Alexandra Holzhammer','Lacey Dover'],
basedOn:['Alexis Nolent','Luc Jacamon'],
screenplay:['Andrew Kevin Walker'],
production:['Ceán Chaffin'],
music:['Trent Reznor','Atticus Ross'],
camera:['Erik Messerschmidt'],
cut:['Kirk Baxter'],
sound:['Ren Klyce'],
scenography:['Donald Graham Burt','Brandi Kalish'],
costumes:['Cate Adams']},
{title:'Priscilla',
titleCZ:'Priscilla',
year:2023,
runtime:110,
countries:['USA'],
genres:['Drama','Biographic'],
director:['Sofia Coppola'],
actors:['Cailee Spaeny','Jacob Elordi','Ari Cohen','Dagmara Dominczyk','Tim Post','Lynne Griffin','Dan Beirne','Rodrigo Fernandez-Stoll','Dan Abramovici','Tim Dowler-Coltman','R Austin Ball','Olivia Barrett','Emily Mitchell','Raine Monroe Boland','Jorja Cadence','Luke Humphrey','Deanna Jarvis','Josette Halpert','Kamilla Kowal','Conni Miu','Stephanie Moran','Kelaiah Guiel','Gwynne Phillips'],
basedOn:['Priscilla Presley'],
screenplay:['Sofia Coppola'],
production:['Sofia Coppola','Youree Henley','Lorenzo Mieli'],
camera:['Philippe Le Sourd'],
cut:['Sarah Flack'],
sound:['Steve Foster'],
scenography:['Tamara Deverell'],
costumes:['Stacey Battat']},
{title:'The Hunger Games',
titleCZ:'Hunger Games',
year:2012,
runtime:137,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Thriller'],
director:['Gary Ross'],
actors:['Jennifer Lawrence','Josh Hutcherson','Elizabeth Banks','Liam Hemsworth','Willow Shields','Leven Rambin','Wes Bentley','Woody Harrelson','Stanley Tucci','Dayo Okeniyi','Kalia Prescott','Donald Sutherland','Isabelle Fuhrman','Paula Malcomson','Toby Jones','Lenny Kravitz','Bruce Bundy','Mackenzie Lintz','Alexander Ludwig','Jack Quaid','Amandla Stenberg','Annie Thurman','Jacqueline Emerson','Ian Nelson','Steve Coulter','Phillip Troy Linger','Anthony Reynolds','Julie Ivey','Cody Lowe','Judd Lormand','Kelly Lynn Reiter','Tara Macken','Sandra Ellis Lafferty','Ashton Moio','Ethan Jamieson','Chris Mark','Kara Petersen','Leigha Hancock','Sam Ly','Sam Tan','Imanol Yepez-Frias','Jeremy Marinas','Dakota Hood','Latarsha Rose','Karan Kendrick','Luis Carlos Machicao','Taylor John Smith','Gwydion Lashlee-Walton','Dwayne Boyd','Chase Anderson'],
basedOn:['Suzanne Collins'],
screenplay:['Gary Ross','Suzanne Collins','Billy Ray'],
production:['Nina Jacobson','Jon Kilik'],
music:['James Newton Howard','T Bone Burnett','Jo Blankenburg'],
camera:['Tom Stern'],
cut:['Stephen Mirrione','Juliette Welfling','Christopher S. Capp'],
sound:['Michael Prestwood Smith','Michael Keller'],
scenography:['Philip Messina','Larry Dias'],
masks:['Edouard F. Henriques','Ve Neill','Cheri Minns','Nikoletta Skarlatos','Vasilios Tanis','Erin Keith','Priscilla Green','Colleen LaBaff','Lisa Rocco','Diana Acrey','Bryn E. Leetch','Robert Maverick','Steven R. Soussanna','Anthony Brooks','Nicki A. Chestnut','Marie Del Prete','Shutchai Tym Buacharern'],
costumes:['Judianna Makovsky']},
{title:'The Hunger Games: The Ballad of Songbirds and Snakes',
titleCZ:'Hunger Games: Balada o ptácích a hadech',
year:2023,
runtime:157,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Francis Lawrence'],
actors:['Tom Blyth','Rachel Zegler','Peter Dinklage','Josh Andrés Rivera','Hunter Schafer','Viola Davis','Jason Schwartzman','Fionnula Flanagan','Burn Gorman','Ashley Liao','Max Raphael','Zoe Renee','Nick Benson','Isobel Jesper Jones','George Somner','Mackenzie Lansing','Knox Gibson','Aamer Husain','Jerome Lance','Lilly Maria Cooper','Luna Steeples','Hiroki Berrecloth','Cooper Dillon','Kjell Brutscheidt','Dimitri Abold','Athena Strates','Dakota Shapiro','Joshua Kantara','Amélie Hoeferle','Irene Böhm','Sofia Sanchez'],
basedOn:['Suzanne Collins'],
screenplay:['Michael Lesslie','Michael Arndt'],
production:['Nina Jacobson','Brad Simpson','Francis Lawrence'],
music:['James Newton Howard'],
camera:['Jo Willems'],
cut:['Mark Yoshikawa'],
sound:['José Antonio García'],
scenography:['Uli Hanisch'],
masks:['Melissa Döberl'],
costumes:['Trish Summerville']},
{title:'The Hunger Games: Catching Fire',
titleCZ:'Hunger Games: Vražedná pomsta',
year:2013,
runtime:146,
countries:['USA'],
genres:['Action','Adventure','Mystery','Sci-Fi','Thriller'],
director:['Francis Lawrence'],
actors:['Jennifer Lawrence','Liam Hemsworth','Josh Hutcherson','Elizabeth Banks','Woody Harrelson','Philip Seymour Hoffman','Stanley Tucci','Toby Jones','Donald Sutherland','Willow Shields','Amanda Plummer','Jena Malone','Lynn Cohen','Meta Golding','Alan Ritchson','Sam Claflin','Juliet Reeves','Paula Malcomson','Lenny Kravitz','Stephanie Leigh Schlund','Bruno Gunn','Jeffrey Wright','Kirk LaSalle','Elena Sanchez','Monique Ganderton','Stef Dawson','Elyse DuFour','Maria Howell','E. Roger Mitchell','Wilbur Fitzgerald','Erika Bierman','Harley Castro','Jill Jane Clements','Patrick St. Esprit','Afemo Omilami','Judd Lormand','Sandra Ellis Lafferty','Amandla Stenberg','Dayo Okeniyi','Hunter Clowdus','Megan Hayes','Leon Lamar','Ravi Naidu','Nickolas Wolf','Jaylen Moore','Moses J. Moseley','Daniel Bernhardt','Franco Castan','Kathryn Kelly','Milli M.'],
basedOn:['Suzanne Collins'],
screenplay:['Michael Arndt','Simon Beaufoy'],
production:['Nina Jacobson','Jon Kilik'],
music:['James Newton Howard'],
camera:['Jo Willems'],
cut:['Alan Edward Bell'],
sound:['Skip Lievsay','Mark Weingarten'],
scenography:['Philip Messina','Adam Davis','Larry Dias'],
masks:['Valerie Jackson','Deborah Rutherford','Ve Neill','Nikoletta Skarlatos','Tyson Fountaine','Tifanie White','Nikki Bell','Trenton Simmons','Shana Fruman','Zoe Hay','Jennifer Tremont','Diana Acrey','Lynne K. Eagan','Robert Maverick','Shutchai Tym Buacharern'],
costumes:['Trish Summerville']},
{title:'The Hunger Games: Mockingjay - Part 1',
titleCZ:'Hunger Games: Síla vzdoru 1. část',
year:2014,
runtime:125,
countries:['USA'],
genres:['Sci-Fi','Adventure','Thriller'],
director:['Francis Lawrence'],
actors:['Jennifer Lawrence','Josh Hutcherson','Liam Hemsworth','Woody Harrelson','Elizabeth Banks','Julianne Moore','Philip Seymour Hoffman','Stanley Tucci','Donald Sutherland','Willow Shields','Sam Claflin','Mahershala Ali','Robert Knepper','Natalie Dormer','Evan Ross','Jena Malone','Jeffrey Wright','Elden Henson','Patina Miller','Wes Chatham','Phillip Troy Linger','Monique Ganderton','Stef Dawson','Paula Malcomson','Erika Bierman','Rus Blackwell','Jordan Woods-Robinson','Justine Ezarik','Ian J. Cunningham','Donna Biscoe','Emma Elle Roberts','Michael Garza','Angel Giuffria','Ryan DeLaney','Jacklyn Edney'],
basedOn:['Suzanne Collins'],
screenplay:['Danny Strong','Peter Craig'],
production:['Nina Jacobson','Jon Kilik'],
music:['James Newton Howard'],
camera:['Jo Willems'],
cut:['Alan Edward Bell','Mark Yoshikawa'],
sound:['Skip Lievsay'],
scenography:['Philip Messina','Steve Summersgill','Larry Dias','Dan Webster'],
masks:['Valerie Jackson','Gigi Collins','Ve Neill','Nikoletta Skarlatos','Leay Cangelosi','Joanetta Stowers','Robert C. Mathews III','Camille Friend','Shutchai Tym Buacharern'],
costumes:['Bart Mueller','Kurt Swanson']},
{title:'The Hunger Games: Mockingjay - Part 2',
titleCZ:'Hunger Games: Síla vzdoru 2. část',
year:2015,
runtime:137,
countries:['USA','Germany'],
genres:['Sci-Fi','Adventure','Action','Thriller'],
director:['Francis Lawrence'],
actors:['Jennifer Lawrence','Josh Hutcherson','Liam Hemsworth','Woody Harrelson','Sam Claflin','Elizabeth Banks','Donald Sutherland','Julianne Moore','Philip Seymour Hoffman','Willow Shields','Jeffrey Wright','Stanley Tucci','Toby Jones','Mahershala Ali','Jena Malone','Natalie Dormer','Gwendoline Christie','Elden Henson','Robert Knepper','Evan Ross','Wes Chatham','Joe Chrest','Phillip Troy Linger','Monique Ganderton','Stef Dawson','Patina Miller','Mark Jeffrey Miller','Michelle Forbes','Misty Ormiston','Kim Ormiston','Paula Malcomson','Eugenie Bondurant','Meta Golding','Tobias Lauterberg','Omid Abtahi','Chris Theisinger','Jeffrey Vu','Corey Maher','Courtney Dietz','Emma Elle Roberts','Elle Graham','Robert Byron','Phil Armijo','Erick Wofford','Christopher De Stefano','Bradley Bowen','Jacklyn Edney','Luke Loveless','Kate Rachesky','Marco Fuller'],
basedOn:['Suzanne Collins'],
screenplay:['Danny Strong','Peter Craig'],
production:['Nina Jacobson','Jon Kilik','Henning Molfenter','Christoph Fisser','Charlie Woebcken'],
music:['James Newton Howard'],
camera:['Jo Willems'],
cut:['Alan Edward Bell','Mark Yoshikawa'],
sound:['Skip Lievsay'],
scenography:['Philip Messina','Steve Summersgill','Larry Dias','Dan Webster'],
masks:['Deborah Rutherford','Ve Neill','Nikoletta Skarlatos','Leay Cangelosi','Tifanie White','Joanetta Stowers','Robert C. Mathews III','Jan Kempkens-Odemski','Camille Friend','Shutchai Tym Buacharern'],
costumes:['Bart Mueller','Kurt Swanson']},
{title:'Divergent',
titleCZ:'Divergence',
year:2014,
runtime:139,
countries:['USA'],
genres:['Sci-Fi','Adventure','Thriller'],
director:['Neil Burger'],
actors:['Shailene Woodley','Theo James','Zoë Kravitz','Miles Teller','Jai Courtney','Kate Winslet','Ray Stevenson','Ansel Elgort','Ashley Judd','Maggie Q','Tony Goldwyn','Mekhi Phifer','Ben Lloyd-Hughes','Justine Wachsberger','Amy Newbold','Christian Madsen','Veronica Roth','Ben Lamb','Yasmine Aker','Michael James Bell','Will Blagrove','Casimere Jollette','Parker Mack','Rotimi','Cleo Anthony','Emmanuel Manzanares','Chandra Michaels','Brandon Bowens','Chris Hayes','Kate Rees Davies','Austin Lyon','Rebecca Ray','Danielle Swanson','Anthony Fleming','Bob Rumnock','Faye Jackson','Lukas Burger','Lucas Ross','Michael Gideon Sherry','Clara Burger','Alexander Hashioka Oatfield','Renee Morrison','Janet Ulrich Brooks','Ana Corbi','Ryan Carr','Leigh Bush'],
basedOn:['Veronica Roth'],
screenplay:['Vanessa Taylor','Evan Daugherty'],
production:['Douglas Wick','Lucy Fisher','Pouya Shahbazian'],
music:['Junkie XL'],
camera:['Alwin H. Küchler'],
cut:['Richard Francis-Bruce','Nancy Richardson'],
sound:['Michael Prestwood Smith','Wylie Stateman','Michael Keller'],
scenography:['Andy Nicholson','Anne Kuljian'],
masks:['Rosalind Jones-Crosby','Lisa Jelic','Kevin Haney','Ivana Primorac','Dominic Mango','Lillian Sakamaki','Suzi Ostos','Alejandra Ford','Vivian Maxwell','Denise Baker','Alma Izquierdo'],
costumes:['Carlo Poggioli']},
{title:'Insurgent',
titleCZ:'Rezistence',
year:2015,
runtime:119,
countries:['USA'],
genres:['Sci-Fi','Adventure','Thriller'],
director:['Robert Schwentke'],
actors:['Shailene Woodley','Theo James','Kate Winslet','Ansel Elgort','Miles Teller','Jai Courtney','Zoë Kravitz','Naomi Watts','Maggie Q','Daniel Dae Kim','Octavia Spencer','Ray Stevenson','Mekhi Phifer','Emjay Anthony','Rosa Salazar','Justine Wachsberger','Jonny Weston','Suki Waterhouse','Hunter Deno','Lyon Beckwith','Ashley Judd','Tony Goldwyn','Keiynan Lonsdale','Ben Lamb','Shaker Sangam','Robert Dane Goodwin','Lawrence Kao','Ian Casselberry','Hunter Burke',"Logan O'Neill",'Deaven Brooks','Suparna Thies','Emma Elle Roberts','Nelson Bonilla','Pete Burris','David Landry','Jack Champion','Isaiah John','Nathalia Hencker','Kendrick Cross','Stephanie Leigh Schlund','Justice Leak','Lyndsi LaRose','Rebecca Ray','Summer Cain','Walter Hendrix III','Erick Wofford','Charlie Bodin','Bradley Bowen','Arian Ash','Gissette Valentin','Marcus Lewis',"Alphonso A'Qen-Aten Jackson",'Luke Loveless','Cynthia Barrett','Kate Rachesky'],
basedOn:['Veronica Roth'],
screenplay:['Brian Duffield','Akiva Goldsman','Mark Bomback'],
production:['Douglas Wick','Lucy Fisher','Pouya Shahbazian'],
music:['Joseph Trapanese'],
camera:['Florian Ballhaus'],
cut:['Stuart Levy','Nancy Richardson'],
sound:['Christian P. Minkler','Michael Minkler','Wylie Stateman'],
scenography:['Alec Hammond','Jay Pelissier','Kathy Lucas'],
masks:['Yolanda Toussieng','Leay Cangelosi','Howard Berger','Greg Nicotero','Dee Dee Metzger'],
costumes:['Louise Mingenbach','Paula Truman']},
{title:'Allegiant',
titleCZ:'Aliance',
year:2016,
runtime:120,
countries:['USA'],
genres:['Adventure','Romance','Sci-Fi','Action'],
director:['Robert Schwentke'],
actors:['Shailene Woodley','Theo James','Naomi Watts','Zoë Kravitz','Miles Teller','Ansel Elgort','Jonny Weston','Maggie Q','Jeff Daniels','Bill Skarsgård','Emjay Anthony','Rachel Hendrix','Autumn Dial','Courtney Hope','Keiynan Lonsdale','Lyon Beckwith','Ben Levin','Julie Ivey','Octavia Spencer','Nadia Hilker','Maria Howell','Michael Beasley','Amy Parrish','Robert Dane Goodwin','Nea Dune','Jordan Price','Daniel Dae Kim','Andy Bean','Deja Dee','Joseph David-Jones','Derek Roberts','Adin Steckler','Hannah Riley','Mekhi Phifer','Jonathan Yaskoff','Anniston Price','Tinsley Price','Kyle Clements','Josh Duvendeck',"Logan O'Neill",'Emily Grace Dunn','Deaven Brooks','Zeeko Zaki','Wes McGee','Eric Mendenhall','Erin Elizabeth Burns','Tara Ochs','Rebecca Ray','Phil Armijo','Conphidance','Andrew Farmer','Bradley Bowen','Kristin McKenzie Rice','Al Vicente','Myrom Kingery','Luke Loveless','Dwayne Boyd','Christopher Johnson','Joe Knezevich','Danielle Lyn','Michael Christopher Rodney'],
basedOn:['Veronica Roth'],
screenplay:['Noah Oppenheim','Bill Collage','Adam Cooper'],
production:['Douglas Wick','Lucy Fisher','Pouya Shahbazian'],
music:['Joseph Trapanese'],
camera:['Florian Ballhaus'],
cut:['Stuart Levy'],
sound:['Gary Rizzo','Beau Borders','Michael Minkler','Matthew Wood','Steve Boeddeker'],
scenography:['Alec Hammond','Kathy Lucas'],
masks:['Edouard F. Henriques','Yolanda Toussieng','Leay Cangelosi','Nikki Bell','Dee Dee Metzger'],
costumes:['Marlene Stewart']},
{title:'Wish',
titleCZ:'Přání',
year:2023,
runtime:95,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family','Fantasy','Musical'],
director:['Chris Buck','Fawn Veerasunthorn'],
actors:['Ariana DeBose','Chris Pine','Evan Peters','Alan Tudyk','Harvey Guillén','Victor Garber','Della Saba','Angelique Cabral','Ramy Youssef','Natasha Rothwell','Jon Rudnitsky','Nasim Pedrad','Heather Matarazzo','Nicole Lynn Evans','Keone Young'],
screenplay:['Jennifer Lee','Allison Moore'],
production:['Peter Del Vecho','Juan Pablo Reyes Lancaster-Jones'],
music:['Dave Metzger'],
sound:['David E. Fluhr','Paul McGrath']},
{title:'Next Goal Wins',
titleCZ:'Jeden gól',
year:2023,
runtime:104,
countries:['USA'],
genres:['Comedy','Sport','Drama'],
director:['Taika Waititi'],
actors:['Michael Fassbender','Oscar Kightley','Kaimana','David Fane','Beulah Koale','Rachel House','Will Arnett','Elisabeth Moss','Uli Latukefu','Chris Alosio','Lehi Makisi Falepapalangi','Ioane Goodhue','Rhys Darby','Angus Sampson','Luke Hemsworth','Kaitlyn Dever','Hio Pelesasa','Taika Waititi','Sisa Grey'],
screenplay:['Taika Waititi','Iain Morris'],
production:['Mike Brett','Jonathan Cavendish','Steve Jamison','Garrett Basch','Taika Waititi'],
music:['Michael Giacchino'],
camera:['Lachlan Milne'],
cut:['Tom Eagles','Yana Gorskaya','Nicholas Monsour','Nat Sanders'],
scenography:['Ra Vincent'],
masks:['Ralph Malani','Jaime Leigh McIntosh'],
costumes:['Miyako Bellizzi']},
{title:'Renaissance: A Film by Beyoncé',
titleCZ:'Renaissance: A Film by Beyoncé',
year:2023,
runtime:150,
countries:['USA'],
genres:['Music'],
director:['James B. Merryman','Mark Ritchie'],
actors:['Beyoncé'],
production:['Ned Doyle'],
music:['James William Blades'],
camera:['Kenneth Wales']},
{title:'The Bikeriders',
titleCZ:'Motorkáři',
year:2023,
runtime:116,
countries:['USA'],
genres:['Drama','Crime'],
director:['Jeff Nichols'],
actors:['Austin Butler','Jodie Comer','Tom Hardy','Michael Shannon','Boyd Holbrook','Norman Reedus','Damon Herriman','Beau Knapp','Karl Glusman','Emory Cohen','Mike Faist','Toby Wallace','Phuong Kubacki','Happy Anderson','Michael Abbott Jr.','Andrew Riley Stephens'],
screenplay:['Jeff Nichols'],
production:['Sarah Green','Brian Kavanaugh-Jones'],
music:['David Wingo'],
camera:['Adam Stone'],
cut:['Julie Monroe'],
scenography:['Chad Keith'],
costumes:['Erin Benach']},
{title:'The Boy and the Heron',
titleCZ:'Chlapec a volavka',
year:2023,
runtime:125,
countries:['Japan'],
genres:['Animation','Adventure','Action','Fantasy'],
director:['Hajao Mijazaki'],
actors:['Sóma Santoki','Takuja Kimura','Džun Fubuki','Džun Kunimura','Kaoru Kobajaši','Karen Takizawa','Keiko Takešita','Kó Šibasaki','Masaki Suda','Sawako Agawa','Šinobu Ótake','Šóhei Hino','Jošino Kimura','Nami Uehara'],
basedOn:['Genzaburó Jošino'],
screenplay:['Hajao Mijazaki'],
production:['Tošio Suzuki'],
music:['Džó Hisaiši'],
camera:['Acuši Okui'],
cut:['Akane Širaiši','Rie Macubara','Takeši Sejama'],
sound:['Kódži Kasamacu'],
scenography:['Jódži Takešige']},
{title:'Poor Things',
titleCZ:'Chudáčci',
year:2023,
runtime:141,
countries:['Ireland','UK','USA'],
genres:['Sci-Fi','Comedy','Drama','Romance'],
director:['Yorgos Lanthimos'],
actors:['Emma Stone','Mark Ruffalo','Willem Dafoe','Ramy Youssef','Christopher Abbott','Jerrod Carmichael','Hanna Schygulla','Margaret Qualley','Kathryn Hunter','Suzy Bemba','Vicki Pepperdine','Wayne Brett','Tom Stourton','Damien Bonnard','Jeremy Wheeler','Roderick Hill','Jack Barton','Laurent Borel','Gergő Borbás','Jerskin Fendrix','Laurent Winkler'],
basedOn:['Alasdair Gray'],
screenplay:['Tony McNamara'],
production:['Ed Guiney','Andrew Lowe','Yorgos Lanthimos','Emma Stone'],
music:['Jerskin Fendrix'],
camera:['Robbie Ryan'],
cut:['Yorgos Mavropsaridis'],
scenography:['James Price','Shona Heath'],
masks:['Nadia Stacey','Mark Coulier','Josh Weston'],
costumes:['Holly Waddington']},
{title:'Leave the World Behind',
titleCZ:'Nech svět světem',
year:2023,
runtime:139,
countries:['USA'],
genres:['Drama','Thriller','Mystery'],
director:['Sam Esmail'],
actors:['Julia Roberts','Ethan Hawke','Mahershala Ali',"Myha'la",'Farrah Mackenzie','Charlie Evans','Kevin Bacon','Alexis Rae Forlenza','Vanessa Aspillaga','Josh Drennen','Orli Gottesman','Erica Cho'],
basedOn:['Rumaan Alam'],
screenplay:['Sam Esmail'],
production:['Julia Roberts','Lisa Roberts Gillan','Sam Esmail'],
music:['Mac Quayle'],
camera:['Tod Campbell'],
cut:['Lisa Lassek'],
scenography:['Anastasia White','David Schlesinger'],
masks:['Jennifer Tiffany Green'],
costumes:['Catherine Marie Thomas']},
{title:'Rebel Moon: Part One - A Child of Fire',
titleCZ:'Rebel Moon: První část - Zrozená z ohně',
year:2023,
runtime:133,
countries:['USA'],
genres:['Sci-Fi','Action','Adventure'],
director:['Zack Snyder'],
actors:['Sofia Boutella','Charlie Hunnam','Jena Malone','Corey Stoll','Cary Elwes','Michiel Huisman','Alfonso Herrera','Djimon Hounsou','Ed Skrein','Du-na Bae','Ray Fisher','Cleopatra Coleman','Ingvar Sigurðsson','Dominic Burgess','Staz Nair','Stuart Martin','Kayden Alexander Koshelev','Zack Palmisano','Anthony Hopkins','Alex Mortensen','Mark Steger','Sisse Marie','Caden Dragomer','Patrick Luwis','Meredith VanCuyk','Fra Fee','Danielle Burgio','Kingston Foster','Christopher Matthew Cook','Douglas Tait','Josefine Lindegaard','Allen Lee Haff','Greg Kriek','John Orr','Giovanni Lopes','Rhian Rees','Jullian Dulce Vida','Isabella Brenza','Gary Nohealii','Michael James Bell','Savanna Gann','Stella Grace Fitzgerald'],
screenplay:['Zack Snyder','Shay Hatten','Kurt Johnstad'],
production:['Zack Snyder','Deborah Snyder','Wesley Coller','Eric Newman'],
music:['Junkie XL'],
camera:['Zack Snyder'],
cut:['Dody Dorn'],
sound:['Andy Koyama'],
scenography:['Stephen Swain','Stefan Dechant','Claudia Bonfe'],
masks:['Christopher Allen Nelson','Jason Orion'],
costumes:['Stephanie Portnoy Porter']},
{title:"Five Nights at Freddy's",
titleCZ:'Pět nocí u Freddyho',
year:2023,
runtime:109,
countries:['USA'],
genres:['Horror','Sci-Fi','Thriller'],
director:['Emma Tammi'],
actors:['Josh Hutcherson','Piper Rubio','Elizabeth Lail','Matthew Lillard','Mary Stuart Masterson','Kat Conner Sterling','Christian Stokes','Joseph Poliquin','Grant Feely','Jophielle Love','Lucas Grant','Jessica Blackmore','Theodus Crane'],
screenplay:['Emma Tammi'],
production:['Jason Blum'],
music:['The Newton Brothers'],
camera:['Lyn Moncrief'],
cut:['William Paley','Andrew Wesman'],
scenography:['Marc Fisichella','Mark A. Terry'],
masks:['Carl Variste'],
costumes:["Natalie O'Brien"]},
{title:'Toys',
titleCZ:'Hračky',
year:1992,
runtime:116,
countries:['USA'],
genres:['Fantasy','Comedy','Family'],
director:['Barry Levinson'],
actors:['Robin Williams','Michael Gambon','Joan Cusack','Robin Wright','LL Cool J',"Donald O'Connor",'Jack Warden','Debi Mazar','Julio Oscar Mechoso','Jamie Foxx','Art Metrano','Yeardley Smith','Ron Jeremy','Blake Clark','Arthur Malet','Sam Levinson','Wendy Melvoin','Steve Park','Shelly Desai','Tommy Townsend','Kevin West','Jack Levinson','Jacque Lynn Colton'],
screenplay:['Valerie Curtin','Barry Levinson'],
production:['Mark Johnson','Barry Levinson'],
music:['Hans Zimmer','Trevor Horn'],
camera:['Adam Greenberg'],
cut:['Stu Linder'],
sound:['Richard Beggs','Tom Johnson'],
scenography:['Ferdinando Scarfiotti'],
masks:['Cheri Minns','Greg Nelson'],
costumes:['Albert Wolsky']},
{title:'Dry Season',
titleCZ:'Sucho',
year:2024,
runtime:114,
countries:['Czechia','Germany','Slovakia'],
genres:['Drama'],
director:['Bohdan Sláma'],
actors:['Martin Pechlát','Magdaléna Borová','Marek Daniel','Judit Pecháček','Bolek Polívka','Dorota Šlajerová','Tomas Sean Pšenička','Marek Taclík','Gabriela Míčová','Marie Ludvíková'],
screenplay:['Bohdan Sláma'],
production:['Pavel Strnad','Petr Oukropec'],
music:['Jakub Kudláč'],
camera:['Diviš Marek'],
cut:['Jan Daňhel'],
sound:['Sebastian Schmidt','Florian Marquardt','Marek Poledna'],
scenography:['Jan Vlasák'],
masks:['Jaroslav Šámal'],
costumes:['Zuzana Krejzková']},
{title:'The Zone of Interest',
titleCZ:'Zóna zájmu',
year:2023,
runtime:105,
countries:['USA','UK','Poland'],
genres:['Drama','History','War'],
director:['Jonathan Glazer'],
actors:['Sandra Hüller','Christian Friedel','Ralph Herforth','Freya Kreutzkam','Max Beck','Ralf Zillmann','Imogen Kogge','Stephanie Petrowitz','Marie Rosa Tietjen','Daniel Holzberg','Sascha Maaz','Lilli Falk'],
basedOn:['Martin Amis'],
screenplay:['Jonathan Glazer'],
production:['Ewa Puszczyńska','James Wilson'],
music:['Mica Levi'],
camera:['Łukasz Żal'],
cut:['Paul Watts'],
sound:['Johnnie Burn','Tarn Willers'],
scenography:['Chris Oddy','Joanna Kuś','Katarzyna Sikora'],
costumes:['Małgorzata Karpiuk']},
{title:'One Life',
titleCZ:'Jeden život',
year:2023,
runtime:108,
countries:['UK'],
genres:['Drama','Biographic','History'],
director:['James Hawes'],
actors:['Anthony Hopkins','Helena Bonham Carter','Johnny Flynn','Jonathan Pryce','Lena Olin','Romola Garai','Adrian Rawlins','Samantha Spiro','Marthe Keller','Alex Sharp','Henrietta Garden','Ziggy Heath','Matilda Thorpe','Antonie Formanová','Ruth Magdaléna Schmidtová','Barbora Černá','Juliana Moska','Martin Bednár','Barbora Váchová','Kateřina Kocichová','Kateřina Dias'],
screenplay:['Lucinda Coxon'],
production:['Iain Canning','Guy Heeley','Emile Sherman'],
music:['Volker Bertelmann'],
camera:['Zac Nicholson'],
cut:['Lucia Zucchetti'],
scenography:['Christina Moore'],
costumes:['Joanna Eatwell']},
{title:'Ferrari',
titleCZ:'Ferrari',
year:2023,
runtime:130,
countries:['USA'],
genres:['Biographic','Drama','Action','Sport'],
director:['Michael Mann'],
actors:['Adam Driver','Shailene Woodley','Alessandro Cremona','Penélope Cruz','Gabriel Leone','Patrick Dempsey','Michele Savoia','Domenico Fortunato',"Jack O'Connell",'Sarah Gadon','Valentina Bellè','Massi Furlan','Tommaso Basili','Lino Musella','Andrea Bruschi','Giuseppe Russo','Agnese Brighittini','Gianfilippo Grasso','Alex Tonti','Daniela Piperno','The Stig','Alessio Cioni'],
basedOn:['Brock Yates'],
screenplay:['Troy Kennedy-Martin','Michael Mann'],
production:['John Lesher','Michael Mann','P. J. van Sandwijk','John Friedberg'],
music:['Daniel Pemberton'],
camera:['Erik Messerschmidt'],
sound:['Angelo Bonanni','David Werntz','Tony Lamberti','Andy Nelson'],
scenography:['Maria Djurkovic','Massimo Pauletto'],
masks:['Aldo Signoretti'],
costumes:['Massimo Cantini Parrini']},
{title:'Saltburn',
titleCZ:'Saltburn',
year:2023,
runtime:127,
countries:['USA','UK'],
genres:['Thriller','Comedy','Drama'],
director:['Emerald Fennell'],
actors:['Barry Keoghan','Jacob Elordi','Archie Madekwe','Rosamund Pike','Richard E. Grant','Ewan Mitchell','Carey Mulligan','Reece Shearsmith','Lolly Adefope','Alison Oliver','Paul Rhys','Sadie Soverall','Michelle Thomas'],
screenplay:['Emerald Fennell'],
production:['Tom Ackerley','Emerald Fennell','Josey McNamara','Margot Robbie'],
music:['Anthony B. Willis'],
camera:['Linus Sandgren'],
cut:['Victoria Boydell'],
scenography:['Charlotte Dirickx','Suzie Davies'],
costumes:['Sophie Canale']},
{title:'The Beekeeper',
titleCZ:'The Beekeeper',
year:2024,
runtime:105,
countries:['USA'],
genres:['Thriller','Action'],
director:['David Ayer'],
actors:['Jason Statham','Josh Hutcherson','Jeremy Irons','Emmy Raver-Lampman','Bobby Naderi','Derek Siow','Phylicia Rashad','Michael Epp','Taylor James','Jemma Redgrave','Minnie Driver','Don Gilet','Enzo Cilenti','Megan Le','Dan Li','Jay Rincon','Peter Brooke','Arian Nik','Reza Diako','Adam Basil','Jonathan Cohen'],
screenplay:['Kurt Wimmer'],
production:['Bill Block','Jason Statham','Kurt Wimmer'],
music:['Jared Michael Fry'],
camera:['Gabriel Beristain'],
cut:["Geoffrey O'Brien"],
costumes:['Kelli Jones']},
{title:'fantomas',
titleCZ:'Fantomas',
year:2024,
runtime:'024',
countries:['France'],
genres:['Action','Crime','Horror','Mystery'],
actors:['Guillaume Campanacci'],
basedOn:['Marcel Allain'],
screenplay:['Christophe Gans'],
production:['Thomas Langmann']},
{title:'Blowback',
titleCZ:'Vrah se vrací',
year:2000,
runtime:91,
countries:['Canada','USA'],
genres:['Thriller'],
director:['Mark L. Lester'],
actors:['Mario Van Peebles','James Remar','Sharisse Baker-Bernard','David Groh','Stephen Caffrey','Simon Rhee','Leslie Zemeckis','David Grant Wright','Leonard Kelly-Young','Gladise Jiminez','Erynn Dalton','Peter Allas','Richard Stay','Stephen Poletti'],
screenplay:['Randall Frakes'],
production:['Mark L. Lester'],
music:['Sean Callery'],
camera:['Jacques Haitkin'],
cut:['Christopher Roth'],
sound:['Paul Ratajczak','Jonathan Wales'],
scenography:['Wendy Guidery'],
costumes:['Arlene Castillo']},
{title:'Lisa Frankenstein',
titleCZ:'Lisa Frankenstein',
year:2024,
runtime:101,
countries:['USA'],
genres:['Comedy','Fantasy','Horror'],
director:['Zelda Williams'],
actors:['Kathryn Newton','Carla Gugino','Cole Sprouse','Liza Soberano','Jenna Davis','Joe Chrest','Henry Eikenberry','Charlie Talbert','Sylvia Grace Crim','Paola Andino','Ritchie Montgomery','Jennifer Pierce Mathus','Trina LaFargue','Bryce Romero','Geraldine Singer','Ray Gaspard','Donna Duplantier','Summer Selby','Sarah Fisher','Joshua Montes'],
screenplay:['Diablo Cody'],
production:['Diablo Cody','Mason Novick'],
music:['Isabella Summers'],
camera:['Paula Huidobro'],
cut:['Brad Turner'],
scenography:['Andrew W. Bofinger','Mark Worthington'],
costumes:['Meagan McLaughlin']},
{title:'Migration',
titleCZ:'Ptáci stěhováci',
year:2023,
runtime:92,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Benjamin Renner'],
actors:['Isabela Merced','Elizabeth Banks','Awkwafina','Keegan-Michael Key','Carol Kane','Danny DeVito','Kumail Nanjiani','David Mitchell','Jimmy Donaldson','JP Karliak'],
screenplay:['Mike White'],
production:['Christopher Meledandri'],
music:['John Powell'],
cut:['Christian Gazal'],
sound:['Daniel Laurie','Scott R. Lewis','Gary Rizzo']},
{title:'Anyone But You',
titleCZ:'S tebou nikdy',
year:2023,
runtime:103,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Will Gluck'],
actors:['Sydney Sweeney','Glen Powell','Alexandra Shipp','Hadley Robinson','Dermot Mulroney','Rachel Griffiths','Michelle Hurd','Bryan Brown','Darren Barnet','Charlee Fraser','Joe Davidson','GaTa','Mia Artemis','Nat Buchanan'],
screenplay:['Ilana Wolpert','Will Gluck'],
production:['Will Gluck','Jeff Kirschenbaum','Joe Roth'],
music:['Este Haim','Christopher Stracey'],
camera:['Danny Ruhlmann'],
cut:['Tia Nolan'],
sound:['Nick Emond','Tateum Kohut','Greg Orloff','Jon Wakeham'],
costumes:['Amelia Gebler']},
{title:'Mean Girls',
titleCZ:'Protivný sprostý holky',
year:2004,
runtime:97,
countries:['USA','Canada'],
genres:['Comedy','Romance'],
director:['Mark Waters'],
actors:['Lindsay Lohan','Tina Fey','Lizzy Caplan','Lacey Chabert','Rachel McAdams','Amy Poehler','Tim Meadows','Ana Gasteyer','Daniel Franzese','Amanda Seyfried','Jonathan Bennett','Neil Flynn','Jill Morrison','Shannon Todd','Laura de Carteret','Krysta Carter','Clare Preuss','Jonathan Malen','William R Phillips','Chris Anton','Miranda Edwards','Dan Willmott','Rajiv Surendra','Ely Henry','Sharron Matthews','Stefanie Drummond','Julia Chantrey','Sima Fisher','Bruce Hunter'],
basedOn:['Rosalind Wiseman'],
screenplay:['Tina Fey'],
production:['Lorne Michaels'],
music:['Rolfe Kent'],
camera:['Daryn Okada'],
cut:['Wendy Greene Bricmont'],
sound:['Chuck Michael','Patrick Cyccone Jr.',"Terry O'Bright"],
scenography:['Cary White','Patricia Cuccia'],
masks:['Mario Cacioppo','Jo-Ann MacNeil'],
costumes:['Mary Jane Fort']},
{title:'American Fiction',
titleCZ:'American Fiction',
year:2023,
runtime:117,
countries:['USA'],
genres:['Comedy','Drama'],
director:['Cord Jefferson'],
actors:['Jeffrey Wright','Tracee Ellis Ross','John Ortiz','Erika Alexander','Leslie Uggams','Adam Brody','Keith David','Issa Rae','Sterling K. Brown','Myra Lucretia Taylor','Raymond Anthony Thomas','Okieriete Onaodowan','Miriam Shor','Michael Cyril Creighton','Patrick Fischler','Neal Lerner','J.C. MacKenzie','Jenn Harris','Bates Wilder','John Ales','Alexander Pobutsky','Carmen Cusack','Celeste Oliva','Kate Avallone','Michael Malvesti','Michele Proude','Skyler Wright','Greta Quispe'],
screenplay:['Cord Jefferson'],
production:['Cord Jefferson','Ben LeClair','Nikos Karamigios','Jermaine Johnson'],
music:['Laura Karpman'],
camera:['Cristina Dunlap'],
cut:['Hilda Rasula'],
sound:['Richard Weingart','Alexandra Fehrman'],
scenography:['Jonathan Guggenheim'],
costumes:['Rudy Mance']},
{title:'A Quiet Place: Day One',
titleCZ:'Tiché místo: První den',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Horror','Thriller','Sci-Fi','Drama'],
director:['Michael Sarnoski'],
actors:["Lupita Nyong'o",'Djimon Hounsou','Joseph Quinn','Alex Wolff',"Denis O'Hare",'Elijah Ungvary'],
screenplay:['Michael Sarnoski'],
production:['Michael Bay','Andrew Form','Brad Fuller','John Krasinski'],
camera:['Patrick Scola'],
cut:['Andrew Mondshein'],
scenography:['Simon Bowles']},
{title:"Miller's Girl",
titleCZ:'Premiantka',
year:2024,
runtime:93,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Jade Halley Bartlett'],
actors:['Martin Freeman','Jenna Ortega','Bashir Salahuddin','Gideon Adlon','Dagmara Dominczyk','Christine Adams'],
screenplay:['Jade Halley Bartlett'],
production:['Joseph Drake','Josh Fagen','Evan Goldberg','Nathan Kahane','Seth Rogen','James Weaver'],
music:['Elyssa Samsel'],
camera:['Daniel Brothers'],
cut:['Vanara Taing'],
scenography:['Cheyenne Ford'],
costumes:['Lauren Bott']},
{title:'Orion and the Dark',
titleCZ:'Orion a tma',
year:2024,
runtime:90,
countries:['USA'],
genres:['Animation','Adventure','Fantasy','Comedy','Mystery'],
director:['Sean Charmatz'],
actors:['Jacob Tremblay','Paul Walter Hauser','Werner Herzog','Colin Hanks','Ike Barinholtz','Nat Faxon','Golda Rosheuvel','Natasia Demetriou','Angela Bassett','Aparna Nancherla','Carla Gugino','Matt Dellapina','Shannon Chan-Kent','Ren Hanami','Amy Hill'],
basedOn:['Emma Yarlett'],
screenplay:['Charlie Kaufman'],
music:['Kevin Lax','Robert Lydecker'],
sound:['Jessey Drake'],
scenography:['Christine Bian']},
{title:'The Holdovers',
titleCZ:'Zimní prázdniny',
year:2023,
runtime:133,
countries:['USA'],
genres:['Comedy','Drama'],
director:['Alexander Payne'],
actors:['Paul Giamatti','Dominic Sessa',"Da'Vine Joy Randolph",'Gillian Vigman','Carrie Preston','Tate Donovan','Michael Provost','Oscar Wahlberg','Brady Hepner','Darby Lee-Stack','Naheem Garcia','Pamela Jayne Morgan','Jonathan von Mering','Rena Maliszewski','Ian Dolley','Jim Kaplan'],
screenplay:['David Hemingson'],
production:['Bill Block','David Hemingson','Mark Johnson'],
music:['Mark Orton'],
camera:['Eigil Bryld'],
cut:['Kevin Tent'],
sound:['David J. Schwartz','Frank Gaeta'],
scenography:['Ryan Warren Smith'],
costumes:['Wendy Chuck']},
{title:'The Ministry of Ungentlemanly Warfare',
titleCZ:'The Ministry of Ungentlemanly Warfare',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Drama','War','Action'],
director:['Guy Ritchie'],
actors:['Henry Cavill','Eiza González','Alan Ritchson','Cary Elwes','Hero Fiennes Tiffin','Alex Pettyfer','Henry Golding','Til Schweiger','Babs Olusanmokun','Henrique Zaga'],
basedOn:['Damien Lewis'],
screenplay:['Arash Amel','Eric Johnson','Guy Ritchie','Paul Tamasy'],
production:['Jerry Bruckheimer','Ivan Atkinson','John Friedberg'],
music:['Christopher Benstead'],
costumes:['Loulou Bontemps']},
{title:'Upgraded',
titleCZ:'Povýšení',
year:2024,
runtime:105,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Carlson Young'],
actors:['Camila Mendes','Archie Renaux','Marisa Tomei','Lena Olin','Anthony Head','Thomas Kretschmann','Saoirse-Monica Jackson','Fola Evans-Akingbola','Andrew Schulz','Rachel Matthews','Grégory Montel','Aimee Carrero'],
screenplay:['Luke Spencer Roberts','Justin Matthews'],
production:['Mike Karz','Lena Roklin','Piers Tempest'],
music:['Isom Innis'],
camera:['Mike Stern Sterzyński'],
cut:['Bruce Green'],
scenography:['Andrew Holden-Stokes','Lisa De Cunha'],
costumes:['Lara de Bruijn']},
{title:'Barbie',
titleCZ:'Barbie',
year:2023,
runtime:114,
countries:['USA'],
genres:['Comedy','Adventure','Fantasy'],
director:['Greta Gerwig'],
actors:['Margot Robbie','Ryan Gosling','America Ferrera','Kate McKinnon','Will Ferrell','Simu Liu','Issa Rae','Rhea Perlman','Hari Nef','Alexandra Shipp','Emma Mackey','Kingsley Ben-Adir','Connor Swindells','Michael Cera','John Cena','Sharon Rooney','Ariana Greenblatt','Ncuti Gatwa','Scott Evans','Jamie Demetriou','Dua Lipa','Nicola Coughlan','Emerald Fennell','Ana Cruz Kayne','Ritu Arya','Helen Mirren','Caroline Wilde','Annie Mumolo','Lauren Holt','Isla Ashworth','Olivia Brody'],
screenplay:['Greta Gerwig','Noah Baumbach'],
production:['Tom Ackerley','Robbie Brenner','David Heyman','Margot Robbie'],
music:['Mark Ronson','Andrew Wyatt'],
camera:['Rodrigo Prieto'],
cut:['Nick Houy'],
sound:["Kevin O'Connell",'Nina Rice'],
scenography:['Sarah Greenwood','Katie Spencer'],
costumes:['Jacqueline Durran']},
{title:'The Creator',
titleCZ:'Stvořitel',
year:2023,
runtime:134,
countries:['USA'],
genres:['Action','Drama','Sci-Fi','Thriller'],
director:['Gareth Edwards'],
actors:['John David Washington','Madeleine Yuna Voyles','Gemma Chan','Allison Janney','Ken Watanabe','Ralph Ineson','Marc Menchaca','Sturgill Simpson','Amar Chadha-Patel','Michael Esper','Mackenzie Lansing','Leanna Chea','Rad Pereira','Robbie Tann','Veronica Ngo',"Eoin O'Brien",'Pat Skelton','Ian Verdun'],
screenplay:['Gareth Edwards','Chris Weitz'],
production:['Gareth Edwards','Kiri Hart','Jim Spencer','Arnon Milchan'],
music:['Hans Zimmer'],
camera:['Greig Fraser','Oren Soffer'],
cut:['Hank Corwin','Scott Morris','Joe Walker'],
sound:['Erik Aadahl','Tom Ozanich','Dean A. Zupancic','Ian Voigt','Ethan Van der Ryn'],
scenography:['James Clyne','Claire Levinson-Gendler','Chris DiPaola'],
costumes:['Jeremy Hanna']},
{title:'How to Have Sex',
titleCZ:'Jak mít sex',
year:2023,
runtime:92,
countries:['UK','Řecko'],
genres:['Drama'],
director:['Molly Manning Walker'],
actors:['Mia McKenna-Bruce','Shaun Thomas','Lara Peake','Enva Lewis','Samuel Bottomley','Eilidh Loan','Laura Ambler'],
screenplay:['Molly Manning Walker'],
production:['Emily Leo','Konstantinos Kontovrakis','Ivana MacKinnon'],
music:['James Jacob'],
camera:['Nicolas Canniccioni'],
cut:['Fin Oates'],
sound:['Steve Fanagan'],
scenography:['Luke Moran-Morris'],
masks:['Natasha Lawes'],
costumes:['George Buxton']},
{title:'The Iron Claw',
titleCZ:'Železní bratři',
year:2023,
runtime:130,
countries:['USA','UK'],
genres:['Drama','Sport','Biographic'],
director:['Sean Durkin'],
actors:['Zac Efron','Lily James','Harris Dickinson','Jeremy Allen White','Maura Tierney','Holt McCallany','Cazzey Louis Cereghino','Stanley Simons','Brady Pierce','Kevin Anton','Jullian Dulce Vida','Jim Gleason','Maxwell Friedman','Ryan Nemeth','Michael Papajohn','Aaron Dean Eisenberg','Chelsea Edmundson'],
screenplay:['Sean Durkin'],
production:['Juliette Howell','Angus Lamont','Tessa Ross','Derrin Schlesinger'],
music:['Richard Reed Parry'],
camera:['Mátyás Erdély'],
cut:['Matthew Hannam'],
sound:['Matthew Chan','Graham Rogers'],
scenography:['James Price'],
masks:['Courtney Lether'],
costumes:['Jennifer Starzyk']},
{title:'Past Lives',
titleCZ:'Minulé životy',
year:2023,
runtime:105,
countries:['USA','South Korea'],
genres:['Drama','Romance'],
director:['Celine Song'],
actors:['Greta Lee','Yoo Teo','John Magaro','Isaac Powell','Jojo T. Gibbs','Kristen Sieh','Nathan Clarkson','Emily Cass McDonnell','Keelia Clarkson','Seung-ah Moon','Jane Kim','Seung-min Leem'],
screenplay:['Celine Song'],
production:['David Hinojosa','Pamela Koffler','Christine Vachon'],
music:['Christopher Bear','Daniel Rossen'],
camera:['Shabier Kirchner'],
cut:['Keith Fraase'],
sound:['Jacob Ribicoff'],
scenography:['Grace Yun','Alan Lampert'],
masks:['Sarah Graalman'],
costumes:['Katina Danabassis']},
{title:'Triangle of Sadness',
titleCZ:'Trojúhelník smutku',
year:2022,
runtime:149,
countries:['Sweden','France','UK','Germany'],
genres:['Drama','Comedy'],
director:['Ruben Östlund'],
actors:['Harris Dickinson','Charlbi Dean','Zlatko Burić','Woody Harrelson','Dolly De Leon','Vicki Berlin','Henrik Dorsin','Iris Berben','Jean-Christophe Folly','Oliver Ford Davies','Hanna Oldenburg','Arvin Kananian','Camilla Läckberg','Sunnyi Melles','Malte Gårdinger','Mia Benson','Shaniaz Hama Ali','Carolina Gynning','Alex Schulman','Nikolas Chalkiadakis','Malick Afocozi'],
screenplay:['Ruben Östlund'],
production:['Erik Hemmendorff','Philippe Bober'],
camera:['Fredrik Wenzel'],
cut:['Mikel Cee Karlsson','Ruben Östlund'],
scenography:['Josefin Åsberg'],
masks:['Evi Zafiropoulou','Stefanie Gredig'],
costumes:['Sofie Krunegård']},
{title:'Everything Everywhere All at Once',
titleCZ:'Všechno, všude, najednou',
year:2022,
runtime:139,
countries:['USA'],
genres:['Action','Sci-Fi','Fantasy','Drama','Comedy'],
director:['Daniel Kwan','Daniel Scheinert'],
actors:['Michelle Yeoh','Ke Huy Quan','Stephanie Hsu','James Hong','Jamie Lee Curtis','Tallie Medel','Jenny Slate','Harry Shum Jr.','Sunita Mani','Aaron Lazar','Andy Le','Randall Archer','Audrey Wasilewski','Li Jing','Anthony Molinari','Mičiko Nišiwaki','Daniel Scheinert','Elle Alexander','Randy Newman','D.Y. Sao','Jason Hamer'],
screenplay:['Daniel Kwan','Daniel Scheinert'],
production:['Daniel Kwan','Daniel Scheinert','Anthony Russo','Joe Russo','Mike Larocca','Jonathan Wang'],
music:['Son Lux'],
camera:['Larkin Seiple'],
cut:['Paul Rogers'],
sound:['Alexandra Fehrman'],
scenography:['Jason Kisvarday','Kelsi Ephraim','Amelia Brooke'],
masks:['Dania Simental','Jason Hamer','Meghan Heaney','Michelle Chung'],
costumes:['Shirley Kurata']},
{title:'Dumb Money',
titleCZ:'Peníze těch tupců',
year:2023,
runtime:104,
countries:['USA'],
genres:['Biographic','Comedy','Drama'],
director:['Craig Gillespie'],
actors:['Paul Dano','Pete Davidson',"Vincent D'Onofrio",'America Ferrera',"Myha'la",'Nick Offerman','Anthony Ramos','Seth Rogen','Talia Ryder','Sebastian Stan','Shailene Woodley','Kate Burton','Clancy Brown','Rushi Kota','Larry Owens','Dane DeHaan','Olivia Thirlby','Gerardo Rodriguez','Christina Brucato','Deniz Akdeniz','Sal Rendino','Stephen Reich','Brian David Tracy','Christopher Gray'],
basedOn:['Ben Mezrich'],
screenplay:['Lauren Schuker Blum','Rebecca Angelo'],
production:['Aaron Ryder','Teddy Schwarzman','Craig Gillespie'],
music:['Will Bates'],
camera:['Nicolas Karakatsanis'],
cut:['Kirk Baxter'],
sound:['Griffin Richardson'],
scenography:['Scott Kuzio','Paige Mitchell'],
costumes:['Kameron Lennox']},
{title:'Království divočiny: Šprotci štíhlí',
titleCZ:'Království divočiny: Šprotci štíhlí',
year:2006,
runtime:25,
countries:['Japan'],
genres:['Documentary','Short']},
{title:'Dirty Dancing',
titleCZ:'Hříšný tanec',
year:1987,
runtime:96,
countries:['USA'],
genres:['Romance','Drama','Music','Dance'],
director:['Emile Ardolino'],
actors:['Jennifer Grey','Patrick Swayze','Jerry Orbach','Cynthia Rhodes','Jack Weston','Jane Brucker','Kelly Bishop','Lonny Price','Max Cantor','Neal Jones','Wayne Knight','Paula Trueman','Garry Goodrow','Antone Pagán','Emile Ardolino','Darren W. Conrad'],
screenplay:['Eleanor Bergstein'],
production:['Linda Gottlieb'],
music:['John Morris'],
camera:['Jeffrey Jur'],
cut:['Peter C. Frank'],
sound:['John Pritchett','Bob Olari'],
scenography:['David Chapman'],
costumes:['Hilary Rosenfeld']},
{title:'Born on the Fourth of July',
titleCZ:'Narozen 4. července',
year:1989,
runtime:145,
countries:['USA'],
genres:['Drama','War','Biographic'],
director:['Oliver Stone'],
actors:['Tom Cruise','Willem Dafoe','Kyra Sedgwick','Raymond J. Barry','Jerry Levine','Frank Whaley','Caroline Kava','Ed Lauter','John Getz','Michael Wincott','Stephen Baldwin','Bob Gunton','Anne Bobby','David Warshofsky','Reg E. Cathey','Josh Evans','Lili Taylor','David Herman','Andrew Lauer','Tom Sizemore','Bryan Larkin','Daniel Baldwin','Brian Tarantina','Wayne Knight','John C. McGinley','Lucinda Jenney','Dale Dye','Tom Berenger','Oliver Stone','Sean Stone','Jason Gedrick','Holly Marie Combs','William Baldwin','James Le Gros','William Mapother',"Don 'The Dragon' Wilson",'Vivica A. Fox','Mark Moses','Jake Weber','Joseph P. Reidy','Mike Starr','Beau Starr','Jodi Long','Elizabeth Hoffman','Jack McGee','William Wallace','Rocky Carroll','Dean Mauro','Delia Sheppard','Richard Panebianco','Henry Strzalkowski','Nick Nicholson','Chris Pedersen','Annie McEnroe','Rob Camilletti','R.D. Call','Dean Denton','Begonya Plaza','Peter Crombie','Markus Flanagan','Anthony Pena','Edie Brickell','Michelle Hurst','Samantha Larkin','Kevin Harvey Morse','Jamie Talisman','Ron Kovic','Paul Sanchez','Byron Minns','Cordelia González','Billie Neal','Bill Allen','David Neidorf','Norma Moore','Bruce MacVittie','Tony Frank','Corkey Ford','Damien Leake','Ivan Kane','Réal Andrews','Stacey Moseley','Edith Diaz','Richard Poe','Jenna von Oÿ','Frank Cavestani','Alan Toy','Íce Mrozek','Donald Wilson'],
screenplay:['Oliver Stone','Ron Kovic'],
production:['A. Kitman Ho','Oliver Stone'],
music:['John Williams'],
camera:['Robert Richardson'],
cut:['David Brenner','Joe Hutshing'],
sound:['Michael Minkler','Wylie Stateman','Tod A. Maitland'],
scenography:['Bruno Rubeo'],
masks:['Gordon J. Smith','Jean Ann Black'],
costumes:['Judy L. Ruskin']},
{title:'Mr. & Mrs. Smith',
titleCZ:'Pan Smith s manželkou',
year:1941,
runtime:95,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Alfred Hitchcock'],
actors:['Carole Lombard','Robert Montgomery','Gene Raymond','Jack Carson','Philip Merivale','Lucile Watson','William Tracy','Charles Halton','Esther Dale','Emma Dunn','Betty Compson','Patricia Farr','William Edmunds','Pamela Blake','Ernie Adams','Ernie Alexander','Murray Alper','Ralph Brooks','James Conaty','Alec Craig','Sayre Dearing','Ralph Dunn','James Flavin','Bess Flowers','Jack Gardner','Sam Harris','Alfred Hitchcock','Robert Emmett Keane','Frank Mills',"William H. O'Brien","Jack O'Shea",'Emory Parnell','Ralph Sanford','Brick Sullivan','Russell Wade','Allen Wood','Barbara Woodell','James Pierce'],
screenplay:['Norman Krasna'],
music:['Edward Ward'],
camera:['Harry Stradling Sr.'],
cut:['William Hamilton'],
scenography:["Albert S. d'Agostino",'Van Nest Polglase','Darrell Silvera'],
masks:['Mel Berns'],
costumes:['Irene']},
{title:'Treachery and Greed on the Planet of the Apes',
titleCZ:'Zrada a chamtivost na Planetě opic',
year:1980,
runtime:94,
countries:['USA'],
genres:['Adventure','Sci-Fi','Thriller'],
director:['Ralph Senensky'],
actors:['Roddy McDowall','Ron Harper','James Naughton','Richard Devon','Mark Lenard','Russ Marin','Arlen Stuart','Ron Troncatty'],
screenplay:['Walter Black'],
production:['Stanley Hough']},
{title:'Alita: Battle Angel',
titleCZ:'Alita: Bojový Anděl',
year:2019,
runtime:122,
countries:['USA','Canada','Argentina'],
genres:['Action','Adventure','Romance','Sci-Fi','Thriller'],
director:['Robert Rodriguez'],
actors:['Rosa Salazar','Christoph Waltz','Keean Johnson','Jennifer Connelly','Mahershala Ali','Jeff Fahey','Jackie Earle Haley','Eiza González','Ed Skrein','Casper Van Dien','Lana Condor','Jorge Lendeborg Jr.','Idara Victor','Derek Mears','Leonard Wu','Marko Zaror','Rick Yune','Billy Blair','Dimitrius Pulido','Elle LaMont','Alex Livinalli','Sam Medina','Vincent Fuentes','Jorge A. Jimenez','Gregg Berger','Edward Norton','Michelle Rodriguez','Jai Courtney','Gary Teague','Alan Trong','Tony LaThanh','Iba Thiam','Jeff Bottoms','Liza Wilk','David Sobolov','Elizabeth Tabish','Dakota Millett','Carl Thomas','Andre Pelzer'],
basedOn:['Jukito Kiširo'],
screenplay:['James Cameron','Laeta Kalogridis','Robert Rodriguez'],
production:['James Cameron','Jon Landau'],
music:['Junkie XL'],
camera:['Bill Pope'],
cut:['Stephen E. Rivkin','Ian Silverstein'],
sound:['Craig Henighan','Andy Nelson','Paula Fairfield'],
scenography:['Caylah Eddleblute','Steve Joyner'],
masks:['Kara Sutherlin','Howard Berger','Greg Nicotero','Mark Landon'],
costumes:['Nina Proctor']},
{title:'Oblivion',
titleCZ:'Nevědomí',
year:2013,
runtime:124,
countries:['USA'],
genres:['Sci-Fi','Action','Adventure','Mystery'],
director:['Joseph Kosinski'],
actors:['Tom Cruise','Morgan Freeman','Olga Kurylenko','Nikolaj Coster-Waldau','Andrea Riseborough','Zoë Bell','Melissa Leo','James Rawlings',"Booch O'Connell",'John L. Armijo','Jaylen Moore'],
basedOn:['Joseph Kosinski'],
screenplay:['Karl Gajdusek','Michael Arndt'],
production:['Dylan Clark','Peter Chernin','Joseph Kosinski','Barry Levine','Duncan Henderson'],
music:['M83','Anthony Gonzalez','Joseph Trapanese'],
camera:['Claudio Miranda'],
cut:['Richard Francis-Bruce'],
sound:['Gwendolyn Yates Whittle','Al Nelson','Gary Rizzo','Ren Klyce','Juan Peralta'],
scenography:['Darren Gilford','Gena Vazquez','Ronald R. Reiss'],
masks:['Desne J. Holland','Sarah Monzani','Anna Stachow','Remi Savva','Stacey Herbert'],
costumes:['Marlene Stewart']},
{title:'Run Lola Run',
titleCZ:'Lola běží o život',
year:1998,
runtime:81,
countries:['Germany'],
genres:['Thriller','Crime'],
director:['Tom Tykwer'],
actors:['Franka Potente','Moritz Bleibtreu','Herbert Knaup','Nina Petri','Armin Rohde','Joachim Król','Ludger Pistor','Suzanne von Borsody','Sebastian Schipper','Heino Ferch','Monica Bleibtreu','Marc Bischoff','Lars Rudolph','Ute Lubosch','Peter Pauli','Utz Krause','Hans Paetsch','Beate Finckh','Andreas Petri','Klaus Müller'],
screenplay:['Tom Tykwer'],
production:['Andreas Schreitmüller','Stefan Arndt'],
music:['Tom Tykwer','Johnny Klimek','Reinhold Heil'],
camera:['Frank Griebe'],
cut:['Mathilde Bonnefoy'],
sound:['Matthias Lempert','Dirk Jacob','Frank Behnke'],
scenography:['Alexander Manasse','Irene Otterpohl','Attila Saygel'],
masks:['Babette Bröseke','Margrit Neufink'],
costumes:['Monika Jacobs']},
{title:'Puss in Boots',
titleCZ:'Kocour v botách',
year:2011,
runtime:90,
countries:['USA'],
genres:['Animation','Action','Adventure','Comedy','Family','Fantasy'],
director:['Chris Miller'],
actors:['Antonio Banderas','Salma Hayek','Zach Galifianakis','Billy Bob Thornton','Amy Sedaris','Constance Marie','Guillermo del Toro','Mike Mitchell','Tom Wheeler','Conrad Vernon','Tom McGrath','Chris Miller','Julie Wittner','Roberto Donati','Joshua Rush','Bob Persichetti','Ryan Crego','Bob Joles','Rebecca Davis','Jossara Jinaro'],
basedOn:['Charles Perrault'],
screenplay:['Tom Wheeler','Brian Lynch','Jon Zack'],
music:['Henry Jackman'],
sound:['Richard King','Andy Nelson','Anna Behlmer'],
scenography:['Guillaume Aretos']},
{title:'Turning Red',
titleCZ:'Proměna',
year:2022,
runtime:100,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family','Fantasy'],
director:['Domee Shi'],
actors:['Rosalie Chiang','Sandra Oh','Maitreyi Ramakrishnan','Orion Lee','Wai Ching Ho','Lori Tan Chinn','Sherry Cola','James Hong','Jordan Fisher',"Finneas O'Connell",'Josh Levi','Sasha Roiz','Addie Chandler','Lily Sanfelippo','Anne-Marie'],
screenplay:['Julia Cho','Domee Shi'],
production:['Lindsey Collins'],
music:['Ludwig Göransson'],
camera:['Mahyar Abousaeedi'],
cut:['Steve Bloom','Nicholas C. Smith'],
sound:['Coya Elliott','Ren Klyce','Stephen Urata']},
{title:'The Tomorrow War',
titleCZ:'Válka zítřka',
year:2021,
runtime:138,
countries:['USA'],
genres:['Action','Sci-Fi'],
director:['Chris McKay'],
actors:['Chris Pratt','Yvonne Strahovski','J.K. Simmons','Betty Gilpin','Sam Richardson','Edwin Hodge','Jasmine Mathews','Ryan Kiera Armstrong','Keith Powers','Mary Lynn Rajskub','Mike Mitchell','Alexis Louder','Rose Bianco','Seychelle Gabriel','Alan Trong','David Maldonado','Keith Brooks','Jim Palmer','Clark Sarullo','Mary Ashlyn Moore','Felisha Terrell','Roger Barton','Eric Graise','Angel Giuffria','D. James Jones','Christina Bach','Andrea Andrade','Gary Weeks','Melissa Saint-Amand','Robert Tinsley','Piper Collins','Gabrielle Byndloss','Chibuikem Uche',"Tommy O'Brien",'Gissette Valentin','Nikki Mejia','Kenneth Israel','Patrick Y. Malone','Dean Feldman'],
screenplay:['Zach Dean'],
production:['David Ellison','Dana Goldberg','Don Granger','Jules Daly','David S. Goyer','Adam Kolbrenner'],
music:['Lorne Balfe'],
camera:['Larry Fong'],
cut:['Roger Barton','Garret Elkins'],
scenography:['Peter Wenham','Beauchamp Fontaine'],
masks:['Priya Maharaj','Brynn Berg','Mary Flaa','Missy Lisenby','Sarah Graham'],
costumes:['Betsy Heimann']},
{title:'The Girl on the Train',
titleCZ:'Dívka ve vlaku',
year:2016,
runtime:112,
countries:['USA','Indie'],
genres:['Mystery','Crime','Thriller','Drama'],
director:['Tate Taylor'],
actors:['Emily Blunt','Rebecca Ferguson','Haley Bennett','Justin Theroux','Luke Evans','Édgar Ramírez','Allison Janney','Lisa Kudrow','Laura Prepon','Marko Caka','Mauricio Ovalle','Darren Goldstein','Faith Logan','Peter Mayer-Klepchick','Ross Gibby','Lana Young'],
basedOn:['Paula Hawkins'],
screenplay:['Erin Cressida Wilson'],
production:['Marc Platt','Jared LeBoff'],
music:['Danny Elfman'],
camera:['Charlotte Bruus Christensen'],
cut:['Michael McCusker','Andrew Buckland'],
sound:['Paul Urmson','Skip Lievsay','Gregg Rudloff','Scott Millan'],
scenography:['Kevin Thompson'],
masks:['Michael Marino','Bernadette Mazur','Jackie Risotto','Michael Fontaine','Pat Moore-Theis'],
costumes:['Michelle Matland','Ann Roth']},
{title:'Her',
titleCZ:'Ona',
year:2013,
runtime:126,
countries:['USA'],
genres:['Drama','Romance','Sci-Fi'],
director:['Spike Jonze'],
actors:['Joaquin Phoenix','Amy Adams','Scarlett Johansson','Rooney Mara','Olivia Wilde','Chris Pratt','Matt Letscher','Portia Doubleday','Sam Jaeger','Katherine Boecher','Luka Jones','Bill Hader','Kristen Wiig','Soko','Brian Cox','Spike Jonze','Matt Copko','Laura Kai Chen','Steve Zissis','Lynn Adrianna','Claudia Choi','Lisa Renee Pitts','Seth Carr','Alia Janine','Alan Mueting','Eric Pumphrey','Pamela Roylance','Yvette Saunders','Hoyte van Hoytema'],
screenplay:['Spike Jonze'],
production:['Megan Ellison','Spike Jonze','Vincent Landay'],
music:['Owen Pallett','Win Butler'],
camera:['Hoyte van Hoytema'],
cut:['Jeff Buchanan','Eric Zumbrunnen'],
sound:['David Parker','Ren Klyce'],
scenography:['K.K. Barrett','Gene Serdena'],
costumes:['Casey Storm']},
{title:'Ice Age: The Meltdown',
titleCZ:'Doba ledová 2: Obleva',
year:2006,
runtime:86,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Carlos Saldanha'],
actors:['Ray Romano','John Leguizamo','Denis Leary','Seann William Scott','Josh Peck','Queen Latifah','Will Arnett','Jay Leno','Chris Wedge','Joseph Bologna','Madeleine Martin','Jordi Caballero','Renée Taylor','Ariel Winter','Carlos Saldanha','Claudia Besso','Laura Marano','Mindy Sterling','Alan Tudyk','Stephen Root','Tara Strong','Zack Shada','John Cygan','Clea Lewis','Marshall Efron','Debi Derryberry','Paul Butcher','James Sie','Jan Rabson','Shane Baumel','Jennifer Darling','Danny Mann','Jansen Panettiere','Crispin Freeman','Jack Angel'],
screenplay:['Gerry Swallow','Peter Gaulke','Jim Hecht'],
production:['Lori Forte'],
music:['John Powell'],
cut:['Harry Hitner'],
sound:['Douglas Murray','Gwendolyn Yates Whittle','Randy Thom','Lora Hirschberg','Christopher Scarabosio']},
{title:'Ice Age: Dawn of the Dinosaurs',
titleCZ:'Doba ledová 3: Úsvit dinosaurů',
year:2009,
runtime:90,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Carlos Saldanha','Mike Thurmeier'],
actors:['John Leguizamo','Queen Latifah','Ray Romano','Chris Wedge','Denis Leary','Joey King','Simon Pegg','Seann William Scott','Josh Peck','Jane Lynch','Bill Hader','Kristen Wiig','Karen Disher','Selenis Leyva','Matt Adler','Clea Lewis','Johnathan Tchaikovsky','Bea Miller','Kelly Keaton','Nicole Ehinger','June Christopher','Allegra Leguizamo','Maile Flanagan'],
screenplay:['Peter Ackerman','Michael Berg','Yoni Brenner','Mike Reiss'],
production:['Lori Forte','John C. Donkin'],
music:['John Powell'],
cut:['Harry Hitner'],
sound:['Gwendolyn Yates Whittle','Randy Thom','Lora Hirschberg']},
{title:'Ice Age: Continental Drift',
titleCZ:'Doba ledová 4: Země v pohybu',
year:2012,
runtime:84,
countries:['USA'],
genres:['Animation','Adventure','Comedy'],
director:['Steve Martino','Mike Thurmeier'],
actors:['Ray Romano','Queen Latifah','John Leguizamo','Denis Leary','Chris Wedge','Josh Peck','Jennifer Lopez','Seann William Scott','Aziz Ansari','Peter Dinklage','Keke Palmer','Ester Dean','Drake','Wanda Sykes','Kunal Nayyar','Nick Frost','Nicki Minaj','Rebel Wilson','Alan Tudyk','Heather Morris','Josh Gad','Alain Chabat','Jennette McCurdy','Simon Pegg','Tashiana Washington','Danny Flaherty','Selenis Leyva','Joy Behar','Sondra James','Ashley Paige Albert','Corwin C. Tuggles','Marieve Herington','Randy Thom','Edita Brychta','Allegra Leguizamo','Jim Conroy','Alexa Kahn'],
screenplay:['Michael Berg','Jason Fuchs','Mike Reiss'],
production:['Lori Forte','John C. Donkin'],
music:['John Powell'],
camera:['Renato Falcão'],
cut:['David Ian Salter'],
sound:['Randy Thom','Andy King','Lora Hirschberg']},
{title:'Ice Age: Collision Course',
titleCZ:'Doba ledová: Mamutí drcnutí',
year:2016,
runtime:94,
countries:['USA'],
genres:['Animation','Sci-Fi','Adventure','Comedy','Family'],
director:['Mike Thurmeier'],
actors:['Stephanie Beatriz','John Leguizamo','Denis Leary','Adam Devine','Queen Latifah','Ray Romano','Wanda Sykes','Chris Wedge','Roshon Fegan','Keke Palmer','Jay Leno','Simon Pegg','Seann William Scott','Max Greenfield','Nick Offerman','Melissa Rauch','Jennifer Lopez','Jessie J','Michael Strahan','Josh Peck','Jesse Tyler Ferguson','Lilly Singh','Byron Thames','Randy Thom','Hope Levy','Whindersson Nunes','Ruth Zalduondo'],
screenplay:['Michael Berg'],
production:['Lori Forte'],
music:['John Debney'],
camera:['Renato Falcão'],
sound:['Randy Thom','Gary Summers','Lora Hirschberg','Jeremy Bowker','Hunter Berk']},
{title:'Cloud Atlas',
titleCZ:'Atlas mraků',
year:2012,
runtime:165,
countries:['USA','Germany','Singapore','China','Hong Kong'],
genres:['Drama','Mystery','Sci-Fi','Psycology'],
director:['Lana Wachowski','Tom Tykwer','Lilly Wachowski'],
actors:['Tom Hanks','Halle Berry','Jim Broadbent','Hugo Weaving','Jim Sturgess','Du-na Bae','Ben Whishaw','Keith David',"James D'Arcy",'Xun Zhou','David Gyasi','Susan Sarandon','Hugh Grant','Robert Fyfe','Martin Wuttke','Robin Morrissey','Brody Nicholas Lee','Ian van Temperley','Amanda Walker','Ralph Riach','Andrew Havill','Tanja de Wendt','Raevan Lee Hanan','Götz Otto','Niall Greig Fulton','Louis Dempsey','Martin Docherty','Alistair Petrie','Zhu Zhu','Sylvestra Le Touzel','Jojo Schöning','Laura Vietzen','Thomas Kügel','Marie Rönnebeck','Ruby Kastner','Emma Werz','Mya-Lecia Naylor','Korbyn Hawk Hanan','Katy Karrenbauer','Dulcie Smart','Anna Holmes','Shaun Lawton','Moritz Berg','Gigi Lee','Genevien Lee','Cody Benjamin Lee','Heike Hanold-Lynch','Victor Solé','Kristoffer Fuss','Marco Albrecht','Gary McCormack','David Mitchell','Zsuzsanna Cseh','Valérie Lillibeth','Jeremy Paxman','Daniele Rizzo','Rose Wakesho','Nikko Weidemann','Alexander Yassin','Phoenix Melville'],
basedOn:['David Mitchell'],
screenplay:['Lana Wachowski','Tom Tykwer','Lilly Wachowski'],
production:['Grant Hill','Stefan Arndt','Lana Wachowski','Tom Tykwer','Lilly Wachowski'],
music:['Tom Tykwer','Johnny Klimek','Reinhold Heil'],
camera:['John Toll','Frank Griebe'],
cut:['Alexander Berner'],
sound:['Roland Winke','Ivan Sharrock','Frank Kruse','Matthias Lempert','Lars Ginzel','Markus Stemler','Oleg Kulchytskyi'],
scenography:['Uli Hanisch','Hugh Bateup','Rebecca Alleway','Stephan O. Gessler','Nicki McCallum'],
masks:['Daniel Parker','Jeremy Woodhead','Göran Lundström','Daniela Skala','Jan Kempkens-Odemski'],
costumes:['Kym Barrett','Pierre-Yves Gayraud']},
{title:'megan 2020',
titleCZ:'Vegan 2020',
year:2020,
runtime:51,
countries:['UK'],
genres:['Documentary'],
director:['Klaus Mitchell'],
actors:['David Attenborough','James Blunt','Tabitha Brown','Novak Djokovic','Bruce Friedrich','Bill Maher','Milton Mills','Snoop Dogg','Chris Tarrant','Ed Winters','Jane Goodall','Michael Greger','Peter Hammarstedt','Klaus Mitchell','Jane Velez-Mitchell']},
{title:'Rambo: First Blood Part II',
titleCZ:'Rambo II',
year:1985,
runtime:96,
countries:['USA'],
genres:['Action','Adventure','Thriller','War'],
director:['George P. Cosmatos'],
actors:['Sylvester Stallone','Richard Crenna','Charles Napier','Steven Berkoff','Julia Nickson','George Cheung','Andy Wood','Martin Kove','William Ghent','Dana Lee','John Pankow','Tony Munafo','Voyo Goric','Roger Cudney','William Rothlein','Jeff Imada','Baoan Coleman'],
screenplay:['Sylvester Stallone','James Cameron'],
production:['Buzz Feitshans'],
music:['Jerry Goldsmith'],
camera:['Jack Cardiff'],
cut:['Gib Jaffe','Mark Helfrich','Mark Goldblatt','Larry Bock'],
sound:["Kevin O'Connell",'Rob Young'],
scenography:['Bill Kenney'],
costumes:['Tom Bronson']},
{title:'Rambo III',
titleCZ:'Rambo III',
year:1988,
runtime:102,
countries:['USA'],
genres:['Action','Adventure','Thriller','War'],
director:['Peter MacDonald'],
actors:['Sylvester Stallone','Richard Crenna','Marc de Jonge','Kurtwood Smith','Spiros Focás','Sasson Gabai','Doudi Shoua','Randy Raney','Marcus Gilbert','Joseph Shiloach','Harold Diamond','Alon Aboutboul'],
screenplay:['Sylvester Stallone','Sheldon Lettich'],
production:['Buzz Feitshans'],
music:['Jerry Goldsmith'],
camera:['John Stanier'],
cut:['Andrew London','O. Nicholas Brown','James R. Symons','Edward Warschilka'],
sound:['Michael Minkler',"Kevin O'Connell"],
scenography:['Bill Kenney'],
masks:['Michael Westmore','Giannetto De Rossi'],
costumes:['Richard La Motte']},
{title:'Rambo',
titleCZ:'Rambo: Do pekla a zpět',
year:2008,
runtime:'Alternativní 87 min',
countries:['USA','Germany'],
genres:['Action','Thriller','War'],
director:['Sylvester Stallone'],
actors:['Sylvester Stallone','Julie Benz','Paul Schulze','Matthew Marsden','Graham McTavish','Tim Kang','Reynaldo Gallegos','Jake La Botz','Maung Maung Khin','Ken Howard','James With'],
screenplay:['Sylvester Stallone','Art Monterastelli'],
production:['Avi Lerner','John Thompson','Kevin King Templeton'],
music:['Brian Tyler'],
camera:['Glen MacPherson'],
cut:['Sean Albertson'],
sound:['Chris David','Marshall Garlington','Barney Cabral','Gabriel J. Serrano'],
scenography:['Franco-Giacomo Carbone'],
masks:['Scott H. Eddo','Vasit Suchitta'],
costumes:['Lizz Wolf']},
{title:'Rambo: Last Blood',
titleCZ:'Rambo: Poslední krev',
year:2019,
runtime:100,
countries:['USA'],
genres:['Action','Adventure','Thriller'],
director:['Adrian Grunberg'],
actors:['Sylvester Stallone','Paz Vega','Joaquín Cosio','Yvette Monreal','Óscar Jaenada','Sheila Shah','Sergio Peris-Mencheta','Adriana Barraza','Jessica Madsen','Owen Davis','Manuel Uriza','Marco de la O','Carlos Licea','Fenessa Pineda','Genie Kim','Rick Zingale','Díana Bermudez','Nick Wittman'],
screenplay:['Matthew Cirulnick','Sylvester Stallone'],
production:['Avi Lerner','Steven Paul','Kevin King Templeton','Yariv Lerner','Les Weldon'],
music:['Brian Tyler'],
camera:['Brendan Galvin'],
cut:['Carsten Kurpanek','Todd E. Miller'],
sound:['Robert Fernandez'],
scenography:['Franco-Giacomo Carbone','Edou Hydallgo','Nieves Monterde'],
costumes:['Cristina Sopeña']},
{title:'Commando',
titleCZ:'Komando',
year:1985,
runtime:87,
countries:['USA'],
genres:['Action','Adventure','Comedy','Thriller'],
director:['Mark L. Lester'],
actors:['Arnold Schwarzenegger','Rae Dawn Chong','Dan Hedaya','Vernon Wells','James Olson','David Patrick Kelly','Alyssa Milano','Bill Duke','Drew Snyder','Sharon Wyatt','Chelsea Field','Branscombe Richmond','Bill Paxton','Gary Carlos Cervantes','Thomas Rosales Jr.','Ava Cadell','Bob Minor','Michael DeLano','Hank Calia','Phil Adams','Lenny Juliano','Charles Meshack','Billy Cardenas','Julie Hayek','Tom Simmons'],
screenplay:['Steven E. de Souza'],
production:['Joel Silver'],
music:['James Horner'],
camera:['Matthew F. Leonetti'],
cut:['John F. Link','Mark Goldblatt','Glenn Farr','Howard Kunin'],
sound:['Tim Webb'],
scenography:['John Vallone','Robert Gould'],
masks:['William Turner','Joe McKinney']},
{title:'Wensday',
titleCZ:'Whensday',
year:2013,
runtime:100,
countries:['USA'],
genres:['Comedy'],
director:['Tomas Herrera','Ben Mozer','Andrew Schneider','Doug Usher'],
actors:['Tomas Herrera'],
camera:['Doug Usher'],
sound:['Ben Governale']},
{title:'Pipi Dlouhá punčocha',
titleCZ:'Pipi Dlouhá punčocha',
year:1982,
runtime:134,
countries:['Russia'],
genres:['Family','Musical','Comedy'],
director:['Margarita Mikaeljan'],
actors:['Taťjana Vasiljeva','Ljudmila Šagalova','Michail Bojarskij','Leonid Jarmolnik','Leonid Kaněvskij','Fjodor Stukov','Jelizaveta Nikiščichina'],
basedOn:['Astrid Lindgren'],
screenplay:['Margarita Mikaeljan'],
music:['Vladimir Daškevič']},
{title:"The Astronaut's Wife",
titleCZ:'Astronautova žena',
year:1999,
runtime:109,
countries:['USA'],
genres:['Sci-Fi','Thriller'],
director:['Rand Ravich'],
actors:['Johnny Depp','Charlize Theron','Joe Morton','Clea DuVall','Nick Cassavetes','Samantha Eggar','Blair Brown','Tom Noonan','Donna Murphy','Edward Kerr','Gary Grubbs','Dylan Sprouse','Cole Sprouse','Michael Luceri','Gary Carlos Cervantes','Carl Burrows','Ben Van Bergen','Rondi Reed',"Tom O'Brien",'Seth Barrish','Charles Lanyer','Ellen Lancaster','Linda Powell','Conrad Bachmann','Michael Crider'],
screenplay:['Rand Ravich'],
production:['Andrew Lazar'],
music:['George S. Clinton'],
camera:['Allen Daviau'],
cut:['Steve Mirkovich','Timothy Alverson'],
sound:['Tom Fleischman','Michael Barosky'],
scenography:['Jan Roelfs'],
costumes:['Isis Mussenden']},
{title:'The Expendables',
titleCZ:'Expendables: Postradatelní',
year:2010,
runtime:103,
countries:['USA'],
genres:['Action','Adventure','Thriller'],
director:['Sylvester Stallone'],
actors:['Sylvester Stallone','Jason Statham','Jet Li','Dolph Lundgren','Eric Roberts','Randy Couture','Steve Austin','David Zayas','Giselle Itié','Charisma Carpenter','Gary Daniels','Terry Crews','Mickey Rourke','Arnold Schwarzenegger','Bruce Willis','David Joseph Martinez','James Landry Hébert','Grifon Aldren','Tatsu Carvalho','Lauren Jones','Amin Joseph','Antonio Rodrigo Nogueira'],
screenplay:['Dave Callaham','Sylvester Stallone'],
production:['Avi Lerner','Jason Constantine','John Thompson','Kevin King Templeton'],
music:['Brian Tyler'],
camera:['Jeffrey L. Kimball'],
cut:['Ken Blackwell','Paul Harb'],
sound:['Chris David','Gabriel J. Serrano'],
scenography:['Franco-Giacomo Carbone','Robert Gould'],
masks:['Scott H. Eddo','Ken Diaz','Remi Savva'],
costumes:['Lizz Wolf']},
{title:'The Expendables 2',
titleCZ:'Expendables: Postradatelní 2',
year:2012,
runtime:103,
countries:['USA'],
genres:['Action','Adventure','Thriller'],
director:['Simon West'],
actors:['Sylvester Stallone','Jason Statham','Liam Hemsworth','Dolph Lundgren','Jean-Claude Van Damme','Jet Li','Terry Crews','Randy Couture','Arnold Schwarzenegger','Bruce Willis','Chuck Norris','Scott Adkins','Nan Yu','Amanda Ooms','Charisma Carpenter','Nikolette Noel','George Zlatarev','Velislav Pavlov','Niki Stanchev','Silvia Petkova','Nikola Dodov','Novak Djokovic','Dimo Alexiev','Saňa Borisova-Ilijeva'],
screenplay:['Sylvester Stallone','Richard Wenk'],
production:['Avi Lerner','Jason Constantine','Les Weldon','Danny Lerner','John Thompson','Miguel Menéndez de Zubillaga','Kevin King Templeton'],
music:['Brian Tyler'],
camera:['Shelly Johnson'],
cut:['Todd E. Miller'],
sound:['Chris David','Gabriel J. Serrano'],
scenography:['Paul Cross'],
masks:['Scott H. Eddo','Sofi Hvarleva'],
costumes:['Lizz Wolf']},
{title:'The Expendables 3',
titleCZ:'Expendables: Postradatelní 3',
year:2014,
runtime:126,
countries:['USA'],
genres:['Action','Thriller','Adventure'],
director:['Patrick Hughes'],
actors:['Sylvester Stallone','Jason Statham','Antonio Banderas','Arnold Schwarzenegger','Jet Li','Wesley Snipes','Dolph Lundgren','Kelsey Grammer','Randy Couture','Terry Crews','Mel Gibson','Harrison Ford','Kellan Lutz','Ronda Rousey','Glen Powell','Victor Ortiz','Robert Davi','Natalie Burn','Sarai Givaty','Lisbeth Olofsson','Velizar Binev','Bashar Rahal','Frank Pesce','Harry Anichkin'],
screenplay:['Sylvester Stallone','Creighton Rothenberger','Katrin Benedikt'],
production:['Avi Lerner','Les Weldon','Danny Lerner','John Thompson','Kevin King Templeton'],
music:['Brian Tyler'],
camera:['Peter Menzies Jr.'],
cut:['Sean Albertson','Paul Harb'],
sound:['Chris David','Gabriel J. Serrano'],
scenography:['Daniel T. Dorrance','Kelly Berry'],
masks:['Scott H. Eddo','Bill Corso','Shauna Giesbrecht','Anna Quinn'],
costumes:['Lizz Wolf']},
{title:'Jaws 2',
titleCZ:'Čelisti 2',
year:1978,
runtime:111,
countries:['USA'],
genres:['Thriller','Horror','Adventure','Drama'],
director:['Jeannot Szwarc'],
actors:['Roy Scheider','Lorraine Gary','Murray Hamilton','Joseph Mascolo','Jeffrey Kramer','Collin Wilcox Paxton','Ann Dusenberry','Mark Gruner','Barry Coe','Susan French','Gary Springer','Donna Wilkes','Gary Dubin','John Dukakis','G. Thomas Dunlop','David Elliott','Marc Gilpin','Keith Gordon','Cindy Grover','Ben Marley','Martha Swatek','Billy Van Zandt','Gigi Vorgan','Jerry M. Baxter','Jean Coulter','April Gilpin','William Griffith','Fritzi Jane Courtney','Alfred Wilde','George Buck'],
screenplay:['Carl Gottlieb','Howard Sackler'],
production:['Richard D. Zanuck','David Brown'],
music:['John Williams'],
camera:['Michael C. Butler'],
cut:['Neil Travis','Arthur Schmidt'],
sound:['James R. Alexander'],
scenography:['Joe Alves'],
masks:['Robert Jiras','Rick Sharp'],
costumes:['Bill Jobe']},
{title:'Jaws 3-D',
titleCZ:'Čelisti 3',
year:1983,
runtime:94,
countries:['USA'],
genres:['Thriller','Horror','Adventure'],
director:['Joe Alves'],
actors:['Dennis Quaid','Bess Armstrong','Simon MacCorkindale','Louis Gossett Jr.','John Putch','Lea Thompson','P. H. Moriarty','Will Knickerbocker','Barbara Quinn','Lisa Maurer','Alonzo Ward','Dan Blasko','Jon Freda'],
screenplay:['Richard Matheson','Carl Gottlieb'],
production:['Rupert Hitzig'],
music:['Alan Parker'],
camera:['James A. Contner','Austin McKinney'],
cut:['Corky Ehlers','Randy Roberts'],
sound:['Bob Minkler'],
scenography:['Woods Mackintosh'],
masks:['Kathryn Bihr'],
costumes:['Dresden Urquhart']},
{title:'Children of Men',
titleCZ:'Potomci lidí',
year:2006,
runtime:109,
countries:['USA','UK','Japan'],
genres:['Sci-Fi','Drama','Thriller','Adventure'],
director:['Alfonso Cuarón'],
actors:['Clive Owen','Julianne Moore','Michael Caine','Danny Huston','Charlie Hunnam','Chiwetel Ejiofor','Pam Ferris','Peter Mullan','Clare-Hope Ashitey','Oana Pellea','Jacek Koman','Ilario Bisi-Pedro','Ed Westwick','Faruk Pruti','Paul Sharma','Andy Callaghan','Rita Davies','Tehmina Sunny','Steve Murphy','Caroline Lena Olsson','Forbes KB','Jody Halse','Paul Warren',"Dhaffer L'Abidine",'Nabil Shaban','Miriam Karlin','Barnaby Edwards','Mishal Husain','Yolanda Vazquez','Barry Martin','Simon Poland','Andrew Brooke','Vera Graziadei','Yana Yanezic','Nihal Arthanyake','Atalanta White','Francisco Labbe'],
basedOn:['P. D. James'],
screenplay:['Alfonso Cuarón','David Arata','Mark Fergus','Hawk Ostby','Timothy J. Sexton'],
production:['Marc Abraham','Eric Newman','Hilary Shor','Iain Smith'],
music:['John Tavener'],
camera:['Emmanuel Lubezki'],
cut:['Alex Rodríguez','Alfonso Cuarón'],
sound:['David Evans','Richard Beggs','Mark Paterson','Tom Johnson'],
scenography:['Geoffrey Kirkland','Jim Clay','Paul Inglis','Ray Chan'],
masks:['Karen Cohen','Graham Johnston'],
costumes:['Jany Temime']},
{title:'Germinal',
titleCZ:'Germinal',
year:1993,
runtime:159,
countries:['France','Belgium','Italy'],
genres:['Drama','History'],
director:['Claude Berri'],
actors:['Miou-Miou','Jean Carmet','Renaud','Judith Henry','Jean-Roger Milo','Gérard Depardieu','Laurent Terzieff','Bernard Fresson','Jean-Pierre Bisson','Jacques Dacqmine','Anny Duperey','Frédéric van den Driessche','Cécile Bois','Yolande Moreau','Annick Alane','Georges Staquet','Fred Personne','Thierry Levaret','Yvette Petit','Jenny Clève','Maximilien Regiani','Fred Ulysse','Pierre Lafont','André Julien','André Chaumeau','Philippe Desboeuf','Gérard Croce','Fernand Kindt','Anne-Marie Pisani','Alexandrine Loeb'],
basedOn:['Émile Zola'],
screenplay:['Claude Berri','Arlette Langmann'],
production:['Claude Berri'],
music:['Jean-Louis Roques'],
camera:['Yves Angelo'],
cut:['Hervé de Luze'],
sound:['Michel Klochendler'],
scenography:['Hoang Thanh At','Christian Marti'],
masks:['Joël Lavau','Pierre Vadé'],
costumes:['Caroline de Vivaise','Sylvie Gautrelet','Moidele Bickel']},
{title:'Crocodile Dundee',
titleCZ:'Krokodýl Dundee',
year:1986,
runtime:92,
countries:['Australia'],
genres:['Comedy','Action','Adventure','Romance'],
director:['Peter Faiman'],
actors:['Paul Hogan','Linda Kozlowski','John Meillon','David Gulpilil','Reginald VelJohnson','Mark Blum','Anne Carlisle','Caitlin Clarke','Gerry Skilton','Steve Rackman','Barry Kivel','John Snyder','Sullivan Walker','Michael Lombard',"Graham 'Grace' Walker",'Paul Greco','Khristina Totos','Irving Metzman','David Trim','Maggie Blinco'],
screenplay:['Paul Hogan','John Cornell','Ken Shadie'],
production:['John Cornell','Jane Scott'],
music:['Peter Best'],
camera:['Russell Boyd'],
cut:['David Stiven'],
sound:['Roger Savage'],
scenography:["Graham 'Grace' Walker"],
costumes:['Norma Moriceau']},
{title:'Crocodile Dundee 2',
titleCZ:'Krokodýl Dundee 2',
year:1988,
runtime:105,
countries:['Australia','USA'],
genres:['Action','Adventure','Comedy'],
director:['John Cornell'],
actors:['Paul Hogan','Linda Kozlowski','John Meillon','Ernie Dingo','Juan Fernández','Charles S. Dutton','Kenneth Welsh','Tatyana Ali','Dennis Boutsikaris','Jace Alexander','Luis Guzmán','Stephen Root','Susie Essman','Carlos Carrasco','Anthony Ruiz','Gerry Skilton','Steve Rackman','Gregory Jbara','Marilyn Sokol','Hechter Ubarry','Colin Quinn','Roger Serbagi','Alberto Vazquez','Anthony Crivello','Gus Mercurio','Alec Wilson','Maggie Blinco','Al Cerullo'],
screenplay:['Paul Hogan'],
production:['Paul Hogan','John Cornell','Jane Scott','Mark Turnbull'],
music:['Peter Best'],
camera:['Russell Boyd'],
cut:['David Stiven'],
sound:['John T. Reitz','Gregg Rudloff','David E. Campbell'],
costumes:['Norma Moriceau']},
{title:'Crocodile Dundee 3',
titleCZ:'Krokodýl Dundee v Los Angeles',
year:2001,
runtime:91,
countries:['Australia','USA'],
genres:['Comedy','Adventure'],
director:['Simon Wincer'],
actors:['Paul Hogan','Linda Kozlowski','Jere Burns','Jonathan Banks','Aida Turturro','Paul Rodriguez','Kaitlin Hopkins','Joe Michael Burke','Jim Davidson','John Billingsley','Jay Acovone','Rick Gonzalez','Kenneth Ransom','Nicholas Hammond','George Hamilton','Mike Tyson','Mark Adair-Rios','David Franklin','Clare Carey',"Morgan O'Neill",'Ronnie Marmo','Steven Grives','Gerry Skilton','Steve Rackman','Ernie Dingo','Matt Winston','Rhonda Aldrich','David Ngoombujarra','Alan Zitner','April Fitzsimmons','Brian Turk','Daryl Keith Roach','Matthew Kimbrough','Gregg Donovan','Buddy Daniels Friedman','Darko Tuscan','Keli Daniels','Chad S. Taylor','Alec Wilson','Peter Kent','Harvey Shain','David Bickford','Nick McKinless'],
screenplay:['Matt Berry','Eric Abrams'],
music:['Basil Poledouris'],
camera:['David Burr'],
cut:['Terry Blythe'],
sound:['Leonel Pedraza',"Terry O'Bright"],
scenography:['Leslie Binns','Lisette Thomas','Lisa Thompson'],
masks:['Anita Morgan','Michael Lorenz'],
costumes:['Marion Boyce']},
{title:'Dragonfly',
titleCZ:'Na křídlech vážky',
year:2002,
runtime:104,
countries:['USA','Germany'],
genres:['Sci-Fi','Thriller','Drama','Mystery'],
director:['Tom Shadyac'],
actors:['Kevin Costner','Susanna Thompson','Joe Morton','Ron Rifkin','Kathy Bates','Lisa Banes','Jay Thomas','Matt Craven','Leslie Hope','Peter Hansen','Heidi Swedberg','Oni Faida Lampley','L. Scott Caldwell','Linda Hunt','Jacob Vargas','Liza Weil','Justina Machado','Gillian Vigman','Andy Umberger','Samantha Smith','Rich Komenich',"Deirdre O'Connell",'Casey Biggs','Robert Bailey Jr.','Jacob Smith','Maz Jobrani','Jerome Butler','Lise Simms','Anne Betancourt','Nicholas Cascone','Paul Gutrecht','Nigel Gibbs','Mary Beth Fisher','Lina Patel','William Dennis Hunt','Judith Moreland','Joseph Will','Kent Faulcon','Matt Champagne','Monnae Michaell','John Lordan'],
screenplay:['Brandon Camp','Mike Thompson','David Seltzer'],
production:['Mark Johnson','Gary Barber','Roger Birnbaum','Tom Shadyac'],
music:['John Debney'],
camera:['Dean Semler'],
cut:['Don Zimmerman'],
sound:["Kevin O'Connell",'Greg P. Russell','Odin Benitez'],
scenography:['Linda DeScenna'],
masks:['David LeRoy Anderson','Nena Smarz','Jackie Dobbie','Suzi Ostos','Kerry Mendenhall','Thomas Floutz'],
costumes:['Judy L. Ruskin']},
{title:'Dracula',
titleCZ:'Dracula',
year:1992,
runtime:128,
countries:['USA'],
genres:['Horror','Romance','Drama','Thriller'],
director:['Francis Ford Coppola'],
actors:['Gary Oldman','Winona Ryder','Anthony Hopkins','Keanu Reeves','Richard E. Grant','Cary Elwes','Billy Campbell','Sadie Frost','Tom Waits','Monica Bellucci','Tatiana von Furstenberg','Daniel Newman','Ele Bardha','Jay Robinson','Tina Cote','Moreen Littrell','Maud Winchester','I.M. Hobson','Adamo Palladino','Nancy Linehan Charles','Heidi Schooler','Honey Lauren','Mark Borkowski','Robert Buckingham','Damon Stout'],
basedOn:['Bram Stoker'],
screenplay:['James V. Hart'],
production:['Francis Ford Coppola','Charles Mulvehill','Fred Fuchs'],
music:['Wojciech Kilar'],
camera:['Michael Ballhaus'],
cut:['Glen Scantlebury','Anne Goursaud','Nicholas C. Smith'],
sound:['David E. Stone'],
scenography:['Thomas E. Sanders'],
masks:['John Blake','Matthew W. Mungle','Greg Cannom','Mari Bloom','Keith VanderLaan'],
costumes:['Eiko Išioka']},
{title:'Van Helsing',
titleCZ:'Van Helsing',
year:2004,
runtime:131,
countries:['USA','Czechia'],
genres:['Fantasy','Adventure','Horror','Action','Mystery','Thriller'],
director:['Stephen Sommers'],
actors:['Hugh Jackman','David Wenham','Kate Beckinsale','Shuler Hensley','Richard Roxburgh','Will Kemp',"Kevin J. O'Connor",'Alun Armstrong','Josie Maran','Tom Fisher','Elena Anaya','Marek Vašut','Samuel West','Dana Morávková','Zuzana Ďurdinová','Silvia Colloca','Jaroslav Vízner','Ladislav Ondřej','Kacie Borrowman','Martin Klebba','Robbie Coltrane','Allison Queal','Jan Pavel Filipenský','Petr Vlasák'],
screenplay:['Stephen Sommers'],
production:['Bob Ducsay','Stephen Sommers'],
music:['Alan Silvestri'],
camera:['Allen Daviau'],
cut:['Bob Ducsay','Jim May','Kelly Matsumoto'],
sound:['David Parker'],
scenography:['Allan Cameron','Anna Pinnock'],
masks:['Jana Radilová','Eva Ungrová-Malíková','Steve La Porte','Nena Smarz','Brian Sipe','Stephen Kelley','Greg Cannom','Ozzy Alvarez','Steve La Porte','Alexei Dmitiew'],
costumes:['Jiřina Eisenhamerová','Carlo Poggioli','Gabriella Pescucci']},
{title:'We Children from Bahnhof Zoo',
titleCZ:'My děti ze stanice Zoo',
year:1981,
runtime:'Alternativní 125 min',
countries:['Germany'],
genres:['Drama','Biographic'],
director:['Uli Edel'],
actors:['Natja Brunckhorst','Thomas Haustein','Jens Kuphal','Rainer Woelk','Jan Georg Effler','Christiane Reichelt','Daniela Jaeger','Kerstin Richter','David Bowie','Eberhard Auriga','Peggy Bussieck','Lothar Chamski','Uwe Diderich','Renate Küster','Christiane Lechle','Ellen Esser'],
basedOn:['Kai Hermann','Horst Rieck','Christiane Felscherinow'],
screenplay:['Herman Weigel'],
production:['Hans Weth','Bernd Eichinger'],
music:['Jürgen Knieper'],
camera:['Jürgen Jürges','Justus Pankau'],
cut:['Jane Seitz'],
sound:['Lothar Mankewitz'],
masks:['Colin Arthur']},
{title:'Dawn of the Planet of the Apes',
titleCZ:'Úsvit planety opic',
year:2014,
runtime:125,
countries:['USA'],
genres:['Action','Adventure','Drama','Sci-Fi'],
director:['Matt Reeves'],
actors:['Andy Serkis','Jason Clarke','Gary Oldman','Keri Russell','Toby Kebbell','Kodi Smit-McPhee','Kirk Acevedo','Judy Greer','Nick Thurston','Terry Notary','Jon Eyez','Enrique Murciano','Karin Konoval',"Keir O'Donnell",'Kevin Rankin','Jocko Sims','Larramie Doc Shaw','Steven Wiig','Michelle DeVito','Lucky Johnson','Matthew James','Christopher Berry','Lombardo Boyar','J.D. Evermore','Deneen Tyler','Andrea Vittoria Alvarado','Michael Papajohn','Jon Arthur','John L. Armijo','Lee Ross','Anthony A. Kung','Mike Seal','Sergio Kato','Peyton Wich','Al Vicente'],
basedOn:['Pierre Boulle'],
screenplay:['Mark Bomback','Rick Jaffa','Amanda Silver'],
production:['Dylan Clark','Peter Chernin','Amanda Silver','Rick Jaffa'],
music:['Michael Giacchino'],
camera:['Michael Seresin'],
cut:['William Hoy','Stan Salfas'],
sound:['Douglas Murray','Andy Nelson','Will Files','Vinii Khullar'],
scenography:['James Chinlund','Amanda Moss Serino','Shane Vieau'],
masks:['Lisa Love','Vicki Syskakis','Vince Yoshida'],
costumes:['Melissa Bruning']},
{title:'The Ring',
titleCZ:'Kruh',
year:2002,
runtime:111,
countries:['USA','Japan'],
genres:['Thriller','Horror','Mystery'],
director:['Gore Verbinski'],
actors:['Naomi Watts','Martin Henderson','Brian Cox','David Dorfman','Jane Alexander','Lindsay Frost','Amber Tamblyn','Rachael Bella','Daveigh Chase','Shannon Cochran','Richard Lineback','Adam Brody','Alan Blumenfeld','Pauley Perrette','Sasha Barrese','Sara Rue','Joe Sabatino','Joe Chrest','Gary Carlos Cervantes','Art Frankel','Stephanie Erb','Lindsey Stoddart','Keith Campbell','David Povall','Michael Spound','Chuck Hicks','Ronald William Lawrence','Maury Ginsberg','Tess Hall','Catherine Paolone'],
basedOn:['Kódži Suzuki'],
screenplay:['Ehren Kruger','Hiroši Takahaši'],
production:['Walter F. Parkes','Laurie MacDonald'],
music:['Hans Zimmer'],
camera:['Bojan Bazelli'],
cut:['Craig Wood'],
sound:['Tim Holland','Lora Hirschberg','Tom Johnson'],
scenography:['Tom Duffield','Rosemary Brandenburg'],
masks:['Jean Ann Black','Jamie Kelman','Kazu Hiro','Rick Baker'],
costumes:['Jiřina Eisenhamerová','Julie Weiss']},
{title:'Rings',
titleCZ:'Kruhy',
year:2017,
runtime:102,
countries:['USA'],
genres:['Drama','Horror','Mystery'],
director:['F. Javier Gutiérrez'],
actors:['Matilda Anna Ingrid Lutz','Zach Roerig','Johnny Galecki',"Vincent D'Onofrio",'Aimee Teegarden','Lizzie Brocheré','Laura Wiggins','Bonnie Morgan','Patrick Walker','Alex Roe','Andrea Powell','Jill Jane Clements','Kayli Carter','Adam Fristoe','Ricky Muse','Rose Bianco','Daveigh Chase','Arjen Tuiten'],
basedOn:['Kódži Suzuki'],
screenplay:['Akiva Goldsman','David Loucka','Jacob Aaron Estes'],
production:['Walter F. Parkes','Laurie MacDonald'],
music:['Matthew Margeson'],
camera:['Sharone Meir'],
cut:["Jeremiah O'Driscoll",'Steve Mirkovich'],
sound:['Tony Lamberti'],
scenography:['Kevin Kavanaugh'],
masks:['Arjen Tuiten','Heather Morris'],
costumes:['Christopher Peterson']},
{title:'Kung Fu Panda',
titleCZ:'Kung Fu Panda',
year:2008,
runtime:92,
countries:['USA'],
genres:['Animation','Action','Comedy','Adventure'],
director:['John Stevenson','Mark Osborne'],
actors:['Jack Black','Dustin Hoffman','Angelina Jolie','Ian McShane','Seth Rogen','Lucy Liu','David Cross','Randall Duk Kim','James Hong','Dan Fogler','Michael Clarke Duncan','Jackie Chan','Wayne Knight','Kyle Gass','JR Reed','Mark Osborne','John Stevenson','Kent Osborne','Melissa Cobb','Laura Kightlinger','Jeremy Shipp'],
screenplay:['Jonathan Aibel','Glenn Berger'],
production:['Melissa Cobb'],
music:['Hans Zimmer','John Powell'],
camera:['Yong Duk Jhun'],
cut:['Clare Knight'],
sound:['Simon Ellegaard','Erik Aadahl','Ethan Van der Ryn','Andy Nelson','Anna Behlmer']},
{title:'Kung Fu Panda 2',
titleCZ:'Kung Fu Panda 2',
year:2011,
runtime:87,
countries:['USA'],
genres:['Animation','Action','Adventure','Comedy'],
director:['Jennifer Yuh'],
actors:['Jack Black','Angelina Jolie','Seth Rogen','Dustin Hoffman','Lucy Liu','James Hong','David Cross','Michelle Yeoh','Jean-Claude Van Damme','Victor Garber','Gary Oldman','James Woods','Jackie Chan','Danny McBride','Dennis Haysbert','Romy Rosemont','Maury Sterling','Alexandra Gold Jourden','Mike Bell','Jeremy Shipp'],
screenplay:['Jonathan Aibel','Glenn Berger'],
production:['Melissa Cobb'],
music:['Hans Zimmer','John Powell'],
cut:['Clare Knight','Maryann Brandon'],
sound:['Ethan Van der Ryn','Andy Nelson']},
{title:'Kung Fu Panda 3',
titleCZ:'Kung Fu Panda 3',
year:2016,
runtime:95,
countries:['USA','China'],
genres:['Animation','Fantasy','Adventure','Action','Comedy','Family'],
director:['Jennifer Yuh','Alessandro Carloni'],
actors:['Jack Black','Bryan Cranston','Dustin Hoffman','Angelina Jolie','J.K. Simmons','Seth Rogen','Lucy Liu','David Cross','Kate Hudson','Jackie Chan','James Hong','Wayne Knight','Randall Duk Kim','Ava Acres','Willie Geist','Al Roker','Shiloh Jolie-Pitt','Jean-Claude Van Damme','Mick Wingert','Barbara Dirickson'],
screenplay:['Jonathan Aibel','Glenn Berger'],
production:['Melissa Cobb'],
music:['Hans Zimmer'],
cut:['Clare Knight'],
sound:['Paul Massey','Erik Aadahl','Ethan Van der Ryn','Doug Hemphill','Andy Nelson','Anna Behlmer']},
{title:'Kung Fu Panda 4',
titleCZ:'Kung Fu Panda 4',
year:2024,
runtime:'024',
countries:['USA','China'],
genres:['Animation','Action','Adventure'],
director:['Mike Mitchell'],
actors:['Jack Black','Awkwafina','Viola Davis','Dustin Hoffman','James Hong','Bryan Cranston','Ian McShane','Ke Huy Quan'],
screenplay:['Jonathan Aibel','Glenn Berger'],
production:['Rebecca Huntley'],
music:['Steve Mazzaro','Hans Zimmer'],
cut:['Christopher Knights'],
sound:['Erik Aadahl','Paul Massey','Greg P. Russell','Julian Slater','Ethan Van der Ryn']},
{title:'Match Point',
titleCZ:'Match Point - Hra osudu',
year:2005,
runtime:124,
countries:['UK','Ireland','Luxembourg'],
genres:['Drama','Romance','Crime','Thriller'],
director:['Woody Allen'],
actors:['Jonathan Rhys Meyers','Scarlett Johansson','Emily Mortimer','Alexander Armstrong','Matthew Goode','Brian Cox','Penelope Wilton','Colin Salmon','Steve Pemberton','Ewen Bremner','James Nesbitt','Margaret Tyzack','Rupert Penry-Jones','Layke Anderson','Miranda Raison','Georgina Chapman','Zoe Telford',"Anthony O'Donnell",'Selina Cadell','Scott Handy','Simon Kunz','Mark Gatiss','Geoffrey Streatfeild'],
screenplay:['Woody Allen'],
production:['Letty Aronson'],
camera:['Remi Adefarasin'],
cut:['Alisa Lepselter'],
sound:['Lee Dichter'],
scenography:['Jim Clay'],
masks:['Sharon Martin'],
costumes:['Jill Taylor']},
{title:'Sweet November',
titleCZ:'Listopadová romance',
year:2001,
runtime:116,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:["Pat O'Connor"],
actors:['Keanu Reeves','Charlize Theron','Jason Isaacs','Greg Germann','Liam Aiken','Robert Joy','Lauren Graham','Michael Rosenbaum','Frank Langella','Jason Kravits','Ray Baker','David Fine','Kelvin Han Yee','Presciliana Esparolini','Joe Bellan','June Carryl','Diana C. Weng','Kathy Garver'],
screenplay:['Kurt Voelker','Herman Raucher'],
production:['Elliott Kastner','Erwin Stoff','Steven Reuther'],
music:['Christopher Young'],
camera:['Edward Lachman'],
cut:['Anne V. Coates'],
sound:['Steve Pederson','Rick Hart','Daniel J. Leahy'],
scenography:['Naomi Shohan','Bob Kensinger'],
masks:['Peter Robb-King','David Atherton'],
costumes:['Shay Cunliffe']},
{title:'Kill Bill: Vol. 1',
titleCZ:'Kill Bill',
year:2003,
runtime:111,
countries:['USA','Japan','China'],
genres:['Action','Crime','Thriller'],
director:['Quentin Tarantino'],
actors:['Uma Thurman','Lucy Liu','Vivica A. Fox','Daryl Hannah','David Carradine','Michael Madsen','Julie Dreyfus','Čiaki Kurijama','Sonny Čiba','Gordon Liu','Michael Parks','Michael Bowen','Džun Kunimura','Kendži Óba','Juki Kazamacuri','James Parks','Sakiči Sató','Jonathan Loughran','Jošijuki Morišita','Kazuki Kitamura','Jódži Tanaka','Issei Takahaši','Só Jamanaka','Džuri Manase','Akadži Maro','Šun Sugata','Ambrosia Kelley','Ai Maeda','Naomi Kusumi','Hikaru Midorikawa','Christopher Allen Nelson','Quentin Tarantino'],
screenplay:['Quentin Tarantino'],
production:['Lawrence Bender'],
music:['RZA'],
camera:['Robert Richardson'],
cut:['Sally Menke'],
sound:['Wylie Stateman','Michael Minkler','Myron Nettinga','Mark Ulano'],
scenography:['Jóhei Taneda','David Wasco','Jošihito Akacuka','Sandy Reynolds-Wasco'],
masks:['Heba Thorisdottir','Scott Patton','Howard Berger','Greg Nicotero','Christopher Allen Nelson'],
costumes:['Catherine Marie Thomas','Kumiko Ogawa']},
{title:'Kill Bill: Vol. 2',
titleCZ:'Kill Bill 2',
year:2004,
runtime:137,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Quentin Tarantino'],
actors:['Uma Thurman','David Carradine','Michael Madsen','Daryl Hannah','Gordon Liu','Lucy Liu','Vivica A. Fox','Michael Parks','Bo Svenson','Jeannie Epper','Samuel L. Jackson','Reda Beebe','Sid Haig','Larry Bishop','Laura Cayouette','Claire Smithies','Caitlin Keats','Perla Haney-Jardine','Julie Dreyfus','Zoë Bell','Lawrence Bender','Quentin Tarantino','Jódži Tanaka','Džun Kunimura','Sakiči Sató','Issei Takahaši','Ambrosia Kelley','James Parks','Jonathan Loughran','Michael Bowen','Stephanie L. Moore','Akadži Maro','Jošijuki Morišita','Juki Kazamacuri','Clark Middleton','Christopher Allen Nelson','Shana Stein','Venessia Valentino'],
screenplay:['Quentin Tarantino'],
production:['Lawrence Bender'],
music:['Robert Rodriguez'],
camera:['Robert Richardson'],
cut:['Sally Menke'],
sound:['Michael Minkler','Wylie Stateman','Myron Nettinga','Mark Ulano'],
scenography:['David Wasco','Sandy Reynolds-Wasco'],
masks:['Heba Thorisdottir','Camille Calvet','Howard Berger','Greg Nicotero','Christopher Allen Nelson'],
costumes:['Catherine Marie Thomas']},
{title:'Blue Jasmine',
titleCZ:'Jasmíniny slzy',
year:2013,
runtime:98,
countries:['USA'],
genres:['Drama','Comedy'],
director:['Woody Allen'],
actors:['Cate Blanchett','Alec Baldwin','Sally Hawkins','Bobby Cannavale','Andrew Dice Clay','Peter Sarsgaard','Louis C.K.','Alden Ehrenreich','Michael Stuhlbarg','Max Casella','Annie McNamara','Charlie Tahan','Tammy Blanchard','Tom Kemp','Jaden Alexander','Irit Levi','Glenn Fleshler','Jessiqa Pace','Nkechi','Allene Hebert','Barbara Garrick','Joe Bellan','Peggy Sandow','Christopher Greene','Ted Neustadt'],
screenplay:['Woody Allen'],
production:['Letty Aronson','Stephen Tenenbaum','Edward Walson'],
camera:['Javier Aguirresarobe'],
cut:['Alisa Lepselter'],
sound:['Lee Dichter'],
scenography:['Santo Loquasto'],
costumes:['Suzy Benzinger']},
{title:'The Crimson Rivers',
titleCZ:'Purpurové řeky',
year:2000,
runtime:102,
countries:['France'],
genres:['Crime','Mystery','Thriller'],
director:['Mathieu Kassovitz'],
actors:['Jean Reno','Vincent Cassel','Nadia Fares','Dominique Sanda','Karim Belkhadra','Jean-Pierre Cassel','Didier Flamand','François Levantal','Francine Bergé','Philippe Nahon','Laurent Lafitte','Nicky Naudé','Tonio Descanvelle','Françoise Loreau','Vincent Tulli','Nicolas Koretzky','Sami Zitouni','Christophe Rossignon','Dominique Bettenfeld'],
basedOn:['Jean-Christophe Grangé'],
screenplay:['Jean-Christophe Grangé','Mathieu Kassovitz'],
production:['Alain Goldman'],
music:['Bruno Coulais'],
camera:['Thierry Arbogast'],
cut:['Maryline Monthieux'],
sound:['Vincent Tulli','Cyril Holtz','Philippe Amouroux'],
scenography:['Thierry Flamand'],
masks:['Nathalie Tissier'],
costumes:['Julie Mauduech']},
{title:'Godzilla 1985',
titleCZ:'Návrat Godzilly',
year:1985,
runtime:87,
countries:['Japan','USA'],
genres:['Action','Drama','Horror','Sci-Fi'],
director:['Kódži Hašimoto','R. J. Kizer'],
actors:['Taketoši Naitó','Kei Sató','Nobuo Kaneko','Raymond Burr','Šinpei Hajašija','Kenpačiró Sacuma','Tecuja Takeda','Warren J. Kemmerling','Keidžu Kobajaši','Šin Takuma','Eitaró Ozawa','Jasuko Sawaguči','Džunkiči Orimoto','Ken Tanaka','Kódži Išizaka','Kunio Murai','Šigeo Kató','Justin Gocke'],
basedOn:['Tomojuki Tanaka'],
screenplay:['Hideiči Nagahara','Tony Randel','Lisa Tomei'],
production:['Tomojuki Tanaka','Norio Hajaši'],
music:['Reidžiró Koroku'],
cut:['Jošitami Kuroiwa'],
sound:['Joseph D. Citarella']},
{title:'Godzilla',
titleCZ:'Godzilla',
year:2014,
runtime:123,
countries:['USA','Japan'],
genres:['Action','Adventure','Thriller','Sci-Fi'],
director:['Gareth Edwards'],
actors:['Aaron Taylor-Johnson','Bryan Cranston','Elizabeth Olsen','Juliette Binoche','David Strathairn','Ken Watanabe','Al Sapienza','Sally Hawkins','Brian Markinson','Richard T. Jones','Victor Rasuk','CJ Adams','Carson Bolde','Eli Goree','Anthony Konechny','Eric Keenleyside','Jodie Yee','Ty Olsson','Monique Ganderton','Patrick Sabongui','Oliver Drawson','Jason Furukawa','Jill Teed','Ed Heavey','Primo Allon','Jesse Reid','Darren Dolynski','Chris Shields','Toby Levins','Matthew Hoglie','Charles Edward Bae','Peter Kawasaki','Leif Havdale','Bill Marchant','Lane Edwards','James Pizzinato','Melody B. Choi',"Kevin O'Grady",'Ken Jamamura','Warren Takeuchi',"John O'Brien",'Josh Cowdery','Rich Paul','Marci T. House','Keo Woolford','Yukari Komatsu','Kurt Max Runte','Gardiner Millar','Dee Jay Jackson','Dalias Blake','Michael Patrick Denis','James Kot','P. Lynn Johnson','David Ross Paterson','Luc Roderique','Erik Aadahl','Stephen Stanton','Ian Gregson','Dean Redman','Eric Breker'],
screenplay:['Max Borenstein','Dave Callaham','Frank Darabont','David S. Goyer'],
production:['Brian Rogers','Mary Parent','Jon Jashni','Thomas Tull','Bob Ducsay'],
music:['Alexandre Desplat'],
camera:['Seamus McGarvey'],
cut:['Bob Ducsay'],
sound:['Gregg Landaker','Erik Aadahl','Ethan Van der Ryn'],
scenography:['Owen Paterson'],
masks:['Victoria Down','Diana Acrey','Toby Lindala','Vince Yoshida'],
costumes:['Sharen Davis']},
{title:'A Walk in the Woods',
titleCZ:'A Walk in the Woods',
year:2015,
runtime:98,
countries:['USA'],
genres:['Adventure','Comedy','Drama'],
director:['Ken Kwapis'],
actors:['Robert Redford','Nick Nolte','Emma Thompson','Nick Offerman','Kristen Schaal','Mary Steenburgen','R. Keith Harris','Alex Van','Randall Newsome','Rachel Woodhouse','Danny Vinson','Susan McPhail','Derek Krantz','Sandra Ellis Lafferty','Chandler Head','Hayley Lovitt','Tucker Meek','Chrystee Pharris','Katie Groshong','Walter Hendrix III','Erick Wofford','Andrew Vogel'],
basedOn:['Bill Bryson'],
screenplay:['Michael Arndt','Bill Holderman'],
production:['Bill Holderman','Robert Redford','Chip Diggins'],
music:['Nathan Larson'],
camera:['John Bailey'],
cut:['Carol Littleton','Julie Garces'],
sound:['Ron Bochar'],
scenography:['Gae S. Buckley','Lynne Mitchell'],
masks:['Brian McManus','Joani Yarbrough'],
costumes:['Leigh Leverett']},
{title:'The Sea of Trees',
titleCZ:'Moře stromů',
year:2015,
runtime:110,
countries:['USA'],
genres:['Drama'],
director:['Gus Van Sant'],
actors:['Matthew McConaughey','Naomi Watts','Ken Watanabe','Bruce Norris','Richard Levine','Katie Aselton','Nada Despotovich','James Saito','Hjunri','Joseph Baken','Jordan Gavaris','Anna Friedman','Ryoko Seta','Owen Burke','Jeffrey Corazzini','Rosemary Howard','Jimi Stanton','Ami Haruna'],
screenplay:['Chris Sparling'],
production:['F. Gary Gray','Chris Sparling','Gil Netter','Ken Kao'],
music:['Mason Bates'],
camera:['Kasper Tuxen'],
cut:['Pietro Scalia'],
sound:['Beau Borders','Ai-Ling Lee','Deb Adair'],
scenography:['Alex DiGerlando','Jeanette Scott'],
masks:['Matthew W. Mungle'],
costumes:['Danny Glicker']},
{title:'Mud',
titleCZ:'Bahno z Mississippi',
year:2012,
runtime:124,
countries:['USA'],
genres:['Drama'],
director:['Jeff Nichols'],
actors:['Matthew McConaughey','Reese Witherspoon','Tye Sheridan','Jacob Lofland','Sam Shepard','Ray McKinnon','Sarah Paulson','Michael Shannon','Joe Don Baker','Paul Sparks','Stuart Greer','Kristy Barrington','Douglas Ligon','Michael Abbott Jr.','Bonnie Sturdivant'],
screenplay:['Jeff Nichols'],
production:['Sarah Green','Aaron Ryder'],
music:['David Wingo'],
camera:['Adam Stone'],
cut:['Julie Monroe'],
sound:['Brandon Proctor','Will Files'],
scenography:['Richard A. Wright','Beauchamp Fontaine'],
masks:['Matthew W. Mungle'],
costumes:['Kari Perkins']},
{title:'Where the Crawdads Sing',
titleCZ:'Kde zpívají raci',
year:2022,
runtime:125,
countries:['USA'],
genres:['Drama','Mystery'],
director:['Olivia Newman'],
actors:['Daisy Edgar-Jones','Taylor John Smith','Harris Dickinson','David Strathairn','Michael Hyatt','Sterling Macer Jr.','Logan Macrae','Bill Kelly',"Ahna O'Reilly",'Garret Dillahunt','Jojo Regina','Luke David Blumm','Blue Clarke','Will Bundon','Jayson Warner Smith','Dane Rhodes','Eric Ladin','Charlie Talbert','Billy Slaughter','Caroline Cole','Jerri Tubbs','Sarah Durn','Joe Chrest','Sharon Landry','Don Stallings','Taylor Shurte'],
basedOn:['Delia Owens'],
screenplay:['Lucy Alibar'],
production:['Reese Witherspoon','Lauren Levy Neustadter'],
music:['Mychael Danna'],
camera:['Polly Morgan'],
cut:['Alan Edward Bell'],
sound:["Kevin O'Connell",'Tony Lamberti'],
scenography:['Sue Chan','Alice Baker'],
masks:['Stacey Perry'],
costumes:['Mirren Gordon-Crozier']},
{title:'Jack Reacher: Never Go Back',
titleCZ:'Jack Reacher: Nevracej se',
year:2016,
runtime:116,
countries:['USA','China'],
genres:['Action','Crime','Drama','Mystery','Thriller'],
director:['Edward Zwick'],
actors:['Tom Cruise','Cobie Smulders','Robert Knepper','Aldis Hodge','Danika Yarosh','Patrick Heusinger','Holt McCallany','Christopher Heskey','Jason Douglas','Michael Papajohn','Billy Slaughter','Sabrina Gennarino','Rachel Varela','Divine Prince Ty Emmecca','Bob Walker','Juan Gaspard','John L. Armijo','Sean Boyd','Hunter Burke','Chris Angerdina','Julia Holter','Teri Wyble','Judd Lormand','Lee Child','Anthony Molinari','Abbie Gayle','Ninja N. Devoe','Nicole Barré','Ben VanderMey','Austin Hébert','Rhonda Laizer','Jared Bankens','Bobby Gilchrist','James Michael Smith','Jesse Malinowski','Sarah Kate Allsup','Kyler Porche','Ryan Broussard','Lisha Wheeler'],
basedOn:['Lee Child'],
screenplay:['Richard Wenk','Edward Zwick','Marshall Herskovitz'],
production:['Tom Cruise','Don Granger','Christopher McQuarrie'],
music:['Henry Jackman'],
camera:['Oliver Wood'],
cut:['Billy Weber'],
sound:['Andy Nelson','Oleg Kulchytskyi','Mark P. Stoeckinger'],
scenography:['Clay A. Griffith','Lisa K. Sessions','Bryan Felty'],
masks:['Sarah Monzani','Amy Wood','Jack Lazzaro'],
costumes:['Lisa Lovaas']},
{title:'Jack Reacher',
titleCZ:'Jack Reacher: Poslední výstřel',
year:2012,
runtime:125,
countries:['USA'],
genres:['Action','Crime','Thriller','Mystery'],
director:['Christopher McQuarrie'],
actors:['Tom Cruise','Rosamund Pike','Richard Jenkins','Werner Herzog','Jai Courtney','David Oyelowo','Vladimir Sizov','Robert Duvall','Alexia Fast','Joseph Sikora','Michael Raymond-James','Scott A. Martin','Joshua Elijah Reese','John W. Iwanonkiw','Nicole Forester','Lee Child','Tommy LaFitte','Josh Helman','Shane Callahan','Ron Pucillo','Mark Falvo','Jason McCune','Jace Jeanes','Susan Angelo','James Martin Kelly','Jordan Trovillion','Dylan Kussman','David Whalen','Sophie Guest','Lissy Gulick','Sara Lindsey','Dave Petti','Tammy Felice','Julia Yorks','Tyler Courtad','Amy Morse','Mike Stern'],
basedOn:['Lee Child'],
screenplay:['Christopher McQuarrie'],
production:['Tom Cruise','Gary Levinsohn','David Ellison','Don Granger','Paula Wagner'],
music:['Joe Kraemer'],
camera:['Caleb Deschanel'],
cut:['Kevin Stitt'],
sound:['Anna Behlmer','Mark P. Stoeckinger'],
scenography:['Jim Bissell','Gregory A. Weimerskirch','Douglas A. Mowat'],
masks:['Trefor Proud','Sarah Monzani'],
costumes:['Susan Matheson']},
{title:'Indiana Jones and the Dial of Destiny',
titleCZ:'Indiana Jones a nástroj osudu',
year:2023,
runtime:154,
countries:['USA'],
genres:['Adventure','Action','Drama','Sci-Fi'],
director:['James Mangold'],
actors:['Harrison Ford','Phoebe Waller-Bridge','Mads Mikkelsen','Boyd Holbrook','Antonio Banderas','Toby Jones','John Rhys-Davies','Thomas Kretschmann','Shaunette Renée Wilson','Corrado Invernizzi','Nasser Memarzia','Olivier Richters','Mark Killeen','Alaa Safi','Martin McDougall','Jill Winternitz','Alton Fitzgerald White','Alfonso Mandia','Karen Allen','Ethann Isidore','Aron von Andrian'],
screenplay:['James Mangold','David Koepp','Jez Butterworth','John-Henry Butterworth'],
production:['Kathleen Kennedy','Frank Marshall','Simon Emanuel'],
music:['John Williams'],
camera:['Phedon Papamichael'],
cut:['Andrew Buckland','Michael McCusker','Dirk Westervelt'],
sound:['Donald Sylvester','Gary Rydstrom','Paul Massey','David Giammarco'],
scenography:['Adam Stockhausen','Anna Pinnock'],
masks:['Karen Cohen','Frances Hannon','Bill Corso','Chiara Ugolini','Sarah Nuth','Debbie Black'],
costumes:['Joanna Johnston']},
{title:'Indiana Jones and the Kingdom of the Crystal Skull',
titleCZ:'Indiana Jones a Království křišťálové lebky',
year:2008,
runtime:122,
countries:['USA'],
genres:['Adventure','Action','Drama','Sci-Fi'],
director:['Steven Spielberg'],
actors:['Harrison Ford','Karen Allen','Shia LaBeouf','Cate Blanchett','John Hurt','Ray Winstone','Jim Broadbent','Andrew Divoff','Alan Dale','Sasha Spielberg','Pasha D. Lychnikoff','Igor Žižikin','Neil Flynn','Jonathan Lomma','Ilia Volok','Martin Dew','Dimitri Diatchenko','Audi Resendez','Robert Baker','Errol Sack','Chris Bryant','Helena Barrett','Steven A. Miller','Carlos Linares','Joel Stoffer','Ted Grossman','V.J. Foster','Chet Hanks','Janet Lopez','Larry Eudene'],
screenplay:['David Koepp'],
production:['Frank Marshall'],
music:['John Williams'],
camera:['Janusz Kamiński'],
cut:['Michael Kahn'],
sound:['Richard Hymns','Andy Nelson','Gary Rydstrom','Christopher Scarabosio'],
scenography:['Guy Hendrix Dyas','Larry Dias','Luke Freeborn'],
masks:['Kevin Haney','Bill Corso','Nikoletta Skarlatos','Jamie Kelman','Kenny Niederbaumer','Ken Diaz','Matthew W. Mungle','Cathrine A. Marcotte','Morag Ross','Mark Landon','Tomasina Smith','Sasha Cummins','Kelcey Fry','Chris Burgoyne'],
costumes:['Mary Zophres']},
{title:'Brothers',
titleCZ:'Bratři',
year:2023,
runtime:135,
countries:['Czechia','Slovakia'],
genres:['Adventure','History','Drama'],
director:['Tomáš Mašín'],
actors:['Oskar Hes','Jan Nedbal','Tatiana Dyková','Adam Ernest','Stefan Konarske','Karolína Lea Nováková','Matěj Hádek','Matyáš Řezníček','Tony Mašek','Alžběta Malá','Veronika Bellová','Filip Teller','Václav Neužil ml.','Karel Dobrý','Lucie Ingrová','Jan Lyčka','Zbyšek Humpolec','Kateřina Jebavá','Daniela Kolářová','Jan Jankovský','Jiří Imlauf','Jan Teplý ml.','Adam Langer'],
screenplay:['Marek Epstein'],
production:['Petr Bílek','Zuzana Mistríková','Ľubica Orechovská'],
music:['Karel Havlíček'],
camera:['Friede Clausz'],
cut:['Petr Turyna'],
sound:['David Titěra','Viktor Ekrt'],
scenography:['Milan Býček'],
masks:['Adéla Anděla Bursová'],
costumes:['Ján Kocman']},
{title:'Sonic the Hedgehog 2',
titleCZ:'Ježek Sonic 2',
year:2022,
runtime:122,
countries:['USA','Japan'],
genres:['Action','Adventure','Comedy','Family','Sci-Fi'],
director:['Jeff Fowler'],
actors:['Ben Schwartz','James Marsden','Jim Carrey','Tika Sumpter','Idris Elba','Natasha Rothwell','Adam Pally','Shemar Moore','Lee Majdoub',"Colleen O'Shaughnessey",'Melody Nosipho Niemann','Tom Butler','Scott Patey','Leif Havdale','Johnson Phan','Sook Hexamer','Mike Mitchell','Elizabeth Bowen','Shawn Stewart','Barry Nerling','Ted Barba','Quinn Early','Sarah Surh','Paul Lazenby','Joel Hyrland','Zac Vran','Krista Alvarez'],
screenplay:['Pat Casey','Josh Miller','John Whittington'],
production:['Neal H. Moritz','Toru Nakahara','Toby Ascher','Hitoši Okuno'],
music:['Junkie XL'],
camera:['Brandon Trost'],
cut:['Jim May'],
sound:['Erik Aadahl','Ethan Van der Ryn','Anna Behlmer'],
scenography:['Luke Freeborn','David Clarke'],
costumes:['Debra McGuire']},
{title:'Stopmotion',
titleCZ:'Stopmotion',
year:2023,
runtime:93,
countries:['UK'],
genres:['Horror'],
director:['Robert Morgan'],
actors:['Aisling Franciosi','Stella Gonet','Tom York','Caoilinn Springall','James Swanton'],
screenplay:['Robert Morgan'],
camera:['Léo Hinstin'],
cut:['Aurora Vögeli'],
sound:['Ben Baird'],
costumes:['Saffron Cullane']},
{title:'Imaginary',
titleCZ:'Neviditelné zlo',
year:2024,
runtime:104,
countries:['USA'],
genres:['Horror'],
director:['Jeff Wadlow'],
actors:['DeWanda Wise','Betty Buckley','Veronica Falcón','Dane DiLiegro','Matthew Sato','Pyper Braun','Tom Payne','Taegen Burns'],
screenplay:['Jeff Wadlow','Greg Erb','Bryce McGuire','Jason Oremland'],
production:['Jason Blum','Paul Uddo','Jeff Wadlow'],
music:['Bear McCreary'],
camera:['James McMillan'],
cut:['Sean Albertson'],
scenography:['Meghan C. Rogers'],
costumes:['Eulyn Colette Hufkie']},
{title:'Road House',
titleCZ:'Road House',
year:1989,
runtime:114,
countries:['USA'],
genres:['Action','Crime','Drama','Thriller'],
director:['Rowdy Herrington'],
actors:['Patrick Swayze','Kelly Lynch','Sam Elliott','Ben Gazzara','Marshall R. Teague','Kevin Tighe','John Doe','Kathleen Wilhoite','Gary Hudson','Anthony De Longis','Tiny Ron','Keith David','Red West','Sunshine Parker','Tito Larriva','Patricia Tallman','Terry Nemeroff','Benny Urquidez','Laura Albert','Jeff Healey','Joe Unger','Julie Michaels','Michael Rider','Christopher Collins','Amelia Kinkade','John William Young','Henry Kingi','Kym Malin','James McIntire','Tom Finnegan','Roger Hewlett','Travis McKenna','Terry Funk'],
screenplay:['Hilary Henkin','David Lee Henry'],
production:['Joel Silver'],
music:['Michael Kamen'],
camera:['Dean Cundey'],
cut:['John F. Link','Frank J. Urioste'],
sound:['Bud Maffett'],
scenography:['Philip Leonard'],
masks:['Scott H. Eddo'],
costumes:['Marilyn Vance']},
{title:'ghost buster:',
titleCZ:'Ghost Buster',
year:1952,
runtime:18,
countries:['USA'],
genres:['Short','Comedy'],
actors:['Carol Hughes','Donald MacBride','Donna Martell','George Wallace','Barbara Pepper','Edward Clark','Jim Hayward','Gil Lamb'],
screenplay:['Elwood Ullman'],
camera:['Frank Redman'],
cut:['Edward W. Williams'],
scenography:['Feild M. Gray']},
{title:'Now You See Me 2',
titleCZ:'Podfukáři 2',
year:2016,
runtime:129,
countries:['USA','France'],
genres:['Mystery','Adventure','Crime','Action','Thriller','Comedy'],
director:['Jon M. Chu'],
actors:['Jesse Eisenberg','Mark Ruffalo','Woody Harrelson','Lizzy Caplan','Dave Franco','Daniel Radcliffe','Morgan Freeman','Michael Caine','Sanaa Lathan','Jay Chou','Justine Wachsberger','Tsai Chin','Lee Nicholas Harris','David Warshofsky','Lasco Atkins','Amber Elizabeth','Clem So','Mark Haldor','Miroslav Zaruba','Attila G. Kerekes','Kornelia Horvath','Varada Sethu','Anthony Milton','Teresa Mahoney','Pamela Betsy Cooper','Greg Brummel','Missy Malek','Isla Fisher','Henry Lloyd-Hughes','Dino Fetscher','Xuan Liu','Annarie Boor','Daniel Stisen','Michael Cooke','Simon Connolly'],
screenplay:['Ed Solomon','Peter Chiarelli'],
production:['Alex Kurtzman','Roberto Orci','Bobby Cohen'],
music:['Brian Tyler'],
camera:['Peter Deming'],
cut:['Stan Salfas'],
sound:['Will Files','Andy Koyama'],
scenography:['Sharon Seymour','Judy Farr','Stephen Swain'],
masks:['Karen Cohen','Nicky Knowles','Nora Robertson','Mark Coulier','Frances Hannon','Rebecca Cole','Jessica Brooks','Siân Miller','Josh Weston'],
costumes:['Anna Biedrzycka-Sheppard']},
{title:'Arthur the King',
titleCZ:'Nezlomní',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Adventure','Drama'],
director:['Simon Cellan Jones'],
actors:['Mark Wahlberg','Nathalie Emmanuel','Simu Liu','Michael Landes','Paul Guilfoyle','Rob Collins','Viktor Åkerblom','Zamantha Díaz','Luis del Valle','Roger Wasserman','Angie Gisèle'],
basedOn:['Mikael Lindnord'],
screenplay:['Michael Brandt'],
production:['Mark Canton','Courtney Solomon','Tucker Tooley','Tessa Tooley'],
music:['Kevin Matley'],
camera:['Jacques Jouffret'],
cut:['Gary D. Roach'],
sound:['Christian T. Cooke'],
scenography:['Mailara Santana','Fernando Carrion','María Fernanda Sabogal'],
costumes:['Carol Ramsey']},
{title:'Wanted',
titleCZ:'Wanted',
year:2008,
runtime:110,
countries:['USA','Germany'],
genres:['Action','Crime','Thriller'],
director:['Timur Bekmambetov'],
actors:['James McAvoy','Morgan Freeman','Angelina Jolie','Terence Stamp','Thomas Kretschmann','Common','Kristen Hager','Marc Warren',"David O'Hara",'Konstantin Chabenskij','Dato Bachtadze','Chris Pratt','Lorna Scott','Sophiya Haque','Brian Caspe',"Mark O'Neal",'Scarlett Sperduto','Claudia DiBiccari','Larry Nazimek'],
basedOn:['Mark Millar'],
screenplay:['Michael Brandt','Derek Haas','Chris Morgan','Mark Millar'],
production:['Jim Lemley','Marc Platt','Iain Smith','Jason Netter'],
music:['Danny Elfman'],
camera:['Mitchell Amundsen'],
cut:['David Brenner'],
sound:['Wylie Stateman','Frank A. Montaño'],
scenography:['John Myhre','Richard Roberts'],
masks:['René Stejskal','Bohumil Sobotka','Frances Hannon'],
costumes:['Varvara Avdyushko']},
{title:'Godzilla x Kong: The New Empire',
titleCZ:'Godzilla x Kong: Nové imperium',
year:2024,
runtime:114,
countries:['USA'],
genres:['Action','Sci-Fi','Thriller'],
director:['Adam Wingard'],
actors:['Dan Stevens','Alex Ferns','Brian Tyree Henry','Rebecca Hall','Rachel House','Fala Chen','Kaylee Hottle'],
screenplay:['Simon Barrett','Terry Rossio','Jeremy Slater'],
production:['Eric McLeod','Alex Garcia','Mary Parent'],
music:['Junkie XL'],
cut:['Josh Schaeffer'],
scenography:['Thomas S. Hammock','Mark Dawson']},
{title:'Captain America: Civil War',
titleCZ:'Captain America: Občanská válka',
year:2016,
runtime:147,
countries:['USA','Germany'],
genres:['Action','Adventure','Sci-Fi'],
director:['Anthony Russo','Joe Russo'],
actors:['Chris Evans','Robert Downey Jr.','Scarlett Johansson','Sebastian Stan','Anthony Mackie','Don Cheadle','Jeremy Renner','Chadwick Boseman','Paul Bettany','Elizabeth Olsen','Paul Rudd','Emily VanCamp','Tom Holland','Daniel Brühl','Frank Grillo','William Hurt','Martin Freeman','Marisa Tomei','John Kani','John Slattery','Hope Davis','Alfre Woodard','Gene Farber','Florence Kasumba','Sven Hönig','Oli Bigalke','Rafael Banasik','Katie Amess','Brett Gentile','Beniamino Brogi','Silvina Buchbauer','Damion Poitier','Jim Rash','Stan Lee','Kerry Condon','Julianna Guill','Surely Alvelo','Ray Sahetapy','Chris Theisinger','Alexander Yassin','Peter Luis Zimmerman','Jane Wu','Robert Clotworthy','Cornell John','John Curran','Jonathan Yaskoff','Jessica Walther-Gabory','Adrian Lockett','Chris Jai Alex','Jessica Bell','Amelia Morck','Shijia Jin','Jimmy Star','Yi Long','Erick Wofford','Jason Shwartz','Al Cerullo'],
basedOn:['Jack Kirby','Joe Simon'],
screenplay:['Christopher Markus','Stephen McFeely'],
production:['Kevin Feige','Henning Molfenter','Christoph Fisser','Charlie Woebcken'],
music:['Henry Jackman'],
camera:['Trent Opaloch'],
cut:['Jeffrey Ford','Matthew Schmidt'],
sound:['Juan Peralta','Daniel Laurie','Shannon Mills','Petur Hliddal','Tom Johnson'],
scenography:['Owen Paterson','Ronald R. Reiss','Stephan O. Gessler'],
masks:['John Blake','Allan A. Apone','Leay Cangelosi','Louisa V. Anthony','Camille Friend'],
costumes:['Judianna Makovsky']},
{title:'abigail',
titleCZ:'Abigail',
year:2014,
runtime:'014',
countries:['Czechia'],
genres:['Short'],
director:['Lenka Pipková'],
actors:['Jitka Sedláčková','Tomáš Hanák','Martin Cikán'],
screenplay:['Lenka Pipková']},
{title:'Monkey Man',
titleCZ:'Opičí muž',
year:2024,
runtime:113,
countries:['USA','Canada'],
genres:['Action','Thriller'],
director:['Dev Patel'],
actors:['Dev Patel','Sharlto Copley','Sobhita Dhulipala','Pitobash Tripathy','Vipin Sharma','Sikander Kher','Fahad Scale'],
screenplay:['Paul Angunawela','John Collee','Dev Patel'],
production:['Basil Iwanyk','Erica Lee','Dev Patel','Jordan Peele'],
music:['Volker Bertelmann'],
camera:['Sharone Meir'],
cut:['Chris Gill'],
scenography:['Yasmin Sethi'],
costumes:['Divvya Gambhir','Nidhi Gambhir']},
{title:'Challengers',
titleCZ:'Rivalové',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Drama','Romance','Sport'],
director:['Luca Guadagnino'],
actors:['Zendaya',"Josh O'Connor",'Mike Faist','Faith Fay','A.J. Lister'],
screenplay:['Justin Kuritzkes'],
production:['Luca Guadagnino','Amy Pascal'],
camera:['Sayombhu Mukdeeprom'],
cut:['Marco Costa'],
sound:['Craig Berkey'],
scenography:['Merissa Lombardo','Jasmine Cho']},
{title:'The Tourist',
titleCZ:'Cizinec',
year:2010,
runtime:103,
countries:['USA','France','Italy','UK'],
genres:['Mystery','Thriller','Action','Adventure','Romance','Crime'],
director:['Florian Henckel von Donnersmarck'],
actors:['Johnny Depp','Angelina Jolie','Rufus Sewell','Paul Bettany','Clément Sibony','Bruno Wolkowitch','François Vincentelli','Jean-Marie Lamour','Timothy Dalton','Steven Berkoff','Alessio Boni','Julien Baumgartner','Daniele Pecci','Marc Ruchmann','Igor Žižikin','Christian De Sica','Renato Scarpa','Ralf Moeller','Raoul Bova','Neri Marcorè','Nino Frassica','Maurizio Casagrande','Gwilym Lee','Mhamed Arezki','Jean-Claude Adelin','Alec Utgoff','Mark Zak','Nicolas Guillot','Riccardo De Torrebruna','Jennifer Iacono','Gabriele Gallinari'],
screenplay:['Florian Henckel von Donnersmarck','Christopher McQuarrie','Jérôme Salle'],
production:['Graham King','Gary Barber','Roger Birnbaum','Jonathan Glickman','Tim Headington'],
music:['James Newton Howard'],
camera:['John Seale'],
cut:['Patricia Rommel','Joe Hutshing'],
sound:['David Parker','Wylie Stateman','Scott Millan','Mark Ulano'],
scenography:['Jon Hutman','Anna Pinnock','Susanna Codognato'],
masks:['Joel Harlow'],
costumes:['Colleen Atwood']},
{title:'Salt',
titleCZ:'Saltová',
year:2010,
runtime:96,
countries:['USA'],
genres:['Action','Thriller','Mystery','Crime'],
director:['Phillip Noyce'],
actors:['Angelina Jolie','Liev Schreiber','Chiwetel Ejiofor','Daniel Olbrychski','August Diehl','Gaius Charles','Cassidy Hinkle','Victor Slezak','James Schram','Nicole Signore','Corey Stoll',"Kevin O'Donnell",'Gary Wilmes','Hunt Block','Michelle Ray Smith','Victoria Cartagena','Marion McCorry','Zoe Lister Jones','Nick Poltoranin','Harry L. Seddon','Hristo Hristov','Ethan Ladd','James Cronin','Zach Shaffer','Tobias Campbell','Ivo Velon','Angelo Lopez','Dionne Audain','Brian Distance','William Henderson White','Xavier Rafael','Frosty Lawson','Mardi Jones','David Agranov','Michael Ahl','George Aloi','James P. Anderson','Mike D. Anderson','Quarles Antoine','Lara Apponyi','Gaetano Averella','Cecilia Foss','Natalie Gal','Yara Shahidi','Olek Krupa','Andre Braugher','Matthew James Gulbranson','Ivan Cardona','Michael James Levy','Tika Sumpter','Kamar de los Reyes','Katherine Dickson','Edgar Jimz','Armand Schultz','Rich Ting','Solima Arnold','Robert Myers','Susie Griswold','Frank Harts','Nicky Julius','Olja Zujeva','Frank Anello','Angel David','Jordan Lage','Storm Garner','Roslyn Ruff','Albert Jones','James Nuciforo'],
screenplay:['Kurt Wimmer','Brian Helgeland'],
production:['Lorenzo di Bonaventura','Sunil Perkash'],
music:['James Newton Howard'],
camera:['Robert Elswit'],
cut:['Stuart Baird','John Gilroy'],
sound:['Paul Hsu','Warren Shaw','Greg P. Russell','Schavaria Reeves','Scott Millan'],
scenography:['Scott Chambliss'],
masks:['John Caglione','Jr.','Kazu Hiro','Adruitha Lee','Thomas Floutz'],
costumes:['Sarah Edwards']},
{title:'The Fall Guy',
titleCZ:'Kaskadér',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Action','Comedy','Drama','Thriller'],
director:['David Leitch'],
actors:['Ryan Gosling','Aaron Taylor-Johnson','Emily Blunt','Hannah Waddingham','Winston Duke','Stephanie Hsu'],
screenplay:['Drew Pearce'],
production:['Ashok Amritraj','Guymon Casady','Ryan Gosling','Kelly McCormick','Walter F. Parkes'],
scenography:['David Scheunemann']},
{title:'Back to Black',
titleCZ:'Back to Black',
year:2024,
runtime:'024',
countries:['UK','USA'],
genres:['Biographic','Drama'],
director:['Sam Taylor-Johnson'],
actors:['Marisa Abela',"Jack O'Connell",'Lesley Manville','Eddie Marsan','Juliet Cowan','Bronson Webb','Ansu Kabia','Harley Bird','Colin Mace','Tim Treloar','Matilda Thorpe'],
screenplay:['Matt Greenhalgh'],
production:['Debra Hayward','Alison Owen'],
camera:['Polly Morgan'],
cut:['Martin Walsh'],
sound:['Glenn Freemantle'],
scenography:['Sarah Greenwood','Katie Spencer','Gabrielle Rosenberg'],
costumes:['P.C. Williams']},
{title:'Lara Croft Tomb Raider: The Cradle of Life',
titleCZ:'Lara Croft - Tomb Raider: Kolébka života',
year:2003,
runtime:113,
countries:['USA','Germany','Japan','UK'],
genres:['Action','Fantasy','Adventure','Thriller'],
director:['Jan de Bont'],
actors:['Angelina Jolie','Gerard Butler','Ciarán Hinds','Chris Barrie','Noah Taylor','Robert Cavanah','Richard Ng','Simon Yam','Djimon Hounsou','Til Schweiger','Graham McTavish','Ronan Vibert','Daniel Caltagirone','Gerald Kyd','Daryl Kwan','Marem Hassler','Richard Ridings','Jonny Coyne','Martin Glyn Murray','Tom Wu','Jamie Hayden','Vincent Mbaya'],
screenplay:['Dean Georgaris'],
production:['Lawrence Gordon','Lloyd Levin'],
music:['Alan Silvestri'],
camera:['David Tattersall'],
cut:['Michael Kahn'],
sound:['Randy Thom','Gary Summers','Steve Boeddeker','Chris Munro'],
scenography:['Paul Kirby','Kirk M. Petruccelli'],
masks:['Frances Hannon'],
costumes:['Lindy Hemming']},
{title:'Lara Croft: Tomb Raider',
titleCZ:'Lara Croft - Tomb Raider',
year:2001,
runtime:93,
countries:['UK','Germany','USA','Japan'],
genres:['Action','Fantasy','Adventure'],
director:['Simon West'],
actors:['Angelina Jolie','Jon Voight','Iain Glen','Noah Taylor','Daniel Craig','Richard Johnson','Chris Barrie','Leslie Phillips','Ozzie Yue','Olegar Fedoro','Julian Rhind-Tutt','Richenda Carey','Anna-Maria Everett','David K.S. Tse'],
screenplay:['John Zinman','Patrick Massett'],
production:['Lawrence Gordon','Colin Wilson','Lloyd Levin'],
music:['Graeme Revell'],
camera:['Peter Menzies Jr.'],
cut:['Mark Warner','Glen Scantlebury','Eric Strand','Dallas Puett'],
sound:['Joe DeAngelis','Alan Robert Murray','Gregg Landaker','Steve Boeddeker'],
scenography:['Kirk M. Petruccelli'],
masks:['Paul Engelen'],
costumes:['Lindy Hemming']},
{title:'Gone in Sixty Seconds',
titleCZ:'60 sekund',
year:2000,
runtime:111,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Dominic Sena'],
actors:['Nicolas Cage','Giovanni Ribisi','Angelina Jolie','William Lee Scott','Scott Caan','James Duval','Will Patton','Delroy Lindo','Timothy Olyphant','Chi McBride','Robert Duvall','Christopher Eccleston','Vinnie Jones','Grace Zabriskie','Jaime Bergman','Harry Van Gorkum','Frances Fisher','Stephen Shellen','Arye Gross','Master P',"David 'Shark' Fralick",'Carmen Argenziano','Brad William Henke','John Carroll Lynch','Michael Peña','Ken Jenkins','Cosimo Fusco','Bodhi Elfman','Trevor Goddard','Kevin Weisman','Tim DeZarn',"Billy 'Sly' Williams",'Lombardo Boyar','Joseph Patrick Kelly','Dan Hildebrand','Jesse Corti','Lois Hall','Greg Collins','Douglas Bennett','Dean Rader-Duval','Kevin West','Eddie Mui','Nick Meaney','Greg Bronson','Michael Owen','Rainbow Borden','Bob Sattler'],
screenplay:['Scott Rosenberg','H.B. Halicki'],
production:['Jerry Bruckheimer'],
music:['Trevor Rabin'],
camera:['Paul Cameron'],
cut:['Chris Lebenzon','Roger Barton','Tom Muldoon'],
sound:["Kevin O'Connell",'Greg P. Russell'],
scenography:['Jeff Mann'],
masks:['Matt Danon'],
costumes:['Marlene Stewart']},
{title:'Taking Lives',
titleCZ:'Zloděj životů',
year:2004,
runtime:103,
countries:['USA','Australia'],
genres:['Mystery','Thriller','Crime'],
director:['D.J. Caruso'],
actors:['Angelina Jolie','Ethan Hawke','Tchéky Karyo','Olivier Martinez','Gena Rowlands','Paul Dano','Shawn Roberts','Emmanuel Bilodeau','Jean-Hugues Anglade','Marie-Josée Croze','Kiefer Sutherland','Julien Poulin','Judith Baribeau','Justin Chatwin','Dominique Briand','Bernie Goldmann','Vince Grant','André Lacoste','Richard Lemire','Henri Pardo','Brett Watson','Freddy Bessa','Andy Bradshaw','Alex Sol'],
basedOn:['Michael Pye'],
screenplay:['Jon Bokenkamp'],
production:['Mark Canton','Bernie Goldmann'],
music:['Philip Glass'],
camera:['Amir Mokri'],
cut:['Anne V. Coates'],
sound:['Craig Henighan','John T. Reitz','Gregg Rudloff','Yann Delpuech'],
scenography:['Tom Southwell','Amanda Moss Serino'],
masks:['Adrien Morot','Donald Mowat'],
costumes:['Marie-Sylvie Deveau']},
{title:'Furiosa: A Mad Max Saga',
titleCZ:'Furiosa: Sága Šíleného Maxe',
year:2024,
runtime:'024',
countries:['Australia','USA'],
genres:['Action','Adventure','Sci-Fi','Thriller'],
director:['George Miller'],
actors:['Anya Taylor-Joy','Chris Hemsworth','Tom Burke','Nathan Jones','Angus Sampson','Charlee Fraser'],
screenplay:['Nick Lathouris','George Miller'],
production:['George Miller','Doug Mitchell'],
music:['Junkie XL'],
camera:['Simon Duggan'],
scenography:['Colin Gibson'],
costumes:['Jenny Beavan']},
{title:'Original Sin',
titleCZ:'Sedmý hřích',
year:2001,
runtime:116,
countries:['USA','France'],
genres:['Thriller','Drama','Psycology'],
director:['Michael Cristofer'],
actors:['Antonio Banderas','Angelina Jolie','Thomas Jane','Jack Thompson','Pedro Armendáriz Jr.','Gregory Itzin','Allison Mackie','Joan Pringle','Lisa Owen','Fernando Torre Laphame','Patricio Castillo','Farnesio de Bernal','Roger Cudney','Alejandro Reza','Julio Bracho','Daniel Martínez','Adrian Makala','Shaula Vega','Mario Iván Martínez','George Belanger'],
basedOn:['Cornell Woolrich'],
screenplay:['Michael Cristofer'],
production:['Denise Di Novi'],
music:['Terence Blanchard'],
camera:['Rodrigo Prieto'],
cut:['Eric A. Sears'],
sound:['Brad Sherman'],
scenography:['David J. Bomba'],
masks:['Nena Smarz'],
costumes:['Donna Zakowska']},
{title:'The Garfield Movie',
titleCZ:'Garfield ve filmu',
year:2024,
runtime:'024',
countries:['USA','UK'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Mark Dindal'],
actors:['Chris Pratt','Hannah Waddingham','Nicholas Hoult','Samuel L. Jackson','Ving Rhames','Cecily Strong'],
screenplay:['David Reynolds','Mark Torgove'],
production:['John Cohen','Broderick Johnson','Andrew A. Kosove']},
{title:'hit man',
titleCZ:'Hit Man',
year:2023,
runtime:113,
countries:['USA'],
genres:['Action','Comedy'],
director:['Richard Linklater'],
actors:['Glen Powell','Adria Arjona','Austin Amelio','Retta','Molly Bernard','Ritchie Montgomery','Kate Adair','Jordan Salloum','Mike Markoff','Richard Robichaux','Gralen Bryant Banks','Anthony Michael Frederick','Murphee Bloom'],
screenplay:['Richard Linklater','Glen Powell'],
production:['Jason Bateman','Mike Blizzard','Michael Costigan','Richard Linklater','Glen Powell'],
music:['Graham Reynolds'],
camera:['Shane F. Kelly'],
cut:['Sandra Adair'],
scenography:['Bruce Curtis'],
costumes:['Juliana Hoffpauir']},
{title:'Inside Out 2',
titleCZ:'V hlavě 2',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Animation','Adventure','Comedy'],
director:['Pete Docter','Kelsey Mann'],
actors:['Amy Poehler','Phyllis Smith','Lewis Black','Diane Lane','Maya Hawke','Tony Hale','Liza Lapira'],
screenplay:['Meg LeFauve'],
production:['Mark Nielsen']},
{title:'Frida',
titleCZ:'Frida',
year:2002,
runtime:123,
countries:['USA','Canada'],
genres:['Drama','Biographic'],
director:['Julie Taymor'],
actors:['Salma Hayek','Alfred Molina','Valeria Golino','Mía Maestro','Roger Rees','Diego Luna','Patricia Reyes Spíndola','Margarita Sanz','Geoffrey Rush','Amelia Zapata','Fermín Martínez','Roberto Medina','Ashley Judd','Antonio Banderas','Lila Downs','Martha Claudia Moreno','Maria Ines Pintado','Aida López','Ivana Sejenovich','Ehécatl Chávez','Elliot Goldenthal','Edward Norton','Saffron Burrows','Didi Conn','Julian Sedgwick','Enoc Leaño','Karine Plantadit-Bageot','Jorge Zepeda','Benjamín Benítez','Andrés Montiel','Jorge Valdés García','Eszter Zakariás','Antonio Zavala Kugler'],
basedOn:['Hayden Herrera'],
screenplay:['Clancy Sigal','Diane Lake','Gregory Nava','Anna Thomas'],
production:['Sarah Green','Salma Hayek','Jay Polstein','Lizz Speed','Nancy Hardin','Lindsay Flickinger','Roberto Sneider'],
music:['Elliot Goldenthal'],
camera:['Rodrigo Prieto'],
cut:['Françoise Bonnot'],
sound:['Santiago Núñez','Blake Leyh','Robert Fernandez'],
scenography:['Felipe Fernández del Paso','Hania Robledo'],
masks:['Matthew W. Mungle','Judy Chin'],
costumes:['Julie Weiss']},
{title:'Desperado',
titleCZ:'Desperado',
year:1995,
runtime:104,
countries:['USA','Mexico'],
genres:['Action','Thriller','Crime'],
director:['Robert Rodriguez'],
actors:['Antonio Banderas','Salma Hayek','Joaquim de Almeida','Cheech Marin','Steve Buscemi','Carlos Gómez','Quentin Tarantino','Tito Larriva','Danny Trejo','Carlos Gallardo','Albert Michel Jr.','Peter Marquardt','Consuelo Gómez','Tommy Nix','Reinol Martinez','Enrique Iglesias','Angel Aviles','Mike Moroff','Mark Dalton','Cristos','Gerardo Moscoso'],
screenplay:['Robert Rodriguez'],
production:['Robert Rodriguez','Bill Borden'],
music:['Los Lobos'],
camera:['Guillermo Navarro'],
cut:['Robert Rodriguez'],
sound:['Sergio Reyes','Mark Ulano'],
scenography:['Cecilia Montiel'],
masks:['Allan A. Apone'],
costumes:['Graciela Mazón']},
{title:'Evita',
titleCZ:'Evita',
year:1996,
runtime:129,
countries:['USA'],
genres:['Drama','Musical','Biographic'],
director:['Alan Parker'],
actors:['Madonna','Antonio Banderas','Jonathan Pryce','Jimmy Nail','Andrea Corr','Adriá Collado','Mark Ryan','Alan Parker','Vera Fogwill','Billie Piper','Diego Leske','Ana Justo','Peter Polycarpou','Mónica Lairana','Nickolas Grace','Gary Brooker','George Little','Mem Ferda','Mara Bestelli','Ian Hill','Sally Bourne','Olga Merediz','Denis Lill','Harry Fielder','Alexander Hall','Peter Hughes','Lucinda Rhodes Thakrar','Julian Littman','Brian Cobby','Eduardo Ruderman'],
basedOn:['Tim Rice'],
screenplay:['Alan Parker','Oliver Stone'],
production:['Robert Stigwood','Alan Parker','Andrew G. Vajna'],
music:['Andrew Lloyd Webber'],
camera:['Darius Khondji'],
cut:['Gerry Hambling'],
sound:['Eddy Joseph','Andy Nelson','Anna Behlmer'],
scenography:['Brian Morris'],
masks:['Martin Samuel','Sarah Monzani'],
costumes:['Penny Rose']},
{title:'The 13th Warrior',
titleCZ:'Vikingové',
year:1999,
runtime:102,
countries:['USA'],
genres:['Action','Adventure','History'],
director:['John McTiernan','Michael Crichton'],
actors:['Antonio Banderas','Vladimír Kulich','Tony Curran','Omar Sharif','Dennis Storhøi','Erick Avari','Sven Wollter','Diane Venora','Maria Bonnevie','Kaaren de Zilva','Sven-Ole Thorsen','Chris Angel','Clive Russell','John DeSantis','Richard Bremmer','Layla Alizada','Alex Zahara','Albie Woodington','Anders T. Andersen','Yolande Bavan','Brian Jensen','Susan Willis','Greg Michaels','Mark Acheson','Andrew Kavadas','Suzanne Bertish','Mischa Hausserman','Mina E. Mina','Michael Jonsson','Bjørn Ove Pedersen'],
basedOn:['Michael Crichton'],
screenplay:['William Wisher Jr.','Warren Lewis'],
production:['Michael Crichton','John McTiernan','Ned Dowd'],
music:['Jerry Goldsmith'],
camera:['Peter Menzies Jr.'],
cut:['John Wright'],
sound:['Alan Robert Murray','Michael Minkler','Frank A. Montaño','Christopher Boyes'],
scenography:['Wolf Kroeger','Rose Marie McSherry'],
masks:['Jeff Dawn','Charles Porlier','Victoria Down','Dayne Johnson','Janet Sala'],
costumes:['Kate Harrington','Sandra J. Blackie']},
{title:'Despicable Me',
titleCZ:'Já, padouch',
year:2010,
runtime:91,
countries:['USA','France'],
genres:['Animation','Comedy','Family','Sci-Fi'],
director:['Chris Renaud','Pierre Coffin'],
actors:['Steve Carell','Jason Segel','Russell Brand','Kristen Wiig','Miranda Cosgrove','Will Arnett','Danny McBride','Jack McBrayer','Julie Andrews','Dana Gaier','Elsie Fisher','Pierre Coffin','Chris Renaud','Jemaine Clement','Mindy Kaling','Ken Daurio','Ken Jeong','Rob Huebel','Mikaila Baumel','Chris Edgerly','Pat Fraley','Derya Flechtner','David Cowgill','Katie Leigh','Danny Mann','John Hans Tester'],
screenplay:['Cinco Paul','Ken Daurio'],
production:['Janet Healy','John Cohen'],
music:['Pharrell Williams','Heitor Pereira'],
cut:['Gregory Perler','Pam Ziegenhagen'],
sound:['Dennis Leonard','Christopher Scarabosio','Tom Johnson']},
{title:'Despicable Me 2',
titleCZ:'Já, padouch 2',
year:2013,
runtime:98,
countries:['USA','France','Japan'],
genres:['Animation','Sci-Fi','Adventure','Crime','Comedy','Family'],
director:['Pierre Coffin','Chris Renaud'],
actors:['Steve Carell','Kristen Wiig','Benjamin Bratt','Miranda Cosgrove','Russell Brand','Ken Jeong','Steve Coogan','Elsie Fisher','Dana Gaier','Nasim Pedrad','Kristen Schaal','Pierre Coffin','Chris Renaud','Jess Harnell','Alec Medlock','Laraine Newman','Jim Ward','Moises Arias','Eva Bella','Vanessa Bayer','Casey Simpson','Ava Acres','John Cygan','Andre Robinson','Mason McNulty','Lori Alan','Bailey Gambertoglio','Debi Derryberry','Chris Edgerly','April Winchell','Pat Fraley','Jan Rabson','Dan Navarro','Mona Marshall','Danny Mann','Jack Angel'],
screenplay:['Ken Daurio','Cinco Paul'],
production:['Janet Healy'],
music:['Pharrell Williams','Heitor Pereira'],
cut:['Gregory Perler'],
sound:['Dennis Leonard','Gary Rizzo','Oleg Kulchytskyi','Christopher Scarabosio','Tom Johnson']},
{title:'Despicable Me 3',
titleCZ:'Já, padouch 3',
year:2017,
runtime:89,
countries:['USA'],
genres:['Animation','Fantasy','Sci-Fi','Adventure','Action','Comedy','Family'],
director:['Kyle Balda','Pierre Coffin'],
actors:['Steve Carell','Kristen Wiig','Trey Parker','Jenny Slate','Miranda Cosgrove','Steve Coogan','Russell Brand','Pierre Coffin','Andy Nyman','Dana Gaier','Tara Strong','Mindy Sterling','Lori Alan','Jan Rabson','Mona Marshall','Danny Mann','Brian T. Delaney','Michael Beattie'],
screenplay:['Ken Daurio','Cinco Paul'],
production:['Janet Healy','Christopher Meledandri'],
music:['Heitor Pereira'],
cut:['Claire Dodgson'],
sound:['Dennis Leonard','Randy Thom','Brandon Proctor','Pedro Sánchez Alonso']},
{title:'Despicable Me 4',
titleCZ:'Já, padouch 4',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Chris Renaud','Patrick Delage'],
actors:['Steve Carell','Kristen Wiig','Miranda Cosgrove','Steve Coogan','Pierre Coffin','Madison Skyy Polan'],
screenplay:['Mike White'],
production:['Janet Healy','Christopher Meledandri']},
{title:'The Minions',
titleCZ:'Mimoni',
year:2015,
runtime:91,
countries:['USA'],
genres:['Animation','Adventure','Action','Comedy','Family'],
director:['Kyle Balda','Pierre Coffin'],
actors:['Sandra Bullock','Jon Hamm','Michael Keaton','Allison Janney','Katy Mixon','Steve Coogan','Pierre Coffin','Chris Renaud','Steve Carell','Hirojuki Sanada','Geoffrey Rush','Robin Rose Singer','Paul Thornley','Ava Acres','John Cygan','Tara Strong','Mindy Sterling','Lori Alan','Chris Edgerly','Pat Fraley','Jan Rabson','Gary Martin','Mona Marshall','Danny Mann','Brian T. Delaney','Alexander Polinsky','Michael Beattie'],
screenplay:['Brian Lynch'],
production:['Janet Healy'],
music:['Heitor Pereira'],
cut:['Claire Dodgson'],
sound:['Dennis Leonard','Gary Rizzo','Christopher Scarabosio']},
{title:'Minions: The Rise of Gru',
titleCZ:'Mimoni 2: Padouch přichází',
year:2022,
runtime:88,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Kyle Balda','Brad Ableson'],
actors:['Pierre Coffin','Steve Carell','Lucy Lawless','Michelle Yeoh','Jean-Claude Van Damme','Julie Andrews','Dolph Lundgren','Taraji P. Henson','Alan Arkin','Danny Trejo','Russell Brand','RZA','Scarlett Estevez','Benjamin Plessala','Michael Beattie','Jake Green','JP Karliak'],
screenplay:['Brian Lynch','Matt Fogel'],
production:['Christopher Meledandri','Janet Healy','Chris Renaud'],
cut:['Claire Dodgson'],
sound:['Brandon Proctor']},
{title:'Longlegs',
titleCZ:'Longlegs',
year:2024,
runtime:101,
countries:['USA'],
genres:['Horror','Thriller'],
director:['Oz Perkins'],
actors:['Nicolas Cage','Maika Monroe','Alicia Witt','Blair Underwood','Lisa Chandler','Erin Boyes','Dakota Daulby','Vanessa Walsh','Charles Jarman'],
screenplay:['Oz Perkins'],
production:['Nicolas Cage','Dave Caplan','Chris Ferguson','Dan Kagan','Brian Kavanaugh-Jones'],
camera:['Andrés Arochi'],
cut:['Greg Ng'],
scenography:['Danny Vermette','Trevor Johnston'],
masks:['Harlow MacFarlane']},
{title:'Twisters',
titleCZ:'Twisters',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Action','Adventure','Thriller'],
director:['Lee Isaac Chung'],
actors:['Daisy Edgar-Jones','Glen Powell','Anthony Ramos','Brandon Perea','Kiernan Shipka','Maura Tierney','Harry Hadden-Paton','Sasha Lane','Nik Dodani','David Corenswet','Tunde Adebimpe'],
screenplay:['Mark L. Smith'],
production:['Frank Marshall','Patrick Crowley'],
scenography:['Patrick M. Sullivan Jr.'],
costumes:['Eunice Jera Lee']},
{title:'Pretty Woman',
titleCZ:'Pretty Woman',
year:1990,
runtime:119,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Garry Marshall'],
actors:['Richard Gere','Julia Roberts','Ralph Bellamy','Jason Alexander','Laura San Giacomo','Hector Elizondo','Alex Hyde-White','Amy Yasbeck','Hank Azaria','Larry Hankin','Kathleen Marshall','Larry Miller','Dey Young','Garry Marshall','Patrick Richwood','Scott Marshall','Al Sapienza','Elinor Donahue','Charles Minsky','Robyn Peterson','R. Darrell Hunter','Paul Bradley','Nancy Locke','James Patrick Stuart','Lynda Goodfriend','Amzie Strickland','Norman Large','Stacy Keach Sr.','Rio Hackford','Abdul Salaam El Razzac','Bill Applebaum','Frank Campanella','Rodney Kageyama','Tracy Reiner','Billy Gallo','Valorie Armstrong','John David Carson','Carol Williard','Mariann Aalda','Tom Nolan','Paul Van'],
screenplay:['J.F. Lawton'],
production:['Arnon Milchan','Steven Reuther'],
music:['James Newton Howard'],
camera:['Charles Minsky'],
cut:['Priscilla Nedd-Friendly','Raja Gosnell'],
scenography:['Albert Brenner'],
costumes:['Marilyn Vance']},
{title:'Karate Kid',
titleCZ:'Karate Kid',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Action','Drama','Family'],
director:['Jonathan Entwistle'],
actors:['Jackie Chan','Ralph Macchio'],
screenplay:['Rob Lieber'],
production:['Karen Rosenfelt']},
{title:'The Karate Kid',
titleCZ:'Karate Kid',
year:2010,
runtime:134,
countries:['USA','China'],
genres:['Action','Drama','Family','Sport'],
director:['Harald Zwart'],
actors:['Jackie Chan','Jaden Smith','Taraji P. Henson','Ringo Yu','Wenwen Han','Zhensu Wu','Zhenwei Wang','Ji Wang','Xiaofei Zhou'],
screenplay:['Christopher Murphey'],
production:['Jerry Weintraub','Will Smith','James Lassiter'],
music:['James Horner'],
camera:['Roger Pratt'],
cut:['Joel Negron'],
sound:['Tateum Kohut'],
scenography:['François Séguin'],
masks:['Jingjing Ma','Camille Friend'],
costumes:['Han Feng']},
{title:'Sonic the Hedgehog 3',
titleCZ:'Sonic the Hedgehog 3',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Animation','Action','Adventure'],
director:['Jeff Fowler'],
actors:['Idris Elba','James Marsden','Ben Schwartz',"Colleen O'Shaughnessey",'Olivia Brody'],
screenplay:['Pat Casey','Josh Miller'],
production:['Neal H. Moritz']},
{title:'Nosferatu',
titleCZ:'Upír Nosferatu',
year:1922,
runtime:94,
countries:['Germany'],
genres:['Fantasy','Horror'],
director:['Friedrich Wilhelm Murnau'],
actors:['Max Schreck','Gustav von Wangenheim','Greta Schröder','Georg H. Schnell','Ruth Landshoff','John Gottowt','Gustav Botz','Max Nemetz','Wolfgang Heinz','Albert Venohr','Eric van Viele','Alexander Granach','Karl Etlinger','Guido Herzfeld','Loni Nest'],
basedOn:['Bram Stoker'],
screenplay:['Henrik Galeen'],
music:['Hans Erdmann','Nash the Slash','Gérard Hourbette','Hugh Doolan','Richard Feren','James Bernard','Thierry Zaboitzeff','Robert Steadman','Peter Schirmann','Hans Posegga'],
camera:['Fritz Arno Wagner','Gunther Krampf']},
{title:'Beverly Hills Cop: Axel Foley',
titleCZ:'Beverly Hills Cop: Axel F',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Action','Comedy','Crime'],
director:['Mark Molloy'],
actors:['Eddie Murphy','Joseph Gordon-Levitt','Kevin Bacon','Paul Reiser','Judge Reinhold','John Ashton','Bronson Pinchot','Taylour Paige','James Preston Rogers','Damien Diaz','Michael Camp'],
screenplay:['Daniel Petrie Jr.','Josh Appelbaum','Will Beall','André Nemec'],
production:['Jerry Bruckheimer','Eddie Murphy'],
camera:['Dante Spinotti'],
scenography:['Jahmin Assa'],
masks:['Steven R. Soussanna']},
{title:'Love Story',
titleCZ:'Love Story',
year:1970,
runtime:99,
countries:['USA'],
genres:['Drama','Romance'],
director:['Arthur Hiller'],
actors:['Ali MacGraw',"Ryan O'Neal",'John Marley','Ray Milland','Tommy Lee Jones','Russell Nype','Andrew Duncan','Sudie Bond','Sydney Walker',"Kevin O'Neal"],
screenplay:['Erich Segal'],
production:['Howard G. Minsky'],
music:['Francis Lai'],
camera:['Richard C. Kratina'],
cut:['Robert C. Jones'],
scenography:['Robert Gundlach','Philip Smith'],
costumes:['Alice Manougian Martin','Pearl Somner']},
{title:'Sadsacks Go to War',
titleCZ:'Bažanti jdou do boje',
year:1974,
runtime:85,
countries:['France','Italy','Germany'],
genres:['Comedy','War','Adventure'],
director:['Claude Zidi'],
actors:['Jean-Guy Fechner','Gérard Filippelli','Gérard Rinaldi','Jean Sarrus','Jacques Seiler','Marisa Merlini','Heidy Bohlen','Paolo Stoppa','Myriam Boyer','Pierre Gualdi','André Tomasi','Jacques Robiolles','Georges Douking','Jean-Paul Farré','Alain Flick','Emanuela Barattolo','André Badin','Philippe Castelli'],
screenplay:['Claude Zidi','Jean-Paul Farré','Jean Bouchaud'],
production:['Christian Fechner'],
music:['Paul Plot'],
camera:['Paul Bonis'],
cut:['Monique Isnardon','Robert Isnardon','Yvette Bastide','Ines Colignon','Colette Lambert'],
scenography:['Jacques Bufnoir'],
masks:['Charly Koubesserian'],
costumes:['Laurence Brignon']},
{title:'The Lord of the Rings: The War of the Rohirrim',
titleCZ:'The Lord of the Rings: The War of the Rohirrim',
year:2024,
runtime:'024',
countries:['USA','Japan'],
genres:['Animation','Fantasy','Action','Adventure'],
director:['Kendži Kamijama'],
actors:['Brian Cox','Miranda Otto','Shaun Dooley','Luke Pasqualino','Lorraine Ashbourne','Janine Duvitski','Benjamin Wainwright','Michael Wildman','Jude Akuwudike','Bilal Hasna'],
basedOn:['J.R.R. Tolkien'],
screenplay:['Jeffrey Addiss','Will Matthews'],
production:['Joseph Chou'],
music:['Steve Gallagher']},
{title:'Wicked part 1',
titleCZ:'Wicked Sex Party 4',
year:2002,
runtime:87,
countries:['USA'],
genres:['Erotic'],
director:['Brad Armstrong'],
actors:['Allysin Chaynes','Mark Davis','Keri Windsor','Sydnee Steele','Gina Ryder']},
{title:'Brave',
titleCZ:'Rebelka',
year:2012,
runtime:90,
countries:['USA'],
genres:['Animation','Fantasy','Action','Adventure','Comedy'],
director:['Mark Andrews','Brenda Chapman'],
actors:['Kelly Macdonald','Billy Connolly','Emma Thompson','Julie Walters','Kevin McKidd','Robbie Coltrane','Craig Ferguson','John Ratzenberger','Steven Cree'],
screenplay:['Brenda Chapman','Irene Mecchi'],
music:['Patrick Doyle'],
cut:['Nicholas C. Smith'],
sound:['Gwendolyn Yates Whittle','Gary Rydstrom','Will Files','Tom Johnson']},
{title:'A Man Called Otto',
titleCZ:'Muž jménem Otto',
year:2022,
runtime:126,
countries:['USA','Sweden'],
genres:['Comedy','Drama'],
director:['Marc Forster'],
actors:['Tom Hanks','Mariana Treviño','Rachel Keller','Manuel Garcia-Rulfo','Cameron Britton','Mike Birbiglia','Christiana Montoya','Kelly Lamor Wilson','Juanita Jennings','Kailey Hyman','Bryant Carroll','Lavel Schley','Jon Osbeck','Jeff Hochendoner','Elle Chapman','Josefine Lindegaard','Ira Amyx','Spenser Granese','David Magee','Robyne Parrish','Branislav R. Tatalovic','Alessandra Perez','Julian Manjerico'],
basedOn:['Fredrik Backman'],
screenplay:['David Magee'],
production:['Fredrik Wikström Nicastro','Rita Wilson','Tom Hanks','Gary Goetzman'],
music:['Thomas Newman'],
camera:['Matthias Koenigswieser'],
cut:['Matt Chessé'],
scenography:['Barbara Ling','Frank Galline'],
masks:['Rachel Kick'],
costumes:['Frank L. Fleming']},
{title:'Kingsman: The Golden Circle',
titleCZ:'Kingsman: Zlatý kruh',
year:2017,
runtime:141,
countries:['UK','USA'],
genres:['Action','Adventure','Comedy'],
director:['Matthew Vaughn'],
actors:['Taron Egerton','Mark Strong','Pedro Pascal','Colin Firth','Julianne Moore','Halle Berry','Edward Holcroft','Hanna Alström','Channing Tatum','Jeff Bridges','Elton John','Poppy Delevingne','Sophie Cookson','Lena Endre','Juha Pihanen','Samantha Womack','Anthony Milton','Björn Granath','Tobi Bakare','Thomas Turgoose','Keith Allen','Michael Gambon','Bruce Greenwood','Emily Watson','Grant Crookes','Tobias James-Samuels','Lee Nicholas Harris','Grant Gillespie','Martyn Ford','Calvin Demba','Iain McKee','Mark Arnold','Tom Benedict Knight','Samuel L. Jackson','Sofia Boutella','Jeff Ricketts','Tony Cook','Laurentiu Possa','Nesba Crenshaw','Robert Eames','Annarie Boor','Antonio Magro','Neil Summerville','Tara Hugo','Samantha Coughlan','Rachel Fowler','Yuriri Naka','Jamie-Lee Beacher','Al Fenderico'],
basedOn:['Mark Millar','Dave Gibbons'],
screenplay:['Matthew Vaughn','Jane Goldman'],
production:['Matthew Vaughn','Adam Bohling','David Reid'],
music:['Henry Jackman','Matthew Margeson'],
camera:['George Richmond'],
cut:['Eddie Hamilton'],
sound:['Michael Prestwood Smith','Rob Prynne','Matthew Collinge'],
scenography:['Darren Gilford','Grant Armstrong','Rosemary Brandenburg'],
masks:['Amanda Knight','Norma Hill-Patton'],
costumes:['Arianne Phillips']},
{title:"The King's Man",
titleCZ:'Kingsman: První mise',
year:2021,
runtime:131,
countries:['UK','USA'],
genres:['Action','Adventure'],
director:['Matthew Vaughn'],
actors:['Ralph Fiennes','Gemma Arterton','Matthew Goode','Harris Dickinson','Djimon Hounsou','Tom Hollander','Rhys Ifans','Daniel Brühl','Charles Dance','Aaron Taylor-Johnson','Valerie Pachner','Alexandra Maria Lara','August Diehl','Ron Cook','Ian Kelly','Branka Katič','Robert Aramayo','Alison Steadman','Stanley Tucci','David Kross','Joel Basman','Simon Connolly','Olivier Richters','Todd Boyce','Angus Castle-Doughty','Neil Jackson','Kristian Wanzl Nekrasov','Alexander Cobb','Emun Elliott','Ross Anderson','Timon Staehler','Vår Haugholt','Ronja Haugholt',"Jed O'Hagan",'Gabriel Constantin','Terence Anderson','Aaron Vodovoz','Pippa Winslow','Gabriela Całun','Ed Cooper Clarke','Fiz Marcus','Dolores Carbonari','Constantine Gregory','Chloé Booyens','Jack Cunningham-Nuttall','Jhon Lumsden','Maja Simonsen'],
basedOn:['Mark Millar','Dave Gibbons'],
screenplay:['Matthew Vaughn','Karl Gajdusek'],
production:['Matthew Vaughn','David Reid','Adam Bohling'],
music:['Matthew Margeson','Dominic Lewis'],
camera:['Ben Davis'],
cut:['Jason Ballantine','Robert Hall'],
sound:['Paul Massey','Markus Stemler','Christopher Scarabosio','Matthew Collinge'],
scenography:['Darren Gilford','Dominic Capon'],
masks:['Jenny Shircore','Joe Hopker','Heather Manson'],
costumes:['Michele Clapton']},
{title:'Uncharted',
titleCZ:'Uncharted',
year:2022,
runtime:117,
countries:['USA'],
genres:['Action','Adventure'],
director:['Ruben Fleischer'],
actors:['Tom Holland','Mark Wahlberg','Antonio Banderas','Tati Gabrielle','Steven Waddington','Sophia Ali','Patricia Meeden','Sarah Petrick','Jonathan Failla','Matt Barkley','Rudy Pankow','Diarmaid Murtagh','Joseph Balderrama','Alana Boden','Manuel de Blas','Pilou Asbæk','Carlo Kitzlinger','Nolan North','Peter Seaton-Clark','Pingi Moli'],
screenplay:['Joe Carnahan','Rafe Judkins','Art Marcum','Matt Holloway'],
production:['Avi Arad','Charles Roven','Alex Gartner'],
music:['Ramin Djawadi'],
camera:['Jung-hoon Jung'],
cut:['Chris Lebenzon'],
sound:["Kevin O'Connell",'Mark Paterson','Paul N.J. Ottosson'],
scenography:['Shepherd Frankel','Kata Bartyik'],
masks:['Allan A. Apone','Laura García','Victoria Down'],
costumes:['Anthony Franco']},
{title:'Death on the Nile',
titleCZ:'Smrt na Nilu',
year:2022,
runtime:127,
countries:['USA'],
genres:['Crime','Drama','Mystery'],
director:['Kenneth Branagh'],
actors:['Kenneth Branagh','Gal Gadot','Armie Hammer','Tom Bateman','Letitia Wright','Emma Mackey','Sophie Okonedo','Russell Brand','Annette Bening','Ali Fazal','Rose Leslie','Jennifer Saunders','Dawn French','Susannah Fielding','Orlando Seale','Michael Rouse','Alaa Safi','Charlie Anson','Eleanor de Rohan','Adam Garcia','Rick Warden','Rosie Dwyer','Hayat Kamille','Niamh Lynch','Jon-Scott Clark','Edward Lewis French','John Wolfe','Stacy Abalogun','Victor Alli','Rhiannon Clements','George Jaques','Naveed Khan'],
basedOn:['Agatha Christie'],
screenplay:['Michael Green'],
production:['Ridley Scott','Kevin J. Walsh','Kenneth Branagh','Judy Hofflund'],
music:['Patrick Doyle'],
camera:['Haris Zambarloukos'],
cut:['Úna Ní Dhonghaíle'],
sound:['James Mather','Colin Nicolson'],
scenography:['Jim Clay','Abi Groves'],
masks:['Chiara Ugolini','Alexis Continente','Duncan Jarman','Wakana Yoshihara','Barrie Gower'],
costumes:['Paco Delgado']},
{title:'Death on the Nile',
titleCZ:'Vražda na Nilu',
year:1978,
runtime:140,
countries:['UK'],
genres:['Crime','Drama','Mystery','Thriller'],
director:['John Guillermin'],
actors:['Peter Ustinov','Jane Birkin','Lois Chiles','Bette Davis','Mia Farrow','Jon Finch','Olivia Hussey','I.S. Johar','George Kennedy','Angela Lansbury','Simon MacCorkindale','David Niven','Maggie Smith','Jack Warden','Harry Andrews','Sam Wanamaker','François Guillaume','Barbara Hicks','Reg Lye'],
basedOn:['Agatha Christie'],
screenplay:['Anthony Shaffer'],
music:['Nino Rota'],
camera:['Jack Cardiff'],
cut:['Malcolm Cooke'],
sound:['Eric Tomlinson','Bill Rowe'],
scenography:['Peter Murton'],
costumes:['Anthony Powell']},
{title:'Murder on the Orient Express',
titleCZ:'Vražda v Orient expresu',
year:2017,
runtime:114,
countries:['USA','Malta'],
genres:['Mystery','Crime','Drama'],
director:['Kenneth Branagh'],
actors:['Kenneth Branagh','Johnny Depp','Daisy Ridley','Michelle Pfeiffer','Penélope Cruz','Willem Dafoe','Judi Dench','Lucy Boynton','Leslie Odom Jr.','Derek Jacobi','Tom Bateman','Joseph Long','Olivia Colman','Sergej Polunin','Marwan Kenzari','Richard Price','Josh Gad','Manuel Garcia-Rulfo','Hadley Fraser','Adam Garcia','Kathryn Wilder','Ansu Kabia','Michael Rouse','Alaa Safi','Maxime Durand','Richard Clifford','Elena Valdameri',"Asan N'Jie"],
basedOn:['Agatha Christie'],
screenplay:['Michael Green'],
production:['Kenneth Branagh','Ridley Scott','Simon Kinberg','Mark Gordon','Michael Schaefer','Aditya Sood','Judy Hofflund'],
music:['Patrick Doyle'],
camera:['Haris Zambarloukos'],
cut:['Mick Audsley'],
sound:['James Mather','Michael Prestwood Smith','Colin Nicolson'],
scenography:['Jim Clay','Charlo Dalli','Andrew Ackland-Snow','Will Coubrough','Rebecca Alleway','Phil Harvey'],
masks:['Chiara Ugolini','Julio Parodi','Naomi Donne','Kenny Niederbaumer','Wakana Yoshihara'],
costumes:['Alexandra Byrne']},
{title:'A Haunting in Venice',
titleCZ:'Přízraky v Benátkách',
year:2023,
runtime:103,
countries:['USA'],
genres:['Crime','Drama','Mystery','Thriller','Horror'],
director:['Kenneth Branagh'],
actors:['Kenneth Branagh','Tina Fey','Camille Cottin','Kelly Reilly','Jamie Dornan','Kyle Allen','Jude Hill','Riccardo Scamarcio','Emma Laird','Ali Khan','Michelle Yeoh','Amir El-Masry','Lorenzo Acquaviva','David Menkin','Vanessa Ifediora'],
basedOn:['Agatha Christie'],
screenplay:['Michael Green'],
production:['Kenneth Branagh','Judy Hofflund','Ridley Scott','Simon Kinberg'],
music:['Hildur Guðnadóttir'],
camera:['Haris Zambarloukos'],
cut:['Lucy Donaldson'],
sound:['Andy Nelson','Colin Nicolson'],
scenography:['John Paul Kelly','Celia Bobak'],
masks:['Wakana Yoshihara'],
costumes:['Sammy Sheldon Differ']},
{title:'We Have Never Been Modern',
titleCZ:'Úsvit',
year:2023,
runtime:117,
countries:['Czechia','Slovakia'],
genres:['Drama','Crime'],
director:['Matěj Chlupáček'],
actors:['Eliška Křenková','Miloslav König','Milan Ondrík','Marián Mitaš','Luboš Veselý','Martha Issová','Ladislav Hampl','Ján Jackuliak','Anton Šulík ml.','Richard Langdon','Martin Siničák','Zuzana Konečná','Andrea Bučko','Viktória Petrášová','Lukáš Frlajs'],
screenplay:['Miro Šifra'],
production:['Maja Hamplová','Matěj Chlupáček'],
music:['Simon Goff'],
camera:['Martin Douba'],
cut:['Pavel Hrdlička ml.'],
sound:['Pavel Rejholec','Peter Hilčanský'],
scenography:['Henrich Boráros'],
masks:['Lenka Nosková','Martin Jankovič'],
costumes:['Jarmila Dunděrová']},
{title:'My Big Fat Greek Wedding',
titleCZ:'Moje tlustá řecká svatba',
year:2002,
runtime:95,
countries:['USA','Canada'],
genres:['Romance','Comedy','Drama'],
director:['Joel Zwick'],
actors:['Nia Vardalos','John Corbett','Peter Tharos','Michael Constantine','John Kalangis','Lainie Kazan','Bruce Gray','Andrea Martin','Joey Fatone','Louis Mandylor','Gia Carides','Ian Gomez','Jayne Eastwood','Fiona Reid','Gale Garnett','Stavroula Logothettis','Gerry Mendicino','Maria Vacratsis'],
screenplay:['Nia Vardalos'],
production:['Tom Hanks','Rita Wilson','Gary Goetzman'],
music:['Alexander Janko','Chris Wilson'],
camera:['Jeffrey Jur'],
cut:['Mia Goldman'],
scenography:['Gregory P. Keen','Enrico Campana'],
masks:['Ann Brodie'],
costumes:['Michael Clancy']},
{title:'My Big Fat Greek Wedding 2',
titleCZ:'Moje tlustá řecká svatba 2',
year:2016,
runtime:94,
countries:['USA','Canada'],
genres:['Romance','Comedy','Family'],
director:['Kirk Jones'],
actors:['Peter Tharos','John Stamos','John Corbett','Alex Wolff','Nia Vardalos','Lainie Kazan','Rita Wilson','Elena Kampouris','Andrea Martin','Louis Mandylor','Gia Carides','Ian Gomez','Michael Constantine','Joey Fatone','Kolton Stewart','Jayne Eastwood','Bruce Gray','Fiona Reid','Stavroula Logothettis','Gerry Mendicino','Kathryn Greenwood','Mark Margolis','Jeanie Calleja','Jeff White','Maria Vacratsis','Teresa Pavlinek','Harper Gunn','Lindsay Christopher','Leonidas Castrounis'],
screenplay:['Nia Vardalos'],
production:['Tom Hanks','Rita Wilson','Jonathan Shore','Gary Goetzman'],
music:['Christopher Lennertz'],
camera:['Jim Denault'],
cut:['Mark Czyzewski'],
sound:['Christian P. Minkler'],
scenography:['Gregory P. Keen','Patricia Cuccia'],
masks:['Antoinette Julien'],
costumes:['Gersha Phillips']},
{title:'My Big Fat Greek Wedding 3',
titleCZ:'Moje tlustá řecká svatba 3',
year:2023,
runtime:93,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Nia Vardalos'],
actors:['Nia Vardalos','John Corbett','Elena Kampouris','Louis Mandylor','Lainie Kazan','Andrea Martin','Gia Carides','Joey Fatone','Stephanie Nur','Elias Kacavas','Daphne Alexander','Stavroula Logothettis','Maria Vacratsis','Gerry Mendicino','Melina Kotselou','Peter Tharos','Alexis Georgoulis','Jeanie Calleja','Kathryn Greenwood','Jayne Eastwood','Ileana Handrinou'],
screenplay:['Nia Vardalos'],
production:['Gary Goetzman','Tom Hanks','Rita Wilson'],
music:['Stephanie Economou'],
camera:['Barry Peterson'],
cut:['Annette Davey','Craig Herring'],
sound:['Colin Nicolson'],
scenography:['Grant Armstrong','Michael Standish'],
costumes:['Timothy A. Wonsik']},
{title:'She Came at Night',
titleCZ:'Přišla v noci',
year:2023,
runtime:85,
countries:['Czechia'],
genres:['Comedy','Drama','Horror'],
director:['Jan Vejnar','Tomáš Pavlíček'],
actors:['Simona Peková','Jiří Rendl','Annette Nesvadbová','Vladimír Kratina','Judit Pecháček','Jan Vondráček','Vasil Fridrich','Denisa Barešová','Michal Kern'],
screenplay:['Jan Vejnar','Tomáš Pavlíček'],
production:['Pavel Vácha','Eva Pavlíčková','Tomáš Pavlíček','Jan Vejnar','Šimon Dvořáček'],
music:['Aid Kid'],
camera:['Šimon Dvořáček'],
cut:['Jakub Vansa'],
sound:['Michaela Patríková'],
scenography:['Zuzana Mazáčová']},
{title:'Restore Point',
titleCZ:'Bod obnovy',
year:2023,
runtime:116,
countries:['Czechia','Slovakia','Poland','Srbsko'],
genres:['Sci-Fi','Crime','Drama','Thriller'],
director:['Robert Hloz'],
actors:['Andrea Mohylová','Matěj Hádek','Milan Ondrík','Václav Neužil ml.','Karel Dobrý','Agáta Kryštůfková','Katarzyna Zawadzka','Iveta Dušková','Jan Vlasák','Richard Stanke','Adam Vacula','Jan Jankovský','Lech Dyblik','Lucie Štěpánková','Daniel Rouha','Tereza Richtrová','Terezie Holá','Zdeňka Goričev Hrdličková','Petr Kleňha','Filip Minařík','Barbora Dragounová'],
screenplay:['Tomislav Čečka','Robert Hloz','Zdeněk Jecelín'],
production:['Jan Kallista','Pavel Berčík','Silvie Michajlova','Karla Stojáková','Ondřej Zima'],
music:['Jan Šléška'],
camera:['Filip Marek'],
cut:['Jarosław Kamiński'],
sound:['Lukáš Ujčík','Samuel Jurkovič','Jan Šulcek'],
scenography:['Ondřej Lipenský'],
masks:['Vladimír Wittgruber'],
costumes:['Ivan Stekla','Eliška Krejzová']},
{title:'Her Body',
titleCZ:'Její tělo',
year:2023,
runtime:108,
countries:['Czechia','Slovakia'],
genres:['Drama'],
director:['Natálie Císařovská'],
actors:['Natalia Germani','Denisa Barešová','Zuzana Mauréry','Martin Finger','Cyril Dobrý','Zuzana Stivínová','Tereza Švejdová','Karolína Krézlová','Štěpán Lustyk','Jiří Rendl','Andrej Polák','Roman Polák','Jan Fanta','Lucia Čižinská','Miroslav Maršálek','Jiří Miroslav Valůšek','Martina Mrakviová','Jan Hodač'],
screenplay:['Natálie Císařovská','Aneta Honzková'],
production:['Viktor Schwarcz','Alena Müllerová','Katarína Krnáčová'],
music:['Aid Kid'],
camera:['Klára Belicová'],
cut:['Jan Daňhel'],
sound:['František Šec'],
scenography:['Jan Pjena Novotný'],
costumes:['Petra Krčmářová']},
{title:'Cesta pustým lesem',
titleCZ:'Cesta pustým lesem',
year:1997,
runtime:87,
countries:['Czechia'],
genres:['Drama','Parable','Poetic'],
director:['Ivan Vojnár'],
actors:['Václav Koubek','Pavel Landovský','Eliška Sirová','Jana Dolanská','Karel Pospíšil','Matěj Hádek','Terezka Tobolová','Jiří Soukup','Vladimír Labský'],
screenplay:['Jiří Soukup','Ivan Arsenjev'],
production:['Čestmír Kopecký'],
music:['Vojtěch Havel','Irena Havlová'],
camera:['Jaromír Kačer'],
cut:['Alois Fišárek'],
sound:['Miroslav Hřebejk'],
scenography:['Vladimír Labský'],
costumes:['Jan Tobola']},
{title:'La Grande Bouffe',
titleCZ:'Velká žranice',
year:1973,
runtime:135,
countries:['France','Italy'],
genres:['Drama','Comedy'],
director:['Marco Ferreri'],
actors:['Marcello Mastroianni','Michel Piccoli','Philippe Noiret','Ugo Tognazzi','Andréa Ferréol','Florence Giorgetti','Maurice Dorléac','Monique Chaumette','Michèle Alexandre','Louis Navarre','Bernard Menez','Gérard Boucaron','James Campbell','Eva Simonet','Giuseppe Maffioli'],
screenplay:['Marco Ferreri'],
production:['Vincent Malle'],
music:['Philippe Sarde'],
camera:['Mario Vulpiani'],
cut:['Claudine Merlin'],
scenography:['Michel de Broin'],
masks:['Alfonso Gola'],
costumes:['Gitt Magrini']},
{title:'The Whale',
titleCZ:'Velryba',
year:2022,
runtime:117,
countries:['USA'],
genres:['Drama'],
director:['Darren Aronofsky'],
actors:['Brendan Fraser','Sadie Sink','Hong Chau','Ty Simpkins','Samantha Morton','Sathya Sridharan','Huck Milner'],
screenplay:['Samuel D. Hunter','Samuel D. Hunter'],
production:['Darren Aronofsky','Jeremy Dawson','Ari Handel'],
music:['Rob Simonsen'],
camera:['Matthew Libatique'],
cut:['Andrew Weisblum'],
sound:['Craig Henighan','Skip Lievsay','Drew Kunin','Chris Chae'],
scenography:['Mark Friedberg','Robert Pyzocha','Lisa Scoppa'],
masks:['Judy Chin','Adrien Morot','Anne Marie Bradley'],
costumes:['Danny Glicker']},
{title:'Will the World Remember Your Name?',
titleCZ:'Bude si svět pamatovat tvoje jméno?',
year:2017,
runtime:17,
countries:['Czechia'],
genres:['Short','Documentary'],
director:['Marie-Magdalena Kochová'],
camera:['Marie-Magdalena Kochová'],
cut:['Marie-Magdalena Kochová'],
sound:['Jan Knot']},
{title:'Winnie the Pooh: Blood and Honey',
titleCZ:'Medvídek Pú: Krev a med',
year:2023,
runtime:84,
countries:['UK'],
genres:['Horror'],
director:['Rhys Waterfield'],
actors:['Amber Doig-Thorne','Richard D. Myers','Natasha Rose Mills','May Kelly','Danielle Ronald','Marcus Massey','Nikolai Ivakhiv','Craig David Dowsett','Chris Cordell','Paula Coiz','Maria Taylor','Natasha Tosini'],
screenplay:['Rhys Waterfield'],
production:['Rhys Waterfield','Scott Jeffrey'],
music:['Andrew Scott Bell'],
camera:['Vince Knight']},
{title:'3:10 to Yuma',
titleCZ:'3:10 Vlak do Yumy',
year:2007,
runtime:122,
countries:['USA'],
genres:['Western','Drama','Action'],
director:['James Mangold'],
actors:['Russell Crowe','Christian Bale','Logan Lerman','Dallas Roberts','Ben Foster','Peter Fonda','Vinessa Shaw','Alan Tudyk','Luce Rains','Gretchen Mol','Lennie Loftin','Rio Alexander','Johnny Whitworth','Jason Rodriguez','Kevin Durand','Chris Browning','Chad Brummett','Forrest Fyre','Luke Wilson','Benjamin Petry','Arron Shiver','Sean Hennigan','Girard Swan','Christopher Berry','King Orba','James Blackburn','Billy Lockwood','J. Nathan Simmons'],
basedOn:['Elmore Leonard'],
screenplay:['Michael Brandt','Derek Haas','Halsted Welles'],
production:['Cathy Konrad'],
music:['Marco Beltrami'],
camera:['Phedon Papamichael'],
cut:['Michael McCusker'],
sound:['Donald Sylvester','Paul Massey','David Giammarco'],
scenography:['Andrew Menzies','Greg Berry','Jay Hart'],
masks:['Kathrine Gordon','Jane Galli','L. Taylor Roberts','Leah Vautrot'],
costumes:['Arianne Phillips']},
{title:'King Kong',
titleCZ:'King Kong',
year:1976,
runtime:128,
countries:['USA'],
genres:['Adventure','Fantasy','Romance','Thriller','Horror'],
director:['John Guillermin'],
actors:['Jeff Bridges','Jessica Lange','Charles Grodin',"Jack O'Halloran",'John Randolph','René Auberjonois','Julius Harris','Dennis Fimple','Ed Lauter','Jorge Moreno','John Lone','John Agar','Corbin Bernsen','Brent Huff','Joe Piscopo','Rick Baker','Forrest J. Ackerman','Walt Gorney','Eve McVeagh','Garry Walberg','Mario Gallo','Wayne Heffley','David Roya','Sid Conrad','Keny Long','Todd Baker'],
screenplay:['Lorenzo Semple Jr.','James Ashmore Creelman'],
production:['Dino De Laurentiis'],
music:['John Barry'],
camera:['Richard H. Kline'],
cut:['Ralph E. Winters'],
sound:['Jack Solomon'],
scenography:['Mario Chiari','Dale Hennesy','Robert Gundlach'],
masks:['Del Acevedo','John Truwe','Rob Bottin','Rick Baker'],
costumes:['Anthea Sylbert','Moss Mabry']},
{title:'King Kong',
titleCZ:'King Kong',
year:2005,
runtime:187,
countries:['New Zealand','USA','Germany'],
genres:['Action','Adventure','Drama','Romance'],
director:['Peter Jackson'],
actors:['Naomi Watts','Jack Black','Adrien Brody','Andy Serkis','Jamie Bell','Lobo Chan','Colin Hanks','Evan Parke','Kyle Chandler','Thomas Kretschmann','Mark Hadlow','Craig Hall','Billy Jackson','Christian Rivers','Vicky Haughton','Lee Donoghue','Frank Darabont','Matthew Chamberlain','Matt Gillanders','Howard Shore','Eric Vespe','Louis Sutherland','Rick Baker','Jed Brophy','Tom Hobbs','Camille Keenan','Jim Knobeloch','Joe Folau','Edwin Wright','John Sumner','David Dennis','Lorraine Ashbourne','Randall William Cook','Stig Eldred','Latham Gaines','David Pittu','Peter McKenzie','Eddie Campbell','Jimmy Star','Jim McLarty','Tim Kano','Ross Duncan','Will Wallace','Samuel E. Shore','John Dybvig','Thomas Robins','Alice Dinnean'],
screenplay:['Fran Walsh','Philippa Boyens','Peter Jackson'],
production:['Peter Jackson','Fran Walsh','Carolynne Cunningham'],
music:['James Newton Howard'],
camera:['Andrew Lesnie'],
cut:['Jamie Selkirk'],
sound:['Mike Hopkins','Ethan Van der Ryn','Michael Semanick','Christopher Boyes','Michael Hedges','Dave Whitehead','Tom Johnson'],
scenography:['Grant Major','Simon Bright','Simon Bright'],
masks:["Peter 'Swords' King",'Gino Acevedo','Dominie Till','Rick Findlater','Louise Harris','Shiree Collier','Susie Glass'],
costumes:['Terry Ryan']},
{title:'King Kong',
titleCZ:'King Kong',
year:1933,
runtime:100,
countries:['USA'],
genres:['Adventure','Fantasy','Horror'],
director:['Merian C. Cooper','Ernest B. Schoedsack'],
actors:['Fay Wray','Robert Armstrong','Bruce Cabot','Frank Reicher','Sam Hardy','James Flavin','Ernest B. Schoedsack','Dorothy Gulliver','Merian C. Cooper','Roscoe Ates','Everett Brown','Paul Porcasi','Charles Sullivan','Frank Mills','Gil Perkins','Harry Tenbrook','Edwin Rochelle','Syd Saylor','Ethan Laidlaw','Larry Steers','George Magrill','Harry Strang','Victor Wong','Dick Curtis','Earl Dwire','Lynton Brent','Oliver Eckhardt',"Frank O'Connor",'LeRoy Mason','King Mojave','Russ Powell','Jack Perry','Jimmy Dime','Blackie Whiteford','Frank Fanning','Bill Williams','Eddie Boland','Vivian Dandridge','Sailor Vincent','Lee Phelps','Vera Lewis','Roy Stewart','Edward Clark','John Northpole',"Paddy O'Flynn",'Noble Johnson','Roy Brent','Jack Pratt','Eddie Hart','Larry McGrath','Louise Emmons','Florence Dudley','Blue Washington','Jean Fenwick','Pat Harmon','George MacQuarrie','Harry Bowen','Ray Turner','June Gittelson','Monte Vandergrift','Harry Keaton','Gertrude Sutton','Steve Clemente','Lew Harvey','Ruby Dandridge','Jim Thorpe','Etta McDaniel'],
screenplay:['James Ashmore Creelman','Edgar Wallace'],
production:['Merian C. Cooper','Ernest B. Schoedsack'],
music:['Max Steiner'],
camera:['Vernon L. Walker','Kenneth Peach','Edward Linden'],
cut:['Ted Cheesman'],
sound:['Clem Portman'],
scenography:['Carroll Clark','Ray Moyer'],
costumes:['Walter Plunkett']},
{title:'The Mighty Kong',
titleCZ:'King Kong',
year:1998,
runtime:'998',
countries:['USA'],
genres:['Family','Animation'],
actors:['Dudley Moore','Jodi Benson','Bill Sage','Jason Gray-Stanford','Michael Dobson','Paul Dobson','Ian James Corlett'],
screenplay:['James Ashmore Creelman'],
production:['Denis de Vallance'],
music:['David Siebels'],
sound:['Kerri Wilson']},
{title:"Bridget Jones's Diary",
titleCZ:'Deník Bridget Jonesové',
year:2001,
runtime:93,
countries:['UK','Ireland','France'],
genres:['Comedy','Romance'],
director:['Sharon Maguire'],
actors:['Renée Zellweger','Colin Firth','Hugh Grant','Jim Broadbent','Gemma Jones','Celia Imrie','James Faulkner','Charmian May','Paul Brooke','Felicity Montagu','Shirley Henderson','Sally Phillips','James Callis','Salman Rushdie','Embeth Davidtz','Rebecca Charles','Patrick Barlow','Joan Blackham','Honor Blackman','Lisa Barbuscia','Neil Pearson','Paul Ross','Stewart Wright','Claire Skinner','Dolly Wells','David Cann','Lisa Kay','Sarah Alexander','Crispin Bonham-Carter','Stefan Booth','June Smith'],
basedOn:['Helen Fielding'],
screenplay:['Helen Fielding','Andrew Davies','Richard Curtis'],
production:['Tim Bevan','Eric Fellner','Jonathan Cavendish'],
music:['Patrick Doyle'],
camera:['Stuart Dryburgh'],
cut:['Martin Walsh'],
sound:['David Crozier','Glenn Freemantle','Nicolas Le Messurier','Richard Pryke'],
scenography:['Gemma Jackson','David Warren'],
masks:['Karen Cohen','Graham Johnston'],
costumes:['Rachael Fleming']},
{title:"Bridget Jones's Baby",
titleCZ:'Dítě Bridget Jonesové',
year:2016,
runtime:118,
countries:['UK','France','Ireland','USA'],
genres:['Comedy','Romance'],
director:['Sharon Maguire'],
actors:['Renée Zellweger','Colin Firth','Patrick Dempsey','Emma Thompson','Shirley Henderson','Sarah Solemani','Jim Broadbent','James Callis','Celia Imrie','Sally Phillips','Gemma Jones','Enzo Cilenti','Ed Sheeran','Mark Arnold','Lasco Atkins','Adam Prickett','Clem So','Marilyn May James','Martyn Mayger','Ben Willbond','Lee Nicholas Harris','Adam Leese','Cedric Tylleman','Shaun Newnham','Attila G. Kerekes','Kornelia Horvath','Joanna Scanlan','Beattie Edmondson','Dustin Demri-Burns','Cathy Murphy','Nick Mohammed','Gbola Adewunmi',"Kate O'Flynn",'Dominic Coleman','Charlie Rawes','David Crow','Pamela Betsy Cooper','Pete Meads','Ashley McGuire','Annarie Boor','Clea Martin','Daniel Stisen','Rafferty Railton','Laura Checkley','Neil Pearson','Matt Rentell','Monica Lovari','Aiste S. Gram','Elena Valdameri'],
basedOn:['Helen Fielding'],
screenplay:['Helen Fielding','Dan Mazer','Emma Thompson'],
production:['Eric Fellner','Tim Bevan','Debra Hayward'],
music:['Craig Armstrong'],
camera:['Andrew Dunn'],
cut:['Melanie Ann Oliver'],
sound:['Glenn Freemantle','Brendan Nicholson'],
scenography:['John Paul Kelly'],
masks:['Sam Bear','Rebecca Cole'],
costumes:['Steven Noble']},
{title:'Bridget Jones: The Edge of Reason',
titleCZ:'Bridget Jonesová - S rozumem v koncích',
year:2004,
runtime:108,
countries:['UK','France','Germany','Ireland'],
genres:['Comedy','Romance'],
director:['Beeban Kidron'],
actors:['Renée Zellweger','Hugh Grant','Colin Firth','Jim Broadbent','Gemma Jones','Jacinda Barrett','James Callis','Shirley Henderson','Sally Phillips','Neil Pearson','Jessica Hynes','Tom Brooke','Rosalind Halstead','Neil Dudgeon','Simón Andreu','James Faulkner','Patrick Baladi','Paul Nicholls','Jason Watkins','Jade Ramsey','Sam Hazeldine','Jeremy Paxman','Hon Ping Tang','Alex Jennings','Lucy Robinson','Oliver Chris','Mark Tandy','Nikita Ramsey','David Verrey','Ting-Ting Hu','Catherine Russell','Wolf Kahler','Richard Braine','David Auker','Sam Beazley','Antonia Frering','Hannes Flaschberger','Vee Vimolmal','Lilo Baur','Trevor Fox','Rong Kaomulkadee'],
basedOn:['Helen Fielding'],
screenplay:['Andrew Davies','Helen Fielding','Richard Curtis','Adam Brooks'],
production:['Tim Bevan','Eric Fellner','Jonathan Cavendish'],
music:['Harry Gregson-Williams','Stuart Roslyn'],
camera:['Adrian Biddle'],
cut:['Greg Hayden'],
sound:['Glenn Freemantle','Simon Hayes','Brendan Nicholson','Richard Pryke'],
scenography:['Gemma Jackson','David Warren','Paul Inglis','Anna Lynch-Robinson'],
masks:['Karen Cohen','Graham Johnston'],
costumes:['Jany Temime']},
{title:'Muž v černém',
titleCZ:'Muž v černém',
year:2023,
runtime:60,
countries:['France','USA','UK'],
genres:['Documentary'],
director:['Bing Wang'],
camera:['Caroline Champetier']},
{title:'man in black 2',
titleCZ:'A Black Man in Zimbabwe',
year:2018,
runtime:4,
countries:['South Africa','Zimbabwe'],
genres:['Short','Documentary'],
director:['Roger Horn']},
{title:'man in black 3',
titleCZ:'A Black Man in Zimbabwe',
year:2018,
runtime:4,
countries:['South Africa','Zimbabwe'],
genres:['Short','Documentary'],
director:['Roger Horn']},
{title:'Independence Day',
titleCZ:'Den nezávislosti',
year:1996,
runtime:139,
countries:['USA'],
genres:['Sci-Fi','Action','Thriller','Adventure'],
director:['Roland Emmerich'],
actors:['Will Smith','Jeff Goldblum','Bill Pullman','Mary McDonnell','Judd Hirsch','Mae Whitman','Vivica A. Fox','Margaret Colin','Robert Loggia','James Rebhorn','Randy Quaid','James Duval','Harvey Fierstein','Adam Baldwin','Brent Spiner','Harry Connick','Jr.','Kiersten Warren','Devon Gummersall','Leland Orser','Bobby Hosea','Dan Lauria','Jay Acovone','Frank Welker','Robert Pine','Derek Webster','Erick Avari','Dean Devlin','John Capodice','Lyman Ward','Richard Speight Jr.','Kevin Cooney','Andrew Keegan','Malcolm Danare','Giuseppe Andrews','Thom Barry','Randy Oglesby','Nectar Rose','Tracey Walter','Darin Mangan','Lisa Jakub','Jana Marie Hupp','Bill Smitrovich','Raphael Sbarge','Rance Howard','John Bradley','Peter J. Lucas','Kimberly Beck','Darla Rae','Kristof Konrad','Ross Bagley','Carlos Lacámara','John Bennett Perry','Jon Shear','Jim Piddock','Barry Del Sherman','Jessika Cardinahl','Wayne Wilderson','Greg Collins','Pat Skipper','Frank Novak','Kevin Sifuentes','Nelson Mashita','Thomas F. Duffy','Anthony Crivello','Barry Nolan','David Pressman','Tim Kelleher','Volker Engel','Jake Garber','Levani','Greg Bronson','Joyce Cohen','Jerry Dunphy','John McLaughlin','Daren Dochterman','Mark Fite'],
screenplay:['Dean Devlin','Roland Emmerich'],
production:['Dean Devlin'],
music:['David Arnold'],
camera:['Karl Walter Lindenlaub'],
cut:['David Brenner'],
sound:['Bob Beemer','Tod A. Maitland','Chris Carpenter'],
scenography:['Oliver Scholl','Patrick Tatopoulos','Jim Erickson'],
masks:['Stacey Morris'],
costumes:['Joseph A. Porro']},
{title:'Countdown: Jerusalem',
titleCZ:'Zúčtování: Armagedon',
year:2009,
runtime:90,
countries:['USA'],
genres:['Thriller','Sci-Fi','Catastrophic'],
director:['A.F. Silver'],
actors:['Kim Little','Emilio Roso','Jose Prendes','Domiziano Arcangeli','Matt Mercer','Meredith Thomas','Jonathan Nation','Hillary Harper'],
screenplay:['David Michael Latt','Jose Prendes'],
production:['David Michael Latt'],
music:['Joseph Trapanese'],
camera:['Adam Silver'],
cut:['Bobby K. Richardson','Brian Brinkman'],
scenography:['Hillary Harper'],
costumes:['Jennifer L. Beck']},
{title:'Armageddon',
titleCZ:'Armageddon',
year:1998,
runtime:151,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Thriller','Catastrophic'],
director:['Michael Bay'],
actors:['Bruce Willis','Billy Bob Thornton','Ben Affleck','Liv Tyler','Will Patton','Steve Buscemi','William Fichtner','Owen Wilson','Michael Clarke Duncan','Peter Stormare','Ken Hudson Campbell','Jessica Steen','Keith David','Chris Ellis','Jason Isaacs','Grayson McCouch','Marshall R. Teague','Greg Collins','John Mahon','Grace Zabriskie','Eddie Griffin','Jim Ishida','Stanley Anderson','James Harper','Ellen Cleghorne','Udo Kier','John Aylward','Mark Curry','Seiko Macuda','Dyllan Christopher','Judith Hoag','Sage Allen','Steven Ford','Christian Clemenson','Andy Ryan','Michael Taliferro','Shawnee Smith','Dwight Hicks','Odile Corso','Jim Maniaci','Bodhi Elfman','Joseph Patrick Kelly','Peter White','Frank van Keeken','Frederick Weller','Jeff Austin','Googy Gress','Matt Malloy','H. Richard Greene','Brian Brophy','Peter Murnik','Brian Hayes Currie','Andrew Heckler','Andy Milder','Michael Kaplan','Patrick Richwood','Dina Morrone','Jim Fitzpatrick','Charlton Heston','Michael Bay','Judi Beecher','Mark Boone Junior',"Le Ann Cheri'",'Judith Drake','Ronald Fox','John Frazier','Gustavo Perez','Mary Ann Schmidt','Erik Per Sullivan','Lawrence Tierney','Gedde Watanabe','papež Jan Pavel II.'],
screenplay:['Jonathan Hensleigh','J.J. Abrams'],
production:['Jerry Bruckheimer','Gale Anne Hurd','Michael Bay'],
music:['Trevor Rabin'],
camera:['John Schwartzman'],
cut:['Mark Goldblatt','Chris Lebenzon','Glen Scantlebury'],
sound:['Christopher Boyes','Keith A. Wester',"Kevin O'Connell",'Greg P. Russell'],
scenography:['Michael White'],
masks:['Edouard F. Henriques','Yolanda Toussieng','Lynne K. Eagan','Melissa Forney'],
costumes:['Michael Kaplan','Magali Guidasci']},
{title:'The Fast and the Furious',
titleCZ:'Rychle a zběsile',
year:2001,
runtime:106,
countries:['USA','Germany'],
genres:['Action','Crime','Thriller'],
director:['Rob Cohen'],
actors:['Paul Walker','Vin Diesel','Michelle Rodriguez','Jordana Brewster','Rick Yune','Chad Lindberg','Matt Schulze','Ted Levine','Ja Rule','Thom Barry','Noel Gugliemi','Reggie Lee','Rob Cohen','Johnny Strong','Vyto Ruginis','Neal H. Moritz','Norman Gregory McGuire','F. Valentino Morales','Peter Navy Tuiasosopo','Mike White','David Douglas','Angela Rockwood','Jimmy Star'],
screenplay:['Gary Scott Thompson','Erik Bergquist','David Ayer'],
production:['Neal H. Moritz'],
music:['BT'],
camera:['Ericson Core'],
cut:['Peter Honess'],
sound:['Michael C. Casper','Jonathan Wales','Daniel J. Leahy'],
scenography:['Waldemar Kalinowski'],
masks:['Michael Germain','Matthew W. Mungle','Georgina Williams'],
costumes:['Sanja Milkovic Hays']},
{title:'2 Fast 2 Furious',
titleCZ:'Rychle a zběsile 2',
year:2003,
runtime:108,
countries:['USA','Germany'],
genres:['Action','Crime','Thriller'],
director:['John Singleton'],
actors:['Paul Walker','Tyrese Gibson','Cole Hauser','Eva Mendes','Ludacris','Thom Barry','Devon Aoki','Amaury Nolasco','Michael Ealy','James Remar','Mark Boone Junior','Corey Michael Eubanks','Tara Carroll','John Cenatiempo','Jin Auyeung','Mo Gallini','Marc Macaulay','Neal H. Moritz',"Roberto 'Sanz' Sanchez",'Edward Finlay','Tamara Jones'],
screenplay:['Michael Brandt','Derek Haas'],
production:['Neal H. Moritz'],
music:['David Arnold'],
camera:['Matthew F. Leonetti'],
cut:['Bruce Cannon','Dallas Puett'],
sound:['Tom Ozanich','Chris Carpenter','Greg Hedgepath','Andy Koyama'],
scenography:['Keith Brian Burns'],
masks:['Linda Melazzo','Erin Koplow'],
costumes:['Sanja Milkovic Hays']},
{title:'Fast Five',
titleCZ:'Rychle a zběsile 5',
year:2011,
runtime:125,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Justin Lin'],
actors:['Vin Diesel','Paul Walker','Jordana Brewster','Dwayne Johnson','Tyrese Gibson','Elsa Pataky','Gal Gadot','Ludacris','TJ Hassan','Joaquim de Almeida','Matt Schulze','Tego Calderón','Don Omar','Sung Kang','Alimi Ballard','Geoff Meed','Eva Mendes','Mark Hicks','Amanda Salinas','Corey Michael Eubanks','Benjamin Easterday','Natalie Gal','Luis Da Silva Jr.','Jeimy Osorio','Arlene Santana','Jay Jackson','Yorgo Constantine','Michael Irby','Pedro García','Richard Tavernaro','Fernando Chien','Blue Kimble','L. Stephanie Ray','Esteban Cueto','Jimmy Star','JT Tomangi'],
screenplay:['Chris Morgan'],
production:['Neal H. Moritz','Michael Fottrell','Vin Diesel'],
music:['Brian Tyler'],
camera:['Stephen F. Windon'],
cut:['Fred Raskin','Christian Wagner','Kelly Matsumoto'],
sound:['Jon Taylor','Stephen P. Robinson','Frank A. Montaño'],
scenography:['Peter Wenham','Bob Kensinger'],
masks:['John Blake','Nikki Bell','Joani Yarbrough','James MacKinnon'],
costumes:['Sanja Milkovic Hays']},
{title:'Fast & Furious 6',
titleCZ:'Rychle a zběsile 6',
year:2013,
runtime:130,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Justin Lin'],
actors:['Vin Diesel','Paul Walker','Dwayne Johnson','Michelle Rodriguez','Luke Evans','Tyrese Gibson','Gina Carano','Sung Kang','Gal Gadot','Ludacris','Jordana Brewster','Elsa Pataky','Benjamin Davies','Joe Taslim','Clara Paget','Lee Asquith-Coe','Kim Kold','Thure Lindhardt','Rowena Diamond','John Ortiz','Jason Statham','Shea Whigham','Rita Ora','Matthew Stirling','David Ajala','Andrei Zayats','Deborah Rosan','Gemita Samarra','Clem So','Mark Haldor','Stephen Marcus','Andrew Koji','Chris Wilson','Alex Martin','Jason Thorpe','Catherine Delaloye','Jimmy Star','Victor Gardener'],
screenplay:['Chris Morgan'],
production:['Neal H. Moritz','Clayton Townsend','Vin Diesel'],
music:['Lucas Vidal'],
camera:['Stephen F. Windon'],
cut:['Christian Wagner',"Greg D'Auria",'Dylan Highsmith','Kelly Matsumoto','Leigh Folsom Boyd'],
sound:['Jay Wilkinson','Jon Taylor','Stephen P. Robinson','Frank A. Montaño','Oleg Kulchytskyi'],
scenography:['Jan Roelfs','Richard Roberts','Toby Britton','Su Whitaker','Guy Bradley','Gavin Fitch'],
masks:['John Blake','Amanda Knight','Amy Byrne','Nora Robertson'],
costumes:['Sanja Milkovic Hays']},
{title:'Furious 7',
titleCZ:'Rychle a zběsile 7',
year:2015,
runtime:137,
countries:['USA','Japan'],
genres:['Action','Crime','Thriller'],
director:['James Wan'],
actors:['Vin Diesel','Paul Walker','Jason Statham','Michelle Rodriguez','Jordana Brewster','Tyrese Gibson','Ludacris','Dwayne Johnson','Kurt Russell','Tony Jaa','Djimon Hounsou','Lucas Black','Cody Walker','Shad Moss','Nathalie Emmanuel','Iggy Azalea','John Brotherton','Susan Santiago','Noel Gugliemi','Ronda Rousey','Brian Mahoney','Ali Fazal','Anna Colwell','Elsa Pataky','Luke Evans','Gal Gadot','Gentry White','Romeo Santos','Bryan Casserly','Mitchell Yee','John Cenatiempo','Shaker Sangam','Caitlin Dechelle','T-Pain','John Koyama','Michelle Farrah Huang','Levy Tran','Vince Romo','Viviana Chavez','Tara Macken','Jorge-Luis Pallo','Sara Sohn','Adrian Lockett','Elena Diaz','Marina Hova','Priscilla Quintana','Brittney Alger','Brianna Young','Jimmy Star','Bradley Bowen','Rebecah Rye','Callen David','Antwan Mills','Toneata Morgan','Kelsey Delemar'],
screenplay:['Chris Morgan','Gary Scott Thompson'],
production:['Michael Fottrell','Vin Diesel'],
music:['Brian Tyler'],
camera:['Stephen F. Windon','Marc Spicer'],
cut:['Christian Wagner','Kirk M. Morri','Dylan Highsmith','Leigh Folsom Boyd'],
sound:['Jon Taylor','Stephen P. Robinson','Frank A. Montaño','Mark Weingarten','Tim Hays'],
scenography:['Bill Brzeski','Danielle Berman','Jay Pelissier','Jon Carlos'],
masks:['Autumn Butler'],
costumes:['Sanja Milkovic Hays']},
{title:'The Fate of the Furious',
titleCZ:'Rychle a zběsile 8',
year:2017,
runtime:136,
countries:['USA','China','Japan'],
genres:['Action','Crime','Thriller'],
director:['F. Gary Gray'],
actors:['Vin Diesel','Dwayne Johnson','Jason Statham','Charlize Theron','Kurt Russell','Michelle Rodriguez','Tyrese Gibson','Ludacris','Nathalie Emmanuel','Luke Evans','Kristofer Hivju','Helen Mirren','Elsa Pataky','Scott Eastwood','Marko Caka','Branislav R. Tatalovic','Don Omar','Tego Calderón','Patrick St. Esprit','Corey Maher','Olek Krupa','Nick Gracer','Gary Weeks','Matt Cornwell','Anita Farmer Bergman','Tyrone C. Wiggins','Yuliya Zelenskaya','Faith Logan','Darren Lee Campbell','Friday Chamberlain','Gary Lee Vincent','Porche Robinson','Jim Gloyd','Özcan Özdemir','Debbie Scaletta','Lenny Lenox','Myrom Kingery','Kenny Barr','Quavo'],
screenplay:['Chris Morgan'],
production:['Vin Diesel','Michael Fottrell','Neal H. Moritz'],
music:['Brian Tyler'],
camera:['Stephen F. Windon'],
cut:['Christian Wagner','Paul Rubell'],
sound:['Jon Taylor','Stephen P. Robinson','Frank A. Montaño','Mark P. Stoeckinger'],
scenography:['Bill Brzeski','Danielle Berman','Jay Pelissier','Jon Carlos'],
masks:['Autumn Butler','James MacKinnon']},
{title:'F9',
titleCZ:'Rychle a zběsile 9',
year:2021,
runtime:145,
countries:['USA'],
genres:['Action','Adventure','Crime','Thriller'],
director:['Justin Lin'],
actors:['Vin Diesel','Michelle Rodriguez','Jordana Brewster','Tyrese Gibson','Ludacris','Nathalie Emmanuel','John Cena','Charlize Theron','Thue Ersted Rasmussen','Finn Cole','Sung Kang','Anna Sawai','Helen Mirren','Kurt Russell','Lucas Black','Shad Moss','Don Omar','Shea Whigham','JD Pardo','Michael Rooker','Jim Parrack','Siena Agudong','Igby Rigney','Sophia Tatum','Martyn Ford','Bad Bunny','Jason Tobin','Cardi B','Ozuna','Jason Statham','Bill Simmons','Amber Sienna','Janice Blue','Miraj Grbic','Mark Krenik','Jimmy Star','Francis Ngannou','Vinnie Bennett'],
screenplay:['Daniel Casey','Justin Lin'],
production:['Neal H. Moritz','Vin Diesel','Justin Lin','Jeff Kirschenbaum','Joe Roth','Clayton Townsend','Samantha Vincent'],
music:['Brian Tyler'],
camera:['Stephen F. Windon'],
cut:['Dylan Highsmith','Kelly Matsumoto',"Greg D'Auria"],
sound:['Stephen P. Robinson','Jon Taylor','Frank A. Montaño','Oleg Kulchytskyi'],
scenography:['Jan Roelfs','Brana Rosenfeld','Toby Britton','Gavin Fitch','Daniel Nussbaumer','Fay Viola'],
masks:['Amanda Knight','Ahou Mofid'],
costumes:['Sanja Milkovic Hays']},
{title:'Fast X',
titleCZ:'Rychle a zběsile 10',
year:2023,
runtime:141,
countries:['USA'],
genres:['Action','Adventure','Crime','Thriller'],
director:['Louis Leterrier'],
actors:['Vin Diesel','Michelle Rodriguez','Jason Momoa','Jordana Brewster','Tyrese Gibson','Ludacris','Nathalie Emmanuel','Brie Larson','Sung Kang','John Cena','Alan Ritchson','Charlize Theron','Jason Statham','Helen Mirren','Scott Eastwood','Luis Da Silva Jr.','Daniela Melchior','Leo Abelo Perry','Joaquim de Almeida','Rita Moreno','Pete Davidson','Miraj Grbic','Meadow Walker','Michael Irby','Debby Ryan','Josh Dun','Paul Walker','Isabelle Bernardo','Alexandre Chen','Calvin Chen','Gal Gadot','Dwayne Johnson','Michael Rooker','Amber Sienna','Reneque Samuels'],
screenplay:['Justin Lin','Dan Mazeau'],
production:['Justin Lin','Neal H. Moritz'],
music:['Brian Tyler'],
camera:['Stephen F. Windon'],
cut:['Dylan Highsmith','Kelly Matsumoto','Laura Yanovich','Corbin Mehl'],
sound:['Stephen P. Robinson','John Casali'],
scenography:['Jan Roelfs','Kathryn Pyle','Chloe Kletsa','Brunella De Cola'],
masks:['Kashiya Hinds'],
costumes:['Sanja Milkovic Hays']},
{title:'Fast & Furious Presents: Hobbs & Shaw',
titleCZ:'Rychle a zběsile: Hobbs a Shaw',
year:2019,
runtime:134,
countries:['USA'],
genres:['Action','Crime','Thriller','Comedy'],
director:['David Leitch'],
actors:['Dwayne Johnson','Jason Statham','Vanessa Kirby','Idris Elba','Helen Mirren','Eiza González','Eddie Marsan','Ryan Reynolds','Eliana Sua','Cliff Curtis','Kevin Hart',"Joe Anoa'i",'Rob Delaney','Tom Wu','Akie Kotabe','Felicity Dean','Peter Basham','Stephanie Vogt','Antonio Mancino','James Dryden','Ella-Rae Smith','Nathan Jones','Spencer Wilding','Axel Nu','Stephen Dunlevy','David Leitch','Teresa Mahoney','Daniel Eghan','Jack Kane','Thalissa Teixeira','Dan Li','Peter Parker Mensah','Ansu Kabia','Conlan Casal','David Mumeni','John Tui','Michael Wildman','Pingi Moli','Meesha Garbett','Sergio Briones','Hio Pelesasa'],
screenplay:['Chris Morgan','Drew Pearce'],
production:['Dwayne Johnson','Jason Statham','Chris Morgan','Hiram Garcia'],
music:['Tyler Bates'],
camera:['Jonathan Sela'],
cut:['Christopher Rouse'],
sound:['Jon Taylor','Stephen P. Robinson','Frank A. Montaño','Mark P. Stoeckinger'],
scenography:['David Scheunemann','Jeffrey Kushon','Shane Vieau','Lisa Chugg','Will Coubrough','Choi Ho Man'],
masks:['Ralph Malani','David Malinowski','Lara Licari'],
costumes:['Sarah Evelyn']},
{title:'The Fast and the Furious: Tokyo Drift',
titleCZ:'Rychle a zběsile: Tokijská jízda',
year:2006,
runtime:100,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Justin Lin'],
actors:['Lucas Black','Sung Kang','Nathalie Kelley','Brian Tee','Shad Moss','Zachery Ty Bryan','Brandon Brendel','Vin Diesel','Satoši Cumabuki','Vincent Laresca','Caroline de Souza Correa','Silvia Šuvadová','Sonny Čiba','Leonardo Nam','Nikki Griffin','Brian Goodman','Lynda Boyd','Keiko Kitagawa','Kevin Ryan','Jóko Maki','Ashika Gogna','April Betts','Amber Stevens West','Rie Šibata','Jason Tobin','Daniel Booko','Paul Leach','Micuki Kóga','Kazuki Namioka','Verena Mei','Tak Kubota','Koji Kataoka','Trula M. Marcus','Keiiči Cučija','Konishiki','Eidži Nakamura'],
screenplay:['Chris Morgan'],
production:['Neal H. Moritz'],
music:['Brian Tyler'],
camera:['Stephen F. Windon'],
cut:['Fred Raskin','Dallas Puett','Kelly Matsumoto'],
sound:['Chris Carpenter'],
scenography:['Ida Random','Jošihito Akacuka','Douglas A. Mowat'],
masks:["Yesim 'Shimmy' Osman",'John Blake'],
costumes:['Sanja Milkovic Hays']},
{title:'King Arthur: Legend of the Sword',
titleCZ:'Král Artuš: Legenda o meči',
year:2017,
runtime:126,
countries:['UK','Australia','USA'],
genres:['Action','Adventure','Drama','Fantasy'],
director:['Guy Ritchie'],
actors:['Charlie Hunnam','Jude Law','Àstrid Bergès-Frisbey','Djimon Hounsou','Eric Bana','Annabelle Wallis','Hermione Corfield','Katie McGrath','David Beckham','Mikael Persbrandt','Freddie Fox','Neil Maskell','Peter Guinness','Poppy Delevingne','Kalle Hennie','Aidan Gillen','Michael McElhatton','Peter Ferdinando','Mark Haldor','Miroslav Zaruba','Attila G. Kerekes','Tom Wu','Claira Watson Parr','Kamil Lemieszewski','Clem So','Eline Powell','Georgina Campbell','Tobias James-Samuels','Jahgo Williams','Charlie Rawes','Lucy Chappell','Kingsley Ben-Adir','Geoff Bell','Jean-Paul Ly','Barney Walsh','Michael Hillberg','Moon Saker','James Warren','Adrian Bouchet','Jason Farries','Clea Martin','Daniel Stisen','Rocci Williams','Cole Wealleans-Watts','Paul Low-Hang','Alan Turkington','Rebecca Calder','Tom Coulston','Jason Lines'],
screenplay:['Joby Harold','Guy Ritchie','Lionel Wigram'],
production:['Tory Tunnell','Lionel Wigram','Guy Ritchie','Joby Harold','Akiva Goldsman'],
music:['Daniel Pemberton'],
camera:['John Mathieson'],
cut:['James Herbert'],
sound:['Dominic Gibbs','Andrew Stirk','Simon Hayes'],
scenography:['Gemma Jackson','Tina Jones','Luke Hull','Luigi Marchione'],
masks:['Christine Blundell','Natalia Osipova','Donald McInnes','Jessica Brooks','Lesa Warrener'],
costumes:['Annie Symons']},
{title:'King Arthur',
titleCZ:'Král Artuš',
year:2004,
runtime:126,
countries:['USA','UK','Ireland'],
genres:['Action','War','History','Adventure'],
director:['Antoine Fuqua'],
actors:['Clive Owen','Stephen Dillane','Keira Knightley','Ioan Gruffudd','Joel Edgerton','Stellan Skarsgård','Ray Winstone','Hugh Dancy','Til Schweiger','Mads Mikkelsen','Ray Stevenson','Graham McTavish','Ken Stott','David Murray','Owen Teale','Clive Russell','Ivano Marescotti','Charlie Creed-Miles','Ned Dennehy',"Lochlainn O'Mearain",'Lorenzo De Angelis','Maria Gładkowska','Sean Gilder',"Gerry O'Brien",'Des Braiden','Stefania Orsola Garello','Shane Murray-Corcoran','Robert Knox','Dawn Bradfield','Sylvia Rohrer'],
screenplay:['David Franzoni'],
production:['Jerry Bruckheimer'],
music:['Hans Zimmer','Jake Jackson'],
camera:['Sławomir Idziak'],
cut:['Conrad Buff IV','Jamie Pearson'],
sound:['Eddy Joseph','Neil Collymore',"Kevin O'Connell"],
scenography:['Paul Cross','Dan Weil'],
masks:['Ailbhe Lemass','Amy Byrne','Jan Hope-Kavanagh','Uxue Laguardia','Sharon Doyle'],
costumes:['Penny Rose']},
{title:'Delta Force',
titleCZ:'Delta Force',
year:1995,
runtime:54,
countries:['USA'],
genres:['Documentary'],
director:['Glen Ellis'],
actors:['Ken Saro-Wiwa']},
{title:'Die Hard with a Vengeance',
titleCZ:'Smrtonosná past 3',
year:1995,
runtime:131,
countries:['USA'],
genres:['Action','Thriller','Crime'],
director:['John McTiernan'],
actors:['Bruce Willis','Jeremy Irons','Samuel L. Jackson','Graham Greene','Colleen Camp','Anthony Peck','Kevin Chamberlin','Michael Cristofer','Tony Travis','Jeannie Epper','John Doman','Aasif Mandvi','Aldis Hodge','Edwin Hodge','Tony Halme','Leslie Ann Phillips','Dick Durock','Michael Tadross','Stephen Pearlman','James Saito','Larry Bryggman','Sharon Washington','Daryl Edwards','Víctor Rojas','Mischa Hausserman','Gerry Becker','Charles Dumas','John C. Vennema','Phyllis Yvonne Stickney','Drew Nelson','Kent Faulcon','J.R. Horne','Andre Ware'],
screenplay:['Jonathan Hensleigh'],
production:['John McTiernan','Michael Tadross'],
music:['Michael Kamen'],
camera:['Peter Menzies Jr.'],
cut:['John Wright'],
sound:['Bob Beemer','Michael Minkler','Kim Maitland','Daniel J. Leahy'],
scenography:['Jackson De Govia'],
masks:['Cecilia Verardi','Verne Caruso','Marilyn Peoples'],
costumes:['Joseph G. Aulisi']},
{title:'Live Free or Die Hard',
titleCZ:'Smrtonosná past 4.0',
year:2007,
runtime:128,
countries:['USA','UK'],
genres:['Action','Crime','Thriller'],
director:['Len Wiseman'],
actors:['Bruce Willis','Timothy Olyphant','Justin Long','Maggie Q','Cliff Curtis','Jonathan Sadowski','Kevin Smith','Cyril Raffaelli','Mary Elizabeth Winstead','Sung Kang','Željko Ivanek','Christina Chang','Chris Ellis',"Matt O'Leary",'Tim Russ','Yancey Arias','Rick Cramer','Jake McDorman','Michael Ahl','Gerald Downey','Allen Maldonado','Ethan Flower','Edoardo Costa','Tim DeZarn','Alexander Kanellakos','George W. Bush','Jimmy Carter','Bill Clinton','Dwight D. Eisenhower','Lyndon B. Johnson','John F. Kennedy','Richard Nixon','Gerald Ford','Ronald Reagan','Franklin D. Roosevelt','Yorgo Constantine','Nadine Ellis','John Lacy','Jim Cantafio','Drew Nelson','Andrew Friedman','Edward James Gage','Tamieka Chavis',"Chris O'Brocki"],
screenplay:['Mark Bomback'],
production:['Michael Fottrell'],
music:['Marco Beltrami'],
camera:['Simon Duggan','James Peterson'],
cut:['Nicolas De Toth'],
sound:['Ai-Ling Lee','Andy Nelson','Anna Behlmer'],
scenography:['Patrick Tatopoulos','Robert Gould'],
masks:['Gerald Quist','Scott Cameron','Toni-Ann Walker'],
costumes:['Denise Wingate']},
{title:"Don't Die Too Hard!",
titleCZ:'Téměř smrtonosná past',
year:2001,
runtime:92,
countries:['France'],
genres:['Comedy'],
director:['Charles Nemes'],
actors:['Eric Judor','Ramzy Bedia','Marina Foïs','Serge Riaboukine','Edgar Givry','Pierre-François Martin-Laval','Benoît Giros','Joey Starr','Omar Sy','Fred Testot','Pierre Semmler','Jean-Claude Dauphin','Thibault Lacroix','Michel Puterflam','Olivier Balazuc','Bruce Lester-Johnson','Bô Gaultier de Kermoal','Vincent Haquin'],
screenplay:['Kader Aoun','Xavier Matthieu'],
production:['Christian Fechner'],
music:['Jean-Claude Vannier'],
cut:['Dominique Galliéni'],
masks:['Françoise Quilichini'],
costumes:['Julie Mauduech']},
{title:'A Good Day to Die Hard',
titleCZ:'Smrtonosná past: Opět v akci',
year:2013,
runtime:105,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['John Moore'],
actors:['Bruce Willis','Jai Courtney','Sebastian Koch','Mary Elizabeth Winstead','Julia Snigir','Radivoje Bukvič','Cole Hauser','Amaury Nolasco','Sergej Kolesnikov','Roman Luknár','Zolee Ganxsta','Péter Takátsy','Pasha D. Lychnikoff','Megalyn Echikunwoke','Melissa Tang','Rico Simonini','Ján Gallovič','Patrik "Rytmus" Vrbovský','Joe Massingill','Attila Árpa','Martin Hindy','Iván Kamarás','Chris Majors','Anne Vyalitsyna','Scott Michael Campbell','Cooper Thornton','Saša Komarov','Justin Smith'],
screenplay:['Skip Woods'],
production:['Wyck Godfrey'],
music:['Marco Beltrami'],
camera:['Jonathan Sela'],
cut:['Dan Zimmerman'],
sound:['Jay Wilkinson','Ron Bartlett','Doug Hemphill'],
scenography:['Daniel T. Dorrance'],
masks:['Edouard F. Henriques','Lynda Armstrong','Gerald Quist'],
costumes:['Bojana Nikitovič']},
{title:'Lethal Weapon 4',
titleCZ:'Smrtonosná zbraň 4',
year:1998,
runtime:119,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Richard Donner'],
actors:['Mel Gibson','Danny Glover','Joe Pesci','Rene Russo','Chris Rock','Jet Li','Steve Kahan','Philip Tan','Kim Chan','Darlene Love','Traci Wolfe','Damon Hines','Ebonie Smith','Steven Lam','Richard Riehle','Simon Rhee','Roger Yuan','James Lew','François Chau','Stephen Blackehart','Frank McRae','Roland Kickinger','Rick Hoffman','Al Sapienza','Conan Lee','Mary Ellen Trainor','Mičiko Nišiwaki','George Cheung','Richard Libertini','Danny Arroyo','Raymond Ma','Benjamin King','Jack Kehler','Elizabeth Sung','Eddy Ko','Bill Henderson','Paul Tuerpe','Dana Lee','Marian Collier','Jennie Lew Tugend','Jessica Jann','Calvin Jung','Barret Swatek','James Wing Woo','Michael Chow','James Oliver','Judith Woodbury','Joyce Ingalls','Sarah Sullivan','John Forker','Kenny Endoso','Jeff Imada','Greg Bronson','Jeanne Chinn','Tim Cooney'],
screenplay:['Channing Gibson'],
production:['Joel Silver'],
music:['Michael Kamen','Eric Clapton','Marcus Miller','David Sanborn'],
camera:['Andrzej Bartkowiak'],
cut:['Kevin Stitt','Frank J. Urioste','Eric Strand','Dallas Puett'],
sound:['Dan Hiland','Mark A. Mangini','John T. Reitz','Gregg Rudloff','David E. Campbell','Gary D. Rogers'],
scenography:['J. Michael Riva'],
masks:['James R. Scribner','Gary Liddiard','Robin L. Neal','Julie Hewett'],
costumes:['Ha Nguyen']},
{title:'Hardware',
titleCZ:'Zbraň',
year:1990,
runtime:93,
countries:['UK'],
genres:['Sci-Fi','Horror','Thriller'],
director:['Richard Stanley'],
actors:['Dylan McDermott','Stacey Travis','John Lynch','Carl McCoy','Iggy Pop','Mac McDonald','William Hootkins','Lemmy','Richard Stanley','Eva Garbo','Chris McHallem'],
screenplay:['Richard Stanley'],
production:['Paul Trijbits','JoAnne Sellar'],
music:['Simon Boswell'],
camera:['Steven Chivers'],
cut:['Derek Trigg'],
sound:['Ronald Bailey'],
scenography:['Joseph Bennett'],
masks:['Kirstin Chalmers']},
{title:'Men in Black: International',
titleCZ:'Muži v černém: Globální hrozba',
year:2019,
runtime:115,
countries:['USA'],
genres:['Comedy','Sci-Fi','Action'],
director:['F. Gary Gray'],
actors:['Chris Hemsworth','Tessa Thompson','Liam Neeson','Emma Thompson','Rafe Spall','Rebecca Ferguson','Kumail Nanjiani','Stephen Wight','Anatole Taubman','Marcy Harriell','Jess Radomska','Andy Beckwith','Ania Sowinski','Ariana Grande','Natasha Culzac','Christopher Amos','Beau Fowler','Mandeiya Flory','Daniel Scott-Smith','Jeff Kim','Aron von Andrian'],
basedOn:['Lowell Cunningham'],
screenplay:['Matt Holloway','Art Marcum'],
production:['Laurie MacDonald','Walter F. Parkes'],
music:['Chris Bacon','Danny Elfman'],
camera:['Stuart Dryburgh'],
cut:['Christian Wagner','Matthew Willard'],
sound:['Julian Slater','Paul N.J. Ottosson'],
scenography:['Charles Wood','Su Whitaker','David Doran'],
masks:['Jeremy Woodhead','Matiki Anoff','Matteo Silvi','Marie Deehan'],
costumes:['Penny Rose']},
{title:'Men in black: alien attack',
titleCZ:'Men in Black Alien Attack',
year:2000,
runtime:4,
countries:['USA'],
genres:['Short','Sci-Fi','Action'],
director:['Linda Hassani'],
actors:['Will Smith','Rip Torn','Gregg Berger'],
screenplay:['Tracy Berna'],
music:['Andy Garfield']},
{title:'Gladiator 2',
titleCZ:'Gladiator 2',
year:2024,
runtime:'024',
countries:['UK','USA'],
genres:['Action','Adventure','Drama'],
director:['Ridley Scott'],
actors:['Paul Mescal','Denzel Washington','Pedro Pascal','Connie Nielsen','Djimon Hounsou','Joseph Quinn','Fred Hechinger','Derek Jacobi','Matt Lucas','Lior Raz','May Calamawy','Peter Mensah'],
screenplay:['David Scarpa'],
production:['Lucy Fisher','David Franzoni','Laurie MacDonald','Walter F. Parkes','Michael A. Pruss','Ridley Scott','Douglas Wick'],
camera:['Dariusz Wolski'],
scenography:['Arthur Max'],
costumes:['Janty Yates']},
{title:'venom 3',
titleCZ:'Venom 3',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Action','Adventure','Sci-Fi'],
director:['Kelly Marcel'],
actors:['Tom Hardy','Juno Temple','Chiwetel Ejiofor'],
screenplay:['Kelly Marcel'],
production:['Avi Arad','Amy Pascal','Tom Hardy','Kelly Marcel','Hutch Parker','Matthew Tolmach']},
{title:'Moana 2',
titleCZ:'Moana 2',
year:2024,
runtime:'024',
countries:['USA'],
genres:['Animation','Adventure','Comedy'],
director:['David G. Derrick Jr.'],
screenplay:['David G. Derrick Jr.'],
production:['Osnat Shurer']},
{title:'If',
titleCZ:'If',
year:2023,
runtime:13,
countries:['Canada'],
genres:['Short','Adventure'],
director:['Didier Charette'],
actors:['Brittany Drisdelle'],
screenplay:['Didier Charette'],
production:['Didier Charette'],
music:['Philippe Brault'],
camera:['Simon-Pierre Gingras'],
cut:['Paul Jutras']},
{title:'The Pacifier',
titleCZ:'Ochránce',
year:2005,
runtime:95,
countries:['Canada','USA'],
genres:['Action','Comedy','Drama','Family'],
director:['Adam Shankman'],
actors:['Vin Diesel','Max Thieriot','Faith Ford','Lauren Graham','Carol Kane','Tate Donovan','Brittany Snow','Kyle Schmid','Jordan Todosey','Anne Fletcher','Brad Garrett','Denis Akiyama','David Sparrow','Morgan York','David Lipper','Chris Potter','Scott Thompson','Nikki Shah','Alexander Conti','Kegan Hoover','Logan Hoover','Mung-Ling Tsui','Christopher Giroux','Tommy Chang','John MacDonald','Matt Purdy','F. Valentino Morales','Christian Laurin','Jean Pearson','Demetrius Joyette'],
screenplay:['Thomas Lennon','Robert Ben Garant'],
production:['Gary Barber','Roger Birnbaum','Jonathan Glickman'],
music:['John Debney'],
camera:['Peter James'],
cut:['Christopher Greenbury'],
sound:['Christian P. Minkler','David E. Fluhr','Paul Menichini'],
scenography:['Linda DeScenna'],
masks:['Linda Dowds','Jean Webber'],
costumes:['Christopher Hargadon','Kirston Leigh Mann']},
{title:'Houdini',
titleCZ:'Houdini',
year:2014,
runtime:'2x83 min',
countries:['Canada','USA'],
genres:['Biographic','Drama'],
director:['Uli Edel'],
actors:['Adrien Brody','Kristen Connolly','Evan Jones','Tim Pigott-Smith','Tom Benedict Knight','Shaun Williamson','Eszter Ónodi','Jeremy Wheeler','József Székhelyi','Tim Woodward','Mark C. Phelan','Veronika Fazekas','Caroline Boulton','Szofi Berki','Stephen Saracco','Niké Kurta','Zétény Nagy','Gyula Mesterházy','Iván Fenyő','Iván Kamarás','László Konter','Wayne Brett','Megan Dodds','David Calder','Linda Marlowe','Madeleine Potter','Michael Terry','Anthony Cozens','Luca Bercovici','Kevin Griffiths','Máté Haumann','Gretchen Meddaugh','Tom Whitecross','Jason Cheater'],
screenplay:['Nicholas Meyer'],
production:['Ildikó Kemény'],
music:['John Debney'],
camera:['Karl Walter Lindenlaub'],
cut:['Sabrina Plisco','David Beatty'],
sound:['Michael J. Benavente','Onnalee Blank','Kenneth R. Burton','Michael Sana'],
scenography:['Patrizia von Brandenstein','Melanie J. Baker'],
masks:['Gregor Eckstein','Jeanette-Nicole Latzelsberger'],
costumes:['Birgit Hutter']},
{title:'Houdini',
titleCZ:'Houdini',
year:1953,
runtime:106,
countries:['USA'],
genres:['Drama','Biographic'],
director:['George Marshall'],
actors:['Tony Curtis','Janet Leigh','Torin Thatcher','Angela Clarke','Stefan Schnabel','Ian Wolfe','Sig Ruman','Michael Pate','Connie Gilchrist','Malcolm Lee Beggs','Frank Orth','Barry Bernard','Douglas Spencer','Eric Alden','Fred Aldrich','Elsie Ames','Peter Baldwin','Bobby Barber','John Barton','Oliver Blake','Billy Bletcher','Paul Bradley','John Breen','Steve Carruthers','Donald Chaffin','Dick Cherney','Cliff Clark','Edward Clark','Bud Cokes','Paul Cristo','Billy Engle','Fred Essler','Bess Flowers','Maxine Gates','Jody Gilbert','Arthur Gould-Porter','Kit Guard','Grace Hayle','Len Hendry','Frank Jaquet','Tor Johnson','Lyle Latell','Lewis Martin','Thomas Martin','William Meader','Mary Murphy','Tudor Owen','Mabel Paige','Ralph Peters','Joe Ploski','Luce Potter','Richard Shannon','Ray Spiker','Bert Stevens','Charles Sullivan','Arthur Tovey','Ernö Verebes','Anthony Warde','Henry Guttman'],
screenplay:['Philip Yordan'],
production:['George Pal'],
music:['Roy Webb'],
camera:['Ernest Laszlo'],
cut:['George Tomasini'],
sound:['Gene Garvin','Harry D. Mills'],
scenography:['Hal Pereira','Ray Moyer','Sam Comer'],
masks:['Wally Westmore'],
costumes:['Edith Head']},
{title:'Angel of the Lord',
titleCZ:'Anděl Páně',
year:2005,
runtime:91,
countries:['Czechia'],
genres:['Fairytale'],
director:['Jiří Strach'],
actors:['Ivan Trojan','Jiří Dvořák','Zuzana Kajnarová','David Švehlík','Zuzana Stivínová','Oldřich Navrátil','Klára Issová','Jana Štěpánková','Josef Somr','Jiří Bartoška','Oldřich Vlach','Martin Zahálka','Otmar Brancuzský','Jakub Konáš','Gabriela Osvaldová','Aňa Geislerová','Veronika Žilková','Jiří Pecha','Jiřina Jirásková','Jana Hlaváčová','Stanislav Zindulka','René Dubovský','Girmah Tewolde','Jin Wenjun','Dana Hlaváčová','Martin Šára','Irena Šmídová','Naďa Izakovičová','Petr Podrazil','Martin Ešpandr','Petr Hanus','Martin Hanuš','Josef Trojan'],
basedOn:['Božena Němcová'],
screenplay:['Lucie Konášová'],
production:['Magdalena Sedláková'],
music:['Miloš Bok'],
camera:['Petr Polák'],
cut:['Zdenek Patočka'],
sound:['Jiří Klenka'],
scenography:['Jiří Veselý'],
masks:['Lukáš Král','Lenka Dýcková'],
costumes:['Jarmila Konečná','Hana Káclová','Dana Bláhová','Božena Měchurová']},
{title:'Angel of the Lord 2',
titleCZ:'Anděl Páně 2',
year:2016,
runtime:95,
countries:['Czechia','Slovakia'],
genres:['Fairytale'],
director:['Jiří Strach'],
actors:['Ivan Trojan','Jiří Dvořák','Vica Kerekes','Anna Čtvrtníčková','Vojtěch Dyk','Bolek Polívka','Stanislav Majer','Pavel Liška','Marek Taclík','Marián Labuda st.','Viktor Preiss','Jiří Bartoška','Klára Issová','Jiřina Bohdalová','Roman Luknár','Veronika Žilková','Jiří Pecha','Martin Huba','Lucie Bílá','Matěj Hádek','Josef Abrhám','Karel Smyczek','Petr Čtvrtníček','Viktor Antonio','Gabriela Osvaldová','Michal Horáček','Valentýna Dvořáková','Ester Singerová','Rosalie Bártová','Hugo Kollár','Patrik Baroš','Dominika Čapková','Elisabeth Vodička','Klaudie Cikánová','Charlotte Ella Gottová','Nelly Sofie Gottová','Zdeněk Dušek','Juraj Šimko','Jiří Fero Burda','Tomáš Stopa','Aleš Hajdalák','Karel Freund','Zdeňka Sajfertová','Lenka Barilíková Spišáková','Zdeněk Velen','Renata Rychlá','František Polívka','Anna Randárová','Judita Hansman','Barbora Palčíková','Matyáš Svoboda','Milan Němec','Růžena Merunková','Josef Pecl','Josef Wiesner','Ján Zachar','Matěj Bendík','Lukáš Bendík','Hana Kusnjerová','Alena Mihulová','Jaroslav Plesl','Karel Vávrovec','Filip Vlastník'],
screenplay:['Jiří Strach','Marek Epstein'],
production:['Svatka Peschková','Šárka Cimbalová'],
music:['Ondřej Gregor Brzobohatý'],
camera:['Martin Šec'],
cut:['Jan Mattlach'],
sound:['Radim Hladík ml.','Matěj Matuška'],
scenography:['David Voborský'],
masks:['Andrea McDonald','Jana McDonald'],
costumes:['Katarína Hollá']},
{title:'Cars 2',
titleCZ:'Auta 2',
year:2011,
runtime:106,
countries:['USA'],
genres:['Animation','Sport','Adventure','Comedy','Family'],
director:['John Lasseter','Bradford Lewis'],
actors:['Owen Wilson','Cheech Marin','Tony Shalhoub','Larry the Cable Guy','Michael Caine','John Turturro','Emily Mortimer','Jason Isaacs','Joe Mantegna','Peter Jacobson','Thomas Kretschmann','Bonnie Hunt','Franco Nero','Eddie Izzard','Jeff Garlin','Paul Dooley','Jenifer Lewis','Katherine Helmond','Jacques Villeneuve','Bruce Campbell','Vanessa Redgrave','John Ratzenberger','Richard Kind','Teresa Gallagher','Velibor Topic','Michel Michelis','Sig Hansen','Stanley Townsend','Sebastian Vettel','Lewis Hamilton','Edie McClurg','Brent Musburger','Jeroen van Inkel','John Mainieri','Guido Quaroni','Zarko Potocnjak'],
screenplay:['Ben Queen'],
production:['Denise Ream'],
music:['Michael Giacchino'],
camera:['Jeremy Lasky'],
cut:['Stephen Schaffer'],
sound:['Gary Rizzo','Michael Semanick'],
scenography:['Harley Jessup']},
{title:'Cars 3',
titleCZ:'Auta 3',
year:2017,
runtime:102,
countries:['USA'],
genres:['Animation','Sport','Adventure','Comedy','Family'],
director:['Brian Fee'],
actors:['Owen Wilson','Chris Cooper','Nathan Fillion','Larry the Cable Guy','Armie Hammer','Bonnie Hunt','Tony Shalhoub','Lea DeLaria','Kerry Washington','Bob Costas','Margo Martindale','Isiah Whitlock Jr.','Bob Peterson','John Ratzenberger','Cheech Marin','Katherine Helmond','Lewis Hamilton','Chase Elliott','Paul Newman','Madeleine McGraw','Guido Quaroni','Zarko Potocnjak','Andra Day','Ryan Blaney','Darrell Wallace Jr.'],
screenplay:['Kiel Murray','Bob Peterson','Mike Rich'],
production:['Kevin Reher'],
music:['Randy Newman'],
camera:['Jeremy Lasky'],
cut:['Jason Hudak'],
sound:['Nathan Nance','Michael Semanick','Brian Chumney'],
scenography:['Paul Abadilla']},
{title:'Toy Story 4',
titleCZ:'Toy Story 4: Příběh hraček',
year:2019,
runtime:100,
countries:['USA'],
genres:['Animation','Fantasy','Adventure','Comedy','Family'],
director:['Josh Cooley'],
actors:['Tom Hanks','Patricia Arquette','Tim Allen','Joan Cusack','Laurie Metcalf','Annie Potts','Bonnie Hunt','John Ratzenberger','Wallace Shawn','Jodi Benson','Don Rickles','Blake Clark','Alec Medlock','Fred Tatasciore','Estelle Harris','Keanu Reeves','Christina Hendricks','Jordan Peele','Jay Hernandez','Timothy Dalton','Betty White','Kristen Schaal','Mel Brooks','Keegan-Michael Key','Jeff Garlin','Tony Hale','Ally Maki','Carl Weathers','Carol Burnett','Carl Reiner','June Squibb','Madeleine McGraw','Alan Oppenheimer','Bud Luckey','Juliana Hansen','Lori Alan'],
screenplay:['Stephany Folsom','Andrew Stanton'],
production:['Jonas Rivera','Mark Nielsen','Galyn Susman'],
music:['Randy Newman'],
camera:['Jean-Claude Kalache'],
cut:['Axel Geddes'],
sound:['Coya Elliott','Ren Klyce','Nathan Nance','Michael Semanick']},
{title:"A Bug's Life",
titleCZ:'Život brouka',
year:1998,
runtime:91,
countries:['USA'],
genres:['Animation','Comedy','Family'],
director:['John Lasseter','Andrew Stanton'],
actors:['Dave Foley','Kevin Spacey','Julia Louis-Dreyfus','Hayden Panettiere','Phyllis Diller','Richard Kind','David Hyde Pierce','Denis Leary','Madeline Kahn','Bonnie Hunt','Michael McShane','Roddy McDowall','Alex Rocco','Carlos Alazraqui','Bob Bergen','Rodger Bumpass','Bill Farmer','Sam Gifaldi','Jess Harnell','John Lasseter','Courtland Mead','Christina Milian','Andrew Stanton','Russi Taylor','Lee Unkrich','Brad Garrett','Ashley Tisdale','Joe Ranft','Kelsey Mulrooney','Kimberly J. Brown','John Ratzenberger','Travis Tedford','Jordan Warkol','Edie McClurg','Phil Proctor','David L. Lander','David Ossman','Francesca Marie Smith','Stig Grybe','Debi Derryberry','Denise Johnson','Paul Eiding','Jan Rabson','Jennifer Darling','Rachel Davey','Jack Angel',"Ryan O'Donohue"],
screenplay:['Andrew Stanton','Don McEnery','Bob Shaw'],
production:['Kevin Reher','Darla K. Anderson'],
music:['Randy Newman'],
sound:['Tim Holland','Gary Summers','Gary Rydstrom','Argiris Kandilis']},
{title:'Monsters University',
titleCZ:'Univerzita pro příšerky',
year:2013,
runtime:104,
countries:['USA'],
genres:['Animation','Fantasy','Adventure','Comedy','Family'],
director:['Dan Scanlon'],
actors:['John Goodman','Billy Crystal','Frank Oz','Steve Buscemi','Nathan Fillion','Jennifer Tilly','Dave Foley','Charlie Day','Julia Sweeney','Joel Murray','John Ratzenberger','Helen Mirren','Bobby Moynihan','Bonnie Hunt','John Krasinski','Tyree Brown','Alfred Molina','Bill Hader','Tyler Labine','Aubrey Plaza','Beth Behrs','Patrick Carlyle','Raymond Ochoa','Ava Acres','Paul Lazenby','Phil Proctor','John Cygan','Teresa Ganzel','David Neher','Montse Hernandez','Betsy Sodaro',"Bret 'Brook' Parker",'Donald Fullilove','Mindy Sterling','Kristen Li','Lori Alan','April Winchell','Jan Rabson','David Theune','Mona Marshall','Donovan Patton','Danny Mann','Neil Campbell','Andy Fischer-Price','Cristina Pucelli','Jack Angel'],
screenplay:['Pete Docter','Andrew Stanton','Robert L. Baird'],
production:['Kori Rae'],
music:['Randy Newman'],
sound:['Gary Summers','Michael Semanick'],
scenography:['Paul Abadilla']},
{title:'The Good Dinosaur',
titleCZ:'Hodný dinosaurus',
year:2015,
runtime:93,
countries:['USA'],
genres:['Animation','Fantasy','Adventure','Comedy','Drama','Family'],
director:['Peter Sohn'],
actors:['Jeffrey Wright','Frances McDormand','Raymond Ochoa','Marcus Scribner','Steve Zahn','Anna Paquin','Sam Elliott','Alan Tudyk','A. J. Buckley','John Ratzenberger','Carrie Paff','Lena Schaffer','David Boat','Aidan McGraw'],
screenplay:['Meg LeFauve','Adrian Molina'],
production:['Denise Ream'],
music:['Jeff Danna','Mychael Danna'],
camera:['Mahyar Abousaeedi'],
cut:['Stephen Schaffer'],
sound:['Michael Semanick','Shannon Mills','Tom Johnson','Craig Berkey'],
scenography:['Harley Jessup','Daniel Lopez Muñoz']},
{title:'Finding Dory',
titleCZ:'Hledá se Dory',
year:2016,
runtime:97,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Andrew Stanton'],
actors:['Ellen DeGeneres','Albert Brooks','Diane Keaton','Eugene Levy','Ty Burrell','Kaitlin Olson',"Ed O'Neill",'Willem Dafoe','Idris Elba','Dominic West','Preston Bailey','Hayden Rolence','Sigourney Weaver','Kate McKinnon','Vicki Lewis','Aaron Hendry','Emma Shannon','Gunnar Sizemore','Will Collyer','Ashlyn Faith Williams','Aaron Fors','Jason Pace','Torbin Xan Bullock','Daniel Edward Mora','Andy Hirsch'],
screenplay:['Andrew Stanton','Victoria Strouse'],
production:['Lindsey Collins'],
music:['Thomas Newman'],
camera:['Jeremy Lasky'],
cut:['Axel Geddes'],
sound:['Nathan Nance','Michael Semanick'],
scenography:['Paul Abadilla','Don Shank']},
{title:'Onward',
titleCZ:'Frčíme',
year:2020,
runtime:103,
countries:['USA'],
genres:['Animation','Comedy','Family','Fantasy'],
director:['Dan Scanlon'],
actors:['Chris Pratt','Tom Holland','Julia Louis-Dreyfus','Octavia Spencer','Ali Wong','John Ratzenberger','Lena Waithe','Mel Rodriguez'],
screenplay:['Dan Scanlon'],
production:['Kori Rae'],
music:['Jeff Danna','Mychael Danna'],
camera:['Adam Habib'],
cut:['Catherine Apple'],
sound:['Juan Peralta','Michael Semanick','Shannon Mills']},
{title:'Luca',
titleCZ:'Luca',
year:2021,
runtime:96,
countries:['USA'],
genres:['Animation','Adventure','Family','Fantasy'],
director:['Enrico Casarosa'],
actors:['Jacob Tremblay','Maya Rudolph','Jack Dylan Grazer','Jim Gaffigan','Marco Barricelli','Saverio Raimondo','Sacha Baron Cohen','Emma Berman'],
screenplay:['Jesse Andrews','Mike Jones'],
production:['Andrea Warren'],
music:['Dan Romer'],
sound:['Tony Villaflor','Christopher Scarabosio'],
scenography:['Daniela Strijleva']},
{title:'Lightyear',
titleCZ:'Rakeťák',
year:2022,
runtime:105,
countries:['USA'],
genres:['Animation','Adventure','Family','Fantasy','Sci-Fi'],
director:['Angus MacLane'],
actors:['Chris Evans','Taika Waititi','Keke Palmer','James Brolin','Efren Ramirez','Uzo Aduba','Isiah Whitlock Jr.','Peter Sohn','Dale Soules','Bill Hader'],
screenplay:['Jason Headley','Angus MacLane'],
production:['Galyn Susman'],
music:['Michael Giacchino'],
camera:['Jeremy Lasky','Ian Megibben']},
{title:'Elemental',
titleCZ:'Mezi živly',
year:2023,
runtime:111,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family','Fantasy'],
director:['Peter Sohn'],
actors:['Mamoudou Athie','Leah Lewis','Wendi McLendon-Covey',"Catherine O'Hara",'Shila Ommi','Ronnie Del Carmen','Matthew Yang King','Joe Pera'],
screenplay:['John Hoberg','Kat Likkel','Brenda Hsueh'],
production:['Denise Ream'],
music:['Thomas Newman'],
camera:['Jean-Claude Kalache'],
cut:['Stephen Schaffer'],
sound:['Coya Elliott','Ren Klyce','Paul McGrath','Stephen Urata'],
scenography:['Don Shank']},
{title:'Ava',
titleCZ:'Ava: Bez soucitu',
year:2020,
runtime:98,
countries:['USA'],
genres:['Action','Drama','Crime','Mystery','Thriller'],
director:['Tate Taylor'],
actors:['Jessica Chastain','Colin Farrell','John Malkovich','Geena Davis','Common','Jess Weixler','Joan Chen','Diana Silvers','Ioan Gruffudd','Levon Panek'],
screenplay:['Matthew Newton'],
production:['Jessica Chastain','Nicolas Chartier','Dominic Rustam','Kelly Carmichael'],
music:['Bear McCreary'],
camera:['Stephen Goldblatt'],
cut:['Zach Staenberg'],
sound:['Greg P. Russell','Will Files'],
scenography:['Molly Hughes'],
masks:['Linda Dowds','Stephanie Ingram'],
costumes:['Megan Coates']},
{title:'Stuck with a Perfect Woman',
titleCZ:'Bezva ženská na krku',
year:2016,
runtime:97,
countries:['Czechia'],
genres:['Comedy','Romance'],
director:['Tomáš Hoffman'],
actors:['Petra Hřebíčková','Ondřej Vetchý','Miroslav Táborský','Jiří Langmajer','Tereza Kostková','Jenovéfa Boková','Václav Postránecký','Matouš Ruml','Kristína Svarinská','Ondřej Malý','Pavla Tomicová','Nela Boudová','Veronika Khek Kubařová','Petr Vaněk','Ondřej Kavan','Martin Kavan','Eva Leinweberová','Martin Pechlát','Jiří Vejdělek','Václav Kopta','Vladimíra Havlíčková','Vojtěch Lavička','Jan Šrámek','Viktor Antonio','Jitka Sedláčková','Jakub Maršál','Kryštof Racek','Johana Racková'],
screenplay:['Jiří Vejdělek','Tomáš Hoffman','Martin Horský'],
production:['Tomáš Hoffman','Jiří Vejdělek','Marek Jeníček'],
camera:['Jan Drnek'],
cut:['Ondřej Hokr'],
sound:['Richard Müller','Michal Pajdiak'],
scenography:['Milan Býček'],
masks:['Lidmila Kopecká'],
costumes:['Michaela Wondreys Kunešová']},
{title:'Stadium Nuts',
titleCZ:'Blázni ze stadiónu',
year:1972,
runtime:85,
countries:['France'],
genres:['Comedy'],
director:['Claude Zidi'],
actors:['Jean-Guy Fechner','Gérard Filippelli','Gérard Rinaldi','Jean Sarrus','Paul Préboist','Martine Kelly','Gérard Croce','Jacques Seiler','François Cadet','Pierre Gualdi','Guy Lux','Christian Fechner','Jacques Préboist','Patrick Gilles'],
screenplay:['Claude Zidi','Jacques Fansten'],
production:['Christian Fechner'],
music:['Les Charlots','Jean-Guy Fechner','Gérard Filippelli','Gérard Rinaldi','Jean Sarrus'],
camera:['Paul Bonis'],
cut:['Monique Isnardon'],
sound:['Jacques Gallois'],
scenography:['André Guérin'],
costumes:['Laurence Brignon']},
{title:'Journey to the Center of the Earth',
titleCZ:'Cesta do středu Země',
year:2008,
runtime:93,
countries:['USA'],
genres:['Action','Adventure','Family','Fantasy','Sci-Fi','IMAX'],
director:['Eric Brevig'],
actors:['Brendan Fraser','Josh Hutcherson','Anita Briem','Kaniehtiio Horn','Jean Michel Paré','Seth Meyers','Jane Wheeler'],
basedOn:['Jules Verne'],
screenplay:['Michael D. Weiss','Jennifer Flackett','Mark Levin'],
production:['Beau Flynn'],
music:['Andrew Lockington','Jake Jackson'],
camera:['Chuck Shuman'],
cut:['Steven Rosenblum','Dirk Westervelt','Paul Martin Smith'],
sound:['Bill Sheppard','Dean Giammarco'],
scenography:['David Sandefur','Eve Boulonne','Réal Proulx'],
costumes:['Mario Davignon']},
{title:'The Witch',
titleCZ:'Čarodějnice',
year:2015,
runtime:92,
countries:['USA','Canada','UK'],
genres:['Horror','Mystery'],
director:['Robert Eggers'],
actors:['Anya Taylor-Joy','Ralph Ineson','Kate Dickie','Harvey Scrimshaw','Ellie Grainger','Julian Richings','Cat Simmons'],
screenplay:['Robert Eggers'],
production:['Jay Van Hoy','Lars Knudsen','Daniel Bekerman','Jodi Redmond','Rodrigo Teixeira'],
music:['Mark Korven'],
camera:['Jarin Blaschke'],
cut:['Louise Ford'],
sound:['Jason Perreira'],
scenography:['Craig Lathrop','Mary Kirkland'],
costumes:['Linda Muir']},
{title:'The Black Corsair',
titleCZ:'Černý korzár',
year:1976,
runtime:118,
countries:['Italy'],
genres:['Adventure','Action'],
director:['Sergio Sollima'],
actors:['Kabir Bedi','Carole André','Mel Ferrer','Angelo Infanti','Sal Borgese','Guido Alberti','Dagmar Lassander','Pietro Torrisi','Sonja Jeannine','Mariano Rigillo','Jackie Basehart','Franco Fantasia','Pierangeli Llinas','Lionello Pio Di Savoia'],
basedOn:['Emilio Salgari'],
screenplay:['Alberto Silvestri'],
production:['Luigi Rovere'],
music:['Maurizio De Angelis','Guido De Angelis'],
camera:['Alberto Spagnoli'],
cut:['Alberto Gallitti'],
sound:['Roberto Petrozzi',"Gianni D'Amico"],
scenography:['Sergio Canevari'],
masks:['Mario Van Riel','Iolanda Conti'],
costumes:['Dario Cecchi','Mario Carlini']},
{title:'Lucky Four Serving the King',
titleCZ:'Čtyřlístek ve službách krále',
year:2013,
runtime:90,
countries:['Czechia'],
genres:['Animation','Fantasy','Family'],
director:['Michal Žabka','Zdeněk Štěpán'],
actors:['Ivan Trojan','Tereza Bebarová','Bohdan Tůma','Ondřej Gregor Brzobohatý','Václav Postránecký','Vladimír Brabec','Jiří Lábus','Jan Přeučil','Petr Nárožný','Kryštof Hádek','Tomáš Juřička','Martin Písařík','Pavel Kříž','Vladimír Javorský','Martha Issová','Ota Jirák','Otakar Brousek st.','Miroslav Táborský','Anna Remková','Gabriela Osvaldová','Lucie Bílá','Zlata Adamovská','Petr Rychlý'],
basedOn:['Jaroslav Němeček'],
screenplay:['Josef Lamka','Hana Lamková'],
production:['Miloslav Šmídmajer'],
music:['Ondřej Soukup'],
cut:['Luděk Hudec'],
sound:['Marek Musil']},
{title:'The Devil Wears Prada',
titleCZ:'Ďábel nosí Pradu',
year:2006,
runtime:104,
countries:['USA'],
genres:['Drama','Romance','Comedy'],
director:['David Frankel'],
actors:['Meryl Streep','Anne Hathaway','Emily Blunt','Stanley Tucci','Simon Baker','Adrian Grenier','Tracie Thoms','Rich Sommer','Daniel Sunjata','David Marshall Grant','James Naughton','Tibor Feldman','Rebecca Mader','Jimena Hoyos','Gisele Bündchen','George C. Wolfe','John Rothman','Stephanie Szostak','Colleen Dengel','Suzanne Dengel','Heidi Klum','Valentino Garavani','Alyssa Sutherland','James Cronin','Frank Anello','Carl Burrows','Alexie Gilmore','Ingrid Sophie Schram','Jennifer Scott','Caroline Slaughter','Taylor Treadwell','Mira Tzur','Lauren Weisberger','Donatella Versace','Alexander Blaise'],
basedOn:['Lauren Weisberger'],
screenplay:['Aline Brosh McKenna'],
production:['Wendy Finerman'],
music:['Theodore Shapiro'],
camera:['Florian Ballhaus'],
cut:['Mark Livolsi'],
sound:['Lawrence Herman','Tom Fleischman','Nicholas Renbeck','Paul Urmson',"T.J. O'Mara"],
scenography:['Jess Gonchor','Lydia Marks'],
masks:['Nicki Ledermann','Angel De Angelis'],
costumes:['Patricia Field']},
{title:'Flipper',
titleCZ:'Delfín Filip',
year:1996,
runtime:95,
countries:['USA'],
genres:['Family','Adventure'],
director:['Alan Shapiro'],
actors:['Elijah Wood','Paul Hogan','Jessica Wesson','Jonathan Banks','Luke Halpin','Chelsea Field','Jason Fuchs','Isaac Hayes','Allison Bertolino','Robert Deacon','Mal Jones'],
screenplay:['Alan Shapiro'],
production:['Perry Katz','James J. McNamara'],
music:['Joel McNeely'],
camera:['Bill Butler'],
cut:['Peck Prior'],
sound:['Michael C. Casper','Daniel J. Leahy'],
scenography:['Thomas A. Walsh','David Schlesinger'],
masks:['David B. Miller',"Karla O'Keefe"],
costumes:['Matthew Jacobsen']},
{title:'Wild',
titleCZ:'Divočina',
year:2014,
runtime:110,
countries:['USA'],
genres:['Biographic','Drama','Adventure'],
director:['Jean-Marc Vallée'],
actors:['Reese Witherspoon','Laura Dern','Thomas Sadoski','Michiel Huisman','Gaby Hoffmann','Kevin Rankin','W. Earl Brown','Mo McRae','Ted Rooney','Cheryl Strayed','Brian Van Holt','J.D. Evermore','Rich Morris','Tony Doupe','Jan Hoag','Will Cuddy','Randy Schulman','Robert Alan Barnett','Anne Gee Byrd','Beth Hall','Cathryn de Prume','Jeanine Jackson','Matt Pascua','Keene McRae','Greg James','Andrew Saunderson',"Evan O'Toole",'Dylan Wayne Lawrence','Orianna Milne','Art Alexakis'],
basedOn:['Cheryl Strayed'],
screenplay:['Nick Hornby'],
production:['Bill Pohlad','Bruna Papandrea'],
camera:['Yves Bélanger'],
cut:['Martin Pensa','Jean-Marc Vallée'],
sound:['Ai-Ling Lee','Mildred Iatrou','Andy Nelson'],
scenography:['John Paino','Javiera Varas'],
masks:['Kymber Blake','Matthew W. Mungle','Tanya Cookingham'],
costumes:['Melissa Bruning']},
{title:'Bones and All',
titleCZ:'Do morku kostí',
year:2022,
runtime:130,
countries:['Italy','USA'],
genres:['Drama','Horror','Romance','Road movie'],
director:['Luca Guadagnino'],
actors:['Taylor Russell','Timothée Chalamet','Mark Rylance','André Holland','Chloë Sevigny','Michael Stuhlbarg','David Gordon Green','Jessica Harper','Francesca Scorsese','Jake Horowitz','Anna Cobb','Johanna McGinley','Sean Bridgers','Ellie Parker','Tyler Craig','Brady Gentry','Madeleine Hall'],
basedOn:['Camille DeAngelis'],
screenplay:['David Kajganich'],
production:['Luca Guadagnino','David Kajganich',"Francesco Melzi d'Eril",'Lorenzo Mieli','Marco Morabito','Peter Spears'],
music:['Trent Reznor','Atticus Ross'],
camera:['Arseni Khachaturan'],
cut:['Marco Costa'],
scenography:['Elliott Hostetter'],
masks:['Massimo Gattabrusi'],
costumes:['Giulia Piersanti']},
{title:'Jonah: A VeggieTales Movie',
titleCZ:'Dobrodružství pirátů v zeleninové zemi',
year:2002,
runtime:83,
countries:['USA'],
genres:['Musical','Animation','Comedy','Family'],
director:['Phil Vischer','Mike Nawrocki'],
actors:['Phil Vischer','Mike Nawrocki','Steve Hullfish','Tim Hodge'],
sound:["Andy D'Addario",'Brad Zoern','Elius Caruso'],
scenography:['Joseph Sapulich']},
{title:'Elysium',
titleCZ:'Elysium',
year:2013,
runtime:109,
countries:['USA'],
genres:['Sci-Fi','Action','Thriller','Drama'],
director:['Neill Blomkamp'],
actors:['Matt Damon','Jodie Foster','William Fichtner','Alice Braga','Diego Luna','Michael Shanks','Carly Pope','Talisa Soto','Sharlto Copley','Wagner Moura','Faran Tahir','Ona Grauer','Terry Chen','Jose Pablo Cantillo','Catherine Lough Haggquist','Jared Keeso','Adrian Holmes','Michael Mando','Johnny Cicco','Claude Duhamel','Angelina Pratap','Emma Tremblay','Christina Cox','Christian Vazquez','Maxwell Perry Cotton','Sean Owen Roberts','Yolanda Abbud L.','Alejandro Rae','Josh Blacker','Chris Shields','Julian Christopher','Brandon Auret','Sofía Sisniega','Alejandro Peraza','Alejandro Belmonte','Alan Del Castillo','Pauline Egan','Dalias Blake','Stephen Chang','Iñaki Goci','Kat Ruston','Peter Muyzers','Chris Humphreys','Tiffani Timms','Tracy Waterhouse'],
screenplay:['Neill Blomkamp'],
production:['Simon Kinberg','Bill Block','Neill Blomkamp'],
music:['Ryan Amon'],
camera:['Trent Opaloch'],
cut:['Lee Smith','Julian Clarke'],
sound:['Oleg Kulchytskyi','Dave Whitehead','Christopher Scarabosio','Craig Berkey'],
scenography:['Philip Ivey','Gena Vazquez'],
masks:['Joe Dunckley','Sarah Rubano','Fay von Schroeder','Vince Yoshida'],
costumes:['April Ferry']},
{title:'Equilibrium',
titleCZ:'Equilibrium',
year:2002,
runtime:107,
countries:['USA'],
genres:['Action','Sci-Fi','Thriller','Drama'],
director:['Kurt Wimmer'],
actors:['Christian Bale','Dominic Purcell','Emily Watson','Christian Kahrmann','Sean Bean','David Hemmings','Dirk Martens','Angus Macfadyen','Taye Diggs','Sean Pertwee','Anatole Taubman','Florian Fitz','Kurt Wimmer','Mehmet Kurtuluş','Klaus Schindler','Brian W. Cook','William Fichtner','Dennenesch Zoudé','Matthew Harbour','Maria Pia Calzone','Sy Turner','John Keogh','Oliver Brandl','Francesco Cabras','Kay Ramczyk','Danny Lee Clark'],
screenplay:['Kurt Wimmer'],
production:['Lucas Foster'],
music:['Klaus Badelt'],
camera:['Dion Beebe'],
cut:['William Yeh','Tom Rolf'],
sound:['Jeffrey Perkins'],
scenography:['Wolf Kroeger','Anne Kuljian'],
masks:['Hasso von Hugo','Luigi Rocchetti','Björn Rehbein','Tanja Drewitz'],
costumes:['Joseph A. Porro']},
{title:'Fimfárum 2',
titleCZ:'Fimfárum 2',
year:2006,
runtime:90,
countries:['Czechia'],
genres:['Animation','Puppets','Fairytale','Tale'],
director:['Vlasta Pospíšilová','Břetislav Pojar','Aurel Klimt','Jan Balej'],
actors:['Jan Werich','Ota Jirák'],
basedOn:['Jan Werich'],
screenplay:['Jiří Kubíček','Aurel Klimt','Jan Balej','Břetislav Pojar'],
production:['Martin Vandas','Aurel Klimt'],
music:['Vladimír Merta'],
camera:['Zdeněk Pospíšil','Vladimír Malík','Jan Müller','Miloslav Špála'],
cut:['Daniel Lisý','Magda Sandersová','Lucie Haladová'],
sound:['Marek Musil']},
{title:'Wrath of the Titans',
titleCZ:'Hněv Titánů',
year:2012,
runtime:95,
countries:['USA','Spain'],
genres:['Action','Adventure','Fantasy'],
director:['Jonathan Liebesman'],
actors:['Sam Worthington','Liam Neeson','Édgar Ramírez','Danny Huston','Toby Kebbell','Rosamund Pike','Ralph Fiennes','Bill Nighy','Matt Milne','Lily James','Sinéad Cusack','John Bell','George Blagden','Jd Roth-round','Spencer Wilding','Lasco Atkins','Lamberto Guerra','Alex Klaus','Jorge Guimerá','Caoilfhionn Dunne','James Michael Rankin'],
screenplay:['Dan Mazeau','David Leslie Johnson-McGoldrick','Beverley Cross'],
production:['Basil Iwanyk','Polly Johnsen'],
music:['Javier Navarrete'],
camera:['Ben Davis'],
cut:['Martin Walsh'],
sound:['Dominic Gibbs','Michael Fentum','Mark Taylor','Mark Paterson','Ivan Sharrock'],
scenography:['Ray Chan','Paul Kirby','Charles Wood','Jordan Crockett','Lee Sandales'],
masks:['Paul Engelen',"Conor O'Sullivan",'Hannah Eccleston','Göran Lundström','David Malinowski','Barrie Gower'],
costumes:['Jany Temime']},
{title:'Husband to Rent',
titleCZ:'Hodinový manžel',
year:2014,
runtime:100,
countries:['Czechia'],
genres:['Comedy'],
director:['Tomáš Svoboda'],
actors:['David Novotný','Bolek Polívka','David Matásek','Lukáš Latinák','Jitka Čvančarová','Zuzana Norisová','Eva Holubová','Nina Divíšková','Lenka Vlasáková','Simona Babčáková','Jana Stryková','Andrej Hryc','Vasil Fridrich','Lenka Zahradnická','Dana Batulková','Norbert Lichý','Milan Šteindler','Pavel Šimčík','Anna Čtvrtníčková','Agáta Svobodová','Igor Rattaj','Dušan Sitek','Jan Vlas','Tomáš Svoboda'],
screenplay:['Tomáš Svoboda'],
production:['Igor Konyukov'],
music:['René Rypar'],
camera:['Karel Fairaisl'],
sound:['Tomáš Bělohradský'],
masks:['Veronika Riehs']},
{title:'The Good Plumber',
titleCZ:'Instalatér z Tuchlovic',
year:2016,
runtime:85,
countries:['Czechia'],
genres:['Comedy'],
director:['Tomáš Vorel st.'],
actors:['Jakub Kohák','Eva Holubová','Petra Špalková','Filip Blažek','Jan Budař','Maruška Page','Petr Čtvrtníček','Tomáš Matonoha','Barbora Poláková','Lucie Polišenská','Petra Nesvačilová','Vendula Svobodová','Matýsek Březina','Gabriela Heclová','Lukáš Bílý','Blanka Rozkošná','Michal Koubek','Tomáš Koubek','Thu Trao Than','Ngoc Lam','Duy Quang Nguyen','Jan Slovák','Jindřiška Malinová','Matěj Malát','Baru Vlčková','Petr Vopelka','Gábina Haunerová','Radomil Uhlíř','Tomáš Vorel st.','Pavel Vácha','Petra Švecová','Leoš Heřmánek'],
screenplay:['Tomáš Vorel st.','Baru Vlčková'],
production:['Tomáš Vorel st.'],
music:['David Hlaváč','Barbora Poláková','Jan P. Muchow'],
camera:['Tomáš Vorel st.'],
cut:['Tomáš Vorel st.','Tereza Žbánková','Jakub Jurásek','Jaroslav Sedláček','Alois Fišárek'],
sound:['Jakub Jurásek'],
scenography:['Roman Chochola','Tomáš Vorel st.'],
masks:['Veronika Riehs'],
costumes:['Iva Rašková']},
{title:'Jobs',
titleCZ:'jOBS',
year:2013,
runtime:128,
countries:['USA'],
genres:['Biographic','Drama'],
director:['Joshua Michael Stern'],
actors:['Ashton Kutcher','Dermot Mulroney','Josh Gad','Lukas Haas','Matthew Modine','J.K. Simmons','Lesley Ann Warren','Ron Eldard',"Ahna O'Reilly",'Victor Rasuk','John Getz','Kevin Dunn','James Woods','Nelson Franklin','Eddie Hassell','Elden Henson','Lenny Jacobson','Brett Gelman','Brad William Henke','Giles Matthey','Robert Pine','Clint Jung','David Denman','Masi Oka','Abby Brammell','Annika Bertea','Amanda Crew','Samm Levine','Joel Murray','William Mapother','Scott Krinsky','Evan Helmuth','Laura Niemi','Jim Turner','Clayton Rohner','Rachel Rosenstein','Christopher Curry','Mark Kassen','Olivia Jordan','Ava Acres','Ronnie Gene Blevins','Abigail McConnell','Fabian Schopper','Hollie Winnard','Lanre Idewu'],
screenplay:['Matt Whiteley'],
production:['Joshua Michael Stern','Mark Hulme'],
music:['John Debney'],
camera:['Russell Carpenter'],
cut:['Robert Komatsu'],
sound:['Paula Fairfield','J. Stanley Johnston','Gary Coppola'],
scenography:['Freddy Waff','Linda Lee Sutton'],
masks:['Dennis Liddiard','Christopher Allen Nelson','Robert Maverick','Laura Berman'],
costumes:['Lisa Jensen']},
{title:'Jumanji: The Next Level',
titleCZ:'Jumanji: Další level',
year:2019,
runtime:123,
countries:['USA'],
genres:['Action','Adventure','Comedy','Fantasy'],
director:['Jake Kasdan'],
actors:['Dwayne Johnson','Kevin Hart','Jack Black','Karen Gillan','Awkwafina','Nick Jonas','Alex Wolff','Morgan Turner','Madison Iseman',"Ser'Darius Blain",'Danny DeVito','Danny Glover','Rhys Darby','Colin Hanks','Rory McCann','Marin Hinkle','Charles Green','Massi Furlan','Dania Ramirez','John Ross Bowie','Madison Johnson','Nick Gomez','Deobia Oparei','Lucy DeVito','Lamorne Morris','Bebe Neuwirth','Vince Pisani','Leslie Simms','Jennifer Patino','Derek Russo','Ego Mikitas'],
screenplay:['Jeff Pinkner','Scott Rosenberg'],
production:['Hiram Garcia','Dwayne Johnson','William Teitler','Matthew Tolmach','Dany Garcia'],
music:['Henry Jackman'],
camera:['Gyula Pados'],
cut:['Steve Edwards','Mark Helfrich'],
sound:['Julian Slater',"Kevin O'Connell",'Chuck Michael','Joel Shryack'],
scenography:['Bill Brzeski','Danielle Berman'],
masks:['Benji Dove','Yolanda Toussieng','Karen Bartek','Dee Dee Metzger','Ellen Arden']},
{title:'Jumanji',
titleCZ:'Jumanji',
year:1995,
runtime:104,
countries:['USA'],
genres:['Action','Adventure','Family','Fantasy','Thriller'],
director:['Joe Johnston'],
actors:['Robin Williams','Jonathan Hyde','Kirsten Dunst','Bradley Pierce','Bonnie Hunt','Bebe Neuwirth','David Alan Grier','Patricia Clarkson','Adam Hann-Byrd','James Handy','Frank Welker','Peter Bryant','Laura Bell Bundy','Tom Woodruff Jr.','Gillian Barber','Darryl Henriques','Malcolm Stewart','Lloyd Berry','Annabel Kershaw','Robyn Driscoll'],
basedOn:['Chris Van Allsburg'],
screenplay:['Jonathan Hensleigh','Greg Taylor','Jim Strain'],
production:['William Teitler','Scott Kroopf'],
music:['James Horner'],
camera:['Thomas E. Ackerman'],
cut:['Robert Dalva'],
sound:['Richard Hymns','Randy Thom','Gary Summers','Gary Rydstrom','Rob Young'],
scenography:['Jim Bissell','Tedd Kuchera','Cynthia T. Lewis'],
masks:['Elvia Mante'],
costumes:['Jane E. Still','Martha Wynne Snetsinger']},
{title:'Jurassic Park III',
titleCZ:'Jurský park 3',
year:2001,
runtime:92,
countries:['USA'],
genres:['Action','Adventure','Sci-Fi','Thriller'],
director:['Joe Johnston'],
actors:['Sam Neill','William H. Macy','Téa Leoni','Alessandro Nivola','Trevor Morgan','Michael Jeter','John Diehl','Bruce A. Young','Laura Dern','Taylor Nichols','Julio Oscar Mechoso','Linda Park','Mark Harelik','Sarah Danielle Madison','Bruce French'],
screenplay:['Alexander Payne','Jim Taylor','Peter Buchman'],
production:['Kathleen Kennedy','Larry Franco'],
music:['Don Davis'],
camera:['Shelly Johnson'],
cut:['Robert Dalva'],
sound:['Gary Summers','Christopher Boyes'],
scenography:['Ed Verreaux'],
masks:['Dennis Liddiard'],
costumes:['Betsy Cox']},
{title:'Jurassic World',
titleCZ:'Jurský svět',
year:2015,
runtime:119,
countries:['USA'],
genres:['Sci-Fi','Adventure','Action'],
director:['Colin Trevorrow'],
actors:['Chris Pratt','Bryce Dallas Howard',"Vincent D'Onofrio",'Ty Simpkins','Nick Robinson','Jake Johnson','Omar Sy','BD Wong','Judy Greer','Irrfan Khan','Brian Tee','Katie McGrath','Lauren Lapkus','Andy Buckley','James DuMont','Gary Weeks','Eric Edelstein','Michelle DeVito','Erik Thirsk','Isaac Keys','Jimmy Fallon','Christopher Heskey','Tiffany Forest','Nazeema Bartek','Eddie J. Fernandez','Michael Papajohn','Divine Prince Ty Emmecca','John L. Armijo','Tait Fletcher','Silvia Moore','Chloe Perrin','Chris Angerdina','Colin Trevorrow','Mike McCutchen','Justin Lebrun','Rhonda Laizer','Christopher Scott Hassell','Joy Kate Lawson','Stephen Wise','Nicholas Leiting','Jimmy Buffett','Mona Sishodia','Michael D. Anglin','Matty Cardarople','Steven I. Dillard','Justin Mane','James Michael Smith','Christopher De Stefano','Heather Ashley Chase','Natalie Daniels','Billy Smith','Abraham Hsu'],
screenplay:['Rick Jaffa','Amanda Silver','Derek Connolly','Colin Trevorrow'],
production:['Frank Marshall','Patrick Crowley'],
music:['Michael Giacchino'],
camera:['John Schwartzman'],
cut:['Kevin Stitt'],
sound:['Gwendolyn Yates Whittle','Pete Horner','Al Nelson','Christopher Boyes','Vinii Khullar'],
scenography:['Ed Verreaux','Ronald R. Reiss'],
masks:['Ralph Malani','Vivian Baker'],
costumes:['April Ferry','Daniel Orlandi']},
{title:"Huevos: Little Rooster's Egg-cellent Adventure",
titleCZ:'Kyky Ryky a pár vajec',
year:2015,
runtime:98,
countries:['Mexico'],
genres:['Animation'],
director:['Gabriel Riva Palacio Alatriste','Rodolfo Riva-Palacio Alatriste'],
actors:['Bruno Bichir','Maite Perroni','Sergio Sendel','Ninel Conde','Omar Chaparro','Carlos Espejel','Angélica Vale','Anna Brisbin'],
screenplay:['Gabriel Riva Palacio Alatriste','Rodolfo Riva-Palacio Alatriste'],
production:['Ignacio Martínez Casares'],
music:['Zacarías M. de la Riva'],
camera:['Aldo Cruz'],
sound:['Matías Barberis']},
{title:'Goat Story 2',
titleCZ:'Kozí příběh se sýrem',
year:2012,
runtime:85,
countries:['Czechia'],
genres:['Animation','Fairytale','Comedy','History'],
director:['Jan Tománek'],
actors:['Jiří Lábus','Matěj Hádek','Mahulena Bočanová','Karel Heřmánek','Michal Dlouhý','Miroslav Táborský','Martin Dejdar','Miroslav Vladyka','Milan Šteindler','Václav Vydra nejml.','Dalimil Klapka','Ota Jirák','Justin Svoboda','Jim Krenn'],
screenplay:['Jan Tománek','Jiří Růžička'],
production:['Jan Tománek'],
music:['David Solař'],
cut:['Alois Fišárek','Jan Tománek'],
sound:['Michal Deliopulos']},
{title:'Krabat and the Legend of the Satanic Mill',
titleCZ:'Krabat: Čarodějův učeň',
year:2008,
runtime:120,
countries:['Germany'],
genres:['Drama','Fantasy'],
director:['Marco Kreuzpaintner'],
actors:['David Kross','Daniel Brühl','Robert Stadlober','Tom Wlaschiha','Stefan Haschke','Anna Thalbach','Charly Hübner','Christian Redl','Paula Kalenberg','Tom Lass','Otto Sander','Hanno Koffler','Moritz Grove','Sven Hönig','Peter Rappenglück','David Fischbach','Daniel Fripan','Daniel Steiner','Mac Steinmeier'],
basedOn:['Otfried Preußler'],
screenplay:['Michael Gutmann','Marco Kreuzpaintner'],
production:['Jakob Claussen'],
music:['Annette Focks'],
camera:['Daniel Gottschalk'],
cut:['Hansjörg Weißbrich'],
sound:['Tschangis Chahrokh','Dirk Jacob'],
scenography:['Naomi Shohan','Christian M. Goldbeck','Ernestine Hipper'],
masks:['Heike Merker','Tatjana Krauskopf','Georg Korpas'],
costumes:['Michael Kaplan','Anke Winckler']},
{title:'The Cat Returns',
titleCZ:'Království koček',
year:2002,
runtime:75,
countries:['Japan'],
genres:['Animation','Adventure','Family','Fantasy'],
director:['Hirojuki Morita'],
actors:['Čizuru Ikewaki','Jošihiko Hakamada','Aki Maeda','Takajuki Jamada','Jóko Honna','Acuko Tanaka','Hitomi Sató','Tecu Watanabe','Tecuró Tanba','Mari Hamada','Kenta Satoi','Tarusuke Šingaki','Takajuki Suzui','Robert Clotworthy','Kumiko Okae','Keiko Cukamoto','Daisuke Egawa','Tošitaka Šimizu','Tošihiro Nakamura','Hikari Jono'],
basedOn:['Aoi Hiiragi'],
screenplay:['Reiko Jošida'],
production:['Tošio Suzuki'],
music:['Júdži Nomi'],
camera:['Kentaró Takahaši'],
cut:['Megumi Učida'],
sound:['Tom E. Dahl'],
scenography:['Naoja Tanaka']},
{title:'The Cow',
titleCZ:'Kráva',
year:1993,
runtime:86,
countries:['Czechia'],
genres:['Drama'],
director:['Karel Kachyňa'],
actors:['Radek Holub','Alena Mihulová','Valérie Zawadská','Viktorie Knotková','Antonín Molčík','František Peterka','Vlastimil Zavřel','Eva Jiroušková','Zdeněk Kozák st.','Roman Slovák','Bohumír Starý','Alice Šnirychová','Zdeněk Dušek','Václav Helšus','Milena Šajdková','Jindřich Khain','Miroslav Vrba','Dimo Lipitkovský','Arnošt Janeček','Jiří Klenot','František Stupka'],
basedOn:['Jan Procházka'],
screenplay:['Karel Čabrádek','Karel Kachyňa'],
production:['Karel Škop'],
music:['Petr Hapka'],
camera:['Petr Hojda'],
cut:['Jan Svoboda'],
sound:['Jaroslav Novák'],
scenography:['Milan Dvořák','Miroslav Fára'],
costumes:['Ivana Olmerová']},
{title:'Labyrinth',
titleCZ:'Labyrint',
year:2012,
runtime:93,
countries:['Czechia'],
genres:['Thriller','Mystery','Horror'],
director:['Tomáš Houška'],
actors:['Lucie Vondráčková','Mary Coronado','Martin Zbrožek','Jan Zadražil','David Steigerwald','Gabriela Houšková','Michal Novotný','Petra Ptáčková','Tomáš Houška','Simona Vavrušová','Ludvík Němec','Veronika Velková','Patrik Velek','Pavla Vaňková','Gabriela Benešová'],
screenplay:['Tomáš Houška'],
production:['Štefan Voržáček'],
music:['Filip Goméz'],
camera:['Martin Matiášek','Michael Gahut'],
cut:['Marek Bureš'],
sound:['Tomáš Bělohradský'],
scenography:['Petr Brož'],
masks:['René Stejskal'],
costumes:['Lenka Urbanová']},
{title:'Maze Runner: The Death Cure',
titleCZ:'Labyrint: Vražedná léčba',
year:2018,
runtime:143,
countries:['USA'],
genres:['Action','Thriller','Sci-Fi'],
director:['Wes Ball'],
actors:["Dylan O'Brien",'Dexter Darden','Thomas Brodie-Sangster','Rosa Salazar','Ki-hong Lee','Giancarlo Esposito','Nathalie Emmanuel','Kaya Scodelario','Will Poulter','Katherine McNamara','Patricia Clarkson','Jacob Lofland','Barry Pepper','Walton Goggins','Paul Lazenby','Jake Curran','Aidan Gillen','Clayton Evertson','Scot Cooper'],
basedOn:['James Dashner'],
screenplay:['T.S. Nowlin'],
production:['Wyck Godfrey','Ellen Goldsmith-Vein','Lee Stollman'],
music:['John Paesano'],
camera:['Gyula Pados'],
cut:['Dan Zimmerman'],
sound:['Paul Massey','Ai-Ling Lee'],
scenography:['Daniel T. Dorrance','Anneke Botha','Andrea Borland','Hugo Santiago'],
masks:['Alec Gillis','Tom Woodruff Jr.'],
costumes:['Sanja Milkovic Hays']},
{title:'Maze Runner: The Scorch Trials',
titleCZ:'Labyrint: Zkoušky ohněm',
year:2015,
runtime:131,
countries:['USA'],
genres:['Action','Sci-Fi','Thriller'],
director:['Wes Ball'],
actors:["Dylan O'Brien",'Thomas Brodie-Sangster','Kaya Scodelario','Ki-hong Lee','Dexter Darden','Alexander Flores','Jacob Lofland','Rosa Salazar','Giancarlo Esposito','Aidan Gillen','Patricia Clarkson','Lili Taylor','Barry Pepper','J. Nathan Simmons','Alan Tudyk','Jenny Gabrielle','Lora Martinez-Cunningham','Matthew Page','Tatanka Means','Katherine McNamara','Nathalie Emmanuel','Bryce Romero','Keith Jardine','Gary Hood','McKenna Pippen','Luke Gallegos','Jetto Dorsainville','Terry Dale Parks','James Burnett','Matt Metzler','David House','Morse Bicknell','Alex Knight','Andrea Good','Brandon K. Hampton','Alex Wagenman','John Trejo','Jess King','Frank Powers'],
basedOn:['James Dashner'],
screenplay:['T.S. Nowlin'],
production:['Wyck Godfrey','Marty Bowen','Ellen Goldsmith-Vein','Lee Stollman'],
music:['John Paesano'],
camera:['Gyula Pados'],
cut:['Dan Zimmerman'],
sound:['Ai-Ling Lee','Ron Bartlett'],
scenography:['Daniel T. Dorrance','Kelly Berry','Billy W. Ray'],
masks:['Bonnie Masoner','Megan Daum'],
costumes:['Sanja Milkovic Hays']},
{title:'Planes',
titleCZ:'Letadla',
year:2013,
runtime:91,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Klay Hall'],
actors:['Carlos Alazraqui','Dane Cook','Stacy Keach','Val Kilmer','Brad Garrett','Julia Louis-Dreyfus','John Cleese','Teri Hatcher','Anthony Edwards','Priyanka Chopra Jonas','Cedric the Entertainer','Sinbad','Oliver Kalkofe','Gabriel Iglesias','Niyanta Acharya','Klay Hall','Roma Chugani','Emerson Tenney','Jaswant Dev Shrestha','Kari Wahlgren','Roger Craig Smith','Brent Musburger','Danny Mann','Dave Wittenberg'],
screenplay:['Jeffrey M. Howard'],
music:['Mark Mancina','Marlon Espino'],
cut:['Jeremy Milton'],
sound:['David E. Fluhr','Adam Jenkins','Frank Verderosa']},
{title:'Planes: Fire and Rescue',
titleCZ:'Letadla 2: Hasiči a záchranáři',
year:2014,
runtime:83,
countries:['USA'],
genres:['Animation','Comedy','Adventure','Family'],
director:['Bobs Gannaway'],
actors:['Dane Cook','Ed Harris','Julie Bowen','Curtis Armstrong','John Michael Higgins','Hal Holbrook','Wes Studi','Brad Garrett','Teri Hatcher','Stacy Keach','Cedric the Entertainer','Barry Corbin','Regina King','Anne Meara','Jerry Stiller','Fred Willard','Dale Dye','Corri English','Patrick Warburton','René Auberjonois','Erik Estrada','John Ratzenberger','Caroline Aaron','Kate Micucci','Masasa Moyo','Brad Paisley','Fred Tatasciore','Steve Schirripa','Bryan Callen','Kevin Michael Richardson','Kari Wahlgren','Brent Musburger','Ferrell Barron','Danny Mann'],
screenplay:['Jeffrey M. Howard'],
production:['Ferrell Barron'],
music:['Mark Mancina','Marlon Espino'],
cut:['Dan Molina'],
sound:['Dean A. Zupancic','David E. Fluhr','Frank Verderosa'],
scenography:['Toby Wilson']},
{title:'League of Dispensables, The',
titleCZ:'Liga nepotřebných',
year:2013,
runtime:76,
countries:['Czechia'],
genres:['Action','Comedy'],
director:['Lukáš Šimandl'],
actors:['Martin Šolc','Lukáš Šimandl','Zuzana Petráňová','Michal Veit','Josef Petráň','Milan Bočkai','Pavlína Bajborová']},
{title:'The Oddsockeaters',
titleCZ:'Lichožrouti',
year:2016,
runtime:83,
countries:['Czechia','Slovakia','Chorvatsko'],
genres:['Animation','Family'],
director:['Galina Miklínová'],
actors:['Ondřej Trojan','Kryštof Hádek','Matěj Ruppert','Josef Somr','Jolka Krásná','Marek Taclík','Tatiana Dyková','David Novotný','Jan Maxián','Stanislav Zindulka','Aleš Najbrt','Václav Koubek','Jakub Žáček','Jiří Fero Burda','Václav Neužil ml.','Eva Spoustová','Jiří Havelka','Zuzana Stivínová','Petr Prokop'],
basedOn:['Pavel Šrut'],
screenplay:['Galina Miklínová','Pavel Šrut'],
production:['Ondřej Trojan'],
music:['Filip Míšek','Martin Hůla','Beata Hlavenková'],
camera:['Tomáš Sysel'],
cut:['Vladimír Barák'],
sound:['Jan Čeněk','Richard Müller','Bohumil Martinák'],
scenography:['Galina Miklínová']},
{title:'Eraser',
titleCZ:'Likvidátor',
year:1996,
runtime:115,
countries:['USA'],
genres:['Action','Thriller','Crime','Drama'],
director:['Chuck Russell'],
actors:['Arnold Schwarzenegger','James Caan','Vanessa Williams','James Coburn','Robert Pastorelli','James Cromwell','Danny Nucci','Nick Chinlund','Michael Papajohn','Joe Viterelli','Mark Rolston','John Slattery','Robert Miranda','Roma Maffia','Tony Longo','Melora Walters','Olek Krupa','Cylk Cozart','K. Todd Freeman','Rocco Sisto','Patrick Kilpatrick','A. J. Nay','Camryn Manheim','Skipp Sudduth','Sven-Ole Thorsen','Ben Shenkman','Gregory McKinney','Matthew James Gulbranson','Sonny King','Brian Libby','David Novak','Denis Forest','Matthew Mahaney','Sebastian La Cause','Steven Ford','Vic Polizos','Camille Winbush','John Snyder','Bruce Holman','Sam Scarber','Andy Romano','Michael Gregory','Gerald Berns','Clayton Landey','Mischa Hausserman','Gerry Becker','Dominic Marcus','Tim Colceri','Tom Billett','David Fonteno','Rick Batalla','Christopher Mankiewicz','Al Cerullo'],
screenplay:['Walon Green'],
production:['Arnold Kopelson'],
music:['Alan Silvestri'],
camera:['Adam Greenberg'],
cut:['Michael Tronick'],
sound:['Alan Robert Murray','Christopher Boyes','Kevin E. Carpenter'],
scenography:['Bill Kenney','George DeTitta Jr.'],
masks:['Jeff Dawn','Maria Valdivia','Dayne Johnson'],
costumes:['Richard Bruno']},
{title:'Ruffiano and Sweeteeth',
titleCZ:'Lotrando a Zubejda',
year:1996,
runtime:106,
countries:['Czechia','Bulgaria','France'],
genres:['Fairytale','Comedy'],
director:['Karel Smyczek'],
actors:['Jiří Strach','Pavel Zedníček','Barbora Seidlová','Arnošt Goldflam','Marián Labuda st.','Jiří Lábus','Miroslav Táborský','Jaroslav Sypal','Ladislav Gerendáš','Jiří Pecha','Ljuba Krbová','Oldřich Navrátil','Josef Karlík','Vladimír Javorský','Karel Smyczek','Petr Brukner','Jan Hraběta','Jan Bonaventura','Bořivoj Penc','Jaroslava Kretschmerová','Naďa Konvalinková','Josef Kubíček','Otmar Brancuzský','Antonín Bubeník','Barbora Srncová','Zdeněk Vronský','Zdeněk Svěrák','Jakub Hladík','Tomáš Staněk','Johan Kolínský','Petr Smyczek','Jan Müller','Josef Kolínský'],
basedOn:['Karel Čapek'],
screenplay:['Zdeněk Svěrák','Karel Smyczek'],
production:['Karel Škop','Robert Fuksa'],
music:['Jaroslav Uhlíř'],
camera:['Jan Malíř'],
cut:['Zdenek Patočka'],
sound:['Ivo Špalj','Vladimír Nahodil'],
scenography:['Jiří Hlupý'],
masks:['Jiří Farkaš','Ivana Chlostová','Eva Ungrová-Malíková'],
costumes:['Petr Kolínský']},
{title:'National Treasure',
titleCZ:'Lovci pokladů',
year:2004,
runtime:131,
countries:['USA'],
genres:['Action','Adventure','Family','Mystery','Thriller'],
director:['Jon Turteltaub'],
actors:['Nicolas Cage','Diane Kruger','Sean Bean','Justin Bartha','Jon Voight','Harvey Keitel','Christopher Plummer','Arabella Field','Stewart Finlay-McLennan','Oleg Taktarov','Mark Pellegrino','Erik King','Ron Canada','Jason Earles','Michael Ahl','Alexander Emmert','Annie Parisse','David Dayan Fisher','Don McManus','Blaze Kelly Coyle','Sharon Wilkins','Jacques Pater','Colleen Dengel','Suzanne Dengel','Joe Sheridan','François-Régis Marchasson','Marc Bertolini','Guy Di Rigo','Jody Halse','Rod McLachlan','Frank Anello','Terrence Currier','Armando Riesco','Joshua Bitton','James Biberi','Nicholas J. Benson','Hunter Gomez','Yves Beneche'],
screenplay:['Jim Kouf','Cormac Wibberley','Marianne Wibberley'],
production:['Jerry Bruckheimer','Jon Turteltaub'],
music:['Trevor Rabin'],
camera:['Caleb Deschanel'],
cut:['William Goldenberg'],
sound:['Tod A. Maitland',"Kevin O'Connell",'Greg P. Russell'],
scenography:['Norris Spencer','Anne D. McCulley'],
masks:['Scott H. Eddo','Scott Patton','Judy Chin','Matt Danon','Sherri Bramlett','Barbara Lacy'],
costumes:['Judianna Makovsky']},
{title:'The Little Man',
titleCZ:'Malý Pán',
year:2015,
runtime:83,
countries:['Czechia','Slovakia'],
genres:['Puppets'],
director:['Radek Beran'],
actors:['Saša Rašilov nejml.','Valérie Zawadská','Zuzana Bydžovská','Klára Oltová','Tatiana Dyková','Pavel Liška','Miloslav Mejzlík','Vanda Hybnerová','Miroslav Krobot','Tomáš Procházka','Vladimír Javorský','Miroslav Táborský','Jan Vondráček','Petr Pelzer','Hynek Chmelař','Lumír Tuček','Jana Tučková'],
screenplay:['Lumír Tuček'],
production:['Jakub Červenka'],
music:['Milan Cais'],
camera:['Filip Sanders'],
cut:['Martin Palouš'],
scenography:['František Antonín Skála']},
{title:'The Little Prince',
titleCZ:'Malý princ',
year:2015,
runtime:106,
countries:['France'],
genres:['Animation','Fantasy'],
director:['Mark Osborne'],
actors:['James Franco','Rachel McAdams','Marion Cotillard','Jeff Bridges','Mackenzie Foy','Paul Giamatti','Benicio Del Toro','Albert Brooks','Bud Cort','Florence Foresti','Bernard Tiphaine','Ricky Gervais','Paul Rudd'],
basedOn:['Antoine de Saint-Exupéry'],
screenplay:['Irena Brignull','Bob Persichetti'],
production:['Dimitri Rassam','Aton Soumache','Alexis Vonarb'],
music:['Hans Zimmer','Richard Harvey'],
camera:['Kris Kapp'],
cut:['Matt Landon','Carole Kravetz Aykanian'],
sound:['Tucker Bodine'],
scenography:['Lou Romano']},
{title:'My Name Is Nobody',
titleCZ:'Mé jméno je Nikdo',
year:1973,
runtime:117,
countries:['Italy','France','Germany'],
genres:['Western','Comedy'],
director:['Tonino Valerii'],
actors:['Terence Hill','Henry Fonda','Jean Martin','Geoffrey Lewis','R.G. Armstrong','Steve Kanaly','Leo Gordon','Antoine Saint-John','Piero Lulli','Mario Brega','Marc Mazza','Carla Mancini','Alexander Allerson','Franco Angrisano','Benito Stefanelli','Antonio Molino Rojo','Hubert Mittendorf','Renato Pinciroli','Luigi Antonio Guerra','Angelo Novi','Stocker Fontelieu','Neil Summers','Jackson D. Kane'],
screenplay:['Ernesto Gastaldi'],
production:['Fulvio Morsella'],
music:['Ennio Morricone'],
camera:['Giuseppe Ruzzolini'],
cut:['Nino Baragli'],
sound:['Fausto Ancillai'],
scenography:['Gianni Polidori'],
masks:['Grazia De Rossi'],
costumes:['Vera Marzot']},
{title:'Frosty',
titleCZ:'Mrazík',
year:1964,
runtime:79,
countries:['Russia'],
genres:['Family','Fairytale'],
director:['Alexandr Rou'],
actors:['Alexandr Chvylja','Natalja Sedych','Eduard Izotov','Inna Čurikova','Pavel Pavlenko','Věra Altajskaja','Georgij Milljar','Michail Janšin','Anatolij Kubackij','Valentin Brylejev','Taťjana Peltcer','Varvara Popova','Margarita Korabelnikova','Lev Potěmkin','Olga Jukina','Taťjana Jukina','Anastasija Zujeva'],
screenplay:['Michail Volpin','Nikolaj Erdman'],
music:['Nikolaj Pavlovič Budaškin'],
camera:['Dmitrij Surenskij']},
{title:'On the Road',
titleCZ:'Na cestě',
year:2012,
runtime:140,
countries:['USA','UK','France','Brazil'],
genres:['Adventure','Drama','Road movie'],
director:['Walter Salles'],
actors:['Garrett Hedlund','Sam Riley','Tom Sturridge','Kristen Stewart','Kirsten Dunst','Amy Adams','Viggo Mortensen','Steve Buscemi','Alice Braga','Elisabeth Moss','Terrence Howard','Larry Day','Giovanna Zacarías','Rocky Marquette','Joe Chrest','Kim Bubbs','Danny Morgan','Kaniehtiio Horn','Jenessa Grant','Roc LaFortune','Alison Louder','Madison Wolfe','Dan Beirne','Kyle Gatehouse','Sarah Allen','Joey Klein','Barry Del Sherman','Jason Cavalier','Daniel Kash','Bronwen Mantel','Ricardo Andres','Eric Davis','Arthur Holden','Paul Dillon','Daniela Wong','Clara Altimas','Moira Wylie','Gina Vargas','Sean Dillingham','Andaluz Russell','Marie-Ginette Guay','Neil Kroetsch','Luc Morissette','Tyler Hall','Greg Kramer',"Ayana O'Shun",'Mark Trafford','Isa Garcia'],
basedOn:['Jack Kerouac'],
screenplay:['Jose Rivera'],
production:['Roman Coppola','Rebecca Yeldham','Charles Gillibert','Nathanaël Karmitz'],
music:['Gustavo Santaolalla'],
camera:['Eric Gautier'],
cut:['François Gédigier'],
sound:['Martín Hernández','Jean-Paul Hurier'],
scenography:['Carlos Conti'],
masks:['John Caglione','Jr.','Ricardo Molina'],
costumes:['Danny Glicker']},
{title:'Night at the Museum',
titleCZ:'Noc v muzeu',
year:2006,
runtime:104,
countries:['USA','UK'],
genres:['Action','Comedy','Fantasy','Adventure'],
director:['Shawn Levy'],
actors:['Ben Stiller','Carla Gugino','Dick Van Dyke','Mickey Rooney','Bill Cobbs','Jake Cherry','Ricky Gervais','Robin Williams','Kim Raver','Patrick Gallagher','Rami Malek','Pierfrancesco Favino','Charlie Murphy','Steve Coogan','Mizuo Peck','Matthew Harrison','Paul Rudd','Anne Meara','Meshach Peters','Brad Garrett','opice Crystal','Owen Wilson','Che Landon','Matthew Walker','Jody Racicot','Jason McKinnon','Dan Rizzuto','Kerry van der Griend','Pat Kiernan','Trevor Addie','Nico McEown'],
basedOn:['Milan Trenc'],
screenplay:['Robert Ben Garant','Thomas Lennon'],
production:['Chris Columbus','Michael Barnathan'],
music:['Alan Silvestri'],
camera:['Guillermo Navarro'],
cut:['Don Zimmerman'],
sound:['Craig Henighan','John A. Larsen','Rob Young'],
scenography:['Claude Paré','Michele Laliberte'],
masks:['Cheri Minns','Adrien Morot','Kate Biscoe','Victoria Down','Mike Fields','Sarah Graham'],
costumes:['Renée April']},
{title:'Shaun the Sheep Movie',
titleCZ:'Ovečka Shaun ve filmu',
year:2015,
runtime:85,
countries:['UK','France'],
genres:['Animation','Fantasy','Adventure','Comedy','Family'],
director:['Mark Burton','Richard Starzak'],
actors:['Omid Djalili','John Sparkes','Kate Harbour','Andy Nyman','Nick Park','Justin Fletcher','Richard Webber','Simon Greenall','Jack Paulson'],
screenplay:['Mark Burton','Richard Starzak'],
production:['Paul Kewley','Julie Lockhart'],
music:['Ilan Eshkeri'],
camera:['Dave Alex Riddett','Charles Copping'],
cut:['Sim Evan-Jones'],
sound:['Antony Bayman']},
{title:'A Few Best Men',
titleCZ:'Pařmeni',
year:2011,
runtime:97,
countries:['Australia','UK'],
genres:['Comedy'],
director:['Stephan Elliott'],
actors:['Laura Brent','Xavier Samuel','Kris Marshall','Kevin Bishop','Tim Draxl','Elizabeth Debicki','Rebel Wilson','Olivia Newton-John','Steve Le Marquand','Guy Gross','Matt Butcher','Oliver Torr','David Sullivan','Kim Knuckey'],
screenplay:['Dean Craig'],
production:['Josh Kesselman','Antonia Barnard','Gary Hamilton','Share Stallings'],
music:['Guy Gross'],
camera:['Stephen F. Windon'],
cut:['Sue Blainey'],
sound:['Sam Hayward'],
scenography:['George Liddle'],
costumes:['Lizzy Gardiner']},
{title:'Passengers',
titleCZ:'Pasažéři',
year:2016,
runtime:116,
countries:['USA'],
genres:['Adventure','Drama','Romance','Sci-Fi'],
director:['Morten Tyldum'],
actors:['Chris Pratt','Jennifer Lawrence','Michael Sheen','Laurence Fishburne','Aurora Perrineau','Andy Garcia','Fred Melamed','Jean-Michel Richaud','Kara Flowers','Kayla Radomski','Julee Cerda','Zeus Mendoza','Kristin Brock','Matt Corboy','Chris Edgerly','Marie Burke','Lauren Farmer'],
screenplay:['Jon Spaihts'],
production:['Stephen Hamel','Michael Maher','Ori Marmur','Neal H. Moritz'],
music:['Thomas Newman'],
camera:['Rodrigo Prieto'],
cut:['Maryann Brandon'],
sound:["Kevin O'Connell",'Will Files'],
scenography:['Guy Hendrix Dyas','Luke Freeborn','Gene Serdena'],
masks:['Gigi Collins','Mike Smithson','Teresa Foshee','Vivian Baker'],
costumes:['Jany Temime']},
{title:'Pet',
titleCZ:'Zvířátko',
year:2016,
runtime:94,
countries:['USA','Spain'],
genres:['Horror','Thriller'],
director:['Carles Torrens'],
actors:['Ksenia Solo','Dominic Monaghan','Jennette McCurdy','Nathan Parsons','Gary J. Tunnicliffe',"Da'Vone McDonald",'Sean Blakemore','John Ross Bowie','Irene Roseen','Janet Song'],
screenplay:['Jeremy Slater'],
production:['Carles Torrens','Nick Phillips'],
music:['Zacarías M. de la Riva'],
camera:['Timothy A. Burton'],
cut:['Elena Ruiz'],
scenography:['Krystyna Loboda'],
costumes:['Olivia Miles']},
{title:'Four Weddings and a Funeral',
titleCZ:'Čtyři svatby a jeden pohřeb',
year:1994,
runtime:117,
countries:['UK','USA'],
genres:['Comedy','Romance','Drama'],
director:['Mike Newell'],
actors:['Hugh Grant','Andie MacDowell','James Fleet','Simon Callow','John Hannah','Kristin Scott Thomas','Elspet Gray','Rowan Atkinson','Corin Redgrave','Anna Chancellor','Hannah Taylor-Gordon','Bernice Stegers','Jeremy Kemp','Sophie Thompson','Charlotte Coleman','David Haig','Nicola Walker','Struan Rodger','Simon Kunz','Duncan Kenworthy','Rosalie Crutchley','Rupert Vansittart','Kenneth Griffith','Philip Voss','Randall Paul','Sara Crowe','Richard Butler','Nigel Hastings','Juliette James'],
screenplay:['Richard Curtis'],
production:['Duncan Kenworthy','Eric Fellner'],
music:['Richard Rodney Bennett'],
camera:['Michael Coulter'],
cut:['Jon Gregory'],
scenography:['Anna Pinnock'],
masks:['Ann Buchanan'],
costumes:['Lindy Hemming']},
{title:'Fahrenheit 451',
titleCZ:'451 stupňů Fahrenheita',
year:2018,
runtime:100,
countries:['USA'],
genres:['Drama','Sci-Fi'],
director:['Ramin Bahrani'],
actors:['Michael Shannon','Michael B. Jordan','Sofia Boutella','Lilly Singh','Tim Post','Jane Moffat','Keir Dullea','Martin Donovan','Grace Lynn Kung','Dylan Taylor','Lynne Griffin','Raoul Bhaneja','Christopher Cordell','David Tompa','Daniel Zolghadri','Drew Nelson','Edsson Morales','Saad Siddiqui','Alex Spencer','Cindy Katz','Andy McQueen'],
basedOn:['Ray Bradbury'],
screenplay:['Ramin Bahrani','Amir Naderi'],
production:['David Coatsworth'],
music:['Antony Partos','Matteo Zingales'],
camera:['Kramer Morgenthau'],
sound:['Tom Fleischman','Jacob Ribicoff','Henry Embry'],
scenography:['Mark Digby','Kimberley Zaharko'],
masks:['Jordan Samuel','Kristin Wayne','Rhosael Ciandre'],
costumes:['Meghan Kasperlik']},
{title:'Taken 2',
titleCZ:'96 hodin: Odplata',
year:2012,
runtime:92,
countries:['France'],
genres:['Action','Thriller'],
director:['Olivier Megaton'],
actors:['Liam Neeson','Famke Janssen','Maggie Grace','Rade Šerbedžija','Luke Grimes','Leland Orser','Jon Gries','D.B. Sweeney','Ergun Kuyucu','Laura Bryce','Alain Figlarz','Luran Ahmeti','Cengiz Bozkurt','Michaël Vander-Meiren','Uğur Uğural','Kenneth James Dakan','Çağan Atakan Arslan','Atilla Pekoz','Mustafa Akın','Eraslan Sağlam','Alex Dawe','Ahmet Orhan Özçam'],
screenplay:['Luc Besson','Robert Mark Kamen'],
production:['Luc Besson'],
music:['Nathaniel Méchaly'],
camera:['Romain Lacourbas'],
cut:['Vincent Tabaillon','Camille Delamarre'],
sound:['Andrii Trifonov'],
scenography:['Sébastien Inizan'],
masks:['Brian McManus','Steven R. Soussanna'],
costumes:['Pamela Lee Incardona']},
{title:"It's Gonna Get Worse",
titleCZ:'...a bude hůř',
year:2007,
runtime:84,
countries:['Czechia'],
genres:['Drama'],
director:['Petr Nikolaev'],
actors:['Karel Žídek','Filip Kaňkovský','Radomil Uhlíř','Pavel Zajíček','Vladimír Škultéty','Karel Zima','Otmar Brancuzský','Jiří Maria Sieber','Michal Gulyáš','Tereza Hofová','Perla Kotmelová','Vratislav Brabenec','Miroslav Hanuš','Martin Matejka','Markéta Štechová','Hynek Čermák','Petr Koza','Martin Dusbaba','Jiří Kout','Martin Veliký','Lenka Ouhrabková','Jiří Hajdyla','Michal Pešek','Jan Šantroch','Viktorie Jackson','Erika Deutschová','Prasman Dunka'],
basedOn:['Jan Pelc'],
screenplay:['Petr Nikolaev','Jan Pelc'],
production:['Petr Koza','Čestmír Kopecký'],
music:['Jim Čert','Michal Ambrož'],
camera:['Diviš Marek'],
cut:['Jiří Brožek'],
sound:['Ladislav Procházka'],
scenography:['Tomáš Kuča','Petr Pištěk'],
costumes:['Simona Rybáková']},
{title:'The Dawns Here Are Quiet',
titleCZ:'...a jitra jsou zde tichá',
year:1972,
runtime:188,
countries:['Russia'],
genres:['Drama','War'],
director:['Stanislav Rostockij'],
actors:['Irina Ševčuk','Jelena Drapeko','Andrej Martynov','Vladimir Sergejevič Ivašov','Igor Kostolevskij','Olga Ostroumova','Kirill Stoljarov','Alexej Černov','Jekatěrina Markova','Irina Dolganova','Alexandr Mězencev','Georgij Martynjuk','Irina Kmit','Alla Meščerjakova','Viktor Avdjuško','Natalja Pjarn','Boris Tokarev'],
screenplay:['Stanislav Rostockij','Boris Vasiljev'],
music:['Kirill Molčanov'],
camera:['Vjačeslav Šumskij']},
{title:'Angelique and the King',
titleCZ:'Angelika a král',
year:1966,
runtime:100,
countries:['France','Italy','Germany'],
genres:['Adventure','History','Romance'],
director:['Bernard Borderie'],
actors:['Michèle Mercier','Jacques Toja','Sami Frey','Robert Hossein','Jean Rochefort','Estella Blain','Michel Galabru','Philippe Lemaire','Fred Williams','René Lefèvre','Ann Smyrner','Pasquale Martino','Jean Lefebvre','Claude Giraud','Jean Parédès','Jacques Hilling','Dominique Zardi','Roberto','Michel Thomass','Robert Favart','Valérie Boisgel','Jean Degrave','Joëlle Bernard','Dany Jacquet'],
basedOn:['Anne Golon','Serge Golon'],
screenplay:['Bernard Borderie','Alain Decaux','Francis Cosne'],
production:['Raymond Borderie','Francis Cosne'],
music:['Michel Magne'],
camera:['Henri Persin'],
cut:['Christian Gaudin'],
sound:['Jean Nény'],
costumes:['Rosine Delamare']},
{title:'Angelique and the Sultan',
titleCZ:'Angelika a sultán',
year:1968,
runtime:105,
countries:['France','Italy','Germany'],
genres:['Romance','History','Adventure'],
director:['Bernard Borderie'],
actors:['Michèle Mercier','Robert Hossein','Jean-Claude Pascal','Aly Ben Ayed','Helmuth Schneider','Roger Pigaut','Jacques Santi','Sieghardt Rupp','Ettore Manni','Erno Crisa','Arturo Dominici','Mino Doro','Henri Cogan','Gaby Mesée','Manja Golec','Bruno Dietrich','Mario Meniconi','Renato De Carmine'],
basedOn:['Anne Golon','Serge Golon'],
screenplay:['Bernard Borderie','Francis Cosne'],
production:['Raymond Borderie','Francis Cosne','François Chavane'],
music:['Michel Magne'],
camera:['Henri Persin'],
cut:['Christian Gaudin'],
sound:['Jean Nény'],
costumes:['Rosine Delamare']},
{title:'Angelika, markýza andělů',
titleCZ:'Angelika, markýza andělů',
year:1964,
runtime:115,
countries:['France','Germany','Italy'],
genres:['Adventure'],
director:['Bernard Borderie'],
actors:['Michèle Mercier','Robert Hossein','Jean Rochefort','Claude Giraud','Giuliano Gemma','Jacques Toja','Robert Hoffmann','Bernard La Jarrige','Madeleine Lebeau','Bernard Woringer','Philippe Lemaire','Robert Porte','Geneviève Fontanel','Etchika Choureau','Jean Topart','Jacques Castelot','Paula Dehelly','Yves Barsacq','Rosalba Neri','François Maistre','Serge Marquand','Jean Ozenne','Monique Mélinand','Renate Ewert','Denise Provence','Jacques Hilling','Alexandre Rignault','Claude Vernier','Albert Dagnant','André Rouyer','Michel de Ré','Roberto','Georges Guéret','Geymond Vital','Noëlle Noblecourt','Henri Cogan','Elizabeth Ercy','Sylvie Coste','Pierre Hatet','Ellen Bahl','Charles Regnier','Britt Semand'],
basedOn:['Anne Golon','Serge Golon'],
screenplay:['Bernard Borderie','Daniel Boulanger','Claude Brulé','Francis Cosne'],
production:['Raymond Borderie','Francis Cosne'],
music:['Michel Magne'],
camera:['Henri Persin'],
cut:['Christian Gaudin'],
sound:['Jean Nény'],
scenography:['René Moulaert'],
costumes:['Rosine Delamare']},
{title:'Bába z ledu',
titleCZ:'Bába z ledu',
year:2017,
runtime:106,
countries:['Czechia','Slovakia','France'],
genres:['Drama','Comedy','Romance'],
director:['Bohdan Sláma'],
actors:['Zuzana Kronerová','Pavel Nový','Daniel Vízek','Václav Neužil ml.','Marek Daniel','Tatiana Dyková','Petra Špalková','Alena Mihulová','Tadeáš Kalcovský','Luboš Veselý','Josef Ježek','Marie Ludvíková','Tobiáš Rímský','Mariana Chmelařová','Zdeňka Sajfertová','Mirka Louthanová'],
screenplay:['Bohdan Sláma'],
production:['Pavel Strnad','Petr Oukropec'],
camera:['Diviš Marek'],
cut:['Jan Daňhel'],
sound:['Michal Holubec','Marek Poledna'],
scenography:['Jan Vlasák'],
masks:['Zdeněk Klika'],
costumes:['Zuzana Krejzková']},
{title:'Angelique: The Road to Versailles',
titleCZ:'Báječná Angelika',
year:1965,
runtime:100,
countries:['France','Germany','Italy'],
genres:['Adventure'],
director:['Bernard Borderie'],
actors:['Michèle Mercier','Jean Rochefort','Jean-Louis Trintignant','Claude Giraud','Giuliano Gemma','Robert Hoffmann','Jacques Toja','Robert Porte','Noël Roquevert','Rosalba Neri','Claire Maurier','François Maistre','Elizabeth Ercy','Serge Marquand','Denise Provence','Jacques Hilling','Malka Ribowska','Paul Mercey','Olivier Hussenot','Pietro Tordi','Roberto','Henri Cogan','Nadia Barentin','Ernst Schröder','Charles Regnier','Gino Marturano','Gianni Di Segni'],
basedOn:['Anne Golon','Serge Golon'],
screenplay:['Bernard Borderie','Daniel Boulanger','Claude Brulé','Francis Cosne'],
production:['Raymond Borderie','Francis Cosne'],
music:['Michel Magne'],
camera:['Henri Persin'],
cut:['Christian Gaudin'],
sound:['Jean Nény'],
scenography:['René Moulaert'],
costumes:['Rosine Delamare']},
{title:'The Wonderful Years That Sucked',
titleCZ:'Báječná léta pod psa',
year:1997,
runtime:109,
countries:['Czechia'],
genres:['Comedy'],
director:['Petr Nikolaev'],
actors:['Ondřej Vetchý','Libuše Šafránková','Vladimír Javorský','Jan Zahálka','Jakub Wehrenberg','Klára Botková','Jitka Ježková','Vladimír Dlouhý','Vilma Cibulková','Miriam Kantorková','Květa Fialová','Stanislav Zindulka','Otakar Brousek st.','Viktor Preiss','Jiří Schmitzer','Alice Bendová','Emma Černá','Miloň Čepelka','Otmar Brancuzský','Lenka Vychodilová','Jan Hraběta','Zdeněk David','Vlastimil Zavřel','Jan Slovák','Jiří Fero Burda','Aleš Najbrt','Bohumil Klepl','Jan Vondráček','František Švihlík','Doubravka Svobodová','Petr Koutecký','Jaroslav Horák','Martin Matejka','Bohumila Kuklová','Ladislav Klepal','Miloslav Uhlíř','Milena Dvorská','Martin Luhan'],
basedOn:['Michal Viewegh'],
screenplay:['Jan Novák'],
production:['Jiří Ježek'],
music:['Michal Dvořák','Ivan Hlas'],
camera:['Martin Duba'],
cut:['Alois Fišárek'],
sound:['Vladimír Nahodil','Jan Kacián'],
scenography:['Milan Býček'],
masks:['František Příhoda','Zdena Prchlíková'],
costumes:['Katarína Hollá']},
{title:'Conan the Barbarian',
titleCZ:'Barbar Conan',
year:1982,
runtime:129,
countries:['USA'],
genres:['Action','Fantasy','Adventure'],
director:['John Milius'],
actors:['Arnold Schwarzenegger','James Earl Jones','Max von Sydow','Sandahl Bergman','Ben Davidson','Mako','Valérie Quennessen','William Smith','Franco Columbu','Jorge Sanz','Jack Taylor','Sven-Ole Thorsen','John Milius','Pilar Alcón','Donald Gibb','Gerry Lopez','Cassandra Gava','Andrea Guzon','Nadiuska','Ron Cobb','Celia Kaye','Luis Barboo'],
basedOn:['Robert E. Howard'],
screenplay:['John Milius','Oliver Stone'],
production:['Dino De Laurentiis','Buzz Feitshans','Raffaella De Laurentiis'],
music:['Basil Poledouris'],
camera:['Duke Callaghan'],
cut:["Carroll Timothy O'Meara"],
sound:['Michael Jiron','Jim Willis'],
scenography:['Ron Cobb'],
masks:['Colin Arthur'],
costumes:['John Bloomfield']},
{title:'Baraka',
titleCZ:'Baraka - Odysea země',
year:1992,
runtime:96,
countries:['USA'],
genres:['Documentary'],
director:['Ron Fricke'],
music:['Michael Stearns'],
camera:['Ron Fricke'],
cut:['David Aubrey']},
{title:'100 Things',
titleCZ:'Bez věcí nad věcí',
year:2018,
runtime:111,
countries:['Germany'],
genres:['Comedy'],
director:['Florian David Fitz'],
actors:['Florian David Fitz','Matthias Schweighöfer','Miriam Stein','Hannelore Elsner','Wolfgang Stumph','Katharina Thalbach','Johannes Allmayer','Maria Furtwängler','Sarah Viktoria Frick','Artjom Gilz','Daniel Flieger','Nora Boeckler','Milo Eisenblätter'],
screenplay:['Florian David Fitz'],
production:['Dan Maag','Daniel Sonnabend'],
music:['Josef Bach','Arne Schumann'],
camera:['Bernhard Jasper'],
cut:['Denis Bachter','Ana de Mier y Ortuño'],
sound:['Achim Hofmann','Christian Bischoff','Marc Meusinger'],
scenography:['Christian Eisele','Alexandra Pilhatsch'],
masks:['Katharina De Malotki','Charlotte Chang'],
costumes:['Metin Misdik']},
{title:'Teeth Bewitched to Get Hitched',
titleCZ:'Bezva zuby na zásnuby',
year:2022,
runtime:67,
countries:['Czechia'],
genres:['Comedy'],
director:['Jiří Vejdělek'],
actors:['Jiří Langmajer','Anna Fialová','Simona Stašová','Miroslav Hanuš','Mia Kavanová','Martin Sitta','Betka Stanková','Jan Vondráček','Šárka Kubíková','Miluše Bittnerová','Naďa Bartáková','Milan Enčev','Bohdana Pavlíková','Martin Matejka','Zdeněk Stadtherr','Milan Slepička','Julie Brožová'],
screenplay:['Marek Epstein'],
production:['Jaroslav Sedláček'],
music:['Jan P. Muchow'],
camera:['Martin Šácha'],
cut:['Ondřej Hokr'],
sound:['Michal Pajdiak'],
scenography:['Milan Býček'],
masks:['Dana Kleňhová'],
costumes:['Simona Rybáková','Lucie Urbanová']},
{title:'The Running Man',
titleCZ:'Běžící muž',
year:1987,
runtime:101,
countries:['USA'],
genres:['Sci-Fi','Action','Thriller'],
director:['Paul Michael Glaser'],
actors:['Arnold Schwarzenegger','Maria Conchita Alonso','Richard Dawson','Yaphet Kotto','Jim Brown','Jesse Ventura','Erland van Lidth','Professor Toru Tanaka','Marvin J. McIntyre','Gus Rethwisch','Mick Fleetwood','Sven-Ole Thorsen','Edward Bunker','Kurt Fuller','Dey Young','Rodger Bumpass','Lin Shaye','Jeff Jensen','Franco Columbu','Boyd Kestner','Thomas Rosales Jr.','Ken Lerner','Karen Leigh Hopkins','Anthony Pena','Wayne Grace','Lynne Marie Stewart','Greg Lewis','Kerry Wall','Dona Hardy','Bryan Kestner','George P. Wilbur','Dweezil Zappa','Megan Gallivan'],
basedOn:['Stephen King'],
screenplay:['Steven E. de Souza'],
production:['Tim Zinnemann'],
music:['Vassal Benford','Harold Faltermeyer'],
camera:['Thomas Del Ruth'],
cut:['Edward A. Warschilka','Mark Warner','John Wright'],
sound:['James Cavarretta',"Kevin O'Connell"],
scenography:['Jack T. Collis','Jim Duffy'],
masks:['James Lee McCoy','Jeff Dawn','Steve La Porte','Frankie Bergman'],
costumes:['Robert Blackman']},
{title:'The White Massai',
titleCZ:'Bílá masajka',
year:2005,
runtime:131,
countries:['Germany'],
genres:['Drama','Romance'],
director:['Hermine Huntgeburth'],
actors:['Nina Hoss','Jacky Ido','Katja Flint','Nino Prester','Janek Rieke','Barbara M. Ahren','Robert Dölle','Barbara Herschbach'],
basedOn:['Corinne Hofmann'],
screenplay:['Johannes W. Betz','Ruth Toma'],
production:['Günter Rohrbach'],
music:['Niki Reiser'],
camera:['Martin Langer'],
cut:['Eva Schnare'],
sound:['Martin Steyer','Stefan Busch','Eckhard W. Kuchenbecker'],
scenography:['Susann Bieling','Uwe Szielasko'],
masks:['Sabine Hehnen-Wild','Gregor Eckstein'],
costumes:['Maria Dimler']},
{title:'Point Break',
titleCZ:'Bod zlomu',
year:1991,
runtime:120,
countries:['USA','Japan'],
genres:['Action','Crime','Thriller'],
director:['Kathryn Bigelow'],
actors:['Patrick Swayze','Keanu Reeves','Gary Busey','Lori Petty','John C. McGinley','James Le Gros','Bojesse Christopher','Julian Reyes','Daniel Beer','Vincent Klyn','Anthony Kiedis','Christopher Pettiet','Michael Kopelow','Tom Sizemore','Elizabeth Berkley','Debra Lamb','Lee Tergesen','Sydney Walsh','John Philbin','Peter Phelps','Chris Pedersen','Mike Genovese','Richard Grove','Ping Wu','John Apicella','Jack Kehler','Julie Michaels','Galyn Görg','Raymond Forchion','Anthony Mangano','Betsy Lynn George','Jeff Imada','Mick Regan','Gary Roberts'],
screenplay:['W. Peter Iliff'],
production:['Peter Abrams','Robert L. Levy'],
music:['Mark Isham'],
camera:['Donald Peterman'],
cut:['Howard E. Smith'],
sound:['Bob Beemer','Roland Winke','Greg P. Russell'],
scenography:['Peter Jamison'],
masks:['Greg LaCava','Wes Dawn','Michael Mills']},
{title:'Bolt',
titleCZ:'Bolt - pes pro každý případ',
year:2008,
runtime:93,
countries:['USA'],
genres:['Animation','Comedy','Family','Adventure'],
director:['Chris Williams','Byron Howard'],
actors:['John Travolta','Miley Cyrus','Susie Essman','Malcolm McDowell','Chloë Grace Moretz','Greg Germann','James Lipton','Nick Swardson','Nathan Greno','Diedrich Bader','Grey Griffin','Brian Stepanek','John DiMaggio','Chris Williams','Tara Strong','Jenny Lewis','Ronn Moss','Dan Fogelman','Daran Norris','Kari Wahlgren','Randy Savage','Mark Walton','Özz Nûjen','Paul Pape','Lino DiSalvo','J.P. Manoux','June Christopher','David Cowgill','Sean Donnellan','Karen Ryan'],
screenplay:['Dan Fogelman','Chris Williams'],
production:['Clark Spencer'],
music:['John Powell'],
sound:['Frank Eulner','Randy Thom','David E. Fluhr','Argiris Kandilis'],
scenography:['Paul A. Felix']},
{title:'Bruce Almighty',
titleCZ:'Božský Bruce',
year:2003,
runtime:100,
countries:['USA'],
genres:['Comedy','Fantasy','Romance'],
director:['Tom Shadyac'],
actors:['Jim Carrey','Jennifer Aniston','Morgan Freeman','Philip Baker Hall','Lisa Ann Walter','Steve Carell','Nora Dunn','Eddie Jemison','Paul Satterfield','Sally Kirkland','Emilio Rivera','Robert Curtis Brown','Shaun Robinson','Catherine Bell','Mary Pat Gleason','Ara Celi','Max Grodénchik','Shashawnee Hall','Colby French','Bradley Stryker','Ben Livingston','Mark Adair-Rios','Noel Gugliemi','Ted Garcia','Annie Wersching','Darcy Fowers','Ron Jeremy','Michael Villani','Tony Bennett','P.J. Byrne','Cubbie Kile','Michael Bofshever','Lillian Adams','Mark Kiely','Alfred Dennis','Sabrina Culver','Ryan McGonagle','Dohn Norwood','Dan Desmond','Greg Collins','Tom Beyer','Christopher Darga','Rolando Molina','Don Dowe','Nelson Mashita','Carey Scott','Gino Montesinos','Carrie Quinn Dolin','Allen Lulu','William Thomas Jr.','Micah Williams','Nick Huff','Bette Rae','Manny Suárez','Michael Olifiers','Jamison Yang','Gina St. John','Dougald Park','Adrian Neil'],
screenplay:['Steve Koren',"Mark O'Keefe"],
production:['Jim Carrey','Tom Shadyac',"Mark O'Keefe"],
music:['John Debney'],
camera:['Dean Semler'],
cut:['Scott Hill'],
sound:['Steve Maslow','Odin Benitez'],
scenography:['Linda DeScenna'],
masks:['Lance Anderson','David LeRoy Anderson','Bill Corso',"Valli O'Reilly",'Anne Morgan','Kim M. Ferry','Melissa Forney'],
costumes:['Judy L. Ruskin']},
{title:'La Femme Nikita',
titleCZ:'Brutální Nikita',
year:1990,
runtime:117,
countries:['France','Italy'],
genres:['Action','Thriller'],
director:['Luc Besson'],
actors:['Anne Parillaud','Jean-Hugues Anglade','Tchéky Karyo','Jeanne Moreau','Jean Reno','Roland Blanche','Marc Duret','Philippe Leroy','Jacques Boudet','Philippe du Janerand','Jean Bouise','Pierre-Alain de Garrigues','Jacques Disses','Stéphane Fey','Philippe Dehesdin','Pavel Slabý','Jean-Luc Caron','Rénos Mandis','Iska Khan','Edith Perret','Hubert Gillet','Eric Prat','Mia Frye','Olivier Hémon','Christian Gazio','Jean-Claude Bolle-Reddat','Maurice Antoni','Michèle Amiel','Xavier Bonastre','Pétronille Moss'],
screenplay:['Luc Besson'],
production:['Patrice Ledoux'],
music:['Eric Serra'],
camera:['Thierry Arbogast'],
cut:['Olivier Mauffroy'],
sound:['Pierre Befve','Gérard Lamps','Marie Guesnier'],
scenography:['Dan Weil'],
masks:['Geneviève Peyralade'],
costumes:['Mimi Lempicka']},
{title:'Deck the Halls',
titleCZ:'Budiž světlo',
year:2006,
runtime:89,
countries:['USA'],
genres:['Comedy','Family'],
director:['John Whitesell'],
actors:['Danny DeVito','Matthew Broderick','Kristin Davis','Kristin Chenoweth','Alia Shawkat','Dylan Blue','Jorge Garcia','Lochlyn Munro','Fred Armisen','Gillian Vigman','Jackie Burroughs','Garry Chalk','Nicola Peltz','Zak Santiago','Jill Morrison','Quinn Lord','Fulvio Cecere','Cory Monteith','Ty Olsson','Agam Darshi','Aaron Pearl',"Sean O'Bryan",'Kelly Aldridge','Sabrina Aldridge','David Lewis','Calum Worthy','Caroline Redekopp','Kal Penn','Ryan Devlin','Alf Humphreys','Ken Kramer','Brenda Crichlow','Aaron Craven','Daniel Bacon','David Stuart'],
screenplay:['Matt Corman','Chris Ord','Don Rhymer'],
production:['Michael Costigan','Arnon Milchan'],
music:['George S. Clinton'],
camera:['Mark Irwin'],
cut:['Paul Hirsch'],
sound:['Chris Carpenter','Andy Koyama'],
scenography:['Bill Brzeski','Tedd Kuchera'],
masks:['Lisa Love'],
costumes:['Carol Ramsey']},
{title:'The Celestine Prophecy',
titleCZ:'Celestinské proroctví',
year:2006,
runtime:99,
countries:['USA'],
genres:['Adventure'],
director:['Armand Mastroianni'],
actors:['Matthew Settle','Thomas Kretschmann','Annabeth Gish','Hector Elizondo','Joaquim de Almeida','Jürgen Prochnow','Obba Babatundé','Sarah Wayne Callies','Castulo Guerra','Tequan Richmond','Kyle Reed','John Aylward','Vinicius Machado','Robyn Cohen','Vernee Watson','Robert Harvey','Aaron Grady','Ryan Sparks','Sammy Kahn','Eric Esteban','Eli T. Peña'],
screenplay:['Dan Gordon','Barnet Bain'],
production:['Barnet Bain','Terry Collis','Beverly J. Camhe'],
music:['Nuno Malo'],
cut:['Maysie Hoy','Scott Vickrey'],
sound:['Thomas E. Allen'],
scenography:['James L. Schoppe'],
masks:['Diane Maurno','Randa Squillacote']},
{title:'The Commuter',
titleCZ:'Cizinec ve vlaku',
year:2018,
runtime:105,
countries:['USA','France'],
genres:['Mystery','Action','Crime','Thriller','Drama'],
director:['Jaume Collet-Serra'],
actors:['Liam Neeson','Vera Farmiga','Patrick Wilson','Jonathan Banks','Sam Neill','Elizabeth McGovern','Killian Scott','Shazad Latif','Andy Nyman','Clara Lago','Roland Møller','Florence Pugh','Dean-Charles Chapman','Ella-Rae Smith','Kobna Holdbrook-Smith','Colin McFarlane','Adam Nagaitis','Kingsley Ben-Adir','Damson Idris','Andy Lucas','Zaak Conway','Ben Caplan','Letitia Wright','Jamie Beamish','Edward Bluemel','Aoife Hinds','Jaime Menéndez','Anthony Milton','Graham Curry','Peter Meyer','Pamela Betsy Cooper','Steven I. Dillard','Pat Kiernan'],
screenplay:['Byron Willinger','Philip de Blasi','Ryan Engle'],
production:['Andrew Rona','Alex Heineman'],
music:['Roque Baños'],
camera:['Paul Cameron'],
cut:['Nicolas De Toth'],
sound:['James Harrison'],
scenography:['Richard Bridgland','Wing Lee','Tina Jones'],
masks:['Noriko Watanabe'],
costumes:['Betsy Heimann','Jill Taylor']},
{title:'Cliffhanger',
titleCZ:'Cliffhanger',
year:1993,
runtime:110,
countries:['USA','Italy','France'],
genres:['Action','Adventure','Thriller'],
director:['Renny Harlin'],
actors:['Sylvester Stallone','John Lithgow','Michael Rooker','Janine Turner','Rex Linn','Caroline Goodall','Leon','Craig Fairbrass','Gregory Scott Cummins','Michelle Joyner','Max Perlich','Paul Winfield','Ralph Waite','Zach Grenier','Bruce McGill','Don Davis','Jeff Blynn','John Finn','Rosemary Dunsmore','Denis Forest','Vyto Ruginis','Kim Robillard','Scott Hoxby','Jeff McCarthy'],
screenplay:['Michael France','Sylvester Stallone'],
production:['Alan Marshall','Renny Harlin'],
music:['Trevor Jones'],
camera:['Alex Thomson'],
cut:['Frank J. Urioste'],
sound:['Bob Beemer','Michael Minkler','Wylie Stateman'],
scenography:['John Vallone','Robert Gould'],
masks:['Gary Liddiard','Jeff Dawn','Jim Kail','Aldo Signoretti'],
costumes:['Ellen Mirojnick']},
{title:'Rumor Has It...',
titleCZ:'Co je šeptem...',
year:2005,
runtime:93,
countries:['USA','Australia','Germany'],
genres:['Comedy','Romance'],
director:['Rob Reiner'],
actors:['Jennifer Aniston','Mark Ruffalo','Shirley MacLaine','Kevin Costner','Kathy Bates','Richard Jenkins','Christopher McDonald','Mena Suvari','Mike Vogel','Roger Lim','Andy Milder','Erinn Bartlett','Jaime Ray Newman','Jenny Wade','Jennifer Taylor','Erinn Hayes','Sandra Plazinic','Maree Cheatham','Christopher Stapleton','Paul Ganus','Jordan Lund','Lisa Vachon','Robert Foreman','Rachel Zeskind','Gabriel Jarret','Troy Christian','Leigh French','Terrie Snell','Rolando Molina','Frank Novak','Charlotte Colavin','Lynn Wanlass','Marcia Ann Burrs','George Gerdes','Donna Cooper','Mike Baldridge','Joshua Bevier','Gregory White','John Sterling Carter'],
screenplay:['Ted Griffin'],
production:['Paula Weinstein','Ben Cosgrove'],
music:['Marc Shaiman'],
camera:['Peter Deming'],
cut:['Robert Leighton'],
sound:['Tony Lamberti'],
scenography:['Thomas E. Sanders','Jay Hart'],
masks:["Valli O'Reilly",'Stephen Kelley','Linda De Andrea','Vera Yurtchuk'],
costumes:['Kym Barrett']},
{title:'What Would You Say to Some Spinach?',
titleCZ:'Což takhle dát si špenát',
year:1977,
runtime:86,
countries:['Czechoslovakia'],
genres:['Comedy','Sci-Fi'],
director:['Václav Vorlíček'],
actors:['Vladimír Menšík','Jiří Sovák','Iva Janžurová','Michal Kocourek','Ondřej Hach','František Filipovský','Ivana Maříková','Petr Přívozník','Stella Zázvorková','Josef Somr','Eva Hudečková','Petr Kostka','Jaroslava Obermaierová','Bedřich Prokoš','Čestmír Řanda st.','Juraj Herz','Josef Větrovec','Václav Štekl','Lubomír Kostelka','Petr Nárožný','Jiří Lír','Vladimír Hlavatý','Míla Myslíková','Luděk Kopřiva','Miroslav Vlček','Jan Přeučil','Vladimír Krška','František Miroslav Doubrava','Václav Sloup','Alena Kreuzmannová','Josef Beyvl','Vlastimil Hašek','Oldřich Velen','Jan Kraus','Jaroslav Drbohlav','Zdeněk Braunschläger','Vítězslav Černý','Otto Budín','Václav Kotva','Helena Růžičková','Vladimír Hrubý','Roman Čada','Inka Čekanová','Jiřina Bílá','Jaroslav Heyduk','Jožka Stoklasa','Gabriela Wilhelmová','Stanislav Remunda','Jan Kuželka','Viktor Maurer','Zdeněk Blažek','Jan Gariš','Pavel Jiras','Petr Kopřiva','Miroslav Krejča','Jaroslav Tomsa','Karel Hovorka st.','Milica Kolofíková','Alena Frimlová','Stanislav Litera','Karel Fridrich','Václav Hrůza','Pavel Robin','Jitka Nováková','Eduard Pavlíček','Vladimír Klimeš','Rudolf Pechan','Marta Richterová','Jana Váňová','Žofie Veselá','Anna Štrosová','Alois Vachek','Josef Kubíček','Vincenc Vávra','Dana Francová','Petr Makovička','Věra Petáková','Karel Fiala','Karel Hluchý','Jan Řeřicha','Karel Woska','Zlata Jeřábková','Bohumil Koška','Bohuslav Ličman','Vladimír Pospíšil','Ferdinand Šnajberk','Slávka Hamouzová','Jiří Potsch','Marek Fritsch','Vladimír Fürst','Vladimír Navrátil','Vít Pešina','Jaroslav Pfleger','Josef Střecha','Miloslav Šindler','Soňa Vlčková','Lubor Tokoš','Miloš Vavruška'],
screenplay:['Miloš Macourek'],
music:['Karel Svoboda'],
camera:['František Uldrich'],
cut:['Miroslav Hájek'],
sound:['František Fabián'],
scenography:['Oldřich Bosák'],
masks:['Jiří Hurych','Jiřina Bissingerová','Pavel Minichbauer'],
costumes:['Theodor Pištěk ml.','Ludmila Ondráčková']},
{title:'Cry Macho',
titleCZ:'Cry Macho',
year:2021,
runtime:104,
countries:['USA'],
genres:['Drama'],
director:['Clint Eastwood'],
actors:['Clint Eastwood','Dwight Yoakam','Fernanda Urrejola','Horacio Garcia Rojas','Sebestien Soliz','Ana Rey','Brytnee Ratledge','Alexandra Ruddy','Natalia Traven','Ramona Thornton','Eduardo Minett','Paul Alayo','Daniel V. Graulau','Amber Lynn Ashley','Rocko Reyes'],
basedOn:['N. Richard Nash'],
screenplay:['Nick Schenk','N. Richard Nash'],
production:['Clint Eastwood','Daniel Grodnik','Jessica Meier','Tim Moore','Albert S. Ruddy'],
music:['Mark Mancina'],
camera:['Ben Davis'],
cut:['David S. Cox','Joel Cox'],
sound:['Alan Robert Murray','Dean A. Zupancic','Tom Ozanich'],
scenography:['Ronald R. Reiss','Christopher Carlson'],
masks:['Betty Niecy Alexander-Lawson'],
costumes:['Deborah Hopper']},
{title:'The Witches of Eastwick',
titleCZ:'Čarodějky z Eastwicku',
year:1987,
runtime:114,
countries:['USA'],
genres:['Comedy','Fantasy','Horror'],
director:['George Miller'],
actors:['Jack Nicholson','Cher','Susan Sarandon','Michelle Pfeiffer','Veronica Cartwright','Richard Jenkins','Carel Struycken','James Boyle','Corey Carrier','Harriet Medin','Ron Campbell','Jane A. Johnston','Carole White','Becca Lish'],
basedOn:['John Updike'],
screenplay:['Michael Cristofer'],
production:['Neil Canton','Jon Peters','Peter Guber'],
music:['John Williams'],
camera:['Vilmos Zsigmond'],
cut:['Richard Francis-Bruce','Hubert de La Bouillerie'],
sound:['Tom E. Dahl'],
scenography:['Polly Platt','Joe D. Mitchell'],
masks:['Rob Bottin'],
costumes:['Aggie Guerard Rodgers']},
{title:"Prizzi's Honor",
titleCZ:'Čest rodiny Prizziů',
year:1985,
runtime:130,
countries:['USA'],
genres:['Comedy','Drama','Romance','Crime'],
director:['John Huston'],
actors:['Jack Nicholson','Kathleen Turner','Robert Loggia','John Randolph','William Hickey','Lee Richardson','Anjelica Huston','Michael Lombard','Lawrence Tierney','CCH Pounder','Raymond Serra','Dominic Barto','Stanley Tucci','Nick Vallelonga','Mark Lotito',"Dick O'Neill",'Joseph Ruskin','Vic Polizos','Sully Boyar','George Santopietro','Tom Signorelli','Julia Campanelli','John P. Codiglia',"Skip O'Brien"],
basedOn:['Richard Condon'],
screenplay:['Richard Condon','Janet Roach'],
production:['John Foreman'],
music:['Alex North'],
camera:['Andrzej Bartkowiak'],
cut:['Kaja Fehr','Rudi Fehr'],
sound:['Richard Shorr','John T. Reitz','Gregg Rudloff','David E. Campbell','Kim Maitland','Alfred T. Ferrante'],
scenography:['Dennis Washington'],
masks:['Mark Reedall'],
costumes:['Donfeld']},
{title:'Short Circuit',
titleCZ:'Číslo 5 žije',
year:1986,
runtime:95,
countries:['USA'],
genres:['Comedy','Family','Romance','Sci-Fi'],
director:['John Badham'],
actors:['Ally Sheedy','Steve Guttenberg','Fisher Stevens','Austin Pendleton','G. W. Bailey','Brian McNamara','Marvin J. McIntyre','Robert Krantz','Jack Thompson','Barbara Tarbuck','Vernon Weddle','Sergio Kato','Penny Santon'],
screenplay:['S.S. Wilson','Brent Maddock'],
production:['Lawrence Turman','David Foster'],
music:['David Shire'],
camera:['Nick McLean'],
cut:['Frank Morriss'],
sound:['Tom E. Dahl'],
scenography:['Dianne Wager']},
{title:'Daughter',
titleCZ:'Dcera',
year:2019,
runtime:15,
countries:['Czechia'],
genres:['Short','Puppets','Drama'],
director:['Daria Kashcheeva'],
screenplay:['Daria Kashcheeva'],
production:['Zuzana Roháčová','Martin Vandas'],
music:['Petr Vrba'],
camera:['Daria Kashcheeva'],
cut:['Alexander Kashcheev'],
sound:['Daria Kashcheeva','Miroslav Chaloupka'],
scenography:['Daria Kashcheeva']},
{title:"Ocean's 8",
titleCZ:'Debbie a její parťačky',
year:2018,
runtime:110,
countries:['USA'],
genres:['Action','Crime','Comedy','Thriller'],
director:['Gary Ross'],
actors:['Sandra Bullock','Cate Blanchett','Anne Hathaway','Sarah Paulson','Helena Bonham Carter','Rihanna','Mindy Kaling','Awkwafina','Richard Armitage','James Corden','Elizabeth Ashley','Dana Ivey','Marlo Thomas','Mary Louise Wilson','Elliott Gould','Shaobo Qin','Damian Young','Dakota Fanning','James Biberi','Nathanya Alexander','Conor Donovan','Caitlin Mehner','Richard Robichaux','Daniella Rabbani','Griffin Dunne','Brian J. Carter','Midori Francis','Brian Anthony Wilson','Charlotte Kirk','Steven Hauck','Sas Goldberg','Gideon Glick','Liana Wright-Mark','Clark Carmichael','McNally Sagal','Grant Hyun','Michael Gandolfini','Kevin Brown','Robert G. McKay','Leon Bridges','Common','Waris Ahluwalia','Lily Aldridge','Hailey Bieber','Desiigner','Andrew Bolton','Hamish Bowles','Gigi Hadid','Serena Williams','Tommy Hilfiger','Kendall Jenner','Kylie Jenner','Kim Kardashian','John McEnroe','Jaime King','Adriana Lima','Wendi Murdoch','Olivia Munn','Rainey Qualley','Amy Robach','Maria Šarapovová','Anna Wintour','Alexander Wang','Katie Holmes','Marko Caka','Candice A. Buenrostro','Candy Ibarra','Doris McCarthy','Zac Posen','Heidi Klum','Faith Logan','John Buscemi','Mareli Miniutti','Kate Easton','Hannah McKechnie','Emmy Elliott','Kevyn Bashore','Melanie Little','Elizabeth Inghram','Whit Anderson','Alexander Blaise'],
screenplay:['Gary Ross','Olivia Milch'],
production:['Steven Soderbergh'],
music:['Daniel Pemberton'],
camera:['Eigil Bryld'],
cut:['Juliette Welfling'],
sound:['Paul Hsu'],
scenography:['Alex DiGerlando','Rena DeAngelo'],
masks:['Kay Georgiou','Morag Ross'],
costumes:['Sarah Edwards']},
{title:'Demolition Man',
titleCZ:'Demolition Man',
year:1993,
runtime:110,
countries:['USA'],
genres:['Action','Comedy','Sci-Fi','Thriller'],
director:['Marco Brambilla'],
actors:['Sylvester Stallone','Wesley Snipes','Sandra Bullock','Nigel Hawthorne','Benjamin Bratt','Bob Gunton','Glenn Shadix','Denis Leary','Bill Cobbs','Troy Evans','Andre Gregory','Jesse Ventura','Grand L. Bush','Steve Kahan','Chris Durand','Brandy Ledford','Jack Black','Rob Schneider','John Enos III','Anneliza Scott','Dan Cortese','Carlton Wilborn','Bryan Hanna','Robert Grasmere','Alexandr Kuzněcov','Lara Harris','Pat Skipper','Paul Perri','Kristopher Logan','Alex Ardenti','Christopher Sararo','Vanna Bonta','Jennifer Darling','Stewart Skelton'],
screenplay:['Daniel Waters','Robert Reneau','Peter M. Lenkov'],
production:['Howard G. Kazanjian','Joel Silver'],
music:['Elliot Goldenthal'],
camera:['Alex Thomson'],
cut:['Stuart Baird'],
sound:['Franklin Jones Jr.','William Griggs','Allen L. Stone','Tom E. Dahl','Michael Geisler','Tim Cooney','Sam Horta'],
scenography:['David L. Snyder','Robert Gould'],
masks:['Scott H. Eddo','Janis Clark','Kevin Westmore','Alicia M. Tripi','R. Christopher Biggs'],
costumes:['Bob Ringwood']},
{title:'Children of Nagasaki',
titleCZ:'Děti z Nagasaki',
year:1983,
runtime:128,
countries:['Japan'],
genres:['Drama','War'],
director:['Keisuke Kinošita'],
actors:['Šinobu Ótake','Čikage Awašima','Jukio Toake','Takaši Jamaguči'],
screenplay:['Taiči Jamada'],
music:['Čúdži Kinošita']},
{title:'The Girl in the Fog',
titleCZ:'Dívka v mlze',
year:2017,
runtime:128,
countries:['Italy'],
genres:['Thriller'],
director:['Donato Carrisi'],
actors:['Toni Servillo','Alessio Boni','Jacopo Olmo Antinori','Michela Cescon','Jean Reno','Lorenzo Richelmy','Greta Scacchi','Marina Occhionero','Galatea Ranzi','Lucrezia Guidone','Daniela Piazza','Thierry Toscan','Ekaterina Buscemi','Antonio Gerardi','Sabrina Martina','Pietro Faiella','Massimo Rigo','Massimo Sacilotto','Alberto Paradossi','Franco Moscon'],
screenplay:['Donato Carrisi'],
music:['Vito Lo Re'],
camera:['Federico Masiero'],
cut:['Massimo Quaglia'],
sound:['Marco Coppolecchia'],
scenography:['Tonino Zera','Maria Grazia Schirripa'],
masks:['Simona Castaldi']},
{title:"The Girl in the Spider's Web",
titleCZ:'Dívka v pavoučí síti',
year:2018,
runtime:111,
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Fede Alvarez'],
actors:['Claire Foy','Sylvia Hoeks','Lakeith Stanfield','Sverrir Gudnason','Stephen Merchant','Vicky Krieps','Synnøve Macody Lund','Cameron Britton','Mikael Persbrandt','Volker Bruch','Claes Bang','Carlotta von Falkenhayn','Alexander Yassin','Johan Eriksson','Hendrik Heutmann','Wolfgang Lindner','Christian Serritiello','Sonja Chan','Beau Gadsdon','Christopher Convery','Sinha Gierke','Andreja Pejić','Martin Müller','Felix Quinton'],
basedOn:['David Lagercrantz'],
screenplay:['Steven Knight','Fede Alvarez','Jay Basu'],
production:['Scott Rudin','Amy Pascal','Elizabeth Cantillon','Eli Bush','Søren Stærmose','Ole Søndberg','Berna Levin'],
music:['Roque Baños'],
camera:['Pedro Luque'],
cut:['Tatiana S. Riegel'],
sound:['Roland Winke','Julian Slater',"Kevin O'Connell",'Tony Lamberti','Mandell Winter'],
scenography:['Eve Stewart'],
masks:['Heike Merker','Andrea Pirchner','Antje Zobler','Annett Schulze','Irina Schwarz','Julia Böhm','Dana Bieler'],
costumes:['Carlos Rosario']},
{title:'Dívka za zrcadlem',
titleCZ:'Dívka za zrcadlem',
year:2018,
runtime:104,
countries:['Czechia'],
genres:['Drama'],
director:['Andrea Sedláčková'],
actors:['Tatiana Dyková','Oldřich Kaiser','Vojtěch Dyk','Eva Podzimková','Vojtěch Kotek','Jiří Lábus','Josefína Marková','Logan Hillier','Kryštof Rímský','Vít Piskala','Kryštof Hádek','Elizaveta Maximová','Dáša Vokatá','Mirka Hyžíková','Viktorie Čermáková','František Loukota','Kamila Brunias','Martin Kubala','Boris Machytka','Ondřej Gregor Brzobohatý','Pavel Ridoško','Karel Steigerwald','Jaroslav Pížl','Tereza Gübelová','Andrea Daňková','Renata Najmanová','Petr Vorel','Jana Polášková'],
screenplay:['Andrea Sedláčková'],
production:['Jan Štern'],
music:['Ondřej Gregor Brzobohatý'],
camera:['Jan Baset Střítežský'],
cut:['Boris Machytka'],
sound:['Roman Čapek','Jiří Čermák'],
scenography:['Barbora Erniholdová'],
masks:['Kamila Brunias','Barbora Potužníková'],
costumes:['Andrea Králová','Romana Luxová']},
{title:'Dívka, která kopla do vosího hnízda',
titleCZ:'Dívka, která kopla do vosího hnízda',
year:2009,
runtime:141,
countries:['Sweden','Denmark','Germany'],
genres:['Crime','Drama','Thriller'],
director:['Daniel Alfredson'],
actors:['Michael Nyqvist','Noomi Rapace','Lena Endre','Annika Hallin','Jacob Ericksson','Sofia Ledarp','Anders Ahlbom Rosendahl','Micke Spreitz','Georgi Stajkov','Mirja Turestedt','Niklas Falk','Hans Alfredson','Lennart Hjulström','Jan Holmquist','Niklas Hjulström','Johan Kylén','Tanja Lorentzon','Donald Högberg','Magnus Krepper','Michalis Koutsogiannakis','Aksel Morisse','Carl-Åke Eriksson','Jacob Nordenson','Peter Andersson','Sanna Krepper','Thomas Köhler','Johan Holmberg','Rolf Degerlund','Ylva Lööf','Pelle Bolander','Nicklas Gustavsson','Aida Jerkovic','Tehilla Blad','Tina Berg','Kerstin Green','Jannike Grut','Arne Isaksson','Per Oscarsson','Alexandra Pascalidou','Berit Sarvisé','Göran Sjögren','Henrik Sjöman','Cecilia Söderlind'],
basedOn:['Stieg Larsson'],
screenplay:['Ulf Ryberg'],
production:['Søren Stærmose','Tobias Åström'],
music:['Jacob Groth'],
camera:['Peter Mokrosinski'],
cut:['Håkan Karlsson'],
sound:['Carl Aage Hansen','Anders Hörling','Lasse Liljeholm','Dan Widegren','Niels Arild'],
scenography:['Maria Håård','Jan Olof Ågren'],
masks:['Jenny Fred','Love Larson'],
costumes:['Cilla Rörby']},
{title:'The Girl Who Played with Fire',
titleCZ:'Dívka, která si hrála s ohněm',
year:2009,
runtime:129,
countries:['Sweden','Denmark','Germany'],
genres:['Mystery','Thriller','Crime','Drama'],
director:['Daniel Alfredson'],
actors:['Michael Nyqvist','Noomi Rapace','Tehilla Blad','Hans Christian Thulin','Lena Endre','Georgi Stajkov','Micke Spreitz','Paolo Roberto','Jacob Ericksson','Sofia Ledarp','Yasmine Garbi','Johan Kylén','Per Oscarsson','Annika Hallin','Peter Andersson','Tanja Lorentzon','Niklas Hjulström','Magnus Krepper','Daniel Gustavsson','Ralph Carlsson','Reuben Sallmander','Jennie Silfverhjelm','Sunil Munshi','Ola Wahlström','Donald Högberg','Pelle Bolander','Michalis Koutsogiannakis','Anders Ahlbom Rosendahl','David Druid','Thomas Lindblad','Dennis Önder'],
basedOn:['Stieg Larsson'],
screenplay:['Jonas Frykberg'],
production:['Søren Stærmose'],
music:['Jacob Groth'],
camera:['Peter Mokrosinski'],
cut:['Mattias Morheden'],
sound:['Andreas Kongsgaard','Niels Arild','Carl Aage Hansen'],
scenography:['Maria Håård'],
masks:['Jenny Fred'],
costumes:['Cilla Rörby']},
{title:'The Long Kiss Goodnight',
titleCZ:'Dlouhý polibek na dobrou noc',
year:1996,
runtime:114,
countries:['USA'],
genres:['Action','Thriller','Drama','Mystery','Crime'],
director:['Renny Harlin'],
actors:['Geena Davis','Samuel L. Jackson','Craig Bierko','Yvonne Zima','Tom Amandes','Brian Cox','Patrick Malahide','David Morse','Melina Kanakaredes','Kristen Bone','Rex Linn','Alan North','G. D. Spradlin','Shawn Doyle','John Stead','Joseph McKenna','Chad Donella','Edwin Hodge','Larry King','Frank Moore','Sharon Washington','Gerry Bamman','Judah Katz',"Gladys O'Connor"],
screenplay:['Shane Black'],
production:['Renny Harlin','Shane Black'],
music:['Alan Silvestri'],
camera:['Guillermo Navarro'],
cut:['William Goldenberg'],
sound:['Paul Massey','Doug Hemphill'],
scenography:['Howard Cummings','Dennis Davenport'],
masks:['Gordon J. Smith'],
costumes:['Michael Kaplan']},
{title:'Ghost',
titleCZ:'Duch',
year:1990,
runtime:127,
countries:['USA'],
genres:['Drama','Romance','Thriller','Fantasy'],
director:['Jerry Zucker'],
actors:['Patrick Swayze','Demi Moore','Tony Goldwyn','Whoopi Goldberg','Vincent Schiavelli','Said Faraj','Phil Leeds','Mike Jittlov','Stephen Root','Rick Aviles','Bruce Jarchow','Alma Beltran','William Cort','Angelina Estrada','Gail Boggs','Vivian Bonnell','Tom Finnegan','Faye Brenner','Paul Van'],
screenplay:['Bruce Joel Rubin'],
production:['Lisa Weinstein','Howard W. Koch'],
music:['Maurice Jarre'],
camera:['Adam Greenberg'],
cut:['Walter Murch'],
sound:['Steve Maslow'],
scenography:['Jane Musky','Joe D. Mitchell'],
costumes:['Ruth Morley']},
{title:'The Lake House',
titleCZ:'Dům u jezera',
year:2006,
runtime:95,
countries:['USA','Australia'],
genres:['Drama','Fantasy','Romance'],
director:['Alejandro Agresti'],
actors:['Keanu Reeves','Sandra Bullock','Shohreh Aghdashloo','Willeke van Ammelrooy','Christopher Plummer','Ebon Moss-Bachrach','Dylan Walsh','Lynn Collins','Nathan Adloff','John Littlefield','Mike Bacarella','Cynthia Kaye McWilliams','Mia Park','Kevin M. Brennan','Peggy Roeder'],
basedOn:['Eun-jeong Kim'],
screenplay:['David Auburn'],
production:['Doug Davison','Roy Lee'],
music:['Rachel Portman'],
camera:['Alar Kivilo'],
cut:['Lynzee Klingman','Alejandro Brodersohn'],
sound:['John T. Reitz','Gregg Rudloff','David E. Campbell','Ron Bartlett','Frank Gaeta'],
scenography:['Nathan Crowley'],
masks:['Suzi Ostos'],
costumes:['Deena Appel']},
{title:'Easy Rider',
titleCZ:'Bezstarostná jízda',
year:1969,
runtime:95,
countries:['USA'],
genres:['Drama','Road movie'],
director:['Dennis Hopper'],
actors:['Peter Fonda','Dennis Hopper','Phil Spector','Warren Finnerty','Luke Askew','Luana Anders','Sabrina Scharf','Sandy Brown Wyeth','Robert Walker Jr.','Robert Ball','Carmen Phillips','Michael Pataki','Jack Nicholson','Toni Basil','Karen Black','Bridget Fonda','Virgil Frye','Dan Haggerty','Helena Kallianiotes','Carrie Snodgress'],
screenplay:['Peter Fonda','Dennis Hopper','Terry Southern'],
production:['Peter Fonda','Bob Rafelson'],
camera:['László Kovács'],
cut:['Donn Cambern'],
sound:['James Nelson'],
masks:['Virgil Frye']},
{title:'Eyes Wide Shut',
titleCZ:'Spalující touha',
year:1999,
runtime:159,
countries:['USA','UK'],
genres:['Mystery','Thriller','Drama','Erotic'],
director:['Stanley Kubrick'],
actors:['Tom Cruise','Nicole Kidman','Jackie Sawiris','Sydney Pollack','Todd Field','Sky du Mont','Marie Richardson','Thomas Gibson','Vinessa Shaw','Rade Šerbedžija','Togo Igawa','Leelee Sobieski','Brian W. Cook','Carmela Marner','Julienne Davis','Alan Cumming','Fay Masterson','Stanley Kubrick','Christiane Kubrick','Stewart Thorndike','Treva Etienne','Leon Vitali','Angus MacInnes','Randall Paul','Katharina Kubrick','Cate Blanchett','Sam Douglas','Lisa Leone'],
basedOn:['Arthur Schnitzler'],
screenplay:['Stanley Kubrick','Frederic Raphael'],
production:['Stanley Kubrick'],
music:['Jocelyn Pook'],
camera:['Larry Smith'],
cut:['Nigel Galt'],
scenography:['Leslie Tomkins','Roy Walker'],
costumes:['Marit Allen']},
{title:'Rogue Agent',
titleCZ:'Falešný agent',
year:2022,
runtime:115,
countries:['UK'],
genres:['Thriller'],
director:['Declan Lawn','Adam Patterson'],
actors:['Gemma Arterton','James Norton','Sarah Goldberg','Shazad Latif','Freya Mavor','Jimmy Akingbola','Julian Barratt','Edwina Findley','Marisa Abela','Philip Wright'],
screenplay:['Declan Lawn','Adam Patterson','Michael Bronner'],
production:['Michael Bronner','Gina Carter'],
music:['Hannah Peel'],
camera:['Larry Smith'],
cut:['Mags Arnold'],
scenography:['Catrin Meredydd']},
{title:'Phineas and Ferb the Movie: Across the 2nd Dimension',
titleCZ:'Phineas a Ferb v paralelním vesmíru',
year:2011,
runtime:78,
countries:['USA'],
genres:['Animation','Adventure','Family'],
director:['Dan Povenmire','Robert Hughes','Kyle Menke'],
actors:['Thomas Brodie-Sangster','Alyson Stoner','Dee Bradley Baker','Vincent Cassel','Kelly Hu','Kevin James','Irrfan Khan','Mitchel Musso','Maulik Pancholy','Caroline Rhea','Ashley Tisdale','Sigourney Weaver','Vincent Martella','Todd Stashwick','Jaret Reddick','Kevin Michael Richardson','Loni Love','Doris Roberts','April Stewart','Dan Povenmire','Olivia Olson','Diamond White','Jeff "Swampy" Marsh','Danny Jacob','Laura Dickinson','Bobby Gaylor'],
screenplay:['Dan Povenmire','Jeff "Swampy" Marsh','Chris Headrick','Michael Diederich','Kaz','Kim Roberson','Chong Lee','Aliki Theofilopoulos','Joe Orrantia'],
music:['Danny Jacob'],
cut:['Ted Supa'],
sound:['Melissa Ellis','Robert Poole II'],
scenography:['Alan Bodner']},
{title:'Flashdance',
titleCZ:'Flashdance',
year:1983,
runtime:89,
countries:['USA'],
genres:['Drama','Romance','Music'],
director:['Adrian Lyne'],
actors:['Jennifer Beals','Michael Nouri','Lilia Skala','Sunny Johnson','Kyle T. Heffner','Lee Ving','Ron Karabatsos','Belinda Bauer','Malcolm Danare','Philip Bruns','Cynthia Rhodes','Durga McBroom','Liz Sagal','Robert Wuhl','Monique Gabrielle','Stacey Pickren','Micole Mercurio','Frank Pesce','Lucy Lee Flippin','Debra Gordon','Ann Muffly','Don Brockett','Larry John Meyers','Tony De Santis','Bob Harks','Joe Shelby','Colin Hamilton','Crazy Legs'],
screenplay:['Joe Eszterhas','Thomas Hedley Jr.'],
production:['Jerry Bruckheimer','Don Simpson'],
music:['Giorgio Moroder'],
camera:['Donald Peterman'],
cut:['Bud S. Smith','Walt Mulconery'],
sound:['Don Digirolamo','Robert Glass'],
scenography:['Charles Rosen','Marvin March'],
masks:['Rick Sharp'],
costumes:['Michael Kaplan']},
{title:'G.I. Jane',
titleCZ:'G. I. Jane',
year:1997,
runtime:125,
countries:['USA'],
genres:['Action','Drama'],
director:['Ridley Scott'],
actors:['Demi Moore','Viggo Mortensen','Anne Bancroft','Jason Beghe','Daniel von Bargen','John Michael Higgins','Kevin Gage','Morris Chestnut','David Warshofsky','Josh Hopkins','James Caviezel','Stephen Ramsey','Scott Wilson','Lucinda Jenney','Neal Jones','Boyd Kestner','Michael Currie','Rick Cramer','Steve Gonzales','Donn Swaby','Diandra Newlin','Dimitri Diatchenko','Irene Ziegler','Arthur Max','Ted Sutton','Gregg Bello','David Vadim','Jack Gwaltney','Stephen Mendillo','Angel David','John Seitz','Jimmy Star','Johnny Meyer','Michael Wayne Thomas'],
screenplay:['David Twohy','Danielle Alexandra'],
production:['Ridley Scott','Roger Birnbaum','Suzanne Todd','Demi Moore'],
music:['Trevor Jones'],
camera:['Hugh Johnson'],
cut:['Pietro Scalia'],
sound:["Terry O'Bright"],
scenography:['Arthur Max','William Hiney'],
masks:['Cheri Minns','Sherri Bramlett','Barbara Lacy'],
costumes:['Marilyn Vance']},
{title:'Memoirs of a Geisha',
titleCZ:'Gejša',
year:2005,
runtime:145,
countries:['USA'],
genres:['Drama','Romance'],
director:['Rob Marshall'],
actors:['Ziyi Zhang','Ken Watanabe','Kódži Jakušo','Michelle Yeoh','Li Gong','Kaori Momoi','Júki Kudó','Suzuka Ógo','Togo Igawa','Mako','Samantha Futerman','Elizabeth Sung','Tsai Chin','Zoe Weizenbaum','Karl Yune','Eugenia Yuan','Jóko Narahaši','Kenneth Tsang','Cary-Hiroyuki Tagawa','Rick Mali','Steve Terada','Diane Mizota','Randall Duk Kim','Takayo Fischer','Cameron Duncan','Brannon Bates','Ted Levine','Paul Adelstein','Shizuko Hoshi','HIKARI','Minae Noji','Nikki Tuazon','Addie Yungmee','Halla','James Huang','Julia Ling','Tohoru Masamune','Sophie Oda','Austin Michael Scott','Cathy Shim'],
basedOn:['Arthur Golden'],
screenplay:['Robin Swicord'],
production:['Lucy Fisher','Douglas Wick','Steven Spielberg'],
music:['John Williams'],
camera:['Dion Beebe'],
cut:['Pietro Scalia'],
sound:['Harry Cohen',"Kevin O'Connell",'Wylie Stateman','Greg P. Russell'],
scenography:['John Myhre','Gretchen Rau'],
masks:['Noriko Watanabe','Kate Biscoe','Ketty Gonzalez'],
costumes:['Colleen Atwood']},
{title:'Gia',
titleCZ:'Gia',
year:1998,
runtime:120,
countries:['USA'],
genres:['Biographic','Romance','Drama'],
director:['Michael Cristofer'],
actors:['Angelina Jolie','Elizabeth Mitchell','Eric Michael Cole','Kylie Travis','John Considine','Louis Giambalvo','Scott Cohen','Mercedes Ruehl','Faye Dunaway','Mila Kunis',"Tricia O'Neil",'Holly Sampson','Audrey Wasilewski','Adina Porter','Joan Pringle','Torsten Voges','Michael E. Rodgers','Chuck Zito','Jullian Dulce Vida','Brian Donovan','Lombardo Boyar','Martin Seifert','Guido Föhrweißer','Jason Stuart','Shelby Leverington','Lynn Wanlass','Lisa Stothard','Sam Pancake','Allison Mackie','Sebastian Feldman','Rick Batalla','Joe Basile','Phillipe Simon'],
screenplay:['Michael Cristofer','Jay McInerney'],
music:['Terence Blanchard'],
cut:['Eric A. Sears'],
sound:['Jeffrey Perkins','Gregory M. Gerlich'],
scenography:['David J. Bomba','Claus-Jürgen Pfeiffer','Kathy Lucas'],
masks:['Nena Smarz','Barbara Lorenz'],
costumes:['Robert Turturice']},
{title:'Snake Eyes',
titleCZ:'Hadí oči',
year:1998,
runtime:98,
countries:['USA','Canada'],
genres:['Thriller','Mystery','Crime'],
director:['Brian De Palma'],
actors:['Nicolas Cage','Gary Sinise','John Heard','Carla Gugino','Stan Shaw','Kevin Dunn','Michael Rispoli','Luis Guzmán','Joel Fabiani','Mike Starr','Tamara Tunie','Chip Chuipka','Jayne Heitmeyer','Christina Fulton','Alain Goulem','Brian Anthony Wilson','Peter McRobbie','David Anthony Higgins','Lance E. Nichols','Chip Zien','Kevin Craig West','Mark Camacho','Sébastien Delorme','Peter Patrikios','Jim Whelan','Frédérick De Grandpré','Jacynthe René','Richard Lemire','Deano Clavet','Sylvain Massé','Desmond Campbell','Christopher B. MacCabe','Cary Lawrence','Dean Hagopian','Kelly Deadmon','Patrick F. McDade','John Thaddeus'],
screenplay:['David Koepp'],
production:['Brian De Palma'],
music:['Rjúiči Sakamoto'],
camera:['Stephen H. Burum'],
cut:['Bill Pankow'],
sound:['Lee Dichter','Maurice Schell'],
scenography:['Anne Pritchard','Réal Proulx'],
costumes:['Odette Gadoury']},
{title:'Hana',
titleCZ:'Hana',
year:2006,
runtime:127,
countries:['Japan'],
genres:['Drama'],
director:["Hirokazu Kore'eda"],
actors:['Arata Furuta','Rie Mijazawa','Tadanobu Asano','Jošio Harada','Terujuki Kagawa','Rendži Išibaši','Kacuo Nakamura','Jui Nacukawa','Susumu Teradžima',"Ken'iči Endó",'Rjó Kase','Robert McCollum','Džun Kunimura',"Džun'iči Okada",'Rjó Kacudži','Tecuši Tanaka','Tomoko Tabata','Rjúhei Uešima','Óga Tanaka','Chuck Huber','Seidži Čihara','Sei Hiraizumi','Šóhei Tanaka','Júiči Kimura'],
screenplay:["Hirokazu Kore'eda"],
production:['Nozomu Enoki','Hijiri Taguchi'],
camera:['Jutaka Jamazaki'],
cut:["Hirokazu Kore'eda"],
scenography:['Tošihiro Isomi'],
costumes:['Kazuko Kurosawa']},
{title:'Girls on Top',
titleCZ:'Holky to chtěj taky',
year:2001,
runtime:90,
countries:['Germany'],
genres:['Comedy'],
director:['Dennis Gansel'],
actors:['Diana Amft','Karoline Herfurth','Felicitas Woll','Max Riemelt','Florian Lukas','Josephine Jacob','Dennis Gansel','Martin Reinhold','Max Richter','Alexandra Schiffer','Henning Baum','Ulrike Kriener','Thorsten Feller','Barbara Bauer','Arzu Bazman','Butz Ulrich Buse','Germain Wagner','Thomas Feist','Anke Schwiekowski','Andreas Christ','Maximilian Cress','Elisabeth Scherer','Frederic Welter','Alexander Wagner'],
screenplay:['Christian Zübert'],
production:['Thomas Augsberger','Viola Jäger','Harald Kügler','Molly von Fürstenberg','Martin Moszkowicz'],
music:['Martin Probst'],
sound:['Frank Heidbrink','Hubertus Rath'],
scenography:['Ingrid Henn'],
masks:['Martine Flener','Mechthild Schmitt'],
costumes:['Natascha Curtius-Noss']},
{title:'Witch Hunt',
titleCZ:'Hon na čarodějky',
year:2021,
runtime:92,
countries:['USA'],
genres:['Fantasy','Horror','Thriller'],
director:['Elle Callahan'],
actors:['Gideon Adlon','Elizabeth Mitchell','Abigail Cowen','Nicholas Crovetti','Cameron Crovetti','Christian Camargo','Lulu Antariksa','Natasha Tina Liu','Ashley Bell','Anna Grace Barlow','Treva Etienne','Assaf Cohen','Jess Varley','Regi Davis','Sadie Stratton','Riley Scott','Christian Hicks','Kristen Laffey','Bella Shepard'],
screenplay:['Elle Callahan'],
production:['Maurice Fadida','Eric B. Fleischman'],
music:['Blitz//Berlin'],
camera:['Nico Aguilar','Tommy Oceanak'],
cut:['Nick Garnham Wright'],
scenography:['Holly Trotta'],
masks:['Leya Oakley','Brittany White'],
costumes:['Joanna David']},
{title:'The Host',
titleCZ:'Hostitel',
year:2013,
runtime:125,
countries:['USA'],
genres:['Sci-Fi','Thriller','Romance','Action','Adventure'],
director:['Andrew Niccol'],
actors:['Saoirse Ronan','Max Irons','Diane Kruger','Jake Abel','William Hurt','Frances Fisher','Chandler Canterbury','Phil Austin','Boyd Holbrook','Andrea Frankle','Stephen Conroy','Emily Browning','Tatanka Means','Bokeem Woodbine','Scott Lawrence','Rachel Roberts','Tailinh Agoyo','J.D. Evermore','John L. Armijo','Stephen Rider','Yohance Myles','David House','Erik Beacham','Marcus Lyle Brown','Shawn Carter Peterson','Jaylen Moore','Evan Cleaver'],
basedOn:['Stephenie Meyer'],
screenplay:['Andrew Niccol'],
production:['Nick Wechsler','Paula Mae Schwartz','Steve Schwartz'],
music:['Antonio Pinto'],
camera:['Roberto Schaefer'],
cut:['Thomas J. Nordberg'],
sound:['David Giammarco','Paul Massey'],
scenography:['Andy Nicholson','Cynthia La Jeunesse'],
masks:['Courtney Lether','Ve Neill','Anna Stachow'],
costumes:['Erin Benach']},
{title:'Interview with the Vampire: The Vampire Chronicles',
titleCZ:'Interview s upírem',
year:1994,
runtime:123,
countries:['USA'],
genres:['Drama','Romance','Horror','Fantasy'],
director:['Neil Jordan'],
actors:['Tom Cruise','Brad Pitt','Kirsten Dunst','Stephen Rea','Antonio Banderas','Christian Slater','Thandiwe Newton','Helen McCrory','Roger Lloyd Pack','Marcel Iureș','Susan Lynch','Andrew Tiernan','Domiziana Giordano','Laure Marsac','John McConnell','George Antoni','Jacquelyn Twodat Jackson','Bellina Logan','Louise Salter','Micha Bergese','Greta Valenti','Simon Tyrrell','Danny Kamin','Indra Ové'],
basedOn:['Anne Rice'],
screenplay:['Anne Rice'],
production:['Stephen Woolley','David Geffen'],
music:['Elliot Goldenthal'],
camera:['Philippe Rousselot'],
cut:['Mick Audsley'],
sound:['Eddy Joseph','Tom Fleischman'],
scenography:['Dante Ferretti','Francesca Lo Schiavo'],
masks:['Nick Dudman','Sarah Monzani','Morag Ross'],
costumes:['Sandy Powell']},
{title:'Jack Ryan: Shadow Recruit',
titleCZ:'Jack Ryan: V utajení',
year:2014,
runtime:105,
countries:['USA','Russia'],
genres:['Mystery','Action','Thriller'],
director:['Kenneth Branagh'],
actors:['Chris Pine','Keira Knightley','Kevin Costner','Kenneth Branagh','Colm Feore','Nonso Anozie','Aleksandar Aleksiev','David Paymer','Lee Asquith-Coe','Gemma Chan','Karen David','Andrew Byron','Jelena Velikanova','Alec Utgoff','Deborah Rosan','Lenn Kudrjawizki','Akie Kotabe','Georg Nikoloff','Stuart Mulcaster','Jozef Aoki','James Grogan','Martyn Mayger','Eisa Davis','Mike Houston','Brian Woodward','Parker Sawyers','William Meredith','Michael Starke','Chris Cowlin','Frank Harts','Bogdan Kominowski','Vaughn Johseph','Claira Watson Parr','Ian Bonar','Mike Noble','Graham Curry','Nick Court','Kieron Jecchinis','Angus Wright','Robert Eames','John Schwab','Chinasa Ogbuagu','Michail Baryšnikov','Pat Kiernan','Drew Marquardt','Lucas Antoine Starrets','Erich Redman'],
screenplay:['David Koepp','Adam Cozad'],
production:['David Barron','Lorenzo di Bonaventura','Mace Neufeld','David Ellison','Mark Vahradian'],
music:['Patrick Doyle'],
camera:['Haris Zambarloukos'],
cut:['Martin Walsh'],
sound:['James Mather','Richard Pryke','Michael Barosky'],
scenography:['Andrew Laws','Judy Farr'],
masks:['Jeremy Woodhead','Matthew W. Mungle'],
costumes:['Jill Taylor']},
{title:'Joachim, Put It in the Machine',
titleCZ:'Jáchyme, hoď ho do stroje!',
year:1974,
runtime:95,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Oldřich Lipský'],
actors:['Luděk Sobota','Marta Vančurová','Věra Ferbasová','Josef Dvořák','Ladislav Smoljak','Zdeněk Svěrák','Karel Novák','Václav Lohniský','Eva Fiedlerová','František Husák','Josef Hlinomaz','Miroslav Homola','Lubomír Lipský st.','Petr Nárožný','Eva Svobodová','Josef Beyvl','Václav Kotva','František Peterka','Oldřich Velen','Vladimír Krška','Oldřich Unger','Jaroslav Weigel','Miloň Čepelka','Jan Hartl','Jiří Wimmer','Jan Vala','Tetsuchi Sassagawa','Karel Augusta','Radoslav Dubanský','Petr Kopřiva','Karel Kryška','Jiří Lábus','Jiří Zavřel','Jan Kuželka','Oldřich Musil','Josef Koza','Vlastimil Bedrna','Antonín Navrátil','René Přibil','Jaroslav Tomsa','Karel Peyr','Pavel Vondruška','Jaroslav Vozáb','Mirko Musil','Josef A. Stehlík','Antonín Soukup','Karel Smrž','Luisa Kollingerová','Josef Skrčený','Marie Prokešová','Jana Posseltová','Michal Pospíšil','Vladimír Hrabánek','Ivan Pokorný','František Vinant-Petiška','Ivan Martin','Vilém Lipský','Anna Pitašová','Zdeněk Křeček','Jana Drastíková','Dana Klossová','Olga Hrzánová','Petr Hájek','Petr Brukner','Alena Augustová','Josef Brozman','Jiřina Bílá','Josefa Pechlátová','Vlastimila Vlková','František Jákl','Petr Jákl st.','Jiří Mašín','Zdeněk Hrdlička','Karel Vítek st.','Jaroslav Klenot','Vladimír Fürst'],
screenplay:['Ladislav Smoljak','Zdeněk Svěrák','Oldřich Lipský'],
music:['Zdeněk Liška'],
camera:['Jaroslav Kučera'],
cut:['Miroslav Hájek'],
sound:['Josef Vlček'],
scenography:['Jindřich Goetz'],
masks:['František Čížek'],
costumes:['Theodor Pištěk ml.']},
{title:'How to Get Dad Into Reform School',
titleCZ:'Jak dostat tatínka do polepšovny',
year:1978,
runtime:91,
countries:['Czechoslovakia'],
genres:['Comedy','Family'],
director:['Marie Poledňáková'],
actors:['Jana Preissová','Tomáš Holý','František Němec','Josef Karlík','Petr Nárožný','Luděk Sobota','Bronislav Poloczek','František Peterka','Jana Dítětová','Gabriela Vránová','Alena Kreuzmannová','Vlastimil Harapes'],
screenplay:['Marie Poledňáková'],
music:['Václav Zahradník'],
camera:['Petr Polák'],
cut:['Karel Kohout'],
sound:['Dobroslav Šrámek'],
scenography:['Karel Černý'],
masks:['František Pilný'],
costumes:['Svatava Sophová']},
{title:"How to Pull Out a Whale's Tooth",
titleCZ:'Jak vytrhnout velrybě stoličku',
year:1977,
runtime:80,
countries:['Czechoslovakia'],
genres:['Comedy','Family'],
director:['Marie Poledňáková'],
actors:['Jana Preissová','Tomáš Holý','František Němec','Vlastimil Harapes','Jana Dítětová','Blanka Waleská','Gabriela Vránová','Petr Kostka','Stella Zázvorková','Miroslav Vydlák','Robert Vrchota','Viktor Maurer','Jaroslav Hovorka','Marie Marešová'],
screenplay:['Marie Poledňáková'],
music:['Václav Zahradník'],
camera:['Petr Polák'],
cut:['Miroslav Hájek'],
sound:['Dobroslav Šrámek'],
scenography:['Karel Černý'],
masks:['Stanislav Petřek'],
costumes:['Svatava Sophová']},
{title:'Sekal Has to Die',
titleCZ:'Je třeba zabít Sekala',
year:1998,
runtime:109,
countries:['Czechia','Poland','Slovakia','France'],
genres:['Drama'],
director:['Vladimír Michálek'],
actors:['Bogusław Linda','Olaf Lubaszenko','Jiří Bartoška','Agnieszka Sitek','Vlasta Chramostová','Ľudovít Cittel','Martin Sitta','Jiří Holý','Milan Riehs','Anton Šulík st.','Josef Bulík','Bohuslav Ličman','Gustav Nezval','Gustav Vondráček','Zdeněk Kozák st.','Robert Sklenář','František Kouba','Petra Lustigová','Miloslav Mejzlík','Jan Šťastný','Dana Černá'],
screenplay:['Jiří Křižan'],
production:['Jaroslav Bouček'],
music:['Michał Lorenc'],
camera:['Martin Štrba'],
cut:['Jiří Brožek'],
sound:['Radim Hladík ml.','Ivo Špalj'],
scenography:['Jiří Sternwald'],
masks:['Jana Dolejší','Jaroslav Šámal'],
costumes:['Mona Hafsahl','Petra Jáchimová']},
{title:'The Ride',
titleCZ:'Jízda',
year:1994,
runtime:90,
countries:['Czechia'],
genres:['Comedy','Drama','Romance','Road movie'],
director:['Jan Svěrák'],
actors:['Aňa Geislerová','Radek Pastrňák','Jakub Špalek','Filip Renč'],
screenplay:['Martin Dostál','Jan Svěrák'],
production:['Klára Bukovská','Markéta Hájková','Přemysl Pražský'],
music:['Radek Pastrňák','Buty'],
camera:['F. A. Brabec'],
cut:['Alois Fišárek'],
sound:['Zbyněk Mikulík','Pavel Rejholec'],
costumes:['Jaroslava Brabcová Pecharová']},
{title:'John Wick: Chapter 4',
titleCZ:'John Wick: Kapitola 4',
year:2023,
runtime:169,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Chad Stahelski'],
actors:['Keanu Reeves','Donnie Yen','Bill Skarsgård','Ian McShane','Laurence Fishburne','Rina Sawayama','Lance Reddick','Shamier Anderson','Hirojuki Sanada','Scott Adkins','Clancy Brown','Marko Zaror','Natalia Tena','George Georgiou','Sven Marquardt','Aimée Kwan'],
screenplay:['Michael Finch','Shay Hatten'],
production:['Basil Iwanyk','Erica Lee','Chad Stahelski'],
music:['Tyler Bates','Joel J. Richard'],
camera:['Dan Laustsen'],
cut:['Nathan Orloff'],
sound:['Mark P. Stoeckinger','Andy Koyama'],
scenography:['Kevin Kavanaugh'],
costumes:['Paco Delgado']},
{title:'John Wick: Chapter 2',
titleCZ:'John Wick 2',
year:2017,
runtime:122,
countries:['USA','Hong Kong'],
genres:['Action','Crime','Thriller'],
director:['Chad Stahelski'],
actors:['Keanu Reeves','Riccardo Scamarcio','Ian McShane','Ruby Rose','Common','Claudia Gerini','Lance Reddick','Laurence Fishburne','Tobias Segal','John Leguizamo','Bridget Moynahan','Thomas Sadoski','David Patrick Kelly','Perry Yung','Franco Nero','Peter Serafinowicz','Luca Mosca','Thaddeus Daniels','Chukwudi Iwuji','Peter Stormare','Simone Spinazze','Aly Mang','Crystal Lonneberg','Angel Pai','Alex Ziwak','Mark Vincent','Marmee Cosico','Chris LaPanta','Doris McCarthy','Faith Logan','Kenny Sheard','Jennifer Dong','Jimmy Star','Bruno Verdirosi','Frank Modica','Guyviaud Joseph'],
screenplay:['Derek Kolstad'],
production:['Basil Iwanyk','Erica Lee'],
music:['Tyler Bates','Joel J. Richard'],
camera:['Dan Laustsen'],
cut:['Evan Schiff'],
sound:['David J. Schwartz','Mark P. Stoeckinger','Gabriel J. Serrano','Andy Koyama'],
scenography:['Kevin Kavanaugh','David Schlesinger'],
masks:['Anna Stachow','Stephen Kelley','Matteo Silvi'],
costumes:['Luca Mosca']},
{title:'John Wick: Chapter 3 - Parabellum',
titleCZ:'John Wick 3',
year:2019,
runtime:131,
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Chad Stahelski'],
actors:['Keanu Reeves','Halle Berry','Ian McShane','Laurence Fishburne','Mark Dacascos','Asia Kate Dillon','Lance Reddick','Tobias Segal','Anjelica Huston','Saïd Taghmaoui','Jerome Flynn','Randall Duk Kim','Robin Lord Taylor','Susan Blommaert','Jason Mantzoukas','Cecep Arif Rahman','Yayan Ruhian','Tiger Chen Hu','Faith Logan','Oscar Pavlo','Boban Marjanović','Ahmed Adel','Andrea Sooch','Jimmy Star'],
screenplay:['Derek Kolstad','Shay Hatten','Chris Collins','Marc Abrams'],
production:['Basil Iwanyk','Erica Lee'],
music:['Tyler Bates','Joel J. Richard'],
camera:['Dan Laustsen'],
cut:['Evan Schiff'],
sound:['David J. Schwartz','Mark P. Stoeckinger','Andy Koyama'],
scenography:['Kevin Kavanaugh','David Schlesinger'],
masks:['Anna Stachow','Stephen Kelley','Angela Marinis','Zoe Tahir','Therese Ducey'],
costumes:['Luca Mosca']},
{title:'John Wick 5',
titleCZ:'John Wick: Chapter 5',
year:2025,
runtime:'025',
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Chad Stahelski'],
actors:['Keanu Reeves'],
production:['Basil Iwanyk']},
{title:'Coffee and Cigarettes',
titleCZ:'Kafe a cigára',
year:2003,
runtime:96,
countries:['USA'],
genres:['Comedy','Drama','Music','Tale'],
director:['Jim Jarmusch'],
actors:['Roberto Benigni','Cate Blanchett','Steve Buscemi','Iggy Pop','Alfred Molina','Bill Murray','Tom Waits','Isaach De Bankolé','Jack White','Meg White','Steve Coogan','The GZA','RZA','Joie Lee','Cinqué Lee','Alex Descas','Steven Wright','Joseph Rigano','Vinny Vella Jr.','Renee French','E.J. Rodriguez','Katy Hansz','Michael Hogan','William Rice','Vinny Vella','Taylor Mead'],
screenplay:['Jim Jarmusch'],
production:['Stacey E. Smith','Gretchen McGowan','Jim Stark','Demetra J. MacBride','Joana Vicente','Jason Kliot'],
camera:['Ellen Kuras','Robby Müller','Frederick Elmes','Tom DiCillo'],
cut:['Jay Rabinowitz','Jim Jarmusch','Melody London','Terry Katz'],
scenography:['Mark Friedberg','Dan Bishop','Tom Jarmusch','Rena DeAngelo'],
masks:['Judy Chin']},
{title:'Karolina',
titleCZ:'Karolína',
year:2021,
runtime:69,
countries:['Czechia'],
genres:['Documentary'],
director:['Helena Třeštíková'],
screenplay:['Helena Třeštíková'],
production:['Alena Müllerová','Kateřina Černá','Pavel Strnad'],
camera:['Vlastimil Hamerník','Martin Kubala','Ivan Vojnár','Stano Slušný','Jan Šuster','Hynek Ciboch','Jiří Chod','David Cysař'],
cut:['Jakub Hejna'],
sound:['Richard Müller']},
{title:'Those Who Wish Me Dead',
titleCZ:'Kdo mi jde po krku',
year:2021,
runtime:100,
countries:['USA'],
genres:['Thriller','Drama','Action'],
director:['Taylor Sheridan'],
actors:['Angelina Jolie','Jon Bernthal','Nicholas Hoult','Aidan Gillen','Tyler Perry','Jake Weber','Medina Senghore','James Jordan','Finn Little','Laura Niemi','Tory Kittles','Lora Martinez-Cunningham','Dylan Kenin','Alma Sisneros','Matt Medrano','Jacob Browne','Alex Wagenman','John Trejo','Sofia Embid'],
basedOn:['Michael Koryta'],
screenplay:['Taylor Sheridan','Michael Koryta','Charles Leavitt'],
production:['Aaron L. Gilbert','Kevin Turen','Steven Zaillian','Taylor Sheridan','Garrett Basch'],
music:['Brian Tyler'],
camera:['Ben Richardson'],
cut:['Chad Galster'],
sound:['Alan Robert Murray','Dean A. Zupancic','Tom Ozanich','Andrejs Prokopenko'],
scenography:['Neil Spisak','Jay Hart'],
masks:['Arjen Tuiten','Madeline McCue','Tim Muir','Audrey Futterman-Stern']},
{title:'After the Sunset',
titleCZ:'Když se setmí',
year:2004,
runtime:97,
countries:['USA'],
genres:['Action','Comedy','Crime','Drama'],
director:['Brett Ratner'],
actors:['Pierce Brosnan','Salma Hayek','Woody Harrelson','Don Cheadle','Naomie Harris','Chris Penn','Obba Babatundé','Michael Bowen',"Shaquille O'Neal",'Rex Linn','Kate Walsh','Gillian Vigman','Troy Garity','Chad Gabriel','Alan Dale','Russell Hornsby','John Michael Higgins','Gianni Russo','Rachael Harris','Jeff Garlin','Kirk B.R. Woller','Omahyra','Paul Benedict','Noémie Lenoir','Tom McGowan','Anthony Reynolds','Joel McKinnon Miller','Andrew Fiscella','David Reivers','LeShay N. Tomlinson'],
screenplay:['Paul Zbyszewski','Craig Rosenberg'],
production:['Beau Flynn','Tripp Vinson'],
music:['Lalo Schifrin'],
camera:['Dante Spinotti'],
cut:['Mark Helfrich'],
sound:['Steve Maslow','Gregory King','Yann Delpuech'],
scenography:['Geoffrey Kirkland'],
masks:['Matthew W. Mungle','Camille Friend','Denise Dellavalle'],
costumes:['Rita Ryack']},
{title:'The Brothers Grimm',
titleCZ:'Kletba bratří Grimmů',
year:2005,
runtime:118,
countries:['USA','Czechia','UK'],
genres:['Adventure','Fantasy','Horror','Comedy'],
director:['Terry Gilliam'],
actors:['Matt Damon','Heath Ledger','Jonathan Pryce','Lena Headey','Peter Stormare','Monica Bellucci','Roger Ashton-Griffiths','Tomáš Hanák','Miroslav Táborský','Jan Unger','Petr Ratimec','Barbara Lukešová','Radim Kalvoda','Rudolf Pellar','Lukáš Bech','František Velecký','Jakub Zindulka','Věra Uzelacová','Václav Chalupa','Mackenzie Crook','Martin Kavan','Drahomíra Fialková','Luděk Eliáš','Martin Hofmann','Petr Vršek','Simona Včalová','Jana Radojčičová','Marika Procházková','Alena Jakobová','Jan Pavel Filipenský','Veronika Loulová','Annika Murjahn','Laura Greenwood','Pepa Nos','Audrey Hamm','Tomáš Liška','Richard Ridings','Julian Bleach','Anna Rust','Ota Filip'],
screenplay:['Ehren Kruger'],
production:['Charles Roven','Daniel Bobker'],
music:['Dario Marianelli'],
camera:['Newton Thomas Sigel'],
cut:['Lesley Walker'],
sound:['Michael Prestwood Smith','Ivan Sharrock'],
scenography:['Guy Hendrix Dyas','Judy Farr'],
masks:['Eva Ungrová-Malíková','Kay Georgiou'],
costumes:['Carlo Poggioli','Gabriella Pescucci']},
{title:'Nanny McPhee Returns',
titleCZ:'Kouzelná chůva a Velký třesk',
year:2010,
runtime:105,
countries:['UK','France','USA'],
genres:['Comedy','Family','Fantasy'],
director:['Susanna White'],
actors:['Emma Thompson','Maggie Gyllenhaal','Ralph Fiennes','Ewan McGregor','Maggie Smith','Rhys Ifans','Asa Butterfield','Eros Vlahos','Bill Bailey','Nonso Anozie','Katy Brand','Sinead Matthews','Ed Stoppard','Oscar Steer','Sam Kelly','Gillian Steventon'],
screenplay:['Emma Thompson'],
production:['Tim Bevan','Eric Fellner','Lindsay Doran'],
music:['James Newton Howard'],
camera:['Mike Eley'],
cut:['Sim Evan-Jones'],
sound:['Glenn Freemantle','Richard Pryke','Simon Hayes'],
scenography:['Simon Elliott'],
masks:['Tamsin Dorling Barbosa',"Peter 'Swords' King"],
costumes:['Jacqueline Durran']},
{title:'Nanny McPhee',
titleCZ:'Kouzelná chůva Nanny McPhee',
year:2005,
runtime:97,
countries:['USA','UK','France'],
genres:['Comedy','Family','Fantasy'],
director:['Kirk Jones'],
actors:['Emma Thompson','Colin Firth','Kelly Macdonald','Thomas Brodie-Sangster','Eliza Bennett','Raphaël Coleman','Angela Lansbury','Celia Imrie','Imelda Staunton','Elizabeth Berrington','Derek Jacobi','Patrick Barlow','Adam Godley','Samuel Honywood','Jennifer Rae Daykin','Holly Gibbs','Phyllida Law','Claire Downes'],
basedOn:['Christianna Brand'],
screenplay:['Emma Thompson'],
production:['Tim Bevan','Eric Fellner','Lindsay Doran'],
music:['Patrick Doyle'],
camera:['Henry Braham'],
cut:['Nick Moore','Justin Krish'],
sound:['Glenn Freemantle','Brendan Nicholson','Simon Hayes'],
scenography:['Michael Howells','Ray Chan'],
masks:['Tamsin Dorling Barbosa','Jeremy Woodhead',"Peter 'Swords' King"],
costumes:['Nic Ede']},
{title:"Krakonoš's Secret",
titleCZ:'Krakonošovo tajemství',
year:2022,
runtime:99,
countries:['Czechia','Slovakia','Germany'],
genres:['Fairytale'],
director:['Peter Bebjak'],
actors:['David Švehlík','Leona','Jan Nedbal','Ondřej Sokol','Dominika Morávková-Zeleníková','Jakub Prachař','Martin Huba','Diana Mórová','Jakub Barták','Olaf Burmeister','Ctirad Götz','Lucie Matoušková','Nataša Bednářová','Jan Vondráček','Norbert Lichý','Jiří Maryško','Vladislav Georgiev','Anna Theimerová','Roman Štabrňák','Stanislav Paseka'],
screenplay:['Barbara Johnsonová'],
production:['Rasťo Šesták','Peter Bebjak','Barbara Johnsonová'],
music:['Juraj Dobrakov'],
camera:['Martin Žiaran'],
cut:['Marek Kráľovský'],
sound:['Jiří Hruban'],
scenography:['Juraj Kuchárek'],
masks:['Michaela Kicková','Jiřina Vlková','Iveta Huptychová'],
costumes:['Ján Kocman','Beáta Kodajová']},
{title:'Belle de Jour',
titleCZ:'Kráska dne',
year:1967,
runtime:101,
countries:['France','Italy'],
genres:['Drama'],
director:['Luis Buñuel'],
actors:['Catherine Deneuve','Jean Sorel','Michel Piccoli','Geneviève Page','Françoise Fabian','Maria Latour','Macha Méril','Francisco Rabal','Bernard Fresson','Luis Buñuel','Pierre Clémenti','Brigitte Parmentier','François Maistre','Georges Marchal','Francis Blanche','Bernard Musson','Marc Eyraud','Claude Cerval','Marcel Charvey','Michel Charrel','Iska Khan','Muni'],
basedOn:['Joseph Kessel'],
screenplay:['Luis Buñuel','Jean-Claude Carrière'],
production:['Raymond Hakim','Robert Hakim'],
camera:['Sacha Vierny'],
cut:['Louisette Hautecoeur'],
scenography:['Robert Clavel'],
masks:['Janine Jarreau']},
{title:'Krásný čas',
titleCZ:'Krásný čas',
year:2006,
runtime:97,
countries:['Czechia'],
genres:['Drama'],
director:['Andrea Sedláčková'],
actors:['Tatiana Dyková','Karel Roden','Ladislav Mrkvička','Aňa Geislerová','Ivan Trojan','Alena Vránová','Jana Preissová','Oldřich Kaiser','Kateřina Winterová','Ladislav Smoček','Vladimír Drha','Michaela Pavlátová','Sarah Bidermanová'],
screenplay:['Andrea Sedláčková'],
production:['Jaroslav Kučera'],
music:['Quentin Sirjacq'],
camera:['Vladimír Holomek'],
cut:['Boris Machytka'],
sound:['Jiří Klenka','Daniel Němec'],
scenography:['Martin Kurel'],
masks:['Anna Kodešová','Dana Kleňhová'],
costumes:['Simona Rybáková','Božena Měchurová','Simona Ledererová']},
{title:'Wild Flowers',
titleCZ:'Kytice',
year:2000,
runtime:81,
countries:['Czechia'],
genres:['Drama','Horror','Mystery','Romance','Fantasy','Tale','Poetic'],
director:['F. A. Brabec'],
actors:['Linda Rybová','Bolek Polívka','Kateřina Janečková','Klára Oltová','Karel Dobrý','Sandra Nováková','Stella Zázvorková','Jana Švandová','Alena Mihulová','Aňa Geislerová','Věra Galatíková','Nina Divíšková','Zuzana Bydžovská','Ivan Vyskočil','Jiří Schmitzer','Karel Roden','Dan Bárta','Sára Voříšková','Marian Roden','Naďa Šafratová','Anna Bezoušková','Martina Bezoušková','Sylvie Kraslová','Jiří Hálek'],
basedOn:['Karel Jaromír Erben'],
screenplay:['F. A. Brabec','Deana Horváthová-Jakubisková','Miloš Macourek'],
production:['Deana Horváthová-Jakubisková'],
music:['Jan Jirásek'],
camera:['F. A. Brabec'],
cut:['Boris Machytka'],
sound:['Jiří Klenka'],
scenography:['David Saudek','Jiří Hlupý','Milan Popelka'],
masks:['Jana Radilová'],
costumes:['Jaroslava Brabcová Pecharová']},
{title:'Failure to Launch',
titleCZ:'Lemra líná',
year:2006,
runtime:97,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Tom Dey'],
actors:['Matthew McConaughey','Sarah Jessica Parker','Justin Bartha','Zooey Deschanel','Bradley Cooper','Rob Corddry','Stephen Tobolowsky','Sarah Lilly','Adam Alexi-Malle','Kathy Bates','Katheryn Winnick','Michael Ahl','Mageina Tovah','Don Lincoln','Patton Oswalt','Larry Gamell Jr.','Tyrel Jackson Williams','Terry Bradshaw','Kate McGregor-Stewart','Jessica Stone','Ilana Levine','Elton LeBlanc','Raymond Parker','Stewart Skelton'],
screenplay:['Tom J. Astle'],
production:['Scott Rudin','Scott Aversano'],
music:['Rolfe Kent'],
camera:['Claudio Miranda'],
cut:['Steven Rosenblum'],
sound:['Tom Fleischman','Jacob Ribicoff'],
scenography:['Jeremy Conway'],
masks:['Judy Chin','Bernadette Mazur','Nicki Ledermann'],
costumes:['Ellen Mirojnick']},
{title:"Something's Gotta Give",
titleCZ:'Lepší pozdě nežli později',
year:2003,
runtime:128,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Nancy Meyers'],
actors:['Jack Nicholson','Diane Keaton','Amanda Peet','Keanu Reeves','Frances McDormand','Jon Favreau','KaDee Strickland','Paul Michael Glaser','Rachel Ticotin','Lorraine Nicholson','Audrey Wasilewski','Peter Spears','Susan Misner','Nichole Hiltz','T.J. Thyne','Patrick Fischler','Lorna Scott','Shashi Balooja','Jennifer Siebel Newsom','Melissa Keller','Connie Sawyer','Julia Rose','Troy Christian','Robert Frank Telfer','Robin Pearson Rose','Elayn J. Taylor','Ara Anton','Alan Charof','Julia Sanford','Sean Smith'],
screenplay:['Nancy Meyers'],
production:['Bruce A. Block','Nancy Meyers'],
music:['Hans Zimmer'],
camera:['Michael Ballhaus'],
cut:['Joe Hutshing'],
sound:['Tod A. Maitland'],
scenography:['Jon Hutman'],
masks:['Michael Germain','Cyndilee Rice','Eryn Krueger Mekash','Linda Grimes','Jennifer Bell','Carol Collini','Kelcey Fry'],
costumes:['Suzanne McCabe']},
{title:'Lilo & Stitch 2: Stitch Has a Glitch',
titleCZ:'Lilo a Stitch 2: Stitch má mouchy',
year:2005,
runtime:68,
countries:['USA'],
genres:['Animation','Comedy','Sci-Fi'],
director:['Michael LaBash','Anthony Leondis'],
actors:['Tia Carrere','Dakota Fanning','Jason Scott Lee','Holliston Coleman','Kevin Macdonald','Chris Sanders','David Ogden Stiers','Emily Osment','Liliana Mumy','William J. Caparella','Jillian Henry','Matt Corboy','Grace Rolek'],
screenplay:['Alexa Junge','Eddie Guzelian','Michael Lucker'],
music:['Joel McNeely'],
cut:['William J. Caparella'],
sound:['Keith Rogers',"Terry O'Bright",'Ronald Eng']},
{title:"Dr. Seuss' The Lorax",
titleCZ:'Lorax',
year:2012,
runtime:86,
countries:['USA'],
genres:['Animation','Family','Comedy','Fantasy'],
director:['Chris Renaud','Kyle Balda'],
actors:['Zac Efron','Danny DeVito','Taylor Swift','Ed Helms','Betty White','Rob Riggle','Jenny Slate','Stephen Tobolowsky','Jim Ward','Joel Swetow','John Cygan','Elmarie Wendel','Debi Derryberry','Jan Rabson','Dempsey Pappion','Mona Marshall','Danny Mann','Michael Beattie','Dave B. Mitchell','Jack Angel'],
basedOn:['Dr. Seuss'],
screenplay:['Ken Daurio','Cinco Paul'],
production:['Janet Healy'],
music:['John Powell'],
cut:['Ken Schretzmann','Claire Dodgson'],
sound:['Dennis Leonard','Randy Thom','Gary Rizzo','Andrii Trifonov']},
{title:'Lovecká sezóna',
titleCZ:'Lovecká sezóna',
year:2010,
runtime:57,
countries:['Czechia'],
genres:['Documentary'],
director:['Richard Komárek'],
camera:['Jiří Strnad']},
{title:'Madagascar',
titleCZ:'Madagaskar',
year:2005,
runtime:86,
countries:['USA'],
genres:['Animation','Adventure','Comedy','Family'],
director:['Eric Darnell','Tom McGrath'],
actors:['Ben Stiller','Chris Rock','David Schwimmer','Jada Pinkett Smith','Sacha Baron Cohen','Cedric the Entertainer','Tom McGrath','Chris Miller','Bob Saget','Andy Richter','Christopher Knights','Bastian Pastewka','Cody Cameron','Jeffrey Katzenberg','Zlatan Zuhrić-Zuhra','David Cowgill','Jennifer Darling','Danny Mann','David P. Smith'],
screenplay:['Mark Burton','Billy Frolick','Eric Darnell','Tom McGrath'],
production:['Mireille Soria'],
music:['Hans Zimmer'],
cut:['Clare Knight','Mark A. Hester'],
sound:['Richard L. Anderson','Andy Nelson','Anna Behlmer']},
{title:'Máj',
titleCZ:'Máj',
year:2008,
runtime:69,
countries:['Czechia'],
genres:['Poetic'],
director:['F. A. Brabec'],
actors:['Matěj Stropnický','Sandra Lehnertová','Juraj Kukura','Bronislav Poloczek','Vladimír Javorský','Nina Divíšková','Jan Přeučil','Kryštof Hádek','Jan Tříska','Iveta Jiřičková','Filip Menzel','Ondřej Kobza','Lukáš Melník','Tomáš Dianiška','Petr Puha'],
basedOn:['Karel Hynek Mácha'],
screenplay:['Ivana Nováková','F. A. Brabec'],
production:['Miloš Remeň'],
camera:['F. A. Brabec'],
cut:['Filip Issa'],
sound:['Štěpán Mamula'],
scenography:['Jindřich Goetz'],
masks:['Ivana Chlostová'],
costumes:['Jaroslava Brabcová Pecharová']},
{title:'Little Women',
titleCZ:'Malé ženy',
year:2019,
runtime:135,
countries:['USA'],
genres:['Drama','Romance'],
director:['Greta Gerwig'],
actors:['Saoirse Ronan','Emma Watson','Florence Pugh','Eliza Scanlen','Laura Dern','Timothée Chalamet','Tracy Letts','Bob Odenkirk','James Norton','Louis Garrel','Jayne Houdyshell','Chris Cooper','Meryl Streep','Maryann Plunkett','Ana Cruz Kayne','Dash Barber','Sasha Frolova','Jen Nikolaisen','Abby Quinn','Lilly Englert','Tom Kemp','Edgar Damatian','Hadley Robinson','Kristina Byerley','Ken Holmes','Jared Reinfeldt','Lonnie Farmer','Grant Rosado','Lewis D. Wheeler','Amber Rothberg'],
basedOn:['Louisa May Alcott'],
screenplay:['Greta Gerwig'],
production:['Denise Di Novi','Amy Pascal','Robin Swicord'],
music:['Alexandre Desplat'],
camera:['Yorick Le Saux'],
cut:['Nick Houy'],
sound:['Paul Urmson','Skip Lievsay',"Kevin O'Connell"],
scenography:['Jess Gonchor','Bryan Felty','Claire Kaufman'],
masks:['Miho Suzuki','Judy Chin','Jennifer Bell'],
costumes:['Jacqueline Durran']},
{title:'Little Buddha',
titleCZ:'Malý Buddha',
year:1993,
runtime:140,
countries:['UK','France','Italy','Liechtenstein'],
genres:['Drama'],
director:['Bernardo Bertolucci'],
actors:['Keanu Reeves','Chris Isaak','Bridget Fonda','Jo Champa','Bhisham Sahni','Ruocheng Ying','Alex Wiesendanger','Raju Lal','Greishma Makar Singh','Sogyal Rinpoche','Ven. Khyongla Rato Rinpoche','Ven. Geshe Tsultim Gyelsen','Jigme Kunsang','Thubtem Jampa','T.K. Lama','Doma Tshomo','Mantu Lal','Rinzin Dakpa','Surekha Sikri','Sadiya Siddiqui','Anupam Shyam','Kiran Rao'],
screenplay:['Mark Peploe','Rudy Wurlitzer'],
production:['Jeremy Thomas'],
music:['Rjúiči Sakamoto'],
camera:['Vittorio Storaro'],
cut:['Pietro Scalia'],
sound:['Vincent Arnardi','Eddy Joseph','Ivan Sharrock'],
scenography:['James Acheson','Gianni Giovagnoni'],
masks:['Daniel Parker','Martin Samuel'],
costumes:['James Acheson']},
{title:'Mamma Mia!',
titleCZ:'Mamma Mia!',
year:2008,
runtime:109,
countries:['USA','UK','Germany'],
genres:['Musical','Romance','Comedy'],
director:['Phyllida Lloyd'],
actors:['Meryl Streep','Pierce Brosnan','Colin Firth','Stellan Skarsgård','Amanda Seyfried','Julie Walters','Christine Baranski','Dominic Cooper','Rachel McDowall','Jennifer Leung','Juan Pablo Di Pace','Benny Andersson','George Georgiou','Mia Soteriou','Chris Jarvis','Taylor James','Emrhys Cooper','Heather Emmanuel','Ricardo Montez','Enzo Squillino Jr.','Niall Buggy','Philip Michael'],
screenplay:['Catherine Johnson'],
production:['Gary Goetzman'],
music:['Benny Andersson'],
camera:['Haris Zambarloukos'],
cut:['Lesley Walker'],
sound:['Nick Adams','Michael Minkler','Simon Hayes','Alastair Sirkett','Dominick Tavella'],
scenography:['Maria Djurkovic'],
masks:['Amy Byrne','Zoe Tahir'],
costumes:['Ann Roth']},
{title:'Marie Antoinette',
titleCZ:'Marie Antoinetta',
year:2006,
runtime:123,
countries:['USA'],
genres:['Drama','Biographic','History'],
director:['Sofia Coppola'],
actors:['Kirsten Dunst','Jason Schwartzman','Judy Davis','Rip Torn','Rose Byrne','Asia Argento','Molly Shannon','Shirley Henderson','Danny Huston','Marianne Faithfull','Aurore Clément','Guillaume Gallienne','Tom Hardy','Steve Coogan','André Oumansky','Clémentine Poidatz','Sarah Adler','Mathieu Amalric','Carlo Brandt','Jamie Dornan','Scali Delpeyrat','Gaëlle Bona','Sabine Glaser','David Walliams','Jean-Christophe Bouvet','Céline Sallette','Sebastian Armesto','Alexia Landeau','Alain Doutey','Mary Nighy','Dominic Gould','Joseph Malerba','Joe Sheridan','Xavier Bonastre','Raphaël Neal','Charles Hurez','Fabrice Scott','Bo Barrett','James Lance','John Arnold','Clara Brajtman','Hamish Bowles','Marc Gourdeau','Jean-Marie Moncelet','Serge Christiaenssens','Katrine Boorman'],
screenplay:['Sofia Coppola'],
production:['Ross Katz','Sofia Coppola'],
camera:['Lance Acord'],
cut:['Sarah Flack'],
sound:['Richard Beggs'],
scenography:['K.K. Barrett','Richard Cunin','Véronique Melery'],
masks:['Hue Lan Van Duc','Mauro Tagliaventi','Estelle Tolstoukine'],
costumes:['Milena Canonero']},
{title:'A Bad Moms Christmas',
titleCZ:'Matky na tahu o Vánocích',
year:2017,
runtime:104,
countries:['USA','China'],
genres:['Adventure','Comedy'],
director:['Jon Lucas','Scott Moore'],
actors:['Mila Kunis','Kristen Bell','Kathryn Hahn','Christine Baranski','Susan Sarandon','Jay Hernandez','Justin Hartley','Oona Laurence','Cheryl Hines','Peter Gallagher','David Walton','Phil Pierce','Wanda Sykes','Emjay Anthony','Lyle Brocato','Ariana Greenblatt','Keith Hudson','Terayle Hill','Stan Madray','Jill Kargman','Tian Richards','Christina Applegate','Sophia Alongi','Matthew Warzel','Kurt Yue','J. Gaven Wilde','Patrick Walker'],
screenplay:['Jon Lucas','Scott Moore'],
production:['Suzanne Todd'],
music:['Christopher Lennertz'],
camera:['Mitchell Amundsen'],
cut:['James Thomas'],
sound:['Julian Slater','Greg Orloff'],
scenography:['Marcia Hinds']},
{title:'Teddy Bear',
titleCZ:'Medvídek',
year:2007,
runtime:100,
countries:['Czechia'],
genres:['Comedy','Drama'],
director:['Jan Hřebejk'],
actors:['Jiří Macháček','Roman Luknár','Ivan Trojan','Tatiana Dyková','Aňa Geislerová','Nataša Burger','Klára Issová','Zuzana Fialová','Jiří Menzel','Věra Křesadlová','Kristýna Boková','Berta Macháčková','Sára Sotonová','Tomáš Havlík','Petr Ostrouchov','Petr Jarchovský','Cyril Svoboda'],
screenplay:['Petr Jarchovský','Jan Hřebejk'],
production:['Ondřej Trojan'],
camera:['Jan Malíř'],
cut:['Vladimír Barák'],
sound:['Michal Holubec'],
masks:['Jana Bílková'],
costumes:['Katarína Štrbová Bieliková']},
{title:'City of Angels',
titleCZ:'Město andělů',
year:1998,
runtime:114,
countries:['USA','Germany'],
genres:['Drama','Romance','Fantasy'],
director:['Brad Silberling'],
actors:['Nicolas Cage','Meg Ryan','Andre Braugher','Dennis Franz','Colm Feore','Robin Bartlett','John Putch','Kim Murphy','Elisabeth Shue','Alexander Gould','Amy Brenneman','Chad Lindberg','Brian Markinson','Nick Offerman','Kieu Chinh',"Deirdre O'Connell",'William Stanford Davis','Bernard White','Geoffrey Thorne','Peter Spellos','Joanna Merlin','Mik Scriba','E.J. Callahan','Jay Patterson','Nigel Gibbs','Dan Desmond','Alexander Folk','Rhonda Dotson','Shishir Kurup','Christian Aubert','Tudi Roche','Harper Roisman','Rainbow Borden','Lauri Johnson'],
screenplay:['Dana Stevens','Wim Wenders','Richard Reitinger'],
production:['Charles Roven','Dawn Steel'],
music:['Gabriel Yared'],
camera:['John Seale'],
cut:['Lynzee Klingman'],
sound:['Mark A. Mangini'],
scenography:['Lilly Kilvert','Gretchen Rau'],
masks:['Kenneth Paul Schoenfeld'],
costumes:['Shay Cunliffe']},
{title:'Kitty Mama',
titleCZ:'Micimutr',
year:2011,
runtime:89,
countries:['Czechia'],
genres:['Fairytale'],
director:['Vít Karas'],
actors:['Libuše Šafránková','Ondřej Novák','Marika Šoposká','Jiří Bartoška','Jaroslava Kretschmerová','Vojtěch Dyk','Martin Dejdar','Josef Weinzettel','Nela Boudová','Ivan Lupták','Jiří Suchý','Václav Jílek','Ivan Dejmal','Nikola Navrátil','Barbora Poláková','Kristína Lukešová','Jiří Ployhar ml.','Jindřich Žampa','Vladimír T. Gottwald'],
screenplay:['Irena Dousková'],
production:['Magdalena Sedláková','Ivana Neumannová'],
music:['Ondřej Brousek'],
camera:['Pavel Berkovič'],
cut:['Michal Hýka'],
sound:['David Titěra','Juraj Mravec'],
scenography:['Martin Kurel'],
masks:['Zdeněk Klika','Ivana Němcová','Růžena Novotná'],
costumes:['Jarmila Konečná']},
{title:'The Lover',
titleCZ:'Milenec',
year:1992,
runtime:115,
countries:['France','UK','Vietnam'],
genres:['Drama','Romance','Biographic','Erotic'],
director:['Jean-Jacques Annaud'],
actors:['Jane March','Tony Leung Ka-fai','Frédérique Meininger','Arnaud Giovaninetti','Melvil Poupaud','Lisa Faulkner','Philippe Le Dem','Hélène Patarot','Jeanne Moreau','Frédéric Auburtin'],
basedOn:['Marguerite Duras'],
screenplay:['Gérard Brach','Jean-Jacques Annaud'],
production:['Claude Berri'],
music:['Gabriel Yared'],
camera:['Robert Fraisse'],
cut:['Noëlle Boisson'],
sound:['Laurent Quaglio','Claude Villand'],
scenography:['Hoang Thanh At'],
costumes:['Yvonne Sassinot de Nesle']},
{title:'My Girl',
titleCZ:'Moje první láska',
year:1991,
runtime:102,
countries:['USA'],
genres:['Comedy','Drama','Romance','Family'],
director:['Howard Zieff'],
actors:['Anna Chlumsky','Macaulay Culkin','Dan Aykroyd','Jamie Lee Curtis','Richard Masur','Griffin Dunne','Ann Nelson','Jane Hallaren','Peter Michael Goetz','Tom Villard','Lara Steinick','Shane Obedzinski','Kevin Scott Richardson','Kurt Smildsin','Anthony R. Jones'],
screenplay:['Laurice Elehwany'],
production:['Brian Grazer'],
music:['James Newton Howard'],
camera:['Paul Elliott'],
cut:['Wendy Greene Bricmont'],
sound:['Carlos Delarios'],
scenography:['Joseph T. Garrity'],
costumes:['Karen Patch']},
{title:'Mrs. Doubtfire',
titleCZ:'Mrs. Doubtfire - Táta v sukni',
year:1993,
runtime:120,
countries:['USA'],
genres:['Comedy','Drama','Family'],
director:['Chris Columbus'],
actors:['Robin Williams','Sally Field','Pierce Brosnan','Harvey Fierstein','Polly Holliday','Matthew Lawrence','Mara Wilson','Robert Prosky','Anne Haney','Martin Mull','Terence McGovern','Rick Overton','Paul Guilfoyle','Lisa Jakub','William Newman','Joe Bellan','Tim Silano','Jessica Myerson','Sydney Walker','Molly McClure','Karen Kahn','Scott Beach','Ralph Peduto'],
basedOn:['Anne Fine'],
screenplay:['Randi Mayem Singer','Leslie Dixon'],
production:['Robin Williams','Mark Radcliffe'],
music:['Howard Shore'],
camera:['Donald McAlpine'],
cut:['Raja Gosnell'],
sound:['Gary Summers','Gary Rydstrom','Tom Johnson'],
scenography:['Angelo P. Graham'],
masks:['Ve Neill','Yolanda Toussieng','Greg Cannom'],
costumes:['Marit Allen']},
{title:'The Whole Nine Yards',
titleCZ:'Můj soused zabiják',
year:2000,
runtime:95,
countries:['USA','Canada'],
genres:['Comedy','Crime'],
director:['Jonathan Lynn'],
actors:['Bruce Willis','Matthew Perry','Rosanna Arquette','Michael Clarke Duncan','Natasha Henstridge','Amanda Peet','Kevin Pollak','Harland Williams','Rumer Willis','Stéphanie Biddle','Joanna Noyes','Mark Camacho','Richard Jutras','Gary Gold','Deano Clavet','France Arbour','Carmen Ferland','Serge Christiaenssens','Jean-Guy Bouchard','Sean Devine'],
screenplay:['Mitchell Kapner'],
production:['Allan Kaufman','David Willis'],
music:['Randy Edelman','Gary Gold'],
camera:['David Franco'],
cut:['Tom Lewis'],
sound:['Christian P. Minkler'],
scenography:['David L. Snyder'],
masks:['Gerald Quist'],
costumes:['Edi Giguere']},
{title:'The Man in the Iron Mask',
titleCZ:'Muž se železnou maskou',
year:1998,
runtime:132,
countries:['UK','USA'],
genres:['Action','Adventure','Drama'],
director:['Randall Wallace'],
actors:['Leonardo DiCaprio','Jeremy Irons','John Malkovich','Gérard Depardieu','Gabriel Byrne','Anne Parillaud','Judith Godrèche','Edward Atterton','Peter Sarsgaard','Hugh Laurie','Leonor Varela','Laura Fraser','Brigitte Auber','James Gammon','Olivier Hémon','Joe Sheridan','Cécile Auclert','Vincent Nemeth','Russell Gannon','Emmanuel Patron','Karine Belly','François Guillaume','François Montagut'],
basedOn:['Alexandre Dumas st.'],
screenplay:['Randall Wallace'],
production:['Russell Smith','Randall Wallace'],
music:['Nick Glennie-Smith'],
camera:['Peter Suschitzky'],
cut:['William Hoy'],
sound:['Michael Keller'],
scenography:['Anthony Pratt'],
masks:['Giannetto De Rossi','Linda DeVetta'],
costumes:['James Acheson']},
{title:'Entertainment',
titleCZ:'Ve vlaku',
year:2005,
runtime:4,
countries:['France'],
genres:['Animation','Short'],
director:['Emilie Sengelin'],
cut:['Catherine Aladenise']},
{title:'Return to the Blue Lagoon',
titleCZ:'Návrat do Modré laguny',
year:1991,
runtime:98,
countries:['USA'],
genres:['Adventure','Romance'],
director:['William A. Graham'],
actors:['Milla Jovovich','Brian Krause','Lisa Pelikan','Garette Ratliff Henson','John Dicks','Wayne Pygram','Gus Mercurio'],
basedOn:['Henry De Vere Stacpoole'],
screenplay:['Leslie Stevens'],
production:['William A. Graham'],
music:['Basil Poledouris'],
camera:['Robert Steadman'],
cut:['Ronald J. Fagan'],
sound:['John J. Stephens'],
scenography:['Jon Dowding'],
masks:['Lesley Vanderwalt']},
{title:'Speed',
titleCZ:'Nebezpečná rychlost',
year:1994,
runtime:116,
countries:['USA'],
genres:['Action','Thriller'],
director:['Jan de Bont'],
actors:['Keanu Reeves','Sandra Bullock','Dennis Hopper','Joe Morton','Jeff Daniels','Glenn Plummer','Richard Lineback','Beau Starr','John Capodice','Richard Schiff','Beth Grant','Alan Ruck','Patrick Fischler','James DuMont','Carlos Carrasco','Thomas Rosales Jr.','Robert Mailhouse','Carmen Williams','Julia Vera','Daniel Villarreal','Hawthorne James','Mark Gordon','Jordan Lund','Susan Barnes','Marylou Lim','Sandy Martin','J. David Jones','Loyda Ramos','Rick Dano','Patrick John Hurley','Natsuko Ohama','Brian Grant','Barry Kramer','Todd Gordon'],
screenplay:['Graham Yost'],
production:['Mark Gordon'],
music:['Mark Mancina'],
camera:['Andrzej Bartkowiak'],
cut:['John Wright'],
sound:['Bob Beemer','Steve Maslow','Gregg Landaker'],
scenography:['Jackson De Govia','K.C. Fox'],
masks:['Susan Zietlow-Maust'],
costumes:['Ellen Mirojnick']},
{title:'Indecent Proposal',
titleCZ:'Neslušný návrh',
year:1993,
runtime:113,
countries:['USA'],
genres:['Drama','Romance'],
director:['Adrian Lyne'],
actors:['Robert Redford','Demi Moore','Woody Harrelson','Seymour Cassel','Oliver Platt','Billy Bob Thornton','Rip Taylor','Billy Connolly','Joel Brooks','Danny Zorn','Chi Muoi Lo','Iqbal Theba','Matthew Barry','Joseph Ruskin','Pamela Holt','Mariclare Costello','Nicholas Georgiade','Sergio Kato','Selma Archerd','Elsa Raven','Kevin West','Pierre Epstein','Maurice Sherbanee','Sheena Easton','Joe La Due','Israel Juarbe','Frankie J. Allison','Art Chudabala','Richard Livingston'],
basedOn:['Jack Engelhard'],
screenplay:['Amy Holden Jones'],
production:['Sherry Lansing'],
music:['John Barry'],
camera:['Howard Atherton'],
cut:['Joe Hutshing'],
sound:['Alan Robert Murray','Andy Nelson','Steve Pederson','Keith A. Wester','Scott Millan'],
scenography:['Mel Bourne'],
costumes:['Bernie Pollack','Beatrix Aruna Pasztor','Bobbie Read']},
{title:'Shameless',
titleCZ:'Nestyda',
year:2008,
runtime:82,
countries:['Czechia'],
genres:['Comedy'],
director:['Jan Hřebejk'],
actors:['Jiří Macháček','Simona Babčáková','Pavel Liška','Emília Vášáryová','Nina Divíšková','Pavel Landovský','Vica Kerekes','Vojta Husa','Roman Luknár','Ady Hajdu','Martina Krátká','Kryštof Mucha','Miloš Pokorný','Roman Ondráček','Petr Kracík','Hana Seidlová','Petra Eliáš-Voláková','Lukáš Příkazký','Štefan Capko','Tomáš Hanák','Jiří Fero Burda','Ester Janečková','Halina Pawlowská','Přemek Podlaha','Milan Šteindler','Petr Čtvrtníček','Michal Viewegh','Hana Hegerová','Karel Gott','Vanessa Biermannová','Zdeněk Fišer','Petr Malásek'],
basedOn:['Michal Viewegh'],
screenplay:['Michal Viewegh','Jan Hřebejk','Jiří Macháček'],
production:['Rudolf Biermann','Tomáš Hoffman'],
camera:['Jan Malíř'],
cut:['Vladimír Barák'],
sound:['Robert Dufek'],
masks:['Zdeněk Klika'],
costumes:['Katarína Štrbová Bieliková']},
{title:'Runaway Bride',
titleCZ:'Nevěsta na útěku',
year:1999,
runtime:112,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Garry Marshall'],
actors:['Julia Roberts','Richard Gere','Joan Cusack','Hector Elizondo','Rita Wilson','Paul Dooley','Christopher Meloni','Donal Logue','Reg Rogers','Yul Vazquez','Kathleen Marshall','Sela Ward','Diana Kent','Larry Miller','Garry Marshall','Laurie Metcalf','Patrick Richwood','Rebekah Hoyle','Scott Marshall','Lisa Roberts Gillan','Jane Morris','Tom Mason','Tom Hines','Tiffany Paulsen','Jack Hoffman','Shannon Wilcox','Kevin Murray','Jean Schertler','Mark Byrne','Sandra Taylor','Linda Larkin'],
screenplay:['Josann McGibbon','Sara Parriott'],
production:['Robert W. Cort','Ted Field','Tom Rosenberg','Scott Kroopf'],
music:['James Newton Howard'],
camera:['Stuart Dryburgh'],
cut:['Bruce Green'],
sound:['Jim Fitzpatrick','Gary C. Bourgeois','Keith A. Wester','Myron Nettinga'],
scenography:['Mark Friedberg','Stephanie Carroll'],
masks:['Barbara Lacy'],
costumes:['Albert Wolsky']},
{title:'Indomptable Angélique',
titleCZ:'Nezkrotná Angelika',
year:1967,
runtime:80,
countries:['France','Germany','Italy'],
genres:['Adventure'],
director:['Bernard Borderie'],
actors:['Michèle Mercier','Robert Hossein','Roger Pigaut','Ettore Manni','Sieghardt Rupp','Helmuth Schneider','Pasquale Martino','Jean-Claude Pascal','Paul Müller','Jacques Santi','Arturo Dominici','Christian Rode','Mino Doro','Poldo Bendandi','Gaby Mesée','Mimmo Poli','Paolo Giusti','Bruno Dietrich','Gianni Solaro','Renato De Carmine'],
basedOn:['Anne Golon','Serge Golon'],
screenplay:['Bernard Borderie','Francis Cosne'],
production:['Francis Cosne','François Chavane'],
music:['Michel Magne'],
camera:['Henri Persin'],
cut:['Christian Gaudin'],
sound:['Jean Nény'],
scenography:['Robert Giordani'],
costumes:['Rosine Delamare']},
{title:'Unknown',
titleCZ:'Neznámý',
year:2011,
runtime:113,
countries:['USA','UK','Germany','France'],
genres:['Drama','Thriller','Action'],
director:['Jaume Collet-Serra'],
actors:['Liam Neeson','Diane Kruger','January Jones','Aidan Quinn','Bruno Ganz','Frank Langella','Sebastian Koch','Stipe Erceg','Rainer Bock','Mido Hamada','Karl Markovics','Rainer Sellien','Petra Schmidt-Schaller','Sanny Van Heteren','Janina Flieger','Fritz Roth','Eva Löbau','Matthias Weidenhöfer','Kida Khodr Ramadan','Michael Baral','Herbert Olschok','Torsten Michaelis','Karla Trippel','Adnan Maral','Annabelle Mandeng','Peter Becker','Heike Hanold-Lynch','Sebastian Stielke','Vladimir Pavič','Rose Wakesho','Petra Hartung'],
basedOn:['Didier Van Cauwelaert'],
screenplay:['Oliver Butcher','Stephen Cornwell'],
production:['Joel Silver','Leonard Goldberg','Henning Molfenter','Christoph Fisser','Charlie Woebcken','Andrew Rona'],
music:['John Ottman','Alexander Rudd'],
camera:['Flavio Martínez Labiano'],
cut:['Timothy Alverson'],
sound:['Oliver Tarney','Mark Taylor','Colin Nicolson'],
scenography:['Richard Bridgland'],
masks:['Graham Johnston','Susanne Kasper','Charlotte Chang'],
costumes:['Ruth Myers']},
{title:'Sleeping with the Enemy',
titleCZ:'Noci s nepřítelem',
year:1991,
runtime:95,
countries:['USA'],
genres:['Drama','Thriller'],
director:['Joseph Ruben'],
actors:['Julia Roberts','Patrick Bergin','Kevin Anderson','Elizabeth Lawrence','Kyle Secor','Claudette Nevins','Marita Geraghty','John Lindley','John Ward','Nancy Fish','Tony Abatemarco','Bonnie Johnson'],
basedOn:['Nancy Price'],
screenplay:['Ronald Bass'],
production:['Leonard Goldberg'],
music:['Jerry Goldsmith'],
camera:['John Lindley'],
cut:['George Bowers'],
sound:['John Benson','Chris Carpenter','Kevin E. Carpenter','Chris Connelly','Rick Hart'],
scenography:['Doug Kraner','Lee Poll'],
masks:['Jeff Goodwin'],
costumes:['Richard Hornung']},
{title:'A Nightmare on Elm Street',
titleCZ:'Noční můra v Elm Street',
year:1984,
runtime:87,
countries:['USA'],
genres:['Horror','Thriller'],
director:['Wes Craven'],
actors:['John Saxon','Ronee Blakley','Heather Langenkamp','Amanda Wyss','Jsu Garcia','Johnny Depp','Charles Fleischer','Joseph Whipp','Lin Shaye','Robert Englund','Joe Unger','David Andrews','Shashawnee Hall','Jeff Levine','Ed Call','Mimi Craven','José Alonso','Fernando Sáenz','Ash Adams'],
screenplay:['Wes Craven'],
production:['Robert Shaye'],
music:['Charles Bernstein'],
camera:['Jacques Haitkin'],
cut:['Rick Shaine','Patrick McMahon','Sigfrido García Jr.'],
sound:['James LaRue'],
scenography:['Gregg Fonseca','Anne H. Ahrens'],
masks:['David B. Miller'],
costumes:['Dana Lyman']},
{title:'Identity Card',
titleCZ:'Občanský průkaz',
year:2010,
runtime:129,
countries:['Czechia','Slovakia'],
genres:['Comedy','Drama'],
director:['Ondřej Trojan'],
actors:['Libor Kovář','Matouš Vrba','Jakub Šárka','Jan Vlček','Aňa Geislerová','Martin Myšička','Jan Vaši','Jenovéfa Boková','Marek Taclík','Adam Kubišta','Lilian Malkina','Juraj Nvota','Kristýna Boková','Magdalena Sidonová','Jaromír Dulava','Jana Šulcová','Věra Králová','Jiří Macháček','Jana Kepková','Nella Miščíková','Václav Kopta','Oldřich Vlach','Jakub Jánoš','Matej Landl','Lukáš Latinák','Marina Vyskvorkina','Jan Hrušínský','Lukáš Pavlásek','Ondrej Kovaľ','Monika Sailerová','Markéta Tannerová Šebesťáková','Jiří Fero Burda','Ondřej Zach','Štěpánka Ludvíková','Martin Veliký','Naděžda Husáková','Ľubica Orechovská','Zuzana Mistríková','Katarína Štrbová Bieliková','Richard Pospíšil','Anna Věrtelářová','Jakub Sedláček','Kamil Švejda','Ondřej Trojan'],
basedOn:['Petr Šabach'],
screenplay:['Petr Jarchovský'],
production:['Ondřej Trojan'],
music:['Petr Ostrouchov'],
camera:['Martin Štrba'],
cut:['Vladimír Barák'],
sound:['Jiří Klenka','Jan Čeněk','Pavel Dvořák','Ivo Špalj'],
scenography:['Milan Býček'],
masks:['Jana Bílková'],
costumes:['Katarína Štrbová Bieliková','Jitka Novotná','Soňa Nemcová']},
{title:'I Served the King of England',
titleCZ:'Obsluhoval jsem anglického krále',
year:2006,
runtime:120,
countries:['Czechia','Slovakia','Germany','Hungary'],
genres:['Drama','Comedy','Romance','War'],
director:['Jiří Menzel'],
actors:['Ivan Barnev','Oldřich Kaiser','Julia Jentsch','Zuzana Fialová','Milan Lasica','Marián Labuda st.','Martin Huba','Josef Abrhám','Jiří Lábus','Jaromír Dulava','István Szabó','Pavel Nový','Zdeněk Žák','Rudolf Hrušínský ml.','Petr Čtvrtníček','Jiří Šesták','Pavel Vondruška','Petr Brukner','Jaroslav Tomsa','Oldřich Vlach','Jiří Knot','Naďa Konvalinková','Ladislav Županič','Tonya Graves','Václav Knop','Milan Enčev','Kristýna Boková','Emília Vášáryová','Jan Klusák','Jiří Žák','Rudolf Jelínek','Petr Herrmann','František Řehák','Václav Chalupa','Vlastimil Brabec','Zdeněk Maryška','Martin Zahálka','Barbora Mottlová','Jana Podlipná','Milan Šimáček','Nikolaj Pavlov Penev','Thomas Zielinski','Vladimír Kulhavý','Zdeněk Dolejší','Petra Hřebíčková','Jiří Plachý ml.','Marie Málková','Adolf Hitler','Svatava Hanzl Milková'],
basedOn:['Bohumil Hrabal'],
screenplay:['Jiří Menzel'],
production:['Rudolf Biermann','Robert Schaffer','Andrea Metcalfe'],
music:['Aleš Březina'],
camera:['Jaromír Šofr'],
cut:['Jiří Brožek'],
sound:['Radim Hladík ml.'],
scenography:['Milan Býček'],
masks:['Jiřina Pahlerová'],
costumes:['Milan Čorba']},
{title:'Opravdová láska',
titleCZ:'Opravdová láska',
year:2007,
runtime:80,
countries:['Czechia'],
genres:['Psycology','Drama'],
director:['Andrea Sedláčková'],
actors:['Tatiana Dyková','Oldřich Kaiser','Ivan Trojan','Lucie Žáčková','Vojtěch Kotek','Jana Šulcová','Jana Štěpánková','Marie Drahokoupilová','Václav Sloup','Vratislav Hlavatý','Pavel Lagner','Veronika Teplá','Marika Šoposká','Louis-Charles Sirjacq','Gregor Bauer','Hynek Bečka'],
screenplay:['Andrea Sedláčková'],
production:['Jaroslav Kučera'],
music:['Quentin Sirjacq'],
camera:['Vladimír Holomek'],
cut:['Boris Machytka'],
sound:['Roman Čapek','Petr Lenděl','Karel Zámečník'],
scenography:['Petr Zeman'],
masks:['Květa Holasová','Jana Bílková'],
costumes:['Simona Rybáková','Iveta Trmalová']},
{title:'The Bodyguard',
titleCZ:'Osobní strážce',
year:1992,
runtime:129,
countries:['USA'],
genres:['Romance','Drama','Thriller','Music'],
director:['Mick Jackson'],
actors:['Kevin Costner','Whitney Houston','Gary Kemp','Bill Cobbs','Ralph Waite','Tomas Arana','Michele Lamar Richards','Mike Starr','Christopher Birt','DeVaughn Nixon','Gerry Bamman','Joe Urla','Tony Pierce','Charles Keating','Robert Wuhl','Debbie Reynolds','Danny Kamin','Ethel Ayler','Richard Schiff','Christopher Connelly','Nathaniel Parker','Bert Remsen','Donald Hotton','Nita Whitaker','Patricia Healy','Rob Sullivan','Stephen Shellen','Victoria Bass','Joe Hess','Joe Unger','Susan Traylor','Bruce Holman','David Joseph Martinez','Jimmy Star','Damon Stout'],
screenplay:['Lawrence Kasdan'],
production:['Lawrence Kasdan','Jim Wilson','Kevin Costner'],
music:['Alan Silvestri'],
camera:['Andrew Dunn'],
cut:['Richard A. Harris','Donn Cambern'],
sound:['Greg P. Russell'],
scenography:['Jeffrey Beecroft'],
masks:['Thomas R. Burman','Jake Garber'],
costumes:['Susan Nininger']},
{title:'Shooter',
titleCZ:'Odstřelovač',
year:2007,
runtime:124,
countries:['USA'],
genres:['Action','Thriller','Crime','Mystery'],
director:['Antoine Fuqua'],
actors:['Mark Wahlberg','Kate Mara','Michael Peña','Danny Glover','Mike Dopud','Lane Garrison','Elias Koteas','Rhona Mitra','Ned Beatty','Louis Ferreira','Tate Donovan','Rade Šerbedžija','Holly Eglington','Zak Santiago','Michael Ahl','Brian Markinson','Alexander Emmert','Tom Butler','Levon Helm','A.C. Peterson','Mackenzie Gray','Brad Kelly','John Tench','Roberto Lombardi','Trish Allen','David Bloom','Mac McDonald','Rebecca Toolan','Lauren Glazier','Erica Lynne Arden','Dean McKenzie','Henry Penzi','Damien Colletti','Fred Keating'],
basedOn:['Stephen Hunter'],
screenplay:['Jonathan Lemkin'],
production:['Lorenzo di Bonaventura','Ric Kidney'],
music:['Mark Mancina'],
camera:['Peter Menzies Jr.'],
cut:['Conrad Buff IV','Eric A. Sears'],
sound:['Steve Pederson','Brad Sherman','Rob Young'],
scenography:['Dennis Washington','Johanne Hubert'],
masks:['Donald Mowat','Victoria Down'],
costumes:['Ha Nguyen']},
{title:'The Magdalene Sisters',
titleCZ:'Padlé ženy',
year:2002,
runtime:119,
countries:['Ireland','UK'],
genres:['Drama'],
director:['Peter Mullan'],
actors:['Geraldine McEwan','Nora-Jane Noone','Anne-Marie Duff','Dorothy Duffy','Eileen Walsh','Stephen McCole','Tracy Kearney','Peter Mullan','Eamonn Owens','Kevin Shields','Ian Hanmore','Phyllis Mcmahon','Ciaran Owens','Mary Murray','Seán McDonagh','Frances Healy','Gareth Milne','Julie Wilson Nimmo'],
screenplay:['Peter Mullan'],
production:['Paul Trijbits'],
music:['Craig Armstrong'],
camera:['Nigel Willoughby'],
cut:['Colin Monie'],
sound:['Colin Nicolson','Tom Johnson'],
costumes:['Trisha Biggar']},
{title:'Paprika',
titleCZ:'Paprika',
year:2006,
runtime:90,
countries:['Japan'],
genres:['Animation','Mystery','Psycology','Thriller','Sci-Fi'],
director:['Satoši Kon'],
actors:['Megumi Hajašibara','Akio Ócuka','Hidejuki Tanaka','Kóiči Jamadera','Micuo Iwata','Satoši Kon','Jasutaka Cucui','Daisuke Sakaguči','Rikako Aikawa','Anri Kacu','Kacunosuke Hori','Tóru Furuja','Kózó Mito','Kumiko Izumi','Keiičiró Endó','Masanori Hajaši'],
basedOn:['Jasutaka Cucui'],
screenplay:['Satoši Kon','Seiši Minakami'],
music:['Susumu Hirasawa'],
camera:['Mičija Kató'],
cut:['Takeši Sejama'],
sound:['Masafumi Mima'],
scenography:['Nobutaka Ike']},
{title:'A Few Good Men',
titleCZ:'Pár správných chlapů',
year:1992,
runtime:131,
countries:['USA'],
genres:['Drama','Crime','Thriller','Mystery'],
director:['Rob Reiner'],
actors:['Tom Cruise','Jack Nicholson','Demi Moore','Kevin Bacon','Kiefer Sutherland','Kevin Pollak','James Marshall','J. T. Walsh','Christopher Guest','J.A. Preston','Matt Craven','Wolfgang Bodison','Xander Berkeley','John M. Jackson','Noah Wyle','Cuba Gooding Jr.','Joshua Malina','Oscar Jordan','Aaron Sorkin','Frank Cavestani','Jan Munroe','Ron Ostrow','Harry Caesar','Michael DeLorenzo','Geoffrey Nauffts','Cameron Thor','David Bowe','Maud Winchester','Alex Wexo','Lawrence Lowe'],
screenplay:['Aaron Sorkin','Aaron Sorkin'],
production:['David Brown','Rob Reiner','Andrew Scheinman'],
music:['Marc Shaiman'],
camera:['Robert Richardson'],
cut:['Robert Leighton','Steven Nevius'],
sound:["Kevin O'Connell",'Louis L. Edemann','Charles L. Campbell'],
scenography:['J. Michael Riva'],
masks:['Stephen Abrums','Sherri Bramlett'],
costumes:['Gloria Gresham']},
{title:'Paris, I Love You',
titleCZ:'Paříži, miluji Tě',
year:2006,
runtime:115,
countries:['France','Liechtenstein','Switzerland','Germany'],
genres:['Romance','Drama','Tale'],
director:['Bruno Podalydès','Gurinder Chadha','Gus Van Sant','Joel Coen','Ethan Coen','Walter Salles','Daniela Thomas','Christopher Doyle','Isabel Coixet','Nobuhiro Suwa','Sylvain Chomet','Alfonso Cuarón','Olivier Assayas','Oliver Schmitz','Richard LaGravenese','Vincenzo Natali','Wes Craven','Tom Tykwer','Frédéric Auburtin','Gérard Depardieu','Alexander Payne'],
actors:['Bruno Podalydès','Marianne Faithfull','Elias McConnell','Gaspard Ulliel','Steve Buscemi','Catalina Sandino Moreno','Barbet Schroeder','Javier Cámara','Sergio Castellitto','Miranda Richardson','Leonor Watling','Juliette Binoche','Willem Dafoe','Hippolyte Girardot','Yolande Moreau','Nick Nolte','Ludivine Sagnier','Maggie Gyllenhaal','Aïssa Maïga','Fanny Ardant','Bob Hoskins','Olga Kurylenko','Elijah Wood','Emily Mortimer','Alexander Payne','Rufus Sewell','Melchior Derouet','Natalie Portman','Gérard Depardieu','Ben Gazzara','Gena Rowlands','Margo Martindale','Adel Bencherif','Wes Craven','Emilie Ohana','Hélène Patarot','Cyril Descours','Leïla Bekhti','Julien Beramis','Walid Afkir','Morgane Slemp','Sara Martins','Julie Bataille','Florence Muller','Nino Kirtadze','Lionel Dray','Laetitia Spigarelli','Hervé Pierre','Axel Kiener','Frankie Pain','Jean-Christophe Barc','Salah Teskouk','Daniely Francisque','Paul Putner','Chany Sabaty','Marina Moncade','Joana Preiss','Xing Xing Cheng'],
screenplay:['Richard LaGravenese','Ethan Coen','Joel Coen','Gus Van Sant','Walter Salles','Isabel Coixet','Alfonso Cuarón','Olivier Assayas','Wes Craven','Tom Tykwer','Alexander Payne','Vincenzo Natali','Rain Li'],
production:['Claudie Ossard'],
music:['Tom Tykwer','Johnny Klimek','Michael Andrews','Pierre Adenot'],
camera:['Bruno Delbonnel','Frank Griebe','Michael Seresin','Maxime Alexandre','Tecuo Nagata','Eric Guichard','Denis Lenoir','Pascal Marti','Michel Amathieu','Eric Gautier','David Quesemand','Pierre Aïm','Jean-Claude Larrieu','Pascal Rabaud','Rain Li','Matthieu Poirot-Delpech','Gérard Sterin'],
cut:['Luc Barnier','Simon Jacquet','Anne Klotz','Alex Rodríguez','Stan Collet','Isabel Meier','Mathilde Bonnefoy'],
sound:['Jean-Paul Mugel','Matthias Lempert','Daniel Sobrino','Dirk Jacob'],
scenography:['Bettina von den Steinen'],
masks:['Stéphane Robert','Sabine Liedl'],
costumes:['Olivier Bériot']},
{title:'The Mule',
titleCZ:'Pašerák',
year:2018,
runtime:116,
countries:['USA'],
genres:['Crime','Drama','Thriller'],
director:['Clint Eastwood'],
actors:['Clint Eastwood','Bradley Cooper','Dianne Wiest','Taissa Farmiga','Michael Peña','Alison Eastwood','Andy Garcia','Laurence Fishburne','Clifton Collins Jr.','Robert LaSardo','Noel Gugliemi','Katie Gill','Ignacio Serricchio','Lobo Sebastian','Loren Dean','Victor Rasuk','Pete Burris','Devon Ogden','Lee Coc','Michael H. Cole','Austin Freeman','Alan Heckner','Paul Alayo','Kaitlin Hodson','Ashani Roberts','Derek Russo','Diego Cataño','Sparrow Nicole','Travina Springer','Kenny Barr','Tess Malis Kincaid','Antwan Mills','Joe Knezevich','Cesar De León','Keith Flippen','Kinsley Isla Dillon','Eugene Cordero','Daniel Moncada','Kareem J. Grimes','Dylan Kussman','Saul Huezo','Caroline Avery Granger','Dayna Beilenson','Artemis'],
screenplay:['Nick Schenk'],
production:['Clint Eastwood','Tim Moore','Bradley Thomas','Kristina Rivera','Dan Friedkin','Jessica Meier'],
music:['Arturo Sandoval'],
camera:['Yves Bélanger'],
cut:['Joel Cox'],
sound:['Alan Robert Murray','Dean A. Zupancic','John T. Reitz'],
scenography:['Kevin Ishioka','Ronald R. Reiss'],
masks:['Patricia Dehaney','Luisa Abel','Lori McCoy-Bell'],
costumes:['Deborah Hopper']},
{title:'Pes baskervillský',
titleCZ:'Pes baskervillský',
year:1937,
runtime:82,
countries:['Germany'],
genres:['Crime','Horror','Mystery'],
director:['Karel Lamač'],
actors:['Peter Voß','Fritz Odemar','Fritz Rasp','Paul Rehkopf','Siegfried Schürenberg','Michael von Newlinsky','Gertrud Wolle','Friedrich Kayßler','Erich Ponto','Artur Malkowsky','Ernst Rotmund','Horst Birr','Walter Bechmann','Kurt Bobeth-Bolander','Lili Schoenborn-Anspach','Kurt Lauermann','Klaus Pohl','Hanna Waag'],
basedOn:['Arthur Conan Doyle'],
screenplay:['Carla von Stackelberg'],
production:['Anny Ondráková','Karel Lamač'],
music:['Paul Hühn'],
camera:['Willi Winterstein'],
sound:['Carl Erich Kroschke'],
scenography:['Wilhelm Depenau']},
{title:'Life of Pi',
titleCZ:'Pí a jeho život',
year:2012,
runtime:122,
countries:['USA','Taiwan','UK','Canada'],
genres:['Adventure','Drama'],
director:['Ang Lee'],
actors:['Suraj Sharma','Irrfan Khan','Adil Hussain','Tabu','Gérard Depardieu','Rafe Spall','Andrea Di Stefano','Chien-wei Huang','James Saito','I-Chen Ko'],
basedOn:['Yann Martel'],
screenplay:['David Magee'],
production:['Gil Netter','David Womark'],
music:['Mychael Danna'],
camera:['Claudio Miranda'],
cut:['Tim Squyres'],
sound:['Eugene Gearty','Paul Hsu','Ron Bartlett','Doug Hemphill'],
scenography:['David Gropman','Huili Liao','Anna Pinnock','Dan Webster'],
masks:['Forest Sala','Fae Hammond','Kirstin Chalmers','Barrie Gower'],
costumes:['Arjun Bhasin']},
{title:'Pinocchio',
titleCZ:'Pinocchio',
year:2022,
runtime:105,
countries:['USA'],
genres:['Comedy','Drama','Family'],
director:['Robert Zemeckis'],
actors:['Tom Hanks','Joseph Gordon-Levitt','Benjamin Evan Ainsworth','Luke Evans','Lorraine Bracco','Keegan-Michael Key','Cynthia Erivo','Sheila Atim','Angus Wright','Jamie Demetriou','Giuseppe Battiston','Lewin Lloyd'],
basedOn:['Carlo Collodi'],
screenplay:['Robert Zemeckis','Simon Farnaby','Chris Weitz'],
production:['Chris Weitz','Andrew Miano'],
music:['Alan Silvestri'],
camera:['Seamus McGarvey'],
cut:['Mick Audsley'],
sound:['Randy Thom'],
scenography:['Stefan Dechant','Tina Jones','Stephen Swain'],
masks:['Jenny Shircore'],
costumes:['Joanna Johnston']},
{title:'The Beach',
titleCZ:'Pláž',
year:2000,
runtime:114,
countries:['USA','UK'],
genres:['Drama','Adventure','Thriller'],
director:['Danny Boyle'],
actors:['Leonardo DiCaprio','Tilda Swinton','Virginie Ledoyen','Guillaume Canet','Robert Carlyle','Peter Youngblood Hills','Paterson Joseph','Daniel Caltagirone','Victoria Smurfit','Josh Cole','Hélène de Fougerolles','Stacy Hart','Isabella Seibert','Saskia Mulder','Jukka Hiltunen','Bindu De Stoppani','Zelda Tinska','Jerry Swindall','Staffan Kihlbom Thor','Daniel York'],
basedOn:['Alex Garland'],
screenplay:['John Hodge'],
production:['Andrew Macdonald'],
music:['Angelo Badalamenti','Jake Jackson'],
camera:['Darius Khondji'],
cut:['Masahiro Hirakubo'],
sound:['Glenn Freemantle'],
scenography:['Andrew McAlpine','Anna Pinnock'],
masks:['Mark Coulier','Barrie Gower','Siân Grigg'],
costumes:['Rachael Fleming']},
{title:'The Tin Drum',
titleCZ:'Plechový bubínek',
year:1979,
runtime:142,
countries:['Germany','France','Poland','Jugoslávie'],
genres:['Drama','War'],
director:['Volker Schlöndorff'],
actors:['Mario Adorf','Angela Winkler','David Bennent','Katharina Thalbach','Daniel Olbrychski','Tina Engel','Berta Drews','Andréa Ferréol','Heinz Bennent','Ilse Pagé','Werner Rehm','Käte Jaenicke','Helmut Brasch','Otto Sander','Wigand Witting','Mariella Oliveri','Fritz Hakl','Charles Aznavour','Marek Walczewski','Ernst Jacobi','Wojciech Pszoniak','Henning Schlüter','Zygmunt Hübner','Mieczyslaw Czechowicz','Bruno Thost','Lech Grzmociński','Stanisław Michalski','Horst Gentzen','Jerzy Łapiński','Günter Meisner','Beata Poźniak Daniels','Raphaël Vogt','Herbert Weissbach','Tadeusz Kunikowski','Gustaw Holoubek','Joachim Hackethal','Alexander von Richthofen','Herbert Behrendt','Dietrich Frauboes'],
basedOn:['Günter Grass'],
screenplay:['Jean-Claude Carrière','Franz Seitz','Volker Schlöndorff'],
production:['Franz Seitz','Hans Prescher'],
music:['Maurice Jarre','Friedrich Meyer'],
camera:['Igor Luther'],
cut:['Suzanne Baron'],
sound:['Peter Kellerhals','Peter Beil'],
scenography:['Zeljko Senecic','Piotr Dudziński','Ewa Kowalska'],
masks:['Teresa Jakuczyn-Tomaszewska'],
costumes:['Dagmar Niefind','Inge Heer']},
{title:'Počítání oveček',
titleCZ:'Počítání oveček',
year:1981,
runtime:77,
countries:['Czechoslovakia'],
genres:['Drama'],
director:['Karel Kachyňa'],
actors:['Žaneta Fuchsová','Věra Galatíková','Vlastimil Brodský','Naďa Konvalinková','Nina Divíšková','Peter Debnár','Jaroslav Heyduk','Karel Heřmánek','Pavel Zedníček','Zdeněk Ornest','Boris Halmi','Zdena Hadrbolcová','Jaroslava Kretschmerová','Bohumila Dousková Pešicová','Zdeněk Martínek','Ondřej Pavelka','Svatava Hubeňáková','Jindra Kvardová','Renáta Doleželová','Marta Richterová','Lucie Vojtěchová','Veronika Jeníková','Anna Štrosová','Zdena Burdová','Lenka Pichlíková','Ondřej Vetchý','Lukáš Bech','Martin Krb','Martin Mikuláš','Pavlína Mourková','Klára Pollertová-Trojanová'],
screenplay:['Karel Čabrádek','Karel Kachyňa'],
music:['Luboš Fišer'],
camera:['Jan Čuřík'],
cut:['Josef Valušiak'],
sound:['Pavel Jelínek'],
scenography:['Jan Oliva'],
masks:['Jiří Šimon'],
costumes:['Helena Dubová']},
{title:'Working Girl',
titleCZ:'Podnikavá dívka',
year:1988,
runtime:109,
countries:['USA'],
genres:['Comedy','Romance','Drama'],
director:['Mike Nichols'],
actors:['Melanie Griffith','Harrison Ford','Sigourney Weaver','Alec Baldwin','Joan Cusack','Philip Bosco','Nora Dunn','Oliver Platt','James Lally','Kevin Spacey','Robert Easton','Olympia Dukakis','Amy Aquino','Jeffrey Nordling','Elizabeth Whitcraft','Maggie Wagner','Lou DiMaggio','David Duchovny','Caroline Aaron','Nancy Giles','Julia Silverman','Zach Grenier','Ralph Byers','Barbara Garrick','Ricki Lake','Marceline Hugot','Timothy Carhart','Suzanne Shepherd','Matthew Bennett','Trish Cook'],
screenplay:['Kevin Wade'],
production:['Douglas Wick'],
music:['Carly Simon'],
camera:['Michael Ballhaus'],
cut:["Sam O'Steen"],
sound:['Lee Dichter'],
scenography:['Patrizia von Brandenstein','George DeTitta Jr.'],
costumes:['Ann Roth']},
{title:'Poker Face',
titleCZ:'Poker Face',
year:2023,
runtime:'18h 35min',
episodeRuntime:'43-66min',
countries:['USA'],
genres:['Mystery'],
director:['Rian Johnson','Iain B. MacDonald','Tiffany Johnson','Lucky McKee','Ben Sinclair','Natasha Lyonne','Janicza Bravo'],
actors:['Natasha Lyonne','Joseph Gordon-Levitt','Adrien Brody','Stephanie Hsu','Benjamin Bratt','Lil Rel Howery','S. Epatha Merkerson','Nicholas Cirillo','Niall Cunningham','Chloë Sevigny','Jameela Jamil','Ellen Barkin','Tim Meadows','Dascha Polanco','Noah Segan','Jeremy Lawrence','Eddie Gorodetsky','Ashley Austin Morris','Carol Jefferson','Ted Griffin','Hong Chau','Megan Suri','Colton Ryan','John Ratzenberger','Brandon Micheal Hall','Chelsea Frei','Jaswant Dev Shrestha','Lincoln A. Castellanos','Christopher Hagen','Vic Browder','Danielle Macdonald','Shane Paul McGhie','Larry Brown','Stephen C. Bradbury','Chuck Cooper','Ari Barkan','Carmine Famiglietti','Bryan Burton','Judith Light','K Callan','Simon Helberg','Reed Birney','Audrey Corsa','Tim Blake Nelson','Charles Melton','Leslie Silva','Angel Desai','Nick Nolte','Cherry Jones','Luis Guzmán','Tim Russ','Rowan Blanchard','Johnny Ferri','Jack Alcott','Reid Richards','Ali Nasser','David Castañeda Jr.','Darius Fraser','Ron Perlman','Clea DuVall','Rhea Perlman','Chloë Caro','Jeffrey T. Bernstein','Elsa Kennedy','Michael Reagan'],
screenplay:['Rian Johnson','Alice Ju','Wyatt Cain','Christine Boylan','Charlie Peppers','Chris Downey','Joe Lawson','Natasha Lyonne'],
music:['Nathan Johnson'],
camera:['Steve Yedlin','Christine Ng','Jaron Presant'],
cut:['Bob Ducsay','Glenn Garland','Shaheed Qaasim','Paul Swain'],
sound:['Larry Benjamin'],
scenography:['Judy Rhee','Elizabeth Eggert','Miles Michael'],
masks:['Elvira Gonzalez'],
costumes:['Trayce Gigi Field']},
{title:'Kindergarten Cop',
titleCZ:'Policajt ze školky',
year:1990,
runtime:107,
countries:['USA'],
genres:['Action','Comedy','Thriller','Crime'],
director:['Ivan Reitman'],
actors:['Arnold Schwarzenegger','Penelope Ann Miller','Pamela Reed','Linda Hunt','Richard Tyson','Carroll Baker','Cathy Moriarty','Christian Cousins','Joseph Cousins','Park Overall','Jayne Brook','Richard Portnow','Heidi Swedberg','Angela Bassett','Alix Koromzay','Chi Muoi Lo','Michael Chapman','Leo Lee','Miko Hughes','Adam Wylie','Ross Malinger','Jason Reitman','Odette Annable','Catherine Reitman','Tom Dugan','Sarah Rose Karr','Ed Crick','Thomas Rosales Jr.','Peter Mark Vasquez','Rick Jones','Frankie Avina','Galen Yuen','Steve Park','Jason Stuart','Eugene Elman','Charlie Holliday','Ray Glanzmann','Ben Diskin'],
screenplay:['Herschel Weingrod','Timothy Harris','Murray Salem'],
production:['Brian Grazer','Ivan Reitman'],
music:['Randy Edelman'],
camera:['Michael Chapman'],
cut:['Sheldon Kahn','Wendy Greene Bricmont'],
sound:['Anna Behlmer','Gary C. Bourgeois'],
scenography:['Bruno Rubeo','Anne D. McCulley'],
masks:['Ken Chase','Jeff Dawn'],
costumes:['Gloria Gresham']},
{title:"Luna's Revenge",
titleCZ:'Pomsta Luny',
year:2017,
runtime:92,
countries:['Germany'],
genres:['Thriller'],
director:['Khaled Kaissar'],
actors:['Lisa Vicari','Carlo Ljubek','Branko Tomović','Rainer Bock','Bibiana Beglau','Benjamin Sadler','Genija Rykova','Annika Blendl','Alexander Beyer','Luise Deschauer','Eugen Knecht','Rafael Koussouris','Zoe Thurau','Urs Fabian Winiger','Laura Graser','Thomas Wenke','Adrian Spielbauer','Tamara Graser','Nora Schulte','Patrick Katzer'],
screenplay:['Alexander Costea','Ali Zojaji'],
production:['Khaled Kaissar','Thomas Wöbke'],
music:['Heiko Maile','Christoph Zirngibl'],
camera:['Namche Okon'],
cut:['Florian Duffe'],
sound:['Hubert Bartholomae','Peter Kautzsch','Andreas Biegler'],
scenography:['Carina Cavegn'],
masks:['Karin Steinhäuser']},
{title:'Last Shot, The',
titleCZ:'Poslední výstřel',
year:1950,
runtime:91,
countries:['Czechoslovakia'],
genres:['Drama','War'],
director:['Jiří Weiss'],
actors:['Antonín Klimša','Jiří Kostka','Adolf Král','Čeněk Rábl','Zdeněk Grygar','Soběslav Křivda','František Vyplel','Štěpán Gorniesiewicz','Inocenc Březina','Augustin Lanča','Josef Brus','Jana Kalášková','Nelly Gaierová','Jindřich Vicherek','František Šlégr','Rudolf Široký','Miloslav Holub','František Klika','Jaromír Krejčí','Adolf Kaštovský','Břetislav Lanča','Pavel Nozar','Blažej Jiříkovský','Rudolf Grudněvič','Marie Palečková','Václav Lohniský'],
music:['Jiří Srnka'],
camera:['Ferdinand Pečenka'],
cut:['Miroslav Hájek'],
sound:['Dobroslav Šrámek'],
scenography:['Karel Lier','Bohuslav Kulič'],
masks:['Otakar Košťál']},
{title:'How Do You Know',
titleCZ:'Poznáš, až to přijde?',
year:2010,
runtime:116,
countries:['USA'],
genres:['Comedy','Romance','Drama'],
director:['James L. Brooks'],
actors:['Reese Witherspoon','Paul Rudd','Owen Wilson','Jack Nicholson','Kathryn Hahn','Mark Linn-Baker','Molly Price','Shelley Conn','Domenick Lombardozzi','John Tormey','Tony Shalhoub','Dean Norris','Andrew Wilson','Tara Subkoff','Brian Distance','Bill McKinney','Matthew James Gulbranson','Laura Bryce','Michael James Levy','Anthony Bradford','Alexandra Begg','Greg Perrow','David A. Gregory','Teyonah Parris','Jacob Bertrand','Will Blagrove','Ron McLarty','Lenny Venito','Kirk Curran','Patsy Meck','Cindy Marie Martin','Doug Henderson','Terrence Beasor','Kimberly Lynn Campbell','Thomas Walton','Atif Lanier','Kendel Skinner','Karsen Skinner'],
screenplay:['James L. Brooks'],
production:['Paula Weinstein','Laurence Mark','James L. Brooks','Julie Ansell'],
music:['Hans Zimmer'],
camera:['Janusz Kamiński'],
cut:['Richard Marks','Tracey Wadmore-Smith'],
sound:['David Giammarco','Michael Semanick','Deb Adair','Petur Hliddal'],
scenography:['Jeannine Oppewall','Nancy Nye','David Blass'],
masks:['Michael Germain','June Brickman'],
costumes:['Shay Cunliffe']},
{title:'They Call Me Trinity',
titleCZ:'Pravá a levá ruka ďábla',
year:1970,
runtime:109,
countries:['Italy'],
genres:['Comedy','Western'],
director:['Enzo Barboni'],
actors:['Terence Hill','Bud Spencer','Farley Granger','Gisela Hahn','Dominic Barto','Riccardo Pizzuti','Luciano Rossi','Pietro Torrisi',"Alberto Dell'Acqua",'Gilberto Galimberti','Artemio Antonini','Omero Capanna','Fortunato Arena','Larry Dolgin','Ted Rusoff','Remo Capitani','Giancarlo Bastianoni','Osiride Pevarello','Franco Ukmar','Paolo Figlia','Ezio Marano','Angelo Casadei','Ugo Sasso','Franco Marletta','Paolo Magalotti','Alba Maiolini','Sergio Smacchi','Sergio Testori','Antonio Monselesan','Dan Sturkie','Luigi Bonos'],
screenplay:['Enzo Barboni'],
production:['Joseph E. Levine'],
music:['Franco Micalizzi'],
camera:['Aldo Giordani'],
scenography:['Enzo Bulgarelli'],
costumes:['Luciano Sagoni']},
{title:'Legally Blonde',
titleCZ:'Pravá blondýnka',
year:2001,
runtime:93,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Robert Luketic'],
actors:['Reese Witherspoon','Luke Wilson','Selma Blair','Matthew Davis','Victor Garber','Jennifer Coolidge','Holland Taylor','Ali Larter','Alanna Ubach','Oz Perkins','Linda Cardellini','Bruce Thomas','Meredith Scott Lynn','Raquel Welch','Kimberly McCullough','Allyce Beasley','Kevin Cooney','James Read','Tane McClure','Lisa K. Wyatt','Chaney Kley','Nectar Rose','Joanna Krupa','Sasha Barrese','Ted Rooney','Jessica Cauffiel','Samantha Lemole','Greg Serano','John Kapelos','Brody Hutzler','Victoria Mahoney','Lacey Beeman','Kelly Nyks','Gary Ambrosia','Lisa Arch','Jodi Harris','Mark Heidelberger','Amber Goetz','Niklaus Lange','Doug Spinuzza','Michael B. Silver','Ted Kairys','Cici Lau','Francesca P. Roberts','Jimmy Star','Jason Christopher','Scott Ryan','Wayne Federman','Melissa Anne Young'],
basedOn:['Amanda Brown'],
screenplay:['Karen McCullah','Kirsten Smith'],
production:['Marc Platt','Ric Kidney'],
music:['Rolfe Kent'],
camera:['Anthony B. Richmond'],
cut:['Anita Brandt Burgoyne','Garth Craven'],
sound:['Frederick Howard','Joe Barnett'],
scenography:['Missy Stewart','Kathy Lucas'],
masks:['Warren Lewis'],
costumes:['Sophie De Rakoff']},
{title:'Legally Blonde 2: Red, White & Blonde',
titleCZ:'Pravá blondýnka 2',
year:2003,
runtime:95,
countries:['USA'],
genres:['Comedy'],
director:['Charles Herman-Wurmfeld'],
actors:['Reese Witherspoon','Regina King','Sally Field','Jennifer Coolidge','Mary Lynn Rajskub','Alanna Ubach','Bruce Thomas','Bob Newhart','Josh Holland','Carolyn Hennesy','Luke Wilson','Dana Ivey','Bruce McGill','Stanley Anderson','James Read','Masi Oka','Octavia Spencer','Tanja Reichert','Tane McClure','Dale Waddington','Jackie Hoffman','Jack McGee','Jason Bushman','Jessica Cauffiel','Erin Cottrell','Christina Sheldon','Amy Schlagel','Keone Young','Amir Talai','Arianne Fraser','James Urbaniak','Bryan Cuprill','J Barton','Catherine Lazo','Robert Peters','Madeleine Wade','Michael Krawic','Sam Pancake','Elizabeth Beckwith','Caroline Williams','Ruth Williamson','Matt Price','Karen-Eileen Gordon'],
screenplay:['Kate Kondell'],
production:['Marc Platt'],
music:['Rolfe Kent'],
camera:['Elliot Davis'],
cut:['Peter Teschner'],
sound:['Richard L. Anderson','Gary Gegan'],
scenography:['Missy Stewart','K.C. Fox','Mark Worthington'],
masks:['Katherine James','Anne Morgan','Toni-Ann Walker'],
costumes:['Sophie De Rakoff']},
{title:'Keeping the Faith',
titleCZ:'Rabín, kněz a krásná blondýna',
year:2000,
runtime:128,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Edward Norton'],
actors:['Ben Stiller','Edward Norton','Jenna Elfman','Anne Bancroft','Eli Wallach','Ron Rifkin','Miloš Forman','Holland Taylor','Lisa Edelstein','Rena Sofer','Ken Leung','David Wain','Blythe Auffarth','Dagmara Dominczyk','Bodhi Elfman','Brian Anthony Wilson','Susie Essman','Stuart Blumberg','Jessica Prince','Brian George','Craig Castaldo','Brenda Denmark','Matt Winston','Wai Ching Ho','Hawk Koch','Samuel Goldberg','Donna Hanover','Liz Larsen','Michael Charles Roman','Catherine Lloyd Burns','Kelly Deadmon','Tony Rossi','Francine Beers','Laura Summer'],
screenplay:['Stuart Blumberg'],
production:['Stuart Blumberg','Edward Norton','Hawk Koch'],
music:['Elmer Bernstein'],
camera:['Anastas N. Michos'],
cut:['Malcolm Campbell'],
sound:['Kevin E. Carpenter'],
scenography:['Wynn Thomas'],
masks:['Carla White'],
costumes:['Michael Kaplan']},
{title:'Rob Roy',
titleCZ:'Rob Roy',
year:1995,
runtime:139,
countries:['USA'],
genres:['Drama','History','Romance','War'],
director:['Michael Caton-Jones'],
actors:['Liam Neeson','Jessica Lange','John Hurt','Tim Roth','Eric Stoltz','Andrew Keir','Brian Cox','Brian McCardie','Gilly Gilchrist','Jason Flemyng','Ewan Stewart','David Hayman','Shirley Henderson','John Murtagh'],
screenplay:['Alan Sharp'],
production:['Richard Jackson'],
music:['Carter Burwell'],
camera:['Karl Walter Lindenlaub'],
cut:['Peter Honess'],
sound:['Richard King','Adam Jenkins','David John'],
scenography:['Assheton Gorton'],
masks:['Morag Ross'],
costumes:['Sandy Powell']},
{title:'Robin Hood: Prince of Thieves',
titleCZ:'Robin Hood: Král zbojníků',
year:1991,
runtime:'Alternativní 137 min',
countries:['USA'],
genres:['Action','Adventure','Drama','History','Romance'],
director:['Kevin Reynolds'],
actors:['Kevin Costner','Morgan Freeman','Mary Elizabeth Mastrantonio','Christian Slater','Alan Rickman','Geraldine McEwan','Michael McShane','Brian Blessed','Michael Wincott','Nick Brimble','Daniel Newman','Walter Sparrow','Howard Lew Lewis','Sean Connery','Jack Wild','David Bowles','Merelina Kendall','Pat Roach','John H. Francis','Christopher Adamson','John Hallam','Imogen Bain','Derek Deadman','Jimmy Gardner','Richard Strange','Barry Stanton','Larry Klein','John Tordoff','Cecily Hobbs','Fred Wood','Douglas Blackwell','Harold Innocent','Alexander Hall','Marc Zuber','Bobby Parr'],
screenplay:['Pen Densham','John Watson'],
production:['Kevin Costner','Pen Densham','Richard Barton Lewis','John Watson','Sarah Radclyffe'],
music:['Michael Kamen'],
camera:['Douglas Milsome'],
cut:['Peter Boyle'],
sound:['Paul Massey','Otto Snel','Doug Hemphill','Anna Behlmer','Chris Munro'],
scenography:['John Graysmark','Peter Young'],
masks:['Paul Engelen','Lynda Armstrong','Daniel Parker'],
costumes:['John Bloomfield']},
{title:'Romeo + Juliet',
titleCZ:'Romeo a Julie',
year:1996,
runtime:120,
countries:['USA'],
genres:['Romance','Drama'],
director:['Baz Luhrmann'],
actors:['Leonardo DiCaprio','Claire Danes','Zak Orth','Jamie Kennedy','Dash Mihok','John Leguizamo','Paul Sorvino','Brian Dennehy','Vondie Curtis-Hall','Paul Rudd','Jesse Bradford','M. Emmet Walsh','Diane Venora','Miriam Margolyes','Pete Postlethwaite','Harold Perrineau','Harriet Sansom Harris','Vincent Laresca','Christina Pickles','Mario Cimarro','Farnesio de Bernal','Edwina Moore','Michael Corbett','Jorge Abraham','Ricardo Barona','Paco Morayta','Pedro Altamirano','Carlos Manzo'],
screenplay:['Baz Luhrmann','Craig Pearce','William Shakespeare'],
production:['Baz Luhrmann','Gabriella Martinelli'],
music:['Craig Armstrong'],
camera:['Donald McAlpine'],
cut:['Jill Bilcock'],
sound:['Roger Savage','Michael Semanick','Rob Young'],
scenography:['Catherine Martin'],
masks:['Aldo Signoretti'],
costumes:['Kym Barrett']},
{title:'Ronin',
titleCZ:'Ronin',
year:1998,
runtime:122,
countries:['UK','France','USA'],
genres:['Action','Crime','Thriller','Drama'],
director:['John Frankenheimer'],
actors:['Robert De Niro','Jean Reno','Natascha McElhone','Stellan Skarsgård','Sean Bean','Skipp Sudduth','Michael Lonsdale','Jan Tříska','Jonathan Pryce','Ron Perkins','Féodor Atkine','Katarina Witt','Daniel Breton','Amidou','Tolsty','Lionel Vitrant','Vincent Schmitt','Léopoldine Serre','Julia Maraval','Laurent Spielvogel','Steve Suissa','Katia Tchenko','Lilly-Fleur Pointeaux','Dimitrij Rafalský','Pierre Forest','Nader Boussandel'],
screenplay:['J.D. Zeik','David Mamet'],
production:['Frank Mancuso Jr.'],
music:['Ilja David Cmíral'],
camera:['Robert Fraisse'],
cut:['Antony Gibbs'],
sound:['Rick Alexander'],
scenography:['Michael Z. Hanan'],
costumes:['May Routh']},
{title:'Red Sparrow',
titleCZ:'Rudá volavka',
year:2018,
runtime:140,
countries:['USA'],
genres:['Drama','Thriller'],
director:['Francis Lawrence'],
actors:['Jennifer Lawrence','Joel Edgerton','Matthias Schoenaerts','Jeremy Irons','Charlotte Rampling','Ciarán Hinds','Mary-Louise Parker',"Nicole O'Neill",'Sergej Polunin','Joely Richardson','Douglas Hodge','Thekla Reuten','Joel de la Fuente','Júlia Ubrankovics','Sakina Jaffrey','Sergej Onopko','Kristof Konrad','Makar Zaporožskij','Sasha Frolova','Endre Szilvási','Judit Rezes','Kata Pálfi','Zsolt Vicei','Andrea Takáts','Bálint Adorjáni','Zsolt Anger','Judit Viktor','George Mendel','Sebastian Hülk','Martin Müller','Victoria Hauer','Lauren Glazier','Attila Árpa','Dávid Miller','Alex Klaus','Louis Hofmann'],
basedOn:['Jason Matthews'],
screenplay:['Justin Haythe'],
production:['Peter Chernin','David Ready','Jenno Topping','Steven Zaillian'],
music:['James Newton Howard'],
camera:['Jo Willems'],
cut:['Alan Edward Bell'],
sound:['Mac Ruth'],
scenography:['Maria Djurkovic'],
masks:['David LeRoy Anderson',"Conor O'Sullivan",'Luisa Abel'],
costumes:['Trish Summerville']},
{title:'Chain Reaction',
titleCZ:'Řetězová reakce',
year:1996,
runtime:102,
countries:['USA'],
genres:['Action','Thriller','Drama'],
director:['Andrew Davis'],
actors:['Keanu Reeves','Morgan Freeman','Rachel Weisz','Fred Ward','Kevin Dunn','Brian Cox','Joanna Cassidy','Tzi Ma','Margaret Travolta','Danny Goldring','Michael Shannon','Neil Flynn','Chelcie Ross','David Pasquesi','Rich Komenich','Godfrey','Krzysztof Pieczyński','Ron Dean','Nicholas Kusenko','Joseph F. Kosala','Jacqueline G. Arthur','Nathan Davis','Jim Ortlieb','Gene Barge','Will Zahrn','Allen Hamilton','Eddie Bo Smith Jr.','Johnny Lee Davenport','Scott Benjaminson','James Sie','Julie Pearl','Cathy Herd','Randall Arney','Daniel H. Friedman','Ann Whitney','Mark Morettini','Larry Nazimek'],
screenplay:['J.F. Lawton','Michael Bortman'],
production:['Richard D. Zanuck','Andrew Davis','Arne Schmidt'],
music:['Jerry Goldsmith'],
camera:['Frank Tidy'],
cut:['Don Brochu','Dov Hoenig','Arthur Schmidt','Mark Stevens'],
sound:['Randy Thom','Bob Beemer','John A. Larsen','David E. Stone'],
scenography:['Maher Ahmad','Gene Serdena'],
masks:['Dominic Mango'],
costumes:['Jodie Lynn Tillen']},
{title:'Woman of Rome',
titleCZ:'Římanka',
year:1954,
runtime:92,
countries:['Italy','France'],
genres:['Drama'],
director:['Luigi Zampa'],
actors:['Gina Lollobrigida','Daniel Gélin','Franco Fabrizi','Raymond Pellegrin','Pina Piovani','Xenia Valderi','Riccardo Garrone','Gustavo Giorgi','Renato Tontini','Aldo Vasco','Ada Colangeli','Gino Buzzanca','Giuseppe Addobbati','Giovanni Di Benedetto'],
basedOn:['Alberto Moravia'],
screenplay:['Luigi Zampa','Alberto Moravia','Ennio Flaiano','Giorgio Bassani'],
production:['Carlo Ponti','Dino De Laurentiis'],
music:['Franco Mannino','Enzo Masetti'],
camera:['Enzo Serafin'],
cut:['Eraldo Da Roma'],
scenography:['Flavio Mogherini'],
costumes:['Gaia Romanini']},
{title:'Madonna: Truth or Dare',
titleCZ:'S Madonnou v posteli',
year:1991,
runtime:114,
countries:['USA'],
genres:['Music','Comedy','Documentary'],
director:['Alek Keshishian'],
actors:['Madonna','Olivia Newton-John','Mandy Patinkin','Al Pacino','Matt Dillon','Kevin Costner','Warren Beatty','Antonio Banderas','Pedro Almodóvar','Alan Wilder','Donna DeLory','Carlton Wilborn','Lionel Richie','Jack Larson','Niki Harris','Christopher Ciccone'],
production:['Steve Golin','Gregg Fienberg'],
cut:['Barry Alexander Brown'],
sound:['Rick Ash']},
{title:'Home Alone 2: Lost in New York',
titleCZ:'Sám doma 2: Ztracen v New Yorku',
year:1992,
runtime:115,
countries:['USA'],
genres:['Family','Comedy','Adventure'],
director:['Chris Columbus'],
actors:['Macaulay Culkin','Joe Pesci','Daniel Stern',"Catherine O'Hara",'John Heard','Devin Ratray','Kieran Culkin','Tim Curry','Brenda Fricker','Eddie Bracken','Dana Ivey','Rob Schneider','Rip Taylor','Ally Sheedy','Ron Canada','Donald Trump','Eden Riegel','Ralph Foody','Clare Hoak','Jimmie Walker','Chris Columbus','Senta Moses','Abdoulaye NGom','Eleanor Columbus','Gerry Bamman','Hillary Wolf','Michael C. Maronna','Maureen Elisabeth Shay','Terrie Snell','Jedidiah Cohen','Anna Slotky','Diana Rein','Jaye P. Morgan','Leigh Zimmerman','Sandra Macat','Joe Liss','Teri McEvoy','Daniel Dassin','Clarke Devereux','William Dambra','Venessia Valentino','Andre Lachaumette','Rod Sell','Harry Hutchinson','Cedric Young','Mark Morettini','Warren Rice','Michael Hansen','Peter Pantaleo','Donna Black','Monica Devereux','Mario Todisco','Anthony Cannata','Karen Giordano','Michael Goldfinger','Fran McGee','Leonard Tepper','Kevin Thomas','Al Cerullo','Laurence S. Chess','Crazy Legs'],
screenplay:['John Hughes'],
production:['John Hughes'],
music:['John Williams'],
camera:['Julio Macat'],
cut:['Raja Gosnell'],
sound:['Wylie Stateman','Chris Carpenter','Kevin E. Carpenter','Tony Araki','Rick Hart','Tim Webb'],
scenography:['Sandy Veneziano','Marvin March','Gary A. Lee'],
masks:['Kenny Myers','Linda Rizzuto','Elvia Mante','Linda Melazzo'],
costumes:['Jay Hurley']},
{title:'Loners',
titleCZ:'Samotáři',
year:2000,
runtime:109,
countries:['Czechia','Slovenia'],
genres:['Comedy','Drama'],
director:['David Ondříček'],
actors:['Labina Mitevska','Jitka Schneiderová','Saša Rašilov nejml.','Jiří Macháček','Ivan Trojan','Mikuláš Křen','Dana Sedláková','Hana Maciuchová','František Němec','Emma Černá','Tatiana Dyková','Zdeněk Suchý','David Matásek','Petr Kasnar','Pavla Drtinová','Petr Janiš','Robert Vlček','Ota Filip','Jana Gýrová','Helena Brabcová','Jan Nemejovský','Zdeněk Dvořáček','Jan P. Muchow','Kryštof Michal','Jaroslav Růžička','Jakub Kohák'],
screenplay:['Petr Zelenka'],
production:['David Ondříček'],
music:['Jan P. Muchow'],
camera:['Richard Řeřicha'],
cut:['Michal Lánský'],
sound:['Pavel Rejholec','Jakub Čech'],
scenography:['Radek Hanák'],
masks:['Jiří Farkaš','Eva Ungrová-Malíková','František Příhoda'],
costumes:['Kateřina Coufalíková']},
{title:'Little Witch on a Broomstick',
titleCZ:'Saxána a Lexikon kouzel',
year:2011,
runtime:90,
countries:['Czechia'],
genres:['Fairytale'],
director:['Václav Vorlíček'],
actors:['Petra Černocká','Helena Nováčková','Jan Hrušínský','Jiřina Bohdalová','Petr Nárožný','Josef Somr','Jiří Lábus','Naďa Konvalinková','Jaromír Dulava','Ota Jirák','Markéta Hrubešová','Jaroslav Kepka','Bronislav Poloczek','Uršula Kluková','Jaromír Nosek','Jan Kuželka','Oldřich Hrůza','Petr Kocourek','Alice Šnirychová','Štěpán Krtička','Ladislav Cigánek','Dalimil Klapka','Libor Terš','Jakub Saic','Otmar Brancuzský','Tomáš Racek','Karel Gult','Daniel Rous','Jaromír Meduna','Eva Spoustová','Johana Krtičková','Oldřich Vlach','Jan Dolanský','Václav Vorlíček','Ivo Halík','Petr Puha','Dominik Rataj'],
screenplay:['Václav Vorlíček','Miloš Macourek','Vlastimil Mistrík'],
production:['Jaroslav Nietsch','Christian Becker'],
music:['Radim Hladík st.'],
camera:['Petr Polák','Antonín Weiser'],
cut:['Dalibor Lipský'],
scenography:['Martin Malý'],
masks:['Tomáš Kuchta'],
costumes:['Ivana Řezáčová']},
{title:'Seven Years in Tibet',
titleCZ:'Sedm let v Tibetu',
year:1997,
runtime:129,
countries:['USA'],
genres:['Drama','Adventure','Biographic','History'],
director:['Jean-Jacques Annaud'],
actors:['Brad Pitt','David Thewlis','BD Wong','Mako','Danny Denzongpa','Victor Wong','Ingeborga Dapkunajtě','Jamyang Jamtsho Wangchuk','Lhakpa Tsamchoe','Jetsun Pema','Ama Ashe Dongtse','Sonam Wangchuk','Dorjee Tsering','Ngawang Chojor','Ric Young','Duncan Fraser','Benedick Blythe','Tom Raudaschl','Wolfgang Tonninger','Chemchok','Tsering Wangdue','Yama Ngudup Cheshatsang','Kalsang Dhundop Lungtok','Sonam Bidhartsang','Lama Champa Tsondu','Geshe Lobsang Nyma','Geshe Yeshi Tsultrim','Lama Champa Chandu','Pemba Norbu Sherpa','Karma Apo-Tsang','Ngawang Tenzingyatso','Choeden Tsering','Lama Jampa Lekshe','Lama Thupten Nugdup','Daniel Tedeschi','Gerardo Ebert','Sebastian Zevalia','Philipp Kriechbaum','Victor A. Haddox'],
basedOn:['Heinrich Harrer'],
screenplay:['Becky Johnston'],
production:['Jean-Jacques Annaud','John H. Williams','Iain Smith'],
music:['John Williams'],
camera:['Robert Fraisse'],
cut:['Noëlle Boisson'],
sound:['Tim Cavagin'],
scenography:['Hoang Thanh At','Jim Erickson'],
masks:['Christine Blundell','Paul Engelen','Jean Ann Black','Alberto Moccia'],
costumes:['Enrico Sabbatini']},
{title:'Common Sense',
titleCZ:'Selský rozum',
year:2017,
runtime:73,
countries:['Czechia'],
genres:['Documentary'],
director:['Vít Janeček','Zuzana Piussi'],
actors:['Bohumír Rada','Jakub Patočka','Zuzana Vlasatá','Andrej Babiš','Taňa Králová','František Tomášek','Jan Rambousek','Josef Středula','Jana Moravcová','Jan Boček'],
production:['Petr Kubica','Vít Janeček','Zuzana Piussi'],
camera:['Vít Janeček','Zuzana Piussi'],
cut:['Vít Janeček','Zuzana Piussi'],
sound:['Luka Šuto','Tomáš Krchlík']},
{title:'Sex and the City',
titleCZ:'Sex ve městě',
year:2008,
runtime:139,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Michael Patrick King'],
actors:['Sarah Jessica Parker','Kim Cattrall','Kristin Davis','Cynthia Nixon','Chris Noth','David Eigenberg','Evan Handler','Jason Lewis','Mario Cantone','Lynn Cohen','Willie Garson','Jennifer Hudson','Candice Bergen','Joanna Gleason','Kerry Bishé','Amanda Setton','Daphne Rubin-Vega','Kim Shaw','Bridget Regan','Dreama Walker','Damian Young','Malcolm Gets','April McCullough','Annaleigh Ashford','Gilles Marini','Lena Hall','André Leon Talley','Veanne Cox','Suzanne Cryer','Philipp Christopher','Van Hughes','Bridget Everett','Henry Strozier','Julie Halston','Rick Aiello','Alexandra Fong','Parker Fong','Peter Y. Kim','Charles Martins','Ricardo Molina','Joshua Henry','Rogelio T. Ramos','Sara Gettelfinger','Lisa Kron'],
basedOn:['Candace Bushnell'],
screenplay:['Michael Patrick King'],
production:['Sarah Jessica Parker','Michael Patrick King','Darren Star','John P. Melfi'],
music:['Aaron Zigman','Dean Landon'],
camera:['John Thomas'],
cut:['Michael Berenbaum'],
sound:['Michael Keller','Odin Benitez'],
scenography:['Jeremy Conway','Lydia Marks'],
masks:['Valerie Gladstone-Appel','Judy Chin','Colleen LaBaff'],
costumes:['Patricia Field']},
{title:'Sex and the City 2',
titleCZ:'Sex ve městě 2',
year:2010,
runtime:140,
countries:['USA'],
genres:['Comedy','Drama','Romance'],
director:['Michael Patrick King'],
actors:['Sarah Jessica Parker','Kim Cattrall','Kristin Davis','Cynthia Nixon','Chris Noth','David Eigenberg','Evan Handler','Jason Lewis','Willie Garson','Mario Cantone','Liza Minnelli','Lynn Cohen','Alice Eve','Max Ryan','Omid Djalili','Art Malik','Raza Jaffrey','John Corbett','Penélope Cruz','Miley Cyrus','Waleed Zuaiter','Natalie Gal','George Aloi','Ron White','Kevin Brown','Michael T. Weiss','Andrew Rannells','Marjan Neshat','Jennifer Ferrin','Tim Gunn','Matthew Risch','Melanie Chandra','Neal Bledsoe','David Alan Basche','Alexander Wraith','Fumi Desalu-Vold','Noah Mills','Selenis Leyva','Vincent De Paul',"Dhaffer L'Abidine",'Van Hughes','Tetto Wada','Dola Rashad','Norm Lewis',"Kelli O'Hara",'Nicole Shalhoub','Piter Marek','Jimmy Palumbo','Alexandra Fong','Parker Fong','Kyle Dean Massey','Devon Diep','Arash Mokhtar','Maria Michaels','Chriselle Almeida','Nick Adams','Anoush NeVart','Shawlini Manjunath-Holbrook'],
basedOn:['Candace Bushnell'],
screenplay:['Michael Patrick King'],
production:['Michael Patrick King','Sarah Jessica Parker','Darren Star','John P. Melfi'],
music:['Aaron Zigman'],
camera:['John Thomas'],
cut:['Michael Berenbaum'],
sound:['Michael Keller','Odin Benitez','Sean Byrne'],
scenography:['Jeremy Conway','Lee Sandales','Miguel López-Castillo','Lydia Marks'],
masks:['Judy Chin','Nicki Ledermann','Björn Rehbein'],
costumes:['Patricia Field','Danny Santiago','Jessica Replansky','Molly Rogers','Jacqueline Demeterio']},
{title:'The Rebound',
titleCZ:'Sexy 40',
year:2009,
runtime:91,
countries:['USA'],
genres:['Comedy','Romance'],
director:['Bart Freundlich'],
actors:['Catherine Zeta-Jones','Justin Bartha','Art Garfunkel','Joanna Gleason','Lynn Whitfield','Kelly Gould','Andrew Cherry','Kate Jennings Grant','Rob Kerkovich','John Schneider','Sam Robards','Alice Playten','Stephanie Szostak','Jake Cherry','Nick Poltoranin','James P. Anderson','Quarles Antoine','Peter Francis James','Fatima Ptacek','Samantha Ivers','Jennifer Butler','Saadet Aksoy','Danny Boushebel','Michael Chernus','Lisamarie Costabile','Megan Byrne','Gregory Marcel','Zabryna Guevara','Thomas Middleditch','Skai Jackson','Veanne Cox','Tom Riis Farrell','Joe Mancini','Dan Ziskie','Saidah Arrika Ekulona','Carter Roy','Elliot Villar','Steve Park','Danielle McKee','Jon Norman Schneider','Heidi Blickenstaff','Helen Coxe','Jordan Carlos','Lauren Blumenfeld','Edward M. Kelahan','William Broderick','Mitchell Greenberg','Eliza Callahan','Rehan Yadav','Carmen M. Herlihy','Adam Grupper'],
screenplay:['Bart Freundlich'],
production:['Mark Gill','Robert Katz','Tim Perell','Bart Freundlich'],
music:['Clint Mansell'],
camera:['Jonathan Freeman'],
cut:['Christopher Tellefsen'],
sound:['Robert Fernandez',"T.J. O'Mara",'Kim Maitland'],
scenography:['Ford Wheeler','Carolyn Cartwright'],
masks:['Julie Teel'],
costumes:['Melissa Toth']},
{title:'Meet Joe Black',
titleCZ:'Seznamte se, Joe Black',
year:1998,
runtime:178,
countries:['USA'],
genres:['Romance','Drama','Fantasy','Mystery'],
director:['Martin Brest'],
actors:['Brad Pitt','Anthony Hopkins','Claire Forlani','Jake Weber','Marcia Gay Harden','Jeffrey Tambor','Richard Clarke','Marylouise Burke','June Squibb','Stephen Adly Guirgis','Leo Marks','Gene Canfield','Jeffrey Corazzini'],
screenplay:['Bo Goldman','Kevin Wade','Jeff Reno','Ron Osborn','Maxwell Anderson'],
production:['Celia D. Costas','Martin Brest'],
music:['Thomas Newman'],
camera:['Emmanuel Lubezki'],
cut:['Joe Hutshing','Michael Tronick'],
sound:['Ron Bartlett'],
scenography:['Dante Ferretti'],
masks:['Jean Ann Black','Tricia Heine','Jerry DeCarlo'],
costumes:['Aude Bronson-Howard','David C. Robinson']},
{title:'Sin City',
titleCZ:'Sin City - město hříchu',
year:2005,
runtime:'Alternativní 119 min',
countries:['USA'],
genres:['Action','Crime','Thriller'],
director:['Robert Rodriguez','Frank Miller','Quentin Tarantino'],
actors:['Jessica Alba','Bruce Willis','Alexis Bledel','Powers Boothe','Mickey Rourke','Clive Owen','Devon Aoki','Rosario Dawson','Elijah Wood','Benicio Del Toro','Jude Ciccolella','Michael Clarke Duncan','Rick Gomez','Carla Gugino','Josh Hartnett','Rutger Hauer','Nicky Katt','Jaime King','Michael Madsen','Frank Miller','Brittany Murphy','Marley Shelton','Nick Stahl','Makenzie Vega','Arie Verveen','Tommy Flanagan','Penny Drake','Ethan Maniquis','Emmy Robbin','Amanda Phillips','Lauren-Elaine Powell','Nick Offerman','Tommy Nix','Robert Rodriguez','Jason Douglas','Randal Reeder','David Hickey','Charissa Allen','Clark Middleton','Ken Thomas','Texas Presley','Marco Perella','Paul T. Taylor','Lisa Marie Newmyer','Kelley Robins'],
basedOn:['Frank Miller'],
screenplay:['Robert Rodriguez','Frank Miller'],
production:['Elizabeth Avellan'],
music:['Robert Rodriguez','John Debney','Graeme Revell'],
camera:['Robert Rodriguez'],
cut:['Robert Rodriguez'],
sound:['Sergio Reyes','Craig Henighan'],
scenography:['Jeanette Scott','Jeanette Scott'],
masks:['Scott Patton','Gerald Quist','Chelsey Fiske','Howard Berger','Greg Nicotero','Christopher Allen Nelson','Elisabeth Dietrich']},
{title:'Glass',
titleCZ:'Skleněný',
year:2019,
runtime:129,
countries:['USA'],
genres:['Thriller','Drama','Sci-Fi'],
director:['M. Night Shyamalan'],
actors:['James McAvoy','Bruce Willis','Samuel L. Jackson','Anya Taylor-Joy','Sarah Paulson','Spencer Treat Clark','Charlayne Woodard','Luke Kirby','Adam David Thompson','M. Night Shyamalan','Jane Park Smith','Marisa Brown','Shayna Ryan','Veronica Sixtos','Emma Hong','Brian Donahue','Tobias Segal','Donnamarie Davis','Nina Wisner','Kyli Zion','William Turner','Estelle Girard Parks','Rob Yang','Jesse Bradley'],
screenplay:['M. Night Shyamalan'],
production:['M. Night Shyamalan','Jason Blum','Marc Bienstock','Ashwin Rajan'],
music:['West Dylan Thordson'],
camera:['Mike Gioulakis'],
cut:['Luke Ciarrocchi','Blu Murray'],
sound:['Skip Lievsay','Sean Garnhart'],
scenography:['Chris Trujillo','Olivia Peebles','Jesse Rosenthal'],
masks:['Camille Friend'],
costumes:['Paco Delgado']},
{title:'Larks on a String',
titleCZ:'Skřivánci na niti',
year:1969,
runtime:95,
countries:['Czechoslovakia'],
genres:['Comedy','Parable'],
director:['Jiří Menzel'],
actors:['Rudolf Hrušínský','Vlastimil Brodský','Václav Neckář','Jitka Zelenohorská','Jaroslav Satoranský','Vladimír Šmeral','Ferdinand Krůta','František Řehák','Leoš Suchařípa','Vladimír Ptáček','Eugen Jegorov','Naďa Urbánková','Věra Křesadlová','Věra Ferbasová','Jiřina Štěpničková','Míla Myslíková','Tereza Bariová','Karel Mareš','Ladislav Šimek','Zdeněk Svěrák','Gustav Oplustil','Vlasta Jelínková','Věra Galatíková','Zora Jiráková','Jiřina Třebická','Stella Zázvorková','Otakar Brousek st.','Jan Teplý st.','Eva Blažková','Zdena Burdová','Hana Talpová','Eva Rubínová','Jindřiška Gabriela Preissová','Miroslav Saic','Karel Hovorka st.','Alois Vachek','Jan Vala','Jiří Kasík','Rudolf Kalina','Antonín Gondolán','František Gondolán','Jiří Gondolán','Vojtěch Gondolán','Ondřej Gondolán','Miloš Kohout','Jiří Menzel','Oldřich Janovský','Bořivoj Fiala','Bohumil Koška','Miloslav Balcar','Alena Frimlová','Rudolf Pešta','Jarmila Gybasová','Vladimír Hrabánek','Antonín Samler','Eva Vejlová','Helena Velenovská','Marie Benetková','Ivana Horká','Eva Podzimková','Jitka Molavcová'],
basedOn:['Bohumil Hrabal'],
screenplay:['Bohumil Hrabal','Jiří Menzel'],
music:['Jiří Šust'],
camera:['Jaromír Šofr'],
cut:['Jiřina Lukešová'],
sound:['Jiří Pavlík'],
scenography:['Oldřich Bosák'],
masks:['Josef Lojík'],
costumes:['Dagmar Krausová']},
{title:'Death Becomes Her',
titleCZ:'Smrt jí sluší',
year:1992,
runtime:99,
countries:['USA'],
genres:['Fantasy','Comedy','Horror'],
director:['Robert Zemeckis'],
actors:['Meryl Streep','Bruce Willis','Goldie Hawn','Isabella Rossellini','Ian Ogilvy','Adam Storke','Nancy Fish','Michelle Johnson','John Ingle','Debra Jo Rupp','Jonathan Silverman','Michael A. Nickles','John Enos III','Fabio','Kenneth Hughes','Sydney Pollack','Catherine Bell','Joel Beeson','Mary Ellen Trainor','Mimi Kennedy','Paulo Tocha','Clement von Franckenstein','Carol Ann Susi','Phillip Irwin Cooper','Bob Swain','Stéphanie Anderson','Bonnie Cahoon','Michael Higgins','Alaina Reed-Hall','Susan Kellermann','William Frankfather','Jim Jansen','Ernest Harada','Colleen Morris','Danny Lee Clark','Jean St. James','Michael Mills','Thomas Murphy',"Michael O'Hearn",'Anya Longwell'],
screenplay:['David Koepp','Martin Donovan'],
production:['Robert Zemeckis','Steve Starkey'],
music:['Alan Silvestri'],
camera:['Dean Cundey'],
cut:['Arthur Schmidt'],
sound:["Andy D'Addario",'Rick Alexander'],
scenography:['Rick Carter','Jackie Carr'],
masks:['Lance Anderson','Kevin Haney','Michael Mills','Shirley Crawford','Scott Oshita','Dick Smith'],
costumes:['Joanna Johnston']},
{title:'Forbidden Dreams',
titleCZ:'Smrt krásných srnců',
year:1986,
runtime:91,
countries:['Czechoslovakia'],
genres:['Drama','Comedy'],
director:['Karel Kachyňa'],
actors:['Karel Heřmánek','Rudolf Hrušínský','Jiří Krampol','Lubor Tokoš','Marta Vančurová','Dana Vlková','Miroslav Walter','Ladislav Potměšil','Oldřich Vlach','Milan Riehs','Jiří Strach','Jan Jirásek','Jan Přeučil','Ladislav Trojan','Ivan Vyskočil','Zdeněk Dítě','Alois Švehlík','Bronislav Poloczek','Petr Pelzer','Karel Smrž','Jana Synková','Zuzana Geislerová','Jana Paulová','Valerie Čižmárová','Gabriela Wilhelmová','Jana Marková','Jiřina Jelenská','Blanka Lormanová','Viktor Maurer','Stanislav Zindulka','Vladimír Pospíšil','Miloslav Štibich','Josef Vondráček','Petr Skarke','Jindřich Hinke','Roman Skamene','Stanislav Tříska','Jiří Knot','Michal Herz','Vladimír Hrabánek','Eva Kelemenová-Ziliziová','Alena Mihulová','Bohumila Dolejšová','Romana Kvapilíková-Julinová','Eva Asterová','Marta Krampolová','Daniela Bakerová','Eugen Jegorov','Arnošt Proschek','Milan Pěkný','Miroslav Dubský','Tomáš Jančařík','Miroslav Krejča','Petr Svárovský','Ludvík Pozník','Jan Kotva','Jan Krafka','Vít Pešina','Miloslav Homola','Jan Hájek','Jindra Kvardová','Jan Polívka','František Mikeš','Zdeněk Novotný','Karel Vejvoda','Eva Weissová','Luděk Munzar'],
basedOn:['Ota Pavel'],
screenplay:['Karel Kachyňa','Dušan Hamšík'],
music:['Luboš Fišer'],
camera:['Vladimír Smutný'],
cut:['Jiří Brožek'],
sound:['Pavel Jelínek'],
scenography:['Karel Lier'],
masks:['František Čížek'],
costumes:['Irena Greifová']},
{title:'Snowdrops and Aces',
titleCZ:'Sněženky a machři',
year:1982,
runtime:82,
countries:['Czechoslovakia'],
genres:['Comedy'],
director:['Karel Smyczek'],
actors:['Václav Kopta','Michal Suchánek','Jan Antonín Duchoslav','Radoslav Brzobohatý','Veronika Freimanová','Eva Jeníčková','Valentina Thielová','Pavel Marek','Boris Halmi','Daniel Šedivák','Christian Thuri','Filip Sirový','Michal Petrov','Zdeněk Straka','Jan Valenta','Karel Kovář','Filip Smoljak','Jiřina Jelenská','Karel Smyczek','Ilona Svobodová'],
screenplay:['Radek John','Ivo Pelant'],
music:['Zdeněk John'],
camera:['Richard Valenta'],
cut:['Jiří Brožek'],
sound:['Jiří Moudrý'],
scenography:['Boris Halmi'],
masks:['Jiří Hurych','Pavel Minichbauer'],
costumes:['Kristina Novotná']},
{title:'I Dreamed of Africa',
titleCZ:'Snila jsem o Africe',
year:2000,
runtime:110,
countries:['USA'],
genres:['Drama','Adventure','Biographic'],
director:['Hugh Hudson'],
actors:['Kim Basinger','Vincent Perez','Liam Aiken','Eva Marie Saint','Daniel Craig','Patrick Lyster','Valeria Cavalli','John Carson','Lance Reddick','Nick Boraine','Giselda Volodi','Ian Roberts','Garrett Strommen','Winston Ntshona','Federico Scribani','Connie Chiume','Frances Nacman','Shannon Esra'],
screenplay:['Susan Shilliday','Paula Milne'],
production:['Stanley R. Jaffe','Allyn Stewart'],
music:['Maurice Jarre'],
camera:['Bernard Lutic'],
cut:['Scott Thomas'],
sound:['Mark Taylor'],
scenography:['Andrew Sanders'],
masks:['Alessandro Durante'],
costumes:['Shirley Russell']},
{title:'The Salvation',
titleCZ:'Spása',
year:2014,
runtime:92,
countries:['Denmark','UK','South Africa','Sweden','Belgium'],
genres:['Western','Drama'],
director:['Kristian Levring'],
actors:['Mads Mikkelsen','Eva Green','Jeffrey Dean Morgan','Eric Cantona','Mikael Persbrandt','Douglas Henshall','Michael Raymond-James','Jonathan Pryce','Alexander Arnold','Nanna Øland Fabricius','Langley Kirkwood','Robert Hobbs','Sean Cameron Michael','Nick Boraine','Vanessa Cooke','David James','Carel Nel','Anthony Oseyemi','Grant Swanby','Daniel Janks','Toke Lars Bjarke'],
screenplay:['Anders Thomas Jensen','Kristian Levring'],
production:['Sisse Graum Jørgensen'],
music:['Kasper Winding'],
camera:['Jens Schlosser'],
cut:['Pernille Bech Christensen'],
sound:['Alastair Sirkett'],
scenography:['Merissa Lombardo','Jørgen Munk','Anneke Botha'],
masks:['Ann Elizabeth Bartels','Morten Jacobsen'],
costumes:['Diana Cilliers']},
{title:'The Specialists',
titleCZ:'Specialista',
year:1969,
runtime:104,
countries:['Italy','France','Germany'],
genres:['Western'],
director:['Sergio Corbucci'],
actors:['Johnny Hallyday','Mario Adorf','Françoise Fabian','Gastone Moschin','Riccardo Pizzuti','Gino Pernice','Ettore Arena','Serge Marquand','Mario Castellani','Alberigo Donadeo','Pietro Ceccarelli','Mimmo Poli','Sylvie Fennec','Valentino Macchi','Renato Pinciroli','Angela Luce','Brizio Montinaro','Franco Castellani','Franco Marletta','Lucio Rosato','Riccardo Domenici'],
screenplay:['Sergio Corbucci'],
music:['Angelo Francesco Lavagnino'],
camera:['Dario Di Palma'],
sound:['Franco Bassi'],
scenography:['Riccardo Domenici'],
costumes:['Enrico Job']},
{title:'Old-Timers',
titleCZ:'Staříci',
year:2019,
runtime:92,
countries:['Czechia','Slovakia'],
genres:['Drama','Road movie'],
director:['Martin Dušek','Ondřej Provazník'],
actors:['Jiří Schmitzer','Ladislav Mrkvička','Dušan Kaprálik','Milena Steinmasslová','Michal Suchánek','Pavel Batěk','Marika Procházková','Matěj Nechvátal','Karel Jirák','Jakub Krejča','Přemysl Bureš','Petr Fridrich','Greta Stocklassa','Hana Strnadová','Milan Gunár','Hana Malaníková','Václav Veselý'],
screenplay:['Martin Dušek','Ondřej Provazník'],
production:['Jiří Konečný'],
music:['Matouš Hejl','Miroslav Srnka'],
camera:['Lukáš Milota'],
cut:['Janka Vlčková'],
sound:['Václav Flegl','Petr Kapeller','Petr Stuchlík'],
scenography:['Antonín Šilar'],
masks:['Eva Schwarzová'],
costumes:['Anna Hrušková']},
{title:'The Stepford Wives',
titleCZ:'Stepfordské paničky',
year:1975,
runtime:115,
countries:['USA'],
genres:['Horror','Thriller','Mystery','Sci-Fi'],
director:['Bryan Forbes'],
actors:['Katharine Ross','Paula Prentiss','Peter Masterson','Nanette Newman','Tina Louise','William Prince',"Patrick O'Neal",'Carole Mallory','Josef Sommer','Mary Stuart Masterson','Kenneth McMillan','Dee Wallace','George Coe','John Aprea','Robert Fields','Carol Eve Rossen','Michael Higgins','Franklin Cover','Paula Trueman','Tom Spratley'],
basedOn:['Ira Levin'],
screenplay:['William Goldman'],
production:['Edgar J. Scherick'],
music:['Michael Small'],
camera:['Owen Roizman'],
cut:['Timothy Gee'],
sound:['Dick Vorisek'],
scenography:['Gene Callahan'],
masks:['Enrico A. Cortese','Dick Smith'],
costumes:['Anna Hill Johnstone']},
{title:'Striptease',
titleCZ:'Striptýz',
year:1996,
runtime:115,
countries:['USA'],
genres:['Crime','Drama','Thriller','Comedy'],
director:['Andrew Bergman'],
actors:['Demi Moore','Burt Reynolds','Armand Assante','Ving Rhames','Robert Patrick','Paul Guilfoyle','Jerry Grayson','Rumer Willis','Robert Stanton','William Hill','Stuart Pankin','Dina Waters','Barbara Alyn Woods','Rena Riffel','Siobhan Fallon Hogan','Gary Basaraba','Antoni Corone','Frances Fisher','Gianni Russo','Steve Warren','Tammi Sutton','Eduardo Yáñez','José Zúñiga','Teddy Bergman','Keone Young','Brad Grunberg','Jerry Pacific','Pandora Peaks'],
basedOn:['Carl Hiaasen'],
screenplay:['Andrew Bergman'],
production:['Mike Lobell'],
music:['Howard Shore'],
camera:['Stephen Goldblatt'],
cut:['Anne V. Coates'],
sound:['Lee Dichter'],
scenography:['Mel Bourne'],
costumes:['Albert Wolsky']},
{title:'Stop! Or My Mom Will Shoot',
titleCZ:'Stůj, nebo maminka vystřelí!',
year:1992,
runtime:84,
countries:['USA'],
genres:['Action','Comedy'],
director:['Roger Spottiswoode'],
actors:['Sylvester Stallone','Estelle Getty','JoBeth Williams','Roger Rees','Gailard Sartain','John Wesley','Martin Ferrero','Al Fann','Ella Joyce','Dennis Burkley','Ving Rhames','Richard Schiff','Vanessa Angel','Marjean Holden','Dorian Gregory','Ernie Lively','J. Kenneth Campbell','Nicholas Sadler','Julia Montgomery','Patti Yasutake','Christopher Collins','Kimberley LaMarque','Roydon Clark','Joey DePinto','Manny Perry'],
screenplay:['William Osborne','William Davies','Blake Snyder'],
production:['Joe Medjuck','Ivan Reitman'],
music:['Alan Silvestri'],
camera:['Frank Tidy'],
cut:['Mark Conte','Lois Freeman-Fox'],
sound:['Dean A. Zupancic','Rick Ash'],
scenography:['Charles Rosen','Diane Yates','Donald J. Remacle'],
masks:['Christa Reusch','Gary Liddiard'],
costumes:['Marie France']},
{title:'Svatební cesta do Jiljí',
titleCZ:'Svatební cesta do Jiljí',
year:1983,
runtime:82,
countries:['Czechoslovakia'],
genres:['Comedy','Romance'],
director:['Hynek Bočan'],
actors:['Josef Abrhám','Libuše Šafránková','Josef Větrovec','Blažena Holišová','Jiří Kodet','Pavla Maršálková','Zdeněk Svěrák','Ladislav Smoljak','Jan Skopeček','Karel Augusta','Ladislav Krečmer','Václav Vydra nejml.','Eva Svobodová','Dana Balounová','Viktor Maurer','Vlastimil Bedrna','Ladislav Gerendáš','Hana Čížková','Pavel Marek','Zdeněk Dolanský','Jaroslav Kubeš'],
basedOn:['Miroslav Skála'],
screenplay:['Miroslav Skála'],
music:['Petr Skoumal'],
camera:['Jiří Tarantík'],
cut:['Ivana Kačírková'],
sound:['Adolf Böhm'],
scenography:['Bohumil Nový'],
masks:['Eva Vyplelová'],
costumes:['Svatava Sophová']},
{title:'Big Beat',
titleCZ:'Šakalí léta',
year:1993,
runtime:110,
countries:['Czechia'],
genres:['Musical','Comedy'],
director:['Jan Hřebejk'],
actors:['Martin Dejdar','Jakub Špalek','Josef Abrhám','Sylva Tománková','Jan Semotán','Jitka Asterová','Jiří Ornest','Jan Kačani','Pavel Janoušek','Saša Rašilov nejml.','Zdeněk Vencl','Václav Chalupa','Václav Jakoubek','Radek Holub','Anna Kreuzmannová','Raoul Schránil','Zuzana Michnová','Martina Dirgová','Petr Jarchovský','Gabriela Osvaldová','Jan Antonín Pacák','Josef Prouza','Linda Rybová','Petra Špalková','Jan Tobola','Milan Tomsa','Jiří Zelenka','Václav Koubek','Jan Hřebejk','Ivan Hlas','Jan Kalousek','Leona Machálková','Josef Oplt','Lída Nopová','Jiří Škorpík','Radek Balaš','Petr Franc','Lenka Krobotová','Aňa Geislerová','Jan Potměšil'],
basedOn:['Petr Šabach'],
screenplay:['Petr Jarchovský'],
production:['Jiří Ježek'],
music:['Ivan Hlas'],
camera:['Jan Malíř'],
cut:['Jan Mattlach'],
sound:['Marek Hart'],
scenography:['Zbyněk Hloch','Jan Tobola'],
masks:['Aleš Kocián'],
costumes:['Katarína Hollá']},
{title:'Šarlatán',
titleCZ:'Šarlatán',
year:2020,
runtime:118,
countries:['Czechia','Ireland','Poland','Slovakia'],
genres:['Biographic','Drama'],
director:['Agnieszka Holland'],
actors:['Ivan Trojan','Josef Trojan','Juraj Loj','Jaroslava Pokorná','Martin Myšička','Miroslav Hanuš','Jiří Černý','Tomáš Jeřábek','Jan Budař','Melika Yildiz','Martin Sitta','Jan Vlasák','Daniela Voráčková','František Trojan','Jana Oľhová','Kamil Švejda','Václav Kopta','Ivan Sochor','Marek Epstein','Jana Kvantiková','Philipp Schenker','Matěj Preisler','František Beleš','Barbora Milotová','Lukáš Novotný','Natálie Steklá','Matěj Šumbera','Jiří Rendl'],
screenplay:['Marek Epstein'],
production:['Šárka Cimbalová','Kevan Van Thompson'],
music:['Antoni Komasa-Łazarkiewicz'],
camera:['Martin Štrba'],
cut:['Pavel Hrdlička ml.'],
sound:['Radim Hladík ml.'],
scenography:['Milan Býček'],
costumes:['Katarína Štrbová Bieliková']},
{title:'Whisper',
titleCZ:'Šeptej',
year:1996,
runtime:84,
countries:['Czechia'],
genres:['Romance'],
director:['David Ondříček'],
actors:['Tatiana Dyková','Jan P. Muchow','Jan Čechtický','Kateřina Winterová','Petra Špalková','Zdeněk David','Zdeněk Suchý','Bořivoj Navrátil','Václav Mareš','Nikolaj Hejko','Petra Lustigová','David Ondříček','Jan Hřebejk','Lukáš Bech','Martin Myšička','Jan Španbauer','Rudolf Kubík','Antonín Brtoun','Bára Fišerová','Petr Macháček','Petr Hošek','Kateřina Coufalíková','Marek Najbrt','Dušan Vozáry'],
screenplay:['David Ondříček','Jan Novák','Tomáš Mašín'],
production:['Petr Oukropec','Pavel Strnad'],
music:['Jan P. Muchow'],
camera:['Alexander Šurkala'],
cut:['Petr Turyna'],
sound:['Jan Čeněk'],
scenography:['Tomáš Kuča'],
masks:['Václav Kunc','Martina Zeilmanová'],
costumes:['Kateřina Coufalíková']},
{title:'The Da Vinci Code',
titleCZ:'Šifra mistra Leonarda',
year:2006,
runtime:149,
countries:['USA','Malta','France','UK'],
genres:['Mystery','Thriller'],
director:['Ron Howard'],
actors:['Tom Hanks','Audrey Tautou','Ian McKellen','Jean Reno','Paul Bettany','Alfred Molina','Jürgen Prochnow','Jean-Yves Berteloot','Jean-Pierre Marielle','Seth Gabel','Denis Podalydès','David Saracino','Hugh Mitchell','Matthew Butler-Hart','Dan Brown','Agathe Natanson','Peter Pedrero','Garance Mazureck','Etienne Chicot','Tonio Descanvelle','Rita Davies','Xavier De Guillebon','David Bark-Jones','Marie-Françoise Audollent','Francesco Carnelutti','Paul Herbert','Yves Aubert',"Dhaffer L'Abidine",'Shane Zaza','Charlie Rose','Harry Taylor','Chris Wilson','Dan Tondowski','Roland Menou','David Bertrand','Norman Campbell Rees'],
basedOn:['Dan Brown'],
screenplay:['Akiva Goldsman'],
production:['Brian Grazer','John Calley'],
music:['Hans Zimmer'],
camera:['Salvatore Totino'],
cut:['Daniel P. Hanley','Mike Hill'],
sound:["Kevin O'Connell",'Ivan Sharrock','Greg P. Russell'],
scenography:['Allan Cameron','Richard Roberts'],
masks:['David White','Rossana Parker','Frances Hannon','Paul Gooch','Uxue Laguardia','Norma Webb','Josh Weston'],
costumes:['Daniel Orlandi']},
{title:'Dirty Pretty Things',
titleCZ:'Špína Londýna',
year:2002,
runtime:97,
countries:['UK'],
genres:['Drama','Thriller','Crime'],
director:['Stephen Frears'],
actors:['Audrey Tautou','Sergi López','Chiwetel Ejiofor','Sophie Okonedo','Zlatko Burić','Benedict Wong','Sotigui Kouyaté','Jean-Philippe Écoffey','Damon Younger','Josef Altin','Adrian Scarborough','Deobia Oparei','Noma Dumezweni','Michael Mellinger',"Darrell D'Silva"],
screenplay:['Steven Knight'],
production:['Tracey Seaward','Robert Jones'],
music:['Nathan Larson'],
camera:['Chris Menges'],
cut:['Mick Audsley'],
sound:['Michael Prestwood Smith'],
scenography:['Hugo Luczyc-Wyhowski'],
masks:['Matthew Smith','Jenny Shircore'],
costumes:['Odile Dicks-Mireaux']},
{title:'American Hustle',
titleCZ:'Špinavý trik',
year:2013,
runtime:132,
countries:['USA'],
genres:['Crime','Drama'],
director:['David O. Russell'],
actors:['Christian Bale','Bradley Cooper','Amy Adams','Jeremy Renner','Jennifer Lawrence','Louis C.K.','Jack Huston','Michael Peña','Shea Whigham','Alessandro Nivola','Elisabeth Röhm','Paul Herman','Saïd Taghmaoui','Adrian Martinez','Anthony Zerbe','Colleen Camp','Robert De Niro','Dawn Olivieri','Christy Scott Cashman','Andres Faucher','Erica McDermott','Josh Philip Weinstein','Sonny Corbo','Danny Corbo','Charley Broderick','Armen Garo','Charlie Tacker','Patsy Meck','Thomas Matthews',"Billy 'V' Vigeant",'Stephen Wu','Gavin Maddox Bergman','Larry Eudene','Austin J. Ryan'],
screenplay:['Eric Warren Singer','David O. Russell'],
production:['Megan Ellison','Jonathan Gordon','Richard Suckle','Charles Roven'],
music:['Danny Elfman'],
camera:['Linus Sandgren'],
cut:['Jay Cassidy','Alan Baumgarten','Crispin Struthers'],
sound:['Myron Nettinga'],
scenography:['Judy Becker','Heather Loeffler','Jesse Rosenthal'],
masks:['Wesley Wofford','Kristen Barry','Lori McCoy-Bell'],
costumes:['Michael Wilkinson']},
{title:'Štěstí',
titleCZ:'Štěstí',
year:2005,
runtime:100,
countries:['Czechia'],
genres:['Drama'],
director:['Bohdan Sláma'],
actors:['Tatiana Dyková','Pavel Liška','Aňa Geislerová','Marek Daniel','Zuzana Kronerová','Simona Stašová','Bolek Polívka','Martin Huba','David Dolnik','Marie Ludvíková','Vanda Hybnerová','Josefína Rašilovová','Lucie Vačkářová','Josef Polášek','Hanuš Bor','Roman Zach','Zdeněk Raušer','Jiří Novák','Jiří Maria Sieber','Tomáš Záruba','Jáchym Dusbaba','Cyril Drozda','Marcela Sidonová'],
screenplay:['Bohdan Sláma'],
production:['Pavel Strnad','Thanassis Karathanos','Karl Baumgartner'],
music:['Leonid Soybelman'],
camera:['Diviš Marek'],
cut:['Jan Daňhel'],
sound:['Jan Čeněk','Sebastian Schmidt','Erik Mischijew','Matz Müller','Stephan Konken'],
scenography:['Petr Pištěk'],
masks:['Veronika Riehs'],
costumes:['Zuzana Krejzková']},
{title:'Dark Shadows',
titleCZ:'Temné stíny',
year:2012,
runtime:113,
countries:['USA','Australia'],
genres:['Comedy','Horror','Fantasy'],
director:['Tim Burton'],
actors:['Johnny Depp','Michelle Pfeiffer','Helena Bonham Carter','Eva Green','Jackie Earle Haley','Jonny Lee Miller','Chloë Grace Moretz','Bella Heathcote','Gulliver McGrath','Christopher Lee','Hannah Murray','Alice Cooper','William Hope','Sophie Kennedy Clark','Jonathan Frid','David Selby','Thomas McDonell','Lara Parker','Jeff Mash','Shane Rimmer','Charlotte Spencer','Raffey Cassidy','Michael Shannon','Ivan Kaye','Lasco Atkins','Greg Bennett','Stuart Mulcaster','Guy Flanagan','Susanna Cappellaro','Sean Mahon','Nigel Whitmey','Duncan Casey','Ian Mann','Matthew David McCarthy','Harry Taylor','Keaton Heinrichs','Ray Shirley','Michael Anthony Brown','Gabriel Freilich','Dominika Van Santen','Chris Martin Hill'],
screenplay:['Seth Grahame-Smith','Dan Curtis'],
production:['Richard D. Zanuck','Graham King','Johnny Depp'],
music:['Danny Elfman'],
camera:['Bruno Delbonnel'],
cut:['Chris Lebenzon'],
sound:['Andrew Stirk','Julian Slater','Michael Semanick','Tom Johnson'],
scenography:['Rick Heinrichs','Jason Knox-Johnston','John Dexter','Phil Sims'],
masks:['Tamsin Dorling Barbosa','Lizzie Yianni Georgiou','Duncan Jarman','Paul Gooch','Joel Harlow'],
costumes:['Colleen Atwood']},
{title:'Shanghai Noon',
titleCZ:'Tenkrát na východě',
year:2000,
runtime:110,
countries:['USA'],
genres:['Action','Western','Comedy','Adventure'],
director:['Tom Dey'],
actors:['Jackie Chan','Owen Wilson','Lucy Liu','Roger Yuan','Xander Berkeley','Ringo Yu','Jason Connery','Kate Luyben','Randy Birch','Jody Thompson','Curtis Armstrong','Biao Yuen','Walton Goggins','Simon Baker','Sam Simon','A.C. Peterson','Olivia Cheng','Henry O','Tom Heaton','Tseng Chang','Jim Shield','Rafael Báez','Stacy Grant','Valerie Planche','Adrien Dorval'],
screenplay:['Miles Millar','Alfred Gough'],
production:['Roger Birnbaum','Jonathan Glickman'],
music:['Randy Edelman'],
camera:['Dan Mindel'],
cut:['Richard Chew'],
sound:["Andy D'Addario"],
scenography:['Peter J. Hampton'],
masks:['Rosalina Da Silva'],
costumes:['Joseph A. Porro']},
{title:'The Wall',
titleCZ:'The Wall',
year:2017,
runtime:88,
countries:['USA'],
genres:['Drama','Thriller','War'],
director:['Doug Liman'],
actors:['Aaron Taylor-Johnson','John Cena','Laith Nakli'],
screenplay:['Dwain Worrell'],
production:['David Bartis'],
camera:['Roman Vasjanov'],
cut:['Julia Bloch'],
sound:['Mariusz Glabinski'],
scenography:['Jeff Mann','Kelly Berry'],
masks:['Mike Smithson','Tami Lane','Jamie Kelman'],
costumes:['Cindy Evans']},
{title:'Dark Blue World',
titleCZ:'Tmavomodrý svět',
year:2001,
runtime:112,
countries:['Czechia','UK','Germany','Denmark'],
genres:['War','Drama','Action','Romance'],
director:['Jan Svěrák'],
actors:['Ondřej Vetchý','Kryštof Hádek','Tara Fitzgerald','Charles Dance','Oldřich Kaiser','David Novotný','Linda Rybová','Jaromír Dulava','Lukáš Kantor','Radim Fiala','Juraj Bernáth ml.','Miroslav Táborský','Hans-Jörg Assmann','Thure Riefenstein','Anna Massey','Viktor Preiss','Petr Burian','Čestmír Řanda ml.','Jeremy Swift','Jiří Lábus','Daniela Kolářová','Martin Sitta','Horst Günter Marx','Anna Veselá','Filip Renč','David Fisher','Jeff Tyler','Martin Dostál','John Comer','Michal Zelenka','Zdeněk Dvořák','Zdeněk Svěrák','Jan Svěrák','Sophie Wilcox','Jan Brabec','William Scott-Masson','František Vyskočil','Amy Huck','Caroline Holdaway'],
screenplay:['Zdeněk Svěrák'],
production:['Eric Abraham','Jan Svěrák','Domenico Procacci'],
music:['Ondřej Soukup','Jaroslav Ježek'],
camera:['Vladimír Smutný'],
cut:['Alois Fišárek'],
sound:['Zbyněk Mikulík'],
scenography:['Jan Vlasák'],
masks:['Zdeněk Klika'],
costumes:['Věra Mírová']},
{title:"Don't Worry Darling",
titleCZ:'To nic, drahá',
year:2022,
runtime:123,
countries:['USA'],
genres:['Mystery','Drama','Thriller'],
director:['Olivia Wilde'],
actors:['Florence Pugh','Harry Styles','Olivia Wilde','Chris Pine','Gemma Chan','Nick Kroll','Douglas Smith','KiKi Layne','Timothy Simons','Kate Berlant','Dita Von Teese','Asif Ali','Marcello Julian Reyes','Wylie Quinn Anderson','Monroe Cline','Lexy Hulme','Brooke deRosa','Ali Starr Goebel',"Ari'el Stachel",'Sydney Chandler'],
screenplay:['Katie Silberman','Carey Van Dyke','Shane Van Dyke'],
production:['Roy Lee','Katie Silberman','Olivia Wilde','Miri Yoon'],
music:['John Powell'],
camera:['Matthew Libatique'],
cut:['Jennifer Lame'],
scenography:['Katie Byron'],
masks:['Ahou Mofid','Jaime Leigh McIntosh'],
costumes:['Arianne Phillips']},
{title:'Toman',
titleCZ:'Toman',
year:2018,
runtime:'Televizní verze: 78+75 min',
countries:['Czechia','Slovakia'],
genres:['Drama','History'],
director:['Ondřej Trojan'],
actors:['Jiří Macháček','Kateřina Winterová','Stanislav Majer','Kristýna Boková','Petr Vaněk','Roman Luknár','Martin Finger','Jaromír Dulava','Marek Taclík','Marián Mitaš','Lukáš Melník','Václav Neužil ml.','Miroslav Táborský','Ondřej Malý','Lukáš Latinák','Radek Holub','Táňa Pauhofová','Pavel Liška','Jaroslav Plesl','Aleš Procházka','Jiří Dvořák','Lukáš Hlavica','Ladislav Hampl','Michal Režný','Ady Hajdu','Matěj Ruppert','Martin Veliký','Daniel Tůma','Réka Dérzsi','Jiří Černý','Ivan Herma','Václav Jakoubek','Joe Weintraub','Damian Odess-Gillett','Tereza Osláčová','Jaroslav Kubera','Lucia Šoralová','Josef Hervert','Petr Reif','Daniel Pekárek','Monika Žáková','Alexandr Minajev','Josef Gurunz','Jared Doreck','Andrej Polák','Marcela Máchová','Tomáš Kobr','Kateřina Jebavá','Tereza Rychlá','Johana Ožvold','Veronika Senciová','Viktorie Jackson','Marie Jansová','Tomáš Kraucher','Pavlína Štorková','Halka Jeřábek Třešňáková','Ewa Zurakowská','Marián Škorvaga','Igor Pashko','Vasyl Sevastyanov','Sergii Iegorov','Alžběta Noll','Erika Stárková','Kaia Brown','Zbyšek Pantůček','Adam Mašura','Ondřej Trojan','Sarah Star','Vitalii Vorkhlik','Ladislav Trojan','Branislav Hesko','Jan Matoušek'],
screenplay:['Zdenka Simandlova','Ondřej Trojan'],
production:['Ondřej Trojan'],
music:['Michal Novinski'],
camera:['Tomáš Sysel'],
cut:['Vladimír Barák'],
sound:['Jiří Klenka'],
scenography:['Tomáš Svoboda','Nora Sopková'],
masks:['Jana Bílková'],
costumes:['Katarína Štrbová Bieliková']},
{title:'Total Recall',
titleCZ:'Total Recall',
year:2012,
runtime:'Alternativní 113 min',
countries:['USA','Canada'],
genres:['Action','Adventure','Thriller','Sci-Fi'],
director:['Len Wiseman'],
actors:['Colin Farrell','Kate Beckinsale','Jessica Biel','Bryan Cranston','Bokeem Woodbine','Bill Nighy','John Cho','Will Yun Lee','James McGowan','Michael Therriault','Currie Graham','Morgane Slemp','Ethan Hawke','Steve Byers','Kaitlyn Leeb','Emily Chang','Warren Belle','Jozef Aoki','Jenny Jacoya Chowles','James Downing','Geoffrey Pounsett','Leigh Folsom Boyd','Brett Donahue','Mishael Morgan','Brooks Darnell','Lisa Chandler','Stephon Fuller','Phi Huynh','Stephen Stanton','Cam Clarke','Andrew Moodie','Brian T. Delaney','Tony Kelly','Kyle Warren'],
basedOn:['Philip K. Dick'],
screenplay:['Kurt Wimmer','James Vanderbilt','Mark Bomback'],
production:['Neal H. Moritz','Toby Jaffe'],
music:['Harry Gregson-Williams'],
camera:['Paul Cameron'],
cut:['Christian Wagner'],
sound:['David Giammarco','Paul Massey','Jamey Scott','Greg Orloff','Oleg Kulchytskyi'],
scenography:['Patrick Tatopoulos',"Carolyn 'Cal' Loucks"],
masks:['Jordan Samuel','Jamie Kelman','Sean Sansom','Kazu Hiro'],
costumes:['Sanja Milkovic Hays']},
{title:'Face/Off',
titleCZ:'Tváří v tvář',
year:1997,
runtime:138,
countries:['USA'],
genres:['Action','Thriller','Crime','Sci-Fi'],
director:['John Woo'],
actors:['John Travolta','Nicolas Cage','Joan Allen','Alessandro Nivola','Gina Gershon','Dominique Swain','Nick Cassavetes','Harve Presnell','Colm Feore','John Carroll Lynch','CCH Pounder','Robert Wisdom','Margaret Cho','Matt Ross','Chris Bauer','Myles Jeffrey','Thomas Jane','Tommy Flanagan','Paul Hipp','Lisa Boyle','John Bloom','James Denton','Danny Masterson','Megan Paul','Kirk Baltz','Romy Windsor','David Warshofsky','Thomas Rosales Jr.','Del Zamora','Steve Hytner','Ben Reed','Tory Christopher','Tom Fridley','Tony Boldi','Brooke Leslie','Laurence Walsh','Jacinto Rodriguez'],
screenplay:['Mike Werb','Michael Colleary'],
production:['Anant Singh','David Permut','Terence Chang','Barrie M. Osborne'],
music:['John Powell'],
camera:['Oliver Wood'],
cut:['Steven Kemper','Christian Wagner'],
sound:['Per Hallberg','Andy Nelson','Tom Perry','Anna Behlmer','Mark P. Stoeckinger'],
scenography:['Neil Spisak'],
masks:['David Danon','Michael Mills','David Atherton','Kevin Yagher','Matt Danon'],
costumes:['Ellen Mirojnick']},
{title:'Twin Peaks: Fire Walk with Me',
titleCZ:'Twin Peaks: ohni se mnou pojď',
year:1992,
runtime:135,
countries:['USA','France'],
genres:['Drama','Horror','Thriller','Mystery'],
director:['David Lynch'],
actors:['Sheryl Lee','Ray Wise','Mädchen Amick','Dana Ashbrook','Phoebe Augustine','David Bowie','Eric DaRe','Miguel Ferrer','Pamela Gidley','Heather Graham','Chris Isaak','Moira Kelly','Peggy Lipton','David Lynch','James Marshall','Jürgen Prochnow','Harry Dean Stanton','Kiefer Sutherland','Lenny von Dohlen','Grace Zabriskie','Kyle MacLachlan','Frances Bay','Catherine E. Coulson','Michael J. Anderson','Frank Silva','Walter Olkewicz','Al Strobel','Gary Hershberger','Chris Pedersen','Victor Rivers','Rick Aiello','Calvin Lockhart','David Brisbin','Andrea Hays','Julee Cruise','James Parks','Anne Gaybis','Jon Huck'],
screenplay:['David Lynch','Robert Engels'],
production:['Gregg Fienberg'],
music:['Angelo Badalamenti'],
camera:['Ronald Víctor García'],
cut:['Mary Sweeney'],
sound:['Douglas Murray','David Parker','Michael Semanick'],
scenography:['Patricia Norris'],
masks:['Katharina Hirsch-Smith'],
costumes:['Patricia Norris']},
{title:'Sink or Swim',
titleCZ:'Utop se, nebo plav',
year:2018,
runtime:122,
countries:['France'],
genres:['Comedy'],
director:['Gilles Lellouche'],
actors:['Mathieu Amalric','Guillaume Canet','Benoît Poelvoorde','Jean-Hugues Anglade','Virginie Efira','Leïla Bekhti','Marina Foïs','Philippe Katerine','Félix Moati','Noée Abita','Alban Ivanov','Balasingham Thamilchelvan','Jonathan Zaccaï','Mélanie Doutey','Erika Sainte','Anderz Eide','Claire Nadeau','Ian McCamy','Hervé Colombel','Pierre Pirol','Sébastien Lozach','Christian Gazio','Maximilien Poullein','Sam Chemoul','Sira Topic','Sami Zitouni'],
screenplay:['Gilles Lellouche','Julien Lambroschini','Ahmed Hamidi'],
production:['Alain Attal','Hugo Sélignac'],
music:['Jon Brion'],
camera:['Laurent Tangy'],
cut:['Simon Jacquet'],
sound:['Marc Doisne','Gwennolé Le Borgne'],
scenography:['Florian Sanson'],
costumes:['Elise Bouquet','Reem Kuzayli']},
{title:'Being John Malkovich',
titleCZ:'V kůži Johna Malkoviche',
year:1999,
runtime:108,
countries:['USA'],
genres:['Comedy','Drama','Fantasy','Romance'],
director:['Spike Jonze'],
actors:['John Cusack','Cameron Diaz','Ned Bellamy','Mary Kay Place','Catherine Keener','Orson Bean','John Malkovich','Kevin Carroll','W. Earl Brown','Charlie Sheen','Gerald Emerick','Gregory Sporleder','Brad Pitt','Sean Penn','Spike Jonze','David Fincher','James Murray','Octavia Spencer','Richard Fancy','Willie Garson','Jester Hairston','Kacee DeMasi','James Murray','Pamela Hayden','Carlos Jacott','K.K. Dodds','Reginald C. Hayes','Patti Tippo','Byrne Piven','Bill M. Ryusaki','Eddie L. Fauria','Neil Ross'],
screenplay:['Charlie Kaufman'],
production:['Steve Golin','Vincent Landay','Sandy Stern','Michael Stipe'],
music:['Carter Burwell'],
camera:['Lance Acord'],
cut:['Eric Zumbrunnen'],
sound:['Richard L. Anderson','Gary Gegan'],
scenography:['K.K. Barrett','Gene Serdena'],
masks:['John Vulich'],
costumes:['Casey Storm']},
{title:'Black Snake Moan',
titleCZ:'V řetězech',
year:2006,
runtime:116,
countries:['USA'],
genres:['Drama','Thriller'],
director:['Craig Brewer'],
actors:['Samuel L. Jackson','Christina Ricci','Justin Timberlake','S. Epatha Merkerson','Michael Raymond-James','John Cothran Jr.','David Banner','Clare Grant','Amy Lavere','Kim Richards','Adriane Lenox','Jeff Pope'],
screenplay:['Craig Brewer'],
production:['Stephanie Allain','John Singleton'],
music:['Scott Bomar'],
camera:['Amy Vincent'],
cut:['Billy Fox'],
sound:['David E. Fluhr','Kevin E. Carpenter'],
scenography:['Keith Brian Burns'],
masks:['Allan A. Apone','Joani Yarbrough','Philip Ivey'],
costumes:['Paul A. Simmons Jr.']},
{title:'Vaclav',
titleCZ:'Václav',
year:2007,
runtime:97,
countries:['Czechia'],
genres:['Comedy','Drama'],
director:['Jiří Vejdělek'],
actors:['Ivan Trojan','Gregor Bauer','Jiří Lábus','Emília Vášáryová','Jan Budař','Zuzana Kronerová','Petra Špalková','Martin Pechlát','Soňa Norisová','Vladimír Javorský','Jan Vlasák','Oldřich Hajlich','Josef Polášek','Martin Sitta','Zdeněk Dušek','Tomáš Pavelka','František Stupka','Hana Seidlová','Miroslav Hanuš','Martin Finger','Jana Galinová','Michal Mareda','Miroslav Moravec','Jan Šťastný','Lukáš Vacek','Hanuš Bor','Radim Fiala','Martina Delišová','Jan Holík','Hynek Bečka'],
screenplay:['Marek Epstein','Jiří Vejdělek'],
production:['Jaroslav Bouček'],
music:['Jan P. Muchow'],
camera:['Jakub Šimůnek'],
cut:['Jan Daňhel'],
sound:['Peter Mazáček'],
scenography:['Henrich Boráros'],
costumes:['Andrea Králová','Zuzana Krejzková']},
{title:'The Blizzard',
titleCZ:'Vánice',
year:1962,
runtime:80,
countries:['Czechoslovakia'],
genres:['Drama'],
director:['Čeněk Duba'],
actors:['Ivo Palec','Zuzana Fišárková','Josef Mixa','Michaela Bendová','Vladimír Menšík','Slávka Budínová','Josef Hlinomaz','Věra Kalendová','Rudolf Jelínek','Miloš Preininger','Karel Hlušička','Gustav Nezval','Jarmila Švabíková','Ferdinand Krůta','Božena Obrová','Miloš Vavruška','Miroslav Rous','Miroslav Bílek','Ladislav Vaněk','Jana Vaňková','Jitka Zelenohorská','Milan Janda','Alena Procházková','Jiří Mikeš','Petr Patera','Petr Novák','Martin Vačkář','Bohuslav Sýkora','Jindřich Hartmann','Waldemar Matuška','Světla Svozilová','Jana Werichová-Kvapilová','Eva Mrázová','Karel Hábl','Pavla Maršálková','Ivo Gübel','Mirko Musil','Hana Pastejříková','Karel Hovorka st.','Bohuš Hrádek','Emil Rohan','Jaroslav Lejčko','Vladimír Klapka','Dagmar Felixová','Miroslav Samek','Antonín Kubový','Petr Kostka','Jiří Bruder'],
screenplay:['Jiří Mucha'],
music:['Miloš Vacek'],
camera:['Jaromír Holpuch'],
cut:['Jan Chaloupek'],
sound:['Adolf Böhm'],
scenography:['Karel Černý'],
masks:['Jiří Šimon','Karel Konrád','Růžena Richterová'],
costumes:['Bohumila Maršálková','Ondrej Brezovský']},
{title:'Widows',
titleCZ:'Vdovy',
year:2018,
runtime:129,
countries:['USA','UK'],
genres:['Drama','Crime','Thriller'],
director:['Steve McQueen'],
actors:['Viola Davis','Michelle Rodriguez','Elizabeth Debicki','Cynthia Erivo','Colin Farrell','Brian Tyree Henry','Daniel Kaluuya','Garret Dillahunt','Carrie Coon','Jacki Weaver','Robert Duvall','Liam Neeson','Manuel Garcia-Rulfo','Jon Bernthal','Lukas Haas',"Kevin J. O'Connor",'Michael Harney','Matt Walsh','Adepero Oduye','Ann Mitchell','André Holland','Lizzy Leigh','Molly Kunz','Anita Farmer Bergman','Will Zahrn','Coburn Goss','Bailey Rhyse Walters','Keith Kupferer','Socorro Santiago','Jon Michael Hill','Lily Mojekwu','Wendy Mateo','Brian King','Patrese McClain','Charles D. Clark','Ashland Thomas','Katherine Mallen Kupferer','Chloe Baldwin','Eric C. Lynch'],
screenplay:['Gillian Flynn','Steve McQueen'],
production:['Steve McQueen','Iain Canning','Emile Sherman','Arnon Milchan'],
music:['Hans Zimmer'],
camera:['Sean Bobbitt'],
cut:['Joe Walker'],
sound:['James Harrison'],
scenography:['Adam Stockhausen','Elizabeth Keenan','Heather Ratliff'],
masks:['Rosalind Jones-Crosby','Daniel Curet','Ken Diaz','Jamika Wilson','Denise Baker'],
costumes:['Jenny Eagan']},
{title:'The Age of Innocence',
titleCZ:'Věk nevinnosti',
year:1993,
runtime:133,
countries:['USA'],
genres:['Drama','Romance'],
director:['Martin Scorsese'],
actors:['Daniel Day-Lewis','Michelle Pfeiffer','Winona Ryder','Alexis Smith','Mary Beth Hurt','Richard E. Grant','Alec McCowen','Geraldine Chaplin','Stuart Wilson','Michael Gough','Miriam Margolyes','Siân Phillips','Norman Lloyd','Thomas Gibson','Jonathan Pryce','Robert Sean Leonard','Joanne Woodward','Claire Bloom','Martin Scorsese','Charles Scorsese','Catherine Scorsese','Domenica Cameron-Scorsese','June Squibb','Tamasin Day-Lewis','Carolyn Farina','Brian Davies','Pasquale Cajano','Howard Erskine','Clement Fowler','Patricia Dunnock','Tracey Ellis','Cindy Katz'],
basedOn:['Edith Wharton'],
screenplay:['Jay Cocks','Martin Scorsese'],
production:['Barbara De Fina'],
music:['Elmer Bernstein'],
camera:['Michael Ballhaus'],
cut:['Thelma Schoonmaker'],
sound:['Tom Fleischman','Skip Lievsay','Tod A. Maitland'],
scenography:['Dante Ferretti'],
masks:['Manlio Rocchetti'],
costumes:['Gabriella Pescucci']},
{title:'The Great Gatsby',
titleCZ:'Velký Gatsby',
year:2013,
runtime:142,
countries:['Australia','USA'],
genres:['Drama','Romance'],
director:['Baz Luhrmann'],
actors:['Leonardo DiCaprio','Tobey Maguire','Carey Mulligan','Joel Edgerton','Isla Fisher','Jason Clarke','Elizabeth Debicki','Jack Thompson','Amitabh Bachchan','Gemma Ward','Callan McAuliffe','Jacek Koman','Vince Colosimo','Goran D. Kleut','Heather Mitchell','Charlize Skinner','Adelaide Clemens','Richard Carter','Kate Mulvany','iOTA','Barry Otto','Arthur Dignam','Bill Young','Nick Tate','Matthew Whittet','Ryan Cooper','Lara Mulcahy','Eddie Ritchard','Max Cullen','Gus Murray','Hamish Michael','Nancy Denis','Jake Ryan','Kim Knuckey','Shae Beadman','Stefan Mogel'],
basedOn:['F. Scott Fitzgerald'],
screenplay:['Baz Luhrmann','Craig Pearce'],
production:['Douglas Wick','Lucy Fisher','Catherine Martin','Baz Luhrmann'],
music:['Craig Armstrong'],
camera:['Simon Duggan'],
cut:['Matt Villa','Jason Ballantine','Jonathan Redmond'],
sound:['Steve Maslow'],
scenography:['Catherine Martin','Beverley Dunn'],
masks:['Matteo Silvi','Adam Johansen','Wizzy Molineaux','Jodee Lenaine-Smith','Siân Grigg'],
costumes:['Catherine Martin']},
{title:'Venkovský učitel',
titleCZ:'Venkovský učitel',
year:2008,
runtime:121,
countries:['Czechia','France','Germany'],
genres:['Drama'],
director:['Bohdan Sláma'],
actors:['Pavel Liška','Zuzana Bydžovská','Ladislav Šedivý','Marek Daniel','Tereza Ramba','Marie Ludvíková','Zuzana Kronerová','Miroslav Krobot','František Prošek','Josef Prošek','Anna Vladyková','Pavel Vladyka','Vojtěch Kotek','Cyril Drozda','Ivo Krobot'],
screenplay:['Bohdan Sláma'],
production:['Petr Oukropec','Pavel Strnad','Karl Baumgartner','Thanassis Karathanos'],
music:['Vladimír Godár'],
camera:['Diviš Marek'],
cut:['Jan Daňhel'],
sound:['Jan Čeněk','Sebastian Schmidt'],
scenography:['Václav Novák'],
masks:['Veronika Riehs'],
costumes:['Zuzana Krejzková']},
{title:'Veterán',
titleCZ:'Veterán',
year:2020,
runtime:100,
countries:['Czechia'],
genres:['Crime','Drama'],
director:['Jan Hřebejk'],
actors:['Milan Ondrík','Marie Poulová','Pavel Kříž','Alena Antalová','Vincent Navrátil','Éva Bandor','Jan Kolařík','John Bok','Matouš Rajmont','Lukáš Bech','Michael Beran','Martin Cenek','Dalibor Černák','Dušan Hřebíček','Naďa Kovářová','Ivo Kučera','Miroslav Kumhala','Jana Musilová','Marek Příkazký','Jan Šibík','Monika Šišková','Martin E. Kyšperský','Roman Kracík','Mirka Louthanová'],
screenplay:['Marek Epstein'],
production:['Jiřina Budíková'],
music:['Martin E. Kyšperský'],
camera:['Martin Šec'],
cut:['Vladimír Barák'],
sound:['Štěpán Trčka','Jiří Klenka'],
scenography:['David Voborský'],
masks:['Zdeněk Klika'],
costumes:['Vladimíra Fomínová']},
{title:'The Duchess',
titleCZ:'Vévodkyně',
year:2008,
runtime:110,
countries:['UK','Italy','France'],
genres:['Drama','History','Romance','Biographic'],
director:['Saul Dibb'],
actors:['Keira Knightley','Ralph Fiennes','Charlotte Rampling','Hayley Atwell','Dominic Cooper','John Shrapnel','Aidan McArdle','Alistair Petrie','Georgia King','Simon McBurney','Camilla Arfwedson','Patrick Godfrey','Steve Hardy','Richard McCabe','Michael Medwin','Bruce Mackinnon','Max Bennett','Michael Thomson','Gilbert Wynne','Poppy Wigglesworth','Rose Romain','Andrew Armour','Benjamin Noble','Sebastian Applewhite'],
basedOn:['Amanda Foreman'],
screenplay:['Jeffrey Hatcher','Anders Thomas Jensen','Saul Dibb'],
production:['Gabrielle Tana','Christine Langan','Michael Kuhn'],
music:['Rachel Portman'],
camera:['Gyula Pados'],
cut:['Masahiro Hirakubo'],
scenography:['Michael Carlin','Rebecca Alleway'],
masks:['Fran Needham','Daniel Phillips','Loulia Sheppard','Heather Manson'],
costumes:["Michael O'Connor"]},
{title:'Vinetou',
titleCZ:'Vinnetou',
year:2008,
runtime:4,
countries:['Czechia'],
genres:['Short'],
director:['Jan Veselý']},
{title:'Wolf',
titleCZ:'Vlk',
year:1994,
runtime:125,
countries:['USA'],
genres:['Drama','Horror','Romance','Thriller'],
director:['Mike Nichols'],
actors:['Jack Nicholson','Michelle Pfeiffer','James Spader','Kate Nelligan','Richard Jenkins','Eileen Atkins','Christopher Plummer','Ron Rifkin','David Hyde Pierce','Om Puri','Prunella Scales','Brian Markinson','Peter Gerety','David Schwimmer','Christopher Birt','Allison Janney','William Hill','Oz Perkins','Madhur Jaffrey',"Cynthia O'Neal",'Bradford English','Starletta DuPois','Stewart J. Zully','Irene Cagen','Thomas F. Duffy','Lisa Emery','Kirby Mitchell','Joanna Sanchez'],
screenplay:['Wesley Strick','Jim Harrison'],
production:['Douglas Wick'],
music:['Ennio Morricone'],
camera:['Giuseppe Rotunno'],
cut:["Sam O'Steen"],
sound:['Lee Dichter','Bob Olari'],
scenography:['Bo Welch','Jim Dultz'],
masks:['Greg Nelson','John Logan','Rick Baker','Audrey Futterman-Stern'],
costumes:['Ann Roth']},
{title:'Private Benjamin',
titleCZ:'Vojín Benjaminová',
year:1980,
runtime:106,
countries:['USA'],
genres:['Comedy'],
director:['Howard Zieff'],
actors:['Goldie Hawn','Eileen Brennan','Armand Assante','Sam Wanamaker','Barbara Barrie','Robert Webber','Mary Kay Place','Harry Dean Stanton','Albert Brooks','Lee Wallace','Toni Kalem','P. J. Soles','Craig T. Nelson','Sally Kirkland','Lilyan Chauvin','Richard Herd','Alan Oppenheimer','Lillian Adams','Hal Williams','Damita Jo Freeman','Maxine Stuart','Alice Hirson','Mimi Maynard','Keone Young','Tim Haldeman','Danny Wells','Alston Ahern','Wil Albert','Paul Marin','Robert Hanley','J.P. Bumstead'],
screenplay:['Nancy Meyers','Harvey Miller','Charles Shyer'],
production:['Nancy Meyers','Charles Shyer'],
music:['Bill Conti'],
camera:['David M. Walsh'],
cut:['Sheldon Kahn'],
sound:['Martin Raymond Bolger','Rick Alexander'],
scenography:['Jeffrey Howard','Robert F. Boyle','Arthur Jeph Parker'],
masks:['E. Thomas Case'],
costumes:['Betsy Cox']},
{title:'Empties',
titleCZ:'Vratné lahve',
year:2007,
runtime:99,
countries:['Czechia'],
genres:['Comedy'],
director:['Jan Svěrák'],
actors:['Zdeněk Svěrák','Daniela Kolářová','Tatiana Dyková','Jiří Macháček','Pavel Landovský','Jan Budař','Nela Boudová','Miroslav Táborský','Věra Tichánková','Jana Plodková','Martin Pechlát','Božidara Turzonovová','Jan Vlasák','Alena Vránová','Ondřej Vetchý','Eva Leinweberová','Ladislav Smoljak','Bořivoj Penc','Jaroslav Weigel','Jan Hraběta','Petr Brukner','Jan Kašpar','Pavel Vondruška','Danica Jurčová','Jiří Bábek','Filip Renč','Sára Voříšková','Kristina Kloubková','Lucie Pernetová','Lenka Zahradnická','Jelena Juklová','Martin Bohadlo','Petr Chajda','Jitka Asterová','Natálie Drabiščáková','Miroslav Hanuš','Radim Novák','Lubor Šplíchal','Marcela Holubcová','Robin Soudek','Martha Olšrová'],
screenplay:['Zdeněk Svěrák'],
production:['Eric Abraham','Jan Svěrák'],
music:['Ondřej Soukup','Jaroslav Uhlíř'],
camera:['Vladimír Smutný'],
cut:['Alois Fišárek'],
sound:['Pavel Rejholec','Jakub Čech'],
scenography:['Jan Vlasák'],
masks:['Zdeněk Klika'],
costumes:['Simona Rybáková','Helena Rovná']},
{title:'Bringing Up Girls in Bohemia',
titleCZ:'Výchova dívek v Čechách',
year:1997,
runtime:112,
countries:['Czechia'],
genres:['Comedy','Romance'],
director:['Petr Koliha'],
actors:['Ondřej Pavelka','Aňa Geislerová','Milan Lasica','Jan Kačer','Alois Švehlík','Jana Švandová','Vilma Cibulková','Kristýna Badinková Nováková','Jan Lepšík','Viktorie Čermáková','Jan Vlasák','Oldřich Vlach','Zuzana Geislerová','Jitka Smutná','Lenka Termerová','Marie Spurná','Valerie Kaplanová','Zdeněk Dušek','Martin Hub','Miloš Kabyl','Veronika Rašťáková','Adam Cingroš','Leoš Stránský','Michal Lang','Karel Steigerwald','Ivan Klíma','Václav Bělohradský'],
basedOn:['Michal Viewegh'],
screenplay:['Václav Šašek'],
production:['Ilona Jirásková'],
music:['Miki Jelínek'],
camera:['Vladimír Smutný'],
cut:['Jiří Brožek'],
sound:['Karel Jaroš'],
scenography:['Ondřej Nekvasil'],
costumes:['Ondřej Nekvasil']},
{title:'Higher Principle',
titleCZ:'Vyšší princip',
year:1960,
runtime:102,
countries:['Czechoslovakia'],
genres:['Drama','War'],
director:['Jiří Krejčík'],
actors:['František Smolík','Jana Brejchová','Ivan Mistrík','Jan Šmíd','Alexandr Postler st.','Petr Kostka','Radovan Lukavský','Václav Lohniský','Marie Lukášová','Miroslav Svoboda','Gustav Hilmar','Bohuš Záhorský','Marie Vášová','Otomar Krejča st.','Hannjo Hasse','František Pálka','Nora Houfová','Jindřich Narenta','Rudolf Hrušínský','Bedřich Prokoš','Marie Glázrová','Věra Tichánková','Zuzana Stivínová','Stanislava Seimlová','Vladimír Hlavatý','Karel Pavlík','Josef Kozák','Jiří Kodet','Elena Hálková','Naděžda Gajerová','Blažena Slavíčková','Jan Skopeček','Štěpán Bulejko','Karel Enzmann','Václav Švec','Rudolf Široký','Jarmila Kurandová','Ladislav Gzela','Bohuš Hradil','Libuše Švormová','Luba Skořepová','František Suk','Michal Staninec','Jitka Frantová','Elmar Kloss','Jan Kühmund','Sheila Miroslava Ochová','Jiří Šrámek'],
basedOn:['Jan Drda'],
screenplay:['Jan Drda','Jiří Krejčík'],
production:['František Milič'],
music:['Zdeněk Liška'],
camera:['Jaroslav Tuzar'],
cut:['Růžena Hejsková'],
sound:['Jiří Pavlík'],
scenography:['Karel Škvor'],
masks:['Milan Novák','Otakar Košťál'],
costumes:['Erna Veselá']},
{title:'A Conspiracy of Faith',
titleCZ:'Vzkaz v láhvi',
year:2016,
runtime:112,
countries:['Denmark','Germany','Norsko','Sweden'],
genres:['Crime','Mystery','Thriller'],
director:['Hans Petter Moland'],
actors:['Nikolaj Lie Kaas','Fares Fares','Pål Sverre Hagen','Jacob Lohmann','Amanda Collin','Johanne Louise Schmidt','Jakob Oftebro','Signe Mannov','Søren Pilmark','Michael Brostrup','Morten Kirkskov','Olivia Terpet Gammelgaard','Jasper Friis Møller','Louis Sylvester Larsen','Lotte Andersen','Benjamin Kitter','Maria Rossing','Laura Bro','Jeanette Lindbæk Birk','Mercedes Claro Schelin','Armin Rohde','Betina Grove','Peder Holm Johansen','Ulla Vejby','Niels Weyde','Zeino Macauley','Jakob Højlev Jørgensen','Johannes Lassen','Kenth Rosenberg','Roberta Hilarius Reichhardt','Frederik Lykkegaard','Viola Ellehammer Dasseville','Divya Das'],
basedOn:['Jussi Adler-Olsen'],
screenplay:['Nikolaj Arcel'],
production:['Louise Vesth','Peter Aalbæk Jensen'],
music:['Nicklas Schmidt'],
camera:['John Andreas Andersen'],
cut:['Nicolaj Monberg','Olivier Bugge Coutté'],
sound:['Rune Palving','Gisle Tveito','Christian Lund'],
scenography:['Søren Schwarzberg','Seth Turner','Desiree Peton'],
masks:['Dennis Knudsen','Love Larson','Morten Jacobsen'],
costumes:['Manon Rasmussen']},
{title:'The Secret Life of Walter Mitty',
titleCZ:'Walter Mitty a jeho tajný život',
year:2013,
runtime:114,
countries:['USA','Canada'],
genres:['Adventure','Comedy','Drama','Fantasy'],
director:['Ben Stiller'],
actors:['Ben Stiller','Kristen Wiig','Shirley MacLaine','Adam Scott','Kathryn Hahn','Patton Oswalt','Adrian Martinez','Ólafur Darri Ólafsson','Terence Bernie Hines','Sean Penn','Joey Slotnick','Rosemary Howard','Kai Lennox','Jon Daly','Makka Kleist','Ari Matthíasson',"Conan O'Brien",'Maariu Olsen','Andy Richter','Jenny Rostain','Paul Fitzgerald','Craig Castaldo','Amirak Nallem Capozzollo','Amy Stiller','Hynden Walch','Stuart Cornfeld','Þórhallur Sigurðsson','Joe Vargas','Don Ellione','Grace Rex','Gunnar Helgason','Raymond Mamrak','Gurdeep Singh','Matt Levin'],
basedOn:['James Thurber'],
screenplay:['Steve Conrad'],
production:['G. Mac Brown','Ben Stiller','Stuart Cornfeld','John Goldwyn','Samuel Goldwyn Jr.'],
music:['Theodore Shapiro'],
camera:['Stuart Dryburgh'],
cut:['Greg Hayden'],
sound:['Paul Urmson','Craig Henighan'],
scenography:['Jeff Mann','Regina Graves'],
masks:['Kristín Júlla Kristjánsdóttir','Michael Marino','Rebecca Hickey','Michael Fontaine','Paul Molnar'],
costumes:['Sarah Edwards']},
{title:'Wendy Wu: Homecoming Warrior',
titleCZ:'Wendy Wu: Bojovnice proti zlu',
year:2006,
runtime:91,
countries:['USA'],
genres:['Action','Adventure','Family'],
director:['John Laing'],
actors:['Brenda Song','Šin Kojamada','Susan Chuang','Justin Chon','Ellen Woglom','Tsai Chin','Anna Hutchison','Sally Martin','James Gaylyn','Geoff Dolan','Andy Fischer-Price'],
screenplay:['Ben Montanio','Vince Cheung','Lydia Look'],
production:['Janine Dickins'],
music:['Nathan Wang'],
camera:['Kevin Riley'],
cut:['Owen Ferrier-Kerr'],
sound:['Keith Rogers',"Terry O'Bright",'Mark Friedgen'],
scenography:['Ralph Davies','Megan Vertelle','Andy McLaren'],
costumes:['Jane Holland']},
{title:'Zamilovaná čarodějka',
titleCZ:'Zamilovaná čarodějka',
year:1997,
runtime:102,
countries:['France'],
genres:['Comedy','Romance'],
director:['René Manzor'],
actors:['Vanessa Paradis','Gil Bellows','Jeanne Moreau','Jean Reno','Dabney Coleman','Paula Dehelly','Clément Harari','Katrine Boorman','Eléonore Hirt','Barnaby Apps','Jim Adhi Limas','Patrick Floersheim','Riccardo Parisio Perrotti','Daniel Milgram','Pietro De Silva','Rémy Roubakha','Louise Vincent','Jean-Paul Solal','Nicholas Hawtrey','Bruce Lester-Johnson','Benjamin Sacks'],
production:['Christian Fechner'],
music:['Jean-Félix Lalanne'],
sound:['Laurent Quaglio','Jean-Paul Loublier','Patrick Rousseau'],
scenography:['Thierry Flamand'],
masks:['Jean-Pierre Eychenne'],
costumes:['Annie Périer']},
{title:'The Nutty Professor',
titleCZ:'Zamilovaný profesor',
year:1996,
runtime:91,
countries:['USA'],
genres:['Comedy','Romance','Sci-Fi'],
director:['Tom Shadyac'],
actors:['Eddie Murphy','Jada Pinkett Smith','James Coburn','Larry Miller','Dave Chappelle','David Ramsey','Roy Werner','Lisa Boyle','Athena Massey','Jamal Mixon','John Ales','Ned Luke','Arthur Tovey','Sara Ballantine','John Prosky','Julianne Christie','Joe Greco','Alexia Robinson','Patricia Wilson','Steve Monroe','Hamilton von Watts','Judith Woodbury','Nick Kokotakis','Mark McPherson','Chaz Lamar Shepherd','Derrex Brady','Annett Culp','Chao Li Chi','Michael Rothhaar'],
screenplay:['Evan Spiliotopoulos','David Sheffield','Barry W. Blaustein','Jerry Lewis','Bill Richmond','Tom Shadyac','Steve Oedekerk'],
production:['Brian Grazer'],
music:['David Newman'],
camera:['Julio Macat'],
cut:['Don Zimmerman'],
sound:['Steve Maslow','Gregg Landaker'],
scenography:['William A. Elliott'],
masks:['Matt Rose','Chad Waters','Stacey Morris','Kathleen Karridene','Rick Baker'],
costumes:['Ha Nguyen']},
{title:'Nomadland',
titleCZ:'Země nomádů',
year:2020,
runtime:107,
countries:['USA','Germany'],
genres:['Drama','Road movie'],
director:['Chloé Zhao'],
actors:['Frances McDormand','David Strathairn','Linda May','Swankie','Bob Wells','Peter Spears','Cat Clifford','Tay Strathairn','Gay DeForest','Patricia Grier','Angela Reyes','Carl R. Hughes','Douglas G. Soul','Ryan Aquino','Teresa Buchanan','Karie Lynn McDermott Wilder','Brandy Wilber','Makenzie Etcheverry','Annette Webb'],
basedOn:['Jessica Bruder'],
screenplay:['Chloé Zhao'],
production:['Mollye Asher','Dan Janvey','Frances McDormand','Peter Spears','Chloé Zhao'],
music:['Ludovico Einaudi'],
camera:['Joshua James Richards'],
cut:['Chloé Zhao'],
sound:['Sergio Diaz','Zach Seivers'],
scenography:['Joshua James Richards','Elizabeth Godar'],
costumes:['Hannah Peterson']},
{title:'The Golden Eels',
titleCZ:'Zlatí úhoři',
year:1979,
runtime:84,
countries:['Czechoslovakia'],
genres:['Drama','Poetic'],
director:['Karel Kachyňa'],
actors:['Vladimír Menšík','Slávka Hozová','Rudolf Hrušínský','Martin Mikuláš','Radoslav Brzobohatý','Eliška Balzerová','Tomáš Murdych','Michal Vejrostek','Zdeněk Martínek','Karel Augusta','Jiří Císler','Bronislav Poloczek','Václav Mareš','Josef Vorel','Zdeněk Zindel','Jindřich Narenta','Luděk Munzar'],
basedOn:['Ota Pavel'],
screenplay:['Karel Kachyňa'],
music:['Luboš Fišer'],
camera:['Jan Čuřík'],
cut:['Jiří Brožek'],
sound:['Pavel Jelínek'],
scenography:['Jan Oliva'],
masks:['Jiří Šimon'],
costumes:['Eliška Kachyňová']},
{title:'The Hunchback of Notre Dame',
titleCZ:'Zvoník u Matky Boží',
year:1996,
runtime:91,
countries:['USA'],
genres:['Animation','Drama','Family','Musical'],
director:['Kirk Wise','Gary Trousdale'],
actors:['Tom Hulce','Demi Moore','Kevin Kline','Jason Alexander','David Ogden Stiers','Frank Welker','Gary Trousdale','Jim Cummings','Corey Burton','Bill Fagerbakke','Mary Wickes','Jane Withers','Tom McBeath','Dana Hill','Charles Kimbrough','Tony Jay','Marcelo Tubert','Phil Proctor','Beatrix Lehmann','Mary Kay Bergman','Brian Cant','Anthony Verner','Gay Hamilton','Susan Blu','Victoria Clark','Kath Soucie','Debi Derryberry','Patrick Pinney','Jan Rabson','Mona Marshall','Judy Kaye','Jennifer Darling','Jack Angel','Eddie Korbich'],
basedOn:['Victor Hugo'],
screenplay:['Irene Mecchi','Tab Murphy','Bob Tzudiker','Noni White','Jonathan Roberts'],
music:['Alan Menken'],
cut:['Ellen Keneshea'],
sound:['Dean A. Zupancic']},
{title:'Splash',
titleCZ:'Žbluňk!',
year:1984,
runtime:111,
countries:['USA'],
genres:['Fantasy','Romance','Comedy'],
director:['Ron Howard'],
actors:['Tom Hanks','Daryl Hannah','Eugene Levy','John Candy','Dody Goodman','Shecky Greene','Richard B. Shull','Bobby Di Cicco','Howard Morris','David Knell','Tony Longo','Joe Grifasi','Clint Howard','Dana Olsen','Jodi Long','Nick Vallelonga','Bill Smitrovich','Rance Howard','Valerie Wildman','Fred Lerner','Migdia Chinea','Jeff Doucette','Tony DiBenedetto','Daryl Edwards','Patrick Cronin','Charles Walker','Charles Macaulay','Than Wyenn','Jill Jacobson','Nora Denney','Royce D. Applegate','Lee Delano','Rick Dano','Pierre Epstein','Ron Kuhlman','Ronald F. Hoiseck','Joe Cirillo','Fil Formicola','Clare Peck','Eileen Saki','Bob Harks',"James 'Hotfeet' Davis",'James Ritz'],
screenplay:['Babaloo Mandel','Lowell Ganz'],
production:['Brian Grazer'],
music:['Lee Holdridge'],
camera:['Donald Peterman'],
cut:['Daniel P. Hanley','Mike Hill'],
sound:['Nick Alphin','Richard S. Church'],
scenography:['Jack T. Collis','Philip Smith','Norman Rockett'],
costumes:['May Routh']},
{title:'Želary',
titleCZ:'Želary',
year:2003,
runtime:142,
countries:['Czechia','Slovakia','Austria'],
genres:['Romance','Drama'],
director:['Ondřej Trojan'],
actors:['Aňa Geislerová','György Cserhalmi','Jaroslava Adamová','Miroslav Donutil','Jaroslav Dušek','Iva Bittová','Ivan Trojan','Jan Hrušínský','Anna Věrtelářová','Tomáš Žatečka','Ondrej Kovaľ','František Velecký','Viera Pavlíková','Juraj Hrčka','Imrich Boráros','Jana Oľhová','Jan Tříska','Michal Hofbauer','Edita Malovčić','Reinhard Simonischek','Gabriela Schmoll','Zita Kabátová','Svatopluk Beneš','Marián Filadelfi','Wolfram Rupperti','Jakub Laurych','Kateřina Liďáková','Juliana Oľhová','Jurij Galin','Alexander Kučerenko','Igor Latta','Jevgenij Libezňuk','Vasiľ Rusiňák','Michal Hudák','Sergej Hudák','Jozef Tkáč','Lubomír Mindoš','Zdeněk Sedláček','René Šmotek','Štefan Richtárech','Pavol Klimašovský','Miroslav Táborský','Miriam Kantorková','Petr Hübner','Alexandr Minajev','Pavel Pafko','Peter Varga','Trude Ackermann','Martin Zbrožek','Ondra Dorian','Adrian Jastraban','Ondřej Trojan'],
basedOn:['Květa Legátová'],
screenplay:['Petr Jarchovský'],
production:['Ondřej Trojan','Helena Uldrichová'],
music:['Petr Ostrouchov'],
camera:['Asen Šopov'],
cut:['Vladimír Barák'],
sound:['Jiří Klenka','Jan Čeněk','Radim Hladík ml.'],
scenography:['Milan Býček'],
masks:['František Příhoda','Jana Dopitová'],
costumes:['Katarína Štrbová Bieliková','Beáta Kodajová']},
]


//! Export

export default {
  movies, variables
}